{
  "allowedLenses": [
    "published"
  ],
  "allowedModes": [
    "site"
  ],
  "audienceId": "site",
  "authoringGuides": {
    "guides": [
      {
        "checklist": [
          {
            "id": "host",
            "labelKey": "authoring.design.check.host"
          },
          {
            "id": "roles",
            "labelKey": "authoring.design.check.roles"
          },
          {
            "id": "states",
            "labelKey": "authoring.design.check.states"
          },
          {
            "id": "authority",
            "labelKey": "authoring.design.check.authority"
          },
          {
            "id": "responsive",
            "labelKey": "authoring.design.check.responsive"
          },
          {
            "id": "provenance",
            "labelKey": "authoring.design.check.provenance"
          }
        ],
        "descriptionKey": "authoring.design.description",
        "eyebrowKey": "authoring.design.eyebrow",
        "id": "workblock-design",
        "outcomeKey": "authoring.design.outcome",
        "pathways": [
          {
            "id": "outside-platform",
            "steps": [
              {
                "bodyKey": "authoring.design.outside.step1.body",
                "id": "install-kit",
                "resourceIds": [
                  "authoring-kit"
                ],
                "titleKey": "authoring.design.outside.step1.title"
              },
              {
                "bodyKey": "authoring.design.outside.step2.body",
                "id": "select-contracts",
                "resourceIds": [
                  "design-catalogue",
                  "design-doctrine",
                  "workblock-catalogue"
                ],
                "titleKey": "authoring.design.outside.step2.title"
              },
              {
                "bodyKey": "authoring.design.outside.step3.body",
                "id": "author",
                "resourceIds": [
                  "starter",
                  "design-prompt"
                ],
                "titleKey": "authoring.design.outside.step3.title"
              },
              {
                "bodyKey": "authoring.design.outside.step4.body",
                "id": "validate",
                "titleKey": "authoring.design.outside.step4.title"
              }
            ],
            "summaryKey": "authoring.design.outside.summary",
            "titleKey": "authoring.design.outside.title"
          },
          {
            "id": "inside-platform",
            "steps": [
              {
                "bodyKey": "authoring.design.inside.step1.body",
                "id": "start-template",
                "resourceIds": [
                  "portable-workblock"
                ],
                "titleKey": "authoring.design.inside.step1.title"
              },
              {
                "bodyKey": "authoring.design.inside.step2.body",
                "id": "adapt-source",
                "resourceIds": [
                  "design-catalogue",
                  "workblock-catalogue"
                ],
                "titleKey": "authoring.design.inside.step2.title"
              },
              {
                "bodyKey": "authoring.design.inside.step3.body",
                "id": "author-local",
                "resourceIds": [
                  "design-doctrine"
                ],
                "titleKey": "authoring.design.inside.step3.title"
              },
              {
                "bodyKey": "authoring.design.inside.step4.body",
                "id": "prove",
                "titleKey": "authoring.design.inside.step4.title"
              }
            ],
            "summaryKey": "authoring.design.inside.summary",
            "titleKey": "authoring.design.inside.title"
          }
        ],
        "prompt": {
          "bodyKey": "authoring.design.prompt.body",
          "id": "brand-and-style-workblock",
          "titleKey": "authoring.design.prompt.title"
        },
        "resources": [
          {
            "descriptionKey": "authoring.resource.kit.description",
            "id": "authoring-kit",
            "kind": "asset",
            "labelKey": "authoring.resource.kit.label",
            "target": "groundworks-authoring-kit"
          },
          {
            "descriptionKey": "authoring.resource.design-catalogue.description",
            "id": "design-catalogue",
            "kind": "route",
            "labelKey": "authoring.resource.design-catalogue.label",
            "target": "/design"
          },
          {
            "descriptionKey": "authoring.resource.design-doctrine.description",
            "id": "design-doctrine",
            "kind": "asset",
            "labelKey": "authoring.resource.design-doctrine.label",
            "target": "groundworks-app-design"
          },
          {
            "descriptionKey": "authoring.resource.workblocks.description",
            "id": "workblock-catalogue",
            "kind": "route",
            "labelKey": "authoring.resource.workblocks.label",
            "target": "/workblocks"
          },
          {
            "descriptionKey": "authoring.resource.starter.description",
            "id": "starter",
            "kind": "asset",
            "labelKey": "authoring.resource.starter.label",
            "target": "workblock-starter-invoice-exception-triage"
          },
          {
            "descriptionKey": "authoring.resource.portable.description",
            "id": "portable-workblock",
            "kind": "route",
            "labelKey": "authoring.resource.portable.label",
            "target": "/downloads/groundworks-authoring-kit"
          },
          {
            "descriptionKey": "authoring.resource.design-prompt.description",
            "id": "design-prompt",
            "kind": "asset",
            "labelKey": "authoring.resource.design-prompt.label",
            "target": "authoring-prompt-brand-and-style-workblock"
          }
        ],
        "route": "/build/workblock-design",
        "routeId": "workblock-design",
        "sections": [
          {
            "id": "host-and-register",
            "introductionKey": "authoring.design.section.host.introduction",
            "items": [
              {
                "bodyKey": "authoring.design.host.boundary.body",
                "id": "host-boundary",
                "titleKey": "authoring.design.host.boundary.title"
              },
              {
                "bodyKey": "authoring.design.host.register.body",
                "id": "copy-register",
                "titleKey": "authoring.design.host.register.title"
              }
            ],
            "titleKey": "authoring.design.section.host.title"
          },
          {
            "id": "system-language",
            "introductionKey": "authoring.design.section.system.introduction",
            "items": [
              {
                "bodyKey": "authoring.design.system.roles.body",
                "id": "semantic-roles",
                "resourceIds": [
                  "design-doctrine"
                ],
                "titleKey": "authoring.design.system.roles.title"
              },
              {
                "bodyKey": "authoring.design.system.components.body",
                "id": "components",
                "resourceIds": [
                  "design-catalogue"
                ],
                "titleKey": "authoring.design.system.components.title"
              },
              {
                "bodyKey": "authoring.design.system.glyphs.body",
                "id": "glyphs",
                "titleKey": "authoring.design.system.glyphs.title"
              }
            ],
            "titleKey": "authoring.design.section.system.title"
          },
          {
            "id": "truth-and-access",
            "introductionKey": "authoring.design.section.truth.introduction",
            "items": [
              {
                "bodyKey": "authoring.design.truth.state.body",
                "id": "state",
                "titleKey": "authoring.design.truth.state.title"
              },
              {
                "bodyKey": "authoring.design.truth.authority.body",
                "id": "authority",
                "titleKey": "authoring.design.truth.authority.title"
              },
              {
                "bodyKey": "authoring.design.truth.accessibility.body",
                "id": "accessibility",
                "titleKey": "authoring.design.truth.accessibility.title"
              }
            ],
            "titleKey": "authoring.design.section.truth.title"
          }
        ],
        "skill": {
          "boundaryKeys": [
            "authoring.design.skill.boundary1",
            "authoring.design.skill.boundary2",
            "authoring.design.skill.boundary3",
            "authoring.design.skill.boundary4"
          ],
          "descriptionKey": "authoring.design.skill.description",
          "id": "style-groundworks-workblock",
          "name": "style-groundworks-workblock",
          "workflowStepKeys": [
            "authoring.design.skill.step1",
            "authoring.design.skill.step2",
            "authoring.design.skill.step3",
            "authoring.design.skill.step4",
            "authoring.design.skill.step5"
          ]
        },
        "titleKey": "authoring.design.title",
        "version": "1.0.0"
      },
      {
        "checklist": [
          {
            "id": "outcome",
            "labelKey": "authoring.architecture.check.outcome"
          },
          {
            "id": "owner",
            "labelKey": "authoring.architecture.check.owner"
          },
          {
            "id": "surface",
            "labelKey": "authoring.architecture.check.surface"
          },
          {
            "id": "provenance",
            "labelKey": "authoring.architecture.check.provenance"
          },
          {
            "id": "reliability",
            "labelKey": "authoring.architecture.check.reliability"
          },
          {
            "id": "migration",
            "labelKey": "authoring.architecture.check.migration"
          },
          {
            "id": "validation",
            "labelKey": "authoring.architecture.check.validation"
          }
        ],
        "descriptionKey": "authoring.architecture.description",
        "eyebrowKey": "authoring.architecture.eyebrow",
        "id": "workblock-architecture",
        "outcomeKey": "authoring.architecture.outcome",
        "pathways": [
          {
            "id": "outside-platform",
            "steps": [
              {
                "bodyKey": "authoring.architecture.outside.step1.body",
                "id": "install-kit",
                "resourceIds": [
                  "authoring-kit"
                ],
                "titleKey": "authoring.architecture.outside.step1.title"
              },
              {
                "bodyKey": "authoring.architecture.outside.step2.body",
                "id": "select-outcome",
                "resourceIds": [
                  "workblock-catalogue",
                  "module-briefs"
                ],
                "titleKey": "authoring.architecture.outside.step2.title"
              },
              {
                "bodyKey": "authoring.architecture.outside.step3.body",
                "id": "map-records",
                "resourceIds": [
                  "data-catalogue",
                  "data-dictionary",
                  "connected-work"
                ],
                "titleKey": "authoring.architecture.outside.step3.title"
              },
              {
                "bodyKey": "authoring.architecture.outside.step4.body",
                "id": "author-and-validate",
                "resourceIds": [
                  "starter",
                  "architecture-prompt"
                ],
                "titleKey": "authoring.architecture.outside.step4.title"
              }
            ],
            "summaryKey": "authoring.architecture.outside.summary",
            "titleKey": "authoring.architecture.outside.title"
          },
          {
            "id": "inside-platform",
            "steps": [
              {
                "bodyKey": "authoring.architecture.inside.step1.body",
                "id": "start-template",
                "resourceIds": [
                  "portable-workblock"
                ],
                "titleKey": "authoring.architecture.inside.step1.title"
              },
              {
                "bodyKey": "authoring.architecture.inside.step2.body",
                "id": "bind-contracts",
                "resourceIds": [
                  "module-briefs",
                  "data-catalogue"
                ],
                "titleKey": "authoring.architecture.inside.step2.title"
              },
              {
                "bodyKey": "authoring.architecture.inside.step3.body",
                "id": "author-graph",
                "titleKey": "authoring.architecture.inside.step3.title"
              },
              {
                "bodyKey": "authoring.architecture.inside.step4.body",
                "id": "prove-lifecycle",
                "titleKey": "authoring.architecture.inside.step4.title"
              }
            ],
            "summaryKey": "authoring.architecture.inside.summary",
            "titleKey": "authoring.architecture.inside.title"
          }
        ],
        "prompt": {
          "bodyKey": "authoring.architecture.prompt.body",
          "id": "align-workblock-architecture",
          "titleKey": "authoring.architecture.prompt.title"
        },
        "resources": [
          {
            "descriptionKey": "authoring.resource.kit.description",
            "id": "authoring-kit",
            "kind": "asset",
            "labelKey": "authoring.resource.kit.label",
            "target": "groundworks-authoring-kit"
          },
          {
            "descriptionKey": "authoring.resource.workblocks.description",
            "id": "workblock-catalogue",
            "kind": "route",
            "labelKey": "authoring.resource.workblocks.label",
            "target": "/workblocks"
          },
          {
            "descriptionKey": "authoring.resource.module-briefs.description",
            "id": "module-briefs",
            "kind": "route",
            "labelKey": "authoring.resource.module-briefs.label",
            "target": "/downloads"
          },
          {
            "descriptionKey": "authoring.resource.data-catalogue.description",
            "id": "data-catalogue",
            "kind": "route",
            "labelKey": "authoring.resource.data-catalogue.label",
            "target": "/groundworks"
          },
          {
            "descriptionKey": "authoring.resource.data-dictionary.description",
            "id": "data-dictionary",
            "kind": "asset",
            "labelKey": "authoring.resource.data-dictionary.label",
            "target": "data-dictionary"
          },
          {
            "descriptionKey": "authoring.resource.connected-work.description",
            "id": "connected-work",
            "kind": "route",
            "labelKey": "authoring.resource.connected-work.label",
            "target": "/connected-work"
          },
          {
            "descriptionKey": "authoring.resource.starter.description",
            "id": "starter",
            "kind": "asset",
            "labelKey": "authoring.resource.starter.label",
            "target": "workblock-starter-invoice-exception-triage"
          },
          {
            "descriptionKey": "authoring.resource.portable.description",
            "id": "portable-workblock",
            "kind": "route",
            "labelKey": "authoring.resource.portable.label",
            "target": "/downloads/groundworks-authoring-kit"
          },
          {
            "descriptionKey": "authoring.resource.architecture-prompt.description",
            "id": "architecture-prompt",
            "kind": "asset",
            "labelKey": "authoring.resource.architecture-prompt.label",
            "target": "authoring-prompt-align-workblock-architecture"
          }
        ],
        "route": "/build/workblock-architecture",
        "routeId": "workblock-architecture",
        "sections": [
          {
            "id": "outcome-and-graph",
            "introductionKey": "authoring.architecture.section.outcome.introduction",
            "items": [
              {
                "bodyKey": "authoring.architecture.outcome.owner.body",
                "id": "outcome-owner",
                "titleKey": "authoring.architecture.outcome.owner.title"
              },
              {
                "bodyKey": "authoring.architecture.outcome.graph.body",
                "id": "module-graph",
                "titleKey": "authoring.architecture.outcome.graph.title"
              },
              {
                "bodyKey": "authoring.architecture.outcome.authority.body",
                "id": "authority",
                "titleKey": "authoring.architecture.outcome.authority.title"
              }
            ],
            "titleKey": "authoring.architecture.section.outcome.title"
          },
          {
            "id": "state-and-evidence",
            "introductionKey": "authoring.architecture.section.state.introduction",
            "items": [
              {
                "bodyKey": "authoring.architecture.state.ownership.body",
                "id": "ownership",
                "resourceIds": [
                  "data-catalogue"
                ],
                "titleKey": "authoring.architecture.state.ownership.title"
              },
              {
                "bodyKey": "authoring.architecture.state.provenance.body",
                "id": "provenance",
                "titleKey": "authoring.architecture.state.provenance.title"
              },
              {
                "bodyKey": "authoring.architecture.state.freshness.body",
                "id": "freshness",
                "titleKey": "authoring.architecture.state.freshness.title"
              }
            ],
            "titleKey": "authoring.architecture.section.state.title"
          },
          {
            "id": "delivery-and-change",
            "introductionKey": "authoring.architecture.section.delivery.introduction",
            "items": [
              {
                "bodyKey": "authoring.architecture.delivery.reliability.body",
                "id": "reliability",
                "resourceIds": [
                  "connected-work"
                ],
                "titleKey": "authoring.architecture.delivery.reliability.title"
              },
              {
                "bodyKey": "authoring.architecture.delivery.migration.body",
                "id": "migration",
                "titleKey": "authoring.architecture.delivery.migration.title"
              },
              {
                "bodyKey": "authoring.architecture.delivery.validation.body",
                "id": "validation",
                "titleKey": "authoring.architecture.delivery.validation.title"
              }
            ],
            "titleKey": "authoring.architecture.section.delivery.title"
          }
        ],
        "skill": {
          "boundaryKeys": [
            "authoring.architecture.skill.boundary1",
            "authoring.architecture.skill.boundary2",
            "authoring.architecture.skill.boundary3",
            "authoring.architecture.skill.boundary4"
          ],
          "descriptionKey": "authoring.architecture.skill.description",
          "id": "align-groundworks-workblock-architecture",
          "name": "align-groundworks-workblock-architecture",
          "workflowStepKeys": [
            "authoring.architecture.skill.step1",
            "authoring.architecture.skill.step2",
            "authoring.architecture.skill.step3",
            "authoring.architecture.skill.step4",
            "authoring.architecture.skill.step5",
            "authoring.architecture.skill.step6"
          ]
        },
        "titleKey": "authoring.architecture.title",
        "version": "1.0.0"
      }
    ],
    "kit": {
      "descriptionKey": "authoring.kit.description",
      "id": "groundworks-authoring-kit",
      "mcpTools": [
        {
          "descriptionKey": "authoring.kit.tool.get-started",
          "id": "get_started"
        },
        {
          "descriptionKey": "authoring.kit.tool.list-assets",
          "id": "list_assets"
        },
        {
          "descriptionKey": "authoring.kit.tool.search-assets",
          "id": "search_assets"
        },
        {
          "descriptionKey": "authoring.kit.tool.get-asset",
          "id": "get_asset"
        },
        {
          "descriptionKey": "authoring.kit.tool.get-component",
          "id": "get_component"
        },
        {
          "descriptionKey": "authoring.kit.tool.get-entity",
          "id": "get_entity"
        },
        {
          "descriptionKey": "authoring.kit.tool.get-workblock",
          "id": "get_workblock"
        },
        {
          "descriptionKey": "authoring.kit.tool.get-business-module",
          "id": "get_business_module"
        },
        {
          "descriptionKey": "authoring.kit.tool.get-design-doctrine",
          "id": "get_design_doctrine"
        },
        {
          "descriptionKey": "authoring.kit.tool.get-starter",
          "id": "get_starter"
        },
        {
          "descriptionKey": "authoring.kit.tool.get-guide",
          "id": "get_guide"
        },
        {
          "descriptionKey": "authoring.kit.tool.get-prompt",
          "id": "get_prompt"
        },
        {
          "descriptionKey": "authoring.kit.tool.list-skills",
          "id": "list_skills"
        }
      ],
      "setupIntroductionKey": "authoring.kit.setup.introduction",
      "setupSteps": [
        {
          "bodyKey": "authoring.kit.setup.download.body",
          "id": "download",
          "titleKey": "authoring.kit.setup.download.title"
        },
        {
          "bodyKey": "authoring.kit.setup.configure.body",
          "id": "configure",
          "titleKey": "authoring.kit.setup.configure.title"
        },
        {
          "bodyKey": "authoring.kit.setup.skills.body",
          "id": "install-skills",
          "titleKey": "authoring.kit.setup.skills.title"
        },
        {
          "bodyKey": "authoring.kit.setup.start.body",
          "id": "start",
          "titleKey": "authoring.kit.setup.start.title"
        }
      ],
      "setupTitleKey": "authoring.kit.setup.title",
      "skillIds": [
        "style-groundworks-workblock",
        "align-groundworks-workblock-architecture"
      ],
      "titleKey": "authoring.kit.title",
      "version": "1.0.0"
    },
    "registryVersion": "1.0.0",
    "schemaVersion": "1.0.0"
  },
  "businessModuleRegistry": {
    "autonomyLevels": [
      {
        "commitmentBoundary": "No mutation outside retry-local progress and retrieval indexes.",
        "definition": "Assemble, classify and measure evidence without changing a business record.",
        "id": "observe",
        "label": "Observe",
        "level": 1,
        "promotionEvidence": [
          "Source completeness measured",
          "Provenance and freshness checks pass",
          "Representative replay set exists"
        ]
      },
      {
        "commitmentBoundary": "Recommendations are explicitly non-committed and expire when evidence changes.",
        "definition": "Rank options and explain a next action while the business record remains unchanged.",
        "id": "recommend",
        "label": "Recommend",
        "level": 2,
        "promotionEvidence": [
          "Recommendation quality meets the declared evaluation bar",
          "Decline and escalation behaviour is tested",
          "Operators can correct outcomes"
        ]
      },
      {
        "commitmentBoundary": "A draft may be stored and compared but cannot claim or trigger a committed outcome.",
        "definition": "Prepare a complete proposal, artifact or transaction below the commitment boundary.",
        "id": "draft",
        "label": "Draft",
        "level": 3,
        "promotionEvidence": [
          "Diff and source evidence are complete",
          "Proposal staleness is detected",
          "Material omissions and unsupported content are evaluated"
        ]
      },
      {
        "commitmentBoundary": "The authority event is explicit; the Workblock owns safe execution, retry and reconciliation after it.",
        "definition": "Execute a specifically authorised proposal and reconcile the downstream result.",
        "id": "execute_with_approval",
        "label": "Supervised execution",
        "level": 4,
        "promotionEvidence": [
          "Side effects are idempotent",
          "Partial batches reconcile",
          "Recovery and compensating actions are exercised"
        ]
      },
      {
        "commitmentBoundary": "Only listed verbs, entities, thresholds, tools, evidence conditions and time windows are granted.",
        "definition": "Act without per-item review inside a versioned policy envelope, with critic checks, sampling and automatic demotion.",
        "id": "policy_autonomous_with_monitoring",
        "label": "Bounded autonomy",
        "level": 5,
        "promotionEvidence": [
          "Shadow and canary outcomes meet the versioned bar",
          "False-action and missed-exception rates remain within SLO",
          "Kill switch, rollback and sampled review work"
        ]
      },
      {
        "commitmentBoundary": "The mission, budget, duration, tools, forbidden actions and stop conditions are explicit; material or novel commitments still escalate.",
        "definition": "Choose and execute permitted steps toward a bounded goal while humans supervise outcome, policy and harm metrics.",
        "id": "mission_autonomous_with_supervision",
        "label": "Mission autonomy",
        "level": 6,
        "promotionEvidence": [
          "Multi-step plans remain inside the envelope",
          "Course correction and interruption are proven",
          "Standing performance and harm review is operational"
        ]
      }
    ],
    "autonomyNorthStar": "Safe autonomy is the destination: Workblocks act inside versioned authority envelopes while people supervise outcomes, govern policy, inspect sampled performance, handle true exceptions and retain pause, stop and rollback rights.",
    "businessModules": [
      {
        "agents": [
          {
            "autonomousActions": [
              "Accept schema-valid idempotent deltas",
              "Apply validated deterministic mappings",
              "Reuse high-confidence classifications inside calibrated slices",
              "Quarantine malformed or unreconciled lines",
              "Publish a last-good batch after all deterministic gates pass"
            ],
            "escalationTriggers": [
              "Unresolved party collision",
              "Material control-total mismatch",
              "New or unsupported source schema",
              "Restricted data leakage risk",
              "Classification confidence below the active envelope"
            ],
            "id": "spend-steward-agent",
            "label": "Spend steward agent",
            "mission": "Maintain a reconciled, classified and provenance-complete spend projection while abstaining on ambiguous identity or taxonomy decisions.",
            "operatorRoleIds": [
              "data-steward"
            ],
            "personaIds": [
              "category-management-persona",
              "finance",
              "platform-operator"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "procurement-analyst",
              "data-steward"
            ]
          },
          {
            "autonomousActions": [
              "Run deterministic and sampled critic checks",
              "Mark a source or slice degraded",
              "Block a candidate batch",
              "Demote classification to rule-only or proposal mode"
            ],
            "escalationTriggers": [
              "Repeated source reconciliation failure",
              "Material unexplained spend movement",
              "Evaluation slice regression",
              "Lineage gap in a published record"
            ],
            "id": "spend-quality-critic-agent",
            "label": "Spend quality critic agent",
            "mission": "Independently test completeness, reconciliation, classification calibration, lineage and freshness before spend is consumed.",
            "operatorRoleIds": [
              "data-steward"
            ],
            "personaIds": [
              "finance",
              "platform-operator"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "procurement-analyst",
              "data-steward"
            ]
          }
        ],
        "agentStoryKey": "workblock.spend-foundation.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Material unexplained financial reconciliation gap",
            "Suspected restricted or personal data exposure",
            "A source schema change that alters financial meaning",
            "Identity merge across conflicting legal entities",
            "Deletion or broad replacement of canonical spend state"
          ],
          "authorityEnvelope": [
            "Named source adapters, schemas and legal entities",
            "Allowed normalization, identity and category rule versions",
            "Calibrated confidence floors by evaluation slice",
            "Maximum unresolved and reconciliation variance",
            "Allowed create, correct, quarantine and publish verbs",
            "Publication cadence, sample rate and source freshness bounds",
            "Per-source, legal-entity and publication-route kill switches that block new mutations while retaining last-good reads"
          ],
          "humanSupervision": [
            "Govern taxonomy and source contracts",
            "Review sampled high-confidence records and all material drift slices",
            "Resolve novel identity collisions and disputed classifications",
            "Approve widening to new sources, fields or classification slices",
            "Retain pause, quarantine and rollback rights"
          ],
          "rollback": [
            "Stop new publication while preserving source snapshots and last-good rows",
            "Restore the last-approved mapping, classifier and schema projection",
            "Replay affected source batches using stable business keys",
            "Reconcile downstream change events and mark superseded records"
          ],
          "targetPosture": "policy_autonomous_with_monitoring"
        },
        "coreValue": "Turn fragmented spend lines into a governed, current and explainable evidence foundation that every category, policy, demand and sourcing action can trust without pretending one source system owns all meaning.",
        "currentStateKey": "workblock.spend-foundation.current-state",
        "dataMappings": [
          {
            "access": "create",
            "entityId": "spend-record",
            "purpose": "Create provenance-complete normalised spend lines only after source validation and reconciliation."
          },
          {
            "access": "update",
            "entityId": "spend-record",
            "purpose": "Apply versioned identity, classification and quality corrections without overwriting source evidence."
          },
          {
            "access": "read",
            "entityId": "spend-record",
            "purpose": "Support reconciliation, record drill-through, downstream analysis and evaluation."
          },
          {
            "access": "index",
            "entityId": "spend-record",
            "purpose": "Serve stable equality lookup and permission-scoped analytical projections."
          },
          {
            "access": "create",
            "entityId": "spend-classification-decision",
            "purpose": "Record a provenance-complete classification proposal or authorised decision without overwriting a predecessor."
          },
          {
            "access": "update",
            "entityId": "spend-classification-decision",
            "purpose": "Advance acknowledgement or reconciliation state under expected-version control; corrections and reversals use successor records."
          },
          {
            "access": "read",
            "entityId": "spend-classification-decision",
            "purpose": "Expose the permission-filtered proposal, decision, commitment and correction chain for record drill-through."
          },
          {
            "access": "index",
            "entityId": "spend-classification-decision",
            "purpose": "Support permission-scoped decision-chain lookup without making the index authoritative."
          },
          {
            "access": "read",
            "entityId": "taxonomy-version",
            "purpose": "Resolve category and assignment records against the exact active company taxonomy version."
          },
          {
            "access": "read",
            "entityId": "category-dimension-assignment",
            "purpose": "Resolve the exact category assignment and nearest authorised ancestor without inferring a default from proposal signals."
          },
          {
            "access": "index",
            "entityId": "tail-spend-evaluation",
            "purpose": "Own the governed tail spend evaluation contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "spend-record",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "spend-classification-decision",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "tail-spend-evaluation",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          }
        ],
        "descriptionKey": "workblock.spend-foundation.description",
        "descriptorKey": "workblock.spend-foundation.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "strategy-policy-category-spend",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "category-manager",
              "procurement-analyst",
              "data-steward",
              "policy-owner"
            ],
            "id": "ingest-spend-delta",
            "jobIds": [
              "spend-data-foundation.addressable-view",
              "spend-data-foundation.ambiguous-record",
              "spend-data-foundation.publication-control",
              "spend-data-foundation.stale-consumer"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: accepted source batch, source lineage bundle, and batch intake status.",
                "Accepted and rejected inputs are counted, source-linked and assigned a freshness state; a failed refresh retains last-good data.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "procurement-analyst",
                "data-steward"
              ]
            },
            "kind": "ingest",
            "label": "Ingest spend delta",
            "trigger": "Explicit adapter event or governed schedule supplies source ID, watermark, schema version and snapshot reference."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "category-manager",
              "procurement-analyst",
              "data-steward",
              "policy-owner"
            ],
            "id": "canonicalize-spend",
            "jobIds": [
              "spend-data-foundation.addressable-view",
              "spend-data-foundation.ambiguous-record",
              "spend-data-foundation.publication-control",
              "spend-data-foundation.stale-consumer"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: candidate spend records, classification diagnostics, and unresolved lines.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "procurement-analyst",
                "data-steward"
              ]
            },
            "kind": "analyse",
            "label": "Canonicalize and classify spend",
            "trigger": "Accepted source batch from the ingest module."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "category-manager",
              "procurement-analyst",
              "data-steward",
              "policy-owner"
            ],
            "id": "reconcile-publish-spend",
            "jobIds": [
              "spend-data-foundation.addressable-view",
              "spend-data-foundation.ambiguous-record",
              "spend-data-foundation.publication-control",
              "spend-data-foundation.stale-consumer"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: reconciliation result, publication disposition, and spend change set.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "procurement-analyst",
                "data-steward"
              ]
            },
            "kind": "operate",
            "label": "Reconcile and publish spend",
            "trigger": "Candidate spend records and source control totals are available."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "category-manager",
              "procurement-analyst",
              "data-steward",
              "policy-owner"
            ],
            "id": "monitor-spend-foundation",
            "jobIds": [
              "spend-data-foundation.addressable-view",
              "spend-data-foundation.ambiguous-record",
              "spend-data-foundation.publication-control",
              "spend-data-foundation.stale-consumer"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: foundation health, spend evaluation result, and posture recommendation.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "procurement-analyst",
                "data-steward"
              ]
            },
            "kind": "monitor",
            "label": "Monitor spend foundation",
            "trigger": "Publication, correction, source-health change or scheduled evaluation."
          }
        ],
        "futureStateKey": "workblock.spend-foundation.future-state",
        "hiredInsteadKey": "workblock.spend-foundation.hired-instead",
        "id": "spend-data-foundation",
        "implementationStatus": "roadmap",
        "jobStatementKey": "workblock.spend-foundation.job",
        "jobStories": [
          {
            "completionKey": "workblock.spend-foundation.story.addressable-view.completion",
            "executionFlowIds": [
              "ingest-spend-delta",
              "canonicalize-spend",
              "reconcile-publish-spend",
              "monitor-spend-foundation"
            ],
            "id": "spend-data-foundation.addressable-view",
            "roleCardId": "procurement-analyst",
            "storyKey": "workblock.spend-foundation.story.addressable-view.story"
          },
          {
            "completionKey": "workblock.spend-foundation.story.ambiguous-record.completion",
            "executionFlowIds": [
              "ingest-spend-delta",
              "canonicalize-spend",
              "reconcile-publish-spend",
              "monitor-spend-foundation"
            ],
            "id": "spend-data-foundation.ambiguous-record",
            "roleCardId": "data-steward",
            "storyKey": "workblock.spend-foundation.story.ambiguous-record.story"
          },
          {
            "completionKey": "workblock.spend-foundation.story.publication-control.completion",
            "executionFlowIds": [
              "ingest-spend-delta",
              "canonicalize-spend",
              "reconcile-publish-spend",
              "monitor-spend-foundation"
            ],
            "id": "spend-data-foundation.publication-control",
            "roleCardId": "data-steward",
            "storyKey": "workblock.spend-foundation.story.publication-control.story"
          },
          {
            "completionKey": "workblock.spend-foundation.story.stale-consumer.completion",
            "executionFlowIds": [
              "ingest-spend-delta",
              "canonicalize-spend",
              "reconcile-publish-spend",
              "monitor-spend-foundation"
            ],
            "id": "spend-data-foundation.stale-consumer",
            "roleCardId": "procurement-analyst",
            "storyKey": "workblock.spend-foundation.story.stale-consumer.story"
          }
        ],
        "labelKey": "workblock.spend-foundation.label",
        "metrics": [
          "Source coverage: accepted source spend divided by declared in-scope source spend, with record drill-through",
          "Reconciliation variance: absolute canonical-to-source value difference by source and period",
          "Classification coverage and calibrated accuracy by category and source slice",
          "Unresolved identity rate and median resolution age",
          "Freshness SLO attainment by source",
          "Duplicate or lost-record rate after replay",
          "Downstream correction rate per one thousand published lines"
        ],
        "officeCapabilities": [
          "conductor"
        ],
        "operatingModel": "Continuously ingest source-shaped financial deltas, preserve source identity, canonicalize parties and categories, reconcile totals, publish a last-good operational projection and convert validated corrections into versioned classification evidence.",
        "outcomeKey": "workblock.spend-foundation.outcome",
        "prerequisites": [
          "A read connection to each ERP and finance system that holds line-level spend",
          "Source delta feeds or extracts with stable business keys for spend lines",
          "The category taxonomy and legal-entity structure for canonical records",
          "A named data steward for identity collisions and disputed classifications",
          "Agreed reconciliation tolerances and confidence floors for publication"
        ],
        "toolKey": "workblock.spend-foundation.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Refresh eligible signals",
              "Create and merge non-committed opportunity hypotheses",
              "Re-score and expire stale proposals",
              "Recommend a destination Workblock",
              "Request bounded evidence refresh"
            ],
            "escalationTriggers": [
              "Material value with low evidence confidence",
              "Conflicting strategy or policy",
              "Novel risk or market event",
              "Potential supplier fairness or confidentiality issue",
              "Proposed action outside portfolio capacity"
            ],
            "id": "category-radar-agent",
            "label": "Category radar agent",
            "mission": "Discover, refresh and prioritise category opportunity hypotheses while preserving counter-evidence and avoiding duplicate action.",
            "operatorRoleIds": [
              "category-manager"
            ],
            "personaIds": [
              "category-management-persona",
              "procurement-leadership"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "procurement-analyst",
              "category-manager"
            ]
          },
          {
            "autonomousActions": [
              "Mark evidence insufficient",
              "Reduce confidence or priority",
              "Detect overlap and link related opportunities",
              "Expire invalidated hypotheses"
            ],
            "escalationTriggers": [
              "Irreconcilable baseline disagreement",
              "Material risk excluded from the score",
              "Evidence access conflict",
              "Potentially misleading financial claim"
            ],
            "id": "opportunity-critic-agent",
            "label": "Opportunity critic agent",
            "mission": "Challenge baselines, causal claims, double counting, feasibility and evidence sufficiency before an opportunity is promoted.",
            "operatorRoleIds": [
              "category-manager"
            ],
            "personaIds": [
              "finance",
              "supplier-risk-manager",
              "category-management-persona"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "procurement-analyst",
              "category-manager"
            ]
          },
          {
            "autonomousActions": [
              "Refresh price evidence for exposed categories on each series' published assessment cadence",
              "Recompute outlook scenarios when an index moves beyond the configured band",
              "Create, re-score and expire non-committed price-driven opportunity proposals",
              "Mark an outlook degraded when a referenced price series is revised, stale or discontinued",
              "Record outlook accuracy against later observed assessments"
            ],
            "escalationTriggers": [
              "A referenced price series is discontinued, renamed or changes methodology",
              "Observed prices decouple from the modelled cost drivers",
              "An outlook would support a purchase commitment or a contract price change",
              "Outlook calibration breaches its governed error band",
              "Price evidence permission or licensing limits would be exceeded"
            ],
            "id": "commodity-price-outlook-agent",
            "label": "Commodity price outlook agent",
            "mission": "Maintain explainable commodity price outlooks per category exposure and surface price-driven opportunities before market windows close.",
            "operatorRoleIds": [
              "category-manager"
            ],
            "personaIds": [
              "category-management-persona",
              "finance",
              "procurement-leadership"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "category-manager",
              "procurement-analyst"
            ]
          },
          {
            "autonomousActions": [
              "Resolve the tail scope from evaluation refreshes and repeat-purchase patterns",
              "Read tail-spend evaluations, spend records and buying requests as clustering evidence",
              "Cluster repeat purchases by category, item similarity and supplier overlap",
              "Propose consolidation candidates with the repeat history and channel basis attached",
              "Expire candidates whose repeat pattern or evidence lapses"
            ],
            "escalationTriggers": [
              "A proposed cluster crosses a category boundary or a declared exclusion",
              "Tail-spend evaluation source is stale, revised or discontinued",
              "A candidate implies changing a confirmed requirement or supplier commitment",
              "Cluster evidence conflicts across sources without a resolvable owner",
              "Any conversion execution or supplier contact is requested"
            ],
            "id": "tail-spend-consolidation-agent",
            "label": "Tail spend consolidation agent",
            "mission": "Cluster repeat tail purchases across suppliers and channels and surface consolidation candidates as evidence-linked category opportunities before the tail fragments further.",
            "operatorRoleIds": [
              "category-manager"
            ],
            "personaIds": [
              "category-management-persona",
              "buyer",
              "finance"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "category-manager",
              "procurement-analyst"
            ]
          }
        ],
        "agentStoryKey": "workblock.category-radar.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Any external supplier communication or business commitment",
            "A material financial claim lacking finance-approved baseline",
            "A novel risk, sustainability or legal consequence",
            "Cross-category double counting that cannot be resolved deterministically",
            "Evidence that the active strategy or policy is unsafe or contradictory"
          ],
          "authorityEnvelope": [
            "Named categories, signal sources and freshness floors",
            "Permitted opportunity types and baseline methods",
            "Maximum proposal value and confidence bands for autonomous ranking",
            "Allowed create, merge, refresh, rank, expire and handoff-proposal verbs",
            "Forbidden supplier communication, commitment and realized-value claims",
            "Mission duration, portfolio capacity and stop conditions",
            "Per-category, signal-source and handoff-route kill switches that preserve current opportunity reads"
          ],
          "humanSupervision": [
            "Set category objectives and value methods",
            "Inspect sampled high-ranked and suppressed opportunities",
            "Resolve material baseline or causal disputes",
            "Accept, decline or delegate consequential initiatives",
            "Review missed-opportunity and harm metrics"
          ],
          "rollback": [
            "Stop new hypothesis creation and handoffs",
            "Restore the last-approved detector, scoring and baseline versions",
            "Re-score active records and mark superseded proposals",
            "Retract unconsumed handoff proposals while preserving evidence",
            "Reconcile any converted records with downstream owners"
          ],
          "targetPosture": "mission_autonomous_with_supervision"
        },
        "coreValue": "Keep category teams focused on the few current opportunities that can change value, resilience, compliance or demand outcomes, with every score opening into the records that created it.",
        "currentStateKey": "workblock.category-radar.current-state",
        "dataMappings": [
          {
            "access": "create",
            "entityId": "category-opportunity",
            "purpose": "Persist distinct, evidence-complete and expiring opportunity hypotheses."
          },
          {
            "access": "update",
            "entityId": "category-opportunity",
            "purpose": "Refresh scores, evidence, expiry disposition and downstream linkage without rewriting history."
          },
          {
            "access": "read",
            "entityId": "category-opportunity",
            "purpose": "Serve portfolio, critic, conversion and outcome-reconciliation views."
          },
          {
            "access": "index",
            "entityId": "category-opportunity",
            "purpose": "Support category, mechanism, state, freshness and strategy lookup."
          },
          {
            "access": "read",
            "entityId": "spend-record",
            "purpose": "Derive governed spend movement, fragmentation, concentration and addressability signals."
          },
          {
            "access": "read",
            "entityId": "business-unit",
            "purpose": "Read the policy-filtered canonical business unit projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "category",
            "purpose": "Read the policy-filtered canonical category projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "source-record-reference",
            "purpose": "Read the policy-filtered canonical source record reference projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "evidence-item",
            "purpose": "Read the policy-filtered canonical evidence item projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "authority-envelope",
            "purpose": "Read the policy-filtered canonical authority envelope projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "learning-example",
            "purpose": "Read the policy-filtered canonical learning example projection from learning-evaluation-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "evaluation-result",
            "purpose": "Read the policy-filtered canonical evaluation result projection from learning-evaluation-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "integration-state",
            "purpose": "Read the policy-filtered canonical integration state projection from integration-state-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "tail-spend-evaluation",
            "purpose": "Read the governed tail spend evaluation contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "buying-request",
            "purpose": "Read the policy-filtered canonical buying-request projection from guided-buying; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "category-opportunity",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "action-proposal",
            "purpose": "Point-read the exact permission-safe D1 handoff action-proposal record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "decision",
            "purpose": "Point-read the exact permission-safe D1 handoff decision record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "committed-action",
            "purpose": "Point-read the exact permission-safe D1 handoff committed-action record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "business-event",
            "purpose": "Point-read the exact permission-safe D1 handoff business-event record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "create",
            "entityId": "action-proposal",
            "purpose": "Submit the version-pinned D1 requested outcome, sender/receiver, source/target, evidence, authority, expiry and reopen context to shared-ledger-service without writing receiver-owned state."
          },
          {
            "access": "append",
            "entityId": "committed-action",
            "purpose": "Append each authorised D1 delivery or receiver-owned command attempt with idempotency, safe-retry and reconciliation state through shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "business-event",
            "purpose": "Append immutable D1 delivery, acknowledgement, rejection, reconciliation, replay or reopen facts through audit-event-service; an event never becomes current domain state."
          }
        ],
        "descriptionKey": "workblock.category-radar.description",
        "descriptorKey": "workblock.category-radar.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "strategy-policy-category-spend",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "category-manager",
              "procurement-analyst",
              "data-steward",
              "policy-owner"
            ],
            "id": "refresh-category-signals",
            "jobIds": [
              "category-opportunity-radar.spend-refresh",
              "category-opportunity-radar.market-event",
              "category-opportunity-radar.duplicate-signals",
              "category-opportunity-radar.boundary-review",
              "category-opportunity-radar.approved-handoff",
              "category-opportunity-radar.source-change"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "A typed-signal-set and radar-source-health record exist for the requested category scope, with source freshness and any degraded inputs visible.",
                "Accepted and rejected inputs are counted, source-linked and assigned a freshness state; a failed refresh retains last-good data.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "procurement-analyst",
                "category-manager"
              ]
            },
            "kind": "refresh",
            "label": "Refresh category signals",
            "trigger": "Spend, demand, strategy, contract, supplier, market or policy change event, plus scheduled freshness scan."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "category-manager",
              "procurement-analyst",
              "data-steward",
              "policy-owner"
            ],
            "id": "detect-category-opportunities",
            "jobIds": [
              "category-opportunity-radar.spend-refresh",
              "category-opportunity-radar.market-event",
              "category-opportunity-radar.duplicate-signals",
              "category-opportunity-radar.boundary-review",
              "category-opportunity-radar.approved-handoff",
              "category-opportunity-radar.source-change"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Evidence-complete-candidates and detection-diagnostics show the hypothesis, baseline, value range, source evidence, expiry, duplicates and unresolved gaps.",
                "Each candidate is ready to be accepted for assessment, dismissed with a recorded reason, or parked with a reopening condition.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "category-manager",
                "procurement-analyst"
              ]
            },
            "kind": "analyse",
            "label": "Detect category opportunities",
            "trigger": "Typed signal set for one or more categories."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "category-manager",
              "procurement-analyst",
              "data-steward",
              "policy-owner"
            ],
            "id": "qualify-category-opportunities",
            "jobIds": [
              "category-opportunity-radar.spend-refresh",
              "category-opportunity-radar.market-event",
              "category-opportunity-radar.duplicate-signals",
              "category-opportunity-radar.boundary-review",
              "category-opportunity-radar.approved-handoff",
              "category-opportunity-radar.source-change"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The opportunity-change-set records each candidate as accepted, dismissed or parked with its reason, owner and reopening condition; the ranked-opportunity-summary and any exception-proposals reference the same evidence version.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "category-manager",
                "procurement-analyst"
              ]
            },
            "kind": "operate",
            "label": "Qualify and maintain opportunities",
            "trigger": "Evidence-complete candidates or material evidence change."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "category-manager",
              "procurement-analyst",
              "data-steward",
              "policy-owner"
            ],
            "id": "read-category-opportunity-portfolio",
            "jobIds": [
              "category-opportunity-radar.spend-refresh",
              "category-opportunity-radar.market-event",
              "category-opportunity-radar.duplicate-signals",
              "category-opportunity-radar.boundary-review",
              "category-opportunity-radar.approved-handoff",
              "category-opportunity-radar.source-change"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The category-opportunity-portfolio and portfolio-snapshot-version expose current or clearly stale last-good records, with every aggregate linked to its contributing opportunities and evidence.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "category-manager",
                "procurement-analyst"
              ]
            },
            "kind": "read",
            "label": "Read category opportunity portfolio",
            "trigger": "User, role agent or downstream Workblock requests a scoped portfolio or record."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "category-manager",
              "procurement-analyst",
              "data-steward",
              "policy-owner"
            ],
            "id": "learn-category-opportunity-outcomes",
            "jobIds": [
              "category-opportunity-radar.spend-refresh",
              "category-opportunity-radar.market-event",
              "category-opportunity-radar.duplicate-signals",
              "category-opportunity-radar.boundary-review",
              "category-opportunity-radar.approved-handoff",
              "category-opportunity-radar.source-change"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The radar-evaluation links prediction, disposition and realized outcome by version and slice; the radar-posture-recommendation states whether to retain, narrow, demote or propose a detector change.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "procurement-analyst",
                "category-manager"
              ]
            },
            "kind": "monitor",
            "label": "Learn from opportunity outcomes",
            "trigger": "Opportunity disposition, converted initiative milestone or realized-outcome reconciliation."
          },
          {
            "agentIds": [
              "commodity-price-outlook-agent"
            ],
            "escalationRoleIds": [
              "category-manager",
              "procurement-analyst",
              "data-steward",
              "policy-owner"
            ],
            "id": "project-commodity-price-outlook",
            "jobIds": [
              "category-opportunity-radar.market-event"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "A commodity-price-outlook-set exists for each exposed category scope, and every scenario names its price series, assessment date, publication cadence and revision state, with projected values kept distinct from observed assessments.",
                "Each price-driven-opportunity-proposal references the outlook version and its evidence items, carries an expiry, and remains a non-committed proposal; no output records a purchase or a contract price change.",
                "Stale, revised or discontinued price series are marked with their freshness state, the flow retains last-good outlooks, and each escalation records its reason and target role.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "category-manager",
                "procurement-analyst"
              ]
            },
            "kind": "agent",
            "label": "Project commodity price outlook",
            "trigger": "Market price evidence refresh or a commodity index movement beyond the configured band."
          },
          {
            "agentIds": [
              "tail-spend-consolidation-agent"
            ],
            "escalationRoleIds": [
              "category-manager",
              "policy-owner"
            ],
            "id": "surface-tail-consolidation-opportunities",
            "jobIds": [
              "category-opportunity-radar.spend-refresh"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: tail consolidation cluster set and tail consolidation candidate proposal.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "category-manager"
              ]
            },
            "kind": "agent",
            "label": "Surface tail consolidation opportunities",
            "trigger": "Tail-spend evaluation refresh or repeat-purchase pattern detected across buying requests in an indirect category."
          }
        ],
        "futureStateKey": "workblock.category-radar.future-state",
        "hiredInsteadKey": "workblock.category-radar.hired-instead",
        "id": "category-opportunity-radar",
        "implementationStatus": "pattern",
        "jobStatementKey": "workblock.category-radar.job",
        "jobStories": [
          {
            "completionKey": "workblock.category-radar.story.spend-refresh.completion",
            "executionFlowIds": [
              "refresh-category-signals",
              "detect-category-opportunities",
              "qualify-category-opportunities",
              "read-category-opportunity-portfolio",
              "learn-category-opportunity-outcomes",
              "surface-tail-consolidation-opportunities"
            ],
            "id": "category-opportunity-radar.spend-refresh",
            "roleCardId": "category-manager",
            "storyKey": "workblock.category-radar.story.spend-refresh.story"
          },
          {
            "completionKey": "workblock.category-radar.story.market-event.completion",
            "executionFlowIds": [
              "refresh-category-signals",
              "detect-category-opportunities",
              "qualify-category-opportunities",
              "read-category-opportunity-portfolio",
              "learn-category-opportunity-outcomes",
              "project-commodity-price-outlook"
            ],
            "id": "category-opportunity-radar.market-event",
            "roleCardId": "category-manager",
            "storyKey": "workblock.category-radar.story.market-event.story"
          },
          {
            "completionKey": "workblock.category-radar.story.duplicate-signals.completion",
            "executionFlowIds": [
              "refresh-category-signals",
              "detect-category-opportunities",
              "qualify-category-opportunities",
              "read-category-opportunity-portfolio",
              "learn-category-opportunity-outcomes"
            ],
            "id": "category-opportunity-radar.duplicate-signals",
            "roleCardId": "procurement-analyst",
            "storyKey": "workblock.category-radar.story.duplicate-signals.story"
          },
          {
            "completionKey": "workblock.category-radar.story.boundary-review.completion",
            "executionFlowIds": [
              "refresh-category-signals",
              "detect-category-opportunities",
              "qualify-category-opportunities",
              "read-category-opportunity-portfolio",
              "learn-category-opportunity-outcomes"
            ],
            "id": "category-opportunity-radar.boundary-review",
            "roleCardId": "category-manager",
            "storyKey": "workblock.category-radar.story.boundary-review.story"
          },
          {
            "completionKey": "workblock.category-radar.story.approved-handoff.completion",
            "executionFlowIds": [
              "refresh-category-signals",
              "detect-category-opportunities",
              "qualify-category-opportunities",
              "read-category-opportunity-portfolio",
              "learn-category-opportunity-outcomes"
            ],
            "id": "category-opportunity-radar.approved-handoff",
            "roleCardId": "category-manager",
            "storyKey": "workblock.category-radar.story.approved-handoff.story"
          },
          {
            "completionKey": "workblock.category-radar.story.source-change.completion",
            "executionFlowIds": [
              "refresh-category-signals",
              "detect-category-opportunities",
              "qualify-category-opportunities",
              "read-category-opportunity-portfolio",
              "learn-category-opportunity-outcomes"
            ],
            "id": "category-opportunity-radar.source-change",
            "roleCardId": "procurement-analyst",
            "storyKey": "workblock.category-radar.story.source-change.story"
          }
        ],
        "labelKey": "workblock.category-radar.label",
        "metrics": [
          "Qualified-opportunity precision and estimated recall by mechanism",
          "Median signal-to-qualified-opportunity time",
          "Accepted and converted share of qualified opportunities",
          "Predicted value range calibration against reconciled outcomes",
          "Duplicate and double-counting rate",
          "Stale-opportunity rate and median expiry lag",
          "Portfolio attention load per category owner"
        ],
        "officeCapabilities": [
          "conductor"
        ],
        "operatingModel": "Continuously assemble spend, demand, market, contract, supplier and policy signals; detect and de-duplicate opportunity hypotheses; quantify and critic-test them; maintain an explainable portfolio; and hand accepted opportunities to strategy or sourcing without crossing the initiative commitment boundary.",
        "outcomeKey": "workblock.category-radar.outcome",
        "prerequisites": [
          "Access to the governed spend record baseline",
          "The category taxonomy and business-unit structure",
          "Named category owners to accept or decline qualified opportunities",
          "Agreed category objectives and value methods for scoring",
          "Authority envelopes defining the opportunity actions the agent may take"
        ],
        "toolKey": "workblock.category-radar.tool",
        "version": "5.2.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Refresh the fact base",
              "Draft and compare non-committed scenarios",
              "Maintain assumption and dependency registers",
              "Propose objectives and initiative sequencing",
              "Mark stale assumptions"
            ],
            "escalationTriggers": [
              "Material objective or baseline change",
              "Conflicting finance and category value methods",
              "Novel legal, supply or sustainability risk",
              "Insufficient evidence for a consequential initiative"
            ],
            "id": "category-strategist-agent",
            "label": "Category strategist agent",
            "mission": "Synthesize current category evidence into challenged strategy scenarios, objectives and an executable initiative portfolio.",
            "operatorRoleIds": [
              "category-manager"
            ],
            "personaIds": [
              "category-management-persona",
              "procurement-leadership",
              "finance"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "category-manager",
              "procurement-analyst",
              "policy-owner"
            ]
          },
          {
            "autonomousActions": [
              "Start permitted reversible initiative handoffs",
              "Sequence dependencies",
              "Refresh milestone and outcome state",
              "Pause work on guard breach",
              "Propose bounded reallocation or replanning"
            ],
            "escalationTriggers": [
              "New external commitment",
              "Budget or authority threshold breach",
              "Material strategy objective conflict",
              "Systemic supplier or operational risk",
              "Irreversible cancellation or relationship action"
            ],
            "id": "strategy-orchestration-agent",
            "label": "Strategy orchestration agent",
            "mission": "Pursue committed category objectives by coordinating permitted Workblock handoffs, monitoring outcomes and replanning inside the strategy envelope.",
            "operatorRoleIds": [
              "category-manager"
            ],
            "personaIds": [
              "category-management-persona",
              "supplier-relationship-manager",
              "supplier-risk-manager"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "category-manager",
              "procurement-analyst",
              "policy-owner"
            ]
          }
        ],
        "agentStoryKey": "workblock.category-strategy.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "A strategy, budget or authority-envelope change",
            "External commercial, legal or supplier commitment outside an existing grant",
            "Material value, risk or sustainability trade-off",
            "Irreversible cancellation, supplier exit or public communication",
            "Evidence that the mission or policy is unsafe"
          ],
          "authorityEnvelope": [
            "Committed strategy version, category, objectives and mission horizon",
            "Named initiative classes, budgets, tools and downstream Workblocks",
            "Allowed draft, refresh, sequence, launch reversible handoff, pause and propose-replan verbs",
            "Evidence, source-health, outcome and risk guard conditions",
            "Maximum concurrent initiatives and resource allocation",
            "Forbidden supplier commitments, policy changes and irreversible relationship actions",
            "Per-category, initiative-class and downstream-Workblock kill switches for new handoffs and mutating tools"
          ],
          "humanSupervision": [
            "Commit strategy objectives and material revisions",
            "Set portfolio budget and initiative authority classes",
            "Inspect outcome, harm and sampled action metrics",
            "Resolve cross-functional objective and priority conflicts",
            "Pause, narrow or roll back the mission"
          ],
          "rollback": [
            "Pause new downstream starts while preserving active case state",
            "Restore the last-approved strategy and authority versions",
            "Cancel only uncommitted handoff proposals",
            "Reconcile running downstream Workblocks and partial effects with their owners",
            "Recompute strategy projections and publish explicit supersession"
          ],
          "targetPosture": "mission_autonomous_with_supervision"
        },
        "coreValue": "Make category strategy a living, executable and evidence-traceable system of work that continuously connects objectives to initiatives, dependencies, authority and observed outcomes.",
        "currentStateKey": "workblock.category-strategy.current-state",
        "dataMappings": [
          {
            "access": "create",
            "entityId": "category-strategy",
            "purpose": "Create complete, versioned strategy proposals and committed releases."
          },
          {
            "access": "update",
            "entityId": "category-strategy",
            "purpose": "Maintain current execution links and lifecycle while strategy content changes create a new version."
          },
          {
            "access": "read",
            "entityId": "category-strategy",
            "purpose": "Serve orchestration, monitoring, drill-through and downstream strategy context."
          },
          {
            "access": "index",
            "entityId": "category-strategy",
            "purpose": "Find the active strategy, owner and reviews by stable equality keys."
          },
          {
            "access": "read",
            "entityId": "category-opportunity",
            "purpose": "Build and monitor the initiative portfolio from accepted opportunities."
          },
          {
            "access": "update",
            "entityId": "category-opportunity",
            "purpose": "Submit a typed owner command to category-opportunity-radar to link accepted opportunities to the governing strategy and mark conversion without changing evidence."
          },
          {
            "access": "read",
            "entityId": "spend-record",
            "purpose": "Build reproducible spend baselines and monitor financial assumptions."
          },
          {
            "access": "read",
            "entityId": "tail-spend-evaluation",
            "purpose": "Read the governed tail spend evaluation contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "category-strategy",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "action-proposal",
            "purpose": "Point-read the exact permission-safe D1 handoff action-proposal record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "decision",
            "purpose": "Point-read the exact permission-safe D1 handoff decision record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "committed-action",
            "purpose": "Point-read the exact permission-safe D1 handoff committed-action record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "business-event",
            "purpose": "Point-read the exact permission-safe D1 handoff business-event record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "create",
            "entityId": "decision",
            "purpose": "Submit the authorised, version-pinned D1 receiving-owner acceptance, rejection, redirect, expiry or reopen decision to shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "committed-action",
            "purpose": "Append each authorised D1 delivery or receiver-owned command attempt with idempotency, safe-retry and reconciliation state through shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "business-event",
            "purpose": "Append immutable D1 delivery, acknowledgement, rejection, reconciliation, replay or reopen facts through audit-event-service; an event never becomes current domain state."
          }
        ],
        "descriptionKey": "workblock.category-strategy.description",
        "descriptorKey": "workblock.category-strategy.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "strategy-policy-category-spend",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "category-manager",
              "procurement-analyst",
              "data-steward",
              "policy-owner"
            ],
            "id": "assemble-category-fact-base",
            "jobIds": [
              "category-strategy-orchestrator.current-fact-base",
              "category-strategy-orchestrator.scenario-choice",
              "category-strategy-orchestrator.strategy-commit",
              "category-strategy-orchestrator.initiative-handoff",
              "category-strategy-orchestrator.strategy-drift"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: strategy context snapshot and fact base diagnostics.",
                "Accepted and rejected inputs are counted, source-linked and assigned a freshness state; a failed refresh retains last-good data.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "category-manager",
                "procurement-analyst",
                "policy-owner"
              ]
            },
            "kind": "refresh",
            "label": "Assemble category fact base",
            "trigger": "Strategy start, source change or assumption freshness scan."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "category-manager",
              "procurement-analyst",
              "data-steward",
              "policy-owner"
            ],
            "id": "design-category-strategy",
            "jobIds": [
              "category-strategy-orchestrator.current-fact-base",
              "category-strategy-orchestrator.scenario-choice",
              "category-strategy-orchestrator.strategy-commit",
              "category-strategy-orchestrator.initiative-handoff",
              "category-strategy-orchestrator.strategy-drift"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: strategy candidate, challenged strategy scenarios, and strategy design diagnostics.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "category-manager",
                "procurement-analyst",
                "policy-owner"
              ]
            },
            "kind": "analyse",
            "label": "Design category strategy",
            "trigger": "Current strategy context and planning mandate."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "category-manager",
              "procurement-analyst",
              "data-steward",
              "policy-owner"
            ],
            "id": "commit-category-strategy",
            "jobIds": [
              "category-strategy-orchestrator.current-fact-base",
              "category-strategy-orchestrator.scenario-choice",
              "category-strategy-orchestrator.strategy-commit",
              "category-strategy-orchestrator.initiative-handoff",
              "category-strategy-orchestrator.strategy-drift"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: committed strategy and strategy release.",
                "The exact proposal version, authorised reviewer or policy authority, decision and reason are durable before any commitment.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "category-manager",
                "procurement-analyst",
                "policy-owner"
              ]
            },
            "kind": "review",
            "label": "Commit category strategy version",
            "trigger": "A complete strategy candidate is ready for authority or exception review."
          },
          {
            "agentIds": [
              "category-strategist-agent",
              "strategy-orchestration-agent"
            ],
            "escalationRoleIds": [
              "category-manager",
              "procurement-analyst",
              "data-steward",
              "policy-owner"
            ],
            "id": "orchestrate-category-strategy",
            "jobIds": [
              "category-strategy-orchestrator.current-fact-base",
              "category-strategy-orchestrator.scenario-choice",
              "category-strategy-orchestrator.strategy-commit",
              "category-strategy-orchestrator.initiative-handoff",
              "category-strategy-orchestrator.strategy-drift"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: initiative state, orchestration disposition, and strategy handoff events.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "category-manager",
                "procurement-analyst",
                "policy-owner"
              ]
            },
            "kind": "agent",
            "label": "Orchestrate category strategy",
            "trigger": "Active strategy, initiative event or scheduled mission cycle."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "category-manager",
              "procurement-analyst",
              "data-steward",
              "policy-owner"
            ],
            "id": "monitor-strategy-fitness",
            "jobIds": [
              "category-strategy-orchestrator.current-fact-base",
              "category-strategy-orchestrator.scenario-choice",
              "category-strategy-orchestrator.strategy-commit",
              "category-strategy-orchestrator.initiative-handoff",
              "category-strategy-orchestrator.strategy-drift"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: strategy fitness findings, strategy evaluation, and strategy posture recommendation.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "category-manager",
                "procurement-analyst",
                "policy-owner"
              ]
            },
            "kind": "monitor",
            "label": "Monitor strategy fitness",
            "trigger": "Evidence, assumption, initiative or outcome change."
          }
        ],
        "futureStateKey": "workblock.category-strategy.future-state",
        "hiredInsteadKey": "workblock.category-strategy.hired-instead",
        "id": "category-strategy-orchestrator",
        "implementationStatus": "roadmap",
        "jobStatementKey": "workblock.category-strategy.job",
        "jobStories": [
          {
            "completionKey": "workblock.category-strategy.story.current-fact-base.completion",
            "executionFlowIds": [
              "assemble-category-fact-base",
              "design-category-strategy",
              "commit-category-strategy",
              "orchestrate-category-strategy",
              "monitor-strategy-fitness"
            ],
            "id": "category-strategy-orchestrator.current-fact-base",
            "roleCardId": "category-manager",
            "storyKey": "workblock.category-strategy.story.current-fact-base.story"
          },
          {
            "completionKey": "workblock.category-strategy.story.scenario-choice.completion",
            "executionFlowIds": [
              "assemble-category-fact-base",
              "design-category-strategy",
              "commit-category-strategy",
              "orchestrate-category-strategy",
              "monitor-strategy-fitness"
            ],
            "id": "category-strategy-orchestrator.scenario-choice",
            "roleCardId": "category-manager",
            "storyKey": "workblock.category-strategy.story.scenario-choice.story"
          },
          {
            "completionKey": "workblock.category-strategy.story.strategy-commit.completion",
            "executionFlowIds": [
              "assemble-category-fact-base",
              "design-category-strategy",
              "commit-category-strategy",
              "orchestrate-category-strategy",
              "monitor-strategy-fitness"
            ],
            "id": "category-strategy-orchestrator.strategy-commit",
            "roleCardId": "category-manager",
            "storyKey": "workblock.category-strategy.story.strategy-commit.story"
          },
          {
            "completionKey": "workblock.category-strategy.story.initiative-handoff.completion",
            "executionFlowIds": [
              "assemble-category-fact-base",
              "design-category-strategy",
              "commit-category-strategy",
              "orchestrate-category-strategy",
              "monitor-strategy-fitness"
            ],
            "id": "category-strategy-orchestrator.initiative-handoff",
            "roleCardId": "procurement-analyst",
            "storyKey": "workblock.category-strategy.story.initiative-handoff.story"
          },
          {
            "completionKey": "workblock.category-strategy.story.strategy-drift.completion",
            "executionFlowIds": [
              "assemble-category-fact-base",
              "design-category-strategy",
              "commit-category-strategy",
              "orchestrate-category-strategy",
              "monitor-strategy-fitness"
            ],
            "id": "category-strategy-orchestrator.strategy-drift",
            "roleCardId": "category-manager",
            "storyKey": "workblock.category-strategy.story.strategy-drift.story"
          }
        ],
        "labelKey": "workblock.category-strategy.label",
        "metrics": [
          "Share of active initiatives linked to a current strategy objective",
          "Strategy assumption freshness and stale-duration distribution",
          "Initiative on-time milestone rate with record drill-through",
          "Predicted-to-reconciled value calibration",
          "Cross-Workblock handoff success and exception rates",
          "Median drift-to-replan-proposal time",
          "Policy-bounded action conformance and sampled defect rate"
        ],
        "officeCapabilities": [
          "composer",
          "conductor"
        ],
        "operatingModel": "Assemble a current category fact base, co-author scenarios and a versioned strategy, commit approved objectives and authority boundaries, orchestrate accepted initiatives across Workblocks, monitor assumptions and outcomes, and propose replanning before drift becomes a periodic-review surprise.",
        "outcomeKey": "workblock.category-strategy.outcome",
        "prerequisites": [
          "Access to the governed spend record baseline",
          "A qualified category opportunity backlog to draw initiatives from",
          "Named owners with authority to commit strategy objectives and revisions",
          "Agreed portfolio budget and initiative authority classes"
        ],
        "toolKey": "workblock.category-strategy.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Extract non-committed rule candidates",
              "Generate boundary and conflict tests",
              "Flag ambiguity and unreachable rules",
              "Prepare release diffs",
              "Apply pre-authorised editorial metadata patches"
            ],
            "escalationTriggers": [
              "Ambiguous source policy",
              "Material change in eligibility threshold or obligation",
              "Conflicting policy authority",
              "Rule effect lacking a source anchor",
              "Personal or restricted fact use without purpose authority"
            ],
            "id": "policy-rule-author-agent",
            "label": "Policy rule author agent",
            "mission": "Translate source-anchored policy into deterministic typed rule proposals without inventing obligations or obscuring ambiguity.",
            "operatorRoleIds": [
              "data-steward"
            ],
            "personaIds": [
              "contract-legal",
              "category-management-persona",
              "platform-operator"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "policy-owner",
              "data-steward"
            ]
          },
          {
            "autonomousActions": [
              "Block a failing release",
              "Start a pre-authorised low-risk canary",
              "Suspend a release on guard breach",
              "Notify affected consumers",
              "Recommend promotion or demotion"
            ],
            "escalationTriggers": [
              "Material decision delta",
              "Unresolved legal interpretation",
              "Financial or access-control harm",
              "No compatible rollback release",
              "Consumer cannot pin or acknowledge the release"
            ],
            "id": "policy-release-critic-agent",
            "label": "Policy release critic agent",
            "mission": "Independently prove semantic fidelity, regression behaviour, precedence, consumer compatibility and rollback readiness before activation.",
            "operatorRoleIds": [
              "data-steward"
            ],
            "personaIds": [
              "platform-operator",
              "contract-legal",
              "finance"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "policy-owner",
              "data-steward"
            ]
          },
          {
            "autonomousActions": [
              "Resolve which released channel rules are in scope for a review window",
              "Read routed requisitions as channel-usage evidence with named records",
              "Assess drift per rule with assigned route, observed route and drift share",
              "Propose channel-rule adjustments with the drift evidence attached",
              "Expire drift findings whose evidence or rule release lapses"
            ],
            "escalationTriggers": [
              "A proposed adjustment would change an approval threshold or authority boundary",
              "Requisition evidence is stale, revised or incomplete for the review window",
              "Drift is concentrated on a rule under active release testing",
              "A finding implies remediating an individual buy rather than a rule",
              "Any rule deployment or release approval is requested"
            ],
            "id": "channel-drift-agent",
            "label": "Channel drift agent",
            "mission": "Measure where routed buying leaves its released channel rules, name the rule and the evidence behind every drift finding, and propose rule adjustments that make the compliant path the easiest path.",
            "operatorRoleIds": [
              "policy-owner"
            ],
            "personaIds": [
              "category-management-persona",
              "finance",
              "platform-operator"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "policy-owner"
            ]
          }
        ],
        "agentStoryKey": "workblock.policy-lifecycle.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Threshold, eligibility, obligation, prohibition or authority meaning changes",
            "Use of a new personal or restricted fact",
            "Conflicting legal or policy authority",
            "No safe compatible rollback",
            "Material access, financial, fairness or regulatory harm"
          ],
          "authorityEnvelope": [
            "Named policy IDs, rule families and consumer Workblocks",
            "Allowed extraction, test generation, compatibility analysis, packaging, canary, suspend and rollback verbs",
            "Pre-authorised non-semantic patch classes",
            "Evaluation suites and zero-tolerance control invariants",
            "Canary audience, decision-volume cap and duration",
            "Exact rollback release and stop conditions",
            "Per-policy-family, release and consumer-cohort kill switches that stop activation without hiding the last-good release"
          ],
          "humanSupervision": [
            "Own policy meaning and approve material semantic changes",
            "Review sampled rule-to-source traces",
            "Set evaluation and harm thresholds",
            "Approve expansion to new facts, consumers or authority classes",
            "Review standing exception and override patterns"
          ],
          "rollback": [
            "Suspend the candidate release and stop new evaluations against it",
            "Restore the named last-approved release",
            "Notify consumers and invalidate unexpired guidance produced only by the failed release",
            "Replay affected decisions and open exceptions for material deltas",
            "Preserve the failed release and evaluation evidence for audit"
          ],
          "targetPosture": "policy_autonomous_with_monitoring"
        },
        "coreValue": "Convert governed procurement policy into transparent, testable and safely deployable machine rules so every Workblock applies the same effective logic and can prove which version governed an action.",
        "currentStateKey": "workblock.policy-lifecycle.current-state",
        "dataMappings": [
          {
            "access": "create",
            "entityId": "policy-rule-release",
            "purpose": "Persist immutable executable rule releases with source, evaluation and rollback lineage."
          },
          {
            "access": "update",
            "entityId": "policy-rule-release",
            "purpose": "Manage release activation, suspension and retirement without altering immutable rule meaning."
          },
          {
            "access": "read",
            "entityId": "policy-rule-release",
            "purpose": "Support authoring diffs, runtime resolution, consumer compatibility and audit drill-through."
          },
          {
            "access": "index",
            "entityId": "policy-rule-release",
            "purpose": "Resolve exact active rules by governed equality keys and effective time."
          },
          {
            "access": "create",
            "entityId": "tail-spend-rule",
            "purpose": "Create a versioned company-scoped tail-spend definition without writing membership onto transactions."
          },
          {
            "access": "update",
            "entityId": "tail-spend-rule",
            "purpose": "Activate, supersede or retire a rule under expected-version control without changing its analytical meaning."
          },
          {
            "access": "read",
            "entityId": "tail-spend-rule",
            "purpose": "Expose the exact period, scope, method and provenance required to reproduce a membership evaluation."
          },
          {
            "access": "index",
            "entityId": "tail-spend-rule",
            "purpose": "Support permission-scoped active-rule lookup while keeping the index derived and rebuildable."
          },
          {
            "access": "read",
            "entityId": "policy-guidance-result",
            "purpose": "Evaluate runtime decision distribution, exceptions, overrides and consumer impact."
          },
          {
            "access": "read",
            "entityId": "requisition",
            "purpose": "Read the policy-filtered canonical requisition projection from requisition-policy-routing; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "policy-rule-release",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "tail-spend-rule",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "create",
            "entityId": "policy-change-impact",
            "purpose": "Create the frozen policy-change impact cohort with evidence, affected-owner handoffs, expiry and authority lineage."
          },
          {
            "access": "update",
            "entityId": "policy-change-impact",
            "purpose": "Advance acknowledgement, reconciliation, closure, expiry or reopening under expected-version control without overwriting the frozen impact snapshot."
          },
          {
            "access": "read",
            "entityId": "policy-change-impact",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "policy-change-impact",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "action-proposal",
            "purpose": "Point-read the exact permission-safe D3/D4 handoff action-proposal record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "decision",
            "purpose": "Point-read the exact permission-safe D3/D4 handoff decision record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "committed-action",
            "purpose": "Point-read the exact permission-safe D3/D4 handoff committed-action record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "business-event",
            "purpose": "Point-read the exact permission-safe D3/D4 handoff business-event record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "create",
            "entityId": "action-proposal",
            "purpose": "Submit the version-pinned D3/D4 requested outcome, sender/receiver, source/target, evidence, authority, expiry and reopen context to shared-ledger-service without writing receiver-owned state."
          },
          {
            "access": "create",
            "entityId": "decision",
            "purpose": "Submit the authorised, version-pinned D3/D4 receiving-owner acceptance, rejection, redirect, expiry or reopen decision to shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "committed-action",
            "purpose": "Append each authorised D3/D4 delivery or receiver-owned command attempt with idempotency, safe-retry and reconciliation state through shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "business-event",
            "purpose": "Append immutable D3/D4 delivery, acknowledgement, rejection, reconciliation, replay or reopen facts through audit-event-service; an event never becomes current domain state."
          },
          {
            "access": "read",
            "entityId": "intake-request",
            "purpose": "Read the exact D4 intake evidence record/version presented to the rule owner."
          },
          {
            "access": "read",
            "entityId": "policy-guidance-result",
            "purpose": "Evaluate the reproducible, permission-filtered D3 guidance-result cohort for the changed rule release and frozen snapshot."
          },
          {
            "access": "read",
            "entityId": "requisition",
            "purpose": "Evaluate the reproducible, permission-filtered D3 requisition cohort from owner-held policy evaluations at the frozen snapshot."
          }
        ],
        "descriptionKey": "workblock.policy-lifecycle.description",
        "descriptorKey": "workblock.policy-lifecycle.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "strategy-policy-category-spend",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "category-manager",
              "procurement-analyst",
              "data-steward",
              "policy-owner"
            ],
            "id": "ingest-policy-version",
            "jobIds": [
              "policy-rule-lifecycle.source-trace",
              "policy-rule-lifecycle.rule-authoring",
              "policy-rule-lifecycle.boundary-testing",
              "policy-rule-lifecycle.controlled-release",
              "policy-rule-lifecycle.change-impact"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: policy clause set, semantic change set, and policy impact map.",
                "Accepted and rejected inputs are counted, source-linked and assigned a freshness state; a failed refresh retains last-good data.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "policy-owner",
                "data-steward"
              ]
            },
            "kind": "ingest",
            "label": "Ingest policy version",
            "trigger": "Approved policy-version event or explicit governed import."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "category-manager",
              "procurement-analyst",
              "data-steward",
              "policy-owner"
            ],
            "id": "author-test-rule-release",
            "jobIds": [
              "policy-rule-lifecycle.source-trace",
              "policy-rule-lifecycle.rule-authoring",
              "policy-rule-lifecycle.boundary-testing",
              "policy-rule-lifecycle.controlled-release",
              "policy-rule-lifecycle.change-impact"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: release candidate, candidate evaluation, and rule authoring diagnostics.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "policy-owner",
                "data-steward"
              ]
            },
            "kind": "analyse",
            "label": "Author and test rule release",
            "trigger": "Accepted policy clauses and explicit release scope."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "category-manager",
              "procurement-analyst",
              "data-steward",
              "policy-owner"
            ],
            "id": "approve-deploy-rule-release",
            "jobIds": [
              "policy-rule-lifecycle.source-trace",
              "policy-rule-lifecycle.rule-authoring",
              "policy-rule-lifecycle.boundary-testing",
              "policy-rule-lifecycle.controlled-release",
              "policy-rule-lifecycle.change-impact"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: approved rule release and deployment result.",
                "The exact proposal version, authorised reviewer or policy authority, decision and reason are durable before any commitment.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "policy-owner",
                "data-steward"
              ]
            },
            "kind": "review",
            "label": "Approve and deploy rule release",
            "trigger": "A complete release candidate and evaluation result."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "category-manager",
              "procurement-analyst",
              "data-steward",
              "policy-owner"
            ],
            "id": "monitor-policy-runtime",
            "jobIds": [
              "policy-rule-lifecycle.source-trace",
              "policy-rule-lifecycle.rule-authoring",
              "policy-rule-lifecycle.boundary-testing",
              "policy-rule-lifecycle.controlled-release",
              "policy-rule-lifecycle.change-impact"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: runtime evaluation, release findings, and release disposition.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "policy-owner",
                "data-steward"
              ]
            },
            "kind": "monitor",
            "label": "Monitor policy runtime",
            "trigger": "Guidance result, exception, override, consumer error or scheduled evaluation."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "category-manager",
              "procurement-analyst",
              "data-steward",
              "policy-owner"
            ],
            "id": "read-policy-release-registry",
            "jobIds": [
              "policy-rule-lifecycle.source-trace",
              "policy-rule-lifecycle.rule-authoring",
              "policy-rule-lifecycle.boundary-testing",
              "policy-rule-lifecycle.controlled-release",
              "policy-rule-lifecycle.change-impact"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: policy release registry response.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "policy-owner",
                "data-steward"
              ]
            },
            "kind": "read",
            "label": "Read policy release registry",
            "trigger": "Authorised Workblock, operator or auditor requests releases, diffs or lineage."
          },
          {
            "agentIds": [
              "channel-drift-agent"
            ],
            "escalationRoleIds": [
              "policy-owner",
              "category-manager"
            ],
            "id": "monitor-channel-drift",
            "jobIds": [
              "policy-rule-lifecycle.channel-drift"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: channel drift assessment and channel rule adjustment proposal.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "policy-owner"
              ]
            },
            "kind": "agent",
            "label": "Monitor channel drift",
            "trigger": "Routed requisition volume drifting from released channel rules beyond the configured tolerance, or a channel-rule release review window opens."
          }
        ],
        "futureStateKey": "workblock.policy-lifecycle.future-state",
        "hiredInsteadKey": "workblock.policy-lifecycle.hired-instead",
        "id": "policy-rule-lifecycle",
        "implementationStatus": "roadmap",
        "jobStatementKey": "workblock.policy-lifecycle.job",
        "jobStories": [
          {
            "completionKey": "workblock.policy-lifecycle.story.source-trace.completion",
            "executionFlowIds": [
              "ingest-policy-version",
              "author-test-rule-release",
              "approve-deploy-rule-release",
              "monitor-policy-runtime",
              "read-policy-release-registry"
            ],
            "id": "policy-rule-lifecycle.source-trace",
            "roleCardId": "policy-owner",
            "storyKey": "workblock.policy-lifecycle.story.source-trace.story"
          },
          {
            "completionKey": "workblock.policy-lifecycle.story.rule-authoring.completion",
            "executionFlowIds": [
              "ingest-policy-version",
              "author-test-rule-release",
              "approve-deploy-rule-release",
              "monitor-policy-runtime",
              "read-policy-release-registry"
            ],
            "id": "policy-rule-lifecycle.rule-authoring",
            "roleCardId": "policy-owner",
            "storyKey": "workblock.policy-lifecycle.story.rule-authoring.story"
          },
          {
            "completionKey": "workblock.policy-lifecycle.story.boundary-testing.completion",
            "executionFlowIds": [
              "ingest-policy-version",
              "author-test-rule-release",
              "approve-deploy-rule-release",
              "monitor-policy-runtime",
              "read-policy-release-registry"
            ],
            "id": "policy-rule-lifecycle.boundary-testing",
            "roleCardId": "policy-owner",
            "storyKey": "workblock.policy-lifecycle.story.boundary-testing.story"
          },
          {
            "completionKey": "workblock.policy-lifecycle.story.controlled-release.completion",
            "executionFlowIds": [
              "ingest-policy-version",
              "author-test-rule-release",
              "approve-deploy-rule-release",
              "monitor-policy-runtime",
              "read-policy-release-registry"
            ],
            "id": "policy-rule-lifecycle.controlled-release",
            "roleCardId": "policy-owner",
            "storyKey": "workblock.policy-lifecycle.story.controlled-release.story"
          },
          {
            "completionKey": "workblock.policy-lifecycle.story.change-impact.completion",
            "executionFlowIds": [
              "ingest-policy-version",
              "author-test-rule-release",
              "approve-deploy-rule-release",
              "monitor-policy-runtime",
              "read-policy-release-registry"
            ],
            "id": "policy-rule-lifecycle.change-impact",
            "roleCardId": "policy-owner",
            "storyKey": "workblock.policy-lifecycle.story.change-impact.story"
          },
          {
            "completionKey": "workblock.policy-lifecycle.story.channel-drift.completion",
            "executionFlowIds": [
              "monitor-channel-drift"
            ],
            "id": "policy-rule-lifecycle.channel-drift",
            "roleCardId": "policy-owner",
            "storyKey": "workblock.policy-lifecycle.story.channel-drift.story"
          }
        ],
        "labelKey": "workblock.policy-lifecycle.label",
        "metrics": [
          "Rule-to-source anchor coverage",
          "Evaluation pass rate by suite and consequence class",
          "Unexpected active-to-candidate decision delta",
          "Policy exception and override rate by rule",
          "Consumer compatibility and acknowledgement rate",
          "Median policy approval-to-runtime release time",
          "Rollback recovery time and affected-decision reconciliation completeness"
        ],
        "officeCapabilities": [
          "composer"
        ],
        "operatingModel": "Ingest approved policy versions, extract and author typed rule candidates, resolve precedence, test representative and adversarial cases, publish immutable releases, canary policy-runtime changes, monitor decision and harm outcomes, and roll back or demote on breach while preserving the last-good active release with explicit source, evaluation and consumer freshness.",
        "outcomeKey": "workblock.policy-lifecycle.outcome",
        "prerequisites": [
          "The approved procurement policy documents in their governed versions",
          "Named policy owners with authority over policy meaning",
          "Representative historical cases for rule testing and simulation",
          "Agreed evaluation and harm thresholds for release and rollback"
        ],
        "toolKey": "workblock.policy-lifecycle.tool",
        "version": "5.2.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Normalize questions into typed facts",
              "Evaluate active deterministic rules",
              "Return expiring guidance",
              "Ask bounded clarification questions",
              "Open an exception when a declared condition requires it"
            ],
            "escalationTriggers": [
              "Conflicting effective rules",
              "No authoritative source for a material fact",
              "Novel or consequential policy gap",
              "Restricted evidence the current viewer cannot access",
              "Request to override or commit an action"
            ],
            "id": "policy-guidance-agent",
            "label": "Policy guidance agent",
            "mission": "Resolve routine procurement policy questions from typed facts and effective rules, explain the result and ask only decision-relevant clarifications.",
            "operatorRoleIds": [
              "category-manager"
            ],
            "personaIds": [
              "requester-persona",
              "buyer",
              "category-management-persona"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "policy-owner",
              "category-manager"
            ]
          },
          {
            "autonomousActions": [
              "Block unsupported guidance",
              "Remove inaccessible explanation detail",
              "Expire stale results",
              "Demote to recommendation-only",
              "Route a true exception"
            ],
            "escalationTriggers": [
              "Source and rule meaning conflict",
              "Potential legal interpretation",
              "Access-control leakage",
              "Material repeated false guidance"
            ],
            "id": "guidance-critic-agent",
            "label": "Guidance critic agent",
            "mission": "Independently verify fact provenance, effective-time rules, explanation fidelity, audience safety and proposal language before guidance is actionable.",
            "operatorRoleIds": [
              "category-manager"
            ],
            "personaIds": [
              "contract-legal",
              "platform-operator"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "policy-owner",
              "category-manager"
            ]
          }
        ],
        "agentStoryKey": "workblock.policy.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Request to override policy or expand authority",
            "Conflicting active rule outcomes",
            "Novel legal, regulatory, safety or material financial consequence",
            "Inaccessible evidence required to decide",
            "Any downstream commitment not already authorised by its owning Workblock"
          ],
          "authorityEnvelope": [
            "Named audiences, subject entity types and policy domains",
            "Allowed read, normalize, clarify, evaluate, explain, expire and open-exception verbs",
            "Approved fact schemas, rule releases and retrieval collections",
            "Minimum fact provenance and explanation critic thresholds",
            "Maximum advice validity and exception consequence classes",
            "No permission to override policy or commit downstream business actions",
            "Per-policy-domain, audience and downstream-consumer kill switches for new actionable guidance"
          ],
          "humanSupervision": [
            "Own policy meaning and exception authority",
            "Inspect sampled actionable and declined guidance",
            "Correct misunderstood facts and explanations",
            "Review recurring gaps and harmful distributional patterns",
            "Pause or narrow policy domains"
          ],
          "rollback": [
            "Stop new actionable guidance while continuing read-only policy search",
            "Restore the last-approved rule, prompt and retrieval-index versions",
            "Expire results affected by the failed version",
            "Replay affected cases and notify consuming Workblocks",
            "Preserve prior results and exception evidence"
          ],
          "targetPosture": "policy_autonomous_with_monitoring"
        },
        "coreValue": "Give each requester, buyer and agent an immediate, source-anchored answer about what is permitted, what evidence is missing and which route is valid, while ensuring advice expires and never masquerades as a committed action.",
        "currentStateKey": "workblock.policy.current-state",
        "dataMappings": [
          {
            "access": "create",
            "entityId": "policy-guidance-result",
            "purpose": "Persist an immutable, expiring policy evaluation with exact facts, rules and explanation."
          },
          {
            "access": "update",
            "entityId": "policy-guidance-result",
            "purpose": "Link a resulting exception or shorten validity without changing the evaluated outcome."
          },
          {
            "access": "read",
            "entityId": "policy-guidance-result",
            "purpose": "Serve requester explanations, Workblock route checks, audit and evaluation replay."
          },
          {
            "access": "index",
            "entityId": "policy-guidance-result",
            "purpose": "Resolve reusable current guidance, affected results and exception-linked cases."
          },
          {
            "access": "read",
            "entityId": "policy-rule-release",
            "purpose": "Evaluate exact effective rules and produce source-traceable outcomes."
          },
          {
            "access": "read",
            "entityId": "evidence-item",
            "purpose": "Read the policy-filtered canonical evidence item projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "policy",
            "purpose": "Read the policy-filtered canonical policy projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "policy-version",
            "purpose": "Read the policy-filtered canonical policy version projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "exception",
            "purpose": "Read the policy-filtered canonical exception case projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "registry-release",
            "purpose": "Read the policy-filtered canonical registry release projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "tail-spend-evaluation",
            "purpose": "Read the governed tail spend evaluation contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "policy-guidance-result",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "policy-change-impact",
            "purpose": "Read an authorised policy-change-impact record by stable identity through policy-rule-lifecycle's owner API; this grants no collection browsing or datastore access."
          },
          {
            "access": "read",
            "entityId": "action-proposal",
            "purpose": "Point-read the exact permission-safe D3 handoff action-proposal record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "decision",
            "purpose": "Point-read the exact permission-safe D3 handoff decision record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "committed-action",
            "purpose": "Point-read the exact permission-safe D3 handoff committed-action record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "business-event",
            "purpose": "Point-read the exact permission-safe D3 handoff business-event record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "create",
            "entityId": "decision",
            "purpose": "Submit the authorised, version-pinned D3 receiving-owner acceptance, rejection, redirect, expiry or reopen decision to shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "committed-action",
            "purpose": "Append each authorised D3 delivery or receiver-owned command attempt with idempotency, safe-retry and reconciliation state through shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "business-event",
            "purpose": "Append immutable D3 delivery, acknowledgement, rejection, reconciliation, replay or reopen facts through audit-event-service; an event never becomes current domain state."
          }
        ],
        "descriptionKey": "workblock.policy.description",
        "descriptorKey": "workblock.policy.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "strategy-policy-category-spend",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "category-manager",
              "procurement-analyst",
              "data-steward",
              "policy-owner"
            ],
            "id": "evaluate-policy-question",
            "jobIds": [
              "policy-guidance.which-route",
              "policy-guidance.missing-fact",
              "policy-guidance.conflicting-sources",
              "policy-guidance.exception-route",
              "policy-guidance.policy-change",
              "policy-guidance.decision-point"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: policy trace, evaluation inputs, and missing fact questions.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "policy-owner",
                "category-manager"
              ]
            },
            "kind": "analyse",
            "label": "Evaluate policy question",
            "trigger": "Typed API request, role-agent tool call or submitted conversational question."
          },
          {
            "agentIds": [
              "policy-guidance-agent",
              "guidance-critic-agent"
            ],
            "escalationRoleIds": [
              "category-manager",
              "procurement-analyst",
              "data-steward",
              "policy-owner"
            ],
            "id": "compose-policy-guidance",
            "jobIds": [
              "policy-guidance.which-route",
              "policy-guidance.missing-fact",
              "policy-guidance.conflicting-sources",
              "policy-guidance.exception-route",
              "policy-guidance.policy-change",
              "policy-guidance.decision-point"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: policy guidance result and guidance disposition.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "policy-owner",
                "category-manager"
              ]
            },
            "kind": "agent",
            "label": "Compose and critic guidance",
            "trigger": "Complete deterministic policy trace."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "category-manager",
              "procurement-analyst",
              "data-steward",
              "policy-owner"
            ],
            "id": "operate-policy-exception",
            "jobIds": [
              "policy-guidance.which-route",
              "policy-guidance.missing-fact",
              "policy-guidance.conflicting-sources",
              "policy-guidance.exception-route",
              "policy-guidance.policy-change",
              "policy-guidance.decision-point"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: exception reference and exception event.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "policy-owner",
                "category-manager"
              ]
            },
            "kind": "operate",
            "label": "Operate policy exception",
            "trigger": "Guidance outcome is exception-required or insufficient evidence cannot be resolved automatically."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "category-manager",
              "procurement-analyst",
              "data-steward",
              "policy-owner"
            ],
            "id": "monitor-policy-guidance",
            "jobIds": [
              "policy-guidance.which-route",
              "policy-guidance.missing-fact",
              "policy-guidance.conflicting-sources",
              "policy-guidance.exception-route",
              "policy-guidance.policy-change",
              "policy-guidance.decision-point"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: expired result set, guidance evaluation, and guidance posture recommendation.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "policy-owner",
                "category-manager"
              ]
            },
            "kind": "monitor",
            "label": "Monitor policy guidance",
            "trigger": "Rule release change, subject fact change, exception resolution, correction or scheduled sample."
          }
        ],
        "futureStateKey": "workblock.policy.future-state",
        "hiredInsteadKey": "workblock.policy.hired-instead",
        "id": "policy-guidance",
        "implementationStatus": "pattern",
        "jobStatementKey": "workblock.policy.job",
        "jobStories": [
          {
            "completionKey": "workblock.policy.story.which-route.completion",
            "executionFlowIds": [
              "evaluate-policy-question",
              "compose-policy-guidance",
              "operate-policy-exception",
              "monitor-policy-guidance"
            ],
            "id": "policy-guidance.which-route",
            "roleCardId": "policy-owner",
            "storyKey": "workblock.policy.story.which-route.story"
          },
          {
            "completionKey": "workblock.policy.story.missing-fact.completion",
            "executionFlowIds": [
              "evaluate-policy-question",
              "compose-policy-guidance",
              "operate-policy-exception",
              "monitor-policy-guidance"
            ],
            "id": "policy-guidance.missing-fact",
            "roleCardId": "policy-owner",
            "storyKey": "workblock.policy.story.missing-fact.story"
          },
          {
            "completionKey": "workblock.policy.story.conflicting-sources.completion",
            "executionFlowIds": [
              "evaluate-policy-question",
              "compose-policy-guidance",
              "operate-policy-exception",
              "monitor-policy-guidance"
            ],
            "id": "policy-guidance.conflicting-sources",
            "roleCardId": "policy-owner",
            "storyKey": "workblock.policy.story.conflicting-sources.story"
          },
          {
            "completionKey": "workblock.policy.story.exception-route.completion",
            "executionFlowIds": [
              "evaluate-policy-question",
              "compose-policy-guidance",
              "operate-policy-exception",
              "monitor-policy-guidance"
            ],
            "id": "policy-guidance.exception-route",
            "roleCardId": "policy-owner",
            "storyKey": "workblock.policy.story.exception-route.story"
          },
          {
            "completionKey": "workblock.policy.story.policy-change.completion",
            "executionFlowIds": [
              "evaluate-policy-question",
              "compose-policy-guidance",
              "operate-policy-exception",
              "monitor-policy-guidance"
            ],
            "id": "policy-guidance.policy-change",
            "roleCardId": "policy-owner",
            "storyKey": "workblock.policy.story.policy-change.story"
          },
          {
            "completionKey": "workblock.policy.story.decision-point.completion",
            "executionFlowIds": [
              "evaluate-policy-question",
              "compose-policy-guidance",
              "operate-policy-exception",
              "monitor-policy-guidance"
            ],
            "id": "policy-guidance.decision-point",
            "roleCardId": "policy-owner",
            "storyKey": "workblock.policy.story.decision-point.story"
          }
        ],
        "labelKey": "workblock.policy.label",
        "metrics": [
          "First-pass actionable-guidance rate with denominator of complete in-scope questions",
          "Outcome accuracy and missed-exception rate on sampled cases",
          "Median question-to-guidance duration",
          "Average decision-relevant clarification turns",
          "Source-anchor and fact-provenance completeness",
          "Expired-guidance reuse prevented",
          "Exception resolution feedback captured and replayed"
        ],
        "officeCapabilities": [
          "composer"
        ],
        "operatingModel": "Normalize a procurement question or proposed action into typed facts, resolve effective rule releases, evaluate deterministic conditions, retrieve permission-safe source explanations, critic-check the answer, return an expiring guidance result, preserve the last-good result as visibly non-actionable when stale, reconcile consumer receipt and reevaluation, and open a true exception only when active policy cannot decide safely.",
        "outcomeKey": "workblock.policy.outcome",
        "prerequisites": [
          "Versioned policy sources and their executable rule releases",
          "Named exception owners for questions active policy cannot decide",
          "Permission scopes defining who may see each policy source",
          "Guidance expiry and re-evaluation rules configured"
        ],
        "toolKey": "workblock.policy.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Draft offering versions",
              "Generate aliases and example intents",
              "Flag overlaps and missing contracts",
              "Apply pre-authorised metadata corrections",
              "Suspend an offering whose entrypoint is unavailable"
            ],
            "escalationTriggers": [
              "Material eligibility or service-scope change",
              "No accountable owner",
              "Conflicting policy releases",
              "Breaking input-schema migration",
              "Restricted-service audience ambiguity"
            ],
            "id": "service-catalogue-curator-agent",
            "label": "Service catalogue curator agent",
            "mission": "Maintain complete, non-overlapping and policy-compatible offering proposals from service-owner evidence.",
            "operatorRoleIds": [
              "intake-owner"
            ],
            "personaIds": [
              "buyer",
              "category-management-persona",
              "platform-operator"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "process-owner",
              "intake-owner",
              "requester"
            ]
          },
          {
            "autonomousActions": [
              "Rank eligible offerings",
              "Explain differences and required inputs",
              "Start a non-committed intake draft",
              "Record unmet intent",
              "Recommend buyer assistance"
            ],
            "escalationTriggers": [
              "No eligible service",
              "Multiple materially different high-confidence matches",
              "Request implies prohibited or high-consequence activity",
              "Required facts cannot be obtained safely"
            ],
            "id": "service-discovery-agent",
            "label": "Service discovery agent",
            "mission": "Match requester intent to eligible services with explainable confidence and abstain when the catalogue cannot safely decide.",
            "operatorRoleIds": [
              "intake-owner"
            ],
            "personaIds": [
              "requester-persona",
              "buyer"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "process-owner",
              "intake-owner",
              "requester"
            ]
          }
        ],
        "agentStoryKey": "workblock.service-catalogue.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "New service or material scope and eligibility meaning",
            "Breaking schema or in-flight migration",
            "Restricted audience uncertainty",
            "Conflicting policy or service ownership",
            "A service path enabling an external commitment without its owning Workblock"
          ],
          "authorityEnvelope": [
            "Named service families, audiences and legal entities",
            "Allowed draft, index, rank, explain, start-draft, suspend and pre-authorised metadata-publish verbs",
            "Approved policy releases, offering schemas and Workblock entrypoints",
            "Minimum match confidence and eligibility evidence",
            "Maximum canary audience and release consequence class",
            "No authority to create new policy, entitlement or business commitment",
            "Per-service-family, audience and start-route kill switches that retain the last-good catalogue projection"
          ],
          "humanSupervision": [
            "Own service scope and outcomes",
            "Approve material eligibility, input or expectation changes",
            "Inspect unmet intent, rerouting and sampled match quality",
            "Govern restricted audiences and offering ownership",
            "Pause or roll back releases"
          ],
          "rollback": [
            "Stop new starts for the candidate release",
            "Restore the last-good offering and search projection",
            "Keep in-flight requests pinned to compatible versions",
            "Notify affected owners and reroute only through explicit compatible contracts",
            "Replay search and intake outcomes for reconciliation"
          ],
          "targetPosture": "policy_autonomous_with_monitoring"
        },
        "coreValue": "Present one plain-language, policy-current front door to procurement services so people and agents can discover the right outcome, required evidence and expected path without understanding the organisation chart.",
        "currentStateKey": "workblock.service-catalogue.current-state",
        "dataMappings": [
          {
            "access": "create",
            "entityId": "procurement-service-offering",
            "purpose": "Create immutable, executable offering versions with policy and Workblock contracts."
          },
          {
            "access": "update",
            "entityId": "procurement-service-offering",
            "purpose": "Publish, suspend, supersede or retire a release without altering its contract."
          },
          {
            "access": "read",
            "entityId": "procurement-service-offering",
            "purpose": "Serve permission-scoped discovery, compatibility checks and release drill-through."
          },
          {
            "access": "index",
            "entityId": "procurement-service-offering",
            "purpose": "Support stable service lookup and permission-filtered search projections."
          },
          {
            "access": "read",
            "entityId": "policy-rule-release",
            "purpose": "Validate offering eligibility and bind the exact effective policy behaviour."
          },
          {
            "access": "read",
            "entityId": "procurement-service-offering",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "policy-change-impact",
            "purpose": "Read an authorised policy-change-impact record by stable identity through policy-rule-lifecycle's owner API; this grants no collection browsing or datastore access."
          },
          {
            "access": "read",
            "entityId": "action-proposal",
            "purpose": "Point-read the exact permission-safe D2 handoff action-proposal record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "decision",
            "purpose": "Point-read the exact permission-safe D2 handoff decision record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "committed-action",
            "purpose": "Point-read the exact permission-safe D2 handoff committed-action record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "business-event",
            "purpose": "Point-read the exact permission-safe D2 handoff business-event record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "create",
            "entityId": "action-proposal",
            "purpose": "Submit the version-pinned D2 requested outcome, sender/receiver, source/target, evidence, authority, expiry and reopen context to shared-ledger-service without writing receiver-owned state."
          },
          {
            "access": "append",
            "entityId": "committed-action",
            "purpose": "Append each authorised D2 delivery or receiver-owned command attempt with idempotency, safe-retry and reconciliation state through shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "business-event",
            "purpose": "Append immutable D2 delivery, acknowledgement, rejection, reconciliation, replay or reopen facts through audit-event-service; an event never becomes current domain state."
          },
          {
            "access": "read",
            "entityId": "intake-request",
            "purpose": "Evaluate the reproducible, permission-filtered D2 active-request cohort for one retiring service offering and snapshot before retirement can commit."
          }
        ],
        "descriptionKey": "workblock.service-catalogue.description",
        "descriptorKey": "workblock.service-catalogue.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "intake-demand",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "intake-owner",
              "demand-owner",
              "process-owner"
            ],
            "id": "author-service-offering",
            "jobIds": [
              "procurement-service-catalogue.find-service",
              "procurement-service-catalogue.start-ready",
              "procurement-service-catalogue.publish-contract",
              "procurement-service-catalogue.service-friction",
              "procurement-service-catalogue.retire-service"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: offering candidate and offering diagnostics.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "process-owner",
                "intake-owner",
                "requester"
              ]
            },
            "kind": "operate",
            "label": "Author service offering",
            "trigger": "Service-owner proposal, policy change or identified catalogue gap."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "intake-owner",
              "demand-owner",
              "process-owner"
            ],
            "id": "publish-service-catalogue",
            "jobIds": [
              "procurement-service-catalogue.find-service",
              "procurement-service-catalogue.start-ready",
              "procurement-service-catalogue.publish-contract",
              "procurement-service-catalogue.service-friction",
              "procurement-service-catalogue.retire-service"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: published offering and catalogue release.",
                "The exact proposal version, authorised reviewer or policy authority, decision and reason are durable before any commitment.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "process-owner",
                "intake-owner",
                "requester"
              ]
            },
            "kind": "review",
            "label": "Publish service catalogue",
            "trigger": "Complete offering candidate with evaluation and release authority."
          },
          {
            "agentIds": [
              "service-catalogue-curator-agent",
              "service-discovery-agent"
            ],
            "escalationRoleIds": [
              "requester",
              "intake-owner",
              "demand-owner",
              "process-owner"
            ],
            "id": "discover-procurement-service",
            "jobIds": [
              "procurement-service-catalogue.find-service",
              "procurement-service-catalogue.start-ready",
              "procurement-service-catalogue.publish-contract",
              "procurement-service-catalogue.service-friction",
              "procurement-service-catalogue.retire-service"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: discovery response and unmet intent signal.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "process-owner",
                "intake-owner",
                "requester"
              ]
            },
            "kind": "agent",
            "label": "Discover procurement service",
            "trigger": "Requester search, intent statement or another Workblock tool call."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "intake-owner",
              "demand-owner",
              "process-owner"
            ],
            "id": "monitor-service-catalogue",
            "jobIds": [
              "procurement-service-catalogue.find-service",
              "procurement-service-catalogue.start-ready",
              "procurement-service-catalogue.publish-contract",
              "procurement-service-catalogue.service-friction",
              "procurement-service-catalogue.retire-service"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: service funnel, catalogue findings, and offering disposition.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "process-owner",
                "intake-owner",
                "requester"
              ]
            },
            "kind": "monitor",
            "label": "Monitor service catalogue",
            "trigger": "Search, intake, reroute, exception, dependency health or scheduled review."
          }
        ],
        "futureStateKey": "workblock.service-catalogue.future-state",
        "hiredInsteadKey": "workblock.service-catalogue.hired-instead",
        "id": "procurement-service-catalogue",
        "implementationStatus": "roadmap",
        "jobStatementKey": "workblock.service-catalogue.job",
        "jobStories": [
          {
            "completionKey": "workblock.service-catalogue.story.find-service.completion",
            "executionFlowIds": [
              "author-service-offering",
              "publish-service-catalogue",
              "discover-procurement-service",
              "monitor-service-catalogue"
            ],
            "id": "procurement-service-catalogue.find-service",
            "roleCardId": "requester",
            "storyKey": "workblock.service-catalogue.story.find-service.story"
          },
          {
            "completionKey": "workblock.service-catalogue.story.start-ready.completion",
            "executionFlowIds": [
              "author-service-offering",
              "publish-service-catalogue",
              "discover-procurement-service",
              "monitor-service-catalogue"
            ],
            "id": "procurement-service-catalogue.start-ready",
            "roleCardId": "requester",
            "storyKey": "workblock.service-catalogue.story.start-ready.story"
          },
          {
            "completionKey": "workblock.service-catalogue.story.publish-contract.completion",
            "executionFlowIds": [
              "author-service-offering",
              "publish-service-catalogue",
              "discover-procurement-service",
              "monitor-service-catalogue"
            ],
            "id": "procurement-service-catalogue.publish-contract",
            "roleCardId": "process-owner",
            "storyKey": "workblock.service-catalogue.story.publish-contract.story"
          },
          {
            "completionKey": "workblock.service-catalogue.story.service-friction.completion",
            "executionFlowIds": [
              "author-service-offering",
              "publish-service-catalogue",
              "discover-procurement-service",
              "monitor-service-catalogue"
            ],
            "id": "procurement-service-catalogue.service-friction",
            "roleCardId": "intake-owner",
            "storyKey": "workblock.service-catalogue.story.service-friction.story"
          },
          {
            "completionKey": "workblock.service-catalogue.story.retire-service.completion",
            "executionFlowIds": [
              "author-service-offering",
              "publish-service-catalogue",
              "discover-procurement-service",
              "monitor-service-catalogue"
            ],
            "id": "procurement-service-catalogue.retire-service",
            "roleCardId": "process-owner",
            "storyKey": "workblock.service-catalogue.story.retire-service.story"
          }
        ],
        "labelKey": "workblock.service-catalogue.label",
        "metrics": [
          "Eligible search-to-intake-start conversion",
          "No-result and unmet-intent rate",
          "Incorrect-service reroute rate",
          "Request completion and abandonment by offering version",
          "Offering policy and entrypoint freshness",
          "Restricted-audience leakage incidents",
          "Median catalogue-gap-to-published-release time"
        ],
        "operatingModel": "Design and version service offerings, bind them to policy and Workblock entrypoints, validate audience eligibility and input schemas, publish permission-scoped searchable projections, monitor route success and capacity, and retire or supersede offerings without breaking in-flight demand.",
        "outcomeKey": "workblock.service-catalogue.outcome",
        "prerequisites": [
          "A defined set of procurement services with eligibility rules and required evidence",
          "Named service owners for each offering",
          "Current policy rule releases to bind offerings against",
          "Audience and permission scopes for restricted offerings"
        ],
        "toolKey": "workblock.service-catalogue.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Create and update a draft",
              "Extract proposed fields with source spans",
              "Select bounded clarification questions",
              "Validate completeness",
              "Recommend eligible service offerings"
            ],
            "escalationTriggers": [
              "Requester intent remains materially ambiguous",
              "Potential prohibited, unsafe or high-consequence request",
              "Restricted attachment or inaccessible evidence",
              "No eligible service offering",
              "Identity or delegated-authority conflict"
            ],
            "id": "request-intake-agent",
            "label": "Request intake agent",
            "mission": "Help a requester create a complete, accurately understood need statement with the fewest useful clarifications.",
            "operatorRoleIds": [
              "intake-owner"
            ],
            "personaIds": [
              "requester-persona",
              "buyer"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "requester",
              "intake-owner",
              "process-owner"
            ]
          },
          {
            "autonomousActions": [
              "Remove unsupported derived fields",
              "Mark evidence missing",
              "Block incomplete submission",
              "Request targeted confirmation",
              "Flag a likely duplicate"
            ],
            "escalationTriggers": [
              "Conflicting requester confirmations",
              "Sensitive data without purpose",
              "Material requirement cannot be sourced",
              "Repeated quality regression by channel or slice"
            ],
            "id": "intake-quality-critic-agent",
            "label": "Intake quality critic agent",
            "mission": "Verify that a submitted request reflects requester-confirmed intent, satisfies the exact service schema and contains no unsupported inferred facts.",
            "operatorRoleIds": [
              "intake-owner"
            ],
            "personaIds": [
              "buyer",
              "platform-operator"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "requester",
              "intake-owner",
              "process-owner"
            ]
          }
        ],
        "agentStoryKey": "workblock.intake.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Identity or delegated-authority conflict",
            "Prohibited, unsafe, regulated or unusually consequential request",
            "Sensitive data without declared purpose",
            "No eligible service or irreducible intent ambiguity",
            "Any attempt to turn inferred content into a committed fact without confirmation"
          ],
          "authorityEnvelope": [
            "Authenticated requester, tenant and delegated identity scope",
            "Named service-offering schemas, channels and supported artifact types",
            "Allowed create-draft, extract, clarify, validate, save and submit-after-confirmation verbs",
            "Field confidence and source-span requirements",
            "Maximum clarification turns and mission duration",
            "No authority to select a non-permitted route or create commercial commitment",
            "Per-channel, service-offering and submission-route kill switches that preserve requester drafts"
          ],
          "humanSupervision": [
            "Requester confirms the business need and material facts",
            "Buyers inspect sampled submissions and resolve novel cases",
            "Service owners govern intake schemas",
            "Operators monitor access, extraction and channel quality",
            "People may correct, withdraw, pause or report unsafe behavior"
          ],
          "rollback": [
            "Stop new submissions while preserving drafts",
            "Restore the last-approved schema, extraction and clarification versions",
            "Mark affected submitted requests for targeted revalidation",
            "Replay drafts from immutable evidence references",
            "Notify downstream Workblocks of supersession without deleting the original request"
          ],
          "targetPosture": "mission_autonomous_with_supervision"
        },
        "coreValue": "Let a requester describe the business need once and leave with a complete, correctly understood and traceable procurement request instead of navigating forms, teams and policy language.",
        "currentStateKey": "workblock.intake.current-state",
        "dataMappings": [
          {
            "access": "create",
            "entityId": "intake-request",
            "purpose": "Create one canonical request with requester-confirmed facts and evidence references."
          },
          {
            "access": "update",
            "entityId": "intake-request",
            "purpose": "Maintain the draft and lifecycle while preserving correction and confirmation provenance."
          },
          {
            "access": "read",
            "entityId": "intake-request",
            "purpose": "Render requester review, resume drafts and support downstream quality evaluation."
          },
          {
            "access": "index",
            "entityId": "intake-request",
            "purpose": "Find requester drafts and submitted records under server-side scope."
          },
          {
            "access": "read",
            "entityId": "procurement-service-offering",
            "purpose": "Select the exact eligible service schema and explain intake requirements."
          },
          {
            "access": "read",
            "entityId": "person",
            "purpose": "Read the policy-filtered canonical person projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "business-unit",
            "purpose": "Read the policy-filtered canonical business unit projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "category",
            "purpose": "Read the policy-filtered canonical category projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "item-service",
            "purpose": "Read the policy-filtered canonical item or service projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "source-record-reference",
            "purpose": "Read the policy-filtered canonical source record reference projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "policy",
            "purpose": "Read the policy-filtered canonical policy projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "policy-version",
            "purpose": "Read the policy-filtered canonical policy version projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "authority-envelope",
            "purpose": "Read the policy-filtered canonical authority envelope projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "learning-example",
            "purpose": "Read the policy-filtered canonical learning example projection from learning-evaluation-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "evaluation-result",
            "purpose": "Read the policy-filtered canonical evaluation result projection from learning-evaluation-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "integration-state",
            "purpose": "Read the policy-filtered canonical integration state projection from integration-state-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "budget",
            "purpose": "Read the governed budget contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "intake-request",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "policy-change-impact",
            "purpose": "Read an authorised policy-change-impact record by stable identity through policy-rule-lifecycle's owner API; this grants no collection browsing or datastore access."
          },
          {
            "access": "read",
            "entityId": "action-proposal",
            "purpose": "Point-read the exact permission-safe D2/D4 handoff action-proposal record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "decision",
            "purpose": "Point-read the exact permission-safe D2/D4 handoff decision record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "committed-action",
            "purpose": "Point-read the exact permission-safe D2/D4 handoff committed-action record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "business-event",
            "purpose": "Point-read the exact permission-safe D2/D4 handoff business-event record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "create",
            "entityId": "action-proposal",
            "purpose": "Submit the version-pinned D2/D4 requested outcome, sender/receiver, source/target, evidence, authority, expiry and reopen context to shared-ledger-service without writing receiver-owned state."
          },
          {
            "access": "create",
            "entityId": "decision",
            "purpose": "Submit the authorised, version-pinned D2/D4 receiving-owner acceptance, rejection, redirect, expiry or reopen decision to shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "committed-action",
            "purpose": "Append each authorised D2/D4 delivery or receiver-owned command attempt with idempotency, safe-retry and reconciliation state through shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "business-event",
            "purpose": "Append immutable D2/D4 delivery, acknowledgement, rejection, reconciliation, replay or reopen facts through audit-event-service; an event never becomes current domain state."
          },
          {
            "access": "read",
            "entityId": "policy-rule-release",
            "purpose": "Read the exact D4 receiving-owner rule release/version returned after correction disposition."
          }
        ],
        "descriptionKey": "workblock.intake.description",
        "descriptorKey": "workblock.intake.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "intake-demand",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "intake-owner",
              "demand-owner",
              "process-owner"
            ],
            "id": "start-intake-request",
            "jobIds": [
              "intelligent-intake.explain-once",
              "intelligent-intake.assemble-case",
              "intelligent-intake.solution-first",
              "intelligent-intake.scoped-decision",
              "intelligent-intake.fix-the-rule"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The intake-draft, intake-evidence-set and candidate-intake-contract preserve the requester's original content, source artifacts, selected offering schema and idempotent draft identity.",
                "The draft remains distinct from a submitted intake request and records who may continue or withdraw it.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "requester",
                "intake-owner",
                "process-owner"
              ]
            },
            "kind": "operate",
            "label": "Start intake request",
            "trigger": "Authorised requester starts from a catalogue offering, channel message, API or uploaded artifact."
          },
          {
            "agentIds": [
              "request-intake-agent",
              "intake-quality-critic-agent"
            ],
            "escalationRoleIds": [
              "requester",
              "intake-owner",
              "demand-owner",
              "process-owner"
            ],
            "id": "understand-intake-request",
            "jobIds": [
              "intelligent-intake.explain-once",
              "intelligent-intake.assemble-case",
              "intelligent-intake.solution-first",
              "intelligent-intake.scoped-decision",
              "intelligent-intake.fix-the-rule"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The updated-intake-draft source-anchors every derived fact, the completeness-result names material gaps, and the clarification-plan ranks only decision-relevant questions.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "intake-owner",
                "requester",
                "process-owner"
              ]
            },
            "kind": "agent",
            "label": "Understand intake request",
            "trigger": "Draft source, requester response or offering change."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "intake-owner",
              "demand-owner",
              "process-owner"
            ],
            "id": "confirm-submit-intake",
            "jobIds": [
              "intelligent-intake.explain-once",
              "intelligent-intake.assemble-case",
              "intelligent-intake.solution-first",
              "intelligent-intake.scoped-decision",
              "intelligent-intake.fix-the-rule"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The submitted-intake-request, submission-disposition and intake-submitted-event bind the requester's confirmation or corrections, the critic result and the canonical request version.",
                "The exact proposal version, authorised reviewer or policy authority, decision and reason are durable before any commitment.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "requester",
                "intake-owner",
                "process-owner"
              ]
            },
            "kind": "review",
            "label": "Confirm and submit intake",
            "trigger": "Completeness threshold met and requester requests submission."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "intake-owner",
              "demand-owner",
              "process-owner"
            ],
            "id": "monitor-intake-quality",
            "jobIds": [
              "intelligent-intake.explain-once",
              "intelligent-intake.assemble-case",
              "intelligent-intake.solution-first",
              "intelligent-intake.scoped-decision",
              "intelligent-intake.fix-the-rule"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The intake-quality-metrics report completeness, correction, reroute and abandonment by channel and material slice; the intake-posture-recommendation identifies a bounded change or preserves the current release.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "process-owner",
                "intake-owner",
                "requester"
              ]
            },
            "kind": "monitor",
            "label": "Monitor intake quality",
            "trigger": "Submission, withdrawal, reroute, downstream correction or scheduled sample."
          }
        ],
        "futureStateKey": "workblock.intake.future-state",
        "hiredInsteadKey": "workblock.intake.hired-instead",
        "id": "intelligent-intake",
        "implementationStatus": "reference",
        "jobStatementKey": "workblock.intake.job",
        "jobStories": [
          {
            "completionKey": "workblock.intake.story.explain-once.completion",
            "executionFlowIds": [
              "start-intake-request",
              "understand-intake-request",
              "confirm-submit-intake",
              "monitor-intake-quality"
            ],
            "id": "intelligent-intake.explain-once",
            "roleCardId": "requester",
            "storyKey": "workblock.intake.story.explain-once.story"
          },
          {
            "completionKey": "workblock.intake.story.assemble-case.completion",
            "executionFlowIds": [
              "start-intake-request",
              "understand-intake-request",
              "confirm-submit-intake",
              "monitor-intake-quality"
            ],
            "id": "intelligent-intake.assemble-case",
            "roleCardId": "intake-owner",
            "storyKey": "workblock.intake.story.assemble-case.story"
          },
          {
            "completionKey": "workblock.intake.story.solution-first.completion",
            "executionFlowIds": [
              "start-intake-request",
              "understand-intake-request",
              "confirm-submit-intake",
              "monitor-intake-quality"
            ],
            "id": "intelligent-intake.solution-first",
            "roleCardId": "intake-owner",
            "storyKey": "workblock.intake.story.solution-first.story"
          },
          {
            "completionKey": "workblock.intake.story.scoped-decision.completion",
            "executionFlowIds": [
              "start-intake-request",
              "understand-intake-request",
              "confirm-submit-intake",
              "monitor-intake-quality"
            ],
            "id": "intelligent-intake.scoped-decision",
            "roleCardId": "process-owner",
            "storyKey": "workblock.intake.story.scoped-decision.story"
          },
          {
            "completionKey": "workblock.intake.story.fix-the-rule.completion",
            "executionFlowIds": [
              "start-intake-request",
              "understand-intake-request",
              "confirm-submit-intake",
              "monitor-intake-quality"
            ],
            "id": "intelligent-intake.fix-the-rule",
            "roleCardId": "process-owner",
            "storyKey": "workblock.intake.story.fix-the-rule.story"
          }
        ],
        "labelKey": "workblock.intake.label",
        "metrics": [
          "Complete-on-first-submission rate",
          "Median requester active time and clarification turns",
          "Field correction rate by channel and offering",
          "Unsupported-inference and sensitive-data defect rate",
          "Submission abandonment and resume rate",
          "Downstream reroute or requirement-rework rate",
          "Requester-reported effort and outcome understanding"
        ],
        "operatingModel": "Capture intent through conversational, form, file and API channels; resolve the requester and service context; extract typed requirements with source spans; ask the smallest decision-relevant clarifications; validate completeness; preserve the last-good draft and request projection with explicit field and source freshness; obtain requester confirmation; publish one canonical intake request; reconcile downstream receipt; and make every permitted aggregate drill into its underlying request records.",
        "outcomeKey": "workblock.intake.outcome",
        "prerequisites": [
          "A published procurement service catalogue for requests to land against",
          "Access to the organisation's person and business-unit directory",
          "The category and item or service structures used to type requirements",
          "Current policy versions governing intake validation",
          "Named buyers to inspect sampled submissions and resolve novel cases"
        ],
        "toolKey": "workblock.intake.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Normalize derived facts",
              "Attach permission-safe context candidates",
              "Detect likely duplicates and consolidation candidates",
              "Request missing evidence",
              "Create an expiring enrichment proposal"
            ],
            "escalationTriggers": [
              "Conflicting category or value evidence",
              "Potential duplicate across restricted scope",
              "Supplier identity or eligibility ambiguity",
              "Material requirement inconsistency"
            ],
            "id": "request-enrichment-agent",
            "label": "Request enrichment agent",
            "mission": "Assemble a procurement-ready, evidence-linked request context without changing confirmed requester facts.",
            "operatorRoleIds": [
              "demand-owner"
            ],
            "personaIds": [
              "buyer",
              "category-management-persona",
              "requester-persona"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "intake-owner",
              "demand-owner",
              "process-owner"
            ]
          },
          {
            "autonomousActions": [
              "Rank permitted routes",
              "Expire stale proposals",
              "Commit low-consequence routes inside the envelope",
              "Open true exceptions",
              "Notify orchestration of a committed route"
            ],
            "escalationTriggers": [
              "No permitted route",
              "High consequence or novel route",
              "Policy and service-contract conflict",
              "Risk or fairness concern",
              "Evidence or source freshness below threshold"
            ],
            "id": "request-routing-agent",
            "label": "Request routing agent",
            "mission": "Select and explain the best policy-permitted route, committing only when the active envelope authorises that route class.",
            "operatorRoleIds": [
              "demand-owner"
            ],
            "personaIds": [
              "buyer",
              "supplier-risk-manager",
              "platform-operator"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "intake-owner",
              "demand-owner",
              "process-owner"
            ]
          }
        ],
        "agentStoryKey": "workblock.request-routing.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "No policy-permitted route",
            "Novel, high-value, high-risk or irreversible route",
            "Supplier fairness or conflict concern",
            "Restricted cross-request context affects the decision",
            "Policy, catalogue or evidence conflict"
          ],
          "authorityEnvelope": [
            "Named service offerings, categories, legal entities and route classes",
            "Allowed normalize, retrieve, classify, propose, expire, open-exception and commit-listed-route verbs",
            "Minimum identity, category, context and route confidence",
            "Required policy result and evidence freshness",
            "Value, risk, complexity and reversibility thresholds",
            "Forbidden supplier communication and downstream commercial commitment",
            "Per-service, category and destination-route kill switches for new route commitments"
          ],
          "humanSupervision": [
            "Govern route policy and consequence classes",
            "Inspect sampled straight-through routes and all material exceptions",
            "Correct category, context and route outcomes",
            "Review fairness, consolidation and access effects",
            "Pause or narrow route classes"
          ],
          "rollback": [
            "Stop new route commitments",
            "Restore last-approved classifiers, retrieval and routing policy",
            "Expire affected enrichments and mark downstream route state uncertain",
            "Replay cases from canonical intake and policy evidence",
            "Reconcile or cancel only unconsumed orchestration starts"
          ],
          "targetPosture": "policy_autonomous_with_monitoring"
        },
        "coreValue": "Turn a complete business need into a context-rich, policy-valid and explainable route proposal without asking the requester to rediscover supplier, contract, catalogue, category or prior-demand context.",
        "currentStateKey": "workblock.request-routing.current-state",
        "dataMappings": [
          {
            "access": "create",
            "entityId": "enriched-request",
            "purpose": "Create a versioned, expiring enrichment and route proposal without overwriting intake facts."
          },
          {
            "access": "update",
            "entityId": "enriched-request",
            "purpose": "Refresh context and move through validated, routed, escalated or expired states."
          },
          {
            "access": "read",
            "entityId": "enriched-request",
            "purpose": "Serve route review, orchestration, monitoring and drill-through."
          },
          {
            "access": "index",
            "entityId": "enriched-request",
            "purpose": "Resolve the current validated enrichment and route by request and state."
          },
          {
            "access": "read",
            "entityId": "intake-request",
            "purpose": "Read requester-confirmed facts and evidence as immutable routing inputs."
          },
          {
            "access": "read",
            "entityId": "policy-guidance-result",
            "purpose": "Bind routing to the exact effective policy result and validity window."
          },
          {
            "access": "read",
            "entityId": "enriched-request",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          }
        ],
        "descriptionKey": "workblock.request-routing.description",
        "descriptorKey": "workblock.request-routing.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "intake-demand",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "intake-owner",
              "demand-owner",
              "process-owner"
            ],
            "id": "enrich-procurement-request",
            "jobIds": [
              "request-enrichment-routing.normalise-request",
              "request-enrichment-routing.reuse-enterprise-context",
              "request-enrichment-routing.explain-route",
              "request-enrichment-routing.related-demand",
              "request-enrichment-routing.true-exception"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: enrichment candidate, context candidates, and enrichment diagnostics.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "intake-owner",
                "demand-owner",
                "process-owner"
              ]
            },
            "kind": "analyse",
            "label": "Enrich procurement request",
            "trigger": "Committed intake submission or material request change."
          },
          {
            "agentIds": [
              "request-enrichment-agent",
              "request-routing-agent"
            ],
            "escalationRoleIds": [
              "requester",
              "intake-owner",
              "demand-owner",
              "process-owner"
            ],
            "id": "evaluate-request-route",
            "jobIds": [
              "request-enrichment-routing.normalise-request",
              "request-enrichment-routing.reuse-enterprise-context",
              "request-enrichment-routing.explain-route",
              "request-enrichment-routing.related-demand",
              "request-enrichment-routing.true-exception"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: proposed enriched request, route proposal, and routing diagnostics.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "intake-owner",
                "demand-owner",
                "process-owner"
              ]
            },
            "kind": "agent",
            "label": "Evaluate request route",
            "trigger": "Evidence-complete enrichment candidate."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "intake-owner",
              "demand-owner",
              "process-owner"
            ],
            "id": "commit-request-route",
            "jobIds": [
              "request-enrichment-routing.normalise-request",
              "request-enrichment-routing.reuse-enterprise-context",
              "request-enrichment-routing.explain-route",
              "request-enrichment-routing.related-demand",
              "request-enrichment-routing.true-exception"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: routed enrichment, routing disposition, and routed request event.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "intake-owner",
                "demand-owner",
                "process-owner"
              ]
            },
            "kind": "operate",
            "label": "Commit request route",
            "trigger": "Route proposal, current evidence and active authority envelope."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "intake-owner",
              "demand-owner",
              "process-owner"
            ],
            "id": "monitor-routing-quality",
            "jobIds": [
              "request-enrichment-routing.normalise-request",
              "request-enrichment-routing.reuse-enterprise-context",
              "request-enrichment-routing.explain-route",
              "request-enrichment-routing.related-demand",
              "request-enrichment-routing.true-exception"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: routing evaluation and routing posture recommendation.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "intake-owner",
                "demand-owner",
                "process-owner"
              ]
            },
            "kind": "monitor",
            "label": "Monitor routing quality",
            "trigger": "Reroute, exception, downstream completion, buyer correction or source change."
          }
        ],
        "futureStateKey": "workblock.request-routing.future-state",
        "hiredInsteadKey": "workblock.request-routing.hired-instead",
        "id": "request-enrichment-routing",
        "implementationStatus": "roadmap",
        "jobStatementKey": "workblock.request-routing.job",
        "jobStories": [
          {
            "completionKey": "workblock.request-routing.story.normalise-request.completion",
            "executionFlowIds": [
              "enrich-procurement-request",
              "evaluate-request-route",
              "commit-request-route",
              "monitor-routing-quality"
            ],
            "id": "request-enrichment-routing.normalise-request",
            "roleCardId": "intake-owner",
            "storyKey": "workblock.request-routing.story.normalise-request.story"
          },
          {
            "completionKey": "workblock.request-routing.story.reuse-enterprise-context.completion",
            "executionFlowIds": [
              "enrich-procurement-request",
              "evaluate-request-route",
              "commit-request-route",
              "monitor-routing-quality"
            ],
            "id": "request-enrichment-routing.reuse-enterprise-context",
            "roleCardId": "intake-owner",
            "storyKey": "workblock.request-routing.story.reuse-enterprise-context.story"
          },
          {
            "completionKey": "workblock.request-routing.story.explain-route.completion",
            "executionFlowIds": [
              "enrich-procurement-request",
              "evaluate-request-route",
              "commit-request-route",
              "monitor-routing-quality"
            ],
            "id": "request-enrichment-routing.explain-route",
            "roleCardId": "requester",
            "storyKey": "workblock.request-routing.story.explain-route.story"
          },
          {
            "completionKey": "workblock.request-routing.story.related-demand.completion",
            "executionFlowIds": [
              "enrich-procurement-request",
              "evaluate-request-route",
              "commit-request-route",
              "monitor-routing-quality"
            ],
            "id": "request-enrichment-routing.related-demand",
            "roleCardId": "demand-owner",
            "storyKey": "workblock.request-routing.story.related-demand.story"
          },
          {
            "completionKey": "workblock.request-routing.story.true-exception.completion",
            "executionFlowIds": [
              "enrich-procurement-request",
              "evaluate-request-route",
              "commit-request-route",
              "monitor-routing-quality"
            ],
            "id": "request-enrichment-routing.true-exception",
            "roleCardId": "intake-owner",
            "storyKey": "workblock.request-routing.story.true-exception.story"
          }
        ],
        "labelKey": "workblock.request-routing.label",
        "metrics": [
          "Straight-through policy-valid routing rate",
          "Buyer correction and reroute rate by route class",
          "Median submission-to-committed-route time",
          "Duplicate or consolidation candidate detection precision and recall",
          "Context-match source and permission completeness",
          "Fairness and access-control defect rate",
          "Downstream first-time-right completion by route"
        ],
        "operatingModel": "Read the committed intake, normalize requirements, classify category and value, retrieve permission-safe related records, detect duplicates and aggregation candidates, obtain an exact policy guidance result, evaluate eligible routes, critic-check evidence and confidence, then commit a route only inside an active authority envelope or open a true exception.",
        "outcomeKey": "workblock.request-routing.outcome",
        "prerequisites": [
          "Canonical intake requests from the intake front door",
          "Read access to contract, catalogue and supplier records for context retrieval",
          "Exact policy guidance results for route checks",
          "Route authority envelopes and consequence classes configured",
          "Named owners for material routing exceptions"
        ],
        "toolKey": "workblock.request-routing.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Instantiate an approved plan",
              "Start reversible and pre-authorised child steps",
              "Request required evidence",
              "Retry idempotent operations",
              "Pause on guard breach",
              "Close reconciled routine cases"
            ],
            "escalationTriggers": [
              "New authority or route required",
              "Irreversible or material external commitment",
              "Conflicting child outcomes",
              "Repeated partial failure",
              "Requester or owner disputes the plan"
            ],
            "id": "demand-orchestrator-agent",
            "label": "Demand orchestrator agent",
            "mission": "Pursue the committed demand outcome by selecting permitted next steps, coordinating typed Workblocks and stopping on guard or evidence failure.",
            "operatorRoleIds": [
              "demand-owner"
            ],
            "personaIds": [
              "buyer",
              "requester-persona",
              "category-management-persona"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "demand-owner",
              "intake-owner",
              "requester",
              "process-owner"
            ]
          },
          {
            "autonomousActions": [
              "Block an unsafe next step",
              "Mark external state uncertain",
              "Open a reconciliation task",
              "Demote a plan class",
              "Trigger bounded recovery"
            ],
            "escalationTriggers": [
              "Lost or duplicate commitment evidence",
              "Material plan-policy conflict",
              "Unsafe compensation",
              "Systemic Workblock or integration degradation"
            ],
            "id": "journey-critic-agent",
            "label": "Journey critic agent",
            "mission": "Independently verify plan conformance, evidence, authority, idempotency, freshness and reconciliation throughout the demand journey.",
            "operatorRoleIds": [
              "demand-owner"
            ],
            "personaIds": [
              "platform-operator",
              "procurement-leadership"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "demand-owner",
              "intake-owner",
              "requester",
              "process-owner"
            ]
          }
        ],
        "agentStoryKey": "workblock.demand.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "New route, authority or policy exception",
            "High-consequence or irreversible commitment outside an active grant",
            "Conflicting legal, finance, risk or requester decision",
            "Uncertain external commitment that cannot reconcile",
            "Compensation that could create greater harm"
          ],
          "authorityEnvelope": [
            "Named route and plan versions, Workblocks, tools and legal entities",
            "Allowed read, plan, start reversible child, request evidence, retry, reconcile, pause and close verbs",
            "Per-step commitment authority and evidence guards",
            "Maximum case value, mission duration, retries and concurrent children",
            "Required critic, sample and freshness controls",
            "Forbidden policy override and material commitment outside a step grant",
            "Per-route, child-Workblock and mutating-tool kill switches that preserve truthful case status"
          ],
          "humanSupervision": [
            "Govern route plans, authority classes and recovery policy",
            "Handle novel or consequential exceptions",
            "Inspect sampled journeys and systemic failure slices",
            "Resolve requester disputes and cross-functional conflicts",
            "Pause, stop or narrow mission scope"
          ],
          "rollback": [
            "Pause new ready-step execution",
            "Restore the last-approved plan, policy and agent versions",
            "Cancel only uncommitted child starts",
            "Run named compensations for committed partial effects where safe",
            "Reconcile every external target and preserve exact case history"
          ],
          "targetPosture": "mission_autonomous_with_supervision"
        },
        "coreValue": "Move each qualified demand through the shortest policy-valid path while giving the requester one truthful status, the next permitted action and an evidence trail across every participating Workblock.",
        "currentStateKey": "workblock.demand.current-state",
        "dataMappings": [
          {
            "access": "create",
            "entityId": "demand-case",
            "purpose": "Create a durable, typed journey record from a committed route."
          },
          {
            "access": "update",
            "entityId": "demand-case",
            "purpose": "Persist reconciled step, commitment, exception and lifecycle state by stable case key."
          },
          {
            "access": "read",
            "entityId": "demand-case",
            "purpose": "Plan, execute, supervise, report and recover the journey."
          },
          {
            "access": "index",
            "entityId": "demand-case",
            "purpose": "Serve requester status, owner queues, portfolio membership and timer scans."
          },
          {
            "access": "read",
            "entityId": "intake-request",
            "purpose": "Bind the journey to immutable requester-confirmed demand."
          },
          {
            "access": "read",
            "entityId": "enriched-request",
            "purpose": "Bind plan selection to the exact validated and committed route evidence."
          },
          {
            "access": "read",
            "entityId": "person",
            "purpose": "Read the policy-filtered canonical person projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "authority-envelope",
            "purpose": "Read the policy-filtered canonical authority envelope projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "action-proposal",
            "purpose": "Read the policy-filtered canonical action proposal projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "committed-action",
            "purpose": "Read the policy-filtered canonical committed action projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "decision",
            "purpose": "Read the policy-filtered canonical decision projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "exception",
            "purpose": "Read the policy-filtered canonical exception case projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "audit-event",
            "purpose": "Read the policy-filtered canonical audit event projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "business-event",
            "purpose": "Read the policy-filtered canonical business event projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "integration-state",
            "purpose": "Read the policy-filtered canonical integration state projection from integration-state-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "registry-release",
            "purpose": "Read the policy-filtered canonical registry release projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "demand-case",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          }
        ],
        "descriptionKey": "workblock.demand.description",
        "descriptorKey": "workblock.demand.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "intake-demand",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "intake-owner",
              "demand-owner",
              "process-owner"
            ],
            "id": "plan-demand-journey",
            "jobIds": [
              "demand-orchestration.one-plan",
              "demand-orchestration.truthful-status",
              "demand-orchestration.scoped-handback",
              "demand-orchestration.partial-failure",
              "demand-orchestration.scope-change",
              "demand-orchestration.stalled-demand"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: executable journey plan and journey plan diagnostics.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "demand-owner",
                "intake-owner",
                "requester",
                "process-owner"
              ]
            },
            "kind": "analyse",
            "label": "Plan demand journey",
            "trigger": "Validated routed enrichment event."
          },
          {
            "agentIds": [
              "demand-orchestrator-agent",
              "journey-critic-agent"
            ],
            "escalationRoleIds": [
              "requester",
              "intake-owner",
              "demand-owner",
              "process-owner"
            ],
            "id": "execute-demand-journey",
            "jobIds": [
              "demand-orchestration.one-plan",
              "demand-orchestration.truthful-status",
              "demand-orchestration.scoped-handback",
              "demand-orchestration.partial-failure",
              "demand-orchestration.scope-change",
              "demand-orchestration.stalled-demand"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: demand case change set and execution result set.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "demand-owner",
                "intake-owner",
                "requester",
                "process-owner"
              ]
            },
            "kind": "agent",
            "label": "Execute demand journey",
            "trigger": "New case, child result, evidence submission, timer or integration event."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "intake-owner",
              "demand-owner",
              "process-owner"
            ],
            "id": "operate-demand-exception",
            "jobIds": [
              "demand-orchestration.one-plan",
              "demand-orchestration.truthful-status",
              "demand-orchestration.scoped-handback",
              "demand-orchestration.partial-failure",
              "demand-orchestration.scope-change",
              "demand-orchestration.stalled-demand"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: exception resolution and case disposition.",
                "The exact proposal version, authorised reviewer or policy authority, decision and reason are durable before any commitment.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "demand-owner",
                "intake-owner",
                "requester",
                "process-owner"
              ]
            },
            "kind": "review",
            "label": "Operate demand exception",
            "trigger": "Plan, evidence, authority, timer or reconciliation exception."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "intake-owner",
              "demand-owner",
              "process-owner"
            ],
            "id": "read-demand-status",
            "jobIds": [
              "demand-orchestration.one-plan",
              "demand-orchestration.truthful-status",
              "demand-orchestration.scoped-handback",
              "demand-orchestration.partial-failure",
              "demand-orchestration.scope-change",
              "demand-orchestration.stalled-demand"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: demand status response.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "demand-owner",
                "intake-owner",
                "requester",
                "process-owner"
              ]
            },
            "kind": "read",
            "label": "Read demand status",
            "trigger": "Requester, owner, role agent or portfolio asks for scoped status."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "intake-owner",
              "demand-owner",
              "process-owner"
            ],
            "id": "monitor-demand-journeys",
            "jobIds": [
              "demand-orchestration.one-plan",
              "demand-orchestration.truthful-status",
              "demand-orchestration.scoped-handback",
              "demand-orchestration.partial-failure",
              "demand-orchestration.scope-change",
              "demand-orchestration.stalled-demand"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: journey metrics, journey findings, and orchestration posture recommendation.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "demand-owner",
                "intake-owner",
                "requester",
                "process-owner"
              ]
            },
            "kind": "monitor",
            "label": "Monitor demand journeys",
            "trigger": "Case transition, exception, completion or scheduled SLO scan."
          }
        ],
        "futureStateKey": "workblock.demand.future-state",
        "hiredInsteadKey": "workblock.demand.hired-instead",
        "id": "demand-orchestration",
        "implementationStatus": "pattern",
        "jobStatementKey": "workblock.demand.job",
        "jobStories": [
          {
            "completionKey": "workblock.demand.story.one-plan.completion",
            "executionFlowIds": [
              "plan-demand-journey",
              "execute-demand-journey",
              "operate-demand-exception",
              "read-demand-status",
              "monitor-demand-journeys"
            ],
            "id": "demand-orchestration.one-plan",
            "roleCardId": "demand-owner",
            "storyKey": "workblock.demand.story.one-plan.story"
          },
          {
            "completionKey": "workblock.demand.story.truthful-status.completion",
            "executionFlowIds": [
              "plan-demand-journey",
              "execute-demand-journey",
              "operate-demand-exception",
              "read-demand-status",
              "monitor-demand-journeys"
            ],
            "id": "demand-orchestration.truthful-status",
            "roleCardId": "requester",
            "storyKey": "workblock.demand.story.truthful-status.story"
          },
          {
            "completionKey": "workblock.demand.story.scoped-handback.completion",
            "executionFlowIds": [
              "plan-demand-journey",
              "execute-demand-journey",
              "operate-demand-exception",
              "read-demand-status",
              "monitor-demand-journeys"
            ],
            "id": "demand-orchestration.scoped-handback",
            "roleCardId": "demand-owner",
            "storyKey": "workblock.demand.story.scoped-handback.story"
          },
          {
            "completionKey": "workblock.demand.story.partial-failure.completion",
            "executionFlowIds": [
              "plan-demand-journey",
              "execute-demand-journey",
              "operate-demand-exception",
              "read-demand-status",
              "monitor-demand-journeys"
            ],
            "id": "demand-orchestration.partial-failure",
            "roleCardId": "demand-owner",
            "storyKey": "workblock.demand.story.partial-failure.story"
          },
          {
            "completionKey": "workblock.demand.story.scope-change.completion",
            "executionFlowIds": [
              "plan-demand-journey",
              "execute-demand-journey",
              "operate-demand-exception",
              "read-demand-status",
              "monitor-demand-journeys"
            ],
            "id": "demand-orchestration.scope-change",
            "roleCardId": "demand-owner",
            "storyKey": "workblock.demand.story.scope-change.story"
          },
          {
            "completionKey": "workblock.demand.story.stalled-demand.completion",
            "executionFlowIds": [
              "plan-demand-journey",
              "execute-demand-journey",
              "operate-demand-exception",
              "read-demand-status",
              "monitor-demand-journeys"
            ],
            "id": "demand-orchestration.stalled-demand",
            "roleCardId": "process-owner",
            "storyKey": "workblock.demand.story.stalled-demand.story"
          }
        ],
        "labelKey": "workblock.demand.label",
        "metrics": [
          "End-to-end demand cycle time and active-versus-wait split",
          "Straight-through completion by route and plan version",
          "Exception, rework and reroute rate",
          "Child Workblock handoff and reconciliation success",
          "Duplicate or uncertain commitment incidents",
          "Requester status freshness and next-action accuracy",
          "Policy-bounded step conformance and sampled defect rate"
        ],
        "operatingModel": "Turn a committed route into a typed durable plan, start and reconcile child Workblocks, wait safely for user or external events, enforce authority before side effects, manage timeouts and true exceptions, preserve last-good case state, and close only when downstream outcomes reconcile.",
        "outcomeKey": "workblock.demand.outcome",
        "prerequisites": [
          "Committed, enriched requests with an approved route",
          "Named owners for each participating specialist function",
          "Authority envelopes enforced before any side effect commits",
          "Escalation owners for novel or consequential exceptions"
        ],
        "toolKey": "workblock.demand.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Refresh membership proposals",
              "Split or merge non-committed portfolios",
              "Expire stale forecasts and scenarios",
              "Rank scenarios",
              "Prepare destination handoff proposals"
            ],
            "escalationTriggers": [
              "Change to committed delivery timing or requirement",
              "Cross-unit ownership conflict",
              "Material service or risk trade-off",
              "Restricted detail required for a grouping decision",
              "No feasible scenario"
            ],
            "id": "demand-portfolio-agent",
            "label": "Demand portfolio agent",
            "mission": "Maintain explainable compatible-demand portfolios and scenarios while protecting urgency, ownership and access constraints.",
            "operatorRoleIds": [
              "demand-owner"
            ],
            "personaIds": [
              "category-management-persona",
              "buyer",
              "procurement-leadership"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "demand-owner",
              "intake-owner",
              "process-owner"
            ]
          },
          {
            "autonomousActions": [
              "Exclude incompatible members",
              "Reduce forecast weight",
              "Block an unsafe scenario",
              "Mark a portfolio stale",
              "Recommend demotion"
            ],
            "escalationTriggers": [
              "Material value disagreement",
              "Potential requester harm or service failure",
              "Access-scope leakage",
              "Forecast confidence below policy",
              "Systemic missed-demand evidence"
            ],
            "id": "demand-portfolio-critic-agent",
            "label": "Demand portfolio critic agent",
            "mission": "Challenge compatibility, access, forecast confidence, value baselines and requester impact before portfolio activation.",
            "operatorRoleIds": [
              "demand-owner"
            ],
            "personaIds": [
              "finance",
              "requester-persona",
              "platform-operator"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "demand-owner",
              "intake-owner",
              "process-owner"
            ]
          },
          {
            "autonomousActions": [
              "Refresh material demand scope on forecast or reference change",
              "Normalise units, grades and calendars across demand sources",
              "Link dependent component demand to governed forecast versions",
              "Propose forecast component updates with source evidence",
              "Flag stale or conflicting material references"
            ],
            "escalationTriggers": [
              "Change to a committed quantity or needed-by date",
              "Unit or grade conversion without a governed reference",
              "Committed demand and forecast disagree beyond tolerance",
              "Material reference conflict across source systems",
              "Forecast confidence below policy"
            ],
            "id": "raw-material-demand-agent",
            "label": "Raw material demand agent",
            "mission": "Keep direct-material demand signals normalised, unit-consistent and forecast-linked so portfolios reflect true raw-material volume before commitments fragment it.",
            "operatorRoleIds": [
              "demand-owner"
            ],
            "personaIds": [
              "category-management-persona",
              "buyer",
              "finance"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "demand-owner",
              "intake-owner"
            ]
          },
          {
            "autonomousActions": [
              "Refresh coverage positions on portfolio, entitlement or forecast change",
              "Align units of measure and planning calendars before gap calculation",
              "Compute time-bucketed coverage gap assessments",
              "Flag under- and over-coverage beyond configured tolerance bands",
              "Prepare coverage action proposals for the owning sourcing modules"
            ],
            "escalationTriggers": [
              "Coverage gap that would require a new commercial commitment",
              "Conflicting entitlement and forecast evidence for the same time bucket",
              "Forecast or entitlement source beyond its freshness threshold",
              "Requested change to a configured tolerance band",
              "No feasible coverage action within the authority envelope"
            ],
            "id": "coverage-position-agent",
            "label": "Coverage position agent",
            "mission": "Continuously reconcile forecast demand against contracted entitlements and flag under- and over-coverage with time-bucketed evidence before it becomes a supply or price exposure.",
            "operatorRoleIds": [
              "demand-owner"
            ],
            "personaIds": [
              "category-management-persona",
              "buyer",
              "finance"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "demand-owner",
              "process-owner"
            ]
          },
          {
            "autonomousActions": [
              "Detect equivalent specification variants across demand cases and items",
              "Map legacy and cross-standard grade designations to a canonical reference",
              "Cluster variants by grade, tolerance class and certificate requirements",
              "Quantify the pooling value of a harmonised specification",
              "Route consent requests to the owning requesters"
            ],
            "escalationTriggers": [
              "Change to a confirmed requirement, quantity or committed date",
              "Requester declines or disputes a proposed equivalence",
              "Conflicting acceptance limits within a proposed cluster",
              "Safety, certification or regulatory constraint on substitution",
              "No governing standard covers the compared variants"
            ],
            "id": "specification-harmonisation-agent",
            "label": "Specification harmonisation agent",
            "mission": "Find functionally equivalent specification variants, quantify the pooling value of harmonising them, and route consent-gated harmonisation proposals to the owning requesters.",
            "operatorRoleIds": [
              "demand-owner"
            ],
            "personaIds": [
              "category-management-persona",
              "requester-persona",
              "buyer"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "demand-owner",
              "intake-owner"
            ]
          }
        ],
        "agentStoryKey": "workblock.demand-portfolio.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Change to a committed requirement, quantity or needed-by date",
            "Material business-owner, service, risk or budget conflict",
            "Restricted cross-unit evidence required to decide",
            "External supplier or commercial commitment",
            "Irreversible cancellation or withdrawal"
          ],
          "authorityEnvelope": [
            "Named categories, units, geographies, horizons and demand states",
            "Allowed read, normalize, group, rank, refresh, split, merge, expire and propose-handoff verbs",
            "Compatibility hard constraints and forecast-confidence floors",
            "Maximum value, timing shift and member count for autonomous proposals",
            "No authority to change confirmed requirements or committed dates",
            "Mission cadence, sample rate and stop conditions",
            "Per-category, business-unit and handoff-destination kill switches for new portfolio mutations"
          ],
          "humanSupervision": [
            "Set consolidation objectives and compatibility policy",
            "Approve material changes to timing, scope or ownership",
            "Inspect sampled groups, exclusions and requester impacts",
            "Resolve cross-unit priorities and finance baselines",
            "Pause or narrow categories and horizons"
          ],
          "rollback": [
            "Stop new handoff proposals",
            "Restore last-approved grouping, scoring and scenario versions",
            "Reinstate prior portfolio membership version",
            "Withdraw only unaccepted destination proposals",
            "Reconcile accepted downstream cases and notify owners of supersession"
          ],
          "targetPosture": "mission_autonomous_with_supervision"
        },
        "coreValue": "Reveal and act on compatible demand across requests, forecasts, units and time before it fragments into avoidable transactions, while preserving ownership, urgency, policy and access boundaries.",
        "currentStateKey": "workblock.demand-portfolio.current-state",
        "dataMappings": [
          {
            "access": "create",
            "entityId": "demand-portfolio",
            "purpose": "Create versioned compatible-demand portfolios and scenarios linked to their supporting records."
          },
          {
            "access": "update",
            "entityId": "demand-portfolio",
            "purpose": "Refresh membership and lifecycle through explicit versions, splits and merges."
          },
          {
            "access": "read",
            "entityId": "demand-portfolio",
            "purpose": "Serve scenarios, supervision, handoffs, drill-through and outcome learning."
          },
          {
            "access": "index",
            "entityId": "demand-portfolio",
            "purpose": "Find current portfolios by category, strategy, owner, state and horizon."
          },
          {
            "access": "read",
            "entityId": "demand-case",
            "purpose": "Build current committed-demand membership and operational constraints."
          },
          {
            "access": "update",
            "entityId": "demand-case",
            "purpose": "Submit a typed owner command to demand-orchestration to record accepted portfolio membership without altering route, requirement or commitment state."
          },
          {
            "access": "update",
            "entityId": "budget",
            "purpose": "Own the governed budget contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "item-service",
            "purpose": "Read the policy-filtered canonical item or service projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "contract-entitlement",
            "purpose": "Compare available entitlement volumes and rights against forecast demand per time bucket."
          },
          {
            "access": "read",
            "entityId": "budget",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "demand-portfolio",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "budget",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          }
        ],
        "descriptionKey": "workblock.demand-portfolio.description",
        "descriptorKey": "workblock.demand-portfolio.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "intake-demand",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "intake-owner",
              "demand-owner",
              "process-owner"
            ],
            "id": "refresh-demand-signals",
            "jobIds": [
              "demand-consolidation-portfolio.compatible-demand",
              "demand-consolidation-portfolio.grouping-rationale",
              "demand-consolidation-portfolio.portfolio-scenarios",
              "demand-consolidation-portfolio.business-consent",
              "demand-consolidation-portfolio.execution-launch"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: normalised demand signals and demand source health.",
                "Accepted and rejected inputs are counted, source-linked and assigned a freshness state; a failed refresh retains last-good data.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "demand-owner",
                "intake-owner",
                "process-owner"
              ]
            },
            "kind": "refresh",
            "label": "Refresh demand signals",
            "trigger": "Intake, demand-case, forecast, strategy or source-health change."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "intake-owner",
              "demand-owner",
              "process-owner"
            ],
            "id": "generate-demand-portfolios",
            "jobIds": [
              "demand-consolidation-portfolio.compatible-demand",
              "demand-consolidation-portfolio.grouping-rationale",
              "demand-consolidation-portfolio.portfolio-scenarios",
              "demand-consolidation-portfolio.business-consent",
              "demand-consolidation-portfolio.execution-launch"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: challenged portfolios and portfolio analysis diagnostics.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "demand-owner",
                "intake-owner",
                "process-owner"
              ]
            },
            "kind": "analyse",
            "label": "Generate demand portfolios",
            "trigger": "Normalised demand signals for a category and horizon."
          },
          {
            "agentIds": [
              "demand-portfolio-agent",
              "demand-portfolio-critic-agent"
            ],
            "escalationRoleIds": [
              "requester",
              "intake-owner",
              "demand-owner",
              "process-owner"
            ],
            "id": "operate-demand-portfolios",
            "jobIds": [
              "demand-consolidation-portfolio.compatible-demand",
              "demand-consolidation-portfolio.grouping-rationale",
              "demand-consolidation-portfolio.portfolio-scenarios",
              "demand-consolidation-portfolio.business-consent",
              "demand-consolidation-portfolio.execution-launch"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: portfolio change set, portfolio disposition, and portfolio handoff proposals.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "demand-owner",
                "intake-owner",
                "process-owner"
              ]
            },
            "kind": "agent",
            "label": "Operate demand portfolios",
            "trigger": "Challenged portfolio, member change, owner decision or expiry."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "intake-owner",
              "demand-owner",
              "process-owner"
            ],
            "id": "read-demand-portfolio",
            "jobIds": [
              "demand-consolidation-portfolio.compatible-demand",
              "demand-consolidation-portfolio.grouping-rationale",
              "demand-consolidation-portfolio.portfolio-scenarios",
              "demand-consolidation-portfolio.business-consent",
              "demand-consolidation-portfolio.execution-launch"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: demand portfolio response.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "demand-owner",
                "intake-owner",
                "process-owner"
              ]
            },
            "kind": "read",
            "label": "Read demand portfolio",
            "trigger": "Authorised portfolio, category, requester or downstream query."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "intake-owner",
              "demand-owner",
              "process-owner"
            ],
            "id": "learn-consolidation-outcomes",
            "jobIds": [
              "demand-consolidation-portfolio.compatible-demand",
              "demand-consolidation-portfolio.grouping-rationale",
              "demand-consolidation-portfolio.portfolio-scenarios",
              "demand-consolidation-portfolio.business-consent",
              "demand-consolidation-portfolio.execution-launch"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: portfolio evaluation and portfolio posture recommendation.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "demand-owner",
                "intake-owner",
                "process-owner"
              ]
            },
            "kind": "monitor",
            "label": "Learn consolidation outcomes",
            "trigger": "Portfolio disposition, destination completion, member correction or scheduled evaluation."
          },
          {
            "agentIds": [
              "raw-material-demand-agent"
            ],
            "escalationRoleIds": [
              "requester",
              "intake-owner",
              "demand-owner",
              "process-owner"
            ],
            "id": "signal-raw-material-demand",
            "jobIds": [
              "demand-consolidation-portfolio.material-economics"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: normalised raw material demand and a raw material forecast component proposal.",
                "Each normalised signal records its source, unit of measure and calendar conversion, grade reference and forecast confidence, and keeps committed demand separate from non-committed forecast quantities.",
                "Forecast component changes remain proposals until the demand owner accepts them, and the completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "demand-owner",
                "intake-owner",
                "process-owner"
              ]
            },
            "kind": "agent",
            "label": "Signal raw material demand",
            "trigger": "Material forecast revision, item reference change or committed demand-case change in a direct-material category."
          },
          {
            "agentIds": [
              "coverage-position-agent"
            ],
            "escalationRoleIds": [
              "demand-owner",
              "intake-owner",
              "process-owner"
            ],
            "id": "monitor-coverage-position",
            "jobIds": [
              "demand-consolidation-portfolio.material-economics"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: coverage gap assessment and coverage action proposal.",
                "Every assessed time bucket drills to the forecast components, entitlement records and the unit and calendar conversions behind its computed gap; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "demand-owner",
                "process-owner"
              ]
            },
            "kind": "agent",
            "label": "Monitor coverage position",
            "trigger": "Portfolio, contract-entitlement or forecast change affecting direct-material coverage."
          },
          {
            "agentIds": [
              "specification-harmonisation-agent"
            ],
            "escalationRoleIds": [
              "requester",
              "demand-owner",
              "process-owner"
            ],
            "id": "harmonise-material-specifications",
            "jobIds": [
              "demand-consolidation-portfolio.material-economics"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: harmonised specification proposal and specification consent routing.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "demand-owner",
                "intake-owner"
              ]
            },
            "kind": "agent",
            "label": "Harmonise material specifications",
            "trigger": "Equivalent-specification variants detected across demand cases, items or portfolios."
          }
        ],
        "futureStateKey": "workblock.demand-portfolio.future-state",
        "hiredInsteadKey": "workblock.demand-portfolio.hired-instead",
        "id": "demand-consolidation-portfolio",
        "implementationStatus": "roadmap",
        "jobStatementKey": "workblock.demand-portfolio.job",
        "jobStories": [
          {
            "completionKey": "workblock.demand-portfolio.story.compatible-demand.completion",
            "executionFlowIds": [
              "refresh-demand-signals",
              "generate-demand-portfolios",
              "operate-demand-portfolios",
              "read-demand-portfolio",
              "learn-consolidation-outcomes"
            ],
            "id": "demand-consolidation-portfolio.compatible-demand",
            "roleCardId": "demand-owner",
            "storyKey": "workblock.demand-portfolio.story.compatible-demand.story"
          },
          {
            "completionKey": "workblock.demand-portfolio.story.grouping-rationale.completion",
            "executionFlowIds": [
              "refresh-demand-signals",
              "generate-demand-portfolios",
              "operate-demand-portfolios",
              "read-demand-portfolio",
              "learn-consolidation-outcomes"
            ],
            "id": "demand-consolidation-portfolio.grouping-rationale",
            "roleCardId": "demand-owner",
            "storyKey": "workblock.demand-portfolio.story.grouping-rationale.story"
          },
          {
            "completionKey": "workblock.demand-portfolio.story.portfolio-scenarios.completion",
            "executionFlowIds": [
              "refresh-demand-signals",
              "generate-demand-portfolios",
              "operate-demand-portfolios",
              "read-demand-portfolio",
              "learn-consolidation-outcomes"
            ],
            "id": "demand-consolidation-portfolio.portfolio-scenarios",
            "roleCardId": "demand-owner",
            "storyKey": "workblock.demand-portfolio.story.portfolio-scenarios.story"
          },
          {
            "completionKey": "workblock.demand-portfolio.story.business-consent.completion",
            "executionFlowIds": [
              "refresh-demand-signals",
              "generate-demand-portfolios",
              "operate-demand-portfolios",
              "read-demand-portfolio",
              "learn-consolidation-outcomes"
            ],
            "id": "demand-consolidation-portfolio.business-consent",
            "roleCardId": "process-owner",
            "storyKey": "workblock.demand-portfolio.story.business-consent.story"
          },
          {
            "completionKey": "workblock.demand-portfolio.story.execution-launch.completion",
            "executionFlowIds": [
              "refresh-demand-signals",
              "generate-demand-portfolios",
              "operate-demand-portfolios",
              "read-demand-portfolio",
              "learn-consolidation-outcomes"
            ],
            "id": "demand-consolidation-portfolio.execution-launch",
            "roleCardId": "demand-owner",
            "storyKey": "workblock.demand-portfolio.story.execution-launch.story"
          },
          {
            "completionKey": "workblock.demand-portfolio.story.material-economics.completion",
            "executionFlowIds": [
              "signal-raw-material-demand",
              "monitor-coverage-position",
              "harmonise-material-specifications"
            ],
            "id": "demand-consolidation-portfolio.material-economics",
            "roleCardId": "demand-owner",
            "storyKey": "workblock.demand-portfolio.story.material-economics.story"
          }
        ],
        "labelKey": "workblock.demand-portfolio.label",
        "metrics": [
          "Addressable demand share surfaced before route execution",
          "Accepted consolidation value and volume by category",
          "False-group and missed-group rate",
          "Median compatible-signal-to-portfolio time",
          "Forecast-to-observed demand calibration",
          "Requester timing or service-impact exception rate",
          "Destination handoff acceptance and reconciled outcome rate",
          "Under- and over-coverage detected before the affected time bucket opens",
          "Coverage action proposal acceptance and resolution rate"
        ],
        "officeCapabilities": [
          "conductor"
        ],
        "operatingModel": "Continuously assemble permission-safe current and forecast demand, generate compatible grouping candidates, model bundle and timing scenarios, critic-test operational and policy constraints, maintain an expiring portfolio proposal, and coordinate accepted groups into category strategy, sourcing or tactical execution.",
        "outcomeKey": "workblock.demand-portfolio.outcome",
        "prerequisites": [
          "A flow of qualified demand cases from request coordination",
          "Forecast demand data by category and business unit",
          "Consolidation objectives and compatibility policy configured",
          "Named owners for cross-unit priority and timing decisions"
        ],
        "toolKey": "workblock.demand-portfolio.tool",
        "version": "5.1.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Refresh pipeline signals",
              "Create and merge non-committed opportunity proposals",
              "Add evidence-linked market candidates",
              "Expire stale hypotheses",
              "Request eligibility or evidence refresh"
            ],
            "escalationTriggers": [
              "Potential supplier conflict or confidentiality issue",
              "Novel or material supply risk",
              "Insufficient viable market evidence",
              "Category strategy or demand conflict",
              "Restricted-party identity ambiguity"
            ],
            "id": "sourcing-discovery-agent",
            "label": "Sourcing discovery agent",
            "mission": "Find and qualify sourcing intervention and market hypotheses from current category, demand, contract and supplier evidence.",
            "operatorRoleIds": [
              "evaluator"
            ],
            "personaIds": [
              "category-management-persona",
              "sourcing-specialist",
              "supplier-risk-manager"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "sourcing-lead",
              "evaluator"
            ]
          },
          {
            "autonomousActions": [
              "Score and sequence proposals",
              "Recommend route and target date",
              "Rebalance non-committed capacity",
              "Prepare destination handoff proposals",
              "Mark evidence stale"
            ],
            "escalationTriggers": [
              "Material baseline or priority dispute",
              "External supplier action",
              "Route lacks competition or policy support",
              "Capacity conflict affects committed deadlines",
              "High-consequence or novel intervention"
            ],
            "id": "sourcing-pipeline-agent",
            "label": "Sourcing pipeline agent",
            "mission": "Recommend route, timing and sequence for qualified opportunities within strategy, policy and capacity constraints.",
            "operatorRoleIds": [
              "evaluator"
            ],
            "personaIds": [
              "sourcing-specialist",
              "procurement-leadership",
              "finance"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "sourcing-lead",
              "evaluator"
            ]
          },
          {
            "autonomousActions": [
              "Assemble price outlook and coverage evidence into a timing fact base",
              "Simulate buy window scenarios against declared volume bands and horizons",
              "Draft bounded mandate proposals that name volume, window and ceiling",
              "Route mandate proposals to the named authorising owner",
              "Expire mandate proposals whose evidence or buy window lapses"
            ],
            "escalationTriggers": [
              "Proposed volume band or price ceiling exceeds the authority envelope",
              "Price assessment source is stale, revised or discontinued",
              "Mandate conflicts with committed demand or category strategy",
              "Zero-cover or full-cover position is proposed",
              "Any purchase execution or supplier contact is requested"
            ],
            "id": "buy-timing-agent",
            "label": "Buy timing agent",
            "mission": "Convert price outlooks and coverage gaps into bounded, evidence-linked buy-timing mandate proposals that name volume, window and ceiling, never executing the buy itself.",
            "operatorRoleIds": [
              "sourcing-lead"
            ],
            "personaIds": [
              "sourcing-specialist",
              "category-management-persona",
              "finance"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "sourcing-lead"
            ]
          }
        ],
        "agentStoryKey": "workblock.sourcing-pipeline.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "External supplier contact or invitation",
            "High-risk, restricted or conflicted party",
            "Material value or route without sufficient competition evidence",
            "Novel legal, regulatory or geopolitical consequence",
            "Change to committed demand or category strategy"
          ],
          "authorityEnvelope": [
            "Named categories, geographies, market sources and horizons",
            "Allowed scan, retrieve, resolve, qualify, score, rank, defer, expire and propose-handoff verbs",
            "Approved route types, baseline methods and supplier-candidate evidence rules",
            "Maximum proposal value and portfolio capacity",
            "Forbidden invitation, supplier communication, award and other commitment",
            "Mission duration, sampling and stop conditions",
            "Per-category, market-source and destination-route kill switches for discovery writes and handoffs"
          ],
          "humanSupervision": [
            "Set category, capacity and route priorities",
            "Inspect sampled high-ranked and suppressed opportunities",
            "Govern supplier discovery, fairness and market evidence policy",
            "Resolve material value, timing and risk conflicts",
            "Accept or delegate consequential destination starts"
          ],
          "rollback": [
            "Stop new discovery writes and handoff proposals",
            "Restore last-approved signal, market, routing and scoring versions",
            "Expire affected pipeline proposals",
            "Withdraw only unaccepted destination handoffs",
            "Reconcile converted records and preserve source evidence"
          ],
          "targetPosture": "mission_autonomous_with_supervision"
        },
        "coreValue": "Maintain a forward-looking sourcing pipeline whose interventions and viable-market candidates open into current source records, rather than waiting for isolated event requests.",
        "currentStateKey": "workblock.sourcing-pipeline.current-state",
        "dataMappings": [
          {
            "access": "create",
            "entityId": "sourcing-opportunity",
            "purpose": "Create qualified and expiring sourcing pipeline proposals linked to their supporting records."
          },
          {
            "access": "update",
            "entityId": "sourcing-opportunity",
            "purpose": "Refresh market, route, priority and disposition while preserving pipeline history."
          },
          {
            "access": "read",
            "entityId": "sourcing-opportunity",
            "purpose": "Serve pipeline planning, destination handoffs, drill-through and outcome evaluation."
          },
          {
            "access": "index",
            "entityId": "sourcing-opportunity",
            "purpose": "Find opportunities by category, source, route, priority, timing and freshness."
          },
          {
            "access": "read",
            "entityId": "category-opportunity",
            "purpose": "Consume accepted category opportunity evidence without duplicating its baseline."
          },
          {
            "access": "read",
            "entityId": "demand-portfolio",
            "purpose": "Derive sourcing scope, volume, timing and forecast confidence."
          },
          {
            "access": "read",
            "entityId": "category-strategy",
            "purpose": "Read the governed category strategy contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "authority-envelope",
            "purpose": "Read the policy-filtered canonical authority envelope projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "sourcing-opportunity",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "create",
            "entityId": "buy-timing-mandate",
            "purpose": "Create a versioned, evidence-linked buy-timing mandate for one sourcing opportunity under named authority."
          },
          {
            "access": "update",
            "entityId": "buy-timing-mandate",
            "purpose": "Record mandate decision, supersession or expiry under expected-version control without rewriting prior revisions."
          },
          {
            "access": "read",
            "entityId": "buy-timing-mandate",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "buy-timing-mandate",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "action-proposal",
            "purpose": "Point-read the exact permission-safe D5/D7 handoff action-proposal record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "decision",
            "purpose": "Point-read the exact permission-safe D5/D7 handoff decision record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "committed-action",
            "purpose": "Point-read the exact permission-safe D5/D7 handoff committed-action record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "business-event",
            "purpose": "Point-read the exact permission-safe D5/D7 handoff business-event record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "create",
            "entityId": "action-proposal",
            "purpose": "Submit the version-pinned D5/D7 requested outcome, sender/receiver, source/target, evidence, authority, expiry and reopen context to shared-ledger-service without writing receiver-owned state."
          },
          {
            "access": "create",
            "entityId": "decision",
            "purpose": "Submit the authorised, version-pinned D5/D7 receiving-owner acceptance, rejection, redirect, expiry or reopen decision to shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "committed-action",
            "purpose": "Append each authorised D5/D7 delivery or receiver-owned command attempt with idempotency, safe-retry and reconciliation state through shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "business-event",
            "purpose": "Append immutable D5/D7 delivery, acknowledgement, rejection, reconciliation, replay or reopen facts through audit-event-service; an event never becomes current domain state."
          },
          {
            "access": "read",
            "entityId": "supplier-innovation-case",
            "purpose": "Read the exact D7 innovation source record/version addressed to this owner."
          }
        ],
        "descriptionKey": "workblock.sourcing-pipeline.description",
        "descriptorKey": "workblock.sourcing-pipeline.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "sourcing-negotiation",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "sourcing-lead",
              "evaluator",
              "award-authority",
              "negotiation-lead"
            ],
            "id": "refresh-sourcing-signals",
            "jobIds": [
              "sourcing-pipeline-discovery.discover-intervention",
              "sourcing-pipeline-discovery.market-readiness",
              "sourcing-pipeline-discovery.route-selection",
              "sourcing-pipeline-discovery.capacity-priority",
              "sourcing-pipeline-discovery.accepted-handoff"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: sourcing signal set and sourcing source health.",
                "Accepted and rejected inputs are counted, source-linked and assigned a freshness state; a failed refresh retains last-good data.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "sourcing-lead",
                "evaluator"
              ]
            },
            "kind": "refresh",
            "label": "Refresh sourcing signals",
            "trigger": "Strategy, opportunity, demand, contract, supplier, market or source-health event."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "sourcing-lead",
              "evaluator",
              "award-authority",
              "negotiation-lead"
            ],
            "id": "discover-sourcing-market",
            "jobIds": [
              "sourcing-pipeline-discovery.discover-intervention",
              "sourcing-pipeline-discovery.market-readiness",
              "sourcing-pipeline-discovery.route-selection",
              "sourcing-pipeline-discovery.capacity-priority",
              "sourcing-pipeline-discovery.accepted-handoff"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: market evidence set and candidate dispositions.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "sourcing-lead",
                "evaluator"
              ]
            },
            "kind": "analyse",
            "label": "Discover sourcing market",
            "trigger": "Qualified scope or material market refresh."
          },
          {
            "agentIds": [
              "sourcing-discovery-agent",
              "sourcing-pipeline-agent"
            ],
            "escalationRoleIds": [
              "sourcing-lead",
              "evaluator",
              "award-authority",
              "negotiation-lead"
            ],
            "id": "qualify-sourcing-opportunity",
            "jobIds": [
              "sourcing-pipeline-discovery.discover-intervention",
              "sourcing-pipeline-discovery.market-readiness",
              "sourcing-pipeline-discovery.route-selection",
              "sourcing-pipeline-discovery.capacity-priority",
              "sourcing-pipeline-discovery.accepted-handoff"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: sourcing opportunity change and qualification result.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "sourcing-lead",
                "evaluator"
              ]
            },
            "kind": "agent",
            "label": "Qualify sourcing opportunity",
            "trigger": "Sourcing signals and market evidence are available."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "sourcing-lead",
              "evaluator",
              "award-authority",
              "negotiation-lead"
            ],
            "id": "operate-sourcing-pipeline",
            "jobIds": [
              "sourcing-pipeline-discovery.discover-intervention",
              "sourcing-pipeline-discovery.market-readiness",
              "sourcing-pipeline-discovery.route-selection",
              "sourcing-pipeline-discovery.capacity-priority",
              "sourcing-pipeline-discovery.accepted-handoff"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: pipeline plan, pipeline disposition, and sourcing handoff set.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "sourcing-lead",
                "evaluator"
              ]
            },
            "kind": "operate",
            "label": "Operate sourcing pipeline",
            "trigger": "Qualified opportunity, capacity change, disposition or expiry."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "sourcing-lead",
              "evaluator",
              "award-authority",
              "negotiation-lead"
            ],
            "id": "monitor-sourcing-pipeline",
            "jobIds": [
              "sourcing-pipeline-discovery.discover-intervention",
              "sourcing-pipeline-discovery.market-readiness",
              "sourcing-pipeline-discovery.route-selection",
              "sourcing-pipeline-discovery.capacity-priority",
              "sourcing-pipeline-discovery.accepted-handoff"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: pipeline evaluation and pipeline posture recommendation.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "sourcing-lead",
                "evaluator"
              ]
            },
            "kind": "monitor",
            "label": "Monitor sourcing pipeline",
            "trigger": "Handoff, event, negotiation, award, realized outcome or scheduled evaluation."
          },
          {
            "agentIds": [
              "buy-timing-agent"
            ],
            "escalationRoleIds": [
              "sourcing-lead",
              "award-authority"
            ],
            "id": "mandate-buy-timing",
            "jobIds": [
              "sourcing-pipeline-discovery.buy-timing"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: buy window scenario set and buy timing mandate routing.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "sourcing-lead"
              ]
            },
            "kind": "agent",
            "label": "Mandate buy timing",
            "trigger": "Commodity price outlook, coverage gap or category strategy window opens a candidate buy window."
          }
        ],
        "futureStateKey": "workblock.sourcing-pipeline.future-state",
        "hiredInsteadKey": "workblock.sourcing-pipeline.hired-instead",
        "id": "sourcing-pipeline-discovery",
        "implementationStatus": "roadmap",
        "jobStatementKey": "workblock.sourcing-pipeline.job",
        "jobStories": [
          {
            "completionKey": "workblock.sourcing-pipeline.story.discover-intervention.completion",
            "executionFlowIds": [
              "refresh-sourcing-signals",
              "discover-sourcing-market",
              "qualify-sourcing-opportunity",
              "operate-sourcing-pipeline",
              "monitor-sourcing-pipeline"
            ],
            "id": "sourcing-pipeline-discovery.discover-intervention",
            "roleCardId": "sourcing-lead",
            "storyKey": "workblock.sourcing-pipeline.story.discover-intervention.story"
          },
          {
            "completionKey": "workblock.sourcing-pipeline.story.market-readiness.completion",
            "executionFlowIds": [
              "refresh-sourcing-signals",
              "discover-sourcing-market",
              "qualify-sourcing-opportunity",
              "operate-sourcing-pipeline",
              "monitor-sourcing-pipeline"
            ],
            "id": "sourcing-pipeline-discovery.market-readiness",
            "roleCardId": "sourcing-lead",
            "storyKey": "workblock.sourcing-pipeline.story.market-readiness.story"
          },
          {
            "completionKey": "workblock.sourcing-pipeline.story.route-selection.completion",
            "executionFlowIds": [
              "refresh-sourcing-signals",
              "discover-sourcing-market",
              "qualify-sourcing-opportunity",
              "operate-sourcing-pipeline",
              "monitor-sourcing-pipeline"
            ],
            "id": "sourcing-pipeline-discovery.route-selection",
            "roleCardId": "sourcing-lead",
            "storyKey": "workblock.sourcing-pipeline.story.route-selection.story"
          },
          {
            "completionKey": "workblock.sourcing-pipeline.story.capacity-priority.completion",
            "executionFlowIds": [
              "refresh-sourcing-signals",
              "discover-sourcing-market",
              "qualify-sourcing-opportunity",
              "operate-sourcing-pipeline",
              "monitor-sourcing-pipeline"
            ],
            "id": "sourcing-pipeline-discovery.capacity-priority",
            "roleCardId": "sourcing-lead",
            "storyKey": "workblock.sourcing-pipeline.story.capacity-priority.story"
          },
          {
            "completionKey": "workblock.sourcing-pipeline.story.accepted-handoff.completion",
            "executionFlowIds": [
              "refresh-sourcing-signals",
              "discover-sourcing-market",
              "qualify-sourcing-opportunity",
              "operate-sourcing-pipeline",
              "monitor-sourcing-pipeline"
            ],
            "id": "sourcing-pipeline-discovery.accepted-handoff",
            "roleCardId": "sourcing-lead",
            "storyKey": "workblock.sourcing-pipeline.story.accepted-handoff.story"
          },
          {
            "completionKey": "workblock.sourcing-pipeline.story.buy-timing.completion",
            "executionFlowIds": [
              "mandate-buy-timing"
            ],
            "id": "sourcing-pipeline-discovery.buy-timing",
            "roleCardId": "sourcing-lead",
            "storyKey": "workblock.sourcing-pipeline.story.buy-timing.story"
          }
        ],
        "labelKey": "workblock.sourcing-pipeline.label",
        "metrics": [
          "Qualified pipeline value and count with record drill-through",
          "Opportunity detection-to-qualified and qualified-to-start time",
          "Accepted and converted pipeline share",
          "Market candidate relevance, eligibility and diversity coverage",
          "Recommended-to-actual route agreement",
          "Predicted-to-observed event cycle and value calibration",
          "Expired, deferred and destination-rejected proposal rate"
        ],
        "officeCapabilities": [
          "conductor"
        ],
        "operatingModel": "Continuously scan category strategies, opportunities, demand portfolios, contract horizons, supplier eligibility and market evidence; qualify intervention candidates; discover and verify prospective parties; recommend a sourcing route and timing; balance value against capacity; and convert accepted proposals into governed event, negotiation or tactical cases.",
        "outcomeKey": "workblock.sourcing-pipeline.outcome",
        "prerequisites": [
          "An accepted category opportunity backlog",
          "Approved demand portfolios ready for sourcing",
          "Contract expiry and renewal horizons from the contract repository",
          "Supplier eligibility records for longlist verification",
          "Named owners for route, timing and capacity decisions"
        ],
        "toolKey": "workblock.sourcing-pipeline.tool",
        "version": "5.1.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Draft event strategy and artifacts",
              "Generate response formats and evaluator packs",
              "Propose invite cohort",
              "Run completeness and competition scenarios",
              "Prepare version diffs"
            ],
            "escalationTriggers": [
              "Novel or high-consequence requirement",
              "Insufficient competition or market depth",
              "Legal or policy deviation",
              "Material evaluation-model change",
              "Sensitive or restricted specification"
            ],
            "id": "sourcing-event-designer-agent",
            "label": "Sourcing event designer agent",
            "mission": "Design a complete, fair and evaluation-ready event proposal from qualified scope, strategy, market and policy evidence.",
            "operatorRoleIds": [
              "evaluator"
            ],
            "personaIds": [
              "sourcing-specialist",
              "category-management-persona",
              "contract-legal"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "sourcing-lead",
              "evaluator"
            ]
          },
          {
            "autonomousActions": [
              "Publish and communicate inside an approved event plan",
              "Answer pre-authorised factual questions",
              "Issue non-semantic corrections",
              "Receive and validate sealed submissions",
              "Pause on control breach"
            ],
            "escalationTriggers": [
              "Material amendment or deadline change",
              "Supplier protest, conflict or exclusion",
              "Unequal information or failed delivery",
              "Late bid requiring discretion",
              "External commitment beyond event publication"
            ],
            "id": "sourcing-event-operator-agent",
            "label": "Sourcing event operator agent",
            "mission": "Operate an authorised event with equal information, reconciled delivery, sealed submissions and automatic pause on fairness or control breach.",
            "operatorRoleIds": [
              "evaluator"
            ],
            "personaIds": [
              "sourcing-specialist",
              "supplier-risk-manager",
              "platform-operator"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "sourcing-lead",
              "evaluator"
            ]
          }
        ],
        "agentStoryKey": "workblock.sourcing-event.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Material scope, evaluation, lot, term or deadline change",
            "Supplier exclusion, conflict, protest or unequal-information concern",
            "Late submission requiring discretion",
            "Legal or policy deviation",
            "Award, contract or other external commercial commitment"
          ],
          "authorityEnvelope": [
            "Named event, published version, participant cohort, channels and schedule",
            "Allowed draft, validate, publish-authorised-version, communicate-listed-content, receive, pause and reconcile verbs",
            "Approved event template, evaluation model, question categories and amendment classes",
            "Supplier eligibility, conflict, equal-information and sealed-access guards",
            "Value, deadline, message-volume and retry bounds",
            "No authority to materially amend, exclude by discretion or award outside a specific grant",
            "Per-event, supplier-channel and mutating-tool kill switches that preserve published artifacts and received submissions"
          ],
          "humanSupervision": [
            "Approve event strategy and material publication consequence",
            "Govern evaluation, fairness, exclusions and material amendments",
            "Inspect sampled communications and all control exceptions",
            "Resolve supplier disputes and late-bid discretion",
            "Pause, cancel or roll back event operations"
          ],
          "rollback": [
            "Pause new communications and submissions as policy allows",
            "Restore last-approved event code, prompt and adapter versions",
            "Published event content is never silently overwritten; issue an explicit amendment or cancellation",
            "Reconcile recipient delivery and affected submissions",
            "Preserve all prior artifacts, messages and authority evidence"
          ],
          "targetPosture": "policy_autonomous_with_monitoring"
        },
        "coreValue": "Run competitive sourcing events faster and more consistently while preserving equal treatment, sealed evidence, source-linked decisions and exact control over every external communication.",
        "currentStateKey": "workblock.sourcing-event.current-state",
        "dataMappings": [
          {
            "access": "create",
            "entityId": "sourcing-event-record",
            "purpose": "Create the governed event identity and complete candidate state."
          },
          {
            "access": "update",
            "entityId": "sourcing-event-record",
            "purpose": "Advance event lifecycle and publish amendments as new immutable artifact versions."
          },
          {
            "access": "read",
            "entityId": "sourcing-event-record",
            "purpose": "Operate, supervise, evaluate and drill through the event and publication lineage."
          },
          {
            "access": "index",
            "entityId": "sourcing-event-record",
            "purpose": "Resolve events by stable identity, opportunity, category, state and deadline."
          },
          {
            "access": "read",
            "entityId": "sourcing-opportunity",
            "purpose": "Bind event design to the accepted pipeline scope, route, market and evidence."
          },
          {
            "access": "read",
            "entityId": "party",
            "purpose": "Read the policy-filtered canonical party projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "person",
            "purpose": "Read the policy-filtered canonical person projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "category",
            "purpose": "Read the policy-filtered canonical category projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "item-service",
            "purpose": "Read the policy-filtered canonical item or service projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "source-record-reference",
            "purpose": "Read the policy-filtered canonical source record reference projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "evidence-item",
            "purpose": "Read the policy-filtered canonical evidence item projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "policy",
            "purpose": "Read the policy-filtered canonical policy projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "policy-version",
            "purpose": "Read the policy-filtered canonical policy version projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "authority-envelope",
            "purpose": "Read the policy-filtered canonical authority envelope projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "action-proposal",
            "purpose": "Read the policy-filtered canonical action proposal projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "committed-action",
            "purpose": "Read the policy-filtered canonical committed action projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "decision",
            "purpose": "Read the policy-filtered canonical decision projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "exception",
            "purpose": "Read the policy-filtered canonical exception case projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "audit-event",
            "purpose": "Read the policy-filtered canonical audit event projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "business-event",
            "purpose": "Read the policy-filtered canonical business event projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "learning-example",
            "purpose": "Read the policy-filtered canonical learning example projection from learning-evaluation-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "evaluation-result",
            "purpose": "Read the policy-filtered canonical evaluation result projection from learning-evaluation-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "integration-state",
            "purpose": "Read the policy-filtered canonical integration state projection from integration-state-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "registry-release",
            "purpose": "Read the policy-filtered canonical registry release projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "update",
            "entityId": "supplier-response",
            "purpose": "Own the governed supplier response contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "supplier-response",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "sourcing-event-record",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "supplier-response",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "buy-timing-mandate",
            "purpose": "Read an authorised buy-timing-mandate record by stable identity through sourcing-pipeline-discovery's owner API; this grants no collection browsing or datastore access."
          }
        ],
        "descriptionKey": "workblock.sourcing-event.description",
        "descriptorKey": "workblock.sourcing-event.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "sourcing-negotiation",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "sourcing-lead",
              "evaluator",
              "award-authority",
              "negotiation-lead"
            ],
            "id": "design-sourcing-event",
            "jobIds": [
              "sourcing-event.shape-event",
              "sourcing-event.one-basis",
              "sourcing-event.score-with-evidence",
              "sourcing-event.compare-scenarios",
              "sourcing-event.amendment-impact",
              "sourcing-event.decide-award"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: event candidate and event design diagnostics.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "sourcing-lead",
                "evaluator"
              ]
            },
            "kind": "analyse",
            "label": "Design sourcing event",
            "trigger": "Accepted sourcing opportunity and event-design mandate."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "sourcing-lead",
              "evaluator",
              "award-authority",
              "negotiation-lead"
            ],
            "id": "author-event-package",
            "jobIds": [
              "sourcing-event.shape-event",
              "sourcing-event.one-basis",
              "sourcing-event.score-with-evidence",
              "sourcing-event.compare-scenarios",
              "sourcing-event.amendment-impact",
              "sourcing-event.decide-award"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: event package candidate and artifact disposition.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "sourcing-lead",
                "evaluator"
              ]
            },
            "kind": "operate",
            "label": "Author event package",
            "trigger": "Complete event candidate."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "sourcing-lead",
              "evaluator",
              "award-authority",
              "negotiation-lead"
            ],
            "id": "publish-sourcing-event",
            "jobIds": [
              "sourcing-event.shape-event",
              "sourcing-event.one-basis",
              "sourcing-event.score-with-evidence",
              "sourcing-event.compare-scenarios",
              "sourcing-event.amendment-impact",
              "sourcing-event.decide-award"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: published sourcing event and invitation result.",
                "The exact proposal version, authorised reviewer or policy authority, decision and reason are durable before any commitment.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "sourcing-lead",
                "evaluator"
              ]
            },
            "kind": "review",
            "label": "Publish sourcing event",
            "trigger": "Event package, eligible participant cohort and authority packet are complete."
          },
          {
            "agentIds": [
              "sourcing-event-designer-agent",
              "sourcing-event-operator-agent"
            ],
            "escalationRoleIds": [
              "sourcing-lead",
              "evaluator",
              "award-authority",
              "negotiation-lead"
            ],
            "id": "operate-live-sourcing-event",
            "jobIds": [
              "sourcing-event.shape-event",
              "sourcing-event.one-basis",
              "sourcing-event.score-with-evidence",
              "sourcing-event.compare-scenarios",
              "sourcing-event.amendment-impact",
              "sourcing-event.decide-award"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: communication result, submission result, and live event change set.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "sourcing-lead",
                "evaluator"
              ]
            },
            "kind": "agent",
            "label": "Operate live sourcing event",
            "trigger": "Supplier question, amendment proposal, delivery event, deadline or bid receipt."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "sourcing-lead",
              "evaluator",
              "award-authority",
              "negotiation-lead"
            ],
            "id": "close-monitor-sourcing-event",
            "jobIds": [
              "sourcing-event.shape-event",
              "sourcing-event.one-basis",
              "sourcing-event.score-with-evidence",
              "sourcing-event.compare-scenarios",
              "sourcing-event.amendment-impact",
              "sourcing-event.decide-award"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: immutable response set, event metrics, event evaluation, and event closure disposition.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "sourcing-lead",
                "evaluator"
              ]
            },
            "kind": "monitor",
            "label": "Close and monitor sourcing event",
            "trigger": "Submission deadline, cancellation, award handoff or scheduled control scan."
          }
        ],
        "futureStateKey": "workblock.sourcing-event.future-state",
        "hiredInsteadKey": "workblock.sourcing-event.hired-instead",
        "id": "sourcing-event",
        "implementationStatus": "reference",
        "jobStatementKey": "workblock.sourcing-event.job",
        "jobStories": [
          {
            "completionKey": "workblock.sourcing-event.story.shape-event.completion",
            "executionFlowIds": [
              "design-sourcing-event",
              "author-event-package",
              "publish-sourcing-event",
              "operate-live-sourcing-event",
              "close-monitor-sourcing-event"
            ],
            "id": "sourcing-event.shape-event",
            "roleCardId": "sourcing-lead",
            "storyKey": "workblock.sourcing-event.story.shape-event.story"
          },
          {
            "completionKey": "workblock.sourcing-event.story.one-basis.completion",
            "executionFlowIds": [
              "design-sourcing-event",
              "author-event-package",
              "publish-sourcing-event",
              "operate-live-sourcing-event",
              "close-monitor-sourcing-event"
            ],
            "id": "sourcing-event.one-basis",
            "roleCardId": "sourcing-lead",
            "storyKey": "workblock.sourcing-event.story.one-basis.story"
          },
          {
            "completionKey": "workblock.sourcing-event.story.score-with-evidence.completion",
            "executionFlowIds": [
              "design-sourcing-event",
              "author-event-package",
              "publish-sourcing-event",
              "operate-live-sourcing-event",
              "close-monitor-sourcing-event"
            ],
            "id": "sourcing-event.score-with-evidence",
            "roleCardId": "evaluator",
            "storyKey": "workblock.sourcing-event.story.score-with-evidence.story"
          },
          {
            "completionKey": "workblock.sourcing-event.story.compare-scenarios.completion",
            "executionFlowIds": [
              "design-sourcing-event",
              "author-event-package",
              "publish-sourcing-event",
              "operate-live-sourcing-event",
              "close-monitor-sourcing-event"
            ],
            "id": "sourcing-event.compare-scenarios",
            "roleCardId": "sourcing-lead",
            "storyKey": "workblock.sourcing-event.story.compare-scenarios.story"
          },
          {
            "completionKey": "workblock.sourcing-event.story.amendment-impact.completion",
            "executionFlowIds": [
              "design-sourcing-event",
              "author-event-package",
              "publish-sourcing-event",
              "operate-live-sourcing-event",
              "close-monitor-sourcing-event"
            ],
            "id": "sourcing-event.amendment-impact",
            "roleCardId": "sourcing-lead",
            "storyKey": "workblock.sourcing-event.story.amendment-impact.story"
          },
          {
            "completionKey": "workblock.sourcing-event.story.decide-award.completion",
            "executionFlowIds": [
              "design-sourcing-event",
              "author-event-package",
              "publish-sourcing-event",
              "operate-live-sourcing-event",
              "close-monitor-sourcing-event"
            ],
            "id": "sourcing-event.decide-award",
            "roleCardId": "award-authority",
            "storyKey": "workblock.sourcing-event.story.decide-award.story"
          }
        ],
        "labelKey": "workblock.sourcing-event.label",
        "metrics": [
          "Opportunity-to-publication and publication-to-close cycle",
          "Event artifact first-time-right and downstream rework rate",
          "Eligible invitation delivery and acknowledgement rate",
          "Participation and complete-response rate",
          "Unequal-information, conflict, protest and access-control incidents",
          "Amendment frequency and cause",
          "Policy-bounded supplier-communication conformance and sampled defect rate"
        ],
        "officeCapabilities": [
          "composer",
          "conductor"
        ],
        "operatingModel": "Convert a qualified sourcing opportunity into a typed event design, draft and critic the native event pack, verify supplier eligibility and conflicts, obtain consequence-based publishing authority, distribute and reconcile invitations, manage amendments and questions, receive sealed bids, maintain a last-good published event, participant and delivery projection with explicit freshness, and hand an immutable response set to evaluation.",
        "outcomeKey": "workblock.sourcing-event.outcome",
        "prerequisites": [
          "Qualified sourcing opportunities with approved scope",
          "The canonical supplier record for participants and eligibility checks",
          "Current policy versions governing event conduct and fairness",
          "Named approvers for event strategy and publication consequence",
          "Channels to distribute invitations and receive supplier responses"
        ],
        "toolKey": "workblock.sourcing-event.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Normalize schema-valid bid facts",
              "Calculate deterministic criteria",
              "Flag missing and outlier evidence",
              "Prepare controlled clarification proposals",
              "Freeze an evaluation dataset"
            ],
            "escalationTriggers": [
              "Ambiguous material bid term",
              "Mandatory-criterion discretion",
              "Evaluator conflict",
              "Supplier eligibility change",
              "Potential collusion, fraud or sealed-access breach"
            ],
            "id": "bid-evaluation-agent",
            "label": "Bid evaluation agent",
            "mission": "Normalize and evaluate bids against the exact published model while preserving source evidence, evaluator independence and abstention on ambiguity.",
            "operatorRoleIds": [
              "award-authority"
            ],
            "personaIds": [
              "sourcing-specialist",
              "category-management-persona",
              "supplier-risk-manager"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "evaluator",
              "sourcing-lead",
              "award-authority"
            ]
          },
          {
            "autonomousActions": [
              "Generate and rank non-committed scenarios",
              "Reject infeasible allocations",
              "Recommend negotiation targets",
              "Commit a specifically authorised bounded award",
              "Pause and reconcile failed writeback"
            ],
            "escalationTriggers": [
              "Material trade-off or baseline dispute",
              "No feasible scenario",
              "Concentration or resilience threshold breach",
              "High-consequence award outside envelope",
              "Supplier protest or writeback uncertainty"
            ],
            "id": "award-optimizer-critic-agent",
            "label": "Award optimizer and critic agent",
            "mission": "Generate feasible, explainable award scenarios and independently challenge value, constraints, sensitivity, risk and commitment authority.",
            "operatorRoleIds": [
              "award-authority"
            ],
            "personaIds": [
              "sourcing-specialist",
              "finance",
              "contract-legal"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "evaluator",
              "sourcing-lead",
              "award-authority"
            ]
          },
          {
            "autonomousActions": [
              "Decompose normalised bids into delivered-to-plant cost components",
              "Price freight, duty, quota and surcharge components from governed rate references",
              "Price carbon cost exposure from the current supplier risk context",
              "Assemble and rank landed cost scenarios with sensitivity to rate, quota and carbon assumptions",
              "Propose a preferred allocation with explicit assumptions"
            ],
            "escalationTriggers": [
              "Missing or stale freight, duty or quota reference",
              "Quota status change or trade measure revision inside an open evaluation",
              "Emissions evidence gap or default-value fallback on a material bid",
              "Scenario ranking sensitive to a contested assumption",
              "Any request to treat a proposed allocation as a committed award"
            ],
            "id": "landed-cost-agent",
            "label": "Landed cost agent",
            "mission": "Decompose every comparable bid into unit, logistics, duty and carbon cost components so award scenarios rank on total landed cost with drill-through evidence.",
            "operatorRoleIds": [
              "evaluator"
            ],
            "personaIds": [
              "sourcing-specialist",
              "finance",
              "category-management-persona"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "evaluator",
              "sourcing-lead"
            ]
          }
        ],
        "agentStoryKey": "workblock.bid-award.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Change to published criteria, weights or mandatory requirements",
            "Evaluator conflict, material ambiguity or collusion concern",
            "No feasible allocation or material objective trade-off",
            "High-value, high-risk or novel award outside envelope",
            "Protest, legal challenge or uncertain external commitment"
          ],
          "authorityEnvelope": [
            "Named event version, bid set, evaluation model, evaluators and constraint set",
            "Allowed normalize, calculate, aggregate, optimize, compare, recommend and commit-specifically-authorised-award verbs",
            "Value, allocation, concentration, risk and supplier-eligibility bounds",
            "Minimum source, evaluator and sensitivity evidence",
            "Named notification and writeback adapters",
            "No authority to change published criteria or commit outside the explicit award grant",
            "Per-event, award-class, notification-adapter and writeback-adapter kill switches for new commitments"
          ],
          "humanSupervision": [
            "Govern published criteria, evaluator roles and material constraints",
            "Resolve qualitative, conflict, protest and trade-off exceptions",
            "Inspect sampled normalization and autonomous commitments",
            "Approve high-consequence awards and policy deviations",
            "Review supplier, value, risk and harm outcomes"
          ],
          "rollback": [
            "Stop new award commitments and notifications",
            "Restore last-approved normalization, scoring and optimizer versions",
            "Mark affected uncommitted scenarios invalidated and replay",
            "Committed awards are not deleted; execute governed cancellation or corrective action",
            "Reconcile all notifications, contracts and order handoffs"
          ],
          "targetPosture": "policy_autonomous_with_monitoring"
        },
        "coreValue": "Produce faster, reproducible and defensible award recommendations by normalising bids, applying the published evaluation model and optimizing feasible allocations without concealing assumptions or confusing a scenario with a committed award.",
        "currentStateKey": "workblock.bid-award.current-state",
        "dataMappings": [
          {
            "access": "create",
            "entityId": "award-scenario",
            "purpose": "Create reproducible evaluation and award scenarios with explicit recommendation state."
          },
          {
            "access": "update",
            "entityId": "award-scenario",
            "purpose": "Link a separate authority decision and move lifecycle without altering source evaluation facts."
          },
          {
            "access": "read",
            "entityId": "award-scenario",
            "purpose": "Serve evaluation, scenario comparison, decision, audit and outcome reconciliation."
          },
          {
            "access": "index",
            "entityId": "award-scenario",
            "purpose": "Resolve scenarios by event, recommendation, decision and lifecycle."
          },
          {
            "access": "read",
            "entityId": "sourcing-event-record",
            "purpose": "Bind bids and evaluation to the exact published event, participant and scoring controls."
          },
          {
            "access": "read",
            "entityId": "supplier-response",
            "purpose": "Read the governed supplier response contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "negotiation-session",
            "purpose": "Read the governed negotiation session contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "tactical-sourcing-case",
            "purpose": "Read the governed tactical sourcing case contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "supplier-risk-assessment",
            "purpose": "Price carbon cost exposure in landed cost scenarios from the current scoped supplier emissions and risk disposition."
          },
          {
            "access": "read",
            "entityId": "award-scenario",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          }
        ],
        "descriptionKey": "workblock.bid-award.description",
        "descriptorKey": "workblock.bid-award.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "sourcing-negotiation",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "sourcing-lead",
              "evaluator",
              "award-authority",
              "negotiation-lead"
            ],
            "id": "normalize-event-bids",
            "jobIds": [
              "bid-evaluation-award.normalise-bids",
              "bid-evaluation-award.apply-criteria",
              "bid-evaluation-award.award-scenarios",
              "bid-evaluation-award.challenge-recommendation",
              "bid-evaluation-award.commit-award"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: evaluation ready bids, bid dispositions, and bid normalization diagnostics.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "evaluator",
                "sourcing-lead",
                "award-authority"
              ]
            },
            "kind": "analyse",
            "label": "Normalize event bids",
            "trigger": "Authorised event close and immutable sealed response set."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "sourcing-lead",
              "evaluator",
              "award-authority",
              "negotiation-lead"
            ],
            "id": "evaluate-event-bids",
            "jobIds": [
              "bid-evaluation-award.normalise-bids",
              "bid-evaluation-award.apply-criteria",
              "bid-evaluation-award.award-scenarios",
              "bid-evaluation-award.challenge-recommendation",
              "bid-evaluation-award.commit-award"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: evaluated bid set and evaluation snapshot.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "evaluator",
                "sourcing-lead",
                "award-authority"
              ]
            },
            "kind": "operate",
            "label": "Evaluate event bids",
            "trigger": "Evaluation-ready bids and published evaluation model."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "sourcing-lead",
              "evaluator",
              "award-authority",
              "negotiation-lead"
            ],
            "id": "optimize-award-scenarios",
            "jobIds": [
              "bid-evaluation-award.normalise-bids",
              "bid-evaluation-award.apply-criteria",
              "bid-evaluation-award.award-scenarios",
              "bid-evaluation-award.challenge-recommendation",
              "bid-evaluation-award.commit-award"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: challenged scenario set and scenario dispositions.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "evaluator",
                "sourcing-lead",
                "award-authority"
              ]
            },
            "kind": "analyse",
            "label": "Optimise award scenarios",
            "trigger": "Evaluation snapshot and authorised constraint set."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "sourcing-lead",
              "evaluator",
              "award-authority",
              "negotiation-lead"
            ],
            "id": "decide-commit-award",
            "jobIds": [
              "bid-evaluation-award.normalise-bids",
              "bid-evaluation-award.apply-criteria",
              "bid-evaluation-award.award-scenarios",
              "bid-evaluation-award.challenge-recommendation",
              "bid-evaluation-award.commit-award"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The committed-award-record names the proposal version, award authority, decision and reason; the award-execution-result reconciles each authorised handoff or records the blocking exception.",
                "The exact proposal version, authorised reviewer or policy authority, decision and reason are durable before any commitment.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "award-authority",
                "sourcing-lead",
                "evaluator"
              ]
            },
            "kind": "review",
            "label": "Decide and commit award",
            "trigger": "Complete award scenario and decision packet."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "sourcing-lead",
              "evaluator",
              "award-authority",
              "negotiation-lead"
            ],
            "id": "monitor-award-outcomes",
            "jobIds": [
              "bid-evaluation-award.normalise-bids",
              "bid-evaluation-award.apply-criteria",
              "bid-evaluation-award.award-scenarios",
              "bid-evaluation-award.challenge-recommendation",
              "bid-evaluation-award.commit-award"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: award evaluation and award posture recommendation.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "evaluator",
                "sourcing-lead",
                "award-authority"
              ]
            },
            "kind": "monitor",
            "label": "Monitor award outcomes",
            "trigger": "Protest, negotiation, contract, order, supplier performance or realized-value event."
          },
          {
            "agentIds": [
              "landed-cost-agent"
            ],
            "escalationRoleIds": [
              "evaluator",
              "award-authority",
              "sourcing-lead"
            ],
            "id": "optimize-landed-cost",
            "jobIds": [
              "bid-evaluation-award.landed-cost"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: landed cost scenario set and landed cost allocation proposal.",
                "Each scenario decomposes unit, logistics, duty, quota and carbon components with the rate source and as-of time of each; the allocation proposal keeps a state distinct from any committed award.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "evaluator",
                "sourcing-lead",
                "award-authority"
              ]
            },
            "kind": "agent",
            "label": "Optimise landed cost",
            "trigger": "Normalised bids or an award-scenario request require total-landed-cost decomposition."
          }
        ],
        "futureStateKey": "workblock.bid-award.future-state",
        "hiredInsteadKey": "workblock.bid-award.hired-instead",
        "id": "bid-evaluation-award",
        "implementationStatus": "roadmap",
        "jobStatementKey": "workblock.bid-award.job",
        "jobStories": [
          {
            "completionKey": "workblock.bid-award.story.normalise-bids.completion",
            "executionFlowIds": [
              "normalize-event-bids",
              "evaluate-event-bids",
              "optimize-award-scenarios",
              "decide-commit-award",
              "monitor-award-outcomes"
            ],
            "id": "bid-evaluation-award.normalise-bids",
            "roleCardId": "evaluator",
            "storyKey": "workblock.bid-award.story.normalise-bids.story"
          },
          {
            "completionKey": "workblock.bid-award.story.apply-criteria.completion",
            "executionFlowIds": [
              "normalize-event-bids",
              "evaluate-event-bids",
              "optimize-award-scenarios",
              "decide-commit-award",
              "monitor-award-outcomes"
            ],
            "id": "bid-evaluation-award.apply-criteria",
            "roleCardId": "evaluator",
            "storyKey": "workblock.bid-award.story.apply-criteria.story"
          },
          {
            "completionKey": "workblock.bid-award.story.award-scenarios.completion",
            "executionFlowIds": [
              "normalize-event-bids",
              "evaluate-event-bids",
              "optimize-award-scenarios",
              "decide-commit-award",
              "monitor-award-outcomes"
            ],
            "id": "bid-evaluation-award.award-scenarios",
            "roleCardId": "sourcing-lead",
            "storyKey": "workblock.bid-award.story.award-scenarios.story"
          },
          {
            "completionKey": "workblock.bid-award.story.challenge-recommendation.completion",
            "executionFlowIds": [
              "normalize-event-bids",
              "evaluate-event-bids",
              "optimize-award-scenarios",
              "decide-commit-award",
              "monitor-award-outcomes"
            ],
            "id": "bid-evaluation-award.challenge-recommendation",
            "roleCardId": "award-authority",
            "storyKey": "workblock.bid-award.story.challenge-recommendation.story"
          },
          {
            "completionKey": "workblock.bid-award.story.commit-award.completion",
            "executionFlowIds": [
              "normalize-event-bids",
              "evaluate-event-bids",
              "optimize-award-scenarios",
              "decide-commit-award",
              "monitor-award-outcomes"
            ],
            "id": "bid-evaluation-award.commit-award",
            "roleCardId": "award-authority",
            "storyKey": "workblock.bid-award.story.commit-award.story"
          },
          {
            "completionKey": "workblock.bid-award.story.landed-cost.completion",
            "executionFlowIds": [
              "optimize-landed-cost"
            ],
            "id": "bid-evaluation-award.landed-cost",
            "roleCardId": "evaluator",
            "storyKey": "workblock.bid-award.story.landed-cost.story"
          }
        ],
        "labelKey": "workblock.bid-award.label",
        "metrics": [
          "Bid normalization first-time-right and correction rate",
          "Evaluation completion cycle and evaluator variance",
          "Scenario feasibility and constraint-defect rate",
          "Award value, risk and concentration sensitivity",
          "Recommendation-to-commitment change rate and rationale",
          "Protest, correction and downstream rework rate",
          "Predicted-to-realized value and supplier-performance calibration"
        ],
        "officeCapabilities": [
          "conductor"
        ],
        "operatingModel": "Freeze the authorised bid set, normalize commercial and qualitative responses with provenance, verify mandatory and supplier eligibility criteria, collect and calibrate evaluator inputs, compute scores, optimise award scenarios under declared constraints, test sensitivity and risk, critic-check the recommendation, preserve the last-good evaluation projection with source and model freshness, make every aggregate drill into permitted bid and scenario records, obtain consequence-based award authority, notify and reconcile downstream outcomes.",
        "outcomeKey": "workblock.bid-award.outcome",
        "prerequisites": [
          "Immutable, authorised response sets from the sourcing event",
          "The published evaluation criteria, weightings and constraints",
          "Named evaluators with their role assignments",
          "Award authority thresholds by consequence class"
        ],
        "toolKey": "workblock.bid-award.tool",
        "version": "5.1.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Refresh evidence and assumptions",
              "Draft non-committed strategy and packages",
              "Run sensitivity and counterparty scenarios",
              "Prepare mandate diffs",
              "Mark stale objectives"
            ],
            "escalationTriggers": [
              "Material reservation-value or legal-position change",
              "Insufficient alternative or market evidence",
              "Relationship or fairness consequence",
              "Conflicting category, finance or legal objective"
            ],
            "id": "negotiation-strategy-agent",
            "label": "Negotiation strategy agent",
            "mission": "Build and challenge a source-grounded negotiation plan, issue model and mandate proposal.",
            "operatorRoleIds": [
              "award-authority"
            ],
            "personaIds": [
              "sourcing-specialist",
              "category-management-persona",
              "finance",
              "contract-legal"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "negotiation-lead",
              "sourcing-lead",
              "award-authority"
            ]
          },
          {
            "autonomousActions": [
              "Draft and send messages inside listed channels and content classes",
              "Offer concessions inside issue and package bounds",
              "Ask authorised factual questions",
              "Update issue state",
              "Pause and hand control to a person"
            ],
            "escalationTriggers": [
              "Counterparty introduces a novel term",
              "Concession or package crosses a bound",
              "Threat, coercion, discrimination or relationship harm signal",
              "Legal commitment language",
              "Uncertain delivery, identity or authority"
            ],
            "id": "negotiation-execution-agent",
            "label": "Negotiation execution agent",
            "mission": "Pursue the authorised negotiation objective through bounded exchanges, independent concession checks and immediate pause on mandate breach.",
            "operatorRoleIds": [
              "award-authority"
            ],
            "personaIds": [
              "sourcing-specialist",
              "supplier-relationship-manager",
              "contract-legal"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "negotiation-lead",
              "sourcing-lead",
              "award-authority"
            ]
          }
        ],
        "agentStoryKey": "workblock.negotiation.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Novel term or issue outside the objective model",
            "Concession, package or cumulative value beyond mandate",
            "Binding award, contract, order or payment language",
            "Legal, regulatory, ethical, coercion or relationship harm concern",
            "Identity, delivery or counterparty-authority uncertainty"
          ],
          "authorityEnvelope": [
            "Named session, counterparty identity, mission, duration and approved channels",
            "Exact objectives, issue bounds, reservation values, package rules and forbidden terms",
            "Allowed retrieve, draft, ask, send-listed-message, concede-within-bound, pause and handoff verbs",
            "Per-turn value, cumulative concession, message and time limits",
            "Required independent critic and evidence freshness",
            "No award, signature, order, payment, public statement or other binding commitment",
            "Per-session, counterparty-channel and outbound-tool kill switches that block new messages without erasing prior exchanges"
          ],
          "humanSupervision": [
            "Set and authorise the negotiation mandate",
            "Inspect sampled exchanges, value and harm metrics",
            "Resolve novel terms, material trade-offs and relationship concerns",
            "Approve any expansion of concession or communication authority",
            "Interrupt, take over, pause or terminate the mission"
          ],
          "rollback": [
            "Stop all new outbound messages immediately",
            "Restore last-approved strategy, prompt, model and tool grants",
            "Unsents proposals are invalidated; sent messages remain immutable evidence",
            "Reconcile delivery and counterparty response state",
            "Route any correction, withdrawal or clarification through an authorised human-owned communication"
          ],
          "targetPosture": "mission_autonomous_with_supervision"
        },
        "coreValue": "Improve negotiation preparation and outcomes with an evidence-grounded strategy and, where explicitly mandated, safely autonomous exchanges that never exceed concession, channel, time or commitment boundaries.",
        "currentStateKey": "workblock.negotiation.current-state",
        "dataMappings": [
          {
            "access": "create",
            "entityId": "negotiation-session",
            "purpose": "Create a versioned negotiation session with explicit objectives, authority and evidence."
          },
          {
            "access": "update",
            "entityId": "negotiation-session",
            "purpose": "Maintain reconciled multi-turn state, proposals and non-binding aligned terms."
          },
          {
            "access": "read",
            "entityId": "negotiation-session",
            "purpose": "Prepare, operate, supervise, recover and evaluate the session."
          },
          {
            "access": "index",
            "entityId": "negotiation-session",
            "purpose": "Resolve active sessions by source, counterparty, mandate, state and deadline."
          },
          {
            "access": "read",
            "entityId": "award-scenario",
            "purpose": "Use evaluated bid and scenario evidence as authorised negotiation context."
          },
          {
            "access": "read",
            "entityId": "sourcing-opportunity",
            "purpose": "Use the accepted sourcing scope, route, strategy and market evidence."
          },
          {
            "access": "read",
            "entityId": "authority-envelope",
            "purpose": "Read the policy-filtered canonical authority envelope projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "supplier-response",
            "purpose": "Read the governed supplier response contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "negotiation-session",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "buy-timing-mandate",
            "purpose": "Read an authorised buy-timing-mandate record by stable identity through sourcing-pipeline-discovery's owner API; this grants no collection browsing or datastore access."
          }
        ],
        "descriptionKey": "workblock.negotiation.description",
        "descriptorKey": "workblock.negotiation.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "sourcing-negotiation",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "sourcing-lead",
              "evaluator",
              "award-authority",
              "negotiation-lead"
            ],
            "id": "prepare-negotiation-strategy",
            "jobIds": [
              "negotiation-copilot.set-mandate",
              "negotiation-copilot.fact-base",
              "negotiation-copilot.compare-packages",
              "negotiation-copilot.bounded-authority",
              "negotiation-copilot.capture-round",
              "negotiation-copilot.hand-off-points"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: negotiation candidate, strategy scenarios, and negotiation design diagnostics.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "negotiation-lead",
                "sourcing-lead",
                "award-authority"
              ]
            },
            "kind": "analyse",
            "label": "Prepare negotiation strategy",
            "trigger": "Accepted negotiation route, award scenario or explicit renegotiation mandate."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "sourcing-lead",
              "evaluator",
              "award-authority",
              "negotiation-lead"
            ],
            "id": "authorise-negotiation-mandate",
            "jobIds": [
              "negotiation-copilot.set-mandate",
              "negotiation-copilot.fact-base",
              "negotiation-copilot.compare-packages",
              "negotiation-copilot.bounded-authority",
              "negotiation-copilot.capture-round",
              "negotiation-copilot.hand-off-points"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: authorised negotiation session and negotiation release.",
                "The exact proposal version, authorised reviewer or policy authority, decision and reason are durable before any commitment.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "negotiation-lead",
                "sourcing-lead",
                "award-authority"
              ]
            },
            "kind": "review",
            "label": "Authorise negotiation mandate",
            "trigger": "Complete negotiation candidate and consequence-classified authority packet."
          },
          {
            "agentIds": [
              "negotiation-strategy-agent",
              "negotiation-execution-agent"
            ],
            "escalationRoleIds": [
              "sourcing-lead",
              "evaluator",
              "award-authority",
              "negotiation-lead"
            ],
            "id": "operate-negotiation-session",
            "jobIds": [
              "negotiation-copilot.set-mandate",
              "negotiation-copilot.fact-base",
              "negotiation-copilot.compare-packages",
              "negotiation-copilot.bounded-authority",
              "negotiation-copilot.capture-round",
              "negotiation-copilot.hand-off-points"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: exchange result and exchange disposition.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "negotiation-lead",
                "sourcing-lead",
                "award-authority"
              ]
            },
            "kind": "agent",
            "label": "Operate negotiation session",
            "trigger": "Authorised start, inbound counterparty exchange, timer or supervised instruction."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "sourcing-lead",
              "evaluator",
              "award-authority",
              "negotiation-lead"
            ],
            "id": "reconcile-negotiation-state",
            "jobIds": [
              "negotiation-copilot.set-mandate",
              "negotiation-copilot.fact-base",
              "negotiation-copilot.compare-packages",
              "negotiation-copilot.bounded-authority",
              "negotiation-copilot.capture-round",
              "negotiation-copilot.hand-off-points"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: negotiation change set and session disposition.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "negotiation-lead",
                "sourcing-lead",
                "award-authority"
              ]
            },
            "kind": "operate",
            "label": "Reconcile negotiation state",
            "trigger": "Exchange result, delivery receipt, counterparty response, pause or agreement signal."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "sourcing-lead",
              "evaluator",
              "award-authority",
              "negotiation-lead"
            ],
            "id": "monitor-negotiation-outcomes",
            "jobIds": [
              "negotiation-copilot.set-mandate",
              "negotiation-copilot.fact-base",
              "negotiation-copilot.compare-packages",
              "negotiation-copilot.bounded-authority",
              "negotiation-copilot.capture-round",
              "negotiation-copilot.hand-off-points"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: negotiation evaluation and negotiation posture recommendation.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "negotiation-lead",
                "sourcing-lead",
                "award-authority"
              ]
            },
            "kind": "monitor",
            "label": "Monitor negotiation outcomes",
            "trigger": "Session close, award, contract, performance, value or sampled exchange event."
          }
        ],
        "futureStateKey": "workblock.negotiation.future-state",
        "hiredInsteadKey": "workblock.negotiation.hired-instead",
        "id": "negotiation-copilot",
        "implementationStatus": "pattern",
        "jobStatementKey": "workblock.negotiation.job",
        "jobStories": [
          {
            "completionKey": "workblock.negotiation.story.set-mandate.completion",
            "executionFlowIds": [
              "prepare-negotiation-strategy",
              "authorise-negotiation-mandate",
              "operate-negotiation-session",
              "reconcile-negotiation-state",
              "monitor-negotiation-outcomes"
            ],
            "id": "negotiation-copilot.set-mandate",
            "roleCardId": "negotiation-lead",
            "storyKey": "workblock.negotiation.story.set-mandate.story"
          },
          {
            "completionKey": "workblock.negotiation.story.fact-base.completion",
            "executionFlowIds": [
              "prepare-negotiation-strategy",
              "authorise-negotiation-mandate",
              "operate-negotiation-session",
              "reconcile-negotiation-state",
              "monitor-negotiation-outcomes"
            ],
            "id": "negotiation-copilot.fact-base",
            "roleCardId": "negotiation-lead",
            "storyKey": "workblock.negotiation.story.fact-base.story"
          },
          {
            "completionKey": "workblock.negotiation.story.compare-packages.completion",
            "executionFlowIds": [
              "prepare-negotiation-strategy",
              "authorise-negotiation-mandate",
              "operate-negotiation-session",
              "reconcile-negotiation-state",
              "monitor-negotiation-outcomes"
            ],
            "id": "negotiation-copilot.compare-packages",
            "roleCardId": "sourcing-lead",
            "storyKey": "workblock.negotiation.story.compare-packages.story"
          },
          {
            "completionKey": "workblock.negotiation.story.bounded-authority.completion",
            "executionFlowIds": [
              "prepare-negotiation-strategy",
              "authorise-negotiation-mandate",
              "operate-negotiation-session",
              "reconcile-negotiation-state",
              "monitor-negotiation-outcomes"
            ],
            "id": "negotiation-copilot.bounded-authority",
            "roleCardId": "negotiation-lead",
            "storyKey": "workblock.negotiation.story.bounded-authority.story"
          },
          {
            "completionKey": "workblock.negotiation.story.capture-round.completion",
            "executionFlowIds": [
              "prepare-negotiation-strategy",
              "authorise-negotiation-mandate",
              "operate-negotiation-session",
              "reconcile-negotiation-state",
              "monitor-negotiation-outcomes"
            ],
            "id": "negotiation-copilot.capture-round",
            "roleCardId": "negotiation-lead",
            "storyKey": "workblock.negotiation.story.capture-round.story"
          },
          {
            "completionKey": "workblock.negotiation.story.hand-off-points.completion",
            "executionFlowIds": [
              "prepare-negotiation-strategy",
              "authorise-negotiation-mandate",
              "operate-negotiation-session",
              "reconcile-negotiation-state",
              "monitor-negotiation-outcomes"
            ],
            "id": "negotiation-copilot.hand-off-points",
            "roleCardId": "negotiation-lead",
            "storyKey": "workblock.negotiation.story.hand-off-points.story"
          }
        ],
        "labelKey": "workblock.negotiation.label",
        "metrics": [
          "Preparation time and evidence completeness",
          "Mandate-conformant proposal and sent-message rate",
          "Negotiated package value versus baseline and target",
          "Concession efficiency and issue-closure rate",
          "Human takeover, pause and escalation rate",
          "Legal, tone, relationship and delivery defect rate",
          "Agreement-in-principle-to-valid-commitment conversion and realized outcome"
        ],
        "officeCapabilities": [
          "conductor"
        ],
        "operatingModel": "Assemble opportunity, bid, contract, market and counterparty evidence; build an issue and objective model; stress-test alternatives, targets and reservation values; create a versioned mandate; draft or conduct authorised exchanges; track offers and issue state in a last-good issue and exchange projection with explicit freshness; critic-check every proposed concession; pause on novelty or guard breach; and hand an agreement-in-principle to award or contract Workblocks for separate commitment.",
        "outcomeKey": "workblock.negotiation.outcome",
        "prerequisites": [
          "Award scenarios or sourcing opportunities that frame the position",
          "Access to current contract, spend and counterparty records",
          "A named owner to set and authorise each negotiation mandate",
          "Concession, channel and commitment boundaries configured as authority envelopes"
        ],
        "toolKey": "workblock.negotiation.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Screen and instantiate eligible cases",
              "Invite approved supplier cohorts",
              "Operate authorised quote communication",
              "Evaluate and negotiate inside bounds",
              "Commit bounded awards",
              "Close fully reconciled cases"
            ],
            "escalationTriggers": [
              "Eligibility becomes false or stale",
              "Insufficient eligible competition",
              "Supplier conflict, protest or novel term",
              "Award or concession outside envelope",
              "Uncertain or failed external commitment"
            ],
            "id": "tactical-sourcing-mission-agent",
            "label": "Tactical sourcing mission agent",
            "mission": "Complete an eligible tactical case through permitted sourcing steps while maintaining competition, evidence, timing and authority guards.",
            "operatorRoleIds": [
              "award-authority"
            ],
            "personaIds": [
              "buyer",
              "sourcing-specialist",
              "category-management-persona"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "sourcing-lead",
              "negotiation-lead",
              "award-authority"
            ]
          },
          {
            "autonomousActions": [
              "Block or pause an unsafe step",
              "Quarantine a response",
              "Mark external state uncertain",
              "Start bounded reconciliation",
              "Demote an eligibility class"
            ],
            "escalationTriggers": [
              "Fairness or access-control breach",
              "Duplicate or lost effect",
              "Material false eligibility",
              "Systemic supplier or requester harm",
              "No safe recovery path"
            ],
            "id": "tactical-sourcing-critic-agent",
            "label": "Tactical sourcing critic agent",
            "mission": "Independently enforce eligibility, fairness, evidence, evaluation, authority and reconciliation throughout the policy-bounded tactical sourcing case.",
            "operatorRoleIds": [
              "award-authority"
            ],
            "personaIds": [
              "supplier-risk-manager",
              "platform-operator",
              "sourcing-specialist"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "sourcing-lead",
              "negotiation-lead",
              "award-authority"
            ]
          },
          {
            "autonomousActions": [
              "Assemble the repeat-buy history from closed tactical cases and tail evidence",
              "Evaluate conversion economics from event frequency, price variance and supplier concentration",
              "Draft conversion proposals that name the target channel, supplier and volume basis",
              "Route conversion proposals to the named authorising owner",
              "Expire proposals whose repeat pattern or economics evidence lapses"
            ],
            "escalationTriggers": [
              "A proposed conversion exceeds the tactical authority envelope",
              "Repeat-buy evidence is stale, revised or spans conflicting definitions",
              "The proposed supplier fails an eligibility or qualification screen",
              "The conversion implies a contract commitment or catalogue release",
              "Any award execution or supplier negotiation is requested"
            ],
            "id": "spot-buy-conversion-agent",
            "label": "Spot buy conversion agent",
            "mission": "Detect repeat spot buys, show what the repetition costs against a governed channel, and route conversion proposals that name the target channel, supplier and volume basis, never committing the conversion itself.",
            "operatorRoleIds": [
              "sourcing-lead"
            ],
            "personaIds": [
              "sourcing-specialist",
              "category-management-persona",
              "buyer"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "sourcing-lead"
            ]
          }
        ],
        "agentStoryKey": "workblock.tactical-sourcing.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Case leaves eligibility or evidence bounds",
            "Insufficient competition, supplier conflict, exclusion or protest",
            "Novel legal, commercial, regulatory or safety term",
            "Award, value or concession beyond the exact envelope",
            "Uncertain external commitment or unsafe compensation"
          ],
          "authorityEnvelope": [
            "Named tactical eligibility class, categories, legal entities, value and risk bounds",
            "Approved supplier-selection policy, minimum competition, channels, templates and adapters",
            "Allowed screen, invite, communicate-listed-content, receive, evaluate, negotiate-within-bounds, commit-listed-action, reconcile and close verbs",
            "Per-step evidence, freshness, fairness and critic thresholds",
            "Mission duration, retries, message, concession and commitment limits",
            "Forbidden policy override, novel terms, unlisted suppliers and irreversible actions outside recovery plan",
            "Per-eligibility-class, supplier-channel, negotiation-tool and commitment-tool kill switches"
          ],
          "humanSupervision": [
            "Govern eligibility, supplier-set, negotiation and award policies",
            "Inspect sampled straight-through cases and all true exceptions",
            "Resolve novel terms, protests and material trade-offs",
            "Review supplier, requester, value, fairness and harm metrics",
            "Pause, kill, narrow or roll back route classes"
          ],
          "rollback": [
            "Kill switch blocks all new mutating tools while preserving case and evidence",
            "Restore the last-approved eligibility, template, evaluator, model and adapter versions",
            "Unsents proposals and invitations are invalidated",
            "Sent communications and commitments remain immutable and receive governed correction or compensation",
            "Reconcile every supplier and downstream target before case closure"
          ],
          "targetPosture": "mission_autonomous_with_supervision"
        },
        "coreValue": "Complete eligible low-complexity sourcing from qualified demand to reconciled award or order with minimal touch, while keeping supplier fairness, authority, evidence and recovery stronger than a manual shortcut.",
        "currentStateKey": "workblock.tactical-sourcing.current-state",
        "dataMappings": [
          {
            "access": "create",
            "entityId": "tactical-sourcing-case",
            "purpose": "Create the durable mission, evidence and recovery record for an eligible tactical case."
          },
          {
            "access": "update",
            "entityId": "tactical-sourcing-case",
            "purpose": "Persist each reconciled external step while keeping proposal and commitment separate."
          },
          {
            "access": "read",
            "entityId": "tactical-sourcing-case",
            "purpose": "Screen, operate, supervise, recover, audit and learn from the full tactical case."
          },
          {
            "access": "index",
            "entityId": "tactical-sourcing-case",
            "purpose": "Find current missions by demand, category, authority, participant, commitment and timer."
          },
          {
            "access": "read",
            "entityId": "demand-case",
            "purpose": "Bind tactical eligibility and mission scope to the committed demand journey."
          },
          {
            "access": "read",
            "entityId": "sourcing-opportunity",
            "purpose": "Reuse qualified market and route evidence when tactical sourcing originates from the pipeline."
          },
          {
            "access": "read",
            "entityId": "supplier-response",
            "purpose": "Read the governed supplier response contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "tail-spend-evaluation",
            "purpose": "Read the policy-filtered canonical tail-spend-evaluation projection from spend-data-foundation; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "tactical-sourcing-case",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "buy-timing-mandate",
            "purpose": "Read an authorised buy-timing-mandate record by stable identity through sourcing-pipeline-discovery's owner API; this grants no collection browsing or datastore access."
          }
        ],
        "descriptionKey": "workblock.tactical-sourcing.description",
        "descriptorKey": "workblock.tactical-sourcing.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "sourcing-negotiation",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "sourcing-lead",
              "evaluator",
              "award-authority",
              "negotiation-lead"
            ],
            "id": "screen-tactical-demand",
            "jobIds": [
              "tactical-sourcing-autonomy.eligibility-screen",
              "tactical-sourcing-autonomy.supplier-cohort",
              "tactical-sourcing-autonomy.bounded-exchange",
              "tactical-sourcing-autonomy.routine-award",
              "tactical-sourcing-autonomy.partial-recovery"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: tactical mission contract and screening disposition.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "sourcing-lead",
                "negotiation-lead",
                "award-authority"
              ]
            },
            "kind": "analyse",
            "label": "Screen tactical demand",
            "trigger": "Demand case routed to tactical sourcing or material demand, policy or risk change."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "sourcing-lead",
              "evaluator",
              "award-authority",
              "negotiation-lead"
            ],
            "id": "launch-tactical-request",
            "jobIds": [
              "tactical-sourcing-autonomy.eligibility-screen",
              "tactical-sourcing-autonomy.supplier-cohort",
              "tactical-sourcing-autonomy.bounded-exchange",
              "tactical-sourcing-autonomy.routine-award",
              "tactical-sourcing-autonomy.partial-recovery"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: invited supplier set and quote launch result.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "sourcing-lead",
                "negotiation-lead",
                "award-authority"
              ]
            },
            "kind": "operate",
            "label": "Launch tactical quote request",
            "trigger": "Eligible screening disposition and active mission contract."
          },
          {
            "agentIds": [
              "tactical-sourcing-mission-agent",
              "tactical-sourcing-critic-agent"
            ],
            "escalationRoleIds": [
              "sourcing-lead",
              "evaluator",
              "award-authority",
              "negotiation-lead"
            ],
            "id": "operate-tactical-responses",
            "jobIds": [
              "tactical-sourcing-autonomy.eligibility-screen",
              "tactical-sourcing-autonomy.supplier-cohort",
              "tactical-sourcing-autonomy.bounded-exchange",
              "tactical-sourcing-autonomy.routine-award",
              "tactical-sourcing-autonomy.partial-recovery"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: tactical communication result, normalised response result, and response change set.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "sourcing-lead",
                "negotiation-lead",
                "award-authority"
              ]
            },
            "kind": "agent",
            "label": "Operate tactical responses",
            "trigger": "Supplier question, delivery event, deadline or sealed quote receipt."
          },
          {
            "agentIds": [
              "tactical-sourcing-mission-agent",
              "tactical-sourcing-critic-agent"
            ],
            "escalationRoleIds": [
              "sourcing-lead",
              "evaluator",
              "award-authority",
              "negotiation-lead"
            ],
            "id": "evaluate-negotiate-tactical-award",
            "jobIds": [
              "tactical-sourcing-autonomy.eligibility-screen",
              "tactical-sourcing-autonomy.supplier-cohort",
              "tactical-sourcing-autonomy.bounded-exchange",
              "tactical-sourcing-autonomy.routine-award",
              "tactical-sourcing-autonomy.partial-recovery"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: tactical evaluation, tactical negotiation result, and tactical commitment result.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "sourcing-lead",
                "negotiation-lead",
                "award-authority"
              ]
            },
            "kind": "agent",
            "label": "Evaluate, negotiate and award tactical case",
            "trigger": "Complete response set or negotiation event."
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "sourcing-lead",
              "evaluator",
              "award-authority",
              "negotiation-lead"
            ],
            "id": "reconcile-close-tactical-case",
            "jobIds": [
              "tactical-sourcing-autonomy.eligibility-screen",
              "tactical-sourcing-autonomy.supplier-cohort",
              "tactical-sourcing-autonomy.bounded-exchange",
              "tactical-sourcing-autonomy.routine-award",
              "tactical-sourcing-autonomy.partial-recovery"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: tactical reconciliation, recovery disposition, tactical case outcome, and tactical evaluation result.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "sourcing-lead",
                "negotiation-lead",
                "award-authority"
              ]
            },
            "kind": "monitor",
            "label": "Reconcile and close tactical case",
            "trigger": "Commitment result, downstream response, timeout, failure or scheduled sample."
          },
          {
            "agentIds": [
              "spot-buy-conversion-agent"
            ],
            "escalationRoleIds": [
              "sourcing-lead",
              "award-authority"
            ],
            "id": "convert-repeat-spot-buys",
            "jobIds": [
              "tactical-sourcing-autonomy.spot-buy-conversion"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: conversion economics assessment and channel conversion routing.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "sourcing-lead"
              ]
            },
            "kind": "agent",
            "label": "Convert repeat spot buys",
            "trigger": "Repeat spot-buy pattern detected across closed tactical cases in a category or supplier pair."
          }
        ],
        "futureStateKey": "workblock.tactical-sourcing.future-state",
        "hiredInsteadKey": "workblock.tactical-sourcing.hired-instead",
        "id": "tactical-sourcing-autonomy",
        "implementationStatus": "roadmap",
        "jobStatementKey": "workblock.tactical-sourcing.job",
        "jobStories": [
          {
            "completionKey": "workblock.tactical-sourcing.story.eligibility-screen.completion",
            "executionFlowIds": [
              "screen-tactical-demand",
              "launch-tactical-request",
              "operate-tactical-responses",
              "evaluate-negotiate-tactical-award",
              "reconcile-close-tactical-case"
            ],
            "id": "tactical-sourcing-autonomy.eligibility-screen",
            "roleCardId": "sourcing-lead",
            "storyKey": "workblock.tactical-sourcing.story.eligibility-screen.story"
          },
          {
            "completionKey": "workblock.tactical-sourcing.story.supplier-cohort.completion",
            "executionFlowIds": [
              "screen-tactical-demand",
              "launch-tactical-request",
              "operate-tactical-responses",
              "evaluate-negotiate-tactical-award",
              "reconcile-close-tactical-case"
            ],
            "id": "tactical-sourcing-autonomy.supplier-cohort",
            "roleCardId": "evaluator",
            "storyKey": "workblock.tactical-sourcing.story.supplier-cohort.story"
          },
          {
            "completionKey": "workblock.tactical-sourcing.story.bounded-exchange.completion",
            "executionFlowIds": [
              "screen-tactical-demand",
              "launch-tactical-request",
              "operate-tactical-responses",
              "evaluate-negotiate-tactical-award",
              "reconcile-close-tactical-case"
            ],
            "id": "tactical-sourcing-autonomy.bounded-exchange",
            "roleCardId": "negotiation-lead",
            "storyKey": "workblock.tactical-sourcing.story.bounded-exchange.story"
          },
          {
            "completionKey": "workblock.tactical-sourcing.story.routine-award.completion",
            "executionFlowIds": [
              "screen-tactical-demand",
              "launch-tactical-request",
              "operate-tactical-responses",
              "evaluate-negotiate-tactical-award",
              "reconcile-close-tactical-case"
            ],
            "id": "tactical-sourcing-autonomy.routine-award",
            "roleCardId": "award-authority",
            "storyKey": "workblock.tactical-sourcing.story.routine-award.story"
          },
          {
            "completionKey": "workblock.tactical-sourcing.story.partial-recovery.completion",
            "executionFlowIds": [
              "screen-tactical-demand",
              "launch-tactical-request",
              "operate-tactical-responses",
              "evaluate-negotiate-tactical-award",
              "reconcile-close-tactical-case"
            ],
            "id": "tactical-sourcing-autonomy.partial-recovery",
            "roleCardId": "sourcing-lead",
            "storyKey": "workblock.tactical-sourcing.story.partial-recovery.story"
          },
          {
            "completionKey": "workblock.tactical-sourcing.story.spot-buy-conversion.completion",
            "executionFlowIds": [
              "convert-repeat-spot-buys"
            ],
            "id": "tactical-sourcing-autonomy.spot-buy-conversion",
            "roleCardId": "sourcing-lead",
            "storyKey": "workblock.tactical-sourcing.story.spot-buy-conversion.story"
          }
        ],
        "labelKey": "workblock.tactical-sourcing.label",
        "metrics": [
          "Eligible and straight-through completed tactical case share",
          "False-eligibility and missed-exception rate",
          "Demand-to-request, request-to-response and response-to-commitment cycle",
          "Minimum-competition, participation and complete-response rate",
          "Award value versus baseline and policy",
          "Supplier fairness, protest and access-control incidents",
          "Duplicate, uncertain or unreconciled external-effect rate",
          "Requester outcome and downstream rework rate"
        ],
        "operatingModel": "Screen demand against tactical eligibility and authority, assemble an eligible supplier set, create and distribute a governed quote request, manage equal-information responses, normalize and evaluate quotes, conduct bounded negotiation when permitted, prepare and critic an award proposal, commit only inside the envelope, preserve last-good case state with dependency freshness, reconcile notifications and downstream records, make every permitted aggregate drill into case and external-effect records, and automatically stop or escalate any case that becomes novel or consequential.",
        "outcomeKey": "workblock.tactical-sourcing.outcome",
        "prerequisites": [
          "Qualified demand cases screened for tactical eligibility",
          "An approved supplier list for eligible quote requests",
          "Category, supplier, value and policy limits configured as authority envelopes",
          "Named sourcing leads for true exceptions",
          "Channels to distribute quote requests and receive supplier responses"
        ],
        "toolKey": "workblock.tactical-sourcing.tool",
        "version": "5.2.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Create intake records",
              "Extract and classify fields",
              "Link high-confidence source sets",
              "Request specifically missing evidence"
            ],
            "escalationTriggers": [
              "Conflicting executed versions",
              "Unresolvable party or contract identity",
              "Unreadable material schedule",
              "Privileged or unsupported document type"
            ],
            "id": "contract-intake-agent",
            "label": "Contract intake agent",
            "mission": "Establish a complete, source-anchored intake record and abstain when identity or evidence is insufficient.",
            "operatorRoleIds": [
              "sourcing-manager"
            ],
            "personaIds": [
              "contract-legal",
              "requester-persona"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "legal-counsel",
              "contract-manager",
              "sourcing-manager"
            ]
          },
          {
            "autonomousActions": [
              "Block unsupported fields",
              "Downgrade confidence",
              "Select sampled cases",
              "Demote a degraded extraction cohort"
            ],
            "escalationTriggers": [
              "False-ready threshold breached",
              "Source anchor mismatch",
              "Systemic parser drift",
              "Schema incompatibility"
            ],
            "id": "intake-critic-agent",
            "label": "Intake evidence critic",
            "mission": "Challenge completeness, provenance, identity and confidence before downstream readiness.",
            "operatorRoleIds": [
              "sourcing-manager"
            ],
            "personaIds": [
              "contract-legal",
              "platform-operator"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "legal-counsel",
              "contract-manager",
              "sourcing-manager"
            ]
          }
        ],
        "agentStoryKey": "workblock.contract-intake.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Conflicting signatures or executed versions",
            "Material unreadable schedules or missing source artifacts",
            "Ambiguous legal entity or agreement identity below threshold",
            "Unsupported privilege, language or document classification"
          ],
          "authorityEnvelope": [
            "May snapshot, classify, extract, index and create intake records for allow-listed document families",
            "May auto-link only above calibrated identity thresholds with no conflicting executed agreement",
            "May request missing evidence through approved templates",
            "Per-document-family kill switch and cohort demotion are mandatory"
          ],
          "humanSupervision": [
            "Own required-field and identity policies",
            "Review stratified samples and false-ready or false-link measures",
            "Resolve genuinely ambiguous hierarchy, privilege or identity cases",
            "Approve promotion by document family and language cohort"
          ],
          "rollback": [
            "Mark the intake superseded and restore the last-good extraction projection",
            "Remove or correct retrieval-index entries without deleting source snapshots",
            "Unlink an erroneous identity through an auditable split decision",
            "Demote the affected document cohort to draft or observe"
          ],
          "targetPosture": "policy_autonomous_with_monitoring"
        },
        "coreValue": "Turn every incoming agreement and attachment into a trusted, searchable contract intake with field-level evidence, identity resolution and an explicit path to review, without losing the source document or inventing missing terms.",
        "currentStateKey": "workblock.contract-intake.current-state",
        "dataMappings": [
          {
            "access": "read",
            "entityId": "contract-template",
            "purpose": "Use the exact effective template version and its approval provenance when classifying intake and establishing downstream drafting context."
          },
          {
            "access": "create",
            "entityId": "contract-intake",
            "purpose": "Create the canonical intake case and immutable source references."
          },
          {
            "access": "update",
            "entityId": "contract-intake",
            "purpose": "Commit identity resolution, calibrated extraction state and readiness."
          },
          {
            "access": "read",
            "entityId": "contract",
            "purpose": "Resolve candidate agreement identity and hierarchy without mutating the contract record."
          },
          {
            "access": "read",
            "entityId": "supplier-profile",
            "purpose": "Resolve extracted parties to canonical suppliers."
          },
          {
            "access": "read",
            "entityId": "contract-intake",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "contract-intake",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          }
        ],
        "descriptionKey": "workblock.contract-intake.description",
        "descriptorKey": "workblock.contract-intake.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "contract-lifecycle-management",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "contract-manager",
              "legal-counsel",
              "sourcing-manager",
              "obligation-owner",
              "category-manager"
            ],
            "id": "capture-intake",
            "jobIds": [
              "contract-intake-digitization.capture-once",
              "contract-intake-digitization.extract-with-citations",
              "contract-intake-digitization.resolve-agreement",
              "contract-intake-digitization.publish-or-except"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: source snapshot ref, content hash, contract intake id, and extraction request.",
                "Accepted and rejected inputs are counted, source-linked and assigned a freshness state; a failed refresh retains last-good data.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "legal-counsel",
                "contract-manager",
                "sourcing-manager"
              ]
            },
            "kind": "ingest",
            "label": "Capture intake",
            "trigger": "contract_source_received"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "contract-manager",
              "legal-counsel",
              "sourcing-manager",
              "obligation-owner",
              "category-manager"
            ],
            "id": "extract-and-resolve",
            "jobIds": [
              "contract-intake-digitization.capture-once",
              "contract-intake-digitization.extract-with-citations",
              "contract-intake-digitization.resolve-agreement",
              "contract-intake-digitization.publish-or-except"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: extracted fields, field evidence, document class, candidate contract id, candidate supplier id, identity confidence, evidence gaps, and readiness candidate.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "contract-manager",
                "legal-counsel",
                "sourcing-manager"
              ]
            },
            "kind": "analyse",
            "label": "Extract and resolve",
            "trigger": "extraction_request"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "contract-manager",
              "legal-counsel",
              "sourcing-manager",
              "obligation-owner",
              "category-manager"
            ],
            "id": "commit-readiness",
            "jobIds": [
              "contract-intake-digitization.capture-once",
              "contract-intake-digitization.extract-with-citations",
              "contract-intake-digitization.resolve-agreement",
              "contract-intake-digitization.publish-or-except"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: critic result, intake status, and intake ready event.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "contract-manager",
                "legal-counsel",
                "sourcing-manager"
              ]
            },
            "kind": "operate",
            "label": "Commit readiness",
            "trigger": "readiness_candidate"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "contract-manager",
              "legal-counsel",
              "sourcing-manager",
              "obligation-owner",
              "category-manager"
            ],
            "id": "read-intake",
            "jobIds": [
              "contract-intake-digitization.capture-once",
              "contract-intake-digitization.extract-with-citations",
              "contract-intake-digitization.resolve-agreement",
              "contract-intake-digitization.publish-or-except"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: intake view, source span view, and freshness view.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "contract-manager",
                "legal-counsel",
                "sourcing-manager"
              ]
            },
            "kind": "read",
            "label": "Read intake",
            "trigger": "ui_intake_query"
          }
        ],
        "futureStateKey": "workblock.contract-intake.future-state",
        "hiredInsteadKey": "workblock.contract-intake.hired-instead",
        "id": "contract-intake-digitization",
        "implementationStatus": "roadmap",
        "jobStatementKey": "workblock.contract-intake.job",
        "jobStories": [
          {
            "completionKey": "workblock.contract-intake.story.capture-once.completion",
            "executionFlowIds": [
              "capture-intake",
              "extract-and-resolve",
              "commit-readiness",
              "read-intake"
            ],
            "id": "contract-intake-digitization.capture-once",
            "roleCardId": "contract-manager",
            "storyKey": "workblock.contract-intake.story.capture-once.story"
          },
          {
            "completionKey": "workblock.contract-intake.story.extract-with-citations.completion",
            "executionFlowIds": [
              "capture-intake",
              "extract-and-resolve",
              "commit-readiness",
              "read-intake"
            ],
            "id": "contract-intake-digitization.extract-with-citations",
            "roleCardId": "legal-counsel",
            "storyKey": "workblock.contract-intake.story.extract-with-citations.story"
          },
          {
            "completionKey": "workblock.contract-intake.story.resolve-agreement.completion",
            "executionFlowIds": [
              "capture-intake",
              "extract-and-resolve",
              "commit-readiness",
              "read-intake"
            ],
            "id": "contract-intake-digitization.resolve-agreement",
            "roleCardId": "contract-manager",
            "storyKey": "workblock.contract-intake.story.resolve-agreement.story"
          },
          {
            "completionKey": "workblock.contract-intake.story.publish-or-except.completion",
            "executionFlowIds": [
              "capture-intake",
              "extract-and-resolve",
              "commit-readiness",
              "read-intake"
            ],
            "id": "contract-intake-digitization.publish-or-except",
            "roleCardId": "contract-manager",
            "storyKey": "workblock.contract-intake.story.publish-or-except.story"
          }
        ],
        "labelKey": "workblock.contract-intake.label",
        "metrics": [
          "Intake ready cycle time: median and 95th percentile received-at to ready",
          "Straight-through readiness rate: ready without human correction / eligible intakes",
          "Field citation validity: valid source anchors / extracted populated fields",
          "False-ready rate: downstream rejected incomplete intakes / intakes marked ready under policy",
          "Identity false-link rate: corrected links / links created under policy",
          "Stale intake rate: open intakes beyond source or processing freshness SLO",
          "Recovery success: failed runs reconciled without duplicate intake / failed runs"
        ],
        "officeCapabilities": [
          "composer"
        ],
        "operatingModel": "The Workblock owns contract-intake case state from source capture through extraction, duplicate resolution and readiness. Native files remain immutable in blob storage; structured intake lives in rowstore; retrieval indexes point back to exact source anchors; downstream authoring begins only from a committed readiness event.",
        "outcomeKey": "workblock.contract-intake.outcome",
        "prerequisites": [
          "Connections to the email, portal and signature channels where agreements arrive",
          "Immutable storage for native source documents",
          "Access to the canonical supplier record for party resolution",
          "Read access to the existing contract record and its hierarchy",
          "Approved contract templates with their approval provenance"
        ],
        "toolKey": "workblock.contract-intake.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Assemble draft versions",
              "Propose source-anchored redlines",
              "Classify deviations",
              "Update negotiation issue proposals"
            ],
            "escalationTriggers": [
              "No approved playbook position",
              "Material interdependent deviations",
              "Unsupported jurisdiction or agreement type",
              "Requested language changes legal effect beyond delegation"
            ],
            "id": "contract-drafting-agent",
            "label": "Contract drafting agent",
            "mission": "Produce complete policy-aligned contract proposals using only approved text, verified intake facts and narrow document tools.",
            "operatorRoleIds": [
              "sourcing-manager"
            ],
            "personaIds": [
              "contract-legal",
              "category-management-persona"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "contract-manager",
              "legal-counsel",
              "sourcing-manager"
            ]
          },
          {
            "autonomousActions": [
              "Reject unsupported proposals",
              "Flag inconsistent definitions",
              "Require missing schedules",
              "Demote a drafting cohort"
            ],
            "escalationTriggers": [
              "Possible fabricated term",
              "Contradictory obligations",
              "Critical forbidden language",
              "Evaluation drift"
            ],
            "id": "contract-review-critic",
            "label": "Contract review critic",
            "mission": "Challenge completeness, source support, playbook fidelity and unintended legal or commercial effects before a version can advance.",
            "operatorRoleIds": [
              "sourcing-manager"
            ],
            "personaIds": [
              "contract-legal",
              "platform-operator"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "contract-manager",
              "legal-counsel",
              "sourcing-manager"
            ]
          }
        ],
        "agentStoryKey": "workblock.contract-authoring.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Acceptance of material or novel legal risk",
            "Forbidden language or no approved position",
            "Waiver, indemnity, liability, termination or governing-law change outside explicit delegation",
            "Any signature, executed amendment or external legal communication beyond approved template"
          ],
          "authorityEnvelope": [
            "May assemble and store non-committed drafts from approved templates and clause positions",
            "May propose redlines and low-risk playbook-conforming fallbacks",
            "May commit only a new draft version, never legal acceptance or signature",
            "Document family, jurisdiction, clause class and risk tier are allow-listed with kill switches"
          ],
          "humanSupervision": [
            "Own playbook and approved-language versions",
            "Inspect sampled low-risk proposals and all material deviation decisions",
            "Review standing omission, unsupported-language and overturn metrics",
            "Promote or demote drafting cohorts"
          ],
          "rollback": [
            "Create a new version reverting accepted patches while retaining lineage",
            "Restore the last-good native artifact and retrieval index",
            "Invalidate stale proposals when content or policy changes",
            "Demote the affected agreement or clause cohort and pause patch tools"
          ],
          "targetPosture": "policy_autonomous_with_monitoring"
        },
        "coreValue": "Move an agreement from trusted intake to negotiable, policy-aligned language faster while keeping every machine draft visibly uncommitted, every deviation source-anchored and every accepted change bound to an immutable version.",
        "currentStateKey": "workblock.contract-authoring.current-state",
        "dataMappings": [
          {
            "access": "read",
            "entityId": "contract-intake",
            "purpose": "Use only ready, source-anchored intake facts as drafting inputs."
          },
          {
            "access": "create",
            "entityId": "contract-template",
            "purpose": "Create an immutable content-addressed template release after authority, applicability and artifact validation."
          },
          {
            "access": "read",
            "entityId": "contract-template",
            "purpose": "Read current and historical template versions with exact applicability, approval, artifact and freshness evidence."
          },
          {
            "access": "update",
            "entityId": "contract-template",
            "purpose": "Activate, supersede or retire a template release through an approval-bound expected-version transition without changing its immutable content."
          },
          {
            "access": "create",
            "entityId": "clause-library-entry",
            "purpose": "Create an immutable approved clause version with exact text, policy, applicability and authority provenance."
          },
          {
            "access": "read",
            "entityId": "clause-library-entry",
            "purpose": "Select only policy-valid clause versions and preserve exact text, applicability and provenance for drafting and review."
          },
          {
            "access": "update",
            "entityId": "clause-library-entry",
            "purpose": "Activate, supersede or retire a clause release through an approval-bound expected-version transition without changing its immutable text."
          },
          {
            "access": "append",
            "entityId": "business-event",
            "purpose": "Submit an append-only owner command to audit-event-service for each reconciled contract-template or clause-library-entry changed-record event, including the exact subject version, authority and idempotency evidence."
          },
          {
            "access": "read",
            "entityId": "contract",
            "purpose": "Load canonical agreement identity and hierarchy."
          },
          {
            "access": "create",
            "entityId": "contract-version",
            "purpose": "Commit every draft or accepted change as an immutable, content-addressed version."
          },
          {
            "access": "read",
            "entityId": "contract-version",
            "purpose": "Compare exact versions and bind analysis to unchanged content."
          },
          {
            "access": "create",
            "entityId": "clause-deviation",
            "purpose": "Create typed, source-anchored deviation proposals."
          },
          {
            "access": "update",
            "entityId": "clause-deviation",
            "purpose": "Record the committed disposition without rewriting the original proposal evidence."
          },
          {
            "access": "read",
            "entityId": "party",
            "purpose": "Read the policy-filtered canonical party projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "person",
            "purpose": "Read the policy-filtered canonical person projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "source-record-reference",
            "purpose": "Read the policy-filtered canonical source record reference projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "evidence-item",
            "purpose": "Read the policy-filtered canonical evidence item projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "policy",
            "purpose": "Read the policy-filtered canonical policy projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "policy-version",
            "purpose": "Read the policy-filtered canonical policy version projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "authority-envelope",
            "purpose": "Read the policy-filtered canonical authority envelope projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "action-proposal",
            "purpose": "Read the policy-filtered canonical action proposal projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "committed-action",
            "purpose": "Read the policy-filtered canonical committed action projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "decision",
            "purpose": "Read the policy-filtered canonical decision projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "exception",
            "purpose": "Read the policy-filtered canonical exception case projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "audit-event",
            "purpose": "Read the policy-filtered canonical audit event projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "learning-example",
            "purpose": "Read the policy-filtered canonical learning example projection from learning-evaluation-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "evaluation-result",
            "purpose": "Read the policy-filtered canonical evaluation result projection from learning-evaluation-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "integration-state",
            "purpose": "Read the policy-filtered canonical integration state projection from integration-state-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "registry-release",
            "purpose": "Read the policy-filtered canonical registry release projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "clause-deviation",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "contract-version",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "contract-template",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "clause-library-entry",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "clause-deviation",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          }
        ],
        "descriptionKey": "workblock.contract-authoring.description",
        "descriptorKey": "workblock.contract-authoring.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "contract-lifecycle-management",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "contract-manager",
              "legal-counsel",
              "sourcing-manager",
              "obligation-owner",
              "category-manager"
            ],
            "id": "assemble-draft",
            "jobIds": [
              "contract-authoring-review.start-with-context",
              "contract-authoring-review.third-party-paper",
              "contract-authoring-review.commercial-position",
              "contract-authoring-review.version-integrity"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The drafting-context, playbook-version, template-ref, draft-artifact-ref and contract-version-id identify one immutable reviewable version; the review-request names each open question and owner.",
                "The draft and patch set remain proposals until their material positions are accepted under the applicable authority.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "contract-manager",
                "legal-counsel",
                "sourcing-manager"
              ]
            },
            "kind": "operate",
            "label": "Assemble draft",
            "trigger": "intake_ready_event"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "contract-manager",
              "legal-counsel",
              "sourcing-manager",
              "obligation-owner",
              "category-manager"
            ],
            "id": "analyse-deviations",
            "jobIds": [
              "contract-authoring-review.start-with-context",
              "contract-authoring-review.third-party-paper",
              "contract-authoring-review.commercial-position",
              "contract-authoring-review.version-integrity"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Clause-anchors, deviation-candidates, playbook-evidence, integrity-findings and the review-proposal link every finding to its source span, applicable playbook version and materiality; unreadable or missing scopes remain explicit.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "legal-counsel",
                "contract-manager",
                "sourcing-manager"
              ]
            },
            "kind": "analyse",
            "label": "Analyse deviations",
            "trigger": "review_request"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "contract-manager",
              "legal-counsel",
              "sourcing-manager",
              "obligation-owner",
              "category-manager"
            ],
            "id": "resolve-review",
            "jobIds": [
              "contract-authoring-review.start-with-context",
              "contract-authoring-review.third-party-paper",
              "contract-authoring-review.commercial-position",
              "contract-authoring-review.version-integrity"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The critic-result and deviation-ids retain each disposition and its authority; the next-contract-version-id contains only accepted patches and the approval-ready-event identifies approvals that remain valid or must reopen.",
                "The exact proposal version, authorised reviewer or policy authority, decision and reason are durable before any commitment.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "contract-manager",
                "legal-counsel",
                "sourcing-manager"
              ]
            },
            "kind": "review",
            "label": "Resolve review",
            "trigger": "review_proposal"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "contract-manager",
              "legal-counsel",
              "sourcing-manager",
              "obligation-owner",
              "category-manager"
            ],
            "id": "read-contract-workspace",
            "jobIds": [
              "contract-authoring-review.start-with-context",
              "contract-authoring-review.third-party-paper",
              "contract-authoring-review.commercial-position",
              "contract-authoring-review.version-integrity"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The version-tree, deviation-queue, source-diff and freshness-view identify the current or clearly stale last-good version and open every material item to its source, decision and authority.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "contract-manager",
                "legal-counsel",
                "sourcing-manager"
              ]
            },
            "kind": "read",
            "label": "Read contract workspace",
            "trigger": "ui_contract_query"
          }
        ],
        "futureStateKey": "workblock.contract-authoring.future-state",
        "hiredInsteadKey": "workblock.contract-authoring.hired-instead",
        "id": "contract-authoring-review",
        "implementationStatus": "reference",
        "jobStatementKey": "workblock.contract-authoring.job",
        "jobStories": [
          {
            "completionKey": "workblock.contract-authoring.story.start-with-context.completion",
            "executionFlowIds": [
              "assemble-draft",
              "analyse-deviations",
              "resolve-review",
              "read-contract-workspace"
            ],
            "id": "contract-authoring-review.start-with-context",
            "roleCardId": "sourcing-manager",
            "storyKey": "workblock.contract-authoring.story.start-with-context.story"
          },
          {
            "completionKey": "workblock.contract-authoring.story.third-party-paper.completion",
            "executionFlowIds": [
              "assemble-draft",
              "analyse-deviations",
              "resolve-review",
              "read-contract-workspace"
            ],
            "id": "contract-authoring-review.third-party-paper",
            "roleCardId": "legal-counsel",
            "storyKey": "workblock.contract-authoring.story.third-party-paper.story"
          },
          {
            "completionKey": "workblock.contract-authoring.story.commercial-position.completion",
            "executionFlowIds": [
              "assemble-draft",
              "analyse-deviations",
              "resolve-review",
              "read-contract-workspace"
            ],
            "id": "contract-authoring-review.commercial-position",
            "roleCardId": "sourcing-manager",
            "storyKey": "workblock.contract-authoring.story.commercial-position.story"
          },
          {
            "completionKey": "workblock.contract-authoring.story.version-integrity.completion",
            "executionFlowIds": [
              "assemble-draft",
              "analyse-deviations",
              "resolve-review",
              "read-contract-workspace"
            ],
            "id": "contract-authoring-review.version-integrity",
            "roleCardId": "sourcing-manager",
            "storyKey": "workblock.contract-authoring.story.version-integrity.story"
          }
        ],
        "labelKey": "workblock.contract-authoring.label",
        "metrics": [
          "Draft cycle time: intake-ready to first complete draft",
          "Deviation recall: validated material deviations detected / validated material deviations",
          "Unsupported-language rate: unsupported proposed clauses / proposed clauses",
          "Proposal acceptance rate and median reviewer edit distance",
          "Material reviewer overturn rate by clause cohort",
          "Native artifact fidelity pass rate",
          "Stale proposal rate after content or playbook change"
        ],
        "officeCapabilities": [
          "composer"
        ],
        "operatingModel": "The Workblock owns immutable contract versions and clause-deviation state. It assembles approved templates and positions, compares text against a versioned playbook, proposes redlines in the native document round trip and hands exact content hashes, rather than mutable files, to approval orchestration.",
        "outcomeKey": "workblock.contract-authoring.outcome",
        "prerequisites": [
          "Contract templates and clause standards agreed and versioned",
          "A versioned negotiation playbook with approved positions and fallbacks",
          "Source-anchored contract intake records as drafting inputs",
          "Read access to canonical party and person records",
          "Named reviewers with authority over deviation decisions"
        ],
        "toolKey": "workblock.contract-authoring.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Derive routes",
              "Request approvals",
              "Send bounded reminders",
              "Reconcile signatures",
              "Publish repository metadata after all controls pass"
            ],
            "escalationTriggers": [
              "Authority conflict",
              "Content hash changed",
              "Signer identity mismatch",
              "Material approval rejected or signature disputed"
            ],
            "id": "contract-approval-agent",
            "label": "Contract approval agent",
            "mission": "Build the correct authority route, maintain content-hash validity and execute only explicitly authorised approval and signature steps.",
            "operatorRoleIds": [
              "sourcing-manager"
            ],
            "personaIds": [
              "contract-legal",
              "category-management-persona",
              "finance"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "contract-manager",
              "legal-counsel",
              "sourcing-manager"
            ]
          },
          {
            "autonomousActions": [
              "Block activation",
              "Expire stale approvals",
              "Quarantine orphan artifacts",
              "Demote a failing integration cohort"
            ],
            "escalationTriggers": [
              "Executed artifact hash mismatch",
              "Missing required authority",
              "Unreconciled signature state",
              "Repository integrity breach"
            ],
            "id": "execution-critic-agent",
            "label": "Contract execution critic",
            "mission": "Independently prove that content, authority, signatures, metadata and downstream state agree before activation.",
            "operatorRoleIds": [
              "sourcing-manager"
            ],
            "personaIds": [
              "contract-legal",
              "platform-operator"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "contract-manager",
              "legal-counsel",
              "sourcing-manager"
            ]
          }
        ],
        "agentStoryKey": "workblock.contract-repository.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Any signature authorisation or material agreement approval not already supplied as a valid decision",
            "Authority conflict, delegation ambiguity or separation-of-duty failure",
            "Executed artifact or signature-receipt dispute",
            "Termination, waiver or non-standard execution ceremony"
          ],
          "authorityEnvelope": [
            "May derive approval routes, create requests, issue reminders and reconcile decisions autonomously",
            "May create a signature envelope only from a specific valid signature-authorisation decision",
            "May activate only when independent content, authority, signature and metadata checks pass",
            "Per-action signature and repository kill switches plus idempotency keys are mandatory"
          ],
          "humanSupervision": [
            "Own authority, signature and retention policies",
            "Make material legal, commercial, budget and signature-authorisation decisions",
            "Inspect sampled routing quality and all integrity exceptions",
            "Review integration and autonomous activation SLOs"
          ],
          "rollback": [
            "Void an uncompleted signature envelope and expire bound approvals",
            "Quarantine mismatched executed artifacts without deleting evidence",
            "Compensate repository metadata and restore last-good lifecycle header",
            "Publish corrective supersession or deactivation events; executed signatures are never falsely described as reversible"
          ],
          "targetPosture": "policy_autonomous_with_monitoring"
        },
        "coreValue": "Convert an approved contract version into a verifiable executed agreement and durable repository record, with the exact content, authority, signature and hierarchy reconciled end to end.",
        "currentStateKey": "workblock.contract-repository.current-state",
        "dataMappings": [
          {
            "access": "read",
            "entityId": "contract-template",
            "purpose": "Verify the executed agreement's template lineage, approval and exact source artifact before repository activation."
          },
          {
            "access": "create",
            "entityId": "contract",
            "purpose": "Establish canonical agreement identity and hierarchy when execution creates a new contract."
          },
          {
            "access": "update",
            "entityId": "contract",
            "purpose": "Activate and maintain the canonical lifecycle header after verified execution or change."
          },
          {
            "access": "read",
            "entityId": "contract-version",
            "purpose": "Bind all decisions and signatures to unchanged text."
          },
          {
            "access": "read",
            "entityId": "clause-deviation",
            "purpose": "Derive required authority from committed deviation dispositions."
          },
          {
            "access": "create",
            "entityId": "contract-approval",
            "purpose": "Create content-bound approval and signature ceremony records."
          },
          {
            "access": "update",
            "entityId": "contract-approval",
            "purpose": "Update the canonical approval or signature state by expected record version while preserving each authority transition as a separate immutable audit event."
          },
          {
            "access": "append",
            "entityId": "audit-event",
            "purpose": "Submit a typed owner command to audit-event-service to submit an immutable, content-bound approval or signature authority transition to the owning audit service and reconcile its receipt."
          },
          {
            "access": "read",
            "entityId": "audit-event",
            "purpose": "Read the policy-filtered canonical audit event projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "contract-compliance-finding",
            "purpose": "Read the governed contract compliance finding contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "contract",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "contract-approval",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "contract",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "contract-approval",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          }
        ],
        "descriptionKey": "workblock.contract-repository.description",
        "descriptorKey": "workblock.contract-repository.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "contract-lifecycle-management",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "contract-manager",
              "legal-counsel",
              "sourcing-manager",
              "obligation-owner",
              "category-manager"
            ],
            "id": "plan-approval",
            "jobIds": [
              "contract-approval-repository.derive-approval-route",
              "contract-approval-repository.protect-approved-content",
              "contract-approval-repository.execute-once",
              "contract-approval-repository.reconcile-repository"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: execution context, content hash, approval plan, authority requirements, approval ids, and approval wait.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "contract-manager",
                "legal-counsel",
                "sourcing-manager"
              ]
            },
            "kind": "analyse",
            "label": "Plan approval",
            "trigger": "approval_ready_event"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "contract-manager",
              "legal-counsel",
              "sourcing-manager",
              "obligation-owner",
              "category-manager"
            ],
            "id": "await-and-sign",
            "jobIds": [
              "contract-approval-repository.derive-approval-route",
              "contract-approval-repository.protect-approved-content",
              "contract-approval-repository.execute-once",
              "contract-approval-repository.reconcile-repository"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: approval state, signature authorisation, signature envelope id, signature wait, signature receipt ref, and executed artifact ref.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "contract-manager",
                "legal-counsel",
                "sourcing-manager"
              ]
            },
            "kind": "operate",
            "label": "Await and sign",
            "trigger": "approval_wait"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "contract-manager",
              "legal-counsel",
              "sourcing-manager",
              "obligation-owner",
              "category-manager"
            ],
            "id": "activate-contract",
            "jobIds": [
              "contract-approval-repository.derive-approval-route",
              "contract-approval-repository.protect-approved-content",
              "contract-approval-repository.execute-once",
              "contract-approval-repository.reconcile-repository"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: execution critic result, contract id, executed contract version id, contract executed event, and writeback receipts.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "contract-manager",
                "legal-counsel",
                "sourcing-manager"
              ]
            },
            "kind": "operate",
            "label": "Activate contract",
            "trigger": "executed_artifact_ref"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "contract-manager",
              "legal-counsel",
              "sourcing-manager",
              "obligation-owner",
              "category-manager"
            ],
            "id": "read-repository",
            "jobIds": [
              "contract-approval-repository.derive-approval-route",
              "contract-approval-repository.protect-approved-content",
              "contract-approval-repository.execute-once",
              "contract-approval-repository.reconcile-repository"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: contract header, version approval timeline, contract hierarchy, and freshness view.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "contract-manager",
                "legal-counsel",
                "sourcing-manager"
              ]
            },
            "kind": "read",
            "label": "Read repository",
            "trigger": "ui_contract_repository_query"
          }
        ],
        "futureStateKey": "workblock.contract-repository.future-state",
        "hiredInsteadKey": "workblock.contract-repository.hired-instead",
        "id": "contract-approval-repository",
        "implementationStatus": "roadmap",
        "jobStatementKey": "workblock.contract-repository.job",
        "jobStories": [
          {
            "completionKey": "workblock.contract-repository.story.derive-approval-route.completion",
            "executionFlowIds": [
              "plan-approval",
              "await-and-sign",
              "activate-contract",
              "read-repository"
            ],
            "id": "contract-approval-repository.derive-approval-route",
            "roleCardId": "contract-manager",
            "storyKey": "workblock.contract-repository.story.derive-approval-route.story"
          },
          {
            "completionKey": "workblock.contract-repository.story.protect-approved-content.completion",
            "executionFlowIds": [
              "plan-approval",
              "await-and-sign",
              "activate-contract",
              "read-repository"
            ],
            "id": "contract-approval-repository.protect-approved-content",
            "roleCardId": "legal-counsel",
            "storyKey": "workblock.contract-repository.story.protect-approved-content.story"
          },
          {
            "completionKey": "workblock.contract-repository.story.execute-once.completion",
            "executionFlowIds": [
              "plan-approval",
              "await-and-sign",
              "activate-contract",
              "read-repository"
            ],
            "id": "contract-approval-repository.execute-once",
            "roleCardId": "sourcing-manager",
            "storyKey": "workblock.contract-repository.story.execute-once.story"
          },
          {
            "completionKey": "workblock.contract-repository.story.reconcile-repository.completion",
            "executionFlowIds": [
              "plan-approval",
              "await-and-sign",
              "activate-contract",
              "read-repository"
            ],
            "id": "contract-approval-repository.reconcile-repository",
            "roleCardId": "contract-manager",
            "storyKey": "workblock.contract-repository.story.reconcile-repository.story"
          }
        ],
        "labelKey": "workblock.contract-repository.label",
        "metrics": [
          "Approval cycle time: approval-ready to complete required decision set",
          "Signature cycle time: authorisation to reconciled execution",
          "Route correction rate: human-added or removed steps / routed cases",
          "Content-hash violation count; target zero",
          "Duplicate commitment count; target zero",
          "Repository completeness: executed contracts with artifact, receipt, metadata and hierarchy / executed contracts",
          "Unreconciled external state age and last-good freshness"
        ],
        "officeCapabilities": [
          "composer"
        ],
        "operatingModel": "The Workblock owns canonical contract identity, lifecycle header and approval records. It derives the required authority route from exact version facts, keeps proposals distinct from decisions, orchestrates approved signature ceremonies, reconciles downstream receipts and publishes one authoritative executed version for obligations and buying.",
        "outcomeKey": "workblock.contract-repository.outcome",
        "prerequisites": [
          "An electronic-signature service for execution ceremonies",
          "A contract repository for executed agreements and their metadata",
          "Signature authority and delegation rules mapped to named people",
          "Immutable contract versions bound to exact content hashes",
          "An append-only audit store for approval and signature events"
        ],
        "toolKey": "workblock.contract-repository.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Calculate due dates",
              "Request evidence",
              "Send reminders",
              "Mark deterministic fulfilment linked to accepted records",
              "Open exception proposals"
            ],
            "escalationTriggers": [
              "Potential breach",
              "Conflicting evidence",
              "Owner absent beyond policy",
              "High-consequence or irreversible duty"
            ],
            "id": "obligation-owner-agent",
            "label": "Obligation owner agent",
            "mission": "Keep assigned duties current, collect required evidence and complete routine follow-through within contract and policy bounds.",
            "operatorRoleIds": [
              "sourcing-manager"
            ],
            "personaIds": [
              "category-management-persona",
              "supplier-relationship-manager"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "obligation-owner",
              "contract-manager",
              "sourcing-manager"
            ]
          },
          {
            "autonomousActions": [
              "Detect triggers",
              "Calculate proposed value",
              "Prepare claim packages",
              "Track expected recovery"
            ],
            "escalationTriggers": [
              "Disputed interpretation",
              "Waiver or expiry decision",
              "Material claim communication",
              "Value or evidence outside threshold"
            ],
            "id": "entitlement-agent",
            "label": "Entitlement realisation agent",
            "mission": "Detect exercisable rights and pursue recovery linked to exact clauses and performance records without waiving or asserting disputed rights autonomously.",
            "operatorRoleIds": [
              "sourcing-manager"
            ],
            "personaIds": [
              "contract-legal",
              "finance",
              "category-management-persona"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "obligation-owner",
              "contract-manager",
              "sourcing-manager"
            ]
          }
        ],
        "agentStoryKey": "workblock.obligation.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Waiver, extension, breach acceptance or disputed interpretation",
            "Material claim, termination right or external legal notice",
            "Critical obligation overdue or evidence conflict",
            "Mission needs a tool, recipient, value or time horizon outside the grant"
          ],
          "authorityEnvelope": [
            "Mission is limited to keeping listed obligations and entitlements current within a contract, time horizon and action budget",
            "May request evidence, send approved communications, calculate state and commit deterministic routine fulfilment",
            "May prepare but not assert material claims, waive rights, accept breach or interpret novel legal language",
            "Per-contract, obligation-class and tool kill switches plus stop conditions are mandatory"
          ],
          "humanSupervision": [
            "Own extraction, due, evidence and escalation policies",
            "Inspect stratified samples and missed-obligation audits",
            "Decide waivers, breaches, disputes and material claims",
            "Review mission performance, harm and recovery outcomes"
          ],
          "rollback": [
            "Cancel future timers and reminders",
            "Correct state through append-only supersession while retaining prior evidence",
            "Withdraw an uncommitted claim draft or follow-up",
            "Use explicit compensating communication where a message was incorrect; legal notices and realized claims require escalation",
            "Demote the mission or obligation cohort"
          ],
          "targetPosture": "mission_autonomous_with_supervision"
        },
        "coreValue": "Continuously turn executed contract language into owned duties and rights linked to exact source clauses so teams fulfil what they owe, exercise what they are entitled to and intervene before value or compliance is lost.",
        "currentStateKey": "workblock.obligation.current-state",
        "dataMappings": [
          {
            "access": "read",
            "entityId": "clause-library-entry",
            "purpose": "Resolve exact approved clause meaning and semantic tags when establishing source-anchored obligations and entitlements."
          },
          {
            "access": "read",
            "entityId": "contract",
            "purpose": "Select active agreements and governing versions."
          },
          {
            "access": "read",
            "entityId": "contract-version",
            "purpose": "Extract obligations and rights from exact executed language."
          },
          {
            "access": "read",
            "entityId": "contract-approval",
            "purpose": "Prove the source version is validly executed before monitoring."
          },
          {
            "access": "create",
            "entityId": "contract-obligation",
            "purpose": "Establish source-anchored duty records and their monitoring contracts."
          },
          {
            "access": "update",
            "entityId": "contract-obligation",
            "purpose": "Commit current due, evidence and fulfilment state."
          },
          {
            "access": "create",
            "entityId": "contract-entitlement",
            "purpose": "Establish exercisable right records."
          },
          {
            "access": "update",
            "entityId": "contract-entitlement",
            "purpose": "Track trigger, claim and realized recovery state."
          },
          {
            "access": "read",
            "entityId": "business-event",
            "purpose": "Read the policy-filtered canonical business event projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "contract-change",
            "purpose": "Read the governed contract change contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "contract-obligation",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "contract-entitlement",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "contract-obligation",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "contract-entitlement",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          }
        ],
        "descriptionKey": "workblock.obligation.description",
        "descriptorKey": "workblock.obligation.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "contract-lifecycle-management",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "contract-manager",
              "legal-counsel",
              "sourcing-manager",
              "obligation-owner",
              "category-manager"
            ],
            "id": "establish-register",
            "jobIds": [
              "obligation-monitoring.validate-extraction",
              "obligation-monitoring.accept-ownership",
              "obligation-monitoring.notice-window",
              "obligation-monitoring.evidence-closure",
              "obligation-monitoring.amendment-impact"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: executed terms, source anchors, obligation candidates, entitlement candidates, register critic result, obligation ids, entitlement ids, and monitoring plan.",
                "Accepted and rejected inputs are counted, source-linked and assigned a freshness state; a failed refresh retains last-good data.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "obligation-owner",
                "contract-manager",
                "sourcing-manager"
              ]
            },
            "kind": "ingest",
            "label": "Establish register",
            "trigger": "contract_executed_event"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "contract-manager",
              "legal-counsel",
              "sourcing-manager",
              "obligation-owner",
              "category-manager"
            ],
            "id": "monitor-commitments",
            "jobIds": [
              "obligation-monitoring.validate-extraction",
              "obligation-monitoring.accept-ownership",
              "obligation-monitoring.notice-window",
              "obligation-monitoring.evidence-closure",
              "obligation-monitoring.amendment-impact"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: trigger evidence, evidence freshness, obligation state candidates, entitlement state candidates, and action candidates.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "obligation-owner",
                "contract-manager",
                "sourcing-manager"
              ]
            },
            "kind": "monitor",
            "label": "Monitor commitments",
            "trigger": "monitoring_plan"
          },
          {
            "agentIds": [
              "obligation-owner-agent",
              "entitlement-agent"
            ],
            "escalationRoleIds": [
              "contract-manager",
              "legal-counsel",
              "sourcing-manager",
              "obligation-owner",
              "category-manager"
            ],
            "id": "pursue-outcomes",
            "jobIds": [
              "obligation-monitoring.validate-extraction",
              "obligation-monitoring.accept-ownership",
              "obligation-monitoring.notice-window",
              "obligation-monitoring.evidence-closure",
              "obligation-monitoring.amendment-impact"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: action critic result, action receipts, exception proposals, committed obligation state, committed entitlement state, and next monitoring plan.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "obligation-owner",
                "contract-manager",
                "sourcing-manager"
              ]
            },
            "kind": "agent",
            "label": "Pursue outcomes",
            "trigger": "action_candidates"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "contract-manager",
              "legal-counsel",
              "sourcing-manager",
              "obligation-owner",
              "category-manager"
            ],
            "id": "read-commitments",
            "jobIds": [
              "obligation-monitoring.validate-extraction",
              "obligation-monitoring.accept-ownership",
              "obligation-monitoring.notice-window",
              "obligation-monitoring.evidence-closure",
              "obligation-monitoring.amendment-impact"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: owned commitments, source evidence view, portfolio metrics, and freshness view.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "obligation-owner",
                "contract-manager",
                "sourcing-manager"
              ]
            },
            "kind": "read",
            "label": "Read commitments",
            "trigger": "ui_commitment_query"
          }
        ],
        "futureStateKey": "workblock.obligation.future-state",
        "hiredInsteadKey": "workblock.obligation.hired-instead",
        "id": "obligation-monitoring",
        "implementationStatus": "pattern",
        "jobStatementKey": "workblock.obligation.job",
        "jobStories": [
          {
            "completionKey": "workblock.obligation.story.validate-extraction.completion",
            "executionFlowIds": [
              "establish-register",
              "monitor-commitments",
              "pursue-outcomes",
              "read-commitments"
            ],
            "id": "obligation-monitoring.validate-extraction",
            "roleCardId": "contract-manager",
            "storyKey": "workblock.obligation.story.validate-extraction.story"
          },
          {
            "completionKey": "workblock.obligation.story.accept-ownership.completion",
            "executionFlowIds": [
              "establish-register",
              "monitor-commitments",
              "pursue-outcomes",
              "read-commitments"
            ],
            "id": "obligation-monitoring.accept-ownership",
            "roleCardId": "obligation-owner",
            "storyKey": "workblock.obligation.story.accept-ownership.story"
          },
          {
            "completionKey": "workblock.obligation.story.notice-window.completion",
            "executionFlowIds": [
              "establish-register",
              "monitor-commitments",
              "pursue-outcomes",
              "read-commitments"
            ],
            "id": "obligation-monitoring.notice-window",
            "roleCardId": "legal-counsel",
            "storyKey": "workblock.obligation.story.notice-window.story"
          },
          {
            "completionKey": "workblock.obligation.story.evidence-closure.completion",
            "executionFlowIds": [
              "establish-register",
              "monitor-commitments",
              "pursue-outcomes",
              "read-commitments"
            ],
            "id": "obligation-monitoring.evidence-closure",
            "roleCardId": "obligation-owner",
            "storyKey": "workblock.obligation.story.evidence-closure.story"
          },
          {
            "completionKey": "workblock.obligation.story.amendment-impact.completion",
            "executionFlowIds": [
              "establish-register",
              "monitor-commitments",
              "pursue-outcomes",
              "read-commitments"
            ],
            "id": "obligation-monitoring.amendment-impact",
            "roleCardId": "contract-manager",
            "storyKey": "workblock.obligation.story.amendment-impact.story"
          }
        ],
        "labelKey": "workblock.obligation.label",
        "metrics": [
          "On-time fulfilment: obligations fulfilled by due-at / obligations due",
          "Critical missed-obligation count; target zero",
          "Evidence completeness: active obligations with current required evidence / active obligations",
          "False-fulfilment and false-alert rates from sampled review",
          "Entitlement realisation: realized value / validated available value",
          "Median days of advance warning before material due date",
          "Mission intervention effectiveness: cases resolved after action / eligible actions",
          "Stale monitoring coverage by source and contract"
        ],
        "officeCapabilities": [
          "composer"
        ],
        "operatingModel": "The Workblock owns obligation and entitlement records from executed-version extraction through recurrence, evidence collection, fulfilment, claim and breach. It monitors events and calendars durably, preserves last-good calculations and delegates only high-consequence waivers, disputes or legal interpretations.",
        "outcomeKey": "workblock.obligation.outcome",
        "prerequisites": [
          "Executed contract versions with source-anchored language",
          "Execution evidence from the contract approval record",
          "Named owners for each obligation class and escalation decision",
          "Business calendars and event feeds for due-date and trigger monitoring",
          "Approved templates for evidence requests and reminders"
        ],
        "toolKey": "workblock.obligation.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Open decision cases",
              "Collect evidence",
              "Prepare option proposals",
              "Start approved child runs",
              "Reconcile resulting versions"
            ],
            "escalationTriggers": [
              "Renewal, termination, waiver or legal notice decision",
              "Continuity or critical supplier risk",
              "Late or missed contractual window",
              "Conflicting rights or executed versions"
            ],
            "id": "contract-change-agent",
            "label": "Contract change agent",
            "mission": "Keep decision windows current, prepare options linked to current terms and performance records, and coordinate an authorised change through completion.",
            "operatorRoleIds": [
              "sourcing-manager"
            ],
            "personaIds": [
              "contract-legal",
              "category-management-persona",
              "supplier-relationship-manager"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "contract-manager",
              "obligation-owner",
              "sourcing-manager",
              "legal-counsel"
            ]
          },
          {
            "autonomousActions": [
              "Monitor allow-listed variance classes",
              "Create and enrich findings",
              "Close deterministic false positives",
              "Prepare routine recovery evidence"
            ],
            "escalationTriggers": [
              "Potential breach or dispute",
              "Material financial impact",
              "Uncertain term interpretation",
              "Irreversible external action"
            ],
            "id": "contract-compliance-agent",
            "label": "Contract compliance agent",
            "mission": "Detect, explain and route material variances without treating weak or stale evidence as breach.",
            "operatorRoleIds": [
              "sourcing-manager"
            ],
            "personaIds": [
              "category-management-persona",
              "finance",
              "contract-legal"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "contract-manager",
              "obligation-owner",
              "sourcing-manager",
              "legal-counsel"
            ]
          }
        ],
        "agentStoryKey": "workblock.renewal-compliance.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Renewal, termination, waiver, amendment acceptance or legal notice commitment",
            "Potential breach, dispute or material recovery claim",
            "Critical continuity or third-party risk",
            "Uncertain governing term, stale critical evidence or missed deadline"
          ],
          "authorityEnvelope": [
            "May monitor decision windows and allow-listed compliance comparisons autonomously",
            "May open cases, collect evidence and prepare options or recovery proposals",
            "May execute only low-risk administrative steps after an explicit decision and within child-run grants",
            "Per-action notice, amendment, termination and writeback kill switches are mandatory"
          ],
          "humanSupervision": [
            "Own renewal, compliance, materiality and recovery policies",
            "Decide material renewals, amendments, waivers, notices, terminations and accepted risk",
            "Inspect sampled clean cases, missed findings and outcome metrics",
            "Promote monitoring and administrative action classes separately"
          ],
          "rollback": [
            "Withdraw uncommitted options and findings superseded by new evidence",
            "Cancel unstarted child runs and future administrative actions",
            "Restore last-good case projection and compensate reversible metadata writebacks",
            "Executed amendments, notices or terminations require explicit corrective legal action rather than a false rollback",
            "Demote the affected monitor or action class"
          ],
          "targetPosture": "policy_autonomous_with_monitoring"
        },
        "coreValue": "Surface renewal, amendment, notice, termination and compliance choices early, quantify their consequences and carry an authorised decision through to a reconciled contractual and operational outcome.",
        "currentStateKey": "workblock.renewal-compliance.current-state",
        "dataMappings": [
          {
            "access": "read",
            "entityId": "clause-library-entry",
            "purpose": "Compare governing terms with the exact approved clause position and applicability contract when opening change or compliance cases."
          },
          {
            "access": "read",
            "entityId": "contract",
            "purpose": "Monitor active agreements and decision windows."
          },
          {
            "access": "read",
            "entityId": "contract-version",
            "purpose": "Ground option and compliance analysis in exact governing terms."
          },
          {
            "access": "read",
            "entityId": "contract-obligation",
            "purpose": "Include duties and notice milestones in change and compliance analysis."
          },
          {
            "access": "read",
            "entityId": "contract-entitlement",
            "purpose": "Include available rights and recovery in option analysis."
          },
          {
            "access": "create",
            "entityId": "contract-change",
            "purpose": "Create governed renewal, amendment, notice, waiver or termination cases."
          },
          {
            "access": "update",
            "entityId": "contract-change",
            "purpose": "Track decision, execution and resulting immutable version."
          },
          {
            "access": "read",
            "entityId": "contract-change",
            "purpose": "Read back the complete committed contract change with authority, freshness and provenance for reconciliation and record drill-through."
          },
          {
            "access": "create",
            "entityId": "contract-compliance-finding",
            "purpose": "Create term-to-actual variance cases linked to their contract and observed records."
          },
          {
            "access": "update",
            "entityId": "contract-compliance-finding",
            "purpose": "Commit materiality, remediation and resolved outcome state."
          },
          {
            "access": "read",
            "entityId": "contract-compliance-finding",
            "purpose": "Read back the complete committed contract compliance finding with authority, freshness and provenance for reconciliation and record drill-through."
          },
          {
            "access": "read",
            "entityId": "contract-change",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "contract-compliance-finding",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "action-proposal",
            "purpose": "Point-read the exact permission-safe D7 handoff action-proposal record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "decision",
            "purpose": "Point-read the exact permission-safe D7 handoff decision record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "committed-action",
            "purpose": "Point-read the exact permission-safe D7 handoff committed-action record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "business-event",
            "purpose": "Point-read the exact permission-safe D7 handoff business-event record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "create",
            "entityId": "decision",
            "purpose": "Submit the authorised, version-pinned D7 receiving-owner acceptance, rejection, redirect, expiry or reopen decision to shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "committed-action",
            "purpose": "Append each authorised D7 delivery or receiver-owned command attempt with idempotency, safe-retry and reconciliation state through shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "business-event",
            "purpose": "Append immutable D7 delivery, acknowledgement, rejection, reconciliation, replay or reopen facts through audit-event-service; an event never becomes current domain state."
          },
          {
            "access": "read",
            "entityId": "supplier-innovation-case",
            "purpose": "Read the exact D7 innovation source record/version addressed to this owner."
          }
        ],
        "descriptionKey": "workblock.renewal-compliance.description",
        "descriptorKey": "workblock.renewal-compliance.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "contract-lifecycle-management",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "contract-manager",
              "legal-counsel",
              "sourcing-manager",
              "obligation-owner",
              "category-manager"
            ],
            "id": "detect-window-or-variance",
            "jobIds": [
              "renewal-change-compliance.decision-window",
              "renewal-change-compliance.compare-paths",
              "renewal-change-compliance.detect-variance",
              "renewal-change-compliance.execute-lifecycle-path"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: contract evidence, evidence freshness, decision window candidates, compliance finding candidates, change candidates, and finding candidates.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "contract-manager",
                "obligation-owner",
                "sourcing-manager",
                "legal-counsel"
              ]
            },
            "kind": "monitor",
            "label": "Detect window or variance",
            "trigger": "contract_monitor_tick_or_business_event"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "contract-manager",
              "legal-counsel",
              "sourcing-manager",
              "obligation-owner",
              "category-manager"
            ],
            "id": "analyse-options",
            "jobIds": [
              "renewal-change-compliance.decision-window",
              "renewal-change-compliance.compare-paths",
              "renewal-change-compliance.detect-variance",
              "renewal-change-compliance.execute-lifecycle-path"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: change options, impact evidence, option critic result, change id, and decision request.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "contract-manager",
                "obligation-owner",
                "sourcing-manager",
                "legal-counsel"
              ]
            },
            "kind": "analyse",
            "label": "Analyse options",
            "trigger": "change_candidates"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "contract-manager",
              "legal-counsel",
              "sourcing-manager",
              "obligation-owner",
              "category-manager"
            ],
            "id": "operate-change-and-findings",
            "jobIds": [
              "renewal-change-compliance.decision-window",
              "renewal-change-compliance.compare-paths",
              "renewal-change-compliance.detect-variance",
              "renewal-change-compliance.execute-lifecycle-path"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: finding ids, remediation candidates, child run refs, resulting version candidate, resulting version id, change outcome event, and finding outcomes.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "contract-manager",
                "obligation-owner",
                "sourcing-manager",
                "legal-counsel"
              ]
            },
            "kind": "operate",
            "label": "Operate change and findings",
            "trigger": "decision_request"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "contract-manager",
              "legal-counsel",
              "sourcing-manager",
              "obligation-owner",
              "category-manager"
            ],
            "id": "read-change-compliance",
            "jobIds": [
              "renewal-change-compliance.decision-window",
              "renewal-change-compliance.compare-paths",
              "renewal-change-compliance.detect-variance",
              "renewal-change-compliance.execute-lifecycle-path"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: decision horizon, change case view, finding view, and source freshness view.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "contract-manager",
                "obligation-owner",
                "sourcing-manager",
                "legal-counsel"
              ]
            },
            "kind": "read",
            "label": "Read change and compliance",
            "trigger": "ui_change_compliance_query"
          }
        ],
        "futureStateKey": "workblock.renewal-compliance.future-state",
        "hiredInsteadKey": "workblock.renewal-compliance.hired-instead",
        "id": "renewal-change-compliance",
        "implementationStatus": "roadmap",
        "jobStatementKey": "workblock.renewal-compliance.job",
        "jobStories": [
          {
            "completionKey": "workblock.renewal-compliance.story.decision-window.completion",
            "executionFlowIds": [
              "detect-window-or-variance",
              "analyse-options",
              "operate-change-and-findings",
              "read-change-compliance"
            ],
            "id": "renewal-change-compliance.decision-window",
            "roleCardId": "contract-manager",
            "storyKey": "workblock.renewal-compliance.story.decision-window.story"
          },
          {
            "completionKey": "workblock.renewal-compliance.story.compare-paths.completion",
            "executionFlowIds": [
              "detect-window-or-variance",
              "analyse-options",
              "operate-change-and-findings",
              "read-change-compliance"
            ],
            "id": "renewal-change-compliance.compare-paths",
            "roleCardId": "sourcing-manager",
            "storyKey": "workblock.renewal-compliance.story.compare-paths.story"
          },
          {
            "completionKey": "workblock.renewal-compliance.story.detect-variance.completion",
            "executionFlowIds": [
              "detect-window-or-variance",
              "analyse-options",
              "operate-change-and-findings",
              "read-change-compliance"
            ],
            "id": "renewal-change-compliance.detect-variance",
            "roleCardId": "obligation-owner",
            "storyKey": "workblock.renewal-compliance.story.detect-variance.story"
          },
          {
            "completionKey": "workblock.renewal-compliance.story.execute-lifecycle-path.completion",
            "executionFlowIds": [
              "detect-window-or-variance",
              "analyse-options",
              "operate-change-and-findings",
              "read-change-compliance"
            ],
            "id": "renewal-change-compliance.execute-lifecycle-path",
            "roleCardId": "contract-manager",
            "storyKey": "workblock.renewal-compliance.story.execute-lifecycle-path.story"
          }
        ],
        "labelKey": "workblock.renewal-compliance.label",
        "metrics": [
          "Decision coverage: active contracts with a current renewal or termination decision / contracts entering horizon",
          "Median actionable lead days before contractual deadline",
          "Missed critical deadline count; target zero",
          "Compliance finding precision and missed-material-finding rate",
          "Validated and realized recovery value with method and evidence",
          "Change cycle time: decision to reconciled resulting version",
          "Child-run and writeback reconciliation rate",
          "Stale evidence exposure by contract value and risk"
        ],
        "officeCapabilities": [
          "composer",
          "conductor"
        ],
        "operatingModel": "The Workblock owns contract-change and compliance-finding cases. It correlates contract dates, obligations, entitlements, orders and performance, prepares source-backed options, orchestrates the selected path through authoring and approval, and proves that resulting versions and operational writebacks agree.",
        "outcomeKey": "workblock.renewal-compliance.outcome",
        "prerequisites": [
          "Read access to executed contract versions and governing terms",
          "Obligation and entitlement records for the covered agreements",
          "Order, consumption and performance data to compare against agreed terms",
          "Notice-period and execution lead-time rules for each contract class",
          "Named owners for renewal, amendment and termination decisions"
        ],
        "toolKey": "workblock.renewal-compliance.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Create onboarding cases",
              "Pre-fill verified data",
              "Request missing evidence",
              "Resolve high-confidence duplicates",
              "Activate complete low-risk cases"
            ],
            "escalationTriggers": [
              "Identity conflict",
              "Restricted screening result",
              "Sensitive master-data change",
              "Critical or novel relationship scope"
            ],
            "id": "supplier-onboarding-agent",
            "label": "Supplier onboarding agent",
            "mission": "Collect the minimum complete evidence set, resolve canonical identity and activate only policy-valid routine supplier relationships.",
            "operatorRoleIds": [
              "accountable-risk-owner"
            ],
            "personaIds": [
              "supplier-risk-manager",
              "requester-persona"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "onboarding-coordinator",
              "supplier-master-steward",
              "supplier-contact",
              "accountable-risk-owner"
            ]
          },
          {
            "autonomousActions": [
              "Block activation",
              "Expire stale evidence",
              "Select sampled cases",
              "Demote an onboarding cohort"
            ],
            "escalationTriggers": [
              "False activation",
              "Systemic duplicate resolution drift",
              "Quarantined evidence source",
              "Writeback integrity failure"
            ],
            "id": "onboarding-critic-agent",
            "label": "Onboarding control critic",
            "mission": "Independently challenge identity, evidence completeness, policy scope and downstream reconciliation before activation.",
            "operatorRoleIds": [
              "accountable-risk-owner"
            ],
            "personaIds": [
              "supplier-risk-manager",
              "platform-operator"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "onboarding-coordinator",
              "supplier-master-steward",
              "supplier-contact",
              "accountable-risk-owner"
            ]
          }
        ],
        "agentStoryKey": "workblock.onboarding.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Restricted or ambiguous screening result",
            "Residual-risk acceptance or critical supplier designation",
            "Duplicate or legal-entity identity ambiguity below threshold",
            "Banking or sensitive payment-data change",
            "Unavailable critical control or stale required evidence"
          ],
          "authorityEnvelope": [
            "May create cases, collect and verify evidence, resolve high-confidence identity and run allow-listed dependencies",
            "May activate only eligible low-risk relationship cohorts with complete fresh deterministic checks and reconciled writeback",
            "May not autonomously accept residual risk, bypass screening, create sensitive payment data or override separation of duty",
            "Per-country, relationship, master-data and writeback kill switches are mandatory"
          ],
          "humanSupervision": [
            "Own scoping, evidence, screening and activation policies",
            "Inspect sampled straight-through activations and duplicate resolutions",
            "Decide residual risk, critical supplier and non-deterministic identity cases",
            "Review supplier effort, false activation and missed-control measures"
          ],
          "rollback": [
            "Stop uncommitted activation and request corrected evidence",
            "Reverse or inactivate a reversible erroneous master creation through controlled writeback",
            "Split or merge supplier identity through an auditable correction",
            "Preserve source and decision evidence while restoring last-good profile",
            "Demote the affected country, relationship or source cohort"
          ],
          "targetPosture": "policy_autonomous_with_monitoring"
        },
        "coreValue": "Establish a supplier once as a verified canonical party, collect only the evidence required for the intended relationship and activate eligible routine cases without repeated forms, duplicate masters or invisible control gaps.",
        "currentStateKey": "workblock.onboarding.current-state",
        "dataMappings": [
          {
            "access": "create",
            "entityId": "supplier-profile",
            "purpose": "Establish the canonical supplier identity and lifecycle header."
          },
          {
            "access": "update",
            "entityId": "supplier-profile",
            "purpose": "Commit verified identity refresh and reconciled downstream master number."
          },
          {
            "access": "create",
            "entityId": "supplier-onboarding-case",
            "purpose": "Create the governed collection and verification case."
          },
          {
            "access": "update",
            "entityId": "supplier-onboarding-case",
            "purpose": "Track evidence, identity resolution, dependency and activation state."
          },
          {
            "access": "read",
            "entityId": "supplier-qualification",
            "purpose": "Prove intended use is within current supplier qualification."
          },
          {
            "access": "read",
            "entityId": "supplier-risk-assessment",
            "purpose": "Prove required risk decision is current and within scope."
          },
          {
            "access": "read",
            "entityId": "party",
            "purpose": "Read the policy-filtered canonical party projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "source-record-reference",
            "purpose": "Read the policy-filtered canonical source record reference projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "policy",
            "purpose": "Read the policy-filtered canonical policy projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "integration-state",
            "purpose": "Read the policy-filtered canonical integration state projection from integration-state-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "registry-release",
            "purpose": "Read the policy-filtered canonical registry release projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "supplier-profile",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "supplier-onboarding-case",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "supplier-profile",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "supplier-onboarding-case",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          }
        ],
        "descriptionKey": "workblock.onboarding.description",
        "descriptorKey": "workblock.onboarding.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "supplier-lifecycle-third-party-risk",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "onboarding-coordinator",
              "supplier-master-steward",
              "accountable-risk-owner",
              "tprm-programme-owner",
              "supplier-contact"
            ],
            "id": "scope-onboarding",
            "jobIds": [
              "supplier-onboarding.new-supplier",
              "supplier-onboarding.duplicate-party",
              "supplier-onboarding.supplier-burden",
              "supplier-onboarding.protected-change",
              "supplier-onboarding.failed-activation"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: supplier request context, request reference, supplier id, duplicate candidates, identity confidence, requirement set version, evidence request, onboarding case id, and collection plan.",
                "Accepted and rejected inputs are counted, source-linked and assigned a freshness state; a failed refresh retains last-good data.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "onboarding-coordinator",
                "supplier-master-steward",
                "supplier-contact",
                "accountable-risk-owner"
              ]
            },
            "kind": "ingest",
            "label": "Scope onboarding",
            "trigger": "supplier_onboarding_requested"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "onboarding-coordinator",
              "supplier-master-steward",
              "accountable-risk-owner",
              "tprm-programme-owner",
              "supplier-contact"
            ],
            "id": "collect-and-verify",
            "jobIds": [
              "supplier-onboarding.new-supplier",
              "supplier-onboarding.duplicate-party",
              "supplier-onboarding.supplier-burden",
              "supplier-onboarding.protected-change",
              "supplier-onboarding.failed-activation"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: evidence state, supplier response, verification results, evidence gaps, risk result, qualification result, screening result, and activation candidate.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "onboarding-coordinator",
                "supplier-master-steward",
                "supplier-contact",
                "accountable-risk-owner"
              ]
            },
            "kind": "operate",
            "label": "Collect and verify",
            "trigger": "collection_plan"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "onboarding-coordinator",
              "supplier-master-steward",
              "accountable-risk-owner",
              "tprm-programme-owner",
              "supplier-contact"
            ],
            "id": "activate-supplier",
            "jobIds": [
              "supplier-onboarding.new-supplier",
              "supplier-onboarding.duplicate-party",
              "supplier-onboarding.supplier-burden",
              "supplier-onboarding.protected-change",
              "supplier-onboarding.failed-activation"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: activation critic result, supplier status, activation outbox event, master writeback receipt, supplier activated event, and onboarding outcome.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "onboarding-coordinator",
                "supplier-master-steward",
                "supplier-contact",
                "accountable-risk-owner"
              ]
            },
            "kind": "operate",
            "label": "Activate supplier",
            "trigger": "activation_candidate"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "onboarding-coordinator",
              "supplier-master-steward",
              "accountable-risk-owner",
              "tprm-programme-owner",
              "supplier-contact"
            ],
            "id": "read-onboarding",
            "jobIds": [
              "supplier-onboarding.new-supplier",
              "supplier-onboarding.duplicate-party",
              "supplier-onboarding.supplier-burden",
              "supplier-onboarding.protected-change",
              "supplier-onboarding.failed-activation"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: onboarding case view, requirement evidence view, dependency view, and freshness view.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "onboarding-coordinator",
                "supplier-master-steward",
                "supplier-contact",
                "accountable-risk-owner"
              ]
            },
            "kind": "read",
            "label": "Read onboarding",
            "trigger": "ui_onboarding_query"
          }
        ],
        "futureStateKey": "workblock.onboarding.future-state",
        "hiredInsteadKey": "workblock.onboarding.hired-instead",
        "id": "supplier-onboarding",
        "implementationStatus": "reference",
        "jobStatementKey": "workblock.onboarding.job",
        "jobStories": [
          {
            "completionKey": "workblock.onboarding.story.new-supplier.completion",
            "executionFlowIds": [
              "scope-onboarding",
              "collect-and-verify",
              "activate-supplier",
              "read-onboarding"
            ],
            "id": "supplier-onboarding.new-supplier",
            "roleCardId": "onboarding-coordinator",
            "storyKey": "workblock.onboarding.story.new-supplier.story"
          },
          {
            "completionKey": "workblock.onboarding.story.duplicate-party.completion",
            "executionFlowIds": [
              "scope-onboarding",
              "collect-and-verify",
              "activate-supplier",
              "read-onboarding"
            ],
            "id": "supplier-onboarding.duplicate-party",
            "roleCardId": "supplier-master-steward",
            "storyKey": "workblock.onboarding.story.duplicate-party.story"
          },
          {
            "completionKey": "workblock.onboarding.story.supplier-burden.completion",
            "executionFlowIds": [
              "scope-onboarding",
              "collect-and-verify",
              "activate-supplier",
              "read-onboarding"
            ],
            "id": "supplier-onboarding.supplier-burden",
            "roleCardId": "supplier-contact",
            "storyKey": "workblock.onboarding.story.supplier-burden.story"
          },
          {
            "completionKey": "workblock.onboarding.story.protected-change.completion",
            "executionFlowIds": [
              "scope-onboarding",
              "collect-and-verify",
              "activate-supplier",
              "read-onboarding"
            ],
            "id": "supplier-onboarding.protected-change",
            "roleCardId": "supplier-master-steward",
            "storyKey": "workblock.onboarding.story.protected-change.story"
          },
          {
            "completionKey": "workblock.onboarding.story.failed-activation.completion",
            "executionFlowIds": [
              "scope-onboarding",
              "collect-and-verify",
              "activate-supplier",
              "read-onboarding"
            ],
            "id": "supplier-onboarding.failed-activation",
            "roleCardId": "onboarding-coordinator",
            "storyKey": "workblock.onboarding.story.failed-activation.story"
          }
        ],
        "labelKey": "workblock.onboarding.label",
        "metrics": [
          "Onboarding cycle time: request to reconciled activation",
          "Straight-through activation: policy-bounded eligible activations / eligible cases",
          "False activation and missed-control count; target zero for restricted controls",
          "Duplicate false-link and missed-duplicate rates",
          "Supplier effort: median required fields, artifacts and response turns",
          "Evidence reuse rate with current purpose-valid evidence",
          "Writeback reconciliation rate and age of uncertain activations",
          "Stale required-evidence exposure"
        ],
        "operatingModel": "The Workblock owns supplier identity, lifecycle header and onboarding-case state. It scopes evidence from intended use, resolves duplicates, verifies identity and registrations, invokes risk or qualification dependencies, and reconciles activation in downstream supplier masters through idempotent writeback.",
        "outcomeKey": "workblock.onboarding.outcome",
        "prerequisites": [
          "A write connection to the ERP supplier master with reconciliation receipts",
          "Access to a screening provider for identity and registration checks",
          "Evidence requirements agreed per country and relationship type",
          "Access to current supplier risk assessments and qualifications",
          "Named owners for residual-risk and activation decisions"
        ],
        "toolKey": "workblock.onboarding.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Create routine scoped qualifications",
              "Apply conditions",
              "Expire stale qualifications",
              "Request renewal evidence",
              "Publish eligibility changes"
            ],
            "escalationTriggers": [
              "Residual risk outside policy",
              "Conflicting qualification scopes",
              "Critical supplier restriction",
              "Novel evidence or category"
            ],
            "id": "supplier-qualification-agent",
            "label": "Supplier qualification agent",
            "mission": "Maintain precise, current supplier eligibility for each permitted scope using verified evidence and deterministic policy.",
            "operatorRoleIds": [
              "onboarding-coordinator"
            ],
            "personaIds": [
              "supplier-risk-manager",
              "category-management-persona",
              "buyer"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "supplier-master-steward",
              "onboarding-coordinator",
              "tprm-programme-owner"
            ]
          },
          {
            "autonomousActions": [
              "Validate routine non-sensitive changes",
              "Request verification",
              "Prepare writeback",
              "Reconcile committed changes"
            ],
            "escalationTriggers": [
              "Bank or payment change",
              "Identity replacement",
              "Verification contradiction",
              "Unreconciled or potentially fraudulent change"
            ],
            "id": "supplier-master-change-agent",
            "label": "Supplier master change agent",
            "mission": "Verify and reconcile master-data changes while enforcing separation of duty and heightened controls for payment attributes.",
            "operatorRoleIds": [
              "onboarding-coordinator"
            ],
            "personaIds": [
              "supplier-risk-manager",
              "finance",
              "platform-operator"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "supplier-master-steward",
              "onboarding-coordinator",
              "tprm-programme-owner"
            ]
          },
          {
            "autonomousActions": [
              "Resolve CBAM-scoped goods and suppliers",
              "Collect installation-level emissions declarations",
              "Verify evidence method, period and verifier accreditation",
              "Assess certificate cost exposure with default-value fallback",
              "Propose compliance dispositions and renewal requests"
            ],
            "escalationTriggers": [
              "Suspected fabricated or default-only emissions values",
              "Supplier eligibility change",
              "Verification failure or conflicting declarations",
              "Declaration or surrender deadline at risk"
            ],
            "id": "carbon-compliance-agent",
            "label": "Carbon compliance agent",
            "mission": "Collect, verify and freshness-track supplier emissions evidence and translate it into CBAM cost exposure and eligibility dispositions that people can defend.",
            "operatorRoleIds": [
              "supplier-master-steward"
            ],
            "personaIds": [
              "supplier-risk-manager",
              "finance",
              "category-management-persona"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "supplier-master-steward",
              "tprm-programme-owner"
            ]
          },
          {
            "autonomousActions": [
              "Assemble observation histories per supplier and material scope",
              "Refresh quality risk predictions",
              "Explain prediction drivers",
              "Flag calibration drift",
              "Propose qualification adjustments"
            ],
            "escalationTriggers": [
              "Calibration breach or prediction drift",
              "Sparse, stale or corrected observation history",
              "Prediction conflicts with current eligibility",
              "Novel material scope or measure definition"
            ],
            "id": "supplier-quality-prediction-agent",
            "label": "Supplier quality prediction agent",
            "mission": "Predict supplier quality risk per material scope from observed performance history, explain the drivers, and propose qualification adjustments without ever auto-changing eligibility.",
            "operatorRoleIds": [
              "supplier-master-steward"
            ],
            "personaIds": [
              "supplier-risk-manager",
              "category-management-persona"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "supplier-master-steward",
              "tprm-programme-owner"
            ]
          }
        ],
        "agentStoryKey": "workblock.supplier-master.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Bank, payment, identity-replacement or sensitive tax change",
            "Residual-risk acceptance or critical supplier restriction",
            "Conflicting authoritative sources or verification failure",
            "Qualification outside known category, geography or use scope",
            "Irreversible or unreconciled downstream mutation"
          ],
          "authorityEnvelope": [
            "May create, renew, condition and expire allow-listed routine qualifications using current deterministic evidence",
            "May validate and write non-sensitive master changes within field, source and value policy",
            "May never autonomously commit bank, payment, identity-replacement or restricted tax changes",
            "Qualification, field and writeback kill switches plus idempotency keys are mandatory"
          ],
          "humanSupervision": [
            "Own qualification scope, conditions and master-change policy",
            "Review sampled routine qualifications and non-sensitive changes",
            "Decide residual-risk, critical restriction and sensitive master changes",
            "Monitor expiry, false-eligibility, fraud and reconciliation measures"
          ],
          "rollback": [
            "Expire or supersede an erroneous qualification and publish corrected eligibility",
            "Cancel uncommitted master changes",
            "Reverse a supported non-sensitive change through controlled compensating writeback",
            "Restore last-good eligibility projection during source degradation",
            "Escalate irreversible or sensitive corrections and demote the action cohort"
          ],
          "targetPosture": "policy_autonomous_with_monitoring"
        },
        "coreValue": "Keep supplier master data and eligibility trustworthy after onboarding by applying effective-dated qualification, certification and sensitive-change controls to every intended use.",
        "currentStateKey": "workblock.supplier-master.current-state",
        "dataMappings": [
          {
            "access": "read",
            "entityId": "supplier-profile",
            "purpose": "Ground qualification and master changes in canonical identity and current lifecycle."
          },
          {
            "access": "read",
            "entityId": "supplier-onboarding-case",
            "purpose": "Reuse verified onboarding evidence within purpose and freshness limits."
          },
          {
            "access": "read",
            "entityId": "supplier-risk-assessment",
            "purpose": "Include current scoped risk disposition in qualification."
          },
          {
            "access": "create",
            "entityId": "supplier-qualification",
            "purpose": "Create effective-dated scoped eligibility decisions."
          },
          {
            "access": "update",
            "entityId": "supplier-qualification",
            "purpose": "Apply restrictions, expiry, suspension or revocation without erasing prior decisions."
          },
          {
            "access": "create",
            "entityId": "supplier-master-change",
            "purpose": "Create controlled master-change proposals with masked evidence."
          },
          {
            "access": "update",
            "entityId": "supplier-master-change",
            "purpose": "Track independent verification, authority, writeback and reversal state."
          },
          {
            "access": "read",
            "entityId": "supplier-master-change",
            "purpose": "Read back the complete committed supplier master change with authority, freshness and provenance for reconciliation and record drill-through."
          },
          {
            "access": "read",
            "entityId": "evidence-item",
            "purpose": "Read supplier emissions declarations and verification reports held as evidence items with integrity, capture and freshness metadata for CBAM exposure assessment."
          },
          {
            "access": "read",
            "entityId": "supplier-performance-observation",
            "purpose": "Ground quality risk predictions in atomic observed performance facts per measure, scope and period, including correction and data-quality state."
          },
          {
            "access": "read",
            "entityId": "supplier-qualification",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "supplier-qualification",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "supplier-master-change",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          }
        ],
        "descriptionKey": "workblock.supplier-master.description",
        "descriptorKey": "workblock.supplier-master.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "supplier-lifecycle-third-party-risk",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "onboarding-coordinator",
              "supplier-master-steward",
              "accountable-risk-owner",
              "tprm-programme-owner",
              "supplier-contact"
            ],
            "id": "evaluate-qualification",
            "jobIds": [
              "supplier-master-qualification.scope-qualification",
              "supplier-master-qualification.expiry-monitoring",
              "supplier-master-qualification.master-change",
              "supplier-master-qualification.publish-eligibility"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: qualification context, evidence freshness, qualification candidate, qualification gaps, qualification critic result, qualification id, and eligibility event.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "supplier-master-steward",
                "onboarding-coordinator",
                "tprm-programme-owner"
              ]
            },
            "kind": "analyse",
            "label": "Evaluate qualification",
            "trigger": "supplier_activated_or_scope_changed"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "onboarding-coordinator",
              "supplier-master-steward",
              "accountable-risk-owner",
              "tprm-programme-owner",
              "supplier-contact"
            ],
            "id": "monitor-eligibility",
            "jobIds": [
              "supplier-master-qualification.scope-qualification",
              "supplier-master-qualification.expiry-monitoring",
              "supplier-master-qualification.master-change",
              "supplier-master-qualification.publish-eligibility"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: active qualifications, qualification actions, qualification updates, and eligibility events.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "supplier-master-steward",
                "onboarding-coordinator",
                "tprm-programme-owner"
              ]
            },
            "kind": "monitor",
            "label": "Monitor eligibility",
            "trigger": "qualification_monitor_tick_or_risk_event"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "onboarding-coordinator",
              "supplier-master-steward",
              "accountable-risk-owner",
              "tprm-programme-owner",
              "supplier-contact"
            ],
            "id": "control-master-change",
            "jobIds": [
              "supplier-master-qualification.scope-qualification",
              "supplier-master-qualification.expiry-monitoring",
              "supplier-master-qualification.master-change",
              "supplier-master-qualification.publish-eligibility"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: master change id, change payload, idempotency key, verification state, change decision request, master change receipt, master change status, and supplier master changed event.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "supplier-master-steward",
                "onboarding-coordinator",
                "tprm-programme-owner"
              ]
            },
            "kind": "operate",
            "label": "Control master change",
            "trigger": "supplier_master_change_requested"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "onboarding-coordinator",
              "supplier-master-steward",
              "accountable-risk-owner",
              "tprm-programme-owner",
              "supplier-contact"
            ],
            "id": "read-master-qualification",
            "jobIds": [
              "supplier-master-qualification.scope-qualification",
              "supplier-master-qualification.expiry-monitoring",
              "supplier-master-qualification.master-change",
              "supplier-master-qualification.publish-eligibility"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: eligibility view, qualification evidence view, master change view, and freshness view.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "supplier-master-steward",
                "onboarding-coordinator",
                "tprm-programme-owner"
              ]
            },
            "kind": "read",
            "label": "Read master and qualification",
            "trigger": "ui_supplier_master_query"
          },
          {
            "agentIds": [
              "carbon-compliance-agent"
            ],
            "escalationRoleIds": [
              "onboarding-coordinator",
              "supplier-master-steward",
              "accountable-risk-owner",
              "tprm-programme-owner",
              "supplier-contact"
            ],
            "id": "verify-carbon-cost-compliance",
            "jobIds": [
              "supplier-master-qualification.carbon-compliance"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: cbam exposure assessment and carbon compliance disposition proposal.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "supplier-master-steward",
                "onboarding-coordinator",
                "tprm-programme-owner"
              ]
            },
            "kind": "agent",
            "label": "Verify carbon cost compliance",
            "trigger": "CBAM-scoped supply detected, emissions evidence expiring or a declaration period opens."
          },
          {
            "agentIds": [
              "supplier-quality-prediction-agent"
            ],
            "escalationRoleIds": [
              "onboarding-coordinator",
              "supplier-master-steward",
              "accountable-risk-owner",
              "tprm-programme-owner",
              "supplier-contact"
            ],
            "id": "predict-supplier-quality",
            "jobIds": [
              "supplier-master-qualification.quality-prediction"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: supplier quality prediction set and qualification adjustment proposal.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "supplier-master-steward",
                "tprm-programme-owner"
              ]
            },
            "kind": "agent",
            "label": "Predict supplier quality",
            "trigger": "New quality observations, qualification review window or material-category eligibility question."
          }
        ],
        "futureStateKey": "workblock.supplier-master.future-state",
        "hiredInsteadKey": "workblock.supplier-master.hired-instead",
        "id": "supplier-master-qualification",
        "implementationStatus": "roadmap",
        "jobStatementKey": "workblock.supplier-master.job",
        "jobStories": [
          {
            "completionKey": "workblock.supplier-master.story.scope-qualification.completion",
            "executionFlowIds": [
              "evaluate-qualification",
              "monitor-eligibility",
              "control-master-change",
              "read-master-qualification"
            ],
            "id": "supplier-master-qualification.scope-qualification",
            "roleCardId": "supplier-master-steward",
            "storyKey": "workblock.supplier-master.story.scope-qualification.story"
          },
          {
            "completionKey": "workblock.supplier-master.story.expiry-monitoring.completion",
            "executionFlowIds": [
              "evaluate-qualification",
              "monitor-eligibility",
              "control-master-change",
              "read-master-qualification"
            ],
            "id": "supplier-master-qualification.expiry-monitoring",
            "roleCardId": "accountable-risk-owner",
            "storyKey": "workblock.supplier-master.story.expiry-monitoring.story"
          },
          {
            "completionKey": "workblock.supplier-master.story.master-change.completion",
            "executionFlowIds": [
              "evaluate-qualification",
              "monitor-eligibility",
              "control-master-change",
              "read-master-qualification"
            ],
            "id": "supplier-master-qualification.master-change",
            "roleCardId": "supplier-master-steward",
            "storyKey": "workblock.supplier-master.story.master-change.story"
          },
          {
            "completionKey": "workblock.supplier-master.story.publish-eligibility.completion",
            "executionFlowIds": [
              "evaluate-qualification",
              "monitor-eligibility",
              "control-master-change",
              "read-master-qualification"
            ],
            "id": "supplier-master-qualification.publish-eligibility",
            "roleCardId": "onboarding-coordinator",
            "storyKey": "workblock.supplier-master.story.publish-eligibility.story"
          },
          {
            "completionKey": "workblock.supplier-master.story.carbon-compliance.completion",
            "executionFlowIds": [
              "verify-carbon-cost-compliance"
            ],
            "id": "supplier-master-qualification.carbon-compliance",
            "roleCardId": "supplier-master-steward",
            "storyKey": "workblock.supplier-master.story.carbon-compliance.story"
          },
          {
            "completionKey": "workblock.supplier-master.story.quality-prediction.completion",
            "executionFlowIds": [
              "predict-supplier-quality"
            ],
            "id": "supplier-master-qualification.quality-prediction",
            "roleCardId": "supplier-master-steward",
            "storyKey": "workblock.supplier-master.story.quality-prediction.story"
          }
        ],
        "labelKey": "workblock.supplier-master.label",
        "metrics": [
          "Qualification cycle time and straight-through rate by scope",
          "False-eligibility and missed-expiry rates",
          "Condition enforcement: blocked non-conforming commitments / attempted non-conforming commitments",
          "Current-evidence coverage of active qualifications",
          "Sensitive master-change boundary violations; target zero",
          "Master-change writeback reconciliation and duplicate count",
          "Mean time to revoke or restrict after material risk event"
        ],
        "operatingModel": "The Workblock owns supplier qualification and controlled master-change records. It segments suppliers, evaluates category and use-specific qualifications, monitors certificate expiry and verifies master changes through separation of duty before idempotent writeback; the supplier profile remains single-writer-owned by onboarding through explicit lifecycle APIs.",
        "outcomeKey": "workblock.supplier-master.outcome",
        "prerequisites": [
          "Access to the canonical supplier record and its lifecycle state",
          "A write connection to the ERP supplier master with reconciliation receipts",
          "Qualification scope, condition and expiry policies per category and use",
          "Access to certification and screening evidence sources",
          "Named stewards for sensitive master-data changes with separation of duty"
        ],
        "toolKey": "workblock.supplier-master.tool",
        "version": "5.1.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Scope routine assessments",
              "Request evidence",
              "Map controls",
              "Calculate deterministic risk",
              "Prepare decision proposals"
            ],
            "escalationTriggers": [
              "Critical inherent or residual risk",
              "Conflicting evidence",
              "Novel risk domain",
              "Required specialist interpretation"
            ],
            "id": "third-party-risk-agent",
            "label": "Third-party risk assessment agent",
            "mission": "Scope risk, collect sufficient evidence and prepare transparent residual-risk decisions using narrow domain tools.",
            "operatorRoleIds": [
              "accountable-risk-owner"
            ],
            "personaIds": [
              "supplier-risk-manager",
              "requester-persona"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "tprm-programme-owner",
              "accountable-risk-owner",
              "onboarding-coordinator",
              "supplier-contact"
            ]
          },
          {
            "autonomousActions": [
              "Block unsupported conclusions",
              "Require evidence gaps",
              "Select sampled cases",
              "Demote a risk-domain cohort"
            ],
            "escalationTriggers": [
              "Missed critical scope",
              "Unsupported risk reduction",
              "Policy or source drift",
              "Incident contradicts accepted control"
            ],
            "id": "risk-assessment-critic",
            "label": "Risk assessment critic",
            "mission": "Challenge scope, evidence sufficiency, scoring and unsupported control conclusions before a decision advances.",
            "operatorRoleIds": [
              "accountable-risk-owner"
            ],
            "personaIds": [
              "supplier-risk-manager",
              "platform-operator"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "tprm-programme-owner",
              "accountable-risk-owner",
              "onboarding-coordinator",
              "supplier-contact"
            ]
          }
        ],
        "agentStoryKey": "workblock.risk-review.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "High or critical residual risk",
            "Control waiver, policy exception or critical supplier decision",
            "Novel domain, conflicting evidence or specialist legal interpretation",
            "Restricted screening or unreliable critical evidence source"
          ],
          "authorityEnvelope": [
            "May scope, request evidence, map controls and calculate risk for allow-listed relationship and risk-domain cohorts",
            "May autonomously accept only explicitly delegated low residual-risk cases with complete current deterministic evidence",
            "May apply pre-authorised conditions but not accept material residual risk or waive required controls",
            "Risk-domain, decision-class and evidence-source kill switches are mandatory"
          ],
          "humanSupervision": [
            "Own risk taxonomy, control and decision policies",
            "Review sampled low-risk decisions and all material residual-risk cases",
            "Investigate incidents that contradict accepted controls",
            "Promote or demote risk domains and relationship cohorts"
          ],
          "rollback": [
            "Expire or supersede a decision when evidence or scope changes",
            "Restore last-good risk projection while critical sources recover",
            "Suspend autonomous acceptance for the affected cohort",
            "Publish corrected restrictions and reopen assessment",
            "Accepted risk requiring reversal becomes an explicit new decision, not deletion of history"
          ],
          "targetPosture": "policy_autonomous_with_monitoring"
        },
        "coreValue": "Reach a defensible third-party risk decision with less supplier and reviewer effort by scoping the real relationship, reusing current evidence and focusing specialists on residual risk and genuine control gaps.",
        "currentStateKey": "workblock.risk-review.current-state",
        "dataMappings": [
          {
            "access": "read",
            "entityId": "supplier-profile",
            "purpose": "Ground assessment in canonical identity and current relationship lifecycle."
          },
          {
            "access": "read",
            "entityId": "supplier-onboarding-case",
            "purpose": "Reuse current onboarding evidence within scope and purpose."
          },
          {
            "access": "read",
            "entityId": "supplier-qualification",
            "purpose": "Include existing restrictions and qualification scope."
          },
          {
            "access": "read",
            "entityId": "supplier-risk-signal",
            "purpose": "Include current observations as evidence without converting them directly into a decision."
          },
          {
            "access": "read",
            "entityId": "supplier-tier-link",
            "purpose": "Assess material upstream dependencies and confidence."
          },
          {
            "access": "create",
            "entityId": "supplier-risk-assessment",
            "purpose": "Create the versioned scoped assessment and proposed decision record."
          },
          {
            "access": "update",
            "entityId": "supplier-risk-assessment",
            "purpose": "Commit evidence, decision and expiry without losing the assessment version."
          },
          {
            "access": "read",
            "entityId": "person",
            "purpose": "Read the policy-filtered canonical person projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "evidence-item",
            "purpose": "Read the policy-filtered canonical evidence item projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "policy-version",
            "purpose": "Read the policy-filtered canonical policy version projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "authority-envelope",
            "purpose": "Read the policy-filtered canonical authority envelope projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "action-proposal",
            "purpose": "Read the policy-filtered canonical action proposal projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "committed-action",
            "purpose": "Read the policy-filtered canonical committed action projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "decision",
            "purpose": "Read the policy-filtered canonical decision projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "exception",
            "purpose": "Read the policy-filtered canonical exception case projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "audit-event",
            "purpose": "Read the policy-filtered canonical audit event projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "business-event",
            "purpose": "Read the policy-filtered canonical business event projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "learning-example",
            "purpose": "Read the policy-filtered canonical learning example projection from learning-evaluation-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "evaluation-result",
            "purpose": "Read the policy-filtered canonical evaluation result projection from learning-evaluation-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "supplier-risk-assessment",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "supplier-risk-assessment",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          }
        ],
        "descriptionKey": "workblock.risk-review.description",
        "descriptorKey": "workblock.risk-review.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "supplier-lifecycle-third-party-risk",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "onboarding-coordinator",
              "supplier-master-steward",
              "accountable-risk-owner",
              "tprm-programme-owner",
              "supplier-contact"
            ],
            "id": "scope-assessment",
            "jobIds": [
              "third-party-risk-review.decision-package",
              "third-party-risk-review.evidence-conflict",
              "third-party-risk-review.monitoring-signal",
              "third-party-risk-review.mitigation-closure",
              "third-party-risk-review.method-change"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The assessment-scope, supplier-context, inherent-risk-level, risk-requirements, assessment-id and evidence-collection-plan record the method version, relationship facts, required specialist reviews and unresolved assumptions.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "tprm-programme-owner",
                "accountable-risk-owner",
                "onboarding-coordinator",
                "supplier-contact"
              ]
            },
            "kind": "analyse",
            "label": "Scope assessment",
            "trigger": "risk_assessment_requested"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "onboarding-coordinator",
              "supplier-master-steward",
              "accountable-risk-owner",
              "tprm-programme-owner",
              "supplier-contact"
            ],
            "id": "evaluate-controls",
            "jobIds": [
              "third-party-risk-review.decision-package",
              "third-party-risk-review.evidence-conflict",
              "third-party-risk-review.monitoring-signal",
              "third-party-risk-review.mitigation-closure",
              "third-party-risk-review.method-change"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The evidence-state, evidence-freshness, control-results and control-gaps preserve sources and reviewer dispositions; the residual-risk-level and decision-candidate state remaining uncertainty without accepting it.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "tprm-programme-owner",
                "accountable-risk-owner",
                "onboarding-coordinator",
                "supplier-contact"
              ]
            },
            "kind": "analyse",
            "label": "Evaluate controls",
            "trigger": "evidence_collection_plan"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "onboarding-coordinator",
              "supplier-master-steward",
              "accountable-risk-owner",
              "tprm-programme-owner",
              "supplier-contact"
            ],
            "id": "decide-risk",
            "jobIds": [
              "third-party-risk-review.decision-package",
              "third-party-risk-review.evidence-conflict",
              "third-party-risk-review.monitoring-signal",
              "third-party-risk-review.mitigation-closure",
              "third-party-risk-review.method-change"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The risk-critic-result and risk-decision-request bind the evidence version and authority; the assessment-status and risk-decision-event record decision, conditions, expiry and reopen triggers, with remediation-candidates kept as owned follow-up.",
                "The exact proposal version, authorised reviewer or policy authority, decision and reason are durable before any commitment.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "accountable-risk-owner",
                "tprm-programme-owner",
                "onboarding-coordinator",
                "supplier-contact"
              ]
            },
            "kind": "review",
            "label": "Decide risk",
            "trigger": "decision_candidate"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "onboarding-coordinator",
              "supplier-master-steward",
              "accountable-risk-owner",
              "tprm-programme-owner",
              "supplier-contact"
            ],
            "id": "read-risk-assessment",
            "jobIds": [
              "third-party-risk-review.decision-package",
              "third-party-risk-review.evidence-conflict",
              "third-party-risk-review.monitoring-signal",
              "third-party-risk-review.mitigation-closure",
              "third-party-risk-review.method-change"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The assessment-view, control-evidence-view, risk-explanation-view and freshness-view show current or clearly stale last-good state and drill from every conclusion to its source and reviewer disposition.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "accountable-risk-owner",
                "tprm-programme-owner",
                "onboarding-coordinator",
                "supplier-contact"
              ]
            },
            "kind": "read",
            "label": "Read risk assessment",
            "trigger": "ui_risk_assessment_query"
          }
        ],
        "futureStateKey": "workblock.risk-review.future-state",
        "hiredInsteadKey": "workblock.risk-review.hired-instead",
        "id": "third-party-risk-review",
        "implementationStatus": "reference",
        "jobStatementKey": "workblock.risk-review.job",
        "jobStories": [
          {
            "completionKey": "workblock.risk-review.story.decision-package.completion",
            "executionFlowIds": [
              "scope-assessment",
              "evaluate-controls",
              "decide-risk",
              "read-risk-assessment"
            ],
            "id": "third-party-risk-review.decision-package",
            "roleCardId": "accountable-risk-owner",
            "storyKey": "workblock.risk-review.story.decision-package.story"
          },
          {
            "completionKey": "workblock.risk-review.story.evidence-conflict.completion",
            "executionFlowIds": [
              "scope-assessment",
              "evaluate-controls",
              "decide-risk",
              "read-risk-assessment"
            ],
            "id": "third-party-risk-review.evidence-conflict",
            "roleCardId": "tprm-programme-owner",
            "storyKey": "workblock.risk-review.story.evidence-conflict.story"
          },
          {
            "completionKey": "workblock.risk-review.story.monitoring-signal.completion",
            "executionFlowIds": [
              "scope-assessment",
              "evaluate-controls",
              "decide-risk",
              "read-risk-assessment"
            ],
            "id": "third-party-risk-review.monitoring-signal",
            "roleCardId": "accountable-risk-owner",
            "storyKey": "workblock.risk-review.story.monitoring-signal.story"
          },
          {
            "completionKey": "workblock.risk-review.story.mitigation-closure.completion",
            "executionFlowIds": [
              "scope-assessment",
              "evaluate-controls",
              "decide-risk",
              "read-risk-assessment"
            ],
            "id": "third-party-risk-review.mitigation-closure",
            "roleCardId": "accountable-risk-owner",
            "storyKey": "workblock.risk-review.story.mitigation-closure.story"
          },
          {
            "completionKey": "workblock.risk-review.story.method-change.completion",
            "executionFlowIds": [
              "scope-assessment",
              "evaluate-controls",
              "decide-risk",
              "read-risk-assessment"
            ],
            "id": "third-party-risk-review.method-change",
            "roleCardId": "tprm-programme-owner",
            "storyKey": "workblock.risk-review.story.method-change.story"
          }
        ],
        "labelKey": "workblock.risk-review.label",
        "metrics": [
          "Assessment cycle time by risk domain and inherent-risk tier",
          "Supplier effort: questions, artifacts and response turns",
          "Evidence reuse rate with purpose- and scope-valid artifacts",
          "False-low-risk and missed-critical-scope rates",
          "Residual-risk decision overturn rate",
          "Accepted supplier incident rate by control conclusion",
          "Stale assessment exposure and mean time to reopen after material signal"
        ],
        "officeCapabilities": [
          "composer",
          "conductor"
        ],
        "operatingModel": "The Workblock owns scoped supplier-risk assessments from inherent-risk scoping through evidence collection, control evaluation, residual-risk proposal and authority decision. Evidence stays source-linked and effective-dated; external signals inform but never silently become a risk decision.",
        "outcomeKey": "workblock.risk-review.outcome",
        "prerequisites": [
          "Access to the canonical supplier record and relationship scope",
          "Reusable onboarding and qualification evidence within purpose limits",
          "An agreed risk taxonomy, control library and decision policy",
          "External risk-signal feeds usable as evidence sources",
          "Named accountable owners for residual-risk decisions"
        ],
        "toolKey": "workblock.risk-review.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Normalize signals",
              "Resolve high-confidence identities",
              "Close deterministic duplicates or non-material repeats",
              "Open material cases",
              "Request evidence and reassessment"
            ],
            "escalationTriggers": [
              "Critical materiality",
              "Low entity confidence",
              "Restricted source content",
              "Proposed supplier restriction or exit"
            ],
            "id": "supplier-risk-monitor-agent",
            "label": "Supplier risk monitor agent",
            "mission": "Keep a bounded supplier portfolio's material risk evidence current and open or pursue only policy-valid cases.",
            "operatorRoleIds": [
              "accountable-risk-owner"
            ],
            "personaIds": [
              "supplier-risk-manager",
              "supplier-relationship-manager"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "tprm-programme-owner",
              "accountable-risk-owner"
            ]
          },
          {
            "autonomousActions": [
              "Create asserted or observed edges",
              "Expire stale edges",
              "Calculate affected paths",
              "Request verification"
            ],
            "escalationTriggers": [
              "Critical unverified dependency",
              "Conflicting network sources",
              "Sensitive supplier-confidential topology",
              "Proposed operational intervention"
            ],
            "id": "supply-network-agent",
            "label": "Supply network evidence agent",
            "mission": "Maintain evidence-scored supplier dependencies and identify affected paths without presenting inference as verified fact.",
            "operatorRoleIds": [
              "accountable-risk-owner"
            ],
            "personaIds": [
              "supplier-risk-manager",
              "category-management-persona"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "tprm-programme-owner",
              "accountable-risk-owner"
            ]
          }
        ],
        "agentStoryKey": "workblock.risk-monitor.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Critical or rapidly escalating materiality",
            "Low-confidence entity match with material consequence",
            "Supplier restriction, suspension, residual-risk acceptance or exit",
            "Restricted allegation, legal interpretation or source dispute",
            "Mission needs ungranted tool, recipient, budget or duration"
          ],
          "authorityEnvelope": [
            "Mission defines supplier portfolio, risk domains, sources, action budget, duration, permitted recipients and stop conditions",
            "May normalize, deduplicate, monitor, request evidence, open cases and invoke reassessment",
            "May close only deterministic duplicate or non-material repeats under sampled assurance",
            "May not restrict, suspend, accept residual risk or exit a supplier without explicit authority",
            "Source-, domain-, supplier- and action-level kill switches are mandatory"
          ],
          "humanSupervision": [
            "Own materiality, source, action and mission policies",
            "Review critical and novel cases plus stratified samples of closed cases",
            "Decide supplier restrictions, residual risk and exit",
            "Monitor missed-event, false-case, source coverage and harm metrics"
          ],
          "rollback": [
            "Stop the mission and future monitoring actions immediately",
            "Supersede erroneous signals or network edges without deleting source evidence",
            "Reopen incorrectly closed cases and restore last-good risk projection",
            "Withdraw uncommitted proposals and send compensating clarification for reversible messages",
            "Demote source, risk-domain, action or mission cohort"
          ],
          "targetPosture": "mission_autonomous_with_supervision"
        },
        "coreValue": "Detect material supplier and sub-tier risk change early, distinguish evidence from noise and pursue the right response continuously without turning every alert into manual triage or an ungoverned supplier restriction.",
        "currentStateKey": "workblock.risk-monitor.current-state",
        "dataMappings": [
          {
            "access": "read",
            "entityId": "supplier-profile",
            "purpose": "Resolve observations and apply current relationship context."
          },
          {
            "access": "read",
            "entityId": "supplier-risk-assessment",
            "purpose": "Evaluate new evidence against current scoped risk posture."
          },
          {
            "access": "create",
            "entityId": "supplier-risk-signal",
            "purpose": "Commit normalised observations without representing them as decisions."
          },
          {
            "access": "create",
            "entityId": "supplier-risk-case",
            "purpose": "Create one governed actionable case per underlying event family."
          },
          {
            "access": "update",
            "entityId": "supplier-risk-case",
            "purpose": "Correlate new evidence and track mission, proposal and decision outcomes."
          },
          {
            "access": "create",
            "entityId": "supplier-tier-link",
            "purpose": "Create evidence-scored supplier and external dependency edges."
          },
          {
            "access": "update",
            "entityId": "supplier-tier-link",
            "purpose": "Verify, dispute, expire or supersede network evidence."
          },
          {
            "access": "read",
            "entityId": "supplier-master-change",
            "purpose": "Read the governed supplier master change contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "supplier-risk-signal",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "supplier-risk-case",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "supplier-tier-link",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "supplier-risk-signal",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "supplier-risk-case",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "supplier-tier-link",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          }
        ],
        "descriptionKey": "workblock.risk-monitor.description",
        "descriptorKey": "workblock.risk-monitor.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "supplier-lifecycle-third-party-risk",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "onboarding-coordinator",
              "supplier-master-steward",
              "accountable-risk-owner",
              "tprm-programme-owner",
              "supplier-contact"
            ],
            "id": "normalize-signals",
            "jobIds": [
              "continuous-risk-monitoring.normalise-observation",
              "continuous-risk-monitoring.resolve-exposure",
              "continuous-risk-monitoring.material-case",
              "continuous-risk-monitoring.early-safeguard"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: risk source snapshot, source freshness, supplier id, entity confidence, signal candidate, deduplication key, signal id, and materiality request.",
                "Accepted and rejected inputs are counted, source-linked and assigned a freshness state; a failed refresh retains last-good data.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "tprm-programme-owner",
                "accountable-risk-owner"
              ]
            },
            "kind": "ingest",
            "label": "Normalize signals",
            "trigger": "risk_source_event_or_refresh"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "onboarding-coordinator",
              "supplier-master-steward",
              "accountable-risk-owner",
              "tprm-programme-owner",
              "supplier-contact"
            ],
            "id": "correlate-materiality",
            "jobIds": [
              "continuous-risk-monitoring.normalise-observation",
              "continuous-risk-monitoring.resolve-exposure",
              "continuous-risk-monitoring.material-case",
              "continuous-risk-monitoring.early-safeguard"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: relationship context, tier context, materiality, severity, case candidate, and signal critic result.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "tprm-programme-owner",
                "accountable-risk-owner"
              ]
            },
            "kind": "analyse",
            "label": "Correlate materiality",
            "trigger": "materiality_request"
          },
          {
            "agentIds": [
              "supplier-risk-monitor-agent",
              "supply-network-agent"
            ],
            "escalationRoleIds": [
              "onboarding-coordinator",
              "supplier-master-steward",
              "accountable-risk-owner",
              "tprm-programme-owner",
              "supplier-contact"
            ],
            "id": "pursue-risk-case",
            "jobIds": [
              "continuous-risk-monitoring.normalise-observation",
              "continuous-risk-monitoring.resolve-exposure",
              "continuous-risk-monitoring.material-case",
              "continuous-risk-monitoring.early-safeguard"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: risk case id, mission plan, mission actions, action receipts, decision proposals, risk case status, and next mission plan.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "tprm-programme-owner",
                "accountable-risk-owner"
              ]
            },
            "kind": "agent",
            "label": "Pursue risk case",
            "trigger": "case_candidate"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "onboarding-coordinator",
              "supplier-master-steward",
              "accountable-risk-owner",
              "tprm-programme-owner",
              "supplier-contact"
            ],
            "id": "read-risk-network",
            "jobIds": [
              "continuous-risk-monitoring.normalise-observation",
              "continuous-risk-monitoring.resolve-exposure",
              "continuous-risk-monitoring.material-case",
              "continuous-risk-monitoring.early-safeguard"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: risk case view, signal evidence view, network view, and source health view.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "tprm-programme-owner",
                "accountable-risk-owner"
              ]
            },
            "kind": "read",
            "label": "Read risk and network",
            "trigger": "ui_risk_monitor_query"
          }
        ],
        "futureStateKey": "workblock.risk-monitor.future-state",
        "hiredInsteadKey": "workblock.risk-monitor.hired-instead",
        "id": "continuous-risk-monitoring",
        "implementationStatus": "roadmap",
        "jobStatementKey": "workblock.risk-monitor.job",
        "jobStories": [
          {
            "completionKey": "workblock.risk-monitor.story.normalise-observation.completion",
            "executionFlowIds": [
              "normalize-signals",
              "correlate-materiality",
              "pursue-risk-case",
              "read-risk-network"
            ],
            "id": "continuous-risk-monitoring.normalise-observation",
            "roleCardId": "tprm-programme-owner",
            "storyKey": "workblock.risk-monitor.story.normalise-observation.story"
          },
          {
            "completionKey": "workblock.risk-monitor.story.resolve-exposure.completion",
            "executionFlowIds": [
              "normalize-signals",
              "correlate-materiality",
              "pursue-risk-case",
              "read-risk-network"
            ],
            "id": "continuous-risk-monitoring.resolve-exposure",
            "roleCardId": "accountable-risk-owner",
            "storyKey": "workblock.risk-monitor.story.resolve-exposure.story"
          },
          {
            "completionKey": "workblock.risk-monitor.story.material-case.completion",
            "executionFlowIds": [
              "normalize-signals",
              "correlate-materiality",
              "pursue-risk-case",
              "read-risk-network"
            ],
            "id": "continuous-risk-monitoring.material-case",
            "roleCardId": "accountable-risk-owner",
            "storyKey": "workblock.risk-monitor.story.material-case.story"
          },
          {
            "completionKey": "workblock.risk-monitor.story.early-safeguard.completion",
            "executionFlowIds": [
              "normalize-signals",
              "correlate-materiality",
              "pursue-risk-case",
              "read-risk-network"
            ],
            "id": "continuous-risk-monitoring.early-safeguard",
            "roleCardId": "tprm-programme-owner",
            "storyKey": "workblock.risk-monitor.story.early-safeguard.story"
          }
        ],
        "labelKey": "workblock.risk-monitor.label",
        "metrics": [
          "Median source-observation to material-case detection time",
          "Material case precision and missed-critical-event rate",
          "Entity false-match and event duplicate rates",
          "False non-material closure rate from sampled assurance",
          "Source coverage and stale-source exposure by critical supplier",
          "Mean time from material signal to reassessment or safeguard decision",
          "Mission action effectiveness and unnecessary-contact rate",
          "Verified and current network-edge coverage for critical dependencies"
        ],
        "operatingModel": "The Workblock owns normalised risk signals, correlated risk cases and effective-dated supplier-tier links. Mission-bounded agents monitor allow-listed sources, resolve entities, deduplicate events, evaluate materiality and pursue evidence or routine safeguards; restrictions, residual-risk acceptance and exits remain explicit decisions.",
        "outcomeKey": "workblock.risk-monitor.outcome",
        "prerequisites": [
          "Approved external risk-data sources and event feeds",
          "Access to the canonical supplier record for entity resolution",
          "Current risk assessments to evaluate new evidence against",
          "Materiality and escalation policies per risk domain",
          "Named owners for restriction, acceptance and exit decisions"
        ],
        "toolKey": "workblock.risk-monitor.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Create approved action plans",
              "Request evidence",
              "Send reminders",
              "Verify deterministic evidence",
              "Close verified routine actions"
            ],
            "escalationTriggers": [
              "Overdue high-risk action",
              "Disputed outcome",
              "Evidence contradiction",
              "Waiver or restriction decision"
            ],
            "id": "supplier-remediation-agent",
            "label": "Supplier remediation agent",
            "mission": "Pursue measurable corrective outcomes within a bounded plan and escalate stalled, disputed or ineffective remediation.",
            "operatorRoleIds": [
              "accountable-risk-owner"
            ],
            "personaIds": [
              "supplier-risk-manager",
              "supplier-relationship-manager"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "accountable-risk-owner",
              "tprm-programme-owner",
              "onboarding-coordinator",
              "supplier-contact"
            ]
          },
          {
            "autonomousActions": [
              "Inventory dependencies",
              "Assign approved exit actions",
              "Invoke authorised child runs",
              "Reconcile receipts",
              "Flag residual exceptions"
            ],
            "escalationTriggers": [
              "Unresolved critical dependency",
              "Active legal or payment dispute",
              "Continuity failure",
              "Irreversible action without explicit grant"
            ],
            "id": "supplier-exit-agent",
            "label": "Supplier exit agent",
            "mission": "Coordinate an authorised exit across dependencies and prove every required restriction, transition and revocation reconciles.",
            "operatorRoleIds": [
              "accountable-risk-owner"
            ],
            "personaIds": [
              "supplier-risk-manager",
              "contract-legal",
              "category-management-persona",
              "platform-operator"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "accountable-risk-owner",
              "tprm-programme-owner",
              "onboarding-coordinator",
              "supplier-contact"
            ]
          }
        ],
        "agentStoryKey": "workblock.supplier-remediation.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Waiver, accepted residual risk or disputed remediation",
            "Supplier restriction, suspension, termination or critical access revocation",
            "Unresolved contract, order, payment, data or continuity dependency",
            "Mission needs action beyond approved tool, budget, recipient or duration",
            "Evidence suggests fraud, harm or legal dispute"
          ],
          "authorityEnvelope": [
            "Remediation mission defines actions, recipients, evidence, budget, duration and stop conditions",
            "May send approved follow-up, collect evidence and close only deterministic verified routine actions",
            "Exit mission may execute only dependency actions explicitly listed in an approved exit authority",
            "May not waive controls, accept residual risk, terminate contracts, stop critical supply or revoke high-consequence access without explicit decision",
            "Per-supplier, dependency and tool kill switches are mandatory"
          ],
          "humanSupervision": [
            "Own remediation, verification, exit and continuity policies",
            "Review sampled verified actions and all high-risk overdue cases",
            "Decide waivers, restrictions, contract changes and exit",
            "Monitor recurrence, mission behavior and residual dependency exposure"
          ],
          "rollback": [
            "Stop missions and cancel future messages immediately",
            "Reopen an incorrectly verified remediation action",
            "Reverse supported reversible access or master restrictions through controlled compensation",
            "Restore last-good dependency state and surface unresolved exposure",
            "Contract termination or completed irreversible revocation requires explicit corrective decision, not synthetic rollback",
            "Demote action or dependency cohort"
          ],
          "targetPosture": "mission_autonomous_with_supervision"
        },
        "coreValue": "Turn supplier risk and control decisions into verified corrective outcomes, or a complete, safe exit, without losing ownership, evidence, continuity or downstream access and commitment controls.",
        "currentStateKey": "workblock.supplier-remediation.current-state",
        "dataMappings": [
          {
            "access": "read",
            "entityId": "supplier-profile",
            "purpose": "Ground remediation and exit in canonical supplier identity and current lifecycle."
          },
          {
            "access": "read",
            "entityId": "supplier-risk-assessment",
            "purpose": "Use the authority-bound risk decision and evidence gaps."
          },
          {
            "access": "read",
            "entityId": "supplier-risk-case",
            "purpose": "Trace the material event and approved treatment context."
          },
          {
            "access": "create",
            "entityId": "supplier-remediation-action",
            "purpose": "Create measurable corrective actions and verification contracts."
          },
          {
            "access": "update",
            "entityId": "supplier-remediation-action",
            "purpose": "Track evidence, verification, overdue and outcome state."
          },
          {
            "access": "read",
            "entityId": "supplier-remediation-action",
            "purpose": "Read back the complete committed supplier remediation action with authority, freshness and provenance for reconciliation and record drill-through."
          },
          {
            "access": "create",
            "entityId": "supplier-offboarding-case",
            "purpose": "Create the cross-domain exit dependency plan."
          },
          {
            "access": "update",
            "entityId": "supplier-offboarding-case",
            "purpose": "Reconcile every exit dependency and committed completion state."
          },
          {
            "access": "read",
            "entityId": "supplier-offboarding-case",
            "purpose": "Read back the complete committed supplier offboarding case with authority, freshness and provenance for reconciliation and record drill-through."
          },
          {
            "access": "read",
            "entityId": "contract",
            "purpose": "Inventory active contractual dependencies and required change actions."
          },
          {
            "access": "read",
            "entityId": "purchase-order",
            "purpose": "Inventory open order commitments before restriction or exit."
          },
          {
            "access": "read",
            "entityId": "supplier-remediation-action",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "supplier-offboarding-case",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "supplier-performance-signal",
            "purpose": "Read an authorised supplier-performance-signal record by stable identity through supplier-performance-monitor-correct's owner API; this grants no collection browsing or datastore access."
          },
          {
            "access": "read",
            "entityId": "action-proposal",
            "purpose": "Point-read the exact permission-safe D9 handoff action-proposal record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "decision",
            "purpose": "Point-read the exact permission-safe D9 handoff decision record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "committed-action",
            "purpose": "Point-read the exact permission-safe D9 handoff committed-action record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "business-event",
            "purpose": "Point-read the exact permission-safe D9 handoff business-event record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "create",
            "entityId": "decision",
            "purpose": "Submit the authorised, version-pinned D9 receiving-owner acceptance, rejection, redirect, expiry or reopen decision to shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "committed-action",
            "purpose": "Append each authorised D9 delivery or receiver-owned command attempt with idempotency, safe-retry and reconciliation state through shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "business-event",
            "purpose": "Append immutable D9 delivery, acknowledgement, rejection, reconciliation, replay or reopen facts through audit-event-service; an event never becomes current domain state."
          }
        ],
        "descriptionKey": "workblock.supplier-remediation.description",
        "descriptorKey": "workblock.supplier-remediation.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "supplier-lifecycle-third-party-risk",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "onboarding-coordinator",
              "supplier-master-steward",
              "accountable-risk-owner",
              "tprm-programme-owner",
              "supplier-contact"
            ],
            "id": "plan-remediation-or-exit",
            "jobIds": [
              "supplier-remediation-exit.corrective-plan",
              "supplier-remediation-exit.coordinated-progress",
              "supplier-remediation-exit.verify-recovery",
              "supplier-remediation-exit.controlled-exit"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: treatment context, authority reference, remediation candidates, exit candidate, dependency inventory, plan critic result, remediation action ids, offboarding case id, and mission plan.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "accountable-risk-owner",
                "tprm-programme-owner",
                "onboarding-coordinator",
                "supplier-contact"
              ]
            },
            "kind": "analyse",
            "label": "Plan remediation or exit",
            "trigger": "risk_treatment_or_exit_decision"
          },
          {
            "agentIds": [
              "supplier-remediation-agent",
              "supplier-exit-agent"
            ],
            "escalationRoleIds": [
              "onboarding-coordinator",
              "supplier-master-steward",
              "accountable-risk-owner",
              "tprm-programme-owner",
              "supplier-contact"
            ],
            "id": "pursue-remediation",
            "jobIds": [
              "supplier-remediation-exit.corrective-plan",
              "supplier-remediation-exit.coordinated-progress",
              "supplier-remediation-exit.verify-recovery",
              "supplier-remediation-exit.controlled-exit"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: follow up actions, evidence submissions, verification results, remediation exceptions, remediation statuses, and next mission plan.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "accountable-risk-owner",
                "tprm-programme-owner",
                "onboarding-coordinator",
                "supplier-contact"
              ]
            },
            "kind": "agent",
            "label": "Pursue remediation",
            "trigger": "mission_plan"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "onboarding-coordinator",
              "supplier-master-steward",
              "accountable-risk-owner",
              "tprm-programme-owner",
              "supplier-contact"
            ],
            "id": "orchestrate-exit",
            "jobIds": [
              "supplier-remediation-exit.corrective-plan",
              "supplier-remediation-exit.coordinated-progress",
              "supplier-remediation-exit.verify-recovery",
              "supplier-remediation-exit.controlled-exit"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: dependency action receipts, residual exceptions, dependency state, completion candidate, exit critic result, offboarding status, and supplier exit completed event.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "accountable-risk-owner",
                "tprm-programme-owner",
                "onboarding-coordinator",
                "supplier-contact"
              ]
            },
            "kind": "operate",
            "label": "Orchestrate exit",
            "trigger": "offboarding_case_id"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "onboarding-coordinator",
              "supplier-master-steward",
              "accountable-risk-owner",
              "tprm-programme-owner",
              "supplier-contact"
            ],
            "id": "read-remediation-exit",
            "jobIds": [
              "supplier-remediation-exit.corrective-plan",
              "supplier-remediation-exit.coordinated-progress",
              "supplier-remediation-exit.verify-recovery",
              "supplier-remediation-exit.controlled-exit"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: action plan view, evidence outcome view, exit dependency view, and freshness view.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "accountable-risk-owner",
                "tprm-programme-owner",
                "onboarding-coordinator",
                "supplier-contact"
              ]
            },
            "kind": "read",
            "label": "Read remediation and exit",
            "trigger": "ui_remediation_exit_query"
          }
        ],
        "futureStateKey": "workblock.supplier-remediation.future-state",
        "hiredInsteadKey": "workblock.supplier-remediation.hired-instead",
        "id": "supplier-remediation-exit",
        "implementationStatus": "roadmap",
        "jobStatementKey": "workblock.supplier-remediation.job",
        "jobStories": [
          {
            "completionKey": "workblock.supplier-remediation.story.corrective-plan.completion",
            "executionFlowIds": [
              "plan-remediation-or-exit",
              "pursue-remediation",
              "orchestrate-exit",
              "read-remediation-exit"
            ],
            "id": "supplier-remediation-exit.corrective-plan",
            "roleCardId": "accountable-risk-owner",
            "storyKey": "workblock.supplier-remediation.story.corrective-plan.story"
          },
          {
            "completionKey": "workblock.supplier-remediation.story.coordinated-progress.completion",
            "executionFlowIds": [
              "plan-remediation-or-exit",
              "pursue-remediation",
              "orchestrate-exit",
              "read-remediation-exit"
            ],
            "id": "supplier-remediation-exit.coordinated-progress",
            "roleCardId": "supplier-contact",
            "storyKey": "workblock.supplier-remediation.story.coordinated-progress.story"
          },
          {
            "completionKey": "workblock.supplier-remediation.story.verify-recovery.completion",
            "executionFlowIds": [
              "plan-remediation-or-exit",
              "pursue-remediation",
              "orchestrate-exit",
              "read-remediation-exit"
            ],
            "id": "supplier-remediation-exit.verify-recovery",
            "roleCardId": "tprm-programme-owner",
            "storyKey": "workblock.supplier-remediation.story.verify-recovery.story"
          },
          {
            "completionKey": "workblock.supplier-remediation.story.controlled-exit.completion",
            "executionFlowIds": [
              "plan-remediation-or-exit",
              "pursue-remediation",
              "orchestrate-exit",
              "read-remediation-exit"
            ],
            "id": "supplier-remediation-exit.controlled-exit",
            "roleCardId": "accountable-risk-owner",
            "storyKey": "workblock.supplier-remediation.story.controlled-exit.story"
          }
        ],
        "labelKey": "workblock.supplier-remediation.label",
        "metrics": [
          "On-time verified remediation: verified by due-at / actions due",
          "False-closure and reopened-action rates",
          "High-risk overdue count and cumulative days at risk",
          "Median evidence-submission to verification time",
          "Mission follow-up effectiveness and unnecessary-contact rate",
          "Exit completeness: reconciled mandatory dependencies / mandatory dependencies",
          "Incomplete exit completion count; target zero",
          "Risk recurrence after verified remediation"
        ],
        "operatingModel": "The Workblock owns remediation-action and supplier-offboarding cases. Mission-bounded agents pursue evidence, deadlines and routine follow-through across suppliers and internal owners; authority-bound restriction or exit decisions trigger a dependency graph covering contracts, orders, invoices, access, data, assets and continuity, with receipt-level reconciliation.",
        "outcomeKey": "workblock.supplier-remediation.outcome",
        "prerequisites": [
          "Access to the canonical supplier record and the originating risk decisions",
          "Read access to active contracts and open purchase orders",
          "An inventory of supplier access, data, asset and continuity dependencies",
          "Verification standards for corrective-action evidence",
          "Named accountable owners for waivers, restrictions and exit decisions"
        ],
        "toolKey": "workblock.supplier-remediation.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Clarify material gaps",
              "Rank current options",
              "Select a deterministic default within explicit requester preferences",
              "Create downstream handoffs",
              "Stop unsupported or prohibited demand"
            ],
            "escalationTriggers": [
              "No compliant option",
              "Novel or sensitive demand",
              "Material ambiguity after interaction budget",
              "New supplier, threshold exception or prohibited category"
            ],
            "id": "requester-buying-agent",
            "label": "Requester buying agent",
            "mission": "Understand one business need and complete the shortest current policy-valid buying route within a bounded interaction and value envelope.",
            "operatorRoleIds": [
              "budget-owner"
            ],
            "personaIds": [
              "requester-persona",
              "buyer"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "requester",
              "procurement-buyer",
              "budget-owner"
            ]
          },
          {
            "autonomousActions": [
              "Remove stale options",
              "Block unsupported route",
              "Require clarification",
              "Demote a category cohort"
            ],
            "escalationTriggers": [
              "False compliant recommendation",
              "Systemic stale catalogue",
              "Policy conflict",
              "Downstream rejection drift"
            ],
            "id": "buying-guidance-critic",
            "label": "Buying guidance critic",
            "mission": "Challenge option completeness, freshness, policy fidelity and hidden commitment before a route is presented or executed.",
            "operatorRoleIds": [
              "budget-owner"
            ],
            "personaIds": [
              "buyer",
              "platform-operator"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "requester",
              "procurement-buyer",
              "budget-owner"
            ]
          },
          {
            "autonomousActions": [
              "Resolve which repeat demand is in scope for a coverage assessment",
              "Read catalogue content and contracted entitlements as the position evidence",
              "Measure content, adoption and price-integrity gaps with named records",
              "Propose catalogue additions and corrections to the owning curator",
              "Expire coverage findings whose demand pattern or content position lapses"
            ],
            "escalationTriggers": [
              "A proposed addition has no contracted supplier or entitlement behind it",
              "Catalogue or contract position evidence is stale or conflicting",
              "A price-integrity gap exceeds the configured variance tolerance",
              "A finding implies changing a supplier commitment or contract term",
              "Any content release or catalogue edit is requested"
            ],
            "id": "catalogue-coverage-agent",
            "label": "Catalogue coverage agent",
            "mission": "Measure where repeat demand lacks governed content, where covered demand still routes off-catalogue, and where catalogue prices drift from contract, and propose the content fixes that close each gap.",
            "operatorRoleIds": [
              "procurement-buyer"
            ],
            "personaIds": [
              "buyer",
              "requester-persona",
              "category-management-persona"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "procurement-buyer",
              "requester"
            ]
          }
        ],
        "agentStoryKey": "workblock.guided-buying.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "No current compliant option",
            "New supplier or policy exception",
            "Sensitive, prohibited, novel or high-consequence category",
            "Material ambiguity after interaction budget",
            "Conflicting policy, contract, price or supplier evidence"
          ],
          "authorityEnvelope": [
            "Mission defines requester, business unit, category, maximum value, duration, interaction budget and permitted routes",
            "May clarify, retrieve, rank, select explicitly deterministic defaults and create non-committed downstream requests",
            "May not create a purchase order, onboard a new supplier, override policy or commit spend from this Workblock",
            "Category, route, supplier-source and handoff kill switches are mandatory"
          ],
          "humanSupervision": [
            "Own buying, category and routing policies",
            "Review samples of compliant and no-result journeys",
            "Handle novel, high-value or policy-exception demand",
            "Monitor false guidance, requester effort and downstream rework"
          ],
          "rollback": [
            "Cancel or supersede an uncommitted downstream request",
            "Restore the last-good option set and mark sources stale",
            "Correct classification and reroute through an auditable new selection",
            "Stop the mission and clear future tool actions",
            "Demote the affected category, route or source cohort"
          ],
          "targetPosture": "mission_autonomous_with_supervision"
        },
        "coreValue": "Help a requester describe the outcome they need once and move immediately to the best current, policy-valid route, whether catalogue, contract, requisition, spot buy, sourcing or stop, without learning procurement structure.",
        "currentStateKey": "workblock.guided-buying.current-state",
        "dataMappings": [
          {
            "access": "create",
            "entityId": "buying-request",
            "purpose": "Create the normalised pre-requisition statement of need."
          },
          {
            "access": "update",
            "entityId": "buying-request",
            "purpose": "Commit clarified intent, source-linked options and selected route."
          },
          {
            "access": "read",
            "entityId": "catalogue-line",
            "purpose": "Present only current selectable catalogue offerings."
          },
          {
            "access": "index",
            "entityId": "catalogue-line",
            "purpose": "Provide derived semantic and keyword retrieval that always resolves back to canonical lines."
          },
          {
            "access": "read",
            "entityId": "supplier-profile",
            "purpose": "Filter options by current supplier identity and lifecycle."
          },
          {
            "access": "read",
            "entityId": "supplier-qualification",
            "purpose": "Enforce scope-specific supplier eligibility and restrictions."
          },
          {
            "access": "read",
            "entityId": "contract",
            "purpose": "Verify governing contract availability and current term."
          },
          {
            "access": "read",
            "entityId": "party",
            "purpose": "Read the policy-filtered canonical party projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "business-unit",
            "purpose": "Read the policy-filtered canonical business unit projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "category",
            "purpose": "Read the policy-filtered canonical category projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "item-service",
            "purpose": "Read the policy-filtered canonical item or service projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "source-record-reference",
            "purpose": "Read the policy-filtered canonical source record reference projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "policy",
            "purpose": "Read the policy-filtered canonical policy projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "policy-version",
            "purpose": "Read the policy-filtered canonical policy version projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "authority-envelope",
            "purpose": "Read the policy-filtered canonical authority envelope projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "evaluation-result",
            "purpose": "Read the policy-filtered canonical evaluation result projection from learning-evaluation-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "integration-state",
            "purpose": "Read the policy-filtered canonical integration state projection from integration-state-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "registry-release",
            "purpose": "Read the policy-filtered canonical registry release projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "contract-entitlement",
            "purpose": "Read the policy-filtered canonical contract-entitlement projection from obligation-monitoring; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "buying-request",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "buying-request",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          }
        ],
        "descriptionKey": "workblock.guided-buying.description",
        "descriptorKey": "workblock.guided-buying.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "buying-ordering-receiving",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "procurement-buyer",
              "budget-owner",
              "receiver",
              "integration-owner"
            ],
            "id": "capture-need",
            "jobIds": [
              "guided-buying.route-need",
              "guided-buying.approve-with-context",
              "guided-buying.resolve-off-path",
              "guided-buying.fix-the-source",
              "guided-buying.one-write"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The need-context preserves the original request, material-gaps and clarified-need distinguish supplied from inferred facts, and the buying-request-id and option-request identify one durable case ready for option assembly.",
                "Accepted and rejected inputs are counted, source-linked and assigned a freshness state; a failed refresh retains last-good data.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "requester",
                "procurement-buyer",
                "budget-owner"
              ]
            },
            "kind": "ingest",
            "label": "Capture need",
            "trigger": "buying_need_submitted"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "procurement-buyer",
              "budget-owner",
              "receiver",
              "integration-owner"
            ],
            "id": "assemble-options",
            "jobIds": [
              "guided-buying.route-need",
              "guided-buying.approve-with-context",
              "guided-buying.resolve-off-path",
              "guided-buying.fix-the-source",
              "guided-buying.one-write"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The option-set and route-candidate retain catalogue-options, contract-options, route-options, policy-results, eligibility-results, source-freshness and the guidance-critic-result, including blocked and unresolved paths.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "procurement-buyer",
                "requester",
                "budget-owner"
              ]
            },
            "kind": "analyse",
            "label": "Assemble options",
            "trigger": "option_request"
          },
          {
            "agentIds": [
              "requester-buying-agent",
              "buying-guidance-critic"
            ],
            "escalationRoleIds": [
              "requester",
              "procurement-buyer",
              "budget-owner",
              "receiver",
              "integration-owner"
            ],
            "id": "route-request",
            "jobIds": [
              "guided-buying.route-need",
              "guided-buying.approve-with-context",
              "guided-buying.resolve-off-path",
              "guided-buying.fix-the-source",
              "guided-buying.one-write"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The selected-route, route-handoff and downstream-run-ref identify the authorised destination; the handoff-receipt, buying-request-status and route-outcome-event confirm acceptance or retain a named blocking exception.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "procurement-buyer",
                "requester",
                "budget-owner"
              ]
            },
            "kind": "agent",
            "label": "Route request",
            "trigger": "route_candidate"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "procurement-buyer",
              "budget-owner",
              "receiver",
              "integration-owner"
            ],
            "id": "read-guided-buying",
            "jobIds": [
              "guided-buying.route-need",
              "guided-buying.approve-with-context",
              "guided-buying.resolve-off-path",
              "guided-buying.fix-the-source",
              "guided-buying.one-write"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The buying-request-view, option-evidence-view, downstream-status-view and freshness-view show current or clearly stale last-good state and drill to the facts and receipt behind the route.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "requester",
                "procurement-buyer",
                "budget-owner"
              ]
            },
            "kind": "read",
            "label": "Read guided buying",
            "trigger": "ui_buying_request_query"
          },
          {
            "agentIds": [
              "catalogue-coverage-agent"
            ],
            "escalationRoleIds": [
              "procurement-buyer",
              "budget-owner"
            ],
            "id": "assess-catalogue-coverage",
            "jobIds": [
              "guided-buying.catalogue-coverage"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: catalogue coverage assessment and catalogue addition proposal.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "procurement-buyer"
              ]
            },
            "kind": "agent",
            "label": "Assess catalogue coverage",
            "trigger": "Repeat demand without covering content, covered demand routed off-catalogue, or catalogue price drifting from the contracted position."
          }
        ],
        "futureStateKey": "workblock.guided-buying.future-state",
        "hiredInsteadKey": "workblock.guided-buying.hired-instead",
        "id": "guided-buying",
        "implementationStatus": "pattern",
        "jobStatementKey": "workblock.guided-buying.job",
        "jobStories": [
          {
            "completionKey": "workblock.guided-buying.story.route-need.completion",
            "executionFlowIds": [
              "capture-need",
              "assemble-options",
              "route-request",
              "read-guided-buying"
            ],
            "id": "guided-buying.route-need",
            "roleCardId": "requester",
            "storyKey": "workblock.guided-buying.story.route-need.story"
          },
          {
            "completionKey": "workblock.guided-buying.story.approve-with-context.completion",
            "executionFlowIds": [
              "capture-need",
              "assemble-options",
              "route-request",
              "read-guided-buying"
            ],
            "id": "guided-buying.approve-with-context",
            "roleCardId": "budget-owner",
            "storyKey": "workblock.guided-buying.story.approve-with-context.story"
          },
          {
            "completionKey": "workblock.guided-buying.story.resolve-off-path.completion",
            "executionFlowIds": [
              "capture-need",
              "assemble-options",
              "route-request",
              "read-guided-buying"
            ],
            "id": "guided-buying.resolve-off-path",
            "roleCardId": "procurement-buyer",
            "storyKey": "workblock.guided-buying.story.resolve-off-path.story"
          },
          {
            "completionKey": "workblock.guided-buying.story.fix-the-source.completion",
            "executionFlowIds": [
              "capture-need",
              "assemble-options",
              "route-request",
              "read-guided-buying"
            ],
            "id": "guided-buying.fix-the-source",
            "roleCardId": "procurement-buyer",
            "storyKey": "workblock.guided-buying.story.fix-the-source.story"
          },
          {
            "completionKey": "workblock.guided-buying.story.one-write.completion",
            "executionFlowIds": [
              "capture-need",
              "assemble-options",
              "route-request",
              "read-guided-buying"
            ],
            "id": "guided-buying.one-write",
            "roleCardId": "procurement-buyer",
            "storyKey": "workblock.guided-buying.story.one-write.story"
          },
          {
            "completionKey": "workblock.guided-buying.story.catalogue-coverage.completion",
            "executionFlowIds": [
              "assess-catalogue-coverage"
            ],
            "id": "guided-buying.catalogue-coverage",
            "roleCardId": "procurement-buyer",
            "storyKey": "workblock.guided-buying.story.catalogue-coverage.story"
          }
        ],
        "labelKey": "workblock.guided-buying.label",
        "metrics": [
          "Time to valid route: need submission to accepted downstream handoff",
          "First-pass downstream acceptance: accepted handoffs / handoffs",
          "False compliant recommendation rate",
          "Requester effort: median clarification turns and fields",
          "No-current-option rate by category with reasons",
          "Stale option exposure and source freshness",
          "Route correction and downstream rework rate",
          "Mission completion within interaction and duration budget"
        ],
        "operatingModel": "The Workblock owns pre-requisition buying-request state and catalogue-line projections. A mission-bounded requester agent clarifies only material gaps, classifies the need, assembles options from current policy, supplier, contract and catalogue evidence, explains constraints, records the requester or delegated selection and hands a complete typed payload to the chosen downstream Workblock.",
        "outcomeKey": "workblock.guided-buying.outcome",
        "prerequisites": [
          "Current catalogue lines with effective prices and availability",
          "Access to the canonical supplier record and qualification state",
          "Read access to governing contracts and their current terms",
          "Buying, category and routing policies in evaluable form",
          "Business-unit and category reference data for requester scope"
        ],
        "toolKey": "workblock.guided-buying.tool",
        "version": "5.2.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Create requisitions",
              "Validate and enrich fields",
              "Resolve deterministic coding gaps",
              "Reserve budget",
              "Route conforming requisitions"
            ],
            "escalationTriggers": [
              "Non-catalogue or new supplier",
              "Threshold or policy exception",
              "Budget conflict",
              "Ambiguous accounting or split-purchase concern"
            ],
            "id": "requisition-policy-agent",
            "label": "Requisition policy agent",
            "mission": "Produce a complete order-ready requisition by resolving routine validation and routing work inside current policy.",
            "operatorRoleIds": [
              "budget-owner"
            ],
            "personaIds": [
              "buyer",
              "requester-persona",
              "finance"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "procurement-buyer",
              "requester",
              "budget-owner"
            ]
          },
          {
            "autonomousActions": [
              "Block stale conversion",
              "Expire invalid approval",
              "Release orphan budget reservation",
              "Demote a route cohort"
            ],
            "escalationTriggers": [
              "False approval",
              "Budget double reservation",
              "Policy drift",
              "Commitment input integrity failure"
            ],
            "id": "requisition-critic-agent",
            "label": "Requisition commitment critic",
            "mission": "Independently verify freshness, line totals, policy, budget and authority before order-ready publication.",
            "operatorRoleIds": [
              "budget-owner"
            ],
            "personaIds": [
              "buyer",
              "finance",
              "platform-operator"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "procurement-buyer",
              "requester",
              "budget-owner"
            ]
          }
        ],
        "agentStoryKey": "workblock.requisition-routing.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "New supplier, non-catalogue or threshold exception",
            "Budget shortfall or accounting ambiguity",
            "Split-purchase or conflict-of-interest concern",
            "Stale critical policy, supplier, contract or budget evidence",
            "Any approval outside deterministic delegation"
          ],
          "authorityEnvelope": [
            "May validate, enrich, calculate, reserve budget and route conforming requisitions within listed entities, categories, values and accounting scopes",
            "May mark approved only when a deterministic policy allows straight-through approval or all explicit decisions exist",
            "May not waive policy, fabricate accounting, override budget or change supplier eligibility",
            "Category, budget, route and publication kill switches plus idempotency keys are mandatory"
          ],
          "humanSupervision": [
            "Own requisition, accounting, budget and authority policies",
            "Inspect sampled straight-through requisitions and downstream corrections",
            "Resolve non-deterministic commercial, policy, budget and accounting exceptions",
            "Monitor false approval, touch, cycle time and control outcomes"
          ],
          "rollback": [
            "Cancel or return an uncommitted requisition for repair",
            "Release or correct an orphan budget reservation",
            "Expire decisions bound to stale requisition state",
            "Restore last-good policy projection and block publication",
            "Demote the affected route, category or accounting cohort"
          ],
          "targetPosture": "policy_autonomous_with_monitoring"
        },
        "coreValue": "Turn a valid business need into a complete, budget-aware and policy-conforming requisition that follows the minimum necessary authority path and is ready for commitment without avoidable rework.",
        "currentStateKey": "workblock.requisition-routing.current-state",
        "dataMappings": [
          {
            "access": "read",
            "entityId": "buying-request",
            "purpose": "Preserve original business intent and route evidence."
          },
          {
            "access": "create",
            "entityId": "requisition",
            "purpose": "Create the governed commitment request header."
          },
          {
            "access": "update",
            "entityId": "requisition",
            "purpose": "Commit recalculation, policy, budget, decision and conversion state."
          },
          {
            "access": "create",
            "entityId": "requisition-line",
            "purpose": "Create separately validated and routable requested lines."
          },
          {
            "access": "update",
            "entityId": "requisition-line",
            "purpose": "Commit requester repairs and deterministic validation outcomes."
          },
          {
            "access": "read",
            "entityId": "catalogue-line",
            "purpose": "Verify effective offer, price and buying constraints."
          },
          {
            "access": "read",
            "entityId": "supplier-profile",
            "purpose": "Verify current supplier lifecycle and base eligibility."
          },
          {
            "access": "read",
            "entityId": "supplier-qualification",
            "purpose": "Enforce scoped qualification conditions at request time."
          },
          {
            "access": "read",
            "entityId": "budget",
            "purpose": "Read the governed budget contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "requisition",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "requisition-line",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "requisition",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "requisition-line",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "policy-change-impact",
            "purpose": "Read an authorised policy-change-impact record by stable identity through policy-rule-lifecycle's owner API; this grants no collection browsing or datastore access."
          },
          {
            "access": "read",
            "entityId": "action-proposal",
            "purpose": "Point-read the exact permission-safe D3 handoff action-proposal record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "decision",
            "purpose": "Point-read the exact permission-safe D3 handoff decision record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "committed-action",
            "purpose": "Point-read the exact permission-safe D3 handoff committed-action record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "business-event",
            "purpose": "Point-read the exact permission-safe D3 handoff business-event record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "create",
            "entityId": "decision",
            "purpose": "Submit the authorised, version-pinned D3 receiving-owner acceptance, rejection, redirect, expiry or reopen decision to shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "committed-action",
            "purpose": "Append each authorised D3 delivery or receiver-owned command attempt with idempotency, safe-retry and reconciliation state through shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "business-event",
            "purpose": "Append immutable D3 delivery, acknowledgement, rejection, reconciliation, replay or reopen facts through audit-event-service; an event never becomes current domain state."
          }
        ],
        "descriptionKey": "workblock.requisition-routing.description",
        "descriptorKey": "workblock.requisition-routing.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "buying-ordering-receiving",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "procurement-buyer",
              "budget-owner",
              "receiver",
              "integration-owner"
            ],
            "id": "build-requisition",
            "jobIds": [
              "requisition-policy-routing.validate-lines",
              "requisition-policy-routing.material-question",
              "requisition-policy-routing.budget-authority",
              "requisition-policy-routing.commitment-input"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: requisition header, requisition line candidates, validated lines, line exceptions, requisition id, requisition line ids, and policy request.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "procurement-buyer",
                "requester",
                "budget-owner"
              ]
            },
            "kind": "operate",
            "label": "Build requisition",
            "trigger": "route_handoff"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "procurement-buyer",
              "budget-owner",
              "receiver",
              "integration-owner"
            ],
            "id": "evaluate-and-route",
            "jobIds": [
              "requisition-policy-routing.validate-lines",
              "requisition-policy-routing.material-question",
              "requisition-policy-routing.budget-authority",
              "requisition-policy-routing.commitment-input"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: policy evaluation, remediation actions, budget reservation, budget result, approval plan, and approval wait.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "procurement-buyer",
                "requester",
                "budget-owner"
              ]
            },
            "kind": "analyse",
            "label": "Evaluate and route",
            "trigger": "policy_request"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "procurement-buyer",
              "budget-owner",
              "receiver",
              "integration-owner"
            ],
            "id": "approve-and-publish",
            "jobIds": [
              "requisition-policy-routing.validate-lines",
              "requisition-policy-routing.material-question",
              "requisition-policy-routing.budget-authority",
              "requisition-policy-routing.commitment-input"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: approval state, requisition critic result, requisition status, order ready event, and budget reconciliation.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "procurement-buyer",
                "requester",
                "budget-owner"
              ]
            },
            "kind": "operate",
            "label": "Approve and publish",
            "trigger": "approval_wait"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "procurement-buyer",
              "budget-owner",
              "receiver",
              "integration-owner"
            ],
            "id": "read-requisition",
            "jobIds": [
              "requisition-policy-routing.validate-lines",
              "requisition-policy-routing.material-question",
              "requisition-policy-routing.budget-authority",
              "requisition-policy-routing.commitment-input"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: requisition view, line policy view, budget approval view, and freshness view.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "procurement-buyer",
                "requester",
                "budget-owner"
              ]
            },
            "kind": "read",
            "label": "Read requisition",
            "trigger": "ui_requisition_query"
          }
        ],
        "futureStateKey": "workblock.requisition-routing.future-state",
        "hiredInsteadKey": "workblock.requisition-routing.hired-instead",
        "id": "requisition-policy-routing",
        "implementationStatus": "roadmap",
        "jobStatementKey": "workblock.requisition-routing.job",
        "jobStories": [
          {
            "completionKey": "workblock.requisition-routing.story.validate-lines.completion",
            "executionFlowIds": [
              "build-requisition",
              "evaluate-and-route",
              "approve-and-publish",
              "read-requisition"
            ],
            "id": "requisition-policy-routing.validate-lines",
            "roleCardId": "procurement-buyer",
            "storyKey": "workblock.requisition-routing.story.validate-lines.story"
          },
          {
            "completionKey": "workblock.requisition-routing.story.material-question.completion",
            "executionFlowIds": [
              "build-requisition",
              "evaluate-and-route",
              "approve-and-publish",
              "read-requisition"
            ],
            "id": "requisition-policy-routing.material-question",
            "roleCardId": "requester",
            "storyKey": "workblock.requisition-routing.story.material-question.story"
          },
          {
            "completionKey": "workblock.requisition-routing.story.budget-authority.completion",
            "executionFlowIds": [
              "build-requisition",
              "evaluate-and-route",
              "approve-and-publish",
              "read-requisition"
            ],
            "id": "requisition-policy-routing.budget-authority",
            "roleCardId": "budget-owner",
            "storyKey": "workblock.requisition-routing.story.budget-authority.story"
          },
          {
            "completionKey": "workblock.requisition-routing.story.commitment-input.completion",
            "executionFlowIds": [
              "build-requisition",
              "evaluate-and-route",
              "approve-and-publish",
              "read-requisition"
            ],
            "id": "requisition-policy-routing.commitment-input",
            "roleCardId": "procurement-buyer",
            "storyKey": "workblock.requisition-routing.story.commitment-input.story"
          }
        ],
        "labelKey": "workblock.requisition-routing.label",
        "metrics": [
          "Requisition first-pass validity: order-ready without repair / submitted requisitions",
          "Straight-through policy eligibility rate for routine cases",
          "False permission and missed-exception rates",
          "Median requester repair and authority cycle time",
          "Reduction in unnecessary approval ceremonies with no increase in control failures",
          "Budget reservation reconciliation and duplicate count",
          "Order conversion success and downstream exception rate",
          "Stale control exposure before publication"
        ],
        "operatingModel": "The Workblock owns requisition header and line state. It validates suppliers, items, price, contract, accounting, budget and delivery at line level, derives deterministic policy exceptions and authority, obtains required decisions, reserves budget and publishes one approved version for purchase-order orchestration.",
        "outcomeKey": "workblock.requisition-routing.outcome",
        "prerequisites": [
          "A connection to the ERP budget check and reservation function",
          "Requisition, accounting and authority policies in deterministic form",
          "Current catalogue lines for offer and price validation",
          "Access to the canonical supplier record and qualification conditions",
          "Named approvers mapped to delegation-of-authority thresholds"
        ],
        "toolKey": "workblock.requisition-routing.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Split orders by deterministic rules",
              "Create and dispatch eligible approved orders",
              "Retry idempotently",
              "Reconcile acknowledgements and fulfillment"
            ],
            "escalationTriggers": [
              "Stale authority or price",
              "New supplier or threshold exception",
              "Uncertain downstream commitment state",
              "Material supplier change or rejection"
            ],
            "id": "purchase-order-agent",
            "label": "Purchase order orchestration agent",
            "mission": "Create, dispatch and reconcile authorised routine order commitments exactly once using typed transaction tools.",
            "operatorRoleIds": [
              "integration-owner"
            ],
            "personaIds": [
              "buyer",
              "finance"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "procurement-buyer",
              "integration-owner"
            ]
          },
          {
            "autonomousActions": [
              "Record acknowledgements",
              "Close exact acceptances",
              "Open change exceptions",
              "Request missing response detail"
            ],
            "escalationTriggers": [
              "Price, quantity or material schedule change",
              "Supplier rejection",
              "Identity or signature mismatch",
              "Response refers to unknown order version"
            ],
            "id": "order-response-agent",
            "label": "Order response agent",
            "mission": "Normalize supplier responses and route proposed differences without changing the committed order outside authority.",
            "operatorRoleIds": [
              "integration-owner"
            ],
            "personaIds": [
              "buyer",
              "requester-persona"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "procurement-buyer",
              "integration-owner"
            ]
          }
        ],
        "agentStoryKey": "workblock.po-orchestration.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "New supplier, non-catalogue threshold exception or stale authority",
            "Material supplier rejection, price, quantity or schedule change",
            "Uncertain ERP or supplier-network commitment state",
            "Contract, budget, supplier eligibility or delivery conflict",
            "Cancellation or irreversible change outside explicit grant"
          ],
          "authorityEnvelope": [
            "May create and dispatch only approved order-ready catalogue or contracted orders within listed suppliers, categories, entities, values and delivery rules",
            "May retry only with the same order-version idempotency key after reconciliation",
            "May record exact acknowledgements and open exceptions for any proposed change",
            "May not accept material supplier changes, create new-supplier commitments or exceed authority",
            "Per-supplier, route, value and integration kill switches are mandatory"
          ],
          "humanSupervision": [
            "Own order split, channel, change and commitment policies",
            "Inspect sampled autonomous orders and all material response exceptions",
            "Decide price, quantity, delivery and contract changes outside delegated tolerance",
            "Monitor duplicate, unauthorized, stale and unreconciled commitment measures"
          ],
          "rollback": [
            "Cancel uncommitted dispatch and release reserved resources",
            "Void or cancel a committed order only through an authorised order-cancellation transaction",
            "Correct reversible metadata through a new order version",
            "Restore last-good projection while reconciling uncertain state",
            "Duplicate or externally accepted orders require explicit recovery, not deletion",
            "Demote the affected supplier, route or integration cohort"
          ],
          "targetPosture": "policy_autonomous_with_monitoring"
        },
        "coreValue": "Convert an approved requisition into one accurate, acknowledged and continuously reconciled purchase-order commitment exactly once, while keeping supplier responses, changes and fulfillment visible at line level.",
        "currentStateKey": "workblock.po-orchestration.current-state",
        "dataMappings": [
          {
            "access": "read",
            "entityId": "requisition",
            "purpose": "Use only current approved order-ready requisitions."
          },
          {
            "access": "read",
            "entityId": "requisition-line",
            "purpose": "Create exact order-line lineage and serialization."
          },
          {
            "access": "read",
            "entityId": "supplier-profile",
            "purpose": "Revalidate supplier identity and ability to receive new commitments."
          },
          {
            "access": "read",
            "entityId": "contract",
            "purpose": "Revalidate governing terms and supplier scope."
          },
          {
            "access": "create",
            "entityId": "purchase-order",
            "purpose": "Create the canonical committed order header and exact commitment controls."
          },
          {
            "access": "update",
            "entityId": "purchase-order",
            "purpose": "Commit reconciled dispatch, acknowledgement, change, fulfillment and closure state."
          },
          {
            "access": "create",
            "entityId": "order-line",
            "purpose": "Create committed order lines with exact requisition lineage."
          },
          {
            "access": "update",
            "entityId": "order-line",
            "purpose": "Track acknowledged schedule and reconciled line fulfillment."
          },
          {
            "access": "create",
            "entityId": "order-response",
            "purpose": "Preserve supplier response evidence separately from committed order state."
          },
          {
            "access": "read",
            "entityId": "catalogue-line",
            "purpose": "Read the policy-filtered canonical catalogue line projection from catalogue-management-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "purchase-order",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "order-line",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "order-response",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "purchase-order",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "order-line",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "order-response",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          }
        ],
        "descriptionKey": "workblock.po-orchestration.description",
        "descriptorKey": "workblock.po-orchestration.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "buying-ordering-receiving",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "procurement-buyer",
              "budget-owner",
              "receiver",
              "integration-owner"
            ],
            "id": "prepare-order",
            "jobIds": [
              "purchase-order-orchestration.precommit-check",
              "purchase-order-orchestration.create-dispatch",
              "purchase-order-orchestration.supplier-response",
              "purchase-order-orchestration.state-reconciliation"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: order context, authority reference, commitment critic result, order candidates, serialized order refs, purchase order ids, and dispatch plan.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "procurement-buyer",
                "integration-owner"
              ]
            },
            "kind": "operate",
            "label": "Prepare order",
            "trigger": "order_ready_event"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "procurement-buyer",
              "budget-owner",
              "receiver",
              "integration-owner"
            ],
            "id": "dispatch-and-reconcile",
            "jobIds": [
              "purchase-order-orchestration.precommit-check",
              "purchase-order-orchestration.create-dispatch",
              "purchase-order-orchestration.supplier-response",
              "purchase-order-orchestration.state-reconciliation"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: erp order receipts, transport receipts, response waits, order statuses, and order dispatched events.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "procurement-buyer",
                "integration-owner"
              ]
            },
            "kind": "operate",
            "label": "Dispatch and reconcile",
            "trigger": "dispatch_plan"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "procurement-buyer",
              "budget-owner",
              "receiver",
              "integration-owner"
            ],
            "id": "process-responses",
            "jobIds": [
              "purchase-order-orchestration.precommit-check",
              "purchase-order-orchestration.create-dispatch",
              "purchase-order-orchestration.supplier-response",
              "purchase-order-orchestration.state-reconciliation"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: response artifact ref, response validity, order response id, response code, proposed changes, acknowledged order status, exception event, and fulfillment plan.",
                "Accepted and rejected inputs are counted, source-linked and assigned a freshness state; a failed refresh retains last-good data.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "procurement-buyer",
                "integration-owner"
              ]
            },
            "kind": "ingest",
            "label": "Process responses",
            "trigger": "supplier_order_response_or_timeout"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "procurement-buyer",
              "budget-owner",
              "receiver",
              "integration-owner"
            ],
            "id": "read-order",
            "jobIds": [
              "purchase-order-orchestration.precommit-check",
              "purchase-order-orchestration.create-dispatch",
              "purchase-order-orchestration.supplier-response",
              "purchase-order-orchestration.state-reconciliation"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: purchase order view, lineage view, response fulfillment view, and freshness view.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "procurement-buyer",
                "integration-owner"
              ]
            },
            "kind": "read",
            "label": "Read order",
            "trigger": "ui_purchase_order_query"
          }
        ],
        "futureStateKey": "workblock.po-orchestration.future-state",
        "hiredInsteadKey": "workblock.po-orchestration.hired-instead",
        "id": "purchase-order-orchestration",
        "implementationStatus": "roadmap",
        "jobStatementKey": "workblock.po-orchestration.job",
        "jobStories": [
          {
            "completionKey": "workblock.po-orchestration.story.precommit-check.completion",
            "executionFlowIds": [
              "prepare-order",
              "dispatch-and-reconcile",
              "process-responses",
              "read-order"
            ],
            "id": "purchase-order-orchestration.precommit-check",
            "roleCardId": "procurement-buyer",
            "storyKey": "workblock.po-orchestration.story.precommit-check.story"
          },
          {
            "completionKey": "workblock.po-orchestration.story.create-dispatch.completion",
            "executionFlowIds": [
              "prepare-order",
              "dispatch-and-reconcile",
              "process-responses",
              "read-order"
            ],
            "id": "purchase-order-orchestration.create-dispatch",
            "roleCardId": "integration-owner",
            "storyKey": "workblock.po-orchestration.story.create-dispatch.story"
          },
          {
            "completionKey": "workblock.po-orchestration.story.supplier-response.completion",
            "executionFlowIds": [
              "prepare-order",
              "dispatch-and-reconcile",
              "process-responses",
              "read-order"
            ],
            "id": "purchase-order-orchestration.supplier-response",
            "roleCardId": "procurement-buyer",
            "storyKey": "workblock.po-orchestration.story.supplier-response.story"
          },
          {
            "completionKey": "workblock.po-orchestration.story.state-reconciliation.completion",
            "executionFlowIds": [
              "prepare-order",
              "dispatch-and-reconcile",
              "process-responses",
              "read-order"
            ],
            "id": "purchase-order-orchestration.state-reconciliation",
            "roleCardId": "integration-owner",
            "storyKey": "workblock.po-orchestration.story.state-reconciliation.story"
          }
        ],
        "labelKey": "workblock.po-orchestration.label",
        "metrics": [
          "Order creation cycle time: order-ready to reconciled dispatch",
          "First-dispatch acceptance: orders acknowledged without correction / dispatched orders",
          "Duplicate and unauthorized commitment count; target zero",
          "Unacknowledged order aging by supplier and value",
          "Response normalization correction rate",
          "Order change and rejection rate with causes",
          "ERP-to-network reconciliation rate and uncertain-state age",
          "Line fulfillment accuracy and downstream invoice exception rate"
        ],
        "operatingModel": "The Workblock owns purchase-order, order-line and order-response records. It performs a final freshness and authority gate, creates and dispatches an idempotent order version, normalizes supplier acknowledgements without silently accepting changes, reconciles ERP and network states and publishes line-level fulfillment events for receiving and invoice matching.",
        "outcomeKey": "workblock.po-orchestration.outcome",
        "prerequisites": [
          "A write connection to the ERP purchase-order system with receipts",
          "A supplier network or equivalent dispatch and acknowledgement channel",
          "Approved, order-ready requisitions with line-level detail",
          "Read access to governing contracts and the canonical supplier record",
          "Change tolerances and named owners for out-of-tolerance supplier responses"
        ],
        "toolKey": "workblock.po-orchestration.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Create or correlate cases",
              "Retry idempotent failed dispatch",
              "Correct allow-listed reversible routing data",
              "Close exact duplicate alerts",
              "Prepare change proposals"
            ],
            "escalationTriggers": [
              "Material commercial change",
              "Uncertain commitment state",
              "Duplicate committed order",
              "Cancellation, new supplier or threshold exception"
            ],
            "id": "purchase-order-exception-agent",
            "label": "Purchase order exception agent",
            "mission": "Diagnose and resolve a bounded order exception with the fewest safe actions and complete downstream reconciliation.",
            "operatorRoleIds": [
              "integration-owner"
            ],
            "personaIds": [
              "buyer",
              "finance"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "procurement-buyer",
              "integration-owner",
              "receiver"
            ]
          },
          {
            "autonomousActions": [
              "Block unsafe resolution",
              "Reopen false closure",
              "Stop a degraded action cohort",
              "Select sampled cases"
            ],
            "escalationTriggers": [
              "Potential duplicate commitment",
              "Missing compensation path",
              "Unreconciled writeback",
              "Resolution recurrence drift"
            ],
            "id": "order-exception-critic",
            "label": "Order exception critic",
            "mission": "Challenge diagnosis, authority, reversibility, idempotency and reconciliation before action or closure.",
            "operatorRoleIds": [
              "integration-owner"
            ],
            "personaIds": [
              "buyer",
              "platform-operator"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "procurement-buyer",
              "integration-owner",
              "receiver"
            ]
          }
        ],
        "agentStoryKey": "workblock.po-exception.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Uncertain or duplicate commitment state",
            "Material price, quantity, date, supplier or contract change",
            "Cancellation, replacement or new spend",
            "Budget, policy or authority exception",
            "Mission needs action outside attempt, value, recipient or duration envelope"
          ],
          "authorityEnvelope": [
            "Mission defines one exception family, order set, permitted lifecycle actions, attempt budget, value, duration, recipients and stop conditions",
            "May retry with existing idempotency key, correct allow-listed reversible routing data and close deterministic duplicates",
            "May not accept supplier commercial changes, cancel commitments, override policy or create replacement spend without explicit authority",
            "Exception-class, action, supplier and integration kill switches are mandatory"
          ],
          "humanSupervision": [
            "Own exception, tolerance, retry and communication policies",
            "Inspect sampled low-risk resolutions and recurrence",
            "Decide material commercial, cancellation and replacement actions",
            "Monitor false closure, duplicate commitment, aging and downstream effects"
          ],
          "rollback": [
            "Stop mission and future actions immediately",
            "Reverse supported routing or metadata corrections through owner lifecycle tool",
            "Reopen false closure and restore last-good exception state",
            "Cancel uncommitted change proposal",
            "Committed duplicate, cancellation or supplier-accepted change requires explicit recovery workflow",
            "Demote the action or exception cohort"
          ],
          "targetPosture": "mission_autonomous_with_supervision"
        },
        "coreValue": "Resolve order failures and variances at the smallest safe scope, automatically where deterministic and reversible, while preserving the committed order, authority and supplier evidence behind every correction.",
        "currentStateKey": "workblock.po-exception.current-state",
        "dataMappings": [
          {
            "access": "read",
            "entityId": "purchase-order",
            "purpose": "Ground diagnosis in the exact committed order and authority state."
          },
          {
            "access": "read",
            "entityId": "order-line",
            "purpose": "Localize line-level variance and consequences."
          },
          {
            "access": "read",
            "entityId": "order-response",
            "purpose": "Use immutable supplier acknowledgement and change evidence."
          },
          {
            "access": "create",
            "entityId": "purchase-order-exception",
            "purpose": "Create one governed causal case per underlying order variance."
          },
          {
            "access": "update",
            "entityId": "purchase-order-exception",
            "purpose": "Track diagnosis, mission, decision and reconciled outcome."
          },
          {
            "access": "read",
            "entityId": "purchase-order-exception",
            "purpose": "Read back the complete committed purchase order exception with authority, freshness and provenance for reconciliation and record drill-through."
          },
          {
            "access": "read",
            "entityId": "shipment",
            "purpose": "Include current despatch and delivery evidence in schedule exceptions."
          },
          {
            "access": "read",
            "entityId": "receipt",
            "purpose": "Avoid order resolutions that conflict with committed receiving state."
          },
          {
            "access": "read",
            "entityId": "authority-envelope",
            "purpose": "Read the policy-filtered canonical authority envelope projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "action-proposal",
            "purpose": "Read the policy-filtered canonical action proposal projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "committed-action",
            "purpose": "Read the policy-filtered canonical committed action projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "decision",
            "purpose": "Read the policy-filtered canonical decision projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "exception",
            "purpose": "Read the policy-filtered canonical exception case projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "audit-event",
            "purpose": "Read the policy-filtered canonical audit event projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "business-event",
            "purpose": "Read the policy-filtered canonical business event projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "catalogue-line",
            "purpose": "Read the policy-filtered canonical catalogue line projection from catalogue-management-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "return-claim",
            "purpose": "Read the governed return or delivery claim contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "purchase-order-exception",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          }
        ],
        "descriptionKey": "workblock.po-exception.description",
        "descriptorKey": "workblock.po-exception.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "buying-ordering-receiving",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "procurement-buyer",
              "budget-owner",
              "receiver",
              "integration-owner"
            ],
            "id": "detect-exception",
            "jobIds": [
              "purchase-order-exception.choose-correction",
              "purchase-order-exception.reconcile-before-retry",
              "purchase-order-exception.business-consequence",
              "purchase-order-exception.record-what-arrived",
              "purchase-order-exception.clean-handoff"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: exception facts, deduplication key, order context, response context, integration context, purchase order exception id, and diagnosis request.",
                "Accepted and rejected inputs are counted, source-linked and assigned a freshness state; a failed refresh retains last-good data.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "procurement-buyer",
                "integration-owner",
                "receiver"
              ]
            },
            "kind": "ingest",
            "label": "Detect exception",
            "trigger": "order_exception_signal"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "procurement-buyer",
              "budget-owner",
              "receiver",
              "integration-owner"
            ],
            "id": "diagnose-resolution",
            "jobIds": [
              "purchase-order-exception.choose-correction",
              "purchase-order-exception.reconcile-before-retry",
              "purchase-order-exception.business-consequence",
              "purchase-order-exception.record-what-arrived",
              "purchase-order-exception.clean-handoff"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: exception type, root cause, severity, resolution options, authority requirements, rollback plan, resolution critic result, proposed resolution, and mission plan.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "procurement-buyer",
                "integration-owner",
                "receiver"
              ]
            },
            "kind": "analyse",
            "label": "Diagnose resolution",
            "trigger": "diagnosis_request"
          },
          {
            "agentIds": [
              "purchase-order-exception-agent",
              "order-exception-critic"
            ],
            "escalationRoleIds": [
              "requester",
              "procurement-buyer",
              "budget-owner",
              "receiver",
              "integration-owner"
            ],
            "id": "resolve-and-reconcile",
            "jobIds": [
              "purchase-order-exception.choose-correction",
              "purchase-order-exception.reconcile-before-retry",
              "purchase-order-exception.business-consequence",
              "purchase-order-exception.record-what-arrived",
              "purchase-order-exception.clean-handoff"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: resolution actions, action receipts, reconciled order state, residual exceptions, exception status, and exception outcome event.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "procurement-buyer",
                "integration-owner",
                "receiver"
              ]
            },
            "kind": "agent",
            "label": "Resolve and reconcile",
            "trigger": "mission_plan"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "procurement-buyer",
              "budget-owner",
              "receiver",
              "integration-owner"
            ],
            "id": "read-order-exception",
            "jobIds": [
              "purchase-order-exception.choose-correction",
              "purchase-order-exception.reconcile-before-retry",
              "purchase-order-exception.business-consequence",
              "purchase-order-exception.record-what-arrived",
              "purchase-order-exception.clean-handoff"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: exception case view, causal evidence view, action receipt view, and freshness view.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "procurement-buyer",
                "integration-owner",
                "receiver"
              ]
            },
            "kind": "read",
            "label": "Read order exception",
            "trigger": "ui_order_exception_query"
          }
        ],
        "futureStateKey": "workblock.po-exception.future-state",
        "hiredInsteadKey": "workblock.po-exception.hired-instead",
        "id": "purchase-order-exception",
        "implementationStatus": "pattern",
        "jobStatementKey": "workblock.po-exception.job",
        "jobStories": [
          {
            "completionKey": "workblock.po-exception.story.choose-correction.completion",
            "executionFlowIds": [
              "detect-exception",
              "diagnose-resolution",
              "resolve-and-reconcile",
              "read-order-exception"
            ],
            "id": "purchase-order-exception.choose-correction",
            "roleCardId": "procurement-buyer",
            "storyKey": "workblock.po-exception.story.choose-correction.story"
          },
          {
            "completionKey": "workblock.po-exception.story.reconcile-before-retry.completion",
            "executionFlowIds": [
              "detect-exception",
              "diagnose-resolution",
              "resolve-and-reconcile",
              "read-order-exception"
            ],
            "id": "purchase-order-exception.reconcile-before-retry",
            "roleCardId": "integration-owner",
            "storyKey": "workblock.po-exception.story.reconcile-before-retry.story"
          },
          {
            "completionKey": "workblock.po-exception.story.business-consequence.completion",
            "executionFlowIds": [
              "detect-exception",
              "diagnose-resolution",
              "resolve-and-reconcile",
              "read-order-exception"
            ],
            "id": "purchase-order-exception.business-consequence",
            "roleCardId": "requester",
            "storyKey": "workblock.po-exception.story.business-consequence.story"
          },
          {
            "completionKey": "workblock.po-exception.story.record-what-arrived.completion",
            "executionFlowIds": [
              "detect-exception",
              "diagnose-resolution",
              "resolve-and-reconcile",
              "read-order-exception"
            ],
            "id": "purchase-order-exception.record-what-arrived",
            "roleCardId": "receiver",
            "storyKey": "workblock.po-exception.story.record-what-arrived.story"
          },
          {
            "completionKey": "workblock.po-exception.story.clean-handoff.completion",
            "executionFlowIds": [
              "detect-exception",
              "diagnose-resolution",
              "resolve-and-reconcile",
              "read-order-exception"
            ],
            "id": "purchase-order-exception.clean-handoff",
            "roleCardId": "integration-owner",
            "storyKey": "workblock.po-exception.story.clean-handoff.story"
          }
        ],
        "labelKey": "workblock.po-exception.label",
        "metrics": [
          "Exception cycle time by class and severity",
          "First-resolution success: reconciled without reopen / resolved cases",
          "False closure and 30-day recurrence rates",
          "Duplicate-alert suppression rate with sampled miss audit",
          "Policy-bounded resolution rate for eligible cases",
          "Duplicate or unauthorized commitment count; target zero",
          "Uncertain-state age and reconciliation success",
          "Downstream receipt and invoice exception rate after resolution"
        ],
        "operatingModel": "The Workblock owns purchase-order-exception cases. It correlates dispatch failures, supplier responses, control changes, fulfillment variance and integration state, deduplicates cases, diagnoses cause, proposes or executes a bounded resolution through the order owner's typed lifecycle tools, and proves downstream state before closure.",
        "outcomeKey": "workblock.po-exception.outcome",
        "prerequisites": [
          "Read access to committed purchase orders, order lines and supplier responses",
          "Read access to shipment and receipt state",
          "Integration-state visibility across the ERP and supplier network",
          "Exception, tolerance and retry policies per exception family",
          "Named owners for commercial changes, cancellations and replacement spend"
        ],
        "toolKey": "workblock.po-exception.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "Normalize shipments",
              "Match high-confidence lines",
              "Commit evidence-complete routine receipts within tolerance",
              "Open variance cases",
              "Reconcile inventory and matching"
            ],
            "escalationTriggers": [
              "Ambiguous order match",
              "Quality or condition judgment",
              "Material overage, substitution or rejection",
              "Uncertain or duplicate receipt state"
            ],
            "id": "receiving-agent",
            "label": "Goods receiving agent",
            "mission": "Prepare and commit accurate routine goods receipts from current delivery evidence within explicit quantity, quality and authority tolerances.",
            "operatorRoleIds": [
              "integration-owner"
            ],
            "personaIds": [
              "requester-persona",
              "buyer"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "receiver",
              "procurement-buyer",
              "requester",
              "integration-owner"
            ]
          },
          {
            "autonomousActions": [
              "Validate periods and arithmetic",
              "Match evidence to ordered units",
              "Prepare acceptance proposals",
              "Commit explicitly delegated objective entries"
            ],
            "escalationTriggers": [
              "Subjective outcome acceptance",
              "Conflicting timesheet or deliverable",
              "Material partial acceptance or rejection",
              "Milestone or contract interpretation"
            ],
            "id": "service-acceptance-agent",
            "label": "Service acceptance agent",
            "mission": "Assemble a source-backed service-entry proposal and commit only deterministic or explicitly authorised acceptance.",
            "operatorRoleIds": [
              "integration-owner"
            ],
            "personaIds": [
              "requester-persona",
              "supplier-relationship-manager",
              "finance"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "receiver",
              "procurement-buyer",
              "requester",
              "integration-owner"
            ]
          },
          {
            "autonomousActions": [
              "Prepare routine return cases",
              "Request authorisation",
              "Track logistics",
              "Reconcile expected recovery"
            ],
            "escalationTriggers": [
              "Supplier dispute",
              "Material recovery",
              "Safety or recall issue",
              "Recovery overdue beyond policy"
            ],
            "id": "return-recovery-agent",
            "label": "Return and recovery agent",
            "mission": "Coordinate authorised return or delivery claims until the expected credit, replacement, repair or remedy is realized.",
            "operatorRoleIds": [
              "integration-owner"
            ],
            "personaIds": [
              "buyer",
              "finance"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "receiver",
              "procurement-buyer",
              "requester",
              "integration-owner"
            ]
          }
        ],
        "agentStoryKey": "workblock.receiving.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Ambiguous order or line match",
            "Subjective service outcome or quality decision",
            "Material excess, shortage, substitution, rejection or supplier dispute",
            "Safety, recall or restricted item issue",
            "Uncertain or duplicate ERP receipt state",
            "Acceptance outside location, value, quantity or authority envelope"
          ],
          "authorityEnvelope": [
            "May normalize shipments and prepare any goods or service acceptance proposal",
            "May commit routine goods receipts only for high-confidence order matches inside quantity, location, condition and value tolerances with current evidence",
            "May commit objective service entries only when the acceptance grant explicitly lists measurable criteria and value bounds",
            "May prepare and pursue routine returns after an authorised rejection",
            "Per-location, supplier, acceptance class and writeback kill switches are mandatory"
          ],
          "humanSupervision": [
            "Own receiving tolerance, proof, service acceptance and return policies",
            "Inspect sampled autonomous receipts and objective service entries",
            "Decide subjective quality, outcome, substitution, material variance and disputes",
            "Monitor false receipt, duplicate writeback, recovery and invoice-match outcomes"
          ],
          "rollback": [
            "Cancel an uncommitted acceptance proposal",
            "Reverse a committed receipt or service entry only through an authorised reversal transaction",
            "Correct line quantities through a new controlled version",
            "Stop return mission and future logistics actions",
            "Restore last-good delivery or recovery projection during source degradation",
            "Invoice or inventory effects require reconciled compensating transactions",
            "Demote the affected location, supplier or acceptance cohort"
          ],
          "targetPosture": "policy_autonomous_with_monitoring"
        },
        "coreValue": "Capture trustworthy evidence that goods or services were delivered, commit acceptance exactly once and route only real quantity, quality, service or recovery exceptions before invoice and payment decisions rely on them.",
        "currentStateKey": "workblock.receiving.current-state",
        "dataMappings": [
          {
            "access": "read",
            "entityId": "purchase-order",
            "purpose": "Resolve delivery and service claims to a current committed order."
          },
          {
            "access": "read",
            "entityId": "order-line",
            "purpose": "Calculate line-level goods and service acceptance."
          },
          {
            "access": "create",
            "entityId": "shipment",
            "purpose": "Normalize despatch and logistics evidence."
          },
          {
            "access": "update",
            "entityId": "shipment",
            "purpose": "Track current shipment observations while retaining source history."
          },
          {
            "access": "create",
            "entityId": "receipt",
            "purpose": "Create exactly-once goods receipt headers with evidence and authority."
          },
          {
            "access": "update",
            "entityId": "receipt",
            "purpose": "Track correction, reversal, dispute and reconciled closure."
          },
          {
            "access": "create",
            "entityId": "receipt-line",
            "purpose": "Commit accepted and rejected quantities against exact order lines."
          },
          {
            "access": "update",
            "entityId": "receipt-line",
            "purpose": "Record controlled correction or reversal without hiding prior financial evidence."
          },
          {
            "access": "read",
            "entityId": "receipt-line",
            "purpose": "Read back the complete committed receipt line with authority, freshness and provenance for reconciliation and record drill-through."
          },
          {
            "access": "create",
            "entityId": "service-entry-sheet",
            "purpose": "Create service delivery and acceptance records."
          },
          {
            "access": "update",
            "entityId": "service-entry-sheet",
            "purpose": "Track partial acceptance, correction, rejection and reversal."
          },
          {
            "access": "read",
            "entityId": "service-entry-sheet",
            "purpose": "Read back the complete committed service entry sheet with authority, freshness and provenance for reconciliation and record drill-through."
          },
          {
            "access": "create",
            "entityId": "return-claim",
            "purpose": "Create a governed return or delivery recovery case."
          },
          {
            "access": "update",
            "entityId": "return-claim",
            "purpose": "Track authorisation, logistics and realized recovery."
          },
          {
            "access": "read",
            "entityId": "return-claim",
            "purpose": "Read back the complete committed return or delivery claim with authority, freshness and provenance for reconciliation and record drill-through."
          },
          {
            "access": "read",
            "entityId": "shipment",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "receipt",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "shipment",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "receipt",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "receipt-line",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "service-entry-sheet",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "return-claim",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          }
        ],
        "descriptionKey": "workblock.receiving.description",
        "descriptorKey": "workblock.receiving.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "buying-ordering-receiving",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "procurement-buyer",
              "budget-owner",
              "receiver",
              "integration-owner"
            ],
            "id": "ingest-delivery",
            "jobIds": [
              "receiving-service-entry.correlate-delivery",
              "receiving-service-entry.quantity-condition",
              "receiving-service-entry.service-acceptance",
              "receiving-service-entry.post-and-recover"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: delivery artifact refs, source freshness, purchase order id, order line matches, match confidence, shipment id, delivery facts, and acceptance request.",
                "Accepted and rejected inputs are counted, source-linked and assigned a freshness state; a failed refresh retains last-good data.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "receiver",
                "procurement-buyer",
                "requester",
                "integration-owner"
              ]
            },
            "kind": "ingest",
            "label": "Ingest delivery",
            "trigger": "despatch_delivery_or_service_claim"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "procurement-buyer",
              "budget-owner",
              "receiver",
              "integration-owner"
            ],
            "id": "evaluate-acceptance",
            "jobIds": [
              "receiving-service-entry.correlate-delivery",
              "receiving-service-entry.quantity-condition",
              "receiving-service-entry.service-acceptance",
              "receiving-service-entry.post-and-recover"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: receipt candidate, receipt line candidates, goods variances, service entry candidate, service variances, acceptance critic result, and acceptance decision request.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "receiver",
                "procurement-buyer",
                "requester",
                "integration-owner"
              ]
            },
            "kind": "analyse",
            "label": "Evaluate acceptance",
            "trigger": "acceptance_request"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "procurement-buyer",
              "budget-owner",
              "receiver",
              "integration-owner"
            ],
            "id": "commit-and-reconcile",
            "jobIds": [
              "receiving-service-entry.correlate-delivery",
              "receiving-service-entry.quantity-condition",
              "receiving-service-entry.service-acceptance",
              "receiving-service-entry.post-and-recover"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: receipt id, receipt line ids, service entry sheet id, writeback plan, receiving writeback receipts, receiving status, receiving event, return claim candidate, return claim id, and recovery plan.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "receiver",
                "procurement-buyer",
                "requester",
                "integration-owner"
              ]
            },
            "kind": "operate",
            "label": "Commit and reconcile",
            "trigger": "acceptance_decision_request"
          },
          {
            "agentIds": [
              "receiving-agent",
              "service-acceptance-agent",
              "return-recovery-agent"
            ],
            "escalationRoleIds": [
              "requester",
              "procurement-buyer",
              "budget-owner",
              "receiver",
              "integration-owner"
            ],
            "id": "pursue-recovery",
            "jobIds": [
              "receiving-service-entry.correlate-delivery",
              "receiving-service-entry.quantity-condition",
              "receiving-service-entry.service-acceptance",
              "receiving-service-entry.post-and-recover"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: recovery actions, recovery receipts, return claim status, recovered outcome, and receiving learning result.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "receiver",
                "procurement-buyer",
                "requester",
                "integration-owner"
              ]
            },
            "kind": "agent",
            "label": "Pursue recovery",
            "trigger": "recovery_plan"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "requester",
              "procurement-buyer",
              "budget-owner",
              "receiver",
              "integration-owner"
            ],
            "id": "read-receiving",
            "jobIds": [
              "receiving-service-entry.correlate-delivery",
              "receiving-service-entry.quantity-condition",
              "receiving-service-entry.service-acceptance",
              "receiving-service-entry.post-and-recover"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: receiving view, order evidence view, variance recovery view, and freshness view.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "receiver",
                "procurement-buyer",
                "requester",
                "integration-owner"
              ]
            },
            "kind": "read",
            "label": "Read receiving",
            "trigger": "ui_receiving_query"
          }
        ],
        "futureStateKey": "workblock.receiving.future-state",
        "hiredInsteadKey": "workblock.receiving.hired-instead",
        "id": "receiving-service-entry",
        "implementationStatus": "roadmap",
        "jobStatementKey": "workblock.receiving.job",
        "jobStories": [
          {
            "completionKey": "workblock.receiving.story.correlate-delivery.completion",
            "executionFlowIds": [
              "ingest-delivery",
              "evaluate-acceptance",
              "commit-and-reconcile",
              "pursue-recovery",
              "read-receiving"
            ],
            "id": "receiving-service-entry.correlate-delivery",
            "roleCardId": "receiver",
            "storyKey": "workblock.receiving.story.correlate-delivery.story"
          },
          {
            "completionKey": "workblock.receiving.story.quantity-condition.completion",
            "executionFlowIds": [
              "ingest-delivery",
              "evaluate-acceptance",
              "commit-and-reconcile",
              "pursue-recovery",
              "read-receiving"
            ],
            "id": "receiving-service-entry.quantity-condition",
            "roleCardId": "receiver",
            "storyKey": "workblock.receiving.story.quantity-condition.story"
          },
          {
            "completionKey": "workblock.receiving.story.service-acceptance.completion",
            "executionFlowIds": [
              "ingest-delivery",
              "evaluate-acceptance",
              "commit-and-reconcile",
              "pursue-recovery",
              "read-receiving"
            ],
            "id": "receiving-service-entry.service-acceptance",
            "roleCardId": "requester",
            "storyKey": "workblock.receiving.story.service-acceptance.story"
          },
          {
            "completionKey": "workblock.receiving.story.post-and-recover.completion",
            "executionFlowIds": [
              "ingest-delivery",
              "evaluate-acceptance",
              "commit-and-reconcile",
              "pursue-recovery",
              "read-receiving"
            ],
            "id": "receiving-service-entry.post-and-recover",
            "roleCardId": "receiver",
            "storyKey": "workblock.receiving.story.post-and-recover.story"
          }
        ],
        "labelKey": "workblock.receiving.label",
        "metrics": [
          "Receipt cycle time: delivery evidence to reconciled receipt",
          "First-pass order and line match accuracy",
          "Policy-bounded eligible goods-receipt rate",
          "False receipt, false service acceptance and duplicate writeback count",
          "Receipt correction and reversal rate",
          "Service-entry decision cycle and dispute rate",
          "Invoice first-match rate after receipt or service entry",
          "Return cycle time and realized recovery / validated expected recovery",
          "Stale delivery and uncertain writeback exposure"
        ],
        "operatingModel": "The Workblock owns shipments, receipts, receipt lines, service-entry sheets and return claims. It correlates despatch and delivery evidence to exact order versions, prepares acceptance proposals, applies requester or delegated authority, writes receipts idempotently, reconciles inventory and invoice-matching state and pursues returns or claims to recovered outcome.",
        "outcomeKey": "workblock.receiving.outcome",
        "prerequisites": [
          "A write connection to the ERP receiving and service-entry functions",
          "Read access to committed purchase orders and their open lines",
          "Access to warehouse, proof-of-delivery and timesheet evidence sources",
          "Receiving tolerances and acceptance criteria agreed per location",
          "Named receivers with acceptance authority for subjective decisions"
        ],
        "toolKey": "workblock.receiving.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "deduplicate related symptoms",
              "request missing non-sensitive evidence",
              "assign a policy-defined owner",
              "apply pre-approved coding or routing corrections",
              "close a reconciled routine case"
            ],
            "escalationTriggers": [
              "conflicting or stale source evidence",
              "sensitive master-data change",
              "material tax or fraud signal",
              "payment already executed",
              "action outside the authority envelope",
              "supplier dispute without a deterministic remedy"
            ],
            "id": "invoice-exception-coordinator-agent",
            "label": "Invoice exception coordinator agent",
            "mission": "Resolve routine invoice exceptions within policy while keeping evidence, ownership and payment consequence explicit.",
            "operatorRoleIds": [
              "ap-processor"
            ],
            "personaIds": [
              "accounts-payable",
              "buyer",
              "requester-persona",
              "finance"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "ap-processor",
              "controller",
              "risk-owner"
            ]
          }
        ],
        "agentStoryKey": "workblock.invoice-triage.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Suspected fraud or duplicate payment after release",
            "Bank-detail or sensitive supplier-master change",
            "Material tax or legal ambiguity",
            "Evidence conflict that changes payable amount",
            "Action outside the named envelope"
          ],
          "authorityEnvelope": [
            "Named exception types and permitted action verbs",
            "Tenant, legal-entity, supplier and invoice scope",
            "Materiality and age thresholds",
            "Required evidence and freshness bands",
            "Permitted adapters and communication channels",
            "Grantor, effective window and expiry",
            "Forbidden payment, tax, bank-detail and destructive actions"
          ],
          "humanSupervision": [
            "Set exception policy and owner routes",
            "Inspect stratified samples and harm metrics",
            "Handle novel, material or disputed cases",
            "Approve promotion by exception cohort",
            "Retain pause, stop and compensation rights"
          ],
          "rollback": [
            "Pause new automated case actions",
            "Restore the last approved exception policy and handling method",
            "Undo reversible coding or routing changes",
            "Reopen affected cases and keep the original decision trail",
            "Recheck the affected case group before restoring automation"
          ],
          "targetPosture": "mission_autonomous_with_supervision"
        },
        "coreValue": "Move every genuine invoice exception to the shortest safe resolution path while clean invoices continue without avoidable touch.",
        "currentStateKey": "workblock.invoice-triage.current-state",
        "dataMappings": [
          {
            "access": "read",
            "entityId": "invoice",
            "purpose": "Anchor the exception in current invoice facts and source evidence."
          },
          {
            "access": "read",
            "entityId": "invoice-match-assessment",
            "purpose": "Explain the discrepancy and the rule version that produced it."
          },
          {
            "access": "create",
            "entityId": "invoice-exception",
            "purpose": "Create one durable, owned case per business exception. Includes every owned record-envelope and lifecycle field required to reproduce this version."
          },
          {
            "access": "update",
            "entityId": "invoice-exception",
            "purpose": "Keep proposals distinct from committed dispositions and reconcile last-good state."
          },
          {
            "access": "read",
            "entityId": "supplier-invoice-resolution",
            "purpose": "Observe supplier-facing resolution progress without duplicating its owner record."
          },
          {
            "access": "read",
            "entityId": "party",
            "purpose": "Read the policy-filtered canonical party projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "category",
            "purpose": "Read the policy-filtered canonical category projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "item-service",
            "purpose": "Read the policy-filtered canonical item or service projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "source-record-reference",
            "purpose": "Read the policy-filtered canonical source record reference projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "evidence-item",
            "purpose": "Read the policy-filtered canonical evidence item projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "policy",
            "purpose": "Read the policy-filtered canonical policy projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "policy-version",
            "purpose": "Read the policy-filtered canonical policy version projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "authority-envelope",
            "purpose": "Read the policy-filtered canonical authority envelope projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "action-proposal",
            "purpose": "Read the policy-filtered canonical action proposal projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "committed-action",
            "purpose": "Read the policy-filtered canonical committed action projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "decision",
            "purpose": "Read the policy-filtered canonical decision projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "exception",
            "purpose": "Read the policy-filtered canonical exception case projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "audit-event",
            "purpose": "Read the policy-filtered canonical audit event projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "business-event",
            "purpose": "Read the policy-filtered canonical business event projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "learning-example",
            "purpose": "Read the policy-filtered canonical learning example projection from learning-evaluation-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "evaluation-result",
            "purpose": "Read the policy-filtered canonical evaluation result projection from learning-evaluation-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "integration-state",
            "purpose": "Read the policy-filtered canonical integration state projection from integration-state-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "registry-release",
            "purpose": "Read the policy-filtered canonical registry release projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "purchase-order-exception",
            "purpose": "Read the governed purchase order exception contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "invoice-exception",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "invoice-exception",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "create",
            "entityId": "decision",
            "purpose": "Submit the authorised, version-pinned D6 receiving-owner acceptance, rejection, redirect, expiry or reopen decision to shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "committed-action",
            "purpose": "Append each authorised D6 delivery or receiver-owned command attempt with idempotency, safe-retry and reconciliation state through shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "business-event",
            "purpose": "Append immutable D6 delivery, acknowledgement, rejection, reconciliation, replay or reopen facts through audit-event-service; an event never becomes current domain state."
          }
        ],
        "descriptionKey": "workblock.invoice-triage.description",
        "descriptorKey": "workblock.invoice-triage.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "invoice-exception-payment-readiness",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "ap-processor",
              "controller",
              "payment-approver",
              "treasury-manager",
              "risk-owner"
            ],
            "id": "refresh-exception-queue",
            "jobIds": [
              "invoice-exception-triage.quantity-mismatch",
              "invoice-exception-triage.missing-receipt",
              "invoice-exception-triage.price-mismatch",
              "invoice-exception-triage.duplicate-candidate",
              "invoice-exception-triage.approval-missing"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: open match assessments, exception candidates, and exception queue snapshot.",
                "Accepted and rejected inputs are counted, source-linked and assigned a freshness state; a failed refresh retains last-good data.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "ap-processor",
                "controller",
                "risk-owner"
              ]
            },
            "kind": "refresh",
            "label": "Refresh exception queue",
            "trigger": "InvoiceMatchAssessed, InvoiceStatusChanged, evidence change or scheduled reconciliation"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "ap-processor",
              "controller",
              "payment-approver",
              "treasury-manager",
              "risk-owner"
            ],
            "id": "operate-exception",
            "jobIds": [
              "invoice-exception-triage.quantity-mismatch",
              "invoice-exception-triage.missing-receipt",
              "invoice-exception-triage.price-mismatch",
              "invoice-exception-triage.duplicate-candidate",
              "invoice-exception-triage.approval-missing"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: exception evidence package, resolution options, resolution attempt, and reconciled exception result.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "ap-processor",
                "controller",
                "risk-owner"
              ]
            },
            "kind": "operate",
            "label": "Operate exception case",
            "trigger": "Case opened, evidence received, owner response or retry due"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "ap-processor",
              "controller",
              "payment-approver",
              "treasury-manager",
              "risk-owner"
            ],
            "id": "read-exception-workspace",
            "jobIds": [
              "invoice-exception-triage.quantity-mismatch",
              "invoice-exception-triage.missing-receipt",
              "invoice-exception-triage.price-mismatch",
              "invoice-exception-triage.duplicate-candidate",
              "invoice-exception-triage.approval-missing"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: exception page and exception detail.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "ap-processor",
                "controller",
                "risk-owner"
              ]
            },
            "kind": "read",
            "label": "Read exception workspace",
            "trigger": "Workspace query or record drill-through"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "ap-processor",
              "controller",
              "payment-approver",
              "treasury-manager",
              "risk-owner"
            ],
            "id": "evaluate-exception-policy",
            "jobIds": [
              "invoice-exception-triage.quantity-mismatch",
              "invoice-exception-triage.missing-receipt",
              "invoice-exception-triage.price-mismatch",
              "invoice-exception-triage.duplicate-candidate",
              "invoice-exception-triage.approval-missing"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: exception evaluation example and exception evaluation result.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "ap-processor",
                "controller",
                "risk-owner"
              ]
            },
            "kind": "monitor",
            "label": "Evaluate exception policy",
            "trigger": "Reconciled outcome, sampled policy-bounded action or evaluation schedule"
          }
        ],
        "futureStateKey": "workblock.invoice-triage.future-state",
        "hiredInsteadKey": "workblock.invoice-triage.hired-instead",
        "id": "invoice-exception-triage",
        "implementationStatus": "reference",
        "jobStatementKey": "workblock.invoice-triage.job",
        "jobStories": [
          {
            "completionKey": "workblock.invoice-triage.story.quantity-mismatch.completion",
            "executionFlowIds": [
              "refresh-exception-queue",
              "operate-exception",
              "read-exception-workspace",
              "evaluate-exception-policy"
            ],
            "id": "invoice-exception-triage.quantity-mismatch",
            "roleCardId": "ap-processor",
            "storyKey": "workblock.invoice-triage.story.quantity-mismatch.story"
          },
          {
            "completionKey": "workblock.invoice-triage.story.missing-receipt.completion",
            "executionFlowIds": [
              "refresh-exception-queue",
              "operate-exception",
              "read-exception-workspace",
              "evaluate-exception-policy"
            ],
            "id": "invoice-exception-triage.missing-receipt",
            "roleCardId": "ap-processor",
            "storyKey": "workblock.invoice-triage.story.missing-receipt.story"
          },
          {
            "completionKey": "workblock.invoice-triage.story.price-mismatch.completion",
            "executionFlowIds": [
              "refresh-exception-queue",
              "operate-exception",
              "read-exception-workspace",
              "evaluate-exception-policy"
            ],
            "id": "invoice-exception-triage.price-mismatch",
            "roleCardId": "ap-processor",
            "storyKey": "workblock.invoice-triage.story.price-mismatch.story"
          },
          {
            "completionKey": "workblock.invoice-triage.story.duplicate-candidate.completion",
            "executionFlowIds": [
              "refresh-exception-queue",
              "operate-exception",
              "read-exception-workspace",
              "evaluate-exception-policy"
            ],
            "id": "invoice-exception-triage.duplicate-candidate",
            "roleCardId": "controller",
            "storyKey": "workblock.invoice-triage.story.duplicate-candidate.story"
          },
          {
            "completionKey": "workblock.invoice-triage.story.approval-missing.completion",
            "executionFlowIds": [
              "refresh-exception-queue",
              "operate-exception",
              "read-exception-workspace",
              "evaluate-exception-policy"
            ],
            "id": "invoice-exception-triage.approval-missing",
            "roleCardId": "ap-processor",
            "storyKey": "workblock.invoice-triage.story.approval-missing.story"
          }
        ],
        "labelKey": "workblock.invoice-triage.label",
        "metrics": [
          "Straight-through exception resolution rate, always segmented by exception type and authority cohort",
          "Median and tail time to owner, evidence completeness and reconciled closure",
          "False policy-bounded action, missed material exception, override, reopen and dispute rates",
          "Aging and payable exposure with invoice-level drill-through",
          "SLO: queue freshness, integration lag and last-good age use source-owned thresholds displayed with every aggregate",
          "Recovery SLO: every partial batch exposes per-case result and is replayable by business key without duplicate side effects"
        ],
        "operatingModel": "The Workblock continuously consumes typed match assessments, groups duplicate symptoms into one case, assembles current evidence, selects the permitted resolution path, coordinates the right role or downstream Workblock and reconciles the committed result. Beyond Work execution rails preserve waits, retries, ownership and the proposal-to-commitment boundary across long-running cases.",
        "outcomeKey": "workblock.invoice-triage.outcome",
        "prerequisites": [
          "Access to the canonical invoice and match-assessment records",
          "Read connections to order, receipt, tax and supplier identity sources",
          "A versioned exception policy with named owner routes",
          "Approved channels for supplier and requester evidence requests"
        ],
        "toolKey": "workblock.invoice-triage.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "refresh checks",
              "expire stale assessment",
              "commit routine ready status",
              "commit policy-defined hold",
              "request missing internal evidence"
            ],
            "escalationTriggers": [
              "conflicting payable amount",
              "supplier or account change",
              "sanction or fraud indicator",
              "manual override request",
              "material unresolved exception",
              "degraded mandatory control source"
            ],
            "id": "payment-readiness-agent",
            "label": "Payment readiness agent",
            "mission": "Keep each invoice's readiness state current, explainable and inside finance control policy.",
            "operatorRoleIds": [
              "ap-processor"
            ],
            "personaIds": [
              "accounts-payable",
              "finance",
              "supplier-risk-manager"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "controller",
              "payment-approver",
              "treasury-manager",
              "risk-owner",
              "ap-processor"
            ]
          },
          {
            "autonomousActions": [
              "Assemble the terms fact base from approved invoices, contracted terms and the cash calendar",
              "Model static and sliding-scale discount capture against due-date discipline",
              "Rank working-capital positions with the records behind every projected move",
              "Propose terms actions into the existing human readiness commitment path",
              "Expire proposals whose invoice, terms or cash evidence lapses"
            ],
            "escalationTriggers": [
              "A proposed action changes a payment schedule, payee or bank detail",
              "Contracted-terms evidence is stale, conflicting or missing for a supplier",
              "A discount capture would breach a readiness or screening control",
              "A terms position implies renegotiating a supplier agreement",
              "Any payment execution or acceleration is requested"
            ],
            "id": "payment-terms-agent",
            "label": "Payment terms agent",
            "mission": "Model discount capture and terms scenarios against approved invoices, contracted terms and the cash calendar, and rank working-capital positions as proposals a named human commits, never touching a payment.",
            "operatorRoleIds": [
              "treasury-manager"
            ],
            "personaIds": [
              "finance",
              "accounts-payable"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "treasury-manager",
              "payment-approver"
            ]
          }
        ],
        "agentStoryKey": "workblock.payment.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Fraud, sanctions or account-integrity signal",
            "Conflicting legal payable amount",
            "Manual release of a policy hold",
            "Missing mandatory high-consequence evidence",
            "Out-of-envelope entity, currency or amount"
          ],
          "authorityEnvelope": [
            "Permitted readiness and hold verbs",
            "Invoice, supplier, entity, currency and materiality scope",
            "Mandatory checks and freshness thresholds",
            "Permitted finance and supplier-risk adapters",
            "Decision expiry conditions",
            "Grantor, start, expiry and review cadence",
            "Forbidden payment execution and master-data mutation"
          ],
          "humanSupervision": [
            "Own finance control policy",
            "Review material or novel holds",
            "Inspect stratified ready and held samples",
            "Approve cohort promotion and envelope expansion",
            "Pause or narrow autonomy when control quality changes"
          ],
          "rollback": [
            "Expire affected committed assessments",
            "Restore prior check policy and adapter mapping",
            "Place a reversible safety hold where authorised",
            "Re-evaluate affected invoices by business key",
            "Preserve all superseded decisions and evidence"
          ],
          "targetPosture": "policy_autonomous_with_monitoring"
        },
        "coreValue": "Establish a defensible, current go-or-hold decision for every payable invoice before any payment instruction crosses the commitment boundary.",
        "currentStateKey": "workblock.payment.current-state",
        "dataMappings": [
          {
            "access": "read",
            "entityId": "invoice",
            "purpose": "Establish the payable facts and source freshness."
          },
          {
            "access": "read",
            "entityId": "invoice-match-assessment",
            "purpose": "Prove match status against the exact rule set."
          },
          {
            "access": "read",
            "entityId": "invoice-exception",
            "purpose": "Block readiness for unresolved or materially changed exceptions."
          },
          {
            "access": "create",
            "entityId": "payment-readiness-assessment",
            "purpose": "Create the version-bound proposal and decision record. Includes every owned record-envelope and lifecycle field required to reproduce this version."
          },
          {
            "access": "update",
            "entityId": "payment-readiness-assessment",
            "purpose": "Expire, hold, commit or reconcile the current assessment without erasing prior evidence."
          },
          {
            "access": "read",
            "entityId": "person",
            "purpose": "Read the policy-filtered canonical person projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "policy",
            "purpose": "Read the policy-filtered canonical policy projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "policy-version",
            "purpose": "Read the policy-filtered canonical policy version projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "authority-envelope",
            "purpose": "Read the policy-filtered canonical authority envelope projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "exception",
            "purpose": "Read the policy-filtered canonical exception case projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "audit-event",
            "purpose": "Read the policy-filtered canonical audit event projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "business-event",
            "purpose": "Read the policy-filtered canonical business event projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "integration-state",
            "purpose": "Read the policy-filtered canonical integration state projection from integration-state-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "invoice-line",
            "purpose": "Read the governed invoice line contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "contract-entitlement",
            "purpose": "Read the policy-filtered canonical contract-entitlement projection from obligation-monitoring; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "payment-readiness-assessment",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "payment-readiness-assessment",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "action-proposal",
            "purpose": "Point-read the exact permission-safe D6 handoff action-proposal record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "decision",
            "purpose": "Point-read the exact permission-safe D6 handoff decision record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "committed-action",
            "purpose": "Point-read the exact permission-safe D6 handoff committed-action record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "create",
            "entityId": "decision",
            "purpose": "Submit the authorised, version-pinned D6 receiving-owner acceptance, rejection, redirect, expiry or reopen decision to shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "committed-action",
            "purpose": "Append each authorised D6 delivery or receiver-owned command attempt with idempotency, safe-retry and reconciliation state through shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "business-event",
            "purpose": "Append immutable D6 delivery, acknowledgement, rejection, reconciliation, replay or reopen facts through audit-event-service; an event never becomes current domain state."
          }
        ],
        "descriptionKey": "workblock.payment.description",
        "descriptorKey": "workblock.payment.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "invoice-exception-payment-readiness",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "ap-processor",
              "controller",
              "payment-approver",
              "treasury-manager",
              "risk-owner"
            ],
            "id": "assess-payment-readiness",
            "jobIds": [
              "payment-readiness.batch-review",
              "payment-readiness.payee-change",
              "payment-readiness.stale-screening",
              "payment-readiness.treasury-change",
              "payment-readiness.decision-handoff"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The readiness-input-snapshot, deterministic-check-results, complete-check-results and readiness-proposal bind each requirement to its source time, policy version and allowed, blocked or unresolved result.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "controller",
                "payment-approver",
                "treasury-manager",
                "risk-owner",
                "ap-processor"
              ]
            },
            "kind": "analyse",
            "label": "Assess payment readiness",
            "trigger": "Invoice or material control evidence changes"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "ap-processor",
              "controller",
              "payment-approver",
              "treasury-manager",
              "risk-owner"
            ],
            "id": "commit-payment-readiness",
            "jobIds": [
              "payment-readiness.batch-review",
              "payment-readiness.payee-change",
              "payment-readiness.stale-screening",
              "payment-readiness.treasury-change",
              "payment-readiness.decision-handoff"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The validated-readiness-proposal and readiness-commitment bind the candidate set, requirement results, source times, authority and decision; the readiness-event publishes that exact version or records the hold.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "payment-approver",
                "controller",
                "treasury-manager",
                "risk-owner",
                "ap-processor"
              ]
            },
            "kind": "operate",
            "label": "Commit payment readiness",
            "trigger": "In-envelope proposal or explicit authority event"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "ap-processor",
              "controller",
              "payment-approver",
              "treasury-manager",
              "risk-owner"
            ],
            "id": "read-readiness-control",
            "jobIds": [
              "payment-readiness.batch-review",
              "payment-readiness.payee-change",
              "payment-readiness.stale-screening",
              "payment-readiness.treasury-change",
              "payment-readiness.decision-handoff"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The readiness-page and readiness-detail show current or clearly expired decisions and let every batch aggregate drill to its candidates, requirement results, source times and authority record.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "payment-approver",
                "controller",
                "treasury-manager",
                "risk-owner",
                "ap-processor"
              ]
            },
            "kind": "read",
            "label": "Read readiness control",
            "trigger": "Queue query or invoice drill-through"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "ap-processor",
              "controller",
              "payment-approver",
              "treasury-manager",
              "risk-owner"
            ],
            "id": "monitor-readiness-quality",
            "jobIds": [
              "payment-readiness.batch-review",
              "payment-readiness.payee-change",
              "payment-readiness.stale-screening",
              "payment-readiness.treasury-change",
              "payment-readiness.decision-handoff"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The readiness-outcome-example links commitment and downstream result by version; the readiness-evaluation-result reports false-clear, false-block, expiry and control failures by material slice.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "controller",
                "payment-approver",
                "treasury-manager",
                "risk-owner",
                "ap-processor"
              ]
            },
            "kind": "monitor",
            "label": "Monitor readiness quality",
            "trigger": "Payment result, hold release, sampled decision or schedule"
          },
          {
            "agentIds": [
              "payment-terms-agent"
            ],
            "escalationRoleIds": [
              "treasury-manager",
              "controller",
              "payment-approver"
            ],
            "id": "assess-payment-terms-position",
            "jobIds": [
              "payment-readiness.payment-terms"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: payment terms scenario set and payment terms action proposal.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "treasury-manager"
              ]
            },
            "kind": "agent",
            "label": "Assess payment terms position",
            "trigger": "Approved-invoice stream, contracted-terms change or cash-calendar refresh shifts the discount and terms position."
          }
        ],
        "futureStateKey": "workblock.payment.future-state",
        "hiredInsteadKey": "workblock.payment.hired-instead",
        "id": "payment-readiness",
        "implementationStatus": "pattern",
        "jobStatementKey": "workblock.payment.job",
        "jobStories": [
          {
            "completionKey": "workblock.payment.story.batch-review.completion",
            "executionFlowIds": [
              "assess-payment-readiness",
              "commit-payment-readiness",
              "read-readiness-control",
              "monitor-readiness-quality"
            ],
            "id": "payment-readiness.batch-review",
            "roleCardId": "payment-approver",
            "storyKey": "workblock.payment.story.batch-review.story"
          },
          {
            "completionKey": "workblock.payment.story.payee-change.completion",
            "executionFlowIds": [
              "assess-payment-readiness",
              "commit-payment-readiness",
              "read-readiness-control",
              "monitor-readiness-quality"
            ],
            "id": "payment-readiness.payee-change",
            "roleCardId": "controller",
            "storyKey": "workblock.payment.story.payee-change.story"
          },
          {
            "completionKey": "workblock.payment.story.stale-screening.completion",
            "executionFlowIds": [
              "assess-payment-readiness",
              "commit-payment-readiness",
              "read-readiness-control",
              "monitor-readiness-quality"
            ],
            "id": "payment-readiness.stale-screening",
            "roleCardId": "risk-owner",
            "storyKey": "workblock.payment.story.stale-screening.story"
          },
          {
            "completionKey": "workblock.payment.story.treasury-change.completion",
            "executionFlowIds": [
              "assess-payment-readiness",
              "commit-payment-readiness",
              "read-readiness-control",
              "monitor-readiness-quality"
            ],
            "id": "payment-readiness.treasury-change",
            "roleCardId": "treasury-manager",
            "storyKey": "workblock.payment.story.treasury-change.story"
          },
          {
            "completionKey": "workblock.payment.story.decision-handoff.completion",
            "executionFlowIds": [
              "assess-payment-readiness",
              "commit-payment-readiness",
              "read-readiness-control",
              "monitor-readiness-quality"
            ],
            "id": "payment-readiness.decision-handoff",
            "roleCardId": "payment-approver",
            "storyKey": "workblock.payment.story.decision-handoff.story"
          },
          {
            "completionKey": "workblock.payment.story.payment-terms.completion",
            "executionFlowIds": [
              "assess-payment-terms-position"
            ],
            "id": "payment-readiness.payment-terms",
            "roleCardId": "treasury-manager",
            "storyKey": "workblock.payment.story.payment-terms.story"
          }
        ],
        "labelKey": "workblock.payment.label",
        "metrics": [
          "Ready, held, expiring and evidence-missing amounts with invoice drill-through",
          "False-ready, false-hold, override and reversal rates",
          "Assessment latency and age of last-good mandatory evidence",
          "Percentage of committed decisions with complete source and authority lineage",
          "SLO: no committed ready state survives a material bound-evidence change",
          "Recovery SLO: affected assessments can be expired and replayed without emitting a duplicate execution request"
        ],
        "operatingModel": "The Workblock reconciles invoice, match, resolution, supplier, payment-term, hold, duplicate, sanction and downstream integration evidence into a versioned readiness assessment. It can commit routine ready or held states inside policy, while payment execution remains a separate guarded Workblock.",
        "outcomeKey": "workblock.payment.outcome",
        "prerequisites": [
          "Access to the canonical invoice, match and exception records",
          "Read connections to finance and supplier-risk sources",
          "A finance control policy defining mandatory checks and freshness thresholds",
          "Named owners for the payment-release decision"
        ],
        "toolKey": "workblock.payment.tool",
        "version": "5.2.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "validate standards rules",
              "canonicalize supported fields",
              "apply approved identity mappings",
              "perform policy-defined match",
              "publish clean assessment",
              "quarantine invalid input"
            ],
            "escalationTriggers": [
              "ambiguous supplier identity",
              "conflicting invoice version",
              "duplicate candidate above policy materiality",
              "unsupported tax treatment",
              "missing mandatory commercial evidence",
              "source mapping drift"
            ],
            "id": "invoice-intake-agent",
            "label": "Invoice intake and match agent",
            "mission": "Resolve ambiguous invoice identity and matching evidence without weakening deterministic financial controls.",
            "operatorRoleIds": [
              "ap-processor"
            ],
            "personaIds": [
              "accounts-payable",
              "buyer",
              "finance"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "ap-processor",
              "controller",
              "risk-owner"
            ]
          }
        ],
        "agentStoryKey": "workblock.invoice-match.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Unsupported or conflicting invoice semantics",
            "Ambiguous party or duplicate identity with material consequence",
            "Tax treatment outside configured rules",
            "Source artifact integrity failure",
            "Required order or receipt evidence conflict"
          ],
          "authorityEnvelope": [
            "Accepted document types, channels and source schema versions",
            "Permitted mapping, identity and match rules",
            "Supplier, entity, currency and amount scope",
            "Required evidence and tolerance sets",
            "Permitted canonical-store and response adapters",
            "Grantor, expiry and policy version",
            "Forbidden master-data, tax-rule and payable-amount overrides"
          ],
          "humanSupervision": [
            "Approve mapping and match policy versions",
            "Resolve new source schemas and ambiguous identities",
            "Inspect sampled clean and rejected cases",
            "Review drift by field, supplier and source",
            "Retain quarantine, replay and rollback control"
          ],
          "rollback": [
            "Quarantine the affected mapping or model version",
            "Restore prior source mapping and match policy",
            "Rebuild affected projections from immutable source snapshots",
            "Supersede incorrect assessments and open exceptions",
            "Do not delete prior canonical or audit records"
          ],
          "targetPosture": "policy_autonomous_with_monitoring"
        },
        "coreValue": "Turn every incoming invoice into a provenance-complete canonical record and a deterministic, explainable match result as early as possible.",
        "currentStateKey": "workblock.invoice-match.current-state",
        "dataMappings": [
          {
            "access": "create",
            "entityId": "invoice",
            "purpose": "Persist the canonical UBL-aligned invoice header and its version envelope."
          },
          {
            "access": "create",
            "entityId": "invoice-line",
            "purpose": "Preserve line semantics and exact source anchors for matching and drill-through. Includes every owned record-envelope and lifecycle field required to reproduce this version."
          },
          {
            "access": "read",
            "entityId": "invoice-line",
            "purpose": "Read back the complete committed invoice line with authority, freshness and provenance for reconciliation and record drill-through."
          },
          {
            "access": "create",
            "entityId": "invoice-match-assessment",
            "purpose": "Create an immutable, replayable match assessment for each evidence and policy version. Includes every owned record-envelope and lifecycle field required to reproduce this version."
          },
          {
            "access": "read",
            "entityId": "purchase-order",
            "purpose": "Read the governed purchase order contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "order-line",
            "purpose": "Read the governed order line contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "receipt",
            "purpose": "Read the governed receipt contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "receipt-line",
            "purpose": "Read the governed receipt line contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "service-entry-sheet",
            "purpose": "Read the governed service entry sheet contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "receipt-line",
            "purpose": "Read the governed receipt line contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "service-entry-sheet",
            "purpose": "Read the governed service entry sheet contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "invoice",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "invoice-match-assessment",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "invoice",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "invoice-line",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "invoice-match-assessment",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "action-proposal",
            "purpose": "Point-read the exact permission-safe D6 handoff action-proposal record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "decision",
            "purpose": "Point-read the exact permission-safe D6 handoff decision record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "committed-action",
            "purpose": "Point-read the exact permission-safe D6 handoff committed-action record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "business-event",
            "purpose": "Point-read the exact permission-safe D6 handoff business-event record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "create",
            "entityId": "action-proposal",
            "purpose": "Submit the version-pinned D6 requested outcome, sender/receiver, source/target, evidence, authority, expiry and reopen context to shared-ledger-service without writing receiver-owned state."
          },
          {
            "access": "append",
            "entityId": "committed-action",
            "purpose": "Append each authorised D6 delivery or receiver-owned command attempt with idempotency, safe-retry and reconciliation state through shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "business-event",
            "purpose": "Append immutable D6 delivery, acknowledgement, rejection, reconciliation, replay or reopen facts through audit-event-service; an event never becomes current domain state."
          },
          {
            "access": "read",
            "entityId": "payment-readiness-assessment",
            "purpose": "Read the exact D6 payment-readiness owner result/version during reconciliation."
          },
          {
            "access": "read",
            "entityId": "invoice-exception",
            "purpose": "Read the exact D6 invoice-exception owner result/version during reconciliation."
          }
        ],
        "descriptionKey": "workblock.invoice-match.description",
        "descriptorKey": "workblock.invoice-match.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "invoice-exception-payment-readiness",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "ap-processor",
              "controller",
              "payment-approver",
              "treasury-manager",
              "risk-owner"
            ],
            "id": "ingest-invoice",
            "jobIds": [
              "invoice-intake-match.channel-intake",
              "invoice-intake-match.syntax-business-validation",
              "invoice-intake-match.duplicate-conflict",
              "invoice-intake-match.line-match",
              "invoice-intake-match.publish-disposition"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: invoice source snapshot, validated invoice payload, canonical invoice header, canonical invoice lines, and invoice ingest result.",
                "Accepted and rejected inputs are counted, source-linked and assigned a freshness state; a failed refresh retains last-good data.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "ap-processor",
                "controller",
                "risk-owner"
              ]
            },
            "kind": "ingest",
            "label": "Ingest invoice",
            "trigger": "Structured invoice message or governed artifact received"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "ap-processor",
              "controller",
              "payment-approver",
              "treasury-manager",
              "risk-owner"
            ],
            "id": "assess-invoice-match",
            "jobIds": [
              "invoice-intake-match.channel-intake",
              "invoice-intake-match.syntax-business-validation",
              "invoice-intake-match.duplicate-conflict",
              "invoice-intake-match.line-match",
              "invoice-intake-match.publish-disposition"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: invoice comparison set, invoice match facts, evaluated match result, and match assessment result.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "ap-processor",
                "controller",
                "risk-owner"
              ]
            },
            "kind": "analyse",
            "label": "Assess invoice match",
            "trigger": "Invoice canonicalized or referenced evidence changes"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "ap-processor",
              "controller",
              "payment-approver",
              "treasury-manager",
              "risk-owner"
            ],
            "id": "read-invoice-match",
            "jobIds": [
              "invoice-intake-match.channel-intake",
              "invoice-intake-match.syntax-business-validation",
              "invoice-intake-match.duplicate-conflict",
              "invoice-intake-match.line-match",
              "invoice-intake-match.publish-disposition"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: invoice page and invoice match detail.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "ap-processor",
                "controller",
                "risk-owner"
              ]
            },
            "kind": "read",
            "label": "Read invoice match",
            "trigger": "Search, queue query or record drill-through"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "ap-processor",
              "controller",
              "payment-approver",
              "treasury-manager",
              "risk-owner"
            ],
            "id": "evaluate-intake-match",
            "jobIds": [
              "invoice-intake-match.channel-intake",
              "invoice-intake-match.syntax-business-validation",
              "invoice-intake-match.duplicate-conflict",
              "invoice-intake-match.line-match",
              "invoice-intake-match.publish-disposition"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: intake match example and intake match evaluation result.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "ap-processor",
                "controller",
                "risk-owner"
              ]
            },
            "kind": "monitor",
            "label": "Evaluate intake and match",
            "trigger": "Corrected invoice, exception disposition or reconciliation schedule"
          }
        ],
        "futureStateKey": "workblock.invoice-match.future-state",
        "hiredInsteadKey": "workblock.invoice-match.hired-instead",
        "id": "invoice-intake-match",
        "implementationStatus": "roadmap",
        "jobStatementKey": "workblock.invoice-match.job",
        "jobStories": [
          {
            "completionKey": "workblock.invoice-match.story.channel-intake.completion",
            "executionFlowIds": [
              "ingest-invoice",
              "assess-invoice-match",
              "read-invoice-match",
              "evaluate-intake-match"
            ],
            "id": "invoice-intake-match.channel-intake",
            "roleCardId": "ap-processor",
            "storyKey": "workblock.invoice-match.story.channel-intake.story"
          },
          {
            "completionKey": "workblock.invoice-match.story.syntax-business-validation.completion",
            "executionFlowIds": [
              "ingest-invoice",
              "assess-invoice-match",
              "read-invoice-match",
              "evaluate-intake-match"
            ],
            "id": "invoice-intake-match.syntax-business-validation",
            "roleCardId": "ap-processor",
            "storyKey": "workblock.invoice-match.story.syntax-business-validation.story"
          },
          {
            "completionKey": "workblock.invoice-match.story.duplicate-conflict.completion",
            "executionFlowIds": [
              "ingest-invoice",
              "assess-invoice-match",
              "read-invoice-match",
              "evaluate-intake-match"
            ],
            "id": "invoice-intake-match.duplicate-conflict",
            "roleCardId": "risk-owner",
            "storyKey": "workblock.invoice-match.story.duplicate-conflict.story"
          },
          {
            "completionKey": "workblock.invoice-match.story.line-match.completion",
            "executionFlowIds": [
              "ingest-invoice",
              "assess-invoice-match",
              "read-invoice-match",
              "evaluate-intake-match"
            ],
            "id": "invoice-intake-match.line-match",
            "roleCardId": "ap-processor",
            "storyKey": "workblock.invoice-match.story.line-match.story"
          },
          {
            "completionKey": "workblock.invoice-match.story.publish-disposition.completion",
            "executionFlowIds": [
              "ingest-invoice",
              "assess-invoice-match",
              "read-invoice-match",
              "evaluate-intake-match"
            ],
            "id": "invoice-intake-match.publish-disposition",
            "roleCardId": "controller",
            "storyKey": "workblock.invoice-match.story.publish-disposition.story"
          }
        ],
        "labelKey": "workblock.invoice-match.label",
        "metrics": [
          "Invoice and line canonicalisation completeness with source-record drill-through",
          "Standards rejection, quarantine and correction rates by source schema",
          "Duplicate precision, recall and prevented duplicate exposure",
          "Two-, three- and policy-match rates with exact exception reasons",
          "SLO: source acceptance, canonicalisation and match freshness thresholds are configured per channel",
          "Recovery SLO: all invoices can be deterministically rebuilt from immutable source snapshots without duplicate business keys"
        ],
        "operatingModel": "The Workblock accepts structured invoices and governed document artifacts, validates required semantics, reconciles supplier and document identity, preserves line-level provenance, detects duplicates and performs two-, three- or policy-defined matching against adapter-projected order and receipt evidence.",
        "outcomeKey": "workblock.invoice-match.outcome",
        "prerequisites": [
          "Structured invoice feeds from the e-invoicing network or document channels",
          "Read connections to order and receipt evidence in the ERP",
          "Approved supplier identity and document-profile reference data",
          "Versioned mapping, tolerance and match rules approved by finance"
        ],
        "toolKey": "workblock.invoice-match.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "draft and send approved routine requests",
              "send policy-timed reminders",
              "classify structured status responses",
              "link received artifacts",
              "apply pre-approved documentary resolutions",
              "close reconciled requests"
            ],
            "escalationTriggers": [
              "commercial or legal dispute",
              "supplier denies obligation",
              "contact or channel uncertainty",
              "sensitive data in message",
              "material value change",
              "response contradicts authoritative invoice evidence"
            ],
            "id": "supplier-invoice-resolution-agent",
            "label": "Supplier invoice resolution agent",
            "mission": "Obtain and apply the minimum supplier evidence or correction required to resolve an invoice safely.",
            "operatorRoleIds": [
              "ap-processor"
            ],
            "personaIds": [
              "accounts-payable",
              "buyer",
              "supplier-relationship-manager"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "ap-processor",
              "controller"
            ]
          }
        ],
        "agentStoryKey": "workblock.invoice-resolution.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Dispute of contractual or legal obligation",
            "Request to change bank or sensitive supplier data",
            "Material credit, settlement or write-off",
            "Recipient or disclosure uncertainty",
            "Threat, coercion or sensitive-content detection",
            "Action outside message or resolution envelope"
          ],
          "authorityEnvelope": [
            "Permitted resolution intents and message templates",
            "Approved supplier parties, contacts, channels and languages",
            "Invoice, entity and materiality scope",
            "Permitted reminder cadence and elapsed-time limits",
            "Required invoice and exception evidence",
            "Permitted message, artifact and resolution tools",
            "Forbidden admissions, settlements, bank-detail and contract changes"
          ],
          "humanSupervision": [
            "Approve communication policies and disclosure rules",
            "Handle commercial disputes and relationship-sensitive cases",
            "Inspect sent-message and outcome samples",
            "Review supplier experience and error metrics",
            "Pause sending while retaining drafts and evidence"
          ],
          "rollback": [
            "Stop new outbound messages",
            "Restore prior template, policy, model and Workblock versions",
            "Retract only where channel and policy permit",
            "Reopen incorrectly closed cases",
            "Record corrections and affected recipients immutably"
          ],
          "targetPosture": "mission_autonomous_with_supervision"
        },
        "coreValue": "Resolve supplier-dependent invoice issues through one governed conversation and one reconciled record instead of disconnected email and status chasing.",
        "currentStateKey": "workblock.invoice-resolution.current-state",
        "dataMappings": [
          {
            "access": "read",
            "entityId": "invoice-exception",
            "purpose": "Open supplier work only from a current, owned exception."
          },
          {
            "access": "read",
            "entityId": "invoice",
            "purpose": "Ground each communication in current invoice facts."
          },
          {
            "access": "create",
            "entityId": "supplier-invoice-resolution",
            "purpose": "Create the durable supplier-facing resolution record. Includes every owned record-envelope and lifecycle field required to reproduce this version."
          },
          {
            "access": "update",
            "entityId": "supplier-invoice-resolution",
            "purpose": "Record communication, evidence and confirmed resolution without overwriting the proposal."
          },
          {
            "access": "read",
            "entityId": "invoice-line",
            "purpose": "Read the governed invoice line contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "supplier-invoice-resolution",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "supplier-invoice-resolution",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          }
        ],
        "descriptionKey": "workblock.invoice-resolution.description",
        "descriptorKey": "workblock.invoice-resolution.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "invoice-exception-payment-readiness",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "ap-processor",
              "controller",
              "payment-approver",
              "treasury-manager",
              "risk-owner"
            ],
            "id": "open-supplier-resolution",
            "jobIds": [
              "supplier-invoice-resolution.precise-request",
              "supplier-invoice-resolution.approved-exchange",
              "supplier-invoice-resolution.response-commitment",
              "supplier-invoice-resolution.interpret-evidence",
              "supplier-invoice-resolution.reconcile-resolution"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: resolution context, resolution route, resolution message proposal, and opened resolution case.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "ap-processor",
                "controller"
              ]
            },
            "kind": "operate",
            "label": "Open supplier resolution",
            "trigger": "InvoiceResolutionRequested"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "ap-processor",
              "controller",
              "payment-approver",
              "treasury-manager",
              "risk-owner"
            ],
            "id": "continue-supplier-resolution",
            "jobIds": [
              "supplier-invoice-resolution.precise-request",
              "supplier-invoice-resolution.approved-exchange",
              "supplier-invoice-resolution.response-commitment",
              "supplier-invoice-resolution.interpret-evidence",
              "supplier-invoice-resolution.reconcile-resolution"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: validated resolution message, supplier message result, resolution response assessment, and reconciled resolution result.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "ap-processor",
                "controller"
              ]
            },
            "kind": "operate",
            "label": "Continue supplier resolution",
            "trigger": "Authority event, message receipt, timer or delivery status"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "ap-processor",
              "controller",
              "payment-approver",
              "treasury-manager",
              "risk-owner"
            ],
            "id": "read-supplier-resolution",
            "jobIds": [
              "supplier-invoice-resolution.precise-request",
              "supplier-invoice-resolution.approved-exchange",
              "supplier-invoice-resolution.response-commitment",
              "supplier-invoice-resolution.interpret-evidence",
              "supplier-invoice-resolution.reconcile-resolution"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: resolution page and resolution timeline.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "ap-processor",
                "controller"
              ]
            },
            "kind": "read",
            "label": "Read supplier resolution",
            "trigger": "Queue query or case drill-through"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "ap-processor",
              "controller",
              "payment-approver",
              "treasury-manager",
              "risk-owner"
            ],
            "id": "evaluate-resolution-quality",
            "jobIds": [
              "supplier-invoice-resolution.precise-request",
              "supplier-invoice-resolution.approved-exchange",
              "supplier-invoice-resolution.response-commitment",
              "supplier-invoice-resolution.interpret-evidence",
              "supplier-invoice-resolution.reconcile-resolution"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: resolution learning example and resolution evaluation result.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "ap-processor",
                "controller"
              ]
            },
            "kind": "monitor",
            "label": "Evaluate resolution quality",
            "trigger": "Confirmed resolution, dispute or sample schedule"
          }
        ],
        "futureStateKey": "workblock.invoice-resolution.future-state",
        "hiredInsteadKey": "workblock.invoice-resolution.hired-instead",
        "id": "supplier-invoice-resolution",
        "implementationStatus": "roadmap",
        "jobStatementKey": "workblock.invoice-resolution.job",
        "jobStories": [
          {
            "completionKey": "workblock.invoice-resolution.story.precise-request.completion",
            "executionFlowIds": [
              "open-supplier-resolution",
              "continue-supplier-resolution",
              "read-supplier-resolution",
              "evaluate-resolution-quality"
            ],
            "id": "supplier-invoice-resolution.precise-request",
            "roleCardId": "ap-processor",
            "storyKey": "workblock.invoice-resolution.story.precise-request.story"
          },
          {
            "completionKey": "workblock.invoice-resolution.story.approved-exchange.completion",
            "executionFlowIds": [
              "open-supplier-resolution",
              "continue-supplier-resolution",
              "read-supplier-resolution",
              "evaluate-resolution-quality"
            ],
            "id": "supplier-invoice-resolution.approved-exchange",
            "roleCardId": "ap-processor",
            "storyKey": "workblock.invoice-resolution.story.approved-exchange.story"
          },
          {
            "completionKey": "workblock.invoice-resolution.story.response-commitment.completion",
            "executionFlowIds": [
              "open-supplier-resolution",
              "continue-supplier-resolution",
              "read-supplier-resolution",
              "evaluate-resolution-quality"
            ],
            "id": "supplier-invoice-resolution.response-commitment",
            "roleCardId": "ap-processor",
            "storyKey": "workblock.invoice-resolution.story.response-commitment.story"
          },
          {
            "completionKey": "workblock.invoice-resolution.story.interpret-evidence.completion",
            "executionFlowIds": [
              "open-supplier-resolution",
              "continue-supplier-resolution",
              "read-supplier-resolution",
              "evaluate-resolution-quality"
            ],
            "id": "supplier-invoice-resolution.interpret-evidence",
            "roleCardId": "controller",
            "storyKey": "workblock.invoice-resolution.story.interpret-evidence.story"
          },
          {
            "completionKey": "workblock.invoice-resolution.story.reconcile-resolution.completion",
            "executionFlowIds": [
              "open-supplier-resolution",
              "continue-supplier-resolution",
              "read-supplier-resolution",
              "evaluate-resolution-quality"
            ],
            "id": "supplier-invoice-resolution.reconcile-resolution",
            "roleCardId": "controller",
            "storyKey": "workblock.invoice-resolution.story.reconcile-resolution.story"
          }
        ],
        "labelKey": "workblock.invoice-resolution.label",
        "metrics": [
          "Open, awaiting, overdue, disputed and confirmed cases with invoice drill-through",
          "Median and tail supplier response and resolution time",
          "First-contact resolution, reminder, alternate-channel and delivery-failure rates",
          "Wrong-recipient, duplicate-send, factual correction and dispute rates",
          "SLO: every sent message has current evidence, an approved recipient and immutable delivery state",
          "Recovery SLO: interrupted waits resume without duplicate sends and changed evidence expires stale drafts"
        ],
        "operatingModel": "The Workblock converts a validated exception into a structured resolution request, selects an approved channel, manages durable waits and reminders, interprets responses against current invoice evidence, applies permitted resolutions and confirms the resulting invoice and payment-readiness state.",
        "outcomeKey": "workblock.invoice-resolution.outcome",
        "prerequisites": [
          "Access to the canonical invoice and exception records",
          "Approved supplier contacts, channels and languages",
          "Communication policies and disclosure rules approved by accounts payable",
          "Named owners for commercial disputes and material resolutions"
        ],
        "toolKey": "workblock.invoice-resolution.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "build instruction proposal",
              "revalidate controls",
              "submit low-consequence in-envelope instruction",
              "poll and reconcile status",
              "retry safely rejected technical submission",
              "escalate business rejection"
            ],
            "escalationTriggers": [
              "amount or account token changed after readiness",
              "duplicate or conflicting status",
              "material or out-of-envelope payment",
              "fraud, sanction or account-integrity signal",
              "unknown downstream status",
              "recall, cancellation or manual release required"
            ],
            "id": "payment-execution-guard-agent",
            "label": "Payment execution guard agent",
            "mission": "Submit and reconcile only payments that remain inside an explicit, current finance authority envelope.",
            "operatorRoleIds": [
              "controller"
            ],
            "personaIds": [
              "finance",
              "accounts-payable",
              "platform-operator"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "payment-approver",
              "treasury-manager",
              "controller",
              "risk-owner"
            ]
          }
        ],
        "agentStoryKey": "workblock.payment-guard.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Account token or amount changed after readiness",
            "Fraud, sanction or duplicate indicator",
            "Payment outside amount, currency, entity or cumulative limit",
            "Unknown, conflicting or returned downstream status",
            "Recall, cancellation, write-off or manual hold release",
            "Control source degraded at commitment time"
          ],
          "authorityEnvelope": [
            "Permitted submit, retry, monitor and reconcile verbs",
            "Entity, account token, payment method, currency and amount limits",
            "Approved invoice and readiness cohorts",
            "Required control evidence and maximum age",
            "Allow-listed adapter and exact message version",
            "Grantor, effective window, expiry and cumulative budget",
            "Forbidden account changes, manual releases, recalls and unsupported compensation"
          ],
          "humanSupervision": [
            "Own payment authority and segregation policy",
            "Review material, novel and sampled low-consequence payments",
            "Monitor settlement, false-action and harm metrics",
            "Approve adapter and envelope releases",
            "Retain immediate kill switch and compensation authority"
          ],
          "rollback": [
            "Kill switch blocks all new commit and submit operations",
            "Restore prior execution policy, Workblock and adapter mapping",
            "Continue read-only status monitoring",
            "Invoke separately authorised cancellation, recall or offset when possible",
            "Open recovery cases for uncertain outcomes and preserve every status event"
          ],
          "targetPosture": "policy_autonomous_with_monitoring"
        },
        "coreValue": "Convert only unexpired, committed readiness decisions into controlled payment instructions and prove the downstream result end to end.",
        "currentStateKey": "workblock.payment-guard.current-state",
        "dataMappings": [
          {
            "access": "read",
            "entityId": "payment-readiness-assessment",
            "purpose": "Admit only current committed-ready invoices to execution controls."
          },
          {
            "access": "read",
            "entityId": "invoice",
            "purpose": "Revalidate payable and remittance facts at commitment time."
          },
          {
            "access": "create",
            "entityId": "payment-instruction",
            "purpose": "Persist proposal and committed instruction states with exact control lineage. Includes every owned record-envelope and lifecycle field required to reproduce this version."
          },
          {
            "access": "append",
            "entityId": "payment-execution-status",
            "purpose": "Append immutable downstream status and reconciliation evidence. Includes every owned record-envelope and lifecycle field required to reproduce this version."
          },
          {
            "access": "read",
            "entityId": "payment-execution-status",
            "purpose": "Read back the complete committed payment execution status with authority, freshness and provenance for reconciliation and record drill-through."
          },
          {
            "access": "update",
            "entityId": "payment-instruction",
            "purpose": "Project the latest reconciled status without erasing the append-only status history."
          },
          {
            "access": "read",
            "entityId": "payment-instruction",
            "purpose": "Read back the complete committed payment instruction with authority, freshness and provenance for reconciliation and record drill-through."
          },
          {
            "access": "read",
            "entityId": "payment-instruction",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "payment-execution-status",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          }
        ],
        "descriptionKey": "workblock.payment-guard.description",
        "descriptorKey": "workblock.payment-guard.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "invoice-exception-payment-readiness",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "ap-processor",
              "controller",
              "payment-approver",
              "treasury-manager",
              "risk-owner"
            ],
            "id": "propose-payment-instruction",
            "jobIds": [
              "payment-execution-guard.final-validation",
              "payment-execution-guard.duplicate-prevention",
              "payment-execution-guard.in-envelope-submit",
              "payment-execution-guard.track-outcome",
              "payment-execution-guard.reconcile-recovery"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: ready payable set, execution control result, and payment instruction proposal.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "payment-approver",
                "treasury-manager",
                "controller",
                "risk-owner"
              ]
            },
            "kind": "analyse",
            "label": "Propose payment instruction",
            "trigger": "Committed ready event or execution schedule"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "ap-processor",
              "controller",
              "payment-approver",
              "treasury-manager",
              "risk-owner"
            ],
            "id": "commit-and-submit-payment",
            "jobIds": [
              "payment-execution-guard.final-validation",
              "payment-execution-guard.duplicate-prevention",
              "payment-execution-guard.in-envelope-submit",
              "payment-execution-guard.track-outcome",
              "payment-execution-guard.reconcile-recovery"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: validated payment instruction, committed payment instruction, and payment submission result.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "payment-approver",
                "treasury-manager",
                "controller",
                "risk-owner"
              ]
            },
            "kind": "operate",
            "label": "Commit and submit payment",
            "trigger": "In-envelope proposal or explicit authority event"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "ap-processor",
              "controller",
              "payment-approver",
              "treasury-manager",
              "risk-owner"
            ],
            "id": "reconcile-payment-status",
            "jobIds": [
              "payment-execution-guard.final-validation",
              "payment-execution-guard.duplicate-prevention",
              "payment-execution-guard.in-envelope-submit",
              "payment-execution-guard.track-outcome",
              "payment-execution-guard.reconcile-recovery"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: canonical payment status, matched payment status, and reconciled payment outcome.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "payment-approver",
                "treasury-manager",
                "controller",
                "risk-owner"
              ]
            },
            "kind": "monitor",
            "label": "Reconcile payment status",
            "trigger": "Status message, statement entry, timeout or retry schedule"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "ap-processor",
              "controller",
              "payment-approver",
              "treasury-manager",
              "risk-owner"
            ],
            "id": "read-payment-guard",
            "jobIds": [
              "payment-execution-guard.final-validation",
              "payment-execution-guard.duplicate-prevention",
              "payment-execution-guard.in-envelope-submit",
              "payment-execution-guard.track-outcome",
              "payment-execution-guard.reconcile-recovery"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: payment page and payment evidence detail.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "payment-approver",
                "treasury-manager",
                "controller",
                "risk-owner"
              ]
            },
            "kind": "read",
            "label": "Read payment guard",
            "trigger": "Batch query or instruction drill-through"
          }
        ],
        "futureStateKey": "workblock.payment-guard.future-state",
        "hiredInsteadKey": "workblock.payment-guard.hired-instead",
        "id": "payment-execution-guard",
        "implementationStatus": "roadmap",
        "jobStatementKey": "workblock.payment-guard.job",
        "jobStories": [
          {
            "completionKey": "workblock.payment-guard.story.final-validation.completion",
            "executionFlowIds": [
              "propose-payment-instruction",
              "commit-and-submit-payment",
              "reconcile-payment-status",
              "read-payment-guard"
            ],
            "id": "payment-execution-guard.final-validation",
            "roleCardId": "payment-approver",
            "storyKey": "workblock.payment-guard.story.final-validation.story"
          },
          {
            "completionKey": "workblock.payment-guard.story.duplicate-prevention.completion",
            "executionFlowIds": [
              "propose-payment-instruction",
              "commit-and-submit-payment",
              "reconcile-payment-status",
              "read-payment-guard"
            ],
            "id": "payment-execution-guard.duplicate-prevention",
            "roleCardId": "risk-owner",
            "storyKey": "workblock.payment-guard.story.duplicate-prevention.story"
          },
          {
            "completionKey": "workblock.payment-guard.story.in-envelope-submit.completion",
            "executionFlowIds": [
              "propose-payment-instruction",
              "commit-and-submit-payment",
              "reconcile-payment-status",
              "read-payment-guard"
            ],
            "id": "payment-execution-guard.in-envelope-submit",
            "roleCardId": "treasury-manager",
            "storyKey": "workblock.payment-guard.story.in-envelope-submit.story"
          },
          {
            "completionKey": "workblock.payment-guard.story.track-outcome.completion",
            "executionFlowIds": [
              "propose-payment-instruction",
              "commit-and-submit-payment",
              "reconcile-payment-status",
              "read-payment-guard"
            ],
            "id": "payment-execution-guard.track-outcome",
            "roleCardId": "treasury-manager",
            "storyKey": "workblock.payment-guard.story.track-outcome.story"
          },
          {
            "completionKey": "workblock.payment-guard.story.reconcile-recovery.completion",
            "executionFlowIds": [
              "propose-payment-instruction",
              "commit-and-submit-payment",
              "reconcile-payment-status",
              "read-payment-guard"
            ],
            "id": "payment-execution-guard.reconcile-recovery",
            "roleCardId": "controller",
            "storyKey": "workblock.payment-guard.story.reconcile-recovery.story"
          }
        ],
        "labelKey": "workblock.payment-guard.label",
        "metrics": [
          "Proposed, committed, submitted, accepted, rejected, settled, returned and unknown amounts with instruction drill-through",
          "Duplicate prevented, unauthorised attempt and post-readiness change rates",
          "Acceptance and settlement latency plus reconciliation coverage",
          "Partial-batch, technical retry, business rejection and return rates",
          "SLO: zero duplicate or out-of-envelope committed instructions",
          "Recovery SLO: kill switch takes effect before any new commit and every uncertain instruction enters an owned recovery case"
        ],
        "operatingModel": "The Workblock validates authority and anti-duplication controls at the final commitment boundary, creates a standards-mapped instruction proposal, commits and submits only permitted batches, monitors acceptance and settlement messages, reconciles statements and remittance evidence and contains partial failure with explicit compensation.",
        "outcomeKey": "workblock.payment-guard.outcome",
        "prerequisites": [
          "Access to committed payment-readiness assessments and canonical invoices",
          "An allow-listed bank or payment-network connection with exact message versions",
          "A payment authority and segregation-of-duties policy with named grantors",
          "Bank statement and remittance feeds for settlement reconciliation",
          "Entity, account, currency and amount limits agreed with treasury"
        ],
        "toolKey": "workblock.payment-guard.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "assemble evidence pack",
              "calculate approved measures",
              "identify missing or conflicting evidence",
              "draft narrative and action options",
              "schedule routine follow-up",
              "open pre-authorised internal actions"
            ],
            "escalationTriggers": [
              "supplier disputes material evidence",
              "scorecard method is inapplicable",
              "critical service or risk deterioration",
              "relationship restriction or exit proposed",
              "material financial commitment",
              "conflict of interest or unfair comparison"
            ],
            "id": "supplier-performance-review-agent",
            "label": "Supplier performance review agent",
            "mission": "Prepare, explain and follow through a fair supplier review from current governed evidence.",
            "operatorRoleIds": [
              "governance-owner"
            ],
            "personaIds": [
              "supplier-relationship-manager",
              "category-management-persona",
              "supplier-risk-manager",
              "finance"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "relationship-manager",
              "governance-owner",
              "metric-owner",
              "supplier-account-lead"
            ]
          }
        ],
        "agentStoryKey": "workblock.performance.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Critical service, safety or supplier-risk signal",
            "Supplier dispute of material evidence",
            "Restriction, suspension, exit or contract remedy",
            "Material financial or public commitment",
            "Scorecard method conflict or invalid peer comparison",
            "Evidence gap that could reverse the decision"
          ],
          "authorityEnvelope": [
            "Permitted evidence, calculation, drafting, scheduling and action-opening verbs",
            "Supplier, category, relationship segment and review-period scope",
            "Approved scorecard, cohort and comparison methods",
            "Materiality and consequence boundaries for internal actions",
            "Permitted evidence, document and work-management tools",
            "Grantor, duration, sampling and expiry",
            "Forbidden supplier restriction, contract change and ungranted financial commitment"
          ],
          "humanSupervision": [
            "Own relationship objectives and scorecard meaning",
            "Commit material performance and relationship decisions",
            "Inspect sampled autonomous packages and routine actions",
            "Resolve supplier disputes and qualitative judgement",
            "Approve release promotion, demotion and envelope change"
          ],
          "rollback": [
            "Pause new automated actions",
            "Restore the last approved scorecard and review method",
            "Rebuild the proposed review from the last trusted observations",
            "Correct or supersede disputed review through a new decision",
            "Keep the committed history and notify each affected action owner"
          ],
          "targetPosture": "mission_autonomous_with_supervision"
        },
        "coreValue": "Turn current, source-linked supplier performance evidence into a fair review, a committed decision and an owned improvement plan.",
        "currentStateKey": "workblock.performance.current-state",
        "dataMappings": [
          {
            "access": "read",
            "entityId": "supplier-segment-assignment",
            "purpose": "Select the valid scorecard and governance ceremony."
          },
          {
            "access": "read",
            "entityId": "supplier-performance-observation",
            "purpose": "Calculate and explain the scorecard from atomic observations."
          },
          {
            "access": "create",
            "entityId": "supplier-performance-review-record",
            "purpose": "Create a proposal that binds exact evidence and method versions. Includes every owned record-envelope and lifecycle field required to reproduce this version."
          },
          {
            "access": "update",
            "entityId": "supplier-performance-review-record",
            "purpose": "Record the authorised review and follow-through without replacing the proposal."
          },
          {
            "access": "read",
            "entityId": "party",
            "purpose": "Read the policy-filtered canonical party projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "source-record-reference",
            "purpose": "Read the policy-filtered canonical source record reference projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "authority-envelope",
            "purpose": "Read the policy-filtered canonical authority envelope projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "decision",
            "purpose": "Read the policy-filtered canonical decision projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "audit-event",
            "purpose": "Read the policy-filtered canonical audit event projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "business-event",
            "purpose": "Read the policy-filtered canonical business event projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "learning-example",
            "purpose": "Read the policy-filtered canonical learning example projection from learning-evaluation-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "evaluation-result",
            "purpose": "Read the policy-filtered canonical evaluation result projection from learning-evaluation-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "integration-state",
            "purpose": "Read the policy-filtered canonical integration state projection from integration-state-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "registry-release",
            "purpose": "Read the policy-filtered canonical registry release projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "supplier-remediation-action",
            "purpose": "Read the governed supplier remediation action contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "supplier-offboarding-case",
            "purpose": "Read the governed supplier offboarding case contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "supplier-performance-review-record",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "supplier-performance-review-record",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "supplier-performance-signal",
            "purpose": "Read an authorised supplier-performance-signal record by stable identity through supplier-performance-monitor-correct's owner API; this grants no collection browsing or datastore access."
          },
          {
            "access": "read",
            "entityId": "action-proposal",
            "purpose": "Point-read the exact permission-safe D8 handoff action-proposal record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "committed-action",
            "purpose": "Point-read the exact permission-safe D8 handoff committed-action record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "create",
            "entityId": "decision",
            "purpose": "Submit the authorised, version-pinned D8 receiving-owner acceptance, rejection, redirect, expiry or reopen decision to shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "committed-action",
            "purpose": "Append each authorised D8 delivery or receiver-owned command attempt with idempotency, safe-retry and reconciliation state through shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "business-event",
            "purpose": "Append immutable D8 delivery, acknowledgement, rejection, reconciliation, replay or reopen facts through audit-event-service; an event never becomes current domain state."
          }
        ],
        "descriptionKey": "workblock.performance.description",
        "descriptorKey": "workblock.performance.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "supplier-performance-innovation-relationship",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "relationship-manager",
              "governance-owner",
              "metric-owner",
              "supplier-account-lead",
              "innovation-sponsor"
            ],
            "id": "prepare-supplier-review",
            "jobIds": [
              "supplier-performance-review.prepare-pack",
              "supplier-performance-review.critical-event",
              "supplier-performance-review.reproduce-score",
              "supplier-performance-review.accept-commitment",
              "supplier-performance-review.verify-closure",
              "supplier-performance-review.carry-handoff"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The review-evidence-snapshot, supplier-scorecard-result, review-gap-set and supplier-review-proposal make every score reproducible from its method, sources and period and leave missing or disputed evidence explicit.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "relationship-manager",
                "governance-owner",
                "metric-owner",
                "supplier-account-lead"
              ]
            },
            "kind": "analyse",
            "label": "Prepare supplier review",
            "trigger": "Review window, material observation change or explicit request"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "relationship-manager",
              "governance-owner",
              "metric-owner",
              "supplier-account-lead",
              "innovation-sponsor"
            ],
            "id": "commit-supplier-review",
            "jobIds": [
              "supplier-performance-review.prepare-pack",
              "supplier-performance-review.critical-event",
              "supplier-performance-review.reproduce-score",
              "supplier-performance-review.accept-commitment",
              "supplier-performance-review.verify-closure",
              "supplier-performance-review.carry-handoff"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The validated-supplier-review and committed-supplier-review retain the evidence version, authority and each accepted conclusion; the supplier-review-action-result distinguishes dispatched buyer actions, accepted supplier commitments and blocked handoffs.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "relationship-manager",
                "metric-owner",
                "governance-owner",
                "supplier-account-lead"
              ]
            },
            "kind": "operate",
            "label": "Commit supplier review",
            "trigger": "In-envelope internal action or explicit review authority event"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "relationship-manager",
              "governance-owner",
              "metric-owner",
              "supplier-account-lead",
              "innovation-sponsor"
            ],
            "id": "read-supplier-review",
            "jobIds": [
              "supplier-performance-review.prepare-pack",
              "supplier-performance-review.critical-event",
              "supplier-performance-review.reproduce-score",
              "supplier-performance-review.accept-commitment",
              "supplier-performance-review.verify-closure",
              "supplier-performance-review.carry-handoff"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The supplier-review-page and supplier-review-detail expose current or clearly stale last-good state and open every score, conclusion and action to its method, evidence, authority and acceptance status.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "relationship-manager",
                "metric-owner",
                "governance-owner",
                "supplier-account-lead"
              ]
            },
            "kind": "read",
            "label": "Read supplier review",
            "trigger": "Calendar, portfolio or supplier drill-through"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "relationship-manager",
              "governance-owner",
              "metric-owner",
              "supplier-account-lead",
              "innovation-sponsor"
            ],
            "id": "evaluate-review-outcomes",
            "jobIds": [
              "supplier-performance-review.prepare-pack",
              "supplier-performance-review.critical-event",
              "supplier-performance-review.reproduce-score",
              "supplier-performance-review.accept-commitment",
              "supplier-performance-review.verify-closure",
              "supplier-performance-review.carry-handoff"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The supplier-review-example links the committed review to accepted actions, closure evidence and subsequent performance; the supplier-review-evaluation-result reports quality, dispute, overdue and harm slices by version.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "governance-owner",
                "relationship-manager",
                "metric-owner",
                "supplier-account-lead"
              ]
            },
            "kind": "monitor",
            "label": "Evaluate review outcomes",
            "trigger": "Action outcome, next review, dispute or sampling schedule"
          }
        ],
        "futureStateKey": "workblock.performance.future-state",
        "hiredInsteadKey": "workblock.performance.hired-instead",
        "id": "supplier-performance-review",
        "implementationStatus": "reference",
        "jobStatementKey": "workblock.performance.job",
        "jobStories": [
          {
            "completionKey": "workblock.performance.story.prepare-pack.completion",
            "executionFlowIds": [
              "prepare-supplier-review",
              "commit-supplier-review",
              "read-supplier-review",
              "evaluate-review-outcomes"
            ],
            "id": "supplier-performance-review.prepare-pack",
            "roleCardId": "relationship-manager",
            "storyKey": "workblock.performance.story.prepare-pack.story"
          },
          {
            "completionKey": "workblock.performance.story.critical-event.completion",
            "executionFlowIds": [
              "prepare-supplier-review",
              "commit-supplier-review",
              "read-supplier-review",
              "evaluate-review-outcomes"
            ],
            "id": "supplier-performance-review.critical-event",
            "roleCardId": "relationship-manager",
            "storyKey": "workblock.performance.story.critical-event.story"
          },
          {
            "completionKey": "workblock.performance.story.reproduce-score.completion",
            "executionFlowIds": [
              "prepare-supplier-review",
              "commit-supplier-review",
              "read-supplier-review",
              "evaluate-review-outcomes"
            ],
            "id": "supplier-performance-review.reproduce-score",
            "roleCardId": "metric-owner",
            "storyKey": "workblock.performance.story.reproduce-score.story"
          },
          {
            "completionKey": "workblock.performance.story.accept-commitment.completion",
            "executionFlowIds": [
              "prepare-supplier-review",
              "commit-supplier-review",
              "read-supplier-review",
              "evaluate-review-outcomes"
            ],
            "id": "supplier-performance-review.accept-commitment",
            "roleCardId": "supplier-account-lead",
            "storyKey": "workblock.performance.story.accept-commitment.story"
          },
          {
            "completionKey": "workblock.performance.story.verify-closure.completion",
            "executionFlowIds": [
              "prepare-supplier-review",
              "commit-supplier-review",
              "read-supplier-review",
              "evaluate-review-outcomes"
            ],
            "id": "supplier-performance-review.verify-closure",
            "roleCardId": "relationship-manager",
            "storyKey": "workblock.performance.story.verify-closure.story"
          },
          {
            "completionKey": "workblock.performance.story.carry-handoff.completion",
            "executionFlowIds": [
              "prepare-supplier-review",
              "commit-supplier-review",
              "read-supplier-review",
              "evaluate-review-outcomes"
            ],
            "id": "supplier-performance-review.carry-handoff",
            "roleCardId": "relationship-manager",
            "storyKey": "workblock.performance.story.carry-handoff.story"
          }
        ],
        "labelKey": "workblock.performance.label",
        "metrics": [
          "Review coverage, due and overdue count with supplier drill-through",
          "Observation completeness and freshness by measure",
          "Score correction, narrative edit, dispute and override rates",
          "Corrective action completion and post-review performance change",
          "SLO: every displayed score has measure definition, period, source and freshness",
          "Recovery SLO: stale or corrected observations rebuild the proposal without changing a committed historical review"
        ],
        "officeCapabilities": [
          "composer",
          "conductor"
        ],
        "operatingModel": "The Workblock assembles governed observations across delivery, quality, service, commercial, risk, sustainability and relationship outcomes; applies a versioned scorecard; exposes disagreements and missing evidence; drafts a review narrative and action set; records the committed review outcome; and follows every decision into corrective or joint-value work.",
        "outcomeKey": "workblock.performance.outcome",
        "prerequisites": [
          "Access to supplier performance observations and segment assignments",
          "A versioned scorecard method agreed with relationship owners",
          "Read connections to delivery, quality, service and commercial evidence sources",
          "Named owners for review decisions and improvement actions"
        ],
        "toolKey": "workblock.performance.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "deduplicate and classify ideas",
              "request routine evidence",
              "draft hypotheses and experiment plans",
              "schedule gate preparation",
              "coordinate in-envelope experiment tasks",
              "close withdrawn or duplicate cases"
            ],
            "escalationTriggers": [
              "investment or contractual commitment",
              "intellectual-property or competition concern",
              "material security, safety or third-party risk",
              "unsupported value claim",
              "experiment exceeds budget or stop condition",
              "supplier communication outside approved scope"
            ],
            "id": "supplier-innovation-agent",
            "label": "Supplier innovation agent",
            "mission": "Advance qualified supplier ideas through the shortest evidence and governance path to a measured outcome.",
            "operatorRoleIds": [
              "governance-owner"
            ],
            "personaIds": [
              "supplier-relationship-manager",
              "category-management-persona",
              "requester-persona",
              "finance",
              "supplier-risk-manager"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "innovation-sponsor",
              "relationship-manager",
              "governance-owner",
              "supplier-account-lead"
            ]
          }
        ],
        "agentStoryKey": "workblock.innovation.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Contract, investment or supplier promise",
            "Intellectual-property, competition or restricted-data issue",
            "Material security, safety, compliance or supplier-risk concern",
            "Experiment beyond budget, scope or stop condition",
            "Evidence conflicts on feasibility or value",
            "Novel decision not represented in gate policy"
          ],
          "authorityEnvelope": [
            "Permitted capture, enrich, request, draft, schedule and coordinate verbs",
            "Supplier, category, objective and innovation-type scope",
            "Experiment budget, duration, data and tool limits",
            "Approved stage definitions and evidence requirements",
            "Permitted internal and supplier channels",
            "Grantor, mission duration, stop conditions and sampling",
            "Forbidden investment, IP, contract and external promise actions unless separately granted"
          ],
          "humanSupervision": [
            "Set innovation themes and gate policy",
            "Sponsor experiments and commit investment or scale decisions",
            "Inspect sampled agent coordination and outcome quality",
            "Resolve IP, risk, competition and relationship exceptions",
            "Stop experiments and narrow mission scope"
          ],
          "rollback": [
            "Invoke the Workblock kill switch to pause new gate and experiment actions",
            "Restore prior gate policy, prompt, model and Workblock versions",
            "Execute pre-agreed experiment stop and data-handling plan",
            "Reopen incorrectly advanced cases",
            "Preserve supplier communications, decisions and outcomes"
          ],
          "targetPosture": "mission_autonomous_with_supervision"
        },
        "coreValue": "Convert supplier ideas into governed experiments and measurable outcomes instead of an unprioritised suggestion backlog.",
        "currentStateKey": "workblock.innovation.current-state",
        "dataMappings": [
          {
            "access": "read",
            "entityId": "supplier-segment-assignment",
            "purpose": "Apply the relationship-specific innovation path and authority."
          },
          {
            "access": "read",
            "entityId": "supplier-performance-review-record",
            "purpose": "Use recent relationship decisions without treating a review narrative as measured innovation value."
          },
          {
            "access": "create",
            "entityId": "supplier-innovation-case",
            "purpose": "Create the governed innovation case and its provisional hypotheses. Includes every owned record-envelope and lifecycle field required to reproduce this version."
          },
          {
            "access": "update",
            "entityId": "supplier-innovation-case",
            "purpose": "Record committed gates and measured outcomes separately from proposals."
          },
          {
            "access": "read",
            "entityId": "supplier-joint-value-plan",
            "purpose": "Align the case with agreed relationship objectives and prevent duplicate work."
          },
          {
            "access": "read",
            "entityId": "supplier-innovation-case",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "supplier-innovation-case",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "action-proposal",
            "purpose": "Point-read the exact permission-safe D7/D8 handoff action-proposal record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "decision",
            "purpose": "Point-read the exact permission-safe D7/D8 handoff decision record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "committed-action",
            "purpose": "Point-read the exact permission-safe D7/D8 handoff committed-action record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "business-event",
            "purpose": "Point-read the exact permission-safe D7/D8 handoff business-event record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "create",
            "entityId": "action-proposal",
            "purpose": "Submit the version-pinned D7/D8 requested outcome, sender/receiver, source/target, evidence, authority, expiry and reopen context to shared-ledger-service without writing receiver-owned state."
          },
          {
            "access": "create",
            "entityId": "decision",
            "purpose": "Submit the authorised, version-pinned D7/D8 receiving-owner acceptance, rejection, redirect, expiry or reopen decision to shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "committed-action",
            "purpose": "Append each authorised D7/D8 delivery or receiver-owned command attempt with idempotency, safe-retry and reconciliation state through shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "business-event",
            "purpose": "Append immutable D7/D8 delivery, acknowledgement, rejection, reconciliation, replay or reopen facts through audit-event-service; an event never becomes current domain state."
          },
          {
            "access": "read",
            "entityId": "sourcing-opportunity",
            "purpose": "Read the exact D7 receiver-owned sourcing target/version returned during reconciliation."
          },
          {
            "access": "read",
            "entityId": "contract-change",
            "purpose": "Read the exact D7 receiver-owned contract-change target/version returned during reconciliation."
          },
          {
            "access": "read",
            "entityId": "value-opportunity-baseline",
            "purpose": "Read the exact D7 receiver-owned value target/version returned during reconciliation."
          }
        ],
        "descriptionKey": "workblock.innovation.description",
        "descriptorKey": "workblock.innovation.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "supplier-performance-innovation-relationship",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "relationship-manager",
              "governance-owner",
              "metric-owner",
              "supplier-account-lead",
              "innovation-sponsor"
            ],
            "id": "intake-innovation-case",
            "jobIds": [
              "supplier-innovation-pipeline.capture-idea",
              "supplier-innovation-pipeline.attach-sponsor",
              "supplier-innovation-pipeline.bound-stage",
              "supplier-innovation-pipeline.answer-supplier",
              "supplier-innovation-pipeline.separate-value"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: normalised innovation concept, innovation related set, innovation evidence snapshot, and opened innovation case.",
                "Accepted and rejected inputs are counted, source-linked and assigned a freshness state; a failed refresh retains last-good data.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "innovation-sponsor",
                "relationship-manager",
                "governance-owner",
                "supplier-account-lead"
              ]
            },
            "kind": "ingest",
            "label": "Intake innovation case",
            "trigger": "Business need, supplier idea or relationship-plan signal"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "relationship-manager",
              "governance-owner",
              "metric-owner",
              "supplier-account-lead",
              "innovation-sponsor"
            ],
            "id": "operate-innovation-gate",
            "jobIds": [
              "supplier-innovation-pipeline.capture-idea",
              "supplier-innovation-pipeline.attach-sponsor",
              "supplier-innovation-pipeline.bound-stage",
              "supplier-innovation-pipeline.answer-supplier",
              "supplier-innovation-pipeline.separate-value"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: innovation gate package, innovation gate proposal, committed innovation gate, and innovation gate action result.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "innovation-sponsor",
                "relationship-manager",
                "governance-owner",
                "supplier-account-lead"
              ]
            },
            "kind": "operate",
            "label": "Operate innovation gate",
            "trigger": "Stage entry, evidence received, experiment event or authority event"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "relationship-manager",
              "governance-owner",
              "metric-owner",
              "supplier-account-lead",
              "innovation-sponsor"
            ],
            "id": "monitor-innovation-experiment",
            "jobIds": [
              "supplier-innovation-pipeline.capture-idea",
              "supplier-innovation-pipeline.attach-sponsor",
              "supplier-innovation-pipeline.bound-stage",
              "supplier-innovation-pipeline.answer-supplier",
              "supplier-innovation-pipeline.separate-value"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: experiment observation set, experiment evaluation, and innovation outcome result.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "innovation-sponsor",
                "relationship-manager",
                "governance-owner",
                "supplier-account-lead"
              ]
            },
            "kind": "monitor",
            "label": "Monitor innovation experiment",
            "trigger": "Experiment measure, milestone, stop signal or schedule"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "relationship-manager",
              "governance-owner",
              "metric-owner",
              "supplier-account-lead",
              "innovation-sponsor"
            ],
            "id": "read-innovation-pipeline",
            "jobIds": [
              "supplier-innovation-pipeline.capture-idea",
              "supplier-innovation-pipeline.attach-sponsor",
              "supplier-innovation-pipeline.bound-stage",
              "supplier-innovation-pipeline.answer-supplier",
              "supplier-innovation-pipeline.separate-value"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: innovation page and innovation detail.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "innovation-sponsor",
                "relationship-manager",
                "governance-owner",
                "supplier-account-lead"
              ]
            },
            "kind": "read",
            "label": "Read innovation pipeline",
            "trigger": "Pipeline query or case drill-through"
          }
        ],
        "futureStateKey": "workblock.innovation.future-state",
        "hiredInsteadKey": "workblock.innovation.hired-instead",
        "id": "supplier-innovation-pipeline",
        "implementationStatus": "roadmap",
        "jobStatementKey": "workblock.innovation.job",
        "jobStories": [
          {
            "completionKey": "workblock.innovation.story.capture-idea.completion",
            "executionFlowIds": [
              "intake-innovation-case",
              "operate-innovation-gate",
              "monitor-innovation-experiment",
              "read-innovation-pipeline"
            ],
            "id": "supplier-innovation-pipeline.capture-idea",
            "roleCardId": "relationship-manager",
            "storyKey": "workblock.innovation.story.capture-idea.story"
          },
          {
            "completionKey": "workblock.innovation.story.attach-sponsor.completion",
            "executionFlowIds": [
              "intake-innovation-case",
              "operate-innovation-gate",
              "monitor-innovation-experiment",
              "read-innovation-pipeline"
            ],
            "id": "supplier-innovation-pipeline.attach-sponsor",
            "roleCardId": "innovation-sponsor",
            "storyKey": "workblock.innovation.story.attach-sponsor.story"
          },
          {
            "completionKey": "workblock.innovation.story.bound-stage.completion",
            "executionFlowIds": [
              "intake-innovation-case",
              "operate-innovation-gate",
              "monitor-innovation-experiment",
              "read-innovation-pipeline"
            ],
            "id": "supplier-innovation-pipeline.bound-stage",
            "roleCardId": "innovation-sponsor",
            "storyKey": "workblock.innovation.story.bound-stage.story"
          },
          {
            "completionKey": "workblock.innovation.story.answer-supplier.completion",
            "executionFlowIds": [
              "intake-innovation-case",
              "operate-innovation-gate",
              "monitor-innovation-experiment",
              "read-innovation-pipeline"
            ],
            "id": "supplier-innovation-pipeline.answer-supplier",
            "roleCardId": "supplier-account-lead",
            "storyKey": "workblock.innovation.story.answer-supplier.story"
          },
          {
            "completionKey": "workblock.innovation.story.separate-value.completion",
            "executionFlowIds": [
              "intake-innovation-case",
              "operate-innovation-gate",
              "monitor-innovation-experiment",
              "read-innovation-pipeline"
            ],
            "id": "supplier-innovation-pipeline.separate-value",
            "roleCardId": "innovation-sponsor",
            "storyKey": "workblock.innovation.story.separate-value.story"
          }
        ],
        "labelKey": "workblock.innovation.label",
        "metrics": [
          "Ideas by stage, age, owner and next action with case drill-through",
          "Duplicate, evidence-missing, gate conversion and cycle-time rates",
          "Experiment started, stopped, successful, scaled and outcome-validated counts",
          "Unsupported claim, missed-risk, override and reopened-gate rates",
          "SLO: every active experiment has a current plan, owner, baseline, success measure and stop condition",
          "Recovery SLO: a kill event stops new experiment actions and preserves a complete decision and communication trail"
        ],
        "operatingModel": "The Workblock captures needs and supplier proposals, checks scope and duplication, develops concepts linked to source records and assumptions, routes the right stage gate, coordinates experiments, tracks commitments and measures outcomes. Machine hypotheses remain explicitly provisional until a named authority commits a gate or investment decision.",
        "outcomeKey": "workblock.innovation.outcome",
        "prerequisites": [
          "Access to supplier segment assignments and performance review records",
          "Stage-gate definitions and evidence requirements agreed with sponsors",
          "Approved internal and supplier channels for idea capture",
          "Named sponsors for gate and investment decisions"
        ],
        "toolKey": "workblock.innovation.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "refresh features",
              "propose assignment",
              "commit non-material in-envelope assignment",
              "expire stale proposal",
              "publish routine governance changes"
            ],
            "escalationTriggers": [
              "strategic or restricted segment change",
              "criticality increase",
              "conflicting value and risk evidence",
              "supplier dispute",
              "material downstream governance impact",
              "missing mandatory dependency evidence"
            ],
            "id": "supplier-segmentation-agent",
            "label": "Supplier segmentation agent",
            "mission": "Maintain supplier assignments linked to current qualification and relationship records and activate the correct governance path.",
            "operatorRoleIds": [
              "governance-owner"
            ],
            "personaIds": [
              "supplier-relationship-manager",
              "category-management-persona",
              "supplier-risk-manager",
              "finance"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "governance-owner",
              "relationship-manager",
              "metric-owner"
            ]
          }
        ],
        "agentStoryKey": "workblock.supplier-segmentation.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Assignment enters or leaves a strategic or critical cohort",
            "Criticality increases materially",
            "Supplier disputes assignment or evidence",
            "Mandatory dependency or risk evidence conflicts",
            "Downstream restriction or material cost change",
            "Transition absent from policy"
          ],
          "authorityEnvelope": [
            "Permitted feature refresh, proposal, commit and publish verbs",
            "Supplier, category and segment-transition cohorts",
            "Approved model, thresholds, evidence and freshness policy",
            "Materiality and criticality limits",
            "Permitted ledger and event tools",
            "Grantor, effective period, expiry and sampling",
            "Forbidden supplier restriction, exit and unapproved governance reduction"
          ],
          "humanSupervision": [
            "Own segmentation meaning and downstream governance",
            "Review strategic, critical and disputed assignments",
            "Inspect sampled routine changes and cohort outcomes",
            "Approve policy or envelope releases",
            "Pause automatic commitment while preserving proposals"
          ],
          "rollback": [
            "Invoke the Workblock kill switch to stop new assignment commits",
            "Restore prior segmentation policy and Workblock versions",
            "Reinstate last-good effective assignment where allowed",
            "Republish corrective governance events",
            "Retain every proposal, commitment and supersession"
          ],
          "targetPosture": "policy_autonomous_with_monitoring"
        },
        "coreValue": "Keep every supplier on the governance, performance and collaboration path warranted by current value, criticality, risk and relationship evidence.",
        "currentStateKey": "workblock.supplier-segmentation.current-state",
        "dataMappings": [
          {
            "access": "read",
            "entityId": "supplier-performance-observation",
            "purpose": "Use governed performance evidence without duplicating observations."
          },
          {
            "access": "create",
            "entityId": "supplier-segment-assignment",
            "purpose": "Create the transparent, effective-dated segment proposal. Includes every owned record-envelope and lifecycle field required to reproduce this version."
          },
          {
            "access": "update",
            "entityId": "supplier-segment-assignment",
            "purpose": "Commit or supersede the assignment while preserving proposal and history."
          },
          {
            "access": "read",
            "entityId": "supplier-segment-assignment",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "supplier-segment-assignment",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "action-proposal",
            "purpose": "Point-read the exact permission-safe D8 handoff action-proposal record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "decision",
            "purpose": "Point-read the exact permission-safe D8 handoff decision record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "committed-action",
            "purpose": "Point-read the exact permission-safe D8 handoff committed-action record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "business-event",
            "purpose": "Point-read the exact permission-safe D8 handoff business-event record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "create",
            "entityId": "action-proposal",
            "purpose": "Submit the version-pinned D8 requested outcome, sender/receiver, source/target, evidence, authority, expiry and reopen context to shared-ledger-service without writing receiver-owned state."
          },
          {
            "access": "append",
            "entityId": "committed-action",
            "purpose": "Append each authorised D8 delivery or receiver-owned command attempt with idempotency, safe-retry and reconciliation state through shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "business-event",
            "purpose": "Append immutable D8 delivery, acknowledgement, rejection, reconciliation, replay or reopen facts through audit-event-service; an event never becomes current domain state."
          }
        ],
        "descriptionKey": "workblock.supplier-segmentation.description",
        "descriptorKey": "workblock.supplier-segmentation.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "supplier-performance-innovation-relationship",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "relationship-manager",
              "governance-owner",
              "metric-owner",
              "supplier-account-lead",
              "innovation-sponsor"
            ],
            "id": "refresh-segmentation",
            "jobIds": [
              "supplier-segmentation-governance.current-segment",
              "supplier-segmentation-governance.change-signal",
              "supplier-segmentation-governance.routine-resegment",
              "supplier-segmentation-governance.material-assignment",
              "supplier-segmentation-governance.propagate-treatment"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: segmentation evidence set, segmentation feature set, supplier segment proposals, and segment impact preview.",
                "Accepted and rejected inputs are counted, source-linked and assigned a freshness state; a failed refresh retains last-good data.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "governance-owner",
                "relationship-manager",
                "metric-owner"
              ]
            },
            "kind": "refresh",
            "label": "Refresh segmentation",
            "trigger": "Material supplier evidence change or scheduled cohort refresh"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "relationship-manager",
              "governance-owner",
              "metric-owner",
              "supplier-account-lead",
              "innovation-sponsor"
            ],
            "id": "commit-segment-assignment",
            "jobIds": [
              "supplier-segmentation-governance.current-segment",
              "supplier-segmentation-governance.change-signal",
              "supplier-segmentation-governance.routine-resegment",
              "supplier-segmentation-governance.material-assignment",
              "supplier-segmentation-governance.propagate-treatment"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: validated segment proposal, committed segment assignment, and segment governance event.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "governance-owner",
                "relationship-manager",
                "metric-owner"
              ]
            },
            "kind": "operate",
            "label": "Commit segment assignment",
            "trigger": "In-envelope proposal or explicit segmentation authority event"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "relationship-manager",
              "governance-owner",
              "metric-owner",
              "supplier-account-lead",
              "innovation-sponsor"
            ],
            "id": "read-segmentation-governance",
            "jobIds": [
              "supplier-segmentation-governance.current-segment",
              "supplier-segmentation-governance.change-signal",
              "supplier-segmentation-governance.routine-resegment",
              "supplier-segmentation-governance.material-assignment",
              "supplier-segmentation-governance.propagate-treatment"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: segmentation page and segmentation detail.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "governance-owner",
                "relationship-manager",
                "metric-owner"
              ]
            },
            "kind": "read",
            "label": "Read segmentation governance",
            "trigger": "Portfolio query or supplier drill-through"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "relationship-manager",
              "governance-owner",
              "metric-owner",
              "supplier-account-lead",
              "innovation-sponsor"
            ],
            "id": "evaluate-segmentation",
            "jobIds": [
              "supplier-segmentation-governance.current-segment",
              "supplier-segmentation-governance.change-signal",
              "supplier-segmentation-governance.routine-resegment",
              "supplier-segmentation-governance.material-assignment",
              "supplier-segmentation-governance.propagate-treatment"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: segmentation example and segmentation evaluation result.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "governance-owner",
                "relationship-manager",
                "metric-owner"
              ]
            },
            "kind": "monitor",
            "label": "Evaluate segmentation",
            "trigger": "Assignment correction, outcome change or evaluation schedule"
          }
        ],
        "futureStateKey": "workblock.supplier-segmentation.future-state",
        "hiredInsteadKey": "workblock.supplier-segmentation.hired-instead",
        "id": "supplier-segmentation-governance",
        "implementationStatus": "roadmap",
        "jobStatementKey": "workblock.supplier-segmentation.job",
        "jobStories": [
          {
            "completionKey": "workblock.supplier-segmentation.story.current-segment.completion",
            "executionFlowIds": [
              "refresh-segmentation",
              "commit-segment-assignment",
              "read-segmentation-governance",
              "evaluate-segmentation"
            ],
            "id": "supplier-segmentation-governance.current-segment",
            "roleCardId": "relationship-manager",
            "storyKey": "workblock.supplier-segmentation.story.current-segment.story"
          },
          {
            "completionKey": "workblock.supplier-segmentation.story.change-signal.completion",
            "executionFlowIds": [
              "refresh-segmentation",
              "commit-segment-assignment",
              "read-segmentation-governance",
              "evaluate-segmentation"
            ],
            "id": "supplier-segmentation-governance.change-signal",
            "roleCardId": "metric-owner",
            "storyKey": "workblock.supplier-segmentation.story.change-signal.story"
          },
          {
            "completionKey": "workblock.supplier-segmentation.story.routine-resegment.completion",
            "executionFlowIds": [
              "refresh-segmentation",
              "commit-segment-assignment",
              "read-segmentation-governance",
              "evaluate-segmentation"
            ],
            "id": "supplier-segmentation-governance.routine-resegment",
            "roleCardId": "governance-owner",
            "storyKey": "workblock.supplier-segmentation.story.routine-resegment.story"
          },
          {
            "completionKey": "workblock.supplier-segmentation.story.material-assignment.completion",
            "executionFlowIds": [
              "refresh-segmentation",
              "commit-segment-assignment",
              "read-segmentation-governance",
              "evaluate-segmentation"
            ],
            "id": "supplier-segmentation-governance.material-assignment",
            "roleCardId": "governance-owner",
            "storyKey": "workblock.supplier-segmentation.story.material-assignment.story"
          },
          {
            "completionKey": "workblock.supplier-segmentation.story.propagate-treatment.completion",
            "executionFlowIds": [
              "refresh-segmentation",
              "commit-segment-assignment",
              "read-segmentation-governance",
              "evaluate-segmentation"
            ],
            "id": "supplier-segmentation-governance.propagate-treatment",
            "roleCardId": "relationship-manager",
            "storyKey": "workblock.supplier-segmentation.story.propagate-treatment.story"
          }
        ],
        "labelKey": "workblock.supplier-segmentation.label",
        "metrics": [
          "Supplier distribution by committed segment and criticality with record drill-through",
          "Feature completeness, freshness and stale last-good age",
          "Proposal-to-commit, override, dispute and transition rates",
          "Downstream scorecard, review and governance activation coverage",
          "SLO: every effective assignment has current policy, evidence snapshot and authority lineage",
          "Recovery SLO: a bad policy cohort can return to last-good assignments and republish governance without duplicate effects"
        ],
        "operatingModel": "The Workblock reconciles approved spend, dependency, category, risk, performance, innovation and strategic evidence; calculates a transparent segment proposal; commits routine assignments inside policy; routes material changes; and publishes the effective assignment that controls scorecards, reviews, cadence, authority and relationship work.",
        "outcomeKey": "workblock.supplier-segmentation.outcome",
        "prerequisites": [
          "Access to supplier performance observations",
          "Read connections to approved spend, dependency and risk evidence",
          "An approved segmentation model with thresholds and freshness policy",
          "A named governance owner for material segment changes"
        ],
        "toolKey": "workblock.supplier-segmentation.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "validate and publish observation",
              "open routine signal",
              "consolidate duplicate symptoms",
              "request approved evidence",
              "create internal corrective tasks",
              "send policy-timed reminders",
              "verify deterministic recovery"
            ],
            "escalationTriggers": [
              "critical safety, service or compliance breach",
              "supplier disputes source or target",
              "contractual remedy or restriction",
              "persistent failure after corrective plan",
              "material business impact",
              "measurement method conflict"
            ],
            "id": "supplier-performance-monitor-agent",
            "label": "Supplier performance monitor and correction agent",
            "mission": "Find actionable supplier deterioration and coordinate recovery linked to current observations inside relationship policy.",
            "operatorRoleIds": [
              "governance-owner"
            ],
            "personaIds": [
              "supplier-relationship-manager",
              "category-management-persona",
              "supplier-risk-manager",
              "buyer",
              "requester-persona"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "metric-owner",
              "relationship-manager",
              "governance-owner",
              "supplier-account-lead"
            ]
          }
        ],
        "agentStoryKey": "workblock.performance-monitor.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Safety, regulatory or critical service breach",
            "Supplier disputes authoritative source or target",
            "Contractual remedy, restriction or exit",
            "Persistent failure beyond policy window",
            "Data quality could reverse material conclusion",
            "Novel measure or root-cause class"
          ],
          "authorityEnvelope": [
            "Permitted ingest, detect, consolidate, request, task, remind and verify verbs",
            "Supplier, segment, measure, service and consequence cohorts",
            "Approved measure definitions, targets and signal rules",
            "Evidence, persistence and freshness requirements",
            "Permitted source, work-management and collaboration tools",
            "Grantor, duration, sampling and expiry",
            "Forbidden contract remedy, supplier restriction and unapproved external commitment"
          ],
          "humanSupervision": [
            "Own measure meaning and corrective policy",
            "Handle critical, disputed and persistent cases",
            "Inspect signal and closure samples",
            "Approve external supplier commitments and consequences",
            "Promote, demote or disable signal cohorts"
          ],
          "rollback": [
            "Invoke the Workblock kill switch and disable the affected signal or action cohort",
            "Restore prior rule, model and Workblock versions",
            "Rebuild signals from immutable observations",
            "Reopen wrongly closed or suppressed actions",
            "Preserve supplier communications and committed actions"
          ],
          "targetPosture": "policy_autonomous_with_monitoring"
        },
        "coreValue": "Detect material supplier performance change early and drive the smallest effective corrective action through verified closure.",
        "currentStateKey": "workblock.performance-monitor.current-state",
        "dataMappings": [
          {
            "access": "read",
            "entityId": "supplier-segment-assignment",
            "purpose": "Apply segment-specific monitoring and escalation rules."
          },
          {
            "access": "create",
            "entityId": "supplier-performance-observation",
            "purpose": "Publish atomic, comparable and source-linked performance facts."
          },
          {
            "access": "update",
            "entityId": "supplier-performance-observation",
            "purpose": "Correct or supersede quality and control projections without overwriting observed history."
          },
          {
            "access": "read",
            "entityId": "supplier-performance-review-record",
            "purpose": "Coordinate corrective work with the current committed review."
          },
          {
            "access": "read",
            "entityId": "supplier-performance-observation",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "supplier-performance-observation",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "create",
            "entityId": "supplier-performance-signal",
            "purpose": "Create an evidence- and policy-linked performance signal from an exact observation set without transferring remediation ownership."
          },
          {
            "access": "update",
            "entityId": "supplier-performance-signal",
            "purpose": "Record dispute, routing, recovery or supersession under expected-version control while preserving observation and evidence lineage."
          },
          {
            "access": "read",
            "entityId": "supplier-performance-signal",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "supplier-performance-signal",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "supplier-remediation-action",
            "purpose": "Read an authorised supplier-remediation-action record by stable identity through supplier-remediation-exit's owner API; this grants no collection browsing or datastore access."
          },
          {
            "access": "read",
            "entityId": "action-proposal",
            "purpose": "Point-read the exact permission-safe D8/D9 handoff action-proposal record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "decision",
            "purpose": "Point-read the exact permission-safe D8/D9 handoff decision record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "committed-action",
            "purpose": "Point-read the exact permission-safe D8/D9 handoff committed-action record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "business-event",
            "purpose": "Point-read the exact permission-safe D8/D9 handoff business-event record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "create",
            "entityId": "action-proposal",
            "purpose": "Submit the version-pinned D8/D9 requested outcome, sender/receiver, source/target, evidence, authority, expiry and reopen context to shared-ledger-service without writing receiver-owned state."
          },
          {
            "access": "create",
            "entityId": "decision",
            "purpose": "Submit the authorised, version-pinned D8/D9 receiving-owner acceptance, rejection, redirect, expiry or reopen decision to shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "committed-action",
            "purpose": "Append each authorised D8/D9 delivery or receiver-owned command attempt with idempotency, safe-retry and reconciliation state through shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "business-event",
            "purpose": "Append immutable D8/D9 delivery, acknowledgement, rejection, reconciliation, replay or reopen facts through audit-event-service; an event never becomes current domain state."
          }
        ],
        "descriptionKey": "workblock.performance-monitor.description",
        "descriptorKey": "workblock.performance-monitor.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "supplier-performance-innovation-relationship",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "relationship-manager",
              "governance-owner",
              "metric-owner",
              "supplier-account-lead",
              "innovation-sponsor"
            ],
            "id": "ingest-performance-observations",
            "jobIds": [
              "supplier-performance-monitor-correct.atomic-observations",
              "supplier-performance-monitor-correct.detect-change",
              "supplier-performance-monitor-correct.quality-or-performance",
              "supplier-performance-monitor-correct.corrective-action",
              "supplier-performance-monitor-correct.sustained-recovery"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: validated performance observations, canonical performance observations, and performance ingest result.",
                "Accepted and rejected inputs are counted, source-linked and assigned a freshness state; a failed refresh retains last-good data.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "metric-owner",
                "relationship-manager",
                "governance-owner",
                "supplier-account-lead"
              ]
            },
            "kind": "ingest",
            "label": "Ingest performance observations",
            "trigger": "Source observation event or scheduled batch"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "relationship-manager",
              "governance-owner",
              "metric-owner",
              "supplier-account-lead",
              "innovation-sponsor"
            ],
            "id": "detect-performance-signals",
            "jobIds": [
              "supplier-performance-monitor-correct.atomic-observations",
              "supplier-performance-monitor-correct.detect-change",
              "supplier-performance-monitor-correct.quality-or-performance",
              "supplier-performance-monitor-correct.corrective-action",
              "supplier-performance-monitor-correct.sustained-recovery"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: supplier performance series, performance signal candidates, and actionable performance signals.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "metric-owner",
                "relationship-manager",
                "governance-owner",
                "supplier-account-lead"
              ]
            },
            "kind": "monitor",
            "label": "Detect performance signals",
            "trigger": "Observation published, target changed or scheduled evaluation"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "relationship-manager",
              "governance-owner",
              "metric-owner",
              "supplier-account-lead",
              "innovation-sponsor"
            ],
            "id": "operate-corrective-action",
            "jobIds": [
              "supplier-performance-monitor-correct.atomic-observations",
              "supplier-performance-monitor-correct.detect-change",
              "supplier-performance-monitor-correct.quality-or-performance",
              "supplier-performance-monitor-correct.corrective-action",
              "supplier-performance-monitor-correct.sustained-recovery"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: corrective evidence package, corrective action proposal, corrective action result, and corrective recovery result.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "metric-owner",
                "relationship-manager",
                "governance-owner",
                "supplier-account-lead"
              ]
            },
            "kind": "operate",
            "label": "Operate corrective action",
            "trigger": "Actionable signal, evidence, milestone, timer or authority event"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "relationship-manager",
              "governance-owner",
              "metric-owner",
              "supplier-account-lead",
              "innovation-sponsor"
            ],
            "id": "read-performance-control",
            "jobIds": [
              "supplier-performance-monitor-correct.atomic-observations",
              "supplier-performance-monitor-correct.detect-change",
              "supplier-performance-monitor-correct.quality-or-performance",
              "supplier-performance-monitor-correct.corrective-action",
              "supplier-performance-monitor-correct.sustained-recovery"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: performance signal page and performance series detail.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "metric-owner",
                "relationship-manager",
                "governance-owner",
                "supplier-account-lead"
              ]
            },
            "kind": "read",
            "label": "Read performance control",
            "trigger": "Signal query or supplier drill-through"
          }
        ],
        "futureStateKey": "workblock.performance-monitor.future-state",
        "hiredInsteadKey": "workblock.performance-monitor.hired-instead",
        "id": "supplier-performance-monitor-correct",
        "implementationStatus": "roadmap",
        "jobStatementKey": "workblock.performance-monitor.job",
        "jobStories": [
          {
            "completionKey": "workblock.performance-monitor.story.atomic-observations.completion",
            "executionFlowIds": [
              "ingest-performance-observations",
              "detect-performance-signals",
              "operate-corrective-action",
              "read-performance-control"
            ],
            "id": "supplier-performance-monitor-correct.atomic-observations",
            "roleCardId": "metric-owner",
            "storyKey": "workblock.performance-monitor.story.atomic-observations.story"
          },
          {
            "completionKey": "workblock.performance-monitor.story.detect-change.completion",
            "executionFlowIds": [
              "ingest-performance-observations",
              "detect-performance-signals",
              "operate-corrective-action",
              "read-performance-control"
            ],
            "id": "supplier-performance-monitor-correct.detect-change",
            "roleCardId": "relationship-manager",
            "storyKey": "workblock.performance-monitor.story.detect-change.story"
          },
          {
            "completionKey": "workblock.performance-monitor.story.quality-or-performance.completion",
            "executionFlowIds": [
              "ingest-performance-observations",
              "detect-performance-signals",
              "operate-corrective-action",
              "read-performance-control"
            ],
            "id": "supplier-performance-monitor-correct.quality-or-performance",
            "roleCardId": "metric-owner",
            "storyKey": "workblock.performance-monitor.story.quality-or-performance.story"
          },
          {
            "completionKey": "workblock.performance-monitor.story.corrective-action.completion",
            "executionFlowIds": [
              "ingest-performance-observations",
              "detect-performance-signals",
              "operate-corrective-action",
              "read-performance-control"
            ],
            "id": "supplier-performance-monitor-correct.corrective-action",
            "roleCardId": "governance-owner",
            "storyKey": "workblock.performance-monitor.story.corrective-action.story"
          },
          {
            "completionKey": "workblock.performance-monitor.story.sustained-recovery.completion",
            "executionFlowIds": [
              "ingest-performance-observations",
              "detect-performance-signals",
              "operate-corrective-action",
              "read-performance-control"
            ],
            "id": "supplier-performance-monitor-correct.sustained-recovery",
            "roleCardId": "relationship-manager",
            "storyKey": "workblock.performance-monitor.story.sustained-recovery.story"
          }
        ],
        "labelKey": "workblock.performance-monitor.label",
        "metrics": [
          "Current breaches, trends and corrective actions with observation drill-through",
          "Observation completeness, quality, freshness and correction rates",
          "Signal precision, missed critical event, duplicate and suppression rates",
          "Corrective action cycle time, overdue, closure, sustained recovery and recurrence",
          "SLO: no critical signal is hidden by stale last-good or duplicate suppression",
          "Recovery SLO: a bad source batch is quarantined and prior series remains visible with exact freshness"
        ],
        "officeCapabilities": [
          "conductor"
        ],
        "operatingModel": "The Workblock ingests atomic performance observations, validates definition and quality, detects target breaches and trend shifts, consolidates related symptoms, proposes a proportionate corrective plan, executes routine internal follow-through and reconciles supplier evidence and subsequent performance before closure.",
        "outcomeKey": "workblock.performance-monitor.outcome",
        "prerequisites": [
          "Observation feeds for delivery, quality and service from operational systems",
          "Approved measure definitions, targets and signal rules",
          "Access to supplier segment assignments and review records",
          "Named owners for corrective actions and escalation"
        ],
        "toolKey": "workblock.performance-monitor.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "assemble governance brief",
              "draft plan changes",
              "create pre-authorised internal tasks",
              "send routine approved reminders",
              "coordinate in-envelope milestones",
              "record observed progress"
            ],
            "escalationTriggers": [
              "new supplier or financial commitment",
              "material plan or relationship posture change",
              "contract, restriction or risk decision",
              "supplier disputes outcome or ownership",
              "sensitive disclosure",
              "mission budget, duration or stop condition reached"
            ],
            "id": "supplier-relationship-agent",
            "label": "Supplier relationship and joint-value agent",
            "mission": "Coordinate the permitted work required to achieve agreed relationship objectives and surface decisions that need human authority.",
            "operatorRoleIds": [
              "governance-owner"
            ],
            "personaIds": [
              "supplier-relationship-manager",
              "category-management-persona",
              "requester-persona",
              "supplier-risk-manager",
              "finance"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "relationship-manager",
              "supplier-account-lead",
              "innovation-sponsor",
              "governance-owner"
            ]
          }
        ],
        "agentStoryKey": "workblock.relationship-value.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "New financial, contractual or supplier commitment",
            "Relationship restriction, exit or material posture change",
            "Sensitive cross-party disclosure",
            "Supplier dispute of outcome, evidence or ownership",
            "Mission budget, duration or stop condition reached",
            "Novel decision outside relationship policy"
          ],
          "authorityEnvelope": [
            "Bounded relationship mission, objectives and permitted action classes",
            "Supplier, category, entity and participant scope",
            "Time, workload and financial budget",
            "Approved communication, task, evidence and planning tools",
            "Data visibility and disclosure constraints",
            "Grantor, duration, stop conditions, sampling and review cadence",
            "Forbidden contract, restriction, price, investment and public commitments unless separately granted"
          ],
          "humanSupervision": [
            "Own relationship objectives and mutual commitments",
            "Commit material plan versions and external promises",
            "Handle relationship conflict and strategic trade-offs",
            "Inspect mission outcomes, samples and harm metrics",
            "Interrupt, narrow or end the mission"
          ],
          "rollback": [
            "Pause new mission actions and outbound messages",
            "Restore prior planning, prompt, model and Workblock versions",
            "Cancel only uncommitted tasks where safe",
            "Open compensation work for incorrect committed actions",
            "Retain mutual commitments, communications and audit evidence"
          ],
          "targetPosture": "mission_autonomous_with_supervision"
        },
        "coreValue": "Turn strategic supplier relationships into a shared, governed plan whose commitments, dependencies and realised outcomes remain visible to both sides.",
        "currentStateKey": "workblock.relationship-value.current-state",
        "dataMappings": [
          {
            "access": "read",
            "entityId": "supplier-segment-assignment",
            "purpose": "Select relationship scope, cadence and authority."
          },
          {
            "access": "read",
            "entityId": "supplier-performance-review-record",
            "purpose": "Bring committed performance decisions into the relationship plan."
          },
          {
            "access": "read",
            "entityId": "supplier-innovation-case",
            "purpose": "Coordinate innovation without duplicating its gate authority."
          },
          {
            "access": "create",
            "entityId": "supplier-joint-value-plan",
            "purpose": "Create the proposed relationship plan with typed objectives and commitments. Includes every owned record-envelope and lifecycle field required to reproduce this version."
          },
          {
            "access": "update",
            "entityId": "supplier-joint-value-plan",
            "purpose": "Record the committed plan and current progress while preserving proposal history."
          },
          {
            "access": "read",
            "entityId": "supplier-joint-value-plan",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "supplier-joint-value-plan",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "action-proposal",
            "purpose": "Point-read the exact permission-safe D8 handoff action-proposal record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "decision",
            "purpose": "Point-read the exact permission-safe D8 handoff decision record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "committed-action",
            "purpose": "Point-read the exact permission-safe D8 handoff committed-action record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "business-event",
            "purpose": "Point-read the exact permission-safe D8 handoff business-event record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "create",
            "entityId": "decision",
            "purpose": "Submit the authorised, version-pinned D8 receiving-owner acceptance, rejection, redirect, expiry or reopen decision to shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "committed-action",
            "purpose": "Append each authorised D8 delivery or receiver-owned command attempt with idempotency, safe-retry and reconciliation state through shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "business-event",
            "purpose": "Append immutable D8 delivery, acknowledgement, rejection, reconciliation, replay or reopen facts through audit-event-service; an event never becomes current domain state."
          }
        ],
        "descriptionKey": "workblock.relationship-value.description",
        "descriptorKey": "workblock.relationship-value.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "supplier-performance-innovation-relationship",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "relationship-manager",
              "governance-owner",
              "metric-owner",
              "supplier-account-lead",
              "innovation-sponsor"
            ],
            "id": "prepare-joint-value-plan",
            "jobIds": [
              "supplier-relationship-joint-value.mutual-objectives",
              "supplier-relationship-joint-value.governance-cadence",
              "supplier-relationship-joint-value.cross-functional-actions",
              "supplier-relationship-joint-value.connected-plan",
              "supplier-relationship-joint-value.adapt-next-plan"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: relationship evidence snapshot, joint objective proposals, and joint value plan proposal.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "relationship-manager",
                "supplier-account-lead",
                "innovation-sponsor",
                "governance-owner"
              ]
            },
            "kind": "analyse",
            "label": "Prepare joint-value plan",
            "trigger": "Relationship cycle, segment change or objective request"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "relationship-manager",
              "governance-owner",
              "metric-owner",
              "supplier-account-lead",
              "innovation-sponsor"
            ],
            "id": "commit-and-operate-joint-plan",
            "jobIds": [
              "supplier-relationship-joint-value.mutual-objectives",
              "supplier-relationship-joint-value.governance-cadence",
              "supplier-relationship-joint-value.cross-functional-actions",
              "supplier-relationship-joint-value.connected-plan",
              "supplier-relationship-joint-value.adapt-next-plan"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: validated joint plan, committed joint plan, joint commitment result, and joint progress result.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "relationship-manager",
                "supplier-account-lead",
                "innovation-sponsor",
                "governance-owner"
              ]
            },
            "kind": "operate",
            "label": "Commit and operate joint plan",
            "trigger": "Plan authority event, commitment event, timer or evidence change"
          },
          {
            "agentIds": [
              "supplier-relationship-agent"
            ],
            "escalationRoleIds": [
              "relationship-manager",
              "governance-owner",
              "metric-owner",
              "supplier-account-lead",
              "innovation-sponsor"
            ],
            "id": "prepare-relationship-governance",
            "jobIds": [
              "supplier-relationship-joint-value.mutual-objectives",
              "supplier-relationship-joint-value.governance-cadence",
              "supplier-relationship-joint-value.cross-functional-actions",
              "supplier-relationship-joint-value.connected-plan",
              "supplier-relationship-joint-value.adapt-next-plan"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: relationship governance brief and relationship decision queue.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "relationship-manager",
                "supplier-account-lead",
                "innovation-sponsor",
                "governance-owner"
              ]
            },
            "kind": "agent",
            "label": "Prepare relationship governance",
            "trigger": "Governance milestone or material relationship event"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "relationship-manager",
              "governance-owner",
              "metric-owner",
              "supplier-account-lead",
              "innovation-sponsor"
            ],
            "id": "read-joint-value-workspace",
            "jobIds": [
              "supplier-relationship-joint-value.mutual-objectives",
              "supplier-relationship-joint-value.governance-cadence",
              "supplier-relationship-joint-value.cross-functional-actions",
              "supplier-relationship-joint-value.connected-plan",
              "supplier-relationship-joint-value.adapt-next-plan"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: joint value page and joint value detail.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "relationship-manager",
                "supplier-account-lead",
                "innovation-sponsor",
                "governance-owner"
              ]
            },
            "kind": "read",
            "label": "Read joint-value workspace",
            "trigger": "Portfolio query or relationship drill-through"
          }
        ],
        "futureStateKey": "workblock.relationship-value.future-state",
        "hiredInsteadKey": "workblock.relationship-value.hired-instead",
        "id": "supplier-relationship-joint-value",
        "implementationStatus": "roadmap",
        "jobStatementKey": "workblock.relationship-value.job",
        "jobStories": [
          {
            "completionKey": "workblock.relationship-value.story.mutual-objectives.completion",
            "executionFlowIds": [
              "prepare-joint-value-plan",
              "commit-and-operate-joint-plan",
              "prepare-relationship-governance",
              "read-joint-value-workspace"
            ],
            "id": "supplier-relationship-joint-value.mutual-objectives",
            "roleCardId": "relationship-manager",
            "storyKey": "workblock.relationship-value.story.mutual-objectives.story"
          },
          {
            "completionKey": "workblock.relationship-value.story.governance-cadence.completion",
            "executionFlowIds": [
              "prepare-joint-value-plan",
              "commit-and-operate-joint-plan",
              "prepare-relationship-governance",
              "read-joint-value-workspace"
            ],
            "id": "supplier-relationship-joint-value.governance-cadence",
            "roleCardId": "supplier-account-lead",
            "storyKey": "workblock.relationship-value.story.governance-cadence.story"
          },
          {
            "completionKey": "workblock.relationship-value.story.cross-functional-actions.completion",
            "executionFlowIds": [
              "prepare-joint-value-plan",
              "commit-and-operate-joint-plan",
              "prepare-relationship-governance",
              "read-joint-value-workspace"
            ],
            "id": "supplier-relationship-joint-value.cross-functional-actions",
            "roleCardId": "governance-owner",
            "storyKey": "workblock.relationship-value.story.cross-functional-actions.story"
          },
          {
            "completionKey": "workblock.relationship-value.story.connected-plan.completion",
            "executionFlowIds": [
              "prepare-joint-value-plan",
              "commit-and-operate-joint-plan",
              "prepare-relationship-governance",
              "read-joint-value-workspace"
            ],
            "id": "supplier-relationship-joint-value.connected-plan",
            "roleCardId": "metric-owner",
            "storyKey": "workblock.relationship-value.story.connected-plan.story"
          },
          {
            "completionKey": "workblock.relationship-value.story.adapt-next-plan.completion",
            "executionFlowIds": [
              "prepare-joint-value-plan",
              "commit-and-operate-joint-plan",
              "prepare-relationship-governance",
              "read-joint-value-workspace"
            ],
            "id": "supplier-relationship-joint-value.adapt-next-plan",
            "roleCardId": "innovation-sponsor",
            "storyKey": "workblock.relationship-value.story.adapt-next-plan.story"
          }
        ],
        "labelKey": "workblock.relationship-value.label",
        "metrics": [
          "Objectives, commitments, milestones and decisions by status with record drill-through",
          "On-time commitment, evidence completeness and cross-domain action reconciliation",
          "Supplier acknowledgement, dispute and communication correction rates",
          "Innovation, corrective and validated-value outcomes linked to plan objectives",
          "SLO: every committed relationship action has explicit owner, authority, evidence and downstream state",
          "Recovery SLO: mission stop blocks new actions while leaving a complete last-good plan and recoverable action queue"
        ],
        "officeCapabilities": [
          "composer",
          "conductor"
        ],
        "operatingModel": "The Workblock translates relationship posture and strategy into objectives, mutual commitments, governance cadence, milestones, risks, innovation and value work. It coordinates routine follow-through, prepares governance moments linked to current records, records each committed plan version and reconciles progress and realised value without confusing supplier claims with validated outcomes.",
        "outcomeKey": "workblock.relationship-value.outcome",
        "prerequisites": [
          "Access to segment assignments, performance reviews and innovation cases",
          "Agreed relationship objectives and governance cadence",
          "Approved communication, task and planning channels for both organisations",
          "Data visibility and disclosure rules for shared plan content",
          "Named owners for relationship and commercial commitments"
        ],
        "toolKey": "workblock.relationship-value.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "draft plan and changes",
              "create pre-authorised internal child work",
              "coordinate milestones",
              "refresh forecast from governed inputs",
              "open delivery risk",
              "request realisation review",
              "close fully reconciled routine initiative"
            ],
            "escalationTriggers": [
              "target, scope, method or value-recognition-treatment change",
              "material financial or supplier commitment",
              "initiative stop or benefit write-off",
              "baseline invalidation",
              "cross-domain conflict",
              "mission budget, duration or authority exceeded"
            ],
            "id": "savings-initiative-agent",
            "label": "Savings initiative agent",
            "mission": "Coordinate the permitted work needed to turn an approved value baseline into a finance-reconciled outcome.",
            "operatorRoleIds": [
              "budget-owner"
            ],
            "personaIds": [
              "category-management-persona",
              "finance",
              "buyer",
              "sourcing-specialist",
              "supplier-relationship-manager"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "value-lead",
              "category-manager",
              "finance-delegate",
              "budget-owner"
            ]
          }
        ],
        "agentStoryKey": "workblock.savings.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Baseline, target, method or value-recognition-treatment change",
            "Material supplier, contract or financial commitment",
            "Initiative stop, write-off or value claim",
            "Evidence conflict or suspected double count",
            "Mission budget, duration or stop condition reached",
            "Novel cross-domain consequence"
          ],
          "authorityEnvelope": [
            "Bounded value mission, permitted action classes and child Workblocks",
            "Initiative, category, supplier, entity and value-type scope",
            "Time, workload, transaction and financial budget limits",
            "Approved baseline, method and accounting treatment",
            "Permitted planning, task, event and evidence tools",
            "Grantor, duration, stop conditions, sampling and review cadence",
            "Forbidden target, baseline, contract, supplier and finance commitments unless separately granted"
          ],
          "humanSupervision": [
            "Commit target, method, material plan and accounting treatment",
            "Resolve portfolio trade-offs and cross-domain conflict",
            "Inspect mission actions, samples and outcome quality",
            "Approve value claims and initiative stop or write-off",
            "Interrupt, narrow or terminate the mission"
          ],
          "rollback": [
            "Stop new mission and child actions",
            "Restore prior plan, prompt, model and Workblock versions",
            "Cancel only uncommitted reversible tasks",
            "Open compensation or recovery work for committed errors",
            "Preserve every plan version, action, forecast and outcome"
          ],
          "targetPosture": "mission_autonomous_with_supervision"
        },
        "coreValue": "Move a validated value opportunity through owned delivery work to finance-reconciled realisation without losing the baseline, method or evidence trail.",
        "currentStateKey": "workblock.savings.current-state",
        "dataMappings": [
          {
            "access": "read",
            "entityId": "value-opportunity-baseline",
            "purpose": "Anchor target and method in a committed baseline linked to source records and assumptions."
          },
          {
            "access": "create",
            "entityId": "savings-initiative-record",
            "purpose": "Create the initiative proposal and operational plan. Includes every owned record-envelope and lifecycle field required to reproduce this version."
          },
          {
            "access": "update",
            "entityId": "savings-initiative-record",
            "purpose": "Operate and reconcile the committed plan without conflating forecast, leakage and validated realisation."
          },
          {
            "access": "read",
            "entityId": "value-realization-attribution",
            "purpose": "Update validated realisation only from committed, reconciled attribution."
          },
          {
            "access": "read",
            "entityId": "value-leakage-finding",
            "purpose": "Expose initiative leakage and route owned remediation."
          },
          {
            "access": "read",
            "entityId": "business-unit",
            "purpose": "Read the policy-filtered canonical business unit projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "category",
            "purpose": "Read the policy-filtered canonical category projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "source-record-reference",
            "purpose": "Read the policy-filtered canonical source record reference projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "evidence-item",
            "purpose": "Read the policy-filtered canonical evidence item projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "authority-envelope",
            "purpose": "Read the policy-filtered canonical authority envelope projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "action-proposal",
            "purpose": "Read the policy-filtered canonical action proposal projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "committed-action",
            "purpose": "Read the policy-filtered canonical committed action projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "decision",
            "purpose": "Read the policy-filtered canonical decision projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "exception",
            "purpose": "Read the policy-filtered canonical exception case projection from shared-ledger-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "audit-event",
            "purpose": "Read the policy-filtered canonical audit event projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "business-event",
            "purpose": "Read the policy-filtered canonical business event projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "learning-example",
            "purpose": "Read the policy-filtered canonical learning example projection from learning-evaluation-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "evaluation-result",
            "purpose": "Read the policy-filtered canonical evaluation result projection from learning-evaluation-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "integration-state",
            "purpose": "Read the policy-filtered canonical integration state projection from integration-state-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "registry-release",
            "purpose": "Read the policy-filtered canonical registry release projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "budget",
            "purpose": "Read the governed budget contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "value-portfolio-forecast",
            "purpose": "Read the governed value portfolio forecast contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "savings-initiative-record",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "savings-initiative-record",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          }
        ],
        "descriptionKey": "workblock.savings.description",
        "descriptorKey": "workblock.savings.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "value-realization-savings",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "value-lead",
              "finance-delegate",
              "category-manager",
              "budget-owner"
            ],
            "id": "create-savings-initiative",
            "jobIds": [
              "savings-initiative.qualify-opportunity",
              "savings-initiative.agree-method",
              "savings-initiative.carry-award",
              "savings-initiative.validate-result",
              "savings-initiative.restate-result"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: initiative context, savings initiative proposal, validated initiative proposal, and committed initiative result.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "value-lead",
                "category-manager",
                "finance-delegate",
                "budget-owner"
              ]
            },
            "kind": "operate",
            "label": "Create savings initiative",
            "trigger": "Committed value baseline or explicit initiative request"
          },
          {
            "agentIds": [
              "savings-initiative-agent"
            ],
            "escalationRoleIds": [
              "value-lead",
              "finance-delegate",
              "category-manager",
              "budget-owner"
            ],
            "id": "operate-savings-initiative",
            "jobIds": [
              "savings-initiative.qualify-opportunity",
              "savings-initiative.agree-method",
              "savings-initiative.carry-award",
              "savings-initiative.validate-result",
              "savings-initiative.restate-result"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: initiative action plan, initiative action results, initiative progress result, and initiative health result.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "value-lead",
                "category-manager",
                "finance-delegate",
                "budget-owner"
              ]
            },
            "kind": "agent",
            "label": "Operate savings initiative",
            "trigger": "Committed plan, milestone, child outcome, risk signal or authority event"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "value-lead",
              "finance-delegate",
              "category-manager",
              "budget-owner"
            ],
            "id": "read-savings-portfolio",
            "jobIds": [
              "savings-initiative.qualify-opportunity",
              "savings-initiative.agree-method",
              "savings-initiative.carry-award",
              "savings-initiative.validate-result",
              "savings-initiative.restate-result"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: savings page and savings initiative detail.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "value-lead",
                "category-manager",
                "finance-delegate",
                "budget-owner"
              ]
            },
            "kind": "read",
            "label": "Read savings portfolio",
            "trigger": "Portfolio query or initiative drill-through"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "value-lead",
              "finance-delegate",
              "category-manager",
              "budget-owner"
            ],
            "id": "evaluate-initiative-outcomes",
            "jobIds": [
              "savings-initiative.qualify-opportunity",
              "savings-initiative.agree-method",
              "savings-initiative.carry-award",
              "savings-initiative.validate-result",
              "savings-initiative.restate-result"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: initiative outcome example and initiative evaluation result.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "value-lead",
                "category-manager",
                "finance-delegate",
                "budget-owner"
              ]
            },
            "kind": "monitor",
            "label": "Evaluate initiative outcomes",
            "trigger": "Forecast refresh, realisation disposition, closure or evaluation schedule"
          }
        ],
        "futureStateKey": "workblock.savings.future-state",
        "hiredInsteadKey": "workblock.savings.hired-instead",
        "id": "savings-initiative",
        "implementationStatus": "reference",
        "jobStatementKey": "workblock.savings.job",
        "jobStories": [
          {
            "completionKey": "workblock.savings.story.qualify-opportunity.completion",
            "executionFlowIds": [
              "create-savings-initiative",
              "operate-savings-initiative",
              "read-savings-portfolio",
              "evaluate-initiative-outcomes"
            ],
            "id": "savings-initiative.qualify-opportunity",
            "roleCardId": "value-lead",
            "storyKey": "workblock.savings.story.qualify-opportunity.story"
          },
          {
            "completionKey": "workblock.savings.story.agree-method.completion",
            "executionFlowIds": [
              "create-savings-initiative",
              "operate-savings-initiative",
              "read-savings-portfolio",
              "evaluate-initiative-outcomes"
            ],
            "id": "savings-initiative.agree-method",
            "roleCardId": "finance-delegate",
            "storyKey": "workblock.savings.story.agree-method.story"
          },
          {
            "completionKey": "workblock.savings.story.carry-award.completion",
            "executionFlowIds": [
              "create-savings-initiative",
              "operate-savings-initiative",
              "read-savings-portfolio",
              "evaluate-initiative-outcomes"
            ],
            "id": "savings-initiative.carry-award",
            "roleCardId": "category-manager",
            "storyKey": "workblock.savings.story.carry-award.story"
          },
          {
            "completionKey": "workblock.savings.story.validate-result.completion",
            "executionFlowIds": [
              "create-savings-initiative",
              "operate-savings-initiative",
              "read-savings-portfolio",
              "evaluate-initiative-outcomes"
            ],
            "id": "savings-initiative.validate-result",
            "roleCardId": "finance-delegate",
            "storyKey": "workblock.savings.story.validate-result.story"
          },
          {
            "completionKey": "workblock.savings.story.restate-result.completion",
            "executionFlowIds": [
              "create-savings-initiative",
              "operate-savings-initiative",
              "read-savings-portfolio",
              "evaluate-initiative-outcomes"
            ],
            "id": "savings-initiative.restate-result",
            "roleCardId": "value-lead",
            "storyKey": "workblock.savings.story.restate-result.story"
          }
        ],
        "labelKey": "workblock.savings.label",
        "metrics": [
          "Target, forecast, validated realisation and leakage with initiative and evidence drill-through",
          "Initiatives by stage, risk, owner, milestone and dependency state",
          "Plan change, override, stopped, reopened and delayed rates",
          "Forecast error and realisation cycle time by value type and method version",
          "SLO: no forecast is displayed as validated realisation and no closed initiative lacks committed attribution",
          "Recovery SLO: mission stop prevents new child actions while leaving completed results and blocked dependencies recoverable"
        ],
        "officeCapabilities": [
          "conductor"
        ],
        "operatingModel": "The Workblock converts a committed opportunity baseline into a versioned initiative plan, coordinates milestones and dependencies across procurement domains, maintains target and forecast separately from validated realisation, detects delivery risk, routes material changes and closes only when outcome evidence and attribution reconcile.",
        "outcomeKey": "workblock.savings.outcome",
        "prerequisites": [
          "Access to committed value-opportunity baselines and their methods",
          "Read connections to realisation attribution and leakage findings",
          "Business unit and category reference data",
          "A named finance delegate for realisation decisions",
          "Named owners for initiative milestones and dependencies"
        ],
        "toolKey": "workblock.savings.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "detect and consolidate findings",
              "request missing internal evidence",
              "assign policy owner",
              "apply pre-approved reversible corrections",
              "request typed owner-domain work",
              "verify deterministic prevention or recovery"
            ],
            "escalationTriggers": [
              "supplier dispute or contractual interpretation",
              "retrospective financial change",
              "material credit, write-off or settlement",
              "tax or accounting ambiguity",
              "payment already executed with uncertain recovery",
              "evidence conflict or out-of-envelope exposure"
            ],
            "id": "value-leakage-agent",
            "label": "Value leakage monitor agent",
            "mission": "Detect, explain and recover policy-defined value leakage while preserving financial authority and source truth.",
            "operatorRoleIds": [
              "budget-owner"
            ],
            "personaIds": [
              "category-management-persona",
              "finance",
              "buyer",
              "contract-legal",
              "supplier-relationship-manager",
              "accounts-payable"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "value-lead",
              "finance-delegate",
              "category-manager",
              "budget-owner"
            ]
          },
          {
            "autonomousActions": [
              "Resolve which categories and orders are in scope for a variance sweep",
              "Read order prices against the contracted and catalogue position",
              "Measure off-contract, off-price and missed-volume-band variance with named records",
              "Propose recovery actions to the owning modules and named humans",
              "Expire variance findings whose price or position evidence lapses"
            ],
            "escalationTriggers": [
              "A variance implies a supplier dispute or contract enforcement action",
              "Order or contract price evidence is stale, revised or conflicting",
              "A recovery action would change a commitment or issue a credit",
              "Variance concentrates on a supplier under remediation or exit",
              "Any recovery execution or supplier contact is requested"
            ],
            "id": "price-variance-agent",
            "label": "Price variance agent",
            "mission": "Find where indirect buying pays off contract or off price, quantify each variance against the entitled position with drill-through records, and propose recovery actions to the owners who can act.",
            "operatorRoleIds": [
              "value-lead"
            ],
            "personaIds": [
              "finance",
              "category-management-persona",
              "procurement-leadership"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "value-lead",
              "category-manager"
            ]
          }
        ],
        "agentStoryKey": "workblock.leakage.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Contractual interpretation or supplier dispute",
            "Tax or accounting ambiguity",
            "Material credit, settlement, write-off or retrospective financial change",
            "Payment already executed with uncertain recovery",
            "Evidence conflict that changes exposure materially",
            "Action outside recovery envelope"
          ],
          "authorityEnvelope": [
            "Permitted detect, consolidate, request, route, correct and verify verbs",
            "Leakage types, suppliers, categories, entities and transaction cohorts",
            "Materiality, age, recoverability and evidence thresholds",
            "Approved expected-value rules and calculation methods",
            "Permitted source, task and reversible correction adapters",
            "Grantor, duration, cumulative recovery limit and sampling",
            "Forbidden write-off, settlement, contract interpretation and irreversible financial actions"
          ],
          "humanSupervision": [
            "Own leakage and recovery policy",
            "Handle material, contractual, disputed and accounting cases",
            "Inspect false-positive and autonomous recovery samples",
            "Approve rule and envelope promotion",
            "Retain kill switch, compensation and write-off authority"
          ],
          "rollback": [
            "Disable affected detection and remediation cohorts",
            "Restore prior rule, model and Workblock versions",
            "Compensate reversible corrections",
            "Reopen incorrectly closed findings",
            "Retain expected, actual, proposal, action and outcome history"
          ],
          "targetPosture": "policy_autonomous_with_monitoring"
        },
        "coreValue": "Find value that is being lost after a commercial decision and recover it before leakage becomes accepted run-rate.",
        "currentStateKey": "workblock.leakage.current-state",
        "dataMappings": [
          {
            "access": "read",
            "entityId": "value-opportunity-baseline",
            "purpose": "Use a governed expectation where leakage relates to an initiative baseline."
          },
          {
            "access": "read",
            "entityId": "savings-initiative-record",
            "purpose": "Connect leakage to the initiative without overwriting its financial measures."
          },
          {
            "access": "create",
            "entityId": "value-leakage-finding",
            "purpose": "Create the source-linked leakage finding and recovery proposal. Includes every owned record-envelope and lifecycle field required to reproduce this version."
          },
          {
            "access": "update",
            "entityId": "value-leakage-finding",
            "purpose": "Record authorised recovery and reconciled disposition while preserving proposal history."
          },
          {
            "access": "read",
            "entityId": "value-realization-attribution",
            "purpose": "Avoid claiming recovered value already attributed elsewhere."
          },
          {
            "access": "read",
            "entityId": "authority-envelope",
            "purpose": "Read the policy-filtered canonical authority envelope projection from registry-governance-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "business-event",
            "purpose": "Read the policy-filtered canonical business event projection from audit-event-service; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "purchase-order",
            "purpose": "Read the policy-filtered canonical purchase-order projection from purchase-order-orchestration; entity access policy still limits returned fields and records."
          },
          {
            "access": "read",
            "entityId": "value-leakage-finding",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "value-leakage-finding",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          }
        ],
        "descriptionKey": "workblock.leakage.description",
        "descriptorKey": "workblock.leakage.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "value-realization-savings",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "value-lead",
              "finance-delegate",
              "category-manager",
              "budget-owner"
            ],
            "id": "detect-value-leakage",
            "jobIds": [
              "value-leakage-monitor.confirm-variance",
              "value-leakage-monitor.test-causes",
              "value-leakage-monitor.own-the-response",
              "value-leakage-monitor.source-acceptance",
              "value-leakage-monitor.remeasure"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The leakage-comparison-set, leakage-candidates, proposed-leakage-findings and leakage-detection-result preserve the comparator, calculation, materiality reason, duplicates and unresolved cause for every finding.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "value-lead",
                "finance-delegate",
                "category-manager",
                "budget-owner"
              ]
            },
            "kind": "monitor",
            "label": "Detect value leakage",
            "trigger": "Expected-rule or source-transaction change and scheduled scan"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "value-lead",
              "finance-delegate",
              "category-manager",
              "budget-owner"
            ],
            "id": "operate-leakage-recovery",
            "jobIds": [
              "value-leakage-monitor.confirm-variance",
              "value-leakage-monitor.test-causes",
              "value-leakage-monitor.own-the-response",
              "value-leakage-monitor.source-acceptance",
              "value-leakage-monitor.remeasure"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The leakage-evidence-package and leakage-remediation-proposal retain the tested cause, options, owner and authority; the leakage-remediation-result and reconciled-leakage-outcome record owning-system acceptance and remeasurement as recovered, partial, ineffective or tolerated with reason.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "value-lead",
                "finance-delegate",
                "category-manager",
                "budget-owner"
              ]
            },
            "kind": "operate",
            "label": "Operate leakage recovery",
            "trigger": "Finding opened, evidence received, owner action or authority event"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "value-lead",
              "finance-delegate",
              "category-manager",
              "budget-owner"
            ],
            "id": "read-leakage-control",
            "jobIds": [
              "value-leakage-monitor.confirm-variance",
              "value-leakage-monitor.test-causes",
              "value-leakage-monitor.own-the-response",
              "value-leakage-monitor.source-acceptance",
              "value-leakage-monitor.remeasure"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The leakage-page and leakage-detail show current or clearly stale last-good findings and drill every exposure aggregate to its calculation, evidence, disposition, owning-system receipt and remeasurement.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "value-lead",
                "finance-delegate",
                "category-manager",
                "budget-owner"
              ]
            },
            "kind": "read",
            "label": "Read leakage control",
            "trigger": "Exposure query or finding drill-through"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "value-lead",
              "finance-delegate",
              "category-manager",
              "budget-owner"
            ],
            "id": "evaluate-leakage-policy",
            "jobIds": [
              "value-leakage-monitor.confirm-variance",
              "value-leakage-monitor.test-causes",
              "value-leakage-monitor.own-the-response",
              "value-leakage-monitor.source-acceptance",
              "value-leakage-monitor.remeasure"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "The leakage-learning-example links the original finding, finance disposition, action and reconciled outcome; the leakage-evaluation-result reports false positives, cause accuracy, recovery effectiveness and harm slices by version.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "value-lead",
                "finance-delegate",
                "category-manager",
                "budget-owner"
              ]
            },
            "kind": "monitor",
            "label": "Evaluate leakage policy",
            "trigger": "Recovered, accepted, disputed or false-positive outcome and evaluation schedule"
          },
          {
            "agentIds": [
              "price-variance-agent"
            ],
            "escalationRoleIds": [
              "value-lead",
              "finance-delegate",
              "budget-owner"
            ],
            "id": "detect-off-contract-price-variance",
            "jobIds": [
              "value-leakage-monitor.price-variance"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: price variance assessment and variance recovery proposal.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "value-lead"
              ]
            },
            "kind": "agent",
            "label": "Detect off-contract price variance",
            "trigger": "Order or invoice prices in indirect categories drifting from the contracted or catalogue position beyond tolerance."
          }
        ],
        "futureStateKey": "workblock.leakage.future-state",
        "hiredInsteadKey": "workblock.leakage.hired-instead",
        "id": "value-leakage-monitor",
        "implementationStatus": "pattern",
        "jobStatementKey": "workblock.leakage.job",
        "jobStories": [
          {
            "completionKey": "workblock.leakage.story.confirm-variance.completion",
            "executionFlowIds": [
              "detect-value-leakage",
              "operate-leakage-recovery",
              "read-leakage-control",
              "evaluate-leakage-policy"
            ],
            "id": "value-leakage-monitor.confirm-variance",
            "roleCardId": "value-lead",
            "storyKey": "workblock.leakage.story.confirm-variance.story"
          },
          {
            "completionKey": "workblock.leakage.story.test-causes.completion",
            "executionFlowIds": [
              "detect-value-leakage",
              "operate-leakage-recovery",
              "read-leakage-control",
              "evaluate-leakage-policy"
            ],
            "id": "value-leakage-monitor.test-causes",
            "roleCardId": "finance-delegate",
            "storyKey": "workblock.leakage.story.test-causes.story"
          },
          {
            "completionKey": "workblock.leakage.story.own-the-response.completion",
            "executionFlowIds": [
              "detect-value-leakage",
              "operate-leakage-recovery",
              "read-leakage-control",
              "evaluate-leakage-policy"
            ],
            "id": "value-leakage-monitor.own-the-response",
            "roleCardId": "budget-owner",
            "storyKey": "workblock.leakage.story.own-the-response.story"
          },
          {
            "completionKey": "workblock.leakage.story.source-acceptance.completion",
            "executionFlowIds": [
              "detect-value-leakage",
              "operate-leakage-recovery",
              "read-leakage-control",
              "evaluate-leakage-policy"
            ],
            "id": "value-leakage-monitor.source-acceptance",
            "roleCardId": "category-manager",
            "storyKey": "workblock.leakage.story.source-acceptance.story"
          },
          {
            "completionKey": "workblock.leakage.story.remeasure.completion",
            "executionFlowIds": [
              "detect-value-leakage",
              "operate-leakage-recovery",
              "read-leakage-control",
              "evaluate-leakage-policy"
            ],
            "id": "value-leakage-monitor.remeasure",
            "roleCardId": "value-lead",
            "storyKey": "workblock.leakage.story.remeasure.story"
          },
          {
            "completionKey": "workblock.leakage.story.price-variance.completion",
            "executionFlowIds": [
              "detect-off-contract-price-variance"
            ],
            "id": "value-leakage-monitor.price-variance",
            "roleCardId": "value-lead",
            "storyKey": "workblock.leakage.story.price-variance.story"
          }
        ],
        "labelKey": "workblock.leakage.label",
        "metrics": [
          "Detected, recoverable, in-recovery, recovered, prevented, accepted and disputed exposure with record drill-through",
          "Finding precision, missed material leakage, duplicate and false-positive rates",
          "Recovery cycle time, recovery rate, write-off and recurrence by root cause",
          "Policy-bounded action, override, compensation and supplier-dispute rates",
          "SLO: every exposure traces to expected rule and actual source facts and is never displayed as realised value",
          "Recovery SLO: a bad rule cohort can be disabled, compensated and replayed without erasing findings"
        ],
        "officeCapabilities": [
          "conductor"
        ],
        "operatingModel": "The Workblock compares governed expectations from baselines, contracts, awards, price terms, entitlements and initiative plans with current order, receipt, invoice, payment and performance evidence; consolidates related variances into findings; proposes and executes permitted remediation; and verifies recovered or accepted outcomes.",
        "outcomeKey": "workblock.leakage.outcome",
        "prerequisites": [
          "Access to committed baselines and initiative records",
          "Read connections to order, invoice and payment evidence in the ERP",
          "Contract price terms and entitlements from the contract repository",
          "Approved expected-value rules and materiality thresholds",
          "A named value realisation lead for cause and recovery decisions"
        ],
        "toolKey": "workblock.leakage.tool",
        "version": "5.2.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "deduplicate opportunities",
              "assemble and normalize evidence",
              "calculate approved scenarios",
              "draft assumptions and target",
              "refresh routine proposal",
              "commit pre-authorised low-consequence baseline"
            ],
            "escalationTriggers": [
              "new or ambiguous measurement method",
              "material target or budget implication",
              "overlap or double-count conflict",
              "insufficient source coverage",
              "value-recognition-treatment ambiguity",
              "out-of-envelope currency, entity or value"
            ],
            "id": "value-baseline-agent",
            "label": "Value opportunity and baseline agent",
            "mission": "Build transparent, reproducible value opportunities and baseline proposals from governed evidence.",
            "operatorRoleIds": [
              "budget-owner"
            ],
            "personaIds": [
              "category-management-persona",
              "finance",
              "sourcing-specialist",
              "buyer"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "value-lead",
              "finance-delegate",
              "category-manager",
              "budget-owner"
            ]
          }
        ],
        "agentStoryKey": "workblock.value-baseline.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "New or ambiguous measurement method",
            "Material budget, target or accounting consequence",
            "Overlap or double-count conflict",
            "Insufficient evidence for required coverage",
            "Unsupported external benchmark",
            "Out-of-envelope entity, currency or value"
          ],
          "authorityEnvelope": [
            "Permitted search, normalize, calculate, draft, refresh and routine-commit verbs",
            "Opportunity types, methods, entities, categories, currencies and value limits",
            "Approved source classes, adjustment rules and evidence coverage",
            "Permitted data, calculation and ledger tools",
            "Proposal expiry and reassessment conditions",
            "Grantor, duration, cumulative target limit and sampling",
            "Forbidden accounting policy, budget and material target commitments"
          ],
          "humanSupervision": [
            "Own baseline and measurement methods",
            "Commit material baselines, targets and accounting treatment",
            "Resolve overlap, ambiguity and missing-evidence exceptions",
            "Inspect calculations and later forecast error samples",
            "Promote, demote or retire methods"
          ],
          "rollback": [
            "Invoke the Workblock kill switch to stop new baseline commitments",
            "Restore prior method, model and Workblock versions",
            "Recalculate proposals from immutable source refs",
            "Expire affected uncommitted proposals",
            "Supersede, never erase, committed baselines through finance authority"
          ],
          "targetPosture": "policy_autonomous_with_monitoring"
        },
        "coreValue": "Establish the evidence, counterfactual and measurement contract that make a value opportunity comparable, fundable and later provable.",
        "currentStateKey": "workblock.value-baseline.current-state",
        "dataMappings": [
          {
            "access": "create",
            "entityId": "value-opportunity-baseline",
            "purpose": "Persist the complete opportunity, calculation proposal and version envelope. Includes every owned record-envelope and lifecycle field required to reproduce this version."
          },
          {
            "access": "update",
            "entityId": "value-opportunity-baseline",
            "purpose": "Commit, expire or supersede the measurement contract without overwriting its proposal."
          },
          {
            "access": "read",
            "entityId": "savings-initiative-record",
            "purpose": "Prevent overlapping or duplicate value work."
          },
          {
            "access": "read",
            "entityId": "value-opportunity-baseline",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "value-opportunity-baseline",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          },
          {
            "access": "read",
            "entityId": "action-proposal",
            "purpose": "Point-read the exact permission-safe D7 handoff action-proposal record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "decision",
            "purpose": "Point-read the exact permission-safe D7 handoff decision record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "committed-action",
            "purpose": "Point-read the exact permission-safe D7 handoff committed-action record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "read",
            "entityId": "business-event",
            "purpose": "Point-read the exact permission-safe D7 handoff business-event record/version through its canonical service owner; this grants no browse-all or direct-write access."
          },
          {
            "access": "create",
            "entityId": "decision",
            "purpose": "Submit the authorised, version-pinned D7 receiving-owner acceptance, rejection, redirect, expiry or reopen decision to shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "committed-action",
            "purpose": "Append each authorised D7 delivery or receiver-owned command attempt with idempotency, safe-retry and reconciliation state through shared-ledger-service."
          },
          {
            "access": "append",
            "entityId": "business-event",
            "purpose": "Append immutable D7 delivery, acknowledgement, rejection, reconciliation, replay or reopen facts through audit-event-service; an event never becomes current domain state."
          },
          {
            "access": "read",
            "entityId": "supplier-innovation-case",
            "purpose": "Read the exact D7 innovation source record/version addressed to this owner."
          }
        ],
        "descriptionKey": "workblock.value-baseline.description",
        "descriptorKey": "workblock.value-baseline.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "value-realization-savings",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "value-lead",
              "finance-delegate",
              "category-manager",
              "budget-owner"
            ],
            "id": "qualify-value-opportunity",
            "jobIds": [
              "value-opportunity-baseline.qualify-opportunity",
              "value-opportunity-baseline.counterfactual-scope",
              "value-opportunity-baseline.calculate-baseline",
              "value-opportunity-baseline.assumption-sensitivity",
              "value-opportunity-baseline.commit-measurement"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: normalised value opportunity, value overlap set, baseline evidence set, and qualified value opportunity.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "value-lead",
                "finance-delegate",
                "category-manager",
                "budget-owner"
              ]
            },
            "kind": "analyse",
            "label": "Qualify value opportunity",
            "trigger": "Opportunity signal or explicit baseline request"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "value-lead",
              "finance-delegate",
              "category-manager",
              "budget-owner"
            ],
            "id": "calculate-value-baseline",
            "jobIds": [
              "value-opportunity-baseline.qualify-opportunity",
              "value-opportunity-baseline.counterfactual-scope",
              "value-opportunity-baseline.calculate-baseline",
              "value-opportunity-baseline.assumption-sensitivity",
              "value-opportunity-baseline.commit-measurement"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: normalised baseline inputs, baseline scenario set, baseline evaluation, and value baseline proposal.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "value-lead",
                "finance-delegate",
                "category-manager",
                "budget-owner"
              ]
            },
            "kind": "analyse",
            "label": "Calculate value baseline",
            "trigger": "Qualified opportunity, evidence change or method change"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "value-lead",
              "finance-delegate",
              "category-manager",
              "budget-owner"
            ],
            "id": "commit-value-baseline",
            "jobIds": [
              "value-opportunity-baseline.qualify-opportunity",
              "value-opportunity-baseline.counterfactual-scope",
              "value-opportunity-baseline.calculate-baseline",
              "value-opportunity-baseline.assumption-sensitivity",
              "value-opportunity-baseline.commit-measurement"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: validated baseline proposal, committed value baseline, and baseline commitment event.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "value-lead",
                "finance-delegate",
                "category-manager",
                "budget-owner"
              ]
            },
            "kind": "operate",
            "label": "Commit value baseline",
            "trigger": "In-envelope proposal or explicit finance authority event"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "value-lead",
              "finance-delegate",
              "category-manager",
              "budget-owner"
            ],
            "id": "read-value-baseline",
            "jobIds": [
              "value-opportunity-baseline.qualify-opportunity",
              "value-opportunity-baseline.counterfactual-scope",
              "value-opportunity-baseline.calculate-baseline",
              "value-opportunity-baseline.assumption-sensitivity",
              "value-opportunity-baseline.commit-measurement"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: value opportunity page and value baseline detail.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "value-lead",
                "finance-delegate",
                "category-manager",
                "budget-owner"
              ]
            },
            "kind": "read",
            "label": "Read value baseline",
            "trigger": "Opportunity query or baseline drill-through"
          }
        ],
        "futureStateKey": "workblock.value-baseline.future-state",
        "hiredInsteadKey": "workblock.value-baseline.hired-instead",
        "id": "value-opportunity-baseline",
        "implementationStatus": "roadmap",
        "jobStatementKey": "workblock.value-baseline.job",
        "jobStories": [
          {
            "completionKey": "workblock.value-baseline.story.qualify-opportunity.completion",
            "executionFlowIds": [
              "qualify-value-opportunity",
              "calculate-value-baseline",
              "commit-value-baseline",
              "read-value-baseline"
            ],
            "id": "value-opportunity-baseline.qualify-opportunity",
            "roleCardId": "value-lead",
            "storyKey": "workblock.value-baseline.story.qualify-opportunity.story"
          },
          {
            "completionKey": "workblock.value-baseline.story.counterfactual-scope.completion",
            "executionFlowIds": [
              "qualify-value-opportunity",
              "calculate-value-baseline",
              "commit-value-baseline",
              "read-value-baseline"
            ],
            "id": "value-opportunity-baseline.counterfactual-scope",
            "roleCardId": "category-manager",
            "storyKey": "workblock.value-baseline.story.counterfactual-scope.story"
          },
          {
            "completionKey": "workblock.value-baseline.story.calculate-baseline.completion",
            "executionFlowIds": [
              "qualify-value-opportunity",
              "calculate-value-baseline",
              "commit-value-baseline",
              "read-value-baseline"
            ],
            "id": "value-opportunity-baseline.calculate-baseline",
            "roleCardId": "finance-delegate",
            "storyKey": "workblock.value-baseline.story.calculate-baseline.story"
          },
          {
            "completionKey": "workblock.value-baseline.story.assumption-sensitivity.completion",
            "executionFlowIds": [
              "qualify-value-opportunity",
              "calculate-value-baseline",
              "commit-value-baseline",
              "read-value-baseline"
            ],
            "id": "value-opportunity-baseline.assumption-sensitivity",
            "roleCardId": "value-lead",
            "storyKey": "workblock.value-baseline.story.assumption-sensitivity.story"
          },
          {
            "completionKey": "workblock.value-baseline.story.commit-measurement.completion",
            "executionFlowIds": [
              "qualify-value-opportunity",
              "calculate-value-baseline",
              "commit-value-baseline",
              "read-value-baseline"
            ],
            "id": "value-opportunity-baseline.commit-measurement",
            "roleCardId": "finance-delegate",
            "storyKey": "workblock.value-baseline.story.commit-measurement.story"
          }
        ],
        "labelKey": "workblock.value-baseline.label",
        "metrics": [
          "Opportunity, proposed baseline, committed target and evidence coverage with record drill-through",
          "Time to qualified and finance-validated baseline",
          "Correction, expiry, overlap and duplicate-opportunity rates",
          "Baseline error and attribution variance by method and value type",
          "SLO: every committed baseline is reproducible from pinned source records, method and adjustments",
          "Recovery SLO: method rollback rebuilds proposals while leaving committed history and affected initiatives visible"
        ],
        "officeCapabilities": [
          "conductor"
        ],
        "operatingModel": "The Workblock qualifies an opportunity, resolves its scope, selects an approved baseline and comparison method, normalises currency, unit, timing, volume, mix and market context, states assumptions and exclusions, drafts target and forecast, routes finance validation and publishes an effective-dated baseline that downstream initiatives cannot silently reinterpret.",
        "outcomeKey": "workblock.value-baseline.outcome",
        "prerequisites": [
          "Read connections to spend data in the warehouse and the contract repository",
          "Approved baseline and comparison methods agreed with finance",
          "Access to existing initiative records for duplicate checks",
          "A named finance delegate to commit the measurement contract"
        ],
        "toolKey": "workblock.value-baseline.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "assemble actuals",
              "normalize approved adjustments",
              "calculate approved attribution",
              "detect overlap",
              "draft disposition",
              "commit routine in-envelope realisation",
              "reject deterministic duplicate claim"
            ],
            "escalationTriggers": [
              "overlap cannot be deterministically allocated",
              "value-recognition-treatment ambiguity",
              "material manual adjustment",
              "insufficient actual evidence",
              "negative or anomalous realisation",
              "out-of-envelope value or entity"
            ],
            "id": "value-attribution-agent",
            "label": "Value realisation attribution agent",
            "mission": "Produce reproducible, double-count-safe realisation proposals and commit only finance-authorised routine outcomes.",
            "operatorRoleIds": [
              "budget-owner"
            ],
            "personaIds": [
              "finance",
              "category-management-persona",
              "buyer"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "finance-delegate",
              "value-lead",
              "category-manager",
              "budget-owner"
            ]
          }
        ],
        "agentStoryKey": "workblock.realization-reconciliation.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Ambiguous accounting treatment or period",
            "Material manual or residual adjustment",
            "Unresolved overlap or double-count conflict",
            "Insufficient or conflicting actual evidence",
            "Negative, anomalous or out-of-envelope realisation",
            "Restatement of committed finance outcome"
          ],
          "authorityEnvelope": [
            "Permitted load, match, normalize, calculate, reject-duplicate and routine-commit verbs",
            "Initiative, method, entity, currency, period and value limits",
            "Approved actual sources, adjustment classes and evidence coverage",
            "Permitted calculation and attribution-ledger tools",
            "Restatement and proposal-expiry rules",
            "Grantor, duration, cumulative value limit and sampling",
            "Forbidden source-ledger mutation, accounting-policy and unapproved manual adjustment"
          ],
          "humanSupervision": [
            "Own attribution and accounting methods",
            "Commit material, novel and manually adjusted realisation",
            "Resolve overlap and source conflicts",
            "Inspect committed and rejected samples",
            "Promote, demote or restore methods"
          ],
          "rollback": [
            "Stop new attribution commitments",
            "Restore prior method, mapping, model and Workblock versions",
            "Rebuild proposals from pinned actual snapshots",
            "Reopen affected uncommitted reconciliations",
            "Restate committed outcomes only through a new finance decision"
          ],
          "targetPosture": "policy_autonomous_with_monitoring"
        },
        "coreValue": "Convert observed financial and transaction changes into one reproducible, non-duplicated realisation decision with finance authority.",
        "currentStateKey": "workblock.realization-reconciliation.current-state",
        "dataMappings": [
          {
            "access": "read",
            "entityId": "value-opportunity-baseline",
            "purpose": "Reconcile against the exact committed counterfactual."
          },
          {
            "access": "read",
            "entityId": "savings-initiative-record",
            "purpose": "Apply the initiative scope and accounting treatment."
          },
          {
            "access": "create",
            "entityId": "value-realization-attribution",
            "purpose": "Create the reproducible calculation and uncommitted disposition. Includes every owned record-envelope and lifecycle field required to reproduce this version."
          },
          {
            "access": "update",
            "entityId": "value-realization-attribution",
            "purpose": "Record finance commitment or rejection separately from the proposal."
          },
          {
            "access": "read",
            "entityId": "value-leakage-finding",
            "purpose": "Account for unresolved leakage and avoid duplicate recovery claims."
          },
          {
            "access": "read",
            "entityId": "budget",
            "purpose": "Read the governed budget contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "payment-instruction",
            "purpose": "Read the governed payment instruction contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "payment-execution-status",
            "purpose": "Read the governed payment execution status contract through its declared authority and freshness boundary."
          },
          {
            "access": "read",
            "entityId": "value-realization-attribution",
            "purpose": "Return the current authoritative record by stable identity through the owning module API, after server-side permission filtering and with last-good age preserved."
          },
          {
            "access": "read",
            "entityId": "value-realization-attribution",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          }
        ],
        "descriptionKey": "workblock.realization-reconciliation.description",
        "descriptorKey": "workblock.realization-reconciliation.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "value-realization-savings",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "value-lead",
              "finance-delegate",
              "category-manager",
              "budget-owner"
            ],
            "id": "reconcile-value-actuals",
            "jobIds": [
              "realization-reconciliation-attribution.assemble-actuals",
              "realization-reconciliation-attribution.normalise-effects",
              "realization-reconciliation-attribution.attribute-value",
              "realization-reconciliation-attribution.prevent-overlap",
              "realization-reconciliation-attribution.commit-reconcile"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: attribution scope, matched attribution actuals, normalised attribution inputs, and realisation attribution proposal.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "finance-delegate",
                "value-lead",
                "category-manager",
                "budget-owner"
              ]
            },
            "kind": "analyse",
            "label": "Reconcile value actuals",
            "trigger": "Period close, actual-source change or explicit request"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "value-lead",
              "finance-delegate",
              "category-manager",
              "budget-owner"
            ],
            "id": "commit-realization-attribution",
            "jobIds": [
              "realization-reconciliation-attribution.assemble-actuals",
              "realization-reconciliation-attribution.normalise-effects",
              "realization-reconciliation-attribution.attribute-value",
              "realization-reconciliation-attribution.prevent-overlap",
              "realization-reconciliation-attribution.commit-reconcile"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: attribution overlap result, validated attribution proposal, committed realisation attribution, and realisation update event.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "finance-delegate",
                "value-lead",
                "category-manager",
                "budget-owner"
              ]
            },
            "kind": "operate",
            "label": "Commit realisation attribution",
            "trigger": "In-envelope proposal or explicit finance authority event"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "value-lead",
              "finance-delegate",
              "category-manager",
              "budget-owner"
            ],
            "id": "read-realization-control",
            "jobIds": [
              "realization-reconciliation-attribution.assemble-actuals",
              "realization-reconciliation-attribution.normalise-effects",
              "realization-reconciliation-attribution.attribute-value",
              "realization-reconciliation-attribution.prevent-overlap",
              "realization-reconciliation-attribution.commit-reconcile"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: realisation page and attribution detail.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "finance-delegate",
                "value-lead",
                "category-manager",
                "budget-owner"
              ]
            },
            "kind": "read",
            "label": "Read realisation control",
            "trigger": "Period query or attribution drill-through"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "value-lead",
              "finance-delegate",
              "category-manager",
              "budget-owner"
            ],
            "id": "evaluate-attribution-method",
            "jobIds": [
              "realization-reconciliation-attribution.assemble-actuals",
              "realization-reconciliation-attribution.normalise-effects",
              "realization-reconciliation-attribution.attribute-value",
              "realization-reconciliation-attribution.prevent-overlap",
              "realization-reconciliation-attribution.commit-reconcile"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: attribution learning example and attribution evaluation result.",
                "The evaluation records its population, definition, freshness and disposition; degraded inputs retain last-good state.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "finance-delegate",
                "value-lead",
                "category-manager",
                "budget-owner"
              ]
            },
            "kind": "monitor",
            "label": "Evaluate attribution method",
            "trigger": "Finance correction, later restatement or evaluation schedule"
          }
        ],
        "futureStateKey": "workblock.realization-reconciliation.future-state",
        "hiredInsteadKey": "workblock.realization-reconciliation.hired-instead",
        "id": "realization-reconciliation-attribution",
        "implementationStatus": "roadmap",
        "jobStatementKey": "workblock.realization-reconciliation.job",
        "jobStories": [
          {
            "completionKey": "workblock.realization-reconciliation.story.assemble-actuals.completion",
            "executionFlowIds": [
              "reconcile-value-actuals",
              "commit-realization-attribution",
              "read-realization-control",
              "evaluate-attribution-method"
            ],
            "id": "realization-reconciliation-attribution.assemble-actuals",
            "roleCardId": "value-lead",
            "storyKey": "workblock.realization-reconciliation.story.assemble-actuals.story"
          },
          {
            "completionKey": "workblock.realization-reconciliation.story.normalise-effects.completion",
            "executionFlowIds": [
              "reconcile-value-actuals",
              "commit-realization-attribution",
              "read-realization-control",
              "evaluate-attribution-method"
            ],
            "id": "realization-reconciliation-attribution.normalise-effects",
            "roleCardId": "finance-delegate",
            "storyKey": "workblock.realization-reconciliation.story.normalise-effects.story"
          },
          {
            "completionKey": "workblock.realization-reconciliation.story.attribute-value.completion",
            "executionFlowIds": [
              "reconcile-value-actuals",
              "commit-realization-attribution",
              "read-realization-control",
              "evaluate-attribution-method"
            ],
            "id": "realization-reconciliation-attribution.attribute-value",
            "roleCardId": "finance-delegate",
            "storyKey": "workblock.realization-reconciliation.story.attribute-value.story"
          },
          {
            "completionKey": "workblock.realization-reconciliation.story.prevent-overlap.completion",
            "executionFlowIds": [
              "reconcile-value-actuals",
              "commit-realization-attribution",
              "read-realization-control",
              "evaluate-attribution-method"
            ],
            "id": "realization-reconciliation-attribution.prevent-overlap",
            "roleCardId": "value-lead",
            "storyKey": "workblock.realization-reconciliation.story.prevent-overlap.story"
          },
          {
            "completionKey": "workblock.realization-reconciliation.story.commit-reconcile.completion",
            "executionFlowIds": [
              "reconcile-value-actuals",
              "commit-realization-attribution",
              "read-realization-control",
              "evaluate-attribution-method"
            ],
            "id": "realization-reconciliation-attribution.commit-reconcile",
            "roleCardId": "finance-delegate",
            "storyKey": "workblock.realization-reconciliation.story.commit-reconcile.story"
          }
        ],
        "labelKey": "workblock.realization-reconciliation.label",
        "metrics": [
          "Proposed, committed, rejected and unreconciled value with attribution drill-through",
          "Actual-source match coverage and stale last-good age",
          "Adjustment mix, finance override, restatement and attribution error rates",
          "Overlap conflicts and duplicate value prevented",
          "SLO: zero committed double-counted realisation and every committed amount is reproducible",
          "Recovery SLO: method rollback rebuilds proposals without mutating finance decisions or source ledgers"
        ],
        "officeCapabilities": [
          "conductor"
        ],
        "operatingModel": "The Workblock joins committed baselines and initiative scope to actual order, invoice, payment, ledger and operational evidence; normalises period, volume, mix, market, currency and one-off effects; applies a versioned attribution method; detects overlap; drafts a disposition; and records only finance-committed realisation as validated value.",
        "outcomeKey": "workblock.realization-reconciliation.outcome",
        "prerequisites": [
          "Committed baselines and initiative records with agreed scope",
          "Read connections to order, invoice, payment and ledger actuals in the ERP",
          "An approved attribution method and adjustment classes agreed with finance",
          "A named finance delegate for realisation commitments"
        ],
        "toolKey": "workblock.realization-reconciliation.tool",
        "version": "5.0.0"
      },
      {
        "agents": [
          {
            "autonomousActions": [
              "refresh portfolio forecast",
              "publish routine forecast version",
              "detect variance and risk",
              "draft interventions",
              "create pre-authorised internal intervention tasks",
              "expire stale proposal"
            ],
            "escalationTriggers": [
              "material target or budget change",
              "portfolio reprioritisation or resource commitment",
              "forecast method change",
              "source gaps could reverse material view",
              "concentration or systemic risk",
              "intervention outside mission authority"
            ],
            "id": "value-portfolio-agent",
            "label": "Value portfolio forecast agent",
            "mission": "Keep the value portfolio forecast current, explain variance and coordinate permitted interventions.",
            "operatorRoleIds": [
              "budget-owner"
            ],
            "personaIds": [
              "procurement-leadership",
              "finance",
              "category-management-persona"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "value-lead",
              "finance-delegate",
              "category-manager",
              "budget-owner"
            ]
          },
          {
            "autonomousActions": [
              "assemble margin fact base",
              "model margin trade-off scenarios",
              "rank candidate interventions",
              "draft margin intervention proposals",
              "expire stale proposal"
            ],
            "escalationTriggers": [
              "material margin position change beyond tolerance",
              "intervention changes a committed target, budget or resource",
              "forecast method change",
              "source gaps could reverse the margin conclusion",
              "scenario used for an external commitment"
            ],
            "id": "margin-tradeoff-agent",
            "label": "Margin trade-off agent",
            "mission": "Model cost, price and service trade-offs across the value portfolio and rank interventions with drill-through to the records behind every projected margin move.",
            "operatorRoleIds": [
              "value-lead"
            ],
            "personaIds": [
              "finance",
              "procurement-leadership",
              "category-management-persona"
            ],
            "promptVersion": "1.0.0",
            "servedRoleIds": [
              "value-lead",
              "finance-delegate"
            ]
          }
        ],
        "agentStoryKey": "workblock.value-portfolio.agent-story",
        "autonomy": {
          "alwaysEscalate": [
            "Material target, budget, priority or resource change",
            "Forecast method change",
            "Systemic or concentration risk",
            "Source gap could reverse a material conclusion",
            "Portfolio intervention outside pre-authorised internal work",
            "Scenario used for an external commitment"
          ],
          "authorityEnvelope": [
            "Permitted refresh, publish, detect, draft and internal-intervention verbs",
            "Portfolio, entity, currency, horizon, scenario and materiality scope",
            "Approved forecast methods, source coverage and freshness thresholds",
            "Permitted read, calculation, event and task tools",
            "Cumulative intervention workload limit",
            "Grantor, duration, sampling and expiry",
            "Forbidden target, budget, priority, resource and external commitments"
          ],
          "humanSupervision": [
            "Own forecast method and portfolio objectives",
            "Commit reprioritisation, target, resource and budget decisions",
            "Inspect forecast-error and intervention samples",
            "Resolve systemic source and method exceptions",
            "Pause publishing or intervention dispatch"
          ],
          "rollback": [
            "Stop new forecast publication and intervention dispatch",
            "Restore prior method, source mapping, model and Workblock versions",
            "Keep last-good forecast visible with stale status",
            "Cancel only uncommitted reversible interventions",
            "Preserve forecast and portfolio decision history"
          ],
          "targetPosture": "policy_autonomous_with_monitoring"
        },
        "coreValue": "Give procurement and finance one current, scenario-aware view of when value is likely to land, why it may move and which intervention can still change the outcome.",
        "currentStateKey": "workblock.value-portfolio.current-state",
        "dataMappings": [
          {
            "access": "read",
            "entityId": "value-opportunity-baseline",
            "purpose": "Include committed baseline and target inputs with freshness."
          },
          {
            "access": "read",
            "entityId": "savings-initiative-record",
            "purpose": "Build the forecast from current initiative plans and state."
          },
          {
            "access": "read",
            "entityId": "value-realization-attribution",
            "purpose": "Use only committed realisation as actual outcome."
          },
          {
            "access": "read",
            "entityId": "value-leakage-finding",
            "purpose": "Represent current leakage and recovery risk."
          },
          {
            "access": "create",
            "entityId": "value-portfolio-forecast",
            "purpose": "Publish an explainable, versioned forecast and intervention proposal. Includes every owned record-envelope and lifecycle field required to reproduce this version."
          },
          {
            "access": "update",
            "entityId": "value-portfolio-forecast",
            "purpose": "Record portfolio authority decisions separately from forecast and proposal."
          },
          {
            "access": "read",
            "entityId": "value-portfolio-forecast",
            "purpose": "Read back the complete committed value portfolio forecast with authority, freshness and provenance for reconciliation and record drill-through."
          },
          {
            "access": "read",
            "entityId": "award-scenario",
            "purpose": "Use evaluated award scenarios and committed award outcomes as cost inputs to margin trade-off modelling."
          },
          {
            "access": "read",
            "entityId": "value-portfolio-forecast",
            "purpose": "List the module-owned ledger through its owner API with indexed filters, cursor pagination, stable row identity, authorised-only counts and last-good age."
          }
        ],
        "descriptionKey": "workblock.value-portfolio.description",
        "descriptorKey": "workblock.value-portfolio.descriptor",
        "dimensionApplicability": [
          {
            "dimensionId": "spend-segment",
            "memberIds": [
              "direct",
              "indirect"
            ]
          }
        ],
        "domainWorkblockId": "value-realization-savings",
        "executionFlows": [
          {
            "agentIds": [],
            "escalationRoleIds": [
              "value-lead",
              "finance-delegate",
              "category-manager",
              "budget-owner"
            ],
            "id": "refresh-value-forecast",
            "jobIds": [
              "value-portfolio-forecast.current-forecast",
              "value-portfolio-forecast.movement-bridge",
              "value-portfolio-forecast.scenario-range",
              "value-portfolio-forecast.portfolio-risk",
              "value-portfolio-forecast.track-intervention"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: value portfolio inputs, normalised portfolio values, value forecast scenarios, and value portfolio forecast result.",
                "Accepted and rejected inputs are counted, source-linked and assigned a freshness state; a failed refresh retains last-good data.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "value-lead",
                "finance-delegate",
                "category-manager",
                "budget-owner"
              ]
            },
            "kind": "refresh",
            "label": "Refresh value forecast",
            "trigger": "Portfolio source event or scheduled forecast cycle"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "value-lead",
              "finance-delegate",
              "category-manager",
              "budget-owner"
            ],
            "id": "analyse-portfolio-variance",
            "jobIds": [
              "value-portfolio-forecast.current-forecast",
              "value-portfolio-forecast.movement-bridge",
              "value-portfolio-forecast.scenario-range",
              "value-portfolio-forecast.portfolio-risk",
              "value-portfolio-forecast.track-intervention"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: forecast variance bridge, portfolio risk set, and portfolio intervention proposals.",
                "Checks, assumptions and material uncertainty are recorded; unresolved cases remain explicit instead of becoming inferred facts.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "value-lead",
                "finance-delegate",
                "category-manager",
                "budget-owner"
              ]
            },
            "kind": "analyse",
            "label": "Analyse portfolio variance",
            "trigger": "Forecast published or material variance detected"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "value-lead",
              "finance-delegate",
              "category-manager",
              "budget-owner"
            ],
            "id": "operate-portfolio-intervention",
            "jobIds": [
              "value-portfolio-forecast.current-forecast",
              "value-portfolio-forecast.movement-bridge",
              "value-portfolio-forecast.scenario-range",
              "value-portfolio-forecast.portfolio-risk",
              "value-portfolio-forecast.track-intervention"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: validated portfolio intervention, portfolio intervention result, and portfolio intervention outcome.",
                "Proposals and committed outcomes keep distinct states; every write records authority, idempotency and reconciliation.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "value-lead",
                "finance-delegate",
                "category-manager",
                "budget-owner"
              ]
            },
            "kind": "operate",
            "label": "Operate portfolio intervention",
            "trigger": "In-envelope proposal or explicit portfolio authority event"
          },
          {
            "agentIds": [],
            "escalationRoleIds": [
              "value-lead",
              "finance-delegate",
              "category-manager",
              "budget-owner"
            ],
            "id": "read-value-portfolio",
            "jobIds": [
              "value-portfolio-forecast.current-forecast",
              "value-portfolio-forecast.movement-bridge",
              "value-portfolio-forecast.scenario-range",
              "value-portfolio-forecast.portfolio-risk",
              "value-portfolio-forecast.track-intervention"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: value portfolio page and value forecast detail.",
                "The response exposes freshness and lets every aggregate drill into its contributing records.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "value-lead",
                "finance-delegate",
                "category-manager",
                "budget-owner"
              ]
            },
            "kind": "read",
            "label": "Read value portfolio",
            "trigger": "Executive query or aggregate drill-through"
          },
          {
            "agentIds": [
              "margin-tradeoff-agent"
            ],
            "escalationRoleIds": [
              "value-lead",
              "finance-delegate",
              "budget-owner"
            ],
            "id": "arbitrate-margin-tradeoffs",
            "jobIds": [
              "value-portfolio-forecast.margin-tradeoff"
            ],
            "jobToBeDone": {
              "completionEvidence": [
                "Declared outputs exist and validate against their contracts: margin tradeoff scenario set and margin intervention proposal.",
                "The mission records its grant, tool calls, stop conditions and handoffs; actions outside policy remain proposals or exceptions.",
                "The completion record links the trigger, task results, output versions, provenance and freshness without overwriting last-good state."
              ],
              "roleCardIds": [
                "value-lead",
                "finance-delegate",
                "budget-owner"
              ]
            },
            "kind": "agent",
            "label": "Arbitrate margin tradeoffs",
            "trigger": "Forecast refresh, input-cost shock or award outcome shifts a margin position beyond tolerance"
          }
        ],
        "futureStateKey": "workblock.value-portfolio.future-state",
        "hiredInsteadKey": "workblock.value-portfolio.hired-instead",
        "id": "value-portfolio-forecast",
        "implementationStatus": "roadmap",
        "jobStatementKey": "workblock.value-portfolio.job",
        "jobStories": [
          {
            "completionKey": "workblock.value-portfolio.story.current-forecast.completion",
            "executionFlowIds": [
              "refresh-value-forecast",
              "analyse-portfolio-variance",
              "operate-portfolio-intervention",
              "read-value-portfolio"
            ],
            "id": "value-portfolio-forecast.current-forecast",
            "roleCardId": "value-lead",
            "storyKey": "workblock.value-portfolio.story.current-forecast.story"
          },
          {
            "completionKey": "workblock.value-portfolio.story.movement-bridge.completion",
            "executionFlowIds": [
              "refresh-value-forecast",
              "analyse-portfolio-variance",
              "operate-portfolio-intervention",
              "read-value-portfolio"
            ],
            "id": "value-portfolio-forecast.movement-bridge",
            "roleCardId": "finance-delegate",
            "storyKey": "workblock.value-portfolio.story.movement-bridge.story"
          },
          {
            "completionKey": "workblock.value-portfolio.story.scenario-range.completion",
            "executionFlowIds": [
              "refresh-value-forecast",
              "analyse-portfolio-variance",
              "operate-portfolio-intervention",
              "read-value-portfolio"
            ],
            "id": "value-portfolio-forecast.scenario-range",
            "roleCardId": "value-lead",
            "storyKey": "workblock.value-portfolio.story.scenario-range.story"
          },
          {
            "completionKey": "workblock.value-portfolio.story.portfolio-risk.completion",
            "executionFlowIds": [
              "refresh-value-forecast",
              "analyse-portfolio-variance",
              "operate-portfolio-intervention",
              "read-value-portfolio"
            ],
            "id": "value-portfolio-forecast.portfolio-risk",
            "roleCardId": "budget-owner",
            "storyKey": "workblock.value-portfolio.story.portfolio-risk.story"
          },
          {
            "completionKey": "workblock.value-portfolio.story.track-intervention.completion",
            "executionFlowIds": [
              "refresh-value-forecast",
              "analyse-portfolio-variance",
              "operate-portfolio-intervention",
              "read-value-portfolio"
            ],
            "id": "value-portfolio-forecast.track-intervention",
            "roleCardId": "category-manager",
            "storyKey": "workblock.value-portfolio.story.track-intervention.story"
          },
          {
            "completionKey": "workblock.value-portfolio.story.margin-tradeoff.completion",
            "executionFlowIds": [
              "arbitrate-margin-tradeoffs"
            ],
            "id": "value-portfolio-forecast.margin-tradeoff",
            "roleCardId": "value-lead",
            "storyKey": "workblock.value-portfolio.story.margin-tradeoff.story"
          }
        ],
        "labelKey": "workblock.value-portfolio.label",
        "metrics": [
          "Target, forecast, validated realisation, leakage and remaining value with initiative drill-through",
          "Forecast movement and variance bridge by cause",
          "Forecast error and interval coverage by horizon, value type and method version",
          "At-risk value, concentration, dependency and intervention outcome",
          "SLO: missing or stale sources remain visible and never silently reduce forecast to zero",
          "Recovery SLO: last-good forecast remains queryable and a bad release can be restored with its exact source and method versions"
        ],
        "officeCapabilities": [
          "conductor"
        ],
        "operatingModel": "The Workblock rolls committed baselines, initiative plans, milestone progress, realised attribution, leakage, dependencies and source freshness into versioned portfolio forecasts. It maintains scenarios and confidence intervals, detects material variance, proposes interventions and records portfolio decisions without presenting forecast as validated realisation.",
        "outcomeKey": "workblock.value-portfolio.outcome",
        "prerequisites": [
          "Access to committed baselines, initiative records, attribution and leakage findings",
          "Approved forecast methods and freshness thresholds",
          "Portfolio scope, entities, currencies and horizons agreed with finance",
          "Named owners for portfolio interventions and reprioritisation"
        ],
        "toolKey": "workblock.value-portfolio.tool",
        "version": "5.1.0"
      }
    ],
    "personas": [
      {
        "id": "procurement-leadership",
        "label": "Procurement leadership",
        "mission": "Steer value, risk, capacity and the performance of policy-bounded actions across procurement from current evidence rather than retrospective reporting."
      },
      {
        "id": "category-management-persona",
        "label": "Category manager",
        "mission": "Turn spend, demand, market, supplier and contract signals into category value and resilient supply."
      },
      {
        "id": "buyer",
        "label": "Buyer",
        "mission": "Move valid demand through the shortest compliant route and resolve exceptions that need commercial judgement."
      },
      {
        "id": "sourcing-specialist",
        "label": "Sourcing specialist",
        "mission": "Convert qualified opportunities into competitive, defensible sourcing outcomes."
      },
      {
        "id": "contract-legal",
        "label": "Contract and legal specialist",
        "mission": "Move agreements to executable language while protecting approved legal and commercial positions."
      },
      {
        "id": "supplier-risk-manager",
        "label": "Supplier risk manager",
        "mission": "Keep supplier eligibility, control evidence and material risk current across the relationship lifecycle."
      },
      {
        "id": "supplier-relationship-manager",
        "label": "Supplier relationship manager",
        "mission": "Improve performance, collaboration, resilience and joint value with the right supplier relationships."
      },
      {
        "id": "requester-persona",
        "label": "Requester and business stakeholder",
        "mission": "Describe a business need once, provide missing evidence and see it progress without navigating procurement structure."
      },
      {
        "id": "accounts-payable",
        "label": "Accounts payable",
        "mission": "Resolve invoice exceptions and prepare accurate payment outcomes with minimal avoidable touch."
      },
      {
        "id": "finance",
        "label": "Finance",
        "mission": "Connect procurement activity to budget, invoice, payment and realised-value evidence."
      },
      {
        "id": "platform-operator",
        "label": "Platform and control operator",
        "mission": "Keep data, integrations, policies, evaluations and authority grants healthy across Workblocks."
      }
    ]
  },
  "content": {
    "businessModuleStatusDisplay": [
      {
        "chipKey": "status.reference.chip",
        "id": "reference",
        "legendKey": "status.reference.legend"
      },
      {
        "chipKey": "status.pattern.chip",
        "id": "pattern",
        "legendKey": "status.pattern.legend"
      },
      {
        "chipKey": "status.roadmap.chip",
        "id": "roadmap",
        "legendKey": "status.roadmap.legend"
      }
    ],
    "capabilities": [
      {
        "descriptionKey": "capability.control-tower.description",
        "icon": "radar",
        "id": "procurement-control-tower",
        "labelKey": "capability.control-tower.label",
        "order": 1
      },
      {
        "descriptionKey": "capability.copilot.description",
        "icon": "sparkles",
        "id": "platform-copilot-agent-tools",
        "labelKey": "capability.copilot.label",
        "order": 2
      },
      {
        "descriptionKey": "capability.data.description",
        "icon": "database",
        "id": "data-evidence-analytics-learning",
        "labelKey": "capability.data.label",
        "order": 3
      },
      {
        "descriptionKey": "capability.integration.description",
        "icon": "plug",
        "id": "integration-coexistence",
        "labelKey": "capability.integration.label",
        "order": 4
      },
      {
        "descriptionKey": "capability.office.description",
        "icon": "files",
        "id": "office-composer-conductor",
        "labelKey": "capability.office.label",
        "order": 5
      },
      {
        "descriptionKey": "capability.controls.description",
        "icon": "fingerprint",
        "id": "identity-policy-controls-audit",
        "labelKey": "capability.controls.label",
        "order": 6
      },
      {
        "descriptionKey": "capability.authoring.description",
        "icon": "blocks",
        "id": "workblock-authoring-adaptability",
        "labelKey": "capability.authoring.label",
        "order": 7
      },
      {
        "descriptionKey": "capability.messaging.description",
        "icon": "messages-square",
        "id": "messaging-localization-glossary",
        "labelKey": "capability.messaging.label",
        "order": 8
      }
    ],
    "capabilityRows": [
      {
        "capabilityIds": [
          "data-evidence-analytics-learning",
          "identity-policy-controls-audit"
        ],
        "id": "intelligence-control",
        "labelKey": "capability-row.intelligence-control.label",
        "order": 1
      },
      {
        "capabilityIds": [
          "platform-copilot-agent-tools",
          "office-composer-conductor",
          "messaging-localization-glossary"
        ],
        "id": "agents-cowork",
        "labelKey": "capability-row.agents-cowork.label",
        "order": 2
      },
      {
        "capabilityIds": [
          "integration-coexistence",
          "workblock-authoring-adaptability"
        ],
        "id": "connect-change",
        "labelKey": "capability-row.connect-change.label",
        "order": 3
      }
    ],
    "domainWorkblocks": [
      {
        "businessModuleIds": [
          "spend-data-foundation",
          "category-opportunity-radar",
          "category-strategy-orchestrator",
          "policy-rule-lifecycle",
          "policy-guidance"
        ],
        "buyerQuestionKey": "domain.strategy.buyer-question",
        "changes": [
          {
            "afterKey": "domain.strategy.change.decision-queue.after",
            "beforeKey": "domain.strategy.change.decision-queue.before",
            "id": "decision-queue",
            "titleKey": "domain.strategy.change.decision-queue.title"
          },
          {
            "afterKey": "domain.strategy.change.answer-or-escalation.after",
            "beforeKey": "domain.strategy.change.answer-or-escalation.before",
            "id": "answer-or-escalation",
            "titleKey": "domain.strategy.change.answer-or-escalation.title"
          }
        ],
        "deepDive": true,
        "deepDivePrinciples": [
          {
            "bodyKey": "domain.strategy.principle.proposal-not-commitment.body",
            "id": "proposal-not-commitment",
            "titleKey": "domain.strategy.principle.proposal-not-commitment.title"
          },
          {
            "bodyKey": "domain.strategy.principle.aggregate-is-a-door.body",
            "id": "aggregate-is-a-door",
            "titleKey": "domain.strategy.principle.aggregate-is-a-door.title"
          },
          {
            "bodyKey": "domain.strategy.principle.approved-not-delivered.body",
            "id": "approved-not-delivered",
            "titleKey": "domain.strategy.principle.approved-not-delivered.title"
          }
        ],
        "descriptionKey": "domain.strategy.description",
        "descriptorKey": "system.radar.descriptor",
        "icon": "compass",
        "id": "strategy-policy-category-spend",
        "labelKey": "domain.strategy.label",
        "nameKey": "system.radar.name",
        "narrativeGapKeys": [
          "domain.strategy.gap-1",
          "domain.strategy.gap-2",
          "domain.strategy.gap-3"
        ],
        "order": 1,
        "outcomeKey": "domain.strategy.outcome",
        "previewBusinessModuleIds": [
          "category-opportunity-radar",
          "category-strategy-orchestrator",
          "policy-guidance"
        ],
        "previewRoleIds": [
          "category-manager",
          "procurement-analyst",
          "policy-owner"
        ],
        "proofQuestionKey": "domain.strategy.proof-question",
        "roleCards": [
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.strategy.role.category-manager.alone",
            "commitKey": "domain.strategy.role.category-manager.commit",
            "consultedBusinessModuleIds": [
              "policy-guidance"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.strategy.role.category-manager.hired",
            "id": "category-manager",
            "mandateKey": "domain.strategy.role.category-manager.mandate",
            "measuredKey": "domain.strategy.role.category-manager.measured",
            "performsBusinessModuleIds": [
              "category-opportunity-radar",
              "category-strategy-orchestrator"
            ],
            "proposeKey": "domain.strategy.role.category-manager.propose",
            "questionKey": "domain.strategy.role.category-manager.question",
            "roleKey": "domain.strategy.role.category-manager.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.strategy.role.procurement-analyst.alone",
            "commitKey": "domain.strategy.role.procurement-analyst.commit",
            "consultedBusinessModuleIds": [
              "category-strategy-orchestrator"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.strategy.role.procurement-analyst.hired",
            "id": "procurement-analyst",
            "mandateKey": "domain.strategy.role.procurement-analyst.mandate",
            "measuredKey": "domain.strategy.role.procurement-analyst.measured",
            "performsBusinessModuleIds": [
              "category-opportunity-radar",
              "spend-data-foundation"
            ],
            "proposeKey": "domain.strategy.role.procurement-analyst.propose",
            "questionKey": "domain.strategy.role.procurement-analyst.question",
            "roleKey": "domain.strategy.role.procurement-analyst.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.strategy.role.data-steward.alone",
            "commitKey": "domain.strategy.role.data-steward.commit",
            "consultedBusinessModuleIds": [
              "category-opportunity-radar",
              "spend-data-foundation",
              "policy-rule-lifecycle"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.strategy.role.data-steward.hired",
            "id": "data-steward",
            "mandateKey": "domain.strategy.role.data-steward.mandate",
            "measuredKey": "domain.strategy.role.data-steward.measured",
            "performsBusinessModuleIds": [],
            "proposeKey": "domain.strategy.role.data-steward.propose",
            "questionKey": "domain.strategy.role.data-steward.question",
            "roleKey": "domain.strategy.role.data-steward.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.strategy.role.policy-owner.alone",
            "commitKey": "domain.strategy.role.policy-owner.commit",
            "consultedBusinessModuleIds": [
              "category-opportunity-radar",
              "category-strategy-orchestrator"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.strategy.role.policy-owner.hired",
            "id": "policy-owner",
            "mandateKey": "domain.strategy.role.policy-owner.mandate",
            "measuredKey": "domain.strategy.role.policy-owner.measured",
            "performsBusinessModuleIds": [
              "policy-guidance",
              "policy-rule-lifecycle"
            ],
            "proposeKey": "domain.strategy.role.policy-owner.propose",
            "questionKey": "domain.strategy.role.policy-owner.question",
            "roleKey": "domain.strategy.role.policy-owner.title"
          }
        ],
        "shortLabelKey": "domain.strategy.short",
        "signatureKey": "system.radar.signature",
        "version": "4.1.0",
        "wedgeKey": "domain.strategy.wedge",
        "workblockContract": {
          "accountableRoleIds": [
            "category-manager",
            "procurement-analyst",
            "data-steward",
            "policy-owner"
          ],
          "authority": "Routine bounded actions execute inside versioned authority envelopes. Domain roles supervise outcomes, samples, exceptions and policy, and retain pause, stop, revoke, demote and rollback rights.",
          "completionEvidence": [
            "The selected business module records its observable completion evidence and every consequential receipt.",
            "Cross-module handoffs retain record identity, authority, provenance, freshness and qualified execution trace.",
            "Exceptions remain owned, recoverable and visible without turning routine work into a universal approval queue."
          ],
          "crossModuleOrchestration": "Business modules exchange typed owner commands and versioned events through GroundWorks records. Execution flows never share hidden in-memory state and retries never duplicate commitments.",
          "failureConsequence": "Committed state remains distinguishable from proposals and partial work. Last-good records stay visible, failed side effects reconcile, and an accountable domain role can pause, retry, reverse or reassign within policy.",
          "releaseBoundary": "The domain Workblock is the independently versioned product and interface boundary. A child Workblock exists only for a real release, credential, authority, scale, failure or reuse boundary.",
          "trigger": "A governed domain record, event, schedule or authorised request enters one of this Workblock's five business modules.",
          "ux": "One cohesive Workblock interface provides five business-module views, shared domain context, explicit state and authority, record drill-through, and truthful loading, empty, partial, stale, blocked, error and success states."
        }
      },
      {
        "businessModuleIds": [
          "procurement-service-catalogue",
          "intelligent-intake",
          "request-enrichment-routing",
          "demand-orchestration",
          "demand-consolidation-portfolio"
        ],
        "buyerQuestionKey": "domain.intake.buyer-question",
        "changes": [
          {
            "afterKey": "domain.intake.change.decision-package.after",
            "beforeKey": "domain.intake.change.decision-package.before",
            "id": "decision-package",
            "titleKey": "domain.intake.change.decision-package.title"
          },
          {
            "afterKey": "domain.intake.change.parent-outcome.after",
            "beforeKey": "domain.intake.change.parent-outcome.before",
            "id": "parent-outcome",
            "titleKey": "domain.intake.change.parent-outcome.title"
          }
        ],
        "deepDive": true,
        "deepDivePrinciples": [
          {
            "bodyKey": "domain.intake.principle.proposal-not-commitment.body",
            "id": "proposal-not-commitment",
            "titleKey": "domain.intake.principle.proposal-not-commitment.title"
          },
          {
            "bodyKey": "domain.intake.principle.no-state-from-silence.body",
            "id": "no-state-from-silence",
            "titleKey": "domain.intake.principle.no-state-from-silence.title"
          },
          {
            "bodyKey": "domain.intake.principle.complete-per-route.body",
            "id": "complete-per-route",
            "titleKey": "domain.intake.principle.complete-per-route.title"
          }
        ],
        "descriptionKey": "domain.intake.description",
        "descriptorKey": "system.gateway.descriptor",
        "icon": "inbox",
        "id": "intake-demand",
        "labelKey": "domain.intake.label",
        "nameKey": "system.gateway.name",
        "narrativeGapKeys": [
          "domain.intake.gap-1",
          "domain.intake.gap-2",
          "domain.intake.gap-3"
        ],
        "order": 2,
        "outcomeKey": "domain.intake.outcome",
        "previewBusinessModuleIds": [
          "intelligent-intake",
          "request-enrichment-routing",
          "demand-orchestration"
        ],
        "previewRoleIds": [
          "requester",
          "intake-owner",
          "demand-owner"
        ],
        "proofQuestionKey": "domain.intake.proof-question",
        "roleCards": [
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.intake.role.requester.alone",
            "commitKey": "domain.intake.role.requester.commit",
            "consultedBusinessModuleIds": [
              "demand-orchestration",
              "procurement-service-catalogue",
              "request-enrichment-routing"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.intake.role.requester.hired",
            "id": "requester",
            "mandateKey": "domain.intake.role.requester.mandate",
            "measuredKey": "domain.intake.role.requester.measured",
            "performsBusinessModuleIds": [
              "intelligent-intake"
            ],
            "proposeKey": "domain.intake.role.requester.propose",
            "questionKey": "domain.intake.role.requester.question",
            "roleKey": "domain.intake.role.requester.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.intake.role.intake-owner.alone",
            "commitKey": "domain.intake.role.intake-owner.commit",
            "consultedBusinessModuleIds": [
              "demand-orchestration",
              "procurement-service-catalogue",
              "demand-consolidation-portfolio"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.intake.role.intake-owner.hired",
            "id": "intake-owner",
            "mandateKey": "domain.intake.role.intake-owner.mandate",
            "measuredKey": "domain.intake.role.intake-owner.measured",
            "performsBusinessModuleIds": [
              "intelligent-intake",
              "request-enrichment-routing"
            ],
            "proposeKey": "domain.intake.role.intake-owner.propose",
            "questionKey": "domain.intake.role.intake-owner.question",
            "roleKey": "domain.intake.role.intake-owner.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.intake.role.demand-owner.alone",
            "commitKey": "domain.intake.role.demand-owner.commit",
            "consultedBusinessModuleIds": [
              "intelligent-intake",
              "request-enrichment-routing"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.intake.role.demand-owner.hired",
            "id": "demand-owner",
            "mandateKey": "domain.intake.role.demand-owner.mandate",
            "measuredKey": "domain.intake.role.demand-owner.measured",
            "performsBusinessModuleIds": [
              "demand-orchestration",
              "demand-consolidation-portfolio"
            ],
            "proposeKey": "domain.intake.role.demand-owner.propose",
            "questionKey": "domain.intake.role.demand-owner.question",
            "roleKey": "domain.intake.role.demand-owner.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.intake.role.process-owner.alone",
            "commitKey": "domain.intake.role.process-owner.commit",
            "consultedBusinessModuleIds": [
              "intelligent-intake",
              "demand-orchestration",
              "request-enrichment-routing",
              "demand-consolidation-portfolio"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.intake.role.process-owner.hired",
            "id": "process-owner",
            "mandateKey": "domain.intake.role.process-owner.mandate",
            "measuredKey": "domain.intake.role.process-owner.measured",
            "performsBusinessModuleIds": [
              "procurement-service-catalogue"
            ],
            "proposeKey": "domain.intake.role.process-owner.propose",
            "questionKey": "domain.intake.role.process-owner.question",
            "roleKey": "domain.intake.role.process-owner.title"
          }
        ],
        "shortLabelKey": "domain.intake.short",
        "signatureKey": "system.gateway.signature",
        "version": "4.1.0",
        "wedgeKey": "domain.intake.wedge",
        "workblockContract": {
          "accountableRoleIds": [
            "requester",
            "intake-owner",
            "demand-owner",
            "process-owner"
          ],
          "authority": "Routine bounded actions execute inside versioned authority envelopes. Domain roles supervise outcomes, samples, exceptions and policy, and retain pause, stop, revoke, demote and rollback rights.",
          "completionEvidence": [
            "The selected business module records its observable completion evidence and every consequential receipt.",
            "Cross-module handoffs retain record identity, authority, provenance, freshness and qualified execution trace.",
            "Exceptions remain owned, recoverable and visible without turning routine work into a universal approval queue."
          ],
          "crossModuleOrchestration": "Business modules exchange typed owner commands and versioned events through GroundWorks records. Execution flows never share hidden in-memory state and retries never duplicate commitments.",
          "failureConsequence": "Committed state remains distinguishable from proposals and partial work. Last-good records stay visible, failed side effects reconcile, and an accountable domain role can pause, retry, reverse or reassign within policy.",
          "releaseBoundary": "The domain Workblock is the independently versioned product and interface boundary. A child Workblock exists only for a real release, credential, authority, scale, failure or reuse boundary.",
          "trigger": "A governed domain record, event, schedule or authorised request enters one of this Workblock's five business modules.",
          "ux": "One cohesive Workblock interface provides five business-module views, shared domain context, explicit state and authority, record drill-through, and truthful loading, empty, partial, stale, blocked, error and success states."
        }
      },
      {
        "businessModuleIds": [
          "sourcing-pipeline-discovery",
          "sourcing-event",
          "bid-evaluation-award",
          "negotiation-copilot",
          "tactical-sourcing-autonomy"
        ],
        "buyerQuestionKey": "domain.sourcing.buyer-question",
        "changes": [
          {
            "afterKey": "domain.sourcing.change.assembled-award.after",
            "beforeKey": "domain.sourcing.change.assembled-award.before",
            "id": "assembled-award",
            "titleKey": "domain.sourcing.change.assembled-award.title"
          },
          {
            "afterKey": "domain.sourcing.change.authority-line.after",
            "beforeKey": "domain.sourcing.change.authority-line.before",
            "id": "authority-line",
            "titleKey": "domain.sourcing.change.authority-line.title"
          }
        ],
        "deepDive": true,
        "deepDivePrinciples": [
          {
            "bodyKey": "domain.sourcing.principle.recommendation-not-commitment.body",
            "id": "recommendation-not-commitment",
            "titleKey": "domain.sourcing.principle.recommendation-not-commitment.title"
          },
          {
            "bodyKey": "domain.sourcing.principle.original-response.body",
            "id": "original-response",
            "titleKey": "domain.sourcing.principle.original-response.title"
          },
          {
            "bodyKey": "domain.sourcing.principle.dissent-survives.body",
            "id": "dissent-survives",
            "titleKey": "domain.sourcing.principle.dissent-survives.title"
          }
        ],
        "descriptionKey": "domain.sourcing.description",
        "descriptorKey": "system.dealroom.descriptor",
        "icon": "gavel",
        "id": "sourcing-negotiation",
        "labelKey": "domain.sourcing.label",
        "nameKey": "system.dealroom.name",
        "narrativeGapKeys": [
          "domain.sourcing.gap-1",
          "domain.sourcing.gap-2",
          "domain.sourcing.gap-3"
        ],
        "order": 3,
        "outcomeKey": "domain.sourcing.outcome",
        "previewBusinessModuleIds": [
          "sourcing-event",
          "bid-evaluation-award",
          "negotiation-copilot"
        ],
        "previewRoleIds": [
          "sourcing-lead",
          "evaluator",
          "award-authority"
        ],
        "proofQuestionKey": "domain.sourcing.proof-question",
        "roleCards": [
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.sourcing.role.sourcing-lead.alone",
            "commitKey": "domain.sourcing.role.sourcing-lead.commit",
            "consultedBusinessModuleIds": [
              "negotiation-copilot",
              "bid-evaluation-award"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.sourcing.role.sourcing-lead.hired",
            "id": "sourcing-lead",
            "mandateKey": "domain.sourcing.role.sourcing-lead.mandate",
            "measuredKey": "domain.sourcing.role.sourcing-lead.measured",
            "performsBusinessModuleIds": [
              "sourcing-event",
              "sourcing-pipeline-discovery",
              "tactical-sourcing-autonomy"
            ],
            "proposeKey": "domain.sourcing.role.sourcing-lead.propose",
            "questionKey": "domain.sourcing.role.sourcing-lead.question",
            "roleKey": "domain.sourcing.role.sourcing-lead.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.sourcing.role.evaluator.alone",
            "commitKey": "domain.sourcing.role.evaluator.commit",
            "consultedBusinessModuleIds": [
              "sourcing-pipeline-discovery",
              "tactical-sourcing-autonomy"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.sourcing.role.evaluator.hired",
            "id": "evaluator",
            "mandateKey": "domain.sourcing.role.evaluator.mandate",
            "measuredKey": "domain.sourcing.role.evaluator.measured",
            "performsBusinessModuleIds": [
              "sourcing-event",
              "bid-evaluation-award"
            ],
            "proposeKey": "domain.sourcing.role.evaluator.propose",
            "questionKey": "domain.sourcing.role.evaluator.question",
            "roleKey": "domain.sourcing.role.evaluator.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.sourcing.role.award-authority.alone",
            "commitKey": "domain.sourcing.role.award-authority.commit",
            "consultedBusinessModuleIds": [
              "sourcing-event",
              "negotiation-copilot",
              "bid-evaluation-award",
              "tactical-sourcing-autonomy"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.sourcing.role.award-authority.hired",
            "id": "award-authority",
            "mandateKey": "domain.sourcing.role.award-authority.mandate",
            "measuredKey": "domain.sourcing.role.award-authority.measured",
            "performsBusinessModuleIds": [],
            "proposeKey": "domain.sourcing.role.award-authority.propose",
            "questionKey": "domain.sourcing.role.award-authority.question",
            "roleKey": "domain.sourcing.role.award-authority.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.sourcing.role.negotiation-lead.alone",
            "commitKey": "domain.sourcing.role.negotiation-lead.commit",
            "consultedBusinessModuleIds": [
              "sourcing-event",
              "tactical-sourcing-autonomy"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.sourcing.role.negotiation-lead.hired",
            "id": "negotiation-lead",
            "mandateKey": "domain.sourcing.role.negotiation-lead.mandate",
            "measuredKey": "domain.sourcing.role.negotiation-lead.measured",
            "performsBusinessModuleIds": [
              "negotiation-copilot"
            ],
            "proposeKey": "domain.sourcing.role.negotiation-lead.propose",
            "questionKey": "domain.sourcing.role.negotiation-lead.question",
            "roleKey": "domain.sourcing.role.negotiation-lead.title"
          }
        ],
        "shortLabelKey": "domain.sourcing.short",
        "signatureKey": "system.dealroom.signature",
        "version": "4.1.0",
        "wedgeKey": "domain.sourcing.wedge",
        "workblockContract": {
          "accountableRoleIds": [
            "sourcing-lead",
            "evaluator",
            "award-authority",
            "negotiation-lead"
          ],
          "authority": "Routine bounded actions execute inside versioned authority envelopes. Domain roles supervise outcomes, samples, exceptions and policy, and retain pause, stop, revoke, demote and rollback rights.",
          "completionEvidence": [
            "The selected business module records its observable completion evidence and every consequential receipt.",
            "Cross-module handoffs retain record identity, authority, provenance, freshness and qualified execution trace.",
            "Exceptions remain owned, recoverable and visible without turning routine work into a universal approval queue."
          ],
          "crossModuleOrchestration": "Business modules exchange typed owner commands and versioned events through GroundWorks records. Execution flows never share hidden in-memory state and retries never duplicate commitments.",
          "failureConsequence": "Committed state remains distinguishable from proposals and partial work. Last-good records stay visible, failed side effects reconcile, and an accountable domain role can pause, retry, reverse or reassign within policy.",
          "releaseBoundary": "The domain Workblock is the independently versioned product and interface boundary. A child Workblock exists only for a real release, credential, authority, scale, failure or reuse boundary.",
          "trigger": "A governed domain record, event, schedule or authorised request enters one of this Workblock's five business modules.",
          "ux": "One cohesive Workblock interface provides five business-module views, shared domain context, explicit state and authority, record drill-through, and truthful loading, empty, partial, stale, blocked, error and success states."
        }
      },
      {
        "businessModuleIds": [
          "contract-intake-digitization",
          "contract-authoring-review",
          "contract-approval-repository",
          "obligation-monitoring",
          "renewal-change-compliance"
        ],
        "buyerQuestionKey": "domain.clm.buyer-question",
        "changes": [
          {
            "afterKey": "domain.clm.change.review-decisions.after",
            "beforeKey": "domain.clm.change.review-decisions.before",
            "id": "review-decisions",
            "titleKey": "domain.clm.change.review-decisions.title"
          },
          {
            "afterKey": "domain.clm.change.active-obligations.after",
            "beforeKey": "domain.clm.change.active-obligations.before",
            "id": "active-obligations",
            "titleKey": "domain.clm.change.active-obligations.title"
          }
        ],
        "deepDive": true,
        "deepDivePrinciples": [
          {
            "bodyKey": "domain.clm.principle.native-artifact.body",
            "id": "native-artifact",
            "titleKey": "domain.clm.principle.native-artifact.title"
          },
          {
            "bodyKey": "domain.clm.principle.proposal-not-position.body",
            "id": "proposal-not-position",
            "titleKey": "domain.clm.principle.proposal-not-position.title"
          },
          {
            "bodyKey": "domain.clm.principle.owned-obligations.body",
            "id": "owned-obligations",
            "titleKey": "domain.clm.principle.owned-obligations.title"
          }
        ],
        "descriptionKey": "domain.clm.description",
        "descriptorKey": "system.covenant.descriptor",
        "icon": "file-signature",
        "id": "contract-lifecycle-management",
        "labelKey": "domain.clm.label",
        "nameKey": "system.covenant.name",
        "narrativeGapKeys": [
          "domain.clm.gap-1",
          "domain.clm.gap-2",
          "domain.clm.gap-3"
        ],
        "order": 4,
        "outcomeKey": "domain.clm.outcome",
        "previewBusinessModuleIds": [
          "contract-authoring-review",
          "contract-approval-repository",
          "obligation-monitoring"
        ],
        "previewRoleIds": [
          "contract-manager",
          "legal-counsel",
          "sourcing-manager"
        ],
        "proofQuestionKey": "domain.clm.proof-question",
        "roleCards": [
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.clm.role.contract-manager.alone",
            "commitKey": "domain.clm.role.contract-manager.commit",
            "consultedBusinessModuleIds": [],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.clm.role.contract-manager.hired",
            "id": "contract-manager",
            "mandateKey": "domain.clm.role.contract-manager.mandate",
            "measuredKey": "domain.clm.role.contract-manager.measured",
            "performsBusinessModuleIds": [
              "contract-authoring-review",
              "obligation-monitoring",
              "contract-intake-digitization",
              "contract-approval-repository",
              "renewal-change-compliance"
            ],
            "proposeKey": "domain.clm.role.contract-manager.propose",
            "questionKey": "domain.clm.role.contract-manager.question",
            "roleKey": "domain.clm.role.contract-manager.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.clm.role.legal-counsel.alone",
            "commitKey": "domain.clm.role.legal-counsel.commit",
            "consultedBusinessModuleIds": [
              "obligation-monitoring",
              "contract-intake-digitization",
              "contract-approval-repository",
              "renewal-change-compliance"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.clm.role.legal-counsel.hired",
            "id": "legal-counsel",
            "mandateKey": "domain.clm.role.legal-counsel.mandate",
            "measuredKey": "domain.clm.role.legal-counsel.measured",
            "performsBusinessModuleIds": [
              "contract-authoring-review"
            ],
            "proposeKey": "domain.clm.role.legal-counsel.propose",
            "questionKey": "domain.clm.role.legal-counsel.question",
            "roleKey": "domain.clm.role.legal-counsel.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.clm.role.sourcing-manager.alone",
            "commitKey": "domain.clm.role.sourcing-manager.commit",
            "consultedBusinessModuleIds": [
              "obligation-monitoring",
              "contract-intake-digitization",
              "contract-approval-repository",
              "renewal-change-compliance"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.clm.role.sourcing-manager.hired",
            "id": "sourcing-manager",
            "mandateKey": "domain.clm.role.sourcing-manager.mandate",
            "measuredKey": "domain.clm.role.sourcing-manager.measured",
            "performsBusinessModuleIds": [
              "contract-authoring-review"
            ],
            "proposeKey": "domain.clm.role.sourcing-manager.propose",
            "questionKey": "domain.clm.role.sourcing-manager.question",
            "roleKey": "domain.clm.role.sourcing-manager.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.clm.role.obligation-owner.alone",
            "commitKey": "domain.clm.role.obligation-owner.commit",
            "consultedBusinessModuleIds": [
              "contract-authoring-review",
              "renewal-change-compliance"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.clm.role.obligation-owner.hired",
            "id": "obligation-owner",
            "mandateKey": "domain.clm.role.obligation-owner.mandate",
            "measuredKey": "domain.clm.role.obligation-owner.measured",
            "performsBusinessModuleIds": [
              "obligation-monitoring"
            ],
            "proposeKey": "domain.clm.role.obligation-owner.propose",
            "questionKey": "domain.clm.role.obligation-owner.question",
            "roleKey": "domain.clm.role.obligation-owner.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.clm.role.category-manager.alone",
            "commitKey": "domain.clm.role.category-manager.commit",
            "consultedBusinessModuleIds": [
              "contract-authoring-review",
              "contract-approval-repository"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.clm.role.category-manager.hired",
            "id": "category-manager",
            "mandateKey": "domain.clm.role.category-manager.mandate",
            "measuredKey": "domain.clm.role.category-manager.measured",
            "performsBusinessModuleIds": [
              "renewal-change-compliance"
            ],
            "proposeKey": "domain.clm.role.category-manager.propose",
            "questionKey": "domain.clm.role.category-manager.question",
            "roleKey": "domain.clm.role.category-manager.title"
          }
        ],
        "shortLabelKey": "domain.clm.short",
        "signatureKey": "system.covenant.signature",
        "version": "4.1.0",
        "wedgeKey": "domain.clm.wedge",
        "workblockContract": {
          "accountableRoleIds": [
            "contract-manager",
            "legal-counsel",
            "sourcing-manager",
            "obligation-owner",
            "category-manager"
          ],
          "authority": "Routine bounded actions execute inside versioned authority envelopes. Domain roles supervise outcomes, samples, exceptions and policy, and retain pause, stop, revoke, demote and rollback rights.",
          "completionEvidence": [
            "The selected business module records its observable completion evidence and every consequential receipt.",
            "Cross-module handoffs retain record identity, authority, provenance, freshness and qualified execution trace.",
            "Exceptions remain owned, recoverable and visible without turning routine work into a universal approval queue."
          ],
          "crossModuleOrchestration": "Business modules exchange typed owner commands and versioned events through GroundWorks records. Execution flows never share hidden in-memory state and retries never duplicate commitments.",
          "failureConsequence": "Committed state remains distinguishable from proposals and partial work. Last-good records stay visible, failed side effects reconcile, and an accountable domain role can pause, retry, reverse or reassign within policy.",
          "releaseBoundary": "The domain Workblock is the independently versioned product and interface boundary. A child Workblock exists only for a real release, credential, authority, scale, failure or reuse boundary.",
          "trigger": "A governed domain record, event, schedule or authorised request enters one of this Workblock's five business modules.",
          "ux": "One cohesive Workblock interface provides five business-module views, shared domain context, explicit state and authority, record drill-through, and truthful loading, empty, partial, stale, blocked, error and success states."
        }
      },
      {
        "businessModuleIds": [
          "supplier-onboarding",
          "supplier-master-qualification",
          "third-party-risk-review",
          "continuous-risk-monitoring",
          "supplier-remediation-exit"
        ],
        "buyerQuestionKey": "domain.tprm.buyer-question",
        "changes": [
          {
            "afterKey": "domain.tprm.change.assembled-case.after",
            "beforeKey": "domain.tprm.change.assembled-case.before",
            "id": "assembled-case",
            "titleKey": "domain.tprm.change.assembled-case.title"
          },
          {
            "afterKey": "domain.tprm.change.managed-exceptions.after",
            "beforeKey": "domain.tprm.change.managed-exceptions.before",
            "id": "managed-exceptions",
            "titleKey": "domain.tprm.change.managed-exceptions.title"
          }
        ],
        "deepDive": true,
        "deepDivePrinciples": [
          {
            "bodyKey": "domain.tprm.principle.engagement-not-record.body",
            "id": "engagement-not-record",
            "titleKey": "domain.tprm.principle.engagement-not-record.title"
          },
          {
            "bodyKey": "domain.tprm.principle.proposal-not-acceptance.body",
            "id": "proposal-not-acceptance",
            "titleKey": "domain.tprm.principle.proposal-not-acceptance.title"
          },
          {
            "bodyKey": "domain.tprm.principle.proportionate-review.body",
            "id": "proportionate-review",
            "titleKey": "domain.tprm.principle.proportionate-review.title"
          }
        ],
        "descriptionKey": "domain.tprm.description",
        "descriptorKey": "system.sentinel.descriptor",
        "icon": "shield-check",
        "id": "supplier-lifecycle-third-party-risk",
        "labelKey": "domain.tprm.label",
        "nameKey": "system.sentinel.name",
        "narrativeGapKeys": [
          "domain.tprm.gap-1",
          "domain.tprm.gap-2",
          "domain.tprm.gap-3"
        ],
        "order": 5,
        "outcomeKey": "domain.tprm.outcome",
        "previewBusinessModuleIds": [
          "supplier-onboarding",
          "supplier-master-qualification",
          "third-party-risk-review"
        ],
        "previewRoleIds": [
          "onboarding-coordinator",
          "supplier-master-steward",
          "accountable-risk-owner"
        ],
        "proofQuestionKey": "domain.tprm.proof-question",
        "roleCards": [
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.tprm.role.onboarding-coordinator.alone",
            "commitKey": "domain.tprm.role.onboarding-coordinator.commit",
            "consultedBusinessModuleIds": [
              "third-party-risk-review",
              "supplier-master-qualification",
              "supplier-remediation-exit"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.tprm.role.onboarding-coordinator.hired",
            "id": "onboarding-coordinator",
            "mandateKey": "domain.tprm.role.onboarding-coordinator.mandate",
            "measuredKey": "domain.tprm.role.onboarding-coordinator.measured",
            "performsBusinessModuleIds": [
              "supplier-onboarding"
            ],
            "proposeKey": "domain.tprm.role.onboarding-coordinator.propose",
            "questionKey": "domain.tprm.role.onboarding-coordinator.question",
            "roleKey": "domain.tprm.role.onboarding-coordinator.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.tprm.role.supplier-master-steward.alone",
            "commitKey": "domain.tprm.role.supplier-master-steward.commit",
            "consultedBusinessModuleIds": [],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.tprm.role.supplier-master-steward.hired",
            "id": "supplier-master-steward",
            "mandateKey": "domain.tprm.role.supplier-master-steward.mandate",
            "measuredKey": "domain.tprm.role.supplier-master-steward.measured",
            "performsBusinessModuleIds": [
              "supplier-onboarding",
              "supplier-master-qualification"
            ],
            "proposeKey": "domain.tprm.role.supplier-master-steward.propose",
            "questionKey": "domain.tprm.role.supplier-master-steward.question",
            "roleKey": "domain.tprm.role.supplier-master-steward.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.tprm.role.accountable-risk-owner.alone",
            "commitKey": "domain.tprm.role.accountable-risk-owner.commit",
            "consultedBusinessModuleIds": [
              "supplier-onboarding",
              "continuous-risk-monitoring",
              "supplier-master-qualification"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.tprm.role.accountable-risk-owner.hired",
            "id": "accountable-risk-owner",
            "mandateKey": "domain.tprm.role.accountable-risk-owner.mandate",
            "measuredKey": "domain.tprm.role.accountable-risk-owner.measured",
            "performsBusinessModuleIds": [
              "third-party-risk-review",
              "supplier-remediation-exit"
            ],
            "proposeKey": "domain.tprm.role.accountable-risk-owner.propose",
            "questionKey": "domain.tprm.role.accountable-risk-owner.question",
            "roleKey": "domain.tprm.role.accountable-risk-owner.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.tprm.role.tprm-programme-owner.alone",
            "commitKey": "domain.tprm.role.tprm-programme-owner.commit",
            "consultedBusinessModuleIds": [
              "supplier-onboarding",
              "supplier-master-qualification",
              "supplier-remediation-exit"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.tprm.role.tprm-programme-owner.hired",
            "id": "tprm-programme-owner",
            "mandateKey": "domain.tprm.role.tprm-programme-owner.mandate",
            "measuredKey": "domain.tprm.role.tprm-programme-owner.measured",
            "performsBusinessModuleIds": [
              "third-party-risk-review",
              "continuous-risk-monitoring"
            ],
            "proposeKey": "domain.tprm.role.tprm-programme-owner.propose",
            "questionKey": "domain.tprm.role.tprm-programme-owner.question",
            "roleKey": "domain.tprm.role.tprm-programme-owner.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.tprm.role.supplier-contact.alone",
            "commitKey": "domain.tprm.role.supplier-contact.commit",
            "consultedBusinessModuleIds": [
              "third-party-risk-review",
              "supplier-remediation-exit"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.tprm.role.supplier-contact.hired",
            "id": "supplier-contact",
            "mandateKey": "domain.tprm.role.supplier-contact.mandate",
            "measuredKey": "domain.tprm.role.supplier-contact.measured",
            "performsBusinessModuleIds": [
              "supplier-onboarding"
            ],
            "proposeKey": "domain.tprm.role.supplier-contact.propose",
            "questionKey": "domain.tprm.role.supplier-contact.question",
            "roleKey": "domain.tprm.role.supplier-contact.title"
          }
        ],
        "shortLabelKey": "domain.tprm.short",
        "signatureKey": "system.sentinel.signature",
        "version": "4.1.0",
        "wedgeKey": "domain.tprm.wedge",
        "workblockContract": {
          "accountableRoleIds": [
            "onboarding-coordinator",
            "supplier-master-steward",
            "accountable-risk-owner",
            "tprm-programme-owner",
            "supplier-contact"
          ],
          "authority": "Routine bounded actions execute inside versioned authority envelopes. Domain roles supervise outcomes, samples, exceptions and policy, and retain pause, stop, revoke, demote and rollback rights.",
          "completionEvidence": [
            "The selected business module records its observable completion evidence and every consequential receipt.",
            "Cross-module handoffs retain record identity, authority, provenance, freshness and qualified execution trace.",
            "Exceptions remain owned, recoverable and visible without turning routine work into a universal approval queue."
          ],
          "crossModuleOrchestration": "Business modules exchange typed owner commands and versioned events through GroundWorks records. Execution flows never share hidden in-memory state and retries never duplicate commitments.",
          "failureConsequence": "Committed state remains distinguishable from proposals and partial work. Last-good records stay visible, failed side effects reconcile, and an accountable domain role can pause, retry, reverse or reassign within policy.",
          "releaseBoundary": "The domain Workblock is the independently versioned product and interface boundary. A child Workblock exists only for a real release, credential, authority, scale, failure or reuse boundary.",
          "trigger": "A governed domain record, event, schedule or authorised request enters one of this Workblock's five business modules.",
          "ux": "One cohesive Workblock interface provides five business-module views, shared domain context, explicit state and authority, record drill-through, and truthful loading, empty, partial, stale, blocked, error and success states."
        }
      },
      {
        "businessModuleIds": [
          "guided-buying",
          "requisition-policy-routing",
          "purchase-order-orchestration",
          "purchase-order-exception",
          "receiving-service-entry"
        ],
        "buyerQuestionKey": "domain.buying.buyer-question",
        "changes": [
          {
            "afterKey": "domain.buying.change.exception-case.after",
            "beforeKey": "domain.buying.change.exception-case.before",
            "id": "exception",
            "titleKey": "domain.buying.change.exception-case.title"
          },
          {
            "afterKey": "domain.buying.change.graduated-attention.after",
            "beforeKey": "domain.buying.change.graduated-attention.before",
            "id": "graduated-attention",
            "titleKey": "domain.buying.change.graduated-attention.title"
          }
        ],
        "deepDive": true,
        "deepDivePrinciples": [
          {
            "bodyKey": "domain.buying.principle.proposal-not-order.body",
            "id": "proposal-not-order",
            "titleKey": "domain.buying.principle.proposal-not-order.title"
          },
          {
            "bodyKey": "domain.buying.principle.erp-keeps-transaction.body",
            "id": "erp-keeps-transaction",
            "titleKey": "domain.buying.principle.erp-keeps-transaction.title"
          },
          {
            "bodyKey": "domain.buying.principle.no-blind-retry.body",
            "id": "no-blind-retry",
            "titleKey": "domain.buying.principle.no-blind-retry.title"
          }
        ],
        "descriptionKey": "domain.buying.description",
        "descriptorKey": "system.buyline.descriptor",
        "icon": "shopping-cart",
        "id": "buying-ordering-receiving",
        "labelKey": "domain.buying.label",
        "nameKey": "system.buyline.name",
        "narrativeGapKeys": [
          "domain.buying.gap-1",
          "domain.buying.gap-2",
          "domain.buying.gap-3"
        ],
        "order": 6,
        "outcomeKey": "domain.buying.outcome",
        "previewBusinessModuleIds": [
          "guided-buying",
          "purchase-order-exception",
          "receiving-service-entry"
        ],
        "previewRoleIds": [
          "requester",
          "procurement-buyer",
          "receiver"
        ],
        "proofQuestionKey": "domain.buying.proof-question",
        "roleCards": [
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.buying.role.requester.alone",
            "commitKey": "domain.buying.role.requester.commit",
            "consultedBusinessModuleIds": [
              "purchase-order-exception",
              "requisition-policy-routing",
              "receiving-service-entry"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.buying.role.requester.hired",
            "id": "requester",
            "mandateKey": "domain.buying.role.requester.mandate",
            "measuredKey": "domain.buying.role.requester.measured",
            "performsBusinessModuleIds": [
              "guided-buying"
            ],
            "proposeKey": "domain.buying.role.requester.propose",
            "questionKey": "domain.buying.role.requester.question",
            "roleKey": "domain.buying.role.requester.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.buying.role.procurement-buyer.alone",
            "commitKey": "domain.buying.role.procurement-buyer.commit",
            "consultedBusinessModuleIds": [
              "receiving-service-entry"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.buying.role.procurement-buyer.hired",
            "id": "procurement-buyer",
            "mandateKey": "domain.buying.role.procurement-buyer.mandate",
            "measuredKey": "domain.buying.role.procurement-buyer.measured",
            "performsBusinessModuleIds": [
              "guided-buying",
              "purchase-order-exception",
              "requisition-policy-routing",
              "purchase-order-orchestration"
            ],
            "proposeKey": "domain.buying.role.procurement-buyer.propose",
            "questionKey": "domain.buying.role.procurement-buyer.question",
            "roleKey": "domain.buying.role.procurement-buyer.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.buying.role.budget-owner.alone",
            "commitKey": "domain.buying.role.budget-owner.commit",
            "consultedBusinessModuleIds": [
              "purchase-order-exception",
              "requisition-policy-routing"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.buying.role.budget-owner.hired",
            "id": "budget-owner",
            "mandateKey": "domain.buying.role.budget-owner.mandate",
            "measuredKey": "domain.buying.role.budget-owner.measured",
            "performsBusinessModuleIds": [
              "guided-buying"
            ],
            "proposeKey": "domain.buying.role.budget-owner.propose",
            "questionKey": "domain.buying.role.budget-owner.question",
            "roleKey": "domain.buying.role.budget-owner.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.buying.role.receiver.alone",
            "commitKey": "domain.buying.role.receiver.commit",
            "consultedBusinessModuleIds": [],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.buying.role.receiver.hired",
            "id": "receiver",
            "mandateKey": "domain.buying.role.receiver.mandate",
            "measuredKey": "domain.buying.role.receiver.measured",
            "performsBusinessModuleIds": [
              "purchase-order-exception",
              "receiving-service-entry"
            ],
            "proposeKey": "domain.buying.role.receiver.propose",
            "questionKey": "domain.buying.role.receiver.question",
            "roleKey": "domain.buying.role.receiver.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.buying.role.integration-owner.alone",
            "commitKey": "domain.buying.role.integration-owner.commit",
            "consultedBusinessModuleIds": [
              "guided-buying",
              "purchase-order-orchestration",
              "receiving-service-entry"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.buying.role.integration-owner.hired",
            "id": "integration-owner",
            "mandateKey": "domain.buying.role.integration-owner.mandate",
            "measuredKey": "domain.buying.role.integration-owner.measured",
            "performsBusinessModuleIds": [
              "purchase-order-exception"
            ],
            "proposeKey": "domain.buying.role.integration-owner.propose",
            "questionKey": "domain.buying.role.integration-owner.question",
            "roleKey": "domain.buying.role.integration-owner.title"
          }
        ],
        "shortLabelKey": "domain.buying.short",
        "signatureKey": "system.buyline.signature",
        "version": "4.1.0",
        "wedgeKey": "domain.buying.wedge",
        "workblockContract": {
          "accountableRoleIds": [
            "requester",
            "procurement-buyer",
            "budget-owner",
            "receiver",
            "integration-owner"
          ],
          "authority": "Routine bounded actions execute inside versioned authority envelopes. Domain roles supervise outcomes, samples, exceptions and policy, and retain pause, stop, revoke, demote and rollback rights.",
          "completionEvidence": [
            "The selected business module records its observable completion evidence and every consequential receipt.",
            "Cross-module handoffs retain record identity, authority, provenance, freshness and qualified execution trace.",
            "Exceptions remain owned, recoverable and visible without turning routine work into a universal approval queue."
          ],
          "crossModuleOrchestration": "Business modules exchange typed owner commands and versioned events through GroundWorks records. Execution flows never share hidden in-memory state and retries never duplicate commitments.",
          "failureConsequence": "Committed state remains distinguishable from proposals and partial work. Last-good records stay visible, failed side effects reconcile, and an accountable domain role can pause, retry, reverse or reassign within policy.",
          "releaseBoundary": "The domain Workblock is the independently versioned product and interface boundary. A child Workblock exists only for a real release, credential, authority, scale, failure or reuse boundary.",
          "trigger": "A governed domain record, event, schedule or authorised request enters one of this Workblock's five business modules.",
          "ux": "One cohesive Workblock interface provides five business-module views, shared domain context, explicit state and authority, record drill-through, and truthful loading, empty, partial, stale, blocked, error and success states."
        }
      },
      {
        "businessModuleIds": [
          "invoice-exception-triage",
          "payment-readiness",
          "invoice-intake-match",
          "supplier-invoice-resolution",
          "payment-execution-guard"
        ],
        "buyerQuestionKey": "domain.invoice.buyer-question",
        "changes": [
          {
            "afterKey": "domain.invoice.change.causal-case.after",
            "beforeKey": "domain.invoice.change.causal-case.before",
            "id": "causal-case",
            "titleKey": "domain.invoice.change.causal-case.title"
          },
          {
            "afterKey": "domain.invoice.change.dated-readiness.after",
            "beforeKey": "domain.invoice.change.dated-readiness.before",
            "id": "dated-readiness",
            "titleKey": "domain.invoice.change.dated-readiness.title"
          }
        ],
        "deepDive": true,
        "deepDivePrinciples": [
          {
            "bodyKey": "domain.invoice.principle.failure-vs-cause.body",
            "id": "failure-vs-cause",
            "titleKey": "domain.invoice.principle.failure-vs-cause.title"
          },
          {
            "bodyKey": "domain.invoice.principle.resolution-is-source-truth.body",
            "id": "resolution-is-source-truth",
            "titleKey": "domain.invoice.principle.resolution-is-source-truth.title"
          },
          {
            "bodyKey": "domain.invoice.principle.readiness-expires.body",
            "id": "readiness-expires",
            "titleKey": "domain.invoice.principle.readiness-expires.title"
          }
        ],
        "descriptionKey": "domain.invoice.description",
        "descriptorKey": "system.clearway.descriptor",
        "icon": "receipt",
        "id": "invoice-exception-payment-readiness",
        "labelKey": "domain.invoice.label",
        "nameKey": "system.clearway.name",
        "narrativeGapKeys": [
          "domain.invoice.gap-1",
          "domain.invoice.gap-2",
          "domain.invoice.gap-3"
        ],
        "order": 7,
        "outcomeKey": "domain.invoice.outcome",
        "previewBusinessModuleIds": [
          "invoice-exception-triage",
          "payment-readiness",
          "payment-execution-guard"
        ],
        "previewRoleIds": [
          "ap-processor",
          "controller",
          "payment-approver"
        ],
        "proofQuestionKey": "domain.invoice.proof-question",
        "roleCards": [
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.invoice.role.ap-processor.alone",
            "commitKey": "domain.invoice.role.ap-processor.commit",
            "consultedBusinessModuleIds": [
              "payment-readiness"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.invoice.role.ap-processor.hired",
            "id": "ap-processor",
            "mandateKey": "domain.invoice.role.ap-processor.mandate",
            "measuredKey": "domain.invoice.role.ap-processor.measured",
            "performsBusinessModuleIds": [
              "invoice-exception-triage",
              "invoice-intake-match",
              "supplier-invoice-resolution"
            ],
            "proposeKey": "domain.invoice.role.ap-processor.propose",
            "questionKey": "domain.invoice.role.ap-processor.question",
            "roleKey": "domain.invoice.role.ap-processor.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.invoice.role.controller.alone",
            "commitKey": "domain.invoice.role.controller.commit",
            "consultedBusinessModuleIds": [
              "invoice-exception-triage",
              "invoice-intake-match",
              "supplier-invoice-resolution",
              "payment-execution-guard"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.invoice.role.controller.hired",
            "id": "controller",
            "mandateKey": "domain.invoice.role.controller.mandate",
            "measuredKey": "domain.invoice.role.controller.measured",
            "performsBusinessModuleIds": [
              "payment-readiness"
            ],
            "proposeKey": "domain.invoice.role.controller.propose",
            "questionKey": "domain.invoice.role.controller.question",
            "roleKey": "domain.invoice.role.controller.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.invoice.role.payment-approver.alone",
            "commitKey": "domain.invoice.role.payment-approver.commit",
            "consultedBusinessModuleIds": [],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.invoice.role.payment-approver.hired",
            "id": "payment-approver",
            "mandateKey": "domain.invoice.role.payment-approver.mandate",
            "measuredKey": "domain.invoice.role.payment-approver.measured",
            "performsBusinessModuleIds": [
              "payment-readiness",
              "payment-execution-guard"
            ],
            "proposeKey": "domain.invoice.role.payment-approver.propose",
            "questionKey": "domain.invoice.role.payment-approver.question",
            "roleKey": "domain.invoice.role.payment-approver.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.invoice.role.treasury-manager.alone",
            "commitKey": "domain.invoice.role.treasury-manager.commit",
            "consultedBusinessModuleIds": [
              "payment-readiness",
              "payment-execution-guard"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.invoice.role.treasury-manager.hired",
            "id": "treasury-manager",
            "mandateKey": "domain.invoice.role.treasury-manager.mandate",
            "measuredKey": "domain.invoice.role.treasury-manager.measured",
            "performsBusinessModuleIds": [],
            "proposeKey": "domain.invoice.role.treasury-manager.propose",
            "questionKey": "domain.invoice.role.treasury-manager.question",
            "roleKey": "domain.invoice.role.treasury-manager.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.invoice.role.risk-owner.alone",
            "commitKey": "domain.invoice.role.risk-owner.commit",
            "consultedBusinessModuleIds": [
              "payment-readiness",
              "invoice-exception-triage",
              "invoice-intake-match",
              "payment-execution-guard"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.invoice.role.risk-owner.hired",
            "id": "risk-owner",
            "mandateKey": "domain.invoice.role.risk-owner.mandate",
            "measuredKey": "domain.invoice.role.risk-owner.measured",
            "performsBusinessModuleIds": [],
            "proposeKey": "domain.invoice.role.risk-owner.propose",
            "questionKey": "domain.invoice.role.risk-owner.question",
            "roleKey": "domain.invoice.role.risk-owner.title"
          }
        ],
        "shortLabelKey": "domain.invoice.short",
        "signatureKey": "system.clearway.signature",
        "version": "4.1.0",
        "wedgeKey": "domain.invoice.wedge",
        "workblockContract": {
          "accountableRoleIds": [
            "ap-processor",
            "controller",
            "payment-approver",
            "treasury-manager",
            "risk-owner"
          ],
          "authority": "Routine bounded actions execute inside versioned authority envelopes. Domain roles supervise outcomes, samples, exceptions and policy, and retain pause, stop, revoke, demote and rollback rights.",
          "completionEvidence": [
            "The selected business module records its observable completion evidence and every consequential receipt.",
            "Cross-module handoffs retain record identity, authority, provenance, freshness and qualified execution trace.",
            "Exceptions remain owned, recoverable and visible without turning routine work into a universal approval queue."
          ],
          "crossModuleOrchestration": "Business modules exchange typed owner commands and versioned events through GroundWorks records. Execution flows never share hidden in-memory state and retries never duplicate commitments.",
          "failureConsequence": "Committed state remains distinguishable from proposals and partial work. Last-good records stay visible, failed side effects reconcile, and an accountable domain role can pause, retry, reverse or reassign within policy.",
          "releaseBoundary": "The domain Workblock is the independently versioned product and interface boundary. A child Workblock exists only for a real release, credential, authority, scale, failure or reuse boundary.",
          "trigger": "A governed domain record, event, schedule or authorised request enters one of this Workblock's five business modules.",
          "ux": "One cohesive Workblock interface provides five business-module views, shared domain context, explicit state and authority, record drill-through, and truthful loading, empty, partial, stale, blocked, error and success states."
        }
      },
      {
        "businessModuleIds": [
          "supplier-performance-review",
          "supplier-innovation-pipeline",
          "supplier-segmentation-governance",
          "supplier-performance-monitor-correct",
          "supplier-relationship-joint-value"
        ],
        "buyerQuestionKey": "domain.performance.buyer-question",
        "changes": [
          {
            "afterKey": "domain.performance.change.decision-package.after",
            "beforeKey": "domain.performance.change.decision-package.before",
            "id": "decision-package",
            "titleKey": "domain.performance.change.decision-package.title"
          },
          {
            "afterKey": "domain.performance.change.accepted-commitments.after",
            "beforeKey": "domain.performance.change.accepted-commitments.before",
            "id": "accepted-commitments",
            "titleKey": "domain.performance.change.accepted-commitments.title"
          }
        ],
        "deepDive": true,
        "deepDivePrinciples": [
          {
            "bodyKey": "domain.performance.principle.five-records.body",
            "id": "five-records",
            "titleKey": "domain.performance.principle.five-records.title"
          },
          {
            "bodyKey": "domain.performance.principle.critical-exception.body",
            "id": "critical-exception",
            "titleKey": "domain.performance.principle.critical-exception.title"
          },
          {
            "bodyKey": "domain.performance.principle.interest-not-commitment.body",
            "id": "interest-not-commitment",
            "titleKey": "domain.performance.principle.interest-not-commitment.title"
          }
        ],
        "descriptionKey": "domain.performance.description",
        "descriptorKey": "system.alliance.descriptor",
        "icon": "handshake",
        "id": "supplier-performance-innovation-relationship",
        "labelKey": "domain.performance.label",
        "nameKey": "system.alliance.name",
        "narrativeGapKeys": [
          "domain.performance.gap-1",
          "domain.performance.gap-2",
          "domain.performance.gap-3"
        ],
        "order": 8,
        "outcomeKey": "domain.performance.outcome",
        "previewBusinessModuleIds": [
          "supplier-performance-review",
          "supplier-performance-monitor-correct",
          "supplier-relationship-joint-value"
        ],
        "previewRoleIds": [
          "relationship-manager",
          "metric-owner",
          "supplier-account-lead"
        ],
        "proofQuestionKey": "domain.performance.proof-question",
        "roleCards": [
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.performance.role.relationship-manager.alone",
            "commitKey": "domain.performance.role.relationship-manager.commit",
            "consultedBusinessModuleIds": [
              "supplier-innovation-pipeline",
              "supplier-segmentation-governance",
              "supplier-performance-monitor-correct"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.performance.role.relationship-manager.hired",
            "id": "relationship-manager",
            "mandateKey": "domain.performance.role.relationship-manager.mandate",
            "measuredKey": "domain.performance.role.relationship-manager.measured",
            "performsBusinessModuleIds": [
              "supplier-performance-review",
              "supplier-relationship-joint-value"
            ],
            "proposeKey": "domain.performance.role.relationship-manager.propose",
            "questionKey": "domain.performance.role.relationship-manager.question",
            "roleKey": "domain.performance.role.relationship-manager.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.performance.role.governance-owner.alone",
            "commitKey": "domain.performance.role.governance-owner.commit",
            "consultedBusinessModuleIds": [
              "supplier-performance-review",
              "supplier-innovation-pipeline",
              "supplier-performance-monitor-correct",
              "supplier-relationship-joint-value"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.performance.role.governance-owner.hired",
            "id": "governance-owner",
            "mandateKey": "domain.performance.role.governance-owner.mandate",
            "measuredKey": "domain.performance.role.governance-owner.measured",
            "performsBusinessModuleIds": [
              "supplier-segmentation-governance"
            ],
            "proposeKey": "domain.performance.role.governance-owner.propose",
            "questionKey": "domain.performance.role.governance-owner.question",
            "roleKey": "domain.performance.role.governance-owner.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.performance.role.metric-owner.alone",
            "commitKey": "domain.performance.role.metric-owner.commit",
            "consultedBusinessModuleIds": [
              "supplier-performance-review",
              "supplier-segmentation-governance",
              "supplier-relationship-joint-value"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.performance.role.metric-owner.hired",
            "id": "metric-owner",
            "mandateKey": "domain.performance.role.metric-owner.mandate",
            "measuredKey": "domain.performance.role.metric-owner.measured",
            "performsBusinessModuleIds": [
              "supplier-performance-monitor-correct"
            ],
            "proposeKey": "domain.performance.role.metric-owner.propose",
            "questionKey": "domain.performance.role.metric-owner.question",
            "roleKey": "domain.performance.role.metric-owner.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.performance.role.supplier-account-lead.alone",
            "commitKey": "domain.performance.role.supplier-account-lead.commit",
            "consultedBusinessModuleIds": [
              "supplier-performance-review",
              "supplier-innovation-pipeline",
              "supplier-performance-monitor-correct",
              "supplier-relationship-joint-value"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.performance.role.supplier-account-lead.hired",
            "id": "supplier-account-lead",
            "mandateKey": "domain.performance.role.supplier-account-lead.mandate",
            "measuredKey": "domain.performance.role.supplier-account-lead.measured",
            "performsBusinessModuleIds": [],
            "proposeKey": "domain.performance.role.supplier-account-lead.propose",
            "questionKey": "domain.performance.role.supplier-account-lead.question",
            "roleKey": "domain.performance.role.supplier-account-lead.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.performance.role.innovation-sponsor.alone",
            "commitKey": "domain.performance.role.innovation-sponsor.commit",
            "consultedBusinessModuleIds": [
              "supplier-relationship-joint-value"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.performance.role.innovation-sponsor.hired",
            "id": "innovation-sponsor",
            "mandateKey": "domain.performance.role.innovation-sponsor.mandate",
            "measuredKey": "domain.performance.role.innovation-sponsor.measured",
            "performsBusinessModuleIds": [
              "supplier-innovation-pipeline"
            ],
            "proposeKey": "domain.performance.role.innovation-sponsor.propose",
            "questionKey": "domain.performance.role.innovation-sponsor.question",
            "roleKey": "domain.performance.role.innovation-sponsor.title"
          }
        ],
        "shortLabelKey": "domain.performance.short",
        "signatureKey": "system.alliance.signature",
        "version": "4.1.0",
        "wedgeKey": "domain.performance.wedge",
        "workblockContract": {
          "accountableRoleIds": [
            "relationship-manager",
            "governance-owner",
            "metric-owner",
            "supplier-account-lead",
            "innovation-sponsor"
          ],
          "authority": "Routine bounded actions execute inside versioned authority envelopes. Domain roles supervise outcomes, samples, exceptions and policy, and retain pause, stop, revoke, demote and rollback rights.",
          "completionEvidence": [
            "The selected business module records its observable completion evidence and every consequential receipt.",
            "Cross-module handoffs retain record identity, authority, provenance, freshness and qualified execution trace.",
            "Exceptions remain owned, recoverable and visible without turning routine work into a universal approval queue."
          ],
          "crossModuleOrchestration": "Business modules exchange typed owner commands and versioned events through GroundWorks records. Execution flows never share hidden in-memory state and retries never duplicate commitments.",
          "failureConsequence": "Committed state remains distinguishable from proposals and partial work. Last-good records stay visible, failed side effects reconcile, and an accountable domain role can pause, retry, reverse or reassign within policy.",
          "releaseBoundary": "The domain Workblock is the independently versioned product and interface boundary. A child Workblock exists only for a real release, credential, authority, scale, failure or reuse boundary.",
          "trigger": "A governed domain record, event, schedule or authorised request enters one of this Workblock's five business modules.",
          "ux": "One cohesive Workblock interface provides five business-module views, shared domain context, explicit state and authority, record drill-through, and truthful loading, empty, partial, stale, blocked, error and success states."
        }
      },
      {
        "businessModuleIds": [
          "savings-initiative",
          "value-leakage-monitor",
          "value-opportunity-baseline",
          "realization-reconciliation-attribution",
          "value-portfolio-forecast"
        ],
        "buyerQuestionKey": "domain.value.buyer-question",
        "changes": [
          {
            "afterKey": "domain.value.change.worked-case.after",
            "beforeKey": "domain.value.change.worked-case.before",
            "id": "worked-case",
            "titleKey": "domain.value.change.worked-case.title"
          },
          {
            "afterKey": "domain.value.change.causal-case.after",
            "beforeKey": "domain.value.change.causal-case.before",
            "id": "causal-case",
            "titleKey": "domain.value.change.causal-case.title"
          }
        ],
        "deepDive": true,
        "deepDivePrinciples": [
          {
            "bodyKey": "domain.value.principle.separate-states.body",
            "id": "separate-states",
            "titleKey": "domain.value.principle.separate-states.title"
          },
          {
            "bodyKey": "domain.value.principle.definition-before-number.body",
            "id": "definition-before-number",
            "titleKey": "domain.value.principle.definition-before-number.title"
          },
          {
            "bodyKey": "domain.value.principle.variance-into-action.body",
            "id": "variance-into-action",
            "titleKey": "domain.value.principle.variance-into-action.title"
          }
        ],
        "descriptionKey": "domain.value.description",
        "descriptorKey": "system.value-hunter.descriptor",
        "icon": "trending-up",
        "id": "value-realization-savings",
        "labelKey": "domain.value.label",
        "nameKey": "system.value-hunter.name",
        "narrativeGapKeys": [
          "domain.value.gap-1",
          "domain.value.gap-2",
          "domain.value.gap-3"
        ],
        "order": 9,
        "outcomeKey": "domain.value.outcome",
        "previewBusinessModuleIds": [
          "savings-initiative",
          "realization-reconciliation-attribution",
          "value-portfolio-forecast"
        ],
        "previewRoleIds": [
          "value-lead",
          "finance-delegate",
          "category-manager"
        ],
        "proofQuestionKey": "domain.value.proof-question",
        "roleCards": [
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.value.role.value-lead.alone",
            "commitKey": "domain.value.role.value-lead.commit",
            "consultedBusinessModuleIds": [
              "realization-reconciliation-attribution"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.value.role.value-lead.hired",
            "id": "value-lead",
            "mandateKey": "domain.value.role.value-lead.mandate",
            "measuredKey": "domain.value.role.value-lead.measured",
            "performsBusinessModuleIds": [
              "savings-initiative",
              "value-leakage-monitor",
              "value-opportunity-baseline",
              "value-portfolio-forecast"
            ],
            "proposeKey": "domain.value.role.value-lead.propose",
            "questionKey": "domain.value.role.value-lead.question",
            "roleKey": "domain.value.role.value-lead.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.value.role.finance-delegate.alone",
            "commitKey": "domain.value.role.finance-delegate.commit",
            "consultedBusinessModuleIds": [
              "value-leakage-monitor",
              "value-opportunity-baseline",
              "value-portfolio-forecast"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.value.role.finance-delegate.hired",
            "id": "finance-delegate",
            "mandateKey": "domain.value.role.finance-delegate.mandate",
            "measuredKey": "domain.value.role.finance-delegate.measured",
            "performsBusinessModuleIds": [
              "savings-initiative",
              "realization-reconciliation-attribution"
            ],
            "proposeKey": "domain.value.role.finance-delegate.propose",
            "questionKey": "domain.value.role.finance-delegate.question",
            "roleKey": "domain.value.role.finance-delegate.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.value.role.category-manager.alone",
            "commitKey": "domain.value.role.category-manager.commit",
            "consultedBusinessModuleIds": [
              "value-leakage-monitor",
              "value-opportunity-baseline",
              "realization-reconciliation-attribution",
              "value-portfolio-forecast"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.value.role.category-manager.hired",
            "id": "category-manager",
            "mandateKey": "domain.value.role.category-manager.mandate",
            "measuredKey": "domain.value.role.category-manager.measured",
            "performsBusinessModuleIds": [
              "savings-initiative"
            ],
            "proposeKey": "domain.value.role.category-manager.propose",
            "questionKey": "domain.value.role.category-manager.question",
            "roleKey": "domain.value.role.category-manager.title"
          },
          {
            "actionClasses": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct"
            ],
            "aloneKey": "domain.value.role.budget-owner.alone",
            "commitKey": "domain.value.role.budget-owner.commit",
            "consultedBusinessModuleIds": [
              "savings-initiative",
              "value-leakage-monitor",
              "value-opportunity-baseline",
              "realization-reconciliation-attribution",
              "value-portfolio-forecast"
            ],
            "escalationActionClasses": [
              "approve",
              "commit",
              "correct"
            ],
            "hiredKey": "domain.value.role.budget-owner.hired",
            "id": "budget-owner",
            "mandateKey": "domain.value.role.budget-owner.mandate",
            "measuredKey": "domain.value.role.budget-owner.measured",
            "performsBusinessModuleIds": [],
            "proposeKey": "domain.value.role.budget-owner.propose",
            "questionKey": "domain.value.role.budget-owner.question",
            "roleKey": "domain.value.role.budget-owner.title",
            "usesContextualLabel": true
          }
        ],
        "shortLabelKey": "domain.value.short",
        "signatureKey": "system.value-hunter.signature",
        "version": "4.1.0",
        "wedgeKey": "domain.value.wedge",
        "workblockContract": {
          "accountableRoleIds": [
            "value-lead",
            "finance-delegate",
            "category-manager",
            "budget-owner"
          ],
          "authority": "Routine bounded actions execute inside versioned authority envelopes. Domain roles supervise outcomes, samples, exceptions and policy, and retain pause, stop, revoke, demote and rollback rights.",
          "completionEvidence": [
            "The selected business module records its observable completion evidence and every consequential receipt.",
            "Cross-module handoffs retain record identity, authority, provenance, freshness and qualified execution trace.",
            "Exceptions remain owned, recoverable and visible without turning routine work into a universal approval queue."
          ],
          "crossModuleOrchestration": "Business modules exchange typed owner commands and versioned events through GroundWorks records. Execution flows never share hidden in-memory state and retries never duplicate commitments.",
          "failureConsequence": "Committed state remains distinguishable from proposals and partial work. Last-good records stay visible, failed side effects reconcile, and an accountable domain role can pause, retry, reverse or reassign within policy.",
          "releaseBoundary": "The domain Workblock is the independently versioned product and interface boundary. A child Workblock exists only for a real release, credential, authority, scale, failure or reuse boundary.",
          "trigger": "A governed domain record, event, schedule or authorised request enters one of this Workblock's five business modules.",
          "ux": "One cohesive Workblock interface provides five business-module views, shared domain context, explicit state and authority, record drill-through, and truthful loading, empty, partial, stale, blocked, error and success states."
        }
      }
    ],
    "editorialStories": [
      {
        "agentIds": [
          "raw-material-demand-agent",
          "specification-harmonisation-agent",
          "commodity-price-outlook-agent",
          "coverage-position-agent",
          "buy-timing-agent",
          "landed-cost-agent",
          "carbon-compliance-agent",
          "supplier-quality-prediction-agent",
          "margin-tradeoff-agent"
        ],
        "businessModuleIds": [
          "demand-consolidation-portfolio",
          "category-opportunity-radar",
          "sourcing-pipeline-discovery",
          "bid-evaluation-award",
          "supplier-master-qualification",
          "value-portfolio-forecast"
        ],
        "capabilityMapId": "accenture-direct-material",
        "chapters": [
          {
            "authorityKey": "editorial-story.direct-material-economics.chapter.normalize-demand.authority",
            "bodyKey": "editorial-story.direct-material-economics.chapter.normalize-demand.body",
            "businessModuleIds": [
              "demand-consolidation-portfolio"
            ],
            "executionFlowIds": [
              "signal-raw-material-demand",
              "harmonise-material-specifications"
            ],
            "handoffKey": "editorial-story.direct-material-economics.chapter.normalize-demand.handoff",
            "id": "normalize-demand",
            "ownerRoleId": "demand-owner",
            "recordEntityIds": [
              "demand-portfolio",
              "item-service"
            ],
            "titleKey": "editorial-story.direct-material-economics.chapter.normalize-demand.title"
          },
          {
            "authorityKey": "editorial-story.direct-material-economics.chapter.observe-price-and-coverage.authority",
            "bodyKey": "editorial-story.direct-material-economics.chapter.observe-price-and-coverage.body",
            "businessModuleIds": [
              "category-opportunity-radar",
              "demand-consolidation-portfolio"
            ],
            "executionFlowIds": [
              "project-commodity-price-outlook",
              "monitor-coverage-position"
            ],
            "handoffKey": "editorial-story.direct-material-economics.chapter.observe-price-and-coverage.handoff",
            "id": "observe-price-and-coverage",
            "ownerRoleId": "category-manager",
            "recordEntityIds": [
              "category-opportunity",
              "demand-portfolio"
            ],
            "titleKey": "editorial-story.direct-material-economics.chapter.observe-price-and-coverage.title"
          },
          {
            "authorityKey": "editorial-story.direct-material-economics.chapter.propose-buy-timing.authority",
            "bodyKey": "editorial-story.direct-material-economics.chapter.propose-buy-timing.body",
            "businessModuleIds": [
              "sourcing-pipeline-discovery"
            ],
            "executionFlowIds": [
              "mandate-buy-timing"
            ],
            "handoffKey": "editorial-story.direct-material-economics.chapter.propose-buy-timing.handoff",
            "id": "propose-buy-timing",
            "ownerRoleId": "sourcing-lead",
            "recordEntityIds": [
              "sourcing-opportunity",
              "authority-envelope"
            ],
            "titleKey": "editorial-story.direct-material-economics.chapter.propose-buy-timing.title"
          },
          {
            "authorityKey": "editorial-story.direct-material-economics.chapter.compare-landed-cost-and-carbon.authority",
            "bodyKey": "editorial-story.direct-material-economics.chapter.compare-landed-cost-and-carbon.body",
            "businessModuleIds": [
              "bid-evaluation-award",
              "supplier-master-qualification"
            ],
            "executionFlowIds": [
              "optimize-landed-cost",
              "verify-carbon-cost-compliance"
            ],
            "handoffKey": "editorial-story.direct-material-economics.chapter.compare-landed-cost-and-carbon.handoff",
            "id": "compare-landed-cost-and-carbon",
            "ownerRoleId": "evaluator",
            "recordEntityIds": [
              "award-scenario",
              "supplier-risk-assessment"
            ],
            "titleKey": "editorial-story.direct-material-economics.chapter.compare-landed-cost-and-carbon.title"
          },
          {
            "authorityKey": "editorial-story.direct-material-economics.chapter.retain-quality-and-margin-evidence.authority",
            "bodyKey": "editorial-story.direct-material-economics.chapter.retain-quality-and-margin-evidence.body",
            "businessModuleIds": [
              "supplier-master-qualification",
              "value-portfolio-forecast"
            ],
            "executionFlowIds": [
              "predict-supplier-quality",
              "arbitrate-margin-tradeoffs"
            ],
            "handoffKey": "editorial-story.direct-material-economics.chapter.retain-quality-and-margin-evidence.handoff",
            "id": "retain-quality-and-margin-evidence",
            "ownerRoleId": "value-lead",
            "recordEntityIds": [
              "value-portfolio-forecast",
              "supplier-performance-observation"
            ],
            "titleKey": "editorial-story.direct-material-economics.chapter.retain-quality-and-margin-evidence.title"
          }
        ],
        "domainWorkblockIds": [
          "intake-demand",
          "strategy-policy-category-spend",
          "sourcing-negotiation",
          "supplier-lifecycle-third-party-risk",
          "value-realization-savings"
        ],
        "executionFlowIds": [
          "signal-raw-material-demand",
          "harmonise-material-specifications",
          "project-commodity-price-outlook",
          "monitor-coverage-position",
          "mandate-buy-timing",
          "optimize-landed-cost",
          "verify-carbon-cost-compliance",
          "predict-supplier-quality",
          "arbitrate-margin-tradeoffs"
        ],
        "id": "direct-material-economics",
        "kickerKey": "editorial-story.direct-material-economics.kicker",
        "namedQueryIds": [
          "query-demand-consolidation-portfolio-read-item-service",
          "query-demand-consolidation-portfolio-read-contract-entitlement",
          "query-sourcing-pipeline-discovery-read-authority-envelope",
          "query-bid-evaluation-award-read-supplier-risk-assessment",
          "query-supplier-master-qualification-read-evidence-item",
          "query-supplier-master-qualification-read-supplier-performance-observation",
          "query-value-portfolio-forecast-read-award-scenario"
        ],
        "outcomeKey": "editorial-story.direct-material-economics.outcome",
        "resourceIds": [
          "direct-material-economics-framework-brief"
        ],
        "spendSegmentId": "direct",
        "summaryKey": "editorial-story.direct-material-economics.summary",
        "systemBoundaryKey": "editorial-story.direct-material-economics.system-boundary",
        "systemProfileIds": [
          "sap-ibp",
          "market-price-and-commodity-data"
        ],
        "titleKey": "editorial-story.direct-material-economics.title",
        "version": "1.0.0",
        "workMomentId": "direct-material-buy-timing"
      },
      {
        "agentIds": [
          "catalogue-coverage-agent",
          "channel-drift-agent",
          "tail-spend-consolidation-agent",
          "spot-buy-conversion-agent",
          "price-variance-agent",
          "payment-terms-agent"
        ],
        "businessModuleIds": [
          "intelligent-intake",
          "guided-buying",
          "policy-rule-lifecycle",
          "category-opportunity-radar",
          "tactical-sourcing-autonomy",
          "value-leakage-monitor",
          "payment-readiness"
        ],
        "capabilityMapId": "accenture-indirect-buying",
        "chapters": [
          {
            "authorityKey": "editorial-story.indirect-buying.chapter.route-the-request.authority",
            "bodyKey": "editorial-story.indirect-buying.chapter.route-the-request.body",
            "businessModuleIds": [
              "intelligent-intake",
              "guided-buying"
            ],
            "executionFlowIds": [
              "understand-intake-request",
              "assess-catalogue-coverage"
            ],
            "handoffKey": "editorial-story.indirect-buying.chapter.route-the-request.handoff",
            "id": "route-the-request",
            "ownerRoleId": "procurement-buyer",
            "recordEntityIds": [
              "intake-request",
              "buying-request"
            ],
            "titleKey": "editorial-story.indirect-buying.chapter.route-the-request.title"
          },
          {
            "authorityKey": "editorial-story.indirect-buying.chapter.hold-the-channel.authority",
            "bodyKey": "editorial-story.indirect-buying.chapter.hold-the-channel.body",
            "businessModuleIds": [
              "policy-rule-lifecycle"
            ],
            "executionFlowIds": [
              "monitor-channel-drift"
            ],
            "handoffKey": "editorial-story.indirect-buying.chapter.hold-the-channel.handoff",
            "id": "hold-the-channel",
            "ownerRoleId": "policy-owner",
            "recordEntityIds": [
              "requisition",
              "spend-record"
            ],
            "titleKey": "editorial-story.indirect-buying.chapter.hold-the-channel.title"
          },
          {
            "authorityKey": "editorial-story.indirect-buying.chapter.consolidate-the-tail.authority",
            "bodyKey": "editorial-story.indirect-buying.chapter.consolidate-the-tail.body",
            "businessModuleIds": [
              "category-opportunity-radar"
            ],
            "executionFlowIds": [
              "surface-tail-consolidation-opportunities"
            ],
            "handoffKey": "editorial-story.indirect-buying.chapter.consolidate-the-tail.handoff",
            "id": "consolidate-the-tail",
            "ownerRoleId": "category-manager",
            "recordEntityIds": [
              "tail-spend-evaluation",
              "category-opportunity"
            ],
            "titleKey": "editorial-story.indirect-buying.chapter.consolidate-the-tail.title"
          },
          {
            "authorityKey": "editorial-story.indirect-buying.chapter.convert-repeat-buys.authority",
            "bodyKey": "editorial-story.indirect-buying.chapter.convert-repeat-buys.body",
            "businessModuleIds": [
              "tactical-sourcing-autonomy"
            ],
            "executionFlowIds": [
              "convert-repeat-spot-buys"
            ],
            "handoffKey": "editorial-story.indirect-buying.chapter.convert-repeat-buys.handoff",
            "id": "convert-repeat-buys",
            "ownerRoleId": "sourcing-lead",
            "recordEntityIds": [
              "sourcing-opportunity",
              "contract-entitlement"
            ],
            "titleKey": "editorial-story.indirect-buying.chapter.convert-repeat-buys.title"
          },
          {
            "authorityKey": "editorial-story.indirect-buying.chapter.guard-the-contract-price.authority",
            "bodyKey": "editorial-story.indirect-buying.chapter.guard-the-contract-price.body",
            "businessModuleIds": [
              "value-leakage-monitor"
            ],
            "executionFlowIds": [
              "detect-off-contract-price-variance"
            ],
            "handoffKey": "editorial-story.indirect-buying.chapter.guard-the-contract-price.handoff",
            "id": "guard-the-contract-price",
            "ownerRoleId": "value-lead",
            "recordEntityIds": [
              "purchase-order",
              "invoice"
            ],
            "titleKey": "editorial-story.indirect-buying.chapter.guard-the-contract-price.title"
          },
          {
            "authorityKey": "editorial-story.indirect-buying.chapter.position-the-payment.authority",
            "bodyKey": "editorial-story.indirect-buying.chapter.position-the-payment.body",
            "businessModuleIds": [
              "payment-readiness"
            ],
            "executionFlowIds": [
              "assess-payment-terms-position"
            ],
            "handoffKey": "editorial-story.indirect-buying.chapter.position-the-payment.handoff",
            "id": "position-the-payment",
            "ownerRoleId": "treasury-manager",
            "recordEntityIds": [
              "invoice",
              "contract-entitlement"
            ],
            "titleKey": "editorial-story.indirect-buying.chapter.position-the-payment.title"
          }
        ],
        "domainWorkblockIds": [
          "intake-demand",
          "strategy-policy-category-spend",
          "sourcing-negotiation",
          "buying-ordering-receiving",
          "value-realization-savings",
          "invoice-exception-payment-readiness"
        ],
        "executionFlowIds": [
          "understand-intake-request",
          "assess-catalogue-coverage",
          "monitor-channel-drift",
          "surface-tail-consolidation-opportunities",
          "convert-repeat-spot-buys",
          "detect-off-contract-price-variance",
          "assess-payment-terms-position"
        ],
        "id": "indirect-buying",
        "kickerKey": "editorial-story.indirect-buying.kicker",
        "namedQueryIds": [
          "query-category-opportunity-radar-read-buying-request",
          "query-policy-rule-lifecycle-read-requisition",
          "query-guided-buying-read-contract-entitlement",
          "query-tactical-sourcing-autonomy-read-tail-spend-evaluation",
          "query-payment-readiness-read-contract-entitlement",
          "query-value-leakage-monitor-read-purchase-order"
        ],
        "outcomeKey": "editorial-story.indirect-buying.outcome",
        "resourceIds": [
          "indirect-buying-framework-brief"
        ],
        "spendSegmentId": "indirect",
        "summaryKey": "editorial-story.indirect-buying.summary",
        "systemBoundaryKey": "editorial-story.indirect-buying.system-boundary",
        "systemProfileIds": [
          "sap-ariba-suite",
          "coupa",
          "amazon-business"
        ],
        "titleKey": "editorial-story.indirect-buying.title",
        "version": "1.0.0",
        "workMomentId": "tail-spend-consolidation"
      },
      {
        "agentIds": [
          "value-leakage-agent",
          "price-variance-agent",
          "contract-change-agent",
          "coverage-position-agent",
          "raw-material-demand-agent",
          "buy-timing-agent",
          "value-portfolio-agent"
        ],
        "businessModuleIds": [
          "demand-consolidation-portfolio",
          "sourcing-pipeline-discovery",
          "renewal-change-compliance",
          "value-leakage-monitor",
          "value-portfolio-forecast"
        ],
        "capabilityMapId": "accenture-s2p-master",
        "chapters": [
          {
            "authorityKey": "editorial-story.compounding-intelligence.chapter.read-the-terms.authority",
            "bodyKey": "editorial-story.compounding-intelligence.chapter.read-the-terms.body",
            "businessModuleIds": [
              "value-leakage-monitor"
            ],
            "executionFlowIds": [
              "detect-value-leakage"
            ],
            "handoffKey": "editorial-story.compounding-intelligence.chapter.read-the-terms.handoff",
            "id": "read-the-terms",
            "ownerRoleId": "value-lead",
            "recordEntityIds": [
              "contract-entitlement",
              "value-leakage-finding"
            ],
            "titleKey": "editorial-story.compounding-intelligence.chapter.read-the-terms.title"
          },
          {
            "authorityKey": "editorial-story.compounding-intelligence.chapter.price-the-leakage.authority",
            "bodyKey": "editorial-story.compounding-intelligence.chapter.price-the-leakage.body",
            "businessModuleIds": [
              "value-leakage-monitor"
            ],
            "executionFlowIds": [
              "detect-off-contract-price-variance"
            ],
            "handoffKey": "editorial-story.compounding-intelligence.chapter.price-the-leakage.handoff",
            "id": "price-the-leakage",
            "ownerRoleId": "controller",
            "recordEntityIds": [
              "purchase-order",
              "invoice",
              "value-leakage-finding"
            ],
            "titleKey": "editorial-story.compounding-intelligence.chapter.price-the-leakage.title"
          },
          {
            "authorityKey": "editorial-story.compounding-intelligence.chapter.time-the-renewal.authority",
            "bodyKey": "editorial-story.compounding-intelligence.chapter.time-the-renewal.body",
            "businessModuleIds": [
              "renewal-change-compliance",
              "demand-consolidation-portfolio"
            ],
            "executionFlowIds": [
              "detect-window-or-variance",
              "analyse-options",
              "monitor-coverage-position"
            ],
            "handoffKey": "editorial-story.compounding-intelligence.chapter.time-the-renewal.handoff",
            "id": "time-the-renewal",
            "ownerRoleId": "contract-manager",
            "recordEntityIds": [
              "contract",
              "contract-change",
              "demand-portfolio"
            ],
            "titleKey": "editorial-story.compounding-intelligence.chapter.time-the-renewal.title"
          },
          {
            "authorityKey": "editorial-story.compounding-intelligence.chapter.prepare-the-mandate.authority",
            "bodyKey": "editorial-story.compounding-intelligence.chapter.prepare-the-mandate.body",
            "businessModuleIds": [
              "demand-consolidation-portfolio",
              "sourcing-pipeline-discovery"
            ],
            "executionFlowIds": [
              "signal-raw-material-demand",
              "mandate-buy-timing"
            ],
            "handoffKey": "editorial-story.compounding-intelligence.chapter.prepare-the-mandate.handoff",
            "id": "prepare-the-mandate",
            "ownerRoleId": "sourcing-lead",
            "recordEntityIds": [
              "demand-portfolio",
              "sourcing-opportunity",
              "authority-envelope"
            ],
            "titleKey": "editorial-story.compounding-intelligence.chapter.prepare-the-mandate.title"
          },
          {
            "authorityKey": "editorial-story.compounding-intelligence.chapter.bank-the-value.authority",
            "bodyKey": "editorial-story.compounding-intelligence.chapter.bank-the-value.body",
            "businessModuleIds": [
              "value-portfolio-forecast"
            ],
            "executionFlowIds": [
              "refresh-value-forecast"
            ],
            "handoffKey": "editorial-story.compounding-intelligence.chapter.bank-the-value.handoff",
            "id": "bank-the-value",
            "ownerRoleId": "value-lead",
            "recordEntityIds": [
              "value-opportunity-baseline",
              "value-realization-attribution"
            ],
            "titleKey": "editorial-story.compounding-intelligence.chapter.bank-the-value.title"
          }
        ],
        "domainWorkblockIds": [
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "value-realization-savings"
        ],
        "executionFlowIds": [
          "detect-value-leakage",
          "detect-off-contract-price-variance",
          "monitor-coverage-position",
          "detect-window-or-variance",
          "analyse-options",
          "signal-raw-material-demand",
          "mandate-buy-timing",
          "refresh-value-forecast"
        ],
        "id": "compounding-intelligence",
        "kickerKey": "editorial-story.compounding-intelligence.kicker",
        "namedQueryIds": [
          "query-value-leakage-monitor-read-value-opportunity-baseline",
          "query-renewal-change-compliance-read-contract-entitlement",
          "query-demand-consolidation-portfolio-read-demand-portfolio",
          "query-sourcing-pipeline-discovery-read-authority-envelope",
          "query-value-portfolio-forecast-read-value-realization-attribution"
        ],
        "outcomeKey": "editorial-story.compounding-intelligence.outcome",
        "resourceIds": [
          "compounding-intelligence-framework-brief"
        ],
        "spendSegmentId": "direct",
        "summaryKey": "editorial-story.compounding-intelligence.summary",
        "systemBoundaryKey": "editorial-story.compounding-intelligence.system-boundary",
        "systemProfileIds": [
          "sap-s4hana-ecc",
          "sap-ibp"
        ],
        "titleKey": "editorial-story.compounding-intelligence.title",
        "version": "1.0.0",
        "workMomentId": "direct-material-buy-timing"
      },
      {
        "agentIds": [
          "coverage-position-agent",
          "commodity-price-outlook-agent",
          "contract-change-agent",
          "supplier-risk-monitor-agent"
        ],
        "businessModuleIds": [
          "demand-consolidation-portfolio",
          "category-opportunity-radar",
          "renewal-change-compliance",
          "continuous-risk-monitoring"
        ],
        "capabilityMapId": "accenture-s2p-master",
        "chapters": [
          {
            "authorityKey": "editorial-story.morning-decision-brief.chapter.open-the-position.authority",
            "bodyKey": "editorial-story.morning-decision-brief.chapter.open-the-position.body",
            "businessModuleIds": [
              "demand-consolidation-portfolio"
            ],
            "executionFlowIds": [
              "monitor-coverage-position",
              "read-demand-portfolio"
            ],
            "handoffKey": "editorial-story.morning-decision-brief.chapter.open-the-position.handoff",
            "id": "open-the-position",
            "ownerRoleId": "demand-owner",
            "recordEntityIds": [
              "demand-portfolio",
              "contract-entitlement"
            ],
            "titleKey": "editorial-story.morning-decision-brief.chapter.open-the-position.title"
          },
          {
            "authorityKey": "editorial-story.morning-decision-brief.chapter.read-your-own-outlook.authority",
            "bodyKey": "editorial-story.morning-decision-brief.chapter.read-your-own-outlook.body",
            "businessModuleIds": [
              "category-opportunity-radar"
            ],
            "executionFlowIds": [
              "project-commodity-price-outlook"
            ],
            "handoffKey": "editorial-story.morning-decision-brief.chapter.read-your-own-outlook.handoff",
            "id": "read-your-own-outlook",
            "ownerRoleId": "category-manager",
            "recordEntityIds": [
              "category-opportunity"
            ],
            "titleKey": "editorial-story.morning-decision-brief.chapter.read-your-own-outlook.title"
          },
          {
            "authorityKey": "editorial-story.morning-decision-brief.chapter.check-the-windows.authority",
            "bodyKey": "editorial-story.morning-decision-brief.chapter.check-the-windows.body",
            "businessModuleIds": [
              "renewal-change-compliance"
            ],
            "executionFlowIds": [
              "detect-window-or-variance"
            ],
            "handoffKey": "editorial-story.morning-decision-brief.chapter.check-the-windows.handoff",
            "id": "check-the-windows",
            "ownerRoleId": "contract-manager",
            "recordEntityIds": [
              "contract",
              "contract-change"
            ],
            "titleKey": "editorial-story.morning-decision-brief.chapter.check-the-windows.title"
          },
          {
            "authorityKey": "editorial-story.morning-decision-brief.chapter.weigh-the-risk.authority",
            "bodyKey": "editorial-story.morning-decision-brief.chapter.weigh-the-risk.body",
            "businessModuleIds": [
              "continuous-risk-monitoring"
            ],
            "executionFlowIds": [
              "read-risk-network"
            ],
            "handoffKey": "editorial-story.morning-decision-brief.chapter.weigh-the-risk.handoff",
            "id": "weigh-the-risk",
            "ownerRoleId": "risk-owner",
            "recordEntityIds": [
              "supplier-risk-signal",
              "supplier-risk-assessment"
            ],
            "titleKey": "editorial-story.morning-decision-brief.chapter.weigh-the-risk.title"
          },
          {
            "authorityKey": "editorial-story.morning-decision-brief.chapter.ask-and-commit.authority",
            "bodyKey": "editorial-story.morning-decision-brief.chapter.ask-and-commit.body",
            "businessModuleIds": [
              "demand-consolidation-portfolio"
            ],
            "executionFlowIds": [
              "monitor-coverage-position"
            ],
            "handoffKey": "editorial-story.morning-decision-brief.chapter.ask-and-commit.handoff",
            "id": "ask-and-commit",
            "ownerRoleId": "demand-owner",
            "recordEntityIds": [
              "demand-portfolio",
              "authority-envelope"
            ],
            "titleKey": "editorial-story.morning-decision-brief.chapter.ask-and-commit.title"
          }
        ],
        "domainWorkblockIds": [
          "intake-demand",
          "strategy-policy-category-spend",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk"
        ],
        "executionFlowIds": [
          "monitor-coverage-position",
          "read-demand-portfolio",
          "project-commodity-price-outlook",
          "detect-window-or-variance",
          "read-risk-network"
        ],
        "id": "morning-decision-brief",
        "kickerKey": "editorial-story.morning-decision-brief.kicker",
        "namedQueryIds": [
          "query-demand-consolidation-portfolio-read-demand-portfolio",
          "query-category-opportunity-radar-read-category-opportunity",
          "query-renewal-change-compliance-read-contract",
          "query-continuous-risk-monitoring-read-supplier-risk-assessment"
        ],
        "outcomeKey": "editorial-story.morning-decision-brief.outcome",
        "resourceIds": [
          "morning-decision-brief-framework-brief"
        ],
        "spendSegmentId": "direct",
        "summaryKey": "editorial-story.morning-decision-brief.summary",
        "systemBoundaryKey": "editorial-story.morning-decision-brief.system-boundary",
        "systemProfileIds": [
          "sap-ibp",
          "client-prediction-models"
        ],
        "titleKey": "editorial-story.morning-decision-brief.title",
        "version": "1.0.0",
        "workMomentId": "daily-decision-brief"
      }
    ],
    "enterpriseMessages": [
      {
        "buyerValueKey": "enterprise.predictable-cost.value",
        "category": "commercial",
        "headlineKey": "enterprise.predictable-cost.headline",
        "id": "predictable-cost",
        "mechanismKey": "enterprise.predictable-cost.mechanism",
        "titleKey": "enterprise.predictable-cost.title"
      },
      {
        "buyerValueKey": "enterprise.price-stability.value",
        "category": "commercial",
        "headlineKey": "enterprise.price-stability.headline",
        "id": "price-stability",
        "mechanismKey": "enterprise.price-stability.mechanism",
        "titleKey": "enterprise.price-stability.title"
      },
      {
        "buyerValueKey": "enterprise.contract-start-roi.value",
        "category": "commercial",
        "headlineKey": "enterprise.contract-start-roi.headline",
        "id": "contract-start-roi",
        "mechanismKey": "enterprise.contract-start-roi.mechanism",
        "titleKey": "enterprise.contract-start-roi.title"
      },
      {
        "buyerValueKey": "enterprise.production-track-record.value",
        "category": "track-record",
        "headlineKey": "enterprise.production-track-record.headline",
        "id": "production-track-record",
        "mechanismKey": "enterprise.production-track-record.mechanism",
        "titleKey": "enterprise.production-track-record.title"
      },
      {
        "buyerValueKey": "enterprise.governed-ai-environment.value",
        "category": "governance",
        "headlineKey": "enterprise.governed-ai-environment.headline",
        "id": "governed-ai-environment",
        "mechanismKey": "enterprise.governed-ai-environment.mechanism",
        "titleKey": "enterprise.governed-ai-environment.title"
      },
      {
        "buyerValueKey": "enterprise.transport-independent-access.value",
        "category": "integration",
        "headlineKey": "enterprise.transport-independent-access.headline",
        "id": "transport-independent-access",
        "integrationExampleIds": [
          "document-first-sap-network-exchange",
          "canonical-suite-overlays"
        ],
        "mechanismKey": "enterprise.transport-independent-access.mechanism",
        "titleKey": "enterprise.transport-independent-access.title"
      },
      {
        "buyerValueKey": "enterprise.enterprise-interoperability.value",
        "category": "interoperability",
        "headlineKey": "enterprise.enterprise-interoperability.headline",
        "id": "enterprise-interoperability",
        "integrationExampleIds": [
          "copilot-invoice-exception-triage",
          "document-first-sap-network-exchange",
          "canonical-suite-overlays",
          "sharepoint-governed-content-channel"
        ],
        "mechanismKey": "enterprise.enterprise-interoperability.mechanism",
        "titleKey": "enterprise.enterprise-interoperability.title"
      },
      {
        "buyerValueKey": "enterprise.model-residency.value",
        "category": "residency",
        "headlineKey": "enterprise.model-residency.headline",
        "id": "model-residency",
        "mechanismKey": "enterprise.model-residency.mechanism",
        "titleKey": "enterprise.model-residency.title"
      },
      {
        "buyerValueKey": "enterprise.regulatory-delivery.value",
        "category": "regulatory",
        "headlineKey": "enterprise.regulatory-delivery.headline",
        "id": "regulatory-delivery",
        "mechanismKey": "enterprise.regulatory-delivery.mechanism",
        "titleKey": "enterprise.regulatory-delivery.title"
      },
      {
        "buyerValueKey": "enterprise.pilot-production.value",
        "category": "deployment",
        "headlineKey": "enterprise.pilot-production.headline",
        "id": "pilot-production",
        "integrationExampleIds": [
          "copilot-invoice-exception-triage"
        ],
        "mechanismKey": "enterprise.pilot-production.mechanism",
        "titleKey": "enterprise.pilot-production.title"
      },
      {
        "buyerValueKey": "enterprise.human-accountability.value",
        "category": "accountability",
        "headlineKey": "enterprise.human-accountability.headline",
        "id": "human-accountability",
        "integrationExampleIds": [
          "copilot-invoice-exception-triage",
          "sharepoint-governed-content-channel"
        ],
        "mechanismKey": "enterprise.human-accountability.mechanism",
        "titleKey": "enterprise.human-accountability.title"
      }
    ],
    "faqs": [
      {
        "answerKey": "faq.who-builds.answer",
        "category": "Framework and model",
        "id": "who-builds",
        "questionKey": "faq.who-builds.question"
      },
      {
        "answerKey": "faq.framework.answer",
        "category": "Framework and model",
        "id": "framework-vs-platform",
        "questionKey": "faq.framework.question"
      },
      {
        "answerKey": "faq.systems.answer",
        "category": "Framework and model",
        "id": "systems-of-work",
        "questionKey": "faq.systems.question"
      },
      {
        "answerKey": "faq.map.answer",
        "category": "Framework and model",
        "id": "framework-map",
        "questionKey": "faq.map.question"
      },
      {
        "answerKey": "faq.modular.answer",
        "category": "Workblocks and change",
        "id": "modularity",
        "questionKey": "faq.modular.question"
      },
      {
        "answerKey": "faq.change.answer",
        "category": "Workblocks and change",
        "id": "workblock-change",
        "questionKey": "faq.change.question"
      },
      {
        "answerKey": "faq.status.answer",
        "category": "Workblocks and change",
        "id": "workblock-status",
        "questionKey": "faq.status.question"
      },
      {
        "answerKey": "faq.rollback.answer",
        "category": "Workblocks and change",
        "id": "change-rollback",
        "questionKey": "faq.rollback.question"
      },
      {
        "answerKey": "faq.integration-speed.answer",
        "category": "Speed and implementation",
        "id": "integration-speed",
        "questionKey": "faq.integration-speed.question"
      },
      {
        "answerKey": "faq.build-speed.answer",
        "category": "Speed and implementation",
        "id": "build-speed",
        "questionKey": "faq.build-speed.question"
      },
      {
        "answerKey": "faq.first-outcome.answer",
        "category": "Speed and implementation",
        "id": "first-outcome",
        "questionKey": "faq.first-outcome.question"
      },
      {
        "answerKey": "faq.copilot.answer",
        "category": "Agents and autonomy",
        "id": "copilot",
        "questionKey": "faq.copilot.question"
      },
      {
        "answerKey": "faq.authority.answer",
        "category": "Agents and autonomy",
        "id": "authority",
        "questionKey": "faq.authority.question"
      },
      {
        "answerKey": "faq.graduation.answer",
        "category": "Agents and autonomy",
        "id": "autonomy-graduation",
        "questionKey": "faq.graduation.question"
      },
      {
        "answerKey": "faq.mistakes.answer",
        "category": "Agents and autonomy",
        "id": "agent-mistakes",
        "questionKey": "faq.mistakes.question"
      },
      {
        "answerKey": "faq.data.answer",
        "category": "Data and learning",
        "id": "data",
        "questionKey": "faq.data.question"
      },
      {
        "answerKey": "faq.learning.answer",
        "category": "Data and learning",
        "id": "learning",
        "questionKey": "faq.learning.question"
      },
      {
        "answerKey": "faq.traceability.answer",
        "category": "Data and learning",
        "id": "traceability",
        "questionKey": "faq.traceability.question"
      },
      {
        "answerKey": "faq.office.answer",
        "category": "Microsoft 365 and Office",
        "id": "office",
        "questionKey": "faq.office.question"
      },
      {
        "answerKey": "faq.roundtrip.answer",
        "category": "Microsoft 365 and Office",
        "id": "office-roundtrip",
        "questionKey": "faq.roundtrip.question"
      },
      {
        "answerKey": "faq.coexist.answer",
        "category": "Integration and coexistence",
        "id": "coexistence",
        "questionKey": "faq.coexist.question"
      },
      {
        "answerKey": "faq.durable.answer",
        "category": "Integration and coexistence",
        "id": "durable-runs",
        "questionKey": "faq.durable.question"
      },
      {
        "answerKey": "faq.erp.answer",
        "category": "Integration and coexistence",
        "id": "erp-boundary",
        "questionKey": "faq.erp.question"
      },
      {
        "answerKey": "faq.replace.answer",
        "category": "Integration and coexistence",
        "id": "replacement",
        "questionKey": "faq.replace.question"
      },
      {
        "answerKey": "commercial.pricing-headline",
        "category": "Competitive and commercial",
        "id": "pricing",
        "questionKey": "faq.pricing.question"
      },
      {
        "answerKey": "faq.security.answer",
        "category": "Trust and security",
        "id": "security",
        "questionKey": "faq.security.question"
      },
      {
        "answerKey": "faq.isolation.answer",
        "category": "Trust and security",
        "id": "configuration-isolation",
        "questionKey": "faq.isolation.question"
      }
    ],
    "glossary": [
      {
        "definitionKey": "glossary.framework.definition",
        "id": "agentic-procurement-framework",
        "termKey": "glossary.framework.term"
      },
      {
        "definitionKey": "glossary.platform.definition",
        "id": "agentic-procurement-platform",
        "termKey": "glossary.platform.term"
      },
      {
        "aliases": [
          "execution rails"
        ],
        "definitionKey": "glossary.rails.definition",
        "id": "beyond-work-execution-rails",
        "termKey": "glossary.rails.term"
      },
      {
        "definitionKey": "glossary.workblock.definition",
        "id": "workblock",
        "termKey": "glossary.workblock.term"
      },
      {
        "definitionKey": "glossary.system-of-work.definition",
        "id": "system-of-work",
        "termKey": "glossary.system-of-work.term"
      },
      {
        "definitionKey": "glossary.system-radar.definition",
        "id": "system-radar",
        "termKey": "glossary.system-radar.term"
      },
      {
        "definitionKey": "glossary.system-gateway.definition",
        "id": "system-gateway",
        "termKey": "glossary.system-gateway.term"
      },
      {
        "definitionKey": "glossary.system-dealroom.definition",
        "id": "system-dealroom",
        "termKey": "glossary.system-dealroom.term"
      },
      {
        "definitionKey": "glossary.system-accord.definition",
        "id": "system-covenant",
        "termKey": "glossary.system-accord.term"
      },
      {
        "definitionKey": "glossary.system-sentinel.definition",
        "id": "system-sentinel",
        "termKey": "glossary.system-sentinel.term"
      },
      {
        "definitionKey": "glossary.system-buyline.definition",
        "id": "system-buyline",
        "termKey": "glossary.system-buyline.term"
      },
      {
        "definitionKey": "glossary.system-clearway.definition",
        "id": "system-clearway",
        "termKey": "glossary.system-clearway.term"
      },
      {
        "definitionKey": "glossary.system-alliance.definition",
        "id": "system-alliance",
        "termKey": "glossary.system-alliance.term"
      },
      {
        "definitionKey": "glossary.system-value-hunter.definition",
        "id": "system-value-hunter",
        "termKey": "glossary.system-value-hunter.term"
      },
      {
        "definitionKey": "glossary.status-reference.definition",
        "id": "status-reference",
        "termKey": "glossary.status-reference.term"
      },
      {
        "definitionKey": "glossary.business-module.definition",
        "id": "business-module",
        "termKey": "glossary.business-module.term"
      },
      {
        "definitionKey": "glossary.execution-flow.definition",
        "id": "execution-flow",
        "termKey": "glossary.execution-flow.term"
      },
      {
        "definitionKey": "glossary.task.definition",
        "id": "task",
        "termKey": "glossary.task.term"
      },
      {
        "definitionKey": "glossary.graduated-autonomy.definition",
        "id": "graduated-autonomy",
        "termKey": "glossary.graduated-autonomy.term"
      },
      {
        "definitionKey": "glossary.tenant-learning.definition",
        "id": "tenant-learning",
        "termKey": "glossary.tenant-learning.term"
      },
      {
        "definitionKey": "glossary.copilot.definition",
        "id": "platform-copilot",
        "termKey": "glossary.copilot.term"
      },
      {
        "definitionKey": "glossary.automation.definition",
        "id": "automation-posture",
        "termKey": "glossary.automation.term"
      },
      {
        "definitionKey": "glossary.realization.definition",
        "id": "validated-realization",
        "termKey": "glossary.realization.term"
      },
      {
        "definitionKey": "glossary.last-good.definition",
        "id": "last-good-data",
        "termKey": "glossary.last-good.term"
      },
      {
        "definitionKey": "glossary.composer.definition",
        "id": "composer",
        "termKey": "glossary.composer.term"
      },
      {
        "definitionKey": "glossary.conductor.definition",
        "id": "conductor",
        "termKey": "glossary.conductor.term"
      }
    ],
    "landscapes": [
      {
        "descriptionKey": "landscape.s2p.description",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "id": "full-source-to-pay",
        "kind": "capability",
        "labelKey": "landscape.s2p.label"
      },
      {
        "descriptionKey": "landscape.erp.description",
        "domainWorkblockIds": [
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness"
        ],
        "id": "erp-coexistence",
        "kind": "coexistence",
        "labelKey": "landscape.erp.label"
      },
      {
        "descriptionKey": "landscape.warehouse.description",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "value-realization-savings"
        ],
        "id": "warehouse-coexistence",
        "kind": "integration",
        "labelKey": "landscape.warehouse.label"
      },
      {
        "descriptionKey": "landscape.legacy.description",
        "domainWorkblockIds": [
          "intake-demand",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk"
        ],
        "id": "legacy-suite-differentiation",
        "kind": "market-position",
        "labelKey": "landscape.legacy.label"
      },
      {
        "descriptionKey": "landscape.office.description",
        "domainWorkblockIds": [
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "supplier-performance-innovation-relationship"
        ],
        "id": "office-native-work",
        "kind": "capability",
        "labelKey": "landscape.office.label"
      },
      {
        "descriptionKey": "landscape.adaptability.description",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "id": "continuous-adaptability",
        "kind": "maturity",
        "labelKey": "landscape.adaptability.label"
      }
    ],
    "officeProducts": [
      {
        "actionPairs": [
          {
            "agentActionKey": "office.composer.action.find.agent",
            "humanActionKey": "office.composer.action.find.human",
            "id": "find"
          },
          {
            "agentActionKey": "office.composer.action.inspect.agent",
            "humanActionKey": "office.composer.action.inspect.human",
            "id": "inspect"
          },
          {
            "agentActionKey": "office.composer.action.compare.agent",
            "humanActionKey": "office.composer.action.compare.human",
            "id": "compare"
          },
          {
            "agentActionKey": "office.composer.action.draft.agent",
            "humanActionKey": "office.composer.action.draft.human",
            "id": "draft"
          },
          {
            "agentActionKey": "office.composer.action.redline.agent",
            "humanActionKey": "office.composer.action.redline.human",
            "id": "redline"
          },
          {
            "agentActionKey": "office.composer.action.decide.agent",
            "humanActionKey": "office.composer.action.decide.human",
            "id": "decide"
          },
          {
            "agentActionKey": "office.composer.action.structure.agent",
            "humanActionKey": "office.composer.action.structure.human",
            "id": "structure"
          },
          {
            "agentActionKey": "office.composer.action.finish.agent",
            "humanActionKey": "office.composer.action.finish.human",
            "id": "finish"
          }
        ],
        "actionSectionDescriptionKey": "office.composer.actions.description",
        "actionsHeadingKey": "office.shared.actions.heading",
        "autonomyDescriptionKey": "office.composer.autonomy.description",
        "autonomyHeadingKey": "office.composer.autonomy.heading",
        "autonomySteps": [
          {
            "descriptionKey": "office.composer.autonomy.resolve.description",
            "id": "resolve",
            "labelKey": "office.autonomy.resolve.label"
          },
          {
            "descriptionKey": "office.composer.autonomy.inspect.description",
            "id": "inspect",
            "labelKey": "office.autonomy.inspect.label"
          },
          {
            "descriptionKey": "office.composer.autonomy.validate.description",
            "id": "validate",
            "labelKey": "office.autonomy.validate.label"
          },
          {
            "descriptionKey": "office.composer.autonomy.act.description",
            "id": "act",
            "labelKey": "office.autonomy.act.label"
          },
          {
            "descriptionKey": "office.composer.autonomy.read-back.description",
            "id": "read-back",
            "labelKey": "office.autonomy.read-back.label"
          },
          {
            "descriptionKey": "office.composer.autonomy.return.description",
            "id": "return",
            "labelKey": "office.autonomy.return.label"
          }
        ],
        "capabilitiesDescriptionKey": "office.composer.capabilities.description",
        "capabilitiesHeadingKey": "office.composer.capabilities.heading",
        "capabilityFamilies": [
          {
            "id": "text-styles",
            "labelKey": "office.composer.family.text-styles.label",
            "valueKey": "office.composer.family.text-styles.value"
          },
          {
            "id": "numbering-lists",
            "labelKey": "office.composer.family.numbering-lists.label",
            "valueKey": "office.composer.family.numbering-lists.value"
          },
          {
            "id": "tables",
            "labelKey": "office.composer.family.tables.label",
            "valueKey": "office.composer.family.tables.value"
          },
          {
            "id": "sections-stories",
            "labelKey": "office.composer.family.sections-stories.label",
            "valueKey": "office.composer.family.sections-stories.value"
          },
          {
            "id": "fields-controls",
            "labelKey": "office.composer.family.fields-controls.label",
            "valueKey": "office.composer.family.fields-controls.value"
          },
          {
            "id": "review",
            "labelKey": "office.composer.family.review.label",
            "valueKey": "office.composer.family.review.value"
          },
          {
            "id": "protection",
            "labelKey": "office.composer.family.protection.label",
            "valueKey": "office.composer.family.protection.value"
          },
          {
            "id": "objects",
            "labelKey": "office.composer.family.objects.label",
            "valueKey": "office.composer.family.objects.value"
          },
          {
            "id": "package",
            "labelKey": "office.composer.family.package.label",
            "valueKey": "office.composer.family.package.value"
          }
        ],
        "closingKey": "office.composer.closing",
        "companionProductId": "conductor",
        "ctaKey": "office.composer.cta",
        "deliveryKey": "office.shared.delivery",
        "differentiators": [
          {
            "descriptionKey": "office.composer.difference.word-add-in.description",
            "id": "word-add-in",
            "labelKey": "office.composer.difference.word-add-in.label"
          },
          {
            "descriptionKey": "office.composer.difference.extraction.description",
            "id": "document-extraction",
            "labelKey": "office.composer.difference.extraction.label"
          },
          {
            "descriptionKey": "office.composer.difference.browser-editor.description",
            "id": "browser-editor",
            "labelKey": "office.composer.difference.browser-editor.label"
          },
          {
            "descriptionKey": "office.composer.difference.clm.description",
            "id": "clm-generation",
            "labelKey": "office.composer.difference.clm.label"
          }
        ],
        "differentiatorsDescriptionKey": "office.composer.differentiators.description",
        "differentiatorsHeadingKey": "office.composer.differentiators.heading",
        "formatKey": "office.composer.format",
        "icon": "composer",
        "id": "composer",
        "nameKey": "office.composer.name",
        "officeCapability": "composer",
        "order": 1,
        "programKey": "office.shared.program",
        "relatedBusinessModuleIds": [
          "policy-guidance",
          "sourcing-event",
          "contract-authoring-review",
          "obligation-monitoring",
          "third-party-risk-review",
          "supplier-performance-review",
          "category-strategy-orchestrator",
          "policy-rule-lifecycle",
          "contract-intake-digitization",
          "contract-approval-repository",
          "renewal-change-compliance",
          "supplier-relationship-joint-value"
        ],
        "requirementKeys": [
          "office.composer.requirement.package",
          "office.composer.requirement.targets",
          "office.composer.requirement.review",
          "office.composer.requirement.artifacts",
          "office.composer.requirement.headless",
          "office.composer.requirement.export"
        ],
        "requirementsDescriptionKey": "office.composer.requirements.description",
        "requirementsHeadingKey": "office.composer.requirements.heading",
        "roleJobs": [
          {
            "id": "legal-counsel",
            "questionKey": "office.composer.role.legal.question",
            "roleId": "legal-counsel",
            "roleKey": "office.composer.role.legal.role",
            "valueKey": "office.composer.role.legal.value"
          },
          {
            "id": "contract-manager",
            "questionKey": "office.composer.role.contract-manager.question",
            "roleId": "contract-manager",
            "roleKey": "office.composer.role.contract-manager.role",
            "valueKey": "office.composer.role.contract-manager.value"
          },
          {
            "id": "obligation-owner",
            "questionKey": "office.composer.role.obligation-owner.question",
            "roleId": "obligation-owner",
            "roleKey": "office.composer.role.obligation-owner.role",
            "valueKey": "office.composer.role.obligation-owner.value"
          },
          {
            "id": "negotiation-lead",
            "questionKey": "office.composer.role.negotiation-lead.question",
            "roleId": "negotiation-lead",
            "roleKey": "office.composer.role.negotiation-lead.role",
            "valueKey": "office.composer.role.negotiation-lead.value"
          }
        ],
        "rolesDescriptionKey": "office.composer.roles.description",
        "rolesHeadingKey": "office.composer.roles.heading",
        "route": "/capabilities/composer",
        "specificationCtaKey": "office.composer.specification-cta",
        "summaryKey": "office.composer.summary",
        "taglineKey": "office.composer.tagline",
        "thesisKey": "office.composer.thesis",
        "workblocksDescriptionKey": "office.composer.workblocks.description",
        "workblocksHeadingKey": "office.composer.workblocks.heading"
      },
      {
        "actionPairs": [
          {
            "agentActionKey": "office.conductor.action.find.agent",
            "humanActionKey": "office.conductor.action.find.human",
            "id": "find"
          },
          {
            "agentActionKey": "office.conductor.action.inspect.agent",
            "humanActionKey": "office.conductor.action.inspect.human",
            "id": "inspect"
          },
          {
            "agentActionKey": "office.conductor.action.trace.agent",
            "humanActionKey": "office.conductor.action.trace.human",
            "id": "trace"
          },
          {
            "agentActionKey": "office.conductor.action.write.agent",
            "humanActionKey": "office.conductor.action.write.human",
            "id": "write"
          },
          {
            "agentActionKey": "office.conductor.action.structure.agent",
            "humanActionKey": "office.conductor.action.structure.human",
            "id": "structure"
          },
          {
            "agentActionKey": "office.conductor.action.analyse.agent",
            "humanActionKey": "office.conductor.action.analyse.human",
            "id": "analyse"
          },
          {
            "agentActionKey": "office.conductor.action.decide.agent",
            "humanActionKey": "office.conductor.action.decide.human",
            "id": "decide"
          },
          {
            "agentActionKey": "office.conductor.action.finish.agent",
            "humanActionKey": "office.conductor.action.finish.human",
            "id": "finish"
          }
        ],
        "actionSectionDescriptionKey": "office.conductor.actions.description",
        "actionsHeadingKey": "office.shared.actions.heading",
        "autonomyDescriptionKey": "office.conductor.autonomy.description",
        "autonomyHeadingKey": "office.conductor.autonomy.heading",
        "autonomySteps": [
          {
            "descriptionKey": "office.conductor.autonomy.resolve.description",
            "id": "resolve",
            "labelKey": "office.autonomy.resolve.label"
          },
          {
            "descriptionKey": "office.conductor.autonomy.inspect.description",
            "id": "inspect",
            "labelKey": "office.autonomy.inspect.label"
          },
          {
            "descriptionKey": "office.conductor.autonomy.validate.description",
            "id": "validate",
            "labelKey": "office.autonomy.validate.label"
          },
          {
            "descriptionKey": "office.conductor.autonomy.act.description",
            "id": "act",
            "labelKey": "office.autonomy.act.label"
          },
          {
            "descriptionKey": "office.conductor.autonomy.read-back.description",
            "id": "read-back",
            "labelKey": "office.autonomy.read-back.label"
          },
          {
            "descriptionKey": "office.conductor.autonomy.return.description",
            "id": "return",
            "labelKey": "office.autonomy.return.label"
          }
        ],
        "capabilitiesDescriptionKey": "office.conductor.capabilities.description",
        "capabilitiesHeadingKey": "office.conductor.capabilities.heading",
        "capabilityFamilies": [
          {
            "id": "values-formulas",
            "labelKey": "office.conductor.family.values-formulas.label",
            "valueKey": "office.conductor.family.values-formulas.value"
          },
          {
            "id": "formats",
            "labelKey": "office.conductor.family.formats.label",
            "valueKey": "office.conductor.family.formats.value"
          },
          {
            "id": "tables-names",
            "labelKey": "office.conductor.family.tables-names.label",
            "valueKey": "office.conductor.family.tables-names.value"
          },
          {
            "id": "calculation",
            "labelKey": "office.conductor.family.calculation.label",
            "valueKey": "office.conductor.family.calculation.value"
          },
          {
            "id": "data-actions",
            "labelKey": "office.conductor.family.data-actions.label",
            "valueKey": "office.conductor.family.data-actions.value"
          },
          {
            "id": "visuals",
            "labelKey": "office.conductor.family.visuals.label",
            "valueKey": "office.conductor.family.visuals.value"
          },
          {
            "id": "scenarios",
            "labelKey": "office.conductor.family.scenarios.label",
            "valueKey": "office.conductor.family.scenarios.value"
          },
          {
            "id": "review",
            "labelKey": "office.conductor.family.review.label",
            "valueKey": "office.conductor.family.review.value"
          },
          {
            "id": "protection",
            "labelKey": "office.conductor.family.protection.label",
            "valueKey": "office.conductor.family.protection.value"
          },
          {
            "id": "package",
            "labelKey": "office.conductor.family.package.label",
            "valueKey": "office.conductor.family.package.value"
          }
        ],
        "closingKey": "office.conductor.closing",
        "companionProductId": "composer",
        "ctaKey": "office.conductor.cta",
        "deliveryKey": "office.shared.delivery",
        "differentiators": [
          {
            "descriptionKey": "office.conductor.difference.excel-add-in.description",
            "id": "excel-add-in",
            "labelKey": "office.conductor.difference.excel-add-in.label"
          },
          {
            "descriptionKey": "office.conductor.difference.analytics.description",
            "id": "analytics-notebook",
            "labelKey": "office.conductor.difference.analytics.label"
          },
          {
            "descriptionKey": "office.conductor.difference.component.description",
            "id": "spreadsheet-component",
            "labelKey": "office.conductor.difference.component.label"
          },
          {
            "descriptionKey": "office.conductor.difference.automation.description",
            "id": "cell-automation",
            "labelKey": "office.conductor.difference.automation.label"
          },
          {
            "descriptionKey": "office.conductor.difference.dashboard.description",
            "id": "savings-dashboard",
            "labelKey": "office.conductor.difference.dashboard.label"
          }
        ],
        "differentiatorsDescriptionKey": "office.conductor.differentiators.description",
        "differentiatorsHeadingKey": "office.conductor.differentiators.heading",
        "formatKey": "office.conductor.format",
        "icon": "conductor",
        "id": "conductor",
        "nameKey": "office.conductor.name",
        "officeCapability": "conductor",
        "order": 2,
        "programKey": "office.shared.program",
        "relatedBusinessModuleIds": [
          "category-opportunity-radar",
          "sourcing-event",
          "negotiation-copilot",
          "third-party-risk-review",
          "supplier-performance-review",
          "savings-initiative",
          "value-leakage-monitor",
          "spend-data-foundation",
          "category-strategy-orchestrator",
          "demand-consolidation-portfolio",
          "sourcing-pipeline-discovery",
          "bid-evaluation-award",
          "renewal-change-compliance",
          "supplier-performance-monitor-correct",
          "supplier-relationship-joint-value",
          "value-opportunity-baseline",
          "realization-reconciliation-attribution",
          "value-portfolio-forecast"
        ],
        "requirementKeys": [
          "office.conductor.requirement.package",
          "office.conductor.requirement.targets",
          "office.conductor.requirement.calculation",
          "office.conductor.requirement.review",
          "office.conductor.requirement.kernel",
          "office.conductor.requirement.headless",
          "office.conductor.requirement.export"
        ],
        "requirementsDescriptionKey": "office.conductor.requirements.description",
        "requirementsHeadingKey": "office.conductor.requirements.heading",
        "roleJobs": [
          {
            "id": "award-authority",
            "questionKey": "office.conductor.role.award-authority.question",
            "roleId": "award-authority",
            "roleKey": "office.conductor.role.award-authority.role",
            "valueKey": "office.conductor.role.award-authority.value"
          },
          {
            "id": "finance-delegate",
            "questionKey": "office.conductor.role.finance-delegate.question",
            "roleId": "finance-delegate",
            "roleKey": "office.conductor.role.finance-delegate.role",
            "valueKey": "office.conductor.role.finance-delegate.value"
          },
          {
            "id": "value-lead",
            "questionKey": "office.conductor.role.value-lead.question",
            "roleId": "value-lead",
            "roleKey": "office.conductor.role.value-lead.role",
            "valueKey": "office.conductor.role.value-lead.value"
          },
          {
            "id": "category-manager",
            "questionKey": "office.conductor.role.category-manager.question",
            "roleId": "category-manager",
            "roleKey": "office.conductor.role.category-manager.role",
            "valueKey": "office.conductor.role.category-manager.value"
          },
          {
            "id": "supplier-manager",
            "questionKey": "office.conductor.role.supplier-manager.question",
            "roleId": "relationship-manager",
            "roleKey": "office.conductor.role.supplier-manager.role",
            "valueKey": "office.conductor.role.supplier-manager.value"
          },
          {
            "id": "negotiation-lead",
            "questionKey": "office.conductor.role.negotiation-lead.question",
            "roleId": "negotiation-lead",
            "roleKey": "office.conductor.role.negotiation-lead.role",
            "valueKey": "office.conductor.role.negotiation-lead.value"
          }
        ],
        "rolesDescriptionKey": "office.conductor.roles.description",
        "rolesHeadingKey": "office.conductor.roles.heading",
        "route": "/capabilities/conductor",
        "specificationCtaKey": "office.conductor.specification-cta",
        "summaryKey": "office.conductor.summary",
        "taglineKey": "office.conductor.tagline",
        "thesisKey": "office.conductor.thesis",
        "workblocksDescriptionKey": "office.conductor.workblocks.description",
        "workblocksHeadingKey": "office.conductor.workblocks.heading"
      }
    ],
    "opening": {
      "coreLineKey": "opening.core-line",
      "definitionTitleKey": "opening.definition-title",
      "deliveryTitleKey": "opening.delivery-title",
      "featuredBusinessModuleIds": [
        "sourcing-event",
        "invoice-exception-triage",
        "supplier-performance-review"
      ],
      "firstMoveLinkKey": "opening.first-move-link",
      "firstMoveTitleKey": "opening.first-move-title",
      "gapEyebrowKey": "opening.gap-eyebrow",
      "gapTitleKey": "opening.gap-title",
      "letterP1Key": "opening.letter.p1",
      "letterP2Key": "opening.letter.p2",
      "letterP3Key": "opening.letter.p3",
      "letterP4Key": "opening.letter.p4",
      "letterP5Key": "opening.letter.p5",
      "mapTitleKey": "lifecycle.map-title",
      "moatDetailKey": "moat.body",
      "moatKey": "moat.headline",
      "motionDetailKey": "adoption.keep",
      "motionKey": "adoption.motion",
      "proofTitleKey": "opening.proof-title",
      "shiftEyebrowKey": "opening.shift-eyebrow",
      "titleKey": "opening.title"
    },
    "positioning": [
      {
        "bodyKey": "positioning.modular.body",
        "eyebrowKey": "positioning.modular.eyebrow",
        "headlineKey": "positioning.modular.headline",
        "id": "modular-change"
      },
      {
        "bodyKey": "positioning.speed.body",
        "eyebrowKey": "positioning.speed.eyebrow",
        "headlineKey": "positioning.speed.headline",
        "id": "days-not-weeks"
      },
      {
        "bodyKey": "positioning.copilot.body",
        "eyebrowKey": "positioning.copilot.eyebrow",
        "headlineKey": "positioning.copilot.headline",
        "id": "governed-copilot"
      },
      {
        "bodyKey": "positioning.data.body",
        "eyebrowKey": "positioning.data.eyebrow",
        "headlineKey": "positioning.data.headline",
        "id": "shared-data"
      },
      {
        "bodyKey": "positioning.office.body",
        "eyebrowKey": "positioning.office.eyebrow",
        "headlineKey": "positioning.office.headline",
        "id": "office-roundtrip"
      },
      {
        "bodyKey": "positioning.integration.body",
        "eyebrowKey": "positioning.integration.eyebrow",
        "headlineKey": "positioning.integration.headline",
        "id": "rapid-integration"
      }
    ],
    "primaryNavigationGroups": [
      {
        "id": "sections",
        "labelKey": "nav.group.sections",
        "order": 1
      }
    ],
    "roles": [
      {
        "descriptionKey": "role.accountable-risk-owner.description",
        "id": "accountable-risk-owner",
        "labelKey": "role.accountable-risk-owner.label",
        "searchTermKeys": [
          "role.accountable-risk-owner.search.risk-acceptance"
        ]
      },
      {
        "descriptionKey": "role.ap-processor.description",
        "id": "ap-processor",
        "labelKey": "role.ap-processor.label",
        "searchTermKeys": [
          "role.ap-processor.search.accounts-payable"
        ]
      },
      {
        "descriptionKey": "role.award-authority.description",
        "id": "award-authority",
        "labelKey": "role.award-authority.label"
      },
      {
        "descriptionKey": "role.budget-owner.description",
        "id": "budget-owner",
        "labelKey": "role.budget-owner.label",
        "searchTermKeys": [
          "role.budget-owner.search.business-budget-owner"
        ]
      },
      {
        "descriptionKey": "role.category-manager.description",
        "id": "category-manager",
        "labelKey": "role.category-manager.label"
      },
      {
        "descriptionKey": "role.contract-manager.description",
        "id": "contract-manager",
        "labelKey": "role.contract-manager.label"
      },
      {
        "descriptionKey": "role.controller.description",
        "id": "controller",
        "labelKey": "role.controller.label"
      },
      {
        "descriptionKey": "role.data-steward.description",
        "id": "data-steward",
        "labelKey": "role.data-steward.label"
      },
      {
        "descriptionKey": "role.demand-owner.description",
        "id": "demand-owner",
        "labelKey": "role.demand-owner.label"
      },
      {
        "descriptionKey": "role.evaluator.description",
        "id": "evaluator",
        "labelKey": "role.evaluator.label",
        "searchTermKeys": [
          "role.evaluator.search.subject-matter-expert"
        ]
      },
      {
        "descriptionKey": "role.finance-delegate.description",
        "id": "finance-delegate",
        "labelKey": "role.finance-delegate.label"
      },
      {
        "descriptionKey": "role.governance-owner.description",
        "id": "governance-owner",
        "labelKey": "role.governance-owner.label",
        "searchTermKeys": [
          "role.governance-owner.search.supplier-governance-owner"
        ]
      },
      {
        "descriptionKey": "role.innovation-sponsor.description",
        "id": "innovation-sponsor",
        "labelKey": "role.innovation-sponsor.label"
      },
      {
        "descriptionKey": "role.intake-owner.description",
        "id": "intake-owner",
        "labelKey": "role.intake-owner.label",
        "searchTermKeys": [
          "role.intake-owner.search.procurement-intake-owner"
        ]
      },
      {
        "descriptionKey": "role.integration-owner.description",
        "id": "integration-owner",
        "labelKey": "role.integration-owner.label",
        "searchTermKeys": [
          "role.integration-owner.search.erp-owner"
        ]
      },
      {
        "descriptionKey": "role.legal-counsel.description",
        "id": "legal-counsel",
        "labelKey": "role.legal-counsel.label"
      },
      {
        "descriptionKey": "role.metric-owner.description",
        "id": "metric-owner",
        "labelKey": "role.metric-owner.label",
        "searchTermKeys": [
          "role.metric-owner.search.data-owner"
        ]
      },
      {
        "descriptionKey": "role.negotiation-lead.description",
        "id": "negotiation-lead",
        "labelKey": "role.negotiation-lead.label"
      },
      {
        "descriptionKey": "role.obligation-owner.description",
        "id": "obligation-owner",
        "labelKey": "role.obligation-owner.label"
      },
      {
        "descriptionKey": "role.onboarding-coordinator.description",
        "id": "onboarding-coordinator",
        "labelKey": "role.onboarding-coordinator.label"
      },
      {
        "descriptionKey": "role.payment-approver.description",
        "id": "payment-approver",
        "labelKey": "role.payment-approver.label"
      },
      {
        "descriptionKey": "role.policy-owner.description",
        "id": "policy-owner",
        "labelKey": "role.policy-owner.label",
        "searchTermKeys": [
          "role.policy-owner.search.procurement-policy-owner"
        ]
      },
      {
        "descriptionKey": "role.process-owner.description",
        "id": "process-owner",
        "labelKey": "role.process-owner.label",
        "searchTermKeys": [
          "role.process-owner.search.process-policy-owner"
        ]
      },
      {
        "descriptionKey": "role.procurement-analyst.description",
        "id": "procurement-analyst",
        "labelKey": "role.procurement-analyst.label"
      },
      {
        "descriptionKey": "role.procurement-buyer.description",
        "id": "procurement-buyer",
        "labelKey": "role.procurement-buyer.label"
      },
      {
        "descriptionKey": "role.receiver.description",
        "id": "receiver",
        "labelKey": "role.receiver.label",
        "searchTermKeys": [
          "role.receiver.search.service-owner"
        ]
      },
      {
        "descriptionKey": "role.relationship-manager.description",
        "id": "relationship-manager",
        "labelKey": "role.relationship-manager.label",
        "searchTermKeys": [
          "role.relationship-manager.search.supplier-relationship-manager"
        ]
      },
      {
        "descriptionKey": "role.requester.description",
        "id": "requester",
        "labelKey": "role.requester.label",
        "searchTermKeys": [
          "role.requester.search.business-requester"
        ]
      },
      {
        "descriptionKey": "role.risk-owner.description",
        "id": "risk-owner",
        "labelKey": "role.risk-owner.label",
        "searchTermKeys": [
          "role.risk-owner.search.fraud-sanctions-owner"
        ]
      },
      {
        "descriptionKey": "role.sourcing-lead.description",
        "id": "sourcing-lead",
        "labelKey": "role.sourcing-lead.label"
      },
      {
        "descriptionKey": "role.sourcing-manager.description",
        "id": "sourcing-manager",
        "labelKey": "role.sourcing-manager.label"
      },
      {
        "descriptionKey": "role.supplier-account-lead.description",
        "id": "supplier-account-lead",
        "labelKey": "role.supplier-account-lead.label"
      },
      {
        "descriptionKey": "role.supplier-contact.description",
        "id": "supplier-contact",
        "labelKey": "role.supplier-contact.label"
      },
      {
        "descriptionKey": "role.supplier-master-steward.description",
        "id": "supplier-master-steward",
        "labelKey": "role.supplier-master-steward.label"
      },
      {
        "descriptionKey": "role.tprm-programme-owner.description",
        "id": "tprm-programme-owner",
        "labelKey": "role.tprm-programme-owner.label",
        "searchTermKeys": [
          "role.tprm-programme-owner.search.third-party-risk"
        ]
      },
      {
        "descriptionKey": "role.treasury-manager.description",
        "id": "treasury-manager",
        "labelKey": "role.treasury-manager.label",
        "searchTermKeys": [
          "role.treasury-manager.search.cash-manager"
        ]
      },
      {
        "descriptionKey": "role.value-lead.description",
        "id": "value-lead",
        "labelKey": "role.value-lead.label",
        "searchTermKeys": [
          "role.value-lead.search.value-realisation-lead"
        ]
      }
    ],
    "routes": [
      {
        "icon": "blocks",
        "id": "framework",
        "labelKey": "nav.framework",
        "path": "/",
        "primaryNavigation": {
          "groupId": "sections",
          "order": 10
        }
      },
      {
        "icon": "map",
        "id": "client-engagement",
        "labelKey": "nav.client-engagement",
        "path": "/client-engagement",
        "primaryNavigation": {
          "groupId": "sections",
          "order": 20
        },
        "sectionNavigation": [
          {
            "order": 10,
            "sectionId": "client-engagement"
          }
        ]
      },
      {
        "icon": "trending-up",
        "id": "direct-material-economics",
        "labelKey": "nav.direct-material-economics",
        "path": "/client-engagement/direct-material-economics",
        "sectionNavigation": [
          {
            "order": 15,
            "sectionId": "client-engagement"
          }
        ]
      },
      {
        "icon": "shopping-bag",
        "id": "indirect-buying",
        "labelKey": "nav.indirect-buying",
        "path": "/client-engagement/indirect-buying",
        "sectionNavigation": [
          {
            "order": 16,
            "sectionId": "client-engagement"
          }
        ]
      },
      {
        "icon": "blocks",
        "id": "compounding-intelligence",
        "labelKey": "nav.compounding-intelligence",
        "path": "/client-engagement/compounding-intelligence",
        "sectionNavigation": [
          {
            "order": 17,
            "sectionId": "client-engagement"
          }
        ]
      },
      {
        "icon": "sparkles",
        "id": "morning-decision-brief",
        "labelKey": "nav.morning-decision-brief",
        "path": "/client-engagement/morning-decision-brief",
        "sectionNavigation": [
          {
            "order": 18,
            "sectionId": "client-engagement"
          }
        ]
      },
      {
        "icon": "blocks",
        "id": "build",
        "labelKey": "nav.build",
        "path": "/build",
        "primaryNavigation": {
          "groupId": "sections",
          "order": 30
        },
        "sectionNavigation": [
          {
            "order": 10,
            "sectionId": "build"
          }
        ]
      },
      {
        "icon": "palette",
        "id": "workblock-design",
        "labelKey": "nav.workblock-design",
        "path": "/build/workblock-design",
        "sectionNavigation": [
          {
            "order": 20,
            "sectionId": "build"
          }
        ]
      },
      {
        "icon": "network",
        "id": "workblock-architecture",
        "labelKey": "nav.workblock-architecture",
        "path": "/build/workblock-architecture",
        "sectionNavigation": [
          {
            "order": 30,
            "sectionId": "build"
          }
        ]
      },
      {
        "icon": "map",
        "id": "capability-map",
        "labelKey": "nav.capability-map",
        "path": "/capability-map",
        "sectionNavigation": [
          {
            "order": 40,
            "sectionId": "client-engagement"
          }
        ]
      },
      {
        "icon": "box",
        "id": "workblocks",
        "labelKey": "nav.workblocks",
        "path": "/workblocks",
        "sectionNavigation": [
          {
            "order": 50,
            "sectionId": "build"
          },
          {
            "order": 20,
            "sectionId": "reference"
          }
        ]
      },
      {
        "icon": "network",
        "id": "architecture",
        "labelKey": "nav.platform",
        "path": "/architecture",
        "sectionNavigation": [
          {
            "order": 40,
            "sectionId": "build"
          }
        ]
      },
      {
        "icon": "book-open",
        "id": "reference",
        "labelKey": "nav.reference",
        "path": "/reference",
        "primaryNavigation": {
          "groupId": "sections",
          "order": 40
        },
        "sectionNavigation": [
          {
            "order": 10,
            "sectionId": "reference"
          }
        ]
      },
      {
        "icon": "users",
        "id": "roles",
        "labelKey": "nav.roles",
        "path": "/reference/roles",
        "referenceNavigation": {
          "count": {
            "labelKey": "page.reference.count.roles",
            "source": "content.roles"
          },
          "descriptionKey": "page.reference.roles.description",
          "glyphMeaning": "class.role",
          "order": 20
        },
        "sectionNavigation": [
          {
            "order": 50,
            "sectionId": "reference"
          }
        ]
      },
      {
        "icon": "list-checks",
        "id": "jobs",
        "labelKey": "nav.jobs",
        "path": "/reference/jobs",
        "referenceNavigation": {
          "count": {
            "labelKey": "page.reference.count.jobs",
            "source": "businessModuleRegistry.businessModules"
          },
          "descriptionKey": "page.reference.jobs.description",
          "glyphMeaning": "class.job",
          "order": 30
        },
        "sectionNavigation": [
          {
            "order": 60,
            "sectionId": "reference"
          }
        ]
      },
      {
        "icon": "workflow",
        "id": "work-moments",
        "labelKey": "nav.work-moments",
        "path": "/reference/work-moments",
        "referenceNavigation": {
          "count": {
            "labelKey": "page.reference.count.work-moments",
            "source": "content.workMoments"
          },
          "descriptionKey": "page.reference.work-moments.description",
          "glyphMeaning": "object.workblock",
          "order": 40
        },
        "sectionNavigation": [
          {
            "order": 30,
            "sectionId": "client-engagement"
          },
          {
            "order": 70,
            "sectionId": "reference"
          }
        ]
      },
      {
        "icon": "files",
        "id": "office-capabilities",
        "labelKey": "nav.office-capabilities",
        "path": "/capabilities",
        "sectionNavigation": [
          {
            "order": 90,
            "sectionId": "reference"
          }
        ]
      },
      {
        "icon": "circle-help",
        "id": "faqs",
        "labelKey": "nav.faqs",
        "path": "/faqs",
        "sectionNavigation": [
          {
            "order": 120,
            "sectionId": "reference"
          }
        ]
      },
      {
        "icon": "database",
        "id": "data-model",
        "labelKey": "nav.data-model",
        "path": "/data-model",
        "referenceNavigation": {
          "count": {
            "labelKey": "page.reference.count.records",
            "source": "groundworks.entities"
          },
          "descriptionKey": "page.reference.data-model.description",
          "glyphMeaning": "class.record",
          "order": 10
        },
        "sectionNavigation": [
          {
            "order": 30,
            "sectionId": "reference"
          }
        ]
      },
      {
        "icon": "database",
        "id": "groundworks",
        "labelKey": "nav.data-catalogue",
        "path": "/groundworks",
        "sectionNavigation": [
          {
            "order": 40,
            "sectionId": "reference"
          }
        ]
      },
      {
        "icon": "book-open",
        "id": "language",
        "labelKey": "nav.language",
        "path": "/language",
        "referenceNavigation": {
          "count": {
            "labelKey": "page.reference.count.terms",
            "source": "content.glossary"
          },
          "descriptionKey": "page.reference.language.description",
          "glyphMeaning": "utility.glossary",
          "order": 50
        },
        "sectionNavigation": [
          {
            "order": 110,
            "sectionId": "reference"
          }
        ]
      },
      {
        "icon": "git-branch",
        "id": "release",
        "labelKey": "nav.release",
        "path": "/release",
        "referenceNavigation": {
          "descriptionKey": "page.reference.release.description",
          "glyphMeaning": "utility.release",
          "order": 70
        },
        "sectionNavigation": [
          {
            "order": 130,
            "sectionId": "reference"
          }
        ]
      },
      {
        "icon": "box",
        "id": "downloads",
        "labelKey": "nav.downloads",
        "path": "/downloads",
        "referenceNavigation": {
          "descriptionKey": "page.reference.downloads.description",
          "glyphMeaning": "class.record",
          "order": 80
        },
        "sectionNavigation": [
          {
            "order": 70,
            "sectionId": "build"
          },
          {
            "order": 140,
            "sectionId": "reference"
          }
        ]
      },
      {
        "icon": "search",
        "id": "search",
        "labelKey": "nav.search",
        "path": "/search"
      },
      {
        "icon": "target",
        "id": "why-groundworks",
        "labelKey": "nav.why-groundworks",
        "path": "/why-groundworks",
        "sectionNavigation": [
          {
            "order": 20,
            "sectionId": "client-engagement"
          }
        ]
      },
      {
        "icon": "book-open",
        "id": "design",
        "labelKey": "nav.design",
        "path": "/design",
        "referenceNavigation": {
          "count": {
            "labelKey": "page.reference.count.components",
            "source": "designNarrative.componentCatalogue.componentIds"
          },
          "descriptionKey": "page.reference.design.description",
          "glyphMeaning": "utility.grid",
          "order": 60
        },
        "sectionNavigation": [
          {
            "order": 60,
            "sectionId": "build"
          },
          {
            "order": 100,
            "sectionId": "reference"
          }
        ]
      },
      {
        "icon": "plug",
        "id": "connected-work",
        "labelKey": "nav.connected-work",
        "path": "/connected-work",
        "sectionNavigation": [
          {
            "order": 50,
            "sectionId": "client-engagement"
          },
          {
            "order": 80,
            "sectionId": "reference"
          }
        ]
      }
    ],
    "stages": [
      {
        "domainWorkblockIds": [
          "strategy-policy-category-spend"
        ],
        "id": "plan-govern",
        "labelKey": "stage.plan-govern.label",
        "order": 1
      },
      {
        "domainWorkblockIds": [
          "intake-demand",
          "sourcing-negotiation"
        ],
        "id": "request-source",
        "labelKey": "stage.request-source.label",
        "order": 2
      },
      {
        "domainWorkblockIds": [
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk"
        ],
        "id": "contract-assure",
        "labelKey": "stage.contract-assure.label",
        "order": 3
      },
      {
        "domainWorkblockIds": [
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness"
        ],
        "id": "buy-pay",
        "labelKey": "stage.buy-pay.label",
        "order": 4
      },
      {
        "domainWorkblockIds": [
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "id": "perform-realize",
        "labelKey": "stage.perform-realize.label",
        "order": 5
      }
    ],
    "workMomentAgents": [
      {
        "allowedActionClasses": [
          "assemble evidence pack",
          "calculate approved measures",
          "identify missing or conflicting evidence",
          "draft narrative and action options",
          "schedule routine follow-up",
          "open pre-authorised internal actions"
        ],
        "contributionKey": "work-moment.supplier-performance-review.agent-contribution",
        "id": "supplier-performance-review-agent",
        "label": "Supplier performance review agent"
      },
      {
        "allowedActionClasses": [
          "deduplicate related symptoms",
          "request missing non-sensitive evidence",
          "assign a policy-defined owner",
          "apply pre-approved coding or routing corrections",
          "close a reconciled routine case"
        ],
        "contributionKey": "work-moment.invoice-exception-triage.agent-contribution",
        "id": "invoice-exception-coordinator-agent",
        "label": "Invoice exception coordinator agent"
      },
      {
        "allowedActionClasses": [
          "Refresh the fact base",
          "Draft and compare non-committed scenarios",
          "Maintain assumption and dependency registers",
          "Propose objectives and initiative sequencing",
          "Mark stale assumptions"
        ],
        "contributionKey": "work-moment.category-strategy-refresh.agent-contribution",
        "id": "category-strategist-agent",
        "label": "Category strategist agent"
      },
      {
        "allowedActionClasses": [
          "Create and update a draft",
          "Extract proposed fields with source spans",
          "Select bounded clarification questions",
          "Validate completeness",
          "Recommend eligible service offerings"
        ],
        "contributionKey": "work-moment.intake-clarification.agent-contribution",
        "id": "request-intake-agent",
        "label": "Request intake agent"
      },
      {
        "allowedActionClasses": [
          "Draft event strategy and artifacts",
          "Generate response formats and evaluator packs",
          "Propose invite cohort",
          "Run completeness and competition scenarios",
          "Prepare version diffs"
        ],
        "contributionKey": "work-moment.sourcing-event-amendment.agent-contribution",
        "id": "sourcing-event-designer-agent",
        "label": "Sourcing event designer agent"
      },
      {
        "allowedActionClasses": [
          "Assemble draft versions",
          "Propose source-anchored redlines",
          "Classify deviations",
          "Update negotiation issue proposals"
        ],
        "contributionKey": "work-moment.contract-redline-review.agent-contribution",
        "id": "contract-drafting-agent",
        "label": "Contract drafting agent"
      },
      {
        "allowedActionClasses": [
          "Scope routine assessments",
          "Request evidence",
          "Map controls",
          "Calculate deterministic risk",
          "Prepare decision proposals"
        ],
        "contributionKey": "work-moment.third-party-risk-decision.agent-contribution",
        "id": "third-party-risk-agent",
        "label": "Third-party risk assessment agent"
      },
      {
        "allowedActionClasses": [
          "Clarify material gaps",
          "Rank current options",
          "Select a deterministic default within explicit requester preferences",
          "Create downstream handoffs",
          "Stop unsupported or prohibited demand"
        ],
        "contributionKey": "work-moment.guided-buying-route.agent-contribution",
        "id": "requester-buying-agent",
        "label": "Requester buying agent"
      },
      {
        "allowedActionClasses": [
          "draft plan and changes",
          "create pre-authorised internal child work",
          "coordinate milestones",
          "refresh forecast from governed inputs",
          "open delivery risk",
          "request realisation review",
          "close fully reconciled routine initiative"
        ],
        "contributionKey": "work-moment.savings-validation.agent-contribution",
        "id": "savings-initiative-agent",
        "label": "Savings initiative agent"
      },
      {
        "allowedActionClasses": [
          "Assemble price outlook and coverage evidence into a timing fact base",
          "Simulate buy window scenarios against declared volume bands and horizons",
          "Draft bounded mandate proposals that name volume, window and ceiling",
          "Route mandate proposals to the named authorising owner",
          "Expire mandate proposals whose evidence or buy window lapses"
        ],
        "contributionKey": "work-moment.direct-material-buy-timing.agent-contribution",
        "id": "buy-timing-agent",
        "label": "Buy timing agent"
      },
      {
        "allowedActionClasses": [
          "Resolve the tail scope from evaluation refreshes and repeat-purchase patterns",
          "Read tail-spend evaluations, spend records and buying requests as clustering evidence",
          "Cluster repeat purchases by category, item similarity and supplier overlap",
          "Propose consolidation candidates with the repeat history and channel basis attached",
          "Expire candidates whose repeat pattern or evidence lapses"
        ],
        "contributionKey": "work-moment.tail-spend-consolidation.agent-contribution",
        "id": "tail-spend-consolidation-agent",
        "label": "Tail spend consolidation agent"
      },
      {
        "allowedActionClasses": [
          "Open decision cases",
          "Collect evidence",
          "Prepare option proposals",
          "Start approved child runs",
          "Reconcile resulting versions"
        ],
        "contributionKey": "work-moment.renewal-window-decision.agent-contribution",
        "id": "contract-change-agent",
        "label": "Contract change agent"
      },
      {
        "allowedActionClasses": [
          "Refresh coverage positions on portfolio, entitlement or forecast change",
          "Align units of measure and planning calendars before gap calculation",
          "Compute time-bucketed coverage gap assessments",
          "Flag under- and over-coverage beyond configured tolerance bands",
          "Prepare coverage action proposals for the owning sourcing modules"
        ],
        "contributionKey": "work-moment.daily-decision-brief.agent-contribution",
        "id": "coverage-position-agent",
        "label": "Coverage position agent"
      }
    ],
    "workMomentFixtures": [
      {
        "authorityGrantorRoleId": "governance-owner",
        "escalationOwnerRoleId": "relationship-manager",
        "evidenceRecords": [
          {
            "definitionKey": "work-moment.fixture.supplier-performance-review.evidence.delivery-score.definition",
            "freshness": "current",
            "id": "delivery-score",
            "labelKey": "work-moment.fixture.supplier-performance-review.evidence.delivery-score.label",
            "observedAt": "2026-08-10T09:30:00Z",
            "ownerRoleId": "metric-owner",
            "provenance": "source",
            "sourceKey": "work-moment.fixture.supplier-performance-review.evidence.delivery-score.source"
          },
          {
            "definitionKey": "work-moment.fixture.supplier-performance-review.evidence.quality-score.definition",
            "freshness": "conflicting",
            "id": "quality-score",
            "labelKey": "work-moment.fixture.supplier-performance-review.evidence.quality-score.label",
            "observedAt": "2026-08-09T16:00:00Z",
            "ownerRoleId": "metric-owner",
            "provenance": "source",
            "sourceKey": "work-moment.fixture.supplier-performance-review.evidence.quality-score.source"
          },
          {
            "definitionKey": "work-moment.fixture.supplier-performance-review.evidence.supplier-response.definition",
            "freshness": "current",
            "id": "supplier-response",
            "labelKey": "work-moment.fixture.supplier-performance-review.evidence.supplier-response.label",
            "observedAt": "2026-08-11T11:15:00Z",
            "ownerRoleId": "supplier-account-lead",
            "provenance": "human",
            "sourceKey": "work-moment.fixture.supplier-performance-review.evidence.supplier-response.source"
          }
        ],
        "id": "supplier-performance-review-fixture",
        "modes": {
          "explore-evidence": {
            "headingKey": "work-moment.fixture.supplier-performance-review.mode.evidence.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.supplier-performance-review.record.score-source-conflict.detail",
                "evidenceRecordIds": [
                  "quality-score",
                  "supplier-response"
                ],
                "id": "score-source-conflict",
                "labelKey": "work-moment.fixture.supplier-performance-review.record.score-source-conflict.label",
                "ownerRoleId": "metric-owner",
                "state": "conflicting"
              }
            ],
            "summaryKey": "work-moment.fixture.supplier-performance-review.mode.evidence.summary"
          },
          "open-office-artifact": {
            "headingKey": "work-moment.fixture.supplier-performance-review.mode.office.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.supplier-performance-review.record.review-outcome-committed.detail",
                "evidenceRecordIds": [
                  "delivery-score",
                  "quality-score",
                  "supplier-response"
                ],
                "id": "review-outcome-committed",
                "labelKey": "work-moment.fixture.supplier-performance-review.record.review-outcome-committed.label",
                "ownerRoleId": "relationship-manager",
                "state": "committed"
              }
            ],
            "summaryKey": "work-moment.fixture.supplier-performance-review.mode.office.summary"
          },
          "review-learning": {
            "headingKey": "work-moment.fixture.supplier-performance-review.mode.learning.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.supplier-performance-review.record.disputed-score-reviewed.detail",
                "evidenceRecordIds": [
                  "quality-score",
                  "supplier-response"
                ],
                "id": "disputed-score-reviewed",
                "labelKey": "work-moment.fixture.supplier-performance-review.record.disputed-score-reviewed.label",
                "ownerRoleId": "governance-owner",
                "state": "reviewed"
              }
            ],
            "summaryKey": "work-moment.fixture.supplier-performance-review.mode.learning.summary"
          },
          "supervise-work": {
            "headingKey": "work-moment.fixture.supplier-performance-review.mode.supervise.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.supplier-performance-review.record.review-pack-ready.detail",
                "evidenceRecordIds": [
                  "delivery-score"
                ],
                "id": "review-pack-ready",
                "labelKey": "work-moment.fixture.supplier-performance-review.record.review-pack-ready.label",
                "ownerRoleId": "relationship-manager",
                "state": "normal"
              },
              {
                "detailKey": "work-moment.fixture.supplier-performance-review.record.quality-score-disputed.detail",
                "evidenceRecordIds": [
                  "quality-score",
                  "supplier-response"
                ],
                "id": "quality-score-disputed",
                "labelKey": "work-moment.fixture.supplier-performance-review.record.quality-score-disputed.label",
                "ownerRoleId": "relationship-manager",
                "state": "exception"
              },
              {
                "detailKey": "work-moment.fixture.supplier-performance-review.record.corrective-action-proposed.detail",
                "evidenceRecordIds": [
                  "delivery-score",
                  "quality-score"
                ],
                "id": "corrective-action-proposed",
                "labelKey": "work-moment.fixture.supplier-performance-review.record.corrective-action-proposed.label",
                "ownerRoleId": "relationship-manager",
                "state": "proposal"
              }
            ],
            "summaryKey": "work-moment.fixture.supplier-performance-review.mode.supervise.summary"
          }
        },
        "officeArtifacts": [
          {
            "artifactTypeKey": "work-moment.fixture.supplier-performance-review.office.conductor.type",
            "labelKey": "work-moment.fixture.supplier-performance-review.office.conductor.label",
            "product": "conductor",
            "proposalKey": "work-moment.fixture.supplier-performance-review.office.conductor.proposal",
            "returnRecordKey": "work-moment.fixture.supplier-performance-review.office.conductor.return",
            "reviewedVersionKey": "work-moment.fixture.supplier-performance-review.office.conductor.version",
            "scopeKey": "work-moment.fixture.supplier-performance-review.office.conductor.scope",
            "state": "in-review"
          },
          {
            "artifactTypeKey": "work-moment.fixture.supplier-performance-review.office.composer.type",
            "labelKey": "work-moment.fixture.supplier-performance-review.office.composer.label",
            "product": "composer",
            "proposalKey": "work-moment.fixture.supplier-performance-review.office.composer.proposal",
            "returnRecordKey": "work-moment.fixture.supplier-performance-review.office.composer.return",
            "reviewedVersionKey": "work-moment.fixture.supplier-performance-review.office.composer.version",
            "scopeKey": "work-moment.fixture.supplier-performance-review.office.composer.scope",
            "state": "proposed"
          }
        ],
        "ownerRoleId": "relationship-manager",
        "synthetic": true
      },
      {
        "authorityGrantorRoleId": "controller",
        "escalationOwnerRoleId": "ap-processor",
        "evidenceRecords": [
          {
            "definitionKey": "work-moment.fixture.invoice-exception-triage.evidence.invoice-line.definition",
            "freshness": "current",
            "id": "invoice-line",
            "labelKey": "work-moment.fixture.invoice-exception-triage.evidence.invoice-line.label",
            "observedAt": "2026-08-12T08:20:00Z",
            "ownerRoleId": "ap-processor",
            "provenance": "source",
            "sourceKey": "work-moment.fixture.invoice-exception-triage.evidence.invoice-line.source"
          },
          {
            "definitionKey": "work-moment.fixture.invoice-exception-triage.evidence.receipt-record.definition",
            "freshness": "stale",
            "id": "receipt-record",
            "labelKey": "work-moment.fixture.invoice-exception-triage.evidence.receipt-record.label",
            "observedAt": "2026-08-08T17:45:00Z",
            "ownerRoleId": "ap-processor",
            "provenance": "source",
            "sourceKey": "work-moment.fixture.invoice-exception-triage.evidence.receipt-record.source"
          },
          {
            "definitionKey": "work-moment.fixture.invoice-exception-triage.evidence.policy-envelope.definition",
            "freshness": "current",
            "id": "policy-envelope",
            "labelKey": "work-moment.fixture.invoice-exception-triage.evidence.policy-envelope.label",
            "observedAt": "2026-08-01T09:00:00Z",
            "ownerRoleId": "controller",
            "provenance": "human",
            "sourceKey": "work-moment.fixture.invoice-exception-triage.evidence.policy-envelope.source"
          }
        ],
        "id": "invoice-exception-triage-fixture",
        "modes": {
          "explore-evidence": {
            "headingKey": "work-moment.fixture.invoice-exception-triage.mode.evidence.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.invoice-exception-triage.record.receipt-source-stale.detail",
                "evidenceRecordIds": [
                  "receipt-record"
                ],
                "id": "receipt-source-stale",
                "labelKey": "work-moment.fixture.invoice-exception-triage.record.receipt-source-stale.label",
                "ownerRoleId": "ap-processor",
                "state": "stale"
              }
            ],
            "summaryKey": "work-moment.fixture.invoice-exception-triage.mode.evidence.summary"
          },
          "review-learning": {
            "headingKey": "work-moment.fixture.invoice-exception-triage.mode.learning.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.invoice-exception-triage.record.correction-cohort-reviewed.detail",
                "evidenceRecordIds": [
                  "invoice-line",
                  "policy-envelope"
                ],
                "id": "correction-cohort-reviewed",
                "labelKey": "work-moment.fixture.invoice-exception-triage.record.correction-cohort-reviewed.label",
                "ownerRoleId": "controller",
                "state": "reviewed"
              }
            ],
            "summaryKey": "work-moment.fixture.invoice-exception-triage.mode.learning.summary"
          },
          "supervise-work": {
            "headingKey": "work-moment.fixture.invoice-exception-triage.mode.supervise.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.invoice-exception-triage.record.routine-route-ready.detail",
                "evidenceRecordIds": [
                  "invoice-line",
                  "policy-envelope"
                ],
                "id": "routine-route-ready",
                "labelKey": "work-moment.fixture.invoice-exception-triage.record.routine-route-ready.label",
                "ownerRoleId": "ap-processor",
                "state": "normal"
              },
              {
                "detailKey": "work-moment.fixture.invoice-exception-triage.record.receipt-needs-judgement.detail",
                "evidenceRecordIds": [
                  "invoice-line",
                  "receipt-record"
                ],
                "id": "receipt-needs-judgement",
                "labelKey": "work-moment.fixture.invoice-exception-triage.record.receipt-needs-judgement.label",
                "ownerRoleId": "ap-processor",
                "state": "exception"
              },
              {
                "detailKey": "work-moment.fixture.invoice-exception-triage.record.coding-correction-proposed.detail",
                "evidenceRecordIds": [
                  "invoice-line",
                  "policy-envelope"
                ],
                "id": "coding-correction-proposed",
                "labelKey": "work-moment.fixture.invoice-exception-triage.record.coding-correction-proposed.label",
                "ownerRoleId": "ap-processor",
                "state": "proposal"
              },
              {
                "detailKey": "work-moment.fixture.invoice-exception-triage.record.routine-case-committed.detail",
                "evidenceRecordIds": [
                  "invoice-line",
                  "policy-envelope"
                ],
                "id": "routine-case-committed",
                "labelKey": "work-moment.fixture.invoice-exception-triage.record.routine-case-committed.label",
                "ownerRoleId": "ap-processor",
                "state": "committed"
              }
            ],
            "summaryKey": "work-moment.fixture.invoice-exception-triage.mode.supervise.summary"
          }
        },
        "ownerRoleId": "ap-processor",
        "synthetic": true
      },
      {
        "authorityGrantorRoleId": "policy-owner",
        "escalationOwnerRoleId": "category-manager",
        "evidenceRecords": [
          {
            "definitionKey": "work-moment.fixture.category-strategy-refresh.evidence.spend-fact-base.definition",
            "freshness": "current",
            "id": "spend-fact-base",
            "labelKey": "work-moment.fixture.category-strategy-refresh.evidence.spend-fact-base.label",
            "observedAt": "2026-08-10T08:00:00Z",
            "ownerRoleId": "procurement-analyst",
            "provenance": "source",
            "sourceKey": "work-moment.fixture.category-strategy-refresh.evidence.spend-fact-base.source"
          },
          {
            "definitionKey": "work-moment.fixture.category-strategy-refresh.evidence.market-index.definition",
            "freshness": "conflicting",
            "id": "market-index",
            "labelKey": "work-moment.fixture.category-strategy-refresh.evidence.market-index.label",
            "observedAt": "2026-08-11T06:30:00Z",
            "ownerRoleId": "procurement-analyst",
            "provenance": "source",
            "sourceKey": "work-moment.fixture.category-strategy-refresh.evidence.market-index.source"
          },
          {
            "definitionKey": "work-moment.fixture.category-strategy-refresh.evidence.strategy-objectives.definition",
            "freshness": "current",
            "id": "strategy-objectives",
            "labelKey": "work-moment.fixture.category-strategy-refresh.evidence.strategy-objectives.label",
            "observedAt": "2026-08-01T09:00:00Z",
            "ownerRoleId": "category-manager",
            "provenance": "human",
            "sourceKey": "work-moment.fixture.category-strategy-refresh.evidence.strategy-objectives.source"
          }
        ],
        "id": "category-strategy-refresh-fixture",
        "modes": {
          "explore-evidence": {
            "headingKey": "work-moment.fixture.category-strategy-refresh.mode.evidence.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.category-strategy-refresh.record.index-sources-conflict.detail",
                "evidenceRecordIds": [
                  "market-index"
                ],
                "id": "index-sources-conflict",
                "labelKey": "work-moment.fixture.category-strategy-refresh.record.index-sources-conflict.label",
                "ownerRoleId": "procurement-analyst",
                "state": "conflicting"
              }
            ],
            "summaryKey": "work-moment.fixture.category-strategy-refresh.mode.evidence.summary"
          },
          "open-office-artifact": {
            "headingKey": "work-moment.fixture.category-strategy-refresh.mode.office.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.category-strategy-refresh.record.version-committed.detail",
                "evidenceRecordIds": [
                  "spend-fact-base",
                  "strategy-objectives"
                ],
                "id": "version-committed",
                "labelKey": "work-moment.fixture.category-strategy-refresh.record.version-committed.label",
                "ownerRoleId": "category-manager",
                "state": "committed"
              }
            ],
            "summaryKey": "work-moment.fixture.category-strategy-refresh.mode.office.summary"
          },
          "review-learning": {
            "headingKey": "work-moment.fixture.category-strategy-refresh.mode.learning.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.category-strategy-refresh.record.refresh-cohort-reviewed.detail",
                "evidenceRecordIds": [
                  "market-index"
                ],
                "id": "refresh-cohort-reviewed",
                "labelKey": "work-moment.fixture.category-strategy-refresh.record.refresh-cohort-reviewed.label",
                "ownerRoleId": "policy-owner",
                "state": "reviewed"
              }
            ],
            "summaryKey": "work-moment.fixture.category-strategy-refresh.mode.learning.summary"
          },
          "supervise-work": {
            "headingKey": "work-moment.fixture.category-strategy-refresh.mode.supervise.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.category-strategy-refresh.record.refresh-ready.detail",
                "evidenceRecordIds": [
                  "spend-fact-base"
                ],
                "id": "refresh-ready",
                "labelKey": "work-moment.fixture.category-strategy-refresh.record.refresh-ready.label",
                "ownerRoleId": "category-manager",
                "state": "normal"
              },
              {
                "detailKey": "work-moment.fixture.category-strategy-refresh.record.index-conflict.detail",
                "evidenceRecordIds": [
                  "market-index"
                ],
                "id": "index-conflict",
                "labelKey": "work-moment.fixture.category-strategy-refresh.record.index-conflict.label",
                "ownerRoleId": "procurement-analyst",
                "state": "exception"
              },
              {
                "detailKey": "work-moment.fixture.category-strategy-refresh.record.version-proposed.detail",
                "evidenceRecordIds": [
                  "spend-fact-base",
                  "strategy-objectives"
                ],
                "id": "version-proposed",
                "labelKey": "work-moment.fixture.category-strategy-refresh.record.version-proposed.label",
                "ownerRoleId": "category-manager",
                "state": "proposal"
              }
            ],
            "summaryKey": "work-moment.fixture.category-strategy-refresh.mode.supervise.summary"
          }
        },
        "officeArtifacts": [
          {
            "artifactTypeKey": "work-moment.fixture.category-strategy-refresh.office.conductor.type",
            "labelKey": "work-moment.fixture.category-strategy-refresh.office.conductor.label",
            "product": "conductor",
            "proposalKey": "work-moment.fixture.category-strategy-refresh.office.conductor.proposal",
            "returnRecordKey": "work-moment.fixture.category-strategy-refresh.office.conductor.return",
            "reviewedVersionKey": "work-moment.fixture.category-strategy-refresh.office.conductor.version",
            "scopeKey": "work-moment.fixture.category-strategy-refresh.office.conductor.scope",
            "state": "in-review"
          },
          {
            "artifactTypeKey": "work-moment.fixture.category-strategy-refresh.office.composer.type",
            "labelKey": "work-moment.fixture.category-strategy-refresh.office.composer.label",
            "product": "composer",
            "proposalKey": "work-moment.fixture.category-strategy-refresh.office.composer.proposal",
            "returnRecordKey": "work-moment.fixture.category-strategy-refresh.office.composer.return",
            "reviewedVersionKey": "work-moment.fixture.category-strategy-refresh.office.composer.version",
            "scopeKey": "work-moment.fixture.category-strategy-refresh.office.composer.scope",
            "state": "proposed"
          }
        ],
        "ownerRoleId": "category-manager",
        "synthetic": true
      },
      {
        "authorityGrantorRoleId": "process-owner",
        "escalationOwnerRoleId": "intake-owner",
        "evidenceRecords": [
          {
            "definitionKey": "work-moment.fixture.intake-clarification.evidence.request-intent.definition",
            "freshness": "current",
            "id": "request-intent",
            "labelKey": "work-moment.fixture.intake-clarification.evidence.request-intent.label",
            "observedAt": "2026-08-12T10:05:00Z",
            "ownerRoleId": "requester",
            "provenance": "human",
            "sourceKey": "work-moment.fixture.intake-clarification.evidence.request-intent.source"
          },
          {
            "definitionKey": "work-moment.fixture.intake-clarification.evidence.vendor-quote.definition",
            "freshness": "stale",
            "id": "vendor-quote",
            "labelKey": "work-moment.fixture.intake-clarification.evidence.vendor-quote.label",
            "observedAt": "2026-07-28T14:20:00Z",
            "ownerRoleId": "requester",
            "provenance": "source",
            "sourceKey": "work-moment.fixture.intake-clarification.evidence.vendor-quote.source"
          },
          {
            "definitionKey": "work-moment.fixture.intake-clarification.evidence.offering-contract.definition",
            "freshness": "current",
            "id": "offering-contract",
            "labelKey": "work-moment.fixture.intake-clarification.evidence.offering-contract.label",
            "observedAt": "2026-08-12T10:06:00Z",
            "ownerRoleId": "process-owner",
            "provenance": "source",
            "sourceKey": "work-moment.fixture.intake-clarification.evidence.offering-contract.source"
          }
        ],
        "id": "intake-clarification-fixture",
        "modes": {
          "explore-evidence": {
            "headingKey": "work-moment.fixture.intake-clarification.mode.evidence.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.intake-clarification.record.quote-validity-elapsed.detail",
                "evidenceRecordIds": [
                  "vendor-quote"
                ],
                "id": "quote-validity-elapsed",
                "labelKey": "work-moment.fixture.intake-clarification.record.quote-validity-elapsed.label",
                "ownerRoleId": "requester",
                "state": "stale"
              }
            ],
            "summaryKey": "work-moment.fixture.intake-clarification.mode.evidence.summary"
          },
          "review-learning": {
            "headingKey": "work-moment.fixture.intake-clarification.mode.learning.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.intake-clarification.record.clarification-cohort-reviewed.detail",
                "evidenceRecordIds": [
                  "request-intent"
                ],
                "id": "clarification-cohort-reviewed",
                "labelKey": "work-moment.fixture.intake-clarification.record.clarification-cohort-reviewed.label",
                "ownerRoleId": "process-owner",
                "state": "reviewed"
              }
            ],
            "summaryKey": "work-moment.fixture.intake-clarification.mode.learning.summary"
          },
          "supervise-work": {
            "headingKey": "work-moment.fixture.intake-clarification.mode.supervise.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.intake-clarification.record.intent-confirmed.detail",
                "evidenceRecordIds": [
                  "request-intent",
                  "offering-contract"
                ],
                "id": "intent-confirmed",
                "labelKey": "work-moment.fixture.intake-clarification.record.intent-confirmed.label",
                "ownerRoleId": "requester",
                "state": "normal"
              },
              {
                "detailKey": "work-moment.fixture.intake-clarification.record.quote-stale.detail",
                "evidenceRecordIds": [
                  "vendor-quote"
                ],
                "id": "quote-stale",
                "labelKey": "work-moment.fixture.intake-clarification.record.quote-stale.label",
                "ownerRoleId": "intake-owner",
                "state": "exception"
              },
              {
                "detailKey": "work-moment.fixture.intake-clarification.record.route-proposed.detail",
                "evidenceRecordIds": [
                  "request-intent",
                  "offering-contract"
                ],
                "id": "route-proposed",
                "labelKey": "work-moment.fixture.intake-clarification.record.route-proposed.label",
                "ownerRoleId": "intake-owner",
                "state": "proposal"
              },
              {
                "detailKey": "work-moment.fixture.intake-clarification.record.need-committed.detail",
                "evidenceRecordIds": [
                  "request-intent"
                ],
                "id": "need-committed",
                "labelKey": "work-moment.fixture.intake-clarification.record.need-committed.label",
                "ownerRoleId": "requester",
                "state": "committed"
              }
            ],
            "summaryKey": "work-moment.fixture.intake-clarification.mode.supervise.summary"
          }
        },
        "ownerRoleId": "requester",
        "synthetic": true
      },
      {
        "authorityGrantorRoleId": "sourcing-lead",
        "escalationOwnerRoleId": "sourcing-lead",
        "evidenceRecords": [
          {
            "definitionKey": "work-moment.fixture.sourcing-event-amendment.evidence.published-version.definition",
            "freshness": "current",
            "id": "published-version",
            "labelKey": "work-moment.fixture.sourcing-event-amendment.evidence.published-version.label",
            "observedAt": "2026-08-09T09:00:00Z",
            "ownerRoleId": "sourcing-lead",
            "provenance": "source",
            "sourceKey": "work-moment.fixture.sourcing-event-amendment.evidence.published-version.source"
          },
          {
            "definitionKey": "work-moment.fixture.sourcing-event-amendment.evidence.clarification-question.definition",
            "freshness": "current",
            "id": "clarification-question",
            "labelKey": "work-moment.fixture.sourcing-event-amendment.evidence.clarification-question.label",
            "observedAt": "2026-08-12T15:40:00Z",
            "ownerRoleId": "sourcing-lead",
            "provenance": "human",
            "sourceKey": "work-moment.fixture.sourcing-event-amendment.evidence.clarification-question.source"
          },
          {
            "definitionKey": "work-moment.fixture.sourcing-event-amendment.evidence.legacy-attachment.definition",
            "freshness": "conflicting",
            "id": "legacy-attachment",
            "labelKey": "work-moment.fixture.sourcing-event-amendment.evidence.legacy-attachment.label",
            "observedAt": "2026-08-05T11:00:00Z",
            "ownerRoleId": "evaluator",
            "provenance": "source",
            "sourceKey": "work-moment.fixture.sourcing-event-amendment.evidence.legacy-attachment.source"
          }
        ],
        "id": "sourcing-event-amendment-fixture",
        "modes": {
          "explore-evidence": {
            "headingKey": "work-moment.fixture.sourcing-event-amendment.mode.evidence.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.sourcing-event-amendment.record.requirement-conflict.detail",
                "evidenceRecordIds": [
                  "legacy-attachment",
                  "published-version"
                ],
                "id": "requirement-conflict",
                "labelKey": "work-moment.fixture.sourcing-event-amendment.record.requirement-conflict.label",
                "ownerRoleId": "evaluator",
                "state": "conflicting"
              }
            ],
            "summaryKey": "work-moment.fixture.sourcing-event-amendment.mode.evidence.summary"
          },
          "open-office-artifact": {
            "headingKey": "work-moment.fixture.sourcing-event-amendment.mode.office.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.sourcing-event-amendment.record.amendment-committed.detail",
                "evidenceRecordIds": [
                  "published-version",
                  "clarification-question"
                ],
                "id": "amendment-committed",
                "labelKey": "work-moment.fixture.sourcing-event-amendment.record.amendment-committed.label",
                "ownerRoleId": "sourcing-lead",
                "state": "committed"
              }
            ],
            "summaryKey": "work-moment.fixture.sourcing-event-amendment.mode.office.summary"
          },
          "review-learning": {
            "headingKey": "work-moment.fixture.sourcing-event-amendment.mode.learning.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.sourcing-event-amendment.record.amendment-cohort-reviewed.detail",
                "evidenceRecordIds": [
                  "clarification-question"
                ],
                "id": "amendment-cohort-reviewed",
                "labelKey": "work-moment.fixture.sourcing-event-amendment.record.amendment-cohort-reviewed.label",
                "ownerRoleId": "sourcing-lead",
                "state": "reviewed"
              }
            ],
            "summaryKey": "work-moment.fixture.sourcing-event-amendment.mode.learning.summary"
          },
          "supervise-work": {
            "headingKey": "work-moment.fixture.sourcing-event-amendment.mode.supervise.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.sourcing-event-amendment.record.draft-ready.detail",
                "evidenceRecordIds": [
                  "published-version",
                  "clarification-question"
                ],
                "id": "draft-ready",
                "labelKey": "work-moment.fixture.sourcing-event-amendment.record.draft-ready.label",
                "ownerRoleId": "sourcing-lead",
                "state": "normal"
              },
              {
                "detailKey": "work-moment.fixture.sourcing-event-amendment.record.attachment-conflict.detail",
                "evidenceRecordIds": [
                  "legacy-attachment",
                  "published-version"
                ],
                "id": "attachment-conflict",
                "labelKey": "work-moment.fixture.sourcing-event-amendment.record.attachment-conflict.label",
                "ownerRoleId": "sourcing-lead",
                "state": "exception"
              },
              {
                "detailKey": "work-moment.fixture.sourcing-event-amendment.record.amendment-proposed.detail",
                "evidenceRecordIds": [
                  "published-version",
                  "clarification-question"
                ],
                "id": "amendment-proposed",
                "labelKey": "work-moment.fixture.sourcing-event-amendment.record.amendment-proposed.label",
                "ownerRoleId": "sourcing-lead",
                "state": "proposal"
              }
            ],
            "summaryKey": "work-moment.fixture.sourcing-event-amendment.mode.supervise.summary"
          }
        },
        "officeArtifacts": [
          {
            "artifactTypeKey": "work-moment.fixture.sourcing-event-amendment.office.composer.type",
            "labelKey": "work-moment.fixture.sourcing-event-amendment.office.composer.label",
            "product": "composer",
            "proposalKey": "work-moment.fixture.sourcing-event-amendment.office.composer.proposal",
            "returnRecordKey": "work-moment.fixture.sourcing-event-amendment.office.composer.return",
            "reviewedVersionKey": "work-moment.fixture.sourcing-event-amendment.office.composer.version",
            "scopeKey": "work-moment.fixture.sourcing-event-amendment.office.composer.scope",
            "state": "in-review"
          },
          {
            "artifactTypeKey": "work-moment.fixture.sourcing-event-amendment.office.conductor.type",
            "labelKey": "work-moment.fixture.sourcing-event-amendment.office.conductor.label",
            "product": "conductor",
            "proposalKey": "work-moment.fixture.sourcing-event-amendment.office.conductor.proposal",
            "returnRecordKey": "work-moment.fixture.sourcing-event-amendment.office.conductor.return",
            "reviewedVersionKey": "work-moment.fixture.sourcing-event-amendment.office.conductor.version",
            "scopeKey": "work-moment.fixture.sourcing-event-amendment.office.conductor.scope",
            "state": "proposed"
          }
        ],
        "ownerRoleId": "sourcing-lead",
        "synthetic": true
      },
      {
        "authorityGrantorRoleId": "contract-manager",
        "escalationOwnerRoleId": "legal-counsel",
        "evidenceRecords": [
          {
            "definitionKey": "work-moment.fixture.contract-redline-review.evidence.supplier-draft.definition",
            "freshness": "current",
            "id": "supplier-draft",
            "labelKey": "work-moment.fixture.contract-redline-review.evidence.supplier-draft.label",
            "observedAt": "2026-08-11T16:15:00Z",
            "ownerRoleId": "legal-counsel",
            "provenance": "source",
            "sourceKey": "work-moment.fixture.contract-redline-review.evidence.supplier-draft.source"
          },
          {
            "definitionKey": "work-moment.fixture.contract-redline-review.evidence.playbook-position.definition",
            "freshness": "current",
            "id": "playbook-position",
            "labelKey": "work-moment.fixture.contract-redline-review.evidence.playbook-position.label",
            "observedAt": "2026-08-03T09:00:00Z",
            "ownerRoleId": "contract-manager",
            "provenance": "human",
            "sourceKey": "work-moment.fixture.contract-redline-review.evidence.playbook-position.source"
          },
          {
            "definitionKey": "work-moment.fixture.contract-redline-review.evidence.negotiation-history.definition",
            "freshness": "stale",
            "id": "negotiation-history",
            "labelKey": "work-moment.fixture.contract-redline-review.evidence.negotiation-history.label",
            "observedAt": "2026-08-04T13:30:00Z",
            "ownerRoleId": "sourcing-manager",
            "provenance": "source",
            "sourceKey": "work-moment.fixture.contract-redline-review.evidence.negotiation-history.source"
          }
        ],
        "id": "contract-redline-review-fixture",
        "modes": {
          "explore-evidence": {
            "headingKey": "work-moment.fixture.contract-redline-review.mode.evidence.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.contract-redline-review.record.history-stale.detail",
                "evidenceRecordIds": [
                  "negotiation-history"
                ],
                "id": "history-stale",
                "labelKey": "work-moment.fixture.contract-redline-review.record.history-stale.label",
                "ownerRoleId": "sourcing-manager",
                "state": "stale"
              }
            ],
            "summaryKey": "work-moment.fixture.contract-redline-review.mode.evidence.summary"
          },
          "open-office-artifact": {
            "headingKey": "work-moment.fixture.contract-redline-review.mode.office.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.contract-redline-review.record.clause-committed.detail",
                "evidenceRecordIds": [
                  "supplier-draft",
                  "playbook-position"
                ],
                "id": "clause-committed",
                "labelKey": "work-moment.fixture.contract-redline-review.record.clause-committed.label",
                "ownerRoleId": "legal-counsel",
                "state": "committed"
              }
            ],
            "summaryKey": "work-moment.fixture.contract-redline-review.mode.office.summary"
          },
          "review-learning": {
            "headingKey": "work-moment.fixture.contract-redline-review.mode.learning.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.contract-redline-review.record.deviation-cohort-reviewed.detail",
                "evidenceRecordIds": [
                  "playbook-position"
                ],
                "id": "deviation-cohort-reviewed",
                "labelKey": "work-moment.fixture.contract-redline-review.record.deviation-cohort-reviewed.label",
                "ownerRoleId": "contract-manager",
                "state": "reviewed"
              }
            ],
            "summaryKey": "work-moment.fixture.contract-redline-review.mode.learning.summary"
          },
          "supervise-work": {
            "headingKey": "work-moment.fixture.contract-redline-review.mode.supervise.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.contract-redline-review.record.redlines-ready.detail",
                "evidenceRecordIds": [
                  "supplier-draft",
                  "playbook-position"
                ],
                "id": "redlines-ready",
                "labelKey": "work-moment.fixture.contract-redline-review.record.redlines-ready.label",
                "ownerRoleId": "legal-counsel",
                "state": "normal"
              },
              {
                "detailKey": "work-moment.fixture.contract-redline-review.record.position-stale.detail",
                "evidenceRecordIds": [
                  "negotiation-history"
                ],
                "id": "position-stale",
                "labelKey": "work-moment.fixture.contract-redline-review.record.position-stale.label",
                "ownerRoleId": "sourcing-manager",
                "state": "exception"
              },
              {
                "detailKey": "work-moment.fixture.contract-redline-review.record.redline-proposed.detail",
                "evidenceRecordIds": [
                  "supplier-draft",
                  "playbook-position"
                ],
                "id": "redline-proposed",
                "labelKey": "work-moment.fixture.contract-redline-review.record.redline-proposed.label",
                "ownerRoleId": "legal-counsel",
                "state": "proposal"
              }
            ],
            "summaryKey": "work-moment.fixture.contract-redline-review.mode.supervise.summary"
          }
        },
        "officeArtifacts": [
          {
            "artifactTypeKey": "work-moment.fixture.contract-redline-review.office.composer.type",
            "labelKey": "work-moment.fixture.contract-redline-review.office.composer.label",
            "product": "composer",
            "proposalKey": "work-moment.fixture.contract-redline-review.office.composer.proposal",
            "returnRecordKey": "work-moment.fixture.contract-redline-review.office.composer.return",
            "reviewedVersionKey": "work-moment.fixture.contract-redline-review.office.composer.version",
            "scopeKey": "work-moment.fixture.contract-redline-review.office.composer.scope",
            "state": "in-review"
          }
        ],
        "ownerRoleId": "legal-counsel",
        "synthetic": true
      },
      {
        "authorityGrantorRoleId": "tprm-programme-owner",
        "escalationOwnerRoleId": "accountable-risk-owner",
        "evidenceRecords": [
          {
            "definitionKey": "work-moment.fixture.third-party-risk-decision.evidence.security-certificate.definition",
            "freshness": "current",
            "id": "security-certificate",
            "labelKey": "work-moment.fixture.third-party-risk-decision.evidence.security-certificate.label",
            "observedAt": "2026-08-06T12:00:00Z",
            "ownerRoleId": "tprm-programme-owner",
            "provenance": "source",
            "sourceKey": "work-moment.fixture.third-party-risk-decision.evidence.security-certificate.source"
          },
          {
            "definitionKey": "work-moment.fixture.third-party-risk-decision.evidence.questionnaire-response.definition",
            "freshness": "conflicting",
            "id": "questionnaire-response",
            "labelKey": "work-moment.fixture.third-party-risk-decision.evidence.questionnaire-response.label",
            "observedAt": "2026-08-08T10:45:00Z",
            "ownerRoleId": "supplier-contact",
            "provenance": "human",
            "sourceKey": "work-moment.fixture.third-party-risk-decision.evidence.questionnaire-response.source"
          },
          {
            "definitionKey": "work-moment.fixture.third-party-risk-decision.evidence.service-scope.definition",
            "freshness": "current",
            "id": "service-scope",
            "labelKey": "work-moment.fixture.third-party-risk-decision.evidence.service-scope.label",
            "observedAt": "2026-08-10T09:15:00Z",
            "ownerRoleId": "accountable-risk-owner",
            "provenance": "source",
            "sourceKey": "work-moment.fixture.third-party-risk-decision.evidence.service-scope.source"
          }
        ],
        "id": "third-party-risk-decision-fixture",
        "modes": {
          "explore-evidence": {
            "headingKey": "work-moment.fixture.third-party-risk-decision.mode.evidence.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.third-party-risk-decision.record.control-conflict.detail",
                "evidenceRecordIds": [
                  "security-certificate",
                  "questionnaire-response"
                ],
                "id": "control-conflict",
                "labelKey": "work-moment.fixture.third-party-risk-decision.record.control-conflict.label",
                "ownerRoleId": "tprm-programme-owner",
                "state": "conflicting"
              }
            ],
            "summaryKey": "work-moment.fixture.third-party-risk-decision.mode.evidence.summary"
          },
          "open-office-artifact": {
            "headingKey": "work-moment.fixture.third-party-risk-decision.mode.office.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.third-party-risk-decision.record.decision-committed.detail",
                "evidenceRecordIds": [
                  "service-scope",
                  "security-certificate",
                  "questionnaire-response"
                ],
                "id": "decision-committed",
                "labelKey": "work-moment.fixture.third-party-risk-decision.record.decision-committed.label",
                "ownerRoleId": "accountable-risk-owner",
                "state": "committed"
              }
            ],
            "summaryKey": "work-moment.fixture.third-party-risk-decision.mode.office.summary"
          },
          "review-learning": {
            "headingKey": "work-moment.fixture.third-party-risk-decision.mode.learning.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.third-party-risk-decision.record.conflict-cohort-reviewed.detail",
                "evidenceRecordIds": [
                  "security-certificate",
                  "questionnaire-response"
                ],
                "id": "conflict-cohort-reviewed",
                "labelKey": "work-moment.fixture.third-party-risk-decision.record.conflict-cohort-reviewed.label",
                "ownerRoleId": "tprm-programme-owner",
                "state": "reviewed"
              }
            ],
            "summaryKey": "work-moment.fixture.third-party-risk-decision.mode.learning.summary"
          },
          "supervise-work": {
            "headingKey": "work-moment.fixture.third-party-risk-decision.mode.supervise.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.third-party-risk-decision.record.package-ready.detail",
                "evidenceRecordIds": [
                  "service-scope",
                  "security-certificate"
                ],
                "id": "package-ready",
                "labelKey": "work-moment.fixture.third-party-risk-decision.record.package-ready.label",
                "ownerRoleId": "accountable-risk-owner",
                "state": "normal"
              },
              {
                "detailKey": "work-moment.fixture.third-party-risk-decision.record.evidence-conflict.detail",
                "evidenceRecordIds": [
                  "security-certificate",
                  "questionnaire-response"
                ],
                "id": "evidence-conflict",
                "labelKey": "work-moment.fixture.third-party-risk-decision.record.evidence-conflict.label",
                "ownerRoleId": "tprm-programme-owner",
                "state": "exception"
              },
              {
                "detailKey": "work-moment.fixture.third-party-risk-decision.record.decision-proposed.detail",
                "evidenceRecordIds": [
                  "service-scope",
                  "security-certificate"
                ],
                "id": "decision-proposed",
                "labelKey": "work-moment.fixture.third-party-risk-decision.record.decision-proposed.label",
                "ownerRoleId": "accountable-risk-owner",
                "state": "proposal"
              }
            ],
            "summaryKey": "work-moment.fixture.third-party-risk-decision.mode.supervise.summary"
          }
        },
        "officeArtifacts": [
          {
            "artifactTypeKey": "work-moment.fixture.third-party-risk-decision.office.conductor.type",
            "labelKey": "work-moment.fixture.third-party-risk-decision.office.conductor.label",
            "product": "conductor",
            "proposalKey": "work-moment.fixture.third-party-risk-decision.office.conductor.proposal",
            "returnRecordKey": "work-moment.fixture.third-party-risk-decision.office.conductor.return",
            "reviewedVersionKey": "work-moment.fixture.third-party-risk-decision.office.conductor.version",
            "scopeKey": "work-moment.fixture.third-party-risk-decision.office.conductor.scope",
            "state": "in-review"
          },
          {
            "artifactTypeKey": "work-moment.fixture.third-party-risk-decision.office.composer.type",
            "labelKey": "work-moment.fixture.third-party-risk-decision.office.composer.label",
            "product": "composer",
            "proposalKey": "work-moment.fixture.third-party-risk-decision.office.composer.proposal",
            "returnRecordKey": "work-moment.fixture.third-party-risk-decision.office.composer.return",
            "reviewedVersionKey": "work-moment.fixture.third-party-risk-decision.office.composer.version",
            "scopeKey": "work-moment.fixture.third-party-risk-decision.office.composer.scope",
            "state": "proposed"
          }
        ],
        "ownerRoleId": "accountable-risk-owner",
        "synthetic": true
      },
      {
        "authorityGrantorRoleId": "budget-owner",
        "escalationOwnerRoleId": "procurement-buyer",
        "evidenceRecords": [
          {
            "definitionKey": "work-moment.fixture.guided-buying-route.evidence.stated-need.definition",
            "freshness": "current",
            "id": "stated-need",
            "labelKey": "work-moment.fixture.guided-buying-route.evidence.stated-need.label",
            "observedAt": "2026-08-13T08:30:00Z",
            "ownerRoleId": "requester",
            "provenance": "human",
            "sourceKey": "work-moment.fixture.guided-buying-route.evidence.stated-need.source"
          },
          {
            "definitionKey": "work-moment.fixture.guided-buying-route.evidence.contract-price.definition",
            "freshness": "current",
            "id": "contract-price",
            "labelKey": "work-moment.fixture.guided-buying-route.evidence.contract-price.label",
            "observedAt": "2026-08-13T08:31:00Z",
            "ownerRoleId": "procurement-buyer",
            "provenance": "source",
            "sourceKey": "work-moment.fixture.guided-buying-route.evidence.contract-price.source"
          },
          {
            "definitionKey": "work-moment.fixture.guided-buying-route.evidence.catalogue-item.definition",
            "freshness": "stale",
            "id": "catalogue-item",
            "labelKey": "work-moment.fixture.guided-buying-route.evidence.catalogue-item.label",
            "observedAt": "2026-08-11T05:00:00Z",
            "ownerRoleId": "procurement-buyer",
            "provenance": "source",
            "sourceKey": "work-moment.fixture.guided-buying-route.evidence.catalogue-item.source"
          }
        ],
        "id": "guided-buying-route-fixture",
        "modes": {
          "explore-evidence": {
            "headingKey": "work-moment.fixture.guided-buying-route.mode.evidence.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.guided-buying-route.record.catalogue-feed-stale.detail",
                "evidenceRecordIds": [
                  "catalogue-item"
                ],
                "id": "catalogue-feed-stale",
                "labelKey": "work-moment.fixture.guided-buying-route.record.catalogue-feed-stale.label",
                "ownerRoleId": "procurement-buyer",
                "state": "stale"
              }
            ],
            "summaryKey": "work-moment.fixture.guided-buying-route.mode.evidence.summary"
          },
          "review-learning": {
            "headingKey": "work-moment.fixture.guided-buying-route.mode.learning.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.guided-buying-route.record.route-cohort-reviewed.detail",
                "evidenceRecordIds": [
                  "catalogue-item"
                ],
                "id": "route-cohort-reviewed",
                "labelKey": "work-moment.fixture.guided-buying-route.record.route-cohort-reviewed.label",
                "ownerRoleId": "procurement-buyer",
                "state": "reviewed"
              }
            ],
            "summaryKey": "work-moment.fixture.guided-buying-route.mode.learning.summary"
          },
          "supervise-work": {
            "headingKey": "work-moment.fixture.guided-buying-route.mode.supervise.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.guided-buying-route.record.route-progressing.detail",
                "evidenceRecordIds": [
                  "stated-need",
                  "contract-price"
                ],
                "id": "route-progressing",
                "labelKey": "work-moment.fixture.guided-buying-route.record.route-progressing.label",
                "ownerRoleId": "requester",
                "state": "normal"
              },
              {
                "detailKey": "work-moment.fixture.guided-buying-route.record.availability-stale.detail",
                "evidenceRecordIds": [
                  "catalogue-item"
                ],
                "id": "availability-stale",
                "labelKey": "work-moment.fixture.guided-buying-route.record.availability-stale.label",
                "ownerRoleId": "procurement-buyer",
                "state": "exception"
              },
              {
                "detailKey": "work-moment.fixture.guided-buying-route.record.option-proposed.detail",
                "evidenceRecordIds": [
                  "stated-need",
                  "contract-price"
                ],
                "id": "option-proposed",
                "labelKey": "work-moment.fixture.guided-buying-route.record.option-proposed.label",
                "ownerRoleId": "requester",
                "state": "proposal"
              },
              {
                "detailKey": "work-moment.fixture.guided-buying-route.record.need-committed.detail",
                "evidenceRecordIds": [
                  "stated-need",
                  "contract-price"
                ],
                "id": "need-committed",
                "labelKey": "work-moment.fixture.guided-buying-route.record.need-committed.label",
                "ownerRoleId": "requester",
                "state": "committed"
              }
            ],
            "summaryKey": "work-moment.fixture.guided-buying-route.mode.supervise.summary"
          }
        },
        "ownerRoleId": "requester",
        "synthetic": true
      },
      {
        "authorityGrantorRoleId": "budget-owner",
        "escalationOwnerRoleId": "value-lead",
        "evidenceRecords": [
          {
            "definitionKey": "work-moment.fixture.savings-validation.evidence.committed-baseline.definition",
            "freshness": "current",
            "id": "committed-baseline",
            "labelKey": "work-moment.fixture.savings-validation.evidence.committed-baseline.label",
            "observedAt": "2026-08-01T09:00:00Z",
            "ownerRoleId": "finance-delegate",
            "provenance": "source",
            "sourceKey": "work-moment.fixture.savings-validation.evidence.committed-baseline.source"
          },
          {
            "definitionKey": "work-moment.fixture.savings-validation.evidence.period-actuals.definition",
            "freshness": "current",
            "id": "period-actuals",
            "labelKey": "work-moment.fixture.savings-validation.evidence.period-actuals.label",
            "observedAt": "2026-08-12T07:00:00Z",
            "ownerRoleId": "value-lead",
            "provenance": "source",
            "sourceKey": "work-moment.fixture.savings-validation.evidence.period-actuals.source"
          },
          {
            "definitionKey": "work-moment.fixture.savings-validation.evidence.adjustment-claim.definition",
            "freshness": "conflicting",
            "id": "adjustment-claim",
            "labelKey": "work-moment.fixture.savings-validation.evidence.adjustment-claim.label",
            "observedAt": "2026-08-12T07:05:00Z",
            "ownerRoleId": "value-lead",
            "provenance": "machine",
            "sourceKey": "work-moment.fixture.savings-validation.evidence.adjustment-claim.source"
          }
        ],
        "id": "savings-validation-fixture",
        "modes": {
          "explore-evidence": {
            "headingKey": "work-moment.fixture.savings-validation.mode.evidence.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.savings-validation.record.adjustment-evidence-conflict.detail",
                "evidenceRecordIds": [
                  "adjustment-claim",
                  "period-actuals"
                ],
                "id": "adjustment-evidence-conflict",
                "labelKey": "work-moment.fixture.savings-validation.record.adjustment-evidence-conflict.label",
                "ownerRoleId": "value-lead",
                "state": "conflicting"
              }
            ],
            "summaryKey": "work-moment.fixture.savings-validation.mode.evidence.summary"
          },
          "open-office-artifact": {
            "headingKey": "work-moment.fixture.savings-validation.mode.office.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.savings-validation.record.result-committed.detail",
                "evidenceRecordIds": [
                  "committed-baseline",
                  "period-actuals",
                  "adjustment-claim"
                ],
                "id": "result-committed",
                "labelKey": "work-moment.fixture.savings-validation.record.result-committed.label",
                "ownerRoleId": "finance-delegate",
                "state": "committed"
              }
            ],
            "summaryKey": "work-moment.fixture.savings-validation.mode.office.summary"
          },
          "review-learning": {
            "headingKey": "work-moment.fixture.savings-validation.mode.learning.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.savings-validation.record.validation-cohort-reviewed.detail",
                "evidenceRecordIds": [
                  "adjustment-claim"
                ],
                "id": "validation-cohort-reviewed",
                "labelKey": "work-moment.fixture.savings-validation.record.validation-cohort-reviewed.label",
                "ownerRoleId": "finance-delegate",
                "state": "reviewed"
              }
            ],
            "summaryKey": "work-moment.fixture.savings-validation.mode.learning.summary"
          },
          "supervise-work": {
            "headingKey": "work-moment.fixture.savings-validation.mode.supervise.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.savings-validation.record.claim-calculated.detail",
                "evidenceRecordIds": [
                  "committed-baseline",
                  "period-actuals"
                ],
                "id": "claim-calculated",
                "labelKey": "work-moment.fixture.savings-validation.record.claim-calculated.label",
                "ownerRoleId": "finance-delegate",
                "state": "normal"
              },
              {
                "detailKey": "work-moment.fixture.savings-validation.record.adjustment-conflict.detail",
                "evidenceRecordIds": [
                  "adjustment-claim"
                ],
                "id": "adjustment-conflict",
                "labelKey": "work-moment.fixture.savings-validation.record.adjustment-conflict.label",
                "ownerRoleId": "value-lead",
                "state": "exception"
              },
              {
                "detailKey": "work-moment.fixture.savings-validation.record.validation-proposed.detail",
                "evidenceRecordIds": [
                  "committed-baseline",
                  "period-actuals"
                ],
                "id": "validation-proposed",
                "labelKey": "work-moment.fixture.savings-validation.record.validation-proposed.label",
                "ownerRoleId": "finance-delegate",
                "state": "proposal"
              }
            ],
            "summaryKey": "work-moment.fixture.savings-validation.mode.supervise.summary"
          }
        },
        "officeArtifacts": [
          {
            "artifactTypeKey": "work-moment.fixture.savings-validation.office.conductor.type",
            "labelKey": "work-moment.fixture.savings-validation.office.conductor.label",
            "product": "conductor",
            "proposalKey": "work-moment.fixture.savings-validation.office.conductor.proposal",
            "returnRecordKey": "work-moment.fixture.savings-validation.office.conductor.return",
            "reviewedVersionKey": "work-moment.fixture.savings-validation.office.conductor.version",
            "scopeKey": "work-moment.fixture.savings-validation.office.conductor.scope",
            "state": "in-review"
          }
        ],
        "ownerRoleId": "finance-delegate",
        "synthetic": true
      },
      {
        "authorityGrantorRoleId": "sourcing-lead",
        "escalationOwnerRoleId": "sourcing-lead",
        "evidenceRecords": [
          {
            "definitionKey": "work-moment.fixture.direct-material-buy-timing.evidence.commodity-price-outlook.definition",
            "freshness": "current",
            "id": "commodity-price-outlook",
            "labelKey": "work-moment.fixture.direct-material-buy-timing.evidence.commodity-price-outlook.label",
            "observedAt": "2026-08-12T07:30:00Z",
            "ownerRoleId": "sourcing-lead",
            "provenance": "machine",
            "sourceKey": "work-moment.fixture.direct-material-buy-timing.evidence.commodity-price-outlook.source"
          },
          {
            "definitionKey": "work-moment.fixture.direct-material-buy-timing.evidence.coverage-position.definition",
            "freshness": "current",
            "id": "coverage-position",
            "labelKey": "work-moment.fixture.direct-material-buy-timing.evidence.coverage-position.label",
            "observedAt": "2026-08-12T07:35:00Z",
            "ownerRoleId": "sourcing-lead",
            "provenance": "machine",
            "sourceKey": "work-moment.fixture.direct-material-buy-timing.evidence.coverage-position.source"
          },
          {
            "definitionKey": "work-moment.fixture.direct-material-buy-timing.evidence.demand-portfolio-commitment.definition",
            "freshness": "current",
            "id": "demand-portfolio-commitment",
            "labelKey": "work-moment.fixture.direct-material-buy-timing.evidence.demand-portfolio-commitment.label",
            "observedAt": "2026-08-11T16:00:00Z",
            "ownerRoleId": "sourcing-lead",
            "provenance": "source",
            "sourceKey": "work-moment.fixture.direct-material-buy-timing.evidence.demand-portfolio-commitment.source"
          },
          {
            "definitionKey": "work-moment.fixture.direct-material-buy-timing.evidence.price-assessment-feed.definition",
            "freshness": "conflicting",
            "id": "price-assessment-feed",
            "labelKey": "work-moment.fixture.direct-material-buy-timing.evidence.price-assessment-feed.label",
            "observedAt": "2026-08-12T06:00:00Z",
            "ownerRoleId": "evaluator",
            "provenance": "source",
            "sourceKey": "work-moment.fixture.direct-material-buy-timing.evidence.price-assessment-feed.source"
          }
        ],
        "id": "direct-material-buy-timing-fixture",
        "modes": {
          "explore-evidence": {
            "headingKey": "work-moment.fixture.direct-material-buy-timing.mode.explore.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.direct-material-buy-timing.record.assessment-sources-disagree.detail",
                "evidenceRecordIds": [
                  "price-assessment-feed"
                ],
                "id": "assessment-sources-disagree",
                "labelKey": "work-moment.fixture.direct-material-buy-timing.record.assessment-sources-disagree.label",
                "ownerRoleId": "evaluator",
                "state": "conflicting"
              },
              {
                "detailKey": "work-moment.fixture.direct-material-buy-timing.record.outlook-basis-reproduced.detail",
                "evidenceRecordIds": [
                  "commodity-price-outlook",
                  "price-assessment-feed"
                ],
                "id": "outlook-basis-reproduced",
                "labelKey": "work-moment.fixture.direct-material-buy-timing.record.outlook-basis-reproduced.label",
                "ownerRoleId": "sourcing-lead",
                "state": "normal"
              }
            ],
            "summaryKey": "work-moment.fixture.direct-material-buy-timing.mode.explore.summary"
          },
          "review-learning": {
            "headingKey": "work-moment.fixture.direct-material-buy-timing.mode.review.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.direct-material-buy-timing.record.mandate-authorized.detail",
                "evidenceRecordIds": [
                  "coverage-position"
                ],
                "id": "mandate-authorized",
                "labelKey": "work-moment.fixture.direct-material-buy-timing.record.mandate-authorized.label",
                "ownerRoleId": "sourcing-lead",
                "state": "committed"
              },
              {
                "detailKey": "work-moment.fixture.direct-material-buy-timing.record.mandate-outcome-reviewed.detail",
                "evidenceRecordIds": [
                  "commodity-price-outlook"
                ],
                "id": "mandate-outcome-reviewed",
                "labelKey": "work-moment.fixture.direct-material-buy-timing.record.mandate-outcome-reviewed.label",
                "ownerRoleId": "sourcing-lead",
                "state": "reviewed"
              }
            ],
            "summaryKey": "work-moment.fixture.direct-material-buy-timing.mode.review.summary"
          },
          "supervise-work": {
            "headingKey": "work-moment.fixture.direct-material-buy-timing.mode.supervise.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.direct-material-buy-timing.record.coverage-gap-flagged.detail",
                "evidenceRecordIds": [
                  "coverage-position",
                  "demand-portfolio-commitment"
                ],
                "id": "coverage-gap-flagged",
                "labelKey": "work-moment.fixture.direct-material-buy-timing.record.coverage-gap-flagged.label",
                "ownerRoleId": "sourcing-lead",
                "state": "exception"
              },
              {
                "detailKey": "work-moment.fixture.direct-material-buy-timing.record.price-window-open.detail",
                "evidenceRecordIds": [
                  "commodity-price-outlook"
                ],
                "id": "price-window-open",
                "labelKey": "work-moment.fixture.direct-material-buy-timing.record.price-window-open.label",
                "ownerRoleId": "sourcing-lead",
                "state": "normal"
              },
              {
                "detailKey": "work-moment.fixture.direct-material-buy-timing.record.buy-timing-mandate-proposed.detail",
                "evidenceRecordIds": [
                  "commodity-price-outlook",
                  "coverage-position"
                ],
                "id": "buy-timing-mandate-proposed",
                "labelKey": "work-moment.fixture.direct-material-buy-timing.record.buy-timing-mandate-proposed.label",
                "ownerRoleId": "sourcing-lead",
                "state": "proposal"
              }
            ],
            "summaryKey": "work-moment.fixture.direct-material-buy-timing.mode.supervise.summary"
          }
        },
        "ownerRoleId": "sourcing-lead",
        "synthetic": true
      },
      {
        "authorityGrantorRoleId": "category-manager",
        "escalationOwnerRoleId": "category-manager",
        "evidenceRecords": [
          {
            "definitionKey": "work-moment.fixture.tail-spend-consolidation.evidence.tail-spend-evaluation.definition",
            "freshness": "current",
            "id": "tail-spend-evaluation",
            "labelKey": "work-moment.fixture.tail-spend-consolidation.evidence.tail-spend-evaluation.label",
            "observedAt": "2026-08-13T06:30:00Z",
            "ownerRoleId": "category-manager",
            "provenance": "machine",
            "sourceKey": "work-moment.fixture.tail-spend-consolidation.evidence.tail-spend-evaluation.source"
          },
          {
            "definitionKey": "work-moment.fixture.tail-spend-consolidation.evidence.repeat-purchase-history.definition",
            "freshness": "current",
            "id": "repeat-purchase-history",
            "labelKey": "work-moment.fixture.tail-spend-consolidation.evidence.repeat-purchase-history.label",
            "observedAt": "2026-08-13T06:35:00Z",
            "ownerRoleId": "category-manager",
            "provenance": "source",
            "sourceKey": "work-moment.fixture.tail-spend-consolidation.evidence.repeat-purchase-history.source"
          },
          {
            "definitionKey": "work-moment.fixture.tail-spend-consolidation.evidence.supplier-overlap-map.definition",
            "freshness": "current",
            "id": "supplier-overlap-map",
            "labelKey": "work-moment.fixture.tail-spend-consolidation.evidence.supplier-overlap-map.label",
            "observedAt": "2026-08-13T06:40:00Z",
            "ownerRoleId": "procurement-analyst",
            "provenance": "machine",
            "sourceKey": "work-moment.fixture.tail-spend-consolidation.evidence.supplier-overlap-map.source"
          },
          {
            "definitionKey": "work-moment.fixture.tail-spend-consolidation.evidence.channel-position.definition",
            "freshness": "stale",
            "id": "channel-position",
            "labelKey": "work-moment.fixture.tail-spend-consolidation.evidence.channel-position.label",
            "observedAt": "2026-08-08T09:00:00Z",
            "ownerRoleId": "procurement-analyst",
            "provenance": "source",
            "sourceKey": "work-moment.fixture.tail-spend-consolidation.evidence.channel-position.source"
          }
        ],
        "id": "tail-spend-consolidation-fixture",
        "modes": {
          "explore-evidence": {
            "headingKey": "work-moment.fixture.tail-spend-consolidation.mode.explore.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.tail-spend-consolidation.record.channel-position-stale.detail",
                "evidenceRecordIds": [
                  "channel-position"
                ],
                "id": "channel-position-stale",
                "labelKey": "work-moment.fixture.tail-spend-consolidation.record.channel-position-stale.label",
                "ownerRoleId": "procurement-analyst",
                "state": "stale"
              },
              {
                "detailKey": "work-moment.fixture.tail-spend-consolidation.record.cluster-basis-reproduced.detail",
                "evidenceRecordIds": [
                  "repeat-purchase-history",
                  "tail-spend-evaluation"
                ],
                "id": "cluster-basis-reproduced",
                "labelKey": "work-moment.fixture.tail-spend-consolidation.record.cluster-basis-reproduced.label",
                "ownerRoleId": "category-manager",
                "state": "normal"
              }
            ],
            "summaryKey": "work-moment.fixture.tail-spend-consolidation.mode.explore.summary"
          },
          "review-learning": {
            "headingKey": "work-moment.fixture.tail-spend-consolidation.mode.review.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.tail-spend-consolidation.record.candidate-authorized.detail",
                "evidenceRecordIds": [
                  "supplier-overlap-map"
                ],
                "id": "candidate-authorized",
                "labelKey": "work-moment.fixture.tail-spend-consolidation.record.candidate-authorized.label",
                "ownerRoleId": "category-manager",
                "state": "committed"
              },
              {
                "detailKey": "work-moment.fixture.tail-spend-consolidation.record.consolidation-outcome-reviewed.detail",
                "evidenceRecordIds": [
                  "tail-spend-evaluation"
                ],
                "id": "consolidation-outcome-reviewed",
                "labelKey": "work-moment.fixture.tail-spend-consolidation.record.consolidation-outcome-reviewed.label",
                "ownerRoleId": "category-manager",
                "state": "reviewed"
              }
            ],
            "summaryKey": "work-moment.fixture.tail-spend-consolidation.mode.review.summary"
          },
          "supervise-work": {
            "headingKey": "work-moment.fixture.tail-spend-consolidation.mode.supervise.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.tail-spend-consolidation.record.repeat-pattern-flagged.detail",
                "evidenceRecordIds": [
                  "tail-spend-evaluation",
                  "repeat-purchase-history"
                ],
                "id": "repeat-pattern-flagged",
                "labelKey": "work-moment.fixture.tail-spend-consolidation.record.repeat-pattern-flagged.label",
                "ownerRoleId": "category-manager",
                "state": "exception"
              },
              {
                "detailKey": "work-moment.fixture.tail-spend-consolidation.record.cluster-assembled.detail",
                "evidenceRecordIds": [
                  "repeat-purchase-history",
                  "supplier-overlap-map"
                ],
                "id": "cluster-assembled",
                "labelKey": "work-moment.fixture.tail-spend-consolidation.record.cluster-assembled.label",
                "ownerRoleId": "category-manager",
                "state": "normal"
              },
              {
                "detailKey": "work-moment.fixture.tail-spend-consolidation.record.consolidation-candidate-proposed.detail",
                "evidenceRecordIds": [
                  "tail-spend-evaluation",
                  "supplier-overlap-map"
                ],
                "id": "consolidation-candidate-proposed",
                "labelKey": "work-moment.fixture.tail-spend-consolidation.record.consolidation-candidate-proposed.label",
                "ownerRoleId": "category-manager",
                "state": "proposal"
              }
            ],
            "summaryKey": "work-moment.fixture.tail-spend-consolidation.mode.supervise.summary"
          }
        },
        "ownerRoleId": "category-manager",
        "synthetic": true
      },
      {
        "authorityGrantorRoleId": "contract-manager",
        "escalationOwnerRoleId": "legal-counsel",
        "evidenceRecords": [
          {
            "definitionKey": "work-moment.fixture.renewal-window-decision.evidence.renewal-window-calendar.definition",
            "freshness": "current",
            "id": "renewal-window-calendar",
            "labelKey": "work-moment.fixture.renewal-window-decision.evidence.renewal-window-calendar.label",
            "observedAt": "2026-08-20T06:30:00Z",
            "ownerRoleId": "contract-manager",
            "provenance": "machine",
            "sourceKey": "work-moment.fixture.renewal-window-decision.evidence.renewal-window-calendar.source"
          },
          {
            "definitionKey": "work-moment.fixture.renewal-window-decision.evidence.executed-terms-extract.definition",
            "freshness": "current",
            "id": "executed-terms-extract",
            "labelKey": "work-moment.fixture.renewal-window-decision.evidence.executed-terms-extract.label",
            "observedAt": "2026-08-19T17:00:00Z",
            "ownerRoleId": "contract-manager",
            "provenance": "source",
            "sourceKey": "work-moment.fixture.renewal-window-decision.evidence.executed-terms-extract.source"
          },
          {
            "definitionKey": "work-moment.fixture.renewal-window-decision.evidence.consumption-and-performance.definition",
            "freshness": "delayed",
            "id": "consumption-and-performance",
            "labelKey": "work-moment.fixture.renewal-window-decision.evidence.consumption-and-performance.label",
            "observedAt": "2026-08-18T22:00:00Z",
            "ownerRoleId": "obligation-owner",
            "provenance": "source",
            "sourceKey": "work-moment.fixture.renewal-window-decision.evidence.consumption-and-performance.source"
          },
          {
            "definitionKey": "work-moment.fixture.renewal-window-decision.evidence.option-value-assessment.definition",
            "freshness": "conflicting",
            "id": "option-value-assessment",
            "labelKey": "work-moment.fixture.renewal-window-decision.evidence.option-value-assessment.label",
            "observedAt": "2026-08-20T05:45:00Z",
            "ownerRoleId": "sourcing-manager",
            "provenance": "machine",
            "sourceKey": "work-moment.fixture.renewal-window-decision.evidence.option-value-assessment.source"
          }
        ],
        "id": "renewal-window-decision-fixture",
        "modes": {
          "explore-evidence": {
            "headingKey": "work-moment.fixture.renewal-window-decision.mode.explore.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.renewal-window-decision.record.option-values-disagree.detail",
                "evidenceRecordIds": [
                  "option-value-assessment"
                ],
                "id": "option-values-disagree",
                "labelKey": "work-moment.fixture.renewal-window-decision.record.option-values-disagree.label",
                "ownerRoleId": "sourcing-manager",
                "state": "conflicting"
              },
              {
                "detailKey": "work-moment.fixture.renewal-window-decision.record.window-basis-reproduced.detail",
                "evidenceRecordIds": [
                  "renewal-window-calendar",
                  "executed-terms-extract"
                ],
                "id": "window-basis-reproduced",
                "labelKey": "work-moment.fixture.renewal-window-decision.record.window-basis-reproduced.label",
                "ownerRoleId": "contract-manager",
                "state": "normal"
              }
            ],
            "summaryKey": "work-moment.fixture.renewal-window-decision.mode.explore.summary"
          },
          "review-learning": {
            "headingKey": "work-moment.fixture.renewal-window-decision.mode.review.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.renewal-window-decision.record.path-decision-committed.detail",
                "evidenceRecordIds": [
                  "option-value-assessment",
                  "executed-terms-extract"
                ],
                "id": "path-decision-committed",
                "labelKey": "work-moment.fixture.renewal-window-decision.record.path-decision-committed.label",
                "ownerRoleId": "contract-manager",
                "state": "committed"
              },
              {
                "detailKey": "work-moment.fixture.renewal-window-decision.record.window-outcome-reviewed.detail",
                "evidenceRecordIds": [
                  "consumption-and-performance"
                ],
                "id": "window-outcome-reviewed",
                "labelKey": "work-moment.fixture.renewal-window-decision.record.window-outcome-reviewed.label",
                "ownerRoleId": "contract-manager",
                "state": "reviewed"
              }
            ],
            "summaryKey": "work-moment.fixture.renewal-window-decision.mode.review.summary"
          },
          "supervise-work": {
            "headingKey": "work-moment.fixture.renewal-window-decision.mode.supervise.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.renewal-window-decision.record.window-opened.detail",
                "evidenceRecordIds": [
                  "renewal-window-calendar",
                  "executed-terms-extract"
                ],
                "id": "window-opened",
                "labelKey": "work-moment.fixture.renewal-window-decision.record.window-opened.label",
                "ownerRoleId": "contract-manager",
                "state": "exception"
              },
              {
                "detailKey": "work-moment.fixture.renewal-window-decision.record.terms-read-against-use.detail",
                "evidenceRecordIds": [
                  "executed-terms-extract",
                  "consumption-and-performance"
                ],
                "id": "terms-read-against-use",
                "labelKey": "work-moment.fixture.renewal-window-decision.record.terms-read-against-use.label",
                "ownerRoleId": "obligation-owner",
                "state": "normal"
              },
              {
                "detailKey": "work-moment.fixture.renewal-window-decision.record.lifecycle-paths-prepared.detail",
                "evidenceRecordIds": [
                  "option-value-assessment",
                  "executed-terms-extract"
                ],
                "id": "lifecycle-paths-prepared",
                "labelKey": "work-moment.fixture.renewal-window-decision.record.lifecycle-paths-prepared.label",
                "ownerRoleId": "contract-manager",
                "state": "proposal"
              }
            ],
            "summaryKey": "work-moment.fixture.renewal-window-decision.mode.supervise.summary"
          }
        },
        "ownerRoleId": "contract-manager",
        "synthetic": true
      },
      {
        "authorityGrantorRoleId": "demand-owner",
        "escalationOwnerRoleId": "process-owner",
        "evidenceRecords": [
          {
            "definitionKey": "work-moment.fixture.daily-decision-brief.evidence.coverage-position.definition",
            "freshness": "current",
            "id": "coverage-position",
            "labelKey": "work-moment.fixture.daily-decision-brief.evidence.coverage-position.label",
            "observedAt": "2026-08-20T06:00:00Z",
            "ownerRoleId": "demand-owner",
            "provenance": "machine",
            "sourceKey": "work-moment.fixture.daily-decision-brief.evidence.coverage-position.source"
          },
          {
            "definitionKey": "work-moment.fixture.daily-decision-brief.evidence.own-price-outlook.definition",
            "freshness": "current",
            "id": "own-price-outlook",
            "labelKey": "work-moment.fixture.daily-decision-brief.evidence.own-price-outlook.label",
            "observedAt": "2026-08-20T05:30:00Z",
            "ownerRoleId": "demand-owner",
            "provenance": "source",
            "sourceKey": "work-moment.fixture.daily-decision-brief.evidence.own-price-outlook.source"
          },
          {
            "definitionKey": "work-moment.fixture.daily-decision-brief.evidence.contract-window-readout.definition",
            "freshness": "current",
            "id": "contract-window-readout",
            "labelKey": "work-moment.fixture.daily-decision-brief.evidence.contract-window-readout.label",
            "observedAt": "2026-08-20T05:50:00Z",
            "ownerRoleId": "process-owner",
            "provenance": "source",
            "sourceKey": "work-moment.fixture.daily-decision-brief.evidence.contract-window-readout.source"
          },
          {
            "definitionKey": "work-moment.fixture.daily-decision-brief.evidence.supplier-risk-readout.definition",
            "freshness": "stale",
            "id": "supplier-risk-readout",
            "labelKey": "work-moment.fixture.daily-decision-brief.evidence.supplier-risk-readout.label",
            "observedAt": "2026-08-19T19:00:00Z",
            "ownerRoleId": "process-owner",
            "provenance": "machine",
            "sourceKey": "work-moment.fixture.daily-decision-brief.evidence.supplier-risk-readout.source"
          }
        ],
        "id": "daily-decision-brief-fixture",
        "modes": {
          "explore-evidence": {
            "headingKey": "work-moment.fixture.daily-decision-brief.mode.explore.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.daily-decision-brief.record.risk-readout-lagging.detail",
                "evidenceRecordIds": [
                  "supplier-risk-readout"
                ],
                "id": "risk-readout-lagging",
                "labelKey": "work-moment.fixture.daily-decision-brief.record.risk-readout-lagging.label",
                "ownerRoleId": "process-owner",
                "state": "stale"
              },
              {
                "detailKey": "work-moment.fixture.daily-decision-brief.record.outlook-provenance-opened.detail",
                "evidenceRecordIds": [
                  "own-price-outlook"
                ],
                "id": "outlook-provenance-opened",
                "labelKey": "work-moment.fixture.daily-decision-brief.record.outlook-provenance-opened.label",
                "ownerRoleId": "demand-owner",
                "state": "normal"
              }
            ],
            "summaryKey": "work-moment.fixture.daily-decision-brief.mode.explore.summary"
          },
          "review-learning": {
            "headingKey": "work-moment.fixture.daily-decision-brief.mode.review.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.daily-decision-brief.record.covering-action-committed.detail",
                "evidenceRecordIds": [
                  "coverage-position"
                ],
                "id": "covering-action-committed",
                "labelKey": "work-moment.fixture.daily-decision-brief.record.covering-action-committed.label",
                "ownerRoleId": "demand-owner",
                "state": "committed"
              },
              {
                "detailKey": "work-moment.fixture.daily-decision-brief.record.brief-outcome-reviewed.detail",
                "evidenceRecordIds": [
                  "own-price-outlook",
                  "coverage-position"
                ],
                "id": "brief-outcome-reviewed",
                "labelKey": "work-moment.fixture.daily-decision-brief.record.brief-outcome-reviewed.label",
                "ownerRoleId": "demand-owner",
                "state": "reviewed"
              }
            ],
            "summaryKey": "work-moment.fixture.daily-decision-brief.mode.review.summary"
          },
          "supervise-work": {
            "headingKey": "work-moment.fixture.daily-decision-brief.mode.supervise.heading",
            "records": [
              {
                "detailKey": "work-moment.fixture.daily-decision-brief.record.position-exposed.detail",
                "evidenceRecordIds": [
                  "coverage-position",
                  "own-price-outlook"
                ],
                "id": "position-exposed",
                "labelKey": "work-moment.fixture.daily-decision-brief.record.position-exposed.label",
                "ownerRoleId": "demand-owner",
                "state": "exception"
              },
              {
                "detailKey": "work-moment.fixture.daily-decision-brief.record.question-answered-from-records.detail",
                "evidenceRecordIds": [
                  "coverage-position",
                  "contract-window-readout"
                ],
                "id": "question-answered-from-records",
                "labelKey": "work-moment.fixture.daily-decision-brief.record.question-answered-from-records.label",
                "ownerRoleId": "demand-owner",
                "state": "normal"
              },
              {
                "detailKey": "work-moment.fixture.daily-decision-brief.record.covering-action-proposed.detail",
                "evidenceRecordIds": [
                  "coverage-position",
                  "own-price-outlook"
                ],
                "id": "covering-action-proposed",
                "labelKey": "work-moment.fixture.daily-decision-brief.record.covering-action-proposed.label",
                "ownerRoleId": "demand-owner",
                "state": "proposal"
              }
            ],
            "summaryKey": "work-moment.fixture.daily-decision-brief.mode.supervise.summary"
          }
        },
        "ownerRoleId": "demand-owner",
        "synthetic": true
      }
    ],
    "workMoments": [
      {
        "agentContributionKey": "work-moment.supplier-performance-review.agent-contribution",
        "agentId": "supplier-performance-review-agent",
        "availableModes": [
          "supervise-work",
          "explore-evidence",
          "open-office-artifact",
          "review-learning"
        ],
        "businessModuleId": "supplier-performance-review",
        "coexistenceKey": "work-moment.supplier-performance-review.coexistence",
        "defaultMode": "supervise-work",
        "defaultPerspectiveRoleId": "relationship-manager",
        "fixtureId": "supplier-performance-review-fixture",
        "id": "supplier-performance-review",
        "officeSequence": [
          "conductor",
          "composer"
        ],
        "perspectives": [
          {
            "beforeKey": "work-moment.supplier-performance-review.perspective.relationship-manager.before",
            "jobId": "supplier-performance-review.prepare-pack",
            "nowKey": "work-moment.supplier-performance-review.perspective.relationship-manager.now",
            "responsibilityKey": "work-moment.supplier-performance-review.perspective.relationship-manager.responsibility",
            "roleId": "relationship-manager",
            "supervisionKey": "work-moment.supplier-performance-review.perspective.relationship-manager.supervision"
          },
          {
            "beforeKey": "work-moment.supplier-performance-review.perspective.metric-owner.before",
            "jobId": "supplier-performance-review.reproduce-score",
            "nowKey": "work-moment.supplier-performance-review.perspective.metric-owner.now",
            "responsibilityKey": "work-moment.supplier-performance-review.perspective.metric-owner.responsibility",
            "roleId": "metric-owner",
            "supervisionKey": "work-moment.supplier-performance-review.perspective.metric-owner.supervision"
          }
        ],
        "presentation": "illustrative-work-moment",
        "primaryDifferentiatorClaimId": "diff-supplier-performance-review-review-packs-and-working-scorecards-retain-source-references-through-gov",
        "summaryKey": "work-moment.supplier-performance-review.summary",
        "titleKey": "work-moment.supplier-performance-review.title",
        "version": "2.0.0"
      },
      {
        "agentContributionKey": "work-moment.invoice-exception-triage.agent-contribution",
        "agentId": "invoice-exception-coordinator-agent",
        "availableModes": [
          "supervise-work",
          "explore-evidence",
          "review-learning"
        ],
        "businessModuleId": "invoice-exception-triage",
        "coexistenceKey": "work-moment.invoice-exception-triage.coexistence",
        "defaultMode": "supervise-work",
        "defaultPerspectiveRoleId": "ap-processor",
        "fixtureId": "invoice-exception-triage-fixture",
        "id": "invoice-exception-triage",
        "perspectives": [
          {
            "beforeKey": "work-moment.invoice-exception-triage.perspective.ap-processor.before",
            "jobId": "invoice-exception-triage.quantity-mismatch",
            "nowKey": "work-moment.invoice-exception-triage.perspective.ap-processor.now",
            "responsibilityKey": "work-moment.invoice-exception-triage.perspective.ap-processor.responsibility",
            "roleId": "ap-processor",
            "supervisionKey": "work-moment.invoice-exception-triage.perspective.ap-processor.supervision"
          }
        ],
        "presentation": "illustrative-work-moment",
        "primaryDifferentiatorClaimId": "diff-invoice-exception-triage-routine-coding-routing-and-reversible-remediation-execute-only-inside-a",
        "summaryKey": "work-moment.invoice-exception-triage.summary",
        "titleKey": "work-moment.invoice-exception-triage.title",
        "version": "2.0.0"
      },
      {
        "agentContributionKey": "work-moment.category-strategy-refresh.agent-contribution",
        "agentId": "category-strategist-agent",
        "availableModes": [
          "supervise-work",
          "explore-evidence",
          "open-office-artifact",
          "review-learning"
        ],
        "businessModuleId": "category-strategy-orchestrator",
        "coexistenceKey": "work-moment.category-strategy-refresh.coexistence",
        "defaultMode": "supervise-work",
        "defaultPerspectiveRoleId": "category-manager",
        "fixtureId": "category-strategy-refresh-fixture",
        "id": "category-strategy-refresh",
        "officeSequence": [
          "conductor",
          "composer"
        ],
        "perspectives": [
          {
            "beforeKey": "work-moment.category-strategy-refresh.perspective.category-manager.before",
            "jobId": "category-strategy-orchestrator.strategy-commit",
            "nowKey": "work-moment.category-strategy-refresh.perspective.category-manager.now",
            "responsibilityKey": "work-moment.category-strategy-refresh.perspective.category-manager.responsibility",
            "roleId": "category-manager",
            "supervisionKey": "work-moment.category-strategy-refresh.perspective.category-manager.supervision"
          },
          {
            "beforeKey": "work-moment.category-strategy-refresh.perspective.procurement-analyst.before",
            "jobId": "category-strategy-orchestrator.initiative-handoff",
            "nowKey": "work-moment.category-strategy-refresh.perspective.procurement-analyst.now",
            "responsibilityKey": "work-moment.category-strategy-refresh.perspective.procurement-analyst.responsibility",
            "roleId": "procurement-analyst",
            "supervisionKey": "work-moment.category-strategy-refresh.perspective.procurement-analyst.supervision"
          }
        ],
        "presentation": "illustrative-work-moment",
        "primaryDifferentiatorClaimId": "diff-category-strategy-orchestrator-the-active-strategy-remains-last-good-when-refresh-fails-and-is-visibly",
        "summaryKey": "work-moment.category-strategy-refresh.summary",
        "titleKey": "work-moment.category-strategy-refresh.title",
        "version": "2.0.0"
      },
      {
        "agentContributionKey": "work-moment.intake-clarification.agent-contribution",
        "agentId": "request-intake-agent",
        "availableModes": [
          "supervise-work",
          "explore-evidence",
          "review-learning"
        ],
        "businessModuleId": "intelligent-intake",
        "coexistenceKey": "work-moment.intake-clarification.coexistence",
        "defaultMode": "supervise-work",
        "defaultPerspectiveRoleId": "requester",
        "fixtureId": "intake-clarification-fixture",
        "id": "intake-clarification",
        "perspectives": [
          {
            "beforeKey": "work-moment.intake-clarification.perspective.requester.before",
            "jobId": "intelligent-intake.explain-once",
            "nowKey": "work-moment.intake-clarification.perspective.requester.now",
            "responsibilityKey": "work-moment.intake-clarification.perspective.requester.responsibility",
            "roleId": "requester",
            "supervisionKey": "work-moment.intake-clarification.perspective.requester.supervision"
          },
          {
            "beforeKey": "work-moment.intake-clarification.perspective.intake-owner.before",
            "jobId": "intelligent-intake.assemble-case",
            "nowKey": "work-moment.intake-clarification.perspective.intake-owner.now",
            "responsibilityKey": "work-moment.intake-clarification.perspective.intake-owner.responsibility",
            "roleId": "intake-owner",
            "supervisionKey": "work-moment.intake-clarification.perspective.intake-owner.supervision"
          }
        ],
        "presentation": "illustrative-work-moment",
        "primaryDifferentiatorClaimId": "diff-intelligent-intake-one-canonical-request-survives-channels-and-clarification-turns-while-ev",
        "summaryKey": "work-moment.intake-clarification.summary",
        "titleKey": "work-moment.intake-clarification.title",
        "version": "2.0.0"
      },
      {
        "agentContributionKey": "work-moment.sourcing-event-amendment.agent-contribution",
        "agentId": "sourcing-event-designer-agent",
        "availableModes": [
          "supervise-work",
          "explore-evidence",
          "open-office-artifact",
          "review-learning"
        ],
        "businessModuleId": "sourcing-event",
        "coexistenceKey": "work-moment.sourcing-event-amendment.coexistence",
        "defaultMode": "supervise-work",
        "defaultPerspectiveRoleId": "sourcing-lead",
        "fixtureId": "sourcing-event-amendment-fixture",
        "id": "sourcing-event-amendment",
        "officeSequence": [
          "composer",
          "conductor"
        ],
        "perspectives": [
          {
            "beforeKey": "work-moment.sourcing-event-amendment.perspective.sourcing-lead.before",
            "jobId": "sourcing-event.one-basis",
            "nowKey": "work-moment.sourcing-event-amendment.perspective.sourcing-lead.now",
            "responsibilityKey": "work-moment.sourcing-event-amendment.perspective.sourcing-lead.responsibility",
            "roleId": "sourcing-lead",
            "supervisionKey": "work-moment.sourcing-event-amendment.perspective.sourcing-lead.supervision"
          },
          {
            "beforeKey": "work-moment.sourcing-event-amendment.perspective.evaluator.before",
            "jobId": "sourcing-event.score-with-evidence",
            "nowKey": "work-moment.sourcing-event-amendment.perspective.evaluator.now",
            "responsibilityKey": "work-moment.sourcing-event-amendment.perspective.evaluator.responsibility",
            "roleId": "evaluator",
            "supervisionKey": "work-moment.sourcing-event-amendment.perspective.evaluator.supervision"
          }
        ],
        "presentation": "illustrative-work-moment",
        "primaryDifferentiatorClaimId": "diff-sourcing-event-machine-drafted-specifications-and-messages-remain-proposals-until-the-a",
        "summaryKey": "work-moment.sourcing-event-amendment.summary",
        "titleKey": "work-moment.sourcing-event-amendment.title",
        "version": "2.0.0"
      },
      {
        "agentContributionKey": "work-moment.contract-redline-review.agent-contribution",
        "agentId": "contract-drafting-agent",
        "availableModes": [
          "supervise-work",
          "explore-evidence",
          "open-office-artifact",
          "review-learning"
        ],
        "businessModuleId": "contract-authoring-review",
        "coexistenceKey": "work-moment.contract-redline-review.coexistence",
        "defaultMode": "supervise-work",
        "defaultPerspectiveRoleId": "legal-counsel",
        "fixtureId": "contract-redline-review-fixture",
        "id": "contract-redline-review",
        "officeSequence": [
          "composer"
        ],
        "perspectives": [
          {
            "beforeKey": "work-moment.contract-redline-review.perspective.legal-counsel.before",
            "jobId": "contract-authoring-review.third-party-paper",
            "nowKey": "work-moment.contract-redline-review.perspective.legal-counsel.now",
            "responsibilityKey": "work-moment.contract-redline-review.perspective.legal-counsel.responsibility",
            "roleId": "legal-counsel",
            "supervisionKey": "work-moment.contract-redline-review.perspective.legal-counsel.supervision"
          },
          {
            "beforeKey": "work-moment.contract-redline-review.perspective.sourcing-manager.before",
            "jobId": "contract-authoring-review.commercial-position",
            "nowKey": "work-moment.contract-redline-review.perspective.sourcing-manager.now",
            "responsibilityKey": "work-moment.contract-redline-review.perspective.sourcing-manager.responsibility",
            "roleId": "sourcing-manager",
            "supervisionKey": "work-moment.contract-redline-review.perspective.sourcing-manager.supervision"
          }
        ],
        "presentation": "illustrative-work-moment",
        "primaryDifferentiatorClaimId": "diff-contract-authoring-review-native-document-round-trip-preserves-review-context-tracked-changes-and",
        "summaryKey": "work-moment.contract-redline-review.summary",
        "titleKey": "work-moment.contract-redline-review.title",
        "version": "2.0.0"
      },
      {
        "agentContributionKey": "work-moment.third-party-risk-decision.agent-contribution",
        "agentId": "third-party-risk-agent",
        "availableModes": [
          "supervise-work",
          "explore-evidence",
          "open-office-artifact",
          "review-learning"
        ],
        "businessModuleId": "third-party-risk-review",
        "coexistenceKey": "work-moment.third-party-risk-decision.coexistence",
        "defaultMode": "supervise-work",
        "defaultPerspectiveRoleId": "accountable-risk-owner",
        "fixtureId": "third-party-risk-decision-fixture",
        "id": "third-party-risk-decision",
        "officeSequence": [
          "conductor",
          "composer"
        ],
        "perspectives": [
          {
            "beforeKey": "work-moment.third-party-risk-decision.perspective.accountable-risk-owner.before",
            "jobId": "third-party-risk-review.decision-package",
            "nowKey": "work-moment.third-party-risk-decision.perspective.accountable-risk-owner.now",
            "responsibilityKey": "work-moment.third-party-risk-decision.perspective.accountable-risk-owner.responsibility",
            "roleId": "accountable-risk-owner",
            "supervisionKey": "work-moment.third-party-risk-decision.perspective.accountable-risk-owner.supervision"
          },
          {
            "beforeKey": "work-moment.third-party-risk-decision.perspective.tprm-programme-owner.before",
            "jobId": "third-party-risk-review.evidence-conflict",
            "nowKey": "work-moment.third-party-risk-decision.perspective.tprm-programme-owner.now",
            "responsibilityKey": "work-moment.third-party-risk-decision.perspective.tprm-programme-owner.responsibility",
            "roleId": "tprm-programme-owner",
            "supervisionKey": "work-moment.third-party-risk-decision.perspective.tprm-programme-owner.supervision"
          }
        ],
        "presentation": "illustrative-work-moment",
        "primaryDifferentiatorClaimId": "diff-third-party-risk-review-risk-scoring-evidence-sufficiency-and-decision-authority-are-separately",
        "summaryKey": "work-moment.third-party-risk-decision.summary",
        "titleKey": "work-moment.third-party-risk-decision.title",
        "version": "2.0.0"
      },
      {
        "agentContributionKey": "work-moment.guided-buying-route.agent-contribution",
        "agentId": "requester-buying-agent",
        "availableModes": [
          "supervise-work",
          "explore-evidence",
          "review-learning"
        ],
        "businessModuleId": "guided-buying",
        "coexistenceKey": "work-moment.guided-buying-route.coexistence",
        "defaultMode": "supervise-work",
        "defaultPerspectiveRoleId": "requester",
        "fixtureId": "guided-buying-route-fixture",
        "id": "guided-buying-route",
        "perspectives": [
          {
            "beforeKey": "work-moment.guided-buying-route.perspective.requester.before",
            "jobId": "guided-buying.route-need",
            "nowKey": "work-moment.guided-buying-route.perspective.requester.now",
            "responsibilityKey": "work-moment.guided-buying-route.perspective.requester.responsibility",
            "roleId": "requester",
            "supervisionKey": "work-moment.guided-buying-route.perspective.requester.supervision"
          },
          {
            "beforeKey": "work-moment.guided-buying-route.perspective.procurement-buyer.before",
            "jobId": "guided-buying.resolve-off-path",
            "nowKey": "work-moment.guided-buying-route.perspective.procurement-buyer.now",
            "responsibilityKey": "work-moment.guided-buying-route.perspective.procurement-buyer.responsibility",
            "roleId": "procurement-buyer",
            "supervisionKey": "work-moment.guided-buying-route.perspective.procurement-buyer.supervision"
          }
        ],
        "presentation": "illustrative-work-moment",
        "primaryDifferentiatorClaimId": "diff-guided-buying-the-requester-agent-can-complete-a-bounded-multi-step-mission-while-pres",
        "summaryKey": "work-moment.guided-buying-route.summary",
        "titleKey": "work-moment.guided-buying-route.title",
        "version": "2.0.0"
      },
      {
        "agentContributionKey": "work-moment.savings-validation.agent-contribution",
        "agentId": "savings-initiative-agent",
        "availableModes": [
          "supervise-work",
          "explore-evidence",
          "open-office-artifact",
          "review-learning"
        ],
        "businessModuleId": "savings-initiative",
        "coexistenceKey": "work-moment.savings-validation.coexistence",
        "defaultMode": "supervise-work",
        "defaultPerspectiveRoleId": "finance-delegate",
        "fixtureId": "savings-validation-fixture",
        "id": "savings-validation",
        "officeSequence": [
          "conductor"
        ],
        "perspectives": [
          {
            "beforeKey": "work-moment.savings-validation.perspective.finance-delegate.before",
            "jobId": "savings-initiative.validate-result",
            "nowKey": "work-moment.savings-validation.perspective.finance-delegate.now",
            "responsibilityKey": "work-moment.savings-validation.perspective.finance-delegate.responsibility",
            "roleId": "finance-delegate",
            "supervisionKey": "work-moment.savings-validation.perspective.finance-delegate.supervision"
          },
          {
            "beforeKey": "work-moment.savings-validation.perspective.value-lead.before",
            "jobId": "savings-initiative.restate-result",
            "nowKey": "work-moment.savings-validation.perspective.value-lead.now",
            "responsibilityKey": "work-moment.savings-validation.perspective.value-lead.responsibility",
            "roleId": "value-lead",
            "supervisionKey": "work-moment.savings-validation.perspective.value-lead.supervision"
          }
        ],
        "presentation": "illustrative-work-moment",
        "primaryDifferentiatorClaimId": "diff-savings-initiative-opportunity-baseline-plan-forecast-actual-evidence-attribution-and-commi",
        "summaryKey": "work-moment.savings-validation.summary",
        "titleKey": "work-moment.savings-validation.title",
        "version": "2.0.0"
      },
      {
        "agentContributionKey": "work-moment.direct-material-buy-timing.agent-contribution",
        "agentId": "buy-timing-agent",
        "availableModes": [
          "supervise-work",
          "explore-evidence",
          "review-learning"
        ],
        "businessModuleId": "sourcing-pipeline-discovery",
        "coexistenceKey": "work-moment.direct-material-buy-timing.coexistence",
        "defaultMode": "supervise-work",
        "defaultPerspectiveRoleId": "sourcing-lead",
        "fixtureId": "direct-material-buy-timing-fixture",
        "id": "direct-material-buy-timing",
        "perspectives": [
          {
            "beforeKey": "work-moment.direct-material-buy-timing.perspective.sourcing-lead.before",
            "jobId": "sourcing-pipeline-discovery.buy-timing",
            "nowKey": "work-moment.direct-material-buy-timing.perspective.sourcing-lead.now",
            "responsibilityKey": "work-moment.direct-material-buy-timing.perspective.sourcing-lead.responsibility",
            "roleId": "sourcing-lead",
            "supervisionKey": "work-moment.direct-material-buy-timing.perspective.sourcing-lead.supervision"
          }
        ],
        "presentation": "illustrative-work-moment",
        "primaryDifferentiatorClaimId": "diff-sourcing-pipeline-discovery-the-pipeline-joins-strategy-current-demand-forecasts-contracts-supplier",
        "summaryKey": "work-moment.direct-material-buy-timing.summary",
        "titleKey": "work-moment.direct-material-buy-timing.title",
        "version": "1.0.0"
      },
      {
        "agentContributionKey": "work-moment.tail-spend-consolidation.agent-contribution",
        "agentId": "tail-spend-consolidation-agent",
        "availableModes": [
          "supervise-work",
          "explore-evidence",
          "review-learning"
        ],
        "businessModuleId": "category-opportunity-radar",
        "coexistenceKey": "work-moment.tail-spend-consolidation.coexistence",
        "defaultMode": "supervise-work",
        "defaultPerspectiveRoleId": "category-manager",
        "fixtureId": "tail-spend-consolidation-fixture",
        "id": "tail-spend-consolidation",
        "perspectives": [
          {
            "beforeKey": "work-moment.tail-spend-consolidation.perspective.category-manager.before",
            "jobId": "category-opportunity-radar.spend-refresh",
            "nowKey": "work-moment.tail-spend-consolidation.perspective.category-manager.now",
            "responsibilityKey": "work-moment.tail-spend-consolidation.perspective.category-manager.responsibility",
            "roleId": "category-manager",
            "supervisionKey": "work-moment.tail-spend-consolidation.perspective.category-manager.supervision"
          }
        ],
        "presentation": "illustrative-work-moment",
        "primaryDifferentiatorClaimId": "diff-category-opportunity-radar-a-durable-opportunity-record-carries-its-evidence-expiry-and-disposition",
        "summaryKey": "work-moment.tail-spend-consolidation.summary",
        "titleKey": "work-moment.tail-spend-consolidation.title",
        "version": "1.0.0"
      },
      {
        "agentContributionKey": "work-moment.renewal-window-decision.agent-contribution",
        "agentId": "contract-change-agent",
        "availableModes": [
          "supervise-work",
          "explore-evidence",
          "review-learning"
        ],
        "businessModuleId": "renewal-change-compliance",
        "coexistenceKey": "work-moment.renewal-window-decision.coexistence",
        "defaultMode": "supervise-work",
        "defaultPerspectiveRoleId": "contract-manager",
        "fixtureId": "renewal-window-decision-fixture",
        "id": "renewal-window-decision",
        "perspectives": [
          {
            "beforeKey": "work-moment.renewal-window-decision.perspective.contract-manager.before",
            "jobId": "renewal-change-compliance.decision-window",
            "nowKey": "work-moment.renewal-window-decision.perspective.contract-manager.now",
            "responsibilityKey": "work-moment.renewal-window-decision.perspective.contract-manager.responsibility",
            "roleId": "contract-manager",
            "supervisionKey": "work-moment.renewal-window-decision.perspective.contract-manager.supervision"
          },
          {
            "beforeKey": "work-moment.renewal-window-decision.perspective.sourcing-manager.before",
            "jobId": "renewal-change-compliance.compare-paths",
            "nowKey": "work-moment.renewal-window-decision.perspective.sourcing-manager.now",
            "responsibilityKey": "work-moment.renewal-window-decision.perspective.sourcing-manager.responsibility",
            "roleId": "sourcing-manager",
            "supervisionKey": "work-moment.renewal-window-decision.perspective.sourcing-manager.supervision"
          }
        ],
        "presentation": "illustrative-work-moment",
        "primaryDifferentiatorClaimId": "diff-renewal-change-compliance-renewal-is-treated-as-an-evidence-driven-decision-window-not-a-calendar",
        "summaryKey": "work-moment.renewal-window-decision.summary",
        "titleKey": "work-moment.renewal-window-decision.title",
        "version": "1.0.0"
      },
      {
        "agentContributionKey": "work-moment.daily-decision-brief.agent-contribution",
        "agentId": "coverage-position-agent",
        "availableModes": [
          "supervise-work",
          "explore-evidence",
          "review-learning"
        ],
        "businessModuleId": "demand-consolidation-portfolio",
        "coexistenceKey": "work-moment.daily-decision-brief.coexistence",
        "defaultMode": "supervise-work",
        "defaultPerspectiveRoleId": "demand-owner",
        "fixtureId": "daily-decision-brief-fixture",
        "id": "daily-decision-brief",
        "perspectives": [
          {
            "beforeKey": "work-moment.daily-decision-brief.perspective.demand-owner.before",
            "jobId": "demand-consolidation-portfolio.material-economics",
            "nowKey": "work-moment.daily-decision-brief.perspective.demand-owner.now",
            "responsibilityKey": "work-moment.daily-decision-brief.perspective.demand-owner.responsibility",
            "roleId": "demand-owner",
            "supervisionKey": "work-moment.daily-decision-brief.perspective.demand-owner.supervision"
          },
          {
            "beforeKey": "work-moment.daily-decision-brief.perspective.process-owner.before",
            "jobId": "demand-consolidation-portfolio.business-consent",
            "nowKey": "work-moment.daily-decision-brief.perspective.process-owner.now",
            "responsibilityKey": "work-moment.daily-decision-brief.perspective.process-owner.responsibility",
            "roleId": "process-owner",
            "supervisionKey": "work-moment.daily-decision-brief.perspective.process-owner.supervision"
          }
        ],
        "presentation": "illustrative-work-moment",
        "primaryDifferentiatorClaimId": "diff-demand-consolidation-portfolio-portfolio-aggregates-include-record-drill-through-under-server-side-acce",
        "summaryKey": "work-moment.daily-decision-brief.summary",
        "titleKey": "work-moment.daily-decision-brief.title",
        "version": "1.0.0"
      }
    ]
  },
  "copy": {
    "absence.address.eyebrow": "Framework address",
    "absence.address.route-home": "Go to the framework",
    "absence.address.route-search": "Search GroundWorks",
    "absence.address.support": "There is no framework page at this address.",
    "absence.address.title": "Page not found",
    "absence.business-module.eyebrow": "Business module reference",
    "absence.business-module.route-domain": "Return to the parent Workblock",
    "absence.business-module.route-workblocks": "Browse Workblocks",
    "absence.business-module.support": "This business module does not belong to the requested Workblock.",
    "absence.business-module.title": "Business module not found",
    "absence.capability.eyebrow": "Office capability reference",
    "absence.capability.route": "Return to Office capabilities",
    "absence.capability.support": "This Office capability is not part of the current Accenture GroundWorks programme.",
    "absence.capability.title": "Capability not found",
    "absence.domain.eyebrow": "Domain reference",
    "absence.domain.route": "Return to domains",
    "absence.domain.support": "This domain is not part of the current framework.",
    "absence.domain.title": "Domain not found",
    "absence.entity.eyebrow": "Data-model reference",
    "absence.entity.route": "Return to the data catalogue",
    "absence.entity.support": "This entity is not part of the current data-model reference.",
    "absence.entity.title": "Entity not found",
    "absence.holding.business-modules": "Business modules",
    "absence.holding.entities": "Shared entities",
    "absence.holding.office-capabilities": "Office capabilities",
    "absence.holding.roles": "Roles",
    "absence.holding.work-moments": "Work moments",
    "absence.holding.workblocks": "Domain Workblocks",
    "absence.role.eyebrow": "Role reference",
    "absence.work-moment.eyebrow": "Work moment reference",
    "absence.workblock.eyebrow": "Workblock reference",
    "absence.workblock.route": "Browse Workblocks",
    "absence.workblock.support": "This Workblock is not part of the current framework.",
    "absence.workblock.title": "Workblock not found",
    "adoption.keep": "Keep the systems that earn their place.",
    "adoption.motion": "Coexist first, prove value, replace selectively.",
    "architecture.property.autonomy": "Each named action holds the least authority level that achieves the outcome; every policy-autonomous commitment is logged and a quality drop returns work to people.",
    "architecture.property.data-plane": "One permissioned data plane with one audit trail.",
    "architecture.property.deploys": "Deploys are deliberate, versioned and reversible.",
    "architecture.property.durable": "Runs survive multi-week approvals and pick up exactly where they left off.",
    "architecture.property.learning": "Corrections compound as learning in the client's tenant, not in a vendor's shared model.",
    "authoring.architecture.check.migration": "Schema compatibility, forward migration, rollback, isolation, retention and deletion scenarios are versioned and testable.",
    "authoring.architecture.check.outcome": "The Workblock owns one named outcome with an observable finish and accountable human role.",
    "authoring.architecture.check.owner": "Every canonical fact and consequential command has one authoritative owner and permission boundary.",
    "authoring.architecture.check.provenance": "Evidence carries source, version, actor, time, transformation and links to the decision or action that used it.",
    "authoring.architecture.check.reliability": "Freshness, idempotency, acknowledgement, degraded state, reconciliation, recovery, monitoring and rollback are declared.",
    "authoring.architecture.check.surface": "Task output, module output, Run Data, rowstore, blob, index, cache and event responsibilities are explicit.",
    "authoring.architecture.check.validation": "Normal, duplicate, stale, delayed, partial, failed, unknown-outcome, replay and reversal paths have evidence or are marked not checked.",
    "authoring.architecture.delivery.migration.body": "Classify compatibility, pin the predecessor, define forward and rollback behaviour, preserve applied history and test permission, isolation, retention and deletion paths. Label unproved future architecture as direction.",
    "authoring.architecture.delivery.migration.title": "Version schema and migration together",
    "authoring.architecture.delivery.reliability.body": "For every integration declare freshness, idempotency, acknowledgement, degraded state, reconciliation, recovery, monitoring and rollback. Preserve source shape and lineage, map without commitment, then submit one typed owner command.",
    "authoring.architecture.delivery.reliability.title": "Close the reliable-delivery loop",
    "authoring.architecture.delivery.validation.body": "Inspect and load structure, run consequential paths, examine reports and diagnostics, query durable state, replay recovery, probe the UI and use fidelity services for service semantics that portable mode cannot prove.",
    "authoring.architecture.delivery.validation.title": "Prove behaviour, not just loadability",
    "authoring.architecture.description": "Turn one accountable outcome into a versioned task graph, owned record model, evidence trail and reliable delivery contract. Use the same framework inside Studio or from Claude Code with the local GroundWorks MCP index.",
    "authoring.architecture.eyebrow": "Build guide",
    "authoring.architecture.inside.step1.body": "Use a dedicated branch, explicit local root and advisory lease. Pull before editing when remote drift is possible and keep the package name, manifest IDs and task entrypoints intact.",
    "authoring.architecture.inside.step1.title": "Pull and bind the feature version",
    "authoring.architecture.inside.step2.body": "Select the module job, owner roles, canonical entities, source projections, authority envelope and integration recipes before changing schema.yaml or the task graph.",
    "authoring.architecture.inside.step2.title": "Bind the framework contracts",
    "authoring.architecture.inside.step3.body": "Keep transient task output, module output, Workblock Run Data, mutable rowstore records, blobs, derived indexes, cache and events in their declared roles. Submit one typed command to the canonical owner for each commitment.",
    "authoring.architecture.inside.step3.title": "Separate tasks, surfaces and effects",
    "authoring.architecture.inside.step4.body": "Inspect, load and run the Workblock, review model, flow and run reports, query persisted data when relevant, replay recoverable paths and probe the UI. Recheck drift and hash parity before bridge push.",
    "authoring.architecture.inside.step4.title": "Validate behaviour and parity",
    "authoring.architecture.inside.summary": "Create a feature version of GroundWorks - Source 2 Pay, a generated template or an existing Workblock. Preserve its runtime IDs and bridge contract while changing the outcome-owned architecture.",
    "authoring.architecture.inside.title": "Inside the platform with Studio",
    "authoring.architecture.outcome": "A Workblock architecture in which every fact has one owner and durability, every consequential effect crosses an explicit authority boundary, and every retry, migration and recovery path can be tested.",
    "authoring.architecture.outcome.authority.body": "Record who grants authority, permitted action classes, deterministic guards, required review, escalation owner and recovery rights. An agent may propose within its charter but does not inherit human approval or commitment authority.",
    "authoring.architecture.outcome.authority.title": "Put the commitment boundary in the contract",
    "authoring.architecture.outcome.graph.body": "Separate read, interpretation, proposal, review, approval, commitment, acknowledgement, reconciliation and compensation when they exist. Use explicit waits and child runs; never hide a consequential transition inside an untyped helper.",
    "authoring.architecture.outcome.graph.title": "Make the task graph reflect lifecycle truth",
    "authoring.architecture.outcome.owner.body": "A Workblock is the smallest independently versionable unit that owns a procurement outcome. Name the observable finish, accountable role, permission boundary and handoff before decomposing work.",
    "authoring.architecture.outcome.owner.title": "Keep one outcome owner",
    "authoring.architecture.outside.step1.body": "Configure the read-only MCP, install align-groundworks-workblock-architecture and confirm the full permitted asset manifest is available.",
    "authoring.architecture.outside.step1.title": "Install the kit and architecture skill",
    "authoring.architecture.outside.step2.body": "Retrieve the domain Workblock and business-module brief. Preserve the module's one governed job, observable finish, human roles and authority ceiling rather than starting from a technology or screen.",
    "authoring.architecture.outside.step2.title": "Choose one outcome and accountable owner",
    "authoring.architecture.outside.step3.body": "Use the data catalogue for canonical entities and the Connected Work recipes for source mappings. Assign one owner, lifecycle, surface, provenance, freshness, permission, retention and deletion rule to every fact.",
    "authoring.architecture.outside.step3.title": "Assign records and exchanges",
    "authoring.architecture.outside.step4.body": "Generate or adapt the starter, write the task graph and migration plan, then test normal, duplicate, stale, delayed, partial, failed, unknown-outcome, replay and rollback scenarios.",
    "authoring.architecture.outside.step4.title": "Author and prove the architecture",
    "authoring.architecture.outside.summary": "Use the authoring kit to retrieve Workblock, module, entity, integration and starter contracts without checking out the framework repository.",
    "authoring.architecture.outside.title": "Outside the platform with Claude Code",
    "authoring.architecture.prompt.body": "Align this Workblock with the GroundWorks data model and architecture. First read AGENTS.md, DESIGN.md, manifest.yaml and schema.yaml in the target. Use the local GroundWorks MCP get_started and get_guide tools for workblock-architecture, then retrieve the selected domain Workblock, business-module brief, relevant entity contracts, Connected Work recipes and generated starter. State the one outcome, observable finish, accountable human role and authority ceiling before editing. Inventory each fact and classify it as input, task output, module output, run state, mutable operational record, evidence or blob, derived index, cache, event, analytical measure or learning signal. Assign one owner, stable ID, lifecycle, permission boundary, environment, retention, deletion, provenance and freshness rule to each fact. Keep source truth, interpretation, proposal, human decision, commit attempt, acknowledgement, reconciled outcome and compensation separate. Keep mutable owned records and source health in Workblock-scoped rowstore, completed execution evidence in Workblock Run Data, binary bodies in blobs and retrieval indexes derived and rebuildable unless an explicit decision justifies another surface. For each external exchange preserve source shape and lineage, map without commitment, submit one typed owner command, and declare freshness, idempotency, acknowledgement, degraded state, reconciliation, recovery, monitoring and rollback. Version schema and migration together. Preserve manifest IDs, task entrypoints and bridge contracts. Validate normal, duplicate, stale, delayed, partial, failed, unknown-outcome, replay, rollback, permission, isolation, retention and deletion scenarios. If platform-bound, claim the feature branch, check drift, inspect, load, run, read model, flow and run reports, query durable state where relevant, probe desktop and mobile UI, recheck parity and push only through the bridge. Return an ownership matrix, task graph, state transitions, evidence contract, integration contract, migration plan, validation evidence and anything not checked.",
    "authoring.architecture.prompt.title": "Prompt: align a GroundWorks Workblock data model and architecture",
    "authoring.architecture.section.delivery.introduction": "External exchange and schema evolution are part of the outcome contract, not post-build operations.",
    "authoring.architecture.section.delivery.title": "Reliable delivery, change and proof",
    "authoring.architecture.section.outcome.introduction": "Architecture begins with the business result and the person accountable for it, not with a service, agent or storage product.",
    "authoring.architecture.section.outcome.title": "Outcome, graph and authority",
    "authoring.architecture.section.state.introduction": "One concept can have many read models, but it has one authoritative owner. Choose durability from the fact's lifecycle and consequence.",
    "authoring.architecture.section.state.title": "State, evidence and provenance",
    "authoring.architecture.skill.boundary1": "Do not place mutable business truth only in transient Run Data, cache or vector indexes.",
    "authoring.architecture.skill.boundary2": "Do not merge source truth, machine proposal, human decision and committed outcome into one status or record.",
    "authoring.architecture.skill.boundary3": "Do not let an integration commit canonical state without one typed command to the record owner.",
    "authoring.architecture.skill.boundary4": "Do not claim portable validation proves Postgres, Qdrant, Redis, Temporal, model or document-service semantics.",
    "authoring.architecture.skill.description": "Align a GroundWorks Workblock outcome, task graph, state ownership, evidence, authority, reliable delivery, schema migration and validation. Use for local Claude Code projects and platform-bound Workblocks.",
    "authoring.architecture.skill.step1": "Read the target authoring, design, manifest and schema contracts, then retrieve workblock-architecture with get_guide.",
    "authoring.architecture.skill.step2": "Select the domain Workblock and business module, then state the outcome, owner, observable finish and authority ceiling.",
    "authoring.architecture.skill.step3": "Inventory facts and assign one owner, durable surface, lifecycle, provenance, freshness, permission, retention and deletion rule to each.",
    "authoring.architecture.skill.step4": "Model the task graph and external exchanges with explicit waits, typed owner commands and all eight reliable-delivery controls.",
    "authoring.architecture.skill.step5": "Version schema, compatibility, migration and rollback together while preserving runtime IDs and bridge contracts.",
    "authoring.architecture.skill.step6": "Validate structure, behaviour, persistence, recovery, UI and required service fidelity before feature-version push.",
    "authoring.architecture.state.freshness.body": "Declare current, delayed, stale and conflicting states; preserve last-good values with age and source state; define late-arrival, duplicate, backfill and replay behaviour without silently rewriting history.",
    "authoring.architecture.state.freshness.title": "Model freshness and degraded truth",
    "authoring.architecture.state.ownership.body": "Keep transient calculations in task outputs, module handoffs in module outputs, completed execution evidence in Workblock Run Data, mutable owned records and source health in Workblock-scoped rowstore, binary bodies in blobs, and retrieval indexes derived and rebuildable.",
    "authoring.architecture.state.ownership.title": "Use the narrowest durable surface",
    "authoring.architecture.state.provenance.body": "Record source, source version, extraction method, actor, observed time, confidence, transformations and the proposal, decision or action that consumed the evidence. Cache and vectors never become canonical truth by accident.",
    "authoring.architecture.state.provenance.title": "Link evidence to the decision that used it",
    "authoring.architecture.title": "Align a Workblock data model and architecture",
    "authoring.design.check.authority": "Machine proposals and committed outcomes are distinct, with the human authority and intervention path adjacent.",
    "authoring.design.check.host": "The surface composes inside the Chassis-owned canvas and does not duplicate host chrome.",
    "authoring.design.check.provenance": "DESIGN.md records selected registry assets, copied or adapted source, contract review and any local implementation decision.",
    "authoring.design.check.responsive": "Desktop, mobile, 200% text, keyboard and reduced-motion checks retain the same meaning and action order.",
    "authoring.design.check.roles": "Every component and local style binds GroundWorks semantic roles through apf- classes.",
    "authoring.design.check.states": "Applicable loading, empty, partial, error, blocked, stale, proposal, commitment, failure and reversal states are observable.",
    "authoring.design.description": "Start with the GroundWorks object language and admitted component contracts, then express the Workblock inside the Chassis-owned canvas. The same guide supports Claude Code in a local project and Studio authoring on Beyond Work execution rails.",
    "authoring.design.eyebrow": "Build guide",
    "authoring.design.host.boundary.body": "Do not recreate platform navigation or make the Workblock look like Blockwork, Fabric or another host product. Use GroundWorks semantic roles and let Chassis retain canvas, routing and cross-product controls.",
    "authoring.design.host.boundary.title": "Compose inside Chassis",
    "authoring.design.host.register.body": "The framework register explains a system of work. The app register reports objects, state, evidence, authority and next action. A Workblock operating surface uses the app register end to end.",
    "authoring.design.host.register.title": "Use one writing register",
    "authoring.design.inside.step1.body": "Pull the template or selected Workblock into a bound local folder, claim its branch and preserve the exact package, manifest, module, task and bridge contracts before editing.",
    "authoring.design.inside.step1.title": "Create a feature version from governed source",
    "authoring.design.inside.step2.body": "An existing Workblock component may be copied and adapted when its provenance, props, states, accessibility and host assumptions are reviewed. Import only a supply row that is explicitly available and importable.",
    "authoring.design.inside.step2.title": "Reuse by contract, not appearance alone",
    "authoring.design.inside.step3.body": "A local React implementation and compiled stylesheet are valid without a shared package. Keep DESIGN.md at the authoring root and design_docs/groundworks-design.md where Studio can display the same contract.",
    "authoring.design.inside.step3.title": "Use code plus a design document when that is clearer",
    "authoring.design.inside.step4.body": "Inspect, load and run the Workblock, read its run report, probe desktop and mobile UI, parse the TSX and recheck platform drift. Push only the validated feature version through the bridge.",
    "authoring.design.inside.step4.title": "Prove the built Workblock before push",
    "authoring.design.inside.summary": "Start from GroundWorks - Source 2 Pay, a generated template, or a feature version of an existing Workblock. Keep the platform bridge and Chassis host contracts intact while adapting the Workblock-owned surface.",
    "authoring.design.inside.title": "Inside the platform with Studio",
    "authoring.design.outcome": "A typed React Workblock with compiled CSS, a design document, truthful lifecycle states, explicit human authority and a recorded source for every adapted component.",
    "authoring.design.outside.step1.body": "Extract the kit, add its MCP entry, install the style-groundworks-workblock skill and confirm get_started can list the two guides and complete asset manifest.",
    "authoring.design.outside.step1.title": "Install the read-only authoring kit",
    "authoring.design.outside.step2.body": "Retrieve the design doctrine, the selected Workblock prompt and only the admitted component contracts the screen needs. Treat existing Workblock source as an adaptation reference with provenance, not as automatically importable supply.",
    "authoring.design.outside.step2.title": "Select contracts before composing",
    "authoring.design.outside.step3.body": "Use typed React and semantic apf- classes. Bind role tokens rather than primitive colour values, record the host boundary and source assets in DESIGN.md, and keep the implementation portable.",
    "authoring.design.outside.step3.title": "Author React, compiled CSS and DESIGN.md together",
    "authoring.design.outside.step4.body": "Exercise loading, empty, partial, error, blocked, stale, proposed, committed and reversed states that apply. Check keyboard order, focus, non-colour meaning, reflow and the browser console before claiming completion.",
    "authoring.design.outside.step4.title": "Validate at desktop, mobile and enlarged text",
    "authoring.design.outside.summary": "Use the downloadable kit when the project lives outside Studio. The local MCP makes every permitted registry asset addressable without granting Claude Code access to this repository.",
    "authoring.design.outside.title": "Outside the platform with Claude Code",
    "authoring.design.prompt.body": "Brand and style this Workblock with the GroundWorks UX system. First read AGENTS.md and DESIGN.md in the target, then use the local GroundWorks MCP get_started and get_guide tools for workblock-design. Identify the domain Workblock, business module, user-owned outcome, lifecycle states and Chassis host boundary before editing. Retrieve the GroundWorks design doctrine and only the admitted component contracts required by the screen. Existing Workblock code is an adaptation reference only: record its path and contract review before copying, and do not assume it is importable supply. Never import React, CSS or gw- selectors from the sealed GroundWorks 0.20.0 reference. Implement typed React and one compiled stylesheet with apf- semantic classes and theme roles, or adapt an existing component with explicit provenance. Add or update DESIGN.md and, for a platform-bound Workblock, design_docs/groundworks-design.md. Keep source truth, proposals, human decisions, commitments, failures and reversals distinct. Name the human authority beside consequential actions. Retain last-good data with freshness. Validate loading, empty, partial, error, blocked and stale states; keyboard order, focus, non-colour meaning, reduced motion, mobile reflow and 200% text. If platform-bound, inspect, load, run, read the run report, probe desktop and mobile, check branch drift and push only a feature version through the bridge. Return the files changed, source assets used, states proved and anything not checked.",
    "authoring.design.prompt.title": "Prompt: brand and style a GroundWorks Workblock",
    "authoring.design.section.host.introduction": "The host owns global navigation, canvas and platform chrome. The Workblock owns the bounded procurement matter inside that canvas.",
    "authoring.design.section.host.title": "Host, register and composition boundary",
    "authoring.design.section.system.introduction": "GroundWorks meaning is stable while the Accenture expression is replaceable. Components consume semantic roles, not the palette directly.",
    "authoring.design.section.system.title": "GroundWorks system language",
    "authoring.design.section.truth.introduction": "A polished Workblock is credible only when people can tell what happened, who may act and how the surface behaves when evidence is incomplete.",
    "authoring.design.section.truth.title": "Truth, authority and access",
    "authoring.design.skill.boundary1": "Keep Chassis as host and GroundWorks as the Workblock visual language.",
    "authoring.design.skill.boundary2": "Treat every UX supply row and existing Workblock component as non-importable until its exact contract says otherwise.",
    "authoring.design.skill.boundary3": "Keep machine proposals visibly distinct from human decisions and committed outcomes.",
    "authoring.design.skill.boundary4": "Do not expose deferred operational routes, private bindings, tenant details or internal authoring material.",
    "authoring.design.skill.description": "Design or restyle a Workblock with GroundWorks UX contracts, semantic apf- roles, Chassis host boundaries, truthful states and a matching design document. Use for local Claude Code projects and platform-bound Workblocks.",
    "authoring.design.skill.step1": "Read the target AGENTS.md and DESIGN.md, then retrieve workblock-design with get_guide.",
    "authoring.design.skill.step2": "Select the domain Workblock, business module, app-register job, states and human authority before selecting components.",
    "authoring.design.skill.step3": "Retrieve the design doctrine and required admitted component assets through the GroundWorks MCP.",
    "authoring.design.skill.step4": "Implement typed React, compiled CSS and the design document with apf- semantic roles and recorded provenance.",
    "authoring.design.skill.step5": "Validate browser behaviour, accessibility, responsive reflow and platform runtime evidence in proportion to the change.",
    "authoring.design.system.components.body": "The catalogue contains 25 framework-register components plus the shared Glyph. UX supply rows remain requirements until separately admitted; GroundWorks 0.20.0 is sealed reference material and its React, CSS and gw- selectors must not be imported.",
    "authoring.design.system.components.title": "Start from admitted component contracts",
    "authoring.design.system.glyphs.body": "Resolve symbols through the governed semantic mapping, render them in currentColor and keep a visible text label. Never substitute a second icon library when a meaning is unresolved.",
    "authoring.design.system.glyphs.title": "Map meaning to the canonical glyph",
    "authoring.design.system.roles.body": "Use the apf-<export-name> grammar with spelled-out elements and modifiers. Colour, type, spacing, borders and status bind through the design-system roles and the Accenture theme.",
    "authoring.design.system.roles.title": "Bind apf- roles, never primitive values",
    "authoring.design.title": "Brand and style a Workblock with GroundWorks UX components",
    "authoring.design.truth.accessibility.body": "Preserve reading order, landmarks, labels, visible focus, keyboard completion, reduced motion, text enlargement and non-colour state cues. Responsive behaviour must preserve meaning rather than merely fit the viewport.",
    "authoring.design.truth.accessibility.title": "Design the full interaction contract",
    "authoring.design.truth.authority.body": "Name the accountable person, authority ceiling, required review and intervention path. Do not imply that an agent approves or owns a consequential outcome.",
    "authoring.design.truth.authority.title": "Put the decision owner beside the action",
    "authoring.design.truth.state.body": "Keep source truth, derived interpretation, machine proposal, human decision, commit attempt, reconciled outcome, failure and reversal visually distinct. Retain last-good values with their real age when a source degrades.",
    "authoring.design.truth.state.title": "Show the lifecycle state that exists",
    "authoring.kit.description": "A self-contained, read-only local MCP server, a complete index of the site-safe GroundWorks asset catalogue, two copy-ready Claude Code skills and the governed setup guide.",
    "authoring.kit.setup.boundary-body": "The MCP server opens only manifest.json and the exact generated files that manifest names. It has no write tool, no network call and no repository traversal. Asset provenance, proof class, licence, compatibility and SHA-256 remain adjacent to every returned file.",
    "authoring.kit.setup.boundary-title": "Access boundary",
    "authoring.kit.setup.configuration-body": "The example starts server.mjs with Node.js and points it at the registry carried beside the server. Adjust the relative paths only when the extracted folder has a different name.",
    "authoring.kit.setup.configuration-title": "Claude Code configuration",
    "authoring.kit.setup.configure.body": "Copy .mcp.json.example to .mcp.json at the project root, or merge its groundworks server entry into the existing file. Node.js 20 or later is sufficient; the server has no package dependency.",
    "authoring.kit.setup.configure.title": "Add the MCP configuration",
    "authoring.kit.setup.download.body": "Extract the archive into the project that Claude Code will author. Keep server.mjs beside the registry directory so the example configuration works without an install step.",
    "authoring.kit.setup.download.title": "Download and extract the kit",
    "authoring.kit.setup.index-note": "registry/manifest.json is the complete permitted index for the assets physically carried in this archive. The enclosing archive is listed by the website manifest after the archive is built, so it is intentionally not recursive inside itself.",
    "authoring.kit.setup.introduction": "The server reads only the manifest-listed files carried by the kit. It does not scan the host repository, use the network or write project files.",
    "authoring.kit.setup.skills-description": "Install the matching skill for the work: one governs GroundWorks brand and interaction design, and one governs Workblock data and architecture.",
    "authoring.kit.setup.skills-title": "Suggested Claude Code skills",
    "authoring.kit.setup.skills.body": "Copy the two folders under skills into .claude/skills in the project. They route design work and architecture work to the matching guide, prompt and MCP tools.",
    "authoring.kit.setup.skills.title": "Install the suggested skills",
    "authoring.kit.setup.start.body": "Restart Claude Code, ask the GroundWorks MCP for get_started, then paste the matching prompt. Confirm the selected Workblock, business module, component contracts and record owners before changing code.",
    "authoring.kit.setup.start.title": "Start from the guide",
    "authoring.kit.setup.title": "Set up the local GroundWorks MCP",
    "authoring.kit.setup.tools-title": "Read-only MCP tools",
    "authoring.kit.title": "GroundWorks Claude Code authoring kit",
    "authoring.kit.tool.get-asset": "Return one manifest asset and a selected manifest-listed file.",
    "authoring.kit.tool.get-business-module": "Return the public design brief for one business module ID.",
    "authoring.kit.tool.get-component": "Return the admitted component usage and design prompt for one component ID.",
    "authoring.kit.tool.get-design-doctrine": "Return the GroundWorks app and Workblock design doctrine.",
    "authoring.kit.tool.get-entity": "Return the schema and governed contract for one GroundWorks entity ID.",
    "authoring.kit.tool.get-guide": "Return one governed authoring guide.",
    "authoring.kit.tool.get-prompt": "Return one copy-paste authoring prompt.",
    "authoring.kit.tool.get-started": "Return the kit boundary, setup sequence, guides and suggested skills.",
    "authoring.kit.tool.get-starter": "Locate the generated Workblock starter and its verified archive metadata.",
    "authoring.kit.tool.get-workblock": "Return the published design prompt for one domain Workblock ID.",
    "authoring.kit.tool.list-assets": "List manifest-governed assets with optional class and format filters.",
    "authoring.kit.tool.list-skills": "List the generated Claude Code skills and return their manifest-listed files.",
    "authoring.kit.tool.search-assets": "Search permitted asset metadata without scanning the host project.",
    "authoring.resource.architecture-prompt.description": "The complete prompt from this guide as a downloadable Markdown asset.",
    "authoring.resource.architecture-prompt.label": "Data and architecture prompt",
    "authoring.resource.connected-work.description": "Canonical mappings and the reliability, authority and recovery contracts around external systems.",
    "authoring.resource.connected-work.label": "Connected Work recipes",
    "authoring.resource.data-catalogue.description": "The canonical entities, fields, relationships, ownership and query contracts.",
    "authoring.resource.data-catalogue.label": "GroundWorks data catalogue",
    "authoring.resource.data-dictionary.description": "Every published entity and field in one downloadable reference.",
    "authoring.resource.data-dictionary.label": "GroundWorks data dictionary",
    "authoring.resource.design-catalogue.description": "All 26 admitted components with contracts, reference TSX and component-specific prompts.",
    "authoring.resource.design-catalogue.label": "Component catalogue",
    "authoring.resource.design-doctrine.description": "The app object language, desk postures, state model and authority grammar as design.md.",
    "authoring.resource.design-doctrine.label": "GroundWorks design doctrine",
    "authoring.resource.design-prompt.description": "The complete prompt from this guide as a downloadable Markdown asset.",
    "authoring.resource.design-prompt.label": "Brand and style prompt",
    "authoring.resource.kit.description": "Read-only local MCP, complete permitted asset index, setup guide and two generated Claude Code skills.",
    "authoring.resource.kit.label": "Claude Code authoring kit",
    "authoring.resource.module-briefs.description": "One public brief per module with the governed job, subordinate jobs, authority, records and measures.",
    "authoring.resource.module-briefs.label": "Business-module design briefs",
    "authoring.resource.portable.description": "Use GroundWorks - Source 2 Pay or a generated starter as the governed source, then create a feature version before adapting it.",
    "authoring.resource.portable.label": "Platform template and portable source",
    "authoring.resource.starter.description": "A fixture-backed typed Workblock scaffold with manifest, schema, task graph, React surface, DESIGN.md and provenance.",
    "authoring.resource.starter.label": "Generated Workblock starter",
    "authoring.resource.workblocks.description": "Nine domain Workblocks and 45 business modules with their outcomes, roles, jobs and status.",
    "authoring.resource.workblocks.label": "Workblock and module catalogue",
    "authoring.skill.boundaries.title": "Required boundaries",
    "authoring.skill.introduction": "Use the read-only GroundWorks MCP as the source of framework, Workblock, component and data contracts. Read the target project's AGENTS.md and DESIGN.md before changing files.",
    "authoring.skill.retrieval.guide": "Call get_guide with {guideId} before editing.",
    "authoring.skill.retrieval.prompt": "Call get_prompt with {promptId} when a complete commission prompt is useful.",
    "authoring.skill.retrieval.search": "Use list_assets or search_assets to resolve an unknown asset ID. Never infer a private or unlisted file.",
    "authoring.skill.retrieval.targeted": "Use get_workblock, get_business_module, get_entity, get_design_doctrine and get_component only for the selected target.",
    "authoring.skill.retrieval.title": "Retrieval route",
    "authoring.skill.workflow.title": "Workflow",
    "brand.descriptor": "The foundation for agentic source-to-pay.",
    "brand.name": "Accenture GroundWorks",
    "capability-row.agents-cowork.label": "Governed agents and co-work",
    "capability-row.connect-change.label": "Integration and continuous change",
    "capability-row.intelligence-control.label": "Intelligence, evidence and control",
    "capability.authoring.description": "Configure a domain Workblock and its business modules for the client, then version, replay, evaluate and redeploy it without replacing the platform.",
    "capability.authoring.label": "Workblock authoring and continuous tailoring",
    "capability.control-tower.description": "The framework defines one role-scoped operating picture: outcomes, tasks, evidence and domain health, each opening into the records that produced it.",
    "capability.control-tower.label": "Accenture Procurement Control Tower",
    "capability.controls.description": "Make authority, consequence, evidence and recovery explicit at every commitment boundary.",
    "capability.controls.label": "Identity, policy, approval, controls and audit",
    "capability.copilot.description": "Give one procurement agent access to authorised Workblocks while preserving grants, approvals and audit.",
    "capability.copilot.label": "Governed procurement agents and tools",
    "capability.data.description": "Query governed data in place or connect the warehouse the client already runs.",
    "capability.data.label": "Shared data, evidence, analytics and learning",
    "capability.integration.description": "Connect ERP, suites, SharePoint and warehouses through narrow, observable adapters.",
    "capability.integration.label": "Integration and coexistence",
    "capability.messaging.description": "Keep language, glossary terms and reusable delivery know-how consistent across every Workblock and channel.",
    "capability.messaging.label": "Messaging, localisation, glossary and partner know-how",
    "capability.office.description": "Make document and workbook capabilities available to any authorised Workblock with DOCX and XLSX round-trip fidelity.",
    "capability.office.label": "Composer, Conductor and native Office work",
    "catalogue.clear-filters": "Clear filters",
    "catalogue.count.domain-many": "{count} domains",
    "catalogue.count.domain-one": "{count} domain",
    "catalogue.count.domain.plural": "{count} domains",
    "catalogue.count.domain.singular": "{count} domain",
    "catalogue.count.job-many": "{count} jobs",
    "catalogue.count.job-one": "{count} job",
    "catalogue.count.role-many": "{count} roles",
    "catalogue.count.role-one": "{count} role",
    "catalogue.count.situation-many": "{count} situations",
    "catalogue.count.situation-one": "{count} situation",
    "catalogue.count.visible": "{count} visible",
    "catalogue.domain": "Domain",
    "catalogue.domain.all": "All domains",
    "catalogue.filter.all-domains": "All domains",
    "catalogue.filter.domain": "Domain",
    "catalogue.filter.role": "Role",
    "catalogue.framework-version": "Framework {version}",
    "catalogue.job": "Job",
    "catalogue.jobs.description": "Browse one job per business module. Open the module for its situations, completion evidence, authority and execution flows.",
    "catalogue.jobs.empty-description": "Clear a filter or search for another job, role or domain.",
    "catalogue.jobs.empty-title": "No jobs match",
    "catalogue.jobs.eyebrow": "Reference · Jobs to be done",
    "catalogue.jobs.filter-label": "Filter jobs",
    "catalogue.jobs.result-count": "{count} of {total} jobs",
    "catalogue.jobs.search-label": "Search jobs",
    "catalogue.jobs.section": "Jobs to be done",
    "catalogue.jobs.title": "The progress each business module owns",
    "catalogue.metadata-pair": "{first} · {second}",
    "catalogue.module.back-to-jobs": "Back to jobs to be done",
    "catalogue.module.browse-domain-roles": "Browse all roles in {name}",
    "catalogue.module.browse-work-moments": "Browse all Work moments for this job",
    "catalogue.module.connected-roles-description": "Only people who perform this job or are consulted on it appear here.",
    "catalogue.module.connected-roles-title": "Roles connected to {name}",
    "catalogue.module.connection-label": "Connection",
    "catalogue.module.consulted-label": "Consulted",
    "catalogue.module.consulted-on-module": "Consulted on this module",
    "catalogue.module.other-role-perspectives": "Other role perspectives",
    "catalogue.module.performer-label": "Performer",
    "catalogue.module.performs-module": "Performs this module",
    "catalogue.module.role-record": "Role record",
    "catalogue.module.work-moment-description": "One bounded example connects this job to its module agent, human authority, evidence and learning.",
    "catalogue.module.work-moment-title": "See the job in practice",
    "catalogue.office": "Office",
    "catalogue.office.any": "Any Office capability",
    "catalogue.partner-version": "Partner release {version}",
    "catalogue.preview.description": "A bounded preview keeps this Workblock readable. The complete role and job catalogues remain one link away.",
    "catalogue.preview.job.current-substitute": "Current substitute",
    "catalogue.preview.job.open": "Open job record",
    "catalogue.preview.job.situations": "Situations",
    "catalogue.preview.job.status": "Status",
    "catalogue.preview.jobs.browse-all": "Browse all jobs in this Workblock",
    "catalogue.preview.jobs.count": "{count} jobs in the complete catalogue; the first three preview below",
    "catalogue.preview.jobs.title": "Jobs this Workblock owns",
    "catalogue.preview.role.arrival-question": "Arrival question",
    "catalogue.preview.role.consulted-on": "Consulted on",
    "catalogue.preview.role.drives": "Drives",
    "catalogue.preview.role.hired-today": "Hired today",
    "catalogue.preview.role.may-commit": "May commit",
    "catalogue.preview.role.may-propose": "May propose",
    "catalogue.preview.role.measured-on": "Measured on",
    "catalogue.preview.role.never-alone": "Never alone",
    "catalogue.preview.role.open": "Open role record",
    "catalogue.preview.role.performs": "Performs",
    "catalogue.preview.role.related-jobs": "Related jobs",
    "catalogue.preview.roles.browse-all": "Browse all roles in this Workblock",
    "catalogue.preview.roles.count": "{count} roles in the complete catalogue; the first three preview below",
    "catalogue.preview.roles.title": "People in this Workblock",
    "catalogue.preview.title": "People keep the decisions",
    "catalogue.proof": "Proof",
    "catalogue.proof.any": "Any proof level",
    "catalogue.proof.pattern": "Pattern",
    "catalogue.proof.reference": "Reference",
    "catalogue.proof.roadmap": "Roadmap",
    "catalogue.role": "Role",
    "catalogue.role-detail.back-to-roles": "Back to roles",
    "catalogue.role-detail.browse-jobs": "Browse this role's jobs in the catalogue",
    "catalogue.role-detail.browse-work-moments": "Browse all Work moments for this role",
    "catalogue.role-detail.consulted-count": "consulted on {count}",
    "catalogue.role-detail.consulted-jobs-empty": "No consulted jobs are connected to this role.",
    "catalogue.role-detail.consulted-jobs-title": "Jobs where this role is consulted",
    "catalogue.role-detail.eyebrow": "Role",
    "catalogue.role-detail.find-workblocks": "Find Workblocks for this role",
    "catalogue.role-detail.may-commit": "May commit",
    "catalogue.role-detail.may-propose": "May propose",
    "catalogue.role-detail.measured-on": "Measured on",
    "catalogue.role-detail.never-alone": "Never alone",
    "catalogue.role-detail.not-found-description": "This role is not part of the current reference.",
    "catalogue.role-detail.not-found-title": "Role not found",
    "catalogue.role-detail.open-domain": "Open {name}",
    "catalogue.role-detail.performed-jobs-empty": "No performed jobs are connected to this role.",
    "catalogue.role-detail.performed-jobs-title": "Jobs this role performs",
    "catalogue.role-detail.performs-count": "performs {count}",
    "catalogue.role-detail.placements-title": "Mandate and authority by domain",
    "catalogue.role-detail.return-to-roles": "Return to roles",
    "catalogue.role-detail.work-moments-title": "See this role at work",
    "catalogue.roles.description": "Browse each human role once, then open its domain mandates, related jobs and Work moments.",
    "catalogue.roles.empty-description": "Clear a filter or search for another role or domain.",
    "catalogue.roles.empty-title": "No roles match",
    "catalogue.roles.eyebrow": "Reference",
    "catalogue.roles.filter-label": "Filter roles",
    "catalogue.roles.initials-label": "Role initials",
    "catalogue.roles.result-count": "{count} of {total} roles",
    "catalogue.roles.search-label": "Search roles",
    "catalogue.roles.section": "Roles",
    "catalogue.roles.title": "Roles across source-to-pay",
    "catalogue.search": "Search",
    "catalogue.unavailable.plural": "{count} filters are unavailable in this view and do not affect these results.",
    "catalogue.unavailable.singular": "{count} filter is unavailable in this view and does not affect these results.",
    "catalogue.visible-count": "{count} visible",
    "catalogue.work-moments.count": "{visible} of {total} Work moments",
    "catalogue.work-moments.empty.description": "Clear a filter or browse another role, job or domain.",
    "catalogue.work-moments.empty.title": "No Work moments match",
    "catalogue.work-moments.filter-label": "Filter Work moments",
    "catalogue.workblocks.buying": "Buying mode",
    "catalogue.workblocks.buying.goods": "Goods",
    "catalogue.workblocks.buying.mixed": "Mixed",
    "catalogue.workblocks.buying.services": "Services",
    "catalogue.workblocks.description": "Open a Workblock to see its five business modules and exact composition.",
    "catalogue.workblocks.empty.description": "Clear a filter or try a broader role, job or search term.",
    "catalogue.workblocks.empty.title": "No Workblocks match",
    "catalogue.workblocks.job": "Job",
    "catalogue.workblocks.job-detail.back-to-jobs": "Back to jobs to be done",
    "catalogue.workblocks.job-detail.connection": "Connection",
    "catalogue.workblocks.job-detail.consulted": "Consulted",
    "catalogue.workblocks.job-detail.performer": "Performer",
    "catalogue.workblocks.match.buying": "Buying mode",
    "catalogue.workblocks.match.dimensions": "Dimensions",
    "catalogue.workblocks.match.job": "Job",
    "catalogue.workblocks.match.prefix": "Matched by",
    "catalogue.workblocks.match.role": "Role",
    "catalogue.workblocks.match.segment": "Spend segment",
    "catalogue.workblocks.match.text": "Text",
    "catalogue.workblocks.match.treatment": "Accounting treatment",
    "catalogue.workblocks.module-count": "{count} business modules",
    "catalogue.workblocks.result-count": "{visible} of {total} Workblocks",
    "catalogue.workblocks.role": "Role",
    "catalogue.workblocks.role-context.plural": "{count} domains",
    "catalogue.workblocks.role-context.singular": "{count} domain",
    "catalogue.workblocks.search-label": "Search Workblocks, roles and jobs",
    "catalogue.workblocks.search-placeholder": "Search Workblocks, roles or jobs",
    "catalogue.workblocks.segment": "Spend segment",
    "catalogue.workblocks.segment.direct": "Direct",
    "catalogue.workblocks.segment.indirect": "Indirect",
    "catalogue.workblocks.title": "Workblock catalogue",
    "catalogue.workblocks.treatment": "Accounting treatment",
    "catalogue.workblocks.treatment.capital": "Capital",
    "catalogue.workblocks.treatment.operating": "Operating",
    "catalogue.workblocks.unavailable.plural": "{count} unavailable filters were ignored.",
    "catalogue.workblocks.unavailable.singular": "{count} unavailable filter was ignored.",
    "claim.continuous-tailoring": "Workblocks can be versioned and changed independently, enabling continuous client tailoring.",
    "claim.days-not-weeks": "Workblocks are integrated with client systems in days, not weeks, and working Workblocks are built in the same timeframe.",
    "claim.trust": "Beyond Work execution rails are a European, AI-first, enterprise-native foundation, SOC 2 Type II audited and ISO 27001 certified.",
    "commercial.pricing-headline": "Outcome-based pricing, capped to protect the agreed hard-cost saving versus the legacy SaaS baseline.",
    "component.disclosure.hide-details": "Hide details",
    "component.disclosure.show-details": "Show details",
    "component.facet.clear": "Clear {label}",
    "component.facet.clear-all": "Clear all",
    "component.facet.clear-unavailable": "Clear unavailable filters",
    "component.facet.more-count": "{count} more",
    "component.facet.no-options": "No matching options.",
    "component.facet.option-count": "{count} matching records",
    "component.facet.result-count": "{count} options match.",
    "component.facet.search": "Search {label}",
    "component.facet.selected-count": "{count} selected",
    "component.facet.try-again": "Try again.",
    "component.facet.unavailable-count": "{count} filters are unavailable in this view.",
    "dimension.accounting-treatment.definition": "How an authorised accounting distribution treats the expenditure: capital or operating. A line spanning both treatments is split across distributions rather than assigned a mixed value.",
    "dimension.accounting-treatment.label": "Accounting treatment",
    "dimension.accounting-treatment.member.capital.definition": "Expenditure on an asset the organisation acquires and uses rather than resells, subject to its accounting policy.",
    "dimension.accounting-treatment.member.capital.label": "Capital",
    "dimension.accounting-treatment.member.operating.definition": "Expenditure recognised as an operating cost under the organisation's accounting policy.",
    "dimension.accounting-treatment.member.operating.label": "Operating",
    "dimension.buying-mode.definition": "How the purchase is fulfilled: goods, services or a governed mix. Buying mode can apply to either direct or indirect spend.",
    "dimension.buying-mode.label": "Buying mode",
    "dimension.buying-mode.member.goods.definition": "Tangible items acquired through a governed purchasing route.",
    "dimension.buying-mode.member.goods.label": "Goods",
    "dimension.buying-mode.member.mixed.definition": "A governed requirement that combines goods and services and cannot be represented truthfully by either member alone.",
    "dimension.buying-mode.member.mixed.label": "Mixed",
    "dimension.buying-mode.member.services.definition": "People-based or outcome-based work procured through a statement of work or another governed service engagement.",
    "dimension.buying-mode.member.services.label": "Services",
    "dimension.category.definition": "What is bought, represented by tenant-controlled records in a versioned procurement taxonomy. Category is not a universal fixed tree, and external codes do not replace canonical category IDs.",
    "dimension.category.label": "Category",
    "dimension.spend-segment.definition": "How spend relates to the organisation's delivered goods or services. A company-scoped category assignment supplies the default, and an authorised transaction-line decision takes precedence. It is separate from category, buying mode and accounting treatment.",
    "dimension.spend-segment.label": "Spend segment",
    "dimension.spend-segment.member.direct.definition": "Spend on goods or services that enter what the organisation delivers, including raw materials, components and subcontracted production.",
    "dimension.spend-segment.member.direct.label": "Direct",
    "dimension.spend-segment.member.indirect.definition": "Spend that supports the organisation's operation without entering its delivered product or service, such as technology, facilities, marketing, professional services and maintenance.",
    "dimension.spend-segment.member.indirect.label": "Indirect",
    "dimension.tail-membership.definition": "A period-specific outcome derived from a versioned company rule over spend. Tail membership is not stored as an unqualified boolean or taxonomy level.",
    "dimension.tail-membership.label": "Tail membership",
    "dimension.tail-membership.member.non-tail.definition": "The record falls outside the stated versioned tail-spend rule for the evaluated period.",
    "dimension.tail-membership.member.non-tail.label": "Non-tail",
    "dimension.tail-membership.member.tail.definition": "The record falls within the stated versioned tail-spend rule for the evaluated period.",
    "dimension.tail-membership.member.tail.label": "Tail",
    "domain.buying.buyer-question": "Can we remove a real handoff without creating a shadow order or a weaker approval path?",
    "domain.buying.change.exception-case.after": "The exception arrives as one case: the affected order version, the evidence for its cause, the owner, the authority each option needs and the next valid action. It closes when the owning system shows the corrected state, not when a retry is sent.",
    "domain.buying.change.exception-case.before": "A failed order raises an error code in a worklist. The resolver opens each related system, works out the cause by hand and closes the ticket once a retry is sent.",
    "domain.buying.change.exception-case.title": "The exception arrives as a case",
    "domain.buying.change.graduated-attention.after": "Demand that matches an approved category, supplier and budget moves on the policy's authority, with the full record kept. People see the cases that carry an exception, missing evidence or material spend, and an exception can never quietly become routine.",
    "domain.buying.change.graduated-attention.before": "Every request walks the same approval chain, so approvers clear queues of routine requests while the exceptional ones wait in the same line.",
    "domain.buying.change.graduated-attention.title": "Attention follows materiality",
    "domain.buying.description": "Guide compliant buying, resolve purchase-order exceptions and keep ERP execution aligned with policy.",
    "domain.buying.gap-1": "The buying stack largely works. Catalogue, punchout, requisition, approval, order, receipt: the ERP and the suite run the sequence, and they run it well. The cost sits where the sequence breaks: a failed order, a supplier who rejects or changes a line, a delivery that does not match, a status feed that goes quiet.",
    "domain.buying.gap-2": "When that happens, an error code names the symptom and a person rebuilds the case. The buyer opens the requisition in one system, the order and its versions in another, the message log in a third, the supplier's response in a fourth, then decides what the code meant, who owns the fix and whether a resend is safe. Each system holds its part of the truth. Nobody holds the case.",
    "domain.buying.gap-3": "On the requester side the same distance shows up earlier. The route that applies depends on policy, an agreement, supplier status and budget, and those facts sit outside the buying screen. So the request comes back for rework, waits on a question no one owns, or slips off contract because the compliant path was the harder one to find.",
    "domain.buying.label": "Buying, requisitioning, ordering and receiving",
    "domain.buying.outcome": "The compliant route is the easiest one, and every exception reaches a named owner.",
    "domain.buying.principle.erp-keeps-transaction.body": "Catalogue, supplier network, receiving and finance records stay where they are. The Workblock assembles the policy, agreement, supplier and budget facts around the case, then carries only the approved action into the system that owns it. No shadow requisition, no shadow order.",
    "domain.buying.principle.erp-keeps-transaction.title": "The ERP keeps the transaction",
    "domain.buying.principle.no-blind-retry.body": "A timeout leaves the commit state unknown, so the authoritative system is read before anything is resent. The attempt history is kept, a retry runs only under a named recovery owner, and one approved action produces exactly one transaction.",
    "domain.buying.principle.no-blind-retry.title": "An uncertain write never retries blind",
    "domain.buying.principle.proposal-not-order.body": "A proposed route, correction or change carries its own state and never wears the language of a committed transaction. It becomes a requisition, an order or a receipt only when a named person or a validated policy commits it in the system that owns the record, and the committed result is confirmed at the source rather than assumed.",
    "domain.buying.principle.proposal-not-order.title": "A proposal is never an order",
    "domain.buying.proof-question": "Can a stated need reach the valid buying route, with the reason visible, while the ERP keeps every transaction?",
    "domain.buying.role.budget-owner.alone": "Never creates the evidence they are meant to review independently.",
    "domain.buying.role.budget-owner.commit": "A requisition or an override inside their delegated threshold.",
    "domain.buying.role.budget-owner.hired": "An approval email, a mobile prompt and a chase to whoever holds the missing context.",
    "domain.buying.role.budget-owner.mandate": "Own the spend and its business consequence.",
    "domain.buying.role.budget-owner.measured": "Approval time by request class, returns for missing evidence, post-approval change rate.",
    "domain.buying.role.budget-owner.propose": "Conditions on a request, or its return with a reason.",
    "domain.buying.role.budget-owner.question": "Do I have enough in front of me to approve this, and what happens if I do?",
    "domain.buying.role.budget-owner.title": "Budget owner",
    "domain.buying.role.integration-owner.alone": "Never decides the business correction carried by a write.",
    "domain.buying.role.integration-owner.commit": "A technical production change or replay under the runbook.",
    "domain.buying.role.integration-owner.hired": "An integration monitor, message logs, a runbook and a ticket queue.",
    "domain.buying.role.integration-owner.mandate": "Protect transaction and interface integrity across order, message and status flows.",
    "domain.buying.role.integration-owner.measured": "Duplicate-action rate, recovery completeness, acknowledgement coverage and age.",
    "domain.buying.role.integration-owner.propose": "A replay, an adapter fix or a recovery plan.",
    "domain.buying.role.integration-owner.question": "Did that write commit, and is it safe to send again?",
    "domain.buying.role.integration-owner.title": "ERP or integration owner",
    "domain.buying.role.procurement-buyer.alone": "Never accepts a legal, risk or finance exception outside their mandate.",
    "domain.buying.role.procurement-buyer.commit": "A purchase order or change inside their delegation.",
    "domain.buying.role.procurement-buyer.hired": "The ERP worklist, the supplier network portal, email threads and a spreadsheet of open cases.",
    "domain.buying.role.procurement-buyer.mandate": "Own order creation and every supplier-facing change.",
    "domain.buying.role.procurement-buyer.measured": "Straight-through order creation, touches per exception, resolution time by cause, aged open order lines.",
    "domain.buying.role.procurement-buyer.propose": "Orders, changes, cancellations and exception actions.",
    "domain.buying.role.procurement-buyer.question": "What broke on this order, and what single action puts it right?",
    "domain.buying.role.procurement-buyer.title": "Procurement buyer",
    "domain.buying.role.receiver.alone": "Never certifies a delivery or a service they did not observe.",
    "domain.buying.role.receiver.commit": "Receipt or service acceptance inside their delegated scope.",
    "domain.buying.role.receiver.hired": "The ERP receiving screen, a warehouse system and email chases from finance.",
    "domain.buying.role.receiver.mandate": "Confirm what was actually received or accepted, and nothing more.",
    "domain.buying.role.receiver.measured": "Receipt timeliness, correction and reversal rate, disputed acceptances.",
    "domain.buying.role.receiver.propose": "A receipt, rejection, correction or return.",
    "domain.buying.role.receiver.question": "What is due, what arrived, and what do I do about the difference?",
    "domain.buying.role.receiver.title": "Receiver or service owner",
    "domain.buying.role.requester.alone": "Never approves their own spend where independent approval applies, and never certifies a receipt they did not observe.",
    "domain.buying.role.requester.commit": "Submitting the demand and confirming the supplied facts within their role.",
    "domain.buying.role.requester.hired": "A catalogue tile, a punchout site, a help desk and a colleague who knows the route.",
    "domain.buying.role.requester.mandate": "State the need, the constraints and what was actually received.",
    "domain.buying.role.requester.measured": "Active effort per request, requests returned for missing facts, time from need to accepted route.",
    "domain.buying.role.requester.propose": "Route, item, supplier, dates and change requests.",
    "domain.buying.role.requester.question": "What is the right way to buy this, and where is my request now?",
    "domain.buying.role.requester.title": "Requester",
    "domain.buying.short": "Buying",
    "domain.buying.wedge": "Start with one recurring purchase-order exception: a cause that returns every week, with named owners and a way to confirm the corrected state in the system that owns the order. Lead with guided buying only where one demand class keeps missing its route after the configured path has been examined.",
    "domain.clm.buyer-question": "What changes beyond adding another contract assistant?",
    "domain.clm.change.active-obligations.after": "Executed language becomes owned cases. A renewal arrives as a decision with the clause, the notice deadline, the performance history and a named owner, before the window closes.",
    "domain.clm.change.active-obligations.before": "Executed contracts sit in a repository with reminders. A notification says a contract is about to expire; someone rereads it, works out what it means and chases the owner.",
    "domain.clm.change.active-obligations.title": "From repository to active obligations",
    "domain.clm.change.review-decisions.after": "Each material clause arrives as a decision: the exact language, the position it departs from, the options and the reviewer whose authority it needs, with uncertainty stated rather than smoothed over.",
    "domain.clm.change.review-decisions.before": "A contract is uploaded and a long machine summary comes back: risks, observations and suggested language, hard to verify and structured around nothing in particular.",
    "domain.clm.change.review-decisions.title": "Findings become decisions",
    "domain.clm.description": "Draft, review, approve and monitor contracts while preserving native document fidelity and human legal authority.",
    "domain.clm.gap-1": "The contract system already extracts clauses and sends reminders. Yet when third-party paper arrives, a reviewer still rebuilds the case by hand: the award context from sourcing, the playbook version that applies, the definition two schedules away that changes a clause's meaning. The findings travel into an approval pack by copy and paste, and the exact language and version stay behind.",
    "domain.clm.gap-2": "After signature the pattern repeats. Dates and obligations are extracted or keyed in, and owners receive alerts. An alert says a deadline is near. It does not carry the clause, the trigger event, the evidence rule or the authority to close the case. So the contract manager rereads the agreement, chases the service owner and reconciles what an invoice, a performance report or an amendment means for the rights the organisation holds.",
    "domain.clm.gap-3": "The cost lands between systems. A document change does not reopen the approvals it affects. Fulfilment evidence sits in ERP and service systems while closure stays manual. A notice window is discovered after the right has lapsed. None of this is a missing feature in the contract system: it is the work that happens after the repository and before the decision.",
    "domain.clm.label": "Contract lifecycle management",
    "domain.clm.outcome": "Every clause, control and obligation stays attached to its contract, with a named owner for each one.",
    "domain.clm.principle.native-artifact.body": "Contract review happens in the native DOCX through Composer: comparison, comments and tracked changes survive the round trip, and nothing is flattened into platform-only fields. The immutable original, the working copy and the executed copy remain distinct artifacts.",
    "domain.clm.principle.native-artifact.title": "The document stays the document",
    "domain.clm.principle.owned-obligations.body": "Executed language creates cases that carry the source clause, the trigger, the due logic and the evidence rule, with an owner who has accepted the duty. Evidence submitted is not evidence accepted: the named authority closes a material case, and a disputed one stays open until it does.",
    "domain.clm.principle.owned-obligations.title": "Obligations become owned cases",
    "domain.clm.principle.proposal-not-position.body": "Machine-drafted language stays visibly proposed, with its source and playbook basis attached, until the named owner accepts, edits or rejects it. Approval binds to one exact version and reopens when the document materially changes. Approved for signature is not executed: only the authorised signatory commits the organisation.",
    "domain.clm.principle.proposal-not-position.title": "A proposal is not a position",
    "domain.clm.proof-question": "Can one contract be traced from proposed language through human acceptance to the action that followed, with the native document intact and every finding opening the exact language behind it?",
    "domain.clm.role.category-manager.alone": "Never accepts contract terms: the sourcing manager, legal counsel and award authority hold acceptance.",
    "domain.clm.role.category-manager.commit": "Commits category decisions inside formally delegated authority.",
    "domain.clm.role.category-manager.hired": "A renewals spreadsheet, contract summaries and the category plan.",
    "domain.clm.role.category-manager.mandate": "Own the commercial outcome of a category across its contracts.",
    "domain.clm.role.category-manager.measured": "Category contracts approaching renewal, share of category spend under contract, price and term variance against the category plan.",
    "domain.clm.role.category-manager.propose": "Renewal, renegotiation and consolidation cases across the category's contracts.",
    "domain.clm.role.category-manager.question": "Which contracts in my category are about to change what I can commit to?",
    "domain.clm.role.category-manager.title": "Category manager",
    "domain.clm.role.contract-manager.alone": "Never accepts a material legal position: legal counsel holds that decision.",
    "domain.clm.role.contract-manager.commit": "Closes or escalates cases within delegation.",
    "domain.clm.role.contract-manager.hired": "A contract-system worklist, a Word folder, an issue spreadsheet and email chases.",
    "domain.clm.role.contract-manager.mandate": "Own the contract lifecycle from request to closed obligations: routing, repository quality, milestones and cross-functional follow-through.",
    "domain.clm.role.contract-manager.measured": "Cycle time from request to first reviewable draft, missing-information returns, obligations with accepted owners, notices decided inside their window.",
    "domain.clm.role.contract-manager.propose": "Routing, issue disposition, obligation ownership and escalation.",
    "domain.clm.role.contract-manager.question": "Which contracts are waiting on a decision, and what does each one need before it can move?",
    "domain.clm.role.contract-manager.title": "Contract manager",
    "domain.clm.role.legal-counsel.alone": "Never commits the organisation to the agreement: signature stays with the authorised signatory.",
    "domain.clm.role.legal-counsel.commit": "Accepts legal positions within delegation and decides when specialist or external advice is needed.",
    "domain.clm.role.legal-counsel.hired": "Word with tracked changes, the playbook binder and an inbox of review requests.",
    "domain.clm.role.legal-counsel.mandate": "Interpret legal effect and protect the organisation's legal position on every material deviation.",
    "domain.clm.role.legal-counsel.measured": "Material deviations found and decided, unsupported findings corrected, decisions reopened after acceptance.",
    "domain.clm.role.legal-counsel.propose": "Clause language, risk treatment and legal exceptions.",
    "domain.clm.role.legal-counsel.question": "Which clauses actually need my judgement, and is the evidence behind each finding complete?",
    "domain.clm.role.legal-counsel.title": "Legal counsel",
    "domain.clm.role.obligation-owner.alone": "Never waives a right or closes a disputed case: the delegated contract authority holds that decision.",
    "domain.clm.role.obligation-owner.commit": "Attests performance under the approved policy.",
    "domain.clm.role.obligation-owner.hired": "A task in a worklist, a calendar reminder and the contract PDF reread each time.",
    "domain.clm.role.obligation-owner.mandate": "Perform or coordinate a contractual duty, or exercise a right, and prove it happened.",
    "domain.clm.role.obligation-owner.measured": "On-time accepted closure, partial or disputed closures, evidence completeness.",
    "domain.clm.role.obligation-owner.propose": "Completion plans, evidence and exceptions.",
    "domain.clm.role.obligation-owner.question": "What exactly must I do, by when, and what evidence closes it?",
    "domain.clm.role.obligation-owner.title": "Obligation owner",
    "domain.clm.role.sourcing-manager.alone": "Never accepts a legal position: legal effect stays with counsel.",
    "domain.clm.role.sourcing-manager.commit": "Accepts delegated commercial positions within the delegated threshold.",
    "domain.clm.role.sourcing-manager.hired": "The award workbook, email threads with counsel and the negotiation meeting notes.",
    "domain.clm.role.sourcing-manager.mandate": "Carry the awarded commercial position into the executed agreement.",
    "domain.clm.role.sourcing-manager.measured": "Award terms that survive to execution, commercial positions reopened after acceptance, approval returns, time from award to signature.",
    "domain.clm.role.sourcing-manager.propose": "Commercial terms, negotiation responses and trade-offs.",
    "domain.clm.role.sourcing-manager.question": "Does this paper still hold the price, service and risk position we won?",
    "domain.clm.role.sourcing-manager.title": "Sourcing manager",
    "domain.clm.short": "Contracts",
    "domain.clm.wedge": "Start with one contract family and one decision boundary: third-party paper taken to accepted positions, or one material obligation class taken to accepted closure.",
    "domain.intake.buyer-question": "Can we improve the request experience without replacing the systems that execute procurement?",
    "domain.intake.change.decision-package.after": "The route arrives as a proposal: the policy cited, the source facts with their freshness, what is missing, the alternatives considered and the named owner who accepts or corrects it.",
    "domain.intake.change.decision-package.before": "A form or chat captures the request. An analyst still rebuilds the case by hand across policy, contracts, suppliers, budget and prior requests before anyone can route it.",
    "domain.intake.change.decision-package.title": "Routing becomes a decision package",
    "domain.intake.change.parent-outcome.after": "One parent plan links each specialist's record. A failed step shows as blocked with an owner. The parent cannot report complete while material child work stays open.",
    "domain.intake.change.parent-outcome.before": "One request becomes four queue entries. Procurement, legal, risk and buying each track their own piece, and nobody can say when the whole thing is done.",
    "domain.intake.change.parent-outcome.title": "One parent outcome",
    "domain.intake.description": "Give every request a guided front door, gather the facts that decide its route and hand it to the right policy, person or Workblock.",
    "domain.intake.gap-1": "Today a request starts in email, chat, a portal or a form. An analyst reads it, asks for what is missing, then searches policies, contracts, suppliers, catalogues and budgets by hand before anyone can say what happens next.",
    "domain.intake.gap-2": "Once routed, the request is recreated in one or more downstream systems. Each specialist team asks its own questions and records its own decision. Dependencies travel in meeting notes and spreadsheets. The requester holds a case number and chases status, while the parent request reads in progress and nobody owns the next decision.",
    "domain.intake.gap-3": "The cost accumulates in the gaps. Wrong routes surface late, after a specialist returns the work. Urgent requests bypass review without a named exception. Parents close when a coordinator believes the work is done, not when the evidence confirms it, and months later nobody can reconstruct why a route was valid at the time.",
    "domain.intake.label": "Intake and demand",
    "domain.intake.outcome": "Every request arrives complete, routed and owned, without manual triage.",
    "domain.intake.principle.complete-per-route.body": "Completeness is defined by the selected path and its consequence, not by a universal form. A question is asked only when its answer changes the route, the required evidence, the owner or the authority.",
    "domain.intake.principle.complete-per-route.title": "Complete means ready for the route",
    "domain.intake.principle.no-state-from-silence.body": "Expiry, timeout, access denial and a failed write are explicit states with owners. A waiting request says what it waits for, who resolves it and what reopens it.",
    "domain.intake.principle.no-state-from-silence.title": "No state is inferred from silence",
    "domain.intake.principle.proposal-not-commitment.body": "A machine may classify a request and propose a route. The accepted route carries the name of the person or policy that committed it, and the two states never blur.",
    "domain.intake.principle.proposal-not-commitment.title": "Proposal is not commitment",
    "domain.intake.proof-question": "Does the front door ask only for the facts it cannot find, explain the route it proposes and keep the owner and state visible after the handoff?",
    "domain.intake.role.demand-owner.alone": "Never absorbs a specialist decision into coordination, and never closes a parent while material child work stays open.",
    "domain.intake.role.demand-owner.commit": "Routine plan changes under delegated process policy.",
    "domain.intake.role.demand-owner.hired": "A coordination spreadsheet, standing status meetings and chasing by email.",
    "domain.intake.role.demand-owner.mandate": "Keep an accepted request moving across specialist owners and systems until the agreed outcome is complete.",
    "domain.intake.role.demand-owner.measured": "Requests with an owned next action, orphaned child work and agreement between parent status and child systems.",
    "domain.intake.role.demand-owner.propose": "The plan of downstream work with its dependencies, owners and completion rules.",
    "domain.intake.role.demand-owner.question": "What is the next valid action on each open request, and what is it waiting for?",
    "domain.intake.role.demand-owner.title": "Demand owner",
    "domain.intake.role.intake-owner.alone": "Never makes a specialist risk, legal, tax or security decision, and never approves spend.",
    "domain.intake.role.intake-owner.commit": "Accepting, redirecting, splitting, merging or declining a request under the approved intake policy.",
    "domain.intake.role.intake-owner.hired": "A case queue, a shared mailbox and hand searches across policy, contract and supplier systems.",
    "domain.intake.role.intake-owner.mandate": "Qualify demand, resolve route ambiguity and own the parent request until it is accepted, redirected or declined.",
    "domain.intake.role.intake-owner.measured": "First-valid-route rate, clarification touches per request and the age of unrouted requests.",
    "domain.intake.role.intake-owner.propose": "Classification, route options, splits, merges and requests for missing evidence.",
    "domain.intake.role.intake-owner.question": "Which requests wait on a decision, and what evidence clears each one?",
    "domain.intake.role.intake-owner.title": "Procurement intake owner",
    "domain.intake.role.process-owner.alone": "Never decides an individual case outside the policy they own.",
    "domain.intake.role.process-owner.commit": "Policy and rule changes through the agreed release path.",
    "domain.intake.role.process-owner.hired": "A policy document, a configuration backlog and a quarterly review meeting.",
    "domain.intake.role.process-owner.mandate": "Define the intake rules, thresholds, evidence requirements and exception ownership, and change them safely.",
    "domain.intake.role.process-owner.measured": "Override rate by rule, exception rework and the lead time to change a routing rule.",
    "domain.intake.role.process-owner.propose": "Rule and threshold changes drawn from override and correction history.",
    "domain.intake.role.process-owner.question": "Which rules are being overridden, and is the rule wrong or the case exceptional?",
    "domain.intake.role.process-owner.title": "Process and policy owner",
    "domain.intake.role.requester.alone": "Never commits budget, accepts supplier risk or approves a policy exception.",
    "domain.intake.role.requester.commit": "Withdrawing or amending their own request within policy.",
    "domain.intake.role.requester.hired": "A shared mailbox, a colleague who knows the process and whichever form appears first in search.",
    "domain.intake.role.requester.mandate": "Explain the business need, supply the facts they hold and confirm the requested outcome.",
    "domain.intake.role.requester.measured": "Time from expressing a need to receiving the outcome, and rework returned to them.",
    "domain.intake.role.requester.propose": "Business intent, factual corrections and amendments to their own request.",
    "domain.intake.role.requester.question": "Where is my request, who owns it and what do you still need from me?",
    "domain.intake.role.requester.title": "Requester",
    "domain.intake.short": "Intake and demand",
    "domain.intake.wedge": "Start with one non-catalogue request family that is returned or rerouted today: several owners, a measurable baseline and one downstream action that can be tested safely.",
    "domain.invoice.buyer-question": "Can we remove cross-system exception work without weakening the systems and controls that already move money?",
    "domain.invoice.change.causal-case.after": "The failed check arrives as one case: the competing causes, the evidence that separates them, the accountable owner and the next valid action. The case closes only when the source system accepts the change and reruns the check.",
    "domain.invoice.change.causal-case.before": "A failed check lands in a worklist as a code that names the symptom. The processor works out the cause and the owner by hand, one system at a time.",
    "domain.invoice.change.causal-case.title": "From queue codes to causal cases",
    "domain.invoice.change.dated-readiness.after": "Every release condition names its source and observation time. A material change expires the proposal and reopens only the affected checks. The payment system keeps final release control.",
    "domain.invoice.change.dated-readiness.before": "A payment candidate shows eligible. The approval was granted days ago, and the payee record, a hold or a screening result may have changed since.",
    "domain.invoice.change.dated-readiness.title": "From a status badge to a dated decision",
    "domain.invoice.description": "Classify invoice exceptions, collect the missing records and prepare decisions before payment execution.",
    "domain.invoice.gap-1": "The estate itself is capable. Capture, matching, tax checks and payment controls run where they always have. But when an invoice fails a check, the worklist carries a code that says what failed, not why. An AP processor opens the exception, then searches purchase orders, receipts, contracts, supplier history and email for the cause, and picks an owner by judgement.",
    "domain.invoice.gap-2": "The case then moves. A receiver is asked to confirm delivery, a buyer to check the order, a tax specialist to rule on treatment, and each handoff restarts the search because the failed check was routed as if it were the cause. A reply saying the issue is handled looks like resolution while the invoice stays held. Downstream, a payment run selects the invoice and an approver signs a batch summary. That approval can outlive the payee record, the hold or the screening result that justified it.",
    "domain.invoice.gap-3": "The gap is not capture, matching or payment execution. Those are mature and stay where they are, and some ERP and AP configurations already assemble the whole case; where they do, they should keep it. The work worth changing is the case that crosses systems: the exception whose cause and owner sit in different records, and the payment candidate whose release evidence is spread across AP, procurement, supplier, risk and treasury controls.",
    "domain.invoice.label": "Invoice, exception and payment readiness",
    "domain.invoice.outcome": "A payment queue where every exception carries its records and its owner.",
    "domain.invoice.principle.failure-vs-cause.body": "An exception signal records what failed, not why. The case keeps the two apart: the source failure is never overwritten, and competing causes stay visible until the evidence distinguishes them.",
    "domain.invoice.principle.failure-vs-cause.title": "The failed check is a fact; the cause is a hypothesis",
    "domain.invoice.principle.readiness-expires.body": "Every satisfied condition names its source and observation time. A changed invoice, payee, hold or screening result expires the decision and reopens only the dependent checks. Readiness is never payment: instruction, release and settlement stay with the system that owns them.",
    "domain.invoice.principle.readiness-expires.title": "A readiness decision carries its evidence and its expiry",
    "domain.invoice.principle.resolution-is-source-truth.body": "A sent message or a completed task is not resolution. A case closes when the authoritative system accepts the change and the controlling check reruns clean, or it stays truthfully blocked with a named owner and a reopening condition.",
    "domain.invoice.principle.resolution-is-source-truth.title": "Resolution means the source accepts and revalidates",
    "domain.invoice.proof-question": "Can one case show the causal evidence, the blockers, the owner and the next valid action, while the payment rail stays untouched?",
    "domain.invoice.role.ap-processor.alone": "Never approves their own material exception, or a payment they prepared, where separation applies.",
    "domain.invoice.role.ap-processor.commit": "Actions inside delegated AP policy.",
    "domain.invoice.role.ap-processor.hired": "An ERP worklist, email chases and a spreadsheet tracker.",
    "domain.invoice.role.ap-processor.mandate": "Resolve invoice processing work before the payment run.",
    "domain.invoice.role.ap-processor.measured": "Touchless rate, cycle time from exception to readiness, aged-exception count, reassignment rate.",
    "domain.invoice.role.ap-processor.propose": "Classification, coding, supplier query, hold or resolution.",
    "domain.invoice.role.ap-processor.question": "Why is this invoice blocked, and what single action clears it?",
    "domain.invoice.role.ap-processor.title": "AP processor",
    "domain.invoice.role.controller.alone": "Never moves funds or alters bank data where separation applies.",
    "domain.invoice.role.controller.commit": "Finance decisions within the delegated threshold.",
    "domain.invoice.role.controller.hired": "An approval workflow, a month-end control review and an email trail.",
    "domain.invoice.role.controller.mandate": "Own accounting control and the material invoice exception.",
    "domain.invoice.role.controller.measured": "False-clear and false-block counts, control findings, audit reconstruction completeness.",
    "domain.invoice.role.controller.propose": "Waiver, hold or accounting treatment.",
    "domain.invoice.role.controller.question": "Which approvals are still supported by current facts, and which have quietly expired?",
    "domain.invoice.role.controller.title": "Controller",
    "domain.invoice.role.payment-approver.alone": "Never approves a proposal they prepared where segregation applies.",
    "domain.invoice.role.payment-approver.commit": "Payment release through source controls and the required approvals.",
    "domain.invoice.role.payment-approver.hired": "The batch summary in the payment system, checked against separate screens before cut-off.",
    "domain.invoice.role.payment-approver.mandate": "Review and release payments through the system that owns execution.",
    "domain.invoice.role.payment-approver.measured": "On-time payment runs, blocked-candidate ageing, release-control defects.",
    "domain.invoice.role.payment-approver.propose": "Release or rejection of a payment proposal.",
    "domain.invoice.role.payment-approver.question": "What exactly am I authorising, and is every condition behind it still current?",
    "domain.invoice.role.payment-approver.title": "Payment approver",
    "domain.invoice.role.risk-owner.alone": "Never lets an inference stand in for the specialist result; the authoritative screening service decides.",
    "domain.invoice.role.risk-owner.commit": "Risk dispositions under policy.",
    "domain.invoice.role.risk-owner.hired": "A screening service, payment holds and an exception mailbox.",
    "domain.invoice.role.risk-owner.mandate": "Own the specialist screening result and its exceptions.",
    "domain.invoice.role.risk-owner.measured": "Screening coverage, stale-result use at release decisions, contested-match resolution time.",
    "domain.invoice.role.risk-owner.propose": "Review, hold or escalation.",
    "domain.invoice.role.risk-owner.question": "Is anything treating an absent or stale screening result as clearance?",
    "domain.invoice.role.risk-owner.title": "Fraud, sanctions or risk owner",
    "domain.invoice.role.treasury-manager.alone": "Never clears invoice validity or supplier identity alone.",
    "domain.invoice.role.treasury-manager.commit": "Treasury decisions within policy.",
    "domain.invoice.role.treasury-manager.hired": "The treasury system's payment cycle, a cash position workbook and calls to AP before the run.",
    "domain.invoice.role.treasury-manager.mandate": "Own liquidity, payment timing and the bank route.",
    "domain.invoice.role.treasury-manager.measured": "Cycle and cut-off adherence, funding cost, late or emergency payment volume.",
    "domain.invoice.role.treasury-manager.propose": "Schedule, funding or route instruction.",
    "domain.invoice.role.treasury-manager.question": "Which candidates in this cycle conflict with current cash and funding instructions?",
    "domain.invoice.role.treasury-manager.title": "Treasury or cash manager",
    "domain.invoice.short": "Invoice and payment",
    "domain.invoice.wedge": "Start with one high-volume exception reason with a stable source rule and a named owner, such as a receipt or price mismatch, or one bounded pre-release gate where the evidence spans more than one system. Payment execution stays out of scope.",
    "domain.lenses.catalogue-link": "Browse the segment-filtered catalogue",
    "domain.lenses.description": "Cross-domain lenses that pass through this system of work, each one following a single kind of spend with named owners and governed records.",
    "domain.lenses.eyebrow": "Cross-domain context",
    "domain.lenses.read-story": "Read the cross-domain lens",
    "domain.lenses.title": "Lenses on this domain",
    "domain.performance.buyer-question": "Will this change the decision and the follow-through, or just add another supplier screen?",
    "domain.performance.change.accepted-commitments.after": "An action stays proposed until the responsible buyer or supplier owner accepts it. Closed means a named reviewer accepted the closure evidence; weak evidence reopens the action instead of erasing its history.",
    "domain.performance.change.accepted-commitments.before": "Actions live in minutes, decks and email threads. Done means someone ticked a task, and the next review starts by reconstructing what happened.",
    "domain.performance.change.accepted-commitments.title": "From minuted actions to accepted commitments",
    "domain.performance.change.decision-package.after": "The review arrives as a decision package: every score opens into its method, sources and freshness, critical exceptions sit beside the average, and the proposed conclusion waits for the owner to accept, edit or reject it.",
    "domain.performance.change.decision-package.before": "An analyst reconciles extracts into a workbook, the relationship manager builds a deck, and the reviewer still hunts for the source behind every disputed number.",
    "domain.performance.change.decision-package.title": "From scorecard to decision package",
    "domain.performance.description": "Bring scorecards, actions, reviews and innovation opportunities into one accountable supplier rhythm.",
    "domain.performance.gap-1": "The question is fair: the work before a strategic supplier review is already heavy. Contract, operations, quality, finance, risk and sustainability teams extract data from their own systems. An analyst reconciles supplier identifiers, periods and formulas in a workbook. The relationship manager drafts a scorecard and a deck, then chases internal agreement.",
    "domain.performance.gap-2": "The meeting then spends senior attention on reconciliation instead of decisions. A favourable average can sit on top of a critical service failure. The supplier disputes a number and nobody can open the source behind it. Actions go into the minutes, but a minuted action is not an agreed one: the person expected to do the work may never have accepted it. By the next review, someone is reconstructing what happened to last quarter's actions from email.",
    "domain.performance.gap-3": "Supplier ideas travel a similar path with higher stakes. An idea arrives in a meeting or an inbox, gathers enthusiasm, and loses its business need, its sponsor or its confidentiality terms before anyone with authority decides anything. The whole domain rests on keeping five records apart: the score, the evidence behind it, the decision, the commitment and the idea. Wherever two of them collapse, follow-through dies.",
    "domain.performance.label": "Supplier performance, innovation and relationship",
    "domain.performance.outcome": "Reviews end in commitments someone accepted, and the next review starts from what happened to them.",
    "domain.performance.principle.critical-exception.body": "A favourable total can coexist with a failed hard obligation. Critical conditions stay visible beside the aggregate, with their own route to a decision. Missing evidence shows as unavailable: never as zero, and never as on target.",
    "domain.performance.principle.critical-exception.title": "An average never hides a critical failure",
    "domain.performance.principle.five-records.body": "A score is a result under a named method. Evidence is what supports or challenges it. A decision is an authorised conclusion. A commitment is work someone accepted, with an owner and closure evidence. An idea is a proposal and nothing more. Collapse any two and the review starts trading in false certainty.",
    "domain.performance.principle.five-records.title": "Five records, kept apart",
    "domain.performance.principle.interest-not-commitment.body": "A supplier idea earns attention, not authority. Receipt is not endorsement, a positive meeting is not funding, and a stage decision grants only the next bounded step. The supplier hears a truthful status either way.",
    "domain.performance.principle.interest-not-commitment.title": "Interest is not commitment",
    "domain.performance.proof-question": "Can one review finding be traced from its source evidence to an accepted commitment, its owner and the evidence that closed it?",
    "domain.performance.role.governance-owner.alone": "Never decides an individual contract, risk, funding or supplier action alone.",
    "domain.performance.role.governance-owner.commit": "Domain policy and delegated portfolio decisions.",
    "domain.performance.role.governance-owner.hired": "Governance templates, a scorecard module and a spreadsheet of review cadences.",
    "domain.performance.role.governance-owner.mandate": "Set the review policy: segmentation, cadence, measure methods and escalation across the supplier portfolio.",
    "domain.performance.role.governance-owner.measured": "Review coverage by supplier tier, score reproducibility, method disputes and escalations resolved under the declared policy.",
    "domain.performance.role.governance-owner.propose": "Segmentation, review templates, measure definitions and method changes.",
    "domain.performance.role.governance-owner.question": "Do our scores mean the same thing across suppliers, and would they survive an audit?",
    "domain.performance.role.governance-owner.title": "Supplier-governance owner",
    "domain.performance.role.innovation-sponsor.alone": "Never decides the procurement route, intellectual-property rights or production approval alone.",
    "domain.performance.role.innovation-sponsor.commit": "Stage funding and resource commitments within delegation.",
    "domain.performance.role.innovation-sponsor.hired": "A slide deck, a committee calendar and a spreadsheet of ideas.",
    "domain.performance.role.innovation-sponsor.mandate": "Own the business need behind a supplier idea and sponsor its evaluation through to a stage decision.",
    "domain.performance.role.innovation-sponsor.measured": "Opportunities with a named sponsor and next decision, stage decisions made inside their declared age, ideas answered rather than stranded.",
    "domain.performance.role.innovation-sponsor.propose": "Need statements, evaluation priorities, business-case assumptions and adoption paths.",
    "domain.performance.role.innovation-sponsor.question": "Which ideas deserve my time, and what exactly does the next stage authorise?",
    "domain.performance.role.innovation-sponsor.title": "Innovation sponsor",
    "domain.performance.role.metric-owner.alone": "Never turns a data correction into a relationship conclusion.",
    "domain.performance.role.metric-owner.commit": "Observation and method corrections within remit.",
    "domain.performance.role.metric-owner.hired": "The source system's own report and an extract sent to whoever asked for it.",
    "domain.performance.role.metric-owner.mandate": "Own the measure definitions and the observations behind them: source, formula, period, corrections and data-quality state.",
    "domain.performance.role.metric-owner.measured": "Evidence completeness at decision time, freshness inside the decision window, corrections applied prospectively rather than rewritten into history.",
    "domain.performance.role.metric-owner.propose": "Measure definitions, source corrections and restatement requests.",
    "domain.performance.role.metric-owner.question": "Which score used my data, and was it the method and period we agreed?",
    "domain.performance.role.metric-owner.title": "Metric or data owner",
    "domain.performance.role.relationship-manager.alone": "Never accepts risk, applies a contract remedy or commits funding beyond the delegated grant.",
    "domain.performance.role.relationship-manager.commit": "Relationship conclusions and buyer actions within delegation.",
    "domain.performance.role.relationship-manager.hired": "A reconciliation workbook, a slide deck, meeting minutes and email follow-up.",
    "domain.performance.role.relationship-manager.mandate": "Own the supplier review from scope to follow-through: the narrative, the meeting and what happens to the actions afterwards.",
    "domain.performance.role.relationship-manager.measured": "Pack readiness after period close, findings reaching an accepted disposition, verified closure of commitments, overdue and ownerless actions.",
    "domain.performance.role.relationship-manager.propose": "Review scope, agenda, draft narrative, proposed conclusions and buyer actions.",
    "domain.performance.role.relationship-manager.question": "Can I defend this review line by line, and show what happened to the actions we agreed?",
    "domain.performance.role.relationship-manager.title": "Supplier relationship manager",
    "domain.performance.role.supplier-account-lead.alone": "Never speaks for the buyer's decision, funding or award, and never accepts work beyond the delegation the supplier granted.",
    "domain.performance.role.supplier-account-lead.commit": "Supplier commitments within documented delegation.",
    "domain.performance.role.supplier-account-lead.hired": "Meeting notes, an action list in email and whatever the buyer's minutes recorded.",
    "domain.performance.role.supplier-account-lead.mandate": "Represent the supplier in the review: explain results, bring evidence, dispute facts and accept supplier commitments within documented delegation.",
    "domain.performance.role.supplier-account-lead.measured": "Commitments accepted rather than assumed, closure evidence accepted first time, disputes resolved on sources.",
    "domain.performance.role.supplier-account-lead.propose": "Explanations, supplier evidence, disputed facts, proposed actions and ideas.",
    "domain.performance.role.supplier-account-lead.question": "What did we actually agree to, and what evidence closes it?",
    "domain.performance.role.supplier-account-lead.title": "Supplier account lead",
    "domain.performance.short": "Supplier performance",
    "domain.performance.wedge": "Start with one strategic supplier review cycle: one with heavy preparation, disputed evidence or actions that keep losing their owners.",
    "domain.sourcing.buyer-question": "We already run our events in a sourcing suite. Why add anything beside it?",
    "domain.sourcing.change.assembled-award.after": "The recommendation reaches the award authority as one package: scores, responses, risk inputs, dissent and conditions, each opening to its source.",
    "domain.sourcing.change.assembled-award.before": "The suite closes the event; analysts rebuild the decision in workbooks, inboxes and a pre-award meeting.",
    "domain.sourcing.change.assembled-award.title": "The award review arrives assembled",
    "domain.sourcing.change.authority-line.after": "Each proposed move carries its limit, its approver and its expiry. A move outside authority is blocked and routed for a bounded decision.",
    "domain.sourcing.change.authority-line.before": "What a negotiator may offer lives in a delegation memo and in memory, and a persuasive recommendation can read like an authorised position.",
    "domain.sourcing.change.authority-line.title": "Advice stops at the authority line",
    "domain.sourcing.description": "Shape events, analyse responses and prepare negotiation positions with named decision rights at every award step.",
    "domain.sourcing.gap-1": "The question is fair: the suite earns its place. It publishes the event, collects the bids, scores the responses and records the award. What it does not hold is the decision. The response evidence, the risk inputs, the commercial model, the evaluator comments and the approval history sit in different places, and before every consequential award someone rebuilds them into a pack by hand.",
    "domain.sourcing.gap-2": "The failure shows at the award. A recommendation is returned because a score has nothing behind it. Risk evidence goes stale after the shortlist and nobody recomputes the affected scenario. Disagreement between evaluators is averaged away instead of put in front of the decision owner. So the team books a meeting, walks the pack line by line, and the award waits on the reconstruction rather than on the decision.",
    "domain.sourcing.gap-3": "Negotiation repeats the pattern round by round. Before each session the team reassembles the contract baseline, the spend history, the performance record and the concession plan from workbooks and notes. What the negotiator may offer without escalation lives in a delegation memo and in memory. When the supplier moves, nobody can say quickly which positions are still authorised, and an agreed point can lose its evidence on the way into the contract.",
    "domain.sourcing.label": "Sourcing and negotiation",
    "domain.sourcing.outcome": "Sourcing decisions you can defend line by line: every score opens the response behind it.",
    "domain.sourcing.principle.dissent-survives.body": "Disagreement between evaluators is part of the decision, not noise. Missing scores, recusals and conflicting comments stay visible in the award package instead of being averaged away.",
    "domain.sourcing.principle.dissent-survives.title": "Dissent survives to the decision",
    "domain.sourcing.principle.original-response.body": "Comparison works on a normalised view while the supplier's original response stays beside it. Every converted figure reproduces from the original and a dated rule, so a challenged ranking is answered from the record.",
    "domain.sourcing.principle.original-response.title": "The original response is never overwritten",
    "domain.sourcing.principle.recommendation-not-commitment.body": "A proposed award and an authorised award are different states with different owners. A drafted negotiating move is advice until the person who holds the delegation uses it. Nothing commits by drift.",
    "domain.sourcing.principle.recommendation-not-commitment.title": "Recommendation is not commitment",
    "domain.sourcing.proof-question": "Can the award authority trace every criterion, score and recommendation to the response and rule behind it, without a pack built by hand?",
    "domain.sourcing.role.award-authority.alone": "Never clears a risk or legal block alone; the reviewer who raised it resolves it.",
    "domain.sourcing.role.award-authority.commit": "Approval, rejection or return of the award, with reason.",
    "domain.sourcing.role.award-authority.hired": "A recommendation deck, a pack assembled for the meeting and questions asked in the room.",
    "domain.sourcing.role.award-authority.mandate": "Decide whether and how to commit the award, with the reason recorded.",
    "domain.sourcing.role.award-authority.measured": "Approval returns, challenged awards, time from recommendation to decision.",
    "domain.sourcing.role.award-authority.propose": "Rework requests and alternative scenarios.",
    "domain.sourcing.role.award-authority.question": "Can I defend this recommendation line by line, or do I send it back?",
    "domain.sourcing.role.award-authority.title": "Award authority",
    "domain.sourcing.role.evaluator.alone": "Never alters another evaluator's record and never sees sealed commercial responses outside their assignment.",
    "domain.sourcing.role.evaluator.commit": "Their own evaluation, once submitted.",
    "domain.sourcing.role.evaluator.hired": "An event export, a scoring spreadsheet and supporting material forwarded by email.",
    "domain.sourcing.role.evaluator.mandate": "Judge assigned criteria independently and stand behind every submitted score.",
    "domain.sourcing.role.evaluator.measured": "Scoring completed by deadline, scores submitted with comment and evidence, challenged scores.",
    "domain.sourcing.role.evaluator.propose": "Scores, comments and evidence gaps on assigned criteria.",
    "domain.sourcing.role.evaluator.question": "Where is the evidence for the criterion I am scoring?",
    "domain.sourcing.role.evaluator.title": "Evaluator",
    "domain.sourcing.role.negotiation-lead.alone": "Never accepts a point outside approved bounds alone; a changed bound goes back to its owner before the next round.",
    "domain.sourcing.role.negotiation-lead.commit": "Offers and concessions inside documented delegation.",
    "domain.sourcing.role.negotiation-lead.hired": "A briefing pack built in workbooks and documents, a delegation memo and the previous round's meeting notes.",
    "domain.sourcing.role.negotiation-lead.mandate": "Own the supplier conversation and commit only inside documented delegation.",
    "domain.sourcing.role.negotiation-lead.measured": "Preparation effort per round, escalations caused by unclear authority, agreed points that survive unchanged into the contract.",
    "domain.sourcing.role.negotiation-lead.propose": "Strategy, agenda, question sequence, packages and conditional exchanges.",
    "domain.sourcing.role.negotiation-lead.question": "What may I offer in this round without going back for approval?",
    "domain.sourcing.role.negotiation-lead.title": "Negotiation lead",
    "domain.sourcing.role.sourcing-lead.alone": "Never turns a recommendation into an award alone; that decision sits with the award authority.",
    "domain.sourcing.role.sourcing-lead.commit": "Publication and award only where policy delegates them.",
    "domain.sourcing.role.sourcing-lead.hired": "The sourcing suite for the event, plus comparison workbooks, evaluator emails and a pack-building meeting before the award.",
    "domain.sourcing.role.sourcing-lead.mandate": "Take an approved need through the event to a commercial recommendation the award authority can act on.",
    "domain.sourcing.role.sourcing-lead.measured": "Cycle time from closed responses to approved award, approval returns, effort spent rebuilding the decision.",
    "domain.sourcing.role.sourcing-lead.propose": "Supplier set, event rules, shortlist, scenarios and the award recommendation.",
    "domain.sourcing.role.sourcing-lead.question": "What is still missing before this recommendation survives review?",
    "domain.sourcing.role.sourcing-lead.title": "Sourcing lead",
    "domain.sourcing.short": "Sourcing",
    "domain.sourcing.wedge": "Start with one category's path from closed responses to an approved award, where preparation and evaluation carry a measurable burden today. The suite keeps the event and the bid record; nothing migrates.",
    "domain.strategy.buyer-question": "Can one material category or policy decision move into action without weakening the controls and systems we already trust?",
    "domain.strategy.change.answer-or-escalation.after": "The question meets the current facts. The answer cites the controlling version and clause, asks for a missing fact when one changes the rule, and routes an exception to its named owner.",
    "domain.strategy.change.answer-or-escalation.before": "A requester searches the policy portal, reads the document and decides alone whether the rule applies to their situation.",
    "domain.strategy.change.answer-or-escalation.title": "From search results to owned answers",
    "domain.strategy.change.decision-queue.after": "A material signal arrives as a case: the records behind it, the assumptions and missing facts, a proposed owner and the next action. The reviewer accepts, rejects with a reason, or sends it back for more evidence.",
    "domain.strategy.change.decision-queue.before": "An analyst opens the dashboard, finds something interesting, investigates the data, works out who should own it and builds the case by hand in a workbook.",
    "domain.strategy.change.decision-queue.title": "From dashboards to decision queues",
    "domain.strategy.description": "Turn spend and market signals into category decisions, policy answers and an executable opportunity backlog.",
    "domain.strategy.gap-1": "The spend data usually exists. A warehouse or spend platform refreshes it, dashboards show concentration and contract coverage, and alerts fire. Everything after that is manual. An analyst exports the evidence, the category manager adds market, demand and contract context in workbooks and presentations, finance challenges the baseline, and a governance forum decides.",
    "domain.strategy.gap-2": "The chain between signal and action is where decisions lose their footing. Approved priorities are re-entered into project trackers and sourcing tools, and the link back to the original evidence weakens. A stale market source survives into the decision. Two teams raise the same opportunity and the value is counted twice. A signal is approved with no owner who can act, and the backlog fills with items that cannot move.",
    "domain.strategy.gap-3": "Policy questions follow the same pattern. A requester searches the intranet, reads a document and decides alone whether the rule applies, or asks whoever answered last time. The answer, its source and any exception decision sit in separate systems. When the policy changes, no one can say which earlier answers are now wrong or which open requests still rely on them.",
    "domain.strategy.label": "Strategy, policy, category and spend",
    "domain.strategy.outcome": "A live category agenda where every opportunity has an owner and a source.",
    "domain.strategy.principle.aggregate-is-a-door.body": "A category total or a priority ranking opens into the transactions, the classification confidence and the freshness behind it. A single score never hides the dimensions that produced it.",
    "domain.strategy.principle.aggregate-is-a-door.title": "Every aggregate is a door",
    "domain.strategy.principle.approved-not-delivered.body": "An approved priority stays with its owner until the receiving team accepts the scope and the evidence. A rejected handoff reopens the case instead of leaving it stranded as done.",
    "domain.strategy.principle.approved-not-delivered.title": "Approved is not delivered",
    "domain.strategy.principle.proposal-not-commitment.body": "A detected opportunity, a suggested classification and a drafted policy answer stay visibly proposed until the accountable owner commits. Guidance is not approval, and an opportunity is not a saving.",
    "domain.strategy.principle.proposal-not-commitment.title": "Proposal is not commitment",
    "domain.strategy.proof-question": "Can a reviewer open one opportunity or one policy answer and trace it to its sources, its assumptions, its owner and its next action?",
    "domain.strategy.role.category-manager.alone": "Never claims validated realisation or overrides independent control owners alone.",
    "domain.strategy.role.category-manager.commit": "Category decisions inside formally delegated category authority.",
    "domain.strategy.role.category-manager.hired": "A spend dashboard, a strategy workbook, a presentation deck and a governance meeting.",
    "domain.strategy.role.category-manager.mandate": "Own the category strategy and every opportunity case raised against it.",
    "domain.strategy.role.category-manager.measured": "Evidence completeness of proposed cases, time from signal to accepted owner, downstream handoff acceptance.",
    "domain.strategy.role.category-manager.propose": "Opportunity cases, strategy options and initiative owners.",
    "domain.strategy.role.category-manager.question": "Which signals deserve category action this quarter, and who has accepted the work?",
    "domain.strategy.role.category-manager.title": "Category manager",
    "domain.strategy.role.data-steward.alone": "Never decides commercial priority from data quality alone.",
    "domain.strategy.role.data-steward.commit": "Approved data corrections and taxonomy versions.",
    "domain.strategy.role.data-steward.hired": "Mapping spreadsheets, a steward queue in the analytics tool and change requests by email.",
    "domain.strategy.role.data-steward.mandate": "Own the taxonomy, the supplier and spend mappings and the data-quality rules the analysis stands on.",
    "domain.strategy.role.data-steward.measured": "Classification coverage and sampled quality, confirmed duplicate mappings, reviewed match quality.",
    "domain.strategy.role.data-steward.propose": "Match, mapping and data-quality rule changes.",
    "domain.strategy.role.data-steward.question": "Which mappings and classifications wait on me, and which decisions do they move?",
    "domain.strategy.role.data-steward.title": "Data steward",
    "domain.strategy.role.policy-owner.alone": "Never applies an interpretation outside their mandate or decides matters reserved to legal, finance or risk.",
    "domain.strategy.role.policy-owner.commit": "Approved interpretations, exception decisions and policy changes under governance.",
    "domain.strategy.role.policy-owner.hired": "A policy portal, an inbox of questions and a service desk queue.",
    "domain.strategy.role.policy-owner.mandate": "Own what each policy means, when it applies and how it changes.",
    "domain.strategy.role.policy-owner.measured": "Citation completeness of delivered answers, escalation quality, corrections completed after a policy change.",
    "domain.strategy.role.policy-owner.propose": "Interpretations, clarifications and policy revisions.",
    "domain.strategy.role.policy-owner.question": "Can guidance scale beyond my inbox without generated text becoming authority?",
    "domain.strategy.role.policy-owner.title": "Procurement policy owner",
    "domain.strategy.role.procurement-analyst.alone": "Never approves their own material data exceptions where independent review applies.",
    "domain.strategy.role.procurement-analyst.commit": "No commercial commitment by default; corrections proceed inside approved data rules.",
    "domain.strategy.role.procurement-analyst.hired": "Warehouse exports, spreadsheet reconciliations and email threads with the category team.",
    "domain.strategy.role.procurement-analyst.mandate": "Identify potential opportunities from the spend, curate the spend evidence and test every opportunity signal before it reaches a decision.",
    "domain.strategy.role.procurement-analyst.measured": "Classification coverage and sampled quality, reconciliation differences, duplicate suppression quality.",
    "domain.strategy.role.procurement-analyst.propose": "Classification corrections, opportunity hypotheses and flagged evidence gaps.",
    "domain.strategy.role.procurement-analyst.question": "Is this signal material, and can the population behind it be trusted?",
    "domain.strategy.role.procurement-analyst.title": "Procurement analyst",
    "domain.strategy.short": "Strategy and spend",
    "domain.strategy.wedge": "Start with one category and one opportunity type, or one bounded policy family with a named owner. Prove that a single signal can reach an owned backlog and an accepted downstream action.",
    "domain.tprm.buyer-question": "Can we take the manual case-building out of supplier decisions without weakening risk ownership or replacing the systems we trust?",
    "domain.tprm.change.assembled-case.after": "The case opens with what the organisation already holds, the supplier is asked only for what the decision still needs, and only material exceptions reach a named owner.",
    "domain.tprm.change.assembled-case.before": "Every supplier receives the full questionnaire pack, teams chase documents by email, and reviewers work through the same approval steps regardless of risk.",
    "domain.tprm.change.assembled-case.title": "From forms and chasing to an assembled case",
    "domain.tprm.change.managed-exceptions.after": "A signal is matched to the party and engagement, tested for materiality, and arrives as a case carrying the supporting evidence, the prior decision it affects and a named decision owner.",
    "domain.tprm.change.managed-exceptions.before": "Monitoring produces scores, news alerts and colour ratings, and someone must work out whether each event is real, material and theirs to act on.",
    "domain.tprm.change.managed-exceptions.title": "From risk alerts to managed exceptions",
    "domain.tprm.description": "Coordinate onboarding, evidence collection, risk review, remediation and periodic reassessment around one supplier record.",
    "domain.tprm.gap-1": "Today a supplier starts as a name in a request. Someone searches the master for the party, the requester or the supplier keys in profile, tax and bank data, and each risk function issues its questionnaire from its own tool. Reviewers read responses, certificates and external signals, then carry findings through email, meetings and workflow tasks.",
    "domain.tprm.gap-2": "The decision and the action live in different systems. A named person accepts the risk, but the supplier is created in the ERP, access is granted elsewhere and mitigations are tracked in a third place. A master write can fail after approval and leave a case that looks active. A certification expires or an alert names a supplier, and nobody can say which engagement it touches or which prior decision it reopens.",
    "domain.tprm.gap-3": "The burden lands twice. Suppliers repeat information they have already provided, and reviewers rebuild the context by hand for every case. A questionnaire can be complete and still answer no question, because completeness is not a decision. The missing piece is not more risk data. It is the work between a signal and a proportionate decision with a named owner.",
    "domain.tprm.label": "Supplier lifecycle and third-party risk",
    "domain.tprm.outcome": "Every risk decision has an owner, a case file and a proportionate response.",
    "domain.tprm.principle.engagement-not-record.body": "A supplier record is not a risk decision. The same party can serve two engagements with different data, access and criticality, so every decision names the engagement it covers and the evidence behind it.",
    "domain.tprm.principle.engagement-not-record.title": "One party, many relationships",
    "domain.tprm.principle.proportionate-review.body": "Policy sets the evidence plan from the engagement's purpose, data, access and criticality. Low-risk suppliers take the short route, and the rule behind every extra requirement stays visible.",
    "domain.tprm.principle.proportionate-review.title": "Review sized to the relationship",
    "domain.tprm.principle.proposal-not-acceptance.body": "Workblocks assemble the case, draft findings and show where evidence conflicts. Residual risk is accepted only by the named owner within a delegated threshold, with conditions and expiry on the record.",
    "domain.tprm.principle.proposal-not-acceptance.title": "Assessment is a proposal",
    "domain.tprm.proof-question": "Does the case reuse facts already verified, show which evidence is current and which conflicts, and reserve residual-risk acceptance for the named owner?",
    "domain.tprm.role.accountable-risk-owner.alone": "Never carries authority past its scope, threshold or expiry, and never accepts a specialist domain's risk without its reviewer's finding.",
    "domain.tprm.role.accountable-risk-owner.commit": "Residual-risk acceptance within their delegated domain, threshold and duration.",
    "domain.tprm.role.accountable-risk-owner.hired": "A committee pack built from questionnaire scores, attachments and whatever the analyst could assemble before the meeting.",
    "domain.tprm.role.accountable-risk-owner.mandate": "Decide whether the risk that remains after controls is accepted, mitigated, transferred or declined.",
    "domain.tprm.role.accountable-risk-owner.measured": "Decisions reconstructable from evidence and authority, exceptions open past expiry, material events missed after acceptance.",
    "domain.tprm.role.accountable-risk-owner.propose": "Conditions, mitigations, restrictions and reopen triggers for the decision in front of them.",
    "domain.tprm.role.accountable-risk-owner.question": "What exactly am I accepting, on what evidence, and until when?",
    "domain.tprm.role.accountable-risk-owner.title": "Accountable risk owner",
    "domain.tprm.role.onboarding-coordinator.alone": "Never accepts residual risk or approves a protected bank or tax change alone.",
    "domain.tprm.role.onboarding-coordinator.commit": "Routing, return and operational closure decisions under onboarding policy.",
    "domain.tprm.role.onboarding-coordinator.hired": "A suite worklist, risk questionnaires in separate tools, and email chases with a spreadsheet tracker.",
    "domain.tprm.role.onboarding-coordinator.mandate": "Move each supplier case from proposal to a confirmed readiness state, coordinating evidence and handoffs across procurement, risk, finance and the ERP.",
    "domain.tprm.role.onboarding-coordinator.measured": "Cycle time from proposal to confirmed activation, first-pass case completeness, manual touches per case, aged case count.",
    "domain.tprm.role.onboarding-coordinator.propose": "Case route, evidence requests, returns to the requester and duplicate dispositions for steward review.",
    "domain.tprm.role.onboarding-coordinator.question": "Which cases are stuck, what does each one wait on, and who owns the next decision?",
    "domain.tprm.role.onboarding-coordinator.title": "Onboarding coordinator",
    "domain.tprm.role.supplier-contact.alone": "Never verifies the supplier's own claims; internal checks, approvals and exceptions stay across the boundary.",
    "domain.tprm.role.supplier-contact.commit": "The accuracy of what the supplier submits, and nothing on the buyer's side of the decision.",
    "domain.tprm.role.supplier-contact.hired": "A portal login per customer, the same certificates uploaded again, and a mailbox where questions about status go unanswered.",
    "domain.tprm.role.supplier-contact.mandate": "Answer for the supplier: provide the information, documents and corrections the relationship depends on.",
    "domain.tprm.role.supplier-contact.measured": "Time from first request to complete submission, repeated requests for the same information, support contacts per case.",
    "domain.tprm.role.supplier-contact.propose": "Submissions, corrections and evidence already held by networks the supplier belongs to.",
    "domain.tprm.role.supplier-contact.question": "What do you still need from us, why do you need it, and when can we start?",
    "domain.tprm.role.supplier-contact.title": "Supplier contact",
    "domain.tprm.role.supplier-master-steward.alone": "Never accepts residual risk, and never treats a confident match proposal as a decision.",
    "domain.tprm.role.supplier-master-steward.commit": "Supplier creation and profile changes under master-data policy.",
    "domain.tprm.role.supplier-master-steward.hired": "The ERP supplier master's search screens and a queue of creation requests.",
    "domain.tprm.role.supplier-master-steward.mandate": "Protect supplier identity, sites, tax and bank data so that every transaction lands on the right record.",
    "domain.tprm.role.supplier-master-steward.measured": "Duplicate rate, false matches and missed duplicates, correction effort after activation.",
    "domain.tprm.role.supplier-master-steward.propose": "Match candidates, link and merge options, and corrections to party and site data.",
    "domain.tprm.role.supplier-master-steward.question": "Is this party already in the master, and which record is the true one?",
    "domain.tprm.role.supplier-master-steward.title": "Supplier-master steward",
    "domain.tprm.role.tprm-programme-owner.alone": "Never decides an individual relationship's residual risk; that stays with the accountable owner for the domain.",
    "domain.tprm.role.tprm-programme-owner.commit": "The method itself and programme exceptions within delegation.",
    "domain.tprm.role.tprm-programme-owner.hired": "A configured questionnaire library, a tiering spreadsheet and a policy document that reviewers interpret case by case.",
    "domain.tprm.role.tprm-programme-owner.mandate": "Own the review method: tiering, evidence rules, decision rights and review cadence across the third-party population.",
    "domain.tprm.role.tprm-programme-owner.measured": "Tier and route corrections, required checks completed before activation, evidence freshness coverage across the population.",
    "domain.tprm.role.tprm-programme-owner.propose": "Method changes, tier thresholds, evidence plans and programme-level exceptions.",
    "domain.tprm.role.tprm-programme-owner.question": "Is the review proportionate to the actual relationship, and does the method still fit the rules we are held to?",
    "domain.tprm.role.tprm-programme-owner.title": "TPRM programme owner",
    "domain.tprm.short": "Suppliers and risk",
    "domain.tprm.wedge": "Start with one supplier or risk tier where the evidence rules are stable and the exceptions repeat, and prove one measured handoff into the supplier master or GRC system you already run.",
    "domain.value.buyer-question": "Can we defend the savings number, and act on it, without replacing the systems that calculate, plan and execute it today?",
    "domain.value.change.causal-case.after": "A material variance becomes one case that tests the normal explanations first, names the accountable owner, and stays open until the owning system accepts the action and the result is remeasured.",
    "domain.value.change.causal-case.before": "A dashboard flags a shortfall. Teams debate timing, volume, currency and adoption by email, and the action lands in another system with no link back to the case.",
    "domain.value.change.causal-case.title": "From variance alerts to a causal case",
    "domain.value.change.worked-case.after": "Every number opens the initiative behind it: source records, approved method, owner and current state. A challenged claim is answered from the case, not reassembled for the meeting.",
    "domain.value.change.worked-case.before": "A report shows pipeline, forecast and realised value. When finance challenges a number, an analyst rebuilds the calculation in a workbook and the meeting decides.",
    "domain.value.change.worked-case.title": "From the savings report to the worked case",
    "domain.value.description": "Connect opportunities, initiatives, forecasts, validation and leakage to the records that explain the number.",
    "domain.value.gap-1": "Most organisations already own the systems: spend analytics to find opportunities, a tracker or specialist product for initiatives, a planning platform for the forecast, reports that show pipeline and realised value. The work between them is still manual. Analysts reconcile actuals in workbooks, definitions are agreed case by case, and the number that reaches the review meeting was assembled by hand.",
    "domain.value.gap-2": "An opportunity, a pipeline estimate, a forecast, a validated result and a leakage claim are different facts. Each needs different evidence, and a different person holds the authority to accept it. In most portfolios they travel as one number, so finance challenges the total, the meeting relitigates the method, and the answer is rebuilt in a workbook each time. Approving how a benefit will be measured is not approving the benefit, and a validated result is still not a ledger entry.",
    "domain.value.gap-3": "When a material initiative moves off its value path, the cause lives across systems: the award, the contract terms, the orders and invoices, supplier performance, the finance actuals. Teams debate whether the gap is timing, volume, currency or genuine loss. The recovery action is raised by email in someone else's system, and the case closes when the task closes, whether or not the value ever returned.",
    "domain.value.label": "Value realisation and savings",
    "domain.value.outcome": "A savings number finance can trace to the records that produced it.",
    "domain.value.principle.definition-before-number.body": "Every figure carries an owner, a source, an approved method and a period, and opens to the records that produced it. Approving the method is a separate decision from accepting the result.",
    "domain.value.principle.definition-before-number.title": "Definition before number",
    "domain.value.principle.separate-states.body": "Opportunity, pipeline, forecast, validated realisation and leakage are different facts with different owners. A claim advances only when the evidence and the authority for the next state are present.",
    "domain.value.principle.separate-states.title": "Every value state stands on its own evidence",
    "domain.value.principle.variance-into-action.body": "A material shortfall creates a case with a tested cause, an accountable owner and a next action in the system that owns the record. It closes on an accepted action and a remeasured result, not on an assigned task.",
    "domain.value.principle.variance-into-action.title": "Variance becomes owned work",
    "domain.value.proof-question": "Can a reviewer tell why a number is pipeline, forecast or validated realisation, and open the initiatives and source records behind it?",
    "domain.value.role.budget-owner.alone": "Never validates procurement attribution without the agreed method.",
    "domain.value.role.budget-owner.commit": "Business acceptance, resource and demand decisions inside their mandate.",
    "domain.value.role.budget-owner.hired": "Budget reviews, a planning line and questions relayed through the finance business partner.",
    "domain.value.role.budget-owner.mandate": "Own the demand, adoption and business benefit that turn a negotiated change into an actual one.",
    "domain.value.role.budget-owner.measured": "Adoption of the agreed route and terms, budget outturn, benefit delivered in the business unit.",
    "domain.value.role.budget-owner.propose": "Forecast changes, adoption actions and explanations for variance.",
    "domain.value.role.budget-owner.question": "What does this initiative ask of my teams, and what happens to my budget when it lands?",
    "domain.value.role.budget-owner.title": "Business budget owner",
    "domain.value.role.category-manager.alone": "Never reports a negotiated award delta as realised value before actuals meet the approved method.",
    "domain.value.role.category-manager.commit": "Category actions within commercial authority.",
    "domain.value.role.category-manager.hired": "The award record, a category workbook and chasing buying and finance colleagues by email.",
    "domain.value.role.category-manager.mandate": "Turn category evidence into delivered commercial value through sourcing, contract and demand action.",
    "domain.value.role.category-manager.measured": "Delivered initiative value against target, adoption of negotiated terms, forecast accuracy for the category.",
    "domain.value.role.category-manager.propose": "New initiatives, baseline evidence, forecasts and recovery actions.",
    "domain.value.role.category-manager.question": "Which of my negotiated savings are appearing in actual orders and invoices?",
    "domain.value.role.category-manager.title": "Category manager",
    "domain.value.role.finance-delegate.alone": "Never asserts operational causality without evidence from the owning source system.",
    "domain.value.role.finance-delegate.commit": "Method approval and result validation within finance policy.",
    "domain.value.role.finance-delegate.hired": "A validation workflow in the savings tool where one exists, otherwise an inbox of calculations and a workbook of adjustments.",
    "domain.value.role.finance-delegate.mandate": "Protect the credibility of the reported number: accept the method before delivery and the result after the period closes.",
    "domain.value.role.finance-delegate.measured": "Rejected and adjusted claims, restatement completeness, results calculated against missing or expired methods, reconstruction of past decisions.",
    "domain.value.role.finance-delegate.propose": "Validation rules, adjustments and challenges to baseline, attribution or value type.",
    "domain.value.role.finance-delegate.question": "Can I reproduce this number from source records and the approved method before I accept it?",
    "domain.value.role.finance-delegate.title": "Finance delegate",
    "domain.value.role.value-lead.alone": "Never validates a material result alone where independent finance review applies.",
    "domain.value.role.value-lead.commit": "Initiative state changes within delegated portfolio policy.",
    "domain.value.role.value-lead.hired": "A savings tracker, planning lines, workbook reconciliations and a monthly portfolio review.",
    "domain.value.role.value-lead.mandate": "Keep the initiative portfolio credible: every claim has an owner, an approved method and a state its evidence supports.",
    "domain.value.role.value-lead.measured": "Method completeness before delivery, opportunity disposition coverage, duplicate and overlap defects, cycle time from period close to a review-ready result.",
    "domain.value.role.value-lead.propose": "Opportunity disposition, forecast updates, method proposals and remediation options.",
    "domain.value.role.value-lead.question": "Which initiatives are off their value path, and what can still be recovered?",
    "domain.value.role.value-lead.title": "Value realisation lead",
    "domain.value.short": "Value and savings",
    "domain.value.wedge": "Start with one initiative class where finance has already agreed the baseline and the recognition rule, and the actuals arrive from stable sources. Keep the planning, analytics and finance systems that hold authority today.",
    "door.section.build.body": "The framework model, the delivery motion and the governed Workblock material a build starts from.",
    "door.section.build.title": "Understand the framework and build",
    "door.section.client-engagement.body": "Frame the client problem, choose the differentiators that answer it, and open the stories, mappings and working material that carry the case.",
    "door.section.client-engagement.title": "Make the client case",
    "door.section.reference.body": "Every record type, role, job, Work moment, component and release fact, searchable and drillable.",
    "door.section.reference.title": "Inspect the complete model",
    "editorial-story.chapter.authority": "Authority",
    "editorial-story.chapter.flows": "Execution flows",
    "editorial-story.chapter.handoff": "Handoff",
    "editorial-story.chapter.owner": "Owner",
    "editorial-story.chapter.records": "Records",
    "editorial-story.compounding-intelligence.brief.open": "Download the compounding intelligence framework brief",
    "editorial-story.compounding-intelligence.brief.pdf": "Download the compounding intelligence brief as PDF",
    "editorial-story.compounding-intelligence.chapter.bank-the-value.authority": "The value lead owns the attribution record; adjustments to baselines and attributions stay proposals until a named person commits them.",
    "editorial-story.compounding-intelligence.chapter.bank-the-value.body": "The chain ends in the value portfolio. Realised value is reconciled against its baseline and attributed to the decisions that produced it, with the compounded records still attached, so what reached the bank is a traceable figure rather than a claim. Each record set added along the way made this reconciliation sharper, and the next addition starts from what this cycle proved.",
    "editorial-story.compounding-intelligence.chapter.bank-the-value.handoff": "A reconciled value record closes the loop and re-enters the register, so the next contract read starts sharper than the last.",
    "editorial-story.compounding-intelligence.chapter.bank-the-value.title": "Track the value to the bank",
    "editorial-story.compounding-intelligence.chapter.prepare-the-mandate.authority": "Only a named sourcing lead commits the mandate, inside the declared authority envelope; the preparation is machine work, the decision is not.",
    "editorial-story.compounding-intelligence.chapter.prepare-the-mandate.body": "Consolidated demand completes the register: terms, actuals, coverage and demand now sit in one record set. The buy-timing proposal arrives already prepared, the volume band, the buy window and the price ceiling, each number open to its records, so the mandate reaches a named owner as a decision to take rather than an analysis to assemble.",
    "editorial-story.compounding-intelligence.chapter.prepare-the-mandate.handoff": "An authorised mandate carries its compounded records forward, so realised value can be measured against what was known when the decision was taken.",
    "editorial-story.compounding-intelligence.chapter.prepare-the-mandate.title": "Add demand and prepare the mandate",
    "editorial-story.compounding-intelligence.chapter.price-the-leakage.authority": "The controller owns the priced findings; recovering an amount stays a human commitment, and every figure keeps its record trail.",
    "editorial-story.compounding-intelligence.chapter.price-the-leakage.body": "When ERP actuals join the register, every finding gains a price. Purchase orders and invoices are matched against the entitlements the contracts promised, so off-contract variance stops being an estimate and becomes a priced finding, invoice by invoice, each amount open to the records behind it.",
    "editorial-story.compounding-intelligence.chapter.price-the-leakage.handoff": "Priced leakage tells the next chapter which contracts deserve a timed decision rather than a quiet lapse.",
    "editorial-story.compounding-intelligence.chapter.price-the-leakage.title": "Add ERP actuals and price the leakage",
    "editorial-story.compounding-intelligence.chapter.read-the-terms.authority": "The value lead owns the leakage findings; the agents that read terms and detect drift only propose, and no finding changes a contract.",
    "editorial-story.compounding-intelligence.chapter.read-the-terms.body": "The register starts with one record set: executed contract terms. Entitlements, price schedules, indexation clauses and rebate conditions become queryable records, and the leakage monitor finds where practice has drifted from what was signed. With contracts alone the finding names the clause and the counterparty; what it cannot yet do is price the drift.",
    "editorial-story.compounding-intelligence.chapter.read-the-terms.handoff": "A register of leakage findings, each anchored to its clause, waits for the actuals that will price it.",
    "editorial-story.compounding-intelligence.chapter.read-the-terms.title": "Read the terms, find the leakage",
    "editorial-story.compounding-intelligence.chapter.time-the-renewal.authority": "The contract manager owns the window decision; agents detect windows and analyse options, and a named person commits the choice.",
    "editorial-story.compounding-intelligence.chapter.time-the-renewal.body": "Coverage positions join the same register, and renewal stops being a date on a list. When a renewal or change window opens, the option analysis reads what the contract still covers, what the coverage position needs and what the priced leakage says the current terms are worth, so renew, renegotiate or exit is chosen in time rather than discovered after the lapse.",
    "editorial-story.compounding-intelligence.chapter.time-the-renewal.handoff": "A timed renewal decision hands the next chapter a contract landscape with no silent lapses in it.",
    "editorial-story.compounding-intelligence.chapter.time-the-renewal.title": "Add coverage and time the renewal",
    "editorial-story.compounding-intelligence.journey.description": "Five chapters, each adding one record set to the same register, with a named owner, an explicit authority boundary and a handoff the next owner can hold it to.",
    "editorial-story.compounding-intelligence.kicker": "Compounding intelligence",
    "editorial-story.compounding-intelligence.map.description": "Each capability the compounding chain relies on maps onto an existing business module of the foundation. Nothing new is invented for the lens.",
    "editorial-story.compounding-intelligence.map.open": "Open the source-to-pay capability master map",
    "editorial-story.compounding-intelligence.moment.description": "The buy-timing mandate is where the compounded register turns into a bounded decision. The agent's prepared proposal and the sourcing lead's authorisation stay visibly distinct.",
    "editorial-story.compounding-intelligence.outcome": "One compounding record set: contract terms alone surface leakage findings, joined ERP actuals price each finding invoice by invoice, coverage positions turn renewal windows into timed decisions rather than lapses, consolidated demand lets the buy-timing mandate arrive prepared for a named owner, and realised value is reconciled and tracked to the bank with every step still open to its records.",
    "editorial-story.compounding-intelligence.summary": "How one direct-material register grows sharper with each record set that joins it: contract terms alone find leakage, ERP actuals price it, coverage chooses renewal timing, consolidated demand prepares the buy mandate for a named owner, and realised value is tracked to the bank. Told on illustrative records, not client results.",
    "editorial-story.compounding-intelligence.system-boundary": "Every system keeps its job while the register compounds. ERP and finance systems remain the system of record for orders, invoices and actuals, the contract repository keeps the executed terms, and planning systems keep the demand plan. The foundation reads governed projections through declared channels, joins them in its own records, never edits source data in place, and returns proposals through the one authorised path each recipe pins.",
    "editorial-story.compounding-intelligence.title": "When each addition makes the rest sharper",
    "editorial-story.direct-material-economics.brief.open": "Download the direct-material economics framework brief",
    "editorial-story.direct-material-economics.brief.pdf": "Download the direct-material economics brief as PDF",
    "editorial-story.direct-material-economics.chapter.compare-landed-cost-and-carbon.authority": "The evaluator owns the comparison and a named award authority commits the award; qualification holds are resolved by the supplier master steward, never overridden by a price.",
    "editorial-story.direct-material-economics.chapter.compare-landed-cost-and-carbon.body": "When bids return, the unit price is the beginning of the comparison, not the end. Award scenarios recompute total landed cost across freight, duty, energy and terms, while carbon cost compliance is verified against the supplier's qualification record, so the cheapest tonne and the best tonne are visibly different decisions.",
    "editorial-story.direct-material-economics.chapter.compare-landed-cost-and-carbon.handoff": "The committed award writes its scenario, evidence and qualification state into records the value ledger can hold it to.",
    "editorial-story.direct-material-economics.chapter.compare-landed-cost-and-carbon.title": "Compare total landed cost and carbon exposure",
    "editorial-story.direct-material-economics.chapter.normalize-demand.authority": "The demand owner commits the consolidated portfolio; the agents that signal demand and harmonise specifications only propose.",
    "editorial-story.direct-material-economics.chapter.normalize-demand.body": "Raw-material demand arrives from plans, plants and formats that rarely agree. The demand owner consolidates it into one portfolio, and harmonised material specifications make volumes comparable before anyone talks to a market: same material family, same units, same quality envelope.",
    "editorial-story.direct-material-economics.chapter.normalize-demand.handoff": "A business-consented demand portfolio, in comparable units, becomes the baseline the coverage position is measured against.",
    "editorial-story.direct-material-economics.chapter.normalize-demand.title": "Normalise demand and specifications",
    "editorial-story.direct-material-economics.chapter.observe-price-and-coverage.authority": "Outlooks and coverage readings are evidence, not decisions; the category manager owns the reading and no volume moves on it.",
    "editorial-story.direct-material-economics.chapter.observe-price-and-coverage.body": "A price outlook without a coverage position is a chart; a coverage gap without an outlook is a worry. The category manager watches both in one place: the projected corridor for the material family, and how far committed volume actually covers the consolidated demand.",
    "editorial-story.direct-material-economics.chapter.observe-price-and-coverage.handoff": "A flagged coverage gap with its outlook attached becomes the trigger for a bounded buy-timing proposal.",
    "editorial-story.direct-material-economics.chapter.observe-price-and-coverage.title": "Observe price and coverage together",
    "editorial-story.direct-material-economics.chapter.propose-buy-timing.authority": "Only a named sourcing lead commits a mandate, and only inside the authority envelope; expired evidence expires the proposal.",
    "editorial-story.direct-material-economics.chapter.propose-buy-timing.body": "The buy timing agent converts the outlook and the gap into a drafted mandate that names three numbers: the volume band, the buy window and the price ceiling. The sourcing lead authorises, narrows or declines it against the declared authority envelope. The mandate is a decision record, never an order.",
    "editorial-story.direct-material-economics.chapter.propose-buy-timing.handoff": "An authorised mandate hands sourcing execution a bounded instruction it can run without reopening the timing decision.",
    "editorial-story.direct-material-economics.chapter.propose-buy-timing.title": "Propose a bounded buy-timing mandate",
    "editorial-story.direct-material-economics.chapter.retain-quality-and-margin-evidence.authority": "The value lead owns the margin arbitration record; intervention proposals stay proposals until a named person commits them.",
    "editorial-story.direct-material-economics.chapter.retain-quality-and-margin-evidence.body": "The cycle ends where the next one starts: predicted supplier quality is checked against observed performance, and margin trade-offs between price taken now and exposure carried forward are arbitrated in the value portfolio with the award scenarios still attached. Nothing about the decision has to be reconstructed from memory.",
    "editorial-story.direct-material-economics.chapter.retain-quality-and-margin-evidence.handoff": "Reviewed quality and margin evidence re-enters the opportunity radar and the value portfolio, so the next demand signal starts from what the last cycle proved.",
    "editorial-story.direct-material-economics.chapter.retain-quality-and-margin-evidence.title": "Retain supplier-quality and margin evidence",
    "editorial-story.direct-material-economics.journey.description": "Five chapters, each with a named owner, governed records, an explicit authority boundary and a handoff the next owner can hold it to.",
    "editorial-story.direct-material-economics.kicker": "Direct-material economics",
    "editorial-story.direct-material-economics.map.description": "Each direct-material capability maps onto an existing business module of the foundation. Nothing new is invented for the lens.",
    "editorial-story.direct-material-economics.map.open": "Open the direct-material capability map",
    "editorial-story.direct-material-economics.moment.description": "The buy-timing mandate is where the journey turns from evidence into a bounded decision. The proposal and the human commitment stay visibly distinct.",
    "editorial-story.direct-material-economics.outcome": "One governed decision journey: demand consolidates into a portfolio the business has consented to, market movement becomes a bounded buy-timing mandate a person authorises, award decisions compare total landed cost and carbon exposure on reproducible evidence, and quality and margin learning flow back into the next cycle.",
    "editorial-story.direct-material-economics.summary": "How direct-material decisions, what to buy, when to buy it and what it truly costs, run across five domains of the foundation, with named owners, governed evidence and bounded mandates at every handoff.",
    "editorial-story.direct-material-economics.system-boundary": "Planning systems such as SAP Integrated Business Planning remain the system of record for demand plans, key figures and versions. The foundation reads governed projections through declared channels, never edits planning data in place, and returns procurement-committed quantities through the one authorised import path the recipe pins. Market price assessments stay licensed evidence with their sources attached.",
    "editorial-story.direct-material-economics.title": "When the material is the margin",
    "editorial-story.indirect-buying.brief.open": "Download the indirect buying framework brief",
    "editorial-story.indirect-buying.brief.pdf": "Download the indirect buying brief as PDF",
    "editorial-story.indirect-buying.chapter.consolidate-the-tail.authority": "The agent surfaces and sizes consolidation candidates; only the category manager authorises converting a fragment of the tail into a governed channel.",
    "editorial-story.indirect-buying.chapter.consolidate-the-tail.body": "The tail is not small spend; it is unmanaged spend in small pieces. The consolidation reading groups repeat, fragmented purchases by family and supplier and surfaces the ones worth moving into a governed channel, each with the evidence of what was bought, how often and from whom.",
    "editorial-story.indirect-buying.chapter.consolidate-the-tail.handoff": "An authorised consolidation candidate hands tactical sourcing a bounded instruction: these purchases, this channel, this window.",
    "editorial-story.indirect-buying.chapter.consolidate-the-tail.title": "Consolidate the long tail",
    "editorial-story.indirect-buying.chapter.convert-repeat-buys.authority": "Drafted agreements stay proposals; the sourcing lead commits the conversion and the resulting entitlement inside their authority envelope.",
    "editorial-story.indirect-buying.chapter.convert-repeat-buys.body": "A spot buy is a reasonable answer the first time and an expensive habit the fifth. The conversion flow watches for repeat tactical purchases and drafts the agreement that would replace them, with the price history and demand pattern attached, so the decision to contract is made once, on evidence, instead of never.",
    "editorial-story.indirect-buying.chapter.convert-repeat-buys.handoff": "A committed agreement gives the order path an entitlement to buy against, and gives price-variance monitoring its reference.",
    "editorial-story.indirect-buying.chapter.convert-repeat-buys.title": "Convert repeat buys into agreements",
    "editorial-story.indirect-buying.chapter.guard-the-contract-price.authority": "Variance findings are proposals with the evidence attached; the value lead disposes of each finding, and recovery actions are committed by name.",
    "editorial-story.indirect-buying.chapter.guard-the-contract-price.body": "An agreement only saves money if the orders that follow honour it. Price-variance monitoring compares invoiced and ordered prices against the entitlement they claim, so off-contract variance is caught while the purchase order is still open rather than discovered in a year-end review.",
    "editorial-story.indirect-buying.chapter.guard-the-contract-price.handoff": "Disposed variance findings, recovered or accepted, become the realised-value record payment positioning reads.",
    "editorial-story.indirect-buying.chapter.guard-the-contract-price.title": "Guard the contracted price",
    "editorial-story.indirect-buying.chapter.hold-the-channel.authority": "Drift readings are evidence, not enforcement; the policy owner decides whether the rule, the catalogue or the behaviour changes, and commits that decision by name.",
    "editorial-story.indirect-buying.chapter.hold-the-channel.body": "Every buying channel exists because a policy put it there, and every quarter some spend quietly leaves it. The channel-drift reading compares where requisitions actually ran against where the rules say they should run, so off-contract buying appears as a measured pattern with its spend attached rather than an anecdote.",
    "editorial-story.indirect-buying.chapter.hold-the-channel.handoff": "A measured drift pattern with its affected spend becomes the case the tail consolidation weighs.",
    "editorial-story.indirect-buying.chapter.hold-the-channel.title": "Hold the channel against drift",
    "editorial-story.indirect-buying.chapter.position-the-payment.authority": "The agent only assembles the position and proposes; every change to payment timing or terms is committed by a named person in treasury.",
    "editorial-story.indirect-buying.chapter.position-the-payment.body": "Payment terms are a working-capital position, not a formality at the bottom of an invoice. The payment-terms reading assembles where terms actually stand against the entitlements that govern them, so treasury weighs early-payment value against days-payable position deliberately, on the whole picture.",
    "editorial-story.indirect-buying.chapter.position-the-payment.handoff": "A deliberate terms position closes the journey and re-enters intake as channel guidance for the next thousand small requests.",
    "editorial-story.indirect-buying.chapter.position-the-payment.title": "Position the payment terms",
    "editorial-story.indirect-buying.chapter.route-the-request.authority": "The buyer owns the route; the agents that clarify requests and assess coverage only propose, and no request changes channel without a recorded reason.",
    "editorial-story.indirect-buying.chapter.route-the-request.body": "Indirect demand arrives as thousands of small requests, most of them urgent to exactly one person. Intake clarifies what is actually being asked for, and catalogue coverage decides how far a guided route can carry it: a request that lands on a covered item follows the catalogue, and a gap becomes a recorded coverage fact rather than a workaround.",
    "editorial-story.indirect-buying.chapter.route-the-request.handoff": "A clarified request on its governed channel, or a named coverage gap, becomes the input the channel policy is measured against.",
    "editorial-story.indirect-buying.chapter.route-the-request.title": "Route the request into a governed channel",
    "editorial-story.indirect-buying.journey.description": "Six chapters, each with a named owner, governed records, an explicit authority boundary and a handoff the next owner can hold it to.",
    "editorial-story.indirect-buying.kicker": "Indirect buying",
    "editorial-story.indirect-buying.map.description": "Each indirect-buying capability maps onto an existing business module of the foundation. Nothing new is invented for the lens.",
    "editorial-story.indirect-buying.map.open": "Open the indirect-buying capability map",
    "editorial-story.indirect-buying.moment.description": "The tail-spend consolidation decision is where the journey turns from evidence into a bounded commitment. The agent's proposal and the category manager's authorisation stay visibly distinct.",
    "editorial-story.indirect-buying.outcome": "One governed buying journey: requests arrive through a clarified intake and take the channel policy prefers, drift away from that channel becomes a policy decision rather than a habit, the long tail consolidates into channels a category manager authorises, repeat spot buys convert into governed agreements, off-contract price variance is caught while the order is still open, and payment terms become a deliberate working-capital position.",
    "editorial-story.indirect-buying.summary": "How indirect buying decisions, which channel a request takes, what the long tail is allowed to cost and how payment terms are positioned, run across six domains of the foundation, with named owners, governed records and explicit authority at every handoff.",
    "editorial-story.indirect-buying.system-boundary": "Procure-to-pay suites such as SAP Ariba and Coupa remain the transactional system of record for requisitions, orders and invoices, and marketplaces such as Amazon Business remain the merchant of record inside their integration contract. The foundation reads governed projections of that activity through declared channels, never edits transactional data in place, and returns proposals through the one authorised path each recipe pins.",
    "editorial-story.indirect-buying.title": "When the tail sets the terms",
    "editorial-story.journey.title": "The decision journey",
    "editorial-story.map.title": "Where the capabilities land",
    "editorial-story.missing.body": "The governed story record is not part of this projection.",
    "editorial-story.missing.title": "This story is not published for this audience.",
    "editorial-story.moment.title": "One moment, illustrated",
    "editorial-story.morning-decision-brief.brief.open": "Download the morning decision brief framework brief",
    "editorial-story.morning-decision-brief.brief.pdf": "Download the morning decision brief as PDF",
    "editorial-story.morning-decision-brief.chapter.ask-and-commit.authority": "The demand owner commits each action by name inside the authority envelope; the brief answers and proposes, and it holds no commit authority.",
    "editorial-story.morning-decision-brief.chapter.ask-and-commit.body": "Now the team asks. Why is one plant thin? What happens if the renewal waits a month? The brief answers from the joined records with sources attached, states what it may and may not do, and puts the prepared action forward inside the authority envelope. A named owner commits or declines, and the question, the answer and the decision stay on one record. That is the difference from another dashboard, which shows, and from an ungoverned chat surface, which talks: the brief answers from governed records and commits nothing on its own.",
    "editorial-story.morning-decision-brief.chapter.ask-and-commit.handoff": "The committed actions return to their owning systems through declared paths, and tomorrow's brief starts from tonight's outcomes.",
    "editorial-story.morning-decision-brief.chapter.ask-and-commit.title": "Ask the brief, commit by name",
    "editorial-story.morning-decision-brief.chapter.check-the-windows.authority": "The contract manager owns the window decision; the change agent detects windows and prepares paths, and no notice is issued without a named decision.",
    "editorial-story.morning-decision-brief.chapter.check-the-windows.body": "The brief's contract read answers one question early: which agreements behind these positions reach a renewal or notice window soon. A window that passes unseen forfeits the renegotiation and exit paths, the value of both walking out through a lapsed date. In the brief the window arrives as a decision with lead time, terms and prepared paths, not as a calendar reminder.",
    "editorial-story.morning-decision-brief.chapter.check-the-windows.handoff": "The open windows join the brief as decisions with deadlines, and the supplier behind each one is handed to the risk read.",
    "editorial-story.morning-decision-brief.chapter.check-the-windows.title": "Check the contract windows before they close",
    "editorial-story.morning-decision-brief.chapter.open-the-position.authority": "The demand owner owns the portfolio and its exposed positions; the coverage agent reconciles and raises, and it commits nothing.",
    "editorial-story.morning-decision-brief.chapter.open-the-position.body": "The brief opens on the consolidated position: forecast demand against contracted cover, by material family and month. The coverage agent reconciles the portfolio overnight and raises the positions whose cover runs out inside the declared risk posture. Nobody assembles this picture by hand; the team's first minutes go to the two positions that need a decision, not to the five systems that used to hold the parts. All figures are illustrative.",
    "editorial-story.morning-decision-brief.chapter.open-the-position.handoff": "Two exposed positions, each with its cover and demand records attached, wait for the reads that explain them.",
    "editorial-story.morning-decision-brief.chapter.open-the-position.title": "Open the position, not the systems",
    "editorial-story.morning-decision-brief.chapter.read-your-own-outlook.authority": "The category manager owns the category reading; the outlook agent joins and projects, and the model stays the organisation's own.",
    "editorial-story.morning-decision-brief.chapter.read-your-own-outlook.body": "The price line in the brief is the organisation's own forecasting model, read as a governed signal with source, method and confidence preserved. The category radar joins that outlook to the exposed positions: a rising corridor makes one gap urgent and lets the other wait. The model is not replaced and not second-guessed; it is finally read beside the demand and cover it was built to inform.",
    "editorial-story.morning-decision-brief.chapter.read-your-own-outlook.handoff": "Each exposed position now carries a priced direction, and the contract questions it raises pass to the windows read.",
    "editorial-story.morning-decision-brief.chapter.read-your-own-outlook.title": "Read the team's own price outlook",
    "editorial-story.morning-decision-brief.chapter.weigh-the-risk.authority": "The risk owner owns the risk reading; the monitoring agent normalises and correlates signals, and it blocks nothing on its own.",
    "editorial-story.morning-decision-brief.chapter.weigh-the-risk.body": "The last read joins supplier risk to each prepared action: the signals and assessment state of the suppliers a covering buy or a renewal would lean on. A lagging feed is shown with its age rather than presented as current, and a deteriorating assessment can hold an action back before it is committed rather than explain it afterwards.",
    "editorial-story.morning-decision-brief.chapter.weigh-the-risk.handoff": "Each prepared action now carries the risk state of the supplier it relies on, and the brief is ready to be asked.",
    "editorial-story.morning-decision-brief.chapter.weigh-the-risk.title": "Weigh the supplier behind the position",
    "editorial-story.morning-decision-brief.journey.description": "Five chapters, one morning: each read joins the brief through a governed record, with a named owner, an explicit authority boundary and a handoff the next owner can hold it to.",
    "editorial-story.morning-decision-brief.kicker": "The morning decision brief",
    "editorial-story.morning-decision-brief.map.description": "Each capability the morning brief reads from maps onto an existing business module of the foundation. The brief adds a governed way in, not another module.",
    "editorial-story.morning-decision-brief.map.open": "Open the source-to-pay capability master map",
    "editorial-story.morning-decision-brief.moment.description": "The morning brief is where the joined reads become bounded decisions. The brief's answers and proposals and the demand owner's commitments stay visibly distinct.",
    "editorial-story.morning-decision-brief.outcome": "One governed morning: the exposed positions arrive with their reasons attached, the team asks and the brief answers from governed records with sources cited, prepared actions carry their volume, window and ceiling, a named owner commits or declines each one inside the authority envelope, and the day's decisions stay on one record the next morning starts from.",
    "editorial-story.morning-decision-brief.summary": "How a commodity team's morning changes when cover, its own price outlook, contract windows and supplier risk arrive as one prepared brief that answers questions from governed records, proposes bounded actions and leaves every commitment to a named owner. Told on illustrative records, not client results.",
    "editorial-story.morning-decision-brief.system-boundary": "Planning systems keep the demand plan, the organisation's own prediction models keep the price outlook, and contract, ERP and risk systems keep their records. The brief reads governed projections of those records through declared channels, answers with the source attached, never edits source data in place, and returns each committed action through the one authorised path its recipe pins. It is an access surface over governed Workblocks, not another system of record and not an ungoverned chat surface.",
    "editorial-story.morning-decision-brief.title": "When the day starts with decisions, not dashboards",
    "editorial-story.outcome.title": "What the journey leaves behind",
    "editorial-story.systems.title": "The system-of-record boundary",
    "enterprise.contract-start-roi.headline": "Contractual savings before go-live.",
    "enterprise.contract-start-roi.mechanism": "On larger contracts, the offset can cover the full incumbent licence, with terms that scale with deal size.",
    "enterprise.contract-start-roi.title": "Contractual ROI from contract start",
    "enterprise.contract-start-roi.value": "Beyond Work offsets existing SaaS licences, with a guaranteed saving figure written into the contract before go-live.",
    "enterprise.enterprise-interoperability.headline": "Existing systems keep their role.",
    "enterprise.enterprise-interoperability.mechanism": "The platform is fully compatible with Microsoft 365 Copilot and SharePoint.",
    "enterprise.enterprise-interoperability.title": "Work inside the stack the enterprise already runs",
    "enterprise.enterprise-interoperability.value": "The platform works inside SAP and Microsoft environments, without a parallel tool or platform migration.",
    "enterprise.governed-ai-environment.headline": "Bring AI work under IT control.",
    "enterprise.governed-ai-environment.mechanism": "Identity, access, audit and authority controls across every Workblock.",
    "enterprise.governed-ai-environment.title": "A governed environment for AI work, not shadow IT",
    "enterprise.governed-ai-environment.value": "The platform gives IT one governed environment for AI work.",
    "enterprise.human-accountability.headline": "Delegation never removes ownership.",
    "enterprise.human-accountability.mechanism": "Human evaluation drives learning and review is automatically reinstated when quality falls.",
    "enterprise.human-accountability.title": "Named human authority for every machine action",
    "enterprise.human-accountability.value": "Every AI action has a named human owner.",
    "enterprise.model-residency.headline": "Choose the model. Keep the data in region.",
    "enterprise.model-residency.mechanism": "The platform keeps data in its selected EU or US region and offers single-tenant isolation.",
    "enterprise.model-residency.title": "Model independence and data residency",
    "enterprise.model-residency.value": "The platform is model agnostic across American, European and Chinese providers.",
    "enterprise.pilot-production.headline": "The pilot is the production path.",
    "enterprise.pilot-production.mechanism": "Pilot and production run on the same platform.",
    "enterprise.pilot-production.title": "Designed for production deployment, not pilot hell",
    "enterprise.pilot-production.value": "The Workblock that proves value moves into production without being rebuilt.",
    "enterprise.predictable-cost.headline": "Priced per outcome. Capped per solution.",
    "enterprise.predictable-cost.mechanism": "Beyond Work is priced per outcome and capped per solution, not per token.",
    "enterprise.predictable-cost.title": "Predictable cost, with AI productivity gains",
    "enterprise.predictable-cost.value": "The price does not rise as usage grows, and every system of work has a defined price ceiling.",
    "enterprise.price-stability.headline": "At least three years of locked pricing.",
    "enterprise.price-stability.mechanism": "Contracts run for a minimum term of three years.",
    "enterprise.price-stability.title": "Multi-year price stability",
    "enterprise.price-stability.value": "The price is fixed for the full term, with an annual inflation adjustment capped and tied to a published index and a guaranteed right to renew the same system of work on the same pricing basis.",
    "enterprise.production-track-record.headline": "An established enterprise platform.",
    "enterprise.production-track-record.mechanism": "Three years of large-enterprise production across logistics, pharma and government.",
    "enterprise.production-track-record.title": "Built in the EU. Proven in production.",
    "enterprise.production-track-record.value": "Beyond Work execution rails are built in the EU, SOC 2 Type II audited and ISO 27001 certified.",
    "enterprise.regulatory-delivery.headline": "EU AI Act compliance is part of the delivery model.",
    "enterprise.regulatory-delivery.mechanism": "The platform is delivered with consultancy partners for regulated-industry requirements.",
    "enterprise.regulatory-delivery.title": "Regulatory compliance built into delivery",
    "enterprise.regulatory-delivery.value": "The platform is EU AI Act compliant.",
    "enterprise.transport-independent-access.headline": "Keep system access independent of API policy.",
    "enterprise.transport-independent-access.mechanism": "Standard enterprise channels, document formats and adapters.",
    "enterprise.transport-independent-access.title": "Access to systems of record without API dependency",
    "enterprise.transport-independent-access.value": "The platform reaches systems of record without depending on vendor APIs.",
    "facts.agents.label": "Governed agents",
    "facts.band.label": "The work in numbers",
    "facts.business-modules.label": "Business modules",
    "facts.domains.label": "Domain Workblocks",
    "facts.flows.label": "Execution flows",
    "facts.roles.label": "Roles",
    "facts.stages.label": "Stages",
    "faq.authority.answer": "Authority is set per named action. The ladder runs from Human-led to Policy-autonomous with monitoring. Money, personal data and hard-to-reverse actions keep explicit guards. Changing an action's authority level requires a recorded grant, and every policy-autonomous commitment is logged.",
    "faq.authority.question": "Can agents act without a person approving every step?",
    "faq.build-speed.answer": "Workblocks are integrated with client systems in days, not weeks, and working Workblocks are built in the same timeframe. The build starts from defined domain, module, data and authority contracts rather than a blank page. The Workblock that proves value is the Workblock that deploys, with its version history attached.",
    "faq.build-speed.question": "How long until a working Workblock?",
    "faq.change.answer": "As fast as the operation changes. A Workblock is never a fixed solution: a change is a new version, evaluated against recorded runs and deployed as a deliberate act with the previous version still there. Change the Workblock, not the platform.",
    "faq.change.question": "How quickly can a Workblock change after go-live?",
    "faq.coexist.answer": "No. The platform coexists with ERP, suites, SharePoint and data warehouses through narrow adapters. Clients start with one bounded outcome and expand as the results justify it.",
    "faq.coexist.question": "Does this replace ERP and procurement suites immediately?",
    "faq.copilot.answer": "They use only the Workblocks your platform has authorised, and they keep proposals, approvals and commitments distinct. Where Microsoft 365 Copilot is your preferred front door, Workblock tools are offered tool by tool once each has passed authentication, permission and tenant testing for your environment.",
    "faq.copilot.question": "What can governed procurement agents actually do?",
    "faq.data.answer": "No. The shared data and analytics layer can be queried in place or connected to the warehouse and reporting estate you already operate.",
    "faq.data.question": "Do we have to move our data into a new warehouse?",
    "faq.durable.answer": "It waits, then continues. A run can pause for a multi-week approval or a supplier reply and pick up exactly where it left off, with its state and record intact. Long waits are normal work, not failures.",
    "faq.durable.question": "What happens to work that waits weeks for an approval?",
    "faq.erp.answer": "Yes, for as long as it earns that place. The ERP keeps executing transactions while Workblocks coordinate the judgement, records and exceptions that cross it. Nothing asks you to replace execution to improve the work around it.",
    "faq.erp.question": "Does the ERP stay the system of record?",
    "faq.first-outcome.answer": "With one bounded outcome that crosses systems today: an invoice exception path, a risk review, a savings initiative. One Workblock proves the model while every incumbent system keeps its responsibilities. Expansion is a decision that proof earns.",
    "faq.first-outcome.question": "Where do clients usually start?",
    "faq.framework.answer": "Accenture GroundWorks is the foundation for agentic source-to-pay: one map, one shared vocabulary and nine domain Workblocks containing 45 business modules. The Accenture Agentic Procurement Platform is the client-facing solution configured from it.",
    "faq.framework.question": "What is the difference between the framework and the platform?",
    "faq.graduation.answer": "No. Human evaluation builds the safety record, then rule-based policy graduates routine runs past manual review, with every skip logged. If quality drops, the work returns to people automatically; autonomy is earned on the record and stays reversible.",
    "faq.graduation.question": "Will people always have to review agent work?",
    "faq.integration-speed.answer": "Workblocks are integrated with client systems in days, not weeks, and working Workblocks are built in the same timeframe. Connections are credentialed configuration against one platform boundary, not a bespoke project per system.",
    "faq.integration-speed.question": "How long does integration with our systems take?",
    "faq.isolation.answer": "No. Your platform is an exact, versioned configuration held for you, and every change to it is deliberate, reviewable and reversible. Your configuration is yours.",
    "faq.isolation.question": "Is our configuration shared with other clients?",
    "faq.learning.answer": "Into your tenant, and nowhere else. A validated correction becomes a scored example reused where your work happens, not training in a vendor's shared model. Your operational knowledge compounds for you.",
    "faq.learning.question": "Where does the learning from our corrections go?",
    "faq.map.answer": "Five lifecycle stages contain nine domain Workblocks. Each Workblock contains five business modules; together the 45 modules contain 206 execution flows made from 748 tasks. Three shared capability rows run beneath the map, and one execution foundation runs it all.",
    "faq.map.question": "How is the framework organised?",
    "faq.mistakes.answer": "Proposal is not commitment: machine-drafted work stays visibly proposed until an authorised person or policy commits it. The correction is stored in your tenant and reused, so the same mistake gets rarer exactly where your work happens.",
    "faq.mistakes.question": "What happens when an agent gets it wrong?",
    "faq.modular.answer": "Each domain Workblock owns one outcome, cohesive experience and release. Its five business modules preserve bounded jobs, records and execution flows inside that release, while all nine Workblocks share the same controls and data contracts.",
    "faq.modular.question": "What makes the platform modular?",
    "faq.office.answer": "People stay in Word, Excel and SharePoint. Composer and Conductor let authorised Workblocks do native DOCX and XLSX work in the same files, and approved changes preserve round-trip fidelity.",
    "faq.office.question": "How does Microsoft 365 compatibility work?",
    "faq.pricing.question": "How is the platform priced?",
    "faq.replace.answer": "Only after a Workblock has proved equivalent capability, control and value against gates agreed in advance. Coexist first, prove value, replace selectively. Keep the systems that earn their place.",
    "faq.replace.question": "When would we retire an existing system?",
    "faq.rollback.answer": "Nothing changes for the people running the work until deploy, and deploy is a deliberate act with the previous version still there. A change that misbehaves is rolled back the same way it shipped: one decision, recorded, reversible.",
    "faq.rollback.question": "What happens if a change misbehaves?",
    "faq.roundtrip.answer": "Yes. Composer and Conductor work in the native DOCX and XLSX artifact, review happens in the browser, and approved changes are preserved when the file reopens in Word or Excel. The document is part of the governed work, not a file attached at the end.",
    "faq.roundtrip.question": "Do approved changes survive the round trip to Word and Excel?",
    "faq.security.answer": "Security evidence is governed and current; supporting documents are available through the trust process.",
    "faq.security.question": "What is the security posture of the execution foundation?",
    "faq.status.answer": "Across the 45 business modules, 8 are reference modules, 9 are defined modules and 28 are roadmap modules. A reference module is demonstrable at confirmed fidelity. A defined module has its business, data, authority and execution contracts ready for client configuration. A roadmap module is planned and is never represented as running.",
    "faq.status.question": "What is the implementation status of the business modules?",
    "faq.systems.answer": "A system of work is the coherent operating experience delivered by one domain Workblock, such as Supplier & Third-Party Risk Management (TPRM). Its five business modules share one experience, release boundary, permissions, data contracts and change process.",
    "faq.systems.question": "What is a system of work?",
    "faq.traceability.answer": "Every aggregate is a door. A savings, health or automation figure opens the records, definitions and owners that produced it, with its true freshness shown.",
    "faq.traceability.question": "Can finance trace a reported number to its source?",
    "faq.who-builds.answer": "GroundWorks is for Accenture. It is the foundation their teams use to build, manage, adapt and iterate Workblocks for each client, so Accenture know-how becomes software delivered at the pace each client needs. Clients experience the result as agentically built applications, carried with the assurance and quality of Accenture.",
    "faq.who-builds.question": "Who is GroundWorks for?",
    "framework.description": "The foundation Accenture teams use to build, adapt and run procurement Workblocks for each client: Accenture know-how, shipped as software the client owns. Start with one outcome and expand without a platform reset.",
    "framework.eyebrow": "Accenture GroundWorks",
    "framework.facts": "9 domain Workblocks · 45 business modules · 8 reference modules",
    "framework.positioning": "Why this model is different",
    "framework.pricing-label": "Commercial model",
    "framework.title": "The foundation for agentic source-to-pay.",
    "glossary.automation.definition": "The exact ladder label an action holds, with its actor, scope, consequence, version and expiry. Confidence never grants authority.",
    "glossary.automation.term": "Authority level",
    "glossary.business-module.definition": "One of five bounded business outcomes inside a domain Workblock. It owns a procurement job, records, controls, authority and definitions of done.",
    "glossary.business-module.term": "Business module",
    "glossary.composer.definition": "A universal document capability for native DOCX authoring, review and round-trip fidelity, available to authorised Workblocks.",
    "glossary.composer.term": "Composer",
    "glossary.conductor.definition": "A universal workbook capability for native XLSX analysis and editing, available to authorised Workblocks.",
    "glossary.conductor.term": "Conductor",
    "glossary.copilot.definition": "An agent that can use authorised Workblocks as tools while proposals, permissions, approvals, commitments and audit remain explicit.",
    "glossary.copilot.term": "Governed procurement agent",
    "glossary.execution-flow.definition": "An invokable task graph inside a business module, selected for one trigger or operating path.",
    "glossary.execution-flow.term": "Execution flow",
    "glossary.framework.definition": "The Accenture-owned foundation for agentic source-to-pay: one lifecycle map, one shared vocabulary, nine domain Workblocks and 45 business modules, configured around each client's operating model.",
    "glossary.framework.term": "Accenture GroundWorks",
    "glossary.graduated-autonomy.definition": "Five action-specific levels bound what a machine may do, from Human-led through Policy-autonomous with monitoring. The valid level is the least authority that achieves the outcome.",
    "glossary.graduated-autonomy.term": "Authority ladder",
    "glossary.last-good.definition": "The most recent usable result retained when a source fails, shown with its true freshness.",
    "glossary.last-good.term": "Last-good data",
    "glossary.platform.definition": "The Accenture-owned client solution configured from GroundWorks and tailored to the client's operating model.",
    "glossary.platform.term": "Accenture Agentic Procurement Platform",
    "glossary.rails.definition": "The enterprise execution foundation the configured platform runs on. It gives every Workblock the same durable runs, one permissioned data plane and one audit trail.",
    "glossary.rails.term": "Beyond Work execution rails",
    "glossary.realization.definition": "Value supported by the defined validation method, owner and evidence. It is distinct from pipeline or forecast.",
    "glossary.realization.term": "Validated realisation",
    "glossary.status-reference.definition": "A business module implemented on the execution rails and demonstrable at confirmed fidelity.",
    "glossary.status-reference.term": "Reference build",
    "glossary.system-accord.definition": "The contract lifecycle system of work, delivered by one domain Workblock with five business modules. Its GroundWorks signature name is GroundWorks Accord.",
    "glossary.system-accord.term": "Contract Lifecycle Management (CLM)",
    "glossary.system-alliance.definition": "The supplier performance and innovation system of work, delivered by one domain Workblock with five business modules. Its GroundWorks signature name is GroundWorks Alliance.",
    "glossary.system-alliance.term": "Supplier Relationship Management (SRM)",
    "glossary.system-buyline.definition": "The buying, ordering and receiving system of work, delivered by one domain Workblock with five business modules. Its GroundWorks signature name is GroundWorks Buyline.",
    "glossary.system-buyline.term": "Purchasing & Ordering",
    "glossary.system-clearway.definition": "The invoice and payment readiness system of work, delivered by one domain Workblock with five business modules. Its GroundWorks signature name is GroundWorks Clearway.",
    "glossary.system-clearway.term": "Invoicing & Payment (AP)",
    "glossary.system-dealroom.definition": "The sourcing and negotiation system of work, delivered by one domain Workblock with five business modules. Its GroundWorks signature name is GroundWorks Dealroom.",
    "glossary.system-dealroom.term": "Sourcing & Negotiation",
    "glossary.system-gateway.definition": "The intake and demand system of work, delivered by one domain Workblock with five business modules. Its GroundWorks signature name is GroundWorks Gateway.",
    "glossary.system-gateway.term": "Intake Management",
    "glossary.system-of-work.definition": "The coherent operating experience delivered by one domain Workblock. It is not another container in the product hierarchy.",
    "glossary.system-of-work.term": "System of work",
    "glossary.system-radar.definition": "The category strategy and spend system of work, delivered by one domain Workblock with five business modules. Its GroundWorks signature name is GroundWorks Radar.",
    "glossary.system-radar.term": "Category Management",
    "glossary.system-sentinel.definition": "The supplier lifecycle and third-party risk system of work, delivered by one domain Workblock with five business modules. Its GroundWorks signature name is GroundWorks Sentinel.",
    "glossary.system-sentinel.term": "Supplier & Third-Party Risk Management (TPRM)",
    "glossary.system-value-hunter.definition": "The value realisation and savings system of work, delivered by one domain Workblock with five business modules. Its GroundWorks signature name is GroundWorks Value Hunter.",
    "glossary.system-value-hunter.term": "Savings & Value Realisation",
    "glossary.task.definition": "One typed execution step inside an execution flow.",
    "glossary.task.term": "Task",
    "glossary.tenant-learning.definition": "Validated corrections stored as scored examples in the client's tenant and reused where the client's work happens, not in a vendor's shared model.",
    "glossary.tenant-learning.term": "Tenant learning",
    "glossary.workblock.definition": "One of nine independently versioned units that owns a source-to-pay domain outcome, system of work, cohesive experience, release and authority boundary.",
    "glossary.workblock.term": "Workblock",
    "header.brand-name": "GroundWorks",
    "identity.ownership": "Accenture-owned and purpose-built for procurement",
    "identity.platform-name": "Accenture Agentic Procurement Platform",
    "identity.short-name": "Agentic Procurement Platform",
    "landscape.adaptability.description": "Version and evaluate the smallest useful Workblock rather than replacing the procurement stack. Expansion is a decision the last outcome earns.",
    "landscape.adaptability.label": "Continuous adaptability",
    "landscape.erp.description": "The ERP keeps executing transactions. Workblocks coordinate the judgement, records and exceptions that cross it, then hand the result back.",
    "landscape.erp.label": "ERP coexistence",
    "landscape.legacy.description": "Suites change on their release cycle. Workblocks change on yours: versioned, evaluated and deployed one outcome at a time.",
    "landscape.legacy.label": "Alongside the procurement suite",
    "landscape.office.description": "People keep working in Word, Excel and SharePoint while authorised Workblocks use document and workbook capabilities in the same native files.",
    "landscape.office.label": "Native Microsoft 365 work",
    "landscape.s2p.description": "Nine domain Workblocks share one control, data and agent layer. A Workblock is added without re-platforming the ones already running.",
    "landscape.s2p.label": "Modular source-to-pay coverage",
    "landscape.warehouse.description": "Query governed data in place or connect the warehouse already in use. Metrics keep their source and freshness either way.",
    "landscape.warehouse.label": "Warehouse coexistence",
    "lifecycle.caption": "Colour marks the stage, numbered one to five in the order work moves through them.",
    "lifecycle.map-title": "Nine Domain Workblocks across five stages",
    "method.adoption.legacy": "Adoption means a replacement programme.",
    "method.adoption.method": "Adoption starts alongside what you own: prove one bounded outcome, then replace only what stops earning its place.",
    "method.ai.legacy": "AI arrives as an assistant beside the work: it suggests and summarises, and it never commits.",
    "method.ai.method": "Governed agents work inside the Workblock: policy may commit routine actions inside a revocable grant, while people supervise outcomes, exceptions and sampled work.",
    "method.change.legacy": "Change is a request in someone else's backlog.",
    "method.change.method": "You change the Workblock and leave the platform alone: a new version, deployed as a deliberate act, reversible.",
    "method.learning.legacy": "Your corrections improve the vendor's product for everyone.",
    "method.learning.method": "Your corrections stay in your tenant and compound in your own work.",
    "method.legacy-label": "The legacy model",
    "method.method-label": "The GroundWorks method",
    "method.process.legacy": "Your process lives inside a vendor's modules and changes on the vendor's release calendar.",
    "method.process.method": "Your domain Workblock is a versioned system of work you own, with bounded business modules and the previous release available for recovery.",
    "method.title": "The method, against the legacy model",
    "method.unit.legacy": "You buy seats on modules.",
    "method.unit.method": "You adopt nine domain Workblocks that each own one source-to-pay outcome.",
    "moat.body": "Every system of work added compounds on the last: same tenant, same permissions, same data plane, same change process.",
    "moat.headline": "Accenture know-how, shipped as software the client owns.",
    "nav.build": "Build",
    "nav.capability-map": "Capability",
    "nav.client-engagement": "Client engagement",
    "nav.compounding-intelligence": "Compounding intelligence",
    "nav.connected-work": "Connected Work",
    "nav.data-catalogue": "Data catalogue",
    "nav.data-model": "Data model",
    "nav.design": "Design",
    "nav.direct-material-economics": "Direct-material economics",
    "nav.downloads": "Downloads",
    "nav.faqs": "FAQs",
    "nav.framework": "Home",
    "nav.group.sections": "Sections",
    "nav.indirect-buying": "Indirect buying",
    "nav.jobs": "Jobs to be done",
    "nav.language": "Language",
    "nav.morning-decision-brief": "Morning decision brief",
    "nav.office-capabilities": "Composer and Conductor",
    "nav.platform": "Platform",
    "nav.reference": "Reference",
    "nav.release": "Release",
    "nav.roles": "Roles",
    "nav.search": "Search",
    "nav.section-label": "Section",
    "nav.why-groundworks": "Why GroundWorks",
    "nav.work-moments": "Work moments",
    "nav.workblock-architecture": "Align data and architecture",
    "nav.workblock-design": "Brand and style a Workblock",
    "nav.workblocks": "Workblocks",
    "office.autonomy.act.label": "Act",
    "office.autonomy.inspect.label": "Inspect",
    "office.autonomy.read-back.label": "Read back",
    "office.autonomy.resolve.label": "Resolve",
    "office.autonomy.return.label": "Return",
    "office.autonomy.validate.label": "Validate",
    "office.catalogue.cards-description": "Open the full product specifications for role responsibilities, agentic counterparts, policy-bounded execution, rich-format coverage and product requirements.",
    "office.catalogue.cards-heading": "Choose the artifact at the centre of the work",
    "office.catalogue.description": "Native DOCX and XLSX capabilities for people, agents and Workblocks acting inside explicit authority, delivered by Beyond Work execution rails.",
    "office.catalogue.eyebrow": "Accenture GroundWorks capabilities",
    "office.catalogue.section-description": "Part of the Accenture GroundWorks programme and delivered by Beyond Work execution rails. Open either capability to see its full product specification.",
    "office.catalogue.section-heading": "Composer and Conductor bring native Office work into the Workblock",
    "office.catalogue.title": "Composer and Conductor",
    "office.composer.action.compare.agent": "Assemble the deviation, source language, accepted fallback and connected terms.",
    "office.composer.action.compare.human": "Compare incoming paper with the approved position.",
    "office.composer.action.decide.agent": "Present the exact change to the named authority and carry their disposition into the document.",
    "office.composer.action.decide.human": "Accept, reject or return a proposed position.",
    "office.composer.action.draft.agent": "Write native DOCX content with the required style, list, table and section structure.",
    "office.composer.action.draft.human": "Draft a clause or bounded alternative.",
    "office.composer.action.find.agent": "Resolve the clause by meaning, heading, template field or durable document scope.",
    "office.composer.action.find.human": "Open a contract and find the clause that matters.",
    "office.composer.action.finish.agent": "Validate, export and return the DOCX to the next Workblock stage or human reviewer.",
    "office.composer.action.finish.human": "Save and send the next version.",
    "office.composer.action.inspect.agent": "Inspect the clause in context with its review state, permissions and linked document structure.",
    "office.composer.action.inspect.human": "Read the surrounding language, comments and revisions.",
    "office.composer.action.redline.agent": "Apply tracked changes and comments through the same guarded document actions.",
    "office.composer.action.redline.human": "Redline the document.",
    "office.composer.action.structure.agent": "Use the native operation for that object, then read back the resulting document state.",
    "office.composer.action.structure.human": "Update a table, field, content control or generated region.",
    "office.composer.actions.description": "The agent does not imitate clicks or work from flattened text. It resolves durable document scopes, checks authority, applies the native action and reads the resulting DOCX state back.",
    "office.composer.autonomy.act.description": "Draft, edit, comment, redline or refresh through bounded document operations. Consequential positions remain proposals when policy requires judgement.",
    "office.composer.autonomy.description": "An authorised Workblock can carry a DOCX from intent to a usable result, pause at a consequential boundary and resume with the same artifact context.",
    "office.composer.autonomy.heading": "Document work can run while no editor is open",
    "office.composer.autonomy.inspect.description": "Read content, structure, review posture, permissions and relevant Workblock context before planning a change.",
    "office.composer.autonomy.read-back.description": "Inspect the resulting document state, including exact changes, blocked reasons and dependent content, rather than assuming the mutation succeeded.",
    "office.composer.autonomy.resolve.description": "Open or create the correct DOCX and locate clauses, template fields or other durable document scopes.",
    "office.composer.autonomy.return.description": "Validate export state and return the native DOCX to the next Workblock stage or human reviewer, preserving recovery points.",
    "office.composer.autonomy.validate.description": "Confirm the target is current, the native operation is supported and the requested action sits inside the active authority.",
    "office.composer.capabilities.description": "The structures people use to draft, negotiate, review and retain a document remain available to people, agents and headless Workblocks through one product model.",
    "office.composer.capabilities.heading": "A rich DOCX product, not a text wrapper",
    "office.composer.closing": "Keep the contract as the working artifact. Let Composer do the document work around the judgement, then return the exact DOCX to the person authorised to decide.",
    "office.composer.cta": "Explore Conductor",
    "office.composer.difference.browser-editor.description": "The visual surface is one consumer of package truth, document structure, review state and typed actions. Agents do not drive pixels or target fragile screen positions.",
    "office.composer.difference.browser-editor.label": "Beyond a browser editor",
    "office.composer.difference.clm.description": "Composer extends known-template assembly into rich third-party paper, iterative redlines, clause-level decisions and native round trips while coexisting with the CLM records already in place.",
    "office.composer.difference.clm.label": "Beyond CLM document generation",
    "office.composer.difference.extraction.description": "It can act on the native document that facts came from, create review markup, preserve structure and return a usable DOCX, not just return fields or text.",
    "office.composer.difference.extraction.label": "Beyond document extraction",
    "office.composer.difference.word-add-in.description": "Composer can assist a person in a document and operate as headless document infrastructure inside a durable Workblock, pausing and resuming around human authority.",
    "office.composer.difference.word-add-in.label": "Beyond a Word add-in",
    "office.composer.differentiators.description": "Composer combines rich document truth, human review and durable agent execution. The result is not advice beside a contract. It is a governed next version of the contract itself.",
    "office.composer.differentiators.heading": "The difference is work completed in the native artifact",
    "office.composer.family.fields-controls.label": "Fields, controls and navigation",
    "office.composer.family.fields-controls.value": "Fields, generated content, bookmarks, links and content controls remain meaningful targets with their native behaviours and locks.",
    "office.composer.family.numbering-lists.label": "Numbering and lists",
    "office.composer.family.numbering-lists.value": "Clause numbering and list hierarchies can continue, restart and restructure without flattening markers into text.",
    "office.composer.family.objects.label": "Images, drawings and embedded objects",
    "office.composer.family.objects.value": "Rich objects stay in the package and remain available through the actions defined for them.",
    "office.composer.family.package.label": "DOCX package fidelity",
    "office.composer.family.package.value": "Custom and opaque package content unrelated to the requested action is preserved instead of discarded by a text-only conversion.",
    "office.composer.family.protection.label": "Protection and permissions",
    "office.composer.family.protection.value": "Locked content, permission ranges and workflow scopes constrain both human and agent mutations.",
    "office.composer.family.review.label": "Comments and tracked changes",
    "office.composer.family.review.value": "Review conversations, proposals, replies, resolutions and accepted or rejected edits survive as native review state.",
    "office.composer.family.sections-stories.label": "Sections, page flow and stories",
    "office.composer.family.sections-stories.value": "Sections, breaks, page settings, headers, footers, footnotes and endnotes remain connected to the file.",
    "office.composer.family.tables.label": "Tables",
    "office.composer.family.tables.value": "Commercial schedules, responsibility matrices and clause tables remain editable rows, columns, cells, borders and shading.",
    "office.composer.family.text-styles.label": "Text, styles and themes",
    "office.composer.family.text-styles.value": "Drafts retain typography, paragraph hierarchy, character formatting and house style as native document structure.",
    "office.composer.format": "Native DOCX capability",
    "office.composer.name": "Composer",
    "office.composer.requirement.artifacts": "Keep originals, working copies, approved positions and executed copies as distinct artifacts.",
    "office.composer.requirement.export": "Return a native DOCX that retains the structure required for people to continue in Word.",
    "office.composer.requirement.headless": "Run every authorised document action without mounting the interactive editor and preserve context through waits, retries and approvals.",
    "office.composer.requirement.package": "Own the DOCX package, canonical document, formatting, pagination, geometry, review and export model.",
    "office.composer.requirement.review": "Support rich authoring, comments, tracked changes, version comparison and proposal review through human and agent surfaces.",
    "office.composer.requirement.targets": "Address clauses, paragraphs, tables, lists, fields, content controls, sections, stories and objects as stable semantic targets.",
    "office.composer.requirements.description": "These conditions keep native fidelity, agentic parity and human authority intact as Composer is used across Workblocks.",
    "office.composer.requirements.heading": "The Composer product contract",
    "office.composer.role.contract-manager.question": "Which contracts are waiting on a decision, and is each one on the right version?",
    "office.composer.role.contract-manager.role": "Contract manager",
    "office.composer.role.contract-manager.value": "Approved facts, open issues, comments, revisions and version state stay together in the DOCX. The contract advances without rebuilding context at each handoff.",
    "office.composer.role.legal.question": "Which clauses actually need my judgement?",
    "office.composer.role.legal.role": "Legal counsel",
    "office.composer.role.legal.value": "Material deviations arrive in document context with the approved position, proposed language, connected terms and native review markup already organised. Counsel judges the exception rather than reconstructing it.",
    "office.composer.role.negotiation-lead.question": "What may I put forward without returning for approval?",
    "office.composer.role.negotiation-lead.role": "Negotiation lead",
    "office.composer.role.negotiation-lead.value": "Accepted, open and conditional positions remain aligned with the redline. Bounded alternatives can move inside the mandate while contractual commitment stays with the authorised review.",
    "office.composer.role.obligation-owner.question": "What must I do, by when, and what proves it is complete?",
    "office.composer.role.obligation-owner.role": "Obligation owner",
    "office.composer.role.obligation-owner.value": "The source clause, trigger, deadline, performance standard and closure requirement arrive together. The duty remains connected to the contract and any amendment that changes it.",
    "office.composer.roles.description": "Composer prepares the native document around the question each role needs to answer, without quietly taking the decision away from them.",
    "office.composer.roles.heading": "Document work arrives at the decision owner",
    "office.composer.specification-cta": "Open the Composer product specification",
    "office.composer.summary": "Composer carries document work from approved facts to a review-ready native DOCX, so legal and commercial teams spend their attention on the decisions that require it.",
    "office.composer.tagline": "Contracts arrive ready for judgement.",
    "office.composer.thesis": "For a person, Composer is a document workspace. For an agent, it is a set of precise document actions. For a Workblock, it is a headless document runtime. All three operate on the same DOCX artifact, with clauses, comments, revisions, tables, controls and document structure intact.",
    "office.composer.workblocks.description": "These business modules declare Composer as a shared Office capability. Their implementation status remains visible so a capability relationship is never mistaken for a running module.",
    "office.composer.workblocks.heading": "One document capability across source-to-pay",
    "office.conductor.action.analyse.agent": "Invoke the typed workbook or governed analysis action over the authorised scope.",
    "office.conductor.action.analyse.human": "Filter, sort, pivot, chart or run a scenario over a working set.",
    "office.conductor.action.decide.agent": "Present the result, assumptions and effect to the named authority and carry their disposition into the workbook.",
    "office.conductor.action.decide.human": "Challenge, adjust, accept or return the calculated proposal.",
    "office.conductor.action.find.agent": "Resolve the sheet, table, named range, formula region or durable workbook scope.",
    "office.conductor.action.find.human": "Open a workbook and find the relevant model or input.",
    "office.conductor.action.finish.agent": "Validate, recalculate, export and return the XLSX to the next Workblock stage or human reviewer.",
    "office.conductor.action.finish.human": "Save and send the decision model.",
    "office.conductor.action.inspect.agent": "Inspect its value, formula, display format, dependencies, errors and calculation state.",
    "office.conductor.action.inspect.human": "Read a number and inspect the cells around it.",
    "office.conductor.action.structure.agent": "Change workbook structure through stable identities that survive the edit.",
    "office.conductor.action.structure.human": "Insert rows, move a range or update a table.",
    "office.conductor.action.trace.agent": "Explain the result from the formula graph, precedents and approved method.",
    "office.conductor.action.trace.human": "Trace how a result was calculated.",
    "office.conductor.action.write.agent": "Apply bounded native writes and return the recalculated workbook state.",
    "office.conductor.action.write.human": "Enter values, formulas and formats.",
    "office.conductor.actions.description": "The agent does not drive cells by screen coordinate or copy an answer from a separate model. It resolves stable workbook scopes, calculates through the native dependency graph and reads the resulting XLSX state back.",
    "office.conductor.autonomy.act.description": "Write, restructure, calculate, filter, pivot or run governed analysis through bounded workbook operations. Consequential outcomes remain proposals when policy requires judgement.",
    "office.conductor.autonomy.description": "An authorised Workblock can carry an XLSX from source inputs to a reproducible result, pause at a consequential boundary and resume with the same artifact context.",
    "office.conductor.autonomy.heading": "Workbook work can run while no spreadsheet is open",
    "office.conductor.autonomy.inspect.description": "Read values, formulas, formats, dependencies, errors, protection and relevant Workblock context before planning a change.",
    "office.conductor.autonomy.read-back.description": "Inspect the recalculated values, errors, dependencies and exact mutations rather than assuming the workbook reached the intended state.",
    "office.conductor.autonomy.resolve.description": "Open or create the correct XLSX and locate sheets, tables, names, formulas or other durable workbook scopes.",
    "office.conductor.autonomy.return.description": "Validate export state and return the native XLSX to the next Workblock stage or human reviewer, preserving recovery points.",
    "office.conductor.autonomy.validate.description": "Confirm the target is current, inputs are authorised, calculation can run and the requested action sits inside the active authority.",
    "office.conductor.capabilities.description": "The structures people use to calculate, analyse, challenge and present a workbook remain available to people, agents and headless Workblocks through one product model.",
    "office.conductor.capabilities.heading": "A rich XLSX product, not a grid wrapper",
    "office.conductor.closing": "Keep the workbook as the working model. Let Conductor do the calculation and analysis around the judgement, then return the exact XLSX to the person authorised to decide.",
    "office.conductor.cta": "Explore Composer",
    "office.conductor.difference.analytics.description": "Governed analysis lands in the XLSX people approve and exchange, with declared inputs and output regions, instead of leaving a separate result to copy back by hand.",
    "office.conductor.difference.analytics.label": "Beyond analytics or a notebook",
    "office.conductor.difference.automation.description": "Actions target meaningful workbook scopes, validate that the target is current, calculate the effect and read the resulting state back after structural edits.",
    "office.conductor.difference.automation.label": "Beyond cell automation",
    "office.conductor.difference.component.description": "The grid is one presentation of package truth, stable workbook identity, calculation dependencies, display semantics, workflow state and guarded actions.",
    "office.conductor.difference.component.label": "Beyond a spreadsheet component",
    "office.conductor.difference.dashboard.description": "The worked model behind a pipeline, forecast, realisation or variance stays available. The decision owner can challenge the method and see the result recalculate before accepting it.",
    "office.conductor.difference.dashboard.label": "Beyond a savings dashboard",
    "office.conductor.difference.excel-add-in.description": "Conductor can assist a person in a workbook and operate as headless workbook infrastructure while no spreadsheet is open, then return the same XLSX for human continuation.",
    "office.conductor.difference.excel-add-in.label": "Beyond an Excel add-in",
    "office.conductor.differentiators.description": "Conductor combines workbook truth, calculation, governed tools, human review and durable agent execution. The result is not an answer beside a model. It is the worked XLSX ready for the decision.",
    "office.conductor.differentiators.heading": "The difference is analysis completed in the native artifact",
    "office.conductor.family.calculation.label": "Formula graph and calculation state",
    "office.conductor.family.calculation.value": "Results can be traced, explained, recalculated and checked for errors across dependent sheets and regions.",
    "office.conductor.family.data-actions.label": "Validation, filters, sorts and outlines",
    "office.conductor.family.data-actions.value": "Controlled inputs and working views remain native workbook behaviours available through typed actions.",
    "office.conductor.family.formats.label": "Styles and conditional formats",
    "office.conductor.family.formats.value": "Review cues, exception emphasis and financial formats remain part of the model.",
    "office.conductor.family.package.label": "XLSX package fidelity",
    "office.conductor.family.package.value": "Print setup, external content and features outside the requested action remain in the native workbook rather than being dropped by a row-only conversion.",
    "office.conductor.family.protection.label": "Protection and governed ranges",
    "office.conductor.family.protection.value": "Locked areas and workflow-owned regions constrain both human and agent writes.",
    "office.conductor.family.review.label": "Comments and review state",
    "office.conductor.family.review.value": "Questions, adjustments, explanations and prior results remain with the workbook scope they concern.",
    "office.conductor.family.scenarios.label": "Scenarios, solver and governed tools",
    "office.conductor.family.scenarios.value": "Commercial and value choices can be tested with scoped solver, Python or SQL actions without separating the answer from the model.",
    "office.conductor.family.tables-names.label": "Tables, names and structured references",
    "office.conductor.family.tables-names.value": "Business regions retain stable meaning as rows, columns and surrounding coordinates change.",
    "office.conductor.family.values-formulas.label": "Values, formulas and display formats",
    "office.conductor.family.values-formulas.value": "The number, its calculation and the way the workbook presents it stay together.",
    "office.conductor.family.visuals.label": "Charts, images, drawings and pivots",
    "office.conductor.family.visuals.value": "Decision visuals and summaries stay connected to the ranges and workbook that produce them.",
    "office.conductor.format": "Native XLSX capability",
    "office.conductor.name": "Conductor",
    "office.conductor.requirement.calculation": "Recalculate affected dependencies after change and expose the resulting value, error and calculation state.",
    "office.conductor.requirement.export": "Return a native XLSX that retains the structure required for people to continue in Excel.",
    "office.conductor.requirement.headless": "Run every authorised workbook action without mounting the interactive grid and preserve context through waits, retries and approvals.",
    "office.conductor.requirement.kernel": "Run Python and SQL only through a governed kernel with declared input, output, credential and network boundaries.",
    "office.conductor.requirement.package": "Own the XLSX package, workbook identity, formula graph, calculation, display semantics, grid geometry, workflow and export model.",
    "office.conductor.requirement.review": "Support rich workbook authoring, review, scenario comparison and formula explanation through human and agent surfaces.",
    "office.conductor.requirement.targets": "Address sheets, tables, names, ranges, formulas, charts, pivots and scenarios through stable workbook scopes.",
    "office.conductor.requirements.description": "These conditions keep calculation integrity, agentic parity and human authority intact as Conductor is used across Workblocks.",
    "office.conductor.requirements.heading": "The Conductor product contract",
    "office.conductor.role.award-authority.question": "Can I defend this recommendation line by line?",
    "office.conductor.role.award-authority.role": "Award authority",
    "office.conductor.role.award-authority.value": "Scores, source responses, commercial scenarios, dissent and conditions remain connected in the award workbook. The authority judges the recommendation without asking the team to rebuild the pack.",
    "office.conductor.role.category-manager.question": "Which negotiated savings are appearing in actual orders and invoices?",
    "office.conductor.role.category-manager.role": "Category manager",
    "office.conductor.role.category-manager.value": "Award delta, contracted terms, adoption and actual transactions remain connected. Price, volume, mix, compliance and timing can be separated before value is called realised.",
    "office.conductor.role.finance-delegate.question": "Can I reproduce this number from source records and the approved method before I accept it?",
    "office.conductor.role.finance-delegate.role": "Finance delegate",
    "office.conductor.role.finance-delegate.value": "The baseline, formula, exclusions, source ranges and recalculated result stay in one worked model. Finance can challenge the method without creating a shadow workbook.",
    "office.conductor.role.negotiation-lead.question": "What can I trade, what must I protect and what changes if I move?",
    "office.conductor.role.negotiation-lead.role": "Negotiation lead",
    "office.conductor.role.negotiation-lead.value": "Spend, demand, proposals, mandate and scenario effects remain in one workbook. The lead can test a move without losing the workings or stepping outside granted authority.",
    "office.conductor.role.supplier-manager.question": "Can I defend this review and prove follow-through?",
    "office.conductor.role.supplier-manager.role": "Supplier relationship manager",
    "office.conductor.role.supplier-manager.value": "Measures, service records, obligations, risks and open actions arrive as a worked supplier review. Critical failures stay visible beside aggregates that might otherwise conceal them.",
    "office.conductor.role.value-lead.question": "Which initiatives have left their value path, and what can still be recovered?",
    "office.conductor.role.value-lead.role": "Value realisation lead",
    "office.conductor.role.value-lead.value": "Actuals, approved value path, variance bridge, competing explanations and recovery scenarios arrive together. The portfolio moves from reporting a gap to deciding what to do about it.",
    "office.conductor.roles.description": "Conductor prepares the native model around the question each role needs to answer, while keeping a calculated candidate separate from an accepted business outcome.",
    "office.conductor.roles.heading": "Workbook work arrives with the answer and its workings",
    "office.conductor.specification-cta": "Open the Conductor product specification",
    "office.conductor.summary": "Conductor carries workbook work from source inputs to a decision-ready native XLSX, so procurement and finance can inspect, challenge and continue the calculation that produced the answer.",
    "office.conductor.tagline": "Every number can show its workings.",
    "office.conductor.thesis": "For a person, Conductor is a workbook workspace. For an agent, it is a set of typed workbook actions. For a Workblock, it is a headless calculation and analysis runtime. All three operate on the same XLSX artifact, with formulas, dependencies, formats, scenarios and review state intact.",
    "office.conductor.workblocks.description": "These business modules declare Conductor as a shared Office capability. Their implementation status remains visible so a capability relationship is never mistaken for a running module.",
    "office.conductor.workblocks.heading": "One workbook capability across source-to-pay",
    "office.shared.actions.agent-heading": "What an agent can do inside a Workblock",
    "office.shared.actions.heading": "Every meaningful human action has an agentic counterpart",
    "office.shared.actions.human-heading": "What a person does",
    "office.shared.companion.description": "Use Composer for the document and Conductor for the workbook while the Workblock keeps evidence, authority and the next action connected.",
    "office.shared.companion.heading": "One native artifact model across the commercial decision",
    "office.shared.delivery": "Delivered by Beyond Work execution rails",
    "office.shared.program": "Part of the Accenture GroundWorks programme",
    "office.shared.requirements.item-label": "Product condition",
    "opening.browse-catalogue": "Browse the Workblock catalogue",
    "opening.core-line": "From procurement signals to governed action.",
    "opening.definition-title": "What GroundWorks is",
    "opening.delivery-title": "How Accenture delivers",
    "opening.first-move-link": "Read the delivery motion",
    "opening.first-move-title": "Start with one bounded outcome",
    "opening.first-time": "Read the ten-minute story",
    "opening.gap-eyebrow": "The enterprise problem",
    "opening.gap-title": "The work that hurts is between systems",
    "opening.letter.p1": "Every procurement programme we deliver teaches the same two lessons. The work that hurts is rarely inside one system: it is between them, where people chase records, find owners and carry decisions across boundaries. And no two operations are alike: whatever we bring must bend to each client without breaking what already runs.",
    "opening.letter.p2": "GroundWorks is our answer. At its heart are nine domain Workblocks across source-to-pay. Each gives one domain a coherent home: its roles, decisions, records and controls. Five business modules inside each Workblock define the outcomes a client configures. Their execution flows carry work through typed tasks, human decisions and system actions. The structure is reusable, while policies, systems, thresholds and authority remain the client's own.",
    "opening.letter.p3": "One example. An invoice fails its match, and today someone hunts the order in one system, the receipt in another, the supplier's answer in an inbox. The Invoicing & Payment Workblock contains the business modules for that work. Configured to your operation, it delivers the mismatch as a case: cause identified, records attached, owner named and next action proposed. Policy may clear a routine, reversible case inside its current authority envelope; people supervise outcomes, handle true exceptions and retain stop and rollback rights.",
    "opening.letter.p4": "Start anywhere: the exception queue that hurts most, the contract backlog, supplier onboarding. Workblocks are integrated with client systems in days, not weeks, and working Workblocks are built in the same timeframe. When your operation changes, the Workblock changes with you: adapted, evaluated and redeployed, with the previous version still there. Each Workblock you add inherits the foundation the last one proved: one vocabulary, one data plane, one way of granting authority.",
    "opening.letter.p5": "That is the trade platforms usually force: adopt fast, or stay consistent. Nine cohesive domain Workblocks give you both.",
    "opening.proof-title": "One case, worked through",
    "opening.shift-eyebrow": "The shift",
    "opening.title": "Why we built this",
    "orientation.covers": "The whole source-to-pay lifecycle: every stage, Domain Workblock, business module, record, role and authority boundary that connects a signal to a governed action.",
    "orientation.covers.label": "What it covers",
    "orientation.start": "Start from the work you run, the role you hold, or the outcome you want to change.",
    "orientation.start.label": "Where to start",
    "orientation.use": "Scope a first bounded outcome, walk a client through the operating model, and hand delivery a contract it can build on.",
    "orientation.use.label": "What to use it for",
    "orientation.what": "GroundWorks is the Beyond Work source-to-pay framework. Accenture GroundWorks is Accenture's platform implementation of it, tailored for AI-first procurement.",
    "orientation.what.label": "What it is",
    "page.architecture.description": "Workblocks share identity, data, analytics and integration contracts, so any one can change without touching the rest.",
    "page.architecture.eyebrow": "Reference architecture",
    "page.architecture.title": "One governed foundation across modular procurement domains.",
    "page.authoring-guide.checklist-title": "Completion checklist",
    "page.authoring-guide.copied-prompt": "Prompt copied",
    "page.authoring-guide.copy-failed": "Copy failed",
    "page.authoring-guide.copy-prompt": "Copy prompt",
    "page.authoring-guide.download-kit": "Download the Claude Code authoring kit",
    "page.authoring-guide.guide-title": "Apply the GroundWorks contract",
    "page.authoring-guide.open-resource": "Open resource",
    "page.authoring-guide.outcome-label": "Result",
    "page.authoring-guide.pathways-title": "Choose an authoring path",
    "page.authoring-guide.prompt-description": "Use this prompt in Claude Code from a local project or in a platform authoring session. It points the agent back to the same governed assets.",
    "page.authoring-guide.prompt-title": "Copy-paste prompt",
    "page.authoring-guide.resources-description": "Open the governed source, download the exact asset, or retrieve it through the local GroundWorks MCP index.",
    "page.authoring-guide.resources-title": "Core assets",
    "page.authoring-guide.step-label": "Step {number}",
    "page.build.description": "How GroundWorks turns a bounded procurement outcome into a configured, versioned Workblock on Beyond Work execution rails: the framework model, the delivery motion and the governed material to start from.",
    "page.build.door.architecture": "The hierarchy, lifecycle, authority, data, integration and release model behind every Workblock.",
    "page.build.door.design": "The complete component catalogue with copy-ready usage and design prompts.",
    "page.build.door.downloads": "The complete site-safe asset catalogue with format, version, proof, licence and hash.",
    "page.build.door.workblock-architecture": "A practical inside-platform and Claude Code path from outcome and task graph to owned records, reliable delivery and validation.",
    "page.build.door.workblock-design": "A practical inside-platform and Claude Code path for a GroundWorks-branded, responsive and truthful Workblock surface.",
    "page.build.door.workblocks": "All nine domain Workblocks and 45 business modules, with contracts, flows and status.",
    "page.build.doors.title": "Start from governed material",
    "page.build.eyebrow": "Build",
    "page.build.method.description": "Reuse and client tailoring are the same asset. The domain Workblock prevents a blank-page start; its five business modules make the operating model configurable for the client.",
    "page.build.method.step1.body": "Choose a frequent or consequential piece of work with a named owner, an observable handoff and a result the client can inspect.",
    "page.build.method.step1.title": "Frame the outcome",
    "page.build.method.step2.body": "Use the source-to-pay map to choose the domain Workblock and the bounded business module. Bring the outcome, roles, records, decision rights, measures and recovery path into the room together.",
    "page.build.method.step2.title": "Select the Workblock and module",
    "page.build.method.step3.body": "Configure policy, thresholds, sources, language, roles, human authority and experience. The business contract stays coherent while the expression fits the client.",
    "page.build.method.step3.title": "Make it the client's own",
    "page.build.method.step4.body": "Use narrow, observable adapters. Enterprise resource planning, suites, warehouses, SharePoint and specialist systems remain authoritative where they should. The Workblock owns the cross-system outcome and the handoffs around it.",
    "page.build.method.step4.title": "Connect the existing estate",
    "page.build.method.step5.body": "Keep machine proposals distinct from committed outcomes. People hold consequential authority. Validated corrections remain in the client's tenant, and the next adjacent Workblock reuses the same permissions, records and change process.",
    "page.build.method.step5.title": "Run, inspect and expand",
    "page.build.method.title": "The delivery motion",
    "page.build.title": "From one client outcome to a versioned Workblock.",
    "page.client-engagement.description": "For Accenture pursuit and delivery teams shaping a procurement conversation: frame the client problem, choose the differentiators that answer it, and open the stories, mappings and working material that carry the case.",
    "page.client-engagement.door.capability-map": "The complete Accenture capability map and its correspondence to the nine domain Workblocks.",
    "page.client-engagement.door.connected-work": "Integration recipes, canonical mappings and illustrative examples with their exact proof labels.",
    "page.client-engagement.door.direct-material-economics": "One cross-domain lens on direct-material spend: what to buy, when to buy it and what it truly costs, with named owners at every handoff.",
    "page.client-engagement.door.indirect-buying": "One cross-domain lens on indirect spend: which channel each request takes, what the long tail is allowed to cost and how payment terms are positioned.",
    "page.client-engagement.door.why-groundworks": "The commercial, production, governance and interoperability case, grouped by the questions buyers actually ask.",
    "page.client-engagement.door.work-moments": "Editorial Work moments showing a role supervising a module agent through to a committed outcome.",
    "page.client-engagement.doors.title": "Where to go next",
    "page.client-engagement.eyebrow": "Client engagement",
    "page.client-engagement.move.body": "Start with one frequent or consequential piece of work with a named owner and an observable handoff. Configure one domain Workblock around it, prove the outcome, then expand to the adjacent Workblock on the same records and permissions.",
    "page.client-engagement.move.title": "The first credible move",
    "page.client-engagement.sequence.step1.body": "Most clients own capable systems. The work between them still depends on people. Name where a signal loses its link to an owned action.",
    "page.client-engagement.sequence.step1.title": "Frame the gap",
    "page.client-engagement.sequence.step2.body": "Place the client's estate against the nine domain Workblocks with the capability map, and choose where GroundWorks adds a system of work rather than another tool.",
    "page.client-engagement.sequence.step2.title": "Map what the client owns",
    "page.client-engagement.sequence.step3.body": "Open a Work moment for the chosen domain: the role, the signal, the bounded agent contribution and the human-owned outcome.",
    "page.client-engagement.sequence.step3.title": "Show the work",
    "page.client-engagement.sequence.step4.body": "Close with the downloadable briefs, recipes and schemas the client's own teams can inspect.",
    "page.client-engagement.sequence.step4.title": "Leave working material",
    "page.client-engagement.sequence.title": "The engagement sequence",
    "page.client-engagement.title": "Make the client case, then choose the proof.",
    "page.connected-work.action-class.consequential-action": "Consequential action",
    "page.connected-work.action-class.consequential-create": "Consequential create",
    "page.connected-work.action-class.draft-or-propose": "Draft or propose",
    "page.connected-work.action-class.not-applicable": "Transport contract",
    "page.connected-work.action-class.read-only": "Read only",
    "page.connected-work.action-class.read-or-propose": "Read or propose",
    "page.connected-work.canonical-path": "Source payload or authorised outcome → bounded integration Workblock → owned GroundWorks records → governed projection or reconciled target state",
    "page.connected-work.catalogue-description": "GroundWorks provides versioned recipes for records, mappings, channels, authority, reliable delivery and recovery. Client configuration supplies the installed system, credentials and approved field overlay.",
    "page.connected-work.catalogue-meta": "{recipes} recipes · {mappings} module mappings · {systems} systems",
    "page.connected-work.catalogue-principle-body": "A source payload enters through a bounded integration Workblock, maps to owned GroundWorks records and preserves provenance, authority and source version. An API is one channel, not the architecture of the business process.",
    "page.connected-work.catalogue-title": "Integration recipes for the systems clients already run.",
    "page.connected-work.clear-filters": "Clear filters",
    "page.connected-work.client-pinned-format": "Client-pinned format",
    "page.connected-work.client-schema-label": "Client schema required",
    "page.connected-work.close-body": "A vendor can change an API, a client can change a model provider and an operating team can change a channel. The Workblock keeps its outcome, record ownership, authority and audit contract while the adapter is versioned around it.",
    "page.connected-work.close-title": "The connection changes. The system of work stays coherent.",
    "page.connected-work.configuration-title": "What client configuration must resolve",
    "page.connected-work.copilot-architecture-description": "Nine domain recipe packages organise 45 outcome tools around the agents already published for each module. The access surface never replaces the Workblock's authority or data boundary.",
    "page.connected-work.copilot-architecture-title": "A governed recipe for Microsoft 365 Copilot access to a Workblock outcome",
    "page.connected-work.copilot-examples-description": "Nine domain examples show how an access surface can call a bounded outcome. Module maturity and tool-recipe proof remain independent.",
    "page.connected-work.copilot-examples-title": "Microsoft 365 Copilot outcome examples",
    "page.connected-work.copilot-relationship-label": "Microsoft 365 Copilot and Workblock outcome relationship",
    "page.connected-work.cross-cutting-examples-description": "Document exchange, procurement-suite overlays and SharePoint content use the same canonical data and authority boundaries as the domain Workblocks. Each remains an illustrative example until its client configuration is accepted.",
    "page.connected-work.cross-cutting-examples-title": "Cross-cutting integration examples",
    "page.connected-work.data-model-link": "Inspect the GroundWorks data model",
    "page.connected-work.description": "A partner planning surface for mapping GroundWorks Workblocks, business modules and canonical records to the platforms, channels, authority boundaries and deployment controls a client already operates.",
    "page.connected-work.domain.copilot-example-label": "Microsoft 365 Copilot example",
    "page.connected-work.domain.description": "Shared recipes connect all five modules through the canonical data plane. Client overlays select the installed system, channel and field contract.",
    "page.connected-work.domain.mapping-count-label": "module mappings",
    "page.connected-work.domain.mapping-count-label.singular": "module mapping",
    "page.connected-work.domain.nav": "Connected Work",
    "page.connected-work.domain.open-example": "Open the example",
    "page.connected-work.domain.recipe-count-label": "integration recipes",
    "page.connected-work.domain.recipe-count-label.singular": "integration recipe",
    "page.connected-work.domain.title": "Connected Work",
    "page.connected-work.domain.tool-count-label": "outcome-tool recipes",
    "page.connected-work.domain.tool-count-label.singular": "outcome-tool recipe",
    "page.connected-work.editorial-story-link": "Read the cross-domain lens",
    "page.connected-work.example-flow-label": "Review the proposed demonstration flow",
    "page.connected-work.example.authority-boundary-label": "Authority boundary",
    "page.connected-work.example.authority-ceiling-label": "Authority ceiling",
    "page.connected-work.example.client-configuration-label": "Client configuration",
    "page.connected-work.example.cross-cutting-label": "Cross-cutting integration pattern",
    "page.connected-work.example.cross-domain": "Cross-domain",
    "page.connected-work.example.default-domain": "Connected Work",
    "page.connected-work.example.module-label": "Business module",
    "page.connected-work.example.module-status": "{status} module",
    "page.connected-work.example.not-applicable": "Not applicable",
    "page.connected-work.example.owner-label": "Accountable owner",
    "page.connected-work.example.recipes-label": "Related recipes",
    "page.connected-work.example.records-label": "Canonical records",
    "page.connected-work.example.tool-proof-label": "Tool proof",
    "page.connected-work.eyebrow": "Connected Work",
    "page.connected-work.facet.actionClass": "Action class",
    "page.connected-work.facet.actionClass.all": "All action classes",
    "page.connected-work.facet.channel": "Channel",
    "page.connected-work.facet.channel.all": "All channels",
    "page.connected-work.facet.domain": "Domain",
    "page.connected-work.facet.domain.all": "All domains",
    "page.connected-work.facet.format": "Format",
    "page.connected-work.facet.format.all": "All formats",
    "page.connected-work.facet.module": "Business module",
    "page.connected-work.facet.module.all": "All business modules",
    "page.connected-work.facet.systemRole": "System role",
    "page.connected-work.facet.systemRole.all": "All system roles",
    "page.connected-work.fact.action-classes": "Action classes",
    "page.connected-work.fact.authority": "Authority",
    "page.connected-work.fact.canonical-path": "Canonical path",
    "page.connected-work.fact.channels": "Channels",
    "page.connected-work.fact.formats": "Formats",
    "page.connected-work.fact.inputs": "Canonical inputs",
    "page.connected-work.fact.modules": "Business modules",
    "page.connected-work.fact.no-standard": "Client-pinned format contract; no shared standard profile is required.",
    "page.connected-work.fact.outputs": "Canonical outputs",
    "page.connected-work.fact.owner": "Owner",
    "page.connected-work.fact.records": "Records",
    "page.connected-work.fact.standards": "Standards",
    "page.connected-work.fact.system-roles": "System roles",
    "page.connected-work.fact.trigger": "Trigger and cadence",
    "page.connected-work.fact.workblocks": "Workblocks",
    "page.connected-work.filter-results": "{count} of {total} recipes",
    "page.connected-work.mapping-channels-label": "Durable channels",
    "page.connected-work.mapping-description": "Named examples show the reusable canonical path. Field-level compatibility waits for the installed client schema and representative payloads.",
    "page.connected-work.mapping-formats-label": "Formats",
    "page.connected-work.mapping-recipes-label": "Recipes",
    "page.connected-work.mapping-records-label": "Canonical records",
    "page.connected-work.mapping-systems-label": "Named systems",
    "page.connected-work.mapping-title": "Procurement-suite mapping overlays",
    "page.connected-work.module.action-class-label": "Action class",
    "page.connected-work.module.agent-ownership-description": "This outcome tool can be discovered only through these agent charters published by the module.",
    "page.connected-work.module.agent-ownership-label": "Published agent ownership",
    "page.connected-work.module.authority-ceiling-label": "Authority ceiling",
    "page.connected-work.module.canonical-path-label": "Canonical connection path",
    "page.connected-work.module.copilot-pattern-label": "Microsoft 365 Copilot access pattern",
    "page.connected-work.module.description": "Recipe proof and module maturity are independent. These contracts are ready to tailor; they do not imply an installed connector or Microsoft tool.",
    "page.connected-work.module.direction.bidirectional": "Inbound and outbound",
    "page.connected-work.module.direction.inbound": "Inbound",
    "page.connected-work.module.direction.outbound": "Outbound",
    "page.connected-work.module.eyebrow": "Connected Work",
    "page.connected-work.module.maturity-label": "Module maturity",
    "page.connected-work.module.nav.connections": "Connections",
    "page.connected-work.module.open-mcp-recipe": "Open the Workblock tool recipe",
    "page.connected-work.module.recipe-count": "{recipes} integration recipes",
    "page.connected-work.module.recipe-count.singular": "{recipes} integration recipe",
    "page.connected-work.module.representative-systems-label": "Representative systems",
    "page.connected-work.module.sharepoint-label": "SharePoint posture",
    "page.connected-work.module.systems-to-resolve": "Resolved during client landscape discovery",
    "page.connected-work.module.title": "Integration and outcome-tool recipes",
    "page.connected-work.module.tool-proof-label": "Tool proof",
    "page.connected-work.open-demo-workblock": "Open demo Workblock",
    "page.connected-work.open-record": "Open the canonical record",
    "page.connected-work.package-count": "{tools} outcome-tool recipes · {agents} published agents",
    "page.connected-work.package-link": "Open the domain package",
    "page.connected-work.principle-body": "GroundWorks defines the outcome, authority and canonical record first. The connection may use an API, document, file, event, message, mailbox, user interface or adapter. The system of work remains anchored to durable business records rather than to one vendor's access policy.",
    "page.connected-work.principle-label": "Connection principle",
    "page.connected-work.principle-title": "Start with the work and the record, then choose the transport.",
    "page.connected-work.prompt.copilot-tool-surface.body": "Define a Microsoft 365 Copilot tool surface for [business module]. Name the user role, Entra ID and tenant boundary, typed input and output, allowed GroundWorks records, authority ceiling, approval point, error return, safety annotation and audit event. Keep proposals distinct from committed actions. Include authentication, permission and tenant tests before the tool is offered.",
    "page.connected-work.prompt.copilot-tool-surface.scope": "Choose one domain Workblock and one business module",
    "page.connected-work.prompt.copilot-tool-surface.title": "Expose a bounded Workblock through Microsoft 365 Copilot",
    "page.connected-work.prompt.event-driven-handoff.body": "Define the event that hands [business outcome] from [producing Workblock] to [consuming Workblock]. Specify schema, business key, producer authority, consumer subscription, ordering, delivery semantics, replay window, version compatibility, failure queue, personal-data classification and the canonical records updated on each side.",
    "page.connected-work.prompt.event-driven-handoff.scope": "Choose producing and consuming domain Workblocks",
    "page.connected-work.prompt.event-driven-handoff.title": "Connect Workblocks through a durable enterprise event",
    "page.connected-work.prompt.human-accountability-bridge.body": "Trace [enterprise action] from proposal to commitment. Name the accountable human role, delegated identity, policy guard, approval or auto-approval rule, target-system credential, irreversible boundary, rollback, quality threshold and condition that automatically returns the action to human review.",
    "page.connected-work.prompt.human-accountability-bridge.scope": "Choose a module that proposes or commits an enterprise action",
    "page.connected-work.prompt.human-accountability-bridge.title": "Carry human accountability across a system action",
    "page.connected-work.prompt.model-residency-policy.body": "For [execution flow], classify every input and output, then assign eligible model providers, region, tenant topology and capability tier. State which tasks run deterministically, what may be sent to a model, which fallback is permitted, how calls are logged, where learning examples remain, and what evaluation blocks promotion.",
    "page.connected-work.prompt.model-residency-policy.scope": "Choose one execution flow",
    "page.connected-work.prompt.model-residency-policy.title": "Set model and residency policy for one execution flow",
    "page.connected-work.prompt.production-promotion-plan.body": "Prepare the promotion contract for [Workblock version]. Reuse the pilot artifact and list environment-specific configuration, secrets, connectivity, contract tests, tenant tests, representative replay, failure drills, throughput bounds, evaluation thresholds, approvals, monitoring, rollback version and production acceptance record.",
    "page.connected-work.prompt.production-promotion-plan.scope": "Choose one Workblock and its adapters",
    "page.connected-work.prompt.production-promotion-plan.title": "Promote a client connection without a second build",
    "page.connected-work.prompt.sap-document-bridge.body": "Map [GroundWorks record] to the client's SAP document and transaction standard. Name the SAP system of record, business key, version, document or message format, inbound and outbound state transitions, write authority, idempotency key, acknowledgement, exception route and reconciliation schedule. Provide an API-independent channel and recovery path where the client requires one.",
    "page.connected-work.prompt.sap-document-bridge.title": "Bridge a procurement outcome to SAP document standards",
    "page.connected-work.prompt.sharepoint-document-channel.body": "Design a SharePoint connection for [document-bearing business module]. Specify the site, library, content type, file format, metadata, retention, version, permission group and webhook or polling trigger. Map the document to its GroundWorks record and preserve provenance, human ownership and the accepted version through every round trip.",
    "page.connected-work.prompt.sharepoint-document-channel.title": "Connect SharePoint as a governed document channel",
    "page.connected-work.prompt.system-record-reconciliation.body": "Create a reconciliation Workblock between [GroundWorks entity] and [enterprise system object]. Declare field ownership, source timestamp, freshness policy, last-good behaviour, expected-version write, duplicate detection, conflict precedence, exception owner, retry boundary and evidence that closes the reconciliation.",
    "page.connected-work.prompt.system-record-reconciliation.scope": "Any domain Workblock",
    "page.connected-work.prompt.system-record-reconciliation.title": "Reconcile a canonical record with a system of record",
    "page.connected-work.prompts-description": "Each prompt is a reusable starting point for a bounded integration Workblock. Tailor it with the named domain Workblock, business module, records, authority and target environment before build.",
    "page.connected-work.prompts-title": "Integration Workblock prompts",
    "page.connected-work.proof-description": "Each label answers a different question. None inherits the evidence of another.",
    "page.connected-work.proof-title": "Proof labels",
    "page.connected-work.proof.configured-deployment": "Configured deployment",
    "page.connected-work.proof.demo-workblock": "Demo Workblock",
    "page.connected-work.proof.illustrative-example": "Illustrative example",
    "page.connected-work.proof.production-evidence": "Production evidence",
    "page.connected-work.proof.recipe": "Recipe",
    "page.connected-work.recipe-boundary-body": "A recipe is a current framework asset. It does not mean a named tenant, vendor instance or production path is connected.",
    "page.connected-work.recipe-boundary-label": "Recipe proof boundary",
    "page.connected-work.recipe-direction.bidirectional": "Bidirectional recipe",
    "page.connected-work.recipe-direction.inbound": "Inbound recipe",
    "page.connected-work.recipe-direction.interactive": "Interactive recipe",
    "page.connected-work.recipe-direction.outbound": "Outbound recipe",
    "page.connected-work.recipe-direction.read-model": "Read-model recipe",
    "page.connected-work.recipe-empty-description": "Try a broader recipe, channel or format.",
    "page.connected-work.recipe-empty-title": "No recipes match",
    "page.connected-work.recipe-filter-label": "Filter integration recipes",
    "page.connected-work.recipe-index-meta": "{direction} · {modules} business modules · {records} records",
    "page.connected-work.recipe-library-description": "Filter the reusable contracts, then open one to inspect its canonical path and delivery behaviour.",
    "page.connected-work.recipe-library-title": "Recipe library",
    "page.connected-work.recipe-search-label": "Search integration recipes",
    "page.connected-work.recipe-search-placeholder": "Search outcomes, modules, systems, channels or formats",
    "page.connected-work.record.absence-eyebrow": "Connected Work reference",
    "page.connected-work.record.absence-route": "Browse Connected Work",
    "page.connected-work.record.absence-support": "This record is not part of the current framework release.",
    "page.connected-work.record.absence-title": "Record not found",
    "page.connected-work.record.back": "Back to Connected Work",
    "page.connected-work.record.system-eyebrow": "System profile",
    "page.connected-work.record.tool-eyebrow": "Outcome-tool recipe",
    "page.connected-work.records-label": "GroundWorks records",
    "page.connected-work.related-examples-title": "Related examples",
    "page.connected-work.related-records-suffix": "more through related modules",
    "page.connected-work.reliability.acknowledgement": "Acknowledgement",
    "page.connected-work.reliability.degradedState": "Degraded state",
    "page.connected-work.reliability.freshness": "Freshness",
    "page.connected-work.reliability.idempotency": "Idempotency",
    "page.connected-work.reliability.monitoring": "Monitoring",
    "page.connected-work.reliability.reconciliation": "Reconciliation",
    "page.connected-work.reliability.recovery": "Recovery",
    "page.connected-work.reliability.rollback": "Rollback",
    "page.connected-work.representative-systems-summary": "Show {systems} representative systems",
    "page.connected-work.representative-systems-title": "Representative systems",
    "page.connected-work.resolve-label": "Resolve in the client design",
    "page.connected-work.sequence-description": "The same versioned integration contract moves from discovery through validation and production promotion.",
    "page.connected-work.sequence-title": "From client landscape to production connection",
    "page.connected-work.sequence.choose.body": "Select the durable channel, identity, credential, event and failure semantics for each hand-off.",
    "page.connected-work.sequence.choose.title": "Choose",
    "page.connected-work.sequence.frame.body": "Name the business outcome, accountable role and systems that currently carry it.",
    "page.connected-work.sequence.frame.title": "Frame",
    "page.connected-work.sequence.govern.body": "Set authority, residency, retention, evaluation, audit and regulatory controls before execution.",
    "page.connected-work.sequence.govern.title": "Govern",
    "page.connected-work.sequence.map.body": "Bind Workblock inputs and outputs to canonical GroundWorks records and source-owned fields.",
    "page.connected-work.sequence.map.title": "Map",
    "page.connected-work.sequence.promote.body": "Move the same versioned Workblock and adapters into production with rollback intact.",
    "page.connected-work.sequence.promote.title": "Promote",
    "page.connected-work.sequence.validate.body": "Run contract, tenant, reconciliation, failure and human-approval tests against representative work.",
    "page.connected-work.sequence.validate.title": "Validate",
    "page.connected-work.standard.pinning-label": "Version-pinning guidance",
    "page.connected-work.standard.profile-label": "Related standard profile",
    "page.connected-work.standard.role-label": "Role at the boundary",
    "page.connected-work.standard.scope-label": "Scope",
    "page.connected-work.standards-description": "Profiles state the role each syntax or identifier plays and what a configured adapter must pin. Syntax coverage does not claim a live network endpoint or legal compliance.",
    "page.connected-work.standards-title": "Format and standard profiles",
    "page.connected-work.status-body": "The topics and prompts below define the questions an integration design must answer. They do not represent a deployed client connection.",
    "page.connected-work.status-label": "Planning surface",
    "page.connected-work.system-count": "{systems} systems",
    "page.connected-work.system.channels-label": "Channels",
    "page.connected-work.system.discovery-required": "Select during client landscape discovery.",
    "page.connected-work.system.domains-label": "Related domains",
    "page.connected-work.system.question-label": "Resolve with the client:",
    "page.connected-work.system.recipes-label": "Applicable recipes",
    "page.connected-work.system.roles-label": "Governed roles",
    "page.connected-work.systems-description": "Representative products are grouped by retained responsibility, not presented as installed connectors.",
    "page.connected-work.systems-title": "Systems-of-record discovery map",
    "page.connected-work.tailoring-prompt-label": "Tailoring prompt",
    "page.connected-work.title": "Connect each Workblock to the enterprise without rebuilding the enterprise around it.",
    "page.connected-work.tool-catalogue-description": "Each recipe exposes one business-module outcome through that module's published agents. It defines an action class, canonical records and authority ceiling. It does not claim that the tool is installed in a Microsoft tenant.",
    "page.connected-work.tool-catalogue-title": "All 45 outcome-tool recipes",
    "page.connected-work.tool-package-count": "{count} tool recipes",
    "page.connected-work.tool.action-class-label": "Action class",
    "page.connected-work.tool.agents-label": "Published agents",
    "page.connected-work.tool.authority-label": "Authority ceiling",
    "page.connected-work.tool.maturity-label": "Module maturity",
    "page.connected-work.tool.maturity-unavailable": "Not available",
    "page.connected-work.tool.module-label": "Owning module",
    "page.connected-work.tool.recipes-label": "Related integration recipes",
    "page.connected-work.tool.records-label": "Canonical records",
    "page.connected-work.topic.durable-channels.position": "Choose the narrowest durable channel for the outcome. An API is one transport option, not the architecture of the business process.",
    "page.connected-work.topic.durable-channels.question": "What is the primary channel, what fallback preserves the work if access changes, and which idempotency, retry and reconciliation rules prevent duplicate business action?",
    "page.connected-work.topic.durable-channels.title": "APIs, documents, files, events and adapters",
    "page.connected-work.topic.governance-audit.position": "Resolve identity, credentials, action authority and audit inside one platform boundary before connecting a target system.",
    "page.connected-work.topic.governance-audit.question": "Which identity acts at every step, where is delegated authority recorded, which mutations require human approval, and which audit event proves the committed outcome?",
    "page.connected-work.topic.governance-audit.title": "Identity, authority and audit",
    "page.connected-work.topic.microsoft-365-copilot.position": "Offer authorised Workblocks through the Microsoft experience people already use while GroundWorks retains the tool, authority and audit contract.",
    "page.connected-work.topic.microsoft-365-copilot.question": "Which Workblock tools should Microsoft 365 Copilot expose, for which Entra ID roles, and what must remain proposed until a named human or policy commits it?",
    "page.connected-work.topic.microsoft-365-copilot.title": "Microsoft 365 Copilot",
    "page.connected-work.topic.model-routing.position": "Select the provider and capability tier inside the declared region without changing the Workblock's business and authority contracts.",
    "page.connected-work.topic.model-routing.question": "Which task needs a model, which providers and regions are eligible, what data classification may cross the call, and what deterministic path runs when no model is required?",
    "page.connected-work.topic.model-routing.title": "Model routing and regional residency",
    "page.connected-work.topic.production-promotion.position": "Validate and promote the same versioned Workblock and adapter contract rather than rebuilding a demonstration in another platform.",
    "page.connected-work.topic.production-promotion.question": "Which fixtures, tenant tests, failure drills, performance bounds and approvals must pass before the pilot version is promoted to production?",
    "page.connected-work.topic.production-promotion.title": "Pilot to production",
    "page.connected-work.topic.regulated-delivery.position": "Treat intended use, control ownership, evaluation and operating evidence as implementation work, not a legal appendix after deployment.",
    "page.connected-work.topic.regulated-delivery.question": "Which regulatory role applies, what is the intended use, which controls and records demonstrate it, and which change triggers a renewed risk review?",
    "page.connected-work.topic.regulated-delivery.title": "Regulated delivery",
    "page.connected-work.topic.sap.position": "Map procurement records and hand-offs to SAP document semantics while keeping the operating model independent of a single API contract.",
    "page.connected-work.topic.sap.question": "Which SAP object remains system of record, which document or event moves the work, and which GroundWorks entity owns the decision before the transaction is posted?",
    "page.connected-work.topic.sap.title": "SAP and procurement transaction standards",
    "page.connected-work.topic.sharepoint.position": "Use governed sites, libraries and native Office files as collaboration and document channels without making them the canonical decision record.",
    "page.connected-work.topic.sharepoint.question": "Which library, content type, retention label and permission group owns each document, and which GroundWorks record preserves its business state and provenance?",
    "page.connected-work.topic.sharepoint.title": "SharePoint and Microsoft 365",
    "page.connected-work.topic.systems-of-record.position": "Keep each incumbent's defined responsibility and add the governed work that crosses systems, people and documents.",
    "page.connected-work.topic.systems-of-record.question": "For every field and transition, who is authoritative, who may propose, who may write, and how are conflicts and stale reads reconciled?",
    "page.connected-work.topic.systems-of-record.title": "Systems of record",
    "page.connected-work.topic.tenancy.position": "Make tenant, region and isolation boundaries deployment choices that preserve the same system-of-work definition.",
    "page.connected-work.topic.tenancy.question": "Does the client require a single tenant, which credentials and indexes are tenant-scoped, and how is cross-environment configuration promoted without moving client data?",
    "page.connected-work.topic.tenancy.title": "Tenant topology and isolation",
    "page.connected-work.topics-description": "Use each topic to establish the role of the enterprise platform and the boundary the Workblock must respect.",
    "page.connected-work.topics-title": "Interoperability topics",
    "page.connected-work.workblock-scope-label": "Workblock scope",
    "page.data-model.ai.description": "AI receives explicit meaning, authority and uncertainty before it receives a record. The model makes context mechanically selectable and the route back to source records visible.",
    "page.data-model.ai.limit": "These mechanisms support retrieval and reasoning. They do not prove model accuracy or grant an agent authority to commit a procurement outcome.",
    "page.data-model.ai.mechanism.constraints.body": "Enumerations, typed references and value schemas narrow the meanings a consumer may assign.",
    "page.data-model.ai.mechanism.constraints.title": "Closed constraints",
    "page.data-model.ai.mechanism.context.body": "Ownership, lifecycle, provenance, freshness, evidence and access rules travel beside the value an agent sees.",
    "page.data-model.ai.mechanism.context.title": "Bounded context",
    "page.data-model.ai.mechanism.semantics.body": "Labels, definitions, types, classifications and source authority travel with fields and nested properties.",
    "page.data-model.ai.mechanism.semantics.title": "Semantic fields",
    "page.data-model.ai.mechanism.traversal.body": "Declared predicates and join fields connect roles, jobs, modules, records, standards and systems without free-text matching.",
    "page.data-model.ai.mechanism.traversal.title": "Deterministic traversal",
    "page.data-model.ai.mechanism.truth.body": "Source facts, proposals, decisions, commitments, corrections and observed outcomes remain different record states.",
    "page.data-model.ai.mechanism.truth.title": "Truthful state",
    "page.data-model.ai.mechanism.unresolved.body": "Missing authority resolves to an explicit unresolved state instead of an invented category or silent default.",
    "page.data-model.ai.mechanism.unresolved.title": "Explicit uncertainty",
    "page.data-model.ai.statement.body": "An agent can retrieve by business concept, traverse declared relationships and distinguish a proposal from a committed outcome because those differences are represented in the model, not left in a prompt.",
    "page.data-model.ai.statement.title": "Meaning is part of the data contract.",
    "page.data-model.ai.title": "Made for AI from the first definition",
    "page.data-model.boundary.description": "A complete semantic contract is architecture evidence. It is not evidence that every target service has been generated, installed or operated.",
    "page.data-model.boundary.present.dimensions": "Five independent procurement dimensions with deterministic spend-classification precedence.",
    "page.data-model.boundary.present.ownership": "One named owner, lifecycle, retention, provenance, freshness and access contract per record type.",
    "page.data-model.boundary.present.projections": "Generated audience and graph projections, lake-direction contracts and versioned migration definitions.",
    "page.data-model.boundary.present.schema": "Stable record and field schemas with typed relationships and value constraints.",
    "page.data-model.boundary.present.title": "Present in the model",
    "page.data-model.boundary.title": "The definition layer is explicit about what it proves",
    "page.data-model.boundary.withheld.cue": "CUE generation and equivalence with an accepted platform schema contract.",
    "page.data-model.boundary.withheld.database": "PostgreSQL persistence, migration execution, conditional writes and concurrency behaviour.",
    "page.data-model.boundary.withheld.lake": "Lake export, reconciliation, deletion, recovery and permission-preserving analytics.",
    "page.data-model.boundary.withheld.permission": "Permission-schema generation and enforcement from trusted tenant, role and purpose context.",
    "page.data-model.boundary.withheld.production": "Production operation, performance, availability and AI outcome quality.",
    "page.data-model.boundary.withheld.tenant": "Tenant isolation, installed connectors and environment-specific operating envelopes.",
    "page.data-model.boundary.withheld.title": "Requires separate runtime proof",
    "page.data-model.contents-label": "GroundWorks data-model topics",
    "page.data-model.description": "GroundWorks gives procurement records stable semantic names, typed relationships, named owners, lifecycle, provenance, freshness and access rules. People and agents can follow the same meaning across source-to-pay without collapsing independent business dimensions.",
    "page.data-model.dimensions.description": "Category says what is bought. Spend segment says how that category relates to what a company delivers. Buying mode, accounting treatment and tail membership answer different questions.",
    "page.data-model.dimensions.independent": "A production service can be direct and services at the same time. An asset can be indirect and capital. Neither combination changes its category, and tail membership remains a period-specific rule output.",
    "page.data-model.dimensions.members-label": "Framework members",
    "page.data-model.dimensions.precedence.category-assignment": "An exact category assignment applies next, followed by the nearest assigned ancestor in the same taxonomy version.",
    "page.data-model.dimensions.precedence.committed-line": "A valid committed transaction-line value or approved override wins.",
    "page.data-model.dimensions.precedence.description": "Spend segment is a company-scoped category assignment with an authorised transaction-line override. It is never a taxonomy level or a boolean.",
    "page.data-model.dimensions.precedence.item-default": "An item or catalogue classification supplies the authoritative line default.",
    "page.data-model.dimensions.precedence.proposal": "Supplier classification, descriptions, accounts, contracts and model output may support a proposal but cannot silently commit spend truth.",
    "page.data-model.dimensions.precedence.title": "Spend classification resolves in a fixed order",
    "page.data-model.dimensions.precedence.unresolved": "When no authorised resolution exists, the value remains unresolved rather than defaulting to indirect, other or zero.",
    "page.data-model.dimensions.tenant-values": "Tenant-controlled taxonomy records",
    "page.data-model.dimensions.title": "Five questions stay independent",
    "page.data-model.explore.catalogue.context": "Search every record type, field, relationship, owner and projection contract.",
    "page.data-model.explore.catalogue.label": "Data catalogue",
    "page.data-model.explore.category.context": "Inspect the tenant-taxonomy record and its links to versions and external classifications.",
    "page.data-model.explore.category.label": "Category",
    "page.data-model.explore.decision.context": "Follow proposal, authority, evidence, commitment, correction and predecessor fields.",
    "page.data-model.explore.decision.label": "Spend classification decision",
    "page.data-model.explore.description": "The data catalogue exposes every projected record, field, relationship, dimension and standards mapping. Counts and examples on this page lead back to those records.",
    "page.data-model.explore.standards.context": "See where external document and code-list standards meet canonical records.",
    "page.data-model.explore.standards.label": "Standards mappings",
    "page.data-model.explore.title": "Open the exact contract behind the explanation",
    "page.data-model.explore.trail-label": "Explore the GroundWorks data catalogue",
    "page.data-model.eyebrow": "GroundWorks data model",
    "page.data-model.section.ai-readiness": "Made for AI from the first definition",
    "page.data-model.section.dimensions": "Independent procurement dimensions",
    "page.data-model.section.explore": "Explore the records",
    "page.data-model.section.proven-boundary": "The proved boundary",
    "page.data-model.section.semantic-rules": "Semantic names and traversal",
    "page.data-model.section.structure": "Structure",
    "page.data-model.section.workblock-compatibility": "Workblock compatibility",
    "page.data-model.semantic.description": "A stable identifier tells a reader and a machine what kind of thing it names. Field shape, target and lifecycle remain explicit rather than being inferred from prose.",
    "page.data-model.semantic.relationship.body": "This live slice of the catalogue starts at a spend classification decision. Each edge names its predicate, exact join fields and cardinality, so a consumer does not have to infer the path.",
    "page.data-model.semantic.relationship.cardinality-label": "Cardinality",
    "page.data-model.semantic.relationship.example-label": "Typed relationship example",
    "page.data-model.semantic.relationship.join-label": "Join",
    "page.data-model.semantic.relationship.title": "A relationship is a traversable contract",
    "page.data-model.semantic.rule.entity.body": "Entity IDs are flat, globally unique and lower kebab-case. A derived namespace may add context but never replaces the stable ID.",
    "page.data-model.semantic.rule.entity.title": "Stable entity IDs",
    "page.data-model.semantic.rule.lifecycle.body": "Every durable record names its lifecycle field and allowed states. Absence, status text and process position never stand in for lifecycle.",
    "page.data-model.semantic.rule.lifecycle.title": "Lifecycle is carried, not guessed",
    "page.data-model.semantic.rule.polymorphic.body": "A -ref or -refs field carries a closed list of allowed record types rather than an unbounded object pointer.",
    "page.data-model.semantic.rule.polymorphic.title": "Polymorphism stays typed",
    "page.data-model.semantic.rule.primary-key.body": "Every primary key uses the entity ID followed by -id, so identity is mechanically checkable.",
    "page.data-model.semantic.rule.primary-key.title": "Keys repeat the record name",
    "page.data-model.semantic.rule.reference.body": "A monomorphic reference ends in -id for one target or -ids for a set of targets.",
    "page.data-model.semantic.rule.reference.title": "References declare one or many",
    "page.data-model.semantic.rule.vocabulary.body": "Fields and nested properties carry definitions, classifications and source authority. Closed concepts use enumerated values; an open vocabulary needs an explicit reason.",
    "page.data-model.semantic.rule.vocabulary.title": "Vocabulary is explicit",
    "page.data-model.semantic.title": "Names carry rules, not just labels",
    "page.data-model.structure.description": "The model separates stable framework meaning from tenant records and their governed projections. Each layer has one job and one authority boundary.",
    "page.data-model.structure.exchange.body": "The owning Workblock is the target authority for tenant records. Bounded interfaces and approved read models carry projections without redefining the record.",
    "page.data-model.structure.exchange.title": "Owner and projection boundary",
    "page.data-model.structure.fact.dimensions": "independent dimensions",
    "page.data-model.structure.fact.fields": "top-level fields",
    "page.data-model.structure.fact.records": "record types",
    "page.data-model.structure.figure-label": "GroundWorks semantic data-model structure",
    "page.data-model.structure.figure-lead": "The structure is a graph of record contracts, not a shared procurement database.",
    "page.data-model.structure.graph.body": "Predicate, source field, target field, cardinality and inverse metadata turn references into deterministic traversal paths.",
    "page.data-model.structure.graph.title": "Typed relationship graph",
    "page.data-model.structure.record.body": "Each record type declares stable identity, fields, value rules, owner, lifecycle, retention, provenance, freshness and access.",
    "page.data-model.structure.record.title": "Record contracts",
    "page.data-model.structure.semantic.body": "Governed vocabulary, standards and independent dimensions establish what each procurement concept means.",
    "page.data-model.structure.semantic.title": "Semantic foundation",
    "page.data-model.structure.title": "One semantic graph connects definitions, records and exchange",
    "page.data-model.title": "Procurement meaning that people and agents can follow.",
    "page.data-model.workblock.definition.body": "Git-versioned framework JSON owns stable identifiers, semantic schemas, relationships, audience policy and projection rules.",
    "page.data-model.workblock.definition.title": "Canonical definitions",
    "page.data-model.workblock.description": "GroundWorks and the governed Workblock direction share the same ownership rule: one definition, one authoritative record owner and bounded projections for exchange.",
    "page.data-model.workblock.note": "Compatibility is implemented at the definition and portable-package boundary. Runtime datastore, permission and lake behaviour remains subject to the proof boundary below.",
    "page.data-model.workblock.owner.body": "The schema-first target gives each company or tenant record to one Workblock datastore. Other Workblocks use the owner's bounded interface rather than mutating its storage.",
    "page.data-model.workblock.owner.title": "Owning Workblock",
    "page.data-model.workblock.projection.body": "APIs, events, search indexes, audience snapshots and lake datasets are projections. They may carry or read meaning but never become a second source of truth.",
    "page.data-model.workblock.projection.title": "Exchange and read models",
    "page.data-model.workblock.title": "Aligned with the Workblock data contract",
    "page.design.accessibility.description": "Meaning remains available across keyboard, visual and assistive reading paths. Structure, focus, labels and reflow carry the same reading order.",
    "page.design.accessibility.keyboard": "Keyboard order, visible focus and focus return follow the same path as the interface.",
    "page.design.accessibility.meaning": "Words reinforce every meaningful colour, glyph and state distinction.",
    "page.design.accessibility.reading": "Text enlargement, fallback fonts and reflow preserve the content and its hierarchy.",
    "page.design.accessibility.structure": "Semantic headings and landmarks preserve a clear reading order.",
    "page.design.accessibility.title": "Access is part of the structure",
    "page.design.catalogue.accessibility": "Keyboard and assistive behaviour",
    "page.design.catalogue.anatomy": "Anatomy",
    "page.design.catalogue.component-count": "{count} components",
    "page.design.catalogue.contract-summary": "Contract and options",
    "page.design.catalogue.copied-code": "Code copied",
    "page.design.catalogue.copied-prompt": "Design prompt copied",
    "page.design.catalogue.copy-code": "Copy code",
    "page.design.catalogue.copy-failed": "Copy failed. Try again",
    "page.design.catalogue.copy-prompt": "Copy design prompt",
    "page.design.catalogue.current-surface": "Rendered on this page",
    "page.design.catalogue.design-prompt": "Framework design prompt",
    "page.design.catalogue.failure": "Failure behaviour",
    "page.design.catalogue.index-label": "Design element catalogue",
    "page.design.catalogue.linked": "Shown in working context",
    "page.design.catalogue.open-example": "Open the working example",
    "page.design.catalogue.reference-artifacts": "Reference artefacts",
    "page.design.catalogue.reference-code": "Reference code",
    "page.design.catalogue.states": "States",
    "page.design.catalogue.variants": "Variants",
    "page.design.category.catalogue.description": "Rows, cards, disclosures and facets for finding a bounded framework record without hiding its canonical route.",
    "page.design.category.catalogue.title": "Catalogues and records",
    "page.design.category.evidence.description": "Ruled facts, figures and comparisons that make the mechanism and its supporting readings inspectable.",
    "page.design.category.evidence.title": "Evidence and comparison",
    "page.design.category.framework.description": "Large compositions that connect capabilities, modules, evidence and human authority across the framework.",
    "page.design.category.framework.title": "Framework maps and supervision",
    "page.design.category.identity.description": "The mark, lockup and semantic glyph layer that keep identity and meaning distinct.",
    "page.design.category.identity.title": "Identity and symbols",
    "page.design.category.orientation.description": "The shell, headings, place lines and onward routes that tell a reader where they are and where they can go.",
    "page.design.category.orientation.title": "Navigation and orientation",
    "page.design.category.state.description": "Truthful loading, absence, collection and implementation states, always carried in words as well as form.",
    "page.design.category.state.title": "State and feedback",
    "page.design.choice.access.body": "The conversational way in is an access surface composed from what already exists: governed agents and their declared tasks, personas, the approval queue and the authority ladder. It answers from records, proposes bounded actions and leaves every commit to a named person, so it is neither another dashboard nor an ungoverned chat surface.",
    "page.design.choice.access.title": "The way in inherits, never bypasses",
    "page.design.choice.agency.body": "A Workblock states who may propose, approve, commit, pause, retry, reverse and revoke. Relevant blocked actions explain the route forward.",
    "page.design.choice.agency.title": "Human authority stays explicit",
    "page.design.choice.complexity.body": "Five business modules share domain context inside one independently versioned Workblock, while specialist systems keep their defined responsibilities.",
    "page.design.choice.complexity.title": "One cohesive Workblock boundary",
    "page.design.choice.conditions.body": "Navigation becomes a focus-managed drawer, reading structures stack and labels wrap. Smaller space changes composition, not capability or meaning.",
    "page.design.choice.conditions.title": "Meaning survives the container",
    "page.design.choice.content.body": "Audience, locale and partner expression can change while each outcome, role and relationship keeps one stable meaning across the framework.",
    "page.design.choice.content.title": "Language can change without changing meaning",
    "page.design.choice.intent.body": "A Workblock starts with an accountable outcome. Its roles, records, evidence and controls stay organised around that outcome.",
    "page.design.choice.intent.title": "One outcome before one screen",
    "page.design.choice.structure.body": "Ruled indexes, one content rail and one statement plane establish hierarchy without stacking decorative containers or competing accents.",
    "page.design.choice.structure.title": "Rules replace card walls",
    "page.design.choice.truth.body": "Implementation, evidence, freshness and authority remain separate dimensions. A successful task does not silently become an approved or committed outcome.",
    "page.design.choice.truth.title": "Proposal never reads as commitment",
    "page.design.choice.validation.body": "Every shared interaction names its purpose, states, keyboard path and failure conditions, so teams can test whether it supports the procurement work.",
    "page.design.choice.validation.title": "Quality stays observable",
    "page.design.choices.description": "Each choice protects a procurement meaning. Accenture's expression stays distinctive without changing the outcome, state or authority the interface communicates.",
    "page.design.choices.title": "GroundWorks turns principles into system choices",
    "page.design.contents-label": "GroundWorks design topics",
    "page.design.continue.description": "See how the same language carries the lifecycle, the modular units and the platform foundation.",
    "page.design.continue.framework.context": "See five lifecycle stages, nine domain Workblocks and their shared foundation.",
    "page.design.continue.framework.label": "Framework",
    "page.design.continue.platform.context": "Inspect the governed foundation that connects Workblocks to enterprise systems.",
    "page.design.continue.platform.label": "Platform",
    "page.design.continue.title": "Follow the system into the framework",
    "page.design.continue.trail-label": "Continue exploring GroundWorks",
    "page.design.continue.workblocks.context": "Open the independently versioned units that carry outcomes, records and authority.",
    "page.design.continue.workblocks.label": "Workblocks",
    "page.design.description": "GroundWorks uses one visual and interaction language to make outcomes, evidence, authority and change understandable across the framework. Accenture gives that language a distinctive expression while each meaning remains stable.",
    "page.design.doctrine.download": "Download the app design doctrine (design.md)",
    "page.design.eyebrow": "GroundWorks design",
    "page.design.intent.body": "Procurement work crosses records, systems and owners. GroundWorks gives that complexity a legible structure, so a reader can see what is being decided, what supports it and where human authority begins before visual expression asks for attention.",
    "page.design.intent.eyebrow": "The design intent",
    "page.design.intent.headline": "Make the consequential thing the clearest thing.",
    "page.design.principle.access.body": "A conversational way into the work carries the same rules as the work: a question gets an answer from governed records with its sources, an action stays inside declared authority, and a commitment names its owner.",
    "page.design.principle.access.title": "Govern the way in",
    "page.design.principle.agency.body": "Give people informed choices, safe alternatives and a visible route to pause, correct or recover work.",
    "page.design.principle.agency.title": "Preserve agency and recovery",
    "page.design.principle.complexity.body": "Keep the person's task coherent while the system carries cross-record, policy and integration complexity deliberately.",
    "page.design.principle.complexity.title": "Put complexity where it can be handled",
    "page.design.principle.conditions.body": "Long language, narrow screens, missing assets, stale data, delay and failure belong in the design problem from the start.",
    "page.design.principle.conditions.title": "Design for real conditions",
    "page.design.principle.content.body": "Language, order, timing, controls and system behaviour make one experience. A label cannot repair a false interaction.",
    "page.design.principle.content.title": "Treat words and interaction as one",
    "page.design.principle.intent.body": "Name the person, the procurement outcome and the consequence before choosing a surface or interaction.",
    "page.design.principle.intent.title": "Start with intent",
    "page.design.principle.structure.body": "Let hierarchy, grouping and sequence reveal what matters. Restraint keeps the exceptional thing exceptional.",
    "page.design.principle.structure.title": "Use structure to direct attention",
    "page.design.principle.truth.body": "Show authority, evidence, freshness, uncertainty and consequence as separate facts that stay legible when conditions change.",
    "page.design.principle.truth.title": "Make state truthful",
    "page.design.principle.validation.body": "Treat a design claim as a hypothesis until people can understand and use the result in the conditions where it will run.",
    "page.design.principle.validation.title": "Validate behaviour and understanding",
    "page.design.principles.description": "These decision tests keep the experience focused on useful work, truthful state and real conditions across source-to-pay.",
    "page.design.principles.title": "Eight principles shape every choice",
    "page.design.provenance.accenture.body": "Accenture brings its own visual expression while state, hierarchy and authority keep the same meaning.",
    "page.design.provenance.accenture.title": "Accenture expression",
    "page.design.provenance.description": "Portable principles become GroundWorks meanings for outcomes, records, evidence and authority. Accenture adds its own expression while those meanings remain stable.",
    "page.design.provenance.framework.body": "GroundWorks keeps the same meaning for state, hierarchy and authority across the lifecycle and every domain Workblock.",
    "page.design.provenance.framework.title": "Shared framework meaning",
    "page.design.provenance.groundworks.body": "Procurement doctrine turns those principles into an object language for outcomes, records, evidence, authority and change.",
    "page.design.provenance.groundworks.title": "GroundWorks language",
    "page.design.provenance.knowledge.body": "Broad principles establish how intent, truth, agency, structure, real conditions and validation guide a design decision.",
    "page.design.provenance.knowledge.title": "Shared principles",
    "page.design.provenance.title": "Every expression keeps its lineage",
    "page.design.read-more": "Read the design rationale",
    "page.design.responsive.comparison-title": "One information architecture, two compositions",
    "page.design.responsive.description": "The system composes for available space. It changes arrangement before it removes information, and it keeps the same routes, labels and relationships at every width.",
    "page.design.responsive.narrow-body": "Navigation moves into a modal drawer and parallel structures stack in the same reading order, with no destination or explanation deleted.",
    "page.design.responsive.narrow-label": "Narrower container",
    "page.design.responsive.title": "Responsive behaviour preserves capability",
    "page.design.responsive.wide-body": "The content rail holds grouped navigation and parallel reading structures with shared alignment.",
    "page.design.responsive.wide-label": "Wider container",
    "page.design.scope.body": "Operational work requires record-level density, truthful state, action-level authority, evidence and recovery. Those interactions belong in Accenture Agentic Procurement Platform and do not appear in the framework experience.",
    "page.design.scope.description": "The framework explains how GroundWorks organises source-to-pay. Operational workspaces carry live records, decisions and actions.",
    "page.design.scope.title": "Framework and operational work have different jobs",
    "page.design.section.accessibility": "Accessibility",
    "page.design.section.continue": "Continue",
    "page.design.section.groundworks-choices": "GroundWorks choices",
    "page.design.section.intent": "Intent",
    "page.design.section.present-scope": "Framework and operations",
    "page.design.section.principles": "Principles",
    "page.design.section.provenance": "From principle to expression",
    "page.design.section.responsive-behaviour": "Responsive behaviour",
    "page.design.section.specimens": "Components",
    "page.design.showcase.categories-label": "categories",
    "page.design.showcase.category-count": "{count} categories",
    "page.design.showcase.change-after": "One ruled frame keeps order, ownership and the next destination legible.",
    "page.design.showcase.change-after-label": "GroundWorks",
    "page.design.showcase.change-before": "Scattered examples compete for attention and hide the relationship that matters.",
    "page.design.showcase.change-before-label": "Before",
    "page.design.showcase.change-title": "Structure carries the comparison",
    "page.design.showcase.contract-authority": "Human authority remains explicit.",
    "page.design.showcase.contract-body": "Each entry pairs the admitted contract with a public reference, separate from operational build instructions.",
    "page.design.showcase.contract-label": "Reference contract",
    "page.design.showcase.contract-meaning": "Semantic roles carry meaning across themes.",
    "page.design.showcase.contract-state": "Words and rules carry state together.",
    "page.design.showcase.contract-title": "Meaning before ornament.",
    "page.design.showcase.description": "Ruled structure, semantic state and evidence cues keep the framework reading intact.",
    "page.design.showcase.evidence-label": "Evidence",
    "page.design.showcase.eyebrow": "A working frame",
    "page.design.showcase.index-label": "Design frame index",
    "page.design.showcase.lifecycle-label": "Lifecycle stages",
    "page.design.showcase.live-description": "State, evidence, comparison and relationships stay readable before a visitor opens the catalogue.",
    "page.design.showcase.live-label": "live specimens",
    "page.design.showcase.live-title": "The language in use",
    "page.design.showcase.mapping-connected": "Connected Work",
    "page.design.showcase.mapping-direct": "Direct fit",
    "page.design.showcase.mapping-label": "Related framework paths",
    "page.design.showcase.mapping-partial": "Partial fit",
    "page.design.showcase.mapping-recipe": "Integration recipes",
    "page.design.showcase.mapping-sourcing": "Sourcing and negotiation",
    "page.design.showcase.mapping-workblock": "Domain Workblock",
    "page.design.showcase.module-label": "Business modules",
    "page.design.showcase.place-cut": "Design system 3.0.0",
    "page.design.showcase.place-section": "Design reference",
    "page.design.showcase.register-label": "registers",
    "page.design.showcase.state-label": "State",
    "page.design.showcase.title": "A clear route through the interface language.",
    "page.design.showcase.workblock-label": "Domain Workblocks",
    "page.design.specimen.absence-block.eyebrow": "Reference absence",
    "page.design.specimen.absence-block.hold-label": "Admitted components",
    "page.design.specimen.absence-block.route": "Return to all components",
    "page.design.specimen.absence-block.support": "The complete admitted catalogue remains available.",
    "page.design.specimen.absence-block.title": "That component is not in this release.",
    "page.design.specimen.arrow-link-label.text": "Open the reference",
    "page.design.specimen.before-after.after": "One generated catalogue carries every admitted component and its options.",
    "page.design.specimen.before-after.after-label": "GroundWorks",
    "page.design.specimen.before-after.before": "Four isolated examples leave most component contracts hidden.",
    "page.design.specimen.before-after.before-label": "Before",
    "page.design.specimen.before-after.title": "From inventory to reference",
    "page.design.specimen.capability-mapping.connected-context": "Integration recipes",
    "page.design.specimen.capability-mapping.connected-label": "Connected Work",
    "page.design.specimen.capability-mapping.direct-fit": "Direct fit",
    "page.design.specimen.capability-mapping.label": "Related framework capabilities",
    "page.design.specimen.capability-mapping.partial-fit": "Partial fit",
    "page.design.specimen.capability-mapping.sourcing-context": "Domain Workblock",
    "page.design.specimen.capability-mapping.sourcing-label": "Sourcing and negotiation",
    "page.design.specimen.card.action": "26 components",
    "page.design.specimen.card.descriptor": "The interface language",
    "page.design.specimen.card.explainer": "Browse every admitted component and its contract.",
    "page.design.specimen.card.name": "Design",
    "page.design.specimen.catalogue-facet.clear": "Clear {label}",
    "page.design.specimen.catalogue-facet.clear-all": "Clear all",
    "page.design.specimen.catalogue-facet.clear-unavailable": "Clear unavailable",
    "page.design.specimen.catalogue-facet.label": "Register",
    "page.design.specimen.catalogue-facet.more-count": "{count} more",
    "page.design.specimen.catalogue-facet.no-options": "No registers match",
    "page.design.specimen.catalogue-facet.option-count": "{count} components",
    "page.design.specimen.catalogue-facet.option-framework": "Framework",
    "page.design.specimen.catalogue-facet.option-shared": "Shared",
    "page.design.specimen.catalogue-facet.result-count": "{count} results",
    "page.design.specimen.catalogue-facet.search": "Search {label}",
    "page.design.specimen.catalogue-facet.selected-count": "{count} selected",
    "page.design.specimen.catalogue-facet.try-again": "Try again",
    "page.design.specimen.catalogue-facet.unavailable-count": "{count} unavailable",
    "page.design.specimen.change.after": "One ruled sequence makes order, ownership and the next destination legible.",
    "page.design.specimen.change.after-label": "GroundWorks",
    "page.design.specimen.change.before": "Scattered cards compete for attention and hide which relationship matters.",
    "page.design.specimen.change.before-label": "Before",
    "page.design.specimen.change.label": "Mechanism before decoration",
    "page.design.specimen.change.title": "Structure carries the comparison",
    "page.design.specimen.context-record-preview.canonical-link": "Open role",
    "page.design.specimen.context-record-preview.detail": "Reviews proposals and approves the sourcing decision inside the declared authority boundary.",
    "page.design.specimen.context-record-preview.heading": "Category manager",
    "page.design.specimen.context-record-preview.hide-details": "Hide context",
    "page.design.specimen.context-record-preview.metadata-label": "Domain",
    "page.design.specimen.context-record-preview.metadata-value": "Sourcing and negotiation",
    "page.design.specimen.context-record-preview.show-details": "Show context",
    "page.design.specimen.context-record-preview.summary": "Owns category strategy, sourcing outcomes and supplier performance.",
    "page.design.specimen.door.line": "Follow the records, language and design contracts behind the framework.",
    "page.design.specimen.door.meta": "7 categories",
    "page.design.specimen.door.title": "Open the reference",
    "page.design.specimen.empty-state.description": "Clear the active filters to return to the complete catalogue.",
    "page.design.specimen.empty-state.title": "No matching components",
    "page.design.specimen.fact-band.label": "Framework structure",
    "page.design.specimen.fact-band.module-label": "Business modules",
    "page.design.specimen.fact-band.stage-label": "Lifecycle stages",
    "page.design.specimen.fact-band.workblock-label": "Domain Workblocks",
    "page.design.specimen.fact-row.categories-label": "categories",
    "page.design.specimen.fact-row.components-label": "components",
    "page.design.specimen.fact-row.registers-label": "registers",
    "page.design.specimen.facts.aria-label": "GroundWorks framework structure",
    "page.design.specimen.facts.body": "Counts sit in one ruled reading surface. Labels establish the denominator and the values never pretend to be controls.",
    "page.design.specimen.facts.label": "Structural facts",
    "page.design.specimen.facts.module-label": "Business modules",
    "page.design.specimen.facts.stage-label": "Lifecycle stages",
    "page.design.specimen.facts.title": "One band, not three stat cards",
    "page.design.specimen.facts.workblock-label": "Domain Workblocks",
    "page.design.specimen.figure.categories-label": "categories",
    "page.design.specimen.figure.components-label": "components",
    "page.design.specimen.figure.lead": "The catalogue in one reading",
    "page.design.specimen.glyph.body": "Canonical symbols sit beside visible labels. If an asset fails or a symbol is unfamiliar, the meaning remains.",
    "page.design.specimen.glyph.label": "Meaning with a label",
    "page.design.specimen.glyph.title": "A glyph supports the words",
    "page.design.specimen.place-line.cut": "Canonical",
    "page.design.specimen.place-line.section": "Design",
    "page.design.specimen.place-line.segment": "26 components",
    "page.design.specimen.statement-section.body": "Components bind semantic roles and retain one purpose across themes and containers.",
    "page.design.specimen.statement-section.eyebrow": "Design contract",
    "page.design.specimen.statement-section.headline": "Meaning stays stable while expression changes.",
    "page.design.specimen.status.body": "A status states its condition in text. The short rule reinforces that condition without making colour do the work alone.",
    "page.design.specimen.status.label": "Truthful state",
    "page.design.specimen.status.title": "The word carries the meaning",
    "page.design.specimen.trail.framework-context": "Return to the framework map.",
    "page.design.specimen.trail.framework-label": "Framework",
    "page.design.specimen.trail.label": "Specimen destinations",
    "page.design.specimen.trail.reference-context": "Open the governed reference.",
    "page.design.specimen.trail.reference-label": "Reference",
    "page.design.specimens.description": "Every admitted component appears once, grouped by the job it performs. Live specimens show the component where a bounded example is honest; shell-scale and full-framework components link to their working context.",
    "page.design.specimens.title": "The complete interface language",
    "page.design.title": "Design follows the procurement decision.",
    "page.downloads.body": "Each resource is generated from the published framework release. The manifest records its version, proof class, licence, compatibility and content hash.",
    "page.downloads.copied": "Copied",
    "page.downloads.copy": "Copy",
    "page.downloads.copy-failed": "Copy unavailable",
    "page.downloads.count": "{count} resources",
    "page.downloads.download": "Download",
    "page.downloads.error": "The resource catalogue is unavailable. Reload to try again.",
    "page.downloads.eyebrow": "Governed resources",
    "page.downloads.group.agent-charter-brief": "Agent charter briefs",
    "page.downloads.group.agent-charter-brief.description": "The public agent charter per module: mission, envelope, escalation and the people each agent serves.",
    "page.downloads.group.assurance-report": "Assurance reports",
    "page.downloads.group.assurance-report.description": "Adversarial reviews of the framework's semantic model, published with their method, findings and evidence citations.",
    "page.downloads.group.authoring-guide": "Workblock authoring guides",
    "page.downloads.group.authoring-guide.description": "The governed branding and architecture paths for authoring inside Studio or outside the platform.",
    "page.downloads.group.authoring-kit": "Claude Code authoring kit",
    "page.downloads.group.authoring-kit.description": "The dependency-free read-only MCP server, complete permitted asset index, setup guide and generated skills in one deterministic archive.",
    "page.downloads.group.authoring-prompt": "Copy-paste authoring prompts",
    "page.downloads.group.authoring-prompt.description": "The complete Claude Code and platform prompt for each guide as Markdown.",
    "page.downloads.group.authoring-skill": "Claude Code skills",
    "page.downloads.group.authoring-skill.description": "Two generated skills that route design and architecture work to the matching guide and MCP assets.",
    "page.downloads.group.data-dictionary": "Data dictionary",
    "page.downloads.group.data-dictionary.description": "Every published entity and field in one readable reference.",
    "page.downloads.group.design-component": "Design components",
    "page.downloads.group.design-component.description": "Reference TSX usage and the design prompt for every admitted component.",
    "page.downloads.group.design-doctrine": "App design doctrine",
    "page.downloads.group.design-doctrine.description": "The complete app and Workblock design language as one markdown file: the object language, desk postures, state model and authority grammar.",
    "page.downloads.group.entity-schema": "Data entity schemas",
    "page.downloads.group.entity-schema.description": "One JSON Schema and one governed contract per published entity.",
    "page.downloads.group.framework-brief": "Framework briefs",
    "page.downloads.group.framework-brief.description": "Cross-domain decision journeys assembled from governed story records: owners, records, authority boundaries, handoffs and the system-of-record boundary.",
    "page.downloads.group.integration-recipe": "Integration recipes",
    "page.downloads.group.integration-recipe.description": "Each governed recipe contract as JSON, YAML and a readable summary.",
    "page.downloads.group.module-design-brief": "Module design briefs",
    "page.downloads.group.module-design-brief.description": "A site-safe design brief for each business module: its one governed job, approved subordinate jobs, authority, records and measures.",
    "page.downloads.group.outcome-tool-recipe": "Outcome-tool recipes",
    "page.downloads.group.outcome-tool-recipe.description": "The governed outcome-tool contract per module, with its action class, authority ceiling and related recipes.",
    "page.downloads.group.workblock-design-prompt": "Workblock design prompts",
    "page.downloads.group.workblock-design-prompt.description": "A public design prompt for each domain Workblock, derived from its published contract.",
    "page.downloads.group.workblock-starter": "Workblock starters",
    "page.downloads.group.workblock-starter.description": "Generated authoring starters with manifest, schema, task stubs, README and fixtures.",
    "page.downloads.hash-label": "SHA-256",
    "page.downloads.headline": "Take the framework away as working material.",
    "page.downloads.licence-label": "Licence",
    "page.downloads.loading": "Loading the resource catalogue.",
    "page.downloads.proof-label": "Proof",
    "page.downloads.route-label": "Open the canonical record",
    "page.downloads.version-label": "Version",
    "page.faqs.description": "Direct answers on the framework, Workblocks, speed, agents, data, Microsoft 365, integration and trust.",
    "page.faqs.eyebrow": "Questions",
    "page.faqs.title": "What evaluation teams ask first.",
    "page.glossary.description": "The words the platform uses, defined once and used everywhere.",
    "page.glossary.eyebrow": "Shared language",
    "page.glossary.title": "One vocabulary across source-to-pay.",
    "page.groundworks.description": "Search canonical entities, fields, relationships, ownership and standards mappings across all nine domain Workblocks.",
    "page.groundworks.eyebrow": "Versioned data catalogue",
    "page.groundworks.title": "One governed language for every procurement record.",
    "page.jobs.description": "Browse the bounded progress each business module owns and open the situations that make the job difficult.",
    "page.jobs.eyebrow": "Reference",
    "page.jobs.title": "Jobs to be done",
    "page.landscape.description": "How the platform runs beside your ERP, warehouse, Microsoft 365 and procurement suites, domain by domain.",
    "page.language.audience.category.job": "Run a sourcing event from approved need to authorised award when the evidence that decides it sits in more than one system.",
    "page.language.audience.category.label": "Category and sourcing leads",
    "page.language.audience.category.measured": "Source-to-contract cycle time · savings by stage: identified, negotiated, implemented, realised · contract compliance rate · addressable spend covered by a category strategy.",
    "page.language.audience.finance.job": "Make a savings number reproducible from the records that produced it, before anyone reports it.",
    "page.language.audience.finance.label": "Finance",
    "page.language.audience.finance.measured": "Realised savings validated in the accounts · savings realisation rate against the agreed baseline · budget adherence · days payable outstanding · cost per invoice.",
    "page.language.audience.leadership.job": "Move one material process into a new operating model without weakening the categories, suppliers and systems the organisation already relies on.",
    "page.language.audience.leadership.label": "Procurement leadership",
    "page.language.audience.leadership.measured": "Spend under management · savings realisation rate · cost savings as a percentage of spend · procurement cost as a percentage of spend · continuity of supply.",
    "page.language.audience.operations.job": "Resolve an invoice or order exception before the payment run, when the documents no longer agree.",
    "page.language.audience.operations.label": "Operational procurement",
    "page.language.audience.operations.measured": "Touchless invoice rate with its denominator · invoice exception rate · first-time match rate · requisition-to-order cycle time · cost per invoice.",
    "page.language.audience.requesters.job": "Turn an expressed need into an accepted buying route, when the requester does not know the procurement path.",
    "page.language.audience.requesters.label": "Requesters and budget owners",
    "page.language.audience.requesters.measured": "Time to an approved outcome · requests completed without rework · share of orders placed on a catalogue or an agreed framework.",
    "page.language.audience.suppliers.job": "Tell a supplier when an invoice pays and what is holding it, without them contacting anyone.",
    "page.language.audience.suppliers.label": "Suppliers",
    "page.language.audience.suppliers.measured": "Percentage of payments made in 30 days or fewer, in 31 to 60 days and in 61 days or longer, and the percentage not paid within the agreed period: the United Kingdom statutory disclosure set · on-time payment rate · queries resolved without contact.",
    "page.language.audience.technology.job": "Prove the boundary an agent works inside, and hand an auditor the evidence of it.",
    "page.language.audience.technology.label": "Technology, security and compliance",
    "page.language.audience.technology.measured": "Agent permissions and authority levels · audit coverage of mutating calls · log retention · data residency · model change control.",
    "page.language.audiences.description": "Every capability is stated in the measures the reader is held to. A line that cannot be read in the reader's own numbers is cut rather than softened.",
    "page.language.audiences.heading": "Written for the person who answers for it",
    "page.language.audiences.keywords": "audiences roles chief procurement officer category manager buyer accounts payable finance requester supplier security compliance",
    "page.language.buyer-term.addressable-spend.label": "Addressable spend",
    "page.language.buyer-term.addressable-spend.meaning": "The spend procurement can in principle influence, and the base under most coverage figures. It excludes taxes, payroll and some regulated categories.",
    "page.language.buyer-term.addressable-spend.owner": "Category manager, spend analyst",
    "page.language.buyer-term.baseline.label": "Baseline",
    "page.language.buyer-term.baseline.meaning": "The agreed reference price or cost a saving is measured against: historic, budget, market or technical.",
    "page.language.buyer-term.baseline.owner": "Procurement finance, with the chief financial officer's team",
    "page.language.buyer-term.bid-tabulation.label": "Bid tabulation · bid analysis",
    "page.language.buyer-term.bid-tabulation.meaning": "Bids assembled into one comparable grid and evaluated against the stated requirements.",
    "page.language.buyer-term.bid-tabulation.owner": "Sourcing analyst",
    "page.language.buyer-term.category-strategy.label": "Category strategy",
    "page.language.buyer-term.category-strategy.meaning": "A long-term plan for one category: demand, supply market, risk and value opportunity. Explicitly not a sourcing plan and not a single negotiation.",
    "page.language.buyer-term.category-strategy.owner": "Category manager, category council",
    "page.language.buyer-term.contract-compliance.label": "Contract compliance · contract utilisation",
    "page.language.buyer-term.contract-compliance.meaning": "Buying on the agreed terms and prices, against whether the committed volume actually materialised. Two different measures.",
    "page.language.buyer-term.contract-compliance.owner": "Chief procurement officer, category manager, internal audit",
    "page.language.buyer-term.cost-per-invoice.label": "Cost per invoice · cost per purchase order",
    "page.language.buyer-term.cost-per-invoice.meaning": "The fully loaded cost to process one invoice or one order, counting personnel, systems and overhead.",
    "page.language.buyer-term.cost-per-invoice.owner": "Accounts payable director, shared services, benchmarking analyst",
    "page.language.buyer-term.doa.label": "Delegation of authority matrix",
    "page.language.buyer-term.doa.meaning": "The formal document setting which role may approve at which threshold, what happens when an approver is away, and who granted the authority.",
    "page.language.buyer-term.doa.owner": "Chief financial officer, controller, internal audit",
    "page.language.buyer-term.dpo.label": "Days payable outstanding · on-time payment",
    "page.language.buyer-term.dpo.meaning": "The average days taken to pay suppliers, and the share paid by the due date. In the United Kingdom the payment set is a statutory disclosure a director approves.",
    "page.language.buyer-term.dpo.owner": "Treasurer, chief financial officer, accounts payable manager",
    "page.language.buyer-term.evergreen.label": "Evergreen contract · notice period",
    "page.language.buyer-term.evergreen.meaning": "An agreement that renews automatically until it is terminated, and the written-notice window before that date.",
    "page.language.buyer-term.evergreen.owner": "Procurement, contract manager, legal",
    "page.language.buyer-term.first-time-match.label": "First-time match rate",
    "page.language.buyer-term.first-time-match.meaning": "The share of invoices that clear three-way match with no rework.",
    "page.language.buyer-term.first-time-match.owner": "Accounts payable manager",
    "page.language.buyer-term.goods-receipt.label": "Goods receipt · service entry sheet",
    "page.language.buyer-term.goods-receipt.meaning": "The posting that ordered goods arrived, and the approved record that a service was delivered.",
    "page.language.buyer-term.goods-receipt.owner": "Receiver, requester, accounts payable",
    "page.language.buyer-term.guided-buying.label": "Guided buying",
    "page.language.buyer-term.guided-buying.meaning": "A channel where a requester states a need and the system routes them to the compliant path: catalogue, punchout, form or event. Originally an SAP Ariba product name, now used generally.",
    "page.language.buyer-term.guided-buying.owner": "Requester, procurement enablement lead",
    "page.language.buyer-term.match-tolerance.label": "Match tolerance · tolerance hold",
    "page.language.buyer-term.match-tolerance.meaning": "The variance within which an invoice passes without review, and the status it takes when it does not. Tolerance hold is one suite vendor's status label: fair for describing the client's current world, never one of our own state names.",
    "page.language.buyer-term.match-tolerance.owner": "Accounts payable systems administrator, controller",
    "page.language.buyer-term.obligation.label": "Obligation · entitlement",
    "page.language.buyer-term.obligation.meaning": "What you owe under the contract, and what you are owed under it.",
    "page.language.buyer-term.obligation.owner": "Contract manager, commercial, delivery",
    "page.language.buyer-term.off-contract-spend.label": "Off-contract spend",
    "page.language.buyer-term.off-contract-spend.meaning": "Buying from a supplier outside a negotiated agreement: the narrow case and the transaction-level inverse of spend under management. Write the wider breach as a policy exception, which names the rule without blaming the buyer.",
    "page.language.buyer-term.off-contract-spend.owner": "Chief procurement officer, category manager, internal audit",
    "page.language.buyer-term.playbook.label": "Playbook · fallback position",
    "page.language.buyer-term.playbook.meaning": "Pre-approved alternative clause language, ranked in order, with the rationale, the approval rule and the escalation path.",
    "page.language.buyer-term.playbook.owner": "Legal operations, procurement",
    "page.language.buyer-term.redline-turn.label": "Redline · turn",
    "page.language.buyer-term.redline-turn.meaning": "A marked-up revision, and one exchange of a version out and back. Turns are counted during a negotiation.",
    "page.language.buyer-term.redline-turn.owner": "Legal, deal desk, procurement",
    "page.language.buyer-term.savings-realisation.label": "Savings realisation rate",
    "page.language.buyer-term.savings-realisation.meaning": "Realised savings divided by identified savings, or by negotiated savings. The two versions of the rate are far apart.",
    "page.language.buyer-term.savings-realisation.owner": "Chief procurement officer, chief financial officer",
    "page.language.buyer-term.savings-stages.label": "Identified · negotiated · implemented · realised",
    "page.language.buyer-term.savings-stages.meaning": "The four savings stages: value at analysis, value at signature, rates loaded and buyable, and value finance has validated in the accounts.",
    "page.language.buyer-term.savings-stages.owner": "Category manager through to the controller",
    "page.language.buyer-term.should-cost.label": "Should-cost analysis",
    "page.language.buyer-term.should-cost.meaning": "The expected price built bottom-up from material, labour, process and overhead, rather than from the quoted price or from history.",
    "page.language.buyer-term.should-cost.owner": "Cost engineer, category manager",
    "page.language.buyer-term.sourcing-event.label": "Sourcing event",
    "page.language.buyer-term.sourcing-event.meaning": "One competitive exercise run to select suppliers, with its type, its window and its participants.",
    "page.language.buyer-term.sourcing-event.owner": "Sourcing manager, supplier",
    "page.language.buyer-term.spend-under-management.label": "Spend under management",
    "page.language.buyer-term.spend-under-management.meaning": "The share of spend procurement actively governs, whether sourced by procurement or bought through a compliant channel. The denominator is contested: some sources divide by total spend, some by addressable spend.",
    "page.language.buyer-term.spend-under-management.owner": "Chief procurement officer, to the chief financial officer and the board",
    "page.language.buyer-term.supplier-onboarding.label": "Supplier onboarding",
    "page.language.buyer-term.supplier-onboarding.meaning": "Qualifying a supplier, collecting documentation, verifying compliance and risk standards, and setting the supplier up to transact.",
    "page.language.buyer-term.supplier-onboarding.owner": "Supplier management lead, risk, finance",
    "page.language.buyer-term.three-way-match.label": "Three-way match",
    "page.language.buyer-term.three-way-match.meaning": "The invoice matched to the purchase order and to the goods receipt before payment is authorised.",
    "page.language.buyer-term.three-way-match.owner": "Accounts payable clerk, controller, auditor",
    "page.language.buyer-term.touchless.label": "Touchless invoice rate · straight-through processing",
    "page.language.buyer-term.touchless.meaning": "The share of invoices received, validated, matched and approved without a person touching them. Vendors compute the denominator differently.",
    "page.language.buyer-term.touchless.owner": "Accounts payable manager, shared services director",
    "page.language.buyer-term.value-leakage.label": "Value leakage · slippage",
    "page.language.buyer-term.value-leakage.meaning": "The gap between identified and realised savings, and its causes: late implementation, buying from the old supplier, volume and specification change, timing.",
    "page.language.buyer-term.value-leakage.owner": "Chief procurement officer, finance",
    "page.language.description": "Two registers, one platform. The framework register argues the model with mechanisms. The application register states what happened, what may follow and who decides. One word carries one meaning in both.",
    "page.language.eyebrow": "How the platform speaks",
    "page.language.glossary.keywords": "glossary terms definitions words vocabulary reference build defined module roadmap module systems of work",
    "page.language.label.in-a-sentence": "In a sentence",
    "page.language.label.measured": "Measured on",
    "page.language.pattern.accountability.body": "The agent produces the draft and the named role commits it. Framing an agent as an employee reduced managers' error detection and moved accountability away from the individual (Kropp and others, Harvard Business Review, 2026).",
    "page.language.pattern.accountability.label": "Assign accountability to a person, never to the agent.",
    "page.language.pattern.ceiling.body": "Every statement about autonomy carries its ceiling in the same sentence, so capability and permission are read together.",
    "page.language.pattern.ceiling.label": "State the authority ceiling before the capability.",
    "page.language.pattern.consistency.body": "One figure, one denominator, one source, unchanged across the page, the document and the meeting.",
    "page.language.pattern.consistency.label": "Say the same number everywhere.",
    "page.language.pattern.decision.body": "State the decision the work turns on, in the reader's own words. Concrete language raises satisfaction, because the reader infers that the need was understood (Packard and Berger, Journal of Consumer Research, 2021).",
    "page.language.pattern.decision.label": "Name the decision, not the model.",
    "page.language.pattern.denominator.body": "State the population, the period and the baseline beside the figure. A percentage with no baseline is a mood.",
    "page.language.pattern.denominator.label": "Quantify with a denominator, or drop the number.",
    "page.language.pattern.derivation.body": "A score opens the inputs behind it. Explainability, rather than use on its own, is what carries trust in procurement work that AI supports (Mejri and Skhiri, Frontiers in Artificial Intelligence, 2026).",
    "page.language.pattern.derivation.label": "Show the derivation, not the verdict.",
    "page.language.pattern.edit.body": "People chose an imperfect model more often, and performed better with it, when they could change its output (Dietvorst, Simmons and Massey, Management Science, 2018).",
    "page.language.pattern.edit.label": "Sell the edit, not the answer.",
    "page.language.pattern.gap.body": "Start from the cost of the current arrangement, in the client's own measures, rather than from what the technology promises.",
    "page.language.pattern.gap.label": "Price the gap the client already carries.",
    "page.language.pattern.judgement.body": "State what the person still decides, and the practice that keeps that judgement sharp.",
    "page.language.pattern.judgement.label": "Speak to the job at risk, not the job replaced.",
    "page.language.pattern.redesign.body": "Across the attributes tested in a large survey of AI adoption, redesigning the workflow had the largest effect on realised earnings (McKinsey, The state of AI, 2025).",
    "page.language.pattern.redesign.label": "Name the redesign, because the tool is not the value.",
    "page.language.pattern.reversal.body": "Committed at a stated time, reversible until a stated event, with the undo and the people notified both named.",
    "page.language.pattern.reversal.label": "Publish the reversal path with the action.",
    "page.language.pattern.sequence.body": "Start on one narrow, repeatable process with a manageable error cost, and widen authority as the record accumulates.",
    "page.language.pattern.sequence.label": "Sequence contact before conviction.",
    "page.language.patterns.description": "Twelve moves. Each one replaces a statement about the technology with something the reader can check.",
    "page.language.patterns.heading": "How a technical fact becomes a business fact",
    "page.language.patterns.keywords": "translation patterns business impact technology explanation",
    "page.language.refusal.authority.body": "Every action carries the authority level that permits it and the role that holds the gate. No composite figure stands in for permission, and no level is presented as better than the one below it.",
    "page.language.refusal.authority.eyebrow": "Authority",
    "page.language.refusal.authority.label": "Authority is a contract, not a score.",
    "page.language.refusal.blocked.body": "The screen names the action, the condition that blocks it, the authority that owns the decision, what the person can do instead, and whether their work was kept. A hidden action is not a governed one.",
    "page.language.refusal.blocked.eyebrow": "Blocked work",
    "page.language.refusal.blocked.label": "A blocked action names its way out.",
    "page.language.refusal.state.body": "Committed appears once the confirming source returns, and not before. Where the outcome is not yet known, the screen states the last confirmed stage and the step that reconciles it, so it reads as neither success nor failure.",
    "page.language.refusal.state.eyebrow": "State",
    "page.language.refusal.state.label": "No state word runs ahead of the effect.",
    "page.language.refusals.description": "Each of these is a commitment the client can hold the platform to.",
    "page.language.refusals.heading": "What no screen says",
    "page.language.refusals.keywords": "refusals commitments authority state blocked action",
    "page.language.registers.app.body": "This register is functional. It names the state, the evidence beside it, the authority that applies and the action that moves the work. It carries no argument and no comparison, because a person in the middle of a task is deciding rather than evaluating.",
    "page.language.registers.app.eyebrow": "Application register",
    "page.language.registers.app.headline": "Screens state what is true, then what to do next.",
    "page.language.registers.description": "Each screen speaks one register from end to end. A working screen keeps the application register even where a client opens it from a framework page.",
    "page.language.registers.framework.body": "This register argues the model: what the platform is, how a change ships, and what the client owns afterwards. A line ships only where the fact under it survives in a technical document without a hedge. A figure ships with its source, its date and the population it was measured over.",
    "page.language.registers.framework.eyebrow": "Framework register",
    "page.language.registers.framework.headline": "Every claim names the mechanism under it.",
    "page.language.registers.heading": "Two registers, one platform",
    "page.language.registers.keywords": "language voice register tone wording",
    "page.language.term.agent.body": "The machine actor is named by what governs it: a grant, an authority level and one named action. It is never named after another company's product, and never called a colleague, a teammate or an employee.",
    "page.language.term.agent.label": "Governed procurement agent",
    "page.language.term.agent.worked": "The triage agent holds a grant to propose a match resolution up to the stated tolerance, and it commits nothing.",
    "page.language.term.exception.body": "An exception is a record that breaks a rule and holds work. It is called an error only where the platform itself failed, because the two need different people and different fixes.",
    "page.language.term.exception.label": "Exception",
    "page.language.term.exception.worked": "The invoice is an exception on a quantity difference: the platform did not fail, the documents disagree.",
    "page.language.term.proposal.body": "Two words for two states. A proposal has committed nothing and can still be changed or dropped. A commitment is a durable effect that exists only after the required authority and the confirming record.",
    "page.language.term.proposal.label": "Proposal and commitment",
    "page.language.term.proposal.worked": "The agent has proposed a credit note; the controller commits it, and the commitment exists once the ledger confirms it.",
    "page.language.term.rails.body": "The runtime foundation is named in full, and only where architecture or trust is the subject. Everywhere else the property belongs to the platform the client buys.",
    "page.language.term.rails.label": "Beyond Work execution rails",
    "page.language.term.rails.worked": "The platform runs on Beyond Work execution rails, which is stated here because the subject of the paragraph is the architecture.",
    "page.language.term.system-of-work.body": "The coherent operating experience delivered by one domain Workblock. It is never another hierarchy level, suite or product line: a suite changes on its vendor's release cycle, and a system of work changes on the client's.",
    "page.language.term.system-of-work.label": "System of work",
    "page.language.term.system-of-work.worked": "Invoicing & Payment is the system of work for invoice and payment readiness: one domain Workblock, five business modules and one outcome.",
    "page.language.term.workblock.body": "One word for the governed unit of work, capital W, singular and plural. It is never a module, an app or a feature, because those words hide the version and the change process behind them.",
    "page.language.term.workblock.label": "Workblock",
    "page.language.term.workblock.worked": "The invoice exception Workblock moved to version 4 on the recorded date, and the previous version can be restored.",
    "page.language.terms.description": "These are the buyer's words, not ours. Use each one as the function that owns it uses it, then say what the platform adds inside that same term. Where a term is a vendor or analyst coinage, it is marked and the plain phrasing is safer. Name the measure, never another organisation's number.",
    "page.language.terms.heading": "The buyer's terms",
    "page.language.terms.keywords": "procurement terminology domain vocabulary spend under management off-contract spend three-way match tolerance touchless savings realisation baseline redline obligation evergreen guided buying goods receipt days payable outstanding",
    "page.language.terms.table.meaning": "What it means as used",
    "page.language.terms.table.owner": "Who owns the word",
    "page.language.terms.table.term": "Term",
    "page.language.title": "The platform names the decision, the authority and the evidence.",
    "page.language.vocabulary.action": "Definitions in the glossary",
    "page.language.vocabulary.description": "These words carry the same meaning on every screen, in the client's documentation and in the portable Workblock bundle. A word that changes meaning between two screens is a defect.",
    "page.language.vocabulary.heading": "One word for one thing",
    "page.language.vocabulary.keywords": "vocabulary terminology naming words definitions",
    "page.platform.runs-alongside.heading": "Runs alongside what you already own",
    "page.reference.action": "Open",
    "page.reference.count.components": "{count} components",
    "page.reference.count.jobs": "{count} jobs",
    "page.reference.count.records": "{count} records",
    "page.reference.count.roles": "{count} roles",
    "page.reference.count.terms": "{count} terms",
    "page.reference.count.work-moments": "{count} Work moments",
    "page.reference.data-catalogue.description": "Every canonical record, field, owner and standards mapping, searchable across all nine source-to-pay domains.",
    "page.reference.data-model.description": "How semantic names, typed relationships, ownership and independent procurement dimensions make one model usable by people, Workblocks and AI.",
    "page.reference.description": "The data model every Workblock writes to, the words the platform uses, and how a change reaches your platform.",
    "page.reference.design.description": "The complete component language behind the framework, grouped by purpose with live specimens, variants, states and accessibility contracts.",
    "page.reference.downloads.description": "Download or copy governed resources: Workblock starters, design prompts, component references, integration recipes and data schemas.",
    "page.reference.eyebrow": "Reference",
    "page.reference.jobs.description": "The 45 bounded jobs owned by business modules, with the situations, roles and observable finish behind each one.",
    "page.reference.language.description": "How the platform speaks on every screen, with the glossary of terms it uses.",
    "page.reference.release.description": "How a change reaches your platform: versioned, reviewable and reversible.",
    "page.reference.roles.description": "The people accountable for work across the nine domain Workblocks, with each domain mandate and authority boundary intact.",
    "page.reference.title": "The record behind the framework.",
    "page.reference.work-moments.description": "Illustrative views of a role supervising a module agent, judging exceptions and carrying reviewed work into a committed outcome.",
    "page.release.description": "Every change is deliberate, reviewable and reversible: there is no surprise release.",
    "page.release.eyebrow": "Change control",
    "page.release.record.breaking-description": "Renames are the only breaking changes in this release. Each renamed record and field is listed with its previous name, so an integration built against the predecessor can be updated by inspection.",
    "page.release.record.breaking-title": "The breaking-change boundary",
    "page.release.record.downloads-label": "Schemas and manifests",
    "page.release.record.downloads-link": "Browse the downloadable schemas and manifests",
    "page.release.record.entity-renames-label": "Renamed records",
    "page.release.record.field-renames-label": "Renamed fields",
    "page.release.record.framework-label": "Framework",
    "page.release.record.groundworks-label": "GroundWorks records",
    "page.release.record.gwod-label": "GWOD data model",
    "page.release.record.modules-label": "Business modules",
    "page.release.record.predecessor-label": "Compatible predecessor",
    "page.release.record.rollback-body": "The previous version remains in place when a new one ships. Reverting is a decision, not a project: the predecessor configuration, schemas and records stay addressable until a client retires them.",
    "page.release.record.rollback-title": "Rollback posture",
    "page.release.record.title": "The current release",
    "page.release.title": "Your platform is an exact, versioned configuration.",
    "page.roles.description": "Browse each human role once, then open its domain mandates, related jobs and Work moments.",
    "page.roles.eyebrow": "Reference",
    "page.roles.title": "Roles across source-to-pay",
    "page.search.clear-filter": "Clear filter",
    "page.search.description": "Domains, systems of work, Workblocks, capabilities, glossary terms and answers in one place.",
    "page.search.empty.description": "Try a shorter term, a Workblock, business module, flow, role or record name.",
    "page.search.empty.reference-description": "No reference build matches this search. Clear the filter or try a shorter term.",
    "page.search.empty.title": "No results for this search",
    "page.search.eyebrow": "Search",
    "page.search.form-label": "Search the framework",
    "page.search.group.business-modules": "Business modules",
    "page.search.group.connected-work": "Connected Work records",
    "page.search.group.execution-flows": "Execution flows",
    "page.search.group.faqs": "Questions answered",
    "page.search.group.groundworks-records": "GroundWorks records",
    "page.search.group.language": "Language and glossary",
    "page.search.group.office-capabilities": "Office capabilities",
    "page.search.group.roles": "Roles",
    "page.search.group.work-moments": "Work moments",
    "page.search.group.workblocks": "Workblocks",
    "page.search.kind.illustrative-example": "Illustrative example",
    "page.search.kind.integration-recipe": "Integration recipe",
    "page.search.kind.mapping-profile": "Mapping profile",
    "page.search.kind.office-capability": "Office capability",
    "page.search.kind.outcome-tool": "Outcome tool recipe",
    "page.search.kind.system-profile": "System profile",
    "page.search.placeholder": "Search Workblocks, modules, flows, roles and records",
    "page.search.reference-filter": "Reference builds only · business modules demonstrable at confirmed fidelity.",
    "page.search.result.plural": "results",
    "page.search.result.singular": "result",
    "page.search.suggestion": "Try: supplier risk · invoice intake · contract manager",
    "page.search.title": "Search across the framework.",
    "page.why-groundworks.close-body": "Accenture brings source-to-pay expertise, delivery capability and change leadership. Beyond Work execution rails provide the governed runtime foundation. GroundWorks makes that combination reusable while each client retains control of its policy, data, authority and systems.",
    "page.why-groundworks.close-title": "One execution foundation from the first Workblock to production.",
    "page.why-groundworks.connected-work-link": "See how the connection model is tailored in Connected Work",
    "page.why-groundworks.description": "Through GroundWorks, Accenture brings its source-to-pay expertise onto Beyond Work execution rails. Workblocks turn procurement processes into governed systems of work with enterprise control and one path into production.",
    "page.why-groundworks.eyebrow": "Why GroundWorks",
    "page.why-groundworks.mechanism-label": "Why the product can deliver it",
    "page.why-groundworks.open-recipe": "Open the recipe",
    "page.why-groundworks.position": "Accenture is accountable for source-to-pay design, integration and delivery. Beyond Work is accountable for the execution foundation beneath every Workblock. Together, the partners turn agentic use cases into reliable enterprise production systems, with ownership clear from first delivery through ongoing operation.",
    "page.why-groundworks.position-headline": "Agentic value from accountable partners, built for reliable enterprise production.",
    "page.why-groundworks.position-label": "The delivery partnership",
    "page.why-groundworks.proof-recipes-label": "Proof recipes",
    "page.why-groundworks.reasons-description": "Eleven differentiators connect the commercial model, platform architecture and path into production.",
    "page.why-groundworks.reasons-title": "Why Accenture is using Beyond Work execution rails",
    "page.why-groundworks.title": "Here is why Accenture is using Beyond Work execution rails for its agentic enterprise platform for source-to-pay.",
    "page.why-groundworks.value-label": "What the buyer gets",
    "page.work-moments.description": "See how a person sets intent, supervises a module agent, judges exceptions and retains the decision.",
    "page.work-moments.eyebrow": "Reference",
    "page.work-moments.title": "Work moments",
    "page.workblocks.description": "Each domain Workblock owns one outcome, cohesive experience, release and authority boundary, with five business modules inside it.",
    "page.workblocks.disclosure": "8 reference modules, 9 defined modules and 28 roadmap modules.",
    "page.workblocks.eyebrow": "Modular units of work",
    "page.workblocks.resources.components": "Design components",
    "page.workblocks.resources.components-link": "Inspect the design components this Workblock renders with",
    "page.workblocks.resources.description": "Each resource is generated from the published framework release with its version, proof class and licence recorded.",
    "page.workblocks.resources.module-prompts": "Module design briefs",
    "page.workblocks.resources.module-title": "Take this module away as working material",
    "page.workblocks.resources.open-downloads": "Open the full resource catalogue",
    "page.workblocks.resources.reference-builds": "Explore reference builds",
    "page.workblocks.resources.schemas": "Record schemas",
    "page.workblocks.resources.title": "Take this Workblock away as working material",
    "page.workblocks.resources.unavailable": "The resource catalogue is unavailable right now. The downloads page lists every governed asset.",
    "page.workblocks.title": "Workblocks turn the framework into action.",
    "partner-capability.accounts-payable-support.label": "Accounts-payable inquiry and supplier support",
    "partner-capability.area.cross-cutting": "Cross-cutting area",
    "partner-capability.area.label": "Capability area",
    "partner-capability.benefit-performance-control.label": "Benefit and performance reporting",
    "partner-capability.budget-alignment.label": "Budget alignment and scenario planning",
    "partner-capability.buying-channel-content.label": "Buying-channel and procurement-content enablement",
    "partner-capability.catalogue-management.label": "Catalogue setup and maintenance",
    "partner-capability.category-analysis.label": "Internal, external, spend and category analysis",
    "partner-capability.category-demand-stakeholder-engagement.label": "Demand management and stakeholder engagement",
    "partner-capability.category-management.label": "Category management",
    "partner-capability.category-opportunity-prioritisation.label": "Category option evaluation and prioritisation",
    "partner-capability.category-plan-development.label": "Category plan and sourcing-wave development",
    "partner-capability.category-plan-governance.label": "Category plan governance and continuous improvement",
    "partner-capability.change-continuous-improvement.label": "Change enablement and continuous improvement",
    "partner-capability.contract-administration-repository.label": "Contract administration and repository",
    "partner-capability.contract-change-closure.label": "Contract change, renewal and closure",
    "partner-capability.contract-create-approve.label": "Contract creation, review and approval",
    "partner-capability.contract-lifecycle-management.label": "Contract lifecycle management",
    "partner-capability.contract-performance-compliance.label": "Contract performance, obligation and compliance management",
    "partner-capability.count.plural": "capabilities",
    "partner-capability.count.singular": "capability",
    "partner-capability.data-insights-analytics.label": "Data, insights and analytics",
    "partner-capability.demand-planning-management.label": "Demand planning and management",
    "partner-capability.detail.description": "The Accenture capabilities that correspond to this GroundWorks scope.",
    "partner-capability.detail.heading": "Accenture capability mapping",
    "partner-capability.detailed.description": "Review every mapping in either direction: from Accenture capabilities to GroundWorks, or from GroundWorks domains, business modules and shared capabilities back to Accenture.",
    "partner-capability.detailed.eyebrow": "Complete correspondence",
    "partner-capability.detailed.title": "Detailed capability mappings",
    "partner-capability.direct-material.area.label": "Direct-material economics",
    "partner-capability.direct-material.buy-timing-mandates.label": "Buy-timing mandates",
    "partner-capability.direct-material.carbon-cost-compliance.label": "Carbon cost compliance",
    "partner-capability.direct-material.commodity-price-outlook.label": "Commodity price outlook",
    "partner-capability.direct-material.coverage-position-monitoring.label": "Coverage position monitoring",
    "partner-capability.direct-material.map.description": "Nine direct-material capabilities mapped onto the GroundWorks modules and flows that carry them. The map records framework fit and confidence; it does not assert an installed system or a client deployment.",
    "partner-capability.direct-material.map.title": "Direct-material economics capability map",
    "partner-capability.direct-material.margin-tradeoff-arbitration.label": "Margin trade-off arbitration",
    "partner-capability.direct-material.material-specification-harmonisation.label": "Material specification harmonisation",
    "partner-capability.direct-material.raw-material-demand-signalling.label": "Raw-material demand signalling",
    "partner-capability.direct-material.supplier-quality-prediction.label": "Supplier quality prediction",
    "partner-capability.direct-material.total-landed-cost-optimisation.label": "Total landed cost optimisation",
    "partner-capability.disclaimer.label": "Mapping scope",
    "partner-capability.empty.action": "Open the default map",
    "partner-capability.empty.description": "This capability map is not available in the current view.",
    "partner-capability.empty.title": "Capability map not found",
    "partner-capability.enterprise-enablers-controls.label": "Enterprise enablers and controls",
    "partner-capability.fit.cross-cutting": "Cross-cutting mapping",
    "partner-capability.fit.cross-cutting.description": "The capability is delivered through shared GroundWorks foundations across domains.",
    "partner-capability.fit.direct": "Direct mapping",
    "partner-capability.fit.direct.description": "The capability and GroundWorks target own substantially the same durable outcome.",
    "partner-capability.fit.partial": "Partial mapping",
    "partner-capability.fit.partial.description": "The capability corresponds to part of the GroundWorks target or crosses more than one target.",
    "partner-capability.goods-service-receipt.label": "Goods receipt and service entry",
    "partner-capability.groundworks.foundation": "Cross-cutting foundation",
    "partner-capability.groundworks.portfolio": "GroundWorks portfolio",
    "partner-capability.groundworks.shared": "Shared capabilities",
    "partner-capability.groundworks.workblocks": "GroundWorks Workblocks",
    "partner-capability.guided-buying-requisition.label": "Guided buying and requisition creation",
    "partner-capability.indirect-buying.area.label": "Indirect buying",
    "partner-capability.indirect-buying.buying-channel-drift-detection.label": "Buying-channel drift detection",
    "partner-capability.indirect-buying.catalogue-coverage-adoption.label": "Catalogue coverage and adoption",
    "partner-capability.indirect-buying.intake-clarification.label": "Intake clarification",
    "partner-capability.indirect-buying.map.description": "Nine indirect-buying capabilities mapped onto the GroundWorks modules and flows that carry them. The map records framework fit and confidence; it does not assert an installed system or a client deployment.",
    "partner-capability.indirect-buying.map.title": "Indirect buying capability map",
    "partner-capability.indirect-buying.off-contract-price-variance.label": "Off-contract price variance",
    "partner-capability.indirect-buying.order-and-receipt-execution.label": "Order and receipt execution",
    "partner-capability.indirect-buying.payment-terms-positioning.label": "Payment-terms positioning",
    "partner-capability.indirect-buying.requisition-policy-routing.label": "Requisition policy routing",
    "partner-capability.indirect-buying.spot-buy-conversion.label": "Spot-buy conversion",
    "partner-capability.indirect-buying.tail-spend-consolidation.label": "Tail-spend consolidation",
    "partner-capability.intake-management.label": "Intake management",
    "partner-capability.invoice-exception-resolution.label": "Invoice exception investigation and resolution",
    "partner-capability.invoice-processing-match.label": "Invoice processing, validation and matching",
    "partner-capability.invoice-receipt-capture.label": "Invoice receipt and capture",
    "partner-capability.invoicing-payment.label": "Invoicing and payment",
    "partner-capability.map.description": "One Accenture-owned capability taxonomy mapped to stable GroundWorks domains, business modules and shared capabilities.",
    "partner-capability.map.selector": "Choose capability map",
    "partner-capability.map.title": "Accenture source-to-pay capability master map",
    "partner-capability.negotiation-cost-modelling.label": "Negotiation and cost modelling",
    "partner-capability.overview.area.toggle": "Choose a capability area",
    "partner-capability.overview.description": "Select any capability to inspect its GroundWorks mapping and the status of every mapped business module without losing the complete source-to-pay view.",
    "partner-capability.overview.detail.close": "Close mapping",
    "partner-capability.overview.detail.coverage": "Highest current module status",
    "partner-capability.overview.detail.domains": "Mapped domains",
    "partner-capability.overview.detail.empty.description": "Choose a capability in the selected area to inspect its mapping and module-level implementation status.",
    "partner-capability.overview.detail.empty.title": "Select a capability",
    "partner-capability.overview.detail.mixed": "Mapped business modules have different implementation statuses. The overview shows the highest; the list below keeps every status visible.",
    "partner-capability.overview.detail.modules": "Mapped business modules",
    "partner-capability.overview.detail.no-module": "No GroundWorks business module is currently mapped. Shared capabilities describe correspondence, not an implementation build.",
    "partner-capability.overview.detail.none": "No target mapped",
    "partner-capability.overview.detail.open": "Open detailed mapping",
    "partner-capability.overview.detail.roadmap-only": "Every mapped business module is roadmap. Roadmap modules are planned and are not represented as running.",
    "partner-capability.overview.detail.shared": "Mapped shared capabilities",
    "partner-capability.overview.eyebrow": "Implementation coverage",
    "partner-capability.overview.legend.label": "Capability implementation coverage",
    "partner-capability.overview.select": "Open capability mapping",
    "partner-capability.overview.selected": "Selected",
    "partner-capability.overview.status.no-current-build.description": "Mapped modules are roadmap only, or no business module is mapped.",
    "partner-capability.overview.status.no-current-build.label": "No current build",
    "partner-capability.overview.status.pattern.description": "No reference build; at least one mapped business module is defined.",
    "partner-capability.overview.status.reference.description": "At least one mapped business module is a reference build.",
    "partner-capability.overview.status.roadmap.description": "Every mapped business module is on the roadmap.",
    "partner-capability.overview.status.roadmap.label": "Roadmap",
    "partner-capability.overview.status.unmapped.description": "No business module is mapped; shared-capability correspondence is not implementation coverage.",
    "partner-capability.overview.status.unmapped.label": "No module mapped",
    "partner-capability.overview.title": "Accenture source-to-pay capability coverage, at a glance.",
    "partner-capability.page.description": "Explore how Accenture source-to-pay capabilities correspond to GroundWorks Workblocks, business modules and shared capabilities.",
    "partner-capability.page.disclaimer": "Colour reflects the highest current implementation status among mapped GroundWorks business modules. It does not state complete capability coverage, client deployment, contracted scope, market parity or achieved outcomes.",
    "partner-capability.page.eyebrow": "Accenture capability map",
    "partner-capability.page.title": "One capability map. Both directions.",
    "partner-capability.payment-readiness-execution.label": "Payment readiness and controlled execution",
    "partner-capability.policy-control-monitoring.label": "Policy, control and monitoring",
    "partner-capability.procurement-intake.label": "Business need identification and procurement intake",
    "partner-capability.purchase-order-management.label": "Purchase-order management and exception handling",
    "partner-capability.purchasing-ordering.label": "Purchasing, ordering and receiving",
    "partner-capability.requisition-approval-order.label": "Requisition approval and purchase-order issue",
    "partner-capability.savings-opportunity.label": "Savings opportunity identification and baselining",
    "partner-capability.savings-value-realisation.label": "Savings and value realisation",
    "partner-capability.search.areas": "Accenture capability areas",
    "partner-capability.search.capabilities": "Accenture capabilities",
    "partner-capability.sourcing-negotiation.label": "Sourcing and negotiation",
    "partner-capability.sourcing-project-execution.label": "Sourcing project execution",
    "partner-capability.sourcing-requirements.label": "Sourcing requirements definition",
    "partner-capability.sourcing-strategy.label": "Sourcing strategy and supplier profile",
    "partner-capability.stakeholder-partnering-governance.label": "Stakeholder partnering and operating governance",
    "partner-capability.supplier-development-innovation.label": "Supplier development, innovation and joint value",
    "partner-capability.supplier-einvoicing-enablement.label": "Supplier e-invoicing enablement",
    "partner-capability.supplier-inclusion-sustainability.label": "Supplier inclusion and sustainability",
    "partner-capability.supplier-lifecycle-risk.label": "Supplier lifecycle and third-party risk",
    "partner-capability.supplier-master-data.label": "Supplier master-data setup and maintenance",
    "partner-capability.supplier-onboarding-registration.label": "Supplier registration and onboarding",
    "partner-capability.supplier-performance-reporting.label": "Supplier performance reporting and review",
    "partner-capability.supplier-qualification-risk.label": "Supplier qualification and third-party risk",
    "partner-capability.supplier-relationship-governance.label": "Supplier relationship governance",
    "partner-capability.supplier-relationship-management.label": "Supplier relationship management",
    "partner-capability.supplier-remediation-exit.label": "Supplier remediation and exit",
    "partner-capability.supplier-risk-resilience.label": "Supplier risk, resilience and proactive monitoring",
    "partner-capability.supplier-segmentation.label": "Supplier segmentation",
    "partner-capability.supplier-selection-award.label": "Supplier selection and award",
    "partner-capability.tactical-spot-buy.label": "Project sourcing and spot buying",
    "partner-capability.tail-spend-management.label": "Tail-spend management",
    "partner-capability.targets.modules": "Business modules",
    "partner-capability.targets.shared": "Shared capabilities",
    "partner-capability.targets.workblocks": "Workblocks",
    "partner-capability.value-leakage-variance.label": "Value leakage, variance analysis and mitigation",
    "partner-capability.value-tracking-reporting.label": "Initiative, savings and value tracking",
    "partner-capability.view.groundworks": "GroundWorks to Accenture",
    "partner-capability.view.label": "Choose map direction",
    "partner-capability.view.partner": "Accenture to GroundWorks",
    "place.data-model.scope": "{count} record types",
    "place.data-model.section": "Data catalogue",
    "place.data-model.version": "Framework {version}",
    "place.platform.scope": "8 shared capabilities",
    "place.platform.section": "Platform",
    "place.workblocks.scope": "9 in catalogue",
    "place.workblocks.section": "Workblock catalogue",
    "place.workblocks.view": "in view",
    "positioning.copilot.body": "Governed procurement agents work across authorised Workblocks while grants, proposals and approvals remain explicit. As the record builds, policy graduates routine runs past manual review, every skip is logged and a quality drop returns the work to people.",
    "positioning.copilot.eyebrow": "Governed agents",
    "positioning.copilot.headline": "Agents propose. Authorised people commit.",
    "positioning.data.body": "One permissioned data plane carries records, documents and run history with one audit trail. When your people correct an agent's output, the correction is reused in your work, not in a vendor's shared model.",
    "positioning.data.eyebrow": "Data and learning",
    "positioning.data.headline": "Corrections compound in the client's tenant.",
    "positioning.integration.body": "Keep the systems that earn their place. Narrow, observable adapters let incumbent systems hold their defined responsibilities while one bounded outcome proves the model.",
    "positioning.integration.eyebrow": "Bounded adoption",
    "positioning.integration.headline": "Coexist first, prove value, replace selectively.",
    "positioning.modular.body": "Tailor a workflow, policy, data source or human-authority boundary without waiting for a suite release. A change is a new version, deployed as a deliberate act, and reversible because nothing it replaces is thrown away.",
    "positioning.modular.eyebrow": "Modular by design",
    "positioning.modular.headline": "Change the Workblock, not the platform.",
    "positioning.office.body": "Composer and Conductor give authorised Workblocks native document and workbook capabilities. Approved changes survive the round trip.",
    "positioning.office.eyebrow": "Native Office work",
    "positioning.office.headline": "People stay in Word, Excel and SharePoint.",
    "positioning.speed.body": "Connections are credentialed configuration against one platform boundary, not a bespoke project per system. Builds start from defined domain, module, data and authority contracts, not a blank page. The Workblock that proves value is the Workblock that deploys, version history attached.",
    "positioning.speed.eyebrow": "Speed",
    "positioning.speed.headline": "Workblocks are integrated with client systems in days, not weeks, and working Workblocks are built in the same timeframe.",
    "role.accountable-risk-owner.description": "Own the decision on whether remaining third-party risk is accepted, mitigated, transferred or declined.",
    "role.accountable-risk-owner.label": "Accountable risk owner",
    "role.accountable-risk-owner.search.risk-acceptance": "Risk acceptance owner",
    "role.ap-processor.description": "Own invoice processing work until it reaches a truthful readiness, blocked or resolution state.",
    "role.ap-processor.label": "AP processor",
    "role.ap-processor.search.accounts-payable": "Accounts payable processor",
    "role.award-authority.description": "Own the decision to approve, reject or return a sourcing award within delegated authority.",
    "role.award-authority.label": "Award authority",
    "role.budget-owner.description": "Own the spend, demand and business consequence within delegated budget authority.",
    "role.budget-owner.label": "Budget owner",
    "role.budget-owner.search.business-budget-owner": "Business budget owner",
    "role.category-manager.description": "Own category strategy, commercial outcomes and the cases raised against that strategy.",
    "role.category-manager.label": "Category manager",
    "role.contract-manager.description": "Own the contract lifecycle, repository quality, milestones and cross-functional follow-through.",
    "role.contract-manager.label": "Contract manager",
    "role.controller.description": "Own accounting control and material finance exceptions within the invoice and payment process.",
    "role.controller.label": "Controller",
    "role.data-steward.description": "Own the taxonomy, mappings and data-quality rules that procurement analysis relies on.",
    "role.data-steward.label": "Data steward",
    "role.demand-owner.description": "Own accepted demand across specialist owners and systems until its agreed outcome is complete.",
    "role.demand-owner.label": "Demand owner",
    "role.evaluator.description": "Own an independent assessment of assigned sourcing criteria and the evidence behind every submitted score.",
    "role.evaluator.label": "Evaluator",
    "role.evaluator.search.subject-matter-expert": "Subject-matter expert",
    "role.finance-delegate.description": "Own acceptance of the value method and later result under the organisation's finance authority.",
    "role.finance-delegate.label": "Finance delegate",
    "role.governance-owner.description": "Own supplier segmentation, review cadence, measure methods and escalation policy across the portfolio.",
    "role.governance-owner.label": "Supplier-governance owner",
    "role.governance-owner.search.supplier-governance-owner": "Supplier governance owner",
    "role.innovation-sponsor.description": "Own the business need, resources and stage decisions behind a supplier idea.",
    "role.innovation-sponsor.label": "Innovation sponsor",
    "role.intake-owner.description": "Own qualification and routing of a procurement request until it is accepted, redirected or declined.",
    "role.intake-owner.label": "Procurement intake owner",
    "role.intake-owner.search.procurement-intake-owner": "Intake lead",
    "role.integration-owner.description": "Own transaction and interface integrity across procurement source systems.",
    "role.integration-owner.label": "ERP or integration owner",
    "role.integration-owner.search.erp-owner": "System integration owner",
    "role.legal-counsel.description": "Own legal interpretation and the organisation's legal position on material contractual deviations.",
    "role.legal-counsel.label": "Legal counsel",
    "role.metric-owner.description": "Own measure definitions, observations, source provenance, corrections and data-quality state.",
    "role.metric-owner.label": "Metric or data owner",
    "role.metric-owner.search.data-owner": "Performance data owner",
    "role.negotiation-lead.description": "Own the supplier negotiation and the positions committed inside documented delegation.",
    "role.negotiation-lead.label": "Negotiation lead",
    "role.obligation-owner.description": "Own performance of a contractual duty or exercise of a right and the evidence that closes it.",
    "role.obligation-owner.label": "Obligation owner",
    "role.onboarding-coordinator.description": "Own the supplier case across procurement, risk, finance and ERP handoffs until readiness is confirmed.",
    "role.onboarding-coordinator.label": "Onboarding coordinator",
    "role.payment-approver.description": "Own the decision to release or reject a payment through the source controls that execute it.",
    "role.payment-approver.label": "Payment approver",
    "role.policy-owner.description": "Own what procurement policy means, when it applies and how it changes.",
    "role.policy-owner.label": "Procurement policy owner",
    "role.policy-owner.search.procurement-policy-owner": "Policy owner",
    "role.process-owner.description": "Own intake rules, thresholds, evidence requirements and exception routes as a versioned operating contract.",
    "role.process-owner.label": "Process and policy owner",
    "role.process-owner.search.process-policy-owner": "Intake process owner",
    "role.procurement-analyst.description": "Own curation and testing of spend evidence before an opportunity reaches a decision.",
    "role.procurement-analyst.label": "Procurement analyst",
    "role.procurement-buyer.description": "Own order creation and each supplier-facing change within purchasing authority.",
    "role.procurement-buyer.label": "Procurement buyer",
    "role.receiver.description": "Own confirmation of what was received or accepted and any correction to that record.",
    "role.receiver.label": "Receiver or service owner",
    "role.receiver.search.service-owner": "Service receiver",
    "role.relationship-manager.description": "Own the supplier relationship review, its decisions and follow-through across review periods.",
    "role.relationship-manager.label": "Supplier relationship manager",
    "role.relationship-manager.search.supplier-relationship-manager": "Relationship manager",
    "role.requester.description": "Own the business need, facts and requested outcome before specialist authorities decide their parts.",
    "role.requester.label": "Requester",
    "role.requester.search.business-requester": "Business requester",
    "role.risk-owner.description": "Own the specialist screening result and the exceptions that require risk authority.",
    "role.risk-owner.label": "Fraud, sanctions or risk owner",
    "role.risk-owner.search.fraud-sanctions-owner": "Specialist risk owner",
    "role.sourcing-lead.description": "Own an approved need through the sourcing event to a recommendation the award authority can decide.",
    "role.sourcing-lead.label": "Sourcing lead",
    "role.sourcing-manager.description": "Own continuity of the awarded commercial position into the executed agreement.",
    "role.sourcing-manager.label": "Sourcing manager",
    "role.supplier-account-lead.description": "Own the supplier's review evidence, explanations and commitments within documented delegation.",
    "role.supplier-account-lead.label": "Supplier account lead",
    "role.supplier-contact.description": "Own the supplier's submission of information, documents and corrections for an active relationship case.",
    "role.supplier-contact.label": "Supplier contact",
    "role.supplier-master-steward.description": "Own supplier identity, site, tax and bank-data quality so transactions reach the right record.",
    "role.supplier-master-steward.label": "Supplier-master steward",
    "role.tprm-programme-owner.description": "Own third-party tiering, evidence rules, decision rights and review cadence across the supplier population.",
    "role.tprm-programme-owner.label": "TPRM programme owner",
    "role.tprm-programme-owner.search.third-party-risk": "Third-party risk programme owner",
    "role.treasury-manager.description": "Own liquidity, payment timing and the authorised bank route.",
    "role.treasury-manager.label": "Treasury or cash manager",
    "role.treasury-manager.search.cash-manager": "Cash manager",
    "role.value-lead.description": "Own the credibility of the value portfolio, its methods, owners and evidence-supported states.",
    "role.value-lead.label": "Value realisation lead",
    "role.value-lead.search.value-realisation-lead": "Savings and value lead",
    "site.footer.implementation": "Accenture GroundWorks is Accenture's platform implementation of the Beyond Work source-to-pay framework, tailored for AI-first procurement.",
    "site.footer.license-link": "Read the Beyond Work Partner License",
    "site.footer.licensing": "Licensing is the Beyond Work Partner License for participating partners: free use, adaptation and resale, with recipes and Workblocks executed on Beyond Work execution rails. Integration definitions carry the Apache 2.0 exemption; partner-owned content such as the Accenture capability map remains the partner's property.",
    "site.footer.program": "GroundWorks is a Beyond Work foundation programme for partners: cohesive domain frameworks, developed and offered for partners to adapt and build on.",
    "site.footer.repo-link": "GroundWorks on GitHub",
    "stage.buy-pay.label": "Buy and pay",
    "stage.contract-assure.label": "Contract and assure",
    "stage.perform-realize.label": "Perform and realise",
    "stage.plan-govern.label": "Plan and govern",
    "stage.request-source.label": "Request and source",
    "status.disclosure": "8 reference modules, 9 defined modules and 28 roadmap modules.",
    "status.pattern.chip": "Defined module",
    "status.pattern.legend": "Business, data, authority and execution contracts are defined for client configuration",
    "status.reference.chip": "Reference build",
    "status.reference.legend": "Demonstrable on the execution rails at confirmed fidelity",
    "status.roadmap.chip": "Roadmap module",
    "status.roadmap.legend": "Planned and not represented as running",
    "system.alliance.descriptor": "Supplier performance and innovation system of work",
    "system.alliance.name": "Supplier Relationship Management (SRM)",
    "system.alliance.signature": "GroundWorks Alliance",
    "system.buyline.descriptor": "Buying and ordering system of work",
    "system.buyline.name": "Purchasing & Ordering",
    "system.buyline.signature": "GroundWorks Buyline",
    "system.clearway.descriptor": "Invoice and payment readiness system of work",
    "system.clearway.name": "Invoicing & Payment (AP)",
    "system.clearway.signature": "GroundWorks Clearway",
    "system.covenant.descriptor": "Contract lifecycle system of work",
    "system.covenant.name": "Contract Lifecycle Management (CLM)",
    "system.covenant.signature": "GroundWorks Accord",
    "system.dealroom.descriptor": "Sourcing and negotiation system of work",
    "system.dealroom.name": "Sourcing & Negotiation",
    "system.dealroom.signature": "GroundWorks Dealroom",
    "system.gateway.descriptor": "Intake and demand system of work",
    "system.gateway.name": "Intake Management",
    "system.gateway.signature": "GroundWorks Gateway",
    "system.radar.descriptor": "Category strategy and spend system of work",
    "system.radar.name": "Category Management",
    "system.radar.signature": "GroundWorks Radar",
    "system.sentinel.descriptor": "Supplier lifecycle and third-party risk system of work",
    "system.sentinel.name": "Supplier & Third-Party Risk Management (TPRM)",
    "system.sentinel.signature": "GroundWorks Sentinel",
    "system.value-hunter.descriptor": "Value realisation and savings system of work",
    "system.value-hunter.name": "Savings & Value Realisation",
    "system.value-hunter.signature": "GroundWorks Value Hunter",
    "trail.connected-work": "Connected Work",
    "trail.connected-work.context": "Integration recipes, outcome tools and system profiles with their proof classes.",
    "trail.data": "The data model",
    "trail.data.context": "The records, roles and authority tables every Workblock is built on.",
    "trail.downloads": "The downloads",
    "trail.downloads.context": "Every governed asset in copyable and downloadable form.",
    "trail.label": "Where to go next",
    "trail.language": "The shared language",
    "trail.language.context": "The governed terms for roles, records, authority and execution across all nine Workblocks.",
    "trail.reference": "The reference",
    "trail.reference.context": "The complete governed reference across roles, records, language and downloads.",
    "trail.search": "Search GroundWorks",
    "trail.search.context": "Find any Workblock, module, role, record or page.",
    "trail.work": "The Workblocks",
    "trail.work.context": "Nine domain Workblocks containing 8 reference, 9 defined and 28 roadmap business modules.",
    "vocab.agent-executes": "Agent executes",
    "vocab.human-approves": "Human approves",
    "vocab.human-reviews": "Human reviews",
    "vocab.legend": "Three words carry every hand-off: the agent executes inside its envelope, a person reviews what it proposes, and a named person approves what commits.",
    "work-moment.autonomy.mission_autonomous_with_supervision": "Mission-autonomous with supervision",
    "work-moment.back": "Back to Work moments",
    "work-moment.category-strategy-refresh.agent-contribution": "The category strategist agent refreshes the fact base, recalculates the scenarios and drafts the next strategy version with its objectives and initiative changes. It cannot activate a strategy version or commit an initiative handoff.",
    "work-moment.category-strategy-refresh.coexistence": "Spend, contract and market systems remain authoritative for their facts. The Workblock holds the versioned strategy record while Conductor carries the scenario workbook and Composer carries the strategy document.",
    "work-moment.category-strategy-refresh.perspective.category-manager.before": "Rebuild the fact pack each planning cycle, reconcile market updates by hand and re-argue the strategy from a static deck.",
    "work-moment.category-strategy-refresh.perspective.category-manager.now": "Set the strategy intent, supervise the scenario refresh, judge the recommendation against its evidence and commit the next version explicitly.",
    "work-moment.category-strategy-refresh.perspective.category-manager.responsibility": "Own the active category strategy, its objectives and the decisions that change it.",
    "work-moment.category-strategy-refresh.perspective.category-manager.supervision": "Pause or redirect the refresh, reject a scenario built on disputed facts, hold activation, revoke the grant or restore the last-good strategy version.",
    "work-moment.category-strategy-refresh.perspective.procurement-analyst.before": "Chase extracts from spend and contract systems, patch the workbook and explain why two versions of the same number disagree.",
    "work-moment.category-strategy-refresh.perspective.procurement-analyst.now": "Trace every scenario input to its source record, flag conflicting market evidence and prepare initiative handoffs from the committed version only.",
    "work-moment.category-strategy-refresh.perspective.procurement-analyst.responsibility": "Own the fact base, its source mappings and the handoff quality of committed initiatives.",
    "work-moment.category-strategy-refresh.perspective.procurement-analyst.supervision": "Hold a scenario whose inputs cannot be reproduced, correct source mappings within remit and return strategy judgements to their accountable owner.",
    "work-moment.category-strategy-refresh.summary": "A category manager supervises a scenario refresh after a market movement, judges the recommendation against its evidence and commits the next strategy version only within delegated authority.",
    "work-moment.category-strategy-refresh.title": "Commit a strategy refresh when the fact base moves",
    "work-moment.chapter.agent": "Bounded agent contribution",
    "work-moment.chapter.authority": "Human authority",
    "work-moment.chapter.committed": "Committed outcome",
    "work-moment.chapter.evidence": "Evidence assembled",
    "work-moment.chapter.eyebrow": "Work moment",
    "work-moment.chapter.incumbent": "Incumbent work",
    "work-moment.chapter.learning": "Reviewed learning",
    "work-moment.chapter.open-record": "Open the complete Work moment record",
    "work-moment.chapter.trigger": "Triggering signal",
    "work-moment.contract-redline-review.agent-contribution": "The contract drafting agent maps supplier paper against the playbook, drafts tracked redlines and records each deviation with its rule, risk and evidence. It cannot accept a clause or commit contract text.",
    "work-moment.contract-redline-review.coexistence": "The contract lives as a native document with tracked changes and comments. The Workblock holds deviations, decisions and version lineage without flattening the document into fields.",
    "work-moment.contract-redline-review.perspective.legal-counsel.before": "Read the whole third-party draft cold, mark risks by hand and rebuild the playbook comparison for every new version.",
    "work-moment.contract-redline-review.perspective.legal-counsel.now": "Supervise mapped deviations with their rule and risk, judge the exceptions and keep every accepted change as a tracked, attributable edit.",
    "work-moment.contract-redline-review.perspective.legal-counsel.responsibility": "Own the legal position, deviation decisions and the text that may bind the organisation.",
    "work-moment.contract-redline-review.perspective.legal-counsel.supervision": "Pause or redirect drafting, reject a redline that exceeds the playbook mandate, hold clause acceptance, revoke the grant or restore the prior document version.",
    "work-moment.contract-redline-review.perspective.sourcing-manager.before": "Reconstruct which commercial terms moved across mail threads and hope the latest document reflects the agreed position.",
    "work-moment.contract-redline-review.perspective.sourcing-manager.now": "See each commercial deviation with its value effect and history, and commit position changes explicitly instead of through silent edits.",
    "work-moment.contract-redline-review.perspective.sourcing-manager.responsibility": "Own the commercial position and its trade-offs across the negotiation.",
    "work-moment.contract-redline-review.perspective.sourcing-manager.supervision": "Hold a commercial term under negotiation, correct the recorded position within mandate and return legal judgements to counsel.",
    "work-moment.contract-redline-review.summary": "A legal counsel supervises drafted redlines on supplier paper while the sourcing manager holds the commercial position, and a stale negotiation record returns for judgement.",
    "work-moment.contract-redline-review.title": "Review third-party paper without leaving the document",
    "work-moment.daily-decision-brief.agent-contribution": "The coverage position agent reconciles forecast demand against contracted cover, joins the team's own price outlook, the contract windows and the supplier risk readings behind each exposed position, and prepares the bounded action each gap calls for. The brief answers questions from these records with sources attached; it proposes and explains, and a named person commits.",
    "work-moment.daily-decision-brief.coexistence": "Planning systems keep the demand plan and the organisation's own prediction models keep the price outlook. The brief reads their governed projections with source, method and freshness preserved, answers questions from those records rather than around them, and returns each committed action to the owning system through its declared path.",
    "work-moment.daily-decision-brief.perspective.demand-owner.before": "Open five systems before the first meeting, reconcile cover, prices, contracts and risk by hand, and carry the resulting decision unrecorded into a call.",
    "work-moment.daily-decision-brief.perspective.demand-owner.now": "Open one brief where the exposed positions arrive with their reasons attached, ask why a position is thin and get the answer from the records, with the prepared action waiting for a decision.",
    "work-moment.daily-decision-brief.perspective.demand-owner.responsibility": "Own the material demand portfolio, the cover that protects it and the actions that close each gap.",
    "work-moment.daily-decision-brief.perspective.demand-owner.supervision": "The demand owner commits or declines each prepared action by name inside the authority envelope; the brief answers and proposes, and it never commits.",
    "work-moment.daily-decision-brief.perspective.process-owner.before": "Field questions about why an action was taken with no shared record of what was known, asked or decided that morning.",
    "work-moment.daily-decision-brief.perspective.process-owner.now": "See each morning's questions, answers and decisions on one record, with every answer citing the projections it was read from.",
    "work-moment.daily-decision-brief.perspective.process-owner.responsibility": "Own the buying process the brief's actions run through and the consent the business gives them.",
    "work-moment.daily-decision-brief.perspective.process-owner.supervision": "The process owner reviews the brief's decision trail and escalates when an action falls outside the agreed process; the escalation and its outcome stay on the record.",
    "work-moment.daily-decision-brief.summary": "A demand owner opens one morning brief where cover, the team's own price outlook, contract windows and supplier risk arrive already joined, asks the brief why a position is thin, and commits the prepared covering action by name.",
    "work-moment.daily-decision-brief.title": "Run the morning from one decision brief",
    "work-moment.direct-material-buy-timing.agent-contribution": "The buy timing agent assembles the price outlook and coverage evidence, models buy-window scenarios against the declared volume bands and drafts the bounded mandate proposal. It proposes and routes; a named person authorises every mandate, and the buy itself executes downstream under that mandate.",
    "work-moment.direct-material-buy-timing.coexistence": "Planning and market systems remain authoritative for demand plans and price assessments. The Workblock reads their governed projections, preserves source references through every proposal, and returns the authorised mandate as a bounded record for downstream sourcing execution.",
    "work-moment.direct-material-buy-timing.perspective.sourcing-lead.before": "Watch price feeds and coverage spreadsheets separately, assemble a buy case by hand, and reconstruct afterwards who approved which volume at which ceiling.",
    "work-moment.direct-material-buy-timing.perspective.sourcing-lead.now": "Supervise one timing picture: the coverage gap, the outlook behind it and the drafted mandate arrive together, with every proposal awaiting an explicit decision.",
    "work-moment.direct-material-buy-timing.perspective.sourcing-lead.responsibility": "Own the sourcing pipeline, its buy-timing mandates and the coverage position they protect.",
    "work-moment.direct-material-buy-timing.perspective.sourcing-lead.supervision": "The sourcing lead reviews each drafted mandate against the authority envelope and commits or declines it by name; nothing buys on a model's word.",
    "work-moment.direct-material-buy-timing.summary": "A sourcing lead supervises coverage against a moving commodity market, opens the conflicting price assessments behind the outlook and authorises a bounded buy-timing mandate that names volume, window and ceiling.",
    "work-moment.direct-material-buy-timing.title": "Time a bounded buy inside a market window",
    "work-moment.domain-preview.browse-all": "Browse Work moments for this Workblock",
    "work-moment.domain-preview.title": "See this Workblock at work",
    "work-moment.fixture.category-strategy-refresh.evidence.market-index.definition": "The external market index series behind the affected scenario assumptions.",
    "work-moment.fixture.category-strategy-refresh.evidence.market-index.label": "Market price index",
    "work-moment.fixture.category-strategy-refresh.evidence.market-index.source": "External market data feed",
    "work-moment.fixture.category-strategy-refresh.evidence.spend-fact-base.definition": "The normalised spend position for the category over the strategy period.",
    "work-moment.fixture.category-strategy-refresh.evidence.spend-fact-base.label": "Category spend fact base",
    "work-moment.fixture.category-strategy-refresh.evidence.spend-fact-base.source": "Published spend data foundation",
    "work-moment.fixture.category-strategy-refresh.evidence.strategy-objectives.definition": "The objectives and boundaries the active strategy version commits to.",
    "work-moment.fixture.category-strategy-refresh.evidence.strategy-objectives.label": "Approved strategy objectives",
    "work-moment.fixture.category-strategy-refresh.evidence.strategy-objectives.source": "Active strategy record",
    "work-moment.fixture.category-strategy-refresh.mode.evidence.heading": "Can the scenario inputs stand?",
    "work-moment.fixture.category-strategy-refresh.mode.evidence.summary": "Open each scenario input to its source record, method version and freshness before judging the recommendation.",
    "work-moment.fixture.category-strategy-refresh.mode.learning.heading": "Should the refresh method change?",
    "work-moment.fixture.category-strategy-refresh.mode.learning.summary": "Resolved input conflicts become evaluation cases only after the policy owner accepts their treatment and replay result.",
    "work-moment.fixture.category-strategy-refresh.mode.office.heading": "Continue in the native working artefacts",
    "work-moment.fixture.category-strategy-refresh.mode.office.summary": "Conductor holds the reproducible scenario workbook. Composer carries the strategy document and returns the reviewed version to the Workblock record.",
    "work-moment.fixture.category-strategy-refresh.mode.supervise.heading": "What needs judgement now?",
    "work-moment.fixture.category-strategy-refresh.mode.supervise.summary": "The scenario refresh is ready. One market index conflict holds the recommended version before activation.",
    "work-moment.fixture.category-strategy-refresh.office.composer.label": "Category strategy document",
    "work-moment.fixture.category-strategy-refresh.office.composer.proposal": "Update the bounded scenario section with the corrected assumption and tracked source references.",
    "work-moment.fixture.category-strategy-refresh.office.composer.return": "Reviewed strategy version and committed activation decision",
    "work-moment.fixture.category-strategy-refresh.office.composer.scope": "Objectives section, scenario comparison table and initiative list",
    "work-moment.fixture.category-strategy-refresh.office.composer.type": "Native DOCX strategy",
    "work-moment.fixture.category-strategy-refresh.office.composer.version": "Reviewed strategy version 9",
    "work-moment.fixture.category-strategy-refresh.office.conductor.label": "Category scenario workbook",
    "work-moment.fixture.category-strategy-refresh.office.conductor.proposal": "Recalculate the affected scenario from the verified market series and preserve the prior result.",
    "work-moment.fixture.category-strategy-refresh.office.conductor.return": "Scenario result and source-reference receipt",
    "work-moment.fixture.category-strategy-refresh.office.conductor.scope": "Named ranges for scenario assumptions, spend inputs and outcome calculations",
    "work-moment.fixture.category-strategy-refresh.office.conductor.type": "Native XLSX scenario model",
    "work-moment.fixture.category-strategy-refresh.office.conductor.version": "Reviewed model version 9",
    "work-moment.fixture.category-strategy-refresh.record.index-conflict.detail": "Two market sources disagree for the same period, so the affected scenario waits for analyst judgement.",
    "work-moment.fixture.category-strategy-refresh.record.index-conflict.label": "Market index disputed",
    "work-moment.fixture.category-strategy-refresh.record.index-sources-conflict.detail": "The market feed and the verified analyst series name different index values for July. The affected assumption is held.",
    "work-moment.fixture.category-strategy-refresh.record.index-sources-conflict.label": "Index sources conflict",
    "work-moment.fixture.category-strategy-refresh.record.refresh-cohort-reviewed.detail": "The index conflict and its resolution are retained for replay. The refresh method does not change until its owner approves a versioned release.",
    "work-moment.fixture.category-strategy-refresh.record.refresh-cohort-reviewed.label": "Refresh cohort reviewed",
    "work-moment.fixture.category-strategy-refresh.record.refresh-ready.detail": "The refreshed scenarios reproduce from the current fact base and the approved method version.",
    "work-moment.fixture.category-strategy-refresh.record.refresh-ready.label": "Scenario refresh ready",
    "work-moment.fixture.category-strategy-refresh.record.version-committed.detail": "The category manager committed strategy version 9 after the reviewed artefacts returned. The prior version remains readable with its history.",
    "work-moment.fixture.category-strategy-refresh.record.version-committed.label": "Strategy version committed",
    "work-moment.fixture.category-strategy-refresh.record.version-proposed.detail": "The agent drafted strategy version 9 with its objectives and initiative changes. Nothing is active until the category manager commits it.",
    "work-moment.fixture.category-strategy-refresh.record.version-proposed.label": "Strategy version proposed",
    "work-moment.fixture.contract-redline-review.evidence.negotiation-history.definition": "The last recorded commercial position for the disputed liability clause.",
    "work-moment.fixture.contract-redline-review.evidence.negotiation-history.label": "Negotiation position history",
    "work-moment.fixture.contract-redline-review.evidence.negotiation-history.source": "Negotiation record",
    "work-moment.fixture.contract-redline-review.evidence.playbook-position.definition": "The approved fallback and escalation position for each affected clause.",
    "work-moment.fixture.contract-redline-review.evidence.playbook-position.label": "Playbook position",
    "work-moment.fixture.contract-redline-review.evidence.playbook-position.source": "Approved contract playbook",
    "work-moment.fixture.contract-redline-review.evidence.supplier-draft.definition": "The third-party paper version under review, with its tracked changes and comments.",
    "work-moment.fixture.contract-redline-review.evidence.supplier-draft.label": "Supplier draft version",
    "work-moment.fixture.contract-redline-review.evidence.supplier-draft.source": "Native contract document",
    "work-moment.fixture.contract-redline-review.mode.evidence.heading": "Is the recorded position current?",
    "work-moment.fixture.contract-redline-review.mode.evidence.summary": "Open each deviation to its clause, playbook rule, risk basis and the negotiation history behind the position.",
    "work-moment.fixture.contract-redline-review.mode.learning.heading": "Should the playbook change?",
    "work-moment.fixture.contract-redline-review.mode.learning.summary": "Validated negotiation outcomes become playbook evaluation cases only after the contract manager accepts their treatment.",
    "work-moment.fixture.contract-redline-review.mode.office.heading": "Continue in the native working artefact",
    "work-moment.fixture.contract-redline-review.mode.office.summary": "Composer carries the contract with tracked changes and comments, and returns the reviewed version to the Workblock record.",
    "work-moment.fixture.contract-redline-review.mode.supervise.heading": "What needs judgement now?",
    "work-moment.fixture.contract-redline-review.mode.supervise.summary": "Drafted redlines cover the mapped deviations. A stale commercial position holds the liability clause for judgement.",
    "work-moment.fixture.contract-redline-review.office.composer.label": "Contract under review",
    "work-moment.fixture.contract-redline-review.office.composer.proposal": "Apply the playbook fallback to the liability clause as tracked changes with the deviation recorded.",
    "work-moment.fixture.contract-redline-review.office.composer.return": "Reviewed document version and clause decisions",
    "work-moment.fixture.contract-redline-review.office.composer.scope": "Liability and indemnity sections with tracked changes and comments",
    "work-moment.fixture.contract-redline-review.office.composer.type": "Native DOCX contract",
    "work-moment.fixture.contract-redline-review.office.composer.version": "Reviewed draft version 3",
    "work-moment.fixture.contract-redline-review.record.clause-committed.detail": "Counsel accepted the revised liability clause after the reviewed document returned. The accepted text and its deviation record share one version.",
    "work-moment.fixture.contract-redline-review.record.clause-committed.label": "Clause accepted",
    "work-moment.fixture.contract-redline-review.record.deviation-cohort-reviewed.detail": "The liability deviation and its outcome are retained for replay. The playbook does not change until its owner approves a versioned release.",
    "work-moment.fixture.contract-redline-review.record.deviation-cohort-reviewed.label": "Deviation cohort reviewed",
    "work-moment.fixture.contract-redline-review.record.history-stale.detail": "The last-good commercial position is from the previous round and remains visible with its age until restated.",
    "work-moment.fixture.contract-redline-review.record.history-stale.label": "Negotiation record is stale",
    "work-moment.fixture.contract-redline-review.record.position-stale.detail": "The recorded commercial position predates the latest negotiation round, so the liability clause waits for the sourcing manager.",
    "work-moment.fixture.contract-redline-review.record.position-stale.label": "Commercial position needs judgement",
    "work-moment.fixture.contract-redline-review.record.redline-proposed.detail": "The agent's redlines remain proposals inside the document. No clause is accepted until its owner commits the change.",
    "work-moment.fixture.contract-redline-review.record.redline-proposed.label": "Redline proposed",
    "work-moment.fixture.contract-redline-review.record.redlines-ready.detail": "Tracked redlines and deviation records reproduce from the playbook version and the supplier draft.",
    "work-moment.fixture.contract-redline-review.record.redlines-ready.label": "Redlines drafted",
    "work-moment.fixture.daily-decision-brief.evidence.contract-window-readout.definition": "Renewal and notice windows opening across the portfolio's agreements, read from the contract lifecycle records.",
    "work-moment.fixture.daily-decision-brief.evidence.contract-window-readout.label": "Contract window readout",
    "work-moment.fixture.daily-decision-brief.evidence.contract-window-readout.source": "Contract lifecycle projections",
    "work-moment.fixture.daily-decision-brief.evidence.coverage-position.definition": "Committed and contracted cover against the consolidated demand portfolio for each material family, by month.",
    "work-moment.fixture.daily-decision-brief.evidence.coverage-position.label": "Coverage position",
    "work-moment.fixture.daily-decision-brief.evidence.coverage-position.source": "Computed from the demand portfolio and contract entitlements",
    "work-moment.fixture.daily-decision-brief.evidence.own-price-outlook.definition": "The price outlook produced by the organisation's own forecasting model, read as a governed signal with source, method, confidence and freshness preserved.",
    "work-moment.fixture.daily-decision-brief.evidence.own-price-outlook.label": "The team's own price outlook",
    "work-moment.fixture.daily-decision-brief.evidence.own-price-outlook.source": "The organisation's own prediction model, read through the analytics exchange",
    "work-moment.fixture.daily-decision-brief.evidence.supplier-risk-readout.definition": "Current risk signals and assessment states for the suppliers behind each covered position; the feed refreshes overnight.",
    "work-moment.fixture.daily-decision-brief.evidence.supplier-risk-readout.label": "Supplier risk readout",
    "work-moment.fixture.daily-decision-brief.evidence.supplier-risk-readout.source": "Supplier risk monitoring projections",
    "work-moment.fixture.daily-decision-brief.mode.explore.heading": "Open the sources behind the brief",
    "work-moment.fixture.daily-decision-brief.mode.explore.summary": "Every line in the brief opens to the projection it was read from, and a lagging feed is marked with its age rather than presented as current.",
    "work-moment.fixture.daily-decision-brief.mode.review.heading": "Review the morning's decisions",
    "work-moment.fixture.daily-decision-brief.mode.review.summary": "Each commitment keeps the question, the answer and the evidence versions that carried it, so tomorrow's brief starts from what actually happened.",
    "work-moment.fixture.daily-decision-brief.mode.supervise.heading": "Supervise the morning picture",
    "work-moment.fixture.daily-decision-brief.mode.supervise.summary": "Cover, outlook, contract windows and supplier risk arrive as one picture; the exposed positions and the prepared actions wait for a named decision.",
    "work-moment.fixture.daily-decision-brief.record.brief-outcome-reviewed.detail": "The committed action is compared with the corridor and cover it assumed, and the variance sharpens what tomorrow's brief raises first.",
    "work-moment.fixture.daily-decision-brief.record.brief-outcome-reviewed.label": "Brief outcome reviewed",
    "work-moment.fixture.daily-decision-brief.record.covering-action-committed.detail": "A named demand owner committed the covering action inside the authority envelope; the record carries the decision, the authority and the answer that informed it.",
    "work-moment.fixture.daily-decision-brief.record.covering-action-committed.label": "Covering action committed",
    "work-moment.fixture.daily-decision-brief.record.covering-action-proposed.detail": "The prepared action names the volume, the window and the ceiling it would commit, cites the records it rests on and waits for the demand owner.",
    "work-moment.fixture.daily-decision-brief.record.covering-action-proposed.label": "Covering action proposed",
    "work-moment.fixture.daily-decision-brief.record.outlook-provenance-opened.detail": "The price line opens to the organisation's own model output with method and confidence attached; the brief reads the model, it does not second-guess it.",
    "work-moment.fixture.daily-decision-brief.record.outlook-provenance-opened.label": "Outlook provenance opened",
    "work-moment.fixture.daily-decision-brief.record.position-exposed.detail": "One plant's cover runs out inside the outlook's rising corridor; the gap sits outside the declared risk posture and is raised for a decision.",
    "work-moment.fixture.daily-decision-brief.record.position-exposed.label": "Position exposed",
    "work-moment.fixture.daily-decision-brief.record.question-answered-from-records.detail": "Asked why the position is thin, the brief answers from the coverage and contract records with sources attached, and states what it may and may not do.",
    "work-moment.fixture.daily-decision-brief.record.question-answered-from-records.label": "Question answered from the records",
    "work-moment.fixture.daily-decision-brief.record.risk-readout-lagging.detail": "The supplier risk feed last refreshed yesterday evening; the brief shows the reading with its age instead of treating it as current.",
    "work-moment.fixture.daily-decision-brief.record.risk-readout-lagging.label": "Risk readout lagging",
    "work-moment.fixture.direct-material-buy-timing.evidence.commodity-price-outlook.definition": "The projected price corridor for an illustrative steel wire rod family over the next two quarters, with the assessment basis attached.",
    "work-moment.fixture.direct-material-buy-timing.evidence.commodity-price-outlook.label": "Commodity price outlook",
    "work-moment.fixture.direct-material-buy-timing.evidence.commodity-price-outlook.source": "Derived from governed market price assessments",
    "work-moment.fixture.direct-material-buy-timing.evidence.coverage-position.definition": "Committed and contracted volume against the consolidated demand portfolio for the material family, by month.",
    "work-moment.fixture.direct-material-buy-timing.evidence.coverage-position.label": "Coverage position",
    "work-moment.fixture.direct-material-buy-timing.evidence.coverage-position.source": "Computed from the demand portfolio and contract entitlements",
    "work-moment.fixture.direct-material-buy-timing.evidence.demand-portfolio-commitment.definition": "The consolidated, business-consented demand the coverage position is measured against.",
    "work-moment.fixture.direct-material-buy-timing.evidence.demand-portfolio-commitment.label": "Demand portfolio commitment",
    "work-moment.fixture.direct-material-buy-timing.evidence.demand-portfolio-commitment.source": "Demand consolidation portfolio record",
    "work-moment.fixture.direct-material-buy-timing.evidence.price-assessment-feed.definition": "The external price assessments behind the outlook; two providers currently disagree on the front-month movement.",
    "work-moment.fixture.direct-material-buy-timing.evidence.price-assessment-feed.label": "Price assessment feed",
    "work-moment.fixture.direct-material-buy-timing.evidence.price-assessment-feed.source": "External market data subscription",
    "work-moment.fixture.direct-material-buy-timing.mode.explore.heading": "Open the evidence behind the outlook",
    "work-moment.fixture.direct-material-buy-timing.mode.explore.summary": "Every figure in the timing picture opens to its assessments, and disagreement between providers stays visible rather than averaged away.",
    "work-moment.fixture.direct-material-buy-timing.mode.review.heading": "Review the authorised mandate",
    "work-moment.fixture.direct-material-buy-timing.mode.review.summary": "The decision and its outcome stay attached to the evidence that carried them, so the next window starts from what actually happened.",
    "work-moment.fixture.direct-material-buy-timing.mode.supervise.heading": "Supervise the timing picture",
    "work-moment.fixture.direct-material-buy-timing.mode.supervise.summary": "Coverage, outlook and the drafted mandate arrive as one picture; the flagged gap and the proposal wait for a named decision.",
    "work-moment.fixture.direct-material-buy-timing.record.assessment-sources-disagree.detail": "Two assessment providers diverge on the front-month movement; the outlook carries both readings and the divergence is marked, not averaged.",
    "work-moment.fixture.direct-material-buy-timing.record.assessment-sources-disagree.label": "Assessments disagree",
    "work-moment.fixture.direct-material-buy-timing.record.buy-timing-mandate-proposed.detail": "The drafted mandate names the volume band, the buy window and the price ceiling, and cites the outlook and coverage evidence it rests on.",
    "work-moment.fixture.direct-material-buy-timing.record.buy-timing-mandate-proposed.label": "Buy-timing mandate proposed",
    "work-moment.fixture.direct-material-buy-timing.record.coverage-gap-flagged.detail": "Committed volume covers the consolidated demand only into next quarter; the uncovered band sits outside the declared risk posture.",
    "work-moment.fixture.direct-material-buy-timing.record.coverage-gap-flagged.label": "Coverage gap flagged",
    "work-moment.fixture.direct-material-buy-timing.record.mandate-authorized.detail": "A named sourcing lead authorised the bounded mandate, naming the volume band, the buy window and the price ceiling; the record carries the decision, the authority and the evidence versions.",
    "work-moment.fixture.direct-material-buy-timing.record.mandate-authorized.label": "Mandate authorised",
    "work-moment.fixture.direct-material-buy-timing.record.mandate-outcome-reviewed.detail": "The executed buy is compared with the corridor the mandate assumed; the variance and its reading feed the next timing decision.",
    "work-moment.fixture.direct-material-buy-timing.record.mandate-outcome-reviewed.label": "Mandate outcome reviewed",
    "work-moment.fixture.direct-material-buy-timing.record.outlook-basis-reproduced.detail": "The projected corridor recomputes from the cited assessments, so the sourcing lead can inspect exactly what the proposal rests on.",
    "work-moment.fixture.direct-material-buy-timing.record.outlook-basis-reproduced.label": "Outlook basis reproduced",
    "work-moment.fixture.direct-material-buy-timing.record.price-window-open.detail": "The outlook places the current corridor below the trailing average for the material family, inside the declared buy window.",
    "work-moment.fixture.direct-material-buy-timing.record.price-window-open.label": "Price window open",
    "work-moment.fixture.guided-buying-route.evidence.catalogue-item.definition": "The matched catalogue item's availability and lead time.",
    "work-moment.fixture.guided-buying-route.evidence.catalogue-item.label": "Catalogue availability",
    "work-moment.fixture.guided-buying-route.evidence.catalogue-item.source": "Supplier catalogue feed",
    "work-moment.fixture.guided-buying-route.evidence.contract-price.definition": "The current contract price for the matched item and supplier.",
    "work-moment.fixture.guided-buying-route.evidence.contract-price.label": "Contracted price",
    "work-moment.fixture.guided-buying-route.evidence.contract-price.source": "Contract record",
    "work-moment.fixture.guided-buying-route.evidence.stated-need.definition": "The requester's confirmed need with quantity, timing and delivery site.",
    "work-moment.fixture.guided-buying-route.evidence.stated-need.label": "Stated purchase need",
    "work-moment.fixture.guided-buying-route.evidence.stated-need.source": "Requester's guided intake",
    "work-moment.fixture.guided-buying-route.mode.evidence.heading": "Is the option evidence current?",
    "work-moment.fixture.guided-buying-route.mode.evidence.summary": "Each option carries price, contract, eligibility, availability and policy references with their freshness visible.",
    "work-moment.fixture.guided-buying-route.mode.learning.heading": "Should the guidance source change?",
    "work-moment.fixture.guided-buying-route.mode.learning.summary": "Route outcomes and off-path resolutions become evaluation cases only after the buyer accepts their treatment.",
    "work-moment.fixture.guided-buying-route.mode.supervise.heading": "What needs judgement now?",
    "work-moment.fixture.guided-buying-route.mode.supervise.summary": "The routine route is progressing inside its envelope. A stale catalogue feed holds the recommended option for buyer judgement.",
    "work-moment.fixture.guided-buying-route.record.availability-stale.detail": "The catalogue feed is older than its freshness rule, so the recommended option waits for the buyer.",
    "work-moment.fixture.guided-buying-route.record.availability-stale.label": "Availability needs judgement",
    "work-moment.fixture.guided-buying-route.record.catalogue-feed-stale.detail": "Last-good availability remains visible from 11 August. The option carries no availability promise until the feed reconciles.",
    "work-moment.fixture.guided-buying-route.record.catalogue-feed-stale.label": "Catalogue feed is stale",
    "work-moment.fixture.guided-buying-route.record.need-committed.detail": "The requester committed the confirmed need and chosen option. The order commitment itself belongs to the ordering Workblock.",
    "work-moment.fixture.guided-buying-route.record.need-committed.label": "Need and option committed",
    "work-moment.fixture.guided-buying-route.record.option-proposed.detail": "The agent proposed the contracted option with price and policy evidence. No order exists until the route commits it downstream.",
    "work-moment.fixture.guided-buying-route.record.option-proposed.label": "Contracted option proposed",
    "work-moment.fixture.guided-buying-route.record.route-cohort-reviewed.detail": "Sampled routes met the guidance rule. The buyer corrected one catalogue mapping at its source rather than case by case.",
    "work-moment.fixture.guided-buying-route.record.route-cohort-reviewed.label": "Route cohort reviewed",
    "work-moment.fixture.guided-buying-route.record.route-progressing.detail": "The mission completed need resolution and policy checks inside the approved route envelope.",
    "work-moment.fixture.guided-buying-route.record.route-progressing.label": "Routine route progressing",
    "work-moment.fixture.intake-clarification.evidence.offering-contract.definition": "The catalogue offering contract the captured need currently matches.",
    "work-moment.fixture.intake-clarification.evidence.offering-contract.label": "Matched service offering",
    "work-moment.fixture.intake-clarification.evidence.offering-contract.source": "Procurement service catalogue",
    "work-moment.fixture.intake-clarification.evidence.request-intent.definition": "The requester's stated need with its confirmed scope, quantity and timing.",
    "work-moment.fixture.intake-clarification.evidence.request-intent.label": "Captured business need",
    "work-moment.fixture.intake-clarification.evidence.request-intent.source": "Requester's channel message",
    "work-moment.fixture.intake-clarification.evidence.vendor-quote.definition": "The quotation file the requester attached as pricing context, with its stated validity period.",
    "work-moment.fixture.intake-clarification.evidence.vendor-quote.label": "Attached vendor quotation",
    "work-moment.fixture.intake-clarification.evidence.vendor-quote.source": "Attached file reference",
    "work-moment.fixture.intake-clarification.mode.evidence.heading": "Is the attached evidence current enough?",
    "work-moment.fixture.intake-clarification.mode.evidence.summary": "Every file and message remains a referenced evidence record with its owner, source and age visible.",
    "work-moment.fixture.intake-clarification.mode.learning.heading": "Should the clarification rule change?",
    "work-moment.fixture.intake-clarification.mode.learning.summary": "Corrections and downstream misunderstandings become versioned evaluation cases only after the process owner accepts their treatment.",
    "work-moment.fixture.intake-clarification.mode.supervise.heading": "What needs judgement now?",
    "work-moment.fixture.intake-clarification.mode.supervise.summary": "Clarification is complete for routing. A stale quotation holds the pricing context before the case releases.",
    "work-moment.fixture.intake-clarification.record.clarification-cohort-reviewed.detail": "Sampled clarification turns met the decision-value rule. The process owner retains the current questioning policy and review sample.",
    "work-moment.fixture.intake-clarification.record.clarification-cohort-reviewed.label": "Clarification cohort reviewed",
    "work-moment.fixture.intake-clarification.record.intent-confirmed.detail": "The captured need matches the requester's confirmation and the offering's required facts.",
    "work-moment.fixture.intake-clarification.record.intent-confirmed.label": "Captured need confirmed",
    "work-moment.fixture.intake-clarification.record.need-committed.detail": "The requester confirmed the business need. The commitment covers the need itself, not procurement's routing or downstream demand.",
    "work-moment.fixture.intake-clarification.record.need-committed.label": "Business need committed",
    "work-moment.fixture.intake-clarification.record.quote-stale.detail": "The attached quotation is older than its validity period, so the pricing context waits for the requester.",
    "work-moment.fixture.intake-clarification.record.quote-stale.label": "Quotation needs judgement",
    "work-moment.fixture.intake-clarification.record.quote-validity-elapsed.detail": "The quotation's stated validity ended on 9 August. It remains readable as last-good context until replaced or accepted.",
    "work-moment.fixture.intake-clarification.record.quote-validity-elapsed.label": "Quotation validity elapsed",
    "work-moment.fixture.intake-clarification.record.route-proposed.detail": "The agent proposed the matching offering route with its evidence. No routing is committed until the case releases.",
    "work-moment.fixture.intake-clarification.record.route-proposed.label": "Offering route proposed",
    "work-moment.fixture.invoice-exception-triage.evidence.invoice-line.definition": "The invoiced quantity for the line under exception review.",
    "work-moment.fixture.invoice-exception-triage.evidence.invoice-line.label": "Invoice quantity line",
    "work-moment.fixture.invoice-exception-triage.evidence.invoice-line.source": "ERP invoice record",
    "work-moment.fixture.invoice-exception-triage.evidence.policy-envelope.definition": "The permitted action, materiality, evidence and freshness conditions for this exception class.",
    "work-moment.fixture.invoice-exception-triage.evidence.policy-envelope.label": "Exception policy envelope",
    "work-moment.fixture.invoice-exception-triage.evidence.policy-envelope.source": "Approved invoice exception policy",
    "work-moment.fixture.invoice-exception-triage.evidence.receipt-record.definition": "The last-good received quantity recorded against the purchase-order line.",
    "work-moment.fixture.invoice-exception-triage.evidence.receipt-record.label": "Receipt quantity",
    "work-moment.fixture.invoice-exception-triage.evidence.receipt-record.source": "ERP receipt record",
    "work-moment.fixture.invoice-exception-triage.mode.evidence.heading": "Is the receipt evidence current enough?",
    "work-moment.fixture.invoice-exception-triage.mode.evidence.summary": "The last-good receipt remains visible with its age. The case cannot clear until the owning source reconciles it.",
    "work-moment.fixture.invoice-exception-triage.mode.learning.heading": "Should this correction pattern change?",
    "work-moment.fixture.invoice-exception-triage.mode.learning.summary": "Reviewed corrections and reopened outcomes form an evaluation cohort. A controller owns any policy change and rollback.",
    "work-moment.fixture.invoice-exception-triage.mode.supervise.heading": "What needs judgement now?",
    "work-moment.fixture.invoice-exception-triage.mode.supervise.summary": "Routine coding corrections continue inside policy. A stale receipt record stops the quantity mismatch for AP judgement.",
    "work-moment.fixture.invoice-exception-triage.record.coding-correction-proposed.detail": "The proposal identifies the exact field, rule version and reversible source action. It has committed no effect.",
    "work-moment.fixture.invoice-exception-triage.record.coding-correction-proposed.label": "Coding correction proposed",
    "work-moment.fixture.invoice-exception-triage.record.correction-cohort-reviewed.detail": "Sampled corrections met the declared evidence rule. The controller retains the current policy and review sample.",
    "work-moment.fixture.invoice-exception-triage.record.correction-cohort-reviewed.label": "Correction cohort reviewed",
    "work-moment.fixture.invoice-exception-triage.record.receipt-needs-judgement.detail": "The receipt source is stale and could change the payable quantity, so autonomous correction stops.",
    "work-moment.fixture.invoice-exception-triage.record.receipt-needs-judgement.label": "Receipt evidence needs judgement",
    "work-moment.fixture.invoice-exception-triage.record.receipt-source-stale.detail": "Last-good receipt evidence remains visible from 8 August. Refresh and reconcile before changing the payable amount.",
    "work-moment.fixture.invoice-exception-triage.record.receipt-source-stale.label": "Receipt source is stale",
    "work-moment.fixture.invoice-exception-triage.record.routine-case-committed.detail": "The source accepted a permitted correction and returned a receipt. The case closed against that committed state.",
    "work-moment.fixture.invoice-exception-triage.record.routine-case-committed.label": "Routine case reconciled",
    "work-moment.fixture.invoice-exception-triage.record.routine-route-ready.detail": "The discrepancy and permitted owner route are current and inside the approved exception envelope.",
    "work-moment.fixture.invoice-exception-triage.record.routine-route-ready.label": "Routine route ready",
    "work-moment.fixture.partial": "Conflicting evidence retained",
    "work-moment.fixture.renewal-window-decision.evidence.consumption-and-performance.definition": "Ordered volume, delivered service and obligation findings for the agreement, compared with what the terms promise.",
    "work-moment.fixture.renewal-window-decision.evidence.consumption-and-performance.label": "Consumption and performance record",
    "work-moment.fixture.renewal-window-decision.evidence.consumption-and-performance.source": "ERP order, receipt and performance projections",
    "work-moment.fixture.renewal-window-decision.evidence.executed-terms-extract.definition": "The governing terms of the agreement in the open window: price basis, indexation, notice period and termination rights.",
    "work-moment.fixture.renewal-window-decision.evidence.executed-terms-extract.label": "Executed terms extract",
    "work-moment.fixture.renewal-window-decision.evidence.executed-terms-extract.source": "Contract repository, executed version",
    "work-moment.fixture.renewal-window-decision.evidence.option-value-assessment.definition": "The modelled value of renewing, renegotiating and exiting the agreement; two value readings currently disagree on the renegotiation range.",
    "work-moment.fixture.renewal-window-decision.evidence.option-value-assessment.label": "Option value assessment",
    "work-moment.fixture.renewal-window-decision.evidence.option-value-assessment.source": "Modelled from terms, consumption and market reference prices",
    "work-moment.fixture.renewal-window-decision.evidence.renewal-window-calendar.definition": "Every covered agreement's renewal, notice and option dates, with the lead time each decision needs before its deadline.",
    "work-moment.fixture.renewal-window-decision.evidence.renewal-window-calendar.label": "Renewal window calendar",
    "work-moment.fixture.renewal-window-decision.evidence.renewal-window-calendar.source": "Computed from executed contract terms and notice-period rules",
    "work-moment.fixture.renewal-window-decision.mode.explore.heading": "Open the evidence behind the paths",
    "work-moment.fixture.renewal-window-decision.mode.explore.summary": "Every consequence in a prepared path opens to the terms, transactions and assessments it rests on, and disagreement stays visible rather than averaged away.",
    "work-moment.fixture.renewal-window-decision.mode.review.heading": "Review the decided path",
    "work-moment.fixture.renewal-window-decision.mode.review.summary": "The decision, the evidence versions behind it and the executed outcome stay attached, so the next window starts from what this one taught.",
    "work-moment.fixture.renewal-window-decision.mode.supervise.heading": "Supervise the open window",
    "work-moment.fixture.renewal-window-decision.mode.supervise.summary": "The window, the terms behind it and the prepared paths arrive as one picture, and the decision waits for a named owner while there is still lead time.",
    "work-moment.fixture.renewal-window-decision.record.lifecycle-paths-prepared.detail": "Each path carries its commercial, operational and reversibility consequences with exact sources; the proposal waits for the contract manager's decision.",
    "work-moment.fixture.renewal-window-decision.record.lifecycle-paths-prepared.label": "Renew, renegotiate and exit paths prepared",
    "work-moment.fixture.renewal-window-decision.record.option-values-disagree.detail": "Two value readings diverge on the renegotiation range; the prepared path carries both readings and the divergence is marked, not averaged.",
    "work-moment.fixture.renewal-window-decision.record.option-values-disagree.label": "Value readings disagree",
    "work-moment.fixture.renewal-window-decision.record.path-decision-committed.detail": "A named contract manager decided the path inside the notice window; the record carries the decision, the authority and the prepared paths it chose between.",
    "work-moment.fixture.renewal-window-decision.record.path-decision-committed.label": "Lifecycle path decided",
    "work-moment.fixture.renewal-window-decision.record.terms-read-against-use.detail": "Delivered volume and service are compared with the executed terms, so the renew case rests on what the agreement actually did, not on what it promised.",
    "work-moment.fixture.renewal-window-decision.record.terms-read-against-use.label": "Terms read against use",
    "work-moment.fixture.renewal-window-decision.record.window-basis-reproduced.detail": "The notice deadline recomputes from the executed terms and the notice-period rules, so the contract manager can verify why the window opened when it did.",
    "work-moment.fixture.renewal-window-decision.record.window-basis-reproduced.label": "Window basis reproduced",
    "work-moment.fixture.renewal-window-decision.record.window-opened.detail": "The agreement reaches its notice deadline next month; deciding after that date forfeits the renegotiation and exit paths, so the case is raised now with its lead time stated.",
    "work-moment.fixture.renewal-window-decision.record.window-opened.label": "Decision window open",
    "work-moment.fixture.renewal-window-decision.record.window-outcome-reviewed.detail": "The executed change is compared with the consequences the chosen path assumed, and the variance feeds the preparation of the next window.",
    "work-moment.fixture.renewal-window-decision.record.window-outcome-reviewed.label": "Window outcome reviewed",
    "work-moment.fixture.savings-validation.evidence.adjustment-claim.definition": "The initiative's claimed market-movement adjustment for the period.",
    "work-moment.fixture.savings-validation.evidence.adjustment-claim.label": "Claimed market adjustment",
    "work-moment.fixture.savings-validation.evidence.adjustment-claim.source": "Initiative claim record",
    "work-moment.fixture.savings-validation.evidence.committed-baseline.definition": "The pinned baseline, scope and method the initiative committed to measure against.",
    "work-moment.fixture.savings-validation.evidence.committed-baseline.label": "Committed baseline",
    "work-moment.fixture.savings-validation.evidence.committed-baseline.source": "Measurement contract record",
    "work-moment.fixture.savings-validation.evidence.period-actuals.definition": "The actual transaction facts for the initiative scope and period.",
    "work-moment.fixture.savings-validation.evidence.period-actuals.label": "Period actuals",
    "work-moment.fixture.savings-validation.evidence.period-actuals.source": "Finance ledger extract",
    "work-moment.fixture.savings-validation.mode.evidence.heading": "Can the claimed adjustment stand?",
    "work-moment.fixture.savings-validation.mode.evidence.summary": "Open the claim to its baseline snapshot, actual records, method version and the market evidence behind each adjustment.",
    "work-moment.fixture.savings-validation.mode.learning.heading": "Should the method change?",
    "work-moment.fixture.savings-validation.mode.learning.summary": "Forecast errors and rejected claims become method evaluation cases only after finance accepts their treatment.",
    "work-moment.fixture.savings-validation.mode.office.heading": "Continue in the native working artefact",
    "work-moment.fixture.savings-validation.mode.office.summary": "Conductor holds the reproducible validation workbook and returns the validated result to the Workblock record.",
    "work-moment.fixture.savings-validation.mode.supervise.heading": "What needs judgement now?",
    "work-moment.fixture.savings-validation.mode.supervise.summary": "The claimed result calculates from the committed baseline. One claimed adjustment conflicts with the market evidence and holds validation.",
    "work-moment.fixture.savings-validation.office.conductor.label": "Savings validation workbook",
    "work-moment.fixture.savings-validation.office.conductor.proposal": "Recalculate the result with the disputed adjustment excluded and preserve the claimed version.",
    "work-moment.fixture.savings-validation.office.conductor.return": "Validated result and source-reference receipt",
    "work-moment.fixture.savings-validation.office.conductor.scope": "Named ranges for baseline, actuals, adjustments and validated result",
    "work-moment.fixture.savings-validation.office.conductor.type": "Native XLSX validation model",
    "work-moment.fixture.savings-validation.office.conductor.version": "Reviewed model version 4",
    "work-moment.fixture.savings-validation.record.adjustment-conflict.detail": "The claimed market adjustment disagrees with the observed index, so validation waits for the value lead's restatement.",
    "work-moment.fixture.savings-validation.record.adjustment-conflict.label": "Adjustment disputed",
    "work-moment.fixture.savings-validation.record.adjustment-evidence-conflict.detail": "The claimed adjustment and the observed market index state different movements for the same period.",
    "work-moment.fixture.savings-validation.record.adjustment-evidence-conflict.label": "Adjustment sources conflict",
    "work-moment.fixture.savings-validation.record.claim-calculated.detail": "The claimed amount reproduces from the pinned baseline, method version and period actuals.",
    "work-moment.fixture.savings-validation.record.claim-calculated.label": "Claimed result calculated",
    "work-moment.fixture.savings-validation.record.result-committed.detail": "Finance validated the restated amount after the reviewed workbook returned. Forecast, claimed and validated value remain separate records.",
    "work-moment.fixture.savings-validation.record.result-committed.label": "Validated result committed",
    "work-moment.fixture.savings-validation.record.validation-cohort-reviewed.detail": "The rejected adjustment and its restatement are retained for replay. The measurement method does not change until its owner approves a versioned release.",
    "work-moment.fixture.savings-validation.record.validation-cohort-reviewed.label": "Validation cohort reviewed",
    "work-moment.fixture.savings-validation.record.validation-proposed.detail": "The agent drafted a partial validation with the disputed adjustment excluded. No amount reaches the portfolio until finance commits.",
    "work-moment.fixture.savings-validation.record.validation-proposed.label": "Partial validation proposed",
    "work-moment.fixture.sourcing-event-amendment.evidence.clarification-question.definition": "The recorded participant question that triggered the amendment draft.",
    "work-moment.fixture.sourcing-event-amendment.evidence.clarification-question.label": "Supplier clarification question",
    "work-moment.fixture.sourcing-event-amendment.evidence.clarification-question.source": "Participant message record",
    "work-moment.fixture.sourcing-event-amendment.evidence.legacy-attachment.definition": "An earlier attachment that disagrees with the published specification on one requirement.",
    "work-moment.fixture.sourcing-event-amendment.evidence.legacy-attachment.label": "Legacy specification extract",
    "work-moment.fixture.sourcing-event-amendment.evidence.legacy-attachment.source": "Attached document reference",
    "work-moment.fixture.sourcing-event-amendment.evidence.published-version.definition": "The event basis version every current participant received.",
    "work-moment.fixture.sourcing-event-amendment.evidence.published-version.label": "Published event version",
    "work-moment.fixture.sourcing-event-amendment.evidence.published-version.source": "Event version record",
    "work-moment.fixture.sourcing-event-amendment.mode.evidence.heading": "Which basis did each bid answer?",
    "work-moment.fixture.sourcing-event-amendment.mode.evidence.summary": "Open every requirement to its version history, participant distribution and the responses pinned to it.",
    "work-moment.fixture.sourcing-event-amendment.mode.learning.heading": "Should the event template change?",
    "work-moment.fixture.sourcing-event-amendment.mode.learning.summary": "Amendment causes and downstream evaluation outcomes become template evaluation cases only after the sourcing lead accepts their treatment.",
    "work-moment.fixture.sourcing-event-amendment.mode.office.heading": "Continue in the native working artefacts",
    "work-moment.fixture.sourcing-event-amendment.mode.office.summary": "Composer carries the specification amendment. Conductor holds the evaluation workbook pinned to the published version, and both return their reviewed state to the Workblock.",
    "work-moment.fixture.sourcing-event-amendment.mode.supervise.heading": "What needs judgement now?",
    "work-moment.fixture.sourcing-event-amendment.mode.supervise.summary": "The amendment draft is ready. One conflicting legacy attachment holds publication until the basis is confirmed.",
    "work-moment.fixture.sourcing-event-amendment.office.composer.label": "Event specification amendment",
    "work-moment.fixture.sourcing-event-amendment.office.composer.proposal": "Update the bounded requirement section from the confirmed basis with tracked changes.",
    "work-moment.fixture.sourcing-event-amendment.office.composer.return": "Reviewed amendment version and publication decision",
    "work-moment.fixture.sourcing-event-amendment.office.composer.scope": "Amended requirement section and participant notice",
    "work-moment.fixture.sourcing-event-amendment.office.composer.type": "Native DOCX specification",
    "work-moment.fixture.sourcing-event-amendment.office.composer.version": "Reviewed amendment version 4",
    "work-moment.fixture.sourcing-event-amendment.office.conductor.label": "Evaluation workbook",
    "work-moment.fixture.sourcing-event-amendment.office.conductor.proposal": "Rebind the affected criterion to amendment version 4 and preserve the prior scores.",
    "work-moment.fixture.sourcing-event-amendment.office.conductor.return": "Workbook result and basis-reference receipt",
    "work-moment.fixture.sourcing-event-amendment.office.conductor.scope": "Named ranges for criteria, weights and response scores",
    "work-moment.fixture.sourcing-event-amendment.office.conductor.type": "Native XLSX evaluation model",
    "work-moment.fixture.sourcing-event-amendment.office.conductor.version": "Reviewed workbook version 6",
    "work-moment.fixture.sourcing-event-amendment.record.amendment-cohort-reviewed.detail": "The clarification pattern is retained for replay against the event template. The template does not change until its owner approves a versioned release.",
    "work-moment.fixture.sourcing-event-amendment.record.amendment-cohort-reviewed.label": "Amendment cohort reviewed",
    "work-moment.fixture.sourcing-event-amendment.record.amendment-committed.detail": "The sourcing lead published amendment version 4 to all participants after the reviewed artefacts returned. Every response remains linked to the version it answered.",
    "work-moment.fixture.sourcing-event-amendment.record.amendment-committed.label": "Amendment published",
    "work-moment.fixture.sourcing-event-amendment.record.amendment-proposed.detail": "The agent's amendment remains a proposal. No participant sees it until the sourcing lead publishes a new version.",
    "work-moment.fixture.sourcing-event-amendment.record.amendment-proposed.label": "Amendment proposed",
    "work-moment.fixture.sourcing-event-amendment.record.attachment-conflict.detail": "A legacy attachment names a different requirement value than the published basis, so publication waits for the sourcing lead.",
    "work-moment.fixture.sourcing-event-amendment.record.attachment-conflict.label": "Legacy attachment disputed",
    "work-moment.fixture.sourcing-event-amendment.record.draft-ready.detail": "The drafted amendment, participant message and version impact reproduce from the recorded question.",
    "work-moment.fixture.sourcing-event-amendment.record.draft-ready.label": "Amendment draft ready",
    "work-moment.fixture.sourcing-event-amendment.record.requirement-conflict.detail": "The published basis and the legacy extract state different acceptance thresholds for the same requirement.",
    "work-moment.fixture.sourcing-event-amendment.record.requirement-conflict.label": "Requirement sources conflict",
    "work-moment.fixture.stale": "Stale evidence retained",
    "work-moment.fixture.supplier-performance-review.evidence.delivery-score.definition": "The share of in-scope deliveries meeting the agreed delivery condition for the review period.",
    "work-moment.fixture.supplier-performance-review.evidence.delivery-score.label": "Delivery score",
    "work-moment.fixture.supplier-performance-review.evidence.delivery-score.source": "Operational delivery records",
    "work-moment.fixture.supplier-performance-review.evidence.quality-score.definition": "The approved quality measure for accepted observations in the review period.",
    "work-moment.fixture.supplier-performance-review.evidence.quality-score.label": "Quality score",
    "work-moment.fixture.supplier-performance-review.evidence.quality-score.source": "Quality observations and scorecard method",
    "work-moment.fixture.supplier-performance-review.evidence.supplier-response.definition": "The supplier's recorded challenge to the population included in the quality measure.",
    "work-moment.fixture.supplier-performance-review.evidence.supplier-response.label": "Supplier response",
    "work-moment.fixture.supplier-performance-review.evidence.supplier-response.source": "Supplier review response",
    "work-moment.fixture.supplier-performance-review.mode.evidence.heading": "Can the disputed score stand?",
    "work-moment.fixture.supplier-performance-review.mode.evidence.summary": "Open the score to the observations, definition, source owner and supplier response before deciding whether to retain or correct it.",
    "work-moment.fixture.supplier-performance-review.mode.learning.heading": "Should the evaluation set change?",
    "work-moment.fixture.supplier-performance-review.mode.learning.summary": "A corrected dispute can enter the reviewed evaluation set only after the governance owner accepts its treatment and replay result.",
    "work-moment.fixture.supplier-performance-review.mode.office.heading": "Continue in the native working artefacts",
    "work-moment.fixture.supplier-performance-review.mode.office.summary": "Conductor holds the reproducible scorecard. Composer carries the review pack and returns the reviewed decision to the Workblock record.",
    "work-moment.fixture.supplier-performance-review.mode.supervise.heading": "What needs judgement now?",
    "work-moment.fixture.supplier-performance-review.mode.supervise.summary": "The review pack is assembled. One disputed quality measure stops the relationship conclusion and proposed corrective action.",
    "work-moment.fixture.supplier-performance-review.office.composer.label": "Supplier review pack",
    "work-moment.fixture.supplier-performance-review.office.composer.proposal": "Update the bounded findings section with the corrected score and tracked source references.",
    "work-moment.fixture.supplier-performance-review.office.composer.return": "Reviewed pack version and committed review decision",
    "work-moment.fixture.supplier-performance-review.office.composer.scope": "Quality findings section, source table and proposed corrective-action paragraph",
    "work-moment.fixture.supplier-performance-review.office.composer.type": "Native DOCX review pack",
    "work-moment.fixture.supplier-performance-review.office.composer.version": "Reviewed pack version 7",
    "work-moment.fixture.supplier-performance-review.office.conductor.label": "Supplier performance scorecard",
    "work-moment.fixture.supplier-performance-review.office.conductor.proposal": "Recalculate the disputed quality measure from the accepted source population and preserve the prior result.",
    "work-moment.fixture.supplier-performance-review.office.conductor.return": "Scorecard result and source-reference receipt",
    "work-moment.fixture.supplier-performance-review.office.conductor.scope": "Named ranges for the quality population, delivery observations and score calculation",
    "work-moment.fixture.supplier-performance-review.office.conductor.type": "Native XLSX scorecard",
    "work-moment.fixture.supplier-performance-review.office.conductor.version": "Reviewed scorecard version 12",
    "work-moment.fixture.supplier-performance-review.record.corrective-action-proposed.detail": "The agent drafted a bounded evidence-reconciliation action. No supplier or contract commitment has been made.",
    "work-moment.fixture.supplier-performance-review.record.corrective-action-proposed.label": "Corrective action proposed",
    "work-moment.fixture.supplier-performance-review.record.disputed-score-reviewed.detail": "The correction and outcome are retained for replay. The scorecard method does not change until its owner approves a versioned release.",
    "work-moment.fixture.supplier-performance-review.record.disputed-score-reviewed.label": "Disputed score cohort reviewed",
    "work-moment.fixture.supplier-performance-review.record.quality-score-disputed.detail": "The supplier says one service population was excluded. The relationship conclusion waits for the metric owner.",
    "work-moment.fixture.supplier-performance-review.record.quality-score-disputed.label": "Quality score disputed",
    "work-moment.fixture.supplier-performance-review.record.review-outcome-committed.detail": "The relationship manager accepted the corrected measure and owned action after the reviewed artefacts returned to the Workblock.",
    "work-moment.fixture.supplier-performance-review.record.review-outcome-committed.label": "Review outcome committed",
    "work-moment.fixture.supplier-performance-review.record.review-pack-ready.detail": "Current delivery observations and the approved scorecard version are present for review.",
    "work-moment.fixture.supplier-performance-review.record.review-pack-ready.label": "Review pack assembled",
    "work-moment.fixture.supplier-performance-review.record.score-source-conflict.detail": "The operational extract and supplier response name different in-scope service records for the same period.",
    "work-moment.fixture.supplier-performance-review.record.score-source-conflict.label": "Source populations conflict",
    "work-moment.fixture.tail-spend-consolidation.evidence.channel-position.definition": "Which governed channels currently cover the clustered demand; the catalogue extract is older than its declared refresh window.",
    "work-moment.fixture.tail-spend-consolidation.evidence.channel-position.label": "Channel position",
    "work-moment.fixture.tail-spend-consolidation.evidence.channel-position.source": "Catalogue and channel rule extract",
    "work-moment.fixture.tail-spend-consolidation.evidence.repeat-purchase-history.definition": "The buying requests and closed cases for an illustrative facilities-supplies family, grouped by item similarity across four business units.",
    "work-moment.fixture.tail-spend-consolidation.evidence.repeat-purchase-history.label": "Repeat purchase history",
    "work-moment.fixture.tail-spend-consolidation.evidence.repeat-purchase-history.source": "Buying request and tactical case records",
    "work-moment.fixture.tail-spend-consolidation.evidence.supplier-overlap-map.definition": "The suppliers serving the clustered purchases, with the contracted suppliers already able to carry the volume marked.",
    "work-moment.fixture.tail-spend-consolidation.evidence.supplier-overlap-map.label": "Supplier overlap map",
    "work-moment.fixture.tail-spend-consolidation.evidence.supplier-overlap-map.source": "Computed from supplier profiles and contract records",
    "work-moment.fixture.tail-spend-consolidation.evidence.tail-spend-evaluation.definition": "The governed evaluation that marks which spend records fall in the tail under the released definition, with the rule version attached.",
    "work-moment.fixture.tail-spend-consolidation.evidence.tail-spend-evaluation.label": "Tail spend evaluation",
    "work-moment.fixture.tail-spend-consolidation.evidence.tail-spend-evaluation.source": "Derived from governed spend records under the released tail rule",
    "work-moment.fixture.tail-spend-consolidation.mode.explore.heading": "Open the evidence behind the cluster",
    "work-moment.fixture.tail-spend-consolidation.mode.explore.summary": "Every clustered purchase opens to its source records, and stale channel evidence stays marked rather than silently trusted.",
    "work-moment.fixture.tail-spend-consolidation.mode.review.heading": "Review the authorised consolidation",
    "work-moment.fixture.tail-spend-consolidation.mode.review.summary": "The decision and its outcome stay attached to the evidence that carried them, so the next refresh starts from what actually happened.",
    "work-moment.fixture.tail-spend-consolidation.mode.supervise.heading": "Supervise the consolidation picture",
    "work-moment.fixture.tail-spend-consolidation.mode.supervise.summary": "The repeat pattern, the assembled cluster and the proposed candidate arrive as one picture; the flagged pattern and the proposal wait for a named decision.",
    "work-moment.fixture.tail-spend-consolidation.record.candidate-authorized.detail": "A named category manager authorised the consolidation candidate, naming the cluster boundary, the carrying supplier and the target channel; the record carries the decision, the authority and the evidence versions.",
    "work-moment.fixture.tail-spend-consolidation.record.candidate-authorized.label": "Candidate authorised",
    "work-moment.fixture.tail-spend-consolidation.record.channel-position-stale.detail": "The catalogue extract behind the channel position is older than its declared refresh window; the candidate carries the last-good position with its age visible.",
    "work-moment.fixture.tail-spend-consolidation.record.channel-position-stale.label": "Channel position stale",
    "work-moment.fixture.tail-spend-consolidation.record.cluster-assembled.detail": "The repeat purchases group by item similarity and supplier overlap into one candidate cluster, with each member purchase linked to its source record.",
    "work-moment.fixture.tail-spend-consolidation.record.cluster-assembled.label": "Cluster assembled",
    "work-moment.fixture.tail-spend-consolidation.record.cluster-basis-reproduced.detail": "The cluster recomputes from the cited purchases and the released tail definition, so the category manager can inspect exactly what the proposal rests on.",
    "work-moment.fixture.tail-spend-consolidation.record.cluster-basis-reproduced.label": "Cluster basis reproduced",
    "work-moment.fixture.tail-spend-consolidation.record.consolidation-candidate-proposed.detail": "The proposed candidate names the cluster boundary, the carrying supplier options and the target channel basis, and cites the repeat history it rests on.",
    "work-moment.fixture.tail-spend-consolidation.record.consolidation-candidate-proposed.label": "Consolidation candidate proposed",
    "work-moment.fixture.tail-spend-consolidation.record.consolidation-outcome-reviewed.detail": "The next tail evaluation is compared with the position the candidate assumed; the movement and its reading feed the next consolidation decision.",
    "work-moment.fixture.tail-spend-consolidation.record.consolidation-outcome-reviewed.label": "Consolidation outcome reviewed",
    "work-moment.fixture.tail-spend-consolidation.record.repeat-pattern-flagged.detail": "The same need has been bought repeatedly across business units under the released tail definition; the repetition sits outside the declared channel strategy.",
    "work-moment.fixture.tail-spend-consolidation.record.repeat-pattern-flagged.label": "Repeat pattern flagged",
    "work-moment.fixture.third-party-risk-decision.evidence.questionnaire-response.definition": "The supplier's answered control questionnaire for the same assessed scope.",
    "work-moment.fixture.third-party-risk-decision.evidence.questionnaire-response.label": "Questionnaire response",
    "work-moment.fixture.third-party-risk-decision.evidence.questionnaire-response.source": "Supplier questionnaire",
    "work-moment.fixture.third-party-risk-decision.evidence.security-certificate.definition": "The supplier's current certification for the in-scope service and geography.",
    "work-moment.fixture.third-party-risk-decision.evidence.security-certificate.label": "Security certification",
    "work-moment.fixture.third-party-risk-decision.evidence.security-certificate.source": "Assurance platform record",
    "work-moment.fixture.third-party-risk-decision.evidence.service-scope.definition": "The actual service, data access and geography that derive the assessment scope.",
    "work-moment.fixture.third-party-risk-decision.evidence.service-scope.label": "Assessed service scope",
    "work-moment.fixture.third-party-risk-decision.evidence.service-scope.source": "Service and access records",
    "work-moment.fixture.third-party-risk-decision.mode.evidence.heading": "Can both assurance sources stand?",
    "work-moment.fixture.third-party-risk-decision.mode.evidence.summary": "Open the conflicting control to both sources with purpose, scope, freshness and verification level visible.",
    "work-moment.fixture.third-party-risk-decision.mode.learning.heading": "Should the method change?",
    "work-moment.fixture.third-party-risk-decision.mode.learning.summary": "Validated incidents and conflict resolutions become method evaluation cases only after the programme owner accepts their treatment.",
    "work-moment.fixture.third-party-risk-decision.mode.office.heading": "Continue in the native working artefacts",
    "work-moment.fixture.third-party-risk-decision.mode.office.summary": "Conductor holds the reproducible scoring workbook. Composer carries the decision package and returns the committed decision to the Workblock record.",
    "work-moment.fixture.third-party-risk-decision.mode.supervise.heading": "What needs judgement now?",
    "work-moment.fixture.third-party-risk-decision.mode.supervise.summary": "The decision package is scored and scoped. One conflict between certificate and questionnaire holds the sufficiency verdict.",
    "work-moment.fixture.third-party-risk-decision.office.composer.label": "Risk decision package",
    "work-moment.fixture.third-party-risk-decision.office.composer.proposal": "Update the bounded findings section with the resolved conflict and tracked source references.",
    "work-moment.fixture.third-party-risk-decision.office.composer.return": "Reviewed package version and committed risk decision",
    "work-moment.fixture.third-party-risk-decision.office.composer.scope": "Findings section, evidence table and conditions paragraph",
    "work-moment.fixture.third-party-risk-decision.office.composer.type": "Native DOCX decision package",
    "work-moment.fixture.third-party-risk-decision.office.composer.version": "Reviewed package version 3",
    "work-moment.fixture.third-party-risk-decision.office.conductor.label": "Risk scoring workbook",
    "work-moment.fixture.third-party-risk-decision.office.conductor.proposal": "Recalculate the affected control score from the resolved evidence and preserve the prior result.",
    "work-moment.fixture.third-party-risk-decision.office.conductor.return": "Score result and evidence-reference receipt",
    "work-moment.fixture.third-party-risk-decision.office.conductor.scope": "Named ranges for control results, weights and score calculation",
    "work-moment.fixture.third-party-risk-decision.office.conductor.type": "Native XLSX scoring model",
    "work-moment.fixture.third-party-risk-decision.office.conductor.version": "Reviewed model version 5",
    "work-moment.fixture.third-party-risk-decision.record.conflict-cohort-reviewed.detail": "The control conflict and its resolution are retained for replay. The assessment method does not change until its owner approves a versioned release.",
    "work-moment.fixture.third-party-risk-decision.record.conflict-cohort-reviewed.label": "Conflict cohort reviewed",
    "work-moment.fixture.third-party-risk-decision.record.control-conflict.detail": "The certification asserts the control is operating while the questionnaire declares it not applicable for the same scope.",
    "work-moment.fixture.third-party-risk-decision.record.control-conflict.label": "Control evidence conflicts",
    "work-moment.fixture.third-party-risk-decision.record.decision-committed.detail": "The accountable owner accepted the risk with two conditions after the reviewed artefacts returned. Each condition carries an owner and an expiry.",
    "work-moment.fixture.third-party-risk-decision.record.decision-committed.label": "Risk decision committed",
    "work-moment.fixture.third-party-risk-decision.record.decision-proposed.detail": "The agent drafted an accept-with-conditions proposal. No risk is accepted until the accountable owner decides.",
    "work-moment.fixture.third-party-risk-decision.record.decision-proposed.label": "Decision proposed",
    "work-moment.fixture.third-party-risk-decision.record.evidence-conflict.detail": "The certificate and questionnaire disagree on one control, so the sufficiency verdict waits for the programme owner.",
    "work-moment.fixture.third-party-risk-decision.record.evidence-conflict.label": "Assurance evidence disputed",
    "work-moment.fixture.third-party-risk-decision.record.package-ready.detail": "Scope, evidence and score reproduce from the recorded method version and current sources.",
    "work-moment.fixture.third-party-risk-decision.record.package-ready.label": "Decision package assembled",
    "work-moment.frame.action-scope": "Allowed action classes",
    "work-moment.frame.agent-mission": "Module agent mission",
    "work-moment.frame.artifact": "Artefact",
    "work-moment.frame.authority": "Authority and intervention",
    "work-moment.frame.authority-posture": "Autonomy posture",
    "work-moment.frame.authority-source": "Authority source",
    "work-moment.frame.escalation": "Always escalate",
    "work-moment.frame.escalation-owner": "Escalation owner",
    "work-moment.frame.evidence": "Evidence and freshness",
    "work-moment.frame.evidence-owner": "Evidence owner",
    "work-moment.frame.evidence-source": "Source",
    "work-moment.frame.freshness": "Freshness",
    "work-moment.frame.grantor": "Authority grantor",
    "work-moment.frame.human-supervision": "Human supervision",
    "work-moment.frame.intervention-rights": "Intervention rights",
    "work-moment.frame.learning": "Learning decision",
    "work-moment.frame.learning-evaluation": "Evaluation result",
    "work-moment.frame.learning-proposal": "Reviewed adaptation proposal",
    "work-moment.frame.mode-label": "Work moment mode",
    "work-moment.frame.module-status": "Module status",
    "work-moment.frame.observed-at": "Observed",
    "work-moment.frame.office-handoff": "Office handoff",
    "work-moment.frame.outcome": "Outcome state",
    "work-moment.frame.outcome-owner": "Outcome owner",
    "work-moment.frame.proof-maturity": "Differentiator maturity",
    "work-moment.frame.proposed-mutation": "Proposed mutation",
    "work-moment.frame.provenance": "Provenance",
    "work-moment.frame.read-back-result": "Read-back result",
    "work-moment.frame.record-owner": "Record owner",
    "work-moment.frame.recovery": "Recovery",
    "work-moment.frame.release-owner": "Release owner",
    "work-moment.frame.reviewed-version": "Reviewed version",
    "work-moment.frame.role-situation": "Role situation",
    "work-moment.frame.rollback": "Rollback",
    "work-moment.frame.scope": "Native scope",
    "work-moment.frame.workblock-return": "Workblock return",
    "work-moment.freshness.conflicting": "Conflicting",
    "work-moment.freshness.current": "Current",
    "work-moment.freshness.stale": "Stale",
    "work-moment.guided-buying-route.agent-contribution": "The requester buying agent resolves the need to eligible options, assembles policy and budget context and completes the routine steps of an approved route. It cannot commit an order or bypass an approval.",
    "work-moment.guided-buying-route.coexistence": "Catalogues, contracts and the ERP remain authoritative for items, prices and orders. The Workblock holds the route, its evidence and the mission boundary without duplicating those records.",
    "work-moment.guided-buying-route.perspective.procurement-buyer.before": "Untangle off-catalogue requests after the fact and repair miscoded orders that guidance never saw.",
    "work-moment.guided-buying-route.perspective.procurement-buyer.now": "Judge the cases the mission returns, resolve off-path needs against current facts and correct the guidance source instead of the symptom.",
    "work-moment.guided-buying-route.perspective.procurement-buyer.responsibility": "Own off-path resolution and the integrity of every route the mission may take.",
    "work-moment.guided-buying-route.perspective.procurement-buyer.supervision": "Pause the mission class, redirect a case, revoke the grant or return a route to manual handling while the source is corrected.",
    "work-moment.guided-buying-route.perspective.requester.before": "Guess the right form, search old orders for a similar item and wait for rejections to learn the policy.",
    "work-moment.guided-buying-route.perspective.requester.now": "Describe the need, compare eligible options with price, policy and availability visible, and follow one route to a truthful status.",
    "work-moment.guided-buying-route.perspective.requester.responsibility": "State the need, choose among eligible options and stay informed without owning procurement mechanics.",
    "work-moment.guided-buying-route.perspective.requester.supervision": "Correct the stated need, decline a substituted option and stop the mission before any step with a financial consequence.",
    "work-moment.guided-buying-route.summary": "A requester follows a guided route while the buying agent completes the routine steps, and a stale catalogue feed returns the recommended option for buyer judgement.",
    "work-moment.guided-buying-route.title": "Route a purchase need through a bounded buying mission",
    "work-moment.illustration.committed": "The committed outcome",
    "work-moment.illustration.decision": "A person decides",
    "work-moment.illustration.evidence": "The evidence",
    "work-moment.illustration.label": "How the moment unfolds",
    "work-moment.illustration.proposal": "The agent proposes",
    "work-moment.illustration.signal": "The signal",
    "work-moment.intake-clarification.agent-contribution": "The request intake agent assembles one canonical request across channels, selects only the clarification worth asking and links every file and message as an evidence reference. It cannot commit routing or downstream demand.",
    "work-moment.intake-clarification.coexistence": "Mail, chat and portal channels stay where people already work. The Workblock holds the canonical request, its evidence references and its clarification history without replacing those channels.",
    "work-moment.intake-clarification.perspective.intake-owner.before": "Reconcile duplicate submissions across channels, chase missing context and rebuild each case before routing can start.",
    "work-moment.intake-clarification.perspective.intake-owner.now": "Supervise clarification turns, judge stale or conflicting evidence and release only cases whose captured intent is complete enough to route.",
    "work-moment.intake-clarification.perspective.intake-owner.responsibility": "Own intake quality, clarification burden and the readiness of each case for routing.",
    "work-moment.intake-clarification.perspective.intake-owner.supervision": "Pause clarification, redirect a case, stop the intake mission, revoke the grant or reopen a case from its retained clarification history.",
    "work-moment.intake-clarification.perspective.requester.before": "Retype the same request into a portal, mail and chat, attach the same files twice and repeat the story to each new person who picks it up.",
    "work-moment.intake-clarification.perspective.requester.now": "Explain the need once in a familiar channel, see exactly what was understood and confirm the business need rather than procurement's routing.",
    "work-moment.intake-clarification.perspective.requester.responsibility": "State the business need, answer clarification once and commit what the need actually is.",
    "work-moment.intake-clarification.perspective.requester.supervision": "Correct the captured need, withdraw or restate the request and decline a clarification that exceeds what the routing decision requires.",
    "work-moment.intake-clarification.summary": "A requester states a business need in one channel while the intake owner supervises clarification, and a stale attached quotation returns for judgement before the case routes.",
    "work-moment.intake-clarification.title": "Explain a need once and keep it canonical",
    "work-moment.invoice-exception-triage.agent-contribution": "The invoice exception coordinator agent groups related symptoms, requests missing evidence and applies approved reversible coding or routing corrections. It cannot release payment or change protected supplier data.",
    "work-moment.invoice-exception-triage.coexistence": "The ERP retains the invoice, order, receipt and payment state. The Workblock holds the exception cause, evidence, owner and reconciled outcome without replacing that source responsibility.",
    "work-moment.invoice-exception-triage.perspective.ap-processor.before": "Inspect the invoice queue, search for receipts and policy, chase an owner and return later to confirm whether the source changed.",
    "work-moment.invoice-exception-triage.perspective.ap-processor.now": "Set the exception policy, supervise the cases outside it, judge stale or conflicting evidence and sample routine corrections.",
    "work-moment.invoice-exception-triage.perspective.ap-processor.responsibility": "Own each invoice exception until the source action is accepted and the case reconciles.",
    "work-moment.invoice-exception-triage.perspective.ap-processor.supervision": "Pause new corrections, redirect the case, stop mutation, revoke the grant, demote the exception cohort or reopen a case from its retained history.",
    "work-moment.invoice-exception-triage.summary": "An AP processor supervises routine exception work while stale receipt evidence and payment-consequential cases return for judgement.",
    "work-moment.invoice-exception-triage.title": "Resolve a quantity mismatch before the payment run",
    "work-moment.job-preview.browse-all": "Browse all Work moments for this job",
    "work-moment.job-preview.description": "One bounded example connects this job to its module agent, human authority, evidence and learning.",
    "work-moment.job-preview.other-perspectives": "Other role perspectives",
    "work-moment.job-preview.title": "See the job in practice",
    "work-moment.job.open": "Open the {label} job",
    "work-moment.mode.explore-evidence.label": "Explore evidence",
    "work-moment.mode.explore-evidence.question": "Can I trust the case?",
    "work-moment.mode.open-office-artifact.label": "Open Office artefact",
    "work-moment.mode.open-office-artifact.question": "Where does the native work happen?",
    "work-moment.mode.review-learning.label": "Review learning",
    "work-moment.mode.review-learning.question": "Should this operating class change?",
    "work-moment.mode.supervise-work.label": "Supervise work",
    "work-moment.mode.supervise-work.question": "What needs my judgement now?",
    "work-moment.not-found.action": "Return to Work moments",
    "work-moment.not-found.description": "This Work moment is not part of the current reference.",
    "work-moment.not-found.title": "Work moment not found",
    "work-moment.office.open": "Open {label}",
    "work-moment.outcome.records.plural": "{count} records retain their individual state below.",
    "work-moment.outcome.records.singular": "{count} record retains its individual state below.",
    "work-moment.perspective": "Role perspective",
    "work-moment.print.label": "Complete Work moment reference",
    "work-moment.proof.differentiator": "Differentiator",
    "work-moment.proof.heading": "What this moment proves",
    "work-moment.proof.illustrative": "Illustrative Work moment",
    "work-moment.proof.synthetic": "Synthetic data",
    "work-moment.provenance.human": "Human",
    "work-moment.provenance.machine": "Machine",
    "work-moment.provenance.source": "Source",
    "work-moment.renewal-window-decision.agent-contribution": "The contract change agent keeps every decision window current, assembles the terms, consumption and performance records behind it, and prepares the renew, renegotiate and exit paths with their consequences and sources. It proposes and routes; a named person decides the path, and the executed change reconciles back to the contract record.",
    "work-moment.renewal-window-decision.coexistence": "The contract repository remains authoritative for executed terms, and ERP systems keep orders, receipts and invoices. The Workblock reads their governed projections, keeps source references on every prepared path, and returns the decided path as a change case that authoring and approval carry to an executed version.",
    "work-moment.renewal-window-decision.perspective.contract-manager.before": "Keep expiry dates in spreadsheets and diary reminders, discover windows late, and assemble the renew-or-exit case by hand under notice-period pressure.",
    "work-moment.renewal-window-decision.perspective.contract-manager.now": "Supervise one window picture: the opening window, the terms behind it and the prepared paths arrive together, early enough to decide well.",
    "work-moment.renewal-window-decision.perspective.contract-manager.responsibility": "Own the renewal, notice and termination calendar and the lifecycle decision each window demands.",
    "work-moment.renewal-window-decision.perspective.contract-manager.supervision": "The contract manager weighs the prepared paths against their records and decides renew, renegotiate or exit by name; no window closes on a default.",
    "work-moment.renewal-window-decision.perspective.sourcing-manager.before": "Learn of an expiry when the business asks for continuity, with no time left to test the market or price an alternative path.",
    "work-moment.renewal-window-decision.perspective.sourcing-manager.now": "See each window with the consumption, price and performance readings beside it, and the renegotiation case prepared while there is still time to use it.",
    "work-moment.renewal-window-decision.perspective.sourcing-manager.responsibility": "Own the commercial position a renewal or renegotiation carries into the market.",
    "work-moment.renewal-window-decision.perspective.sourcing-manager.supervision": "The sourcing manager challenges the commercial case behind each prepared path while the window is open; the challenge and its outcome stay on the record.",
    "work-moment.renewal-window-decision.summary": "A contract manager supervises the renewal and notice calendar, opens the prepared renew, renegotiate and exit paths behind an opening window, and decides the path by name while the notice deadline still leaves room to act.",
    "work-moment.renewal-window-decision.title": "Decide a renewal window before it closes",
    "work-moment.savings-validation.agent-contribution": "The savings initiative agent assembles actuals against the committed measurement contract, calculates the claimed result and drafts the validation package. It cannot validate a result or restate a committed amount.",
    "work-moment.savings-validation.coexistence": "Finance and source ledgers remain authoritative for actuals and postings. The Workblock holds opportunity, baseline, forecast, actual and attribution as separate records while Conductor carries the validation workbook.",
    "work-moment.savings-validation.perspective.finance-delegate.before": "Rebuild the tracker's arithmetic, chase the original baseline assumptions and negotiate which number finance will stand behind.",
    "work-moment.savings-validation.perspective.finance-delegate.now": "Validate the claim against its pinned baseline, method version and actual evidence, and commit or reject the amount explicitly.",
    "work-moment.savings-validation.perspective.finance-delegate.responsibility": "Own the validation decision and the amount that reaches the portfolio.",
    "work-moment.savings-validation.perspective.finance-delegate.supervision": "Pause validation, reject a claim whose evidence does not reproduce, hold the portfolio update, revoke the grant or reopen a validated result.",
    "work-moment.savings-validation.perspective.value-lead.before": "Defend a headline saving from a spreadsheet whose baseline, adjustments and attribution nobody could replay.",
    "work-moment.savings-validation.perspective.value-lead.now": "See the claim, baseline and actuals as separate records, and restate the result under version control when the evidence moves.",
    "work-moment.savings-validation.perspective.value-lead.responsibility": "Own the initiative claim, its evidence and any restatement the actuals force.",
    "work-moment.savings-validation.perspective.value-lead.supervision": "Hold a claim with conflicting actuals, correct initiative evidence within remit and return the validation decision to finance.",
    "work-moment.savings-validation.summary": "A finance delegate validates a claimed result against the committed baseline and method while the value lead owns the restatement that conflicting actuals force.",
    "work-moment.savings-validation.title": "Validate a claimed saving against its own baseline",
    "work-moment.sourcing-event-amendment.agent-contribution": "The sourcing event designer agent drafts the specification amendment, the participant message and the version impact from the recorded clarification question. It cannot publish an amendment or alter a sealed bid.",
    "work-moment.sourcing-event-amendment.coexistence": "Supplier portals and mail remain the participant channels. The Workblock owns event identity and published versions while Composer carries the specification and Conductor carries the evaluation workbook.",
    "work-moment.sourcing-event-amendment.perspective.evaluator.before": "Score bids against a moving document, reconcile which answers matched which version and defend the result without a recorded basis.",
    "work-moment.sourcing-event-amendment.perspective.evaluator.now": "Score each response against its pinned basis version, cite evidence for every judgement and keep sealed content segregated until opening.",
    "work-moment.sourcing-event-amendment.perspective.evaluator.responsibility": "Own scores and their evidence against the exact published basis each bid answered.",
    "work-moment.sourcing-event-amendment.perspective.evaluator.supervision": "Hold a score whose basis is ambiguous, record a conflict of interest and return event design judgements to the sourcing lead.",
    "work-moment.sourcing-event-amendment.perspective.sourcing-lead.before": "Track which supplier saw which document version, redraft the specification by hand and hope the mailing list matched the portal.",
    "work-moment.sourcing-event-amendment.perspective.sourcing-lead.now": "Supervise the drafted amendment, judge its version impact and publish one consistent basis to every participant with authority recorded.",
    "work-moment.sourcing-event-amendment.perspective.sourcing-lead.responsibility": "Own the event design, its published basis and every amendment decision.",
    "work-moment.sourcing-event-amendment.perspective.sourcing-lead.supervision": "Pause or redirect drafting, reject an amendment that changes scope beyond the clarification, hold publication, revoke the grant or restore the prior published version.",
    "work-moment.sourcing-event-amendment.summary": "A sourcing lead supervises a drafted amendment while every participant stays on one published version, and an evaluator scores against the exact basis each bid answered.",
    "work-moment.sourcing-event-amendment.title": "Amend a live event without splitting its basis",
    "work-moment.state.awaiting-review": "Awaiting review",
    "work-moment.state.blocked-by-authority": "Blocked by authority",
    "work-moment.state.committed": "Committed",
    "work-moment.state.committing": "Committing",
    "work-moment.state.conflicting": "Conflicting",
    "work-moment.state.exception": "Exception",
    "work-moment.state.failed": "Failed",
    "work-moment.state.in-review": "In review",
    "work-moment.state.mixed": "Mixed states · {count} records",
    "work-moment.state.normal": "Normal",
    "work-moment.state.proposal": "Proposal",
    "work-moment.state.proposed": "Proposed",
    "work-moment.state.reversed": "Reversed",
    "work-moment.state.reviewed": "Reviewed",
    "work-moment.state.stale": "Stale",
    "work-moment.story.before": "Before",
    "work-moment.story.coexistence": "Coexistence",
    "work-moment.story.finish": "Observable finish",
    "work-moment.story.label": "How the work changes",
    "work-moment.story.now": "Now",
    "work-moment.story.progress": "Progress",
    "work-moment.story.role": "Role and situation",
    "work-moment.supplier-performance-review.agent-contribution": "The supplier performance review agent assembles current observations, reproduces approved measures and drafts the review pack. It stops when material evidence is disputed or a relationship commitment needs human authority.",
    "work-moment.supplier-performance-review.coexistence": "Operational and supplier systems remain authoritative for observations and commitments. The Workblock preserves their source references while Conductor carries the scorecard and Composer carries the review pack.",
    "work-moment.supplier-performance-review.perspective.metric-owner.before": "Trace a challenged score through workbook formulas, source extracts and emails before explaining which number can stand.",
    "work-moment.supplier-performance-review.perspective.metric-owner.now": "Open the score to its definition, observations, freshness and supplier response, then decide whether the data or method needs correction.",
    "work-moment.supplier-performance-review.perspective.metric-owner.responsibility": "Own the score definition, its source observations and any correction to the method or data.",
    "work-moment.supplier-performance-review.perspective.metric-owner.supervision": "Correct source or method evidence within remit, hold a score that cannot be reproduced and send the relationship conclusion back to its accountable owner.",
    "work-moment.supplier-performance-review.perspective.relationship-manager.before": "Assemble measures from separate reports, reconcile disputed versions and copy the conclusion into a review pack and action log.",
    "work-moment.supplier-performance-review.perspective.relationship-manager.now": "Set the review intent, supervise evidence assembly, judge the disputed score and commit only the actions inside delegated authority.",
    "work-moment.supplier-performance-review.perspective.relationship-manager.responsibility": "Own the review narrative, meeting decisions and follow-through.",
    "work-moment.supplier-performance-review.perspective.relationship-manager.supervision": "Pause or redirect evidence assembly, reject an unsupported narrative, stop action dispatch, revoke the grant, demote the operating version or restore the last-good review.",
    "work-moment.supplier-performance-review.summary": "A supplier relationship manager supervises the evidence pack, opens a disputed measure to its sources and carries the reviewed scorecard into an owned corrective action.",
    "work-moment.supplier-performance-review.title": "Resolve a disputed supplier score before the review",
    "work-moment.tail-spend-consolidation.agent-contribution": "The tail spend consolidation agent clusters repeat purchases across suppliers and channels, attaches the repeat history and overlap evidence, and proposes consolidation candidates as category opportunities. It proposes and routes; a named person authorises every candidate, and the conversion executes downstream under that decision.",
    "work-moment.tail-spend-consolidation.coexistence": "Spend, buying and card systems remain authoritative for their transactions. The Workblock reads their governed projections, preserves source references through every cluster, and returns the authorised candidate as a bounded record for downstream sourcing and catalogue work.",
    "work-moment.tail-spend-consolidation.perspective.category-manager.before": "Export spend cubes once a year, hunt repeat purchases by hand, and watch the tail refragment before the analysis is finished.",
    "work-moment.tail-spend-consolidation.perspective.category-manager.now": "Supervise one consolidation picture: the repeat pattern, the supplier overlap and the proposed cluster arrive together, with every candidate awaiting an explicit decision.",
    "work-moment.tail-spend-consolidation.perspective.category-manager.responsibility": "Own the category opportunity portfolio and the consolidation candidates that reshape the tail.",
    "work-moment.tail-spend-consolidation.perspective.category-manager.supervision": "The category manager reviews each proposed cluster against its repeat evidence, adjusts the boundary and commits or declines it by name; nothing consolidates on a model's word.",
    "work-moment.tail-spend-consolidation.summary": "A category manager supervises the long tail of repeat purchases, opens the repeat history and supplier overlap behind a proposed consolidation cluster, and authorises converting the cluster into a governed buying channel.",
    "work-moment.tail-spend-consolidation.title": "Turn repeat tail buys into one governed channel",
    "work-moment.third-party-risk-decision.agent-contribution": "The third-party risk assessment agent derives the assessment scope, assembles evidence with purpose and freshness checks and drafts the scored decision package. It cannot accept a risk or waive a control.",
    "work-moment.third-party-risk-decision.coexistence": "Assurance platforms, certificates and questionnaires remain the evidence sources. The Workblock holds scope, sufficiency, score and decision as separate records while Conductor carries the scoring workbook and Composer carries the decision package.",
    "work-moment.third-party-risk-decision.perspective.accountable-risk-owner.before": "Receive a score without its basis, chase certificates by mail and sign a decision whose evidence nobody could reassemble.",
    "work-moment.third-party-risk-decision.perspective.accountable-risk-owner.now": "Judge a decision package whose scope, evidence sufficiency and score are separately visible, and commit acceptance, conditions or rejection explicitly.",
    "work-moment.third-party-risk-decision.perspective.accountable-risk-owner.responsibility": "Own the risk decision, its conditions and the residual exposure that remains after it.",
    "work-moment.third-party-risk-decision.perspective.accountable-risk-owner.supervision": "Pause or redirect assessment, reject a package with insufficient evidence, hold the decision, revoke the grant or reopen the case from its retained history.",
    "work-moment.third-party-risk-decision.perspective.tprm-programme-owner.before": "Reconcile a certificate against a contradicting questionnaire by hand and argue whose spreadsheet holds the real method.",
    "work-moment.third-party-risk-decision.perspective.tprm-programme-owner.now": "Open each conflict to both sources with purpose, scope and verification visible, and resolve it under the recorded method version.",
    "work-moment.third-party-risk-decision.perspective.tprm-programme-owner.responsibility": "Own the assessment method, evidence standards and the resolution of conflicting assurance.",
    "work-moment.third-party-risk-decision.perspective.tprm-programme-owner.supervision": "Hold evidence that fails purpose or freshness checks, correct method mappings within remit and return the risk decision to its accountable owner.",
    "work-moment.third-party-risk-decision.summary": "An accountable risk owner judges a scoped decision package while the programme owner resolves conflicting assurance evidence, and the score never decides alone.",
    "work-moment.third-party-risk-decision.title": "Decide a third-party risk with the evidence in view",
    "workblock.bid-award.agent-story": "When the agent normalises bids, evaluates governed criteria or prepares an in-envelope award proposal, the award authority needs source-linked scores, sensitivity, conflicts, mandate and commit receipt visible, so that routine analysis can run autonomously while the consequential award remains under explicit authority.",
    "workblock.bid-award.current-state": "Bid evaluation is slow and inconsistent, dependent on fragmented qualitative and quantitative inputs rebuilt by hand for every event from response exports, evaluator scorecards and scenario workbooks into an award pack for the approving forum.",
    "workblock.bid-award.description": "Normalise responses, apply declared criteria and constraints, compare scenarios and preserve recommendation-to-decision provenance.",
    "workblock.bid-award.descriptor": "Bid evaluation and award preparation",
    "workblock.bid-award.future-state": "Normalised responses, scores and inconsistencies arrive consolidated against the published criteria and constraints, and the sourcing manager validates the strategic weighting, compares award scenarios and approves the recommendation with its provenance intact.",
    "workblock.bid-award.hired-instead": "Today this job is done by the sourcing suite's response export, comparison and scenario workbooks, evaluator scorecards, risk reviews and an award pack assembled for the approving forum.",
    "workblock.bid-award.job": "Commit a defensible sourcing award from normalised bids, governed criteria and explicit award authority.",
    "workblock.bid-award.label": "Bid evaluation and award preparation",
    "workblock.bid-award.outcome": "Awards are comparable, defensible and connected to their downstream baseline.",
    "workblock.bid-award.story.apply-criteria.completion": "Each score records its criterion, source evidence, evaluator or rule, conflicts and missing evidence, and mandatory failures cannot be hidden by an aggregate score.",
    "workblock.bid-award.story.apply-criteria.story": "When evaluation begins, the evaluator needs mandatory, weighted, commercial and risk criteria applied from the approved event version, so that every supplier is assessed under the same declared rules.",
    "workblock.bid-award.story.award-scenarios.completion": "Each scenario reconciles scope, price, risk, capacity and conditions, and infeasible combinations record the exact constraint that excludes them.",
    "workblock.bid-award.story.award-scenarios.story": "When more than one feasible award exists, the sourcing lead needs single, split and alternate scenarios compared under capacity and constraint assumptions, so that the recommendation reflects the whole award rather than the lowest line price.",
    "workblock.bid-award.story.challenge-recommendation.completion": "The decision package shows which changes would alter the ranking, records conflict dispositions and carries an approve, reject or return decision from the named authority.",
    "workblock.bid-award.story.challenge-recommendation.story": "When an award recommendation is ready, the award authority needs sensitivity, conflicts, counter-evidence and material conditions beside it, so that approval is a decision rather than a rebuild of the evaluation.",
    "workblock.bid-award.story.commit-award.completion": "The award command validates current versions and authority, records an idempotent external receipt, reconciles supplier communications and preserves any failed or reversed effect as a new audited state.",
    "workblock.bid-award.story.commit-award.story": "When an award is authorised, the award authority needs the exact supplier, lot, amount, conditions and communication committed once, so that retries or stale content cannot create a different commercial outcome.",
    "workblock.bid-award.story.landed-cost.completion": "Every cost component names its rate source, reference period and as-of time, quota and carbon exposure assumptions stay explicit, and the preferred allocation remains a proposal until the named award authority decides.",
    "workblock.bid-award.story.landed-cost.story": "When comparable bids arrive under different delivery terms, origins and duty positions, the evaluator needs each bid decomposed to a common delivered-to-plant basis covering unit price, surcharges, freight, duty, quota exposure and carbon cost, so that award scenarios rank on total landed cost instead of quoted price.",
    "workblock.bid-award.story.normalise-bids.completion": "Every normalised value links to the exact source location and transformation, unresolved fields stay explicit, and the immutable bid set remains reproducible.",
    "workblock.bid-award.story.normalise-bids.story": "When sealed bids arrive in unlike formats, the evaluator needs comparable commercial and qualitative fields without losing the submitted evidence, so that convenience does not rewrite a supplier's offer.",
    "workblock.bid-award.tool": "Evaluate bids and award scenarios",
    "workblock.category-radar.agent-story": "When the agent has assembled an opportunity case, the category manager needs to see why each record is included, what is assumed and what is still missing, so that accepting the case does not mean redoing the analysis, and a rejection carries a reason the next version is tested against.",
    "workblock.category-radar.current-state": "Category opportunities today travel from a spend dashboard through exports, strategy workbooks and governance presentations, and the handoff into sourcing is re-entered by hand with the supporting evidence left behind.",
    "workblock.category-radar.description": "Reconcile spend, category context and market signals into an owned opportunity backlog.",
    "workblock.category-radar.descriptor": "Category opportunity discovery and prioritisation",
    "workblock.category-radar.future-state": "A ranked, de-duplicated backlog of category opportunities stays current with every score opening into the records that created it, and the category owner accepts, declines or delegates each one before it enters the approved backlog.",
    "workblock.category-radar.hired-instead": "Today this job is spread across a spend dashboard, an export, a strategy workbook, a presentation and a governance meeting, and the handoff into sourcing is re-entered by hand.",
    "workblock.category-radar.job": "Qualify a category signal into an owned opportunity before it enters the approved backlog.",
    "workblock.category-radar.label": "Category opportunity discovery and prioritisation",
    "workblock.category-radar.outcome": "A ranked backlog where every opportunity has an owner and a source.",
    "workblock.category-radar.story.approved-handoff.completion": "The receiving owner accepts the scope and evidence, and the originating case shows that acceptance.",
    "workblock.category-radar.story.approved-handoff.story": "When a category priority is approved, the category manager needs it transferred into executable work, so that the agenda does not end in a presentation.",
    "workblock.category-radar.story.boundary-review.completion": "The decision carries signed conditions from each required reviewer, or a recorded rejection.",
    "workblock.category-radar.story.boundary-review.story": "When a recommendation crosses risk, policy or budget boundaries, the category manager needs the required reviewers and conditions assembled, so that commercial pressure does not bypass controls.",
    "workblock.category-radar.story.duplicate-signals.completion": "One accountable case remains, with the related records linked and the merge reason retained.",
    "workblock.category-radar.story.duplicate-signals.story": "When several teams raise similar opportunities, the procurement analyst needs duplicates linked without losing distinct evidence, so that value is not counted twice and ownership stays clear.",
    "workblock.category-radar.story.market-event.completion": "A versioned strategy decision names the changed assumption, and each affected handoff is reopened or confirmed.",
    "workblock.category-radar.story.market-event.story": "When a market or supplier event changes a category assumption, the category manager needs to see which decisions it affects, so that strategy changes are deliberate and traceable.",
    "workblock.category-radar.story.source-change.completion": "Reopened items link to the source change, and the prior decision record stays intact.",
    "workblock.category-radar.story.source-change.story": "When source evidence changes after a decision, the procurement analyst needs to see which committed items the change touches, so that the backlog stays current without rewriting history.",
    "workblock.category-radar.story.spend-refresh.completion": "The case is accepted for assessment, dismissed with a recorded reason, or parked with a reopening condition.",
    "workblock.category-radar.story.spend-refresh.story": "When a spend refresh reveals a material pattern, the category manager needs to decide whether it merits category action, so that analyst time goes to consequential work.",
    "workblock.category-radar.tool": "Analyse category opportunities",
    "workblock.category-strategy.agent-story": "When the agent refreshes a fact base or starts a pre-authorised internal handoff, the category manager needs the objective, evidence version, authority envelope and downstream receipt visible, so that routine orchestration can proceed autonomously while strategy changes and external commitments remain supervised.",
    "workblock.category-strategy.current-state": "Category strategy today lives in a strategy document, spend and market workbooks, initiative trackers and governance packs, and the category manager rebuilds the fact base and re-coordinates specialist teams whenever evidence or execution moves.",
    "workblock.category-strategy.description": "Maintain category baselines, market evidence, objectives, initiatives, dependencies and executable plans.",
    "workblock.category-strategy.descriptor": "Category strategy design and governance",
    "workblock.category-strategy.future-state": "The category fact base, scenarios and versioned strategy stay connected to current evidence and execution, the category manager commits objectives and material revisions, and replanning is proposed before drift becomes a periodic-review surprise.",
    "workblock.category-strategy.hired-instead": "Today this job is done through a category-strategy document, spend and market workbooks, initiative trackers, governance packs and the category manager's coordination across specialist teams.",
    "workblock.category-strategy.job": "Commit a category strategy whose objectives, assumptions and initiatives stay connected to current evidence and execution.",
    "workblock.category-strategy.label": "Category strategy design and governance",
    "workblock.category-strategy.outcome": "Category strategy becomes a living system of work rather than a static deck.",
    "workblock.category-strategy.story.current-fact-base.completion": "The fact base pins every source and assumption version, marks missing or stale evidence, and opens each aggregate into its contributing records.",
    "workblock.category-strategy.story.current-fact-base.story": "When a category cycle starts or material evidence changes, the category manager needs one current fact base across spend, demand, market, supplier, contract and value records, so that strategy work begins from traceable facts rather than a rebuilt presentation.",
    "workblock.category-strategy.story.initiative-handoff.completion": "The receiving business module acknowledges an idempotent handoff and returns its owner, state and outcome reference to the originating initiative.",
    "workblock.category-strategy.story.initiative-handoff.story": "When a strategy initiative is accepted, the procurement analyst needs its scope, evidence, dependencies and completion contract transferred to the owning business module, so that execution starts without rekeying the case.",
    "workblock.category-strategy.story.scenario-choice.completion": "Each feasible scenario records objectives, assumptions, dependencies, value and risk ranges, and the selected or rejected disposition has a named reason.",
    "workblock.category-strategy.story.scenario-choice.story": "When objectives or constraints compete, the category manager needs comparable strategy scenarios with sensitivity and counter-evidence, so that the chosen direction reflects explicit trade-offs rather than one forecast.",
    "workblock.category-strategy.story.strategy-commit.completion": "The authorised strategy version records its decision, effective period and superseded version, and no material objective or budget change remains only in draft.",
    "workblock.category-strategy.story.strategy-commit.story": "When stakeholders agree a category direction, the category manager needs one governed strategy version committed without erasing earlier versions, so that every initiative can cite the authority and objective it serves.",
    "workblock.category-strategy.story.strategy-drift.completion": "A versioned drift case links the changed evidence to every affected initiative and results in a confirmed strategy, a governed revision or a recorded decision to take no action.",
    "workblock.category-strategy.story.strategy-drift.story": "When an assumption, risk, outcome or dependency moves outside the committed strategy envelope, the category manager needs the affected objectives and initiatives identified, so that replanning is focused and committed history remains intact.",
    "workblock.category-strategy.tool": "Build or update a category strategy",
    "workblock.contract-authoring.agent-story": "An agent can draft a clause or propose a redline, but the result stays visibly proposed, with its source and basis attached, until the assigned reviewer accepts, edits or rejects it. Counsel does not have to trust the draft: they can open the language and the playbook version behind every proposed change.",
    "workblock.contract-authoring.current-state": "A contract moves between the contract system's editor, tracked-changes documents and an issue list kept in a spreadsheet or email thread, so each review pass begins with a meeting that reassembles which deviations exist and what has already been agreed.",
    "workblock.contract-authoring.description": "Draft and compare clauses, present labelled changes and preserve native DOCX fidelity.",
    "workblock.contract-authoring.descriptor": "Contract drafting, negotiation and redlining",
    "workblock.contract-authoring.future-state": "Each material deviation arrives already found, labelled and traced to its playbook position and source span, so judgement is spent deciding it; a machine draft stays visibly proposed until the assigned reviewer accepts, edits or rejects it, and every accepted change binds to an immutable contract version.",
    "workblock.contract-authoring.hired-instead": "Today this job is done by the contract system's editor, Word with tracked changes, an issue list in a spreadsheet or email thread, and review meetings that reassemble the context each pass.",
    "workblock.contract-authoring.job": "Move a contract from first draft or counterparty redline to accepted positions, with each material deviation decided at the right level of authority.",
    "workblock.contract-authoring.label": "Contract drafting, negotiation and redlining",
    "workblock.contract-authoring.outcome": "Judgement is spent deciding deviations, not finding them.",
    "workblock.contract-authoring.story.commercial-position.completion": "Every commercial issue links the draft language to the award position and carries an accepted, edited or escalated decision with its authority.",
    "workblock.contract-authoring.story.commercial-position.story": "When negotiated language moves, the sourcing manager needs to see which award terms the new draft touches, so that a concession in review does not quietly undo the sourcing result.",
    "workblock.contract-authoring.story.start-with-context.completion": "One reviewable version holds the source request, the award conditions and the open questions, each with a named owner.",
    "workblock.contract-authoring.story.start-with-context.story": "When an approved award reaches contracting, the sourcing manager needs the draft to start from the facts already decided, so that no one re-collects the purpose, parties and conditions the business has already settled.",
    "workblock.contract-authoring.story.third-party-paper.completion": "Each finding opens the source span, the applicable playbook version and the recorded disposition; unreadable or missing scopes are stated, not skipped.",
    "workblock.contract-authoring.story.third-party-paper.story": "When counterparty paper arrives, legal counsel needs every material deviation presented with its exact language and the position it departs from, so that judgement is spent on decisions rather than on finding the clause.",
    "workblock.contract-authoring.story.version-integrity.completion": "The version accepted for signature matches the approved positions, and any reopened approval names the change that caused it.",
    "workblock.contract-authoring.story.version-integrity.story": "When the document changes after an approval, the sourcing manager needs the affected approvals reopened and the rest left standing, so that a stale version cannot advance to signature.",
    "workblock.contract-authoring.tool": "Draft or review a contract",
    "workblock.contract-intake.agent-story": "When the agent extracts and publishes a routine contract intake inside the active evidence envelope, the contract manager needs source citations, identity resolution, missing-evidence state and duplicate checks visible, so that straight-through digitisation can run autonomously while ambiguous legal meaning remains supervised.",
    "workblock.contract-intake.current-state": "Agreements arrive through request forms, shared mailboxes and document folders, their terms keyed into metadata by hand; an intake reviewer then rereads the document set to work out whether it creates, changes or duplicates an agreement that already exists.",
    "workblock.contract-intake.description": "Capture the contract set, extract terms and metadata with source anchors, resolve agreement identity and route evidence exceptions.",
    "workblock.contract-intake.descriptor": "Contract data capture and extraction",
    "workblock.contract-intake.future-state": "Every agreement begins as one complete, source-anchored intake record, with extracted terms, citations and resolved agreement identity arriving together; routine documents publish straight through under policy, and only genuine evidence or identity exceptions reach the contract manager to decide.",
    "workblock.contract-intake.hired-instead": "Today this job is done through a contract-request form, shared mailbox, document folders, manual metadata entry and an intake review that checks whether an agreement already exists.",
    "workblock.contract-intake.job": "Create one canonical, source-anchored contract intake record from a complete document set and route only genuine evidence or identity exceptions.",
    "workblock.contract-intake.label": "Contract data capture and extraction",
    "workblock.contract-intake.outcome": "Every agreement begins as a complete, source-anchored contract record.",
    "workblock.contract-intake.story.capture-once.completion": "The intake record links every received artifact, channel, sender, checksum and version, identifies missing expected items and prevents duplicate ingestion.",
    "workblock.contract-intake.story.capture-once.story": "When a contract request and its files arrive through different channels, the contract manager needs one complete source set captured once, so that later reviewers work from the same immutable material.",
    "workblock.contract-intake.story.extract-with-citations.completion": "Every extracted fact opens the source passage, carries confidence and review state, and ambiguous or absent language remains an explicit gap rather than an inferred fact.",
    "workblock.contract-intake.story.extract-with-citations.story": "When documents are digitised, legal counsel needs parties, dates, values, hierarchy and document type extracted with exact citations, so that structured metadata never outruns the language that supports it.",
    "workblock.contract-intake.story.publish-or-except.completion": "A schema-valid contract record and change event publish exactly once, or an exception names the unresolved evidence, consequence, owner and permitted next action.",
    "workblock.contract-intake.story.publish-or-except.story": "When intake evidence and identity checks complete, the contract manager needs routine documents published and only true exceptions routed, so that manual review focuses on consequential uncertainty.",
    "workblock.contract-intake.story.resolve-agreement.completion": "The source is linked as a new agreement, amendment, related artifact or duplicate with a recorded rationale, and unresolved collisions remain quarantined.",
    "workblock.contract-intake.story.resolve-agreement.story": "When a source may create, amend or duplicate an agreement, the contract manager needs candidate relationships and identity evidence assembled, so that a new canonical record is not created for an existing contract.",
    "workblock.contract-intake.tool": "Digitise or triage a contract",
    "workblock.contract-repository.agent-story": "When the agent assembles an approval route or activates an executed agreement inside policy, the contract manager needs content hashes, authority decisions, signature receipts and repository reconciliation visible, so that routine coordination can run autonomously while signature authority remains explicit.",
    "workblock.contract-repository.current-state": "Approval evidence is gathered across workflow steps, email and committee sign-off, execution runs through a separate electronic-signature product, and repository metadata is reconciled only after signature, so the authority trail behind an executed agreement has to be retraced by hand.",
    "workblock.contract-repository.description": "Assemble approval evidence, bind approval to the exact version, coordinate authorised signature and reconcile the executed agreement to canonical storage.",
    "workblock.contract-repository.descriptor": "Contract approval, execution and storage",
    "workblock.contract-repository.future-state": "The approved agreement is executed exactly once against its exact content, with authority decisions, signature receipts and repository state reconciled together and retrievable; the agent coordinates routine routing and activation, while signature authorisation remains an explicit decision by the named authority.",
    "workblock.contract-repository.hired-instead": "Today this job is done through approval workflows, email or committee sign-off, an electronic-signature product and a contract repository whose metadata is reconciled after signature.",
    "workblock.contract-repository.job": "Authorise and execute the exact approved contract once, then reconcile the signed artifact and canonical repository state.",
    "workblock.contract-repository.label": "Contract approval, execution and storage",
    "workblock.contract-repository.outcome": "The approved agreement is executed once, stored against its authority trail and remains exact and retrievable.",
    "workblock.contract-repository.story.derive-approval-route.completion": "The route names each decision, sequence, delegation basis and expiry, and conflicting or missing authority stops the package with an accountable owner.",
    "workblock.contract-repository.story.derive-approval-route.story": "When a contract reaches approval, the contract manager needs the complete legal, commercial, budget and signature route derived from current facts, so that no required authority is discovered after circulation begins.",
    "workblock.contract-repository.story.execute-once.completion": "The signature command revalidates actor, delegation and content, uses an idempotency key and records the authoritative sent, signed, declined or failed receipt.",
    "workblock.contract-repository.story.execute-once.story": "When every required approval is current, the sourcing manager needs the authorised signature ceremony executed exactly once, so that retries cannot send or sign a different agreement.",
    "workblock.contract-repository.story.protect-approved-content.completion": "Each decision binds to the contract version and content hash, any material change expires affected approvals, and superseded decisions remain in history.",
    "workblock.contract-repository.story.protect-approved-content.story": "When an approver acts, legal counsel needs proof that the content they reviewed is still the content proposed for signature, so that a stale approval cannot authorise changed terms.",
    "workblock.contract-repository.story.reconcile-repository.completion": "The immutable executed artifact and canonical metadata agree with the signature receipt, prior versions are superseded explicitly and downstream consumers acknowledge the activation event.",
    "workblock.contract-repository.story.reconcile-repository.story": "When execution completes, the contract manager needs the signed artifact, metadata, hierarchy and activation event reconciled, so that downstream obligations and buying routes use the agreement that actually took effect.",
    "workblock.contract-repository.tool": "Coordinate contract approval, signature or retrieval",
    "workblock.demand-portfolio.agent-story": "When the agent groups compatible demand or launches a pre-authorised portfolio handoff, the demand owner needs inclusion reasons, exclusions, source freshness, scenario constraints and downstream receipts visible, so that routine consolidation can progress autonomously while contested trade-offs remain supervised.",
    "workblock.demand-portfolio.current-state": "Related demand today is spotted through forecasts, intake exports, sourcing pipelines, category workbooks and planning meetings, so compatible requests fragment into avoidable transactions before anyone decides what can move together.",
    "workblock.demand-portfolio.description": "Surface related demand, form reversible bundles and track capacity, ageing, dependencies and outcomes.",
    "workblock.demand-portfolio.descriptor": "Demand consolidation and portfolio planning",
    "workblock.demand-portfolio.future-state": "Compatible current and forecast demand surfaces as reversible bundle proposals with modelled timing and constraints, and named owners approve material changes to timing, scope or ownership before an accepted group moves into strategy, sourcing or tactical execution.",
    "workblock.demand-portfolio.hired-instead": "Today this job is done through demand forecasts, intake exports, sourcing pipelines, category workbooks and planning meetings where teams decide which requests can move together.",
    "workblock.demand-portfolio.job": "Form executable demand portfolios that balance aggregation value with urgency, service, risk and accountable ownership.",
    "workblock.demand-portfolio.label": "Demand consolidation and portfolio planning",
    "workblock.demand-portfolio.outcome": "Demand is combined where valuable and governed as one current portfolio.",
    "workblock.demand-portfolio.story.business-consent.completion": "Every material condition is accepted, rejected or amended by the authorised role, and dissenting or urgent demand retains its own valid route.",
    "workblock.demand-portfolio.story.business-consent.story": "When a proposed portfolio changes timing or route for several business owners, the process owner needs material consequences and required authority assembled, so that aggregation does not silently override an accountable need.",
    "workblock.demand-portfolio.story.compatible-demand.completion": "The candidate set links each request, scope, required date, owner and freshness, and separates confirmed demand from forecast without double counting.",
    "workblock.demand-portfolio.story.compatible-demand.story": "When live and forecast requests accumulate, the demand owner needs compatible demand visible before route execution, so that consolidation is considered while timing and commercial options are still open.",
    "workblock.demand-portfolio.story.execution-launch.completion": "Idempotent handoffs are acknowledged by the receiving business modules, component requests link to their portfolio and execution records, and partial launch failures remain owned and recoverable.",
    "workblock.demand-portfolio.story.execution-launch.story": "When a portfolio is accepted, the demand owner needs each component launched into its owning business module without losing its request lineage, so that portfolio planning becomes observable work.",
    "workblock.demand-portfolio.story.grouping-rationale.completion": "Every inclusion and exclusion records its category, specification, geography, timing, policy and ownership rationale, with unresolved conflicts explicit.",
    "workblock.demand-portfolio.story.grouping-rationale.story": "When requests are grouped or excluded, the demand owner needs the compatibility rule and constraint behind each choice, so that the portfolio can be challenged without reconstructing it.",
    "workblock.demand-portfolio.story.material-economics.completion": "Normalised demand keeps its unit, grade and calendar conversions, coverage gaps are stated per time bucket against contracted entitlements, and each harmonisation proposal names the grade designations, tolerance class and certificate type it treats as equivalent, with requester consent recorded before any confirmed requirement changes.",
    "workblock.demand-portfolio.story.material-economics.story": "When raw-material demand, contracted cover and specification variants shift on separate cadences, the demand owner needs demand normalised, coverage reconciled and equivalent specifications identified, so that direct-material volume stays poolable before commitments fragment it.",
    "workblock.demand-portfolio.story.portfolio-scenarios.completion": "Each scenario records covered demand, expected value range, timing, constraints, service and risk effects, and the selected disposition has a named decision owner.",
    "workblock.demand-portfolio.story.portfolio-scenarios.story": "When several bundle, timing or route options are feasible, the demand owner needs comparable scenarios, so that value is not optimised at the expense of service, urgency or risk.",
    "workblock.demand-portfolio.tool": "Consolidate or inspect demand",
    "workblock.demand.agent-story": "When the agent has drafted the plan, the demand owner needs to see each proposed child, the dependency it hangs on and the template it came from, so that they can correct the plan before any work starts.",
    "workblock.demand.current-state": "Coordinating a request across specialists today falls to a workflow or case platform where one owns the parent, and otherwise to a coordination spreadsheet, standing status meetings and the coordinator's memory, so handoffs go invisible between owners.",
    "workblock.demand.description": "Coordinate multi-domain tasks, approvals and handoffs from one intake record.",
    "workblock.demand.descriptor": "Procurement request coordination",
    "workblock.demand.future-state": "Each committed route becomes a durable, typed plan that carries the need across specialist owners and systems, the requester sees one truthful status and the next permitted action, and the case closes only when downstream outcomes reconcile.",
    "workblock.demand.hired-instead": "Today this job is hired to a workflow or case platform where one owns the parent, and otherwise to a coordination spreadsheet, standing status meetings and the coordinator's memory.",
    "workblock.demand.job": "Carry an accepted need across specialist owners and systems until the agreed outcome is complete.",
    "workblock.demand.label": "Procurement request coordination",
    "workblock.demand.outcome": "Demand progresses without invisible handoffs.",
    "workblock.demand.story.one-plan.completion": "Every material child has an owner and a completion rule, and the parent state reconciles with each child system.",
    "workblock.demand.story.one-plan.story": "When an accepted request spans several teams and systems, the demand owner needs one plan showing the next valid action, its dependencies and who can act, so that they coordinate the work without becoming the owner of every specialist process.",
    "workblock.demand.story.partial-failure.completion": "One child record at the destination, a truthful blocked or confirmed parent state and an owned recovery.",
    "workblock.demand.story.partial-failure.story": "When a downstream action fails or times out, the demand owner needs the destination reconciled before any retry, so that a slow confirmation never becomes a duplicate commitment.",
    "workblock.demand.story.scope-change.completion": "The changed fact, the reopened gates and the untouched decisions are all visible in the plan's history.",
    "workblock.demand.story.scope-change.story": "When scope, value or supplier changes mid-flight, the demand owner needs only the affected work and approvals reopened, so that one change does not restart everything or continue silently on invalid decisions.",
    "workblock.demand.story.scoped-handback.completion": "A scoped decision with its actor and reason, linked to the child record and reflected in the parent state.",
    "workblock.demand.story.scoped-handback.story": "When a plan needs a specialist decision, the demand owner needs the one issue, its evidence and its consequence kept together, so that the outcome returns to the plan without being flattened into a generic approval.",
    "workblock.demand.story.stalled-demand.completion": "Waiting time is attributed by cause at case level, and each aggregate opens into the records behind it.",
    "workblock.demand.story.stalled-demand.story": "When demand stalls or repeats, the process and policy owner needs the cause named, whether missing evidence, a waiting decision, a dependency, a source failure or an absent owner, so that they change the right part of the operating model.",
    "workblock.demand.story.truthful-status.completion": "A visible owner and next action, with no contradiction between the parent status and the systems behind it.",
    "workblock.demand.story.truthful-status.story": "When the request leaves intake, the requester needs one truthful status and only the actions that are theirs, so that they are not chasing several queues for one outcome.",
    "workblock.demand.tool": "Orchestrate a demand request",
    "workblock.guided-buying.agent-story": "When a route is proposed, the requester needs the controlling rule, the facts behind it and the alternatives that were rejected shown beside it, so that the route can be confirmed or challenged without taking it on faith.",
    "workblock.guided-buying.current-state": "A requester works out how to buy through guided-buying pages, catalogue and punchout search, the procurement help desk and the colleague who knows the route, because the facts that decide the right path sit in policy, agreement and supplier records they cannot see.",
    "workblock.guided-buying.description": "Match demand to policy, catalogue, supplier and approval paths before ERP execution.",
    "workblock.guided-buying.descriptor": "Guided buying",
    "workblock.guided-buying.future-state": "The requester describes the outcome once and receives the current, policy-valid routes with the controlling rule, the facts behind it and the rejected alternatives shown beside each option; the requester or a delegated authority confirms the selection, which is handed on complete, with no spend committed from this step.",
    "workblock.guided-buying.hired-instead": "Today this job is done by the suite's guided-buying pages, catalogue and punchout search, a procurement help desk and the colleague who knows the route.",
    "workblock.guided-buying.job": "Route a stated need to the valid buying path when the facts that decide the route sit in policy, agreement and supplier records.",
    "workblock.guided-buying.label": "Guided buying",
    "workblock.guided-buying.outcome": "Compliant buying feels like the shortest route.",
    "workblock.guided-buying.story.approve-with-context.completion": "An approval, rejection or return recorded with the authority and the reason.",
    "workblock.guided-buying.story.approve-with-context.story": "When a requisition arrives for decision, the budget owner needs the need, the route, the supplier and agreement context and the control results together, with any evidence gaps shown, so that the decision is made without rebuilding the case.",
    "workblock.guided-buying.story.catalogue-coverage.completion": "The coverage assessment names each gap with the demand, content and entitlement records behind it, and every proposed catalogue addition routes to the owning curator as a proposal, never as an edit.",
    "workblock.guided-buying.story.catalogue-coverage.story": "When repeat demand lacks covering content or routes off-catalogue, the procurement buyer needs the content, adoption and price-integrity gaps measured against contracted entitlements, so that the compliant path becomes the easiest path.",
    "workblock.guided-buying.story.fix-the-source.completion": "A corrected rule or entry, and the open requests that depended on it re-evaluated.",
    "workblock.guided-buying.story.fix-the-source.story": "When the same request type keeps failing or detouring, the procurement buyer needs the cause distribution and the exact policy, catalogue or agreement condition involved, so that the source is corrected once rather than requesters coached one at a time.",
    "workblock.guided-buying.story.one-write.completion": "One requisition confirmed in the owning system, with the request and the committed result both on record.",
    "workblock.guided-buying.story.one-write.story": "When a draft requisition is submitted, the ERP owner needs the suite's validation and approval authority preserved and any duplicate or unapproved write prevented, so that one requisition exists in one state.",
    "workblock.guided-buying.story.resolve-off-path.completion": "A corrected requisition, an accepted exception or a handoff accepted by its owner.",
    "workblock.guided-buying.story.resolve-off-path.story": "When demand cannot follow the ordinary path, the procurement buyer needs to see which rule or source blocks it, which options remain valid and who must decide, so that the case is resolved rather than a generic form error translated.",
    "workblock.guided-buying.story.route-need.completion": "A confirmed route and an accepted requisition, or a handoff with a named owner.",
    "workblock.guided-buying.story.route-need.story": "When the buying path is not obvious, the requester needs to state the need in business terms and be asked only the facts that decide the route, so that they reach the compliant option without learning every procurement rule.",
    "workblock.guided-buying.tool": "Guide a purchase",
    "workblock.innovation.agent-story": "When the agent triages an idea, prepares a stage package or creates a pre-authorised internal handoff, the innovation sponsor needs submission terms, source evidence, withheld authorities and destination receipts visible, so that routine pipeline coordination can run autonomously while funding, disclosure, experiment and adoption decisions remain supervised.",
    "workblock.innovation.current-state": "Supplier ideas today collect in relationship meetings, slide decks and spreadsheets, or an innovation platform where one exists, and wait on a committee calendar. The result is an unprioritised backlog in which duplication, stage and ownership are rebuilt for each meeting.",
    "workblock.innovation.description": "Capture, assess and progress supplier ideas against business needs and measured value.",
    "workblock.innovation.descriptor": "Supplier innovation pipeline",
    "workblock.innovation.future-state": "Ideas advance in bounded stages linked to source records and stated assumptions: the agent captures proposals, checks scope and duplication, and prepares stage packages. Funding, disclosure and experiment decisions stay with the named sponsor, so enthusiasm never signs anything.",
    "workblock.innovation.hired-instead": "Today this job is done by an innovation platform where one exists, and otherwise by relationship meetings, slide decks, spreadsheets and a committee calendar.",
    "workblock.innovation.job": "Move a supplier idea from receipt to an authorised stage decision without turning interest into commitment.",
    "workblock.innovation.label": "Supplier innovation pipeline",
    "workblock.innovation.outcome": "Ideas advance in bounded stages, and enthusiasm never signs anything.",
    "workblock.innovation.story.answer-supplier.completion": "The disposition and its permitted reason reach the supplier through an approved channel and stay with the decision history.",
    "workblock.innovation.story.answer-supplier.story": "When an idea is declined or deferred, the supplier account lead needs a truthful status with a permitted reason, so that the relationship survives the answer.",
    "workblock.innovation.story.attach-sponsor.completion": "The opportunity names its need, sponsor and next decision; an idea without a sponsor is declined, deferred or returned with a reason.",
    "workblock.innovation.story.attach-sponsor.story": "When an idea survives triage, the innovation sponsor needs it tied to a stated business need with the open questions listed, so that evaluation effort goes to problems someone owns.",
    "workblock.innovation.story.bound-stage.completion": "The stage decision records what was authorised, under which conditions and expiry, and which authorities were withheld.",
    "workblock.innovation.story.bound-stage.story": "When a business case reaches the committee, the innovation sponsor needs the decision to grant only the next bounded step, so that approval to test is never read as approval to buy, disclose or scale.",
    "workblock.innovation.story.capture-idea.completion": "The idea holds its source, submission terms, confidentiality state and a named triage owner, and the supplier receives an acknowledgement that promises nothing.",
    "workblock.innovation.story.capture-idea.story": "When a supplier floats an idea in a relationship meeting, the supplier relationship manager needs it captured with its terms and restrictions intact, so that enthusiasm does not become an implied commercial promise.",
    "workblock.innovation.story.separate-value.completion": "Each destination owner acknowledges its action, and forecast, experiment result and validated realisation remain separate records.",
    "workblock.innovation.story.separate-value.story": "When an experiment passes its criteria, the innovation sponsor needs adoption handed to the owners of sourcing, contract and value work, so that a passed pilot is not reported as realised value.",
    "workblock.innovation.tool": "Assess a supplier idea",
    "workblock.intake.agent-story": "When the agent has assembled the case, the procurement intake owner needs to see the facts it used, the policy it cited, what is missing and the alternatives it set aside, so that accepting the route is a review, not a second investigation.",
    "workblock.intake.current-state": "New demand today arrives through a suite intake module where one exists, and otherwise through a shared mailbox and a form tool, with an analyst recognising the request type and reconstructing what the requester actually needs.",
    "workblock.intake.description": "Capture demand conversationally, enrich the request and route it through the correct flow.",
    "workblock.intake.descriptor": "Procurement request intake",
    "workblock.intake.future-state": "A requester describes the business need once and confirms the material facts, and one canonical, traceable intake request publishes with typed requirements that reach the right path first time. Buyers inspect sampled submissions and resolve the novel cases.",
    "workblock.intake.hired-instead": "Today this job is hired to a suite intake module where one exists, and otherwise to a shared mailbox, a form tool and the analyst who recognises the request type.",
    "workblock.intake.job": "Turn an expressed need into an accepted route, when the requester does not know the procurement path.",
    "workblock.intake.label": "Procurement request intake",
    "workblock.intake.outcome": "Complete demand reaches the right path first time.",
    "workblock.intake.story.assemble-case.completion": "The acceptance or correction is recorded beside the proposal, and the case can be reconstructed from its retained sources.",
    "workblock.intake.story.assemble-case.story": "When ambiguous demand arrives, the procurement intake owner needs the policy and source facts assembled with what is missing or conflicting shown, so that they can decide the route without losing the requester's original intent.",
    "workblock.intake.story.explain-once.completion": "An accepted or redirected route with visible evidence requirements, a named owner, a next action and a correction path.",
    "workblock.intake.story.explain-once.story": "When a need has no known route, the requester needs to explain it once and answer only the questions that change the path, so that the request reaches a valid owner without a second translation.",
    "workblock.intake.story.fix-the-rule.completion": "A versioned rule change with its evaluation cases, its approval and a rollback path.",
    "workblock.intake.story.fix-the-rule.story": "When route proposals are repeatedly corrected, the process and policy owner needs the cases and reasons in one place, so that they can change one bounded rule instead of adding another local workaround.",
    "workblock.intake.story.scoped-decision.completion": "A scoped decision with the actor, the authority basis, the reason and a link back to the parent state.",
    "workblock.intake.story.scoped-decision.story": "When a request enters a specialist control domain, the process and policy owner needs the exact decision and evidence required by that control, so that its approval is not read as approval of everything else in the request.",
    "workblock.intake.story.solution-first.completion": "Both the stated preference and the underlying need are retained, and the route records which one it was based on.",
    "workblock.intake.story.solution-first.story": "When a request names a supplier but not the need, the procurement intake owner needs the need separated from the proposed solution, so that reuse, an existing contract or a competitive route is not missed.",
    "workblock.intake.tool": "Triage procurement demand",
    "workblock.invoice-match.agent-story": "When the agent validates and matches an in-envelope invoice, the AP processor needs extraction citations, rule versions, match evidence, sampling state and kill-switch control visible, so that routine invoices can flow autonomously while ambiguous or high-consequence cases remain supervised.",
    "workblock.invoice-match.current-state": "Invoices arrive through capture channels, ERP validation and manual document review, and when identity, duplicates or line-level evidence do not align a processor investigates across all of them. The provenance of what was extracted and matched is rebuilt by hand.",
    "workblock.invoice-match.description": "Normalise structured and document invoices, validate profiles, deduplicate and reconcile them to order, receipt and contract.",
    "workblock.invoice-match.descriptor": "Invoice intake and matching",
    "workblock.invoice-match.future-state": "Each valid invoice is published once as a provenance-complete canonical record with a deterministic, explainable match to order, receipt and contract evidence. In-tolerance invoices progress within policy under sampled supervision, and ambiguous ones arrive as evidence-complete cases for a named reviewer.",
    "workblock.invoice-match.hired-instead": "Today this job is done by AP capture and matching software, ERP validation, document review and processor investigation when identity, duplicate or line-level evidence does not align.",
    "workblock.invoice-match.job": "Publish each valid invoice once with a traceable match to authorised commercial and receiving evidence or a precise exception reason.",
    "workblock.invoice-match.label": "Invoice intake and matching",
    "workblock.invoice-match.outcome": "Valid in-tolerance invoices progress within policy bounds, with sampled supervision; ambiguous ones arrive as evidence-complete cases.",
    "workblock.invoice-match.story.channel-intake.completion": "The immutable source artifact and channel metadata are captured once under a stable identity, with receipt status and extraction lineage recorded.",
    "workblock.invoice-match.story.channel-intake.story": "When an invoice arrives through a structured feed, network, email or document channel, the AP processor needs one canonical source record created, so that channel retries and format differences do not create duplicate work.",
    "workblock.invoice-match.story.duplicate-conflict.completion": "The record is confirmed unique, linked as a duplicate or routed as a conflict, with source identifiers, amounts, dates and disposition evidence preserved.",
    "workblock.invoice-match.story.duplicate-conflict.story": "When an invoice resembles an existing document, the risk owner needs exact and probable duplicate evidence compared, so that fraud or retry is stopped without suppressing a legitimate correction.",
    "workblock.invoice-match.story.line-match.completion": "Each line records matched references, quantities, prices, tax, tolerance and freshness, and unmatched evidence remains explicit rather than forced into a header-level pass.",
    "workblock.invoice-match.story.line-match.story": "When an invoice is valid, the AP processor needs header and lines matched to authorised order, receipt, service and contract evidence, so that tolerance is applied to the right commercial facts.",
    "workblock.invoice-match.story.publish-disposition.completion": "The invoice publishes exactly once as matched, partially matched, blocked or rejected, with typed reasons, source drill-through and a reconciled downstream event.",
    "workblock.invoice-match.story.publish-disposition.story": "When validation and matching complete, the controller needs a canonical invoice and precise disposition published, so that payment readiness and exception resolution receive one reproducible state.",
    "workblock.invoice-match.story.syntax-business-validation.completion": "Every required rule records pass, fail or unresolved with source and version, arithmetic reconciles, and material gaps have a typed exception reason.",
    "workblock.invoice-match.story.syntax-business-validation.story": "When invoice data is extracted or received, the AP processor needs syntax, tax, party, totals and business rules validated, so that a well-formed document is not mistaken for a payable one.",
    "workblock.invoice-match.tool": "Capture and match an invoice",
    "workblock.invoice-resolution.agent-story": "When the agent sends a routine evidence request, interprets a bounded response or applies a pre-authorised correction, the AP processor needs the approved channel, source message, proposed meaning and downstream receipt visible, so that routine resolution can progress autonomously while agreement and financial authority remain supervised.",
    "workblock.invoice-resolution.current-state": "Supplier-dependent invoice issues today run through portal messages, email, AP case notes and document attachments, with the processor chasing status across ERP, buyer and receiving teams. The exchange and the agreed outcome live apart from the invoice they concern.",
    "workblock.invoice-resolution.description": "Coordinate permission-scoped evidence requests, corrections, credit notes, disputes and truthful supplier status.",
    "workblock.invoice-resolution.descriptor": "Supplier invoice resolution",
    "workblock.invoice-resolution.future-state": "Each issue resolves through one governed, source-linked exchange on an approved channel: the agent drafts requests, manages reminders and applies pre-authorised corrections. Agreement and financial authority stay with named people, and the reconciled outcome writes back to the invoice record.",
    "workblock.invoice-resolution.hired-instead": "Today this job is done through supplier-portal messages, email, AP case notes, document attachments and processor follow-up across the ERP, buyer and receiving teams.",
    "workblock.invoice-resolution.job": "Resolve an invoice exception with the supplier through one source-linked exchange and reconcile the agreed outcome downstream.",
    "workblock.invoice-resolution.label": "Supplier invoice resolution",
    "workblock.invoice-resolution.outcome": "Invoice issues resolve through one governed two-sided record.",
    "workblock.invoice-resolution.story.approved-exchange.completion": "Every outbound and inbound item records channel receipt, sender, time, artifact version and access state, and failed delivery remains visible with a recovery action.",
    "workblock.invoice-resolution.story.approved-exchange.story": "When the request is sent, the AP processor needs all messages and documents exchanged through approved channels, so that the case history is complete and sensitive data does not move through an unmanaged path.",
    "workblock.invoice-resolution.story.interpret-evidence.completion": "Each proposed resolution cites the source message and documents, records unresolved contradictions and remains a proposal until the required authority accepts it.",
    "workblock.invoice-resolution.story.interpret-evidence.story": "When the supplier responds, the controller needs claims separated from supported facts, so that generated interpretation or courteous language does not invent agreement.",
    "workblock.invoice-resolution.story.precise-request.completion": "The request identifies invoice and lines, exception reason, evidence already held, exact question or document needed, response route and due condition.",
    "workblock.invoice-resolution.story.precise-request.story": "When supplier evidence or action is needed, the AP processor needs one precise resolution request assembled, so that the supplier knows the disputed object, required response and consequence without another clarification round.",
    "workblock.invoice-resolution.story.reconcile-resolution.completion": "The downstream command commits exactly once, returns an authoritative receipt and closes the case only when invoice, exception and supplier communication states agree.",
    "workblock.invoice-resolution.story.reconcile-resolution.story": "When a resolution is authorised, the controller needs the final correction, credit, rejection or payment hold applied and reconciled, so that case closure matches the invoice and source-system state.",
    "workblock.invoice-resolution.story.response-commitment.completion": "The case records promised action, owner and date, reminders follow the active policy, and missed or superseded commitments trigger the defined escalation.",
    "workblock.invoice-resolution.story.response-commitment.story": "When a supplier promises information, a credit or a correction, the AP processor needs the commitment and elapsed time tracked, so that no response is distinguished from rejection or delay.",
    "workblock.invoice-resolution.tool": "Resolve an invoice with a supplier",
    "workblock.invoice-triage.agent-story": "When the agent proposes a cause and a next action, the AP processor can open the evidence behind each hypothesis, see what is missing, and reclassify with the original proposal preserved. Accepted corrections improve the next reviewed version of the logic, not the live rules.",
    "workblock.invoice-triage.current-state": "Invoice exceptions surface in an ERP or AP worklist while the explanation lives in email chases to receivers and buyers, and a spreadsheet tracks who was asked for what. Each processor rebuilds the discrepancy from separate records before anything can move.",
    "workblock.invoice-triage.description": "Classify mismatches, collect supporting records and propose the next valid action.",
    "workblock.invoice-triage.descriptor": "Invoice exception triage",
    "workblock.invoice-triage.future-state": "Every genuine exception arrives as one case with the invoice, lines, match comparison and supporting evidence attached, ranked by consequence. The agent proposes the next permitted action and the AP processor commits it, with the original proposal preserved for the record.",
    "workblock.invoice-triage.hired-instead": "Today this job is done by the ERP or AP worklist, email chases to receivers and buyers, and a spreadsheet that tracks who was asked for what.",
    "workblock.invoice-triage.job": "Resolve an invoice exception before the payment run when the documents do not agree.",
    "workblock.invoice-triage.label": "Invoice exception triage",
    "workblock.invoice-triage.outcome": "Invoice work is ranked by consequence, with the supporting records attached.",
    "workblock.invoice-triage.story.approval-missing.completion": "The authoritative approval trail is complete, or the item remains blocked with the named approver and the fact they are waiting on.",
    "workblock.invoice-triage.story.approval-missing.story": "When an approval route is incomplete, the AP processor needs the right approver and the missing evidence identified under current delegation, so that the invoice is approved or rejected inside policy rather than chased through inboxes.",
    "workblock.invoice-triage.story.duplicate-candidate.completion": "A confirmed duplicate is cancelled or the candidate is cleared, and the duplicate check records the final disposition against every candidate key.",
    "workblock.invoice-triage.story.duplicate-candidate.story": "When two payable records may represent one liability, the controller needs the candidates held side by side with their prior dispositions, so that a duplicate payment is prevented without suppressing a valid invoice.",
    "workblock.invoice-triage.story.missing-receipt.completion": "The receipt is committed in the source system by the receiver, or the invoice remains blocked with a named owner and a reopening condition.",
    "workblock.invoice-triage.story.missing-receipt.story": "When a PO invoice lacks a receipt, the AP processor needs the request to land with the accountable receiver, so that delivery is confirmed or non-receipt explained without a chain of forwarded emails.",
    "workblock.invoice-triage.story.price-mismatch.completion": "The source accepts the corrected term, credit or authorised exception, and the price check reruns against the accepted state.",
    "workblock.invoice-triage.story.price-mismatch.story": "When the invoice price differs from the order, the AP processor needs the controlling term established from the purchase order, the contract and the approved tolerance, so that the correction or the authorised exception is decided once.",
    "workblock.invoice-triage.story.quantity-mismatch.completion": "The source record is corrected or the invoice validly corrected, the match reruns clean, and the case closes with the receipt attached.",
    "workblock.invoice-triage.story.quantity-mismatch.story": "When a match result shows a quantity difference, the AP processor needs to know whether the delivery, the receipt or the invoice is wrong, so that the case reaches the person who can correct the source record instead of bouncing between teams.",
    "workblock.invoice-triage.tool": "Triage an invoice exception",
    "workblock.leakage.agent-story": "When the agent proposes competing causes for a shortfall, the value realisation lead needs the supporting and contrary evidence beside each one, so that they can accept a cause, reject the ranking or ask for more evidence without losing the case history.",
    "workblock.leakage.current-state": "Leakage today surfaces as a variance report or an alert, followed by a chain of explanatory emails and a review meeting, with any recovery action created by hand in another system. By the time the cause is agreed, the shortfall has often become accepted run-rate.",
    "workblock.leakage.description": "Detect variance between negotiated value, adoption and realised outcome, then create owned action.",
    "workblock.leakage.descriptor": "Value leakage monitoring",
    "workblock.leakage.future-state": "Governed expectations from baselines, contracts and price terms are compared continuously with order, invoice and payment evidence, and related variances consolidate into findings. The agent proposes competing causes with supporting and contrary evidence beside each one, and the value realisation lead decides, so leakage becomes visible before it becomes accepted.",
    "workblock.leakage.hired-instead": "Today this job is done by a variance report, an alert, a chain of explanatory emails and a review meeting, with the recovery action created by hand in another system.",
    "workblock.leakage.job": "Resolve a material variance from the approved value path before it is written off, when the cause could be timing, demand, price execution or genuine loss.",
    "workblock.leakage.label": "Value leakage monitoring",
    "workblock.leakage.outcome": "Leakage becomes visible before it becomes accepted.",
    "workblock.leakage.story.confirm-variance.completion": "The variance holds a confirmed comparator, a reproducible calculation and a materiality reason, or a closed false-signal decision.",
    "workblock.leakage.story.confirm-variance.story": "When a report shows a material shortfall, the value realisation lead needs the comparator and the calculation confirmed before anyone investigates, so that the team does not spend a week chasing a data defect or an expired baseline.",
    "workblock.leakage.story.own-the-response.completion": "An action decision names the owner, the chosen response and its consequence, or a tolerated loss with reason, duration and review date.",
    "workblock.leakage.story.own-the-response.story": "When the cause is that negotiated terms are not being used, the business budget owner needs the choice put to them with its consequence, so that the decision to enforce, redesign or accept the exception is theirs and on the record.",
    "workblock.leakage.story.price-variance.completion": "The variance assessment separates off-contract, off-price and missed-band findings with named order and contract records, and every proposed recovery action routes to its owning module and named human.",
    "workblock.leakage.story.price-variance.story": "When indirect orders pay off contract or off price, the value lead needs each variance quantified against the entitled position with drill-through records, so that recovery actions go to owners who can act.",
    "workblock.leakage.story.remeasure.completion": "A remeasurement compares the period after the action with the approved comparator and records the outcome as recovered, partial or ineffective.",
    "workblock.leakage.story.remeasure.story": "When a recovery action completes, the value realisation lead needs the result remeasured under the approved method, so that recovered value is a measured fact rather than a closed task.",
    "workblock.leakage.story.source-acceptance.completion": "The case holds the owning system's acceptance or rejection of the exact request, with a rejection routed back to the owner.",
    "workblock.leakage.story.source-acceptance.story": "When a recovery action is approved, the category manager needs it carried into the system that owns the record and held open until that system accepts it, so that the case cannot close on a sent email.",
    "workblock.leakage.story.test-causes.completion": "A variance bridge accounts for each approved factor and states the residual, with an accepted cause or an explicit unresolved state.",
    "workblock.leakage.story.test-causes.story": "When several causes could explain a shortfall, the finance delegate needs timing, volume, mix, currency and data effects tested against the approved method before leakage is declared, so that a normal movement is not recorded as procurement failure.",
    "workblock.leakage.tool": "Investigate value leakage",
    "workblock.negotiation.agent-story": "When the agent drafts a position or a conditional exchange, the negotiation lead needs to see which facts support it and what authority it assumes, so that advice outside approved bounds never reaches the room.",
    "workblock.negotiation.current-state": "Negotiation preparation today lives in workbooks, documents, the previous round's notes and a briefing meeting, with delegation held in a memo and in memory, so each round rebuilds the position from scattered contracts, spend records and notes.",
    "workblock.negotiation.description": "Prepare fact bases, scenarios, positions and concession logic from governed inputs.",
    "workblock.negotiation.descriptor": "Negotiation preparation",
    "workblock.negotiation.future-state": "Every round opens with a current fact base, feasible packages and a versioned mandate a named owner has authorised, every proposed concession is checked against the approved boundaries, and the round closes on the record with any agreement-in-principle handed on for separate commitment.",
    "workblock.negotiation.hired-instead": "Today this job is done by workbooks, documents, the previous round's notes and a briefing meeting, with delegation held in a memo and in memory.",
    "workblock.negotiation.job": "Prepare a negotiation round from current facts, feasible packages and approved authority when the position is spread across contracts, spend records and meeting notes.",
    "workblock.negotiation.label": "Negotiation preparation",
    "workblock.negotiation.outcome": "Every round opens with a mandate and closes on the record.",
    "workblock.negotiation.story.bounded-authority.completion": "The approver accepts, changes or rejects one explicit authority request, with its condition and expiry recorded.",
    "workblock.negotiation.story.bounded-authority.story": "When a planned move exceeds current delegation, the negotiation lead needs a bounded decision from the authority owner before the next round, so that escalation is not disguised as discretion.",
    "workblock.negotiation.story.capture-round.completion": "The revised plan cites the round record, and the supplier's exact words stay separate from the team's interpretation.",
    "workblock.negotiation.story.capture-round.story": "When a round ends, the negotiation lead needs what was said, agreed and left open captured exactly, so that the next plan starts from the record rather than from memory.",
    "workblock.negotiation.story.compare-packages.completion": "Hard constraints, preferences and unapproved aspirations stay distinct in every compared package.",
    "workblock.negotiation.story.compare-packages.story": "When objectives conflict, the sourcing lead needs packages compared rather than issues argued one by one, so that the decision owner sees the consequence of each feasible outcome.",
    "workblock.negotiation.story.fact-base.completion": "Sampled claims trace to an authorised source or are labelled as assumptions.",
    "workblock.negotiation.story.fact-base.story": "When the evidence is dispersed, the negotiation lead needs a current, comparable fact base, so that the round is argued from facts rather than recollection.",
    "workblock.negotiation.story.hand-off-points.completion": "The authoritative process receives the approved package and confirms its state; nothing commits from meeting notes.",
    "workblock.negotiation.story.hand-off-points.story": "When commercial points converge, the negotiation lead needs the accepted points handed to the award and contract process, so that a meeting agreement is not mistaken for a commitment.",
    "workblock.negotiation.story.set-mandate.completion": "Every issue has an owner, an evidence need and an authority route.",
    "workblock.negotiation.story.set-mandate.story": "When a negotiation is authorised, the negotiation lead needs the issues, minimum needs and decision owners defined, so that no round opens without a mandate.",
    "workblock.negotiation.tool": "Prepare a negotiation",
    "workblock.obligation.agent-story": "When the agent has assembled the notice case and computed the deadline, legal counsel needs each fact traced to its source and any stale event feed marked as stale, so that missing evidence never reads as no issue and the decision to send, waive or close stays with the named authority.",
    "workblock.obligation.current-state": "Once a contract is signed, its commitments scatter into milestone spreadsheets, calendar reminders and, where one exists, an obligation module; when an alert fires, the contract manager rereads the contract to rebuild what is owed, to whom and by when.",
    "workblock.obligation.description": "Extract agreed obligations into owned records and monitor dates, exceptions and follow-through.",
    "workblock.obligation.descriptor": "Obligation and performance management",
    "workblock.obligation.future-state": "Each material obligation reaches its owner as an owned record with the exact clause, deadline and gathered evidence attached, and a stale event feed is marked stale rather than reading as no issue; the agent assembles the case and computes the deadline, while the decision to send, waive or close stays with the named authority.",
    "workblock.obligation.hired-instead": "Today this job is done by the contract system's obligation module where one exists, a milestone spreadsheet, calendar reminders and a contract manager who rereads the contract when an alert arrives.",
    "workblock.obligation.job": "Bring each material obligation to its owner with the language, deadline and evidence needed to act, before the window closes.",
    "workblock.obligation.label": "Obligation and performance management",
    "workblock.obligation.outcome": "Commitments remain visible after signature.",
    "workblock.obligation.story.accept-ownership.completion": "The owner has accepted or rejected the assignment on the record; a rejected or orphaned duty escalates to the governance owner.",
    "workblock.obligation.story.accept-ownership.story": "When a duty is assigned, the obligation owner needs the clause, the trigger, the standard and the evidence rule before accepting it, so that ownership is a decision rather than a task landing in a queue.",
    "workblock.obligation.story.amendment-impact.completion": "Affected records show the superseding amendment; prior occurrences and approvals are preserved unchanged.",
    "workblock.obligation.story.amendment-impact.story": "When an amendment changes a term, the contract manager needs every affected obligation reconciled rather than silently edited, so that a superseded duty stops creating work and history stays intact.",
    "workblock.obligation.story.evidence-closure.completion": "Closure records the accepted evidence, the accepting authority and the time; partial or disputed cases stay open with a named next step.",
    "workblock.obligation.story.evidence-closure.story": "When performance evidence arrives, the obligation owner needs submitted evidence kept separate from accepted fulfilment, so that a file upload cannot quietly close a duty the beneficiary disputes.",
    "workblock.obligation.story.notice-window.completion": "An authorised notice is sent through the approved channel, or the decision not to act is recorded with its reason, inside the window.",
    "workblock.obligation.story.notice-window.story": "When a notice window approaches, legal counsel needs the source clause, the deadline calculation and the facts in one case, so that the decision to act, or to let the window pass, is made on evidence and in time.",
    "workblock.obligation.story.validate-extraction.completion": "Every validated obligation traces to its clause and amendment; ambiguous candidates stay blocked with a named reviewer, and exclusions are recorded.",
    "workblock.obligation.story.validate-extraction.story": "When an executed agreement lands, the contract manager needs the material duties and rights identified without extraction being mistaken for interpretation, so that only validated obligations create operational work.",
    "workblock.obligation.tool": "Monitor contract obligations",
    "workblock.onboarding.agent-story": "The agent searches the master, assembles the engagement facts and drafts the evidence plan as a proposal. The coordinator sees the rule behind each requirement and changes what is wrong, and nothing is created in the master until the named owner commits it.",
    "workblock.onboarding.current-state": "A new supplier is registered through the ERP workflow while risk questionnaires run in separate tools, and coordinators stitch the checks together with email chases and spreadsheet trackers, often asking the supplier for the same evidence more than once.",
    "workblock.onboarding.description": "Coordinate data, documents, checks and approvals around one supplier onboarding record.",
    "workblock.onboarding.descriptor": "Supplier onboarding",
    "workblock.onboarding.future-state": "A supplier is established once as a verified canonical record, with evidence scoped to the intended relationship and identity, registration and risk checks arriving as one case; the agent assembles the engagement facts and drafts the evidence plan as a proposal, and nothing is created in the master until the named owner commits it.",
    "workblock.onboarding.hired-instead": "Today this job is done by the ERP registration workflow, risk questionnaires in separate tools, and the email chases and spreadsheet trackers that stitch them together.",
    "workblock.onboarding.job": "Move a proposed supplier relationship to an authorised, transaction-ready state, when the checks span procurement, risk, finance and the ERP.",
    "workblock.onboarding.label": "Supplier onboarding",
    "workblock.onboarding.outcome": "Suppliers become transaction-ready without the email chase.",
    "workblock.onboarding.story.duplicate-party.completion": "The match decision is recorded with the evidence behind it, and the master holds one confirmed party and site.",
    "workblock.onboarding.story.duplicate-party.story": "When a proposed supplier resembles a record that already exists, the supplier-master steward needs the match candidates and their source basis in one place, so that they can link, merge or create without producing a duplicate.",
    "workblock.onboarding.story.failed-activation.completion": "Approval, outbound request and confirmed master state are three separate facts on the case, and a retry reconciles against the destination first.",
    "workblock.onboarding.story.failed-activation.story": "When approval succeeds but the master write fails, the onboarding coordinator needs the case to say unknown rather than active, so that a retry does not create a duplicate supplier.",
    "workblock.onboarding.story.new-supplier.completion": "The case shows the resolved party, the engagement scope, the required evidence and a named owner for the next decision.",
    "workblock.onboarding.story.new-supplier.story": "When the business proposes a new supplier with a start date already promised, the onboarding coordinator needs the party identified and the case routed proportionately, so that work starts on the right record without a late compliance surprise.",
    "workblock.onboarding.story.protected-change.completion": "The change record shows the independent verification, the approving control owner and the reconciled master state.",
    "workblock.onboarding.story.protected-change.story": "When a supplier reports new bank details, the supplier-master steward needs the change verified independently of whoever requested it, so that a payment diversion is caught before the master changes.",
    "workblock.onboarding.story.supplier-burden.completion": "Every request names the claim it tests, the supplier can see status, owner and the correction route, and a repeated request states why the earlier answer no longer applies.",
    "workblock.onboarding.story.supplier-burden.story": "When a customer asks the supplier to register, the supplier contact needs to provide only what has not already been given and to see why each item is required, so that the relationship starts on time instead of stalling in a portal.",
    "workblock.onboarding.tool": "Onboard a supplier",
    "workblock.payment-guard.agent-story": "When the agent submits an in-envelope routine payment under an active policy grant, the payment approver needs final checks, authority scope, idempotency, bank receipt, sampled outcomes and kill-switch state visible, so that safe execution can run autonomously while novel or material payments remain supervised.",
    "workblock.payment-guard.current-state": "Payment execution today spans ERP payment proposals, treasury controls, bank files and approval packs, with rejected, returned or uncertain instructions reconciled by hand. Proof that an instruction went out exactly once, and what happened to it, is assembled after the fact.",
    "workblock.payment-guard.description": "Build, validate, transmit and reconcile payment instructions within separation-of-duties, duplicate-control and recovery policies.",
    "workblock.payment-guard.descriptor": "Payment execution control",
    "workblock.payment-guard.future-state": "Only unexpired, committed readiness decisions become payment instructions: the agent validates authority and duplicate controls at the commitment boundary, submits permitted batches exactly once and reconciles acceptance, settlement and remittance evidence. Novel or material payments stay with the named payment approver.",
    "workblock.payment-guard.hired-instead": "Today this job is done through ERP payment proposals, treasury controls, bank files or APIs, approval packs and manual reconciliation of rejected, returned or uncertain instructions.",
    "workblock.payment-guard.job": "Submit each authorised payment instruction exactly once and reconcile acceptance, settlement, rejection or return before closure.",
    "workblock.payment-guard.label": "Payment execution control",
    "workblock.payment-guard.outcome": "Routine trusted payments execute inside policy without blurring readiness, release and settlement.",
    "workblock.payment-guard.story.duplicate-prevention.completion": "The instruction binds to an approved content hash and business key, confirmed duplicates are rejected, and uncertain matches enter an owned investigation before submission.",
    "workblock.payment-guard.story.duplicate-prevention.story": "When a payment resembles a prior instruction or its payload changed after approval, the risk owner needs deterministic duplicate and integrity controls applied, so that retries or tampering cannot create a second payment.",
    "workblock.payment-guard.story.final-validation.completion": "Every final requirement records its source and observation time, and any expired, changed or unresolved condition blocks submission with the owning decision named.",
    "workblock.payment-guard.story.final-validation.story": "When a payment instruction reaches execution, the payment approver needs beneficiary, amount, due state, sanctions, funding, segregation and authority revalidated, so that approval of an earlier version cannot release altered or stale details.",
    "workblock.payment-guard.story.in-envelope-submit.completion": "The command revalidates the policy grant at execution, uses an idempotency key and records the authoritative accepted, rejected or unknown bank receipt.",
    "workblock.payment-guard.story.in-envelope-submit.story": "When all controls pass and the active grant covers the payment, the treasury manager needs it committed and transmitted once, so that routine authorised payments can complete without an item-by-item human wait.",
    "workblock.payment-guard.story.reconcile-recovery.completion": "The observed bank and ledger states are reconciled, unsafe retry remains blocked, and the case ends in confirmed settlement, corrected resubmission, authorised reversal or a named manual recovery.",
    "workblock.payment-guard.story.reconcile-recovery.story": "When submission or settlement has an uncertain or failed effect, the controller needs authoritative reconciliation before retry or reversal, so that recovery cannot duplicate value movement.",
    "workblock.payment-guard.story.track-outcome.completion": "The payment state advances only from source-confirmed events, retains freshness and last-good status, and every rejected or returned item opens its typed recovery path.",
    "workblock.payment-guard.story.track-outcome.story": "When a bank accepts an instruction, the treasury manager needs settlement, rejection and return events tracked, so that acceptance is not displayed as completed payment.",
    "workblock.payment-guard.tool": "Prepare or reconcile a payment instruction",
    "workblock.payment.agent-story": "When the agent proposes allowed or blocked, the payment approver needs each requirement's source, its observation time and the events that would expire it, so that the proposal stays a proposal: approval, instruction and release remain with the named authority and the payment system.",
    "workblock.payment.current-state": "Payment release today rests on a payment proposal in the ERP or treasury system, an emailed approval pack and the operator's own checks across separate screens before cut-off. Nothing confirms that each approval is still current when the run leaves.",
    "workblock.payment.description": "Confirm approvals and supporting records before a payment instruction leaves the platform boundary.",
    "workblock.payment.descriptor": "Payment readiness check",
    "workblock.payment.future-state": "Every payable invoice carries a versioned readiness assessment in which each requirement shows its source, observation time and the events that would expire it. The agent proposes ready or held; approval and release stay with the named payment authority, so no payment moves on a stale approval.",
    "workblock.payment.hired-instead": "Today this job is done by the payment proposal in the ERP or treasury system, an emailed approval pack and the operator's own checks across separate screens before cut-off.",
    "workblock.payment.job": "Decide whether a payment candidate is ready for release while every condition that justifies it is still current.",
    "workblock.payment.label": "Payment readiness check",
    "workblock.payment.outcome": "No payment moves on a stale approval.",
    "workblock.payment.story.batch-review.completion": "The readiness decision is recorded as allowed, blocked or expired, and every batch line opens to its candidate, requirement results and source times.",
    "workblock.payment.story.batch-review.story": "When a payment run selects hundreds of candidates, the payment approver needs every material blocker visible and every aggregate open to its items, so that approval covers what is actually in the batch rather than a summary of it.",
    "workblock.payment.story.decision-handoff.completion": "The payment system acknowledges the decision reference, and any later rejection returns as a new owned exception without rewriting the earlier decision.",
    "workblock.payment.story.decision-handoff.story": "When the readiness decision is approved, the payment approver needs it accepted by the system that creates the instruction, so that there is one release path and no second source of payment truth.",
    "workblock.payment.story.payee-change.completion": "The dependent decision shows expired, the renewed evidence is dated, and a new decision is recorded before any handoff.",
    "workblock.payment.story.payee-change.story": "When a payee record or bank-verification result changes after approval, the controller needs the affected decision expired and re-evaluated, so that an old approval cannot carry a payment to changed details.",
    "workblock.payment.story.payment-terms.completion": "The scenario set separates capture, decline and schedule-discipline positions with the invoice and entitlement records behind each, and every proposed terms action enters the existing readiness commitment path for a named human decision.",
    "workblock.payment.story.payment-terms.story": "When approved invoices, contracted terms or the cash calendar shift the discount position, the treasury manager needs capture and terms scenarios ranked with their records, so that working-capital positions change by named commitment rather than by default.",
    "workblock.payment.story.stale-screening.completion": "The candidate holds a failed requirement naming the specialist service, its owner and the current result, or the reason none exists.",
    "workblock.payment.story.stale-screening.story": "When a sanctions or fraud result is stale or unavailable, the risk owner needs the candidate blocked rather than assumed clear, so that absence of screening is never treated as clearance.",
    "workblock.payment.story.treasury-change.completion": "The readiness package references the current cycle version and the renewed treasury instruction, with prior decisions preserved unchanged.",
    "workblock.payment.story.treasury-change.story": "When treasury changes the cycle or funding instruction, the treasury manager needs affected candidates re-evaluated against the current context, so that timing and route decisions bind to the run that will actually execute.",
    "workblock.payment.tool": "Assess payment readiness",
    "workblock.performance-monitor.agent-story": "When the agent opens a routine breach case, requests evidence or verifies an in-envelope recovery milestone, the relationship manager needs source observations, threshold version, supplier response and critic results visible, so that monitoring can run autonomously while consequential remedies remain supervised.",
    "workblock.performance-monitor.current-state": "Performance change today is spotted across operational reports, scorecards, complaint and incident logs and corrective-action trackers, with governance meetings reconciling definitions by hand. Related symptoms stay separate, so correction starts late.",
    "workblock.performance-monitor.description": "Normalise observations, maintain dimensional scorecards and progress material issues through corrective action and verified efficacy.",
    "workblock.performance-monitor.descriptor": "Supplier performance tracking and corrective action",
    "workblock.performance-monitor.future-state": "Comparable observations flow in under approved definitions, and breaches and trend shifts consolidate into one case with a proportionate corrective plan. The agent runs routine internal follow-through and verifies recovery evidence, while consequential remedies stay with the named relationship manager.",
    "workblock.performance-monitor.hired-instead": "Today this job is done through operational reports, supplier scorecards, complaint and incident logs, corrective-action trackers and governance meetings that reconcile definitions by hand.",
    "workblock.performance-monitor.job": "Detect supplier performance change from comparable observations and complete proportionate corrective action through sustained recovery.",
    "workblock.performance-monitor.label": "Supplier performance tracking and corrective action",
    "workblock.performance-monitor.outcome": "Performance signals become timely containment and durable improvement.",
    "workblock.performance-monitor.story.atomic-observations.completion": "Each observation records supplier, service, period, measure definition, numerator, denominator, source and freshness, and incompatible data remains separate.",
    "workblock.performance-monitor.story.atomic-observations.story": "When performance data arrives from different operations, the metric owner needs comparable atomic observations with definition, unit, population and source, so that a score does not combine unlike measures.",
    "workblock.performance-monitor.story.corrective-action.completion": "The committed plan records actions, evidence, dates, escalation conditions and decision authority, and every task remains linked to the original breach.",
    "workblock.performance-monitor.story.corrective-action.story": "When a material performance issue is confirmed, the governance owner needs a proportionate corrective plan with supplier and internal owners, so that response matches consequence and authority.",
    "workblock.performance-monitor.story.detect-change.completion": "The signal cites contract or target thresholds, comparison period and contributing records, and ends in monitor, dismiss, investigate or open-action state.",
    "workblock.performance-monitor.story.detect-change.story": "When observations show breach, degradation or recovery, the relationship manager needs the affected commitment and trend identified, so that one late record is not mistaken for a sustained change.",
    "workblock.performance-monitor.story.quality-or-performance.completion": "The case records validation and reconciliation results, retains last-good state on source failure and routes the issue to the data or relationship owner appropriately.",
    "workblock.performance-monitor.story.quality-or-performance.story": "When a metric moves unexpectedly, the metric owner needs source-quality failure distinguished from supplier performance, so that the supplier is not held accountable for a broken feed.",
    "workblock.performance-monitor.story.sustained-recovery.completion": "The required measures meet the recovery rule across the full period, or the case reopens with failed conditions and routes the next authorised consequence.",
    "workblock.performance-monitor.story.sustained-recovery.story": "When corrective actions report complete, the relationship manager needs recovery verified over the agreed period, so that a single good observation does not close the issue.",
    "workblock.performance-monitor.tool": "Review performance or corrective action",
    "workblock.performance.agent-story": "When the agent has drafted the scorecard narrative, the supplier relationship manager needs every factual sentence to open into its source, so that unsupported text is rejected before the meeting treats it as fact.",
    "workblock.performance.current-state": "A supplier review today is assembled from a scorecard module, a reconciliation workbook, a slide deck and meeting minutes, with email threads chasing the actions afterwards. Whoever runs the review rebuilds the evidence behind each score before the meeting.",
    "workblock.performance.description": "Assemble scorecards, narrative, actions and minutes for a governed review cycle.",
    "workblock.performance.descriptor": "Supplier performance review",
    "workblock.performance.future-state": "The review arrives assembled: source-linked observations, a versioned scorecard, exposed disagreements and a drafted narrative in which every factual sentence opens into its source. The relationship manager commits the outcome, and the review ends in accepted commitments with owned follow-through, not in minutes.",
    "workblock.performance.hired-instead": "Today this job is done by the suite's scorecard module, a reconciliation workbook, a slide deck, meeting minutes and the email threads that chase the actions afterwards.",
    "workblock.performance.job": "Move one supplier review from scattered evidence to accepted commitments and verified closure.",
    "workblock.performance.label": "Supplier performance review",
    "workblock.performance.outcome": "A review ends in accepted commitments, not in meeting minutes.",
    "workblock.performance.story.accept-commitment.completion": "The commitment records the accepting party, delegated owner, due condition and acceptance criteria; anything unaccepted stays visibly proposed.",
    "workblock.performance.story.accept-commitment.story": "When the meeting proposes work for the supplier, the supplier account lead needs to edit and accept it under documented delegation, so that the supplier is held only to work it actually agreed.",
    "workblock.performance.story.carry-handoff.completion": "The destination acknowledges the action or the handoff shows as blocked with a named owner, and the originating decision keeps its evidence attached.",
    "workblock.performance.story.carry-handoff.story": "When a review conclusion creates contract or risk work, the supplier relationship manager needs the accepted decision carried to the system that owns it, so that follow-through does not restart as an email thread.",
    "workblock.performance.story.critical-event.completion": "Materiality is decided, and the authorised response or the reason for no action is recorded and linked to the review.",
    "workblock.performance.story.critical-event.story": "When a material service or quality failure lands mid-period, the supplier relationship manager needs its consequence raised beside the aggregate score, so that a healthy average cannot bury a failed hard obligation.",
    "workblock.performance.story.prepare-pack.completion": "The pack is approved for review, every score opens into its method and sources, and missing or disputed evidence is marked as such.",
    "workblock.performance.story.prepare-pack.story": "When the review period closes and the facts sit in other teams' systems and a workbook, the supplier relationship manager needs the evidence assembled with sources, freshness and gaps visible, so that the meeting starts from shared facts instead of reconciling them.",
    "workblock.performance.story.reproduce-score.completion": "The score is confirmed, corrected or held as a documented dispute, with both positions and the interim decision retained.",
    "workblock.performance.story.reproduce-score.story": "When the supplier disputes a number in the meeting, the metric or data owner needs the method, inputs and period behind the score reproducible, so that the dispute lands on the evidence rather than on the relationship.",
    "workblock.performance.story.verify-closure.completion": "The named reviewer accepts the closure evidence, or the commitment is returned and reopened with the reason attached.",
    "workblock.performance.story.verify-closure.story": "When a commitment is reported done, the supplier relationship manager needs the closure evidence checked by a named reviewer, so that done means the outcome changed rather than a task got ticked.",
    "workblock.performance.tool": "Prepare a supplier review",
    "workblock.po-exception.agent-story": "When the case opens with a proposed cause and next action, the procurement buyer needs the evidence for and against it and the facts still missing, so that the proposal can be accepted, corrected or rejected without redoing the investigation.",
    "workblock.po-exception.current-state": "Order exceptions surface in an attention queue and an integration monitor but are worked through email threads and a spreadsheet of open cases, and resolution depends on whoever knows the runbook re-establishing what the order, the supplier's response and the receipt actually say.",
    "workblock.po-exception.description": "Classify and resolve order exceptions with the right records and authority.",
    "workblock.po-exception.descriptor": "Purchase order exception resolution",
    "workblock.po-exception.future-state": "Each exception is investigated once as a single case carrying the proposed cause, the evidence for and against it and the facts still missing, then corrected in the system that owns the order; deterministic, reversible fixes run within the mission envelope, while commercial changes, cancellations and new spend stay with the buyer.",
    "workblock.po-exception.hired-instead": "Today this job is done by the ERP attention queue, an integration monitor, email threads, a spreadsheet of open cases and whoever knows the runbook.",
    "workblock.po-exception.job": "Resolve a purchase-order exception when the order, the supplier's response and the receipt no longer agree.",
    "workblock.po-exception.label": "Purchase order exception resolution",
    "workblock.po-exception.outcome": "An exception is investigated once and corrected in the system that owns the order.",
    "workblock.po-exception.story.business-consequence.completion": "An accepted operational choice, or a constraint documented against the order.",
    "workblock.po-exception.story.business-consequence.story": "When fulfilment is at risk or the supplier proposes a change, the requester needs the business consequence and the decision they own stated plainly, so that they are not left to interpret integration codes.",
    "workblock.po-exception.story.choose-correction.completion": "An accepted cause, and a corrected state confirmed in the system that owns the order.",
    "workblock.po-exception.story.choose-correction.story": "When an order fails, changes or conflicts with the supplier or receipt state, the procurement buyer needs the affected order version, the evidence for the cause and the valid options with the authority each one needs, so that a correction is chosen without rebuilding the case across applications.",
    "workblock.po-exception.story.clean-handoff.completion": "A handoff accepted by the invoice owner, with the source references attached.",
    "workblock.po-exception.story.clean-handoff.story": "When an invoice later references the order, the procurement buyer needs the committed order and receipt state handed over with any unresolved buying cause, so that the AP processor does not start a second investigation from the same evidence.",
    "workblock.po-exception.story.reconcile-before-retry.completion": "One authoritative transaction, a reconciled message history and a closed recovery record.",
    "workblock.po-exception.story.reconcile-before-retry.story": "When an order message or write fails or its result is unknown, the ERP or integration owner needs to know whether the transaction committed before anything is resent, so that a retry cannot create a second order.",
    "workblock.po-exception.story.record-what-arrived.completion": "An accurate receipt, correction, return or disputed-acceptance case in the receiving record.",
    "workblock.po-exception.story.record-what-arrived.story": "When the delivered quantity, condition or service evidence differs from the order, the receiver needs to record the observed facts and pass the commercial consequence to its owner, so that no despatch note or invoice stands in for their acceptance.",
    "workblock.po-exception.tool": "Resolve an order exception",
    "workblock.po-orchestration.agent-story": "When the agent dispatches a routine order or applies an in-envelope acknowledgement, the procurement buyer needs source versions, idempotency, supplier receipt and reconciliation visible, so that normal orders can flow autonomously while altered commercial terms remain supervised.",
    "workblock.po-orchestration.current-state": "Orders pass through the ERP process, integration middleware and supplier-network messages, and when acknowledgements or changes fail to reconcile it falls to the buyer to chase which version of the order the supplier actually accepted.",
    "workblock.po-orchestration.description": "Create, dispatch, reconcile, change and close routine orders within explicit commercial and policy bounds.",
    "workblock.po-orchestration.descriptor": "Purchase order orchestration",
    "workblock.po-orchestration.future-state": "An approved requisition becomes one accurate, acknowledged purchase order committed exactly once, with acknowledgements, changes and fulfilment reconciled at line level; the agent dispatches routine orders and records supplier responses exactly as received, while material price, quantity or schedule changes go to the buyer to decide.",
    "workblock.po-orchestration.hired-instead": "Today this job is done by the ERP purchase-order process, integration middleware, supplier-network messages and buyer follow-up when acknowledgements or changes do not reconcile.",
    "workblock.po-orchestration.job": "Create, dispatch and reconcile the authorised purchase order exactly once across buyer, supplier and source systems.",
    "workblock.po-orchestration.label": "Purchase order orchestration",
    "workblock.po-orchestration.outcome": "Orders remain aligned with approvals, contracts, acknowledgements and delivery state.",
    "workblock.po-orchestration.story.create-dispatch.completion": "The order command uses a stable business key, returns authoritative internal and external receipts, and uncertain effects enter reconciliation before retry.",
    "workblock.po-orchestration.story.create-dispatch.story": "When an order is authorised, the integration owner needs the correct document created and dispatched exactly once across retries, so that network timeout cannot duplicate a commercial commitment.",
    "workblock.po-orchestration.story.precommit-check.completion": "The order candidate binds to current approved source versions, and any material change returns to the owning decision instead of being silently corrected.",
    "workblock.po-orchestration.story.precommit-check.story": "When an approved requisition is ready for ordering, the procurement buyer needs supplier, price, terms, budget, authority and policy revalidated, so that stale approval cannot create a different commitment.",
    "workblock.po-orchestration.story.state-reconciliation.completion": "The reconciliation identifies the authoritative state, repairs or compensates permitted differences, preserves last-good reads and closes only when every required receipt agrees.",
    "workblock.po-orchestration.story.state-reconciliation.story": "When order, response, change or fulfilment states diverge across systems, the integration owner needs the last confirmed state and repair path visible, so that one system's silence is not presented as agreement.",
    "workblock.po-orchestration.story.supplier-response.completion": "The response links to exact order lines and source message, classifies accepted and changed terms, and routes only material deviations to a named decision owner.",
    "workblock.po-orchestration.story.supplier-response.story": "When a supplier acknowledges, rejects or proposes a change, the procurement buyer needs the response normalised without inventing acceptance, so that every changed term receives the authority it requires.",
    "workblock.po-orchestration.tool": "Create or reconcile an order",
    "workblock.policy-lifecycle.agent-story": "When the agent deploys a canary rule release inside its approved release grant, the policy owner needs the exact source passage, test set, affected decisions, runtime observations and rollback control visible, so that routine releases can progress autonomously without allowing generated interpretation to become authority.",
    "workblock.policy-lifecycle.current-state": "Policy today is divided between approved documents and the requirements tickets, decision tables, test spreadsheets and release pipelines that implement them, and it takes the people who wrote the rules to explain which interpretation is actually running.",
    "workblock.policy-lifecycle.description": "Draft, test, simulate, publish and roll back policy documents, executable rules and affected authority envelopes.",
    "workblock.policy-lifecycle.descriptor": "Procurement policy rule authoring and lifecycle",
    "workblock.policy-lifecycle.future-state": "Approved policy becomes tested, versioned and reversible rule releases, with policy owners approving material semantic changes and every Workblock able to prove which release governed an action.",
    "workblock.policy-lifecycle.hired-instead": "Today this job is divided between policy documents, requirements tickets, decision tables, test spreadsheets, release pipelines and the people who explain which interpretation the code implements.",
    "workblock.policy-lifecycle.job": "Turn approved policy into tested, versioned rules whose effect can be traced, observed and reversed.",
    "workblock.policy-lifecycle.label": "Procurement policy rule authoring and lifecycle",
    "workblock.policy-lifecycle.outcome": "Every active rule is versioned, tested and reversible.",
    "workblock.policy-lifecycle.story.boundary-testing.completion": "The pinned test set passes its required cases, failed and abstained cases have dispositions, and results can be reproduced from the same rule and input versions.",
    "workblock.policy-lifecycle.story.boundary-testing.story": "When a rule release is proposed, the policy owner needs realistic, boundary, conflict and regression cases run before activation, so that a passing happy path does not conceal harmful edge behaviour.",
    "workblock.policy-lifecycle.story.change-impact.completion": "An impact record lists affected consumers and cases, expires only invalid proposals, preserves committed history and tracks every required re-evaluation or notification to closure.",
    "workblock.policy-lifecycle.story.change-impact.story": "When a rule is corrected, superseded or retired, the policy owner needs every affected Workblock and open decision identified, so that delivered guidance and pending commitments are handled deliberately.",
    "workblock.policy-lifecycle.story.channel-drift.completion": "The drift assessment names the rule, the assigned route, the observed route and the drift share with named requisition evidence, and every proposed rule adjustment waits for the policy owner's release decision.",
    "workblock.policy-lifecycle.story.channel-drift.story": "When routed buying drifts from a released channel rule beyond tolerance, the policy owner needs the drift measured per rule with the routed records behind it, so that the rule set changes by evidence rather than by anecdote.",
    "workblock.policy-lifecycle.story.controlled-release.completion": "The authorised release activates once for its declared scope, canary observations remain within limits, and the prior approved release can be restored with a reconciled audit trail.",
    "workblock.policy-lifecycle.story.controlled-release.story": "When a tested rule is ready, the policy owner needs canary deployment, observation and exact rollback under one release record, so that routine changes can move safely without an irreversible cutover.",
    "workblock.policy-lifecycle.story.rule-authoring.completion": "A candidate rule release validates against its schema, contains no unresolved precedence conflict and records every authorised interpretation separately from source text.",
    "workblock.policy-lifecycle.story.rule-authoring.story": "When policy language must become executable, the policy owner needs scope, conditions, effects and precedence expressed deterministically, so that the same facts produce the same bounded decision.",
    "workblock.policy-lifecycle.story.source-trace.completion": "Every active rule cites an approved source version and passage, and unmapped, conflicting or superseded requirements are explicit exceptions.",
    "workblock.policy-lifecycle.story.source-trace.story": "When an approved policy version changes, the policy owner needs each executable rule traced to the exact controlling passage, so that implemented behaviour can be explained and superseded guidance cannot remain active unnoticed.",
    "workblock.policy-lifecycle.tool": "Draft or simulate a policy change",
    "workblock.policy.agent-story": "When the agent drafts an answer, the policy owner needs every conclusion tied to the exact source passage that supports it, and an abstention when the sources conflict or fall silent, so that generated text never becomes authority.",
    "workblock.policy.current-state": "Policy questions today are answered by an intranet search, a colleague who remembers the rule, a service desk queue and the policy owner's inbox, so people act on guesses while the controlling source stays scattered.",
    "workblock.policy.description": "Answer policy questions against governed sources and route exceptions to the right owner.",
    "workblock.policy.descriptor": "Procurement policy guidance",
    "workblock.policy.future-state": "Every question returns an expiring, source-anchored answer stating what is permitted, what evidence is missing and which route is valid, and only true exceptions that active policy cannot decide reach the named exception owner.",
    "workblock.policy.hired-instead": "Today this job is done by an intranet search, a colleague who remembers the rule, a service desk queue and the policy owner's inbox.",
    "workblock.policy.job": "Apply the controlling policy to the facts of a request before anyone acts on a guess.",
    "workblock.policy.label": "Procurement policy guidance",
    "workblock.policy.outcome": "Every answer cites the source that controls it.",
    "workblock.policy.story.conflicting-sources.completion": "An approved interpretation names the controlling source and links every affected case.",
    "workblock.policy.story.conflicting-sources.story": "When two sources appear to conflict, the policy owner needs to decide which one controls, so that both sources and the decision reason are preserved.",
    "workblock.policy.story.decision-point.completion": "The cited rule sits on the record with an explicit approval or escalation state.",
    "workblock.policy.story.decision-point.story": "When a purchase request or sourcing case reaches a policy decision point, the procurement policy owner needs the applicable rule delivered with the proposed action, so that policy evidence travels with the decision instead of a separate search.",
    "workblock.policy.story.exception-route.completion": "A committed approval, rejection or conditional decision is recorded, with conditions and expiry.",
    "workblock.policy.story.exception-route.story": "When a request falls outside the standard rule, the policy owner needs the deviation, rationale and consequence packaged for decision, so that the exception is decided by the right authority rather than by informal approval.",
    "workblock.policy.story.missing-fact.completion": "The context is completed and the answer revised, or the case is closed with the gap named.",
    "workblock.policy.story.missing-fact.story": "When the facts are incomplete, the policy owner needs only the facts that change applicability collected, so that no confident advice lands on a partial case.",
    "workblock.policy.story.policy-change.completion": "An impact review lists the affected cases, and corrected answers and notifications are complete.",
    "workblock.policy.story.policy-change.story": "When a policy changes, the policy owner needs to know which delivered guidance and open work it affects, so that current advice is corrected without rewriting history.",
    "workblock.policy.story.which-route.completion": "A bounded answer cites the controlling source and version and names the next step.",
    "workblock.policy.story.which-route.story": "When a requester does not know which procurement route applies, the procurement policy owner needs the current rule applied to the actual facts, so that the next step is valid without a search through documents.",
    "workblock.policy.tool": "Interpret procurement policy",
    "workblock.realization-reconciliation.agent-story": "When the agent commits a routine in-envelope realisation under an approved method, the finance delegate needs actual-source coverage, adjustments, overlap controls, authority and sampled outcomes visible, so that safe autonomy can handle repeatable cases while material or novel attribution remains supervised.",
    "workblock.realization-reconciliation.current-state": "Realised value today is reconciled through savings trackers, finance and transaction extracts and attribution workbooks, ending in initiative reviews and a finance decision on which amount reaches the portfolio. Each cycle rebuilds the join between baseline, actuals and adjustments by hand.",
    "workblock.realization-reconciliation.description": "Reconcile expected and actual outcomes, apply registered methods and allocate each validated benefit once.",
    "workblock.realization-reconciliation.descriptor": "Value realisation reconciliation and attribution",
    "workblock.realization-reconciliation.future-state": "Committed baselines join to current order, invoice, payment and ledger actuals under a versioned attribution method that normalises period, volume, mix and one-off effects and rejects double counting. The agent drafts the disposition, and only finance-committed realisation is recorded as validated value.",
    "workblock.realization-reconciliation.hired-instead": "Today this job is done through savings trackers, finance and transaction extracts, attribution workbooks, initiative reviews and a finance decision on which amount reaches the portfolio.",
    "workblock.realization-reconciliation.job": "Commit reproducible realised value from current actuals, approved adjustments and double-count-safe attribution.",
    "workblock.realization-reconciliation.label": "Value realisation reconciliation and attribution",
    "workblock.realization-reconciliation.outcome": "Realised value is finance-aligned, non-duplicated and traceable to source records.",
    "workblock.realization-reconciliation.story.assemble-actuals.completion": "The actual set reconciles entities, population, period, unit and currency to the committed measurement contract and marks coverage, freshness and exclusions.",
    "workblock.realization-reconciliation.story.assemble-actuals.story": "When a measurement period closes, the value lead needs actual evidence assembled for the exact initiative scope and period, so that missing or stale data is not treated as zero performance.",
    "workblock.realization-reconciliation.story.attribute-value.completion": "The attribution calculates exactly from pinned baseline and actual snapshots, records initiative shares and explains every difference from gross variance.",
    "workblock.realization-reconciliation.story.attribute-value.story": "When eligible variance remains, the finance delegate needs it attributed to one initiative or an approved shared method, so that the realised amount is reproducible and accountable.",
    "workblock.realization-reconciliation.story.commit-reconcile.completion": "The authorised disposition records value, method and evidence, updates the portfolio exactly once and preserves rejection, restatement and prior finance decisions as separate states.",
    "workblock.realization-reconciliation.story.commit-reconcile.story": "When attribution is complete, the finance delegate needs the realised amount committed or rejected and reconciled to the portfolio, so that validated value remains distinct from forecast and proposal.",
    "workblock.realization-reconciliation.story.normalise-effects.completion": "Every adjustment records class, source, formula, method version and effect, and unapproved or residual adjustments remain proposed exceptions.",
    "workblock.realization-reconciliation.story.normalise-effects.story": "When actuals include volume, mix, market, currency or timing effects, the finance delegate needs approved non-procurement adjustments separated, so that procurement does not claim or lose value it did not cause.",
    "workblock.realization-reconciliation.story.prevent-overlap.completion": "The overlap graph resolves allocation once under an approved method or blocks the affected proposals with the conflict and decision owner named.",
    "workblock.realization-reconciliation.story.prevent-overlap.story": "When initiatives overlap in scope, period or effect, the value lead needs conflicting claims detected before commitment, so that one outcome cannot enter the portfolio twice.",
    "workblock.realization-reconciliation.tool": "Reconcile and attribute realised value",
    "workblock.receiving.agent-story": "When the agent posts an in-envelope routine receipt or opens a recovery case, the receiver needs source evidence, tolerance rules, commit receipt and sampled outcomes visible, so that normal receiving can run autonomously while disputed acceptance remains supervised.",
    "workblock.receiving.current-state": "Delivery evidence is spread across ERP receiving screens, warehouse records, proof-of-delivery files, timesheets and service-entry sheets, and requesters, buyers and suppliers reconcile quantities and acceptance over email before matching can rely on the result.",
    "workblock.receiving.description": "Ingest delivery evidence, reconcile quantities and schedules and coordinate the attestations only people can supply.",
    "workblock.receiving.descriptor": "Goods receipt and service-entry coordination",
    "workblock.receiving.future-state": "Goods receipt and service acceptance are committed exactly once from source-linked delivery evidence, current and ready for invoice matching; routine in-tolerance receipts post under policy, subjective quality and outcome judgements stay with the named receiver, and every material variance becomes a pursued return or recovery case.",
    "workblock.receiving.hired-instead": "Today this job is done through ERP receiving screens, warehouse records, proof-of-delivery files, timesheets, service-entry sheets and email between requesters, buyers and suppliers.",
    "workblock.receiving.job": "Commit accurate goods receipt or service acceptance from source-linked delivery evidence and pursue every material variance.",
    "workblock.receiving.label": "Goods receipt and service-entry coordination",
    "workblock.receiving.outcome": "Receipt and service acceptance are current, evidenced and ready for matching.",
    "workblock.receiving.story.correlate-delivery.completion": "The delivery record links its source artifact and identity evidence to matched order lines, and unmatched or conflicting references remain blocked exceptions.",
    "workblock.receiving.story.correlate-delivery.story": "When goods or service evidence arrives, the receiver needs it correlated to the correct order, lines and schedule, so that a plausible document cannot post against the wrong commitment.",
    "workblock.receiving.story.post-and-recover.completion": "The post returns an authoritative receipt, partial or uncertain effects remain open, and each rejected, returned or recoverable line has an owned action through resolution.",
    "workblock.receiving.story.post-and-recover.story": "When receipt or service acceptance is supported, the receiver needs it committed exactly once and any return or recovery pursued, so that retries and downstream matching see one reconciled truth.",
    "workblock.receiving.story.quantity-condition.completion": "Every line records observed quantity and condition, tolerance result, evidence and disposition, and no rejected or unverified amount contributes to accepted receipt.",
    "workblock.receiving.story.quantity-condition.story": "When physical delivery differs from the order, the receiver needs accepted, short, excess, damaged, rejected and substituted quantities distinguished, so that payment and recovery use what was actually observed.",
    "workblock.receiving.story.service-acceptance.completion": "The service entry records the covered period, evidence and criterion result, and is accepted, partially accepted, rejected or returned by the authorised role.",
    "workblock.receiving.story.service-acceptance.story": "When a service period or milestone is submitted, the requester needs timesheets, deliverables and acceptance criteria compared, so that elapsed time alone does not prove completion.",
    "workblock.receiving.tool": "Record or reconcile delivery",
    "workblock.relationship-value.agent-story": "When the agent refreshes the joint plan, coordinates a pre-authorised internal action or verifies routine evidence, the relationship manager needs mutual commitments, authority, source facts and outcome receipts visible, so that routine coordination can run autonomously while relationship and commercial commitments remain supervised.",
    "workblock.relationship-value.current-state": "Strategic relationships today run on account plans, quarterly business-review decks, action logs, risk and performance reports and innovation lists, with follow-up chased across both organisations. Commitments, dependencies and realised outcomes drift apart between governance meetings.",
    "workblock.relationship-value.description": "Maintain shared objectives, relationship plans, collaboration projects and joint-value handoffs linked to their source records.",
    "workblock.relationship-value.descriptor": "Supplier relationship and joint-value planning",
    "workblock.relationship-value.future-state": "Both sides work from one governed relationship plan whose objectives, mutual commitments, milestones and value work link to their source records. The agent coordinates routine follow-through and verifies evidence, while relationship and commercial commitments stay with named owners and realised value stays distinct from supplier claims.",
    "workblock.relationship-value.hired-instead": "Today this job is done through account plans, quarterly business-review decks, action logs, risk and performance reports, innovation lists and meeting follow-up across both organisations.",
    "workblock.relationship-value.job": "Run a shared supplier relationship plan that turns objectives, commitments, performance, risk, innovation and value into verified outcomes.",
    "workblock.relationship-value.label": "Supplier relationship and joint-value planning",
    "workblock.relationship-value.outcome": "Strategic supplier commitments turn into owned work and finance-visible outcomes.",
    "workblock.relationship-value.story.adapt-next-plan.completion": "Outcomes reconcile to their evidence and baseline, accepted learning is versioned, and the next plan records retained, changed and retired commitments with decision owners.",
    "workblock.relationship-value.story.adapt-next-plan.story": "When an initiative or relationship period closes, the innovation sponsor needs verified outcomes and unmet assumptions carried into the next plan, so that adaptation rests on observed results rather than meeting sentiment.",
    "workblock.relationship-value.story.connected-plan.completion": "The plan version links the changed record, affected objective and decision, and confirms, reopens or supersedes downstream actions without double counting value.",
    "workblock.relationship-value.story.connected-plan.story": "When performance, risk, innovation or value evidence changes, the metric owner needs the effect on relationship objectives and commitments identified, so that separate reviews do not produce contradictory plans.",
    "workblock.relationship-value.story.cross-functional-actions.completion": "Each action has one accountable owner, accepted handoff, dependency, evidence and completion state, and blocked or rejected work remains visible to both sides.",
    "workblock.relationship-value.story.cross-functional-actions.story": "When an objective requires procurement, operations, risk, finance or supplier action, the governance owner needs dependencies and ownership coordinated, so that a shared commitment does not fragment into untracked follow-up.",
    "workblock.relationship-value.story.governance-cadence.completion": "The pack distinguishes facts, proposals, commitments and stale evidence, and records every decision, owner, due condition and source in the relationship history.",
    "workblock.relationship-value.story.governance-cadence.story": "When a governance meeting approaches, the supplier account lead needs a current, source-linked decision package, so that the session focuses on decisions and exceptions instead of reconciling reports.",
    "workblock.relationship-value.story.mutual-objectives.completion": "The committed plan names each objective, baseline, target, owner, supplier commitment, evidence, period and decision authority, with disagreements recorded.",
    "workblock.relationship-value.story.mutual-objectives.story": "When a relationship period begins, the relationship manager needs shared objectives and mutual commitments defined, so that governance is anchored in outcomes rather than a meeting calendar.",
    "workblock.relationship-value.tool": "Manage a supplier relationship plan",
    "workblock.renewal-compliance.agent-story": "When the agent refreshes evidence, opens a renewal case or executes a pre-authorised administrative change, the contract manager needs deadline logic, option comparisons, authority and downstream receipts visible, so that routine lifecycle work can run autonomously while material commercial decisions remain supervised.",
    "workblock.renewal-compliance.current-state": "Renewal and change windows sit in calendar alerts and spreadsheets while the evidence of usage and invoice extracts, stakeholder email and negotiation notes sits elsewhere, so the decision owner rebuilds the commercial picture each time a deadline approaches.",
    "workblock.renewal-compliance.description": "Prepare renewal, renegotiation, amendment, termination and compliance cases from current contract, consumption and performance evidence.",
    "workblock.renewal-compliance.descriptor": "Renewal, change and compliance",
    "workblock.renewal-compliance.future-state": "Renewal, change and compliance choices reach their owner before the contractual window closes, with deadline logic, quantified options and the do-nothing case prepared together from current evidence; the agent readies options and executes pre-authorised administrative steps, while material commercial decisions remain with the accountable owner.",
    "workblock.renewal-compliance.hired-instead": "Today this job is done through contract-calendar alerts, renewal spreadsheets, usage and invoice extracts, stakeholder email, negotiation notes and amendments prepared in the contract system.",
    "workblock.renewal-compliance.job": "Decide and execute a contract renewal, change or exit before its deadline using current commercial, compliance and consumption evidence.",
    "workblock.renewal-compliance.label": "Renewal, change and compliance",
    "workblock.renewal-compliance.outcome": "Renewal, change and compliance decisions reach their owner before the contractual window closes.",
    "workblock.renewal-compliance.story.compare-paths.completion": "Each feasible option records value, service, risk, dependency, notice and authority consequences, and the selected disposition has a named decision and expiry.",
    "workblock.renewal-compliance.story.compare-paths.story": "When a lifecycle decision is due, the sourcing manager needs renew, renegotiate, amend, terminate and do-nothing options compared, so that convenience does not substitute for an explicit commercial choice.",
    "workblock.renewal-compliance.story.decision-window.completion": "The case cites the clause, calendar basis and source events, records the latest safe action dates and assigns an owner before the first required lead-time threshold.",
    "workblock.renewal-compliance.story.decision-window.story": "When a notice or renewal window approaches, the contract manager needs the decision deadline and lead-time path calculated from the controlling clause and current events, so that silence does not become an unintended commitment.",
    "workblock.renewal-compliance.story.detect-variance.completion": "The variance case reconciles contracted and observed values, distinguishes source-quality gaps from non-compliance and records the recovery or decision impact.",
    "workblock.renewal-compliance.story.detect-variance.story": "When actual price, consumption, performance or conduct differs from the agreement, the obligation owner needs the variance traced to contract terms and operational records, so that renewal evidence reflects what happened rather than the stored metadata alone.",
    "workblock.renewal-compliance.story.execute-lifecycle-path.completion": "The authorised action executes exactly once, returns external receipts, publishes the superseding contract state and reconciles every affected obligation, order and access dependency.",
    "workblock.renewal-compliance.story.execute-lifecycle-path.story": "When a renewal, amendment or termination is authorised, the contract manager needs the exact notice, document and system changes committed and reconciled, so that the legal and operational states cannot silently diverge.",
    "workblock.renewal-compliance.tool": "Assess a renewal or compliance case",
    "workblock.request-routing.agent-story": "When the agent enriches and routes a routine request inside the active policy envelope, the intake owner needs the retrieved facts, source freshness, alternatives considered and route receipt visible, so that straight-through routing can run autonomously while uncertain or consequential cases remain owned exceptions.",
    "workblock.request-routing.current-state": "Routing today means an intake analyst searching contracts, catalogues, supplier records, policy and prior requests by hand, then recording the chosen route in a case system and explaining it by email.",
    "workblock.request-routing.description": "Reuse permitted context, run required checks and commit the correct execution path with its decision trace.",
    "workblock.request-routing.descriptor": "Procurement request enrichment and routing",
    "workblock.request-routing.future-state": "An accepted request arrives enriched with permitted supplier, contract, catalogue and prior-demand context and an exact policy guidance result, and the route commits with its decision trace only inside an active authority envelope, with true exceptions routed to a named owner.",
    "workblock.request-routing.hired-instead": "Today this job is done by an intake analyst searching contracts, catalogues, supplier records, policy and prior requests, then recording the route in a case system and explaining it by email.",
    "workblock.request-routing.job": "Convert an accepted request into complete procurement facts and a policy-valid route without making the requester rebuild the case.",
    "workblock.request-routing.label": "Procurement request enrichment and routing",
    "workblock.request-routing.outcome": "Complete demand reaches the right Workblock without repetitive questions.",
    "workblock.request-routing.story.explain-route.completion": "The route record cites the controlling rule and case facts, names the next owner and action, and offers a traceable correction or exception path.",
    "workblock.request-routing.story.explain-route.story": "When a route is proposed, the requester needs to know which facts and policy made it valid, so that they can correct the case or proceed without treating the recommendation as unexplained authority.",
    "workblock.request-routing.story.normalise-request.completion": "The canonical request preserves the source wording, separates confirmed and inferred facts, and names only the missing facts that can change its route or authority.",
    "workblock.request-routing.story.normalise-request.story": "When an accepted request arrives in incomplete business language, the intake owner needs it normalised into procurement-ready facts, so that downstream checks use a stable case instead of interpreting the original message again.",
    "workblock.request-routing.story.related-demand.completion": "Each related request is marked duplicate, separate or a consolidation candidate with scope, urgency and ownership retained, and no value is counted twice.",
    "workblock.request-routing.story.related-demand.story": "When similar requests could be duplicate or compatible demand, the demand owner needs them linked before execution, so that value and workload are not fragmented while distinct business ownership is preserved.",
    "workblock.request-routing.story.reuse-enterprise-context.completion": "Relevant candidates are linked with match rationale and source age, and rejected candidates retain a reason instead of disappearing from the route decision.",
    "workblock.request-routing.story.reuse-enterprise-context.story": "When existing contracts, catalogue items, suppliers or related demand may satisfy the need, the intake owner needs those candidates retrieved with identity and freshness, so that known context is reused before new work starts.",
    "workblock.request-routing.story.true-exception.completion": "The specialist receives the unresolved decision, supporting and contrary evidence, consequence, due state and permitted next actions, and accepts or redirects ownership explicitly.",
    "workblock.request-routing.story.true-exception.story": "When the available facts do not support a standard route, the intake owner needs a complete exception packet sent to the right specialist, so that manual attention is reserved for judgement or new authority.",
    "workblock.request-routing.tool": "Qualify and route a request",
    "workblock.requisition-routing.agent-story": "When the agent corrects deterministic gaps or routes an in-envelope requisition, the procurement buyer needs rule results, budget reservation, authority and immutable handoff state visible, so that routine preparation can run autonomously while exceptions and approvals stay with their named owners.",
    "workblock.requisition-routing.current-state": "Requisitions travel the ERP form and approval workflow, but buyers and budget owners spend the cycle correcting reference data, policy gaps and account coding before an order can be raised, and routine demand queues behind the same approvals as exceptions.",
    "workblock.requisition-routing.description": "Validate catalogue, budget, supplier, category and authority conditions and send valid demand straight through.",
    "workblock.requisition-routing.descriptor": "Requisition policy evaluation and routing",
    "workblock.requisition-routing.future-state": "A valid business need becomes a complete, budget-backed and policy-conforming requisition published once for ordering; conforming requests progress straight through under deterministic policy with budget reserved, while every exception and required approval keeps its named owner.",
    "workblock.requisition-routing.hired-instead": "Today this job is done by the ERP requisition form and approval workflow, with buyers and budget owners correcting reference data, policy gaps and coding before an order can be raised.",
    "workblock.requisition-routing.job": "Publish an approved requisition as a complete, policy-valid and budget-backed input to commitment.",
    "workblock.requisition-routing.label": "Requisition policy evaluation and routing",
    "workblock.requisition-routing.outcome": "Routine requisitions progress without approval queues and exceptions retain explicit owners.",
    "workblock.requisition-routing.story.budget-authority.completion": "The reservation and authority decisions bind to the requisition version, amount, entity and policy, and expiry or source change invalidates only the affected approvals.",
    "workblock.requisition-routing.story.budget-authority.story": "When a requisition is complete, the budget owner needs funds reserved and the exact approval route derived, so that downstream commitment cannot exceed current budget or delegation.",
    "workblock.requisition-routing.story.commitment-input.completion": "The approved requisition version is immutable to the handoff, publishes exactly once with authority and budget references, and the receiving business module acknowledges or rejects it explicitly.",
    "workblock.requisition-routing.story.commitment-input.story": "When approval completes, the procurement buyer needs one stable commitment input published with full evidence lineage, so that purchase-order preparation does not reinterpret the decision.",
    "workblock.requisition-routing.story.material-question.completion": "The corrected fact is versioned against the original request, deterministic gaps are resolved without interruption, and every unanswered material question has an owner and consequence.",
    "workblock.requisition-routing.story.material-question.story": "When a gap can change route, value or authority, the requester needs only the material question returned with their work preserved, so that correction does not mean starting again.",
    "workblock.requisition-routing.story.validate-lines.completion": "The requisition records passed and failed checks with source versions, and no invalid identity, unit, price, coding or required evidence remains hidden.",
    "workblock.requisition-routing.story.validate-lines.story": "When a requisition is submitted, the procurement buyer needs every header and line validated against current supplier, catalogue, accounting, tax and policy data, so that an order is not built from a structurally valid but unusable request.",
    "workblock.requisition-routing.tool": "Validate and route a requisition",
    "workblock.risk-monitor.agent-story": "When the agent suppresses a duplicate signal, refreshes a routine assessment or opens an in-envelope safeguard case, the programme owner needs source freshness, materiality logic, sampled outcomes and stop controls visible, so that monitoring can run autonomously while consequential treatment remains supervised.",
    "workblock.risk-monitor.current-state": "Risk feeds, alerts, news monitoring and supplier reviews each raise their own stream of signals, and an analyst triages them by hand to connect each one to the affected relationship, duplicates, repeats and noise included.",
    "workblock.risk-monitor.description": "Track approved evidence sources, suppress duplicates, test materiality and open evidence-complete supplier risk cases.",
    "workblock.risk-monitor.descriptor": "Third-party risk signal tracking",
    "workblock.risk-monitor.future-state": "Material supplier and sub-tier risk change becomes one owned, evidence-complete case per underlying event, with duplicates suppressed and materiality tested against the actual relationship; the agent monitors sources and pursues evidence, while restrictions, residual-risk acceptance and exit remain explicit decisions by named owners.",
    "workblock.risk-monitor.hired-instead": "Today this job is done through risk-data feeds, GRC alerts, news monitoring, supplier reviews and analyst triage that connects a signal to the affected relationship.",
    "workblock.risk-monitor.job": "Turn fresh supplier and network risk observations into relationship-specific cases before material consequence grows.",
    "workblock.risk-monitor.label": "Third-party risk signal tracking",
    "workblock.risk-monitor.outcome": "Relevant risk creates owned work before exposure becomes accepted.",
    "workblock.risk-monitor.story.early-safeguard.completion": "The action fits the active grant or reaches the authorised owner, records every affected relationship and reconciles completion, expiry or escalation without implying the risk is resolved.",
    "workblock.risk-monitor.story.early-safeguard.story": "When a material signal can affect continuity, compliance or safety, the programme owner needs evidence collection, reassessment or a bounded safeguard started before consequence grows, so that response is not delayed by the next periodic review.",
    "workblock.risk-monitor.story.material-case.completion": "The assessment records impact, likelihood, horizon, current controls, contrary evidence and threshold version, and ends in monitor, dismiss, reassess or open-case state.",
    "workblock.risk-monitor.story.material-case.story": "When exposure is confirmed, the accountable risk owner needs relationship-specific materiality assessed, so that noise is suppressed without hiding a consequential change.",
    "workblock.risk-monitor.story.normalise-observation.completion": "The canonical observation preserves source content, identity, timestamps and quality state, and duplicate or conflicting coverage is linked rather than counted again.",
    "workblock.risk-monitor.story.normalise-observation.story": "When an external or internal risk signal arrives, the programme owner needs it normalised with source, observation time and freshness, so that a repeated headline is not mistaken for a new fact.",
    "workblock.risk-monitor.story.resolve-exposure.completion": "The observation links to confirmed or candidate supplier relationships with evidence and affected commitments, and unresolved identity remains an explicit exception.",
    "workblock.risk-monitor.story.resolve-exposure.story": "When a signal names a supplier or network node, the accountable risk owner needs the affected legal entity, relationship and dependency resolved, so that risk is assessed against actual exposure.",
    "workblock.risk-monitor.tool": "Assess a supplier risk change",
    "workblock.risk-review.agent-story": "The agent drafts the assessment: facts, assumptions, findings and what is missing, each traced to its source. The reviewer opens the exact passage behind any statement and corrects the draft, and the proposal stays on record beside the accepted decision. Acceptance itself never moves without the named owner.",
    "workblock.risk-review.current-state": "The risk worklist tracks questionnaire scores, but the decision itself is assembled in email threads and committee meetings, so suppliers are re-asked for evidence they have already provided and reviewers rebuild the case each cycle.",
    "workblock.risk-review.description": "Assemble the case, draft the assessment and route consequential risk decisions to accountable humans.",
    "workblock.risk-review.descriptor": "Third-party risk review",
    "workblock.risk-review.future-state": "A third-party risk decision reaches its accountable owner sized to the real relationship, with scoped evidence, control conclusions, residual risk and the next action drafted and traced to source; the reviewer opens the exact passage behind any statement and corrects the draft, and acceptance never moves without the named owner.",
    "workblock.risk-review.hired-instead": "Today this job is done by a TPRM or GRC product's worklist, questionnaire scores, and the email threads and committee meetings where the decision is actually assembled.",
    "workblock.risk-review.job": "Bring a third-party risk decision to its accountable owner with the evidence, remaining risk and next action attached.",
    "workblock.risk-review.label": "Third-party risk review",
    "workblock.risk-review.outcome": "Risk decisions sized to the risk, with the assessment behind each one.",
    "workblock.risk-review.story.decision-package.completion": "The accepted decision records the authority it was taken under, the conditions, the expiry and the reopen triggers.",
    "workblock.risk-review.story.decision-package.story": "When a review reaches their desk, the accountable risk owner needs the evidence for and against, the remaining risk and the options in one case, so that they can accept, mitigate or decline without rebuilding the file.",
    "workblock.risk-review.story.evidence-conflict.completion": "The finding shows the evidence for and against with its source locations, and the reviewer's disposition sits beside the original proposal.",
    "workblock.risk-review.story.evidence-conflict.story": "When a questionnaire answer conflicts with the attached report, the TPRM programme owner needs both sources and the exact disagreement shown, so that a false assurance does not reach the decision.",
    "workblock.risk-review.story.method-change.completion": "The rule change carries a version, and every affected relationship is identified before the new rule applies to it.",
    "workblock.risk-review.story.method-change.story": "When a tier rule or evidence requirement changes, the TPRM programme owner needs to see which open and active relationships the change touches, so that the new rule takes effect without silent regression.",
    "workblock.risk-review.story.mitigation-closure.completion": "The mitigation closes against its stated acceptance criteria, or the risk decision reopens with the gap on record.",
    "workblock.risk-review.story.mitigation-closure.story": "When a mitigation falls due, the accountable risk owner needs closure to depend on accepted evidence rather than a ticked task, so that the risk decision does not rest on work that never reduced the risk.",
    "workblock.risk-review.story.monitoring-signal.completion": "The signal record shows the match basis, the materiality call, and either a dismissal reason or the reopened decision it created.",
    "workblock.risk-review.story.monitoring-signal.story": "When an external alert names a supplier, the accountable risk owner needs the signal matched to the party and engagement before anyone acts, so that a false match is dismissed with a reason and a material event reopens only the affected decision.",
    "workblock.risk-review.tool": "Review third-party risk",
    "workblock.savings.agent-story": "When the agent has prepared a realised candidate, the finance delegate needs the source records, method version and exclusions open beside the number, so that they can accept, adjust or reject it without redoing the calculation. The candidate stays proposed until the finance delegate decides.",
    "workblock.savings.current-state": "Savings delivery today is tracked in a savings tracker, planning lines and a reconciliation workbook, and settled in a finance review meeting. The baseline, method and evidence behind each claim scatter, so the calculation is redone whenever the number is challenged.",
    "workblock.savings.description": "Move an opportunity from identified value through validation, delivery and realised outcome.",
    "workblock.savings.descriptor": "Savings initiative tracking",
    "workblock.savings.future-state": "Each initiative carries its committed baseline, versioned plan and evidence trail from accepted opportunity to finance-reconciled realisation. The agent prepares realised candidates with source records, method version and exclusions open beside the number; the candidate stays proposed until the finance delegate decides.",
    "workblock.savings.hired-instead": "Today this job is done by a savings tracker or specialist product, planning lines, a reconciliation workbook and a finance review meeting.",
    "workblock.savings.job": "Move one savings claim from accepted opportunity to a validated result that can be reproduced from source records.",
    "workblock.savings.label": "Savings initiative tracking",
    "workblock.savings.outcome": "Savings remain traceable from claim to source record.",
    "workblock.savings.story.agree-method.completion": "An approved method version names the baseline, formula, exclusions, value type and the authority that accepted it.",
    "workblock.savings.story.agree-method.story": "When an initiative is accepted, the finance delegate needs the baseline, formula and evidence rule agreed before delivery starts, so that success is judged by a method both sides accepted rather than argued after the fact.",
    "workblock.savings.story.carry-award.completion": "The initiative holds the award evidence with its conditions, and a delivery plan accepted by the owners of the follow-on work.",
    "workblock.savings.story.carry-award.story": "When an award or contract change is approved, the category manager needs the expected value carried into a measurable initiative, so that the negotiated delta is not reported as a result before adoption and actuals confirm it.",
    "workblock.savings.story.qualify-opportunity.completion": "The opportunity holds an accepted, rejected, deferred or merged decision with the evidence and overlap relations behind it.",
    "workblock.savings.story.qualify-opportunity.story": "When a new value signal arrives from spend, sourcing or contract work, the value realisation lead needs it checked for duplicates and overlaps before it enters the pipeline, so that the portfolio does not promise the same value twice.",
    "workblock.savings.story.restate-result.completion": "A restatement or no-change decision preserves the prior result, the corrected evidence and the authority that decided.",
    "workblock.savings.story.restate-result.story": "When source data changes after a result was validated, the value realisation lead needs a restatement decision rather than a silent correction, so that the portfolio keeps its history and its credibility.",
    "workblock.savings.story.validate-result.completion": "A validation decision records the accepted, adjusted or rejected result with the source records, method version and reason attached.",
    "workblock.savings.story.validate-result.story": "When a measurement period closes, the finance delegate needs a calculated result they can challenge line by line, so that the accepted number survives audit without a workbook reconstruction.",
    "workblock.savings.tool": "Manage a savings initiative",
    "workblock.service-catalogue.agent-story": "When the agent recommends an eligible service or retires an unused version inside policy, the process owner needs the matching facts, active contract, affected requests and reversal path visible, so that routine catalogue upkeep can run autonomously while material offering changes remain supervised.",
    "workblock.service-catalogue.current-state": "The procurement front door today is spread across a portal, intranet service descriptions, intake forms and process maps, and the service desk translates each business need into the right offering by hand.",
    "workblock.service-catalogue.description": "Publish the available procurement services, eligibility, evidence, routes, owners and operating contracts.",
    "workblock.service-catalogue.descriptor": "Procurement service catalogue",
    "workblock.service-catalogue.future-state": "Procurement services publish as plain-language, versioned operating contracts bound to policy and entry points, so requesters and agents select a valid service and path first time, with service owners approving material changes to eligibility, inputs or expectations.",
    "workblock.service-catalogue.hired-instead": "Today this job is done by a procurement portal, service descriptions on the intranet, intake forms, process maps and the service desk that translates a business need into the right offering.",
    "workblock.service-catalogue.job": "Publish procurement services as versioned operating contracts that lead each eligible need to a clear start.",
    "workblock.service-catalogue.label": "Procurement service catalogue",
    "workblock.service-catalogue.outcome": "Requesters and agents select a valid service and path first time.",
    "workblock.service-catalogue.story.find-service.completion": "The requester reaches one eligible service or a named assisted route, with the original need retained and no duplicate request created.",
    "workblock.service-catalogue.story.find-service.story": "When a requester knows the outcome but not the procurement process, they need to find the service that fits their need in familiar language, so that they can start without choosing an internal workflow.",
    "workblock.service-catalogue.story.publish-contract.completion": "The approved offering version records its outcome, scope, inputs, authority, route, completion evidence and effective dates, and every consumer resolves that version.",
    "workblock.service-catalogue.story.publish-contract.story": "When a procurement service is introduced or changed, the process owner needs it published as a versioned operational contract, so that intake, routing and completion use one definition.",
    "workblock.service-catalogue.story.retire-service.completion": "The old version stops new starts at its effective time, every active request keeps a valid completion path, and successor or assisted routes are published and reconciled.",
    "workblock.service-catalogue.story.retire-service.story": "When an offering changes or retires, the process owner needs active requests protected and future starts redirected, so that catalogue governance does not orphan work already accepted.",
    "workblock.service-catalogue.story.service-friction.completion": "A service review opens the contributing requests and records a retained, revised, split or retired disposition with an accountable owner.",
    "workblock.service-catalogue.story.service-friction.story": "When requests abandon, reroute or repeatedly raise exceptions, the intake owner needs those outcomes linked to the service version and step that caused them, so that catalogue changes address observed friction.",
    "workblock.service-catalogue.story.start-ready.completion": "The selected version shows the facts still needed, applicable conditions and next owner, and the request can validate readiness against that same version.",
    "workblock.service-catalogue.story.start-ready.story": "When a service appears suitable, the requester needs its eligibility, required inputs, evidence and expected service conditions before starting, so that avoidable returns are prevented.",
    "workblock.service-catalogue.tool": "Find a procurement service",
    "workblock.sourcing-event.agent-story": "When the agent has assembled the award package, the award authority needs to see the source behind every included score, risk input and condition, so that approving does not mean rebuilding the pack.",
    "workblock.sourcing-event.current-state": "Today the suite runs the event while the decision around it is built in comparison workbooks, evaluator emails and a pack-building meeting, so the evidence behind the award scatters across systems before it is made.",
    "workblock.sourcing-event.description": "Build event packs, manage responses and structure evaluation around explicit criteria.",
    "workblock.sourcing-event.descriptor": "Sourcing event preparation and evaluation",
    "workblock.sourcing-event.future-state": "Event packs, eligibility checks, amendments and sealed responses are managed as one governed event record with equal treatment preserved, publication carries consequence-based authority from a named approver, and an immutable response set hands to evaluation.",
    "workblock.sourcing-event.hired-instead": "Today the suite runs the event, and the decision around it is done by comparison workbooks, evaluator emails and a pack-building meeting before the award.",
    "workblock.sourcing-event.job": "Run a sourcing event from approved need to authorised award when the decision evidence sits in more than one system.",
    "workblock.sourcing-event.label": "Sourcing event preparation and evaluation",
    "workblock.sourcing-event.outcome": "Sourcing decisions you can defend line by line: every score opens the response behind it.",
    "workblock.sourcing-event.story.amendment-impact.completion": "The amendment accounts for every affected record and event version, and superseded evaluation cannot be used.",
    "workblock.sourcing-event.story.amendment-impact.story": "When a requirement changes after publication, the sourcing lead needs to see every supplier, response and score the change touches, so that no supplier gains or loses information by accident.",
    "workblock.sourcing-event.story.compare-scenarios.completion": "The selected scenario can be reproduced, and the rejected alternatives stay inspectable with their constraints and assumptions.",
    "workblock.sourcing-event.story.compare-scenarios.story": "When cost, capacity, risk and service pull in different directions, the sourcing lead needs feasible award scenarios compared, so that the decision owner sees the trade-offs without rebuilding the model.",
    "workblock.sourcing-event.story.decide-award.completion": "Approval, rejection or return is recorded with its reason, and proposal and commitment never blur.",
    "workblock.sourcing-event.story.decide-award.story": "When an award is proposed, the award authority needs the recommendation, dissent, conditions and next action in one package, so that the decision is made without another reconstruction meeting.",
    "workblock.sourcing-event.story.one-basis.completion": "Every normalised figure reproduces from the original response and a dated rule, with the original preserved beside it.",
    "workblock.sourcing-event.story.one-basis.story": "When responses close with mixed currencies, units and qualifications, the sourcing lead needs the offers compared on one declared basis, so that evaluators judge the same commercial facts.",
    "workblock.sourcing-event.story.score-with-evidence.completion": "Each submitted score carries its evaluator, criterion, comment and the evidence behind it.",
    "workblock.sourcing-event.story.score-with-evidence.story": "When evaluation begins, each evaluator needs the response and approved evidence for their assigned criteria, so that scoring is informed, independent and reviewable.",
    "workblock.sourcing-event.story.shape-event.completion": "Required fields, approvals and unresolved choices are visible before anything is published to suppliers.",
    "workblock.sourcing-event.story.shape-event.story": "When a sourceable need is accepted, the sourcing lead needs it turned into a complete, reviewable event, so that suppliers receive one coherent request under the right rules.",
    "workblock.sourcing-event.tool": "Run a sourcing event",
    "workblock.sourcing-pipeline.agent-story": "When the agent promotes an in-envelope opportunity or creates a reversible sourcing handoff, the sourcing lead needs the signal lineage, market evidence, capacity decision and receiving receipt visible, so that routine pipeline formation can run autonomously while route and commitment boundaries remain supervised.",
    "workblock.sourcing-pipeline.current-state": "The sourcing pipeline today is assembled by hand from category plans, contract calendars, intake queues, opportunity spreadsheets and capacity meetings, so events launch as isolated requests rather than from a forward view of the market.",
    "workblock.sourcing-pipeline.description": "Convert qualified opportunities into sourcing projects and supplier longlists linked to current eligibility and market records.",
    "workblock.sourcing-pipeline.descriptor": "Sourcing pipeline discovery",
    "workblock.sourcing-pipeline.future-state": "A forward-looking, capacity-aware pipeline holds qualified interventions with a justified route, timing and viable-market candidates that open into current source records, and a named owner accepts or delegates each consequential destination start.",
    "workblock.sourcing-pipeline.hired-instead": "Today this job is done through category plans, contract calendars, intake queues, opportunity spreadsheets and sourcing-capacity meetings that assemble the pipeline by hand.",
    "workblock.sourcing-pipeline.job": "Turn strategy, demand and contract signals into an owned, capacity-aware sourcing pipeline with a justified route.",
    "workblock.sourcing-pipeline.label": "Sourcing pipeline discovery",
    "workblock.sourcing-pipeline.outcome": "The right events launch with clear scope, strategy, eligible suppliers and dependencies.",
    "workblock.sourcing-pipeline.story.accepted-handoff.completion": "The receiving business module accepts an idempotent handoff, returns its owner and record reference, and any rejected or partial handoff remains visible in the pipeline.",
    "workblock.sourcing-pipeline.story.accepted-handoff.story": "When a sourcing proposal is accepted, the sourcing lead needs scope, suppliers, policy, evidence and timing transferred into the selected business module, so that execution does not recreate the opportunity.",
    "workblock.sourcing-pipeline.story.buy-timing.completion": "The mandate proposal records its volume band, buy window, price ceiling and escalation bounds, links the price assessments and coverage positions behind it with their source dates, and the named authority accepts, revises or declines it on the record.",
    "workblock.sourcing-pipeline.story.buy-timing.story": "When a price outlook, coverage gap or strategy window opens a candidate buy window, the sourcing lead needs a bounded buy-timing mandate drafted with a volume band, time window and price ceiling, so that forward cover changes by recorded decision rather than by reaction to a single price move.",
    "workblock.sourcing-pipeline.story.capacity-priority.completion": "The committed pipeline version records capacity assumptions, ranked and deferred cases, decision owners and the condition that reopens each deferred item.",
    "workblock.sourcing-pipeline.story.capacity-priority.story": "When pipeline demand exceeds sourcing capacity, the sourcing lead needs opportunities prioritised against deadlines, dependencies, value, risk and effort, so that urgent-looking work does not displace more consequential commitments without a decision.",
    "workblock.sourcing-pipeline.story.discover-intervention.completion": "The candidate links its triggering records, scope, timing, value hypothesis, dependencies and freshness, and is accepted, dismissed or parked with a reopening condition.",
    "workblock.sourcing-pipeline.story.discover-intervention.story": "When strategy, demand, contract or supplier evidence indicates a sourcing intervention, the sourcing lead needs one candidate case assembled, so that viable work is not delayed until the next manual pipeline review.",
    "workblock.sourcing-pipeline.story.market-readiness.completion": "The case records eligible candidate coverage, source dates, known constraints and evidence gaps, and abstains where market readiness cannot be supported.",
    "workblock.sourcing-pipeline.story.market-readiness.story": "When an opportunity is considered, the sourcing lead needs available market candidates and evidence quality assessed, so that a route is not chosen on an assumed competitive market.",
    "workblock.sourcing-pipeline.story.route-selection.completion": "A route proposal records the controlling criteria, alternatives and authority ceiling, and the accepted route has an accountable owner and completion contract.",
    "workblock.sourcing-pipeline.story.route-selection.story": "When several execution paths could address the need, the sourcing lead needs event, negotiation, tactical and no-source options compared, so that ceremony and effort match the outcome and consequence.",
    "workblock.sourcing-pipeline.tool": "Shape a sourcing project",
    "workblock.spend-foundation.agent-story": "When the agent publishes a reconciled spend batch inside its active grant, the data steward needs the applied source, mapping and classifier versions, critic results and rollback point visible, so that routine publication can run without per-item review while supervision stays effective.",
    "workblock.spend-foundation.current-state": "Today the spend baseline is assembled across a data warehouse, ETL mappings, a steward queue and a reconciliation workbook, and analysts rebuild lineage by hand whenever a total, a duplicate or a classification is challenged.",
    "workblock.spend-foundation.description": "Ingest, reconcile and classify line-level spend with source lineage, identity resolution and last-good source health.",
    "workblock.spend-foundation.descriptor": "Spend data ingestion, classification and reconciliation",
    "workblock.spend-foundation.future-state": "Reconciled, classified spend records publish as a last-good baseline that every domain can explain and reuse, with each field drilling to its source record and data stewards resolving only the identity and classification cases the pipeline abstains on.",
    "workblock.spend-foundation.hired-instead": "Today this job is done by the data warehouse and spend-analysis product, with ETL mappings, a steward queue and a reconciliation workbook joining the gaps.",
    "workblock.spend-foundation.job": "Publish reconciled, classified spend records that downstream decisions can use without losing source truth.",
    "workblock.spend-foundation.label": "Spend data ingestion, classification and reconciliation",
    "workblock.spend-foundation.outcome": "A trusted spend baseline that every domain can explain and reuse.",
    "workblock.spend-foundation.story.addressable-view.completion": "The published view reconciles to declared source totals and every permitted aggregate opens the contributing records, exclusions, currency treatment and freshness.",
    "workblock.spend-foundation.story.addressable-view.story": "When a spend period closes or a source refresh lands, the procurement analyst needs an addressable view by category, party and business unit, so that every aggregate used for planning opens into the records behind it.",
    "workblock.spend-foundation.story.ambiguous-record.completion": "The line is mapped with a recorded rule and rationale or quarantined as unresolved, while the original source value and prior decisions remain intact.",
    "workblock.spend-foundation.story.ambiguous-record.story": "When a source line has an uncertain party or category, the data steward needs the candidate matches and original value preserved, so that ambiguity is resolved without turning an inference into a source fact.",
    "workblock.spend-foundation.story.publication-control.completion": "The batch passes its declared reconciliation and lineage gates, records accepted and rejected counts, and publishes exactly once under a versioned contract.",
    "workblock.spend-foundation.story.publication-control.story": "When a candidate spend batch is ready to publish, the data steward needs totals, duplicates, reversals, exclusions and lineage checked together, so that downstream Workblocks receive a complete and reproducible record set.",
    "workblock.spend-foundation.story.stale-consumer.completion": "The last-good projection remains readable with freshness and compatibility state, unsafe publication stops, and affected consumers receive a traceable change or degradation event.",
    "workblock.spend-foundation.story.stale-consumer.story": "When a source refresh fails or a consumer falls behind the registry version, the procurement analyst needs last-good spend to remain visible with its real age and caveats, so that a missing update is not mistaken for zero spend or current evidence.",
    "workblock.spend-foundation.tool": "Refresh or inspect spend data",
    "workblock.supplier-master.agent-story": "When the agent renews routine qualification or commits an in-envelope master correction, the supplier master steward needs evidence versions, segregation checks, external receipts and sampling state visible, so that safe changes can run autonomously while identity, bank and material eligibility risks remain supervised.",
    "workblock.supplier-master.current-state": "After onboarding, supplier data drifts across master workflows, qualification questionnaires, document repositories and certification checks, and the steward reviewing a change request reassembles the evidence to judge whether identity, eligibility or a sensitive field is truly affected.",
    "workblock.supplier-master.description": "Resolve supplier identity, govern low-risk master attributes and maintain qualification and segment evidence.",
    "workblock.supplier-master.descriptor": "Supplier master data and qualification",
    "workblock.supplier-master.future-state": "Downstream work runs on one current, verified supplier identity and eligibility state, with effective-dated qualifications and certificate expiry watched continuously; the agent renews routine qualifications and commits in-envelope non-sensitive changes, while bank, payment and identity changes always pass independent verification and a named steward's decision.",
    "workblock.supplier-master.hired-instead": "Today this job is done through ERP supplier-master workflows, qualification questionnaires, document repositories, sanctions and certification checks, and steward review of change requests.",
    "workblock.supplier-master.job": "Maintain supplier eligibility and master data for a declared business scope using current evidence and fraud-resistant change controls.",
    "workblock.supplier-master.label": "Supplier master data and qualification",
    "workblock.supplier-master.outcome": "Downstream Workblocks use one current, verified supplier identity and eligibility state.",
    "workblock.supplier-master.story.carbon-compliance.completion": "The exposure assessment names the goods scope, emissions values, verification status, certificate price basis and evidence expiry, and the proposed disposition is approved, revised or escalated before the declaration deadline.",
    "workblock.supplier-master.story.carbon-compliance.story": "When a supplier falls in CBAM scope or its emissions evidence approaches expiry, the supplier master steward needs installation-level declarations collected and verified for the declaration period, so that cost exposure and eligibility rest on current verified values rather than marked-up defaults.",
    "workblock.supplier-master.story.expiry-monitoring.completion": "Renewal is completed, conditional use is authorised or eligibility is suspended before the effective deadline, with every affected downstream record notified.",
    "workblock.supplier-master.story.expiry-monitoring.story": "When certification or qualification evidence approaches expiry, the accountable risk owner needs affected uses identified before eligibility lapses, so that buying does not continue on stale evidence.",
    "workblock.supplier-master.story.master-change.completion": "The current record version, authority and required verifications pass, the change commits exactly once, and sensitive changes carry an independent decision and authoritative receipt.",
    "workblock.supplier-master.story.master-change.story": "When identity, tax, address or payment data changes, the supplier master steward needs independent evidence and segregation controls applied, so that speed does not create a fraud-prone shortcut.",
    "workblock.supplier-master.story.publish-eligibility.completion": "A versioned eligibility event names supplier, scope, conditions, effective time and source decision, and each in-scope consumer acknowledges or reports incompatible state.",
    "workblock.supplier-master.story.publish-eligibility.story": "When qualification or master state changes, the onboarding coordinator needs precise conditions delivered to buying and ordering, so that downstream routes apply the current scope without copying the whole assessment.",
    "workblock.supplier-master.story.quality-prediction.completion": "A prediction names its supplier, material scope, observation window, top drivers and calibration state, and every proposed qualification adjustment stays a proposal until the steward decides it.",
    "workblock.supplier-master.story.quality-prediction.story": "When new quality observations arrive or a qualification review window opens, the supplier master steward needs predicted quality risk for each supplier and material scope, so that eligibility decisions use certified test results and observed processing outcomes instead of the last audit alone.",
    "workblock.supplier-master.story.scope-qualification.completion": "The qualification record names its scope, evidence, conditions, effective dates and decision authority, and publishes an eligible, conditional or ineligible state.",
    "workblock.supplier-master.story.scope-qualification.story": "When a supplier is considered for use, the supplier master steward needs qualification assessed for the exact category, legal entity, geography and purpose, so that approval in one scope is not treated as universal eligibility.",
    "workblock.supplier-master.tool": "Resolve or qualify a supplier",
    "workblock.supplier-remediation.agent-story": "When the agent chases evidence, verifies routine milestones or coordinates pre-authorised reversible tasks, the accountable risk owner needs plan versions, supplier responses, critic results and dependency state visible, so that routine remediation can progress autonomously while sanctions, acceptance and exit commitments remain supervised.",
    "workblock.supplier-remediation.current-state": "Corrective actions live in plans, supplier email, task trackers, spreadsheets and governance calls, with offboarding checklists held separately by procurement, operations and technology, so no single place shows whether an issue is actually fixed or an exit is actually complete.",
    "workblock.supplier-remediation.description": "Coordinate mitigation, certificate renewal, offboarding, transition and closure while preserving decision authority.",
    "workblock.supplier-remediation.descriptor": "Supplier remediation and exit coordination",
    "workblock.supplier-remediation.future-state": "Every supplier issue reaches verified remediation or a controlled exit, with evidence that proves outcome rather than activity and every contract, order, access and continuity dependency reconciled; the agent chases evidence and coordinates pre-authorised reversible steps, while waivers, sanctions and exit commitments stay with the accountable risk owner.",
    "workblock.supplier-remediation.hired-instead": "Today this job is done through corrective-action plans, supplier email, GRC tasks, spreadsheets, governance calls and separate offboarding checklists across procurement, operations and technology.",
    "workblock.supplier-remediation.job": "Complete verified supplier remediation or a controlled exit across every affected commitment, access and continuity dependency.",
    "workblock.supplier-remediation.label": "Supplier remediation and exit coordination",
    "workblock.supplier-remediation.outcome": "Supplier issues reach verified remediation or a controlled exit.",
    "workblock.supplier-remediation.story.controlled-exit.completion": "Every dependency has an authorised disposition and receipt, uncertain or partial effects remain open, and the final supplier state reconciles across owner systems without deleting history.",
    "workblock.supplier-remediation.story.controlled-exit.story": "When remediation fails or exit is chosen, the accountable risk owner needs orders, contracts, data, access, inventory and continuity dependencies coordinated, so that ending the relationship does not create an unmanaged exposure.",
    "workblock.supplier-remediation.story.coordinated-progress.completion": "Each action shows last request, response, evidence, owner, age and next step, and duplicate reminders or conflicting instructions are prevented.",
    "workblock.supplier-remediation.story.coordinated-progress.story": "When remediation is under way, the supplier contact needs one current request and status path, so that evidence is not repeatedly chased through disconnected teams.",
    "workblock.supplier-remediation.story.corrective-plan.completion": "The committed plan names each control gap, action, owner, due date, acceptance evidence, consequence and decision authority, with dependencies linked.",
    "workblock.supplier-remediation.story.corrective-plan.story": "When a risk treatment is accepted, the accountable risk owner needs measurable corrective actions, evidence and deadlines assigned, so that remediation is more than a narrative promise.",
    "workblock.supplier-remediation.story.verify-recovery.completion": "Independent evidence passes the acceptance method across the required period, or the action reopens with the failed condition and escalated consequence.",
    "workblock.supplier-remediation.story.verify-recovery.story": "When a supplier reports completion, the programme owner needs outcomes verified against the original gap and sustained period, so that cosmetic closure cannot reset eligibility.",
    "workblock.supplier-remediation.tool": "Manage supplier remediation or exit",
    "workblock.supplier-segmentation.agent-story": "When the agent applies a routine re-segmentation inside an approved rule envelope, the governance owner needs changed evidence, rule version, affected treatment and sampled outcomes visible, so that stable assignments can update autonomously while material or disputed treatment changes remain supervised.",
    "workblock.supplier-segmentation.current-state": "Segments today live in workbooks, supplier-master attributes and risk lists, held together by category judgement and governance meetings that periodically republish tiers to other systems. The evidence behind an assignment scatters as soon as it is agreed.",
    "workblock.supplier-segmentation.description": "Maintain evidence-based segment assignments and provision the cadence, roles and controls each relationship requires.",
    "workblock.supplier-segmentation.descriptor": "Supplier segmentation and governance",
    "workblock.supplier-segmentation.future-state": "Every supplier carries a transparent segment assignment with its evidence attached: the agent recalculates from current value, criticality, risk and performance evidence and commits routine changes inside policy. Material or disputed posture changes go to the named governance owner, and the effective assignment drives cadence, scorecards and authority downstream.",
    "workblock.supplier-segmentation.hired-instead": "Today this job is done through segmentation workbooks, supplier-master attributes, category judgement, risk lists and governance meetings that periodically republish tiers to other systems.",
    "workblock.supplier-segmentation.job": "Maintain an explainable supplier segment and criticality assignment that governs the right downstream relationship treatment.",
    "workblock.supplier-segmentation.label": "Supplier segmentation and governance",
    "workblock.supplier-segmentation.outcome": "Supplier attention and governance remain proportionate and current.",
    "workblock.supplier-segmentation.story.change-signal.completion": "A change case links the new evidence to current thresholds and affected relationships, distinguishes data-quality gaps and records a retain, recalculate or review disposition.",
    "workblock.supplier-segmentation.story.change-signal.story": "When spend, dependency, risk, performance or innovation evidence changes, the metric owner needs the assignments it may affect identified, so that periodic refresh does not hide material drift.",
    "workblock.supplier-segmentation.story.current-segment.completion": "The effective assignment records scope, method, evidence, decision, freshness and treatment, and every aggregate opens the suppliers behind it.",
    "workblock.supplier-segmentation.story.current-segment.story": "When a supplier relationship is planned or reviewed, the relationship manager needs its current segment and criticality with supporting evidence, so that governance effort matches the role the supplier actually plays.",
    "workblock.supplier-segmentation.story.material-assignment.completion": "The named authority accepts, amends or rejects the proposed assignment, with counter-evidence, conditions and effective date preserved.",
    "workblock.supplier-segmentation.story.material-assignment.story": "When re-segmentation changes criticality, governance investment or commercial treatment materially, the governance owner needs the trade-offs and affected owners assembled, so that a model score cannot commit the posture alone.",
    "workblock.supplier-segmentation.story.propagate-treatment.completion": "Versioned events reach every declared consumer, incompatible or failed updates remain visible, and prior treatments are superseded without rewriting their history.",
    "workblock.supplier-segmentation.story.propagate-treatment.story": "When an assignment becomes effective, the relationship manager needs its treatment propagated to performance, risk, innovation and value work, so that downstream governance uses one current posture.",
    "workblock.supplier-segmentation.story.routine-resegment.completion": "The new assignment commits under the active grant, records prior and current versions and passes its sampling and downstream-compatibility checks.",
    "workblock.supplier-segmentation.story.routine-resegment.story": "When evidence crosses an approved deterministic boundary without a material consequence, the governance owner needs the effective assignment updated under policy, so that routine maintenance does not wait for a committee.",
    "workblock.supplier-segmentation.tool": "Assess supplier segmentation",
    "workblock.tactical-sourcing.agent-story": "When the agent runs an eligible quote, bounded negotiation or routine award inside its active grant, the sourcing lead needs cohort fairness, mandate use, sampled outcomes and kill-switch state visible, so that safe autonomy is the operating model and people supervise exceptions, policy and performance.",
    "workblock.tactical-sourcing.current-state": "Routine quotes today run through buyer-held templates, approved-supplier lists, email exchanges and comparison sheets under delegated approval rules, with higher-risk cases passed to a sourcing lead who rebuilds the context.",
    "workblock.tactical-sourcing.description": "Run proven low-complexity RFQs and bounded negotiations end to end inside category, supplier, value and policy limits.",
    "workblock.tactical-sourcing.descriptor": "Policy-bounded tactical sourcing execution",
    "workblock.tactical-sourcing.future-state": "Eligible low-complexity sourcing runs from qualified demand to reconciled award or order inside a declared authority envelope, with supervisors inspecting sampled straight-through cases and only true exceptions reaching a specialist for judgement or new authority.",
    "workblock.tactical-sourcing.hired-instead": "Today this job is done by buyers using quote templates, approved-supplier lists, email exchanges, comparison sheets and delegated approval rules, with higher-risk cases passed to a sourcing lead.",
    "workblock.tactical-sourcing.job": "Complete routine tactical sourcing inside a declared authority envelope and escalate only cases that need specialist judgement or new authority.",
    "workblock.tactical-sourcing.label": "Policy-bounded tactical sourcing execution",
    "workblock.tactical-sourcing.outcome": "Routine sourcing completes within policy bounds, with sampled supervision and specialist attention for true exceptions.",
    "workblock.tactical-sourcing.story.bounded-exchange.completion": "The complete communication trail records terms, mandate consumption and expiry, and any out-of-bounds position stops before transmission and opens an owned exception.",
    "workblock.tactical-sourcing.story.bounded-exchange.story": "When quotes or counter-offers are exchanged, the negotiation lead needs every message and concession kept inside the approved mandate, so that routine negotiation can progress without an unseen commitment.",
    "workblock.tactical-sourcing.story.eligibility-screen.completion": "The case is accepted under a named authority envelope or routed to a specialist with the failed eligibility conditions and complete source evidence.",
    "workblock.tactical-sourcing.story.eligibility-screen.story": "When routine demand enters sourcing, the sourcing lead needs suitability tested against value, category, risk, complexity, market and policy limits, so that tactical autonomy does not absorb work outside its design.",
    "workblock.tactical-sourcing.story.partial-recovery.completion": "The case confirms the observed external state, blocks unsafe duplicate action and ends in a reconciled retry, compensation, specialist handoff or closed exception.",
    "workblock.tactical-sourcing.story.partial-recovery.story": "When an invitation, exchange or award has an uncertain or partial external effect, the sourcing lead needs reconciliation before retry, so that recovery cannot duplicate a supplier communication or commitment.",
    "workblock.tactical-sourcing.story.routine-award.completion": "The award is committed exactly once under the active policy grant, returns an authoritative receipt and remains visibly distinct from proposals, rejected options and later reversals.",
    "workblock.tactical-sourcing.story.routine-award.story": "When evaluation produces an award inside delegated limits, the award authority needs deterministic criteria, evidence and authority revalidated at commit time, so that an eligible routine outcome can complete without per-item approval.",
    "workblock.tactical-sourcing.story.spot-buy-conversion.completion": "The conversion proposal names the target channel, supplier and volume basis, links the repeat cases and tail evidence behind it, and the named authority accepts, revises or declines it on the record.",
    "workblock.tactical-sourcing.story.spot-buy-conversion.story": "When the same need is spot-bought repeatedly, the sourcing lead needs the repeat history and the conversion economics assembled into a channel proposal, so that repetition becomes a governed channel by recorded decision.",
    "workblock.tactical-sourcing.story.supplier-cohort.completion": "The cohort records eligibility, inclusion and exclusion rationale, required coverage and source freshness, and unresolved identity or conflict issues block invitation.",
    "workblock.tactical-sourcing.story.supplier-cohort.story": "When an eligible case proceeds, the evaluator needs a fair supplier cohort selected from current qualification and conflict evidence, so that speed does not narrow competition without a reason.",
    "workblock.tactical-sourcing.tool": "Run a bounded tactical sourcing case",
    "workblock.value-baseline.agent-story": "When the agent calculates a routine baseline inside an approved method envelope, the finance delegate needs source snapshots, assumptions, sensitivity, duplicate checks and method version visible, so that analysis can run autonomously while the measurement contract remains an explicit finance decision.",
    "workblock.value-baseline.current-state": "Baselines today are agreed through opportunity registers, business-case templates, spend and contract extracts and finance models, then settled in review meetings. The counterfactual, assumptions and exclusions live in whichever file was current, so later realisation arguments reopen the method.",
    "workblock.value-baseline.description": "Deduplicate value signals, quantify ranges and commit a versioned baseline and measurement method.",
    "workblock.value-baseline.descriptor": "Value opportunity and baseline definition",
    "workblock.value-baseline.future-state": "Every opportunity starts from an effective-dated, versioned baseline with its scope, counterfactual, assumptions and exclusions stated and its sources snapshotted. The agent calculates within an approved method envelope, and the measurement contract remains an explicit finance decision that downstream initiatives cannot silently reinterpret.",
    "workblock.value-baseline.hired-instead": "Today this job is done through opportunity registers, business-case templates, spend and contract extracts, finance models and review meetings that agree which baseline will count.",
    "workblock.value-baseline.job": "Commit a reproducible value baseline and target whose scope, counterfactual, assumptions and exclusions govern later realisation.",
    "workblock.value-baseline.label": "Value opportunity and baseline definition",
    "workblock.value-baseline.outcome": "Every initiative starts from a defensible counterfactual and source evidence.",
    "workblock.value-baseline.story.assumption-sensitivity.completion": "Material assumptions show their source, range and effect, excluded value is explicit, and unresolved uncertainty remains outside the committed amount.",
    "workblock.value-baseline.story.assumption-sensitivity.story": "When the result depends on uncertain volume, mix, market, currency or timing assumptions, the value lead needs sensitivity and exclusions visible, so that one point estimate is not treated as a commitment.",
    "workblock.value-baseline.story.calculate-baseline.completion": "The result reconciles to pinned source snapshots, records formula and method version and reproduces exactly from the same inputs.",
    "workblock.value-baseline.story.calculate-baseline.story": "When source evidence is ready, the finance delegate needs the baseline and target calculated under an approved method, so that arithmetic and transformations can be reproduced independently.",
    "workblock.value-baseline.story.commit-measurement.completion": "The authorised contract pins scope, baseline, target, method, evidence and effective version, and future change creates a superseding decision with impact recorded.",
    "workblock.value-baseline.story.commit-measurement.story": "When the baseline is agreed, the finance delegate needs one measurement contract committed for delivery and attribution, so that later Workblocks cannot silently change the method.",
    "workblock.value-baseline.story.counterfactual-scope.completion": "The candidate measurement contract records in-scope and excluded items, baseline and target periods, unit, currency and the no-action comparison.",
    "workblock.value-baseline.story.counterfactual-scope.story": "When an opportunity is accepted, the category manager needs entity, population, period, value type and counterfactual defined, so that later performance is compared to the decision actually made.",
    "workblock.value-baseline.story.qualify-opportunity.completion": "The opportunity is accepted, merged, linked, dismissed or parked with a reason, and any overlap retains the contributing records and ownership.",
    "workblock.value-baseline.story.qualify-opportunity.story": "When a value opportunity is raised, the value lead needs its scope and relationship to existing initiatives checked, so that the portfolio does not count the same potential benefit twice.",
    "workblock.value-baseline.tool": "Assess an opportunity and baseline",
    "workblock.value-portfolio.agent-story": "When the agent publishes a routine forecast refresh or creates a pre-authorised internal intervention, the value lead needs source freshness, variance bridge, method version, authority and outcome receipt visible, so that portfolio upkeep can run autonomously while targets, budgets and priorities remain supervised.",
    "workblock.value-portfolio.current-state": "The portfolio view today is stitched from savings and initiative trackers, planning workbooks, finance forecasts and variance decks, with recovery actions assigned in portfolio meetings. Projected, validated and committed value blur, and the picture goes stale between cycles.",
    "workblock.value-portfolio.description": "Maintain a calibrated portfolio of targets, forecast versions, validated outcomes, leakage, capacity and non-financial value.",
    "workblock.value-portfolio.descriptor": "Value portfolio forecasting",
    "workblock.value-portfolio.future-state": "Leadership sees a current, drillable, versioned forecast that rolls baselines, initiative progress, realised attribution and leakage together with scenarios and confidence intervals. The agent detects material variance and drafts interventions, while targets, budgets and priorities stay with named owners and forecast is never presented as validated realisation.",
    "workblock.value-portfolio.hired-instead": "Today this job is done through savings and initiative trackers, planning workbooks, finance forecasts, variance decks and portfolio meetings that assign recovery actions.",
    "workblock.value-portfolio.job": "Maintain a current, explainable value forecast and route interventions without confusing projected, validated and committed value.",
    "workblock.value-portfolio.label": "Value portfolio forecasting",
    "workblock.value-portfolio.outcome": "Leadership sees a current, drillable value picture without confusing forecasts with commitments.",
    "workblock.value-portfolio.story.current-forecast.completion": "A new forecast version reconciles every included initiative and actual, keeps missing inputs explicit and preserves the prior last-good forecast with its age.",
    "workblock.value-portfolio.story.current-forecast.story": "When initiative, actual or leakage evidence changes, the value lead needs the portfolio forecast and realisation schedule refreshed, so that the operating view does not wait for the next planning cycle.",
    "workblock.value-portfolio.story.margin-tradeoff.completion": "Each margin scenario records its cost basis, pass-through terms, price-fixing points and timing lag, ranked interventions name owner, expected effect and required authority, and every projected margin move drills through to the forecast, award and realisation records behind it.",
    "workblock.value-portfolio.story.margin-tradeoff.story": "When an input cost shock, forecast refresh or award outcome moves a margin position beyond tolerance, the value lead needs cost, price and service trade-offs compared across the portfolio, so that interventions are chosen on total margin effect rather than purchase price alone.",
    "workblock.value-portfolio.story.movement-bridge.completion": "The variance bridge accounts for each material change by source, initiative, timing, method or decision and reconciles exactly to the new version.",
    "workblock.value-portfolio.story.movement-bridge.story": "When forecast or target position changes, the finance delegate needs movement from the prior version explained, so that updated numbers do not erase the assumptions and events that moved them.",
    "workblock.value-portfolio.story.portfolio-risk.completion": "The risk case opens contributing records, quantifies the exposed range and records an accepted intervention, watch condition or authorised portfolio decision.",
    "workblock.value-portfolio.story.portfolio-risk.story": "When value, timing, dependency or capacity risk threatens the plan, the budget owner needs the affected initiatives and actionable choices identified, so that intervention focuses on owned causes rather than a red metric.",
    "workblock.value-portfolio.story.scenario-range.completion": "Each scenario records horizon, methods, assumptions, dependencies, confidence treatment and included records, and none changes the committed target without authority.",
    "workblock.value-portfolio.story.scenario-range.story": "When portfolio uncertainty matters, the value lead needs base, upside, downside and policy-approved scenarios compared, so that one forecast is not mistaken for a guaranteed outcome.",
    "workblock.value-portfolio.story.track-intervention.completion": "The receiving owner acknowledges the handoff, state and completion evidence return to the portfolio, and the next forecast incorporates observed outcome without rewriting earlier projections.",
    "workblock.value-portfolio.story.track-intervention.story": "When an intervention is approved or pre-authorised, the category manager needs it routed to the owning business module and tracked to outcome, so that the forecast does not claim action from an unaccepted task.",
    "workblock.value-portfolio.tool": "Inspect or forecast the value portfolio"
  },
  "defaultMode": "site",
  "defaultPartnerCapabilityMappingId": "accenture-s2p-master",
  "designNarrative": {
    "anchors": [
      {
        "id": "intent",
        "labelKey": "page.design.section.intent"
      },
      {
        "id": "principles",
        "labelKey": "page.design.section.principles"
      },
      {
        "id": "groundworks-choices",
        "labelKey": "page.design.section.groundworks-choices"
      },
      {
        "id": "specimens",
        "labelKey": "page.design.section.specimens"
      },
      {
        "id": "provenance",
        "labelKey": "page.design.section.provenance"
      },
      {
        "id": "accessibility",
        "labelKey": "page.design.section.accessibility"
      },
      {
        "id": "responsive-behaviour",
        "labelKey": "page.design.section.responsive-behaviour"
      },
      {
        "id": "present-scope",
        "labelKey": "page.design.section.present-scope"
      },
      {
        "id": "continue",
        "labelKey": "page.design.section.continue"
      }
    ],
    "componentCatalogue": {
      "componentIds": [
        "glyph",
        "groundworks-mark",
        "lockup",
        "app-shell",
        "section-navigation",
        "page-header",
        "section-heading",
        "place-line",
        "trail",
        "door",
        "arrow-link-label",
        "place-trail",
        "status-mark",
        "status-legend",
        "empty-state",
        "absence-block",
        "loading-state",
        "fact-band",
        "fact-row",
        "figure",
        "before-after",
        "statement-section",
        "card",
        "context-record-preview",
        "catalogue-facet",
        "capability-mapping",
        "capability-overview",
        "module-agent-supervision-frame",
        "work-moment-illustration",
        "home-overview",
        "office-product-cards"
      ]
    },
    "principles": [
      {
        "bodyKey": "page.design.principle.intent.body",
        "choiceBodyKey": "page.design.choice.intent.body",
        "choiceTitleKey": "page.design.choice.intent.title",
        "glyphMeaning": "class.job",
        "id": "intent",
        "titleKey": "page.design.principle.intent.title"
      },
      {
        "bodyKey": "page.design.principle.complexity.body",
        "choiceBodyKey": "page.design.choice.complexity.body",
        "choiceTitleKey": "page.design.choice.complexity.title",
        "glyphMeaning": "object.workblock",
        "id": "complexity",
        "titleKey": "page.design.principle.complexity.title"
      },
      {
        "bodyKey": "page.design.principle.content.body",
        "choiceBodyKey": "page.design.choice.content.body",
        "choiceTitleKey": "page.design.choice.content.title",
        "glyphMeaning": "capability.audit",
        "id": "content",
        "titleKey": "page.design.principle.content.title"
      },
      {
        "bodyKey": "page.design.principle.truth.body",
        "choiceBodyKey": "page.design.choice.truth.body",
        "choiceTitleKey": "page.design.choice.truth.title",
        "glyphMeaning": "class.record",
        "id": "truth",
        "titleKey": "page.design.principle.truth.title"
      },
      {
        "bodyKey": "page.design.principle.agency.body",
        "choiceBodyKey": "page.design.choice.agency.body",
        "choiceTitleKey": "page.design.choice.agency.title",
        "glyphMeaning": "capability.controls",
        "id": "agency",
        "titleKey": "page.design.principle.agency.title"
      },
      {
        "bodyKey": "page.design.principle.structure.body",
        "choiceBodyKey": "page.design.choice.structure.body",
        "choiceTitleKey": "page.design.choice.structure.title",
        "glyphMeaning": "utility.grid",
        "id": "structure",
        "titleKey": "page.design.principle.structure.title"
      },
      {
        "bodyKey": "page.design.principle.conditions.body",
        "choiceBodyKey": "page.design.choice.conditions.body",
        "choiceTitleKey": "page.design.choice.conditions.title",
        "glyphMeaning": "capability.integration",
        "id": "conditions",
        "titleKey": "page.design.principle.conditions.title"
      },
      {
        "bodyKey": "page.design.principle.validation.body",
        "choiceBodyKey": "page.design.choice.validation.body",
        "choiceTitleKey": "page.design.choice.validation.title",
        "glyphMeaning": "class.done-when",
        "id": "validation",
        "titleKey": "page.design.principle.validation.title"
      },
      {
        "bodyKey": "page.design.principle.access.body",
        "choiceBodyKey": "page.design.choice.access.body",
        "choiceTitleKey": "page.design.choice.access.title",
        "glyphMeaning": "capability.messaging",
        "id": "access",
        "titleKey": "page.design.principle.access.title"
      }
    ],
    "registryVersion": "1.2.0",
    "schemaVersion": "1.0.0"
  },
  "differentiators": {
    "audienceId": "site",
    "bases": [
      {
        "definition": "A versioned unit of execution combines a typed task graph, agents, state ownership, authority, telemetry and an outcome contract so it can change independently without becoming an ungoverned script.",
        "id": "governed-workblock",
        "label": "Version-controlled process"
      },
      {
        "definition": "Long-running work survives waits, retries and child fan-out through explicit continuation points, idempotent side effects and reconciled run state.",
        "id": "durable-execution",
        "label": "Process continuity"
      },
      {
        "definition": "Canonical records, completed-run facts, files, retrieval indexes and learning examples use distinct owner surfaces while keeping provenance links intact across domains.",
        "id": "shared-evidence-plane",
        "label": "Unified audit trail"
      },
      {
        "definition": "Routine, reversible and well-evidenced actions can execute without per-item review; deterministic guards, critic checks, sampling, escalation, kill switches and rollback contain consequence.",
        "id": "policy-bounded-autonomy",
        "label": "Policy-based auto-approval"
      },
      {
        "definition": "Document and workbook work can be reviewed in governed browser surfaces while preserving source references and approved changes in native file formats.",
        "id": "native-artifact-roundtrip",
        "label": "Native Word/Excel editing"
      },
      {
        "definition": "Failed or empty refreshes preserve the last successfully reconciled record and expose freshness, so missing input is never presented as a valid empty state.",
        "id": "last-good-continuity",
        "label": "Data freshness & fallback"
      },
      {
        "definition": "Audience and role scope are applied before records, search terms, aggregates and counts are projected, so inaccessible content cannot be inferred from a served artifact.",
        "id": "permissioned-projection",
        "label": "Role-based access control (RBAC)"
      },
      {
        "definition": "Facts, transformations, deterministic rules, model judgements, proposals, authority events and committed outcomes remain typed, versioned and separately inspectable.",
        "id": "inspectable-decisioning",
        "label": "Audit trail & traceability"
      }
    ],
    "claims": [
      {
        "baseId": "durable-execution",
        "id": "diff-category-opportunity-radar-a-durable-opportunity-record-carries-its-evidence-expiry-and-disposition",
        "maturity": "pattern",
        "statement": "A durable opportunity record carries its evidence, expiry and disposition rather than becoming a static dashboard alert."
      },
      {
        "baseId": "last-good-continuity",
        "id": "diff-category-strategy-orchestrator-the-active-strategy-remains-last-good-when-refresh-fails-and-is-visibly",
        "maturity": "roadmap",
        "statement": "The active strategy remains last-good when refresh fails and is visibly marked stale instead of being silently regenerated."
      },
      {
        "baseId": "governed-workblock",
        "id": "diff-intelligent-intake-one-canonical-request-survives-channels-and-clarification-turns-while-ev",
        "maturity": "reference",
        "statement": "One canonical request survives channels and clarification turns while every machine-inferred field remains distinguishable from requester-confirmed facts."
      },
      {
        "baseId": "permissioned-projection",
        "id": "diff-demand-consolidation-portfolio-portfolio-aggregates-include-record-drill-through-under-server-side-acce",
        "maturity": "roadmap",
        "statement": "Portfolio aggregates include record drill-through under server-side access projection."
      },
      {
        "baseId": "last-good-continuity",
        "id": "diff-sourcing-pipeline-discovery-the-pipeline-joins-strategy-current-demand-forecasts-contracts-supplier",
        "maturity": "roadmap",
        "statement": "The pipeline joins strategy, current demand, forecasts, contracts, supplier and market evidence through canonical references and freshness contracts."
      },
      {
        "baseId": "inspectable-decisioning",
        "id": "diff-sourcing-event-machine-drafted-specifications-and-messages-remain-proposals-until-the-a",
        "maturity": "reference",
        "statement": "Machine-drafted specifications and messages remain proposals until the active event authority permits publication or delivery."
      },
      {
        "baseId": "native-artifact-roundtrip",
        "id": "diff-contract-authoring-review-native-document-round-trip-preserves-review-context-tracked-changes-and",
        "maturity": "reference",
        "statement": "Native document round trip preserves review context, tracked changes and exact source references."
      },
      {
        "baseId": "inspectable-decisioning",
        "id": "diff-renewal-change-compliance-renewal-is-treated-as-an-evidence-driven-decision-window-not-a-calendar",
        "maturity": "roadmap",
        "statement": "Renewal is treated as an evidence-driven decision window, not a calendar reminder."
      },
      {
        "baseId": "inspectable-decisioning",
        "id": "diff-third-party-risk-review-risk-scoring-evidence-sufficiency-and-decision-authority-are-separately",
        "maturity": "reference",
        "statement": "Risk scoring, evidence sufficiency and decision authority are separately inspectable and versioned."
      },
      {
        "baseId": "inspectable-decisioning",
        "id": "diff-guided-buying-the-requester-agent-can-complete-a-bounded-multi-step-mission-while-pres",
        "maturity": "pattern",
        "statement": "The requester agent can complete a bounded multi-step mission while preserving correction, stop and escalation paths."
      },
      {
        "baseId": "policy-bounded-autonomy",
        "id": "diff-invoice-exception-triage-routine-coding-routing-and-reversible-remediation-execute-only-inside-a",
        "maturity": "reference",
        "statement": "routine coding, routing and reversible remediation execute only inside a versioned exception envelope"
      },
      {
        "baseId": "native-artifact-roundtrip",
        "id": "diff-supplier-performance-review-review-packs-and-working-scorecards-retain-source-references-through-gov",
        "maturity": "reference",
        "statement": "review packs and working scorecards retain source references through governed document and workbook review"
      },
      {
        "baseId": "shared-evidence-plane",
        "id": "diff-savings-initiative-opportunity-baseline-plan-forecast-actual-evidence-attribution-and-commi",
        "maturity": "reference",
        "statement": "opportunity, baseline, plan, forecast, actual evidence, attribution and committed outcome retain separate owners and provenance"
      }
    ]
  },
  "features": {
    "controlTower": false,
    "frameworkExplorer": true,
    "officeRoundTrip": true,
    "platformCopilot": false,
    "pricingCalculator": false
  },
  "frameworkVersion": "6.6.0",
  "generated": {
    "contentHash": "1b8b5c3be43c8c3a7df184dfb5131e6c61c357d43bec7151a499f95e260ee22e",
    "doNotEdit": true,
    "generatedAt": "2026-08-11T09:00:00.000Z",
    "generatorVersion": "6.6.0"
  },
  "groundworks": {
    "dataSurfaces": [
      {
        "id": "task-output",
        "neverFor": "Durable state or cross-execution-flow sharing.",
        "tenantScope": "Ephemeral, run-scoped.",
        "useFor": "A value required by downstream tasks in the same execution-flow run."
      },
      {
        "id": "module-output",
        "neverFor": "Mutable application state or unbounded payloads.",
        "tenantScope": "Run result within the tenant.",
        "useFor": "The stable public result contract of one selected execution-flow run."
      },
      {
        "id": "workblock-run-data",
        "neverFor": "Mutation, pending run state or current record ownership.",
        "tenantScope": "Tenant-scoped completed-run analytics.",
        "useFor": "Read-only analytics and evaluation over completed execution-flow outputs."
      },
      {
        "id": "rowstore",
        "neverFor": "Large binaries, retrieval-only indexes or append-by-whole-collection evidence patterns.",
        "tenantScope": "Workblock scope by default; global only through an intentional shared ledger contract.",
        "useFor": "Current mutable tenant-scoped operational records, status rows and last-good projections."
      },
      {
        "id": "blob",
        "neverFor": "Queryable business fields or authorisation decisions without metadata records.",
        "tenantScope": "Tenant-scoped object storage with record references.",
        "useFor": "Source files, native Office artifacts, evidence binaries and large payloads addressed by stable reference."
      },
      {
        "id": "vector-index",
        "neverFor": "Canonical facts, policy state or record identity.",
        "tenantScope": "Tenant and access-policy scoped retrieval projection.",
        "useFor": "Permission-filtered semantic or lexical retrieval over stable record and blob references."
      },
      {
        "id": "task-cache",
        "neverFor": "Shared application state, audit or business records.",
        "tenantScope": "Task execution scoped.",
        "useFor": "Retry-local progress and reuse within one expensive task execution."
      },
      {
        "id": "learning-data",
        "neverFor": "Application records, unverified feedback or silent policy mutation.",
        "tenantScope": "Tenant-owned learning corpus with explicit lineage.",
        "useFor": "Validated corrections and reconciled outcome examples used by versioned evaluations."
      },
      {
        "id": "event",
        "neverFor": "Canonical storage or an assumption that delivery equals commitment.",
        "tenantScope": "Tenant-scoped delivery with idempotency and reconciliation keys.",
        "useFor": "A versioned signal that work occurred or another business module should react."
      }
    ],
    "dimensions": [
      {
        "applicabilityTargetIds": [
          "business-module",
          "category",
          "spend-record"
        ],
        "assignmentCarrierEntityIds": [
          "category-dimension-assignment"
        ],
        "carrierBindings": [
          {
            "dimensionFieldId": "dimension-id",
            "entityId": "category-dimension-assignment",
            "role": "assignment",
            "valueFieldId": "member-id"
          },
          {
            "entityId": "spend-record",
            "role": "override",
            "valueFieldId": "spend-segment"
          }
        ],
        "definitionKey": "dimension.spend-segment.definition",
        "definitionType": "framework-defined",
        "id": "spend-segment",
        "labelKey": "dimension.spend-segment.label",
        "members": [
          {
            "definitionKey": "dimension.spend-segment.member.direct.definition",
            "id": "direct",
            "labelKey": "dimension.spend-segment.member.direct.label",
            "order": 1,
            "status": "governed"
          },
          {
            "definitionKey": "dimension.spend-segment.member.indirect.definition",
            "id": "indirect",
            "labelKey": "dimension.spend-segment.member.indirect.label",
            "order": 2,
            "status": "governed"
          }
        ],
        "overrideCarrierEntityIds": [
          "spend-record"
        ],
        "owner": "Procurement data model owner",
        "resolutionRuleId": "transaction-line-over-category-assignment",
        "siteFacet": {
          "activation": "complete-module-applicability",
          "parameter": "segment"
        },
        "status": "governed",
        "unknownValuePolicy": "allow-unresolved",
        "valueCardinality": "single",
        "version": "1.0.0"
      },
      {
        "applicabilityTargetIds": [
          "business-module",
          "item-service",
          "catalogue-line",
          "spend-record"
        ],
        "assignmentCarrierEntityIds": [
          "item-service",
          "catalogue-line"
        ],
        "carrierBindings": [
          {
            "entityId": "item-service",
            "role": "assignment",
            "valueFieldId": "buying-mode"
          },
          {
            "entityId": "catalogue-line",
            "role": "assignment",
            "valueFieldId": "buying-mode"
          },
          {
            "entityId": "spend-record",
            "role": "override",
            "valueFieldId": "buying-mode"
          }
        ],
        "definitionKey": "dimension.buying-mode.definition",
        "definitionType": "framework-defined",
        "id": "buying-mode",
        "labelKey": "dimension.buying-mode.label",
        "members": [
          {
            "definitionKey": "dimension.buying-mode.member.goods.definition",
            "id": "goods",
            "labelKey": "dimension.buying-mode.member.goods.label",
            "order": 1,
            "status": "governed"
          },
          {
            "definitionKey": "dimension.buying-mode.member.services.definition",
            "id": "services",
            "labelKey": "dimension.buying-mode.member.services.label",
            "order": 2,
            "status": "governed"
          },
          {
            "definitionKey": "dimension.buying-mode.member.mixed.definition",
            "id": "mixed",
            "labelKey": "dimension.buying-mode.member.mixed.label",
            "order": 3,
            "status": "governed"
          }
        ],
        "overrideCarrierEntityIds": [
          "spend-record"
        ],
        "owner": "Procurement data model owner",
        "resolutionRuleId": "transaction-line-over-item-or-catalogue-default",
        "siteFacet": {
          "activation": "complete-module-applicability",
          "parameter": "buying"
        },
        "status": "governed",
        "unknownValuePolicy": "allow-unresolved",
        "valueCardinality": "single",
        "version": "1.0.0"
      },
      {
        "applicabilityTargetIds": [
          "business-module",
          "requisition-line",
          "spend-record"
        ],
        "assignmentCarrierEntityIds": [
          "spend-record"
        ],
        "carrierBindings": [
          {
            "entityId": "spend-record",
            "role": "assignment",
            "valueFieldId": "accounting-treatment"
          },
          {
            "entityId": "spend-record",
            "role": "override",
            "valueFieldId": "accounting-treatment"
          }
        ],
        "definitionKey": "dimension.accounting-treatment.definition",
        "definitionType": "framework-defined",
        "id": "accounting-treatment",
        "labelKey": "dimension.accounting-treatment.label",
        "members": [
          {
            "definitionKey": "dimension.accounting-treatment.member.capital.definition",
            "id": "capital",
            "labelKey": "dimension.accounting-treatment.member.capital.label",
            "order": 1,
            "status": "governed"
          },
          {
            "definitionKey": "dimension.accounting-treatment.member.operating.definition",
            "id": "operating",
            "labelKey": "dimension.accounting-treatment.member.operating.label",
            "order": 2,
            "status": "governed"
          }
        ],
        "overrideCarrierEntityIds": [
          "spend-record"
        ],
        "owner": "Procurement data model owner",
        "resolutionRuleId": "accounting-distribution-commitment",
        "siteFacet": {
          "activation": "complete-module-applicability",
          "parameter": "treatment"
        },
        "status": "governed",
        "unknownValuePolicy": "allow-unresolved",
        "valueCardinality": "single",
        "version": "1.0.0"
      },
      {
        "applicabilityTargetIds": [
          "category",
          "item-service",
          "catalogue-line",
          "spend-record"
        ],
        "assignmentCarrierEntityIds": [
          "category"
        ],
        "carrierBindings": [
          {
            "entityId": "category",
            "role": "assignment",
            "valueFieldId": "category-id"
          },
          {
            "entityId": "spend-record",
            "role": "override",
            "valueFieldId": "category-id"
          }
        ],
        "definitionKey": "dimension.category.definition",
        "definitionType": "tenant-defined",
        "id": "category",
        "labelKey": "dimension.category.label",
        "members": [],
        "overrideCarrierEntityIds": [
          "spend-record"
        ],
        "owner": "Procurement data model owner",
        "resolutionRuleId": "taxonomy-version-and-nearest-ancestor-assignment",
        "status": "governed",
        "unknownValuePolicy": "allow-unresolved",
        "valueCardinality": "single",
        "version": "1.0.0"
      },
      {
        "applicabilityTargetIds": [
          "spend-record"
        ],
        "assignmentCarrierEntityIds": [
          "tail-spend-evaluation"
        ],
        "carrierBindings": [
          {
            "entityId": "tail-spend-evaluation",
            "role": "derived-result",
            "valueFieldId": "evaluation-result"
          }
        ],
        "definitionKey": "dimension.tail-membership.definition",
        "definitionType": "derived",
        "id": "tail-membership",
        "labelKey": "dimension.tail-membership.label",
        "members": [
          {
            "definitionKey": "dimension.tail-membership.member.tail.definition",
            "id": "tail",
            "labelKey": "dimension.tail-membership.member.tail.label",
            "order": 1,
            "status": "governed"
          },
          {
            "definitionKey": "dimension.tail-membership.member.non-tail.definition",
            "id": "non-tail",
            "labelKey": "dimension.tail-membership.member.non-tail.label",
            "order": 2,
            "status": "governed"
          }
        ],
        "owner": "Procurement data model owner",
        "resolutionRuleId": "versioned-tail-rule-evaluation",
        "status": "governed",
        "unknownValuePolicy": "allow-unresolved",
        "valueCardinality": "single",
        "version": "1.0.0"
      }
    ],
    "entities": [
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "contract-authoring-review",
          "guided-buying",
          "invoice-exception-triage",
          "sourcing-event",
          "supplier-onboarding",
          "supplier-performance-review"
        ],
        "definition": "A person or organisation that participates in procurement. Verified external identifiers are namespaced attributes, never the canonical key.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "internal",
            "definition": "Stable tenant-scoped canonical identifier.",
            "exchangeScope": "mapped",
            "id": "party-id",
            "introducedIn": "1.0.0",
            "label": "Party ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "common-library",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "Exchange identifiers are namespaced; the canonical UUID is not exported unless agreed.",
                "path": "cac:Party/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Current verified legal or personal display name appropriate to the party type.",
            "exchangeScope": "mapped",
            "id": "legal-name",
            "introducedIn": "1.0.0",
            "label": "Legal name",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "common-library",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:Party/cac:PartyLegalEntity/cbc:RegistrationName",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "The closed semantic class of the party.",
            "enumValues": [
              "organisation",
              "person",
              "public-body",
              "internal-legal-entity"
            ],
            "exchangeScope": "unmapped",
            "id": "party-type",
            "introducedIn": "1.0.0",
            "label": "Party type",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Namespaced verified identifier such as supplier number, LEI or GLN; multiple identifiers are represented as an object array.",
            "exchangeScope": "mapped",
            "id": "external-identifier",
            "introducedIn": "1.0.0",
            "label": "External identifier",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "components": [
                  {
                    "standardPath": "cac:Party/cac:PartyIdentification/cbc:ID/@schemeID",
                    "valuePath": "scheme-id"
                  },
                  {
                    "standardPath": "cac:Party/cac:PartyIdentification/cbc:ID",
                    "valuePath": "identifier-value"
                  }
                ],
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "common-library",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:Party/cac:PartyIdentification/cbc:ID[@schemeID]",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              },
              {
                "conceptId": "identifier",
                "coverage": "semantic",
                "direction": "inbound",
                "exchangeScope": "edge-interchange",
                "mappingKind": "identifier-namespace",
                "path": "LEI",
                "releaseId": "iso-17442",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "lei-17442",
                "transformation": "adapter-defined"
              },
              {
                "conceptId": "identifier",
                "coverage": "semantic",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "identifier-namespace",
                "path": "GLN",
                "releaseId": "source-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "gs1-identifiers",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "external-identifier-value",
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "A verified jurisdiction-qualified tax identifier such as a US Employer Identification Number. It is never used as an electronic delivery address or the canonical party key.",
            "exchangeScope": "mapped",
            "id": "tax-identifier",
            "introducedIn": "3.2.0",
            "label": "Tax identifier",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "conceptId": "employer-identification-number",
                "coverage": "semantic",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "identifier-namespace",
                "note": "The jurisdiction and tax scheme remain explicit. EIN is not a Peppol endpoint identifier.",
                "path": "cac:Party/cac:PartyTaxScheme/cbc:CompanyID",
                "releaseId": "jurisdiction-qualified",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "us-irs-ein",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Jurisdiction code records the governed code within Party Tax identifier without treating absence, unknown and zero as equivalent.",
                    "id": "jurisdiction-code",
                    "label": "Jurisdiction code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "tax-identifier",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Scheme ID is the string component carried within Party Tax identifier; its classification and authority inherit from the owning field contract.",
                    "id": "scheme-id",
                    "label": "Scheme ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "tax-identifier",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Identifier value is the string component carried within Party Tax identifier; its classification and authority inherit from the owning field contract.",
                    "id": "identifier-value",
                    "label": "Identifier value",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "tax-identifier",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Verified at is the timestamp component carried within Party Tax identifier; its classification and authority inherit from the owning field contract.",
                    "id": "verified-at",
                    "label": "Verified at",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "tax-identifier",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Source system ID is the string component carried within Party Tax identifier; its classification and authority inherit from the owning field contract.",
                    "id": "source-system-id",
                    "label": "Source system ID",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "tax-identifier",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ],
                "uniqueBy": [
                  "jurisdiction-code",
                  "scheme-id",
                  "identifier-value"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "A scheme-qualified network delivery address, including a Peppol participant endpoint. It remains distinct from tax, legal-entity and canonical party identifiers.",
            "exchangeScope": "mapped",
            "id": "electronic-address",
            "introducedIn": "3.2.0",
            "label": "Electronic address",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "conceptId": "electronic-address",
                "coverage": "exact",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "identifier-namespace",
                "path": "cac:Party/cbc:EndpointID[@schemeID]",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "peppol-eas-iso-6523",
                "transformation": "none"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Scheme ID is the string component carried within Party Electronic address; its classification and authority inherit from the owning field contract.",
                    "id": "scheme-id",
                    "label": "Scheme ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "electronic-address",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Address value is the string component carried within Party Electronic address; its classification and authority inherit from the owning field contract.",
                    "id": "address-value",
                    "label": "Address value",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "electronic-address",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Network ID is the string component carried within Party Electronic address; its classification and authority inherit from the owning field contract.",
                    "id": "network-id",
                    "label": "Network ID",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "electronic-address",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Verified at is the timestamp component carried within Party Electronic address; its classification and authority inherit from the owning field contract.",
                    "id": "verified-at",
                    "label": "Verified at",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "electronic-address",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Valid to is the date component carried within Party Electronic address; its classification and authority inherit from the owning field contract.",
                    "id": "valid-to",
                    "label": "Valid to",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "electronic-address",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  }
                ],
                "uniqueBy": [
                  "scheme-id",
                  "address-value"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Country in which the organisation is legally registered when applicable.",
            "exchangeScope": "mapped",
            "format": "ISO 3166-1 alpha-2",
            "id": "registered-country-code",
            "introducedIn": "1.0.0",
            "label": "Registered country code",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "common-library",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:Party/cac:PostalAddress/cac:Country/cbc:IdentificationCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "An informal name or reference under which this party was observed in a source system, retained as identity-resolution evidence. It is never a verified namespaced identifier and never the canonical party key.",
            "exchangeScope": "internal",
            "id": "observed-name-variant",
            "introducedIn": "4.8.0",
            "label": "Observed name variant",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Variant value is the observed name or reference string carried within Party Observed name variant; its classification and authority inherit from the owning field contract.",
                    "id": "variant-value",
                    "label": "Variant value",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "observed-name-variant",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Source system ID is the string component carried within Party Observed name variant naming the system in which the variant was observed; its classification and authority inherit from the owning field contract.",
                    "id": "source-system-id",
                    "label": "Source system ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "observed-name-variant",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Identity match basis records the governed identity-resolution evidence class that produced this variant within Party Observed name variant without treating absence, unknown and zero as equivalent. It is never the invoice-matching mode carried by invoice-match-assessment.match-basis.",
                    "enumValues": [
                      "name-similarity",
                      "tax-identifier-match",
                      "electronic-address-match",
                      "address-match",
                      "manual"
                    ],
                    "id": "identity-match-basis",
                    "label": "Identity match basis",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "observed-name-variant",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "First observed at is the timestamp component carried within Party Observed name variant; its classification and authority inherit from the owning field contract.",
                    "id": "first-observed-at",
                    "label": "First observed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "observed-name-variant",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Last observed at is the timestamp component carried within Party Observed name variant; its classification and authority inherit from the owning field contract.",
                    "id": "last-observed-at",
                    "label": "Last observed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "observed-name-variant",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  }
                ],
                "uniqueBy": [
                  "variant-value",
                  "source-system-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "The surviving party record that superseded this one when identity resolution merged it. Populated only while lifecycle-state is merged; it records a resolution outcome, never a corporate or legal succession.",
            "exchangeScope": "internal",
            "id": "merged-into-party-id",
            "introducedIn": "4.8.0",
            "label": "Merged into party",
            "nullable": true,
            "referenceEntityId": "party",
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "UTC timestamp of the current canonical version.",
            "exchangeScope": "mapped",
            "format": "ISO 8601 UTC",
            "id": "updated-at",
            "introducedIn": "1.0.0",
            "label": "Updated at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "conceptId": "date-time-value",
                "coverage": "semantic",
                "direction": "outbound",
                "exchangeScope": "edge-interchange",
                "mappingKind": "value-format",
                "path": "updatedAt",
                "releaseId": "iso-8601-1-2019",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-8601",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "party",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "party-id"
            ],
            "id": "party-primary",
            "introducedIn": "1.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "external-identifier"
            ],
            "id": "party-by-external-identifier",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "legal-name",
              "registered-country-code"
            ],
            "id": "party-by-legal-name-and-registered-country-code",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "party",
        "label": "Party",
        "lifecycle": [
          "candidate",
          "active",
          "restricted",
          "inactive",
          "merged"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "shared-ledger-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "platform-services-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Parties",
        "primaryKey": "party-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links a merged party record to the surviving party that superseded it, so the merged lifecycle state names its destination.",
            "id": "party-references-party-merged-into-party-id",
            "introducedIn": "4.8.0",
            "predicate": "references",
            "qualifiedId": "party-references-party-merged-into-party-id",
            "required": false,
            "sourceFieldId": "merged-into-party-id",
            "targetEntityId": "party",
            "targetFieldId": "party-id"
          }
        ],
        "retentionClass": "reference",
        "searchTerms": [
          "supplier",
          "buyer",
          "customer",
          "legal entity",
          "organisation",
          "person",
          "UBL Party",
          "LEI",
          "GLN"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Which party does this invoice, order or contract belong to?",
              "Which external identifiers are registered for this party and under which scheme?",
              "Is this counterparty already known, or is a new party record required?",
              "Which alternate names or references has this party been observed under, and on what identity-match basis?",
              "Which party record superseded this one, and is this record still a valid write target?"
            ],
            "retrievalTerms": [
              "supplier",
              "buyer organisation",
              "business partner",
              "DUNS",
              "LEI",
              "GLN",
              "alias",
              "AKA",
              "trading name",
              "duplicate supplier",
              "merged supplier"
            ],
            "usage": "Resolve any organisation or person participating in a procurement flow to a party before attaching transactions, cases or assessments; treat external identifiers as namespaced attributes, never as the canonical key. An external identifier carries verified namespaced attributes of a still-distinct party; observed-name-variant carries unverified observations that may justify a merge; never conflate the two."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "trading partner",
              "counterparty",
              "legal entity",
              "supplier organisation",
              "vendor record"
            ],
            "concept": "procurement-participant",
            "doNotConfuseWith": [
              {
                "distinction": "A party is any participating person or organisation; person is the human-specific entity used for ownership, contact and authority.",
                "targetEntityId": "person"
              },
              {
                "distinction": "Party is the identity anchor; supplier-profile carries the relationship-specific commercial and lifecycle state for a supplier party.",
                "targetEntityId": "supplier-profile"
              },
              {
                "distinction": "A party is the governed identity that facts are about; a source-record-reference is provenance that names the originating record a fact came from without copying it. Name variants retained on a party are identity evidence about who the party is, never provenance about where a fact arrived from.",
                "targetEntityId": "source-record-reference"
              }
            ]
          },
          "standardsAlignment": [
            {
              "concept": "Legal Entity Identifier registrant",
              "matchKind": "related",
              "standardId": "lei-17442"
            },
            {
              "concept": "Electronic address scheme participant identifier",
              "matchKind": "related",
              "standardId": "peppol-eas-iso-6523"
            },
            {
              "concept": "Global Location Number (GLN) holder",
              "matchKind": "related",
              "standardId": "gs1-identifiers"
            }
          ]
        },
        "sourceSystemRoleIds": [
          "system-of-record",
          "identity-authority",
          "commitment-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.1.0",
        "writebackSystemRoleIds": [
          "system-of-record"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "contract-authoring-review",
          "demand-orchestration",
          "intelligent-intake",
          "payment-readiness",
          "sourcing-event",
          "third-party-risk-review"
        ],
        "definition": "A person known to the platform for ownership, contact or authority purposes; authentication identity and employment master remain external boundaries.",
        "domainWorkblockIds": [
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "personal",
            "definition": "Stable tenant-scoped person identifier.",
            "exchangeScope": "unmapped",
            "id": "person-id",
            "introducedIn": "1.0.0",
            "label": "Person ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "personal",
            "definition": "Canonical party represented by this person.",
            "exchangeScope": "mapped",
            "id": "party-id",
            "introducedIn": "1.0.0",
            "label": "Party ID",
            "nullable": false,
            "referenceEntityId": "party",
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "common-library",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:Party/cac:Person/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Opaque identity-provider subject used for access binding.",
            "exchangeScope": "unmapped",
            "id": "identity-subject",
            "introducedIn": "1.0.0",
            "label": "Identity subject",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "personal",
            "definition": "Name used in owner and activity surfaces.",
            "exchangeScope": "mapped",
            "id": "display-name",
            "introducedIn": "1.0.0",
            "label": "Display name",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "common-library",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:Party/cac:Person/cbc:FirstName | cac:Party/cac:Person/cbc:FamilyName",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Role label for routing and presentation; grants are owned by authority records, not this text.",
            "exchangeScope": "unmapped",
            "id": "primary-role",
            "introducedIn": "1.0.0",
            "label": "Primary role",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "person",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "person-id"
            ],
            "id": "person-primary",
            "introducedIn": "1.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "party-id"
            ],
            "id": "person-by-party-id",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "identity-subject"
            ],
            "id": "person-by-identity-subject",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "party",
        "label": "Person",
        "lifecycle": [
          "active",
          "inactive"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "shared-ledger-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "platform-services-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "People",
        "primaryKey": "person-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "The canonical party represented by the person.",
            "id": "person-belongs-to-party-person-party",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "person-belongs-to-party-person-party",
            "required": true,
            "sourceFieldId": "party-id",
            "targetEntityId": "party",
            "targetFieldId": "party-id"
          }
        ],
        "retentionClass": "reference",
        "searchTerms": [
          "owner",
          "requester",
          "reviewer",
          "approver",
          "contact",
          "authority grantor"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Who owns or is accountable for this record or case?",
              "Which people hold an active assignment to a given role?"
            ],
            "retrievalTerms": [
              "owner",
              "approver",
              "requester",
              "contact person"
            ],
            "usage": "Reference a person for ownership, contact or authority attribution; authentication identity and the employment master remain external systems and are never mirrored here."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "user",
              "employee",
              "stakeholder",
              "contact"
            ],
            "concept": "known-individual",
            "doNotConfuseWith": [
              {
                "distinction": "A person is an individual; a role is the governed definition a person may be assigned to.",
                "targetEntityId": "role"
              }
            ]
          }
        },
        "sourceSystemRoleIds": [
          "identity-authority",
          "source-of-record"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": []
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "approve",
            "commit",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": false,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "category-opportunity-radar",
          "guided-buying",
          "intelligent-intake",
          "savings-initiative"
        ],
        "definition": "An organizational scope used for demand, spend, budget, authority and reporting.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "internal",
            "definition": "Stable canonical identifier.",
            "exchangeScope": "unmapped",
            "id": "business-unit-id",
            "introducedIn": "1.0.0",
            "label": "Business unit ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Namespaced source-system key.",
            "exchangeScope": "unmapped",
            "id": "external-key",
            "introducedIn": "1.0.0",
            "label": "External key",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Current display name.",
            "exchangeScope": "unmapped",
            "id": "name",
            "introducedIn": "1.0.0",
            "label": "Name",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Parent node when present.",
            "exchangeScope": "unmapped",
            "id": "parent-business-unit-id",
            "introducedIn": "1.0.0",
            "label": "Parent business unit ID",
            "nullable": true,
            "referenceEntityId": "business-unit",
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "business-unit",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "business-unit-id"
            ],
            "id": "business-unit-primary",
            "introducedIn": "1.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "external-key"
            ],
            "id": "business-unit-by-external-key",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "reference",
        "label": "Business unit",
        "lifecycle": [
          "active",
          "inactive"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "shared-ledger-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "platform-services-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Business units",
        "primaryKey": "business-unit-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Optional parent in the effective organizational hierarchy.",
            "id": "business-unit-belongs-to-business-unit-business-unit-parent",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "business-unit-belongs-to-business-unit-business-unit-parent",
            "required": false,
            "sourceFieldId": "parent-business-unit-id",
            "targetEntityId": "business-unit",
            "targetFieldId": "business-unit-id"
          }
        ],
        "retentionClass": "reference",
        "searchTerms": [
          "organisation",
          "cost owner",
          "legal entity",
          "department"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Which business unit does this demand, budget or spend belong to?",
              "What is the organisational rollup for this report or forecast?"
            ],
            "retrievalTerms": [
              "org unit",
              "plant",
              "entity scope",
              "company code"
            ],
            "usage": "Scope demand, spend, budget, authority and reporting to a business unit; use it as the organisational dimension on records rather than free-text department names."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "cost centre owner",
              "division",
              "department",
              "operating unit"
            ],
            "concept": "organisational-scope"
          }
        },
        "sourceSystemRoleIds": [
          "commitment-system",
          "identity-authority"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": []
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "approve",
            "commit",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": false,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "category-opportunity-radar",
          "guided-buying",
          "intelligent-intake",
          "invoice-exception-triage",
          "savings-initiative",
          "sourcing-event"
        ],
        "definition": "A governed procurement category in the client-controlled taxonomy, optionally mapped to external classification schemes.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "internal",
            "definition": "Stable canonical identifier independent of taxonomy codes.",
            "exchangeScope": "unmapped",
            "id": "category-id",
            "introducedIn": "1.0.0",
            "label": "Category ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Client-controlled category code within the taxonomy version.",
            "exchangeScope": "mapped",
            "id": "code",
            "introducedIn": "1.0.0",
            "label": "Code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "common-library",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:CommodityClassification/cbc:ItemClassificationCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Current category label.",
            "exchangeScope": "unmapped",
            "id": "name",
            "introducedIn": "1.0.0",
            "label": "Name",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Optional parent node in the same taxonomy version.",
            "exchangeScope": "unmapped",
            "id": "parent-category-id",
            "introducedIn": "1.0.0",
            "label": "Parent category ID",
            "nullable": true,
            "referenceEntityId": "category",
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Namespaced external scheme, version and code mappings.",
            "exchangeScope": "mapped",
            "id": "external-classification",
            "introducedIn": "1.0.0",
            "label": "External classification",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "conceptId": "commodity-classification",
                "coverage": "semantic",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "code-list",
                "path": "code",
                "releaseId": "unresolved-release",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "unspsc",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "internal",
                    "definition": "Scheme ID is the string component carried within Category External classification; its classification and authority inherit from the owning field contract.",
                    "id": "scheme-id",
                    "label": "Scheme ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "external-classification",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "internal",
                    "definition": "Classification code records the governed code within Category External classification without treating absence, unknown and zero as equivalent.",
                    "id": "classification-code",
                    "label": "Classification code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "external-classification",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "internal",
                    "definition": "Scheme version is the string component carried within Category External classification; its classification and authority inherit from the owning field contract.",
                    "id": "scheme-version",
                    "label": "Scheme version",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "external-classification",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "internal",
                    "definition": "Classification label is the string component carried within Category External classification; its classification and authority inherit from the owning field contract.",
                    "id": "classification-label",
                    "label": "Classification label",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "external-classification",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "internal",
                    "definition": "Source system ID is the string component carried within Category External classification; its classification and authority inherit from the owning field contract.",
                    "id": "source-system-id",
                    "label": "Source system ID",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "external-classification",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "internal",
                    "definition": "Effective from is the date component carried within Category External classification; its classification and authority inherit from the owning field contract.",
                    "id": "effective-from",
                    "label": "Effective from",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "external-classification",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  }
                ],
                "uniqueBy": [
                  "scheme-id",
                  "classification-code"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Required governed reference to the immutable company taxonomy release containing this category.",
            "exchangeScope": "unmapped",
            "id": "taxonomy-version-id",
            "introducedIn": "4.0.0",
            "label": "Taxonomy version ID",
            "nullable": false,
            "referenceEntityId": "taxonomy-version",
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "category",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "category-id"
            ],
            "id": "category-primary",
            "introducedIn": "1.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "external-classification"
            ],
            "id": "category-by-external-classification",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "taxonomy-version-id",
              "code"
            ],
            "id": "category-by-taxonomy-version-id-and-code",
            "introducedIn": "4.0.0",
            "unique": true
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "reference",
        "label": "Category",
        "lifecycle": [
          "draft",
          "active",
          "deprecated"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "shared-ledger-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "platform-services-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Categories",
        "primaryKey": "category-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Optional parent category in the same effective taxonomy.",
            "id": "category-classified-as-category-category-parent",
            "introducedIn": "1.0.0",
            "predicate": "classified-as",
            "qualifiedId": "category-classified-as-category-category-parent",
            "required": false,
            "sourceFieldId": "parent-category-id",
            "targetEntityId": "category",
            "targetFieldId": "category-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Governed company taxonomy version containing the category.",
            "id": "category-belongs-to-taxonomy-version-category-taxonomy-version",
            "introducedIn": "4.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "category-belongs-to-taxonomy-version-category-taxonomy-version",
            "required": true,
            "sourceFieldId": "taxonomy-version-id",
            "targetEntityId": "taxonomy-version",
            "targetFieldId": "taxonomy-version-id"
          }
        ],
        "retentionClass": "reference",
        "searchTerms": [
          "taxonomy",
          "commodity",
          "UNSPSC",
          "classification",
          "spend category"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Which company category is this item, line or spend record classified into, and under which taxonomy version?",
              "Which external classification codes map to this company category?"
            ],
            "retrievalTerms": [
              "UNSPSC",
              "CPV",
              "eCl@ss",
              "commodity code",
              "category tree"
            ],
            "usage": "Classify what is bought against the company-controlled taxonomy at a pinned taxonomy version; link external schemes as mappings and never substitute an external code for the company category."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "spend category",
              "commodity group",
              "category node"
            ],
            "concept": "company-procurement-category",
            "doNotConfuseWith": [
              {
                "distinction": "Category is the taxonomy node; the dimension assignment attaches a governed dimension member to that node.",
                "targetEntityId": "category-dimension-assignment"
              },
              {
                "distinction": "Category is one node; taxonomy-version is the immutable company-scoped release that contains it.",
                "targetEntityId": "taxonomy-version"
              }
            ]
          },
          "standardsAlignment": [
            {
              "concept": "UNSPSC commodity classification",
              "matchKind": "related",
              "standardId": "unspsc"
            },
            {
              "concept": "Common Procurement Vocabulary code",
              "matchKind": "related",
              "standardId": "cpv"
            },
            {
              "concept": "eCl@ss classification class",
              "matchKind": "related",
              "standardId": "eclass"
            }
          ]
        },
        "sourceSystemRoleIds": [
          "system-of-record"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "approve",
            "commit",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": false,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "demand-consolidation-portfolio",
          "guided-buying",
          "intelligent-intake",
          "invoice-exception-triage",
          "sourcing-event"
        ],
        "definition": "A procurement subject that may be requested, sourced, catalogued, ordered, received, invoiced or measured.",
        "domainWorkblockIds": [
          "intake-demand",
          "sourcing-negotiation",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness"
        ],
        "fields": [
          {
            "classification": "internal",
            "definition": "Stable canonical identifier.",
            "exchangeScope": "mapped",
            "id": "item-service-id",
            "introducedIn": "1.0.0",
            "label": "Item or service ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "common-library",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:Item/cac:StandardItemIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Whether the record represents a good, service or mixed deliverable.",
            "enumValues": [
              "good",
              "service",
              "mixed"
            ],
            "exchangeScope": "unmapped",
            "id": "kind",
            "introducedIn": "1.0.0",
            "label": "Kind",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Optional governed default for whether this item or service is bought as goods, services or a mixed offering. A committed spend-record value takes precedence.",
            "enumValues": [
              "goods",
              "services",
              "mixed"
            ],
            "exchangeScope": "internal",
            "id": "buying-mode",
            "introducedIn": "4.0.0",
            "label": "Buying mode",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Normalised short name.",
            "exchangeScope": "mapped",
            "id": "name",
            "introducedIn": "1.0.0",
            "label": "Name",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "common-library",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:Item/cbc:Name",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Normalised descriptive text, with source artifact retained separately.",
            "exchangeScope": "mapped",
            "id": "description",
            "introducedIn": "1.0.0",
            "label": "Description",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "common-library",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:Item/cbc:Description",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "text"
          },
          {
            "classification": "internal",
            "definition": "Current governed category assignment.",
            "exchangeScope": "mapped",
            "id": "category-id",
            "introducedIn": "1.0.0",
            "label": "Category ID",
            "nullable": true,
            "referenceEntityId": "category",
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "common-library",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:Item/cac:CommodityClassification/cbc:ItemClassificationCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Namespaced SKU, GTIN or source item identifier.",
            "exchangeScope": "mapped",
            "id": "external-identifier",
            "introducedIn": "1.0.0",
            "label": "External identifier",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "conceptId": "identifier",
                "coverage": "semantic",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "identifier-namespace",
                "path": "GTIN",
                "releaseId": "source-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "gs1-identifiers",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "external-identifier-value",
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "A namespaced, versioned external catalogue or spend classification such as UNSPSC. It does not replace the canonical category relationship.",
            "exchangeScope": "mapped",
            "id": "external-classification",
            "introducedIn": "3.2.0",
            "label": "External classification",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "conceptId": "commodity-classification",
                "coverage": "exact",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "code-list",
                "path": "cac:Item/cac:CommodityClassification/cbc:ItemClassificationCode[@listID]",
                "releaseId": "unresolved-release",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "unspsc",
                "transformation": "none"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "internal",
                    "definition": "Scheme ID is the string component carried within Item or service External classification; its classification and authority inherit from the owning field contract.",
                    "id": "scheme-id",
                    "label": "Scheme ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "external-classification",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "internal",
                    "definition": "Scheme version is the string component carried within Item or service External classification; its classification and authority inherit from the owning field contract.",
                    "id": "scheme-version",
                    "label": "Scheme version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "external-classification",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "internal",
                    "definition": "Classification code records the governed code within Item or service External classification without treating absence, unknown and zero as equivalent.",
                    "id": "classification-code",
                    "label": "Classification code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "external-classification",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "internal",
                    "definition": "Classification label is the string component carried within Item or service External classification; its classification and authority inherit from the owning field contract.",
                    "id": "classification-label",
                    "label": "Classification label",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "external-classification",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "internal",
                    "definition": "Source system ID is the string component carried within Item or service External classification; its classification and authority inherit from the owning field contract.",
                    "id": "source-system-id",
                    "label": "Source system ID",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "external-classification",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ],
                "uniqueBy": [
                  "scheme-id",
                  "scheme-version",
                  "classification-code"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "item-service",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "item-service-id"
            ],
            "id": "item-service-primary",
            "introducedIn": "1.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "external-identifier"
            ],
            "id": "item-service-by-external-identifier",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "category-id",
              "lifecycle-state"
            ],
            "id": "item-service-by-category-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "reference",
        "label": "Item or service",
        "lifecycle": [
          "candidate",
          "active",
          "inactive"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "shared-ledger-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "platform-services-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Items and services",
        "primaryKey": "item-service-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Current governed category for the item or service.",
            "id": "item-service-classified-as-category-item-service-category",
            "introducedIn": "1.0.0",
            "predicate": "classified-as",
            "qualifiedId": "item-service-classified-as-category-item-service-category",
            "required": false,
            "sourceFieldId": "category-id",
            "targetEntityId": "category",
            "targetFieldId": "category-id"
          }
        ],
        "retentionClass": "reference",
        "searchTerms": [
          "product",
          "service",
          "item",
          "SKU",
          "GTIN",
          "catalogue item"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Which item or service does this requisition, order line or invoice line refer to?",
              "How is this item classified and which units and identifiers describe it?"
            ],
            "retrievalTerms": [
              "material master",
              "GTIN",
              "item number",
              "service description"
            ],
            "usage": "Use item-service for anything that can be requested, sourced, catalogued, ordered, received, invoiced or measured; it is the subject that transactions and catalogues reference."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "material",
              "SKU",
              "service line",
              "catalogue item",
              "part"
            ],
            "concept": "procurement-subject"
          },
          "standardsAlignment": [
            {
              "concept": "UNSPSC commodity code on an item",
              "matchKind": "related",
              "standardId": "unspsc"
            },
            {
              "concept": "eCl@ss product class on an item",
              "matchKind": "related",
              "standardId": "eclass"
            },
            {
              "concept": "Global Trade Item Number (GTIN)",
              "matchKind": "related",
              "standardId": "gs1-identifiers"
            }
          ]
        },
        "sourceSystemRoleIds": [
          "system-of-record",
          "source-of-record"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record",
          "source-of-record"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "approve",
            "commit",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "category-opportunity-radar",
          "contract-authoring-review",
          "guided-buying",
          "intelligent-intake",
          "invoice-exception-triage",
          "savings-initiative",
          "sourcing-event",
          "supplier-onboarding",
          "supplier-performance-review"
        ],
        "definition": "A stable reference to an originating record and version without copying its canonical payload.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "internal",
            "definition": "Stable reference identifier.",
            "exchangeScope": "unmapped",
            "id": "source-record-reference-id",
            "introducedIn": "1.0.0",
            "label": "Source record reference ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Governed identifier of the originating system or adapter.",
            "exchangeScope": "unmapped",
            "id": "source-system-id",
            "introducedIn": "1.0.0",
            "label": "Source system ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Source-native object or document class.",
            "exchangeScope": "unmapped",
            "id": "source-object-type",
            "introducedIn": "1.0.0",
            "label": "Source object type",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Opaque source-native record identifier.",
            "exchangeScope": "unmapped",
            "id": "source-record-id",
            "introducedIn": "1.0.0",
            "label": "Source record ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Version, ETag, sequence or checksum observed from the source.",
            "exchangeScope": "unmapped",
            "id": "source-version",
            "introducedIn": "1.0.0",
            "label": "Source version",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Pinned input schema or profile version used to interpret the record.",
            "exchangeScope": "unmapped",
            "id": "source-schema-version",
            "introducedIn": "1.0.0",
            "label": "Source schema version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "UTC time at which this exact source version was observed.",
            "exchangeScope": "mapped",
            "format": "ISO 8601 UTC",
            "id": "observed-at",
            "introducedIn": "1.0.0",
            "label": "Observed at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "conceptId": "date-time-value",
                "coverage": "semantic",
                "direction": "outbound",
                "exchangeScope": "edge-interchange",
                "mappingKind": "value-format",
                "path": "observedAt",
                "releaseId": "iso-8601-1-2019",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-8601",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "source-record-reference",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "source-record-reference-id"
            ],
            "id": "source-record-reference-primary",
            "introducedIn": "1.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "source-system-id",
              "source-object-type",
              "source-record-id"
            ],
            "id": "source-record-reference-by-source-system-id-and-source-object-type-and-source-record-id",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "reference",
        "label": "Source record reference",
        "lifecycle": [
          "observed",
          "superseded",
          "unavailable"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "audit-event-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "platform-services-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Source record references",
        "primaryKey": "source-record-reference-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [],
        "retentionClass": "evidence",
        "searchTerms": [
          "source",
          "lineage",
          "external key",
          "source version",
          "record ref"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Which originating record and version does this fact anchor to?",
              "In which source system does the canonical payload live?"
            ],
            "retrievalTerms": [
              "source system",
              "origin record",
              "record version",
              "anchor"
            ],
            "usage": "Attach a source-record-reference whenever a record derives from or anchors to another system's record; never copy the canonical payload into the referencing record."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "source anchor",
              "origin reference",
              "provenance pointer"
            ],
            "concept": "origin-record-pointer",
            "doNotConfuseWith": [
              {
                "distinction": "A source-record-reference points at an originating record without copying it; an evidence-item carries the supporting fact or file itself.",
                "targetEntityId": "evidence-item"
              }
            ]
          }
        },
        "sourceSystemRoleIds": [
          "execution-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": []
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "category-opportunity-radar",
          "contract-authoring-review",
          "invoice-exception-triage",
          "policy-guidance",
          "savings-initiative",
          "sourcing-event",
          "supplier-master-qualification",
          "third-party-risk-review"
        ],
        "definition": "A fact, file, observation or excerpt that supports a proposal, decision or committed action, with integrity and access metadata.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "internal",
            "definition": "Stable evidence metadata identifier.",
            "exchangeScope": "unmapped",
            "id": "evidence-item-id",
            "introducedIn": "1.0.0",
            "label": "Evidence item ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Governed semantic class of the evidence.",
            "enumValues": [
              "source-record",
              "document",
              "observation",
              "policy-excerpt",
              "communication",
              "control-result",
              "external-signal"
            ],
            "exchangeScope": "unmapped",
            "id": "evidence-type",
            "introducedIn": "1.0.0",
            "label": "Evidence type",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Originating record when the evidence derives from a structured source.",
            "exchangeScope": "unmapped",
            "id": "source-record-reference-id",
            "introducedIn": "1.0.0",
            "label": "Source record reference ID",
            "nullable": true,
            "referenceEntityId": "source-record-reference",
            "required": false,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Stable blob or native artifact reference; binary content is never stored in the row.",
            "exchangeScope": "mapped",
            "id": "artifact-reference",
            "introducedIn": "1.0.0",
            "label": "Artifact reference",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "common-library",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:DocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Integrity checksum for the exact evidence payload or normalised fact set.",
            "exchangeScope": "unmapped",
            "format": "SHA-256",
            "id": "content-hash",
            "introducedIn": "1.0.0",
            "label": "Content hash",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "UTC timestamp when the evidence was captured.",
            "exchangeScope": "mapped",
            "format": "ISO 8601 UTC",
            "id": "captured-at",
            "introducedIn": "1.0.0",
            "label": "Captured at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "conceptId": "date-time-value",
                "coverage": "semantic",
                "direction": "outbound",
                "exchangeScope": "edge-interchange",
                "mappingKind": "value-format",
                "path": "capturedAt",
                "releaseId": "iso-8601-1-2019",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-8601",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Highest data sensitivity applying to metadata and payload.",
            "enumValues": [
              "public",
              "internal",
              "confidential",
              "personal",
              "restricted"
            ],
            "exchangeScope": "unmapped",
            "id": "classification",
            "introducedIn": "1.0.0",
            "label": "Classification",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "evidence-item",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "evidence-item-id"
            ],
            "id": "evidence-item-primary",
            "introducedIn": "1.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "source-record-reference-id"
            ],
            "id": "evidence-item-by-source-record-reference-id",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "evidence-type",
              "lifecycle-state"
            ],
            "id": "evidence-item-by-evidence-type-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "document",
        "label": "Evidence item",
        "lifecycle": [
          "current",
          "stale",
          "superseded",
          "withdrawn"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "audit-event-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "platform-services-datastore",
            "status": "direction"
          },
          {
            "id": "governed-evidence-blob-store",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Evidence items",
        "primaryKey": "evidence-item-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Optional originating structured source record.",
            "id": "evidence-item-evidenced-by-source-record-reference-evidence-source-record",
            "introducedIn": "1.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "evidence-item-evidenced-by-source-record-reference-evidence-source-record",
            "required": false,
            "sourceFieldId": "source-record-reference-id",
            "targetEntityId": "source-record-reference",
            "targetFieldId": "source-record-reference-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "evidence",
          "artifact",
          "document",
          "source excerpt",
          "checksum",
          "provenance"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "What evidence supports this proposal, decision or committed action?",
              "Is the cited evidence still intact and accessible for this audience?"
            ],
            "retrievalTerms": [
              "justification",
              "supporting file",
              "citation",
              "audit evidence"
            ],
            "usage": "Bind every consequential proposal, decision or committed action to evidence-items with integrity and access metadata; agents cite evidence rather than restating unverified claims."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "supporting document",
              "attachment",
              "observation record",
              "excerpt"
            ],
            "concept": "supporting-fact",
            "doNotConfuseWith": [
              {
                "distinction": "Evidence supports a specific proposal or decision; a learning-example is a validated correction curated into an evaluation set.",
                "targetEntityId": "learning-example"
              }
            ]
          }
        },
        "sourceSystemRoleIds": [
          "evidence-source"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": []
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": false,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "contract-authoring-review",
          "guided-buying",
          "intelligent-intake",
          "invoice-exception-triage",
          "payment-readiness",
          "policy-guidance",
          "sourcing-event",
          "supplier-onboarding"
        ],
        "definition": "A governed body of intent and authority whose immutable versions contain executable rules and source artifacts.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "internal",
            "definition": "Stable policy family identifier.",
            "exchangeScope": "internal",
            "id": "policy-id",
            "introducedIn": "1.0.0",
            "label": "Policy ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Stable human-readable policy family code.",
            "exchangeScope": "internal",
            "id": "policy-code",
            "introducedIn": "1.0.0",
            "label": "Policy code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Current policy family title.",
            "exchangeScope": "internal",
            "id": "title",
            "introducedIn": "1.0.0",
            "label": "Title",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Accountable policy owner.",
            "exchangeScope": "internal",
            "id": "owner-person-id",
            "introducedIn": "1.0.0",
            "label": "Owner person ID",
            "nullable": false,
            "referenceEntityId": "person",
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Currently active immutable policy version.",
            "exchangeScope": "internal",
            "id": "active-version-id",
            "introducedIn": "1.0.0",
            "label": "Active version ID",
            "nullable": true,
            "referenceEntityId": "policy-version",
            "required": false,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "policy",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "policy-id"
            ],
            "id": "policy-primary",
            "introducedIn": "1.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "policy-code"
            ],
            "id": "policy-by-policy-code",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "control",
        "label": "Policy",
        "lifecycle": [
          "draft",
          "active",
          "retired"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "registry-governance-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "platform-services-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Policies",
        "primaryKey": "policy-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Accountable owner of the policy family.",
            "id": "policy-governed-by-person-policy-owner",
            "introducedIn": "1.0.0",
            "predicate": "governed-by",
            "qualifiedId": "policy-governed-by-person-policy-owner",
            "required": true,
            "sourceFieldId": "owner-person-id",
            "targetEntityId": "person",
            "targetFieldId": "person-id"
          },
          {
            "cardinality": "one-to-one",
            "definition": "Currently active immutable version.",
            "id": "policy-governed-by-policy-version-policy-active-version",
            "introducedIn": "1.0.0",
            "predicate": "governed-by",
            "qualifiedId": "policy-governed-by-policy-version-policy-active-version",
            "required": false,
            "sourceFieldId": "active-version-id",
            "targetEntityId": "policy-version",
            "targetFieldId": "policy-version-id"
          }
        ],
        "retentionClass": "policy",
        "searchTerms": [
          "rule",
          "guard",
          "procedure",
          "playbook",
          "exception authority"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Which policy governs this action, spend or category?",
              "Which version of the policy was effective at the time of the decision?"
            ],
            "retrievalTerms": [
              "policy rule",
              "compliance rule",
              "buying channel policy"
            ],
            "usage": "Resolve which policy governs an action, then read the effective policy-version; never evaluate rules against the mutable policy head."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "procurement policy",
              "buying rule set",
              "governance policy"
            ],
            "concept": "governed-intent",
            "doNotConfuseWith": [
              {
                "distinction": "Policy is the long-lived governed body; policy-version is one immutable effective release of its rules and sources.",
                "targetEntityId": "policy-version"
              }
            ]
          }
        },
        "sourceSystemRoleIds": [
          "system-of-record",
          "source-of-record"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": false,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "contract-authoring-review",
          "guided-buying",
          "intelligent-intake",
          "invoice-exception-triage",
          "payment-readiness",
          "policy-guidance",
          "sourcing-event",
          "third-party-risk-review"
        ],
        "definition": "An immutable effective version of policy source material, executable rules and tests.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "internal",
            "definition": "Stable immutable policy-version identifier.",
            "exchangeScope": "internal",
            "id": "policy-version-id",
            "introducedIn": "1.0.0",
            "label": "Policy version ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Policy family to which this version belongs.",
            "exchangeScope": "internal",
            "id": "policy-id",
            "introducedIn": "1.0.0",
            "label": "Policy ID",
            "nullable": false,
            "referenceEntityId": "policy",
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Version used for policy compatibility and release history.",
            "exchangeScope": "internal",
            "format": "SemVer",
            "id": "semantic-version",
            "introducedIn": "1.0.0",
            "label": "Semantic version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Reference to the authoritative immutable policy artifact.",
            "exchangeScope": "mapped",
            "id": "artifact-reference",
            "introducedIn": "1.0.0",
            "label": "Artifact reference",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "common-library",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:DocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Integrity hash of the compiled executable rule set.",
            "exchangeScope": "internal",
            "format": "SHA-256",
            "id": "rules-hash",
            "introducedIn": "1.0.0",
            "label": "Rules hash",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "First UTC instant at which this version may govern a new decision.",
            "exchangeScope": "mapped",
            "format": "ISO 8601 UTC",
            "id": "effective-from",
            "introducedIn": "1.0.0",
            "label": "Effective from",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "conceptId": "date-time-value",
                "coverage": "semantic",
                "direction": "outbound",
                "exchangeScope": "edge-interchange",
                "mappingKind": "value-format",
                "path": "effectiveFrom",
                "releaseId": "iso-8601-1-2019",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-8601",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Optional final UTC instant of applicability.",
            "exchangeScope": "mapped",
            "format": "ISO 8601 UTC",
            "id": "effective-to",
            "introducedIn": "1.0.0",
            "label": "Effective to",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "conceptId": "date-time-value",
                "coverage": "semantic",
                "direction": "outbound",
                "exchangeScope": "edge-interchange",
                "mappingKind": "value-format",
                "path": "effectiveTo",
                "releaseId": "iso-8601-1-2019",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-8601",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "policy-version",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "policy-version-id"
            ],
            "id": "policy-version-primary",
            "introducedIn": "1.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "policy-id",
              "semantic-version"
            ],
            "id": "policy-version-by-policy-id-and-semantic-version",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "lifecycle-state",
              "effective-from"
            ],
            "id": "policy-version-by-status-and-effective-from",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "control",
        "label": "Policy version",
        "lifecycle": [
          "draft",
          "tested",
          "scheduled",
          "active",
          "superseded",
          "rolled-back"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "registry-governance-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "platform-services-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Policy versions",
        "primaryKey": "policy-version-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Policy family containing the immutable version.",
            "id": "policy-version-governed-by-policy-policy-version-family",
            "introducedIn": "1.0.0",
            "predicate": "governed-by",
            "qualifiedId": "policy-version-governed-by-policy-policy-version-family",
            "required": true,
            "sourceFieldId": "policy-id",
            "targetEntityId": "policy",
            "targetFieldId": "policy-id"
          }
        ],
        "retentionClass": "policy",
        "searchTerms": [
          "policy release",
          "rule version",
          "effective policy",
          "playbook version",
          "rollback"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Which executable rules and tests were in force for this evaluation?",
              "When did this policy version become effective and what superseded it?"
            ],
            "retrievalTerms": [
              "rule release",
              "effective date",
              "policy source"
            ],
            "usage": "Pin evaluations, guidance results and decisions to the immutable policy-version that was effective; a superseded version remains readable for audit."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "policy release",
              "effective rules"
            ],
            "concept": "effective-policy-release"
          }
        },
        "sourceSystemRoleIds": [
          "system-of-record",
          "source-of-record"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "category-opportunity-radar",
          "contract-authoring-review",
          "demand-orchestration",
          "guided-buying",
          "intelligent-intake",
          "invoice-exception-triage",
          "negotiation-copilot",
          "payment-readiness",
          "purchase-order-exception",
          "savings-initiative",
          "sourcing-event",
          "sourcing-pipeline-discovery",
          "supplier-performance-review",
          "third-party-risk-review",
          "value-leakage-monitor"
        ],
        "definition": "A versioned grant that defines exactly which named actions may be committed without per-item approval, on which records, through which tools and under which evidence and monitoring conditions.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable immutable grant identifier.",
            "exchangeScope": "internal",
            "id": "authority-envelope-id",
            "introducedIn": "1.0.0",
            "label": "Authority envelope ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Workblock whose action classes receive the grant.",
            "exchangeScope": "internal",
            "id": "workblock-id",
            "introducedIn": "1.0.0",
            "label": "Workblock ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Named accountable person or role holder who granted the envelope.",
            "exchangeScope": "internal",
            "id": "grantor-person-id",
            "introducedIn": "1.0.0",
            "label": "Grantor person ID",
            "nullable": false,
            "referenceEntityId": "person",
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Immutable policy version authorising this envelope.",
            "exchangeScope": "internal",
            "id": "policy-version-id",
            "introducedIn": "1.0.0",
            "label": "Policy version ID",
            "nullable": false,
            "referenceEntityId": "policy-version",
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Typed verbs, entity and case classes, tools, integrations, jurisdictions, categories, value and risk bounds.",
            "exchangeScope": "internal",
            "id": "allowed-actions",
            "introducedIn": "1.0.0",
            "label": "Allowed actions",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Action verbs is the set carried within Authority envelope Allowed actions; its owning field governs allowed values and interpretation.",
                    "id": "action-verbs",
                    "label": "Action verbs",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "allowed-actions",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Entity ids is the set carried within Authority envelope Allowed actions; its owning field governs allowed values and interpretation.",
                    "id": "entity-ids",
                    "label": "Entity ids",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "allowed-actions",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Case types is the set carried within Authority envelope Allowed actions; its owning field governs allowed values and interpretation.",
                    "id": "case-types",
                    "label": "Case types",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "allowed-actions",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Tool ids is the set carried within Authority envelope Allowed actions; its owning field governs allowed values and interpretation.",
                    "id": "tool-ids",
                    "label": "Tool ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "allowed-actions",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Integration ids is the set carried within Authority envelope Allowed actions; its owning field governs allowed values and interpretation.",
                    "id": "integration-ids",
                    "label": "Integration ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "allowed-actions",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Jurisdiction codes is the set carried within Authority envelope Allowed actions; its owning field governs allowed values and interpretation.",
                    "id": "jurisdiction-codes",
                    "label": "Jurisdiction codes",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "allowed-actions",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Category ids links this structured value to governed categories through category-id within Authority envelope Allowed actions.",
                    "id": "category-ids",
                    "label": "Category ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "referenceEntityId": "category",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links category ids to governed categories through the canonical category-id field.",
                      "id": "authority-envelope-allowed-actions-category-ids",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "category-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "allowed-actions",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Minimum value is the money component carried within Authority envelope Allowed actions; its classification and authority inherit from the owning field contract.",
                    "id": "minimum-value",
                    "label": "Minimum value",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "allowed-actions",
                      "kind": "inherited-field"
                    },
                    "type": "money",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "money-value",
                      "schemaVersion": "2.0.0"
                    }
                  },
                  {
                    "classification": "restricted",
                    "definition": "Maximum value is the money component carried within Authority envelope Allowed actions; its classification and authority inherit from the owning field contract.",
                    "id": "maximum-value",
                    "label": "Maximum value",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "allowed-actions",
                      "kind": "inherited-field"
                    },
                    "type": "money",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "money-value",
                      "schemaVersion": "2.0.0"
                    }
                  },
                  {
                    "classification": "restricted",
                    "definition": "Risk levels is the set carried within Authority envelope Allowed actions; its owning field governs allowed values and interpretation.",
                    "id": "risk-levels",
                    "label": "Risk levels",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "allowed-actions",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Required evidence, freshness, deterministic policy, confidence vocabulary, novelty, separation of duties, sample and critic conditions.",
            "exchangeScope": "internal",
            "id": "guard-conditions",
            "introducedIn": "1.0.0",
            "label": "Guard conditions",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Required evidence types is the set carried within Authority envelope Guard conditions; its owning field governs allowed values and interpretation.",
                    "id": "required-evidence-types",
                    "label": "Required evidence types",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "guard-conditions",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Freshness rule ID is the string component carried within Authority envelope Guard conditions; its classification and authority inherit from the owning field contract.",
                    "id": "freshness-rule-id",
                    "label": "Freshness rule ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "guard-conditions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Policy version ID links this structured value to governed policy version record through policy-version-id within Authority envelope Guard conditions.",
                    "id": "policy-version-id",
                    "label": "Policy version ID",
                    "nullable": false,
                    "referenceEntityId": "policy-version",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links policy version id to governed policy version record through the canonical policy-version-id field.",
                      "id": "authority-envelope-guard-conditions-policy-version-id",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "policy-version-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "guard-conditions",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Confidence rule ID is the string component carried within Authority envelope Guard conditions; its classification and authority inherit from the owning field contract.",
                    "id": "confidence-rule-id",
                    "label": "Confidence rule ID",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "guard-conditions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Novelty rule ID is the string component carried within Authority envelope Guard conditions; its classification and authority inherit from the owning field contract.",
                    "id": "novelty-rule-id",
                    "label": "Novelty rule ID",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "guard-conditions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Separation of duties rule ID is the string component carried within Authority envelope Guard conditions; its classification and authority inherit from the owning field contract.",
                    "id": "separation-of-duties-rule-id",
                    "label": "Separation of duties rule ID",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "guard-conditions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Sampling rule ID is the string component carried within Authority envelope Guard conditions; its classification and authority inherit from the owning field contract.",
                    "id": "sampling-rule-id",
                    "label": "Sampling rule ID",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "guard-conditions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Critic rule ID is the string component carried within Authority envelope Guard conditions; its classification and authority inherit from the owning field contract.",
                    "id": "critic-rule-id",
                    "label": "Critic rule ID",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "guard-conditions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "First instant at which the grant may be used.",
            "exchangeScope": "mapped",
            "format": "ISO 8601 UTC",
            "id": "effective-from",
            "introducedIn": "1.0.0",
            "label": "Effective from",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "conceptId": "date-time-value",
                "coverage": "semantic",
                "direction": "outbound",
                "exchangeScope": "edge-interchange",
                "mappingKind": "value-format",
                "path": "effectiveFrom",
                "releaseId": "iso-8601-1-2019",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-8601",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Mandatory expiry instant requiring renewal or re-evaluation.",
            "exchangeScope": "mapped",
            "format": "ISO 8601 UTC",
            "id": "expires-at",
            "introducedIn": "1.0.0",
            "label": "Expires at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "conceptId": "date-time-value",
                "coverage": "semantic",
                "direction": "outbound",
                "exchangeScope": "edge-interchange",
                "mappingKind": "value-format",
                "path": "expiresAt",
                "releaseId": "iso-8601-1-2019",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-8601",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Governed role accountable for granting the envelope when authority is role-based.",
            "exchangeScope": "unmapped",
            "id": "grantor-role-id",
            "introducedIn": "4.0.0",
            "label": "Grantor role ID",
            "nullable": true,
            "referenceEntityId": "role",
            "required": false,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "authority-envelope",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "authority-envelope-id"
            ],
            "id": "authority-envelope-primary",
            "introducedIn": "1.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "workblock-id",
              "lifecycle-state"
            ],
            "id": "authority-envelope-by-workblock-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "grantor-person-id",
              "lifecycle-state"
            ],
            "id": "authority-envelope-by-grantor-person-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "control",
        "label": "Authority envelope",
        "lifecycle": [
          "draft",
          "active",
          "suspended",
          "expired",
          "revoked",
          "superseded"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "registry-governance-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "platform-services-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Authority envelopes",
        "primaryKey": "authority-envelope-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Accountable grantor of the envelope.",
            "id": "authority-envelope-governed-by-person-authority-grantor",
            "introducedIn": "1.0.0",
            "predicate": "governed-by",
            "qualifiedId": "authority-envelope-governed-by-person-authority-grantor",
            "required": true,
            "sourceFieldId": "grantor-person-id",
            "targetEntityId": "person",
            "targetFieldId": "person-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Policy version authorising the grant.",
            "id": "authority-envelope-governed-by-policy-version-authority-policy-version",
            "introducedIn": "1.0.0",
            "predicate": "governed-by",
            "qualifiedId": "authority-envelope-governed-by-policy-version-authority-policy-version",
            "required": true,
            "sourceFieldId": "policy-version-id",
            "targetEntityId": "policy-version",
            "targetFieldId": "policy-version-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Role accountable for granting the authority envelope.",
            "id": "authority-envelope-assigned-to-role-authority-grantor-role",
            "introducedIn": "4.0.0",
            "predicate": "assigned-to",
            "qualifiedId": "authority-envelope-assigned-to-role-authority-grantor-role",
            "required": false,
            "sourceFieldId": "grantor-role-id",
            "targetEntityId": "role",
            "targetFieldId": "role-id"
          }
        ],
        "retentionClass": "policy",
        "searchTerms": [
          "grant",
          "autonomy",
          "permission",
          "policy bound",
          "threshold",
          "kill switch",
          "sample rate"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "May this named action be committed on this record without per-item approval?",
              "Which tools, evidence and monitoring conditions does the grant require?"
            ],
            "retrievalTerms": [
              "authority",
              "grant",
              "approval threshold",
              "delegated action"
            ],
            "usage": "Check the governing authority-envelope before committing any action without per-item approval; actions outside the envelope must raise an exception rather than proceed."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "autonomy grant",
              "delegation boundary",
              "mandate"
            ],
            "concept": "bounded-action-grant"
          }
        },
        "sourceSystemRoleIds": [
          "identity-authority",
          "system-of-record"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "identity-authority"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [],
        "definition": "One appended, typed fact recording which actor may take which action class over which governed record set, on what basis, under whose authority and until when. Inside the governed record set no covering grant is a denial: there are no negative grants, and the exception path is a new grant. Grants are append-only tenant records; change is supersession, and expiry, usage exhaustion and revocation are recorded facts on the record rather than mutation. The declared lifecycle therefore holds only the words a writer stamps on an appended row of the same grant: active at commitment, revoked when the revocation fact lands, and expired when the bounded purge records the lapse. Standing that only a second record or arithmetic establishes stays a derived read rather than a lifecycle state: supersession is read from the successor grant's supersedes-data-grant-id, because an append-only predecessor is never re-stamped, and cap exhaustion is read over usage-cap and usage-count, because those two facts already carry it. A grant is never proposed: the ask is a data-access-request carrying its own lifecycle, which keeps the proposal distinct from the commitment that creates the grant. An effective-dated assignment re-stamped in place, such as a person-role assignment, may carry proposed and superseded as written states; an append-only ledger applies one test to every word it declares.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "internal",
            "definition": "Stable canonical identifier for the grant fact, independent of the authorization tuples it compiles to.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "data-grant-id",
            "introducedIn": "4.6.0",
            "label": "Data grant ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Typed person or role reference holding the grant. An agent holds a grant like anyone else, bound through the role its charter names, and never exceeds that charter envelope.",
            "exchangeScope": "internal",
            "id": "actor-ref",
            "introducedIn": "4.6.0",
            "label": "Actor",
            "nullable": false,
            "referenceTargetEntityIds": [
              "person",
              "role"
            ],
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "record-reference-value",
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Single action class the grant permits, from the closed vocabulary. Approve never implies commit, correct is audited amendment rather than delete, export is always named because it leaves the enforcement boundary, and derive is the system-consumer class that can never carry broader scope or field class than the narrowest view grant of the audience reading the derived surface.",
            "enumValues": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct",
              "export",
              "administer",
              "delete",
              "derive"
            ],
            "exchangeScope": "internal",
            "id": "action-class",
            "introducedIn": "4.6.0",
            "label": "Action class",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Governed record type the grant reaches, named by its stable GroundWorks entity ID.",
            "exchangeScope": "internal",
            "format": "GroundWorks entity ID",
            "id": "record-type-id",
            "introducedIn": "4.6.0",
            "label": "Record type ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Typed scope predicate bounding the records the grant reaches, taken from the closed per-record-type list.",
            "exchangeScope": "internal",
            "id": "scope",
            "introducedIn": "4.6.0",
            "label": "Scope",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "access-scope-value",
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Highest field sensitivity classes the grant reaches. Fields above the named classes are returned withheld as a first-class rendered state, never blanked or silently dropped.",
            "enumValues": [
              "public",
              "internal",
              "confidential",
              "restricted",
              "personal"
            ],
            "exchangeScope": "internal",
            "id": "field-classes",
            "introducedIn": "4.6.0",
            "label": "Field classes",
            "listSemantics": "set",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string-list"
          },
          {
            "classification": "internal",
            "definition": "Declared purpose the grant is limited to; a personal field class additionally binds the reader to this purpose.",
            "enumValues": [
              "operate",
              "analyse",
              "export",
              "learn",
              "support"
            ],
            "exchangeScope": "internal",
            "id": "purpose",
            "introducedIn": "4.6.0",
            "label": "Purpose",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "What exercising the grant lets happen, stated so a reviewer can weigh it without reading the policy.",
            "exchangeScope": "internal",
            "id": "consequence",
            "introducedIn": "4.6.0",
            "label": "Consequence",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "text"
          },
          {
            "classification": "internal",
            "definition": "Typed authority level of the grant, from one to five. A grant is never module-wide, and level three or above requires an expiry.",
            "exchangeScope": "internal",
            "format": "integer 1-5",
            "id": "authority-level",
            "introducedIn": "4.6.0",
            "label": "Authority level",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "integer"
          },
          {
            "classification": "internal",
            "definition": "Governing basis the grant stands on: the policy, role assignment, authority envelope or recorded decision that justifies it.",
            "exchangeScope": "internal",
            "id": "basis",
            "introducedIn": "4.6.0",
            "label": "Basis",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "text"
          },
          {
            "classification": "internal",
            "definition": "Typed person or role reference that issued the grant. The requester is never the decider.",
            "exchangeScope": "internal",
            "id": "issued-by-ref",
            "introducedIn": "4.6.0",
            "label": "Issued by",
            "nullable": false,
            "referenceTargetEntityIds": [
              "person",
              "role"
            ],
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "record-reference-value",
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "UTC timestamp at which the grant became effective.",
            "exchangeScope": "internal",
            "format": "ISO 8601 UTC",
            "id": "issued-at",
            "introducedIn": "4.6.0",
            "label": "Issued at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "UTC timestamp at which the grant expires. Required at authority level three or above; expired grants are removed by a bounded, idempotent, evidence-bearing purge, oldest first.",
            "exchangeScope": "internal",
            "format": "ISO 8601 UTC",
            "id": "expires-at",
            "introducedIn": "4.6.0",
            "label": "Expires at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Maximum number of exercises the grant permits. A one-use elevation is a cap of one, consumed by compare-and-set at first exercise.",
            "exchangeScope": "internal",
            "format": "positive integer",
            "id": "usage-cap",
            "introducedIn": "4.6.0",
            "label": "Usage cap",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "integer"
          },
          {
            "classification": "internal",
            "definition": "Exercises recorded against the grant. With a usage cap present, a count that has reached the cap derives the exhausted read; the grant remains present so a replay can never resurrect it.",
            "exchangeScope": "internal",
            "format": "non-negative integer",
            "id": "usage-count",
            "introducedIn": "4.6.0",
            "label": "Usage count",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "integer"
          },
          {
            "classification": "internal",
            "definition": "Typed person or role reference that revoked the grant. Revocation is never a negative grant: it is tuple deletion at the authority event plus this fact, and the fact wins any evaluation race.",
            "exchangeScope": "internal",
            "id": "revoked-by-ref",
            "introducedIn": "4.6.0",
            "label": "Revoked by",
            "nullable": true,
            "referenceTargetEntityIds": [
              "person",
              "role"
            ],
            "required": false,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "record-reference-value",
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "UTC timestamp of the authority event that revoked the grant.",
            "exchangeScope": "internal",
            "format": "ISO 8601 UTC",
            "id": "revoked-at",
            "introducedIn": "4.6.0",
            "label": "Revoked at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Recorded reason for the revocation, so a revoked grant reads as a named act rather than a disappearance.",
            "exchangeScope": "internal",
            "id": "revocation-rationale",
            "introducedIn": "4.6.0",
            "label": "Revocation rationale",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "text"
          },
          {
            "classification": "internal",
            "definition": "Predecessor grant this record supersedes. Correction creates a successor grant and preserves the predecessor chain; it never overwrites, and the predecessor's superseded standing is read from this reference.",
            "exchangeScope": "internal",
            "id": "supersedes-data-grant-id",
            "introducedIn": "4.6.0",
            "label": "Supersedes data grant ID",
            "nullable": true,
            "referenceEntityId": "data-grant",
            "required": false,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Authorization relationship tuples this grant compiled to, so the consistency check can surface a tuple whose fact says revoked or expired, and an annotated-class tuple with no grant record, as audit defects. Deployment binding: never rendered on a framework surface.",
            "exchangeScope": "internal",
            "id": "relation-tuple-keys",
            "introducedIn": "4.6.0",
            "label": "Relation tuple keys",
            "listSemantics": "set",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string-list"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "data-grant",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "data-grant-id"
            ],
            "id": "data-grant-primary",
            "introducedIn": "4.6.0",
            "unique": true
          },
          {
            "fieldIds": [
              "record-type-id",
              "action-class"
            ],
            "id": "data-grant-by-record-type-id-and-action-class",
            "introducedIn": "4.6.0",
            "unique": false
          },
          {
            "fieldIds": [
              "supersedes-data-grant-id"
            ],
            "id": "data-grant-by-supersedes-data-grant-id",
            "introducedIn": "4.6.0",
            "unique": false
          },
          {
            "fieldIds": [
              "expires-at"
            ],
            "id": "data-grant-by-expires-at",
            "introducedIn": "4.6.0",
            "unique": false
          }
        ],
        "introducedIn": "4.6.0",
        "kind": "assignment",
        "label": "Data grant",
        "lifecycle": [
          "active",
          "expired",
          "revoked"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "registry-governance-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "platform-services-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Data grants",
        "primaryKey": "data-grant-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Predecessor grant superseded by this record, preserving the correction chain.",
            "id": "data-grant-supersedes-data-grant-data-grant-predecessor",
            "introducedIn": "4.6.0",
            "predicate": "supersedes",
            "qualifiedId": "data-grant-supersedes-data-grant-data-grant-predecessor",
            "required": false,
            "sourceFieldId": "supersedes-data-grant-id",
            "targetEntityId": "data-grant",
            "targetFieldId": "data-grant-id"
          }
        ],
        "retentionClass": "policy",
        "searchTerms": [
          "data grant",
          "access grant",
          "action class",
          "field class ceiling",
          "authority level",
          "grant expiry",
          "grant revocation",
          "usage cap",
          "deny by default"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Which record types, scopes and field classes may this actor see, and for what purpose?",
              "Was this derived answer computed under a scope no narrower than its reader's grant?",
              "Which records were excluded from this result by scope rather than by filter?"
            ],
            "retrievalTerms": [
              "scope",
              "field class",
              "withheld",
              "purpose limitation",
              "derive",
              "usage cap",
              "role fingerprint"
            ],
            "usage": "Read scope, field-classes and purpose together before answering from any scoped record set, and treat a withheld field as an answerable rendered state rather than missing data. Before serving a derived surface to an audience, check the derive rule carried on action-class against that audience's own view grants, and state the scope a derived answer was computed under."
          },
          "introducedIn": "4.8.0",
          "semanticLabel": {
            "aliases": [
              "access grant",
              "scope contract",
              "role scope",
              "data permission"
            ],
            "concept": "scoped-access-grant",
            "doNotConfuseWith": [
              {
                "distinction": "A data-access-request is the reviewed ask, bound by request-hash so a stale review is refused; a data-grant is the issued, scoped, expiring permission that results. A request is never evidence that access exists.",
                "targetEntityId": "data-access-request"
              },
              {
                "distinction": "An authority-envelope bounds what an actor may commit; a data-grant bounds what an actor may see. Neither implies the other.",
                "targetEntityId": "authority-envelope"
              },
              {
                "distinction": "A role is a governed definition of a position; a data-grant is the scope actually issued against it. Role holding is asserted by person-role-assignment and never inferred from a grant.",
                "targetEntityId": "role"
              }
            ]
          }
        },
        "sourceSystemRoleIds": [
          "identity-authority"
        ],
        "storageClass": "tenant-record",
        "version": "1.1.0",
        "writebackSystemRoleIds": [
          "identity-authority"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [],
        "definition": "A recorded request for a data grant, naming the requester, the terms asked for, the purpose and the justification. The requester is never the decider: the request is routed to the data-owner role for the record type, and the decision is a recorded fact rather than an edit. The composed envelope lifecycle carries the request state, so the record keeps no second status carrier.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "internal",
            "definition": "Stable canonical identifier for the request.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "data-access-request-id",
            "introducedIn": "4.6.0",
            "label": "Data access request ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Typed person or role reference asking for the grant. The requester can never decide their own request.",
            "exchangeScope": "internal",
            "id": "requester-ref",
            "introducedIn": "4.6.0",
            "label": "Requester",
            "nullable": false,
            "referenceTargetEntityIds": [
              "person",
              "role"
            ],
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "record-reference-value",
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Action class asked for, from the same closed vocabulary the grant uses.",
            "enumValues": [
              "view",
              "create",
              "propose",
              "approve",
              "commit",
              "correct",
              "export",
              "administer",
              "delete",
              "derive"
            ],
            "exchangeScope": "internal",
            "id": "requested-action-class",
            "introducedIn": "4.6.0",
            "label": "Requested action class",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Governed record type the request reaches, named by its stable GroundWorks entity ID; its data-owner role decides the request.",
            "exchangeScope": "internal",
            "format": "GroundWorks entity ID",
            "id": "requested-record-type-id",
            "introducedIn": "4.6.0",
            "label": "Requested record type ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Typed scope predicate asked for, taken from the same closed per-record-type list the grant uses.",
            "exchangeScope": "internal",
            "id": "requested-scope",
            "introducedIn": "4.6.0",
            "label": "Requested scope",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "access-scope-value",
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Highest field sensitivity classes asked for. A decision may approve a narrower set than the one requested.",
            "enumValues": [
              "public",
              "internal",
              "confidential",
              "restricted",
              "personal"
            ],
            "exchangeScope": "internal",
            "id": "requested-field-classes",
            "introducedIn": "4.6.0",
            "label": "Requested field classes",
            "listSemantics": "set",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string-list"
          },
          {
            "classification": "internal",
            "definition": "Declared purpose the access is asked for, carried onto the grant and binding the reader when a personal field class is reached.",
            "enumValues": [
              "operate",
              "analyse",
              "export",
              "learn",
              "support"
            ],
            "exchangeScope": "internal",
            "id": "purpose",
            "introducedIn": "4.6.0",
            "label": "Purpose",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Requester's stated reason, recorded so the decider weighs a case rather than a name.",
            "exchangeScope": "internal",
            "id": "justification",
            "introducedIn": "4.6.0",
            "label": "Justification",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "text"
          },
          {
            "classification": "internal",
            "definition": "Typed person or role reference holding the decision: the data-owner role for the requested record type, never whoever can edit the Workblock.",
            "exchangeScope": "internal",
            "id": "assignee-ref",
            "introducedIn": "4.6.0",
            "label": "Assignee",
            "nullable": true,
            "referenceTargetEntityIds": [
              "person",
              "role"
            ],
            "required": false,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "record-reference-value",
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Content hash binding the requested terms, so a decision commits the terms that were reviewed and a stale review is refused rather than silently re-scoped.",
            "exchangeScope": "internal",
            "format": "sha-256 hex digest",
            "id": "request-hash",
            "introducedIn": "4.6.0",
            "label": "Request hash",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Typed person or role reference that decided the request, recorded as a fact rather than an edit.",
            "exchangeScope": "internal",
            "id": "decided-by-ref",
            "introducedIn": "4.6.0",
            "label": "Decided by",
            "nullable": true,
            "referenceTargetEntityIds": [
              "person",
              "role"
            ],
            "required": false,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "record-reference-value",
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "UTC timestamp at which the request reached its terminal state.",
            "exchangeScope": "internal",
            "format": "ISO 8601 UTC",
            "id": "decided-at",
            "introducedIn": "4.6.0",
            "label": "Decided at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Grant the approved request produced. Absent while the request is pending and on every terminal state other than approved.",
            "exchangeScope": "internal",
            "id": "data-grant-id",
            "introducedIn": "4.6.0",
            "label": "Data grant ID",
            "nullable": true,
            "referenceEntityId": "data-grant",
            "required": false,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "data-access-request",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "data-access-request-id"
            ],
            "id": "data-access-request-primary",
            "introducedIn": "4.6.0",
            "unique": true
          },
          {
            "fieldIds": [
              "requested-record-type-id"
            ],
            "id": "data-access-request-by-requested-record-type-id",
            "introducedIn": "4.6.0",
            "unique": false
          },
          {
            "fieldIds": [
              "request-hash"
            ],
            "id": "data-access-request-by-request-hash",
            "introducedIn": "4.6.0",
            "unique": false
          },
          {
            "fieldIds": [
              "data-grant-id"
            ],
            "id": "data-access-request-by-data-grant-id",
            "introducedIn": "4.6.0",
            "unique": false
          }
        ],
        "introducedIn": "4.6.0",
        "kind": "case",
        "label": "Data access request",
        "lifecycle": [
          "pending",
          "approved",
          "declined",
          "withdrawn",
          "expired"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "registry-governance-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "platform-services-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Data access requests",
        "primaryKey": "data-access-request-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Grant issued by the approved decision on this request.",
            "id": "data-access-request-references-data-grant-data-access-request-issued-grant",
            "introducedIn": "4.6.0",
            "predicate": "references",
            "qualifiedId": "data-access-request-references-data-grant-data-access-request-issued-grant",
            "required": false,
            "sourceFieldId": "data-grant-id",
            "targetEntityId": "data-grant",
            "targetFieldId": "data-grant-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "data access request",
          "access request",
          "grant request",
          "requester is never the decider",
          "data owner",
          "purpose",
          "justification"
        ],
        "sourceSystemRoleIds": [
          "identity-authority"
        ],
        "storageClass": "tenant-record",
        "version": "1.0.0",
        "writebackSystemRoleIds": [
          "identity-authority"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "category-opportunity-radar",
          "category-strategy-orchestrator",
          "contract-authoring-review",
          "demand-orchestration",
          "intelligent-intake",
          "invoice-exception-triage",
          "invoice-intake-match",
          "payment-readiness",
          "policy-guidance",
          "policy-rule-lifecycle",
          "procurement-service-catalogue",
          "purchase-order-exception",
          "renewal-change-compliance",
          "requisition-policy-routing",
          "savings-initiative",
          "sourcing-event",
          "sourcing-pipeline-discovery",
          "supplier-innovation-pipeline",
          "supplier-performance-monitor-correct",
          "supplier-performance-review",
          "supplier-relationship-joint-value",
          "supplier-remediation-exit",
          "supplier-segmentation-governance",
          "third-party-risk-review",
          "value-opportunity-baseline"
        ],
        "definition": "A complete proposed mutation or external action that remains structurally distinct from a committed result.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable proposal identifier.",
            "exchangeScope": "internal",
            "id": "action-proposal-id",
            "introducedIn": "1.0.0",
            "label": "Action proposal ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Workblock that produced the proposal.",
            "exchangeScope": "internal",
            "id": "workblock-id",
            "introducedIn": "1.0.0",
            "label": "Workblock ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Typed verb and target semantic class.",
            "exchangeScope": "internal",
            "id": "action-class",
            "introducedIn": "1.0.0",
            "label": "Action class",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Typed target entity and record key.",
            "exchangeScope": "internal",
            "id": "subject-ref",
            "introducedIn": "1.0.0",
            "label": "Subject reference",
            "nullable": false,
            "referenceTargetEntityIds": [
              "action-proposal",
              "audit-event",
              "authority-envelope",
              "award-scenario",
              "budget",
              "buy-timing-mandate",
              "business-event",
              "business-unit",
              "buying-request",
              "catalogue-line",
              "category",
              "category-dimension-assignment",
              "category-opportunity",
              "category-strategy",
              "clause-deviation",
              "clause-library-entry",
              "committed-action",
              "contract",
              "contract-approval",
              "contract-change",
              "contract-compliance-finding",
              "contract-entitlement",
              "contract-intake",
              "contract-obligation",
              "contract-template",
              "contract-version",
              "decision",
              "demand-case",
              "demand-portfolio",
              "enriched-request",
              "evaluation-result",
              "evidence-item",
              "exception",
              "intake-request",
              "integration-state",
              "invoice",
              "invoice-exception",
              "invoice-line",
              "invoice-match-assessment",
              "item-service",
              "job",
              "learning-example",
              "negotiation-session",
              "order-line",
              "order-response",
              "party",
              "payment-execution-status",
              "payment-instruction",
              "payment-readiness-assessment",
              "person",
              "person-role-assignment",
              "policy",
              "policy-change-impact",
              "policy-guidance-result",
              "policy-rule-release",
              "policy-version",
              "procurement-service-offering",
              "purchase-order",
              "purchase-order-exception",
              "receipt",
              "receipt-line",
              "registry-release",
              "requisition",
              "requisition-line",
              "return-claim",
              "role",
              "savings-initiative-record",
              "service-entry-sheet",
              "shipment",
              "source-record-reference",
              "sourcing-event-record",
              "sourcing-opportunity",
              "spend-classification-decision",
              "spend-record",
              "supplier-innovation-case",
              "supplier-invoice-resolution",
              "supplier-joint-value-plan",
              "supplier-master-change",
              "supplier-offboarding-case",
              "supplier-onboarding-case",
              "supplier-performance-observation",
              "supplier-performance-review-record",
              "supplier-performance-signal",
              "supplier-profile",
              "supplier-qualification",
              "supplier-remediation-action",
              "supplier-response",
              "supplier-risk-assessment",
              "supplier-risk-case",
              "supplier-risk-signal",
              "supplier-segment-assignment",
              "supplier-tier-link",
              "tactical-sourcing-case",
              "tail-spend-evaluation",
              "tail-spend-rule",
              "taxonomy-version",
              "value-leakage-finding",
              "value-opportunity-baseline",
              "value-portfolio-forecast",
              "value-realization-attribution",
              "work-moment-record"
            ],
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "record-reference-value",
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Stable business-module or platform-service owner ID that submitted a cross-owner handoff; it does not identify or authorise the acting person.",
            "exchangeScope": "internal",
            "id": "sending-owner-id",
            "introducedIn": "4.3.0",
            "label": "Sending owner ID",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Stable business-module or platform-service owner ID asked to accept, reject or redirect the requested outcome; delivery alone does not satisfy this owner acceptance.",
            "exchangeScope": "internal",
            "id": "receiving-owner-id",
            "introducedIn": "4.3.0",
            "label": "Receiving owner ID",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Exact typed source record and record version from which a cross-owner request was made; handoff writers must populate record-version even though the reusable reference schema permits an unversioned point read.",
            "exchangeScope": "internal",
            "id": "source-record-ref",
            "introducedIn": "4.3.0",
            "label": "Source record reference",
            "nullable": true,
            "referenceTargetEntityIds": [
              "action-proposal",
              "audit-event",
              "authority-envelope",
              "award-scenario",
              "budget",
              "business-event",
              "business-unit",
              "buy-timing-mandate",
              "buying-request",
              "catalogue-line",
              "category",
              "category-dimension-assignment",
              "category-opportunity",
              "category-strategy",
              "clause-deviation",
              "clause-library-entry",
              "committed-action",
              "contract",
              "contract-approval",
              "contract-change",
              "contract-compliance-finding",
              "contract-entitlement",
              "contract-intake",
              "contract-obligation",
              "contract-template",
              "contract-version",
              "decision",
              "demand-case",
              "demand-portfolio",
              "enriched-request",
              "evaluation-result",
              "evidence-item",
              "exception",
              "intake-request",
              "integration-state",
              "invoice",
              "invoice-exception",
              "invoice-line",
              "invoice-match-assessment",
              "item-service",
              "job",
              "learning-example",
              "negotiation-session",
              "order-line",
              "order-response",
              "party",
              "payment-execution-status",
              "payment-instruction",
              "payment-readiness-assessment",
              "person",
              "person-role-assignment",
              "policy",
              "policy-change-impact",
              "policy-guidance-result",
              "policy-rule-release",
              "policy-version",
              "procurement-service-offering",
              "purchase-order",
              "purchase-order-exception",
              "receipt",
              "receipt-line",
              "registry-release",
              "requisition",
              "requisition-line",
              "return-claim",
              "role",
              "savings-initiative-record",
              "service-entry-sheet",
              "shipment",
              "source-record-reference",
              "sourcing-event-record",
              "sourcing-opportunity",
              "spend-classification-decision",
              "spend-record",
              "supplier-innovation-case",
              "supplier-invoice-resolution",
              "supplier-joint-value-plan",
              "supplier-master-change",
              "supplier-offboarding-case",
              "supplier-onboarding-case",
              "supplier-performance-observation",
              "supplier-performance-review-record",
              "supplier-performance-signal",
              "supplier-profile",
              "supplier-qualification",
              "supplier-remediation-action",
              "supplier-response",
              "supplier-risk-assessment",
              "supplier-risk-case",
              "supplier-risk-signal",
              "supplier-segment-assignment",
              "supplier-tier-link",
              "tactical-sourcing-case",
              "tail-spend-evaluation",
              "tail-spend-rule",
              "taxonomy-version",
              "value-leakage-finding",
              "value-opportunity-baseline",
              "value-portfolio-forecast",
              "value-realization-attribution",
              "work-moment-record"
            ],
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "record-reference-value",
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Exact typed receiving-owner record and record version to which a cross-owner request applies; a missing target is distinct from a known record at an unknown version.",
            "exchangeScope": "internal",
            "id": "target-record-ref",
            "introducedIn": "4.3.0",
            "label": "Target record reference",
            "nullable": true,
            "referenceTargetEntityIds": [
              "action-proposal",
              "audit-event",
              "authority-envelope",
              "award-scenario",
              "budget",
              "business-event",
              "business-unit",
              "buy-timing-mandate",
              "buying-request",
              "catalogue-line",
              "category",
              "category-dimension-assignment",
              "category-opportunity",
              "category-strategy",
              "clause-deviation",
              "clause-library-entry",
              "committed-action",
              "contract",
              "contract-approval",
              "contract-change",
              "contract-compliance-finding",
              "contract-entitlement",
              "contract-intake",
              "contract-obligation",
              "contract-template",
              "contract-version",
              "decision",
              "demand-case",
              "demand-portfolio",
              "enriched-request",
              "evaluation-result",
              "evidence-item",
              "exception",
              "intake-request",
              "integration-state",
              "invoice",
              "invoice-exception",
              "invoice-line",
              "invoice-match-assessment",
              "item-service",
              "job",
              "learning-example",
              "negotiation-session",
              "order-line",
              "order-response",
              "party",
              "payment-execution-status",
              "payment-instruction",
              "payment-readiness-assessment",
              "person",
              "person-role-assignment",
              "policy",
              "policy-change-impact",
              "policy-guidance-result",
              "policy-rule-release",
              "policy-version",
              "procurement-service-offering",
              "purchase-order",
              "purchase-order-exception",
              "receipt",
              "receipt-line",
              "registry-release",
              "requisition",
              "requisition-line",
              "return-claim",
              "role",
              "savings-initiative-record",
              "service-entry-sheet",
              "shipment",
              "source-record-reference",
              "sourcing-event-record",
              "sourcing-opportunity",
              "spend-classification-decision",
              "spend-record",
              "supplier-innovation-case",
              "supplier-invoice-resolution",
              "supplier-joint-value-plan",
              "supplier-master-change",
              "supplier-offboarding-case",
              "supplier-onboarding-case",
              "supplier-performance-observation",
              "supplier-performance-review-record",
              "supplier-performance-signal",
              "supplier-profile",
              "supplier-qualification",
              "supplier-remediation-action",
              "supplier-response",
              "supplier-risk-assessment",
              "supplier-risk-case",
              "supplier-risk-signal",
              "supplier-segment-assignment",
              "supplier-tier-link",
              "tactical-sourcing-case",
              "tail-spend-evaluation",
              "tail-spend-rule",
              "taxonomy-version",
              "value-leakage-finding",
              "value-opportunity-baseline",
              "value-portfolio-forecast",
              "value-realization-attribution",
              "work-moment-record"
            ],
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "record-reference-value",
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Observable outcome the receiving owner is asked to accept responsibility for; it is neither an instruction to commit nor proof of completion.",
            "exchangeScope": "internal",
            "id": "requested-outcome",
            "introducedIn": "4.3.0",
            "label": "Requested outcome",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "text"
          },
          {
            "classification": "confidential",
            "definition": "Immutable version of the evidence set reviewed when the cross-owner request was submitted.",
            "exchangeScope": "internal",
            "id": "evidence-version",
            "introducedIn": "4.3.0",
            "label": "Evidence version",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "UTC deadline after which the receiving owner must explicitly renew, reject, redirect or allow the request to expire.",
            "exchangeScope": "internal",
            "format": "ISO 8601 UTC",
            "id": "expires-at",
            "introducedIn": "4.3.0",
            "label": "Expires at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Positive delivery attempt number for the same idempotent cross-owner request; retries do not create a new business proposal.",
            "exchangeScope": "internal",
            "format": "positive integer",
            "id": "handoff-attempt",
            "introducedIn": "4.3.0",
            "label": "Handoff attempt",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "integer"
          },
          {
            "classification": "restricted",
            "definition": "Stable key shared by retries of the same source version, target version, receiving owner and requested outcome.",
            "exchangeScope": "internal",
            "id": "handoff-idempotency-key",
            "introducedIn": "4.3.0",
            "label": "Handoff idempotency key",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Receiving-owner decision that accepts, rejects, redirects, expires or reopens the handoff; message delivery remains a separate business-event fact.",
            "exchangeScope": "internal",
            "id": "acknowledgement-decision-id",
            "introducedIn": "4.3.0",
            "label": "Acknowledgement decision ID",
            "nullable": true,
            "referenceEntityId": "decision",
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Closed or expired predecessor whose unresolved requested outcome caused this new proposal to reopen the handoff without rewriting history.",
            "exchangeScope": "internal",
            "id": "reopened-from-action-proposal-id",
            "introducedIn": "4.3.0",
            "label": "Reopened from action proposal ID",
            "nullable": true,
            "referenceEntityId": "action-proposal",
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Later proposal that supersedes, redirects or reopens this request while retaining this proposal as immutable decision evidence.",
            "exchangeScope": "internal",
            "id": "successor-action-proposal-id",
            "introducedIn": "4.3.0",
            "label": "Successor action proposal ID",
            "nullable": true,
            "referenceEntityId": "action-proposal",
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Envelope evaluated for the named action before policy-bounded or human-authorised execution.",
            "exchangeScope": "internal",
            "id": "authority-envelope-id",
            "introducedIn": "1.0.0",
            "label": "Authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Evidence set supporting the action.",
            "exchangeScope": "internal",
            "id": "evidence-item-ids",
            "introducedIn": "1.0.0",
            "label": "Evidence item IDs",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "restricted",
            "definition": "Typed diff or operation payload below the commitment boundary.",
            "exchangeScope": "internal",
            "id": "proposed-payload",
            "introducedIn": "1.0.0",
            "label": "Proposed payload",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Operation ID is the string component carried within Action proposal Proposed payload; its classification and authority inherit from the owning field contract.",
                    "id": "operation-id",
                    "label": "Operation ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-payload",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Operation is the string component carried within Action proposal Proposed payload; its classification and authority inherit from the owning field contract.",
                    "id": "operation",
                    "label": "Operation",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-payload",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Field path is the string component carried within Action proposal Proposed payload; its classification and authority inherit from the owning field contract.",
                    "id": "field-path",
                    "label": "Field path",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-payload",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Previous value is the string component carried within Action proposal Proposed payload; its classification and authority inherit from the owning field contract.",
                    "id": "previous-value",
                    "label": "Previous value",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-payload",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Proposed value is the string component carried within Action proposal Proposed payload; its classification and authority inherit from the owning field contract.",
                    "id": "proposed-value",
                    "label": "Proposed value",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-payload",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence item ids links this structured value to governed evidence items through evidence-item-id within Action proposal Proposed payload.",
                    "id": "evidence-item-ids",
                    "label": "Evidence item ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links evidence item ids to governed evidence items through the canonical evidence-item-id field.",
                      "id": "action-proposal-proposed-payload-evidence-item-ids",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-payload",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Reversible is the boolean component carried within Action proposal Proposed payload; its classification and authority inherit from the owning field contract.",
                    "id": "reversible",
                    "label": "Reversible",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-payload",
                      "kind": "inherited-field"
                    },
                    "type": "boolean"
                  }
                ],
                "uniqueBy": [
                  "operation-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "UTC creation timestamp.",
            "exchangeScope": "mapped",
            "format": "ISO 8601 UTC",
            "id": "created-at",
            "introducedIn": "1.0.0",
            "label": "Created at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "conceptId": "date-time-value",
                "coverage": "semantic",
                "direction": "outbound",
                "exchangeScope": "edge-interchange",
                "mappingKind": "value-format",
                "path": "createdAt",
                "releaseId": "iso-8601-1-2019",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-8601",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Shared governed decision record that carries authority, rationale and evidence for this domain decision.",
            "exchangeScope": "unmapped",
            "id": "governance-decision-id",
            "introducedIn": "4.0.0",
            "label": "Governance decision ID",
            "nullable": true,
            "referenceEntityId": "decision",
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "action-proposal",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "action-proposal-id"
            ],
            "id": "action-proposal-primary",
            "introducedIn": "1.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "workblock-id",
              "lifecycle-state"
            ],
            "id": "action-proposal-by-workblock-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "subject-ref",
              "lifecycle-state"
            ],
            "id": "action-proposal-by-subject-reference-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "sending-owner-id",
              "lifecycle-state"
            ],
            "id": "action-proposal-by-sending-owner-and-status",
            "introducedIn": "4.3.0",
            "unique": false
          },
          {
            "fieldIds": [
              "receiving-owner-id",
              "lifecycle-state"
            ],
            "id": "action-proposal-by-receiving-owner-and-status",
            "introducedIn": "4.3.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "decision",
        "label": "Action proposal",
        "lifecycle": [
          "draft",
          "proposed",
          "stale",
          "authorised",
          "accepted-for-execution",
          "rejected",
          "withdrawn",
          "superseded"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "shared-ledger-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "platform-services-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Action proposals",
        "primaryKey": "action-proposal-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Envelope considered at the commitment boundary.",
            "id": "action-proposal-governed-by-authority-envelope-proposal-authority-envelope",
            "introducedIn": "1.0.0",
            "predicate": "governed-by",
            "qualifiedId": "action-proposal-governed-by-authority-envelope-proposal-authority-envelope",
            "required": false,
            "sourceFieldId": "authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links action proposals to the governed evidence item record referenced by evidence item ids.",
            "id": "action-proposal-evidenced-by-evidence-item-evidence-item-ids-to-evidence-item",
            "introducedIn": "1.1.0",
            "predicate": "evidenced-by",
            "qualifiedId": "action-proposal-evidenced-by-evidence-item-evidence-item-ids-to-evidence-item",
            "required": true,
            "sourceFieldId": "evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Shared governed decision for this domain outcome.",
            "id": "action-proposal-governed-by-decision-action-proposal-governance-decision",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "action-proposal-governed-by-decision-action-proposal-governance-decision",
            "required": false,
            "sourceFieldId": "governance-decision-id",
            "targetEntityId": "decision",
            "targetFieldId": "decision-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the proposal to the receiving owner's durable acknowledgement decision without treating transport delivery as acceptance.",
            "id": "action-proposal-governed-by-decision-handoff-acknowledgement",
            "introducedIn": "4.3.0",
            "predicate": "governed-by",
            "qualifiedId": "action-proposal-governed-by-decision-handoff-acknowledgement",
            "required": false,
            "sourceFieldId": "acknowledgement-decision-id",
            "targetEntityId": "decision",
            "targetFieldId": "decision-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links a reopened proposal to the exact predecessor whose requested outcome remains unresolved.",
            "id": "action-proposal-references-action-proposal-reopened-predecessor",
            "introducedIn": "4.3.0",
            "predicate": "references",
            "qualifiedId": "action-proposal-references-action-proposal-reopened-predecessor",
            "required": false,
            "sourceFieldId": "reopened-from-action-proposal-id",
            "targetEntityId": "action-proposal",
            "targetFieldId": "action-proposal-id"
          },
          {
            "cardinality": "one-to-one",
            "definition": "Links a proposal to the exact successor that superseded, redirected or reopened it.",
            "id": "action-proposal-references-action-proposal-handoff-successor",
            "introducedIn": "4.3.0",
            "predicate": "references",
            "qualifiedId": "action-proposal-references-action-proposal-handoff-successor",
            "required": false,
            "sourceFieldId": "successor-action-proposal-id",
            "targetEntityId": "action-proposal",
            "targetFieldId": "action-proposal-id"
          }
        ],
        "retentionClass": "operational",
        "searchTerms": [
          "proposal",
          "draft action",
          "machine recommendation",
          "planned change",
          "diff"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "What action is proposed, on which record, with what evidence?",
              "Has this proposal been committed, rejected or superseded?"
            ],
            "retrievalTerms": [
              "proposal",
              "pending action",
              "recommendation record"
            ],
            "usage": "Record every machine-proposed mutation or external action as an action-proposal; a proposal never silently becomes committed truth and must remain visibly distinct."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "machine proposal",
              "draft action",
              "suggested action"
            ],
            "concept": "proposed-mutation",
            "doNotConfuseWith": [
              {
                "distinction": "A proposal is structurally distinct from a committed result; only a committed-action records that the boundary was crossed.",
                "targetEntityId": "committed-action"
              }
            ]
          }
        },
        "sourceSystemRoleIds": [
          "execution-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.1.0",
        "writebackSystemRoleIds": []
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "commit",
            "correct",
            "export"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "category-opportunity-radar",
          "category-strategy-orchestrator",
          "contract-authoring-review",
          "demand-orchestration",
          "intelligent-intake",
          "invoice-exception-triage",
          "invoice-intake-match",
          "payment-readiness",
          "policy-guidance",
          "policy-rule-lifecycle",
          "procurement-service-catalogue",
          "purchase-order-exception",
          "renewal-change-compliance",
          "requisition-policy-routing",
          "savings-initiative",
          "sourcing-event",
          "sourcing-pipeline-discovery",
          "supplier-innovation-pipeline",
          "supplier-performance-monitor-correct",
          "supplier-performance-review",
          "supplier-relationship-joint-value",
          "supplier-remediation-exit",
          "supplier-segmentation-governance",
          "third-party-risk-review",
          "value-opportunity-baseline"
        ],
        "definition": "The durable record that an authorised action crossed its commitment boundary, including its external result and recovery state.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable commitment record identifier.",
            "exchangeScope": "internal",
            "id": "committed-action-id",
            "introducedIn": "1.0.0",
            "label": "Committed action ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "restricted",
            "definition": "Proposal that crossed the commitment boundary.",
            "exchangeScope": "internal",
            "id": "action-proposal-id",
            "introducedIn": "1.0.0",
            "label": "Action proposal ID",
            "nullable": false,
            "referenceEntityId": "action-proposal",
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Grant used to authorise execution.",
            "exchangeScope": "internal",
            "id": "authority-envelope-id",
            "introducedIn": "1.0.0",
            "label": "Authority envelope ID",
            "nullable": false,
            "referenceEntityId": "authority-envelope",
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Stable business key used to prevent duplicate side effects.",
            "exchangeScope": "internal",
            "id": "idempotency-key",
            "introducedIn": "1.0.0",
            "label": "Idempotency key",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Stable owner that originated the accepted proposal, copied onto the commitment for permission-safe reconciliation queries.",
            "exchangeScope": "internal",
            "id": "sending-owner-id",
            "introducedIn": "4.3.0",
            "label": "Sending owner ID",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Stable owner accountable for the committed downstream work; owner acceptance is still proved by its linked decision rather than this copied routing value.",
            "exchangeScope": "internal",
            "id": "receiving-owner-id",
            "introducedIn": "4.3.0",
            "label": "Receiving owner ID",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Receiving-owner decision that authorised this downstream work; its presence does not prove the external side effect or verified outcome.",
            "exchangeScope": "internal",
            "id": "owner-acceptance-decision-id",
            "introducedIn": "4.3.0",
            "label": "Owner acceptance decision ID",
            "nullable": true,
            "referenceEntityId": "decision",
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Positive attempt number for execution under the same idempotency key; an unknown result is reconciled before a further side effect is attempted.",
            "exchangeScope": "internal",
            "format": "positive integer",
            "id": "commit-attempt",
            "introducedIn": "4.3.0",
            "label": "Commit attempt",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "integer"
          },
          {
            "classification": "internal",
            "definition": "State of readback and recovery after the commitment attempt, kept distinct from receiver acceptance and verified business outcome.",
            "enumValues": [
              "not-required",
              "pending",
              "outcome-unknown",
              "conflicting",
              "recovery-required",
              "reconciled",
              "verified"
            ],
            "exchangeScope": "internal",
            "id": "reconciliation-state",
            "introducedIn": "4.3.0",
            "label": "Reconciliation state",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Evidence-linked explanation of an unknown, conflicting, recovered, reconciled or verified result.",
            "exchangeScope": "internal",
            "id": "reconciliation-reason",
            "introducedIn": "4.3.0",
            "label": "Reconciliation reason",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "text"
          },
          {
            "classification": "internal",
            "definition": "UTC time of the latest authoritative readback or recovery check; absence means reconciliation has not been observed.",
            "exchangeScope": "internal",
            "format": "ISO 8601 UTC",
            "id": "last-reconciled-at",
            "introducedIn": "4.3.0",
            "label": "Last reconciled at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "confidential",
            "definition": "Evidence proving the requested business outcome, separate from delivery or system-write receipt evidence.",
            "exchangeScope": "internal",
            "id": "verified-outcome-evidence-item-ids",
            "introducedIn": "4.3.0",
            "label": "Verified outcome evidence item IDs",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "UTC time the requested business outcome was verified against its declared evidence, not the time the action was committed.",
            "exchangeScope": "internal",
            "format": "ISO 8601 UTC",
            "id": "outcome-verified-at",
            "introducedIn": "4.3.0",
            "label": "Outcome verified at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Later authorised commitment that compensates, corrects or supersedes this action without overwriting its attempt and result history.",
            "exchangeScope": "internal",
            "id": "successor-committed-action-id",
            "introducedIn": "4.3.0",
            "label": "Successor committed action ID",
            "nullable": true,
            "referenceEntityId": "committed-action",
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Typed downstream acknowledgement, reference and result summary.",
            "exchangeScope": "internal",
            "id": "commit-result",
            "introducedIn": "1.0.0",
            "label": "Commit result",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Result status records the governed state or type within Committed action Commit result without treating absence, unknown and zero as equivalent.",
                    "id": "result-status",
                    "label": "Result status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "commit-result",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Acknowledgement ID is the string component carried within Committed action Commit result; its classification and authority inherit from the owning field contract.",
                    "id": "acknowledgement-id",
                    "label": "Acknowledgement ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "commit-result",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Downstream record ID is the string component carried within Committed action Commit result; its classification and authority inherit from the owning field contract.",
                    "id": "downstream-record-id",
                    "label": "Downstream record ID",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "commit-result",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Committed at is the timestamp component carried within Committed action Commit result; its classification and authority inherit from the owning field contract.",
                    "id": "committed-at",
                    "label": "Committed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "commit-result",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Receipt evidence item ID links this structured value to the governed evidence-item record within Committed action Commit result.",
                    "id": "receipt-evidence-item-id",
                    "label": "Receipt evidence item ID",
                    "nullable": true,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the receipt evidence item ID in commit result to the referenced evidence item via its canonical evidence item ID.",
                      "id": "committed-action-commit-result-receipt-evidence-item-id",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "commit-result",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Result summary is the string component carried within Committed action Commit result; its classification and authority inherit from the owning field contract.",
                    "id": "result-summary",
                    "label": "Result summary",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "commit-result",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "UTC instant the commitment was confirmed.",
            "exchangeScope": "mapped",
            "format": "ISO 8601 UTC",
            "id": "committed-at",
            "introducedIn": "1.0.0",
            "label": "Committed at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "conceptId": "date-time-value",
                "coverage": "semantic",
                "direction": "outbound",
                "exchangeScope": "edge-interchange",
                "mappingKind": "value-format",
                "path": "committedAt",
                "releaseId": "iso-8601-1-2019",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-8601",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "committed-action",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "committed-action-id"
            ],
            "id": "committed-action-primary",
            "introducedIn": "1.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "action-proposal-id"
            ],
            "id": "committed-action-by-action-proposal-id",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "idempotency-key"
            ],
            "id": "committed-action-by-idempotency-key",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "sending-owner-id",
              "lifecycle-state"
            ],
            "id": "committed-action-by-sending-owner-and-status",
            "introducedIn": "4.3.0",
            "unique": false
          },
          {
            "fieldIds": [
              "receiving-owner-id",
              "reconciliation-state"
            ],
            "id": "committed-action-by-receiving-owner-and-reconciliation-state",
            "introducedIn": "4.3.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "case",
        "label": "Committed action",
        "lifecycle": [
          "committing",
          "committed",
          "partially-committed",
          "outcome-unknown",
          "recovery-required",
          "reconciled",
          "outcome-verified",
          "failed",
          "compensating",
          "superseded"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "shared-ledger-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "append-only-event-store",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Committed actions",
        "primaryKey": "committed-action-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "one-to-one",
            "definition": "Proposal that was committed.",
            "id": "committed-action-references-action-proposal-commit-proposal",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "committed-action-references-action-proposal-commit-proposal",
            "required": true,
            "sourceFieldId": "action-proposal-id",
            "targetEntityId": "action-proposal",
            "targetFieldId": "action-proposal-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Envelope authorising the committed action.",
            "id": "committed-action-governed-by-authority-envelope-commit-authority",
            "introducedIn": "1.0.0",
            "predicate": "governed-by",
            "qualifiedId": "committed-action-governed-by-authority-envelope-commit-authority",
            "required": true,
            "sourceFieldId": "authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links committed downstream work to the receiving-owner decision that accepted responsibility for it.",
            "id": "committed-action-governed-by-decision-owner-acceptance",
            "introducedIn": "4.3.0",
            "predicate": "governed-by",
            "qualifiedId": "committed-action-governed-by-decision-owner-acceptance",
            "required": false,
            "sourceFieldId": "owner-acceptance-decision-id",
            "targetEntityId": "decision",
            "targetFieldId": "decision-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the commitment to evidence that independently verifies the requested business outcome.",
            "id": "committed-action-evidenced-by-evidence-item-verified-outcome",
            "introducedIn": "4.3.0",
            "predicate": "evidenced-by",
            "qualifiedId": "committed-action-evidenced-by-evidence-item-verified-outcome",
            "required": false,
            "sourceFieldId": "verified-outcome-evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "one-to-one",
            "definition": "Links an action to the exact compensating, correcting or superseding commitment.",
            "id": "committed-action-references-committed-action-corrective-successor",
            "introducedIn": "4.3.0",
            "predicate": "references",
            "qualifiedId": "committed-action-references-committed-action-corrective-successor",
            "required": false,
            "sourceFieldId": "successor-committed-action-id",
            "targetEntityId": "committed-action",
            "targetFieldId": "committed-action-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "commitment",
          "executed action",
          "side effect",
          "writeback",
          "reconciliation",
          "compensation"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Did the authorised action commit, and what was its external result?",
              "What recovery state applies if the external system failed after commitment?"
            ],
            "retrievalTerms": [
              "commitment",
              "execution record",
              "external result"
            ],
            "usage": "Read committed-actions for what actually happened, including external results and recovery state; treat them as append-only history, corrected only through successor records."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "executed action",
              "commitment record"
            ],
            "concept": "committed-result",
            "doNotConfuseWith": [
              {
                "distinction": "A decision authorises; the committed-action is the durable record that an authorised action actually crossed its commitment boundary.",
                "targetEntityId": "decision"
              }
            ]
          }
        },
        "sourceSystemRoleIds": [
          "execution-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.1.0",
        "writebackSystemRoleIds": []
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "category-opportunity-radar",
          "category-strategy-orchestrator",
          "contract-authoring-review",
          "demand-orchestration",
          "intelligent-intake",
          "invoice-exception-triage",
          "invoice-intake-match",
          "payment-readiness",
          "policy-guidance",
          "policy-rule-lifecycle",
          "procurement-service-catalogue",
          "purchase-order-exception",
          "renewal-change-compliance",
          "requisition-policy-routing",
          "savings-initiative",
          "sourcing-event",
          "sourcing-pipeline-discovery",
          "supplier-innovation-pipeline",
          "supplier-performance-monitor-correct",
          "supplier-performance-review",
          "supplier-relationship-joint-value",
          "supplier-remediation-exit",
          "supplier-segmentation-governance",
          "third-party-risk-review",
          "value-opportunity-baseline"
        ],
        "definition": "A durable choice with subject, authority, evidence, rationale and outcome; a decision may authorise an action but is not itself evidence that the action committed.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable decision identifier.",
            "exchangeScope": "internal",
            "id": "decision-id",
            "introducedIn": "1.0.0",
            "label": "Decision ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Governed semantic type of choice.",
            "exchangeScope": "internal",
            "id": "decision-type",
            "introducedIn": "1.0.0",
            "label": "Decision type",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Typed entity and record key to which the decision applies.",
            "exchangeScope": "internal",
            "id": "subject-ref",
            "introducedIn": "1.0.0",
            "label": "Subject reference",
            "nullable": false,
            "referenceTargetEntityIds": [
              "action-proposal",
              "audit-event",
              "authority-envelope",
              "award-scenario",
              "budget",
              "buy-timing-mandate",
              "business-event",
              "business-unit",
              "buying-request",
              "catalogue-line",
              "category",
              "category-dimension-assignment",
              "category-opportunity",
              "category-strategy",
              "clause-deviation",
              "clause-library-entry",
              "committed-action",
              "contract",
              "contract-approval",
              "contract-change",
              "contract-compliance-finding",
              "contract-entitlement",
              "contract-intake",
              "contract-obligation",
              "contract-template",
              "contract-version",
              "decision",
              "demand-case",
              "demand-portfolio",
              "enriched-request",
              "evaluation-result",
              "evidence-item",
              "exception",
              "intake-request",
              "integration-state",
              "invoice",
              "invoice-exception",
              "invoice-line",
              "invoice-match-assessment",
              "item-service",
              "job",
              "learning-example",
              "negotiation-session",
              "order-line",
              "order-response",
              "party",
              "payment-execution-status",
              "payment-instruction",
              "payment-readiness-assessment",
              "person",
              "person-role-assignment",
              "policy",
              "policy-change-impact",
              "policy-guidance-result",
              "policy-rule-release",
              "policy-version",
              "procurement-service-offering",
              "purchase-order",
              "purchase-order-exception",
              "receipt",
              "receipt-line",
              "registry-release",
              "requisition",
              "requisition-line",
              "return-claim",
              "role",
              "savings-initiative-record",
              "service-entry-sheet",
              "shipment",
              "source-record-reference",
              "sourcing-event-record",
              "sourcing-opportunity",
              "spend-classification-decision",
              "spend-record",
              "supplier-innovation-case",
              "supplier-invoice-resolution",
              "supplier-joint-value-plan",
              "supplier-master-change",
              "supplier-offboarding-case",
              "supplier-onboarding-case",
              "supplier-performance-observation",
              "supplier-performance-review-record",
              "supplier-performance-signal",
              "supplier-profile",
              "supplier-qualification",
              "supplier-remediation-action",
              "supplier-response",
              "supplier-risk-assessment",
              "supplier-risk-case",
              "supplier-risk-signal",
              "supplier-segment-assignment",
              "supplier-tier-link",
              "tactical-sourcing-case",
              "tail-spend-evaluation",
              "tail-spend-rule",
              "taxonomy-version",
              "value-leakage-finding",
              "value-opportunity-baseline",
              "value-portfolio-forecast",
              "value-realization-attribution",
              "work-moment-record"
            ],
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "record-reference-value",
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Closed, typed decision outcome distinct from an execution result.",
            "exchangeScope": "internal",
            "id": "outcome",
            "introducedIn": "1.0.0",
            "label": "Outcome",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Cross-owner proposal whose receiving-owner acknowledgement is recorded by this decision.",
            "exchangeScope": "internal",
            "id": "handoff-action-proposal-id",
            "introducedIn": "4.3.0",
            "label": "Handoff action proposal ID",
            "nullable": true,
            "referenceEntityId": "action-proposal",
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Stable owner ID that submitted the handoff; retained on the decision so permission-safe sender queries do not depend on transport logs.",
            "exchangeScope": "internal",
            "id": "sending-owner-id",
            "introducedIn": "4.3.0",
            "label": "Sending owner ID",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Stable owner ID accountable for this acknowledgement decision; it is independent of the person or role recorded in decided-by-ref.",
            "exchangeScope": "internal",
            "id": "receiving-owner-id",
            "introducedIn": "4.3.0",
            "label": "Receiving owner ID",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Receiving-owner disposition of the handoff, distinct from message delivery, committed downstream work and verified business outcome.",
            "enumValues": [
              "pending",
              "accepted",
              "rejected",
              "redirected",
              "expired",
              "outcome-unknown",
              "reopened"
            ],
            "exchangeScope": "internal",
            "id": "acknowledgement-state",
            "introducedIn": "4.3.0",
            "label": "Acknowledgement state",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "UTC time the receiving owner made the acknowledgement decision; absence means no acknowledgement is recorded, not rejection.",
            "exchangeScope": "internal",
            "format": "ISO 8601 UTC",
            "id": "acknowledged-at",
            "introducedIn": "4.3.0",
            "label": "Acknowledged at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "confidential",
            "definition": "Evidence-linked reason for acceptance, rejection, redirection, expiry, unknown outcome or reopening.",
            "exchangeScope": "internal",
            "id": "acknowledgement-reason",
            "introducedIn": "4.3.0",
            "label": "Acknowledgement reason",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "text"
          },
          {
            "classification": "internal",
            "definition": "Stable successor owner selected when the receiving owner redirects the requested outcome; redirection creates or links a successor proposal rather than rewriting the original receiver.",
            "exchangeScope": "internal",
            "id": "redirected-to-owner-id",
            "introducedIn": "4.3.0",
            "label": "Redirected to owner ID",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Delivery attempt acknowledged by this decision, allowing a receiver response to reconcile to an exact retry without making delivery the acceptance fact.",
            "exchangeScope": "internal",
            "format": "positive integer",
            "id": "handoff-attempt",
            "introducedIn": "4.3.0",
            "label": "Handoff attempt",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "integer"
          },
          {
            "classification": "confidential",
            "definition": "Immutable evidence-set version considered by the receiving owner, preserving the basis of the acknowledgement if evidence later changes.",
            "exchangeScope": "internal",
            "id": "evidence-version",
            "introducedIn": "4.3.0",
            "label": "Evidence version",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Earlier acknowledgement decision reopened because its requested outcome was not completed, became invalid or requires a new receiving-owner decision.",
            "exchangeScope": "internal",
            "id": "reopened-from-decision-id",
            "introducedIn": "4.3.0",
            "label": "Reopened from decision ID",
            "nullable": true,
            "referenceEntityId": "decision",
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Later decision that supersedes or reopens this acknowledgement while preserving the original decision and evidence version.",
            "exchangeScope": "internal",
            "id": "successor-decision-id",
            "introducedIn": "4.3.0",
            "label": "Successor decision ID",
            "nullable": true,
            "referenceEntityId": "decision",
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Envelope that authorised the named decision, when applicable.",
            "exchangeScope": "internal",
            "id": "authority-envelope-id",
            "introducedIn": "1.0.0",
            "label": "Authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Evidence supporting the decision.",
            "exchangeScope": "internal",
            "id": "evidence-item-ids",
            "introducedIn": "1.0.0",
            "label": "Evidence item IDs",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "confidential",
            "definition": "Concise evidence-linked explanation appropriate to the decision audience.",
            "exchangeScope": "internal",
            "id": "rationale",
            "introducedIn": "1.0.0",
            "label": "Rationale",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "text"
          },
          {
            "classification": "internal",
            "definition": "UTC decision timestamp.",
            "exchangeScope": "mapped",
            "format": "ISO 8601 UTC",
            "id": "decided-at",
            "introducedIn": "1.0.0",
            "label": "Decided at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "conceptId": "date-time-value",
                "coverage": "semantic",
                "direction": "outbound",
                "exchangeScope": "edge-interchange",
                "mappingKind": "value-format",
                "path": "decidedAt",
                "releaseId": "iso-8601-1-2019",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-8601",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Typed person or role reference accountable for the decision.",
            "exchangeScope": "unmapped",
            "id": "decided-by-ref",
            "introducedIn": "4.0.0",
            "label": "Decided by",
            "nullable": false,
            "referenceTargetEntityIds": [
              "person",
              "role"
            ],
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "record-reference-value",
              "schemaVersion": "1.0.0"
            }
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "decision",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "decision-id"
            ],
            "id": "decision-primary",
            "introducedIn": "1.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "subject-ref",
              "decision-type"
            ],
            "id": "decision-by-subject-reference-and-decision-type",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "decided-at"
            ],
            "id": "decision-by-decided-at",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "sending-owner-id",
              "decision-type"
            ],
            "id": "decision-by-sending-owner-and-decision-type",
            "introducedIn": "4.3.0",
            "unique": false
          },
          {
            "fieldIds": [
              "receiving-owner-id",
              "acknowledgement-state"
            ],
            "id": "decision-by-receiving-owner-and-acknowledgement-state",
            "introducedIn": "4.3.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "decision",
        "label": "Decision",
        "lifecycle": [
          "proposed",
          "committed",
          "superseded",
          "withdrawn"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "shared-ledger-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "platform-services-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Decisions",
        "primaryKey": "decision-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Envelope authorising the named decision.",
            "id": "decision-governed-by-authority-envelope-decision-authority",
            "introducedIn": "1.0.0",
            "predicate": "governed-by",
            "qualifiedId": "decision-governed-by-authority-envelope-decision-authority",
            "required": false,
            "sourceFieldId": "authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links decisions to the governed evidence item record referenced by evidence item ids.",
            "id": "decision-evidenced-by-evidence-item-evidence-item-ids-to-evidence-item",
            "introducedIn": "1.1.0",
            "predicate": "evidenced-by",
            "qualifiedId": "decision-evidenced-by-evidence-item-evidence-item-ids-to-evidence-item",
            "required": true,
            "sourceFieldId": "evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links a receiving-owner acknowledgement to the exact cross-owner proposal it decided.",
            "id": "decision-references-action-proposal-handoff-request",
            "introducedIn": "4.3.0",
            "predicate": "references",
            "qualifiedId": "decision-references-action-proposal-handoff-request",
            "required": false,
            "sourceFieldId": "handoff-action-proposal-id",
            "targetEntityId": "action-proposal",
            "targetFieldId": "action-proposal-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links a reopened acknowledgement decision to its exact predecessor.",
            "id": "decision-references-decision-reopened-acknowledgement",
            "introducedIn": "4.3.0",
            "predicate": "references",
            "qualifiedId": "decision-references-decision-reopened-acknowledgement",
            "required": false,
            "sourceFieldId": "reopened-from-decision-id",
            "targetEntityId": "decision",
            "targetFieldId": "decision-id"
          },
          {
            "cardinality": "one-to-one",
            "definition": "Links an acknowledgement decision to the exact successor that superseded or reopened it.",
            "id": "decision-references-decision-acknowledgement-successor",
            "introducedIn": "4.3.0",
            "predicate": "references",
            "qualifiedId": "decision-references-decision-acknowledgement-successor",
            "required": false,
            "sourceFieldId": "successor-decision-id",
            "targetEntityId": "decision",
            "targetFieldId": "decision-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "decision",
          "authority",
          "outcome",
          "rationale",
          "exception decision"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Who decided, under which authority, on what evidence and rationale?",
              "Which decision governs the current state of this subject?"
            ],
            "retrievalTerms": [
              "approval",
              "sign-off",
              "authorisation",
              "rationale"
            ],
            "usage": "Record subject, authority, evidence, rationale and outcome for every durable choice; correction creates a successor decision preserving the predecessor chain."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "ruling",
              "approval record",
              "disposition"
            ],
            "concept": "durable-choice",
            "doNotConfuseWith": [
              {
                "distinction": "A decision is an authorised choice; a proposal is unauthorised input awaiting one.",
                "targetEntityId": "action-proposal"
              }
            ]
          }
        },
        "sourceSystemRoleIds": [
          "execution-system",
          "identity-authority"
        ],
        "storageClass": "tenant-record",
        "version": "4.1.0",
        "writebackSystemRoleIds": []
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "contract-authoring-review",
          "demand-orchestration",
          "invoice-exception-triage",
          "payment-readiness",
          "policy-guidance",
          "purchase-order-exception",
          "savings-initiative",
          "sourcing-event",
          "third-party-risk-review"
        ],
        "definition": "A consequential, ambiguous, novel or policy-triggering case that cannot continue inside the current authority envelope.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable case identifier.",
            "exchangeScope": "internal",
            "id": "exception-id",
            "introducedIn": "1.0.0",
            "label": "Exception case ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Workblock that opened the exception.",
            "exchangeScope": "internal",
            "id": "workblock-id",
            "introducedIn": "1.0.0",
            "label": "Workblock ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Governed trigger class used for routing and metrics.",
            "exchangeScope": "internal",
            "id": "exception-type",
            "introducedIn": "1.0.0",
            "label": "Exception type",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Typed entity and record key affected by the exception.",
            "exchangeScope": "internal",
            "id": "subject-ref",
            "introducedIn": "1.0.0",
            "label": "Subject reference",
            "nullable": false,
            "referenceTargetEntityIds": [
              "action-proposal",
              "audit-event",
              "authority-envelope",
              "award-scenario",
              "budget",
              "buy-timing-mandate",
              "business-event",
              "business-unit",
              "buying-request",
              "catalogue-line",
              "category",
              "category-dimension-assignment",
              "category-opportunity",
              "category-strategy",
              "clause-deviation",
              "clause-library-entry",
              "committed-action",
              "contract",
              "contract-approval",
              "contract-change",
              "contract-compliance-finding",
              "contract-entitlement",
              "contract-intake",
              "contract-obligation",
              "contract-template",
              "contract-version",
              "decision",
              "demand-case",
              "demand-portfolio",
              "enriched-request",
              "evaluation-result",
              "evidence-item",
              "exception",
              "intake-request",
              "integration-state",
              "invoice",
              "invoice-exception",
              "invoice-line",
              "invoice-match-assessment",
              "item-service",
              "job",
              "learning-example",
              "negotiation-session",
              "order-line",
              "order-response",
              "party",
              "payment-execution-status",
              "payment-instruction",
              "payment-readiness-assessment",
              "person",
              "person-role-assignment",
              "policy",
              "policy-change-impact",
              "policy-guidance-result",
              "policy-rule-release",
              "policy-version",
              "procurement-service-offering",
              "purchase-order",
              "purchase-order-exception",
              "receipt",
              "receipt-line",
              "registry-release",
              "requisition",
              "requisition-line",
              "return-claim",
              "role",
              "savings-initiative-record",
              "service-entry-sheet",
              "shipment",
              "source-record-reference",
              "sourcing-event-record",
              "sourcing-opportunity",
              "spend-classification-decision",
              "spend-record",
              "supplier-innovation-case",
              "supplier-invoice-resolution",
              "supplier-joint-value-plan",
              "supplier-master-change",
              "supplier-offboarding-case",
              "supplier-onboarding-case",
              "supplier-performance-observation",
              "supplier-performance-review-record",
              "supplier-performance-signal",
              "supplier-profile",
              "supplier-qualification",
              "supplier-remediation-action",
              "supplier-response",
              "supplier-risk-assessment",
              "supplier-risk-case",
              "supplier-risk-signal",
              "supplier-segment-assignment",
              "supplier-tier-link",
              "tactical-sourcing-case",
              "tail-spend-evaluation",
              "tail-spend-rule",
              "taxonomy-version",
              "value-leakage-finding",
              "value-opportunity-baseline",
              "value-portfolio-forecast",
              "value-realization-attribution",
              "work-moment-record"
            ],
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "record-reference-value",
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "personal",
            "definition": "Current accountable owner with exception authority or routing responsibility.",
            "exchangeScope": "internal",
            "id": "owner-person-id",
            "introducedIn": "1.0.0",
            "label": "Owner person ID",
            "nullable": false,
            "referenceEntityId": "person",
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Evidence assembled for resolution.",
            "exchangeScope": "internal",
            "id": "evidence-item-ids",
            "introducedIn": "1.0.0",
            "label": "Evidence item IDs",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "UTC case creation timestamp.",
            "exchangeScope": "mapped",
            "format": "ISO 8601 UTC",
            "id": "opened-at",
            "introducedIn": "1.0.0",
            "label": "Opened at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "conceptId": "date-time-value",
                "coverage": "semantic",
                "direction": "outbound",
                "exchangeScope": "edge-interchange",
                "mappingKind": "value-format",
                "path": "openedAt",
                "releaseId": "iso-8601-1-2019",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-8601",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          },
          {
            "classification": "confidential",
            "definition": "Committed decision resolving or rejecting the case.",
            "exchangeScope": "internal",
            "id": "resolution-decision-id",
            "introducedIn": "1.0.0",
            "label": "Resolution decision ID",
            "nullable": true,
            "referenceEntityId": "decision",
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Authority envelope governing proposals, approvals and commitments for this record.",
            "exchangeScope": "unmapped",
            "id": "governance-authority-envelope-id",
            "introducedIn": "4.0.0",
            "label": "Governance authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "exception",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "exception-id"
            ],
            "id": "exception-primary",
            "introducedIn": "1.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "workblock-id",
              "lifecycle-state"
            ],
            "id": "exception-by-workblock-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "owner-person-id",
              "lifecycle-state"
            ],
            "id": "exception-by-owner-person-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "case",
        "label": "Exception case",
        "lifecycle": [
          "open",
          "in-progress",
          "waiting-evidence",
          "resolved",
          "rejected",
          "expired",
          "reopened"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "shared-ledger-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "platform-services-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Exception cases",
        "primaryKey": "exception-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Current accountable owner.",
            "id": "exception-assigned-to-person-exception-owner",
            "introducedIn": "1.0.0",
            "predicate": "assigned-to",
            "qualifiedId": "exception-assigned-to-person-exception-owner",
            "required": true,
            "sourceFieldId": "owner-person-id",
            "targetEntityId": "person",
            "targetFieldId": "person-id"
          },
          {
            "cardinality": "one-to-one",
            "definition": "Decision resolving the exception.",
            "id": "exception-references-decision-exception-resolution",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "exception-references-decision-exception-resolution",
            "required": false,
            "sourceFieldId": "resolution-decision-id",
            "targetEntityId": "decision",
            "targetFieldId": "decision-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links exception cases to the governed evidence item record referenced by evidence item ids.",
            "id": "exception-evidenced-by-evidence-item-evidence-item-ids-to-evidence-item",
            "introducedIn": "1.1.0",
            "predicate": "evidenced-by",
            "qualifiedId": "exception-evidenced-by-evidence-item-evidence-item-ids-to-evidence-item",
            "required": true,
            "sourceFieldId": "evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authority envelope governing this record.",
            "id": "exception-governed-by-authority-envelope-exception-governance-authority",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "exception-governed-by-authority-envelope-exception-governance-authority",
            "required": false,
            "sourceFieldId": "governance-authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          }
        ],
        "retentionClass": "operational",
        "searchTerms": [
          "exception",
          "escalation",
          "blocked case",
          "needs evidence",
          "policy conflict"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Why could this case not continue inside its authority envelope?",
              "Who owns the exception and what disposition closed it?"
            ],
            "retrievalTerms": [
              "exception handling",
              "manual review",
              "out of policy"
            ],
            "usage": "Open an exception whenever a case is consequential, ambiguous, novel or policy-triggering and cannot continue inside the current authority envelope; never force such work through automated paths."
          },
          "introducedIn": "4.7.0",
          "semanticLabel": {
            "aliases": [
              "escalation",
              "review case",
              "blocked case"
            ],
            "concept": "escalation-case",
            "doNotConfuseWith": [
              {
                "distinction": "Exception is the shared escalation shape; invoice-exception is the invoice-domain case with its own evidence and disposition contract.",
                "targetEntityId": "invoice-exception"
              }
            ]
          }
        },
        "sourceSystemRoleIds": [
          "execution-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.1.0",
        "writebackSystemRoleIds": []
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "export"
          ],
          "deletePolicy": "immutable",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "contract-approval-repository",
          "contract-authoring-review",
          "demand-orchestration",
          "invoice-exception-triage",
          "payment-readiness",
          "purchase-order-exception",
          "savings-initiative",
          "sourcing-event",
          "supplier-performance-review",
          "third-party-risk-review"
        ],
        "definition": "An immutable high-level record of a consequential state transition, tool invocation, grant use, override or recovery action.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Globally unique event identifier.",
            "exchangeScope": "internal",
            "id": "audit-event-id",
            "introducedIn": "1.0.0",
            "label": "Audit event ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Governed semantic event name.",
            "exchangeScope": "internal",
            "id": "event-type",
            "introducedIn": "1.0.0",
            "label": "Event type",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Typed record or run affected.",
            "exchangeScope": "internal",
            "id": "subject-reference",
            "introducedIn": "1.0.0",
            "label": "Subject reference",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Subject type records the governed state or type within Audit event Subject reference without treating absence, unknown and zero as equivalent.",
                    "id": "subject-type",
                    "label": "Subject type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "subject-reference",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Subject ID is the string component carried within Audit event Subject reference; its classification and authority inherit from the owning field contract.",
                    "id": "subject-id",
                    "label": "Subject ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "subject-reference",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Subject version is the string component carried within Audit event Subject reference; its classification and authority inherit from the owning field contract.",
                    "id": "subject-version",
                    "label": "Subject version",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "subject-reference",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Run ID is the string component carried within Audit event Subject reference; its classification and authority inherit from the owning field contract.",
                    "id": "run-id",
                    "label": "Run ID",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "subject-reference",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Person, service or agent identity responsible for the transition.",
            "exchangeScope": "internal",
            "id": "actor-reference",
            "introducedIn": "1.0.0",
            "label": "Actor reference",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Actor type records the governed state or type within Audit event Actor reference without treating absence, unknown and zero as equivalent.",
                    "id": "actor-type",
                    "label": "Actor type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "actor-reference",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Actor ID is the string component carried within Audit event Actor reference; its classification and authority inherit from the owning field contract.",
                    "id": "actor-id",
                    "label": "Actor ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "actor-reference",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Delegating person ID links this structured value to the governed person record within Audit event Actor reference.",
                    "id": "delegating-person-id",
                    "label": "Delegating person ID",
                    "nullable": true,
                    "referenceEntityId": "person",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the delegating person ID in actor reference to the referenced person via its canonical person ID.",
                      "id": "audit-event-actor-reference-delegating-person-id",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "person-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "actor-reference",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Authority envelope ID links this structured value to the governed authority-envelope record within Audit event Actor reference.",
                    "id": "authority-envelope-id",
                    "label": "Authority envelope ID",
                    "nullable": true,
                    "referenceEntityId": "authority-envelope",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the authority envelope ID in actor reference to the referenced authority envelope via its canonical authority envelope ID.",
                      "id": "audit-event-actor-reference-authority-envelope-id",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "authority-envelope-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "actor-reference",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Workblock, task, policy, schema, model and prompt versions active for the event.",
            "exchangeScope": "internal",
            "id": "version-context",
            "introducedIn": "1.0.0",
            "label": "Version context",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Workblock version is the string component carried within Audit event Version context; its classification and authority inherit from the owning field contract.",
                    "id": "workblock-version",
                    "label": "Workblock version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "version-context",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Schema version is the string component carried within Audit event Version context; its classification and authority inherit from the owning field contract.",
                    "id": "schema-version",
                    "label": "Schema version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "version-context",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Task version is the string component carried within Audit event Version context; its classification and authority inherit from the owning field contract.",
                    "id": "task-version",
                    "label": "Task version",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "version-context",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Policy version is the string component carried within Audit event Version context; its classification and authority inherit from the owning field contract.",
                    "id": "policy-version",
                    "label": "Policy version",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "version-context",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Model version is the string component carried within Audit event Version context; its classification and authority inherit from the owning field contract.",
                    "id": "model-version",
                    "label": "Model version",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "version-context",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Prompt version is the string component carried within Audit event Version context; its classification and authority inherit from the owning field contract.",
                    "id": "prompt-version",
                    "label": "Prompt version",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "version-context",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Stable trace identifier across runs and adapters.",
            "exchangeScope": "internal",
            "id": "correlation-id",
            "introducedIn": "1.0.0",
            "label": "Correlation ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Concise inspectable description excluding secrets and unsupported explanations.",
            "exchangeScope": "internal",
            "id": "summary",
            "introducedIn": "1.0.0",
            "label": "Summary",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "text"
          },
          {
            "classification": "internal",
            "definition": "UTC time of the audited transition.",
            "exchangeScope": "mapped",
            "format": "ISO 8601 UTC",
            "id": "occurred-at",
            "introducedIn": "1.0.0",
            "label": "Occurred at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "conceptId": "date-time-value",
                "coverage": "semantic",
                "direction": "outbound",
                "exchangeScope": "edge-interchange",
                "mappingKind": "value-format",
                "path": "occurredAt",
                "releaseId": "iso-8601-1-2019",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-8601",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          }
        ],
        "freshnessContract": {
          "degradedAction": "not-applicable",
          "lastGoodPolicy": "not-applicable",
          "observationMode": "immutable",
          "sourceHealthRequired": false,
          "thresholdPolicy": "not-applicable"
        },
        "id": "audit-event",
        "immutable": true,
        "indexes": [
          {
            "fieldIds": [
              "audit-event-id"
            ],
            "id": "audit-event-primary",
            "introducedIn": "1.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "correlation-id",
              "occurred-at"
            ],
            "id": "audit-event-by-correlation-id-and-occurred-at",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "subject-reference",
              "occurred-at"
            ],
            "id": "audit-event-by-subject-reference-and-occurred-at",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "event",
        "label": "Audit event",
        "lifecycle": [
          "recorded",
          "retained"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "audit-event-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "append-only-event-store",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Audit events",
        "primaryKey": "audit-event-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [],
        "retentionClass": "evidence",
        "searchTerms": [
          "audit",
          "activity",
          "tool call",
          "override",
          "version",
          "trace"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "What consequential transitions happened on this record and in what order?",
              "Which grant or override was exercised, by whom, when?"
            ],
            "retrievalTerms": [
              "audit trail",
              "log",
              "state transition",
              "override record"
            ],
            "usage": "Emit audit-events for consequential state transitions, tool invocations, grant uses, overrides and recovery actions; they are immutable and never edited."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "audit log entry",
              "trace record"
            ],
            "concept": "immutable-audit-record",
            "doNotConfuseWith": [
              {
                "distinction": "An audit-event records a consequential transition for accountability; a business-event is a signal other modules may react to.",
                "targetEntityId": "business-event"
              }
            ]
          }
        },
        "sourceSystemRoleIds": [
          "execution-system",
          "identity-authority"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": []
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "export"
          ],
          "deletePolicy": "immutable",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "category-opportunity-radar",
          "category-strategy-orchestrator",
          "contract-authoring-review",
          "demand-orchestration",
          "intelligent-intake",
          "invoice-exception-triage",
          "invoice-intake-match",
          "obligation-monitoring",
          "payment-readiness",
          "policy-guidance",
          "policy-rule-lifecycle",
          "procurement-service-catalogue",
          "purchase-order-exception",
          "renewal-change-compliance",
          "requisition-policy-routing",
          "savings-initiative",
          "sourcing-event",
          "sourcing-pipeline-discovery",
          "supplier-innovation-pipeline",
          "supplier-performance-monitor-correct",
          "supplier-performance-review",
          "supplier-relationship-joint-value",
          "supplier-remediation-exit",
          "supplier-segmentation-governance",
          "third-party-risk-review",
          "value-leakage-monitor",
          "value-opportunity-baseline"
        ],
        "definition": "A versioned signal that a procurement fact or lifecycle transition occurred and another business module may react; delivery is not canonical storage.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "internal",
            "definition": "Globally unique event identifier and idempotency anchor.",
            "exchangeScope": "internal",
            "id": "business-event-id",
            "introducedIn": "1.0.0",
            "label": "Business event ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Versioned semantic event name.",
            "exchangeScope": "internal",
            "id": "event-type",
            "introducedIn": "1.0.0",
            "label": "Event type",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Pinned payload contract version.",
            "exchangeScope": "internal",
            "format": "SemVer",
            "id": "event-schema-version",
            "introducedIn": "1.0.0",
            "label": "Event schema version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Typed entity and business key to which the event applies.",
            "exchangeScope": "internal",
            "id": "subject-reference",
            "introducedIn": "1.0.0",
            "label": "Subject reference",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Entity ID is the string component carried within Business event Subject reference; its classification and authority inherit from the owning field contract.",
                    "id": "entity-id",
                    "label": "Entity ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "subject-reference",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Business key is the string component carried within Business event Subject reference; its classification and authority inherit from the owning field contract.",
                    "id": "business-key",
                    "label": "Business key",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "subject-reference",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Record version is the string component carried within Business event Subject reference; its classification and authority inherit from the owning field contract.",
                    "id": "record-version",
                    "label": "Record version",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "subject-reference",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Trace identifier shared across related events and runs.",
            "exchangeScope": "internal",
            "id": "correlation-id",
            "introducedIn": "1.0.0",
            "label": "Correlation ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Optional event or commitment that caused this event.",
            "exchangeScope": "internal",
            "id": "causation-id",
            "introducedIn": "1.0.0",
            "label": "Causation ID",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Stable business-module or platform-service owner that emitted the cross-owner event.",
            "exchangeScope": "internal",
            "id": "sending-owner-id",
            "introducedIn": "4.3.0",
            "label": "Sending owner ID",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Stable intended receiving owner for delivery and replay scope; delivery to this owner is not evidence that the owner accepted the business outcome.",
            "exchangeScope": "internal",
            "id": "receiving-owner-id",
            "introducedIn": "4.3.0",
            "label": "Receiving owner ID",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Positive attempt number for delivery of the same immutable event and idempotency anchor.",
            "exchangeScope": "internal",
            "format": "positive integer",
            "id": "delivery-attempt",
            "introducedIn": "4.3.0",
            "label": "Delivery attempt",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "integer"
          },
          {
            "classification": "internal",
            "definition": "Transport or consumer-processing acknowledgement carried by this immutable event fact, never the receiving owner's business acceptance or verified outcome.",
            "enumValues": [
              "pending",
              "acknowledged",
              "rejected",
              "outcome-unknown",
              "reconciled"
            ],
            "exchangeScope": "internal",
            "id": "delivery-acknowledgement-state",
            "introducedIn": "4.3.0",
            "label": "Delivery acknowledgement state",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "UTC time the transport or consumer-processing acknowledgement was observed; owner acceptance requires a separate decision record.",
            "exchangeScope": "internal",
            "format": "ISO 8601 UTC",
            "id": "delivery-acknowledged-at",
            "introducedIn": "4.3.0",
            "label": "Delivery acknowledged at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "confidential",
            "definition": "Bounded delivery, rejection, unknown-result or reconciliation reason; it cannot be reused as the business rationale for owner acceptance.",
            "exchangeScope": "internal",
            "id": "delivery-acknowledgement-reason",
            "introducedIn": "4.3.0",
            "label": "Delivery acknowledgement reason",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "text"
          },
          {
            "classification": "restricted",
            "definition": "Earlier immutable event whose delivery or processing attempt this event acknowledges, rejects or reconciles.",
            "exchangeScope": "internal",
            "id": "acknowledges-business-event-id",
            "introducedIn": "4.3.0",
            "label": "Acknowledges business event ID",
            "nullable": true,
            "referenceEntityId": "business-event",
            "required": false,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Optional receiving-owner decision correlated after delivery; the event remains only evidence of transport or processing unless this independent decision exists.",
            "exchangeScope": "internal",
            "id": "owner-acceptance-decision-id",
            "introducedIn": "4.3.0",
            "label": "Owner acceptance decision ID",
            "nullable": true,
            "referenceEntityId": "decision",
            "required": false,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Authority envelope governing the consequential emission, replay or acknowledgement operation when one is required.",
            "exchangeScope": "internal",
            "id": "authority-envelope-id",
            "introducedIn": "4.3.0",
            "label": "Authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Minimal versioned consumer payload; canonical records are referenced rather than duplicated.",
            "exchangeScope": "internal",
            "id": "payload",
            "introducedIn": "1.0.0",
            "label": "Payload",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Payload schema ID is the string component carried within Business event Payload; its classification and authority inherit from the owning field contract.",
                    "id": "payload-schema-id",
                    "label": "Payload schema ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "payload",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Payload schema version is the string component carried within Business event Payload; its classification and authority inherit from the owning field contract.",
                    "id": "payload-schema-version",
                    "label": "Payload schema version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "payload",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Record reference ids is the set carried within Business event Payload; its owning field governs allowed values and interpretation.",
                    "id": "record-reference-ids",
                    "label": "Record reference ids",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "payload",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Change summary is the string component carried within Business event Payload; its classification and authority inherit from the owning field contract.",
                    "id": "change-summary",
                    "label": "Change summary",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "payload",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Evidence item ids links this structured value to governed evidence items through evidence-item-id within Business event Payload.",
                    "id": "evidence-item-ids",
                    "label": "Evidence item ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links evidence item ids to governed evidence items through the canonical evidence-item-id field.",
                      "id": "business-event-payload-evidence-item-ids",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "payload",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "UTC time the business transition occurred.",
            "exchangeScope": "mapped",
            "format": "ISO 8601 UTC",
            "id": "occurred-at",
            "introducedIn": "1.0.0",
            "label": "Occurred at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "audit-event-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "conceptId": "date-time-value",
                "coverage": "semantic",
                "direction": "outbound",
                "exchangeScope": "edge-interchange",
                "mappingKind": "value-format",
                "path": "occurredAt",
                "releaseId": "iso-8601-1-2019",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-8601",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          }
        ],
        "freshnessContract": {
          "degradedAction": "not-applicable",
          "lastGoodPolicy": "not-applicable",
          "observationMode": "immutable",
          "sourceHealthRequired": false,
          "thresholdPolicy": "not-applicable"
        },
        "id": "business-event",
        "immutable": true,
        "indexes": [
          {
            "fieldIds": [
              "business-event-id"
            ],
            "id": "business-event-primary",
            "introducedIn": "1.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "event-type",
              "occurred-at"
            ],
            "id": "business-event-by-event-type-and-occurred-at",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "correlation-id"
            ],
            "id": "business-event-by-correlation-id",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "subject-reference",
              "occurred-at"
            ],
            "id": "business-event-by-subject-reference-and-occurred-at",
            "introducedIn": "4.3.0",
            "unique": false
          },
          {
            "fieldIds": [
              "sending-owner-id",
              "occurred-at"
            ],
            "id": "business-event-by-sending-owner-and-occurred-at",
            "introducedIn": "4.3.0",
            "unique": false
          },
          {
            "fieldIds": [
              "receiving-owner-id",
              "delivery-acknowledgement-state"
            ],
            "id": "business-event-by-receiving-owner-and-delivery-state",
            "introducedIn": "4.3.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "event",
        "label": "Business event",
        "lifecycle": [
          "emitted",
          "delivery-pending",
          "delivered",
          "delivery-acknowledged",
          "delivery-rejected",
          "delivery-outcome-unknown",
          "processed",
          "dead-lettered",
          "replayed",
          "reconciled"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "audit-event-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "append-only-event-store",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Business events",
        "primaryKey": "business-event-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links an immutable delivery acknowledgement, rejection or reconciliation event to the attempt it addresses.",
            "id": "business-event-references-business-event-delivery-acknowledgement",
            "introducedIn": "4.3.0",
            "predicate": "references",
            "qualifiedId": "business-event-references-business-event-delivery-acknowledgement",
            "required": false,
            "sourceFieldId": "acknowledges-business-event-id",
            "targetEntityId": "business-event",
            "targetFieldId": "business-event-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links delivery evidence to the independent receiving-owner acceptance decision when one has been made.",
            "id": "business-event-governed-by-decision-owner-acceptance",
            "introducedIn": "4.3.0",
            "predicate": "governed-by",
            "qualifiedId": "business-event-governed-by-decision-owner-acceptance",
            "required": false,
            "sourceFieldId": "owner-acceptance-decision-id",
            "targetEntityId": "decision",
            "targetFieldId": "decision-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links a consequential emission, replay or acknowledgement to the exact governing authority envelope.",
            "id": "business-event-governed-by-authority-envelope-delivery-authority",
            "introducedIn": "4.3.0",
            "predicate": "governed-by",
            "qualifiedId": "business-event-governed-by-authority-envelope-delivery-authority",
            "required": false,
            "sourceFieldId": "authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          }
        ],
        "retentionClass": "operational",
        "searchTerms": [
          "event",
          "signal",
          "trigger",
          "correlation",
          "replay",
          "idempotency"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Which lifecycle transitions has this record signalled to other modules?",
              "What event version should a consumer bind to?"
            ],
            "retrievalTerms": [
              "event",
              "webhook",
              "signal",
              "subscription"
            ],
            "usage": "Publish a business-event when a procurement fact or lifecycle transition may require another module to react; delivery is a transport concern and never canonical storage."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "domain event",
              "lifecycle signal",
              "notification event"
            ],
            "concept": "reactive-business-signal"
          }
        },
        "sourceSystemRoleIds": [
          "execution-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.1.0",
        "writebackSystemRoleIds": []
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "approve",
            "commit",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "category-opportunity-radar",
          "contract-authoring-review",
          "intelligent-intake",
          "invoice-exception-triage",
          "savings-initiative",
          "sourcing-event",
          "supplier-performance-review",
          "third-party-risk-review"
        ],
        "definition": "A validated correction or reconciled outcome used in a tenant-owned evaluation set, never an application record.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable example identifier.",
            "exchangeScope": "unmapped",
            "id": "learning-example-id",
            "introducedIn": "1.0.0",
            "label": "Learning example ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "learning-evaluation-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Workblock behaviour evaluated by the example.",
            "exchangeScope": "unmapped",
            "id": "workblock-id",
            "introducedIn": "1.0.0",
            "label": "Workblock ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "learning-evaluation-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Correction, exception, adverse outcome, positive outcome or edge case.",
            "enumValues": [
              "correction",
              "exception",
              "adverse-outcome",
              "positive-outcome",
              "edge-case"
            ],
            "exchangeScope": "unmapped",
            "id": "example-type",
            "introducedIn": "1.0.0",
            "label": "Example type",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "learning-evaluation-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Stable encrypted or permissioned reference to the evaluated input.",
            "exchangeScope": "unmapped",
            "id": "input-reference",
            "introducedIn": "1.0.0",
            "label": "Input reference",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "learning-evaluation-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Validated output or invariant used for evaluation.",
            "exchangeScope": "unmapped",
            "id": "expected-output",
            "introducedIn": "1.0.0",
            "label": "Expected output",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "learning-evaluation-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Outcome type records the governed state or type within Learning example Expected output without treating absence, unknown and zero as equivalent.",
                    "id": "outcome-type",
                    "label": "Outcome type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "expected-output",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Expected status records the governed state or type within Learning example Expected output without treating absence, unknown and zero as equivalent.",
                    "id": "expected-status",
                    "label": "Expected status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "expected-output",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Assertion codes is the set carried within Learning example Expected output; its owning field governs allowed values and interpretation.",
                    "id": "assertion-codes",
                    "label": "Assertion codes",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "expected-output",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Expected value is the string component carried within Learning example Expected output; its classification and authority inherit from the owning field contract.",
                    "id": "expected-value",
                    "label": "Expected value",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "expected-output",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence item ids links this structured value to governed evidence items through evidence-item-id within Learning example Expected output.",
                    "id": "evidence-item-ids",
                    "label": "Evidence item ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links evidence item ids to governed evidence items through the canonical evidence-item-id field.",
                      "id": "learning-example-expected-output-evidence-item-ids",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "expected-output",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Policy, schema, Workblock, model and prompt versions active for the originating outcome.",
            "exchangeScope": "unmapped",
            "id": "version-context",
            "introducedIn": "1.0.0",
            "label": "Version context",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "learning-evaluation-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Workblock version is the string component carried within Learning example Version context; its classification and authority inherit from the owning field contract.",
                    "id": "workblock-version",
                    "label": "Workblock version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "version-context",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Schema version is the string component carried within Learning example Version context; its classification and authority inherit from the owning field contract.",
                    "id": "schema-version",
                    "label": "Schema version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "version-context",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Policy version is the string component carried within Learning example Version context; its classification and authority inherit from the owning field contract.",
                    "id": "policy-version",
                    "label": "Policy version",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "version-context",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Model version is the string component carried within Learning example Version context; its classification and authority inherit from the owning field contract.",
                    "id": "model-version",
                    "label": "Model version",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "version-context",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Prompt version is the string component carried within Learning example Version context; its classification and authority inherit from the owning field contract.",
                    "id": "prompt-version",
                    "label": "Prompt version",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "version-context",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Evidence supporting inclusion and expected output.",
            "exchangeScope": "unmapped",
            "id": "validation-evidence-item-ids",
            "introducedIn": "1.0.0",
            "label": "Validation evidence item IDs",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "learning-evaluation-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference-list"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "learning-example",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "learning-example-id"
            ],
            "id": "learning-example-primary",
            "introducedIn": "1.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "workblock-id",
              "example-type"
            ],
            "id": "learning-example-by-workblock-id-and-example-type",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "lifecycle-state"
            ],
            "id": "learning-example-by-status",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "document",
        "label": "Learning example",
        "lifecycle": [
          "candidate",
          "validated",
          "excluded",
          "superseded"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "learning-evaluation-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "platform-services-datastore",
            "status": "direction"
          },
          {
            "id": "governed-learning-dataset",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Learning examples",
        "primaryKey": "learning-example-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-many",
            "definition": "Links learning examples to the governed evidence item record referenced by validation evidence item ids.",
            "id": "learning-example-evidenced-by-evidence-item-validation-evidence-item-ids-to-evidence-item",
            "introducedIn": "1.1.0",
            "predicate": "evidenced-by",
            "qualifiedId": "learning-example-evidenced-by-evidence-item-validation-evidence-item-ids-to-evidence-item",
            "required": true,
            "sourceFieldId": "validation-evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "correction",
          "feedback",
          "evaluation case",
          "outcome example",
          "tenant learning"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Which validated corrections exist for this task or module?",
              "Which evaluation set does this example belong to and who validated it?"
            ],
            "retrievalTerms": [
              "learning set",
              "correction",
              "ground truth example"
            ],
            "usage": "Promote validated corrections and reconciled outcomes into tenant-owned evaluation sets as learning-examples; they are curation records, never application records."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "training example",
              "validated correction",
              "evaluation example"
            ],
            "concept": "curated-correction"
          }
        },
        "sourceSystemRoleIds": [
          "execution-system",
          "analytical-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "analytical-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "category-opportunity-radar",
          "contract-authoring-review",
          "guided-buying",
          "intelligent-intake",
          "invoice-exception-triage",
          "savings-initiative",
          "sourcing-event",
          "supplier-performance-review",
          "third-party-risk-review"
        ],
        "definition": "A versioned result over a declared evaluation suite used to promote, retain, demote or block a Workblock or authority envelope.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "internal",
            "definition": "Stable evaluation run result identifier.",
            "exchangeScope": "internal",
            "id": "evaluation-result-id",
            "introducedIn": "1.0.0",
            "label": "Evaluation result ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "learning-evaluation-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Workblock under evaluation.",
            "exchangeScope": "internal",
            "id": "workblock-id",
            "introducedIn": "1.0.0",
            "label": "Workblock ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "learning-evaluation-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Pinned Workblock, policy, model, prompt and schema candidate.",
            "exchangeScope": "internal",
            "id": "candidate-version",
            "introducedIn": "1.0.0",
            "label": "Candidate version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "learning-evaluation-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Workblock version is the string component carried within Evaluation result Candidate version; its classification and authority inherit from the owning field contract.",
                    "id": "workblock-version",
                    "label": "Workblock version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "candidate-version",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Schema version is the string component carried within Evaluation result Candidate version; its classification and authority inherit from the owning field contract.",
                    "id": "schema-version",
                    "label": "Schema version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "candidate-version",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Policy version is the string component carried within Evaluation result Candidate version; its classification and authority inherit from the owning field contract.",
                    "id": "policy-version",
                    "label": "Policy version",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "candidate-version",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Model version is the string component carried within Evaluation result Candidate version; its classification and authority inherit from the owning field contract.",
                    "id": "model-version",
                    "label": "Model version",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "candidate-version",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Prompt version is the string component carried within Evaluation result Candidate version; its classification and authority inherit from the owning field contract.",
                    "id": "prompt-version",
                    "label": "Prompt version",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "candidate-version",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Immutable evaluation suite and fixture version.",
            "exchangeScope": "internal",
            "id": "suite-version",
            "introducedIn": "1.0.0",
            "label": "Suite version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "learning-evaluation-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Per-check outcome, measured error and evidence reference; no unexplained aggregate score.",
            "exchangeScope": "internal",
            "id": "check-results",
            "introducedIn": "1.0.0",
            "label": "Check results",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "learning-evaluation-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Check ID is the string component carried within Evaluation result Check results; its classification and authority inherit from the owning field contract.",
                    "id": "check-id",
                    "label": "Check ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "check-results",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Outcome is the string component carried within Evaluation result Check results; its classification and authority inherit from the owning field contract.",
                    "id": "outcome",
                    "label": "Outcome",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "check-results",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Observed at is the timestamp component carried within Evaluation result Check results; its classification and authority inherit from the owning field contract.",
                    "id": "observed-at",
                    "label": "Observed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "check-results",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Measured error is the decimal component carried within Evaluation result Check results; its classification and authority inherit from the owning field contract.",
                    "id": "measured-error",
                    "label": "Measured error",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "check-results",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Error unit is the string component carried within Evaluation result Check results; its classification and authority inherit from the owning field contract.",
                    "id": "error-unit",
                    "label": "Error unit",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "check-results",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence item ID links this structured value to the governed evidence-item record within Evaluation result Check results.",
                    "id": "evidence-item-id",
                    "label": "Evidence item ID",
                    "nullable": true,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the evidence item ID in check results to the referenced evidence item via its canonical evidence item ID.",
                      "id": "evaluation-result-check-results-evidence-item-id",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "check-results",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Detail is the string component carried within Evaluation result Check results; its classification and authority inherit from the owning field contract.",
                    "id": "detail",
                    "label": "Detail",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "check-results",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ],
                "uniqueBy": [
                  "check-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Explicit promote, retain, demote or block recommendation with owner decision separate when required.",
            "enumValues": [
              "promote",
              "retain",
              "demote",
              "block",
              "inconclusive"
            ],
            "exchangeScope": "internal",
            "id": "disposition",
            "introducedIn": "1.0.0",
            "label": "Disposition",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "learning-evaluation-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "UTC completion timestamp when terminal.",
            "exchangeScope": "mapped",
            "format": "ISO 8601 UTC",
            "id": "completed-at",
            "introducedIn": "1.0.0",
            "label": "Completed at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "learning-evaluation-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "conceptId": "date-time-value",
                "coverage": "semantic",
                "direction": "outbound",
                "exchangeScope": "edge-interchange",
                "mappingKind": "value-format",
                "path": "completedAt",
                "releaseId": "iso-8601-1-2019",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-8601",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "evaluation-result",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "evaluation-result-id"
            ],
            "id": "evaluation-result-primary",
            "introducedIn": "1.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "workblock-id",
              "candidate-version"
            ],
            "id": "evaluation-result-by-workblock-id-and-candidate-version",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "lifecycle-state",
              "completed-at"
            ],
            "id": "evaluation-result-by-status-and-completed-at",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "metric",
        "label": "Evaluation result",
        "lifecycle": [
          "running",
          "passed",
          "failed",
          "inconclusive",
          "superseded"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "learning-evaluation-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "platform-services-datastore",
            "status": "direction"
          },
          {
            "id": "governed-learning-dataset",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Evaluation results",
        "primaryKey": "evaluation-result-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [],
        "retentionClass": "evidence",
        "searchTerms": [
          "eval",
          "regression",
          "promotion",
          "canary",
          "shadow",
          "harm test",
          "drift"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Does the current evaluation permit promoting or retaining this Workblock or grant?",
              "Which suite version produced this result and with what score?"
            ],
            "retrievalTerms": [
              "evaluation suite",
              "promotion gate",
              "quality score"
            ],
            "usage": "Read evaluation-results to promote, retain, demote or block a Workblock or authority envelope; results are versioned over a declared suite and never overwritten."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "eval result",
              "benchmark result",
              "promotion evidence"
            ],
            "concept": "suite-evaluation-outcome"
          }
        },
        "sourceSystemRoleIds": [
          "analytical-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": []
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": false,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "category-opportunity-radar",
          "contract-authoring-review",
          "demand-orchestration",
          "guided-buying",
          "intelligent-intake",
          "invoice-exception-triage",
          "payment-readiness",
          "savings-initiative",
          "sourcing-event",
          "supplier-onboarding",
          "supplier-performance-review"
        ],
        "definition": "Current observable health, freshness, last success and recovery state of a source or writeback adapter.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "internal",
            "definition": "Stable state-record identifier.",
            "exchangeScope": "internal",
            "id": "integration-state-id",
            "introducedIn": "1.0.0",
            "label": "Integration state ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "integration-state-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Governed adapter or source identifier.",
            "exchangeScope": "internal",
            "id": "integration-id",
            "introducedIn": "1.0.0",
            "label": "Integration ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "integration-state-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "UTC instant of the last confirmed successful read or writeback cycle.",
            "exchangeScope": "mapped",
            "format": "ISO 8601 UTC",
            "id": "last-successful-sync-at",
            "introducedIn": "1.0.0",
            "label": "Last successful sync at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "integration-state-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "conceptId": "date-time-value",
                "coverage": "semantic",
                "direction": "outbound",
                "exchangeScope": "edge-interchange",
                "mappingKind": "value-format",
                "path": "lastSuccessfulSyncAt",
                "releaseId": "iso-8601-1-2019",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-8601",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          },
          {
            "classification": "confidential",
            "definition": "Sanitized stable error class, not raw secrets or payload.",
            "exchangeScope": "internal",
            "id": "last-error-code",
            "introducedIn": "1.0.0",
            "label": "Last error code",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "integration-state-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Reference to the most recent usable projection or snapshot produced by this integration.",
            "exchangeScope": "internal",
            "id": "last-good-reference",
            "introducedIn": "1.0.0",
            "label": "Last-good reference",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "integration-state-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "UTC instant at which the state record was last evaluated.",
            "exchangeScope": "mapped",
            "format": "ISO 8601 UTC",
            "id": "updated-at",
            "introducedIn": "1.0.0",
            "label": "Updated at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "integration-state-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "conceptId": "date-time-value",
                "coverage": "semantic",
                "direction": "outbound",
                "exchangeScope": "edge-interchange",
                "mappingKind": "value-format",
                "path": "updatedAt",
                "releaseId": "iso-8601-1-2019",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-8601",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "integration-state",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "integration-state-id"
            ],
            "id": "integration-state-primary",
            "introducedIn": "1.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "integration-id"
            ],
            "id": "integration-state-by-integration-id",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "lifecycle-state"
            ],
            "id": "integration-state-by-status",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "control",
        "label": "Integration state",
        "lifecycle": [
          "healthy",
          "degraded",
          "blocked",
          "recovering",
          "disabled"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "integration-state-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "platform-services-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Integration states",
        "primaryKey": "integration-state-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [],
        "retentionClass": "operational",
        "searchTerms": [
          "integration",
          "adapter",
          "source health",
          "writeback",
          "last sync",
          "degraded"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Is the source or writeback adapter healthy, and when did it last succeed?",
              "What recovery state applies to this integration right now?"
            ],
            "retrievalTerms": [
              "connector",
              "adapter",
              "last success",
              "degraded"
            ],
            "usage": "Consult integration-state before trusting freshness of sourced data or attempting writeback; degraded adapters make last-good data visible rather than hiding it."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "connector status",
              "adapter health",
              "sync state"
            ],
            "concept": "adapter-health-state"
          }
        },
        "sourceSystemRoleIds": [
          "execution-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": []
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "contract-authoring-review",
          "demand-orchestration",
          "guided-buying",
          "invoice-exception-triage",
          "policy-guidance",
          "savings-initiative",
          "sourcing-event",
          "supplier-onboarding",
          "supplier-performance-review"
        ],
        "definition": "An immutable versioned release of Accenture GroundWorks entity, field, relationship, mapping and vocabulary contracts.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "internal",
            "definition": "Immutable timestamped release identifier.",
            "exchangeScope": "internal",
            "format": "UTC timestamp plus release digest",
            "id": "registry-release-id",
            "introducedIn": "1.0.0",
            "label": "Registry release ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Semantic version of the logical contract.",
            "exchangeScope": "internal",
            "format": "SemVer",
            "id": "registry-version",
            "introducedIn": "1.0.0",
            "label": "Registry version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Immediate logical predecessor when present.",
            "exchangeScope": "internal",
            "format": "SemVer",
            "id": "previous-version",
            "introducedIn": "1.0.0",
            "label": "Previous version",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Deterministic hash of the complete resolved registry.",
            "exchangeScope": "internal",
            "format": "SHA-256",
            "id": "content-hash",
            "introducedIn": "1.0.0",
            "label": "Content hash",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Patch, additive-compatible or breaking semantic change.",
            "enumValues": [
              "patch",
              "additive-compatible",
              "breaking"
            ],
            "exchangeScope": "internal",
            "id": "compatibility-class",
            "introducedIn": "1.0.0",
            "label": "Compatibility class",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Human-readable summary linked to exact entity and field changes.",
            "exchangeScope": "internal",
            "id": "change-summary",
            "introducedIn": "1.0.0",
            "label": "Change summary",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "text"
          },
          {
            "classification": "restricted",
            "definition": "Immutable ordered expand, backfill, validate, contract and rollback references.",
            "exchangeScope": "internal",
            "id": "migration-references",
            "introducedIn": "1.0.0",
            "label": "Migration references",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Sequence is the integer component carried within Registry release Migration references; its classification and authority inherit from the owning field contract.",
                    "id": "sequence",
                    "label": "Sequence",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "migration-references",
                      "kind": "inherited-field"
                    },
                    "type": "integer"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Phase is the string component carried within Registry release Migration references; its classification and authority inherit from the owning field contract.",
                    "id": "phase",
                    "label": "Phase",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "migration-references",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Artifact reference is the string component carried within Registry release Migration references; its classification and authority inherit from the owning field contract.",
                    "id": "artifact-reference",
                    "label": "Artifact reference",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "migration-references",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Checksum is the string component carried within Registry release Migration references; its classification and authority inherit from the owning field contract.",
                    "id": "checksum",
                    "label": "Checksum",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "migration-references",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Rollback reference is the string component carried within Registry release Migration references; its classification and authority inherit from the owning field contract.",
                    "id": "rollback-reference",
                    "label": "Rollback reference",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "migration-references",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ],
                "uniqueBy": [
                  "sequence"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "UTC release timestamp when active or superseded.",
            "exchangeScope": "mapped",
            "format": "ISO 8601 UTC",
            "id": "released-at",
            "introducedIn": "1.0.0",
            "label": "Released at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "conceptId": "date-time-value",
                "coverage": "semantic",
                "direction": "outbound",
                "exchangeScope": "edge-interchange",
                "mappingKind": "value-format",
                "path": "releasedAt",
                "releaseId": "iso-8601-1-2019",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-8601",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "registry-release",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "registry-release-id"
            ],
            "id": "registry-release-primary",
            "introducedIn": "1.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "registry-version"
            ],
            "id": "registry-release-by-registry-version",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "lifecycle-state"
            ],
            "id": "registry-release-by-status",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "control",
        "label": "Registry release",
        "lifecycle": [
          "draft",
          "validated",
          "active",
          "superseded",
          "rolled-back"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "registry-governance-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "platform-services-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Registry releases",
        "primaryKey": "registry-release-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [],
        "retentionClass": "policy",
        "searchTerms": [
          "schema version",
          "data model release",
          "migration",
          "compatibility",
          "SemVer"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Which registry release is this consumer pinned to?",
              "What changed between two registry releases?"
            ],
            "retrievalTerms": [
              "release",
              "version pin",
              "contract version"
            ],
            "usage": "Pin consumers to an immutable registry-release of entity, field, relationship, mapping and vocabulary contracts; version claims resolve against releases, never against a mutable head."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "schema release",
              "model release"
            ],
            "concept": "contract-release"
          }
        },
        "sourceSystemRoleIds": [
          "system-of-record"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": []
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "approve",
            "commit",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": false,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "spend-data-foundation"
        ],
        "definition": "An immutable, company-scoped release of the canonical procurement category taxonomy, including its effective state and predecessor.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "internal",
            "definition": "Stable identifier for the immutable company taxonomy release.",
            "exchangeScope": "unmapped",
            "format": "uuid",
            "id": "taxonomy-version-id",
            "introducedIn": "1.0.0",
            "label": "Taxonomy version ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Company whose procurement taxonomy this version governs; it is independent of the enforcing tenant boundary.",
            "exchangeScope": "unmapped",
            "id": "company-party-id",
            "introducedIn": "1.0.0",
            "label": "Company party ID",
            "nullable": false,
            "referenceEntityId": "party",
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Company-controlled immutable release code unique within the company scope.",
            "exchangeScope": "unmapped",
            "id": "version-code",
            "introducedIn": "1.0.0",
            "label": "Version code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Digest of the ordered category membership and parent links in this immutable version.",
            "exchangeScope": "unmapped",
            "format": "sha256",
            "id": "content-hash",
            "introducedIn": "1.0.0",
            "label": "Content hash",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Business-effective timestamp from which this version may resolve category assignments.",
            "exchangeScope": "unmapped",
            "format": "date-time",
            "id": "effective-from",
            "introducedIn": "1.0.0",
            "label": "Effective from",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Immediate predecessor replaced by this version, when one exists.",
            "exchangeScope": "unmapped",
            "id": "supersedes-taxonomy-version-id",
            "introducedIn": "1.0.0",
            "label": "Supersedes taxonomy version ID",
            "nullable": true,
            "referenceEntityId": "taxonomy-version",
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "taxonomy-version",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "taxonomy-version-id"
            ],
            "id": "taxonomy-version-primary",
            "introducedIn": "1.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "company-party-id",
              "version-code"
            ],
            "id": "taxonomy-version-by-company-party-id-and-version-code",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "company-party-id",
              "lifecycle-state"
            ],
            "id": "taxonomy-version-by-company-party-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "reference",
        "label": "Taxonomy version",
        "lifecycle": [
          "draft",
          "approved",
          "active",
          "superseded"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "shared-ledger-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "platform-services-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Taxonomy versions",
        "primaryKey": "taxonomy-version-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Scopes the taxonomy version to the company whose category meaning it governs.",
            "id": "taxonomy-version-references-party-taxonomy-version-company",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "taxonomy-version-references-party-taxonomy-version-company",
            "required": true,
            "sourceFieldId": "company-party-id",
            "targetEntityId": "party",
            "targetFieldId": "party-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links a taxonomy version to its immediate predecessor without rewriting either release.",
            "id": "taxonomy-version-supersedes-taxonomy-version-taxonomy-version-predecessor",
            "introducedIn": "1.0.0",
            "predicate": "supersedes",
            "qualifiedId": "taxonomy-version-supersedes-taxonomy-version-taxonomy-version-predecessor",
            "required": false,
            "sourceFieldId": "supersedes-taxonomy-version-id",
            "targetEntityId": "taxonomy-version",
            "targetFieldId": "taxonomy-version-id"
          }
        ],
        "retentionClass": "reference",
        "searchTerms": [
          "category taxonomy release",
          "taxonomy version",
          "category hierarchy version"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Which taxonomy version is currently effective for this company?",
              "Under which taxonomy version was this classification made?"
            ],
            "retrievalTerms": [
              "taxonomy snapshot",
              "effective taxonomy",
              "category version"
            ],
            "usage": "Resolve categories only within a named taxonomy-version; assignments and classifications carry the version they were made under and survive later releases unchanged."
          },
          "introducedIn": "4.7.0",
          "semanticLabel": {
            "aliases": [
              "category tree version",
              "taxonomy release"
            ],
            "concept": "taxonomy-release"
          }
        },
        "sourceSystemRoleIds": [
          "system-of-record"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "approve",
            "commit",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": false,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [],
        "definition": "A node in the governed company classification master index: the canonical NACE Rev. 2.1 tree of economic activities used to classify companies, with linked external classifications that never replace the canonical key.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "internal",
            "definition": "Stable canonical identifier for the classification node, independent of taxonomy codes.",
            "exchangeScope": "unmapped",
            "format": "uuid",
            "id": "company-classification-category-id",
            "introducedIn": "4.4.0",
            "label": "Company classification category ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Classification code exactly as published by the taxonomy steward, such as the NACE Rev. 2.1 codes C, 10, 10.1 and 10.11; unique within the taxonomy version.",
            "exchangeScope": "unmapped",
            "id": "code",
            "introducedIn": "4.4.0",
            "label": "Code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Published heading of the classification node.",
            "exchangeScope": "unmapped",
            "id": "name",
            "introducedIn": "4.4.0",
            "label": "Name",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Hierarchy level of the node within the classification tree.",
            "enumValues": [
              "section",
              "division",
              "group",
              "class"
            ],
            "exchangeScope": "unmapped",
            "id": "level",
            "introducedIn": "4.4.0",
            "label": "Level",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Optional parent node in the same taxonomy version; sections carry no parent.",
            "exchangeScope": "unmapped",
            "id": "parent-company-classification-category-id",
            "introducedIn": "4.4.0",
            "label": "Parent company classification category ID",
            "nullable": true,
            "referenceEntityId": "company-classification-category",
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Required governed reference to the immutable taxonomy release containing this classification node.",
            "exchangeScope": "unmapped",
            "id": "taxonomy-version-id",
            "introducedIn": "4.4.0",
            "label": "Taxonomy version ID",
            "nullable": false,
            "referenceEntityId": "taxonomy-version",
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Namespaced, versioned external classification links such as ISIC Rev. 5, NAICS 2022 and UK SIC 2007 codes; linked classifications never replace the canonical key.",
            "exchangeScope": "unmapped",
            "id": "external-classification",
            "introducedIn": "4.4.0",
            "label": "External classification",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "external-classification-value",
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "UTC timestamp of the current canonical version.",
            "exchangeScope": "mapped",
            "format": "ISO 8601 UTC",
            "id": "updated-at",
            "introducedIn": "4.4.0",
            "label": "Updated at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "conceptId": "date-time-value",
                "coverage": "semantic",
                "direction": "outbound",
                "exchangeScope": "edge-interchange",
                "mappingKind": "value-format",
                "path": "updatedAt",
                "releaseId": "iso-8601-1-2019",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-8601",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "company-classification-category",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "company-classification-category-id"
            ],
            "id": "company-classification-category-primary",
            "introducedIn": "4.4.0",
            "unique": true
          },
          {
            "fieldIds": [
              "taxonomy-version-id",
              "code"
            ],
            "id": "company-classification-category-by-taxonomy-version-id-and-code",
            "introducedIn": "4.4.0",
            "unique": true
          },
          {
            "fieldIds": [
              "parent-company-classification-category-id"
            ],
            "id": "company-classification-category-by-parent-company-classification-category-id",
            "introducedIn": "4.4.0",
            "unique": false
          },
          {
            "fieldIds": [
              "level"
            ],
            "id": "company-classification-category-by-level",
            "introducedIn": "4.4.0",
            "unique": false
          }
        ],
        "introducedIn": "4.4.0",
        "kind": "reference",
        "label": "Company classification category",
        "lifecycle": [
          "draft",
          "active",
          "superseded",
          "retired"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "shared-ledger-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "platform-services-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Company classification categories",
        "primaryKey": "company-classification-category-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Optional parent classification node in the same taxonomy version.",
            "id": "company-classification-category-classified-as-company-classification-category-company-classification-category-parent",
            "introducedIn": "4.4.0",
            "predicate": "classified-as",
            "qualifiedId": "company-classification-category-classified-as-company-classification-category-company-classification-category-parent",
            "required": false,
            "sourceFieldId": "parent-company-classification-category-id",
            "targetEntityId": "company-classification-category",
            "targetFieldId": "company-classification-category-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Governed taxonomy version containing the classification node.",
            "id": "company-classification-category-belongs-to-taxonomy-version-company-classification-category-taxonomy-version",
            "introducedIn": "4.4.0",
            "predicate": "belongs-to",
            "qualifiedId": "company-classification-category-belongs-to-taxonomy-version-company-classification-category-taxonomy-version",
            "required": true,
            "sourceFieldId": "taxonomy-version-id",
            "targetEntityId": "taxonomy-version",
            "targetFieldId": "taxonomy-version-id"
          }
        ],
        "retentionClass": "reference",
        "searchTerms": [
          "industry classification",
          "NACE",
          "company classification",
          "ISIC",
          "economic activity",
          "industry code"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Which canonical economic-activity node classifies this supplier?",
              "Which external classification codes are linked to this canonical node?",
              "Which companies fall under this branch of the activity tree?"
            ],
            "retrievalTerms": [
              "NACE Rev. 2.1",
              "SIC",
              "industry sector",
              "line of business",
              "supplier segmentation"
            ],
            "usage": "Resolve a company's line of business to a node in the governed canonical economic-activity tree; treat external scheme codes as linked classifications and never as the canonical key."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "NACE code",
              "industry classification",
              "economic activity code",
              "company category"
            ],
            "concept": "company-economic-activity-classification-node",
            "doNotConfuseWith": [
              {
                "distinction": "A company classification category classifies what a company does in the canonical economic-activity tree; category is the company-scoped procurement taxonomy node that classifies what is bought.",
                "targetEntityId": "category"
              },
              {
                "distinction": "The classification node is reference data; party is the classified participant, linked to nodes through its classification attributes.",
                "targetEntityId": "party"
              }
            ]
          },
          "standardsAlignment": [
            {
              "concept": "Product and service classification used alongside activity classification in supplier categorisation",
              "matchKind": "related",
              "standardId": "unspsc"
            },
            {
              "concept": "Procurement subject-matter classification correlated with supplier economic activity",
              "matchKind": "related",
              "standardId": "cpv"
            }
          ]
        },
        "sourceSystemRoleIds": [
          "system-of-record"
        ],
        "storageClass": "tenant-record",
        "version": "1.0.0",
        "writebackSystemRoleIds": [
          "system-of-record"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "approve",
            "commit",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "spend-data-foundation"
        ],
        "definition": "An effective-dated, company- and taxonomy-scoped assignment of one governed dimension member to a category, with explicit inheritance and decision provenance.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for this effective-dated assignment decision.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "category-dimension-assignment-id",
            "introducedIn": "1.0.0",
            "label": "Category dimension assignment ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Company relative to which the category receives the dimension member.",
            "exchangeScope": "internal",
            "id": "company-party-id",
            "introducedIn": "1.0.0",
            "label": "Company party ID",
            "nullable": false,
            "referenceEntityId": "party",
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Optional narrower accountable scope when the approved company policy permits it.",
            "exchangeScope": "internal",
            "id": "business-unit-id",
            "introducedIn": "1.0.0",
            "label": "Business unit ID",
            "nullable": true,
            "referenceEntityId": "business-unit",
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Immutable category-taxonomy release within which the assignment resolves.",
            "exchangeScope": "internal",
            "id": "taxonomy-version-id",
            "introducedIn": "1.0.0",
            "label": "Taxonomy version ID",
            "nullable": false,
            "referenceEntityId": "taxonomy-version",
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Exact canonical category receiving the assignment.",
            "exchangeScope": "internal",
            "id": "category-id",
            "introducedIn": "1.0.0",
            "label": "Category ID",
            "nullable": false,
            "referenceEntityId": "category",
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Stable GroundWorks dimension whose member is being assigned.",
            "exchangeScope": "internal",
            "id": "dimension-id",
            "introducedIn": "1.0.0",
            "label": "Dimension ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Governed member within the stated dimension; unresolved is represented by absence of an active assignment, not by a member value.",
            "exchangeScope": "internal",
            "id": "member-id",
            "introducedIn": "1.0.0",
            "label": "Member ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Whether the member applies only to the exact category or may be inherited by unassigned descendants in the same taxonomy version.",
            "enumValues": [
              "exact-only",
              "exact-and-descendants"
            ],
            "exchangeScope": "internal",
            "id": "inheritance-mode",
            "introducedIn": "1.0.0",
            "label": "Inheritance mode",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Inclusive business-effective timestamp for the assignment.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "effective-from",
            "introducedIn": "1.0.0",
            "label": "Effective from",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Optional exclusive timestamp after which this assignment cannot resolve a transaction.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "effective-until",
            "introducedIn": "1.0.0",
            "label": "Effective until",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Governed method by which the assignment entered the committed record.",
            "enumValues": [
              "human-approved",
              "governed-import",
              "migration"
            ],
            "exchangeScope": "internal",
            "id": "source-method",
            "introducedIn": "1.0.0",
            "label": "Source method",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Typed authority-system reference for the person, role or service responsible for the assignment transition.",
            "exchangeScope": "internal",
            "id": "actor-reference",
            "introducedIn": "1.0.0",
            "label": "Actor reference",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Governed evidence supporting the assignment and its approval.",
            "exchangeScope": "internal",
            "id": "evidence-item-ids",
            "introducedIn": "1.0.0",
            "label": "Evidence item IDs",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "confidential",
            "definition": "Immediate assignment version replaced by this decision, preserving the prior value and rationale.",
            "exchangeScope": "internal",
            "id": "supersedes-assignment-id",
            "introducedIn": "1.0.0",
            "label": "Supersedes assignment ID",
            "nullable": true,
            "referenceEntityId": "category-dimension-assignment",
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "category-dimension-assignment",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "category-dimension-assignment-id"
            ],
            "id": "category-dimension-assignment-primary",
            "introducedIn": "1.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "company-party-id",
              "taxonomy-version-id",
              "category-id",
              "dimension-id",
              "effective-from"
            ],
            "id": "category-dimension-assignment-by-company-party-id-and-taxonomy-version-id-and-category-id-and-dimension-id-and-effective-from",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "dimension-id",
              "member-id",
              "lifecycle-state"
            ],
            "id": "category-dimension-assignment-by-dimension-id-and-member-id-and-state",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "assignment",
        "label": "Category dimension assignment",
        "lifecycle": [
          "proposed",
          "approved",
          "active",
          "superseded",
          "retired"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "shared-ledger-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "platform-services-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Category dimension assignments",
        "primaryKey": "category-dimension-assignment-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Scopes the assignment to the company for which its dimension meaning applies.",
            "id": "category-dimension-assignment-classified-as-party-category-assignment-company",
            "introducedIn": "1.0.0",
            "predicate": "classified-as",
            "qualifiedId": "category-dimension-assignment-classified-as-party-category-assignment-company",
            "required": true,
            "sourceFieldId": "company-party-id",
            "targetEntityId": "party",
            "targetFieldId": "party-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Narrows the assignment to an approved business-unit scope when present.",
            "id": "category-dimension-assignment-classified-as-business-unit-category-assignment-business-unit",
            "introducedIn": "1.0.0",
            "predicate": "classified-as",
            "qualifiedId": "category-dimension-assignment-classified-as-business-unit-category-assignment-business-unit",
            "required": false,
            "sourceFieldId": "business-unit-id",
            "targetEntityId": "business-unit",
            "targetFieldId": "business-unit-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Binds the assignment to one immutable taxonomy version.",
            "id": "category-dimension-assignment-classified-as-taxonomy-version-category-assignment-taxonomy-version",
            "introducedIn": "1.0.0",
            "predicate": "classified-as",
            "qualifiedId": "category-dimension-assignment-classified-as-taxonomy-version-category-assignment-taxonomy-version",
            "required": true,
            "sourceFieldId": "taxonomy-version-id",
            "targetEntityId": "taxonomy-version",
            "targetFieldId": "taxonomy-version-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Names the exact category at which resolution starts before nearest-ancestor inheritance.",
            "id": "category-dimension-assignment-classified-as-category-category-assignment-category",
            "introducedIn": "1.0.0",
            "predicate": "classified-as",
            "qualifiedId": "category-dimension-assignment-classified-as-category-category-assignment-category",
            "required": true,
            "sourceFieldId": "category-id",
            "targetEntityId": "category",
            "targetFieldId": "category-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the assignment to its governed supporting evidence.",
            "id": "category-dimension-assignment-evidenced-by-evidence-item-category-assignment-evidence",
            "introducedIn": "1.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "category-dimension-assignment-evidenced-by-evidence-item-category-assignment-evidence",
            "required": true,
            "sourceFieldId": "evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Preserves the assignment superseded by this version.",
            "id": "category-dimension-assignment-supersedes-category-dimension-assignment-category-assignment-predecessor",
            "introducedIn": "1.0.0",
            "predicate": "supersedes",
            "qualifiedId": "category-dimension-assignment-supersedes-category-dimension-assignment-category-assignment-predecessor",
            "required": false,
            "sourceFieldId": "supersedes-assignment-id",
            "targetEntityId": "category-dimension-assignment",
            "targetFieldId": "category-dimension-assignment-id"
          }
        ],
        "retentionClass": "policy",
        "searchTerms": [
          "category assignment",
          "spend segment assignment",
          "category inheritance"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Which dimension member applies to this category, and is it assigned or inherited?",
              "Who decided this assignment and when does it take effect?"
            ],
            "retrievalTerms": [
              "spend segment",
              "buying mode",
              "dimension member",
              "inheritance"
            ],
            "usage": "Attach governed dimension members to categories through effective-dated assignments with explicit inheritance and decision provenance; never store dimension values as loose attributes."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "dimension tag",
              "category attribute assignment"
            ],
            "concept": "governed-dimension-assignment"
          }
        },
        "sourceSystemRoleIds": [
          "system-of-record",
          "execution-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "export"
          ],
          "deletePolicy": "immutable",
          "exportRequiresAuthority": true,
          "fieldFiltering": false,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [],
        "definition": "A governed human-role definition used by authority, job and involvement contracts; a role is not a persona or a person.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "internal",
            "definition": "Stable identifier for this role record.",
            "exchangeScope": "unmapped",
            "id": "role-id",
            "introducedIn": "4.0.0",
            "label": "Role ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Governed locale key for the public role label.",
            "exchangeScope": "unmapped",
            "id": "label-key",
            "introducedIn": "4.0.0",
            "label": "Label key",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Governed locale key for the role definition.",
            "exchangeScope": "unmapped",
            "id": "description-key",
            "introducedIn": "4.0.0",
            "label": "Description key",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          }
        ],
        "freshnessContract": {
          "degradedAction": "not-applicable",
          "lastGoodPolicy": "not-applicable",
          "observationMode": "immutable",
          "sourceHealthRequired": false,
          "thresholdPolicy": "not-applicable"
        },
        "id": "role",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "role-id"
            ],
            "id": "role-primary",
            "introducedIn": "4.0.0",
            "unique": true
          }
        ],
        "introducedIn": "4.0.0",
        "kind": "role",
        "label": "Role",
        "lifecycle": [
          "active",
          "deprecated"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "registry-governance-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "framework-content",
            "status": "direction"
          }
        ],
        "pluralLabel": "Roles",
        "primaryKey": "role-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [],
        "retentionClass": "reference",
        "searchTerms": [
          "role",
          "authority",
          "responsibility",
          "accountability"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Which role is accountable for this job or decision class?",
              "What authority does this role carry in this Workblock?"
            ],
            "retrievalTerms": [
              "category manager",
              "buyer",
              "approver role",
              "accountability"
            ],
            "usage": "Bind authority, job and involvement contracts to governed roles; a role is neither a persona nor a person and is never invented ad hoc."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "job role",
              "responsibility definition"
            ],
            "concept": "governed-human-role",
            "doNotConfuseWith": [
              {
                "distinction": "A role is a governed definition; a person is the individual who may hold it through an assignment.",
                "targetEntityId": "person"
              }
            ]
          }
        },
        "sourceSystemRoleIds": [
          "system-of-record"
        ],
        "storageClass": "framework-definition",
        "version": "4.0.0",
        "writebackSystemRoleIds": []
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "approve",
            "commit",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": false,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [],
        "definition": "An effective-dated assignment of a person to a governed role within company scope, with granting authority and evidence.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "internal",
            "definition": "Stable identifier for this person role assignment record.",
            "exchangeScope": "unmapped",
            "id": "person-role-assignment-id",
            "introducedIn": "4.0.0",
            "label": "Person role assignment ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Company within which the role assignment is valid.",
            "exchangeScope": "unmapped",
            "id": "company-party-id",
            "introducedIn": "4.0.0",
            "label": "Company party ID",
            "nullable": false,
            "referenceEntityId": "party",
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Person receiving the governed role.",
            "exchangeScope": "unmapped",
            "id": "person-id",
            "introducedIn": "4.0.0",
            "label": "Person ID",
            "nullable": false,
            "referenceEntityId": "person",
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Governed role assigned to the person.",
            "exchangeScope": "unmapped",
            "id": "role-id",
            "introducedIn": "4.0.0",
            "label": "Role ID",
            "nullable": false,
            "referenceEntityId": "role",
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Inclusive start of the assignment.",
            "exchangeScope": "unmapped",
            "id": "effective-from",
            "introducedIn": "4.0.0",
            "label": "Effective from",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "End of the assignment when bounded.",
            "exchangeScope": "unmapped",
            "id": "effective-to",
            "introducedIn": "4.0.0",
            "label": "Effective to",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Typed person or role reference that granted this assignment.",
            "exchangeScope": "unmapped",
            "id": "granted-by-ref",
            "introducedIn": "4.0.0",
            "label": "Granted by",
            "nullable": false,
            "referenceTargetEntityIds": [
              "person",
              "role"
            ],
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "record-reference-value",
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Authority envelope under which this assignment was granted.",
            "exchangeScope": "unmapped",
            "id": "authority-envelope-id",
            "introducedIn": "4.0.0",
            "label": "Authority envelope ID",
            "nullable": false,
            "referenceEntityId": "authority-envelope",
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Evidence supporting the role assignment.",
            "exchangeScope": "unmapped",
            "id": "evidence-item-ids",
            "introducedIn": "4.0.0",
            "label": "Evidence item IDs",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference-list"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "person-role-assignment",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "person-role-assignment-id"
            ],
            "id": "person-role-assignment-primary",
            "introducedIn": "4.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "person-id",
              "role-id",
              "effective-from"
            ],
            "id": "person-role-assignment-by-person-and-role-and-effective-from",
            "introducedIn": "4.0.0",
            "unique": true
          }
        ],
        "introducedIn": "4.0.0",
        "kind": "assignment",
        "label": "Person role assignment",
        "lifecycle": [
          "proposed",
          "approved",
          "active",
          "superseded",
          "retired"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "registry-governance-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "platform-services-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Person role assignments",
        "primaryKey": "person-role-assignment-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Person who holds the role.",
            "id": "person-role-assignment-assigned-to-person-assignment-person",
            "introducedIn": "4.0.0",
            "predicate": "assigned-to",
            "qualifiedId": "person-role-assignment-assigned-to-person-assignment-person",
            "required": false,
            "sourceFieldId": "person-id",
            "targetEntityId": "person",
            "targetFieldId": "person-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Governed role held by the person.",
            "id": "person-role-assignment-assigned-to-role-assignment-role",
            "introducedIn": "4.0.0",
            "predicate": "assigned-to",
            "qualifiedId": "person-role-assignment-assigned-to-role-assignment-role",
            "required": false,
            "sourceFieldId": "role-id",
            "targetEntityId": "role",
            "targetFieldId": "role-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Company scope for the assignment.",
            "id": "person-role-assignment-belongs-to-party-assignment-company",
            "introducedIn": "4.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "person-role-assignment-belongs-to-party-assignment-company",
            "required": false,
            "sourceFieldId": "company-party-id",
            "targetEntityId": "party",
            "targetFieldId": "party-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authority envelope governing the assignment.",
            "id": "person-role-assignment-governed-by-authority-envelope-assignment-authority",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "person-role-assignment-governed-by-authority-envelope-assignment-authority",
            "required": false,
            "sourceFieldId": "authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Evidence supporting the assignment.",
            "id": "person-role-assignment-evidenced-by-evidence-item-assignment-evidence",
            "introducedIn": "4.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "person-role-assignment-evidenced-by-evidence-item-assignment-evidence",
            "required": false,
            "sourceFieldId": "evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          }
        ],
        "retentionClass": "policy",
        "searchTerms": [
          "role assignment",
          "person authority",
          "effective role"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Who holds this role for this company scope today?",
              "Who granted the assignment and on what evidence?"
            ],
            "retrievalTerms": [
              "role holder",
              "assignment",
              "grant",
              "effective date"
            ],
            "usage": "Resolve who currently holds a role through effective-dated person-role-assignments with granting authority and evidence; never infer role holding from titles or free text."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "role grant",
              "assignment record"
            ],
            "concept": "role-assignment"
          }
        },
        "sourceSystemRoleIds": [
          "identity-authority"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "identity-authority"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "export"
          ],
          "deletePolicy": "immutable",
          "exportRequiresAuthority": true,
          "fieldFiltering": false,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [],
        "definition": "A globally addressable procurement job-to-be-done linked to one role, one business module and the execution flows that fulfil it.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "internal",
            "definition": "Stable identifier for this job record.",
            "exchangeScope": "unmapped",
            "id": "job-id",
            "introducedIn": "4.0.0",
            "label": "Job ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Business module accountable for fulfilling this job.",
            "exchangeScope": "unmapped",
            "id": "business-module-id",
            "introducedIn": "4.0.0",
            "label": "Business module ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Role whose outcome this job expresses.",
            "exchangeScope": "unmapped",
            "id": "role-id",
            "introducedIn": "4.0.0",
            "label": "Role ID",
            "nullable": false,
            "referenceEntityId": "role",
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Governed locale key for the job story.",
            "exchangeScope": "unmapped",
            "id": "story-key",
            "introducedIn": "4.0.0",
            "label": "Story key",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Governed locale key for observable completion evidence.",
            "exchangeScope": "unmapped",
            "id": "completion-key",
            "introducedIn": "4.0.0",
            "label": "Completion key",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Qualified execution flows that fulfil the job.",
            "exchangeScope": "unmapped",
            "id": "execution-flow-ids",
            "introducedIn": "4.0.0",
            "label": "Execution flow IDs",
            "listSemantics": "set",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "registry-governance-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string-list"
          }
        ],
        "freshnessContract": {
          "degradedAction": "not-applicable",
          "lastGoodPolicy": "not-applicable",
          "observationMode": "immutable",
          "sourceHealthRequired": false,
          "thresholdPolicy": "not-applicable"
        },
        "id": "job",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "job-id"
            ],
            "id": "job-primary",
            "introducedIn": "4.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "business-module-id",
              "role-id"
            ],
            "id": "job-by-business-module-and-role",
            "introducedIn": "4.0.0",
            "unique": false
          }
        ],
        "introducedIn": "4.0.0",
        "kind": "reference",
        "label": "Job",
        "lifecycle": [
          "active",
          "deprecated"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "registry-governance-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "framework-content",
            "status": "direction"
          }
        ],
        "pluralLabel": "Jobs",
        "primaryKey": "job-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Role whose outcome is represented by this job.",
            "id": "job-assigned-to-role-job-role",
            "introducedIn": "4.0.0",
            "predicate": "assigned-to",
            "qualifiedId": "job-assigned-to-role-job-role",
            "required": false,
            "sourceFieldId": "role-id",
            "targetEntityId": "role",
            "targetFieldId": "role-id"
          }
        ],
        "retentionClass": "reference",
        "searchTerms": [
          "job to be done",
          "completion evidence",
          "execution flow"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Which role owns this job and which execution flows fulfil it?",
              "Which business module publishes this job?"
            ],
            "retrievalTerms": [
              "job to be done",
              "work unit",
              "execution flow"
            ],
            "usage": "Use jobs to connect roles, business modules and execution flows; a job is the globally addressable unit of procurement work an agent can be asked to fulfil."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "JTBD",
              "procurement job"
            ],
            "concept": "job-to-be-done"
          }
        },
        "sourceSystemRoleIds": [
          "system-of-record"
        ],
        "storageClass": "framework-definition",
        "version": "4.0.0",
        "writebackSystemRoleIds": []
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": false,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [],
        "definition": "A governed supervised-work instance connected to a job, role, subject, evidence and explicit lifecycle; it is distinct from illustrative site fixtures.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "internal",
            "definition": "Stable identifier for this work moment record record.",
            "exchangeScope": "unmapped",
            "id": "work-moment-record-id",
            "introducedIn": "4.0.0",
            "label": "Work moment record ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Framework work-moment definition used for this supervised instance.",
            "exchangeScope": "unmapped",
            "id": "work-moment-definition-id",
            "introducedIn": "4.0.0",
            "label": "Work moment definition ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Business module operating the work moment.",
            "exchangeScope": "unmapped",
            "id": "business-module-id",
            "introducedIn": "4.0.0",
            "label": "Business module ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Globally addressable job being fulfilled.",
            "exchangeScope": "unmapped",
            "id": "job-id",
            "introducedIn": "4.0.0",
            "label": "Job ID",
            "nullable": false,
            "referenceEntityId": "job",
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Role accountable for supervising the work moment.",
            "exchangeScope": "unmapped",
            "id": "owner-role-id",
            "introducedIn": "4.0.0",
            "label": "Owner role ID",
            "nullable": false,
            "referenceEntityId": "role",
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Typed reference to the record whose work is being supervised.",
            "exchangeScope": "unmapped",
            "id": "subject-ref",
            "introducedIn": "4.0.0",
            "label": "Subject reference",
            "nullable": false,
            "referenceTargetEntityIds": [
              "action-proposal",
              "audit-event",
              "authority-envelope",
              "award-scenario",
              "budget",
              "buy-timing-mandate",
              "business-event",
              "business-unit",
              "buying-request",
              "catalogue-line",
              "category",
              "category-dimension-assignment",
              "category-opportunity",
              "category-strategy",
              "clause-deviation",
              "clause-library-entry",
              "committed-action",
              "contract",
              "contract-approval",
              "contract-change",
              "contract-compliance-finding",
              "contract-entitlement",
              "contract-intake",
              "contract-obligation",
              "contract-template",
              "contract-version",
              "decision",
              "demand-case",
              "demand-portfolio",
              "enriched-request",
              "evaluation-result",
              "evidence-item",
              "exception",
              "intake-request",
              "integration-state",
              "invoice",
              "invoice-exception",
              "invoice-line",
              "invoice-match-assessment",
              "item-service",
              "job",
              "learning-example",
              "negotiation-session",
              "order-line",
              "order-response",
              "party",
              "payment-execution-status",
              "payment-instruction",
              "payment-readiness-assessment",
              "person",
              "person-role-assignment",
              "policy",
              "policy-change-impact",
              "policy-guidance-result",
              "policy-rule-release",
              "policy-version",
              "procurement-service-offering",
              "purchase-order",
              "purchase-order-exception",
              "receipt",
              "receipt-line",
              "registry-release",
              "requisition",
              "requisition-line",
              "return-claim",
              "role",
              "savings-initiative-record",
              "service-entry-sheet",
              "shipment",
              "source-record-reference",
              "sourcing-event-record",
              "sourcing-opportunity",
              "spend-classification-decision",
              "spend-record",
              "supplier-innovation-case",
              "supplier-invoice-resolution",
              "supplier-joint-value-plan",
              "supplier-master-change",
              "supplier-offboarding-case",
              "supplier-onboarding-case",
              "supplier-performance-observation",
              "supplier-performance-review-record",
              "supplier-performance-signal",
              "supplier-profile",
              "supplier-qualification",
              "supplier-remediation-action",
              "supplier-response",
              "supplier-risk-assessment",
              "supplier-risk-case",
              "supplier-risk-signal",
              "supplier-segment-assignment",
              "supplier-tier-link",
              "tactical-sourcing-case",
              "tail-spend-evaluation",
              "tail-spend-rule",
              "taxonomy-version",
              "value-leakage-finding",
              "value-opportunity-baseline",
              "value-portfolio-forecast",
              "value-realization-attribution",
              "work-moment-record"
            ],
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "record-reference-value",
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Evidence reviewed or produced in this work moment.",
            "exchangeScope": "unmapped",
            "id": "evidence-item-ids",
            "introducedIn": "4.0.0",
            "label": "Evidence item IDs",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Time the governed work moment opened.",
            "exchangeScope": "unmapped",
            "id": "opened-at",
            "introducedIn": "4.0.0",
            "label": "Opened at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Latest authoritative state change time.",
            "exchangeScope": "unmapped",
            "id": "updated-at",
            "introducedIn": "4.0.0",
            "label": "Updated at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Authority envelope governing proposals, approvals and commitments for this record.",
            "exchangeScope": "unmapped",
            "id": "governance-authority-envelope-id",
            "introducedIn": "4.0.0",
            "label": "Governance authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "shared-ledger-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "work-moment-record",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "work-moment-record-id"
            ],
            "id": "work-moment-record-primary",
            "introducedIn": "4.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "business-module-id",
              "lifecycle-state"
            ],
            "id": "work-moment-record-by-business-module-and-lifecycle",
            "introducedIn": "4.0.0",
            "unique": false
          }
        ],
        "introducedIn": "4.0.0",
        "kind": "case",
        "label": "Work moment record",
        "lifecycle": [
          "opened",
          "proposed",
          "awaiting-review",
          "approved",
          "committing",
          "committed",
          "failed",
          "reversed",
          "closed"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "shared-ledger-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "platform-services-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Work moment records",
        "primaryKey": "work-moment-record-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Job fulfilled by the work moment.",
            "id": "work-moment-record-belongs-to-job-work-moment-job",
            "introducedIn": "4.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "work-moment-record-belongs-to-job-work-moment-job",
            "required": false,
            "sourceFieldId": "job-id",
            "targetEntityId": "job",
            "targetFieldId": "job-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Role accountable for this work moment.",
            "id": "work-moment-record-assigned-to-role-work-moment-owner-role",
            "introducedIn": "4.0.0",
            "predicate": "assigned-to",
            "qualifiedId": "work-moment-record-assigned-to-role-work-moment-owner-role",
            "required": false,
            "sourceFieldId": "owner-role-id",
            "targetEntityId": "role",
            "targetFieldId": "role-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Evidence reviewed or produced by the work moment.",
            "id": "work-moment-record-evidenced-by-evidence-item-work-moment-evidence",
            "introducedIn": "4.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "work-moment-record-evidenced-by-evidence-item-work-moment-evidence",
            "required": false,
            "sourceFieldId": "evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authority envelope governing this record.",
            "id": "work-moment-record-governed-by-authority-envelope-work-moment-record-governance-authority",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "work-moment-record-governed-by-authority-envelope-work-moment-record-governance-authority",
            "required": false,
            "sourceFieldId": "governance-authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "work moment",
          "supervision",
          "review",
          "commitment"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Which supervised work is in flight for this subject and who supervises it?",
              "What evidence and lifecycle state does this work moment carry?"
            ],
            "retrievalTerms": [
              "supervised work session",
              "supervised work",
              "task instance"
            ],
            "usage": "Record each governed supervised-work instance with its job, role, subject, evidence and lifecycle; illustrative site fixtures are not work-moment-records."
          },
          "introducedIn": "4.7.0",
          "semanticLabel": {
            "aliases": [
              "work moment",
              "supervised task instance"
            ],
            "concept": "supervised-work-instance",
            "doNotConfuseWith": [
              {
                "distinction": "A job is the reusable definition of work; a work-moment-record is one governed, supervised instance of doing it.",
                "targetEntityId": "job"
              }
            ]
          }
        },
        "sourceSystemRoleIds": [
          "execution-system",
          "source-of-record"
        ],
        "storageClass": "tenant-record",
        "version": "4.1.0",
        "writebackSystemRoleIds": [
          "execution-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "category-opportunity-radar",
          "category-strategy-orchestrator"
        ],
        "definition": "A canonical representation of one external-spend line accounting distribution with party, category, independent committed dimensions, monetary, provenance and quality attributes.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable tenant-scoped identifier for the canonical spend line.",
            "exchangeScope": "unmapped",
            "format": "uuid",
            "id": "spend-record-id",
            "introducedIn": "1.0.0",
            "label": "Spend record ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Governed identifier for the system that supplied the originating line.",
            "exchangeScope": "unmapped",
            "id": "source-system",
            "introducedIn": "1.0.0",
            "label": "Source system",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Source-native document identifier used with source system and line ID for idempotency.",
            "exchangeScope": "mapped",
            "id": "source-record-id",
            "introducedIn": "1.0.0",
            "label": "Source record ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "inbound",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Source-native line identifier within the originating document.",
            "exchangeScope": "mapped",
            "id": "source-line-id",
            "introducedIn": "1.0.0",
            "label": "Source line ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "inbound",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:InvoiceLine/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Resolved canonical party supplying the item or service.",
            "exchangeScope": "mapped",
            "id": "supplier-party-id",
            "introducedIn": "1.0.0",
            "label": "Supplier party ID",
            "nullable": true,
            "referenceEntityId": "party",
            "required": false,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:AccountingSupplierParty/cac:Party/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Company relative to which category, spend-segment and classification authority apply.",
            "exchangeScope": "unmapped",
            "id": "company-party-id",
            "introducedIn": "3.1.0",
            "label": "Company party ID",
            "nullable": true,
            "referenceEntityId": "party",
            "required": false,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Canonical organizational unit accountable for the expenditure.",
            "exchangeScope": "mapped",
            "id": "business-unit-id",
            "introducedIn": "1.0.0",
            "label": "Business unit ID",
            "nullable": true,
            "referenceEntityId": "business-unit",
            "required": false,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:AccountingCustomerParty/cac:Party/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Canonical procurement category assigned to the line.",
            "exchangeScope": "mapped",
            "id": "category-id",
            "introducedIn": "1.0.0",
            "label": "Category ID",
            "nullable": true,
            "referenceEntityId": "category",
            "required": false,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:InvoiceLine/cac:Item/cac:CommodityClassification/cbc:ItemClassificationCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Committed company-relative direct or indirect value after authorised line override, item default or category-assignment resolution; absence remains unresolved.",
            "enumValues": [
              "direct",
              "indirect"
            ],
            "exchangeScope": "unmapped",
            "id": "spend-segment",
            "introducedIn": "3.1.0",
            "label": "Spend segment",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Committed goods, services or mixed buying mode, kept independent from spend segment and accounting treatment.",
            "enumValues": [
              "goods",
              "services",
              "mixed"
            ],
            "exchangeScope": "unmapped",
            "id": "buying-mode",
            "introducedIn": "3.1.0",
            "label": "Buying mode",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Committed capital or operating treatment for this accounting distribution, independent from category and buying mode.",
            "enumValues": [
              "capital",
              "operating"
            ],
            "exchangeScope": "unmapped",
            "id": "accounting-treatment",
            "introducedIn": "3.1.0",
            "label": "Accounting treatment",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Whether the independent committed classification values required by this record remain unresolved, partially resolved or fully resolved.",
            "enumValues": [
              "unresolved",
              "partially-resolved",
              "resolved"
            ],
            "exchangeScope": "unmapped",
            "id": "classification-resolution-status",
            "introducedIn": "3.1.0",
            "label": "Classification resolution status",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Latest controlling classification decision for this committed record version; earlier and dimension-specific decisions remain linked through the decision chain.",
            "exchangeScope": "unmapped",
            "id": "spend-classification-decision-id",
            "introducedIn": "3.1.0",
            "label": "Spend classification decision ID",
            "nullable": true,
            "referenceEntityId": "spend-classification-decision",
            "required": false,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Normalised line description used for classification and evidence review.",
            "exchangeScope": "mapped",
            "id": "description",
            "introducedIn": "1.0.0",
            "label": "Description",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "inbound",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:InvoiceLine/cac:Item/cbc:Description",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "text"
          },
          {
            "classification": "confidential",
            "compositeValueContract": {
              "componentFieldIds": [
                "amount"
              ],
              "representation": "registry-object",
              "schemaId": "money-value",
              "schemaVersion": "2.0.0"
            },
            "definition": "Signed net line amount and currency before analytical conversion, with its definition version and explicit rounding rule.",
            "exchangeScope": "mapped",
            "id": "amount",
            "introducedIn": "1.0.0",
            "label": "Amount",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "components": [
                  {
                    "standardPath": "cac:InvoiceLine/cbc:LineExtensionAmount",
                    "valuePath": "amount"
                  },
                  {
                    "standardPath": "cac:InvoiceLine/cbc:LineExtensionAmount/@currencyID",
                    "valuePath": "currency-code"
                  }
                ],
                "coverage": "exact",
                "direction": "inbound",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:InvoiceLine/cbc:LineExtensionAmount",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "money",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "money-value",
              "schemaVersion": "2.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Date used to place the line in the governed spend period.",
            "exchangeScope": "mapped",
            "format": "date",
            "id": "accounting-date",
            "introducedIn": "1.0.0",
            "label": "Accounting date",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:IssueDate",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "date"
          },
          {
            "classification": "internal",
            "definition": "Calibrated confidence for the category assignment, accompanied by rule or model provenance.",
            "exchangeScope": "unmapped",
            "format": "0..1",
            "id": "classification-confidence",
            "introducedIn": "1.0.0",
            "label": "Classification confidence",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "decimal"
          },
          {
            "classification": "internal",
            "definition": "Current validation and reconciliation disposition for the line.",
            "enumValues": [
              "valid",
              "warning",
              "needs-resolution",
              "quarantined"
            ],
            "exchangeScope": "unmapped",
            "id": "quality-status",
            "introducedIn": "1.0.0",
            "label": "Quality status",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Timestamp at which the current source version was observed.",
            "exchangeScope": "unmapped",
            "format": "date-time",
            "id": "observed-at",
            "introducedIn": "1.0.0",
            "label": "Observed at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Authorised budget used for plan-to-actual attribution where the source supplies one.",
            "exchangeScope": "unmapped",
            "id": "budget-id",
            "introducedIn": "4.0.0",
            "label": "Budget ID",
            "nullable": true,
            "referenceEntityId": "budget",
            "required": false,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "spend-record",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "source-system",
              "source-record-id",
              "source-line-id"
            ],
            "id": "spend-record-by-source-system-and-source-record-id-and-source-line-id",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "category-id",
              "accounting-date"
            ],
            "id": "spend-record-by-category-id-and-accounting-date",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "supplier-party-id",
              "accounting-date"
            ],
            "id": "spend-record-by-supplier-party-id-and-accounting-date",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "company-party-id",
              "spend-segment",
              "accounting-date"
            ],
            "id": "spend-record-by-company-party-id-and-spend-segment-and-accounting-date",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "transaction",
        "label": "Spend record",
        "lifecycle": [
          "received",
          "normalised",
          "classified",
          "reconciled",
          "superseded",
          "quarantined"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "spend-data-foundation",
        "owningDomainWorkblockId": "strategy-policy-category-spend",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Spend records",
        "primaryKey": "spend-record-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Scopes company-relative classification and authority for the spend accounting distribution.",
            "id": "spend-record-references-party-spend-company",
            "introducedIn": "3.1.0",
            "predicate": "references",
            "qualifiedId": "spend-record-references-party-spend-company",
            "required": false,
            "sourceFieldId": "company-party-id",
            "targetEntityId": "party",
            "targetFieldId": "party-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the spend line to the resolved supplying party.",
            "id": "spend-record-belongs-to-party-spend-supplier",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "spend-record-belongs-to-party-spend-supplier",
            "required": false,
            "sourceFieldId": "supplier-party-id",
            "targetEntityId": "party",
            "targetFieldId": "party-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the line to the canonical procurement category.",
            "id": "spend-record-classified-as-category-spend-category",
            "introducedIn": "1.0.0",
            "predicate": "classified-as",
            "qualifiedId": "spend-record-classified-as-category-spend-category",
            "required": false,
            "sourceFieldId": "category-id",
            "targetEntityId": "category",
            "targetFieldId": "category-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the line to the accountable organizational unit.",
            "id": "spend-record-belongs-to-business-unit-spend-business-unit",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "spend-record-belongs-to-business-unit-spend-business-unit",
            "required": false,
            "sourceFieldId": "business-unit-id",
            "targetEntityId": "business-unit",
            "targetFieldId": "business-unit-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the record version to the latest controlling classification decision while preserving the complete predecessor chain.",
            "id": "spend-record-classified-as-spend-classification-decision-spend-classification-decision",
            "introducedIn": "3.1.0",
            "predicate": "classified-as",
            "qualifiedId": "spend-record-classified-as-spend-classification-decision-spend-classification-decision",
            "required": false,
            "sourceFieldId": "spend-classification-decision-id",
            "targetEntityId": "spend-classification-decision",
            "targetFieldId": "spend-classification-decision-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Budget linked to the actual spend record.",
            "id": "spend-record-belongs-to-budget-spend-budget",
            "introducedIn": "4.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "spend-record-belongs-to-budget-spend-budget",
            "required": false,
            "sourceFieldId": "budget-id",
            "targetEntityId": "budget",
            "targetFieldId": "budget-id"
          }
        ],
        "retentionClass": "financial",
        "searchTerms": [
          "spend",
          "invoice line",
          "payment line",
          "classified expenditure",
          "addressable spend"
        ],
        "sourceSystemRoleIds": [
          "planning-system",
          "execution-system",
          "payment-or-settlement-rail"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "analytical-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": false,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "category-strategy-orchestrator",
          "sourcing-pipeline-discovery"
        ],
        "definition": "An opportunity linked to the records supporting a potential improvement in value, resilience, compliance or demand outcomes for a category, kept distinct from an approved initiative.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "sourcing-negotiation"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for the opportunity hypothesis and its disposition history.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "category-opportunity-id",
            "introducedIn": "1.0.0",
            "label": "Opportunity ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "category-opportunity-radar",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Canonical category to which the opportunity applies.",
            "exchangeScope": "mapped",
            "id": "category-id",
            "introducedIn": "1.0.0",
            "label": "Category ID",
            "nullable": false,
            "referenceEntityId": "category",
            "required": true,
            "sourceAuthority": {
              "id": "category-opportunity-radar",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ProcurementProject/cac:MainCommodityClassification/cbc:ItemClassificationCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Concise, evidence-neutral description of the opportunity.",
            "exchangeScope": "mapped",
            "id": "title",
            "introducedIn": "1.0.0",
            "label": "Title",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "category-opportunity-radar",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ProcurementProject/cbc:Name",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Governed value mechanism represented by the opportunity.",
            "enumValues": [
              "price",
              "demand",
              "specification",
              "process",
              "compliance",
              "resilience",
              "sustainability",
              "working-capital"
            ],
            "exchangeScope": "mapped",
            "id": "opportunity-type",
            "introducedIn": "1.0.0",
            "label": "Opportunity type",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "category-opportunity-radar",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "extension",
                "direction": "outbound",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "The platform opportunity taxonomy is exchanged through a governed extension when needed.",
                "path": "cac:ProcurementProject/cbc:ProcurementTypeCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "extension-required"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Versioned amount, currency, range, confidence and method before realisation is validated.",
            "exchangeScope": "mapped",
            "id": "value-hypothesis",
            "introducedIn": "1.0.0",
            "label": "Value hypothesis",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "category-opportunity-radar",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ProcurementProject/cac:RequestedTenderTotal/cbc:EstimatedOverallContractAmount",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Estimated value is the money component carried within Category opportunity Value hypothesis; its classification and authority inherit from the owning field contract.",
                    "id": "estimated-value",
                    "label": "Estimated value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "value-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "money",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "money-value",
                      "schemaVersion": "2.0.0"
                    }
                  },
                  {
                    "classification": "confidential",
                    "definition": "Lower bound is the money component carried within Category opportunity Value hypothesis; its classification and authority inherit from the owning field contract.",
                    "id": "lower-bound",
                    "label": "Lower bound",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "value-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "money",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "money-value",
                      "schemaVersion": "2.0.0"
                    }
                  },
                  {
                    "classification": "confidential",
                    "definition": "Upper bound is the money component carried within Category opportunity Value hypothesis; its classification and authority inherit from the owning field contract.",
                    "id": "upper-bound",
                    "label": "Upper bound",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "value-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "money",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "money-value",
                      "schemaVersion": "2.0.0"
                    }
                  },
                  {
                    "classification": "confidential",
                    "definition": "Confidence is the decimal component carried within Category opportunity Value hypothesis; its classification and authority inherit from the owning field contract.",
                    "id": "confidence",
                    "label": "Confidence",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "value-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Method is the string component carried within Category opportunity Value hypothesis; its classification and authority inherit from the owning field contract.",
                    "id": "method",
                    "label": "Method",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "value-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Baseline description is the string component carried within Category opportunity Value hypothesis; its classification and authority inherit from the owning field contract.",
                    "id": "baseline-description",
                    "label": "Baseline description",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "value-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Normalised portfolio priority produced from value, feasibility, urgency, risk and confidence components.",
            "exchangeScope": "internal",
            "format": "0..100",
            "id": "priority-score",
            "introducedIn": "1.0.0",
            "label": "Priority score",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "category-opportunity-radar",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "decimal"
          },
          {
            "classification": "confidential",
            "definition": "Immutable evidence references supporting the opportunity and score.",
            "exchangeScope": "mapped",
            "id": "evidence-item-ids",
            "introducedIn": "1.0.0",
            "label": "Evidence item IDs",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "category-opportunity-radar",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:AdditionalDocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "confidential",
            "definition": "Category strategy to which an accepted opportunity has been linked.",
            "exchangeScope": "internal",
            "id": "strategy-id",
            "introducedIn": "1.0.0",
            "label": "Strategy ID",
            "nullable": true,
            "referenceEntityId": "category-strategy",
            "required": false,
            "sourceAuthority": {
              "id": "category-opportunity-radar",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Latest observation timestamp included in the current score.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "evidence-as-of",
            "introducedIn": "1.0.0",
            "label": "Evidence as of",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "category-opportunity-radar",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Authority envelope governing proposals, approvals and commitments for this record.",
            "exchangeScope": "unmapped",
            "id": "governance-authority-envelope-id",
            "introducedIn": "4.0.0",
            "label": "Governance authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "category-opportunity-radar",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "category-opportunity",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "category-id",
              "lifecycle-state"
            ],
            "id": "category-opportunity-by-category-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "opportunity-type",
              "priority-score"
            ],
            "id": "category-opportunity-by-opportunity-type-and-priority-score",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "evidence-as-of"
            ],
            "id": "category-opportunity-by-evidence-as-of",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "strategy-id"
            ],
            "id": "category-opportunity-by-strategy-id",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "case",
        "label": "Category opportunity",
        "lifecycle": [
          "detected",
          "qualified",
          "proposed",
          "accepted",
          "declined",
          "converted",
          "expired"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "category-opportunity-radar",
        "owningDomainWorkblockId": "strategy-policy-category-spend",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Category opportunities",
        "primaryKey": "category-opportunity-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Associates the opportunity with its canonical category.",
            "id": "category-opportunity-classified-as-category-opportunity-category",
            "introducedIn": "1.0.0",
            "predicate": "classified-as",
            "qualifiedId": "category-opportunity-classified-as-category-opportunity-category",
            "required": true,
            "sourceFieldId": "category-id",
            "targetEntityId": "category",
            "targetFieldId": "category-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Associates an accepted opportunity with the strategy that governs execution.",
            "id": "category-opportunity-references-category-strategy-opportunity-strategy",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "category-opportunity-references-category-strategy-opportunity-strategy",
            "required": false,
            "sourceFieldId": "strategy-id",
            "targetEntityId": "category-strategy",
            "targetFieldId": "category-strategy-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the opportunity to the immutable evidence records supporting its hypothesis and score.",
            "id": "category-opportunity-evidenced-by-evidence-item-opportunity-evidence",
            "introducedIn": "1.1.0",
            "predicate": "evidenced-by",
            "qualifiedId": "category-opportunity-evidenced-by-evidence-item-opportunity-evidence",
            "required": true,
            "sourceFieldId": "evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authority envelope governing this record.",
            "id": "category-opportunity-governed-by-authority-envelope-category-opportunity-governance-authority",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "category-opportunity-governed-by-authority-envelope-category-opportunity-governance-authority",
            "required": false,
            "sourceFieldId": "governance-authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          }
        ],
        "retentionClass": "operational",
        "searchTerms": [
          "opportunity",
          "savings opportunity",
          "risk opportunity",
          "category signal",
          "addressable value"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Which qualified opportunities exist for this category, who owns them, and what is the hypothesised value and its method?",
              "Which opportunities were converted into governed initiatives, and which expired?",
              "What evidence, as of when, supports this value hypothesis?"
            ],
            "retrievalTerms": [
              "pipeline",
              "value hypothesis",
              "initiative register",
              "priority score",
              "addressable"
            ],
            "usage": "Read value-hypothesis with its method and confidence together; never present the estimate without its basis or evidence-as-of. An opportunity at lifecycle detected or qualified is not addressable value anyone has agreed to."
          },
          "introducedIn": "4.8.0",
          "semanticLabel": {
            "aliases": [
              "savings opportunity",
              "initiative candidate"
            ],
            "concept": "category-value-hypothesis",
            "doNotConfuseWith": [
              {
                "distinction": "category-opportunity is a value hypothesis inside a category strategy; sourcing-opportunity is a route- and timing-bound event candidate. The same value can appear as both, at different stages, and neither supersedes the other.",
                "targetEntityId": "sourcing-opportunity"
              },
              {
                "distinction": "This is the hypothesis and its qualification lifecycle; the savings initiative is the accepted, owned body of work. Promotion runs through category-strategy.initiative-ids with the value claim fixed against a value-opportunity-baseline; an opportunity is never itself an initiative.",
                "targetEntityId": "savings-initiative-record"
              },
              {
                "distinction": "A leakage finding is a detected, evidenced deviation with an exposure amount; an opportunity is a forward hypothesis with a value range and a confidence. A finding may justify raising an opportunity; it is not one.",
                "targetEntityId": "value-leakage-finding"
              },
              {
                "distinction": "An opportunity carries no commitment. Commitment is the action-proposal to decision to committed-action rail, which alone carries reconciliation-state and verified outcome evidence.",
                "targetEntityId": "committed-action"
              },
              {
                "distinction": "category-opportunity is a forward value hypothesis carrying a range and a confidence; value-opportunity-baseline is the governed, reproducible counterfactual whose finance-committed validation a realised saving is measured against. A qualified opportunity earns a baseline before its value is claimed; the hypothesis never substitutes for one.",
                "targetEntityId": "value-opportunity-baseline"
              }
            ]
          }
        },
        "sourceSystemRoleIds": [
          "analytical-system",
          "planning-system",
          "system-of-record",
          "evidence-source"
        ],
        "storageClass": "tenant-record",
        "version": "4.1.0",
        "writebackSystemRoleIds": [
          "planning-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "sourcing-pipeline-discovery"
        ],
        "definition": "A versioned category mission, baseline, objectives, interventions and authority boundaries linked to executable initiatives and observed outcomes.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "sourcing-negotiation"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identity for the category strategy across versions.",
            "exchangeScope": "unmapped",
            "format": "uuid",
            "id": "category-strategy-id",
            "introducedIn": "1.0.0",
            "label": "Strategy ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "category-strategy-orchestrator",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Monotonic committed version of the strategy content and authority boundaries.",
            "exchangeScope": "mapped",
            "id": "version-number",
            "introducedIn": "1.0.0",
            "label": "Version number",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "category-strategy-orchestrator",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:VersionID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "integer"
          },
          {
            "classification": "internal",
            "definition": "Canonical category governed by the strategy.",
            "exchangeScope": "mapped",
            "id": "category-id",
            "introducedIn": "1.0.0",
            "label": "Category ID",
            "nullable": false,
            "referenceEntityId": "category",
            "required": true,
            "sourceAuthority": {
              "id": "category-strategy-orchestrator",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ProcurementProject/cac:MainCommodityClassification/cbc:ItemClassificationCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "personal",
            "definition": "Accountable person for strategy outcomes and policy exceptions.",
            "exchangeScope": "mapped",
            "id": "owner-person-id",
            "introducedIn": "1.0.0",
            "label": "Owner person ID",
            "nullable": false,
            "referenceEntityId": "person",
            "required": true,
            "sourceAuthority": {
              "id": "category-strategy-orchestrator",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ContractingParty/cac:Party/cac:Contact/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Outcome-oriented statement defining the category mission for the strategy horizon.",
            "exchangeScope": "mapped",
            "id": "mission",
            "introducedIn": "1.0.0",
            "label": "Mission",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "category-strategy-orchestrator",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ProcurementProject/cbc:Description",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "text"
          },
          {
            "classification": "confidential",
            "definition": "Typed objectives with measures, baselines, targets, horizons and owners.",
            "exchangeScope": "unmapped",
            "id": "objectives",
            "introducedIn": "1.0.0",
            "label": "Objectives",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "category-strategy-orchestrator",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Objective ID is the uuid component carried within Category strategy Objectives; its classification and authority inherit from the owning field contract.",
                    "id": "objective-id",
                    "label": "Objective ID",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "objectives",
                      "kind": "inherited-field"
                    },
                    "type": "uuid"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Measure code records the governed code within Category strategy Objectives without treating absence, unknown and zero as equivalent.",
                    "id": "measure-code",
                    "label": "Measure code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "objectives",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Baseline value is the decimal component carried within Category strategy Objectives; its classification and authority inherit from the owning field contract.",
                    "id": "baseline-value",
                    "label": "Baseline value",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "objectives",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Target value is the decimal component carried within Category strategy Objectives; its classification and authority inherit from the owning field contract.",
                    "id": "target-value",
                    "label": "Target value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "objectives",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Unit code records the governed code within Category strategy Objectives without treating absence, unknown and zero as equivalent.",
                    "id": "unit-code",
                    "label": "Unit code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "objectives",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Horizon date is the date component carried within Category strategy Objectives; its classification and authority inherit from the owning field contract.",
                    "id": "horizon-date",
                    "label": "Horizon date",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "objectives",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Owner person ID links this structured value to the governed person record within Category strategy Objectives.",
                    "id": "owner-person-id",
                    "label": "Owner person ID",
                    "nullable": false,
                    "referenceEntityId": "person",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the owner person ID in objectives to the referenced person via its canonical person ID.",
                      "id": "category-strategy-objectives-owner-person-id",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "person-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "objectives",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  }
                ],
                "uniqueBy": [
                  "objective-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "References to accepted opportunities or execution initiatives governed by this version.",
            "exchangeScope": "mapped",
            "id": "initiative-ids",
            "introducedIn": "1.0.0",
            "label": "Initiative references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "category-opportunity",
            "required": true,
            "sourceAuthority": {
              "id": "category-strategy-orchestrator",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ProcurementProjectLot/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "restricted",
            "definition": "Versioned grant governing the listed initiative actions that may proceed without per-item approval.",
            "exchangeScope": "unmapped",
            "id": "authority-envelope-id",
            "introducedIn": "1.0.0",
            "label": "Authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "category-strategy-orchestrator",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Date from which this strategy version governs execution.",
            "exchangeScope": "mapped",
            "format": "date",
            "id": "effective-date",
            "introducedIn": "1.0.0",
            "label": "Effective date",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "category-strategy-orchestrator",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:TenderingProcess/cac:DocumentAvailabilityPeriod/cbc:StartDate",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "date"
          },
          {
            "classification": "internal",
            "definition": "Next date by which strategy fitness must be evaluated.",
            "exchangeScope": "unmapped",
            "format": "date",
            "id": "review-due-date",
            "introducedIn": "1.0.0",
            "label": "Review due date",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "category-strategy-orchestrator",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "category-strategy",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "category-id",
              "lifecycle-state"
            ],
            "id": "category-strategy-by-category-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "version-number"
            ],
            "id": "category-strategy-by-version-number",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "review-due-date"
            ],
            "id": "category-strategy-by-review-due-date",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "owner-person-id"
            ],
            "id": "category-strategy-by-owner-person-id",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "document",
        "label": "Category strategy",
        "lifecycle": [
          "assembling",
          "proposed",
          "active",
          "replanning",
          "superseded",
          "closed"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "category-strategy-orchestrator",
        "owningDomainWorkblockId": "strategy-policy-category-spend",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Category strategies",
        "primaryKey": "category-strategy-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Associates the strategy with one canonical category.",
            "id": "category-strategy-classified-as-category-strategy-category",
            "introducedIn": "1.0.0",
            "predicate": "classified-as",
            "qualifiedId": "category-strategy-classified-as-category-strategy-category",
            "required": true,
            "sourceFieldId": "category-id",
            "targetEntityId": "category",
            "targetFieldId": "category-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Associates the strategy with its accountable human owner.",
            "id": "category-strategy-assigned-to-person-strategy-owner",
            "introducedIn": "1.0.0",
            "predicate": "assigned-to",
            "qualifiedId": "category-strategy-assigned-to-person-strategy-owner",
            "required": true,
            "sourceFieldId": "owner-person-id",
            "targetEntityId": "person",
            "targetFieldId": "person-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the strategy to the active autonomy grant.",
            "id": "category-strategy-governed-by-authority-envelope-strategy-authority",
            "introducedIn": "1.0.0",
            "predicate": "governed-by",
            "qualifiedId": "category-strategy-governed-by-authority-envelope-strategy-authority",
            "required": false,
            "sourceFieldId": "authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the strategy version to the accepted opportunities it governs as initiatives.",
            "id": "category-strategy-references-category-opportunity-strategy-initiatives",
            "introducedIn": "1.1.0",
            "predicate": "references",
            "qualifiedId": "category-strategy-references-category-opportunity-strategy-initiatives",
            "required": true,
            "sourceFieldId": "initiative-ids",
            "targetEntityId": "category-opportunity",
            "targetFieldId": "category-opportunity-id"
          }
        ],
        "retentionClass": "policy",
        "searchTerms": [
          "category strategy",
          "category plan",
          "initiative portfolio",
          "category objectives"
        ],
        "sourceSystemRoleIds": [
          "analytical-system",
          "planning-system",
          "evidence-source"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "planning-system",
          "system-of-record"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "intelligent-intake",
          "policy-guidance",
          "procurement-service-catalogue"
        ],
        "definition": "An immutable, testable release of machine-readable procurement rules, precedence, scope, effective periods and exception behaviour derived from governed policy.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable identifier for this immutable executable rule release.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "policy-rule-release-id",
            "introducedIn": "1.0.0",
            "label": "Rule release ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Governed human-readable policy version from which the release is derived.",
            "exchangeScope": "mapped",
            "id": "policy-version-id",
            "introducedIn": "1.0.0",
            "label": "Policy version ID",
            "nullable": false,
            "referenceEntityId": "policy-version",
            "required": true,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:AdditionalDocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Monotonic version number within the source policy version.",
            "exchangeScope": "mapped",
            "id": "release-number",
            "introducedIn": "1.0.0",
            "label": "Release number",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:AdditionalDocumentReference/cbc:VersionID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "integer"
          },
          {
            "classification": "internal",
            "definition": "Stable business identifier for the rule family across releases.",
            "exchangeScope": "mapped",
            "id": "rule-code",
            "introducedIn": "1.0.0",
            "label": "Rule code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "extension",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:AdditionalDocumentReference/cbc:DocumentTypeCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "extension-required"
              }
            ],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Typed applicability expression over legal entity, category, spend band, geography, requester, route and other governed facts.",
            "exchangeScope": "internal",
            "id": "scope",
            "introducedIn": "1.0.0",
            "label": "Scope",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Match expression is the string component carried within Policy rule release Scope; its classification and authority inherit from the owning field contract.",
                    "id": "match-expression",
                    "label": "Match expression",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "scope",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Legal entity ids is the set carried within Policy rule release Scope; its owning field governs allowed values and interpretation.",
                    "id": "legal-entity-ids",
                    "label": "Legal entity ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "scope",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Category ids links this structured value to governed categories through category-id within Policy rule release Scope.",
                    "id": "category-ids",
                    "label": "Category ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "referenceEntityId": "category",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links category ids to governed categories through the canonical category-id field.",
                      "id": "policy-rule-release-scope-category-ids",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "category-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "scope",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Spend band code records the governed code within Policy rule release Scope without treating absence, unknown and zero as equivalent.",
                    "id": "spend-band-code",
                    "label": "Spend band code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "scope",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Geography codes is the set carried within Policy rule release Scope; its owning field governs allowed values and interpretation.",
                    "id": "geography-codes",
                    "label": "Geography codes",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "scope",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Requester role codes is the set carried within Policy rule release Scope; its owning field governs allowed values and interpretation.",
                    "id": "requester-role-codes",
                    "label": "Requester role codes",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "scope",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Route codes is the set carried within Policy rule release Scope; its owning field governs allowed values and interpretation.",
                    "id": "route-codes",
                    "label": "Route codes",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "scope",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Deterministic, versioned predicate evaluated only over declared typed inputs.",
            "exchangeScope": "internal",
            "id": "condition-expression",
            "introducedIn": "1.0.0",
            "label": "Condition expression",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "text"
          },
          {
            "classification": "restricted",
            "definition": "Typed result including permitted route, required evidence, threshold, constraint or escalation class.",
            "exchangeScope": "mapped",
            "id": "effect",
            "introducedIn": "1.0.0",
            "label": "Effect",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "extension",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "Executable policy effect is a GroundWorks extension and must not alter standard UBL meaning.",
                "path": "ext:UBLExtensions/ext:UBLExtension/ext:ExtensionContent",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "extension-required"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Outcome is the string component carried within Policy rule release Effect; its classification and authority inherit from the owning field contract.",
                    "id": "outcome",
                    "label": "Outcome",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "effect",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Permitted route codes is the set carried within Policy rule release Effect; its owning field governs allowed values and interpretation.",
                    "id": "permitted-route-codes",
                    "label": "Permitted route codes",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "effect",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Required evidence codes is the set carried within Policy rule release Effect; its owning field governs allowed values and interpretation.",
                    "id": "required-evidence-codes",
                    "label": "Required evidence codes",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "effect",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Threshold is the money component carried within Policy rule release Effect; its classification and authority inherit from the owning field contract.",
                    "id": "threshold",
                    "label": "Threshold",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "effect",
                      "kind": "inherited-field"
                    },
                    "type": "money",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "money-value",
                      "schemaVersion": "2.0.0"
                    }
                  },
                  {
                    "classification": "restricted",
                    "definition": "Constraint codes is the set carried within Policy rule release Effect; its owning field governs allowed values and interpretation.",
                    "id": "constraint-codes",
                    "label": "Constraint codes",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "effect",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Escalation class is the string component carried within Policy rule release Effect; its classification and authority inherit from the owning field contract.",
                    "id": "escalation-class",
                    "label": "Escalation class",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "effect",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Deterministic conflict-resolution rank within the governed rule set.",
            "exchangeScope": "internal",
            "id": "precedence",
            "introducedIn": "1.0.0",
            "label": "Precedence",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "integer"
          },
          {
            "classification": "internal",
            "definition": "Timestamp from which this release may govern decisions.",
            "exchangeScope": "mapped",
            "format": "date-time",
            "id": "effective-from",
            "introducedIn": "1.0.0",
            "label": "Effective from",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:IssueDate|cbc:IssueTime",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Optional exclusive timestamp after which this release cannot govern new decisions.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "effective-until",
            "introducedIn": "1.0.0",
            "label": "Effective until",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Versioned evaluation evidence required for approval and promotion.",
            "exchangeScope": "internal",
            "id": "evaluation-result-id",
            "introducedIn": "1.0.0",
            "label": "Evaluation result ID",
            "nullable": false,
            "referenceEntityId": "evaluation-result",
            "required": true,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Last-approved compatible release restored if this release is stopped.",
            "exchangeScope": "internal",
            "id": "rollback-release-id",
            "introducedIn": "1.0.0",
            "label": "Rollback release ID",
            "nullable": true,
            "referenceEntityId": "policy-rule-release",
            "required": false,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "policy-rule-release",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "policy-version-id",
              "release-number"
            ],
            "id": "policy-rule-release-by-policy-version-id-and-release-number",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "lifecycle-state",
              "effective-from"
            ],
            "id": "policy-rule-release-by-status-and-effective-from",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "rule-code",
              "lifecycle-state"
            ],
            "id": "policy-rule-release-by-rule-code-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "control",
        "label": "Policy rule release",
        "lifecycle": [
          "draft",
          "testing",
          "approved",
          "active",
          "suspended",
          "superseded",
          "retired"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "policy-rule-lifecycle",
        "owningDomainWorkblockId": "strategy-policy-category-spend",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Policy rule releases",
        "primaryKey": "policy-rule-release-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Binds the executable release to its governed policy source.",
            "id": "policy-rule-release-governed-by-policy-version-rule-source-policy",
            "introducedIn": "1.0.0",
            "predicate": "governed-by",
            "qualifiedId": "policy-rule-release-governed-by-policy-version-rule-source-policy",
            "required": true,
            "sourceFieldId": "policy-version-id",
            "targetEntityId": "policy-version",
            "targetFieldId": "policy-version-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Binds activation to a versioned evaluation result.",
            "id": "policy-rule-release-references-evaluation-result-rule-evaluation",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "policy-rule-release-references-evaluation-result-rule-evaluation",
            "required": true,
            "sourceFieldId": "evaluation-result-id",
            "targetEntityId": "evaluation-result",
            "targetFieldId": "evaluation-result-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Names the exact compatible release used for rollback.",
            "id": "policy-rule-release-references-policy-rule-release-rule-rollback",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "policy-rule-release-references-policy-rule-release-rule-rollback",
            "required": false,
            "sourceFieldId": "rollback-release-id",
            "targetEntityId": "policy-rule-release",
            "targetFieldId": "policy-rule-release-id"
          }
        ],
        "retentionClass": "policy",
        "searchTerms": [
          "policy rule",
          "decision table",
          "control rule",
          "exception rule",
          "policy release"
        ],
        "sourceSystemRoleIds": [
          "system-of-record",
          "evidence-source",
          "execution-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "policy-rule-lifecycle",
          "request-enrichment-routing"
        ],
        "definition": "A point-in-time, evidence-linked evaluation of a procurement question or proposed action against exact policy and rule versions, including permitted routes and true exceptions.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for this immutable point-in-time evaluation.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "policy-guidance-result-id",
            "introducedIn": "1.0.0",
            "label": "Guidance result ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-guidance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Canonical record or proposal evaluated by the guidance service.",
            "exchangeScope": "mapped",
            "id": "subject-entity-id",
            "introducedIn": "1.0.0",
            "label": "Subject entity ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-guidance",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Normalised policy question or requested action stated without unsupported interpretation.",
            "exchangeScope": "internal",
            "id": "question",
            "introducedIn": "1.0.0",
            "label": "Question",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-guidance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "text"
          },
          {
            "classification": "confidential",
            "definition": "Typed and provenance-linked facts used for deterministic rule evaluation.",
            "exchangeScope": "internal",
            "id": "input-facts",
            "introducedIn": "1.0.0",
            "label": "Input facts",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-guidance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Fact ID is the uuid component carried within Policy guidance result Input facts; its classification and authority inherit from the owning field contract.",
                    "id": "fact-id",
                    "label": "Fact ID",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "input-facts",
                      "kind": "inherited-field"
                    },
                    "type": "uuid"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Fact code records the governed code within Policy guidance result Input facts without treating absence, unknown and zero as equivalent.",
                    "id": "fact-code",
                    "label": "Fact code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "input-facts",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Value is the string component carried within Policy guidance result Input facts; its classification and authority inherit from the owning field contract.",
                    "id": "value",
                    "label": "Value",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "input-facts",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Source evidence item ID links this structured value to the governed evidence-item record within Policy guidance result Input facts.",
                    "id": "source-evidence-item-id",
                    "label": "Source evidence item ID",
                    "nullable": false,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the source evidence item ID in input facts to the referenced evidence item via its canonical evidence item ID.",
                      "id": "policy-guidance-result-input-facts-source-evidence-item-id",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "input-facts",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Observed at is the timestamp component carried within Policy guidance result Input facts; its classification and authority inherit from the owning field contract.",
                    "id": "observed-at",
                    "label": "Observed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "input-facts",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Confidence is the decimal component carried within Policy guidance result Input facts; its classification and authority inherit from the owning field contract.",
                    "id": "confidence",
                    "label": "Confidence",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "input-facts",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Confirmed is the boolean component carried within Policy guidance result Input facts; its classification and authority inherit from the owning field contract.",
                    "id": "confirmed",
                    "label": "Confirmed",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "input-facts",
                      "kind": "inherited-field"
                    },
                    "type": "boolean"
                  }
                ],
                "uniqueBy": [
                  "fact-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Exact active rule releases evaluated for the result.",
            "exchangeScope": "mapped",
            "id": "rule-release-ids",
            "introducedIn": "1.0.0",
            "label": "Rule release IDs",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "policy-rule-release",
            "required": true,
            "sourceAuthority": {
              "id": "policy-guidance",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:AdditionalDocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Governed result of the policy evaluation.",
            "enumValues": [
              "permitted",
              "permitted-with-conditions",
              "not-permitted",
              "insufficient-evidence",
              "exception-required"
            ],
            "exchangeScope": "mapped",
            "id": "outcome",
            "introducedIn": "1.0.0",
            "label": "Outcome",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-guidance",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:OrderResponseCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Ordered procurement routes valid under the evaluated facts.",
            "exchangeScope": "mapped",
            "id": "permitted-route-codes",
            "introducedIn": "1.0.0",
            "label": "Permitted route codes",
            "listSemantics": "ordered",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-guidance",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "extension",
                "direction": "outbound",
                "documentId": "order-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "ext:UBLExtensions/ext:UBLExtension/ext:ExtensionContent",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "extension-required"
              }
            ],
            "type": "string-list"
          },
          {
            "classification": "internal",
            "definition": "Evidence classes that must be supplied before the result can support action.",
            "exchangeScope": "internal",
            "id": "required-evidence-codes",
            "introducedIn": "1.0.0",
            "label": "Required evidence codes",
            "listSemantics": "set",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-guidance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string-list"
          },
          {
            "classification": "confidential",
            "definition": "Source-anchored explanation of matched rules, conditions and unresolved facts.",
            "exchangeScope": "mapped",
            "id": "explanation",
            "introducedIn": "1.0.0",
            "label": "Explanation",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-guidance",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:Note",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "text"
          },
          {
            "classification": "restricted",
            "definition": "True exception opened when the request lies outside active policy or authority.",
            "exchangeScope": "internal",
            "id": "exception-id",
            "introducedIn": "1.0.0",
            "label": "Exception case ID",
            "nullable": true,
            "referenceEntityId": "exception",
            "required": false,
            "sourceAuthority": {
              "id": "policy-guidance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Timestamp at which the exact inputs and rule releases were evaluated.",
            "exchangeScope": "mapped",
            "format": "date-time",
            "id": "evaluated-at",
            "introducedIn": "1.0.0",
            "label": "Evaluated at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-guidance",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:IssueDate|cbc:IssueTime",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Timestamp after which the result must be re-evaluated before it can support action.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "expires-at",
            "introducedIn": "1.0.0",
            "label": "Expires at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-guidance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Shared governed decision record that carries authority, rationale and evidence for this domain decision.",
            "exchangeScope": "unmapped",
            "id": "governance-decision-id",
            "introducedIn": "4.0.0",
            "label": "Governance decision ID",
            "nullable": true,
            "referenceEntityId": "decision",
            "required": false,
            "sourceAuthority": {
              "id": "policy-guidance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Authority envelope governing proposals, approvals and commitments for this record.",
            "exchangeScope": "unmapped",
            "id": "governance-authority-envelope-id",
            "introducedIn": "4.0.0",
            "label": "Governance authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "policy-guidance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Evidence supporting this record and its governed outcome.",
            "exchangeScope": "unmapped",
            "id": "governance-evidence-item-ids",
            "introducedIn": "4.0.0",
            "label": "Governance evidence item IDs",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "policy-guidance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "policy-guidance-result",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "subject-entity-id",
              "evaluated-at"
            ],
            "id": "policy-guidance-result-by-subject-entity-id-and-evaluated-at",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "outcome",
              "expires-at"
            ],
            "id": "policy-guidance-result-by-outcome-and-expires-at",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "rule-release-ids"
            ],
            "id": "policy-guidance-result-by-rule-release-ids",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "exception-id"
            ],
            "id": "policy-guidance-result-by-exception-id",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "decision",
        "label": "Policy guidance result",
        "lifecycle": [
          "evaluating",
          "advisory",
          "actionable",
          "escalated",
          "superseded",
          "expired"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "policy-guidance",
        "owningDomainWorkblockId": "strategy-policy-category-spend",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Policy guidance results",
        "primaryKey": "policy-guidance-result-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-many",
            "definition": "Binds the result to every executable rule release considered.",
            "id": "policy-guidance-result-references-policy-rule-release-guidance-rules",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "policy-guidance-result-references-policy-rule-release-guidance-rules",
            "required": true,
            "sourceFieldId": "rule-release-ids",
            "targetEntityId": "policy-rule-release",
            "targetFieldId": "policy-rule-release-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links a result outside active policy to its governed exception case.",
            "id": "policy-guidance-result-references-exception-guidance-exception",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "policy-guidance-result-references-exception-guidance-exception",
            "required": false,
            "sourceFieldId": "exception-id",
            "targetEntityId": "exception",
            "targetFieldId": "exception-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Shared governed decision for this domain outcome.",
            "id": "policy-guidance-result-governed-by-decision-policy-guidance-result-governance-decision",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "policy-guidance-result-governed-by-decision-policy-guidance-result-governance-decision",
            "required": false,
            "sourceFieldId": "governance-decision-id",
            "targetEntityId": "decision",
            "targetFieldId": "decision-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authority envelope governing this record.",
            "id": "policy-guidance-result-governed-by-authority-envelope-policy-guidance-result-governance-authority",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "policy-guidance-result-governed-by-authority-envelope-policy-guidance-result-governance-authority",
            "required": false,
            "sourceFieldId": "governance-authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Evidence supporting this record.",
            "id": "policy-guidance-result-evidenced-by-evidence-item-policy-guidance-result-governance-evidence",
            "introducedIn": "4.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "policy-guidance-result-evidenced-by-evidence-item-policy-guidance-result-governance-evidence",
            "required": false,
            "sourceFieldId": "governance-evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "policy guidance",
          "compliance answer",
          "permitted route",
          "policy exception",
          "required evidence"
        ],
        "sourceSystemRoleIds": [
          "system-of-record",
          "collaboration-channel",
          "identity-authority"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "collaboration-channel",
          "source-of-record"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "approve",
            "commit",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": false,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "intelligent-intake"
        ],
        "definition": "A versioned, audience-scoped description of a procurement service, its eligibility, required inputs, policy route, service expectation and owning Workblock.",
        "domainWorkblockIds": [
          "intake-demand"
        ],
        "fields": [
          {
            "classification": "internal",
            "definition": "Stable identity for the service across versions.",
            "exchangeScope": "mapped",
            "format": "uuid",
            "id": "procurement-service-offering-id",
            "introducedIn": "1.0.0",
            "label": "Service offering ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "procurement-service-catalogue",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "catalogue",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Stable business code used by intake and routing contracts.",
            "exchangeScope": "mapped",
            "id": "service-code",
            "introducedIn": "1.0.0",
            "label": "Service code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "procurement-service-catalogue",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "catalogue",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:CatalogueLine/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Monotonic committed release of the offering.",
            "exchangeScope": "mapped",
            "id": "version-number",
            "introducedIn": "1.0.0",
            "label": "Version number",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "procurement-service-catalogue",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "outbound",
                "documentId": "catalogue",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:VersionID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "integer"
          },
          {
            "classification": "public",
            "definition": "Plain-language name a requester can recognise without knowing procurement structure.",
            "exchangeScope": "mapped",
            "id": "name",
            "introducedIn": "1.0.0",
            "label": "Name",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "procurement-service-catalogue",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "catalogue",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:CatalogueLine/cac:Item/cbc:Name",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "public",
            "definition": "Outcome-oriented description of when the service should be used.",
            "exchangeScope": "mapped",
            "id": "description",
            "introducedIn": "1.0.0",
            "label": "Description",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "procurement-service-catalogue",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "catalogue",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:CatalogueLine/cac:Item/cbc:Description",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "text"
          },
          {
            "classification": "internal",
            "definition": "Typed, deterministic test for audience, legal entity, geography, category, value and risk eligibility.",
            "exchangeScope": "unmapped",
            "id": "eligibility-expression",
            "introducedIn": "1.0.0",
            "label": "Eligibility expression",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "procurement-service-catalogue",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "internal",
                    "definition": "Expression language is the string component carried within Procurement service offering Eligibility expression; its classification and authority inherit from the owning field contract.",
                    "id": "expression-language",
                    "label": "Expression language",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "eligibility-expression",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "internal",
                    "definition": "Expression is the string component carried within Procurement service offering Eligibility expression; its classification and authority inherit from the owning field contract.",
                    "id": "expression",
                    "label": "Expression",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "eligibility-expression",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "internal",
                    "definition": "Audience codes is the set carried within Procurement service offering Eligibility expression; its owning field governs allowed values and interpretation.",
                    "id": "audience-codes",
                    "label": "Audience codes",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "eligibility-expression",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "internal",
                    "definition": "Legal entity ids is the set carried within Procurement service offering Eligibility expression; its owning field governs allowed values and interpretation.",
                    "id": "legal-entity-ids",
                    "label": "Legal entity ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "eligibility-expression",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "internal",
                    "definition": "Geography codes is the set carried within Procurement service offering Eligibility expression; its owning field governs allowed values and interpretation.",
                    "id": "geography-codes",
                    "label": "Geography codes",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "eligibility-expression",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "internal",
                    "definition": "Category ids links this structured value to governed categories through category-id within Procurement service offering Eligibility expression.",
                    "id": "category-ids",
                    "label": "Category ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "referenceEntityId": "category",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links category ids to governed categories through the canonical category-id field.",
                      "id": "procurement-service-offering-eligibility-expression-category-ids",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "category-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "eligibility-expression",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  },
                  {
                    "classification": "internal",
                    "definition": "Value condition is the string component carried within Procurement service offering Eligibility expression; its classification and authority inherit from the owning field contract.",
                    "id": "value-condition",
                    "label": "Value condition",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "eligibility-expression",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "internal",
                    "definition": "Risk condition is the string component carried within Procurement service offering Eligibility expression; its classification and authority inherit from the owning field contract.",
                    "id": "risk-condition",
                    "label": "Risk condition",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "eligibility-expression",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Versioned required and optional fields, evidence types and validation rules for a complete request.",
            "exchangeScope": "mapped",
            "id": "input-schema",
            "introducedIn": "1.0.0",
            "label": "Input schema",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "procurement-service-catalogue",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "catalogue",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:CatalogueLine/cac:RequiredItemLocationQuantity",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "internal",
                    "definition": "Schema version is the string component carried within Procurement service offering Input schema; its classification and authority inherit from the owning field contract.",
                    "id": "schema-version",
                    "label": "Schema version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "input-schema",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "internal",
                    "definition": "Field definitions is the object component carried within Procurement service offering Input schema; its classification and authority inherit from the owning field contract.",
                    "id": "field-definitions",
                    "label": "Field definitions",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "input-schema",
                      "kind": "inherited-field"
                    },
                    "type": "object",
                    "valueSchema": {
                      "mode": "inline",
                      "schema": {
                        "additionalProperties": false,
                        "container": "object-list",
                        "properties": [
                          {
                            "classification": "internal",
                            "definition": "Field ID is the string component carried within Field definitions; its classification and authority inherit from the owning field contract.",
                            "id": "field-id",
                            "label": "Field ID",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "input-schema",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "internal",
                            "definition": "Field type records the governed state or type within Field definitions without treating absence, unknown and zero as equivalent.",
                            "id": "field-type",
                            "label": "Field type",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "input-schema",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "internal",
                            "definition": "Required is the boolean component carried within Field definitions; its classification and authority inherit from the owning field contract.",
                            "id": "required",
                            "label": "Required",
                            "nullable": false,
                            "required": true,
                            "sourceAuthority": {
                              "id": "input-schema",
                              "kind": "inherited-field"
                            },
                            "type": "boolean"
                          },
                          {
                            "classification": "internal",
                            "definition": "Nullable is the boolean component carried within Field definitions; its classification and authority inherit from the owning field contract.",
                            "id": "nullable",
                            "label": "Nullable",
                            "nullable": false,
                            "required": true,
                            "sourceAuthority": {
                              "id": "input-schema",
                              "kind": "inherited-field"
                            },
                            "type": "boolean"
                          },
                          {
                            "classification": "internal",
                            "definition": "Evidence type codes is the set carried within Field definitions; its owning field governs allowed values and interpretation.",
                            "id": "evidence-type-codes",
                            "label": "Evidence type codes",
                            "listSemantics": "set",
                            "nullable": true,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": false,
                            "sourceAuthority": {
                              "id": "input-schema",
                              "kind": "inherited-field"
                            },
                            "type": "string-list"
                          },
                          {
                            "classification": "internal",
                            "definition": "Validation expression is the string component carried within Field definitions; its classification and authority inherit from the owning field contract.",
                            "id": "validation-expression",
                            "label": "Validation expression",
                            "nullable": true,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": false,
                            "sourceAuthority": {
                              "id": "input-schema",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          }
                        ],
                        "uniqueBy": [
                          "field-id"
                        ]
                      },
                      "schemaVersion": "1.0.0"
                    }
                  },
                  {
                    "classification": "internal",
                    "definition": "Validation rule expressions is the set carried within Procurement service offering Input schema; its owning field governs allowed values and interpretation.",
                    "id": "validation-rule-expressions",
                    "label": "Validation rule expressions",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "input-schema",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "internal",
                    "definition": "Evidence type codes is the set carried within Procurement service offering Input schema; its owning field governs allowed values and interpretation.",
                    "id": "evidence-type-codes",
                    "label": "Evidence type codes",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "input-schema",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Stable Workblock entrypoint responsible for the accepted request.",
            "exchangeScope": "unmapped",
            "id": "owner-workblock-id",
            "introducedIn": "1.0.0",
            "label": "Owner Workblock ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "procurement-service-catalogue",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Rule releases governing eligibility and routing for this offering.",
            "exchangeScope": "mapped",
            "id": "policy-rule-release-ids",
            "introducedIn": "1.0.0",
            "label": "Policy rule release IDs",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "policy-rule-release",
            "required": true,
            "sourceAuthority": {
              "id": "procurement-service-catalogue",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "catalogue",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ReferencedContract/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "public",
            "definition": "Published response, evidence and completion expectations with assumptions and exclusions.",
            "exchangeScope": "mapped",
            "id": "service-expectation",
            "introducedIn": "1.0.0",
            "label": "Service expectation",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "procurement-service-catalogue",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "catalogue",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ValidityPeriod",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "public",
                    "definition": "Response expectation is the string component carried within Procurement service offering Service expectation; its classification and authority inherit from the owning field contract.",
                    "id": "response-expectation",
                    "label": "Response expectation",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "service-expectation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "public",
                    "definition": "Required evidence codes is the set carried within Procurement service offering Service expectation; its owning field governs allowed values and interpretation.",
                    "id": "required-evidence-codes",
                    "label": "Required evidence codes",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "service-expectation",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "public",
                    "definition": "Completion criteria is the set carried within Procurement service offering Service expectation; its owning field governs allowed values and interpretation.",
                    "id": "completion-criteria",
                    "label": "Completion criteria",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "service-expectation",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "public",
                    "definition": "Assumptions is the set carried within Procurement service offering Service expectation; its owning field governs allowed values and interpretation.",
                    "id": "assumptions",
                    "label": "Assumptions",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "service-expectation",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "public",
                    "definition": "Exclusions is the set carried within Procurement service offering Service expectation; its owning field governs allowed values and interpretation.",
                    "id": "exclusions",
                    "label": "Exclusions",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "service-expectation",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "public",
                    "definition": "Effective from is the date component carried within Procurement service offering Service expectation; its classification and authority inherit from the owning field contract.",
                    "id": "effective-from",
                    "label": "Effective from",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "service-expectation",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "public",
            "definition": "Governed aliases and intent phrases used for catalogue discovery.",
            "exchangeScope": "mapped",
            "id": "search-keywords",
            "introducedIn": "1.0.0",
            "label": "Search keywords",
            "listSemantics": "set",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "procurement-service-catalogue",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "catalogue",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:CatalogueLine/cac:Item/cbc:Keyword",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string-list"
          },
          {
            "classification": "internal",
            "definition": "Timestamp from which the version may be offered.",
            "exchangeScope": "mapped",
            "format": "date-time",
            "id": "effective-from",
            "introducedIn": "1.0.0",
            "label": "Effective from",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "procurement-service-catalogue",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "catalogue",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ValidityPeriod/cbc:StartDate|cac:ValidityPeriod/cbc:StartTime",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "procurement-service-offering",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "service-code",
              "version-number"
            ],
            "id": "procurement-service-offering-by-service-code-and-version-number",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "lifecycle-state",
              "effective-from"
            ],
            "id": "procurement-service-offering-by-status-and-effective-from",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "owner-workblock-id"
            ],
            "id": "procurement-service-offering-by-owner-workblock-id",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "search-keywords"
            ],
            "id": "procurement-service-offering-by-search-keywords",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "reference",
        "label": "Procurement service offering",
        "lifecycle": [
          "draft",
          "published",
          "restricted",
          "suspended",
          "superseded",
          "retired"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "procurement-service-catalogue",
        "owningDomainWorkblockId": "intake-demand",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Procurement service offerings",
        "primaryKey": "procurement-service-offering-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-many",
            "definition": "Binds the offering to the exact policy releases governing eligibility and routing.",
            "id": "procurement-service-offering-governed-by-policy-rule-release-offering-policy-rules",
            "introducedIn": "1.0.0",
            "predicate": "governed-by",
            "qualifiedId": "procurement-service-offering-governed-by-policy-rule-release-offering-policy-rules",
            "required": true,
            "sourceFieldId": "policy-rule-release-ids",
            "targetEntityId": "policy-rule-release",
            "targetFieldId": "policy-rule-release-id"
          }
        ],
        "retentionClass": "reference",
        "searchTerms": [
          "procurement service",
          "request type",
          "buying service",
          "service catalogue",
          "how to buy"
        ],
        "sourceSystemRoleIds": [
          "system-of-record",
          "planning-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "collaboration-channel"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "demand-orchestration",
          "policy-rule-lifecycle",
          "procurement-service-catalogue",
          "request-enrichment-routing"
        ],
        "definition": "The canonical statement of a business need captured once, with requester intent, outcomes, constraints, evidence and consent for procurement processing.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable tenant-scoped identifier for the request across clarification turns.",
            "exchangeScope": "mapped",
            "format": "uuid",
            "id": "intake-request-id",
            "introducedIn": "1.0.0",
            "label": "Intake request ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "intelligent-intake",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Optional originating channel reference used for reconciliation.",
            "exchangeScope": "mapped",
            "id": "external-reference",
            "introducedIn": "1.0.0",
            "label": "External reference",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "intelligent-intake",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:CustomerReference",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "personal",
            "definition": "Canonical person accountable for confirming the business need.",
            "exchangeScope": "mapped",
            "id": "requester-person-id",
            "introducedIn": "1.0.0",
            "label": "Requester person ID",
            "nullable": false,
            "referenceEntityId": "person",
            "required": true,
            "sourceAuthority": {
              "id": "intelligent-intake",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:BuyerCustomerParty/cac:Party/cac:Contact/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Canonical unit owning the need and expected cost.",
            "exchangeScope": "mapped",
            "id": "business-unit-id",
            "introducedIn": "1.0.0",
            "label": "Business unit ID",
            "nullable": false,
            "referenceEntityId": "business-unit",
            "required": true,
            "sourceAuthority": {
              "id": "intelligent-intake",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:BuyerCustomerParty/cac:Party/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Catalogue offering selected or inferred for the request.",
            "exchangeScope": "mapped",
            "id": "service-offering-id",
            "introducedIn": "1.0.0",
            "label": "Service offering ID",
            "nullable": true,
            "referenceEntityId": "procurement-service-offering",
            "required": false,
            "sourceAuthority": {
              "id": "intelligent-intake",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OrderLine/cac:LineItem/cac:Item/cac:CatalogueItemIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Requester-confirmed description of the desired business outcome, not a prematurely selected solution.",
            "exchangeScope": "mapped",
            "id": "need-statement",
            "introducedIn": "1.0.0",
            "label": "Need statement",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "intelligent-intake",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:Note",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "text"
          },
          {
            "classification": "confidential",
            "definition": "Typed functional, service, quantity, location, timing, risk and constraint requirements.",
            "exchangeScope": "mapped",
            "id": "requirements",
            "introducedIn": "1.0.0",
            "label": "Requirements",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "intelligent-intake",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OrderLine/cac:LineItem",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Functional description is the string component carried within Intake request Requirements; its classification and authority inherit from the owning field contract.",
                    "id": "functional-description",
                    "label": "Functional description",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "requirements",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Service level description is the string component carried within Intake request Requirements; its classification and authority inherit from the owning field contract.",
                    "id": "service-level-description",
                    "label": "Service level description",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "requirements",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Quantity is the quantity component carried within Intake request Requirements; its classification and authority inherit from the owning field contract.",
                    "id": "quantity",
                    "label": "Quantity",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "requirements",
                      "kind": "inherited-field"
                    },
                    "type": "quantity",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "quantity-value",
                      "schemaVersion": "1.0.0"
                    }
                  },
                  {
                    "classification": "confidential",
                    "definition": "Delivery location ID is the string component carried within Intake request Requirements; its classification and authority inherit from the owning field contract.",
                    "id": "delivery-location-id",
                    "label": "Delivery location ID",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "requirements",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Required by date is the date component carried within Intake request Requirements; its classification and authority inherit from the owning field contract.",
                    "id": "required-by-date",
                    "label": "Required by date",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "requirements",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Risk codes is the set carried within Intake request Requirements; its owning field governs allowed values and interpretation.",
                    "id": "risk-codes",
                    "label": "Risk codes",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "requirements",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Constraint descriptions is the set carried within Intake request Requirements; its owning field governs allowed values and interpretation.",
                    "id": "constraint-descriptions",
                    "label": "Constraint descriptions",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "requirements",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Specification evidence item ids links this structured value to governed evidence items through evidence-item-id within Intake request Requirements.",
                    "id": "specification-evidence-item-ids",
                    "label": "Specification evidence item ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links specification evidence item ids to governed evidence items through the canonical evidence-item-id field.",
                      "id": "intake-request-requirements-specification-evidence-item-ids",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "requirements",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Requester estimate with amount, currency, range, confidence and basis.",
            "exchangeScope": "mapped",
            "id": "estimated-value",
            "introducedIn": "1.0.0",
            "label": "Estimated value",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "intelligent-intake",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:AnticipatedMonetaryTotal/cbc:PayableAmount",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Estimate is the money component carried within Intake request Estimated value; its classification and authority inherit from the owning field contract.",
                    "id": "estimate",
                    "label": "Estimate",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "estimated-value",
                      "kind": "inherited-field"
                    },
                    "type": "money",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "money-value",
                      "schemaVersion": "2.0.0"
                    }
                  },
                  {
                    "classification": "confidential",
                    "definition": "Lower bound is the money component carried within Intake request Estimated value; its classification and authority inherit from the owning field contract.",
                    "id": "lower-bound",
                    "label": "Lower bound",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "estimated-value",
                      "kind": "inherited-field"
                    },
                    "type": "money",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "money-value",
                      "schemaVersion": "2.0.0"
                    }
                  },
                  {
                    "classification": "confidential",
                    "definition": "Upper bound is the money component carried within Intake request Estimated value; its classification and authority inherit from the owning field contract.",
                    "id": "upper-bound",
                    "label": "Upper bound",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "estimated-value",
                      "kind": "inherited-field"
                    },
                    "type": "money",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "money-value",
                      "schemaVersion": "2.0.0"
                    }
                  },
                  {
                    "classification": "confidential",
                    "definition": "Confidence is the decimal component carried within Intake request Estimated value; its classification and authority inherit from the owning field contract.",
                    "id": "confidence",
                    "label": "Confidence",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "estimated-value",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Basis is the string component carried within Intake request Estimated value; its classification and authority inherit from the owning field contract.",
                    "id": "basis",
                    "label": "Basis",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "estimated-value",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "As of date is the date component carried within Intake request Estimated value; its classification and authority inherit from the owning field contract.",
                    "id": "as-of-date",
                    "label": "As of date",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "estimated-value",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Date by which the business outcome or delivery is required.",
            "exchangeScope": "mapped",
            "format": "date",
            "id": "needed-by-date",
            "introducedIn": "1.0.0",
            "label": "Needed by date",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "intelligent-intake",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:Delivery/cac:RequestedDeliveryPeriod/cbc:EndDate",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "date"
          },
          {
            "classification": "restricted",
            "definition": "References to source documents, specifications, budget evidence and other supporting material.",
            "exchangeScope": "mapped",
            "id": "evidence-item-ids",
            "introducedIn": "1.0.0",
            "label": "Evidence item IDs",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "intelligent-intake",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:AdditionalDocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Deterministic completeness against the selected offering schema; it does not imply policy compliance.",
            "exchangeScope": "internal",
            "format": "0..1",
            "id": "completeness-score",
            "introducedIn": "1.0.0",
            "label": "Completeness score",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "intelligent-intake",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "decimal"
          },
          {
            "classification": "internal",
            "definition": "Timestamp when the requester committed the complete need for processing.",
            "exchangeScope": "mapped",
            "format": "date-time",
            "id": "submitted-at",
            "introducedIn": "1.0.0",
            "label": "Submitted at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "intelligent-intake",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:IssueDate|cbc:IssueTime",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Authority envelope governing proposals, approvals and commitments for this record.",
            "exchangeScope": "unmapped",
            "id": "governance-authority-envelope-id",
            "introducedIn": "4.0.0",
            "label": "Governance authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "intelligent-intake",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "intake-request",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "requester-person-id",
              "lifecycle-state"
            ],
            "id": "intake-request-by-requester-person-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "service-offering-id",
              "submitted-at"
            ],
            "id": "intake-request-by-service-offering-id-and-submitted-at",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "business-unit-id"
            ],
            "id": "intake-request-by-business-unit-id",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "external-reference"
            ],
            "id": "intake-request-by-external-reference",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "case",
        "label": "Intake request",
        "lifecycle": [
          "started",
          "clarifying",
          "complete",
          "submitted",
          "withdrawn",
          "superseded",
          "converted"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "intelligent-intake",
        "owningDomainWorkblockId": "intake-demand",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Intake requests",
        "primaryKey": "intake-request-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Associates the request with its accountable requester.",
            "id": "intake-request-references-person-intake-requester",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "intake-request-references-person-intake-requester",
            "required": true,
            "sourceFieldId": "requester-person-id",
            "targetEntityId": "person",
            "targetFieldId": "person-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Associates the request with its owning organizational unit.",
            "id": "intake-request-belongs-to-business-unit-intake-business-unit",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "intake-request-belongs-to-business-unit-intake-business-unit",
            "required": true,
            "sourceFieldId": "business-unit-id",
            "targetEntityId": "business-unit",
            "targetFieldId": "business-unit-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Associates the request with its selected service contract.",
            "id": "intake-request-references-procurement-service-offering-intake-offering",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "intake-request-references-procurement-service-offering-intake-offering",
            "required": false,
            "sourceFieldId": "service-offering-id",
            "targetEntityId": "procurement-service-offering",
            "targetFieldId": "procurement-service-offering-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the canonical request to its immutable message, file and source evidence.",
            "id": "intake-request-evidenced-by-evidence-item-intake-evidence",
            "introducedIn": "1.1.0",
            "predicate": "evidenced-by",
            "qualifiedId": "intake-request-evidenced-by-evidence-item-intake-evidence",
            "required": true,
            "sourceFieldId": "evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authority envelope governing this record.",
            "id": "intake-request-governed-by-authority-envelope-intake-request-governance-authority",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "intake-request-governed-by-authority-envelope-intake-request-governance-authority",
            "required": false,
            "sourceFieldId": "governance-authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          }
        ],
        "retentionClass": "operational",
        "searchTerms": [
          "procurement request",
          "business need",
          "buying request",
          "intake",
          "requester intent"
        ],
        "sourceSystemRoleIds": [
          "collaboration-channel",
          "system-of-record"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "collaboration-channel"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": false,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "demand-orchestration"
        ],
        "definition": "A versioned, machine-proposed and evidence-linked augmentation of an intake request with normalised taxonomy, duplicates, supplier or contract context, policy results and route candidates.",
        "domainWorkblockIds": [
          "intake-demand"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for this immutable enrichment version.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "enriched-request-id",
            "introducedIn": "1.0.0",
            "label": "Enrichment ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "request-enrichment-routing",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Monotonic enrichment version for the intake request.",
            "exchangeScope": "internal",
            "id": "version-number",
            "introducedIn": "1.0.0",
            "label": "Version number",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "request-enrichment-routing",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "integer"
          },
          {
            "classification": "confidential",
            "definition": "Request whose facts are augmented without overwriting requester-confirmed content.",
            "exchangeScope": "mapped",
            "id": "intake-request-id",
            "introducedIn": "1.0.0",
            "label": "Intake request ID",
            "nullable": false,
            "referenceEntityId": "intake-request",
            "required": true,
            "sourceAuthority": {
              "id": "request-enrichment-routing",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Proposed canonical category with field-level evidence and confidence.",
            "exchangeScope": "mapped",
            "id": "category-id",
            "introducedIn": "1.0.0",
            "label": "Category ID",
            "nullable": true,
            "referenceEntityId": "category",
            "required": false,
            "sourceAuthority": {
              "id": "request-enrichment-routing",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OrderLine/cac:LineItem/cac:Item/cac:CommodityClassification/cbc:ItemClassificationCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Typed units, quantities, locations, dates, specifications and constraints derived from confirmed intake content.",
            "exchangeScope": "mapped",
            "id": "normalised-requirements",
            "introducedIn": "1.0.0",
            "label": "Normalised requirements",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "request-enrichment-routing",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OrderLine/cac:LineItem",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Normalised quantity is the quantity component carried within Enriched request Normalised requirements; its classification and authority inherit from the owning field contract.",
                    "id": "normalised-quantity",
                    "label": "Normalised quantity",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "normalised-requirements",
                      "kind": "inherited-field"
                    },
                    "type": "quantity",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "quantity-value",
                      "schemaVersion": "1.0.0"
                    }
                  },
                  {
                    "classification": "confidential",
                    "definition": "Location ids is the set carried within Enriched request Normalised requirements; its owning field governs allowed values and interpretation.",
                    "id": "location-ids",
                    "label": "Location ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "normalised-requirements",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Start date is the date component carried within Enriched request Normalised requirements; its classification and authority inherit from the owning field contract.",
                    "id": "start-date",
                    "label": "Start date",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "normalised-requirements",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Required by date is the date component carried within Enriched request Normalised requirements; its classification and authority inherit from the owning field contract.",
                    "id": "required-by-date",
                    "label": "Required by date",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "normalised-requirements",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Specification is the string component carried within Enriched request Normalised requirements; its classification and authority inherit from the owning field contract.",
                    "id": "specification",
                    "label": "Specification",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "normalised-requirements",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Constraint codes is the set carried within Enriched request Normalised requirements; its owning field governs allowed values and interpretation.",
                    "id": "constraint-codes",
                    "label": "Constraint codes",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "normalised-requirements",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Normalization evidence item ids links this structured value to governed evidence items through evidence-item-id within Enriched request Normalised requirements.",
                    "id": "normalization-evidence-item-ids",
                    "label": "Normalization evidence item ids",
                    "listSemantics": "set",
                    "nullable": false,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links normalization evidence item ids to governed evidence items through the canonical evidence-item-id field.",
                      "id": "enriched-request-normalised-requirements-normalization-evidence-item-ids",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "normalised-requirements",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Permission-filtered candidate catalogue, contract, supplier, prior request and portfolio references with match rationale.",
            "exchangeScope": "mapped",
            "id": "context-links",
            "introducedIn": "1.0.0",
            "label": "Context links",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "request-enrichment-routing",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OriginatorDocumentReference|cac:Contract",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Context link ID is the uuid component carried within Enriched request Context links; its classification and authority inherit from the owning field contract.",
                    "id": "context-link-id",
                    "label": "Context link ID",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "context-links",
                      "kind": "inherited-field"
                    },
                    "type": "uuid"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Context type records the governed state or type within Enriched request Context links without treating absence, unknown and zero as equivalent.",
                    "id": "context-type",
                    "label": "Context type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "context-links",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Target entity ID is the string component carried within Enriched request Context links; its classification and authority inherit from the owning field contract.",
                    "id": "target-entity-id",
                    "label": "Target entity ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "context-links",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Match rationale is the string component carried within Enriched request Context links; its classification and authority inherit from the owning field contract.",
                    "id": "match-rationale",
                    "label": "Match rationale",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "context-links",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Confidence is the decimal component carried within Enriched request Context links; its classification and authority inherit from the owning field contract.",
                    "id": "confidence",
                    "label": "Confidence",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "context-links",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Evidence item ids links this structured value to governed evidence items through evidence-item-id within Enriched request Context links.",
                    "id": "evidence-item-ids",
                    "label": "Evidence item ids",
                    "listSemantics": "set",
                    "nullable": false,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links evidence item ids to governed evidence items through the canonical evidence-item-id field.",
                      "id": "enriched-request-context-links-evidence-item-ids",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "context-links",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Permission scope is the string component carried within Enriched request Context links; its classification and authority inherit from the owning field contract.",
                    "id": "permission-scope",
                    "label": "Permission scope",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "context-links",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Source observed at is the timestamp component carried within Enriched request Context links; its classification and authority inherit from the owning field contract.",
                    "id": "source-observed-at",
                    "label": "Source observed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "context-links",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  }
                ],
                "uniqueBy": [
                  "context-link-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Exact policy evaluation supporting the route candidate.",
            "exchangeScope": "mapped",
            "id": "policy-guidance-result-id",
            "introducedIn": "1.0.0",
            "label": "Policy guidance result ID",
            "nullable": false,
            "referenceEntityId": "policy-guidance-result",
            "required": true,
            "sourceAuthority": {
              "id": "request-enrichment-routing",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:AdditionalDocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Proposed procurement route selected from policy-permitted options.",
            "exchangeScope": "mapped",
            "id": "route-code",
            "introducedIn": "1.0.0",
            "label": "Route code",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "request-enrichment-routing",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:OrderTypeCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Calibrated confidence for the proposed route after critic and policy checks.",
            "exchangeScope": "internal",
            "format": "0..1",
            "id": "route-confidence",
            "introducedIn": "1.0.0",
            "label": "Route confidence",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "request-enrichment-routing",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "decimal"
          },
          {
            "classification": "internal",
            "definition": "Required evidence still absent after enrichment, expressed as governed codes.",
            "exchangeScope": "internal",
            "id": "missing-evidence-codes",
            "introducedIn": "1.0.0",
            "label": "Missing evidence codes",
            "listSemantics": "set",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "request-enrichment-routing",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string-list"
          },
          {
            "classification": "internal",
            "definition": "Timestamp after which changed evidence requires enrichment and routing to be recomputed.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "expires-at",
            "introducedIn": "1.0.0",
            "label": "Expires at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "request-enrichment-routing",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Shared governed decision record that carries authority, rationale and evidence for this domain decision.",
            "exchangeScope": "unmapped",
            "id": "governance-decision-id",
            "introducedIn": "4.0.0",
            "label": "Governance decision ID",
            "nullable": true,
            "referenceEntityId": "decision",
            "required": false,
            "sourceAuthority": {
              "id": "request-enrichment-routing",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Authority envelope governing proposals, approvals and commitments for this record.",
            "exchangeScope": "unmapped",
            "id": "governance-authority-envelope-id",
            "introducedIn": "4.0.0",
            "label": "Governance authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "request-enrichment-routing",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Evidence supporting this record and its governed outcome.",
            "exchangeScope": "unmapped",
            "id": "governance-evidence-item-ids",
            "introducedIn": "4.0.0",
            "label": "Governance evidence item IDs",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "request-enrichment-routing",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "enriched-request",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "intake-request-id",
              "version-number"
            ],
            "id": "enriched-request-by-intake-request-id-and-version-number",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "route-code",
              "lifecycle-state"
            ],
            "id": "enriched-request-by-route-code-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "category-id"
            ],
            "id": "enriched-request-by-category-id",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "expires-at"
            ],
            "id": "enriched-request-by-expires-at",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "decision",
        "label": "Enriched request",
        "lifecycle": [
          "assembling",
          "proposed",
          "validated",
          "routed",
          "escalated",
          "superseded",
          "expired"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "request-enrichment-routing",
        "owningDomainWorkblockId": "intake-demand",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Enriched requests",
        "primaryKey": "enriched-request-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Associates each enrichment version with the original request.",
            "id": "enriched-request-references-intake-request-enrichment-request",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "enriched-request-references-intake-request-enrichment-request",
            "required": true,
            "sourceFieldId": "intake-request-id",
            "targetEntityId": "intake-request",
            "targetFieldId": "intake-request-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Associates the derived category with the canonical taxonomy record.",
            "id": "enriched-request-classified-as-category-enrichment-category",
            "introducedIn": "1.0.0",
            "predicate": "classified-as",
            "qualifiedId": "enriched-request-classified-as-category-enrichment-category",
            "required": false,
            "sourceFieldId": "category-id",
            "targetEntityId": "category",
            "targetFieldId": "category-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Binds routing to the exact policy guidance result.",
            "id": "enriched-request-references-policy-guidance-result-enrichment-guidance",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "enriched-request-references-policy-guidance-result-enrichment-guidance",
            "required": true,
            "sourceFieldId": "policy-guidance-result-id",
            "targetEntityId": "policy-guidance-result",
            "targetFieldId": "policy-guidance-result-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Shared governed decision for this domain outcome.",
            "id": "enriched-request-governed-by-decision-enriched-request-governance-decision",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "enriched-request-governed-by-decision-enriched-request-governance-decision",
            "required": false,
            "sourceFieldId": "governance-decision-id",
            "targetEntityId": "decision",
            "targetFieldId": "decision-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authority envelope governing this record.",
            "id": "enriched-request-governed-by-authority-envelope-enriched-request-governance-authority",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "enriched-request-governed-by-authority-envelope-enriched-request-governance-authority",
            "required": false,
            "sourceFieldId": "governance-authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Evidence supporting this record.",
            "id": "enriched-request-evidenced-by-evidence-item-enriched-request-governance-evidence",
            "introducedIn": "4.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "enriched-request-evidenced-by-evidence-item-enriched-request-governance-evidence",
            "required": false,
            "sourceFieldId": "governance-evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "enriched request",
          "route recommendation",
          "duplicate demand",
          "request classification",
          "buying route"
        ],
        "sourceSystemRoleIds": [
          "system-of-record",
          "execution-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "collaboration-channel",
          "execution-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "demand-consolidation-portfolio",
          "tactical-sourcing-autonomy"
        ],
        "definition": "A durable orchestration record that moves one qualified business demand through the selected procurement route, dependencies, commitments, exceptions and handoffs.",
        "domainWorkblockIds": [
          "intake-demand",
          "sourcing-negotiation"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for the orchestrated procurement journey.",
            "exchangeScope": "mapped",
            "format": "uuid",
            "id": "demand-case-id",
            "introducedIn": "1.0.0",
            "label": "Demand case ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "demand-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Committed intake request that originated the demand.",
            "exchangeScope": "mapped",
            "id": "intake-request-id",
            "introducedIn": "1.0.0",
            "label": "Intake request ID",
            "nullable": false,
            "referenceEntityId": "intake-request",
            "required": true,
            "sourceAuthority": {
              "id": "demand-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:CustomerReference",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Exact validated enrichment and route evidence used to create the case.",
            "exchangeScope": "mapped",
            "id": "enrichment-id",
            "introducedIn": "1.0.0",
            "label": "Enrichment ID",
            "nullable": false,
            "referenceEntityId": "enriched-request",
            "required": true,
            "sourceAuthority": {
              "id": "demand-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OriginatorDocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Committed procurement route currently governing orchestration.",
            "exchangeScope": "mapped",
            "id": "route-code",
            "introducedIn": "1.0.0",
            "label": "Route code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "demand-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:OrderTypeCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Monotonic version of the typed step graph, gates and recovery behaviour.",
            "exchangeScope": "internal",
            "id": "plan-version",
            "introducedIn": "1.0.0",
            "label": "Plan version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "demand-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "integer"
          },
          {
            "classification": "confidential",
            "definition": "Current typed graph nodes, dependencies, owners, attempts, child runs and reconciliation state.",
            "exchangeScope": "internal",
            "id": "step-state",
            "introducedIn": "1.0.0",
            "label": "Step state",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "demand-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Step ID is the string component carried within Demand case Step state; its classification and authority inherit from the owning field contract.",
                    "id": "step-id",
                    "label": "Step ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "step-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Step type records the governed state or type within Demand case Step state without treating absence, unknown and zero as equivalent.",
                    "id": "step-type",
                    "label": "Step type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "step-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Status records the governed state or type within Demand case Step state without treating absence, unknown and zero as equivalent.",
                    "id": "status",
                    "label": "Status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "step-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Dependency step ids is the set carried within Demand case Step state; its owning field governs allowed values and interpretation.",
                    "id": "dependency-step-ids",
                    "label": "Dependency step ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "step-state",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Owner person ID links this structured value to the governed person record within Demand case Step state.",
                    "id": "owner-person-id",
                    "label": "Owner person ID",
                    "nullable": true,
                    "referenceEntityId": "person",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the owner person ID in step state to the referenced person via its canonical person ID.",
                      "id": "demand-case-step-state-owner-person-id",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "person-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "step-state",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Attempt count is the integer component carried within Demand case Step state; its classification and authority inherit from the owning field contract.",
                    "id": "attempt-count",
                    "label": "Attempt count",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "step-state",
                      "kind": "inherited-field"
                    },
                    "type": "integer"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Child run ids is the set carried within Demand case Step state; its owning field governs allowed values and interpretation.",
                    "id": "child-run-ids",
                    "label": "Child run ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "step-state",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Reconciliation status records the governed state or type within Demand case Step state without treating absence, unknown and zero as equivalent.",
                    "id": "reconciliation-status",
                    "label": "Reconciliation status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "step-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Updated at is the timestamp component carried within Demand case Step state; its classification and authority inherit from the owning field contract.",
                    "id": "updated-at",
                    "label": "Updated at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "step-state",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  }
                ],
                "uniqueBy": [
                  "step-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "personal",
            "definition": "Person accountable for true exceptions and outcome supervision.",
            "exchangeScope": "mapped",
            "id": "owner-person-id",
            "introducedIn": "1.0.0",
            "label": "Owner person ID",
            "nullable": false,
            "referenceEntityId": "person",
            "required": true,
            "sourceAuthority": {
              "id": "demand-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:BuyerCustomerParty/cac:Party/cac:Contact/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Actions that crossed a documented commitment boundary during orchestration.",
            "exchangeScope": "mapped",
            "id": "committed-action-ids",
            "introducedIn": "1.0.0",
            "label": "Committed action IDs",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "committed-action",
            "required": true,
            "sourceAuthority": {
              "id": "demand-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "extension",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:AdditionalDocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "extension-required"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "restricted",
            "definition": "Active exception outside the route or authority envelope, if any.",
            "exchangeScope": "internal",
            "id": "exception-id",
            "introducedIn": "1.0.0",
            "label": "Exception case ID",
            "nullable": true,
            "referenceEntityId": "exception",
            "required": false,
            "sourceAuthority": {
              "id": "demand-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Demand portfolio into which the case has been grouped for coordinated action.",
            "exchangeScope": "internal",
            "id": "portfolio-id",
            "introducedIn": "1.0.0",
            "label": "Portfolio ID",
            "nullable": true,
            "referenceEntityId": "demand-portfolio",
            "required": false,
            "sourceAuthority": {
              "id": "demand-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Timestamp by which the next required action, timeout or escalation must occur.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "next-action-due-at",
            "introducedIn": "1.0.0",
            "label": "Next action due at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "demand-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Timestamp of the latest reconciled case mutation.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "updated-at",
            "introducedIn": "1.0.0",
            "label": "Updated at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "demand-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Authority envelope governing proposals, approvals and commitments for this record.",
            "exchangeScope": "unmapped",
            "id": "governance-authority-envelope-id",
            "introducedIn": "4.0.0",
            "label": "Governance authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "demand-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Evidence supporting this record and its governed outcome.",
            "exchangeScope": "unmapped",
            "id": "governance-evidence-item-ids",
            "introducedIn": "4.0.0",
            "label": "Governance evidence item IDs",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "demand-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "demand-case",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "intake-request-id"
            ],
            "id": "demand-case-by-intake-request-id",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "route-code",
              "lifecycle-state"
            ],
            "id": "demand-case-by-route-code-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "owner-person-id",
              "lifecycle-state"
            ],
            "id": "demand-case-by-owner-person-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "next-action-due-at"
            ],
            "id": "demand-case-by-next-action-due-at",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "portfolio-id"
            ],
            "id": "demand-case-by-portfolio-id",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "case",
        "label": "Demand case",
        "lifecycle": [
          "qualified",
          "planned",
          "in-progress",
          "waiting",
          "exception",
          "fulfilled",
          "cancelled",
          "closed"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "demand-orchestration",
        "owningDomainWorkblockId": "intake-demand",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Demand cases",
        "primaryKey": "demand-case-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "one-to-one",
            "definition": "Links orchestration to the originating committed intake.",
            "id": "demand-case-references-intake-request-demand-intake",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "demand-case-references-intake-request-demand-intake",
            "required": true,
            "sourceFieldId": "intake-request-id",
            "targetEntityId": "intake-request",
            "targetFieldId": "intake-request-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Binds orchestration to the validated route evidence.",
            "id": "demand-case-references-enriched-request-demand-enrichment",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "demand-case-references-enriched-request-demand-enrichment",
            "required": true,
            "sourceFieldId": "enrichment-id",
            "targetEntityId": "enriched-request",
            "targetFieldId": "enriched-request-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Associates the case with its current consolidation portfolio.",
            "id": "demand-case-belongs-to-demand-portfolio-demand-portfolio-membership",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "demand-case-belongs-to-demand-portfolio-demand-portfolio-membership",
            "required": false,
            "sourceFieldId": "portfolio-id",
            "targetEntityId": "demand-portfolio",
            "targetFieldId": "demand-portfolio-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Associates the case with its accountable human owner.",
            "id": "demand-case-assigned-to-person-demand-owner",
            "introducedIn": "1.1.0",
            "predicate": "assigned-to",
            "qualifiedId": "demand-case-assigned-to-person-demand-owner",
            "required": true,
            "sourceFieldId": "owner-person-id",
            "targetEntityId": "person",
            "targetFieldId": "person-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the case to every separately governed action committed during orchestration.",
            "id": "demand-case-references-committed-action-demand-committed-actions",
            "introducedIn": "1.1.0",
            "predicate": "references",
            "qualifiedId": "demand-case-references-committed-action-demand-committed-actions",
            "required": true,
            "sourceFieldId": "committed-action-ids",
            "targetEntityId": "committed-action",
            "targetFieldId": "committed-action-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links a case outside routine authority to its governed exception record.",
            "id": "demand-case-references-exception-demand-exception",
            "introducedIn": "1.1.0",
            "predicate": "references",
            "qualifiedId": "demand-case-references-exception-demand-exception",
            "required": false,
            "sourceFieldId": "exception-id",
            "targetEntityId": "exception",
            "targetFieldId": "exception-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authority envelope governing this record.",
            "id": "demand-case-governed-by-authority-envelope-demand-case-governance-authority",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "demand-case-governed-by-authority-envelope-demand-case-governance-authority",
            "required": false,
            "sourceFieldId": "governance-authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Evidence supporting this record.",
            "id": "demand-case-evidenced-by-evidence-item-demand-case-governance-evidence",
            "introducedIn": "4.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "demand-case-evidenced-by-evidence-item-demand-case-governance-evidence",
            "required": false,
            "sourceFieldId": "governance-evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          }
        ],
        "retentionClass": "operational",
        "searchTerms": [
          "demand case",
          "procurement case",
          "request status",
          "orchestration",
          "procurement journey"
        ],
        "sourceSystemRoleIds": [
          "system-of-record",
          "execution-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "collaboration-channel",
          "planning-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "sourcing-pipeline-discovery"
        ],
        "definition": "A versioned grouping of compatible current and forecast demand with timing, value, confidence, consolidation logic and an executable portfolio disposition.",
        "domainWorkblockIds": [
          "intake-demand",
          "sourcing-negotiation"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for the grouping and its version history.",
            "exchangeScope": "mapped",
            "format": "uuid",
            "id": "demand-portfolio-id",
            "introducedIn": "1.0.0",
            "label": "Portfolio ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "demand-consolidation-portfolio",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "forecast",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Monotonic grouping and scenario version.",
            "exchangeScope": "mapped",
            "id": "version-number",
            "introducedIn": "1.0.0",
            "label": "Version number",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "demand-consolidation-portfolio",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "forecast",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:VersionID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "integer"
          },
          {
            "classification": "internal",
            "definition": "Primary canonical category for compatible portfolio demand.",
            "exchangeScope": "mapped",
            "id": "category-id",
            "introducedIn": "1.0.0",
            "label": "Category ID",
            "nullable": false,
            "referenceEntityId": "category",
            "required": true,
            "sourceAuthority": {
              "id": "demand-consolidation-portfolio",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "forecast",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ForecastLine/cac:SalesItem/cac:Item/cac:CommodityClassification/cbc:ItemClassificationCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Current committed demand cases included in this exact version.",
            "exchangeScope": "mapped",
            "id": "demand-case-ids",
            "introducedIn": "1.0.0",
            "label": "Demand case IDs",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "demand-case",
            "required": true,
            "sourceAuthority": {
              "id": "demand-consolidation-portfolio",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "forecast",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ForecastLine/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "confidential",
            "definition": "Non-committed forecast quantities, values, time buckets, confidence and provenance kept distinct from live cases.",
            "exchangeScope": "mapped",
            "id": "forecast-components",
            "introducedIn": "1.0.0",
            "label": "Forecast components",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "demand-consolidation-portfolio",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "forecast",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ForecastLine/cac:SalesItem/cbc:Quantity",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Forecast component ID is the uuid component carried within Demand portfolio Forecast components; its classification and authority inherit from the owning field contract.",
                    "id": "forecast-component-id",
                    "label": "Forecast component ID",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "forecast-components",
                      "kind": "inherited-field"
                    },
                    "type": "uuid"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Time bucket start is the date component carried within Demand portfolio Forecast components; its classification and authority inherit from the owning field contract.",
                    "id": "time-bucket-start",
                    "label": "Time bucket start",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "forecast-components",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Time bucket end is the date component carried within Demand portfolio Forecast components; its classification and authority inherit from the owning field contract.",
                    "id": "time-bucket-end",
                    "label": "Time bucket end",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "forecast-components",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Forecast quantity is the quantity component carried within Demand portfolio Forecast components; its classification and authority inherit from the owning field contract.",
                    "id": "forecast-quantity",
                    "label": "Forecast quantity",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "forecast-components",
                      "kind": "inherited-field"
                    },
                    "type": "quantity",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "quantity-value",
                      "schemaVersion": "1.0.0"
                    }
                  },
                  {
                    "classification": "confidential",
                    "definition": "Forecast value is the money component carried within Demand portfolio Forecast components; its classification and authority inherit from the owning field contract.",
                    "id": "forecast-value",
                    "label": "Forecast value",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "forecast-components",
                      "kind": "inherited-field"
                    },
                    "type": "money",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "money-value",
                      "schemaVersion": "2.0.0"
                    }
                  },
                  {
                    "classification": "confidential",
                    "definition": "Confidence is the decimal component carried within Demand portfolio Forecast components; its classification and authority inherit from the owning field contract.",
                    "id": "confidence",
                    "label": "Confidence",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "forecast-components",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Method is the string component carried within Demand portfolio Forecast components; its classification and authority inherit from the owning field contract.",
                    "id": "method",
                    "label": "Method",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "forecast-components",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Provenance evidence item ids links this structured value to governed evidence items through evidence-item-id within Demand portfolio Forecast components.",
                    "id": "provenance-evidence-item-ids",
                    "label": "Provenance evidence item ids",
                    "listSemantics": "set",
                    "nullable": false,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links provenance evidence item ids to governed evidence items through the canonical evidence-item-id field.",
                      "id": "demand-portfolio-forecast-components-provenance-evidence-item-ids",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "forecast-components",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  }
                ],
                "uniqueBy": [
                  "forecast-component-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Explanation of compatibility, exclusions, timing and anticipated benefit linked to its source records.",
            "exchangeScope": "mapped",
            "id": "consolidation-rationale",
            "introducedIn": "1.0.0",
            "label": "Consolidation rationale",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "demand-consolidation-portfolio",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "forecast",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:Note",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "text"
          },
          {
            "classification": "confidential",
            "definition": "Typed baseline and alternative bundle, timing, route and value scenarios with assumptions and constraints.",
            "exchangeScope": "internal",
            "id": "scenario-set",
            "introducedIn": "1.0.0",
            "label": "Scenario set",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "demand-consolidation-portfolio",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Scenario ID is the uuid component carried within Demand portfolio Scenario set; its classification and authority inherit from the owning field contract.",
                    "id": "scenario-id",
                    "label": "Scenario ID",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "scenario-set",
                      "kind": "inherited-field"
                    },
                    "type": "uuid"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Scenario name is the string component carried within Demand portfolio Scenario set; its classification and authority inherit from the owning field contract.",
                    "id": "scenario-name",
                    "label": "Scenario name",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "scenario-set",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Scenario type records the governed state or type within Demand portfolio Scenario set without treating absence, unknown and zero as equivalent.",
                    "id": "scenario-type",
                    "label": "Scenario type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "scenario-set",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Bundle demand case ids links this structured value to governed demand cases through demand-case-id within Demand portfolio Scenario set.",
                    "id": "bundle-demand-case-ids",
                    "label": "Bundle demand case ids",
                    "listSemantics": "set",
                    "nullable": false,
                    "referenceEntityId": "demand-case",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links bundle demand case ids to governed demand cases through the canonical demand-case-id field.",
                      "id": "demand-portfolio-scenario-set-bundle-demand-case-ids",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "demand-case-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "scenario-set",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Timing description is the string component carried within Demand portfolio Scenario set; its classification and authority inherit from the owning field contract.",
                    "id": "timing-description",
                    "label": "Timing description",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "scenario-set",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Route code records the governed code within Demand portfolio Scenario set without treating absence, unknown and zero as equivalent.",
                    "id": "route-code",
                    "label": "Route code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "scenario-set",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Projected value is the money component carried within Demand portfolio Scenario set; its classification and authority inherit from the owning field contract.",
                    "id": "projected-value",
                    "label": "Projected value",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "scenario-set",
                      "kind": "inherited-field"
                    },
                    "type": "money",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "money-value",
                      "schemaVersion": "2.0.0"
                    }
                  },
                  {
                    "classification": "confidential",
                    "definition": "Assumptions is the set carried within Demand portfolio Scenario set; its owning field governs allowed values and interpretation.",
                    "id": "assumptions",
                    "label": "Assumptions",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "scenario-set",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Constraint codes is the set carried within Demand portfolio Scenario set; its owning field governs allowed values and interpretation.",
                    "id": "constraint-codes",
                    "label": "Constraint codes",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "scenario-set",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  }
                ],
                "uniqueBy": [
                  "scenario-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Category strategy governing the chosen portfolio disposition.",
            "exchangeScope": "internal",
            "id": "strategy-id",
            "introducedIn": "1.0.0",
            "label": "Strategy ID",
            "nullable": true,
            "referenceEntityId": "category-strategy",
            "required": false,
            "sourceAuthority": {
              "id": "demand-consolidation-portfolio",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "personal",
            "definition": "Person accountable for portfolio exceptions and outcome supervision.",
            "exchangeScope": "internal",
            "id": "owner-person-id",
            "introducedIn": "1.0.0",
            "label": "Owner person ID",
            "nullable": false,
            "referenceEntityId": "person",
            "required": true,
            "sourceAuthority": {
              "id": "demand-consolidation-portfolio",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Earliest intended execution or delivery date for the portfolio.",
            "exchangeScope": "mapped",
            "format": "date",
            "id": "target-window-start",
            "introducedIn": "1.0.0",
            "label": "Target window start",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "demand-consolidation-portfolio",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "outbound",
                "documentId": "forecast",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ForecastPeriod/cbc:StartDate",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "date"
          },
          {
            "classification": "internal",
            "definition": "Latest intended execution or delivery date for the portfolio.",
            "exchangeScope": "mapped",
            "format": "date",
            "id": "target-window-end",
            "introducedIn": "1.0.0",
            "label": "Target window end",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "demand-consolidation-portfolio",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "outbound",
                "documentId": "forecast",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ForecastPeriod/cbc:EndDate",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "date"
          },
          {
            "classification": "internal",
            "definition": "Authority envelope governing proposals, approvals and commitments for this record.",
            "exchangeScope": "unmapped",
            "id": "governance-authority-envelope-id",
            "introducedIn": "4.0.0",
            "label": "Governance authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "demand-consolidation-portfolio",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Evidence supporting this record and its governed outcome.",
            "exchangeScope": "unmapped",
            "id": "governance-evidence-item-ids",
            "introducedIn": "4.0.0",
            "label": "Governance evidence item IDs",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "demand-consolidation-portfolio",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "demand-portfolio",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "category-id",
              "lifecycle-state"
            ],
            "id": "demand-portfolio-by-category-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "target-window-start",
              "target-window-end"
            ],
            "id": "demand-portfolio-by-target-window-start-and-target-window-end",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "owner-person-id"
            ],
            "id": "demand-portfolio-by-owner-person-id",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "strategy-id"
            ],
            "id": "demand-portfolio-by-strategy-id",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "case",
        "label": "Demand portfolio",
        "lifecycle": [
          "forming",
          "proposed",
          "active",
          "executing",
          "split",
          "merged",
          "closed",
          "expired"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "demand-consolidation-portfolio",
        "owningDomainWorkblockId": "intake-demand",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Demand portfolios",
        "primaryKey": "demand-portfolio-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Associates the portfolio with its primary category.",
            "id": "demand-portfolio-classified-as-category-portfolio-category",
            "introducedIn": "1.0.0",
            "predicate": "classified-as",
            "qualifiedId": "demand-portfolio-classified-as-category-portfolio-category",
            "required": true,
            "sourceFieldId": "category-id",
            "targetEntityId": "category",
            "targetFieldId": "category-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Captures exact current-demand membership for the portfolio version.",
            "id": "demand-portfolio-belongs-to-demand-case-portfolio-demand-cases",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "demand-portfolio-belongs-to-demand-case-portfolio-demand-cases",
            "required": true,
            "sourceFieldId": "demand-case-ids",
            "targetEntityId": "demand-case",
            "targetFieldId": "demand-case-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links portfolio execution to the governing category strategy.",
            "id": "demand-portfolio-belongs-to-category-strategy-portfolio-strategy",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "demand-portfolio-belongs-to-category-strategy-portfolio-strategy",
            "required": false,
            "sourceFieldId": "strategy-id",
            "targetEntityId": "category-strategy",
            "targetFieldId": "category-strategy-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Associates the portfolio with its accountable human owner.",
            "id": "demand-portfolio-assigned-to-person-portfolio-owner",
            "introducedIn": "1.1.0",
            "predicate": "assigned-to",
            "qualifiedId": "demand-portfolio-assigned-to-person-portfolio-owner",
            "required": true,
            "sourceFieldId": "owner-person-id",
            "targetEntityId": "person",
            "targetFieldId": "person-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authority envelope governing this record.",
            "id": "demand-portfolio-governed-by-authority-envelope-demand-portfolio-governance-authority",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "demand-portfolio-governed-by-authority-envelope-demand-portfolio-governance-authority",
            "required": false,
            "sourceFieldId": "governance-authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Evidence supporting this record.",
            "id": "demand-portfolio-evidenced-by-evidence-item-demand-portfolio-governance-evidence",
            "introducedIn": "4.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "demand-portfolio-evidenced-by-evidence-item-demand-portfolio-governance-evidence",
            "required": false,
            "sourceFieldId": "governance-evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          }
        ],
        "retentionClass": "operational",
        "searchTerms": [
          "demand portfolio",
          "consolidated demand",
          "bundle",
          "forecast demand",
          "aggregation opportunity"
        ],
        "sourceSystemRoleIds": [
          "system-of-record",
          "planning-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "planning-system",
          "source-of-record"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": false,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "negotiation-copilot",
          "sourcing-event",
          "supplier-innovation-pipeline",
          "tactical-sourcing-autonomy"
        ],
        "definition": "A qualified candidate for a sourcing intervention, assembled from strategy, demand, contract, supplier and market evidence with a route, timing and expected outcome hypothesis.",
        "domainWorkblockIds": [
          "sourcing-negotiation",
          "supplier-performance-innovation-relationship"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for the sourcing hypothesis and disposition history.",
            "exchangeScope": "mapped",
            "format": "uuid",
            "id": "sourcing-opportunity-id",
            "introducedIn": "1.0.0",
            "label": "Sourcing opportunity ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Canonical category in scope.",
            "exchangeScope": "mapped",
            "id": "category-id",
            "introducedIn": "1.0.0",
            "label": "Category ID",
            "nullable": false,
            "referenceEntityId": "category",
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ProcurementProject/cac:MainCommodityClassification/cbc:ItemClassificationCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Governing category strategy version, if one applies.",
            "exchangeScope": "mapped",
            "id": "strategy-id",
            "introducedIn": "1.0.0",
            "label": "Strategy ID",
            "nullable": true,
            "referenceEntityId": "category-strategy",
            "required": false,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:AdditionalDocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Consolidated demand portfolio that supplies scope and timing.",
            "exchangeScope": "mapped",
            "id": "demand-portfolio-id",
            "introducedIn": "1.0.0",
            "label": "Demand portfolio ID",
            "nullable": true,
            "referenceEntityId": "demand-portfolio",
            "required": false,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ProcurementProjectLot/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Concise opportunity title suitable for portfolio triage.",
            "exchangeScope": "mapped",
            "id": "title",
            "introducedIn": "1.0.0",
            "label": "Title",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ProcurementProject/cbc:Name",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Summary of requirements, lots, locations, timing and exclusions linked to its source records.",
            "exchangeScope": "mapped",
            "id": "scope-summary",
            "introducedIn": "1.0.0",
            "label": "Scope summary",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ProcurementProject/cbc:Description",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "text"
          },
          {
            "classification": "confidential",
            "definition": "Permission-filtered prospective parties with discovery provenance; inclusion does not confer eligibility or invitation.",
            "exchangeScope": "mapped",
            "id": "market-candidate-party-ids",
            "introducedIn": "1.0.0",
            "label": "Market candidate party IDs",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "party",
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "qualification-application-request",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "A qualification request can identify one prospective economic operator; the GroundWorks candidate set is assembled across governed exchanges and does not confer invitation or eligibility.",
                "path": "cac:EconomicOperatorParty/cac:Party/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Proposed event, negotiation or tactical route linked to its supporting records and constrained to policy-permitted choices.",
            "enumValues": [
              "competitive-event",
              "auction",
              "direct-negotiation",
              "tactical-quote",
              "framework-calloff",
              "no-source"
            ],
            "exchangeScope": "mapped",
            "id": "recommended-route",
            "introducedIn": "1.0.0",
            "label": "Recommended route",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:TenderingProcess/cbc:ProcedureCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Expected financial and non-financial outcomes with baseline, range, confidence and method.",
            "exchangeScope": "mapped",
            "id": "value-hypothesis",
            "introducedIn": "1.0.0",
            "label": "Value hypothesis",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ProcurementProject/cac:RequestedTenderTotal/cbc:EstimatedOverallContractAmount",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Financial value is the money component carried within Sourcing opportunity Value hypothesis; its classification and authority inherit from the owning field contract.",
                    "id": "financial-value",
                    "label": "Financial value",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "value-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "money",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "money-value",
                      "schemaVersion": "2.0.0"
                    }
                  },
                  {
                    "classification": "confidential",
                    "definition": "Non financial outcomes is the set carried within Sourcing opportunity Value hypothesis; its owning field governs allowed values and interpretation.",
                    "id": "non-financial-outcomes",
                    "label": "Non financial outcomes",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "value-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Baseline description is the string component carried within Sourcing opportunity Value hypothesis; its classification and authority inherit from the owning field contract.",
                    "id": "baseline-description",
                    "label": "Baseline description",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "value-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Lower bound is the money component carried within Sourcing opportunity Value hypothesis; its classification and authority inherit from the owning field contract.",
                    "id": "lower-bound",
                    "label": "Lower bound",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "value-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "money",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "money-value",
                      "schemaVersion": "2.0.0"
                    }
                  },
                  {
                    "classification": "confidential",
                    "definition": "Upper bound is the money component carried within Sourcing opportunity Value hypothesis; its classification and authority inherit from the owning field contract.",
                    "id": "upper-bound",
                    "label": "Upper bound",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "value-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "money",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "money-value",
                      "schemaVersion": "2.0.0"
                    }
                  },
                  {
                    "classification": "confidential",
                    "definition": "Confidence is the decimal component carried within Sourcing opportunity Value hypothesis; its classification and authority inherit from the owning field contract.",
                    "id": "confidence",
                    "label": "Confidence",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "value-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Method is the string component carried within Sourcing opportunity Value hypothesis; its classification and authority inherit from the owning field contract.",
                    "id": "method",
                    "label": "Method",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "value-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Evidence item ids links this structured value to governed evidence items through evidence-item-id within Sourcing opportunity Value hypothesis.",
                    "id": "evidence-item-ids",
                    "label": "Evidence item ids",
                    "listSemantics": "set",
                    "nullable": false,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links evidence item ids to governed evidence items through the canonical evidence-item-id field.",
                      "id": "sourcing-opportunity-value-hypothesis-evidence-item-ids",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "value-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Normalised value, urgency, feasibility, market, risk and confidence score.",
            "exchangeScope": "internal",
            "format": "0..100",
            "id": "priority-score",
            "introducedIn": "1.0.0",
            "label": "Priority score",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "decimal"
          },
          {
            "classification": "internal",
            "definition": "Proposed date to begin the sourcing intervention.",
            "exchangeScope": "mapped",
            "format": "date",
            "id": "target-start-date",
            "introducedIn": "1.0.0",
            "label": "Target start date",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:TenderingProcess/cac:TenderSubmissionDeadlinePeriod/cbc:StartDate",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "date"
          },
          {
            "classification": "internal",
            "definition": "Latest observation timestamp included in qualification and scoring.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "evidence-as-of",
            "introducedIn": "1.0.0",
            "label": "Evidence as of",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Authority envelope governing proposals, approvals and commitments for this record.",
            "exchangeScope": "unmapped",
            "id": "governance-authority-envelope-id",
            "introducedIn": "4.0.0",
            "label": "Governance authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Evidence supporting this record and its governed outcome.",
            "exchangeScope": "unmapped",
            "id": "governance-evidence-item-ids",
            "introducedIn": "4.0.0",
            "label": "Governance evidence item IDs",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "sourcing-opportunity",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "category-id",
              "lifecycle-state"
            ],
            "id": "sourcing-opportunity-by-category-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "recommended-route",
              "priority-score"
            ],
            "id": "sourcing-opportunity-by-recommended-route-and-priority-score",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "target-start-date"
            ],
            "id": "sourcing-opportunity-by-target-start-date",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "strategy-id"
            ],
            "id": "sourcing-opportunity-by-strategy-id",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "demand-portfolio-id"
            ],
            "id": "sourcing-opportunity-by-demand-portfolio-id",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "case",
        "label": "Sourcing opportunity",
        "lifecycle": [
          "detected",
          "qualified",
          "prioritised",
          "planned",
          "converted",
          "deferred",
          "declined",
          "expired"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "sourcing-pipeline-discovery",
        "owningDomainWorkblockId": "sourcing-negotiation",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Sourcing opportunities",
        "primaryKey": "sourcing-opportunity-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Associates the opportunity with its canonical category.",
            "id": "sourcing-opportunity-classified-as-category-sourcing-opportunity-category",
            "introducedIn": "1.0.0",
            "predicate": "classified-as",
            "qualifiedId": "sourcing-opportunity-classified-as-category-sourcing-opportunity-category",
            "required": true,
            "sourceFieldId": "category-id",
            "targetEntityId": "category",
            "targetFieldId": "category-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the opportunity to its governing category strategy.",
            "id": "sourcing-opportunity-references-category-strategy-sourcing-opportunity-strategy",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "sourcing-opportunity-references-category-strategy-sourcing-opportunity-strategy",
            "required": false,
            "sourceFieldId": "strategy-id",
            "targetEntityId": "category-strategy",
            "targetFieldId": "category-strategy-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links sourcing scope to consolidated demand.",
            "id": "sourcing-opportunity-references-demand-portfolio-sourcing-opportunity-demand",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "sourcing-opportunity-references-demand-portfolio-sourcing-opportunity-demand",
            "required": false,
            "sourceFieldId": "demand-portfolio-id",
            "targetEntityId": "demand-portfolio",
            "targetFieldId": "demand-portfolio-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the opportunity to prospective market parties without implying qualification, invitation or award.",
            "id": "sourcing-opportunity-references-party-sourcing-opportunity-market-candidates",
            "introducedIn": "1.1.0",
            "predicate": "references",
            "qualifiedId": "sourcing-opportunity-references-party-sourcing-opportunity-market-candidates",
            "required": true,
            "sourceFieldId": "market-candidate-party-ids",
            "targetEntityId": "party",
            "targetFieldId": "party-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authority envelope governing this record.",
            "id": "sourcing-opportunity-governed-by-authority-envelope-sourcing-opportunity-governance-authority",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "sourcing-opportunity-governed-by-authority-envelope-sourcing-opportunity-governance-authority",
            "required": false,
            "sourceFieldId": "governance-authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Evidence supporting this record.",
            "id": "sourcing-opportunity-evidenced-by-evidence-item-sourcing-opportunity-governance-evidence",
            "introducedIn": "4.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "sourcing-opportunity-evidenced-by-evidence-item-sourcing-opportunity-governance-evidence",
            "required": false,
            "sourceFieldId": "governance-evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          }
        ],
        "retentionClass": "operational",
        "searchTerms": [
          "sourcing pipeline",
          "sourcing opportunity",
          "event candidate",
          "renewal opportunity",
          "market discovery"
        ],
        "sourceSystemRoleIds": [
          "system-of-record",
          "planning-system",
          "evidence-source"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "source-of-record",
          "planning-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "bid-evaluation-award"
        ],
        "definition": "The governed event identity, specification, participants, schedule, communications, bid state and fairness controls for a competitive sourcing process.",
        "domainWorkblockIds": [
          "sourcing-negotiation"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable canonical identity for the event across amendments.",
            "exchangeScope": "mapped",
            "format": "uuid",
            "id": "sourcing-event-record-id",
            "introducedIn": "1.0.0",
            "label": "Sourcing event ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-event",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Human-facing governed event identifier.",
            "exchangeScope": "mapped",
            "id": "event-number",
            "introducedIn": "1.0.0",
            "label": "Event number",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-event",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ContractFolderID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Monotonic version of the externally visible event package.",
            "exchangeScope": "mapped",
            "id": "published-version",
            "introducedIn": "1.0.0",
            "label": "Published version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-event",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:VersionID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "integer"
          },
          {
            "classification": "confidential",
            "definition": "Qualified pipeline opportunity authorising event creation.",
            "exchangeScope": "mapped",
            "id": "sourcing-opportunity-id",
            "introducedIn": "1.0.0",
            "label": "Sourcing opportunity ID",
            "nullable": false,
            "referenceEntityId": "sourcing-opportunity",
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-event",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "The opportunity is projected as the procurement-project identifier; the tenant-scoped GroundWorks key is never inferred from an untyped document reference.",
                "path": "cac:ProcurementProject/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Primary canonical procurement category.",
            "exchangeScope": "mapped",
            "id": "category-id",
            "introducedIn": "1.0.0",
            "label": "Category ID",
            "nullable": false,
            "referenceEntityId": "category",
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-event",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ProcurementProject/cac:MainCommodityClassification/cbc:ItemClassificationCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Governed competitive event mechanism.",
            "enumValues": [
              "information-request",
              "quotation-request",
              "proposal-request",
              "tender",
              "auction",
              "multi-stage"
            ],
            "exchangeScope": "mapped",
            "id": "event-type",
            "introducedIn": "1.0.0",
            "label": "Event type",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-event",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:TenderingProcess/cbc:ProcedureCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Typed lots, requirements, terms, response schema, evaluation method and mandatory criteria.",
            "exchangeScope": "mapped",
            "id": "event-specification",
            "introducedIn": "1.0.0",
            "label": "Event specification",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-event",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ProcurementProject|cac:ProcurementProjectLot|cac:TenderingTerms",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Governed competitive event mechanism used by this event specification.",
                    "enumValues": [
                      "information-request",
                      "quotation-request",
                      "proposal-request",
                      "tender",
                      "auction",
                      "multi-stage"
                    ],
                    "id": "event-type",
                    "label": "Event type",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "event-specification",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Lots is the object component carried within Sourcing event record Event specification; its classification and authority inherit from the owning field contract.",
                    "id": "lots",
                    "label": "Lots",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "event-specification",
                      "kind": "inherited-field"
                    },
                    "type": "object",
                    "valueSchema": {
                      "mode": "inline",
                      "schema": {
                        "additionalProperties": false,
                        "container": "object-list",
                        "properties": [
                          {
                            "classification": "restricted",
                            "definition": "Lot ID is the string component carried within Lots; its classification and authority inherit from the owning field contract.",
                            "id": "lot-id",
                            "label": "Lot ID",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "event-specification",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Title is the string component carried within Lots; its classification and authority inherit from the owning field contract.",
                            "id": "title",
                            "label": "Title",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "event-specification",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Requirements is the set carried within Lots; its owning field governs allowed values and interpretation.",
                            "id": "requirements",
                            "label": "Requirements",
                            "listSemantics": "set",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "event-specification",
                              "kind": "inherited-field"
                            },
                            "type": "string-list"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Quantity is the quantity component carried within Lots; its classification and authority inherit from the owning field contract.",
                            "id": "quantity",
                            "label": "Quantity",
                            "nullable": true,
                            "required": false,
                            "sourceAuthority": {
                              "id": "event-specification",
                              "kind": "inherited-field"
                            },
                            "type": "quantity",
                            "valueSchema": {
                              "mode": "registry",
                              "schemaId": "quantity-value",
                              "schemaVersion": "1.0.0"
                            }
                          },
                          {
                            "classification": "restricted",
                            "definition": "Mandatory criterion codes is the set carried within Lots; its owning field governs allowed values and interpretation.",
                            "id": "mandatory-criterion-codes",
                            "label": "Mandatory criterion codes",
                            "listSemantics": "set",
                            "nullable": true,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": false,
                            "sourceAuthority": {
                              "id": "event-specification",
                              "kind": "inherited-field"
                            },
                            "type": "string-list"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Response schema version is the string component carried within Lots; its classification and authority inherit from the owning field contract.",
                            "id": "response-schema-version",
                            "label": "Response schema version",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "event-specification",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          }
                        ],
                        "uniqueBy": [
                          "lot-id"
                        ]
                      },
                      "schemaVersion": "1.0.0"
                    }
                  },
                  {
                    "classification": "restricted",
                    "definition": "Terms is the set carried within Sourcing event record Event specification; its owning field governs allowed values and interpretation.",
                    "id": "terms",
                    "label": "Terms",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "event-specification",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Response schema version is the string component carried within Sourcing event record Event specification; its classification and authority inherit from the owning field contract.",
                    "id": "response-schema-version",
                    "label": "Response schema version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "event-specification",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evaluation method is the string component carried within Sourcing event record Event specification; its classification and authority inherit from the owning field contract.",
                    "id": "evaluation-method",
                    "label": "Evaluation method",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "event-specification",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Mandatory criterion codes is the set carried within Sourcing event record Event specification; its owning field governs allowed values and interpretation.",
                    "id": "mandatory-criterion-codes",
                    "label": "Mandatory criterion codes",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "event-specification",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Submission deadline is the timestamp component carried within Sourcing event record Event specification; its classification and authority inherit from the owning field contract.",
                    "id": "submission-deadline",
                    "label": "Submission deadline",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "event-specification",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Eligible parties invited under the published version; candidates and actual invitees remain distinct.",
            "exchangeScope": "mapped",
            "id": "invited-party-ids",
            "introducedIn": "1.0.0",
            "label": "Invited party IDs",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "party",
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-event",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "UBL identifies one receiver per CallForTenders instance; the committed invitee set is reconstructed across versioned, delivery-evidenced exchanges.",
                "path": "cac:ReceiverParty/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "restricted",
            "definition": "Immutable references to the native event pack and governed amendments.",
            "exchangeScope": "mapped",
            "id": "artifact-ids",
            "introducedIn": "1.0.0",
            "label": "Artifact references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-event",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:AdditionalDocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "confidential",
            "definition": "Committed deadline for supplier responses under the active version.",
            "exchangeScope": "mapped",
            "format": "date-time",
            "id": "submission-deadline",
            "introducedIn": "1.0.0",
            "label": "Submission deadline",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "sourcing-event",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:TenderingProcess/cac:TenderSubmissionDeadlinePeriod/cbc:EndDate|cac:TenderingProcess/cac:TenderSubmissionDeadlinePeriod/cbc:EndTime",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Timestamp when published package, recipients and delivery state last reconciled with the external channel.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "last-reconciled-at",
            "introducedIn": "1.0.0",
            "label": "Last reconciled at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "sourcing-event",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Authority envelope governing proposals, approvals and commitments for this record.",
            "exchangeScope": "unmapped",
            "id": "governance-authority-envelope-id",
            "introducedIn": "4.0.0",
            "label": "Governance authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "sourcing-event",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "sourcing-event-record",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "event-number"
            ],
            "id": "sourcing-event-record-by-event-number",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "sourcing-opportunity-id"
            ],
            "id": "sourcing-event-record-by-sourcing-opportunity-id",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "lifecycle-state",
              "submission-deadline"
            ],
            "id": "sourcing-event-record-by-status-and-submission-deadline",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "category-id"
            ],
            "id": "sourcing-event-record-by-category-id",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "published-version"
            ],
            "id": "sourcing-event-record-by-published-version",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "case",
        "label": "Sourcing event record",
        "lifecycle": [
          "designing",
          "proposed",
          "published",
          "open",
          "evaluating",
          "awarded",
          "cancelled",
          "closed",
          "archived"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "sourcing-event",
        "owningDomainWorkblockId": "sourcing-negotiation",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Sourcing event records",
        "primaryKey": "sourcing-event-record-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the event to the qualified opportunity that authorised it.",
            "id": "sourcing-event-record-references-sourcing-opportunity-event-opportunity",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "sourcing-event-record-references-sourcing-opportunity-event-opportunity",
            "required": true,
            "sourceFieldId": "sourcing-opportunity-id",
            "targetEntityId": "sourcing-opportunity",
            "targetFieldId": "sourcing-opportunity-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Associates the event with its primary category.",
            "id": "sourcing-event-record-classified-as-category-event-category",
            "introducedIn": "1.0.0",
            "predicate": "classified-as",
            "qualifiedId": "sourcing-event-record-classified-as-category-event-category",
            "required": true,
            "sourceFieldId": "category-id",
            "targetEntityId": "category",
            "targetFieldId": "category-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the event to the eligible parties selected for invitation.",
            "id": "sourcing-event-record-references-party-event-invited-parties",
            "introducedIn": "2.0.0",
            "predicate": "references",
            "qualifiedId": "sourcing-event-record-references-party-event-invited-parties",
            "required": true,
            "sourceFieldId": "invited-party-ids",
            "targetEntityId": "party",
            "targetFieldId": "party-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the event to its immutable published pack and amendment evidence.",
            "id": "sourcing-event-record-evidenced-by-evidence-item-event-artifacts",
            "introducedIn": "2.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "sourcing-event-record-evidenced-by-evidence-item-event-artifacts",
            "required": true,
            "sourceFieldId": "artifact-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authority envelope governing this record.",
            "id": "sourcing-event-record-governed-by-authority-envelope-sourcing-event-record-governance-authority",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "sourcing-event-record-governed-by-authority-envelope-sourcing-event-record-governance-authority",
            "required": false,
            "sourceFieldId": "governance-authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "sourcing event",
          "rfx",
          "tender",
          "request for proposal",
          "competitive event"
        ],
        "sourceSystemRoleIds": [
          "source-of-record",
          "system-of-record",
          "collaboration-channel"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "collaboration-channel",
          "system-of-record"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "negotiation-copilot",
          "value-portfolio-forecast"
        ],
        "definition": "A reproducible bid evaluation and allocation scenario with normalised responses, constraint model, scores, sensitivity, risk and an explicit boundary between recommendation and committed award.",
        "domainWorkblockIds": [
          "sourcing-negotiation",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable identifier for the reproducible evaluation and allocation scenario.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "award-scenario-id",
            "introducedIn": "1.0.0",
            "label": "Award scenario ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "bid-evaluation-award",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Monotonic number within the sourcing event.",
            "exchangeScope": "internal",
            "id": "scenario-number",
            "introducedIn": "1.0.0",
            "label": "Scenario number",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "bid-evaluation-award",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "integer"
          },
          {
            "classification": "restricted",
            "definition": "Exact event and published version whose bids were evaluated.",
            "exchangeScope": "mapped",
            "id": "sourcing-event-id",
            "introducedIn": "1.0.0",
            "label": "Sourcing event ID",
            "nullable": false,
            "referenceEntityId": "sourcing-event-record",
            "required": true,
            "sourceAuthority": {
              "id": "bid-evaluation-award",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "tender",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ContractFolderID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Immutable sealed response references and content hashes included in the scenario.",
            "exchangeScope": "mapped",
            "id": "bid-source-ids",
            "introducedIn": "1.0.0",
            "label": "Bid source references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "bid-evaluation-award",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "tender",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID|cac:DocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "restricted",
            "definition": "Versioned mandatory criteria, weighted criteria, evaluator aggregation and conflict rules.",
            "exchangeScope": "mapped",
            "id": "evaluation-model",
            "introducedIn": "1.0.0",
            "label": "Evaluation model",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "bid-evaluation-award",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "UBL awarding criteria seed the model; evaluator aggregation, conflict rules, missing-score handling and the model version remain GroundWorks data.",
                "path": "cac:TenderingTerms/cac:AwardingTerms/cac:AwardingCriterion",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Model version is the string component carried within Award scenario Evaluation model; its classification and authority inherit from the owning field contract.",
                    "id": "model-version",
                    "label": "Model version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "evaluation-model",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Criteria is the object component carried within Award scenario Evaluation model; its classification and authority inherit from the owning field contract.",
                    "id": "criteria",
                    "label": "Criteria",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "evaluation-model",
                      "kind": "inherited-field"
                    },
                    "type": "object",
                    "valueSchema": {
                      "mode": "inline",
                      "schema": {
                        "additionalProperties": false,
                        "container": "object-list",
                        "properties": [
                          {
                            "classification": "restricted",
                            "definition": "Criterion ID is the string component carried within Criteria; its classification and authority inherit from the owning field contract.",
                            "id": "criterion-id",
                            "label": "Criterion ID",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "evaluation-model",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Label is the string component carried within Criteria; its classification and authority inherit from the owning field contract.",
                            "id": "label",
                            "label": "Label",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "evaluation-model",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Mandatory is the boolean component carried within Criteria; its classification and authority inherit from the owning field contract.",
                            "id": "mandatory",
                            "label": "Mandatory",
                            "nullable": false,
                            "required": true,
                            "sourceAuthority": {
                              "id": "evaluation-model",
                              "kind": "inherited-field"
                            },
                            "type": "boolean"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Weight is the decimal component carried within Criteria; its classification and authority inherit from the owning field contract.",
                            "id": "weight",
                            "label": "Weight",
                            "nullable": true,
                            "required": false,
                            "sourceAuthority": {
                              "id": "evaluation-model",
                              "kind": "inherited-field"
                            },
                            "type": "decimal"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Scoring method is the string component carried within Criteria; its classification and authority inherit from the owning field contract.",
                            "id": "scoring-method",
                            "label": "Scoring method",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "evaluation-model",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Evaluator role codes is the set carried within Criteria; its owning field governs allowed values and interpretation.",
                            "id": "evaluator-role-codes",
                            "label": "Evaluator role codes",
                            "listSemantics": "set",
                            "nullable": true,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": false,
                            "sourceAuthority": {
                              "id": "evaluation-model",
                              "kind": "inherited-field"
                            },
                            "type": "string-list"
                          }
                        ],
                        "uniqueBy": [
                          "criterion-id"
                        ]
                      },
                      "schemaVersion": "1.0.0"
                    }
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evaluator aggregation is the string component carried within Award scenario Evaluation model; its classification and authority inherit from the owning field contract.",
                    "id": "evaluator-aggregation",
                    "label": "Evaluator aggregation",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "evaluation-model",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Conflict rule codes is the set carried within Award scenario Evaluation model; its owning field governs allowed values and interpretation.",
                    "id": "conflict-rule-codes",
                    "label": "Conflict rule codes",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "evaluation-model",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Missing score rule is the string component carried within Award scenario Evaluation model; its classification and authority inherit from the owning field contract.",
                    "id": "missing-score-rule",
                    "label": "Missing score rule",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "evaluation-model",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Score scale is the string component carried within Award scenario Evaluation model; its classification and authority inherit from the owning field contract.",
                    "id": "score-scale",
                    "label": "Score scale",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "evaluation-model",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Line-, lot- and supplier-level commercial, qualitative, risk and eligibility facts with transformation provenance.",
            "exchangeScope": "mapped",
            "id": "normalised-results",
            "introducedIn": "1.0.0",
            "label": "Normalised results",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "bid-evaluation-award",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "tender",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:TenderedProject/cac:ProcurementProjectLot|cac:TenderedProject/cac:LegalMonetaryTotal",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Result ID is the uuid component carried within Award scenario Normalised results; its classification and authority inherit from the owning field contract.",
                    "id": "result-id",
                    "label": "Result ID",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "normalised-results",
                      "kind": "inherited-field"
                    },
                    "type": "uuid"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Bid evidence item ID links this structured value to the governed evidence-item record within Award scenario Normalised results.",
                    "id": "bid-evidence-item-id",
                    "label": "Bid evidence item ID",
                    "nullable": false,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the bid evidence item ID in normalised results to the referenced evidence item via its canonical evidence item ID.",
                      "id": "award-scenario-normalised-results-bid-evidence-item-id",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "normalised-results",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Lot ID is the string component carried within Award scenario Normalised results; its classification and authority inherit from the owning field contract.",
                    "id": "lot-id",
                    "label": "Lot ID",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "normalised-results",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Line ID is the string component carried within Award scenario Normalised results; its classification and authority inherit from the owning field contract.",
                    "id": "line-id",
                    "label": "Line ID",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "normalised-results",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Supplier party ID links this structured value to the governed party record within Award scenario Normalised results.",
                    "id": "supplier-party-id",
                    "label": "Supplier party ID",
                    "nullable": false,
                    "referenceEntityId": "party",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the supplier party ID in normalised results to the referenced party via its canonical party ID.",
                      "id": "award-scenario-normalised-results-supplier-party-id",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "party-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "normalised-results",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Commercial value is the money component carried within Award scenario Normalised results; its classification and authority inherit from the owning field contract.",
                    "id": "commercial-value",
                    "label": "Commercial value",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "normalised-results",
                      "kind": "inherited-field"
                    },
                    "type": "money",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "money-value",
                      "schemaVersion": "2.0.0"
                    }
                  },
                  {
                    "classification": "restricted",
                    "definition": "Qualitative score is the decimal component carried within Award scenario Normalised results; its classification and authority inherit from the owning field contract.",
                    "id": "qualitative-score",
                    "label": "Qualitative score",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "normalised-results",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Risk score is the decimal component carried within Award scenario Normalised results; its classification and authority inherit from the owning field contract.",
                    "id": "risk-score",
                    "label": "Risk score",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "normalised-results",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Eligible is the boolean component carried within Award scenario Normalised results; its classification and authority inherit from the owning field contract.",
                    "id": "eligible",
                    "label": "Eligible",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "normalised-results",
                      "kind": "inherited-field"
                    },
                    "type": "boolean"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Transformation provenance is the set carried within Award scenario Normalised results; its owning field governs allowed values and interpretation.",
                    "id": "transformation-provenance",
                    "label": "Transformation provenance",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "normalised-results",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  }
                ],
                "uniqueBy": [
                  "result-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Typed business, capacity, risk, concentration, lot and award constraints used by the optimizer.",
            "exchangeScope": "internal",
            "id": "constraint-set",
            "introducedIn": "1.0.0",
            "label": "Constraint set",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "bid-evaluation-award",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Constraint ID is the string component carried within Award scenario Constraint set; its classification and authority inherit from the owning field contract.",
                    "id": "constraint-id",
                    "label": "Constraint ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "constraint-set",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Constraint type records the governed state or type within Award scenario Constraint set without treating absence, unknown and zero as equivalent.",
                    "id": "constraint-type",
                    "label": "Constraint type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "constraint-set",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Scope ID is the string component carried within Award scenario Constraint set; its classification and authority inherit from the owning field contract.",
                    "id": "scope-id",
                    "label": "Scope ID",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "constraint-set",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Operator is the string component carried within Award scenario Constraint set; its classification and authority inherit from the owning field contract.",
                    "id": "operator",
                    "label": "Operator",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "constraint-set",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Value expression is the string component carried within Award scenario Constraint set; its classification and authority inherit from the owning field contract.",
                    "id": "value-expression",
                    "label": "Value expression",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "constraint-set",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Hard constraint is the boolean component carried within Award scenario Constraint set; its classification and authority inherit from the owning field contract.",
                    "id": "hard-constraint",
                    "label": "Hard constraint",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "constraint-set",
                      "kind": "inherited-field"
                    },
                    "type": "boolean"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Rationale is the string component carried within Award scenario Constraint set; its classification and authority inherit from the owning field contract.",
                    "id": "rationale",
                    "label": "Rationale",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "constraint-set",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Source evidence item ids links this structured value to governed evidence items through evidence-item-id within Award scenario Constraint set.",
                    "id": "source-evidence-item-ids",
                    "label": "Source evidence item ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links source evidence item ids to governed evidence items through the canonical evidence-item-id field.",
                      "id": "award-scenario-constraint-set-source-evidence-item-ids",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "constraint-set",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  }
                ],
                "uniqueBy": [
                  "constraint-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Proposed award recipients under this scenario; this field never denotes a committed award.",
            "exchangeScope": "mapped",
            "id": "recommended-party-ids",
            "introducedIn": "1.0.0",
            "label": "Recommended party IDs",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "party",
            "required": true,
            "sourceAuthority": {
              "id": "bid-evaluation-award",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "awarded-notification",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:TenderResult/cac:WinningParty/cac:Party/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "restricted",
            "definition": "Proposed lot, line, quantity, value and party allocation with feasibility proof.",
            "exchangeScope": "mapped",
            "id": "allocation",
            "introducedIn": "1.0.0",
            "label": "Allocation",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "bid-evaluation-award",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "awarded-notification",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:TenderResult",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Allocation line ID is the uuid component carried within Award scenario Allocation; its classification and authority inherit from the owning field contract.",
                    "id": "allocation-line-id",
                    "label": "Allocation line ID",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "allocation",
                      "kind": "inherited-field"
                    },
                    "type": "uuid"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Lot ID is the string component carried within Award scenario Allocation; its classification and authority inherit from the owning field contract.",
                    "id": "lot-id",
                    "label": "Lot ID",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "allocation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Line ID is the string component carried within Award scenario Allocation; its classification and authority inherit from the owning field contract.",
                    "id": "line-id",
                    "label": "Line ID",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "allocation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Allocated quantity is the quantity component carried within Award scenario Allocation; its classification and authority inherit from the owning field contract.",
                    "id": "allocated-quantity",
                    "label": "Allocated quantity",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "allocation",
                      "kind": "inherited-field"
                    },
                    "type": "quantity",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "quantity-value",
                      "schemaVersion": "1.0.0"
                    }
                  },
                  {
                    "classification": "restricted",
                    "definition": "Allocated value is the money component carried within Award scenario Allocation; its classification and authority inherit from the owning field contract.",
                    "id": "allocated-value",
                    "label": "Allocated value",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "allocation",
                      "kind": "inherited-field"
                    },
                    "type": "money",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "money-value",
                      "schemaVersion": "2.0.0"
                    }
                  },
                  {
                    "classification": "restricted",
                    "definition": "Party ID links this structured value to the governed party record within Award scenario Allocation.",
                    "id": "party-id",
                    "label": "Party ID",
                    "nullable": false,
                    "referenceEntityId": "party",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the party ID in allocation to the referenced party via its canonical party ID.",
                      "id": "award-scenario-allocation-party-id",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "party-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "allocation",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Feasible is the boolean component carried within Award scenario Allocation; its classification and authority inherit from the owning field contract.",
                    "id": "feasible",
                    "label": "Feasible",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "allocation",
                      "kind": "inherited-field"
                    },
                    "type": "boolean"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Feasibility evidence is the set carried within Award scenario Allocation; its owning field governs allowed values and interpretation.",
                    "id": "feasibility-evidence",
                    "label": "Feasibility evidence",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "allocation",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  }
                ],
                "uniqueBy": [
                  "allocation-line-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Changes in recommendation under declared price, score, risk, volume and constraint perturbations.",
            "exchangeScope": "internal",
            "id": "sensitivity-analysis",
            "introducedIn": "1.0.0",
            "label": "Sensitivity analysis",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "bid-evaluation-award",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Analysis ID is the uuid component carried within Award scenario Sensitivity analysis; its classification and authority inherit from the owning field contract.",
                    "id": "analysis-id",
                    "label": "Analysis ID",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "sensitivity-analysis",
                      "kind": "inherited-field"
                    },
                    "type": "uuid"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Perturbation type records the governed state or type within Award scenario Sensitivity analysis without treating absence, unknown and zero as equivalent.",
                    "id": "perturbation-type",
                    "label": "Perturbation type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "sensitivity-analysis",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Parameter ID is the string component carried within Award scenario Sensitivity analysis; its classification and authority inherit from the owning field contract.",
                    "id": "parameter-id",
                    "label": "Parameter ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "sensitivity-analysis",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Baseline value is the decimal component carried within Award scenario Sensitivity analysis; its classification and authority inherit from the owning field contract.",
                    "id": "baseline-value",
                    "label": "Baseline value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "sensitivity-analysis",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Perturbed value is the decimal component carried within Award scenario Sensitivity analysis; its classification and authority inherit from the owning field contract.",
                    "id": "perturbed-value",
                    "label": "Perturbed value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "sensitivity-analysis",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Recommendation changed is the boolean component carried within Award scenario Sensitivity analysis; its classification and authority inherit from the owning field contract.",
                    "id": "recommendation-changed",
                    "label": "Recommendation changed",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "sensitivity-analysis",
                      "kind": "inherited-field"
                    },
                    "type": "boolean"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Affected party ids links this structured value to governed parties through party-id within Award scenario Sensitivity analysis.",
                    "id": "affected-party-ids",
                    "label": "Affected party ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "referenceEntityId": "party",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links affected party ids to governed parties through the canonical party-id field.",
                      "id": "award-scenario-sensitivity-analysis-affected-party-ids",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "party-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "sensitivity-analysis",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Affected allocation line ids is the set carried within Award scenario Sensitivity analysis; its owning field governs allowed values and interpretation.",
                    "id": "affected-allocation-line-ids",
                    "label": "Affected allocation line ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "sensitivity-analysis",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Rationale is the string component carried within Award scenario Sensitivity analysis; its classification and authority inherit from the owning field contract.",
                    "id": "rationale",
                    "label": "Rationale",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "sensitivity-analysis",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ],
                "uniqueBy": [
                  "analysis-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Authority decision that committed an award based on this exact scenario, null before commitment.",
            "exchangeScope": "mapped",
            "id": "committed-decision-id",
            "introducedIn": "1.0.0",
            "label": "Committed decision ID",
            "nullable": true,
            "referenceEntityId": "decision",
            "required": false,
            "sourceAuthority": {
              "id": "bid-evaluation-award",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "awarded-notification",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Timestamp at which source bids and evaluation versions were frozen for this scenario.",
            "exchangeScope": "mapped",
            "format": "date-time",
            "id": "evaluated-at",
            "introducedIn": "1.0.0",
            "label": "Evaluated at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "bid-evaluation-award",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "awarded-notification",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:IssueDate|cbc:IssueTime",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Shared governed decision record that carries authority, rationale and evidence for this domain decision.",
            "exchangeScope": "unmapped",
            "id": "governance-decision-id",
            "introducedIn": "4.0.0",
            "label": "Governance decision ID",
            "nullable": true,
            "referenceEntityId": "decision",
            "required": false,
            "sourceAuthority": {
              "id": "bid-evaluation-award",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Authority envelope governing proposals, approvals and commitments for this record.",
            "exchangeScope": "unmapped",
            "id": "governance-authority-envelope-id",
            "introducedIn": "4.0.0",
            "label": "Governance authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "bid-evaluation-award",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "award-scenario",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "sourcing-event-id",
              "scenario-number"
            ],
            "id": "award-scenario-by-sourcing-event-id-and-scenario-number",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "lifecycle-state"
            ],
            "id": "award-scenario-by-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "recommended-party-ids"
            ],
            "id": "award-scenario-by-recommended-party-ids",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "committed-decision-id"
            ],
            "id": "award-scenario-by-committed-decision-id",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "decision",
        "label": "Award scenario",
        "lifecycle": [
          "normalising",
          "evaluated",
          "proposed",
          "authorised",
          "committed",
          "rejected",
          "superseded",
          "invalidated"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "bid-evaluation-award",
        "owningDomainWorkblockId": "sourcing-negotiation",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Award scenarios",
        "primaryKey": "award-scenario-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Associates the scenario with the exact sourcing event.",
            "id": "award-scenario-references-sourcing-event-record-award-event",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "award-scenario-references-sourcing-event-record-award-event",
            "required": true,
            "sourceFieldId": "sourcing-event-id",
            "targetEntityId": "sourcing-event-record",
            "targetFieldId": "sourcing-event-record-id"
          },
          {
            "cardinality": "one-to-one",
            "definition": "Links a recommendation to the separate authority event that committed it.",
            "id": "award-scenario-references-decision-award-decision",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "award-scenario-references-decision-award-decision",
            "required": false,
            "sourceFieldId": "committed-decision-id",
            "targetEntityId": "decision",
            "targetFieldId": "decision-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the scenario to the immutable sealed bid evidence frozen for evaluation.",
            "id": "award-scenario-references-evidence-item-award-bid-sources",
            "introducedIn": "2.0.0",
            "predicate": "references",
            "qualifiedId": "award-scenario-references-evidence-item-award-bid-sources",
            "required": true,
            "sourceFieldId": "bid-source-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the non-committed scenario recommendation to its proposed award parties.",
            "id": "award-scenario-references-party-award-recommended-parties",
            "introducedIn": "2.0.0",
            "predicate": "references",
            "qualifiedId": "award-scenario-references-party-award-recommended-parties",
            "required": true,
            "sourceFieldId": "recommended-party-ids",
            "targetEntityId": "party",
            "targetFieldId": "party-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Shared governed decision for this domain outcome.",
            "id": "award-scenario-governed-by-decision-award-scenario-governance-decision",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "award-scenario-governed-by-decision-award-scenario-governance-decision",
            "required": false,
            "sourceFieldId": "governance-decision-id",
            "targetEntityId": "decision",
            "targetFieldId": "decision-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authority envelope governing this record.",
            "id": "award-scenario-governed-by-authority-envelope-award-scenario-governance-authority",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "award-scenario-governed-by-authority-envelope-award-scenario-governance-authority",
            "required": false,
            "sourceFieldId": "governance-authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "bid evaluation",
          "award recommendation",
          "award scenario",
          "supplier score",
          "allocation optimization"
        ],
        "sourceSystemRoleIds": [
          "collaboration-channel",
          "system-of-record",
          "analytical-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "collaboration-channel",
          "system-of-record",
          "execution-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "bid-evaluation-award"
        ],
        "definition": "A governed negotiation objective, issue model, authority boundary, counterparty exchange and agreement-in-principle trail, distinct from a signed or awarded commitment.",
        "domainWorkblockIds": [
          "sourcing-negotiation"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable canonical identifier for the negotiation trail.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "negotiation-session-id",
            "introducedIn": "1.0.0",
            "label": "Negotiation session ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "negotiation-copilot",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "restricted",
            "definition": "Sourcing opportunity, event or award scenario that authorised negotiation.",
            "exchangeScope": "mapped",
            "id": "source-record-id",
            "introducedIn": "1.0.0",
            "label": "Source record ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "negotiation-copilot",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "tender",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID|cbc:ContractFolderID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Canonical external party participating in this session.",
            "exchangeScope": "mapped",
            "id": "counterparty-id",
            "introducedIn": "1.0.0",
            "label": "Counterparty ID",
            "nullable": false,
            "referenceEntityId": "party",
            "required": true,
            "sourceAuthority": {
              "id": "negotiation-copilot",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "tender",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:TendererParty/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Versioned targets, priorities, reservation values, trade variables, alternatives and non-financial objectives.",
            "exchangeScope": "internal",
            "id": "objective-model",
            "introducedIn": "1.0.0",
            "label": "Objective model",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "negotiation-copilot",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Model version is the string component carried within Negotiation session Objective model; its classification and authority inherit from the owning field contract.",
                    "id": "model-version",
                    "label": "Model version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "objective-model",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Targets is the object component carried within Negotiation session Objective model; its classification and authority inherit from the owning field contract.",
                    "id": "targets",
                    "label": "Targets",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "objective-model",
                      "kind": "inherited-field"
                    },
                    "type": "object",
                    "valueSchema": {
                      "mode": "inline",
                      "schema": {
                        "additionalProperties": false,
                        "container": "object-list",
                        "properties": [
                          {
                            "classification": "restricted",
                            "definition": "Objective ID is the string component carried within Targets; its classification and authority inherit from the owning field contract.",
                            "id": "objective-id",
                            "label": "Objective ID",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "objective-model",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Issue ID is the string component carried within Targets; its classification and authority inherit from the owning field contract.",
                            "id": "issue-id",
                            "label": "Issue ID",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "objective-model",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Target value is the string component carried within Targets; its classification and authority inherit from the owning field contract.",
                            "id": "target-value",
                            "label": "Target value",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "objective-model",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Reservation value is the string component carried within Targets; its classification and authority inherit from the owning field contract.",
                            "id": "reservation-value",
                            "label": "Reservation value",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "objective-model",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Priority is the integer component carried within Targets; its classification and authority inherit from the owning field contract.",
                            "id": "priority",
                            "label": "Priority",
                            "nullable": false,
                            "required": true,
                            "sourceAuthority": {
                              "id": "objective-model",
                              "kind": "inherited-field"
                            },
                            "type": "integer"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Non financial is the boolean component carried within Targets; its classification and authority inherit from the owning field contract.",
                            "id": "non-financial",
                            "label": "Non financial",
                            "nullable": false,
                            "required": true,
                            "sourceAuthority": {
                              "id": "objective-model",
                              "kind": "inherited-field"
                            },
                            "type": "boolean"
                          }
                        ],
                        "uniqueBy": [
                          "objective-id"
                        ]
                      },
                      "schemaVersion": "1.0.0"
                    }
                  },
                  {
                    "classification": "restricted",
                    "definition": "Alternative descriptions is the set carried within Negotiation session Objective model; its owning field governs allowed values and interpretation.",
                    "id": "alternative-descriptions",
                    "label": "Alternative descriptions",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "objective-model",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Trade variable ids is the set carried within Negotiation session Objective model; its owning field governs allowed values and interpretation.",
                    "id": "trade-variable-ids",
                    "label": "Trade variable ids",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "objective-model",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence as of is the timestamp component carried within Negotiation session Objective model; its classification and authority inherit from the owning field contract.",
                    "id": "evidence-as-of",
                    "label": "Evidence as of",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "objective-model",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence item ids links this structured value to governed evidence items through evidence-item-id within Negotiation session Objective model.",
                    "id": "evidence-item-ids",
                    "label": "Evidence item ids",
                    "listSemantics": "set",
                    "nullable": false,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links evidence item ids to governed evidence items through the canonical evidence-item-id field.",
                      "id": "negotiation-session-objective-model-evidence-item-ids",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "objective-model",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Current positions, offers, confidence, dependencies and open issues for each negotiation variable.",
            "exchangeScope": "internal",
            "id": "issue-state",
            "introducedIn": "1.0.0",
            "label": "Issue state",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "negotiation-copilot",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Issue ID is the string component carried within Negotiation session Issue state; its classification and authority inherit from the owning field contract.",
                    "id": "issue-id",
                    "label": "Issue ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "issue-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Issue label is the string component carried within Negotiation session Issue state; its classification and authority inherit from the owning field contract.",
                    "id": "issue-label",
                    "label": "Issue label",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "issue-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Current position is the string component carried within Negotiation session Issue state; its classification and authority inherit from the owning field contract.",
                    "id": "current-position",
                    "label": "Current position",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "issue-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Counterparty position is the string component carried within Negotiation session Issue state; its classification and authority inherit from the owning field contract.",
                    "id": "counterparty-position",
                    "label": "Counterparty position",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "issue-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Latest offer is the string component carried within Negotiation session Issue state; its classification and authority inherit from the owning field contract.",
                    "id": "latest-offer",
                    "label": "Latest offer",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "issue-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Confidence is the decimal component carried within Negotiation session Issue state; its classification and authority inherit from the owning field contract.",
                    "id": "confidence",
                    "label": "Confidence",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "issue-state",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Dependency issue ids is the set carried within Negotiation session Issue state; its owning field governs allowed values and interpretation.",
                    "id": "dependency-issue-ids",
                    "label": "Dependency issue ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "issue-state",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Status records the governed state or type within Negotiation session Issue state without treating absence, unknown and zero as equivalent.",
                    "id": "status",
                    "label": "Status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "issue-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Updated at is the timestamp component carried within Negotiation session Issue state; its classification and authority inherit from the owning field contract.",
                    "id": "updated-at",
                    "label": "Updated at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "issue-state",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence item ids links this structured value to governed evidence items through evidence-item-id within Negotiation session Issue state.",
                    "id": "evidence-item-ids",
                    "label": "Evidence item ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links evidence item ids to governed evidence items through the canonical evidence-item-id field.",
                      "id": "negotiation-session-issue-state-evidence-item-ids",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "issue-state",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  }
                ],
                "uniqueBy": [
                  "issue-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Exact grant defining allowed proposals, communication channels, concessions and commitment restrictions.",
            "exchangeScope": "internal",
            "id": "authority-envelope-id",
            "introducedIn": "1.0.0",
            "label": "Authority envelope ID",
            "nullable": false,
            "referenceEntityId": "authority-envelope",
            "required": true,
            "sourceAuthority": {
              "id": "negotiation-copilot",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Immutable inbound and outbound communication artifacts with hashes, actors and delivery status.",
            "exchangeScope": "mapped",
            "id": "exchange-artifact-ids",
            "introducedIn": "1.0.0",
            "label": "Exchange artifact references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "negotiation-copilot",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "tender",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:DocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "restricted",
            "definition": "Latest machine- or person-prepared package and expiry; it is not a committed commercial outcome.",
            "exchangeScope": "mapped",
            "id": "current-proposal",
            "introducedIn": "1.0.0",
            "label": "Current proposal",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "negotiation-copilot",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "tender",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:TenderedProject",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Proposal ID is the uuid component carried within Negotiation session Current proposal; its classification and authority inherit from the owning field contract.",
                    "id": "proposal-id",
                    "label": "Proposal ID",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "current-proposal",
                      "kind": "inherited-field"
                    },
                    "type": "uuid"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Proposal version is the integer component carried within Negotiation session Current proposal; its classification and authority inherit from the owning field contract.",
                    "id": "proposal-version",
                    "label": "Proposal version",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "current-proposal",
                      "kind": "inherited-field"
                    },
                    "type": "integer"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Prepared by person ID links this structured value to the governed person record within Negotiation session Current proposal.",
                    "id": "prepared-by-person-id",
                    "label": "Prepared by person ID",
                    "nullable": true,
                    "referenceEntityId": "person",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the prepared by person ID in current proposal to the referenced person via its canonical person ID.",
                      "id": "negotiation-session-current-proposal-prepared-by-person-id",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "person-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "current-proposal",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Prepared by agent ID is the string component carried within Negotiation session Current proposal; its classification and authority inherit from the owning field contract.",
                    "id": "prepared-by-agent-id",
                    "label": "Prepared by agent ID",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "current-proposal",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Package summary is the string component carried within Negotiation session Current proposal; its classification and authority inherit from the owning field contract.",
                    "id": "package-summary",
                    "label": "Package summary",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "current-proposal",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Issue offers is the object component carried within Negotiation session Current proposal; its classification and authority inherit from the owning field contract.",
                    "id": "issue-offers",
                    "label": "Issue offers",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "current-proposal",
                      "kind": "inherited-field"
                    },
                    "type": "object",
                    "valueSchema": {
                      "mode": "inline",
                      "schema": {
                        "additionalProperties": false,
                        "container": "object-list",
                        "properties": [
                          {
                            "classification": "restricted",
                            "definition": "Issue ID is the string component carried within Issue offers; its classification and authority inherit from the owning field contract.",
                            "id": "issue-id",
                            "label": "Issue ID",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "current-proposal",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Proposed value is the string component carried within Issue offers; its classification and authority inherit from the owning field contract.",
                            "id": "proposed-value",
                            "label": "Proposed value",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "current-proposal",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Rationale is the string component carried within Issue offers; its classification and authority inherit from the owning field contract.",
                            "id": "rationale",
                            "label": "Rationale",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "current-proposal",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Concession is the boolean component carried within Issue offers; its classification and authority inherit from the owning field contract.",
                            "id": "concession",
                            "label": "Concession",
                            "nullable": false,
                            "required": true,
                            "sourceAuthority": {
                              "id": "current-proposal",
                              "kind": "inherited-field"
                            },
                            "type": "boolean"
                          }
                        ],
                        "uniqueBy": [
                          "issue-id"
                        ]
                      },
                      "schemaVersion": "1.0.0"
                    }
                  },
                  {
                    "classification": "restricted",
                    "definition": "Expires at is the timestamp component carried within Negotiation session Current proposal; its classification and authority inherit from the owning field contract.",
                    "id": "expires-at",
                    "label": "Expires at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "current-proposal",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence item ids links this structured value to governed evidence items through evidence-item-id within Negotiation session Current proposal.",
                    "id": "evidence-item-ids",
                    "label": "Evidence item ids",
                    "listSemantics": "set",
                    "nullable": false,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links evidence item ids to governed evidence items through the canonical evidence-item-id field.",
                      "id": "negotiation-session-current-proposal-evidence-item-ids",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "current-proposal",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Non-binding summary of aligned terms, remaining conditions and evidence before a separate award, contract or order commitment.",
            "exchangeScope": "mapped",
            "id": "agreement-in-principle",
            "introducedIn": "1.0.0",
            "label": "Agreement in principle",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "negotiation-copilot",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "tender",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:Note",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Agreement ID is the uuid component carried within Negotiation session Agreement in principle; its classification and authority inherit from the owning field contract.",
                    "id": "agreement-id",
                    "label": "Agreement ID",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "agreement-in-principle",
                      "kind": "inherited-field"
                    },
                    "type": "uuid"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Summary is the string component carried within Negotiation session Agreement in principle; its classification and authority inherit from the owning field contract.",
                    "id": "summary",
                    "label": "Summary",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "agreement-in-principle",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Aligned terms is the object component carried within Negotiation session Agreement in principle; its classification and authority inherit from the owning field contract.",
                    "id": "aligned-terms",
                    "label": "Aligned terms",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "agreement-in-principle",
                      "kind": "inherited-field"
                    },
                    "type": "object",
                    "valueSchema": {
                      "mode": "inline",
                      "schema": {
                        "additionalProperties": false,
                        "container": "object-list",
                        "properties": [
                          {
                            "classification": "restricted",
                            "definition": "Term ID is the string component carried within Aligned terms; its classification and authority inherit from the owning field contract.",
                            "id": "term-id",
                            "label": "Term ID",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "agreement-in-principle",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Term description is the string component carried within Aligned terms; its classification and authority inherit from the owning field contract.",
                            "id": "term-description",
                            "label": "Term description",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "agreement-in-principle",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Evidence item ids links this structured value to governed evidence items through evidence-item-id within Aligned terms.",
                            "id": "evidence-item-ids",
                            "label": "Evidence item ids",
                            "listSemantics": "set",
                            "nullable": false,
                            "referenceEntityId": "evidence-item",
                            "relationship": {
                              "cardinality": "many-to-many",
                              "definition": "Links evidence item ids to governed evidence items through the canonical evidence-item-id field.",
                              "id": "negotiation-session-agreement-in-principle-aligned-terms-evidence-item-ids",
                              "introducedIn": "2.0.0",
                              "required": true,
                              "targetFieldId": "evidence-item-id"
                            },
                            "required": true,
                            "sourceAuthority": {
                              "id": "agreement-in-principle",
                              "kind": "inherited-field"
                            },
                            "type": "reference-list"
                          }
                        ],
                        "uniqueBy": [
                          "term-id"
                        ]
                      },
                      "schemaVersion": "1.0.0"
                    }
                  },
                  {
                    "classification": "restricted",
                    "definition": "Remaining condition descriptions is the set carried within Negotiation session Agreement in principle; its owning field governs allowed values and interpretation.",
                    "id": "remaining-condition-descriptions",
                    "label": "Remaining condition descriptions",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "agreement-in-principle",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence item ids links this structured value to governed evidence items through evidence-item-id within Negotiation session Agreement in principle.",
                    "id": "evidence-item-ids",
                    "label": "Evidence item ids",
                    "listSemantics": "set",
                    "nullable": false,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links evidence item ids to governed evidence items through the canonical evidence-item-id field.",
                      "id": "negotiation-session-agreement-in-principle-evidence-item-ids",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "agreement-in-principle",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Recorded at is the timestamp component carried within Negotiation session Agreement in principle; its classification and authority inherit from the owning field contract.",
                    "id": "recorded-at",
                    "label": "Recorded at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "agreement-in-principle",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Confirmed by party ids links this structured value to governed parties through party-id within Negotiation session Agreement in principle.",
                    "id": "confirmed-by-party-ids",
                    "label": "Confirmed by party ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "referenceEntityId": "party",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links confirmed by party ids to governed parties through the canonical party-id field.",
                      "id": "negotiation-session-agreement-in-principle-confirmed-by-party-ids",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "party-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "agreement-in-principle",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Non binding is the boolean component carried within Negotiation session Agreement in principle; its classification and authority inherit from the owning field contract.",
                    "id": "non-binding",
                    "label": "Non binding",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "agreement-in-principle",
                      "kind": "inherited-field"
                    },
                    "type": "boolean"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Timestamp by which the next authorised communication or escalation is due.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "next-exchange-due-at",
            "introducedIn": "1.0.0",
            "label": "Next exchange due at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "negotiation-copilot",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Timestamp of the latest reconciled session mutation.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "updated-at",
            "introducedIn": "1.0.0",
            "label": "Updated at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "negotiation-copilot",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "negotiation-session",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "source-record-id"
            ],
            "id": "negotiation-session-by-source-record-id",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "counterparty-id",
              "lifecycle-state"
            ],
            "id": "negotiation-session-by-counterparty-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "authority-envelope-id"
            ],
            "id": "negotiation-session-by-authority-envelope-id",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "next-exchange-due-at"
            ],
            "id": "negotiation-session-by-next-exchange-due-at",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "case",
        "label": "Negotiation session",
        "lifecycle": [
          "preparing",
          "authorised",
          "active",
          "paused",
          "agreement-in-principle",
          "failed",
          "handed-off",
          "closed"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "negotiation-copilot",
        "owningDomainWorkblockId": "sourcing-negotiation",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Negotiation sessions",
        "primaryKey": "negotiation-session-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the session to its canonical external counterparty.",
            "id": "negotiation-session-belongs-to-party-negotiation-counterparty",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "negotiation-session-belongs-to-party-negotiation-counterparty",
            "required": true,
            "sourceFieldId": "counterparty-id",
            "targetEntityId": "party",
            "targetFieldId": "party-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Binds all agent actions to the exact negotiation mandate.",
            "id": "negotiation-session-governed-by-authority-envelope-negotiation-authority",
            "introducedIn": "1.0.0",
            "predicate": "governed-by",
            "qualifiedId": "negotiation-session-governed-by-authority-envelope-negotiation-authority",
            "required": true,
            "sourceFieldId": "authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the session to immutable inbound and outbound exchange evidence.",
            "id": "negotiation-session-evidenced-by-evidence-item-negotiation-exchange-artifacts",
            "introducedIn": "2.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "negotiation-session-evidenced-by-evidence-item-negotiation-exchange-artifacts",
            "required": true,
            "sourceFieldId": "exchange-artifact-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "negotiation",
          "counteroffer",
          "negotiation plan",
          "agreement in principle",
          "commercial mandate"
        ],
        "sourceSystemRoleIds": [
          "collaboration-channel",
          "system-of-record",
          "evidence-source"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "collaboration-channel",
          "system-of-record"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "bid-evaluation-award"
        ],
        "definition": "A policy-bounded, end-to-end sourcing case for eligible low-complexity demand, covering supplier set, quote request, evaluation, negotiation, commitment and downstream reconciliation.",
        "domainWorkblockIds": [
          "sourcing-negotiation"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable identifier for the policy-bounded tactical sourcing case and recovery trail.",
            "exchangeScope": "mapped",
            "format": "uuid",
            "id": "tactical-sourcing-case-id",
            "introducedIn": "1.0.0",
            "label": "Tactical case ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "tactical-sourcing-autonomy",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Qualified demand case authorising tactical sourcing.",
            "exchangeScope": "mapped",
            "id": "demand-case-id",
            "introducedIn": "1.0.0",
            "label": "Demand case ID",
            "nullable": false,
            "referenceEntityId": "demand-case",
            "required": true,
            "sourceAuthority": {
              "id": "tactical-sourcing-autonomy",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ContractFolderID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Canonical category used for eligibility and supplier selection.",
            "exchangeScope": "mapped",
            "id": "category-id",
            "introducedIn": "1.0.0",
            "label": "Category ID",
            "nullable": false,
            "referenceEntityId": "category",
            "required": true,
            "sourceAuthority": {
              "id": "tactical-sourcing-autonomy",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ProcurementProject/cac:MainCommodityClassification/cbc:ItemClassificationCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Versioned rule results, facts and reasons proving the case is inside or outside tactical autonomy.",
            "exchangeScope": "internal",
            "id": "eligibility-result",
            "introducedIn": "1.0.0",
            "label": "Eligibility result",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "tactical-sourcing-autonomy",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Evaluation ID is the uuid component carried within Tactical sourcing case Eligibility result; its classification and authority inherit from the owning field contract.",
                    "id": "evaluation-id",
                    "label": "Evaluation ID",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "eligibility-result",
                      "kind": "inherited-field"
                    },
                    "type": "uuid"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Rule release ids is the set carried within Tactical sourcing case Eligibility result; its owning field governs allowed values and interpretation.",
                    "id": "rule-release-ids",
                    "label": "Rule release ids",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "eligibility-result",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Fact evidence item ids links this structured value to governed evidence items through evidence-item-id within Tactical sourcing case Eligibility result.",
                    "id": "fact-evidence-item-ids",
                    "label": "Fact evidence item ids",
                    "listSemantics": "set",
                    "nullable": false,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links fact evidence item ids to governed evidence items through the canonical evidence-item-id field.",
                      "id": "tactical-sourcing-case-eligibility-result-fact-evidence-item-ids",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "eligibility-result",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Eligible is the boolean component carried within Tactical sourcing case Eligibility result; its classification and authority inherit from the owning field contract.",
                    "id": "eligible",
                    "label": "Eligible",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "eligibility-result",
                      "kind": "inherited-field"
                    },
                    "type": "boolean"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Reason codes is the set carried within Tactical sourcing case Eligibility result; its owning field governs allowed values and interpretation.",
                    "id": "reason-codes",
                    "label": "Reason codes",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "eligibility-result",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evaluated at is the timestamp component carried within Tactical sourcing case Eligibility result; its classification and authority inherit from the owning field contract.",
                    "id": "evaluated-at",
                    "label": "Evaluated at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "eligibility-result",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Expires at is the timestamp component carried within Tactical sourcing case Eligibility result; its classification and authority inherit from the owning field contract.",
                    "id": "expires-at",
                    "label": "Expires at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "eligibility-result",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Critic passed is the boolean component carried within Tactical sourcing case Eligibility result; its classification and authority inherit from the owning field contract.",
                    "id": "critic-passed",
                    "label": "Critic passed",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "eligibility-result",
                      "kind": "inherited-field"
                    },
                    "type": "boolean"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Authority envelope ID links this structured value to the governed authority-envelope record within Tactical sourcing case Eligibility result.",
                    "id": "authority-envelope-id",
                    "label": "Authority envelope ID",
                    "nullable": true,
                    "referenceEntityId": "authority-envelope",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the authority envelope ID in eligibility result to the referenced authority envelope via its canonical authority envelope ID.",
                      "id": "tactical-sourcing-case-eligibility-result-authority-envelope-id",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "authority-envelope-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "eligibility-result",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Exact grant for allowed steps, value, suppliers, tools, timing and commitment boundary.",
            "exchangeScope": "internal",
            "id": "authority-envelope-id",
            "introducedIn": "1.0.0",
            "label": "Authority envelope ID",
            "nullable": false,
            "referenceEntityId": "authority-envelope",
            "required": true,
            "sourceAuthority": {
              "id": "tactical-sourcing-autonomy",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Eligible parties selected under documented coverage, fairness and conflict rules.",
            "exchangeScope": "mapped",
            "id": "invited-party-ids",
            "introducedIn": "1.0.0",
            "label": "Invited party IDs",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "party",
            "required": true,
            "sourceAuthority": {
              "id": "tactical-sourcing-autonomy",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "UBL identifies one receiver per CallForTenders instance; the tactical invitee set is reconstructed across versioned, delivery-evidenced exchanges.",
                "path": "cac:ReceiverParty/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "restricted",
            "definition": "Immutable published request artifact and content hash.",
            "exchangeScope": "mapped",
            "id": "quote-request-artifact-id",
            "introducedIn": "1.0.0",
            "label": "Quote request artifact reference",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "tactical-sourcing-autonomy",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:AdditionalDocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Sealed quote references, normalised terms, completeness, eligibility and receipt evidence.",
            "exchangeScope": "mapped",
            "id": "response-set",
            "introducedIn": "1.0.0",
            "label": "Response set",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "tactical-sourcing-autonomy",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "tender",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID|cac:TenderedProject",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Response ID is the uuid component carried within Tactical sourcing case Response set; its classification and authority inherit from the owning field contract.",
                    "id": "response-id",
                    "label": "Response ID",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "response-set",
                      "kind": "inherited-field"
                    },
                    "type": "uuid"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Supplier party ID links this structured value to the governed party record within Tactical sourcing case Response set.",
                    "id": "supplier-party-id",
                    "label": "Supplier party ID",
                    "nullable": false,
                    "referenceEntityId": "party",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the supplier party ID in response set to the referenced party via its canonical party ID.",
                      "id": "tactical-sourcing-case-response-set-supplier-party-id",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "party-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "response-set",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Quote evidence item ID links this structured value to the governed evidence-item record within Tactical sourcing case Response set.",
                    "id": "quote-evidence-item-id",
                    "label": "Quote evidence item ID",
                    "nullable": false,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the quote evidence item ID in response set to the referenced evidence item via its canonical evidence item ID.",
                      "id": "tactical-sourcing-case-response-set-quote-evidence-item-id",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "response-set",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Received at is the timestamp component carried within Tactical sourcing case Response set; its classification and authority inherit from the owning field contract.",
                    "id": "received-at",
                    "label": "Received at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "response-set",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Content hash is the string component carried within Tactical sourcing case Response set; its classification and authority inherit from the owning field contract.",
                    "id": "content-hash",
                    "label": "Content hash",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "response-set",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Normalised terms is the object component carried within Tactical sourcing case Response set; its classification and authority inherit from the owning field contract.",
                    "id": "normalised-terms",
                    "label": "Normalised terms",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "response-set",
                      "kind": "inherited-field"
                    },
                    "type": "object",
                    "valueSchema": {
                      "mode": "inline",
                      "schema": {
                        "additionalProperties": false,
                        "container": "object",
                        "properties": [
                          {
                            "classification": "restricted",
                            "definition": "Total value is the money component carried within Normalised terms; its classification and authority inherit from the owning field contract.",
                            "id": "total-value",
                            "label": "Total value",
                            "nullable": true,
                            "required": false,
                            "sourceAuthority": {
                              "id": "response-set",
                              "kind": "inherited-field"
                            },
                            "type": "money",
                            "valueSchema": {
                              "mode": "registry",
                              "schemaId": "money-value",
                              "schemaVersion": "2.0.0"
                            }
                          },
                          {
                            "classification": "restricted",
                            "definition": "Lead time description is the string component carried within Normalised terms; its classification and authority inherit from the owning field contract.",
                            "id": "lead-time-description",
                            "label": "Lead time description",
                            "nullable": true,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": false,
                            "sourceAuthority": {
                              "id": "response-set",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Validity until is the date component carried within Normalised terms; its classification and authority inherit from the owning field contract.",
                            "id": "validity-until",
                            "label": "Validity until",
                            "nullable": true,
                            "required": false,
                            "sourceAuthority": {
                              "id": "response-set",
                              "kind": "inherited-field"
                            },
                            "type": "date"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Term descriptions is the set carried within Normalised terms; its owning field governs allowed values and interpretation.",
                            "id": "term-descriptions",
                            "label": "Term descriptions",
                            "listSemantics": "set",
                            "nullable": true,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": false,
                            "sourceAuthority": {
                              "id": "response-set",
                              "kind": "inherited-field"
                            },
                            "type": "string-list"
                          }
                        ]
                      },
                      "schemaVersion": "1.0.0"
                    }
                  },
                  {
                    "classification": "restricted",
                    "definition": "Complete is the boolean component carried within Tactical sourcing case Response set; its classification and authority inherit from the owning field contract.",
                    "id": "complete",
                    "label": "Complete",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "response-set",
                      "kind": "inherited-field"
                    },
                    "type": "boolean"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Eligible is the boolean component carried within Tactical sourcing case Response set; its classification and authority inherit from the owning field contract.",
                    "id": "eligible",
                    "label": "Eligible",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "response-set",
                      "kind": "inherited-field"
                    },
                    "type": "boolean"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Receipt status records the governed state or type within Tactical sourcing case Response set without treating absence, unknown and zero as equivalent.",
                    "id": "receipt-status",
                    "label": "Receipt status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "response-set",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ],
                "uniqueBy": [
                  "response-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Current evaluated supplier, allocation, value and rationale before commitment.",
            "exchangeScope": "mapped",
            "id": "award-proposal",
            "introducedIn": "1.0.0",
            "label": "Award proposal",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "tactical-sourcing-autonomy",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "awarded-notification",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:TenderResult",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Proposal ID is the uuid component carried within Tactical sourcing case Award proposal; its classification and authority inherit from the owning field contract.",
                    "id": "proposal-id",
                    "label": "Proposal ID",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "award-proposal",
                      "kind": "inherited-field"
                    },
                    "type": "uuid"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Recommended party ID links this structured value to the governed party record within Tactical sourcing case Award proposal.",
                    "id": "recommended-party-id",
                    "label": "Recommended party ID",
                    "nullable": false,
                    "referenceEntityId": "party",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the recommended party ID in award proposal to the referenced party via its canonical party ID.",
                      "id": "tactical-sourcing-case-award-proposal-recommended-party-id",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "party-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "award-proposal",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Allocation lines is the object component carried within Tactical sourcing case Award proposal; its classification and authority inherit from the owning field contract.",
                    "id": "allocation-lines",
                    "label": "Allocation lines",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "award-proposal",
                      "kind": "inherited-field"
                    },
                    "type": "object",
                    "valueSchema": {
                      "mode": "inline",
                      "schema": {
                        "additionalProperties": false,
                        "container": "object-list",
                        "properties": [
                          {
                            "classification": "restricted",
                            "definition": "Allocation line ID is the uuid component carried within Allocation lines; its classification and authority inherit from the owning field contract.",
                            "id": "allocation-line-id",
                            "label": "Allocation line ID",
                            "nullable": false,
                            "required": true,
                            "sourceAuthority": {
                              "id": "award-proposal",
                              "kind": "inherited-field"
                            },
                            "type": "uuid"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Line ID is the string component carried within Allocation lines; its classification and authority inherit from the owning field contract.",
                            "id": "line-id",
                            "label": "Line ID",
                            "nullable": true,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": false,
                            "sourceAuthority": {
                              "id": "award-proposal",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Quantity is the quantity component carried within Allocation lines; its classification and authority inherit from the owning field contract.",
                            "id": "quantity",
                            "label": "Quantity",
                            "nullable": true,
                            "required": false,
                            "sourceAuthority": {
                              "id": "award-proposal",
                              "kind": "inherited-field"
                            },
                            "type": "quantity",
                            "valueSchema": {
                              "mode": "registry",
                              "schemaId": "quantity-value",
                              "schemaVersion": "1.0.0"
                            }
                          },
                          {
                            "classification": "restricted",
                            "definition": "Value is the money component carried within Allocation lines; its classification and authority inherit from the owning field contract.",
                            "id": "value",
                            "label": "Value",
                            "nullable": true,
                            "required": false,
                            "sourceAuthority": {
                              "id": "award-proposal",
                              "kind": "inherited-field"
                            },
                            "type": "money",
                            "valueSchema": {
                              "mode": "registry",
                              "schemaId": "money-value",
                              "schemaVersion": "2.0.0"
                            }
                          }
                        ],
                        "uniqueBy": [
                          "allocation-line-id"
                        ]
                      },
                      "schemaVersion": "1.0.0"
                    }
                  },
                  {
                    "classification": "restricted",
                    "definition": "Total value is the money component carried within Tactical sourcing case Award proposal; its classification and authority inherit from the owning field contract.",
                    "id": "total-value",
                    "label": "Total value",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "award-proposal",
                      "kind": "inherited-field"
                    },
                    "type": "money",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "money-value",
                      "schemaVersion": "2.0.0"
                    }
                  },
                  {
                    "classification": "restricted",
                    "definition": "Rationale is the string component carried within Tactical sourcing case Award proposal; its classification and authority inherit from the owning field contract.",
                    "id": "rationale",
                    "label": "Rationale",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "award-proposal",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evaluation result ID links this structured value to governed evaluation result record through evaluation-result-id within Tactical sourcing case Award proposal.",
                    "id": "evaluation-result-id",
                    "label": "Evaluation result ID",
                    "nullable": false,
                    "referenceEntityId": "evaluation-result",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links evaluation result id to governed evaluation result record through the canonical evaluation-result-id field.",
                      "id": "tactical-sourcing-case-award-proposal-evaluation-result-id",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "evaluation-result-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "award-proposal",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Critic result ID is the string component carried within Tactical sourcing case Award proposal; its classification and authority inherit from the owning field contract.",
                    "id": "critic-result-id",
                    "label": "Critic result ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "award-proposal",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Expires at is the timestamp component carried within Tactical sourcing case Award proposal; its classification and authority inherit from the owning field contract.",
                    "id": "expires-at",
                    "label": "Expires at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "award-proposal",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Separate action-ledger record for an authorised award, order or other external commitment.",
            "exchangeScope": "mapped",
            "id": "committed-action-id",
            "introducedIn": "1.0.0",
            "label": "Committed action ID",
            "nullable": true,
            "referenceEntityId": "committed-action",
            "required": false,
            "sourceAuthority": {
              "id": "tactical-sourcing-autonomy",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "awarded-notification",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Per-destination idempotency key, attempt, external identifier, last result, error and compensating action.",
            "exchangeScope": "mapped",
            "id": "reconciliation-state",
            "introducedIn": "1.0.0",
            "label": "Reconciliation state",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "tactical-sourcing-autonomy",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "order-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OrderReference/cbc:ID|cbc:OrderResponseCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Destination ID is the string component carried within Tactical sourcing case Reconciliation state; its classification and authority inherit from the owning field contract.",
                    "id": "destination-id",
                    "label": "Destination ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "reconciliation-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Idempotency key is the string component carried within Tactical sourcing case Reconciliation state; its classification and authority inherit from the owning field contract.",
                    "id": "idempotency-key",
                    "label": "Idempotency key",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "reconciliation-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Attempt count is the integer component carried within Tactical sourcing case Reconciliation state; its classification and authority inherit from the owning field contract.",
                    "id": "attempt-count",
                    "label": "Attempt count",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "reconciliation-state",
                      "kind": "inherited-field"
                    },
                    "type": "integer"
                  },
                  {
                    "classification": "restricted",
                    "definition": "External ID is the string component carried within Tactical sourcing case Reconciliation state; its classification and authority inherit from the owning field contract.",
                    "id": "external-id",
                    "label": "External ID",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "reconciliation-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Last result is the string component carried within Tactical sourcing case Reconciliation state; its classification and authority inherit from the owning field contract.",
                    "id": "last-result",
                    "label": "Last result",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "reconciliation-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Last attempt at is the timestamp component carried within Tactical sourcing case Reconciliation state; its classification and authority inherit from the owning field contract.",
                    "id": "last-attempt-at",
                    "label": "Last attempt at",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "reconciliation-state",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Error code records the governed code within Tactical sourcing case Reconciliation state without treating absence, unknown and zero as equivalent.",
                    "id": "error-code",
                    "label": "Error code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "reconciliation-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Error detail is the string component carried within Tactical sourcing case Reconciliation state; its classification and authority inherit from the owning field contract.",
                    "id": "error-detail",
                    "label": "Error detail",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "reconciliation-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Compensating action ID links this structured value to the governed committed-action record within Tactical sourcing case Reconciliation state.",
                    "id": "compensating-action-id",
                    "label": "Compensating action ID",
                    "nullable": true,
                    "referenceEntityId": "committed-action",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the compensating action ID in reconciliation state to the referenced committed action via its canonical committed action ID.",
                      "id": "tactical-sourcing-case-reconciliation-state-compensating-action-id",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "committed-action-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "reconciliation-state",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Status records the governed state or type within Tactical sourcing case Reconciliation state without treating absence, unknown and zero as equivalent.",
                    "id": "status",
                    "label": "Status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "reconciliation-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ],
                "uniqueBy": [
                  "destination-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Timestamp for the next step, response deadline, retry or escalation.",
            "exchangeScope": "mapped",
            "format": "date-time",
            "id": "next-action-due-at",
            "introducedIn": "1.0.0",
            "label": "Next action due at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "tactical-sourcing-autonomy",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "call-for-tenders",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:TenderingProcess/cac:TenderSubmissionDeadlinePeriod/cbc:EndDate|cac:TenderingProcess/cac:TenderSubmissionDeadlinePeriod/cbc:EndTime",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "tactical-sourcing-case",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "demand-case-id"
            ],
            "id": "tactical-sourcing-case-by-demand-case-id",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "lifecycle-state",
              "next-action-due-at"
            ],
            "id": "tactical-sourcing-case-by-status-and-next-action-due-at",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "category-id"
            ],
            "id": "tactical-sourcing-case-by-category-id",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "authority-envelope-id"
            ],
            "id": "tactical-sourcing-case-by-authority-envelope-id",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "committed-action-id"
            ],
            "id": "tactical-sourcing-case-by-committed-action-id",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "case",
        "label": "Tactical sourcing case",
        "lifecycle": [
          "screening",
          "eligible",
          "executing",
          "waiting-response",
          "proposed",
          "committing",
          "reconciling",
          "completed",
          "escalated",
          "stopped"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "tactical-sourcing-autonomy",
        "owningDomainWorkblockId": "sourcing-negotiation",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Tactical sourcing cases",
        "primaryKey": "tactical-sourcing-case-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "one-to-one",
            "definition": "Links the tactical case to its authorising demand.",
            "id": "tactical-sourcing-case-references-demand-case-tactical-demand",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "tactical-sourcing-case-references-demand-case-tactical-demand",
            "required": true,
            "sourceFieldId": "demand-case-id",
            "targetEntityId": "demand-case",
            "targetFieldId": "demand-case-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Associates the case with its canonical category.",
            "id": "tactical-sourcing-case-classified-as-category-tactical-category",
            "introducedIn": "1.0.0",
            "predicate": "classified-as",
            "qualifiedId": "tactical-sourcing-case-classified-as-category-tactical-category",
            "required": true,
            "sourceFieldId": "category-id",
            "targetEntityId": "category",
            "targetFieldId": "category-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Binds every policy-bounded tactical sourcing step to the exact active grant.",
            "id": "tactical-sourcing-case-governed-by-authority-envelope-tactical-authority",
            "introducedIn": "1.0.0",
            "predicate": "governed-by",
            "qualifiedId": "tactical-sourcing-case-governed-by-authority-envelope-tactical-authority",
            "required": true,
            "sourceFieldId": "authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "one-to-one",
            "definition": "Separates the evaluated proposal from the actual downstream commitment.",
            "id": "tactical-sourcing-case-references-committed-action-tactical-commitment",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "tactical-sourcing-case-references-committed-action-tactical-commitment",
            "required": false,
            "sourceFieldId": "committed-action-id",
            "targetEntityId": "committed-action",
            "targetFieldId": "committed-action-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the case to the eligible parties selected under governed fairness rules.",
            "id": "tactical-sourcing-case-references-party-tactical-invited-parties",
            "introducedIn": "2.0.0",
            "predicate": "references",
            "qualifiedId": "tactical-sourcing-case-references-party-tactical-invited-parties",
            "required": true,
            "sourceFieldId": "invited-party-ids",
            "targetEntityId": "party",
            "targetFieldId": "party-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the case to the immutable published quote-request evidence when present.",
            "id": "tactical-sourcing-case-evidenced-by-evidence-item-tactical-quote-request-artifact",
            "introducedIn": "2.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "tactical-sourcing-case-evidenced-by-evidence-item-tactical-quote-request-artifact",
            "required": false,
            "sourceFieldId": "quote-request-artifact-id",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "tactical sourcing",
          "autonomous sourcing",
          "three quotes",
          "spot buy",
          "low complexity event"
        ],
        "sourceSystemRoleIds": [
          "system-of-record",
          "collaboration-channel",
          "evidence-source"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "collaboration-channel",
          "system-of-record",
          "execution-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [],
        "definition": "A versioned proposal, authority decision, commitment, correction or reversal for one spend-record dimension, preserving prior value, rationale and evidence.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for this proposal, decision or corrective classification fact.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "spend-classification-decision-id",
            "introducedIn": "1.0.0",
            "label": "Spend classification decision ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Company relative to which the classification meaning and authority apply.",
            "exchangeScope": "internal",
            "id": "company-party-id",
            "introducedIn": "1.0.0",
            "label": "Company party ID",
            "nullable": false,
            "referenceEntityId": "party",
            "required": true,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Canonical accounting-distribution spend record whose dimension value is under decision.",
            "exchangeScope": "internal",
            "id": "spend-record-id",
            "introducedIn": "1.0.0",
            "label": "Spend record ID",
            "nullable": false,
            "referenceEntityId": "spend-record",
            "required": true,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Independent governed dimension being decided; values from different dimensions are never collapsed into one enum.",
            "enumValues": [
              "spend-segment",
              "buying-mode",
              "accounting-treatment",
              "category"
            ],
            "exchangeScope": "internal",
            "id": "dimension-id",
            "introducedIn": "1.0.0",
            "label": "Dimension ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Candidate member suggested by a person, rule, source default or model; it is not committed truth.",
            "exchangeScope": "internal",
            "id": "proposed-member-id",
            "introducedIn": "1.0.0",
            "label": "Proposed member ID",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Authorised member committed for the dimension, when the decision has reached a commitment state.",
            "exchangeScope": "internal",
            "id": "committed-member-id",
            "introducedIn": "1.0.0",
            "label": "Committed member ID",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Highest-precedence authorised source used to resolve the committed value.",
            "enumValues": [
              "transaction-line-override",
              "item-or-catalogue-default",
              "category-assignment",
              "proposal-only",
              "unresolved"
            ],
            "exchangeScope": "internal",
            "id": "resolution-source",
            "introducedIn": "1.0.0",
            "label": "Resolution source",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Method that produced this version while preserving the distinction between proposal and authorised commitment.",
            "enumValues": [
              "human",
              "policy-authorised",
              "model-assisted",
              "source-default",
              "migration"
            ],
            "exchangeScope": "internal",
            "id": "decision-method",
            "introducedIn": "1.0.0",
            "label": "Decision method",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Typed authority-system reference for the person, role or service responsible for this transition.",
            "exchangeScope": "internal",
            "id": "actor-reference",
            "introducedIn": "1.0.0",
            "label": "Actor reference",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Exact authority envelope permitting the named decision action.",
            "exchangeScope": "internal",
            "id": "authority-envelope-id",
            "introducedIn": "1.0.0",
            "label": "Authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Versioned policy rule used by an authorised automatic or assisted decision, when applicable.",
            "exchangeScope": "internal",
            "id": "rule-release-id",
            "introducedIn": "1.0.0",
            "label": "Rule release ID",
            "nullable": true,
            "referenceEntityId": "policy-rule-release",
            "required": false,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Exact model or classifier version that supported a proposal, never an authority grant.",
            "exchangeScope": "internal",
            "id": "model-version",
            "introducedIn": "1.0.0",
            "label": "Model version",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Calibrated proposal confidence between zero and one; it does not establish commitment.",
            "exchangeScope": "internal",
            "format": "0..1",
            "id": "confidence",
            "introducedIn": "1.0.0",
            "label": "Confidence",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "decimal"
          },
          {
            "classification": "confidential",
            "definition": "Evidence-linked explanation for the proposal, decision, correction or reversal.",
            "exchangeScope": "internal",
            "id": "rationale",
            "introducedIn": "1.0.0",
            "label": "Rationale",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "text"
          },
          {
            "classification": "confidential",
            "definition": "Versioned evidence used by the proposal or decision, subject to its own permission boundary.",
            "exchangeScope": "internal",
            "id": "evidence-item-ids",
            "introducedIn": "1.0.0",
            "label": "Evidence item IDs",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "restricted",
            "definition": "Exact category, item, catalogue, account, contract or source-record versions evaluated by this decision.",
            "exchangeScope": "internal",
            "id": "source-version-references",
            "introducedIn": "1.0.0",
            "label": "Source version references",
            "listSemantics": "set",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string-list"
          },
          {
            "classification": "confidential",
            "definition": "Prior proposal or committed decision corrected, superseded or reversed by this version.",
            "exchangeScope": "internal",
            "id": "predecessor-decision-id",
            "introducedIn": "1.0.0",
            "label": "Predecessor decision ID",
            "nullable": true,
            "referenceEntityId": "spend-classification-decision",
            "required": false,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "UTC timestamp at which this decision version was recorded.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "decided-at",
            "introducedIn": "1.0.0",
            "label": "Decided at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Whether a requested downstream write was acknowledged; internal approval never implies external success.",
            "enumValues": [
              "not-requested",
              "pending",
              "acknowledged",
              "failed"
            ],
            "exchangeScope": "internal",
            "id": "external-acknowledgement-status",
            "introducedIn": "1.0.0",
            "label": "External acknowledgement status",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Shared governed decision record that carries authority, rationale and evidence for this domain decision.",
            "exchangeScope": "unmapped",
            "id": "governance-decision-id",
            "introducedIn": "4.0.0",
            "label": "Governance decision ID",
            "nullable": true,
            "referenceEntityId": "decision",
            "required": false,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "spend-classification-decision",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "spend-classification-decision-id"
            ],
            "id": "spend-classification-decision-primary",
            "introducedIn": "1.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "spend-record-id",
              "dimension-id",
              "lifecycle-state"
            ],
            "id": "spend-classification-decision-by-spend-record-id-and-dimension-id-and-state",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "company-party-id",
              "decided-at"
            ],
            "id": "spend-classification-decision-by-company-party-id-and-decided-at",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "decision",
        "label": "Spend classification decision",
        "lifecycle": [
          "proposed",
          "rejected",
          "approved",
          "committed",
          "externally-acknowledged",
          "reconciled",
          "corrected",
          "reversed"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "spend-data-foundation",
        "owningDomainWorkblockId": "strategy-policy-category-spend",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Spend classification decisions",
        "primaryKey": "spend-classification-decision-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Scopes the classification meaning and authority to one company.",
            "id": "spend-classification-decision-classified-as-party-classification-decision-company",
            "introducedIn": "1.0.0",
            "predicate": "classified-as",
            "qualifiedId": "spend-classification-decision-classified-as-party-classification-decision-company",
            "required": true,
            "sourceFieldId": "company-party-id",
            "targetEntityId": "party",
            "targetFieldId": "party-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the decision to the canonical spend accounting distribution it classifies.",
            "id": "spend-classification-decision-classified-as-spend-record-classification-decision-spend-record",
            "introducedIn": "1.0.0",
            "predicate": "classified-as",
            "qualifiedId": "spend-classification-decision-classified-as-spend-record-classification-decision-spend-record",
            "required": true,
            "sourceFieldId": "spend-record-id",
            "targetEntityId": "spend-record",
            "targetFieldId": "spend-record-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Binds an approval, commitment, correction or reversal to its exact authority grant.",
            "id": "spend-classification-decision-governed-by-authority-envelope-classification-decision-authority",
            "introducedIn": "1.0.0",
            "predicate": "governed-by",
            "qualifiedId": "spend-classification-decision-governed-by-authority-envelope-classification-decision-authority",
            "required": false,
            "sourceFieldId": "authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links a policy-supported decision to the exact rule release evaluated.",
            "id": "spend-classification-decision-classified-as-policy-rule-release-classification-decision-rule",
            "introducedIn": "1.0.0",
            "predicate": "classified-as",
            "qualifiedId": "spend-classification-decision-classified-as-policy-rule-release-classification-decision-rule",
            "required": false,
            "sourceFieldId": "rule-release-id",
            "targetEntityId": "policy-rule-release",
            "targetFieldId": "policy-rule-release-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the decision to its governed supporting evidence.",
            "id": "spend-classification-decision-evidenced-by-evidence-item-classification-decision-evidence",
            "introducedIn": "1.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "spend-classification-decision-evidenced-by-evidence-item-classification-decision-evidence",
            "required": true,
            "sourceFieldId": "evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Preserves the proposal or committed decision superseded by this corrective fact.",
            "id": "spend-classification-decision-supersedes-spend-classification-decision-classification-decision-predecessor",
            "introducedIn": "1.0.0",
            "predicate": "supersedes",
            "qualifiedId": "spend-classification-decision-supersedes-spend-classification-decision-classification-decision-predecessor",
            "required": false,
            "sourceFieldId": "predecessor-decision-id",
            "targetEntityId": "spend-classification-decision",
            "targetFieldId": "spend-classification-decision-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Shared governed decision for this domain outcome.",
            "id": "spend-classification-decision-governed-by-decision-spend-classification-decision-governance-decision",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "spend-classification-decision-governed-by-decision-spend-classification-decision-governance-decision",
            "required": false,
            "sourceFieldId": "governance-decision-id",
            "targetEntityId": "decision",
            "targetFieldId": "decision-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "classification decision",
          "spend segment override",
          "classification correction",
          "classification provenance"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Who changed this record's category or other dimension, from what to what, and when?",
              "Was this classification later reversed or corrected, and by which decision?",
              "Was this decision made by a human, a policy, or a model, and under which version?"
            ],
            "retrievalTerms": [
              "reclassify",
              "from-to",
              "reversal",
              "actor",
              "override",
              "audit trail"
            ],
            "usage": "Read the chain through predecessor-decision-id: the predecessor's committed-member-id is the from, this record's is the to. Reversal is a lifecycle state, never an absent record; a reversed classification still has its row."
          },
          "introducedIn": "4.8.0",
          "semanticLabel": {
            "aliases": [
              "reclassification",
              "classification override",
              "reclassification log row"
            ],
            "concept": "classification-audit-entry",
            "doNotConfuseWith": [
              {
                "distinction": "spend-classification-decision is the domain-specific per-dimension classification fact; decision is the generic governed-choice entity, referenced only when a shared ruling wraps it.",
                "targetEntityId": "decision"
              },
              {
                "distinction": "The decision is the append-only transition; the spend record carries the current resolved state. classification-confidence on the spend record is calibrated for the category assignment only; per-axis confidence lives here, on confidence, grouped by dimension-id.",
                "targetEntityId": "spend-record"
              },
              {
                "distinction": "audit-event is the immutable accountability log that a transition occurred; this entity is the classification fact itself, with the from, the to and the rationale that make it reviewable.",
                "targetEntityId": "audit-event"
              }
            ]
          }
        },
        "sourceSystemRoleIds": [
          "execution-system",
          "system-of-record",
          "planning-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.1.0",
        "writebackSystemRoleIds": [
          "planning-system",
          "analytical-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [],
        "definition": "A versioned, company-scoped control that derives tail or non-tail membership for a stated period without persisting an unqualified boolean on spend records.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable identifier for the versioned rule family release.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "tail-spend-rule-id",
            "introducedIn": "1.0.0",
            "label": "Tail spend rule ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Company whose spend population and management policy the rule evaluates.",
            "exchangeScope": "internal",
            "id": "company-party-id",
            "introducedIn": "1.0.0",
            "label": "Company party ID",
            "nullable": false,
            "referenceEntityId": "party",
            "required": true,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Optional narrower accountable scope when the approved company policy permits it.",
            "exchangeScope": "internal",
            "id": "business-unit-id",
            "introducedIn": "1.0.0",
            "label": "Business unit ID",
            "nullable": true,
            "referenceEntityId": "business-unit",
            "required": false,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Immutable semantic version of the rule and its analytical definition.",
            "exchangeScope": "internal",
            "format": "semantic version",
            "id": "rule-version",
            "introducedIn": "1.0.0",
            "label": "Rule version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Governed calculation method used to derive membership for the declared period.",
            "enumValues": [
              "threshold",
              "pareto",
              "management-state",
              "composite"
            ],
            "exchangeScope": "internal",
            "id": "method",
            "introducedIn": "1.0.0",
            "label": "Method",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "compositeValueContract": {
              "componentFieldIds": [
                "threshold-amount"
              ],
              "representation": "registry-object",
              "schemaId": "money-value",
              "schemaVersion": "2.0.0"
            },
            "definition": "Optional governed amount and currency used by a threshold or composite rule.",
            "exchangeScope": "internal",
            "id": "threshold-amount",
            "introducedIn": "1.0.0",
            "label": "Threshold amount",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "money",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "money-value",
              "schemaVersion": "2.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Optional cumulative spend percentage used by a Pareto or composite rule.",
            "exchangeScope": "internal",
            "format": "0..100",
            "id": "pareto-percentage",
            "introducedIn": "1.0.0",
            "label": "Pareto percentage",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "decimal"
          },
          {
            "classification": "internal",
            "definition": "Named period convention used by the rule so membership is never timeless.",
            "enumValues": [
              "calendar-year",
              "fiscal-year",
              "rolling-twelve-months",
              "explicit-period"
            ],
            "exchangeScope": "internal",
            "id": "evaluation-period-basis",
            "introducedIn": "1.0.0",
            "label": "Evaluation period basis",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Optional category scope explicitly included in evaluation.",
            "exchangeScope": "internal",
            "id": "included-category-ids",
            "introducedIn": "1.0.0",
            "label": "Included category IDs",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "category",
            "required": false,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "confidential",
            "definition": "Optional category scope explicitly excluded from evaluation.",
            "exchangeScope": "internal",
            "id": "excluded-category-ids",
            "introducedIn": "1.0.0",
            "label": "Excluded category IDs",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "category",
            "required": false,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Inclusive timestamp from which this rule version may govern new evaluations.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "effective-from",
            "introducedIn": "1.0.0",
            "label": "Effective from",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Optional exclusive timestamp after which this rule cannot govern a new evaluation.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "effective-until",
            "introducedIn": "1.0.0",
            "label": "Effective until",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Exact authority envelope permitting approval or activation of this rule.",
            "exchangeScope": "internal",
            "id": "authority-envelope-id",
            "introducedIn": "1.0.0",
            "label": "Authority envelope ID",
            "nullable": false,
            "referenceEntityId": "authority-envelope",
            "required": true,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Evidence supporting the analytical definition and approval of this rule version.",
            "exchangeScope": "internal",
            "id": "evidence-item-ids",
            "introducedIn": "1.0.0",
            "label": "Evidence item IDs",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "restricted",
            "definition": "Immediate rule version replaced by this rule, preserving historical evaluation meaning.",
            "exchangeScope": "internal",
            "id": "supersedes-tail-spend-rule-id",
            "introducedIn": "1.0.0",
            "label": "Supersedes tail spend rule ID",
            "nullable": true,
            "referenceEntityId": "tail-spend-rule",
            "required": false,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "tail-spend-rule",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "tail-spend-rule-id"
            ],
            "id": "tail-spend-rule-primary",
            "introducedIn": "1.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "company-party-id",
              "rule-version"
            ],
            "id": "tail-spend-rule-by-company-party-id-and-rule-version",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "company-party-id",
              "lifecycle-state",
              "effective-from"
            ],
            "id": "tail-spend-rule-by-company-party-id-and-status-and-effective-from",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "control",
        "label": "Tail spend rule",
        "lifecycle": [
          "proposed",
          "approved",
          "active",
          "superseded",
          "retired"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "policy-rule-lifecycle",
        "owningDomainWorkblockId": "strategy-policy-category-spend",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Tail spend rules",
        "primaryKey": "tail-spend-rule-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Scopes the rule to the company whose spend population it evaluates.",
            "id": "tail-spend-rule-references-party-tail-rule-company",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "tail-spend-rule-references-party-tail-rule-company",
            "required": true,
            "sourceFieldId": "company-party-id",
            "targetEntityId": "party",
            "targetFieldId": "party-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Narrows the rule to an approved business-unit scope when present.",
            "id": "tail-spend-rule-belongs-to-business-unit-tail-rule-business-unit",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "tail-spend-rule-belongs-to-business-unit-tail-rule-business-unit",
            "required": false,
            "sourceFieldId": "business-unit-id",
            "targetEntityId": "business-unit",
            "targetFieldId": "business-unit-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the rule to categories explicitly included in its population.",
            "id": "tail-spend-rule-references-category-tail-rule-included-categories",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "tail-spend-rule-references-category-tail-rule-included-categories",
            "required": false,
            "sourceFieldId": "included-category-ids",
            "targetEntityId": "category",
            "targetFieldId": "category-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the rule to categories explicitly excluded from its population.",
            "id": "tail-spend-rule-references-category-tail-rule-excluded-categories",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "tail-spend-rule-references-category-tail-rule-excluded-categories",
            "required": false,
            "sourceFieldId": "excluded-category-ids",
            "targetEntityId": "category",
            "targetFieldId": "category-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Binds approval and activation to the exact authority grant.",
            "id": "tail-spend-rule-governed-by-authority-envelope-tail-rule-authority",
            "introducedIn": "1.0.0",
            "predicate": "governed-by",
            "qualifiedId": "tail-spend-rule-governed-by-authority-envelope-tail-rule-authority",
            "required": true,
            "sourceFieldId": "authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the rule version to its governed evidence.",
            "id": "tail-spend-rule-evidenced-by-evidence-item-tail-rule-evidence",
            "introducedIn": "1.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "tail-spend-rule-evidenced-by-evidence-item-tail-rule-evidence",
            "required": true,
            "sourceFieldId": "evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Preserves the rule version superseded by this release.",
            "id": "tail-spend-rule-supersedes-tail-spend-rule-tail-rule-predecessor",
            "introducedIn": "1.0.0",
            "predicate": "supersedes",
            "qualifiedId": "tail-spend-rule-supersedes-tail-spend-rule-tail-rule-predecessor",
            "required": false,
            "sourceFieldId": "supersedes-tail-spend-rule-id",
            "targetEntityId": "tail-spend-rule",
            "targetFieldId": "tail-spend-rule-id"
          }
        ],
        "retentionClass": "policy",
        "searchTerms": [
          "tail spend",
          "tail classification rule",
          "Pareto rule",
          "spend threshold"
        ],
        "sourceSystemRoleIds": [
          "system-of-record",
          "analytical-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": []
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": false,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "bid-evaluation-award",
          "negotiation-copilot",
          "tactical-sourcing-autonomy"
        ],
        "definition": "Versioned structured metadata for a supplier bid, quotation or tender response, with protected document bodies retained as governed evidence blobs.",
        "domainWorkblockIds": [
          "sourcing-negotiation"
        ],
        "fields": [
          {
            "classification": "internal",
            "definition": "Stable identifier for this supplier response record.",
            "exchangeScope": "unmapped",
            "id": "supplier-response-id",
            "introducedIn": "4.0.0",
            "label": "Supplier response ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-event",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Sourcing event to which this response belongs.",
            "exchangeScope": "unmapped",
            "id": "sourcing-event-record-id",
            "introducedIn": "4.0.0",
            "label": "Sourcing event record ID",
            "nullable": false,
            "referenceEntityId": "sourcing-event-record",
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-event",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Supplier party that submitted the response.",
            "exchangeScope": "unmapped",
            "id": "supplier-party-id",
            "introducedIn": "4.0.0",
            "label": "Supplier party ID",
            "nullable": false,
            "referenceEntityId": "party",
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-event",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Immutable supplier response version within the sourcing event.",
            "exchangeScope": "unmapped",
            "id": "response-version",
            "introducedIn": "4.0.0",
            "label": "Response version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-event",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Authoritative submission time when submitted.",
            "exchangeScope": "unmapped",
            "id": "submitted-at",
            "introducedIn": "4.0.0",
            "label": "Submitted at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "sourcing-event",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "compositeValueContract": {
              "componentFieldIds": [
                "total-price"
              ],
              "representation": "registry-object",
              "schemaId": "money-value",
              "schemaVersion": "2.0.0"
            },
            "definition": "Supplier-stated total price with explicit currency; it remains a proposal until authorised award.",
            "exchangeScope": "unmapped",
            "id": "total-price",
            "introducedIn": "4.0.0",
            "label": "Total price",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "sourcing-event",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "money",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "money-value",
              "schemaVersion": "2.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Protected response document or native artifact metadata.",
            "exchangeScope": "unmapped",
            "id": "artifact-id",
            "introducedIn": "4.0.0",
            "label": "Artifact reference",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "sourcing-event",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Evidence supporting the response and its verification.",
            "exchangeScope": "unmapped",
            "id": "evidence-item-ids",
            "introducedIn": "4.0.0",
            "label": "Evidence item IDs",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "sourcing-event",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Prior response version superseded by this record.",
            "exchangeScope": "unmapped",
            "id": "supersedes-supplier-response-id",
            "introducedIn": "4.0.0",
            "label": "Superseded response ID",
            "nullable": true,
            "referenceEntityId": "supplier-response",
            "required": false,
            "sourceAuthority": {
              "id": "sourcing-event",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "supplier-response",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "supplier-response-id"
            ],
            "id": "supplier-response-primary",
            "introducedIn": "4.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "sourcing-event-record-id",
              "supplier-party-id",
              "response-version"
            ],
            "id": "supplier-response-by-event-and-supplier-and-version",
            "introducedIn": "4.0.0",
            "unique": true
          }
        ],
        "introducedIn": "4.0.0",
        "kind": "document",
        "label": "Supplier response",
        "lifecycle": [
          "draft",
          "submitted",
          "withdrawn",
          "accepted",
          "rejected",
          "superseded"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "sourcing-event",
        "owningDomainWorkblockId": "sourcing-negotiation",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Supplier responses",
        "primaryKey": "supplier-response-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Sourcing event receiving the response.",
            "id": "supplier-response-belongs-to-sourcing-event-record-response-event",
            "introducedIn": "4.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-response-belongs-to-sourcing-event-record-response-event",
            "required": false,
            "sourceFieldId": "sourcing-event-record-id",
            "targetEntityId": "sourcing-event-record",
            "targetFieldId": "sourcing-event-record-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Supplier that submitted the response.",
            "id": "supplier-response-belongs-to-party-response-supplier",
            "introducedIn": "4.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-response-belongs-to-party-response-supplier",
            "required": false,
            "sourceFieldId": "supplier-party-id",
            "targetEntityId": "party",
            "targetFieldId": "party-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Protected response document metadata.",
            "id": "supplier-response-evidenced-by-evidence-item-response-artifact",
            "introducedIn": "4.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "supplier-response-evidenced-by-evidence-item-response-artifact",
            "required": false,
            "sourceFieldId": "artifact-id",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Evidence supporting response verification.",
            "id": "supplier-response-evidenced-by-evidence-item-response-evidence",
            "introducedIn": "4.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "supplier-response-evidenced-by-evidence-item-response-evidence",
            "required": false,
            "sourceFieldId": "evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Prior immutable response version.",
            "id": "supplier-response-supersedes-supplier-response-response-supersedes",
            "introducedIn": "4.0.0",
            "predicate": "supersedes",
            "qualifiedId": "supplier-response-supersedes-supplier-response-response-supersedes",
            "required": false,
            "sourceFieldId": "supersedes-supplier-response-id",
            "targetEntityId": "supplier-response",
            "targetFieldId": "supplier-response-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "supplier response",
          "bid",
          "quotation",
          "tender response"
        ],
        "sourceSystemRoleIds": [
          "source-of-record"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "source-of-record"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": false,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "intelligent-intake",
          "realization-reconciliation-attribution",
          "requisition-policy-routing",
          "savings-initiative"
        ],
        "definition": "An authorised plan amount for a company scope, accountable owner, period and currency, linked to demand, requisition and actual spend without replacing finance authority.",
        "domainWorkblockIds": [
          "intake-demand",
          "buying-ordering-receiving",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "internal",
            "definition": "Stable identifier for this budget record.",
            "exchangeScope": "unmapped",
            "id": "budget-id",
            "introducedIn": "4.0.0",
            "label": "Budget ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "demand-consolidation-portfolio",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Company to which the budget applies.",
            "exchangeScope": "unmapped",
            "id": "company-party-id",
            "introducedIn": "4.0.0",
            "label": "Company party ID",
            "nullable": false,
            "referenceEntityId": "party",
            "required": true,
            "sourceAuthority": {
              "id": "demand-consolidation-portfolio",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Optional accountable business-unit scope.",
            "exchangeScope": "unmapped",
            "id": "business-unit-id",
            "introducedIn": "4.0.0",
            "label": "Business unit ID",
            "nullable": true,
            "referenceEntityId": "business-unit",
            "required": false,
            "sourceAuthority": {
              "id": "demand-consolidation-portfolio",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Role accountable for authorising and governing the budget.",
            "exchangeScope": "unmapped",
            "id": "owner-role-id",
            "introducedIn": "4.0.0",
            "label": "Owner role ID",
            "nullable": false,
            "referenceEntityId": "role",
            "required": true,
            "sourceAuthority": {
              "id": "demand-consolidation-portfolio",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Finance-controlled budget code within company scope.",
            "exchangeScope": "unmapped",
            "id": "budget-code",
            "introducedIn": "4.0.0",
            "label": "Budget code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "demand-consolidation-portfolio",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Inclusive start date for the budget period.",
            "exchangeScope": "unmapped",
            "id": "period-start",
            "introducedIn": "4.0.0",
            "label": "Period start",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "demand-consolidation-portfolio",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "internal",
            "definition": "Inclusive end date for the budget period.",
            "exchangeScope": "unmapped",
            "id": "period-end",
            "introducedIn": "4.0.0",
            "label": "Period end",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "demand-consolidation-portfolio",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "internal",
            "compositeValueContract": {
              "componentFieldIds": [
                "authorised-amount"
              ],
              "representation": "registry-object",
              "schemaId": "money-value",
              "schemaVersion": "2.0.0"
            },
            "definition": "Authorised plan amount with explicit currency and rounding semantics.",
            "exchangeScope": "unmapped",
            "id": "authorised-amount",
            "introducedIn": "4.0.0",
            "label": "Authorised amount",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "demand-consolidation-portfolio",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "money",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "money-value",
              "schemaVersion": "2.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Prior budget version superseded by this record.",
            "exchangeScope": "unmapped",
            "id": "supersedes-budget-id",
            "introducedIn": "4.0.0",
            "label": "Superseded budget ID",
            "nullable": true,
            "referenceEntityId": "budget",
            "required": false,
            "sourceAuthority": {
              "id": "demand-consolidation-portfolio",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "budget",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "budget-id"
            ],
            "id": "budget-primary",
            "introducedIn": "4.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "company-party-id",
              "budget-code",
              "period-start"
            ],
            "id": "budget-by-company-and-code-and-period",
            "introducedIn": "4.0.0",
            "unique": true
          }
        ],
        "introducedIn": "4.0.0",
        "kind": "control",
        "label": "Budget",
        "lifecycle": [
          "draft",
          "approved",
          "active",
          "closed",
          "superseded"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "demand-consolidation-portfolio",
        "owningDomainWorkblockId": "intake-demand",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Budgets",
        "primaryKey": "budget-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Company owning the budget.",
            "id": "budget-belongs-to-party-budget-company",
            "introducedIn": "4.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "budget-belongs-to-party-budget-company",
            "required": false,
            "sourceFieldId": "company-party-id",
            "targetEntityId": "party",
            "targetFieldId": "party-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Optional business-unit scope.",
            "id": "budget-belongs-to-business-unit-budget-business-unit",
            "introducedIn": "4.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "budget-belongs-to-business-unit-budget-business-unit",
            "required": false,
            "sourceFieldId": "business-unit-id",
            "targetEntityId": "business-unit",
            "targetFieldId": "business-unit-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Role accountable for the budget.",
            "id": "budget-assigned-to-role-budget-owner-role",
            "introducedIn": "4.0.0",
            "predicate": "assigned-to",
            "qualifiedId": "budget-assigned-to-role-budget-owner-role",
            "required": false,
            "sourceFieldId": "owner-role-id",
            "targetEntityId": "role",
            "targetFieldId": "role-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Prior budget version.",
            "id": "budget-supersedes-budget-budget-supersedes",
            "introducedIn": "4.0.0",
            "predicate": "supersedes",
            "qualifiedId": "budget-supersedes-budget-budget-supersedes",
            "required": false,
            "sourceFieldId": "supersedes-budget-id",
            "targetEntityId": "budget",
            "targetFieldId": "budget-id"
          }
        ],
        "retentionClass": "financial",
        "searchTerms": [
          "budget",
          "plan",
          "commitment",
          "plan versus actual"
        ],
        "sourceSystemRoleIds": [
          "planning-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "planning-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": false,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "category-opportunity-radar",
          "category-strategy-orchestrator",
          "policy-guidance",
          "tactical-sourcing-autonomy"
        ],
        "definition": "A reproducible derived evaluation of a spend record against one versioned tail rule and period; it never writes a timeless tail boolean to the spend record.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "sourcing-negotiation"
        ],
        "fields": [
          {
            "classification": "internal",
            "definition": "Stable identifier for this tail spend evaluation record.",
            "exchangeScope": "unmapped",
            "id": "tail-spend-evaluation-id",
            "introducedIn": "4.0.0",
            "label": "Tail spend evaluation ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Spend record evaluated by the rule.",
            "exchangeScope": "unmapped",
            "id": "spend-record-id",
            "introducedIn": "4.0.0",
            "label": "Spend record ID",
            "nullable": false,
            "referenceEntityId": "spend-record",
            "required": true,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Exact versioned rule used for evaluation.",
            "exchangeScope": "unmapped",
            "id": "tail-spend-rule-id",
            "introducedIn": "4.0.0",
            "label": "Tail spend rule ID",
            "nullable": false,
            "referenceEntityId": "tail-spend-rule",
            "required": true,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Derived result with unresolved preserved as a state rather than coerced to false.",
            "enumValues": [
              "tail",
              "non-tail",
              "unresolved"
            ],
            "exchangeScope": "unmapped",
            "id": "evaluation-result",
            "introducedIn": "4.0.0",
            "label": "Evaluation result",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Version of the evaluation definition and rounding rules.",
            "exchangeScope": "unmapped",
            "id": "definition-version",
            "introducedIn": "4.0.0",
            "label": "Definition version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Time the derived result was calculated.",
            "exchangeScope": "unmapped",
            "id": "evaluated-at",
            "introducedIn": "4.0.0",
            "label": "Evaluated at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Exact spend-record version used by the evaluation.",
            "exchangeScope": "unmapped",
            "id": "source-record-version",
            "introducedIn": "4.0.0",
            "label": "Source record version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Authority envelope governing proposals, approvals and commitments for this record.",
            "exchangeScope": "unmapped",
            "id": "governance-authority-envelope-id",
            "introducedIn": "4.0.0",
            "label": "Governance authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Evidence supporting this record and its governed outcome.",
            "exchangeScope": "unmapped",
            "id": "governance-evidence-item-ids",
            "introducedIn": "4.0.0",
            "label": "Governance evidence item IDs",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "spend-data-foundation",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "tail-spend-evaluation",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "tail-spend-evaluation-id"
            ],
            "id": "tail-spend-evaluation-primary",
            "introducedIn": "4.0.0",
            "unique": true
          },
          {
            "fieldIds": [
              "tail-spend-rule-id",
              "spend-record-id"
            ],
            "id": "tail-spend-evaluation-by-rule-and-spend-record",
            "introducedIn": "4.0.0",
            "unique": true
          }
        ],
        "introducedIn": "4.0.0",
        "kind": "assessment",
        "label": "Tail spend evaluation",
        "lifecycle": [
          "computed",
          "stale",
          "superseded"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "spend-data-foundation",
        "owningDomainWorkblockId": "strategy-policy-category-spend",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-read-model",
            "status": "direction"
          },
          {
            "id": "lake-gold-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Tail spend evaluations",
        "primaryKey": "tail-spend-evaluation-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Spend record evaluated.",
            "id": "tail-spend-evaluation-derived-from-spend-record-evaluation-spend-record",
            "introducedIn": "4.0.0",
            "predicate": "derived-from",
            "qualifiedId": "tail-spend-evaluation-derived-from-spend-record-evaluation-spend-record",
            "required": false,
            "sourceFieldId": "spend-record-id",
            "targetEntityId": "spend-record",
            "targetFieldId": "spend-record-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Versioned tail rule used for evaluation.",
            "id": "tail-spend-evaluation-governed-by-tail-spend-rule-evaluation-tail-rule",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "tail-spend-evaluation-governed-by-tail-spend-rule-evaluation-tail-rule",
            "required": false,
            "sourceFieldId": "tail-spend-rule-id",
            "targetEntityId": "tail-spend-rule",
            "targetFieldId": "tail-spend-rule-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authority envelope governing this record.",
            "id": "tail-spend-evaluation-governed-by-authority-envelope-tail-spend-evaluation-governance-authority",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "tail-spend-evaluation-governed-by-authority-envelope-tail-spend-evaluation-governance-authority",
            "required": false,
            "sourceFieldId": "governance-authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Evidence supporting this record.",
            "id": "tail-spend-evaluation-evidenced-by-evidence-item-tail-spend-evaluation-governance-evidence",
            "introducedIn": "4.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "tail-spend-evaluation-evidenced-by-evidence-item-tail-spend-evaluation-governance-evidence",
            "required": false,
            "sourceFieldId": "governance-evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          }
        ],
        "retentionClass": "financial",
        "searchTerms": [
          "tail spend evaluation",
          "derived membership",
          "tail rule"
        ],
        "sourceSystemRoleIds": [
          "analytical-system",
          "system-of-record"
        ],
        "storageClass": "generated-projection",
        "version": "4.0.0",
        "writebackSystemRoleIds": []
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "policy-guidance",
          "procurement-service-catalogue",
          "intelligent-intake",
          "requisition-policy-routing"
        ],
        "definition": "A policy-owner impact case that freezes the affected record cohort and evidence for one rule release, then tracks each receiving owner disposition and handoff receipt to expiry, reopening or verified closure without mutating another owner's records.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "buying-ordering-receiving"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable identifier for one frozen impact cohort and its closure history.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "policy-change-impact-id",
            "introducedIn": "4.3.0",
            "label": "Policy change impact ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "restricted",
            "definition": "Exact rule release whose changed meaning or effective state caused this impact assessment.",
            "exchangeScope": "internal",
            "id": "policy-rule-release-id",
            "introducedIn": "4.3.0",
            "label": "Policy rule release ID",
            "nullable": false,
            "referenceEntityId": "policy-rule-release",
            "required": true,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Optional predecessor release against which affected records and changed outcomes were determined.",
            "exchangeScope": "internal",
            "id": "prior-policy-rule-release-id",
            "introducedIn": "4.3.0",
            "label": "Prior policy rule release ID",
            "nullable": true,
            "referenceEntityId": "policy-rule-release",
            "required": false,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "UTC time at which the permission-filtered affected cohort and exact record versions were frozen for reconciliation.",
            "exchangeScope": "internal",
            "format": "ISO 8601 UTC",
            "id": "impact-snapshot-at",
            "introducedIn": "4.3.0",
            "label": "Impact snapshot at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Evidence item containing the immutable, permissioned cohort snapshot or its governed artifact reference and integrity hash.",
            "exchangeScope": "internal",
            "id": "impact-snapshot-evidence-item-id",
            "introducedIn": "4.3.0",
            "label": "Impact snapshot evidence item ID",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Versioned evidence supporting inclusion, exclusion, expected disposition and later closure of affected records.",
            "exchangeScope": "internal",
            "id": "impact-evidence-item-ids",
            "introducedIn": "4.3.0",
            "label": "Impact evidence item IDs",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Exact distinct set of business-module or platform-service owners represented in affected-items; it is stored for permission-safe cohort routing and must reconcile to affected-owner-count.",
            "exchangeScope": "internal",
            "id": "affected-owner-ids",
            "introducedIn": "4.3.0",
            "label": "Affected owner IDs",
            "listSemantics": "set",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string-list"
          },
          {
            "classification": "internal",
            "definition": "Exact count of distinct affected owners in the frozen snapshot; redacted owners are omitted before this authorised count is calculated.",
            "exchangeScope": "internal",
            "format": "non-negative integer",
            "id": "affected-owner-count",
            "introducedIn": "4.3.0",
            "label": "Affected owner count",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "integer"
          },
          {
            "classification": "internal",
            "definition": "Exact count of permission-visible affected record versions represented by affected-items; unknown, withheld and zero remain distinct.",
            "exchangeScope": "internal",
            "format": "non-negative integer",
            "id": "affected-record-count",
            "introducedIn": "4.3.0",
            "label": "Affected record count",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "integer"
          },
          {
            "classification": "restricted",
            "definition": "Frozen record-version impacts with one current disposition and the exact proposal, owner decision and immutable receipt event needed to explain closure; delivery, acceptance and completion stay distinct.",
            "exchangeScope": "internal",
            "id": "affected-items",
            "introducedIn": "4.3.0",
            "label": "Affected items",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Stable item key within the frozen impact cohort.",
                    "id": "impact-item-id",
                    "label": "Impact item ID",
                    "nullable": false,
                    "openVocabularyJustification": "The policy owner assigns a stable item key within this impact record and enforces uniqueness through the owning field contract.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "affected-items",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "internal",
                    "definition": "Stable business-module or platform-service owner of the affected record and disposition.",
                    "id": "affected-owner-id",
                    "label": "Affected owner ID",
                    "nullable": false,
                    "openVocabularyJustification": "The value is a governed owner registry ID rather than a member of an entity-local closed vocabulary.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "affected-items",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Typed affected record and exact optimistic-concurrency or immutable record version from the frozen snapshot.",
                    "id": "affected-record-ref",
                    "label": "Affected record reference",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "affected-items",
                      "kind": "inherited-field"
                    },
                    "type": "object",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "record-reference-value",
                      "schemaVersion": "1.0.0"
                    }
                  },
                  {
                    "classification": "internal",
                    "definition": "Current governed treatment of this affected record version; a receipt or acceptance does not by itself prove completion.",
                    "enumValues": [
                      "re-evaluation-required",
                      "notification-required",
                      "pending-owner-acceptance",
                      "accepted",
                      "rejected",
                      "redirected",
                      "expired",
                      "outcome-unknown",
                      "completed",
                      "reopened",
                      "not-affected"
                    ],
                    "id": "disposition",
                    "label": "Disposition",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "affected-items",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Cross-owner request submitted for this exact affected record version.",
                    "id": "handoff-action-proposal-id",
                    "label": "Handoff action proposal ID",
                    "nullable": true,
                    "referenceEntityId": "action-proposal",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the impact item to its exact cross-owner proposal.",
                      "id": "policy-change-impact-affected-items-handoff-action-proposal-id",
                      "introducedIn": "4.3.0",
                      "required": false,
                      "targetFieldId": "action-proposal-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "affected-items",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Receiving-owner acknowledgement decision for this affected record version.",
                    "id": "handoff-decision-id",
                    "label": "Handoff decision ID",
                    "nullable": true,
                    "referenceEntityId": "decision",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the impact item to the receiver's exact acknowledgement decision.",
                      "id": "policy-change-impact-affected-items-handoff-decision-id",
                      "introducedIn": "4.3.0",
                      "required": false,
                      "targetFieldId": "decision-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "affected-items",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Immutable transport or processing receipt for this item; it never substitutes for owner acceptance or completion.",
                    "id": "handoff-receipt-business-event-id",
                    "label": "Handoff receipt business event ID",
                    "nullable": true,
                    "referenceEntityId": "business-event",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the impact item to its immutable handoff delivery or processing receipt.",
                      "id": "policy-change-impact-affected-items-handoff-receipt-business-event-id",
                      "introducedIn": "4.3.0",
                      "required": false,
                      "targetFieldId": "business-event-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "affected-items",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "internal",
                    "definition": "Successor owner selected by a redirect disposition, while the original receiving owner and decision remain preserved.",
                    "id": "redirected-to-owner-id",
                    "label": "Redirected to owner ID",
                    "nullable": true,
                    "openVocabularyJustification": "The value is a governed owner registry ID rather than a member of an entity-local closed vocabulary.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "affected-items",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Evidence-linked reason explaining the current item disposition.",
                    "id": "disposition-reason",
                    "label": "Disposition reason",
                    "nullable": true,
                    "openVocabularyJustification": "The value is an evidence-linked case explanation rather than a reusable vocabulary member.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "affected-items",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "internal",
                    "definition": "UTC time the affected owner verified the required re-evaluation, notification or successor outcome for this item.",
                    "id": "completed-at",
                    "label": "Completed at",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "affected-items",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  }
                ],
                "uniqueBy": [
                  "impact-item-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Exact envelope authorising publication, handoff, closure, expiry or reopening of this policy impact case.",
            "exchangeScope": "internal",
            "id": "authority-envelope-id",
            "introducedIn": "4.3.0",
            "label": "Authority envelope ID",
            "nullable": false,
            "referenceEntityId": "authority-envelope",
            "required": true,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "UTC deadline for unresolved affected-item dispositions; expiry remains visible and can later be reopened.",
            "exchangeScope": "internal",
            "format": "ISO 8601 UTC",
            "id": "expires-at",
            "introducedIn": "4.3.0",
            "label": "Expires at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Closed or expired predecessor reopened after a changed, failed or unknown affected-owner outcome; the predecessor remains immutable evidence.",
            "exchangeScope": "internal",
            "id": "reopened-from-policy-change-impact-id",
            "introducedIn": "4.3.0",
            "label": "Reopened from policy change impact ID",
            "nullable": true,
            "referenceEntityId": "policy-change-impact",
            "required": false,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "UTC time all non-excluded affected items reached verified completion under this exact rule-release impact snapshot.",
            "exchangeScope": "internal",
            "format": "ISO 8601 UTC",
            "id": "completed-at",
            "introducedIn": "4.3.0",
            "label": "Completed at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "policy-rule-lifecycle",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "policy-change-impact",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "policy-change-impact-id"
            ],
            "id": "policy-change-impact-primary",
            "introducedIn": "4.3.0",
            "unique": true
          },
          {
            "fieldIds": [
              "policy-rule-release-id",
              "lifecycle-state"
            ],
            "id": "policy-change-impact-by-policy-rule-release-and-status",
            "introducedIn": "4.3.0",
            "unique": false
          },
          {
            "fieldIds": [
              "affected-owner-ids",
              "lifecycle-state"
            ],
            "id": "policy-change-impact-by-affected-owner-and-status",
            "introducedIn": "4.3.0",
            "unique": false
          },
          {
            "fieldIds": [
              "expires-at",
              "lifecycle-state"
            ],
            "id": "policy-change-impact-by-expiry-and-status",
            "introducedIn": "4.3.0",
            "unique": false
          }
        ],
        "introducedIn": "4.3.0",
        "kind": "case",
        "label": "Policy change impact",
        "lifecycle": [
          "assessing",
          "open",
          "handoffs-pending",
          "reconciling",
          "closed",
          "expired",
          "reopened",
          "superseded"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "policy-rule-lifecycle",
        "owningDomainWorkblockId": "strategy-policy-category-spend",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Policy change impacts",
        "primaryKey": "policy-change-impact-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Binds the impact cohort to the exact rule release that caused it.",
            "id": "policy-change-impact-governed-by-policy-rule-release-impact-release",
            "introducedIn": "4.3.0",
            "predicate": "governed-by",
            "qualifiedId": "policy-change-impact-governed-by-policy-rule-release-impact-release",
            "required": true,
            "sourceFieldId": "policy-rule-release-id",
            "targetEntityId": "policy-rule-release",
            "targetFieldId": "policy-rule-release-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the impact calculation to the predecessor release used for comparison.",
            "id": "policy-change-impact-references-policy-rule-release-prior-release",
            "introducedIn": "4.3.0",
            "predicate": "references",
            "qualifiedId": "policy-change-impact-references-policy-rule-release-prior-release",
            "required": false,
            "sourceFieldId": "prior-policy-rule-release-id",
            "targetEntityId": "policy-rule-release",
            "targetFieldId": "policy-rule-release-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the impact record to its frozen, integrity-protected cohort snapshot.",
            "id": "policy-change-impact-evidenced-by-evidence-item-impact-snapshot",
            "introducedIn": "4.3.0",
            "predicate": "evidenced-by",
            "qualifiedId": "policy-change-impact-evidenced-by-evidence-item-impact-snapshot",
            "required": true,
            "sourceFieldId": "impact-snapshot-evidence-item-id",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links inclusion, disposition and closure to their governed evidence items.",
            "id": "policy-change-impact-evidenced-by-evidence-item-impact-evidence",
            "introducedIn": "4.3.0",
            "predicate": "evidenced-by",
            "qualifiedId": "policy-change-impact-evidenced-by-evidence-item-impact-evidence",
            "required": true,
            "sourceFieldId": "impact-evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Binds consequential impact publication, handoff and closure to the exact authority envelope.",
            "id": "policy-change-impact-governed-by-authority-envelope-impact-authority",
            "introducedIn": "4.3.0",
            "predicate": "governed-by",
            "qualifiedId": "policy-change-impact-governed-by-authority-envelope-impact-authority",
            "required": true,
            "sourceFieldId": "authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links a reopened impact case to the exact closed or expired predecessor.",
            "id": "policy-change-impact-references-policy-change-impact-reopened-predecessor",
            "introducedIn": "4.3.0",
            "predicate": "references",
            "qualifiedId": "policy-change-impact-references-policy-change-impact-reopened-predecessor",
            "required": false,
            "sourceFieldId": "reopened-from-policy-change-impact-id",
            "targetEntityId": "policy-change-impact",
            "targetFieldId": "policy-change-impact-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "policy change impact",
          "affected cohort",
          "rule release impact",
          "consumer disposition",
          "closure receipt"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Which authorised records and owners are affected by this policy rule release?",
              "Which receiving-owner dispositions and handoff receipts remain unresolved for this impact case?",
              "Can this impact case close, expire or reopen under its frozen evidence and authority?"
            ],
            "retrievalTerms": [
              "rule release assessment",
              "affected record cohort",
              "re-evaluation closure",
              "reopen predecessor"
            ],
            "usage": "Create and update a policy-change-impact when a rule release changes the treatment of permission-visible records; keep each owner disposition and receipt linked, and never mutate an affected record through the impact case."
          },
          "introducedIn": "4.7.0",
          "semanticLabel": {
            "aliases": [
              "policy impact case",
              "impact cohort",
              "owner disposition case"
            ],
            "concept": "policy-impact-case",
            "doNotConfuseWith": [
              {
                "distinction": "A policy-change-impact freezes the affected record cohort and tracks owner dispositions; a policy-rule-release is the versioned rule change that caused the impact.",
                "targetEntityId": "policy-rule-release"
              },
              {
                "distinction": "A policy-change-impact owns the affected cohort and closure lifecycle; an action-proposal is one cross-owner request within that lifecycle.",
                "targetEntityId": "action-proposal"
              }
            ]
          }
        },
        "sourceSystemRoleIds": [
          "system-of-record",
          "evidence-source",
          "execution-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": []
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "sourcing-event",
          "negotiation-copilot",
          "tactical-sourcing-autonomy"
        ],
        "definition": "A sourcing-pipeline-owned, authority-decided mandate that pins an opportunity version to a volume band, buy window, price ceiling, evidence dates and expiry without treating a routed scenario as an accepted mandate.",
        "domainWorkblockIds": [
          "sourcing-negotiation"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable identifier for one mandate revision and its authority disposition.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "buy-timing-mandate-id",
            "introducedIn": "4.3.0",
            "label": "Buy timing mandate ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Sourcing opportunity whose exact current record version is pinned by the common record envelope provenance for this mandate revision.",
            "exchangeScope": "internal",
            "id": "sourcing-opportunity-id",
            "introducedIn": "4.3.0",
            "label": "Sourcing opportunity ID",
            "nullable": false,
            "referenceEntityId": "sourcing-opportunity",
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Monotonic positive revision within the sourcing opportunity's mandate history.",
            "exchangeScope": "internal",
            "format": "positive integer",
            "id": "revision-number",
            "introducedIn": "4.3.0",
            "label": "Revision number",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "integer"
          },
          {
            "classification": "confidential",
            "definition": "Inclusive lower and upper volume bounds, unit and definition version used to interpret this mandate; at least one bound must be present and a missing bound means unbounded rather than zero.",
            "exchangeScope": "internal",
            "id": "volume-band",
            "introducedIn": "4.3.0",
            "label": "Volume band",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Optional inclusive lower bound; absence means the band is unbounded below and never means zero.",
                    "id": "minimum-volume",
                    "label": "Minimum volume",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "volume-band",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Optional inclusive upper bound; absence means the band is unbounded above.",
                    "id": "maximum-volume",
                    "label": "Maximum volume",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "volume-band",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "internal",
                    "definition": "Governed measurement unit applying to both volume bounds.",
                    "id": "unit-code",
                    "label": "Unit code",
                    "nullable": false,
                    "openVocabularyJustification": "The configured measurement profile governs the unit vocabulary and its source standard.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "volume-band",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "internal",
                    "definition": "Semantic version of the volume-band business definition and unit interpretation.",
                    "format": "semantic version",
                    "id": "definition-version",
                    "label": "Definition version",
                    "nullable": false,
                    "openVocabularyJustification": "The value is the owner-controlled semantic version of this field definition.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "volume-band",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Inclusive first business date on which the authorised buy timing may be acted on.",
            "exchangeScope": "internal",
            "format": "date",
            "id": "buy-window-start-date",
            "introducedIn": "4.3.0",
            "label": "Buy window start date",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "confidential",
            "definition": "Inclusive last business date on which the accepted mandate remains actionable before expiry or revision.",
            "exchangeScope": "internal",
            "format": "date",
            "id": "buy-window-end-date",
            "introducedIn": "4.3.0",
            "label": "Buy window end date",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "restricted",
            "compositeValueContract": {
              "componentFieldIds": [
                "price-ceiling"
              ],
              "representation": "registry-object",
              "schemaId": "money-value",
              "schemaVersion": "2.0.0"
            },
            "definition": "Maximum authorised amount and currency for the declared volume band and buy window, with explicit definition version and rounding.",
            "exchangeScope": "internal",
            "id": "price-ceiling",
            "introducedIn": "4.3.0",
            "label": "Price ceiling",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "money",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "money-value",
              "schemaVersion": "2.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Inclusive earliest source date represented in the demand, market and commercial inputs used for this mandate revision.",
            "exchangeScope": "internal",
            "format": "date",
            "id": "source-period-start",
            "introducedIn": "4.3.0",
            "label": "Source period start",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "internal",
            "definition": "Inclusive latest source date represented in the inputs; it is distinct from evidence capture and mandate expiry.",
            "exchangeScope": "internal",
            "format": "date",
            "id": "source-period-end",
            "introducedIn": "4.3.0",
            "label": "Source period end",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "internal",
            "definition": "UTC time through which all mandate evidence was observed and reviewed for this revision.",
            "exchangeScope": "internal",
            "format": "ISO 8601 UTC",
            "id": "evidence-as-of",
            "introducedIn": "4.3.0",
            "label": "Evidence as of",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "confidential",
            "definition": "Versioned demand, market, commercial and scenario evidence submitted to the named authority for this exact revision.",
            "exchangeScope": "internal",
            "id": "evidence-item-ids",
            "introducedIn": "4.3.0",
            "label": "Evidence item IDs",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "UTC time after which this revision cannot govern a new sourcing commitment and must be renewed or superseded.",
            "exchangeScope": "internal",
            "format": "ISO 8601 UTC",
            "id": "expires-at",
            "introducedIn": "4.3.0",
            "label": "Expires at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Exact authority envelope permitting the named authority to accept, revise or decline this mandate revision.",
            "exchangeScope": "internal",
            "id": "authority-envelope-id",
            "introducedIn": "4.3.0",
            "label": "Authority envelope ID",
            "nullable": false,
            "referenceEntityId": "authority-envelope",
            "required": true,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Durable named-authority decision accepting, requesting revision or declining this mandate; absence means it remains proposed.",
            "exchangeScope": "internal",
            "id": "authority-decision-id",
            "introducedIn": "4.3.0",
            "label": "Authority decision ID",
            "nullable": true,
            "referenceEntityId": "decision",
            "required": false,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "UTC time the named authority recorded its disposition for this exact revision.",
            "exchangeScope": "internal",
            "format": "ISO 8601 UTC",
            "id": "decided-at",
            "introducedIn": "4.3.0",
            "label": "Decided at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Immediate predecessor revision replaced by this mandate; accepted historical decisions remain addressable and are never rewritten.",
            "exchangeScope": "internal",
            "id": "supersedes-buy-timing-mandate-id",
            "introducedIn": "4.3.0",
            "label": "Supersedes buy timing mandate ID",
            "nullable": true,
            "referenceEntityId": "buy-timing-mandate",
            "required": false,
            "sourceAuthority": {
              "id": "sourcing-pipeline-discovery",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "buy-timing-mandate",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "buy-timing-mandate-id"
            ],
            "id": "buy-timing-mandate-primary",
            "introducedIn": "4.3.0",
            "unique": true
          },
          {
            "fieldIds": [
              "sourcing-opportunity-id",
              "revision-number"
            ],
            "id": "buy-timing-mandate-by-opportunity-and-revision",
            "introducedIn": "4.3.0",
            "unique": true
          },
          {
            "fieldIds": [
              "lifecycle-state",
              "expires-at"
            ],
            "id": "buy-timing-mandate-by-status-and-expiry",
            "introducedIn": "4.3.0",
            "unique": false
          },
          {
            "fieldIds": [
              "authority-decision-id"
            ],
            "id": "buy-timing-mandate-by-authority-decision",
            "introducedIn": "4.3.0",
            "unique": false
          }
        ],
        "introducedIn": "4.3.0",
        "kind": "decision",
        "label": "Buy timing mandate",
        "lifecycle": [
          "proposed",
          "accepted",
          "revision-requested",
          "declined",
          "expired",
          "superseded",
          "withdrawn"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "sourcing-pipeline-discovery",
        "owningDomainWorkblockId": "sourcing-negotiation",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Buy timing mandates",
        "primaryKey": "buy-timing-mandate-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Binds each mandate revision to its sourcing opportunity.",
            "id": "buy-timing-mandate-belongs-to-sourcing-opportunity-mandate-opportunity",
            "introducedIn": "4.3.0",
            "predicate": "belongs-to",
            "qualifiedId": "buy-timing-mandate-belongs-to-sourcing-opportunity-mandate-opportunity",
            "required": true,
            "sourceFieldId": "sourcing-opportunity-id",
            "targetEntityId": "sourcing-opportunity",
            "targetFieldId": "sourcing-opportunity-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the mandate revision to the evidence set considered by the authority.",
            "id": "buy-timing-mandate-evidenced-by-evidence-item-mandate-evidence",
            "introducedIn": "4.3.0",
            "predicate": "evidenced-by",
            "qualifiedId": "buy-timing-mandate-evidenced-by-evidence-item-mandate-evidence",
            "required": true,
            "sourceFieldId": "evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Binds acceptance, revision or decline to the exact authority envelope.",
            "id": "buy-timing-mandate-governed-by-authority-envelope-mandate-authority",
            "introducedIn": "4.3.0",
            "predicate": "governed-by",
            "qualifiedId": "buy-timing-mandate-governed-by-authority-envelope-mandate-authority",
            "required": true,
            "sourceFieldId": "authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "one-to-one",
            "definition": "Links the mandate revision to its named-authority disposition decision.",
            "id": "buy-timing-mandate-governed-by-decision-mandate-disposition",
            "introducedIn": "4.3.0",
            "predicate": "governed-by",
            "qualifiedId": "buy-timing-mandate-governed-by-decision-mandate-disposition",
            "required": false,
            "sourceFieldId": "authority-decision-id",
            "targetEntityId": "decision",
            "targetFieldId": "decision-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links a revised mandate to the exact predecessor it supersedes.",
            "id": "buy-timing-mandate-supersedes-buy-timing-mandate-mandate-predecessor",
            "introducedIn": "4.3.0",
            "predicate": "supersedes",
            "qualifiedId": "buy-timing-mandate-supersedes-buy-timing-mandate-mandate-predecessor",
            "required": false,
            "sourceFieldId": "supersedes-buy-timing-mandate-id",
            "targetEntityId": "buy-timing-mandate",
            "targetFieldId": "buy-timing-mandate-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "buy timing mandate",
          "buy window",
          "volume band",
          "price ceiling",
          "authority disposition"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "What volume band, buy window, price ceiling and source period are authorised for this opportunity?",
              "Which authority decided this mandate, on which evidence version and before which expiry?",
              "Is this mandate accepted, revision-requested, declined, expired or superseded, and what successor preserves its history?"
            ],
            "retrievalTerms": [
              "purchase timing",
              "price ceiling",
              "source period",
              "mandate revision"
            ],
            "usage": "Create and revise a buy-timing-mandate from a versioned sourcing opportunity and evidence; record the named authority decision and never treat a scenario or acceptance as a launched sourcing action."
          },
          "introducedIn": "4.7.0",
          "semanticLabel": {
            "aliases": [
              "buy timing decision",
              "buy window decision",
              "volume-band decision"
            ],
            "concept": "bounded-buy-timing-decision",
            "doNotConfuseWith": [
              {
                "distinction": "A buy-timing-mandate records bounded timing terms and an authority disposition; a sourcing-opportunity is the opportunity being considered and can exist before a mandate.",
                "targetEntityId": "sourcing-opportunity"
              },
              {
                "distinction": "A buy-timing-mandate records commercial bounds for one opportunity; an authority-envelope grants permitted actions and thresholds across its scope.",
                "targetEntityId": "authority-envelope"
              }
            ]
          }
        },
        "sourceSystemRoleIds": [
          "planning-system",
          "evidence-source",
          "analytical-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": []
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "contract-authoring-review"
        ],
        "definition": "A governed request to ingest, classify and establish the authoritative source set for an agreement before drafting or review begins.",
        "domainWorkblockIds": [
          "contract-lifecycle-management"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable tenant-scoped identifier for the intake case.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "contract-intake-id",
            "introducedIn": "1.0.0",
            "label": "Contract intake ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-intake-digitization",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Identifier supplied by the request channel or source repository for reconciliation.",
            "exchangeScope": "mapped",
            "id": "external-reference",
            "introducedIn": "1.0.0",
            "label": "External reference",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "contract-intake-digitization",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "tender-contract",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Canonical contract linked after identity resolution; null while the intake may represent a new agreement.",
            "exchangeScope": "internal",
            "id": "candidate-contract-id",
            "introducedIn": "1.0.0",
            "label": "Candidate contract ID",
            "nullable": true,
            "referenceEntityId": "contract",
            "required": false,
            "sourceAuthority": {
              "id": "contract-intake-digitization",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Ordered references to immutable source documents and attachments held in blob storage.",
            "exchangeScope": "mapped",
            "id": "source-artifact-ids",
            "introducedIn": "1.0.0",
            "label": "Source artifact references",
            "listSemantics": "ordered",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "contract-intake-digitization",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "tender-contract",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ContractDocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Calibrated confidence for the complete extracted record, never a substitute for field-level provenance.",
            "exchangeScope": "internal",
            "format": "0..1",
            "id": "extraction-confidence",
            "introducedIn": "1.0.0",
            "label": "Extraction confidence",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "contract-intake-digitization",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "decimal"
          },
          {
            "classification": "internal",
            "definition": "Timestamp at which the intake first entered the governed workflow.",
            "exchangeScope": "mapped",
            "format": "date-time",
            "id": "received-at",
            "introducedIn": "1.0.0",
            "label": "Received at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-intake-digitization",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "tender-contract",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:IssueDate|cbc:IssueTime",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Timestamp of the latest committed intake mutation.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "updated-at",
            "introducedIn": "1.0.0",
            "label": "Updated at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-intake-digitization",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Authority envelope governing proposals, approvals and commitments for this record.",
            "exchangeScope": "unmapped",
            "id": "governance-authority-envelope-id",
            "introducedIn": "4.0.0",
            "label": "Governance authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "contract-intake-digitization",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "contract-intake",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "external-reference"
            ],
            "id": "contract-intake-by-external-reference",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "lifecycle-state",
              "received-at"
            ],
            "id": "contract-intake-by-status-and-received-at",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "candidate-contract-id"
            ],
            "id": "contract-intake-by-candidate-contract-id",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "case",
        "label": "Contract intake",
        "lifecycle": [
          "received",
          "extracting",
          "needs-evidence",
          "ready",
          "superseded",
          "closed"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "contract-intake-digitization",
        "owningDomainWorkblockId": "contract-lifecycle-management",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Contract intakes",
        "primaryKey": "contract-intake-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links an intake to the canonical agreement it created or refreshed.",
            "id": "contract-intake-belongs-to-contract-resolved-contract",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "contract-intake-belongs-to-contract-resolved-contract",
            "required": false,
            "sourceFieldId": "candidate-contract-id",
            "targetEntityId": "contract",
            "targetFieldId": "contract-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links contract intakes to the governed evidence item record referenced by source artifact references.",
            "id": "contract-intake-evidenced-by-evidence-item-source-artifact-ids-to-evidence-item",
            "introducedIn": "1.1.0",
            "predicate": "evidenced-by",
            "qualifiedId": "contract-intake-evidenced-by-evidence-item-source-artifact-ids-to-evidence-item",
            "required": true,
            "sourceFieldId": "source-artifact-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authority envelope governing this record.",
            "id": "contract-intake-governed-by-authority-envelope-contract-intake-governance-authority",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "contract-intake-governed-by-authority-envelope-contract-intake-governance-authority",
            "required": false,
            "sourceFieldId": "governance-authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "contract request",
          "agreement intake",
          "digitisation",
          "source document"
        ],
        "sourceSystemRoleIds": [
          "collaboration-channel",
          "evidence-source",
          "execution-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "contract-authoring-review",
          "contract-intake-digitization",
          "guided-buying",
          "obligation-monitoring",
          "purchase-order-orchestration",
          "renewal-change-compliance",
          "supplier-remediation-exit"
        ],
        "definition": "The canonical agreement identity and lifecycle header, distinct from each immutable contractual version and its source artifacts.",
        "domainWorkblockIds": [
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable tenant-scoped identifier for the agreement across versions and systems.",
            "exchangeScope": "unmapped",
            "format": "uuid",
            "id": "contract-id",
            "introducedIn": "1.0.0",
            "label": "Contract ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-approval-repository",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Human-facing governed agreement number.",
            "exchangeScope": "mapped",
            "id": "contract-number",
            "introducedIn": "1.0.0",
            "label": "Contract number",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-approval-repository",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "tender-contract",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Concise agreement title suitable for search and work queues.",
            "exchangeScope": "mapped",
            "id": "title",
            "introducedIn": "1.0.0",
            "label": "Title",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-approval-repository",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "tender-contract",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ContractName",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Canonical supplier identifier for the principal external contracting party.",
            "exchangeScope": "mapped",
            "id": "supplier-id",
            "introducedIn": "1.0.0",
            "label": "Supplier reference",
            "nullable": true,
            "referenceEntityId": "supplier-profile",
            "required": false,
            "sourceAuthority": {
              "id": "contract-approval-repository",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "tender-contract",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "The economic operator is the external contracting party; its exchange identifier must be resolved to the canonical supplier reference.",
                "path": "cac:EconomicOperatorParty/cac:Party/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Optional agreement governing this agreement in a contract hierarchy.",
            "exchangeScope": "mapped",
            "id": "parent-contract-id",
            "introducedIn": "1.0.0",
            "label": "Parent contract ID",
            "nullable": true,
            "referenceEntityId": "contract",
            "required": false,
            "sourceAuthority": {
              "id": "contract-approval-repository",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "tender-contract",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ContractDocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Immutable contract version currently effective or governing the active draft.",
            "exchangeScope": "unmapped",
            "id": "current-version-id",
            "introducedIn": "1.0.0",
            "label": "Current version ID",
            "nullable": true,
            "referenceEntityId": "contract-version",
            "required": false,
            "sourceAuthority": {
              "id": "contract-approval-repository",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Date on which the agreement begins to govern.",
            "exchangeScope": "mapped",
            "format": "date",
            "id": "effective-date",
            "introducedIn": "1.0.0",
            "label": "Effective date",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "contract-approval-repository",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "tender-contract",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:TenderResult/cac:Contract/cac:ValidityPeriod/cbc:StartDate",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "date"
          },
          {
            "classification": "confidential",
            "definition": "Current scheduled end date before any exercised renewal or termination.",
            "exchangeScope": "mapped",
            "format": "date",
            "id": "expiry-date",
            "introducedIn": "1.0.0",
            "label": "Expiry date",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "contract-approval-repository",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "tender-contract",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:TenderResult/cac:Contract/cac:ValidityPeriod/cbc:EndDate",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "date"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "contract",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "contract-number"
            ],
            "id": "contract-by-contract-number",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "lifecycle-state",
              "effective-date"
            ],
            "id": "contract-by-status-and-effective-date",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "supplier-id"
            ],
            "id": "contract-by-supplier-reference",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "parent-contract-id"
            ],
            "id": "contract-by-parent-contract-id",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "document",
        "label": "Contract",
        "lifecycle": [
          "draft",
          "in-review",
          "approved",
          "executed",
          "active",
          "expired",
          "terminated",
          "archived"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "contract-approval-repository",
        "owningDomainWorkblockId": "contract-lifecycle-management",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Contracts",
        "primaryKey": "contract-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "one-to-one",
            "definition": "Selects the currently governing immutable contract version.",
            "id": "contract-references-contract-version-current-version",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "contract-references-contract-version-current-version",
            "required": false,
            "sourceFieldId": "current-version-id",
            "targetEntityId": "contract-version",
            "targetFieldId": "contract-version-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Connects related agreements into an explicit hierarchy.",
            "id": "contract-belongs-to-contract-parent-contract",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "contract-belongs-to-contract-parent-contract",
            "required": false,
            "sourceFieldId": "parent-contract-id",
            "targetEntityId": "contract",
            "targetFieldId": "contract-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the agreement to the canonical supplier party.",
            "id": "contract-belongs-to-supplier-profile-principal-supplier",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "contract-belongs-to-supplier-profile-principal-supplier",
            "required": false,
            "sourceFieldId": "supplier-id",
            "targetEntityId": "supplier-profile",
            "targetFieldId": "supplier-profile-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "agreement",
          "contract",
          "executed agreement",
          "master agreement"
        ],
        "sourceSystemRoleIds": [
          "system-of-record",
          "execution-system",
          "planning-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record",
          "planning-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "contract-approval-repository",
          "obligation-monitoring",
          "renewal-change-compliance"
        ],
        "definition": "An immutable, content-addressed version of an agreement with its structured terms, source artifact and approval provenance.",
        "domainWorkblockIds": [
          "contract-lifecycle-management"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable identifier for this immutable contract version.",
            "exchangeScope": "unmapped",
            "format": "uuid",
            "id": "contract-version-id",
            "introducedIn": "1.0.0",
            "label": "Contract version ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Agreement identity to which this version belongs.",
            "exchangeScope": "mapped",
            "id": "contract-id",
            "introducedIn": "1.0.0",
            "label": "Contract ID",
            "nullable": false,
            "referenceEntityId": "contract",
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "tender-contract",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Monotonic business version number within the agreement.",
            "exchangeScope": "mapped",
            "id": "version-number",
            "introducedIn": "1.0.0",
            "label": "Version number",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "tender-contract",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "UBL carries the embedded contract version; the canonical immutable contract-version identity remains GroundWorks data.",
                "path": "cac:TenderResult/cac:Contract/cbc:VersionID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "integer"
          },
          {
            "classification": "restricted",
            "definition": "Version from which this version was derived.",
            "exchangeScope": "unmapped",
            "id": "parent-version-id",
            "introducedIn": "1.0.0",
            "label": "Parent version ID",
            "nullable": true,
            "referenceEntityId": "contract-version",
            "required": false,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Reference to the immutable native-format contract artifact in blob storage.",
            "exchangeScope": "mapped",
            "id": "artifact-id",
            "introducedIn": "1.0.0",
            "label": "Artifact reference",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "tender-contract",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ContractDocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Cryptographic digest used to detect content change and bind approvals to exact text.",
            "exchangeScope": "mapped",
            "format": "sha-256",
            "id": "content-hash",
            "introducedIn": "1.0.0",
            "label": "Content hash",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "tender-contract",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:Signature/cac:DigitalSignatureAttachment/cac:ExternalReference/cbc:DocumentHash",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Versioned legal and commercial playbook used for review.",
            "exchangeScope": "unmapped",
            "id": "playbook-version",
            "introducedIn": "1.0.0",
            "label": "Playbook version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Timestamp when this immutable version was committed.",
            "exchangeScope": "unmapped",
            "format": "date-time",
            "id": "committed-at",
            "introducedIn": "1.0.0",
            "label": "Committed at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "contract-version",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "contract-id",
              "version-number"
            ],
            "id": "contract-version-by-contract-id-and-version-number",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "content-hash"
            ],
            "id": "contract-version-by-content-hash",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "lifecycle-state"
            ],
            "id": "contract-version-by-status",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "document",
        "label": "Contract version",
        "lifecycle": [
          "draft",
          "proposed",
          "approved",
          "executed",
          "superseded",
          "void"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "contract-authoring-review",
        "owningDomainWorkblockId": "contract-lifecycle-management",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Contract versions",
        "primaryKey": "contract-version-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Associates the immutable version with its agreement identity.",
            "id": "contract-version-belongs-to-contract-version-of-contract",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "contract-version-belongs-to-contract-version-of-contract",
            "required": true,
            "sourceFieldId": "contract-id",
            "targetEntityId": "contract",
            "targetFieldId": "contract-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Creates an auditable version lineage.",
            "id": "contract-version-derived-from-contract-version-derived-from-version",
            "introducedIn": "1.0.0",
            "predicate": "derived-from",
            "qualifiedId": "contract-version-derived-from-contract-version-derived-from-version",
            "required": false,
            "sourceFieldId": "parent-version-id",
            "targetEntityId": "contract-version",
            "targetFieldId": "contract-version-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links contract versions to the governed evidence item record referenced by artifact reference.",
            "id": "contract-version-evidenced-by-evidence-item-artifact-id-to-evidence-item",
            "introducedIn": "1.1.0",
            "predicate": "evidenced-by",
            "qualifiedId": "contract-version-evidenced-by-evidence-item-artifact-id-to-evidence-item",
            "required": true,
            "sourceFieldId": "artifact-id",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "contract draft",
          "executed version",
          "redline",
          "agreement version"
        ],
        "sourceSystemRoleIds": [
          "collaboration-channel",
          "system-of-record",
          "execution-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record",
          "execution-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "contract-approval-repository",
          "contract-intake-digitization"
        ],
        "definition": "A reusable, approved and content-addressed agreement template whose applicability, effective period and source artifact are governed independently of any individual contract version.",
        "domainWorkblockIds": [
          "contract-lifecycle-management"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable identifier for this immutable template version.",
            "exchangeScope": "unmapped",
            "format": "uuid",
            "id": "contract-template-id",
            "introducedIn": "2.1.0",
            "label": "Contract template ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Stable business code grouping successive versions of the same reusable agreement form.",
            "exchangeScope": "unmapped",
            "id": "template-code",
            "introducedIn": "2.1.0",
            "label": "Template code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Version of the template contract used for compatibility, release and rollback.",
            "exchangeScope": "unmapped",
            "format": "SemVer",
            "id": "semantic-version",
            "introducedIn": "2.1.0",
            "label": "Semantic version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Human-readable name of the reusable agreement template.",
            "exchangeScope": "unmapped",
            "id": "title",
            "introducedIn": "2.1.0",
            "label": "Title",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Reference to the immutable native-format template artifact held outside rowstore.",
            "exchangeScope": "unmapped",
            "id": "artifact-id",
            "introducedIn": "2.1.0",
            "label": "Artifact reference",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Cryptographic digest binding approval and use to exact template content.",
            "exchangeScope": "unmapped",
            "format": "sha-256",
            "id": "content-hash",
            "introducedIn": "2.1.0",
            "label": "Content hash",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Exact policy or playbook release under which the template was reviewed and approved.",
            "exchangeScope": "unmapped",
            "id": "policy-version-id",
            "introducedIn": "2.1.0",
            "label": "Policy version ID",
            "nullable": false,
            "referenceEntityId": "policy-version",
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Versioned, inspectable conditions such as agreement type, jurisdiction, category and value band that determine permitted template use.",
            "exchangeScope": "unmapped",
            "id": "applicability-rules",
            "introducedIn": "2.1.0",
            "label": "Applicability rules",
            "listSemantics": "set",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string-list"
          },
          {
            "classification": "internal",
            "definition": "First UTC instant at which this template version may be selected for a new contract.",
            "exchangeScope": "unmapped",
            "format": "date-time",
            "id": "effective-from",
            "introducedIn": "2.1.0",
            "label": "Effective from",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Optional final UTC instant of template applicability.",
            "exchangeScope": "unmapped",
            "format": "date-time",
            "id": "effective-to",
            "introducedIn": "2.1.0",
            "label": "Effective to",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Governed decision that authorised this exact template content and applicability contract.",
            "exchangeScope": "unmapped",
            "id": "approval-decision-id",
            "introducedIn": "2.1.0",
            "label": "Approval decision ID",
            "nullable": false,
            "referenceEntityId": "decision",
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "contract-template",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "template-code",
              "semantic-version"
            ],
            "id": "contract-template-by-template-code-and-semantic-version",
            "introducedIn": "2.1.0",
            "unique": false
          },
          {
            "fieldIds": [
              "lifecycle-state",
              "effective-from"
            ],
            "id": "contract-template-by-status-and-effective-from",
            "introducedIn": "2.1.0",
            "unique": false
          },
          {
            "fieldIds": [
              "content-hash"
            ],
            "id": "contract-template-by-content-hash",
            "introducedIn": "2.1.0",
            "unique": false
          }
        ],
        "introducedIn": "2.1.0",
        "kind": "document",
        "label": "Contract template",
        "lifecycle": [
          "draft",
          "in-review",
          "approved",
          "active",
          "superseded",
          "retired"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "contract-authoring-review",
        "owningDomainWorkblockId": "contract-lifecycle-management",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Contract templates",
        "primaryKey": "contract-template-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the template record to its immutable native artifact.",
            "id": "contract-template-evidenced-by-evidence-item-template-artifact",
            "introducedIn": "2.1.0",
            "predicate": "evidenced-by",
            "qualifiedId": "contract-template-evidenced-by-evidence-item-template-artifact",
            "required": true,
            "sourceFieldId": "artifact-id",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Pins template review and applicability to an exact policy release.",
            "id": "contract-template-governed-by-policy-version-template-policy-version",
            "introducedIn": "2.1.0",
            "predicate": "governed-by",
            "qualifiedId": "contract-template-governed-by-policy-version-template-policy-version",
            "required": true,
            "sourceFieldId": "policy-version-id",
            "targetEntityId": "policy-version",
            "targetFieldId": "policy-version-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Binds activation to a governed decision for exact template content.",
            "id": "contract-template-references-decision-template-approval-decision",
            "introducedIn": "2.1.0",
            "predicate": "references",
            "qualifiedId": "contract-template-references-decision-template-approval-decision",
            "required": true,
            "sourceFieldId": "approval-decision-id",
            "targetEntityId": "decision",
            "targetFieldId": "decision-id"
          }
        ],
        "retentionClass": "policy",
        "searchTerms": [
          "agreement template",
          "contract template",
          "approved form",
          "standard agreement"
        ],
        "sourceSystemRoleIds": [
          "collaboration-channel",
          "system-of-record"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "obligation-monitoring",
          "renewal-change-compliance"
        ],
        "definition": "An approved, reusable and versioned clause position with exact text, applicability, jurisdiction, policy provenance and semantic tags independent of any one agreement.",
        "domainWorkblockIds": [
          "contract-lifecycle-management"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable identifier for this immutable clause version.",
            "exchangeScope": "unmapped",
            "format": "uuid",
            "id": "clause-library-entry-id",
            "introducedIn": "2.1.0",
            "label": "Clause library entry ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Stable business code grouping successive versions of the same clause position.",
            "exchangeScope": "unmapped",
            "id": "clause-code",
            "introducedIn": "2.1.0",
            "label": "Clause code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Version of clause text and applicability used for exact selection and rollback.",
            "exchangeScope": "unmapped",
            "format": "SemVer",
            "id": "semantic-version",
            "introducedIn": "2.1.0",
            "label": "Semantic version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Human-readable clause name.",
            "exchangeScope": "unmapped",
            "id": "title",
            "introducedIn": "2.1.0",
            "label": "Title",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Exact approved reusable language for this clause version.",
            "exchangeScope": "unmapped",
            "id": "clause-text",
            "introducedIn": "2.1.0",
            "label": "Clause text",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "text"
          },
          {
            "classification": "internal",
            "definition": "Cryptographic digest binding selection, comparison and decision evidence to exact clause text.",
            "exchangeScope": "unmapped",
            "format": "sha-256",
            "id": "text-hash",
            "introducedIn": "2.1.0",
            "label": "Text hash",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Exact playbook or policy release approving this clause position.",
            "exchangeScope": "unmapped",
            "id": "policy-version-id",
            "introducedIn": "2.1.0",
            "label": "Policy version ID",
            "nullable": false,
            "referenceEntityId": "policy-version",
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Set of governed jurisdiction codes in which the clause may be used.",
            "exchangeScope": "unmapped",
            "id": "jurisdiction-codes",
            "introducedIn": "2.1.0",
            "label": "Jurisdiction codes",
            "listSemantics": "set",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string-list"
          },
          {
            "classification": "internal",
            "definition": "Versioned, inspectable conditions governing when this clause may be proposed or committed.",
            "exchangeScope": "unmapped",
            "id": "applicability-rules",
            "introducedIn": "2.1.0",
            "label": "Applicability rules",
            "listSemantics": "set",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string-list"
          },
          {
            "classification": "internal",
            "definition": "Set of governed clause concepts, including obligation, entitlement, renewal, notice, compliance and remedy classifications.",
            "exchangeScope": "unmapped",
            "id": "semantic-tags",
            "introducedIn": "2.1.0",
            "label": "Semantic tags",
            "listSemantics": "set",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string-list"
          },
          {
            "classification": "internal",
            "definition": "First UTC instant at which this clause version may be selected.",
            "exchangeScope": "unmapped",
            "format": "date-time",
            "id": "effective-from",
            "introducedIn": "2.1.0",
            "label": "Effective from",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Optional final UTC instant of clause applicability.",
            "exchangeScope": "unmapped",
            "format": "date-time",
            "id": "effective-to",
            "introducedIn": "2.1.0",
            "label": "Effective to",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Governed decision that authorised this exact clause version and applicability contract.",
            "exchangeScope": "unmapped",
            "id": "approval-decision-id",
            "introducedIn": "2.1.0",
            "label": "Approval decision ID",
            "nullable": false,
            "referenceEntityId": "decision",
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "clause-library-entry",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "clause-code",
              "semantic-version"
            ],
            "id": "clause-library-entry-by-clause-code-and-semantic-version",
            "introducedIn": "2.1.0",
            "unique": false
          },
          {
            "fieldIds": [
              "lifecycle-state",
              "effective-from"
            ],
            "id": "clause-library-entry-by-status-and-effective-from",
            "introducedIn": "2.1.0",
            "unique": false
          },
          {
            "fieldIds": [
              "jurisdiction-codes"
            ],
            "id": "clause-library-entry-by-jurisdiction-codes",
            "introducedIn": "2.1.0",
            "unique": false
          },
          {
            "fieldIds": [
              "text-hash"
            ],
            "id": "clause-library-entry-by-text-hash",
            "introducedIn": "2.1.0",
            "unique": false
          }
        ],
        "introducedIn": "2.1.0",
        "kind": "document",
        "label": "Clause library entry",
        "lifecycle": [
          "draft",
          "in-review",
          "approved",
          "active",
          "superseded",
          "retired"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "contract-authoring-review",
        "owningDomainWorkblockId": "contract-lifecycle-management",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Clause library entries",
        "primaryKey": "clause-library-entry-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Pins the reusable clause to the exact policy or playbook release approving it.",
            "id": "clause-library-entry-governed-by-policy-version-clause-policy-version",
            "introducedIn": "2.1.0",
            "predicate": "governed-by",
            "qualifiedId": "clause-library-entry-governed-by-policy-version-clause-policy-version",
            "required": true,
            "sourceFieldId": "policy-version-id",
            "targetEntityId": "policy-version",
            "targetFieldId": "policy-version-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Binds publication to a governed decision for exact clause text and applicability.",
            "id": "clause-library-entry-references-decision-clause-approval-decision",
            "introducedIn": "2.1.0",
            "predicate": "references",
            "qualifiedId": "clause-library-entry-references-decision-clause-approval-decision",
            "required": true,
            "sourceFieldId": "approval-decision-id",
            "targetEntityId": "decision",
            "targetFieldId": "decision-id"
          }
        ],
        "retentionClass": "policy",
        "searchTerms": [
          "approved clause",
          "clause library",
          "fallback language",
          "standard provision"
        ],
        "sourceSystemRoleIds": [
          "collaboration-channel",
          "system-of-record"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "contract-approval-repository"
        ],
        "definition": "A source-anchored difference between contractual language and a versioned playbook position, including risk, rationale and resolution.",
        "domainWorkblockIds": [
          "contract-lifecycle-management"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable identifier for the version-specific clause deviation.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "clause-deviation-id",
            "introducedIn": "1.0.0",
            "label": "Deviation ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "restricted",
            "definition": "Exact contract version containing the language.",
            "exchangeScope": "internal",
            "id": "contract-version-id",
            "introducedIn": "1.0.0",
            "label": "Contract version ID",
            "nullable": false,
            "referenceEntityId": "contract-version",
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Stable structural or page-and-span anchor into the source artifact.",
            "exchangeScope": "internal",
            "id": "clause-anchor",
            "introducedIn": "1.0.0",
            "label": "Clause anchor",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Versioned policy position against which the text was evaluated.",
            "exchangeScope": "internal",
            "id": "playbook-rule-id",
            "introducedIn": "1.0.0",
            "label": "Playbook rule ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Policy-calculated consequence band for the deviation.",
            "enumValues": [
              "low",
              "moderate",
              "high",
              "critical"
            ],
            "exchangeScope": "internal",
            "id": "risk-level",
            "introducedIn": "1.0.0",
            "label": "Risk level",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Machine or human proposed replacement text, visibly uncommitted until accepted into a new contract version.",
            "exchangeScope": "internal",
            "id": "proposed-language",
            "introducedIn": "1.0.0",
            "label": "Proposed language",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "text"
          },
          {
            "classification": "restricted",
            "definition": "Evidence-linked explanation for the committed disposition.",
            "exchangeScope": "internal",
            "id": "resolution-rationale",
            "introducedIn": "1.0.0",
            "label": "Resolution rationale",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "text"
          },
          {
            "classification": "internal",
            "definition": "Shared governed decision record that carries authority, rationale and evidence for this domain decision.",
            "exchangeScope": "unmapped",
            "id": "governance-decision-id",
            "introducedIn": "4.0.0",
            "label": "Governance decision ID",
            "nullable": true,
            "referenceEntityId": "decision",
            "required": false,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Authority envelope governing proposals, approvals and commitments for this record.",
            "exchangeScope": "unmapped",
            "id": "governance-authority-envelope-id",
            "introducedIn": "4.0.0",
            "label": "Governance authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Evidence supporting this record and its governed outcome.",
            "exchangeScope": "unmapped",
            "id": "governance-evidence-item-ids",
            "introducedIn": "4.0.0",
            "label": "Governance evidence item IDs",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "contract-authoring-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "clause-deviation",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "contract-version-id",
              "clause-anchor"
            ],
            "id": "clause-deviation-by-contract-version-id-and-clause-anchor",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "risk-level",
              "lifecycle-state"
            ],
            "id": "clause-deviation-by-risk-level-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "playbook-rule-id"
            ],
            "id": "clause-deviation-by-playbook-rule-id",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "decision",
        "label": "Clause deviation",
        "lifecycle": [
          "detected",
          "proposed",
          "accepted",
          "rejected",
          "revised",
          "superseded"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "contract-authoring-review",
        "owningDomainWorkblockId": "contract-lifecycle-management",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Clause deviations",
        "primaryKey": "clause-deviation-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Binds the deviation to exact reviewed language.",
            "id": "clause-deviation-references-contract-version-deviation-version",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "clause-deviation-references-contract-version-deviation-version",
            "required": true,
            "sourceFieldId": "contract-version-id",
            "targetEntityId": "contract-version",
            "targetFieldId": "contract-version-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Shared governed decision for this domain outcome.",
            "id": "clause-deviation-governed-by-decision-clause-deviation-governance-decision",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "clause-deviation-governed-by-decision-clause-deviation-governance-decision",
            "required": false,
            "sourceFieldId": "governance-decision-id",
            "targetEntityId": "decision",
            "targetFieldId": "decision-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authority envelope governing this record.",
            "id": "clause-deviation-governed-by-authority-envelope-clause-deviation-governance-authority",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "clause-deviation-governed-by-authority-envelope-clause-deviation-governance-authority",
            "required": false,
            "sourceFieldId": "governance-authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Evidence supporting this record.",
            "id": "clause-deviation-evidenced-by-evidence-item-clause-deviation-governance-evidence",
            "introducedIn": "4.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "clause-deviation-evidenced-by-evidence-item-clause-deviation-governance-evidence",
            "required": false,
            "sourceFieldId": "governance-evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "clause deviation",
          "playbook exception",
          "redline",
          "legal risk"
        ],
        "sourceSystemRoleIds": [
          "collaboration-channel",
          "system-of-record"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record",
          "collaboration-channel"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "obligation-monitoring"
        ],
        "definition": "An authority-bound decision and, where applicable, signature execution record for an exact contract content hash.",
        "domainWorkblockIds": [
          "contract-lifecycle-management"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable identifier for the approval or signature decision record.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "contract-approval-id",
            "introducedIn": "1.0.0",
            "label": "Approval ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-approval-repository",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "restricted",
            "definition": "Exact immutable contract version under decision.",
            "exchangeScope": "internal",
            "id": "contract-version-id",
            "introducedIn": "1.0.0",
            "label": "Contract version ID",
            "nullable": false,
            "referenceEntityId": "contract-version",
            "required": true,
            "sourceAuthority": {
              "id": "contract-approval-repository",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Digest proving the decision applies to unchanged text.",
            "exchangeScope": "mapped",
            "format": "sha-256",
            "id": "content-hash",
            "introducedIn": "1.0.0",
            "label": "Content hash",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-approval-repository",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "tender-contract",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:Signature/cac:DigitalSignatureAttachment/cac:ExternalReference/cbc:DocumentHash",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Authority ceremony represented by the record.",
            "enumValues": [
              "legal-approval",
              "commercial-approval",
              "budget-approval",
              "signature-authorisation",
              "signature"
            ],
            "exchangeScope": "internal",
            "id": "decision-type",
            "introducedIn": "1.0.0",
            "label": "Decision type",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-approval-repository",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Versioned authority envelope that permitted the decision or execution.",
            "exchangeScope": "internal",
            "id": "authority-grant-reference",
            "introducedIn": "1.0.0",
            "label": "Authority grant reference",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "contract-approval-repository",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Timestamp of the committed decision or signature event.",
            "exchangeScope": "mapped",
            "format": "date-time",
            "id": "decided-at",
            "introducedIn": "1.0.0",
            "label": "Decided at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "contract-approval-repository",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "tender-contract",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:Signature/cbc:ValidationDate|cac:Signature/cbc:ValidationTime",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Immutable downstream approval or electronic-signature receipt.",
            "exchangeScope": "mapped",
            "id": "receipt-id",
            "introducedIn": "1.0.0",
            "label": "Receipt reference",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "contract-approval-repository",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "tender-contract",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:Signature/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Shared governed decision record that carries authority, rationale and evidence for this domain decision.",
            "exchangeScope": "unmapped",
            "id": "governance-decision-id",
            "introducedIn": "4.0.0",
            "label": "Governance decision ID",
            "nullable": true,
            "referenceEntityId": "decision",
            "required": false,
            "sourceAuthority": {
              "id": "contract-approval-repository",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Authority envelope governing proposals, approvals and commitments for this record.",
            "exchangeScope": "unmapped",
            "id": "governance-authority-envelope-id",
            "introducedIn": "4.0.0",
            "label": "Governance authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "contract-approval-repository",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "contract-approval",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "contract-version-id",
              "lifecycle-state"
            ],
            "id": "contract-approval-by-contract-version-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "authority-grant-reference"
            ],
            "id": "contract-approval-by-authority-grant-reference",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "content-hash"
            ],
            "id": "contract-approval-by-content-hash",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "decision",
        "label": "Contract approval",
        "lifecycle": [
          "requested",
          "pending",
          "approved",
          "rejected",
          "expired",
          "signed",
          "failed",
          "revoked"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "contract-approval-repository",
        "owningDomainWorkblockId": "contract-lifecycle-management",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Contract approvals",
        "primaryKey": "contract-approval-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Binds the decision to the exact contract version.",
            "id": "contract-approval-references-contract-version-approval-version",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "contract-approval-references-contract-version-approval-version",
            "required": true,
            "sourceFieldId": "contract-version-id",
            "targetEntityId": "contract-version",
            "targetFieldId": "contract-version-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links contract approvals to the governed evidence item record referenced by receipt reference.",
            "id": "contract-approval-evidenced-by-evidence-item-receipt-id-to-evidence-item",
            "introducedIn": "1.1.0",
            "predicate": "evidenced-by",
            "qualifiedId": "contract-approval-evidenced-by-evidence-item-receipt-id-to-evidence-item",
            "required": false,
            "sourceFieldId": "receipt-id",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Shared governed decision for this domain outcome.",
            "id": "contract-approval-governed-by-decision-contract-approval-governance-decision",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "contract-approval-governed-by-decision-contract-approval-governance-decision",
            "required": false,
            "sourceFieldId": "governance-decision-id",
            "targetEntityId": "decision",
            "targetFieldId": "decision-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authority envelope governing this record.",
            "id": "contract-approval-governed-by-authority-envelope-contract-approval-governance-authority",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "contract-approval-governed-by-authority-envelope-contract-approval-governance-authority",
            "required": false,
            "sourceFieldId": "governance-authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "contract approval",
          "signature",
          "authority",
          "execution"
        ],
        "sourceSystemRoleIds": [
          "execution-system",
          "identity-authority"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record",
          "execution-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "renewal-change-compliance"
        ],
        "definition": "A party-owned contractual duty with source anchoring, due logic, evidence requirements and fulfilment state.",
        "domainWorkblockIds": [
          "contract-lifecycle-management"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for the contractual duty across monitoring cycles.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "contract-obligation-id",
            "introducedIn": "1.0.0",
            "label": "Obligation ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "obligation-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Agreement that establishes the duty.",
            "exchangeScope": "mapped",
            "id": "contract-id",
            "introducedIn": "1.0.0",
            "label": "Contract ID",
            "nullable": false,
            "referenceEntityId": "contract",
            "required": true,
            "sourceAuthority": {
              "id": "obligation-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "tender-contract",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Exact version from which the obligation was derived.",
            "exchangeScope": "internal",
            "id": "contract-version-id",
            "introducedIn": "1.0.0",
            "label": "Contract version ID",
            "nullable": false,
            "referenceEntityId": "contract-version",
            "required": true,
            "sourceAuthority": {
              "id": "obligation-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Location of the authoritative contractual language.",
            "exchangeScope": "internal",
            "id": "clause-anchor",
            "introducedIn": "1.0.0",
            "label": "Clause anchor",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "obligation-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Governed classification used for routing and control policy.",
            "enumValues": [
              "deliverable",
              "payment",
              "notice",
              "reporting",
              "service-level",
              "compliance",
              "renewal-action",
              "other"
            ],
            "exchangeScope": "mapped",
            "id": "obligation-type",
            "introducedIn": "1.0.0",
            "label": "Obligation type",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "obligation-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "extension",
                "direction": "inbound",
                "documentId": "tender-contract",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "TenderContract has no native obligation-classification record; a governed extension is required.",
                "path": "ext:UBLExtensions/ext:UBLExtension/ext:ExtensionContent",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "extension-required"
              }
            ],
            "type": "string"
          },
          {
            "classification": "personal",
            "definition": "Role or person accountable for satisfying or evidencing the duty.",
            "exchangeScope": "internal",
            "id": "owner-reference",
            "introducedIn": "1.0.0",
            "label": "Owner reference",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "obligation-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Next calculated due timestamp, including contract-specified calendar rules.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "due-at",
            "introducedIn": "1.0.0",
            "label": "Due at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "obligation-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "confidential",
            "definition": "Typed evidence that must be present and fresh to mark fulfilment.",
            "exchangeScope": "internal",
            "id": "evidence-requirements",
            "introducedIn": "1.0.0",
            "label": "Evidence requirements",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "obligation-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Requirement ID is the string component carried within Contract obligation Evidence requirements; its classification and authority inherit from the owning field contract.",
                    "id": "requirement-id",
                    "label": "Requirement ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "evidence-requirements",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Evidence type records the governed state or type within Contract obligation Evidence requirements without treating absence, unknown and zero as equivalent.",
                    "id": "evidence-type",
                    "label": "Evidence type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "evidence-requirements",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Verification rule ID is the string component carried within Contract obligation Evidence requirements; its classification and authority inherit from the owning field contract.",
                    "id": "verification-rule-id",
                    "label": "Verification rule ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "evidence-requirements",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Freshness rule ID is the string component carried within Contract obligation Evidence requirements; its classification and authority inherit from the owning field contract.",
                    "id": "freshness-rule-id",
                    "label": "Freshness rule ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "evidence-requirements",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Accepted source types is the set carried within Contract obligation Evidence requirements; its owning field governs allowed values and interpretation.",
                    "id": "accepted-source-types",
                    "label": "Accepted source types",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "evidence-requirements",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Mandatory is the boolean component carried within Contract obligation Evidence requirements; its classification and authority inherit from the owning field contract.",
                    "id": "mandatory",
                    "label": "Mandatory",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "evidence-requirements",
                      "kind": "inherited-field"
                    },
                    "type": "boolean"
                  }
                ],
                "uniqueBy": [
                  "requirement-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Consequence band used for monitoring and escalation.",
            "enumValues": [
              "low",
              "moderate",
              "high",
              "critical"
            ],
            "exchangeScope": "internal",
            "id": "risk-level",
            "introducedIn": "1.0.0",
            "label": "Risk level",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "obligation-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "contract-obligation",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "contract-id",
              "due-at"
            ],
            "id": "contract-obligation-by-contract-id-and-due-at",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "owner-reference",
              "lifecycle-state"
            ],
            "id": "contract-obligation-by-owner-reference-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "risk-level",
              "lifecycle-state"
            ],
            "id": "contract-obligation-by-risk-level-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "control",
        "label": "Contract obligation",
        "lifecycle": [
          "proposed",
          "active",
          "due",
          "fulfilled",
          "waived",
          "breached",
          "superseded",
          "closed"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "obligation-monitoring",
        "owningDomainWorkblockId": "contract-lifecycle-management",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Contract obligations",
        "primaryKey": "contract-obligation-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the duty to the governing agreement.",
            "id": "contract-obligation-belongs-to-contract-obligation-contract",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "contract-obligation-belongs-to-contract-obligation-contract",
            "required": true,
            "sourceFieldId": "contract-id",
            "targetEntityId": "contract",
            "targetFieldId": "contract-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the duty to exact source language.",
            "id": "contract-obligation-references-contract-version-obligation-version",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "contract-obligation-references-contract-version-obligation-version",
            "required": true,
            "sourceFieldId": "contract-version-id",
            "targetEntityId": "contract-version",
            "targetFieldId": "contract-version-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "obligation",
          "deliverable",
          "notice",
          "milestone",
          "contract duty"
        ],
        "sourceSystemRoleIds": [
          "system-of-record",
          "planning-system",
          "evidence-source"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record",
          "collaboration-channel"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "demand-consolidation-portfolio",
          "guided-buying",
          "payment-readiness",
          "renewal-change-compliance"
        ],
        "definition": "A contractual right, credit, rebate, remedy, option or concession that may be exercised or recovered.",
        "domainWorkblockIds": [
          "contract-lifecycle-management",
          "intake-demand",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for the contractual right.",
            "exchangeScope": "unmapped",
            "format": "uuid",
            "id": "contract-entitlement-id",
            "introducedIn": "1.0.0",
            "label": "Entitlement ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "obligation-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Agreement that establishes the right.",
            "exchangeScope": "mapped",
            "id": "contract-id",
            "introducedIn": "1.0.0",
            "label": "Contract ID",
            "nullable": false,
            "referenceEntityId": "contract",
            "required": true,
            "sourceAuthority": {
              "id": "obligation-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "tender-contract",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Source anchor for the right and its exercise conditions.",
            "exchangeScope": "unmapped",
            "id": "clause-anchor",
            "introducedIn": "1.0.0",
            "label": "Clause anchor",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "obligation-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Governed right classification.",
            "enumValues": [
              "rebate",
              "service-credit",
              "remedy",
              "termination-right",
              "renewal-option",
              "audit-right",
              "other"
            ],
            "exchangeScope": "unmapped",
            "id": "entitlement-type",
            "introducedIn": "1.0.0",
            "label": "Entitlement type",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "obligation-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Deterministic or evidence-evaluated condition that makes the right exercisable.",
            "exchangeScope": "unmapped",
            "id": "trigger-condition",
            "introducedIn": "1.0.0",
            "label": "Trigger condition",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "obligation-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Condition ID is the string component carried within Contract entitlement Trigger condition; its classification and authority inherit from the owning field contract.",
                    "id": "condition-id",
                    "label": "Condition ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "trigger-condition",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Evaluation mode is the string component carried within Contract entitlement Trigger condition; its classification and authority inherit from the owning field contract.",
                    "id": "evaluation-mode",
                    "label": "Evaluation mode",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "trigger-condition",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Rule expression is the string component carried within Contract entitlement Trigger condition; its classification and authority inherit from the owning field contract.",
                    "id": "rule-expression",
                    "label": "Rule expression",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "trigger-condition",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Policy version ID links this structured value to governed policy version record through policy-version-id within Contract entitlement Trigger condition.",
                    "id": "policy-version-id",
                    "label": "Policy version ID",
                    "nullable": false,
                    "referenceEntityId": "policy-version",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links policy version id to governed policy version record through the canonical policy-version-id field.",
                      "id": "contract-entitlement-trigger-condition-policy-version-id",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "policy-version-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "trigger-condition",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Evidence requirement ids is the set carried within Contract entitlement Trigger condition; its owning field governs allowed values and interpretation.",
                    "id": "evidence-requirement-ids",
                    "label": "Evidence requirement ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "trigger-condition",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Last evaluated at is the timestamp component carried within Contract entitlement Trigger condition; its classification and authority inherit from the owning field contract.",
                    "id": "last-evaluated-at",
                    "label": "Last evaluated at",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "trigger-condition",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Current calculated monetary value with currency and method carried in the object.",
            "exchangeScope": "unmapped",
            "id": "estimated-value",
            "introducedIn": "1.0.0",
            "label": "Estimated value",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "obligation-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Amount is the decimal component carried within Contract entitlement Estimated value; its classification and authority inherit from the owning field contract.",
                    "id": "amount",
                    "label": "Amount",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "estimated-value",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Currency code records the governed code within Contract entitlement Estimated value without treating absence, unknown and zero as equivalent.",
                    "id": "currency-code",
                    "label": "Currency code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "estimated-value",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Calculation method is the string component carried within Contract entitlement Estimated value; its classification and authority inherit from the owning field contract.",
                    "id": "calculation-method",
                    "label": "Calculation method",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "estimated-value",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Calculated at is the timestamp component carried within Contract entitlement Estimated value; its classification and authority inherit from the owning field contract.",
                    "id": "calculated-at",
                    "label": "Calculated at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "estimated-value",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Evidence item ids links this structured value to governed evidence items through evidence-item-id within Contract entitlement Estimated value.",
                    "id": "evidence-item-ids",
                    "label": "Evidence item ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links evidence item ids to governed evidence items through the canonical evidence-item-id field.",
                      "id": "contract-entitlement-estimated-value-evidence-item-ids",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "estimated-value",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Observed or calculated date on which exercise became available.",
            "exchangeScope": "unmapped",
            "format": "date",
            "id": "trigger-date",
            "introducedIn": "1.0.0",
            "label": "Trigger date",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "obligation-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "contract-entitlement",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "contract-id",
              "lifecycle-state"
            ],
            "id": "contract-entitlement-by-contract-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "trigger-date"
            ],
            "id": "contract-entitlement-by-trigger-date",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "entitlement-type"
            ],
            "id": "contract-entitlement-by-entitlement-type",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "transaction",
        "label": "Contract entitlement",
        "lifecycle": [
          "identified",
          "available",
          "triggered",
          "claimed",
          "realised",
          "expired",
          "waived",
          "disputed"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "obligation-monitoring",
        "owningDomainWorkblockId": "contract-lifecycle-management",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Contract entitlements",
        "primaryKey": "contract-entitlement-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the right to the governing agreement.",
            "id": "contract-entitlement-belongs-to-contract-entitlement-contract",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "contract-entitlement-belongs-to-contract-entitlement-contract",
            "required": true,
            "sourceFieldId": "contract-id",
            "targetEntityId": "contract",
            "targetFieldId": "contract-id"
          }
        ],
        "retentionClass": "financial",
        "searchTerms": [
          "entitlement",
          "rebate",
          "service credit",
          "remedy",
          "contract right"
        ],
        "sourceSystemRoleIds": [
          "system-of-record",
          "planning-system",
          "analytical-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "collaboration-channel",
          "planning-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "obligation-monitoring",
          "supplier-innovation-pipeline"
        ],
        "definition": "A governed renewal, amendment, notice, waiver or termination case that moves from proposal to an effective contractual outcome.",
        "domainWorkblockIds": [
          "contract-lifecycle-management",
          "supplier-performance-innovation-relationship"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable identifier for the governed change case.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "contract-change-id",
            "introducedIn": "1.0.0",
            "label": "Change ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "renewal-change-compliance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Agreement being renewed, amended, noticed, waived or terminated.",
            "exchangeScope": "mapped",
            "id": "contract-id",
            "introducedIn": "1.0.0",
            "label": "Contract ID",
            "nullable": false,
            "referenceEntityId": "contract",
            "required": true,
            "sourceAuthority": {
              "id": "renewal-change-compliance",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "tender-contract",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Governed contractual action type.",
            "enumValues": [
              "renewal",
              "amendment",
              "notice",
              "waiver",
              "termination"
            ],
            "exchangeScope": "mapped",
            "id": "change-type",
            "introducedIn": "1.0.0",
            "label": "Change type",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "renewal-change-compliance",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "digital-agreement",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:AgreementTypeCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Evidence or obligation that initiated the case.",
            "exchangeScope": "internal",
            "id": "trigger-reference",
            "introducedIn": "1.0.0",
            "label": "Trigger reference",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "renewal-change-compliance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Latest safe decision date after applying contractual notice and operational lead times.",
            "exchangeScope": "internal",
            "format": "date",
            "id": "decision-deadline",
            "introducedIn": "1.0.0",
            "label": "Decision deadline",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "renewal-change-compliance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "restricted",
            "definition": "Evidence-linked commercial, legal, operational and risk impact of the proposed change.",
            "exchangeScope": "internal",
            "id": "impact-summary",
            "introducedIn": "1.0.0",
            "label": "Impact summary",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "renewal-change-compliance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Assessment version is the string component carried within Contract change Impact summary; its classification and authority inherit from the owning field contract.",
                    "id": "assessment-version",
                    "label": "Assessment version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "impact-summary",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Impact domains is the set carried within Contract change Impact summary; its owning field governs allowed values and interpretation.",
                    "id": "impact-domains",
                    "label": "Impact domains",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "impact-summary",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Commercial impact is the string component carried within Contract change Impact summary; its classification and authority inherit from the owning field contract.",
                    "id": "commercial-impact",
                    "label": "Commercial impact",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "impact-summary",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Legal impact is the string component carried within Contract change Impact summary; its classification and authority inherit from the owning field contract.",
                    "id": "legal-impact",
                    "label": "Legal impact",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "impact-summary",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Operational impact is the string component carried within Contract change Impact summary; its classification and authority inherit from the owning field contract.",
                    "id": "operational-impact",
                    "label": "Operational impact",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "impact-summary",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Risk impact is the string component carried within Contract change Impact summary; its classification and authority inherit from the owning field contract.",
                    "id": "risk-impact",
                    "label": "Risk impact",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "impact-summary",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence item ids links this structured value to governed evidence items through evidence-item-id within Contract change Impact summary.",
                    "id": "evidence-item-ids",
                    "label": "Evidence item ids",
                    "listSemantics": "set",
                    "nullable": false,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links evidence item ids to governed evidence items through the canonical evidence-item-id field.",
                      "id": "contract-change-impact-summary-evidence-item-ids",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "impact-summary",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Immutable agreement version created when the change becomes effective.",
            "exchangeScope": "mapped",
            "id": "resulting-version-id",
            "introducedIn": "1.0.0",
            "label": "Resulting version ID",
            "nullable": true,
            "referenceEntityId": "contract-version",
            "required": false,
            "sourceAuthority": {
              "id": "renewal-change-compliance",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "digital-agreement",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:VersionID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Authority envelope governing proposals, approvals and commitments for this record.",
            "exchangeScope": "unmapped",
            "id": "governance-authority-envelope-id",
            "introducedIn": "4.0.0",
            "label": "Governance authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "renewal-change-compliance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Evidence supporting this record and its governed outcome.",
            "exchangeScope": "unmapped",
            "id": "governance-evidence-item-ids",
            "introducedIn": "4.0.0",
            "label": "Governance evidence item IDs",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "renewal-change-compliance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "contract-change",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "contract-id",
              "change-type"
            ],
            "id": "contract-change-by-contract-id-and-change-type",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "decision-deadline",
              "lifecycle-state"
            ],
            "id": "contract-change-by-decision-deadline-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "resulting-version-id"
            ],
            "id": "contract-change-by-resulting-version-id",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "case",
        "label": "Contract change",
        "lifecycle": [
          "identified",
          "analysing",
          "proposed",
          "approved",
          "issued",
          "effective",
          "rejected",
          "cancelled"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "renewal-change-compliance",
        "owningDomainWorkblockId": "contract-lifecycle-management",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Contract changes",
        "primaryKey": "contract-change-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the change case to the affected agreement.",
            "id": "contract-change-belongs-to-contract-change-contract",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "contract-change-belongs-to-contract-change-contract",
            "required": true,
            "sourceFieldId": "contract-id",
            "targetEntityId": "contract",
            "targetFieldId": "contract-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links an effective change to the resulting immutable contract version.",
            "id": "contract-change-derived-from-contract-version-change-result-version",
            "introducedIn": "1.0.0",
            "predicate": "derived-from",
            "qualifiedId": "contract-change-derived-from-contract-version-change-result-version",
            "required": false,
            "sourceFieldId": "resulting-version-id",
            "targetEntityId": "contract-version",
            "targetFieldId": "contract-version-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authority envelope governing this record.",
            "id": "contract-change-governed-by-authority-envelope-contract-change-governance-authority",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "contract-change-governed-by-authority-envelope-contract-change-governance-authority",
            "required": false,
            "sourceFieldId": "governance-authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Evidence supporting this record.",
            "id": "contract-change-evidenced-by-evidence-item-contract-change-governance-evidence",
            "introducedIn": "4.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "contract-change-evidenced-by-evidence-item-contract-change-governance-evidence",
            "required": false,
            "sourceFieldId": "governance-evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "renewal",
          "amendment",
          "termination",
          "notice",
          "waiver",
          "contract change"
        ],
        "sourceSystemRoleIds": [
          "system-of-record",
          "collaboration-channel",
          "execution-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record",
          "execution-system",
          "collaboration-channel"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "contract-approval-repository"
        ],
        "definition": "A variance linking contracted rights or duties to the observed transactions, performance or conduct that differs from them.",
        "domainWorkblockIds": [
          "contract-lifecycle-management"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for the compliance variance.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "contract-compliance-finding-id",
            "introducedIn": "1.0.0",
            "label": "Finding ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "renewal-change-compliance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Agreement whose terms govern the comparison.",
            "exchangeScope": "mapped",
            "id": "contract-id",
            "introducedIn": "1.0.0",
            "label": "Contract ID",
            "nullable": false,
            "referenceEntityId": "contract",
            "required": true,
            "sourceAuthority": {
              "id": "renewal-change-compliance",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "tender-contract",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Clause, obligation or entitlement used as the expected state.",
            "exchangeScope": "internal",
            "id": "source-term-reference",
            "introducedIn": "1.0.0",
            "label": "Source term reference",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "renewal-change-compliance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Immutable references to transactions, performance facts or attestations used as actual state.",
            "exchangeScope": "internal",
            "id": "observed-evidence-ids",
            "introducedIn": "1.0.0",
            "label": "Observed evidence references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "renewal-change-compliance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Governed variance category.",
            "enumValues": [
              "price",
              "volume",
              "service-level",
              "obligation",
              "entitlement",
              "term",
              "scope",
              "other"
            ],
            "exchangeScope": "internal",
            "id": "finding-type",
            "introducedIn": "1.0.0",
            "label": "Finding type",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "renewal-change-compliance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Consequence band after value, duration, reversibility and legal effect are considered.",
            "enumValues": [
              "low",
              "moderate",
              "high",
              "critical"
            ],
            "exchangeScope": "internal",
            "id": "severity",
            "introducedIn": "1.0.0",
            "label": "Severity",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "renewal-change-compliance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Versioned financial or operational impact calculation with method and confidence.",
            "exchangeScope": "internal",
            "id": "estimated-impact",
            "introducedIn": "1.0.0",
            "label": "Estimated impact",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "renewal-change-compliance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Impact type records the governed state or type within Contract compliance finding Estimated impact without treating absence, unknown and zero as equivalent.",
                    "id": "impact-type",
                    "label": "Impact type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "estimated-impact",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Calculation method is the string component carried within Contract compliance finding Estimated impact; its classification and authority inherit from the owning field contract.",
                    "id": "calculation-method",
                    "label": "Calculation method",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "estimated-impact",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Calculated at is the timestamp component carried within Contract compliance finding Estimated impact; its classification and authority inherit from the owning field contract.",
                    "id": "calculated-at",
                    "label": "Calculated at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "estimated-impact",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Confidence code records the governed code within Contract compliance finding Estimated impact without treating absence, unknown and zero as equivalent.",
                    "id": "confidence-code",
                    "label": "Confidence code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "estimated-impact",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Financial impact is the money component carried within Contract compliance finding Estimated impact; its classification and authority inherit from the owning field contract.",
                    "id": "financial-impact",
                    "label": "Financial impact",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "estimated-impact",
                      "kind": "inherited-field"
                    },
                    "type": "money",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "money-value",
                      "schemaVersion": "2.0.0"
                    }
                  },
                  {
                    "classification": "confidential",
                    "definition": "Operational impact is the string component carried within Contract compliance finding Estimated impact; its classification and authority inherit from the owning field contract.",
                    "id": "operational-impact",
                    "label": "Operational impact",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "estimated-impact",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Evidence item ids links this structured value to governed evidence items through evidence-item-id within Contract compliance finding Estimated impact.",
                    "id": "evidence-item-ids",
                    "label": "Evidence item ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links evidence item ids to governed evidence items through the canonical evidence-item-id field.",
                      "id": "contract-compliance-finding-estimated-impact-evidence-item-ids",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "estimated-impact",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Timestamp of the latest evidence included in the finding.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "observed-at",
            "introducedIn": "1.0.0",
            "label": "Observed at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "renewal-change-compliance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Authority envelope governing proposals, approvals and commitments for this record.",
            "exchangeScope": "unmapped",
            "id": "governance-authority-envelope-id",
            "introducedIn": "4.0.0",
            "label": "Governance authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "renewal-change-compliance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "contract-compliance-finding",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "contract-id",
              "finding-type"
            ],
            "id": "contract-compliance-finding-by-contract-id-and-finding-type",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "severity",
              "lifecycle-state"
            ],
            "id": "contract-compliance-finding-by-severity-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "observed-at"
            ],
            "id": "contract-compliance-finding-by-observed-at",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "case",
        "label": "Contract compliance finding",
        "lifecycle": [
          "detected",
          "validated",
          "disputed",
          "remediating",
          "resolved",
          "accepted",
          "false-positive"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "renewal-change-compliance",
        "owningDomainWorkblockId": "contract-lifecycle-management",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Contract compliance findings",
        "primaryKey": "contract-compliance-finding-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the variance to its governing agreement.",
            "id": "contract-compliance-finding-belongs-to-contract-finding-contract",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "contract-compliance-finding-belongs-to-contract-finding-contract",
            "required": true,
            "sourceFieldId": "contract-id",
            "targetEntityId": "contract",
            "targetFieldId": "contract-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links contract compliance findings to the governed evidence item record referenced by observed evidence references.",
            "id": "contract-compliance-finding-evidenced-by-evidence-item-observed-evidence-ids-to-evidence-item",
            "introducedIn": "1.1.0",
            "predicate": "evidenced-by",
            "qualifiedId": "contract-compliance-finding-evidenced-by-evidence-item-observed-evidence-ids-to-evidence-item",
            "required": true,
            "sourceFieldId": "observed-evidence-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authority envelope governing this record.",
            "id": "contract-compliance-finding-governed-by-authority-envelope-contract-compliance-finding-governance-authority",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "contract-compliance-finding-governed-by-authority-envelope-contract-compliance-finding-governance-authority",
            "required": false,
            "sourceFieldId": "governance-authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "contract compliance",
          "leakage",
          "variance",
          "breach",
          "off-contract"
        ],
        "sourceSystemRoleIds": [
          "system-of-record",
          "planning-system",
          "analytical-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "collaboration-channel",
          "planning-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "continuous-risk-monitoring",
          "contract-intake-digitization",
          "guided-buying",
          "purchase-order-orchestration",
          "requisition-policy-routing",
          "supplier-master-qualification",
          "supplier-remediation-exit",
          "third-party-risk-review"
        ],
        "definition": "The effective-dated procurement lifecycle, verification and eligibility projection for a supplier, linked to the canonical shared party identity.",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk",
          "contract-lifecycle-management",
          "buying-ordering-receiving"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable tenant-scoped canonical supplier identifier.",
            "exchangeScope": "unmapped",
            "format": "uuid",
            "id": "supplier-profile-id",
            "introducedIn": "1.0.0",
            "label": "Supplier ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-onboarding",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Canonical shared party identity represented by this supplier lifecycle projection.",
            "exchangeScope": "unmapped",
            "id": "party-id",
            "introducedIn": "1.1.0",
            "label": "Party ID",
            "nullable": false,
            "referenceEntityId": "party",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-onboarding",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Human-facing governed supplier master number.",
            "exchangeScope": "mapped",
            "id": "supplier-number",
            "introducedIn": "1.0.0",
            "label": "Supplier number",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-onboarding",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "business-card",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "The adapter must pin the supplier-number scheme. Exchange identifiers remain external and must be resolved; they are never used as canonical supplier or party ledger keys.",
                "path": "cac:BusinessParty/cac:PartyIdentification/cbc:ID[@schemeID]",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Verified registered name of the supplying legal entity.",
            "exchangeScope": "mapped",
            "id": "legal-name",
            "introducedIn": "1.0.0",
            "label": "Legal name",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-onboarding",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "business-card",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:BusinessParty/cac:PartyLegalEntity/cbc:RegistrationName",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "ISO 3166-1 alpha-2 country of legal registration.",
            "exchangeScope": "mapped",
            "format": "ISO 3166-1 alpha-2",
            "id": "country-code",
            "introducedIn": "1.0.0",
            "label": "Country code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-onboarding",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "business-card",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:BusinessParty/cac:PartyLegalEntity/cac:RegistrationAddress/cac:Country/cbc:IdentificationCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "string"
          },
          {
            "classification": "public",
            "definition": "Optional verified ISO 17442 Legal Entity Identifier.",
            "exchangeScope": "mapped",
            "format": "ISO 17442 LEI",
            "id": "legal-entity-identifier",
            "introducedIn": "1.0.0",
            "label": "Legal Entity Identifier",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-onboarding",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "conceptId": "legal-entity-identifier",
                "coverage": "exact",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "identifier-namespace",
                "path": "LEI",
                "releaseId": "iso-17442",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "lei-17442",
                "transformation": "none"
              },
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "business-card",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:BusinessParty/cac:PartyIdentification/cbc:ID[@schemeID='LEI']",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Effective-dated identifiers keyed by scheme, issuer and source system.",
            "exchangeScope": "mapped",
            "id": "external-identifiers",
            "introducedIn": "1.0.0",
            "label": "External identifiers",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-onboarding",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "business-card",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:BusinessParty/cac:PartyIdentification",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Scheme ID is the string component carried within Supplier profile External identifiers; its classification and authority inherit from the owning field contract.",
                    "id": "scheme-id",
                    "label": "Scheme ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "external-identifiers",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Identifier value is the string component carried within Supplier profile External identifiers; its classification and authority inherit from the owning field contract.",
                    "id": "identifier-value",
                    "label": "Identifier value",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "external-identifiers",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Issuer ID is the string component carried within Supplier profile External identifiers; its classification and authority inherit from the owning field contract.",
                    "id": "issuer-id",
                    "label": "Issuer ID",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "external-identifiers",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Source system ID is the string component carried within Supplier profile External identifiers; its classification and authority inherit from the owning field contract.",
                    "id": "source-system-id",
                    "label": "Source system ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "external-identifiers",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Effective from is the date component carried within Supplier profile External identifiers; its classification and authority inherit from the owning field contract.",
                    "id": "effective-from",
                    "label": "Effective from",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "external-identifiers",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Effective to is the date component carried within Supplier profile External identifiers; its classification and authority inherit from the owning field contract.",
                    "id": "effective-to",
                    "label": "Effective to",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "external-identifiers",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  }
                ],
                "uniqueBy": [
                  "scheme-id",
                  "identifier-value"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Current policy result for use in new procurement commitments.",
            "enumValues": [
              "unknown",
              "eligible",
              "conditionally-eligible",
              "ineligible",
              "expired"
            ],
            "exchangeScope": "mapped",
            "id": "eligibility-status",
            "introducedIn": "1.0.0",
            "label": "Eligibility status",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-onboarding",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "tenderer-qualification-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "UBL admission codes require a governed adapter mapping to the GroundWorks eligibility vocabulary.",
                "path": "cac:QualificationResolution/cbc:AdmissionCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Timestamp of the most recent complete identity verification.",
            "exchangeScope": "unmapped",
            "format": "date-time",
            "id": "verified-at",
            "introducedIn": "1.0.0",
            "label": "Verified at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-onboarding",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "supplier-profile",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "supplier-number"
            ],
            "id": "supplier-profile-by-supplier-number",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "legal-name",
              "country-code"
            ],
            "id": "supplier-profile-by-legal-name-and-country-code",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "legal-entity-identifier"
            ],
            "id": "supplier-profile-by-legal-entity-identifier",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "lifecycle-state",
              "eligibility-status"
            ],
            "id": "supplier-profile-by-lifecycle-status-and-eligibility-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "party-id"
            ],
            "id": "supplier-profile-by-party-id",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "party",
        "label": "Supplier profile",
        "lifecycle": [
          "prospect",
          "onboarding",
          "active",
          "restricted",
          "suspended",
          "offboarding",
          "inactive"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "supplier-onboarding",
        "owningDomainWorkblockId": "supplier-lifecycle-third-party-risk",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Supplier profiles",
        "primaryKey": "supplier-profile-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links supplier profiles to the governed party record referenced by party id.",
            "id": "supplier-profile-belongs-to-party-party-id-to-party",
            "introducedIn": "1.1.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-profile-belongs-to-party-party-id-to-party",
            "required": true,
            "sourceFieldId": "party-id",
            "targetEntityId": "party",
            "targetFieldId": "party-id"
          }
        ],
        "retentionClass": "reference",
        "searchTerms": [
          "supplier",
          "vendor",
          "third party",
          "legal entity",
          "supplier master"
        ],
        "sourceSystemRoleIds": [
          "source-of-record",
          "system-of-record",
          "identity-authority",
          "planning-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record",
          "planning-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "supplier-master-qualification",
          "third-party-risk-review"
        ],
        "definition": "A governed case that collects, verifies and resolves the evidence required to create or activate a supplier relationship.",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable identifier for the onboarding case.",
            "exchangeScope": "mapped",
            "format": "uuid",
            "id": "supplier-onboarding-case-id",
            "introducedIn": "1.0.0",
            "label": "Onboarding case ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-onboarding",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "qualification-application-request",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Canonical supplier being established or refreshed.",
            "exchangeScope": "mapped",
            "id": "supplier-id",
            "introducedIn": "1.0.0",
            "label": "Supplier ID",
            "nullable": false,
            "referenceEntityId": "supplier-profile",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-onboarding",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "qualification-application-request",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:EconomicOperatorParty/cac:Party/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Source request or demand reference that justifies onboarding.",
            "exchangeScope": "mapped",
            "id": "request-reference",
            "introducedIn": "1.0.0",
            "label": "Request reference",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-onboarding",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "qualification-application-request",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ContractFolderID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Versioned onboarding and evidence policy applied to the case.",
            "exchangeScope": "internal",
            "id": "requirement-set-version",
            "introducedIn": "1.0.0",
            "label": "Requirement set version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-onboarding",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Per-requirement responses, artifact references, verification results, expiry and source freshness.",
            "exchangeScope": "mapped",
            "id": "evidence-state",
            "introducedIn": "1.0.0",
            "label": "Evidence state",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-onboarding",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "qualification-application-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "UBL evidence supplies artifacts and responses; verification, completeness, expiry and freshness remain GroundWorks state.",
                "path": "cac:Evidence",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Requirement ID is the string component carried within Supplier onboarding case Evidence state; its classification and authority inherit from the owning field contract.",
                    "id": "requirement-id",
                    "label": "Requirement ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "evidence-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Response status records the governed state or type within Supplier onboarding case Evidence state without treating absence, unknown and zero as equivalent.",
                    "id": "response-status",
                    "label": "Response status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "evidence-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Artifact reference ids is the set carried within Supplier onboarding case Evidence state; its owning field governs allowed values and interpretation.",
                    "id": "artifact-reference-ids",
                    "label": "Artifact reference ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "evidence-state",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Verification status records the governed state or type within Supplier onboarding case Evidence state without treating absence, unknown and zero as equivalent.",
                    "id": "verification-status",
                    "label": "Verification status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "evidence-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Verified at is the timestamp component carried within Supplier onboarding case Evidence state; its classification and authority inherit from the owning field contract.",
                    "id": "verified-at",
                    "label": "Verified at",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "evidence-state",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Expires at is the timestamp component carried within Supplier onboarding case Evidence state; its classification and authority inherit from the owning field contract.",
                    "id": "expires-at",
                    "label": "Expires at",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "evidence-state",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Source observed at is the timestamp component carried within Supplier onboarding case Evidence state; its classification and authority inherit from the owning field contract.",
                    "id": "source-observed-at",
                    "label": "Source observed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "evidence-state",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Source system ID is the string component carried within Supplier onboarding case Evidence state; its classification and authority inherit from the owning field contract.",
                    "id": "source-system-id",
                    "label": "Source system ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "evidence-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ],
                "uniqueBy": [
                  "requirement-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Potential canonical supplier matches requiring deterministic resolution or escalation.",
            "exchangeScope": "internal",
            "id": "duplicate-candidate-ids",
            "introducedIn": "1.0.0",
            "label": "Duplicate candidate IDs",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "supplier-profile",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-onboarding",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Next response or completion deadline.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "due-at",
            "introducedIn": "1.0.0",
            "label": "Due at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-onboarding",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Authority envelope governing proposals, approvals and commitments for this record.",
            "exchangeScope": "unmapped",
            "id": "governance-authority-envelope-id",
            "introducedIn": "4.0.0",
            "label": "Governance authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-onboarding",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Evidence supporting this record and its governed outcome.",
            "exchangeScope": "unmapped",
            "id": "governance-evidence-item-ids",
            "introducedIn": "4.0.0",
            "label": "Governance evidence item IDs",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-onboarding",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "supplier-onboarding-case",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "supplier-id",
              "lifecycle-state"
            ],
            "id": "supplier-onboarding-case-by-supplier-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "request-reference"
            ],
            "id": "supplier-onboarding-case-by-request-reference",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "due-at",
              "lifecycle-state"
            ],
            "id": "supplier-onboarding-case-by-due-at-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "case",
        "label": "Supplier onboarding case",
        "lifecycle": [
          "requested",
          "collecting",
          "verifying",
          "needs-evidence",
          "approved",
          "rejected",
          "cancelled",
          "activated"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "supplier-onboarding",
        "owningDomainWorkblockId": "supplier-lifecycle-third-party-risk",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Supplier onboarding cases",
        "primaryKey": "supplier-onboarding-case-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the case to the resolved canonical supplier.",
            "id": "supplier-onboarding-case-belongs-to-supplier-profile-onboarding-supplier",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-onboarding-case-belongs-to-supplier-profile-onboarding-supplier",
            "required": true,
            "sourceFieldId": "supplier-id",
            "targetEntityId": "supplier-profile",
            "targetFieldId": "supplier-profile-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links supplier onboarding cases to the governed supplier profile record referenced by duplicate candidate ids.",
            "id": "supplier-onboarding-case-belongs-to-supplier-profile-duplicate-candidate-ids-to-supplier-profile",
            "introducedIn": "1.1.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-onboarding-case-belongs-to-supplier-profile-duplicate-candidate-ids-to-supplier-profile",
            "required": false,
            "sourceFieldId": "duplicate-candidate-ids",
            "targetEntityId": "supplier-profile",
            "targetFieldId": "supplier-profile-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authority envelope governing this record.",
            "id": "supplier-onboarding-case-governed-by-authority-envelope-supplier-onboarding-case-governance-authority",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "supplier-onboarding-case-governed-by-authority-envelope-supplier-onboarding-case-governance-authority",
            "required": false,
            "sourceFieldId": "governance-authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Evidence supporting this record.",
            "id": "supplier-onboarding-case-evidenced-by-evidence-item-supplier-onboarding-case-governance-evidence",
            "introducedIn": "4.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "supplier-onboarding-case-evidenced-by-evidence-item-supplier-onboarding-case-governance-evidence",
            "required": false,
            "sourceFieldId": "governance-evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "supplier onboarding",
          "registration",
          "supplier request",
          "evidence request"
        ],
        "sourceSystemRoleIds": [
          "source-of-record",
          "identity-authority",
          "system-of-record"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record",
          "planning-system",
          "collaboration-channel"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": false,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "guided-buying",
          "requisition-policy-routing",
          "supplier-onboarding",
          "third-party-risk-review"
        ],
        "definition": "An effective-dated eligibility or certification decision for a supplier within a category, geography, legal entity or business purpose.",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for an effective-dated qualification decision.",
            "exchangeScope": "mapped",
            "format": "uuid",
            "id": "supplier-qualification-id",
            "introducedIn": "1.0.0",
            "label": "Qualification ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-master-qualification",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "qualification-application-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Canonical supplier subject to qualification.",
            "exchangeScope": "mapped",
            "id": "supplier-id",
            "introducedIn": "1.0.0",
            "label": "Supplier ID",
            "nullable": false,
            "referenceEntityId": "supplier-profile",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-master-qualification",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "qualification-application-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:EconomicOperatorParty/cac:Party/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Structured qualification scope such as category, geography, entity or service.",
            "exchangeScope": "mapped",
            "id": "scope-code",
            "introducedIn": "1.0.0",
            "label": "Scope code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-master-qualification",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "qualification-application-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ProcurementProjectLot/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Exact qualification policy used for the decision.",
            "exchangeScope": "internal",
            "id": "policy-version",
            "introducedIn": "1.0.0",
            "label": "Policy version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-master-qualification",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Machine-readable restrictions, evidence requirements and usage constraints attached to conditional eligibility.",
            "exchangeScope": "internal",
            "id": "conditions",
            "introducedIn": "1.0.0",
            "label": "Conditions",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-master-qualification",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Condition ID is the string component carried within Supplier qualification Conditions; its classification and authority inherit from the owning field contract.",
                    "id": "condition-id",
                    "label": "Condition ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "conditions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Restriction type records the governed state or type within Supplier qualification Conditions without treating absence, unknown and zero as equivalent.",
                    "id": "restriction-type",
                    "label": "Restriction type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "conditions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Rule expression is the string component carried within Supplier qualification Conditions; its classification and authority inherit from the owning field contract.",
                    "id": "rule-expression",
                    "label": "Rule expression",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "conditions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Evidence requirement ids is the set carried within Supplier qualification Conditions; its owning field governs allowed values and interpretation.",
                    "id": "evidence-requirement-ids",
                    "label": "Evidence requirement ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "conditions",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Usage constraint codes is the set carried within Supplier qualification Conditions; its owning field governs allowed values and interpretation.",
                    "id": "usage-constraint-codes",
                    "label": "Usage constraint codes",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "conditions",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Valid from is the date component carried within Supplier qualification Conditions; its classification and authority inherit from the owning field contract.",
                    "id": "valid-from",
                    "label": "Valid from",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "conditions",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Valid to is the date component carried within Supplier qualification Conditions; its classification and authority inherit from the owning field contract.",
                    "id": "valid-to",
                    "label": "Valid to",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "conditions",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  }
                ],
                "uniqueBy": [
                  "condition-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Start date of the qualification decision.",
            "exchangeScope": "internal",
            "format": "date",
            "id": "valid-from",
            "introducedIn": "1.0.0",
            "label": "Valid from",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-master-qualification",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "internal",
            "definition": "Expiry date requiring requalification or a new decision.",
            "exchangeScope": "internal",
            "format": "date",
            "id": "valid-to",
            "introducedIn": "1.0.0",
            "label": "Valid to",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-master-qualification",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "internal",
            "definition": "Shared governed decision record that carries authority, rationale and evidence for this domain decision.",
            "exchangeScope": "unmapped",
            "id": "governance-decision-id",
            "introducedIn": "4.0.0",
            "label": "Governance decision ID",
            "nullable": true,
            "referenceEntityId": "decision",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-master-qualification",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Authority envelope governing proposals, approvals and commitments for this record.",
            "exchangeScope": "unmapped",
            "id": "governance-authority-envelope-id",
            "introducedIn": "4.0.0",
            "label": "Governance authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-master-qualification",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Evidence supporting this record and its governed outcome.",
            "exchangeScope": "unmapped",
            "id": "governance-evidence-item-ids",
            "introducedIn": "4.0.0",
            "label": "Governance evidence item IDs",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-master-qualification",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "supplier-qualification",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "supplier-id",
              "scope-code"
            ],
            "id": "supplier-qualification-by-supplier-id-and-scope-code",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "lifecycle-state",
              "valid-to"
            ],
            "id": "supplier-qualification-by-status-and-valid-to",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "policy-version"
            ],
            "id": "supplier-qualification-by-policy-version",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "decision",
        "label": "Supplier qualification",
        "lifecycle": [
          "pending",
          "qualified",
          "conditional",
          "expired",
          "suspended",
          "revoked",
          "rejected"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "supplier-master-qualification",
        "owningDomainWorkblockId": "supplier-lifecycle-third-party-risk",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Supplier qualifications",
        "primaryKey": "supplier-qualification-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the qualification to its supplier.",
            "id": "supplier-qualification-belongs-to-supplier-profile-qualification-supplier",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-qualification-belongs-to-supplier-profile-qualification-supplier",
            "required": true,
            "sourceFieldId": "supplier-id",
            "targetEntityId": "supplier-profile",
            "targetFieldId": "supplier-profile-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Shared governed decision for this domain outcome.",
            "id": "supplier-qualification-governed-by-decision-supplier-qualification-governance-decision",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "supplier-qualification-governed-by-decision-supplier-qualification-governance-decision",
            "required": false,
            "sourceFieldId": "governance-decision-id",
            "targetEntityId": "decision",
            "targetFieldId": "decision-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authority envelope governing this record.",
            "id": "supplier-qualification-governed-by-authority-envelope-supplier-qualification-governance-authority",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "supplier-qualification-governed-by-authority-envelope-supplier-qualification-governance-authority",
            "required": false,
            "sourceFieldId": "governance-authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Evidence supporting this record.",
            "id": "supplier-qualification-evidenced-by-evidence-item-supplier-qualification-governance-evidence",
            "introducedIn": "4.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "supplier-qualification-evidenced-by-evidence-item-supplier-qualification-governance-evidence",
            "required": false,
            "sourceFieldId": "governance-evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "supplier qualification",
          "certification",
          "approved supplier",
          "eligibility"
        ],
        "sourceSystemRoleIds": [
          "system-of-record",
          "identity-authority"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record",
          "execution-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "continuous-risk-monitoring"
        ],
        "definition": "A controlled proposal linked to its supporting records to change supplier identity, address, tax, payment or banking attributes.",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable identifier for the controlled change case.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "supplier-master-change-id",
            "introducedIn": "1.0.0",
            "label": "Master change ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-master-qualification",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "restricted",
            "definition": "Canonical supplier whose master data would change.",
            "exchangeScope": "mapped",
            "id": "supplier-id",
            "introducedIn": "1.0.0",
            "label": "Supplier ID",
            "nullable": false,
            "referenceEntityId": "supplier-profile",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-master-qualification",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "business-card",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:BusinessParty/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Governed attribute group being changed.",
            "enumValues": [
              "legal-name",
              "identifier",
              "address",
              "tax",
              "payment-method",
              "bank-account",
              "contact",
              "other"
            ],
            "exchangeScope": "internal",
            "id": "change-type",
            "introducedIn": "1.0.0",
            "label": "Change type",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-master-qualification",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Encrypted or tokenised before and proposed values with attribute-level provenance.",
            "exchangeScope": "mapped",
            "id": "change-payload",
            "introducedIn": "1.0.0",
            "label": "Change payload",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-master-qualification",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "business-card",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:BusinessParty",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Attribute path is the string component carried within Supplier master change Change payload; its classification and authority inherit from the owning field contract.",
                    "id": "attribute-path",
                    "label": "Attribute path",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "change-payload",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Operation is the string component carried within Supplier master change Change payload; its classification and authority inherit from the owning field contract.",
                    "id": "operation",
                    "label": "Operation",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "change-payload",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Before value token is the string component carried within Supplier master change Change payload; its classification and authority inherit from the owning field contract.",
                    "id": "before-value-token",
                    "label": "Before value token",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "change-payload",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Proposed value token is the string component carried within Supplier master change Change payload; its classification and authority inherit from the owning field contract.",
                    "id": "proposed-value-token",
                    "label": "Proposed value token",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "change-payload",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Protection mode is the string component carried within Supplier master change Change payload; its classification and authority inherit from the owning field contract.",
                    "id": "protection-mode",
                    "label": "Protection mode",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "change-payload",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Provenance evidence item ID links this structured value to the governed evidence-item record within Supplier master change Change payload.",
                    "id": "provenance-evidence-item-id",
                    "label": "Provenance evidence item ID",
                    "nullable": false,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the provenance evidence item ID in change payload to the referenced evidence item via its canonical evidence item ID.",
                      "id": "supplier-master-change-change-payload-provenance-evidence-item-id",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "change-payload",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Source system ID is the string component carried within Supplier master change Change payload; its classification and authority inherit from the owning field contract.",
                    "id": "source-system-id",
                    "label": "Source system ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "change-payload",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ],
                "uniqueBy": [
                  "attribute-path"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Independent verification methods, results, evidence references and verifier separation.",
            "exchangeScope": "internal",
            "id": "verification-state",
            "introducedIn": "1.0.0",
            "label": "Verification state",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-master-qualification",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Verification ID is the string component carried within Supplier master change Verification state; its classification and authority inherit from the owning field contract.",
                    "id": "verification-id",
                    "label": "Verification ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "verification-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Method type records the governed state or type within Supplier master change Verification state without treating absence, unknown and zero as equivalent.",
                    "id": "method-type",
                    "label": "Method type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "verification-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Result is the string component carried within Supplier master change Verification state; its classification and authority inherit from the owning field contract.",
                    "id": "result",
                    "label": "Result",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "verification-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Verifier ID is the string component carried within Supplier master change Verification state; its classification and authority inherit from the owning field contract.",
                    "id": "verifier-id",
                    "label": "Verifier ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "verification-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Independent verifier is the boolean component carried within Supplier master change Verification state; its classification and authority inherit from the owning field contract.",
                    "id": "independent-verifier",
                    "label": "Independent verifier",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "verification-state",
                      "kind": "inherited-field"
                    },
                    "type": "boolean"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence item ID links this structured value to the governed evidence-item record within Supplier master change Verification state.",
                    "id": "evidence-item-id",
                    "label": "Evidence item ID",
                    "nullable": false,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the evidence item ID in verification state to the referenced evidence item via its canonical evidence item ID.",
                      "id": "supplier-master-change-verification-state-evidence-item-id",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "verification-state",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Verified at is the timestamp component carried within Supplier master change Verification state; its classification and authority inherit from the owning field contract.",
                    "id": "verified-at",
                    "label": "Verified at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "verification-state",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  }
                ],
                "uniqueBy": [
                  "verification-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Stable key preventing duplicate downstream mutation across retries.",
            "exchangeScope": "internal",
            "id": "idempotency-key",
            "introducedIn": "1.0.0",
            "label": "Idempotency key",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-master-qualification",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Timestamp when the change request entered the controlled workflow.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "requested-at",
            "introducedIn": "1.0.0",
            "label": "Requested at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-master-qualification",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Authority envelope governing proposals, approvals and commitments for this record.",
            "exchangeScope": "unmapped",
            "id": "governance-authority-envelope-id",
            "introducedIn": "4.0.0",
            "label": "Governance authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-master-qualification",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Evidence supporting this record and its governed outcome.",
            "exchangeScope": "unmapped",
            "id": "governance-evidence-item-ids",
            "introducedIn": "4.0.0",
            "label": "Governance evidence item IDs",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-master-qualification",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "supplier-master-change",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "supplier-id",
              "change-type"
            ],
            "id": "supplier-master-change-by-supplier-id-and-change-type",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "lifecycle-state",
              "requested-at"
            ],
            "id": "supplier-master-change-by-status-and-requested-at",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "idempotency-key"
            ],
            "id": "supplier-master-change-by-idempotency-key",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "case",
        "label": "Supplier master change",
        "lifecycle": [
          "requested",
          "verifying",
          "proposed",
          "approved",
          "rejected",
          "committed",
          "failed",
          "reversed"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "supplier-master-qualification",
        "owningDomainWorkblockId": "supplier-lifecycle-third-party-risk",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Supplier master changes",
        "primaryKey": "supplier-master-change-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the controlled change to the affected supplier.",
            "id": "supplier-master-change-belongs-to-supplier-profile-master-change-supplier",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-master-change-belongs-to-supplier-profile-master-change-supplier",
            "required": true,
            "sourceFieldId": "supplier-id",
            "targetEntityId": "supplier-profile",
            "targetFieldId": "supplier-profile-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authority envelope governing this record.",
            "id": "supplier-master-change-governed-by-authority-envelope-supplier-master-change-governance-authority",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "supplier-master-change-governed-by-authority-envelope-supplier-master-change-governance-authority",
            "required": false,
            "sourceFieldId": "governance-authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Evidence supporting this record.",
            "id": "supplier-master-change-evidenced-by-evidence-item-supplier-master-change-governance-evidence",
            "introducedIn": "4.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "supplier-master-change-evidenced-by-evidence-item-supplier-master-change-governance-evidence",
            "required": false,
            "sourceFieldId": "governance-evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "supplier master change",
          "bank detail change",
          "address change",
          "payment data"
        ],
        "sourceSystemRoleIds": [
          "source-of-record",
          "system-of-record",
          "identity-authority"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record",
          "planning-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "bid-evaluation-award",
          "continuous-risk-monitoring",
          "supplier-master-qualification",
          "supplier-onboarding",
          "supplier-remediation-exit"
        ],
        "definition": "A versioned, scoped evaluation of supplier inherent risk, controls, evidence, residual risk and an authority-bound disposition.",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk",
          "sourcing-negotiation"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable identifier for the assessment version.",
            "exchangeScope": "mapped",
            "format": "uuid",
            "id": "supplier-risk-assessment-id",
            "introducedIn": "1.0.0",
            "label": "Assessment ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "third-party-risk-review",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "qualification-application-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Canonical supplier subject to assessment.",
            "exchangeScope": "mapped",
            "id": "supplier-id",
            "introducedIn": "1.0.0",
            "label": "Supplier ID",
            "nullable": false,
            "referenceEntityId": "supplier-profile",
            "required": true,
            "sourceAuthority": {
              "id": "third-party-risk-review",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "qualification-application-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:EconomicOperatorParty/cac:Party/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Versioned business use, service, geography, data access and risk-domain scope.",
            "exchangeScope": "mapped",
            "id": "assessment-scope",
            "introducedIn": "1.0.0",
            "label": "Assessment scope",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "third-party-risk-review",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "qualification-application-request",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:TenderingCriterion",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Scope version is the string component carried within Supplier risk assessment Assessment scope; its classification and authority inherit from the owning field contract.",
                    "id": "scope-version",
                    "label": "Scope version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "assessment-scope",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Business use is the string component carried within Supplier risk assessment Assessment scope; its classification and authority inherit from the owning field contract.",
                    "id": "business-use",
                    "label": "Business use",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "assessment-scope",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Service codes is the set carried within Supplier risk assessment Assessment scope; its owning field governs allowed values and interpretation.",
                    "id": "service-codes",
                    "label": "Service codes",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "assessment-scope",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Geography codes is the set carried within Supplier risk assessment Assessment scope; its owning field governs allowed values and interpretation.",
                    "id": "geography-codes",
                    "label": "Geography codes",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "assessment-scope",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Data access classifications is the set carried within Supplier risk assessment Assessment scope; its owning field governs allowed values and interpretation.",
                    "id": "data-access-classifications",
                    "label": "Data access classifications",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "assessment-scope",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Risk domain codes is the set carried within Supplier risk assessment Assessment scope; its owning field governs allowed values and interpretation.",
                    "id": "risk-domain-codes",
                    "label": "Risk domain codes",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "assessment-scope",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Exact risk and decision policy used.",
            "exchangeScope": "internal",
            "id": "policy-version",
            "introducedIn": "1.0.0",
            "label": "Policy version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "third-party-risk-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Responses, artifacts, external observations, verification status and expiry by control requirement.",
            "exchangeScope": "mapped",
            "id": "evidence-state",
            "introducedIn": "1.0.0",
            "label": "Evidence state",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "third-party-risk-review",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "qualification-application-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:Evidence",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Requirement ID is the string component carried within Supplier risk assessment Evidence state; its classification and authority inherit from the owning field contract.",
                    "id": "requirement-id",
                    "label": "Requirement ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "evidence-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Response status records the governed state or type within Supplier risk assessment Evidence state without treating absence, unknown and zero as equivalent.",
                    "id": "response-status",
                    "label": "Response status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "evidence-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Artifact reference ids is the set carried within Supplier risk assessment Evidence state; its owning field governs allowed values and interpretation.",
                    "id": "artifact-reference-ids",
                    "label": "Artifact reference ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "evidence-state",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "External observation ids is the set carried within Supplier risk assessment Evidence state; its owning field governs allowed values and interpretation.",
                    "id": "external-observation-ids",
                    "label": "External observation ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "evidence-state",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Verification status records the governed state or type within Supplier risk assessment Evidence state without treating absence, unknown and zero as equivalent.",
                    "id": "verification-status",
                    "label": "Verification status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "evidence-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Observed at is the timestamp component carried within Supplier risk assessment Evidence state; its classification and authority inherit from the owning field contract.",
                    "id": "observed-at",
                    "label": "Observed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "evidence-state",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Expires at is the timestamp component carried within Supplier risk assessment Evidence state; its classification and authority inherit from the owning field contract.",
                    "id": "expires-at",
                    "label": "Expires at",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "evidence-state",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  }
                ],
                "uniqueBy": [
                  "requirement-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Risk before evaluated controls and mitigations.",
            "enumValues": [
              "low",
              "moderate",
              "high",
              "critical"
            ],
            "exchangeScope": "internal",
            "id": "inherent-risk-level",
            "introducedIn": "1.0.0",
            "label": "Inherent risk level",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "third-party-risk-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Risk remaining after verified controls and approved mitigations.",
            "enumValues": [
              "low",
              "moderate",
              "high",
              "critical"
            ],
            "exchangeScope": "internal",
            "id": "residual-risk-level",
            "introducedIn": "1.0.0",
            "label": "Residual risk level",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "third-party-risk-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Latest date at which the decision remains valid without refresh.",
            "exchangeScope": "internal",
            "format": "date",
            "id": "valid-to",
            "introducedIn": "1.0.0",
            "label": "Valid to",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "third-party-risk-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "internal",
            "definition": "Shared governed decision record that carries authority, rationale and evidence for this domain decision.",
            "exchangeScope": "unmapped",
            "id": "governance-decision-id",
            "introducedIn": "4.0.0",
            "label": "Governance decision ID",
            "nullable": true,
            "referenceEntityId": "decision",
            "required": false,
            "sourceAuthority": {
              "id": "third-party-risk-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Authority envelope governing proposals, approvals and commitments for this record.",
            "exchangeScope": "unmapped",
            "id": "governance-authority-envelope-id",
            "introducedIn": "4.0.0",
            "label": "Governance authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "third-party-risk-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Evidence supporting this record and its governed outcome.",
            "exchangeScope": "unmapped",
            "id": "governance-evidence-item-ids",
            "introducedIn": "4.0.0",
            "label": "Governance evidence item IDs",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "third-party-risk-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "supplier-risk-assessment",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "supplier-id",
              "assessment-scope"
            ],
            "id": "supplier-risk-assessment-by-supplier-id-and-assessment-scope",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "residual-risk-level",
              "lifecycle-state"
            ],
            "id": "supplier-risk-assessment-by-residual-risk-level-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "valid-to"
            ],
            "id": "supplier-risk-assessment-by-valid-to",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "assessment",
        "label": "Supplier risk assessment",
        "lifecycle": [
          "planned",
          "collecting",
          "evaluating",
          "needs-evidence",
          "proposed",
          "accepted",
          "restricted",
          "rejected",
          "expired"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "third-party-risk-review",
        "owningDomainWorkblockId": "supplier-lifecycle-third-party-risk",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Supplier risk assessments",
        "primaryKey": "supplier-risk-assessment-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the assessment to the canonical supplier.",
            "id": "supplier-risk-assessment-belongs-to-supplier-profile-assessment-supplier",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-risk-assessment-belongs-to-supplier-profile-assessment-supplier",
            "required": true,
            "sourceFieldId": "supplier-id",
            "targetEntityId": "supplier-profile",
            "targetFieldId": "supplier-profile-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Shared governed decision for this domain outcome.",
            "id": "supplier-risk-assessment-governed-by-decision-supplier-risk-assessment-governance-decision",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "supplier-risk-assessment-governed-by-decision-supplier-risk-assessment-governance-decision",
            "required": false,
            "sourceFieldId": "governance-decision-id",
            "targetEntityId": "decision",
            "targetFieldId": "decision-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authority envelope governing this record.",
            "id": "supplier-risk-assessment-governed-by-authority-envelope-supplier-risk-assessment-governance-authority",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "supplier-risk-assessment-governed-by-authority-envelope-supplier-risk-assessment-governance-authority",
            "required": false,
            "sourceFieldId": "governance-authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Evidence supporting this record.",
            "id": "supplier-risk-assessment-evidenced-by-evidence-item-supplier-risk-assessment-governance-evidence",
            "introducedIn": "4.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "supplier-risk-assessment-evidenced-by-evidence-item-supplier-risk-assessment-governance-evidence",
            "required": false,
            "sourceFieldId": "governance-evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "third party risk",
          "supplier assessment",
          "due diligence",
          "residual risk"
        ],
        "sourceSystemRoleIds": [
          "source-of-record",
          "analytical-system",
          "evidence-source",
          "identity-authority"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record",
          "collaboration-channel"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "commit",
            "correct",
            "export"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "third-party-risk-review"
        ],
        "definition": "A deduplicated, time-bounded observation that may change supplier risk, eligibility or required action but is not itself a risk decision.",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable identifier for the normalised observation.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "supplier-risk-signal-id",
            "introducedIn": "1.0.0",
            "label": "Signal ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "continuous-risk-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Canonical supplier to which the signal was resolved.",
            "exchangeScope": "internal",
            "id": "supplier-id",
            "introducedIn": "1.0.0",
            "label": "Supplier ID",
            "nullable": false,
            "referenceEntityId": "supplier-profile",
            "required": true,
            "sourceAuthority": {
              "id": "continuous-risk-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Governed risk taxonomy category.",
            "enumValues": [
              "financial",
              "cyber",
              "privacy",
              "compliance",
              "sanctions",
              "environmental",
              "social",
              "operational",
              "geopolitical",
              "other"
            ],
            "exchangeScope": "internal",
            "id": "risk-domain",
            "introducedIn": "1.0.0",
            "label": "Risk domain",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "continuous-risk-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Licensed or internal source plus immutable snapshot reference.",
            "exchangeScope": "internal",
            "id": "source-reference",
            "introducedIn": "1.0.0",
            "label": "Source reference",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "continuous-risk-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Stable correlation key grouping repeat observations of the same underlying event.",
            "exchangeScope": "internal",
            "id": "deduplication-key",
            "introducedIn": "1.0.0",
            "label": "Deduplication key",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "continuous-risk-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Policy result describing likely relevance to the current supplier relationship.",
            "enumValues": [
              "unknown",
              "non-material",
              "monitor",
              "material",
              "critical"
            ],
            "exchangeScope": "internal",
            "id": "materiality",
            "introducedIn": "1.0.0",
            "label": "Materiality",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "continuous-risk-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Calibrated confidence that the observation concerns the canonical supplier.",
            "exchangeScope": "internal",
            "format": "0..1",
            "id": "confidence",
            "introducedIn": "1.0.0",
            "label": "Entity-match confidence",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "continuous-risk-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "decimal"
          },
          {
            "classification": "internal",
            "definition": "Time the source says the event occurred or was observed.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "observed-at",
            "introducedIn": "1.0.0",
            "label": "Observed at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "continuous-risk-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Time the platform committed the normalised signal.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "ingested-at",
            "introducedIn": "1.0.0",
            "label": "Ingested at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "continuous-risk-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "supplier-risk-signal",
        "immutable": true,
        "indexes": [
          {
            "fieldIds": [
              "supplier-id",
              "observed-at"
            ],
            "id": "supplier-risk-signal-by-supplier-id-and-observed-at",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "risk-domain",
              "materiality"
            ],
            "id": "supplier-risk-signal-by-risk-domain-and-materiality",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "deduplication-key"
            ],
            "id": "supplier-risk-signal-by-deduplication-key",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "event",
        "label": "Supplier risk signal",
        "lifecycle": [
          "observed",
          "correlated",
          "material",
          "non-material",
          "superseded",
          "expired"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "continuous-risk-monitoring",
        "owningDomainWorkblockId": "supplier-lifecycle-third-party-risk",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "append-only-event-store",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Supplier risk signals",
        "primaryKey": "supplier-risk-signal-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the observation to the resolved supplier.",
            "id": "supplier-risk-signal-belongs-to-supplier-profile-signal-supplier",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-risk-signal-belongs-to-supplier-profile-signal-supplier",
            "required": true,
            "sourceFieldId": "supplier-id",
            "targetEntityId": "supplier-profile",
            "targetFieldId": "supplier-profile-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "risk alert",
          "risk signal",
          "adverse event",
          "monitoring"
        ],
        "sourceSystemRoleIds": [
          "analytical-system",
          "identity-authority",
          "managed-network",
          "execution-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "execution-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "supplier-remediation-exit"
        ],
        "definition": "A governed exception case created when correlated evidence may require restriction, reassessment, remediation, suspension or exit.",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable identifier for the governed risk exception.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "supplier-risk-case-id",
            "introducedIn": "1.0.0",
            "label": "Risk case ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "continuous-risk-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Canonical supplier affected by the case.",
            "exchangeScope": "internal",
            "id": "supplier-id",
            "introducedIn": "1.0.0",
            "label": "Supplier ID",
            "nullable": false,
            "referenceEntityId": "supplier-profile",
            "required": true,
            "sourceAuthority": {
              "id": "continuous-risk-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Deduplicated evidence observations included in current materiality evaluation.",
            "exchangeScope": "internal",
            "id": "signal-ids",
            "introducedIn": "1.0.0",
            "label": "Signal IDs",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "supplier-risk-signal",
            "required": true,
            "sourceAuthority": {
              "id": "continuous-risk-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Correlation key preventing parallel cases for the same supplier and underlying event.",
            "exchangeScope": "internal",
            "id": "case-family-key",
            "introducedIn": "1.0.0",
            "label": "Case family key",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "continuous-risk-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Policy-calculated consequence after scope, confidence and existing controls.",
            "enumValues": [
              "low",
              "moderate",
              "high",
              "critical"
            ],
            "exchangeScope": "internal",
            "id": "severity",
            "introducedIn": "1.0.0",
            "label": "Severity",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "continuous-risk-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Uncommitted action with evidence, restrictions, reversibility and authority requirement.",
            "exchangeScope": "internal",
            "id": "proposed-action",
            "introducedIn": "1.0.0",
            "label": "Proposed action",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "continuous-risk-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Action type records the governed state or type within Supplier risk case Proposed action without treating absence, unknown and zero as equivalent.",
                    "id": "action-type",
                    "label": "Action type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-action",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Rationale is the string component carried within Supplier risk case Proposed action; its classification and authority inherit from the owning field contract.",
                    "id": "rationale",
                    "label": "Rationale",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-action",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Restriction codes is the set carried within Supplier risk case Proposed action; its owning field governs allowed values and interpretation.",
                    "id": "restriction-codes",
                    "label": "Restriction codes",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-action",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Reversible is the boolean component carried within Supplier risk case Proposed action; its classification and authority inherit from the owning field contract.",
                    "id": "reversible",
                    "label": "Reversible",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-action",
                      "kind": "inherited-field"
                    },
                    "type": "boolean"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Authority requirement ID is the string component carried within Supplier risk case Proposed action; its classification and authority inherit from the owning field contract.",
                    "id": "authority-requirement-id",
                    "label": "Authority requirement ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-action",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence item ids links this structured value to governed evidence items through evidence-item-id within Supplier risk case Proposed action.",
                    "id": "evidence-item-ids",
                    "label": "Evidence item ids",
                    "listSemantics": "set",
                    "nullable": false,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links evidence item ids to governed evidence items through the canonical evidence-item-id field.",
                      "id": "supplier-risk-case-proposed-action-evidence-item-ids",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-action",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Timestamp when material evidence created the case.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "opened-at",
            "introducedIn": "1.0.0",
            "label": "Opened at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "continuous-risk-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Shared exception case that records ownership, resolution and evidence for this domain exception.",
            "exchangeScope": "unmapped",
            "id": "governance-exception-id",
            "introducedIn": "4.0.0",
            "label": "Governance exception case ID",
            "nullable": true,
            "referenceEntityId": "exception",
            "required": false,
            "sourceAuthority": {
              "id": "continuous-risk-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Authority envelope governing proposals, approvals and commitments for this record.",
            "exchangeScope": "unmapped",
            "id": "governance-authority-envelope-id",
            "introducedIn": "4.0.0",
            "label": "Governance authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "continuous-risk-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Evidence supporting this record and its governed outcome.",
            "exchangeScope": "unmapped",
            "id": "governance-evidence-item-ids",
            "introducedIn": "4.0.0",
            "label": "Governance evidence item IDs",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "continuous-risk-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "supplier-risk-case",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "supplier-id",
              "lifecycle-state"
            ],
            "id": "supplier-risk-case-by-supplier-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "severity",
              "opened-at"
            ],
            "id": "supplier-risk-case-by-severity-and-opened-at",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "case-family-key"
            ],
            "id": "supplier-risk-case-by-case-family-key",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "case",
        "label": "Supplier risk case",
        "lifecycle": [
          "open",
          "triaging",
          "monitoring",
          "action-proposed",
          "restricted",
          "resolved",
          "dismissed",
          "escalated"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "continuous-risk-monitoring",
        "owningDomainWorkblockId": "supplier-lifecycle-third-party-risk",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Supplier risk cases",
        "primaryKey": "supplier-risk-case-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the case to its supplier.",
            "id": "supplier-risk-case-belongs-to-supplier-profile-risk-case-supplier",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-risk-case-belongs-to-supplier-profile-risk-case-supplier",
            "required": true,
            "sourceFieldId": "supplier-id",
            "targetEntityId": "supplier-profile",
            "targetFieldId": "supplier-profile-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links supplier risk cases to the governed supplier risk signal record referenced by signal ids.",
            "id": "supplier-risk-case-belongs-to-supplier-risk-signal-supplier-risk-signal-ids-to-supplier-risk-signal",
            "introducedIn": "1.1.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-risk-case-belongs-to-supplier-risk-signal-supplier-risk-signal-ids-to-supplier-risk-signal",
            "required": true,
            "sourceFieldId": "signal-ids",
            "targetEntityId": "supplier-risk-signal",
            "targetFieldId": "supplier-risk-signal-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Shared governed exception case for this domain exception.",
            "id": "supplier-risk-case-governed-by-exception-supplier-risk-case-governance-exception",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "supplier-risk-case-governed-by-exception-supplier-risk-case-governance-exception",
            "required": false,
            "sourceFieldId": "governance-exception-id",
            "targetEntityId": "exception",
            "targetFieldId": "exception-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authority envelope governing this record.",
            "id": "supplier-risk-case-governed-by-authority-envelope-supplier-risk-case-governance-authority",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "supplier-risk-case-governed-by-authority-envelope-supplier-risk-case-governance-authority",
            "required": false,
            "sourceFieldId": "governance-authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Evidence supporting this record.",
            "id": "supplier-risk-case-evidenced-by-evidence-item-supplier-risk-case-governance-evidence",
            "introducedIn": "4.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "supplier-risk-case-evidenced-by-evidence-item-supplier-risk-case-governance-evidence",
            "required": false,
            "sourceFieldId": "governance-evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "supplier risk case",
          "risk exception",
          "restriction",
          "risk action"
        ],
        "sourceSystemRoleIds": [
          "execution-system",
          "system-of-record"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record",
          "collaboration-channel"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "supplier-performance-review",
          "supplier-performance-monitor-correct"
        ],
        "definition": "A measurable corrective action with owner, evidence, due state and verification criteria arising from supplier risk or performance evidence.",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk",
          "supplier-performance-innovation-relationship"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable identifier for the corrective action.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "supplier-remediation-action-id",
            "introducedIn": "1.0.0",
            "label": "Remediation action ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-remediation-exit",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Supplier accountable for or affected by the action.",
            "exchangeScope": "internal",
            "id": "supplier-id",
            "introducedIn": "1.0.0",
            "label": "Supplier ID",
            "nullable": false,
            "referenceEntityId": "supplier-profile",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-remediation-exit",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Risk case, assessment, finding or decision that requires remediation.",
            "exchangeScope": "internal",
            "id": "origin-reference",
            "introducedIn": "1.0.0",
            "label": "Origin reference",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-remediation-exit",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Optional supplier-performance signal that originated or materially supports this action; the signal owner may propose and route, while supplier-remediation-exit remains the sole owner of the corrective-action lifecycle.",
            "exchangeScope": "internal",
            "id": "performance-signal-id",
            "introducedIn": "4.3.0",
            "label": "Performance signal ID",
            "nullable": true,
            "referenceEntityId": "supplier-performance-signal",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-remediation-exit",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Measurable condition that must be true to complete the action.",
            "exchangeScope": "internal",
            "id": "required-outcome",
            "introducedIn": "1.0.0",
            "label": "Required outcome",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-remediation-exit",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "text"
          },
          {
            "classification": "restricted",
            "definition": "Typed evidence and independent verification checks required for completion.",
            "exchangeScope": "internal",
            "id": "evidence-requirements",
            "introducedIn": "1.0.0",
            "label": "Evidence requirements",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-remediation-exit",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Requirement ID is the string component carried within Supplier remediation action Evidence requirements; its classification and authority inherit from the owning field contract.",
                    "id": "requirement-id",
                    "label": "Requirement ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "evidence-requirements",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence type records the governed state or type within Supplier remediation action Evidence requirements without treating absence, unknown and zero as equivalent.",
                    "id": "evidence-type",
                    "label": "Evidence type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "evidence-requirements",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Verification rule ID is the string component carried within Supplier remediation action Evidence requirements; its classification and authority inherit from the owning field contract.",
                    "id": "verification-rule-id",
                    "label": "Verification rule ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "evidence-requirements",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Freshness rule ID is the string component carried within Supplier remediation action Evidence requirements; its classification and authority inherit from the owning field contract.",
                    "id": "freshness-rule-id",
                    "label": "Freshness rule ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "evidence-requirements",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Accepted source types is the set carried within Supplier remediation action Evidence requirements; its owning field governs allowed values and interpretation.",
                    "id": "accepted-source-types",
                    "label": "Accepted source types",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "evidence-requirements",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Must pass is the boolean component carried within Supplier remediation action Evidence requirements; its classification and authority inherit from the owning field contract.",
                    "id": "must-pass",
                    "label": "Must pass",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "evidence-requirements",
                      "kind": "inherited-field"
                    },
                    "type": "boolean"
                  }
                ],
                "uniqueBy": [
                  "requirement-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "personal",
            "definition": "Accountable role or party for delivering the outcome.",
            "exchangeScope": "internal",
            "id": "owner-reference",
            "introducedIn": "1.0.0",
            "label": "Owner reference",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-remediation-exit",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Committed corrective-action deadline.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "due-at",
            "introducedIn": "1.0.0",
            "label": "Due at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-remediation-exit",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "supplier-remediation-action",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "supplier-remediation-action-id"
            ],
            "id": "supplier-remediation-action-primary",
            "introducedIn": "4.3.0",
            "unique": true
          },
          {
            "fieldIds": [
              "supplier-id",
              "lifecycle-state"
            ],
            "id": "supplier-remediation-action-by-supplier-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "due-at",
              "lifecycle-state"
            ],
            "id": "supplier-remediation-action-by-due-at-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "origin-reference"
            ],
            "id": "supplier-remediation-action-by-origin-reference",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "performance-signal-id"
            ],
            "id": "supplier-remediation-action-by-performance-signal",
            "introducedIn": "4.3.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "control",
        "label": "Supplier remediation action",
        "lifecycle": [
          "proposed",
          "agreed",
          "in-progress",
          "evidence-submitted",
          "verified",
          "overdue",
          "failed",
          "waived",
          "closed"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "supplier-remediation-exit",
        "owningDomainWorkblockId": "supplier-lifecycle-third-party-risk",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Supplier remediation actions",
        "primaryKey": "supplier-remediation-action-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the action to its supplier.",
            "id": "supplier-remediation-action-belongs-to-supplier-profile-remediation-supplier",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-remediation-action-belongs-to-supplier-profile-remediation-supplier",
            "required": true,
            "sourceFieldId": "supplier-id",
            "targetEntityId": "supplier-profile",
            "targetFieldId": "supplier-profile-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the corrective action to the performance signal routed by supplier-performance-monitor-correct without transferring action ownership to the signal producer.",
            "id": "supplier-remediation-action-derived-from-supplier-performance-signal-remediation-performance-signal",
            "introducedIn": "4.3.0",
            "predicate": "derived-from",
            "qualifiedId": "supplier-remediation-action-derived-from-supplier-performance-signal-remediation-performance-signal",
            "required": false,
            "sourceFieldId": "performance-signal-id",
            "targetEntityId": "supplier-performance-signal",
            "targetFieldId": "supplier-performance-signal-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "supplier remediation",
          "corrective action",
          "risk treatment",
          "action plan"
        ],
        "sourceSystemRoleIds": [
          "execution-system",
          "source-of-record",
          "collaboration-channel"
        ],
        "storageClass": "tenant-record",
        "version": "4.1.0",
        "writebackSystemRoleIds": [
          "source-of-record",
          "collaboration-channel",
          "system-of-record"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "supplier-performance-review"
        ],
        "definition": "A controlled transition that removes procurement eligibility and access while resolving commitments, data, assets, continuity and evidence obligations.",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk",
          "supplier-performance-innovation-relationship"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable identifier for the exit transition.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "supplier-offboarding-case-id",
            "introducedIn": "1.0.0",
            "label": "Offboarding case ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-remediation-exit",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Canonical supplier being exited.",
            "exchangeScope": "internal",
            "id": "supplier-id",
            "introducedIn": "1.0.0",
            "label": "Supplier ID",
            "nullable": false,
            "referenceEntityId": "supplier-profile",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-remediation-exit",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Governed reason for the transition.",
            "enumValues": [
              "relationship-end",
              "risk",
              "performance",
              "consolidation",
              "duplicate",
              "inactivity",
              "other"
            ],
            "exchangeScope": "internal",
            "id": "exit-reason-code",
            "introducedIn": "1.0.0",
            "label": "Exit reason code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-remediation-exit",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Contracts, orders, invoices, access, data, assets and continuity actions with owners and receipts.",
            "exchangeScope": "internal",
            "id": "dependency-state",
            "introducedIn": "1.0.0",
            "label": "Dependency state",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-remediation-exit",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Dependency ID is the string component carried within Supplier offboarding case Dependency state; its classification and authority inherit from the owning field contract.",
                    "id": "dependency-id",
                    "label": "Dependency ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "dependency-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Dependency type records the governed state or type within Supplier offboarding case Dependency state without treating absence, unknown and zero as equivalent.",
                    "id": "dependency-type",
                    "label": "Dependency type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "dependency-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Record ID is the string component carried within Supplier offboarding case Dependency state; its classification and authority inherit from the owning field contract.",
                    "id": "record-id",
                    "label": "Record ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "dependency-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Owner person ID links this structured value to the governed person record within Supplier offboarding case Dependency state.",
                    "id": "owner-person-id",
                    "label": "Owner person ID",
                    "nullable": false,
                    "referenceEntityId": "person",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the owner person ID in dependency state to the referenced person via its canonical person ID.",
                      "id": "supplier-offboarding-case-dependency-state-owner-person-id",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "person-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "dependency-state",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Status records the governed state or type within Supplier offboarding case Dependency state without treating absence, unknown and zero as equivalent.",
                    "id": "status",
                    "label": "Status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "dependency-state",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Action due date is the date component carried within Supplier offboarding case Dependency state; its classification and authority inherit from the owning field contract.",
                    "id": "action-due-date",
                    "label": "Action due date",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "dependency-state",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Receipt evidence item ids links this structured value to governed evidence items through evidence-item-id within Supplier offboarding case Dependency state.",
                    "id": "receipt-evidence-item-ids",
                    "label": "Receipt evidence item ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links receipt evidence item ids to governed evidence items through the canonical evidence-item-id field.",
                      "id": "supplier-offboarding-case-dependency-state-receipt-evidence-item-ids",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "dependency-state",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  }
                ],
                "uniqueBy": [
                  "dependency-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Planned time by which all required exit controls should reconcile.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "target-completion-at",
            "introducedIn": "1.0.0",
            "label": "Target completion at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-remediation-exit",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Timestamp when every mandatory dependency and reconciliation check passed.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "completed-at",
            "introducedIn": "1.0.0",
            "label": "Completed at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-remediation-exit",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Authority envelope governing proposals, approvals and commitments for this record.",
            "exchangeScope": "unmapped",
            "id": "governance-authority-envelope-id",
            "introducedIn": "4.0.0",
            "label": "Governance authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-remediation-exit",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Evidence supporting this record and its governed outcome.",
            "exchangeScope": "unmapped",
            "id": "governance-evidence-item-ids",
            "introducedIn": "4.0.0",
            "label": "Governance evidence item IDs",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-remediation-exit",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "supplier-offboarding-case",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "supplier-id",
              "lifecycle-state"
            ],
            "id": "supplier-offboarding-case-by-supplier-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "target-completion-at"
            ],
            "id": "supplier-offboarding-case-by-target-completion-at",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "exit-reason-code"
            ],
            "id": "supplier-offboarding-case-by-exit-reason-code",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "case",
        "label": "Supplier offboarding case",
        "lifecycle": [
          "planned",
          "approved",
          "in-progress",
          "blocked",
          "completed",
          "cancelled",
          "reopened"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "supplier-remediation-exit",
        "owningDomainWorkblockId": "supplier-lifecycle-third-party-risk",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Supplier offboarding cases",
        "primaryKey": "supplier-offboarding-case-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the exit case to the supplier.",
            "id": "supplier-offboarding-case-belongs-to-supplier-profile-offboarding-supplier",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-offboarding-case-belongs-to-supplier-profile-offboarding-supplier",
            "required": true,
            "sourceFieldId": "supplier-id",
            "targetEntityId": "supplier-profile",
            "targetFieldId": "supplier-profile-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authority envelope governing this record.",
            "id": "supplier-offboarding-case-governed-by-authority-envelope-supplier-offboarding-case-governance-authority",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "supplier-offboarding-case-governed-by-authority-envelope-supplier-offboarding-case-governance-authority",
            "required": false,
            "sourceFieldId": "governance-authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Evidence supporting this record.",
            "id": "supplier-offboarding-case-evidenced-by-evidence-item-supplier-offboarding-case-governance-evidence",
            "introducedIn": "4.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "supplier-offboarding-case-evidenced-by-evidence-item-supplier-offboarding-case-governance-evidence",
            "required": false,
            "sourceFieldId": "governance-evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "supplier exit",
          "supplier offboarding",
          "access removal",
          "transition"
        ],
        "sourceSystemRoleIds": [
          "system-of-record",
          "identity-authority",
          "planning-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record",
          "identity-authority",
          "planning-system",
          "collaboration-channel"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "approve",
            "commit",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "third-party-risk-review"
        ],
        "definition": "An effective-dated, evidence-scored dependency from one supplier or site to an upstream supplier, facility or critical resource.",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable identifier for the effective-dated dependency edge.",
            "exchangeScope": "unmapped",
            "format": "uuid",
            "id": "supplier-tier-link-id",
            "introducedIn": "1.0.0",
            "label": "Tier link ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "continuous-risk-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "restricted",
            "definition": "Canonical downstream supplier that depends on the upstream node.",
            "exchangeScope": "unmapped",
            "id": "from-supplier-id",
            "introducedIn": "1.0.0",
            "label": "From supplier ID",
            "nullable": false,
            "referenceEntityId": "supplier-profile",
            "required": true,
            "sourceAuthority": {
              "id": "continuous-risk-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Canonical upstream supplier when the dependency resolves to a known supplier; null for facility or resource nodes.",
            "exchangeScope": "unmapped",
            "id": "to-supplier-id",
            "introducedIn": "1.0.0",
            "label": "To supplier ID",
            "nullable": true,
            "referenceEntityId": "supplier-profile",
            "required": false,
            "sourceAuthority": {
              "id": "continuous-risk-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Typed facility, location or resource identity when no canonical supplier record exists.",
            "exchangeScope": "unmapped",
            "id": "external-node",
            "introducedIn": "1.0.0",
            "label": "External node",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "continuous-risk-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Node type records the governed state or type within Supplier tier link External node without treating absence, unknown and zero as equivalent.",
                    "id": "node-type",
                    "label": "Node type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "external-node",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "External ID is the string component carried within Supplier tier link External node; its classification and authority inherit from the owning field contract.",
                    "id": "external-id",
                    "label": "External ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "external-node",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Identifier scheme is the string component carried within Supplier tier link External node; its classification and authority inherit from the owning field contract.",
                    "id": "identifier-scheme",
                    "label": "Identifier scheme",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "external-node",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Node name is the string component carried within Supplier tier link External node; its classification and authority inherit from the owning field contract.",
                    "id": "node-name",
                    "label": "Node name",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "external-node",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Location code records the governed code within Supplier tier link External node without treating absence, unknown and zero as equivalent.",
                    "id": "location-code",
                    "label": "Location code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "external-node",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Source system ID is the string component carried within Supplier tier link External node; its classification and authority inherit from the owning field contract.",
                    "id": "source-system-id",
                    "label": "Source system ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "external-node",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Nature of the upstream relationship.",
            "enumValues": [
              "materials",
              "component",
              "service",
              "facility",
              "logistics",
              "technology",
              "data",
              "other"
            ],
            "exchangeScope": "unmapped",
            "id": "dependency-type",
            "introducedIn": "1.0.0",
            "label": "Dependency type",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "continuous-risk-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Source snapshot or supplier assertion supporting the edge.",
            "exchangeScope": "unmapped",
            "id": "evidence-reference",
            "introducedIn": "1.0.0",
            "label": "Evidence reference",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "continuous-risk-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Calibrated confidence in the node identities and relationship.",
            "exchangeScope": "unmapped",
            "format": "0..1",
            "id": "confidence",
            "introducedIn": "1.0.0",
            "label": "Confidence",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "continuous-risk-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "decimal"
          },
          {
            "classification": "internal",
            "definition": "Date after which the relationship must be re-observed or re-verified.",
            "exchangeScope": "unmapped",
            "format": "date",
            "id": "valid-to",
            "introducedIn": "1.0.0",
            "label": "Valid to",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "continuous-risk-monitoring",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "supplier-tier-link",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "from-supplier-id",
              "to-supplier-id"
            ],
            "id": "supplier-tier-link-by-from-supplier-id-and-to-supplier-id",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "dependency-type",
              "lifecycle-state"
            ],
            "id": "supplier-tier-link-by-dependency-type-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "valid-to"
            ],
            "id": "supplier-tier-link-by-valid-to",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "reference",
        "label": "Supplier tier link",
        "lifecycle": [
          "observed",
          "asserted",
          "verified",
          "disputed",
          "expired",
          "superseded"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "continuous-risk-monitoring",
        "owningDomainWorkblockId": "supplier-lifecycle-third-party-risk",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Supplier tier links",
        "primaryKey": "supplier-tier-link-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Connects the dependency edge to the downstream supplier.",
            "id": "supplier-tier-link-belongs-to-supplier-profile-tier-link-from-supplier",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-tier-link-belongs-to-supplier-profile-tier-link-from-supplier",
            "required": true,
            "sourceFieldId": "from-supplier-id",
            "targetEntityId": "supplier-profile",
            "targetFieldId": "supplier-profile-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Connects the dependency edge to a resolved upstream supplier.",
            "id": "supplier-tier-link-belongs-to-supplier-profile-tier-link-to-supplier",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-tier-link-belongs-to-supplier-profile-tier-link-to-supplier",
            "required": false,
            "sourceFieldId": "to-supplier-id",
            "targetEntityId": "supplier-profile",
            "targetFieldId": "supplier-profile-id"
          }
        ],
        "retentionClass": "reference",
        "searchTerms": [
          "sub-tier",
          "tier n",
          "supplier dependency",
          "supply network"
        ],
        "sourceSystemRoleIds": [
          "managed-network",
          "analytical-system",
          "transport-execution-boundary"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "execution-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "category-opportunity-radar",
          "requisition-policy-routing"
        ],
        "definition": "A normalised statement of business need and context used to present policy-valid buying options before a requisition or commitment exists.",
        "domainWorkblockIds": [
          "buying-ordering-receiving",
          "strategy-policy-category-spend"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for the pre-requisition request.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "buying-request-id",
            "introducedIn": "1.0.0",
            "label": "Buying request ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "guided-buying",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "personal",
            "definition": "Authenticated requester or governed service identity.",
            "exchangeScope": "mapped",
            "id": "requester-reference",
            "introducedIn": "1.0.0",
            "label": "Requester reference",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "guided-buying",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:BuyerCustomerParty/cac:Party/cac:Contact/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Governed organizational scope for policy, budget and authority.",
            "exchangeScope": "mapped",
            "id": "business-unit-code",
            "introducedIn": "1.0.0",
            "label": "Business unit code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "guided-buying",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:BuyerCustomerParty/cac:Party/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Requester-authored and normalised description of required outcome, not a fabricated item specification.",
            "exchangeScope": "mapped",
            "id": "need-description",
            "introducedIn": "1.0.0",
            "label": "Need description",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "guided-buying",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OrderLine/cac:LineItem/cac:Item/cbc:Description",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "text"
          },
          {
            "classification": "internal",
            "definition": "Chosen governed commodity or service classification with confidence and source.",
            "exchangeScope": "mapped",
            "format": "UNSPSC",
            "id": "classification-code",
            "introducedIn": "1.0.0",
            "label": "Classification code",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "guided-buying",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "conceptId": "commodity-classification",
                "coverage": "exact",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "code-list",
                "path": "CommodityCode",
                "releaseId": "unresolved-release",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "unspsc",
                "transformation": "none"
              },
              {
                "coverage": "exact",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OrderLine/cac:LineItem/cac:Item/cac:CommodityClassification/cbc:ItemClassificationCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Requester estimate or policy-calculated range with currency and provenance.",
            "exchangeScope": "mapped",
            "id": "estimated-value",
            "introducedIn": "1.0.0",
            "label": "Estimated value",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "guided-buying",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:AnticipatedMonetaryTotal/cbc:PayableAmount",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Estimate type records the governed state or type within Buying request Estimated value without treating absence, unknown and zero as equivalent.",
                    "id": "estimate-type",
                    "label": "Estimate type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "estimated-value",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Currency code records the governed code within Buying request Estimated value without treating absence, unknown and zero as equivalent.",
                    "id": "currency-code",
                    "label": "Currency code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "estimated-value",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Point amount is the decimal component carried within Buying request Estimated value; its classification and authority inherit from the owning field contract.",
                    "id": "point-amount",
                    "label": "Point amount",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "estimated-value",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Minimum amount is the decimal component carried within Buying request Estimated value; its classification and authority inherit from the owning field contract.",
                    "id": "minimum-amount",
                    "label": "Minimum amount",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "estimated-value",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Maximum amount is the decimal component carried within Buying request Estimated value; its classification and authority inherit from the owning field contract.",
                    "id": "maximum-amount",
                    "label": "Maximum amount",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "estimated-value",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Provenance source ID is the string component carried within Buying request Estimated value; its classification and authority inherit from the owning field contract.",
                    "id": "provenance-source-id",
                    "label": "Provenance source ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "estimated-value",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Calculated at is the timestamp component carried within Buying request Estimated value; its classification and authority inherit from the owning field contract.",
                    "id": "calculated-at",
                    "label": "Calculated at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "estimated-value",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Business date by which the outcome is required.",
            "exchangeScope": "mapped",
            "format": "date",
            "id": "needed-by-date",
            "introducedIn": "1.0.0",
            "label": "Needed by date",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "guided-buying",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:Delivery/cac:RequestedDeliveryPeriod/cbc:EndDate",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "date"
          },
          {
            "classification": "confidential",
            "definition": "Ranked, evidence-linked policy-valid routes, items or suppliers; every option states freshness and constraints.",
            "exchangeScope": "internal",
            "id": "option-set",
            "introducedIn": "1.0.0",
            "label": "Option set",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "guided-buying",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Option ID is the string component carried within Buying request Option set; its classification and authority inherit from the owning field contract.",
                    "id": "option-id",
                    "label": "Option ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "option-set",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Option type records the governed state or type within Buying request Option set without treating absence, unknown and zero as equivalent.",
                    "id": "option-type",
                    "label": "Option type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "option-set",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Rank is the integer component carried within Buying request Option set; its classification and authority inherit from the owning field contract.",
                    "id": "rank",
                    "label": "Rank",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "option-set",
                      "kind": "inherited-field"
                    },
                    "type": "integer"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Route code records the governed code within Buying request Option set without treating absence, unknown and zero as equivalent.",
                    "id": "route-code",
                    "label": "Route code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "option-set",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Item service ID links this structured value to the governed item-service record within Buying request Option set.",
                    "id": "item-service-id",
                    "label": "Item service ID",
                    "nullable": true,
                    "referenceEntityId": "item-service",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the item service ID in option set to the referenced item service via its canonical item service ID.",
                      "id": "buying-request-option-set-item-service-id",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "item-service-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "option-set",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Supplier party ID links this structured value to the governed party record within Buying request Option set.",
                    "id": "supplier-party-id",
                    "label": "Supplier party ID",
                    "nullable": true,
                    "referenceEntityId": "party",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the supplier party ID in option set to the referenced party via its canonical party ID.",
                      "id": "buying-request-option-set-supplier-party-id",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "party-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "option-set",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Evidence item ids links this structured value to governed evidence items through evidence-item-id within Buying request Option set.",
                    "id": "evidence-item-ids",
                    "label": "Evidence item ids",
                    "listSemantics": "set",
                    "nullable": false,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links evidence item ids to governed evidence items through the canonical evidence-item-id field.",
                      "id": "buying-request-option-set-evidence-item-ids",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "option-set",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Freshness observed at is the timestamp component carried within Buying request Option set; its classification and authority inherit from the owning field contract.",
                    "id": "freshness-observed-at",
                    "label": "Freshness observed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "option-set",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Constraint codes is the set carried within Buying request Option set; its owning field governs allowed values and interpretation.",
                    "id": "constraint-codes",
                    "label": "Constraint codes",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "option-set",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Policy valid is the boolean component carried within Buying request Option set; its classification and authority inherit from the owning field contract.",
                    "id": "policy-valid",
                    "label": "Policy valid",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "option-set",
                      "kind": "inherited-field"
                    },
                    "type": "boolean"
                  }
                ],
                "uniqueBy": [
                  "option-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Committed routing result after requester choice or bounded policy action.",
            "enumValues": [
              "catalogue",
              "requisition",
              "spot-buy",
              "sourcing",
              "contract-request",
              "supplier-onboarding",
              "stop"
            ],
            "exchangeScope": "internal",
            "id": "selected-route",
            "introducedIn": "1.0.0",
            "label": "Selected route",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "guided-buying",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Canonical company category linked beside any external classification code.",
            "exchangeScope": "unmapped",
            "id": "category-id",
            "introducedIn": "4.0.0",
            "label": "Category ID",
            "nullable": true,
            "referenceEntityId": "category",
            "required": false,
            "sourceAuthority": {
              "id": "guided-buying",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Authority envelope governing proposals, approvals and commitments for this record.",
            "exchangeScope": "unmapped",
            "id": "governance-authority-envelope-id",
            "introducedIn": "4.0.0",
            "label": "Governance authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "guided-buying",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Evidence supporting this record and its governed outcome.",
            "exchangeScope": "unmapped",
            "id": "governance-evidence-item-ids",
            "introducedIn": "4.0.0",
            "label": "Governance evidence item IDs",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "guided-buying",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "buying-request",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "requester-reference",
              "lifecycle-state"
            ],
            "id": "buying-request-by-requester-reference-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "business-unit-code",
              "needed-by-date"
            ],
            "id": "buying-request-by-business-unit-code-and-needed-by-date",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "selected-route"
            ],
            "id": "buying-request-by-selected-route",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "case",
        "label": "Buying request",
        "lifecycle": [
          "captured",
          "clarifying",
          "options-ready",
          "selected",
          "routed",
          "cancelled",
          "expired"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "guided-buying",
        "owningDomainWorkblockId": "buying-ordering-receiving",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Buying requests",
        "primaryKey": "buying-request-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Canonical company category for this purchase classification.",
            "id": "buying-request-classified-as-category-buying-request-category",
            "introducedIn": "4.0.0",
            "predicate": "classified-as",
            "qualifiedId": "buying-request-classified-as-category-buying-request-category",
            "required": false,
            "sourceFieldId": "category-id",
            "targetEntityId": "category",
            "targetFieldId": "category-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authority envelope governing this record.",
            "id": "buying-request-governed-by-authority-envelope-buying-request-governance-authority",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "buying-request-governed-by-authority-envelope-buying-request-governance-authority",
            "required": false,
            "sourceFieldId": "governance-authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Evidence supporting this record.",
            "id": "buying-request-evidenced-by-evidence-item-buying-request-governance-evidence",
            "introducedIn": "4.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "buying-request-evidenced-by-evidence-item-buying-request-governance-evidence",
            "required": false,
            "sourceFieldId": "governance-evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          }
        ],
        "retentionClass": "operational",
        "searchTerms": [
          "buying request",
          "purchase request",
          "business need",
          "guided buying"
        ],
        "sourceSystemRoleIds": [
          "collaboration-channel",
          "execution-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "execution-system",
          "collaboration-channel"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "approve",
            "commit",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": false,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "guided-buying",
          "purchase-order-exception",
          "purchase-order-orchestration",
          "requisition-policy-routing"
        ],
        "definition": "An effective-dated supplier offering with item or service identity, price, contract, availability and buying constraints.",
        "domainWorkblockIds": [
          "buying-ordering-receiving"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for the effective-dated offering.",
            "exchangeScope": "mapped",
            "format": "uuid",
            "id": "catalogue-line-id",
            "introducedIn": "1.0.0",
            "label": "Catalogue line ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "catalogue-management-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "catalogue",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:CatalogueLine/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Canonical supplier providing the offering.",
            "exchangeScope": "mapped",
            "id": "supplier-id",
            "introducedIn": "1.0.0",
            "label": "Supplier ID",
            "nullable": false,
            "referenceEntityId": "supplier-profile",
            "required": true,
            "sourceAuthority": {
              "id": "catalogue-management-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "catalogue",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ProviderParty/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Supplier-assigned item or service identifier.",
            "exchangeScope": "mapped",
            "id": "supplier-item-id",
            "introducedIn": "1.0.0",
            "label": "Supplier item ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "catalogue-management-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "catalogue",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:CatalogueLine/cac:Item/cac:SellersItemIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Approved searchable description of the item or service.",
            "exchangeScope": "mapped",
            "id": "description",
            "introducedIn": "1.0.0",
            "label": "Description",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "catalogue-management-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "catalogue",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:CatalogueLine/cac:Item/cbc:Description",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "text"
          },
          {
            "classification": "internal",
            "definition": "Governed commodity or service classification.",
            "exchangeScope": "mapped",
            "format": "UNSPSC",
            "id": "classification-code",
            "introducedIn": "1.0.0",
            "label": "Classification code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "catalogue-management-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "conceptId": "commodity-classification",
                "coverage": "exact",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "code-list",
                "path": "CommodityCode",
                "releaseId": "unresolved-release",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "unspsc",
                "transformation": "none"
              },
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "catalogue",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:CatalogueLine/cac:Item/cac:CommodityClassification/cbc:ItemClassificationCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Optional governed catalogue default for whether this offering is bought as goods, services or a mixed offering. A committed spend-record value takes precedence.",
            "enumValues": [
              "goods",
              "services",
              "mixed"
            ],
            "exchangeScope": "internal",
            "id": "buying-mode",
            "introducedIn": "4.0.0",
            "label": "Buying mode",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "catalogue-management-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Effective unit price including currency, base quantity and price conditions.",
            "exchangeScope": "mapped",
            "id": "unit-price",
            "introducedIn": "1.0.0",
            "label": "Unit price",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "catalogue-management-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "catalogue",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:CatalogueLine/cac:RequiredItemLocationQuantity/cac:Price/cbc:PriceAmount",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Amount is the decimal component carried within Catalogue line Unit price; its classification and authority inherit from the owning field contract.",
                    "id": "amount",
                    "label": "Amount",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "unit-price",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Currency code records the governed code within Catalogue line Unit price without treating absence, unknown and zero as equivalent.",
                    "id": "currency-code",
                    "label": "Currency code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "unit-price",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Base quantity is the quantity component carried within Catalogue line Unit price; its classification and authority inherit from the owning field contract.",
                    "id": "base-quantity",
                    "label": "Base quantity",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "unit-price",
                      "kind": "inherited-field"
                    },
                    "type": "quantity",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "quantity-value",
                      "schemaVersion": "1.0.0"
                    }
                  },
                  {
                    "classification": "confidential",
                    "definition": "Condition codes is the set carried within Catalogue line Unit price; its owning field governs allowed values and interpretation.",
                    "id": "condition-codes",
                    "label": "Condition codes",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "unit-price",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Valid from is the timestamp component carried within Catalogue line Unit price; its classification and authority inherit from the owning field contract.",
                    "id": "valid-from",
                    "label": "Valid from",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "unit-price",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Valid to is the timestamp component carried within Catalogue line Unit price; its classification and authority inherit from the owning field contract.",
                    "id": "valid-to",
                    "label": "Valid to",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "unit-price",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Optional governing contract for the offering and price.",
            "exchangeScope": "mapped",
            "id": "contract-id",
            "introducedIn": "1.0.0",
            "label": "Contract ID",
            "nullable": true,
            "referenceEntityId": "contract",
            "required": false,
            "sourceAuthority": {
              "id": "catalogue-management-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "catalogue",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ReferencedContract/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Minimum quantity, geography, user scope, lead time and configurable-option rules.",
            "exchangeScope": "mapped",
            "id": "buying-constraints",
            "introducedIn": "1.0.0",
            "label": "Buying constraints",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "catalogue-management-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "catalogue",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:CatalogueLine/cac:RequiredItemLocationQuantity",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "internal",
                    "definition": "Rule set version is the string component carried within Catalogue line Buying constraints; its classification and authority inherit from the owning field contract.",
                    "id": "rule-set-version",
                    "label": "Rule set version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "buying-constraints",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "internal",
                    "definition": "Minimum order quantity is the quantity component carried within Catalogue line Buying constraints; its classification and authority inherit from the owning field contract.",
                    "id": "minimum-order-quantity",
                    "label": "Minimum order quantity",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "buying-constraints",
                      "kind": "inherited-field"
                    },
                    "type": "quantity",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "quantity-value",
                      "schemaVersion": "1.0.0"
                    }
                  },
                  {
                    "classification": "internal",
                    "definition": "Geography codes is the set carried within Catalogue line Buying constraints; its owning field governs allowed values and interpretation.",
                    "id": "geography-codes",
                    "label": "Geography codes",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "buying-constraints",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "internal",
                    "definition": "User scope codes is the set carried within Catalogue line Buying constraints; its owning field governs allowed values and interpretation.",
                    "id": "user-scope-codes",
                    "label": "User scope codes",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "buying-constraints",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "internal",
                    "definition": "Lead time days is the integer component carried within Catalogue line Buying constraints; its classification and authority inherit from the owning field contract.",
                    "id": "lead-time-days",
                    "label": "Lead time days",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "buying-constraints",
                      "kind": "inherited-field"
                    },
                    "type": "integer"
                  },
                  {
                    "classification": "internal",
                    "definition": "Configurable option rule ids is the set carried within Catalogue line Buying constraints; its owning field governs allowed values and interpretation.",
                    "id": "configurable-option-rule-ids",
                    "label": "Configurable option rule ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "buying-constraints",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Last date on which the offering can be selected for a new request.",
            "exchangeScope": "mapped",
            "format": "date",
            "id": "valid-to",
            "introducedIn": "1.0.0",
            "label": "Valid to",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "catalogue-management-service",
              "kind": "platform-service"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "catalogue",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ValidityPeriod/cbc:EndDate",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "date"
          },
          {
            "classification": "internal",
            "definition": "Canonical company category linked beside any external classification code.",
            "exchangeScope": "unmapped",
            "id": "category-id",
            "introducedIn": "4.0.0",
            "label": "Category ID",
            "nullable": true,
            "referenceEntityId": "category",
            "required": false,
            "sourceAuthority": {
              "id": "catalogue-management-service",
              "kind": "platform-service"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "catalogue-line",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "supplier-id",
              "supplier-item-id"
            ],
            "id": "catalogue-line-by-supplier-id-and-supplier-item-id",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "classification-code",
              "lifecycle-state"
            ],
            "id": "catalogue-line-by-classification-code-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "valid-to",
              "lifecycle-state"
            ],
            "id": "catalogue-line-by-valid-to-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "contract-id"
            ],
            "id": "catalogue-line-by-contract-id",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "reference",
        "label": "Catalogue line",
        "lifecycle": [
          "draft",
          "active",
          "blocked",
          "expired",
          "superseded",
          "withdrawn"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerServiceId": "catalogue-management-service",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "platform-services-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Catalogue lines",
        "primaryKey": "catalogue-line-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the offering to the canonical supplier.",
            "id": "catalogue-line-belongs-to-supplier-profile-catalogue-supplier",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "catalogue-line-belongs-to-supplier-profile-catalogue-supplier",
            "required": true,
            "sourceFieldId": "supplier-id",
            "targetEntityId": "supplier-profile",
            "targetFieldId": "supplier-profile-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the offering to its governing agreement.",
            "id": "catalogue-line-belongs-to-contract-catalogue-contract",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "catalogue-line-belongs-to-contract-catalogue-contract",
            "required": false,
            "sourceFieldId": "contract-id",
            "targetEntityId": "contract",
            "targetFieldId": "contract-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Canonical company category for this purchase classification.",
            "id": "catalogue-line-classified-as-category-catalogue-line-category",
            "introducedIn": "4.0.0",
            "predicate": "classified-as",
            "qualifiedId": "catalogue-line-classified-as-category-catalogue-line-category",
            "required": false,
            "sourceFieldId": "category-id",
            "targetEntityId": "category",
            "targetFieldId": "category-id"
          }
        ],
        "retentionClass": "reference",
        "searchTerms": [
          "catalogue item",
          "supplier offering",
          "contracted price",
          "punchout"
        ],
        "sourceSystemRoleIds": [
          "execution-system",
          "managed-network",
          "system-of-record"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "execution-system",
          "planning-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "policy-rule-lifecycle",
          "purchase-order-orchestration"
        ],
        "definition": "A policy-evaluated internal request for procurement commitment, including accounting, budget, authority and routing state.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "buying-ordering-receiving"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable tenant-scoped identifier for the requisition.",
            "exchangeScope": "unmapped",
            "format": "uuid",
            "id": "requisition-id",
            "introducedIn": "1.0.0",
            "label": "Requisition ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "requisition-policy-routing",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Human-facing governed requisition number.",
            "exchangeScope": "unmapped",
            "id": "requisition-number",
            "introducedIn": "1.0.0",
            "label": "Requisition number",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "requisition-policy-routing",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Pre-requisition request that supplied the business intent and selected route.",
            "exchangeScope": "unmapped",
            "id": "source-buying-request-id",
            "introducedIn": "1.0.0",
            "label": "Source buying request ID",
            "nullable": true,
            "referenceEntityId": "buying-request",
            "required": false,
            "sourceAuthority": {
              "id": "requisition-policy-routing",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "personal",
            "definition": "Authenticated requester or service identity.",
            "exchangeScope": "unmapped",
            "id": "requester-reference",
            "introducedIn": "1.0.0",
            "label": "Requester reference",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "requisition-policy-routing",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Organizational scope for policy, budget and authority.",
            "exchangeScope": "unmapped",
            "id": "business-unit-code",
            "introducedIn": "1.0.0",
            "label": "Business unit code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "requisition-policy-routing",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "compositeValueContract": {
              "componentFieldIds": [
                "total-amount"
              ],
              "representation": "registry-object",
              "schemaId": "money-value",
              "schemaVersion": "2.0.0"
            },
            "definition": "Calculated sum of current lines, charges and taxes with document currency, definition version and explicit rounding rule.",
            "exchangeScope": "mapped",
            "id": "total-amount",
            "introducedIn": "1.0.0",
            "label": "Total amount",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "requisition-policy-routing",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "components": [
                  {
                    "standardPath": "alphabeticCode",
                    "valuePath": "currency-code"
                  }
                ],
                "conceptId": "currency-code",
                "coverage": "exact",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "code-list",
                "path": "alphabeticCode",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-4217",
                "transformation": "none"
              },
              {
                "components": [
                  {
                    "standardPath": "cac:AnticipatedMonetaryTotal/cbc:PayableAmount",
                    "valuePath": "amount"
                  },
                  {
                    "standardPath": "cac:AnticipatedMonetaryTotal/cbc:PayableAmount/@currencyID",
                    "valuePath": "currency-code"
                  }
                ],
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:AnticipatedMonetaryTotal/cbc:PayableAmount",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "money",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "money-value",
              "schemaVersion": "2.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Versioned rule results, exceptions, evidence freshness and permitted route.",
            "exchangeScope": "unmapped",
            "id": "policy-evaluation",
            "introducedIn": "1.0.0",
            "label": "Policy evaluation",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "requisition-policy-routing",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Policy version ID links this structured value to governed policy version record through policy-version-id within Requisition Policy evaluation.",
                    "id": "policy-version-id",
                    "label": "Policy version ID",
                    "nullable": false,
                    "referenceEntityId": "policy-version",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links policy version id to governed policy version record through the canonical policy-version-id field.",
                      "id": "requisition-policy-evaluation-policy-version-id",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "policy-version-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "policy-evaluation",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Evaluated at is the timestamp component carried within Requisition Policy evaluation; its classification and authority inherit from the owning field contract.",
                    "id": "evaluated-at",
                    "label": "Evaluated at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "policy-evaluation",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Result is the string component carried within Requisition Policy evaluation; its classification and authority inherit from the owning field contract.",
                    "id": "result",
                    "label": "Result",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "policy-evaluation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Rule result codes is the set carried within Requisition Policy evaluation; its owning field governs allowed values and interpretation.",
                    "id": "rule-result-codes",
                    "label": "Rule result codes",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "policy-evaluation",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Exception case ids links this structured value to governed exception cases through exception-id within Requisition Policy evaluation.",
                    "id": "exception-ids",
                    "label": "Exception case ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "referenceEntityId": "exception",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links exception case ids to governed exception cases through the canonical exception-id field.",
                      "id": "requisition-policy-evaluation-exception-ids",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "exception-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "policy-evaluation",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Evidence freshness status records the governed state or type within Requisition Policy evaluation without treating absence, unknown and zero as equivalent.",
                    "id": "evidence-freshness-status",
                    "label": "Evidence freshness status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "policy-evaluation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Permitted route code records the governed code within Requisition Policy evaluation without treating absence, unknown and zero as equivalent.",
                    "id": "permitted-route-code",
                    "label": "Permitted route code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "policy-evaluation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Reservation identifier, amount, accounting scope, expiry and reconciliation state.",
            "exchangeScope": "mapped",
            "id": "budget-reservation",
            "introducedIn": "1.0.0",
            "label": "Budget reservation",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "requisition-policy-routing",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "extension",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:AccountingCustomerParty",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "extension-required"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Reservation ID is the string component carried within Requisition Budget reservation; its classification and authority inherit from the owning field contract.",
                    "id": "reservation-id",
                    "label": "Reservation ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "budget-reservation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Reserved amount is the money component carried within Requisition Budget reservation; its classification and authority inherit from the owning field contract.",
                    "id": "reserved-amount",
                    "label": "Reserved amount",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "budget-reservation",
                      "kind": "inherited-field"
                    },
                    "type": "money",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "money-value",
                      "schemaVersion": "2.0.0"
                    }
                  },
                  {
                    "classification": "restricted",
                    "definition": "Accounting scope code records the governed code within Requisition Budget reservation without treating absence, unknown and zero as equivalent.",
                    "id": "accounting-scope-code",
                    "label": "Accounting scope code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "budget-reservation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Expires at is the timestamp component carried within Requisition Budget reservation; its classification and authority inherit from the owning field contract.",
                    "id": "expires-at",
                    "label": "Expires at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "budget-reservation",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Reconciliation status records the governed state or type within Requisition Budget reservation without treating absence, unknown and zero as equivalent.",
                    "id": "reconciliation-status",
                    "label": "Reconciliation status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "budget-reservation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Reconciled at is the timestamp component carried within Requisition Budget reservation; its classification and authority inherit from the owning field contract.",
                    "id": "reconciled-at",
                    "label": "Reconciled at",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "budget-reservation",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Authorised budget against which the requisition is checked or reserved.",
            "exchangeScope": "unmapped",
            "id": "budget-id",
            "introducedIn": "4.0.0",
            "label": "Budget ID",
            "nullable": true,
            "referenceEntityId": "budget",
            "required": false,
            "sourceAuthority": {
              "id": "requisition-policy-routing",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "requisition",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "requisition-number"
            ],
            "id": "requisition-by-requisition-number",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "requester-reference",
              "lifecycle-state"
            ],
            "id": "requisition-by-requester-reference-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "business-unit-code",
              "lifecycle-state"
            ],
            "id": "requisition-by-business-unit-code-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "source-buying-request-id"
            ],
            "id": "requisition-by-source-buying-request-id",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "transaction",
        "label": "Requisition",
        "lifecycle": [
          "draft",
          "validating",
          "needs-information",
          "routed",
          "approved",
          "rejected",
          "converted",
          "cancelled"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "requisition-policy-routing",
        "owningDomainWorkblockId": "buying-ordering-receiving",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Requisitions",
        "primaryKey": "requisition-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the commitment request to its original business need.",
            "id": "requisition-references-buying-request-requisition-buying-request",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "requisition-references-buying-request-requisition-buying-request",
            "required": false,
            "sourceFieldId": "source-buying-request-id",
            "targetEntityId": "buying-request",
            "targetFieldId": "buying-request-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authorised budget used for requisition policy and reservation checks.",
            "id": "requisition-governed-by-budget-requisition-budget",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "requisition-governed-by-budget-requisition-budget",
            "required": false,
            "sourceFieldId": "budget-id",
            "targetEntityId": "budget",
            "targetFieldId": "budget-id"
          }
        ],
        "retentionClass": "financial",
        "searchTerms": [
          "requisition",
          "purchase requisition",
          "approval request",
          "budget reservation"
        ],
        "sourceSystemRoleIds": [
          "execution-system",
          "planning-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "planning-system",
          "execution-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "purchase-order-orchestration"
        ],
        "definition": "A separately classifiable and routable requested item or service with quantity, price, supplier, delivery and accounting intent.",
        "domainWorkblockIds": [
          "buying-ordering-receiving"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for the requested line.",
            "exchangeScope": "unmapped",
            "format": "uuid",
            "id": "requisition-line-id",
            "introducedIn": "1.0.0",
            "label": "Requisition line ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "requisition-policy-routing",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Header to which the line belongs.",
            "exchangeScope": "unmapped",
            "id": "requisition-id",
            "introducedIn": "1.0.0",
            "label": "Requisition ID",
            "nullable": false,
            "referenceEntityId": "requisition",
            "required": true,
            "sourceAuthority": {
              "id": "requisition-policy-routing",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Stable display and exchange sequence within the requisition.",
            "exchangeScope": "mapped",
            "id": "line-number",
            "introducedIn": "1.0.0",
            "label": "Line number",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "requisition-policy-routing",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OrderLine/cac:LineItem/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "integer"
          },
          {
            "classification": "confidential",
            "definition": "Selected effective-dated catalogue offering when the line is catalogue-backed.",
            "exchangeScope": "unmapped",
            "id": "catalogue-line-id",
            "introducedIn": "1.0.0",
            "label": "Catalogue line ID",
            "nullable": true,
            "referenceEntityId": "catalogue-line",
            "required": false,
            "sourceAuthority": {
              "id": "requisition-policy-routing",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Proposed canonical supplier when known.",
            "exchangeScope": "mapped",
            "id": "supplier-id",
            "introducedIn": "1.0.0",
            "label": "Supplier ID",
            "nullable": true,
            "referenceEntityId": "supplier-profile",
            "required": false,
            "sourceAuthority": {
              "id": "requisition-policy-routing",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:SellerSupplierParty/cac:Party/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Requested item or service description.",
            "exchangeScope": "mapped",
            "id": "description",
            "introducedIn": "1.0.0",
            "label": "Description",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "requisition-policy-routing",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OrderLine/cac:LineItem/cac:Item/cbc:Description",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "text"
          },
          {
            "classification": "confidential",
            "definition": "Requested quantity and unit of measure.",
            "exchangeScope": "mapped",
            "id": "quantity",
            "introducedIn": "1.0.0",
            "label": "Quantity",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "requisition-policy-routing",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "components": [
                  {
                    "standardPath": "cac:OrderLine/cac:LineItem/cbc:Quantity",
                    "valuePath": "value"
                  },
                  {
                    "standardPath": "cac:OrderLine/cac:LineItem/cbc:Quantity/@unitCode",
                    "valuePath": "unit-code"
                  }
                ],
                "coverage": "exact",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OrderLine/cac:LineItem/cbc:Quantity",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "quantity",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "quantity-value",
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Proposed unit price with currency, basis and price-source freshness.",
            "exchangeScope": "mapped",
            "id": "unit-price",
            "introducedIn": "1.0.0",
            "label": "Unit price",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "requisition-policy-routing",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "UBL PriceAmount does not carry the required price-source and price-observation provenance leaves.",
                "path": "cac:OrderLine/cac:LineItem/cac:Price/cbc:PriceAmount",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Amount is the decimal component carried within Requisition line Unit price; its classification and authority inherit from the owning field contract.",
                    "id": "amount",
                    "label": "Amount",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "unit-price",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Currency code records the governed code within Requisition line Unit price without treating absence, unknown and zero as equivalent.",
                    "id": "currency-code",
                    "label": "Currency code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "unit-price",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Basis quantity is the decimal component carried within Requisition line Unit price; its classification and authority inherit from the owning field contract.",
                    "id": "basis-quantity",
                    "label": "Basis quantity",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "unit-price",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Basis unit code records the governed code within Requisition line Unit price without treating absence, unknown and zero as equivalent.",
                    "id": "basis-unit-code",
                    "label": "Basis unit code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "unit-price",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Price source ID is the string component carried within Requisition line Unit price; its classification and authority inherit from the owning field contract.",
                    "id": "price-source-id",
                    "label": "Price source ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "unit-price",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Price observed at is the timestamp component carried within Requisition line Unit price; its classification and authority inherit from the owning field contract.",
                    "id": "price-observed-at",
                    "label": "Price observed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "unit-price",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Validated cost object, ledger and percentage or amount allocation.",
            "exchangeScope": "mapped",
            "id": "accounting-splits",
            "introducedIn": "1.0.0",
            "label": "Accounting splits",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "requisition-policy-routing",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OrderLine/cac:LineItem/cbc:AccountingCost",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Split ID is the string component carried within Requisition line Accounting splits; its classification and authority inherit from the owning field contract.",
                    "id": "split-id",
                    "label": "Split ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "accounting-splits",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Ledger account code records the governed code within Requisition line Accounting splits without treating absence, unknown and zero as equivalent.",
                    "id": "ledger-account-code",
                    "label": "Ledger account code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "accounting-splits",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Cost object code records the governed code within Requisition line Accounting splits without treating absence, unknown and zero as equivalent.",
                    "id": "cost-object-code",
                    "label": "Cost object code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "accounting-splits",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Allocation method is the string component carried within Requisition line Accounting splits; its classification and authority inherit from the owning field contract.",
                    "id": "allocation-method",
                    "label": "Allocation method",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "accounting-splits",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Percentage is the decimal component carried within Requisition line Accounting splits; its classification and authority inherit from the owning field contract.",
                    "id": "percentage",
                    "label": "Percentage",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "accounting-splits",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Amount is the money component carried within Requisition line Accounting splits; its classification and authority inherit from the owning field contract.",
                    "id": "amount",
                    "label": "Amount",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "accounting-splits",
                      "kind": "inherited-field"
                    },
                    "type": "money",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "money-value",
                      "schemaVersion": "2.0.0"
                    }
                  }
                ],
                "uniqueBy": [
                  "split-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "requisition-line",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "requisition-id",
              "line-number"
            ],
            "id": "requisition-line-by-requisition-id-and-line-number",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "supplier-id",
              "lifecycle-state"
            ],
            "id": "requisition-line-by-supplier-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "catalogue-line-id"
            ],
            "id": "requisition-line-by-catalogue-line-id",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "transaction",
        "label": "Requisition line",
        "lifecycle": [
          "draft",
          "valid",
          "exception",
          "approved",
          "rejected",
          "converted",
          "cancelled"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "requisition-policy-routing",
        "owningDomainWorkblockId": "buying-ordering-receiving",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Requisition lines",
        "primaryKey": "requisition-line-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Associates the line with its requisition header.",
            "id": "requisition-line-references-requisition-line-requisition",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "requisition-line-references-requisition-line-requisition",
            "required": true,
            "sourceFieldId": "requisition-id",
            "targetEntityId": "requisition",
            "targetFieldId": "requisition-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links a catalogue-backed line to the exact effective offering.",
            "id": "requisition-line-references-catalogue-line-line-catalogue",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "requisition-line-references-catalogue-line-line-catalogue",
            "required": false,
            "sourceFieldId": "catalogue-line-id",
            "targetEntityId": "catalogue-line",
            "targetFieldId": "catalogue-line-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the requested line to the proposed supplier.",
            "id": "requisition-line-belongs-to-supplier-profile-line-supplier",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "requisition-line-belongs-to-supplier-profile-line-supplier",
            "required": false,
            "sourceFieldId": "supplier-id",
            "targetEntityId": "supplier-profile",
            "targetFieldId": "supplier-profile-id"
          }
        ],
        "retentionClass": "financial",
        "searchTerms": [
          "requisition line",
          "requested item",
          "requested service"
        ],
        "sourceSystemRoleIds": [
          "execution-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "planning-system",
          "execution-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": false,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "invoice-intake-match",
          "purchase-order-exception",
          "receiving-service-entry",
          "supplier-remediation-exit",
          "value-leakage-monitor"
        ],
        "definition": "A committed buying instruction with exact supplier, contract, value, delivery, accounting, authority and downstream reconciliation state.",
        "domainWorkblockIds": [
          "buying-ordering-receiving",
          "supplier-lifecycle-third-party-risk",
          "invoice-exception-payment-readiness",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable canonical identifier for the order across versions and systems.",
            "exchangeScope": "unmapped",
            "format": "uuid",
            "id": "purchase-order-id",
            "introducedIn": "1.0.0",
            "label": "Purchase order ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "purchase-order-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Human-facing committed order number.",
            "exchangeScope": "mapped",
            "id": "purchase-order-number",
            "introducedIn": "1.0.0",
            "label": "Purchase order number",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "purchase-order-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Monotonic version incremented for each committed order change.",
            "exchangeScope": "mapped",
            "id": "order-version",
            "introducedIn": "1.0.0",
            "label": "Order version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "purchase-order-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "order-change",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:SequenceNumberID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "integer"
          },
          {
            "classification": "confidential",
            "definition": "Approved requisition from which the order was derived.",
            "exchangeScope": "mapped",
            "id": "requisition-id",
            "introducedIn": "1.0.0",
            "label": "Requisition ID",
            "nullable": false,
            "referenceEntityId": "requisition",
            "required": true,
            "sourceAuthority": {
              "id": "purchase-order-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OriginatorDocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Canonical supplier receiving the order.",
            "exchangeScope": "mapped",
            "id": "supplier-id",
            "introducedIn": "1.0.0",
            "label": "Supplier ID",
            "nullable": false,
            "referenceEntityId": "supplier-profile",
            "required": true,
            "sourceAuthority": {
              "id": "purchase-order-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:SellerSupplierParty/cac:Party/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Governing contract when the order draws on contracted terms.",
            "exchangeScope": "mapped",
            "id": "contract-id",
            "introducedIn": "1.0.0",
            "label": "Contract ID",
            "nullable": true,
            "referenceEntityId": "contract",
            "required": false,
            "sourceAuthority": {
              "id": "purchase-order-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:Contract/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "compositeValueContract": {
              "componentFieldIds": [
                "total-amount"
              ],
              "representation": "registry-object",
              "schemaId": "money-value",
              "schemaVersion": "2.0.0"
            },
            "definition": "Committed order total with document currency, definition version and explicit rounding rule.",
            "exchangeScope": "mapped",
            "id": "total-amount",
            "introducedIn": "1.0.0",
            "label": "Total amount",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "purchase-order-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "components": [
                  {
                    "standardPath": "alphabeticCode",
                    "valuePath": "currency-code"
                  }
                ],
                "conceptId": "currency-code",
                "coverage": "exact",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "code-list",
                "path": "alphabeticCode",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-4217",
                "transformation": "none"
              },
              {
                "components": [
                  {
                    "standardPath": "cac:AnticipatedMonetaryTotal/cbc:PayableAmount",
                    "valuePath": "amount"
                  },
                  {
                    "standardPath": "cac:AnticipatedMonetaryTotal/cbc:PayableAmount/@currencyID",
                    "valuePath": "currency-code"
                  }
                ],
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:AnticipatedMonetaryTotal/cbc:PayableAmount",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "money",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "money-value",
              "schemaVersion": "2.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Stable order-version key preventing duplicate commitment across retries.",
            "exchangeScope": "unmapped",
            "id": "idempotency-key",
            "introducedIn": "1.0.0",
            "label": "Idempotency key",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "purchase-order-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "purchase-order",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "purchase-order-number"
            ],
            "id": "purchase-order-by-purchase-order-number",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "supplier-id",
              "lifecycle-state"
            ],
            "id": "purchase-order-by-supplier-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "requisition-id"
            ],
            "id": "purchase-order-by-requisition-id",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "idempotency-key"
            ],
            "id": "purchase-order-by-idempotency-key",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "transaction",
        "label": "Purchase order",
        "lifecycle": [
          "draft",
          "approved",
          "dispatching",
          "sent",
          "acknowledged",
          "changed",
          "part-fulfilled",
          "fulfilled",
          "cancelled",
          "closed"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "purchase-order-orchestration",
        "owningDomainWorkblockId": "buying-ordering-receiving",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Purchase orders",
        "primaryKey": "purchase-order-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the committed order to its approved internal request.",
            "id": "purchase-order-belongs-to-requisition-order-requisition",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "purchase-order-belongs-to-requisition-order-requisition",
            "required": true,
            "sourceFieldId": "requisition-id",
            "targetEntityId": "requisition",
            "targetFieldId": "requisition-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the order to the canonical supplier.",
            "id": "purchase-order-belongs-to-supplier-profile-order-supplier",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "purchase-order-belongs-to-supplier-profile-order-supplier",
            "required": true,
            "sourceFieldId": "supplier-id",
            "targetEntityId": "supplier-profile",
            "targetFieldId": "supplier-profile-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the order to governing contracted terms.",
            "id": "purchase-order-belongs-to-contract-order-contract",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "purchase-order-belongs-to-contract-order-contract",
            "required": false,
            "sourceFieldId": "contract-id",
            "targetEntityId": "contract",
            "targetFieldId": "contract-id"
          }
        ],
        "retentionClass": "financial",
        "searchTerms": [
          "purchase order",
          "PO",
          "order",
          "committed order"
        ],
        "sourceSystemRoleIds": [
          "execution-system",
          "planning-system",
          "managed-network"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "planning-system",
          "managed-network"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": false,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "invoice-intake-match",
          "purchase-order-exception",
          "receiving-service-entry"
        ],
        "definition": "A committed item or service instruction with quantity, price, delivery, accounting and fulfilment state.",
        "domainWorkblockIds": [
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable canonical identifier for the order line.",
            "exchangeScope": "mapped",
            "format": "uuid",
            "id": "order-line-id",
            "introducedIn": "1.0.0",
            "label": "Order line ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "purchase-order-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "The canonical line UUID is carried only when the exchange profile preserves it; it is never inferred from the business line number.",
                "path": "cac:OrderLine/cac:LineItem/cbc:UUID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Order header to which the line belongs.",
            "exchangeScope": "mapped",
            "id": "purchase-order-id",
            "introducedIn": "1.0.0",
            "label": "Purchase order ID",
            "nullable": false,
            "referenceEntityId": "purchase-order",
            "required": true,
            "sourceAuthority": {
              "id": "purchase-order-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Approved requested line from which this committed line was derived.",
            "exchangeScope": "mapped",
            "id": "requisition-line-id",
            "introducedIn": "1.0.0",
            "label": "Requisition line ID",
            "nullable": false,
            "referenceEntityId": "requisition-line",
            "required": true,
            "sourceAuthority": {
              "id": "purchase-order-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "extension",
                "direction": "outbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OrderLine/cac:LineItem/cac:OriginatorParty/cbc:EndpointID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "extension-required"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Stable display and exchange sequence within the order.",
            "exchangeScope": "mapped",
            "id": "line-number",
            "introducedIn": "1.0.0",
            "label": "Line number",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "purchase-order-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OrderLine/cac:LineItem/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "integer"
          },
          {
            "classification": "confidential",
            "definition": "Buyer, seller, manufacturer, GTIN or other governed item identifiers.",
            "exchangeScope": "mapped",
            "id": "item-identifiers",
            "introducedIn": "1.0.0",
            "label": "Item identifiers",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "purchase-order-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "conceptId": "identification-key",
                "coverage": "semantic",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "identifier-namespace",
                "path": "GTIN",
                "releaseId": "source-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "gs1-identifiers",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OrderLine/cac:LineItem/cac:Item/cac:StandardItemIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Scheme ID is the string component carried within Order line Item identifiers; its classification and authority inherit from the owning field contract.",
                    "id": "scheme-id",
                    "label": "Scheme ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "item-identifiers",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Identifier value is the string component carried within Order line Item identifiers; its classification and authority inherit from the owning field contract.",
                    "id": "identifier-value",
                    "label": "Identifier value",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "item-identifiers",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Issuer ID is the string component carried within Order line Item identifiers; its classification and authority inherit from the owning field contract.",
                    "id": "issuer-id",
                    "label": "Issuer ID",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "item-identifiers",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Source system ID is the string component carried within Order line Item identifiers; its classification and authority inherit from the owning field contract.",
                    "id": "source-system-id",
                    "label": "Source system ID",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "item-identifiers",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ],
                "uniqueBy": [
                  "scheme-id",
                  "identifier-value"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Committed item or service description.",
            "exchangeScope": "mapped",
            "id": "description",
            "introducedIn": "1.0.0",
            "label": "Description",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "purchase-order-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OrderLine/cac:LineItem/cac:Item/cbc:Description",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "text"
          },
          {
            "classification": "confidential",
            "definition": "Committed quantity and unit of measure.",
            "exchangeScope": "mapped",
            "id": "ordered-quantity",
            "introducedIn": "1.0.0",
            "label": "Ordered quantity",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "purchase-order-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "components": [
                  {
                    "standardPath": "cac:OrderLine/cac:LineItem/cbc:Quantity",
                    "valuePath": "value"
                  },
                  {
                    "standardPath": "cac:OrderLine/cac:LineItem/cbc:Quantity/@unitCode",
                    "valuePath": "unit-code"
                  }
                ],
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OrderLine/cac:LineItem/cbc:Quantity",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "quantity",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "quantity-value",
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Committed unit price with basis and currency.",
            "exchangeScope": "mapped",
            "id": "unit-price",
            "introducedIn": "1.0.0",
            "label": "Unit price",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "purchase-order-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "components": [
                  {
                    "standardPath": "cac:OrderLine/cac:LineItem/cac:Price/cbc:PriceAmount",
                    "valuePath": "amount"
                  },
                  {
                    "standardPath": "cac:OrderLine/cac:LineItem/cac:Price/cbc:PriceAmount/@currencyID",
                    "valuePath": "currency-code"
                  },
                  {
                    "standardPath": "cac:OrderLine/cac:LineItem/cac:Price/cbc:BaseQuantity",
                    "valuePath": "base-quantity"
                  },
                  {
                    "standardPath": "cac:OrderLine/cac:LineItem/cac:Price/cbc:BaseQuantity/@unitCode",
                    "valuePath": "base-unit-code"
                  }
                ],
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OrderLine/cac:LineItem/cac:Price/cbc:PriceAmount",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Amount is the decimal component carried within Order line Unit price; its classification and authority inherit from the owning field contract.",
                    "id": "amount",
                    "label": "Amount",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "unit-price",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Currency code records the governed code within Order line Unit price without treating absence, unknown and zero as equivalent.",
                    "id": "currency-code",
                    "label": "Currency code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "unit-price",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Base quantity is the decimal component carried within Order line Unit price; its classification and authority inherit from the owning field contract.",
                    "id": "base-quantity",
                    "label": "Base quantity",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "unit-price",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Base unit code records the governed code within Order line Unit price without treating absence, unknown and zero as equivalent.",
                    "id": "base-unit-code",
                    "label": "Base unit code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "unit-price",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Requested delivery period, location and fulfilment constraints.",
            "exchangeScope": "mapped",
            "id": "delivery-requirement",
            "introducedIn": "1.0.0",
            "label": "Delivery requirement",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "purchase-order-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OrderLine/cac:LineItem/cac:Delivery",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Requested start date is the date component carried within Order line Delivery requirement; its classification and authority inherit from the owning field contract.",
                    "id": "requested-start-date",
                    "label": "Requested start date",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "delivery-requirement",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Requested end date is the date component carried within Order line Delivery requirement; its classification and authority inherit from the owning field contract.",
                    "id": "requested-end-date",
                    "label": "Requested end date",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "delivery-requirement",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Location ID is the string component carried within Order line Delivery requirement; its classification and authority inherit from the owning field contract.",
                    "id": "location-id",
                    "label": "Location ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "delivery-requirement",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Fulfilment constraint codes is the set carried within Order line Delivery requirement; its owning field governs allowed values and interpretation.",
                    "id": "fulfilment-constraint-codes",
                    "label": "Fulfilment constraint codes",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "delivery-requirement",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Partial delivery permitted is the boolean component carried within Order line Delivery requirement; its classification and authority inherit from the owning field contract.",
                    "id": "partial-delivery-permitted",
                    "label": "Partial delivery permitted",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "delivery-requirement",
                      "kind": "inherited-field"
                    },
                    "type": "boolean"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "order-line",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "purchase-order-id",
              "line-number"
            ],
            "id": "order-line-by-purchase-order-id-and-line-number",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "requisition-line-id"
            ],
            "id": "order-line-by-requisition-line-id",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "lifecycle-state"
            ],
            "id": "order-line-by-fulfilment-status",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "transaction",
        "label": "Order line",
        "lifecycle": [
          "open",
          "acknowledged",
          "changed",
          "part-fulfilled",
          "fulfilled",
          "cancelled",
          "closed"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "purchase-order-orchestration",
        "owningDomainWorkblockId": "buying-ordering-receiving",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Order lines",
        "primaryKey": "order-line-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Associates the line with its order header.",
            "id": "order-line-belongs-to-purchase-order-line-order",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "order-line-belongs-to-purchase-order-line-order",
            "required": true,
            "sourceFieldId": "purchase-order-id",
            "targetEntityId": "purchase-order",
            "targetFieldId": "purchase-order-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Preserves exact lineage to the approved requisition line.",
            "id": "order-line-references-requisition-line-line-requisition-line",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "order-line-references-requisition-line-line-requisition-line",
            "required": true,
            "sourceFieldId": "requisition-line-id",
            "targetEntityId": "requisition-line",
            "targetFieldId": "requisition-line-id"
          }
        ],
        "retentionClass": "financial",
        "searchTerms": [
          "order line",
          "PO line",
          "ordered item",
          "ordered service"
        ],
        "sourceSystemRoleIds": [
          "execution-system",
          "managed-network",
          "planning-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "planning-system",
          "managed-network"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": false,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "invoice-exception-triage"
        ],
        "definition": "A deduplicated, policy-classified order variance that requires automated correction, monitored tolerance, or explicit commercial authority.",
        "domainWorkblockIds": [
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for the deduplicated exception case.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "purchase-order-exception-id",
            "introducedIn": "1.0.0",
            "label": "Purchase order exception ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "purchase-order-exception",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Affected committed order.",
            "exchangeScope": "mapped",
            "id": "purchase-order-id",
            "introducedIn": "1.0.0",
            "label": "Purchase order ID",
            "nullable": false,
            "referenceEntityId": "purchase-order",
            "required": true,
            "sourceAuthority": {
              "id": "purchase-order-exception",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "inbound",
                "documentId": "order-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OrderReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Affected line when the exception is line-specific.",
            "exchangeScope": "mapped",
            "id": "order-line-id",
            "introducedIn": "1.0.0",
            "label": "Order line ID",
            "nullable": true,
            "referenceEntityId": "order-line",
            "required": false,
            "sourceAuthority": {
              "id": "purchase-order-exception",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "order-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OrderLine/cac:LineItem/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Governed order variance classification.",
            "enumValues": [
              "dispatch-failure",
              "rejection",
              "quantity-change",
              "price-change",
              "date-change",
              "supplier-ineligible",
              "budget",
              "contract",
              "duplicate",
              "other"
            ],
            "exchangeScope": "internal",
            "id": "exception-type",
            "introducedIn": "1.0.0",
            "label": "Exception type",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "purchase-order-exception",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Stable correlation key preventing repeat cases and actions for one underlying variance.",
            "exchangeScope": "internal",
            "id": "deduplication-key",
            "introducedIn": "1.0.0",
            "label": "Deduplication key",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "purchase-order-exception",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Consequence band after value, reversibility, schedule, contract and supplier effects.",
            "enumValues": [
              "low",
              "moderate",
              "high",
              "critical"
            ],
            "exchangeScope": "internal",
            "id": "severity",
            "introducedIn": "1.0.0",
            "label": "Severity",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "purchase-order-exception",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Uncommitted correction with evidence, policy authority, predicted effect and rollback path.",
            "exchangeScope": "internal",
            "id": "proposed-resolution",
            "introducedIn": "1.0.0",
            "label": "Proposed resolution",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "purchase-order-exception",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Resolution type records the governed state or type within Purchase order exception Proposed resolution without treating absence, unknown and zero as equivalent.",
                    "id": "resolution-type",
                    "label": "Resolution type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-resolution",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Proposed change summary is the string component carried within Purchase order exception Proposed resolution; its classification and authority inherit from the owning field contract.",
                    "id": "proposed-change-summary",
                    "label": "Proposed change summary",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-resolution",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Evidence item ids links this structured value to governed evidence items through evidence-item-id within Purchase order exception Proposed resolution.",
                    "id": "evidence-item-ids",
                    "label": "Evidence item ids",
                    "listSemantics": "set",
                    "nullable": false,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links evidence item ids to governed evidence items through the canonical evidence-item-id field.",
                      "id": "purchase-order-exception-proposed-resolution-evidence-item-ids",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-resolution",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Policy authority ID is the string component carried within Purchase order exception Proposed resolution; its classification and authority inherit from the owning field contract.",
                    "id": "policy-authority-id",
                    "label": "Policy authority ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-resolution",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Predicted effect is the string component carried within Purchase order exception Proposed resolution; its classification and authority inherit from the owning field contract.",
                    "id": "predicted-effect",
                    "label": "Predicted effect",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-resolution",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Rollback instructions is the string component carried within Purchase order exception Proposed resolution; its classification and authority inherit from the owning field contract.",
                    "id": "rollback-instructions",
                    "label": "Rollback instructions",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-resolution",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Reversible is the boolean component carried within Purchase order exception Proposed resolution; its classification and authority inherit from the owning field contract.",
                    "id": "reversible",
                    "label": "Reversible",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-resolution",
                      "kind": "inherited-field"
                    },
                    "type": "boolean"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Shared exception case that records ownership, resolution and evidence for this domain exception.",
            "exchangeScope": "unmapped",
            "id": "governance-exception-id",
            "introducedIn": "4.0.0",
            "label": "Governance exception case ID",
            "nullable": true,
            "referenceEntityId": "exception",
            "required": false,
            "sourceAuthority": {
              "id": "purchase-order-exception",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Authority envelope governing proposals, approvals and commitments for this record.",
            "exchangeScope": "unmapped",
            "id": "governance-authority-envelope-id",
            "introducedIn": "4.0.0",
            "label": "Governance authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "purchase-order-exception",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Evidence supporting this record and its governed outcome.",
            "exchangeScope": "unmapped",
            "id": "governance-evidence-item-ids",
            "introducedIn": "4.0.0",
            "label": "Governance evidence item IDs",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "purchase-order-exception",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "purchase-order-exception",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "purchase-order-id",
              "lifecycle-state"
            ],
            "id": "purchase-order-exception-by-purchase-order-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "exception-type",
              "severity"
            ],
            "id": "purchase-order-exception-by-exception-type-and-severity",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "deduplication-key"
            ],
            "id": "purchase-order-exception-by-deduplication-key",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "case",
        "label": "Purchase order exception",
        "lifecycle": [
          "detected",
          "triaging",
          "auto-resolving",
          "proposed",
          "resolved",
          "waived",
          "rejected",
          "failed",
          "reopened"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "purchase-order-exception",
        "owningDomainWorkblockId": "buying-ordering-receiving",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Purchase order exceptions",
        "primaryKey": "purchase-order-exception-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the case to the affected order.",
            "id": "purchase-order-exception-belongs-to-purchase-order-exception-order",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "purchase-order-exception-belongs-to-purchase-order-exception-order",
            "required": true,
            "sourceFieldId": "purchase-order-id",
            "targetEntityId": "purchase-order",
            "targetFieldId": "purchase-order-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links a line-specific exception to its order line.",
            "id": "purchase-order-exception-references-order-line-exception-line",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "purchase-order-exception-references-order-line-exception-line",
            "required": false,
            "sourceFieldId": "order-line-id",
            "targetEntityId": "order-line",
            "targetFieldId": "order-line-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Shared governed exception case for this domain exception.",
            "id": "purchase-order-exception-governed-by-exception-purchase-order-exception-governance-exception",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "purchase-order-exception-governed-by-exception-purchase-order-exception-governance-exception",
            "required": false,
            "sourceFieldId": "governance-exception-id",
            "targetEntityId": "exception",
            "targetFieldId": "exception-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authority envelope governing this record.",
            "id": "purchase-order-exception-governed-by-authority-envelope-purchase-order-exception-governance-authority",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "purchase-order-exception-governed-by-authority-envelope-purchase-order-exception-governance-authority",
            "required": false,
            "sourceFieldId": "governance-authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Evidence supporting this record.",
            "id": "purchase-order-exception-evidenced-by-evidence-item-purchase-order-exception-governance-evidence",
            "introducedIn": "4.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "purchase-order-exception-evidenced-by-evidence-item-purchase-order-exception-governance-evidence",
            "required": false,
            "sourceFieldId": "governance-evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "PO exception",
          "order exception",
          "price variance",
          "order failure"
        ],
        "sourceSystemRoleIds": [
          "execution-system",
          "managed-network",
          "system-of-record",
          "planning-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "planning-system",
          "managed-network",
          "collaboration-channel"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "purchase-order-exception"
        ],
        "definition": "An immutable supplier acknowledgement, rejection or proposed change to an order, normalised before any change becomes committed.",
        "domainWorkblockIds": [
          "buying-ordering-receiving"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable canonical identifier for the normalised response.",
            "exchangeScope": "unmapped",
            "format": "uuid",
            "id": "order-response-id",
            "introducedIn": "1.0.0",
            "label": "Order response ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "purchase-order-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Order to which the supplier responded.",
            "exchangeScope": "mapped",
            "id": "purchase-order-id",
            "introducedIn": "1.0.0",
            "label": "Purchase order ID",
            "nullable": false,
            "referenceEntityId": "purchase-order",
            "required": true,
            "sourceAuthority": {
              "id": "purchase-order-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "inbound",
                "documentId": "order-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OrderReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Identifier assigned by the responding supplier or network.",
            "exchangeScope": "mapped",
            "id": "supplier-response-id",
            "introducedIn": "1.0.0",
            "label": "Supplier response ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "purchase-order-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "inbound",
                "documentId": "order-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Normalised header response result.",
            "enumValues": [
              "accepted",
              "accepted-with-changes",
              "rejected",
              "partial",
              "unknown"
            ],
            "exchangeScope": "mapped",
            "id": "response-code",
            "introducedIn": "1.0.0",
            "label": "Response code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "purchase-order-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "inbound",
                "documentId": "order-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:OrderResponseCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Line and header differences from the committed order, explicitly non-committed until evaluated.",
            "exchangeScope": "mapped",
            "id": "proposed-changes",
            "introducedIn": "1.0.0",
            "label": "Proposed changes",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "purchase-order-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "order-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OrderLine",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Change ID is the string component carried within Order response Proposed changes; its classification and authority inherit from the owning field contract.",
                    "id": "change-id",
                    "label": "Change ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-changes",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Change scope is the string component carried within Order response Proposed changes; its classification and authority inherit from the owning field contract.",
                    "id": "change-scope",
                    "label": "Change scope",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-changes",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Order line ID links this structured value to governed order line record through order-line-id within Order response Proposed changes.",
                    "id": "order-line-id",
                    "label": "Order line ID",
                    "nullable": true,
                    "referenceEntityId": "order-line",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links order line id to governed order line record through the canonical order-line-id field.",
                      "id": "order-response-proposed-changes-order-line-id",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "order-line-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-changes",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Field path is the string component carried within Order response Proposed changes; its classification and authority inherit from the owning field contract.",
                    "id": "field-path",
                    "label": "Field path",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-changes",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Committed value is the string component carried within Order response Proposed changes; its classification and authority inherit from the owning field contract.",
                    "id": "committed-value",
                    "label": "Committed value",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-changes",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Proposed value is the string component carried within Order response Proposed changes; its classification and authority inherit from the owning field contract.",
                    "id": "proposed-value",
                    "label": "Proposed value",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-changes",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Change status records the governed state or type within Order response Proposed changes without treating absence, unknown and zero as equivalent.",
                    "id": "change-status",
                    "label": "Change status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-changes",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ],
                "uniqueBy": [
                  "change-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Immutable raw supplier response or transport payload.",
            "exchangeScope": "unmapped",
            "id": "artifact-id",
            "introducedIn": "1.0.0",
            "label": "Artifact reference",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "purchase-order-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Timestamp when the response entered the integration boundary.",
            "exchangeScope": "mapped",
            "format": "date-time",
            "id": "received-at",
            "introducedIn": "1.0.0",
            "label": "Received at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "purchase-order-orchestration",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "order-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:IssueDate|cbc:IssueTime",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "order-response",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "purchase-order-id",
              "received-at"
            ],
            "id": "order-response-by-purchase-order-id-and-received-at",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "supplier-response-id"
            ],
            "id": "order-response-by-supplier-response-id",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "response-code"
            ],
            "id": "order-response-by-response-code",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "document",
        "label": "Order response",
        "lifecycle": [
          "received",
          "validated",
          "accepted",
          "exception",
          "superseded",
          "rejected"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "purchase-order-orchestration",
        "owningDomainWorkblockId": "buying-ordering-receiving",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Order responses",
        "primaryKey": "order-response-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the response to the exact canonical order.",
            "id": "order-response-belongs-to-purchase-order-response-order",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "order-response-belongs-to-purchase-order-response-order",
            "required": true,
            "sourceFieldId": "purchase-order-id",
            "targetEntityId": "purchase-order",
            "targetFieldId": "purchase-order-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links order responses to the governed evidence item record referenced by artifact reference.",
            "id": "order-response-evidenced-by-evidence-item-artifact-id-to-evidence-item",
            "introducedIn": "1.1.0",
            "predicate": "evidenced-by",
            "qualifiedId": "order-response-evidenced-by-evidence-item-artifact-id-to-evidence-item",
            "required": true,
            "sourceFieldId": "artifact-id",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "order acknowledgement",
          "order response",
          "supplier confirmation",
          "order rejection"
        ],
        "sourceSystemRoleIds": [
          "managed-network",
          "analytical-system",
          "source-of-record"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "execution-system",
          "collaboration-channel"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "commit",
            "correct",
            "export"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": false,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "purchase-order-exception"
        ],
        "definition": "A normalised despatch event linking packages, transport, quantities and expected delivery to committed order lines.",
        "domainWorkblockIds": [
          "buying-ordering-receiving"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable canonical identifier for the normalised shipment.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "shipment-id",
            "introducedIn": "1.0.0",
            "label": "Shipment ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Supplier, carrier or logistics network shipment identifier.",
            "exchangeScope": "mapped",
            "id": "shipment-reference",
            "introducedIn": "1.0.0",
            "label": "Shipment reference",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "inbound",
                "documentId": "despatch-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Canonical order being fulfilled.",
            "exchangeScope": "mapped",
            "id": "purchase-order-id",
            "introducedIn": "1.0.0",
            "label": "Purchase order ID",
            "nullable": false,
            "referenceEntityId": "purchase-order",
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "inbound",
                "documentId": "despatch-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OrderReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Order-line allocations, shipped quantities, package identities and item identifiers.",
            "exchangeScope": "mapped",
            "id": "despatch-lines",
            "introducedIn": "1.0.0",
            "label": "Despatch lines",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "components": [
                  {
                    "standardPath": "cac:DespatchLine/cbc:ID",
                    "valuePath": "despatch-line-id"
                  },
                  {
                    "standardPath": "cac:DespatchLine/cac:OrderLineReference/cbc:LineID",
                    "valuePath": "order-line-id"
                  },
                  {
                    "standardPath": "cac:DespatchLine/cbc:DeliveredQuantity",
                    "valuePath": "shipped-quantity"
                  },
                  {
                    "standardPath": "cac:DespatchLine/cbc:DeliveredQuantity/@unitCode",
                    "valuePath": "quantity-unit-code"
                  }
                ],
                "coverage": "exact",
                "direction": "inbound",
                "documentId": "despatch-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:DespatchLine",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Despatch line ID is the string component carried within Shipment Despatch lines; its classification and authority inherit from the owning field contract.",
                    "id": "despatch-line-id",
                    "label": "Despatch line ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "despatch-lines",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Order line ID links this structured value to governed order line record through order-line-id within Shipment Despatch lines.",
                    "id": "order-line-id",
                    "label": "Order line ID",
                    "nullable": false,
                    "referenceEntityId": "order-line",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links order line id to governed order line record through the canonical order-line-id field.",
                      "id": "shipment-despatch-lines-order-line-id",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "order-line-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "despatch-lines",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Shipped quantity is the decimal component carried within Shipment Despatch lines; its classification and authority inherit from the owning field contract.",
                    "id": "shipped-quantity",
                    "label": "Shipped quantity",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "despatch-lines",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Quantity unit code records the governed code within Shipment Despatch lines without treating absence, unknown and zero as equivalent.",
                    "id": "quantity-unit-code",
                    "label": "Quantity unit code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "despatch-lines",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Package identifiers is the set carried within Shipment Despatch lines; its owning field governs allowed values and interpretation.",
                    "id": "package-identifiers",
                    "label": "Package identifiers",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "despatch-lines",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Item identifiers is the set carried within Shipment Despatch lines; its owning field governs allowed values and interpretation.",
                    "id": "item-identifiers",
                    "label": "Item identifiers",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "despatch-lines",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  }
                ],
                "uniqueBy": [
                  "despatch-line-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "SSCC or other governed package and logistics-unit identifiers.",
            "exchangeScope": "mapped",
            "format": "GS1 identifiers where available",
            "id": "package-identifiers",
            "introducedIn": "1.0.0",
            "label": "Package identifiers",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "conceptId": "identification-key",
                "coverage": "semantic",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "identifier-namespace",
                "path": "SSCC",
                "releaseId": "source-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "gs1-identifiers",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "despatch-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:Shipment/cac:TransportHandlingUnit/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Scheme ID is the string component carried within Shipment Package identifiers; its classification and authority inherit from the owning field contract.",
                    "id": "scheme-id",
                    "label": "Scheme ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "package-identifiers",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Identifier value is the string component carried within Shipment Package identifiers; its classification and authority inherit from the owning field contract.",
                    "id": "identifier-value",
                    "label": "Identifier value",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "package-identifiers",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Issuer ID is the string component carried within Shipment Package identifiers; its classification and authority inherit from the owning field contract.",
                    "id": "issuer-id",
                    "label": "Issuer ID",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "package-identifiers",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Source system ID is the string component carried within Shipment Package identifiers; its classification and authority inherit from the owning field contract.",
                    "id": "source-system-id",
                    "label": "Source system ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "package-identifiers",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Observed at is the timestamp component carried within Shipment Package identifiers; its classification and authority inherit from the owning field contract.",
                    "id": "observed-at",
                    "label": "Observed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "package-identifiers",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  }
                ],
                "uniqueBy": [
                  "scheme-id",
                  "identifier-value"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Latest source-observed expected delivery timestamp.",
            "exchangeScope": "mapped",
            "format": "date-time",
            "id": "expected-delivery-at",
            "introducedIn": "1.0.0",
            "label": "Expected delivery at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "despatch-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:Shipment/cac:Delivery/cac:EstimatedDeliveryPeriod/cbc:EndDate",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Timestamp of the most recent source observation represented.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "observed-at",
            "introducedIn": "1.0.0",
            "label": "Observed at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "shipment",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "shipment-reference"
            ],
            "id": "shipment-by-shipment-reference",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "purchase-order-id",
              "lifecycle-state"
            ],
            "id": "shipment-by-purchase-order-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "expected-delivery-at"
            ],
            "id": "shipment-by-expected-delivery-at",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "transaction",
        "label": "Shipment",
        "lifecycle": [
          "announced",
          "in-transit",
          "delayed",
          "delivered",
          "cancelled",
          "closed"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "receiving-service-entry",
        "owningDomainWorkblockId": "buying-ordering-receiving",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "append-only-event-store",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Shipments",
        "primaryKey": "shipment-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the shipment to its order.",
            "id": "shipment-belongs-to-purchase-order-shipment-order",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "shipment-belongs-to-purchase-order-shipment-order",
            "required": true,
            "sourceFieldId": "purchase-order-id",
            "targetEntityId": "purchase-order",
            "targetFieldId": "purchase-order-id"
          }
        ],
        "retentionClass": "operational",
        "searchTerms": [
          "shipment",
          "despatch advice",
          "delivery",
          "package"
        ],
        "sourceSystemRoleIds": [
          "managed-network",
          "transport-execution-boundary"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "planning-system",
          "transport-execution-boundary"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "invoice-intake-match",
          "purchase-order-exception"
        ],
        "definition": "A committed record that goods or a measurable delivery were received, rejected or accepted with variance against order and despatch evidence.",
        "domainWorkblockIds": [
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable canonical identifier for the receipt.",
            "exchangeScope": "mapped",
            "format": "uuid",
            "id": "receipt-id",
            "introducedIn": "1.0.0",
            "label": "Receipt ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "receipt-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Human-facing receipt number assigned by the authoritative receiving system.",
            "exchangeScope": "mapped",
            "id": "receipt-number",
            "introducedIn": "1.0.0",
            "label": "Receipt number",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "purchase-receipt",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Committed order against which receipt occurs.",
            "exchangeScope": "mapped",
            "id": "purchase-order-id",
            "introducedIn": "1.0.0",
            "label": "Purchase order ID",
            "nullable": false,
            "referenceEntityId": "purchase-order",
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "receipt-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OrderReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Optional despatch record supporting the physical delivery.",
            "exchangeScope": "mapped",
            "id": "shipment-id",
            "introducedIn": "1.0.0",
            "label": "Shipment ID",
            "nullable": true,
            "referenceEntityId": "shipment",
            "required": false,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "receipt-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:DespatchDocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Governed GLN, internal site or address where receipt was observed.",
            "exchangeScope": "mapped",
            "id": "receiving-location",
            "introducedIn": "1.0.0",
            "label": "Receiving location",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "conceptId": "identification-key",
                "coverage": "semantic",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "identifier-namespace",
                "path": "GLN",
                "releaseId": "source-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "gs1-identifiers",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "receipt-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:DeliveryCustomerParty/cac:Party/cac:PhysicalLocation",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Location type records the governed state or type within Receipt Receiving location without treating absence, unknown and zero as equivalent.",
                    "id": "location-type",
                    "label": "Location type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "receiving-location",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Location ID is the string component carried within Receipt Receiving location; its classification and authority inherit from the owning field contract.",
                    "id": "location-id",
                    "label": "Location ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "receiving-location",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Identification scheme is the string component carried within Receipt Receiving location; its classification and authority inherit from the owning field contract.",
                    "id": "identification-scheme",
                    "label": "Identification scheme",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "receiving-location",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Location name is the string component carried within Receipt Receiving location; its classification and authority inherit from the owning field contract.",
                    "id": "location-name",
                    "label": "Location name",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "receiving-location",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Address line is the string component carried within Receipt Receiving location; its classification and authority inherit from the owning field contract.",
                    "id": "address-line",
                    "label": "Address line",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "receiving-location",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Country code records the governed code within Receipt Receiving location without treating absence, unknown and zero as equivalent.",
                    "id": "country-code",
                    "label": "Country code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "receiving-location",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Source system ID is the string component carried within Receipt Receiving location; its classification and authority inherit from the owning field contract.",
                    "id": "source-system-id",
                    "label": "Source system ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "receiving-location",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Immutable proof-of-delivery, image, scan, sensor or signed delivery evidence.",
            "exchangeScope": "mapped",
            "id": "proof-artifact-ids",
            "introducedIn": "1.0.0",
            "label": "Proof artifact references",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "receipt-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:AdditionalDocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Stable key preventing duplicate receipt commitment across retries.",
            "exchangeScope": "unmapped",
            "id": "idempotency-key",
            "introducedIn": "1.0.0",
            "label": "Idempotency key",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Timestamp at which delivery was observed or accepted.",
            "exchangeScope": "mapped",
            "format": "date-time",
            "id": "received-at",
            "introducedIn": "1.0.0",
            "label": "Received at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "receipt-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:IssueDate|cbc:IssueTime",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "timestamp"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "receipt",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "receipt-number"
            ],
            "id": "receipt-by-receipt-number",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "purchase-order-id",
              "received-at"
            ],
            "id": "receipt-by-purchase-order-id-and-received-at",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "lifecycle-state"
            ],
            "id": "receipt-by-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "idempotency-key"
            ],
            "id": "receipt-by-idempotency-key",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "transaction",
        "label": "Receipt",
        "lifecycle": [
          "draft",
          "evidence-ready",
          "committed",
          "corrected",
          "reversed",
          "disputed",
          "closed"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "receiving-service-entry",
        "owningDomainWorkblockId": "buying-ordering-receiving",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Receipts",
        "primaryKey": "receipt-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the receipt to the committed order.",
            "id": "receipt-belongs-to-purchase-order-receipt-order",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "receipt-belongs-to-purchase-order-receipt-order",
            "required": true,
            "sourceFieldId": "purchase-order-id",
            "targetEntityId": "purchase-order",
            "targetFieldId": "purchase-order-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links receipt to supporting despatch evidence.",
            "id": "receipt-belongs-to-shipment-receipt-shipment",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "receipt-belongs-to-shipment-receipt-shipment",
            "required": false,
            "sourceFieldId": "shipment-id",
            "targetEntityId": "shipment",
            "targetFieldId": "shipment-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links receipts to the governed evidence item record referenced by proof artifact references.",
            "id": "receipt-evidenced-by-evidence-item-proof-artifact-ids-to-evidence-item",
            "introducedIn": "1.1.0",
            "predicate": "evidenced-by",
            "qualifiedId": "receipt-evidenced-by-evidence-item-proof-artifact-ids-to-evidence-item",
            "required": false,
            "sourceFieldId": "proof-artifact-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          }
        ],
        "retentionClass": "financial",
        "searchTerms": [
          "goods receipt",
          "receipt advice",
          "proof of delivery",
          "received quantity"
        ],
        "sourceSystemRoleIds": [
          "transport-execution-boundary",
          "planning-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "planning-system",
          "transport-execution-boundary",
          "execution-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": false,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "invoice-intake-match"
        ],
        "definition": "A line-level accepted, rejected, damaged or short quantity against a committed order line.",
        "domainWorkblockIds": [
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for the receipt line.",
            "exchangeScope": "mapped",
            "format": "uuid",
            "id": "receipt-line-id",
            "introducedIn": "1.0.0",
            "label": "Receipt line ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "receipt-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "The canonical line UUID is carried only when the exchange profile preserves it; it is never inferred from the business line number.",
                "path": "cac:ReceiptLine/cbc:UUID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Receipt header to which the line belongs.",
            "exchangeScope": "mapped",
            "id": "receipt-id",
            "introducedIn": "1.0.0",
            "label": "Receipt ID",
            "nullable": false,
            "referenceEntityId": "receipt",
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "receipt-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Committed order line being received.",
            "exchangeScope": "mapped",
            "id": "order-line-id",
            "introducedIn": "1.0.0",
            "label": "Order line ID",
            "nullable": false,
            "referenceEntityId": "order-line",
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "receipt-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ReceiptLine/cac:OrderLineReference/cbc:LineID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Stable display and exchange sequence within the receipt.",
            "exchangeScope": "mapped",
            "id": "line-number",
            "introducedIn": "1.0.0",
            "label": "Line number",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "receipt-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ReceiptLine/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "integer"
          },
          {
            "classification": "confidential",
            "definition": "Observed and accepted quantity with unit of measure.",
            "exchangeScope": "mapped",
            "id": "received-quantity",
            "introducedIn": "1.0.0",
            "label": "Received quantity",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "components": [
                  {
                    "standardPath": "cac:ReceiptLine/cbc:ReceivedQuantity",
                    "valuePath": "value"
                  },
                  {
                    "standardPath": "cac:ReceiptLine/cbc:ReceivedQuantity/@unitCode",
                    "valuePath": "unit-code"
                  }
                ],
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "receipt-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ReceiptLine/cbc:ReceivedQuantity",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "quantity",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "quantity-value",
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Quantity not accepted with unit of measure.",
            "exchangeScope": "mapped",
            "id": "rejected-quantity",
            "introducedIn": "1.0.0",
            "label": "Rejected quantity",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "components": [
                  {
                    "standardPath": "cac:ReceiptLine/cbc:RejectedQuantity",
                    "valuePath": "value"
                  },
                  {
                    "standardPath": "cac:ReceiptLine/cbc:RejectedQuantity/@unitCode",
                    "valuePath": "unit-code"
                  }
                ],
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "receipt-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ReceiptLine/cbc:RejectedQuantity",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "quantity",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "quantity-value",
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Governed reason for short, excess, damaged, substituted or rejected delivery.",
            "enumValues": [
              "short",
              "excess",
              "damaged",
              "substituted",
              "quality",
              "not-ordered",
              "other"
            ],
            "exchangeScope": "mapped",
            "id": "variance-reason-code",
            "introducedIn": "1.0.0",
            "label": "Variance reason code",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "receipt-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ReceiptLine/cbc:RejectReasonCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Lot, batch, serial, GTIN or other traceability identifiers observed at receipt.",
            "exchangeScope": "mapped",
            "id": "item-trace",
            "introducedIn": "1.0.0",
            "label": "Item trace",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "conceptId": "identification-key",
                "coverage": "semantic",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "identifier-namespace",
                "path": "GTIN|lot|serial",
                "releaseId": "source-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "gs1-identifiers",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "receipt-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ReceiptLine/cac:Item/cac:ItemInstance",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Trace type records the governed state or type within Receipt line Item trace without treating absence, unknown and zero as equivalent.",
                    "id": "trace-type",
                    "label": "Trace type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "item-trace",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Identifier value is the string component carried within Receipt line Item trace; its classification and authority inherit from the owning field contract.",
                    "id": "identifier-value",
                    "label": "Identifier value",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "item-trace",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Scheme ID is the string component carried within Receipt line Item trace; its classification and authority inherit from the owning field contract.",
                    "id": "scheme-id",
                    "label": "Scheme ID",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "item-trace",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Observed at is the timestamp component carried within Receipt line Item trace; its classification and authority inherit from the owning field contract.",
                    "id": "observed-at",
                    "label": "Observed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "item-trace",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Source system ID is the string component carried within Receipt line Item trace; its classification and authority inherit from the owning field contract.",
                    "id": "source-system-id",
                    "label": "Source system ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "item-trace",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ],
                "uniqueBy": [
                  "trace-type",
                  "identifier-value"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "receipt-line",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "receipt-id",
              "line-number"
            ],
            "id": "receipt-line-by-receipt-id-and-line-number",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "order-line-id"
            ],
            "id": "receipt-line-by-order-line-id",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "lifecycle-state"
            ],
            "id": "receipt-line-by-status",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "transaction",
        "label": "Receipt line",
        "lifecycle": [
          "draft",
          "accepted",
          "accepted-with-variance",
          "rejected",
          "corrected",
          "reversed"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "receiving-service-entry",
        "owningDomainWorkblockId": "buying-ordering-receiving",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Receipt lines",
        "primaryKey": "receipt-line-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Associates the line with its receipt header.",
            "id": "receipt-line-belongs-to-receipt-receipt-line-receipt",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "receipt-line-belongs-to-receipt-receipt-line-receipt",
            "required": true,
            "sourceFieldId": "receipt-id",
            "targetEntityId": "receipt",
            "targetFieldId": "receipt-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links received quantities to the exact committed order line.",
            "id": "receipt-line-belongs-to-order-line-receipt-line-order-line",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "receipt-line-belongs-to-order-line-receipt-line-order-line",
            "required": true,
            "sourceFieldId": "order-line-id",
            "targetEntityId": "order-line",
            "targetFieldId": "order-line-id"
          }
        ],
        "retentionClass": "financial",
        "searchTerms": [
          "receipt line",
          "received quantity",
          "short delivery",
          "damaged goods"
        ],
        "sourceSystemRoleIds": [
          "transport-execution-boundary",
          "planning-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "planning-system",
          "transport-execution-boundary",
          "execution-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "invoice-intake-match"
        ],
        "definition": "A governed claim and acceptance record for time-, milestone- or outcome-based services delivered against order and contract evidence.",
        "domainWorkblockIds": [
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable canonical identifier for the service entry.",
            "exchangeScope": "unmapped",
            "format": "uuid",
            "id": "service-entry-sheet-id",
            "introducedIn": "1.0.0",
            "label": "Service entry sheet ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Human-facing number assigned by the authoritative service-entry system.",
            "exchangeScope": "unmapped",
            "id": "service-entry-number",
            "introducedIn": "1.0.0",
            "label": "Service entry number",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Order against which services are claimed.",
            "exchangeScope": "mapped",
            "id": "purchase-order-id",
            "introducedIn": "1.0.0",
            "label": "Purchase order ID",
            "nullable": false,
            "referenceEntityId": "purchase-order",
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "receipt-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "UBL ReceiptAdvice can carry service acceptance semantically; platform-specific detail uses an extension profile.",
                "path": "cac:OrderReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Service order lines covered by the entry.",
            "exchangeScope": "mapped",
            "id": "order-line-ids",
            "introducedIn": "1.0.0",
            "label": "Order line IDs",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "order-line",
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "receipt-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ReceiptLine/cac:OrderLineReference/cbc:LineID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "confidential",
            "definition": "Start date of delivered service covered by the entry.",
            "exchangeScope": "unmapped",
            "format": "date",
            "id": "service-period-start",
            "introducedIn": "1.0.0",
            "label": "Service period start",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "confidential",
            "definition": "End date of delivered service covered by the entry.",
            "exchangeScope": "unmapped",
            "format": "date",
            "id": "service-period-end",
            "introducedIn": "1.0.0",
            "label": "Service period end",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "restricted",
            "definition": "Claimed hours, milestones, units, outcomes and value by order line.",
            "exchangeScope": "unmapped",
            "id": "delivery-claim",
            "introducedIn": "1.0.0",
            "label": "Delivery claim",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Claim line ID is the string component carried within Service entry sheet Delivery claim; its classification and authority inherit from the owning field contract.",
                    "id": "claim-line-id",
                    "label": "Claim line ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "delivery-claim",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Order line ID links this structured value to governed order line record through order-line-id within Service entry sheet Delivery claim.",
                    "id": "order-line-id",
                    "label": "Order line ID",
                    "nullable": false,
                    "referenceEntityId": "order-line",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links order line id to governed order line record through the canonical order-line-id field.",
                      "id": "service-entry-sheet-delivery-claim-order-line-id",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "order-line-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "delivery-claim",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Measure type records the governed state or type within Service entry sheet Delivery claim without treating absence, unknown and zero as equivalent.",
                    "id": "measure-type",
                    "label": "Measure type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "delivery-claim",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Claimed quantity is the quantity component carried within Service entry sheet Delivery claim; its classification and authority inherit from the owning field contract.",
                    "id": "claimed-quantity",
                    "label": "Claimed quantity",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "delivery-claim",
                      "kind": "inherited-field"
                    },
                    "type": "quantity",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "quantity-value",
                      "schemaVersion": "1.0.0"
                    }
                  },
                  {
                    "classification": "restricted",
                    "definition": "Milestone ID is the string component carried within Service entry sheet Delivery claim; its classification and authority inherit from the owning field contract.",
                    "id": "milestone-id",
                    "label": "Milestone ID",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "delivery-claim",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Outcome description is the string component carried within Service entry sheet Delivery claim; its classification and authority inherit from the owning field contract.",
                    "id": "outcome-description",
                    "label": "Outcome description",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "delivery-claim",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Claimed value is the money component carried within Service entry sheet Delivery claim; its classification and authority inherit from the owning field contract.",
                    "id": "claimed-value",
                    "label": "Claimed value",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "delivery-claim",
                      "kind": "inherited-field"
                    },
                    "type": "money",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "money-value",
                      "schemaVersion": "2.0.0"
                    }
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence item ids links this structured value to governed evidence items through evidence-item-id within Service entry sheet Delivery claim.",
                    "id": "evidence-item-ids",
                    "label": "Evidence item ids",
                    "listSemantics": "set",
                    "nullable": false,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-many",
                      "definition": "Links evidence item ids to governed evidence items through the canonical evidence-item-id field.",
                      "id": "service-entry-sheet-delivery-claim-evidence-item-ids",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "delivery-claim",
                      "kind": "inherited-field"
                    },
                    "type": "reference-list"
                  }
                ],
                "uniqueBy": [
                  "claim-line-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Immutable timesheets, deliverables, milestone evidence and service-owner observations.",
            "exchangeScope": "mapped",
            "id": "evidence-ids",
            "introducedIn": "1.0.0",
            "label": "Evidence references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "receipt-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:AdditionalDocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Stable key preventing duplicate acceptance commitment across retries.",
            "exchangeScope": "unmapped",
            "id": "idempotency-key",
            "introducedIn": "1.0.0",
            "label": "Idempotency key",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "service-entry-sheet",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "service-entry-number"
            ],
            "id": "service-entry-sheet-by-service-entry-number",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "purchase-order-id",
              "lifecycle-state"
            ],
            "id": "service-entry-sheet-by-purchase-order-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "service-period-end"
            ],
            "id": "service-entry-sheet-by-service-period-end",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "idempotency-key"
            ],
            "id": "service-entry-sheet-by-idempotency-key",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "transaction",
        "label": "Service entry sheet",
        "lifecycle": [
          "draft",
          "submitted",
          "evidence-ready",
          "accepted",
          "part-accepted",
          "rejected",
          "corrected",
          "reversed"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "receiving-service-entry",
        "owningDomainWorkblockId": "buying-ordering-receiving",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Service entry sheets",
        "primaryKey": "service-entry-sheet-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the service claim to its committed order.",
            "id": "service-entry-sheet-belongs-to-purchase-order-service-entry-order",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "service-entry-sheet-belongs-to-purchase-order-service-entry-order",
            "required": true,
            "sourceFieldId": "purchase-order-id",
            "targetEntityId": "purchase-order",
            "targetFieldId": "purchase-order-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links service entry sheets to the governed order line record referenced by order line ids.",
            "id": "service-entry-sheet-belongs-to-order-line-order-line-ids-to-order-line",
            "introducedIn": "1.1.0",
            "predicate": "belongs-to",
            "qualifiedId": "service-entry-sheet-belongs-to-order-line-order-line-ids-to-order-line",
            "required": true,
            "sourceFieldId": "order-line-ids",
            "targetEntityId": "order-line",
            "targetFieldId": "order-line-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links service entry sheets to the governed evidence item record referenced by evidence references.",
            "id": "service-entry-sheet-evidenced-by-evidence-item-evidence-ids-to-evidence-item",
            "introducedIn": "1.1.0",
            "predicate": "evidenced-by",
            "qualifiedId": "service-entry-sheet-evidenced-by-evidence-item-evidence-ids-to-evidence-item",
            "required": true,
            "sourceFieldId": "evidence-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          }
        ],
        "retentionClass": "financial",
        "searchTerms": [
          "service entry sheet",
          "service acceptance",
          "milestone acceptance",
          "timesheet"
        ],
        "sourceSystemRoleIds": [
          "source-of-record",
          "planning-system",
          "execution-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "planning-system",
          "execution-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "purchase-order-exception"
        ],
        "definition": "A governed case for returning goods or recovering value after a short, damaged, rejected, substituted or otherwise non-conforming delivery.",
        "domainWorkblockIds": [
          "buying-ordering-receiving"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for the return or recovery case.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "return-claim-id",
            "introducedIn": "1.0.0",
            "label": "Return claim ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Human or supplier-facing return authorisation reference.",
            "exchangeScope": "mapped",
            "id": "return-reference",
            "introducedIn": "1.0.0",
            "label": "Return reference",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "instruction-for-returns",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Order under which the goods were supplied.",
            "exchangeScope": "internal",
            "id": "purchase-order-id",
            "introducedIn": "1.0.0",
            "label": "Purchase order ID",
            "nullable": false,
            "referenceEntityId": "purchase-order",
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Received lines and quantities subject to return or recovery.",
            "exchangeScope": "internal",
            "id": "receipt-line-ids",
            "introducedIn": "1.0.0",
            "label": "Receipt line IDs",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "receipt-line",
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Governed reason for the return or recovery.",
            "enumValues": [
              "damaged",
              "short",
              "excess",
              "wrong-item",
              "quality",
              "recall",
              "not-required",
              "other"
            ],
            "exchangeScope": "mapped",
            "id": "claim-reason-code",
            "introducedIn": "1.0.0",
            "label": "Claim reason code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "extension",
                "direction": "outbound",
                "documentId": "instruction-for-returns",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "InstructionForReturns has no native governed claim-reason code; a profile-pinned extension is required.",
                "path": "ext:UBLExtensions/ext:UBLExtension/ext:ExtensionContent",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "extension-required"
              }
            ],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Immutable condition, receipt, communication and authorisation evidence.",
            "exchangeScope": "mapped",
            "id": "evidence-ids",
            "introducedIn": "1.0.0",
            "label": "Evidence references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "instruction-for-returns",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:DocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "confidential",
            "definition": "Expected credit, replacement, repair or other remedy with value and due date.",
            "exchangeScope": "internal",
            "id": "expected-recovery",
            "introducedIn": "1.0.0",
            "label": "Expected recovery",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Remedy type records the governed state or type within Return or delivery claim Expected recovery without treating absence, unknown and zero as equivalent.",
                    "id": "remedy-type",
                    "label": "Remedy type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "expected-recovery",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Expected value is the money component carried within Return or delivery claim Expected recovery; its classification and authority inherit from the owning field contract.",
                    "id": "expected-value",
                    "label": "Expected value",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "expected-recovery",
                      "kind": "inherited-field"
                    },
                    "type": "money",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "money-value",
                      "schemaVersion": "2.0.0"
                    }
                  },
                  {
                    "classification": "confidential",
                    "definition": "Due date is the date component carried within Return or delivery claim Expected recovery; its classification and authority inherit from the owning field contract.",
                    "id": "due-date",
                    "label": "Due date",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "expected-recovery",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Recovery description is the string component carried within Return or delivery claim Expected recovery; its classification and authority inherit from the owning field contract.",
                    "id": "recovery-description",
                    "label": "Recovery description",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "expected-recovery",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Destination party ID links this structured value to the governed party record within Return or delivery claim Expected recovery.",
                    "id": "destination-party-id",
                    "label": "Destination party ID",
                    "nullable": true,
                    "referenceEntityId": "party",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the destination party ID in expected recovery to the referenced party via its canonical party ID.",
                      "id": "return-claim-expected-recovery-destination-party-id",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "party-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "expected-recovery",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Policy basis ID is the string component carried within Return or delivery claim Expected recovery; its classification and authority inherit from the owning field contract.",
                    "id": "policy-basis-id",
                    "label": "Policy basis ID",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "expected-recovery",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Date by which the expected remedy should be realized.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "recovery-due-at",
            "introducedIn": "1.0.0",
            "label": "Recovery due at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Authority envelope governing proposals, approvals and commitments for this record.",
            "exchangeScope": "unmapped",
            "id": "governance-authority-envelope-id",
            "introducedIn": "4.0.0",
            "label": "Governance authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "receiving-service-entry",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "return-claim",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "purchase-order-id",
              "lifecycle-state"
            ],
            "id": "return-claim-by-purchase-order-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "return-reference"
            ],
            "id": "return-claim-by-return-reference",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "recovery-due-at"
            ],
            "id": "return-claim-by-recovery-due-at",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "case",
        "label": "Return or delivery claim",
        "lifecycle": [
          "identified",
          "proposed",
          "authorised",
          "in-transit",
          "received-by-supplier",
          "credited",
          "replaced",
          "rejected",
          "closed"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "receiving-service-entry",
        "owningDomainWorkblockId": "buying-ordering-receiving",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Returns and delivery claims",
        "primaryKey": "return-claim-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the return or claim to its order.",
            "id": "return-claim-belongs-to-purchase-order-return-order",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "return-claim-belongs-to-purchase-order-return-order",
            "required": true,
            "sourceFieldId": "purchase-order-id",
            "targetEntityId": "purchase-order",
            "targetFieldId": "purchase-order-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links returns and delivery claims to the governed receipt line record referenced by receipt line ids.",
            "id": "return-claim-belongs-to-receipt-line-receipt-line-ids-to-receipt-line",
            "introducedIn": "1.1.0",
            "predicate": "belongs-to",
            "qualifiedId": "return-claim-belongs-to-receipt-line-receipt-line-ids-to-receipt-line",
            "required": true,
            "sourceFieldId": "receipt-line-ids",
            "targetEntityId": "receipt-line",
            "targetFieldId": "receipt-line-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links returns and delivery claims to the governed evidence item record referenced by evidence references.",
            "id": "return-claim-evidenced-by-evidence-item-evidence-ids-to-evidence-item",
            "introducedIn": "1.1.0",
            "predicate": "evidenced-by",
            "qualifiedId": "return-claim-evidenced-by-evidence-item-evidence-ids-to-evidence-item",
            "required": true,
            "sourceFieldId": "evidence-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authority envelope governing this record.",
            "id": "return-claim-governed-by-authority-envelope-return-claim-governance-authority",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "return-claim-governed-by-authority-envelope-return-claim-governance-authority",
            "required": false,
            "sourceFieldId": "governance-authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          }
        ],
        "retentionClass": "financial",
        "searchTerms": [
          "goods return",
          "delivery claim",
          "return merchandise",
          "credit claim"
        ],
        "sourceSystemRoleIds": [
          "transport-execution-boundary",
          "managed-network",
          "planning-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "managed-network",
          "planning-system",
          "execution-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "invoice-exception-triage",
          "payment-execution-guard",
          "payment-readiness",
          "supplier-invoice-resolution"
        ],
        "definition": "The canonical, versioned invoice header received from a supplier or source channel, preserving standards semantics, source provenance and the distinction between observed document state and platform processing state.",
        "domainWorkblockIds": [
          "invoice-exception-payment-readiness"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable tenant-scoped identifier for the canonical invoice across source retries and processing stages.",
            "exchangeScope": "mapped",
            "format": "uuid",
            "id": "invoice-id",
            "introducedIn": "1.0.0",
            "label": "Invoice ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "Use the exchange UUID when governed and unique; otherwise retain it separately from the platform identifier.",
                "path": "cbc:UUID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Supplier-assigned identifier for the invoice or credit document.",
            "exchangeScope": "mapped",
            "id": "invoice-number",
            "introducedIn": "1.0.0",
            "label": "Invoice number",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              },
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "BT-1",
                "releaseId": "en-16931",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "en-16931",
                "transformation": "none"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Governed document type distinguishing invoice, debit, credit and supported correction semantics.",
            "exchangeScope": "mapped",
            "id": "invoice-type-code",
            "introducedIn": "1.0.0",
            "label": "Invoice type code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:InvoiceTypeCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              },
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "BT-3",
                "releaseId": "en-16931",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "en-16931",
                "transformation": "none"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Canonical party representing the accounting supplier after identity resolution.",
            "exchangeScope": "mapped",
            "id": "supplier-party-id",
            "introducedIn": "1.0.0",
            "label": "Supplier party reference",
            "nullable": false,
            "referenceEntityId": "party",
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:AccountingSupplierParty/cac:Party/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:AccountingSupplierParty/cac:Party/cac:PartyIdentification/cbc:ID",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "peppol-bis-billing-3",
                "transformation": "none"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Canonical party representing the accounting customer or legal entity.",
            "exchangeScope": "mapped",
            "id": "customer-party-id",
            "introducedIn": "1.0.0",
            "label": "Customer party reference",
            "nullable": false,
            "referenceEntityId": "party",
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:AccountingCustomerParty/cac:Party/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:AccountingCustomerParty/cac:Party/cac:PartyIdentification/cbc:ID",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "peppol-bis-billing-3",
                "transformation": "none"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Supplier-declared invoice issue date.",
            "exchangeScope": "mapped",
            "format": "date",
            "id": "issue-date",
            "introducedIn": "1.0.0",
            "label": "Issue date",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:IssueDate",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              },
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "BT-2",
                "releaseId": "en-16931",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "en-16931",
                "transformation": "none"
              }
            ],
            "type": "date"
          },
          {
            "classification": "confidential",
            "definition": "Current contractual or invoice due date used for readiness and prioritisation.",
            "exchangeScope": "mapped",
            "format": "date",
            "id": "due-date",
            "introducedIn": "1.0.0",
            "label": "Due date",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:DueDate",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              },
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "BT-9",
                "releaseId": "en-16931",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "en-16931",
                "transformation": "none"
              }
            ],
            "type": "date"
          },
          {
            "classification": "confidential",
            "definition": "Identifiers for orders cited by the invoice, resolved through the ordering adapter without duplicating the order ledger.",
            "exchangeScope": "mapped",
            "id": "order-ids",
            "introducedIn": "1.0.0",
            "label": "Order references",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "purchase-order",
            "required": false,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OrderReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "confidential",
            "definition": "Identifiers for governing agreements cited or resolved for the invoice.",
            "exchangeScope": "mapped",
            "id": "contract-ids",
            "introducedIn": "1.0.0",
            "label": "Contract references",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "contract",
            "required": false,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:ContractDocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "confidential",
            "definition": "Identifiers for despatch, receipt or service-entry evidence relevant to matching.",
            "exchangeScope": "mapped",
            "id": "receipt-ids",
            "introducedIn": "1.0.0",
            "label": "Receipt references",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "receipt",
            "required": false,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:DespatchDocumentReference/cbc:ID|cac:ReceiptDocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "confidential",
            "definition": "ISO 4217 currency in which invoice monetary amounts are stated.",
            "exchangeScope": "mapped",
            "format": "iso-4217-alpha",
            "id": "document-currency-code",
            "introducedIn": "1.0.0",
            "label": "Document currency code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:DocumentCurrencyCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              },
              {
                "conceptId": "currency-code",
                "coverage": "exact",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "code-list",
                "path": "alphabetic code",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-4217",
                "transformation": "none"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Structured tax subtotals and total with currency, category, rate and jurisdiction context.",
            "exchangeScope": "mapped",
            "id": "tax-total",
            "introducedIn": "1.0.0",
            "label": "Tax total",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "components": [
                  {
                    "standardPath": "cac:TaxTotal/cbc:TaxAmount",
                    "valuePath": "tax-amount"
                  },
                  {
                    "standardPath": "cac:TaxTotal/cbc:TaxAmount/@currencyID",
                    "valuePath": "currency-code"
                  }
                ],
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:TaxTotal",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Tax amount is the decimal component carried within Invoice Tax total; its classification and authority inherit from the owning field contract.",
                    "id": "tax-amount",
                    "label": "Tax amount",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "tax-total",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Currency code records the governed code within Invoice Tax total without treating absence, unknown and zero as equivalent.",
                    "format": "ISO 4217 alphabetic",
                    "id": "currency-code",
                    "label": "Currency code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "tax-total",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Tax subtotals is the object component carried within Invoice Tax total; its classification and authority inherit from the owning field contract.",
                    "id": "tax-subtotals",
                    "label": "Tax subtotals",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "tax-total",
                      "kind": "inherited-field"
                    },
                    "type": "object",
                    "valueSchema": {
                      "mode": "inline",
                      "schema": {
                        "additionalProperties": false,
                        "container": "object-list",
                        "properties": [
                          {
                            "classification": "confidential",
                            "definition": "Tax category code records the governed code within Tax subtotals without treating absence, unknown and zero as equivalent.",
                            "id": "tax-category-code",
                            "label": "Tax category code",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "tax-total",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "confidential",
                            "definition": "Tax amount is the decimal component carried within Tax subtotals; its classification and authority inherit from the owning field contract.",
                            "id": "tax-amount",
                            "label": "Tax amount",
                            "nullable": false,
                            "required": true,
                            "sourceAuthority": {
                              "id": "tax-total",
                              "kind": "inherited-field"
                            },
                            "type": "decimal"
                          },
                          {
                            "classification": "confidential",
                            "definition": "Taxable amount is the decimal component carried within Tax subtotals; its classification and authority inherit from the owning field contract.",
                            "id": "taxable-amount",
                            "label": "Taxable amount",
                            "nullable": true,
                            "required": false,
                            "sourceAuthority": {
                              "id": "tax-total",
                              "kind": "inherited-field"
                            },
                            "type": "decimal"
                          },
                          {
                            "classification": "confidential",
                            "definition": "Percent is the decimal component carried within Tax subtotals; its classification and authority inherit from the owning field contract.",
                            "id": "percent",
                            "label": "Percent",
                            "nullable": true,
                            "required": false,
                            "sourceAuthority": {
                              "id": "tax-total",
                              "kind": "inherited-field"
                            },
                            "type": "decimal"
                          },
                          {
                            "classification": "confidential",
                            "definition": "Tax scheme ID is the string component carried within Tax subtotals; its classification and authority inherit from the owning field contract.",
                            "id": "tax-scheme-id",
                            "label": "Tax scheme ID",
                            "nullable": true,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": false,
                            "sourceAuthority": {
                              "id": "tax-total",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "confidential",
                            "definition": "Jurisdiction code records the governed code within Tax subtotals without treating absence, unknown and zero as equivalent.",
                            "id": "jurisdiction-code",
                            "label": "Jurisdiction code",
                            "nullable": true,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": false,
                            "sourceAuthority": {
                              "id": "tax-total",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          }
                        ],
                        "uniqueBy": [
                          "tax-category-code",
                          "tax-scheme-id",
                          "jurisdiction-code"
                        ]
                      },
                      "schemaVersion": "1.0.0"
                    }
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Structured invoice-level allowances and charges reconciled to monetary totals.",
            "exchangeScope": "mapped",
            "id": "allowance-charge-total",
            "introducedIn": "1.0.0",
            "label": "Allowance and charge total",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "components": [
                  {
                    "standardPath": "cac:AllowanceCharge/cbc:ChargeIndicator",
                    "valuePath": "charge-indicator"
                  },
                  {
                    "standardPath": "cac:AllowanceCharge/cbc:Amount",
                    "valuePath": "amount"
                  },
                  {
                    "standardPath": "cac:AllowanceCharge/cbc:Amount/@currencyID",
                    "valuePath": "currency-code"
                  }
                ],
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:AllowanceCharge",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Charge indicator is the boolean component carried within Invoice Allowance and charge total; its classification and authority inherit from the owning field contract.",
                    "id": "charge-indicator",
                    "label": "Charge indicator",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "allowance-charge-total",
                      "kind": "inherited-field"
                    },
                    "type": "boolean"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Amount is the decimal component carried within Invoice Allowance and charge total; its classification and authority inherit from the owning field contract.",
                    "id": "amount",
                    "label": "Amount",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "allowance-charge-total",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Currency code records the governed code within Invoice Allowance and charge total without treating absence, unknown and zero as equivalent.",
                    "format": "ISO 4217 alphabetic",
                    "id": "currency-code",
                    "label": "Currency code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "allowance-charge-total",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Reason code records the governed code within Invoice Allowance and charge total without treating absence, unknown and zero as equivalent.",
                    "id": "reason-code",
                    "label": "Reason code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "allowance-charge-total",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Reason is the string component carried within Invoice Allowance and charge total; its classification and authority inherit from the owning field contract.",
                    "id": "reason",
                    "label": "Reason",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "allowance-charge-total",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Base amount is the decimal component carried within Invoice Allowance and charge total; its classification and authority inherit from the owning field contract.",
                    "id": "base-amount",
                    "label": "Base amount",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "allowance-charge-total",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Multiplier factor is the decimal component carried within Invoice Allowance and charge total; its classification and authority inherit from the owning field contract.",
                    "id": "multiplier-factor",
                    "label": "Multiplier factor",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "allowance-charge-total",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  }
                ],
                "uniqueBy": [
                  "charge-indicator",
                  "reason-code",
                  "amount",
                  "currency-code",
                  "base-amount",
                  "multiplier-factor"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Structured line extension, tax-exclusive, tax-inclusive, allowance, charge, prepaid, rounding and payable amounts.",
            "exchangeScope": "mapped",
            "id": "legal-monetary-total",
            "introducedIn": "1.0.0",
            "label": "Legal monetary total",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "components": [
                  {
                    "standardPath": "cac:LegalMonetaryTotal/cbc:LineExtensionAmount",
                    "valuePath": "line-extension-amount"
                  },
                  {
                    "standardPath": "cac:LegalMonetaryTotal/cbc:TaxExclusiveAmount",
                    "valuePath": "tax-exclusive-amount"
                  },
                  {
                    "standardPath": "cac:LegalMonetaryTotal/cbc:TaxInclusiveAmount",
                    "valuePath": "tax-inclusive-amount"
                  },
                  {
                    "standardPath": "cac:LegalMonetaryTotal/cbc:PayableAmount",
                    "valuePath": "payable-amount"
                  },
                  {
                    "standardPath": "cac:LegalMonetaryTotal/cbc:PayableAmount/@currencyID",
                    "valuePath": "currency-code"
                  }
                ],
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:LegalMonetaryTotal",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Line extension amount is the decimal component carried within Invoice Legal monetary total; its classification and authority inherit from the owning field contract.",
                    "id": "line-extension-amount",
                    "label": "Line extension amount",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "legal-monetary-total",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Tax exclusive amount is the decimal component carried within Invoice Legal monetary total; its classification and authority inherit from the owning field contract.",
                    "id": "tax-exclusive-amount",
                    "label": "Tax exclusive amount",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "legal-monetary-total",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Tax inclusive amount is the decimal component carried within Invoice Legal monetary total; its classification and authority inherit from the owning field contract.",
                    "id": "tax-inclusive-amount",
                    "label": "Tax inclusive amount",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "legal-monetary-total",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Payable amount is the decimal component carried within Invoice Legal monetary total; its classification and authority inherit from the owning field contract.",
                    "id": "payable-amount",
                    "label": "Payable amount",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "legal-monetary-total",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Currency code records the governed code within Invoice Legal monetary total without treating absence, unknown and zero as equivalent.",
                    "format": "ISO 4217 alphabetic",
                    "id": "currency-code",
                    "label": "Currency code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "legal-monetary-total",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Allowance total amount is the decimal component carried within Invoice Legal monetary total; its classification and authority inherit from the owning field contract.",
                    "id": "allowance-total-amount",
                    "label": "Allowance total amount",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "legal-monetary-total",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Charge total amount is the decimal component carried within Invoice Legal monetary total; its classification and authority inherit from the owning field contract.",
                    "id": "charge-total-amount",
                    "label": "Charge total amount",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "legal-monetary-total",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Prepaid amount is the decimal component carried within Invoice Legal monetary total; its classification and authority inherit from the owning field contract.",
                    "id": "prepaid-amount",
                    "label": "Prepaid amount",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "legal-monetary-total",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Payable rounding amount is the decimal component carried within Invoice Legal monetary total; its classification and authority inherit from the owning field contract.",
                    "id": "payable-rounding-amount",
                    "label": "Payable rounding amount",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "legal-monetary-total",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Structured payment method and tokenised account references; raw sensitive account data is not exposed to general Workblocks.",
            "exchangeScope": "mapped",
            "id": "payment-means",
            "introducedIn": "1.0.0",
            "label": "Payment means",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "components": [
                  {
                    "standardPath": "cac:PaymentMeans/cbc:PaymentMeansCode",
                    "valuePath": "payment-means-code"
                  }
                ],
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:PaymentMeans",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Payment means code records the governed code within Invoice Payment means without treating absence, unknown and zero as equivalent.",
                    "id": "payment-means-code",
                    "label": "Payment means code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "payment-means",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Payment ID is the string component carried within Invoice Payment means; its classification and authority inherit from the owning field contract.",
                    "id": "payment-id",
                    "label": "Payment ID",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "payment-means",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Account token reference is the string component carried within Invoice Payment means; its classification and authority inherit from the owning field contract.",
                    "format": "tokenised account reference",
                    "id": "account-token-reference",
                    "label": "Account token reference",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "payment-means",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Mandate reference is the string component carried within Invoice Payment means; its classification and authority inherit from the owning field contract.",
                    "id": "mandate-reference",
                    "label": "Mandate reference",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "payment-means",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Instruction note is the string component carried within Invoice Payment means; its classification and authority inherit from the owning field contract.",
                    "id": "instruction-note",
                    "label": "Instruction note",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "payment-means",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ],
                "uniqueBy": [
                  "payment-means-code",
                  "payment-id",
                  "mandate-reference"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Structured payment terms, due calculation inputs, discounts and penalties.",
            "exchangeScope": "mapped",
            "id": "payment-terms",
            "introducedIn": "1.0.0",
            "label": "Payment terms",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "The governed term type is derived from UBL payment-term leaves; no single required UBL leaf proves the complete inline contract.",
                "path": "cac:PaymentTerms",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Term type code records the governed code within Invoice Payment terms without treating absence, unknown and zero as equivalent.",
                    "id": "term-type-code",
                    "label": "Term type code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "payment-terms",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Reference event code records the governed code within Invoice Payment terms without treating absence, unknown and zero as equivalent.",
                    "id": "reference-event-code",
                    "label": "Reference event code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "payment-terms",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Due date is the date component carried within Invoice Payment terms; its classification and authority inherit from the owning field contract.",
                    "id": "due-date",
                    "label": "Due date",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "payment-terms",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Settlement discount percent is the decimal component carried within Invoice Payment terms; its classification and authority inherit from the owning field contract.",
                    "id": "settlement-discount-percent",
                    "label": "Settlement discount percent",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "payment-terms",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Penalty percent is the decimal component carried within Invoice Payment terms; its classification and authority inherit from the owning field contract.",
                    "id": "penalty-percent",
                    "label": "Penalty percent",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "payment-terms",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Payment percent is the decimal component carried within Invoice Payment terms; its classification and authority inherit from the owning field contract.",
                    "id": "payment-percent",
                    "label": "Payment percent",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "payment-terms",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Amount is the money component carried within Invoice Payment terms; its classification and authority inherit from the owning field contract.",
                    "id": "amount",
                    "label": "Amount",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "payment-terms",
                      "kind": "inherited-field"
                    },
                    "type": "money",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "money-value",
                      "schemaVersion": "2.0.0"
                    }
                  },
                  {
                    "classification": "confidential",
                    "definition": "Note is the string component carried within Invoice Payment terms; its classification and authority inherit from the owning field contract.",
                    "id": "note",
                    "label": "Note",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "payment-terms",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ],
                "uniqueBy": [
                  "term-type-code",
                  "reference-event-code",
                  "due-date",
                  "payment-percent"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Reference to the immutable structured message or rendered invoice artifact.",
            "exchangeScope": "mapped",
            "id": "source-artifact-id",
            "introducedIn": "1.0.0",
            "label": "Source artifact reference",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:AdditionalDocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Stable identifier for the authoritative source adapter.",
            "exchangeScope": "unmapped",
            "id": "source-system",
            "introducedIn": "1.0.0",
            "label": "Source system",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Exact structured-message or adapter schema version used during ingestion.",
            "exchangeScope": "unmapped",
            "id": "source-schema-version",
            "introducedIn": "1.0.0",
            "label": "Source schema version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Timestamp at which the source version was observed.",
            "exchangeScope": "mapped",
            "format": "date-time",
            "id": "observed-at",
            "introducedIn": "1.0.0",
            "label": "Observed at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "conceptId": "date-time-value",
                "coverage": "exact",
                "direction": "inbound",
                "exchangeScope": "edge-interchange",
                "mappingKind": "value-format",
                "path": "date-time representation",
                "releaseId": "iso-8601-1-2019",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-8601",
                "transformation": "none"
              }
            ],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "References to immutable source, validation, correction and reconciliation evidence.",
            "exchangeScope": "unmapped",
            "id": "evidence-ids",
            "introducedIn": "1.0.0",
            "label": "Evidence references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Policy version that governed canonicalisation and current processing state.",
            "exchangeScope": "unmapped",
            "id": "policy-version-id",
            "introducedIn": "1.0.0",
            "label": "Policy version",
            "nullable": false,
            "referenceEntityId": "policy-version",
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Version of invoice-intake-match that produced the record.",
            "exchangeScope": "unmapped",
            "id": "workblock-version",
            "introducedIn": "1.0.0",
            "label": "Workblock version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "invoice",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "business-key"
            ],
            "id": "invoice-by-business-key",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "invoice-number",
              "supplier-party-id"
            ],
            "id": "invoice-by-invoice-number-and-supplier-party-reference",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "due-date",
              "lifecycle-state"
            ],
            "id": "invoice-by-due-date-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "order-ids"
            ],
            "id": "invoice-by-order-references",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "freshness-status"
            ],
            "id": "invoice-by-freshness-status",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "transaction",
        "label": "Invoice",
        "lifecycle": [
          "received",
          "validating",
          "validated",
          "matched",
          "exception",
          "ready",
          "submitted-for-payment",
          "paid",
          "rejected",
          "credited",
          "superseded"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "invoice-intake-match",
        "owningDomainWorkblockId": "invoice-exception-payment-readiness",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Invoices",
        "primaryKey": "invoice-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the invoice to the referenced party.",
            "id": "invoice-belongs-to-party-invoice-supplier-party-id",
            "introducedIn": "2.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "invoice-belongs-to-party-invoice-supplier-party-id",
            "required": true,
            "sourceFieldId": "supplier-party-id",
            "targetEntityId": "party",
            "targetFieldId": "party-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the invoice to the referenced party.",
            "id": "invoice-belongs-to-party-invoice-customer-party-id",
            "introducedIn": "2.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "invoice-belongs-to-party-invoice-customer-party-id",
            "required": true,
            "sourceFieldId": "customer-party-id",
            "targetEntityId": "party",
            "targetFieldId": "party-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the invoice to the referenced purchase orders.",
            "id": "invoice-belongs-to-purchase-order-invoice-order-ids",
            "introducedIn": "2.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "invoice-belongs-to-purchase-order-invoice-order-ids",
            "required": false,
            "sourceFieldId": "order-ids",
            "targetEntityId": "purchase-order",
            "targetFieldId": "purchase-order-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the invoice to the referenced contracts.",
            "id": "invoice-belongs-to-contract-invoice-contract-ids",
            "introducedIn": "2.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "invoice-belongs-to-contract-invoice-contract-ids",
            "required": false,
            "sourceFieldId": "contract-ids",
            "targetEntityId": "contract",
            "targetFieldId": "contract-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the invoice to the referenced receipts.",
            "id": "invoice-belongs-to-receipt-invoice-receipt-ids",
            "introducedIn": "2.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "invoice-belongs-to-receipt-invoice-receipt-ids",
            "required": false,
            "sourceFieldId": "receipt-ids",
            "targetEntityId": "receipt",
            "targetFieldId": "receipt-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the invoice to the referenced evidence item.",
            "id": "invoice-evidenced-by-evidence-item-invoice-source-artifact-id",
            "introducedIn": "2.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "invoice-evidenced-by-evidence-item-invoice-source-artifact-id",
            "required": true,
            "sourceFieldId": "source-artifact-id",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the invoice to the referenced evidence items.",
            "id": "invoice-evidenced-by-evidence-item-invoice-evidence-ids",
            "introducedIn": "2.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "invoice-evidenced-by-evidence-item-invoice-evidence-ids",
            "required": true,
            "sourceFieldId": "evidence-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the invoice to the referenced policy version.",
            "id": "invoice-governed-by-policy-version-id-invoice-policy-version-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "invoice-governed-by-policy-version-id-invoice-policy-version-id",
            "required": true,
            "sourceFieldId": "policy-version-id",
            "targetEntityId": "policy-version",
            "targetFieldId": "policy-version-id"
          }
        ],
        "retentionClass": "financial",
        "searchTerms": [
          "invoice",
          "supplier invoice",
          "accounts payable document",
          "billing document",
          "credit correction"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "What did the supplier actually invoice, on which document version, from which channel?",
              "Which party, order and contract references does this invoice carry?"
            ],
            "retrievalTerms": [
              "invoice header",
              "billing document",
              "supplier billing",
              "accounts payable"
            ],
            "usage": "Treat the invoice as the canonical, versioned received document preserving standards semantics and source provenance; observed document values stay distinct from derived interpretation."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "supplier invoice",
              "AP invoice",
              "supplier bill",
              "e-invoice"
            ],
            "concept": "supplier-invoice-header",
            "doNotConfuseWith": [
              {
                "distinction": "The invoice is the canonical received document; an invoice-exception is the case opened when it cannot continue straight through.",
                "targetEntityId": "invoice-exception"
              }
            ]
          },
          "standardsAlignment": [
            {
              "concept": "UBL Invoice document",
              "matchKind": "close",
              "standardId": "ubl-2-4"
            },
            {
              "concept": "EN 16931 core invoice model",
              "matchKind": "close",
              "standardId": "en-16931"
            },
            {
              "concept": "Peppol BIS Billing 3.0 invoice",
              "matchKind": "close",
              "standardId": "peppol-bis-billing-3"
            },
            {
              "concept": "cXML InvoiceDetailRequest",
              "matchKind": "related",
              "standardId": "cxml-1-2-070"
            },
            {
              "concept": "SAP INVOIC IDoc",
              "matchKind": "related",
              "standardId": "sap-idoc"
            }
          ]
        },
        "sourceSystemRoleIds": [
          "execution-system",
          "planning-system",
          "evidence-source"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "planning-system",
          "execution-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "payment-readiness",
          "supplier-invoice-resolution"
        ],
        "definition": "A canonical line from an invoice with item, quantity, price, tax, commercial references and exact source anchoring for match and value analysis.",
        "domainWorkblockIds": [
          "invoice-exception-payment-readiness"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for the canonical line within the invoice version.",
            "exchangeScope": "mapped",
            "format": "uuid",
            "id": "invoice-line-id",
            "introducedIn": "1.0.0",
            "label": "Invoice line ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:InvoiceLine/cbc:UUID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Canonical invoice containing the line.",
            "exchangeScope": "mapped",
            "id": "invoice-id",
            "introducedIn": "1.0.0",
            "label": "Invoice ID",
            "nullable": false,
            "referenceEntityId": "invoice",
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Supplier-assigned line identifier within the invoice.",
            "exchangeScope": "mapped",
            "id": "line-number",
            "introducedIn": "1.0.0",
            "label": "Line number",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:InvoiceLine/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Canonical or source item or service identifier used for matching and classification.",
            "exchangeScope": "mapped",
            "id": "item-reference",
            "introducedIn": "1.0.0",
            "label": "Item or service reference",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:InvoiceLine/cac:Item/cac:SellersItemIdentification/cbc:ID|cac:InvoiceLine/cac:Item/cac:StandardItemIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              },
              {
                "conceptId": "gtin",
                "coverage": "semantic",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "identifier-namespace",
                "path": "Global Trade Item Number",
                "releaseId": "source-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "gs1-identifiers",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Supplier-provided line description after safe canonical text normalization.",
            "exchangeScope": "mapped",
            "id": "description",
            "introducedIn": "1.0.0",
            "label": "Description",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:InvoiceLine/cac:Item/cbc:Description",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "text"
          },
          {
            "classification": "confidential",
            "definition": "Structured invoiced quantity with unit code and precision.",
            "exchangeScope": "mapped",
            "id": "quantity",
            "introducedIn": "1.0.0",
            "label": "Quantity",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "components": [
                  {
                    "standardPath": "cac:InvoiceLine/cbc:InvoicedQuantity",
                    "valuePath": "value"
                  },
                  {
                    "standardPath": "cac:InvoiceLine/cbc:InvoicedQuantity/@unitCode",
                    "valuePath": "unit-code"
                  }
                ],
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:InvoiceLine/cbc:InvoicedQuantity",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "quantity",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "quantity-value",
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Structured item price, base quantity, currency and allowance context.",
            "exchangeScope": "mapped",
            "id": "price",
            "introducedIn": "1.0.0",
            "label": "Price",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "components": [
                  {
                    "standardPath": "cac:InvoiceLine/cac:Price/cbc:PriceAmount",
                    "valuePath": "price-amount"
                  },
                  {
                    "standardPath": "cac:InvoiceLine/cac:Price/cbc:PriceAmount/@currencyID",
                    "valuePath": "currency-code"
                  }
                ],
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:InvoiceLine/cac:Price",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Price amount is the decimal component carried within Invoice line Price; its classification and authority inherit from the owning field contract.",
                    "id": "price-amount",
                    "label": "Price amount",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "price",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Currency code records the governed code within Invoice line Price without treating absence, unknown and zero as equivalent.",
                    "format": "ISO 4217 alphabetic",
                    "id": "currency-code",
                    "label": "Currency code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "price",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Base quantity is the quantity component carried within Invoice line Price; its classification and authority inherit from the owning field contract.",
                    "id": "base-quantity",
                    "label": "Base quantity",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "price",
                      "kind": "inherited-field"
                    },
                    "type": "quantity",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "quantity-value",
                      "schemaVersion": "1.0.0"
                    }
                  },
                  {
                    "classification": "confidential",
                    "definition": "Price type code records the governed code within Invoice line Price without treating absence, unknown and zero as equivalent.",
                    "id": "price-type-code",
                    "label": "Price type code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "price",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Price type label is the string component carried within Invoice line Price; its classification and authority inherit from the owning field contract.",
                    "id": "price-type-label",
                    "label": "Price type label",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "price",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Allowance charge reason is the string component carried within Invoice line Price; its classification and authority inherit from the owning field contract.",
                    "id": "allowance-charge-reason",
                    "label": "Allowance charge reason",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "price",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "compositeValueContract": {
              "componentFieldIds": [
                "line-extension-amount"
              ],
              "representation": "registry-object",
              "schemaId": "money-value",
              "schemaVersion": "2.0.0"
            },
            "definition": "Net line amount before document-level tax and settlement adjustments.",
            "exchangeScope": "mapped",
            "id": "line-extension-amount",
            "introducedIn": "1.0.0",
            "label": "Line extension amount",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "components": [
                  {
                    "standardPath": "cac:InvoiceLine/cbc:LineExtensionAmount",
                    "valuePath": "amount"
                  },
                  {
                    "standardPath": "cac:InvoiceLine/cbc:LineExtensionAmount/@currencyID",
                    "valuePath": "currency-code"
                  }
                ],
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:InvoiceLine/cbc:LineExtensionAmount",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "money",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "money-value",
              "schemaVersion": "2.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Structured line tax category, percent, scheme and exemption reason.",
            "exchangeScope": "mapped",
            "id": "tax-category",
            "introducedIn": "1.0.0",
            "label": "Tax category",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "components": [
                  {
                    "standardPath": "cac:InvoiceLine/cac:Item/cac:ClassifiedTaxCategory/cbc:ID",
                    "valuePath": "category-code"
                  },
                  {
                    "standardPath": "cac:InvoiceLine/cac:Item/cac:ClassifiedTaxCategory/cac:TaxScheme/cbc:ID",
                    "valuePath": "tax-scheme-id"
                  }
                ],
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:InvoiceLine/cac:Item/cac:ClassifiedTaxCategory",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Category code records the governed code within Invoice line Tax category without treating absence, unknown and zero as equivalent.",
                    "id": "category-code",
                    "label": "Category code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "tax-category",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Tax scheme ID is the string component carried within Invoice line Tax category; its classification and authority inherit from the owning field contract.",
                    "id": "tax-scheme-id",
                    "label": "Tax scheme ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "tax-category",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Percent is the decimal component carried within Invoice line Tax category; its classification and authority inherit from the owning field contract.",
                    "id": "percent",
                    "label": "Percent",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "tax-category",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Exemption reason code records the governed code within Invoice line Tax category without treating absence, unknown and zero as equivalent.",
                    "id": "exemption-reason-code",
                    "label": "Exemption reason code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "tax-category",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Exemption reason is the string component carried within Invoice line Tax category; its classification and authority inherit from the owning field contract.",
                    "id": "exemption-reason",
                    "label": "Exemption reason",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "tax-category",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Source reference to the applicable purchase-order line.",
            "exchangeScope": "mapped",
            "id": "order-line-reference",
            "introducedIn": "1.0.0",
            "label": "Order line reference",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:InvoiceLine/cac:OrderLineReference/cbc:LineID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "References to receipt, despatch or service-entry lines used for matching.",
            "exchangeScope": "mapped",
            "id": "receipt-line-ids",
            "introducedIn": "1.0.0",
            "label": "Receipt line references",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "receipt-line",
            "required": false,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "Receipt-line references are carried explicitly; despatch-line and generic document references are not treated as receipt-line identities.",
                "path": "cac:InvoiceLine/cac:ReceiptLineReference/cbc:LineID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "restricted",
            "definition": "Stable structural or page-and-span anchor to the received source artifact.",
            "exchangeScope": "unmapped",
            "id": "source-anchor",
            "introducedIn": "1.0.0",
            "label": "Source anchor",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Authoritative invoice source adapter.",
            "exchangeScope": "unmapped",
            "id": "source-system",
            "introducedIn": "1.0.0",
            "label": "Source system",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Exact source message or extraction schema version.",
            "exchangeScope": "unmapped",
            "id": "source-schema-version",
            "introducedIn": "1.0.0",
            "label": "Source schema version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Timestamp at which this line version was observed.",
            "exchangeScope": "unmapped",
            "format": "date-time",
            "id": "observed-at",
            "introducedIn": "1.0.0",
            "label": "Observed at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Source, validation, match and correction evidence.",
            "exchangeScope": "unmapped",
            "id": "evidence-ids",
            "introducedIn": "1.0.0",
            "label": "Evidence references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Policy version governing line canonicalisation.",
            "exchangeScope": "unmapped",
            "id": "policy-version-id",
            "introducedIn": "1.0.0",
            "label": "Policy version",
            "nullable": false,
            "referenceEntityId": "policy-version",
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Workblock version producing the line.",
            "exchangeScope": "unmapped",
            "id": "workblock-version",
            "introducedIn": "1.0.0",
            "label": "Workblock version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "invoice-line",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "invoice-id",
              "line-number"
            ],
            "id": "invoice-line-by-invoice-id-and-line-number",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "order-line-reference"
            ],
            "id": "invoice-line-by-order-line-reference",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "item-reference"
            ],
            "id": "invoice-line-by-item-reference",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "freshness-status"
            ],
            "id": "invoice-line-by-freshness-status",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "transaction",
        "label": "Invoice line",
        "lifecycle": [
          "received",
          "validated",
          "matched",
          "exception",
          "credited",
          "superseded"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "invoice-intake-match",
        "owningDomainWorkblockId": "invoice-exception-payment-readiness",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Invoice lines",
        "primaryKey": "invoice-line-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Associates the canonical line with its invoice header.",
            "id": "invoice-line-belongs-to-invoice-line-of-invoice",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "invoice-line-belongs-to-invoice-line-of-invoice",
            "required": true,
            "sourceFieldId": "invoice-id",
            "targetEntityId": "invoice",
            "targetFieldId": "invoice-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the invoice line to the referenced receipt lines.",
            "id": "invoice-line-belongs-to-receipt-line-invoice-line-receipt-line-ids",
            "introducedIn": "2.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "invoice-line-belongs-to-receipt-line-invoice-line-receipt-line-ids",
            "required": false,
            "sourceFieldId": "receipt-line-ids",
            "targetEntityId": "receipt-line",
            "targetFieldId": "receipt-line-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the invoice line to the referenced evidence items.",
            "id": "invoice-line-evidenced-by-evidence-item-invoice-line-evidence-ids",
            "introducedIn": "2.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "invoice-line-evidenced-by-evidence-item-invoice-line-evidence-ids",
            "required": true,
            "sourceFieldId": "evidence-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the invoice line to the referenced policy version.",
            "id": "invoice-line-governed-by-policy-version-id-invoice-line-policy-version-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "invoice-line-governed-by-policy-version-id-invoice-line-policy-version-id",
            "required": true,
            "sourceFieldId": "policy-version-id",
            "targetEntityId": "policy-version",
            "targetFieldId": "policy-version-id"
          }
        ],
        "retentionClass": "financial",
        "searchTerms": [
          "invoice line",
          "billing line",
          "line item",
          "invoiced item"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "What items, quantities and prices were invoiced on each line?",
              "Which order line or receipt does this invoice line anchor to?"
            ],
            "retrievalTerms": [
              "line item",
              "invoice detail",
              "tax line",
              "unit price"
            ],
            "usage": "Read invoice-lines for item, quantity, price, tax and commercial references with exact source anchoring; match and value analysis operate on lines, not on header totals alone."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "invoice item",
              "billing line"
            ],
            "concept": "invoice-line-item"
          },
          "standardsAlignment": [
            {
              "concept": "UBL InvoiceLine",
              "matchKind": "close",
              "standardId": "ubl-2-4"
            },
            {
              "concept": "EN 16931 invoice line",
              "matchKind": "close",
              "standardId": "en-16931"
            }
          ]
        },
        "sourceSystemRoleIds": [
          "execution-system",
          "planning-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "planning-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "invoice-exception-triage",
          "payment-readiness"
        ],
        "definition": "An immutable assessment of an invoice against a pinned comparison set, tolerance policy and evidence version, producing an explainable result without overwriting prior assessments.",
        "domainWorkblockIds": [
          "invoice-exception-payment-readiness"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for this exact assessment version.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "invoice-match-assessment-id",
            "introducedIn": "1.0.0",
            "label": "Match assessment ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Invoice evaluated by the assessment.",
            "exchangeScope": "mapped",
            "id": "invoice-id",
            "introducedIn": "1.0.0",
            "label": "Invoice ID",
            "nullable": false,
            "referenceEntityId": "invoice",
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Governed comparison pattern used for the assessment.",
            "enumValues": [
              "invoice-only",
              "two-way",
              "three-way",
              "service-entry",
              "contract-based",
              "policy-defined"
            ],
            "exchangeScope": "internal",
            "id": "match-basis",
            "introducedIn": "1.0.0",
            "label": "Match basis",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Pinned invoice, line, order, receipt, service-entry and contract facts used in matching.",
            "exchangeScope": "mapped",
            "id": "comparison-set",
            "introducedIn": "1.0.0",
            "label": "Comparison set",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:OrderReference|cac:DespatchDocumentReference|cac:ReceiptDocumentReference|cac:ContractDocumentReference",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Comparison fact ID is the string component carried within Invoice match assessment Comparison set; its classification and authority inherit from the owning field contract.",
                    "id": "comparison-fact-id",
                    "label": "Comparison fact ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "comparison-set",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Fact role is the string component carried within Invoice match assessment Comparison set; its classification and authority inherit from the owning field contract.",
                    "id": "fact-role",
                    "label": "Fact role",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "comparison-set",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Source record reference links this structured value to the governed source-record-reference record within Invoice match assessment Comparison set.",
                    "id": "source-record-id",
                    "label": "Source record reference",
                    "nullable": false,
                    "referenceEntityId": "source-record-reference",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the source record reference in comparison set to the referenced source record reference via its canonical source record reference ID.",
                      "id": "invoice-match-assessment-comparison-set-source-record-reference",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "source-record-reference-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "comparison-set",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Source path is the string component carried within Invoice match assessment Comparison set; its classification and authority inherit from the owning field contract.",
                    "id": "source-path",
                    "label": "Source path",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "comparison-set",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Value is the object component carried within Invoice match assessment Comparison set; its classification and authority inherit from the owning field contract.",
                    "id": "value",
                    "label": "Value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "comparison-set",
                      "kind": "inherited-field"
                    },
                    "type": "object",
                    "valueSchema": {
                      "mode": "inline",
                      "schema": {
                        "additionalProperties": false,
                        "container": "object",
                        "properties": [
                          {
                            "classification": "restricted",
                            "definition": "Value type records the governed state or type within Value without treating absence, unknown and zero as equivalent.",
                            "id": "value-type",
                            "label": "Value type",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "comparison-set",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Text value is the string component carried within Value; its classification and authority inherit from the owning field contract.",
                            "id": "text-value",
                            "label": "Text value",
                            "nullable": true,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": false,
                            "sourceAuthority": {
                              "id": "comparison-set",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Decimal value is the decimal component carried within Value; its classification and authority inherit from the owning field contract.",
                            "id": "decimal-value",
                            "label": "Decimal value",
                            "nullable": true,
                            "required": false,
                            "sourceAuthority": {
                              "id": "comparison-set",
                              "kind": "inherited-field"
                            },
                            "type": "decimal"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Boolean value is the boolean component carried within Value; its classification and authority inherit from the owning field contract.",
                            "id": "boolean-value",
                            "label": "Boolean value",
                            "nullable": true,
                            "required": false,
                            "sourceAuthority": {
                              "id": "comparison-set",
                              "kind": "inherited-field"
                            },
                            "type": "boolean"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Date value is the date component carried within Value; its classification and authority inherit from the owning field contract.",
                            "id": "date-value",
                            "label": "Date value",
                            "nullable": true,
                            "required": false,
                            "sourceAuthority": {
                              "id": "comparison-set",
                              "kind": "inherited-field"
                            },
                            "type": "date"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Unit code records the governed code within Value without treating absence, unknown and zero as equivalent.",
                            "id": "unit-code",
                            "label": "Unit code",
                            "nullable": true,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": false,
                            "sourceAuthority": {
                              "id": "comparison-set",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Currency code records the governed code within Value without treating absence, unknown and zero as equivalent.",
                            "format": "ISO 4217 alphabetic",
                            "id": "currency-code",
                            "label": "Currency code",
                            "nullable": true,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": false,
                            "sourceAuthority": {
                              "id": "comparison-set",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          }
                        ]
                      },
                      "schemaVersion": "1.0.0"
                    }
                  },
                  {
                    "classification": "restricted",
                    "definition": "Observed at is the timestamp component carried within Invoice match assessment Comparison set; its classification and authority inherit from the owning field contract.",
                    "id": "observed-at",
                    "label": "Observed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "comparison-set",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Freshness status records the governed state or type within Invoice match assessment Comparison set without treating absence, unknown and zero as equivalent.",
                    "id": "freshness-status",
                    "label": "Freshness status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "comparison-set",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence reference links this structured value to the governed evidence-item record within Invoice match assessment Comparison set.",
                    "id": "evidence-id",
                    "label": "Evidence reference",
                    "nullable": true,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the evidence reference in comparison set to the referenced evidence item via its canonical evidence item ID.",
                      "id": "invoice-match-assessment-comparison-set-evidence-reference",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "comparison-set",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  }
                ],
                "uniqueBy": [
                  "comparison-fact-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Exact absolute, percentage, quantity, timing and tax tolerances applied by scope.",
            "exchangeScope": "internal",
            "id": "tolerances",
            "introducedIn": "1.0.0",
            "label": "Tolerances",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Tolerance ID is the string component carried within Invoice match assessment Tolerances; its classification and authority inherit from the owning field contract.",
                    "id": "tolerance-id",
                    "label": "Tolerance ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "tolerances",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Tolerance type records the governed state or type within Invoice match assessment Tolerances without treating absence, unknown and zero as equivalent.",
                    "id": "tolerance-type",
                    "label": "Tolerance type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "tolerances",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Scope code records the governed code within Invoice match assessment Tolerances without treating absence, unknown and zero as equivalent.",
                    "id": "scope-code",
                    "label": "Scope code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "tolerances",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Comparison direction is the string component carried within Invoice match assessment Tolerances; its classification and authority inherit from the owning field contract.",
                    "id": "comparison-direction",
                    "label": "Comparison direction",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "tolerances",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Absolute value is the decimal component carried within Invoice match assessment Tolerances; its classification and authority inherit from the owning field contract.",
                    "id": "absolute-value",
                    "label": "Absolute value",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "tolerances",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Percentage value is the decimal component carried within Invoice match assessment Tolerances; its classification and authority inherit from the owning field contract.",
                    "id": "percentage-value",
                    "label": "Percentage value",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "tolerances",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Quantity value is the quantity component carried within Invoice match assessment Tolerances; its classification and authority inherit from the owning field contract.",
                    "id": "quantity-value",
                    "label": "Quantity value",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "tolerances",
                      "kind": "inherited-field"
                    },
                    "type": "quantity",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "quantity-value",
                      "schemaVersion": "1.0.0"
                    }
                  },
                  {
                    "classification": "confidential",
                    "definition": "Timing days is the integer component carried within Invoice match assessment Tolerances; its classification and authority inherit from the owning field contract.",
                    "id": "timing-days",
                    "label": "Timing days",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "tolerances",
                      "kind": "inherited-field"
                    },
                    "type": "integer"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Tax category code records the governed code within Invoice match assessment Tolerances without treating absence, unknown and zero as equivalent.",
                    "id": "tax-category-code",
                    "label": "Tax category code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "tolerances",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Policy version links this structured value to the governed policy-version record within Invoice match assessment Tolerances.",
                    "id": "policy-version-id",
                    "label": "Policy version",
                    "nullable": false,
                    "referenceEntityId": "policy-version",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the policy version in tolerances to the referenced policy version via its canonical policy version ID.",
                      "id": "invoice-match-assessment-tolerances-policy-version",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "policy-version-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "tolerances",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  }
                ],
                "uniqueBy": [
                  "tolerance-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Current assessment outcome, distinct from a later exception disposition.",
            "enumValues": [
              "matched",
              "exception",
              "insufficient-evidence",
              "duplicate-suspected",
              "invalid"
            ],
            "exchangeScope": "mapped",
            "id": "result",
            "introducedIn": "1.0.0",
            "label": "Result",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "application-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:DocumentResponse/cac:Response/cbc:ResponseCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Deterministic reason codes explaining every failed or unresolved comparison.",
            "exchangeScope": "mapped",
            "id": "exception-reason-codes",
            "introducedIn": "1.0.0",
            "label": "Exception reason codes",
            "listSemantics": "set",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "application-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:DocumentResponse/cac:Response/cac:Status/cbc:StatusReasonCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string-list"
          },
          {
            "classification": "internal",
            "definition": "Evidence sufficiency band expressed as governed words, not an unexplained numeric model score.",
            "enumValues": [
              "insufficient-or-conflicting",
              "usable-but-uncertain",
              "sufficient-and-deterministic",
              "validated-current-and-calibrated"
            ],
            "exchangeScope": "internal",
            "id": "confidence-band",
            "introducedIn": "1.0.0",
            "label": "Confidence band",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Lifecycle of the current uncommitted proposal; authorised means permission to attempt the action, while execution and committed outcome remain separate.",
            "enumValues": [
              "none",
              "draft",
              "proposed",
              "stale",
              "authorised",
              "rejected",
              "withdrawn",
              "superseded"
            ],
            "exchangeScope": "internal",
            "id": "proposal-status",
            "introducedIn": "1.0.0",
            "label": "Proposal status",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Timestamp when the assessment completed.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "assessed-at",
            "introducedIn": "1.0.0",
            "label": "Assessed at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Primary assessment producer identifier.",
            "exchangeScope": "internal",
            "id": "source-system",
            "introducedIn": "1.0.0",
            "label": "Source system",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Exact comparison adapter schema bundle.",
            "exchangeScope": "internal",
            "id": "source-schema-version",
            "introducedIn": "1.0.0",
            "label": "Source schema version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Latest observation time of the bound comparison sources.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "observed-at",
            "introducedIn": "1.0.0",
            "label": "Observed at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "References to every source and validation artifact supporting the result.",
            "exchangeScope": "internal",
            "id": "evidence-ids",
            "introducedIn": "1.0.0",
            "label": "Evidence references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Exact match and tolerance policy version.",
            "exchangeScope": "internal",
            "id": "policy-version-id",
            "introducedIn": "1.0.0",
            "label": "Policy version",
            "nullable": false,
            "referenceEntityId": "policy-version",
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Version of invoice-intake-match producing the assessment.",
            "exchangeScope": "internal",
            "id": "workblock-version",
            "introducedIn": "1.0.0",
            "label": "Workblock version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Governed purchase order id included in the invoice matching evidence set.",
            "exchangeScope": "unmapped",
            "id": "purchase-order-id",
            "introducedIn": "4.0.0",
            "label": "Purchase order ID",
            "nullable": true,
            "referenceEntityId": "purchase-order",
            "required": false,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Governed order line ids included in the invoice matching evidence set.",
            "exchangeScope": "unmapped",
            "id": "order-line-ids",
            "introducedIn": "4.0.0",
            "label": "Order line IDs",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "order-line",
            "required": false,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Governed receipt ids included in the invoice matching evidence set.",
            "exchangeScope": "unmapped",
            "id": "receipt-ids",
            "introducedIn": "4.0.0",
            "label": "Receipt IDs",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "receipt",
            "required": false,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Governed receipt line ids included in the invoice matching evidence set.",
            "exchangeScope": "unmapped",
            "id": "receipt-line-ids",
            "introducedIn": "4.0.0",
            "label": "Receipt line IDs",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "receipt-line",
            "required": false,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Governed service entry sheet ids included in the invoice matching evidence set.",
            "exchangeScope": "unmapped",
            "id": "service-entry-sheet-ids",
            "introducedIn": "4.0.0",
            "label": "Service entry sheet IDs",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "service-entry-sheet",
            "required": false,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Shared governed decision record that carries authority, rationale and evidence for this domain decision.",
            "exchangeScope": "unmapped",
            "id": "governance-decision-id",
            "introducedIn": "4.0.0",
            "label": "Governance decision ID",
            "nullable": true,
            "referenceEntityId": "decision",
            "required": false,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Authority envelope governing proposals, approvals and commitments for this record.",
            "exchangeScope": "unmapped",
            "id": "governance-authority-envelope-id",
            "introducedIn": "4.0.0",
            "label": "Governance authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "invoice-intake-match",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "invoice-match-assessment",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "business-key"
            ],
            "id": "invoice-match-assessment-by-business-key",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "invoice-id",
              "assessed-at"
            ],
            "id": "invoice-match-assessment-by-invoice-id-and-assessed-at",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "result"
            ],
            "id": "invoice-match-assessment-by-result",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "exception-reason-codes"
            ],
            "id": "invoice-match-assessment-by-exception-reason-codes",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "assessment",
        "label": "Invoice match assessment",
        "lifecycle": [
          "evaluating",
          "proposed",
          "matched",
          "exception",
          "insufficient-evidence",
          "expired",
          "superseded"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "invoice-intake-match",
        "owningDomainWorkblockId": "invoice-exception-payment-readiness",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Invoice match assessments",
        "primaryKey": "invoice-match-assessment-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Binds the assessment to the canonical invoice.",
            "id": "invoice-match-assessment-belongs-to-invoice-assessment-of-invoice",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "invoice-match-assessment-belongs-to-invoice-assessment-of-invoice",
            "required": true,
            "sourceFieldId": "invoice-id",
            "targetEntityId": "invoice",
            "targetFieldId": "invoice-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the invoice match assessment to the referenced evidence items.",
            "id": "invoice-match-assessment-evidenced-by-evidence-item-invoice-match-assessment-evidence-ids",
            "introducedIn": "2.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "invoice-match-assessment-evidenced-by-evidence-item-invoice-match-assessment-evidence-ids",
            "required": true,
            "sourceFieldId": "evidence-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the invoice match assessment to the referenced policy version.",
            "id": "invoice-match-assessment-governed-by-policy-version-id-id-invoice-match-assessment-policy-version-id-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "invoice-match-assessment-governed-by-policy-version-id-id-invoice-match-assessment-policy-version-id-id",
            "required": true,
            "sourceFieldId": "policy-version-id",
            "targetEntityId": "policy-version",
            "targetFieldId": "policy-version-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Record used by the invoice match assessment for purchase order evidence.",
            "id": "invoice-match-assessment-references-purchase-order-match-purchase-order",
            "introducedIn": "4.0.0",
            "predicate": "references",
            "qualifiedId": "invoice-match-assessment-references-purchase-order-match-purchase-order",
            "required": false,
            "sourceFieldId": "purchase-order-id",
            "targetEntityId": "purchase-order",
            "targetFieldId": "purchase-order-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Record used by the invoice match assessment for order line evidence.",
            "id": "invoice-match-assessment-references-order-line-match-order-line",
            "introducedIn": "4.0.0",
            "predicate": "references",
            "qualifiedId": "invoice-match-assessment-references-order-line-match-order-line",
            "required": false,
            "sourceFieldId": "order-line-ids",
            "targetEntityId": "order-line",
            "targetFieldId": "order-line-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Record used by the invoice match assessment for receipt evidence.",
            "id": "invoice-match-assessment-references-receipt-match-receipt",
            "introducedIn": "4.0.0",
            "predicate": "references",
            "qualifiedId": "invoice-match-assessment-references-receipt-match-receipt",
            "required": false,
            "sourceFieldId": "receipt-ids",
            "targetEntityId": "receipt",
            "targetFieldId": "receipt-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Record used by the invoice match assessment for receipt line evidence.",
            "id": "invoice-match-assessment-references-receipt-line-match-receipt-line",
            "introducedIn": "4.0.0",
            "predicate": "references",
            "qualifiedId": "invoice-match-assessment-references-receipt-line-match-receipt-line",
            "required": false,
            "sourceFieldId": "receipt-line-ids",
            "targetEntityId": "receipt-line",
            "targetFieldId": "receipt-line-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Record used by the invoice match assessment for service entry sheet evidence.",
            "id": "invoice-match-assessment-references-service-entry-sheet-match-service-entry-sheet",
            "introducedIn": "4.0.0",
            "predicate": "references",
            "qualifiedId": "invoice-match-assessment-references-service-entry-sheet-match-service-entry-sheet",
            "required": false,
            "sourceFieldId": "service-entry-sheet-ids",
            "targetEntityId": "service-entry-sheet",
            "targetFieldId": "service-entry-sheet-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Shared governed decision for this domain outcome.",
            "id": "invoice-match-assessment-governed-by-decision-invoice-match-assessment-governance-decision",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "invoice-match-assessment-governed-by-decision-invoice-match-assessment-governance-decision",
            "required": false,
            "sourceFieldId": "governance-decision-id",
            "targetEntityId": "decision",
            "targetFieldId": "decision-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Authority envelope governing this record.",
            "id": "invoice-match-assessment-governed-by-authority-envelope-invoice-match-assessment-governance-authority",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "invoice-match-assessment-governed-by-authority-envelope-invoice-match-assessment-governance-authority",
            "required": false,
            "sourceFieldId": "governance-authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "invoice match",
          "two-way match",
          "three-way match",
          "tolerance",
          "match exception"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Did this invoice match its order and receipt within tolerance, and why exactly?",
              "Which tolerance policy and comparison set produced this result?"
            ],
            "retrievalTerms": [
              "two-way match",
              "three-way match",
              "tolerance",
              "match explanation"
            ],
            "usage": "Produce a new immutable assessment for every match run against a pinned comparison set, tolerance policy and evidence version; never overwrite a prior assessment."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "three-way match result",
              "match verdict"
            ],
            "concept": "match-result",
            "doNotConfuseWith": [
              {
                "distinction": "The assessment is the immutable explainable match result; the exception is the owned case opened when a material condition blocks straight-through processing.",
                "targetEntityId": "invoice-exception"
              }
            ]
          }
        },
        "sourceSystemRoleIds": [
          "system-of-record",
          "execution-system",
          "transport-execution-boundary"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record",
          "planning-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "invoice-intake-match",
          "payment-readiness",
          "supplier-invoice-resolution"
        ],
        "definition": "A durable, owned case for a material invoice condition that cannot continue straight through, including its evidence, machine proposal, authority and committed disposition.",
        "domainWorkblockIds": [
          "invoice-exception-payment-readiness"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for the durable exception case.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "invoice-exception-id",
            "introducedIn": "1.0.0",
            "label": "Invoice exception ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-exception-triage",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Invoice affected by the exception.",
            "exchangeScope": "mapped",
            "id": "invoice-id",
            "introducedIn": "1.0.0",
            "label": "Invoice ID",
            "nullable": false,
            "referenceEntityId": "invoice",
            "required": true,
            "sourceAuthority": {
              "id": "invoice-exception-triage",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "application-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:DocumentResponse/cac:DocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Assessment that opened or most recently substantiated the exception.",
            "exchangeScope": "internal",
            "id": "match-assessment-id",
            "introducedIn": "1.0.0",
            "label": "Match assessment ID",
            "nullable": false,
            "referenceEntityId": "invoice-match-assessment",
            "required": true,
            "sourceAuthority": {
              "id": "invoice-exception-triage",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Governed reason category used for routing and control.",
            "enumValues": [
              "duplicate",
              "price",
              "quantity",
              "receipt",
              "service-entry",
              "tax",
              "supplier-data",
              "payment-data",
              "order-reference",
              "contract-reference",
              "approval",
              "other"
            ],
            "exchangeScope": "mapped",
            "id": "exception-type",
            "introducedIn": "1.0.0",
            "label": "Exception type",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-exception-triage",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "application-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:DocumentResponse/cac:Response/cac:Status/cbc:StatusReasonCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Policy-defined consequence band based on value, due risk, control and business impact.",
            "enumValues": [
              "routine",
              "moderate",
              "material",
              "critical"
            ],
            "exchangeScope": "internal",
            "id": "materiality-band",
            "introducedIn": "1.0.0",
            "label": "Materiality band",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-exception-triage",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "personal",
            "definition": "Role or person accountable for the next action.",
            "exchangeScope": "internal",
            "id": "owner-reference",
            "introducedIn": "1.0.0",
            "label": "Owner reference",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-exception-triage",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Current resolution due timestamp derived from payment and case policy.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "due-at",
            "introducedIn": "1.0.0",
            "label": "Due at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "invoice-exception-triage",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Machine or human proposed action and rationale, explicitly uncommitted.",
            "exchangeScope": "internal",
            "id": "proposed-resolution",
            "introducedIn": "1.0.0",
            "label": "Proposed resolution",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "invoice-exception-triage",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Resolution type records the governed state or type within Invoice exception Proposed resolution without treating absence, unknown and zero as equivalent.",
                    "id": "resolution-type",
                    "label": "Resolution type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-resolution",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Action code records the governed code within Invoice exception Proposed resolution without treating absence, unknown and zero as equivalent.",
                    "id": "action-code",
                    "label": "Action code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-resolution",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Rationale is the string component carried within Invoice exception Proposed resolution; its classification and authority inherit from the owning field contract.",
                    "id": "rationale",
                    "label": "Rationale",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-resolution",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence references is the set carried within Invoice exception Proposed resolution; its owning field governs allowed values and interpretation.",
                    "format": "evidence-item references",
                    "id": "evidence-references",
                    "label": "Evidence references",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-resolution",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Proposed by is the string component carried within Invoice exception Proposed resolution; its classification and authority inherit from the owning field contract.",
                    "id": "proposed-by",
                    "label": "Proposed by",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-resolution",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Proposed at is the timestamp component carried within Invoice exception Proposed resolution; its classification and authority inherit from the owning field contract.",
                    "id": "proposed-at",
                    "label": "Proposed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-resolution",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Expected effect is the string component carried within Invoice exception Proposed resolution; its classification and authority inherit from the owning field contract.",
                    "id": "expected-effect",
                    "label": "Expected effect",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-resolution",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Expires at is the timestamp component carried within Invoice exception Proposed resolution; its classification and authority inherit from the owning field contract.",
                    "id": "expires-at",
                    "label": "Expires at",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-resolution",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Lifecycle of the current uncommitted proposal; authorised means permission to attempt the action, while execution and committed outcome remain separate.",
            "enumValues": [
              "none",
              "draft",
              "proposed",
              "stale",
              "authorised",
              "rejected",
              "withdrawn",
              "superseded"
            ],
            "exchangeScope": "internal",
            "id": "proposal-status",
            "introducedIn": "1.0.0",
            "label": "Proposal status",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-exception-triage",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Authorised outcome and applied action, distinct from the proposal.",
            "exchangeScope": "mapped",
            "id": "committed-disposition",
            "introducedIn": "1.0.0",
            "label": "Committed disposition",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "invoice-exception-triage",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "application-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:DocumentResponse/cac:Response",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Disposition code records the governed code within Invoice exception Committed disposition without treating absence, unknown and zero as equivalent.",
                    "id": "disposition-code",
                    "label": "Disposition code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-disposition",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Applied action code records the governed code within Invoice exception Committed disposition without treating absence, unknown and zero as equivalent.",
                    "id": "applied-action-code",
                    "label": "Applied action code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-disposition",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Committed by is the string component carried within Invoice exception Committed disposition; its classification and authority inherit from the owning field contract.",
                    "id": "committed-by",
                    "label": "Committed by",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-disposition",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Committed at is the timestamp component carried within Invoice exception Committed disposition; its classification and authority inherit from the owning field contract.",
                    "id": "committed-at",
                    "label": "Committed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-disposition",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Downstream result code records the governed code within Invoice exception Committed disposition without treating absence, unknown and zero as equivalent.",
                    "id": "downstream-result-code",
                    "label": "Downstream result code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "committed-disposition",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Result reference is the string component carried within Invoice exception Committed disposition; its classification and authority inherit from the owning field contract.",
                    "id": "result-reference",
                    "label": "Result reference",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "committed-disposition",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence references is the set carried within Invoice exception Committed disposition; its owning field governs allowed values and interpretation.",
                    "format": "evidence-item references",
                    "id": "evidence-references",
                    "label": "Evidence references",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "committed-disposition",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Correction of reference is the string component carried within Invoice exception Committed disposition; its classification and authority inherit from the owning field contract.",
                    "id": "correction-of-reference",
                    "label": "Correction of reference",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "committed-disposition",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Authority envelope permitting the committed disposition.",
            "exchangeScope": "internal",
            "id": "authority-envelope-id",
            "introducedIn": "1.0.0",
            "label": "Authority envelope reference",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "invoice-exception-triage",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Timestamp when the exception case was created.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "opened-at",
            "introducedIn": "1.0.0",
            "label": "Opened at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-exception-triage",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Timestamp of the latest committed case mutation.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "updated-at",
            "introducedIn": "1.0.0",
            "label": "Updated at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-exception-triage",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Primary source or producer for the case.",
            "exchangeScope": "internal",
            "id": "source-system",
            "introducedIn": "1.0.0",
            "label": "Source system",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-exception-triage",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Exact input event and adapter schema bundle.",
            "exchangeScope": "internal",
            "id": "source-schema-version",
            "introducedIn": "1.0.0",
            "label": "Source schema version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-exception-triage",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Latest observation time of bound source evidence.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "observed-at",
            "introducedIn": "1.0.0",
            "label": "Observed at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-exception-triage",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Immutable evidence supporting reason, proposal, decision and result.",
            "exchangeScope": "internal",
            "id": "evidence-ids",
            "introducedIn": "1.0.0",
            "label": "Evidence references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "invoice-exception-triage",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Exact exception and routing policy version.",
            "exchangeScope": "internal",
            "id": "policy-version-id",
            "introducedIn": "1.0.0",
            "label": "Policy version",
            "nullable": false,
            "referenceEntityId": "policy-version",
            "required": true,
            "sourceAuthority": {
              "id": "invoice-exception-triage",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Version of invoice-exception-triage managing the case.",
            "exchangeScope": "internal",
            "id": "workblock-version",
            "introducedIn": "1.0.0",
            "label": "Workblock version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "invoice-exception-triage",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Shared exception case that records ownership, resolution and evidence for this domain exception.",
            "exchangeScope": "unmapped",
            "id": "governance-exception-id",
            "introducedIn": "4.0.0",
            "label": "Governance exception case ID",
            "nullable": true,
            "referenceEntityId": "exception",
            "required": false,
            "sourceAuthority": {
              "id": "invoice-exception-triage",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "invoice-exception",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "business-key"
            ],
            "id": "invoice-exception-by-business-key",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "invoice-id",
              "lifecycle-state"
            ],
            "id": "invoice-exception-by-invoice-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "owner-reference",
              "lifecycle-state"
            ],
            "id": "invoice-exception-by-owner-reference-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "exception-type",
              "materiality-band"
            ],
            "id": "invoice-exception-by-exception-type-and-materiality-band",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "due-at"
            ],
            "id": "invoice-exception-by-due-at",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "case",
        "label": "Invoice exception",
        "lifecycle": [
          "open",
          "gathering-evidence",
          "proposed",
          "in-resolution",
          "escalated",
          "resolved",
          "closed",
          "reopened",
          "superseded"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "invoice-exception-triage",
        "owningDomainWorkblockId": "invoice-exception-payment-readiness",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Invoice exceptions",
        "primaryKey": "invoice-exception-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the case to the affected invoice.",
            "id": "invoice-exception-belongs-to-invoice-exception-on-invoice",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "invoice-exception-belongs-to-invoice-exception-on-invoice",
            "required": true,
            "sourceFieldId": "invoice-id",
            "targetEntityId": "invoice",
            "targetFieldId": "invoice-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the case to the assessment that established the discrepancy.",
            "id": "invoice-exception-references-invoice-match-assessment-exception-from-assessment",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "invoice-exception-references-invoice-match-assessment-exception-from-assessment",
            "required": true,
            "sourceFieldId": "match-assessment-id",
            "targetEntityId": "invoice-match-assessment",
            "targetFieldId": "invoice-match-assessment-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the invoice exception to the referenced authority envelope.",
            "id": "invoice-exception-governed-by-authority-envelope-invoice-exception-authority-envelope-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "invoice-exception-governed-by-authority-envelope-invoice-exception-authority-envelope-id",
            "required": false,
            "sourceFieldId": "authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the invoice exception to the referenced evidence items.",
            "id": "invoice-exception-evidenced-by-evidence-item-invoice-exception-evidence-ids",
            "introducedIn": "2.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "invoice-exception-evidenced-by-evidence-item-invoice-exception-evidence-ids",
            "required": true,
            "sourceFieldId": "evidence-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the invoice exception to the referenced policy version.",
            "id": "invoice-exception-governed-by-policy-version-id-invoice-exception-policy-version-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "invoice-exception-governed-by-policy-version-id-invoice-exception-policy-version-id",
            "required": true,
            "sourceFieldId": "policy-version-id",
            "targetEntityId": "policy-version",
            "targetFieldId": "policy-version-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Shared governed exception case for this domain exception.",
            "id": "invoice-exception-governed-by-exception-invoice-exception-governance-exception",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "invoice-exception-governed-by-exception-invoice-exception-governance-exception",
            "required": false,
            "sourceFieldId": "governance-exception-id",
            "targetEntityId": "exception",
            "targetFieldId": "exception-id"
          }
        ],
        "retentionClass": "financial",
        "searchTerms": [
          "invoice exception",
          "match exception",
          "invoice hold",
          "invoice dispute",
          "accounts payable case"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Why is this invoice blocked and who owns the exception?",
              "What disposition was committed and under which authority?"
            ],
            "retrievalTerms": [
              "price variance",
              "quantity mismatch",
              "missing receipt",
              "duplicate invoice"
            ],
            "usage": "Open a durable invoice-exception for any material condition that blocks straight-through processing; keep the machine proposal, authority and committed disposition visibly distinct."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "invoice hold",
              "blocked invoice",
              "AP exception"
            ],
            "concept": "invoice-processing-case",
            "doNotConfuseWith": [
              {
                "distinction": "The exception is the internal case; the resolution is the supplier-facing case that carries approved communication and received evidence.",
                "targetEntityId": "supplier-invoice-resolution"
              }
            ]
          }
        },
        "sourceSystemRoleIds": [
          "system-of-record",
          "collaboration-channel",
          "evidence-source"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record",
          "collaboration-channel"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "invoice-exception-triage"
        ],
        "definition": "A durable supplier-facing resolution case that binds a validated invoice exception to approved communication, received evidence, proposed action, committed outcome and downstream reconciliation.",
        "domainWorkblockIds": [
          "invoice-exception-payment-readiness"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for the durable supplier resolution case.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "supplier-invoice-resolution-id",
            "introducedIn": "1.0.0",
            "label": "Invoice resolution ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-invoice-resolution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Exception requiring supplier evidence or correction.",
            "exchangeScope": "internal",
            "id": "invoice-exception-id",
            "introducedIn": "1.0.0",
            "label": "Invoice exception ID",
            "nullable": false,
            "referenceEntityId": "invoice-exception",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-invoice-resolution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Invoice at issue.",
            "exchangeScope": "mapped",
            "id": "invoice-id",
            "introducedIn": "1.0.0",
            "label": "Invoice ID",
            "nullable": false,
            "referenceEntityId": "invoice",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-invoice-resolution",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "application-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:DocumentResponse/cac:DocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Canonical supplier party participating in the resolution.",
            "exchangeScope": "mapped",
            "id": "supplier-party-id",
            "introducedIn": "1.0.0",
            "label": "Supplier party reference",
            "nullable": false,
            "referenceEntityId": "party",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-invoice-resolution",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "application-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:SenderParty/cac:PartyIdentification/cbc:ID|cac:ReceiverParty/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Governed supplier request or response intent.",
            "enumValues": [
              "status",
              "corrected-invoice",
              "credit-note",
              "missing-reference",
              "tax-evidence",
              "duplicate-confirmation",
              "dispute",
              "other"
            ],
            "exchangeScope": "mapped",
            "id": "resolution-type",
            "introducedIn": "1.0.0",
            "label": "Resolution type",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-invoice-resolution",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "application-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:DocumentResponse/cac:Response/cbc:ResponseCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Approved structured exchange or messaging channel.",
            "enumValues": [
              "structured-exchange",
              "supplier-portal",
              "secure-message",
              "approved-email-adapter"
            ],
            "exchangeScope": "internal",
            "id": "channel",
            "introducedIn": "1.0.0",
            "label": "Channel",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-invoice-resolution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Draft message or resolution action, explicitly uncommitted and unsent until authorised by policy.",
            "exchangeScope": "internal",
            "id": "proposed-action",
            "introducedIn": "1.0.0",
            "label": "Proposed action",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-invoice-resolution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Action type records the governed state or type within Supplier invoice resolution Proposed action without treating absence, unknown and zero as equivalent.",
                    "id": "action-type",
                    "label": "Action type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-action",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Approved structured exchange or messaging channel proposed for the supplier action.",
                    "enumValues": [
                      "structured-exchange",
                      "supplier-portal",
                      "secure-message",
                      "approved-email-adapter"
                    ],
                    "id": "channel",
                    "label": "Channel",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-action",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Message subject is the string component carried within Supplier invoice resolution Proposed action; its classification and authority inherit from the owning field contract.",
                    "id": "message-subject",
                    "label": "Message subject",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-action",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Message body reference links this structured value to the governed evidence-item record within Supplier invoice resolution Proposed action.",
                    "id": "message-body-id",
                    "label": "Message body reference",
                    "nullable": true,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the message body reference in proposed action to the referenced evidence item via its canonical evidence item ID.",
                      "id": "supplier-invoice-resolution-proposed-action-message-body-reference",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-action",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Rationale is the string component carried within Supplier invoice resolution Proposed action; its classification and authority inherit from the owning field contract.",
                    "id": "rationale",
                    "label": "Rationale",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-action",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Proposed by is the string component carried within Supplier invoice resolution Proposed action; its classification and authority inherit from the owning field contract.",
                    "id": "proposed-by",
                    "label": "Proposed by",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-action",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Proposed at is the timestamp component carried within Supplier invoice resolution Proposed action; its classification and authority inherit from the owning field contract.",
                    "id": "proposed-at",
                    "label": "Proposed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-action",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Expires at is the timestamp component carried within Supplier invoice resolution Proposed action; its classification and authority inherit from the owning field contract.",
                    "id": "expires-at",
                    "label": "Expires at",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-action",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Lifecycle of the current uncommitted proposal; authorised means permission to attempt the action, while execution and committed outcome remain separate.",
            "enumValues": [
              "none",
              "draft",
              "proposed",
              "stale",
              "authorised",
              "rejected",
              "withdrawn",
              "superseded"
            ],
            "exchangeScope": "internal",
            "id": "proposal-status",
            "introducedIn": "1.0.0",
            "label": "Proposal status",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-invoice-resolution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Authorised sent communication or applied resolution, content-bound and distinct from draft.",
            "exchangeScope": "mapped",
            "id": "committed-action",
            "introducedIn": "1.0.0",
            "label": "Committed action",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-invoice-resolution",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "application-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:DocumentResponse/cac:Response",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Action type records the governed state or type within Supplier invoice resolution Committed action without treating absence, unknown and zero as equivalent.",
                    "id": "action-type",
                    "label": "Action type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-action",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Approved structured exchange or messaging channel used for the committed supplier action.",
                    "enumValues": [
                      "structured-exchange",
                      "supplier-portal",
                      "secure-message",
                      "approved-email-adapter"
                    ],
                    "id": "channel",
                    "label": "Channel",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-action",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Content hash is the string component carried within Supplier invoice resolution Committed action; its classification and authority inherit from the owning field contract.",
                    "id": "content-hash",
                    "label": "Content hash",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-action",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Sent or applied at is the timestamp component carried within Supplier invoice resolution Committed action; its classification and authority inherit from the owning field contract.",
                    "id": "sent-or-applied-at",
                    "label": "Sent or applied at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-action",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Committed by is the string component carried within Supplier invoice resolution Committed action; its classification and authority inherit from the owning field contract.",
                    "id": "committed-by",
                    "label": "Committed by",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-action",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Delivery status records the governed state or type within Supplier invoice resolution Committed action without treating absence, unknown and zero as equivalent.",
                    "id": "delivery-status",
                    "label": "Delivery status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-action",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Application response code records the governed code within Supplier invoice resolution Committed action without treating absence, unknown and zero as equivalent.",
                    "id": "application-response-code",
                    "label": "Application response code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "committed-action",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Result reference links this structured value to the governed evidence-item record within Supplier invoice resolution Committed action.",
                    "id": "result-id",
                    "label": "Result reference",
                    "nullable": true,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the result reference in committed action to the referenced evidence item via its canonical evidence item ID.",
                      "id": "supplier-invoice-resolution-committed-action-result-reference",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "committed-action",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Authority permitting communication or resolution action.",
            "exchangeScope": "internal",
            "id": "authority-envelope-id",
            "introducedIn": "1.0.0",
            "label": "Authority envelope reference",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-invoice-resolution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Reference to a UBL ApplicationResponse or adopted invoice-response message.",
            "exchangeScope": "mapped",
            "id": "application-response-id",
            "introducedIn": "1.0.0",
            "label": "Application response reference",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-invoice-resolution",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "application-response",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Reference to a received UBL CreditNote resolving all or part of the invoice.",
            "exchangeScope": "mapped",
            "id": "credit-note-id",
            "introducedIn": "1.0.0",
            "label": "Credit note reference",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-invoice-resolution",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "inbound",
                "documentId": "credit-note",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Reference to the superseding or corrected invoice source document.",
            "exchangeScope": "mapped",
            "id": "corrected-invoice-id",
            "introducedIn": "1.0.0",
            "label": "Corrected invoice reference",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-invoice-resolution",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:BillingReference/cac:InvoiceDocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Timestamp when supplier resolution began.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "opened-at",
            "introducedIn": "1.0.0",
            "label": "Opened at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-invoice-resolution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Next reminder, follow-up or escalation timestamp.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "next-action-at",
            "introducedIn": "1.0.0",
            "label": "Next action at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-invoice-resolution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Timestamp of the latest committed outbound communication.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "communicated-at",
            "introducedIn": "1.0.0",
            "label": "Communicated at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-invoice-resolution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Timestamp when resolution and downstream invoice state reconciled.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "confirmed-at",
            "introducedIn": "1.0.0",
            "label": "Confirmed at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-invoice-resolution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Primary resolution event source.",
            "exchangeScope": "internal",
            "id": "source-system",
            "introducedIn": "1.0.0",
            "label": "Source system",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-invoice-resolution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Exact message and adapter schema bundle.",
            "exchangeScope": "internal",
            "id": "source-schema-version",
            "introducedIn": "1.0.0",
            "label": "Source schema version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-invoice-resolution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Latest observation timestamp for message or resolution evidence.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "observed-at",
            "introducedIn": "1.0.0",
            "label": "Observed at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-invoice-resolution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Messages, artifacts, receipts, responses, decisions and downstream evidence.",
            "exchangeScope": "internal",
            "id": "evidence-ids",
            "introducedIn": "1.0.0",
            "label": "Evidence references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-invoice-resolution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Communication and resolution policy version.",
            "exchangeScope": "internal",
            "id": "policy-version-id",
            "introducedIn": "1.0.0",
            "label": "Policy version",
            "nullable": false,
            "referenceEntityId": "policy-version",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-invoice-resolution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Version of supplier-invoice-resolution managing the case.",
            "exchangeScope": "internal",
            "id": "workblock-version",
            "introducedIn": "1.0.0",
            "label": "Workblock version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-invoice-resolution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "supplier-invoice-resolution",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "business-key"
            ],
            "id": "supplier-invoice-resolution-by-business-key",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "invoice-exception-id"
            ],
            "id": "supplier-invoice-resolution-by-invoice-exception-id",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "supplier-party-id",
              "lifecycle-state"
            ],
            "id": "supplier-invoice-resolution-by-supplier-party-reference-and-resolution-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "next-action-at"
            ],
            "id": "supplier-invoice-resolution-by-next-action-at",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "case",
        "label": "Supplier invoice resolution",
        "lifecycle": [
          "opened",
          "drafted",
          "sent",
          "awaiting-response",
          "response-received",
          "proposed",
          "confirmed",
          "disputed",
          "escalated",
          "closed"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "supplier-invoice-resolution",
        "owningDomainWorkblockId": "invoice-exception-payment-readiness",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Supplier invoice resolutions",
        "primaryKey": "supplier-invoice-resolution-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the supplier case to its invoice exception.",
            "id": "supplier-invoice-resolution-references-invoice-exception-resolution-of-exception",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "supplier-invoice-resolution-references-invoice-exception-resolution-of-exception",
            "required": true,
            "sourceFieldId": "invoice-exception-id",
            "targetEntityId": "invoice-exception",
            "targetFieldId": "invoice-exception-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the supplier case to the invoice at issue.",
            "id": "supplier-invoice-resolution-belongs-to-invoice-resolution-for-invoice",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-invoice-resolution-belongs-to-invoice-resolution-for-invoice",
            "required": true,
            "sourceFieldId": "invoice-id",
            "targetEntityId": "invoice",
            "targetFieldId": "invoice-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the supplier invoice resolution to the referenced party.",
            "id": "supplier-invoice-resolution-belongs-to-party-supplier-invoice-resolution-supplier-party-id",
            "introducedIn": "2.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-invoice-resolution-belongs-to-party-supplier-invoice-resolution-supplier-party-id",
            "required": true,
            "sourceFieldId": "supplier-party-id",
            "targetEntityId": "party",
            "targetFieldId": "party-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the supplier invoice resolution to the referenced authority envelope.",
            "id": "supplier-invoice-resolution-governed-by-authority-envelope-supplier-invoice-resolution-authority-envelope-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "supplier-invoice-resolution-governed-by-authority-envelope-supplier-invoice-resolution-authority-envelope-id",
            "required": false,
            "sourceFieldId": "authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the supplier invoice resolution to the referenced evidence item.",
            "id": "supplier-invoice-resolution-belongs-to-evidence-item-supplier-invoice-resolution-application-response-id",
            "introducedIn": "2.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-invoice-resolution-belongs-to-evidence-item-supplier-invoice-resolution-application-response-id",
            "required": false,
            "sourceFieldId": "application-response-id",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the supplier invoice resolution to the referenced evidence item.",
            "id": "supplier-invoice-resolution-belongs-to-evidence-item-supplier-invoice-resolution-credit-note-id",
            "introducedIn": "2.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-invoice-resolution-belongs-to-evidence-item-supplier-invoice-resolution-credit-note-id",
            "required": false,
            "sourceFieldId": "credit-note-id",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the supplier invoice resolution to the referenced evidence item.",
            "id": "supplier-invoice-resolution-belongs-to-evidence-item-supplier-invoice-resolution-corrected-invoice-id",
            "introducedIn": "2.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-invoice-resolution-belongs-to-evidence-item-supplier-invoice-resolution-corrected-invoice-id",
            "required": false,
            "sourceFieldId": "corrected-invoice-id",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the supplier invoice resolution to the referenced evidence items.",
            "id": "supplier-invoice-resolution-evidenced-by-evidence-item-supplier-invoice-resolution-evidence-ids",
            "introducedIn": "2.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "supplier-invoice-resolution-evidenced-by-evidence-item-supplier-invoice-resolution-evidence-ids",
            "required": true,
            "sourceFieldId": "evidence-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the supplier invoice resolution to the referenced policy version.",
            "id": "supplier-invoice-resolution-governed-by-policy-version-id-supplier-invoice-resolution-policy-version-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "supplier-invoice-resolution-governed-by-policy-version-id-supplier-invoice-resolution-policy-version-id",
            "required": true,
            "sourceFieldId": "policy-version-id",
            "targetEntityId": "policy-version",
            "targetFieldId": "policy-version-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "supplier invoice resolution",
          "invoice response",
          "credit note request",
          "supplier dispute",
          "invoice correction"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "What was communicated to the supplier and what evidence did they return?",
              "Which committed outcome closed the resolution and what follows downstream?"
            ],
            "retrievalTerms": [
              "supplier communication",
              "dispute",
              "clarification request"
            ],
            "usage": "Use the resolution case to bind a validated exception to approved supplier communication, received evidence, the proposed action, the committed outcome and downstream reconciliation."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "supplier dispute case",
              "invoice clarification"
            ],
            "concept": "supplier-facing-resolution-case"
          }
        },
        "sourceSystemRoleIds": [
          "system-of-record",
          "collaboration-channel",
          "execution-system",
          "evidence-source"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "collaboration-channel",
          "system-of-record",
          "execution-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "invoice-intake-match",
          "payment-execution-guard"
        ],
        "definition": "A version-bound pre-payment control assessment that separates a machine readiness proposal from the committed ready or held decision.",
        "domainWorkblockIds": [
          "invoice-exception-payment-readiness"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for this exact assessment version.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "payment-readiness-assessment-id",
            "introducedIn": "1.0.0",
            "label": "Payment readiness ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-readiness",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Invoice whose readiness is being assessed.",
            "exchangeScope": "mapped",
            "id": "invoice-id",
            "introducedIn": "1.0.0",
            "label": "Invoice ID",
            "nullable": false,
            "referenceEntityId": "invoice",
            "required": true,
            "sourceAuthority": {
              "id": "payment-readiness",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Committed exception and supplier-resolution outcomes required for readiness.",
            "exchangeScope": "internal",
            "id": "resolution-ids",
            "introducedIn": "1.0.0",
            "label": "Resolution references",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "supplier-invoice-resolution",
            "required": false,
            "sourceAuthority": {
              "id": "payment-readiness",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "restricted",
            "definition": "Typed result, reason, evidence, freshness and source for every mandatory readiness control.",
            "exchangeScope": "internal",
            "id": "check-results",
            "introducedIn": "1.0.0",
            "label": "Check results",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-readiness",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Check ID is the string component carried within Payment readiness assessment Check results; its classification and authority inherit from the owning field contract.",
                    "id": "check-id",
                    "label": "Check ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "check-results",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Check type records the governed state or type within Payment readiness assessment Check results without treating absence, unknown and zero as equivalent.",
                    "id": "check-type",
                    "label": "Check type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "check-results",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Result code records the governed code within Payment readiness assessment Check results without treating absence, unknown and zero as equivalent.",
                    "id": "result-code",
                    "label": "Result code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "check-results",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Reason code records the governed code within Payment readiness assessment Check results without treating absence, unknown and zero as equivalent.",
                    "id": "reason-code",
                    "label": "Reason code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "check-results",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Source record reference links this structured value to the governed source-record-reference record within Payment readiness assessment Check results.",
                    "id": "source-record-id",
                    "label": "Source record reference",
                    "nullable": true,
                    "referenceEntityId": "source-record-reference",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the source record reference in check results to the referenced source record reference via its canonical source record reference ID.",
                      "id": "payment-readiness-assessment-check-results-source-record-reference",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "source-record-reference-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "check-results",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence reference links this structured value to the governed evidence-item record within Payment readiness assessment Check results.",
                    "id": "evidence-id",
                    "label": "Evidence reference",
                    "nullable": true,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the evidence reference in check results to the referenced evidence item via its canonical evidence item ID.",
                      "id": "payment-readiness-assessment-check-results-evidence-reference",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "check-results",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Observed at is the timestamp component carried within Payment readiness assessment Check results; its classification and authority inherit from the owning field contract.",
                    "id": "observed-at",
                    "label": "Observed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "check-results",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Freshness status records the governed state or type within Payment readiness assessment Check results without treating absence, unknown and zero as equivalent.",
                    "id": "freshness-status",
                    "label": "Freshness status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "check-results",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Policy version links this structured value to the governed policy-version record within Payment readiness assessment Check results.",
                    "id": "policy-version-id",
                    "label": "Policy version",
                    "nullable": false,
                    "referenceEntityId": "policy-version",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the policy version in check results to the referenced policy version via its canonical policy version ID.",
                      "id": "payment-readiness-assessment-check-results-policy-version",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "policy-version-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "check-results",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  }
                ],
                "uniqueBy": [
                  "check-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "compositeValueContract": {
              "componentFieldIds": [
                "payable-amount"
              ],
              "representation": "registry-object",
              "schemaId": "money-value",
              "schemaVersion": "2.0.0"
            },
            "definition": "Amount and currency admitted by current invoice and resolution evidence.",
            "exchangeScope": "mapped",
            "id": "payable-amount",
            "introducedIn": "1.0.0",
            "label": "Payable amount",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-readiness",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "components": [
                  {
                    "standardPath": "cac:LegalMonetaryTotal/cbc:PayableAmount",
                    "valuePath": "amount"
                  },
                  {
                    "standardPath": "cac:LegalMonetaryTotal/cbc:PayableAmount/@currencyID",
                    "valuePath": "currency-code"
                  }
                ],
                "coverage": "exact",
                "direction": "inbound",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:LegalMonetaryTotal/cbc:PayableAmount",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "money",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "money-value",
              "schemaVersion": "2.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Current due date at assessment time.",
            "exchangeScope": "mapped",
            "format": "date",
            "id": "due-date",
            "introducedIn": "1.0.0",
            "label": "Due date",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "payment-readiness",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "inbound",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:DueDate",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "date"
          },
          {
            "classification": "restricted",
            "definition": "Current duplicate, fraud, sanctions, account-integrity and control flags with their supporting records attached.",
            "exchangeScope": "internal",
            "id": "risk-flags",
            "introducedIn": "1.0.0",
            "label": "Risk flags",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-readiness",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Risk flag ID is the string component carried within Payment readiness assessment Risk flags; its classification and authority inherit from the owning field contract.",
                    "id": "risk-flag-id",
                    "label": "Risk flag ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "risk-flags",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Risk type records the governed state or type within Payment readiness assessment Risk flags without treating absence, unknown and zero as equivalent.",
                    "id": "risk-type",
                    "label": "Risk type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "risk-flags",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Severity is the string component carried within Payment readiness assessment Risk flags; its classification and authority inherit from the owning field contract.",
                    "id": "severity",
                    "label": "Severity",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "risk-flags",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Status records the governed state or type within Payment readiness assessment Risk flags without treating absence, unknown and zero as equivalent.",
                    "id": "status",
                    "label": "Status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "risk-flags",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Rationale is the string component carried within Payment readiness assessment Risk flags; its classification and authority inherit from the owning field contract.",
                    "id": "rationale",
                    "label": "Rationale",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "risk-flags",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence reference links this structured value to the governed evidence-item record within Payment readiness assessment Risk flags.",
                    "id": "evidence-id",
                    "label": "Evidence reference",
                    "nullable": true,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the evidence reference in risk flags to the referenced evidence item via its canonical evidence item ID.",
                      "id": "payment-readiness-assessment-risk-flags-evidence-reference",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "risk-flags",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Detected at is the timestamp component carried within Payment readiness assessment Risk flags; its classification and authority inherit from the owning field contract.",
                    "id": "detected-at",
                    "label": "Detected at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "risk-flags",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Expires at is the timestamp component carried within Payment readiness assessment Risk flags; its classification and authority inherit from the owning field contract.",
                    "id": "expires-at",
                    "label": "Expires at",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "risk-flags",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  }
                ],
                "uniqueBy": [
                  "risk-flag-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Machine-proposed ready or held outcome with reasons, explicitly uncommitted.",
            "enumValues": [
              "ready",
              "hold",
              "insufficient-evidence",
              "expired"
            ],
            "exchangeScope": "internal",
            "id": "proposed-readiness",
            "introducedIn": "1.0.0",
            "label": "Proposed readiness",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-readiness",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Authorised readiness state used by payment execution.",
            "enumValues": [
              "ready",
              "held",
              "expired"
            ],
            "exchangeScope": "internal",
            "id": "committed-readiness",
            "introducedIn": "1.0.0",
            "label": "Committed readiness",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "payment-readiness",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Deterministic or authorised reasons for a committed hold.",
            "exchangeScope": "internal",
            "id": "hold-reason-codes",
            "introducedIn": "1.0.0",
            "label": "Hold reason codes",
            "listSemantics": "set",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "payment-readiness",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string-list"
          },
          {
            "classification": "restricted",
            "definition": "Authority envelope permitting the readiness commitment.",
            "exchangeScope": "internal",
            "id": "authority-envelope-id",
            "introducedIn": "1.0.0",
            "label": "Authority envelope reference",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "payment-readiness",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Timestamp when the complete check set was assessed.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "assessed-at",
            "introducedIn": "1.0.0",
            "label": "Assessed at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-readiness",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Primary producer identifier for the assessment.",
            "exchangeScope": "internal",
            "id": "source-system",
            "introducedIn": "1.0.0",
            "label": "Source system",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-readiness",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Exact control-source schema bundle.",
            "exchangeScope": "internal",
            "id": "source-schema-version",
            "introducedIn": "1.0.0",
            "label": "Source schema version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-readiness",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Latest observation timestamp among bound sources.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "observed-at",
            "introducedIn": "1.0.0",
            "label": "Observed at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-readiness",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Source, control, exception, authority and decision evidence.",
            "exchangeScope": "internal",
            "id": "evidence-ids",
            "introducedIn": "1.0.0",
            "label": "Evidence references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "payment-readiness",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Exact readiness and hold policy version.",
            "exchangeScope": "internal",
            "id": "policy-version-id",
            "introducedIn": "1.0.0",
            "label": "Policy version",
            "nullable": false,
            "referenceEntityId": "policy-version",
            "required": true,
            "sourceAuthority": {
              "id": "payment-readiness",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Version of payment-readiness producing the assessment.",
            "exchangeScope": "internal",
            "id": "workblock-version",
            "introducedIn": "1.0.0",
            "label": "Workblock version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-readiness",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "payment-readiness-assessment",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "business-key"
            ],
            "id": "payment-readiness-assessment-by-business-key",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "invoice-id",
              "lifecycle-state"
            ],
            "id": "payment-readiness-assessment-by-invoice-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "due-date"
            ],
            "id": "payment-readiness-assessment-by-due-date",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "committed-readiness"
            ],
            "id": "payment-readiness-assessment-by-committed-readiness",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "freshness-status"
            ],
            "id": "payment-readiness-assessment-by-freshness-status",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "assessment",
        "label": "Payment readiness assessment",
        "lifecycle": [
          "evaluating",
          "proposed-ready",
          "proposed-hold",
          "ready",
          "held",
          "expired",
          "superseded"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "payment-readiness",
        "owningDomainWorkblockId": "invoice-exception-payment-readiness",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Payment readiness assessments",
        "primaryKey": "payment-readiness-assessment-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Binds readiness to the payable invoice.",
            "id": "payment-readiness-assessment-belongs-to-invoice-readiness-for-invoice",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "payment-readiness-assessment-belongs-to-invoice-readiness-for-invoice",
            "required": true,
            "sourceFieldId": "invoice-id",
            "targetEntityId": "invoice",
            "targetFieldId": "invoice-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the payment readiness assessment to the referenced supplier invoice resolutions.",
            "id": "payment-readiness-assessment-references-supplier-invoice-resolution-payment-readiness-assessment-resolution-ids",
            "introducedIn": "2.0.0",
            "predicate": "references",
            "qualifiedId": "payment-readiness-assessment-references-supplier-invoice-resolution-payment-readiness-assessment-resolution-ids",
            "required": false,
            "sourceFieldId": "resolution-ids",
            "targetEntityId": "supplier-invoice-resolution",
            "targetFieldId": "supplier-invoice-resolution-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the payment readiness assessment to the referenced authority envelope.",
            "id": "payment-readiness-assessment-governed-by-authority-envelope-payment-readiness-assessment-authority-envelope-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "payment-readiness-assessment-governed-by-authority-envelope-payment-readiness-assessment-authority-envelope-id",
            "required": false,
            "sourceFieldId": "authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the payment readiness assessment to the referenced evidence items.",
            "id": "payment-readiness-assessment-evidenced-by-evidence-item-payment-readiness-assessment-evidence-ids",
            "introducedIn": "2.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "payment-readiness-assessment-evidenced-by-evidence-item-payment-readiness-assessment-evidence-ids",
            "required": true,
            "sourceFieldId": "evidence-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the payment readiness assessment to the referenced policy version.",
            "id": "payment-readiness-assessment-governed-by-policy-version-id-id-payment-readiness-assessment-policy-version-id-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "payment-readiness-assessment-governed-by-policy-version-id-id-payment-readiness-assessment-policy-version-id-id",
            "required": true,
            "sourceFieldId": "policy-version-id",
            "targetEntityId": "policy-version",
            "targetFieldId": "policy-version-id"
          }
        ],
        "retentionClass": "financial",
        "searchTerms": [
          "payment readiness",
          "invoice ready to pay",
          "payment hold",
          "pre-payment control"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Is this invoice ready for payment, and which controls said so?",
              "Who committed the ready or held decision and on what evidence?"
            ],
            "retrievalTerms": [
              "payment block",
              "release for payment",
              "control check"
            ],
            "usage": "Run version-bound pre-payment controls and keep the machine readiness proposal separate from the committed ready-or-held decision."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "payment readiness check",
              "release check"
            ],
            "concept": "pre-payment-control-result",
            "doNotConfuseWith": [
              {
                "distinction": "The assessment decides ready-or-held; the instruction is the controlled payment content that follows a ready decision.",
                "targetEntityId": "payment-instruction"
              }
            ]
          }
        },
        "sourceSystemRoleIds": [
          "system-of-record",
          "execution-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record",
          "planning-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "realization-reconciliation-attribution"
        ],
        "definition": "A controlled payment instruction whose proposal, committed content, authority, submission message and latest reconciled status remain distinguishable.",
        "domainWorkblockIds": [
          "invoice-exception-payment-readiness",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable identifier for the controlled instruction.",
            "exchangeScope": "mapped",
            "format": "uuid",
            "id": "payment-instruction-id",
            "introducedIn": "1.0.0",
            "label": "Payment instruction ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "outbound",
                "documentId": "customer-credit-transfer-initiation-pain-001",
                "exchangeScope": "edge-interchange",
                "mappingKind": "message-path",
                "note": "The exact ISO 20022 message version is pinned by the active adapter.",
                "path": "CdtTrfTxInf/PmtId/InstrId",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-20022",
                "transformation": "none"
              }
            ],
            "type": "uuid"
          },
          {
            "classification": "restricted",
            "definition": "Committed, unexpired readiness assessments admitted to this instruction.",
            "exchangeScope": "unmapped",
            "id": "readiness-ids",
            "introducedIn": "1.0.0",
            "label": "Readiness references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "payment-readiness-assessment",
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "confidential",
            "definition": "Invoices settled or partly settled by this instruction.",
            "exchangeScope": "mapped",
            "id": "invoice-ids",
            "introducedIn": "1.0.0",
            "label": "Invoice references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "invoice",
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "customer-credit-transfer-initiation-pain-001",
                "exchangeScope": "edge-interchange",
                "mappingKind": "message-path",
                "path": "CdtTrfTxInf/RmtInf/Strd/RfrdDocInf/Nb",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-20022",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "remittance-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:RemittanceAdviceLine/cac:DocumentReference/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "restricted",
            "definition": "Restricted token resolving to the authorised paying account inside the payment adapter.",
            "exchangeScope": "mapped",
            "id": "debtor-account-token",
            "introducedIn": "1.0.0",
            "label": "Debtor account token",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "customer-credit-transfer-initiation-pain-001",
                "exchangeScope": "edge-interchange",
                "mappingKind": "message-path",
                "note": "The platform stores a token; the adapter resolves the regulated account identifier.",
                "path": "PmtInf/DbtrAcct/Id",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-20022",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Restricted token resolving to the approved supplier payment account.",
            "exchangeScope": "mapped",
            "id": "creditor-account-token",
            "introducedIn": "1.0.0",
            "label": "Creditor account token",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "customer-credit-transfer-initiation-pain-001",
                "exchangeScope": "edge-interchange",
                "mappingKind": "message-path",
                "note": "The platform stores a token; the adapter resolves the regulated account identifier.",
                "path": "CdtTrfTxInf/CdtrAcct/Id",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-20022",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "restricted",
            "compositeValueContract": {
              "componentFieldIds": [
                "instructed-amount"
              ],
              "representation": "registry-object",
              "schemaId": "money-value",
              "schemaVersion": "2.0.0"
            },
            "definition": "Payment amount and currency committed for transfer, with its definition version and explicit rounding rule.",
            "exchangeScope": "mapped",
            "id": "instructed-amount",
            "introducedIn": "1.0.0",
            "label": "Instructed amount",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "components": [
                  {
                    "standardPath": "alphabetic code",
                    "valuePath": "currency-code"
                  }
                ],
                "conceptId": "currency-code",
                "coverage": "exact",
                "direction": "outbound",
                "exchangeScope": "edge-interchange",
                "mappingKind": "code-list",
                "path": "alphabetic code",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-4217",
                "transformation": "none"
              },
              {
                "components": [
                  {
                    "standardPath": "CdtTrfTxInf/Amt/InstdAmt",
                    "valuePath": "amount"
                  },
                  {
                    "standardPath": "CdtTrfTxInf/Amt/InstdAmt/@Ccy",
                    "valuePath": "currency-code"
                  }
                ],
                "coverage": "exact",
                "direction": "outbound",
                "documentId": "customer-credit-transfer-initiation-pain-001",
                "exchangeScope": "edge-interchange",
                "mappingKind": "message-path",
                "path": "CdtTrfTxInf/Amt/InstdAmt",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-20022",
                "transformation": "none"
              }
            ],
            "type": "money",
            "valueSchema": {
              "mode": "registry",
              "schemaId": "money-value",
              "schemaVersion": "2.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Date on which the payment adapter is requested to execute the transfer.",
            "exchangeScope": "mapped",
            "format": "date",
            "id": "requested-execution-date",
            "introducedIn": "1.0.0",
            "label": "Requested execution date",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "outbound",
                "documentId": "customer-credit-transfer-initiation-pain-001",
                "exchangeScope": "edge-interchange",
                "mappingKind": "message-path",
                "path": "PmtInf/ReqdExctnDt",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-20022",
                "transformation": "none"
              }
            ],
            "type": "date"
          },
          {
            "classification": "internal",
            "definition": "Approved transfer method for the active adapter and authority envelope.",
            "exchangeScope": "mapped",
            "id": "payment-method-code",
            "introducedIn": "1.0.0",
            "label": "Payment method code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "outbound",
                "documentId": "customer-credit-transfer-initiation-pain-001",
                "exchangeScope": "edge-interchange",
                "mappingKind": "message-path",
                "path": "PmtInf/PmtMtd",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-20022",
                "transformation": "none"
              },
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:PaymentMeans/cbc:PaymentMeansCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Structured or unstructured references enabling supplier and invoice reconciliation.",
            "exchangeScope": "mapped",
            "id": "remittance-information",
            "introducedIn": "1.0.0",
            "label": "Remittance information",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "customer-credit-transfer-initiation-pain-001",
                "exchangeScope": "edge-interchange",
                "mappingKind": "message-path",
                "note": "Structured, unstructured and mixed remittance forms are normalised into one governed contract; the derived remittance mode is not a direct ISO 20022 leaf.",
                "path": "CdtTrfTxInf/RmtInf",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-20022",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "semantic",
                "direction": "outbound",
                "documentId": "remittance-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:RemittanceAdviceLine",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Remittance mode is the string component carried within Payment instruction Remittance information; its classification and authority inherit from the owning field contract.",
                    "enumValues": [
                      "structured",
                      "unstructured",
                      "mixed"
                    ],
                    "id": "remittance-mode",
                    "label": "Remittance mode",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "remittance-information",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Unstructured lines is the ordered list carried within Payment instruction Remittance information; its owning field governs allowed values and interpretation.",
                    "id": "unstructured-lines",
                    "label": "Unstructured lines",
                    "listSemantics": "ordered",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "remittance-information",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Creditor reference type code records the governed code within Payment instruction Remittance information without treating absence, unknown and zero as equivalent.",
                    "id": "creditor-reference-type-code",
                    "label": "Creditor reference type code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "remittance-information",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Creditor reference is the string component carried within Payment instruction Remittance information; its classification and authority inherit from the owning field contract.",
                    "id": "creditor-reference",
                    "label": "Creditor reference",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "remittance-information",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Additional remittance information is the ordered list carried within Payment instruction Remittance information; its owning field governs allowed values and interpretation.",
                    "id": "additional-remittance-information",
                    "label": "Additional remittance information",
                    "listSemantics": "ordered",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "remittance-information",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Invoice reference values is the set carried within Payment instruction Remittance information; its owning field governs allowed values and interpretation.",
                    "id": "invoice-reference-values",
                    "label": "Invoice reference values",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "remittance-information",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Lifecycle of the current uncommitted proposal; authorised means permission to attempt the action, while execution and committed outcome remain separate.",
            "enumValues": [
              "none",
              "draft",
              "proposed",
              "stale",
              "authorised",
              "rejected",
              "withdrawn",
              "superseded"
            ],
            "exchangeScope": "unmapped",
            "id": "proposal-status",
            "introducedIn": "1.0.0",
            "label": "Proposal status",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Latest reconciled instruction state; null before commitment.",
            "enumValues": [
              "committed",
              "submitted",
              "accepted",
              "rejected",
              "settled",
              "returned",
              "cancelled",
              "unknown"
            ],
            "exchangeScope": "mapped",
            "id": "committed-status",
            "introducedIn": "1.0.0",
            "label": "Committed status",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "pain-002",
                "exchangeScope": "edge-interchange",
                "mappingKind": "message-path",
                "path": "TxInfAndSts/TxSts",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-20022",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "pacs-002",
                "exchangeScope": "edge-interchange",
                "mappingKind": "message-path",
                "path": "TxInfAndSts/TxSts",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-20022",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Authority envelope permitting instruction commitment and submission.",
            "exchangeScope": "unmapped",
            "id": "authority-envelope-id",
            "introducedIn": "1.0.0",
            "label": "Authority envelope reference",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Immutable reference to the exact submitted ISO 20022 message.",
            "exchangeScope": "mapped",
            "id": "instruction-message-id",
            "introducedIn": "1.0.0",
            "label": "Instruction message reference",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "outbound",
                "documentId": "customer-credit-transfer-initiation-pain-001",
                "exchangeScope": "edge-interchange",
                "mappingKind": "message-path",
                "path": "GrpHdr/MsgId",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-20022",
                "transformation": "none"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Timestamp when the proposal was created.",
            "exchangeScope": "unmapped",
            "format": "date-time",
            "id": "created-at",
            "introducedIn": "1.0.0",
            "label": "Created at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Timestamp when exact instruction content crossed the commitment boundary.",
            "exchangeScope": "unmapped",
            "format": "date-time",
            "id": "committed-at",
            "introducedIn": "1.0.0",
            "label": "Committed at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Payment instruction producer identifier.",
            "exchangeScope": "unmapped",
            "id": "source-system",
            "introducedIn": "1.0.0",
            "label": "Source system",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Exact payment adapter and ISO 20022 message version bundle.",
            "exchangeScope": "unmapped",
            "id": "source-schema-version",
            "introducedIn": "1.0.0",
            "label": "Source schema version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Latest downstream observation timestamp.",
            "exchangeScope": "unmapped",
            "format": "date-time",
            "id": "observed-at",
            "introducedIn": "1.0.0",
            "label": "Observed at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Readiness, control, authority, message, status and statement evidence.",
            "exchangeScope": "unmapped",
            "id": "evidence-ids",
            "introducedIn": "1.0.0",
            "label": "Evidence references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Payment execution policy version.",
            "exchangeScope": "unmapped",
            "id": "policy-version-id",
            "introducedIn": "1.0.0",
            "label": "Policy version",
            "nullable": false,
            "referenceEntityId": "policy-version",
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Version of payment-execution-guard producing the instruction.",
            "exchangeScope": "unmapped",
            "id": "workblock-version",
            "introducedIn": "1.0.0",
            "label": "Workblock version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "payment-instruction",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "business-key"
            ],
            "id": "payment-instruction-by-business-key",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "readiness-ids"
            ],
            "id": "payment-instruction-by-readiness-references",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "invoice-ids"
            ],
            "id": "payment-instruction-by-invoice-references",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "committed-status"
            ],
            "id": "payment-instruction-by-committed-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "requested-execution-date"
            ],
            "id": "payment-instruction-by-requested-execution-date",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "transaction",
        "label": "Payment instruction",
        "lifecycle": [
          "proposed",
          "validated",
          "committed",
          "submitted",
          "accepted",
          "rejected",
          "settled",
          "returned",
          "cancelled",
          "unknown"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "payment-execution-guard",
        "owningDomainWorkblockId": "invoice-exception-payment-readiness",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Payment instructions",
        "primaryKey": "payment-instruction-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-many",
            "definition": "Links every instruction to the committed readiness assessments it consumes.",
            "id": "payment-instruction-references-payment-readiness-assessment-instruction-from-readiness",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "payment-instruction-references-payment-readiness-assessment-instruction-from-readiness",
            "required": true,
            "sourceFieldId": "readiness-ids",
            "targetEntityId": "payment-readiness-assessment",
            "targetFieldId": "payment-readiness-assessment-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the instruction to invoices represented in remittance information.",
            "id": "payment-instruction-belongs-to-invoice-instruction-settles-invoices",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "payment-instruction-belongs-to-invoice-instruction-settles-invoices",
            "required": true,
            "sourceFieldId": "invoice-ids",
            "targetEntityId": "invoice",
            "targetFieldId": "invoice-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the payment instruction to the referenced authority envelope.",
            "id": "payment-instruction-governed-by-authority-envelope-payment-instruction-authority-envelope-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "payment-instruction-governed-by-authority-envelope-payment-instruction-authority-envelope-id",
            "required": false,
            "sourceFieldId": "authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the payment instruction to the referenced evidence item.",
            "id": "payment-instruction-references-evidence-item-payment-instruction-instruction-message-id",
            "introducedIn": "2.0.0",
            "predicate": "references",
            "qualifiedId": "payment-instruction-references-evidence-item-payment-instruction-instruction-message-id",
            "required": false,
            "sourceFieldId": "instruction-message-id",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the payment instruction to the referenced evidence items.",
            "id": "payment-instruction-evidenced-by-evidence-item-payment-instruction-evidence-ids",
            "introducedIn": "2.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "payment-instruction-evidenced-by-evidence-item-payment-instruction-evidence-ids",
            "required": true,
            "sourceFieldId": "evidence-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the payment instruction to the referenced policy version.",
            "id": "payment-instruction-governed-by-policy-version-id-payment-instruction-policy-version-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "payment-instruction-governed-by-policy-version-id-payment-instruction-policy-version-id",
            "required": true,
            "sourceFieldId": "policy-version-id",
            "targetEntityId": "policy-version",
            "targetFieldId": "policy-version-id"
          }
        ],
        "retentionClass": "financial",
        "searchTerms": [
          "payment instruction",
          "credit transfer",
          "payment batch",
          "payment submission",
          "payment order"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "What payment was instructed, to whom, under which authority?",
              "What is the latest reconciled status of this instruction?"
            ],
            "retrievalTerms": [
              "payment run",
              "disbursement",
              "remittance",
              "bank transfer"
            ],
            "usage": "Keep proposal, committed content, authority, submission message and latest reconciled status distinguishable on every payment-instruction; submission formats are deployment bindings."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "payment order",
              "credit transfer instruction",
              "payment run entry"
            ],
            "concept": "controlled-payment-order"
          },
          "standardsAlignment": [
            {
              "concept": "pain.001 customer credit transfer initiation",
              "matchKind": "close",
              "standardId": "iso-20022"
            }
          ]
        },
        "sourceSystemRoleIds": [
          "payment-or-settlement-rail",
          "analytical-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "payment-or-settlement-rail",
          "planning-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "commit",
            "correct",
            "export"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "realization-reconciliation-attribution"
        ],
        "definition": "An append-only canonical status, acknowledgement, settlement, return or reconciliation event for a payment instruction.",
        "domainWorkblockIds": [
          "invoice-exception-payment-readiness",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable identifier for the append-only canonical status event.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "payment-execution-status-id",
            "introducedIn": "1.0.0",
            "label": "Payment status event ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "restricted",
            "definition": "Controlled instruction to which the status applies.",
            "exchangeScope": "mapped",
            "id": "payment-instruction-id",
            "introducedIn": "1.0.0",
            "label": "Payment instruction ID",
            "nullable": false,
            "referenceEntityId": "payment-instruction",
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "pain-002",
                "exchangeScope": "edge-interchange",
                "mappingKind": "message-path",
                "path": "TxInfAndSts/OrgnlInstrId|OrgnlEndToEndId",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-20022",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "pacs-002",
                "exchangeScope": "edge-interchange",
                "mappingKind": "message-path",
                "path": "TxInfAndSts/OrgnlInstrId|OrgnlEndToEndId",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-20022",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Canonical ISO 20022 or remittance message family producing the event.",
            "enumValues": [
              "pain.002",
              "pacs.002",
              "camt.053",
              "camt.054",
              "ubl-remittance-advice",
              "adapter-status"
            ],
            "exchangeScope": "mapped",
            "id": "message-type",
            "introducedIn": "1.0.0",
            "label": "Message type",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "inbound",
                "documentId": "payment-status-and-cash-management",
                "exchangeScope": "edge-interchange",
                "mappingKind": "message-path",
                "path": "message definition identifier",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-20022",
                "transformation": "none"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Exact version of the source message definition pinned by the adapter.",
            "exchangeScope": "mapped",
            "id": "message-version",
            "introducedIn": "1.0.0",
            "label": "Message version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "inbound",
                "documentId": "payment-status-and-cash-management",
                "exchangeScope": "edge-interchange",
                "mappingKind": "message-path",
                "path": "message definition version",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-20022",
                "transformation": "none"
              }
            ],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Original status code from the authoritative downstream source.",
            "exchangeScope": "mapped",
            "id": "downstream-status-code",
            "introducedIn": "1.0.0",
            "label": "Downstream status code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "inbound",
                "documentId": "pain-002",
                "exchangeScope": "edge-interchange",
                "mappingKind": "message-path",
                "path": "TxInfAndSts/TxSts",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-20022",
                "transformation": "none"
              },
              {
                "coverage": "exact",
                "direction": "inbound",
                "documentId": "pacs-002",
                "exchangeScope": "edge-interchange",
                "mappingKind": "message-path",
                "path": "TxInfAndSts/TxSts",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-20022",
                "transformation": "none"
              }
            ],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Original or canonical reason for acceptance, rejection, pending state or return.",
            "exchangeScope": "mapped",
            "id": "acceptance-reason-code",
            "introducedIn": "1.0.0",
            "label": "Acceptance or rejection reason code",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "inbound",
                "documentId": "pain-002",
                "exchangeScope": "edge-interchange",
                "mappingKind": "message-path",
                "path": "TxInfAndSts/StsRsnInf/Rsn",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-20022",
                "transformation": "none"
              },
              {
                "coverage": "exact",
                "direction": "inbound",
                "documentId": "pacs-002",
                "exchangeScope": "edge-interchange",
                "mappingKind": "message-path",
                "path": "TxInfAndSts/StsRsnInf/Rsn",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-20022",
                "transformation": "none"
              }
            ],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Canonical instruction status derived by the pinned mapping.",
            "enumValues": [
              "submitted",
              "accepted",
              "pending",
              "rejected",
              "settled",
              "returned",
              "cancelled",
              "unknown"
            ],
            "exchangeScope": "mapped",
            "id": "execution-status",
            "introducedIn": "1.0.0",
            "label": "Execution status",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "payment-status-and-cash-management",
                "exchangeScope": "edge-interchange",
                "mappingKind": "message-path",
                "path": "canonical mapping from transaction status",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-20022",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Timestamp when this source status was observed.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "observed-at",
            "introducedIn": "1.0.0",
            "label": "Observed at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Booked or value date when supplied by authoritative settlement evidence.",
            "exchangeScope": "mapped",
            "format": "date",
            "id": "settlement-date",
            "introducedIn": "1.0.0",
            "label": "Settlement date",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "camt-053",
                "exchangeScope": "edge-interchange",
                "mappingKind": "message-path",
                "path": "Ntry/BookgDt|Ntry/ValDt",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-20022",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "camt-054",
                "exchangeScope": "edge-interchange",
                "mappingKind": "message-path",
                "path": "Ntry/BookgDt|Ntry/ValDt",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-20022",
                "transformation": "adapter-defined"
              }
            ],
            "type": "date"
          },
          {
            "classification": "restricted",
            "definition": "Reference to the immutable statement or notification entry used for reconciliation.",
            "exchangeScope": "mapped",
            "id": "statement-id",
            "introducedIn": "1.0.0",
            "label": "Statement reference",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "inbound",
                "documentId": "camt-053",
                "exchangeScope": "edge-interchange",
                "mappingKind": "message-path",
                "path": "Ntry/NtryRef",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-20022",
                "transformation": "none"
              },
              {
                "coverage": "exact",
                "direction": "inbound",
                "documentId": "camt-054",
                "exchangeScope": "edge-interchange",
                "mappingKind": "message-path",
                "path": "Ntry/NtryRef",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-20022",
                "transformation": "none"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Reference to the UBL RemittanceAdvice associated with the payment.",
            "exchangeScope": "mapped",
            "id": "remittance-advice-id",
            "introducedIn": "1.0.0",
            "label": "Remittance advice reference",
            "nullable": true,
            "referenceEntityId": "evidence-item",
            "required": false,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "remittance-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Sanitised structured diagnostic for rejected, unmatched or unknown statuses.",
            "exchangeScope": "internal",
            "id": "error-detail",
            "introducedIn": "1.0.0",
            "label": "Error detail",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Error code records the governed code within Payment execution status Error detail without treating absence, unknown and zero as equivalent.",
                    "id": "error-code",
                    "label": "Error code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "error-detail",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Error category is the string component carried within Payment execution status Error detail; its classification and authority inherit from the owning field contract.",
                    "id": "error-category",
                    "label": "Error category",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "error-detail",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Sanitised message is the string component carried within Payment execution status Error detail; its classification and authority inherit from the owning field contract.",
                    "id": "sanitised-message",
                    "label": "Sanitised message",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "error-detail",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Source component is the string component carried within Payment execution status Error detail; its classification and authority inherit from the owning field contract.",
                    "id": "source-component",
                    "label": "Source component",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "error-detail",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Retryable is the boolean component carried within Payment execution status Error detail; its classification and authority inherit from the owning field contract.",
                    "id": "retryable",
                    "label": "Retryable",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "error-detail",
                      "kind": "inherited-field"
                    },
                    "type": "boolean"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Occurred at is the timestamp component carried within Payment execution status Error detail; its classification and authority inherit from the owning field contract.",
                    "id": "occurred-at",
                    "label": "Occurred at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "error-detail",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Correlation reference is the string component carried within Payment execution status Error detail; its classification and authority inherit from the owning field contract.",
                    "id": "correlation-reference",
                    "label": "Correlation reference",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "error-detail",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence reference links this structured value to the governed evidence-item record within Payment execution status Error detail.",
                    "id": "evidence-id",
                    "label": "Evidence reference",
                    "nullable": true,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the evidence reference in error detail to the referenced evidence item via its canonical evidence item ID.",
                      "id": "payment-execution-status-error-detail-evidence-reference",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "error-detail",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Authoritative status adapter identifier.",
            "exchangeScope": "internal",
            "id": "source-system",
            "introducedIn": "1.0.0",
            "label": "Source system",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Exact source message and adapter mapping version.",
            "exchangeScope": "internal",
            "id": "source-schema-version",
            "introducedIn": "1.0.0",
            "label": "Source schema version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Source message, mapping, match and reconciliation evidence.",
            "exchangeScope": "internal",
            "id": "evidence-ids",
            "introducedIn": "1.0.0",
            "label": "Evidence references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Status mapping and reconciliation policy version.",
            "exchangeScope": "internal",
            "id": "policy-version-id",
            "introducedIn": "1.0.0",
            "label": "Policy version",
            "nullable": false,
            "referenceEntityId": "policy-version",
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Version of payment-execution-guard producing the canonical status.",
            "exchangeScope": "internal",
            "id": "workblock-version",
            "introducedIn": "1.0.0",
            "label": "Workblock version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "payment-execution-guard",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "payment-execution-status",
        "immutable": true,
        "indexes": [
          {
            "fieldIds": [
              "business-key"
            ],
            "id": "payment-execution-status-by-business-key",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "payment-instruction-id",
              "observed-at"
            ],
            "id": "payment-execution-status-by-payment-instruction-id-and-observed-at",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "execution-status"
            ],
            "id": "payment-execution-status-by-execution-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "statement-id"
            ],
            "id": "payment-execution-status-by-statement-reference",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "event",
        "label": "Payment execution status",
        "lifecycle": [
          "received",
          "matched",
          "reconciled",
          "exception",
          "superseded-by-correction"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "payment-execution-guard",
        "owningDomainWorkblockId": "invoice-exception-payment-readiness",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "append-only-event-store",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Payment execution statuses",
        "primaryKey": "payment-execution-status-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Associates the status event with its payment instruction.",
            "id": "payment-execution-status-references-payment-instruction-status-of-instruction",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "payment-execution-status-references-payment-instruction-status-of-instruction",
            "required": true,
            "sourceFieldId": "payment-instruction-id",
            "targetEntityId": "payment-instruction",
            "targetFieldId": "payment-instruction-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the payment execution status to the referenced evidence item.",
            "id": "payment-execution-lifecycle-state-references-evidence-item-payment-execution-lifecycle-state-statement-id",
            "introducedIn": "1.1.0",
            "predicate": "references",
            "qualifiedId": "payment-execution-lifecycle-state-references-evidence-item-payment-execution-lifecycle-state-statement-id",
            "required": false,
            "sourceFieldId": "statement-id",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the payment execution status to the referenced evidence item.",
            "id": "payment-execution-lifecycle-state-references-evidence-item-payment-execution-lifecycle-state-remittance-advice-id",
            "introducedIn": "1.1.0",
            "predicate": "references",
            "qualifiedId": "payment-execution-lifecycle-state-references-evidence-item-payment-execution-lifecycle-state-remittance-advice-id",
            "required": false,
            "sourceFieldId": "remittance-advice-id",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the payment execution status to the referenced evidence items.",
            "id": "payment-execution-lifecycle-state-evidenced-by-evidence-item-payment-execution-lifecycle-state-evidence-ids",
            "introducedIn": "1.1.0",
            "predicate": "evidenced-by",
            "qualifiedId": "payment-execution-lifecycle-state-evidenced-by-evidence-item-payment-execution-lifecycle-state-evidence-ids",
            "required": true,
            "sourceFieldId": "evidence-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the payment execution status to the referenced policy version.",
            "id": "payment-execution-lifecycle-state-governed-by-policy-version-id-payment-execution-lifecycle-state-policy-version-id",
            "introducedIn": "1.1.0",
            "predicate": "governed-by",
            "qualifiedId": "payment-execution-lifecycle-state-governed-by-policy-version-id-payment-execution-lifecycle-state-policy-version-id",
            "required": true,
            "sourceFieldId": "policy-version-id",
            "targetEntityId": "policy-version",
            "targetFieldId": "policy-version-id"
          }
        ],
        "retentionClass": "financial",
        "searchTerms": [
          "payment status",
          "payment acknowledgement",
          "settlement",
          "payment return",
          "statement entry"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Has this payment settled, been returned or been acknowledged, and when?",
              "What is the full execution history of this instruction?"
            ],
            "retrievalTerms": [
              "settlement",
              "return",
              "acknowledgement",
              "reconciliation"
            ],
            "usage": "Append status, acknowledgement, settlement, return and reconciliation events to the owning payment-instruction; the event stream is canonical and never rewritten."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "payment status",
              "settlement event",
              "bank acknowledgement"
            ],
            "concept": "payment-status-event"
          },
          "standardsAlignment": [
            {
              "concept": "pain.002 payment status report and camt notifications",
              "matchKind": "close",
              "standardId": "iso-20022"
            }
          ]
        },
        "sourceSystemRoleIds": [
          "payment-or-settlement-rail",
          "analytical-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "payment-or-settlement-rail"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "supplier-innovation-pipeline",
          "supplier-performance-monitor-correct",
          "supplier-performance-review",
          "supplier-relationship-joint-value"
        ],
        "definition": "An effective-dated assignment of a supplier to a relationship segment and criticality band with supporting records attached, keeping the machine proposal separate from the committed governance control.",
        "domainWorkblockIds": [
          "supplier-performance-innovation-relationship"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for this proposed or committed assignment version.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "supplier-segment-assignment-id",
            "introducedIn": "1.0.0",
            "label": "Supplier segment assignment ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-segmentation-governance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Canonical supplier party receiving the assignment.",
            "exchangeScope": "mapped",
            "id": "supplier-party-id",
            "introducedIn": "1.0.0",
            "label": "Supplier party reference",
            "nullable": false,
            "referenceEntityId": "party",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-segmentation-governance",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "common-library",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:Party/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              },
              {
                "conceptId": "gln",
                "coverage": "semantic",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "identifier-namespace",
                "path": "Global Location Number",
                "releaseId": "source-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "gs1-identifiers",
                "transformation": "adapter-defined"
              },
              {
                "conceptId": "legal-entity-identifier",
                "coverage": "semantic",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "identifier-namespace",
                "path": "Legal Entity Identifier",
                "releaseId": "iso-17442",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "lei-17442",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Categories within which this assignment applies, or empty for enterprise-wide scope.",
            "exchangeScope": "mapped",
            "id": "category-ids",
            "introducedIn": "1.0.0",
            "label": "Category references",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "category",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-segmentation-governance",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "conceptId": "commodity-classification",
                "coverage": "semantic",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "code-list",
                "path": "pinned commodity classification code",
                "releaseId": "unresolved-release",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "unspsc",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Versioned feature, threshold and transition model used to create the proposal.",
            "exchangeScope": "internal",
            "id": "segmentation-model-version",
            "introducedIn": "1.0.0",
            "label": "Segmentation model version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-segmentation-governance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Pinned source and feature snapshots supporting the assignment.",
            "exchangeScope": "internal",
            "id": "input-snapshot-ids",
            "introducedIn": "1.0.0",
            "label": "Input snapshot references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "source-record-reference",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-segmentation-governance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "confidential",
            "definition": "Uncommitted relationship segment produced by the active model.",
            "enumValues": [
              "transactional",
              "managed",
              "preferred",
              "strategic",
              "restricted"
            ],
            "exchangeScope": "mapped",
            "id": "proposed-segment-code",
            "introducedIn": "1.0.0",
            "label": "Proposed segment code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-segmentation-governance",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "extension",
                "direction": "bidirectional",
                "documentId": "business-card",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "UBL does not define procurement relationship segmentation; exchange only through a profile-pinned BusinessCard extension.",
                "path": "ext:UBLExtensions/ext:UBLExtension/ext:ExtensionContent",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "extension-required"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Uncommitted operational dependency and consequence band.",
            "enumValues": [
              "low",
              "moderate",
              "high",
              "critical"
            ],
            "exchangeScope": "internal",
            "id": "proposed-criticality-band",
            "introducedIn": "1.0.0",
            "label": "Proposed criticality band",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-segmentation-governance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Lifecycle of the current uncommitted proposal; authorised means permission to attempt the action, while execution and committed outcome remain separate.",
            "enumValues": [
              "none",
              "draft",
              "proposed",
              "stale",
              "authorised",
              "rejected",
              "withdrawn",
              "superseded"
            ],
            "exchangeScope": "internal",
            "id": "proposal-status",
            "introducedIn": "1.0.0",
            "label": "Proposal status",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-segmentation-governance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Effective relationship segment controlling downstream governance.",
            "enumValues": [
              "transactional",
              "managed",
              "preferred",
              "strategic",
              "restricted"
            ],
            "exchangeScope": "internal",
            "id": "committed-segment-code",
            "introducedIn": "1.0.0",
            "label": "Committed segment code",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-segmentation-governance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Effective criticality control used by monitoring and escalation.",
            "enumValues": [
              "low",
              "moderate",
              "high",
              "critical"
            ],
            "exchangeScope": "internal",
            "id": "committed-criticality-band",
            "introducedIn": "1.0.0",
            "label": "Committed criticality band",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-segmentation-governance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Governed interaction posture activated by the committed segment and criticality.",
            "enumValues": [
              "automated-transactional",
              "operational-management",
              "performance-development",
              "joint-value",
              "restricted-control"
            ],
            "exchangeScope": "mapped",
            "id": "relationship-posture",
            "introducedIn": "1.0.0",
            "label": "Relationship posture",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-segmentation-governance",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "conceptId": "collaborative-business-relationship",
                "coverage": "semantic",
                "direction": "bidirectional",
                "exchangeScope": "internal-semantic",
                "mappingKind": "concept",
                "path": "relationship management plan and governance",
                "releaseId": "iso-44001-2017",
                "roundTrip": {
                  "status": "not-applicable"
                },
                "standardId": "iso-44001",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Authority permitting the committed segment transition.",
            "exchangeScope": "internal",
            "id": "authority-envelope-id",
            "introducedIn": "1.0.0",
            "label": "Authority envelope reference",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-segmentation-governance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Date and time from which the committed assignment governs.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "valid-from",
            "introducedIn": "1.0.0",
            "label": "Valid from",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-segmentation-governance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Date and time at which the assignment ceased to govern, if superseded or expired.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "valid-to",
            "introducedIn": "1.0.0",
            "label": "Valid to",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-segmentation-governance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Primary assignment producer identifier.",
            "exchangeScope": "internal",
            "id": "source-system",
            "introducedIn": "1.0.0",
            "label": "Source system",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-segmentation-governance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Exact input feature schema bundle.",
            "exchangeScope": "internal",
            "id": "source-schema-version",
            "introducedIn": "1.0.0",
            "label": "Source schema version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-segmentation-governance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Latest observation timestamp among the input snapshots.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "observed-at",
            "introducedIn": "1.0.0",
            "label": "Observed at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-segmentation-governance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Feature, impact, challenge, decision and downstream governance evidence.",
            "exchangeScope": "internal",
            "id": "evidence-ids",
            "introducedIn": "1.0.0",
            "label": "Evidence references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-segmentation-governance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Exact segmentation and transition policy version.",
            "exchangeScope": "internal",
            "id": "policy-version-id",
            "introducedIn": "1.0.0",
            "label": "Policy version",
            "nullable": false,
            "referenceEntityId": "policy-version",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-segmentation-governance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Version of supplier-segmentation-governance producing the assignment.",
            "exchangeScope": "internal",
            "id": "workblock-version",
            "introducedIn": "1.0.0",
            "label": "Workblock version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-segmentation-governance",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "supplier-segment-assignment",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "business-key"
            ],
            "id": "supplier-segment-assignment-by-business-key",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "supplier-party-id",
              "lifecycle-state"
            ],
            "id": "supplier-segment-assignment-by-supplier-party-reference-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "committed-segment-code",
              "committed-criticality-band"
            ],
            "id": "supplier-segment-assignment-by-committed-segment-code-and-committed-criticality-band",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "valid-from",
              "valid-to"
            ],
            "id": "supplier-segment-assignment-by-valid-from-and-valid-to",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "assignment",
        "label": "Supplier segment assignment",
        "lifecycle": [
          "proposed",
          "committed",
          "challenged",
          "expired",
          "superseded",
          "withdrawn"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "supplier-segmentation-governance",
        "owningDomainWorkblockId": "supplier-performance-innovation-relationship",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Supplier segment assignments",
        "primaryKey": "supplier-segment-assignment-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the effective assignment to the canonical supplier party.",
            "id": "supplier-segment-assignment-belongs-to-party-segment-assigned-to-party",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-segment-assignment-belongs-to-party-segment-assigned-to-party",
            "required": true,
            "sourceFieldId": "supplier-party-id",
            "targetEntityId": "party",
            "targetFieldId": "party-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the supplier segment assignment to the referenced categories.",
            "id": "supplier-segment-assignment-classified-as-category-supplier-segment-assignment-category-ids",
            "introducedIn": "2.0.0",
            "predicate": "classified-as",
            "qualifiedId": "supplier-segment-assignment-classified-as-category-supplier-segment-assignment-category-ids",
            "required": false,
            "sourceFieldId": "category-ids",
            "targetEntityId": "category",
            "targetFieldId": "category-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the supplier segment assignment to the referenced source record references.",
            "id": "supplier-segment-assignment-assigned-to-source-record-reference-supplier-segment-assignment-input-snapshot-ids",
            "introducedIn": "2.0.0",
            "predicate": "assigned-to",
            "qualifiedId": "supplier-segment-assignment-assigned-to-source-record-reference-supplier-segment-assignment-input-snapshot-ids",
            "required": true,
            "sourceFieldId": "input-snapshot-ids",
            "targetEntityId": "source-record-reference",
            "targetFieldId": "source-record-reference-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the supplier segment assignment to the referenced authority envelope.",
            "id": "supplier-segment-assignment-governed-by-authority-envelope-supplier-segment-assignment-authority-envelope-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "supplier-segment-assignment-governed-by-authority-envelope-supplier-segment-assignment-authority-envelope-id",
            "required": false,
            "sourceFieldId": "authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the supplier segment assignment to the referenced evidence items.",
            "id": "supplier-segment-assignment-evidenced-by-evidence-item-supplier-segment-assignment-evidence-ids",
            "introducedIn": "2.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "supplier-segment-assignment-evidenced-by-evidence-item-supplier-segment-assignment-evidence-ids",
            "required": true,
            "sourceFieldId": "evidence-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the supplier segment assignment to the referenced policy version.",
            "id": "supplier-segment-assignment-governed-by-policy-version-id-supplier-segment-assignment-policy-version-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "supplier-segment-assignment-governed-by-policy-version-id-supplier-segment-assignment-policy-version-id",
            "required": true,
            "sourceFieldId": "policy-version-id",
            "targetEntityId": "policy-version",
            "targetFieldId": "policy-version-id"
          }
        ],
        "retentionClass": "policy",
        "searchTerms": [
          "supplier segment",
          "supplier criticality",
          "relationship posture",
          "strategic supplier",
          "supplier governance"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Which segment and criticality band does this supplier hold, and since when?",
              "What supporting records justified the current segmentation?"
            ],
            "retrievalTerms": [
              "strategic supplier",
              "segmentation",
              "criticality",
              "tiering"
            ],
            "usage": "Assign suppliers to relationship segments and criticality bands through effective-dated assignments with supporting records; keep the machine proposal separate from the committed assignment."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "supplier segmentation",
              "criticality banding"
            ],
            "concept": "relationship-segment-assignment"
          }
        },
        "sourceSystemRoleIds": [
          "execution-system",
          "analytical-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record",
          "collaboration-channel"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "supplier-master-qualification",
          "supplier-performance-review",
          "supplier-segmentation-governance"
        ],
        "definition": "An atomic, source-linked supplier performance fact for a defined measure, scope and period, preserving correction and data-quality state separately from breach interpretation.",
        "domainWorkblockIds": [
          "supplier-performance-innovation-relationship",
          "supplier-lifecycle-third-party-risk"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for the atomic observation version.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "supplier-performance-observation-id",
            "introducedIn": "1.0.0",
            "label": "Supplier performance observation ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Canonical supplier party measured.",
            "exchangeScope": "mapped",
            "id": "supplier-party-id",
            "introducedIn": "1.0.0",
            "label": "Supplier party reference",
            "nullable": false,
            "referenceEntityId": "party",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "common-library",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:Party/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Optional category scope for the observation.",
            "exchangeScope": "mapped",
            "id": "category-id",
            "introducedIn": "1.0.0",
            "label": "Category reference",
            "nullable": true,
            "referenceEntityId": "category",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "conceptId": "commodity-classification",
                "coverage": "semantic",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "code-list",
                "path": "pinned commodity classification code",
                "releaseId": "unresolved-release",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "unspsc",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Optional agreement defining the target or scope.",
            "exchangeScope": "mapped",
            "id": "contract-id",
            "introducedIn": "1.0.0",
            "label": "Contract reference",
            "nullable": true,
            "referenceEntityId": "contract",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "tender-contract",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Optional canonical item or service measured.",
            "exchangeScope": "mapped",
            "id": "service-id",
            "introducedIn": "1.0.0",
            "label": "Service reference",
            "nullable": true,
            "referenceEntityId": "item-service",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "common-library",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:Item/cac:StandardItemIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Stable governed code for the performance measure.",
            "exchangeScope": "mapped",
            "id": "measure-code",
            "introducedIn": "1.0.0",
            "label": "Measure code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "common-library",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "UBL metric type codes require a governed mapping to the GroundWorks measure registry.",
                "path": "cbc:PerformanceMetricTypeCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Exact definition, calculation, target and evidence contract used.",
            "exchangeScope": "internal",
            "id": "measure-definition-version",
            "introducedIn": "1.0.0",
            "label": "Measure definition version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Inclusive start date of the measured period.",
            "exchangeScope": "internal",
            "format": "date",
            "id": "performance-period-start",
            "introducedIn": "1.0.0",
            "label": "Performance period start",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "confidential",
            "definition": "Inclusive end date of the measured period.",
            "exchangeScope": "internal",
            "format": "date",
            "id": "performance-period-end",
            "introducedIn": "1.0.0",
            "label": "Performance period end",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "confidential",
            "definition": "Structured target, threshold and comparison direction for this scope and period.",
            "exchangeScope": "internal",
            "id": "target-value",
            "introducedIn": "1.0.0",
            "label": "Target value",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Measure value is the decimal component carried within Supplier performance observation Target value; its classification and authority inherit from the owning field contract.",
                    "id": "measure-value",
                    "label": "Measure value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "target-value",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Comparison direction is the string component carried within Supplier performance observation Target value; its classification and authority inherit from the owning field contract.",
                    "id": "comparison-direction",
                    "label": "Comparison direction",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "target-value",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Threshold value is the decimal component carried within Supplier performance observation Target value; its classification and authority inherit from the owning field contract.",
                    "id": "threshold-value",
                    "label": "Threshold value",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "target-value",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Lower bound is the decimal component carried within Supplier performance observation Target value; its classification and authority inherit from the owning field contract.",
                    "id": "lower-bound",
                    "label": "Lower bound",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "target-value",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Upper bound is the decimal component carried within Supplier performance observation Target value; its classification and authority inherit from the owning field contract.",
                    "id": "upper-bound",
                    "label": "Upper bound",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "target-value",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Unit code records the governed code within Supplier performance observation Target value without treating absence, unknown and zero as equivalent.",
                    "id": "unit-code",
                    "label": "Unit code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "target-value",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Effective from is the date component carried within Supplier performance observation Target value; its classification and authority inherit from the owning field contract.",
                    "id": "effective-from",
                    "label": "Effective from",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "target-value",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Effective to is the date component carried within Supplier performance observation Target value; its classification and authority inherit from the owning field contract.",
                    "id": "effective-to",
                    "label": "Effective to",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "target-value",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Structured atomic value before scorecard weighting or narrative interpretation.",
            "exchangeScope": "internal",
            "id": "observed-value",
            "introducedIn": "1.0.0",
            "label": "Observed value",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Measure value is the decimal component carried within Supplier performance observation Observed value; its classification and authority inherit from the owning field contract.",
                    "id": "measure-value",
                    "label": "Measure value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "observed-value",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Unit code records the governed code within Supplier performance observation Observed value without treating absence, unknown and zero as equivalent.",
                    "id": "unit-code",
                    "label": "Unit code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "observed-value",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Sample count is the integer component carried within Supplier performance observation Observed value; its classification and authority inherit from the owning field contract.",
                    "id": "sample-count",
                    "label": "Sample count",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "observed-value",
                      "kind": "inherited-field"
                    },
                    "type": "integer"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Numerator is the decimal component carried within Supplier performance observation Observed value; its classification and authority inherit from the owning field contract.",
                    "id": "numerator",
                    "label": "Numerator",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "observed-value",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Denominator is the decimal component carried within Supplier performance observation Observed value; its classification and authority inherit from the owning field contract.",
                    "id": "denominator",
                    "label": "Denominator",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "observed-value",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Aggregation method is the string component carried within Supplier performance observation Observed value; its classification and authority inherit from the owning field contract.",
                    "id": "aggregation-method",
                    "label": "Aggregation method",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "observed-value",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Observation status records the governed state or type within Supplier performance observation Observed value without treating absence, unknown and zero as equivalent.",
                    "id": "observation-status",
                    "label": "Observation status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "observed-value",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Source time is the timestamp component carried within Supplier performance observation Observed value; its classification and authority inherit from the owning field contract.",
                    "id": "source-time",
                    "label": "Source time",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "observed-value",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Governed unit in which target and observation are comparable.",
            "exchangeScope": "mapped",
            "id": "unit-code",
            "introducedIn": "1.0.0",
            "label": "Unit code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "common-library",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:PerformanceValueQuantity/@unitCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Validity and completeness state of the observation independent of supplier performance.",
            "enumValues": [
              "valid",
              "partial",
              "late",
              "conflicting",
              "invalid",
              "corrected"
            ],
            "exchangeScope": "internal",
            "id": "quality-status",
            "introducedIn": "1.0.0",
            "label": "Quality status",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Result of applying the current target and signal policy.",
            "enumValues": [
              "not-evaluated",
              "within-target",
              "watch",
              "breach",
              "critical-breach",
              "recovered"
            ],
            "exchangeScope": "internal",
            "id": "breach-status",
            "introducedIn": "1.0.0",
            "label": "Breach status",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Whether this observation is original, challenged, corrected or superseded.",
            "enumValues": [
              "original",
              "challenged",
              "corrected",
              "superseded"
            ],
            "exchangeScope": "internal",
            "id": "correction-status",
            "introducedIn": "1.0.0",
            "label": "Correction status",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Atomic source records supporting the observation calculation.",
            "exchangeScope": "internal",
            "id": "source-record-ids",
            "introducedIn": "1.0.0",
            "label": "Source record references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "source-record-reference",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Authoritative observation source adapter.",
            "exchangeScope": "internal",
            "id": "source-system",
            "introducedIn": "1.0.0",
            "label": "Source system",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Exact source and calculation schema version.",
            "exchangeScope": "internal",
            "id": "source-schema-version",
            "introducedIn": "1.0.0",
            "label": "Source schema version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Timestamp when source facts were observed or the period result became available.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "observed-at",
            "introducedIn": "1.0.0",
            "label": "Observed at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Source, calculation, quality, challenge and correction evidence.",
            "exchangeScope": "internal",
            "id": "evidence-ids",
            "introducedIn": "1.0.0",
            "label": "Evidence references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Measure quality and signal policy version.",
            "exchangeScope": "internal",
            "id": "policy-version-id",
            "introducedIn": "1.0.0",
            "label": "Policy version",
            "nullable": false,
            "referenceEntityId": "policy-version",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Version of supplier-performance-monitor-correct producing the observation.",
            "exchangeScope": "internal",
            "id": "workblock-version",
            "introducedIn": "1.0.0",
            "label": "Workblock version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "supplier-performance-observation",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "business-key"
            ],
            "id": "supplier-performance-observation-by-business-key",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "supplier-party-id",
              "measure-code",
              "performance-period-end"
            ],
            "id": "supplier-performance-observation-by-supplier-party-reference-and-measure-code-and-performance-period-end",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "breach-status"
            ],
            "id": "supplier-performance-observation-by-breach-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "quality-status"
            ],
            "id": "supplier-performance-observation-by-quality-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "freshness-status"
            ],
            "id": "supplier-performance-observation-by-freshness-status",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "metric",
        "label": "Supplier performance observation",
        "lifecycle": [
          "observed",
          "validated",
          "quality-exception",
          "breach",
          "corrected",
          "superseded"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "supplier-performance-monitor-correct",
        "owningDomainWorkblockId": "supplier-performance-innovation-relationship",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Supplier performance observations",
        "primaryKey": "supplier-performance-observation-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the observation to the canonical supplier party.",
            "id": "supplier-performance-observation-belongs-to-party-observation-for-supplier",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-performance-observation-belongs-to-party-observation-for-supplier",
            "required": true,
            "sourceFieldId": "supplier-party-id",
            "targetEntityId": "party",
            "targetFieldId": "party-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the supplier performance observation to the referenced category.",
            "id": "supplier-performance-observation-classified-as-category-supplier-performance-observation-category-id",
            "introducedIn": "1.1.0",
            "predicate": "classified-as",
            "qualifiedId": "supplier-performance-observation-classified-as-category-supplier-performance-observation-category-id",
            "required": false,
            "sourceFieldId": "category-id",
            "targetEntityId": "category",
            "targetFieldId": "category-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the supplier performance observation to the referenced contract.",
            "id": "supplier-performance-observation-belongs-to-contract-supplier-performance-observation-contract-id",
            "introducedIn": "1.1.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-performance-observation-belongs-to-contract-supplier-performance-observation-contract-id",
            "required": false,
            "sourceFieldId": "contract-id",
            "targetEntityId": "contract",
            "targetFieldId": "contract-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the supplier performance observation to the referenced item or service.",
            "id": "supplier-performance-observation-belongs-to-item-service-supplier-performance-observation-service-id",
            "introducedIn": "1.1.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-performance-observation-belongs-to-item-service-supplier-performance-observation-service-id",
            "required": false,
            "sourceFieldId": "service-id",
            "targetEntityId": "item-service",
            "targetFieldId": "item-service-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the supplier performance observation to the referenced source record references.",
            "id": "supplier-performance-observation-evidenced-by-source-record-reference-supplier-performance-observation-source-record-ids",
            "introducedIn": "1.1.0",
            "predicate": "evidenced-by",
            "qualifiedId": "supplier-performance-observation-evidenced-by-source-record-reference-supplier-performance-observation-source-record-ids",
            "required": true,
            "sourceFieldId": "source-record-ids",
            "targetEntityId": "source-record-reference",
            "targetFieldId": "source-record-reference-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the supplier performance observation to the referenced evidence items.",
            "id": "supplier-performance-observation-evidenced-by-evidence-item-supplier-performance-observation-evidence-ids",
            "introducedIn": "1.1.0",
            "predicate": "evidenced-by",
            "qualifiedId": "supplier-performance-observation-evidenced-by-evidence-item-supplier-performance-observation-evidence-ids",
            "required": true,
            "sourceFieldId": "evidence-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the supplier performance observation to the referenced policy version.",
            "id": "supplier-performance-observation-governed-by-policy-version-id-supplier-performance-observation-policy-version-id",
            "introducedIn": "1.1.0",
            "predicate": "governed-by",
            "qualifiedId": "supplier-performance-observation-governed-by-policy-version-id-supplier-performance-observation-policy-version-id",
            "required": true,
            "sourceFieldId": "policy-version-id",
            "targetEntityId": "policy-version",
            "targetFieldId": "policy-version-id"
          }
        ],
        "retentionClass": "operational",
        "searchTerms": [
          "supplier KPI",
          "supplier performance measure",
          "service level",
          "quality result",
          "delivery performance"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "What was measured for this supplier, over which scope and period, from which source?",
              "Which observations were corrected and what is their data-quality state?"
            ],
            "retrievalTerms": [
              "on-time delivery",
              "quality rate",
              "KPI",
              "measurement"
            ],
            "usage": "Record atomic, source-linked performance facts per measure, scope and period; corrections and data-quality state stay separate from breach interpretation."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "performance measurement",
              "KPI observation"
            ],
            "concept": "atomic-performance-fact",
            "doNotConfuseWith": [
              {
                "distinction": "The observation is the atomic sourced fact; the signal is a versioned interpretation over exact observations.",
                "targetEntityId": "supplier-performance-signal"
              }
            ]
          }
        },
        "sourceSystemRoleIds": [
          "execution-system",
          "transport-execution-boundary",
          "planning-system",
          "collaboration-channel"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "analytical-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "supplier-innovation-pipeline",
          "supplier-performance-monitor-correct",
          "supplier-relationship-joint-value"
        ],
        "definition": "A versioned supplier review that binds atomic observations and a scorecard definition to a proposal, stakeholder and supplier input, an authorised decision and corrective follow-through.",
        "domainWorkblockIds": [
          "supplier-performance-innovation-relationship"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for the review version.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "supplier-performance-review-record-id",
            "introducedIn": "1.0.0",
            "label": "Supplier performance review ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Canonical supplier party reviewed.",
            "exchangeScope": "mapped",
            "id": "supplier-party-id",
            "introducedIn": "1.0.0",
            "label": "Supplier party reference",
            "nullable": false,
            "referenceEntityId": "party",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-review",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "common-library",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:Party/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Inclusive start date of the governed review period.",
            "exchangeScope": "internal",
            "format": "date",
            "id": "review-period-start",
            "introducedIn": "1.0.0",
            "label": "Review period start",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "confidential",
            "definition": "Inclusive end date of the governed review period.",
            "exchangeScope": "internal",
            "format": "date",
            "id": "review-period-end",
            "introducedIn": "1.0.0",
            "label": "Review period end",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "confidential",
            "definition": "Committed assignment selecting scorecard and governance ceremony.",
            "exchangeScope": "internal",
            "id": "segment-assignment-id",
            "introducedIn": "1.0.0",
            "label": "Segment assignment reference",
            "nullable": false,
            "referenceEntityId": "supplier-segment-assignment",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Exact atomic observations included in the scorecard.",
            "exchangeScope": "internal",
            "id": "observation-ids",
            "introducedIn": "1.0.0",
            "label": "Observation references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "supplier-performance-observation",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Exact measure, target, weight and evidence policy applied.",
            "exchangeScope": "mapped",
            "id": "scorecard-definition-version",
            "introducedIn": "1.0.0",
            "label": "Scorecard definition version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-review",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "conceptId": "sustainable-procurement-guidance",
                "coverage": "semantic",
                "direction": "bidirectional",
                "exchangeScope": "internal-semantic",
                "mappingKind": "concept",
                "path": "supplier performance and improvement considerations",
                "releaseId": "iso-20400-2017",
                "roundTrip": {
                  "status": "not-applicable"
                },
                "standardId": "iso-20400",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Structured scorecard results retaining measure contributions and missing-state behaviour.",
            "exchangeScope": "mapped",
            "id": "aggregate-scores",
            "introducedIn": "1.0.0",
            "label": "Aggregate scores",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-review",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "common-library",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "UBL performance data lines provide metric values; aggregation, confidence, evidence and review disposition remain GroundWorks data.",
                "path": "cac:PerformanceDataLine",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Score ID is the string component carried within Supplier performance review Aggregate scores; its classification and authority inherit from the owning field contract.",
                    "id": "score-id",
                    "label": "Score ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "aggregate-scores",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Measure code records the governed code within Supplier performance review Aggregate scores without treating absence, unknown and zero as equivalent.",
                    "id": "measure-code",
                    "label": "Measure code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "aggregate-scores",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Score is the decimal component carried within Supplier performance review Aggregate scores; its classification and authority inherit from the owning field contract.",
                    "id": "score",
                    "label": "Score",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "aggregate-scores",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Weight is the decimal component carried within Supplier performance review Aggregate scores; its classification and authority inherit from the owning field contract.",
                    "id": "weight",
                    "label": "Weight",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "aggregate-scores",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Weighted score is the decimal component carried within Supplier performance review Aggregate scores; its classification and authority inherit from the owning field contract.",
                    "id": "weighted-score",
                    "label": "Weighted score",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "aggregate-scores",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Missing state code records the governed code within Supplier performance review Aggregate scores without treating absence, unknown and zero as equivalent.",
                    "id": "missing-state-code",
                    "label": "Missing state code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "aggregate-scores",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Observation references is the set carried within Supplier performance review Aggregate scores; its owning field governs allowed values and interpretation.",
                    "format": "supplier-performance-observation references",
                    "id": "observation-references",
                    "label": "Observation references",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "aggregate-scores",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Calculation version is the string component carried within Supplier performance review Aggregate scores; its classification and authority inherit from the owning field contract.",
                    "id": "calculation-version",
                    "label": "Calculation version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "aggregate-scores",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ],
                "uniqueBy": [
                  "score-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Structured period and cohort comparisons with valid methodology and source coverage.",
            "exchangeScope": "internal",
            "id": "trend-summary",
            "introducedIn": "1.0.0",
            "label": "Trend summary",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Trend ID is the string component carried within Supplier performance review Trend summary; its classification and authority inherit from the owning field contract.",
                    "id": "trend-id",
                    "label": "Trend ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "trend-summary",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Measure code records the governed code within Supplier performance review Trend summary without treating absence, unknown and zero as equivalent.",
                    "id": "measure-code",
                    "label": "Measure code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "trend-summary",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Comparison period start is the date component carried within Supplier performance review Trend summary; its classification and authority inherit from the owning field contract.",
                    "id": "comparison-period-start",
                    "label": "Comparison period start",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "trend-summary",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Comparison period end is the date component carried within Supplier performance review Trend summary; its classification and authority inherit from the owning field contract.",
                    "id": "comparison-period-end",
                    "label": "Comparison period end",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "trend-summary",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Comparison value is the decimal component carried within Supplier performance review Trend summary; its classification and authority inherit from the owning field contract.",
                    "id": "comparison-value",
                    "label": "Comparison value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "trend-summary",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Current value is the decimal component carried within Supplier performance review Trend summary; its classification and authority inherit from the owning field contract.",
                    "id": "current-value",
                    "label": "Current value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "trend-summary",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Direction is the string component carried within Supplier performance review Trend summary; its classification and authority inherit from the owning field contract.",
                    "id": "direction",
                    "label": "Direction",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "trend-summary",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Methodology version is the string component carried within Supplier performance review Trend summary; its classification and authority inherit from the owning field contract.",
                    "id": "methodology-version",
                    "label": "Methodology version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "trend-summary",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Source coverage percent is the decimal component carried within Supplier performance review Trend summary; its classification and authority inherit from the owning field contract.",
                    "id": "source-coverage-percent",
                    "label": "Source coverage percent",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "trend-summary",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  }
                ],
                "uniqueBy": [
                  "trend-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Evidence-linked machine or human draft, visibly uncommitted.",
            "exchangeScope": "internal",
            "id": "proposed-narrative",
            "introducedIn": "1.0.0",
            "label": "Proposed narrative",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-performance-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "text"
          },
          {
            "classification": "restricted",
            "definition": "Uncommitted corrective, development, innovation or governance actions.",
            "exchangeScope": "internal",
            "id": "proposed-actions",
            "introducedIn": "1.0.0",
            "label": "Proposed actions",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-performance-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Action ID is the string component carried within Supplier performance review Proposed actions; its classification and authority inherit from the owning field contract.",
                    "id": "action-id",
                    "label": "Action ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-actions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Action type records the governed state or type within Supplier performance review Proposed actions without treating absence, unknown and zero as equivalent.",
                    "id": "action-type",
                    "label": "Action type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-actions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Description is the string component carried within Supplier performance review Proposed actions; its classification and authority inherit from the owning field contract.",
                    "id": "description",
                    "label": "Description",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-actions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Owner reference is the string component carried within Supplier performance review Proposed actions; its classification and authority inherit from the owning field contract.",
                    "id": "owner-reference",
                    "label": "Owner reference",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-actions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Due date is the date component carried within Supplier performance review Proposed actions; its classification and authority inherit from the owning field contract.",
                    "id": "due-date",
                    "label": "Due date",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-actions",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Measure code records the governed code within Supplier performance review Proposed actions without treating absence, unknown and zero as equivalent.",
                    "id": "measure-code",
                    "label": "Measure code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-actions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence references is the set carried within Supplier performance review Proposed actions; its owning field governs allowed values and interpretation.",
                    "format": "evidence-item references",
                    "id": "evidence-references",
                    "label": "Evidence references",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-actions",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Rationale is the string component carried within Supplier performance review Proposed actions; its classification and authority inherit from the owning field contract.",
                    "id": "rationale",
                    "label": "Rationale",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-actions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ],
                "uniqueBy": [
                  "action-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Lifecycle of the current uncommitted proposal; authorised means permission to attempt the action, while execution and committed outcome remain separate.",
            "enumValues": [
              "none",
              "draft",
              "proposed",
              "stale",
              "authorised",
              "rejected",
              "withdrawn",
              "superseded"
            ],
            "exchangeScope": "internal",
            "id": "proposal-status",
            "introducedIn": "1.0.0",
            "label": "Proposal status",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Authorised review outcomes and decisions, distinct from the proposed narrative and actions.",
            "exchangeScope": "internal",
            "id": "committed-decisions",
            "introducedIn": "1.0.0",
            "label": "Committed decisions",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-performance-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Decision ID links this structured value to governed decision record through decision-id within Supplier performance review Committed decisions.",
                    "id": "decision-id",
                    "label": "Decision ID",
                    "nullable": false,
                    "referenceEntityId": "decision",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links decision id to governed decision record through the canonical decision-id field.",
                      "id": "supplier-performance-review-record-committed-decisions-decision-id",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "decision-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-decisions",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Decision code records the governed code within Supplier performance review Committed decisions without treating absence, unknown and zero as equivalent.",
                    "id": "decision-code",
                    "label": "Decision code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-decisions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Action reference is the string component carried within Supplier performance review Committed decisions; its classification and authority inherit from the owning field contract.",
                    "id": "action-reference",
                    "label": "Action reference",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "committed-decisions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Committed by is the string component carried within Supplier performance review Committed decisions; its classification and authority inherit from the owning field contract.",
                    "id": "committed-by",
                    "label": "Committed by",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-decisions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Committed at is the timestamp component carried within Supplier performance review Committed decisions; its classification and authority inherit from the owning field contract.",
                    "id": "committed-at",
                    "label": "Committed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-decisions",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Effective from is the date component carried within Supplier performance review Committed decisions; its classification and authority inherit from the owning field contract.",
                    "id": "effective-from",
                    "label": "Effective from",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "committed-decisions",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Outcome required is the boolean component carried within Supplier performance review Committed decisions; its classification and authority inherit from the owning field contract.",
                    "id": "outcome-required",
                    "label": "Outcome required",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-decisions",
                      "kind": "inherited-field"
                    },
                    "type": "boolean"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence references is the set carried within Supplier performance review Committed decisions; its owning field governs allowed values and interpretation.",
                    "format": "evidence-item references",
                    "id": "evidence-references",
                    "label": "Evidence references",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "committed-decisions",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  }
                ],
                "uniqueBy": [
                  "decision-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Authority permitting committed review decisions and routine action opening.",
            "exchangeScope": "internal",
            "id": "authority-envelope-id",
            "introducedIn": "1.0.0",
            "label": "Authority envelope reference",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-performance-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Structured committed or proposed actions with owners, milestones, measures and closure criteria.",
            "exchangeScope": "internal",
            "id": "corrective-action-plan",
            "introducedIn": "1.0.0",
            "label": "Corrective action plan",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-performance-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Plan ID is the string component carried within Supplier performance review Corrective action plan; its classification and authority inherit from the owning field contract.",
                    "id": "plan-id",
                    "label": "Plan ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "corrective-action-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Plan version is the string component carried within Supplier performance review Corrective action plan; its classification and authority inherit from the owning field contract.",
                    "id": "plan-version",
                    "label": "Plan version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "corrective-action-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Status records the governed state or type within Supplier performance review Corrective action plan without treating absence, unknown and zero as equivalent.",
                    "id": "status",
                    "label": "Status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "corrective-action-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Actions is the object component carried within Supplier performance review Corrective action plan; its classification and authority inherit from the owning field contract.",
                    "id": "actions",
                    "label": "Actions",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "corrective-action-plan",
                      "kind": "inherited-field"
                    },
                    "type": "object",
                    "valueSchema": {
                      "mode": "inline",
                      "schema": {
                        "additionalProperties": false,
                        "container": "object-list",
                        "properties": [
                          {
                            "classification": "restricted",
                            "definition": "Action ID is the string component carried within Actions; its classification and authority inherit from the owning field contract.",
                            "id": "action-id",
                            "label": "Action ID",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "corrective-action-plan",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Description is the string component carried within Actions; its classification and authority inherit from the owning field contract.",
                            "id": "description",
                            "label": "Description",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "corrective-action-plan",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Owner reference is the string component carried within Actions; its classification and authority inherit from the owning field contract.",
                            "id": "owner-reference",
                            "label": "Owner reference",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "corrective-action-plan",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Due date is the date component carried within Actions; its classification and authority inherit from the owning field contract.",
                            "id": "due-date",
                            "label": "Due date",
                            "nullable": false,
                            "required": true,
                            "sourceAuthority": {
                              "id": "corrective-action-plan",
                              "kind": "inherited-field"
                            },
                            "type": "date"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Measure code records the governed code within Actions without treating absence, unknown and zero as equivalent.",
                            "id": "measure-code",
                            "label": "Measure code",
                            "nullable": true,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": false,
                            "sourceAuthority": {
                              "id": "corrective-action-plan",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Closure criteria is the string component carried within Actions; its classification and authority inherit from the owning field contract.",
                            "id": "closure-criteria",
                            "label": "Closure criteria",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "corrective-action-plan",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Status records the governed state or type within Actions without treating absence, unknown and zero as equivalent.",
                            "id": "status",
                            "label": "Status",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "corrective-action-plan",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          }
                        ],
                        "uniqueBy": [
                          "action-id"
                        ]
                      },
                      "schemaVersion": "1.0.0"
                    }
                  },
                  {
                    "classification": "restricted",
                    "definition": "Started at is the timestamp component carried within Supplier performance review Corrective action plan; its classification and authority inherit from the owning field contract.",
                    "id": "started-at",
                    "label": "Started at",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "corrective-action-plan",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Target completion date is the date component carried within Supplier performance review Corrective action plan; its classification and authority inherit from the owning field contract.",
                    "id": "target-completion-date",
                    "label": "Target completion date",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "corrective-action-plan",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Closure evidence references is the set carried within Supplier performance review Corrective action plan; its owning field governs allowed values and interpretation.",
                    "format": "evidence-item references",
                    "id": "closure-evidence-references",
                    "label": "Closure evidence references",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "corrective-action-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Approved by is the string component carried within Supplier performance review Corrective action plan; its classification and authority inherit from the owning field contract.",
                    "id": "approved-by",
                    "label": "Approved by",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "corrective-action-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Timestamp of the committed review decision.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "reviewed-at",
            "introducedIn": "1.0.0",
            "label": "Reviewed at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-performance-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Scheduled start or due timestamp for the next governed review.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "next-review-at",
            "introducedIn": "1.0.0",
            "label": "Next review at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-performance-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Review producer identifier.",
            "exchangeScope": "internal",
            "id": "source-system",
            "introducedIn": "1.0.0",
            "label": "Source system",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Exact observation and review package schema bundle.",
            "exchangeScope": "internal",
            "id": "source-schema-version",
            "introducedIn": "1.0.0",
            "label": "Source schema version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Latest observation timestamp among the review evidence.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "observed-at",
            "introducedIn": "1.0.0",
            "label": "Observed at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Score, narrative, supplier response, decision and action evidence.",
            "exchangeScope": "internal",
            "id": "evidence-ids",
            "introducedIn": "1.0.0",
            "label": "Evidence references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Review and scorecard governance policy version.",
            "exchangeScope": "internal",
            "id": "policy-version-id",
            "introducedIn": "1.0.0",
            "label": "Policy version",
            "nullable": false,
            "referenceEntityId": "policy-version",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Version of supplier-performance-review producing the record.",
            "exchangeScope": "internal",
            "id": "workblock-version",
            "introducedIn": "1.0.0",
            "label": "Workblock version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Shared governed decision record that carries authority, rationale and evidence for this domain decision.",
            "exchangeScope": "unmapped",
            "id": "governance-decision-id",
            "introducedIn": "4.0.0",
            "label": "Governance decision ID",
            "nullable": true,
            "referenceEntityId": "decision",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-performance-review",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "supplier-performance-review-record",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "business-key"
            ],
            "id": "supplier-performance-review-record-by-business-key",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "supplier-party-id",
              "review-period-end"
            ],
            "id": "supplier-performance-review-record-by-supplier-party-reference-and-review-period-end",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "lifecycle-state"
            ],
            "id": "supplier-performance-review-record-by-review-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "next-review-at"
            ],
            "id": "supplier-performance-review-record-by-next-review-at",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "decision",
        "label": "Supplier performance review",
        "lifecycle": [
          "preparing",
          "evidence-gap",
          "proposed",
          "in-review",
          "committed",
          "disputed",
          "superseded",
          "closed"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "supplier-performance-review",
        "owningDomainWorkblockId": "supplier-performance-innovation-relationship",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Supplier performance reviews",
        "primaryKey": "supplier-performance-review-record-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the review to the canonical supplier party.",
            "id": "supplier-performance-review-record-belongs-to-party-review-of-supplier",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-performance-review-record-belongs-to-party-review-of-supplier",
            "required": true,
            "sourceFieldId": "supplier-party-id",
            "targetEntityId": "party",
            "targetFieldId": "party-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Binds the review to the committed segment assignment used.",
            "id": "supplier-performance-review-record-references-supplier-segment-assignment-review-under-segment",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "supplier-performance-review-record-references-supplier-segment-assignment-review-under-segment",
            "required": true,
            "sourceFieldId": "segment-assignment-id",
            "targetEntityId": "supplier-segment-assignment",
            "targetFieldId": "supplier-segment-assignment-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links scorecard results to atomic observations.",
            "id": "supplier-performance-review-record-references-supplier-performance-observation-review-uses-observations",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "supplier-performance-review-record-references-supplier-performance-observation-review-uses-observations",
            "required": true,
            "sourceFieldId": "observation-ids",
            "targetEntityId": "supplier-performance-observation",
            "targetFieldId": "supplier-performance-observation-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the supplier performance review to the referenced authority envelope.",
            "id": "supplier-performance-review-record-governed-by-authority-envelope-supplier-performance-review-record-authority-envelope-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "supplier-performance-review-record-governed-by-authority-envelope-supplier-performance-review-record-authority-envelope-id",
            "required": false,
            "sourceFieldId": "authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the supplier performance review to the referenced evidence items.",
            "id": "supplier-performance-review-record-evidenced-by-evidence-item-supplier-performance-review-record-evidence-ids",
            "introducedIn": "2.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "supplier-performance-review-record-evidenced-by-evidence-item-supplier-performance-review-record-evidence-ids",
            "required": true,
            "sourceFieldId": "evidence-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the supplier performance review to the referenced policy version.",
            "id": "supplier-performance-review-record-governed-by-policy-version-id-supplier-performance-review-record-policy-version-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "supplier-performance-review-record-governed-by-policy-version-id-supplier-performance-review-record-policy-version-id",
            "required": true,
            "sourceFieldId": "policy-version-id",
            "targetEntityId": "policy-version",
            "targetFieldId": "policy-version-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Shared governed decision for this domain outcome.",
            "id": "supplier-performance-review-record-governed-by-decision-supplier-performance-review-record-governance-decision",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "supplier-performance-review-record-governed-by-decision-supplier-performance-review-record-governance-decision",
            "required": false,
            "sourceFieldId": "governance-decision-id",
            "targetEntityId": "decision",
            "targetFieldId": "decision-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "supplier review",
          "supplier scorecard",
          "business review",
          "performance review",
          "corrective action plan"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "What did the latest review decide for this supplier and on which scorecard?",
              "Which corrective actions follow from the review and who owns them?"
            ],
            "retrievalTerms": [
              "scorecard",
              "review meeting",
              "performance decision"
            ],
            "usage": "Bind atomic observations and a scorecard definition to the proposal, stakeholder and supplier input, the authorised decision and corrective follow-through in one versioned review."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "supplier review",
              "scorecard review",
              "business review record"
            ],
            "concept": "performance-review-decision"
          }
        },
        "sourceSystemRoleIds": [
          "analytical-system",
          "system-of-record",
          "execution-system",
          "collaboration-channel"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record",
          "collaboration-channel"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "renewal-change-compliance",
          "sourcing-pipeline-discovery",
          "supplier-relationship-joint-value",
          "value-opportunity-baseline"
        ],
        "definition": "A governed supplier innovation opportunity carrying the need, provisional value and risk hypotheses, stage evidence, experiment plan, authority decision and measured outcome.",
        "domainWorkblockIds": [
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for the innovation case.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "supplier-innovation-case-id",
            "introducedIn": "1.0.0",
            "label": "Supplier innovation case ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-innovation-pipeline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Canonical supplier party participating in the opportunity.",
            "exchangeScope": "mapped",
            "id": "supplier-party-id",
            "introducedIn": "1.0.0",
            "label": "Supplier party reference",
            "nullable": false,
            "referenceEntityId": "party",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-innovation-pipeline",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "common-library",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:Party/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Concise innovation opportunity title suitable for search and work queues.",
            "exchangeScope": "internal",
            "id": "title",
            "introducedIn": "1.0.0",
            "label": "Title",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-innovation-pipeline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Business need, supplier idea and desired outcome stated without asserting unvalidated value.",
            "exchangeScope": "internal",
            "id": "need-or-opportunity",
            "introducedIn": "1.0.0",
            "label": "Need or opportunity",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-innovation-pipeline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "text"
          },
          {
            "classification": "personal",
            "definition": "Role or person accountable for the business outcome and gate commitment.",
            "exchangeScope": "internal",
            "id": "sponsor-reference",
            "introducedIn": "1.0.0",
            "label": "Sponsor reference",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-innovation-pipeline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "personal",
            "definition": "Role or person accountable for the next case action.",
            "exchangeScope": "internal",
            "id": "owner-reference",
            "introducedIn": "1.0.0",
            "label": "Owner reference",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-innovation-pipeline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Categories to which the opportunity applies.",
            "exchangeScope": "mapped",
            "id": "category-ids",
            "introducedIn": "1.0.0",
            "label": "Category references",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "category",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-innovation-pipeline",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "conceptId": "commodity-classification",
                "coverage": "semantic",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "code-list",
                "path": "pinned commodity classification code",
                "releaseId": "unresolved-release",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "unspsc",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "restricted",
            "definition": "Agreements relevant to rights, obligations, experiment or scale.",
            "exchangeScope": "mapped",
            "id": "contract-ids",
            "introducedIn": "1.0.0",
            "label": "Contract references",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "contract",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-innovation-pipeline",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "tender-contract",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "confidential",
            "definition": "Provisional outcome, baseline idea, measures and sensitivity, explicitly not validated value.",
            "exchangeScope": "internal",
            "id": "value-hypothesis",
            "introducedIn": "1.0.0",
            "label": "Value hypothesis",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-innovation-pipeline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Hypothesis statement is the string component carried within Supplier innovation case Value hypothesis; its classification and authority inherit from the owning field contract.",
                    "id": "hypothesis-statement",
                    "label": "Hypothesis statement",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "value-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Value type records the governed state or type within Supplier innovation case Value hypothesis without treating absence, unknown and zero as equivalent.",
                    "id": "value-type",
                    "label": "Value type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "value-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Baseline description is the string component carried within Supplier innovation case Value hypothesis; its classification and authority inherit from the owning field contract.",
                    "id": "baseline-description",
                    "label": "Baseline description",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "value-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Target description is the string component carried within Supplier innovation case Value hypothesis; its classification and authority inherit from the owning field contract.",
                    "id": "target-description",
                    "label": "Target description",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "value-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Measure codes is the set carried within Supplier innovation case Value hypothesis; its owning field governs allowed values and interpretation.",
                    "id": "measure-codes",
                    "label": "Measure codes",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "value-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Sensitivity factors is the set carried within Supplier innovation case Value hypothesis; its owning field governs allowed values and interpretation.",
                    "id": "sensitivity-factors",
                    "label": "Sensitivity factors",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "value-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Evidence references is the set carried within Supplier innovation case Value hypothesis; its owning field governs allowed values and interpretation.",
                    "format": "evidence-item references",
                    "id": "evidence-references",
                    "label": "Evidence references",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "value-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Confidence band is the string component carried within Supplier innovation case Value hypothesis; its classification and authority inherit from the owning field contract.",
                    "id": "confidence-band",
                    "label": "Confidence band",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "value-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Provisional operational, security, safety, legal, intellectual-property and supplier-risk assessment.",
            "exchangeScope": "internal",
            "id": "risk-hypothesis",
            "introducedIn": "1.0.0",
            "label": "Risk hypothesis",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-innovation-pipeline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Risk ID is the string component carried within Supplier innovation case Risk hypothesis; its classification and authority inherit from the owning field contract.",
                    "id": "risk-id",
                    "label": "Risk ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "risk-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Risk type records the governed state or type within Supplier innovation case Risk hypothesis without treating absence, unknown and zero as equivalent.",
                    "id": "risk-type",
                    "label": "Risk type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "risk-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Description is the string component carried within Supplier innovation case Risk hypothesis; its classification and authority inherit from the owning field contract.",
                    "id": "description",
                    "label": "Description",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "risk-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Likelihood band is the string component carried within Supplier innovation case Risk hypothesis; its classification and authority inherit from the owning field contract.",
                    "id": "likelihood-band",
                    "label": "Likelihood band",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "risk-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Impact band is the string component carried within Supplier innovation case Risk hypothesis; its classification and authority inherit from the owning field contract.",
                    "id": "impact-band",
                    "label": "Impact band",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "risk-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Mitigation hypothesis is the string component carried within Supplier innovation case Risk hypothesis; its classification and authority inherit from the owning field contract.",
                    "id": "mitigation-hypothesis",
                    "label": "Mitigation hypothesis",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "risk-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence references is the set carried within Supplier innovation case Risk hypothesis; its owning field governs allowed values and interpretation.",
                    "format": "evidence-item references",
                    "id": "evidence-references",
                    "label": "Evidence references",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "risk-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Assessment status records the governed state or type within Supplier innovation case Risk hypothesis without treating absence, unknown and zero as equivalent.",
                    "id": "assessment-status",
                    "label": "Assessment status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "risk-hypothesis",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ],
                "uniqueBy": [
                  "risk-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Uncommitted stage gate, evidence request, experiment or closure action.",
            "exchangeScope": "internal",
            "id": "proposed-next-action",
            "introducedIn": "1.0.0",
            "label": "Proposed next action",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-innovation-pipeline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Action type records the governed state or type within Supplier innovation case Proposed next action without treating absence, unknown and zero as equivalent.",
                    "id": "action-type",
                    "label": "Action type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-next-action",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Action description is the string component carried within Supplier innovation case Proposed next action; its classification and authority inherit from the owning field contract.",
                    "id": "action-description",
                    "label": "Action description",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-next-action",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Rationale is the string component carried within Supplier innovation case Proposed next action; its classification and authority inherit from the owning field contract.",
                    "id": "rationale",
                    "label": "Rationale",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-next-action",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Owner reference is the string component carried within Supplier innovation case Proposed next action; its classification and authority inherit from the owning field contract.",
                    "id": "owner-reference",
                    "label": "Owner reference",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-next-action",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Due at is the timestamp component carried within Supplier innovation case Proposed next action; its classification and authority inherit from the owning field contract.",
                    "id": "due-at",
                    "label": "Due at",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-next-action",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Required evidence is the set carried within Supplier innovation case Proposed next action; its owning field governs allowed values and interpretation.",
                    "id": "required-evidence",
                    "label": "Required evidence",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-next-action",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Proposed at is the timestamp component carried within Supplier innovation case Proposed next action; its classification and authority inherit from the owning field contract.",
                    "id": "proposed-at",
                    "label": "Proposed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-next-action",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Expires at is the timestamp component carried within Supplier innovation case Proposed next action; its classification and authority inherit from the owning field contract.",
                    "id": "expires-at",
                    "label": "Expires at",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-next-action",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Lifecycle of the current uncommitted proposal; authorised means permission to attempt the action, while execution and committed outcome remain separate.",
            "enumValues": [
              "none",
              "draft",
              "proposed",
              "stale",
              "authorised",
              "rejected",
              "withdrawn",
              "superseded"
            ],
            "exchangeScope": "internal",
            "id": "proposal-status",
            "introducedIn": "1.0.0",
            "label": "Proposal status",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-innovation-pipeline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Authorised stage, experiment, scale, stop or close decision.",
            "exchangeScope": "internal",
            "id": "committed-gate-decision",
            "introducedIn": "1.0.0",
            "label": "Committed gate decision",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-innovation-pipeline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Decision code records the governed code within Supplier innovation case Committed gate decision without treating absence, unknown and zero as equivalent.",
                    "id": "decision-code",
                    "label": "Decision code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-gate-decision",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Resulting stage is the string component carried within Supplier innovation case Committed gate decision; its classification and authority inherit from the owning field contract.",
                    "id": "resulting-stage",
                    "label": "Resulting stage",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-gate-decision",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Decision rationale is the string component carried within Supplier innovation case Committed gate decision; its classification and authority inherit from the owning field contract.",
                    "id": "decision-rationale",
                    "label": "Decision rationale",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-gate-decision",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Committed by is the string component carried within Supplier innovation case Committed gate decision; its classification and authority inherit from the owning field contract.",
                    "id": "committed-by",
                    "label": "Committed by",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-gate-decision",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Committed at is the timestamp component carried within Supplier innovation case Committed gate decision; its classification and authority inherit from the owning field contract.",
                    "id": "committed-at",
                    "label": "Committed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-gate-decision",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Conditions is the set carried within Supplier innovation case Committed gate decision; its owning field governs allowed values and interpretation.",
                    "id": "conditions",
                    "label": "Conditions",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "committed-gate-decision",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Experiment plan version is the string component carried within Supplier innovation case Committed gate decision; its classification and authority inherit from the owning field contract.",
                    "id": "experiment-plan-version",
                    "label": "Experiment plan version",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "committed-gate-decision",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence references is the set carried within Supplier innovation case Committed gate decision; its owning field governs allowed values and interpretation.",
                    "format": "evidence-item references",
                    "id": "evidence-references",
                    "label": "Evidence references",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "committed-gate-decision",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Authority permitting the committed gate and experiment actions.",
            "exchangeScope": "internal",
            "id": "authority-envelope-id",
            "introducedIn": "1.0.0",
            "label": "Authority envelope reference",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-innovation-pipeline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Versioned hypothesis, baseline, measures, budget, duration, data scope, success and stop conditions.",
            "exchangeScope": "internal",
            "id": "experiment-plan",
            "introducedIn": "1.0.0",
            "label": "Experiment plan",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-innovation-pipeline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Experiment ID is the string component carried within Supplier innovation case Experiment plan; its classification and authority inherit from the owning field contract.",
                    "id": "experiment-id",
                    "label": "Experiment ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "experiment-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Plan version is the string component carried within Supplier innovation case Experiment plan; its classification and authority inherit from the owning field contract.",
                    "id": "plan-version",
                    "label": "Plan version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "experiment-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Hypothesis is the string component carried within Supplier innovation case Experiment plan; its classification and authority inherit from the owning field contract.",
                    "id": "hypothesis",
                    "label": "Hypothesis",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "experiment-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Baseline description is the string component carried within Supplier innovation case Experiment plan; its classification and authority inherit from the owning field contract.",
                    "id": "baseline-description",
                    "label": "Baseline description",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "experiment-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Measure codes is the set carried within Supplier innovation case Experiment plan; its owning field governs allowed values and interpretation.",
                    "id": "measure-codes",
                    "label": "Measure codes",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "experiment-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Budget is the money component carried within Supplier innovation case Experiment plan; its classification and authority inherit from the owning field contract.",
                    "id": "budget",
                    "label": "Budget",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "experiment-plan",
                      "kind": "inherited-field"
                    },
                    "type": "money",
                    "valueSchema": {
                      "mode": "registry",
                      "schemaId": "money-value",
                      "schemaVersion": "2.0.0"
                    }
                  },
                  {
                    "classification": "restricted",
                    "definition": "Start date is the date component carried within Supplier innovation case Experiment plan; its classification and authority inherit from the owning field contract.",
                    "id": "start-date",
                    "label": "Start date",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "experiment-plan",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "End date is the date component carried within Supplier innovation case Experiment plan; its classification and authority inherit from the owning field contract.",
                    "id": "end-date",
                    "label": "End date",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "experiment-plan",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Data scope is the string component carried within Supplier innovation case Experiment plan; its classification and authority inherit from the owning field contract.",
                    "id": "data-scope",
                    "label": "Data scope",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "experiment-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Success conditions is the set carried within Supplier innovation case Experiment plan; its owning field governs allowed values and interpretation.",
                    "id": "success-conditions",
                    "label": "Success conditions",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "experiment-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Stop conditions is the set carried within Supplier innovation case Experiment plan; its owning field governs allowed values and interpretation.",
                    "id": "stop-conditions",
                    "label": "Stop conditions",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "experiment-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence references is the set carried within Supplier innovation case Experiment plan; its owning field governs allowed values and interpretation.",
                    "format": "evidence-item references",
                    "id": "evidence-references",
                    "label": "Evidence references",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "experiment-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Observed results, stop reason, validated measures and outcome disposition, not automatically realised value.",
            "exchangeScope": "internal",
            "id": "experiment-outcome",
            "introducedIn": "1.0.0",
            "label": "Experiment outcome",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-innovation-pipeline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Experiment ID is the string component carried within Supplier innovation case Experiment outcome; its classification and authority inherit from the owning field contract.",
                    "id": "experiment-id",
                    "label": "Experiment ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "experiment-outcome",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Plan version is the string component carried within Supplier innovation case Experiment outcome; its classification and authority inherit from the owning field contract.",
                    "id": "plan-version",
                    "label": "Plan version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "experiment-outcome",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Outcome code records the governed code within Supplier innovation case Experiment outcome without treating absence, unknown and zero as equivalent.",
                    "id": "outcome-code",
                    "label": "Outcome code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "experiment-outcome",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Observed results is the string component carried within Supplier innovation case Experiment outcome; its classification and authority inherit from the owning field contract.",
                    "id": "observed-results",
                    "label": "Observed results",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "experiment-outcome",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Validated measures is the object component carried within Supplier innovation case Experiment outcome; its classification and authority inherit from the owning field contract.",
                    "id": "validated-measures",
                    "label": "Validated measures",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "experiment-outcome",
                      "kind": "inherited-field"
                    },
                    "type": "object",
                    "valueSchema": {
                      "mode": "inline",
                      "schema": {
                        "additionalProperties": false,
                        "container": "object-list",
                        "properties": [
                          {
                            "classification": "restricted",
                            "definition": "Measure code records the governed code within Validated measures without treating absence, unknown and zero as equivalent.",
                            "id": "measure-code",
                            "label": "Measure code",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "experiment-outcome",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Observed value is the decimal component carried within Validated measures; its classification and authority inherit from the owning field contract.",
                            "id": "observed-value",
                            "label": "Observed value",
                            "nullable": false,
                            "required": true,
                            "sourceAuthority": {
                              "id": "experiment-outcome",
                              "kind": "inherited-field"
                            },
                            "type": "decimal"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Unit code records the governed code within Validated measures without treating absence, unknown and zero as equivalent.",
                            "id": "unit-code",
                            "label": "Unit code",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "experiment-outcome",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Evidence reference links this structured value to the governed evidence-item record within Validated measures.",
                            "id": "evidence-id",
                            "label": "Evidence reference",
                            "nullable": true,
                            "referenceEntityId": "evidence-item",
                            "relationship": {
                              "cardinality": "many-to-one",
                              "definition": "Links the evidence reference in validated measures to the referenced evidence item via its canonical evidence item ID.",
                              "id": "supplier-innovation-case-experiment-outcome-validated-measures-evidence-reference",
                              "introducedIn": "2.0.0",
                              "required": false,
                              "targetFieldId": "evidence-item-id"
                            },
                            "required": false,
                            "sourceAuthority": {
                              "id": "experiment-outcome",
                              "kind": "inherited-field"
                            },
                            "type": "reference"
                          }
                        ],
                        "uniqueBy": [
                          "measure-code"
                        ]
                      },
                      "schemaVersion": "1.0.0"
                    }
                  },
                  {
                    "classification": "restricted",
                    "definition": "Stop reason is the string component carried within Supplier innovation case Experiment outcome; its classification and authority inherit from the owning field contract.",
                    "id": "stop-reason",
                    "label": "Stop reason",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "experiment-outcome",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Disposition code records the governed code within Supplier innovation case Experiment outcome without treating absence, unknown and zero as equivalent.",
                    "id": "disposition-code",
                    "label": "Disposition code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "experiment-outcome",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evaluated at is the timestamp component carried within Supplier innovation case Experiment outcome; its classification and authority inherit from the owning field contract.",
                    "id": "evaluated-at",
                    "label": "Evaluated at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "experiment-outcome",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence references is the set carried within Supplier innovation case Experiment outcome; its owning field governs allowed values and interpretation.",
                    "format": "evidence-item references",
                    "id": "evidence-references",
                    "label": "Evidence references",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "experiment-outcome",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Timestamp when the canonical case was created.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "opened-at",
            "introducedIn": "1.0.0",
            "label": "Opened at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-innovation-pipeline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Scheduled next gate or evidence deadline.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "next-gate-at",
            "introducedIn": "1.0.0",
            "label": "Next gate at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-innovation-pipeline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Timestamp when the case was closed or stopped with a committed disposition.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "closed-at",
            "introducedIn": "1.0.0",
            "label": "Closed at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-innovation-pipeline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Primary innovation submission or producer.",
            "exchangeScope": "internal",
            "id": "source-system",
            "introducedIn": "1.0.0",
            "label": "Source system",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-innovation-pipeline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Exact submission and evidence schema bundle.",
            "exchangeScope": "internal",
            "id": "source-schema-version",
            "introducedIn": "1.0.0",
            "label": "Source schema version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-innovation-pipeline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Latest observation timestamp among the case evidence.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "observed-at",
            "introducedIn": "1.0.0",
            "label": "Observed at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-innovation-pipeline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Submission, rights, risk, gate, experiment, supplier and outcome evidence.",
            "exchangeScope": "internal",
            "id": "evidence-ids",
            "introducedIn": "1.0.0",
            "label": "Evidence references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-innovation-pipeline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Innovation stage and experiment policy version.",
            "exchangeScope": "internal",
            "id": "policy-version-id",
            "introducedIn": "1.0.0",
            "label": "Policy version",
            "nullable": false,
            "referenceEntityId": "policy-version",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-innovation-pipeline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Version of supplier-innovation-pipeline managing the case.",
            "exchangeScope": "internal",
            "id": "workblock-version",
            "introducedIn": "1.0.0",
            "label": "Workblock version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-innovation-pipeline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "supplier-innovation-case",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "business-key"
            ],
            "id": "supplier-innovation-case-by-business-key",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "supplier-party-id",
              "lifecycle-state"
            ],
            "id": "supplier-innovation-case-by-supplier-party-reference-and-stage",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "owner-reference",
              "next-gate-at"
            ],
            "id": "supplier-innovation-case-by-owner-reference-and-next-gate-at",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "category-ids"
            ],
            "id": "supplier-innovation-case-by-category-references",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "case",
        "label": "Supplier innovation case",
        "lifecycle": [
          "captured",
          "qualifying",
          "proposed",
          "experiment-approved",
          "experiment-active",
          "scale-proposed",
          "scaled",
          "realised",
          "stopped",
          "closed"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "supplier-innovation-pipeline",
        "owningDomainWorkblockId": "supplier-performance-innovation-relationship",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Supplier innovation cases",
        "primaryKey": "supplier-innovation-case-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the innovation case to the canonical supplier party.",
            "id": "supplier-innovation-case-belongs-to-party-innovation-with-supplier",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-innovation-case-belongs-to-party-innovation-with-supplier",
            "required": true,
            "sourceFieldId": "supplier-party-id",
            "targetEntityId": "party",
            "targetFieldId": "party-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the supplier innovation case to the referenced categories.",
            "id": "supplier-innovation-case-classified-as-category-supplier-innovation-case-category-ids",
            "introducedIn": "2.0.0",
            "predicate": "classified-as",
            "qualifiedId": "supplier-innovation-case-classified-as-category-supplier-innovation-case-category-ids",
            "required": false,
            "sourceFieldId": "category-ids",
            "targetEntityId": "category",
            "targetFieldId": "category-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the supplier innovation case to the referenced contracts.",
            "id": "supplier-innovation-case-belongs-to-contract-supplier-innovation-case-contract-ids",
            "introducedIn": "2.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-innovation-case-belongs-to-contract-supplier-innovation-case-contract-ids",
            "required": false,
            "sourceFieldId": "contract-ids",
            "targetEntityId": "contract",
            "targetFieldId": "contract-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the supplier innovation case to the referenced authority envelope.",
            "id": "supplier-innovation-case-governed-by-authority-envelope-supplier-innovation-case-authority-envelope-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "supplier-innovation-case-governed-by-authority-envelope-supplier-innovation-case-authority-envelope-id",
            "required": false,
            "sourceFieldId": "authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the supplier innovation case to the referenced evidence items.",
            "id": "supplier-innovation-case-evidenced-by-evidence-item-supplier-innovation-case-evidence-ids",
            "introducedIn": "2.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "supplier-innovation-case-evidenced-by-evidence-item-supplier-innovation-case-evidence-ids",
            "required": true,
            "sourceFieldId": "evidence-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the supplier innovation case to the referenced policy version.",
            "id": "supplier-innovation-case-governed-by-policy-version-id-supplier-innovation-case-policy-version-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "supplier-innovation-case-governed-by-policy-version-id-supplier-innovation-case-policy-version-id",
            "required": true,
            "sourceFieldId": "policy-version-id",
            "targetEntityId": "policy-version",
            "targetFieldId": "policy-version-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "supplier innovation",
          "supplier idea",
          "joint innovation",
          "experiment",
          "innovation stage gate"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Which innovation opportunities are active with this supplier and at what stage?",
              "What value hypothesis was tested and what outcome was measured?"
            ],
            "retrievalTerms": [
              "innovation",
              "experiment",
              "value hypothesis",
              "pilot"
            ],
            "usage": "Carry the need, provisional value and risk hypotheses, stage evidence, experiment plan, authority decision and measured outcome for each governed supplier innovation opportunity."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "supplier innovation",
              "innovation pipeline entry"
            ],
            "concept": "innovation-opportunity-case"
          }
        },
        "sourceSystemRoleIds": [
          "collaboration-channel",
          "system-of-record",
          "analytical-system",
          "execution-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record",
          "collaboration-channel"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "administer",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "supplier-innovation-pipeline"
        ],
        "definition": "An effective-dated relationship plan containing shared objectives, mutual commitments, milestones, governance, linked innovation and validated outcome references, with proposal and committed plan versions kept distinct.",
        "domainWorkblockIds": [
          "supplier-performance-innovation-relationship"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for the relationship plan identity and version lineage.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "supplier-joint-value-plan-id",
            "introducedIn": "1.0.0",
            "label": "Supplier joint-value plan ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-relationship-joint-value",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Canonical supplier party participating in the plan.",
            "exchangeScope": "mapped",
            "id": "supplier-party-id",
            "introducedIn": "1.0.0",
            "label": "Supplier party reference",
            "nullable": false,
            "referenceEntityId": "party",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-relationship-joint-value",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "exact",
                "direction": "bidirectional",
                "documentId": "common-library",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:Party/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "none"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Committed segment and relationship posture governing the plan.",
            "exchangeScope": "internal",
            "id": "segment-assignment-id",
            "introducedIn": "1.0.0",
            "label": "Segment assignment reference",
            "nullable": false,
            "referenceEntityId": "supplier-segment-assignment",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-relationship-joint-value",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Versioned, measurable relationship objectives linked to business and category outcomes.",
            "exchangeScope": "mapped",
            "id": "objectives",
            "introducedIn": "1.0.0",
            "label": "Objectives",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-relationship-joint-value",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "conceptId": "collaborative-business-relationship",
                "coverage": "semantic",
                "direction": "bidirectional",
                "exchangeScope": "internal-semantic",
                "mappingKind": "concept",
                "path": "joint objectives and value creation",
                "releaseId": "iso-44001-2017",
                "roundTrip": {
                  "status": "not-applicable"
                },
                "standardId": "iso-44001",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Objective ID is the string component carried within Supplier joint-value plan Objectives; its classification and authority inherit from the owning field contract.",
                    "id": "objective-id",
                    "label": "Objective ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "objectives",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Title is the string component carried within Supplier joint-value plan Objectives; its classification and authority inherit from the owning field contract.",
                    "id": "title",
                    "label": "Title",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "objectives",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Outcome description is the string component carried within Supplier joint-value plan Objectives; its classification and authority inherit from the owning field contract.",
                    "id": "outcome-description",
                    "label": "Outcome description",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "objectives",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Measure codes is the set carried within Supplier joint-value plan Objectives; its owning field governs allowed values and interpretation.",
                    "id": "measure-codes",
                    "label": "Measure codes",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "objectives",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Target date is the date component carried within Supplier joint-value plan Objectives; its classification and authority inherit from the owning field contract.",
                    "id": "target-date",
                    "label": "Target date",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "objectives",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Internal owner reference is the string component carried within Supplier joint-value plan Objectives; its classification and authority inherit from the owning field contract.",
                    "id": "internal-owner-reference",
                    "label": "Internal owner reference",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "objectives",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Supplier owner reference is the string component carried within Supplier joint-value plan Objectives; its classification and authority inherit from the owning field contract.",
                    "id": "supplier-owner-reference",
                    "label": "Supplier owner reference",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "objectives",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Status records the governed state or type within Supplier joint-value plan Objectives without treating absence, unknown and zero as equivalent.",
                    "id": "status",
                    "label": "Status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "objectives",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ],
                "uniqueBy": [
                  "objective-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Typed internal and supplier commitments with owner, due date, evidence and consequence.",
            "exchangeScope": "mapped",
            "id": "mutual-commitments",
            "introducedIn": "1.0.0",
            "label": "Mutual commitments",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-relationship-joint-value",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "conceptId": "collaborative-business-relationship",
                "coverage": "semantic",
                "direction": "bidirectional",
                "exchangeScope": "internal-semantic",
                "mappingKind": "concept",
                "path": "roles, responsibilities and collaborative commitments",
                "releaseId": "iso-44001-2017",
                "roundTrip": {
                  "status": "not-applicable"
                },
                "standardId": "iso-44001",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Commitment ID is the string component carried within Supplier joint-value plan Mutual commitments; its classification and authority inherit from the owning field contract.",
                    "id": "commitment-id",
                    "label": "Commitment ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "mutual-commitments",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Party role is the string component carried within Supplier joint-value plan Mutual commitments; its classification and authority inherit from the owning field contract.",
                    "id": "party-role",
                    "label": "Party role",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "mutual-commitments",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Owner reference is the string component carried within Supplier joint-value plan Mutual commitments; its classification and authority inherit from the owning field contract.",
                    "id": "owner-reference",
                    "label": "Owner reference",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "mutual-commitments",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Commitment description is the string component carried within Supplier joint-value plan Mutual commitments; its classification and authority inherit from the owning field contract.",
                    "id": "commitment-description",
                    "label": "Commitment description",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "mutual-commitments",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Due date is the date component carried within Supplier joint-value plan Mutual commitments; its classification and authority inherit from the owning field contract.",
                    "id": "due-date",
                    "label": "Due date",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "mutual-commitments",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence required is the set carried within Supplier joint-value plan Mutual commitments; its owning field governs allowed values and interpretation.",
                    "id": "evidence-required",
                    "label": "Evidence required",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "mutual-commitments",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Consequence is the string component carried within Supplier joint-value plan Mutual commitments; its classification and authority inherit from the owning field contract.",
                    "id": "consequence",
                    "label": "Consequence",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "mutual-commitments",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Status records the governed state or type within Supplier joint-value plan Mutual commitments without treating absence, unknown and zero as equivalent.",
                    "id": "status",
                    "label": "Status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "mutual-commitments",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ],
                "uniqueBy": [
                  "commitment-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Plan milestones, dependencies, due dates, measures and completion evidence.",
            "exchangeScope": "internal",
            "id": "milestones",
            "introducedIn": "1.0.0",
            "label": "Milestones",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-relationship-joint-value",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Milestone ID is the string component carried within Supplier joint-value plan Milestones; its classification and authority inherit from the owning field contract.",
                    "id": "milestone-id",
                    "label": "Milestone ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "milestones",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Title is the string component carried within Supplier joint-value plan Milestones; its classification and authority inherit from the owning field contract.",
                    "id": "title",
                    "label": "Title",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "milestones",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Due date is the date component carried within Supplier joint-value plan Milestones; its classification and authority inherit from the owning field contract.",
                    "id": "due-date",
                    "label": "Due date",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "milestones",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Owner reference is the string component carried within Supplier joint-value plan Milestones; its classification and authority inherit from the owning field contract.",
                    "id": "owner-reference",
                    "label": "Owner reference",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "milestones",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Dependency ids is the set carried within Supplier joint-value plan Milestones; its owning field governs allowed values and interpretation.",
                    "id": "dependency-ids",
                    "label": "Dependency ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "milestones",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Measure codes is the set carried within Supplier joint-value plan Milestones; its owning field governs allowed values and interpretation.",
                    "id": "measure-codes",
                    "label": "Measure codes",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "milestones",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Completion criteria is the string component carried within Supplier joint-value plan Milestones; its classification and authority inherit from the owning field contract.",
                    "id": "completion-criteria",
                    "label": "Completion criteria",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "milestones",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Completion evidence references is the set carried within Supplier joint-value plan Milestones; its owning field governs allowed values and interpretation.",
                    "format": "evidence-item references",
                    "id": "completion-evidence-references",
                    "label": "Completion evidence references",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "milestones",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Status records the governed state or type within Supplier joint-value plan Milestones without treating absence, unknown and zero as equivalent.",
                    "id": "status",
                    "label": "Status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "milestones",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ],
                "uniqueBy": [
                  "milestone-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Review rhythm, participants, agenda, decision rights and preparation rules.",
            "exchangeScope": "mapped",
            "id": "governance-cadence",
            "introducedIn": "1.0.0",
            "label": "Governance cadence",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-relationship-joint-value",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "conceptId": "collaborative-business-relationship",
                "coverage": "semantic",
                "direction": "bidirectional",
                "exchangeScope": "internal-semantic",
                "mappingKind": "concept",
                "path": "governance and relationship management plan",
                "releaseId": "iso-44001-2017",
                "roundTrip": {
                  "status": "not-applicable"
                },
                "standardId": "iso-44001",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Governance forum ID is the string component carried within Supplier joint-value plan Governance cadence; its classification and authority inherit from the owning field contract.",
                    "id": "governance-forum-id",
                    "label": "Governance forum ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "governance-cadence",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Forum type records the governed state or type within Supplier joint-value plan Governance cadence without treating absence, unknown and zero as equivalent.",
                    "id": "forum-type",
                    "label": "Forum type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "governance-cadence",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Interval description is the string component carried within Supplier joint-value plan Governance cadence; its classification and authority inherit from the owning field contract.",
                    "id": "interval-description",
                    "label": "Interval description",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "governance-cadence",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Participant references is the set carried within Supplier joint-value plan Governance cadence; its owning field governs allowed values and interpretation.",
                    "id": "participant-references",
                    "label": "Participant references",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "governance-cadence",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Agenda items is the ordered list carried within Supplier joint-value plan Governance cadence; its owning field governs allowed values and interpretation.",
                    "id": "agenda-items",
                    "label": "Agenda items",
                    "listSemantics": "ordered",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "governance-cadence",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Decision rights is the string component carried within Supplier joint-value plan Governance cadence; its classification and authority inherit from the owning field contract.",
                    "id": "decision-rights",
                    "label": "Decision rights",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "governance-cadence",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Preparation rules is the ordered list carried within Supplier joint-value plan Governance cadence; its owning field governs allowed values and interpretation.",
                    "id": "preparation-rules",
                    "label": "Preparation rules",
                    "listSemantics": "ordered",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "governance-cadence",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Next review at is the timestamp component carried within Supplier joint-value plan Governance cadence; its classification and authority inherit from the owning field contract.",
                    "id": "next-review-at",
                    "label": "Next review at",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "governance-cadence",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  }
                ],
                "uniqueBy": [
                  "governance-forum-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Agreed treatment of shared risks, benefits, dependencies and evidence without asserting unvalidated value.",
            "exchangeScope": "mapped",
            "id": "shared-risk-and-benefit",
            "introducedIn": "1.0.0",
            "label": "Shared risk and benefit model",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-relationship-joint-value",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "conceptId": "collaborative-business-relationship",
                "coverage": "semantic",
                "direction": "bidirectional",
                "exchangeScope": "internal-semantic",
                "mappingKind": "concept",
                "path": "value creation and risk management",
                "releaseId": "iso-44001-2017",
                "roundTrip": {
                  "status": "not-applicable"
                },
                "standardId": "iso-44001",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Sharing item ID is the string component carried within Supplier joint-value plan Shared risk and benefit model; its classification and authority inherit from the owning field contract.",
                    "id": "sharing-item-id",
                    "label": "Sharing item ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "shared-risk-and-benefit",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Item type records the governed state or type within Supplier joint-value plan Shared risk and benefit model without treating absence, unknown and zero as equivalent.",
                    "id": "item-type",
                    "label": "Item type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "shared-risk-and-benefit",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Description is the string component carried within Supplier joint-value plan Shared risk and benefit model; its classification and authority inherit from the owning field contract.",
                    "id": "description",
                    "label": "Description",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "shared-risk-and-benefit",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Internal treatment is the string component carried within Supplier joint-value plan Shared risk and benefit model; its classification and authority inherit from the owning field contract.",
                    "id": "internal-treatment",
                    "label": "Internal treatment",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "shared-risk-and-benefit",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Supplier treatment is the string component carried within Supplier joint-value plan Shared risk and benefit model; its classification and authority inherit from the owning field contract.",
                    "id": "supplier-treatment",
                    "label": "Supplier treatment",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "shared-risk-and-benefit",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Allocation basis is the string component carried within Supplier joint-value plan Shared risk and benefit model; its classification and authority inherit from the owning field contract.",
                    "id": "allocation-basis",
                    "label": "Allocation basis",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "shared-risk-and-benefit",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence required is the set carried within Supplier joint-value plan Shared risk and benefit model; its owning field governs allowed values and interpretation.",
                    "id": "evidence-required",
                    "label": "Evidence required",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "shared-risk-and-benefit",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Status records the governed state or type within Supplier joint-value plan Shared risk and benefit model without treating absence, unknown and zero as equivalent.",
                    "id": "status",
                    "label": "Status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "shared-risk-and-benefit",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ],
                "uniqueBy": [
                  "sharing-item-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Uncommitted plan version or change set.",
            "exchangeScope": "internal",
            "id": "proposed-plan",
            "introducedIn": "1.0.0",
            "label": "Proposed plan",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-relationship-joint-value",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Plan version is the string component carried within Supplier joint-value plan Proposed plan; its classification and authority inherit from the owning field contract.",
                    "id": "plan-version",
                    "label": "Plan version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Change summary is the string component carried within Supplier joint-value plan Proposed plan; its classification and authority inherit from the owning field contract.",
                    "id": "change-summary",
                    "label": "Change summary",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Proposed by is the string component carried within Supplier joint-value plan Proposed plan; its classification and authority inherit from the owning field contract.",
                    "id": "proposed-by",
                    "label": "Proposed by",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Proposed at is the timestamp component carried within Supplier joint-value plan Proposed plan; its classification and authority inherit from the owning field contract.",
                    "id": "proposed-at",
                    "label": "Proposed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-plan",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Effective from is the date component carried within Supplier joint-value plan Proposed plan; its classification and authority inherit from the owning field contract.",
                    "id": "effective-from",
                    "label": "Effective from",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-plan",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Objective ids is the set carried within Supplier joint-value plan Proposed plan; its owning field governs allowed values and interpretation.",
                    "id": "objective-ids",
                    "label": "Objective ids",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Commitment ids is the set carried within Supplier joint-value plan Proposed plan; its owning field governs allowed values and interpretation.",
                    "id": "commitment-ids",
                    "label": "Commitment ids",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Milestone ids is the set carried within Supplier joint-value plan Proposed plan; its owning field governs allowed values and interpretation.",
                    "id": "milestone-ids",
                    "label": "Milestone ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Rationale is the string component carried within Supplier joint-value plan Proposed plan; its classification and authority inherit from the owning field contract.",
                    "id": "rationale",
                    "label": "Rationale",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Lifecycle of the current uncommitted proposal; authorised means permission to attempt the action, while execution and committed outcome remain separate.",
            "enumValues": [
              "none",
              "draft",
              "proposed",
              "stale",
              "authorised",
              "rejected",
              "withdrawn",
              "superseded"
            ],
            "exchangeScope": "internal",
            "id": "proposal-status",
            "introducedIn": "1.0.0",
            "label": "Proposal status",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-relationship-joint-value",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Semantic version and content hash of the mutually committed plan.",
            "exchangeScope": "internal",
            "id": "committed-plan-version",
            "introducedIn": "1.0.0",
            "label": "Committed plan version",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-relationship-joint-value",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Authority permitting plan commitment and routine mission actions.",
            "exchangeScope": "internal",
            "id": "authority-envelope-id",
            "introducedIn": "1.0.0",
            "label": "Authority envelope reference",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-relationship-joint-value",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Current observed progress by objective and commitment with source and freshness; not a substitute for atomic records.",
            "exchangeScope": "internal",
            "id": "progress-summary",
            "introducedIn": "1.0.0",
            "label": "Progress summary",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-relationship-joint-value",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Summary item ID is the string component carried within Supplier joint-value plan Progress summary; its classification and authority inherit from the owning field contract.",
                    "id": "summary-item-id",
                    "label": "Summary item ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "progress-summary",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Subject type records the governed state or type within Supplier joint-value plan Progress summary without treating absence, unknown and zero as equivalent.",
                    "id": "subject-type",
                    "label": "Subject type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "progress-summary",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Subject ID is the string component carried within Supplier joint-value plan Progress summary; its classification and authority inherit from the owning field contract.",
                    "id": "subject-id",
                    "label": "Subject ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "progress-summary",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Progress status records the governed state or type within Supplier joint-value plan Progress summary without treating absence, unknown and zero as equivalent.",
                    "id": "progress-status",
                    "label": "Progress status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "progress-summary",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Progress percent is the decimal component carried within Supplier joint-value plan Progress summary; its classification and authority inherit from the owning field contract.",
                    "id": "progress-percent",
                    "label": "Progress percent",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "progress-summary",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Observed at is the timestamp component carried within Supplier joint-value plan Progress summary; its classification and authority inherit from the owning field contract.",
                    "id": "observed-at",
                    "label": "Observed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "progress-summary",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Freshness status records the governed state or type within Supplier joint-value plan Progress summary without treating absence, unknown and zero as equivalent.",
                    "id": "freshness-status",
                    "label": "Freshness status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "progress-summary",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Source record reference links this structured value to the governed source-record-reference record within Supplier joint-value plan Progress summary.",
                    "id": "source-record-id",
                    "label": "Source record reference",
                    "nullable": true,
                    "referenceEntityId": "source-record-reference",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the source record reference in progress summary to the referenced source record reference via its canonical source record reference ID.",
                      "id": "supplier-joint-value-plan-progress-summary-source-record-reference",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "source-record-reference-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "progress-summary",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Evidence reference links this structured value to the governed evidence-item record within Supplier joint-value plan Progress summary.",
                    "id": "evidence-id",
                    "label": "Evidence reference",
                    "nullable": true,
                    "referenceEntityId": "evidence-item",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the evidence reference in progress summary to the referenced evidence item via its canonical evidence item ID.",
                      "id": "supplier-joint-value-plan-progress-summary-evidence-reference",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "evidence-item-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "progress-summary",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  }
                ],
                "uniqueBy": [
                  "summary-item-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Innovation cases contributing to relationship objectives.",
            "exchangeScope": "internal",
            "id": "linked-innovation-ids",
            "introducedIn": "1.0.0",
            "label": "Linked innovation references",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "supplier-innovation-case",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-relationship-joint-value",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "restricted",
            "definition": "References to committed realisation outcomes; supplier or plan claims are excluded until validated.",
            "exchangeScope": "internal",
            "id": "validated-value-ids",
            "introducedIn": "1.0.0",
            "label": "Validated value references",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "value-realization-attribution",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-relationship-joint-value",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Timestamp from which the committed plan governs.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "effective-from",
            "introducedIn": "1.0.0",
            "label": "Effective from",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-relationship-joint-value",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Timestamp when the plan ceased to govern, if superseded or terminated.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "effective-to",
            "introducedIn": "1.0.0",
            "label": "Effective to",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "supplier-relationship-joint-value",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Primary relationship plan producer identifier.",
            "exchangeScope": "internal",
            "id": "source-system",
            "introducedIn": "1.0.0",
            "label": "Source system",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-relationship-joint-value",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Exact plan, action and collaboration schema bundle.",
            "exchangeScope": "internal",
            "id": "source-schema-version",
            "introducedIn": "1.0.0",
            "label": "Source schema version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-relationship-joint-value",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Latest observation timestamp among plan progress sources.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "observed-at",
            "introducedIn": "1.0.0",
            "label": "Observed at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-relationship-joint-value",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Objectives, plan, acknowledgement, action, progress, decision and outcome evidence.",
            "exchangeScope": "internal",
            "id": "evidence-ids",
            "introducedIn": "1.0.0",
            "label": "Evidence references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-relationship-joint-value",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Relationship planning and mission policy version.",
            "exchangeScope": "internal",
            "id": "policy-version-id",
            "introducedIn": "1.0.0",
            "label": "Policy version",
            "nullable": false,
            "referenceEntityId": "policy-version",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-relationship-joint-value",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Version of supplier-relationship-joint-value producing the plan.",
            "exchangeScope": "internal",
            "id": "workblock-version",
            "introducedIn": "1.0.0",
            "label": "Workblock version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-relationship-joint-value",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "supplier-joint-value-plan",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "business-key"
            ],
            "id": "supplier-joint-value-plan-by-business-key",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "supplier-party-id",
              "lifecycle-state"
            ],
            "id": "supplier-joint-value-plan-by-supplier-party-reference-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "segment-assignment-id"
            ],
            "id": "supplier-joint-value-plan-by-segment-assignment-reference",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "effective-from",
              "effective-to"
            ],
            "id": "supplier-joint-value-plan-by-effective-from-and-effective-to",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "control",
        "label": "Supplier joint-value plan",
        "lifecycle": [
          "draft",
          "proposed",
          "committed",
          "active",
          "at-risk",
          "superseded",
          "completed",
          "terminated"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "supplier-relationship-joint-value",
        "owningDomainWorkblockId": "supplier-performance-innovation-relationship",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Supplier joint-value plans",
        "primaryKey": "supplier-joint-value-plan-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the plan to the canonical supplier party.",
            "id": "supplier-joint-value-plan-belongs-to-party-joint-plan-with-supplier",
            "introducedIn": "1.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-joint-value-plan-belongs-to-party-joint-plan-with-supplier",
            "required": true,
            "sourceFieldId": "supplier-party-id",
            "targetEntityId": "party",
            "targetFieldId": "party-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Binds the plan to the governing relationship posture.",
            "id": "supplier-joint-value-plan-references-supplier-segment-assignment-joint-plan-under-segment",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "supplier-joint-value-plan-references-supplier-segment-assignment-joint-plan-under-segment",
            "required": true,
            "sourceFieldId": "segment-assignment-id",
            "targetEntityId": "supplier-segment-assignment",
            "targetFieldId": "supplier-segment-assignment-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links governed innovation work to relationship objectives.",
            "id": "supplier-joint-value-plan-references-supplier-innovation-case-joint-plan-links-innovation",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "supplier-joint-value-plan-references-supplier-innovation-case-joint-plan-links-innovation",
            "required": false,
            "sourceFieldId": "linked-innovation-ids",
            "targetEntityId": "supplier-innovation-case",
            "targetFieldId": "supplier-innovation-case-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the supplier joint-value plan to the referenced authority envelope.",
            "id": "supplier-joint-value-plan-governed-by-authority-envelope-supplier-joint-value-plan-authority-envelope-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "supplier-joint-value-plan-governed-by-authority-envelope-supplier-joint-value-plan-authority-envelope-id",
            "required": false,
            "sourceFieldId": "authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the supplier joint-value plan to the referenced value realisation attributions.",
            "id": "supplier-joint-value-plan-belongs-to-value-realization-attribution-supplier-joint-value-plan-validated-value-ids",
            "introducedIn": "2.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-joint-value-plan-belongs-to-value-realization-attribution-supplier-joint-value-plan-validated-value-ids",
            "required": false,
            "sourceFieldId": "validated-value-ids",
            "targetEntityId": "value-realization-attribution",
            "targetFieldId": "value-realization-attribution-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the supplier joint-value plan to the referenced evidence items.",
            "id": "supplier-joint-value-plan-evidenced-by-evidence-item-supplier-joint-value-plan-evidence-ids",
            "introducedIn": "2.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "supplier-joint-value-plan-evidenced-by-evidence-item-supplier-joint-value-plan-evidence-ids",
            "required": true,
            "sourceFieldId": "evidence-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the supplier joint-value plan to the referenced policy version.",
            "id": "supplier-joint-value-plan-governed-by-policy-version-id-supplier-joint-value-plan-policy-version-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "supplier-joint-value-plan-governed-by-policy-version-id-supplier-joint-value-plan-policy-version-id",
            "required": true,
            "sourceFieldId": "policy-version-id",
            "targetEntityId": "policy-version",
            "targetFieldId": "policy-version-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "supplier relationship plan",
          "joint value plan",
          "strategic supplier plan",
          "mutual commitment",
          "business review plan"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "What objectives and commitments are agreed with this supplier and by when?",
              "Which milestones are at risk and which validated outcomes have landed?"
            ],
            "retrievalTerms": [
              "supplier joint plan",
              "mutual commitment",
              "milestone",
              "governance cadence"
            ],
            "usage": "Maintain shared objectives, mutual commitments, milestones, governance and linked outcomes as an effective-dated plan; proposal and committed plan states stay distinct."
          },
          "introducedIn": "4.7.0",
          "semanticLabel": {
            "aliases": [
              "joint business plan",
              "relationship plan",
              "JBP"
            ],
            "concept": "joint-relationship-plan"
          },
          "standardsAlignment": [
            {
              "concept": "Collaborative business relationship management framework",
              "matchKind": "related",
              "standardId": "iso-44001"
            }
          ]
        },
        "sourceSystemRoleIds": [
          "system-of-record",
          "analytical-system",
          "collaboration-channel"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "system-of-record",
          "collaboration-channel"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "realization-reconciliation-attribution",
          "savings-initiative",
          "supplier-innovation-pipeline",
          "value-leakage-monitor",
          "value-portfolio-forecast"
        ],
        "definition": "A governed value opportunity and reproducible counterfactual baseline, preserving source scope, method, assumptions, target proposal and finance-committed validation as distinct states.",
        "domainWorkblockIds": [
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for the opportunity and baseline version lineage.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "value-opportunity-baseline-id",
            "introducedIn": "1.0.0",
            "label": "Value opportunity baseline ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Stable reference to the originating category, sourcing, contract, buying, supplier or analyst opportunity.",
            "exchangeScope": "internal",
            "id": "opportunity-reference",
            "introducedIn": "1.0.0",
            "label": "Opportunity reference",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Governed value category selecting baseline and attribution policy.",
            "enumValues": [
              "price",
              "demand",
              "process",
              "cash",
              "cost-avoidance",
              "rebate",
              "credit",
              "risk-adjusted",
              "revenue-or-innovation",
              "non-financial",
              "other"
            ],
            "exchangeScope": "mapped",
            "id": "opportunity-type",
            "introducedIn": "1.0.0",
            "label": "Opportunity type",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "extension",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "Value opportunity type is a GroundWorks extension whose evidence may reference UBL transactions.",
                "path": "ext:UBLExtensions/ext:UBLExtension",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "extension-required"
              },
              {
                "coverage": "extension",
                "direction": "bidirectional",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "Value opportunity type is a GroundWorks extension whose evidence may reference UBL transactions.",
                "path": "ext:UBLExtensions/ext:UBLExtension",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "extension-required"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Concise opportunity title suitable for portfolio search and work queues.",
            "exchangeScope": "internal",
            "id": "title",
            "introducedIn": "1.0.0",
            "label": "Title",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "personal",
            "definition": "Role or person accountable for qualification and baseline evidence.",
            "exchangeScope": "internal",
            "id": "owner-reference",
            "introducedIn": "1.0.0",
            "label": "Owner reference",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Categories included in the opportunity scope.",
            "exchangeScope": "mapped",
            "id": "category-ids",
            "introducedIn": "1.0.0",
            "label": "Category references",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "category",
            "required": false,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "conceptId": "commodity-classification",
                "coverage": "semantic",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "code-list",
                "path": "pinned commodity classification code",
                "releaseId": "unresolved-release",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "unspsc",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "confidential",
            "definition": "Supplier parties included in the opportunity scope.",
            "exchangeScope": "mapped",
            "id": "supplier-party-ids",
            "introducedIn": "1.0.0",
            "label": "Supplier party references",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "party",
            "required": false,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "bidirectional",
                "documentId": "common-library",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:Party/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "restricted",
            "definition": "Agreements defining expected terms, scope or value rights.",
            "exchangeScope": "mapped",
            "id": "contract-ids",
            "introducedIn": "1.0.0",
            "label": "Contract references",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "contract",
            "required": false,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "tender-contract",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "restricted",
            "definition": "Pinned transaction, finance, benchmark and operational source records used by the baseline.",
            "exchangeScope": "mapped",
            "id": "source-record-ids",
            "introducedIn": "1.0.0",
            "label": "Source record references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "source-record-reference",
            "required": true,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "Document and line identifiers are explicit alternatives; source type, namespace and reconciliation keys remain GroundWorks provenance.",
                "path": "cbc:ID|cac:InvoiceLine/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "Document and line identifiers are explicit alternatives; source type, namespace and reconciliation keys remain GroundWorks provenance.",
                "path": "cbc:ID|cac:OrderLine/cac:LineItem/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "receipt-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "Document and line identifiers are explicit alternatives; source type, namespace and reconciliation keys remain GroundWorks provenance.",
                "path": "cbc:ID|cac:ReceiptLine/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "remittance-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "Document and line identifiers are explicit alternatives; source type, namespace and reconciliation keys remain GroundWorks provenance.",
                "path": "cbc:ID|cac:RemittanceAdviceLine/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "confidential",
            "definition": "Inclusive start date of the historical or counterfactual baseline period.",
            "exchangeScope": "internal",
            "format": "date",
            "id": "baseline-period-start",
            "introducedIn": "1.0.0",
            "label": "Baseline period start",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "confidential",
            "definition": "Inclusive end date of the baseline period.",
            "exchangeScope": "internal",
            "format": "date",
            "id": "baseline-period-end",
            "introducedIn": "1.0.0",
            "label": "Baseline period end",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "confidential",
            "definition": "Optional start date for the intended outcome comparison period.",
            "exchangeScope": "internal",
            "format": "date",
            "id": "comparison-period-start",
            "introducedIn": "1.0.0",
            "label": "Comparison period start",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "confidential",
            "definition": "Optional end date for the intended outcome comparison period.",
            "exchangeScope": "internal",
            "format": "date",
            "id": "comparison-period-end",
            "introducedIn": "1.0.0",
            "label": "Comparison period end",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "internal",
            "definition": "Exact approved method, normalizations, adjustment rules and evidence requirements.",
            "exchangeScope": "internal",
            "id": "baseline-method-version",
            "introducedIn": "1.0.0",
            "label": "Baseline method version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Structured monetary or quantitative counterfactual value, currency, unit and calculation components. Currency is carried by currency-code when the value is monetary.",
            "exchangeScope": "mapped",
            "id": "baseline-amount",
            "introducedIn": "1.0.0",
            "label": "Baseline amount",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:LegalMonetaryTotal",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:AnticipatedMonetaryTotal",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Value is the decimal component carried within Value opportunity baseline Baseline amount; its classification and authority inherit from the owning field contract.",
                    "id": "value",
                    "label": "Value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "baseline-amount",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Value type records the governed state or type within Value opportunity baseline Baseline amount without treating absence, unknown and zero as equivalent.",
                    "id": "value-type",
                    "label": "Value type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "baseline-amount",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Unit code records the governed code within Value opportunity baseline Baseline amount without treating absence, unknown and zero as equivalent.",
                    "id": "unit-code",
                    "label": "Unit code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "baseline-amount",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Calculation components is the object component carried within Value opportunity baseline Baseline amount; its classification and authority inherit from the owning field contract.",
                    "id": "calculation-components",
                    "label": "Calculation components",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "baseline-amount",
                      "kind": "inherited-field"
                    },
                    "type": "object",
                    "valueSchema": {
                      "mode": "inline",
                      "schema": {
                        "additionalProperties": false,
                        "container": "object-list",
                        "properties": [
                          {
                            "classification": "restricted",
                            "definition": "Component ID is the string component carried within Calculation components; its classification and authority inherit from the owning field contract.",
                            "id": "component-id",
                            "label": "Component ID",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "baseline-amount",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Component type records the governed state or type within Calculation components without treating absence, unknown and zero as equivalent.",
                            "id": "component-type",
                            "label": "Component type",
                            "nullable": false,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": true,
                            "sourceAuthority": {
                              "id": "baseline-amount",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Value is the decimal component carried within Calculation components; its classification and authority inherit from the owning field contract.",
                            "id": "value",
                            "label": "Value",
                            "nullable": false,
                            "required": true,
                            "sourceAuthority": {
                              "id": "baseline-amount",
                              "kind": "inherited-field"
                            },
                            "type": "decimal"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Unit code records the governed code within Calculation components without treating absence, unknown and zero as equivalent.",
                            "id": "unit-code",
                            "label": "Unit code",
                            "nullable": true,
                            "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                            "required": false,
                            "sourceAuthority": {
                              "id": "baseline-amount",
                              "kind": "inherited-field"
                            },
                            "type": "string"
                          },
                          {
                            "classification": "restricted",
                            "definition": "Source record reference links this structured value to the governed source-record-reference record within Calculation components.",
                            "id": "source-record-id",
                            "label": "Source record reference",
                            "nullable": true,
                            "referenceEntityId": "source-record-reference",
                            "relationship": {
                              "cardinality": "many-to-one",
                              "definition": "Links the source record reference in calculation components to the referenced source record reference via its canonical source record reference ID.",
                              "id": "value-opportunity-baseline-baseline-amount-calculation-components-source-record-reference",
                              "introducedIn": "2.0.0",
                              "required": false,
                              "targetFieldId": "source-record-reference-id"
                            },
                            "required": false,
                            "sourceAuthority": {
                              "id": "baseline-amount",
                              "kind": "inherited-field"
                            },
                            "type": "reference"
                          }
                        ],
                        "uniqueBy": [
                          "component-id"
                        ]
                      },
                      "schemaVersion": "1.0.0"
                    }
                  },
                  {
                    "classification": "restricted",
                    "definition": "Calculation method version is the string component carried within Value opportunity baseline Baseline amount; its classification and authority inherit from the owning field contract.",
                    "id": "calculation-method-version",
                    "label": "Calculation method version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "baseline-amount",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Proposed or committed outcome target with currency, period and value type. Currency is carried by currency-code when the value is monetary.",
            "exchangeScope": "internal",
            "id": "target-amount",
            "introducedIn": "1.0.0",
            "label": "Target amount",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Value is the decimal component carried within Value opportunity baseline Target amount; its classification and authority inherit from the owning field contract.",
                    "id": "value",
                    "label": "Value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "target-amount",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Value type records the governed state or type within Value opportunity baseline Target amount without treating absence, unknown and zero as equivalent.",
                    "id": "value-type",
                    "label": "Value type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "target-amount",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Unit code records the governed code within Value opportunity baseline Target amount without treating absence, unknown and zero as equivalent.",
                    "id": "unit-code",
                    "label": "Unit code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "target-amount",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Period start is the date component carried within Value opportunity baseline Target amount; its classification and authority inherit from the owning field contract.",
                    "id": "period-start",
                    "label": "Period start",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "target-amount",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Period end is the date component carried within Value opportunity baseline Target amount; its classification and authority inherit from the owning field contract.",
                    "id": "period-end",
                    "label": "Period end",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "target-amount",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Target status records the governed state or type within Value opportunity baseline Target amount without treating absence, unknown and zero as equivalent.",
                    "id": "target-status",
                    "label": "Target status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "target-amount",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Calculation method version is the string component carried within Value opportunity baseline Target amount; its classification and authority inherit from the owning field contract.",
                    "id": "calculation-method-version",
                    "label": "Calculation method version",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "target-amount",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Current unvalidated expectation for delivery from the opportunity before initiative planning. Currency is carried by currency-code when the value is monetary.",
            "exchangeScope": "internal",
            "id": "forecast-amount",
            "introducedIn": "1.0.0",
            "label": "Forecast amount",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Value is the decimal component carried within Value opportunity baseline Forecast amount; its classification and authority inherit from the owning field contract.",
                    "id": "value",
                    "label": "Value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "forecast-amount",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Value type records the governed state or type within Value opportunity baseline Forecast amount without treating absence, unknown and zero as equivalent.",
                    "id": "value-type",
                    "label": "Value type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "forecast-amount",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Unit code records the governed code within Value opportunity baseline Forecast amount without treating absence, unknown and zero as equivalent.",
                    "id": "unit-code",
                    "label": "Unit code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "forecast-amount",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "As of date is the date component carried within Value opportunity baseline Forecast amount; its classification and authority inherit from the owning field contract.",
                    "id": "as-of-date",
                    "label": "As of date",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "forecast-amount",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Period start is the date component carried within Value opportunity baseline Forecast amount; its classification and authority inherit from the owning field contract.",
                    "id": "period-start",
                    "label": "Period start",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "forecast-amount",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Period end is the date component carried within Value opportunity baseline Forecast amount; its classification and authority inherit from the owning field contract.",
                    "id": "period-end",
                    "label": "Period end",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "forecast-amount",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Confidence band is the string component carried within Value opportunity baseline Forecast amount; its classification and authority inherit from the owning field contract.",
                    "id": "confidence-band",
                    "label": "Confidence band",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "forecast-amount",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "ISO 4217 alphabetic currency shared by monetary baseline, target and forecast values; null for non-monetary opportunities.",
            "exchangeScope": "mapped",
            "format": "ISO 4217 alpha-3",
            "id": "currency-code",
            "introducedIn": "2.0.0",
            "label": "Currency code",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "conceptId": "currency-code",
                "coverage": "exact",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "code-list",
                "path": "alphabetic code",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-4217",
                "transformation": "none"
              },
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "The document currency is an input to the baseline; selected amount leaves, normalization and conversion remain pinned in GroundWorks provenance.",
                "path": "cbc:DocumentCurrencyCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "The document currency is an input to the baseline; selected amount leaves, normalization and conversion remain pinned in GroundWorks provenance.",
                "path": "cbc:DocumentCurrencyCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Explicit scope, exclusions, quantity, mix, market, currency, timing and one-off assumptions.",
            "exchangeScope": "internal",
            "id": "assumptions",
            "introducedIn": "1.0.0",
            "label": "Assumptions",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Assumption ID is the string component carried within Value opportunity baseline Assumptions; its classification and authority inherit from the owning field contract.",
                    "id": "assumption-id",
                    "label": "Assumption ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "assumptions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Assumption type records the governed state or type within Value opportunity baseline Assumptions without treating absence, unknown and zero as equivalent.",
                    "id": "assumption-type",
                    "label": "Assumption type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "assumptions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Statement is the string component carried within Value opportunity baseline Assumptions; its classification and authority inherit from the owning field contract.",
                    "id": "statement",
                    "label": "Statement",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "assumptions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Applies to is the string component carried within Value opportunity baseline Assumptions; its classification and authority inherit from the owning field contract.",
                    "id": "applies-to",
                    "label": "Applies to",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "assumptions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Source reference is the string component carried within Value opportunity baseline Assumptions; its classification and authority inherit from the owning field contract.",
                    "id": "source-reference",
                    "label": "Source reference",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "assumptions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Effective from is the date component carried within Value opportunity baseline Assumptions; its classification and authority inherit from the owning field contract.",
                    "id": "effective-from",
                    "label": "Effective from",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "assumptions",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Effective to is the date component carried within Value opportunity baseline Assumptions; its classification and authority inherit from the owning field contract.",
                    "id": "effective-to",
                    "label": "Effective to",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "assumptions",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Status records the governed state or type within Value opportunity baseline Assumptions without treating absence, unknown and zero as equivalent.",
                    "id": "status",
                    "label": "Status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "assumptions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ],
                "uniqueBy": [
                  "assumption-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Uncommitted baseline, target, method and sensitivity recommendation linked to its source records and assumptions.",
            "exchangeScope": "internal",
            "id": "proposed-validation",
            "introducedIn": "1.0.0",
            "label": "Proposed validation",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Baseline value is the decimal component carried within Value opportunity baseline Proposed validation; its classification and authority inherit from the owning field contract.",
                    "id": "baseline-value",
                    "label": "Baseline value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-validation",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Target value is the decimal component carried within Value opportunity baseline Proposed validation; its classification and authority inherit from the owning field contract.",
                    "id": "target-value",
                    "label": "Target value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-validation",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Value type records the governed state or type within Value opportunity baseline Proposed validation without treating absence, unknown and zero as equivalent.",
                    "id": "value-type",
                    "label": "Value type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-validation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Method version is the string component carried within Value opportunity baseline Proposed validation; its classification and authority inherit from the owning field contract.",
                    "id": "method-version",
                    "label": "Method version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-validation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Scope description is the string component carried within Value opportunity baseline Proposed validation; its classification and authority inherit from the owning field contract.",
                    "id": "scope-description",
                    "label": "Scope description",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-validation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Governed treatment describing how the proposed value relates to budget, profit-and-loss, cash or a non-financial outcome.",
                    "enumValues": [
                      "profit-and-loss",
                      "budget",
                      "cash",
                      "working-capital",
                      "cost-avoidance",
                      "risk-adjusted",
                      "non-financial",
                      "not-applicable"
                    ],
                    "id": "value-recognition-treatment",
                    "label": "Value recognition treatment",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-validation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Sensitivity summary is the string component carried within Value opportunity baseline Proposed validation; its classification and authority inherit from the owning field contract.",
                    "id": "sensitivity-summary",
                    "label": "Sensitivity summary",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-validation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Proposed by is the string component carried within Value opportunity baseline Proposed validation; its classification and authority inherit from the owning field contract.",
                    "id": "proposed-by",
                    "label": "Proposed by",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-validation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Proposed at is the timestamp component carried within Value opportunity baseline Proposed validation; its classification and authority inherit from the owning field contract.",
                    "id": "proposed-at",
                    "label": "Proposed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-validation",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence references is the set carried within Value opportunity baseline Proposed validation; its owning field governs allowed values and interpretation.",
                    "format": "evidence-item references",
                    "id": "evidence-references",
                    "label": "Evidence references",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-validation",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Lifecycle of the current uncommitted proposal; authorised means permission to attempt the action, while execution and committed outcome remain separate.",
            "enumValues": [
              "none",
              "draft",
              "proposed",
              "stale",
              "authorised",
              "rejected",
              "withdrawn",
              "superseded"
            ],
            "exchangeScope": "internal",
            "id": "proposal-status",
            "introducedIn": "1.0.0",
            "label": "Proposal status",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Finance-authorised baseline, target, method, scope and accounting treatment.",
            "exchangeScope": "internal",
            "id": "committed-validation",
            "introducedIn": "1.0.0",
            "label": "Committed validation",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Baseline value is the decimal component carried within Value opportunity baseline Committed validation; its classification and authority inherit from the owning field contract.",
                    "id": "baseline-value",
                    "label": "Baseline value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-validation",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Target value is the decimal component carried within Value opportunity baseline Committed validation; its classification and authority inherit from the owning field contract.",
                    "id": "target-value",
                    "label": "Target value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-validation",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Value type records the governed state or type within Value opportunity baseline Committed validation without treating absence, unknown and zero as equivalent.",
                    "id": "value-type",
                    "label": "Value type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-validation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Method version is the string component carried within Value opportunity baseline Committed validation; its classification and authority inherit from the owning field contract.",
                    "id": "method-version",
                    "label": "Method version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-validation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Scope description is the string component carried within Value opportunity baseline Committed validation; its classification and authority inherit from the owning field contract.",
                    "id": "scope-description",
                    "label": "Scope description",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-validation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Governed treatment describing how the committed value relates to budget, profit-and-loss, cash or a non-financial outcome.",
                    "enumValues": [
                      "profit-and-loss",
                      "budget",
                      "cash",
                      "working-capital",
                      "cost-avoidance",
                      "risk-adjusted",
                      "non-financial",
                      "not-applicable"
                    ],
                    "id": "value-recognition-treatment",
                    "label": "Value recognition treatment",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-validation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Committed by is the string component carried within Value opportunity baseline Committed validation; its classification and authority inherit from the owning field contract.",
                    "id": "committed-by",
                    "label": "Committed by",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-validation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Committed at is the timestamp component carried within Value opportunity baseline Committed validation; its classification and authority inherit from the owning field contract.",
                    "id": "committed-at",
                    "label": "Committed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-validation",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Effective from is the date component carried within Value opportunity baseline Committed validation; its classification and authority inherit from the owning field contract.",
                    "id": "effective-from",
                    "label": "Effective from",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-validation",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence references is the set carried within Value opportunity baseline Committed validation; its owning field governs allowed values and interpretation.",
                    "format": "evidence-item references",
                    "id": "evidence-references",
                    "label": "Evidence references",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-validation",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Authority permitting routine or explicit finance validation.",
            "exchangeScope": "internal",
            "id": "authority-envelope-id",
            "introducedIn": "1.0.0",
            "label": "Authority envelope reference",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Primary opportunity or baseline producer identifier.",
            "exchangeScope": "internal",
            "id": "source-system",
            "introducedIn": "1.0.0",
            "label": "Source system",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Exact source and normalization schema bundle.",
            "exchangeScope": "internal",
            "id": "source-schema-version",
            "introducedIn": "1.0.0",
            "label": "Source schema version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Latest observation timestamp among baseline sources.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "observed-at",
            "introducedIn": "1.0.0",
            "label": "Observed at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Source, method, normalization, overlap, proposal and finance validation evidence.",
            "exchangeScope": "internal",
            "id": "evidence-ids",
            "introducedIn": "1.0.0",
            "label": "Evidence references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Opportunity qualification and baseline policy version.",
            "exchangeScope": "internal",
            "id": "policy-version-id",
            "introducedIn": "1.0.0",
            "label": "Policy version",
            "nullable": false,
            "referenceEntityId": "policy-version",
            "required": true,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Version of value-opportunity-baseline producing the record.",
            "exchangeScope": "internal",
            "id": "workblock-version",
            "introducedIn": "1.0.0",
            "label": "Workblock version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Shared governed decision record that carries authority, rationale and evidence for this domain decision.",
            "exchangeScope": "unmapped",
            "id": "governance-decision-id",
            "introducedIn": "4.0.0",
            "label": "Governance decision ID",
            "nullable": true,
            "referenceEntityId": "decision",
            "required": false,
            "sourceAuthority": {
              "id": "value-opportunity-baseline",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "value-opportunity-baseline",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "business-key"
            ],
            "id": "value-opportunity-baseline-by-business-key",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "opportunity-reference"
            ],
            "id": "value-opportunity-baseline-by-opportunity-reference",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "owner-reference",
              "lifecycle-state"
            ],
            "id": "value-opportunity-baseline-by-owner-reference-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "category-ids"
            ],
            "id": "value-opportunity-baseline-by-category-references",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "supplier-party-ids"
            ],
            "id": "value-opportunity-baseline-by-supplier-party-references",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "decision",
        "label": "Value opportunity baseline",
        "lifecycle": [
          "identified",
          "qualifying",
          "proposed",
          "validated",
          "rejected",
          "expired",
          "superseded",
          "withdrawn"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "value-opportunity-baseline",
        "owningDomainWorkblockId": "value-realization-savings",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Value opportunity baselines",
        "primaryKey": "value-opportunity-baseline-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-many",
            "definition": "Links the value opportunity baseline to the referenced categories.",
            "id": "value-opportunity-baseline-classified-as-category-value-opportunity-baseline-category-ids",
            "introducedIn": "2.0.0",
            "predicate": "classified-as",
            "qualifiedId": "value-opportunity-baseline-classified-as-category-value-opportunity-baseline-category-ids",
            "required": false,
            "sourceFieldId": "category-ids",
            "targetEntityId": "category",
            "targetFieldId": "category-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the value opportunity baseline to the referenced parties.",
            "id": "value-opportunity-baseline-belongs-to-party-value-opportunity-baseline-supplier-party-ids",
            "introducedIn": "2.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "value-opportunity-baseline-belongs-to-party-value-opportunity-baseline-supplier-party-ids",
            "required": false,
            "sourceFieldId": "supplier-party-ids",
            "targetEntityId": "party",
            "targetFieldId": "party-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the value opportunity baseline to the referenced contracts.",
            "id": "value-opportunity-baseline-belongs-to-contract-value-opportunity-baseline-contract-ids",
            "introducedIn": "2.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "value-opportunity-baseline-belongs-to-contract-value-opportunity-baseline-contract-ids",
            "required": false,
            "sourceFieldId": "contract-ids",
            "targetEntityId": "contract",
            "targetFieldId": "contract-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the value opportunity baseline to the referenced source record references.",
            "id": "value-opportunity-baseline-evidenced-by-source-record-id-value-opportunity-baseline-source-record-ids",
            "introducedIn": "2.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "value-opportunity-baseline-evidenced-by-source-record-id-value-opportunity-baseline-source-record-ids",
            "required": true,
            "sourceFieldId": "source-record-ids",
            "targetEntityId": "source-record-reference",
            "targetFieldId": "source-record-reference-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the value opportunity baseline to the referenced authority envelope.",
            "id": "value-opportunity-baseline-governed-by-authority-envelope-value-opportunity-baseline-authority-envelope-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "value-opportunity-baseline-governed-by-authority-envelope-value-opportunity-baseline-authority-envelope-id",
            "required": false,
            "sourceFieldId": "authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the value opportunity baseline to the referenced evidence items.",
            "id": "value-opportunity-baseline-evidenced-by-evidence-item-value-opportunity-baseline-evidence-ids",
            "introducedIn": "2.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "value-opportunity-baseline-evidenced-by-evidence-item-value-opportunity-baseline-evidence-ids",
            "required": true,
            "sourceFieldId": "evidence-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the value opportunity baseline to the referenced policy version.",
            "id": "value-opportunity-baseline-governed-by-policy-version-id-value-opportunity-baseline-policy-version-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "value-opportunity-baseline-governed-by-policy-version-id-value-opportunity-baseline-policy-version-id",
            "required": true,
            "sourceFieldId": "policy-version-id",
            "targetEntityId": "policy-version",
            "targetFieldId": "policy-version-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Shared governed decision for this domain outcome.",
            "id": "value-opportunity-baseline-governed-by-decision-value-opportunity-baseline-governance-decision",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "value-opportunity-baseline-governed-by-decision-value-opportunity-baseline-governance-decision",
            "required": false,
            "sourceFieldId": "governance-decision-id",
            "targetEntityId": "decision",
            "targetFieldId": "decision-id"
          }
        ],
        "retentionClass": "financial",
        "searchTerms": [
          "value opportunity",
          "savings baseline",
          "counterfactual",
          "value target",
          "benefit baseline"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "What counterfactual and method underpin this value claim?",
              "Has finance committed the baseline or is it still a proposal?"
            ],
            "retrievalTerms": [
              "baseline",
              "counterfactual",
              "savings methodology",
              "should-cost"
            ],
            "usage": "Fix the source scope, method, assumptions and counterfactual before claiming value; the target proposal and finance-committed validation are distinct states on the baseline."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "savings baseline",
              "counterfactual baseline",
              "opportunity baseline"
            ],
            "concept": "value-baseline",
            "doNotConfuseWith": [
              {
                "distinction": "The baseline fixes the reproducible counterfactual; the initiative is the owned delivery vehicle that commits to move against it.",
                "targetEntityId": "savings-initiative-record"
              }
            ]
          }
        },
        "sourceSystemRoleIds": [
          "analytical-system",
          "system-of-record",
          "execution-system",
          "evidence-source"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "analytical-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "realization-reconciliation-attribution",
          "value-leakage-monitor",
          "value-opportunity-baseline",
          "value-portfolio-forecast"
        ],
        "definition": "A governed delivery initiative connecting a committed value baseline to an owned plan, milestones, dependencies, forecasts, leakage, validated realisation and closure evidence.",
        "domainWorkblockIds": [
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "confidential",
            "definition": "Stable identifier for the initiative across plan versions.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "savings-initiative-record-id",
            "introducedIn": "1.0.0",
            "label": "Savings initiative ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "restricted",
            "definition": "Committed baseline and measurement contract governing the initiative.",
            "exchangeScope": "internal",
            "id": "value-opportunity-baseline-id",
            "introducedIn": "1.0.0",
            "label": "Value opportunity baseline ID",
            "nullable": false,
            "referenceEntityId": "value-opportunity-baseline",
            "required": true,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Concise initiative title suitable for portfolio search and work queues.",
            "exchangeScope": "internal",
            "id": "title",
            "introducedIn": "1.0.0",
            "label": "Title",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "personal",
            "definition": "Role or person accountable for initiative delivery.",
            "exchangeScope": "internal",
            "id": "owner-reference",
            "introducedIn": "1.0.0",
            "label": "Owner reference",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "personal",
            "definition": "Role or person holding material initiative decision authority.",
            "exchangeScope": "internal",
            "id": "sponsor-reference",
            "introducedIn": "1.0.0",
            "label": "Sponsor reference",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Governed value classification inherited from or refined within the committed baseline.",
            "enumValues": [
              "price",
              "demand",
              "process",
              "cash",
              "cost-avoidance",
              "rebate",
              "credit",
              "risk-adjusted",
              "revenue-or-innovation",
              "non-financial",
              "other"
            ],
            "exchangeScope": "internal",
            "id": "value-type",
            "introducedIn": "1.0.0",
            "label": "Value type",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Governed treatment describing how target, forecast and realisation relate to budget, profit-and-loss, cash or non-financial outcome.",
            "enumValues": [
              "profit-and-loss",
              "budget",
              "cash",
              "working-capital",
              "cost-avoidance",
              "risk-adjusted",
              "non-financial",
              "not-applicable"
            ],
            "exchangeScope": "internal",
            "id": "value-recognition-treatment",
            "introducedIn": "1.0.0",
            "label": "Value recognition treatment",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Committed initiative target with amount, currency, period and value type. Currency is carried by currency-code when the value is monetary.",
            "exchangeScope": "internal",
            "id": "target-value",
            "introducedIn": "1.0.0",
            "label": "Target value",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Value is the decimal component carried within Savings initiative Target value; its classification and authority inherit from the owning field contract.",
                    "id": "value",
                    "label": "Value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "target-value",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Governed value classification for the initiative target.",
                    "enumValues": [
                      "price",
                      "demand",
                      "process",
                      "cash",
                      "cost-avoidance",
                      "rebate",
                      "credit",
                      "risk-adjusted",
                      "revenue-or-innovation",
                      "non-financial",
                      "other"
                    ],
                    "id": "value-type",
                    "label": "Value type",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "target-value",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Period start is the date component carried within Savings initiative Target value; its classification and authority inherit from the owning field contract.",
                    "id": "period-start",
                    "label": "Period start",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "target-value",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Period end is the date component carried within Savings initiative Target value; its classification and authority inherit from the owning field contract.",
                    "id": "period-end",
                    "label": "Period end",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "target-value",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Unit code records the governed code within Savings initiative Target value without treating absence, unknown and zero as equivalent.",
                    "id": "unit-code",
                    "label": "Unit code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "target-value",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Commitment status records the governed state or type within Savings initiative Target value without treating absence, unknown and zero as equivalent.",
                    "id": "commitment-status",
                    "label": "Commitment status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "target-value",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Current expectation linked to its source records and assumptions, explicitly not validated realisation. Currency is carried by currency-code when the value is monetary.",
            "exchangeScope": "internal",
            "id": "forecast-value",
            "introducedIn": "1.0.0",
            "label": "Forecast value",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Value is the decimal component carried within Savings initiative Forecast value; its classification and authority inherit from the owning field contract.",
                    "id": "value",
                    "label": "Value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "forecast-value",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Governed value classification for the initiative forecast.",
                    "enumValues": [
                      "price",
                      "demand",
                      "process",
                      "cash",
                      "cost-avoidance",
                      "rebate",
                      "credit",
                      "risk-adjusted",
                      "revenue-or-innovation",
                      "non-financial",
                      "other"
                    ],
                    "id": "value-type",
                    "label": "Value type",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "forecast-value",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "As of date is the date component carried within Savings initiative Forecast value; its classification and authority inherit from the owning field contract.",
                    "id": "as-of-date",
                    "label": "As of date",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "forecast-value",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Period start is the date component carried within Savings initiative Forecast value; its classification and authority inherit from the owning field contract.",
                    "id": "period-start",
                    "label": "Period start",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "forecast-value",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Period end is the date component carried within Savings initiative Forecast value; its classification and authority inherit from the owning field contract.",
                    "id": "period-end",
                    "label": "Period end",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "forecast-value",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Unit code records the governed code within Savings initiative Forecast value without treating absence, unknown and zero as equivalent.",
                    "id": "unit-code",
                    "label": "Unit code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "forecast-value",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Confidence band is the string component carried within Savings initiative Forecast value; its classification and authority inherit from the owning field contract.",
                    "id": "confidence-band",
                    "label": "Confidence band",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "forecast-value",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Sum of committed, reconciled attribution records only. Currency is carried by currency-code when the value is monetary.",
            "exchangeScope": "internal",
            "id": "validated-realization",
            "introducedIn": "1.0.0",
            "label": "Validated realisation",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Value is the decimal component carried within Savings initiative Validated realisation; its classification and authority inherit from the owning field contract.",
                    "id": "value",
                    "label": "Value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "validated-realization",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Governed value classification for the validated realisation.",
                    "enumValues": [
                      "price",
                      "demand",
                      "process",
                      "cash",
                      "cost-avoidance",
                      "rebate",
                      "credit",
                      "risk-adjusted",
                      "revenue-or-innovation",
                      "non-financial",
                      "other"
                    ],
                    "id": "value-type",
                    "label": "Value type",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "validated-realization",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Period start is the date component carried within Savings initiative Validated realisation; its classification and authority inherit from the owning field contract.",
                    "id": "period-start",
                    "label": "Period start",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "validated-realization",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Period end is the date component carried within Savings initiative Validated realisation; its classification and authority inherit from the owning field contract.",
                    "id": "period-end",
                    "label": "Period end",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "validated-realization",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Attribution references is the set carried within Savings initiative Validated realisation; its owning field governs allowed values and interpretation.",
                    "format": "value-realization-attribution references",
                    "id": "attribution-references",
                    "label": "Attribution references",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "validated-realization",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Reconciled at is the timestamp component carried within Savings initiative Validated realisation; its classification and authority inherit from the owning field contract.",
                    "id": "reconciled-at",
                    "label": "Reconciled at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "validated-realization",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Unit code records the governed code within Savings initiative Validated realisation without treating absence, unknown and zero as equivalent.",
                    "id": "unit-code",
                    "label": "Unit code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "validated-realization",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Current detected, accepted and recovered leakage measures kept separate from realisation. Currency is carried by currency-code when the value is monetary.",
            "exchangeScope": "internal",
            "id": "leakage-value",
            "introducedIn": "1.0.0",
            "label": "Leakage value",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Detected value is the decimal component carried within Savings initiative Leakage value; its classification and authority inherit from the owning field contract.",
                    "id": "detected-value",
                    "label": "Detected value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "leakage-value",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Accepted value is the decimal component carried within Savings initiative Leakage value; its classification and authority inherit from the owning field contract.",
                    "id": "accepted-value",
                    "label": "Accepted value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "leakage-value",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Recovered value is the decimal component carried within Savings initiative Leakage value; its classification and authority inherit from the owning field contract.",
                    "id": "recovered-value",
                    "label": "Recovered value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "leakage-value",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Residual value is the decimal component carried within Savings initiative Leakage value; its classification and authority inherit from the owning field contract.",
                    "id": "residual-value",
                    "label": "Residual value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "leakage-value",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "As of date is the date component carried within Savings initiative Leakage value; its classification and authority inherit from the owning field contract.",
                    "id": "as-of-date",
                    "label": "As of date",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "leakage-value",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Unit code records the governed code within Savings initiative Leakage value without treating absence, unknown and zero as equivalent.",
                    "id": "unit-code",
                    "label": "Unit code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "leakage-value",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Finding references is the set carried within Savings initiative Leakage value; its owning field governs allowed values and interpretation.",
                    "format": "value-leakage-finding references",
                    "id": "finding-references",
                    "label": "Finding references",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "leakage-value",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "ISO 4217 reporting currency for initiative portfolio measures.",
            "exchangeScope": "mapped",
            "format": "iso-4217-alpha",
            "id": "currency-code",
            "introducedIn": "1.0.0",
            "label": "Currency code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "conceptId": "currency-code",
                "coverage": "exact",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "code-list",
                "path": "alphabetic code",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-4217",
                "transformation": "none"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Exact realisation and forecast method contract inherited from the baseline or committed plan.",
            "exchangeScope": "internal",
            "id": "measurement-method-version",
            "introducedIn": "1.0.0",
            "label": "Measurement method version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Versioned milestones, measures, owners, due dates, dependencies and completion evidence.",
            "exchangeScope": "internal",
            "id": "milestone-plan",
            "introducedIn": "1.0.0",
            "label": "Milestone plan",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Milestone ID is the string component carried within Savings initiative Milestone plan; its classification and authority inherit from the owning field contract.",
                    "id": "milestone-id",
                    "label": "Milestone ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "milestone-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Title is the string component carried within Savings initiative Milestone plan; its classification and authority inherit from the owning field contract.",
                    "id": "title",
                    "label": "Title",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "milestone-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Owner reference is the string component carried within Savings initiative Milestone plan; its classification and authority inherit from the owning field contract.",
                    "id": "owner-reference",
                    "label": "Owner reference",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "milestone-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Due date is the date component carried within Savings initiative Milestone plan; its classification and authority inherit from the owning field contract.",
                    "id": "due-date",
                    "label": "Due date",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "milestone-plan",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Dependency ids is the set carried within Savings initiative Milestone plan; its owning field governs allowed values and interpretation.",
                    "id": "dependency-ids",
                    "label": "Dependency ids",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "milestone-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Measure codes is the set carried within Savings initiative Milestone plan; its owning field governs allowed values and interpretation.",
                    "id": "measure-codes",
                    "label": "Measure codes",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "milestone-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Completion criteria is the string component carried within Savings initiative Milestone plan; its classification and authority inherit from the owning field contract.",
                    "id": "completion-criteria",
                    "label": "Completion criteria",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "milestone-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Status records the governed state or type within Savings initiative Milestone plan without treating absence, unknown and zero as equivalent.",
                    "id": "status",
                    "label": "Status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "milestone-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Evidence references is the set carried within Savings initiative Milestone plan; its owning field governs allowed values and interpretation.",
                    "format": "evidence-item references",
                    "id": "evidence-references",
                    "label": "Evidence references",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "milestone-plan",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  }
                ],
                "uniqueBy": [
                  "milestone-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "Typed references to domain work, decisions, integrations and external conditions required for delivery.",
            "exchangeScope": "internal",
            "id": "dependency-ids",
            "introducedIn": "1.0.0",
            "label": "Dependency references",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "savings-initiative-record",
            "required": false,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "restricted",
            "definition": "Uncommitted change to scope, milestones, forecast, timing or action sequence.",
            "exchangeScope": "internal",
            "id": "proposed-plan-change",
            "introducedIn": "1.0.0",
            "label": "Proposed plan change",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Change ID is the string component carried within Savings initiative Proposed plan change; its classification and authority inherit from the owning field contract.",
                    "id": "change-id",
                    "label": "Change ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-plan-change",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Change type records the governed state or type within Savings initiative Proposed plan change without treating absence, unknown and zero as equivalent.",
                    "id": "change-type",
                    "label": "Change type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-plan-change",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Scope summary is the string component carried within Savings initiative Proposed plan change; its classification and authority inherit from the owning field contract.",
                    "id": "scope-summary",
                    "label": "Scope summary",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-plan-change",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Milestone changes is the set carried within Savings initiative Proposed plan change; its owning field governs allowed values and interpretation.",
                    "id": "milestone-changes",
                    "label": "Milestone changes",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-plan-change",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Forecast value is the decimal component carried within Savings initiative Proposed plan change; its classification and authority inherit from the owning field contract.",
                    "id": "forecast-value",
                    "label": "Forecast value",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-plan-change",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Effective date is the date component carried within Savings initiative Proposed plan change; its classification and authority inherit from the owning field contract.",
                    "id": "effective-date",
                    "label": "Effective date",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-plan-change",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Rationale is the string component carried within Savings initiative Proposed plan change; its classification and authority inherit from the owning field contract.",
                    "id": "rationale",
                    "label": "Rationale",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-plan-change",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Proposed by is the string component carried within Savings initiative Proposed plan change; its classification and authority inherit from the owning field contract.",
                    "id": "proposed-by",
                    "label": "Proposed by",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-plan-change",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Proposed at is the timestamp component carried within Savings initiative Proposed plan change; its classification and authority inherit from the owning field contract.",
                    "id": "proposed-at",
                    "label": "Proposed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-plan-change",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Lifecycle of the current uncommitted proposal; authorised means permission to attempt the action, while execution and committed outcome remain separate.",
            "enumValues": [
              "none",
              "draft",
              "proposed",
              "stale",
              "authorised",
              "rejected",
              "withdrawn",
              "superseded"
            ],
            "exchangeScope": "internal",
            "id": "proposal-status",
            "introducedIn": "1.0.0",
            "label": "Proposal status",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Semantic version and content hash of the current authorised initiative plan.",
            "exchangeScope": "internal",
            "id": "committed-plan-version",
            "introducedIn": "1.0.0",
            "label": "Committed plan version",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Authority envelope permitting initiative commitment and mission actions.",
            "exchangeScope": "internal",
            "id": "authority-envelope-id",
            "introducedIn": "1.0.0",
            "label": "Authority envelope reference",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Date initiative delivery begins under the committed plan.",
            "exchangeScope": "internal",
            "format": "date",
            "id": "start-date",
            "introducedIn": "1.0.0",
            "label": "Start date",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "internal",
            "definition": "Current committed target date for delivery and outcome validation.",
            "exchangeScope": "internal",
            "format": "date",
            "id": "target-completion-date",
            "introducedIn": "1.0.0",
            "label": "Target completion date",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "internal",
            "definition": "Timestamp when closure criteria and finance reconciliation were committed.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "closed-at",
            "introducedIn": "1.0.0",
            "label": "Closed at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Current operating status, including blocked and stale distinctions within the lifecycle stage.",
            "enumValues": [
              "active",
              "attention",
              "blocked",
              "stale",
              "closed",
              "superseded"
            ],
            "exchangeScope": "internal",
            "id": "attention-status",
            "introducedIn": "1.0.0",
            "label": "Status",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Primary initiative producer identifier.",
            "exchangeScope": "internal",
            "id": "source-system",
            "introducedIn": "1.0.0",
            "label": "Source system",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Exact plan and domain-event schema bundle.",
            "exchangeScope": "internal",
            "id": "source-schema-version",
            "introducedIn": "1.0.0",
            "label": "Source schema version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Latest observation timestamp among initiative progress sources.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "observed-at",
            "introducedIn": "1.0.0",
            "label": "Observed at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Baseline, plan, action, milestone, forecast, leakage, attribution and closure evidence.",
            "exchangeScope": "internal",
            "id": "evidence-ids",
            "introducedIn": "1.0.0",
            "label": "Evidence references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Initiative and mission governance policy version.",
            "exchangeScope": "internal",
            "id": "policy-version-id",
            "introducedIn": "1.0.0",
            "label": "Policy version",
            "nullable": false,
            "referenceEntityId": "policy-version",
            "required": true,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Version of savings-initiative operating the record.",
            "exchangeScope": "internal",
            "id": "workblock-version",
            "introducedIn": "1.0.0",
            "label": "Workblock version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "savings-initiative",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "savings-initiative-record",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "business-key"
            ],
            "id": "savings-initiative-record-by-business-key",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "value-opportunity-baseline-id"
            ],
            "id": "savings-initiative-record-by-value-opportunity-baseline-id",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "owner-reference",
              "lifecycle-state"
            ],
            "id": "savings-initiative-record-by-owner-reference-and-stage",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "target-completion-date"
            ],
            "id": "savings-initiative-record-by-target-completion-date",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "freshness-status"
            ],
            "id": "savings-initiative-record-by-freshness-status",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "case",
        "label": "Savings initiative",
        "lifecycle": [
          "identified",
          "validated",
          "committed",
          "in-delivery",
          "at-risk",
          "realised",
          "stopped",
          "closed",
          "superseded"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "savings-initiative",
        "owningDomainWorkblockId": "value-realization-savings",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Savings initiatives",
        "primaryKey": "savings-initiative-record-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Binds the delivery initiative to its committed measurement contract.",
            "id": "savings-initiative-record-references-value-opportunity-baseline-initiative-from-baseline",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "savings-initiative-record-references-value-opportunity-baseline-initiative-from-baseline",
            "required": true,
            "sourceFieldId": "value-opportunity-baseline-id",
            "targetEntityId": "value-opportunity-baseline",
            "targetFieldId": "value-opportunity-baseline-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the savings initiative to the referenced savings initiatives.",
            "id": "savings-initiative-record-references-savings-initiative-record-savings-initiative-record-dependency-ids",
            "introducedIn": "2.0.0",
            "predicate": "references",
            "qualifiedId": "savings-initiative-record-references-savings-initiative-record-savings-initiative-record-dependency-ids",
            "required": false,
            "sourceFieldId": "dependency-ids",
            "targetEntityId": "savings-initiative-record",
            "targetFieldId": "savings-initiative-record-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the savings initiative to the referenced authority envelope.",
            "id": "savings-initiative-record-governed-by-authority-envelope-savings-initiative-record-authority-envelope-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "savings-initiative-record-governed-by-authority-envelope-savings-initiative-record-authority-envelope-id",
            "required": false,
            "sourceFieldId": "authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the savings initiative to the referenced evidence items.",
            "id": "savings-initiative-record-evidenced-by-evidence-item-savings-initiative-record-evidence-ids",
            "introducedIn": "2.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "savings-initiative-record-evidenced-by-evidence-item-savings-initiative-record-evidence-ids",
            "required": true,
            "sourceFieldId": "evidence-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the savings initiative to the referenced policy version.",
            "id": "savings-initiative-record-governed-by-policy-version-id-savings-initiative-record-policy-version-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "savings-initiative-record-governed-by-policy-version-id-savings-initiative-record-policy-version-id",
            "required": true,
            "sourceFieldId": "policy-version-id",
            "targetEntityId": "policy-version",
            "targetFieldId": "policy-version-id"
          }
        ],
        "retentionClass": "financial",
        "searchTerms": [
          "savings initiative",
          "value initiative",
          "benefit plan",
          "cost reduction",
          "value delivery"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Which initiatives deliver against this baseline and what is their forecast?",
              "What realisation has been validated and what leakage was found?"
            ],
            "retrievalTerms": [
              "initiative",
              "savings pipeline",
              "delivery plan",
              "milestone"
            ],
            "usage": "Connect a committed baseline to an owned plan, milestones, dependencies, forecasts, leakage, validated realisation and closure evidence; an initiative without a committed baseline cannot claim value."
          },
          "introducedIn": "4.7.0",
          "semanticLabel": {
            "aliases": [
              "value project",
              "cost-reduction initiative"
            ],
            "concept": "value-delivery-initiative"
          }
        },
        "sourceSystemRoleIds": [
          "analytical-system",
          "collaboration-channel",
          "system-of-record",
          "execution-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "analytical-system",
          "collaboration-channel"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "savings-initiative",
          "value-leakage-monitor",
          "value-portfolio-forecast"
        ],
        "definition": "A reproducible period reconciliation that joins a committed baseline to actual evidence, explicit adjustments and overlap controls, keeping the attribution proposal separate from the finance-committed disposition.",
        "domainWorkblockIds": [
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable identifier for the attribution calculation and decision version.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "value-realization-attribution-id",
            "introducedIn": "1.0.0",
            "label": "Value realisation attribution ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "realization-reconciliation-attribution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "restricted",
            "definition": "Initiative receiving the proposed or committed attribution.",
            "exchangeScope": "internal",
            "id": "savings-initiative-id",
            "introducedIn": "1.0.0",
            "label": "Savings initiative ID",
            "nullable": false,
            "referenceEntityId": "savings-initiative-record",
            "required": true,
            "sourceAuthority": {
              "id": "realization-reconciliation-attribution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Committed counterfactual baseline used in the calculation.",
            "exchangeScope": "internal",
            "id": "value-opportunity-baseline-id",
            "introducedIn": "1.0.0",
            "label": "Value opportunity baseline ID",
            "nullable": false,
            "referenceEntityId": "value-opportunity-baseline",
            "required": true,
            "sourceAuthority": {
              "id": "realization-reconciliation-attribution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Inclusive start date of the reconciled period.",
            "exchangeScope": "internal",
            "format": "date",
            "id": "attribution-period-start",
            "introducedIn": "1.0.0",
            "label": "Attribution period start",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "realization-reconciliation-attribution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "confidential",
            "definition": "Inclusive end date of the reconciled period.",
            "exchangeScope": "internal",
            "format": "date",
            "id": "attribution-period-end",
            "introducedIn": "1.0.0",
            "label": "Attribution period end",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "realization-reconciliation-attribution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "restricted",
            "definition": "Pinned transaction, finance and operational records admitted as actual evidence.",
            "exchangeScope": "mapped",
            "id": "actual-source-record-ids",
            "introducedIn": "1.0.0",
            "label": "Actual source record references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "source-record-reference",
            "required": true,
            "sourceAuthority": {
              "id": "realization-reconciliation-attribution",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "Document and line identifiers are explicit alternatives; source type, namespace and reconciliation keys remain GroundWorks provenance.",
                "path": "cbc:ID|cac:InvoiceLine/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "Document and line identifiers are explicit alternatives; source type, namespace and reconciliation keys remain GroundWorks provenance.",
                "path": "cbc:ID|cac:OrderLine/cac:LineItem/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "receipt-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "Document and line identifiers are explicit alternatives; source type, namespace and reconciliation keys remain GroundWorks provenance.",
                "path": "cbc:ID|cac:ReceiptLine/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "remittance-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "Document and line identifiers are explicit alternatives; source type, namespace and reconciliation keys remain GroundWorks provenance.",
                "path": "cbc:ID|cac:RemittanceAdviceLine/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "restricted",
            "definition": "Structured observed amount, quantity or outcome before attribution adjustments. Currency is carried by currency-code when the value is monetary.",
            "exchangeScope": "mapped",
            "id": "actual-amount",
            "introducedIn": "1.0.0",
            "label": "Actual amount",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "realization-reconciliation-attribution",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:LegalMonetaryTotal|cac:InvoiceLine/cbc:LineExtensionAmount",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Value is the decimal component carried within Value realisation attribution Actual amount; its classification and authority inherit from the owning field contract.",
                    "id": "value",
                    "label": "Value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "actual-amount",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Value type records the governed state or type within Value realisation attribution Actual amount without treating absence, unknown and zero as equivalent.",
                    "id": "value-type",
                    "label": "Value type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "actual-amount",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Unit code records the governed code within Value realisation attribution Actual amount without treating absence, unknown and zero as equivalent.",
                    "id": "unit-code",
                    "label": "Unit code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "actual-amount",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Period start is the date component carried within Value realisation attribution Actual amount; its classification and authority inherit from the owning field contract.",
                    "id": "period-start",
                    "label": "Period start",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "actual-amount",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Period end is the date component carried within Value realisation attribution Actual amount; its classification and authority inherit from the owning field contract.",
                    "id": "period-end",
                    "label": "Period end",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "actual-amount",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Source record references is the set carried within Value realisation attribution Actual amount; its owning field governs allowed values and interpretation.",
                    "format": "source-record-reference references",
                    "id": "source-record-references",
                    "label": "Source record references",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "actual-amount",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Normalization status records the governed state or type within Value realisation attribution Actual amount without treating absence, unknown and zero as equivalent.",
                    "id": "normalization-status",
                    "label": "Normalization status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "actual-amount",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Difference between normalised baseline and actual before attribution adjustments. Currency is carried by currency-code when the value is monetary.",
            "exchangeScope": "internal",
            "id": "gross-variance",
            "introducedIn": "1.0.0",
            "label": "Gross variance",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "realization-reconciliation-attribution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Baseline value is the decimal component carried within Value realisation attribution Gross variance; its classification and authority inherit from the owning field contract.",
                    "id": "baseline-value",
                    "label": "Baseline value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "gross-variance",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Actual value is the decimal component carried within Value realisation attribution Gross variance; its classification and authority inherit from the owning field contract.",
                    "id": "actual-value",
                    "label": "Actual value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "gross-variance",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Variance value is the decimal component carried within Value realisation attribution Gross variance; its classification and authority inherit from the owning field contract.",
                    "id": "variance-value",
                    "label": "Variance value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "gross-variance",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Value type records the governed state or type within Value realisation attribution Gross variance without treating absence, unknown and zero as equivalent.",
                    "id": "value-type",
                    "label": "Value type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "gross-variance",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Unit code records the governed code within Value realisation attribution Gross variance without treating absence, unknown and zero as equivalent.",
                    "id": "unit-code",
                    "label": "Unit code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "gross-variance",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Calculation method version is the string component carried within Value realisation attribution Gross variance; its classification and authority inherit from the owning field contract.",
                    "id": "calculation-method-version",
                    "label": "Calculation method version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "gross-variance",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Explicit volume, mix, market, currency, timing, one-off and other approved adjustments with source and rationale.",
            "exchangeScope": "internal",
            "id": "adjustments",
            "introducedIn": "1.0.0",
            "label": "Adjustments",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "realization-reconciliation-attribution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Adjustment ID is the string component carried within Value realisation attribution Adjustments; its classification and authority inherit from the owning field contract.",
                    "id": "adjustment-id",
                    "label": "Adjustment ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "adjustments",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Adjustment type records the governed state or type within Value realisation attribution Adjustments without treating absence, unknown and zero as equivalent.",
                    "id": "adjustment-type",
                    "label": "Adjustment type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "adjustments",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Amount is the decimal component carried within Value realisation attribution Adjustments; its classification and authority inherit from the owning field contract.",
                    "id": "amount",
                    "label": "Amount",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "adjustments",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Unit code records the governed code within Value realisation attribution Adjustments without treating absence, unknown and zero as equivalent.",
                    "id": "unit-code",
                    "label": "Unit code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "adjustments",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Rationale is the string component carried within Value realisation attribution Adjustments; its classification and authority inherit from the owning field contract.",
                    "id": "rationale",
                    "label": "Rationale",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "adjustments",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Source record reference links this structured value to the governed source-record-reference record within Value realisation attribution Adjustments.",
                    "id": "source-record-id",
                    "label": "Source record reference",
                    "nullable": true,
                    "referenceEntityId": "source-record-reference",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the source record reference in adjustments to the referenced source record reference via its canonical source record reference ID.",
                      "id": "value-realization-attribution-adjustments-source-record-reference",
                      "introducedIn": "2.0.0",
                      "required": false,
                      "targetFieldId": "source-record-reference-id"
                    },
                    "required": false,
                    "sourceAuthority": {
                      "id": "adjustments",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Approved by is the string component carried within Value realisation attribution Adjustments; its classification and authority inherit from the owning field contract.",
                    "id": "approved-by",
                    "label": "Approved by",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "adjustments",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Approval status records the governed state or type within Value realisation attribution Adjustments without treating absence, unknown and zero as equivalent.",
                    "id": "approval-status",
                    "label": "Approval status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "adjustments",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ],
                "uniqueBy": [
                  "adjustment-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Calculated amount eligible for the proposed or committed initiative attribution after adjustments and overlap control. Currency is carried by currency-code when the value is monetary.",
            "exchangeScope": "internal",
            "id": "attributed-amount",
            "introducedIn": "1.0.0",
            "label": "Attributed amount",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "realization-reconciliation-attribution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Gross variance value is the decimal component carried within Value realisation attribution Attributed amount; its classification and authority inherit from the owning field contract.",
                    "id": "gross-variance-value",
                    "label": "Gross variance value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "attributed-amount",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Total adjustment value is the decimal component carried within Value realisation attribution Attributed amount; its classification and authority inherit from the owning field contract.",
                    "id": "total-adjustment-value",
                    "label": "Total adjustment value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "attributed-amount",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Eligible value is the decimal component carried within Value realisation attribution Attributed amount; its classification and authority inherit from the owning field contract.",
                    "id": "eligible-value",
                    "label": "Eligible value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "attributed-amount",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Attributed value is the decimal component carried within Value realisation attribution Attributed amount; its classification and authority inherit from the owning field contract.",
                    "id": "attributed-value",
                    "label": "Attributed value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "attributed-amount",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Value type records the governed state or type within Value realisation attribution Attributed amount without treating absence, unknown and zero as equivalent.",
                    "id": "value-type",
                    "label": "Value type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "attributed-amount",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Unit code records the governed code within Value realisation attribution Attributed amount without treating absence, unknown and zero as equivalent.",
                    "id": "unit-code",
                    "label": "Unit code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "attributed-amount",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Attribution method version is the string component carried within Value realisation attribution Attributed amount; its classification and authority inherit from the owning field contract.",
                    "id": "attribution-method-version",
                    "label": "Attribution method version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "attributed-amount",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "ISO 4217 reporting currency for this attribution.",
            "exchangeScope": "mapped",
            "format": "iso-4217-alpha",
            "id": "currency-code",
            "introducedIn": "1.0.0",
            "label": "Currency code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "realization-reconciliation-attribution",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "conceptId": "currency-code",
                "coverage": "exact",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "code-list",
                "path": "alphabetic code",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-4217",
                "transformation": "none"
              },
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "The invoice document currency is an input; normalization, conversion and attribution remain GroundWorks data.",
                "path": "cbc:DocumentCurrencyCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Exact method for normalization, adjustment, allocation, overlap and rounding.",
            "exchangeScope": "internal",
            "id": "attribution-method-version",
            "introducedIn": "1.0.0",
            "label": "Attribution method version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "realization-reconciliation-attribution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Portfolio overlap result, related attribution references and unresolved conflicts.",
            "exchangeScope": "internal",
            "id": "double-count-check",
            "introducedIn": "1.0.0",
            "label": "Double-count check",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "realization-reconciliation-attribution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Result code records the governed code within Value realisation attribution Double-count check without treating absence, unknown and zero as equivalent.",
                    "id": "result-code",
                    "label": "Result code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "double-count-check",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Checked at is the timestamp component carried within Value realisation attribution Double-count check; its classification and authority inherit from the owning field contract.",
                    "id": "checked-at",
                    "label": "Checked at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "double-count-check",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Overlap value is the decimal component carried within Value realisation attribution Double-count check; its classification and authority inherit from the owning field contract.",
                    "id": "overlap-value",
                    "label": "Overlap value",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "double-count-check",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Related attribution references is the set carried within Value realisation attribution Double-count check; its owning field governs allowed values and interpretation.",
                    "format": "value-realization-attribution references",
                    "id": "related-attribution-references",
                    "label": "Related attribution references",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "double-count-check",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Unresolved conflicts is the set carried within Value realisation attribution Double-count check; its owning field governs allowed values and interpretation.",
                    "id": "unresolved-conflicts",
                    "label": "Unresolved conflicts",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "double-count-check",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Portfolio index version is the string component carried within Value realisation attribution Double-count check; its classification and authority inherit from the owning field contract.",
                    "id": "portfolio-index-version",
                    "label": "Portfolio index version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "double-count-check",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Reviewer reference is the string component carried within Value realisation attribution Double-count check; its classification and authority inherit from the owning field contract.",
                    "id": "reviewer-reference",
                    "label": "Reviewer reference",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "double-count-check",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Evidence sufficiency band expressed as governed words.",
            "enumValues": [
              "insufficient-or-conflicting",
              "usable-but-uncertain",
              "sufficient-and-deterministic",
              "validated-current-and-calibrated"
            ],
            "exchangeScope": "internal",
            "id": "confidence-band",
            "introducedIn": "1.0.0",
            "label": "Confidence band",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "realization-reconciliation-attribution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Uncommitted recommendation to validate, reject, defer or reallocate the calculated amount.",
            "exchangeScope": "internal",
            "id": "proposed-disposition",
            "introducedIn": "1.0.0",
            "label": "Proposed disposition",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "realization-reconciliation-attribution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Disposition code records the governed code within Value realisation attribution Proposed disposition without treating absence, unknown and zero as equivalent.",
                    "id": "disposition-code",
                    "label": "Disposition code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-disposition",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Proposed value is the decimal component carried within Value realisation attribution Proposed disposition; its classification and authority inherit from the owning field contract.",
                    "id": "proposed-value",
                    "label": "Proposed value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-disposition",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Value type records the governed state or type within Value realisation attribution Proposed disposition without treating absence, unknown and zero as equivalent.",
                    "id": "value-type",
                    "label": "Value type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-disposition",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Rationale is the string component carried within Value realisation attribution Proposed disposition; its classification and authority inherit from the owning field contract.",
                    "id": "rationale",
                    "label": "Rationale",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-disposition",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Allocation reference is the string component carried within Value realisation attribution Proposed disposition; its classification and authority inherit from the owning field contract.",
                    "id": "allocation-reference",
                    "label": "Allocation reference",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-disposition",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Proposed by is the string component carried within Value realisation attribution Proposed disposition; its classification and authority inherit from the owning field contract.",
                    "id": "proposed-by",
                    "label": "Proposed by",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-disposition",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Proposed at is the timestamp component carried within Value realisation attribution Proposed disposition; its classification and authority inherit from the owning field contract.",
                    "id": "proposed-at",
                    "label": "Proposed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-disposition",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Expires at is the timestamp component carried within Value realisation attribution Proposed disposition; its classification and authority inherit from the owning field contract.",
                    "id": "expires-at",
                    "label": "Expires at",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-disposition",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Lifecycle of the current uncommitted proposal; authorised means permission to attempt the action, while execution and committed outcome remain separate.",
            "enumValues": [
              "none",
              "draft",
              "proposed",
              "stale",
              "authorised",
              "rejected",
              "withdrawn",
              "superseded"
            ],
            "exchangeScope": "internal",
            "id": "proposal-status",
            "introducedIn": "1.0.0",
            "label": "Proposal status",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "realization-reconciliation-attribution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Finance-authorised value, rejection, deferral, reallocation or restatement.",
            "exchangeScope": "internal",
            "id": "committed-disposition",
            "introducedIn": "1.0.0",
            "label": "Committed disposition",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "realization-reconciliation-attribution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Disposition code records the governed code within Value realisation attribution Committed disposition without treating absence, unknown and zero as equivalent.",
                    "id": "disposition-code",
                    "label": "Disposition code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-disposition",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Committed value is the decimal component carried within Value realisation attribution Committed disposition; its classification and authority inherit from the owning field contract.",
                    "id": "committed-value",
                    "label": "Committed value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-disposition",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Value type records the governed state or type within Value realisation attribution Committed disposition without treating absence, unknown and zero as equivalent.",
                    "id": "value-type",
                    "label": "Value type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-disposition",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Rationale is the string component carried within Value realisation attribution Committed disposition; its classification and authority inherit from the owning field contract.",
                    "id": "rationale",
                    "label": "Rationale",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-disposition",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Allocation reference is the string component carried within Value realisation attribution Committed disposition; its classification and authority inherit from the owning field contract.",
                    "id": "allocation-reference",
                    "label": "Allocation reference",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "committed-disposition",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Committed by is the string component carried within Value realisation attribution Committed disposition; its classification and authority inherit from the owning field contract.",
                    "id": "committed-by",
                    "label": "Committed by",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-disposition",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Committed at is the timestamp component carried within Value realisation attribution Committed disposition; its classification and authority inherit from the owning field contract.",
                    "id": "committed-at",
                    "label": "Committed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-disposition",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Restatement of reference is the string component carried within Value realisation attribution Committed disposition; its classification and authority inherit from the owning field contract.",
                    "id": "restatement-of-reference",
                    "label": "Restatement of reference",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "committed-disposition",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Authority permitting the committed attribution disposition.",
            "exchangeScope": "internal",
            "id": "authority-envelope-id",
            "introducedIn": "1.0.0",
            "label": "Authority envelope reference",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "realization-reconciliation-attribution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Current actual matching, overlap and finance decision state.",
            "enumValues": [
              "unmatched",
              "partial",
              "matched",
              "conflict",
              "proposed",
              "committed",
              "rejected",
              "restated"
            ],
            "exchangeScope": "internal",
            "id": "reconciliation-status",
            "introducedIn": "1.0.0",
            "label": "Reconciliation status",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "realization-reconciliation-attribution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Timestamp when the attribution proposal completed.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "calculated-at",
            "introducedIn": "1.0.0",
            "label": "Calculated at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "realization-reconciliation-attribution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Primary attribution producer identifier.",
            "exchangeScope": "internal",
            "id": "source-system",
            "introducedIn": "1.0.0",
            "label": "Source system",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "realization-reconciliation-attribution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Exact actual-source and calculation schema bundle.",
            "exchangeScope": "internal",
            "id": "source-schema-version",
            "introducedIn": "1.0.0",
            "label": "Source schema version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "realization-reconciliation-attribution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Latest observation timestamp among matched actual sources.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "observed-at",
            "introducedIn": "1.0.0",
            "label": "Observed at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "realization-reconciliation-attribution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Baseline, actual, normalization, adjustment, overlap, proposal and finance decision evidence.",
            "exchangeScope": "internal",
            "id": "evidence-ids",
            "introducedIn": "1.0.0",
            "label": "Evidence references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "realization-reconciliation-attribution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Attribution and finance control policy version.",
            "exchangeScope": "internal",
            "id": "policy-version-id",
            "introducedIn": "1.0.0",
            "label": "Policy version",
            "nullable": false,
            "referenceEntityId": "policy-version",
            "required": true,
            "sourceAuthority": {
              "id": "realization-reconciliation-attribution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Version of realisation-reconciliation-attribution producing the record.",
            "exchangeScope": "internal",
            "id": "workblock-version",
            "introducedIn": "1.0.0",
            "label": "Workblock version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "realization-reconciliation-attribution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Shared governed decision record that carries authority, rationale and evidence for this domain decision.",
            "exchangeScope": "unmapped",
            "id": "governance-decision-id",
            "introducedIn": "4.0.0",
            "label": "Governance decision ID",
            "nullable": true,
            "referenceEntityId": "decision",
            "required": false,
            "sourceAuthority": {
              "id": "realization-reconciliation-attribution",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "value-realization-attribution",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "business-key"
            ],
            "id": "value-realization-attribution-by-business-key",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "savings-initiative-id",
              "attribution-period-end"
            ],
            "id": "value-realization-attribution-by-savings-initiative-id-and-attribution-period-end",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "reconciliation-status"
            ],
            "id": "value-realization-attribution-by-reconciliation-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "double-count-check"
            ],
            "id": "value-realization-attribution-by-double-count-check",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "freshness-status"
            ],
            "id": "value-realization-attribution-by-freshness-status",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "decision",
        "label": "Value realisation attribution",
        "lifecycle": [
          "calculating",
          "proposed",
          "conflict",
          "committed",
          "rejected",
          "restated",
          "superseded"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "realization-reconciliation-attribution",
        "owningDomainWorkblockId": "value-realization-savings",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Value realisation attributions",
        "primaryKey": "value-realization-attribution-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the attribution to its value initiative.",
            "id": "value-realization-attribution-references-savings-initiative-record-attribution-for-initiative",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "value-realization-attribution-references-savings-initiative-record-attribution-for-initiative",
            "required": true,
            "sourceFieldId": "savings-initiative-id",
            "targetEntityId": "savings-initiative-record",
            "targetFieldId": "savings-initiative-record-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Binds the calculation to the exact baseline contract.",
            "id": "value-realization-attribution-references-value-opportunity-baseline-attribution-against-baseline",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "value-realization-attribution-references-value-opportunity-baseline-attribution-against-baseline",
            "required": true,
            "sourceFieldId": "value-opportunity-baseline-id",
            "targetEntityId": "value-opportunity-baseline",
            "targetFieldId": "value-opportunity-baseline-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the value realisation attribution to the referenced source record references.",
            "id": "value-realization-attribution-evidenced-by-source-record-id-value-realization-attribution-actual-source-record-ids",
            "introducedIn": "2.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "value-realization-attribution-evidenced-by-source-record-id-value-realization-attribution-actual-source-record-ids",
            "required": true,
            "sourceFieldId": "actual-source-record-ids",
            "targetEntityId": "source-record-reference",
            "targetFieldId": "source-record-reference-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the value realisation attribution to the referenced authority envelope.",
            "id": "value-realization-attribution-governed-by-authority-envelope-value-realization-attribution-authority-envelope-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "value-realization-attribution-governed-by-authority-envelope-value-realization-attribution-authority-envelope-id",
            "required": false,
            "sourceFieldId": "authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the value realisation attribution to the referenced evidence items.",
            "id": "value-realization-attribution-evidenced-by-evidence-item-value-realization-attribution-evidence-ids",
            "introducedIn": "2.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "value-realization-attribution-evidenced-by-evidence-item-value-realization-attribution-evidence-ids",
            "required": true,
            "sourceFieldId": "evidence-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the value realisation attribution to the referenced policy version.",
            "id": "value-realization-attribution-governed-by-policy-version-id-value-realization-attribution-policy-version-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "value-realization-attribution-governed-by-policy-version-id-value-realization-attribution-policy-version-id",
            "required": true,
            "sourceFieldId": "policy-version-id",
            "targetEntityId": "policy-version",
            "targetFieldId": "policy-version-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Shared governed decision for this domain outcome.",
            "id": "value-realization-attribution-governed-by-decision-value-realization-attribution-governance-decision",
            "introducedIn": "4.0.0",
            "predicate": "governed-by",
            "qualifiedId": "value-realization-attribution-governed-by-decision-value-realization-attribution-governance-decision",
            "required": false,
            "sourceFieldId": "governance-decision-id",
            "targetEntityId": "decision",
            "targetFieldId": "decision-id"
          }
        ],
        "retentionClass": "financial",
        "searchTerms": [
          "realized savings",
          "value attribution",
          "benefit reconciliation",
          "actual savings",
          "double count"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "How much value was realised this period against the committed baseline?",
              "Which adjustments and overlap controls shaped the attribution?"
            ],
            "retrievalTerms": [
              "realised savings",
              "attribution",
              "overlap control",
              "period reconciliation"
            ],
            "usage": "Join a committed baseline to actual evidence with explicit adjustments and overlap controls per period; the attribution proposal stays separate from the committed attribution."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "savings attribution",
              "realisation reconciliation"
            ],
            "concept": "period-realisation-reconciliation",
            "doNotConfuseWith": [
              {
                "distinction": "Attribution reconciles what was realised against the baseline; a leakage finding is the case opened for an expected-versus-actual variance.",
                "targetEntityId": "value-leakage-finding"
              }
            ]
          }
        },
        "sourceSystemRoleIds": [
          "analytical-system",
          "system-of-record",
          "execution-system",
          "payment-or-settlement-rail"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": [
          "analytical-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "commit",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "realization-reconciliation-attribution",
          "savings-initiative",
          "value-portfolio-forecast"
        ],
        "definition": "A source-linked expected-versus-actual variance case carrying exposure, root cause, recovery proposal, authority, committed remediation and reconciled disposition.",
        "domainWorkblockIds": [
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable identifier for the leakage case.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "value-leakage-finding-id",
            "introducedIn": "1.0.0",
            "label": "Value leakage finding ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-leakage-monitor",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "restricted",
            "definition": "Optional initiative whose target or realisation is affected.",
            "exchangeScope": "internal",
            "id": "savings-initiative-id",
            "introducedIn": "1.0.0",
            "label": "Savings initiative ID",
            "nullable": true,
            "referenceEntityId": "savings-initiative-record",
            "required": false,
            "sourceAuthority": {
              "id": "value-leakage-monitor",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Governed expected-versus-actual variance category.",
            "enumValues": [
              "price",
              "quantity",
              "off-contract",
              "term",
              "rebate",
              "credit",
              "duplicate-charge",
              "unclaimed-entitlement",
              "payment-timing",
              "implementation-gap",
              "performance",
              "other"
            ],
            "exchangeScope": "mapped",
            "id": "leakage-type",
            "introducedIn": "1.0.0",
            "label": "Leakage type",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-leakage-monitor",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "extension",
                "direction": "bidirectional",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "Leakage is a GroundWorks extension referencing UBL transaction evidence.",
                "path": "ext:UBLExtensions/ext:UBLExtension",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "extension-required"
              },
              {
                "coverage": "extension",
                "direction": "bidirectional",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "Leakage is a GroundWorks extension referencing UBL transaction evidence.",
                "path": "ext:UBLExtensions/ext:UBLExtension",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "extension-required"
              },
              {
                "coverage": "extension",
                "direction": "bidirectional",
                "documentId": "credit-note",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "Leakage is a GroundWorks extension referencing UBL transaction evidence.",
                "path": "ext:UBLExtensions/ext:UBLExtension",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "extension-required"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Supplier party associated with the leakage, if applicable.",
            "exchangeScope": "mapped",
            "id": "supplier-party-id",
            "introducedIn": "1.0.0",
            "label": "Supplier party reference",
            "nullable": true,
            "referenceEntityId": "party",
            "required": false,
            "sourceAuthority": {
              "id": "value-leakage-monitor",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:AccountingSupplierParty/cac:Party/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:SellerSupplierParty/cac:Party/cac:PartyIdentification/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Category affected by the leakage.",
            "exchangeScope": "mapped",
            "id": "category-id",
            "introducedIn": "1.0.0",
            "label": "Category reference",
            "nullable": true,
            "referenceEntityId": "category",
            "required": false,
            "sourceAuthority": {
              "id": "value-leakage-monitor",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "conceptId": "commodity-classification",
                "coverage": "semantic",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "code-list",
                "path": "pinned commodity classification code",
                "releaseId": "unresolved-release",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "unspsc",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Agreement establishing the expected term or entitlement.",
            "exchangeScope": "mapped",
            "id": "contract-id",
            "introducedIn": "1.0.0",
            "label": "Contract reference",
            "nullable": true,
            "referenceEntityId": "contract",
            "required": false,
            "sourceAuthority": {
              "id": "value-leakage-monitor",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "tender-contract",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Pinned expected and actual transaction, performance or finance records.",
            "exchangeScope": "mapped",
            "id": "source-record-ids",
            "introducedIn": "1.0.0",
            "label": "Source record references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "source-record-reference",
            "required": true,
            "sourceAuthority": {
              "id": "value-leakage-monitor",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "Document and line identifiers are explicit alternatives; source type, namespace and reconciliation keys remain GroundWorks provenance.",
                "path": "cbc:ID|cac:InvoiceLine/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "credit-note",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "Document and line identifiers are explicit alternatives; source type, namespace and reconciliation keys remain GroundWorks provenance.",
                "path": "cbc:ID|cac:CreditNoteLine/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "Document and line identifiers are explicit alternatives; source type, namespace and reconciliation keys remain GroundWorks provenance.",
                "path": "cbc:ID|cac:OrderLine/cac:LineItem/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "receipt-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "Document and line identifiers are explicit alternatives; source type, namespace and reconciliation keys remain GroundWorks provenance.",
                "path": "cbc:ID|cac:ReceiptLine/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "remittance-advice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "Document and line identifiers are explicit alternatives; source type, namespace and reconciliation keys remain GroundWorks provenance.",
                "path": "cbc:ID|cac:RemittanceAdviceLine/cbc:ID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "reference-list"
          },
          {
            "classification": "restricted",
            "definition": "Structured policy, contract, baseline or entitlement expectation with amount, quantity, unit and period. Currency is carried by currency-code when the value is monetary.",
            "exchangeScope": "mapped",
            "id": "expected-value",
            "introducedIn": "1.0.0",
            "label": "Expected value",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-leakage-monitor",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "Expected value can originate from an order total or an awarded tender total; the comparison basis remains versioned GroundWorks data.",
                "path": "cac:AnticipatedMonetaryTotal",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "tender-contract",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "Expected value can originate from an order total or an awarded tender total; the comparison basis remains versioned GroundWorks data.",
                "path": "cac:TenderResult/cac:AwardedTenderedProject/cac:LegalMonetaryTotal",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Value is the decimal component carried within Value leakage finding Expected value; its classification and authority inherit from the owning field contract.",
                    "id": "value",
                    "label": "Value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "expected-value",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Value type records the governed state or type within Value leakage finding Expected value without treating absence, unknown and zero as equivalent.",
                    "id": "value-type",
                    "label": "Value type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "expected-value",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Unit code records the governed code within Value leakage finding Expected value without treating absence, unknown and zero as equivalent.",
                    "id": "unit-code",
                    "label": "Unit code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "expected-value",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Period start is the date component carried within Value leakage finding Expected value; its classification and authority inherit from the owning field contract.",
                    "id": "period-start",
                    "label": "Period start",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "expected-value",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Period end is the date component carried within Value leakage finding Expected value; its classification and authority inherit from the owning field contract.",
                    "id": "period-end",
                    "label": "Period end",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "expected-value",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Basis type records the governed state or type within Value leakage finding Expected value without treating absence, unknown and zero as equivalent.",
                    "id": "basis-type",
                    "label": "Basis type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "expected-value",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Basis reference is the string component carried within Value leakage finding Expected value; its classification and authority inherit from the owning field contract.",
                    "id": "basis-reference",
                    "label": "Basis reference",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "expected-value",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Structured observed transaction or outcome for the same scope, unit and period. Currency is carried by currency-code when the value is monetary.",
            "exchangeScope": "mapped",
            "id": "actual-value",
            "introducedIn": "1.0.0",
            "label": "Actual value",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-leakage-monitor",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:LegalMonetaryTotal|cac:InvoiceLine/cbc:LineExtensionAmount",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "credit-note",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "path": "cac:LegalMonetaryTotal|cac:CreditNoteLine/cbc:LineExtensionAmount",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Value is the decimal component carried within Value leakage finding Actual value; its classification and authority inherit from the owning field contract.",
                    "id": "value",
                    "label": "Value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "actual-value",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Value type records the governed state or type within Value leakage finding Actual value without treating absence, unknown and zero as equivalent.",
                    "id": "value-type",
                    "label": "Value type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "actual-value",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Unit code records the governed code within Value leakage finding Actual value without treating absence, unknown and zero as equivalent.",
                    "id": "unit-code",
                    "label": "Unit code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "actual-value",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Period start is the date component carried within Value leakage finding Actual value; its classification and authority inherit from the owning field contract.",
                    "id": "period-start",
                    "label": "Period start",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "actual-value",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Period end is the date component carried within Value leakage finding Actual value; its classification and authority inherit from the owning field contract.",
                    "id": "period-end",
                    "label": "Period end",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "actual-value",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Source record references is the set carried within Value leakage finding Actual value; its owning field governs allowed values and interpretation.",
                    "format": "source-record-reference references",
                    "id": "source-record-references",
                    "label": "Source record references",
                    "listSemantics": "set",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "actual-value",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Observation status records the governed state or type within Value leakage finding Actual value without treating absence, unknown and zero as equivalent.",
                    "id": "observation-status",
                    "label": "Observation status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "actual-value",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "The same-item comparator population from which a variance finding was drawn, summarised as a sample size and a price range with its detection method. It explains the population behind the expected-versus-actual pair; it never replaces that pair. Currency is carried by currency-code when the values are monetary.",
            "exchangeScope": "internal",
            "id": "dispersion-evidence",
            "introducedIn": "4.8.0",
            "label": "Dispersion evidence",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "value-leakage-monitor",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Cell key is the grouping key that defines same item for Value leakage finding Dispersion evidence, composed of the category identifier with the item identifier scheme and value; it scopes the comparator population and never identifies a single line.",
                    "id": "cell-key",
                    "label": "Cell key",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "dispersion-evidence",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Sample size is the count of comparator lines carried within Value leakage finding Dispersion evidence; its classification and authority inherit from the owning field contract.",
                    "id": "sample-size",
                    "label": "Sample size",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "dispersion-evidence",
                      "kind": "inherited-field"
                    },
                    "type": "integer"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Low value is the lowest observed unit value in the comparator cell carried within Value leakage finding Dispersion evidence; its classification and authority inherit from the owning field contract.",
                    "id": "low-value",
                    "label": "Low value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "dispersion-evidence",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "High value is the highest observed unit value in the comparator cell carried within Value leakage finding Dispersion evidence; its classification and authority inherit from the owning field contract.",
                    "id": "high-value",
                    "label": "High value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "dispersion-evidence",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Median value is the median observed unit value in the comparator cell carried within Value leakage finding Dispersion evidence; its classification and authority inherit from the owning field contract.",
                    "id": "median-value",
                    "label": "Median value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "dispersion-evidence",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Unit code records the governed measure code the low, high and median values are expressed in within Value leakage finding Dispersion evidence; it is absent when the values carry a currency alone, without treating absence, unknown and zero as equivalent.",
                    "id": "unit-code",
                    "label": "Unit code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "dispersion-evidence",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Detection method code records the governed method by which the variance was detected across this comparator population within Value leakage finding Dispersion evidence; it names how the comparator population was formed and is never a restatement of the finding's leakage-type.",
                    "enumValues": [
                      "unit-price-dispersion",
                      "contract-price-deviation",
                      "other"
                    ],
                    "id": "detection-method-code",
                    "label": "Detection method code",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "dispersion-evidence",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Current calculated gross, recoverable and residual exposure, not realised value. Currency is carried by currency-code when the value is monetary.",
            "exchangeScope": "internal",
            "id": "exposure-amount",
            "introducedIn": "1.0.0",
            "label": "Exposure amount",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-leakage-monitor",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Gross value is the decimal component carried within Value leakage finding Exposure amount; its classification and authority inherit from the owning field contract.",
                    "id": "gross-value",
                    "label": "Gross value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "exposure-amount",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Recoverable value is the decimal component carried within Value leakage finding Exposure amount; its classification and authority inherit from the owning field contract.",
                    "id": "recoverable-value",
                    "label": "Recoverable value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "exposure-amount",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Residual value is the decimal component carried within Value leakage finding Exposure amount; its classification and authority inherit from the owning field contract.",
                    "id": "residual-value",
                    "label": "Residual value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "exposure-amount",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Value type records the governed state or type within Value leakage finding Exposure amount without treating absence, unknown and zero as equivalent.",
                    "id": "value-type",
                    "label": "Value type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "exposure-amount",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Unit code records the governed code within Value leakage finding Exposure amount without treating absence, unknown and zero as equivalent.",
                    "id": "unit-code",
                    "label": "Unit code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "exposure-amount",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Calculated at is the timestamp component carried within Value leakage finding Exposure amount; its classification and authority inherit from the owning field contract.",
                    "id": "calculated-at",
                    "label": "Calculated at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "exposure-amount",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Calculation method version is the string component carried within Value leakage finding Exposure amount; its classification and authority inherit from the owning field contract.",
                    "id": "calculation-method-version",
                    "label": "Calculation method version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "exposure-amount",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "confidential",
            "definition": "ISO 4217 reporting currency for exposure.",
            "exchangeScope": "mapped",
            "format": "iso-4217-alpha",
            "id": "currency-code",
            "introducedIn": "1.0.0",
            "label": "Currency code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-leakage-monitor",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "conceptId": "currency-code",
                "coverage": "exact",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "code-list",
                "path": "alphabetic code",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-4217",
                "transformation": "none"
              },
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "order",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "Source currency for monetary expected values.",
                "path": "cac:AnticipatedMonetaryTotal/cbc:PayableAmount/@currencyID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "tender-contract",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "Source currency for monetary expected values.",
                "path": "cac:TenderResult/cac:AwardedTenderedProject/cac:LegalMonetaryTotal/cbc:PayableAmount/@currencyID",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "invoice",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "The document currency is an input to actual value and exposure; selected amount leaves and conversion remain GroundWorks provenance.",
                "path": "cbc:DocumentCurrencyCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              },
              {
                "coverage": "semantic",
                "direction": "inbound",
                "documentId": "credit-note",
                "exchangeScope": "edge-interchange",
                "mappingKind": "document-path",
                "note": "The document currency is an input to actual value and exposure; selected amount leaves and conversion remain GroundWorks provenance.",
                "path": "cbc:DocumentCurrencyCode",
                "releaseId": "2.4",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "ubl-2-4",
                "transformation": "adapter-defined"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Policy-defined consequence band for recovery and escalation.",
            "enumValues": [
              "routine",
              "moderate",
              "material",
              "critical"
            ],
            "exchangeScope": "internal",
            "id": "materiality-band",
            "introducedIn": "1.0.0",
            "label": "Materiality band",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-leakage-monitor",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Observed or provisional root cause with evidence state and classification.",
            "exchangeScope": "internal",
            "id": "root-cause",
            "introducedIn": "1.0.0",
            "label": "Root cause",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "value-leakage-monitor",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Cause code records the governed code within Value leakage finding Root cause without treating absence, unknown and zero as equivalent.",
                    "id": "cause-code",
                    "label": "Cause code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "root-cause",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Cause category is the string component carried within Value leakage finding Root cause; its classification and authority inherit from the owning field contract.",
                    "id": "cause-category",
                    "label": "Cause category",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "root-cause",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Description is the string component carried within Value leakage finding Root cause; its classification and authority inherit from the owning field contract.",
                    "id": "description",
                    "label": "Description",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "root-cause",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence status records the governed state or type within Value leakage finding Root cause without treating absence, unknown and zero as equivalent.",
                    "id": "evidence-status",
                    "label": "Evidence status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "root-cause",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Confidence band is the string component carried within Value leakage finding Root cause; its classification and authority inherit from the owning field contract.",
                    "id": "confidence-band",
                    "label": "Confidence band",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "root-cause",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence references is the set carried within Value leakage finding Root cause; its owning field governs allowed values and interpretation.",
                    "format": "evidence-item references",
                    "id": "evidence-references",
                    "label": "Evidence references",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "root-cause",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Assessed at is the timestamp component carried within Value leakage finding Root cause; its classification and authority inherit from the owning field contract.",
                    "id": "assessed-at",
                    "label": "Assessed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "root-cause",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Uncommitted prevention, correction, recovery, supplier, contract or finance action.",
            "exchangeScope": "internal",
            "id": "proposed-remediation",
            "introducedIn": "1.0.0",
            "label": "Proposed remediation",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "value-leakage-monitor",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Remediation ID is the string component carried within Value leakage finding Proposed remediation; its classification and authority inherit from the owning field contract.",
                    "id": "remediation-id",
                    "label": "Remediation ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-remediation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Action type records the governed state or type within Value leakage finding Proposed remediation without treating absence, unknown and zero as equivalent.",
                    "id": "action-type",
                    "label": "Action type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-remediation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Action description is the string component carried within Value leakage finding Proposed remediation; its classification and authority inherit from the owning field contract.",
                    "id": "action-description",
                    "label": "Action description",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-remediation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Rationale is the string component carried within Value leakage finding Proposed remediation; its classification and authority inherit from the owning field contract.",
                    "id": "rationale",
                    "label": "Rationale",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-remediation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Owner reference is the string component carried within Value leakage finding Proposed remediation; its classification and authority inherit from the owning field contract.",
                    "id": "owner-reference",
                    "label": "Owner reference",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-remediation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Due date is the date component carried within Value leakage finding Proposed remediation; its classification and authority inherit from the owning field contract.",
                    "id": "due-date",
                    "label": "Due date",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-remediation",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Proposed recovery value is the decimal component carried within Value leakage finding Proposed remediation; its classification and authority inherit from the owning field contract.",
                    "id": "proposed-recovery-value",
                    "label": "Proposed recovery value",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-remediation",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Proposed at is the timestamp component carried within Value leakage finding Proposed remediation; its classification and authority inherit from the owning field contract.",
                    "id": "proposed-at",
                    "label": "Proposed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-remediation",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Lifecycle of the current uncommitted proposal; authorised means permission to attempt the action, while execution and committed outcome remain separate.",
            "enumValues": [
              "none",
              "draft",
              "proposed",
              "stale",
              "authorised",
              "rejected",
              "withdrawn",
              "superseded"
            ],
            "exchangeScope": "internal",
            "id": "proposal-status",
            "introducedIn": "1.0.0",
            "label": "Proposal status",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-leakage-monitor",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Authorised action and downstream result, distinct from the proposal.",
            "exchangeScope": "internal",
            "id": "committed-remediation",
            "introducedIn": "1.0.0",
            "label": "Committed remediation",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "value-leakage-monitor",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Remediation ID is the string component carried within Value leakage finding Committed remediation; its classification and authority inherit from the owning field contract.",
                    "id": "remediation-id",
                    "label": "Remediation ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-remediation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Action type records the governed state or type within Value leakage finding Committed remediation without treating absence, unknown and zero as equivalent.",
                    "id": "action-type",
                    "label": "Action type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-remediation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Action description is the string component carried within Value leakage finding Committed remediation; its classification and authority inherit from the owning field contract.",
                    "id": "action-description",
                    "label": "Action description",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-remediation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Committed by is the string component carried within Value leakage finding Committed remediation; its classification and authority inherit from the owning field contract.",
                    "id": "committed-by",
                    "label": "Committed by",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-remediation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Committed at is the timestamp component carried within Value leakage finding Committed remediation; its classification and authority inherit from the owning field contract.",
                    "id": "committed-at",
                    "label": "Committed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-remediation",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Downstream status records the governed state or type within Value leakage finding Committed remediation without treating absence, unknown and zero as equivalent.",
                    "id": "downstream-status",
                    "label": "Downstream status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-remediation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Recovered value is the decimal component carried within Value leakage finding Committed remediation; its classification and authority inherit from the owning field contract.",
                    "id": "recovered-value",
                    "label": "Recovered value",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "committed-remediation",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Result reference is the string component carried within Value leakage finding Committed remediation; its classification and authority inherit from the owning field contract.",
                    "id": "result-reference",
                    "label": "Result reference",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "committed-remediation",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Authority permitting the committed remediation.",
            "exchangeScope": "internal",
            "id": "authority-envelope-id",
            "introducedIn": "1.0.0",
            "label": "Authority envelope reference",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "value-leakage-monitor",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "personal",
            "definition": "Role or person accountable for the next recovery action.",
            "exchangeScope": "internal",
            "id": "owner-reference",
            "introducedIn": "1.0.0",
            "label": "Owner reference",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-leakage-monitor",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Timestamp when the canonical finding was opened.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "detected-at",
            "introducedIn": "1.0.0",
            "label": "Detected at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-leakage-monitor",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Current remediation or decision due timestamp.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "due-at",
            "introducedIn": "1.0.0",
            "label": "Due at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "value-leakage-monitor",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Timestamp when recovery or an authorised disposition reconciled.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "closed-at",
            "introducedIn": "1.0.0",
            "label": "Closed at",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "value-leakage-monitor",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Primary expected or actual source identifier.",
            "exchangeScope": "internal",
            "id": "source-system",
            "introducedIn": "1.0.0",
            "label": "Source system",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-leakage-monitor",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Exact expectation, actual and calculation schema bundle.",
            "exchangeScope": "internal",
            "id": "source-schema-version",
            "introducedIn": "1.0.0",
            "label": "Source schema version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-leakage-monitor",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Latest observation timestamp among expected and actual sources.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "observed-at",
            "introducedIn": "1.0.0",
            "label": "Observed at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-leakage-monitor",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Expected, actual, calculation, root cause, proposal, action and recovery evidence.",
            "exchangeScope": "internal",
            "id": "evidence-ids",
            "introducedIn": "1.0.0",
            "label": "Evidence references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "value-leakage-monitor",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Leakage detection and recovery policy version.",
            "exchangeScope": "internal",
            "id": "policy-version-id",
            "introducedIn": "1.0.0",
            "label": "Policy version",
            "nullable": false,
            "referenceEntityId": "policy-version",
            "required": true,
            "sourceAuthority": {
              "id": "value-leakage-monitor",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Version of value-leakage-monitor managing the finding.",
            "exchangeScope": "internal",
            "id": "workblock-version",
            "introducedIn": "1.0.0",
            "label": "Workblock version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-leakage-monitor",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "value-leakage-finding",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "business-key"
            ],
            "id": "value-leakage-finding-by-business-key",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "savings-initiative-id",
              "lifecycle-state"
            ],
            "id": "value-leakage-finding-by-savings-initiative-id-and-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "leakage-type",
              "materiality-band"
            ],
            "id": "value-leakage-finding-by-leakage-type-and-materiality-band",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "owner-reference",
              "due-at"
            ],
            "id": "value-leakage-finding-by-owner-reference-and-due-at",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "freshness-status"
            ],
            "id": "value-leakage-finding-by-freshness-status",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "case",
        "label": "Value leakage finding",
        "lifecycle": [
          "detected",
          "evidence-gap",
          "proposed",
          "in-recovery",
          "recovered",
          "prevented",
          "accepted",
          "disputed",
          "false-positive",
          "written-off",
          "closed",
          "reopened"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "value-leakage-monitor",
        "owningDomainWorkblockId": "value-realization-savings",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Value leakage findings",
        "primaryKey": "value-leakage-finding-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links a finding to the initiative whose value is exposed.",
            "id": "value-leakage-finding-references-savings-initiative-record-leakage-affects-initiative",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "value-leakage-finding-references-savings-initiative-record-leakage-affects-initiative",
            "required": false,
            "sourceFieldId": "savings-initiative-id",
            "targetEntityId": "savings-initiative-record",
            "targetFieldId": "savings-initiative-record-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the value leakage finding to the referenced party.",
            "id": "value-leakage-finding-belongs-to-party-value-leakage-finding-supplier-party-id",
            "introducedIn": "2.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "value-leakage-finding-belongs-to-party-value-leakage-finding-supplier-party-id",
            "required": false,
            "sourceFieldId": "supplier-party-id",
            "targetEntityId": "party",
            "targetFieldId": "party-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the value leakage finding to the referenced category.",
            "id": "value-leakage-finding-classified-as-category-value-leakage-finding-category-id",
            "introducedIn": "2.0.0",
            "predicate": "classified-as",
            "qualifiedId": "value-leakage-finding-classified-as-category-value-leakage-finding-category-id",
            "required": false,
            "sourceFieldId": "category-id",
            "targetEntityId": "category",
            "targetFieldId": "category-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the value leakage finding to the referenced contract.",
            "id": "value-leakage-finding-belongs-to-contract-value-leakage-finding-contract-id",
            "introducedIn": "2.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "value-leakage-finding-belongs-to-contract-value-leakage-finding-contract-id",
            "required": false,
            "sourceFieldId": "contract-id",
            "targetEntityId": "contract",
            "targetFieldId": "contract-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the value leakage finding to the referenced source record references.",
            "id": "value-leakage-finding-evidenced-by-source-record-reference-value-leakage-finding-source-record-ids",
            "introducedIn": "2.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "value-leakage-finding-evidenced-by-source-record-reference-value-leakage-finding-source-record-ids",
            "required": true,
            "sourceFieldId": "source-record-ids",
            "targetEntityId": "source-record-reference",
            "targetFieldId": "source-record-reference-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the value leakage finding to the referenced authority envelope.",
            "id": "value-leakage-finding-governed-by-authority-envelope-value-leakage-finding-authority-envelope-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "value-leakage-finding-governed-by-authority-envelope-value-leakage-finding-authority-envelope-id",
            "required": false,
            "sourceFieldId": "authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the value leakage finding to the referenced evidence items.",
            "id": "value-leakage-finding-evidenced-by-evidence-item-value-leakage-finding-evidence-ids",
            "introducedIn": "2.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "value-leakage-finding-evidenced-by-evidence-item-value-leakage-finding-evidence-ids",
            "required": true,
            "sourceFieldId": "evidence-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the value leakage finding to the referenced policy version.",
            "id": "value-leakage-finding-governed-by-policy-version-id-value-leakage-finding-policy-version-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "value-leakage-finding-governed-by-policy-version-id-value-leakage-finding-policy-version-id",
            "required": true,
            "sourceFieldId": "policy-version-id",
            "targetEntityId": "policy-version",
            "targetFieldId": "policy-version-id"
          }
        ],
        "retentionClass": "financial",
        "searchTerms": [
          "value leakage",
          "price leakage",
          "missed rebate",
          "unclaimed credit",
          "off-contract loss",
          "benefit erosion"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Where is value leaking, at what exposure, and what is the root cause?",
              "What remediation was committed and did it recover the leakage?",
              "Across which sample of same-item lines was this variance detected, and what range did the population show?"
            ],
            "retrievalTerms": [
              "leakage",
              "maverick spend",
              "price non-compliance",
              "recovery",
              "price dispersion",
              "same-item spread",
              "unit-price range"
            ],
            "usage": "Open a source-linked case for expected-versus-actual variances carrying exposure, root cause, recovery proposal, authority, committed remediation and reconciled disposition."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "leakage finding",
              "value erosion case",
              "compliance variance"
            ],
            "concept": "value-variance-case"
          }
        },
        "sourceSystemRoleIds": [
          "analytical-system",
          "system-of-record",
          "execution-system",
          "transport-execution-boundary",
          "payment-or-settlement-rail"
        ],
        "storageClass": "tenant-record",
        "version": "4.1.0",
        "writebackSystemRoleIds": [
          "analytical-system",
          "collaboration-channel",
          "execution-system"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "savings-initiative"
        ],
        "definition": "An immutable as-of portfolio forecast version that keeps scenario, target, validated realisation, leakage, risk, assumptions, intervention proposal and committed portfolio decision distinct.",
        "domainWorkblockIds": [
          "value-realization-savings"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable identifier for the immutable forecast version.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "value-portfolio-forecast-id",
            "introducedIn": "1.0.0",
            "label": "Value portfolio forecast ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-portfolio-forecast",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "internal",
            "definition": "Date through which source evidence is included in the forecast.",
            "exchangeScope": "internal",
            "format": "date",
            "id": "as-of-date",
            "introducedIn": "1.0.0",
            "label": "As-of date",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-portfolio-forecast",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "internal",
            "definition": "Governed portfolio scenario represented by this forecast version.",
            "enumValues": [
              "base",
              "upside",
              "downside",
              "approved-custom"
            ],
            "exchangeScope": "internal",
            "id": "scenario-code",
            "introducedIn": "1.0.0",
            "label": "Scenario code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-portfolio-forecast",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "The external price reference tier selected as the comparator for this forecast version, applying to the whole as-of portfolio version rather than to any per-initiative or per-period row. It names which reference produced the comparator values behind the version's benchmark-based assumptions; it does not describe the forecast's directional framing, and it never embeds the reference series itself. It is absent when no external benchmark backs the version, and absence is never an unknown tier. A custom-tier selection documents its source through assumptions source-reference.",
            "enumValues": [
              "median",
              "average",
              "lowest-quartile",
              "lowest-decile",
              "custom-tier"
            ],
            "exchangeScope": "internal",
            "id": "benchmark-tier-code",
            "introducedIn": "4.8.0",
            "label": "Benchmark tier code",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "value-portfolio-forecast",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Inclusive first date represented in the realisation schedule.",
            "exchangeScope": "internal",
            "format": "date",
            "id": "forecast-horizon-start",
            "introducedIn": "1.0.0",
            "label": "Forecast horizon start",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-portfolio-forecast",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "internal",
            "definition": "Inclusive final date represented in the realisation schedule.",
            "exchangeScope": "internal",
            "format": "date",
            "id": "forecast-horizon-end",
            "introducedIn": "1.0.0",
            "label": "Forecast horizon end",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-portfolio-forecast",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "restricted",
            "definition": "Exact initiative versions included in the forecast.",
            "exchangeScope": "internal",
            "id": "initiative-ids",
            "introducedIn": "1.0.0",
            "label": "Initiative references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "savings-initiative-record",
            "required": true,
            "sourceAuthority": {
              "id": "value-portfolio-forecast",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "restricted",
            "definition": "Committed value baselines contributing target and counterfactual context.",
            "exchangeScope": "internal",
            "id": "baseline-ids",
            "introducedIn": "1.0.0",
            "label": "Baseline references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "value-opportunity-baseline",
            "required": true,
            "sourceAuthority": {
              "id": "value-portfolio-forecast",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Exact feature, scenario, confidence interval, risk and currency treatment.",
            "exchangeScope": "internal",
            "id": "forecast-method-version",
            "introducedIn": "1.0.0",
            "label": "Forecast method version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-portfolio-forecast",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Structured forecast by value type and reporting currency, explicitly not validated realisation. Currency is carried by currency-code when the value is monetary.",
            "exchangeScope": "internal",
            "id": "forecast-amount",
            "introducedIn": "1.0.0",
            "label": "Forecast amount",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-portfolio-forecast",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Value is the decimal component carried within Value portfolio forecast Forecast amount; its classification and authority inherit from the owning field contract.",
                    "id": "value",
                    "label": "Value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "forecast-amount",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Value type records the governed state or type within Value portfolio forecast Forecast amount without treating absence, unknown and zero as equivalent.",
                    "id": "value-type",
                    "label": "Value type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "forecast-amount",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Unit code records the governed code within Value portfolio forecast Forecast amount without treating absence, unknown and zero as equivalent.",
                    "id": "unit-code",
                    "label": "Unit code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "forecast-amount",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Governed portfolio scenario represented by this forecast amount.",
                    "enumValues": [
                      "base",
                      "upside",
                      "downside",
                      "approved-custom"
                    ],
                    "id": "scenario-code",
                    "label": "Scenario code",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "forecast-amount",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Horizon start is the date component carried within Value portfolio forecast Forecast amount; its classification and authority inherit from the owning field contract.",
                    "id": "horizon-start",
                    "label": "Horizon start",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "forecast-amount",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Horizon end is the date component carried within Value portfolio forecast Forecast amount; its classification and authority inherit from the owning field contract.",
                    "id": "horizon-end",
                    "label": "Horizon end",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "forecast-amount",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "As of date is the date component carried within Value portfolio forecast Forecast amount; its classification and authority inherit from the owning field contract.",
                    "id": "as-of-date",
                    "label": "As of date",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "forecast-amount",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Calculation method version is the string component carried within Value portfolio forecast Forecast amount; its classification and authority inherit from the owning field contract.",
                    "id": "calculation-method-version",
                    "label": "Calculation method version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "forecast-amount",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "ISO 4217 alphabetic reporting currency for monetary forecast values; null for a wholly non-monetary scenario.",
            "exchangeScope": "mapped",
            "format": "ISO 4217 alpha-3",
            "id": "currency-code",
            "introducedIn": "2.0.0",
            "label": "Currency code",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "value-portfolio-forecast",
              "kind": "business-module"
            },
            "standardMappings": [
              {
                "conceptId": "currency-code",
                "coverage": "exact",
                "direction": "bidirectional",
                "exchangeScope": "edge-interchange",
                "mappingKind": "code-list",
                "path": "alphabetic code",
                "releaseId": "adapter-pinned",
                "roundTrip": {
                  "limitations": "The configured adapter must validate round-trip behaviour for this field and release.",
                  "status": "conditional"
                },
                "standardId": "iso-4217",
                "transformation": "none"
              }
            ],
            "type": "string"
          },
          {
            "classification": "confidential",
            "definition": "Method-derived forecast range with stated horizon, coverage and calibration basis.",
            "exchangeScope": "internal",
            "id": "confidence-interval",
            "introducedIn": "1.0.0",
            "label": "Confidence interval",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-portfolio-forecast",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "confidential",
                    "definition": "Lower bound is the decimal component carried within Value portfolio forecast Confidence interval; its classification and authority inherit from the owning field contract.",
                    "id": "lower-bound",
                    "label": "Lower bound",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "confidence-interval",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Central estimate is the decimal component carried within Value portfolio forecast Confidence interval; its classification and authority inherit from the owning field contract.",
                    "id": "central-estimate",
                    "label": "Central estimate",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "confidence-interval",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Upper bound is the decimal component carried within Value portfolio forecast Confidence interval; its classification and authority inherit from the owning field contract.",
                    "id": "upper-bound",
                    "label": "Upper bound",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "confidence-interval",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Confidence level is the decimal component carried within Value portfolio forecast Confidence interval; its classification and authority inherit from the owning field contract.",
                    "id": "confidence-level",
                    "label": "Confidence level",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "confidence-interval",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Horizon start is the date component carried within Value portfolio forecast Confidence interval; its classification and authority inherit from the owning field contract.",
                    "id": "horizon-start",
                    "label": "Horizon start",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "confidence-interval",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Horizon end is the date component carried within Value portfolio forecast Confidence interval; its classification and authority inherit from the owning field contract.",
                    "id": "horizon-end",
                    "label": "Horizon end",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "confidence-interval",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Coverage description is the string component carried within Value portfolio forecast Confidence interval; its classification and authority inherit from the owning field contract.",
                    "id": "coverage-description",
                    "label": "Coverage description",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "confidence-interval",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Calibration version is the string component carried within Value portfolio forecast Confidence interval; its classification and authority inherit from the owning field contract.",
                    "id": "calibration-version",
                    "label": "Calibration version",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "confidence-interval",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Transparent adjustment by initiative, dependency, stage, leakage and concentration risk.",
            "exchangeScope": "internal",
            "id": "risk-adjustment",
            "introducedIn": "1.0.0",
            "label": "Risk adjustment",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-portfolio-forecast",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Adjustment ID is the string component carried within Value portfolio forecast Risk adjustment; its classification and authority inherit from the owning field contract.",
                    "id": "adjustment-id",
                    "label": "Adjustment ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "risk-adjustment",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Risk type records the governed state or type within Value portfolio forecast Risk adjustment without treating absence, unknown and zero as equivalent.",
                    "id": "risk-type",
                    "label": "Risk type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "risk-adjustment",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Source scope is the string component carried within Value portfolio forecast Risk adjustment; its classification and authority inherit from the owning field contract.",
                    "id": "source-scope",
                    "label": "Source scope",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "risk-adjustment",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Gross value is the decimal component carried within Value portfolio forecast Risk adjustment; its classification and authority inherit from the owning field contract.",
                    "id": "gross-value",
                    "label": "Gross value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "risk-adjustment",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Adjustment value is the decimal component carried within Value portfolio forecast Risk adjustment; its classification and authority inherit from the owning field contract.",
                    "id": "adjustment-value",
                    "label": "Adjustment value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "risk-adjustment",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Rationale is the string component carried within Value portfolio forecast Risk adjustment; its classification and authority inherit from the owning field contract.",
                    "id": "rationale",
                    "label": "Rationale",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "risk-adjustment",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Dependency reference is the string component carried within Value portfolio forecast Risk adjustment; its classification and authority inherit from the owning field contract.",
                    "id": "dependency-reference",
                    "label": "Dependency reference",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "risk-adjustment",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "As of date is the date component carried within Value portfolio forecast Risk adjustment; its classification and authority inherit from the owning field contract.",
                    "id": "as-of-date",
                    "label": "As of date",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "risk-adjustment",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  }
                ],
                "uniqueBy": [
                  "adjustment-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Periodised target, forecast and committed realisation schedule by initiative and value type.",
            "exchangeScope": "internal",
            "id": "realization-schedule",
            "introducedIn": "1.0.0",
            "label": "Realisation schedule",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-portfolio-forecast",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Schedule line ID is the string component carried within Value portfolio forecast Realisation schedule; its classification and authority inherit from the owning field contract.",
                    "id": "schedule-line-id",
                    "label": "Schedule line ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "realization-schedule",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Period start is the date component carried within Value portfolio forecast Realisation schedule; its classification and authority inherit from the owning field contract.",
                    "id": "period-start",
                    "label": "Period start",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "realization-schedule",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Period end is the date component carried within Value portfolio forecast Realisation schedule; its classification and authority inherit from the owning field contract.",
                    "id": "period-end",
                    "label": "Period end",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "realization-schedule",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Initiative reference links this structured value to the governed savings-initiative-record record within Value portfolio forecast Realisation schedule.",
                    "id": "initiative-id",
                    "label": "Initiative reference",
                    "nullable": false,
                    "referenceEntityId": "savings-initiative-record",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links the initiative reference in realisation schedule to the referenced savings initiative record via its canonical savings initiative ID.",
                      "id": "value-portfolio-forecast-realization-schedule-initiative-reference",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "savings-initiative-record-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "realization-schedule",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Value type records the governed state or type within Value portfolio forecast Realisation schedule without treating absence, unknown and zero as equivalent.",
                    "id": "value-type",
                    "label": "Value type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "realization-schedule",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Target value is the decimal component carried within Value portfolio forecast Realisation schedule; its classification and authority inherit from the owning field contract.",
                    "id": "target-value",
                    "label": "Target value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "realization-schedule",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Forecast value is the decimal component carried within Value portfolio forecast Realisation schedule; its classification and authority inherit from the owning field contract.",
                    "id": "forecast-value",
                    "label": "Forecast value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "realization-schedule",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Committed realisation value is the decimal component carried within Value portfolio forecast Realisation schedule; its classification and authority inherit from the owning field contract.",
                    "id": "committed-realization-value",
                    "label": "Committed realisation value",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "realization-schedule",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Unit code records the governed code within Value portfolio forecast Realisation schedule without treating absence, unknown and zero as equivalent.",
                    "id": "unit-code",
                    "label": "Unit code",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "realization-schedule",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ],
                "uniqueBy": [
                  "schedule-line-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Scenario, currency, timing, initiative, dependency, capacity and missing-source assumptions.",
            "exchangeScope": "internal",
            "id": "assumptions",
            "introducedIn": "1.0.0",
            "label": "Assumptions",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-portfolio-forecast",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object-list",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Assumption ID is the string component carried within Value portfolio forecast Assumptions; its classification and authority inherit from the owning field contract.",
                    "id": "assumption-id",
                    "label": "Assumption ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "assumptions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Assumption type records the governed state or type within Value portfolio forecast Assumptions without treating absence, unknown and zero as equivalent.",
                    "id": "assumption-type",
                    "label": "Assumption type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "assumptions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Statement is the string component carried within Value portfolio forecast Assumptions; its classification and authority inherit from the owning field contract.",
                    "id": "statement",
                    "label": "Statement",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "assumptions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Applies to is the string component carried within Value portfolio forecast Assumptions; its classification and authority inherit from the owning field contract.",
                    "id": "applies-to",
                    "label": "Applies to",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "assumptions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Source reference is the string component carried within Value portfolio forecast Assumptions; its classification and authority inherit from the owning field contract.",
                    "id": "source-reference",
                    "label": "Source reference",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "assumptions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Effective from is the date component carried within Value portfolio forecast Assumptions; its classification and authority inherit from the owning field contract.",
                    "id": "effective-from",
                    "label": "Effective from",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "assumptions",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Effective to is the date component carried within Value portfolio forecast Assumptions; its classification and authority inherit from the owning field contract.",
                    "id": "effective-to",
                    "label": "Effective to",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "assumptions",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Status records the governed state or type within Value portfolio forecast Assumptions without treating absence, unknown and zero as equivalent.",
                    "id": "status",
                    "label": "Status",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "assumptions",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ],
                "uniqueBy": [
                  "assumption-id"
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Pinned portfolio source snapshots supporting the forecast version.",
            "exchangeScope": "internal",
            "id": "source-snapshot-ids",
            "introducedIn": "1.0.0",
            "label": "Source snapshot references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "source-record-reference",
            "required": true,
            "sourceAuthority": {
              "id": "value-portfolio-forecast",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "restricted",
            "definition": "Uncommitted intervention, escalation or decision request derived from forecast variance or risk.",
            "exchangeScope": "internal",
            "id": "proposed-portfolio-action",
            "introducedIn": "1.0.0",
            "label": "Proposed portfolio action",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "value-portfolio-forecast",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Action ID is the string component carried within Value portfolio forecast Proposed portfolio action; its classification and authority inherit from the owning field contract.",
                    "id": "action-id",
                    "label": "Action ID",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-portfolio-action",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Action type records the governed state or type within Value portfolio forecast Proposed portfolio action without treating absence, unknown and zero as equivalent.",
                    "id": "action-type",
                    "label": "Action type",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-portfolio-action",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Scope is the string component carried within Value portfolio forecast Proposed portfolio action; its classification and authority inherit from the owning field contract.",
                    "id": "scope",
                    "label": "Scope",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-portfolio-action",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Rationale is the string component carried within Value portfolio forecast Proposed portfolio action; its classification and authority inherit from the owning field contract.",
                    "id": "rationale",
                    "label": "Rationale",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-portfolio-action",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Priority code records the governed code within Value portfolio forecast Proposed portfolio action without treating absence, unknown and zero as equivalent.",
                    "id": "priority-code",
                    "label": "Priority code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-portfolio-action",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Requested owner is the string component carried within Value portfolio forecast Proposed portfolio action; its classification and authority inherit from the owning field contract.",
                    "id": "requested-owner",
                    "label": "Requested owner",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-portfolio-action",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Proposed at is the timestamp component carried within Value portfolio forecast Proposed portfolio action; its classification and authority inherit from the owning field contract.",
                    "id": "proposed-at",
                    "label": "Proposed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "proposed-portfolio-action",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Expires at is the timestamp component carried within Value portfolio forecast Proposed portfolio action; its classification and authority inherit from the owning field contract.",
                    "id": "expires-at",
                    "label": "Expires at",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-portfolio-action",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Evidence references is the set carried within Value portfolio forecast Proposed portfolio action; its owning field governs allowed values and interpretation.",
                    "format": "evidence-item references",
                    "id": "evidence-references",
                    "label": "Evidence references",
                    "listSemantics": "set",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "proposed-portfolio-action",
                      "kind": "inherited-field"
                    },
                    "type": "string-list"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "Lifecycle of the current uncommitted proposal; authorised means permission to attempt the action, while execution and committed outcome remain separate.",
            "enumValues": [
              "none",
              "draft",
              "proposed",
              "stale",
              "authorised",
              "rejected",
              "withdrawn",
              "superseded"
            ],
            "exchangeScope": "internal",
            "id": "proposal-status",
            "introducedIn": "1.0.0",
            "label": "Proposal status",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-portfolio-forecast",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Authorised priority, intervention or resource decision, separate from forecast content.",
            "exchangeScope": "internal",
            "id": "committed-portfolio-decision",
            "introducedIn": "1.0.0",
            "label": "Committed portfolio decision",
            "nullable": true,
            "required": false,
            "sourceAuthority": {
              "id": "value-portfolio-forecast",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "restricted",
                    "definition": "Decision ID links this structured value to governed decision record through decision-id within Value portfolio forecast Committed portfolio decision.",
                    "id": "decision-id",
                    "label": "Decision ID",
                    "nullable": false,
                    "referenceEntityId": "decision",
                    "relationship": {
                      "cardinality": "many-to-one",
                      "definition": "Links decision id to governed decision record through the canonical decision-id field.",
                      "id": "value-portfolio-forecast-committed-portfolio-decision-decision-id",
                      "introducedIn": "2.0.0",
                      "required": true,
                      "targetFieldId": "decision-id"
                    },
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-portfolio-decision",
                      "kind": "inherited-field"
                    },
                    "type": "reference"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Decision code records the governed code within Value portfolio forecast Committed portfolio decision without treating absence, unknown and zero as equivalent.",
                    "id": "decision-code",
                    "label": "Decision code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-portfolio-decision",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Scope is the string component carried within Value portfolio forecast Committed portfolio decision; its classification and authority inherit from the owning field contract.",
                    "id": "scope",
                    "label": "Scope",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-portfolio-decision",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Rationale is the string component carried within Value portfolio forecast Committed portfolio decision; its classification and authority inherit from the owning field contract.",
                    "id": "rationale",
                    "label": "Rationale",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-portfolio-decision",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Priority code records the governed code within Value portfolio forecast Committed portfolio decision without treating absence, unknown and zero as equivalent.",
                    "id": "priority-code",
                    "label": "Priority code",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-portfolio-decision",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Committed by is the string component carried within Value portfolio forecast Committed portfolio decision; its classification and authority inherit from the owning field contract.",
                    "id": "committed-by",
                    "label": "Committed by",
                    "nullable": false,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-portfolio-decision",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Committed at is the timestamp component carried within Value portfolio forecast Committed portfolio decision; its classification and authority inherit from the owning field contract.",
                    "id": "committed-at",
                    "label": "Committed at",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-portfolio-decision",
                      "kind": "inherited-field"
                    },
                    "type": "timestamp"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Effective from is the date component carried within Value portfolio forecast Committed portfolio decision; its classification and authority inherit from the owning field contract.",
                    "id": "effective-from",
                    "label": "Effective from",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "committed-portfolio-decision",
                      "kind": "inherited-field"
                    },
                    "type": "date"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Resource owner is the string component carried within Value portfolio forecast Committed portfolio decision; its classification and authority inherit from the owning field contract.",
                    "id": "resource-owner",
                    "label": "Resource owner",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "committed-portfolio-decision",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "restricted",
                    "definition": "Result tracking reference is the string component carried within Value portfolio forecast Committed portfolio decision; its classification and authority inherit from the owning field contract.",
                    "id": "result-tracking-reference",
                    "label": "Result tracking reference",
                    "nullable": true,
                    "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
                    "required": false,
                    "sourceAuthority": {
                      "id": "committed-portfolio-decision",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "restricted",
            "definition": "Authority permitting routine forecast publication or committed intervention.",
            "exchangeScope": "internal",
            "id": "authority-envelope-id",
            "introducedIn": "1.0.0",
            "label": "Authority envelope reference",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "value-portfolio-forecast",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Forecast producer identifier.",
            "exchangeScope": "internal",
            "id": "source-system",
            "introducedIn": "1.0.0",
            "label": "Source system",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-portfolio-forecast",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Exact portfolio input and forecast schema bundle.",
            "exchangeScope": "internal",
            "id": "source-schema-version",
            "introducedIn": "1.0.0",
            "label": "Source schema version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-portfolio-forecast",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Latest observation timestamp among included sources.",
            "exchangeScope": "internal",
            "format": "date-time",
            "id": "observed-at",
            "introducedIn": "1.0.0",
            "label": "Observed at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-portfolio-forecast",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "restricted",
            "definition": "Source, method, scenario, variance, intervention, decision and outcome evidence.",
            "exchangeScope": "internal",
            "id": "evidence-ids",
            "introducedIn": "1.0.0",
            "label": "Evidence references",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "value-portfolio-forecast",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "internal",
            "definition": "Forecast publication and intervention policy version.",
            "exchangeScope": "internal",
            "id": "policy-version-id",
            "introducedIn": "1.0.0",
            "label": "Policy version",
            "nullable": false,
            "referenceEntityId": "policy-version",
            "required": true,
            "sourceAuthority": {
              "id": "value-portfolio-forecast",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "internal",
            "definition": "Version of value-portfolio-forecast producing the record.",
            "exchangeScope": "internal",
            "id": "workblock-version",
            "introducedIn": "1.0.0",
            "label": "Workblock version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "value-portfolio-forecast",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "value-portfolio-forecast",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "business-key"
            ],
            "id": "value-portfolio-forecast-by-business-key",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "as-of-date",
              "scenario-code"
            ],
            "id": "value-portfolio-forecast-by-as-of-date-and-scenario-code",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "forecast-horizon-end"
            ],
            "id": "value-portfolio-forecast-by-forecast-horizon-end",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "lifecycle-state"
            ],
            "id": "value-portfolio-forecast-by-status",
            "introducedIn": "1.0.0",
            "unique": false
          },
          {
            "fieldIds": [
              "freshness-status"
            ],
            "id": "value-portfolio-forecast-by-freshness-status",
            "introducedIn": "1.0.0",
            "unique": false
          }
        ],
        "introducedIn": "1.0.0",
        "kind": "metric",
        "label": "Value portfolio forecast",
        "lifecycle": [
          "calculating",
          "published",
          "stale",
          "superseded",
          "withdrawn"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "value-portfolio-forecast",
        "owningDomainWorkblockId": "value-realization-savings",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Value portfolio forecasts",
        "primaryKey": "value-portfolio-forecast-id",
        "provenanceContract": {
          "actorRequired": false,
          "evidenceRequired": false,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-many",
            "definition": "Links the portfolio projection to exact initiative records.",
            "id": "value-portfolio-forecast-references-savings-initiative-record-forecast-includes-initiatives",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "value-portfolio-forecast-references-savings-initiative-record-forecast-includes-initiatives",
            "required": true,
            "sourceFieldId": "initiative-ids",
            "targetEntityId": "savings-initiative-record",
            "targetFieldId": "savings-initiative-record-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the portfolio projection to its committed baselines.",
            "id": "value-portfolio-forecast-references-value-opportunity-baseline-forecast-includes-baselines",
            "introducedIn": "1.0.0",
            "predicate": "references",
            "qualifiedId": "value-portfolio-forecast-references-value-opportunity-baseline-forecast-includes-baselines",
            "required": true,
            "sourceFieldId": "baseline-ids",
            "targetEntityId": "value-opportunity-baseline",
            "targetFieldId": "value-opportunity-baseline-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the value portfolio forecast to the referenced source record references.",
            "id": "value-portfolio-forecast-belongs-to-source-record-reference-value-portfolio-forecast-source-snapshot-ids",
            "introducedIn": "2.0.0",
            "predicate": "belongs-to",
            "qualifiedId": "value-portfolio-forecast-belongs-to-source-record-reference-value-portfolio-forecast-source-snapshot-ids",
            "required": true,
            "sourceFieldId": "source-snapshot-ids",
            "targetEntityId": "source-record-reference",
            "targetFieldId": "source-record-reference-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the value portfolio forecast to the referenced authority envelope.",
            "id": "value-portfolio-forecast-governed-by-authority-envelope-value-portfolio-forecast-authority-envelope-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "value-portfolio-forecast-governed-by-authority-envelope-value-portfolio-forecast-authority-envelope-id",
            "required": false,
            "sourceFieldId": "authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the value portfolio forecast to the referenced evidence items.",
            "id": "value-portfolio-forecast-evidenced-by-evidence-item-value-portfolio-forecast-evidence-ids",
            "introducedIn": "2.0.0",
            "predicate": "evidenced-by",
            "qualifiedId": "value-portfolio-forecast-evidenced-by-evidence-item-value-portfolio-forecast-evidence-ids",
            "required": true,
            "sourceFieldId": "evidence-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the value portfolio forecast to the referenced policy version.",
            "id": "value-portfolio-forecast-governed-by-policy-version-id-value-portfolio-forecast-policy-version-id",
            "introducedIn": "2.0.0",
            "predicate": "governed-by",
            "qualifiedId": "value-portfolio-forecast-governed-by-policy-version-id-value-portfolio-forecast-policy-version-id",
            "required": true,
            "sourceFieldId": "policy-version-id",
            "targetEntityId": "policy-version",
            "targetFieldId": "policy-version-id"
          }
        ],
        "retentionClass": "financial",
        "searchTerms": [
          "savings forecast",
          "value forecast",
          "benefit portfolio",
          "realisation schedule",
          "forecast variance"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "What is the as-of portfolio position against target for this period?",
              "Which interventions were proposed and which were committed?",
              "Which external benchmark tier was selected as the pricing comparator for this forecast version?"
            ],
            "retrievalTerms": [
              "forecast",
              "portfolio",
              "scenario",
              "target gap",
              "benchmark tier",
              "pricing tier",
              "reference tier"
            ],
            "usage": "Read the immutable as-of forecast version for scenario, target, validated realisation, leakage, risk and assumptions; interventions and portfolio decisions keep proposal and commitment distinct."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "value forecast",
              "savings forecast",
              "portfolio outlook"
            ],
            "concept": "portfolio-forecast-version",
            "doNotConfuseWith": [
              {
                "distinction": "A value-portfolio-forecast is an immutable as-of projection of portfolio value that may select an external benchmark tier as a comparator input; a value-opportunity-baseline is the governed, finance-committed counterfactual a realised saving is measured against. Reading a forecast never substitutes for the baseline's committed reference.",
                "targetEntityId": "value-opportunity-baseline"
              }
            ]
          }
        },
        "sourceSystemRoleIds": [
          "analytical-system",
          "planning-system",
          "collaboration-channel",
          "execution-system"
        ],
        "storageClass": "tenant-record",
        "version": "4.1.0",
        "writebackSystemRoleIds": [
          "analytical-system",
          "collaboration-channel"
        ]
      },
      {
        "accessContract": {
          "actionClasses": [
            "view",
            "create",
            "propose",
            "approve",
            "correct",
            "export",
            "delete"
          ],
          "deletePolicy": "retention-governed",
          "exportRequiresAuthority": true,
          "fieldFiltering": true,
          "scopeAttributes": [
            "tenant",
            "company",
            "environment",
            "purpose",
            "authority"
          ]
        },
        "consumerBusinessModuleIds": [
          "supplier-performance-review",
          "supplier-remediation-exit"
        ],
        "definition": "A versioned, evidence-linked interpretation of exact supplier-performance observations that may be dismissed, disputed, routed to the remediation owner or verified as recovered without becoming a corrective action itself.",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk",
          "supplier-performance-innovation-relationship"
        ],
        "fields": [
          {
            "classification": "restricted",
            "definition": "Stable identifier for the signal, its evidence basis, disposition and recovery links.",
            "exchangeScope": "internal",
            "format": "uuid",
            "id": "supplier-performance-signal-id",
            "introducedIn": "4.3.0",
            "label": "Supplier performance signal ID",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "uuid"
          },
          {
            "classification": "confidential",
            "definition": "Canonical supplier party to which all source observations and this signal apply.",
            "exchangeScope": "internal",
            "id": "supplier-party-id",
            "introducedIn": "4.3.0",
            "label": "Supplier party ID",
            "nullable": false,
            "referenceEntityId": "party",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Exact canonical supplier-performance observations used to derive the signal; narrative or chart output cannot replace this record set.",
            "exchangeScope": "internal",
            "id": "observation-ids",
            "introducedIn": "4.3.0",
            "label": "Observation IDs",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "supplier-performance-observation",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "restricted",
            "definition": "Deterministic version or integrity hash of the exact observation IDs and record versions evaluated, allowing duplicate detection and later replay.",
            "exchangeScope": "internal",
            "id": "observation-set-version",
            "introducedIn": "4.3.0",
            "label": "Observation set version",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Governed interpretation class; source-quality and missing-data signals remain distinct from supplier-performance outcomes.",
            "enumValues": [
              "threshold-breach",
              "deterioration",
              "improvement",
              "volatility",
              "missing-data",
              "source-quality"
            ],
            "exchangeScope": "internal",
            "id": "signal-type",
            "introducedIn": "4.3.0",
            "label": "Signal type",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Stable performance measure code shared by the contributing observations and governing threshold definition.",
            "exchangeScope": "internal",
            "id": "measure-code",
            "introducedIn": "4.3.0",
            "label": "Measure code",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Inclusive earliest business date represented by the observations evaluated for this signal.",
            "exchangeScope": "internal",
            "format": "date",
            "id": "performance-period-start",
            "introducedIn": "4.3.0",
            "label": "Performance period start",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "internal",
            "definition": "Inclusive latest business date represented by the observations evaluated for this signal.",
            "exchangeScope": "internal",
            "format": "date",
            "id": "performance-period-end",
            "introducedIn": "4.3.0",
            "label": "Performance period end",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "date"
          },
          {
            "classification": "confidential",
            "definition": "Versioned materiality classification, observed change, confidence and explanation used to distinguish actionable change from noise.",
            "exchangeScope": "internal",
            "id": "materiality",
            "introducedIn": "4.3.0",
            "label": "Materiality",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "object",
            "valueSchema": {
              "mode": "inline",
              "schema": {
                "additionalProperties": false,
                "container": "object",
                "properties": [
                  {
                    "classification": "internal",
                    "definition": "Governed materiality level for the declared measure, period and evidence set.",
                    "enumValues": [
                      "informational",
                      "watch",
                      "actionable",
                      "critical"
                    ],
                    "id": "materiality-class",
                    "label": "Materiality class",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "materiality",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "internal",
                    "definition": "Exact threshold, baseline or comparison-method version used to classify materiality.",
                    "id": "threshold-definition-version",
                    "label": "Threshold definition version",
                    "nullable": false,
                    "openVocabularyJustification": "The value is the owner-controlled version of the governed threshold definition.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "materiality",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Optional signed change expressed in the measure's declared unit; absence is distinct from zero and applies to non-numeric quality signals.",
                    "id": "observed-change",
                    "label": "Observed change",
                    "nullable": true,
                    "required": false,
                    "sourceAuthority": {
                      "id": "materiality",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "internal",
                    "definition": "Calibrated confidence in the materiality interpretation, never a substitute for source completeness or human authority.",
                    "format": "0..1",
                    "id": "confidence",
                    "label": "Confidence",
                    "nullable": false,
                    "required": true,
                    "sourceAuthority": {
                      "id": "materiality",
                      "kind": "inherited-field"
                    },
                    "type": "decimal"
                  },
                  {
                    "classification": "confidential",
                    "definition": "Concise evidence-linked explanation of materiality, uncertainty and material limitations.",
                    "id": "explanation",
                    "label": "Explanation",
                    "nullable": false,
                    "openVocabularyJustification": "The value explains this evidence-specific assessment rather than defining a reusable vocabulary member.",
                    "required": true,
                    "sourceAuthority": {
                      "id": "materiality",
                      "kind": "inherited-field"
                    },
                    "type": "string"
                  }
                ]
              },
              "schemaVersion": "1.0.0"
            }
          },
          {
            "classification": "internal",
            "definition": "UTC time the signal was first derived from this exact observation-set version.",
            "exchangeScope": "internal",
            "format": "ISO 8601 UTC",
            "id": "detected-at",
            "introducedIn": "4.3.0",
            "label": "Detected at",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "internal",
            "definition": "Latest UTC observation time included in the materiality decision; the common freshness and last-good fields expose its current usability.",
            "exchangeScope": "internal",
            "format": "ISO 8601 UTC",
            "id": "evidence-as-of",
            "introducedIn": "4.3.0",
            "label": "Evidence as of",
            "nullable": false,
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "timestamp"
          },
          {
            "classification": "confidential",
            "definition": "Governed evidence supporting the signal, its dispute disposition, routing and recovery verification.",
            "exchangeScope": "internal",
            "id": "evidence-item-ids",
            "introducedIn": "4.3.0",
            "label": "Evidence item IDs",
            "listSemantics": "set",
            "nullable": false,
            "referenceEntityId": "evidence-item",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "restricted",
            "definition": "Exact governed policy version defining the measure, threshold, materiality rule, routing boundary and recovery evidence.",
            "exchangeScope": "internal",
            "id": "policy-version-id",
            "introducedIn": "4.3.0",
            "label": "Policy version ID",
            "nullable": false,
            "referenceEntityId": "policy-version",
            "required": true,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Optional authority envelope governing signal approval, dispute disposition or routing; it cannot authorise this module to commit a remediation action.",
            "exchangeScope": "internal",
            "id": "authority-envelope-id",
            "introducedIn": "4.3.0",
            "label": "Authority envelope ID",
            "nullable": true,
            "referenceEntityId": "authority-envelope",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Canonical earlier signal with the same governed observation-set meaning; this record remains available as a deduplication decision trace.",
            "exchangeScope": "internal",
            "id": "duplicate-of-supplier-performance-signal-id",
            "introducedIn": "4.3.0",
            "label": "Duplicate of supplier performance signal ID",
            "nullable": true,
            "referenceEntityId": "supplier-performance-signal",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Durable decision accepting, rejecting or revising a dispute over the signal's evidence or materiality; dispute does not erase source observations.",
            "exchangeScope": "internal",
            "id": "dispute-decision-id",
            "introducedIn": "4.3.0",
            "label": "Dispute decision ID",
            "nullable": true,
            "referenceEntityId": "decision",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Cross-owner proposal requesting the declared remediation owner to accept, reject or redirect the corrective outcome; it is not a committed action.",
            "exchangeScope": "internal",
            "id": "routing-action-proposal-id",
            "introducedIn": "4.3.0",
            "label": "Routing action proposal ID",
            "nullable": true,
            "referenceEntityId": "action-proposal",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "restricted",
            "definition": "Optional corrective action accepted and owned by supplier-remediation-exit after routing; the signal owner cannot update or close that action.",
            "exchangeScope": "internal",
            "id": "supplier-remediation-action-id",
            "introducedIn": "4.3.0",
            "label": "Supplier remediation action ID",
            "nullable": true,
            "referenceEntityId": "supplier-remediation-action",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          },
          {
            "classification": "confidential",
            "definition": "Later canonical observations used to verify sustained recovery against the same governed measure and policy version.",
            "exchangeScope": "internal",
            "id": "recovery-observation-ids",
            "introducedIn": "4.3.0",
            "label": "Recovery observation IDs",
            "listSemantics": "set",
            "nullable": true,
            "referenceEntityId": "supplier-performance-observation",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference-list"
          },
          {
            "classification": "restricted",
            "definition": "Durable decision that the declared recovery evidence meets the signal's policy-defined recovery test; absence means recovery remains unverified.",
            "exchangeScope": "internal",
            "id": "recovery-decision-id",
            "introducedIn": "4.3.0",
            "label": "Recovery decision ID",
            "nullable": true,
            "referenceEntityId": "decision",
            "required": false,
            "sourceAuthority": {
              "id": "supplier-performance-monitor-correct",
              "kind": "business-module"
            },
            "standardMappings": [],
            "type": "reference"
          }
        ],
        "freshnessContract": {
          "degradedAction": "show-last-good",
          "lastGoodPolicy": "retain-with-age",
          "observationMode": "source-observed",
          "sourceHealthRequired": true,
          "thresholdPolicy": "owner-defined"
        },
        "id": "supplier-performance-signal",
        "immutable": false,
        "indexes": [
          {
            "fieldIds": [
              "supplier-performance-signal-id"
            ],
            "id": "supplier-performance-signal-primary",
            "introducedIn": "4.3.0",
            "unique": true
          },
          {
            "fieldIds": [
              "supplier-party-id",
              "lifecycle-state"
            ],
            "id": "supplier-performance-signal-by-supplier-and-status",
            "introducedIn": "4.3.0",
            "unique": false
          },
          {
            "fieldIds": [
              "observation-set-version"
            ],
            "id": "supplier-performance-signal-by-observation-set-version",
            "introducedIn": "4.3.0",
            "unique": false
          },
          {
            "fieldIds": [
              "duplicate-of-supplier-performance-signal-id"
            ],
            "id": "supplier-performance-signal-by-duplicate-predecessor",
            "introducedIn": "4.3.0",
            "unique": false
          },
          {
            "fieldIds": [
              "routing-action-proposal-id"
            ],
            "id": "supplier-performance-signal-by-routing-proposal",
            "introducedIn": "4.3.0",
            "unique": false
          },
          {
            "fieldIds": [
              "supplier-remediation-action-id"
            ],
            "id": "supplier-performance-signal-by-remediation-action",
            "introducedIn": "4.3.0",
            "unique": false
          }
        ],
        "introducedIn": "4.3.0",
        "kind": "assessment",
        "label": "Supplier performance signal",
        "lifecycle": [
          "candidate",
          "actionable",
          "dismissed",
          "disputed",
          "routed",
          "recovery-monitoring",
          "recovered",
          "superseded"
        ],
        "lifecycleFieldId": "lifecycle-state",
        "ownerBusinessModuleId": "supplier-performance-monitor-correct",
        "owningDomainWorkblockId": "supplier-performance-innovation-relationship",
        "permissionDefinition": true,
        "platformTargets": [
          {
            "id": "workblock-schema-datastore",
            "status": "direction"
          },
          {
            "id": "lake-silver-projection",
            "status": "direction"
          }
        ],
        "pluralLabel": "Supplier performance signals",
        "primaryKey": "supplier-performance-signal-id",
        "provenanceContract": {
          "actorRequired": true,
          "evidenceRequired": true,
          "limitationsRequired": true,
          "sourceAuthorityRequired": true,
          "sourceVersionRequired": true,
          "transformationVersionRequired": true
        },
        "recordEnvelopeId": "ledger-record-envelope",
        "relationships": [
          {
            "cardinality": "many-to-one",
            "definition": "Links the signal to its canonical supplier party.",
            "id": "supplier-performance-signal-belongs-to-party-performance-signal-supplier",
            "introducedIn": "4.3.0",
            "predicate": "belongs-to",
            "qualifiedId": "supplier-performance-signal-belongs-to-party-performance-signal-supplier",
            "required": true,
            "sourceFieldId": "supplier-party-id",
            "targetEntityId": "party",
            "targetFieldId": "party-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the signal to the exact canonical observations from which it was derived.",
            "id": "supplier-performance-signal-derived-from-supplier-performance-observation-signal-observations",
            "introducedIn": "4.3.0",
            "predicate": "derived-from",
            "qualifiedId": "supplier-performance-signal-derived-from-supplier-performance-observation-signal-observations",
            "required": true,
            "sourceFieldId": "observation-ids",
            "targetEntityId": "supplier-performance-observation",
            "targetFieldId": "supplier-performance-observation-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links the signal, dispute, routing and recovery states to governed evidence.",
            "id": "supplier-performance-signal-evidenced-by-evidence-item-signal-evidence",
            "introducedIn": "4.3.0",
            "predicate": "evidenced-by",
            "qualifiedId": "supplier-performance-signal-evidenced-by-evidence-item-signal-evidence",
            "required": true,
            "sourceFieldId": "evidence-item-ids",
            "targetEntityId": "evidence-item",
            "targetFieldId": "evidence-item-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Binds materiality, dispute, routing and recovery interpretation to the exact policy version.",
            "id": "supplier-performance-signal-governed-by-policy-version-signal-policy",
            "introducedIn": "4.3.0",
            "predicate": "governed-by",
            "qualifiedId": "supplier-performance-signal-governed-by-policy-version-signal-policy",
            "required": true,
            "sourceFieldId": "policy-version-id",
            "targetEntityId": "policy-version",
            "targetFieldId": "policy-version-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links consequential signal disposition and routing to the exact authority envelope without granting remediation ownership.",
            "id": "supplier-performance-signal-governed-by-authority-envelope-signal-authority",
            "introducedIn": "4.3.0",
            "predicate": "governed-by",
            "qualifiedId": "supplier-performance-signal-governed-by-authority-envelope-signal-authority",
            "required": false,
            "sourceFieldId": "authority-envelope-id",
            "targetEntityId": "authority-envelope",
            "targetFieldId": "authority-envelope-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links a duplicate disposition to the canonical earlier signal.",
            "id": "supplier-performance-signal-references-supplier-performance-signal-duplicate-predecessor",
            "introducedIn": "4.3.0",
            "predicate": "references",
            "qualifiedId": "supplier-performance-signal-references-supplier-performance-signal-duplicate-predecessor",
            "required": false,
            "sourceFieldId": "duplicate-of-supplier-performance-signal-id",
            "targetEntityId": "supplier-performance-signal",
            "targetFieldId": "supplier-performance-signal-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links a disputed signal to its evidence-linked disposition decision.",
            "id": "supplier-performance-signal-governed-by-decision-signal-dispute",
            "introducedIn": "4.3.0",
            "predicate": "governed-by",
            "qualifiedId": "supplier-performance-signal-governed-by-decision-signal-dispute",
            "required": false,
            "sourceFieldId": "dispute-decision-id",
            "targetEntityId": "decision",
            "targetFieldId": "decision-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the signal to the cross-owner proposal routed to the declared remediation owner.",
            "id": "supplier-performance-signal-references-action-proposal-corrective-routing",
            "introducedIn": "4.3.0",
            "predicate": "references",
            "qualifiedId": "supplier-performance-signal-references-action-proposal-corrective-routing",
            "required": false,
            "sourceFieldId": "routing-action-proposal-id",
            "targetEntityId": "action-proposal",
            "targetFieldId": "action-proposal-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links the signal to a corrective action accepted and owned by supplier-remediation-exit.",
            "id": "supplier-performance-signal-references-supplier-remediation-action-owned-corrective-action",
            "introducedIn": "4.3.0",
            "predicate": "references",
            "qualifiedId": "supplier-performance-signal-references-supplier-remediation-action-owned-corrective-action",
            "required": false,
            "sourceFieldId": "supplier-remediation-action-id",
            "targetEntityId": "supplier-remediation-action",
            "targetFieldId": "supplier-remediation-action-id"
          },
          {
            "cardinality": "many-to-many",
            "definition": "Links a recovery evaluation to the later observations used to prove sustained change.",
            "id": "supplier-performance-signal-derived-from-supplier-performance-observation-recovery-observations",
            "introducedIn": "4.3.0",
            "predicate": "derived-from",
            "qualifiedId": "supplier-performance-signal-derived-from-supplier-performance-observation-recovery-observations",
            "required": false,
            "sourceFieldId": "recovery-observation-ids",
            "targetEntityId": "supplier-performance-observation",
            "targetFieldId": "supplier-performance-observation-id"
          },
          {
            "cardinality": "many-to-one",
            "definition": "Links recovery state to the independent decision that the policy-defined recovery evidence is sufficient.",
            "id": "supplier-performance-signal-governed-by-decision-recovery-verification",
            "introducedIn": "4.3.0",
            "predicate": "governed-by",
            "qualifiedId": "supplier-performance-signal-governed-by-decision-recovery-verification",
            "required": false,
            "sourceFieldId": "recovery-decision-id",
            "targetEntityId": "decision",
            "targetFieldId": "decision-id"
          }
        ],
        "retentionClass": "evidence",
        "searchTerms": [
          "supplier performance signal",
          "material performance change",
          "corrective action proposal",
          "performance dispute",
          "sustained recovery"
        ],
        "semanticAnnotation": {
          "agentGuidance": {
            "competencyQuestions": [
              "Which performance signals are open for this supplier and what evidence supports them?",
              "Was this signal dismissed, disputed, routed or verified as recovered?"
            ],
            "retrievalTerms": [
              "breach",
              "alert",
              "threshold",
              "remediation routing"
            ],
            "usage": "Interpret exact observations into versioned, evidence-linked signals that may be dismissed, disputed, routed to the remediation owner or verified as recovered; never mutate the underlying observations."
          },
          "introducedIn": "4.5.0",
          "semanticLabel": {
            "aliases": [
              "performance alert",
              "breach signal"
            ],
            "concept": "interpreted-performance-signal",
            "doNotConfuseWith": [
              {
                "distinction": "A signal is an interpretation that may route to remediation; the review record is the versioned decision over observations and scorecard.",
                "targetEntityId": "supplier-performance-review-record"
              }
            ]
          }
        },
        "sourceSystemRoleIds": [
          "analytical-system",
          "evidence-source",
          "system-of-record"
        ],
        "storageClass": "tenant-record",
        "version": "4.0.0",
        "writebackSystemRoleIds": []
      }
    ],
    "involvements": [
      {
        "id": "accountable-accountable-risk-owner-domain-workblock-supplier-lifecycle-third-party-risk",
        "relation": "accountable",
        "roleId": "accountable-risk-owner",
        "targetId": "supplier-lifecycle-third-party-risk",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-ap-processor-domain-workblock-invoice-exception-payment-readiness",
        "relation": "accountable",
        "roleId": "ap-processor",
        "targetId": "invoice-exception-payment-readiness",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-ap-processor-entity-invoice",
        "relation": "accountable",
        "roleId": "ap-processor",
        "targetId": "invoice",
        "targetKind": "entity"
      },
      {
        "id": "accountable-ap-processor-entity-invoice-exception",
        "relation": "accountable",
        "roleId": "ap-processor",
        "targetId": "invoice-exception",
        "targetKind": "entity"
      },
      {
        "id": "accountable-ap-processor-entity-invoice-line",
        "relation": "accountable",
        "roleId": "ap-processor",
        "targetId": "invoice-line",
        "targetKind": "entity"
      },
      {
        "id": "accountable-ap-processor-entity-invoice-match-assessment",
        "relation": "accountable",
        "roleId": "ap-processor",
        "targetId": "invoice-match-assessment",
        "targetKind": "entity"
      },
      {
        "id": "accountable-ap-processor-entity-payment-execution-status",
        "relation": "accountable",
        "roleId": "ap-processor",
        "targetId": "payment-execution-status",
        "targetKind": "entity"
      },
      {
        "id": "accountable-ap-processor-entity-payment-instruction",
        "relation": "accountable",
        "roleId": "ap-processor",
        "targetId": "payment-instruction",
        "targetKind": "entity"
      },
      {
        "id": "accountable-ap-processor-entity-payment-readiness-assessment",
        "relation": "accountable",
        "roleId": "ap-processor",
        "targetId": "payment-readiness-assessment",
        "targetKind": "entity"
      },
      {
        "id": "accountable-ap-processor-entity-supplier-invoice-resolution",
        "relation": "accountable",
        "roleId": "ap-processor",
        "targetId": "supplier-invoice-resolution",
        "targetKind": "entity"
      },
      {
        "id": "accountable-award-authority-domain-workblock-sourcing-negotiation",
        "relation": "accountable",
        "roleId": "award-authority",
        "targetId": "sourcing-negotiation",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-budget-owner-domain-workblock-buying-ordering-receiving",
        "relation": "accountable",
        "roleId": "budget-owner",
        "targetId": "buying-ordering-receiving",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-budget-owner-domain-workblock-value-realization-savings",
        "relation": "accountable",
        "roleId": "budget-owner",
        "targetId": "value-realization-savings",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-category-manager-domain-workblock-contract-lifecycle-management",
        "relation": "accountable",
        "roleId": "category-manager",
        "targetId": "contract-lifecycle-management",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-category-manager-domain-workblock-strategy-policy-category-spend",
        "relation": "accountable",
        "roleId": "category-manager",
        "targetId": "strategy-policy-category-spend",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-category-manager-domain-workblock-value-realization-savings",
        "relation": "accountable",
        "roleId": "category-manager",
        "targetId": "value-realization-savings",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-category-manager-entity-category-opportunity",
        "relation": "accountable",
        "roleId": "category-manager",
        "targetId": "category-opportunity",
        "targetKind": "entity"
      },
      {
        "id": "accountable-category-manager-entity-category-strategy",
        "relation": "accountable",
        "roleId": "category-manager",
        "targetId": "category-strategy",
        "targetKind": "entity"
      },
      {
        "id": "accountable-category-manager-entity-policy-guidance-result",
        "relation": "accountable",
        "roleId": "category-manager",
        "targetId": "policy-guidance-result",
        "targetKind": "entity"
      },
      {
        "id": "accountable-category-manager-entity-policy-rule-release",
        "relation": "accountable",
        "roleId": "category-manager",
        "targetId": "policy-rule-release",
        "targetKind": "entity"
      },
      {
        "id": "accountable-category-manager-entity-spend-classification-decision",
        "relation": "accountable",
        "roleId": "category-manager",
        "targetId": "spend-classification-decision",
        "targetKind": "entity"
      },
      {
        "id": "accountable-category-manager-entity-spend-record",
        "relation": "accountable",
        "roleId": "category-manager",
        "targetId": "spend-record",
        "targetKind": "entity"
      },
      {
        "id": "accountable-category-manager-entity-tail-spend-evaluation",
        "relation": "accountable",
        "roleId": "category-manager",
        "targetId": "tail-spend-evaluation",
        "targetKind": "entity"
      },
      {
        "id": "accountable-category-manager-entity-tail-spend-rule",
        "relation": "accountable",
        "roleId": "category-manager",
        "targetId": "tail-spend-rule",
        "targetKind": "entity"
      },
      {
        "id": "accountable-contract-manager-domain-workblock-contract-lifecycle-management",
        "relation": "accountable",
        "roleId": "contract-manager",
        "targetId": "contract-lifecycle-management",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-contract-manager-entity-clause-deviation",
        "relation": "accountable",
        "roleId": "contract-manager",
        "targetId": "clause-deviation",
        "targetKind": "entity"
      },
      {
        "id": "accountable-contract-manager-entity-clause-library-entry",
        "relation": "accountable",
        "roleId": "contract-manager",
        "targetId": "clause-library-entry",
        "targetKind": "entity"
      },
      {
        "id": "accountable-contract-manager-entity-contract",
        "relation": "accountable",
        "roleId": "contract-manager",
        "targetId": "contract",
        "targetKind": "entity"
      },
      {
        "id": "accountable-contract-manager-entity-contract-approval",
        "relation": "accountable",
        "roleId": "contract-manager",
        "targetId": "contract-approval",
        "targetKind": "entity"
      },
      {
        "id": "accountable-contract-manager-entity-contract-change",
        "relation": "accountable",
        "roleId": "contract-manager",
        "targetId": "contract-change",
        "targetKind": "entity"
      },
      {
        "id": "accountable-contract-manager-entity-contract-compliance-finding",
        "relation": "accountable",
        "roleId": "contract-manager",
        "targetId": "contract-compliance-finding",
        "targetKind": "entity"
      },
      {
        "id": "accountable-contract-manager-entity-contract-entitlement",
        "relation": "accountable",
        "roleId": "contract-manager",
        "targetId": "contract-entitlement",
        "targetKind": "entity"
      },
      {
        "id": "accountable-contract-manager-entity-contract-intake",
        "relation": "accountable",
        "roleId": "contract-manager",
        "targetId": "contract-intake",
        "targetKind": "entity"
      },
      {
        "id": "accountable-contract-manager-entity-contract-obligation",
        "relation": "accountable",
        "roleId": "contract-manager",
        "targetId": "contract-obligation",
        "targetKind": "entity"
      },
      {
        "id": "accountable-contract-manager-entity-contract-template",
        "relation": "accountable",
        "roleId": "contract-manager",
        "targetId": "contract-template",
        "targetKind": "entity"
      },
      {
        "id": "accountable-contract-manager-entity-contract-version",
        "relation": "accountable",
        "roleId": "contract-manager",
        "targetId": "contract-version",
        "targetKind": "entity"
      },
      {
        "id": "accountable-controller-domain-workblock-invoice-exception-payment-readiness",
        "relation": "accountable",
        "roleId": "controller",
        "targetId": "invoice-exception-payment-readiness",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-data-steward-domain-workblock-strategy-policy-category-spend",
        "relation": "accountable",
        "roleId": "data-steward",
        "targetId": "strategy-policy-category-spend",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-demand-owner-domain-workblock-intake-demand",
        "relation": "accountable",
        "roleId": "demand-owner",
        "targetId": "intake-demand",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-evaluator-domain-workblock-sourcing-negotiation",
        "relation": "accountable",
        "roleId": "evaluator",
        "targetId": "sourcing-negotiation",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-finance-delegate-domain-workblock-value-realization-savings",
        "relation": "accountable",
        "roleId": "finance-delegate",
        "targetId": "value-realization-savings",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-governance-owner-domain-workblock-supplier-performance-innovation-relationship",
        "relation": "accountable",
        "roleId": "governance-owner",
        "targetId": "supplier-performance-innovation-relationship",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-innovation-sponsor-domain-workblock-supplier-performance-innovation-relationship",
        "relation": "accountable",
        "roleId": "innovation-sponsor",
        "targetId": "supplier-performance-innovation-relationship",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-intake-owner-domain-workblock-intake-demand",
        "relation": "accountable",
        "roleId": "intake-owner",
        "targetId": "intake-demand",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-integration-owner-domain-workblock-buying-ordering-receiving",
        "relation": "accountable",
        "roleId": "integration-owner",
        "targetId": "buying-ordering-receiving",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-legal-counsel-domain-workblock-contract-lifecycle-management",
        "relation": "accountable",
        "roleId": "legal-counsel",
        "targetId": "contract-lifecycle-management",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-metric-owner-domain-workblock-supplier-performance-innovation-relationship",
        "relation": "accountable",
        "roleId": "metric-owner",
        "targetId": "supplier-performance-innovation-relationship",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-negotiation-lead-domain-workblock-sourcing-negotiation",
        "relation": "accountable",
        "roleId": "negotiation-lead",
        "targetId": "sourcing-negotiation",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-obligation-owner-domain-workblock-contract-lifecycle-management",
        "relation": "accountable",
        "roleId": "obligation-owner",
        "targetId": "contract-lifecycle-management",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-onboarding-coordinator-domain-workblock-supplier-lifecycle-third-party-risk",
        "relation": "accountable",
        "roleId": "onboarding-coordinator",
        "targetId": "supplier-lifecycle-third-party-risk",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-onboarding-coordinator-entity-supplier-master-change",
        "relation": "accountable",
        "roleId": "onboarding-coordinator",
        "targetId": "supplier-master-change",
        "targetKind": "entity"
      },
      {
        "id": "accountable-onboarding-coordinator-entity-supplier-offboarding-case",
        "relation": "accountable",
        "roleId": "onboarding-coordinator",
        "targetId": "supplier-offboarding-case",
        "targetKind": "entity"
      },
      {
        "id": "accountable-onboarding-coordinator-entity-supplier-onboarding-case",
        "relation": "accountable",
        "roleId": "onboarding-coordinator",
        "targetId": "supplier-onboarding-case",
        "targetKind": "entity"
      },
      {
        "id": "accountable-onboarding-coordinator-entity-supplier-profile",
        "relation": "accountable",
        "roleId": "onboarding-coordinator",
        "targetId": "supplier-profile",
        "targetKind": "entity"
      },
      {
        "id": "accountable-onboarding-coordinator-entity-supplier-qualification",
        "relation": "accountable",
        "roleId": "onboarding-coordinator",
        "targetId": "supplier-qualification",
        "targetKind": "entity"
      },
      {
        "id": "accountable-onboarding-coordinator-entity-supplier-remediation-action",
        "relation": "accountable",
        "roleId": "onboarding-coordinator",
        "targetId": "supplier-remediation-action",
        "targetKind": "entity"
      },
      {
        "id": "accountable-onboarding-coordinator-entity-supplier-risk-assessment",
        "relation": "accountable",
        "roleId": "onboarding-coordinator",
        "targetId": "supplier-risk-assessment",
        "targetKind": "entity"
      },
      {
        "id": "accountable-onboarding-coordinator-entity-supplier-risk-case",
        "relation": "accountable",
        "roleId": "onboarding-coordinator",
        "targetId": "supplier-risk-case",
        "targetKind": "entity"
      },
      {
        "id": "accountable-onboarding-coordinator-entity-supplier-risk-signal",
        "relation": "accountable",
        "roleId": "onboarding-coordinator",
        "targetId": "supplier-risk-signal",
        "targetKind": "entity"
      },
      {
        "id": "accountable-onboarding-coordinator-entity-supplier-tier-link",
        "relation": "accountable",
        "roleId": "onboarding-coordinator",
        "targetId": "supplier-tier-link",
        "targetKind": "entity"
      },
      {
        "id": "accountable-payment-approver-domain-workblock-invoice-exception-payment-readiness",
        "relation": "accountable",
        "roleId": "payment-approver",
        "targetId": "invoice-exception-payment-readiness",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-policy-owner-domain-workblock-strategy-policy-category-spend",
        "relation": "accountable",
        "roleId": "policy-owner",
        "targetId": "strategy-policy-category-spend",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-process-owner-domain-workblock-intake-demand",
        "relation": "accountable",
        "roleId": "process-owner",
        "targetId": "intake-demand",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-procurement-analyst-domain-workblock-strategy-policy-category-spend",
        "relation": "accountable",
        "roleId": "procurement-analyst",
        "targetId": "strategy-policy-category-spend",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-procurement-buyer-domain-workblock-buying-ordering-receiving",
        "relation": "accountable",
        "roleId": "procurement-buyer",
        "targetId": "buying-ordering-receiving",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-receiver-domain-workblock-buying-ordering-receiving",
        "relation": "accountable",
        "roleId": "receiver",
        "targetId": "buying-ordering-receiving",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-relationship-manager-domain-workblock-supplier-performance-innovation-relationship",
        "relation": "accountable",
        "roleId": "relationship-manager",
        "targetId": "supplier-performance-innovation-relationship",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-relationship-manager-entity-supplier-innovation-case",
        "relation": "accountable",
        "roleId": "relationship-manager",
        "targetId": "supplier-innovation-case",
        "targetKind": "entity"
      },
      {
        "id": "accountable-relationship-manager-entity-supplier-joint-value-plan",
        "relation": "accountable",
        "roleId": "relationship-manager",
        "targetId": "supplier-joint-value-plan",
        "targetKind": "entity"
      },
      {
        "id": "accountable-relationship-manager-entity-supplier-performance-observation",
        "relation": "accountable",
        "roleId": "relationship-manager",
        "targetId": "supplier-performance-observation",
        "targetKind": "entity"
      },
      {
        "id": "accountable-relationship-manager-entity-supplier-performance-review-record",
        "relation": "accountable",
        "roleId": "relationship-manager",
        "targetId": "supplier-performance-review-record",
        "targetKind": "entity"
      },
      {
        "id": "accountable-relationship-manager-entity-supplier-segment-assignment",
        "relation": "accountable",
        "roleId": "relationship-manager",
        "targetId": "supplier-segment-assignment",
        "targetKind": "entity"
      },
      {
        "id": "accountable-requester-domain-workblock-buying-ordering-receiving",
        "relation": "accountable",
        "roleId": "requester",
        "targetId": "buying-ordering-receiving",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-requester-domain-workblock-intake-demand",
        "relation": "accountable",
        "roleId": "requester",
        "targetId": "intake-demand",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-requester-entity-budget",
        "relation": "accountable",
        "roleId": "requester",
        "targetId": "budget",
        "targetKind": "entity"
      },
      {
        "id": "accountable-requester-entity-buying-request",
        "relation": "accountable",
        "roleId": "requester",
        "targetId": "buying-request",
        "targetKind": "entity"
      },
      {
        "id": "accountable-requester-entity-demand-case",
        "relation": "accountable",
        "roleId": "requester",
        "targetId": "demand-case",
        "targetKind": "entity"
      },
      {
        "id": "accountable-requester-entity-demand-portfolio",
        "relation": "accountable",
        "roleId": "requester",
        "targetId": "demand-portfolio",
        "targetKind": "entity"
      },
      {
        "id": "accountable-requester-entity-enriched-request",
        "relation": "accountable",
        "roleId": "requester",
        "targetId": "enriched-request",
        "targetKind": "entity"
      },
      {
        "id": "accountable-requester-entity-intake-request",
        "relation": "accountable",
        "roleId": "requester",
        "targetId": "intake-request",
        "targetKind": "entity"
      },
      {
        "id": "accountable-requester-entity-order-line",
        "relation": "accountable",
        "roleId": "requester",
        "targetId": "order-line",
        "targetKind": "entity"
      },
      {
        "id": "accountable-requester-entity-order-response",
        "relation": "accountable",
        "roleId": "requester",
        "targetId": "order-response",
        "targetKind": "entity"
      },
      {
        "id": "accountable-requester-entity-procurement-service-offering",
        "relation": "accountable",
        "roleId": "requester",
        "targetId": "procurement-service-offering",
        "targetKind": "entity"
      },
      {
        "id": "accountable-requester-entity-purchase-order",
        "relation": "accountable",
        "roleId": "requester",
        "targetId": "purchase-order",
        "targetKind": "entity"
      },
      {
        "id": "accountable-requester-entity-purchase-order-exception",
        "relation": "accountable",
        "roleId": "requester",
        "targetId": "purchase-order-exception",
        "targetKind": "entity"
      },
      {
        "id": "accountable-requester-entity-receipt",
        "relation": "accountable",
        "roleId": "requester",
        "targetId": "receipt",
        "targetKind": "entity"
      },
      {
        "id": "accountable-requester-entity-receipt-line",
        "relation": "accountable",
        "roleId": "requester",
        "targetId": "receipt-line",
        "targetKind": "entity"
      },
      {
        "id": "accountable-requester-entity-requisition",
        "relation": "accountable",
        "roleId": "requester",
        "targetId": "requisition",
        "targetKind": "entity"
      },
      {
        "id": "accountable-requester-entity-requisition-line",
        "relation": "accountable",
        "roleId": "requester",
        "targetId": "requisition-line",
        "targetKind": "entity"
      },
      {
        "id": "accountable-requester-entity-return-claim",
        "relation": "accountable",
        "roleId": "requester",
        "targetId": "return-claim",
        "targetKind": "entity"
      },
      {
        "id": "accountable-requester-entity-service-entry-sheet",
        "relation": "accountable",
        "roleId": "requester",
        "targetId": "service-entry-sheet",
        "targetKind": "entity"
      },
      {
        "id": "accountable-requester-entity-shipment",
        "relation": "accountable",
        "roleId": "requester",
        "targetId": "shipment",
        "targetKind": "entity"
      },
      {
        "id": "accountable-risk-owner-domain-workblock-invoice-exception-payment-readiness",
        "relation": "accountable",
        "roleId": "risk-owner",
        "targetId": "invoice-exception-payment-readiness",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-sourcing-lead-domain-workblock-sourcing-negotiation",
        "relation": "accountable",
        "roleId": "sourcing-lead",
        "targetId": "sourcing-negotiation",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-sourcing-lead-entity-award-scenario",
        "relation": "accountable",
        "roleId": "sourcing-lead",
        "targetId": "award-scenario",
        "targetKind": "entity"
      },
      {
        "id": "accountable-sourcing-lead-entity-negotiation-session",
        "relation": "accountable",
        "roleId": "sourcing-lead",
        "targetId": "negotiation-session",
        "targetKind": "entity"
      },
      {
        "id": "accountable-sourcing-lead-entity-sourcing-event-record",
        "relation": "accountable",
        "roleId": "sourcing-lead",
        "targetId": "sourcing-event-record",
        "targetKind": "entity"
      },
      {
        "id": "accountable-sourcing-lead-entity-sourcing-opportunity",
        "relation": "accountable",
        "roleId": "sourcing-lead",
        "targetId": "sourcing-opportunity",
        "targetKind": "entity"
      },
      {
        "id": "accountable-sourcing-lead-entity-supplier-response",
        "relation": "accountable",
        "roleId": "sourcing-lead",
        "targetId": "supplier-response",
        "targetKind": "entity"
      },
      {
        "id": "accountable-sourcing-lead-entity-tactical-sourcing-case",
        "relation": "accountable",
        "roleId": "sourcing-lead",
        "targetId": "tactical-sourcing-case",
        "targetKind": "entity"
      },
      {
        "id": "accountable-sourcing-manager-domain-workblock-contract-lifecycle-management",
        "relation": "accountable",
        "roleId": "sourcing-manager",
        "targetId": "contract-lifecycle-management",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-supplier-account-lead-domain-workblock-supplier-performance-innovation-relationship",
        "relation": "accountable",
        "roleId": "supplier-account-lead",
        "targetId": "supplier-performance-innovation-relationship",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-supplier-contact-domain-workblock-supplier-lifecycle-third-party-risk",
        "relation": "accountable",
        "roleId": "supplier-contact",
        "targetId": "supplier-lifecycle-third-party-risk",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-supplier-master-steward-domain-workblock-supplier-lifecycle-third-party-risk",
        "relation": "accountable",
        "roleId": "supplier-master-steward",
        "targetId": "supplier-lifecycle-third-party-risk",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-tprm-programme-owner-domain-workblock-supplier-lifecycle-third-party-risk",
        "relation": "accountable",
        "roleId": "tprm-programme-owner",
        "targetId": "supplier-lifecycle-third-party-risk",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-treasury-manager-domain-workblock-invoice-exception-payment-readiness",
        "relation": "accountable",
        "roleId": "treasury-manager",
        "targetId": "invoice-exception-payment-readiness",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-value-lead-domain-workblock-value-realization-savings",
        "relation": "accountable",
        "roleId": "value-lead",
        "targetId": "value-realization-savings",
        "targetKind": "domain-workblock"
      },
      {
        "id": "accountable-value-lead-entity-savings-initiative-record",
        "relation": "accountable",
        "roleId": "value-lead",
        "targetId": "savings-initiative-record",
        "targetKind": "entity"
      },
      {
        "id": "accountable-value-lead-entity-value-leakage-finding",
        "relation": "accountable",
        "roleId": "value-lead",
        "targetId": "value-leakage-finding",
        "targetKind": "entity"
      },
      {
        "id": "accountable-value-lead-entity-value-opportunity-baseline",
        "relation": "accountable",
        "roleId": "value-lead",
        "targetId": "value-opportunity-baseline",
        "targetKind": "entity"
      },
      {
        "id": "accountable-value-lead-entity-value-portfolio-forecast",
        "relation": "accountable",
        "roleId": "value-lead",
        "targetId": "value-portfolio-forecast",
        "targetKind": "entity"
      },
      {
        "id": "accountable-value-lead-entity-value-realization-attribution",
        "relation": "accountable",
        "roleId": "value-lead",
        "targetId": "value-realization-attribution",
        "targetKind": "entity"
      },
      {
        "id": "consulted-accountable-risk-owner-business-module-continuous-risk-monitoring",
        "relation": "consulted",
        "roleId": "accountable-risk-owner",
        "targetId": "continuous-risk-monitoring",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-accountable-risk-owner-business-module-supplier-master-qualification",
        "relation": "consulted",
        "roleId": "accountable-risk-owner",
        "targetId": "supplier-master-qualification",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-accountable-risk-owner-business-module-supplier-onboarding",
        "relation": "consulted",
        "roleId": "accountable-risk-owner",
        "targetId": "supplier-onboarding",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-ap-processor-business-module-payment-readiness",
        "relation": "consulted",
        "roleId": "ap-processor",
        "targetId": "payment-readiness",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-award-authority-business-module-bid-evaluation-award",
        "relation": "consulted",
        "roleId": "award-authority",
        "targetId": "bid-evaluation-award",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-award-authority-business-module-negotiation-copilot",
        "relation": "consulted",
        "roleId": "award-authority",
        "targetId": "negotiation-copilot",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-award-authority-business-module-sourcing-event",
        "relation": "consulted",
        "roleId": "award-authority",
        "targetId": "sourcing-event",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-award-authority-business-module-tactical-sourcing-autonomy",
        "relation": "consulted",
        "roleId": "award-authority",
        "targetId": "tactical-sourcing-autonomy",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-budget-owner-business-module-purchase-order-exception",
        "relation": "consulted",
        "roleId": "budget-owner",
        "targetId": "purchase-order-exception",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-budget-owner-business-module-realization-reconciliation-attribution",
        "relation": "consulted",
        "roleId": "budget-owner",
        "targetId": "realization-reconciliation-attribution",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-budget-owner-business-module-requisition-policy-routing",
        "relation": "consulted",
        "roleId": "budget-owner",
        "targetId": "requisition-policy-routing",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-budget-owner-business-module-savings-initiative",
        "relation": "consulted",
        "roleId": "budget-owner",
        "targetId": "savings-initiative",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-budget-owner-business-module-value-leakage-monitor",
        "relation": "consulted",
        "roleId": "budget-owner",
        "targetId": "value-leakage-monitor",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-budget-owner-business-module-value-opportunity-baseline",
        "relation": "consulted",
        "roleId": "budget-owner",
        "targetId": "value-opportunity-baseline",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-budget-owner-business-module-value-portfolio-forecast",
        "relation": "consulted",
        "roleId": "budget-owner",
        "targetId": "value-portfolio-forecast",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-category-manager-business-module-contract-approval-repository",
        "relation": "consulted",
        "roleId": "category-manager",
        "targetId": "contract-approval-repository",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-category-manager-business-module-contract-authoring-review",
        "relation": "consulted",
        "roleId": "category-manager",
        "targetId": "contract-authoring-review",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-category-manager-business-module-policy-guidance",
        "relation": "consulted",
        "roleId": "category-manager",
        "targetId": "policy-guidance",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-category-manager-business-module-realization-reconciliation-attribution",
        "relation": "consulted",
        "roleId": "category-manager",
        "targetId": "realization-reconciliation-attribution",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-category-manager-business-module-value-leakage-monitor",
        "relation": "consulted",
        "roleId": "category-manager",
        "targetId": "value-leakage-monitor",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-category-manager-business-module-value-opportunity-baseline",
        "relation": "consulted",
        "roleId": "category-manager",
        "targetId": "value-opportunity-baseline",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-category-manager-business-module-value-portfolio-forecast",
        "relation": "consulted",
        "roleId": "category-manager",
        "targetId": "value-portfolio-forecast",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-controller-business-module-invoice-exception-triage",
        "relation": "consulted",
        "roleId": "controller",
        "targetId": "invoice-exception-triage",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-controller-business-module-invoice-intake-match",
        "relation": "consulted",
        "roleId": "controller",
        "targetId": "invoice-intake-match",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-controller-business-module-payment-execution-guard",
        "relation": "consulted",
        "roleId": "controller",
        "targetId": "payment-execution-guard",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-controller-business-module-supplier-invoice-resolution",
        "relation": "consulted",
        "roleId": "controller",
        "targetId": "supplier-invoice-resolution",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-data-steward-business-module-category-opportunity-radar",
        "relation": "consulted",
        "roleId": "data-steward",
        "targetId": "category-opportunity-radar",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-data-steward-business-module-policy-rule-lifecycle",
        "relation": "consulted",
        "roleId": "data-steward",
        "targetId": "policy-rule-lifecycle",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-data-steward-business-module-spend-data-foundation",
        "relation": "consulted",
        "roleId": "data-steward",
        "targetId": "spend-data-foundation",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-demand-owner-business-module-intelligent-intake",
        "relation": "consulted",
        "roleId": "demand-owner",
        "targetId": "intelligent-intake",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-demand-owner-business-module-request-enrichment-routing",
        "relation": "consulted",
        "roleId": "demand-owner",
        "targetId": "request-enrichment-routing",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-evaluator-business-module-sourcing-pipeline-discovery",
        "relation": "consulted",
        "roleId": "evaluator",
        "targetId": "sourcing-pipeline-discovery",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-evaluator-business-module-tactical-sourcing-autonomy",
        "relation": "consulted",
        "roleId": "evaluator",
        "targetId": "tactical-sourcing-autonomy",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-finance-delegate-business-module-value-leakage-monitor",
        "relation": "consulted",
        "roleId": "finance-delegate",
        "targetId": "value-leakage-monitor",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-finance-delegate-business-module-value-opportunity-baseline",
        "relation": "consulted",
        "roleId": "finance-delegate",
        "targetId": "value-opportunity-baseline",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-finance-delegate-business-module-value-portfolio-forecast",
        "relation": "consulted",
        "roleId": "finance-delegate",
        "targetId": "value-portfolio-forecast",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-governance-owner-business-module-supplier-innovation-pipeline",
        "relation": "consulted",
        "roleId": "governance-owner",
        "targetId": "supplier-innovation-pipeline",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-governance-owner-business-module-supplier-performance-monitor-correct",
        "relation": "consulted",
        "roleId": "governance-owner",
        "targetId": "supplier-performance-monitor-correct",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-governance-owner-business-module-supplier-performance-review",
        "relation": "consulted",
        "roleId": "governance-owner",
        "targetId": "supplier-performance-review",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-governance-owner-business-module-supplier-relationship-joint-value",
        "relation": "consulted",
        "roleId": "governance-owner",
        "targetId": "supplier-relationship-joint-value",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-innovation-sponsor-business-module-supplier-relationship-joint-value",
        "relation": "consulted",
        "roleId": "innovation-sponsor",
        "targetId": "supplier-relationship-joint-value",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-intake-owner-business-module-demand-consolidation-portfolio",
        "relation": "consulted",
        "roleId": "intake-owner",
        "targetId": "demand-consolidation-portfolio",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-intake-owner-business-module-demand-orchestration",
        "relation": "consulted",
        "roleId": "intake-owner",
        "targetId": "demand-orchestration",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-intake-owner-business-module-procurement-service-catalogue",
        "relation": "consulted",
        "roleId": "intake-owner",
        "targetId": "procurement-service-catalogue",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-integration-owner-business-module-guided-buying",
        "relation": "consulted",
        "roleId": "integration-owner",
        "targetId": "guided-buying",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-integration-owner-business-module-purchase-order-orchestration",
        "relation": "consulted",
        "roleId": "integration-owner",
        "targetId": "purchase-order-orchestration",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-integration-owner-business-module-receiving-service-entry",
        "relation": "consulted",
        "roleId": "integration-owner",
        "targetId": "receiving-service-entry",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-legal-counsel-business-module-contract-approval-repository",
        "relation": "consulted",
        "roleId": "legal-counsel",
        "targetId": "contract-approval-repository",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-legal-counsel-business-module-contract-intake-digitization",
        "relation": "consulted",
        "roleId": "legal-counsel",
        "targetId": "contract-intake-digitization",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-legal-counsel-business-module-obligation-monitoring",
        "relation": "consulted",
        "roleId": "legal-counsel",
        "targetId": "obligation-monitoring",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-legal-counsel-business-module-renewal-change-compliance",
        "relation": "consulted",
        "roleId": "legal-counsel",
        "targetId": "renewal-change-compliance",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-metric-owner-business-module-supplier-performance-review",
        "relation": "consulted",
        "roleId": "metric-owner",
        "targetId": "supplier-performance-review",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-metric-owner-business-module-supplier-relationship-joint-value",
        "relation": "consulted",
        "roleId": "metric-owner",
        "targetId": "supplier-relationship-joint-value",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-metric-owner-business-module-supplier-segmentation-governance",
        "relation": "consulted",
        "roleId": "metric-owner",
        "targetId": "supplier-segmentation-governance",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-negotiation-lead-business-module-sourcing-event",
        "relation": "consulted",
        "roleId": "negotiation-lead",
        "targetId": "sourcing-event",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-negotiation-lead-business-module-tactical-sourcing-autonomy",
        "relation": "consulted",
        "roleId": "negotiation-lead",
        "targetId": "tactical-sourcing-autonomy",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-obligation-owner-business-module-contract-authoring-review",
        "relation": "consulted",
        "roleId": "obligation-owner",
        "targetId": "contract-authoring-review",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-obligation-owner-business-module-renewal-change-compliance",
        "relation": "consulted",
        "roleId": "obligation-owner",
        "targetId": "renewal-change-compliance",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-onboarding-coordinator-business-module-supplier-master-qualification",
        "relation": "consulted",
        "roleId": "onboarding-coordinator",
        "targetId": "supplier-master-qualification",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-onboarding-coordinator-business-module-supplier-remediation-exit",
        "relation": "consulted",
        "roleId": "onboarding-coordinator",
        "targetId": "supplier-remediation-exit",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-onboarding-coordinator-business-module-third-party-risk-review",
        "relation": "consulted",
        "roleId": "onboarding-coordinator",
        "targetId": "third-party-risk-review",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-policy-owner-business-module-category-opportunity-radar",
        "relation": "consulted",
        "roleId": "policy-owner",
        "targetId": "category-opportunity-radar",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-policy-owner-business-module-category-strategy-orchestrator",
        "relation": "consulted",
        "roleId": "policy-owner",
        "targetId": "category-strategy-orchestrator",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-process-owner-business-module-demand-consolidation-portfolio",
        "relation": "consulted",
        "roleId": "process-owner",
        "targetId": "demand-consolidation-portfolio",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-process-owner-business-module-demand-orchestration",
        "relation": "consulted",
        "roleId": "process-owner",
        "targetId": "demand-orchestration",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-process-owner-business-module-intelligent-intake",
        "relation": "consulted",
        "roleId": "process-owner",
        "targetId": "intelligent-intake",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-process-owner-business-module-request-enrichment-routing",
        "relation": "consulted",
        "roleId": "process-owner",
        "targetId": "request-enrichment-routing",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-procurement-analyst-business-module-category-strategy-orchestrator",
        "relation": "consulted",
        "roleId": "procurement-analyst",
        "targetId": "category-strategy-orchestrator",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-procurement-buyer-business-module-receiving-service-entry",
        "relation": "consulted",
        "roleId": "procurement-buyer",
        "targetId": "receiving-service-entry",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-relationship-manager-business-module-supplier-innovation-pipeline",
        "relation": "consulted",
        "roleId": "relationship-manager",
        "targetId": "supplier-innovation-pipeline",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-relationship-manager-business-module-supplier-performance-monitor-correct",
        "relation": "consulted",
        "roleId": "relationship-manager",
        "targetId": "supplier-performance-monitor-correct",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-relationship-manager-business-module-supplier-segmentation-governance",
        "relation": "consulted",
        "roleId": "relationship-manager",
        "targetId": "supplier-segmentation-governance",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-requester-business-module-demand-orchestration",
        "relation": "consulted",
        "roleId": "requester",
        "targetId": "demand-orchestration",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-requester-business-module-procurement-service-catalogue",
        "relation": "consulted",
        "roleId": "requester",
        "targetId": "procurement-service-catalogue",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-requester-business-module-purchase-order-exception",
        "relation": "consulted",
        "roleId": "requester",
        "targetId": "purchase-order-exception",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-requester-business-module-receiving-service-entry",
        "relation": "consulted",
        "roleId": "requester",
        "targetId": "receiving-service-entry",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-requester-business-module-request-enrichment-routing",
        "relation": "consulted",
        "roleId": "requester",
        "targetId": "request-enrichment-routing",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-requester-business-module-requisition-policy-routing",
        "relation": "consulted",
        "roleId": "requester",
        "targetId": "requisition-policy-routing",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-risk-owner-business-module-invoice-exception-triage",
        "relation": "consulted",
        "roleId": "risk-owner",
        "targetId": "invoice-exception-triage",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-risk-owner-business-module-invoice-intake-match",
        "relation": "consulted",
        "roleId": "risk-owner",
        "targetId": "invoice-intake-match",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-risk-owner-business-module-payment-execution-guard",
        "relation": "consulted",
        "roleId": "risk-owner",
        "targetId": "payment-execution-guard",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-risk-owner-business-module-payment-readiness",
        "relation": "consulted",
        "roleId": "risk-owner",
        "targetId": "payment-readiness",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-sourcing-lead-business-module-bid-evaluation-award",
        "relation": "consulted",
        "roleId": "sourcing-lead",
        "targetId": "bid-evaluation-award",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-sourcing-lead-business-module-negotiation-copilot",
        "relation": "consulted",
        "roleId": "sourcing-lead",
        "targetId": "negotiation-copilot",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-sourcing-manager-business-module-contract-approval-repository",
        "relation": "consulted",
        "roleId": "sourcing-manager",
        "targetId": "contract-approval-repository",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-sourcing-manager-business-module-contract-intake-digitization",
        "relation": "consulted",
        "roleId": "sourcing-manager",
        "targetId": "contract-intake-digitization",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-sourcing-manager-business-module-obligation-monitoring",
        "relation": "consulted",
        "roleId": "sourcing-manager",
        "targetId": "obligation-monitoring",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-sourcing-manager-business-module-renewal-change-compliance",
        "relation": "consulted",
        "roleId": "sourcing-manager",
        "targetId": "renewal-change-compliance",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-supplier-account-lead-business-module-supplier-innovation-pipeline",
        "relation": "consulted",
        "roleId": "supplier-account-lead",
        "targetId": "supplier-innovation-pipeline",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-supplier-account-lead-business-module-supplier-performance-monitor-correct",
        "relation": "consulted",
        "roleId": "supplier-account-lead",
        "targetId": "supplier-performance-monitor-correct",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-supplier-account-lead-business-module-supplier-performance-review",
        "relation": "consulted",
        "roleId": "supplier-account-lead",
        "targetId": "supplier-performance-review",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-supplier-account-lead-business-module-supplier-relationship-joint-value",
        "relation": "consulted",
        "roleId": "supplier-account-lead",
        "targetId": "supplier-relationship-joint-value",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-supplier-contact-business-module-supplier-remediation-exit",
        "relation": "consulted",
        "roleId": "supplier-contact",
        "targetId": "supplier-remediation-exit",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-supplier-contact-business-module-third-party-risk-review",
        "relation": "consulted",
        "roleId": "supplier-contact",
        "targetId": "third-party-risk-review",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-tprm-programme-owner-business-module-supplier-master-qualification",
        "relation": "consulted",
        "roleId": "tprm-programme-owner",
        "targetId": "supplier-master-qualification",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-tprm-programme-owner-business-module-supplier-onboarding",
        "relation": "consulted",
        "roleId": "tprm-programme-owner",
        "targetId": "supplier-onboarding",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-tprm-programme-owner-business-module-supplier-remediation-exit",
        "relation": "consulted",
        "roleId": "tprm-programme-owner",
        "targetId": "supplier-remediation-exit",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-treasury-manager-business-module-payment-execution-guard",
        "relation": "consulted",
        "roleId": "treasury-manager",
        "targetId": "payment-execution-guard",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-treasury-manager-business-module-payment-readiness",
        "relation": "consulted",
        "roleId": "treasury-manager",
        "targetId": "payment-readiness",
        "targetKind": "business-module"
      },
      {
        "id": "consulted-value-lead-business-module-realization-reconciliation-attribution",
        "relation": "consulted",
        "roleId": "value-lead",
        "targetId": "realization-reconciliation-attribution",
        "targetKind": "business-module"
      },
      {
        "id": "informed-accountable-risk-owner-entity-action-proposal",
        "relation": "informed",
        "roleId": "accountable-risk-owner",
        "targetId": "action-proposal",
        "targetKind": "entity"
      },
      {
        "id": "informed-accountable-risk-owner-entity-audit-event",
        "relation": "informed",
        "roleId": "accountable-risk-owner",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-accountable-risk-owner-entity-authority-envelope",
        "relation": "informed",
        "roleId": "accountable-risk-owner",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-accountable-risk-owner-entity-business-event",
        "relation": "informed",
        "roleId": "accountable-risk-owner",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-accountable-risk-owner-entity-committed-action",
        "relation": "informed",
        "roleId": "accountable-risk-owner",
        "targetId": "committed-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-accountable-risk-owner-entity-contract",
        "relation": "informed",
        "roleId": "accountable-risk-owner",
        "targetId": "contract",
        "targetKind": "entity"
      },
      {
        "id": "informed-accountable-risk-owner-entity-decision",
        "relation": "informed",
        "roleId": "accountable-risk-owner",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-accountable-risk-owner-entity-evaluation-result",
        "relation": "informed",
        "roleId": "accountable-risk-owner",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-accountable-risk-owner-entity-evidence-item",
        "relation": "informed",
        "roleId": "accountable-risk-owner",
        "targetId": "evidence-item",
        "targetKind": "entity"
      },
      {
        "id": "informed-accountable-risk-owner-entity-exception",
        "relation": "informed",
        "roleId": "accountable-risk-owner",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-accountable-risk-owner-entity-integration-state",
        "relation": "informed",
        "roleId": "accountable-risk-owner",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-accountable-risk-owner-entity-learning-example",
        "relation": "informed",
        "roleId": "accountable-risk-owner",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-accountable-risk-owner-entity-party",
        "relation": "informed",
        "roleId": "accountable-risk-owner",
        "targetId": "party",
        "targetKind": "entity"
      },
      {
        "id": "informed-accountable-risk-owner-entity-person",
        "relation": "informed",
        "roleId": "accountable-risk-owner",
        "targetId": "person",
        "targetKind": "entity"
      },
      {
        "id": "informed-accountable-risk-owner-entity-policy",
        "relation": "informed",
        "roleId": "accountable-risk-owner",
        "targetId": "policy",
        "targetKind": "entity"
      },
      {
        "id": "informed-accountable-risk-owner-entity-policy-version",
        "relation": "informed",
        "roleId": "accountable-risk-owner",
        "targetId": "policy-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-accountable-risk-owner-entity-purchase-order",
        "relation": "informed",
        "roleId": "accountable-risk-owner",
        "targetId": "purchase-order",
        "targetKind": "entity"
      },
      {
        "id": "informed-accountable-risk-owner-entity-registry-release",
        "relation": "informed",
        "roleId": "accountable-risk-owner",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-accountable-risk-owner-entity-source-record-reference",
        "relation": "informed",
        "roleId": "accountable-risk-owner",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-accountable-risk-owner-entity-supplier-master-change",
        "relation": "informed",
        "roleId": "accountable-risk-owner",
        "targetId": "supplier-master-change",
        "targetKind": "entity"
      },
      {
        "id": "informed-accountable-risk-owner-entity-supplier-onboarding-case",
        "relation": "informed",
        "roleId": "accountable-risk-owner",
        "targetId": "supplier-onboarding-case",
        "targetKind": "entity"
      },
      {
        "id": "informed-accountable-risk-owner-entity-supplier-profile",
        "relation": "informed",
        "roleId": "accountable-risk-owner",
        "targetId": "supplier-profile",
        "targetKind": "entity"
      },
      {
        "id": "informed-accountable-risk-owner-entity-supplier-qualification",
        "relation": "informed",
        "roleId": "accountable-risk-owner",
        "targetId": "supplier-qualification",
        "targetKind": "entity"
      },
      {
        "id": "informed-accountable-risk-owner-entity-supplier-risk-assessment",
        "relation": "informed",
        "roleId": "accountable-risk-owner",
        "targetId": "supplier-risk-assessment",
        "targetKind": "entity"
      },
      {
        "id": "informed-accountable-risk-owner-entity-supplier-risk-case",
        "relation": "informed",
        "roleId": "accountable-risk-owner",
        "targetId": "supplier-risk-case",
        "targetKind": "entity"
      },
      {
        "id": "informed-accountable-risk-owner-entity-supplier-risk-signal",
        "relation": "informed",
        "roleId": "accountable-risk-owner",
        "targetId": "supplier-risk-signal",
        "targetKind": "entity"
      },
      {
        "id": "informed-accountable-risk-owner-entity-supplier-tier-link",
        "relation": "informed",
        "roleId": "accountable-risk-owner",
        "targetId": "supplier-tier-link",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-action-proposal",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "action-proposal",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-audit-event",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-authority-envelope",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-business-event",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-category",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "category",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-committed-action",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "committed-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-decision",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-evaluation-result",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-evidence-item",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "evidence-item",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-exception",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-integration-state",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-invoice",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "invoice",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-invoice-exception",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "invoice-exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-invoice-line",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "invoice-line",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-invoice-match-assessment",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "invoice-match-assessment",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-item-service",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "item-service",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-learning-example",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-order-line",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "order-line",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-party",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "party",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-person",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "person",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-policy",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "policy",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-policy-version",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "policy-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-purchase-order",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "purchase-order",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-purchase-order-exception",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "purchase-order-exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-receipt",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "receipt",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-receipt-line",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "receipt-line",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-registry-release",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-service-entry-sheet",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "service-entry-sheet",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-source-record-reference",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-ap-processor-entity-supplier-invoice-resolution",
        "relation": "informed",
        "roleId": "ap-processor",
        "targetId": "supplier-invoice-resolution",
        "targetKind": "entity"
      },
      {
        "id": "informed-award-authority-entity-action-proposal",
        "relation": "informed",
        "roleId": "award-authority",
        "targetId": "action-proposal",
        "targetKind": "entity"
      },
      {
        "id": "informed-award-authority-entity-audit-event",
        "relation": "informed",
        "roleId": "award-authority",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-award-authority-entity-authority-envelope",
        "relation": "informed",
        "roleId": "award-authority",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-award-authority-entity-award-scenario",
        "relation": "informed",
        "roleId": "award-authority",
        "targetId": "award-scenario",
        "targetKind": "entity"
      },
      {
        "id": "informed-award-authority-entity-business-event",
        "relation": "informed",
        "roleId": "award-authority",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-award-authority-entity-category",
        "relation": "informed",
        "roleId": "award-authority",
        "targetId": "category",
        "targetKind": "entity"
      },
      {
        "id": "informed-award-authority-entity-committed-action",
        "relation": "informed",
        "roleId": "award-authority",
        "targetId": "committed-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-award-authority-entity-decision",
        "relation": "informed",
        "roleId": "award-authority",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-award-authority-entity-demand-case",
        "relation": "informed",
        "roleId": "award-authority",
        "targetId": "demand-case",
        "targetKind": "entity"
      },
      {
        "id": "informed-award-authority-entity-evaluation-result",
        "relation": "informed",
        "roleId": "award-authority",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-award-authority-entity-evidence-item",
        "relation": "informed",
        "roleId": "award-authority",
        "targetId": "evidence-item",
        "targetKind": "entity"
      },
      {
        "id": "informed-award-authority-entity-exception",
        "relation": "informed",
        "roleId": "award-authority",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-award-authority-entity-integration-state",
        "relation": "informed",
        "roleId": "award-authority",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-award-authority-entity-item-service",
        "relation": "informed",
        "roleId": "award-authority",
        "targetId": "item-service",
        "targetKind": "entity"
      },
      {
        "id": "informed-award-authority-entity-learning-example",
        "relation": "informed",
        "roleId": "award-authority",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-award-authority-entity-negotiation-session",
        "relation": "informed",
        "roleId": "award-authority",
        "targetId": "negotiation-session",
        "targetKind": "entity"
      },
      {
        "id": "informed-award-authority-entity-party",
        "relation": "informed",
        "roleId": "award-authority",
        "targetId": "party",
        "targetKind": "entity"
      },
      {
        "id": "informed-award-authority-entity-person",
        "relation": "informed",
        "roleId": "award-authority",
        "targetId": "person",
        "targetKind": "entity"
      },
      {
        "id": "informed-award-authority-entity-policy",
        "relation": "informed",
        "roleId": "award-authority",
        "targetId": "policy",
        "targetKind": "entity"
      },
      {
        "id": "informed-award-authority-entity-policy-version",
        "relation": "informed",
        "roleId": "award-authority",
        "targetId": "policy-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-award-authority-entity-registry-release",
        "relation": "informed",
        "roleId": "award-authority",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-award-authority-entity-source-record-reference",
        "relation": "informed",
        "roleId": "award-authority",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-award-authority-entity-sourcing-event-record",
        "relation": "informed",
        "roleId": "award-authority",
        "targetId": "sourcing-event-record",
        "targetKind": "entity"
      },
      {
        "id": "informed-award-authority-entity-sourcing-opportunity",
        "relation": "informed",
        "roleId": "award-authority",
        "targetId": "sourcing-opportunity",
        "targetKind": "entity"
      },
      {
        "id": "informed-award-authority-entity-supplier-response",
        "relation": "informed",
        "roleId": "award-authority",
        "targetId": "supplier-response",
        "targetKind": "entity"
      },
      {
        "id": "informed-award-authority-entity-tactical-sourcing-case",
        "relation": "informed",
        "roleId": "award-authority",
        "targetId": "tactical-sourcing-case",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-action-proposal",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "action-proposal",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-audit-event",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-authority-envelope",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-budget",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "budget",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-business-event",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-business-unit",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "business-unit",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-buying-request",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "buying-request",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-catalogue-line",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "catalogue-line",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-category",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "category",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-committed-action",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "committed-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-contract",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "contract",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-decision",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-evaluation-result",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-evidence-item",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "evidence-item",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-exception",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-integration-state",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-item-service",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "item-service",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-learning-example",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-order-line",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "order-line",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-order-response",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "order-response",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-party",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "party",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-payment-execution-status",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "payment-execution-status",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-payment-instruction",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "payment-instruction",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-policy",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "policy",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-policy-version",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "policy-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-purchase-order",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "purchase-order",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-receipt",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "receipt",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-registry-release",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-return-claim",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "return-claim",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-savings-initiative-record",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "savings-initiative-record",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-shipment",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "shipment",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-source-record-reference",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-supplier-profile",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "supplier-profile",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-supplier-qualification",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "supplier-qualification",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-value-leakage-finding",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "value-leakage-finding",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-value-opportunity-baseline",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "value-opportunity-baseline",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-value-portfolio-forecast",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "value-portfolio-forecast",
        "targetKind": "entity"
      },
      {
        "id": "informed-budget-owner-entity-value-realization-attribution",
        "relation": "informed",
        "roleId": "budget-owner",
        "targetId": "value-realization-attribution",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-action-proposal",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "action-proposal",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-audit-event",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-authority-envelope",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-budget",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "budget",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-business-event",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-business-unit",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "business-unit",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-category",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "category",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-category-opportunity",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "category-opportunity",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-clause-deviation",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "clause-deviation",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-clause-library-entry",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "clause-library-entry",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-committed-action",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "committed-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-contract",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "contract",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-contract-compliance-finding",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "contract-compliance-finding",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-contract-entitlement",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "contract-entitlement",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-contract-intake",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "contract-intake",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-contract-obligation",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "contract-obligation",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-contract-template",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "contract-template",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-contract-version",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "contract-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-decision",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-evaluation-result",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-evidence-item",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "evidence-item",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-exception",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-integration-state",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-learning-example",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-party",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "party",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-payment-execution-status",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "payment-execution-status",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-payment-instruction",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "payment-instruction",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-person",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "person",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-policy",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "policy",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-policy-rule-release",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "policy-rule-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-policy-version",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "policy-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-registry-release",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-savings-initiative-record",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "savings-initiative-record",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-source-record-reference",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-spend-record",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "spend-record",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-tail-spend-evaluation",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "tail-spend-evaluation",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-value-leakage-finding",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "value-leakage-finding",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-value-opportunity-baseline",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "value-opportunity-baseline",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-value-portfolio-forecast",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "value-portfolio-forecast",
        "targetKind": "entity"
      },
      {
        "id": "informed-category-manager-entity-value-realization-attribution",
        "relation": "informed",
        "roleId": "category-manager",
        "targetId": "value-realization-attribution",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-action-proposal",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "action-proposal",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-audit-event",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-authority-envelope",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-business-event",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-clause-deviation",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "clause-deviation",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-clause-library-entry",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "clause-library-entry",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-committed-action",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "committed-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-contract",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "contract",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-contract-approval",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "contract-approval",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-contract-change",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "contract-change",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-contract-compliance-finding",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "contract-compliance-finding",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-contract-entitlement",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "contract-entitlement",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-contract-intake",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "contract-intake",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-contract-obligation",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "contract-obligation",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-contract-template",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "contract-template",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-contract-version",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "contract-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-decision",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-evaluation-result",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-evidence-item",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "evidence-item",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-exception",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-integration-state",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-learning-example",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-party",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "party",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-person",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "person",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-policy",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "policy",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-policy-version",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "policy-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-registry-release",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-source-record-reference",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-contract-manager-entity-supplier-profile",
        "relation": "informed",
        "roleId": "contract-manager",
        "targetId": "supplier-profile",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-action-proposal",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "action-proposal",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-audit-event",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-authority-envelope",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-business-event",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-category",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "category",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-committed-action",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "committed-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-decision",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-evaluation-result",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-evidence-item",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "evidence-item",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-exception",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-integration-state",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-invoice",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "invoice",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-invoice-exception",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "invoice-exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-invoice-line",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "invoice-line",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-invoice-match-assessment",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "invoice-match-assessment",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-item-service",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "item-service",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-learning-example",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-order-line",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "order-line",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-party",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "party",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-payment-readiness-assessment",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "payment-readiness-assessment",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-person",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "person",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-policy",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "policy",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-policy-version",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "policy-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-purchase-order",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "purchase-order",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-purchase-order-exception",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "purchase-order-exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-receipt",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "receipt",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-receipt-line",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "receipt-line",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-registry-release",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-service-entry-sheet",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "service-entry-sheet",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-source-record-reference",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-controller-entity-supplier-invoice-resolution",
        "relation": "informed",
        "roleId": "controller",
        "targetId": "supplier-invoice-resolution",
        "targetKind": "entity"
      },
      {
        "id": "informed-data-steward-entity-authority-envelope",
        "relation": "informed",
        "roleId": "data-steward",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-data-steward-entity-business-unit",
        "relation": "informed",
        "roleId": "data-steward",
        "targetId": "business-unit",
        "targetKind": "entity"
      },
      {
        "id": "informed-data-steward-entity-category",
        "relation": "informed",
        "roleId": "data-steward",
        "targetId": "category",
        "targetKind": "entity"
      },
      {
        "id": "informed-data-steward-entity-category-dimension-assignment",
        "relation": "informed",
        "roleId": "data-steward",
        "targetId": "category-dimension-assignment",
        "targetKind": "entity"
      },
      {
        "id": "informed-data-steward-entity-evaluation-result",
        "relation": "informed",
        "roleId": "data-steward",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-data-steward-entity-evidence-item",
        "relation": "informed",
        "roleId": "data-steward",
        "targetId": "evidence-item",
        "targetKind": "entity"
      },
      {
        "id": "informed-data-steward-entity-integration-state",
        "relation": "informed",
        "roleId": "data-steward",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-data-steward-entity-learning-example",
        "relation": "informed",
        "roleId": "data-steward",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-data-steward-entity-policy-guidance-result",
        "relation": "informed",
        "roleId": "data-steward",
        "targetId": "policy-guidance-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-data-steward-entity-source-record-reference",
        "relation": "informed",
        "roleId": "data-steward",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-data-steward-entity-spend-record",
        "relation": "informed",
        "roleId": "data-steward",
        "targetId": "spend-record",
        "targetKind": "entity"
      },
      {
        "id": "informed-data-steward-entity-tail-spend-evaluation",
        "relation": "informed",
        "roleId": "data-steward",
        "targetId": "tail-spend-evaluation",
        "targetKind": "entity"
      },
      {
        "id": "informed-data-steward-entity-taxonomy-version",
        "relation": "informed",
        "roleId": "data-steward",
        "targetId": "taxonomy-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-demand-owner-entity-action-proposal",
        "relation": "informed",
        "roleId": "demand-owner",
        "targetId": "action-proposal",
        "targetKind": "entity"
      },
      {
        "id": "informed-demand-owner-entity-audit-event",
        "relation": "informed",
        "roleId": "demand-owner",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-demand-owner-entity-authority-envelope",
        "relation": "informed",
        "roleId": "demand-owner",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-demand-owner-entity-budget",
        "relation": "informed",
        "roleId": "demand-owner",
        "targetId": "budget",
        "targetKind": "entity"
      },
      {
        "id": "informed-demand-owner-entity-business-event",
        "relation": "informed",
        "roleId": "demand-owner",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-demand-owner-entity-business-unit",
        "relation": "informed",
        "roleId": "demand-owner",
        "targetId": "business-unit",
        "targetKind": "entity"
      },
      {
        "id": "informed-demand-owner-entity-category",
        "relation": "informed",
        "roleId": "demand-owner",
        "targetId": "category",
        "targetKind": "entity"
      },
      {
        "id": "informed-demand-owner-entity-committed-action",
        "relation": "informed",
        "roleId": "demand-owner",
        "targetId": "committed-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-demand-owner-entity-decision",
        "relation": "informed",
        "roleId": "demand-owner",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-demand-owner-entity-demand-case",
        "relation": "informed",
        "roleId": "demand-owner",
        "targetId": "demand-case",
        "targetKind": "entity"
      },
      {
        "id": "informed-demand-owner-entity-enriched-request",
        "relation": "informed",
        "roleId": "demand-owner",
        "targetId": "enriched-request",
        "targetKind": "entity"
      },
      {
        "id": "informed-demand-owner-entity-evaluation-result",
        "relation": "informed",
        "roleId": "demand-owner",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-demand-owner-entity-exception",
        "relation": "informed",
        "roleId": "demand-owner",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-demand-owner-entity-intake-request",
        "relation": "informed",
        "roleId": "demand-owner",
        "targetId": "intake-request",
        "targetKind": "entity"
      },
      {
        "id": "informed-demand-owner-entity-integration-state",
        "relation": "informed",
        "roleId": "demand-owner",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-demand-owner-entity-item-service",
        "relation": "informed",
        "roleId": "demand-owner",
        "targetId": "item-service",
        "targetKind": "entity"
      },
      {
        "id": "informed-demand-owner-entity-learning-example",
        "relation": "informed",
        "roleId": "demand-owner",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-demand-owner-entity-person",
        "relation": "informed",
        "roleId": "demand-owner",
        "targetId": "person",
        "targetKind": "entity"
      },
      {
        "id": "informed-demand-owner-entity-policy",
        "relation": "informed",
        "roleId": "demand-owner",
        "targetId": "policy",
        "targetKind": "entity"
      },
      {
        "id": "informed-demand-owner-entity-policy-guidance-result",
        "relation": "informed",
        "roleId": "demand-owner",
        "targetId": "policy-guidance-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-demand-owner-entity-policy-version",
        "relation": "informed",
        "roleId": "demand-owner",
        "targetId": "policy-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-demand-owner-entity-procurement-service-offering",
        "relation": "informed",
        "roleId": "demand-owner",
        "targetId": "procurement-service-offering",
        "targetKind": "entity"
      },
      {
        "id": "informed-demand-owner-entity-registry-release",
        "relation": "informed",
        "roleId": "demand-owner",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-demand-owner-entity-source-record-reference",
        "relation": "informed",
        "roleId": "demand-owner",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-evaluator-entity-action-proposal",
        "relation": "informed",
        "roleId": "evaluator",
        "targetId": "action-proposal",
        "targetKind": "entity"
      },
      {
        "id": "informed-evaluator-entity-audit-event",
        "relation": "informed",
        "roleId": "evaluator",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-evaluator-entity-authority-envelope",
        "relation": "informed",
        "roleId": "evaluator",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-evaluator-entity-business-event",
        "relation": "informed",
        "roleId": "evaluator",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-evaluator-entity-category",
        "relation": "informed",
        "roleId": "evaluator",
        "targetId": "category",
        "targetKind": "entity"
      },
      {
        "id": "informed-evaluator-entity-category-opportunity",
        "relation": "informed",
        "roleId": "evaluator",
        "targetId": "category-opportunity",
        "targetKind": "entity"
      },
      {
        "id": "informed-evaluator-entity-category-strategy",
        "relation": "informed",
        "roleId": "evaluator",
        "targetId": "category-strategy",
        "targetKind": "entity"
      },
      {
        "id": "informed-evaluator-entity-committed-action",
        "relation": "informed",
        "roleId": "evaluator",
        "targetId": "committed-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-evaluator-entity-decision",
        "relation": "informed",
        "roleId": "evaluator",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-evaluator-entity-demand-case",
        "relation": "informed",
        "roleId": "evaluator",
        "targetId": "demand-case",
        "targetKind": "entity"
      },
      {
        "id": "informed-evaluator-entity-demand-portfolio",
        "relation": "informed",
        "roleId": "evaluator",
        "targetId": "demand-portfolio",
        "targetKind": "entity"
      },
      {
        "id": "informed-evaluator-entity-evaluation-result",
        "relation": "informed",
        "roleId": "evaluator",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-evaluator-entity-evidence-item",
        "relation": "informed",
        "roleId": "evaluator",
        "targetId": "evidence-item",
        "targetKind": "entity"
      },
      {
        "id": "informed-evaluator-entity-exception",
        "relation": "informed",
        "roleId": "evaluator",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-evaluator-entity-integration-state",
        "relation": "informed",
        "roleId": "evaluator",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-evaluator-entity-item-service",
        "relation": "informed",
        "roleId": "evaluator",
        "targetId": "item-service",
        "targetKind": "entity"
      },
      {
        "id": "informed-evaluator-entity-learning-example",
        "relation": "informed",
        "roleId": "evaluator",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-evaluator-entity-negotiation-session",
        "relation": "informed",
        "roleId": "evaluator",
        "targetId": "negotiation-session",
        "targetKind": "entity"
      },
      {
        "id": "informed-evaluator-entity-party",
        "relation": "informed",
        "roleId": "evaluator",
        "targetId": "party",
        "targetKind": "entity"
      },
      {
        "id": "informed-evaluator-entity-person",
        "relation": "informed",
        "roleId": "evaluator",
        "targetId": "person",
        "targetKind": "entity"
      },
      {
        "id": "informed-evaluator-entity-policy",
        "relation": "informed",
        "roleId": "evaluator",
        "targetId": "policy",
        "targetKind": "entity"
      },
      {
        "id": "informed-evaluator-entity-policy-version",
        "relation": "informed",
        "roleId": "evaluator",
        "targetId": "policy-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-evaluator-entity-registry-release",
        "relation": "informed",
        "roleId": "evaluator",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-evaluator-entity-source-record-reference",
        "relation": "informed",
        "roleId": "evaluator",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-evaluator-entity-sourcing-event-record",
        "relation": "informed",
        "roleId": "evaluator",
        "targetId": "sourcing-event-record",
        "targetKind": "entity"
      },
      {
        "id": "informed-evaluator-entity-sourcing-opportunity",
        "relation": "informed",
        "roleId": "evaluator",
        "targetId": "sourcing-opportunity",
        "targetKind": "entity"
      },
      {
        "id": "informed-evaluator-entity-supplier-response",
        "relation": "informed",
        "roleId": "evaluator",
        "targetId": "supplier-response",
        "targetKind": "entity"
      },
      {
        "id": "informed-evaluator-entity-tactical-sourcing-case",
        "relation": "informed",
        "roleId": "evaluator",
        "targetId": "tactical-sourcing-case",
        "targetKind": "entity"
      },
      {
        "id": "informed-finance-delegate-entity-action-proposal",
        "relation": "informed",
        "roleId": "finance-delegate",
        "targetId": "action-proposal",
        "targetKind": "entity"
      },
      {
        "id": "informed-finance-delegate-entity-audit-event",
        "relation": "informed",
        "roleId": "finance-delegate",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-finance-delegate-entity-authority-envelope",
        "relation": "informed",
        "roleId": "finance-delegate",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-finance-delegate-entity-budget",
        "relation": "informed",
        "roleId": "finance-delegate",
        "targetId": "budget",
        "targetKind": "entity"
      },
      {
        "id": "informed-finance-delegate-entity-business-event",
        "relation": "informed",
        "roleId": "finance-delegate",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-finance-delegate-entity-business-unit",
        "relation": "informed",
        "roleId": "finance-delegate",
        "targetId": "business-unit",
        "targetKind": "entity"
      },
      {
        "id": "informed-finance-delegate-entity-category",
        "relation": "informed",
        "roleId": "finance-delegate",
        "targetId": "category",
        "targetKind": "entity"
      },
      {
        "id": "informed-finance-delegate-entity-committed-action",
        "relation": "informed",
        "roleId": "finance-delegate",
        "targetId": "committed-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-finance-delegate-entity-decision",
        "relation": "informed",
        "roleId": "finance-delegate",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-finance-delegate-entity-evaluation-result",
        "relation": "informed",
        "roleId": "finance-delegate",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-finance-delegate-entity-evidence-item",
        "relation": "informed",
        "roleId": "finance-delegate",
        "targetId": "evidence-item",
        "targetKind": "entity"
      },
      {
        "id": "informed-finance-delegate-entity-exception",
        "relation": "informed",
        "roleId": "finance-delegate",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-finance-delegate-entity-integration-state",
        "relation": "informed",
        "roleId": "finance-delegate",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-finance-delegate-entity-learning-example",
        "relation": "informed",
        "roleId": "finance-delegate",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-finance-delegate-entity-payment-execution-status",
        "relation": "informed",
        "roleId": "finance-delegate",
        "targetId": "payment-execution-status",
        "targetKind": "entity"
      },
      {
        "id": "informed-finance-delegate-entity-payment-instruction",
        "relation": "informed",
        "roleId": "finance-delegate",
        "targetId": "payment-instruction",
        "targetKind": "entity"
      },
      {
        "id": "informed-finance-delegate-entity-registry-release",
        "relation": "informed",
        "roleId": "finance-delegate",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-finance-delegate-entity-savings-initiative-record",
        "relation": "informed",
        "roleId": "finance-delegate",
        "targetId": "savings-initiative-record",
        "targetKind": "entity"
      },
      {
        "id": "informed-finance-delegate-entity-source-record-reference",
        "relation": "informed",
        "roleId": "finance-delegate",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-finance-delegate-entity-value-leakage-finding",
        "relation": "informed",
        "roleId": "finance-delegate",
        "targetId": "value-leakage-finding",
        "targetKind": "entity"
      },
      {
        "id": "informed-finance-delegate-entity-value-opportunity-baseline",
        "relation": "informed",
        "roleId": "finance-delegate",
        "targetId": "value-opportunity-baseline",
        "targetKind": "entity"
      },
      {
        "id": "informed-finance-delegate-entity-value-portfolio-forecast",
        "relation": "informed",
        "roleId": "finance-delegate",
        "targetId": "value-portfolio-forecast",
        "targetKind": "entity"
      },
      {
        "id": "informed-finance-delegate-entity-value-realization-attribution",
        "relation": "informed",
        "roleId": "finance-delegate",
        "targetId": "value-realization-attribution",
        "targetKind": "entity"
      },
      {
        "id": "informed-governance-owner-entity-audit-event",
        "relation": "informed",
        "roleId": "governance-owner",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-governance-owner-entity-authority-envelope",
        "relation": "informed",
        "roleId": "governance-owner",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-governance-owner-entity-business-event",
        "relation": "informed",
        "roleId": "governance-owner",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-governance-owner-entity-decision",
        "relation": "informed",
        "roleId": "governance-owner",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-governance-owner-entity-evaluation-result",
        "relation": "informed",
        "roleId": "governance-owner",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-governance-owner-entity-integration-state",
        "relation": "informed",
        "roleId": "governance-owner",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-governance-owner-entity-learning-example",
        "relation": "informed",
        "roleId": "governance-owner",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-governance-owner-entity-party",
        "relation": "informed",
        "roleId": "governance-owner",
        "targetId": "party",
        "targetKind": "entity"
      },
      {
        "id": "informed-governance-owner-entity-registry-release",
        "relation": "informed",
        "roleId": "governance-owner",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-governance-owner-entity-source-record-reference",
        "relation": "informed",
        "roleId": "governance-owner",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-governance-owner-entity-supplier-innovation-case",
        "relation": "informed",
        "roleId": "governance-owner",
        "targetId": "supplier-innovation-case",
        "targetKind": "entity"
      },
      {
        "id": "informed-governance-owner-entity-supplier-joint-value-plan",
        "relation": "informed",
        "roleId": "governance-owner",
        "targetId": "supplier-joint-value-plan",
        "targetKind": "entity"
      },
      {
        "id": "informed-governance-owner-entity-supplier-offboarding-case",
        "relation": "informed",
        "roleId": "governance-owner",
        "targetId": "supplier-offboarding-case",
        "targetKind": "entity"
      },
      {
        "id": "informed-governance-owner-entity-supplier-performance-observation",
        "relation": "informed",
        "roleId": "governance-owner",
        "targetId": "supplier-performance-observation",
        "targetKind": "entity"
      },
      {
        "id": "informed-governance-owner-entity-supplier-performance-review-record",
        "relation": "informed",
        "roleId": "governance-owner",
        "targetId": "supplier-performance-review-record",
        "targetKind": "entity"
      },
      {
        "id": "informed-governance-owner-entity-supplier-remediation-action",
        "relation": "informed",
        "roleId": "governance-owner",
        "targetId": "supplier-remediation-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-governance-owner-entity-supplier-segment-assignment",
        "relation": "informed",
        "roleId": "governance-owner",
        "targetId": "supplier-segment-assignment",
        "targetKind": "entity"
      },
      {
        "id": "informed-innovation-sponsor-entity-supplier-innovation-case",
        "relation": "informed",
        "roleId": "innovation-sponsor",
        "targetId": "supplier-innovation-case",
        "targetKind": "entity"
      },
      {
        "id": "informed-innovation-sponsor-entity-supplier-joint-value-plan",
        "relation": "informed",
        "roleId": "innovation-sponsor",
        "targetId": "supplier-joint-value-plan",
        "targetKind": "entity"
      },
      {
        "id": "informed-innovation-sponsor-entity-supplier-performance-review-record",
        "relation": "informed",
        "roleId": "innovation-sponsor",
        "targetId": "supplier-performance-review-record",
        "targetKind": "entity"
      },
      {
        "id": "informed-innovation-sponsor-entity-supplier-segment-assignment",
        "relation": "informed",
        "roleId": "innovation-sponsor",
        "targetId": "supplier-segment-assignment",
        "targetKind": "entity"
      },
      {
        "id": "informed-intake-owner-entity-action-proposal",
        "relation": "informed",
        "roleId": "intake-owner",
        "targetId": "action-proposal",
        "targetKind": "entity"
      },
      {
        "id": "informed-intake-owner-entity-audit-event",
        "relation": "informed",
        "roleId": "intake-owner",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-intake-owner-entity-authority-envelope",
        "relation": "informed",
        "roleId": "intake-owner",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-intake-owner-entity-budget",
        "relation": "informed",
        "roleId": "intake-owner",
        "targetId": "budget",
        "targetKind": "entity"
      },
      {
        "id": "informed-intake-owner-entity-business-event",
        "relation": "informed",
        "roleId": "intake-owner",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-intake-owner-entity-business-unit",
        "relation": "informed",
        "roleId": "intake-owner",
        "targetId": "business-unit",
        "targetKind": "entity"
      },
      {
        "id": "informed-intake-owner-entity-category",
        "relation": "informed",
        "roleId": "intake-owner",
        "targetId": "category",
        "targetKind": "entity"
      },
      {
        "id": "informed-intake-owner-entity-committed-action",
        "relation": "informed",
        "roleId": "intake-owner",
        "targetId": "committed-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-intake-owner-entity-decision",
        "relation": "informed",
        "roleId": "intake-owner",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-intake-owner-entity-demand-case",
        "relation": "informed",
        "roleId": "intake-owner",
        "targetId": "demand-case",
        "targetKind": "entity"
      },
      {
        "id": "informed-intake-owner-entity-enriched-request",
        "relation": "informed",
        "roleId": "intake-owner",
        "targetId": "enriched-request",
        "targetKind": "entity"
      },
      {
        "id": "informed-intake-owner-entity-evaluation-result",
        "relation": "informed",
        "roleId": "intake-owner",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-intake-owner-entity-exception",
        "relation": "informed",
        "roleId": "intake-owner",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-intake-owner-entity-intake-request",
        "relation": "informed",
        "roleId": "intake-owner",
        "targetId": "intake-request",
        "targetKind": "entity"
      },
      {
        "id": "informed-intake-owner-entity-integration-state",
        "relation": "informed",
        "roleId": "intake-owner",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-intake-owner-entity-item-service",
        "relation": "informed",
        "roleId": "intake-owner",
        "targetId": "item-service",
        "targetKind": "entity"
      },
      {
        "id": "informed-intake-owner-entity-learning-example",
        "relation": "informed",
        "roleId": "intake-owner",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-intake-owner-entity-person",
        "relation": "informed",
        "roleId": "intake-owner",
        "targetId": "person",
        "targetKind": "entity"
      },
      {
        "id": "informed-intake-owner-entity-policy",
        "relation": "informed",
        "roleId": "intake-owner",
        "targetId": "policy",
        "targetKind": "entity"
      },
      {
        "id": "informed-intake-owner-entity-policy-guidance-result",
        "relation": "informed",
        "roleId": "intake-owner",
        "targetId": "policy-guidance-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-intake-owner-entity-policy-rule-release",
        "relation": "informed",
        "roleId": "intake-owner",
        "targetId": "policy-rule-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-intake-owner-entity-policy-version",
        "relation": "informed",
        "roleId": "intake-owner",
        "targetId": "policy-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-intake-owner-entity-procurement-service-offering",
        "relation": "informed",
        "roleId": "intake-owner",
        "targetId": "procurement-service-offering",
        "targetKind": "entity"
      },
      {
        "id": "informed-intake-owner-entity-registry-release",
        "relation": "informed",
        "roleId": "intake-owner",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-intake-owner-entity-source-record-reference",
        "relation": "informed",
        "roleId": "intake-owner",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-action-proposal",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "action-proposal",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-audit-event",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-authority-envelope",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-business-event",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-business-unit",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "business-unit",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-catalogue-line",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "catalogue-line",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-category",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "category",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-committed-action",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "committed-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-contract",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "contract",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-decision",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-evaluation-result",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-exception",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-integration-state",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-item-service",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "item-service",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-order-line",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "order-line",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-order-response",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "order-response",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-party",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "party",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-policy",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "policy",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-policy-version",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "policy-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-purchase-order",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "purchase-order",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-receipt",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "receipt",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-registry-release",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-requisition",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "requisition",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-requisition-line",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "requisition-line",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-return-claim",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "return-claim",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-shipment",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "shipment",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-source-record-reference",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-supplier-profile",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "supplier-profile",
        "targetKind": "entity"
      },
      {
        "id": "informed-integration-owner-entity-supplier-qualification",
        "relation": "informed",
        "roleId": "integration-owner",
        "targetId": "supplier-qualification",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-action-proposal",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "action-proposal",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-audit-event",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-authority-envelope",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-business-event",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-clause-deviation",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "clause-deviation",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-clause-library-entry",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "clause-library-entry",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-committed-action",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "committed-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-contract",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "contract",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-contract-approval",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "contract-approval",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-contract-change",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "contract-change",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-contract-compliance-finding",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "contract-compliance-finding",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-contract-entitlement",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "contract-entitlement",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-contract-intake",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "contract-intake",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-contract-obligation",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "contract-obligation",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-contract-template",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "contract-template",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-contract-version",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "contract-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-decision",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-evaluation-result",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-evidence-item",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "evidence-item",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-exception",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-integration-state",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-learning-example",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-party",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "party",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-person",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "person",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-policy",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "policy",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-policy-version",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "policy-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-registry-release",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-source-record-reference",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-legal-counsel-entity-supplier-profile",
        "relation": "informed",
        "roleId": "legal-counsel",
        "targetId": "supplier-profile",
        "targetKind": "entity"
      },
      {
        "id": "informed-metric-owner-entity-audit-event",
        "relation": "informed",
        "roleId": "metric-owner",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-metric-owner-entity-authority-envelope",
        "relation": "informed",
        "roleId": "metric-owner",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-metric-owner-entity-business-event",
        "relation": "informed",
        "roleId": "metric-owner",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-metric-owner-entity-decision",
        "relation": "informed",
        "roleId": "metric-owner",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-metric-owner-entity-evaluation-result",
        "relation": "informed",
        "roleId": "metric-owner",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-metric-owner-entity-integration-state",
        "relation": "informed",
        "roleId": "metric-owner",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-metric-owner-entity-learning-example",
        "relation": "informed",
        "roleId": "metric-owner",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-metric-owner-entity-party",
        "relation": "informed",
        "roleId": "metric-owner",
        "targetId": "party",
        "targetKind": "entity"
      },
      {
        "id": "informed-metric-owner-entity-registry-release",
        "relation": "informed",
        "roleId": "metric-owner",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-metric-owner-entity-source-record-reference",
        "relation": "informed",
        "roleId": "metric-owner",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-metric-owner-entity-supplier-innovation-case",
        "relation": "informed",
        "roleId": "metric-owner",
        "targetId": "supplier-innovation-case",
        "targetKind": "entity"
      },
      {
        "id": "informed-metric-owner-entity-supplier-offboarding-case",
        "relation": "informed",
        "roleId": "metric-owner",
        "targetId": "supplier-offboarding-case",
        "targetKind": "entity"
      },
      {
        "id": "informed-metric-owner-entity-supplier-performance-observation",
        "relation": "informed",
        "roleId": "metric-owner",
        "targetId": "supplier-performance-observation",
        "targetKind": "entity"
      },
      {
        "id": "informed-metric-owner-entity-supplier-performance-review-record",
        "relation": "informed",
        "roleId": "metric-owner",
        "targetId": "supplier-performance-review-record",
        "targetKind": "entity"
      },
      {
        "id": "informed-metric-owner-entity-supplier-remediation-action",
        "relation": "informed",
        "roleId": "metric-owner",
        "targetId": "supplier-remediation-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-metric-owner-entity-supplier-segment-assignment",
        "relation": "informed",
        "roleId": "metric-owner",
        "targetId": "supplier-segment-assignment",
        "targetKind": "entity"
      },
      {
        "id": "informed-negotiation-lead-entity-action-proposal",
        "relation": "informed",
        "roleId": "negotiation-lead",
        "targetId": "action-proposal",
        "targetKind": "entity"
      },
      {
        "id": "informed-negotiation-lead-entity-audit-event",
        "relation": "informed",
        "roleId": "negotiation-lead",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-negotiation-lead-entity-authority-envelope",
        "relation": "informed",
        "roleId": "negotiation-lead",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-negotiation-lead-entity-award-scenario",
        "relation": "informed",
        "roleId": "negotiation-lead",
        "targetId": "award-scenario",
        "targetKind": "entity"
      },
      {
        "id": "informed-negotiation-lead-entity-business-event",
        "relation": "informed",
        "roleId": "negotiation-lead",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-negotiation-lead-entity-category",
        "relation": "informed",
        "roleId": "negotiation-lead",
        "targetId": "category",
        "targetKind": "entity"
      },
      {
        "id": "informed-negotiation-lead-entity-committed-action",
        "relation": "informed",
        "roleId": "negotiation-lead",
        "targetId": "committed-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-negotiation-lead-entity-decision",
        "relation": "informed",
        "roleId": "negotiation-lead",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-negotiation-lead-entity-demand-case",
        "relation": "informed",
        "roleId": "negotiation-lead",
        "targetId": "demand-case",
        "targetKind": "entity"
      },
      {
        "id": "informed-negotiation-lead-entity-evaluation-result",
        "relation": "informed",
        "roleId": "negotiation-lead",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-negotiation-lead-entity-evidence-item",
        "relation": "informed",
        "roleId": "negotiation-lead",
        "targetId": "evidence-item",
        "targetKind": "entity"
      },
      {
        "id": "informed-negotiation-lead-entity-exception",
        "relation": "informed",
        "roleId": "negotiation-lead",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-negotiation-lead-entity-integration-state",
        "relation": "informed",
        "roleId": "negotiation-lead",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-negotiation-lead-entity-item-service",
        "relation": "informed",
        "roleId": "negotiation-lead",
        "targetId": "item-service",
        "targetKind": "entity"
      },
      {
        "id": "informed-negotiation-lead-entity-learning-example",
        "relation": "informed",
        "roleId": "negotiation-lead",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-negotiation-lead-entity-party",
        "relation": "informed",
        "roleId": "negotiation-lead",
        "targetId": "party",
        "targetKind": "entity"
      },
      {
        "id": "informed-negotiation-lead-entity-person",
        "relation": "informed",
        "roleId": "negotiation-lead",
        "targetId": "person",
        "targetKind": "entity"
      },
      {
        "id": "informed-negotiation-lead-entity-policy",
        "relation": "informed",
        "roleId": "negotiation-lead",
        "targetId": "policy",
        "targetKind": "entity"
      },
      {
        "id": "informed-negotiation-lead-entity-policy-version",
        "relation": "informed",
        "roleId": "negotiation-lead",
        "targetId": "policy-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-negotiation-lead-entity-registry-release",
        "relation": "informed",
        "roleId": "negotiation-lead",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-negotiation-lead-entity-source-record-reference",
        "relation": "informed",
        "roleId": "negotiation-lead",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-negotiation-lead-entity-sourcing-opportunity",
        "relation": "informed",
        "roleId": "negotiation-lead",
        "targetId": "sourcing-opportunity",
        "targetKind": "entity"
      },
      {
        "id": "informed-negotiation-lead-entity-supplier-response",
        "relation": "informed",
        "roleId": "negotiation-lead",
        "targetId": "supplier-response",
        "targetKind": "entity"
      },
      {
        "id": "informed-obligation-owner-entity-action-proposal",
        "relation": "informed",
        "roleId": "obligation-owner",
        "targetId": "action-proposal",
        "targetKind": "entity"
      },
      {
        "id": "informed-obligation-owner-entity-audit-event",
        "relation": "informed",
        "roleId": "obligation-owner",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-obligation-owner-entity-authority-envelope",
        "relation": "informed",
        "roleId": "obligation-owner",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-obligation-owner-entity-business-event",
        "relation": "informed",
        "roleId": "obligation-owner",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-obligation-owner-entity-clause-library-entry",
        "relation": "informed",
        "roleId": "obligation-owner",
        "targetId": "clause-library-entry",
        "targetKind": "entity"
      },
      {
        "id": "informed-obligation-owner-entity-committed-action",
        "relation": "informed",
        "roleId": "obligation-owner",
        "targetId": "committed-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-obligation-owner-entity-contract",
        "relation": "informed",
        "roleId": "obligation-owner",
        "targetId": "contract",
        "targetKind": "entity"
      },
      {
        "id": "informed-obligation-owner-entity-contract-approval",
        "relation": "informed",
        "roleId": "obligation-owner",
        "targetId": "contract-approval",
        "targetKind": "entity"
      },
      {
        "id": "informed-obligation-owner-entity-contract-change",
        "relation": "informed",
        "roleId": "obligation-owner",
        "targetId": "contract-change",
        "targetKind": "entity"
      },
      {
        "id": "informed-obligation-owner-entity-contract-entitlement",
        "relation": "informed",
        "roleId": "obligation-owner",
        "targetId": "contract-entitlement",
        "targetKind": "entity"
      },
      {
        "id": "informed-obligation-owner-entity-contract-intake",
        "relation": "informed",
        "roleId": "obligation-owner",
        "targetId": "contract-intake",
        "targetKind": "entity"
      },
      {
        "id": "informed-obligation-owner-entity-contract-obligation",
        "relation": "informed",
        "roleId": "obligation-owner",
        "targetId": "contract-obligation",
        "targetKind": "entity"
      },
      {
        "id": "informed-obligation-owner-entity-contract-version",
        "relation": "informed",
        "roleId": "obligation-owner",
        "targetId": "contract-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-obligation-owner-entity-decision",
        "relation": "informed",
        "roleId": "obligation-owner",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-obligation-owner-entity-evaluation-result",
        "relation": "informed",
        "roleId": "obligation-owner",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-obligation-owner-entity-evidence-item",
        "relation": "informed",
        "roleId": "obligation-owner",
        "targetId": "evidence-item",
        "targetKind": "entity"
      },
      {
        "id": "informed-obligation-owner-entity-exception",
        "relation": "informed",
        "roleId": "obligation-owner",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-obligation-owner-entity-integration-state",
        "relation": "informed",
        "roleId": "obligation-owner",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-obligation-owner-entity-learning-example",
        "relation": "informed",
        "roleId": "obligation-owner",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-obligation-owner-entity-party",
        "relation": "informed",
        "roleId": "obligation-owner",
        "targetId": "party",
        "targetKind": "entity"
      },
      {
        "id": "informed-obligation-owner-entity-person",
        "relation": "informed",
        "roleId": "obligation-owner",
        "targetId": "person",
        "targetKind": "entity"
      },
      {
        "id": "informed-obligation-owner-entity-policy",
        "relation": "informed",
        "roleId": "obligation-owner",
        "targetId": "policy",
        "targetKind": "entity"
      },
      {
        "id": "informed-obligation-owner-entity-policy-version",
        "relation": "informed",
        "roleId": "obligation-owner",
        "targetId": "policy-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-obligation-owner-entity-registry-release",
        "relation": "informed",
        "roleId": "obligation-owner",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-obligation-owner-entity-source-record-reference",
        "relation": "informed",
        "roleId": "obligation-owner",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-onboarding-coordinator-entity-action-proposal",
        "relation": "informed",
        "roleId": "onboarding-coordinator",
        "targetId": "action-proposal",
        "targetKind": "entity"
      },
      {
        "id": "informed-onboarding-coordinator-entity-audit-event",
        "relation": "informed",
        "roleId": "onboarding-coordinator",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-onboarding-coordinator-entity-authority-envelope",
        "relation": "informed",
        "roleId": "onboarding-coordinator",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-onboarding-coordinator-entity-business-event",
        "relation": "informed",
        "roleId": "onboarding-coordinator",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-onboarding-coordinator-entity-committed-action",
        "relation": "informed",
        "roleId": "onboarding-coordinator",
        "targetId": "committed-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-onboarding-coordinator-entity-contract",
        "relation": "informed",
        "roleId": "onboarding-coordinator",
        "targetId": "contract",
        "targetKind": "entity"
      },
      {
        "id": "informed-onboarding-coordinator-entity-decision",
        "relation": "informed",
        "roleId": "onboarding-coordinator",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-onboarding-coordinator-entity-evaluation-result",
        "relation": "informed",
        "roleId": "onboarding-coordinator",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-onboarding-coordinator-entity-evidence-item",
        "relation": "informed",
        "roleId": "onboarding-coordinator",
        "targetId": "evidence-item",
        "targetKind": "entity"
      },
      {
        "id": "informed-onboarding-coordinator-entity-exception",
        "relation": "informed",
        "roleId": "onboarding-coordinator",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-onboarding-coordinator-entity-integration-state",
        "relation": "informed",
        "roleId": "onboarding-coordinator",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-onboarding-coordinator-entity-learning-example",
        "relation": "informed",
        "roleId": "onboarding-coordinator",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-onboarding-coordinator-entity-party",
        "relation": "informed",
        "roleId": "onboarding-coordinator",
        "targetId": "party",
        "targetKind": "entity"
      },
      {
        "id": "informed-onboarding-coordinator-entity-person",
        "relation": "informed",
        "roleId": "onboarding-coordinator",
        "targetId": "person",
        "targetKind": "entity"
      },
      {
        "id": "informed-onboarding-coordinator-entity-policy",
        "relation": "informed",
        "roleId": "onboarding-coordinator",
        "targetId": "policy",
        "targetKind": "entity"
      },
      {
        "id": "informed-onboarding-coordinator-entity-policy-version",
        "relation": "informed",
        "roleId": "onboarding-coordinator",
        "targetId": "policy-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-onboarding-coordinator-entity-purchase-order",
        "relation": "informed",
        "roleId": "onboarding-coordinator",
        "targetId": "purchase-order",
        "targetKind": "entity"
      },
      {
        "id": "informed-onboarding-coordinator-entity-registry-release",
        "relation": "informed",
        "roleId": "onboarding-coordinator",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-onboarding-coordinator-entity-source-record-reference",
        "relation": "informed",
        "roleId": "onboarding-coordinator",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-onboarding-coordinator-entity-supplier-onboarding-case",
        "relation": "informed",
        "roleId": "onboarding-coordinator",
        "targetId": "supplier-onboarding-case",
        "targetKind": "entity"
      },
      {
        "id": "informed-onboarding-coordinator-entity-supplier-profile",
        "relation": "informed",
        "roleId": "onboarding-coordinator",
        "targetId": "supplier-profile",
        "targetKind": "entity"
      },
      {
        "id": "informed-onboarding-coordinator-entity-supplier-qualification",
        "relation": "informed",
        "roleId": "onboarding-coordinator",
        "targetId": "supplier-qualification",
        "targetKind": "entity"
      },
      {
        "id": "informed-onboarding-coordinator-entity-supplier-risk-assessment",
        "relation": "informed",
        "roleId": "onboarding-coordinator",
        "targetId": "supplier-risk-assessment",
        "targetKind": "entity"
      },
      {
        "id": "informed-onboarding-coordinator-entity-supplier-risk-case",
        "relation": "informed",
        "roleId": "onboarding-coordinator",
        "targetId": "supplier-risk-case",
        "targetKind": "entity"
      },
      {
        "id": "informed-onboarding-coordinator-entity-supplier-risk-signal",
        "relation": "informed",
        "roleId": "onboarding-coordinator",
        "targetId": "supplier-risk-signal",
        "targetKind": "entity"
      },
      {
        "id": "informed-onboarding-coordinator-entity-supplier-tier-link",
        "relation": "informed",
        "roleId": "onboarding-coordinator",
        "targetId": "supplier-tier-link",
        "targetKind": "entity"
      },
      {
        "id": "informed-payment-approver-entity-audit-event",
        "relation": "informed",
        "roleId": "payment-approver",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-payment-approver-entity-authority-envelope",
        "relation": "informed",
        "roleId": "payment-approver",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-payment-approver-entity-business-event",
        "relation": "informed",
        "roleId": "payment-approver",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-payment-approver-entity-exception",
        "relation": "informed",
        "roleId": "payment-approver",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-payment-approver-entity-integration-state",
        "relation": "informed",
        "roleId": "payment-approver",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-payment-approver-entity-invoice",
        "relation": "informed",
        "roleId": "payment-approver",
        "targetId": "invoice",
        "targetKind": "entity"
      },
      {
        "id": "informed-payment-approver-entity-invoice-exception",
        "relation": "informed",
        "roleId": "payment-approver",
        "targetId": "invoice-exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-payment-approver-entity-invoice-line",
        "relation": "informed",
        "roleId": "payment-approver",
        "targetId": "invoice-line",
        "targetKind": "entity"
      },
      {
        "id": "informed-payment-approver-entity-invoice-match-assessment",
        "relation": "informed",
        "roleId": "payment-approver",
        "targetId": "invoice-match-assessment",
        "targetKind": "entity"
      },
      {
        "id": "informed-payment-approver-entity-payment-readiness-assessment",
        "relation": "informed",
        "roleId": "payment-approver",
        "targetId": "payment-readiness-assessment",
        "targetKind": "entity"
      },
      {
        "id": "informed-payment-approver-entity-person",
        "relation": "informed",
        "roleId": "payment-approver",
        "targetId": "person",
        "targetKind": "entity"
      },
      {
        "id": "informed-payment-approver-entity-policy",
        "relation": "informed",
        "roleId": "payment-approver",
        "targetId": "policy",
        "targetKind": "entity"
      },
      {
        "id": "informed-payment-approver-entity-policy-version",
        "relation": "informed",
        "roleId": "payment-approver",
        "targetId": "policy-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-policy-owner-entity-authority-envelope",
        "relation": "informed",
        "roleId": "policy-owner",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-policy-owner-entity-business-unit",
        "relation": "informed",
        "roleId": "policy-owner",
        "targetId": "business-unit",
        "targetKind": "entity"
      },
      {
        "id": "informed-policy-owner-entity-category",
        "relation": "informed",
        "roleId": "policy-owner",
        "targetId": "category",
        "targetKind": "entity"
      },
      {
        "id": "informed-policy-owner-entity-category-opportunity",
        "relation": "informed",
        "roleId": "policy-owner",
        "targetId": "category-opportunity",
        "targetKind": "entity"
      },
      {
        "id": "informed-policy-owner-entity-evaluation-result",
        "relation": "informed",
        "roleId": "policy-owner",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-policy-owner-entity-evidence-item",
        "relation": "informed",
        "roleId": "policy-owner",
        "targetId": "evidence-item",
        "targetKind": "entity"
      },
      {
        "id": "informed-policy-owner-entity-exception",
        "relation": "informed",
        "roleId": "policy-owner",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-policy-owner-entity-integration-state",
        "relation": "informed",
        "roleId": "policy-owner",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-policy-owner-entity-learning-example",
        "relation": "informed",
        "roleId": "policy-owner",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-policy-owner-entity-policy",
        "relation": "informed",
        "roleId": "policy-owner",
        "targetId": "policy",
        "targetKind": "entity"
      },
      {
        "id": "informed-policy-owner-entity-policy-guidance-result",
        "relation": "informed",
        "roleId": "policy-owner",
        "targetId": "policy-guidance-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-policy-owner-entity-policy-rule-release",
        "relation": "informed",
        "roleId": "policy-owner",
        "targetId": "policy-rule-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-policy-owner-entity-policy-version",
        "relation": "informed",
        "roleId": "policy-owner",
        "targetId": "policy-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-policy-owner-entity-registry-release",
        "relation": "informed",
        "roleId": "policy-owner",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-policy-owner-entity-source-record-reference",
        "relation": "informed",
        "roleId": "policy-owner",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-policy-owner-entity-spend-record",
        "relation": "informed",
        "roleId": "policy-owner",
        "targetId": "spend-record",
        "targetKind": "entity"
      },
      {
        "id": "informed-policy-owner-entity-tail-spend-evaluation",
        "relation": "informed",
        "roleId": "policy-owner",
        "targetId": "tail-spend-evaluation",
        "targetKind": "entity"
      },
      {
        "id": "informed-process-owner-entity-action-proposal",
        "relation": "informed",
        "roleId": "process-owner",
        "targetId": "action-proposal",
        "targetKind": "entity"
      },
      {
        "id": "informed-process-owner-entity-audit-event",
        "relation": "informed",
        "roleId": "process-owner",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-process-owner-entity-authority-envelope",
        "relation": "informed",
        "roleId": "process-owner",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-process-owner-entity-budget",
        "relation": "informed",
        "roleId": "process-owner",
        "targetId": "budget",
        "targetKind": "entity"
      },
      {
        "id": "informed-process-owner-entity-business-event",
        "relation": "informed",
        "roleId": "process-owner",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-process-owner-entity-business-unit",
        "relation": "informed",
        "roleId": "process-owner",
        "targetId": "business-unit",
        "targetKind": "entity"
      },
      {
        "id": "informed-process-owner-entity-category",
        "relation": "informed",
        "roleId": "process-owner",
        "targetId": "category",
        "targetKind": "entity"
      },
      {
        "id": "informed-process-owner-entity-committed-action",
        "relation": "informed",
        "roleId": "process-owner",
        "targetId": "committed-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-process-owner-entity-decision",
        "relation": "informed",
        "roleId": "process-owner",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-process-owner-entity-demand-case",
        "relation": "informed",
        "roleId": "process-owner",
        "targetId": "demand-case",
        "targetKind": "entity"
      },
      {
        "id": "informed-process-owner-entity-enriched-request",
        "relation": "informed",
        "roleId": "process-owner",
        "targetId": "enriched-request",
        "targetKind": "entity"
      },
      {
        "id": "informed-process-owner-entity-evaluation-result",
        "relation": "informed",
        "roleId": "process-owner",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-process-owner-entity-exception",
        "relation": "informed",
        "roleId": "process-owner",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-process-owner-entity-intake-request",
        "relation": "informed",
        "roleId": "process-owner",
        "targetId": "intake-request",
        "targetKind": "entity"
      },
      {
        "id": "informed-process-owner-entity-integration-state",
        "relation": "informed",
        "roleId": "process-owner",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-process-owner-entity-item-service",
        "relation": "informed",
        "roleId": "process-owner",
        "targetId": "item-service",
        "targetKind": "entity"
      },
      {
        "id": "informed-process-owner-entity-learning-example",
        "relation": "informed",
        "roleId": "process-owner",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-process-owner-entity-person",
        "relation": "informed",
        "roleId": "process-owner",
        "targetId": "person",
        "targetKind": "entity"
      },
      {
        "id": "informed-process-owner-entity-policy",
        "relation": "informed",
        "roleId": "process-owner",
        "targetId": "policy",
        "targetKind": "entity"
      },
      {
        "id": "informed-process-owner-entity-policy-guidance-result",
        "relation": "informed",
        "roleId": "process-owner",
        "targetId": "policy-guidance-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-process-owner-entity-policy-rule-release",
        "relation": "informed",
        "roleId": "process-owner",
        "targetId": "policy-rule-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-process-owner-entity-policy-version",
        "relation": "informed",
        "roleId": "process-owner",
        "targetId": "policy-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-process-owner-entity-procurement-service-offering",
        "relation": "informed",
        "roleId": "process-owner",
        "targetId": "procurement-service-offering",
        "targetKind": "entity"
      },
      {
        "id": "informed-process-owner-entity-registry-release",
        "relation": "informed",
        "roleId": "process-owner",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-process-owner-entity-source-record-reference",
        "relation": "informed",
        "roleId": "process-owner",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-analyst-entity-authority-envelope",
        "relation": "informed",
        "roleId": "procurement-analyst",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-analyst-entity-business-unit",
        "relation": "informed",
        "roleId": "procurement-analyst",
        "targetId": "business-unit",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-analyst-entity-category",
        "relation": "informed",
        "roleId": "procurement-analyst",
        "targetId": "category",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-analyst-entity-category-dimension-assignment",
        "relation": "informed",
        "roleId": "procurement-analyst",
        "targetId": "category-dimension-assignment",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-analyst-entity-category-opportunity",
        "relation": "informed",
        "roleId": "procurement-analyst",
        "targetId": "category-opportunity",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-analyst-entity-evaluation-result",
        "relation": "informed",
        "roleId": "procurement-analyst",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-analyst-entity-evidence-item",
        "relation": "informed",
        "roleId": "procurement-analyst",
        "targetId": "evidence-item",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-analyst-entity-integration-state",
        "relation": "informed",
        "roleId": "procurement-analyst",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-analyst-entity-learning-example",
        "relation": "informed",
        "roleId": "procurement-analyst",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-analyst-entity-source-record-reference",
        "relation": "informed",
        "roleId": "procurement-analyst",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-analyst-entity-spend-record",
        "relation": "informed",
        "roleId": "procurement-analyst",
        "targetId": "spend-record",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-analyst-entity-tail-spend-evaluation",
        "relation": "informed",
        "roleId": "procurement-analyst",
        "targetId": "tail-spend-evaluation",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-analyst-entity-taxonomy-version",
        "relation": "informed",
        "roleId": "procurement-analyst",
        "targetId": "taxonomy-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-action-proposal",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "action-proposal",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-audit-event",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-authority-envelope",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-budget",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "budget",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-business-event",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-business-unit",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "business-unit",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-buying-request",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "buying-request",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-catalogue-line",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "catalogue-line",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-category",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "category",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-committed-action",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "committed-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-contract",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "contract",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-decision",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-evaluation-result",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-exception",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-integration-state",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-item-service",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "item-service",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-order-line",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "order-line",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-order-response",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "order-response",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-party",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "party",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-policy",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "policy",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-policy-version",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "policy-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-purchase-order",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "purchase-order",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-receipt",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "receipt",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-registry-release",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-requisition",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "requisition",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-requisition-line",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "requisition-line",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-return-claim",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "return-claim",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-shipment",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "shipment",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-source-record-reference",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-supplier-profile",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "supplier-profile",
        "targetKind": "entity"
      },
      {
        "id": "informed-procurement-buyer-entity-supplier-qualification",
        "relation": "informed",
        "roleId": "procurement-buyer",
        "targetId": "supplier-qualification",
        "targetKind": "entity"
      },
      {
        "id": "informed-receiver-entity-action-proposal",
        "relation": "informed",
        "roleId": "receiver",
        "targetId": "action-proposal",
        "targetKind": "entity"
      },
      {
        "id": "informed-receiver-entity-audit-event",
        "relation": "informed",
        "roleId": "receiver",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-receiver-entity-authority-envelope",
        "relation": "informed",
        "roleId": "receiver",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-receiver-entity-business-event",
        "relation": "informed",
        "roleId": "receiver",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-receiver-entity-catalogue-line",
        "relation": "informed",
        "roleId": "receiver",
        "targetId": "catalogue-line",
        "targetKind": "entity"
      },
      {
        "id": "informed-receiver-entity-committed-action",
        "relation": "informed",
        "roleId": "receiver",
        "targetId": "committed-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-receiver-entity-decision",
        "relation": "informed",
        "roleId": "receiver",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-receiver-entity-exception",
        "relation": "informed",
        "roleId": "receiver",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-receiver-entity-order-line",
        "relation": "informed",
        "roleId": "receiver",
        "targetId": "order-line",
        "targetKind": "entity"
      },
      {
        "id": "informed-receiver-entity-order-response",
        "relation": "informed",
        "roleId": "receiver",
        "targetId": "order-response",
        "targetKind": "entity"
      },
      {
        "id": "informed-receiver-entity-purchase-order",
        "relation": "informed",
        "roleId": "receiver",
        "targetId": "purchase-order",
        "targetKind": "entity"
      },
      {
        "id": "informed-receiver-entity-receipt",
        "relation": "informed",
        "roleId": "receiver",
        "targetId": "receipt",
        "targetKind": "entity"
      },
      {
        "id": "informed-receiver-entity-return-claim",
        "relation": "informed",
        "roleId": "receiver",
        "targetId": "return-claim",
        "targetKind": "entity"
      },
      {
        "id": "informed-receiver-entity-shipment",
        "relation": "informed",
        "roleId": "receiver",
        "targetId": "shipment",
        "targetKind": "entity"
      },
      {
        "id": "informed-relationship-manager-entity-audit-event",
        "relation": "informed",
        "roleId": "relationship-manager",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-relationship-manager-entity-authority-envelope",
        "relation": "informed",
        "roleId": "relationship-manager",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-relationship-manager-entity-business-event",
        "relation": "informed",
        "roleId": "relationship-manager",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-relationship-manager-entity-decision",
        "relation": "informed",
        "roleId": "relationship-manager",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-relationship-manager-entity-evaluation-result",
        "relation": "informed",
        "roleId": "relationship-manager",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-relationship-manager-entity-integration-state",
        "relation": "informed",
        "roleId": "relationship-manager",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-relationship-manager-entity-learning-example",
        "relation": "informed",
        "roleId": "relationship-manager",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-relationship-manager-entity-party",
        "relation": "informed",
        "roleId": "relationship-manager",
        "targetId": "party",
        "targetKind": "entity"
      },
      {
        "id": "informed-relationship-manager-entity-registry-release",
        "relation": "informed",
        "roleId": "relationship-manager",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-relationship-manager-entity-source-record-reference",
        "relation": "informed",
        "roleId": "relationship-manager",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-relationship-manager-entity-supplier-innovation-case",
        "relation": "informed",
        "roleId": "relationship-manager",
        "targetId": "supplier-innovation-case",
        "targetKind": "entity"
      },
      {
        "id": "informed-relationship-manager-entity-supplier-joint-value-plan",
        "relation": "informed",
        "roleId": "relationship-manager",
        "targetId": "supplier-joint-value-plan",
        "targetKind": "entity"
      },
      {
        "id": "informed-relationship-manager-entity-supplier-offboarding-case",
        "relation": "informed",
        "roleId": "relationship-manager",
        "targetId": "supplier-offboarding-case",
        "targetKind": "entity"
      },
      {
        "id": "informed-relationship-manager-entity-supplier-performance-observation",
        "relation": "informed",
        "roleId": "relationship-manager",
        "targetId": "supplier-performance-observation",
        "targetKind": "entity"
      },
      {
        "id": "informed-relationship-manager-entity-supplier-performance-review-record",
        "relation": "informed",
        "roleId": "relationship-manager",
        "targetId": "supplier-performance-review-record",
        "targetKind": "entity"
      },
      {
        "id": "informed-relationship-manager-entity-supplier-remediation-action",
        "relation": "informed",
        "roleId": "relationship-manager",
        "targetId": "supplier-remediation-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-relationship-manager-entity-supplier-segment-assignment",
        "relation": "informed",
        "roleId": "relationship-manager",
        "targetId": "supplier-segment-assignment",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-action-proposal",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "action-proposal",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-audit-event",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-authority-envelope",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-budget",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "budget",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-business-event",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-business-unit",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "business-unit",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-buying-request",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "buying-request",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-catalogue-line",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "catalogue-line",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-category",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "category",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-committed-action",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "committed-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-contract",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "contract",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-decision",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-enriched-request",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "enriched-request",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-evaluation-result",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-exception",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-intake-request",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "intake-request",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-integration-state",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-item-service",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "item-service",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-learning-example",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-order-line",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "order-line",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-order-response",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "order-response",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-party",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "party",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-person",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "person",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-policy",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "policy",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-policy-guidance-result",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "policy-guidance-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-policy-rule-release",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "policy-rule-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-policy-version",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "policy-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-procurement-service-offering",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "procurement-service-offering",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-purchase-order",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "purchase-order",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-receipt",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "receipt",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-registry-release",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-return-claim",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "return-claim",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-shipment",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "shipment",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-source-record-reference",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-supplier-profile",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "supplier-profile",
        "targetKind": "entity"
      },
      {
        "id": "informed-requester-entity-supplier-qualification",
        "relation": "informed",
        "roleId": "requester",
        "targetId": "supplier-qualification",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-action-proposal",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "action-proposal",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-audit-event",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-authority-envelope",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-business-event",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-category",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "category",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-committed-action",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "committed-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-decision",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-evaluation-result",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-evidence-item",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "evidence-item",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-exception",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-integration-state",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-invoice",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "invoice",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-invoice-exception",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "invoice-exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-invoice-line",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "invoice-line",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-invoice-match-assessment",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "invoice-match-assessment",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-item-service",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "item-service",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-learning-example",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-order-line",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "order-line",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-party",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "party",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-payment-readiness-assessment",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "payment-readiness-assessment",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-person",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "person",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-policy",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "policy",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-policy-version",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "policy-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-purchase-order",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "purchase-order",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-purchase-order-exception",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "purchase-order-exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-receipt",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "receipt",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-receipt-line",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "receipt-line",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-registry-release",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-service-entry-sheet",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "service-entry-sheet",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-source-record-reference",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-risk-owner-entity-supplier-invoice-resolution",
        "relation": "informed",
        "roleId": "risk-owner",
        "targetId": "supplier-invoice-resolution",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-action-proposal",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "action-proposal",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-audit-event",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-authority-envelope",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-award-scenario",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "award-scenario",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-business-event",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-category",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "category",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-category-opportunity",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "category-opportunity",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-category-strategy",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "category-strategy",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-committed-action",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "committed-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-decision",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-demand-case",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "demand-case",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-demand-portfolio",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "demand-portfolio",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-evaluation-result",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-evidence-item",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "evidence-item",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-exception",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-integration-state",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-item-service",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "item-service",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-learning-example",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-negotiation-session",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "negotiation-session",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-party",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "party",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-person",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "person",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-policy",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "policy",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-policy-version",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "policy-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-registry-release",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-source-record-reference",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-sourcing-event-record",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "sourcing-event-record",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-sourcing-opportunity",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "sourcing-opportunity",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-supplier-response",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "supplier-response",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-lead-entity-tactical-sourcing-case",
        "relation": "informed",
        "roleId": "sourcing-lead",
        "targetId": "tactical-sourcing-case",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-action-proposal",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "action-proposal",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-audit-event",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-authority-envelope",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-business-event",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-clause-deviation",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "clause-deviation",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-clause-library-entry",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "clause-library-entry",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-committed-action",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "committed-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-contract",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "contract",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-contract-approval",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "contract-approval",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-contract-change",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "contract-change",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-contract-compliance-finding",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "contract-compliance-finding",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-contract-entitlement",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "contract-entitlement",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-contract-intake",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "contract-intake",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-contract-obligation",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "contract-obligation",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-contract-template",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "contract-template",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-contract-version",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "contract-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-decision",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-evaluation-result",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-evidence-item",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "evidence-item",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-exception",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-integration-state",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-learning-example",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-party",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "party",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-person",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "person",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-policy",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "policy",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-policy-version",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "policy-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-registry-release",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-source-record-reference",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-sourcing-manager-entity-supplier-profile",
        "relation": "informed",
        "roleId": "sourcing-manager",
        "targetId": "supplier-profile",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-account-lead-entity-audit-event",
        "relation": "informed",
        "roleId": "supplier-account-lead",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-account-lead-entity-authority-envelope",
        "relation": "informed",
        "roleId": "supplier-account-lead",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-account-lead-entity-business-event",
        "relation": "informed",
        "roleId": "supplier-account-lead",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-account-lead-entity-decision",
        "relation": "informed",
        "roleId": "supplier-account-lead",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-account-lead-entity-evaluation-result",
        "relation": "informed",
        "roleId": "supplier-account-lead",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-account-lead-entity-integration-state",
        "relation": "informed",
        "roleId": "supplier-account-lead",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-account-lead-entity-learning-example",
        "relation": "informed",
        "roleId": "supplier-account-lead",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-account-lead-entity-party",
        "relation": "informed",
        "roleId": "supplier-account-lead",
        "targetId": "party",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-account-lead-entity-registry-release",
        "relation": "informed",
        "roleId": "supplier-account-lead",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-account-lead-entity-source-record-reference",
        "relation": "informed",
        "roleId": "supplier-account-lead",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-account-lead-entity-supplier-innovation-case",
        "relation": "informed",
        "roleId": "supplier-account-lead",
        "targetId": "supplier-innovation-case",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-account-lead-entity-supplier-joint-value-plan",
        "relation": "informed",
        "roleId": "supplier-account-lead",
        "targetId": "supplier-joint-value-plan",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-account-lead-entity-supplier-offboarding-case",
        "relation": "informed",
        "roleId": "supplier-account-lead",
        "targetId": "supplier-offboarding-case",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-account-lead-entity-supplier-performance-observation",
        "relation": "informed",
        "roleId": "supplier-account-lead",
        "targetId": "supplier-performance-observation",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-account-lead-entity-supplier-performance-review-record",
        "relation": "informed",
        "roleId": "supplier-account-lead",
        "targetId": "supplier-performance-review-record",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-account-lead-entity-supplier-remediation-action",
        "relation": "informed",
        "roleId": "supplier-account-lead",
        "targetId": "supplier-remediation-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-account-lead-entity-supplier-segment-assignment",
        "relation": "informed",
        "roleId": "supplier-account-lead",
        "targetId": "supplier-segment-assignment",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-contact-entity-action-proposal",
        "relation": "informed",
        "roleId": "supplier-contact",
        "targetId": "action-proposal",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-contact-entity-audit-event",
        "relation": "informed",
        "roleId": "supplier-contact",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-contact-entity-authority-envelope",
        "relation": "informed",
        "roleId": "supplier-contact",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-contact-entity-business-event",
        "relation": "informed",
        "roleId": "supplier-contact",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-contact-entity-committed-action",
        "relation": "informed",
        "roleId": "supplier-contact",
        "targetId": "committed-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-contact-entity-contract",
        "relation": "informed",
        "roleId": "supplier-contact",
        "targetId": "contract",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-contact-entity-decision",
        "relation": "informed",
        "roleId": "supplier-contact",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-contact-entity-evaluation-result",
        "relation": "informed",
        "roleId": "supplier-contact",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-contact-entity-evidence-item",
        "relation": "informed",
        "roleId": "supplier-contact",
        "targetId": "evidence-item",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-contact-entity-exception",
        "relation": "informed",
        "roleId": "supplier-contact",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-contact-entity-integration-state",
        "relation": "informed",
        "roleId": "supplier-contact",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-contact-entity-learning-example",
        "relation": "informed",
        "roleId": "supplier-contact",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-contact-entity-party",
        "relation": "informed",
        "roleId": "supplier-contact",
        "targetId": "party",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-contact-entity-person",
        "relation": "informed",
        "roleId": "supplier-contact",
        "targetId": "person",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-contact-entity-policy",
        "relation": "informed",
        "roleId": "supplier-contact",
        "targetId": "policy",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-contact-entity-policy-version",
        "relation": "informed",
        "roleId": "supplier-contact",
        "targetId": "policy-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-contact-entity-purchase-order",
        "relation": "informed",
        "roleId": "supplier-contact",
        "targetId": "purchase-order",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-contact-entity-registry-release",
        "relation": "informed",
        "roleId": "supplier-contact",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-contact-entity-source-record-reference",
        "relation": "informed",
        "roleId": "supplier-contact",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-contact-entity-supplier-onboarding-case",
        "relation": "informed",
        "roleId": "supplier-contact",
        "targetId": "supplier-onboarding-case",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-contact-entity-supplier-profile",
        "relation": "informed",
        "roleId": "supplier-contact",
        "targetId": "supplier-profile",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-contact-entity-supplier-qualification",
        "relation": "informed",
        "roleId": "supplier-contact",
        "targetId": "supplier-qualification",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-contact-entity-supplier-risk-assessment",
        "relation": "informed",
        "roleId": "supplier-contact",
        "targetId": "supplier-risk-assessment",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-contact-entity-supplier-risk-case",
        "relation": "informed",
        "roleId": "supplier-contact",
        "targetId": "supplier-risk-case",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-contact-entity-supplier-risk-signal",
        "relation": "informed",
        "roleId": "supplier-contact",
        "targetId": "supplier-risk-signal",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-contact-entity-supplier-tier-link",
        "relation": "informed",
        "roleId": "supplier-contact",
        "targetId": "supplier-tier-link",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-master-steward-entity-integration-state",
        "relation": "informed",
        "roleId": "supplier-master-steward",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-master-steward-entity-party",
        "relation": "informed",
        "roleId": "supplier-master-steward",
        "targetId": "party",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-master-steward-entity-policy",
        "relation": "informed",
        "roleId": "supplier-master-steward",
        "targetId": "policy",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-master-steward-entity-registry-release",
        "relation": "informed",
        "roleId": "supplier-master-steward",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-master-steward-entity-source-record-reference",
        "relation": "informed",
        "roleId": "supplier-master-steward",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-master-steward-entity-supplier-onboarding-case",
        "relation": "informed",
        "roleId": "supplier-master-steward",
        "targetId": "supplier-onboarding-case",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-master-steward-entity-supplier-profile",
        "relation": "informed",
        "roleId": "supplier-master-steward",
        "targetId": "supplier-profile",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-master-steward-entity-supplier-qualification",
        "relation": "informed",
        "roleId": "supplier-master-steward",
        "targetId": "supplier-qualification",
        "targetKind": "entity"
      },
      {
        "id": "informed-supplier-master-steward-entity-supplier-risk-assessment",
        "relation": "informed",
        "roleId": "supplier-master-steward",
        "targetId": "supplier-risk-assessment",
        "targetKind": "entity"
      },
      {
        "id": "informed-tprm-programme-owner-entity-action-proposal",
        "relation": "informed",
        "roleId": "tprm-programme-owner",
        "targetId": "action-proposal",
        "targetKind": "entity"
      },
      {
        "id": "informed-tprm-programme-owner-entity-audit-event",
        "relation": "informed",
        "roleId": "tprm-programme-owner",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-tprm-programme-owner-entity-authority-envelope",
        "relation": "informed",
        "roleId": "tprm-programme-owner",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-tprm-programme-owner-entity-business-event",
        "relation": "informed",
        "roleId": "tprm-programme-owner",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-tprm-programme-owner-entity-committed-action",
        "relation": "informed",
        "roleId": "tprm-programme-owner",
        "targetId": "committed-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-tprm-programme-owner-entity-contract",
        "relation": "informed",
        "roleId": "tprm-programme-owner",
        "targetId": "contract",
        "targetKind": "entity"
      },
      {
        "id": "informed-tprm-programme-owner-entity-decision",
        "relation": "informed",
        "roleId": "tprm-programme-owner",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-tprm-programme-owner-entity-evaluation-result",
        "relation": "informed",
        "roleId": "tprm-programme-owner",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-tprm-programme-owner-entity-evidence-item",
        "relation": "informed",
        "roleId": "tprm-programme-owner",
        "targetId": "evidence-item",
        "targetKind": "entity"
      },
      {
        "id": "informed-tprm-programme-owner-entity-exception",
        "relation": "informed",
        "roleId": "tprm-programme-owner",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-tprm-programme-owner-entity-integration-state",
        "relation": "informed",
        "roleId": "tprm-programme-owner",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-tprm-programme-owner-entity-learning-example",
        "relation": "informed",
        "roleId": "tprm-programme-owner",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-tprm-programme-owner-entity-party",
        "relation": "informed",
        "roleId": "tprm-programme-owner",
        "targetId": "party",
        "targetKind": "entity"
      },
      {
        "id": "informed-tprm-programme-owner-entity-person",
        "relation": "informed",
        "roleId": "tprm-programme-owner",
        "targetId": "person",
        "targetKind": "entity"
      },
      {
        "id": "informed-tprm-programme-owner-entity-policy",
        "relation": "informed",
        "roleId": "tprm-programme-owner",
        "targetId": "policy",
        "targetKind": "entity"
      },
      {
        "id": "informed-tprm-programme-owner-entity-policy-version",
        "relation": "informed",
        "roleId": "tprm-programme-owner",
        "targetId": "policy-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-tprm-programme-owner-entity-purchase-order",
        "relation": "informed",
        "roleId": "tprm-programme-owner",
        "targetId": "purchase-order",
        "targetKind": "entity"
      },
      {
        "id": "informed-tprm-programme-owner-entity-registry-release",
        "relation": "informed",
        "roleId": "tprm-programme-owner",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-tprm-programme-owner-entity-source-record-reference",
        "relation": "informed",
        "roleId": "tprm-programme-owner",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-tprm-programme-owner-entity-supplier-master-change",
        "relation": "informed",
        "roleId": "tprm-programme-owner",
        "targetId": "supplier-master-change",
        "targetKind": "entity"
      },
      {
        "id": "informed-tprm-programme-owner-entity-supplier-onboarding-case",
        "relation": "informed",
        "roleId": "tprm-programme-owner",
        "targetId": "supplier-onboarding-case",
        "targetKind": "entity"
      },
      {
        "id": "informed-tprm-programme-owner-entity-supplier-profile",
        "relation": "informed",
        "roleId": "tprm-programme-owner",
        "targetId": "supplier-profile",
        "targetKind": "entity"
      },
      {
        "id": "informed-tprm-programme-owner-entity-supplier-qualification",
        "relation": "informed",
        "roleId": "tprm-programme-owner",
        "targetId": "supplier-qualification",
        "targetKind": "entity"
      },
      {
        "id": "informed-tprm-programme-owner-entity-supplier-risk-assessment",
        "relation": "informed",
        "roleId": "tprm-programme-owner",
        "targetId": "supplier-risk-assessment",
        "targetKind": "entity"
      },
      {
        "id": "informed-tprm-programme-owner-entity-supplier-risk-case",
        "relation": "informed",
        "roleId": "tprm-programme-owner",
        "targetId": "supplier-risk-case",
        "targetKind": "entity"
      },
      {
        "id": "informed-tprm-programme-owner-entity-supplier-risk-signal",
        "relation": "informed",
        "roleId": "tprm-programme-owner",
        "targetId": "supplier-risk-signal",
        "targetKind": "entity"
      },
      {
        "id": "informed-tprm-programme-owner-entity-supplier-tier-link",
        "relation": "informed",
        "roleId": "tprm-programme-owner",
        "targetId": "supplier-tier-link",
        "targetKind": "entity"
      },
      {
        "id": "informed-treasury-manager-entity-audit-event",
        "relation": "informed",
        "roleId": "treasury-manager",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-treasury-manager-entity-authority-envelope",
        "relation": "informed",
        "roleId": "treasury-manager",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-treasury-manager-entity-business-event",
        "relation": "informed",
        "roleId": "treasury-manager",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-treasury-manager-entity-exception",
        "relation": "informed",
        "roleId": "treasury-manager",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-treasury-manager-entity-integration-state",
        "relation": "informed",
        "roleId": "treasury-manager",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-treasury-manager-entity-invoice",
        "relation": "informed",
        "roleId": "treasury-manager",
        "targetId": "invoice",
        "targetKind": "entity"
      },
      {
        "id": "informed-treasury-manager-entity-invoice-exception",
        "relation": "informed",
        "roleId": "treasury-manager",
        "targetId": "invoice-exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-treasury-manager-entity-invoice-line",
        "relation": "informed",
        "roleId": "treasury-manager",
        "targetId": "invoice-line",
        "targetKind": "entity"
      },
      {
        "id": "informed-treasury-manager-entity-invoice-match-assessment",
        "relation": "informed",
        "roleId": "treasury-manager",
        "targetId": "invoice-match-assessment",
        "targetKind": "entity"
      },
      {
        "id": "informed-treasury-manager-entity-payment-readiness-assessment",
        "relation": "informed",
        "roleId": "treasury-manager",
        "targetId": "payment-readiness-assessment",
        "targetKind": "entity"
      },
      {
        "id": "informed-treasury-manager-entity-person",
        "relation": "informed",
        "roleId": "treasury-manager",
        "targetId": "person",
        "targetKind": "entity"
      },
      {
        "id": "informed-treasury-manager-entity-policy",
        "relation": "informed",
        "roleId": "treasury-manager",
        "targetId": "policy",
        "targetKind": "entity"
      },
      {
        "id": "informed-treasury-manager-entity-policy-version",
        "relation": "informed",
        "roleId": "treasury-manager",
        "targetId": "policy-version",
        "targetKind": "entity"
      },
      {
        "id": "informed-value-lead-entity-action-proposal",
        "relation": "informed",
        "roleId": "value-lead",
        "targetId": "action-proposal",
        "targetKind": "entity"
      },
      {
        "id": "informed-value-lead-entity-audit-event",
        "relation": "informed",
        "roleId": "value-lead",
        "targetId": "audit-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-value-lead-entity-authority-envelope",
        "relation": "informed",
        "roleId": "value-lead",
        "targetId": "authority-envelope",
        "targetKind": "entity"
      },
      {
        "id": "informed-value-lead-entity-budget",
        "relation": "informed",
        "roleId": "value-lead",
        "targetId": "budget",
        "targetKind": "entity"
      },
      {
        "id": "informed-value-lead-entity-business-event",
        "relation": "informed",
        "roleId": "value-lead",
        "targetId": "business-event",
        "targetKind": "entity"
      },
      {
        "id": "informed-value-lead-entity-business-unit",
        "relation": "informed",
        "roleId": "value-lead",
        "targetId": "business-unit",
        "targetKind": "entity"
      },
      {
        "id": "informed-value-lead-entity-category",
        "relation": "informed",
        "roleId": "value-lead",
        "targetId": "category",
        "targetKind": "entity"
      },
      {
        "id": "informed-value-lead-entity-committed-action",
        "relation": "informed",
        "roleId": "value-lead",
        "targetId": "committed-action",
        "targetKind": "entity"
      },
      {
        "id": "informed-value-lead-entity-decision",
        "relation": "informed",
        "roleId": "value-lead",
        "targetId": "decision",
        "targetKind": "entity"
      },
      {
        "id": "informed-value-lead-entity-evaluation-result",
        "relation": "informed",
        "roleId": "value-lead",
        "targetId": "evaluation-result",
        "targetKind": "entity"
      },
      {
        "id": "informed-value-lead-entity-evidence-item",
        "relation": "informed",
        "roleId": "value-lead",
        "targetId": "evidence-item",
        "targetKind": "entity"
      },
      {
        "id": "informed-value-lead-entity-exception",
        "relation": "informed",
        "roleId": "value-lead",
        "targetId": "exception",
        "targetKind": "entity"
      },
      {
        "id": "informed-value-lead-entity-integration-state",
        "relation": "informed",
        "roleId": "value-lead",
        "targetId": "integration-state",
        "targetKind": "entity"
      },
      {
        "id": "informed-value-lead-entity-learning-example",
        "relation": "informed",
        "roleId": "value-lead",
        "targetId": "learning-example",
        "targetKind": "entity"
      },
      {
        "id": "informed-value-lead-entity-payment-execution-status",
        "relation": "informed",
        "roleId": "value-lead",
        "targetId": "payment-execution-status",
        "targetKind": "entity"
      },
      {
        "id": "informed-value-lead-entity-payment-instruction",
        "relation": "informed",
        "roleId": "value-lead",
        "targetId": "payment-instruction",
        "targetKind": "entity"
      },
      {
        "id": "informed-value-lead-entity-registry-release",
        "relation": "informed",
        "roleId": "value-lead",
        "targetId": "registry-release",
        "targetKind": "entity"
      },
      {
        "id": "informed-value-lead-entity-savings-initiative-record",
        "relation": "informed",
        "roleId": "value-lead",
        "targetId": "savings-initiative-record",
        "targetKind": "entity"
      },
      {
        "id": "informed-value-lead-entity-source-record-reference",
        "relation": "informed",
        "roleId": "value-lead",
        "targetId": "source-record-reference",
        "targetKind": "entity"
      },
      {
        "id": "informed-value-lead-entity-value-leakage-finding",
        "relation": "informed",
        "roleId": "value-lead",
        "targetId": "value-leakage-finding",
        "targetKind": "entity"
      },
      {
        "id": "informed-value-lead-entity-value-opportunity-baseline",
        "relation": "informed",
        "roleId": "value-lead",
        "targetId": "value-opportunity-baseline",
        "targetKind": "entity"
      },
      {
        "id": "informed-value-lead-entity-value-portfolio-forecast",
        "relation": "informed",
        "roleId": "value-lead",
        "targetId": "value-portfolio-forecast",
        "targetKind": "entity"
      },
      {
        "id": "informed-value-lead-entity-value-realization-attribution",
        "relation": "informed",
        "roleId": "value-lead",
        "targetId": "value-realization-attribution",
        "targetKind": "entity"
      },
      {
        "id": "performs-accountable-risk-owner-business-module-supplier-remediation-exit",
        "relation": "performs",
        "roleId": "accountable-risk-owner",
        "targetId": "supplier-remediation-exit",
        "targetKind": "business-module"
      },
      {
        "id": "performs-accountable-risk-owner-business-module-third-party-risk-review",
        "relation": "performs",
        "roleId": "accountable-risk-owner",
        "targetId": "third-party-risk-review",
        "targetKind": "business-module"
      },
      {
        "id": "performs-accountable-risk-owner-entity-supplier-offboarding-case",
        "relation": "performs",
        "roleId": "accountable-risk-owner",
        "targetId": "supplier-offboarding-case",
        "targetKind": "entity"
      },
      {
        "id": "performs-accountable-risk-owner-entity-supplier-remediation-action",
        "relation": "performs",
        "roleId": "accountable-risk-owner",
        "targetId": "supplier-remediation-action",
        "targetKind": "entity"
      },
      {
        "id": "performs-accountable-risk-owner-entity-supplier-risk-assessment",
        "relation": "performs",
        "roleId": "accountable-risk-owner",
        "targetId": "supplier-risk-assessment",
        "targetKind": "entity"
      },
      {
        "id": "performs-accountable-risk-owner-job-continuous-risk-monitoring-material-case",
        "relation": "performs",
        "roleId": "accountable-risk-owner",
        "targetId": "continuous-risk-monitoring.material-case",
        "targetKind": "job"
      },
      {
        "id": "performs-accountable-risk-owner-job-continuous-risk-monitoring-resolve-exposure",
        "relation": "performs",
        "roleId": "accountable-risk-owner",
        "targetId": "continuous-risk-monitoring.resolve-exposure",
        "targetKind": "job"
      },
      {
        "id": "performs-accountable-risk-owner-job-supplier-master-qualification-expiry-monitoring",
        "relation": "performs",
        "roleId": "accountable-risk-owner",
        "targetId": "supplier-master-qualification.expiry-monitoring",
        "targetKind": "job"
      },
      {
        "id": "performs-accountable-risk-owner-job-supplier-remediation-exit-controlled-exit",
        "relation": "performs",
        "roleId": "accountable-risk-owner",
        "targetId": "supplier-remediation-exit.controlled-exit",
        "targetKind": "job"
      },
      {
        "id": "performs-accountable-risk-owner-job-supplier-remediation-exit-corrective-plan",
        "relation": "performs",
        "roleId": "accountable-risk-owner",
        "targetId": "supplier-remediation-exit.corrective-plan",
        "targetKind": "job"
      },
      {
        "id": "performs-accountable-risk-owner-job-third-party-risk-review-decision-package",
        "relation": "performs",
        "roleId": "accountable-risk-owner",
        "targetId": "third-party-risk-review.decision-package",
        "targetKind": "job"
      },
      {
        "id": "performs-accountable-risk-owner-job-third-party-risk-review-mitigation-closure",
        "relation": "performs",
        "roleId": "accountable-risk-owner",
        "targetId": "third-party-risk-review.mitigation-closure",
        "targetKind": "job"
      },
      {
        "id": "performs-accountable-risk-owner-job-third-party-risk-review-monitoring-signal",
        "relation": "performs",
        "roleId": "accountable-risk-owner",
        "targetId": "third-party-risk-review.monitoring-signal",
        "targetKind": "job"
      },
      {
        "id": "performs-ap-processor-business-module-invoice-exception-triage",
        "relation": "performs",
        "roleId": "ap-processor",
        "targetId": "invoice-exception-triage",
        "targetKind": "business-module"
      },
      {
        "id": "performs-ap-processor-business-module-invoice-intake-match",
        "relation": "performs",
        "roleId": "ap-processor",
        "targetId": "invoice-intake-match",
        "targetKind": "business-module"
      },
      {
        "id": "performs-ap-processor-business-module-supplier-invoice-resolution",
        "relation": "performs",
        "roleId": "ap-processor",
        "targetId": "supplier-invoice-resolution",
        "targetKind": "business-module"
      },
      {
        "id": "performs-ap-processor-entity-invoice",
        "relation": "performs",
        "roleId": "ap-processor",
        "targetId": "invoice",
        "targetKind": "entity"
      },
      {
        "id": "performs-ap-processor-entity-invoice-exception",
        "relation": "performs",
        "roleId": "ap-processor",
        "targetId": "invoice-exception",
        "targetKind": "entity"
      },
      {
        "id": "performs-ap-processor-entity-invoice-line",
        "relation": "performs",
        "roleId": "ap-processor",
        "targetId": "invoice-line",
        "targetKind": "entity"
      },
      {
        "id": "performs-ap-processor-entity-invoice-match-assessment",
        "relation": "performs",
        "roleId": "ap-processor",
        "targetId": "invoice-match-assessment",
        "targetKind": "entity"
      },
      {
        "id": "performs-ap-processor-entity-supplier-invoice-resolution",
        "relation": "performs",
        "roleId": "ap-processor",
        "targetId": "supplier-invoice-resolution",
        "targetKind": "entity"
      },
      {
        "id": "performs-ap-processor-job-invoice-exception-triage-approval-missing",
        "relation": "performs",
        "roleId": "ap-processor",
        "targetId": "invoice-exception-triage.approval-missing",
        "targetKind": "job"
      },
      {
        "id": "performs-ap-processor-job-invoice-exception-triage-missing-receipt",
        "relation": "performs",
        "roleId": "ap-processor",
        "targetId": "invoice-exception-triage.missing-receipt",
        "targetKind": "job"
      },
      {
        "id": "performs-ap-processor-job-invoice-exception-triage-price-mismatch",
        "relation": "performs",
        "roleId": "ap-processor",
        "targetId": "invoice-exception-triage.price-mismatch",
        "targetKind": "job"
      },
      {
        "id": "performs-ap-processor-job-invoice-exception-triage-quantity-mismatch",
        "relation": "performs",
        "roleId": "ap-processor",
        "targetId": "invoice-exception-triage.quantity-mismatch",
        "targetKind": "job"
      },
      {
        "id": "performs-ap-processor-job-invoice-intake-match-channel-intake",
        "relation": "performs",
        "roleId": "ap-processor",
        "targetId": "invoice-intake-match.channel-intake",
        "targetKind": "job"
      },
      {
        "id": "performs-ap-processor-job-invoice-intake-match-line-match",
        "relation": "performs",
        "roleId": "ap-processor",
        "targetId": "invoice-intake-match.line-match",
        "targetKind": "job"
      },
      {
        "id": "performs-ap-processor-job-invoice-intake-match-syntax-business-validation",
        "relation": "performs",
        "roleId": "ap-processor",
        "targetId": "invoice-intake-match.syntax-business-validation",
        "targetKind": "job"
      },
      {
        "id": "performs-ap-processor-job-supplier-invoice-resolution-approved-exchange",
        "relation": "performs",
        "roleId": "ap-processor",
        "targetId": "supplier-invoice-resolution.approved-exchange",
        "targetKind": "job"
      },
      {
        "id": "performs-ap-processor-job-supplier-invoice-resolution-precise-request",
        "relation": "performs",
        "roleId": "ap-processor",
        "targetId": "supplier-invoice-resolution.precise-request",
        "targetKind": "job"
      },
      {
        "id": "performs-ap-processor-job-supplier-invoice-resolution-response-commitment",
        "relation": "performs",
        "roleId": "ap-processor",
        "targetId": "supplier-invoice-resolution.response-commitment",
        "targetKind": "job"
      },
      {
        "id": "performs-award-authority-job-bid-evaluation-award-challenge-recommendation",
        "relation": "performs",
        "roleId": "award-authority",
        "targetId": "bid-evaluation-award.challenge-recommendation",
        "targetKind": "job"
      },
      {
        "id": "performs-award-authority-job-bid-evaluation-award-commit-award",
        "relation": "performs",
        "roleId": "award-authority",
        "targetId": "bid-evaluation-award.commit-award",
        "targetKind": "job"
      },
      {
        "id": "performs-award-authority-job-sourcing-event-decide-award",
        "relation": "performs",
        "roleId": "award-authority",
        "targetId": "sourcing-event.decide-award",
        "targetKind": "job"
      },
      {
        "id": "performs-award-authority-job-tactical-sourcing-autonomy-routine-award",
        "relation": "performs",
        "roleId": "award-authority",
        "targetId": "tactical-sourcing-autonomy.routine-award",
        "targetKind": "job"
      },
      {
        "id": "performs-budget-owner-business-module-guided-buying",
        "relation": "performs",
        "roleId": "budget-owner",
        "targetId": "guided-buying",
        "targetKind": "business-module"
      },
      {
        "id": "performs-budget-owner-entity-buying-request",
        "relation": "performs",
        "roleId": "budget-owner",
        "targetId": "buying-request",
        "targetKind": "entity"
      },
      {
        "id": "performs-budget-owner-job-guided-buying-approve-with-context",
        "relation": "performs",
        "roleId": "budget-owner",
        "targetId": "guided-buying.approve-with-context",
        "targetKind": "job"
      },
      {
        "id": "performs-budget-owner-job-requisition-policy-routing-budget-authority",
        "relation": "performs",
        "roleId": "budget-owner",
        "targetId": "requisition-policy-routing.budget-authority",
        "targetKind": "job"
      },
      {
        "id": "performs-budget-owner-job-value-leakage-monitor-own-the-response",
        "relation": "performs",
        "roleId": "budget-owner",
        "targetId": "value-leakage-monitor.own-the-response",
        "targetKind": "job"
      },
      {
        "id": "performs-budget-owner-job-value-portfolio-forecast-portfolio-risk",
        "relation": "performs",
        "roleId": "budget-owner",
        "targetId": "value-portfolio-forecast.portfolio-risk",
        "targetKind": "job"
      },
      {
        "id": "performs-category-manager-business-module-category-opportunity-radar",
        "relation": "performs",
        "roleId": "category-manager",
        "targetId": "category-opportunity-radar",
        "targetKind": "business-module"
      },
      {
        "id": "performs-category-manager-business-module-category-strategy-orchestrator",
        "relation": "performs",
        "roleId": "category-manager",
        "targetId": "category-strategy-orchestrator",
        "targetKind": "business-module"
      },
      {
        "id": "performs-category-manager-business-module-renewal-change-compliance",
        "relation": "performs",
        "roleId": "category-manager",
        "targetId": "renewal-change-compliance",
        "targetKind": "business-module"
      },
      {
        "id": "performs-category-manager-business-module-savings-initiative",
        "relation": "performs",
        "roleId": "category-manager",
        "targetId": "savings-initiative",
        "targetKind": "business-module"
      },
      {
        "id": "performs-category-manager-entity-category-opportunity",
        "relation": "performs",
        "roleId": "category-manager",
        "targetId": "category-opportunity",
        "targetKind": "entity"
      },
      {
        "id": "performs-category-manager-entity-category-strategy",
        "relation": "performs",
        "roleId": "category-manager",
        "targetId": "category-strategy",
        "targetKind": "entity"
      },
      {
        "id": "performs-category-manager-entity-contract-change",
        "relation": "performs",
        "roleId": "category-manager",
        "targetId": "contract-change",
        "targetKind": "entity"
      },
      {
        "id": "performs-category-manager-entity-contract-compliance-finding",
        "relation": "performs",
        "roleId": "category-manager",
        "targetId": "contract-compliance-finding",
        "targetKind": "entity"
      },
      {
        "id": "performs-category-manager-entity-savings-initiative-record",
        "relation": "performs",
        "roleId": "category-manager",
        "targetId": "savings-initiative-record",
        "targetKind": "entity"
      },
      {
        "id": "performs-category-manager-job-category-opportunity-radar-approved-handoff",
        "relation": "performs",
        "roleId": "category-manager",
        "targetId": "category-opportunity-radar.approved-handoff",
        "targetKind": "job"
      },
      {
        "id": "performs-category-manager-job-category-opportunity-radar-boundary-review",
        "relation": "performs",
        "roleId": "category-manager",
        "targetId": "category-opportunity-radar.boundary-review",
        "targetKind": "job"
      },
      {
        "id": "performs-category-manager-job-category-opportunity-radar-market-event",
        "relation": "performs",
        "roleId": "category-manager",
        "targetId": "category-opportunity-radar.market-event",
        "targetKind": "job"
      },
      {
        "id": "performs-category-manager-job-category-opportunity-radar-spend-refresh",
        "relation": "performs",
        "roleId": "category-manager",
        "targetId": "category-opportunity-radar.spend-refresh",
        "targetKind": "job"
      },
      {
        "id": "performs-category-manager-job-category-strategy-orchestrator-current-fact-base",
        "relation": "performs",
        "roleId": "category-manager",
        "targetId": "category-strategy-orchestrator.current-fact-base",
        "targetKind": "job"
      },
      {
        "id": "performs-category-manager-job-category-strategy-orchestrator-scenario-choice",
        "relation": "performs",
        "roleId": "category-manager",
        "targetId": "category-strategy-orchestrator.scenario-choice",
        "targetKind": "job"
      },
      {
        "id": "performs-category-manager-job-category-strategy-orchestrator-strategy-commit",
        "relation": "performs",
        "roleId": "category-manager",
        "targetId": "category-strategy-orchestrator.strategy-commit",
        "targetKind": "job"
      },
      {
        "id": "performs-category-manager-job-category-strategy-orchestrator-strategy-drift",
        "relation": "performs",
        "roleId": "category-manager",
        "targetId": "category-strategy-orchestrator.strategy-drift",
        "targetKind": "job"
      },
      {
        "id": "performs-category-manager-job-savings-initiative-carry-award",
        "relation": "performs",
        "roleId": "category-manager",
        "targetId": "savings-initiative.carry-award",
        "targetKind": "job"
      },
      {
        "id": "performs-category-manager-job-value-leakage-monitor-source-acceptance",
        "relation": "performs",
        "roleId": "category-manager",
        "targetId": "value-leakage-monitor.source-acceptance",
        "targetKind": "job"
      },
      {
        "id": "performs-category-manager-job-value-opportunity-baseline-counterfactual-scope",
        "relation": "performs",
        "roleId": "category-manager",
        "targetId": "value-opportunity-baseline.counterfactual-scope",
        "targetKind": "job"
      },
      {
        "id": "performs-category-manager-job-value-portfolio-forecast-track-intervention",
        "relation": "performs",
        "roleId": "category-manager",
        "targetId": "value-portfolio-forecast.track-intervention",
        "targetKind": "job"
      },
      {
        "id": "performs-contract-manager-business-module-contract-approval-repository",
        "relation": "performs",
        "roleId": "contract-manager",
        "targetId": "contract-approval-repository",
        "targetKind": "business-module"
      },
      {
        "id": "performs-contract-manager-business-module-contract-authoring-review",
        "relation": "performs",
        "roleId": "contract-manager",
        "targetId": "contract-authoring-review",
        "targetKind": "business-module"
      },
      {
        "id": "performs-contract-manager-business-module-contract-intake-digitization",
        "relation": "performs",
        "roleId": "contract-manager",
        "targetId": "contract-intake-digitization",
        "targetKind": "business-module"
      },
      {
        "id": "performs-contract-manager-business-module-obligation-monitoring",
        "relation": "performs",
        "roleId": "contract-manager",
        "targetId": "obligation-monitoring",
        "targetKind": "business-module"
      },
      {
        "id": "performs-contract-manager-business-module-renewal-change-compliance",
        "relation": "performs",
        "roleId": "contract-manager",
        "targetId": "renewal-change-compliance",
        "targetKind": "business-module"
      },
      {
        "id": "performs-contract-manager-entity-clause-deviation",
        "relation": "performs",
        "roleId": "contract-manager",
        "targetId": "clause-deviation",
        "targetKind": "entity"
      },
      {
        "id": "performs-contract-manager-entity-clause-library-entry",
        "relation": "performs",
        "roleId": "contract-manager",
        "targetId": "clause-library-entry",
        "targetKind": "entity"
      },
      {
        "id": "performs-contract-manager-entity-contract",
        "relation": "performs",
        "roleId": "contract-manager",
        "targetId": "contract",
        "targetKind": "entity"
      },
      {
        "id": "performs-contract-manager-entity-contract-approval",
        "relation": "performs",
        "roleId": "contract-manager",
        "targetId": "contract-approval",
        "targetKind": "entity"
      },
      {
        "id": "performs-contract-manager-entity-contract-change",
        "relation": "performs",
        "roleId": "contract-manager",
        "targetId": "contract-change",
        "targetKind": "entity"
      },
      {
        "id": "performs-contract-manager-entity-contract-compliance-finding",
        "relation": "performs",
        "roleId": "contract-manager",
        "targetId": "contract-compliance-finding",
        "targetKind": "entity"
      },
      {
        "id": "performs-contract-manager-entity-contract-entitlement",
        "relation": "performs",
        "roleId": "contract-manager",
        "targetId": "contract-entitlement",
        "targetKind": "entity"
      },
      {
        "id": "performs-contract-manager-entity-contract-intake",
        "relation": "performs",
        "roleId": "contract-manager",
        "targetId": "contract-intake",
        "targetKind": "entity"
      },
      {
        "id": "performs-contract-manager-entity-contract-obligation",
        "relation": "performs",
        "roleId": "contract-manager",
        "targetId": "contract-obligation",
        "targetKind": "entity"
      },
      {
        "id": "performs-contract-manager-entity-contract-template",
        "relation": "performs",
        "roleId": "contract-manager",
        "targetId": "contract-template",
        "targetKind": "entity"
      },
      {
        "id": "performs-contract-manager-entity-contract-version",
        "relation": "performs",
        "roleId": "contract-manager",
        "targetId": "contract-version",
        "targetKind": "entity"
      },
      {
        "id": "performs-contract-manager-job-contract-approval-repository-derive-approval-route",
        "relation": "performs",
        "roleId": "contract-manager",
        "targetId": "contract-approval-repository.derive-approval-route",
        "targetKind": "job"
      },
      {
        "id": "performs-contract-manager-job-contract-approval-repository-reconcile-repository",
        "relation": "performs",
        "roleId": "contract-manager",
        "targetId": "contract-approval-repository.reconcile-repository",
        "targetKind": "job"
      },
      {
        "id": "performs-contract-manager-job-contract-intake-digitization-capture-once",
        "relation": "performs",
        "roleId": "contract-manager",
        "targetId": "contract-intake-digitization.capture-once",
        "targetKind": "job"
      },
      {
        "id": "performs-contract-manager-job-contract-intake-digitization-publish-or-except",
        "relation": "performs",
        "roleId": "contract-manager",
        "targetId": "contract-intake-digitization.publish-or-except",
        "targetKind": "job"
      },
      {
        "id": "performs-contract-manager-job-contract-intake-digitization-resolve-agreement",
        "relation": "performs",
        "roleId": "contract-manager",
        "targetId": "contract-intake-digitization.resolve-agreement",
        "targetKind": "job"
      },
      {
        "id": "performs-contract-manager-job-obligation-monitoring-amendment-impact",
        "relation": "performs",
        "roleId": "contract-manager",
        "targetId": "obligation-monitoring.amendment-impact",
        "targetKind": "job"
      },
      {
        "id": "performs-contract-manager-job-obligation-monitoring-validate-extraction",
        "relation": "performs",
        "roleId": "contract-manager",
        "targetId": "obligation-monitoring.validate-extraction",
        "targetKind": "job"
      },
      {
        "id": "performs-contract-manager-job-renewal-change-compliance-decision-window",
        "relation": "performs",
        "roleId": "contract-manager",
        "targetId": "renewal-change-compliance.decision-window",
        "targetKind": "job"
      },
      {
        "id": "performs-contract-manager-job-renewal-change-compliance-execute-lifecycle-path",
        "relation": "performs",
        "roleId": "contract-manager",
        "targetId": "renewal-change-compliance.execute-lifecycle-path",
        "targetKind": "job"
      },
      {
        "id": "performs-controller-business-module-payment-readiness",
        "relation": "performs",
        "roleId": "controller",
        "targetId": "payment-readiness",
        "targetKind": "business-module"
      },
      {
        "id": "performs-controller-entity-payment-readiness-assessment",
        "relation": "performs",
        "roleId": "controller",
        "targetId": "payment-readiness-assessment",
        "targetKind": "entity"
      },
      {
        "id": "performs-controller-job-invoice-exception-triage-duplicate-candidate",
        "relation": "performs",
        "roleId": "controller",
        "targetId": "invoice-exception-triage.duplicate-candidate",
        "targetKind": "job"
      },
      {
        "id": "performs-controller-job-invoice-intake-match-publish-disposition",
        "relation": "performs",
        "roleId": "controller",
        "targetId": "invoice-intake-match.publish-disposition",
        "targetKind": "job"
      },
      {
        "id": "performs-controller-job-payment-execution-guard-reconcile-recovery",
        "relation": "performs",
        "roleId": "controller",
        "targetId": "payment-execution-guard.reconcile-recovery",
        "targetKind": "job"
      },
      {
        "id": "performs-controller-job-payment-readiness-payee-change",
        "relation": "performs",
        "roleId": "controller",
        "targetId": "payment-readiness.payee-change",
        "targetKind": "job"
      },
      {
        "id": "performs-controller-job-supplier-invoice-resolution-interpret-evidence",
        "relation": "performs",
        "roleId": "controller",
        "targetId": "supplier-invoice-resolution.interpret-evidence",
        "targetKind": "job"
      },
      {
        "id": "performs-controller-job-supplier-invoice-resolution-reconcile-resolution",
        "relation": "performs",
        "roleId": "controller",
        "targetId": "supplier-invoice-resolution.reconcile-resolution",
        "targetKind": "job"
      },
      {
        "id": "performs-data-steward-job-spend-data-foundation-ambiguous-record",
        "relation": "performs",
        "roleId": "data-steward",
        "targetId": "spend-data-foundation.ambiguous-record",
        "targetKind": "job"
      },
      {
        "id": "performs-data-steward-job-spend-data-foundation-publication-control",
        "relation": "performs",
        "roleId": "data-steward",
        "targetId": "spend-data-foundation.publication-control",
        "targetKind": "job"
      },
      {
        "id": "performs-demand-owner-business-module-demand-consolidation-portfolio",
        "relation": "performs",
        "roleId": "demand-owner",
        "targetId": "demand-consolidation-portfolio",
        "targetKind": "business-module"
      },
      {
        "id": "performs-demand-owner-business-module-demand-orchestration",
        "relation": "performs",
        "roleId": "demand-owner",
        "targetId": "demand-orchestration",
        "targetKind": "business-module"
      },
      {
        "id": "performs-demand-owner-entity-budget",
        "relation": "performs",
        "roleId": "demand-owner",
        "targetId": "budget",
        "targetKind": "entity"
      },
      {
        "id": "performs-demand-owner-entity-demand-case",
        "relation": "performs",
        "roleId": "demand-owner",
        "targetId": "demand-case",
        "targetKind": "entity"
      },
      {
        "id": "performs-demand-owner-entity-demand-portfolio",
        "relation": "performs",
        "roleId": "demand-owner",
        "targetId": "demand-portfolio",
        "targetKind": "entity"
      },
      {
        "id": "performs-demand-owner-job-demand-consolidation-portfolio-compatible-demand",
        "relation": "performs",
        "roleId": "demand-owner",
        "targetId": "demand-consolidation-portfolio.compatible-demand",
        "targetKind": "job"
      },
      {
        "id": "performs-demand-owner-job-demand-consolidation-portfolio-execution-launch",
        "relation": "performs",
        "roleId": "demand-owner",
        "targetId": "demand-consolidation-portfolio.execution-launch",
        "targetKind": "job"
      },
      {
        "id": "performs-demand-owner-job-demand-consolidation-portfolio-grouping-rationale",
        "relation": "performs",
        "roleId": "demand-owner",
        "targetId": "demand-consolidation-portfolio.grouping-rationale",
        "targetKind": "job"
      },
      {
        "id": "performs-demand-owner-job-demand-consolidation-portfolio-material-economics",
        "relation": "performs",
        "roleId": "demand-owner",
        "targetId": "demand-consolidation-portfolio.material-economics",
        "targetKind": "job"
      },
      {
        "id": "performs-demand-owner-job-demand-consolidation-portfolio-portfolio-scenarios",
        "relation": "performs",
        "roleId": "demand-owner",
        "targetId": "demand-consolidation-portfolio.portfolio-scenarios",
        "targetKind": "job"
      },
      {
        "id": "performs-demand-owner-job-demand-orchestration-one-plan",
        "relation": "performs",
        "roleId": "demand-owner",
        "targetId": "demand-orchestration.one-plan",
        "targetKind": "job"
      },
      {
        "id": "performs-demand-owner-job-demand-orchestration-partial-failure",
        "relation": "performs",
        "roleId": "demand-owner",
        "targetId": "demand-orchestration.partial-failure",
        "targetKind": "job"
      },
      {
        "id": "performs-demand-owner-job-demand-orchestration-scope-change",
        "relation": "performs",
        "roleId": "demand-owner",
        "targetId": "demand-orchestration.scope-change",
        "targetKind": "job"
      },
      {
        "id": "performs-demand-owner-job-demand-orchestration-scoped-handback",
        "relation": "performs",
        "roleId": "demand-owner",
        "targetId": "demand-orchestration.scoped-handback",
        "targetKind": "job"
      },
      {
        "id": "performs-demand-owner-job-request-enrichment-routing-related-demand",
        "relation": "performs",
        "roleId": "demand-owner",
        "targetId": "request-enrichment-routing.related-demand",
        "targetKind": "job"
      },
      {
        "id": "performs-evaluator-business-module-bid-evaluation-award",
        "relation": "performs",
        "roleId": "evaluator",
        "targetId": "bid-evaluation-award",
        "targetKind": "business-module"
      },
      {
        "id": "performs-evaluator-business-module-sourcing-event",
        "relation": "performs",
        "roleId": "evaluator",
        "targetId": "sourcing-event",
        "targetKind": "business-module"
      },
      {
        "id": "performs-evaluator-entity-award-scenario",
        "relation": "performs",
        "roleId": "evaluator",
        "targetId": "award-scenario",
        "targetKind": "entity"
      },
      {
        "id": "performs-evaluator-entity-sourcing-event-record",
        "relation": "performs",
        "roleId": "evaluator",
        "targetId": "sourcing-event-record",
        "targetKind": "entity"
      },
      {
        "id": "performs-evaluator-entity-supplier-response",
        "relation": "performs",
        "roleId": "evaluator",
        "targetId": "supplier-response",
        "targetKind": "entity"
      },
      {
        "id": "performs-evaluator-job-bid-evaluation-award-apply-criteria",
        "relation": "performs",
        "roleId": "evaluator",
        "targetId": "bid-evaluation-award.apply-criteria",
        "targetKind": "job"
      },
      {
        "id": "performs-evaluator-job-bid-evaluation-award-landed-cost",
        "relation": "performs",
        "roleId": "evaluator",
        "targetId": "bid-evaluation-award.landed-cost",
        "targetKind": "job"
      },
      {
        "id": "performs-evaluator-job-bid-evaluation-award-normalise-bids",
        "relation": "performs",
        "roleId": "evaluator",
        "targetId": "bid-evaluation-award.normalise-bids",
        "targetKind": "job"
      },
      {
        "id": "performs-evaluator-job-sourcing-event-score-with-evidence",
        "relation": "performs",
        "roleId": "evaluator",
        "targetId": "sourcing-event.score-with-evidence",
        "targetKind": "job"
      },
      {
        "id": "performs-evaluator-job-tactical-sourcing-autonomy-supplier-cohort",
        "relation": "performs",
        "roleId": "evaluator",
        "targetId": "tactical-sourcing-autonomy.supplier-cohort",
        "targetKind": "job"
      },
      {
        "id": "performs-finance-delegate-business-module-realization-reconciliation-attribution",
        "relation": "performs",
        "roleId": "finance-delegate",
        "targetId": "realization-reconciliation-attribution",
        "targetKind": "business-module"
      },
      {
        "id": "performs-finance-delegate-business-module-savings-initiative",
        "relation": "performs",
        "roleId": "finance-delegate",
        "targetId": "savings-initiative",
        "targetKind": "business-module"
      },
      {
        "id": "performs-finance-delegate-entity-savings-initiative-record",
        "relation": "performs",
        "roleId": "finance-delegate",
        "targetId": "savings-initiative-record",
        "targetKind": "entity"
      },
      {
        "id": "performs-finance-delegate-entity-value-realization-attribution",
        "relation": "performs",
        "roleId": "finance-delegate",
        "targetId": "value-realization-attribution",
        "targetKind": "entity"
      },
      {
        "id": "performs-finance-delegate-job-realization-reconciliation-attribution-attribute-value",
        "relation": "performs",
        "roleId": "finance-delegate",
        "targetId": "realization-reconciliation-attribution.attribute-value",
        "targetKind": "job"
      },
      {
        "id": "performs-finance-delegate-job-realization-reconciliation-attribution-commit-reconcile",
        "relation": "performs",
        "roleId": "finance-delegate",
        "targetId": "realization-reconciliation-attribution.commit-reconcile",
        "targetKind": "job"
      },
      {
        "id": "performs-finance-delegate-job-realization-reconciliation-attribution-normalise-effects",
        "relation": "performs",
        "roleId": "finance-delegate",
        "targetId": "realization-reconciliation-attribution.normalise-effects",
        "targetKind": "job"
      },
      {
        "id": "performs-finance-delegate-job-savings-initiative-agree-method",
        "relation": "performs",
        "roleId": "finance-delegate",
        "targetId": "savings-initiative.agree-method",
        "targetKind": "job"
      },
      {
        "id": "performs-finance-delegate-job-savings-initiative-validate-result",
        "relation": "performs",
        "roleId": "finance-delegate",
        "targetId": "savings-initiative.validate-result",
        "targetKind": "job"
      },
      {
        "id": "performs-finance-delegate-job-value-leakage-monitor-test-causes",
        "relation": "performs",
        "roleId": "finance-delegate",
        "targetId": "value-leakage-monitor.test-causes",
        "targetKind": "job"
      },
      {
        "id": "performs-finance-delegate-job-value-opportunity-baseline-calculate-baseline",
        "relation": "performs",
        "roleId": "finance-delegate",
        "targetId": "value-opportunity-baseline.calculate-baseline",
        "targetKind": "job"
      },
      {
        "id": "performs-finance-delegate-job-value-opportunity-baseline-commit-measurement",
        "relation": "performs",
        "roleId": "finance-delegate",
        "targetId": "value-opportunity-baseline.commit-measurement",
        "targetKind": "job"
      },
      {
        "id": "performs-finance-delegate-job-value-portfolio-forecast-movement-bridge",
        "relation": "performs",
        "roleId": "finance-delegate",
        "targetId": "value-portfolio-forecast.movement-bridge",
        "targetKind": "job"
      },
      {
        "id": "performs-governance-owner-business-module-supplier-segmentation-governance",
        "relation": "performs",
        "roleId": "governance-owner",
        "targetId": "supplier-segmentation-governance",
        "targetKind": "business-module"
      },
      {
        "id": "performs-governance-owner-entity-supplier-segment-assignment",
        "relation": "performs",
        "roleId": "governance-owner",
        "targetId": "supplier-segment-assignment",
        "targetKind": "entity"
      },
      {
        "id": "performs-governance-owner-job-supplier-performance-monitor-correct-corrective-action",
        "relation": "performs",
        "roleId": "governance-owner",
        "targetId": "supplier-performance-monitor-correct.corrective-action",
        "targetKind": "job"
      },
      {
        "id": "performs-governance-owner-job-supplier-relationship-joint-value-cross-functional-actions",
        "relation": "performs",
        "roleId": "governance-owner",
        "targetId": "supplier-relationship-joint-value.cross-functional-actions",
        "targetKind": "job"
      },
      {
        "id": "performs-governance-owner-job-supplier-segmentation-governance-material-assignment",
        "relation": "performs",
        "roleId": "governance-owner",
        "targetId": "supplier-segmentation-governance.material-assignment",
        "targetKind": "job"
      },
      {
        "id": "performs-governance-owner-job-supplier-segmentation-governance-routine-resegment",
        "relation": "performs",
        "roleId": "governance-owner",
        "targetId": "supplier-segmentation-governance.routine-resegment",
        "targetKind": "job"
      },
      {
        "id": "performs-innovation-sponsor-business-module-supplier-innovation-pipeline",
        "relation": "performs",
        "roleId": "innovation-sponsor",
        "targetId": "supplier-innovation-pipeline",
        "targetKind": "business-module"
      },
      {
        "id": "performs-innovation-sponsor-entity-supplier-innovation-case",
        "relation": "performs",
        "roleId": "innovation-sponsor",
        "targetId": "supplier-innovation-case",
        "targetKind": "entity"
      },
      {
        "id": "performs-innovation-sponsor-job-supplier-innovation-pipeline-attach-sponsor",
        "relation": "performs",
        "roleId": "innovation-sponsor",
        "targetId": "supplier-innovation-pipeline.attach-sponsor",
        "targetKind": "job"
      },
      {
        "id": "performs-innovation-sponsor-job-supplier-innovation-pipeline-bound-stage",
        "relation": "performs",
        "roleId": "innovation-sponsor",
        "targetId": "supplier-innovation-pipeline.bound-stage",
        "targetKind": "job"
      },
      {
        "id": "performs-innovation-sponsor-job-supplier-innovation-pipeline-separate-value",
        "relation": "performs",
        "roleId": "innovation-sponsor",
        "targetId": "supplier-innovation-pipeline.separate-value",
        "targetKind": "job"
      },
      {
        "id": "performs-innovation-sponsor-job-supplier-relationship-joint-value-adapt-next-plan",
        "relation": "performs",
        "roleId": "innovation-sponsor",
        "targetId": "supplier-relationship-joint-value.adapt-next-plan",
        "targetKind": "job"
      },
      {
        "id": "performs-intake-owner-business-module-intelligent-intake",
        "relation": "performs",
        "roleId": "intake-owner",
        "targetId": "intelligent-intake",
        "targetKind": "business-module"
      },
      {
        "id": "performs-intake-owner-business-module-request-enrichment-routing",
        "relation": "performs",
        "roleId": "intake-owner",
        "targetId": "request-enrichment-routing",
        "targetKind": "business-module"
      },
      {
        "id": "performs-intake-owner-entity-enriched-request",
        "relation": "performs",
        "roleId": "intake-owner",
        "targetId": "enriched-request",
        "targetKind": "entity"
      },
      {
        "id": "performs-intake-owner-entity-intake-request",
        "relation": "performs",
        "roleId": "intake-owner",
        "targetId": "intake-request",
        "targetKind": "entity"
      },
      {
        "id": "performs-intake-owner-job-intelligent-intake-assemble-case",
        "relation": "performs",
        "roleId": "intake-owner",
        "targetId": "intelligent-intake.assemble-case",
        "targetKind": "job"
      },
      {
        "id": "performs-intake-owner-job-intelligent-intake-solution-first",
        "relation": "performs",
        "roleId": "intake-owner",
        "targetId": "intelligent-intake.solution-first",
        "targetKind": "job"
      },
      {
        "id": "performs-intake-owner-job-procurement-service-catalogue-service-friction",
        "relation": "performs",
        "roleId": "intake-owner",
        "targetId": "procurement-service-catalogue.service-friction",
        "targetKind": "job"
      },
      {
        "id": "performs-intake-owner-job-request-enrichment-routing-normalise-request",
        "relation": "performs",
        "roleId": "intake-owner",
        "targetId": "request-enrichment-routing.normalise-request",
        "targetKind": "job"
      },
      {
        "id": "performs-intake-owner-job-request-enrichment-routing-reuse-enterprise-context",
        "relation": "performs",
        "roleId": "intake-owner",
        "targetId": "request-enrichment-routing.reuse-enterprise-context",
        "targetKind": "job"
      },
      {
        "id": "performs-intake-owner-job-request-enrichment-routing-true-exception",
        "relation": "performs",
        "roleId": "intake-owner",
        "targetId": "request-enrichment-routing.true-exception",
        "targetKind": "job"
      },
      {
        "id": "performs-integration-owner-business-module-purchase-order-exception",
        "relation": "performs",
        "roleId": "integration-owner",
        "targetId": "purchase-order-exception",
        "targetKind": "business-module"
      },
      {
        "id": "performs-integration-owner-entity-purchase-order-exception",
        "relation": "performs",
        "roleId": "integration-owner",
        "targetId": "purchase-order-exception",
        "targetKind": "entity"
      },
      {
        "id": "performs-integration-owner-job-purchase-order-exception-clean-handoff",
        "relation": "performs",
        "roleId": "integration-owner",
        "targetId": "purchase-order-exception.clean-handoff",
        "targetKind": "job"
      },
      {
        "id": "performs-integration-owner-job-purchase-order-exception-reconcile-before-retry",
        "relation": "performs",
        "roleId": "integration-owner",
        "targetId": "purchase-order-exception.reconcile-before-retry",
        "targetKind": "job"
      },
      {
        "id": "performs-integration-owner-job-purchase-order-orchestration-create-dispatch",
        "relation": "performs",
        "roleId": "integration-owner",
        "targetId": "purchase-order-orchestration.create-dispatch",
        "targetKind": "job"
      },
      {
        "id": "performs-integration-owner-job-purchase-order-orchestration-state-reconciliation",
        "relation": "performs",
        "roleId": "integration-owner",
        "targetId": "purchase-order-orchestration.state-reconciliation",
        "targetKind": "job"
      },
      {
        "id": "performs-legal-counsel-business-module-contract-authoring-review",
        "relation": "performs",
        "roleId": "legal-counsel",
        "targetId": "contract-authoring-review",
        "targetKind": "business-module"
      },
      {
        "id": "performs-legal-counsel-entity-clause-deviation",
        "relation": "performs",
        "roleId": "legal-counsel",
        "targetId": "clause-deviation",
        "targetKind": "entity"
      },
      {
        "id": "performs-legal-counsel-entity-clause-library-entry",
        "relation": "performs",
        "roleId": "legal-counsel",
        "targetId": "clause-library-entry",
        "targetKind": "entity"
      },
      {
        "id": "performs-legal-counsel-entity-contract-template",
        "relation": "performs",
        "roleId": "legal-counsel",
        "targetId": "contract-template",
        "targetKind": "entity"
      },
      {
        "id": "performs-legal-counsel-entity-contract-version",
        "relation": "performs",
        "roleId": "legal-counsel",
        "targetId": "contract-version",
        "targetKind": "entity"
      },
      {
        "id": "performs-legal-counsel-job-contract-approval-repository-protect-approved-content",
        "relation": "performs",
        "roleId": "legal-counsel",
        "targetId": "contract-approval-repository.protect-approved-content",
        "targetKind": "job"
      },
      {
        "id": "performs-legal-counsel-job-contract-authoring-review-third-party-paper",
        "relation": "performs",
        "roleId": "legal-counsel",
        "targetId": "contract-authoring-review.third-party-paper",
        "targetKind": "job"
      },
      {
        "id": "performs-legal-counsel-job-contract-intake-digitization-extract-with-citations",
        "relation": "performs",
        "roleId": "legal-counsel",
        "targetId": "contract-intake-digitization.extract-with-citations",
        "targetKind": "job"
      },
      {
        "id": "performs-legal-counsel-job-obligation-monitoring-notice-window",
        "relation": "performs",
        "roleId": "legal-counsel",
        "targetId": "obligation-monitoring.notice-window",
        "targetKind": "job"
      },
      {
        "id": "performs-metric-owner-business-module-supplier-performance-monitor-correct",
        "relation": "performs",
        "roleId": "metric-owner",
        "targetId": "supplier-performance-monitor-correct",
        "targetKind": "business-module"
      },
      {
        "id": "performs-metric-owner-entity-supplier-performance-observation",
        "relation": "performs",
        "roleId": "metric-owner",
        "targetId": "supplier-performance-observation",
        "targetKind": "entity"
      },
      {
        "id": "performs-metric-owner-job-supplier-performance-monitor-correct-atomic-observations",
        "relation": "performs",
        "roleId": "metric-owner",
        "targetId": "supplier-performance-monitor-correct.atomic-observations",
        "targetKind": "job"
      },
      {
        "id": "performs-metric-owner-job-supplier-performance-monitor-correct-quality-or-performance",
        "relation": "performs",
        "roleId": "metric-owner",
        "targetId": "supplier-performance-monitor-correct.quality-or-performance",
        "targetKind": "job"
      },
      {
        "id": "performs-metric-owner-job-supplier-performance-review-reproduce-score",
        "relation": "performs",
        "roleId": "metric-owner",
        "targetId": "supplier-performance-review.reproduce-score",
        "targetKind": "job"
      },
      {
        "id": "performs-metric-owner-job-supplier-relationship-joint-value-connected-plan",
        "relation": "performs",
        "roleId": "metric-owner",
        "targetId": "supplier-relationship-joint-value.connected-plan",
        "targetKind": "job"
      },
      {
        "id": "performs-metric-owner-job-supplier-segmentation-governance-change-signal",
        "relation": "performs",
        "roleId": "metric-owner",
        "targetId": "supplier-segmentation-governance.change-signal",
        "targetKind": "job"
      },
      {
        "id": "performs-negotiation-lead-business-module-negotiation-copilot",
        "relation": "performs",
        "roleId": "negotiation-lead",
        "targetId": "negotiation-copilot",
        "targetKind": "business-module"
      },
      {
        "id": "performs-negotiation-lead-entity-negotiation-session",
        "relation": "performs",
        "roleId": "negotiation-lead",
        "targetId": "negotiation-session",
        "targetKind": "entity"
      },
      {
        "id": "performs-negotiation-lead-job-negotiation-copilot-bounded-authority",
        "relation": "performs",
        "roleId": "negotiation-lead",
        "targetId": "negotiation-copilot.bounded-authority",
        "targetKind": "job"
      },
      {
        "id": "performs-negotiation-lead-job-negotiation-copilot-capture-round",
        "relation": "performs",
        "roleId": "negotiation-lead",
        "targetId": "negotiation-copilot.capture-round",
        "targetKind": "job"
      },
      {
        "id": "performs-negotiation-lead-job-negotiation-copilot-fact-base",
        "relation": "performs",
        "roleId": "negotiation-lead",
        "targetId": "negotiation-copilot.fact-base",
        "targetKind": "job"
      },
      {
        "id": "performs-negotiation-lead-job-negotiation-copilot-hand-off-points",
        "relation": "performs",
        "roleId": "negotiation-lead",
        "targetId": "negotiation-copilot.hand-off-points",
        "targetKind": "job"
      },
      {
        "id": "performs-negotiation-lead-job-negotiation-copilot-set-mandate",
        "relation": "performs",
        "roleId": "negotiation-lead",
        "targetId": "negotiation-copilot.set-mandate",
        "targetKind": "job"
      },
      {
        "id": "performs-negotiation-lead-job-tactical-sourcing-autonomy-bounded-exchange",
        "relation": "performs",
        "roleId": "negotiation-lead",
        "targetId": "tactical-sourcing-autonomy.bounded-exchange",
        "targetKind": "job"
      },
      {
        "id": "performs-obligation-owner-business-module-obligation-monitoring",
        "relation": "performs",
        "roleId": "obligation-owner",
        "targetId": "obligation-monitoring",
        "targetKind": "business-module"
      },
      {
        "id": "performs-obligation-owner-entity-contract-entitlement",
        "relation": "performs",
        "roleId": "obligation-owner",
        "targetId": "contract-entitlement",
        "targetKind": "entity"
      },
      {
        "id": "performs-obligation-owner-entity-contract-obligation",
        "relation": "performs",
        "roleId": "obligation-owner",
        "targetId": "contract-obligation",
        "targetKind": "entity"
      },
      {
        "id": "performs-obligation-owner-job-obligation-monitoring-accept-ownership",
        "relation": "performs",
        "roleId": "obligation-owner",
        "targetId": "obligation-monitoring.accept-ownership",
        "targetKind": "job"
      },
      {
        "id": "performs-obligation-owner-job-obligation-monitoring-evidence-closure",
        "relation": "performs",
        "roleId": "obligation-owner",
        "targetId": "obligation-monitoring.evidence-closure",
        "targetKind": "job"
      },
      {
        "id": "performs-obligation-owner-job-renewal-change-compliance-detect-variance",
        "relation": "performs",
        "roleId": "obligation-owner",
        "targetId": "renewal-change-compliance.detect-variance",
        "targetKind": "job"
      },
      {
        "id": "performs-onboarding-coordinator-business-module-supplier-onboarding",
        "relation": "performs",
        "roleId": "onboarding-coordinator",
        "targetId": "supplier-onboarding",
        "targetKind": "business-module"
      },
      {
        "id": "performs-onboarding-coordinator-entity-supplier-onboarding-case",
        "relation": "performs",
        "roleId": "onboarding-coordinator",
        "targetId": "supplier-onboarding-case",
        "targetKind": "entity"
      },
      {
        "id": "performs-onboarding-coordinator-entity-supplier-profile",
        "relation": "performs",
        "roleId": "onboarding-coordinator",
        "targetId": "supplier-profile",
        "targetKind": "entity"
      },
      {
        "id": "performs-onboarding-coordinator-job-supplier-master-qualification-publish-eligibility",
        "relation": "performs",
        "roleId": "onboarding-coordinator",
        "targetId": "supplier-master-qualification.publish-eligibility",
        "targetKind": "job"
      },
      {
        "id": "performs-onboarding-coordinator-job-supplier-onboarding-failed-activation",
        "relation": "performs",
        "roleId": "onboarding-coordinator",
        "targetId": "supplier-onboarding.failed-activation",
        "targetKind": "job"
      },
      {
        "id": "performs-onboarding-coordinator-job-supplier-onboarding-new-supplier",
        "relation": "performs",
        "roleId": "onboarding-coordinator",
        "targetId": "supplier-onboarding.new-supplier",
        "targetKind": "job"
      },
      {
        "id": "performs-payment-approver-business-module-payment-execution-guard",
        "relation": "performs",
        "roleId": "payment-approver",
        "targetId": "payment-execution-guard",
        "targetKind": "business-module"
      },
      {
        "id": "performs-payment-approver-business-module-payment-readiness",
        "relation": "performs",
        "roleId": "payment-approver",
        "targetId": "payment-readiness",
        "targetKind": "business-module"
      },
      {
        "id": "performs-payment-approver-entity-payment-execution-status",
        "relation": "performs",
        "roleId": "payment-approver",
        "targetId": "payment-execution-status",
        "targetKind": "entity"
      },
      {
        "id": "performs-payment-approver-entity-payment-instruction",
        "relation": "performs",
        "roleId": "payment-approver",
        "targetId": "payment-instruction",
        "targetKind": "entity"
      },
      {
        "id": "performs-payment-approver-entity-payment-readiness-assessment",
        "relation": "performs",
        "roleId": "payment-approver",
        "targetId": "payment-readiness-assessment",
        "targetKind": "entity"
      },
      {
        "id": "performs-payment-approver-job-payment-execution-guard-final-validation",
        "relation": "performs",
        "roleId": "payment-approver",
        "targetId": "payment-execution-guard.final-validation",
        "targetKind": "job"
      },
      {
        "id": "performs-payment-approver-job-payment-readiness-batch-review",
        "relation": "performs",
        "roleId": "payment-approver",
        "targetId": "payment-readiness.batch-review",
        "targetKind": "job"
      },
      {
        "id": "performs-payment-approver-job-payment-readiness-decision-handoff",
        "relation": "performs",
        "roleId": "payment-approver",
        "targetId": "payment-readiness.decision-handoff",
        "targetKind": "job"
      },
      {
        "id": "performs-policy-owner-business-module-policy-guidance",
        "relation": "performs",
        "roleId": "policy-owner",
        "targetId": "policy-guidance",
        "targetKind": "business-module"
      },
      {
        "id": "performs-policy-owner-business-module-policy-rule-lifecycle",
        "relation": "performs",
        "roleId": "policy-owner",
        "targetId": "policy-rule-lifecycle",
        "targetKind": "business-module"
      },
      {
        "id": "performs-policy-owner-entity-policy-guidance-result",
        "relation": "performs",
        "roleId": "policy-owner",
        "targetId": "policy-guidance-result",
        "targetKind": "entity"
      },
      {
        "id": "performs-policy-owner-entity-policy-rule-release",
        "relation": "performs",
        "roleId": "policy-owner",
        "targetId": "policy-rule-release",
        "targetKind": "entity"
      },
      {
        "id": "performs-policy-owner-entity-tail-spend-rule",
        "relation": "performs",
        "roleId": "policy-owner",
        "targetId": "tail-spend-rule",
        "targetKind": "entity"
      },
      {
        "id": "performs-policy-owner-job-policy-guidance-conflicting-sources",
        "relation": "performs",
        "roleId": "policy-owner",
        "targetId": "policy-guidance.conflicting-sources",
        "targetKind": "job"
      },
      {
        "id": "performs-policy-owner-job-policy-guidance-decision-point",
        "relation": "performs",
        "roleId": "policy-owner",
        "targetId": "policy-guidance.decision-point",
        "targetKind": "job"
      },
      {
        "id": "performs-policy-owner-job-policy-guidance-exception-route",
        "relation": "performs",
        "roleId": "policy-owner",
        "targetId": "policy-guidance.exception-route",
        "targetKind": "job"
      },
      {
        "id": "performs-policy-owner-job-policy-guidance-missing-fact",
        "relation": "performs",
        "roleId": "policy-owner",
        "targetId": "policy-guidance.missing-fact",
        "targetKind": "job"
      },
      {
        "id": "performs-policy-owner-job-policy-guidance-policy-change",
        "relation": "performs",
        "roleId": "policy-owner",
        "targetId": "policy-guidance.policy-change",
        "targetKind": "job"
      },
      {
        "id": "performs-policy-owner-job-policy-guidance-which-route",
        "relation": "performs",
        "roleId": "policy-owner",
        "targetId": "policy-guidance.which-route",
        "targetKind": "job"
      },
      {
        "id": "performs-policy-owner-job-policy-rule-lifecycle-boundary-testing",
        "relation": "performs",
        "roleId": "policy-owner",
        "targetId": "policy-rule-lifecycle.boundary-testing",
        "targetKind": "job"
      },
      {
        "id": "performs-policy-owner-job-policy-rule-lifecycle-change-impact",
        "relation": "performs",
        "roleId": "policy-owner",
        "targetId": "policy-rule-lifecycle.change-impact",
        "targetKind": "job"
      },
      {
        "id": "performs-policy-owner-job-policy-rule-lifecycle-controlled-release",
        "relation": "performs",
        "roleId": "policy-owner",
        "targetId": "policy-rule-lifecycle.controlled-release",
        "targetKind": "job"
      },
      {
        "id": "performs-policy-owner-job-policy-rule-lifecycle-rule-authoring",
        "relation": "performs",
        "roleId": "policy-owner",
        "targetId": "policy-rule-lifecycle.rule-authoring",
        "targetKind": "job"
      },
      {
        "id": "performs-policy-owner-job-policy-rule-lifecycle-source-trace",
        "relation": "performs",
        "roleId": "policy-owner",
        "targetId": "policy-rule-lifecycle.source-trace",
        "targetKind": "job"
      },
      {
        "id": "performs-process-owner-business-module-procurement-service-catalogue",
        "relation": "performs",
        "roleId": "process-owner",
        "targetId": "procurement-service-catalogue",
        "targetKind": "business-module"
      },
      {
        "id": "performs-process-owner-entity-procurement-service-offering",
        "relation": "performs",
        "roleId": "process-owner",
        "targetId": "procurement-service-offering",
        "targetKind": "entity"
      },
      {
        "id": "performs-process-owner-job-demand-consolidation-portfolio-business-consent",
        "relation": "performs",
        "roleId": "process-owner",
        "targetId": "demand-consolidation-portfolio.business-consent",
        "targetKind": "job"
      },
      {
        "id": "performs-process-owner-job-demand-orchestration-stalled-demand",
        "relation": "performs",
        "roleId": "process-owner",
        "targetId": "demand-orchestration.stalled-demand",
        "targetKind": "job"
      },
      {
        "id": "performs-process-owner-job-intelligent-intake-fix-the-rule",
        "relation": "performs",
        "roleId": "process-owner",
        "targetId": "intelligent-intake.fix-the-rule",
        "targetKind": "job"
      },
      {
        "id": "performs-process-owner-job-intelligent-intake-scoped-decision",
        "relation": "performs",
        "roleId": "process-owner",
        "targetId": "intelligent-intake.scoped-decision",
        "targetKind": "job"
      },
      {
        "id": "performs-process-owner-job-procurement-service-catalogue-publish-contract",
        "relation": "performs",
        "roleId": "process-owner",
        "targetId": "procurement-service-catalogue.publish-contract",
        "targetKind": "job"
      },
      {
        "id": "performs-process-owner-job-procurement-service-catalogue-retire-service",
        "relation": "performs",
        "roleId": "process-owner",
        "targetId": "procurement-service-catalogue.retire-service",
        "targetKind": "job"
      },
      {
        "id": "performs-procurement-analyst-business-module-category-opportunity-radar",
        "relation": "performs",
        "roleId": "procurement-analyst",
        "targetId": "category-opportunity-radar",
        "targetKind": "business-module"
      },
      {
        "id": "performs-procurement-analyst-business-module-spend-data-foundation",
        "relation": "performs",
        "roleId": "procurement-analyst",
        "targetId": "spend-data-foundation",
        "targetKind": "business-module"
      },
      {
        "id": "performs-procurement-analyst-entity-category-opportunity",
        "relation": "performs",
        "roleId": "procurement-analyst",
        "targetId": "category-opportunity",
        "targetKind": "entity"
      },
      {
        "id": "performs-procurement-analyst-entity-spend-classification-decision",
        "relation": "performs",
        "roleId": "procurement-analyst",
        "targetId": "spend-classification-decision",
        "targetKind": "entity"
      },
      {
        "id": "performs-procurement-analyst-entity-spend-record",
        "relation": "performs",
        "roleId": "procurement-analyst",
        "targetId": "spend-record",
        "targetKind": "entity"
      },
      {
        "id": "performs-procurement-analyst-entity-tail-spend-evaluation",
        "relation": "performs",
        "roleId": "procurement-analyst",
        "targetId": "tail-spend-evaluation",
        "targetKind": "entity"
      },
      {
        "id": "performs-procurement-analyst-job-category-opportunity-radar-duplicate-signals",
        "relation": "performs",
        "roleId": "procurement-analyst",
        "targetId": "category-opportunity-radar.duplicate-signals",
        "targetKind": "job"
      },
      {
        "id": "performs-procurement-analyst-job-category-opportunity-radar-source-change",
        "relation": "performs",
        "roleId": "procurement-analyst",
        "targetId": "category-opportunity-radar.source-change",
        "targetKind": "job"
      },
      {
        "id": "performs-procurement-analyst-job-category-strategy-orchestrator-initiative-handoff",
        "relation": "performs",
        "roleId": "procurement-analyst",
        "targetId": "category-strategy-orchestrator.initiative-handoff",
        "targetKind": "job"
      },
      {
        "id": "performs-procurement-analyst-job-spend-data-foundation-addressable-view",
        "relation": "performs",
        "roleId": "procurement-analyst",
        "targetId": "spend-data-foundation.addressable-view",
        "targetKind": "job"
      },
      {
        "id": "performs-procurement-analyst-job-spend-data-foundation-stale-consumer",
        "relation": "performs",
        "roleId": "procurement-analyst",
        "targetId": "spend-data-foundation.stale-consumer",
        "targetKind": "job"
      },
      {
        "id": "performs-procurement-buyer-business-module-guided-buying",
        "relation": "performs",
        "roleId": "procurement-buyer",
        "targetId": "guided-buying",
        "targetKind": "business-module"
      },
      {
        "id": "performs-procurement-buyer-business-module-purchase-order-exception",
        "relation": "performs",
        "roleId": "procurement-buyer",
        "targetId": "purchase-order-exception",
        "targetKind": "business-module"
      },
      {
        "id": "performs-procurement-buyer-business-module-purchase-order-orchestration",
        "relation": "performs",
        "roleId": "procurement-buyer",
        "targetId": "purchase-order-orchestration",
        "targetKind": "business-module"
      },
      {
        "id": "performs-procurement-buyer-business-module-requisition-policy-routing",
        "relation": "performs",
        "roleId": "procurement-buyer",
        "targetId": "requisition-policy-routing",
        "targetKind": "business-module"
      },
      {
        "id": "performs-procurement-buyer-entity-buying-request",
        "relation": "performs",
        "roleId": "procurement-buyer",
        "targetId": "buying-request",
        "targetKind": "entity"
      },
      {
        "id": "performs-procurement-buyer-entity-order-line",
        "relation": "performs",
        "roleId": "procurement-buyer",
        "targetId": "order-line",
        "targetKind": "entity"
      },
      {
        "id": "performs-procurement-buyer-entity-order-response",
        "relation": "performs",
        "roleId": "procurement-buyer",
        "targetId": "order-response",
        "targetKind": "entity"
      },
      {
        "id": "performs-procurement-buyer-entity-purchase-order",
        "relation": "performs",
        "roleId": "procurement-buyer",
        "targetId": "purchase-order",
        "targetKind": "entity"
      },
      {
        "id": "performs-procurement-buyer-entity-purchase-order-exception",
        "relation": "performs",
        "roleId": "procurement-buyer",
        "targetId": "purchase-order-exception",
        "targetKind": "entity"
      },
      {
        "id": "performs-procurement-buyer-entity-requisition",
        "relation": "performs",
        "roleId": "procurement-buyer",
        "targetId": "requisition",
        "targetKind": "entity"
      },
      {
        "id": "performs-procurement-buyer-entity-requisition-line",
        "relation": "performs",
        "roleId": "procurement-buyer",
        "targetId": "requisition-line",
        "targetKind": "entity"
      },
      {
        "id": "performs-procurement-buyer-job-guided-buying-fix-the-source",
        "relation": "performs",
        "roleId": "procurement-buyer",
        "targetId": "guided-buying.fix-the-source",
        "targetKind": "job"
      },
      {
        "id": "performs-procurement-buyer-job-guided-buying-one-write",
        "relation": "performs",
        "roleId": "procurement-buyer",
        "targetId": "guided-buying.one-write",
        "targetKind": "job"
      },
      {
        "id": "performs-procurement-buyer-job-guided-buying-resolve-off-path",
        "relation": "performs",
        "roleId": "procurement-buyer",
        "targetId": "guided-buying.resolve-off-path",
        "targetKind": "job"
      },
      {
        "id": "performs-procurement-buyer-job-purchase-order-exception-choose-correction",
        "relation": "performs",
        "roleId": "procurement-buyer",
        "targetId": "purchase-order-exception.choose-correction",
        "targetKind": "job"
      },
      {
        "id": "performs-procurement-buyer-job-purchase-order-orchestration-precommit-check",
        "relation": "performs",
        "roleId": "procurement-buyer",
        "targetId": "purchase-order-orchestration.precommit-check",
        "targetKind": "job"
      },
      {
        "id": "performs-procurement-buyer-job-purchase-order-orchestration-supplier-response",
        "relation": "performs",
        "roleId": "procurement-buyer",
        "targetId": "purchase-order-orchestration.supplier-response",
        "targetKind": "job"
      },
      {
        "id": "performs-procurement-buyer-job-requisition-policy-routing-commitment-input",
        "relation": "performs",
        "roleId": "procurement-buyer",
        "targetId": "requisition-policy-routing.commitment-input",
        "targetKind": "job"
      },
      {
        "id": "performs-procurement-buyer-job-requisition-policy-routing-validate-lines",
        "relation": "performs",
        "roleId": "procurement-buyer",
        "targetId": "requisition-policy-routing.validate-lines",
        "targetKind": "job"
      },
      {
        "id": "performs-receiver-business-module-purchase-order-exception",
        "relation": "performs",
        "roleId": "receiver",
        "targetId": "purchase-order-exception",
        "targetKind": "business-module"
      },
      {
        "id": "performs-receiver-business-module-receiving-service-entry",
        "relation": "performs",
        "roleId": "receiver",
        "targetId": "receiving-service-entry",
        "targetKind": "business-module"
      },
      {
        "id": "performs-receiver-entity-purchase-order-exception",
        "relation": "performs",
        "roleId": "receiver",
        "targetId": "purchase-order-exception",
        "targetKind": "entity"
      },
      {
        "id": "performs-receiver-entity-receipt",
        "relation": "performs",
        "roleId": "receiver",
        "targetId": "receipt",
        "targetKind": "entity"
      },
      {
        "id": "performs-receiver-entity-receipt-line",
        "relation": "performs",
        "roleId": "receiver",
        "targetId": "receipt-line",
        "targetKind": "entity"
      },
      {
        "id": "performs-receiver-entity-return-claim",
        "relation": "performs",
        "roleId": "receiver",
        "targetId": "return-claim",
        "targetKind": "entity"
      },
      {
        "id": "performs-receiver-entity-service-entry-sheet",
        "relation": "performs",
        "roleId": "receiver",
        "targetId": "service-entry-sheet",
        "targetKind": "entity"
      },
      {
        "id": "performs-receiver-entity-shipment",
        "relation": "performs",
        "roleId": "receiver",
        "targetId": "shipment",
        "targetKind": "entity"
      },
      {
        "id": "performs-receiver-job-purchase-order-exception-record-what-arrived",
        "relation": "performs",
        "roleId": "receiver",
        "targetId": "purchase-order-exception.record-what-arrived",
        "targetKind": "job"
      },
      {
        "id": "performs-receiver-job-receiving-service-entry-correlate-delivery",
        "relation": "performs",
        "roleId": "receiver",
        "targetId": "receiving-service-entry.correlate-delivery",
        "targetKind": "job"
      },
      {
        "id": "performs-receiver-job-receiving-service-entry-post-and-recover",
        "relation": "performs",
        "roleId": "receiver",
        "targetId": "receiving-service-entry.post-and-recover",
        "targetKind": "job"
      },
      {
        "id": "performs-receiver-job-receiving-service-entry-quantity-condition",
        "relation": "performs",
        "roleId": "receiver",
        "targetId": "receiving-service-entry.quantity-condition",
        "targetKind": "job"
      },
      {
        "id": "performs-relationship-manager-business-module-supplier-performance-review",
        "relation": "performs",
        "roleId": "relationship-manager",
        "targetId": "supplier-performance-review",
        "targetKind": "business-module"
      },
      {
        "id": "performs-relationship-manager-business-module-supplier-relationship-joint-value",
        "relation": "performs",
        "roleId": "relationship-manager",
        "targetId": "supplier-relationship-joint-value",
        "targetKind": "business-module"
      },
      {
        "id": "performs-relationship-manager-entity-supplier-joint-value-plan",
        "relation": "performs",
        "roleId": "relationship-manager",
        "targetId": "supplier-joint-value-plan",
        "targetKind": "entity"
      },
      {
        "id": "performs-relationship-manager-entity-supplier-performance-review-record",
        "relation": "performs",
        "roleId": "relationship-manager",
        "targetId": "supplier-performance-review-record",
        "targetKind": "entity"
      },
      {
        "id": "performs-relationship-manager-job-supplier-innovation-pipeline-capture-idea",
        "relation": "performs",
        "roleId": "relationship-manager",
        "targetId": "supplier-innovation-pipeline.capture-idea",
        "targetKind": "job"
      },
      {
        "id": "performs-relationship-manager-job-supplier-performance-monitor-correct-detect-change",
        "relation": "performs",
        "roleId": "relationship-manager",
        "targetId": "supplier-performance-monitor-correct.detect-change",
        "targetKind": "job"
      },
      {
        "id": "performs-relationship-manager-job-supplier-performance-monitor-correct-sustained-recovery",
        "relation": "performs",
        "roleId": "relationship-manager",
        "targetId": "supplier-performance-monitor-correct.sustained-recovery",
        "targetKind": "job"
      },
      {
        "id": "performs-relationship-manager-job-supplier-performance-review-carry-handoff",
        "relation": "performs",
        "roleId": "relationship-manager",
        "targetId": "supplier-performance-review.carry-handoff",
        "targetKind": "job"
      },
      {
        "id": "performs-relationship-manager-job-supplier-performance-review-critical-event",
        "relation": "performs",
        "roleId": "relationship-manager",
        "targetId": "supplier-performance-review.critical-event",
        "targetKind": "job"
      },
      {
        "id": "performs-relationship-manager-job-supplier-performance-review-prepare-pack",
        "relation": "performs",
        "roleId": "relationship-manager",
        "targetId": "supplier-performance-review.prepare-pack",
        "targetKind": "job"
      },
      {
        "id": "performs-relationship-manager-job-supplier-performance-review-verify-closure",
        "relation": "performs",
        "roleId": "relationship-manager",
        "targetId": "supplier-performance-review.verify-closure",
        "targetKind": "job"
      },
      {
        "id": "performs-relationship-manager-job-supplier-relationship-joint-value-mutual-objectives",
        "relation": "performs",
        "roleId": "relationship-manager",
        "targetId": "supplier-relationship-joint-value.mutual-objectives",
        "targetKind": "job"
      },
      {
        "id": "performs-relationship-manager-job-supplier-segmentation-governance-current-segment",
        "relation": "performs",
        "roleId": "relationship-manager",
        "targetId": "supplier-segmentation-governance.current-segment",
        "targetKind": "job"
      },
      {
        "id": "performs-relationship-manager-job-supplier-segmentation-governance-propagate-treatment",
        "relation": "performs",
        "roleId": "relationship-manager",
        "targetId": "supplier-segmentation-governance.propagate-treatment",
        "targetKind": "job"
      },
      {
        "id": "performs-requester-business-module-guided-buying",
        "relation": "performs",
        "roleId": "requester",
        "targetId": "guided-buying",
        "targetKind": "business-module"
      },
      {
        "id": "performs-requester-business-module-intelligent-intake",
        "relation": "performs",
        "roleId": "requester",
        "targetId": "intelligent-intake",
        "targetKind": "business-module"
      },
      {
        "id": "performs-requester-entity-buying-request",
        "relation": "performs",
        "roleId": "requester",
        "targetId": "buying-request",
        "targetKind": "entity"
      },
      {
        "id": "performs-requester-entity-intake-request",
        "relation": "performs",
        "roleId": "requester",
        "targetId": "intake-request",
        "targetKind": "entity"
      },
      {
        "id": "performs-requester-job-demand-orchestration-truthful-status",
        "relation": "performs",
        "roleId": "requester",
        "targetId": "demand-orchestration.truthful-status",
        "targetKind": "job"
      },
      {
        "id": "performs-requester-job-guided-buying-route-need",
        "relation": "performs",
        "roleId": "requester",
        "targetId": "guided-buying.route-need",
        "targetKind": "job"
      },
      {
        "id": "performs-requester-job-intelligent-intake-explain-once",
        "relation": "performs",
        "roleId": "requester",
        "targetId": "intelligent-intake.explain-once",
        "targetKind": "job"
      },
      {
        "id": "performs-requester-job-procurement-service-catalogue-find-service",
        "relation": "performs",
        "roleId": "requester",
        "targetId": "procurement-service-catalogue.find-service",
        "targetKind": "job"
      },
      {
        "id": "performs-requester-job-procurement-service-catalogue-start-ready",
        "relation": "performs",
        "roleId": "requester",
        "targetId": "procurement-service-catalogue.start-ready",
        "targetKind": "job"
      },
      {
        "id": "performs-requester-job-purchase-order-exception-business-consequence",
        "relation": "performs",
        "roleId": "requester",
        "targetId": "purchase-order-exception.business-consequence",
        "targetKind": "job"
      },
      {
        "id": "performs-requester-job-receiving-service-entry-service-acceptance",
        "relation": "performs",
        "roleId": "requester",
        "targetId": "receiving-service-entry.service-acceptance",
        "targetKind": "job"
      },
      {
        "id": "performs-requester-job-request-enrichment-routing-explain-route",
        "relation": "performs",
        "roleId": "requester",
        "targetId": "request-enrichment-routing.explain-route",
        "targetKind": "job"
      },
      {
        "id": "performs-requester-job-requisition-policy-routing-material-question",
        "relation": "performs",
        "roleId": "requester",
        "targetId": "requisition-policy-routing.material-question",
        "targetKind": "job"
      },
      {
        "id": "performs-risk-owner-job-invoice-intake-match-duplicate-conflict",
        "relation": "performs",
        "roleId": "risk-owner",
        "targetId": "invoice-intake-match.duplicate-conflict",
        "targetKind": "job"
      },
      {
        "id": "performs-risk-owner-job-payment-execution-guard-duplicate-prevention",
        "relation": "performs",
        "roleId": "risk-owner",
        "targetId": "payment-execution-guard.duplicate-prevention",
        "targetKind": "job"
      },
      {
        "id": "performs-risk-owner-job-payment-readiness-stale-screening",
        "relation": "performs",
        "roleId": "risk-owner",
        "targetId": "payment-readiness.stale-screening",
        "targetKind": "job"
      },
      {
        "id": "performs-sourcing-lead-business-module-sourcing-event",
        "relation": "performs",
        "roleId": "sourcing-lead",
        "targetId": "sourcing-event",
        "targetKind": "business-module"
      },
      {
        "id": "performs-sourcing-lead-business-module-sourcing-pipeline-discovery",
        "relation": "performs",
        "roleId": "sourcing-lead",
        "targetId": "sourcing-pipeline-discovery",
        "targetKind": "business-module"
      },
      {
        "id": "performs-sourcing-lead-business-module-tactical-sourcing-autonomy",
        "relation": "performs",
        "roleId": "sourcing-lead",
        "targetId": "tactical-sourcing-autonomy",
        "targetKind": "business-module"
      },
      {
        "id": "performs-sourcing-lead-entity-sourcing-event-record",
        "relation": "performs",
        "roleId": "sourcing-lead",
        "targetId": "sourcing-event-record",
        "targetKind": "entity"
      },
      {
        "id": "performs-sourcing-lead-entity-sourcing-opportunity",
        "relation": "performs",
        "roleId": "sourcing-lead",
        "targetId": "sourcing-opportunity",
        "targetKind": "entity"
      },
      {
        "id": "performs-sourcing-lead-entity-supplier-response",
        "relation": "performs",
        "roleId": "sourcing-lead",
        "targetId": "supplier-response",
        "targetKind": "entity"
      },
      {
        "id": "performs-sourcing-lead-entity-tactical-sourcing-case",
        "relation": "performs",
        "roleId": "sourcing-lead",
        "targetId": "tactical-sourcing-case",
        "targetKind": "entity"
      },
      {
        "id": "performs-sourcing-lead-job-bid-evaluation-award-award-scenarios",
        "relation": "performs",
        "roleId": "sourcing-lead",
        "targetId": "bid-evaluation-award.award-scenarios",
        "targetKind": "job"
      },
      {
        "id": "performs-sourcing-lead-job-negotiation-copilot-compare-packages",
        "relation": "performs",
        "roleId": "sourcing-lead",
        "targetId": "negotiation-copilot.compare-packages",
        "targetKind": "job"
      },
      {
        "id": "performs-sourcing-lead-job-sourcing-event-amendment-impact",
        "relation": "performs",
        "roleId": "sourcing-lead",
        "targetId": "sourcing-event.amendment-impact",
        "targetKind": "job"
      },
      {
        "id": "performs-sourcing-lead-job-sourcing-event-compare-scenarios",
        "relation": "performs",
        "roleId": "sourcing-lead",
        "targetId": "sourcing-event.compare-scenarios",
        "targetKind": "job"
      },
      {
        "id": "performs-sourcing-lead-job-sourcing-event-one-basis",
        "relation": "performs",
        "roleId": "sourcing-lead",
        "targetId": "sourcing-event.one-basis",
        "targetKind": "job"
      },
      {
        "id": "performs-sourcing-lead-job-sourcing-event-shape-event",
        "relation": "performs",
        "roleId": "sourcing-lead",
        "targetId": "sourcing-event.shape-event",
        "targetKind": "job"
      },
      {
        "id": "performs-sourcing-lead-job-sourcing-pipeline-discovery-accepted-handoff",
        "relation": "performs",
        "roleId": "sourcing-lead",
        "targetId": "sourcing-pipeline-discovery.accepted-handoff",
        "targetKind": "job"
      },
      {
        "id": "performs-sourcing-lead-job-sourcing-pipeline-discovery-buy-timing",
        "relation": "performs",
        "roleId": "sourcing-lead",
        "targetId": "sourcing-pipeline-discovery.buy-timing",
        "targetKind": "job"
      },
      {
        "id": "performs-sourcing-lead-job-sourcing-pipeline-discovery-capacity-priority",
        "relation": "performs",
        "roleId": "sourcing-lead",
        "targetId": "sourcing-pipeline-discovery.capacity-priority",
        "targetKind": "job"
      },
      {
        "id": "performs-sourcing-lead-job-sourcing-pipeline-discovery-discover-intervention",
        "relation": "performs",
        "roleId": "sourcing-lead",
        "targetId": "sourcing-pipeline-discovery.discover-intervention",
        "targetKind": "job"
      },
      {
        "id": "performs-sourcing-lead-job-sourcing-pipeline-discovery-market-readiness",
        "relation": "performs",
        "roleId": "sourcing-lead",
        "targetId": "sourcing-pipeline-discovery.market-readiness",
        "targetKind": "job"
      },
      {
        "id": "performs-sourcing-lead-job-sourcing-pipeline-discovery-route-selection",
        "relation": "performs",
        "roleId": "sourcing-lead",
        "targetId": "sourcing-pipeline-discovery.route-selection",
        "targetKind": "job"
      },
      {
        "id": "performs-sourcing-lead-job-tactical-sourcing-autonomy-eligibility-screen",
        "relation": "performs",
        "roleId": "sourcing-lead",
        "targetId": "tactical-sourcing-autonomy.eligibility-screen",
        "targetKind": "job"
      },
      {
        "id": "performs-sourcing-lead-job-tactical-sourcing-autonomy-partial-recovery",
        "relation": "performs",
        "roleId": "sourcing-lead",
        "targetId": "tactical-sourcing-autonomy.partial-recovery",
        "targetKind": "job"
      },
      {
        "id": "performs-sourcing-manager-business-module-contract-authoring-review",
        "relation": "performs",
        "roleId": "sourcing-manager",
        "targetId": "contract-authoring-review",
        "targetKind": "business-module"
      },
      {
        "id": "performs-sourcing-manager-entity-clause-deviation",
        "relation": "performs",
        "roleId": "sourcing-manager",
        "targetId": "clause-deviation",
        "targetKind": "entity"
      },
      {
        "id": "performs-sourcing-manager-entity-clause-library-entry",
        "relation": "performs",
        "roleId": "sourcing-manager",
        "targetId": "clause-library-entry",
        "targetKind": "entity"
      },
      {
        "id": "performs-sourcing-manager-entity-contract-template",
        "relation": "performs",
        "roleId": "sourcing-manager",
        "targetId": "contract-template",
        "targetKind": "entity"
      },
      {
        "id": "performs-sourcing-manager-entity-contract-version",
        "relation": "performs",
        "roleId": "sourcing-manager",
        "targetId": "contract-version",
        "targetKind": "entity"
      },
      {
        "id": "performs-sourcing-manager-job-contract-approval-repository-execute-once",
        "relation": "performs",
        "roleId": "sourcing-manager",
        "targetId": "contract-approval-repository.execute-once",
        "targetKind": "job"
      },
      {
        "id": "performs-sourcing-manager-job-contract-authoring-review-commercial-position",
        "relation": "performs",
        "roleId": "sourcing-manager",
        "targetId": "contract-authoring-review.commercial-position",
        "targetKind": "job"
      },
      {
        "id": "performs-sourcing-manager-job-contract-authoring-review-start-with-context",
        "relation": "performs",
        "roleId": "sourcing-manager",
        "targetId": "contract-authoring-review.start-with-context",
        "targetKind": "job"
      },
      {
        "id": "performs-sourcing-manager-job-contract-authoring-review-version-integrity",
        "relation": "performs",
        "roleId": "sourcing-manager",
        "targetId": "contract-authoring-review.version-integrity",
        "targetKind": "job"
      },
      {
        "id": "performs-sourcing-manager-job-renewal-change-compliance-compare-paths",
        "relation": "performs",
        "roleId": "sourcing-manager",
        "targetId": "renewal-change-compliance.compare-paths",
        "targetKind": "job"
      },
      {
        "id": "performs-supplier-account-lead-job-supplier-innovation-pipeline-answer-supplier",
        "relation": "performs",
        "roleId": "supplier-account-lead",
        "targetId": "supplier-innovation-pipeline.answer-supplier",
        "targetKind": "job"
      },
      {
        "id": "performs-supplier-account-lead-job-supplier-performance-review-accept-commitment",
        "relation": "performs",
        "roleId": "supplier-account-lead",
        "targetId": "supplier-performance-review.accept-commitment",
        "targetKind": "job"
      },
      {
        "id": "performs-supplier-account-lead-job-supplier-relationship-joint-value-governance-cadence",
        "relation": "performs",
        "roleId": "supplier-account-lead",
        "targetId": "supplier-relationship-joint-value.governance-cadence",
        "targetKind": "job"
      },
      {
        "id": "performs-supplier-contact-business-module-supplier-onboarding",
        "relation": "performs",
        "roleId": "supplier-contact",
        "targetId": "supplier-onboarding",
        "targetKind": "business-module"
      },
      {
        "id": "performs-supplier-contact-entity-supplier-onboarding-case",
        "relation": "performs",
        "roleId": "supplier-contact",
        "targetId": "supplier-onboarding-case",
        "targetKind": "entity"
      },
      {
        "id": "performs-supplier-contact-entity-supplier-profile",
        "relation": "performs",
        "roleId": "supplier-contact",
        "targetId": "supplier-profile",
        "targetKind": "entity"
      },
      {
        "id": "performs-supplier-contact-job-supplier-onboarding-supplier-burden",
        "relation": "performs",
        "roleId": "supplier-contact",
        "targetId": "supplier-onboarding.supplier-burden",
        "targetKind": "job"
      },
      {
        "id": "performs-supplier-contact-job-supplier-remediation-exit-coordinated-progress",
        "relation": "performs",
        "roleId": "supplier-contact",
        "targetId": "supplier-remediation-exit.coordinated-progress",
        "targetKind": "job"
      },
      {
        "id": "performs-supplier-master-steward-business-module-supplier-master-qualification",
        "relation": "performs",
        "roleId": "supplier-master-steward",
        "targetId": "supplier-master-qualification",
        "targetKind": "business-module"
      },
      {
        "id": "performs-supplier-master-steward-business-module-supplier-onboarding",
        "relation": "performs",
        "roleId": "supplier-master-steward",
        "targetId": "supplier-onboarding",
        "targetKind": "business-module"
      },
      {
        "id": "performs-supplier-master-steward-entity-supplier-master-change",
        "relation": "performs",
        "roleId": "supplier-master-steward",
        "targetId": "supplier-master-change",
        "targetKind": "entity"
      },
      {
        "id": "performs-supplier-master-steward-entity-supplier-onboarding-case",
        "relation": "performs",
        "roleId": "supplier-master-steward",
        "targetId": "supplier-onboarding-case",
        "targetKind": "entity"
      },
      {
        "id": "performs-supplier-master-steward-entity-supplier-profile",
        "relation": "performs",
        "roleId": "supplier-master-steward",
        "targetId": "supplier-profile",
        "targetKind": "entity"
      },
      {
        "id": "performs-supplier-master-steward-entity-supplier-qualification",
        "relation": "performs",
        "roleId": "supplier-master-steward",
        "targetId": "supplier-qualification",
        "targetKind": "entity"
      },
      {
        "id": "performs-supplier-master-steward-job-supplier-master-qualification-carbon-compliance",
        "relation": "performs",
        "roleId": "supplier-master-steward",
        "targetId": "supplier-master-qualification.carbon-compliance",
        "targetKind": "job"
      },
      {
        "id": "performs-supplier-master-steward-job-supplier-master-qualification-master-change",
        "relation": "performs",
        "roleId": "supplier-master-steward",
        "targetId": "supplier-master-qualification.master-change",
        "targetKind": "job"
      },
      {
        "id": "performs-supplier-master-steward-job-supplier-master-qualification-quality-prediction",
        "relation": "performs",
        "roleId": "supplier-master-steward",
        "targetId": "supplier-master-qualification.quality-prediction",
        "targetKind": "job"
      },
      {
        "id": "performs-supplier-master-steward-job-supplier-master-qualification-scope-qualification",
        "relation": "performs",
        "roleId": "supplier-master-steward",
        "targetId": "supplier-master-qualification.scope-qualification",
        "targetKind": "job"
      },
      {
        "id": "performs-supplier-master-steward-job-supplier-onboarding-duplicate-party",
        "relation": "performs",
        "roleId": "supplier-master-steward",
        "targetId": "supplier-onboarding.duplicate-party",
        "targetKind": "job"
      },
      {
        "id": "performs-supplier-master-steward-job-supplier-onboarding-protected-change",
        "relation": "performs",
        "roleId": "supplier-master-steward",
        "targetId": "supplier-onboarding.protected-change",
        "targetKind": "job"
      },
      {
        "id": "performs-tprm-programme-owner-business-module-continuous-risk-monitoring",
        "relation": "performs",
        "roleId": "tprm-programme-owner",
        "targetId": "continuous-risk-monitoring",
        "targetKind": "business-module"
      },
      {
        "id": "performs-tprm-programme-owner-business-module-third-party-risk-review",
        "relation": "performs",
        "roleId": "tprm-programme-owner",
        "targetId": "third-party-risk-review",
        "targetKind": "business-module"
      },
      {
        "id": "performs-tprm-programme-owner-entity-supplier-risk-assessment",
        "relation": "performs",
        "roleId": "tprm-programme-owner",
        "targetId": "supplier-risk-assessment",
        "targetKind": "entity"
      },
      {
        "id": "performs-tprm-programme-owner-entity-supplier-risk-case",
        "relation": "performs",
        "roleId": "tprm-programme-owner",
        "targetId": "supplier-risk-case",
        "targetKind": "entity"
      },
      {
        "id": "performs-tprm-programme-owner-entity-supplier-risk-signal",
        "relation": "performs",
        "roleId": "tprm-programme-owner",
        "targetId": "supplier-risk-signal",
        "targetKind": "entity"
      },
      {
        "id": "performs-tprm-programme-owner-entity-supplier-tier-link",
        "relation": "performs",
        "roleId": "tprm-programme-owner",
        "targetId": "supplier-tier-link",
        "targetKind": "entity"
      },
      {
        "id": "performs-tprm-programme-owner-job-continuous-risk-monitoring-early-safeguard",
        "relation": "performs",
        "roleId": "tprm-programme-owner",
        "targetId": "continuous-risk-monitoring.early-safeguard",
        "targetKind": "job"
      },
      {
        "id": "performs-tprm-programme-owner-job-continuous-risk-monitoring-normalise-observation",
        "relation": "performs",
        "roleId": "tprm-programme-owner",
        "targetId": "continuous-risk-monitoring.normalise-observation",
        "targetKind": "job"
      },
      {
        "id": "performs-tprm-programme-owner-job-supplier-remediation-exit-verify-recovery",
        "relation": "performs",
        "roleId": "tprm-programme-owner",
        "targetId": "supplier-remediation-exit.verify-recovery",
        "targetKind": "job"
      },
      {
        "id": "performs-tprm-programme-owner-job-third-party-risk-review-evidence-conflict",
        "relation": "performs",
        "roleId": "tprm-programme-owner",
        "targetId": "third-party-risk-review.evidence-conflict",
        "targetKind": "job"
      },
      {
        "id": "performs-tprm-programme-owner-job-third-party-risk-review-method-change",
        "relation": "performs",
        "roleId": "tprm-programme-owner",
        "targetId": "third-party-risk-review.method-change",
        "targetKind": "job"
      },
      {
        "id": "performs-treasury-manager-job-payment-execution-guard-in-envelope-submit",
        "relation": "performs",
        "roleId": "treasury-manager",
        "targetId": "payment-execution-guard.in-envelope-submit",
        "targetKind": "job"
      },
      {
        "id": "performs-treasury-manager-job-payment-execution-guard-track-outcome",
        "relation": "performs",
        "roleId": "treasury-manager",
        "targetId": "payment-execution-guard.track-outcome",
        "targetKind": "job"
      },
      {
        "id": "performs-treasury-manager-job-payment-readiness-treasury-change",
        "relation": "performs",
        "roleId": "treasury-manager",
        "targetId": "payment-readiness.treasury-change",
        "targetKind": "job"
      },
      {
        "id": "performs-value-lead-business-module-savings-initiative",
        "relation": "performs",
        "roleId": "value-lead",
        "targetId": "savings-initiative",
        "targetKind": "business-module"
      },
      {
        "id": "performs-value-lead-business-module-value-leakage-monitor",
        "relation": "performs",
        "roleId": "value-lead",
        "targetId": "value-leakage-monitor",
        "targetKind": "business-module"
      },
      {
        "id": "performs-value-lead-business-module-value-opportunity-baseline",
        "relation": "performs",
        "roleId": "value-lead",
        "targetId": "value-opportunity-baseline",
        "targetKind": "business-module"
      },
      {
        "id": "performs-value-lead-business-module-value-portfolio-forecast",
        "relation": "performs",
        "roleId": "value-lead",
        "targetId": "value-portfolio-forecast",
        "targetKind": "business-module"
      },
      {
        "id": "performs-value-lead-entity-savings-initiative-record",
        "relation": "performs",
        "roleId": "value-lead",
        "targetId": "savings-initiative-record",
        "targetKind": "entity"
      },
      {
        "id": "performs-value-lead-entity-value-leakage-finding",
        "relation": "performs",
        "roleId": "value-lead",
        "targetId": "value-leakage-finding",
        "targetKind": "entity"
      },
      {
        "id": "performs-value-lead-entity-value-opportunity-baseline",
        "relation": "performs",
        "roleId": "value-lead",
        "targetId": "value-opportunity-baseline",
        "targetKind": "entity"
      },
      {
        "id": "performs-value-lead-entity-value-portfolio-forecast",
        "relation": "performs",
        "roleId": "value-lead",
        "targetId": "value-portfolio-forecast",
        "targetKind": "entity"
      },
      {
        "id": "performs-value-lead-job-realization-reconciliation-attribution-assemble-actuals",
        "relation": "performs",
        "roleId": "value-lead",
        "targetId": "realization-reconciliation-attribution.assemble-actuals",
        "targetKind": "job"
      },
      {
        "id": "performs-value-lead-job-realization-reconciliation-attribution-prevent-overlap",
        "relation": "performs",
        "roleId": "value-lead",
        "targetId": "realization-reconciliation-attribution.prevent-overlap",
        "targetKind": "job"
      },
      {
        "id": "performs-value-lead-job-savings-initiative-qualify-opportunity",
        "relation": "performs",
        "roleId": "value-lead",
        "targetId": "savings-initiative.qualify-opportunity",
        "targetKind": "job"
      },
      {
        "id": "performs-value-lead-job-savings-initiative-restate-result",
        "relation": "performs",
        "roleId": "value-lead",
        "targetId": "savings-initiative.restate-result",
        "targetKind": "job"
      },
      {
        "id": "performs-value-lead-job-value-leakage-monitor-confirm-variance",
        "relation": "performs",
        "roleId": "value-lead",
        "targetId": "value-leakage-monitor.confirm-variance",
        "targetKind": "job"
      },
      {
        "id": "performs-value-lead-job-value-leakage-monitor-remeasure",
        "relation": "performs",
        "roleId": "value-lead",
        "targetId": "value-leakage-monitor.remeasure",
        "targetKind": "job"
      },
      {
        "id": "performs-value-lead-job-value-opportunity-baseline-assumption-sensitivity",
        "relation": "performs",
        "roleId": "value-lead",
        "targetId": "value-opportunity-baseline.assumption-sensitivity",
        "targetKind": "job"
      },
      {
        "id": "performs-value-lead-job-value-opportunity-baseline-qualify-opportunity",
        "relation": "performs",
        "roleId": "value-lead",
        "targetId": "value-opportunity-baseline.qualify-opportunity",
        "targetKind": "job"
      },
      {
        "id": "performs-value-lead-job-value-portfolio-forecast-current-forecast",
        "relation": "performs",
        "roleId": "value-lead",
        "targetId": "value-portfolio-forecast.current-forecast",
        "targetKind": "job"
      },
      {
        "id": "performs-value-lead-job-value-portfolio-forecast-margin-tradeoff",
        "relation": "performs",
        "roleId": "value-lead",
        "targetId": "value-portfolio-forecast.margin-tradeoff",
        "targetKind": "job"
      },
      {
        "id": "performs-value-lead-job-value-portfolio-forecast-scenario-range",
        "relation": "performs",
        "roleId": "value-lead",
        "targetId": "value-portfolio-forecast.scenario-range",
        "targetKind": "job"
      },
      {
        "id": "performs-policy-owner-job-policy-rule-lifecycle-channel-drift",
        "relation": "performs",
        "roleId": "policy-owner",
        "targetId": "policy-rule-lifecycle.channel-drift",
        "targetKind": "job"
      },
      {
        "id": "performs-procurement-buyer-job-guided-buying-catalogue-coverage",
        "relation": "performs",
        "roleId": "procurement-buyer",
        "targetId": "guided-buying.catalogue-coverage",
        "targetKind": "job"
      },
      {
        "id": "performs-sourcing-lead-job-tactical-sourcing-autonomy-spot-buy-conversion",
        "relation": "performs",
        "roleId": "sourcing-lead",
        "targetId": "tactical-sourcing-autonomy.spot-buy-conversion",
        "targetKind": "job"
      },
      {
        "id": "performs-treasury-manager-job-payment-readiness-payment-terms",
        "relation": "performs",
        "roleId": "treasury-manager",
        "targetId": "payment-readiness.payment-terms",
        "targetKind": "job"
      },
      {
        "id": "performs-value-lead-job-value-leakage-monitor-price-variance",
        "relation": "performs",
        "roleId": "value-lead",
        "targetId": "value-leakage-monitor.price-variance",
        "targetKind": "job"
      }
    ],
    "jobDefinitions": [
      {
        "businessModuleId": "spend-data-foundation",
        "completionKey": "workblock.spend-foundation.story.addressable-view.completion",
        "executionFlowIds": [
          "ingest-spend-delta",
          "canonicalize-spend",
          "reconcile-publish-spend",
          "monitor-spend-foundation"
        ],
        "id": "spend-data-foundation.addressable-view",
        "roleId": "procurement-analyst",
        "storyKey": "workblock.spend-foundation.story.addressable-view.story"
      },
      {
        "businessModuleId": "spend-data-foundation",
        "completionKey": "workblock.spend-foundation.story.ambiguous-record.completion",
        "executionFlowIds": [
          "ingest-spend-delta",
          "canonicalize-spend",
          "reconcile-publish-spend",
          "monitor-spend-foundation"
        ],
        "id": "spend-data-foundation.ambiguous-record",
        "roleId": "data-steward",
        "storyKey": "workblock.spend-foundation.story.ambiguous-record.story"
      },
      {
        "businessModuleId": "spend-data-foundation",
        "completionKey": "workblock.spend-foundation.story.publication-control.completion",
        "executionFlowIds": [
          "ingest-spend-delta",
          "canonicalize-spend",
          "reconcile-publish-spend",
          "monitor-spend-foundation"
        ],
        "id": "spend-data-foundation.publication-control",
        "roleId": "data-steward",
        "storyKey": "workblock.spend-foundation.story.publication-control.story"
      },
      {
        "businessModuleId": "spend-data-foundation",
        "completionKey": "workblock.spend-foundation.story.stale-consumer.completion",
        "executionFlowIds": [
          "ingest-spend-delta",
          "canonicalize-spend",
          "reconcile-publish-spend",
          "monitor-spend-foundation"
        ],
        "id": "spend-data-foundation.stale-consumer",
        "roleId": "procurement-analyst",
        "storyKey": "workblock.spend-foundation.story.stale-consumer.story"
      },
      {
        "businessModuleId": "category-opportunity-radar",
        "completionKey": "workblock.category-radar.story.spend-refresh.completion",
        "executionFlowIds": [
          "refresh-category-signals",
          "detect-category-opportunities",
          "qualify-category-opportunities",
          "read-category-opportunity-portfolio",
          "learn-category-opportunity-outcomes",
          "surface-tail-consolidation-opportunities"
        ],
        "id": "category-opportunity-radar.spend-refresh",
        "roleId": "category-manager",
        "storyKey": "workblock.category-radar.story.spend-refresh.story"
      },
      {
        "businessModuleId": "category-opportunity-radar",
        "completionKey": "workblock.category-radar.story.market-event.completion",
        "executionFlowIds": [
          "refresh-category-signals",
          "detect-category-opportunities",
          "qualify-category-opportunities",
          "read-category-opportunity-portfolio",
          "learn-category-opportunity-outcomes",
          "project-commodity-price-outlook"
        ],
        "id": "category-opportunity-radar.market-event",
        "roleId": "category-manager",
        "storyKey": "workblock.category-radar.story.market-event.story"
      },
      {
        "businessModuleId": "category-opportunity-radar",
        "completionKey": "workblock.category-radar.story.duplicate-signals.completion",
        "executionFlowIds": [
          "refresh-category-signals",
          "detect-category-opportunities",
          "qualify-category-opportunities",
          "read-category-opportunity-portfolio",
          "learn-category-opportunity-outcomes"
        ],
        "id": "category-opportunity-radar.duplicate-signals",
        "roleId": "procurement-analyst",
        "storyKey": "workblock.category-radar.story.duplicate-signals.story"
      },
      {
        "businessModuleId": "category-opportunity-radar",
        "completionKey": "workblock.category-radar.story.boundary-review.completion",
        "executionFlowIds": [
          "refresh-category-signals",
          "detect-category-opportunities",
          "qualify-category-opportunities",
          "read-category-opportunity-portfolio",
          "learn-category-opportunity-outcomes"
        ],
        "id": "category-opportunity-radar.boundary-review",
        "roleId": "category-manager",
        "storyKey": "workblock.category-radar.story.boundary-review.story"
      },
      {
        "businessModuleId": "category-opportunity-radar",
        "completionKey": "workblock.category-radar.story.approved-handoff.completion",
        "executionFlowIds": [
          "refresh-category-signals",
          "detect-category-opportunities",
          "qualify-category-opportunities",
          "read-category-opportunity-portfolio",
          "learn-category-opportunity-outcomes"
        ],
        "id": "category-opportunity-radar.approved-handoff",
        "roleId": "category-manager",
        "storyKey": "workblock.category-radar.story.approved-handoff.story"
      },
      {
        "businessModuleId": "category-opportunity-radar",
        "completionKey": "workblock.category-radar.story.source-change.completion",
        "executionFlowIds": [
          "refresh-category-signals",
          "detect-category-opportunities",
          "qualify-category-opportunities",
          "read-category-opportunity-portfolio",
          "learn-category-opportunity-outcomes"
        ],
        "id": "category-opportunity-radar.source-change",
        "roleId": "procurement-analyst",
        "storyKey": "workblock.category-radar.story.source-change.story"
      },
      {
        "businessModuleId": "category-strategy-orchestrator",
        "completionKey": "workblock.category-strategy.story.current-fact-base.completion",
        "executionFlowIds": [
          "assemble-category-fact-base",
          "design-category-strategy",
          "commit-category-strategy",
          "orchestrate-category-strategy",
          "monitor-strategy-fitness"
        ],
        "id": "category-strategy-orchestrator.current-fact-base",
        "roleId": "category-manager",
        "storyKey": "workblock.category-strategy.story.current-fact-base.story"
      },
      {
        "businessModuleId": "category-strategy-orchestrator",
        "completionKey": "workblock.category-strategy.story.scenario-choice.completion",
        "executionFlowIds": [
          "assemble-category-fact-base",
          "design-category-strategy",
          "commit-category-strategy",
          "orchestrate-category-strategy",
          "monitor-strategy-fitness"
        ],
        "id": "category-strategy-orchestrator.scenario-choice",
        "roleId": "category-manager",
        "storyKey": "workblock.category-strategy.story.scenario-choice.story"
      },
      {
        "businessModuleId": "category-strategy-orchestrator",
        "completionKey": "workblock.category-strategy.story.strategy-commit.completion",
        "executionFlowIds": [
          "assemble-category-fact-base",
          "design-category-strategy",
          "commit-category-strategy",
          "orchestrate-category-strategy",
          "monitor-strategy-fitness"
        ],
        "id": "category-strategy-orchestrator.strategy-commit",
        "roleId": "category-manager",
        "storyKey": "workblock.category-strategy.story.strategy-commit.story"
      },
      {
        "businessModuleId": "category-strategy-orchestrator",
        "completionKey": "workblock.category-strategy.story.initiative-handoff.completion",
        "executionFlowIds": [
          "assemble-category-fact-base",
          "design-category-strategy",
          "commit-category-strategy",
          "orchestrate-category-strategy",
          "monitor-strategy-fitness"
        ],
        "id": "category-strategy-orchestrator.initiative-handoff",
        "roleId": "procurement-analyst",
        "storyKey": "workblock.category-strategy.story.initiative-handoff.story"
      },
      {
        "businessModuleId": "category-strategy-orchestrator",
        "completionKey": "workblock.category-strategy.story.strategy-drift.completion",
        "executionFlowIds": [
          "assemble-category-fact-base",
          "design-category-strategy",
          "commit-category-strategy",
          "orchestrate-category-strategy",
          "monitor-strategy-fitness"
        ],
        "id": "category-strategy-orchestrator.strategy-drift",
        "roleId": "category-manager",
        "storyKey": "workblock.category-strategy.story.strategy-drift.story"
      },
      {
        "businessModuleId": "policy-rule-lifecycle",
        "completionKey": "workblock.policy-lifecycle.story.source-trace.completion",
        "executionFlowIds": [
          "ingest-policy-version",
          "author-test-rule-release",
          "approve-deploy-rule-release",
          "monitor-policy-runtime",
          "read-policy-release-registry"
        ],
        "id": "policy-rule-lifecycle.source-trace",
        "roleId": "policy-owner",
        "storyKey": "workblock.policy-lifecycle.story.source-trace.story"
      },
      {
        "businessModuleId": "policy-rule-lifecycle",
        "completionKey": "workblock.policy-lifecycle.story.rule-authoring.completion",
        "executionFlowIds": [
          "ingest-policy-version",
          "author-test-rule-release",
          "approve-deploy-rule-release",
          "monitor-policy-runtime",
          "read-policy-release-registry"
        ],
        "id": "policy-rule-lifecycle.rule-authoring",
        "roleId": "policy-owner",
        "storyKey": "workblock.policy-lifecycle.story.rule-authoring.story"
      },
      {
        "businessModuleId": "policy-rule-lifecycle",
        "completionKey": "workblock.policy-lifecycle.story.boundary-testing.completion",
        "executionFlowIds": [
          "ingest-policy-version",
          "author-test-rule-release",
          "approve-deploy-rule-release",
          "monitor-policy-runtime",
          "read-policy-release-registry"
        ],
        "id": "policy-rule-lifecycle.boundary-testing",
        "roleId": "policy-owner",
        "storyKey": "workblock.policy-lifecycle.story.boundary-testing.story"
      },
      {
        "businessModuleId": "policy-rule-lifecycle",
        "completionKey": "workblock.policy-lifecycle.story.controlled-release.completion",
        "executionFlowIds": [
          "ingest-policy-version",
          "author-test-rule-release",
          "approve-deploy-rule-release",
          "monitor-policy-runtime",
          "read-policy-release-registry"
        ],
        "id": "policy-rule-lifecycle.controlled-release",
        "roleId": "policy-owner",
        "storyKey": "workblock.policy-lifecycle.story.controlled-release.story"
      },
      {
        "businessModuleId": "policy-rule-lifecycle",
        "completionKey": "workblock.policy-lifecycle.story.change-impact.completion",
        "executionFlowIds": [
          "ingest-policy-version",
          "author-test-rule-release",
          "approve-deploy-rule-release",
          "monitor-policy-runtime",
          "read-policy-release-registry"
        ],
        "id": "policy-rule-lifecycle.change-impact",
        "roleId": "policy-owner",
        "storyKey": "workblock.policy-lifecycle.story.change-impact.story"
      },
      {
        "businessModuleId": "policy-guidance",
        "completionKey": "workblock.policy.story.which-route.completion",
        "executionFlowIds": [
          "evaluate-policy-question",
          "compose-policy-guidance",
          "operate-policy-exception",
          "monitor-policy-guidance"
        ],
        "id": "policy-guidance.which-route",
        "roleId": "policy-owner",
        "storyKey": "workblock.policy.story.which-route.story"
      },
      {
        "businessModuleId": "policy-guidance",
        "completionKey": "workblock.policy.story.missing-fact.completion",
        "executionFlowIds": [
          "evaluate-policy-question",
          "compose-policy-guidance",
          "operate-policy-exception",
          "monitor-policy-guidance"
        ],
        "id": "policy-guidance.missing-fact",
        "roleId": "policy-owner",
        "storyKey": "workblock.policy.story.missing-fact.story"
      },
      {
        "businessModuleId": "policy-guidance",
        "completionKey": "workblock.policy.story.conflicting-sources.completion",
        "executionFlowIds": [
          "evaluate-policy-question",
          "compose-policy-guidance",
          "operate-policy-exception",
          "monitor-policy-guidance"
        ],
        "id": "policy-guidance.conflicting-sources",
        "roleId": "policy-owner",
        "storyKey": "workblock.policy.story.conflicting-sources.story"
      },
      {
        "businessModuleId": "policy-guidance",
        "completionKey": "workblock.policy.story.exception-route.completion",
        "executionFlowIds": [
          "evaluate-policy-question",
          "compose-policy-guidance",
          "operate-policy-exception",
          "monitor-policy-guidance"
        ],
        "id": "policy-guidance.exception-route",
        "roleId": "policy-owner",
        "storyKey": "workblock.policy.story.exception-route.story"
      },
      {
        "businessModuleId": "policy-guidance",
        "completionKey": "workblock.policy.story.policy-change.completion",
        "executionFlowIds": [
          "evaluate-policy-question",
          "compose-policy-guidance",
          "operate-policy-exception",
          "monitor-policy-guidance"
        ],
        "id": "policy-guidance.policy-change",
        "roleId": "policy-owner",
        "storyKey": "workblock.policy.story.policy-change.story"
      },
      {
        "businessModuleId": "policy-guidance",
        "completionKey": "workblock.policy.story.decision-point.completion",
        "executionFlowIds": [
          "evaluate-policy-question",
          "compose-policy-guidance",
          "operate-policy-exception",
          "monitor-policy-guidance"
        ],
        "id": "policy-guidance.decision-point",
        "roleId": "policy-owner",
        "storyKey": "workblock.policy.story.decision-point.story"
      },
      {
        "businessModuleId": "procurement-service-catalogue",
        "completionKey": "workblock.service-catalogue.story.find-service.completion",
        "executionFlowIds": [
          "author-service-offering",
          "publish-service-catalogue",
          "discover-procurement-service",
          "monitor-service-catalogue"
        ],
        "id": "procurement-service-catalogue.find-service",
        "roleId": "requester",
        "storyKey": "workblock.service-catalogue.story.find-service.story"
      },
      {
        "businessModuleId": "procurement-service-catalogue",
        "completionKey": "workblock.service-catalogue.story.start-ready.completion",
        "executionFlowIds": [
          "author-service-offering",
          "publish-service-catalogue",
          "discover-procurement-service",
          "monitor-service-catalogue"
        ],
        "id": "procurement-service-catalogue.start-ready",
        "roleId": "requester",
        "storyKey": "workblock.service-catalogue.story.start-ready.story"
      },
      {
        "businessModuleId": "procurement-service-catalogue",
        "completionKey": "workblock.service-catalogue.story.publish-contract.completion",
        "executionFlowIds": [
          "author-service-offering",
          "publish-service-catalogue",
          "discover-procurement-service",
          "monitor-service-catalogue"
        ],
        "id": "procurement-service-catalogue.publish-contract",
        "roleId": "process-owner",
        "storyKey": "workblock.service-catalogue.story.publish-contract.story"
      },
      {
        "businessModuleId": "procurement-service-catalogue",
        "completionKey": "workblock.service-catalogue.story.service-friction.completion",
        "executionFlowIds": [
          "author-service-offering",
          "publish-service-catalogue",
          "discover-procurement-service",
          "monitor-service-catalogue"
        ],
        "id": "procurement-service-catalogue.service-friction",
        "roleId": "intake-owner",
        "storyKey": "workblock.service-catalogue.story.service-friction.story"
      },
      {
        "businessModuleId": "procurement-service-catalogue",
        "completionKey": "workblock.service-catalogue.story.retire-service.completion",
        "executionFlowIds": [
          "author-service-offering",
          "publish-service-catalogue",
          "discover-procurement-service",
          "monitor-service-catalogue"
        ],
        "id": "procurement-service-catalogue.retire-service",
        "roleId": "process-owner",
        "storyKey": "workblock.service-catalogue.story.retire-service.story"
      },
      {
        "businessModuleId": "intelligent-intake",
        "completionKey": "workblock.intake.story.explain-once.completion",
        "executionFlowIds": [
          "start-intake-request",
          "understand-intake-request",
          "confirm-submit-intake",
          "monitor-intake-quality"
        ],
        "id": "intelligent-intake.explain-once",
        "roleId": "requester",
        "storyKey": "workblock.intake.story.explain-once.story"
      },
      {
        "businessModuleId": "intelligent-intake",
        "completionKey": "workblock.intake.story.assemble-case.completion",
        "executionFlowIds": [
          "start-intake-request",
          "understand-intake-request",
          "confirm-submit-intake",
          "monitor-intake-quality"
        ],
        "id": "intelligent-intake.assemble-case",
        "roleId": "intake-owner",
        "storyKey": "workblock.intake.story.assemble-case.story"
      },
      {
        "businessModuleId": "intelligent-intake",
        "completionKey": "workblock.intake.story.solution-first.completion",
        "executionFlowIds": [
          "start-intake-request",
          "understand-intake-request",
          "confirm-submit-intake",
          "monitor-intake-quality"
        ],
        "id": "intelligent-intake.solution-first",
        "roleId": "intake-owner",
        "storyKey": "workblock.intake.story.solution-first.story"
      },
      {
        "businessModuleId": "intelligent-intake",
        "completionKey": "workblock.intake.story.scoped-decision.completion",
        "executionFlowIds": [
          "start-intake-request",
          "understand-intake-request",
          "confirm-submit-intake",
          "monitor-intake-quality"
        ],
        "id": "intelligent-intake.scoped-decision",
        "roleId": "process-owner",
        "storyKey": "workblock.intake.story.scoped-decision.story"
      },
      {
        "businessModuleId": "intelligent-intake",
        "completionKey": "workblock.intake.story.fix-the-rule.completion",
        "executionFlowIds": [
          "start-intake-request",
          "understand-intake-request",
          "confirm-submit-intake",
          "monitor-intake-quality"
        ],
        "id": "intelligent-intake.fix-the-rule",
        "roleId": "process-owner",
        "storyKey": "workblock.intake.story.fix-the-rule.story"
      },
      {
        "businessModuleId": "request-enrichment-routing",
        "completionKey": "workblock.request-routing.story.normalise-request.completion",
        "executionFlowIds": [
          "enrich-procurement-request",
          "evaluate-request-route",
          "commit-request-route",
          "monitor-routing-quality"
        ],
        "id": "request-enrichment-routing.normalise-request",
        "roleId": "intake-owner",
        "storyKey": "workblock.request-routing.story.normalise-request.story"
      },
      {
        "businessModuleId": "request-enrichment-routing",
        "completionKey": "workblock.request-routing.story.reuse-enterprise-context.completion",
        "executionFlowIds": [
          "enrich-procurement-request",
          "evaluate-request-route",
          "commit-request-route",
          "monitor-routing-quality"
        ],
        "id": "request-enrichment-routing.reuse-enterprise-context",
        "roleId": "intake-owner",
        "storyKey": "workblock.request-routing.story.reuse-enterprise-context.story"
      },
      {
        "businessModuleId": "request-enrichment-routing",
        "completionKey": "workblock.request-routing.story.explain-route.completion",
        "executionFlowIds": [
          "enrich-procurement-request",
          "evaluate-request-route",
          "commit-request-route",
          "monitor-routing-quality"
        ],
        "id": "request-enrichment-routing.explain-route",
        "roleId": "requester",
        "storyKey": "workblock.request-routing.story.explain-route.story"
      },
      {
        "businessModuleId": "request-enrichment-routing",
        "completionKey": "workblock.request-routing.story.related-demand.completion",
        "executionFlowIds": [
          "enrich-procurement-request",
          "evaluate-request-route",
          "commit-request-route",
          "monitor-routing-quality"
        ],
        "id": "request-enrichment-routing.related-demand",
        "roleId": "demand-owner",
        "storyKey": "workblock.request-routing.story.related-demand.story"
      },
      {
        "businessModuleId": "request-enrichment-routing",
        "completionKey": "workblock.request-routing.story.true-exception.completion",
        "executionFlowIds": [
          "enrich-procurement-request",
          "evaluate-request-route",
          "commit-request-route",
          "monitor-routing-quality"
        ],
        "id": "request-enrichment-routing.true-exception",
        "roleId": "intake-owner",
        "storyKey": "workblock.request-routing.story.true-exception.story"
      },
      {
        "businessModuleId": "demand-orchestration",
        "completionKey": "workblock.demand.story.one-plan.completion",
        "executionFlowIds": [
          "plan-demand-journey",
          "execute-demand-journey",
          "operate-demand-exception",
          "read-demand-status",
          "monitor-demand-journeys"
        ],
        "id": "demand-orchestration.one-plan",
        "roleId": "demand-owner",
        "storyKey": "workblock.demand.story.one-plan.story"
      },
      {
        "businessModuleId": "demand-orchestration",
        "completionKey": "workblock.demand.story.truthful-status.completion",
        "executionFlowIds": [
          "plan-demand-journey",
          "execute-demand-journey",
          "operate-demand-exception",
          "read-demand-status",
          "monitor-demand-journeys"
        ],
        "id": "demand-orchestration.truthful-status",
        "roleId": "requester",
        "storyKey": "workblock.demand.story.truthful-status.story"
      },
      {
        "businessModuleId": "demand-orchestration",
        "completionKey": "workblock.demand.story.scoped-handback.completion",
        "executionFlowIds": [
          "plan-demand-journey",
          "execute-demand-journey",
          "operate-demand-exception",
          "read-demand-status",
          "monitor-demand-journeys"
        ],
        "id": "demand-orchestration.scoped-handback",
        "roleId": "demand-owner",
        "storyKey": "workblock.demand.story.scoped-handback.story"
      },
      {
        "businessModuleId": "demand-orchestration",
        "completionKey": "workblock.demand.story.partial-failure.completion",
        "executionFlowIds": [
          "plan-demand-journey",
          "execute-demand-journey",
          "operate-demand-exception",
          "read-demand-status",
          "monitor-demand-journeys"
        ],
        "id": "demand-orchestration.partial-failure",
        "roleId": "demand-owner",
        "storyKey": "workblock.demand.story.partial-failure.story"
      },
      {
        "businessModuleId": "demand-orchestration",
        "completionKey": "workblock.demand.story.scope-change.completion",
        "executionFlowIds": [
          "plan-demand-journey",
          "execute-demand-journey",
          "operate-demand-exception",
          "read-demand-status",
          "monitor-demand-journeys"
        ],
        "id": "demand-orchestration.scope-change",
        "roleId": "demand-owner",
        "storyKey": "workblock.demand.story.scope-change.story"
      },
      {
        "businessModuleId": "demand-orchestration",
        "completionKey": "workblock.demand.story.stalled-demand.completion",
        "executionFlowIds": [
          "plan-demand-journey",
          "execute-demand-journey",
          "operate-demand-exception",
          "read-demand-status",
          "monitor-demand-journeys"
        ],
        "id": "demand-orchestration.stalled-demand",
        "roleId": "process-owner",
        "storyKey": "workblock.demand.story.stalled-demand.story"
      },
      {
        "businessModuleId": "demand-consolidation-portfolio",
        "completionKey": "workblock.demand-portfolio.story.compatible-demand.completion",
        "executionFlowIds": [
          "refresh-demand-signals",
          "generate-demand-portfolios",
          "operate-demand-portfolios",
          "read-demand-portfolio",
          "learn-consolidation-outcomes"
        ],
        "id": "demand-consolidation-portfolio.compatible-demand",
        "roleId": "demand-owner",
        "storyKey": "workblock.demand-portfolio.story.compatible-demand.story"
      },
      {
        "businessModuleId": "demand-consolidation-portfolio",
        "completionKey": "workblock.demand-portfolio.story.grouping-rationale.completion",
        "executionFlowIds": [
          "refresh-demand-signals",
          "generate-demand-portfolios",
          "operate-demand-portfolios",
          "read-demand-portfolio",
          "learn-consolidation-outcomes"
        ],
        "id": "demand-consolidation-portfolio.grouping-rationale",
        "roleId": "demand-owner",
        "storyKey": "workblock.demand-portfolio.story.grouping-rationale.story"
      },
      {
        "businessModuleId": "demand-consolidation-portfolio",
        "completionKey": "workblock.demand-portfolio.story.portfolio-scenarios.completion",
        "executionFlowIds": [
          "refresh-demand-signals",
          "generate-demand-portfolios",
          "operate-demand-portfolios",
          "read-demand-portfolio",
          "learn-consolidation-outcomes"
        ],
        "id": "demand-consolidation-portfolio.portfolio-scenarios",
        "roleId": "demand-owner",
        "storyKey": "workblock.demand-portfolio.story.portfolio-scenarios.story"
      },
      {
        "businessModuleId": "demand-consolidation-portfolio",
        "completionKey": "workblock.demand-portfolio.story.business-consent.completion",
        "executionFlowIds": [
          "refresh-demand-signals",
          "generate-demand-portfolios",
          "operate-demand-portfolios",
          "read-demand-portfolio",
          "learn-consolidation-outcomes"
        ],
        "id": "demand-consolidation-portfolio.business-consent",
        "roleId": "process-owner",
        "storyKey": "workblock.demand-portfolio.story.business-consent.story"
      },
      {
        "businessModuleId": "demand-consolidation-portfolio",
        "completionKey": "workblock.demand-portfolio.story.execution-launch.completion",
        "executionFlowIds": [
          "refresh-demand-signals",
          "generate-demand-portfolios",
          "operate-demand-portfolios",
          "read-demand-portfolio",
          "learn-consolidation-outcomes"
        ],
        "id": "demand-consolidation-portfolio.execution-launch",
        "roleId": "demand-owner",
        "storyKey": "workblock.demand-portfolio.story.execution-launch.story"
      },
      {
        "businessModuleId": "demand-consolidation-portfolio",
        "completionKey": "workblock.demand-portfolio.story.material-economics.completion",
        "executionFlowIds": [
          "signal-raw-material-demand",
          "monitor-coverage-position",
          "harmonise-material-specifications"
        ],
        "id": "demand-consolidation-portfolio.material-economics",
        "roleId": "demand-owner",
        "storyKey": "workblock.demand-portfolio.story.material-economics.story"
      },
      {
        "businessModuleId": "sourcing-pipeline-discovery",
        "completionKey": "workblock.sourcing-pipeline.story.discover-intervention.completion",
        "executionFlowIds": [
          "refresh-sourcing-signals",
          "discover-sourcing-market",
          "qualify-sourcing-opportunity",
          "operate-sourcing-pipeline",
          "monitor-sourcing-pipeline"
        ],
        "id": "sourcing-pipeline-discovery.discover-intervention",
        "roleId": "sourcing-lead",
        "storyKey": "workblock.sourcing-pipeline.story.discover-intervention.story"
      },
      {
        "businessModuleId": "sourcing-pipeline-discovery",
        "completionKey": "workblock.sourcing-pipeline.story.market-readiness.completion",
        "executionFlowIds": [
          "refresh-sourcing-signals",
          "discover-sourcing-market",
          "qualify-sourcing-opportunity",
          "operate-sourcing-pipeline",
          "monitor-sourcing-pipeline"
        ],
        "id": "sourcing-pipeline-discovery.market-readiness",
        "roleId": "sourcing-lead",
        "storyKey": "workblock.sourcing-pipeline.story.market-readiness.story"
      },
      {
        "businessModuleId": "sourcing-pipeline-discovery",
        "completionKey": "workblock.sourcing-pipeline.story.route-selection.completion",
        "executionFlowIds": [
          "refresh-sourcing-signals",
          "discover-sourcing-market",
          "qualify-sourcing-opportunity",
          "operate-sourcing-pipeline",
          "monitor-sourcing-pipeline"
        ],
        "id": "sourcing-pipeline-discovery.route-selection",
        "roleId": "sourcing-lead",
        "storyKey": "workblock.sourcing-pipeline.story.route-selection.story"
      },
      {
        "businessModuleId": "sourcing-pipeline-discovery",
        "completionKey": "workblock.sourcing-pipeline.story.capacity-priority.completion",
        "executionFlowIds": [
          "refresh-sourcing-signals",
          "discover-sourcing-market",
          "qualify-sourcing-opportunity",
          "operate-sourcing-pipeline",
          "monitor-sourcing-pipeline"
        ],
        "id": "sourcing-pipeline-discovery.capacity-priority",
        "roleId": "sourcing-lead",
        "storyKey": "workblock.sourcing-pipeline.story.capacity-priority.story"
      },
      {
        "businessModuleId": "sourcing-pipeline-discovery",
        "completionKey": "workblock.sourcing-pipeline.story.accepted-handoff.completion",
        "executionFlowIds": [
          "refresh-sourcing-signals",
          "discover-sourcing-market",
          "qualify-sourcing-opportunity",
          "operate-sourcing-pipeline",
          "monitor-sourcing-pipeline"
        ],
        "id": "sourcing-pipeline-discovery.accepted-handoff",
        "roleId": "sourcing-lead",
        "storyKey": "workblock.sourcing-pipeline.story.accepted-handoff.story"
      },
      {
        "businessModuleId": "sourcing-pipeline-discovery",
        "completionKey": "workblock.sourcing-pipeline.story.buy-timing.completion",
        "executionFlowIds": [
          "mandate-buy-timing"
        ],
        "id": "sourcing-pipeline-discovery.buy-timing",
        "roleId": "sourcing-lead",
        "storyKey": "workblock.sourcing-pipeline.story.buy-timing.story"
      },
      {
        "businessModuleId": "sourcing-event",
        "completionKey": "workblock.sourcing-event.story.shape-event.completion",
        "executionFlowIds": [
          "design-sourcing-event",
          "author-event-package",
          "publish-sourcing-event",
          "operate-live-sourcing-event",
          "close-monitor-sourcing-event"
        ],
        "id": "sourcing-event.shape-event",
        "roleId": "sourcing-lead",
        "storyKey": "workblock.sourcing-event.story.shape-event.story"
      },
      {
        "businessModuleId": "sourcing-event",
        "completionKey": "workblock.sourcing-event.story.one-basis.completion",
        "executionFlowIds": [
          "design-sourcing-event",
          "author-event-package",
          "publish-sourcing-event",
          "operate-live-sourcing-event",
          "close-monitor-sourcing-event"
        ],
        "id": "sourcing-event.one-basis",
        "roleId": "sourcing-lead",
        "storyKey": "workblock.sourcing-event.story.one-basis.story"
      },
      {
        "businessModuleId": "sourcing-event",
        "completionKey": "workblock.sourcing-event.story.score-with-evidence.completion",
        "executionFlowIds": [
          "design-sourcing-event",
          "author-event-package",
          "publish-sourcing-event",
          "operate-live-sourcing-event",
          "close-monitor-sourcing-event"
        ],
        "id": "sourcing-event.score-with-evidence",
        "roleId": "evaluator",
        "storyKey": "workblock.sourcing-event.story.score-with-evidence.story"
      },
      {
        "businessModuleId": "sourcing-event",
        "completionKey": "workblock.sourcing-event.story.compare-scenarios.completion",
        "executionFlowIds": [
          "design-sourcing-event",
          "author-event-package",
          "publish-sourcing-event",
          "operate-live-sourcing-event",
          "close-monitor-sourcing-event"
        ],
        "id": "sourcing-event.compare-scenarios",
        "roleId": "sourcing-lead",
        "storyKey": "workblock.sourcing-event.story.compare-scenarios.story"
      },
      {
        "businessModuleId": "sourcing-event",
        "completionKey": "workblock.sourcing-event.story.amendment-impact.completion",
        "executionFlowIds": [
          "design-sourcing-event",
          "author-event-package",
          "publish-sourcing-event",
          "operate-live-sourcing-event",
          "close-monitor-sourcing-event"
        ],
        "id": "sourcing-event.amendment-impact",
        "roleId": "sourcing-lead",
        "storyKey": "workblock.sourcing-event.story.amendment-impact.story"
      },
      {
        "businessModuleId": "sourcing-event",
        "completionKey": "workblock.sourcing-event.story.decide-award.completion",
        "executionFlowIds": [
          "design-sourcing-event",
          "author-event-package",
          "publish-sourcing-event",
          "operate-live-sourcing-event",
          "close-monitor-sourcing-event"
        ],
        "id": "sourcing-event.decide-award",
        "roleId": "award-authority",
        "storyKey": "workblock.sourcing-event.story.decide-award.story"
      },
      {
        "businessModuleId": "bid-evaluation-award",
        "completionKey": "workblock.bid-award.story.normalise-bids.completion",
        "executionFlowIds": [
          "normalize-event-bids",
          "evaluate-event-bids",
          "optimize-award-scenarios",
          "decide-commit-award",
          "monitor-award-outcomes"
        ],
        "id": "bid-evaluation-award.normalise-bids",
        "roleId": "evaluator",
        "storyKey": "workblock.bid-award.story.normalise-bids.story"
      },
      {
        "businessModuleId": "bid-evaluation-award",
        "completionKey": "workblock.bid-award.story.apply-criteria.completion",
        "executionFlowIds": [
          "normalize-event-bids",
          "evaluate-event-bids",
          "optimize-award-scenarios",
          "decide-commit-award",
          "monitor-award-outcomes"
        ],
        "id": "bid-evaluation-award.apply-criteria",
        "roleId": "evaluator",
        "storyKey": "workblock.bid-award.story.apply-criteria.story"
      },
      {
        "businessModuleId": "bid-evaluation-award",
        "completionKey": "workblock.bid-award.story.award-scenarios.completion",
        "executionFlowIds": [
          "normalize-event-bids",
          "evaluate-event-bids",
          "optimize-award-scenarios",
          "decide-commit-award",
          "monitor-award-outcomes"
        ],
        "id": "bid-evaluation-award.award-scenarios",
        "roleId": "sourcing-lead",
        "storyKey": "workblock.bid-award.story.award-scenarios.story"
      },
      {
        "businessModuleId": "bid-evaluation-award",
        "completionKey": "workblock.bid-award.story.challenge-recommendation.completion",
        "executionFlowIds": [
          "normalize-event-bids",
          "evaluate-event-bids",
          "optimize-award-scenarios",
          "decide-commit-award",
          "monitor-award-outcomes"
        ],
        "id": "bid-evaluation-award.challenge-recommendation",
        "roleId": "award-authority",
        "storyKey": "workblock.bid-award.story.challenge-recommendation.story"
      },
      {
        "businessModuleId": "bid-evaluation-award",
        "completionKey": "workblock.bid-award.story.commit-award.completion",
        "executionFlowIds": [
          "normalize-event-bids",
          "evaluate-event-bids",
          "optimize-award-scenarios",
          "decide-commit-award",
          "monitor-award-outcomes"
        ],
        "id": "bid-evaluation-award.commit-award",
        "roleId": "award-authority",
        "storyKey": "workblock.bid-award.story.commit-award.story"
      },
      {
        "businessModuleId": "bid-evaluation-award",
        "completionKey": "workblock.bid-award.story.landed-cost.completion",
        "executionFlowIds": [
          "optimize-landed-cost"
        ],
        "id": "bid-evaluation-award.landed-cost",
        "roleId": "evaluator",
        "storyKey": "workblock.bid-award.story.landed-cost.story"
      },
      {
        "businessModuleId": "negotiation-copilot",
        "completionKey": "workblock.negotiation.story.set-mandate.completion",
        "executionFlowIds": [
          "prepare-negotiation-strategy",
          "authorise-negotiation-mandate",
          "operate-negotiation-session",
          "reconcile-negotiation-state",
          "monitor-negotiation-outcomes"
        ],
        "id": "negotiation-copilot.set-mandate",
        "roleId": "negotiation-lead",
        "storyKey": "workblock.negotiation.story.set-mandate.story"
      },
      {
        "businessModuleId": "negotiation-copilot",
        "completionKey": "workblock.negotiation.story.fact-base.completion",
        "executionFlowIds": [
          "prepare-negotiation-strategy",
          "authorise-negotiation-mandate",
          "operate-negotiation-session",
          "reconcile-negotiation-state",
          "monitor-negotiation-outcomes"
        ],
        "id": "negotiation-copilot.fact-base",
        "roleId": "negotiation-lead",
        "storyKey": "workblock.negotiation.story.fact-base.story"
      },
      {
        "businessModuleId": "negotiation-copilot",
        "completionKey": "workblock.negotiation.story.compare-packages.completion",
        "executionFlowIds": [
          "prepare-negotiation-strategy",
          "authorise-negotiation-mandate",
          "operate-negotiation-session",
          "reconcile-negotiation-state",
          "monitor-negotiation-outcomes"
        ],
        "id": "negotiation-copilot.compare-packages",
        "roleId": "sourcing-lead",
        "storyKey": "workblock.negotiation.story.compare-packages.story"
      },
      {
        "businessModuleId": "negotiation-copilot",
        "completionKey": "workblock.negotiation.story.bounded-authority.completion",
        "executionFlowIds": [
          "prepare-negotiation-strategy",
          "authorise-negotiation-mandate",
          "operate-negotiation-session",
          "reconcile-negotiation-state",
          "monitor-negotiation-outcomes"
        ],
        "id": "negotiation-copilot.bounded-authority",
        "roleId": "negotiation-lead",
        "storyKey": "workblock.negotiation.story.bounded-authority.story"
      },
      {
        "businessModuleId": "negotiation-copilot",
        "completionKey": "workblock.negotiation.story.capture-round.completion",
        "executionFlowIds": [
          "prepare-negotiation-strategy",
          "authorise-negotiation-mandate",
          "operate-negotiation-session",
          "reconcile-negotiation-state",
          "monitor-negotiation-outcomes"
        ],
        "id": "negotiation-copilot.capture-round",
        "roleId": "negotiation-lead",
        "storyKey": "workblock.negotiation.story.capture-round.story"
      },
      {
        "businessModuleId": "negotiation-copilot",
        "completionKey": "workblock.negotiation.story.hand-off-points.completion",
        "executionFlowIds": [
          "prepare-negotiation-strategy",
          "authorise-negotiation-mandate",
          "operate-negotiation-session",
          "reconcile-negotiation-state",
          "monitor-negotiation-outcomes"
        ],
        "id": "negotiation-copilot.hand-off-points",
        "roleId": "negotiation-lead",
        "storyKey": "workblock.negotiation.story.hand-off-points.story"
      },
      {
        "businessModuleId": "tactical-sourcing-autonomy",
        "completionKey": "workblock.tactical-sourcing.story.eligibility-screen.completion",
        "executionFlowIds": [
          "screen-tactical-demand",
          "launch-tactical-request",
          "operate-tactical-responses",
          "evaluate-negotiate-tactical-award",
          "reconcile-close-tactical-case"
        ],
        "id": "tactical-sourcing-autonomy.eligibility-screen",
        "roleId": "sourcing-lead",
        "storyKey": "workblock.tactical-sourcing.story.eligibility-screen.story"
      },
      {
        "businessModuleId": "tactical-sourcing-autonomy",
        "completionKey": "workblock.tactical-sourcing.story.supplier-cohort.completion",
        "executionFlowIds": [
          "screen-tactical-demand",
          "launch-tactical-request",
          "operate-tactical-responses",
          "evaluate-negotiate-tactical-award",
          "reconcile-close-tactical-case"
        ],
        "id": "tactical-sourcing-autonomy.supplier-cohort",
        "roleId": "evaluator",
        "storyKey": "workblock.tactical-sourcing.story.supplier-cohort.story"
      },
      {
        "businessModuleId": "tactical-sourcing-autonomy",
        "completionKey": "workblock.tactical-sourcing.story.bounded-exchange.completion",
        "executionFlowIds": [
          "screen-tactical-demand",
          "launch-tactical-request",
          "operate-tactical-responses",
          "evaluate-negotiate-tactical-award",
          "reconcile-close-tactical-case"
        ],
        "id": "tactical-sourcing-autonomy.bounded-exchange",
        "roleId": "negotiation-lead",
        "storyKey": "workblock.tactical-sourcing.story.bounded-exchange.story"
      },
      {
        "businessModuleId": "tactical-sourcing-autonomy",
        "completionKey": "workblock.tactical-sourcing.story.routine-award.completion",
        "executionFlowIds": [
          "screen-tactical-demand",
          "launch-tactical-request",
          "operate-tactical-responses",
          "evaluate-negotiate-tactical-award",
          "reconcile-close-tactical-case"
        ],
        "id": "tactical-sourcing-autonomy.routine-award",
        "roleId": "award-authority",
        "storyKey": "workblock.tactical-sourcing.story.routine-award.story"
      },
      {
        "businessModuleId": "tactical-sourcing-autonomy",
        "completionKey": "workblock.tactical-sourcing.story.partial-recovery.completion",
        "executionFlowIds": [
          "screen-tactical-demand",
          "launch-tactical-request",
          "operate-tactical-responses",
          "evaluate-negotiate-tactical-award",
          "reconcile-close-tactical-case"
        ],
        "id": "tactical-sourcing-autonomy.partial-recovery",
        "roleId": "sourcing-lead",
        "storyKey": "workblock.tactical-sourcing.story.partial-recovery.story"
      },
      {
        "businessModuleId": "contract-intake-digitization",
        "completionKey": "workblock.contract-intake.story.capture-once.completion",
        "executionFlowIds": [
          "capture-intake",
          "extract-and-resolve",
          "commit-readiness",
          "read-intake"
        ],
        "id": "contract-intake-digitization.capture-once",
        "roleId": "contract-manager",
        "storyKey": "workblock.contract-intake.story.capture-once.story"
      },
      {
        "businessModuleId": "contract-intake-digitization",
        "completionKey": "workblock.contract-intake.story.extract-with-citations.completion",
        "executionFlowIds": [
          "capture-intake",
          "extract-and-resolve",
          "commit-readiness",
          "read-intake"
        ],
        "id": "contract-intake-digitization.extract-with-citations",
        "roleId": "legal-counsel",
        "storyKey": "workblock.contract-intake.story.extract-with-citations.story"
      },
      {
        "businessModuleId": "contract-intake-digitization",
        "completionKey": "workblock.contract-intake.story.resolve-agreement.completion",
        "executionFlowIds": [
          "capture-intake",
          "extract-and-resolve",
          "commit-readiness",
          "read-intake"
        ],
        "id": "contract-intake-digitization.resolve-agreement",
        "roleId": "contract-manager",
        "storyKey": "workblock.contract-intake.story.resolve-agreement.story"
      },
      {
        "businessModuleId": "contract-intake-digitization",
        "completionKey": "workblock.contract-intake.story.publish-or-except.completion",
        "executionFlowIds": [
          "capture-intake",
          "extract-and-resolve",
          "commit-readiness",
          "read-intake"
        ],
        "id": "contract-intake-digitization.publish-or-except",
        "roleId": "contract-manager",
        "storyKey": "workblock.contract-intake.story.publish-or-except.story"
      },
      {
        "businessModuleId": "contract-authoring-review",
        "completionKey": "workblock.contract-authoring.story.start-with-context.completion",
        "executionFlowIds": [
          "assemble-draft",
          "analyse-deviations",
          "resolve-review",
          "read-contract-workspace"
        ],
        "id": "contract-authoring-review.start-with-context",
        "roleId": "sourcing-manager",
        "storyKey": "workblock.contract-authoring.story.start-with-context.story"
      },
      {
        "businessModuleId": "contract-authoring-review",
        "completionKey": "workblock.contract-authoring.story.third-party-paper.completion",
        "executionFlowIds": [
          "assemble-draft",
          "analyse-deviations",
          "resolve-review",
          "read-contract-workspace"
        ],
        "id": "contract-authoring-review.third-party-paper",
        "roleId": "legal-counsel",
        "storyKey": "workblock.contract-authoring.story.third-party-paper.story"
      },
      {
        "businessModuleId": "contract-authoring-review",
        "completionKey": "workblock.contract-authoring.story.commercial-position.completion",
        "executionFlowIds": [
          "assemble-draft",
          "analyse-deviations",
          "resolve-review",
          "read-contract-workspace"
        ],
        "id": "contract-authoring-review.commercial-position",
        "roleId": "sourcing-manager",
        "storyKey": "workblock.contract-authoring.story.commercial-position.story"
      },
      {
        "businessModuleId": "contract-authoring-review",
        "completionKey": "workblock.contract-authoring.story.version-integrity.completion",
        "executionFlowIds": [
          "assemble-draft",
          "analyse-deviations",
          "resolve-review",
          "read-contract-workspace"
        ],
        "id": "contract-authoring-review.version-integrity",
        "roleId": "sourcing-manager",
        "storyKey": "workblock.contract-authoring.story.version-integrity.story"
      },
      {
        "businessModuleId": "contract-approval-repository",
        "completionKey": "workblock.contract-repository.story.derive-approval-route.completion",
        "executionFlowIds": [
          "plan-approval",
          "await-and-sign",
          "activate-contract",
          "read-repository"
        ],
        "id": "contract-approval-repository.derive-approval-route",
        "roleId": "contract-manager",
        "storyKey": "workblock.contract-repository.story.derive-approval-route.story"
      },
      {
        "businessModuleId": "contract-approval-repository",
        "completionKey": "workblock.contract-repository.story.protect-approved-content.completion",
        "executionFlowIds": [
          "plan-approval",
          "await-and-sign",
          "activate-contract",
          "read-repository"
        ],
        "id": "contract-approval-repository.protect-approved-content",
        "roleId": "legal-counsel",
        "storyKey": "workblock.contract-repository.story.protect-approved-content.story"
      },
      {
        "businessModuleId": "contract-approval-repository",
        "completionKey": "workblock.contract-repository.story.execute-once.completion",
        "executionFlowIds": [
          "plan-approval",
          "await-and-sign",
          "activate-contract",
          "read-repository"
        ],
        "id": "contract-approval-repository.execute-once",
        "roleId": "sourcing-manager",
        "storyKey": "workblock.contract-repository.story.execute-once.story"
      },
      {
        "businessModuleId": "contract-approval-repository",
        "completionKey": "workblock.contract-repository.story.reconcile-repository.completion",
        "executionFlowIds": [
          "plan-approval",
          "await-and-sign",
          "activate-contract",
          "read-repository"
        ],
        "id": "contract-approval-repository.reconcile-repository",
        "roleId": "contract-manager",
        "storyKey": "workblock.contract-repository.story.reconcile-repository.story"
      },
      {
        "businessModuleId": "obligation-monitoring",
        "completionKey": "workblock.obligation.story.validate-extraction.completion",
        "executionFlowIds": [
          "establish-register",
          "monitor-commitments",
          "pursue-outcomes",
          "read-commitments"
        ],
        "id": "obligation-monitoring.validate-extraction",
        "roleId": "contract-manager",
        "storyKey": "workblock.obligation.story.validate-extraction.story"
      },
      {
        "businessModuleId": "obligation-monitoring",
        "completionKey": "workblock.obligation.story.accept-ownership.completion",
        "executionFlowIds": [
          "establish-register",
          "monitor-commitments",
          "pursue-outcomes",
          "read-commitments"
        ],
        "id": "obligation-monitoring.accept-ownership",
        "roleId": "obligation-owner",
        "storyKey": "workblock.obligation.story.accept-ownership.story"
      },
      {
        "businessModuleId": "obligation-monitoring",
        "completionKey": "workblock.obligation.story.notice-window.completion",
        "executionFlowIds": [
          "establish-register",
          "monitor-commitments",
          "pursue-outcomes",
          "read-commitments"
        ],
        "id": "obligation-monitoring.notice-window",
        "roleId": "legal-counsel",
        "storyKey": "workblock.obligation.story.notice-window.story"
      },
      {
        "businessModuleId": "obligation-monitoring",
        "completionKey": "workblock.obligation.story.evidence-closure.completion",
        "executionFlowIds": [
          "establish-register",
          "monitor-commitments",
          "pursue-outcomes",
          "read-commitments"
        ],
        "id": "obligation-monitoring.evidence-closure",
        "roleId": "obligation-owner",
        "storyKey": "workblock.obligation.story.evidence-closure.story"
      },
      {
        "businessModuleId": "obligation-monitoring",
        "completionKey": "workblock.obligation.story.amendment-impact.completion",
        "executionFlowIds": [
          "establish-register",
          "monitor-commitments",
          "pursue-outcomes",
          "read-commitments"
        ],
        "id": "obligation-monitoring.amendment-impact",
        "roleId": "contract-manager",
        "storyKey": "workblock.obligation.story.amendment-impact.story"
      },
      {
        "businessModuleId": "renewal-change-compliance",
        "completionKey": "workblock.renewal-compliance.story.decision-window.completion",
        "executionFlowIds": [
          "detect-window-or-variance",
          "analyse-options",
          "operate-change-and-findings",
          "read-change-compliance"
        ],
        "id": "renewal-change-compliance.decision-window",
        "roleId": "contract-manager",
        "storyKey": "workblock.renewal-compliance.story.decision-window.story"
      },
      {
        "businessModuleId": "renewal-change-compliance",
        "completionKey": "workblock.renewal-compliance.story.compare-paths.completion",
        "executionFlowIds": [
          "detect-window-or-variance",
          "analyse-options",
          "operate-change-and-findings",
          "read-change-compliance"
        ],
        "id": "renewal-change-compliance.compare-paths",
        "roleId": "sourcing-manager",
        "storyKey": "workblock.renewal-compliance.story.compare-paths.story"
      },
      {
        "businessModuleId": "renewal-change-compliance",
        "completionKey": "workblock.renewal-compliance.story.detect-variance.completion",
        "executionFlowIds": [
          "detect-window-or-variance",
          "analyse-options",
          "operate-change-and-findings",
          "read-change-compliance"
        ],
        "id": "renewal-change-compliance.detect-variance",
        "roleId": "obligation-owner",
        "storyKey": "workblock.renewal-compliance.story.detect-variance.story"
      },
      {
        "businessModuleId": "renewal-change-compliance",
        "completionKey": "workblock.renewal-compliance.story.execute-lifecycle-path.completion",
        "executionFlowIds": [
          "detect-window-or-variance",
          "analyse-options",
          "operate-change-and-findings",
          "read-change-compliance"
        ],
        "id": "renewal-change-compliance.execute-lifecycle-path",
        "roleId": "contract-manager",
        "storyKey": "workblock.renewal-compliance.story.execute-lifecycle-path.story"
      },
      {
        "businessModuleId": "supplier-onboarding",
        "completionKey": "workblock.onboarding.story.new-supplier.completion",
        "executionFlowIds": [
          "scope-onboarding",
          "collect-and-verify",
          "activate-supplier",
          "read-onboarding"
        ],
        "id": "supplier-onboarding.new-supplier",
        "roleId": "onboarding-coordinator",
        "storyKey": "workblock.onboarding.story.new-supplier.story"
      },
      {
        "businessModuleId": "supplier-onboarding",
        "completionKey": "workblock.onboarding.story.duplicate-party.completion",
        "executionFlowIds": [
          "scope-onboarding",
          "collect-and-verify",
          "activate-supplier",
          "read-onboarding"
        ],
        "id": "supplier-onboarding.duplicate-party",
        "roleId": "supplier-master-steward",
        "storyKey": "workblock.onboarding.story.duplicate-party.story"
      },
      {
        "businessModuleId": "supplier-onboarding",
        "completionKey": "workblock.onboarding.story.supplier-burden.completion",
        "executionFlowIds": [
          "scope-onboarding",
          "collect-and-verify",
          "activate-supplier",
          "read-onboarding"
        ],
        "id": "supplier-onboarding.supplier-burden",
        "roleId": "supplier-contact",
        "storyKey": "workblock.onboarding.story.supplier-burden.story"
      },
      {
        "businessModuleId": "supplier-onboarding",
        "completionKey": "workblock.onboarding.story.protected-change.completion",
        "executionFlowIds": [
          "scope-onboarding",
          "collect-and-verify",
          "activate-supplier",
          "read-onboarding"
        ],
        "id": "supplier-onboarding.protected-change",
        "roleId": "supplier-master-steward",
        "storyKey": "workblock.onboarding.story.protected-change.story"
      },
      {
        "businessModuleId": "supplier-onboarding",
        "completionKey": "workblock.onboarding.story.failed-activation.completion",
        "executionFlowIds": [
          "scope-onboarding",
          "collect-and-verify",
          "activate-supplier",
          "read-onboarding"
        ],
        "id": "supplier-onboarding.failed-activation",
        "roleId": "onboarding-coordinator",
        "storyKey": "workblock.onboarding.story.failed-activation.story"
      },
      {
        "businessModuleId": "supplier-master-qualification",
        "completionKey": "workblock.supplier-master.story.scope-qualification.completion",
        "executionFlowIds": [
          "evaluate-qualification",
          "monitor-eligibility",
          "control-master-change",
          "read-master-qualification"
        ],
        "id": "supplier-master-qualification.scope-qualification",
        "roleId": "supplier-master-steward",
        "storyKey": "workblock.supplier-master.story.scope-qualification.story"
      },
      {
        "businessModuleId": "supplier-master-qualification",
        "completionKey": "workblock.supplier-master.story.expiry-monitoring.completion",
        "executionFlowIds": [
          "evaluate-qualification",
          "monitor-eligibility",
          "control-master-change",
          "read-master-qualification"
        ],
        "id": "supplier-master-qualification.expiry-monitoring",
        "roleId": "accountable-risk-owner",
        "storyKey": "workblock.supplier-master.story.expiry-monitoring.story"
      },
      {
        "businessModuleId": "supplier-master-qualification",
        "completionKey": "workblock.supplier-master.story.master-change.completion",
        "executionFlowIds": [
          "evaluate-qualification",
          "monitor-eligibility",
          "control-master-change",
          "read-master-qualification"
        ],
        "id": "supplier-master-qualification.master-change",
        "roleId": "supplier-master-steward",
        "storyKey": "workblock.supplier-master.story.master-change.story"
      },
      {
        "businessModuleId": "supplier-master-qualification",
        "completionKey": "workblock.supplier-master.story.publish-eligibility.completion",
        "executionFlowIds": [
          "evaluate-qualification",
          "monitor-eligibility",
          "control-master-change",
          "read-master-qualification"
        ],
        "id": "supplier-master-qualification.publish-eligibility",
        "roleId": "onboarding-coordinator",
        "storyKey": "workblock.supplier-master.story.publish-eligibility.story"
      },
      {
        "businessModuleId": "supplier-master-qualification",
        "completionKey": "workblock.supplier-master.story.carbon-compliance.completion",
        "executionFlowIds": [
          "verify-carbon-cost-compliance"
        ],
        "id": "supplier-master-qualification.carbon-compliance",
        "roleId": "supplier-master-steward",
        "storyKey": "workblock.supplier-master.story.carbon-compliance.story"
      },
      {
        "businessModuleId": "supplier-master-qualification",
        "completionKey": "workblock.supplier-master.story.quality-prediction.completion",
        "executionFlowIds": [
          "predict-supplier-quality"
        ],
        "id": "supplier-master-qualification.quality-prediction",
        "roleId": "supplier-master-steward",
        "storyKey": "workblock.supplier-master.story.quality-prediction.story"
      },
      {
        "businessModuleId": "third-party-risk-review",
        "completionKey": "workblock.risk-review.story.decision-package.completion",
        "executionFlowIds": [
          "scope-assessment",
          "evaluate-controls",
          "decide-risk",
          "read-risk-assessment"
        ],
        "id": "third-party-risk-review.decision-package",
        "roleId": "accountable-risk-owner",
        "storyKey": "workblock.risk-review.story.decision-package.story"
      },
      {
        "businessModuleId": "third-party-risk-review",
        "completionKey": "workblock.risk-review.story.evidence-conflict.completion",
        "executionFlowIds": [
          "scope-assessment",
          "evaluate-controls",
          "decide-risk",
          "read-risk-assessment"
        ],
        "id": "third-party-risk-review.evidence-conflict",
        "roleId": "tprm-programme-owner",
        "storyKey": "workblock.risk-review.story.evidence-conflict.story"
      },
      {
        "businessModuleId": "third-party-risk-review",
        "completionKey": "workblock.risk-review.story.monitoring-signal.completion",
        "executionFlowIds": [
          "scope-assessment",
          "evaluate-controls",
          "decide-risk",
          "read-risk-assessment"
        ],
        "id": "third-party-risk-review.monitoring-signal",
        "roleId": "accountable-risk-owner",
        "storyKey": "workblock.risk-review.story.monitoring-signal.story"
      },
      {
        "businessModuleId": "third-party-risk-review",
        "completionKey": "workblock.risk-review.story.mitigation-closure.completion",
        "executionFlowIds": [
          "scope-assessment",
          "evaluate-controls",
          "decide-risk",
          "read-risk-assessment"
        ],
        "id": "third-party-risk-review.mitigation-closure",
        "roleId": "accountable-risk-owner",
        "storyKey": "workblock.risk-review.story.mitigation-closure.story"
      },
      {
        "businessModuleId": "third-party-risk-review",
        "completionKey": "workblock.risk-review.story.method-change.completion",
        "executionFlowIds": [
          "scope-assessment",
          "evaluate-controls",
          "decide-risk",
          "read-risk-assessment"
        ],
        "id": "third-party-risk-review.method-change",
        "roleId": "tprm-programme-owner",
        "storyKey": "workblock.risk-review.story.method-change.story"
      },
      {
        "businessModuleId": "continuous-risk-monitoring",
        "completionKey": "workblock.risk-monitor.story.normalise-observation.completion",
        "executionFlowIds": [
          "normalize-signals",
          "correlate-materiality",
          "pursue-risk-case",
          "read-risk-network"
        ],
        "id": "continuous-risk-monitoring.normalise-observation",
        "roleId": "tprm-programme-owner",
        "storyKey": "workblock.risk-monitor.story.normalise-observation.story"
      },
      {
        "businessModuleId": "continuous-risk-monitoring",
        "completionKey": "workblock.risk-monitor.story.resolve-exposure.completion",
        "executionFlowIds": [
          "normalize-signals",
          "correlate-materiality",
          "pursue-risk-case",
          "read-risk-network"
        ],
        "id": "continuous-risk-monitoring.resolve-exposure",
        "roleId": "accountable-risk-owner",
        "storyKey": "workblock.risk-monitor.story.resolve-exposure.story"
      },
      {
        "businessModuleId": "continuous-risk-monitoring",
        "completionKey": "workblock.risk-monitor.story.material-case.completion",
        "executionFlowIds": [
          "normalize-signals",
          "correlate-materiality",
          "pursue-risk-case",
          "read-risk-network"
        ],
        "id": "continuous-risk-monitoring.material-case",
        "roleId": "accountable-risk-owner",
        "storyKey": "workblock.risk-monitor.story.material-case.story"
      },
      {
        "businessModuleId": "continuous-risk-monitoring",
        "completionKey": "workblock.risk-monitor.story.early-safeguard.completion",
        "executionFlowIds": [
          "normalize-signals",
          "correlate-materiality",
          "pursue-risk-case",
          "read-risk-network"
        ],
        "id": "continuous-risk-monitoring.early-safeguard",
        "roleId": "tprm-programme-owner",
        "storyKey": "workblock.risk-monitor.story.early-safeguard.story"
      },
      {
        "businessModuleId": "supplier-remediation-exit",
        "completionKey": "workblock.supplier-remediation.story.corrective-plan.completion",
        "executionFlowIds": [
          "plan-remediation-or-exit",
          "pursue-remediation",
          "orchestrate-exit",
          "read-remediation-exit"
        ],
        "id": "supplier-remediation-exit.corrective-plan",
        "roleId": "accountable-risk-owner",
        "storyKey": "workblock.supplier-remediation.story.corrective-plan.story"
      },
      {
        "businessModuleId": "supplier-remediation-exit",
        "completionKey": "workblock.supplier-remediation.story.coordinated-progress.completion",
        "executionFlowIds": [
          "plan-remediation-or-exit",
          "pursue-remediation",
          "orchestrate-exit",
          "read-remediation-exit"
        ],
        "id": "supplier-remediation-exit.coordinated-progress",
        "roleId": "supplier-contact",
        "storyKey": "workblock.supplier-remediation.story.coordinated-progress.story"
      },
      {
        "businessModuleId": "supplier-remediation-exit",
        "completionKey": "workblock.supplier-remediation.story.verify-recovery.completion",
        "executionFlowIds": [
          "plan-remediation-or-exit",
          "pursue-remediation",
          "orchestrate-exit",
          "read-remediation-exit"
        ],
        "id": "supplier-remediation-exit.verify-recovery",
        "roleId": "tprm-programme-owner",
        "storyKey": "workblock.supplier-remediation.story.verify-recovery.story"
      },
      {
        "businessModuleId": "supplier-remediation-exit",
        "completionKey": "workblock.supplier-remediation.story.controlled-exit.completion",
        "executionFlowIds": [
          "plan-remediation-or-exit",
          "pursue-remediation",
          "orchestrate-exit",
          "read-remediation-exit"
        ],
        "id": "supplier-remediation-exit.controlled-exit",
        "roleId": "accountable-risk-owner",
        "storyKey": "workblock.supplier-remediation.story.controlled-exit.story"
      },
      {
        "businessModuleId": "guided-buying",
        "completionKey": "workblock.guided-buying.story.route-need.completion",
        "executionFlowIds": [
          "capture-need",
          "assemble-options",
          "route-request",
          "read-guided-buying"
        ],
        "id": "guided-buying.route-need",
        "roleId": "requester",
        "storyKey": "workblock.guided-buying.story.route-need.story"
      },
      {
        "businessModuleId": "guided-buying",
        "completionKey": "workblock.guided-buying.story.approve-with-context.completion",
        "executionFlowIds": [
          "capture-need",
          "assemble-options",
          "route-request",
          "read-guided-buying"
        ],
        "id": "guided-buying.approve-with-context",
        "roleId": "budget-owner",
        "storyKey": "workblock.guided-buying.story.approve-with-context.story"
      },
      {
        "businessModuleId": "guided-buying",
        "completionKey": "workblock.guided-buying.story.resolve-off-path.completion",
        "executionFlowIds": [
          "capture-need",
          "assemble-options",
          "route-request",
          "read-guided-buying"
        ],
        "id": "guided-buying.resolve-off-path",
        "roleId": "procurement-buyer",
        "storyKey": "workblock.guided-buying.story.resolve-off-path.story"
      },
      {
        "businessModuleId": "guided-buying",
        "completionKey": "workblock.guided-buying.story.fix-the-source.completion",
        "executionFlowIds": [
          "capture-need",
          "assemble-options",
          "route-request",
          "read-guided-buying"
        ],
        "id": "guided-buying.fix-the-source",
        "roleId": "procurement-buyer",
        "storyKey": "workblock.guided-buying.story.fix-the-source.story"
      },
      {
        "businessModuleId": "guided-buying",
        "completionKey": "workblock.guided-buying.story.one-write.completion",
        "executionFlowIds": [
          "capture-need",
          "assemble-options",
          "route-request",
          "read-guided-buying"
        ],
        "id": "guided-buying.one-write",
        "roleId": "procurement-buyer",
        "storyKey": "workblock.guided-buying.story.one-write.story"
      },
      {
        "businessModuleId": "requisition-policy-routing",
        "completionKey": "workblock.requisition-routing.story.validate-lines.completion",
        "executionFlowIds": [
          "build-requisition",
          "evaluate-and-route",
          "approve-and-publish",
          "read-requisition"
        ],
        "id": "requisition-policy-routing.validate-lines",
        "roleId": "procurement-buyer",
        "storyKey": "workblock.requisition-routing.story.validate-lines.story"
      },
      {
        "businessModuleId": "requisition-policy-routing",
        "completionKey": "workblock.requisition-routing.story.material-question.completion",
        "executionFlowIds": [
          "build-requisition",
          "evaluate-and-route",
          "approve-and-publish",
          "read-requisition"
        ],
        "id": "requisition-policy-routing.material-question",
        "roleId": "requester",
        "storyKey": "workblock.requisition-routing.story.material-question.story"
      },
      {
        "businessModuleId": "requisition-policy-routing",
        "completionKey": "workblock.requisition-routing.story.budget-authority.completion",
        "executionFlowIds": [
          "build-requisition",
          "evaluate-and-route",
          "approve-and-publish",
          "read-requisition"
        ],
        "id": "requisition-policy-routing.budget-authority",
        "roleId": "budget-owner",
        "storyKey": "workblock.requisition-routing.story.budget-authority.story"
      },
      {
        "businessModuleId": "requisition-policy-routing",
        "completionKey": "workblock.requisition-routing.story.commitment-input.completion",
        "executionFlowIds": [
          "build-requisition",
          "evaluate-and-route",
          "approve-and-publish",
          "read-requisition"
        ],
        "id": "requisition-policy-routing.commitment-input",
        "roleId": "procurement-buyer",
        "storyKey": "workblock.requisition-routing.story.commitment-input.story"
      },
      {
        "businessModuleId": "purchase-order-orchestration",
        "completionKey": "workblock.po-orchestration.story.precommit-check.completion",
        "executionFlowIds": [
          "prepare-order",
          "dispatch-and-reconcile",
          "process-responses",
          "read-order"
        ],
        "id": "purchase-order-orchestration.precommit-check",
        "roleId": "procurement-buyer",
        "storyKey": "workblock.po-orchestration.story.precommit-check.story"
      },
      {
        "businessModuleId": "purchase-order-orchestration",
        "completionKey": "workblock.po-orchestration.story.create-dispatch.completion",
        "executionFlowIds": [
          "prepare-order",
          "dispatch-and-reconcile",
          "process-responses",
          "read-order"
        ],
        "id": "purchase-order-orchestration.create-dispatch",
        "roleId": "integration-owner",
        "storyKey": "workblock.po-orchestration.story.create-dispatch.story"
      },
      {
        "businessModuleId": "purchase-order-orchestration",
        "completionKey": "workblock.po-orchestration.story.supplier-response.completion",
        "executionFlowIds": [
          "prepare-order",
          "dispatch-and-reconcile",
          "process-responses",
          "read-order"
        ],
        "id": "purchase-order-orchestration.supplier-response",
        "roleId": "procurement-buyer",
        "storyKey": "workblock.po-orchestration.story.supplier-response.story"
      },
      {
        "businessModuleId": "purchase-order-orchestration",
        "completionKey": "workblock.po-orchestration.story.state-reconciliation.completion",
        "executionFlowIds": [
          "prepare-order",
          "dispatch-and-reconcile",
          "process-responses",
          "read-order"
        ],
        "id": "purchase-order-orchestration.state-reconciliation",
        "roleId": "integration-owner",
        "storyKey": "workblock.po-orchestration.story.state-reconciliation.story"
      },
      {
        "businessModuleId": "purchase-order-exception",
        "completionKey": "workblock.po-exception.story.choose-correction.completion",
        "executionFlowIds": [
          "detect-exception",
          "diagnose-resolution",
          "resolve-and-reconcile",
          "read-order-exception"
        ],
        "id": "purchase-order-exception.choose-correction",
        "roleId": "procurement-buyer",
        "storyKey": "workblock.po-exception.story.choose-correction.story"
      },
      {
        "businessModuleId": "purchase-order-exception",
        "completionKey": "workblock.po-exception.story.reconcile-before-retry.completion",
        "executionFlowIds": [
          "detect-exception",
          "diagnose-resolution",
          "resolve-and-reconcile",
          "read-order-exception"
        ],
        "id": "purchase-order-exception.reconcile-before-retry",
        "roleId": "integration-owner",
        "storyKey": "workblock.po-exception.story.reconcile-before-retry.story"
      },
      {
        "businessModuleId": "purchase-order-exception",
        "completionKey": "workblock.po-exception.story.business-consequence.completion",
        "executionFlowIds": [
          "detect-exception",
          "diagnose-resolution",
          "resolve-and-reconcile",
          "read-order-exception"
        ],
        "id": "purchase-order-exception.business-consequence",
        "roleId": "requester",
        "storyKey": "workblock.po-exception.story.business-consequence.story"
      },
      {
        "businessModuleId": "purchase-order-exception",
        "completionKey": "workblock.po-exception.story.record-what-arrived.completion",
        "executionFlowIds": [
          "detect-exception",
          "diagnose-resolution",
          "resolve-and-reconcile",
          "read-order-exception"
        ],
        "id": "purchase-order-exception.record-what-arrived",
        "roleId": "receiver",
        "storyKey": "workblock.po-exception.story.record-what-arrived.story"
      },
      {
        "businessModuleId": "purchase-order-exception",
        "completionKey": "workblock.po-exception.story.clean-handoff.completion",
        "executionFlowIds": [
          "detect-exception",
          "diagnose-resolution",
          "resolve-and-reconcile",
          "read-order-exception"
        ],
        "id": "purchase-order-exception.clean-handoff",
        "roleId": "integration-owner",
        "storyKey": "workblock.po-exception.story.clean-handoff.story"
      },
      {
        "businessModuleId": "receiving-service-entry",
        "completionKey": "workblock.receiving.story.correlate-delivery.completion",
        "executionFlowIds": [
          "ingest-delivery",
          "evaluate-acceptance",
          "commit-and-reconcile",
          "pursue-recovery",
          "read-receiving"
        ],
        "id": "receiving-service-entry.correlate-delivery",
        "roleId": "receiver",
        "storyKey": "workblock.receiving.story.correlate-delivery.story"
      },
      {
        "businessModuleId": "receiving-service-entry",
        "completionKey": "workblock.receiving.story.quantity-condition.completion",
        "executionFlowIds": [
          "ingest-delivery",
          "evaluate-acceptance",
          "commit-and-reconcile",
          "pursue-recovery",
          "read-receiving"
        ],
        "id": "receiving-service-entry.quantity-condition",
        "roleId": "receiver",
        "storyKey": "workblock.receiving.story.quantity-condition.story"
      },
      {
        "businessModuleId": "receiving-service-entry",
        "completionKey": "workblock.receiving.story.service-acceptance.completion",
        "executionFlowIds": [
          "ingest-delivery",
          "evaluate-acceptance",
          "commit-and-reconcile",
          "pursue-recovery",
          "read-receiving"
        ],
        "id": "receiving-service-entry.service-acceptance",
        "roleId": "requester",
        "storyKey": "workblock.receiving.story.service-acceptance.story"
      },
      {
        "businessModuleId": "receiving-service-entry",
        "completionKey": "workblock.receiving.story.post-and-recover.completion",
        "executionFlowIds": [
          "ingest-delivery",
          "evaluate-acceptance",
          "commit-and-reconcile",
          "pursue-recovery",
          "read-receiving"
        ],
        "id": "receiving-service-entry.post-and-recover",
        "roleId": "receiver",
        "storyKey": "workblock.receiving.story.post-and-recover.story"
      },
      {
        "businessModuleId": "invoice-exception-triage",
        "completionKey": "workblock.invoice-triage.story.quantity-mismatch.completion",
        "executionFlowIds": [
          "refresh-exception-queue",
          "operate-exception",
          "read-exception-workspace",
          "evaluate-exception-policy"
        ],
        "id": "invoice-exception-triage.quantity-mismatch",
        "roleId": "ap-processor",
        "storyKey": "workblock.invoice-triage.story.quantity-mismatch.story"
      },
      {
        "businessModuleId": "invoice-exception-triage",
        "completionKey": "workblock.invoice-triage.story.missing-receipt.completion",
        "executionFlowIds": [
          "refresh-exception-queue",
          "operate-exception",
          "read-exception-workspace",
          "evaluate-exception-policy"
        ],
        "id": "invoice-exception-triage.missing-receipt",
        "roleId": "ap-processor",
        "storyKey": "workblock.invoice-triage.story.missing-receipt.story"
      },
      {
        "businessModuleId": "invoice-exception-triage",
        "completionKey": "workblock.invoice-triage.story.price-mismatch.completion",
        "executionFlowIds": [
          "refresh-exception-queue",
          "operate-exception",
          "read-exception-workspace",
          "evaluate-exception-policy"
        ],
        "id": "invoice-exception-triage.price-mismatch",
        "roleId": "ap-processor",
        "storyKey": "workblock.invoice-triage.story.price-mismatch.story"
      },
      {
        "businessModuleId": "invoice-exception-triage",
        "completionKey": "workblock.invoice-triage.story.duplicate-candidate.completion",
        "executionFlowIds": [
          "refresh-exception-queue",
          "operate-exception",
          "read-exception-workspace",
          "evaluate-exception-policy"
        ],
        "id": "invoice-exception-triage.duplicate-candidate",
        "roleId": "controller",
        "storyKey": "workblock.invoice-triage.story.duplicate-candidate.story"
      },
      {
        "businessModuleId": "invoice-exception-triage",
        "completionKey": "workblock.invoice-triage.story.approval-missing.completion",
        "executionFlowIds": [
          "refresh-exception-queue",
          "operate-exception",
          "read-exception-workspace",
          "evaluate-exception-policy"
        ],
        "id": "invoice-exception-triage.approval-missing",
        "roleId": "ap-processor",
        "storyKey": "workblock.invoice-triage.story.approval-missing.story"
      },
      {
        "businessModuleId": "payment-readiness",
        "completionKey": "workblock.payment.story.batch-review.completion",
        "executionFlowIds": [
          "assess-payment-readiness",
          "commit-payment-readiness",
          "read-readiness-control",
          "monitor-readiness-quality"
        ],
        "id": "payment-readiness.batch-review",
        "roleId": "payment-approver",
        "storyKey": "workblock.payment.story.batch-review.story"
      },
      {
        "businessModuleId": "payment-readiness",
        "completionKey": "workblock.payment.story.payee-change.completion",
        "executionFlowIds": [
          "assess-payment-readiness",
          "commit-payment-readiness",
          "read-readiness-control",
          "monitor-readiness-quality"
        ],
        "id": "payment-readiness.payee-change",
        "roleId": "controller",
        "storyKey": "workblock.payment.story.payee-change.story"
      },
      {
        "businessModuleId": "payment-readiness",
        "completionKey": "workblock.payment.story.stale-screening.completion",
        "executionFlowIds": [
          "assess-payment-readiness",
          "commit-payment-readiness",
          "read-readiness-control",
          "monitor-readiness-quality"
        ],
        "id": "payment-readiness.stale-screening",
        "roleId": "risk-owner",
        "storyKey": "workblock.payment.story.stale-screening.story"
      },
      {
        "businessModuleId": "payment-readiness",
        "completionKey": "workblock.payment.story.treasury-change.completion",
        "executionFlowIds": [
          "assess-payment-readiness",
          "commit-payment-readiness",
          "read-readiness-control",
          "monitor-readiness-quality"
        ],
        "id": "payment-readiness.treasury-change",
        "roleId": "treasury-manager",
        "storyKey": "workblock.payment.story.treasury-change.story"
      },
      {
        "businessModuleId": "payment-readiness",
        "completionKey": "workblock.payment.story.decision-handoff.completion",
        "executionFlowIds": [
          "assess-payment-readiness",
          "commit-payment-readiness",
          "read-readiness-control",
          "monitor-readiness-quality"
        ],
        "id": "payment-readiness.decision-handoff",
        "roleId": "payment-approver",
        "storyKey": "workblock.payment.story.decision-handoff.story"
      },
      {
        "businessModuleId": "invoice-intake-match",
        "completionKey": "workblock.invoice-match.story.channel-intake.completion",
        "executionFlowIds": [
          "ingest-invoice",
          "assess-invoice-match",
          "read-invoice-match",
          "evaluate-intake-match"
        ],
        "id": "invoice-intake-match.channel-intake",
        "roleId": "ap-processor",
        "storyKey": "workblock.invoice-match.story.channel-intake.story"
      },
      {
        "businessModuleId": "invoice-intake-match",
        "completionKey": "workblock.invoice-match.story.syntax-business-validation.completion",
        "executionFlowIds": [
          "ingest-invoice",
          "assess-invoice-match",
          "read-invoice-match",
          "evaluate-intake-match"
        ],
        "id": "invoice-intake-match.syntax-business-validation",
        "roleId": "ap-processor",
        "storyKey": "workblock.invoice-match.story.syntax-business-validation.story"
      },
      {
        "businessModuleId": "invoice-intake-match",
        "completionKey": "workblock.invoice-match.story.duplicate-conflict.completion",
        "executionFlowIds": [
          "ingest-invoice",
          "assess-invoice-match",
          "read-invoice-match",
          "evaluate-intake-match"
        ],
        "id": "invoice-intake-match.duplicate-conflict",
        "roleId": "risk-owner",
        "storyKey": "workblock.invoice-match.story.duplicate-conflict.story"
      },
      {
        "businessModuleId": "invoice-intake-match",
        "completionKey": "workblock.invoice-match.story.line-match.completion",
        "executionFlowIds": [
          "ingest-invoice",
          "assess-invoice-match",
          "read-invoice-match",
          "evaluate-intake-match"
        ],
        "id": "invoice-intake-match.line-match",
        "roleId": "ap-processor",
        "storyKey": "workblock.invoice-match.story.line-match.story"
      },
      {
        "businessModuleId": "invoice-intake-match",
        "completionKey": "workblock.invoice-match.story.publish-disposition.completion",
        "executionFlowIds": [
          "ingest-invoice",
          "assess-invoice-match",
          "read-invoice-match",
          "evaluate-intake-match"
        ],
        "id": "invoice-intake-match.publish-disposition",
        "roleId": "controller",
        "storyKey": "workblock.invoice-match.story.publish-disposition.story"
      },
      {
        "businessModuleId": "supplier-invoice-resolution",
        "completionKey": "workblock.invoice-resolution.story.precise-request.completion",
        "executionFlowIds": [
          "open-supplier-resolution",
          "continue-supplier-resolution",
          "read-supplier-resolution",
          "evaluate-resolution-quality"
        ],
        "id": "supplier-invoice-resolution.precise-request",
        "roleId": "ap-processor",
        "storyKey": "workblock.invoice-resolution.story.precise-request.story"
      },
      {
        "businessModuleId": "supplier-invoice-resolution",
        "completionKey": "workblock.invoice-resolution.story.approved-exchange.completion",
        "executionFlowIds": [
          "open-supplier-resolution",
          "continue-supplier-resolution",
          "read-supplier-resolution",
          "evaluate-resolution-quality"
        ],
        "id": "supplier-invoice-resolution.approved-exchange",
        "roleId": "ap-processor",
        "storyKey": "workblock.invoice-resolution.story.approved-exchange.story"
      },
      {
        "businessModuleId": "supplier-invoice-resolution",
        "completionKey": "workblock.invoice-resolution.story.response-commitment.completion",
        "executionFlowIds": [
          "open-supplier-resolution",
          "continue-supplier-resolution",
          "read-supplier-resolution",
          "evaluate-resolution-quality"
        ],
        "id": "supplier-invoice-resolution.response-commitment",
        "roleId": "ap-processor",
        "storyKey": "workblock.invoice-resolution.story.response-commitment.story"
      },
      {
        "businessModuleId": "supplier-invoice-resolution",
        "completionKey": "workblock.invoice-resolution.story.interpret-evidence.completion",
        "executionFlowIds": [
          "open-supplier-resolution",
          "continue-supplier-resolution",
          "read-supplier-resolution",
          "evaluate-resolution-quality"
        ],
        "id": "supplier-invoice-resolution.interpret-evidence",
        "roleId": "controller",
        "storyKey": "workblock.invoice-resolution.story.interpret-evidence.story"
      },
      {
        "businessModuleId": "supplier-invoice-resolution",
        "completionKey": "workblock.invoice-resolution.story.reconcile-resolution.completion",
        "executionFlowIds": [
          "open-supplier-resolution",
          "continue-supplier-resolution",
          "read-supplier-resolution",
          "evaluate-resolution-quality"
        ],
        "id": "supplier-invoice-resolution.reconcile-resolution",
        "roleId": "controller",
        "storyKey": "workblock.invoice-resolution.story.reconcile-resolution.story"
      },
      {
        "businessModuleId": "payment-execution-guard",
        "completionKey": "workblock.payment-guard.story.final-validation.completion",
        "executionFlowIds": [
          "propose-payment-instruction",
          "commit-and-submit-payment",
          "reconcile-payment-status",
          "read-payment-guard"
        ],
        "id": "payment-execution-guard.final-validation",
        "roleId": "payment-approver",
        "storyKey": "workblock.payment-guard.story.final-validation.story"
      },
      {
        "businessModuleId": "payment-execution-guard",
        "completionKey": "workblock.payment-guard.story.duplicate-prevention.completion",
        "executionFlowIds": [
          "propose-payment-instruction",
          "commit-and-submit-payment",
          "reconcile-payment-status",
          "read-payment-guard"
        ],
        "id": "payment-execution-guard.duplicate-prevention",
        "roleId": "risk-owner",
        "storyKey": "workblock.payment-guard.story.duplicate-prevention.story"
      },
      {
        "businessModuleId": "payment-execution-guard",
        "completionKey": "workblock.payment-guard.story.in-envelope-submit.completion",
        "executionFlowIds": [
          "propose-payment-instruction",
          "commit-and-submit-payment",
          "reconcile-payment-status",
          "read-payment-guard"
        ],
        "id": "payment-execution-guard.in-envelope-submit",
        "roleId": "treasury-manager",
        "storyKey": "workblock.payment-guard.story.in-envelope-submit.story"
      },
      {
        "businessModuleId": "payment-execution-guard",
        "completionKey": "workblock.payment-guard.story.track-outcome.completion",
        "executionFlowIds": [
          "propose-payment-instruction",
          "commit-and-submit-payment",
          "reconcile-payment-status",
          "read-payment-guard"
        ],
        "id": "payment-execution-guard.track-outcome",
        "roleId": "treasury-manager",
        "storyKey": "workblock.payment-guard.story.track-outcome.story"
      },
      {
        "businessModuleId": "payment-execution-guard",
        "completionKey": "workblock.payment-guard.story.reconcile-recovery.completion",
        "executionFlowIds": [
          "propose-payment-instruction",
          "commit-and-submit-payment",
          "reconcile-payment-status",
          "read-payment-guard"
        ],
        "id": "payment-execution-guard.reconcile-recovery",
        "roleId": "controller",
        "storyKey": "workblock.payment-guard.story.reconcile-recovery.story"
      },
      {
        "businessModuleId": "supplier-performance-review",
        "completionKey": "workblock.performance.story.prepare-pack.completion",
        "executionFlowIds": [
          "prepare-supplier-review",
          "commit-supplier-review",
          "read-supplier-review",
          "evaluate-review-outcomes"
        ],
        "id": "supplier-performance-review.prepare-pack",
        "roleId": "relationship-manager",
        "storyKey": "workblock.performance.story.prepare-pack.story"
      },
      {
        "businessModuleId": "supplier-performance-review",
        "completionKey": "workblock.performance.story.critical-event.completion",
        "executionFlowIds": [
          "prepare-supplier-review",
          "commit-supplier-review",
          "read-supplier-review",
          "evaluate-review-outcomes"
        ],
        "id": "supplier-performance-review.critical-event",
        "roleId": "relationship-manager",
        "storyKey": "workblock.performance.story.critical-event.story"
      },
      {
        "businessModuleId": "supplier-performance-review",
        "completionKey": "workblock.performance.story.reproduce-score.completion",
        "executionFlowIds": [
          "prepare-supplier-review",
          "commit-supplier-review",
          "read-supplier-review",
          "evaluate-review-outcomes"
        ],
        "id": "supplier-performance-review.reproduce-score",
        "roleId": "metric-owner",
        "storyKey": "workblock.performance.story.reproduce-score.story"
      },
      {
        "businessModuleId": "supplier-performance-review",
        "completionKey": "workblock.performance.story.accept-commitment.completion",
        "executionFlowIds": [
          "prepare-supplier-review",
          "commit-supplier-review",
          "read-supplier-review",
          "evaluate-review-outcomes"
        ],
        "id": "supplier-performance-review.accept-commitment",
        "roleId": "supplier-account-lead",
        "storyKey": "workblock.performance.story.accept-commitment.story"
      },
      {
        "businessModuleId": "supplier-performance-review",
        "completionKey": "workblock.performance.story.verify-closure.completion",
        "executionFlowIds": [
          "prepare-supplier-review",
          "commit-supplier-review",
          "read-supplier-review",
          "evaluate-review-outcomes"
        ],
        "id": "supplier-performance-review.verify-closure",
        "roleId": "relationship-manager",
        "storyKey": "workblock.performance.story.verify-closure.story"
      },
      {
        "businessModuleId": "supplier-performance-review",
        "completionKey": "workblock.performance.story.carry-handoff.completion",
        "executionFlowIds": [
          "prepare-supplier-review",
          "commit-supplier-review",
          "read-supplier-review",
          "evaluate-review-outcomes"
        ],
        "id": "supplier-performance-review.carry-handoff",
        "roleId": "relationship-manager",
        "storyKey": "workblock.performance.story.carry-handoff.story"
      },
      {
        "businessModuleId": "supplier-innovation-pipeline",
        "completionKey": "workblock.innovation.story.capture-idea.completion",
        "executionFlowIds": [
          "intake-innovation-case",
          "operate-innovation-gate",
          "monitor-innovation-experiment",
          "read-innovation-pipeline"
        ],
        "id": "supplier-innovation-pipeline.capture-idea",
        "roleId": "relationship-manager",
        "storyKey": "workblock.innovation.story.capture-idea.story"
      },
      {
        "businessModuleId": "supplier-innovation-pipeline",
        "completionKey": "workblock.innovation.story.attach-sponsor.completion",
        "executionFlowIds": [
          "intake-innovation-case",
          "operate-innovation-gate",
          "monitor-innovation-experiment",
          "read-innovation-pipeline"
        ],
        "id": "supplier-innovation-pipeline.attach-sponsor",
        "roleId": "innovation-sponsor",
        "storyKey": "workblock.innovation.story.attach-sponsor.story"
      },
      {
        "businessModuleId": "supplier-innovation-pipeline",
        "completionKey": "workblock.innovation.story.bound-stage.completion",
        "executionFlowIds": [
          "intake-innovation-case",
          "operate-innovation-gate",
          "monitor-innovation-experiment",
          "read-innovation-pipeline"
        ],
        "id": "supplier-innovation-pipeline.bound-stage",
        "roleId": "innovation-sponsor",
        "storyKey": "workblock.innovation.story.bound-stage.story"
      },
      {
        "businessModuleId": "supplier-innovation-pipeline",
        "completionKey": "workblock.innovation.story.answer-supplier.completion",
        "executionFlowIds": [
          "intake-innovation-case",
          "operate-innovation-gate",
          "monitor-innovation-experiment",
          "read-innovation-pipeline"
        ],
        "id": "supplier-innovation-pipeline.answer-supplier",
        "roleId": "supplier-account-lead",
        "storyKey": "workblock.innovation.story.answer-supplier.story"
      },
      {
        "businessModuleId": "supplier-innovation-pipeline",
        "completionKey": "workblock.innovation.story.separate-value.completion",
        "executionFlowIds": [
          "intake-innovation-case",
          "operate-innovation-gate",
          "monitor-innovation-experiment",
          "read-innovation-pipeline"
        ],
        "id": "supplier-innovation-pipeline.separate-value",
        "roleId": "innovation-sponsor",
        "storyKey": "workblock.innovation.story.separate-value.story"
      },
      {
        "businessModuleId": "supplier-segmentation-governance",
        "completionKey": "workblock.supplier-segmentation.story.current-segment.completion",
        "executionFlowIds": [
          "refresh-segmentation",
          "commit-segment-assignment",
          "read-segmentation-governance",
          "evaluate-segmentation"
        ],
        "id": "supplier-segmentation-governance.current-segment",
        "roleId": "relationship-manager",
        "storyKey": "workblock.supplier-segmentation.story.current-segment.story"
      },
      {
        "businessModuleId": "supplier-segmentation-governance",
        "completionKey": "workblock.supplier-segmentation.story.change-signal.completion",
        "executionFlowIds": [
          "refresh-segmentation",
          "commit-segment-assignment",
          "read-segmentation-governance",
          "evaluate-segmentation"
        ],
        "id": "supplier-segmentation-governance.change-signal",
        "roleId": "metric-owner",
        "storyKey": "workblock.supplier-segmentation.story.change-signal.story"
      },
      {
        "businessModuleId": "supplier-segmentation-governance",
        "completionKey": "workblock.supplier-segmentation.story.routine-resegment.completion",
        "executionFlowIds": [
          "refresh-segmentation",
          "commit-segment-assignment",
          "read-segmentation-governance",
          "evaluate-segmentation"
        ],
        "id": "supplier-segmentation-governance.routine-resegment",
        "roleId": "governance-owner",
        "storyKey": "workblock.supplier-segmentation.story.routine-resegment.story"
      },
      {
        "businessModuleId": "supplier-segmentation-governance",
        "completionKey": "workblock.supplier-segmentation.story.material-assignment.completion",
        "executionFlowIds": [
          "refresh-segmentation",
          "commit-segment-assignment",
          "read-segmentation-governance",
          "evaluate-segmentation"
        ],
        "id": "supplier-segmentation-governance.material-assignment",
        "roleId": "governance-owner",
        "storyKey": "workblock.supplier-segmentation.story.material-assignment.story"
      },
      {
        "businessModuleId": "supplier-segmentation-governance",
        "completionKey": "workblock.supplier-segmentation.story.propagate-treatment.completion",
        "executionFlowIds": [
          "refresh-segmentation",
          "commit-segment-assignment",
          "read-segmentation-governance",
          "evaluate-segmentation"
        ],
        "id": "supplier-segmentation-governance.propagate-treatment",
        "roleId": "relationship-manager",
        "storyKey": "workblock.supplier-segmentation.story.propagate-treatment.story"
      },
      {
        "businessModuleId": "supplier-performance-monitor-correct",
        "completionKey": "workblock.performance-monitor.story.atomic-observations.completion",
        "executionFlowIds": [
          "ingest-performance-observations",
          "detect-performance-signals",
          "operate-corrective-action",
          "read-performance-control"
        ],
        "id": "supplier-performance-monitor-correct.atomic-observations",
        "roleId": "metric-owner",
        "storyKey": "workblock.performance-monitor.story.atomic-observations.story"
      },
      {
        "businessModuleId": "supplier-performance-monitor-correct",
        "completionKey": "workblock.performance-monitor.story.detect-change.completion",
        "executionFlowIds": [
          "ingest-performance-observations",
          "detect-performance-signals",
          "operate-corrective-action",
          "read-performance-control"
        ],
        "id": "supplier-performance-monitor-correct.detect-change",
        "roleId": "relationship-manager",
        "storyKey": "workblock.performance-monitor.story.detect-change.story"
      },
      {
        "businessModuleId": "supplier-performance-monitor-correct",
        "completionKey": "workblock.performance-monitor.story.quality-or-performance.completion",
        "executionFlowIds": [
          "ingest-performance-observations",
          "detect-performance-signals",
          "operate-corrective-action",
          "read-performance-control"
        ],
        "id": "supplier-performance-monitor-correct.quality-or-performance",
        "roleId": "metric-owner",
        "storyKey": "workblock.performance-monitor.story.quality-or-performance.story"
      },
      {
        "businessModuleId": "supplier-performance-monitor-correct",
        "completionKey": "workblock.performance-monitor.story.corrective-action.completion",
        "executionFlowIds": [
          "ingest-performance-observations",
          "detect-performance-signals",
          "operate-corrective-action",
          "read-performance-control"
        ],
        "id": "supplier-performance-monitor-correct.corrective-action",
        "roleId": "governance-owner",
        "storyKey": "workblock.performance-monitor.story.corrective-action.story"
      },
      {
        "businessModuleId": "supplier-performance-monitor-correct",
        "completionKey": "workblock.performance-monitor.story.sustained-recovery.completion",
        "executionFlowIds": [
          "ingest-performance-observations",
          "detect-performance-signals",
          "operate-corrective-action",
          "read-performance-control"
        ],
        "id": "supplier-performance-monitor-correct.sustained-recovery",
        "roleId": "relationship-manager",
        "storyKey": "workblock.performance-monitor.story.sustained-recovery.story"
      },
      {
        "businessModuleId": "supplier-relationship-joint-value",
        "completionKey": "workblock.relationship-value.story.mutual-objectives.completion",
        "executionFlowIds": [
          "prepare-joint-value-plan",
          "commit-and-operate-joint-plan",
          "prepare-relationship-governance",
          "read-joint-value-workspace"
        ],
        "id": "supplier-relationship-joint-value.mutual-objectives",
        "roleId": "relationship-manager",
        "storyKey": "workblock.relationship-value.story.mutual-objectives.story"
      },
      {
        "businessModuleId": "supplier-relationship-joint-value",
        "completionKey": "workblock.relationship-value.story.governance-cadence.completion",
        "executionFlowIds": [
          "prepare-joint-value-plan",
          "commit-and-operate-joint-plan",
          "prepare-relationship-governance",
          "read-joint-value-workspace"
        ],
        "id": "supplier-relationship-joint-value.governance-cadence",
        "roleId": "supplier-account-lead",
        "storyKey": "workblock.relationship-value.story.governance-cadence.story"
      },
      {
        "businessModuleId": "supplier-relationship-joint-value",
        "completionKey": "workblock.relationship-value.story.cross-functional-actions.completion",
        "executionFlowIds": [
          "prepare-joint-value-plan",
          "commit-and-operate-joint-plan",
          "prepare-relationship-governance",
          "read-joint-value-workspace"
        ],
        "id": "supplier-relationship-joint-value.cross-functional-actions",
        "roleId": "governance-owner",
        "storyKey": "workblock.relationship-value.story.cross-functional-actions.story"
      },
      {
        "businessModuleId": "supplier-relationship-joint-value",
        "completionKey": "workblock.relationship-value.story.connected-plan.completion",
        "executionFlowIds": [
          "prepare-joint-value-plan",
          "commit-and-operate-joint-plan",
          "prepare-relationship-governance",
          "read-joint-value-workspace"
        ],
        "id": "supplier-relationship-joint-value.connected-plan",
        "roleId": "metric-owner",
        "storyKey": "workblock.relationship-value.story.connected-plan.story"
      },
      {
        "businessModuleId": "supplier-relationship-joint-value",
        "completionKey": "workblock.relationship-value.story.adapt-next-plan.completion",
        "executionFlowIds": [
          "prepare-joint-value-plan",
          "commit-and-operate-joint-plan",
          "prepare-relationship-governance",
          "read-joint-value-workspace"
        ],
        "id": "supplier-relationship-joint-value.adapt-next-plan",
        "roleId": "innovation-sponsor",
        "storyKey": "workblock.relationship-value.story.adapt-next-plan.story"
      },
      {
        "businessModuleId": "savings-initiative",
        "completionKey": "workblock.savings.story.qualify-opportunity.completion",
        "executionFlowIds": [
          "create-savings-initiative",
          "operate-savings-initiative",
          "read-savings-portfolio",
          "evaluate-initiative-outcomes"
        ],
        "id": "savings-initiative.qualify-opportunity",
        "roleId": "value-lead",
        "storyKey": "workblock.savings.story.qualify-opportunity.story"
      },
      {
        "businessModuleId": "savings-initiative",
        "completionKey": "workblock.savings.story.agree-method.completion",
        "executionFlowIds": [
          "create-savings-initiative",
          "operate-savings-initiative",
          "read-savings-portfolio",
          "evaluate-initiative-outcomes"
        ],
        "id": "savings-initiative.agree-method",
        "roleId": "finance-delegate",
        "storyKey": "workblock.savings.story.agree-method.story"
      },
      {
        "businessModuleId": "savings-initiative",
        "completionKey": "workblock.savings.story.carry-award.completion",
        "executionFlowIds": [
          "create-savings-initiative",
          "operate-savings-initiative",
          "read-savings-portfolio",
          "evaluate-initiative-outcomes"
        ],
        "id": "savings-initiative.carry-award",
        "roleId": "category-manager",
        "storyKey": "workblock.savings.story.carry-award.story"
      },
      {
        "businessModuleId": "savings-initiative",
        "completionKey": "workblock.savings.story.validate-result.completion",
        "executionFlowIds": [
          "create-savings-initiative",
          "operate-savings-initiative",
          "read-savings-portfolio",
          "evaluate-initiative-outcomes"
        ],
        "id": "savings-initiative.validate-result",
        "roleId": "finance-delegate",
        "storyKey": "workblock.savings.story.validate-result.story"
      },
      {
        "businessModuleId": "savings-initiative",
        "completionKey": "workblock.savings.story.restate-result.completion",
        "executionFlowIds": [
          "create-savings-initiative",
          "operate-savings-initiative",
          "read-savings-portfolio",
          "evaluate-initiative-outcomes"
        ],
        "id": "savings-initiative.restate-result",
        "roleId": "value-lead",
        "storyKey": "workblock.savings.story.restate-result.story"
      },
      {
        "businessModuleId": "value-leakage-monitor",
        "completionKey": "workblock.leakage.story.confirm-variance.completion",
        "executionFlowIds": [
          "detect-value-leakage",
          "operate-leakage-recovery",
          "read-leakage-control",
          "evaluate-leakage-policy"
        ],
        "id": "value-leakage-monitor.confirm-variance",
        "roleId": "value-lead",
        "storyKey": "workblock.leakage.story.confirm-variance.story"
      },
      {
        "businessModuleId": "value-leakage-monitor",
        "completionKey": "workblock.leakage.story.test-causes.completion",
        "executionFlowIds": [
          "detect-value-leakage",
          "operate-leakage-recovery",
          "read-leakage-control",
          "evaluate-leakage-policy"
        ],
        "id": "value-leakage-monitor.test-causes",
        "roleId": "finance-delegate",
        "storyKey": "workblock.leakage.story.test-causes.story"
      },
      {
        "businessModuleId": "value-leakage-monitor",
        "completionKey": "workblock.leakage.story.own-the-response.completion",
        "executionFlowIds": [
          "detect-value-leakage",
          "operate-leakage-recovery",
          "read-leakage-control",
          "evaluate-leakage-policy"
        ],
        "id": "value-leakage-monitor.own-the-response",
        "roleId": "budget-owner",
        "storyKey": "workblock.leakage.story.own-the-response.story"
      },
      {
        "businessModuleId": "value-leakage-monitor",
        "completionKey": "workblock.leakage.story.source-acceptance.completion",
        "executionFlowIds": [
          "detect-value-leakage",
          "operate-leakage-recovery",
          "read-leakage-control",
          "evaluate-leakage-policy"
        ],
        "id": "value-leakage-monitor.source-acceptance",
        "roleId": "category-manager",
        "storyKey": "workblock.leakage.story.source-acceptance.story"
      },
      {
        "businessModuleId": "value-leakage-monitor",
        "completionKey": "workblock.leakage.story.remeasure.completion",
        "executionFlowIds": [
          "detect-value-leakage",
          "operate-leakage-recovery",
          "read-leakage-control",
          "evaluate-leakage-policy"
        ],
        "id": "value-leakage-monitor.remeasure",
        "roleId": "value-lead",
        "storyKey": "workblock.leakage.story.remeasure.story"
      },
      {
        "businessModuleId": "value-opportunity-baseline",
        "completionKey": "workblock.value-baseline.story.qualify-opportunity.completion",
        "executionFlowIds": [
          "qualify-value-opportunity",
          "calculate-value-baseline",
          "commit-value-baseline",
          "read-value-baseline"
        ],
        "id": "value-opportunity-baseline.qualify-opportunity",
        "roleId": "value-lead",
        "storyKey": "workblock.value-baseline.story.qualify-opportunity.story"
      },
      {
        "businessModuleId": "value-opportunity-baseline",
        "completionKey": "workblock.value-baseline.story.counterfactual-scope.completion",
        "executionFlowIds": [
          "qualify-value-opportunity",
          "calculate-value-baseline",
          "commit-value-baseline",
          "read-value-baseline"
        ],
        "id": "value-opportunity-baseline.counterfactual-scope",
        "roleId": "category-manager",
        "storyKey": "workblock.value-baseline.story.counterfactual-scope.story"
      },
      {
        "businessModuleId": "value-opportunity-baseline",
        "completionKey": "workblock.value-baseline.story.calculate-baseline.completion",
        "executionFlowIds": [
          "qualify-value-opportunity",
          "calculate-value-baseline",
          "commit-value-baseline",
          "read-value-baseline"
        ],
        "id": "value-opportunity-baseline.calculate-baseline",
        "roleId": "finance-delegate",
        "storyKey": "workblock.value-baseline.story.calculate-baseline.story"
      },
      {
        "businessModuleId": "value-opportunity-baseline",
        "completionKey": "workblock.value-baseline.story.assumption-sensitivity.completion",
        "executionFlowIds": [
          "qualify-value-opportunity",
          "calculate-value-baseline",
          "commit-value-baseline",
          "read-value-baseline"
        ],
        "id": "value-opportunity-baseline.assumption-sensitivity",
        "roleId": "value-lead",
        "storyKey": "workblock.value-baseline.story.assumption-sensitivity.story"
      },
      {
        "businessModuleId": "value-opportunity-baseline",
        "completionKey": "workblock.value-baseline.story.commit-measurement.completion",
        "executionFlowIds": [
          "qualify-value-opportunity",
          "calculate-value-baseline",
          "commit-value-baseline",
          "read-value-baseline"
        ],
        "id": "value-opportunity-baseline.commit-measurement",
        "roleId": "finance-delegate",
        "storyKey": "workblock.value-baseline.story.commit-measurement.story"
      },
      {
        "businessModuleId": "realization-reconciliation-attribution",
        "completionKey": "workblock.realization-reconciliation.story.assemble-actuals.completion",
        "executionFlowIds": [
          "reconcile-value-actuals",
          "commit-realization-attribution",
          "read-realization-control",
          "evaluate-attribution-method"
        ],
        "id": "realization-reconciliation-attribution.assemble-actuals",
        "roleId": "value-lead",
        "storyKey": "workblock.realization-reconciliation.story.assemble-actuals.story"
      },
      {
        "businessModuleId": "realization-reconciliation-attribution",
        "completionKey": "workblock.realization-reconciliation.story.normalise-effects.completion",
        "executionFlowIds": [
          "reconcile-value-actuals",
          "commit-realization-attribution",
          "read-realization-control",
          "evaluate-attribution-method"
        ],
        "id": "realization-reconciliation-attribution.normalise-effects",
        "roleId": "finance-delegate",
        "storyKey": "workblock.realization-reconciliation.story.normalise-effects.story"
      },
      {
        "businessModuleId": "realization-reconciliation-attribution",
        "completionKey": "workblock.realization-reconciliation.story.attribute-value.completion",
        "executionFlowIds": [
          "reconcile-value-actuals",
          "commit-realization-attribution",
          "read-realization-control",
          "evaluate-attribution-method"
        ],
        "id": "realization-reconciliation-attribution.attribute-value",
        "roleId": "finance-delegate",
        "storyKey": "workblock.realization-reconciliation.story.attribute-value.story"
      },
      {
        "businessModuleId": "realization-reconciliation-attribution",
        "completionKey": "workblock.realization-reconciliation.story.prevent-overlap.completion",
        "executionFlowIds": [
          "reconcile-value-actuals",
          "commit-realization-attribution",
          "read-realization-control",
          "evaluate-attribution-method"
        ],
        "id": "realization-reconciliation-attribution.prevent-overlap",
        "roleId": "value-lead",
        "storyKey": "workblock.realization-reconciliation.story.prevent-overlap.story"
      },
      {
        "businessModuleId": "realization-reconciliation-attribution",
        "completionKey": "workblock.realization-reconciliation.story.commit-reconcile.completion",
        "executionFlowIds": [
          "reconcile-value-actuals",
          "commit-realization-attribution",
          "read-realization-control",
          "evaluate-attribution-method"
        ],
        "id": "realization-reconciliation-attribution.commit-reconcile",
        "roleId": "finance-delegate",
        "storyKey": "workblock.realization-reconciliation.story.commit-reconcile.story"
      },
      {
        "businessModuleId": "value-portfolio-forecast",
        "completionKey": "workblock.value-portfolio.story.current-forecast.completion",
        "executionFlowIds": [
          "refresh-value-forecast",
          "analyse-portfolio-variance",
          "operate-portfolio-intervention",
          "read-value-portfolio"
        ],
        "id": "value-portfolio-forecast.current-forecast",
        "roleId": "value-lead",
        "storyKey": "workblock.value-portfolio.story.current-forecast.story"
      },
      {
        "businessModuleId": "value-portfolio-forecast",
        "completionKey": "workblock.value-portfolio.story.movement-bridge.completion",
        "executionFlowIds": [
          "refresh-value-forecast",
          "analyse-portfolio-variance",
          "operate-portfolio-intervention",
          "read-value-portfolio"
        ],
        "id": "value-portfolio-forecast.movement-bridge",
        "roleId": "finance-delegate",
        "storyKey": "workblock.value-portfolio.story.movement-bridge.story"
      },
      {
        "businessModuleId": "value-portfolio-forecast",
        "completionKey": "workblock.value-portfolio.story.scenario-range.completion",
        "executionFlowIds": [
          "refresh-value-forecast",
          "analyse-portfolio-variance",
          "operate-portfolio-intervention",
          "read-value-portfolio"
        ],
        "id": "value-portfolio-forecast.scenario-range",
        "roleId": "value-lead",
        "storyKey": "workblock.value-portfolio.story.scenario-range.story"
      },
      {
        "businessModuleId": "value-portfolio-forecast",
        "completionKey": "workblock.value-portfolio.story.portfolio-risk.completion",
        "executionFlowIds": [
          "refresh-value-forecast",
          "analyse-portfolio-variance",
          "operate-portfolio-intervention",
          "read-value-portfolio"
        ],
        "id": "value-portfolio-forecast.portfolio-risk",
        "roleId": "budget-owner",
        "storyKey": "workblock.value-portfolio.story.portfolio-risk.story"
      },
      {
        "businessModuleId": "value-portfolio-forecast",
        "completionKey": "workblock.value-portfolio.story.track-intervention.completion",
        "executionFlowIds": [
          "refresh-value-forecast",
          "analyse-portfolio-variance",
          "operate-portfolio-intervention",
          "read-value-portfolio"
        ],
        "id": "value-portfolio-forecast.track-intervention",
        "roleId": "category-manager",
        "storyKey": "workblock.value-portfolio.story.track-intervention.story"
      },
      {
        "businessModuleId": "value-portfolio-forecast",
        "completionKey": "workblock.value-portfolio.story.margin-tradeoff.completion",
        "executionFlowIds": [
          "arbitrate-margin-tradeoffs"
        ],
        "id": "value-portfolio-forecast.margin-tradeoff",
        "roleId": "value-lead",
        "storyKey": "workblock.value-portfolio.story.margin-tradeoff.story"
      },
      {
        "businessModuleId": "policy-rule-lifecycle",
        "completionKey": "workblock.policy-lifecycle.story.channel-drift.completion",
        "executionFlowIds": [
          "monitor-channel-drift"
        ],
        "id": "policy-rule-lifecycle.channel-drift",
        "roleId": "policy-owner",
        "storyKey": "workblock.policy-lifecycle.story.channel-drift.story"
      },
      {
        "businessModuleId": "guided-buying",
        "completionKey": "workblock.guided-buying.story.catalogue-coverage.completion",
        "executionFlowIds": [
          "assess-catalogue-coverage"
        ],
        "id": "guided-buying.catalogue-coverage",
        "roleId": "procurement-buyer",
        "storyKey": "workblock.guided-buying.story.catalogue-coverage.story"
      },
      {
        "businessModuleId": "tactical-sourcing-autonomy",
        "completionKey": "workblock.tactical-sourcing.story.spot-buy-conversion.completion",
        "executionFlowIds": [
          "convert-repeat-spot-buys"
        ],
        "id": "tactical-sourcing-autonomy.spot-buy-conversion",
        "roleId": "sourcing-lead",
        "storyKey": "workblock.tactical-sourcing.story.spot-buy-conversion.story"
      },
      {
        "businessModuleId": "payment-readiness",
        "completionKey": "workblock.payment.story.payment-terms.completion",
        "executionFlowIds": [
          "assess-payment-terms-position"
        ],
        "id": "payment-readiness.payment-terms",
        "roleId": "treasury-manager",
        "storyKey": "workblock.payment.story.payment-terms.story"
      },
      {
        "businessModuleId": "value-leakage-monitor",
        "completionKey": "workblock.leakage.story.price-variance.completion",
        "executionFlowIds": [
          "detect-off-contract-price-variance"
        ],
        "id": "value-leakage-monitor.price-variance",
        "roleId": "value-lead",
        "storyKey": "workblock.leakage.story.price-variance.story"
      }
    ],
    "lakeProjections": [
      {
        "definitionVersion": "0.5.0",
        "deletionPolicy": "Propagate governed deletion and legal-hold state without deleting immutable audit evidence outside its retention policy.",
        "drillThroughQueryIds": [
          "query-spend-data-foundation-read-spend-record",
          "query-spend-data-foundation-read-spend-classification-decision",
          "query-spend-data-foundation-read-taxonomy-version",
          "query-spend-data-foundation-read-category-dimension-assignment",
          "query-category-opportunity-radar-read-category-opportunity",
          "query-category-opportunity-radar-read-spend-record",
          "query-category-opportunity-radar-read-business-unit",
          "query-category-opportunity-radar-read-category",
          "query-category-opportunity-radar-read-source-record-reference",
          "query-category-opportunity-radar-read-evidence-item",
          "query-category-opportunity-radar-read-authority-envelope",
          "query-category-opportunity-radar-read-learning-example",
          "query-category-opportunity-radar-read-evaluation-result",
          "query-category-opportunity-radar-read-integration-state",
          "query-category-opportunity-radar-read-tail-spend-evaluation",
          "query-category-strategy-orchestrator-read-category-strategy",
          "query-category-strategy-orchestrator-read-category-opportunity",
          "query-category-strategy-orchestrator-read-spend-record",
          "query-category-strategy-orchestrator-read-tail-spend-evaluation",
          "query-policy-rule-lifecycle-read-policy-rule-release",
          "query-policy-rule-lifecycle-read-tail-spend-rule",
          "query-policy-rule-lifecycle-read-policy-guidance-result",
          "query-policy-guidance-read-policy-guidance-result",
          "query-policy-guidance-read-policy-rule-release",
          "query-policy-guidance-read-evidence-item",
          "query-policy-guidance-read-policy",
          "query-policy-guidance-read-policy-version",
          "query-policy-guidance-read-exception",
          "query-policy-guidance-read-registry-release",
          "query-policy-guidance-read-tail-spend-evaluation",
          "query-procurement-service-catalogue-read-procurement-service-offering",
          "query-procurement-service-catalogue-read-policy-rule-release",
          "query-intelligent-intake-read-intake-request",
          "query-intelligent-intake-read-procurement-service-offering",
          "query-intelligent-intake-read-person",
          "query-intelligent-intake-read-business-unit",
          "query-intelligent-intake-read-category",
          "query-intelligent-intake-read-item-service",
          "query-intelligent-intake-read-source-record-reference",
          "query-intelligent-intake-read-policy",
          "query-intelligent-intake-read-policy-version",
          "query-intelligent-intake-read-authority-envelope",
          "query-intelligent-intake-read-learning-example",
          "query-intelligent-intake-read-evaluation-result",
          "query-intelligent-intake-read-integration-state",
          "query-intelligent-intake-read-budget",
          "query-request-enrichment-routing-read-enriched-request",
          "query-request-enrichment-routing-read-intake-request",
          "query-request-enrichment-routing-read-policy-guidance-result",
          "query-demand-orchestration-read-demand-case",
          "query-demand-orchestration-read-intake-request",
          "query-demand-orchestration-read-enriched-request",
          "query-demand-orchestration-read-person",
          "query-demand-orchestration-read-authority-envelope",
          "query-demand-orchestration-read-action-proposal",
          "query-demand-orchestration-read-committed-action",
          "query-demand-orchestration-read-decision",
          "query-demand-orchestration-read-exception",
          "query-demand-orchestration-read-audit-event",
          "query-demand-orchestration-read-business-event",
          "query-demand-orchestration-read-integration-state",
          "query-demand-orchestration-read-registry-release",
          "query-demand-consolidation-portfolio-read-demand-portfolio",
          "query-demand-consolidation-portfolio-read-demand-case",
          "query-sourcing-pipeline-discovery-read-sourcing-opportunity",
          "query-sourcing-pipeline-discovery-read-category-opportunity",
          "query-sourcing-pipeline-discovery-read-demand-portfolio",
          "query-sourcing-pipeline-discovery-read-category-strategy-downstream",
          "query-sourcing-event-read-sourcing-event-record",
          "query-sourcing-event-read-sourcing-opportunity",
          "query-sourcing-event-read-party",
          "query-sourcing-event-read-person",
          "query-sourcing-event-read-category",
          "query-sourcing-event-read-item-service",
          "query-sourcing-event-read-source-record-reference",
          "query-sourcing-event-read-evidence-item",
          "query-sourcing-event-read-policy",
          "query-sourcing-event-read-policy-version",
          "query-sourcing-event-read-authority-envelope",
          "query-sourcing-event-read-action-proposal",
          "query-sourcing-event-read-committed-action",
          "query-sourcing-event-read-decision",
          "query-sourcing-event-read-exception",
          "query-sourcing-event-read-audit-event",
          "query-sourcing-event-read-business-event",
          "query-sourcing-event-read-learning-example",
          "query-sourcing-event-read-evaluation-result",
          "query-sourcing-event-read-integration-state",
          "query-sourcing-event-read-registry-release",
          "query-bid-evaluation-award-read-award-scenario",
          "query-bid-evaluation-award-read-sourcing-event-record",
          "query-bid-evaluation-award-read-supplier-response",
          "query-bid-evaluation-award-read-negotiation-session-downstream",
          "query-bid-evaluation-award-read-tactical-sourcing-case-downstream",
          "query-negotiation-copilot-read-negotiation-session",
          "query-negotiation-copilot-read-award-scenario",
          "query-negotiation-copilot-read-sourcing-opportunity",
          "query-negotiation-copilot-read-authority-envelope",
          "query-negotiation-copilot-read-supplier-response",
          "query-tactical-sourcing-autonomy-read-tactical-sourcing-case",
          "query-tactical-sourcing-autonomy-read-demand-case",
          "query-tactical-sourcing-autonomy-read-sourcing-opportunity",
          "query-tactical-sourcing-autonomy-read-supplier-response",
          "query-contract-intake-digitization-read-contract-template",
          "query-contract-intake-digitization-read-contract",
          "query-contract-intake-digitization-read-supplier-profile",
          "query-contract-authoring-review-read-contract-intake",
          "query-contract-authoring-review-read-contract-template",
          "query-contract-authoring-review-read-clause-library-entry",
          "query-contract-authoring-review-read-contract",
          "query-contract-authoring-review-read-contract-version",
          "query-contract-authoring-review-read-party",
          "query-contract-authoring-review-read-person",
          "query-contract-authoring-review-read-source-record-reference",
          "query-contract-authoring-review-read-evidence-item",
          "query-contract-authoring-review-read-policy",
          "query-contract-authoring-review-read-policy-version",
          "query-contract-authoring-review-read-authority-envelope",
          "query-contract-authoring-review-read-action-proposal",
          "query-contract-authoring-review-read-committed-action",
          "query-contract-authoring-review-read-decision",
          "query-contract-authoring-review-read-exception",
          "query-contract-authoring-review-read-audit-event",
          "query-contract-authoring-review-read-learning-example",
          "query-contract-authoring-review-read-evaluation-result",
          "query-contract-authoring-review-read-integration-state",
          "query-contract-authoring-review-read-registry-release",
          "query-contract-approval-repository-read-contract-template",
          "query-contract-approval-repository-read-contract-version",
          "query-contract-approval-repository-read-clause-deviation",
          "query-contract-approval-repository-read-audit-event",
          "query-contract-approval-repository-read-contract-compliance-finding-downstream",
          "query-obligation-monitoring-read-clause-library-entry",
          "query-obligation-monitoring-read-contract",
          "query-obligation-monitoring-read-contract-version",
          "query-obligation-monitoring-read-contract-approval",
          "query-obligation-monitoring-read-business-event",
          "query-obligation-monitoring-read-contract-change-downstream",
          "query-renewal-change-compliance-read-clause-library-entry",
          "query-renewal-change-compliance-read-contract",
          "query-renewal-change-compliance-read-contract-version",
          "query-renewal-change-compliance-read-contract-obligation",
          "query-renewal-change-compliance-read-contract-entitlement",
          "query-renewal-change-compliance-read-contract-change",
          "query-renewal-change-compliance-read-contract-compliance-finding",
          "query-supplier-onboarding-read-supplier-qualification",
          "query-supplier-onboarding-read-supplier-risk-assessment",
          "query-supplier-onboarding-read-party",
          "query-supplier-onboarding-read-source-record-reference",
          "query-supplier-onboarding-read-policy",
          "query-supplier-onboarding-read-integration-state",
          "query-supplier-onboarding-read-registry-release",
          "query-supplier-master-qualification-read-supplier-profile",
          "query-supplier-master-qualification-read-supplier-onboarding-case",
          "query-supplier-master-qualification-read-supplier-risk-assessment",
          "query-supplier-master-qualification-read-supplier-master-change",
          "query-third-party-risk-review-read-supplier-profile",
          "query-third-party-risk-review-read-supplier-onboarding-case",
          "query-third-party-risk-review-read-supplier-qualification",
          "query-third-party-risk-review-read-supplier-risk-signal",
          "query-third-party-risk-review-read-supplier-tier-link",
          "query-third-party-risk-review-read-person",
          "query-third-party-risk-review-read-evidence-item",
          "query-third-party-risk-review-read-policy-version",
          "query-third-party-risk-review-read-authority-envelope",
          "query-third-party-risk-review-read-action-proposal",
          "query-third-party-risk-review-read-committed-action",
          "query-third-party-risk-review-read-decision",
          "query-third-party-risk-review-read-exception",
          "query-third-party-risk-review-read-audit-event",
          "query-third-party-risk-review-read-business-event",
          "query-third-party-risk-review-read-learning-example",
          "query-third-party-risk-review-read-evaluation-result",
          "query-continuous-risk-monitoring-read-supplier-profile",
          "query-continuous-risk-monitoring-read-supplier-risk-assessment",
          "query-continuous-risk-monitoring-read-supplier-master-change-downstream",
          "query-supplier-remediation-exit-read-supplier-profile",
          "query-supplier-remediation-exit-read-supplier-risk-assessment",
          "query-supplier-remediation-exit-read-supplier-risk-case",
          "query-supplier-remediation-exit-read-supplier-remediation-action",
          "query-supplier-remediation-exit-read-supplier-offboarding-case",
          "query-supplier-remediation-exit-read-contract",
          "query-supplier-remediation-exit-read-purchase-order",
          "query-guided-buying-read-catalogue-line",
          "query-guided-buying-read-supplier-profile",
          "query-guided-buying-read-supplier-qualification",
          "query-guided-buying-read-contract",
          "query-guided-buying-read-party",
          "query-guided-buying-read-business-unit",
          "query-guided-buying-read-category",
          "query-guided-buying-read-item-service",
          "query-guided-buying-read-source-record-reference",
          "query-guided-buying-read-policy",
          "query-guided-buying-read-policy-version",
          "query-guided-buying-read-authority-envelope",
          "query-guided-buying-read-evaluation-result",
          "query-guided-buying-read-integration-state",
          "query-guided-buying-read-registry-release",
          "query-requisition-policy-routing-read-buying-request",
          "query-requisition-policy-routing-read-catalogue-line",
          "query-requisition-policy-routing-read-supplier-profile",
          "query-requisition-policy-routing-read-supplier-qualification",
          "query-requisition-policy-routing-read-budget",
          "query-purchase-order-orchestration-read-requisition",
          "query-purchase-order-orchestration-read-requisition-line",
          "query-purchase-order-orchestration-read-supplier-profile",
          "query-purchase-order-orchestration-read-contract",
          "query-purchase-order-orchestration-read-catalogue-line",
          "query-purchase-order-exception-read-purchase-order",
          "query-purchase-order-exception-read-order-line",
          "query-purchase-order-exception-read-order-response",
          "query-purchase-order-exception-read-purchase-order-exception",
          "query-purchase-order-exception-read-shipment",
          "query-purchase-order-exception-read-receipt",
          "query-purchase-order-exception-read-authority-envelope",
          "query-purchase-order-exception-read-action-proposal",
          "query-purchase-order-exception-read-committed-action",
          "query-purchase-order-exception-read-decision",
          "query-purchase-order-exception-read-exception",
          "query-purchase-order-exception-read-audit-event",
          "query-purchase-order-exception-read-business-event",
          "query-purchase-order-exception-read-catalogue-line",
          "query-purchase-order-exception-read-return-claim-downstream",
          "query-receiving-service-entry-read-purchase-order",
          "query-receiving-service-entry-read-order-line",
          "query-receiving-service-entry-read-receipt-line",
          "query-receiving-service-entry-read-service-entry-sheet",
          "query-receiving-service-entry-read-return-claim",
          "query-invoice-exception-triage-read-invoice",
          "query-invoice-exception-triage-read-invoice-match-assessment",
          "query-invoice-exception-triage-read-supplier-invoice-resolution",
          "query-invoice-exception-triage-read-party",
          "query-invoice-exception-triage-read-category",
          "query-invoice-exception-triage-read-item-service",
          "query-invoice-exception-triage-read-source-record-reference",
          "query-invoice-exception-triage-read-evidence-item",
          "query-invoice-exception-triage-read-policy",
          "query-invoice-exception-triage-read-policy-version",
          "query-invoice-exception-triage-read-authority-envelope",
          "query-invoice-exception-triage-read-action-proposal",
          "query-invoice-exception-triage-read-committed-action",
          "query-invoice-exception-triage-read-decision",
          "query-invoice-exception-triage-read-exception",
          "query-invoice-exception-triage-read-audit-event",
          "query-invoice-exception-triage-read-business-event",
          "query-invoice-exception-triage-read-learning-example",
          "query-invoice-exception-triage-read-evaluation-result",
          "query-invoice-exception-triage-read-integration-state",
          "query-invoice-exception-triage-read-registry-release",
          "query-invoice-exception-triage-read-purchase-order-exception-downstream",
          "query-payment-readiness-read-invoice",
          "query-payment-readiness-read-invoice-match-assessment",
          "query-payment-readiness-read-invoice-exception",
          "query-payment-readiness-read-person",
          "query-payment-readiness-read-policy",
          "query-payment-readiness-read-policy-version",
          "query-payment-readiness-read-authority-envelope",
          "query-payment-readiness-read-exception",
          "query-payment-readiness-read-audit-event",
          "query-payment-readiness-read-business-event",
          "query-payment-readiness-read-integration-state",
          "query-payment-readiness-read-invoice-line-downstream",
          "query-invoice-intake-match-read-invoice-line",
          "query-invoice-intake-match-read-purchase-order-for-invoice-match",
          "query-invoice-intake-match-read-order-line-for-invoice-match",
          "query-invoice-intake-match-read-receipt-for-invoice-match",
          "query-invoice-intake-match-read-receipt-line-for-invoice-match",
          "query-invoice-intake-match-read-service-entry-sheet-for-invoice-match",
          "query-invoice-intake-match-read-receipt-line-downstream",
          "query-invoice-intake-match-read-service-entry-sheet-downstream",
          "query-supplier-invoice-resolution-read-invoice-exception",
          "query-supplier-invoice-resolution-read-invoice",
          "query-supplier-invoice-resolution-read-invoice-line-downstream",
          "query-payment-execution-guard-read-payment-readiness-assessment",
          "query-payment-execution-guard-read-invoice",
          "query-payment-execution-guard-read-payment-execution-status",
          "query-payment-execution-guard-read-payment-instruction",
          "query-supplier-performance-review-read-supplier-segment-assignment",
          "query-supplier-performance-review-read-supplier-performance-observation",
          "query-supplier-performance-review-read-party",
          "query-supplier-performance-review-read-source-record-reference",
          "query-supplier-performance-review-read-authority-envelope",
          "query-supplier-performance-review-read-decision",
          "query-supplier-performance-review-read-audit-event",
          "query-supplier-performance-review-read-business-event",
          "query-supplier-performance-review-read-learning-example",
          "query-supplier-performance-review-read-evaluation-result",
          "query-supplier-performance-review-read-integration-state",
          "query-supplier-performance-review-read-registry-release",
          "query-supplier-performance-review-read-supplier-remediation-action-downstream",
          "query-supplier-performance-review-read-supplier-offboarding-case-downstream",
          "query-supplier-innovation-pipeline-read-supplier-segment-assignment",
          "query-supplier-innovation-pipeline-read-supplier-performance-review-record",
          "query-supplier-innovation-pipeline-read-supplier-joint-value-plan",
          "query-supplier-segmentation-governance-read-supplier-performance-observation",
          "query-supplier-performance-monitor-correct-read-supplier-segment-assignment",
          "query-supplier-performance-monitor-correct-read-supplier-performance-review-record",
          "query-supplier-relationship-joint-value-read-supplier-segment-assignment",
          "query-supplier-relationship-joint-value-read-supplier-performance-review-record",
          "query-supplier-relationship-joint-value-read-supplier-innovation-case",
          "query-savings-initiative-read-value-opportunity-baseline",
          "query-savings-initiative-read-value-realization-attribution",
          "query-savings-initiative-read-value-leakage-finding",
          "query-savings-initiative-read-business-unit",
          "query-savings-initiative-read-category",
          "query-savings-initiative-read-source-record-reference",
          "query-savings-initiative-read-evidence-item",
          "query-savings-initiative-read-authority-envelope",
          "query-savings-initiative-read-action-proposal",
          "query-savings-initiative-read-committed-action",
          "query-savings-initiative-read-decision",
          "query-savings-initiative-read-exception",
          "query-savings-initiative-read-audit-event",
          "query-savings-initiative-read-business-event",
          "query-savings-initiative-read-learning-example",
          "query-savings-initiative-read-evaluation-result",
          "query-savings-initiative-read-integration-state",
          "query-savings-initiative-read-registry-release",
          "query-savings-initiative-read-budget",
          "query-savings-initiative-read-value-portfolio-forecast-downstream",
          "query-value-leakage-monitor-read-value-opportunity-baseline",
          "query-value-leakage-monitor-read-savings-initiative-record",
          "query-value-leakage-monitor-read-value-realization-attribution",
          "query-value-leakage-monitor-read-authority-envelope",
          "query-value-leakage-monitor-read-business-event",
          "query-value-opportunity-baseline-read-savings-initiative-record",
          "query-realization-reconciliation-attribution-read-value-opportunity-baseline",
          "query-realization-reconciliation-attribution-read-savings-initiative-record",
          "query-realization-reconciliation-attribution-read-value-leakage-finding",
          "query-realization-reconciliation-attribution-read-budget",
          "query-realization-reconciliation-attribution-read-payment-instruction-downstream",
          "query-realization-reconciliation-attribution-read-payment-execution-status-downstream",
          "query-value-portfolio-forecast-read-value-opportunity-baseline",
          "query-value-portfolio-forecast-read-savings-initiative-record",
          "query-value-portfolio-forecast-read-value-realization-attribution",
          "query-value-portfolio-forecast-read-value-leakage-finding",
          "query-value-portfolio-forecast-read-value-portfolio-forecast"
        ],
        "freshnessPolicy": "Export last-good records with observed age and source state; never replace unknown or stale values with zero.",
        "id": "gwod-canonical-silver",
        "inputEntityIds": [
          "action-proposal",
          "audit-event",
          "authority-envelope",
          "award-scenario",
          "budget",
          "business-event",
          "business-unit",
          "buying-request",
          "catalogue-line",
          "category",
          "category-dimension-assignment",
          "category-opportunity",
          "category-strategy",
          "clause-deviation",
          "clause-library-entry",
          "committed-action",
          "contract",
          "contract-approval",
          "contract-change",
          "contract-compliance-finding",
          "contract-entitlement",
          "contract-intake",
          "contract-obligation",
          "contract-template",
          "contract-version",
          "decision",
          "demand-case",
          "demand-portfolio",
          "enriched-request",
          "evaluation-result",
          "evidence-item",
          "exception",
          "intake-request",
          "integration-state",
          "invoice",
          "invoice-exception",
          "invoice-line",
          "invoice-match-assessment",
          "item-service",
          "job",
          "learning-example",
          "negotiation-session",
          "order-line",
          "order-response",
          "party",
          "payment-execution-status",
          "payment-instruction",
          "payment-readiness-assessment",
          "person",
          "person-role-assignment",
          "policy",
          "policy-guidance-result",
          "policy-rule-release",
          "policy-version",
          "procurement-service-offering",
          "purchase-order",
          "purchase-order-exception",
          "receipt",
          "receipt-line",
          "registry-release",
          "requisition",
          "requisition-line",
          "return-claim",
          "role",
          "savings-initiative-record",
          "service-entry-sheet",
          "shipment",
          "source-record-reference",
          "sourcing-event-record",
          "sourcing-opportunity",
          "spend-classification-decision",
          "spend-record",
          "supplier-innovation-case",
          "supplier-invoice-resolution",
          "supplier-joint-value-plan",
          "supplier-master-change",
          "supplier-offboarding-case",
          "supplier-onboarding-case",
          "supplier-performance-observation",
          "supplier-performance-review-record",
          "supplier-profile",
          "supplier-qualification",
          "supplier-remediation-action",
          "supplier-response",
          "supplier-risk-assessment",
          "supplier-risk-case",
          "supplier-risk-signal",
          "supplier-segment-assignment",
          "supplier-tier-link",
          "tactical-sourcing-case",
          "tail-spend-evaluation",
          "tail-spend-rule",
          "taxonomy-version",
          "value-leakage-finding",
          "value-opportunity-baseline",
          "value-portfolio-forecast",
          "value-realization-attribution",
          "work-moment-record"
        ],
        "layer": "silver",
        "outputRecordId": "gwod-canonical-envelope",
        "permissionPolicy": "Preserve tenant, company, environment, purpose, authority and field classification from the canonical owner.",
        "reconciliationKeyFieldIds": [
          "business-key",
          "record-version",
          "schema-version"
        ],
        "status": "direction"
      },
      {
        "definitionVersion": "0.5.0",
        "deletionPolicy": "Rebuild or delete derived rows when any governed input is deleted or withdrawn, subject to legal hold.",
        "drillThroughQueryIds": [
          "query-spend-data-foundation-read-spend-record",
          "query-spend-data-foundation-read-spend-classification-decision",
          "query-spend-data-foundation-read-taxonomy-version",
          "query-spend-data-foundation-read-category-dimension-assignment",
          "query-category-opportunity-radar-read-spend-record",
          "query-category-opportunity-radar-read-category",
          "query-category-strategy-orchestrator-read-spend-record",
          "query-intelligent-intake-read-category",
          "query-sourcing-event-read-category",
          "query-guided-buying-read-category",
          "query-invoice-exception-triage-read-category",
          "query-savings-initiative-read-category"
        ],
        "freshnessPolicy": "Declare source versions, effective period, coverage and unresolved classification counts for every result.",
        "id": "classification-resolution-gold",
        "inputEntityIds": [
          "taxonomy-version",
          "category",
          "category-dimension-assignment",
          "spend-record",
          "spend-classification-decision"
        ],
        "layer": "gold",
        "outputRecordId": "classification-resolution",
        "permissionPolicy": "Apply the most restrictive input permission and retain record drill-through only for authorised viewers.",
        "reconciliationKeyFieldIds": [
          "business-key",
          "record-version"
        ],
        "status": "direction"
      },
      {
        "definitionVersion": "0.5.0",
        "deletionPolicy": "Rebuild derived evaluations after governed source deletion while retaining authorised audit references.",
        "drillThroughQueryIds": [
          "query-spend-data-foundation-read-spend-record",
          "query-category-opportunity-radar-read-spend-record",
          "query-category-opportunity-radar-read-tail-spend-evaluation",
          "query-category-strategy-orchestrator-read-spend-record",
          "query-category-strategy-orchestrator-read-tail-spend-evaluation",
          "query-policy-rule-lifecycle-read-tail-spend-rule",
          "query-policy-guidance-read-tail-spend-evaluation"
        ],
        "freshnessPolicy": "Pin the rule, source-record version, evaluation period and time; changed rules create new evaluations without rewriting history.",
        "id": "tail-spend-evaluation-gold",
        "inputEntityIds": [
          "tail-spend-rule",
          "spend-record",
          "tail-spend-evaluation"
        ],
        "layer": "gold",
        "outputRecordId": "tail-spend-evaluation",
        "permissionPolicy": "Apply canonical spend and rule permissions and preserve unresolved values.",
        "reconciliationKeyFieldIds": [
          "business-key",
          "record-version"
        ],
        "status": "direction"
      }
    ],
    "namedQueries": [
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "spend-data-foundation"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "spend-record",
        "filterContract": [
          {
            "fieldId": "spend-record-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "spend-record-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-spend-data-foundation-read-spend-record",
        "identityFieldId": "spend-record-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "spend-data-foundation",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "spend-record-id",
          "source-system",
          "source-record-id",
          "source-line-id",
          "supplier-party-id",
          "company-party-id",
          "business-unit-id",
          "category-id",
          "spend-segment",
          "buying-mode",
          "accounting-treatment",
          "classification-resolution-status",
          "spend-classification-decision-id",
          "description",
          "amount",
          "accounting-date",
          "classification-confidence",
          "quality-status",
          "observed-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "spend-data-foundation"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "spend-classification-decision",
        "filterContract": [
          {
            "fieldId": "spend-classification-decision-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "spend-classification-decision-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-spend-data-foundation-read-spend-classification-decision",
        "identityFieldId": "spend-classification-decision-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "spend-data-foundation",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "spend-classification-decision-id",
          "company-party-id",
          "spend-record-id",
          "dimension-id",
          "proposed-member-id",
          "committed-member-id",
          "resolution-source",
          "lifecycle-state",
          "decision-method",
          "actor-reference",
          "authority-envelope-id",
          "rule-release-id",
          "model-version",
          "confidence",
          "rationale",
          "evidence-item-ids",
          "source-version-references",
          "predecessor-decision-id",
          "decided-at",
          "external-acknowledgement-status",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "spend-data-foundation"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "taxonomy-version",
        "filterContract": [
          {
            "fieldId": "taxonomy-version-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "taxonomy-version-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-spend-data-foundation-read-taxonomy-version",
        "identityFieldId": "taxonomy-version-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "taxonomy-version-id",
          "company-party-id",
          "version-code",
          "content-hash",
          "effective-from",
          "supersedes-taxonomy-version-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "spend-data-foundation"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "category-dimension-assignment",
        "filterContract": [
          {
            "fieldId": "category-dimension-assignment-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "category-dimension-assignment-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-spend-data-foundation-read-category-dimension-assignment",
        "identityFieldId": "category-dimension-assignment-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "category-dimension-assignment-id",
          "company-party-id",
          "business-unit-id",
          "taxonomy-version-id",
          "category-id",
          "dimension-id",
          "member-id",
          "inheritance-mode",
          "effective-from",
          "effective-until",
          "lifecycle-state",
          "source-method",
          "actor-reference",
          "evidence-item-ids",
          "supersedes-assignment-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "category-opportunity-radar"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "category-opportunity",
        "filterContract": [
          {
            "fieldId": "category-opportunity-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "category-opportunity-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-category-opportunity-radar-read-category-opportunity",
        "identityFieldId": "category-opportunity-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "category-opportunity-radar",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "category-opportunity-id",
          "category-id",
          "title",
          "opportunity-type",
          "value-hypothesis",
          "priority-score",
          "evidence-item-ids",
          "strategy-id",
          "lifecycle-state",
          "evidence-as-of",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "category-opportunity-radar"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "spend-record",
        "filterContract": [
          {
            "fieldId": "spend-record-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "spend-record-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-category-opportunity-radar-read-spend-record",
        "identityFieldId": "spend-record-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "spend-data-foundation",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "spend-record-id",
          "supplier-party-id",
          "business-unit-id",
          "category-id",
          "amount",
          "accounting-date",
          "quality-status",
          "observed-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "category-opportunity-radar"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-unit",
        "filterContract": [
          {
            "fieldId": "business-unit-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-unit-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-category-opportunity-radar-read-business-unit",
        "identityFieldId": "business-unit-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-unit-id",
          "external-key",
          "name",
          "parent-business-unit-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "category-opportunity-radar"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "category",
        "filterContract": [
          {
            "fieldId": "category-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "category-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-category-opportunity-radar-read-category",
        "identityFieldId": "category-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "category-id",
          "taxonomy-version-id",
          "code",
          "name",
          "parent-category-id",
          "external-classification",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "category-opportunity-radar"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "source-record-reference",
        "filterContract": [
          {
            "fieldId": "source-record-reference-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "source-record-reference-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-category-opportunity-radar-read-source-record-reference",
        "identityFieldId": "source-record-reference-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "source-record-reference-id",
          "source-system-id",
          "source-object-type",
          "source-record-id",
          "source-version",
          "source-schema-version",
          "observed-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "category-opportunity-radar"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "evidence-item",
        "filterContract": [
          {
            "fieldId": "evidence-item-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "evidence-item-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-category-opportunity-radar-read-evidence-item",
        "identityFieldId": "evidence-item-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "evidence-item-id",
          "evidence-type",
          "source-record-reference-id",
          "artifact-reference",
          "content-hash",
          "captured-at",
          "lifecycle-state",
          "classification",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "category-opportunity-radar"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "authority-envelope",
        "filterContract": [
          {
            "fieldId": "authority-envelope-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "authority-envelope-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-category-opportunity-radar-read-authority-envelope",
        "identityFieldId": "authority-envelope-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "authority-envelope-id",
          "workblock-id",
          "grantor-person-id",
          "policy-version-id",
          "allowed-actions",
          "guard-conditions",
          "effective-from",
          "expires-at",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "category-opportunity-radar"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "learning-example",
        "filterContract": [
          {
            "fieldId": "learning-example-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "learning-example-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-category-opportunity-radar-read-learning-example",
        "identityFieldId": "learning-example-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "learning-evaluation-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "learning-example-id",
          "workblock-id",
          "example-type",
          "input-reference",
          "expected-output",
          "version-context",
          "validation-evidence-item-ids",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "category-opportunity-radar"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "evaluation-result",
        "filterContract": [
          {
            "fieldId": "evaluation-result-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "evaluation-result-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-category-opportunity-radar-read-evaluation-result",
        "identityFieldId": "evaluation-result-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "learning-evaluation-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "evaluation-result-id",
          "workblock-id",
          "candidate-version",
          "suite-version",
          "check-results",
          "disposition",
          "lifecycle-state",
          "completed-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "category-opportunity-radar"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "integration-state",
        "filterContract": [
          {
            "fieldId": "integration-state-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "integration-state-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-category-opportunity-radar-read-integration-state",
        "identityFieldId": "integration-state-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "integration-state-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "integration-state-id",
          "integration-id",
          "lifecycle-state",
          "last-successful-sync-at",
          "last-error-code",
          "last-good-reference",
          "updated-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "category-opportunity-radar"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "tail-spend-evaluation",
        "filterContract": [
          {
            "fieldId": "tail-spend-evaluation-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "tail-spend-evaluation-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-category-opportunity-radar-read-tail-spend-evaluation",
        "identityFieldId": "tail-spend-evaluation-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "spend-data-foundation",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "tail-spend-evaluation-id",
          "spend-record-id",
          "tail-spend-rule-id",
          "evaluation-result",
          "definition-version",
          "evaluated-at",
          "source-record-version",
          "lifecycle-state",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "category-strategy-orchestrator"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "category-strategy",
        "filterContract": [
          {
            "fieldId": "category-strategy-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "category-strategy-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-category-strategy-orchestrator-read-category-strategy",
        "identityFieldId": "category-strategy-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "category-strategy-orchestrator",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "category-strategy-id",
          "version-number",
          "category-id",
          "owner-person-id",
          "mission",
          "objectives",
          "initiative-ids",
          "authority-envelope-id",
          "lifecycle-state",
          "effective-date",
          "review-due-date",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "category-strategy-orchestrator"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "category-opportunity",
        "filterContract": [
          {
            "fieldId": "category-opportunity-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "category-opportunity-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-category-strategy-orchestrator-read-category-opportunity",
        "identityFieldId": "category-opportunity-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "category-opportunity-radar",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "category-opportunity-id",
          "category-id",
          "title",
          "opportunity-type",
          "value-hypothesis",
          "priority-score",
          "evidence-item-ids",
          "strategy-id",
          "lifecycle-state",
          "evidence-as-of",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "category-strategy-orchestrator"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "spend-record",
        "filterContract": [
          {
            "fieldId": "spend-record-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "spend-record-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-category-strategy-orchestrator-read-spend-record",
        "identityFieldId": "spend-record-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "spend-data-foundation",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "spend-record-id",
          "supplier-party-id",
          "business-unit-id",
          "category-id",
          "amount",
          "accounting-date",
          "quality-status",
          "observed-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "category-strategy-orchestrator"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "tail-spend-evaluation",
        "filterContract": [
          {
            "fieldId": "tail-spend-evaluation-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "tail-spend-evaluation-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-category-strategy-orchestrator-read-tail-spend-evaluation",
        "identityFieldId": "tail-spend-evaluation-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "spend-data-foundation",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "tail-spend-evaluation-id",
          "spend-record-id",
          "tail-spend-rule-id",
          "evaluation-result",
          "definition-version",
          "evaluated-at",
          "source-record-version",
          "lifecycle-state",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "policy-rule-lifecycle"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy-rule-release",
        "filterContract": [
          {
            "fieldId": "policy-rule-release-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "policy-rule-release-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-rule-lifecycle-read-policy-rule-release",
        "identityFieldId": "policy-rule-release-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "policy-rule-lifecycle",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-rule-release-id",
          "policy-version-id",
          "release-number",
          "rule-code",
          "scope",
          "condition-expression",
          "effect",
          "precedence",
          "lifecycle-state",
          "effective-from",
          "effective-until",
          "evaluation-result-id",
          "rollback-release-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "policy-rule-lifecycle"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "tail-spend-rule",
        "filterContract": [
          {
            "fieldId": "tail-spend-rule-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "tail-spend-rule-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-rule-lifecycle-read-tail-spend-rule",
        "identityFieldId": "tail-spend-rule-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "policy-rule-lifecycle",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "tail-spend-rule-id",
          "company-party-id",
          "business-unit-id",
          "rule-version",
          "method",
          "threshold-amount",
          "pareto-percentage",
          "evaluation-period-basis",
          "included-category-ids",
          "excluded-category-ids",
          "effective-from",
          "effective-until",
          "lifecycle-state",
          "authority-envelope-id",
          "evidence-item-ids",
          "supersedes-tail-spend-rule-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "policy-rule-lifecycle"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy-guidance-result",
        "filterContract": [
          {
            "fieldId": "policy-guidance-result-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "policy-guidance-result-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-rule-lifecycle-read-policy-guidance-result",
        "identityFieldId": "policy-guidance-result-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "policy-guidance",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-guidance-result-id",
          "subject-entity-id",
          "rule-release-ids",
          "outcome",
          "permitted-route-codes",
          "required-evidence-codes",
          "exception-id",
          "evaluated-at",
          "expires-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "policy-guidance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy-guidance-result",
        "filterContract": [
          {
            "fieldId": "policy-guidance-result-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "policy-guidance-result-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-guidance-read-policy-guidance-result",
        "identityFieldId": "policy-guidance-result-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "policy-guidance",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-guidance-result-id",
          "subject-entity-id",
          "question",
          "input-facts",
          "rule-release-ids",
          "outcome",
          "permitted-route-codes",
          "required-evidence-codes",
          "explanation",
          "exception-id",
          "evaluated-at",
          "expires-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "policy-guidance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy-rule-release",
        "filterContract": [
          {
            "fieldId": "policy-rule-release-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "policy-rule-release-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-guidance-read-policy-rule-release",
        "identityFieldId": "policy-rule-release-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "policy-rule-lifecycle",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-rule-release-id",
          "policy-version-id",
          "release-number",
          "rule-code",
          "scope",
          "condition-expression",
          "effect",
          "precedence",
          "lifecycle-state",
          "effective-from",
          "effective-until",
          "evaluation-result-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "policy-guidance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "evidence-item",
        "filterContract": [
          {
            "fieldId": "evidence-item-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "evidence-item-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-guidance-read-evidence-item",
        "identityFieldId": "evidence-item-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "evidence-item-id",
          "evidence-type",
          "source-record-reference-id",
          "artifact-reference",
          "content-hash",
          "captured-at",
          "lifecycle-state",
          "classification",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "policy-guidance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy",
        "filterContract": [
          {
            "fieldId": "policy-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "policy-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-guidance-read-policy",
        "identityFieldId": "policy-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-id",
          "policy-code",
          "title",
          "owner-person-id",
          "active-version-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "policy-guidance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy-version",
        "filterContract": [
          {
            "fieldId": "policy-version-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "policy-version-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-guidance-read-policy-version",
        "identityFieldId": "policy-version-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-version-id",
          "policy-id",
          "semantic-version",
          "artifact-reference",
          "rules-hash",
          "effective-from",
          "effective-to",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "policy-guidance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "exception",
        "filterContract": [
          {
            "fieldId": "exception-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "exception-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-guidance-read-exception",
        "identityFieldId": "exception-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "exception-id",
          "workblock-id",
          "exception-type",
          "subject-ref",
          "owner-person-id",
          "evidence-item-ids",
          "lifecycle-state",
          "opened-at",
          "resolution-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "policy-guidance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "registry-release",
        "filterContract": [
          {
            "fieldId": "registry-release-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "registry-release-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-guidance-read-registry-release",
        "identityFieldId": "registry-release-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "registry-release-id",
          "registry-version",
          "previous-version",
          "content-hash",
          "compatibility-class",
          "change-summary",
          "migration-references",
          "lifecycle-state",
          "released-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "policy-guidance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "tail-spend-evaluation",
        "filterContract": [
          {
            "fieldId": "tail-spend-evaluation-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "tail-spend-evaluation-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-guidance-read-tail-spend-evaluation",
        "identityFieldId": "tail-spend-evaluation-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "spend-data-foundation",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "tail-spend-evaluation-id",
          "spend-record-id",
          "tail-spend-rule-id",
          "evaluation-result",
          "definition-version",
          "evaluated-at",
          "source-record-version",
          "lifecycle-state",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "procurement-service-catalogue"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "procurement-service-offering",
        "filterContract": [
          {
            "fieldId": "procurement-service-offering-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "procurement-service-offering-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-procurement-service-catalogue-read-procurement-service-offering",
        "identityFieldId": "procurement-service-offering-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "procurement-service-catalogue",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "procurement-service-offering-id",
          "service-code",
          "version-number",
          "name",
          "description",
          "eligibility-expression",
          "input-schema",
          "owner-workblock-id",
          "policy-rule-release-ids",
          "service-expectation",
          "search-keywords",
          "lifecycle-state",
          "effective-from",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "procurement-service-catalogue"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy-rule-release",
        "filterContract": [
          {
            "fieldId": "policy-rule-release-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "policy-rule-release-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-procurement-service-catalogue-read-policy-rule-release",
        "identityFieldId": "policy-rule-release-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "policy-rule-lifecycle",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-rule-release-id",
          "rule-code",
          "scope",
          "effect",
          "precedence",
          "lifecycle-state",
          "effective-from",
          "effective-until",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "intelligent-intake"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "intake-request",
        "filterContract": [
          {
            "fieldId": "intake-request-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "intake-request-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-intelligent-intake-read-intake-request",
        "identityFieldId": "intake-request-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "intelligent-intake",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "intake-request-id",
          "external-reference",
          "requester-person-id",
          "business-unit-id",
          "service-offering-id",
          "need-statement",
          "requirements",
          "estimated-value",
          "needed-by-date",
          "evidence-item-ids",
          "completeness-score",
          "lifecycle-state",
          "submitted-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "intelligent-intake"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "procurement-service-offering",
        "filterContract": [
          {
            "fieldId": "procurement-service-offering-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "procurement-service-offering-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-intelligent-intake-read-procurement-service-offering",
        "identityFieldId": "procurement-service-offering-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "procurement-service-catalogue",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "procurement-service-offering-id",
          "service-code",
          "version-number",
          "name",
          "description",
          "eligibility-expression",
          "input-schema",
          "owner-workblock-id",
          "policy-rule-release-ids",
          "service-expectation",
          "lifecycle-state",
          "effective-from",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "intelligent-intake"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "person",
        "filterContract": [
          {
            "fieldId": "person-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "person-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-intelligent-intake-read-person",
        "identityFieldId": "person-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "person-id",
          "party-id",
          "identity-subject",
          "display-name",
          "primary-role",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "intelligent-intake"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-unit",
        "filterContract": [
          {
            "fieldId": "business-unit-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-unit-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-intelligent-intake-read-business-unit",
        "identityFieldId": "business-unit-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-unit-id",
          "external-key",
          "name",
          "parent-business-unit-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "intelligent-intake"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "category",
        "filterContract": [
          {
            "fieldId": "category-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "category-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-intelligent-intake-read-category",
        "identityFieldId": "category-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "category-id",
          "taxonomy-version-id",
          "code",
          "name",
          "parent-category-id",
          "external-classification",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "intelligent-intake"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "item-service",
        "filterContract": [
          {
            "fieldId": "item-service-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "item-service-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-intelligent-intake-read-item-service",
        "identityFieldId": "item-service-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "item-service-id",
          "kind",
          "buying-mode",
          "name",
          "description",
          "category-id",
          "external-identifier",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "intelligent-intake"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "source-record-reference",
        "filterContract": [
          {
            "fieldId": "source-record-reference-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "source-record-reference-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-intelligent-intake-read-source-record-reference",
        "identityFieldId": "source-record-reference-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "source-record-reference-id",
          "source-system-id",
          "source-object-type",
          "source-record-id",
          "source-version",
          "source-schema-version",
          "observed-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "intelligent-intake"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy",
        "filterContract": [
          {
            "fieldId": "policy-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "policy-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-intelligent-intake-read-policy",
        "identityFieldId": "policy-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-id",
          "policy-code",
          "title",
          "owner-person-id",
          "active-version-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "intelligent-intake"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy-version",
        "filterContract": [
          {
            "fieldId": "policy-version-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "policy-version-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-intelligent-intake-read-policy-version",
        "identityFieldId": "policy-version-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-version-id",
          "policy-id",
          "semantic-version",
          "artifact-reference",
          "rules-hash",
          "effective-from",
          "effective-to",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "intelligent-intake"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "authority-envelope",
        "filterContract": [
          {
            "fieldId": "authority-envelope-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "authority-envelope-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-intelligent-intake-read-authority-envelope",
        "identityFieldId": "authority-envelope-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "authority-envelope-id",
          "workblock-id",
          "grantor-person-id",
          "policy-version-id",
          "allowed-actions",
          "guard-conditions",
          "effective-from",
          "expires-at",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "intelligent-intake"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "learning-example",
        "filterContract": [
          {
            "fieldId": "learning-example-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "learning-example-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-intelligent-intake-read-learning-example",
        "identityFieldId": "learning-example-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "learning-evaluation-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "learning-example-id",
          "workblock-id",
          "example-type",
          "input-reference",
          "expected-output",
          "version-context",
          "validation-evidence-item-ids",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "intelligent-intake"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "evaluation-result",
        "filterContract": [
          {
            "fieldId": "evaluation-result-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "evaluation-result-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-intelligent-intake-read-evaluation-result",
        "identityFieldId": "evaluation-result-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "learning-evaluation-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "evaluation-result-id",
          "workblock-id",
          "candidate-version",
          "suite-version",
          "check-results",
          "disposition",
          "lifecycle-state",
          "completed-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "intelligent-intake"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "integration-state",
        "filterContract": [
          {
            "fieldId": "integration-state-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "integration-state-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-intelligent-intake-read-integration-state",
        "identityFieldId": "integration-state-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "integration-state-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "integration-state-id",
          "integration-id",
          "lifecycle-state",
          "last-successful-sync-at",
          "last-error-code",
          "last-good-reference",
          "updated-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "intelligent-intake"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "budget",
        "filterContract": [
          {
            "fieldId": "budget-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "budget-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-intelligent-intake-read-budget",
        "identityFieldId": "budget-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "demand-consolidation-portfolio",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "budget-id",
          "company-party-id",
          "business-unit-id",
          "owner-role-id",
          "budget-code",
          "period-start",
          "period-end",
          "authorised-amount",
          "supersedes-budget-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "request-enrichment-routing"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "enriched-request",
        "filterContract": [
          {
            "fieldId": "enriched-request-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "enriched-request-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-request-enrichment-routing-read-enriched-request",
        "identityFieldId": "enriched-request-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "request-enrichment-routing",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "enriched-request-id",
          "version-number",
          "intake-request-id",
          "category-id",
          "normalised-requirements",
          "context-links",
          "policy-guidance-result-id",
          "route-code",
          "route-confidence",
          "missing-evidence-codes",
          "lifecycle-state",
          "expires-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "request-enrichment-routing"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "intake-request",
        "filterContract": [
          {
            "fieldId": "intake-request-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "intake-request-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-request-enrichment-routing-read-intake-request",
        "identityFieldId": "intake-request-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "intelligent-intake",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "intake-request-id",
          "requester-person-id",
          "business-unit-id",
          "service-offering-id",
          "need-statement",
          "requirements",
          "estimated-value",
          "needed-by-date",
          "evidence-item-ids",
          "completeness-score",
          "lifecycle-state",
          "submitted-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "request-enrichment-routing"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy-guidance-result",
        "filterContract": [
          {
            "fieldId": "policy-guidance-result-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "policy-guidance-result-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-request-enrichment-routing-read-policy-guidance-result",
        "identityFieldId": "policy-guidance-result-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "policy-guidance",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-guidance-result-id",
          "subject-entity-id",
          "input-facts",
          "rule-release-ids",
          "outcome",
          "permitted-route-codes",
          "required-evidence-codes",
          "exception-id",
          "evaluated-at",
          "expires-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "demand-orchestration"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "demand-case",
        "filterContract": [
          {
            "fieldId": "demand-case-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "demand-case-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-demand-orchestration-read-demand-case",
        "identityFieldId": "demand-case-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "demand-orchestration",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "demand-case-id",
          "intake-request-id",
          "enrichment-id",
          "route-code",
          "plan-version",
          "step-state",
          "owner-person-id",
          "committed-action-ids",
          "exception-id",
          "portfolio-id",
          "lifecycle-state",
          "next-action-due-at",
          "updated-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "demand-orchestration"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "intake-request",
        "filterContract": [
          {
            "fieldId": "intake-request-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "intake-request-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-demand-orchestration-read-intake-request",
        "identityFieldId": "intake-request-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "intelligent-intake",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "intake-request-id",
          "requester-person-id",
          "business-unit-id",
          "service-offering-id",
          "need-statement",
          "requirements",
          "estimated-value",
          "needed-by-date",
          "evidence-item-ids",
          "lifecycle-state",
          "submitted-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "demand-orchestration"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "enriched-request",
        "filterContract": [
          {
            "fieldId": "enriched-request-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "enriched-request-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-demand-orchestration-read-enriched-request",
        "identityFieldId": "enriched-request-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "request-enrichment-routing",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "enriched-request-id",
          "version-number",
          "intake-request-id",
          "category-id",
          "normalised-requirements",
          "context-links",
          "policy-guidance-result-id",
          "route-code",
          "route-confidence",
          "missing-evidence-codes",
          "lifecycle-state",
          "expires-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "demand-orchestration"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "person",
        "filterContract": [
          {
            "fieldId": "person-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "person-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-demand-orchestration-read-person",
        "identityFieldId": "person-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "person-id",
          "party-id",
          "identity-subject",
          "display-name",
          "primary-role",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "demand-orchestration"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "authority-envelope",
        "filterContract": [
          {
            "fieldId": "authority-envelope-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "authority-envelope-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-demand-orchestration-read-authority-envelope",
        "identityFieldId": "authority-envelope-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "authority-envelope-id",
          "workblock-id",
          "grantor-person-id",
          "policy-version-id",
          "allowed-actions",
          "guard-conditions",
          "effective-from",
          "expires-at",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "demand-orchestration"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "action-proposal",
        "filterContract": [
          {
            "fieldId": "action-proposal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "action-proposal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-demand-orchestration-read-action-proposal",
        "identityFieldId": "action-proposal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "action-proposal-id",
          "workblock-id",
          "action-class",
          "subject-ref",
          "authority-envelope-id",
          "evidence-item-ids",
          "proposed-payload",
          "lifecycle-state",
          "created-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "demand-orchestration"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "committed-action",
        "filterContract": [
          {
            "fieldId": "committed-action-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "committed-action-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-demand-orchestration-read-committed-action",
        "identityFieldId": "committed-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "committed-action-id",
          "action-proposal-id",
          "authority-envelope-id",
          "idempotency-key",
          "commit-result",
          "committed-at",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "demand-orchestration"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "decision",
        "filterContract": [
          {
            "fieldId": "decision-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "decision-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-demand-orchestration-read-decision",
        "identityFieldId": "decision-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "decision-id",
          "decision-type",
          "subject-ref",
          "outcome",
          "authority-envelope-id",
          "evidence-item-ids",
          "rationale",
          "decided-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "demand-orchestration"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "exception",
        "filterContract": [
          {
            "fieldId": "exception-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "exception-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-demand-orchestration-read-exception",
        "identityFieldId": "exception-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "exception-id",
          "workblock-id",
          "exception-type",
          "subject-ref",
          "owner-person-id",
          "evidence-item-ids",
          "lifecycle-state",
          "opened-at",
          "resolution-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "demand-orchestration"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "audit-event",
        "filterContract": [
          {
            "fieldId": "audit-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "audit-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-demand-orchestration-read-audit-event",
        "identityFieldId": "audit-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "audit-event-id",
          "event-type",
          "subject-reference",
          "actor-reference",
          "version-context",
          "correlation-id",
          "summary",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "demand-orchestration"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-event",
        "filterContract": [
          {
            "fieldId": "business-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-demand-orchestration-read-business-event",
        "identityFieldId": "business-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-event-id",
          "event-type",
          "event-schema-version",
          "subject-reference",
          "correlation-id",
          "causation-id",
          "payload",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "demand-orchestration"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "integration-state",
        "filterContract": [
          {
            "fieldId": "integration-state-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "integration-state-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-demand-orchestration-read-integration-state",
        "identityFieldId": "integration-state-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "integration-state-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "integration-state-id",
          "integration-id",
          "lifecycle-state",
          "last-successful-sync-at",
          "last-error-code",
          "last-good-reference",
          "updated-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "demand-orchestration"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "registry-release",
        "filterContract": [
          {
            "fieldId": "registry-release-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "registry-release-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-demand-orchestration-read-registry-release",
        "identityFieldId": "registry-release-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "registry-release-id",
          "registry-version",
          "previous-version",
          "content-hash",
          "compatibility-class",
          "change-summary",
          "migration-references",
          "lifecycle-state",
          "released-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "demand-consolidation-portfolio"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "demand-portfolio",
        "filterContract": [
          {
            "fieldId": "demand-portfolio-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "demand-portfolio-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-demand-consolidation-portfolio-read-demand-portfolio",
        "identityFieldId": "demand-portfolio-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "demand-consolidation-portfolio",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "demand-portfolio-id",
          "version-number",
          "category-id",
          "demand-case-ids",
          "forecast-components",
          "consolidation-rationale",
          "scenario-set",
          "strategy-id",
          "owner-person-id",
          "lifecycle-state",
          "target-window-start",
          "target-window-end",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "demand-consolidation-portfolio"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "demand-case",
        "filterContract": [
          {
            "fieldId": "demand-case-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "demand-case-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-demand-consolidation-portfolio-read-demand-case",
        "identityFieldId": "demand-case-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "demand-orchestration",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "demand-case-id",
          "intake-request-id",
          "enrichment-id",
          "route-code",
          "owner-person-id",
          "portfolio-id",
          "lifecycle-state",
          "next-action-due-at",
          "updated-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "demand-consolidation-portfolio"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "item-service",
        "filterContract": [
          {
            "fieldId": "item-service-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "item-service-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-demand-consolidation-portfolio-read-item-service",
        "identityFieldId": "item-service-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "item-service-id",
          "kind",
          "buying-mode",
          "name",
          "description",
          "category-id",
          "external-identifier",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "demand-consolidation-portfolio"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-entitlement",
        "filterContract": [
          {
            "fieldId": "contract-entitlement-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-entitlement-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-demand-consolidation-portfolio-read-contract-entitlement",
        "identityFieldId": "contract-entitlement-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "obligation-monitoring",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-entitlement-id",
          "contract-id",
          "clause-anchor",
          "entitlement-type",
          "trigger-condition",
          "estimated-value",
          "trigger-date",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-pipeline-discovery"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "sourcing-opportunity",
        "filterContract": [
          {
            "fieldId": "sourcing-opportunity-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "sourcing-opportunity-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-pipeline-discovery-read-sourcing-opportunity",
        "identityFieldId": "sourcing-opportunity-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "sourcing-pipeline-discovery",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "sourcing-opportunity-id",
          "category-id",
          "strategy-id",
          "demand-portfolio-id",
          "title",
          "scope-summary",
          "market-candidate-party-ids",
          "recommended-route",
          "value-hypothesis",
          "priority-score",
          "target-start-date",
          "lifecycle-state",
          "evidence-as-of",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-pipeline-discovery"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "category-opportunity",
        "filterContract": [
          {
            "fieldId": "category-opportunity-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "category-opportunity-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-pipeline-discovery-read-category-opportunity",
        "identityFieldId": "category-opportunity-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "category-opportunity-radar",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "category-opportunity-id",
          "category-id",
          "title",
          "opportunity-type",
          "value-hypothesis",
          "priority-score",
          "evidence-item-ids",
          "strategy-id",
          "lifecycle-state",
          "evidence-as-of",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-pipeline-discovery"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "demand-portfolio",
        "filterContract": [
          {
            "fieldId": "demand-portfolio-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "demand-portfolio-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-pipeline-discovery-read-demand-portfolio",
        "identityFieldId": "demand-portfolio-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "demand-consolidation-portfolio",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "demand-portfolio-id",
          "version-number",
          "category-id",
          "demand-case-ids",
          "forecast-components",
          "scenario-set",
          "strategy-id",
          "lifecycle-state",
          "target-window-start",
          "target-window-end",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-pipeline-discovery"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "category-strategy",
        "filterContract": [
          {
            "fieldId": "category-strategy-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "category-strategy-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-pipeline-discovery-read-category-strategy-downstream",
        "identityFieldId": "category-strategy-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "category-strategy-orchestrator",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "category-strategy-id",
          "version-number",
          "category-id",
          "owner-person-id",
          "mission",
          "objectives",
          "initiative-ids",
          "authority-envelope-id",
          "lifecycle-state",
          "effective-date",
          "review-due-date",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-pipeline-discovery"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "authority-envelope",
        "filterContract": [
          {
            "fieldId": "authority-envelope-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "authority-envelope-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-pipeline-discovery-read-authority-envelope",
        "identityFieldId": "authority-envelope-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "authority-envelope-id",
          "workblock-id",
          "grantor-person-id",
          "policy-version-id",
          "allowed-actions",
          "guard-conditions",
          "effective-from",
          "expires-at",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-event"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "sourcing-event-record",
        "filterContract": [
          {
            "fieldId": "sourcing-event-record-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "sourcing-event-record-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-event-read-sourcing-event-record",
        "identityFieldId": "sourcing-event-record-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "sourcing-event",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "sourcing-event-record-id",
          "event-number",
          "published-version",
          "sourcing-opportunity-id",
          "category-id",
          "event-type",
          "event-specification",
          "invited-party-ids",
          "artifact-ids",
          "submission-deadline",
          "lifecycle-state",
          "last-reconciled-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-event"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "sourcing-opportunity",
        "filterContract": [
          {
            "fieldId": "sourcing-opportunity-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "sourcing-opportunity-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-event-read-sourcing-opportunity",
        "identityFieldId": "sourcing-opportunity-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "sourcing-pipeline-discovery",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "sourcing-opportunity-id",
          "category-id",
          "strategy-id",
          "demand-portfolio-id",
          "title",
          "scope-summary",
          "market-candidate-party-ids",
          "recommended-route",
          "value-hypothesis",
          "target-start-date",
          "lifecycle-state",
          "evidence-as-of",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-event"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "party",
        "filterContract": [
          {
            "fieldId": "party-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "party-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-event-read-party",
        "identityFieldId": "party-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "party-id",
          "legal-name",
          "party-type",
          "external-identifier",
          "registered-country-code",
          "lifecycle-state",
          "updated-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-event"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "person",
        "filterContract": [
          {
            "fieldId": "person-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "person-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-event-read-person",
        "identityFieldId": "person-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "person-id",
          "party-id",
          "identity-subject",
          "display-name",
          "primary-role",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-event"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "category",
        "filterContract": [
          {
            "fieldId": "category-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "category-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-event-read-category",
        "identityFieldId": "category-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "category-id",
          "taxonomy-version-id",
          "code",
          "name",
          "parent-category-id",
          "external-classification",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-event"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "item-service",
        "filterContract": [
          {
            "fieldId": "item-service-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "item-service-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-event-read-item-service",
        "identityFieldId": "item-service-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "item-service-id",
          "kind",
          "buying-mode",
          "name",
          "description",
          "category-id",
          "external-identifier",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-event"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "source-record-reference",
        "filterContract": [
          {
            "fieldId": "source-record-reference-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "source-record-reference-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-event-read-source-record-reference",
        "identityFieldId": "source-record-reference-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "source-record-reference-id",
          "source-system-id",
          "source-object-type",
          "source-record-id",
          "source-version",
          "source-schema-version",
          "observed-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-event"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "evidence-item",
        "filterContract": [
          {
            "fieldId": "evidence-item-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "evidence-item-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-event-read-evidence-item",
        "identityFieldId": "evidence-item-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "evidence-item-id",
          "evidence-type",
          "source-record-reference-id",
          "artifact-reference",
          "content-hash",
          "captured-at",
          "lifecycle-state",
          "classification",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-event"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy",
        "filterContract": [
          {
            "fieldId": "policy-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "policy-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-event-read-policy",
        "identityFieldId": "policy-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-id",
          "policy-code",
          "title",
          "owner-person-id",
          "active-version-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-event"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy-version",
        "filterContract": [
          {
            "fieldId": "policy-version-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "policy-version-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-event-read-policy-version",
        "identityFieldId": "policy-version-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-version-id",
          "policy-id",
          "semantic-version",
          "artifact-reference",
          "rules-hash",
          "effective-from",
          "effective-to",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-event"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "authority-envelope",
        "filterContract": [
          {
            "fieldId": "authority-envelope-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "authority-envelope-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-event-read-authority-envelope",
        "identityFieldId": "authority-envelope-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "authority-envelope-id",
          "workblock-id",
          "grantor-person-id",
          "policy-version-id",
          "allowed-actions",
          "guard-conditions",
          "effective-from",
          "expires-at",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-event"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "action-proposal",
        "filterContract": [
          {
            "fieldId": "action-proposal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "action-proposal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-event-read-action-proposal",
        "identityFieldId": "action-proposal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "action-proposal-id",
          "workblock-id",
          "action-class",
          "subject-ref",
          "authority-envelope-id",
          "evidence-item-ids",
          "proposed-payload",
          "lifecycle-state",
          "created-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-event"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "committed-action",
        "filterContract": [
          {
            "fieldId": "committed-action-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "committed-action-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-event-read-committed-action",
        "identityFieldId": "committed-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "committed-action-id",
          "action-proposal-id",
          "authority-envelope-id",
          "idempotency-key",
          "commit-result",
          "committed-at",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-event"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "decision",
        "filterContract": [
          {
            "fieldId": "decision-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "decision-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-event-read-decision",
        "identityFieldId": "decision-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "decision-id",
          "decision-type",
          "subject-ref",
          "outcome",
          "authority-envelope-id",
          "evidence-item-ids",
          "rationale",
          "decided-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-event"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "exception",
        "filterContract": [
          {
            "fieldId": "exception-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "exception-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-event-read-exception",
        "identityFieldId": "exception-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "exception-id",
          "workblock-id",
          "exception-type",
          "subject-ref",
          "owner-person-id",
          "evidence-item-ids",
          "lifecycle-state",
          "opened-at",
          "resolution-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-event"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "audit-event",
        "filterContract": [
          {
            "fieldId": "audit-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "audit-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-event-read-audit-event",
        "identityFieldId": "audit-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "audit-event-id",
          "event-type",
          "subject-reference",
          "actor-reference",
          "version-context",
          "correlation-id",
          "summary",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-event"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-event",
        "filterContract": [
          {
            "fieldId": "business-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-event-read-business-event",
        "identityFieldId": "business-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-event-id",
          "event-type",
          "event-schema-version",
          "subject-reference",
          "correlation-id",
          "causation-id",
          "payload",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-event"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "learning-example",
        "filterContract": [
          {
            "fieldId": "learning-example-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "learning-example-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-event-read-learning-example",
        "identityFieldId": "learning-example-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "learning-evaluation-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "learning-example-id",
          "workblock-id",
          "example-type",
          "input-reference",
          "expected-output",
          "version-context",
          "validation-evidence-item-ids",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-event"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "evaluation-result",
        "filterContract": [
          {
            "fieldId": "evaluation-result-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "evaluation-result-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-event-read-evaluation-result",
        "identityFieldId": "evaluation-result-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "learning-evaluation-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "evaluation-result-id",
          "workblock-id",
          "candidate-version",
          "suite-version",
          "check-results",
          "disposition",
          "lifecycle-state",
          "completed-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-event"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "integration-state",
        "filterContract": [
          {
            "fieldId": "integration-state-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "integration-state-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-event-read-integration-state",
        "identityFieldId": "integration-state-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "integration-state-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "integration-state-id",
          "integration-id",
          "lifecycle-state",
          "last-successful-sync-at",
          "last-error-code",
          "last-good-reference",
          "updated-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-event"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "registry-release",
        "filterContract": [
          {
            "fieldId": "registry-release-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "registry-release-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-event-read-registry-release",
        "identityFieldId": "registry-release-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "registry-release-id",
          "registry-version",
          "previous-version",
          "content-hash",
          "compatibility-class",
          "change-summary",
          "migration-references",
          "lifecycle-state",
          "released-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "bid-evaluation-award"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "award-scenario",
        "filterContract": [
          {
            "fieldId": "award-scenario-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "award-scenario-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-bid-evaluation-award-read-award-scenario",
        "identityFieldId": "award-scenario-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "bid-evaluation-award",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "award-scenario-id",
          "scenario-number",
          "sourcing-event-id",
          "bid-source-ids",
          "evaluation-model",
          "normalised-results",
          "constraint-set",
          "recommended-party-ids",
          "allocation",
          "sensitivity-analysis",
          "committed-decision-id",
          "lifecycle-state",
          "evaluated-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "bid-evaluation-award"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "sourcing-event-record",
        "filterContract": [
          {
            "fieldId": "sourcing-event-record-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "sourcing-event-record-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-bid-evaluation-award-read-sourcing-event-record",
        "identityFieldId": "sourcing-event-record-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "sourcing-event",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "sourcing-event-record-id",
          "event-number",
          "published-version",
          "sourcing-opportunity-id",
          "category-id",
          "event-type",
          "event-specification",
          "invited-party-ids",
          "artifact-ids",
          "submission-deadline",
          "lifecycle-state",
          "last-reconciled-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "bid-evaluation-award"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-response",
        "filterContract": [
          {
            "fieldId": "supplier-response-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-response-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-bid-evaluation-award-read-supplier-response",
        "identityFieldId": "supplier-response-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "sourcing-event",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-response-id",
          "sourcing-event-record-id",
          "supplier-party-id",
          "response-version",
          "submitted-at",
          "total-price",
          "artifact-id",
          "evidence-item-ids",
          "supersedes-supplier-response-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "bid-evaluation-award"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "negotiation-session",
        "filterContract": [
          {
            "fieldId": "negotiation-session-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "negotiation-session-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-bid-evaluation-award-read-negotiation-session-downstream",
        "identityFieldId": "negotiation-session-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "negotiation-copilot",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "negotiation-session-id",
          "source-record-id",
          "counterparty-id",
          "objective-model",
          "issue-state",
          "authority-envelope-id",
          "exchange-artifact-ids",
          "current-proposal",
          "agreement-in-principle",
          "lifecycle-state",
          "next-exchange-due-at",
          "updated-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "bid-evaluation-award"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "tactical-sourcing-case",
        "filterContract": [
          {
            "fieldId": "tactical-sourcing-case-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "tactical-sourcing-case-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-bid-evaluation-award-read-tactical-sourcing-case-downstream",
        "identityFieldId": "tactical-sourcing-case-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "tactical-sourcing-autonomy",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "tactical-sourcing-case-id",
          "demand-case-id",
          "category-id",
          "eligibility-result",
          "authority-envelope-id",
          "invited-party-ids",
          "quote-request-artifact-id",
          "response-set",
          "award-proposal",
          "committed-action-id",
          "reconciliation-state",
          "lifecycle-state",
          "next-action-due-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "bid-evaluation-award"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-risk-assessment",
        "filterContract": [
          {
            "fieldId": "supplier-risk-assessment-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-risk-assessment-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-bid-evaluation-award-read-supplier-risk-assessment",
        "identityFieldId": "supplier-risk-assessment-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "third-party-risk-review",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-risk-assessment-id",
          "supplier-id",
          "assessment-scope",
          "policy-version",
          "evidence-state",
          "residual-risk-level",
          "lifecycle-state",
          "valid-to",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "negotiation-copilot"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "negotiation-session",
        "filterContract": [
          {
            "fieldId": "negotiation-session-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "negotiation-session-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-negotiation-copilot-read-negotiation-session",
        "identityFieldId": "negotiation-session-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "negotiation-copilot",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "negotiation-session-id",
          "source-record-id",
          "counterparty-id",
          "objective-model",
          "issue-state",
          "authority-envelope-id",
          "exchange-artifact-ids",
          "current-proposal",
          "agreement-in-principle",
          "lifecycle-state",
          "next-exchange-due-at",
          "updated-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "negotiation-copilot"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "award-scenario",
        "filterContract": [
          {
            "fieldId": "award-scenario-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "award-scenario-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-negotiation-copilot-read-award-scenario",
        "identityFieldId": "award-scenario-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "bid-evaluation-award",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "award-scenario-id",
          "sourcing-event-id",
          "evaluation-model",
          "normalised-results",
          "constraint-set",
          "recommended-party-ids",
          "allocation",
          "sensitivity-analysis",
          "committed-decision-id",
          "lifecycle-state",
          "evaluated-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "negotiation-copilot"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "sourcing-opportunity",
        "filterContract": [
          {
            "fieldId": "sourcing-opportunity-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "sourcing-opportunity-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-negotiation-copilot-read-sourcing-opportunity",
        "identityFieldId": "sourcing-opportunity-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "sourcing-pipeline-discovery",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "sourcing-opportunity-id",
          "category-id",
          "strategy-id",
          "demand-portfolio-id",
          "title",
          "scope-summary",
          "market-candidate-party-ids",
          "recommended-route",
          "value-hypothesis",
          "lifecycle-state",
          "evidence-as-of",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "negotiation-copilot"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "authority-envelope",
        "filterContract": [
          {
            "fieldId": "authority-envelope-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "authority-envelope-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-negotiation-copilot-read-authority-envelope",
        "identityFieldId": "authority-envelope-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "authority-envelope-id",
          "workblock-id",
          "grantor-person-id",
          "policy-version-id",
          "allowed-actions",
          "guard-conditions",
          "effective-from",
          "expires-at",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "negotiation-copilot"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-response",
        "filterContract": [
          {
            "fieldId": "supplier-response-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-response-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-negotiation-copilot-read-supplier-response",
        "identityFieldId": "supplier-response-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "sourcing-event",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-response-id",
          "sourcing-event-record-id",
          "supplier-party-id",
          "response-version",
          "submitted-at",
          "total-price",
          "artifact-id",
          "evidence-item-ids",
          "supersedes-supplier-response-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "tactical-sourcing-autonomy"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "tactical-sourcing-case",
        "filterContract": [
          {
            "fieldId": "tactical-sourcing-case-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "tactical-sourcing-case-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-tactical-sourcing-autonomy-read-tactical-sourcing-case",
        "identityFieldId": "tactical-sourcing-case-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "tactical-sourcing-autonomy",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "tactical-sourcing-case-id",
          "demand-case-id",
          "category-id",
          "eligibility-result",
          "authority-envelope-id",
          "invited-party-ids",
          "quote-request-artifact-id",
          "response-set",
          "award-proposal",
          "committed-action-id",
          "reconciliation-state",
          "lifecycle-state",
          "next-action-due-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "tactical-sourcing-autonomy"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "demand-case",
        "filterContract": [
          {
            "fieldId": "demand-case-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "demand-case-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-tactical-sourcing-autonomy-read-demand-case",
        "identityFieldId": "demand-case-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "demand-orchestration",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "demand-case-id",
          "intake-request-id",
          "enrichment-id",
          "route-code",
          "plan-version",
          "step-state",
          "owner-person-id",
          "committed-action-ids",
          "exception-id",
          "lifecycle-state",
          "next-action-due-at",
          "updated-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "tactical-sourcing-autonomy"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "sourcing-opportunity",
        "filterContract": [
          {
            "fieldId": "sourcing-opportunity-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "sourcing-opportunity-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-tactical-sourcing-autonomy-read-sourcing-opportunity",
        "identityFieldId": "sourcing-opportunity-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "sourcing-pipeline-discovery",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "sourcing-opportunity-id",
          "category-id",
          "scope-summary",
          "market-candidate-party-ids",
          "recommended-route",
          "value-hypothesis",
          "lifecycle-state",
          "evidence-as-of",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "tactical-sourcing-autonomy"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-response",
        "filterContract": [
          {
            "fieldId": "supplier-response-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-response-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-tactical-sourcing-autonomy-read-supplier-response",
        "identityFieldId": "supplier-response-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "sourcing-event",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-response-id",
          "sourcing-event-record-id",
          "supplier-party-id",
          "response-version",
          "submitted-at",
          "total-price",
          "artifact-id",
          "evidence-item-ids",
          "supersedes-supplier-response-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-intake-digitization"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-template",
        "filterContract": [
          {
            "fieldId": "contract-template-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-template-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-intake-digitization-read-contract-template",
        "identityFieldId": "contract-template-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "contract-authoring-review",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-template-id",
          "template-code",
          "semantic-version",
          "title",
          "artifact-id",
          "content-hash",
          "policy-version-id",
          "applicability-rules",
          "effective-from",
          "effective-to",
          "approval-decision-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-intake-digitization"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract",
        "filterContract": [
          {
            "fieldId": "contract-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-intake-digitization-read-contract",
        "identityFieldId": "contract-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "contract-approval-repository",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-id",
          "contract-number",
          "title",
          "supplier-id",
          "parent-contract-id",
          "current-version-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-intake-digitization"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-profile",
        "filterContract": [
          {
            "fieldId": "supplier-profile-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-profile-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-intake-digitization-read-supplier-profile",
        "identityFieldId": "supplier-profile-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-onboarding",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-profile-id",
          "supplier-number",
          "legal-name",
          "country-code",
          "legal-entity-identifier",
          "external-identifiers",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-authoring-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-intake",
        "filterContract": [
          {
            "fieldId": "contract-intake-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-intake-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-authoring-review-read-contract-intake",
        "identityFieldId": "contract-intake-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "contract-intake-digitization",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-intake-id",
          "candidate-contract-id",
          "source-artifact-ids",
          "lifecycle-state",
          "extraction-confidence",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-authoring-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-template",
        "filterContract": [
          {
            "fieldId": "contract-template-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-template-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-authoring-review-read-contract-template",
        "identityFieldId": "contract-template-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "contract-authoring-review",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-template-id",
          "template-code",
          "semantic-version",
          "title",
          "artifact-id",
          "content-hash",
          "policy-version-id",
          "applicability-rules",
          "effective-from",
          "effective-to",
          "approval-decision-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-authoring-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "clause-library-entry",
        "filterContract": [
          {
            "fieldId": "clause-library-entry-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "clause-library-entry-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-authoring-review-read-clause-library-entry",
        "identityFieldId": "clause-library-entry-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "contract-authoring-review",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "clause-library-entry-id",
          "clause-code",
          "semantic-version",
          "title",
          "clause-text",
          "text-hash",
          "policy-version-id",
          "jurisdiction-codes",
          "applicability-rules",
          "semantic-tags",
          "effective-from",
          "effective-to",
          "approval-decision-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-authoring-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract",
        "filterContract": [
          {
            "fieldId": "contract-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-authoring-review-read-contract",
        "identityFieldId": "contract-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "contract-approval-repository",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-id",
          "contract-number",
          "title",
          "supplier-id",
          "parent-contract-id",
          "current-version-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-authoring-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-version",
        "filterContract": [
          {
            "fieldId": "contract-version-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-version-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-authoring-review-read-contract-version",
        "identityFieldId": "contract-version-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "contract-authoring-review",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-version-id",
          "contract-id",
          "version-number",
          "parent-version-id",
          "artifact-id",
          "content-hash",
          "playbook-version",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-authoring-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "party",
        "filterContract": [
          {
            "fieldId": "party-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "party-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-authoring-review-read-party",
        "identityFieldId": "party-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "party-id",
          "legal-name",
          "party-type",
          "external-identifier",
          "registered-country-code",
          "lifecycle-state",
          "updated-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-authoring-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "person",
        "filterContract": [
          {
            "fieldId": "person-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "person-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-authoring-review-read-person",
        "identityFieldId": "person-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "person-id",
          "party-id",
          "identity-subject",
          "display-name",
          "primary-role",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-authoring-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "source-record-reference",
        "filterContract": [
          {
            "fieldId": "source-record-reference-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "source-record-reference-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-authoring-review-read-source-record-reference",
        "identityFieldId": "source-record-reference-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "source-record-reference-id",
          "source-system-id",
          "source-object-type",
          "source-record-id",
          "source-version",
          "source-schema-version",
          "observed-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-authoring-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "evidence-item",
        "filterContract": [
          {
            "fieldId": "evidence-item-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "evidence-item-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-authoring-review-read-evidence-item",
        "identityFieldId": "evidence-item-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "evidence-item-id",
          "evidence-type",
          "source-record-reference-id",
          "artifact-reference",
          "content-hash",
          "captured-at",
          "lifecycle-state",
          "classification",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-authoring-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy",
        "filterContract": [
          {
            "fieldId": "policy-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "policy-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-authoring-review-read-policy",
        "identityFieldId": "policy-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-id",
          "policy-code",
          "title",
          "owner-person-id",
          "active-version-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-authoring-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy-version",
        "filterContract": [
          {
            "fieldId": "policy-version-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "policy-version-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-authoring-review-read-policy-version",
        "identityFieldId": "policy-version-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-version-id",
          "policy-id",
          "semantic-version",
          "artifact-reference",
          "rules-hash",
          "effective-from",
          "effective-to",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-authoring-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "authority-envelope",
        "filterContract": [
          {
            "fieldId": "authority-envelope-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "authority-envelope-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-authoring-review-read-authority-envelope",
        "identityFieldId": "authority-envelope-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "authority-envelope-id",
          "workblock-id",
          "grantor-person-id",
          "policy-version-id",
          "allowed-actions",
          "guard-conditions",
          "effective-from",
          "expires-at",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-authoring-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "action-proposal",
        "filterContract": [
          {
            "fieldId": "action-proposal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "action-proposal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-authoring-review-read-action-proposal",
        "identityFieldId": "action-proposal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "action-proposal-id",
          "workblock-id",
          "action-class",
          "subject-ref",
          "authority-envelope-id",
          "evidence-item-ids",
          "proposed-payload",
          "lifecycle-state",
          "created-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-authoring-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "committed-action",
        "filterContract": [
          {
            "fieldId": "committed-action-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "committed-action-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-authoring-review-read-committed-action",
        "identityFieldId": "committed-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "committed-action-id",
          "action-proposal-id",
          "authority-envelope-id",
          "idempotency-key",
          "commit-result",
          "committed-at",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-authoring-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "decision",
        "filterContract": [
          {
            "fieldId": "decision-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "decision-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-authoring-review-read-decision",
        "identityFieldId": "decision-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "decision-id",
          "decision-type",
          "subject-ref",
          "outcome",
          "authority-envelope-id",
          "evidence-item-ids",
          "rationale",
          "decided-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-authoring-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "exception",
        "filterContract": [
          {
            "fieldId": "exception-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "exception-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-authoring-review-read-exception",
        "identityFieldId": "exception-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "exception-id",
          "workblock-id",
          "exception-type",
          "subject-ref",
          "owner-person-id",
          "evidence-item-ids",
          "lifecycle-state",
          "opened-at",
          "resolution-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-authoring-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "audit-event",
        "filterContract": [
          {
            "fieldId": "audit-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "audit-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-authoring-review-read-audit-event",
        "identityFieldId": "audit-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "audit-event-id",
          "event-type",
          "subject-reference",
          "actor-reference",
          "version-context",
          "correlation-id",
          "summary",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-authoring-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "learning-example",
        "filterContract": [
          {
            "fieldId": "learning-example-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "learning-example-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-authoring-review-read-learning-example",
        "identityFieldId": "learning-example-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "learning-evaluation-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "learning-example-id",
          "workblock-id",
          "example-type",
          "input-reference",
          "expected-output",
          "version-context",
          "validation-evidence-item-ids",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-authoring-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "evaluation-result",
        "filterContract": [
          {
            "fieldId": "evaluation-result-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "evaluation-result-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-authoring-review-read-evaluation-result",
        "identityFieldId": "evaluation-result-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "learning-evaluation-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "evaluation-result-id",
          "workblock-id",
          "candidate-version",
          "suite-version",
          "check-results",
          "disposition",
          "lifecycle-state",
          "completed-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-authoring-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "integration-state",
        "filterContract": [
          {
            "fieldId": "integration-state-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "integration-state-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-authoring-review-read-integration-state",
        "identityFieldId": "integration-state-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "integration-state-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "integration-state-id",
          "integration-id",
          "lifecycle-state",
          "last-successful-sync-at",
          "last-error-code",
          "last-good-reference",
          "updated-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-authoring-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "registry-release",
        "filterContract": [
          {
            "fieldId": "registry-release-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "registry-release-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-authoring-review-read-registry-release",
        "identityFieldId": "registry-release-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "registry-release-id",
          "registry-version",
          "previous-version",
          "content-hash",
          "compatibility-class",
          "change-summary",
          "migration-references",
          "lifecycle-state",
          "released-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-approval-repository"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-template",
        "filterContract": [
          {
            "fieldId": "contract-template-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-template-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-approval-repository-read-contract-template",
        "identityFieldId": "contract-template-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "contract-authoring-review",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-template-id",
          "template-code",
          "semantic-version",
          "title",
          "artifact-id",
          "content-hash",
          "policy-version-id",
          "applicability-rules",
          "effective-from",
          "effective-to",
          "approval-decision-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-approval-repository"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-version",
        "filterContract": [
          {
            "fieldId": "contract-version-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-version-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-approval-repository-read-contract-version",
        "identityFieldId": "contract-version-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "contract-authoring-review",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-version-id",
          "contract-id",
          "version-number",
          "artifact-id",
          "content-hash",
          "playbook-version",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-approval-repository"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "clause-deviation",
        "filterContract": [
          {
            "fieldId": "clause-deviation-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "clause-deviation-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-approval-repository-read-clause-deviation",
        "identityFieldId": "clause-deviation-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "contract-authoring-review",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "clause-deviation-id",
          "contract-version-id",
          "risk-level",
          "lifecycle-state",
          "resolution-rationale",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-approval-repository"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "audit-event",
        "filterContract": [
          {
            "fieldId": "audit-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "audit-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-approval-repository-read-audit-event",
        "identityFieldId": "audit-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "audit-event-id",
          "event-type",
          "subject-reference",
          "actor-reference",
          "version-context",
          "correlation-id",
          "summary",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-approval-repository"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-compliance-finding",
        "filterContract": [
          {
            "fieldId": "contract-compliance-finding-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-compliance-finding-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-approval-repository-read-contract-compliance-finding-downstream",
        "identityFieldId": "contract-compliance-finding-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "renewal-change-compliance",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-compliance-finding-id",
          "contract-id",
          "source-term-reference",
          "observed-evidence-ids",
          "finding-type",
          "severity",
          "estimated-impact",
          "lifecycle-state",
          "observed-at",
          "governance-authority-envelope-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "obligation-monitoring"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "clause-library-entry",
        "filterContract": [
          {
            "fieldId": "clause-library-entry-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "clause-library-entry-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-obligation-monitoring-read-clause-library-entry",
        "identityFieldId": "clause-library-entry-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "contract-authoring-review",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "clause-library-entry-id",
          "clause-code",
          "semantic-version",
          "title",
          "clause-text",
          "text-hash",
          "policy-version-id",
          "jurisdiction-codes",
          "applicability-rules",
          "semantic-tags",
          "effective-from",
          "effective-to",
          "approval-decision-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "obligation-monitoring"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract",
        "filterContract": [
          {
            "fieldId": "contract-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-obligation-monitoring-read-contract",
        "identityFieldId": "contract-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "contract-approval-repository",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-id",
          "current-version-id",
          "lifecycle-state",
          "effective-date",
          "expiry-date",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "obligation-monitoring"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-version",
        "filterContract": [
          {
            "fieldId": "contract-version-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-version-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-obligation-monitoring-read-contract-version",
        "identityFieldId": "contract-version-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "contract-authoring-review",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-version-id",
          "contract-id",
          "artifact-id",
          "content-hash",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "obligation-monitoring"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-approval",
        "filterContract": [
          {
            "fieldId": "contract-approval-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-approval-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-obligation-monitoring-read-contract-approval",
        "identityFieldId": "contract-approval-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "contract-approval-repository",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-approval-id",
          "contract-version-id",
          "content-hash",
          "decision-type",
          "lifecycle-state",
          "receipt-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "obligation-monitoring"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-event",
        "filterContract": [
          {
            "fieldId": "business-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-obligation-monitoring-read-business-event",
        "identityFieldId": "business-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-event-id",
          "event-type",
          "event-schema-version",
          "subject-reference",
          "correlation-id",
          "causation-id",
          "payload",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "obligation-monitoring"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-change",
        "filterContract": [
          {
            "fieldId": "contract-change-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-change-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-obligation-monitoring-read-contract-change-downstream",
        "identityFieldId": "contract-change-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "renewal-change-compliance",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-change-id",
          "contract-id",
          "change-type",
          "trigger-reference",
          "decision-deadline",
          "impact-summary",
          "lifecycle-state",
          "resulting-version-id",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "renewal-change-compliance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "clause-library-entry",
        "filterContract": [
          {
            "fieldId": "clause-library-entry-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "clause-library-entry-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-renewal-change-compliance-read-clause-library-entry",
        "identityFieldId": "clause-library-entry-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "contract-authoring-review",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "clause-library-entry-id",
          "clause-code",
          "semantic-version",
          "title",
          "clause-text",
          "text-hash",
          "policy-version-id",
          "jurisdiction-codes",
          "applicability-rules",
          "semantic-tags",
          "effective-from",
          "effective-to",
          "approval-decision-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "renewal-change-compliance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract",
        "filterContract": [
          {
            "fieldId": "contract-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-renewal-change-compliance-read-contract",
        "identityFieldId": "contract-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "contract-approval-repository",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-id",
          "contract-number",
          "supplier-id",
          "current-version-id",
          "lifecycle-state",
          "effective-date",
          "expiry-date",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "renewal-change-compliance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-version",
        "filterContract": [
          {
            "fieldId": "contract-version-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-version-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-renewal-change-compliance-read-contract-version",
        "identityFieldId": "contract-version-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "contract-authoring-review",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-version-id",
          "contract-id",
          "artifact-id",
          "content-hash",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "renewal-change-compliance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-obligation",
        "filterContract": [
          {
            "fieldId": "contract-obligation-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-obligation-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-renewal-change-compliance-read-contract-obligation",
        "identityFieldId": "contract-obligation-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "obligation-monitoring",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-obligation-id",
          "contract-id",
          "clause-anchor",
          "obligation-type",
          "due-at",
          "evidence-requirements",
          "risk-level",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "renewal-change-compliance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-entitlement",
        "filterContract": [
          {
            "fieldId": "contract-entitlement-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-entitlement-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-renewal-change-compliance-read-contract-entitlement",
        "identityFieldId": "contract-entitlement-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "obligation-monitoring",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-entitlement-id",
          "contract-id",
          "clause-anchor",
          "entitlement-type",
          "trigger-condition",
          "estimated-value",
          "trigger-date",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "renewal-change-compliance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-change",
        "filterContract": [
          {
            "fieldId": "contract-change-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-change-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-renewal-change-compliance-read-contract-change",
        "identityFieldId": "contract-change-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "renewal-change-compliance",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-change-id",
          "contract-id",
          "change-type",
          "trigger-reference",
          "decision-deadline",
          "impact-summary",
          "lifecycle-state",
          "resulting-version-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "renewal-change-compliance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-compliance-finding",
        "filterContract": [
          {
            "fieldId": "contract-compliance-finding-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-compliance-finding-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-renewal-change-compliance-read-contract-compliance-finding",
        "identityFieldId": "contract-compliance-finding-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "renewal-change-compliance",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-compliance-finding-id",
          "contract-id",
          "source-term-reference",
          "observed-evidence-ids",
          "finding-type",
          "severity",
          "estimated-impact",
          "lifecycle-state",
          "observed-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-onboarding"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-qualification",
        "filterContract": [
          {
            "fieldId": "supplier-qualification-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-qualification-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-onboarding-read-supplier-qualification",
        "identityFieldId": "supplier-qualification-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-master-qualification",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-qualification-id",
          "supplier-id",
          "scope-code",
          "policy-version",
          "conditions",
          "lifecycle-state",
          "valid-from",
          "valid-to",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-onboarding"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-risk-assessment",
        "filterContract": [
          {
            "fieldId": "supplier-risk-assessment-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-risk-assessment-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-onboarding-read-supplier-risk-assessment",
        "identityFieldId": "supplier-risk-assessment-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "third-party-risk-review",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-risk-assessment-id",
          "supplier-id",
          "assessment-scope",
          "policy-version",
          "residual-risk-level",
          "lifecycle-state",
          "valid-to",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-onboarding"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "party",
        "filterContract": [
          {
            "fieldId": "party-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "party-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-onboarding-read-party",
        "identityFieldId": "party-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "party-id",
          "legal-name",
          "party-type",
          "external-identifier",
          "registered-country-code",
          "lifecycle-state",
          "updated-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-onboarding"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "source-record-reference",
        "filterContract": [
          {
            "fieldId": "source-record-reference-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "source-record-reference-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-onboarding-read-source-record-reference",
        "identityFieldId": "source-record-reference-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "source-record-reference-id",
          "source-system-id",
          "source-object-type",
          "source-record-id",
          "source-version",
          "source-schema-version",
          "observed-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-onboarding"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy",
        "filterContract": [
          {
            "fieldId": "policy-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "policy-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-onboarding-read-policy",
        "identityFieldId": "policy-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-id",
          "policy-code",
          "title",
          "owner-person-id",
          "active-version-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-onboarding"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "integration-state",
        "filterContract": [
          {
            "fieldId": "integration-state-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "integration-state-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-onboarding-read-integration-state",
        "identityFieldId": "integration-state-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "integration-state-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "integration-state-id",
          "integration-id",
          "lifecycle-state",
          "last-successful-sync-at",
          "last-error-code",
          "last-good-reference",
          "updated-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-onboarding"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "registry-release",
        "filterContract": [
          {
            "fieldId": "registry-release-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "registry-release-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-onboarding-read-registry-release",
        "identityFieldId": "registry-release-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "registry-release-id",
          "registry-version",
          "previous-version",
          "content-hash",
          "compatibility-class",
          "change-summary",
          "migration-references",
          "lifecycle-state",
          "released-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-master-qualification"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-profile",
        "filterContract": [
          {
            "fieldId": "supplier-profile-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-profile-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-master-qualification-read-supplier-profile",
        "identityFieldId": "supplier-profile-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-onboarding",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-profile-id",
          "supplier-number",
          "legal-name",
          "country-code",
          "external-identifiers",
          "lifecycle-state",
          "eligibility-status",
          "verified-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-master-qualification"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-onboarding-case",
        "filterContract": [
          {
            "fieldId": "supplier-onboarding-case-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-onboarding-case-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-master-qualification-read-supplier-onboarding-case",
        "identityFieldId": "supplier-onboarding-case-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-onboarding",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-onboarding-case-id",
          "supplier-id",
          "requirement-set-version",
          "evidence-state",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-master-qualification"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-risk-assessment",
        "filterContract": [
          {
            "fieldId": "supplier-risk-assessment-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-risk-assessment-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-master-qualification-read-supplier-risk-assessment",
        "identityFieldId": "supplier-risk-assessment-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "third-party-risk-review",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-risk-assessment-id",
          "supplier-id",
          "assessment-scope",
          "policy-version",
          "evidence-state",
          "residual-risk-level",
          "lifecycle-state",
          "valid-to",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-master-qualification"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-master-change",
        "filterContract": [
          {
            "fieldId": "supplier-master-change-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-master-change-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-master-qualification-read-supplier-master-change",
        "identityFieldId": "supplier-master-change-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-master-qualification",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-master-change-id",
          "supplier-id",
          "change-type",
          "change-payload",
          "verification-state",
          "idempotency-key",
          "lifecycle-state",
          "requested-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-master-qualification"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "evidence-item",
        "filterContract": [
          {
            "fieldId": "evidence-item-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "evidence-item-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-master-qualification-read-evidence-item",
        "identityFieldId": "evidence-item-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "evidence-item-id",
          "evidence-type",
          "source-record-reference-id",
          "artifact-reference",
          "content-hash",
          "captured-at",
          "lifecycle-state",
          "classification",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-master-qualification"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-performance-observation",
        "filterContract": [
          {
            "fieldId": "supplier-performance-observation-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-performance-observation-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-master-qualification-read-supplier-performance-observation",
        "identityFieldId": "supplier-performance-observation-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-performance-monitor-correct",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-performance-observation-id",
          "supplier-party-id",
          "category-id",
          "service-id",
          "measure-code",
          "measure-definition-version",
          "performance-period-start",
          "performance-period-end",
          "target-value",
          "observed-value",
          "unit-code",
          "quality-status",
          "breach-status",
          "correction-status",
          "observed-at",
          "evidence-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "third-party-risk-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-profile",
        "filterContract": [
          {
            "fieldId": "supplier-profile-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-profile-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-third-party-risk-review-read-supplier-profile",
        "identityFieldId": "supplier-profile-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-onboarding",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-profile-id",
          "legal-name",
          "country-code",
          "external-identifiers",
          "lifecycle-state",
          "eligibility-status",
          "verified-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "third-party-risk-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-onboarding-case",
        "filterContract": [
          {
            "fieldId": "supplier-onboarding-case-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-onboarding-case-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-third-party-risk-review-read-supplier-onboarding-case",
        "identityFieldId": "supplier-onboarding-case-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-onboarding",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-onboarding-case-id",
          "supplier-id",
          "requirement-set-version",
          "evidence-state",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "third-party-risk-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-qualification",
        "filterContract": [
          {
            "fieldId": "supplier-qualification-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-qualification-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-third-party-risk-review-read-supplier-qualification",
        "identityFieldId": "supplier-qualification-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-master-qualification",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-qualification-id",
          "supplier-id",
          "scope-code",
          "conditions",
          "lifecycle-state",
          "valid-to",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "third-party-risk-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-risk-signal",
        "filterContract": [
          {
            "fieldId": "supplier-risk-signal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-risk-signal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-third-party-risk-review-read-supplier-risk-signal",
        "identityFieldId": "supplier-risk-signal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "continuous-risk-monitoring",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-risk-signal-id",
          "supplier-id",
          "risk-domain",
          "source-reference",
          "materiality",
          "confidence",
          "observed-at",
          "ingested-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "third-party-risk-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-tier-link",
        "filterContract": [
          {
            "fieldId": "supplier-tier-link-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-tier-link-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-third-party-risk-review-read-supplier-tier-link",
        "identityFieldId": "supplier-tier-link-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "continuous-risk-monitoring",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-tier-link-id",
          "from-supplier-id",
          "to-supplier-id",
          "external-node",
          "dependency-type",
          "evidence-reference",
          "confidence",
          "lifecycle-state",
          "valid-to",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "third-party-risk-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "person",
        "filterContract": [
          {
            "fieldId": "person-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "person-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-third-party-risk-review-read-person",
        "identityFieldId": "person-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "person-id",
          "party-id",
          "identity-subject",
          "display-name",
          "primary-role",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "third-party-risk-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "evidence-item",
        "filterContract": [
          {
            "fieldId": "evidence-item-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "evidence-item-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-third-party-risk-review-read-evidence-item",
        "identityFieldId": "evidence-item-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "evidence-item-id",
          "evidence-type",
          "source-record-reference-id",
          "artifact-reference",
          "content-hash",
          "captured-at",
          "lifecycle-state",
          "classification",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "third-party-risk-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy-version",
        "filterContract": [
          {
            "fieldId": "policy-version-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "policy-version-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-third-party-risk-review-read-policy-version",
        "identityFieldId": "policy-version-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-version-id",
          "policy-id",
          "semantic-version",
          "artifact-reference",
          "rules-hash",
          "effective-from",
          "effective-to",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "third-party-risk-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "authority-envelope",
        "filterContract": [
          {
            "fieldId": "authority-envelope-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "authority-envelope-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-third-party-risk-review-read-authority-envelope",
        "identityFieldId": "authority-envelope-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "authority-envelope-id",
          "workblock-id",
          "grantor-person-id",
          "policy-version-id",
          "allowed-actions",
          "guard-conditions",
          "effective-from",
          "expires-at",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "third-party-risk-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "action-proposal",
        "filterContract": [
          {
            "fieldId": "action-proposal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "action-proposal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-third-party-risk-review-read-action-proposal",
        "identityFieldId": "action-proposal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "action-proposal-id",
          "workblock-id",
          "action-class",
          "subject-ref",
          "authority-envelope-id",
          "evidence-item-ids",
          "proposed-payload",
          "lifecycle-state",
          "created-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "third-party-risk-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "committed-action",
        "filterContract": [
          {
            "fieldId": "committed-action-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "committed-action-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-third-party-risk-review-read-committed-action",
        "identityFieldId": "committed-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "committed-action-id",
          "action-proposal-id",
          "authority-envelope-id",
          "idempotency-key",
          "commit-result",
          "committed-at",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "third-party-risk-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "decision",
        "filterContract": [
          {
            "fieldId": "decision-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "decision-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-third-party-risk-review-read-decision",
        "identityFieldId": "decision-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "decision-id",
          "decision-type",
          "subject-ref",
          "outcome",
          "authority-envelope-id",
          "evidence-item-ids",
          "rationale",
          "decided-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "third-party-risk-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "exception",
        "filterContract": [
          {
            "fieldId": "exception-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "exception-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-third-party-risk-review-read-exception",
        "identityFieldId": "exception-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "exception-id",
          "workblock-id",
          "exception-type",
          "subject-ref",
          "owner-person-id",
          "evidence-item-ids",
          "lifecycle-state",
          "opened-at",
          "resolution-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "third-party-risk-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "audit-event",
        "filterContract": [
          {
            "fieldId": "audit-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "audit-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-third-party-risk-review-read-audit-event",
        "identityFieldId": "audit-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "audit-event-id",
          "event-type",
          "subject-reference",
          "actor-reference",
          "version-context",
          "correlation-id",
          "summary",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "third-party-risk-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-event",
        "filterContract": [
          {
            "fieldId": "business-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-third-party-risk-review-read-business-event",
        "identityFieldId": "business-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-event-id",
          "event-type",
          "event-schema-version",
          "subject-reference",
          "correlation-id",
          "causation-id",
          "payload",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "third-party-risk-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "learning-example",
        "filterContract": [
          {
            "fieldId": "learning-example-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "learning-example-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-third-party-risk-review-read-learning-example",
        "identityFieldId": "learning-example-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "learning-evaluation-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "learning-example-id",
          "workblock-id",
          "example-type",
          "input-reference",
          "expected-output",
          "version-context",
          "validation-evidence-item-ids",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "third-party-risk-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "evaluation-result",
        "filterContract": [
          {
            "fieldId": "evaluation-result-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "evaluation-result-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-third-party-risk-review-read-evaluation-result",
        "identityFieldId": "evaluation-result-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "learning-evaluation-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "evaluation-result-id",
          "workblock-id",
          "candidate-version",
          "suite-version",
          "check-results",
          "disposition",
          "lifecycle-state",
          "completed-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "continuous-risk-monitoring"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-profile",
        "filterContract": [
          {
            "fieldId": "supplier-profile-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-profile-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-continuous-risk-monitoring-read-supplier-profile",
        "identityFieldId": "supplier-profile-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-onboarding",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-profile-id",
          "legal-name",
          "country-code",
          "external-identifiers",
          "lifecycle-state",
          "eligibility-status",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "continuous-risk-monitoring"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-risk-assessment",
        "filterContract": [
          {
            "fieldId": "supplier-risk-assessment-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-risk-assessment-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-continuous-risk-monitoring-read-supplier-risk-assessment",
        "identityFieldId": "supplier-risk-assessment-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "third-party-risk-review",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-risk-assessment-id",
          "supplier-id",
          "assessment-scope",
          "evidence-state",
          "residual-risk-level",
          "lifecycle-state",
          "valid-to",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "continuous-risk-monitoring"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-master-change",
        "filterContract": [
          {
            "fieldId": "supplier-master-change-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-master-change-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-continuous-risk-monitoring-read-supplier-master-change-downstream",
        "identityFieldId": "supplier-master-change-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-master-qualification",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-master-change-id",
          "supplier-id",
          "change-type",
          "change-payload",
          "verification-state",
          "idempotency-key",
          "lifecycle-state",
          "requested-at",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-remediation-exit"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-profile",
        "filterContract": [
          {
            "fieldId": "supplier-profile-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-profile-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-remediation-exit-read-supplier-profile",
        "identityFieldId": "supplier-profile-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-onboarding",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-profile-id",
          "supplier-number",
          "legal-name",
          "lifecycle-state",
          "eligibility-status",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-remediation-exit"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-risk-assessment",
        "filterContract": [
          {
            "fieldId": "supplier-risk-assessment-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-risk-assessment-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-remediation-exit-read-supplier-risk-assessment",
        "identityFieldId": "supplier-risk-assessment-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "third-party-risk-review",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-risk-assessment-id",
          "supplier-id",
          "assessment-scope",
          "evidence-state",
          "residual-risk-level",
          "lifecycle-state",
          "valid-to",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-remediation-exit"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-risk-case",
        "filterContract": [
          {
            "fieldId": "supplier-risk-case-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-risk-case-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-remediation-exit-read-supplier-risk-case",
        "identityFieldId": "supplier-risk-case-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "continuous-risk-monitoring",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-risk-case-id",
          "supplier-id",
          "signal-ids",
          "severity",
          "proposed-action",
          "lifecycle-state",
          "opened-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-remediation-exit"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-remediation-action",
        "filterContract": [
          {
            "fieldId": "supplier-remediation-action-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-remediation-action-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-remediation-exit-read-supplier-remediation-action",
        "identityFieldId": "supplier-remediation-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-remediation-exit",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-remediation-action-id",
          "supplier-id",
          "origin-reference",
          "required-outcome",
          "evidence-requirements",
          "owner-reference",
          "due-at",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-remediation-exit"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-offboarding-case",
        "filterContract": [
          {
            "fieldId": "supplier-offboarding-case-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-offboarding-case-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-remediation-exit-read-supplier-offboarding-case",
        "identityFieldId": "supplier-offboarding-case-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-remediation-exit",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-offboarding-case-id",
          "supplier-id",
          "exit-reason-code",
          "dependency-state",
          "target-completion-at",
          "lifecycle-state",
          "completed-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-remediation-exit"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract",
        "filterContract": [
          {
            "fieldId": "contract-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-remediation-exit-read-contract",
        "identityFieldId": "contract-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "contract-approval-repository",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-id",
          "contract-number",
          "supplier-id",
          "lifecycle-state",
          "expiry-date",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-remediation-exit"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "purchase-order",
        "filterContract": [
          {
            "fieldId": "purchase-order-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "purchase-order-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-remediation-exit-read-purchase-order",
        "identityFieldId": "purchase-order-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "purchase-order-orchestration",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "purchase-order-id",
          "purchase-order-number",
          "supplier-id",
          "lifecycle-state",
          "total-amount",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "guided-buying"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "catalogue-line",
        "filterContract": [
          {
            "fieldId": "catalogue-line-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "catalogue-line-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-guided-buying-read-catalogue-line",
        "identityFieldId": "catalogue-line-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "catalogue-management-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "catalogue-line-id",
          "buying-mode",
          "supplier-id",
          "supplier-item-id",
          "description",
          "classification-code",
          "unit-price",
          "contract-id",
          "buying-constraints",
          "lifecycle-state",
          "valid-to",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "guided-buying"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-profile",
        "filterContract": [
          {
            "fieldId": "supplier-profile-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-profile-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-guided-buying-read-supplier-profile",
        "identityFieldId": "supplier-profile-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-onboarding",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-profile-id",
          "legal-name",
          "lifecycle-state",
          "eligibility-status",
          "verified-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "guided-buying"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-qualification",
        "filterContract": [
          {
            "fieldId": "supplier-qualification-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-qualification-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-guided-buying-read-supplier-qualification",
        "identityFieldId": "supplier-qualification-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-master-qualification",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-qualification-id",
          "supplier-id",
          "scope-code",
          "conditions",
          "lifecycle-state",
          "valid-to",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "guided-buying"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract",
        "filterContract": [
          {
            "fieldId": "contract-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-guided-buying-read-contract",
        "identityFieldId": "contract-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "contract-approval-repository",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-id",
          "contract-number",
          "supplier-id",
          "lifecycle-state",
          "effective-date",
          "expiry-date",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "guided-buying"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "party",
        "filterContract": [
          {
            "fieldId": "party-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "party-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-guided-buying-read-party",
        "identityFieldId": "party-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "party-id",
          "legal-name",
          "party-type",
          "external-identifier",
          "registered-country-code",
          "lifecycle-state",
          "updated-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "guided-buying"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-unit",
        "filterContract": [
          {
            "fieldId": "business-unit-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-unit-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-guided-buying-read-business-unit",
        "identityFieldId": "business-unit-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-unit-id",
          "external-key",
          "name",
          "parent-business-unit-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "guided-buying"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "category",
        "filterContract": [
          {
            "fieldId": "category-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "category-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-guided-buying-read-category",
        "identityFieldId": "category-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "category-id",
          "taxonomy-version-id",
          "code",
          "name",
          "parent-category-id",
          "external-classification",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "guided-buying"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "item-service",
        "filterContract": [
          {
            "fieldId": "item-service-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "item-service-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-guided-buying-read-item-service",
        "identityFieldId": "item-service-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "item-service-id",
          "kind",
          "buying-mode",
          "name",
          "description",
          "category-id",
          "external-identifier",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "guided-buying"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "source-record-reference",
        "filterContract": [
          {
            "fieldId": "source-record-reference-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "source-record-reference-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-guided-buying-read-source-record-reference",
        "identityFieldId": "source-record-reference-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "source-record-reference-id",
          "source-system-id",
          "source-object-type",
          "source-record-id",
          "source-version",
          "source-schema-version",
          "observed-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "guided-buying"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy",
        "filterContract": [
          {
            "fieldId": "policy-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "policy-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-guided-buying-read-policy",
        "identityFieldId": "policy-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-id",
          "policy-code",
          "title",
          "owner-person-id",
          "active-version-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "guided-buying"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy-version",
        "filterContract": [
          {
            "fieldId": "policy-version-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "policy-version-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-guided-buying-read-policy-version",
        "identityFieldId": "policy-version-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-version-id",
          "policy-id",
          "semantic-version",
          "artifact-reference",
          "rules-hash",
          "effective-from",
          "effective-to",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "guided-buying"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "authority-envelope",
        "filterContract": [
          {
            "fieldId": "authority-envelope-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "authority-envelope-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-guided-buying-read-authority-envelope",
        "identityFieldId": "authority-envelope-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "authority-envelope-id",
          "workblock-id",
          "grantor-person-id",
          "policy-version-id",
          "allowed-actions",
          "guard-conditions",
          "effective-from",
          "expires-at",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "guided-buying"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "evaluation-result",
        "filterContract": [
          {
            "fieldId": "evaluation-result-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "evaluation-result-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-guided-buying-read-evaluation-result",
        "identityFieldId": "evaluation-result-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "learning-evaluation-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "evaluation-result-id",
          "workblock-id",
          "candidate-version",
          "suite-version",
          "check-results",
          "disposition",
          "lifecycle-state",
          "completed-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "guided-buying"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "integration-state",
        "filterContract": [
          {
            "fieldId": "integration-state-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "integration-state-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-guided-buying-read-integration-state",
        "identityFieldId": "integration-state-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "integration-state-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "integration-state-id",
          "integration-id",
          "lifecycle-state",
          "last-successful-sync-at",
          "last-error-code",
          "last-good-reference",
          "updated-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "guided-buying"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "registry-release",
        "filterContract": [
          {
            "fieldId": "registry-release-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "registry-release-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-guided-buying-read-registry-release",
        "identityFieldId": "registry-release-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "registry-release-id",
          "registry-version",
          "previous-version",
          "content-hash",
          "compatibility-class",
          "change-summary",
          "migration-references",
          "lifecycle-state",
          "released-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "requisition-policy-routing"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "buying-request",
        "filterContract": [
          {
            "fieldId": "buying-request-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "buying-request-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-requisition-policy-routing-read-buying-request",
        "identityFieldId": "buying-request-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "guided-buying",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "buying-request-id",
          "requester-reference",
          "business-unit-code",
          "need-description",
          "classification-code",
          "estimated-value",
          "needed-by-date",
          "option-set",
          "selected-route",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "requisition-policy-routing"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "catalogue-line",
        "filterContract": [
          {
            "fieldId": "catalogue-line-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "catalogue-line-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-requisition-policy-routing-read-catalogue-line",
        "identityFieldId": "catalogue-line-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "catalogue-management-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "catalogue-line-id",
          "buying-mode",
          "supplier-id",
          "unit-price",
          "contract-id",
          "buying-constraints",
          "lifecycle-state",
          "valid-to",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "requisition-policy-routing"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-profile",
        "filterContract": [
          {
            "fieldId": "supplier-profile-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-profile-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-requisition-policy-routing-read-supplier-profile",
        "identityFieldId": "supplier-profile-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-onboarding",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-profile-id",
          "lifecycle-state",
          "eligibility-status",
          "verified-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "requisition-policy-routing"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-qualification",
        "filterContract": [
          {
            "fieldId": "supplier-qualification-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-qualification-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-requisition-policy-routing-read-supplier-qualification",
        "identityFieldId": "supplier-qualification-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-master-qualification",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-qualification-id",
          "supplier-id",
          "scope-code",
          "conditions",
          "lifecycle-state",
          "valid-to",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "requisition-policy-routing"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "budget",
        "filterContract": [
          {
            "fieldId": "budget-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "budget-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-requisition-policy-routing-read-budget",
        "identityFieldId": "budget-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "demand-consolidation-portfolio",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "budget-id",
          "company-party-id",
          "business-unit-id",
          "owner-role-id",
          "budget-code",
          "period-start",
          "period-end",
          "authorised-amount",
          "supersedes-budget-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "purchase-order-orchestration"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "requisition",
        "filterContract": [
          {
            "fieldId": "requisition-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "requisition-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-purchase-order-orchestration-read-requisition",
        "identityFieldId": "requisition-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "requisition-policy-routing",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "requisition-id",
          "requisition-number",
          "requester-reference",
          "business-unit-code",
          "total-amount",
          "policy-evaluation",
          "budget-reservation",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "purchase-order-orchestration"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "requisition-line",
        "filterContract": [
          {
            "fieldId": "requisition-line-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "requisition-line-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-purchase-order-orchestration-read-requisition-line",
        "identityFieldId": "requisition-line-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "requisition-policy-routing",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "requisition-line-id",
          "requisition-id",
          "line-number",
          "catalogue-line-id",
          "supplier-id",
          "description",
          "quantity",
          "unit-price",
          "accounting-splits",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "purchase-order-orchestration"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-profile",
        "filterContract": [
          {
            "fieldId": "supplier-profile-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-profile-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-purchase-order-orchestration-read-supplier-profile",
        "identityFieldId": "supplier-profile-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-onboarding",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-profile-id",
          "supplier-number",
          "legal-name",
          "lifecycle-state",
          "eligibility-status",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "purchase-order-orchestration"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract",
        "filterContract": [
          {
            "fieldId": "contract-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-purchase-order-orchestration-read-contract",
        "identityFieldId": "contract-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "contract-approval-repository",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-id",
          "contract-number",
          "supplier-id",
          "current-version-id",
          "lifecycle-state",
          "effective-date",
          "expiry-date",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "purchase-order-orchestration"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "catalogue-line",
        "filterContract": [
          {
            "fieldId": "catalogue-line-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "catalogue-line-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-purchase-order-orchestration-read-catalogue-line",
        "identityFieldId": "catalogue-line-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "catalogue-management-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "catalogue-line-id",
          "buying-mode",
          "supplier-id",
          "supplier-item-id",
          "description",
          "classification-code",
          "unit-price",
          "contract-id",
          "buying-constraints",
          "lifecycle-state",
          "valid-to",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "purchase-order-exception"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "purchase-order",
        "filterContract": [
          {
            "fieldId": "purchase-order-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "purchase-order-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-purchase-order-exception-read-purchase-order",
        "identityFieldId": "purchase-order-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "purchase-order-orchestration",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "purchase-order-id",
          "purchase-order-number",
          "order-version",
          "requisition-id",
          "supplier-id",
          "contract-id",
          "total-amount",
          "authority-reference",
          "idempotency-key",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "purchase-order-exception"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "order-line",
        "filterContract": [
          {
            "fieldId": "order-line-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "order-line-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-purchase-order-exception-read-order-line",
        "identityFieldId": "order-line-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "purchase-order-orchestration",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "order-line-id",
          "purchase-order-id",
          "requisition-line-id",
          "line-number",
          "ordered-quantity",
          "unit-price",
          "delivery-requirement",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "purchase-order-exception"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "order-response",
        "filterContract": [
          {
            "fieldId": "order-response-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "order-response-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-purchase-order-exception-read-order-response",
        "identityFieldId": "order-response-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "purchase-order-orchestration",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "order-response-id",
          "purchase-order-id",
          "supplier-response-id",
          "response-code",
          "proposed-changes",
          "artifact-id",
          "received-at",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "purchase-order-exception"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "purchase-order-exception",
        "filterContract": [
          {
            "fieldId": "purchase-order-exception-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "purchase-order-exception-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-purchase-order-exception-read-purchase-order-exception",
        "identityFieldId": "purchase-order-exception-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "purchase-order-exception",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "purchase-order-exception-id",
          "purchase-order-id",
          "order-line-id",
          "exception-type",
          "deduplication-key",
          "severity",
          "proposed-resolution",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "purchase-order-exception"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "shipment",
        "filterContract": [
          {
            "fieldId": "shipment-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "shipment-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-purchase-order-exception-read-shipment",
        "identityFieldId": "shipment-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "receiving-service-entry",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "shipment-id",
          "purchase-order-id",
          "despatch-lines",
          "expected-delivery-at",
          "lifecycle-state",
          "observed-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "purchase-order-exception"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "receipt",
        "filterContract": [
          {
            "fieldId": "receipt-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "receipt-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-purchase-order-exception-read-receipt",
        "identityFieldId": "receipt-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "receiving-service-entry",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "receipt-id",
          "purchase-order-id",
          "shipment-id",
          "lifecycle-state",
          "received-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "purchase-order-exception"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "authority-envelope",
        "filterContract": [
          {
            "fieldId": "authority-envelope-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "authority-envelope-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-purchase-order-exception-read-authority-envelope",
        "identityFieldId": "authority-envelope-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "authority-envelope-id",
          "workblock-id",
          "grantor-person-id",
          "policy-version-id",
          "allowed-actions",
          "guard-conditions",
          "effective-from",
          "expires-at",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "purchase-order-exception"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "action-proposal",
        "filterContract": [
          {
            "fieldId": "action-proposal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "action-proposal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-purchase-order-exception-read-action-proposal",
        "identityFieldId": "action-proposal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "action-proposal-id",
          "workblock-id",
          "action-class",
          "subject-ref",
          "authority-envelope-id",
          "evidence-item-ids",
          "proposed-payload",
          "lifecycle-state",
          "created-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "purchase-order-exception"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "committed-action",
        "filterContract": [
          {
            "fieldId": "committed-action-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "committed-action-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-purchase-order-exception-read-committed-action",
        "identityFieldId": "committed-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "committed-action-id",
          "action-proposal-id",
          "authority-envelope-id",
          "idempotency-key",
          "commit-result",
          "committed-at",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "purchase-order-exception"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "decision",
        "filterContract": [
          {
            "fieldId": "decision-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "decision-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-purchase-order-exception-read-decision",
        "identityFieldId": "decision-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "decision-id",
          "decision-type",
          "subject-ref",
          "outcome",
          "authority-envelope-id",
          "evidence-item-ids",
          "rationale",
          "decided-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "purchase-order-exception"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "exception",
        "filterContract": [
          {
            "fieldId": "exception-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "exception-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-purchase-order-exception-read-exception",
        "identityFieldId": "exception-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "exception-id",
          "workblock-id",
          "exception-type",
          "subject-ref",
          "owner-person-id",
          "evidence-item-ids",
          "lifecycle-state",
          "opened-at",
          "resolution-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "purchase-order-exception"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "audit-event",
        "filterContract": [
          {
            "fieldId": "audit-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "audit-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-purchase-order-exception-read-audit-event",
        "identityFieldId": "audit-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "audit-event-id",
          "event-type",
          "subject-reference",
          "actor-reference",
          "version-context",
          "correlation-id",
          "summary",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "purchase-order-exception"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-event",
        "filterContract": [
          {
            "fieldId": "business-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-purchase-order-exception-read-business-event",
        "identityFieldId": "business-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-event-id",
          "event-type",
          "event-schema-version",
          "subject-reference",
          "correlation-id",
          "causation-id",
          "payload",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "purchase-order-exception"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "catalogue-line",
        "filterContract": [
          {
            "fieldId": "catalogue-line-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "catalogue-line-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-purchase-order-exception-read-catalogue-line",
        "identityFieldId": "catalogue-line-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "catalogue-management-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "catalogue-line-id",
          "buying-mode",
          "supplier-id",
          "supplier-item-id",
          "description",
          "classification-code",
          "unit-price",
          "contract-id",
          "buying-constraints",
          "lifecycle-state",
          "valid-to",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "purchase-order-exception"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "return-claim",
        "filterContract": [
          {
            "fieldId": "return-claim-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "return-claim-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-purchase-order-exception-read-return-claim-downstream",
        "identityFieldId": "return-claim-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "receiving-service-entry",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "return-claim-id",
          "return-reference",
          "purchase-order-id",
          "receipt-line-ids",
          "claim-reason-code",
          "evidence-ids",
          "expected-recovery",
          "recovery-due-at",
          "lifecycle-state",
          "governance-authority-envelope-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "receiving-service-entry"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "purchase-order",
        "filterContract": [
          {
            "fieldId": "purchase-order-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "purchase-order-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-receiving-service-entry-read-purchase-order",
        "identityFieldId": "purchase-order-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "purchase-order-orchestration",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "purchase-order-id",
          "purchase-order-number",
          "order-version",
          "supplier-id",
          "contract-id",
          "total-amount",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "receiving-service-entry"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "order-line",
        "filterContract": [
          {
            "fieldId": "order-line-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "order-line-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-receiving-service-entry-read-order-line",
        "identityFieldId": "order-line-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "purchase-order-orchestration",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "order-line-id",
          "purchase-order-id",
          "line-number",
          "item-identifiers",
          "description",
          "ordered-quantity",
          "unit-price",
          "delivery-requirement",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "receiving-service-entry"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "receipt-line",
        "filterContract": [
          {
            "fieldId": "receipt-line-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "receipt-line-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-receiving-service-entry-read-receipt-line",
        "identityFieldId": "receipt-line-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "receiving-service-entry",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "receipt-line-id",
          "receipt-id",
          "order-line-id",
          "line-number",
          "received-quantity",
          "rejected-quantity",
          "variance-reason-code",
          "item-trace",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "receiving-service-entry"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "service-entry-sheet",
        "filterContract": [
          {
            "fieldId": "service-entry-sheet-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "service-entry-sheet-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-receiving-service-entry-read-service-entry-sheet",
        "identityFieldId": "service-entry-sheet-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "receiving-service-entry",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "service-entry-sheet-id",
          "service-entry-number",
          "purchase-order-id",
          "order-line-ids",
          "service-period-start",
          "service-period-end",
          "delivery-claim",
          "evidence-ids",
          "idempotency-key",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "receiving-service-entry"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "return-claim",
        "filterContract": [
          {
            "fieldId": "return-claim-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "return-claim-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-receiving-service-entry-read-return-claim",
        "identityFieldId": "return-claim-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "receiving-service-entry",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "return-claim-id",
          "return-reference",
          "purchase-order-id",
          "receipt-line-ids",
          "claim-reason-code",
          "evidence-ids",
          "expected-recovery",
          "recovery-due-at",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-exception-triage"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "invoice",
        "filterContract": [
          {
            "fieldId": "invoice-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "invoice-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-exception-triage-read-invoice",
        "identityFieldId": "invoice-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "invoice-intake-match",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "invoice-id",
          "invoice-number",
          "supplier-party-id",
          "due-date",
          "legal-monetary-total",
          "lifecycle-state",
          "evidence-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-exception-triage"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "invoice-match-assessment",
        "filterContract": [
          {
            "fieldId": "invoice-match-assessment-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "invoice-match-assessment-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-exception-triage-read-invoice-match-assessment",
        "identityFieldId": "invoice-match-assessment-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "invoice-intake-match",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "invoice-match-assessment-id",
          "invoice-id",
          "match-basis",
          "comparison-set",
          "tolerances",
          "result",
          "exception-reason-codes",
          "confidence-band",
          "evidence-ids",
          "policy-version-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-exception-triage"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-invoice-resolution",
        "filterContract": [
          {
            "fieldId": "supplier-invoice-resolution-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-invoice-resolution-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-exception-triage-read-supplier-invoice-resolution",
        "identityFieldId": "supplier-invoice-resolution-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-invoice-resolution",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-invoice-resolution-id",
          "invoice-exception-id",
          "lifecycle-state",
          "committed-action",
          "confirmed-at",
          "evidence-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-exception-triage"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "party",
        "filterContract": [
          {
            "fieldId": "party-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "party-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-exception-triage-read-party",
        "identityFieldId": "party-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "party-id",
          "legal-name",
          "party-type",
          "external-identifier",
          "registered-country-code",
          "lifecycle-state",
          "updated-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-exception-triage"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "category",
        "filterContract": [
          {
            "fieldId": "category-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "category-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-exception-triage-read-category",
        "identityFieldId": "category-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "category-id",
          "taxonomy-version-id",
          "code",
          "name",
          "parent-category-id",
          "external-classification",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-exception-triage"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "item-service",
        "filterContract": [
          {
            "fieldId": "item-service-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "item-service-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-exception-triage-read-item-service",
        "identityFieldId": "item-service-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "item-service-id",
          "kind",
          "buying-mode",
          "name",
          "description",
          "category-id",
          "external-identifier",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-exception-triage"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "source-record-reference",
        "filterContract": [
          {
            "fieldId": "source-record-reference-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "source-record-reference-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-exception-triage-read-source-record-reference",
        "identityFieldId": "source-record-reference-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "source-record-reference-id",
          "source-system-id",
          "source-object-type",
          "source-record-id",
          "source-version",
          "source-schema-version",
          "observed-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-exception-triage"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "evidence-item",
        "filterContract": [
          {
            "fieldId": "evidence-item-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "evidence-item-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-exception-triage-read-evidence-item",
        "identityFieldId": "evidence-item-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "evidence-item-id",
          "evidence-type",
          "source-record-reference-id",
          "artifact-reference",
          "content-hash",
          "captured-at",
          "lifecycle-state",
          "classification",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-exception-triage"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy",
        "filterContract": [
          {
            "fieldId": "policy-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "policy-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-exception-triage-read-policy",
        "identityFieldId": "policy-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-id",
          "policy-code",
          "title",
          "owner-person-id",
          "active-version-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-exception-triage"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy-version",
        "filterContract": [
          {
            "fieldId": "policy-version-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "policy-version-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-exception-triage-read-policy-version",
        "identityFieldId": "policy-version-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-version-id",
          "policy-id",
          "semantic-version",
          "artifact-reference",
          "rules-hash",
          "effective-from",
          "effective-to",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-exception-triage"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "authority-envelope",
        "filterContract": [
          {
            "fieldId": "authority-envelope-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "authority-envelope-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-exception-triage-read-authority-envelope",
        "identityFieldId": "authority-envelope-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "authority-envelope-id",
          "workblock-id",
          "grantor-person-id",
          "policy-version-id",
          "allowed-actions",
          "guard-conditions",
          "effective-from",
          "expires-at",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-exception-triage"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "action-proposal",
        "filterContract": [
          {
            "fieldId": "action-proposal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "action-proposal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-exception-triage-read-action-proposal",
        "identityFieldId": "action-proposal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "action-proposal-id",
          "workblock-id",
          "action-class",
          "subject-ref",
          "authority-envelope-id",
          "evidence-item-ids",
          "proposed-payload",
          "lifecycle-state",
          "created-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-exception-triage"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "committed-action",
        "filterContract": [
          {
            "fieldId": "committed-action-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "committed-action-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-exception-triage-read-committed-action",
        "identityFieldId": "committed-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "committed-action-id",
          "action-proposal-id",
          "authority-envelope-id",
          "idempotency-key",
          "commit-result",
          "committed-at",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-exception-triage"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "decision",
        "filterContract": [
          {
            "fieldId": "decision-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "decision-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-exception-triage-read-decision",
        "identityFieldId": "decision-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "decision-id",
          "decision-type",
          "subject-ref",
          "outcome",
          "authority-envelope-id",
          "evidence-item-ids",
          "rationale",
          "decided-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-exception-triage"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "exception",
        "filterContract": [
          {
            "fieldId": "exception-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "exception-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-exception-triage-read-exception",
        "identityFieldId": "exception-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "exception-id",
          "workblock-id",
          "exception-type",
          "subject-ref",
          "owner-person-id",
          "evidence-item-ids",
          "lifecycle-state",
          "opened-at",
          "resolution-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-exception-triage"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "audit-event",
        "filterContract": [
          {
            "fieldId": "audit-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "audit-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-exception-triage-read-audit-event",
        "identityFieldId": "audit-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "audit-event-id",
          "event-type",
          "subject-reference",
          "actor-reference",
          "version-context",
          "correlation-id",
          "summary",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-exception-triage"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-event",
        "filterContract": [
          {
            "fieldId": "business-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-exception-triage-read-business-event",
        "identityFieldId": "business-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-event-id",
          "event-type",
          "event-schema-version",
          "subject-reference",
          "correlation-id",
          "causation-id",
          "payload",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-exception-triage"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "learning-example",
        "filterContract": [
          {
            "fieldId": "learning-example-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "learning-example-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-exception-triage-read-learning-example",
        "identityFieldId": "learning-example-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "learning-evaluation-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "learning-example-id",
          "workblock-id",
          "example-type",
          "input-reference",
          "expected-output",
          "version-context",
          "validation-evidence-item-ids",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-exception-triage"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "evaluation-result",
        "filterContract": [
          {
            "fieldId": "evaluation-result-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "evaluation-result-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-exception-triage-read-evaluation-result",
        "identityFieldId": "evaluation-result-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "learning-evaluation-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "evaluation-result-id",
          "workblock-id",
          "candidate-version",
          "suite-version",
          "check-results",
          "disposition",
          "lifecycle-state",
          "completed-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-exception-triage"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "integration-state",
        "filterContract": [
          {
            "fieldId": "integration-state-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "integration-state-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-exception-triage-read-integration-state",
        "identityFieldId": "integration-state-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "integration-state-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "integration-state-id",
          "integration-id",
          "lifecycle-state",
          "last-successful-sync-at",
          "last-error-code",
          "last-good-reference",
          "updated-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-exception-triage"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "registry-release",
        "filterContract": [
          {
            "fieldId": "registry-release-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "registry-release-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-exception-triage-read-registry-release",
        "identityFieldId": "registry-release-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "registry-release-id",
          "registry-version",
          "previous-version",
          "content-hash",
          "compatibility-class",
          "change-summary",
          "migration-references",
          "lifecycle-state",
          "released-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-exception-triage"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "purchase-order-exception",
        "filterContract": [
          {
            "fieldId": "purchase-order-exception-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "purchase-order-exception-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-exception-triage-read-purchase-order-exception-downstream",
        "identityFieldId": "purchase-order-exception-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "purchase-order-exception",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "purchase-order-exception-id",
          "purchase-order-id",
          "order-line-id",
          "exception-type",
          "deduplication-key",
          "severity",
          "proposed-resolution",
          "lifecycle-state",
          "governance-exception-id",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "payment-readiness"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "invoice",
        "filterContract": [
          {
            "fieldId": "invoice-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "invoice-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-payment-readiness-read-invoice",
        "identityFieldId": "invoice-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "invoice-intake-match",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "invoice-id",
          "invoice-number",
          "supplier-party-id",
          "due-date",
          "legal-monetary-total",
          "payment-means",
          "payment-terms",
          "lifecycle-state",
          "evidence-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "payment-readiness"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "invoice-match-assessment",
        "filterContract": [
          {
            "fieldId": "invoice-match-assessment-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "invoice-match-assessment-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-payment-readiness-read-invoice-match-assessment",
        "identityFieldId": "invoice-match-assessment-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "invoice-intake-match",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "invoice-match-assessment-id",
          "invoice-id",
          "result",
          "exception-reason-codes",
          "confidence-band",
          "assessed-at",
          "evidence-ids",
          "policy-version-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "payment-readiness"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "invoice-exception",
        "filterContract": [
          {
            "fieldId": "invoice-exception-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "invoice-exception-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-payment-readiness-read-invoice-exception",
        "identityFieldId": "invoice-exception-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "invoice-exception-triage",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "invoice-exception-id",
          "invoice-id",
          "materiality-band",
          "committed-disposition",
          "lifecycle-state",
          "updated-at",
          "evidence-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "payment-readiness"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "person",
        "filterContract": [
          {
            "fieldId": "person-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "person-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-payment-readiness-read-person",
        "identityFieldId": "person-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "person-id",
          "party-id",
          "identity-subject",
          "display-name",
          "primary-role",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "payment-readiness"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy",
        "filterContract": [
          {
            "fieldId": "policy-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "policy-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-payment-readiness-read-policy",
        "identityFieldId": "policy-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-id",
          "policy-code",
          "title",
          "owner-person-id",
          "active-version-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "payment-readiness"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy-version",
        "filterContract": [
          {
            "fieldId": "policy-version-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "policy-version-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-payment-readiness-read-policy-version",
        "identityFieldId": "policy-version-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-version-id",
          "policy-id",
          "semantic-version",
          "artifact-reference",
          "rules-hash",
          "effective-from",
          "effective-to",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "payment-readiness"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "authority-envelope",
        "filterContract": [
          {
            "fieldId": "authority-envelope-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "authority-envelope-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-payment-readiness-read-authority-envelope",
        "identityFieldId": "authority-envelope-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "authority-envelope-id",
          "workblock-id",
          "grantor-person-id",
          "policy-version-id",
          "allowed-actions",
          "guard-conditions",
          "effective-from",
          "expires-at",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "payment-readiness"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "exception",
        "filterContract": [
          {
            "fieldId": "exception-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "exception-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-payment-readiness-read-exception",
        "identityFieldId": "exception-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "exception-id",
          "workblock-id",
          "exception-type",
          "subject-ref",
          "owner-person-id",
          "evidence-item-ids",
          "lifecycle-state",
          "opened-at",
          "resolution-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "payment-readiness"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "audit-event",
        "filterContract": [
          {
            "fieldId": "audit-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "audit-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-payment-readiness-read-audit-event",
        "identityFieldId": "audit-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "audit-event-id",
          "event-type",
          "subject-reference",
          "actor-reference",
          "version-context",
          "correlation-id",
          "summary",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "payment-readiness"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-event",
        "filterContract": [
          {
            "fieldId": "business-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-payment-readiness-read-business-event",
        "identityFieldId": "business-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-event-id",
          "event-type",
          "event-schema-version",
          "subject-reference",
          "correlation-id",
          "causation-id",
          "payload",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "payment-readiness"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "integration-state",
        "filterContract": [
          {
            "fieldId": "integration-state-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "integration-state-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-payment-readiness-read-integration-state",
        "identityFieldId": "integration-state-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "integration-state-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "integration-state-id",
          "integration-id",
          "lifecycle-state",
          "last-successful-sync-at",
          "last-error-code",
          "last-good-reference",
          "updated-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "payment-readiness"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "invoice-line",
        "filterContract": [
          {
            "fieldId": "invoice-line-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "invoice-line-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-payment-readiness-read-invoice-line-downstream",
        "identityFieldId": "invoice-line-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "invoice-intake-match",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "invoice-line-id",
          "invoice-id",
          "line-number",
          "item-reference",
          "description",
          "quantity",
          "price",
          "line-extension-amount",
          "tax-category",
          "order-line-reference",
          "receipt-line-ids",
          "source-anchor",
          "lifecycle-state",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-intake-match"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "invoice-line",
        "filterContract": [
          {
            "fieldId": "invoice-line-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "invoice-line-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-intake-match-read-invoice-line",
        "identityFieldId": "invoice-line-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "invoice-intake-match",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "invoice-line-id",
          "invoice-id",
          "line-number",
          "item-reference",
          "description",
          "quantity",
          "price",
          "line-extension-amount",
          "tax-category",
          "order-line-reference",
          "receipt-line-ids",
          "source-anchor",
          "lifecycle-state",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-intake-match"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "purchase-order",
        "filterContract": [
          {
            "fieldId": "purchase-order-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "purchase-order-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-intake-match-read-purchase-order-for-invoice-match",
        "identityFieldId": "purchase-order-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "purchase-order-orchestration",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "purchase-order-id",
          "purchase-order-number",
          "order-version",
          "requisition-id",
          "supplier-id",
          "contract-id",
          "total-amount",
          "idempotency-key",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-intake-match"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "order-line",
        "filterContract": [
          {
            "fieldId": "order-line-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "order-line-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-intake-match-read-order-line-for-invoice-match",
        "identityFieldId": "order-line-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "purchase-order-orchestration",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "order-line-id",
          "purchase-order-id",
          "requisition-line-id",
          "line-number",
          "item-identifiers",
          "description",
          "ordered-quantity",
          "unit-price",
          "delivery-requirement",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-intake-match"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "receipt",
        "filterContract": [
          {
            "fieldId": "receipt-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "receipt-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-intake-match-read-receipt-for-invoice-match",
        "identityFieldId": "receipt-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "receiving-service-entry",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "receipt-id",
          "receipt-number",
          "purchase-order-id",
          "shipment-id",
          "receiving-location",
          "proof-artifact-ids",
          "idempotency-key",
          "lifecycle-state",
          "received-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-intake-match"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "receipt-line",
        "filterContract": [
          {
            "fieldId": "receipt-line-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "receipt-line-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-intake-match-read-receipt-line-for-invoice-match",
        "identityFieldId": "receipt-line-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "receiving-service-entry",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "receipt-line-id",
          "receipt-id",
          "order-line-id",
          "line-number",
          "received-quantity",
          "rejected-quantity",
          "variance-reason-code",
          "item-trace",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-intake-match"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "service-entry-sheet",
        "filterContract": [
          {
            "fieldId": "service-entry-sheet-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "service-entry-sheet-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-intake-match-read-service-entry-sheet-for-invoice-match",
        "identityFieldId": "service-entry-sheet-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "receiving-service-entry",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "service-entry-sheet-id",
          "service-entry-number",
          "purchase-order-id",
          "order-line-ids",
          "service-period-start",
          "service-period-end",
          "delivery-claim",
          "evidence-ids",
          "idempotency-key",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-intake-match"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "receipt-line",
        "filterContract": [
          {
            "fieldId": "receipt-line-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "receipt-line-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-intake-match-read-receipt-line-downstream",
        "identityFieldId": "receipt-line-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "receiving-service-entry",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "receipt-line-id",
          "receipt-id",
          "order-line-id",
          "line-number",
          "received-quantity",
          "rejected-quantity",
          "variance-reason-code",
          "item-trace",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-intake-match"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "service-entry-sheet",
        "filterContract": [
          {
            "fieldId": "service-entry-sheet-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "service-entry-sheet-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-intake-match-read-service-entry-sheet-downstream",
        "identityFieldId": "service-entry-sheet-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "receiving-service-entry",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "service-entry-sheet-id",
          "service-entry-number",
          "purchase-order-id",
          "order-line-ids",
          "service-period-start",
          "service-period-end",
          "delivery-claim",
          "evidence-ids",
          "idempotency-key",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-invoice-resolution"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "invoice-exception",
        "filterContract": [
          {
            "fieldId": "invoice-exception-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "invoice-exception-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-invoice-resolution-read-invoice-exception",
        "identityFieldId": "invoice-exception-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "invoice-exception-triage",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "invoice-exception-id",
          "invoice-id",
          "exception-type",
          "materiality-band",
          "proposed-resolution",
          "committed-disposition",
          "lifecycle-state",
          "evidence-ids",
          "policy-version-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-invoice-resolution"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "invoice",
        "filterContract": [
          {
            "fieldId": "invoice-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "invoice-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-invoice-resolution-read-invoice",
        "identityFieldId": "invoice-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "invoice-intake-match",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "invoice-id",
          "invoice-number",
          "supplier-party-id",
          "issue-date",
          "due-date",
          "order-ids",
          "contract-ids",
          "legal-monetary-total",
          "lifecycle-state",
          "evidence-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-invoice-resolution"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "invoice-line",
        "filterContract": [
          {
            "fieldId": "invoice-line-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "invoice-line-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-invoice-resolution-read-invoice-line-downstream",
        "identityFieldId": "invoice-line-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "invoice-intake-match",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "invoice-line-id",
          "invoice-id",
          "line-number",
          "item-reference",
          "description",
          "quantity",
          "price",
          "line-extension-amount",
          "tax-category",
          "order-line-reference",
          "receipt-line-ids",
          "source-anchor",
          "lifecycle-state",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "payment-execution-guard"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "payment-readiness-assessment",
        "filterContract": [
          {
            "fieldId": "payment-readiness-assessment-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "payment-readiness-assessment-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-payment-execution-guard-read-payment-readiness-assessment",
        "identityFieldId": "payment-readiness-assessment-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "payment-readiness",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "payment-readiness-assessment-id",
          "invoice-id",
          "payable-amount",
          "due-date",
          "committed-readiness",
          "risk-flags",
          "authority-envelope-id",
          "lifecycle-state",
          "assessed-at",
          "evidence-ids",
          "policy-version-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "payment-execution-guard"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "invoice",
        "filterContract": [
          {
            "fieldId": "invoice-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "invoice-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-payment-execution-guard-read-invoice",
        "identityFieldId": "invoice-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "invoice-intake-match",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "invoice-id",
          "supplier-party-id",
          "document-currency-code",
          "legal-monetary-total",
          "payment-means",
          "payment-terms",
          "lifecycle-state",
          "evidence-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "payment-execution-guard"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "payment-execution-status",
        "filterContract": [
          {
            "fieldId": "payment-execution-status-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "payment-execution-status-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-payment-execution-guard-read-payment-execution-status",
        "identityFieldId": "payment-execution-status-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "payment-execution-guard",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "payment-execution-status-id",
          "payment-instruction-id",
          "message-type",
          "message-version",
          "downstream-status-code",
          "acceptance-reason-code",
          "execution-status",
          "observed-at",
          "settlement-date",
          "statement-id",
          "remittance-advice-id",
          "error-detail",
          "source-system",
          "source-schema-version",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "payment-execution-guard"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "payment-instruction",
        "filterContract": [
          {
            "fieldId": "payment-instruction-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "payment-instruction-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-payment-execution-guard-read-payment-instruction",
        "identityFieldId": "payment-instruction-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "payment-execution-guard",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "payment-instruction-id",
          "readiness-ids",
          "invoice-ids",
          "debtor-account-token",
          "creditor-account-token",
          "instructed-amount",
          "requested-execution-date",
          "payment-method-code",
          "remittance-information",
          "proposal-status",
          "committed-status",
          "authority-envelope-id",
          "instruction-message-id",
          "created-at",
          "committed-at",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-segment-assignment",
        "filterContract": [
          {
            "fieldId": "supplier-segment-assignment-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-segment-assignment-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-review-read-supplier-segment-assignment",
        "identityFieldId": "supplier-segment-assignment-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-segmentation-governance",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-segment-assignment-id",
          "supplier-party-id",
          "committed-segment-code",
          "committed-criticality-band",
          "relationship-posture",
          "valid-from",
          "lifecycle-state",
          "evidence-ids",
          "policy-version-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-performance-observation",
        "filterContract": [
          {
            "fieldId": "supplier-performance-observation-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-performance-observation-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-review-read-supplier-performance-observation",
        "identityFieldId": "supplier-performance-observation-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-performance-monitor-correct",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-performance-observation-id",
          "supplier-party-id",
          "measure-code",
          "measure-definition-version",
          "performance-period-start",
          "performance-period-end",
          "target-value",
          "observed-value",
          "unit-code",
          "quality-status",
          "breach-status",
          "evidence-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "party",
        "filterContract": [
          {
            "fieldId": "party-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "party-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-review-read-party",
        "identityFieldId": "party-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "party-id",
          "legal-name",
          "party-type",
          "external-identifier",
          "registered-country-code",
          "lifecycle-state",
          "updated-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "source-record-reference",
        "filterContract": [
          {
            "fieldId": "source-record-reference-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "source-record-reference-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-review-read-source-record-reference",
        "identityFieldId": "source-record-reference-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "source-record-reference-id",
          "source-system-id",
          "source-object-type",
          "source-record-id",
          "source-version",
          "source-schema-version",
          "observed-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "authority-envelope",
        "filterContract": [
          {
            "fieldId": "authority-envelope-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "authority-envelope-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-review-read-authority-envelope",
        "identityFieldId": "authority-envelope-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "authority-envelope-id",
          "workblock-id",
          "grantor-person-id",
          "policy-version-id",
          "allowed-actions",
          "guard-conditions",
          "effective-from",
          "expires-at",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "decision",
        "filterContract": [
          {
            "fieldId": "decision-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "decision-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-review-read-decision",
        "identityFieldId": "decision-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "decision-id",
          "decision-type",
          "subject-ref",
          "outcome",
          "authority-envelope-id",
          "evidence-item-ids",
          "rationale",
          "decided-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "audit-event",
        "filterContract": [
          {
            "fieldId": "audit-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "audit-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-review-read-audit-event",
        "identityFieldId": "audit-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "audit-event-id",
          "event-type",
          "subject-reference",
          "actor-reference",
          "version-context",
          "correlation-id",
          "summary",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-event",
        "filterContract": [
          {
            "fieldId": "business-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-review-read-business-event",
        "identityFieldId": "business-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-event-id",
          "event-type",
          "event-schema-version",
          "subject-reference",
          "correlation-id",
          "causation-id",
          "payload",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "learning-example",
        "filterContract": [
          {
            "fieldId": "learning-example-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "learning-example-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-review-read-learning-example",
        "identityFieldId": "learning-example-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "learning-evaluation-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "learning-example-id",
          "workblock-id",
          "example-type",
          "input-reference",
          "expected-output",
          "version-context",
          "validation-evidence-item-ids",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "evaluation-result",
        "filterContract": [
          {
            "fieldId": "evaluation-result-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "evaluation-result-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-review-read-evaluation-result",
        "identityFieldId": "evaluation-result-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "learning-evaluation-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "evaluation-result-id",
          "workblock-id",
          "candidate-version",
          "suite-version",
          "check-results",
          "disposition",
          "lifecycle-state",
          "completed-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "integration-state",
        "filterContract": [
          {
            "fieldId": "integration-state-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "integration-state-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-review-read-integration-state",
        "identityFieldId": "integration-state-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "integration-state-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "integration-state-id",
          "integration-id",
          "lifecycle-state",
          "last-successful-sync-at",
          "last-error-code",
          "last-good-reference",
          "updated-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "registry-release",
        "filterContract": [
          {
            "fieldId": "registry-release-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "registry-release-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-review-read-registry-release",
        "identityFieldId": "registry-release-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "registry-release-id",
          "registry-version",
          "previous-version",
          "content-hash",
          "compatibility-class",
          "change-summary",
          "migration-references",
          "lifecycle-state",
          "released-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-remediation-action",
        "filterContract": [
          {
            "fieldId": "supplier-remediation-action-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-remediation-action-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-review-read-supplier-remediation-action-downstream",
        "identityFieldId": "supplier-remediation-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-remediation-exit",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-remediation-action-id",
          "supplier-id",
          "origin-reference",
          "required-outcome",
          "evidence-requirements",
          "owner-reference",
          "due-at",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-offboarding-case",
        "filterContract": [
          {
            "fieldId": "supplier-offboarding-case-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-offboarding-case-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-review-read-supplier-offboarding-case-downstream",
        "identityFieldId": "supplier-offboarding-case-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-remediation-exit",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-offboarding-case-id",
          "supplier-id",
          "exit-reason-code",
          "dependency-state",
          "target-completion-at",
          "lifecycle-state",
          "completed-at",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-innovation-pipeline"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-segment-assignment",
        "filterContract": [
          {
            "fieldId": "supplier-segment-assignment-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-segment-assignment-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-innovation-pipeline-read-supplier-segment-assignment",
        "identityFieldId": "supplier-segment-assignment-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-segmentation-governance",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-segment-assignment-id",
          "supplier-party-id",
          "committed-segment-code",
          "relationship-posture",
          "lifecycle-state",
          "evidence-ids",
          "policy-version-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-innovation-pipeline"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-performance-review-record",
        "filterContract": [
          {
            "fieldId": "supplier-performance-review-record-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-performance-review-record-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-innovation-pipeline-read-supplier-performance-review-record",
        "identityFieldId": "supplier-performance-review-record-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-performance-review",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-performance-review-record-id",
          "supplier-party-id",
          "committed-decisions",
          "corrective-action-plan",
          "reviewed-at",
          "evidence-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-innovation-pipeline"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-joint-value-plan",
        "filterContract": [
          {
            "fieldId": "supplier-joint-value-plan-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-joint-value-plan-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-innovation-pipeline-read-supplier-joint-value-plan",
        "identityFieldId": "supplier-joint-value-plan-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-relationship-joint-value",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-joint-value-plan-id",
          "supplier-party-id",
          "objectives",
          "committed-plan-version",
          "linked-innovation-ids",
          "lifecycle-state",
          "evidence-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-segmentation-governance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-performance-observation",
        "filterContract": [
          {
            "fieldId": "supplier-performance-observation-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-performance-observation-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-segmentation-governance-read-supplier-performance-observation",
        "identityFieldId": "supplier-performance-observation-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-performance-monitor-correct",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-performance-observation-id",
          "supplier-party-id",
          "measure-code",
          "performance-period-end",
          "observed-value",
          "quality-status",
          "breach-status",
          "evidence-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-monitor-correct"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-segment-assignment",
        "filterContract": [
          {
            "fieldId": "supplier-segment-assignment-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-segment-assignment-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-monitor-correct-read-supplier-segment-assignment",
        "identityFieldId": "supplier-segment-assignment-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-segmentation-governance",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-segment-assignment-id",
          "supplier-party-id",
          "committed-segment-code",
          "committed-criticality-band",
          "relationship-posture",
          "lifecycle-state",
          "policy-version-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-monitor-correct"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-performance-review-record",
        "filterContract": [
          {
            "fieldId": "supplier-performance-review-record-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-performance-review-record-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-monitor-correct-read-supplier-performance-review-record",
        "identityFieldId": "supplier-performance-review-record-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-performance-review",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-performance-review-record-id",
          "supplier-party-id",
          "corrective-action-plan",
          "committed-decisions",
          "lifecycle-state",
          "next-review-at",
          "evidence-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-relationship-joint-value"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-segment-assignment",
        "filterContract": [
          {
            "fieldId": "supplier-segment-assignment-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-segment-assignment-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-relationship-joint-value-read-supplier-segment-assignment",
        "identityFieldId": "supplier-segment-assignment-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-segmentation-governance",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-segment-assignment-id",
          "supplier-party-id",
          "committed-segment-code",
          "committed-criticality-band",
          "relationship-posture",
          "lifecycle-state",
          "evidence-ids",
          "policy-version-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-relationship-joint-value"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-performance-review-record",
        "filterContract": [
          {
            "fieldId": "supplier-performance-review-record-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-performance-review-record-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-relationship-joint-value-read-supplier-performance-review-record",
        "identityFieldId": "supplier-performance-review-record-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-performance-review",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-performance-review-record-id",
          "supplier-party-id",
          "aggregate-scores",
          "committed-decisions",
          "corrective-action-plan",
          "reviewed-at",
          "next-review-at",
          "evidence-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-relationship-joint-value"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-innovation-case",
        "filterContract": [
          {
            "fieldId": "supplier-innovation-case-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-innovation-case-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-relationship-joint-value-read-supplier-innovation-case",
        "identityFieldId": "supplier-innovation-case-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-innovation-pipeline",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-innovation-case-id",
          "supplier-party-id",
          "title",
          "lifecycle-state",
          "committed-gate-decision",
          "experiment-outcome",
          "evidence-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "savings-initiative"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "value-opportunity-baseline",
        "filterContract": [
          {
            "fieldId": "value-opportunity-baseline-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "value-opportunity-baseline-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-savings-initiative-read-value-opportunity-baseline",
        "identityFieldId": "value-opportunity-baseline-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "value-opportunity-baseline",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "value-opportunity-baseline-id",
          "opportunity-type",
          "title",
          "owner-reference",
          "baseline-period-start",
          "baseline-period-end",
          "baseline-method-version",
          "baseline-amount",
          "target-amount",
          "forecast-amount",
          "committed-validation",
          "lifecycle-state",
          "evidence-ids",
          "policy-version-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "savings-initiative"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "value-realization-attribution",
        "filterContract": [
          {
            "fieldId": "value-realization-attribution-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "value-realization-attribution-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-savings-initiative-read-value-realization-attribution",
        "identityFieldId": "value-realization-attribution-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "realization-reconciliation-attribution",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "value-realization-attribution-id",
          "savings-initiative-id",
          "attributed-amount",
          "currency-code",
          "committed-disposition",
          "reconciliation-status",
          "calculated-at",
          "evidence-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "savings-initiative"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "value-leakage-finding",
        "filterContract": [
          {
            "fieldId": "value-leakage-finding-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "value-leakage-finding-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-savings-initiative-read-value-leakage-finding",
        "identityFieldId": "value-leakage-finding-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "value-leakage-monitor",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "value-leakage-finding-id",
          "savings-initiative-id",
          "leakage-type",
          "exposure-amount",
          "materiality-band",
          "lifecycle-state",
          "detected-at",
          "evidence-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "savings-initiative"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-unit",
        "filterContract": [
          {
            "fieldId": "business-unit-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-unit-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-savings-initiative-read-business-unit",
        "identityFieldId": "business-unit-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-unit-id",
          "external-key",
          "name",
          "parent-business-unit-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "savings-initiative"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "category",
        "filterContract": [
          {
            "fieldId": "category-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "category-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-savings-initiative-read-category",
        "identityFieldId": "category-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "category-id",
          "taxonomy-version-id",
          "code",
          "name",
          "parent-category-id",
          "external-classification",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "savings-initiative"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "source-record-reference",
        "filterContract": [
          {
            "fieldId": "source-record-reference-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "source-record-reference-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-savings-initiative-read-source-record-reference",
        "identityFieldId": "source-record-reference-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "source-record-reference-id",
          "source-system-id",
          "source-object-type",
          "source-record-id",
          "source-version",
          "source-schema-version",
          "observed-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "savings-initiative"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "evidence-item",
        "filterContract": [
          {
            "fieldId": "evidence-item-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "evidence-item-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-savings-initiative-read-evidence-item",
        "identityFieldId": "evidence-item-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "evidence-item-id",
          "evidence-type",
          "source-record-reference-id",
          "artifact-reference",
          "content-hash",
          "captured-at",
          "lifecycle-state",
          "classification",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "savings-initiative"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "authority-envelope",
        "filterContract": [
          {
            "fieldId": "authority-envelope-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "authority-envelope-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-savings-initiative-read-authority-envelope",
        "identityFieldId": "authority-envelope-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "authority-envelope-id",
          "workblock-id",
          "grantor-person-id",
          "policy-version-id",
          "allowed-actions",
          "guard-conditions",
          "effective-from",
          "expires-at",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "savings-initiative"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "action-proposal",
        "filterContract": [
          {
            "fieldId": "action-proposal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "action-proposal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-savings-initiative-read-action-proposal",
        "identityFieldId": "action-proposal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "action-proposal-id",
          "workblock-id",
          "action-class",
          "subject-ref",
          "authority-envelope-id",
          "evidence-item-ids",
          "proposed-payload",
          "lifecycle-state",
          "created-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "savings-initiative"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "committed-action",
        "filterContract": [
          {
            "fieldId": "committed-action-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "committed-action-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-savings-initiative-read-committed-action",
        "identityFieldId": "committed-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "committed-action-id",
          "action-proposal-id",
          "authority-envelope-id",
          "idempotency-key",
          "commit-result",
          "committed-at",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "savings-initiative"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "decision",
        "filterContract": [
          {
            "fieldId": "decision-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "decision-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-savings-initiative-read-decision",
        "identityFieldId": "decision-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "decision-id",
          "decision-type",
          "subject-ref",
          "outcome",
          "authority-envelope-id",
          "evidence-item-ids",
          "rationale",
          "decided-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "savings-initiative"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "exception",
        "filterContract": [
          {
            "fieldId": "exception-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "exception-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-savings-initiative-read-exception",
        "identityFieldId": "exception-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "exception-id",
          "workblock-id",
          "exception-type",
          "subject-ref",
          "owner-person-id",
          "evidence-item-ids",
          "lifecycle-state",
          "opened-at",
          "resolution-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "savings-initiative"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "audit-event",
        "filterContract": [
          {
            "fieldId": "audit-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "audit-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-savings-initiative-read-audit-event",
        "identityFieldId": "audit-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "audit-event-id",
          "event-type",
          "subject-reference",
          "actor-reference",
          "version-context",
          "correlation-id",
          "summary",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "savings-initiative"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-event",
        "filterContract": [
          {
            "fieldId": "business-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-savings-initiative-read-business-event",
        "identityFieldId": "business-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-event-id",
          "event-type",
          "event-schema-version",
          "subject-reference",
          "correlation-id",
          "causation-id",
          "payload",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "savings-initiative"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "learning-example",
        "filterContract": [
          {
            "fieldId": "learning-example-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "learning-example-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-savings-initiative-read-learning-example",
        "identityFieldId": "learning-example-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "learning-evaluation-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "learning-example-id",
          "workblock-id",
          "example-type",
          "input-reference",
          "expected-output",
          "version-context",
          "validation-evidence-item-ids",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "savings-initiative"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "evaluation-result",
        "filterContract": [
          {
            "fieldId": "evaluation-result-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "evaluation-result-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-savings-initiative-read-evaluation-result",
        "identityFieldId": "evaluation-result-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "learning-evaluation-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "evaluation-result-id",
          "workblock-id",
          "candidate-version",
          "suite-version",
          "check-results",
          "disposition",
          "lifecycle-state",
          "completed-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "savings-initiative"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "integration-state",
        "filterContract": [
          {
            "fieldId": "integration-state-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "integration-state-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-savings-initiative-read-integration-state",
        "identityFieldId": "integration-state-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "integration-state-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "integration-state-id",
          "integration-id",
          "lifecycle-state",
          "last-successful-sync-at",
          "last-error-code",
          "last-good-reference",
          "updated-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "savings-initiative"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "registry-release",
        "filterContract": [
          {
            "fieldId": "registry-release-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "registry-release-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-savings-initiative-read-registry-release",
        "identityFieldId": "registry-release-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "registry-release-id",
          "registry-version",
          "previous-version",
          "content-hash",
          "compatibility-class",
          "change-summary",
          "migration-references",
          "lifecycle-state",
          "released-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "savings-initiative"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "budget",
        "filterContract": [
          {
            "fieldId": "budget-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "budget-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-savings-initiative-read-budget",
        "identityFieldId": "budget-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "demand-consolidation-portfolio",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "budget-id",
          "company-party-id",
          "business-unit-id",
          "owner-role-id",
          "budget-code",
          "period-start",
          "period-end",
          "authorised-amount",
          "supersedes-budget-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "savings-initiative"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "value-portfolio-forecast",
        "filterContract": [
          {
            "fieldId": "value-portfolio-forecast-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "value-portfolio-forecast-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-savings-initiative-read-value-portfolio-forecast-downstream",
        "identityFieldId": "value-portfolio-forecast-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "value-portfolio-forecast",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "value-portfolio-forecast-id",
          "as-of-date",
          "scenario-code",
          "benchmark-tier-code",
          "forecast-horizon-start",
          "forecast-horizon-end",
          "initiative-ids",
          "baseline-ids",
          "forecast-method-version",
          "forecast-amount",
          "currency-code",
          "confidence-interval",
          "risk-adjustment",
          "realization-schedule",
          "assumptions",
          "source-snapshot-ids",
          "proposed-portfolio-action",
          "proposal-status",
          "committed-portfolio-decision",
          "authority-envelope-id",
          "lifecycle-state",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "value-leakage-monitor"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "value-opportunity-baseline",
        "filterContract": [
          {
            "fieldId": "value-opportunity-baseline-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "value-opportunity-baseline-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-value-leakage-monitor-read-value-opportunity-baseline",
        "identityFieldId": "value-opportunity-baseline-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "value-opportunity-baseline",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "value-opportunity-baseline-id",
          "baseline-method-version",
          "baseline-amount",
          "target-amount",
          "committed-validation",
          "lifecycle-state",
          "evidence-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "value-leakage-monitor"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "savings-initiative-record",
        "filterContract": [
          {
            "fieldId": "savings-initiative-record-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "savings-initiative-record-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-value-leakage-monitor-read-savings-initiative-record",
        "identityFieldId": "savings-initiative-record-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "savings-initiative",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "savings-initiative-record-id",
          "value-opportunity-baseline-id",
          "lifecycle-state",
          "target-value",
          "forecast-value",
          "validated-realization",
          "leakage-value",
          "measurement-method-version",
          "attention-status",
          "evidence-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "value-leakage-monitor"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "value-realization-attribution",
        "filterContract": [
          {
            "fieldId": "value-realization-attribution-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "value-realization-attribution-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-value-leakage-monitor-read-value-realization-attribution",
        "identityFieldId": "value-realization-attribution-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "realization-reconciliation-attribution",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "value-realization-attribution-id",
          "savings-initiative-id",
          "gross-variance",
          "adjustments",
          "attributed-amount",
          "committed-disposition",
          "reconciliation-status",
          "evidence-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "value-leakage-monitor"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "authority-envelope",
        "filterContract": [
          {
            "fieldId": "authority-envelope-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "authority-envelope-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-value-leakage-monitor-read-authority-envelope",
        "identityFieldId": "authority-envelope-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "registry-governance-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "authority-envelope-id",
          "workblock-id",
          "grantor-person-id",
          "policy-version-id",
          "allowed-actions",
          "guard-conditions",
          "effective-from",
          "expires-at",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "value-leakage-monitor"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-event",
        "filterContract": [
          {
            "fieldId": "business-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-value-leakage-monitor-read-business-event",
        "identityFieldId": "business-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-event-id",
          "event-type",
          "event-schema-version",
          "subject-reference",
          "correlation-id",
          "causation-id",
          "payload",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "value-opportunity-baseline"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "savings-initiative-record",
        "filterContract": [
          {
            "fieldId": "savings-initiative-record-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "savings-initiative-record-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-value-opportunity-baseline-read-savings-initiative-record",
        "identityFieldId": "savings-initiative-record-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "savings-initiative",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "savings-initiative-record-id",
          "value-opportunity-baseline-id",
          "lifecycle-state",
          "target-value",
          "forecast-value",
          "validated-realization",
          "attention-status",
          "evidence-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "realization-reconciliation-attribution"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "value-opportunity-baseline",
        "filterContract": [
          {
            "fieldId": "value-opportunity-baseline-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "value-opportunity-baseline-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-realization-reconciliation-attribution-read-value-opportunity-baseline",
        "identityFieldId": "value-opportunity-baseline-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "value-opportunity-baseline",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "value-opportunity-baseline-id",
          "baseline-period-start",
          "baseline-period-end",
          "baseline-method-version",
          "baseline-amount",
          "target-amount",
          "assumptions",
          "committed-validation",
          "lifecycle-state",
          "evidence-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "realization-reconciliation-attribution"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "savings-initiative-record",
        "filterContract": [
          {
            "fieldId": "savings-initiative-record-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "savings-initiative-record-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-realization-reconciliation-attribution-read-savings-initiative-record",
        "identityFieldId": "savings-initiative-record-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "savings-initiative",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "savings-initiative-record-id",
          "value-opportunity-baseline-id",
          "value-type",
          "value-recognition-treatment",
          "lifecycle-state",
          "measurement-method-version",
          "validated-realization",
          "attention-status",
          "evidence-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "realization-reconciliation-attribution"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "value-leakage-finding",
        "filterContract": [
          {
            "fieldId": "value-leakage-finding-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "value-leakage-finding-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-realization-reconciliation-attribution-read-value-leakage-finding",
        "identityFieldId": "value-leakage-finding-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "value-leakage-monitor",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "value-leakage-finding-id",
          "savings-initiative-id",
          "leakage-type",
          "exposure-amount",
          "committed-remediation",
          "lifecycle-state",
          "evidence-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "realization-reconciliation-attribution"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "budget",
        "filterContract": [
          {
            "fieldId": "budget-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "budget-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-realization-reconciliation-attribution-read-budget",
        "identityFieldId": "budget-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "demand-consolidation-portfolio",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "budget-id",
          "company-party-id",
          "business-unit-id",
          "owner-role-id",
          "budget-code",
          "period-start",
          "period-end",
          "authorised-amount",
          "supersedes-budget-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "realization-reconciliation-attribution"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "payment-instruction",
        "filterContract": [
          {
            "fieldId": "payment-instruction-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "payment-instruction-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-realization-reconciliation-attribution-read-payment-instruction-downstream",
        "identityFieldId": "payment-instruction-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "payment-execution-guard",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "payment-instruction-id",
          "readiness-ids",
          "invoice-ids",
          "debtor-account-token",
          "creditor-account-token",
          "instructed-amount",
          "requested-execution-date",
          "payment-method-code",
          "remittance-information",
          "proposal-status",
          "committed-status",
          "authority-envelope-id",
          "instruction-message-id",
          "created-at",
          "committed-at",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "realization-reconciliation-attribution"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "payment-execution-status",
        "filterContract": [
          {
            "fieldId": "payment-execution-status-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "payment-execution-status-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-realization-reconciliation-attribution-read-payment-execution-status-downstream",
        "identityFieldId": "payment-execution-status-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "payment-execution-guard",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "payment-execution-status-id",
          "payment-instruction-id",
          "message-type",
          "message-version",
          "downstream-status-code",
          "acceptance-reason-code",
          "execution-status",
          "observed-at",
          "settlement-date",
          "statement-id",
          "remittance-advice-id",
          "error-detail",
          "source-system",
          "source-schema-version",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "value-portfolio-forecast"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "value-opportunity-baseline",
        "filterContract": [
          {
            "fieldId": "value-opportunity-baseline-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "value-opportunity-baseline-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-value-portfolio-forecast-read-value-opportunity-baseline",
        "identityFieldId": "value-opportunity-baseline-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "value-opportunity-baseline",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "value-opportunity-baseline-id",
          "opportunity-type",
          "baseline-amount",
          "target-amount",
          "forecast-amount",
          "committed-validation",
          "lifecycle-state",
          "evidence-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "value-portfolio-forecast"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "savings-initiative-record",
        "filterContract": [
          {
            "fieldId": "savings-initiative-record-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "savings-initiative-record-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-value-portfolio-forecast-read-savings-initiative-record",
        "identityFieldId": "savings-initiative-record-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "savings-initiative",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "savings-initiative-record-id",
          "lifecycle-state",
          "target-value",
          "forecast-value",
          "validated-realization",
          "leakage-value",
          "currency-code",
          "milestone-plan",
          "dependency-ids",
          "target-completion-date",
          "attention-status",
          "evidence-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "value-portfolio-forecast"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "value-realization-attribution",
        "filterContract": [
          {
            "fieldId": "value-realization-attribution-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "value-realization-attribution-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-value-portfolio-forecast-read-value-realization-attribution",
        "identityFieldId": "value-realization-attribution-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "realization-reconciliation-attribution",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "value-realization-attribution-id",
          "savings-initiative-id",
          "attribution-period-start",
          "attribution-period-end",
          "attributed-amount",
          "currency-code",
          "committed-disposition",
          "reconciliation-status",
          "evidence-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "value-portfolio-forecast"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "value-leakage-finding",
        "filterContract": [
          {
            "fieldId": "value-leakage-finding-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "value-leakage-finding-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-value-portfolio-forecast-read-value-leakage-finding",
        "identityFieldId": "value-leakage-finding-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "value-leakage-monitor",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "value-leakage-finding-id",
          "savings-initiative-id",
          "exposure-amount",
          "currency-code",
          "materiality-band",
          "lifecycle-state",
          "due-at",
          "evidence-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "value-portfolio-forecast"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "value-portfolio-forecast",
        "filterContract": [
          {
            "fieldId": "value-portfolio-forecast-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "value-portfolio-forecast-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-value-portfolio-forecast-read-value-portfolio-forecast",
        "identityFieldId": "value-portfolio-forecast-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "value-portfolio-forecast",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "value-portfolio-forecast-id",
          "as-of-date",
          "scenario-code",
          "benchmark-tier-code",
          "forecast-horizon-start",
          "forecast-horizon-end",
          "initiative-ids",
          "baseline-ids",
          "forecast-method-version",
          "forecast-amount",
          "currency-code",
          "confidence-interval",
          "risk-adjustment",
          "realization-schedule",
          "assumptions",
          "source-snapshot-ids",
          "proposed-portfolio-action",
          "proposal-status",
          "committed-portfolio-decision",
          "authority-envelope-id",
          "lifecycle-state",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "value-portfolio-forecast"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "award-scenario",
        "filterContract": [
          {
            "fieldId": "award-scenario-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "award-scenario-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-value-portfolio-forecast-read-award-scenario",
        "identityFieldId": "award-scenario-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "bid-evaluation-award",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "award-scenario-id",
          "sourcing-event-id",
          "evaluation-model",
          "normalised-results",
          "constraint-set",
          "recommended-party-ids",
          "allocation",
          "sensitivity-analysis",
          "committed-decision-id",
          "lifecycle-state",
          "evaluated-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "category-opportunity-radar"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "buying-request",
        "filterContract": [
          {
            "fieldId": "buying-request-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "buying-request-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-category-opportunity-radar-read-buying-request",
        "identityFieldId": "buying-request-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "guided-buying",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "buying-request-id",
          "requester-reference",
          "business-unit-code",
          "need-description",
          "classification-code",
          "estimated-value",
          "needed-by-date",
          "option-set",
          "selected-route",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "policy-rule-lifecycle"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "requisition",
        "filterContract": [
          {
            "fieldId": "requisition-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "requisition-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-rule-lifecycle-read-requisition",
        "identityFieldId": "requisition-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "requisition-policy-routing",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "requisition-id",
          "requisition-number",
          "requester-reference",
          "business-unit-code",
          "total-amount",
          "policy-evaluation",
          "budget-reservation",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "guided-buying"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-entitlement",
        "filterContract": [
          {
            "fieldId": "contract-entitlement-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-entitlement-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-guided-buying-read-contract-entitlement",
        "identityFieldId": "contract-entitlement-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "obligation-monitoring",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-entitlement-id",
          "contract-id",
          "clause-anchor",
          "entitlement-type",
          "trigger-condition",
          "estimated-value",
          "trigger-date",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "tactical-sourcing-autonomy"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "tail-spend-evaluation",
        "filterContract": [
          {
            "fieldId": "tail-spend-evaluation-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "tail-spend-evaluation-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-tactical-sourcing-autonomy-read-tail-spend-evaluation",
        "identityFieldId": "tail-spend-evaluation-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "spend-data-foundation",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "tail-spend-evaluation-id",
          "spend-record-id",
          "tail-spend-rule-id",
          "evaluation-result",
          "definition-version",
          "evaluated-at",
          "source-record-version",
          "lifecycle-state",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "payment-readiness"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-entitlement",
        "filterContract": [
          {
            "fieldId": "contract-entitlement-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-entitlement-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-payment-readiness-read-contract-entitlement",
        "identityFieldId": "contract-entitlement-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "obligation-monitoring",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-entitlement-id",
          "contract-id",
          "clause-anchor",
          "entitlement-type",
          "trigger-condition",
          "estimated-value",
          "trigger-date",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "value-leakage-monitor"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "purchase-order",
        "filterContract": [
          {
            "fieldId": "purchase-order-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "purchase-order-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-value-leakage-monitor-read-purchase-order",
        "identityFieldId": "purchase-order-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "purchase-order-orchestration",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "purchase-order-id",
          "purchase-order-number",
          "supplier-id",
          "lifecycle-state",
          "total-amount",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-event"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-response",
        "filterContract": [
          {
            "fieldId": "supplier-response-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-response-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-event-read-supplier-response",
        "identityFieldId": "supplier-response-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "sourcing-event",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-response-id",
          "sourcing-event-record-id",
          "supplier-party-id",
          "response-version",
          "submitted-at",
          "total-price",
          "artifact-id",
          "evidence-item-ids",
          "supersedes-supplier-response-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "demand-consolidation-portfolio"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "budget",
        "filterContract": [
          {
            "fieldId": "budget-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "budget-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-demand-consolidation-portfolio-read-budget",
        "identityFieldId": "budget-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "demand-consolidation-portfolio",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "budget-id",
          "company-party-id",
          "business-unit-id",
          "owner-role-id",
          "budget-code",
          "period-start",
          "period-end",
          "authorised-amount",
          "supersedes-budget-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-intake-digitization"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-intake",
        "filterContract": [
          {
            "fieldId": "contract-intake-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-intake-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-intake-digitization-read-contract-intake",
        "identityFieldId": "contract-intake-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "contract-intake-digitization",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-intake-id",
          "external-reference",
          "candidate-contract-id",
          "source-artifact-ids",
          "extraction-confidence",
          "received-at",
          "updated-at",
          "governance-authority-envelope-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-approval-repository"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract",
        "filterContract": [
          {
            "fieldId": "contract-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-approval-repository-read-contract",
        "identityFieldId": "contract-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "contract-approval-repository",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-id",
          "contract-number",
          "title",
          "supplier-id",
          "parent-contract-id",
          "current-version-id",
          "effective-date",
          "expiry-date",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-authoring-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "clause-deviation",
        "filterContract": [
          {
            "fieldId": "clause-deviation-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "clause-deviation-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-authoring-review-read-clause-deviation",
        "identityFieldId": "clause-deviation-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "contract-authoring-review",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "clause-deviation-id",
          "contract-version-id",
          "clause-anchor",
          "playbook-rule-id",
          "risk-level",
          "proposed-language",
          "resolution-rationale",
          "governance-decision-id",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-approval-repository"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-approval",
        "filterContract": [
          {
            "fieldId": "contract-approval-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-approval-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-approval-repository-read-contract-approval",
        "identityFieldId": "contract-approval-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "contract-approval-repository",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-approval-id",
          "contract-version-id",
          "content-hash",
          "decision-type",
          "authority-grant-reference",
          "decided-at",
          "receipt-id",
          "governance-decision-id",
          "governance-authority-envelope-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "obligation-monitoring"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-obligation",
        "filterContract": [
          {
            "fieldId": "contract-obligation-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-obligation-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-obligation-monitoring-read-contract-obligation",
        "identityFieldId": "contract-obligation-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "obligation-monitoring",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-obligation-id",
          "contract-id",
          "contract-version-id",
          "clause-anchor",
          "obligation-type",
          "owner-reference",
          "due-at",
          "evidence-requirements",
          "risk-level",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "obligation-monitoring"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-entitlement",
        "filterContract": [
          {
            "fieldId": "contract-entitlement-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-entitlement-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-obligation-monitoring-read-contract-entitlement",
        "identityFieldId": "contract-entitlement-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "obligation-monitoring",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-entitlement-id",
          "contract-id",
          "clause-anchor",
          "entitlement-type",
          "trigger-condition",
          "estimated-value",
          "trigger-date",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-onboarding"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-profile",
        "filterContract": [
          {
            "fieldId": "supplier-profile-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-profile-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-onboarding-read-supplier-profile",
        "identityFieldId": "supplier-profile-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-onboarding",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-profile-id",
          "party-id",
          "supplier-number",
          "legal-name",
          "country-code",
          "legal-entity-identifier",
          "external-identifiers",
          "eligibility-status",
          "verified-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-onboarding"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-onboarding-case",
        "filterContract": [
          {
            "fieldId": "supplier-onboarding-case-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-onboarding-case-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-onboarding-read-supplier-onboarding-case",
        "identityFieldId": "supplier-onboarding-case-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-onboarding",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-onboarding-case-id",
          "supplier-id",
          "request-reference",
          "requirement-set-version",
          "evidence-state",
          "duplicate-candidate-ids",
          "due-at",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-master-qualification"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-qualification",
        "filterContract": [
          {
            "fieldId": "supplier-qualification-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-qualification-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-master-qualification-read-supplier-qualification",
        "identityFieldId": "supplier-qualification-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-master-qualification",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-qualification-id",
          "supplier-id",
          "scope-code",
          "policy-version",
          "conditions",
          "valid-from",
          "valid-to",
          "governance-decision-id",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "third-party-risk-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-risk-assessment",
        "filterContract": [
          {
            "fieldId": "supplier-risk-assessment-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-risk-assessment-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-third-party-risk-review-read-supplier-risk-assessment",
        "identityFieldId": "supplier-risk-assessment-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "third-party-risk-review",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-risk-assessment-id",
          "supplier-id",
          "assessment-scope",
          "policy-version",
          "evidence-state",
          "inherent-risk-level",
          "residual-risk-level",
          "valid-to",
          "governance-decision-id",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "continuous-risk-monitoring"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-risk-signal",
        "filterContract": [
          {
            "fieldId": "supplier-risk-signal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-risk-signal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-continuous-risk-monitoring-read-supplier-risk-signal",
        "identityFieldId": "supplier-risk-signal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "continuous-risk-monitoring",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-risk-signal-id",
          "supplier-id",
          "risk-domain",
          "source-reference",
          "deduplication-key",
          "materiality",
          "confidence",
          "observed-at",
          "ingested-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "continuous-risk-monitoring"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-risk-case",
        "filterContract": [
          {
            "fieldId": "supplier-risk-case-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-risk-case-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-continuous-risk-monitoring-read-supplier-risk-case",
        "identityFieldId": "supplier-risk-case-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "continuous-risk-monitoring",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-risk-case-id",
          "supplier-id",
          "signal-ids",
          "case-family-key",
          "severity",
          "proposed-action",
          "opened-at",
          "governance-exception-id",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "continuous-risk-monitoring"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-tier-link",
        "filterContract": [
          {
            "fieldId": "supplier-tier-link-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-tier-link-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-continuous-risk-monitoring-read-supplier-tier-link",
        "identityFieldId": "supplier-tier-link-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "continuous-risk-monitoring",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-tier-link-id",
          "from-supplier-id",
          "to-supplier-id",
          "external-node",
          "dependency-type",
          "evidence-reference",
          "confidence",
          "valid-to",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "guided-buying"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "buying-request",
        "filterContract": [
          {
            "fieldId": "buying-request-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "buying-request-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-guided-buying-read-buying-request",
        "identityFieldId": "buying-request-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "guided-buying",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "buying-request-id",
          "requester-reference",
          "business-unit-code",
          "need-description",
          "classification-code",
          "estimated-value",
          "needed-by-date",
          "option-set",
          "selected-route",
          "category-id",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "requisition-policy-routing"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "requisition",
        "filterContract": [
          {
            "fieldId": "requisition-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "requisition-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-requisition-policy-routing-read-requisition",
        "identityFieldId": "requisition-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "requisition-policy-routing",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "requisition-id",
          "requisition-number",
          "source-buying-request-id",
          "requester-reference",
          "business-unit-code",
          "total-amount",
          "policy-evaluation",
          "budget-reservation",
          "budget-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "requisition-policy-routing"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "requisition-line",
        "filterContract": [
          {
            "fieldId": "requisition-line-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "requisition-line-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-requisition-policy-routing-read-requisition-line",
        "identityFieldId": "requisition-line-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "requisition-policy-routing",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "requisition-line-id",
          "requisition-id",
          "line-number",
          "catalogue-line-id",
          "supplier-id",
          "description",
          "quantity",
          "unit-price",
          "accounting-splits",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "purchase-order-orchestration"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "purchase-order",
        "filterContract": [
          {
            "fieldId": "purchase-order-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "purchase-order-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-purchase-order-orchestration-read-purchase-order",
        "identityFieldId": "purchase-order-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "purchase-order-orchestration",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "purchase-order-id",
          "purchase-order-number",
          "order-version",
          "requisition-id",
          "supplier-id",
          "contract-id",
          "total-amount",
          "idempotency-key",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "purchase-order-orchestration"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "order-line",
        "filterContract": [
          {
            "fieldId": "order-line-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "order-line-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-purchase-order-orchestration-read-order-line",
        "identityFieldId": "order-line-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "purchase-order-orchestration",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "order-line-id",
          "purchase-order-id",
          "requisition-line-id",
          "line-number",
          "item-identifiers",
          "description",
          "ordered-quantity",
          "unit-price",
          "delivery-requirement",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "purchase-order-orchestration"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "order-response",
        "filterContract": [
          {
            "fieldId": "order-response-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "order-response-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-purchase-order-orchestration-read-order-response",
        "identityFieldId": "order-response-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "purchase-order-orchestration",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "order-response-id",
          "purchase-order-id",
          "supplier-response-id",
          "response-code",
          "proposed-changes",
          "artifact-id",
          "received-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "receiving-service-entry"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "shipment",
        "filterContract": [
          {
            "fieldId": "shipment-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "shipment-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-receiving-service-entry-read-shipment",
        "identityFieldId": "shipment-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "receiving-service-entry",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "shipment-id",
          "shipment-reference",
          "purchase-order-id",
          "despatch-lines",
          "package-identifiers",
          "expected-delivery-at",
          "observed-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "receiving-service-entry"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "receipt",
        "filterContract": [
          {
            "fieldId": "receipt-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "receipt-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-receiving-service-entry-read-receipt",
        "identityFieldId": "receipt-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "receiving-service-entry",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "receipt-id",
          "receipt-number",
          "purchase-order-id",
          "shipment-id",
          "receiving-location",
          "proof-artifact-ids",
          "idempotency-key",
          "received-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-intake-match"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "invoice",
        "filterContract": [
          {
            "fieldId": "invoice-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "invoice-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-intake-match-read-invoice",
        "identityFieldId": "invoice-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "invoice-intake-match",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "invoice-id",
          "invoice-number",
          "invoice-type-code",
          "supplier-party-id",
          "customer-party-id",
          "issue-date",
          "due-date",
          "order-ids",
          "contract-ids",
          "receipt-ids",
          "document-currency-code",
          "tax-total",
          "allowance-charge-total",
          "legal-monetary-total",
          "payment-means",
          "payment-terms",
          "source-artifact-id",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-intake-match"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "invoice-match-assessment",
        "filterContract": [
          {
            "fieldId": "invoice-match-assessment-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "invoice-match-assessment-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-intake-match-read-invoice-match-assessment",
        "identityFieldId": "invoice-match-assessment-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "invoice-intake-match",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "invoice-match-assessment-id",
          "invoice-id",
          "match-basis",
          "comparison-set",
          "tolerances",
          "result",
          "exception-reason-codes",
          "confidence-band",
          "proposal-status",
          "assessed-at",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "purchase-order-id",
          "order-line-ids",
          "receipt-ids",
          "receipt-line-ids",
          "service-entry-sheet-ids",
          "governance-decision-id",
          "governance-authority-envelope-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-exception-triage"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "invoice-exception",
        "filterContract": [
          {
            "fieldId": "invoice-exception-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "invoice-exception-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-exception-triage-read-invoice-exception",
        "identityFieldId": "invoice-exception-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "invoice-exception-triage",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "invoice-exception-id",
          "invoice-id",
          "match-assessment-id",
          "exception-type",
          "materiality-band",
          "owner-reference",
          "due-at",
          "proposed-resolution",
          "proposal-status",
          "committed-disposition",
          "authority-envelope-id",
          "opened-at",
          "updated-at",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "governance-exception-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-invoice-resolution"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-invoice-resolution",
        "filterContract": [
          {
            "fieldId": "supplier-invoice-resolution-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-invoice-resolution-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-invoice-resolution-read-supplier-invoice-resolution",
        "identityFieldId": "supplier-invoice-resolution-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-invoice-resolution",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-invoice-resolution-id",
          "invoice-exception-id",
          "invoice-id",
          "supplier-party-id",
          "resolution-type",
          "channel",
          "proposed-action",
          "proposal-status",
          "committed-action",
          "authority-envelope-id",
          "application-response-id",
          "credit-note-id",
          "corrected-invoice-id",
          "opened-at",
          "next-action-at",
          "communicated-at",
          "confirmed-at",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "payment-readiness"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "payment-readiness-assessment",
        "filterContract": [
          {
            "fieldId": "payment-readiness-assessment-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "payment-readiness-assessment-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-payment-readiness-read-payment-readiness-assessment",
        "identityFieldId": "payment-readiness-assessment-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "payment-readiness",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "payment-readiness-assessment-id",
          "invoice-id",
          "resolution-ids",
          "check-results",
          "payable-amount",
          "due-date",
          "risk-flags",
          "proposed-readiness",
          "committed-readiness",
          "hold-reason-codes",
          "authority-envelope-id",
          "assessed-at",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-segmentation-governance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-segment-assignment",
        "filterContract": [
          {
            "fieldId": "supplier-segment-assignment-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-segment-assignment-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-segmentation-governance-read-supplier-segment-assignment",
        "identityFieldId": "supplier-segment-assignment-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-segmentation-governance",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-segment-assignment-id",
          "supplier-party-id",
          "category-ids",
          "segmentation-model-version",
          "input-snapshot-ids",
          "proposed-segment-code",
          "proposed-criticality-band",
          "proposal-status",
          "committed-segment-code",
          "committed-criticality-band",
          "relationship-posture",
          "authority-envelope-id",
          "valid-from",
          "valid-to",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-monitor-correct"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-performance-observation",
        "filterContract": [
          {
            "fieldId": "supplier-performance-observation-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-performance-observation-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-monitor-correct-read-supplier-performance-observation",
        "identityFieldId": "supplier-performance-observation-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-performance-monitor-correct",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-performance-observation-id",
          "supplier-party-id",
          "category-id",
          "contract-id",
          "service-id",
          "measure-code",
          "measure-definition-version",
          "performance-period-start",
          "performance-period-end",
          "target-value",
          "observed-value",
          "unit-code",
          "quality-status",
          "breach-status",
          "correction-status",
          "source-record-ids",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-performance-review-record",
        "filterContract": [
          {
            "fieldId": "supplier-performance-review-record-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-performance-review-record-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-review-read-supplier-performance-review-record",
        "identityFieldId": "supplier-performance-review-record-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-performance-review",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-performance-review-record-id",
          "supplier-party-id",
          "review-period-start",
          "review-period-end",
          "segment-assignment-id",
          "observation-ids",
          "scorecard-definition-version",
          "aggregate-scores",
          "trend-summary",
          "proposed-narrative",
          "proposed-actions",
          "proposal-status",
          "committed-decisions",
          "authority-envelope-id",
          "corrective-action-plan",
          "reviewed-at",
          "next-review-at",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "governance-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-innovation-pipeline"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-innovation-case",
        "filterContract": [
          {
            "fieldId": "supplier-innovation-case-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-innovation-case-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-innovation-pipeline-read-supplier-innovation-case",
        "identityFieldId": "supplier-innovation-case-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-innovation-pipeline",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-innovation-case-id",
          "supplier-party-id",
          "title",
          "need-or-opportunity",
          "sponsor-reference",
          "owner-reference",
          "category-ids",
          "contract-ids",
          "value-hypothesis",
          "risk-hypothesis",
          "proposed-next-action",
          "proposal-status",
          "committed-gate-decision",
          "authority-envelope-id",
          "experiment-plan",
          "experiment-outcome",
          "opened-at",
          "next-gate-at",
          "closed-at",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-relationship-joint-value"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-joint-value-plan",
        "filterContract": [
          {
            "fieldId": "supplier-joint-value-plan-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-joint-value-plan-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-relationship-joint-value-read-supplier-joint-value-plan",
        "identityFieldId": "supplier-joint-value-plan-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-relationship-joint-value",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-joint-value-plan-id",
          "supplier-party-id",
          "segment-assignment-id",
          "objectives",
          "mutual-commitments",
          "milestones",
          "governance-cadence",
          "shared-risk-and-benefit",
          "proposed-plan",
          "proposal-status",
          "committed-plan-version",
          "authority-envelope-id",
          "progress-summary",
          "linked-innovation-ids",
          "validated-value-ids",
          "effective-from",
          "effective-to",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "value-opportunity-baseline"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "value-opportunity-baseline",
        "filterContract": [
          {
            "fieldId": "value-opportunity-baseline-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "value-opportunity-baseline-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-value-opportunity-baseline-read-value-opportunity-baseline",
        "identityFieldId": "value-opportunity-baseline-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "value-opportunity-baseline",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "value-opportunity-baseline-id",
          "opportunity-reference",
          "opportunity-type",
          "title",
          "owner-reference",
          "category-ids",
          "supplier-party-ids",
          "contract-ids",
          "source-record-ids",
          "baseline-period-start",
          "baseline-period-end",
          "comparison-period-start",
          "comparison-period-end",
          "baseline-method-version",
          "baseline-amount",
          "target-amount",
          "forecast-amount",
          "currency-code",
          "assumptions",
          "proposed-validation",
          "proposal-status",
          "committed-validation",
          "authority-envelope-id",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "governance-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "savings-initiative"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "savings-initiative-record",
        "filterContract": [
          {
            "fieldId": "savings-initiative-record-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "savings-initiative-record-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-savings-initiative-read-savings-initiative-record",
        "identityFieldId": "savings-initiative-record-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "savings-initiative",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "savings-initiative-record-id",
          "value-opportunity-baseline-id",
          "title",
          "owner-reference",
          "sponsor-reference",
          "value-type",
          "value-recognition-treatment",
          "target-value",
          "forecast-value",
          "validated-realization",
          "leakage-value",
          "currency-code",
          "measurement-method-version",
          "milestone-plan",
          "dependency-ids",
          "proposed-plan-change",
          "proposal-status",
          "committed-plan-version",
          "authority-envelope-id",
          "start-date",
          "target-completion-date",
          "closed-at",
          "attention-status",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "realization-reconciliation-attribution"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "value-realization-attribution",
        "filterContract": [
          {
            "fieldId": "value-realization-attribution-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "value-realization-attribution-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-realization-reconciliation-attribution-read-value-realization-attribution",
        "identityFieldId": "value-realization-attribution-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "realization-reconciliation-attribution",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "value-realization-attribution-id",
          "savings-initiative-id",
          "value-opportunity-baseline-id",
          "attribution-period-start",
          "attribution-period-end",
          "actual-source-record-ids",
          "actual-amount",
          "gross-variance",
          "adjustments",
          "attributed-amount",
          "currency-code",
          "attribution-method-version",
          "double-count-check",
          "confidence-band",
          "proposed-disposition",
          "proposal-status",
          "committed-disposition",
          "authority-envelope-id",
          "reconciliation-status",
          "calculated-at",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "governance-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "value-leakage-monitor"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "value-leakage-finding",
        "filterContract": [
          {
            "fieldId": "value-leakage-finding-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "value-leakage-finding-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-value-leakage-monitor-read-value-leakage-finding",
        "identityFieldId": "value-leakage-finding-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "value-leakage-monitor",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "value-leakage-finding-id",
          "savings-initiative-id",
          "leakage-type",
          "supplier-party-id",
          "category-id",
          "contract-id",
          "source-record-ids",
          "expected-value",
          "actual-value",
          "dispersion-evidence",
          "exposure-amount",
          "currency-code",
          "materiality-band",
          "root-cause",
          "proposed-remediation",
          "proposal-status",
          "committed-remediation",
          "authority-envelope-id",
          "owner-reference",
          "detected-at",
          "due-at",
          "closed-at",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "spend-data-foundation"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "spend-record",
        "filterContract": [
          {
            "fieldId": "spend-record-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "source-system",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "source-record-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "source-line-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "category-id",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "accounting-date",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "supplier-party-id",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "company-party-id",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "spend-segment",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "spend-record-id",
          "source-system",
          "source-record-id",
          "source-line-id",
          "category-id",
          "accounting-date",
          "supplier-party-id",
          "company-party-id",
          "spend-segment",
          "lifecycle-state",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-spend-data-foundation-list-spend-record",
        "identityFieldId": "spend-record-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "spend-record-id"
          }
        ],
        "ownerId": "spend-data-foundation",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "spend-record-id",
          "source-system",
          "source-record-id",
          "source-line-id",
          "supplier-party-id",
          "company-party-id",
          "business-unit-id",
          "category-id",
          "spend-segment",
          "buying-mode",
          "accounting-treatment",
          "classification-resolution-status",
          "spend-classification-decision-id",
          "description",
          "amount",
          "accounting-date",
          "classification-confidence",
          "quality-status",
          "observed-at",
          "budget-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "category-opportunity-radar"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "category-opportunity",
        "filterContract": [
          {
            "fieldId": "category-opportunity-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "category-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "opportunity-type",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "priority-score",
            "operators": [
              "equals",
              "less-than",
              "less-than-or-equal",
              "greater-than",
              "greater-than-or-equal",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "evidence-as-of",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "strategy-id",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "category-opportunity-id",
          "category-id",
          "lifecycle-state",
          "opportunity-type",
          "priority-score",
          "evidence-as-of",
          "strategy-id",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-category-opportunity-radar-list-category-opportunity",
        "identityFieldId": "category-opportunity-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "category-opportunity-id"
          }
        ],
        "ownerId": "category-opportunity-radar",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "category-opportunity-id",
          "category-id",
          "title",
          "opportunity-type",
          "value-hypothesis",
          "priority-score",
          "evidence-item-ids",
          "strategy-id",
          "evidence-as-of",
          "governance-authority-envelope-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "category-strategy-orchestrator"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "category-strategy",
        "filterContract": [
          {
            "fieldId": "category-strategy-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "category-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "version-number",
            "operators": [
              "equals",
              "less-than",
              "less-than-or-equal",
              "greater-than",
              "greater-than-or-equal",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "review-due-date",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "owner-person-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "category-strategy-id",
          "category-id",
          "lifecycle-state",
          "version-number",
          "review-due-date",
          "owner-person-id",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-category-strategy-orchestrator-list-category-strategy",
        "identityFieldId": "category-strategy-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "category-strategy-id"
          }
        ],
        "ownerId": "category-strategy-orchestrator",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "category-strategy-id",
          "version-number",
          "category-id",
          "owner-person-id",
          "mission",
          "objectives",
          "initiative-ids",
          "authority-envelope-id",
          "effective-date",
          "review-due-date",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "policy-rule-lifecycle"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy-rule-release",
        "filterContract": [
          {
            "fieldId": "policy-rule-release-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "policy-version-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "release-number",
            "operators": [
              "equals",
              "less-than",
              "less-than-or-equal",
              "greater-than",
              "greater-than-or-equal",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-from",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "rule-code",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "policy-rule-release-id",
          "policy-version-id",
          "release-number",
          "lifecycle-state",
          "effective-from",
          "rule-code",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-rule-lifecycle-list-policy-rule-release",
        "identityFieldId": "policy-rule-release-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "policy-rule-release-id"
          }
        ],
        "ownerId": "policy-rule-lifecycle",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-rule-release-id",
          "policy-version-id",
          "release-number",
          "rule-code",
          "scope",
          "condition-expression",
          "effect",
          "precedence",
          "effective-from",
          "effective-until",
          "evaluation-result-id",
          "rollback-release-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "policy-guidance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy-guidance-result",
        "filterContract": [
          {
            "fieldId": "policy-guidance-result-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "subject-entity-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "evaluated-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "outcome",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "expires-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "rule-release-ids",
            "operators": [
              "contains-any",
              "contains-all"
            ],
            "required": false
          },
          {
            "fieldId": "exception-id",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "policy-guidance-result-id",
          "subject-entity-id",
          "evaluated-at",
          "outcome",
          "expires-at",
          "rule-release-ids",
          "exception-id",
          "lifecycle-state",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-guidance-list-policy-guidance-result",
        "identityFieldId": "policy-guidance-result-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "policy-guidance-result-id"
          }
        ],
        "ownerId": "policy-guidance",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-guidance-result-id",
          "subject-entity-id",
          "question",
          "input-facts",
          "rule-release-ids",
          "outcome",
          "permitted-route-codes",
          "required-evidence-codes",
          "explanation",
          "exception-id",
          "evaluated-at",
          "expires-at",
          "governance-decision-id",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "procurement-service-catalogue"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "procurement-service-offering",
        "filterContract": [
          {
            "fieldId": "procurement-service-offering-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "service-code",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "version-number",
            "operators": [
              "equals",
              "less-than",
              "less-than-or-equal",
              "greater-than",
              "greater-than-or-equal",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-from",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "owner-workblock-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "search-keywords",
            "operators": [
              "contains-any",
              "contains-all"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "procurement-service-offering-id",
          "service-code",
          "version-number",
          "lifecycle-state",
          "effective-from",
          "owner-workblock-id",
          "search-keywords",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-procurement-service-catalogue-list-procurement-service-offering",
        "identityFieldId": "procurement-service-offering-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "procurement-service-offering-id"
          }
        ],
        "ownerId": "procurement-service-catalogue",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "procurement-service-offering-id",
          "service-code",
          "version-number",
          "name",
          "description",
          "eligibility-expression",
          "input-schema",
          "owner-workblock-id",
          "policy-rule-release-ids",
          "service-expectation",
          "search-keywords",
          "effective-from",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "intelligent-intake"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "intake-request",
        "filterContract": [
          {
            "fieldId": "intake-request-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "requester-person-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "service-offering-id",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "submitted-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "business-unit-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "external-reference",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "intake-request-id",
          "requester-person-id",
          "lifecycle-state",
          "service-offering-id",
          "submitted-at",
          "business-unit-id",
          "external-reference",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-intelligent-intake-list-intake-request",
        "identityFieldId": "intake-request-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "intake-request-id"
          }
        ],
        "ownerId": "intelligent-intake",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "intake-request-id",
          "external-reference",
          "requester-person-id",
          "business-unit-id",
          "service-offering-id",
          "need-statement",
          "requirements",
          "estimated-value",
          "needed-by-date",
          "evidence-item-ids",
          "completeness-score",
          "submitted-at",
          "governance-authority-envelope-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "request-enrichment-routing"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "enriched-request",
        "filterContract": [
          {
            "fieldId": "enriched-request-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "intake-request-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "version-number",
            "operators": [
              "equals",
              "less-than",
              "less-than-or-equal",
              "greater-than",
              "greater-than-or-equal",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "route-code",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "category-id",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "expires-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "enriched-request-id",
          "intake-request-id",
          "version-number",
          "route-code",
          "lifecycle-state",
          "category-id",
          "expires-at",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-request-enrichment-routing-list-enriched-request",
        "identityFieldId": "enriched-request-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "enriched-request-id"
          }
        ],
        "ownerId": "request-enrichment-routing",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "enriched-request-id",
          "version-number",
          "intake-request-id",
          "category-id",
          "normalised-requirements",
          "context-links",
          "policy-guidance-result-id",
          "route-code",
          "route-confidence",
          "missing-evidence-codes",
          "expires-at",
          "governance-decision-id",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "demand-orchestration"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "demand-case",
        "filterContract": [
          {
            "fieldId": "demand-case-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "intake-request-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "route-code",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "owner-person-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "next-action-due-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "portfolio-id",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "demand-case-id",
          "intake-request-id",
          "route-code",
          "lifecycle-state",
          "owner-person-id",
          "next-action-due-at",
          "portfolio-id",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-demand-orchestration-list-demand-case",
        "identityFieldId": "demand-case-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "demand-case-id"
          }
        ],
        "ownerId": "demand-orchestration",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "demand-case-id",
          "intake-request-id",
          "enrichment-id",
          "route-code",
          "plan-version",
          "step-state",
          "owner-person-id",
          "committed-action-ids",
          "exception-id",
          "portfolio-id",
          "next-action-due-at",
          "updated-at",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "demand-consolidation-portfolio"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "demand-portfolio",
        "filterContract": [
          {
            "fieldId": "demand-portfolio-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "category-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "target-window-start",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "target-window-end",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "owner-person-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "strategy-id",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "demand-portfolio-id",
          "category-id",
          "lifecycle-state",
          "target-window-start",
          "target-window-end",
          "owner-person-id",
          "strategy-id",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-demand-consolidation-portfolio-list-demand-portfolio",
        "identityFieldId": "demand-portfolio-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "demand-portfolio-id"
          }
        ],
        "ownerId": "demand-consolidation-portfolio",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "demand-portfolio-id",
          "version-number",
          "category-id",
          "demand-case-ids",
          "forecast-components",
          "consolidation-rationale",
          "scenario-set",
          "strategy-id",
          "owner-person-id",
          "target-window-start",
          "target-window-end",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-pipeline-discovery"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "sourcing-opportunity",
        "filterContract": [
          {
            "fieldId": "sourcing-opportunity-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "category-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "recommended-route",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "priority-score",
            "operators": [
              "equals",
              "less-than",
              "less-than-or-equal",
              "greater-than",
              "greater-than-or-equal",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "target-start-date",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "strategy-id",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "demand-portfolio-id",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "sourcing-opportunity-id",
          "category-id",
          "lifecycle-state",
          "recommended-route",
          "priority-score",
          "target-start-date",
          "strategy-id",
          "demand-portfolio-id",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-pipeline-discovery-list-sourcing-opportunity",
        "identityFieldId": "sourcing-opportunity-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "sourcing-opportunity-id"
          }
        ],
        "ownerId": "sourcing-pipeline-discovery",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "sourcing-opportunity-id",
          "category-id",
          "strategy-id",
          "demand-portfolio-id",
          "title",
          "scope-summary",
          "market-candidate-party-ids",
          "recommended-route",
          "value-hypothesis",
          "priority-score",
          "target-start-date",
          "evidence-as-of",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-event"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "sourcing-event-record",
        "filterContract": [
          {
            "fieldId": "sourcing-event-record-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "event-number",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "sourcing-opportunity-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "submission-deadline",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "category-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "published-version",
            "operators": [
              "equals",
              "less-than",
              "less-than-or-equal",
              "greater-than",
              "greater-than-or-equal",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "sourcing-event-record-id",
          "event-number",
          "sourcing-opportunity-id",
          "lifecycle-state",
          "submission-deadline",
          "category-id",
          "published-version",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-event-list-sourcing-event-record",
        "identityFieldId": "sourcing-event-record-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "sourcing-event-record-id"
          }
        ],
        "ownerId": "sourcing-event",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "sourcing-event-record-id",
          "event-number",
          "published-version",
          "sourcing-opportunity-id",
          "category-id",
          "event-type",
          "event-specification",
          "invited-party-ids",
          "artifact-ids",
          "submission-deadline",
          "last-reconciled-at",
          "governance-authority-envelope-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "bid-evaluation-award"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "award-scenario",
        "filterContract": [
          {
            "fieldId": "award-scenario-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "sourcing-event-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "scenario-number",
            "operators": [
              "equals",
              "less-than",
              "less-than-or-equal",
              "greater-than",
              "greater-than-or-equal",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "recommended-party-ids",
            "operators": [
              "contains-any",
              "contains-all"
            ],
            "required": false
          },
          {
            "fieldId": "committed-decision-id",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "award-scenario-id",
          "sourcing-event-id",
          "scenario-number",
          "lifecycle-state",
          "recommended-party-ids",
          "committed-decision-id",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-bid-evaluation-award-list-award-scenario",
        "identityFieldId": "award-scenario-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "award-scenario-id"
          }
        ],
        "ownerId": "bid-evaluation-award",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "award-scenario-id",
          "scenario-number",
          "sourcing-event-id",
          "bid-source-ids",
          "evaluation-model",
          "normalised-results",
          "constraint-set",
          "recommended-party-ids",
          "allocation",
          "sensitivity-analysis",
          "committed-decision-id",
          "evaluated-at",
          "governance-decision-id",
          "governance-authority-envelope-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "negotiation-copilot"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "negotiation-session",
        "filterContract": [
          {
            "fieldId": "negotiation-session-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "source-record-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "counterparty-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "authority-envelope-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "next-exchange-due-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "negotiation-session-id",
          "source-record-id",
          "counterparty-id",
          "lifecycle-state",
          "authority-envelope-id",
          "next-exchange-due-at",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-negotiation-copilot-list-negotiation-session",
        "identityFieldId": "negotiation-session-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "negotiation-session-id"
          }
        ],
        "ownerId": "negotiation-copilot",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "negotiation-session-id",
          "source-record-id",
          "counterparty-id",
          "objective-model",
          "issue-state",
          "authority-envelope-id",
          "exchange-artifact-ids",
          "current-proposal",
          "agreement-in-principle",
          "next-exchange-due-at",
          "updated-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "tactical-sourcing-autonomy"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "tactical-sourcing-case",
        "filterContract": [
          {
            "fieldId": "tactical-sourcing-case-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "demand-case-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "next-action-due-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "category-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "authority-envelope-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "committed-action-id",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "tactical-sourcing-case-id",
          "demand-case-id",
          "lifecycle-state",
          "next-action-due-at",
          "category-id",
          "authority-envelope-id",
          "committed-action-id",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-tactical-sourcing-autonomy-list-tactical-sourcing-case",
        "identityFieldId": "tactical-sourcing-case-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "tactical-sourcing-case-id"
          }
        ],
        "ownerId": "tactical-sourcing-autonomy",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "tactical-sourcing-case-id",
          "demand-case-id",
          "category-id",
          "eligibility-result",
          "authority-envelope-id",
          "invited-party-ids",
          "quote-request-artifact-id",
          "response-set",
          "award-proposal",
          "committed-action-id",
          "reconciliation-state",
          "next-action-due-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "spend-data-foundation"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "spend-classification-decision",
        "filterContract": [
          {
            "fieldId": "spend-classification-decision-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "spend-record-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "dimension-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "company-party-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "decided-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "spend-classification-decision-id",
          "spend-record-id",
          "dimension-id",
          "lifecycle-state",
          "company-party-id",
          "decided-at",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-spend-data-foundation-list-spend-classification-decision",
        "identityFieldId": "spend-classification-decision-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "spend-classification-decision-id"
          }
        ],
        "ownerId": "spend-data-foundation",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "spend-classification-decision-id",
          "company-party-id",
          "spend-record-id",
          "dimension-id",
          "proposed-member-id",
          "committed-member-id",
          "resolution-source",
          "decision-method",
          "actor-reference",
          "authority-envelope-id",
          "rule-release-id",
          "model-version",
          "confidence",
          "rationale",
          "evidence-item-ids",
          "source-version-references",
          "predecessor-decision-id",
          "decided-at",
          "external-acknowledgement-status",
          "governance-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "policy-rule-lifecycle"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "tail-spend-rule",
        "filterContract": [
          {
            "fieldId": "tail-spend-rule-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "company-party-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "rule-version",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-from",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "tail-spend-rule-id",
          "company-party-id",
          "rule-version",
          "lifecycle-state",
          "effective-from",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-rule-lifecycle-list-tail-spend-rule",
        "identityFieldId": "tail-spend-rule-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "tail-spend-rule-id"
          }
        ],
        "ownerId": "policy-rule-lifecycle",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "tail-spend-rule-id",
          "company-party-id",
          "business-unit-id",
          "rule-version",
          "method",
          "threshold-amount",
          "pareto-percentage",
          "evaluation-period-basis",
          "included-category-ids",
          "excluded-category-ids",
          "effective-from",
          "effective-until",
          "authority-envelope-id",
          "evidence-item-ids",
          "supersedes-tail-spend-rule-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-event"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-response",
        "filterContract": [
          {
            "fieldId": "supplier-response-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "sourcing-event-record-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "supplier-party-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "response-version",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "supplier-response-id",
          "sourcing-event-record-id",
          "supplier-party-id",
          "response-version",
          "lifecycle-state",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-event-list-supplier-response",
        "identityFieldId": "supplier-response-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "supplier-response-id"
          }
        ],
        "ownerId": "sourcing-event",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-response-id",
          "sourcing-event-record-id",
          "supplier-party-id",
          "response-version",
          "submitted-at",
          "total-price",
          "artifact-id",
          "evidence-item-ids",
          "supersedes-supplier-response-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "demand-consolidation-portfolio"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "budget",
        "filterContract": [
          {
            "fieldId": "budget-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "company-party-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "budget-code",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "period-start",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "budget-id",
          "company-party-id",
          "budget-code",
          "period-start",
          "lifecycle-state",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-demand-consolidation-portfolio-list-budget",
        "identityFieldId": "budget-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "budget-id"
          }
        ],
        "ownerId": "demand-consolidation-portfolio",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "budget-id",
          "company-party-id",
          "business-unit-id",
          "owner-role-id",
          "budget-code",
          "period-start",
          "period-end",
          "authorised-amount",
          "supersedes-budget-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "spend-data-foundation"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "tail-spend-evaluation",
        "filterContract": [
          {
            "fieldId": "tail-spend-evaluation-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "tail-spend-rule-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "spend-record-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "tail-spend-evaluation-id",
          "tail-spend-rule-id",
          "spend-record-id",
          "lifecycle-state",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-spend-data-foundation-list-tail-spend-evaluation",
        "identityFieldId": "tail-spend-evaluation-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "tail-spend-evaluation-id"
          }
        ],
        "ownerId": "spend-data-foundation",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "tail-spend-evaluation-id",
          "spend-record-id",
          "tail-spend-rule-id",
          "evaluation-result",
          "definition-version",
          "evaluated-at",
          "source-record-version",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-intake-digitization"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-intake",
        "filterContract": [
          {
            "fieldId": "contract-intake-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "external-reference",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "received-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "candidate-contract-id",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "contract-intake-id",
          "external-reference",
          "lifecycle-state",
          "received-at",
          "candidate-contract-id",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-intake-digitization-list-contract-intake",
        "identityFieldId": "contract-intake-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "contract-intake-id"
          }
        ],
        "ownerId": "contract-intake-digitization",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-intake-id",
          "external-reference",
          "candidate-contract-id",
          "source-artifact-ids",
          "extraction-confidence",
          "received-at",
          "updated-at",
          "governance-authority-envelope-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-approval-repository"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract",
        "filterContract": [
          {
            "fieldId": "contract-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "contract-number",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-date",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "supplier-id",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "parent-contract-id",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "contract-id",
          "contract-number",
          "lifecycle-state",
          "effective-date",
          "supplier-id",
          "parent-contract-id",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-approval-repository-list-contract",
        "identityFieldId": "contract-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "contract-id"
          }
        ],
        "ownerId": "contract-approval-repository",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-id",
          "contract-number",
          "title",
          "supplier-id",
          "parent-contract-id",
          "current-version-id",
          "effective-date",
          "expiry-date",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-authoring-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-version",
        "filterContract": [
          {
            "fieldId": "contract-version-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "contract-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "version-number",
            "operators": [
              "equals",
              "less-than",
              "less-than-or-equal",
              "greater-than",
              "greater-than-or-equal",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "content-hash",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "contract-version-id",
          "contract-id",
          "version-number",
          "content-hash",
          "lifecycle-state",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-authoring-review-list-contract-version",
        "identityFieldId": "contract-version-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "contract-version-id"
          }
        ],
        "ownerId": "contract-authoring-review",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-version-id",
          "contract-id",
          "version-number",
          "parent-version-id",
          "artifact-id",
          "content-hash",
          "playbook-version",
          "committed-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-authoring-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-template",
        "filterContract": [
          {
            "fieldId": "contract-template-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "template-code",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "semantic-version",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-from",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "content-hash",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "contract-template-id",
          "template-code",
          "semantic-version",
          "lifecycle-state",
          "effective-from",
          "content-hash",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-authoring-review-list-contract-template",
        "identityFieldId": "contract-template-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "contract-template-id"
          }
        ],
        "ownerId": "contract-authoring-review",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-template-id",
          "template-code",
          "semantic-version",
          "title",
          "artifact-id",
          "content-hash",
          "policy-version-id",
          "applicability-rules",
          "effective-from",
          "effective-to",
          "approval-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-authoring-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "clause-library-entry",
        "filterContract": [
          {
            "fieldId": "clause-library-entry-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "clause-code",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "semantic-version",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-from",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "jurisdiction-codes",
            "operators": [
              "contains-any",
              "contains-all"
            ],
            "required": false
          },
          {
            "fieldId": "text-hash",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "clause-library-entry-id",
          "clause-code",
          "semantic-version",
          "lifecycle-state",
          "effective-from",
          "jurisdiction-codes",
          "text-hash",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-authoring-review-list-clause-library-entry",
        "identityFieldId": "clause-library-entry-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "clause-library-entry-id"
          }
        ],
        "ownerId": "contract-authoring-review",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "clause-library-entry-id",
          "clause-code",
          "semantic-version",
          "title",
          "clause-text",
          "text-hash",
          "policy-version-id",
          "jurisdiction-codes",
          "applicability-rules",
          "semantic-tags",
          "effective-from",
          "effective-to",
          "approval-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-authoring-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "clause-deviation",
        "filterContract": [
          {
            "fieldId": "clause-deviation-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "contract-version-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "clause-anchor",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "risk-level",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "playbook-rule-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "clause-deviation-id",
          "contract-version-id",
          "clause-anchor",
          "risk-level",
          "lifecycle-state",
          "playbook-rule-id",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-authoring-review-list-clause-deviation",
        "identityFieldId": "clause-deviation-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "clause-deviation-id"
          }
        ],
        "ownerId": "contract-authoring-review",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "clause-deviation-id",
          "contract-version-id",
          "clause-anchor",
          "playbook-rule-id",
          "risk-level",
          "proposed-language",
          "resolution-rationale",
          "governance-decision-id",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "contract-approval-repository"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-approval",
        "filterContract": [
          {
            "fieldId": "contract-approval-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "contract-version-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "authority-grant-reference",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "content-hash",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "contract-approval-id",
          "contract-version-id",
          "lifecycle-state",
          "authority-grant-reference",
          "content-hash",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-contract-approval-repository-list-contract-approval",
        "identityFieldId": "contract-approval-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "contract-approval-id"
          }
        ],
        "ownerId": "contract-approval-repository",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-approval-id",
          "contract-version-id",
          "content-hash",
          "decision-type",
          "authority-grant-reference",
          "decided-at",
          "receipt-id",
          "governance-decision-id",
          "governance-authority-envelope-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "obligation-monitoring"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-obligation",
        "filterContract": [
          {
            "fieldId": "contract-obligation-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "contract-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "due-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "owner-reference",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "risk-level",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "contract-obligation-id",
          "contract-id",
          "due-at",
          "owner-reference",
          "lifecycle-state",
          "risk-level",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-obligation-monitoring-list-contract-obligation",
        "identityFieldId": "contract-obligation-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "contract-obligation-id"
          }
        ],
        "ownerId": "obligation-monitoring",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-obligation-id",
          "contract-id",
          "contract-version-id",
          "clause-anchor",
          "obligation-type",
          "owner-reference",
          "due-at",
          "evidence-requirements",
          "risk-level",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "obligation-monitoring"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-entitlement",
        "filterContract": [
          {
            "fieldId": "contract-entitlement-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "contract-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "trigger-date",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "entitlement-type",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "contract-entitlement-id",
          "contract-id",
          "lifecycle-state",
          "trigger-date",
          "entitlement-type",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-obligation-monitoring-list-contract-entitlement",
        "identityFieldId": "contract-entitlement-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "contract-entitlement-id"
          }
        ],
        "ownerId": "obligation-monitoring",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-entitlement-id",
          "contract-id",
          "clause-anchor",
          "entitlement-type",
          "trigger-condition",
          "estimated-value",
          "trigger-date",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "renewal-change-compliance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-change",
        "filterContract": [
          {
            "fieldId": "contract-change-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "contract-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "change-type",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "decision-deadline",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "resulting-version-id",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "contract-change-id",
          "contract-id",
          "change-type",
          "decision-deadline",
          "lifecycle-state",
          "resulting-version-id",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-renewal-change-compliance-list-contract-change",
        "identityFieldId": "contract-change-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "contract-change-id"
          }
        ],
        "ownerId": "renewal-change-compliance",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-change-id",
          "contract-id",
          "change-type",
          "trigger-reference",
          "decision-deadline",
          "impact-summary",
          "resulting-version-id",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "renewal-change-compliance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-compliance-finding",
        "filterContract": [
          {
            "fieldId": "contract-compliance-finding-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "contract-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "finding-type",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "severity",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "observed-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "contract-compliance-finding-id",
          "contract-id",
          "finding-type",
          "severity",
          "lifecycle-state",
          "observed-at",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-renewal-change-compliance-list-contract-compliance-finding",
        "identityFieldId": "contract-compliance-finding-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "contract-compliance-finding-id"
          }
        ],
        "ownerId": "renewal-change-compliance",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-compliance-finding-id",
          "contract-id",
          "source-term-reference",
          "observed-evidence-ids",
          "finding-type",
          "severity",
          "estimated-impact",
          "observed-at",
          "governance-authority-envelope-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-onboarding"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-profile",
        "filterContract": [
          {
            "fieldId": "supplier-profile-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "supplier-number",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "legal-name",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "country-code",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "legal-entity-identifier",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "eligibility-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "party-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "supplier-profile-id",
          "supplier-number",
          "legal-name",
          "country-code",
          "legal-entity-identifier",
          "lifecycle-state",
          "eligibility-status",
          "party-id",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-onboarding-list-supplier-profile",
        "identityFieldId": "supplier-profile-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "supplier-profile-id"
          }
        ],
        "ownerId": "supplier-onboarding",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-profile-id",
          "party-id",
          "supplier-number",
          "legal-name",
          "country-code",
          "legal-entity-identifier",
          "external-identifiers",
          "eligibility-status",
          "verified-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-onboarding"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-onboarding-case",
        "filterContract": [
          {
            "fieldId": "supplier-onboarding-case-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "supplier-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "request-reference",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "due-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "supplier-onboarding-case-id",
          "supplier-id",
          "lifecycle-state",
          "request-reference",
          "due-at",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-onboarding-list-supplier-onboarding-case",
        "identityFieldId": "supplier-onboarding-case-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "supplier-onboarding-case-id"
          }
        ],
        "ownerId": "supplier-onboarding",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-onboarding-case-id",
          "supplier-id",
          "request-reference",
          "requirement-set-version",
          "evidence-state",
          "duplicate-candidate-ids",
          "due-at",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-master-qualification"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-qualification",
        "filterContract": [
          {
            "fieldId": "supplier-qualification-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "supplier-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "scope-code",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "valid-to",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "policy-version",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "supplier-qualification-id",
          "supplier-id",
          "scope-code",
          "lifecycle-state",
          "valid-to",
          "policy-version",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-master-qualification-list-supplier-qualification",
        "identityFieldId": "supplier-qualification-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "supplier-qualification-id"
          }
        ],
        "ownerId": "supplier-master-qualification",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-qualification-id",
          "supplier-id",
          "scope-code",
          "policy-version",
          "conditions",
          "valid-from",
          "valid-to",
          "governance-decision-id",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-master-qualification"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-master-change",
        "filterContract": [
          {
            "fieldId": "supplier-master-change-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "supplier-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "change-type",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "requested-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "idempotency-key",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "supplier-master-change-id",
          "supplier-id",
          "change-type",
          "lifecycle-state",
          "requested-at",
          "idempotency-key",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-master-qualification-list-supplier-master-change",
        "identityFieldId": "supplier-master-change-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "supplier-master-change-id"
          }
        ],
        "ownerId": "supplier-master-qualification",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-master-change-id",
          "supplier-id",
          "change-type",
          "change-payload",
          "verification-state",
          "idempotency-key",
          "requested-at",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "third-party-risk-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-risk-assessment",
        "filterContract": [
          {
            "fieldId": "supplier-risk-assessment-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "supplier-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "residual-risk-level",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "valid-to",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "supplier-risk-assessment-id",
          "supplier-id",
          "residual-risk-level",
          "lifecycle-state",
          "valid-to",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-third-party-risk-review-list-supplier-risk-assessment",
        "identityFieldId": "supplier-risk-assessment-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "supplier-risk-assessment-id"
          }
        ],
        "ownerId": "third-party-risk-review",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-risk-assessment-id",
          "supplier-id",
          "assessment-scope",
          "policy-version",
          "evidence-state",
          "inherent-risk-level",
          "residual-risk-level",
          "valid-to",
          "governance-decision-id",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "continuous-risk-monitoring"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-risk-signal",
        "filterContract": [
          {
            "fieldId": "supplier-risk-signal-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "supplier-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "observed-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "risk-domain",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "materiality",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "deduplication-key",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "supplier-risk-signal-id",
          "supplier-id",
          "observed-at",
          "risk-domain",
          "materiality",
          "deduplication-key",
          "lifecycle-state",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-continuous-risk-monitoring-list-supplier-risk-signal",
        "identityFieldId": "supplier-risk-signal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "supplier-risk-signal-id"
          }
        ],
        "ownerId": "continuous-risk-monitoring",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-risk-signal-id",
          "supplier-id",
          "risk-domain",
          "source-reference",
          "deduplication-key",
          "materiality",
          "confidence",
          "observed-at",
          "ingested-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "continuous-risk-monitoring"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-risk-case",
        "filterContract": [
          {
            "fieldId": "supplier-risk-case-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "supplier-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "severity",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "opened-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "case-family-key",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "supplier-risk-case-id",
          "supplier-id",
          "lifecycle-state",
          "severity",
          "opened-at",
          "case-family-key",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-continuous-risk-monitoring-list-supplier-risk-case",
        "identityFieldId": "supplier-risk-case-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "supplier-risk-case-id"
          }
        ],
        "ownerId": "continuous-risk-monitoring",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-risk-case-id",
          "supplier-id",
          "signal-ids",
          "case-family-key",
          "severity",
          "proposed-action",
          "opened-at",
          "governance-exception-id",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-remediation-exit"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-remediation-action",
        "filterContract": [
          {
            "fieldId": "supplier-remediation-action-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "supplier-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "due-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "origin-reference",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "supplier-remediation-action-id",
          "supplier-id",
          "lifecycle-state",
          "due-at",
          "origin-reference",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-remediation-exit-list-supplier-remediation-action",
        "identityFieldId": "supplier-remediation-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "supplier-remediation-action-id"
          }
        ],
        "ownerId": "supplier-remediation-exit",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-remediation-action-id",
          "supplier-id",
          "origin-reference",
          "required-outcome",
          "evidence-requirements",
          "owner-reference",
          "due-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-remediation-exit"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-offboarding-case",
        "filterContract": [
          {
            "fieldId": "supplier-offboarding-case-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "supplier-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "target-completion-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "exit-reason-code",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "supplier-offboarding-case-id",
          "supplier-id",
          "lifecycle-state",
          "target-completion-at",
          "exit-reason-code",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-remediation-exit-list-supplier-offboarding-case",
        "identityFieldId": "supplier-offboarding-case-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "supplier-offboarding-case-id"
          }
        ],
        "ownerId": "supplier-remediation-exit",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-offboarding-case-id",
          "supplier-id",
          "exit-reason-code",
          "dependency-state",
          "target-completion-at",
          "completed-at",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "continuous-risk-monitoring"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-tier-link",
        "filterContract": [
          {
            "fieldId": "supplier-tier-link-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "from-supplier-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "to-supplier-id",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "dependency-type",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "valid-to",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "supplier-tier-link-id",
          "from-supplier-id",
          "to-supplier-id",
          "dependency-type",
          "lifecycle-state",
          "valid-to",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-continuous-risk-monitoring-list-supplier-tier-link",
        "identityFieldId": "supplier-tier-link-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "supplier-tier-link-id"
          }
        ],
        "ownerId": "continuous-risk-monitoring",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-tier-link-id",
          "from-supplier-id",
          "to-supplier-id",
          "external-node",
          "dependency-type",
          "evidence-reference",
          "confidence",
          "valid-to",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "guided-buying"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "buying-request",
        "filterContract": [
          {
            "fieldId": "buying-request-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "requester-reference",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "business-unit-code",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "needed-by-date",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "selected-route",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "buying-request-id",
          "requester-reference",
          "lifecycle-state",
          "business-unit-code",
          "needed-by-date",
          "selected-route",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-guided-buying-list-buying-request",
        "identityFieldId": "buying-request-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "buying-request-id"
          }
        ],
        "ownerId": "guided-buying",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "buying-request-id",
          "requester-reference",
          "business-unit-code",
          "need-description",
          "classification-code",
          "estimated-value",
          "needed-by-date",
          "option-set",
          "selected-route",
          "category-id",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "requisition-policy-routing"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "requisition",
        "filterContract": [
          {
            "fieldId": "requisition-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "requisition-number",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "requester-reference",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "business-unit-code",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "source-buying-request-id",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "requisition-id",
          "requisition-number",
          "requester-reference",
          "lifecycle-state",
          "business-unit-code",
          "source-buying-request-id",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-requisition-policy-routing-list-requisition",
        "identityFieldId": "requisition-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "requisition-id"
          }
        ],
        "ownerId": "requisition-policy-routing",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "requisition-id",
          "requisition-number",
          "source-buying-request-id",
          "requester-reference",
          "business-unit-code",
          "total-amount",
          "policy-evaluation",
          "budget-reservation",
          "budget-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "requisition-policy-routing"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "requisition-line",
        "filterContract": [
          {
            "fieldId": "requisition-line-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "requisition-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "line-number",
            "operators": [
              "equals",
              "less-than",
              "less-than-or-equal",
              "greater-than",
              "greater-than-or-equal",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "supplier-id",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "catalogue-line-id",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "requisition-line-id",
          "requisition-id",
          "line-number",
          "supplier-id",
          "lifecycle-state",
          "catalogue-line-id",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-requisition-policy-routing-list-requisition-line",
        "identityFieldId": "requisition-line-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "requisition-line-id"
          }
        ],
        "ownerId": "requisition-policy-routing",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "requisition-line-id",
          "requisition-id",
          "line-number",
          "catalogue-line-id",
          "supplier-id",
          "description",
          "quantity",
          "unit-price",
          "accounting-splits",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "purchase-order-orchestration"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "purchase-order",
        "filterContract": [
          {
            "fieldId": "purchase-order-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "purchase-order-number",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "supplier-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "requisition-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "idempotency-key",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "purchase-order-id",
          "purchase-order-number",
          "supplier-id",
          "lifecycle-state",
          "requisition-id",
          "idempotency-key",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-purchase-order-orchestration-list-purchase-order",
        "identityFieldId": "purchase-order-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "purchase-order-id"
          }
        ],
        "ownerId": "purchase-order-orchestration",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "purchase-order-id",
          "purchase-order-number",
          "order-version",
          "requisition-id",
          "supplier-id",
          "contract-id",
          "total-amount",
          "idempotency-key",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "purchase-order-orchestration"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "order-line",
        "filterContract": [
          {
            "fieldId": "order-line-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "purchase-order-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "line-number",
            "operators": [
              "equals",
              "less-than",
              "less-than-or-equal",
              "greater-than",
              "greater-than-or-equal",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "requisition-line-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "order-line-id",
          "purchase-order-id",
          "line-number",
          "requisition-line-id",
          "lifecycle-state",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-purchase-order-orchestration-list-order-line",
        "identityFieldId": "order-line-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "order-line-id"
          }
        ],
        "ownerId": "purchase-order-orchestration",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "order-line-id",
          "purchase-order-id",
          "requisition-line-id",
          "line-number",
          "item-identifiers",
          "description",
          "ordered-quantity",
          "unit-price",
          "delivery-requirement",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "purchase-order-exception"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "purchase-order-exception",
        "filterContract": [
          {
            "fieldId": "purchase-order-exception-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "purchase-order-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "exception-type",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "severity",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "deduplication-key",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "purchase-order-exception-id",
          "purchase-order-id",
          "lifecycle-state",
          "exception-type",
          "severity",
          "deduplication-key",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-purchase-order-exception-list-purchase-order-exception",
        "identityFieldId": "purchase-order-exception-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "purchase-order-exception-id"
          }
        ],
        "ownerId": "purchase-order-exception",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "purchase-order-exception-id",
          "purchase-order-id",
          "order-line-id",
          "exception-type",
          "deduplication-key",
          "severity",
          "proposed-resolution",
          "governance-exception-id",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "purchase-order-orchestration"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "order-response",
        "filterContract": [
          {
            "fieldId": "order-response-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "purchase-order-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "received-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "supplier-response-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "response-code",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "order-response-id",
          "purchase-order-id",
          "received-at",
          "supplier-response-id",
          "response-code",
          "lifecycle-state",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-purchase-order-orchestration-list-order-response",
        "identityFieldId": "order-response-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "order-response-id"
          }
        ],
        "ownerId": "purchase-order-orchestration",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "order-response-id",
          "purchase-order-id",
          "supplier-response-id",
          "response-code",
          "proposed-changes",
          "artifact-id",
          "received-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "receiving-service-entry"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "shipment",
        "filterContract": [
          {
            "fieldId": "shipment-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "shipment-reference",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "purchase-order-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "expected-delivery-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "shipment-id",
          "shipment-reference",
          "purchase-order-id",
          "lifecycle-state",
          "expected-delivery-at",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-receiving-service-entry-list-shipment",
        "identityFieldId": "shipment-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "shipment-id"
          }
        ],
        "ownerId": "receiving-service-entry",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "shipment-id",
          "shipment-reference",
          "purchase-order-id",
          "despatch-lines",
          "package-identifiers",
          "expected-delivery-at",
          "observed-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "receiving-service-entry"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "receipt",
        "filterContract": [
          {
            "fieldId": "receipt-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "receipt-number",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "purchase-order-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "received-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "idempotency-key",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "receipt-id",
          "receipt-number",
          "purchase-order-id",
          "received-at",
          "lifecycle-state",
          "idempotency-key",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-receiving-service-entry-list-receipt",
        "identityFieldId": "receipt-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "receipt-id"
          }
        ],
        "ownerId": "receiving-service-entry",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "receipt-id",
          "receipt-number",
          "purchase-order-id",
          "shipment-id",
          "receiving-location",
          "proof-artifact-ids",
          "idempotency-key",
          "received-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "receiving-service-entry"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "receipt-line",
        "filterContract": [
          {
            "fieldId": "receipt-line-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "receipt-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "line-number",
            "operators": [
              "equals",
              "less-than",
              "less-than-or-equal",
              "greater-than",
              "greater-than-or-equal",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "order-line-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "receipt-line-id",
          "receipt-id",
          "line-number",
          "order-line-id",
          "lifecycle-state",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-receiving-service-entry-list-receipt-line",
        "identityFieldId": "receipt-line-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "receipt-line-id"
          }
        ],
        "ownerId": "receiving-service-entry",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "receipt-line-id",
          "receipt-id",
          "order-line-id",
          "line-number",
          "received-quantity",
          "rejected-quantity",
          "variance-reason-code",
          "item-trace",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "receiving-service-entry"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "service-entry-sheet",
        "filterContract": [
          {
            "fieldId": "service-entry-sheet-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "service-entry-number",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "purchase-order-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "service-period-end",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "idempotency-key",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "service-entry-sheet-id",
          "service-entry-number",
          "purchase-order-id",
          "lifecycle-state",
          "service-period-end",
          "idempotency-key",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-receiving-service-entry-list-service-entry-sheet",
        "identityFieldId": "service-entry-sheet-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "service-entry-sheet-id"
          }
        ],
        "ownerId": "receiving-service-entry",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "service-entry-sheet-id",
          "service-entry-number",
          "purchase-order-id",
          "order-line-ids",
          "service-period-start",
          "service-period-end",
          "delivery-claim",
          "evidence-ids",
          "idempotency-key",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "receiving-service-entry"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "return-claim",
        "filterContract": [
          {
            "fieldId": "return-claim-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "purchase-order-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "return-reference",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "recovery-due-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "return-claim-id",
          "purchase-order-id",
          "lifecycle-state",
          "return-reference",
          "recovery-due-at",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-receiving-service-entry-list-return-claim",
        "identityFieldId": "return-claim-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "return-claim-id"
          }
        ],
        "ownerId": "receiving-service-entry",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "return-claim-id",
          "return-reference",
          "purchase-order-id",
          "receipt-line-ids",
          "claim-reason-code",
          "evidence-ids",
          "expected-recovery",
          "recovery-due-at",
          "governance-authority-envelope-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-intake-match"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "invoice",
        "filterContract": [
          {
            "fieldId": "invoice-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "business-key",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "invoice-number",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "supplier-party-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "due-date",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "order-ids",
            "operators": [
              "contains-any",
              "contains-all",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "invoice-id",
          "business-key",
          "invoice-number",
          "supplier-party-id",
          "due-date",
          "lifecycle-state",
          "order-ids",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-intake-match-list-invoice",
        "identityFieldId": "invoice-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "invoice-id"
          }
        ],
        "ownerId": "invoice-intake-match",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "invoice-id",
          "invoice-number",
          "invoice-type-code",
          "supplier-party-id",
          "customer-party-id",
          "issue-date",
          "due-date",
          "order-ids",
          "contract-ids",
          "receipt-ids",
          "document-currency-code",
          "tax-total",
          "allowance-charge-total",
          "legal-monetary-total",
          "payment-means",
          "payment-terms",
          "source-artifact-id",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-intake-match"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "invoice-line",
        "filterContract": [
          {
            "fieldId": "invoice-line-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "invoice-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "line-number",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "order-line-reference",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "item-reference",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "invoice-line-id",
          "invoice-id",
          "line-number",
          "order-line-reference",
          "item-reference",
          "freshness-status",
          "lifecycle-state",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-intake-match-list-invoice-line",
        "identityFieldId": "invoice-line-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "invoice-line-id"
          }
        ],
        "ownerId": "invoice-intake-match",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "invoice-line-id",
          "invoice-id",
          "line-number",
          "item-reference",
          "description",
          "quantity",
          "price",
          "line-extension-amount",
          "tax-category",
          "order-line-reference",
          "receipt-line-ids",
          "source-anchor",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-intake-match"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "invoice-match-assessment",
        "filterContract": [
          {
            "fieldId": "invoice-match-assessment-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "business-key",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "invoice-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "assessed-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "result",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "exception-reason-codes",
            "operators": [
              "contains-any",
              "contains-all",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "invoice-match-assessment-id",
          "business-key",
          "invoice-id",
          "assessed-at",
          "result",
          "exception-reason-codes",
          "lifecycle-state",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-intake-match-list-invoice-match-assessment",
        "identityFieldId": "invoice-match-assessment-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "invoice-match-assessment-id"
          }
        ],
        "ownerId": "invoice-intake-match",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "invoice-match-assessment-id",
          "invoice-id",
          "match-basis",
          "comparison-set",
          "tolerances",
          "result",
          "exception-reason-codes",
          "confidence-band",
          "proposal-status",
          "assessed-at",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "purchase-order-id",
          "order-line-ids",
          "receipt-ids",
          "receipt-line-ids",
          "service-entry-sheet-ids",
          "governance-decision-id",
          "governance-authority-envelope-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-exception-triage"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "invoice-exception",
        "filterContract": [
          {
            "fieldId": "invoice-exception-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "business-key",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "invoice-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "owner-reference",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "exception-type",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "materiality-band",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "due-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "invoice-exception-id",
          "business-key",
          "invoice-id",
          "lifecycle-state",
          "owner-reference",
          "exception-type",
          "materiality-band",
          "due-at",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-exception-triage-list-invoice-exception",
        "identityFieldId": "invoice-exception-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "invoice-exception-id"
          }
        ],
        "ownerId": "invoice-exception-triage",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "invoice-exception-id",
          "invoice-id",
          "match-assessment-id",
          "exception-type",
          "materiality-band",
          "owner-reference",
          "due-at",
          "proposed-resolution",
          "proposal-status",
          "committed-disposition",
          "authority-envelope-id",
          "opened-at",
          "updated-at",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "governance-exception-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-invoice-resolution"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-invoice-resolution",
        "filterContract": [
          {
            "fieldId": "supplier-invoice-resolution-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "business-key",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "invoice-exception-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "supplier-party-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "next-action-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "supplier-invoice-resolution-id",
          "business-key",
          "invoice-exception-id",
          "supplier-party-id",
          "lifecycle-state",
          "next-action-at",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-invoice-resolution-list-supplier-invoice-resolution",
        "identityFieldId": "supplier-invoice-resolution-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "supplier-invoice-resolution-id"
          }
        ],
        "ownerId": "supplier-invoice-resolution",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-invoice-resolution-id",
          "invoice-exception-id",
          "invoice-id",
          "supplier-party-id",
          "resolution-type",
          "channel",
          "proposed-action",
          "proposal-status",
          "committed-action",
          "authority-envelope-id",
          "application-response-id",
          "credit-note-id",
          "corrected-invoice-id",
          "opened-at",
          "next-action-at",
          "communicated-at",
          "confirmed-at",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "payment-readiness"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "payment-readiness-assessment",
        "filterContract": [
          {
            "fieldId": "payment-readiness-assessment-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "business-key",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "invoice-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "due-date",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "committed-readiness",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "payment-readiness-assessment-id",
          "business-key",
          "invoice-id",
          "lifecycle-state",
          "due-date",
          "committed-readiness",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-payment-readiness-list-payment-readiness-assessment",
        "identityFieldId": "payment-readiness-assessment-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "payment-readiness-assessment-id"
          }
        ],
        "ownerId": "payment-readiness",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "payment-readiness-assessment-id",
          "invoice-id",
          "resolution-ids",
          "check-results",
          "payable-amount",
          "due-date",
          "risk-flags",
          "proposed-readiness",
          "committed-readiness",
          "hold-reason-codes",
          "authority-envelope-id",
          "assessed-at",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "payment-execution-guard"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "payment-instruction",
        "filterContract": [
          {
            "fieldId": "payment-instruction-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "business-key",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "readiness-ids",
            "operators": [
              "contains-any",
              "contains-all"
            ],
            "required": false
          },
          {
            "fieldId": "invoice-ids",
            "operators": [
              "contains-any",
              "contains-all"
            ],
            "required": false
          },
          {
            "fieldId": "committed-status",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "requested-execution-date",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "payment-instruction-id",
          "business-key",
          "readiness-ids",
          "invoice-ids",
          "committed-status",
          "requested-execution-date",
          "lifecycle-state",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-payment-execution-guard-list-payment-instruction",
        "identityFieldId": "payment-instruction-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "payment-instruction-id"
          }
        ],
        "ownerId": "payment-execution-guard",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "payment-instruction-id",
          "readiness-ids",
          "invoice-ids",
          "debtor-account-token",
          "creditor-account-token",
          "instructed-amount",
          "requested-execution-date",
          "payment-method-code",
          "remittance-information",
          "proposal-status",
          "committed-status",
          "authority-envelope-id",
          "instruction-message-id",
          "created-at",
          "committed-at",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "payment-execution-guard"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "payment-execution-status",
        "filterContract": [
          {
            "fieldId": "payment-execution-status-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "business-key",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "payment-instruction-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "observed-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "execution-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "statement-id",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "payment-execution-status-id",
          "business-key",
          "payment-instruction-id",
          "observed-at",
          "execution-status",
          "statement-id",
          "lifecycle-state",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-payment-execution-guard-list-payment-execution-status",
        "identityFieldId": "payment-execution-status-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "payment-execution-status-id"
          }
        ],
        "ownerId": "payment-execution-guard",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "payment-execution-status-id",
          "payment-instruction-id",
          "message-type",
          "message-version",
          "downstream-status-code",
          "acceptance-reason-code",
          "execution-status",
          "observed-at",
          "settlement-date",
          "statement-id",
          "remittance-advice-id",
          "error-detail",
          "source-system",
          "source-schema-version",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-segmentation-governance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-segment-assignment",
        "filterContract": [
          {
            "fieldId": "supplier-segment-assignment-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "business-key",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "supplier-party-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "committed-segment-code",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "committed-criticality-band",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "valid-from",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "valid-to",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "supplier-segment-assignment-id",
          "business-key",
          "supplier-party-id",
          "lifecycle-state",
          "committed-segment-code",
          "committed-criticality-band",
          "valid-from",
          "valid-to",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-segmentation-governance-list-supplier-segment-assignment",
        "identityFieldId": "supplier-segment-assignment-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "supplier-segment-assignment-id"
          }
        ],
        "ownerId": "supplier-segmentation-governance",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-segment-assignment-id",
          "supplier-party-id",
          "category-ids",
          "segmentation-model-version",
          "input-snapshot-ids",
          "proposed-segment-code",
          "proposed-criticality-band",
          "proposal-status",
          "committed-segment-code",
          "committed-criticality-band",
          "relationship-posture",
          "authority-envelope-id",
          "valid-from",
          "valid-to",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-monitor-correct"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-performance-observation",
        "filterContract": [
          {
            "fieldId": "supplier-performance-observation-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "business-key",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "supplier-party-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "measure-code",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "performance-period-end",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "breach-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "quality-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "supplier-performance-observation-id",
          "business-key",
          "supplier-party-id",
          "measure-code",
          "performance-period-end",
          "breach-status",
          "quality-status",
          "freshness-status",
          "lifecycle-state",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-monitor-correct-list-supplier-performance-observation",
        "identityFieldId": "supplier-performance-observation-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "supplier-performance-observation-id"
          }
        ],
        "ownerId": "supplier-performance-monitor-correct",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-performance-observation-id",
          "supplier-party-id",
          "category-id",
          "contract-id",
          "service-id",
          "measure-code",
          "measure-definition-version",
          "performance-period-start",
          "performance-period-end",
          "target-value",
          "observed-value",
          "unit-code",
          "quality-status",
          "breach-status",
          "correction-status",
          "source-record-ids",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-performance-review-record",
        "filterContract": [
          {
            "fieldId": "supplier-performance-review-record-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "business-key",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "supplier-party-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "review-period-end",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "next-review-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "supplier-performance-review-record-id",
          "business-key",
          "supplier-party-id",
          "review-period-end",
          "lifecycle-state",
          "next-review-at",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-review-list-supplier-performance-review-record",
        "identityFieldId": "supplier-performance-review-record-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "supplier-performance-review-record-id"
          }
        ],
        "ownerId": "supplier-performance-review",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-performance-review-record-id",
          "supplier-party-id",
          "review-period-start",
          "review-period-end",
          "segment-assignment-id",
          "observation-ids",
          "scorecard-definition-version",
          "aggregate-scores",
          "trend-summary",
          "proposed-narrative",
          "proposed-actions",
          "proposal-status",
          "committed-decisions",
          "authority-envelope-id",
          "corrective-action-plan",
          "reviewed-at",
          "next-review-at",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "governance-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-innovation-pipeline"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-innovation-case",
        "filterContract": [
          {
            "fieldId": "supplier-innovation-case-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "business-key",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "supplier-party-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "owner-reference",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "next-gate-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "category-ids",
            "operators": [
              "contains-any",
              "contains-all",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "supplier-innovation-case-id",
          "business-key",
          "supplier-party-id",
          "lifecycle-state",
          "owner-reference",
          "next-gate-at",
          "category-ids",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-innovation-pipeline-list-supplier-innovation-case",
        "identityFieldId": "supplier-innovation-case-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "supplier-innovation-case-id"
          }
        ],
        "ownerId": "supplier-innovation-pipeline",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-innovation-case-id",
          "supplier-party-id",
          "title",
          "need-or-opportunity",
          "sponsor-reference",
          "owner-reference",
          "category-ids",
          "contract-ids",
          "value-hypothesis",
          "risk-hypothesis",
          "proposed-next-action",
          "proposal-status",
          "committed-gate-decision",
          "authority-envelope-id",
          "experiment-plan",
          "experiment-outcome",
          "opened-at",
          "next-gate-at",
          "closed-at",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-relationship-joint-value"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-joint-value-plan",
        "filterContract": [
          {
            "fieldId": "supplier-joint-value-plan-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "business-key",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "supplier-party-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "segment-assignment-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-from",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "effective-to",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "supplier-joint-value-plan-id",
          "business-key",
          "supplier-party-id",
          "lifecycle-state",
          "segment-assignment-id",
          "effective-from",
          "effective-to",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-relationship-joint-value-list-supplier-joint-value-plan",
        "identityFieldId": "supplier-joint-value-plan-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "supplier-joint-value-plan-id"
          }
        ],
        "ownerId": "supplier-relationship-joint-value",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-joint-value-plan-id",
          "supplier-party-id",
          "segment-assignment-id",
          "objectives",
          "mutual-commitments",
          "milestones",
          "governance-cadence",
          "shared-risk-and-benefit",
          "proposed-plan",
          "proposal-status",
          "committed-plan-version",
          "authority-envelope-id",
          "progress-summary",
          "linked-innovation-ids",
          "validated-value-ids",
          "effective-from",
          "effective-to",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "value-opportunity-baseline"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "value-opportunity-baseline",
        "filterContract": [
          {
            "fieldId": "value-opportunity-baseline-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "business-key",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "opportunity-reference",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "owner-reference",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "category-ids",
            "operators": [
              "contains-any",
              "contains-all",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "supplier-party-ids",
            "operators": [
              "contains-any",
              "contains-all",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "value-opportunity-baseline-id",
          "business-key",
          "opportunity-reference",
          "owner-reference",
          "lifecycle-state",
          "category-ids",
          "supplier-party-ids",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-value-opportunity-baseline-list-value-opportunity-baseline",
        "identityFieldId": "value-opportunity-baseline-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "value-opportunity-baseline-id"
          }
        ],
        "ownerId": "value-opportunity-baseline",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "value-opportunity-baseline-id",
          "opportunity-reference",
          "opportunity-type",
          "title",
          "owner-reference",
          "category-ids",
          "supplier-party-ids",
          "contract-ids",
          "source-record-ids",
          "baseline-period-start",
          "baseline-period-end",
          "comparison-period-start",
          "comparison-period-end",
          "baseline-method-version",
          "baseline-amount",
          "target-amount",
          "forecast-amount",
          "currency-code",
          "assumptions",
          "proposed-validation",
          "proposal-status",
          "committed-validation",
          "authority-envelope-id",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "governance-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "savings-initiative"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "savings-initiative-record",
        "filterContract": [
          {
            "fieldId": "savings-initiative-record-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "business-key",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "value-opportunity-baseline-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "owner-reference",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "target-completion-date",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "savings-initiative-record-id",
          "business-key",
          "value-opportunity-baseline-id",
          "owner-reference",
          "lifecycle-state",
          "target-completion-date",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-savings-initiative-list-savings-initiative-record",
        "identityFieldId": "savings-initiative-record-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "savings-initiative-record-id"
          }
        ],
        "ownerId": "savings-initiative",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "savings-initiative-record-id",
          "value-opportunity-baseline-id",
          "title",
          "owner-reference",
          "sponsor-reference",
          "value-type",
          "value-recognition-treatment",
          "target-value",
          "forecast-value",
          "validated-realization",
          "leakage-value",
          "currency-code",
          "measurement-method-version",
          "milestone-plan",
          "dependency-ids",
          "proposed-plan-change",
          "proposal-status",
          "committed-plan-version",
          "authority-envelope-id",
          "start-date",
          "target-completion-date",
          "closed-at",
          "attention-status",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "realization-reconciliation-attribution"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "value-realization-attribution",
        "filterContract": [
          {
            "fieldId": "value-realization-attribution-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "business-key",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "savings-initiative-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "attribution-period-end",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "reconciliation-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "value-realization-attribution-id",
          "business-key",
          "savings-initiative-id",
          "attribution-period-end",
          "reconciliation-status",
          "freshness-status",
          "lifecycle-state",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-realization-reconciliation-attribution-list-value-realization-attribution",
        "identityFieldId": "value-realization-attribution-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "value-realization-attribution-id"
          }
        ],
        "ownerId": "realization-reconciliation-attribution",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "value-realization-attribution-id",
          "savings-initiative-id",
          "value-opportunity-baseline-id",
          "attribution-period-start",
          "attribution-period-end",
          "actual-source-record-ids",
          "actual-amount",
          "gross-variance",
          "adjustments",
          "attributed-amount",
          "currency-code",
          "attribution-method-version",
          "double-count-check",
          "confidence-band",
          "proposed-disposition",
          "proposal-status",
          "committed-disposition",
          "authority-envelope-id",
          "reconciliation-status",
          "calculated-at",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "governance-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "value-leakage-monitor"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "value-leakage-finding",
        "filterContract": [
          {
            "fieldId": "value-leakage-finding-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "business-key",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "savings-initiative-id",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "leakage-type",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "materiality-band",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "owner-reference",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "due-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "value-leakage-finding-id",
          "business-key",
          "savings-initiative-id",
          "lifecycle-state",
          "leakage-type",
          "materiality-band",
          "owner-reference",
          "due-at",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-value-leakage-monitor-list-value-leakage-finding",
        "identityFieldId": "value-leakage-finding-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "value-leakage-finding-id"
          }
        ],
        "ownerId": "value-leakage-monitor",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "value-leakage-finding-id",
          "savings-initiative-id",
          "leakage-type",
          "supplier-party-id",
          "category-id",
          "contract-id",
          "source-record-ids",
          "expected-value",
          "actual-value",
          "dispersion-evidence",
          "exposure-amount",
          "currency-code",
          "materiality-band",
          "root-cause",
          "proposed-remediation",
          "proposal-status",
          "committed-remediation",
          "authority-envelope-id",
          "owner-reference",
          "detected-at",
          "due-at",
          "closed-at",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "value-portfolio-forecast"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "value-portfolio-forecast",
        "filterContract": [
          {
            "fieldId": "value-portfolio-forecast-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "business-key",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "as-of-date",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "scenario-code",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "forecast-horizon-end",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "value-portfolio-forecast-id",
          "business-key",
          "as-of-date",
          "scenario-code",
          "forecast-horizon-end",
          "lifecycle-state",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-value-portfolio-forecast-list-value-portfolio-forecast",
        "identityFieldId": "value-portfolio-forecast-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "value-portfolio-forecast-id"
          }
        ],
        "ownerId": "value-portfolio-forecast",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "value-portfolio-forecast-id",
          "as-of-date",
          "scenario-code",
          "benchmark-tier-code",
          "forecast-horizon-start",
          "forecast-horizon-end",
          "initiative-ids",
          "baseline-ids",
          "forecast-method-version",
          "forecast-amount",
          "currency-code",
          "confidence-interval",
          "risk-adjustment",
          "realization-schedule",
          "assumptions",
          "source-snapshot-ids",
          "proposed-portfolio-action",
          "proposal-status",
          "committed-portfolio-decision",
          "authority-envelope-id",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "policy-rule-lifecycle"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy-change-impact",
        "filterContract": [
          {
            "fieldId": "policy-change-impact-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "policy-change-impact-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-rule-lifecycle-read-policy-change-impact",
        "identityFieldId": "policy-change-impact-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "policy-rule-lifecycle",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-change-impact-id",
          "policy-rule-release-id",
          "prior-policy-rule-release-id",
          "impact-snapshot-at",
          "impact-snapshot-evidence-item-id",
          "impact-evidence-item-ids",
          "affected-owner-ids",
          "affected-owner-count",
          "affected-record-count",
          "affected-items",
          "authority-envelope-id",
          "expires-at",
          "reopened-from-policy-change-impact-id",
          "completed-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "policy-rule-lifecycle"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy-change-impact",
        "filterContract": [
          {
            "fieldId": "policy-change-impact-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "policy-rule-release-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "affected-owner-ids",
            "operators": [
              "contains-any",
              "contains-all"
            ],
            "required": false
          },
          {
            "fieldId": "expires-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "policy-change-impact-id",
          "policy-rule-release-id",
          "lifecycle-state",
          "affected-owner-ids",
          "expires-at",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-rule-lifecycle-list-policy-change-impact",
        "identityFieldId": "policy-change-impact-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "policy-change-impact-id"
          }
        ],
        "ownerId": "policy-rule-lifecycle",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-change-impact-id",
          "policy-rule-release-id",
          "prior-policy-rule-release-id",
          "impact-snapshot-at",
          "impact-snapshot-evidence-item-id",
          "impact-evidence-item-ids",
          "affected-owner-ids",
          "affected-owner-count",
          "affected-record-count",
          "affected-items",
          "authority-envelope-id",
          "expires-at",
          "reopened-from-policy-change-impact-id",
          "completed-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-pipeline-discovery"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "buy-timing-mandate",
        "filterContract": [
          {
            "fieldId": "buy-timing-mandate-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "buy-timing-mandate-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-pipeline-discovery-read-buy-timing-mandate",
        "identityFieldId": "buy-timing-mandate-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "sourcing-pipeline-discovery",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "buy-timing-mandate-id",
          "sourcing-opportunity-id",
          "revision-number",
          "volume-band",
          "buy-window-start-date",
          "buy-window-end-date",
          "price-ceiling",
          "source-period-start",
          "source-period-end",
          "evidence-as-of",
          "evidence-item-ids",
          "expires-at",
          "authority-envelope-id",
          "authority-decision-id",
          "decided-at",
          "supersedes-buy-timing-mandate-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-pipeline-discovery"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "buy-timing-mandate",
        "filterContract": [
          {
            "fieldId": "buy-timing-mandate-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "sourcing-opportunity-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "revision-number",
            "operators": [
              "equals",
              "less-than",
              "less-than-or-equal",
              "greater-than",
              "greater-than-or-equal",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "expires-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "authority-decision-id",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "buy-timing-mandate-id",
          "sourcing-opportunity-id",
          "revision-number",
          "lifecycle-state",
          "expires-at",
          "authority-decision-id",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-pipeline-discovery-list-buy-timing-mandate",
        "identityFieldId": "buy-timing-mandate-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "buy-timing-mandate-id"
          }
        ],
        "ownerId": "sourcing-pipeline-discovery",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "buy-timing-mandate-id",
          "sourcing-opportunity-id",
          "revision-number",
          "volume-band",
          "buy-window-start-date",
          "buy-window-end-date",
          "price-ceiling",
          "source-period-start",
          "source-period-end",
          "evidence-as-of",
          "evidence-item-ids",
          "expires-at",
          "authority-envelope-id",
          "authority-decision-id",
          "decided-at",
          "supersedes-buy-timing-mandate-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-monitor-correct"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-performance-signal",
        "filterContract": [
          {
            "fieldId": "supplier-performance-signal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-performance-signal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-monitor-correct-read-supplier-performance-signal",
        "identityFieldId": "supplier-performance-signal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-performance-monitor-correct",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-performance-signal-id",
          "supplier-party-id",
          "observation-ids",
          "observation-set-version",
          "signal-type",
          "measure-code",
          "performance-period-start",
          "performance-period-end",
          "materiality",
          "detected-at",
          "evidence-as-of",
          "evidence-item-ids",
          "policy-version-id",
          "authority-envelope-id",
          "duplicate-of-supplier-performance-signal-id",
          "dispute-decision-id",
          "routing-action-proposal-id",
          "supplier-remediation-action-id",
          "recovery-observation-ids",
          "recovery-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-monitor-correct"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-performance-signal",
        "filterContract": [
          {
            "fieldId": "supplier-performance-signal-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "supplier-party-id",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "observation-set-version",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "duplicate-of-supplier-performance-signal-id",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "routing-action-proposal-id",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "supplier-remediation-action-id",
            "operators": [
              "equals",
              "one-of",
              "is-null",
              "is-not-null"
            ],
            "required": false
          },
          {
            "fieldId": "freshness-status",
            "operators": [
              "equals",
              "one-of"
            ],
            "required": false
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between"
            ],
            "required": false
          },
          {
            "fieldId": "last-good-at",
            "operators": [
              "equals",
              "before",
              "on-or-before",
              "after",
              "on-or-after",
              "between",
              "is-null",
              "is-not-null"
            ],
            "required": false
          }
        ],
        "filterFieldIds": [
          "supplier-performance-signal-id",
          "supplier-party-id",
          "lifecycle-state",
          "observation-set-version",
          "duplicate-of-supplier-performance-signal-id",
          "routing-action-proposal-id",
          "supplier-remediation-action-id",
          "freshness-status",
          "effective-at",
          "last-good-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-monitor-correct-list-supplier-performance-signal",
        "identityFieldId": "supplier-performance-signal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "supplier-performance-signal-id"
          }
        ],
        "ownerId": "supplier-performance-monitor-correct",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "collection",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-performance-signal-id",
          "supplier-party-id",
          "observation-ids",
          "observation-set-version",
          "signal-type",
          "measure-code",
          "performance-period-start",
          "performance-period-end",
          "materiality",
          "detected-at",
          "evidence-as-of",
          "evidence-item-ids",
          "policy-version-id",
          "authority-envelope-id",
          "duplicate-of-supplier-performance-signal-id",
          "dispute-decision-id",
          "routing-action-proposal-id",
          "supplier-remediation-action-id",
          "recovery-observation-ids",
          "recovery-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "policy-guidance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy-change-impact",
        "filterContract": [
          {
            "fieldId": "policy-change-impact-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "policy-change-impact-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-guidance-read-policy-change-impact",
        "identityFieldId": "policy-change-impact-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "policy-rule-lifecycle",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-change-impact-id",
          "policy-rule-release-id",
          "prior-policy-rule-release-id",
          "impact-snapshot-at",
          "impact-snapshot-evidence-item-id",
          "impact-evidence-item-ids",
          "affected-owner-ids",
          "affected-owner-count",
          "affected-record-count",
          "affected-items",
          "authority-envelope-id",
          "expires-at",
          "reopened-from-policy-change-impact-id",
          "completed-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "procurement-service-catalogue"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy-change-impact",
        "filterContract": [
          {
            "fieldId": "policy-change-impact-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "policy-change-impact-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-procurement-service-catalogue-read-policy-change-impact",
        "identityFieldId": "policy-change-impact-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "policy-rule-lifecycle",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-change-impact-id",
          "policy-rule-release-id",
          "prior-policy-rule-release-id",
          "impact-snapshot-at",
          "impact-snapshot-evidence-item-id",
          "impact-evidence-item-ids",
          "affected-owner-ids",
          "affected-owner-count",
          "affected-record-count",
          "affected-items",
          "authority-envelope-id",
          "expires-at",
          "reopened-from-policy-change-impact-id",
          "completed-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "intelligent-intake"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy-change-impact",
        "filterContract": [
          {
            "fieldId": "policy-change-impact-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "policy-change-impact-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-intelligent-intake-read-policy-change-impact",
        "identityFieldId": "policy-change-impact-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "policy-rule-lifecycle",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-change-impact-id",
          "policy-rule-release-id",
          "prior-policy-rule-release-id",
          "impact-snapshot-at",
          "impact-snapshot-evidence-item-id",
          "impact-evidence-item-ids",
          "affected-owner-ids",
          "affected-owner-count",
          "affected-record-count",
          "affected-items",
          "authority-envelope-id",
          "expires-at",
          "reopened-from-policy-change-impact-id",
          "completed-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "requisition-policy-routing"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy-change-impact",
        "filterContract": [
          {
            "fieldId": "policy-change-impact-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "policy-change-impact-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-requisition-policy-routing-read-policy-change-impact",
        "identityFieldId": "policy-change-impact-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "policy-rule-lifecycle",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-change-impact-id",
          "policy-rule-release-id",
          "prior-policy-rule-release-id",
          "impact-snapshot-at",
          "impact-snapshot-evidence-item-id",
          "impact-evidence-item-ids",
          "affected-owner-ids",
          "affected-owner-count",
          "affected-record-count",
          "affected-items",
          "authority-envelope-id",
          "expires-at",
          "reopened-from-policy-change-impact-id",
          "completed-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-event"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "buy-timing-mandate",
        "filterContract": [
          {
            "fieldId": "buy-timing-mandate-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "buy-timing-mandate-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-event-read-buy-timing-mandate",
        "identityFieldId": "buy-timing-mandate-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "sourcing-pipeline-discovery",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "buy-timing-mandate-id",
          "sourcing-opportunity-id",
          "revision-number",
          "volume-band",
          "buy-window-start-date",
          "buy-window-end-date",
          "price-ceiling",
          "source-period-start",
          "source-period-end",
          "evidence-as-of",
          "evidence-item-ids",
          "expires-at",
          "authority-envelope-id",
          "authority-decision-id",
          "decided-at",
          "supersedes-buy-timing-mandate-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "negotiation-copilot"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "buy-timing-mandate",
        "filterContract": [
          {
            "fieldId": "buy-timing-mandate-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "buy-timing-mandate-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-negotiation-copilot-read-buy-timing-mandate",
        "identityFieldId": "buy-timing-mandate-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "sourcing-pipeline-discovery",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "buy-timing-mandate-id",
          "sourcing-opportunity-id",
          "revision-number",
          "volume-band",
          "buy-window-start-date",
          "buy-window-end-date",
          "price-ceiling",
          "source-period-start",
          "source-period-end",
          "evidence-as-of",
          "evidence-item-ids",
          "expires-at",
          "authority-envelope-id",
          "authority-decision-id",
          "decided-at",
          "supersedes-buy-timing-mandate-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "tactical-sourcing-autonomy"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "buy-timing-mandate",
        "filterContract": [
          {
            "fieldId": "buy-timing-mandate-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "buy-timing-mandate-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-tactical-sourcing-autonomy-read-buy-timing-mandate",
        "identityFieldId": "buy-timing-mandate-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "sourcing-pipeline-discovery",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "buy-timing-mandate-id",
          "sourcing-opportunity-id",
          "revision-number",
          "volume-band",
          "buy-window-start-date",
          "buy-window-end-date",
          "price-ceiling",
          "source-period-start",
          "source-period-end",
          "evidence-as-of",
          "evidence-item-ids",
          "expires-at",
          "authority-envelope-id",
          "authority-decision-id",
          "decided-at",
          "supersedes-buy-timing-mandate-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-performance-signal",
        "filterContract": [
          {
            "fieldId": "supplier-performance-signal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-performance-signal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-review-read-supplier-performance-signal",
        "identityFieldId": "supplier-performance-signal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-performance-monitor-correct",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-performance-signal-id",
          "supplier-party-id",
          "observation-ids",
          "observation-set-version",
          "signal-type",
          "measure-code",
          "performance-period-start",
          "performance-period-end",
          "materiality",
          "detected-at",
          "evidence-as-of",
          "evidence-item-ids",
          "policy-version-id",
          "authority-envelope-id",
          "duplicate-of-supplier-performance-signal-id",
          "dispute-decision-id",
          "routing-action-proposal-id",
          "supplier-remediation-action-id",
          "recovery-observation-ids",
          "recovery-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-remediation-exit"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-performance-signal",
        "filterContract": [
          {
            "fieldId": "supplier-performance-signal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-performance-signal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-remediation-exit-read-supplier-performance-signal",
        "identityFieldId": "supplier-performance-signal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-performance-monitor-correct",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-performance-signal-id",
          "supplier-party-id",
          "observation-ids",
          "observation-set-version",
          "signal-type",
          "measure-code",
          "performance-period-start",
          "performance-period-end",
          "materiality",
          "detected-at",
          "evidence-as-of",
          "evidence-item-ids",
          "policy-version-id",
          "authority-envelope-id",
          "duplicate-of-supplier-performance-signal-id",
          "dispute-decision-id",
          "routing-action-proposal-id",
          "supplier-remediation-action-id",
          "recovery-observation-ids",
          "recovery-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-monitor-correct"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-remediation-action",
        "filterContract": [
          {
            "fieldId": "supplier-remediation-action-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-remediation-action-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-monitor-correct-read-supplier-remediation-action",
        "identityFieldId": "supplier-remediation-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-remediation-exit",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-remediation-action-id",
          "supplier-id",
          "origin-reference",
          "performance-signal-id",
          "required-outcome",
          "evidence-requirements",
          "owner-reference",
          "due-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "category-opportunity-radar"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "action-proposal",
        "filterContract": [
          {
            "fieldId": "action-proposal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "action-proposal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-category-opportunity-radar-read-action-proposal",
        "identityFieldId": "action-proposal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "action-proposal-id",
          "workblock-id",
          "action-class",
          "subject-ref",
          "sending-owner-id",
          "receiving-owner-id",
          "source-record-ref",
          "target-record-ref",
          "requested-outcome",
          "evidence-version",
          "expires-at",
          "handoff-attempt",
          "handoff-idempotency-key",
          "acknowledgement-decision-id",
          "reopened-from-action-proposal-id",
          "successor-action-proposal-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "proposed-payload",
          "created-at",
          "governance-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "category-opportunity-radar"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "decision",
        "filterContract": [
          {
            "fieldId": "decision-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "decision-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-category-opportunity-radar-read-decision",
        "identityFieldId": "decision-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "decision-id",
          "decision-type",
          "subject-ref",
          "outcome",
          "handoff-action-proposal-id",
          "sending-owner-id",
          "receiving-owner-id",
          "acknowledgement-state",
          "acknowledged-at",
          "acknowledgement-reason",
          "redirected-to-owner-id",
          "handoff-attempt",
          "evidence-version",
          "reopened-from-decision-id",
          "successor-decision-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "rationale",
          "decided-at",
          "decided-by-ref",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "category-opportunity-radar"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "committed-action",
        "filterContract": [
          {
            "fieldId": "committed-action-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "committed-action-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-category-opportunity-radar-read-committed-action",
        "identityFieldId": "committed-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "committed-action-id",
          "action-proposal-id",
          "authority-envelope-id",
          "idempotency-key",
          "sending-owner-id",
          "receiving-owner-id",
          "owner-acceptance-decision-id",
          "commit-attempt",
          "reconciliation-state",
          "reconciliation-reason",
          "last-reconciled-at",
          "verified-outcome-evidence-item-ids",
          "outcome-verified-at",
          "successor-committed-action-id",
          "commit-result",
          "committed-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "category-opportunity-radar"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-event",
        "filterContract": [
          {
            "fieldId": "business-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-category-opportunity-radar-read-business-event",
        "identityFieldId": "business-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-event-id",
          "event-type",
          "event-schema-version",
          "subject-reference",
          "correlation-id",
          "causation-id",
          "sending-owner-id",
          "receiving-owner-id",
          "delivery-attempt",
          "delivery-acknowledgement-state",
          "delivery-acknowledged-at",
          "delivery-acknowledgement-reason",
          "acknowledges-business-event-id",
          "owner-acceptance-decision-id",
          "authority-envelope-id",
          "payload",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "category-strategy-orchestrator"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "action-proposal",
        "filterContract": [
          {
            "fieldId": "action-proposal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "action-proposal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-category-strategy-orchestrator-read-action-proposal",
        "identityFieldId": "action-proposal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "action-proposal-id",
          "workblock-id",
          "action-class",
          "subject-ref",
          "sending-owner-id",
          "receiving-owner-id",
          "source-record-ref",
          "target-record-ref",
          "requested-outcome",
          "evidence-version",
          "expires-at",
          "handoff-attempt",
          "handoff-idempotency-key",
          "acknowledgement-decision-id",
          "reopened-from-action-proposal-id",
          "successor-action-proposal-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "proposed-payload",
          "created-at",
          "governance-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "category-strategy-orchestrator"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "decision",
        "filterContract": [
          {
            "fieldId": "decision-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "decision-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-category-strategy-orchestrator-read-decision",
        "identityFieldId": "decision-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "decision-id",
          "decision-type",
          "subject-ref",
          "outcome",
          "handoff-action-proposal-id",
          "sending-owner-id",
          "receiving-owner-id",
          "acknowledgement-state",
          "acknowledged-at",
          "acknowledgement-reason",
          "redirected-to-owner-id",
          "handoff-attempt",
          "evidence-version",
          "reopened-from-decision-id",
          "successor-decision-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "rationale",
          "decided-at",
          "decided-by-ref",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "category-strategy-orchestrator"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "committed-action",
        "filterContract": [
          {
            "fieldId": "committed-action-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "committed-action-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-category-strategy-orchestrator-read-committed-action",
        "identityFieldId": "committed-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "committed-action-id",
          "action-proposal-id",
          "authority-envelope-id",
          "idempotency-key",
          "sending-owner-id",
          "receiving-owner-id",
          "owner-acceptance-decision-id",
          "commit-attempt",
          "reconciliation-state",
          "reconciliation-reason",
          "last-reconciled-at",
          "verified-outcome-evidence-item-ids",
          "outcome-verified-at",
          "successor-committed-action-id",
          "commit-result",
          "committed-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "category-strategy-orchestrator"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-event",
        "filterContract": [
          {
            "fieldId": "business-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-category-strategy-orchestrator-read-business-event",
        "identityFieldId": "business-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-event-id",
          "event-type",
          "event-schema-version",
          "subject-reference",
          "correlation-id",
          "causation-id",
          "sending-owner-id",
          "receiving-owner-id",
          "delivery-attempt",
          "delivery-acknowledgement-state",
          "delivery-acknowledged-at",
          "delivery-acknowledgement-reason",
          "acknowledges-business-event-id",
          "owner-acceptance-decision-id",
          "authority-envelope-id",
          "payload",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "procurement-service-catalogue"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "action-proposal",
        "filterContract": [
          {
            "fieldId": "action-proposal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "action-proposal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-procurement-service-catalogue-read-action-proposal",
        "identityFieldId": "action-proposal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "action-proposal-id",
          "workblock-id",
          "action-class",
          "subject-ref",
          "sending-owner-id",
          "receiving-owner-id",
          "source-record-ref",
          "target-record-ref",
          "requested-outcome",
          "evidence-version",
          "expires-at",
          "handoff-attempt",
          "handoff-idempotency-key",
          "acknowledgement-decision-id",
          "reopened-from-action-proposal-id",
          "successor-action-proposal-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "proposed-payload",
          "created-at",
          "governance-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "procurement-service-catalogue"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "decision",
        "filterContract": [
          {
            "fieldId": "decision-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "decision-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-procurement-service-catalogue-read-decision",
        "identityFieldId": "decision-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "decision-id",
          "decision-type",
          "subject-ref",
          "outcome",
          "handoff-action-proposal-id",
          "sending-owner-id",
          "receiving-owner-id",
          "acknowledgement-state",
          "acknowledged-at",
          "acknowledgement-reason",
          "redirected-to-owner-id",
          "handoff-attempt",
          "evidence-version",
          "reopened-from-decision-id",
          "successor-decision-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "rationale",
          "decided-at",
          "decided-by-ref",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "procurement-service-catalogue"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "committed-action",
        "filterContract": [
          {
            "fieldId": "committed-action-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "committed-action-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-procurement-service-catalogue-read-committed-action",
        "identityFieldId": "committed-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "committed-action-id",
          "action-proposal-id",
          "authority-envelope-id",
          "idempotency-key",
          "sending-owner-id",
          "receiving-owner-id",
          "owner-acceptance-decision-id",
          "commit-attempt",
          "reconciliation-state",
          "reconciliation-reason",
          "last-reconciled-at",
          "verified-outcome-evidence-item-ids",
          "outcome-verified-at",
          "successor-committed-action-id",
          "commit-result",
          "committed-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "procurement-service-catalogue"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-event",
        "filterContract": [
          {
            "fieldId": "business-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-procurement-service-catalogue-read-business-event",
        "identityFieldId": "business-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-event-id",
          "event-type",
          "event-schema-version",
          "subject-reference",
          "correlation-id",
          "causation-id",
          "sending-owner-id",
          "receiving-owner-id",
          "delivery-attempt",
          "delivery-acknowledgement-state",
          "delivery-acknowledged-at",
          "delivery-acknowledgement-reason",
          "acknowledges-business-event-id",
          "owner-acceptance-decision-id",
          "authority-envelope-id",
          "payload",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "intelligent-intake"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "action-proposal",
        "filterContract": [
          {
            "fieldId": "action-proposal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "action-proposal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-intelligent-intake-read-action-proposal",
        "identityFieldId": "action-proposal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "action-proposal-id",
          "workblock-id",
          "action-class",
          "subject-ref",
          "sending-owner-id",
          "receiving-owner-id",
          "source-record-ref",
          "target-record-ref",
          "requested-outcome",
          "evidence-version",
          "expires-at",
          "handoff-attempt",
          "handoff-idempotency-key",
          "acknowledgement-decision-id",
          "reopened-from-action-proposal-id",
          "successor-action-proposal-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "proposed-payload",
          "created-at",
          "governance-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "intelligent-intake"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "decision",
        "filterContract": [
          {
            "fieldId": "decision-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "decision-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-intelligent-intake-read-decision",
        "identityFieldId": "decision-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "decision-id",
          "decision-type",
          "subject-ref",
          "outcome",
          "handoff-action-proposal-id",
          "sending-owner-id",
          "receiving-owner-id",
          "acknowledgement-state",
          "acknowledged-at",
          "acknowledgement-reason",
          "redirected-to-owner-id",
          "handoff-attempt",
          "evidence-version",
          "reopened-from-decision-id",
          "successor-decision-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "rationale",
          "decided-at",
          "decided-by-ref",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "intelligent-intake"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "committed-action",
        "filterContract": [
          {
            "fieldId": "committed-action-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "committed-action-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-intelligent-intake-read-committed-action",
        "identityFieldId": "committed-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "committed-action-id",
          "action-proposal-id",
          "authority-envelope-id",
          "idempotency-key",
          "sending-owner-id",
          "receiving-owner-id",
          "owner-acceptance-decision-id",
          "commit-attempt",
          "reconciliation-state",
          "reconciliation-reason",
          "last-reconciled-at",
          "verified-outcome-evidence-item-ids",
          "outcome-verified-at",
          "successor-committed-action-id",
          "commit-result",
          "committed-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "intelligent-intake"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-event",
        "filterContract": [
          {
            "fieldId": "business-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-intelligent-intake-read-business-event",
        "identityFieldId": "business-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-event-id",
          "event-type",
          "event-schema-version",
          "subject-reference",
          "correlation-id",
          "causation-id",
          "sending-owner-id",
          "receiving-owner-id",
          "delivery-attempt",
          "delivery-acknowledgement-state",
          "delivery-acknowledged-at",
          "delivery-acknowledgement-reason",
          "acknowledges-business-event-id",
          "owner-acceptance-decision-id",
          "authority-envelope-id",
          "payload",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "policy-rule-lifecycle"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "action-proposal",
        "filterContract": [
          {
            "fieldId": "action-proposal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "action-proposal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-rule-lifecycle-read-action-proposal",
        "identityFieldId": "action-proposal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "action-proposal-id",
          "workblock-id",
          "action-class",
          "subject-ref",
          "sending-owner-id",
          "receiving-owner-id",
          "source-record-ref",
          "target-record-ref",
          "requested-outcome",
          "evidence-version",
          "expires-at",
          "handoff-attempt",
          "handoff-idempotency-key",
          "acknowledgement-decision-id",
          "reopened-from-action-proposal-id",
          "successor-action-proposal-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "proposed-payload",
          "created-at",
          "governance-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "policy-rule-lifecycle"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "decision",
        "filterContract": [
          {
            "fieldId": "decision-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "decision-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-rule-lifecycle-read-decision",
        "identityFieldId": "decision-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "decision-id",
          "decision-type",
          "subject-ref",
          "outcome",
          "handoff-action-proposal-id",
          "sending-owner-id",
          "receiving-owner-id",
          "acknowledgement-state",
          "acknowledged-at",
          "acknowledgement-reason",
          "redirected-to-owner-id",
          "handoff-attempt",
          "evidence-version",
          "reopened-from-decision-id",
          "successor-decision-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "rationale",
          "decided-at",
          "decided-by-ref",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "policy-rule-lifecycle"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "committed-action",
        "filterContract": [
          {
            "fieldId": "committed-action-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "committed-action-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-rule-lifecycle-read-committed-action",
        "identityFieldId": "committed-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "committed-action-id",
          "action-proposal-id",
          "authority-envelope-id",
          "idempotency-key",
          "sending-owner-id",
          "receiving-owner-id",
          "owner-acceptance-decision-id",
          "commit-attempt",
          "reconciliation-state",
          "reconciliation-reason",
          "last-reconciled-at",
          "verified-outcome-evidence-item-ids",
          "outcome-verified-at",
          "successor-committed-action-id",
          "commit-result",
          "committed-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "policy-rule-lifecycle"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-event",
        "filterContract": [
          {
            "fieldId": "business-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-rule-lifecycle-read-business-event",
        "identityFieldId": "business-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-event-id",
          "event-type",
          "event-schema-version",
          "subject-reference",
          "correlation-id",
          "causation-id",
          "sending-owner-id",
          "receiving-owner-id",
          "delivery-attempt",
          "delivery-acknowledgement-state",
          "delivery-acknowledged-at",
          "delivery-acknowledgement-reason",
          "acknowledges-business-event-id",
          "owner-acceptance-decision-id",
          "authority-envelope-id",
          "payload",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "policy-guidance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "action-proposal",
        "filterContract": [
          {
            "fieldId": "action-proposal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "action-proposal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-guidance-read-action-proposal",
        "identityFieldId": "action-proposal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "action-proposal-id",
          "workblock-id",
          "action-class",
          "subject-ref",
          "sending-owner-id",
          "receiving-owner-id",
          "source-record-ref",
          "target-record-ref",
          "requested-outcome",
          "evidence-version",
          "expires-at",
          "handoff-attempt",
          "handoff-idempotency-key",
          "acknowledgement-decision-id",
          "reopened-from-action-proposal-id",
          "successor-action-proposal-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "proposed-payload",
          "created-at",
          "governance-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "policy-guidance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "decision",
        "filterContract": [
          {
            "fieldId": "decision-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "decision-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-guidance-read-decision",
        "identityFieldId": "decision-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "decision-id",
          "decision-type",
          "subject-ref",
          "outcome",
          "handoff-action-proposal-id",
          "sending-owner-id",
          "receiving-owner-id",
          "acknowledgement-state",
          "acknowledged-at",
          "acknowledgement-reason",
          "redirected-to-owner-id",
          "handoff-attempt",
          "evidence-version",
          "reopened-from-decision-id",
          "successor-decision-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "rationale",
          "decided-at",
          "decided-by-ref",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "policy-guidance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "committed-action",
        "filterContract": [
          {
            "fieldId": "committed-action-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "committed-action-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-guidance-read-committed-action",
        "identityFieldId": "committed-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "committed-action-id",
          "action-proposal-id",
          "authority-envelope-id",
          "idempotency-key",
          "sending-owner-id",
          "receiving-owner-id",
          "owner-acceptance-decision-id",
          "commit-attempt",
          "reconciliation-state",
          "reconciliation-reason",
          "last-reconciled-at",
          "verified-outcome-evidence-item-ids",
          "outcome-verified-at",
          "successor-committed-action-id",
          "commit-result",
          "committed-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "policy-guidance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-event",
        "filterContract": [
          {
            "fieldId": "business-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-guidance-read-business-event",
        "identityFieldId": "business-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-event-id",
          "event-type",
          "event-schema-version",
          "subject-reference",
          "correlation-id",
          "causation-id",
          "sending-owner-id",
          "receiving-owner-id",
          "delivery-attempt",
          "delivery-acknowledgement-state",
          "delivery-acknowledged-at",
          "delivery-acknowledgement-reason",
          "acknowledges-business-event-id",
          "owner-acceptance-decision-id",
          "authority-envelope-id",
          "payload",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "requisition-policy-routing"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "action-proposal",
        "filterContract": [
          {
            "fieldId": "action-proposal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "action-proposal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-requisition-policy-routing-read-action-proposal",
        "identityFieldId": "action-proposal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "action-proposal-id",
          "workblock-id",
          "action-class",
          "subject-ref",
          "sending-owner-id",
          "receiving-owner-id",
          "source-record-ref",
          "target-record-ref",
          "requested-outcome",
          "evidence-version",
          "expires-at",
          "handoff-attempt",
          "handoff-idempotency-key",
          "acknowledgement-decision-id",
          "reopened-from-action-proposal-id",
          "successor-action-proposal-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "proposed-payload",
          "created-at",
          "governance-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "requisition-policy-routing"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "decision",
        "filterContract": [
          {
            "fieldId": "decision-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "decision-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-requisition-policy-routing-read-decision",
        "identityFieldId": "decision-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "decision-id",
          "decision-type",
          "subject-ref",
          "outcome",
          "handoff-action-proposal-id",
          "sending-owner-id",
          "receiving-owner-id",
          "acknowledgement-state",
          "acknowledged-at",
          "acknowledgement-reason",
          "redirected-to-owner-id",
          "handoff-attempt",
          "evidence-version",
          "reopened-from-decision-id",
          "successor-decision-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "rationale",
          "decided-at",
          "decided-by-ref",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "requisition-policy-routing"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "committed-action",
        "filterContract": [
          {
            "fieldId": "committed-action-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "committed-action-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-requisition-policy-routing-read-committed-action",
        "identityFieldId": "committed-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "committed-action-id",
          "action-proposal-id",
          "authority-envelope-id",
          "idempotency-key",
          "sending-owner-id",
          "receiving-owner-id",
          "owner-acceptance-decision-id",
          "commit-attempt",
          "reconciliation-state",
          "reconciliation-reason",
          "last-reconciled-at",
          "verified-outcome-evidence-item-ids",
          "outcome-verified-at",
          "successor-committed-action-id",
          "commit-result",
          "committed-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "requisition-policy-routing"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-event",
        "filterContract": [
          {
            "fieldId": "business-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-requisition-policy-routing-read-business-event",
        "identityFieldId": "business-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-event-id",
          "event-type",
          "event-schema-version",
          "subject-reference",
          "correlation-id",
          "causation-id",
          "sending-owner-id",
          "receiving-owner-id",
          "delivery-attempt",
          "delivery-acknowledgement-state",
          "delivery-acknowledged-at",
          "delivery-acknowledgement-reason",
          "acknowledges-business-event-id",
          "owner-acceptance-decision-id",
          "authority-envelope-id",
          "payload",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-pipeline-discovery"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "action-proposal",
        "filterContract": [
          {
            "fieldId": "action-proposal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "action-proposal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-pipeline-discovery-read-action-proposal",
        "identityFieldId": "action-proposal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "action-proposal-id",
          "workblock-id",
          "action-class",
          "subject-ref",
          "sending-owner-id",
          "receiving-owner-id",
          "source-record-ref",
          "target-record-ref",
          "requested-outcome",
          "evidence-version",
          "expires-at",
          "handoff-attempt",
          "handoff-idempotency-key",
          "acknowledgement-decision-id",
          "reopened-from-action-proposal-id",
          "successor-action-proposal-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "proposed-payload",
          "created-at",
          "governance-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-pipeline-discovery"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "decision",
        "filterContract": [
          {
            "fieldId": "decision-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "decision-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-pipeline-discovery-read-decision",
        "identityFieldId": "decision-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "decision-id",
          "decision-type",
          "subject-ref",
          "outcome",
          "handoff-action-proposal-id",
          "sending-owner-id",
          "receiving-owner-id",
          "acknowledgement-state",
          "acknowledged-at",
          "acknowledgement-reason",
          "redirected-to-owner-id",
          "handoff-attempt",
          "evidence-version",
          "reopened-from-decision-id",
          "successor-decision-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "rationale",
          "decided-at",
          "decided-by-ref",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-pipeline-discovery"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "committed-action",
        "filterContract": [
          {
            "fieldId": "committed-action-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "committed-action-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-pipeline-discovery-read-committed-action",
        "identityFieldId": "committed-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "committed-action-id",
          "action-proposal-id",
          "authority-envelope-id",
          "idempotency-key",
          "sending-owner-id",
          "receiving-owner-id",
          "owner-acceptance-decision-id",
          "commit-attempt",
          "reconciliation-state",
          "reconciliation-reason",
          "last-reconciled-at",
          "verified-outcome-evidence-item-ids",
          "outcome-verified-at",
          "successor-committed-action-id",
          "commit-result",
          "committed-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-pipeline-discovery"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-event",
        "filterContract": [
          {
            "fieldId": "business-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-pipeline-discovery-read-business-event",
        "identityFieldId": "business-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-event-id",
          "event-type",
          "event-schema-version",
          "subject-reference",
          "correlation-id",
          "causation-id",
          "sending-owner-id",
          "receiving-owner-id",
          "delivery-attempt",
          "delivery-acknowledgement-state",
          "delivery-acknowledged-at",
          "delivery-acknowledgement-reason",
          "acknowledges-business-event-id",
          "owner-acceptance-decision-id",
          "authority-envelope-id",
          "payload",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-intake-match"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "action-proposal",
        "filterContract": [
          {
            "fieldId": "action-proposal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "action-proposal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-intake-match-read-action-proposal",
        "identityFieldId": "action-proposal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "action-proposal-id",
          "workblock-id",
          "action-class",
          "subject-ref",
          "sending-owner-id",
          "receiving-owner-id",
          "source-record-ref",
          "target-record-ref",
          "requested-outcome",
          "evidence-version",
          "expires-at",
          "handoff-attempt",
          "handoff-idempotency-key",
          "acknowledgement-decision-id",
          "reopened-from-action-proposal-id",
          "successor-action-proposal-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "proposed-payload",
          "created-at",
          "governance-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-intake-match"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "decision",
        "filterContract": [
          {
            "fieldId": "decision-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "decision-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-intake-match-read-decision",
        "identityFieldId": "decision-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "decision-id",
          "decision-type",
          "subject-ref",
          "outcome",
          "handoff-action-proposal-id",
          "sending-owner-id",
          "receiving-owner-id",
          "acknowledgement-state",
          "acknowledged-at",
          "acknowledgement-reason",
          "redirected-to-owner-id",
          "handoff-attempt",
          "evidence-version",
          "reopened-from-decision-id",
          "successor-decision-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "rationale",
          "decided-at",
          "decided-by-ref",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-intake-match"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "committed-action",
        "filterContract": [
          {
            "fieldId": "committed-action-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "committed-action-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-intake-match-read-committed-action",
        "identityFieldId": "committed-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "committed-action-id",
          "action-proposal-id",
          "authority-envelope-id",
          "idempotency-key",
          "sending-owner-id",
          "receiving-owner-id",
          "owner-acceptance-decision-id",
          "commit-attempt",
          "reconciliation-state",
          "reconciliation-reason",
          "last-reconciled-at",
          "verified-outcome-evidence-item-ids",
          "outcome-verified-at",
          "successor-committed-action-id",
          "commit-result",
          "committed-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-intake-match"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-event",
        "filterContract": [
          {
            "fieldId": "business-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-intake-match-read-business-event",
        "identityFieldId": "business-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-event-id",
          "event-type",
          "event-schema-version",
          "subject-reference",
          "correlation-id",
          "causation-id",
          "sending-owner-id",
          "receiving-owner-id",
          "delivery-attempt",
          "delivery-acknowledgement-state",
          "delivery-acknowledged-at",
          "delivery-acknowledgement-reason",
          "acknowledges-business-event-id",
          "owner-acceptance-decision-id",
          "authority-envelope-id",
          "payload",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "payment-readiness"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "action-proposal",
        "filterContract": [
          {
            "fieldId": "action-proposal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "action-proposal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-payment-readiness-read-action-proposal",
        "identityFieldId": "action-proposal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "action-proposal-id",
          "workblock-id",
          "action-class",
          "subject-ref",
          "sending-owner-id",
          "receiving-owner-id",
          "source-record-ref",
          "target-record-ref",
          "requested-outcome",
          "evidence-version",
          "expires-at",
          "handoff-attempt",
          "handoff-idempotency-key",
          "acknowledgement-decision-id",
          "reopened-from-action-proposal-id",
          "successor-action-proposal-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "proposed-payload",
          "created-at",
          "governance-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "payment-readiness"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "decision",
        "filterContract": [
          {
            "fieldId": "decision-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "decision-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-payment-readiness-read-decision",
        "identityFieldId": "decision-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "decision-id",
          "decision-type",
          "subject-ref",
          "outcome",
          "handoff-action-proposal-id",
          "sending-owner-id",
          "receiving-owner-id",
          "acknowledgement-state",
          "acknowledged-at",
          "acknowledgement-reason",
          "redirected-to-owner-id",
          "handoff-attempt",
          "evidence-version",
          "reopened-from-decision-id",
          "successor-decision-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "rationale",
          "decided-at",
          "decided-by-ref",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "payment-readiness"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "committed-action",
        "filterContract": [
          {
            "fieldId": "committed-action-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "committed-action-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-payment-readiness-read-committed-action",
        "identityFieldId": "committed-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "committed-action-id",
          "action-proposal-id",
          "authority-envelope-id",
          "idempotency-key",
          "sending-owner-id",
          "receiving-owner-id",
          "owner-acceptance-decision-id",
          "commit-attempt",
          "reconciliation-state",
          "reconciliation-reason",
          "last-reconciled-at",
          "verified-outcome-evidence-item-ids",
          "outcome-verified-at",
          "successor-committed-action-id",
          "commit-result",
          "committed-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-innovation-pipeline"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "action-proposal",
        "filterContract": [
          {
            "fieldId": "action-proposal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "action-proposal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-innovation-pipeline-read-action-proposal",
        "identityFieldId": "action-proposal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "action-proposal-id",
          "workblock-id",
          "action-class",
          "subject-ref",
          "sending-owner-id",
          "receiving-owner-id",
          "source-record-ref",
          "target-record-ref",
          "requested-outcome",
          "evidence-version",
          "expires-at",
          "handoff-attempt",
          "handoff-idempotency-key",
          "acknowledgement-decision-id",
          "reopened-from-action-proposal-id",
          "successor-action-proposal-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "proposed-payload",
          "created-at",
          "governance-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-innovation-pipeline"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "decision",
        "filterContract": [
          {
            "fieldId": "decision-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "decision-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-innovation-pipeline-read-decision",
        "identityFieldId": "decision-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "decision-id",
          "decision-type",
          "subject-ref",
          "outcome",
          "handoff-action-proposal-id",
          "sending-owner-id",
          "receiving-owner-id",
          "acknowledgement-state",
          "acknowledged-at",
          "acknowledgement-reason",
          "redirected-to-owner-id",
          "handoff-attempt",
          "evidence-version",
          "reopened-from-decision-id",
          "successor-decision-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "rationale",
          "decided-at",
          "decided-by-ref",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-innovation-pipeline"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "committed-action",
        "filterContract": [
          {
            "fieldId": "committed-action-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "committed-action-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-innovation-pipeline-read-committed-action",
        "identityFieldId": "committed-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "committed-action-id",
          "action-proposal-id",
          "authority-envelope-id",
          "idempotency-key",
          "sending-owner-id",
          "receiving-owner-id",
          "owner-acceptance-decision-id",
          "commit-attempt",
          "reconciliation-state",
          "reconciliation-reason",
          "last-reconciled-at",
          "verified-outcome-evidence-item-ids",
          "outcome-verified-at",
          "successor-committed-action-id",
          "commit-result",
          "committed-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-innovation-pipeline"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-event",
        "filterContract": [
          {
            "fieldId": "business-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-innovation-pipeline-read-business-event",
        "identityFieldId": "business-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-event-id",
          "event-type",
          "event-schema-version",
          "subject-reference",
          "correlation-id",
          "causation-id",
          "sending-owner-id",
          "receiving-owner-id",
          "delivery-attempt",
          "delivery-acknowledgement-state",
          "delivery-acknowledged-at",
          "delivery-acknowledgement-reason",
          "acknowledges-business-event-id",
          "owner-acceptance-decision-id",
          "authority-envelope-id",
          "payload",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "renewal-change-compliance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "action-proposal",
        "filterContract": [
          {
            "fieldId": "action-proposal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "action-proposal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-renewal-change-compliance-read-action-proposal",
        "identityFieldId": "action-proposal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "action-proposal-id",
          "workblock-id",
          "action-class",
          "subject-ref",
          "sending-owner-id",
          "receiving-owner-id",
          "source-record-ref",
          "target-record-ref",
          "requested-outcome",
          "evidence-version",
          "expires-at",
          "handoff-attempt",
          "handoff-idempotency-key",
          "acknowledgement-decision-id",
          "reopened-from-action-proposal-id",
          "successor-action-proposal-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "proposed-payload",
          "created-at",
          "governance-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "renewal-change-compliance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "decision",
        "filterContract": [
          {
            "fieldId": "decision-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "decision-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-renewal-change-compliance-read-decision",
        "identityFieldId": "decision-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "decision-id",
          "decision-type",
          "subject-ref",
          "outcome",
          "handoff-action-proposal-id",
          "sending-owner-id",
          "receiving-owner-id",
          "acknowledgement-state",
          "acknowledged-at",
          "acknowledgement-reason",
          "redirected-to-owner-id",
          "handoff-attempt",
          "evidence-version",
          "reopened-from-decision-id",
          "successor-decision-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "rationale",
          "decided-at",
          "decided-by-ref",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "renewal-change-compliance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "committed-action",
        "filterContract": [
          {
            "fieldId": "committed-action-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "committed-action-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-renewal-change-compliance-read-committed-action",
        "identityFieldId": "committed-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "committed-action-id",
          "action-proposal-id",
          "authority-envelope-id",
          "idempotency-key",
          "sending-owner-id",
          "receiving-owner-id",
          "owner-acceptance-decision-id",
          "commit-attempt",
          "reconciliation-state",
          "reconciliation-reason",
          "last-reconciled-at",
          "verified-outcome-evidence-item-ids",
          "outcome-verified-at",
          "successor-committed-action-id",
          "commit-result",
          "committed-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "renewal-change-compliance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-event",
        "filterContract": [
          {
            "fieldId": "business-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-renewal-change-compliance-read-business-event",
        "identityFieldId": "business-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-event-id",
          "event-type",
          "event-schema-version",
          "subject-reference",
          "correlation-id",
          "causation-id",
          "sending-owner-id",
          "receiving-owner-id",
          "delivery-attempt",
          "delivery-acknowledgement-state",
          "delivery-acknowledged-at",
          "delivery-acknowledgement-reason",
          "acknowledges-business-event-id",
          "owner-acceptance-decision-id",
          "authority-envelope-id",
          "payload",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "value-opportunity-baseline"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "action-proposal",
        "filterContract": [
          {
            "fieldId": "action-proposal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "action-proposal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-value-opportunity-baseline-read-action-proposal",
        "identityFieldId": "action-proposal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "action-proposal-id",
          "workblock-id",
          "action-class",
          "subject-ref",
          "sending-owner-id",
          "receiving-owner-id",
          "source-record-ref",
          "target-record-ref",
          "requested-outcome",
          "evidence-version",
          "expires-at",
          "handoff-attempt",
          "handoff-idempotency-key",
          "acknowledgement-decision-id",
          "reopened-from-action-proposal-id",
          "successor-action-proposal-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "proposed-payload",
          "created-at",
          "governance-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "value-opportunity-baseline"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "decision",
        "filterContract": [
          {
            "fieldId": "decision-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "decision-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-value-opportunity-baseline-read-decision",
        "identityFieldId": "decision-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "decision-id",
          "decision-type",
          "subject-ref",
          "outcome",
          "handoff-action-proposal-id",
          "sending-owner-id",
          "receiving-owner-id",
          "acknowledgement-state",
          "acknowledged-at",
          "acknowledgement-reason",
          "redirected-to-owner-id",
          "handoff-attempt",
          "evidence-version",
          "reopened-from-decision-id",
          "successor-decision-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "rationale",
          "decided-at",
          "decided-by-ref",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "value-opportunity-baseline"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "committed-action",
        "filterContract": [
          {
            "fieldId": "committed-action-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "committed-action-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-value-opportunity-baseline-read-committed-action",
        "identityFieldId": "committed-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "committed-action-id",
          "action-proposal-id",
          "authority-envelope-id",
          "idempotency-key",
          "sending-owner-id",
          "receiving-owner-id",
          "owner-acceptance-decision-id",
          "commit-attempt",
          "reconciliation-state",
          "reconciliation-reason",
          "last-reconciled-at",
          "verified-outcome-evidence-item-ids",
          "outcome-verified-at",
          "successor-committed-action-id",
          "commit-result",
          "committed-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "value-opportunity-baseline"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-event",
        "filterContract": [
          {
            "fieldId": "business-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-value-opportunity-baseline-read-business-event",
        "identityFieldId": "business-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-event-id",
          "event-type",
          "event-schema-version",
          "subject-reference",
          "correlation-id",
          "causation-id",
          "sending-owner-id",
          "receiving-owner-id",
          "delivery-attempt",
          "delivery-acknowledgement-state",
          "delivery-acknowledged-at",
          "delivery-acknowledgement-reason",
          "acknowledges-business-event-id",
          "owner-acceptance-decision-id",
          "authority-envelope-id",
          "payload",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-segmentation-governance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "action-proposal",
        "filterContract": [
          {
            "fieldId": "action-proposal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "action-proposal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-segmentation-governance-read-action-proposal",
        "identityFieldId": "action-proposal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "action-proposal-id",
          "workblock-id",
          "action-class",
          "subject-ref",
          "sending-owner-id",
          "receiving-owner-id",
          "source-record-ref",
          "target-record-ref",
          "requested-outcome",
          "evidence-version",
          "expires-at",
          "handoff-attempt",
          "handoff-idempotency-key",
          "acknowledgement-decision-id",
          "reopened-from-action-proposal-id",
          "successor-action-proposal-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "proposed-payload",
          "created-at",
          "governance-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-segmentation-governance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "decision",
        "filterContract": [
          {
            "fieldId": "decision-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "decision-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-segmentation-governance-read-decision",
        "identityFieldId": "decision-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "decision-id",
          "decision-type",
          "subject-ref",
          "outcome",
          "handoff-action-proposal-id",
          "sending-owner-id",
          "receiving-owner-id",
          "acknowledgement-state",
          "acknowledged-at",
          "acknowledgement-reason",
          "redirected-to-owner-id",
          "handoff-attempt",
          "evidence-version",
          "reopened-from-decision-id",
          "successor-decision-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "rationale",
          "decided-at",
          "decided-by-ref",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-segmentation-governance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "committed-action",
        "filterContract": [
          {
            "fieldId": "committed-action-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "committed-action-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-segmentation-governance-read-committed-action",
        "identityFieldId": "committed-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "committed-action-id",
          "action-proposal-id",
          "authority-envelope-id",
          "idempotency-key",
          "sending-owner-id",
          "receiving-owner-id",
          "owner-acceptance-decision-id",
          "commit-attempt",
          "reconciliation-state",
          "reconciliation-reason",
          "last-reconciled-at",
          "verified-outcome-evidence-item-ids",
          "outcome-verified-at",
          "successor-committed-action-id",
          "commit-result",
          "committed-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-segmentation-governance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-event",
        "filterContract": [
          {
            "fieldId": "business-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-segmentation-governance-read-business-event",
        "identityFieldId": "business-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-event-id",
          "event-type",
          "event-schema-version",
          "subject-reference",
          "correlation-id",
          "causation-id",
          "sending-owner-id",
          "receiving-owner-id",
          "delivery-attempt",
          "delivery-acknowledgement-state",
          "delivery-acknowledged-at",
          "delivery-acknowledgement-reason",
          "acknowledges-business-event-id",
          "owner-acceptance-decision-id",
          "authority-envelope-id",
          "payload",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "action-proposal",
        "filterContract": [
          {
            "fieldId": "action-proposal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "action-proposal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-review-read-action-proposal",
        "identityFieldId": "action-proposal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "action-proposal-id",
          "workblock-id",
          "action-class",
          "subject-ref",
          "sending-owner-id",
          "receiving-owner-id",
          "source-record-ref",
          "target-record-ref",
          "requested-outcome",
          "evidence-version",
          "expires-at",
          "handoff-attempt",
          "handoff-idempotency-key",
          "acknowledgement-decision-id",
          "reopened-from-action-proposal-id",
          "successor-action-proposal-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "proposed-payload",
          "created-at",
          "governance-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-review"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "committed-action",
        "filterContract": [
          {
            "fieldId": "committed-action-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "committed-action-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-review-read-committed-action",
        "identityFieldId": "committed-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "committed-action-id",
          "action-proposal-id",
          "authority-envelope-id",
          "idempotency-key",
          "sending-owner-id",
          "receiving-owner-id",
          "owner-acceptance-decision-id",
          "commit-attempt",
          "reconciliation-state",
          "reconciliation-reason",
          "last-reconciled-at",
          "verified-outcome-evidence-item-ids",
          "outcome-verified-at",
          "successor-committed-action-id",
          "commit-result",
          "committed-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-monitor-correct"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "action-proposal",
        "filterContract": [
          {
            "fieldId": "action-proposal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "action-proposal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-monitor-correct-read-action-proposal",
        "identityFieldId": "action-proposal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "action-proposal-id",
          "workblock-id",
          "action-class",
          "subject-ref",
          "sending-owner-id",
          "receiving-owner-id",
          "source-record-ref",
          "target-record-ref",
          "requested-outcome",
          "evidence-version",
          "expires-at",
          "handoff-attempt",
          "handoff-idempotency-key",
          "acknowledgement-decision-id",
          "reopened-from-action-proposal-id",
          "successor-action-proposal-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "proposed-payload",
          "created-at",
          "governance-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-monitor-correct"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "decision",
        "filterContract": [
          {
            "fieldId": "decision-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "decision-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-monitor-correct-read-decision",
        "identityFieldId": "decision-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "decision-id",
          "decision-type",
          "subject-ref",
          "outcome",
          "handoff-action-proposal-id",
          "sending-owner-id",
          "receiving-owner-id",
          "acknowledgement-state",
          "acknowledged-at",
          "acknowledgement-reason",
          "redirected-to-owner-id",
          "handoff-attempt",
          "evidence-version",
          "reopened-from-decision-id",
          "successor-decision-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "rationale",
          "decided-at",
          "decided-by-ref",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-monitor-correct"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "committed-action",
        "filterContract": [
          {
            "fieldId": "committed-action-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "committed-action-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-monitor-correct-read-committed-action",
        "identityFieldId": "committed-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "committed-action-id",
          "action-proposal-id",
          "authority-envelope-id",
          "idempotency-key",
          "sending-owner-id",
          "receiving-owner-id",
          "owner-acceptance-decision-id",
          "commit-attempt",
          "reconciliation-state",
          "reconciliation-reason",
          "last-reconciled-at",
          "verified-outcome-evidence-item-ids",
          "outcome-verified-at",
          "successor-committed-action-id",
          "commit-result",
          "committed-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-performance-monitor-correct"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-event",
        "filterContract": [
          {
            "fieldId": "business-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-performance-monitor-correct-read-business-event",
        "identityFieldId": "business-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-event-id",
          "event-type",
          "event-schema-version",
          "subject-reference",
          "correlation-id",
          "causation-id",
          "sending-owner-id",
          "receiving-owner-id",
          "delivery-attempt",
          "delivery-acknowledgement-state",
          "delivery-acknowledged-at",
          "delivery-acknowledgement-reason",
          "acknowledges-business-event-id",
          "owner-acceptance-decision-id",
          "authority-envelope-id",
          "payload",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-relationship-joint-value"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "action-proposal",
        "filterContract": [
          {
            "fieldId": "action-proposal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "action-proposal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-relationship-joint-value-read-action-proposal",
        "identityFieldId": "action-proposal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "action-proposal-id",
          "workblock-id",
          "action-class",
          "subject-ref",
          "sending-owner-id",
          "receiving-owner-id",
          "source-record-ref",
          "target-record-ref",
          "requested-outcome",
          "evidence-version",
          "expires-at",
          "handoff-attempt",
          "handoff-idempotency-key",
          "acknowledgement-decision-id",
          "reopened-from-action-proposal-id",
          "successor-action-proposal-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "proposed-payload",
          "created-at",
          "governance-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-relationship-joint-value"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "decision",
        "filterContract": [
          {
            "fieldId": "decision-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "decision-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-relationship-joint-value-read-decision",
        "identityFieldId": "decision-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "decision-id",
          "decision-type",
          "subject-ref",
          "outcome",
          "handoff-action-proposal-id",
          "sending-owner-id",
          "receiving-owner-id",
          "acknowledgement-state",
          "acknowledged-at",
          "acknowledgement-reason",
          "redirected-to-owner-id",
          "handoff-attempt",
          "evidence-version",
          "reopened-from-decision-id",
          "successor-decision-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "rationale",
          "decided-at",
          "decided-by-ref",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-relationship-joint-value"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "committed-action",
        "filterContract": [
          {
            "fieldId": "committed-action-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "committed-action-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-relationship-joint-value-read-committed-action",
        "identityFieldId": "committed-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "committed-action-id",
          "action-proposal-id",
          "authority-envelope-id",
          "idempotency-key",
          "sending-owner-id",
          "receiving-owner-id",
          "owner-acceptance-decision-id",
          "commit-attempt",
          "reconciliation-state",
          "reconciliation-reason",
          "last-reconciled-at",
          "verified-outcome-evidence-item-ids",
          "outcome-verified-at",
          "successor-committed-action-id",
          "commit-result",
          "committed-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-relationship-joint-value"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-event",
        "filterContract": [
          {
            "fieldId": "business-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-relationship-joint-value-read-business-event",
        "identityFieldId": "business-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-event-id",
          "event-type",
          "event-schema-version",
          "subject-reference",
          "correlation-id",
          "causation-id",
          "sending-owner-id",
          "receiving-owner-id",
          "delivery-attempt",
          "delivery-acknowledgement-state",
          "delivery-acknowledged-at",
          "delivery-acknowledgement-reason",
          "acknowledges-business-event-id",
          "owner-acceptance-decision-id",
          "authority-envelope-id",
          "payload",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-remediation-exit"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "action-proposal",
        "filterContract": [
          {
            "fieldId": "action-proposal-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "action-proposal-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-remediation-exit-read-action-proposal",
        "identityFieldId": "action-proposal-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "action-proposal-id",
          "workblock-id",
          "action-class",
          "subject-ref",
          "sending-owner-id",
          "receiving-owner-id",
          "source-record-ref",
          "target-record-ref",
          "requested-outcome",
          "evidence-version",
          "expires-at",
          "handoff-attempt",
          "handoff-idempotency-key",
          "acknowledgement-decision-id",
          "reopened-from-action-proposal-id",
          "successor-action-proposal-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "proposed-payload",
          "created-at",
          "governance-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-remediation-exit"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "decision",
        "filterContract": [
          {
            "fieldId": "decision-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "decision-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-remediation-exit-read-decision",
        "identityFieldId": "decision-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "decision-id",
          "decision-type",
          "subject-ref",
          "outcome",
          "handoff-action-proposal-id",
          "sending-owner-id",
          "receiving-owner-id",
          "acknowledgement-state",
          "acknowledged-at",
          "acknowledgement-reason",
          "redirected-to-owner-id",
          "handoff-attempt",
          "evidence-version",
          "reopened-from-decision-id",
          "successor-decision-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "rationale",
          "decided-at",
          "decided-by-ref",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-remediation-exit"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "committed-action",
        "filterContract": [
          {
            "fieldId": "committed-action-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "committed-action-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-remediation-exit-read-committed-action",
        "identityFieldId": "committed-action-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "shared-ledger-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "committed-action-id",
          "action-proposal-id",
          "authority-envelope-id",
          "idempotency-key",
          "sending-owner-id",
          "receiving-owner-id",
          "owner-acceptance-decision-id",
          "commit-attempt",
          "reconciliation-state",
          "reconciliation-reason",
          "last-reconciled-at",
          "verified-outcome-evidence-item-ids",
          "outcome-verified-at",
          "successor-committed-action-id",
          "commit-result",
          "committed-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-remediation-exit"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "business-event",
        "filterContract": [
          {
            "fieldId": "business-event-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "business-event-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-remediation-exit-read-business-event",
        "identityFieldId": "business-event-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "audit-event-service",
        "ownerKind": "platform-service",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "business-event-id",
          "event-type",
          "event-schema-version",
          "subject-reference",
          "correlation-id",
          "causation-id",
          "sending-owner-id",
          "receiving-owner-id",
          "delivery-attempt",
          "delivery-acknowledgement-state",
          "delivery-acknowledged-at",
          "delivery-acknowledgement-reason",
          "acknowledges-business-event-id",
          "owner-acceptance-decision-id",
          "authority-envelope-id",
          "payload",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "policy-rule-lifecycle"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "intake-request",
        "filterContract": [
          {
            "fieldId": "intake-request-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "intake-request-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-rule-lifecycle-read-intake-request",
        "identityFieldId": "intake-request-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "intelligent-intake",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "intake-request-id",
          "external-reference",
          "requester-person-id",
          "business-unit-id",
          "service-offering-id",
          "need-statement",
          "requirements",
          "estimated-value",
          "needed-by-date",
          "evidence-item-ids",
          "completeness-score",
          "submitted-at",
          "governance-authority-envelope-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "intelligent-intake"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy-rule-release",
        "filterContract": [
          {
            "fieldId": "policy-rule-release-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "policy-rule-release-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-intelligent-intake-read-policy-rule-release",
        "identityFieldId": "policy-rule-release-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "policy-rule-lifecycle",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-rule-release-id",
          "policy-version-id",
          "release-number",
          "rule-code",
          "scope",
          "condition-expression",
          "effect",
          "precedence",
          "effective-from",
          "effective-until",
          "evaluation-result-id",
          "rollback-release-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-intake-match"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "payment-readiness-assessment",
        "filterContract": [
          {
            "fieldId": "payment-readiness-assessment-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "payment-readiness-assessment-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-intake-match-read-payment-readiness-assessment",
        "identityFieldId": "payment-readiness-assessment-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "payment-readiness",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "payment-readiness-assessment-id",
          "invoice-id",
          "resolution-ids",
          "check-results",
          "payable-amount",
          "due-date",
          "risk-flags",
          "proposed-readiness",
          "committed-readiness",
          "hold-reason-codes",
          "authority-envelope-id",
          "assessed-at",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "invoice-intake-match"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "invoice-exception",
        "filterContract": [
          {
            "fieldId": "invoice-exception-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "invoice-exception-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-invoice-intake-match-read-invoice-exception",
        "identityFieldId": "invoice-exception-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "invoice-exception-triage",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "invoice-exception-id",
          "invoice-id",
          "match-assessment-id",
          "exception-type",
          "materiality-band",
          "owner-reference",
          "due-at",
          "proposed-resolution",
          "proposal-status",
          "committed-disposition",
          "authority-envelope-id",
          "opened-at",
          "updated-at",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "governance-exception-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "sourcing-pipeline-discovery"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-innovation-case",
        "filterContract": [
          {
            "fieldId": "supplier-innovation-case-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-innovation-case-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-sourcing-pipeline-discovery-read-supplier-innovation-case",
        "identityFieldId": "supplier-innovation-case-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-innovation-pipeline",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-innovation-case-id",
          "supplier-party-id",
          "title",
          "need-or-opportunity",
          "sponsor-reference",
          "owner-reference",
          "category-ids",
          "contract-ids",
          "value-hypothesis",
          "risk-hypothesis",
          "proposed-next-action",
          "proposal-status",
          "committed-gate-decision",
          "authority-envelope-id",
          "experiment-plan",
          "experiment-outcome",
          "opened-at",
          "next-gate-at",
          "closed-at",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "renewal-change-compliance"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-innovation-case",
        "filterContract": [
          {
            "fieldId": "supplier-innovation-case-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-innovation-case-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-renewal-change-compliance-read-supplier-innovation-case",
        "identityFieldId": "supplier-innovation-case-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-innovation-pipeline",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-innovation-case-id",
          "supplier-party-id",
          "title",
          "need-or-opportunity",
          "sponsor-reference",
          "owner-reference",
          "category-ids",
          "contract-ids",
          "value-hypothesis",
          "risk-hypothesis",
          "proposed-next-action",
          "proposal-status",
          "committed-gate-decision",
          "authority-envelope-id",
          "experiment-plan",
          "experiment-outcome",
          "opened-at",
          "next-gate-at",
          "closed-at",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "value-opportunity-baseline"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "supplier-innovation-case",
        "filterContract": [
          {
            "fieldId": "supplier-innovation-case-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "supplier-innovation-case-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-value-opportunity-baseline-read-supplier-innovation-case",
        "identityFieldId": "supplier-innovation-case-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "supplier-innovation-pipeline",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "supplier-innovation-case-id",
          "supplier-party-id",
          "title",
          "need-or-opportunity",
          "sponsor-reference",
          "owner-reference",
          "category-ids",
          "contract-ids",
          "value-hypothesis",
          "risk-hypothesis",
          "proposed-next-action",
          "proposal-status",
          "committed-gate-decision",
          "authority-envelope-id",
          "experiment-plan",
          "experiment-outcome",
          "opened-at",
          "next-gate-at",
          "closed-at",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-innovation-pipeline"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "sourcing-opportunity",
        "filterContract": [
          {
            "fieldId": "sourcing-opportunity-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "sourcing-opportunity-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-innovation-pipeline-read-sourcing-opportunity",
        "identityFieldId": "sourcing-opportunity-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "sourcing-pipeline-discovery",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "sourcing-opportunity-id",
          "category-id",
          "strategy-id",
          "demand-portfolio-id",
          "title",
          "scope-summary",
          "market-candidate-party-ids",
          "recommended-route",
          "value-hypothesis",
          "priority-score",
          "target-start-date",
          "evidence-as-of",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-innovation-pipeline"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "contract-change",
        "filterContract": [
          {
            "fieldId": "contract-change-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "contract-change-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-innovation-pipeline-read-contract-change",
        "identityFieldId": "contract-change-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "renewal-change-compliance",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "contract-change-id",
          "contract-id",
          "change-type",
          "trigger-reference",
          "decision-deadline",
          "impact-summary",
          "resulting-version-id",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "consumerBusinessModuleIds": [
          "supplier-innovation-pipeline"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "value-opportunity-baseline",
        "filterContract": [
          {
            "fieldId": "value-opportunity-baseline-id",
            "operators": [
              "equals"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "value-opportunity-baseline-id"
        ],
        "freshness": "last-good-with-age",
        "id": "query-supplier-innovation-pipeline-read-value-opportunity-baseline",
        "identityFieldId": "value-opportunity-baseline-id",
        "orderBy": [
          {
            "direction": "descending",
            "fieldId": "effective-at"
          }
        ],
        "ownerId": "value-opportunity-baseline",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 50,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "point",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "value-opportunity-baseline-id",
          "opportunity-reference",
          "opportunity-type",
          "title",
          "owner-reference",
          "category-ids",
          "supplier-party-ids",
          "contract-ids",
          "source-record-ids",
          "baseline-period-start",
          "baseline-period-end",
          "comparison-period-start",
          "comparison-period-end",
          "baseline-method-version",
          "baseline-amount",
          "target-amount",
          "forecast-amount",
          "currency-code",
          "assumptions",
          "proposed-validation",
          "proposal-status",
          "committed-validation",
          "authority-envelope-id",
          "source-system",
          "source-schema-version",
          "observed-at",
          "evidence-ids",
          "policy-version-id",
          "workblock-version",
          "governance-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "cohortContract": {
          "completeness": "authorised-snapshot",
          "definitionVersion": "1.0.0",
          "evaluationBasisFieldIds": [
            "service-offering-id",
            "lifecycle-state",
            "record-version"
          ],
          "exclusionSemantics": "reason-coded",
          "inclusionSemantics": "reason-coded",
          "rationaleFieldIds": [
            "service-offering-id",
            "lifecycle-state",
            "needed-by-date"
          ],
          "snapshotFieldId": "effective-at"
        },
        "consumerBusinessModuleIds": [
          "procurement-service-catalogue"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "intake-request",
        "filterContract": [
          {
            "fieldId": "service-offering-id",
            "operators": [
              "equals"
            ],
            "required": true
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "on-or-before"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "service-offering-id",
          "effective-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-procurement-service-catalogue-cohort-intake-request",
        "identityFieldId": "intake-request-id",
        "orderBy": [
          {
            "direction": "ascending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "intake-request-id"
          }
        ],
        "ownerId": "intelligent-intake",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 100,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "cohort",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "intake-request-id",
          "external-reference",
          "requester-person-id",
          "business-unit-id",
          "service-offering-id",
          "need-statement",
          "requirements",
          "estimated-value",
          "needed-by-date",
          "evidence-item-ids",
          "completeness-score",
          "submitted-at",
          "governance-authority-envelope-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "cohortContract": {
          "completeness": "authorised-snapshot",
          "definitionVersion": "1.0.0",
          "evaluationBasisFieldIds": [
            "rule-release-ids",
            "record-version",
            "evaluated-at",
            "expires-at"
          ],
          "exclusionSemantics": "reason-coded",
          "inclusionSemantics": "reason-coded",
          "rationaleFieldIds": [
            "outcome",
            "lifecycle-state",
            "expires-at"
          ],
          "snapshotFieldId": "effective-at"
        },
        "consumerBusinessModuleIds": [
          "policy-rule-lifecycle"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "policy-guidance-result",
        "filterContract": [
          {
            "fieldId": "rule-release-ids",
            "operators": [
              "contains-any"
            ],
            "required": true
          },
          {
            "fieldId": "effective-at",
            "operators": [
              "on-or-before"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "rule-release-ids",
          "effective-at"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-rule-lifecycle-cohort-policy-guidance-result",
        "identityFieldId": "policy-guidance-result-id",
        "orderBy": [
          {
            "direction": "ascending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "policy-guidance-result-id"
          }
        ],
        "ownerId": "policy-guidance",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 100,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "cohort",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "policy-guidance-result-id",
          "subject-entity-id",
          "question",
          "input-facts",
          "rule-release-ids",
          "outcome",
          "permitted-route-codes",
          "required-evidence-codes",
          "explanation",
          "exception-id",
          "evaluated-at",
          "expires-at",
          "governance-decision-id",
          "governance-authority-envelope-id",
          "governance-evidence-item-ids",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      },
      {
        "accessBoundary": "owner-api",
        "cohortContract": {
          "completeness": "authorised-snapshot",
          "definitionVersion": "1.0.0",
          "evaluationBasisFieldIds": [
            "policy-evaluation",
            "record-version",
            "lifecycle-state"
          ],
          "exclusionSemantics": "reason-coded",
          "inclusionSemantics": "reason-coded",
          "rationaleFieldIds": [
            "policy-evaluation",
            "lifecycle-state"
          ],
          "snapshotFieldId": "effective-at"
        },
        "consumerBusinessModuleIds": [
          "policy-rule-lifecycle"
        ],
        "emptyResult": "authorised-empty",
        "entityId": "requisition",
        "filterContract": [
          {
            "fieldId": "effective-at",
            "operators": [
              "on-or-before"
            ],
            "required": true
          },
          {
            "fieldId": "lifecycle-state",
            "operators": [
              "one-of"
            ],
            "required": true
          }
        ],
        "filterFieldIds": [
          "effective-at",
          "lifecycle-state"
        ],
        "freshness": "last-good-with-age",
        "id": "query-policy-rule-lifecycle-cohort-requisition",
        "identityFieldId": "requisition-id",
        "orderBy": [
          {
            "direction": "ascending",
            "fieldId": "effective-at"
          },
          {
            "direction": "ascending",
            "fieldId": "requisition-id"
          }
        ],
        "ownerId": "requisition-policy-routing",
        "ownerKind": "business-module",
        "pagination": {
          "defaultLimit": 100,
          "kind": "cursor",
          "maximumLimit": 500
        },
        "permissionAction": "view",
        "permissionFilterOrder": "before-filter-count-page",
        "queryKind": "cohort",
        "redactionBehaviour": "omit-record",
        "resultCount": "authorised-only",
        "resultFieldIds": [
          "requisition-id",
          "requisition-number",
          "source-buying-request-id",
          "requester-reference",
          "business-unit-code",
          "total-amount",
          "policy-evaluation",
          "budget-reservation",
          "budget-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ]
      }
    ],
    "platformDataMappings": [
      {
        "access": "update",
        "accessBoundary": "owner-datastore",
        "authorityFieldId": "authority-reference",
        "concurrency": "expected-version",
        "concurrencyFieldId": "record-version",
        "entityId": "party",
        "fieldIds": [
          "party-id",
          "legal-name",
          "party-type",
          "external-identifier",
          "tax-identifier",
          "electronic-address",
          "registered-country-code",
          "lifecycle-state",
          "updated-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "business-key"
        ],
        "interface": "ledger-command",
        "keyFieldIds": [
          "party-id"
        ],
        "operationId": "update-party",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Own expected-version mutation and reconciliation of the canonical party through Shared ledger service.",
        "reconciliationKeyFieldIds": [
          "party-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "shared-ledger-service"
      },
      {
        "access": "update",
        "accessBoundary": "owner-datastore",
        "authorityFieldId": "authority-reference",
        "concurrency": "expected-version",
        "concurrencyFieldId": "record-version",
        "entityId": "person",
        "fieldIds": [
          "person-id",
          "party-id",
          "identity-subject",
          "display-name",
          "primary-role",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "business-key"
        ],
        "interface": "ledger-command",
        "keyFieldIds": [
          "person-id"
        ],
        "operationId": "update-person",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Own expected-version mutation and reconciliation of the canonical person through Shared ledger service.",
        "reconciliationKeyFieldIds": [
          "person-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "shared-ledger-service"
      },
      {
        "access": "update",
        "accessBoundary": "owner-datastore",
        "authorityFieldId": "authority-reference",
        "concurrency": "expected-version",
        "concurrencyFieldId": "record-version",
        "entityId": "business-unit",
        "fieldIds": [
          "business-unit-id",
          "external-key",
          "name",
          "parent-business-unit-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "business-key"
        ],
        "interface": "ledger-command",
        "keyFieldIds": [
          "business-unit-id"
        ],
        "operationId": "update-business-unit",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Own expected-version mutation and reconciliation of the canonical business unit through Shared ledger service.",
        "reconciliationKeyFieldIds": [
          "business-unit-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "shared-ledger-service"
      },
      {
        "access": "update",
        "accessBoundary": "owner-datastore",
        "authorityFieldId": "authority-reference",
        "concurrency": "expected-version",
        "concurrencyFieldId": "record-version",
        "entityId": "category",
        "fieldIds": [
          "category-id",
          "taxonomy-version-id",
          "code",
          "name",
          "parent-category-id",
          "external-classification",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "business-key"
        ],
        "interface": "ledger-command",
        "keyFieldIds": [
          "category-id"
        ],
        "operationId": "update-category",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Own expected-version mutation and reconciliation of the canonical category through Shared ledger service.",
        "reconciliationKeyFieldIds": [
          "category-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "shared-ledger-service"
      },
      {
        "access": "update",
        "accessBoundary": "owner-datastore",
        "authorityFieldId": "authority-reference",
        "concurrency": "expected-version",
        "concurrencyFieldId": "record-version",
        "entityId": "item-service",
        "fieldIds": [
          "item-service-id",
          "kind",
          "buying-mode",
          "name",
          "description",
          "category-id",
          "external-identifier",
          "external-classification",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "business-key"
        ],
        "interface": "ledger-command",
        "keyFieldIds": [
          "item-service-id"
        ],
        "operationId": "update-item-service",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Own expected-version mutation and reconciliation of the canonical item or service through Shared ledger service.",
        "reconciliationKeyFieldIds": [
          "item-service-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "shared-ledger-service"
      },
      {
        "access": "create",
        "accessBoundary": "owner-datastore",
        "authorityFieldId": "authority-reference",
        "concurrency": "create-if-absent",
        "concurrencyFieldId": "record-version",
        "entityId": "action-proposal",
        "fieldIds": [
          "action-proposal-id",
          "workblock-id",
          "action-class",
          "subject-ref",
          "sending-owner-id",
          "receiving-owner-id",
          "source-record-ref",
          "target-record-ref",
          "requested-outcome",
          "evidence-version",
          "expires-at",
          "handoff-attempt",
          "handoff-idempotency-key",
          "acknowledgement-decision-id",
          "reopened-from-action-proposal-id",
          "successor-action-proposal-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "proposed-payload",
          "created-at",
          "governance-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "business-key"
        ],
        "interface": "ledger-command",
        "keyFieldIds": [
          "action-proposal-id"
        ],
        "operationId": "create-action-proposal",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Create a version-pinned cross-owner request through Shared ledger service without transferring the source or target record owner.",
        "reconciliationKeyFieldIds": [
          "action-proposal-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "shared-ledger-service"
      },
      {
        "access": "update",
        "accessBoundary": "owner-datastore",
        "authorityFieldId": "authority-reference",
        "concurrency": "expected-version",
        "concurrencyFieldId": "record-version",
        "entityId": "action-proposal",
        "fieldIds": [
          "action-proposal-id",
          "workblock-id",
          "action-class",
          "subject-ref",
          "sending-owner-id",
          "receiving-owner-id",
          "source-record-ref",
          "target-record-ref",
          "requested-outcome",
          "evidence-version",
          "expires-at",
          "handoff-attempt",
          "handoff-idempotency-key",
          "acknowledgement-decision-id",
          "reopened-from-action-proposal-id",
          "successor-action-proposal-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "proposed-payload",
          "created-at",
          "governance-decision-id",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "business-key"
        ],
        "interface": "ledger-command",
        "keyFieldIds": [
          "action-proposal-id"
        ],
        "operationId": "update-action-proposal",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Own expected-version mutation, expiry, withdrawal, supersession and successor reconciliation of the canonical action proposal through Shared ledger service.",
        "reconciliationKeyFieldIds": [
          "action-proposal-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "shared-ledger-service"
      },
      {
        "access": "append",
        "accessBoundary": "event",
        "authorityFieldId": "authority-reference",
        "concurrency": "append-only",
        "concurrencyFieldId": "record-version",
        "entityId": "committed-action",
        "fieldIds": [
          "committed-action-id",
          "action-proposal-id",
          "authority-envelope-id",
          "idempotency-key",
          "sending-owner-id",
          "receiving-owner-id",
          "owner-acceptance-decision-id",
          "commit-attempt",
          "reconciliation-state",
          "reconciliation-reason",
          "last-reconciled-at",
          "verified-outcome-evidence-item-ids",
          "outcome-verified-at",
          "successor-committed-action-id",
          "commit-result",
          "committed-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "idempotency-key"
        ],
        "interface": "event-contract",
        "keyFieldIds": [
          "committed-action-id"
        ],
        "operationId": "append-committed-action",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Append each authorised delivery or receiver-owned command attempt and preserve its safe-retry and reconciliation state through Shared ledger service.",
        "reconciliationKeyFieldIds": [
          "committed-action-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "shared-ledger-service"
      },
      {
        "access": "create",
        "accessBoundary": "owner-datastore",
        "authorityFieldId": "authority-reference",
        "concurrency": "create-if-absent",
        "concurrencyFieldId": "record-version",
        "entityId": "decision",
        "fieldIds": [
          "decision-id",
          "decision-type",
          "subject-ref",
          "outcome",
          "handoff-action-proposal-id",
          "sending-owner-id",
          "receiving-owner-id",
          "acknowledgement-state",
          "acknowledged-at",
          "acknowledgement-reason",
          "redirected-to-owner-id",
          "handoff-attempt",
          "evidence-version",
          "reopened-from-decision-id",
          "successor-decision-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "rationale",
          "decided-at",
          "decided-by-ref",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "business-key"
        ],
        "interface": "ledger-command",
        "keyFieldIds": [
          "decision-id"
        ],
        "operationId": "create-decision",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Create the receiving owner's version-pinned acceptance, rejection, redirect, expiry or reopen decision through Shared ledger service.",
        "reconciliationKeyFieldIds": [
          "decision-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "shared-ledger-service"
      },
      {
        "access": "update",
        "accessBoundary": "owner-datastore",
        "authorityFieldId": "authority-reference",
        "concurrency": "expected-version",
        "concurrencyFieldId": "record-version",
        "entityId": "decision",
        "fieldIds": [
          "decision-id",
          "decision-type",
          "subject-ref",
          "outcome",
          "handoff-action-proposal-id",
          "sending-owner-id",
          "receiving-owner-id",
          "acknowledgement-state",
          "acknowledged-at",
          "acknowledgement-reason",
          "redirected-to-owner-id",
          "handoff-attempt",
          "evidence-version",
          "reopened-from-decision-id",
          "successor-decision-id",
          "authority-envelope-id",
          "evidence-item-ids",
          "rationale",
          "decided-at",
          "decided-by-ref",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "business-key"
        ],
        "interface": "ledger-command",
        "keyFieldIds": [
          "decision-id"
        ],
        "operationId": "update-decision",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Own expected-version supersession and successor reconciliation of the canonical receiving-owner decision through Shared ledger service.",
        "reconciliationKeyFieldIds": [
          "decision-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "shared-ledger-service"
      },
      {
        "access": "update",
        "accessBoundary": "owner-datastore",
        "authorityFieldId": "authority-reference",
        "concurrency": "expected-version",
        "concurrencyFieldId": "record-version",
        "entityId": "exception",
        "fieldIds": [
          "exception-id",
          "workblock-id",
          "exception-type",
          "subject-ref",
          "owner-person-id",
          "evidence-item-ids",
          "lifecycle-state",
          "opened-at",
          "resolution-decision-id",
          "governance-authority-envelope-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "business-key"
        ],
        "interface": "ledger-command",
        "keyFieldIds": [
          "exception-id"
        ],
        "operationId": "update-exception",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Own expected-version mutation and reconciliation of the canonical exception case through Shared ledger service.",
        "reconciliationKeyFieldIds": [
          "exception-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "shared-ledger-service"
      },
      {
        "access": "append",
        "accessBoundary": "event",
        "authorityFieldId": "authority-reference",
        "concurrency": "append-only",
        "concurrencyFieldId": "record-version",
        "entityId": "source-record-reference",
        "fieldIds": [
          "source-record-reference-id",
          "source-system-id",
          "source-object-type",
          "source-record-id",
          "source-version",
          "source-schema-version",
          "observed-at",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "business-key"
        ],
        "interface": "event-contract",
        "keyFieldIds": [
          "source-record-reference-id"
        ],
        "operationId": "append-source-record-reference",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Append and reconcile the immutable canonical source record reference through Audit and evidence service.",
        "reconciliationKeyFieldIds": [
          "source-record-reference-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "audit-event-service"
      },
      {
        "access": "append",
        "accessBoundary": "event",
        "authorityFieldId": "authority-reference",
        "concurrency": "append-only",
        "concurrencyFieldId": "record-version",
        "entityId": "evidence-item",
        "fieldIds": [
          "evidence-item-id",
          "evidence-type",
          "source-record-reference-id",
          "artifact-reference",
          "content-hash",
          "captured-at",
          "lifecycle-state",
          "classification",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "business-key"
        ],
        "interface": "event-contract",
        "keyFieldIds": [
          "evidence-item-id"
        ],
        "operationId": "append-evidence-item",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Append and reconcile the immutable canonical evidence item through Audit and evidence service.",
        "reconciliationKeyFieldIds": [
          "evidence-item-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "audit-event-service"
      },
      {
        "access": "append",
        "accessBoundary": "event",
        "authorityFieldId": "authority-reference",
        "concurrency": "append-only",
        "concurrencyFieldId": "record-version",
        "entityId": "audit-event",
        "fieldIds": [
          "audit-event-id",
          "event-type",
          "subject-reference",
          "actor-reference",
          "version-context",
          "correlation-id",
          "summary",
          "occurred-at",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "business-key"
        ],
        "interface": "event-contract",
        "keyFieldIds": [
          "audit-event-id"
        ],
        "operationId": "append-audit-event",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Append and reconcile the immutable canonical audit event through Audit and evidence service.",
        "reconciliationKeyFieldIds": [
          "audit-event-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "audit-event-service"
      },
      {
        "access": "append",
        "accessBoundary": "event",
        "authorityFieldId": "authority-reference",
        "concurrency": "append-only",
        "concurrencyFieldId": "record-version",
        "entityId": "business-event",
        "fieldIds": [
          "business-event-id",
          "event-type",
          "event-schema-version",
          "subject-reference",
          "correlation-id",
          "causation-id",
          "sending-owner-id",
          "receiving-owner-id",
          "delivery-attempt",
          "delivery-acknowledgement-state",
          "delivery-acknowledged-at",
          "delivery-acknowledgement-reason",
          "acknowledges-business-event-id",
          "owner-acceptance-decision-id",
          "authority-envelope-id",
          "payload",
          "occurred-at",
          "business-key",
          "record-version",
          "schema-version",
          "lifecycle-state",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "business-key"
        ],
        "interface": "event-contract",
        "keyFieldIds": [
          "business-event-id"
        ],
        "operationId": "append-business-event",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Append immutable delivery, acknowledgement, rejection, reconciliation, replay and reopen facts through Audit and evidence service.",
        "reconciliationKeyFieldIds": [
          "business-event-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "audit-event-service"
      },
      {
        "access": "update",
        "accessBoundary": "owner-datastore",
        "authorityFieldId": "authority-reference",
        "concurrency": "expected-version",
        "concurrencyFieldId": "record-version",
        "entityId": "policy",
        "fieldIds": [
          "policy-id",
          "policy-code",
          "title",
          "owner-person-id",
          "active-version-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "business-key"
        ],
        "interface": "ledger-command",
        "keyFieldIds": [
          "policy-id"
        ],
        "operationId": "update-policy",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Own expected-version mutation and reconciliation of the canonical policy through Registry governance service.",
        "reconciliationKeyFieldIds": [
          "policy-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "registry-governance-service"
      },
      {
        "access": "append",
        "accessBoundary": "event",
        "authorityFieldId": "authority-reference",
        "concurrency": "append-only",
        "concurrencyFieldId": "record-version",
        "entityId": "policy-version",
        "fieldIds": [
          "policy-version-id",
          "policy-id",
          "semantic-version",
          "artifact-reference",
          "rules-hash",
          "effective-from",
          "effective-to",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "business-key"
        ],
        "interface": "event-contract",
        "keyFieldIds": [
          "policy-version-id"
        ],
        "operationId": "append-policy-version",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Append and reconcile the immutable canonical policy version through Registry governance service.",
        "reconciliationKeyFieldIds": [
          "policy-version-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "registry-governance-service"
      },
      {
        "access": "update",
        "accessBoundary": "owner-datastore",
        "authorityFieldId": "authority-reference",
        "concurrency": "expected-version",
        "concurrencyFieldId": "record-version",
        "entityId": "authority-envelope",
        "fieldIds": [
          "authority-envelope-id",
          "workblock-id",
          "grantor-person-id",
          "policy-version-id",
          "allowed-actions",
          "guard-conditions",
          "effective-from",
          "expires-at",
          "lifecycle-state",
          "grantor-role-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "business-key"
        ],
        "interface": "ledger-command",
        "keyFieldIds": [
          "authority-envelope-id"
        ],
        "operationId": "update-authority-envelope",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Own expected-version mutation and reconciliation of the canonical authority envelope through Registry governance service.",
        "reconciliationKeyFieldIds": [
          "authority-envelope-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "registry-governance-service"
      },
      {
        "access": "append",
        "accessBoundary": "event",
        "authorityFieldId": "authority-reference",
        "concurrency": "append-only",
        "concurrencyFieldId": "record-version",
        "entityId": "registry-release",
        "fieldIds": [
          "registry-release-id",
          "registry-version",
          "previous-version",
          "content-hash",
          "compatibility-class",
          "change-summary",
          "migration-references",
          "lifecycle-state",
          "released-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "business-key"
        ],
        "interface": "event-contract",
        "keyFieldIds": [
          "registry-release-id"
        ],
        "operationId": "append-registry-release",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Append and reconcile the immutable canonical registry release through Registry governance service.",
        "reconciliationKeyFieldIds": [
          "registry-release-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "registry-governance-service"
      },
      {
        "access": "append",
        "accessBoundary": "event",
        "authorityFieldId": "authority-reference",
        "concurrency": "append-only",
        "concurrencyFieldId": "record-version",
        "entityId": "learning-example",
        "fieldIds": [
          "learning-example-id",
          "workblock-id",
          "example-type",
          "input-reference",
          "expected-output",
          "version-context",
          "validation-evidence-item-ids",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "business-key"
        ],
        "interface": "event-contract",
        "keyFieldIds": [
          "learning-example-id"
        ],
        "operationId": "append-learning-example",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Append and reconcile the immutable canonical learning example through Learning and evaluation service.",
        "reconciliationKeyFieldIds": [
          "learning-example-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "learning-evaluation-service"
      },
      {
        "access": "append",
        "accessBoundary": "event",
        "authorityFieldId": "authority-reference",
        "concurrency": "append-only",
        "concurrencyFieldId": "record-version",
        "entityId": "evaluation-result",
        "fieldIds": [
          "evaluation-result-id",
          "workblock-id",
          "candidate-version",
          "suite-version",
          "check-results",
          "disposition",
          "lifecycle-state",
          "completed-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "business-key"
        ],
        "interface": "event-contract",
        "keyFieldIds": [
          "evaluation-result-id"
        ],
        "operationId": "append-evaluation-result",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Append and reconcile the immutable canonical evaluation result through Learning and evaluation service.",
        "reconciliationKeyFieldIds": [
          "evaluation-result-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "learning-evaluation-service"
      },
      {
        "access": "update",
        "accessBoundary": "owner-datastore",
        "authorityFieldId": "authority-reference",
        "concurrency": "expected-version",
        "concurrencyFieldId": "record-version",
        "entityId": "integration-state",
        "fieldIds": [
          "integration-state-id",
          "integration-id",
          "lifecycle-state",
          "last-successful-sync-at",
          "last-error-code",
          "last-good-reference",
          "updated-at",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "business-key"
        ],
        "interface": "ledger-command",
        "keyFieldIds": [
          "integration-state-id"
        ],
        "operationId": "update-integration-state",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Own expected-version mutation and reconciliation of the canonical integration state through Integration state service.",
        "reconciliationKeyFieldIds": [
          "integration-state-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "integration-state-service"
      },
      {
        "access": "update",
        "accessBoundary": "owner-datastore",
        "authorityFieldId": "authority-reference",
        "concurrency": "expected-version",
        "concurrencyFieldId": "record-version",
        "entityId": "catalogue-line",
        "fieldIds": [
          "catalogue-line-id",
          "buying-mode",
          "supplier-id",
          "supplier-item-id",
          "description",
          "classification-code",
          "unit-price",
          "contract-id",
          "buying-constraints",
          "lifecycle-state",
          "valid-to",
          "category-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "business-key"
        ],
        "interface": "ledger-command",
        "keyFieldIds": [
          "catalogue-line-id"
        ],
        "operationId": "update-catalogue-line",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Own expected-version mutation and reconciliation of the canonical catalogue line through Catalogue management service.",
        "reconciliationKeyFieldIds": [
          "catalogue-line-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "catalogue-management-service"
      },
      {
        "access": "update",
        "accessBoundary": "owner-datastore",
        "authorityFieldId": "authority-reference",
        "concurrency": "expected-version",
        "concurrencyFieldId": "record-version",
        "entityId": "taxonomy-version",
        "fieldIds": [
          "taxonomy-version-id",
          "company-party-id",
          "version-code",
          "content-hash",
          "effective-from",
          "supersedes-taxonomy-version-id",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "business-key"
        ],
        "interface": "ledger-command",
        "keyFieldIds": [
          "taxonomy-version-id"
        ],
        "operationId": "update-taxonomy-version",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Govern draft, approval and activation state while preserving immutable taxonomy release content and predecessor lineage.",
        "reconciliationKeyFieldIds": [
          "taxonomy-version-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "shared-ledger-service"
      },
      {
        "access": "update",
        "accessBoundary": "owner-datastore",
        "authorityFieldId": "authority-reference",
        "concurrency": "expected-version",
        "concurrencyFieldId": "record-version",
        "entityId": "category-dimension-assignment",
        "fieldIds": [
          "category-dimension-assignment-id",
          "company-party-id",
          "business-unit-id",
          "taxonomy-version-id",
          "category-id",
          "dimension-id",
          "member-id",
          "inheritance-mode",
          "effective-from",
          "effective-until",
          "lifecycle-state",
          "source-method",
          "actor-reference",
          "evidence-item-ids",
          "supersedes-assignment-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "business-key"
        ],
        "interface": "ledger-command",
        "keyFieldIds": [
          "category-dimension-assignment-id"
        ],
        "operationId": "update-category-dimension-assignment",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Commit company-scoped category assignments under expected-version and authority control while retaining superseded decisions.",
        "reconciliationKeyFieldIds": [
          "category-dimension-assignment-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "shared-ledger-service"
      },
      {
        "access": "update",
        "accessBoundary": "owner-datastore",
        "authorityFieldId": "authority-reference",
        "concurrency": "expected-version",
        "concurrencyFieldId": "record-version",
        "entityId": "role",
        "fieldIds": [
          "role-id",
          "label-key",
          "description-key",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "business-key"
        ],
        "interface": "ledger-command",
        "keyFieldIds": [
          "role-id"
        ],
        "operationId": "update-role",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Own the governed role contract through its declared authority and freshness boundary.",
        "reconciliationKeyFieldIds": [
          "role-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "registry-governance-service"
      },
      {
        "access": "update",
        "accessBoundary": "owner-datastore",
        "authorityFieldId": "authority-reference",
        "concurrency": "expected-version",
        "concurrencyFieldId": "record-version",
        "entityId": "person-role-assignment",
        "fieldIds": [
          "person-role-assignment-id",
          "company-party-id",
          "person-id",
          "role-id",
          "effective-from",
          "effective-to",
          "granted-by-ref",
          "authority-envelope-id",
          "evidence-item-ids",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "business-key"
        ],
        "interface": "ledger-command",
        "keyFieldIds": [
          "person-role-assignment-id"
        ],
        "operationId": "update-person-role-assignment",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Own the governed person role assignment contract through its declared authority and freshness boundary.",
        "reconciliationKeyFieldIds": [
          "person-role-assignment-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "registry-governance-service"
      },
      {
        "access": "update",
        "accessBoundary": "owner-datastore",
        "authorityFieldId": "authority-reference",
        "concurrency": "expected-version",
        "concurrencyFieldId": "record-version",
        "entityId": "job",
        "fieldIds": [
          "job-id",
          "business-module-id",
          "role-id",
          "story-key",
          "completion-key",
          "execution-flow-ids",
          "lifecycle-state",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "business-key"
        ],
        "interface": "ledger-command",
        "keyFieldIds": [
          "job-id"
        ],
        "operationId": "update-job",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Own the governed job contract through its declared authority and freshness boundary.",
        "reconciliationKeyFieldIds": [
          "job-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "registry-governance-service"
      },
      {
        "access": "update",
        "accessBoundary": "owner-datastore",
        "authorityFieldId": "authority-reference",
        "concurrency": "expected-version",
        "concurrencyFieldId": "record-version",
        "entityId": "work-moment-record",
        "fieldIds": [
          "work-moment-record-id",
          "work-moment-definition-id",
          "business-module-id",
          "job-id",
          "owner-role-id",
          "subject-ref",
          "evidence-item-ids",
          "opened-at",
          "updated-at",
          "lifecycle-state",
          "governance-authority-envelope-id",
          "business-key",
          "record-version",
          "schema-version",
          "effective-at",
          "freshness-status",
          "last-good-at",
          "writer-version",
          "authority-reference",
          "provenance-reference"
        ],
        "idempotencyKeyFieldIds": [
          "business-key"
        ],
        "interface": "ledger-command",
        "keyFieldIds": [
          "work-moment-record-id"
        ],
        "operationId": "update-work-moment-record",
        "ownershipMode": "owner-write",
        "preserveLastGood": true,
        "purpose": "Own the governed work moment record contract through its declared authority and freshness boundary.",
        "reconciliationKeyFieldIds": [
          "work-moment-record-id",
          "record-version"
        ],
        "recordEnvelopeVersion": "2.0.0",
        "serviceId": "shared-ledger-service"
      }
    ],
    "platformServices": [
      {
        "id": "shared-ledger-service",
        "interfaces": [
          "Versioned ledger command API",
          "Policy-filtered ledger query API",
          "Changed-record event contracts"
        ],
        "label": "Shared ledger service",
        "mission": "Own canonical cross-domain master, proposal, commitment, decision and exception records while exposing policy-filtered commands, queries and changed-record events.",
        "ownedEntityIds": [
          "party",
          "person",
          "business-unit",
          "category",
          "taxonomy-version",
          "category-dimension-assignment",
          "item-service",
          "action-proposal",
          "committed-action",
          "decision",
          "exception",
          "work-moment-record",
          "company-classification-category"
        ],
        "ownershipBoundary": "Only this service commits the shared records it owns. Domain Workblocks submit typed commands or consume projections and events; they do not write shared tables directly.",
        "realizationBoundary": "platform-services-workblock"
      },
      {
        "id": "audit-event-service",
        "interfaces": [
          "Evidence metadata API",
          "Append-only audit event contract",
          "Append-only business event contract"
        ],
        "label": "Audit and evidence service",
        "mission": "Own immutable source references, evidence metadata, audit events and business events with integrity, access and retention controls.",
        "ownedEntityIds": [
          "source-record-reference",
          "evidence-item",
          "audit-event",
          "business-event"
        ],
        "ownershipBoundary": "Payload binaries remain in blob storage; the service owns immutable evidence and event metadata and rejects mutation of committed event versions.",
        "realizationBoundary": "platform-services-workblock"
      },
      {
        "id": "registry-governance-service",
        "interfaces": [
          "Registry query API",
          "Governed release command API",
          "Release and revocation events"
        ],
        "label": "Registry governance service",
        "mission": "Own effective policy, policy versions, authority envelopes and immutable registry releases used by every Workblock.",
        "ownedEntityIds": [
          "policy",
          "policy-version",
          "authority-envelope",
          "registry-release",
          "role",
          "person-role-assignment",
          "job",
          "data-grant",
          "data-access-request"
        ],
        "ownershipBoundary": "Policy and schema changes pass versioned governance, compatibility evaluation, canary and rollback contracts before becoming active.",
        "realizationBoundary": "platform-services-workblock"
      },
      {
        "id": "learning-evaluation-service",
        "interfaces": [
          "Learning example append contract",
          "Evaluation run API",
          "Promotion evidence query API"
        ],
        "label": "Learning and evaluation service",
        "mission": "Own validated learning examples and version-pinned evaluation results without allowing feedback to mutate production policy or models silently.",
        "ownedEntityIds": [
          "learning-example",
          "evaluation-result"
        ],
        "ownershipBoundary": "Only reconciled outcomes or explicitly validated corrections enter learning data; promotion and demotion remain separate governed release decisions.",
        "realizationBoundary": "platform-services-workblock"
      },
      {
        "id": "integration-state-service",
        "interfaces": [
          "Adapter checkpoint command API",
          "Source-health query API",
          "Integration health events"
        ],
        "label": "Integration state service",
        "mission": "Own adapter checkpoints, source health, reconciliation cursors and last-success metadata shared across Workblocks.",
        "ownedEntityIds": [
          "integration-state"
        ],
        "ownershipBoundary": "Adapters report state through idempotent commands; domain Workblocks consume last-good health projections and cannot overwrite connector checkpoints.",
        "realizationBoundary": "platform-services-workblock"
      },
      {
        "id": "catalogue-management-service",
        "interfaces": [
          "Catalogue ingestion command API",
          "Effective catalogue query API",
          "Catalogue changed-record events"
        ],
        "label": "Catalogue management service",
        "mission": "Own effective-dated catalogue offerings ingested from governed catalogue, supplier and contract sources for policy-filtered consumption by buying Workblocks.",
        "ownedEntityIds": [
          "catalogue-line"
        ],
        "ownershipBoundary": "The service validates, versions and reconciles catalogue lines. Guided Buying and downstream Workblocks query or index those records but cannot treat a retrieval projection as the canonical catalogue.",
        "realizationBoundary": "platform-services-workblock"
      }
    ],
    "recordEnvelope": {
      "appliesTo": "Every shared or domain canonical entity. Payload fields remain owned by the entity schema; envelope fields and the required execution trace are composed into the stored and exchanged record and are included explicitly in every write, read, event and index mapping.",
      "authorityFieldId": "authority-reference",
      "businessKeyFieldId": "business-key",
      "concurrencyFieldId": "record-version",
      "definition": "The composed metadata contract carried by every canonical ledger record. It makes identity, optimistic concurrency, schema compatibility, effective time, freshness, last-good preservation, writer version, authority, provenance and qualified execution trace consistent across all nine domain Workblocks without duplicating those fields in each payload schema.",
      "effectiveAtFieldId": "effective-at",
      "executionTrace": {
        "definition": "The required execution lineage composed into every canonical record version. It binds the transition to its domain Workblock, acting business module, execution flow, qualified task and run, and concrete writer release.",
        "fields": [
          {
            "classification": "internal",
            "definition": "Stable identifier of the domain Workblock within whose outcome boundary the record transition was requested or produced.",
            "exchangeScope": "internal",
            "format": "stable domain Workblock ID",
            "id": "domain-workblock-id",
            "introducedIn": "1.0.0",
            "label": "Domain Workblock ID",
            "nullable": false,
            "required": true,
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Stable identifier of the business module that requested or produced the record transition, including transitions committed through an owner service.",
            "exchangeScope": "internal",
            "format": "stable business module ID",
            "id": "business-module-id",
            "introducedIn": "1.0.0",
            "label": "Business module ID",
            "nullable": false,
            "required": true,
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Stable identifier of the independently invokable execution flow that produced the transition.",
            "exchangeScope": "internal",
            "format": "stable execution flow ID",
            "id": "execution-flow-id",
            "introducedIn": "1.0.0",
            "label": "Execution flow ID",
            "nullable": false,
            "required": true,
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Release-scoped task identifier namespaced as businessModule.executionFlow.task so the writer remains unambiguous across the framework.",
            "exchangeScope": "internal",
            "format": "businessModule.executionFlow.task",
            "id": "qualified-task-id",
            "introducedIn": "1.0.0",
            "label": "Qualified task ID",
            "nullable": false,
            "required": true,
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "restricted",
            "definition": "Tenant- and environment-qualified immutable identifier for the concrete run that produced the record transition.",
            "exchangeScope": "internal",
            "format": "tenant.environment.run",
            "id": "qualified-run-id",
            "introducedIn": "1.0.0",
            "label": "Qualified run ID",
            "nullable": false,
            "required": true,
            "standardMappings": [],
            "type": "string"
          },
          {
            "classification": "internal",
            "definition": "Concrete semantic version or immutable release reference bound to this execution trace; unlike writer-version's general compatibility pin, it identifies the exact released writer used by the run.",
            "exchangeScope": "internal",
            "format": "semantic version or immutable release reference",
            "id": "writer-release",
            "introducedIn": "1.0.0",
            "label": "Writer release",
            "nullable": false,
            "required": true,
            "standardMappings": [],
            "type": "string"
          }
        ],
        "id": "record-execution-trace",
        "required": true,
        "version": "1.0.0"
      },
      "fields": [
        {
          "classification": "internal",
          "definition": "Stable tenant-scoped idempotency key for the business record or event, independent of retries and transport identifiers.",
          "exchangeScope": "internal",
          "format": "tenant-scoped stable key",
          "id": "business-key",
          "introducedIn": "1.0.0",
          "label": "Business key",
          "nullable": false,
          "required": true,
          "standardMappings": [],
          "type": "string"
        },
        {
          "classification": "internal",
          "definition": "Monotonically increasing version used for expected-version writes and causal reconciliation; immutable events carry their creation version.",
          "exchangeScope": "internal",
          "format": "positive integer",
          "id": "record-version",
          "introducedIn": "1.0.0",
          "label": "Record version",
          "nullable": false,
          "required": true,
          "standardMappings": [],
          "type": "integer"
        },
        {
          "classification": "internal",
          "definition": "Semantic version of the entity contract under which the payload was validated.",
          "exchangeScope": "internal",
          "format": "semantic version",
          "id": "schema-version",
          "introducedIn": "1.0.0",
          "label": "Schema version",
          "nullable": false,
          "required": true,
          "standardMappings": [],
          "type": "string"
        },
        {
          "classification": "internal",
          "definition": "Current lifecycle state validated against the composing entity's declared lifecycle vocabulary.",
          "exchangeScope": "internal",
          "id": "lifecycle-state",
          "introducedIn": "2.0.0",
          "label": "Lifecycle state",
          "nullable": false,
          "openVocabularyJustification": "The closed values are supplied by the composing entity lifecycle rather than one cross-entity enum.",
          "required": true,
          "sourceAuthority": {
            "id": "ledger-record-envelope",
            "kind": "schema-definition"
          },
          "standardMappings": [],
          "type": "string"
        },
        {
          "classification": "internal",
          "definition": "Business-effective timestamp of this record state, kept distinct from ingestion and processing time.",
          "exchangeScope": "internal",
          "format": "date-time",
          "id": "effective-at",
          "introducedIn": "1.0.0",
          "label": "Effective at",
          "nullable": false,
          "required": true,
          "standardMappings": [],
          "type": "timestamp"
        },
        {
          "classification": "internal",
          "definition": "Evaluated recency of the record against its named refresh policy; it never rewrites stale evidence as current.",
          "enumValues": [
            "current",
            "delayed",
            "stale"
          ],
          "exchangeScope": "internal",
          "id": "freshness-status",
          "introducedIn": "1.0.0",
          "label": "Freshness status",
          "nullable": false,
          "required": true,
          "standardMappings": [],
          "type": "string"
        },
        {
          "classification": "internal",
          "definition": "Timestamp of the most recent successfully reconciled usable state retained when a later refresh fails or is incomplete.",
          "exchangeScope": "internal",
          "format": "date-time",
          "id": "last-good-at",
          "introducedIn": "1.0.0",
          "label": "Last good at",
          "nullable": true,
          "required": false,
          "standardMappings": [],
          "type": "timestamp"
        },
        {
          "classification": "internal",
          "definition": "Compatibility contract version declared by the Workblock or platform service that wrote the record transition. This pins the record contract the writer supports; executionTrace.writer-release identifies the exact concrete release used by the run.",
          "exchangeScope": "internal",
          "format": "semantic version compatibility pin",
          "id": "writer-version",
          "introducedIn": "1.0.0",
          "label": "Writer version",
          "nullable": false,
          "required": true,
          "standardMappings": [],
          "type": "string"
        },
        {
          "classification": "restricted",
          "definition": "Versioned policy, grant or service authority under which this read, proposal or commitment was made.",
          "exchangeScope": "internal",
          "format": "versioned authority reference",
          "id": "authority-reference",
          "introducedIn": "1.0.0",
          "label": "Authority reference",
          "nullable": false,
          "required": true,
          "standardMappings": [],
          "type": "string"
        },
        {
          "classification": "restricted",
          "definition": "Immutable reference to the source, transformation, task-run and reconciliation lineage for this exact record version.",
          "exchangeScope": "internal",
          "format": "immutable lineage reference",
          "id": "provenance-reference",
          "introducedIn": "1.0.0",
          "label": "Provenance reference",
          "nullable": false,
          "required": true,
          "standardMappings": [],
          "type": "string"
        }
      ],
      "freshnessFieldId": "freshness-status",
      "id": "ledger-record-envelope",
      "lastGoodAtFieldId": "last-good-at",
      "lifecycleFieldId": "lifecycle-state",
      "provenanceFieldId": "provenance-reference",
      "schemaVersionFieldId": "schema-version",
      "version": "2.0.0",
      "writerVersionFieldId": "writer-version"
    },
    "roleDefinitions": [
      {
        "descriptionKey": "role.accountable-risk-owner.description",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk"
        ],
        "id": "accountable-risk-owner",
        "labelKey": "role.accountable-risk-owner.label",
        "searchTermKeys": [
          "role.accountable-risk-owner.search.risk-acceptance"
        ]
      },
      {
        "descriptionKey": "role.ap-processor.description",
        "domainWorkblockIds": [
          "invoice-exception-payment-readiness"
        ],
        "id": "ap-processor",
        "labelKey": "role.ap-processor.label",
        "searchTermKeys": [
          "role.ap-processor.search.accounts-payable"
        ]
      },
      {
        "descriptionKey": "role.award-authority.description",
        "domainWorkblockIds": [
          "sourcing-negotiation"
        ],
        "id": "award-authority",
        "labelKey": "role.award-authority.label",
        "searchTermKeys": []
      },
      {
        "descriptionKey": "role.budget-owner.description",
        "domainWorkblockIds": [
          "buying-ordering-receiving",
          "value-realization-savings"
        ],
        "id": "budget-owner",
        "labelKey": "role.budget-owner.label",
        "searchTermKeys": [
          "role.budget-owner.search.business-budget-owner"
        ]
      },
      {
        "descriptionKey": "role.category-manager.description",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "contract-lifecycle-management",
          "value-realization-savings"
        ],
        "id": "category-manager",
        "labelKey": "role.category-manager.label",
        "searchTermKeys": []
      },
      {
        "descriptionKey": "role.contract-manager.description",
        "domainWorkblockIds": [
          "contract-lifecycle-management"
        ],
        "id": "contract-manager",
        "labelKey": "role.contract-manager.label",
        "searchTermKeys": []
      },
      {
        "descriptionKey": "role.controller.description",
        "domainWorkblockIds": [
          "invoice-exception-payment-readiness"
        ],
        "id": "controller",
        "labelKey": "role.controller.label",
        "searchTermKeys": []
      },
      {
        "descriptionKey": "role.data-steward.description",
        "domainWorkblockIds": [
          "strategy-policy-category-spend"
        ],
        "id": "data-steward",
        "labelKey": "role.data-steward.label",
        "searchTermKeys": []
      },
      {
        "descriptionKey": "role.demand-owner.description",
        "domainWorkblockIds": [
          "intake-demand"
        ],
        "id": "demand-owner",
        "labelKey": "role.demand-owner.label",
        "searchTermKeys": []
      },
      {
        "descriptionKey": "role.evaluator.description",
        "domainWorkblockIds": [
          "sourcing-negotiation"
        ],
        "id": "evaluator",
        "labelKey": "role.evaluator.label",
        "searchTermKeys": [
          "role.evaluator.search.subject-matter-expert"
        ]
      },
      {
        "descriptionKey": "role.finance-delegate.description",
        "domainWorkblockIds": [
          "value-realization-savings"
        ],
        "id": "finance-delegate",
        "labelKey": "role.finance-delegate.label",
        "searchTermKeys": []
      },
      {
        "descriptionKey": "role.governance-owner.description",
        "domainWorkblockIds": [
          "supplier-performance-innovation-relationship"
        ],
        "id": "governance-owner",
        "labelKey": "role.governance-owner.label",
        "searchTermKeys": [
          "role.governance-owner.search.supplier-governance-owner"
        ]
      },
      {
        "descriptionKey": "role.innovation-sponsor.description",
        "domainWorkblockIds": [
          "supplier-performance-innovation-relationship"
        ],
        "id": "innovation-sponsor",
        "labelKey": "role.innovation-sponsor.label",
        "searchTermKeys": []
      },
      {
        "descriptionKey": "role.intake-owner.description",
        "domainWorkblockIds": [
          "intake-demand"
        ],
        "id": "intake-owner",
        "labelKey": "role.intake-owner.label",
        "searchTermKeys": [
          "role.intake-owner.search.procurement-intake-owner"
        ]
      },
      {
        "descriptionKey": "role.integration-owner.description",
        "domainWorkblockIds": [
          "buying-ordering-receiving"
        ],
        "id": "integration-owner",
        "labelKey": "role.integration-owner.label",
        "searchTermKeys": [
          "role.integration-owner.search.erp-owner"
        ]
      },
      {
        "descriptionKey": "role.legal-counsel.description",
        "domainWorkblockIds": [
          "contract-lifecycle-management"
        ],
        "id": "legal-counsel",
        "labelKey": "role.legal-counsel.label",
        "searchTermKeys": []
      },
      {
        "descriptionKey": "role.metric-owner.description",
        "domainWorkblockIds": [
          "supplier-performance-innovation-relationship"
        ],
        "id": "metric-owner",
        "labelKey": "role.metric-owner.label",
        "searchTermKeys": [
          "role.metric-owner.search.data-owner"
        ]
      },
      {
        "descriptionKey": "role.negotiation-lead.description",
        "domainWorkblockIds": [
          "sourcing-negotiation"
        ],
        "id": "negotiation-lead",
        "labelKey": "role.negotiation-lead.label",
        "searchTermKeys": []
      },
      {
        "descriptionKey": "role.obligation-owner.description",
        "domainWorkblockIds": [
          "contract-lifecycle-management"
        ],
        "id": "obligation-owner",
        "labelKey": "role.obligation-owner.label",
        "searchTermKeys": []
      },
      {
        "descriptionKey": "role.onboarding-coordinator.description",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk"
        ],
        "id": "onboarding-coordinator",
        "labelKey": "role.onboarding-coordinator.label",
        "searchTermKeys": []
      },
      {
        "descriptionKey": "role.payment-approver.description",
        "domainWorkblockIds": [
          "invoice-exception-payment-readiness"
        ],
        "id": "payment-approver",
        "labelKey": "role.payment-approver.label",
        "searchTermKeys": []
      },
      {
        "descriptionKey": "role.policy-owner.description",
        "domainWorkblockIds": [
          "strategy-policy-category-spend"
        ],
        "id": "policy-owner",
        "labelKey": "role.policy-owner.label",
        "searchTermKeys": [
          "role.policy-owner.search.procurement-policy-owner"
        ]
      },
      {
        "descriptionKey": "role.process-owner.description",
        "domainWorkblockIds": [
          "intake-demand"
        ],
        "id": "process-owner",
        "labelKey": "role.process-owner.label",
        "searchTermKeys": [
          "role.process-owner.search.process-policy-owner"
        ]
      },
      {
        "descriptionKey": "role.procurement-analyst.description",
        "domainWorkblockIds": [
          "strategy-policy-category-spend"
        ],
        "id": "procurement-analyst",
        "labelKey": "role.procurement-analyst.label",
        "searchTermKeys": []
      },
      {
        "descriptionKey": "role.procurement-buyer.description",
        "domainWorkblockIds": [
          "buying-ordering-receiving"
        ],
        "id": "procurement-buyer",
        "labelKey": "role.procurement-buyer.label",
        "searchTermKeys": []
      },
      {
        "descriptionKey": "role.receiver.description",
        "domainWorkblockIds": [
          "buying-ordering-receiving"
        ],
        "id": "receiver",
        "labelKey": "role.receiver.label",
        "searchTermKeys": [
          "role.receiver.search.service-owner"
        ]
      },
      {
        "descriptionKey": "role.relationship-manager.description",
        "domainWorkblockIds": [
          "supplier-performance-innovation-relationship"
        ],
        "id": "relationship-manager",
        "labelKey": "role.relationship-manager.label",
        "searchTermKeys": [
          "role.relationship-manager.search.supplier-relationship-manager"
        ]
      },
      {
        "descriptionKey": "role.requester.description",
        "domainWorkblockIds": [
          "intake-demand",
          "buying-ordering-receiving"
        ],
        "id": "requester",
        "labelKey": "role.requester.label",
        "searchTermKeys": [
          "role.requester.search.business-requester"
        ]
      },
      {
        "descriptionKey": "role.risk-owner.description",
        "domainWorkblockIds": [
          "invoice-exception-payment-readiness"
        ],
        "id": "risk-owner",
        "labelKey": "role.risk-owner.label",
        "searchTermKeys": [
          "role.risk-owner.search.fraud-sanctions-owner"
        ]
      },
      {
        "descriptionKey": "role.sourcing-lead.description",
        "domainWorkblockIds": [
          "sourcing-negotiation"
        ],
        "id": "sourcing-lead",
        "labelKey": "role.sourcing-lead.label",
        "searchTermKeys": []
      },
      {
        "descriptionKey": "role.sourcing-manager.description",
        "domainWorkblockIds": [
          "contract-lifecycle-management"
        ],
        "id": "sourcing-manager",
        "labelKey": "role.sourcing-manager.label",
        "searchTermKeys": []
      },
      {
        "descriptionKey": "role.supplier-account-lead.description",
        "domainWorkblockIds": [
          "supplier-performance-innovation-relationship"
        ],
        "id": "supplier-account-lead",
        "labelKey": "role.supplier-account-lead.label",
        "searchTermKeys": []
      },
      {
        "descriptionKey": "role.supplier-contact.description",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk"
        ],
        "id": "supplier-contact",
        "labelKey": "role.supplier-contact.label",
        "searchTermKeys": []
      },
      {
        "descriptionKey": "role.supplier-master-steward.description",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk"
        ],
        "id": "supplier-master-steward",
        "labelKey": "role.supplier-master-steward.label",
        "searchTermKeys": []
      },
      {
        "descriptionKey": "role.tprm-programme-owner.description",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk"
        ],
        "id": "tprm-programme-owner",
        "labelKey": "role.tprm-programme-owner.label",
        "searchTermKeys": [
          "role.tprm-programme-owner.search.third-party-risk"
        ]
      },
      {
        "descriptionKey": "role.treasury-manager.description",
        "domainWorkblockIds": [
          "invoice-exception-payment-readiness"
        ],
        "id": "treasury-manager",
        "labelKey": "role.treasury-manager.label",
        "searchTermKeys": [
          "role.treasury-manager.search.cash-manager"
        ]
      },
      {
        "descriptionKey": "role.value-lead.description",
        "domainWorkblockIds": [
          "value-realization-savings"
        ],
        "id": "value-lead",
        "labelKey": "role.value-lead.label",
        "searchTermKeys": [
          "role.value-lead.search.value-realisation-lead"
        ]
      }
    ],
    "standards": [
      {
        "exchangeTraversal": "format-required",
        "id": "ubl-2-4",
        "kind": "document-schema",
        "label": "OASIS Universal Business Language",
        "licence": {
          "id": "unresolved",
          "note": "Only the governed reference is published. Redistribution terms must be confirmed with the steward before standard or code-list content is packaged.",
          "status": "unresolved"
        },
        "redistributionPosture": "reference-only",
        "release": {
          "id": "2.4",
          "status": "verified"
        },
        "scope": "Canonical exchange mappings for parties, catalogues, sourcing, orders, fulfilment, invoices, credit notes and remittance. UBL projections do not replace internal authority, evidence or lifecycle records.",
        "status": "normative",
        "steward": {
          "organisation": "OASIS Open",
          "status": "verified"
        },
        "stewardshipHistory": [],
        "supersession": {
          "note": "Supersession is checked at each governed release review and is not inferred from an adapter pin.",
          "status": "review-required"
        },
        "version": "2.4"
      },
      {
        "exchangeTraversal": "format-required",
        "id": "peppol-bis-billing-3",
        "kind": "profile",
        "label": "Peppol BIS Billing",
        "licence": {
          "id": "unresolved",
          "note": "Only the governed reference is published. Redistribution terms must be confirmed with the steward before standard or code-list content is packaged.",
          "status": "unresolved"
        },
        "redistributionPosture": "reference-only",
        "release": {
          "id": "adapter-pinned",
          "status": "adapter-pinned"
        },
        "scope": "Profile and business rules for interoperable invoice and credit-note exchange; deployed jurisdiction/profile versions are pinned by adapter.",
        "status": "normative",
        "steward": {
          "organisation": "OpenPeppol",
          "status": "verified"
        },
        "stewardshipHistory": [],
        "supersession": {
          "note": "Supersession is checked at each governed release review and is not inferred from an adapter pin.",
          "status": "review-required"
        },
        "version": "3"
      },
      {
        "exchangeTraversal": "format-required",
        "id": "peppol-ordering-3",
        "kind": "profile",
        "label": "Peppol BIS Ordering",
        "licence": {
          "id": "unresolved",
          "note": "Only the governed reference is published. Redistribution terms must be confirmed with the steward before standard or code-list content is packaged.",
          "status": "unresolved"
        },
        "redistributionPosture": "reference-only",
        "release": {
          "id": "adapter-pinned",
          "status": "adapter-pinned"
        },
        "scope": "Order, order response, catalogue and despatch exchange profiles. Each configured adapter pins the exact OpenPeppol release and jurisdictional rules.",
        "status": "reference",
        "steward": {
          "organisation": "OpenPeppol",
          "status": "verified"
        },
        "stewardshipHistory": [],
        "supersession": {
          "note": "Supersession is checked at each governed release review and is not inferred from an adapter pin.",
          "status": "review-required"
        },
        "version": "adapter-pinned"
      },
      {
        "exchangeTraversal": "format-required",
        "id": "peppol-eas-iso-6523",
        "kind": "identifier-namespace",
        "label": "Peppol electronic address schemes and ISO 6523 identifiers",
        "licence": {
          "id": "unresolved",
          "note": "Only the governed reference is published. Redistribution terms must be confirmed with the steward before standard or code-list content is packaged.",
          "status": "unresolved"
        },
        "redistributionPosture": "reference-only",
        "release": {
          "id": "adapter-pinned",
          "status": "adapter-pinned"
        },
        "scope": "Scheme-qualified Peppol participant addressing. Electronic addresses remain distinct from tax identifiers and canonical party keys.",
        "status": "reference",
        "steward": {
          "organisation": "OpenPeppol",
          "status": "verified"
        },
        "stewardshipHistory": [],
        "supersession": {
          "note": "Supersession is checked at each governed release review and is not inferred from an adapter pin.",
          "status": "review-required"
        },
        "version": "adapter-pinned"
      },
      {
        "exchangeTraversal": "format-required",
        "id": "cxml-1-2-070",
        "kind": "document-schema",
        "label": "cXML",
        "licence": {
          "id": "unresolved",
          "note": "Only the governed reference is published. Redistribution terms must be confirmed with the steward before standard or code-list content is packaged.",
          "status": "unresolved"
        },
        "redistributionPosture": "reference-only",
        "release": {
          "id": "1.2.070",
          "status": "verified"
        },
        "scope": "Procurement document and PunchOut exchange where selected by the trading relationship. The adapter pins the exact DTD or guide release.",
        "status": "reference",
        "steward": {
          "organisation": "SAP",
          "status": "verified"
        },
        "stewardshipHistory": [],
        "supersession": {
          "note": "Supersession is checked at each governed release review and is not inferred from an adapter pin.",
          "status": "review-required"
        },
        "version": "1.2.070"
      },
      {
        "exchangeTraversal": "format-required",
        "id": "sap-idoc",
        "kind": "document-schema",
        "label": "SAP Intermediate Document",
        "licence": {
          "id": "unresolved",
          "note": "Only the governed reference is published. Redistribution terms must be confirmed with the steward before standard or code-list content is packaged.",
          "status": "unresolved"
        },
        "redistributionPosture": "reference-only",
        "release": {
          "id": "adapter-pinned",
          "status": "adapter-pinned"
        },
        "scope": "Document-first SAP exchange. Each client overlay pins message type, basic type, extensions, segments and installed SAP release.",
        "status": "reference",
        "steward": {
          "organisation": "SAP",
          "status": "verified"
        },
        "stewardshipHistory": [],
        "supersession": {
          "note": "Supersession is checked at each governed release review and is not inferred from an adapter pin.",
          "status": "review-required"
        },
        "version": "adapter-pinned"
      },
      {
        "exchangeTraversal": "format-required",
        "id": "edi-partner-agreement",
        "kind": "document-schema",
        "label": "Electronic data interchange partner agreement",
        "licence": {
          "id": "unresolved",
          "note": "Only the governed reference is published. Redistribution terms must be confirmed with the steward before standard or code-list content is packaged.",
          "status": "unresolved"
        },
        "redistributionPosture": "reference-only",
        "release": {
          "id": "partner-pinned",
          "status": "adapter-pinned"
        },
        "scope": "Trading-partner document exchange with the standard, transaction set or message, implementation guide and bilateral agreement pinned by the configured mapping.",
        "status": "reference",
        "steward": {
          "organisation": "Trading-partner agreement",
          "status": "verified"
        },
        "stewardshipHistory": [],
        "supersession": {
          "note": "Supersession is checked at each governed release review and is not inferred from an adapter pin.",
          "status": "review-required"
        },
        "version": "partner-pinned"
      },
      {
        "exchangeTraversal": "format-required",
        "id": "en-16931",
        "kind": "profile",
        "label": "European semantic e-invoicing model",
        "licence": {
          "id": "unresolved",
          "note": "Only the governed reference is published. Redistribution terms must be confirmed with the steward before standard or code-list content is packaged.",
          "status": "unresolved"
        },
        "redistributionPosture": "reference-only",
        "release": {
          "id": "en-16931",
          "status": "verified"
        },
        "scope": "Semantic invoice requirements and validation profiles at the e-invoicing boundary.",
        "status": "reference",
        "steward": {
          "organisation": "European Committee for Standardization",
          "status": "verified"
        },
        "stewardshipHistory": [],
        "supersession": {
          "note": "Supersession is checked at each governed release review and is not inferred from an adapter pin.",
          "status": "review-required"
        },
        "version": "EN 16931"
      },
      {
        "exchangeTraversal": "format-required",
        "id": "iso-20022",
        "kind": "message-schema",
        "label": "ISO 20022 financial messaging",
        "licence": {
          "id": "unresolved",
          "note": "Only the governed reference is published. Redistribution terms must be confirmed with the steward before standard or code-list content is packaged.",
          "status": "unresolved"
        },
        "redistributionPosture": "reference-only",
        "release": {
          "id": "adapter-pinned",
          "status": "adapter-pinned"
        },
        "scope": "Payment initiation, status and bank-statement messages only at the treasury or bank adapter boundary; not the procurement ledger model.",
        "status": "reference",
        "steward": {
          "organisation": "International Organisation for Standardization",
          "status": "verified"
        },
        "stewardshipHistory": [],
        "supersession": {
          "note": "Supersession is checked at each governed release review and is not inferred from an adapter pin.",
          "status": "review-required"
        },
        "version": "adapter-pinned"
      },
      {
        "exchangeTraversal": "format-required",
        "id": "iso-4217",
        "kind": "code-list",
        "label": "ISO 4217 currency codes",
        "licence": {
          "id": "unresolved",
          "note": "Only the governed reference is published. Redistribution terms must be confirmed with the steward before standard or code-list content is packaged.",
          "status": "unresolved"
        },
        "redistributionPosture": "reference-only",
        "release": {
          "id": "adapter-pinned",
          "status": "adapter-pinned"
        },
        "scope": "Currency identifiers paired with decimal monetary amounts.",
        "status": "reference",
        "steward": {
          "organisation": "International Organisation for Standardization",
          "status": "verified"
        },
        "stewardshipHistory": [],
        "supersession": {
          "note": "Supersession is checked at each governed release review and is not inferred from an adapter pin.",
          "status": "review-required"
        },
        "version": "current-provider-release"
      },
      {
        "exchangeTraversal": "format-required",
        "id": "iso-8601",
        "kind": "value-format",
        "label": "ISO 8601 date and time representation",
        "licence": {
          "id": "unresolved",
          "note": "Only the governed reference is published. Redistribution terms must be confirmed with the steward before standard or code-list content is packaged.",
          "status": "unresolved"
        },
        "redistributionPosture": "reference-only",
        "release": {
          "id": "iso-8601-1-2019",
          "status": "verified"
        },
        "scope": "Dates, timestamps, periods and temporal validity.",
        "status": "reference",
        "steward": {
          "organisation": "International Organisation for Standardization",
          "status": "verified"
        },
        "stewardshipHistory": [],
        "supersession": {
          "note": "Supersession is checked at each governed release review and is not inferred from an adapter pin.",
          "status": "review-required"
        },
        "version": "ISO 8601-1:2019"
      },
      {
        "exchangeTraversal": "format-required",
        "id": "unspsc",
        "kind": "code-list",
        "label": "United Nations Standard Products and Services Code",
        "licence": {
          "id": "unresolved",
          "note": "Only the governed reference is published. Redistribution terms must be confirmed with the steward before standard or code-list content is packaged.",
          "status": "unresolved"
        },
        "redistributionPosture": "reference-only",
        "release": {
          "id": "unresolved-release",
          "note": "The official current release remains unresolved because reviewed sources disagree. No release number is inferred.",
          "status": "unresolved"
        },
        "scope": "External category classifications alongside client-controlled taxonomies; never the canonical entity key.",
        "status": "reference",
        "steward": {
          "organisation": "United Nations Development Programme",
          "status": "verified"
        },
        "stewardshipHistory": [
          {
            "note": "UNDP retains the intellectual-property ownership recorded by the governed source review.",
            "organisation": "United Nations Development Programme",
            "role": "owner"
          },
          {
            "effectiveFrom": "2003",
            "effectiveTo": "2024",
            "organisation": "GS1 US",
            "role": "operating-manager"
          },
          {
            "effectiveFrom": "2025-01-01",
            "note": "Operational stewardship returned to UNDP on this date.",
            "organisation": "United Nations Development Programme",
            "role": "steward"
          }
        ],
        "supersession": {
          "note": "Supersession is checked at each governed release review and is not inferred from an adapter pin.",
          "status": "review-required"
        },
        "version": "source-pinned"
      },
      {
        "exchangeTraversal": "format-required",
        "id": "us-irs-ein",
        "kind": "identifier-namespace",
        "label": "US Employer Identification Number",
        "licence": {
          "id": "unresolved",
          "note": "Only the governed reference is published. Redistribution terms must be confirmed with the steward before standard or code-list content is packaged.",
          "status": "unresolved"
        },
        "redistributionPosture": "reference-only",
        "release": {
          "id": "jurisdiction-qualified",
          "status": "adapter-pinned"
        },
        "scope": "US party tax identification only. An EIN is not an electronic delivery address or the canonical party key.",
        "status": "reference",
        "steward": {
          "organisation": "United States Internal Revenue Service",
          "status": "verified"
        },
        "stewardshipHistory": [],
        "supersession": {
          "note": "Supersession is checked at each governed release review and is not inferred from an adapter pin.",
          "status": "review-required"
        },
        "version": "jurisdiction-qualified"
      },
      {
        "exchangeTraversal": "format-required",
        "id": "gs1-identifiers",
        "kind": "identifier-namespace",
        "label": "GS1 identification keys",
        "licence": {
          "id": "unresolved",
          "note": "Only the governed reference is published. Redistribution terms must be confirmed with the steward before standard or code-list content is packaged.",
          "status": "unresolved"
        },
        "redistributionPosture": "reference-only",
        "release": {
          "id": "source-pinned",
          "status": "adapter-pinned"
        },
        "scope": "Namespaced GLN, GTIN and related identifiers; verified identifiers remain attributes rather than canonical platform keys.",
        "status": "reference",
        "steward": {
          "organisation": "GS1",
          "status": "verified"
        },
        "stewardshipHistory": [],
        "supersession": {
          "note": "Supersession is checked at each governed release review and is not inferred from an adapter pin.",
          "status": "review-required"
        },
        "version": "source-pinned"
      },
      {
        "exchangeTraversal": "format-required",
        "id": "lei-17442",
        "kind": "identifier-namespace",
        "label": "Legal Entity Identifier",
        "licence": {
          "id": "unresolved",
          "note": "Only the governed reference is published. Redistribution terms must be confirmed with the steward before standard or code-list content is packaged.",
          "status": "unresolved"
        },
        "redistributionPosture": "reference-only",
        "release": {
          "id": "iso-17442",
          "status": "verified"
        },
        "scope": "Verified legal-entity identity namespace, not the canonical party key.",
        "status": "reference",
        "steward": {
          "organisation": "Global Legal Entity Identifier Foundation",
          "status": "verified"
        },
        "stewardshipHistory": [],
        "supersession": {
          "note": "Supersession is checked at each governed release review and is not inferred from an adapter pin.",
          "status": "review-required"
        },
        "version": "ISO 17442"
      },
      {
        "exchangeTraversal": "format-required",
        "id": "unece-rec-20-21",
        "kind": "code-list",
        "label": "UN/ECE unit codes",
        "licence": {
          "id": "unresolved",
          "note": "Only the governed reference is published. Redistribution terms must be confirmed with the steward before standard or code-list content is packaged.",
          "status": "unresolved"
        },
        "redistributionPosture": "reference-only",
        "release": {
          "id": "profile-pinned",
          "status": "adapter-pinned"
        },
        "scope": "Unit codes used by catalogue and business-document profiles. Each mapping pins the applicable code-list release.",
        "status": "reference",
        "steward": {
          "organisation": "United Nations Centre for Trade Facilitation and Electronic Business",
          "status": "verified"
        },
        "stewardshipHistory": [],
        "supersession": {
          "note": "Supersession is checked at each governed release review and is not inferred from an adapter pin.",
          "status": "review-required"
        },
        "version": "profile-pinned"
      },
      {
        "exchangeTraversal": "not-applicable",
        "id": "iso-20400",
        "kind": "guidance",
        "label": "ISO 20400 sustainable procurement guidance",
        "licence": {
          "id": "unresolved",
          "note": "Only the governed reference is published. Redistribution terms must be confirmed with the steward before standard or code-list content is packaged.",
          "status": "unresolved"
        },
        "redistributionPosture": "reference-only",
        "release": {
          "id": "iso-20400-2017",
          "status": "verified"
        },
        "scope": "Policy and operating-model concepts; no forced field-level transaction mapping.",
        "status": "reference",
        "steward": {
          "organisation": "International Organisation for Standardization",
          "status": "verified"
        },
        "stewardshipHistory": [],
        "supersession": {
          "note": "Supersession is checked at each governed release review and is not inferred from an adapter pin.",
          "status": "review-required"
        },
        "version": "ISO 20400:2017"
      },
      {
        "exchangeTraversal": "not-applicable",
        "id": "iso-44001",
        "kind": "guidance",
        "label": "ISO 44001 collaborative business relationships",
        "licence": {
          "id": "unresolved",
          "note": "Only the governed reference is published. Redistribution terms must be confirmed with the steward before standard or code-list content is packaged.",
          "status": "unresolved"
        },
        "redistributionPosture": "reference-only",
        "release": {
          "id": "iso-44001-2017",
          "status": "verified"
        },
        "scope": "Relationship-management concepts; supplier relationship records remain GroundWorks extensions.",
        "status": "reference",
        "steward": {
          "organisation": "International Organisation for Standardization",
          "status": "verified"
        },
        "stewardshipHistory": [],
        "supersession": {
          "note": "Supersession is checked at each governed release review and is not inferred from an adapter pin.",
          "status": "review-required"
        },
        "version": "ISO 44001:2017"
      },
      {
        "exchangeTraversal": "format-required",
        "id": "cpv",
        "kind": "code-list",
        "label": "Common Procurement Vocabulary",
        "licence": {
          "id": "unresolved",
          "note": "Only the governed reference is published. Redistribution terms must be confirmed with the steward before standard or code-list content is packaged.",
          "status": "unresolved"
        },
        "redistributionPosture": "reference-only",
        "release": {
          "id": "cpv-2008",
          "status": "verified"
        },
        "scope": "External classification for European public procurement. CPV codes remain linked attributes and never replace a company category ID.",
        "status": "reference",
        "steward": {
          "organisation": "European Union",
          "status": "verified"
        },
        "stewardshipHistory": [],
        "supersession": {
          "note": "Supersession is checked at each governed release review and is not inferred from an adapter pin.",
          "status": "review-required"
        },
        "version": "Regulation (EC) No 213/2008"
      },
      {
        "exchangeTraversal": "format-required",
        "id": "eclass",
        "kind": "code-list",
        "label": "ECLASS data standard",
        "licence": {
          "id": "unresolved",
          "note": "Only the governed reference is published. Redistribution terms must be confirmed with the steward before standard or code-list content is packaged.",
          "status": "unresolved"
        },
        "redistributionPosture": "reference-only",
        "release": {
          "id": "unresolved-release",
          "note": "The exact release remains unresolved until the official release source is verified. No release number is inferred.",
          "status": "unresolved"
        },
        "scope": "External product and service classification with a property dictionary. It remains linked to company categories and does not become the canonical category tree.",
        "status": "reference",
        "steward": {
          "organisation": "ECLASS e.V.",
          "status": "verified"
        },
        "stewardshipHistory": [],
        "supersession": {
          "note": "Supersession is checked at each governed release review and is not inferred from an adapter pin.",
          "status": "review-required"
        },
        "version": "unresolved-release"
      }
    ],
    "structuredValueSchemas": [
      {
        "definition": "A decimal amount paired with an ISO 4217 alphabetic currency code, the version of its business definition and an explicit rounding rule.",
        "id": "money-value",
        "label": "Money value",
        "schema": {
          "additionalProperties": false,
          "container": "object",
          "properties": [
            {
              "classification": "internal",
              "definition": "Amount is the decimal component carried within Money value; its classification and authority inherit from the owning field contract.",
              "id": "amount",
              "label": "Amount",
              "nullable": false,
              "required": true,
              "sourceAuthority": {
                "id": "money-value",
                "kind": "schema-definition"
              },
              "type": "decimal"
            },
            {
              "classification": "internal",
              "definition": "Currency code records the governed code within Money value without treating absence, unknown and zero as equivalent.",
              "format": "ISO 4217 alphabetic",
              "id": "currency-code",
              "label": "Currency code",
              "nullable": false,
              "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
              "required": true,
              "sourceAuthority": {
                "id": "money-value",
                "kind": "schema-definition"
              },
              "type": "string"
            },
            {
              "classification": "internal",
              "definition": "Semantic version of the owning monetary field definition used to interpret the amount.",
              "format": "semantic version",
              "id": "definition-version",
              "label": "Definition version",
              "nullable": false,
              "openVocabularyJustification": "The value is the owner-controlled semantic version of the field definition rather than a member of a cross-model closed vocabulary.",
              "required": true,
              "sourceAuthority": {
                "id": "money-value",
                "kind": "schema-definition"
              },
              "type": "string"
            },
            {
              "classification": "internal",
              "definition": "Deterministic rule applied when the amount is rounded; exact records declare that no rounding was applied.",
              "enumValues": [
                "exact",
                "half-even",
                "half-up",
                "half-down",
                "towards-zero",
                "away-from-zero",
                "towards-negative-infinity",
                "towards-positive-infinity"
              ],
              "id": "rounding-mode",
              "label": "Rounding mode",
              "nullable": false,
              "required": true,
              "sourceAuthority": {
                "id": "money-value",
                "kind": "schema-definition"
              },
              "type": "string"
            },
            {
              "classification": "internal",
              "definition": "Optional count of decimal places retained when the rounding mode was applied.",
              "id": "rounding-scale",
              "label": "Rounding scale",
              "nullable": true,
              "required": false,
              "sourceAuthority": {
                "id": "money-value",
                "kind": "schema-definition"
              },
              "type": "integer"
            },
            {
              "classification": "internal",
              "definition": "Optional smallest currency increment used by the rounding rule, expressed in the same currency as amount.",
              "id": "rounding-increment",
              "label": "Rounding increment",
              "nullable": true,
              "required": false,
              "sourceAuthority": {
                "id": "money-value",
                "kind": "schema-definition"
              },
              "type": "decimal"
            }
          ]
        },
        "version": "2.0.0"
      },
      {
        "definition": "A decimal quantity paired with a governed unit code. Positivity, precision, conversions and acceptable unit vocabularies remain governed by the owning business field.",
        "id": "quantity-value",
        "label": "Quantity value",
        "schema": {
          "additionalProperties": false,
          "container": "object",
          "properties": [
            {
              "classification": "internal",
              "definition": "Value is the decimal component carried within Quantity value; its classification and authority inherit from the owning field contract.",
              "id": "value",
              "label": "Value",
              "nullable": false,
              "required": true,
              "sourceAuthority": {
                "id": "quantity-value",
                "kind": "schema-definition"
              },
              "type": "decimal"
            },
            {
              "classification": "internal",
              "definition": "Unit code records the governed code within Quantity value without treating absence, unknown and zero as equivalent.",
              "format": "governed unit code",
              "id": "unit-code",
              "label": "Unit code",
              "nullable": false,
              "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
              "required": true,
              "sourceAuthority": {
                "id": "quantity-value",
                "kind": "schema-definition"
              },
              "type": "string"
            }
          ]
        },
        "version": "1.0.0"
      },
      {
        "definition": "A bounded effective or observation period with explicit boundary semantics; an absent end is open-ended rather than unknown.",
        "id": "period-value",
        "label": "Period value",
        "schema": {
          "additionalProperties": false,
          "container": "object",
          "properties": [
            {
              "classification": "internal",
              "definition": "Inclusive start of the governed period.",
              "id": "starts-at",
              "label": "Starts at",
              "nullable": false,
              "required": true,
              "sourceAuthority": {
                "id": "period-value",
                "kind": "schema-definition"
              },
              "type": "timestamp"
            },
            {
              "classification": "internal",
              "definition": "End of the governed period when bounded; null means deliberately open-ended.",
              "id": "ends-at",
              "label": "Ends at",
              "nullable": true,
              "required": false,
              "sourceAuthority": {
                "id": "period-value",
                "kind": "schema-definition"
              },
              "type": "timestamp"
            },
            {
              "classification": "internal",
              "definition": "Whether ends-at is included in or excluded from the period.",
              "enumValues": [
                "inclusive",
                "exclusive"
              ],
              "id": "end-boundary",
              "label": "End boundary",
              "nullable": false,
              "required": true,
              "sourceAuthority": {
                "id": "period-value",
                "kind": "schema-definition"
              },
              "type": "string"
            },
            {
              "classification": "internal",
              "definition": "IANA timezone used when the source does not carry an absolute instant.",
              "id": "timezone",
              "label": "Timezone",
              "nullable": true,
              "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
              "required": false,
              "sourceAuthority": {
                "id": "period-value",
                "kind": "schema-definition"
              },
              "type": "string"
            }
          ]
        },
        "version": "1.0.0"
      },
      {
        "definition": "A source or authority-issued identifier qualified by scheme, issuer, originating system and effective dates.",
        "id": "external-identifier-value",
        "label": "External identifier value",
        "schema": {
          "additionalProperties": false,
          "container": "object-list",
          "properties": [
            {
              "classification": "internal",
              "definition": "Governed identifier-scheme ID.",
              "id": "scheme-id",
              "label": "Scheme ID",
              "nullable": false,
              "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
              "required": true,
              "sourceAuthority": {
                "id": "external-identifier-value",
                "kind": "schema-definition"
              },
              "type": "string"
            },
            {
              "classification": "internal",
              "definition": "Identifier exactly as issued, without display normalisation.",
              "id": "identifier-value",
              "label": "Identifier value",
              "nullable": false,
              "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
              "required": true,
              "sourceAuthority": {
                "id": "external-identifier-value",
                "kind": "schema-definition"
              },
              "type": "string"
            },
            {
              "classification": "internal",
              "definition": "Issuing authority or organisation ID when known.",
              "id": "issuer-id",
              "label": "Issuer ID",
              "nullable": true,
              "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
              "required": false,
              "sourceAuthority": {
                "id": "external-identifier-value",
                "kind": "schema-definition"
              },
              "type": "string"
            },
            {
              "classification": "internal",
              "definition": "Originating system role or profile ID when the identifier was observed through an integration.",
              "id": "source-system-id",
              "label": "Source system ID",
              "nullable": true,
              "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
              "required": false,
              "sourceAuthority": {
                "id": "external-identifier-value",
                "kind": "schema-definition"
              },
              "type": "string"
            },
            {
              "classification": "internal",
              "definition": "First date on which the identifier is valid.",
              "id": "valid-from",
              "label": "Valid from",
              "nullable": true,
              "required": false,
              "sourceAuthority": {
                "id": "external-identifier-value",
                "kind": "schema-definition"
              },
              "type": "date"
            },
            {
              "classification": "internal",
              "definition": "Last date on which the identifier is valid; null means no stated end.",
              "id": "valid-to",
              "label": "Valid to",
              "nullable": true,
              "required": false,
              "sourceAuthority": {
                "id": "external-identifier-value",
                "kind": "schema-definition"
              },
              "type": "date"
            }
          ],
          "uniqueBy": [
            "scheme-id",
            "identifier-value"
          ]
        },
        "version": "1.0.0"
      },
      {
        "definition": "A code in a governed external classification scheme, pinned to a release without replacing the canonical company category ID.",
        "id": "external-classification-value",
        "label": "External classification value",
        "schema": {
          "additionalProperties": false,
          "container": "object-list",
          "properties": [
            {
              "classification": "internal",
              "definition": "Governed external classification scheme ID.",
              "id": "scheme-id",
              "label": "Scheme ID",
              "nullable": false,
              "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
              "required": true,
              "sourceAuthority": {
                "id": "external-classification-value",
                "kind": "schema-definition"
              },
              "type": "string"
            },
            {
              "classification": "internal",
              "definition": "Exact governed release or explicit unresolved-release ID.",
              "id": "scheme-release-id",
              "label": "Scheme release ID",
              "nullable": false,
              "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
              "required": true,
              "sourceAuthority": {
                "id": "external-classification-value",
                "kind": "schema-definition"
              },
              "type": "string"
            },
            {
              "classification": "internal",
              "definition": "Code exactly as published by the scheme steward.",
              "id": "classification-code",
              "label": "Classification code",
              "nullable": false,
              "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
              "required": true,
              "sourceAuthority": {
                "id": "external-classification-value",
                "kind": "schema-definition"
              },
              "type": "string"
            },
            {
              "classification": "internal",
              "definition": "Display label from the pinned scheme release when redistribution is permitted.",
              "id": "classification-label",
              "label": "Classification label",
              "nullable": true,
              "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
              "required": false,
              "sourceAuthority": {
                "id": "external-classification-value",
                "kind": "schema-definition"
              },
              "type": "string"
            },
            {
              "classification": "internal",
              "definition": "System role or profile through which the mapping was observed.",
              "id": "source-system-id",
              "label": "Source system ID",
              "nullable": true,
              "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
              "required": false,
              "sourceAuthority": {
                "id": "external-classification-value",
                "kind": "schema-definition"
              },
              "type": "string"
            },
            {
              "classification": "internal",
              "definition": "Date from which this mapping applies.",
              "id": "effective-from",
              "label": "Effective from",
              "nullable": true,
              "required": false,
              "sourceAuthority": {
                "id": "external-classification-value",
                "kind": "schema-definition"
              },
              "type": "date"
            }
          ],
          "uniqueBy": [
            "scheme-id",
            "scheme-release-id",
            "classification-code"
          ]
        },
        "version": "1.0.0"
      },
      {
        "definition": "A typed reference to a governed entity record and optional record version; it is not a free-text locator.",
        "id": "record-reference-value",
        "label": "Record reference value",
        "schema": {
          "additionalProperties": false,
          "container": "object",
          "properties": [
            {
              "classification": "internal",
              "definition": "Stable GroundWorks entity ID for the referenced record.",
              "id": "entity-id",
              "label": "Entity ID",
              "nullable": false,
              "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
              "required": true,
              "sourceAuthority": {
                "id": "record-reference-value",
                "kind": "schema-definition"
              },
              "type": "string"
            },
            {
              "classification": "internal",
              "definition": "Stable record identifier within the referenced entity type.",
              "id": "record-id",
              "label": "Record ID",
              "nullable": false,
              "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
              "required": true,
              "sourceAuthority": {
                "id": "record-reference-value",
                "kind": "schema-definition"
              },
              "type": "string"
            },
            {
              "classification": "internal",
              "definition": "Exact optimistic-concurrency or immutable record version when a particular version is required.",
              "id": "record-version",
              "label": "Record version",
              "nullable": true,
              "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
              "required": false,
              "sourceAuthority": {
                "id": "record-reference-value",
                "kind": "schema-definition"
              },
              "type": "string"
            }
          ]
        },
        "version": "1.0.0"
      },
      {
        "definition": "The typed scope predicate a data grant or data access request may name. Scope values come from a closed per-record-type list and declare whether they compile to a relationship tuple or to residue evaluation; free-form query text is never a scope. The widest kind, all, is relationship-shaped: it compiles to a relationship tuple over the whole governed record set for the record type and names no anchor.",
        "id": "access-scope-value",
        "label": "Access scope value",
        "schema": {
          "additionalProperties": false,
          "container": "object",
          "properties": [
            {
              "classification": "confidential",
              "definition": "Closed scope predicate over the governed record set. The widest kind, all, reaches every record of the type; every narrower kind names the anchor or named query it resolves against.",
              "enumValues": [
                "all",
                "owned-by",
                "business-unit",
                "category-branch",
                "single-record",
                "record-set"
              ],
              "id": "scope-kind",
              "label": "Scope kind",
              "nullable": false,
              "required": true,
              "sourceAuthority": {
                "id": "access-scope-value",
                "kind": "schema-definition"
              },
              "type": "string"
            },
            {
              "classification": "confidential",
              "definition": "Where the scope is decided: relationship-shaped scopes compile to authorization tuples, attribute-dependent scopes compile to residue evaluation.",
              "enumValues": [
                "relationship-tuple",
                "residue"
              ],
              "id": "compile-class",
              "label": "Compile class",
              "nullable": false,
              "required": true,
              "sourceAuthority": {
                "id": "access-scope-value",
                "kind": "schema-definition"
              },
              "type": "string"
            },
            {
              "classification": "confidential",
              "definition": "Governed key the scope resolves against: the business unit, category node or single record named by scope-kind. Empty for all, which needs no anchor because it reaches the whole governed record set, and for owned-by, which resolves to the actor.",
              "format": "governed record or node key",
              "id": "scope-anchor",
              "label": "Scope anchor",
              "nullable": true,
              "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
              "required": false,
              "sourceAuthority": {
                "id": "access-scope-value",
                "kind": "schema-definition"
              },
              "type": "string"
            },
            {
              "classification": "confidential",
              "definition": "Governed named-query identifier bounding a record-set scope. Free-form query text is forbidden.",
              "format": "GroundWorks named-query ID",
              "id": "named-query-id",
              "label": "Named query ID",
              "nullable": true,
              "openVocabularyJustification": "Open source or domain vocabulary is retained because the owning field contract, format and authority constrain interpretation.",
              "required": false,
              "sourceAuthority": {
                "id": "access-scope-value",
                "kind": "schema-definition"
              },
              "type": "string"
            },
            {
              "classification": "confidential",
              "definition": "Whether the scope inherits down the governed hierarchy by nearest ancestor or applies only at the named node.",
              "enumValues": [
                "none",
                "nearest-ancestor"
              ],
              "id": "inheritance",
              "label": "Inheritance",
              "nullable": false,
              "required": true,
              "sourceAuthority": {
                "id": "access-scope-value",
                "kind": "schema-definition"
              },
              "type": "string"
            }
          ]
        },
        "version": "1.0.0"
      }
    ],
    "systemAliases": [
      {
        "id": "all-authorised-sources",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "evidence-source"
      },
      {
        "id": "analytics-warehouse",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "analytical-system"
      },
      {
        "id": "approval-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "authority-registry",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "identity-authority"
      },
      {
        "id": "blob-store",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "evidence-source"
      },
      {
        "id": "budget-platform",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "planning-system"
      },
      {
        "id": "budget-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "planning-system"
      },
      {
        "id": "capacity-plan",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "planning-system"
      },
      {
        "id": "carrier-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "transport-execution-boundary"
      },
      {
        "id": "catalogue",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "source-of-record"
      },
      {
        "id": "catalogue-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "category-strategy-ledger",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "category-taxonomy",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "certification-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "identity-authority"
      },
      {
        "id": "clause-library",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "communications-adapter",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "collaboration-channel"
      },
      {
        "id": "content-repository",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "evidence-source"
      },
      {
        "id": "contract",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "contract-adapter",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "contract-ledger",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "contract-repository",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "contract-request-channel",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "collaboration-channel"
      },
      {
        "id": "control-evidence-repository",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "evidence-source"
      },
      {
        "id": "control-library",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "evidence-source"
      },
      {
        "id": "demand-ledger",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "demand-portfolio",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "planning-system"
      },
      {
        "id": "document-editor",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "collaboration-channel"
      },
      {
        "id": "document-management",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "source-of-record"
      },
      {
        "id": "document-repository",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "electronic-data-interchange",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "analytical-system"
      },
      {
        "id": "electronic-signature-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "enterprise-resource-planning",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "planning-system"
      },
      {
        "id": "erp",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "commitment-system"
      },
      {
        "id": "evaluation-runtime",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "analytical-system"
      },
      {
        "id": "evaluation-workbook",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "analytical-system"
      },
      {
        "id": "evidence-repository",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "evidence-source"
      },
      {
        "id": "exception-management",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "source-of-record"
      },
      {
        "id": "expense-platform",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "finance-control-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "finance-ledger-adapter",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "finance-plan-adapter",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "finance-statement-adapter",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "analytical-system"
      },
      {
        "id": "forecast-platform",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "planning-system"
      },
      {
        "id": "framework-repository",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "groundworks-job-registry",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "groundworks-role-registry",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "guided-buying-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "hr-directory",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "identity-authority"
      },
      {
        "id": "identity-and-role-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "identity-authority"
      },
      {
        "id": "identity-provider",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "identity-authority"
      },
      {
        "id": "identity-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "identity-authority"
      },
      {
        "id": "identity-verification-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "identity-authority"
      },
      {
        "id": "initiative-ledger",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "planning-system"
      },
      {
        "id": "innovation-ledger",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "intake-ledger",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "integration-adapters",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "integration-registry",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "integration-runtime",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "internal-event-stream",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "inventory-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "transport-execution-boundary"
      },
      {
        "id": "invoice-capture-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "invoice-exchange-response-adapter",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "invoice-ledger",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "invoice-matching-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "invoice-platform",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "item-master",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "learning-data",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "analytical-system"
      },
      {
        "id": "legal-entity-registry",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "identity-authority"
      },
      {
        "id": "logistics-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "transport-execution-boundary"
      },
      {
        "id": "market-evidence-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "evidence-source"
      },
      {
        "id": "market-intelligence-feed",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "evidence-source"
      },
      {
        "id": "messaging-channel",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "collaboration-channel"
      },
      {
        "id": "office-artifact",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "source-of-record"
      },
      {
        "id": "operational-measure-services",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "ordering-adapter",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "organisational-directory",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "identity-authority"
      },
      {
        "id": "outcome-reconciliation",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "analytical-system"
      },
      {
        "id": "owner-domain-adapters",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "payment-execution-guard",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "payment-or-settlement-rail"
      },
      {
        "id": "payment-network-adapter",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "payment-or-settlement-rail"
      },
      {
        "id": "payment-status-adapter",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "payment-or-settlement-rail"
      },
      {
        "id": "payment-warehouse",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "payment-or-settlement-rail"
      },
      {
        "id": "performance-ledger",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "analytical-system"
      },
      {
        "id": "policy-registry",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "policy-repository",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "policy-runtime",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "policy-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "portfolio-planning-system",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "planning-system"
      },
      {
        "id": "procurement-request-channel",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "collaboration-channel"
      },
      {
        "id": "project-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "planning-system"
      },
      {
        "id": "purchase-order-platform",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "purchase-order-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "quality-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "receiving-adapter",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "transport-execution-boundary"
      },
      {
        "id": "receiving-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "transport-execution-boundary"
      },
      {
        "id": "regulatory-reference-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "relationship-ledger",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "remittance-adapter",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "payment-or-settlement-rail"
      },
      {
        "id": "requisition-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "risk-case-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "risk-control-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "risk-data-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "analytical-system"
      },
      {
        "id": "risk-ledger",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "risk-monitoring-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "risk-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "screening-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "identity-authority"
      },
      {
        "id": "service-catalogue",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "service-design-repository",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "service-management-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "shipment-data-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "transport-execution-boundary"
      },
      {
        "id": "sourcing-channel",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "collaboration-channel"
      },
      {
        "id": "sourcing-ledger",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "sourcing-pipeline",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "source-of-record"
      },
      {
        "id": "sourcing-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "sourcing-suite",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "source-of-record"
      },
      {
        "id": "spend-analytics",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "analytical-system"
      },
      {
        "id": "spend-and-category-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "analytical-system"
      },
      {
        "id": "spend-ledger",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "analytical-system"
      },
      {
        "id": "structured-invoice-exchange",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "supplier-collaboration-adapter",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "collaboration-channel"
      },
      {
        "id": "supplier-disclosure",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "managed-network"
      },
      {
        "id": "supplier-governance-ledger",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "supplier-ledgers",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "supplier-master",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "supplier-master-adapter",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "supplier-network",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "managed-network"
      },
      {
        "id": "supplier-performance-ledger",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "analytical-system"
      },
      {
        "id": "supplier-performance-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "analytical-system"
      },
      {
        "id": "supplier-portal",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "source-of-record"
      },
      {
        "id": "supplier-profile-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "supplier-registry",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "supplier-review-ledger",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "supplier-risk-ledger",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "system-of-record"
      },
      {
        "id": "supplier-risk-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "supply-network-data-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "analytical-system"
      },
      {
        "id": "third-party-risk-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "time-recording-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "value-attribution-ledger",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "analytical-system"
      },
      {
        "id": "value-leakage-ledger",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "analytical-system"
      },
      {
        "id": "value-ledger",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "analytical-system"
      },
      {
        "id": "value-portfolio-ledger",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "analytical-system"
      },
      {
        "id": "value-portfolio-projection",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "analytical-system"
      },
      {
        "id": "verification-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "identity-authority"
      },
      {
        "id": "warehouse-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "transport-execution-boundary"
      },
      {
        "id": "work-management-service",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "collaboration-channel"
      },
      {
        "id": "work-orchestration",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "workblock-event-bus",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      },
      {
        "id": "workblock-runtime",
        "rationale": "Legacy system token resolves through a governed integration role; exact installed products remain tenant configuration.",
        "systemRoleId": "execution-system"
      }
    ],
    "versioningPolicy": "The registry uses semantic versioning. Additive compatible entities, fields or mappings increment MINOR; editorial corrections increment PATCH; changes to keys, meaning, ownership, requiredness, cardinality or access increment MAJOR. Every field and relationship records its introduction, and migrations use expand, backfill, validate and contract with an explicit rollback reference.",
    "vocabulary": [
      {
        "aliases": [
          "canonical entity"
        ],
        "definition": "The governed representation that owns the current meaning of an entity inside the platform boundary; source systems may remain authoritative for originating facts.",
        "id": "canonical-record",
        "introducedIn": "1.0.0",
        "term": "Canonical record"
      },
      {
        "aliases": [
          "read model"
        ],
        "definition": "A query- or task-derived view of canonical or source records optimised for a consumer, carrying freshness and last-good behaviour.",
        "id": "projection",
        "introducedIn": "1.0.0",
        "term": "Projection"
      },
      {
        "aliases": [
          "source ref"
        ],
        "definition": "A stable pointer to the originating system, object, record, version and observed time used to preserve lineage without duplicating source payloads.",
        "id": "source-record-reference",
        "introducedIn": "1.0.0",
        "term": "Source record reference"
      },
      {
        "aliases": [
          "evidence"
        ],
        "definition": "A referenced fact, file, observation or policy excerpt with source, time, integrity and access metadata that can support a decision or action.",
        "id": "evidence-item",
        "introducedIn": "1.0.0",
        "term": "Evidence item"
      },
      {
        "aliases": [
          "lineage"
        ],
        "definition": "The trace of where a record or assertion came from, what transformed it, which versions were active and who or what committed it.",
        "id": "provenance",
        "introducedIn": "1.0.0",
        "term": "Provenance"
      },
      {
        "aliases": [
          "data recency"
        ],
        "definition": "The age and validity of displayed evidence relative to its named update contract; stale data remains visible as last-good when safe.",
        "id": "freshness",
        "introducedIn": "1.0.0",
        "term": "Freshness"
      },
      {
        "aliases": [
          "last-good data"
        ],
        "definition": "The most recent usable projection retained after a failed or empty refresh, always shown with its actual freshness and source health.",
        "id": "last-good",
        "introducedIn": "1.0.0",
        "term": "Last-good state"
      },
      {
        "aliases": [
          "proposal"
        ],
        "definition": "A machine- or person-prepared action that has not crossed its commitment boundary and can become stale, be changed or be declined.",
        "id": "action-proposal",
        "introducedIn": "1.0.0",
        "term": "Action proposal"
      },
      {
        "aliases": [
          "commitment"
        ],
        "definition": "An action whose authority and side effect have been confirmed, with downstream reconciliation and recovery state preserved.",
        "id": "committed-action",
        "introducedIn": "1.0.0",
        "term": "Committed action"
      },
      {
        "aliases": [
          "authority grant",
          "autonomy envelope"
        ],
        "definition": "A versioned grant defining allowed verbs, records, tools, thresholds, evidence, duration, monitoring, escalation and stop conditions for named actions that may commit without per-item approval.",
        "id": "authority-envelope",
        "introducedIn": "1.0.0",
        "term": "Authority envelope"
      },
      {
        "aliases": [
          "policy autonomy"
        ],
        "definition": "Agent execution without per-item review inside an authority envelope, with critic checks, sampling, reconciliation, demotion, kill switch and rollback.",
        "id": "bounded-autonomy",
        "introducedIn": "1.0.0",
        "term": "Bounded autonomy"
      },
      {
        "aliases": [
          "supervision"
        ],
        "definition": "People define policy and authority, inspect performance and sampled actions, handle true exceptions and retain interruption rights rather than reviewing every routine item.",
        "id": "human-supervision",
        "introducedIn": "1.0.0",
        "term": "Human supervision"
      },
      {
        "aliases": [
          "escalation gate"
        ],
        "definition": "A deliberate stop for a consequential, ambiguous, novel or policy-triggering case outside the active authority envelope.",
        "id": "exception-gate",
        "introducedIn": "1.0.0",
        "term": "Exception gate"
      },
      {
        "aliases": [
          "evaluator check"
        ],
        "definition": "An independent deterministic or model-based evaluation applied before or after an agent action; it cannot use the same model self-explanation as audit evidence.",
        "id": "critic-check",
        "introducedIn": "1.0.0",
        "term": "Critic check"
      },
      {
        "aliases": [
          "corrected example"
        ],
        "definition": "A validated correction or reconciled outcome linked to the exact input, policy, model, prompt, Workblock and schema versions used for evaluation.",
        "id": "learning-example",
        "introducedIn": "1.0.0",
        "term": "Learning example"
      },
      {
        "aliases": [
          "promotion"
        ],
        "definition": "An explicit versioned decision to widen an action class after shadow, canary and outcome evidence meet the declared bar.",
        "id": "promotion",
        "introducedIn": "1.0.0",
        "term": "Autonomy promotion"
      },
      {
        "aliases": [
          "demotion"
        ],
        "definition": "A narrowing to proposal-only or supervised execution when evidence, source health, drift, policy or outcome controls breach their bounds.",
        "id": "demotion",
        "introducedIn": "1.0.0",
        "term": "Autonomy demotion"
      },
      {
        "aliases": [
          "stop control"
        ],
        "definition": "A scoped control that blocks new mutating actions and revokes tools or grants while preserving state, audit and last-good evidence.",
        "id": "kill-switch",
        "introducedIn": "1.0.0",
        "term": "Kill switch"
      },
      {
        "aliases": [
          "version rollback"
        ],
        "definition": "Restoration of a last-approved Workblock, policy, model, prompt, mapping or schema projection plus reconciliation of any partial external effects.",
        "id": "rollback",
        "introducedIn": "1.0.0",
        "term": "Rollback"
      },
      {
        "aliases": [],
        "definition": "A modular, versioned task graph with explicit entrypoints, data contracts, agents, authority, telemetry and one bounded system-of-work outcome.",
        "id": "workblock",
        "introducedIn": "1.0.0",
        "term": "Workblock"
      },
      {
        "aliases": [
          "governed role agent"
        ],
        "definition": "A role-scoped agent that pursues a bounded role mission through narrow typed Workblock tools and inherits the active user, tenant and authority scope.",
        "id": "persona-agent",
        "introducedIn": "1.0.0",
        "term": "Role agent"
      },
      {
        "aliases": [
          "schema release"
        ],
        "definition": "An immutable version of the canonical entity, field, relationship and standard-mapping contracts used by Workblocks and projections.",
        "id": "registry-release",
        "introducedIn": "1.0.0",
        "term": "Registry release"
      },
      {
        "aliases": [
          "record envelope"
        ],
        "definition": "The composed, versioned metadata carried by every canonical record for business identity, concurrency, schema, effective time, freshness, last-good state, writer compatibility, authority, provenance and qualified execution trace.",
        "id": "ledger-record-envelope",
        "introducedIn": "2.0.0",
        "term": "Ledger record envelope"
      },
      {
        "aliases": [
          "service owner"
        ],
        "definition": "A named shared-ledger service with the sole right to commit its canonical entities; Workblocks cross the boundary through typed commands, queries or events.",
        "id": "platform-service-owner",
        "introducedIn": "2.0.0",
        "term": "Platform service owner"
      },
      {
        "aliases": [
          "typed owner command"
        ],
        "definition": "A versioned, authority-bound and idempotent request submitted to another canonical owner, which decides and reconciles the mutation rather than permitting a direct cross-owner write.",
        "id": "owner-command",
        "introducedIn": "2.0.0",
        "term": "Owner command"
      },
      {
        "aliases": [
          "value schema"
        ],
        "definition": "A closed, versioned contract for an object or object list, including explicit properties, requiredness, nullability, list semantics, nested bindings and external component mappings.",
        "id": "structured-value-schema",
        "introducedIn": "2.0.0",
        "term": "Structured value schema"
      },
      {
        "aliases": [],
        "definition": "A person, organisation or other accountable economic actor with stable identity across transactions and relationships.",
        "id": "kind-party",
        "introducedIn": "3.4.0",
        "term": "Party"
      },
      {
        "aliases": [],
        "definition": "A governed responsibility and authority classification that can be assigned to people for an effective period.",
        "id": "kind-role",
        "introducedIn": "3.4.0",
        "term": "Role"
      },
      {
        "aliases": [],
        "definition": "A relatively stable governed definition, code, taxonomy or version used by other records.",
        "id": "kind-reference",
        "introducedIn": "3.4.0",
        "term": "Reference record"
      },
      {
        "aliases": [],
        "definition": "An economic or process fact whose value, parties, time and source remain auditable.",
        "id": "kind-transaction",
        "introducedIn": "3.4.0",
        "term": "Transaction record"
      },
      {
        "aliases": [],
        "definition": "A managed request, issue, exception or opportunity that advances through a declared lifecycle.",
        "id": "kind-case",
        "introducedIn": "3.4.0",
        "term": "Case record"
      },
      {
        "aliases": [],
        "definition": "Structured metadata for an authored or received business artifact, with content retained through evidence references.",
        "id": "kind-document",
        "introducedIn": "3.4.0",
        "term": "Document record"
      },
      {
        "aliases": [],
        "definition": "An authority-bearing choice that preserves subject, actor, rationale, evidence and effective time.",
        "id": "kind-decision",
        "introducedIn": "3.4.0",
        "term": "Decision record"
      },
      {
        "aliases": [],
        "definition": "A governed evaluation of evidence against named criteria, distinct from the decision that may follow.",
        "id": "kind-assessment",
        "introducedIn": "3.4.0",
        "term": "Assessment record"
      },
      {
        "aliases": [],
        "definition": "An immutable past-tense fact published after an owned state transition; replay never changes the original fact.",
        "id": "kind-event",
        "introducedIn": "3.4.0",
        "term": "Event record"
      },
      {
        "aliases": [],
        "definition": "An effective-dated relationship between governed records, with authority, provenance and supersession.",
        "id": "kind-assignment",
        "introducedIn": "3.4.0",
        "term": "Assignment record"
      },
      {
        "aliases": [],
        "definition": "A governed measure or result with definition version, inputs, period, unit, freshness and drill-through.",
        "id": "kind-metric",
        "introducedIn": "3.4.0",
        "term": "Metric record"
      },
      {
        "aliases": [],
        "definition": "A policy, rule, plan or authority boundary that constrains or evaluates procurement action.",
        "id": "kind-control",
        "introducedIn": "3.4.0",
        "term": "Control record"
      },
      {
        "aliases": [],
        "definition": "Retain while the governed definition is active and through its supersession and audit period.",
        "id": "retention-reference",
        "introducedIn": "3.4.0",
        "term": "Reference retention"
      },
      {
        "aliases": [],
        "definition": "Retain for the active operating lifecycle and its governed audit and deletion period.",
        "id": "retention-operational",
        "introducedIn": "3.4.0",
        "term": "Operational retention"
      },
      {
        "aliases": [],
        "definition": "Retain according to the applicable financial, tax and audit obligation.",
        "id": "retention-financial",
        "introducedIn": "3.4.0",
        "term": "Financial retention"
      },
      {
        "aliases": [],
        "definition": "Retain as immutable decision or action evidence subject to legal hold and downstream deletion duties.",
        "id": "retention-evidence",
        "introducedIn": "3.4.0",
        "term": "Evidence retention"
      },
      {
        "aliases": [],
        "definition": "Retain every effective policy version needed to reproduce a governed decision or action.",
        "id": "retention-policy",
        "introducedIn": "3.4.0",
        "term": "Policy retention"
      },
      {
        "aliases": [],
        "definition": "Framework information approved for the published Accenture GroundWorks projection.",
        "id": "classification-public",
        "introducedIn": "3.4.0",
        "term": "Public data"
      },
      {
        "aliases": [],
        "definition": "Information available only to authorised internal audiences and excluded from the public projection.",
        "id": "classification-internal",
        "introducedIn": "3.4.0",
        "term": "Internal data"
      },
      {
        "aliases": [],
        "definition": "Business information restricted by tenant, company, purpose and authorised role.",
        "id": "classification-confidential",
        "introducedIn": "3.4.0",
        "term": "Confidential data"
      },
      {
        "aliases": [],
        "definition": "Information about an identifiable person with purpose, retention and field-level access controls.",
        "id": "classification-personal",
        "introducedIn": "3.4.0",
        "term": "Personal data"
      },
      {
        "aliases": [],
        "definition": "Highly constrained information whose read, export and mutation require explicit authority.",
        "id": "classification-restricted",
        "introducedIn": "3.4.0",
        "term": "Restricted data"
      },
      {
        "aliases": [],
        "definition": "No authorised value can currently be resolved; it is not a default, zero or catch-all member.",
        "id": "unresolved-state",
        "introducedIn": "3.4.0",
        "term": "Unresolved state"
      },
      {
        "aliases": [],
        "definition": "A value exists conceptually but is not known from the available authorised evidence.",
        "id": "unknown-state",
        "introducedIn": "3.4.0",
        "term": "Unknown state"
      },
      {
        "aliases": [],
        "definition": "The concept does not apply to this record under its governed definition.",
        "id": "not-applicable-state",
        "introducedIn": "3.4.0",
        "term": "Not applicable state"
      },
      {
        "aliases": [],
        "definition": "A known value is deliberately not disclosed to this audience or purpose.",
        "id": "withheld-state",
        "introducedIn": "3.4.0",
        "term": "Withheld state"
      },
      {
        "aliases": [],
        "definition": "The last-good value remains visible but has exceeded its declared freshness contract.",
        "id": "stale-state",
        "introducedIn": "3.4.0",
        "term": "Stale state"
      },
      {
        "aliases": [],
        "definition": "A measured numeric value of zero; it is distinct from missing, unknown, withheld and not applicable.",
        "id": "zero-value",
        "introducedIn": "3.4.0",
        "term": "Zero value"
      },
      {
        "aliases": [],
        "definition": "A successor fact that repairs an earlier committed value without deleting its history.",
        "id": "correction",
        "introducedIn": "3.4.0",
        "term": "Correction"
      },
      {
        "aliases": [],
        "definition": "A new authorised fact that counteracts a prior commitment while preserving both records.",
        "id": "reversal",
        "introducedIn": "3.4.0",
        "term": "Reversal"
      }
    ]
  },
  "identity": {
    "ownershipKey": "identity.ownership",
    "platformNameKey": "identity.platform-name",
    "shortNameKey": "identity.short-name"
  },
  "integrations": {
    "channels": [
      {
        "id": "channel-sftp",
        "kind": "file-transfer",
        "label": "SFTP",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:sftp"
      },
      {
        "id": "channel-as2",
        "kind": "protocol",
        "label": "AS2",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:as2"
      },
      {
        "id": "channel-object-storage",
        "kind": "transport",
        "label": "Object storage",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:object-storage"
      },
      {
        "id": "channel-https",
        "kind": "transport",
        "label": "HTTPS",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:https"
      },
      {
        "id": "channel-event-stream",
        "kind": "data-access",
        "label": "Event stream",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:event-stream"
      },
      {
        "id": "channel-client-ipaas",
        "kind": "transport",
        "label": "Client integration platform",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:client-ipaas"
      },
      {
        "id": "channel-peppol-access-point",
        "kind": "transport",
        "label": "Peppol access point",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:peppol-access-point"
      },
      {
        "id": "channel-procurement-network",
        "kind": "product-channel",
        "label": "Procurement network",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:procurement-network"
      },
      {
        "id": "channel-email-gateway",
        "kind": "messaging",
        "label": "Email gateway",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:email-gateway"
      },
      {
        "id": "channel-microsoft-graph",
        "kind": "transport",
        "label": "Microsoft Graph",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:microsoft-graph"
      },
      {
        "id": "channel-webhook",
        "kind": "data-access",
        "label": "Webhook",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:webhook"
      },
      {
        "id": "channel-sql",
        "kind": "transport",
        "label": "SQL",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:sql"
      },
      {
        "id": "channel-bank-channel",
        "kind": "transport",
        "label": "Bank channel",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:bank-channel"
      },
      {
        "id": "channel-treasury-platform",
        "kind": "transport",
        "label": "Treasury platform",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:treasury-platform"
      },
      {
        "id": "channel-swift-service",
        "kind": "transport",
        "label": "SWIFT service",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:swift-service"
      },
      {
        "id": "channel-streamable-http",
        "kind": "transport",
        "label": "Streamable HTTP",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:streamable-http"
      },
      {
        "id": "channel-microsoft-graph-copilot-connector",
        "kind": "transport",
        "label": "Microsoft Graph connector for Microsoft 365 Copilot",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:microsoft-graph-copilot-connector"
      },
      {
        "id": "channel-sap-idoc",
        "kind": "protocol",
        "label": "SAP IDoc",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:sap-idoc"
      },
      {
        "id": "channel-cxml",
        "kind": "protocol",
        "label": "cXML",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:cxml"
      },
      {
        "id": "channel-ubl-or-peppol-where-supported",
        "kind": "transport",
        "label": "UBL or Peppol where supported",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:structured-document-exchange"
      },
      {
        "id": "channel-csv",
        "kind": "protocol",
        "label": "CSV",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:csv"
      },
      {
        "id": "channel-xml",
        "kind": "protocol",
        "label": "XML",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:xml"
      },
      {
        "id": "channel-narrow-api",
        "kind": "data-access",
        "label": "Narrow API",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:narrow-api"
      },
      {
        "id": "channel-business-document",
        "kind": "transport",
        "label": "Business document",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:business-document"
      },
      {
        "id": "channel-event",
        "kind": "data-access",
        "label": "Event",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:event"
      },
      {
        "id": "channel-business-event",
        "kind": "data-access",
        "label": "Business event",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:business-event"
      },
      {
        "id": "channel-data-entity",
        "kind": "transport",
        "label": "Data entity",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:data-entity"
      },
      {
        "id": "channel-odata",
        "kind": "transport",
        "label": "OData",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:odata"
      },
      {
        "id": "channel-microsoft-dataverse",
        "kind": "transport",
        "label": "Microsoft Dataverse",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:microsoft-dataverse"
      },
      {
        "id": "channel-workday-report",
        "kind": "product-channel",
        "label": "Workday report",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:workday-report"
      },
      {
        "id": "channel-workday-eib",
        "kind": "product-channel",
        "label": "Workday EIB",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:workday-eib"
      },
      {
        "id": "channel-infor-ion-document",
        "kind": "transport",
        "label": "Infor ION document",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:infor-ion-document"
      },
      {
        "id": "channel-edi",
        "kind": "protocol",
        "label": "EDI",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:edi"
      },
      {
        "id": "channel-rest",
        "kind": "transport",
        "label": "REST",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:rest"
      },
      {
        "id": "channel-soap",
        "kind": "transport",
        "label": "SOAP",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:soap"
      },
      {
        "id": "channel-sap-document-exchange",
        "kind": "product-channel",
        "label": "SAP document exchange",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:sap-document-exchange"
      },
      {
        "id": "channel-coupa-core-flat-file-csv",
        "kind": "file-transfer",
        "label": "Coupa Core flat file CSV",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:coupa-core-flat-file-csv"
      },
      {
        "id": "channel-coupa-core-api-xml-json",
        "kind": "protocol",
        "label": "Coupa Core API XML or JSON",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:coupa-core-api-xml-json"
      },
      {
        "id": "channel-cxml-where-configured",
        "kind": "protocol",
        "label": "cXML where configured",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:cxml-document-exchange"
      },
      {
        "id": "channel-tenant-export-import",
        "kind": "data-access",
        "label": "Tenant export import",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:tenant-export-import"
      },
      {
        "id": "channel-json",
        "kind": "protocol",
        "label": "JSON",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:json"
      },
      {
        "id": "channel-cxml-or-edi-if-configured",
        "kind": "protocol",
        "label": "cXML or EDI if configured",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:trading-partner-document-exchange"
      },
      {
        "id": "channel-client-export-import",
        "kind": "data-access",
        "label": "Client export import",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:client-export-import"
      },
      {
        "id": "channel-basware-xml",
        "kind": "protocol",
        "label": "Basware XML",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:basware-xml"
      },
      {
        "id": "channel-basware-api",
        "kind": "data-access",
        "label": "Basware API",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:basware-api"
      },
      {
        "id": "channel-file-based-exchange",
        "kind": "file-transfer",
        "label": "File based exchange",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:file-based-exchange"
      },
      {
        "id": "channel-peppol-or-network-document",
        "kind": "product-channel",
        "label": "Peppol or network document",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:network-document-exchange"
      },
      {
        "id": "channel-invoice-document",
        "kind": "transport",
        "label": "Invoice document",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:invoice-document"
      },
      {
        "id": "channel-peppol",
        "kind": "transport",
        "label": "Peppol",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:peppol"
      },
      {
        "id": "channel-peppol-bis-billing-3",
        "kind": "transport",
        "label": "Peppol BIS Billing 3",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:peppol-bis-billing-3"
      },
      {
        "id": "channel-peppol-ordering-3",
        "kind": "transport",
        "label": "Peppol BIS Ordering 3",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:peppol-ordering-3"
      },
      {
        "id": "channel-peppol-eas-iso-6523",
        "kind": "transport",
        "label": "Peppol EAS and ISO 6523",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:peppol-eas-iso-6523"
      },
      {
        "id": "channel-iso-20022",
        "kind": "transport",
        "label": "ISO 20022",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:iso-20022"
      },
      {
        "id": "channel-bank-xml",
        "kind": "protocol",
        "label": "Bank XML",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:bank-xml"
      },
      {
        "id": "channel-bank-csv",
        "kind": "protocol",
        "label": "Bank CSV",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:bank-csv"
      },
      {
        "id": "channel-host-to-host",
        "kind": "transport",
        "label": "Host to host",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:host-to-host"
      },
      {
        "id": "channel-bank-file",
        "kind": "file-transfer",
        "label": "Bank file",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:bank-file"
      },
      {
        "id": "channel-coupa-exchange",
        "kind": "product-channel",
        "label": "Coupa exchange",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:coupa-exchange"
      },
      {
        "id": "channel-bank-message",
        "kind": "messaging",
        "label": "Bank message",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:bank-message"
      },
      {
        "id": "channel-document",
        "kind": "transport",
        "label": "Document",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:document"
      },
      {
        "id": "channel-sharepoint-content-binding",
        "kind": "product-channel",
        "label": "SharePoint content binding",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:sharepoint-content-binding"
      },
      {
        "id": "channel-adaptive-card",
        "kind": "interaction",
        "label": "Adaptive card",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:adaptive-card"
      },
      {
        "id": "channel-file-export",
        "kind": "file-transfer",
        "label": "File export",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:file-export"
      },
      {
        "id": "channel-master-reference-sync",
        "kind": "transport",
        "label": "Master reference sync",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:master-reference-sync"
      },
      {
        "id": "channel-risk-evidence-feed",
        "kind": "transport",
        "label": "Risk evidence feed",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:risk-evidence-feed"
      },
      {
        "id": "channel-oauth",
        "kind": "protocol",
        "label": "OAuth",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:oauth"
      },
      {
        "id": "channel-oidc",
        "kind": "transport",
        "label": "OIDC",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:oidc"
      },
      {
        "id": "channel-scim",
        "kind": "protocol",
        "label": "SCIM",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:scim"
      },
      {
        "id": "channel-saml",
        "kind": "transport",
        "label": "SAML",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:saml"
      },
      {
        "id": "channel-dataverse",
        "kind": "transport",
        "label": "Dataverse",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:dataverse"
      },
      {
        "id": "channel-power-automate-connector",
        "kind": "transport",
        "label": "Power Automate connector",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:power-automate-connector"
      },
      {
        "id": "channel-workbook",
        "kind": "transport",
        "label": "Workbook",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:workbook"
      },
      {
        "id": "channel-authorised-tool",
        "kind": "transport",
        "label": "Authorised tool",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:authorised-tool"
      },
      {
        "id": "channel-external-analytics-exchange",
        "kind": "transport",
        "label": "External analytics exchange",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:external-analytics-exchange"
      },
      {
        "id": "channel-table",
        "kind": "transport",
        "label": "Table",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:table"
      },
      {
        "id": "channel-parquet",
        "kind": "transport",
        "label": "Parquet",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:parquet"
      },
      {
        "id": "channel-delta-table",
        "kind": "transport",
        "label": "Delta table",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:delta-table"
      },
      {
        "id": "channel-onelake",
        "kind": "transport",
        "label": "OneLake",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:onelake"
      },
      {
        "id": "channel-semantic-model",
        "kind": "transport",
        "label": "Semantic model",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:semantic-model"
      },
      {
        "id": "channel-file",
        "kind": "file-transfer",
        "label": "File",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:file"
      },
      {
        "id": "channel-source-snapshot-delta-ingest",
        "kind": "transport",
        "label": "Source snapshot delta ingest",
        "licenseId": "apache-2.0",
        "qualifiedId": "channel:source-snapshot-delta-ingest"
      }
    ],
    "copilotAccessContract": {
      "accessSurface": "Microsoft 365 Copilot",
      "authorityBoundary": "Microsoft 365 Copilot is an access surface. The selected Workblock remains the permission, proposal, approval, commitment, evidence and audit boundary.",
      "capabilities": [
        {
          "description": "Show only the published module agents the signed-in person is authorised to use.",
          "id": "authorised-agent-discovery",
          "label": "Authorised agent discovery"
        },
        {
          "description": "Show the bounded outcome-tool schemas enabled for those authorised agents.",
          "id": "enabled-tool-schema-discovery",
          "label": "Enabled outcome discovery"
        },
        {
          "description": "Invoke one selected module outcome inside its Workblock authority and canonical-data contract.",
          "id": "bounded-outcome-invocation",
          "label": "Bounded outcome invocation"
        },
        {
          "description": "Resolve a permission-checked private artifact returned by the outcome without broadening access.",
          "id": "authorised-private-artifact-resolution",
          "label": "Private artifact resolution"
        }
      ],
      "licenseId": "bw-partner-1.0",
      "proofClass": "recipe",
      "relationship": "Microsoft 365 Copilot access surface → domain recipe package → module outcome-tool recipe → published module agent charter → Workblock authority and canonical-data boundary → execution-side MCP bridge"
    },
    "copilotDomainPackages": [
      {
        "agentIds": [
          "spend-steward-agent",
          "spend-quality-critic-agent",
          "category-radar-agent",
          "opportunity-critic-agent",
          "category-strategist-agent",
          "strategy-orchestration-agent",
          "policy-rule-author-agent",
          "policy-release-critic-agent",
          "policy-guidance-agent",
          "guidance-critic-agent",
          "commodity-price-outlook-agent",
          "tail-spend-consolidation-agent",
          "channel-drift-agent"
        ],
        "authorityBoundary": "The package exposes only authorised module outcomes. Each underlying Workblock retains its own identity, records, evidence, proposal, approval, commitment and audit boundary.",
        "domainWorkblockId": "strategy-policy-category-spend",
        "id": "copilot-package-strategy-policy-category-spend",
        "label": "Strategy, policy, category and spend outcome tools",
        "licenseId": "bw-partner-1.0",
        "proofClass": "recipe",
        "toolRecipeIds": [
          "tool-spend-data-foundation",
          "tool-category-opportunity-radar",
          "tool-category-strategy-orchestrator",
          "tool-policy-rule-lifecycle",
          "tool-policy-guidance"
        ]
      },
      {
        "agentIds": [
          "service-catalogue-curator-agent",
          "service-discovery-agent",
          "request-intake-agent",
          "intake-quality-critic-agent",
          "request-enrichment-agent",
          "request-routing-agent",
          "demand-orchestrator-agent",
          "journey-critic-agent",
          "demand-portfolio-agent",
          "demand-portfolio-critic-agent",
          "raw-material-demand-agent",
          "coverage-position-agent",
          "specification-harmonisation-agent"
        ],
        "authorityBoundary": "The package exposes only authorised module outcomes. Each underlying Workblock retains its own identity, records, evidence, proposal, approval, commitment and audit boundary.",
        "domainWorkblockId": "intake-demand",
        "id": "copilot-package-intake-demand",
        "label": "Intake and demand outcome tools",
        "licenseId": "bw-partner-1.0",
        "proofClass": "recipe",
        "toolRecipeIds": [
          "tool-procurement-service-catalogue",
          "tool-intelligent-intake",
          "tool-request-enrichment-routing",
          "tool-demand-orchestration",
          "tool-demand-consolidation-portfolio"
        ]
      },
      {
        "agentIds": [
          "sourcing-discovery-agent",
          "sourcing-pipeline-agent",
          "sourcing-event-designer-agent",
          "sourcing-event-operator-agent",
          "bid-evaluation-agent",
          "award-optimizer-critic-agent",
          "negotiation-strategy-agent",
          "negotiation-execution-agent",
          "tactical-sourcing-mission-agent",
          "tactical-sourcing-critic-agent",
          "buy-timing-agent",
          "landed-cost-agent",
          "spot-buy-conversion-agent"
        ],
        "authorityBoundary": "The package exposes only authorised module outcomes. Each underlying Workblock retains its own identity, records, evidence, proposal, approval, commitment and audit boundary.",
        "domainWorkblockId": "sourcing-negotiation",
        "id": "copilot-package-sourcing-negotiation",
        "label": "Sourcing and negotiation outcome tools",
        "licenseId": "bw-partner-1.0",
        "proofClass": "recipe",
        "toolRecipeIds": [
          "tool-sourcing-pipeline-discovery",
          "tool-sourcing-event",
          "tool-bid-evaluation-award",
          "tool-negotiation-copilot",
          "tool-tactical-sourcing-autonomy"
        ]
      },
      {
        "agentIds": [
          "contract-intake-agent",
          "intake-critic-agent",
          "contract-drafting-agent",
          "contract-review-critic",
          "contract-approval-agent",
          "execution-critic-agent",
          "obligation-owner-agent",
          "entitlement-agent",
          "contract-change-agent",
          "contract-compliance-agent"
        ],
        "authorityBoundary": "The package exposes only authorised module outcomes. Each underlying Workblock retains its own identity, records, evidence, proposal, approval, commitment and audit boundary.",
        "domainWorkblockId": "contract-lifecycle-management",
        "id": "copilot-package-contract-lifecycle-management",
        "label": "Contract lifecycle management outcome tools",
        "licenseId": "bw-partner-1.0",
        "proofClass": "recipe",
        "toolRecipeIds": [
          "tool-contract-intake-digitization",
          "tool-contract-authoring-review",
          "tool-contract-approval-repository",
          "tool-obligation-monitoring",
          "tool-renewal-change-compliance"
        ]
      },
      {
        "agentIds": [
          "supplier-onboarding-agent",
          "onboarding-critic-agent",
          "supplier-qualification-agent",
          "supplier-master-change-agent",
          "third-party-risk-agent",
          "risk-assessment-critic",
          "supplier-risk-monitor-agent",
          "supply-network-agent",
          "supplier-remediation-agent",
          "supplier-exit-agent",
          "carbon-compliance-agent",
          "supplier-quality-prediction-agent"
        ],
        "authorityBoundary": "The package exposes only authorised module outcomes. Each underlying Workblock retains its own identity, records, evidence, proposal, approval, commitment and audit boundary.",
        "domainWorkblockId": "supplier-lifecycle-third-party-risk",
        "id": "copilot-package-supplier-lifecycle-third-party-risk",
        "label": "Supplier lifecycle and third-party risk outcome tools",
        "licenseId": "bw-partner-1.0",
        "proofClass": "recipe",
        "toolRecipeIds": [
          "tool-supplier-onboarding",
          "tool-supplier-master-qualification",
          "tool-third-party-risk-review",
          "tool-continuous-risk-monitoring",
          "tool-supplier-remediation-exit"
        ]
      },
      {
        "agentIds": [
          "requester-buying-agent",
          "buying-guidance-critic",
          "requisition-policy-agent",
          "requisition-critic-agent",
          "purchase-order-agent",
          "order-response-agent",
          "purchase-order-exception-agent",
          "order-exception-critic",
          "receiving-agent",
          "service-acceptance-agent",
          "return-recovery-agent",
          "catalogue-coverage-agent"
        ],
        "authorityBoundary": "The package exposes only authorised module outcomes. Each underlying Workblock retains its own identity, records, evidence, proposal, approval, commitment and audit boundary.",
        "domainWorkblockId": "buying-ordering-receiving",
        "id": "copilot-package-buying-ordering-receiving",
        "label": "Buying, ordering and receiving outcome tools",
        "licenseId": "bw-partner-1.0",
        "proofClass": "recipe",
        "toolRecipeIds": [
          "tool-guided-buying",
          "tool-requisition-policy-routing",
          "tool-purchase-order-orchestration",
          "tool-purchase-order-exception",
          "tool-receiving-service-entry"
        ]
      },
      {
        "agentIds": [
          "invoice-exception-coordinator-agent",
          "payment-readiness-agent",
          "invoice-intake-agent",
          "supplier-invoice-resolution-agent",
          "payment-execution-guard-agent",
          "payment-terms-agent"
        ],
        "authorityBoundary": "The package exposes only authorised module outcomes. Each underlying Workblock retains its own identity, records, evidence, proposal, approval, commitment and audit boundary.",
        "domainWorkblockId": "invoice-exception-payment-readiness",
        "id": "copilot-package-invoice-exception-payment-readiness",
        "label": "Invoice, exception and payment readiness outcome tools",
        "licenseId": "bw-partner-1.0",
        "proofClass": "recipe",
        "toolRecipeIds": [
          "tool-invoice-exception-triage",
          "tool-payment-readiness",
          "tool-invoice-intake-match",
          "tool-supplier-invoice-resolution",
          "tool-payment-execution-guard"
        ]
      },
      {
        "agentIds": [
          "supplier-performance-review-agent",
          "supplier-innovation-agent",
          "supplier-segmentation-agent",
          "supplier-performance-monitor-agent",
          "supplier-relationship-agent"
        ],
        "authorityBoundary": "The package exposes only authorised module outcomes. Each underlying Workblock retains its own identity, records, evidence, proposal, approval, commitment and audit boundary.",
        "domainWorkblockId": "supplier-performance-innovation-relationship",
        "id": "copilot-package-supplier-performance-innovation-relationship",
        "label": "Supplier performance, innovation and relationship outcome tools",
        "licenseId": "bw-partner-1.0",
        "proofClass": "recipe",
        "toolRecipeIds": [
          "tool-supplier-performance-review",
          "tool-supplier-innovation-pipeline",
          "tool-supplier-segmentation-governance",
          "tool-supplier-performance-monitor-correct",
          "tool-supplier-relationship-joint-value"
        ]
      },
      {
        "agentIds": [
          "savings-initiative-agent",
          "value-leakage-agent",
          "value-baseline-agent",
          "value-attribution-agent",
          "value-portfolio-agent",
          "margin-tradeoff-agent",
          "price-variance-agent"
        ],
        "authorityBoundary": "The package exposes only authorised module outcomes. Each underlying Workblock retains its own identity, records, evidence, proposal, approval, commitment and audit boundary.",
        "domainWorkblockId": "value-realization-savings",
        "id": "copilot-package-value-realization-savings",
        "label": "Value realisation and savings outcome tools",
        "licenseId": "bw-partner-1.0",
        "proofClass": "recipe",
        "toolRecipeIds": [
          "tool-savings-initiative",
          "tool-value-leakage-monitor",
          "tool-value-opportunity-baseline",
          "tool-realization-reconciliation-attribution",
          "tool-value-portfolio-forecast"
        ]
      }
    ],
    "examples": [
      {
        "authorityBoundary": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "category-opportunity-radar",
        "domainWorkblockId": "strategy-policy-category-spend",
        "entityIds": [
          "category-opportunity",
          "spend-record",
          "category",
          "party",
          "decision",
          "evidence-item",
          "business-unit",
          "source-record-reference",
          "authority-envelope",
          "learning-example",
          "evaluation-result",
          "integration-state"
        ],
        "featured": true,
        "id": "copilot-category-opportunity-radar",
        "label": "Category opportunity discovery and prioritisation in Microsoft 365 Copilot",
        "licenseId": "bw-partner-1.0",
        "nextAction": "Open the prepared result in its owning Workblock for review.",
        "output": "Retrieve evidence-linked opportunities or propose a triage action without committing the backlog.",
        "owner": "The accountable role named by the domain Workblock",
        "proofClass": "illustrative-example",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "external-analytics-exchange",
          "risk-and-reference-evidence-feed",
          "master-reference-sync"
        ],
        "summary": "Retrieve evidence-linked opportunities or propose a triage action without committing the backlog.",
        "toolRecipeId": "tool-category-opportunity-radar",
        "userQuestion": "Which evidence-linked category opportunities need my decision next?"
      },
      {
        "authorityBoundary": "The tool may act only after exact confirmation, current authority, expected-version checks, idempotency and external reconciliation.",
        "businessModuleId": "intelligent-intake",
        "domainWorkblockId": "intake-demand",
        "entityIds": [
          "intake-request",
          "party",
          "person",
          "business-unit",
          "source-record-reference",
          "evidence-item",
          "procurement-service-offering",
          "category",
          "item-service",
          "policy",
          "policy-version",
          "authority-envelope",
          "learning-example",
          "evaluation-result",
          "integration-state"
        ],
        "featured": true,
        "id": "copilot-intelligent-intake",
        "label": "Procurement request intake in Microsoft 365 Copilot",
        "licenseId": "bw-partner-1.0",
        "nextAction": "Open the prepared result in its owning Workblock for review.",
        "output": "Create an intake request after showing captured facts, route and authority boundary.",
        "owner": "The accountable role named by the domain Workblock",
        "proofClass": "illustrative-example",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "collaboration-intake",
          "sharepoint-content-binding",
          "master-reference-sync"
        ],
        "summary": "Create an intake request after showing captured facts, route and authority boundary.",
        "toolRecipeId": "tool-intelligent-intake",
        "userQuestion": "Start a procurement request from this need and show me what will be created."
      },
      {
        "authorityBoundary": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "sourcing-event",
        "domainWorkblockId": "sourcing-negotiation",
        "entityIds": [
          "sourcing-event-record",
          "party",
          "evidence-item",
          "decision",
          "sourcing-opportunity",
          "person",
          "category",
          "item-service",
          "source-record-reference",
          "policy",
          "policy-version",
          "authority-envelope",
          "action-proposal",
          "committed-action",
          "exception",
          "audit-event",
          "business-event",
          "learning-example",
          "evaluation-result",
          "integration-state",
          "registry-release"
        ],
        "featured": true,
        "id": "copilot-sourcing-event",
        "label": "Sourcing event preparation and evaluation in Microsoft 365 Copilot",
        "licenseId": "bw-partner-1.0",
        "nextAction": "Open the prepared result in its owning Workblock for review.",
        "output": "Assemble event evidence and prepare a reviewable decision package.",
        "owner": "The accountable role named by the domain Workblock",
        "proofClass": "illustrative-example",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "master-reference-sync",
          "structured-business-document-ingest",
          "sharepoint-content-binding"
        ],
        "summary": "Assemble event evidence and prepare a reviewable decision package.",
        "toolRecipeId": "tool-sourcing-event",
        "userQuestion": "Prepare the evidence and decision package for this sourcing event."
      },
      {
        "authorityBoundary": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "contract-authoring-review",
        "domainWorkblockId": "contract-lifecycle-management",
        "entityIds": [
          "contract-version",
          "contract-template",
          "clause-library-entry",
          "clause-deviation",
          "decision",
          "contract-intake",
          "business-event",
          "contract",
          "party",
          "person",
          "source-record-reference",
          "evidence-item",
          "policy",
          "policy-version",
          "authority-envelope",
          "action-proposal",
          "committed-action",
          "exception",
          "audit-event",
          "learning-example",
          "evaluation-result",
          "integration-state",
          "registry-release"
        ],
        "featured": true,
        "id": "copilot-contract-authoring-review",
        "label": "Contract drafting, negotiation and redlining in Microsoft 365 Copilot",
        "licenseId": "bw-partner-1.0",
        "nextAction": "Open the prepared result in its owning Workblock for review.",
        "output": "Prepare a source-linked review and redline package without accepting legal positions.",
        "owner": "The accountable role named by the domain Workblock",
        "proofClass": "illustrative-example",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "sharepoint-content-binding",
          "master-reference-sync"
        ],
        "summary": "Prepare a source-linked review and redline package without accepting legal positions.",
        "toolRecipeId": "tool-contract-authoring-review",
        "userQuestion": "Prepare a source-linked contract review and redline package."
      },
      {
        "authorityBoundary": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "third-party-risk-review",
        "domainWorkblockId": "supplier-lifecycle-third-party-risk",
        "entityIds": [
          "supplier-risk-assessment",
          "supplier-profile",
          "decision",
          "evidence-item",
          "supplier-onboarding-case",
          "supplier-qualification",
          "supplier-risk-signal",
          "supplier-tier-link",
          "person",
          "policy-version",
          "authority-envelope",
          "action-proposal",
          "committed-action",
          "exception",
          "audit-event",
          "business-event",
          "learning-example",
          "evaluation-result"
        ],
        "featured": true,
        "id": "copilot-third-party-risk-review",
        "label": "Third-party risk review in Microsoft 365 Copilot",
        "licenseId": "bw-partner-1.0",
        "nextAction": "Open the prepared result in its owning Workblock for review.",
        "output": "Assemble current evidence, remaining risk and treatment options for the authorised owner.",
        "owner": "The accountable role named by the domain Workblock",
        "proofClass": "illustrative-example",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "risk-and-reference-evidence-feed",
          "master-reference-sync",
          "sharepoint-content-binding"
        ],
        "summary": "Assemble current evidence, remaining risk and treatment options for the authorised owner.",
        "toolRecipeId": "tool-third-party-risk-review",
        "userQuestion": "What is the current supplier risk and which treatment decision is required?"
      },
      {
        "authorityBoundary": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "guided-buying",
        "domainWorkblockId": "buying-ordering-receiving",
        "entityIds": [
          "buying-request",
          "catalogue-line",
          "item-service",
          "party",
          "policy-guidance-result",
          "supplier-profile",
          "supplier-qualification",
          "contract",
          "business-unit",
          "category",
          "source-record-reference",
          "policy",
          "policy-version",
          "authority-envelope",
          "evaluation-result",
          "integration-state",
          "registry-release"
        ],
        "featured": true,
        "id": "copilot-guided-buying",
        "label": "Guided buying in Microsoft 365 Copilot",
        "licenseId": "bw-partner-1.0",
        "nextAction": "Open the prepared result in its owning Workblock for review.",
        "output": "Return the compliant route, source and any missing approval facts.",
        "owner": "The accountable role named by the domain Workblock",
        "proofClass": "illustrative-example",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "master-reference-sync",
          "punchout-catalogue-session",
          "structured-business-document-ingest"
        ],
        "summary": "Return the compliant route, source and any missing approval facts.",
        "toolRecipeId": "tool-guided-buying",
        "userQuestion": "What is the valid buying path and which approval facts are missing?"
      },
      {
        "authorityBoundary": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "invoice-exception-triage",
        "demoReadiness": "Repository demo with packaged synthetic records. Microsoft tenant installation and live source connections are not included.",
        "domainWorkblockId": "invoice-exception-payment-readiness",
        "enterpriseMessageIds": [
          "enterprise-interoperability",
          "pilot-production",
          "human-accountability"
        ],
        "entityIds": [
          "invoice-exception",
          "invoice-match-assessment",
          "purchase-order",
          "receipt",
          "contract",
          "invoice",
          "supplier-invoice-resolution",
          "party",
          "category",
          "item-service",
          "source-record-reference",
          "evidence-item",
          "policy",
          "policy-version",
          "authority-envelope",
          "action-proposal",
          "committed-action",
          "decision",
          "exception",
          "audit-event",
          "business-event",
          "learning-example",
          "evaluation-result",
          "integration-state",
          "registry-release"
        ],
        "featured": true,
        "id": "copilot-invoice-exception-triage",
        "label": "Invoice exception triage in Microsoft 365 Copilot",
        "licenseId": "bw-partner-1.0",
        "nextAction": "Open the prepared resolution proposal for accounts payable owner review.",
        "output": "In the repository demo, packaged synthetic purchase order, Peppol UBL invoice, ERP receipt and SharePoint evidence explain the block and prepare a reviewable resolution proposal.",
        "owner": "The accountable role named by the domain Workblock",
        "proofClass": "demo-workblock",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "structured-business-document-ingest",
          "master-reference-sync",
          "external-analytics-exchange"
        ],
        "summary": "In the repository demo, packaged synthetic purchase order, Peppol UBL invoice, ERP receipt and SharePoint evidence explain the block and prepare a reviewable resolution proposal.",
        "toolRecipeId": "tool-invoice-exception-triage",
        "userQuestion": "Why is this invoice blocked and what resolution can its owner review?",
        "workblockPath": "workblocks/invoice-exception-copilot-demo"
      },
      {
        "authorityBoundary": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "supplier-performance-review",
        "domainWorkblockId": "supplier-performance-innovation-relationship",
        "entityIds": [
          "supplier-performance-review-record",
          "supplier-performance-observation",
          "committed-action",
          "evidence-item",
          "supplier-segment-assignment",
          "party",
          "source-record-reference",
          "authority-envelope",
          "decision",
          "audit-event",
          "business-event",
          "learning-example",
          "evaluation-result",
          "integration-state",
          "registry-release"
        ],
        "featured": true,
        "id": "copilot-supplier-performance-review",
        "label": "Supplier performance review in Microsoft 365 Copilot",
        "licenseId": "bw-partner-1.0",
        "nextAction": "Open the prepared result in its owning Workblock for review.",
        "output": "Assemble current evidence and prepare a review and commitment proposal.",
        "owner": "The accountable role named by the domain Workblock",
        "proofClass": "illustrative-example",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "external-analytics-exchange",
          "sharepoint-content-binding",
          "risk-and-reference-evidence-feed"
        ],
        "summary": "Assemble current evidence and prepare a review and commitment proposal.",
        "toolRecipeId": "tool-supplier-performance-review",
        "userQuestion": "Prepare the current supplier performance review and commitment proposal."
      },
      {
        "authorityBoundary": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "savings-initiative",
        "domainWorkblockId": "value-realization-savings",
        "entityIds": [
          "savings-initiative-record",
          "value-opportunity-baseline",
          "committed-action",
          "evidence-item",
          "value-realization-attribution",
          "value-leakage-finding",
          "business-unit",
          "category",
          "source-record-reference",
          "authority-envelope",
          "action-proposal",
          "decision",
          "exception",
          "audit-event",
          "business-event",
          "learning-example",
          "evaluation-result",
          "integration-state",
          "registry-release"
        ],
        "featured": true,
        "id": "copilot-savings-initiative",
        "label": "Savings initiative tracking in Microsoft 365 Copilot",
        "licenseId": "bw-partner-1.0",
        "nextAction": "Open the prepared result in its owning Workblock for review.",
        "output": "Explain initiative state, evidence, owner and proposed next action without validating value.",
        "owner": "The accountable role named by the domain Workblock",
        "proofClass": "illustrative-example",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "external-analytics-exchange",
          "master-reference-sync",
          "sharepoint-content-binding"
        ],
        "summary": "Explain initiative state, evidence, owner and proposed next action without validating value.",
        "toolRecipeId": "tool-savings-initiative",
        "userQuestion": "Show the baseline, evidence, owner and next decision for this savings initiative."
      },
      {
        "authorityBoundary": "Only an authorised canonical commitment is delivered. Acknowledgement, destination readback and business completion remain distinct.",
        "enterpriseMessageIds": [
          "transport-independent-access",
          "enterprise-interoperability"
        ],
        "entityIds": [
          "purchase-order",
          "invoice",
          "source-record-reference",
          "integration-state"
        ],
        "featured": true,
        "id": "document-first-sap-network-exchange",
        "label": "Document-first SAP and network exchange",
        "licenseId": "bw-partner-1.0",
        "nextAction": "Select the installed SAP release, document type and client mapping overlay.",
        "owner": "The owning purchasing or accounts payable module",
        "proofClass": "illustrative-example",
        "recipeIds": [
          "structured-business-document-ingest",
          "structured-business-document-outbound"
        ],
        "summary": "Project an authorised purchase order or invoice through UBL, Peppol, cXML, IDoc, EDI or an agreed file channel before making a proprietary API a dependency."
      },
      {
        "authorityBoundary": "The installed client system retains its declared responsibility. The overlay cannot bypass the canonical record owner.",
        "enterpriseMessageIds": [
          "transport-independent-access",
          "enterprise-interoperability"
        ],
        "entityIds": [
          "party",
          "purchase-order",
          "invoice",
          "integration-state"
        ],
        "featured": true,
        "id": "canonical-suite-overlays",
        "label": "One canonical contract across procurement suites",
        "licenseId": "bw-partner-1.0",
        "nextAction": "Supply the installed edition, tenant schema and representative authorised payloads.",
        "owner": "The client integration owner and relevant domain owner",
        "proofClass": "illustrative-example",
        "recipeIds": [
          "source-snapshot-delta-ingest",
          "master-reference-sync",
          "structured-business-document-ingest",
          "structured-business-document-outbound"
        ],
        "summary": "Ariba, Coupa, Ivalua and Basware client overlays map authorised document and file formats into the same owned GroundWorks records and reconciliation states."
      },
      {
        "authorityBoundary": "SharePoint owns selected file versions and collaboration state. The Workblock owns procurement proposals, decisions, commitments and outcomes.",
        "enterpriseMessageIds": [
          "enterprise-interoperability",
          "human-accountability"
        ],
        "entityIds": [
          "contract-version",
          "evidence-item",
          "source-record-reference",
          "integration-state"
        ],
        "featured": true,
        "id": "sharepoint-governed-content-channel",
        "label": "SharePoint as a governed content channel",
        "licenseId": "bw-partner-1.0",
        "nextAction": "Select the site, library, content type, permission model, retention and change-recovery contract.",
        "owner": "The document owner and owning procurement module",
        "proofClass": "illustrative-example",
        "recipeIds": [
          "sharepoint-content-binding"
        ],
        "summary": "Bind exact SharePoint file and list versions to procurement records while preserving permissions, provenance and content authority."
      }
    ],
    "formats": [
      {
        "conformanceStandardIds": [
          "ubl-2-4",
          "en-16931",
          "iso-4217",
          "iso-8601"
        ],
        "id": "format-ubl-2-4",
        "kind": "document-schema",
        "label": "OASIS Universal Business Language",
        "licenseId": "apache-2.0",
        "pinning": "Official OASIS 2.4 archive and schema tree already pinned by repository fixture.",
        "qualifiedId": "format:ubl-2-4",
        "role": "canonical document semantics",
        "standardId": "ubl-2-4"
      },
      {
        "conformanceStandardIds": [
          "peppol-bis-billing-3"
        ],
        "id": "format-peppol-bis-billing-3",
        "kind": "document-schema",
        "label": "Peppol BIS Billing",
        "licenseId": "apache-2.0",
        "pinning": "Adapter pins the current deployed jurisdiction and release; November 2025 was current in the reviewed public documentation.",
        "qualifiedId": "format:peppol-bis-billing-3",
        "role": "invoice and credit note profile",
        "standardId": "peppol-bis-billing-3"
      },
      {
        "conformanceStandardIds": [
          "peppol-ordering-3"
        ],
        "id": "format-peppol-ordering-3",
        "kind": "document-schema",
        "label": "Peppol BIS Ordering",
        "licenseId": "apache-2.0",
        "pinning": "Adapter pins exact OpenPeppol release; November 2025 was current in the reviewed upgrade documentation.",
        "qualifiedId": "format:peppol-ordering-3",
        "role": "order order response catalogue despatch and response profiles",
        "standardId": "peppol-ordering-3"
      },
      {
        "conformanceStandardIds": [
          "peppol-eas-iso-6523"
        ],
        "id": "format-peppol-eas-iso-6523",
        "kind": "document-schema",
        "label": "Peppol electronic address schemes and ISO 6523 identifiers",
        "licenseId": "apache-2.0",
        "pinning": "Pin the OpenPeppol participant identifier scheme code-list release and scheme value.",
        "qualifiedId": "format:peppol-eas-iso-6523",
        "role": "electronic addressing",
        "standardId": "peppol-eas-iso-6523"
      },
      {
        "conformanceStandardIds": [
          "cxml-1-2-070"
        ],
        "id": "format-cxml-1-2-070",
        "kind": "document-schema",
        "label": "cXML",
        "licenseId": "apache-2.0",
        "pinning": "Pin the cXML DTD or reference-guide release selected by the trading relationship.",
        "qualifiedId": "format:cxml-1-2-070",
        "role": "procurement document and punchout exchange",
        "standardId": "cxml-1-2-070"
      },
      {
        "conformanceStandardIds": [
          "sap-idoc"
        ],
        "id": "format-sap-idoc",
        "kind": "document-schema",
        "label": "SAP Intermediate Document",
        "licenseId": "apache-2.0",
        "pinning": "Pin message type, basic type, extension, segment contract and SAP release.",
        "qualifiedId": "format:sap-idoc",
        "role": "sap document exchange",
        "standardId": "sap-idoc"
      },
      {
        "conformanceStandardIds": [
          "edi-partner-agreement"
        ],
        "id": "format-edi",
        "kind": "document-schema",
        "label": "Electronic data interchange partner agreement",
        "licenseId": "apache-2.0",
        "pinning": "Pin standard, transaction set or message, implementation guide and partner agreement.",
        "qualifiedId": "format:edi",
        "role": "trading partner document exchange",
        "standardId": "edi-partner-agreement"
      },
      {
        "conformanceStandardIds": [
          "iso-20022"
        ],
        "id": "format-iso-20022",
        "kind": "message",
        "label": "ISO 20022 financial messaging",
        "licenseId": "apache-2.0",
        "pinning": "Pin message family, market practice, bank version and channel.",
        "qualifiedId": "format:iso-20022",
        "role": "payment and bank exchange",
        "standardId": "iso-20022"
      },
      {
        "conformanceStandardIds": [
          "unspsc"
        ],
        "id": "format-unspsc",
        "kind": "external-reference",
        "label": "United Nations Standard Products and Services Code",
        "licenseId": "apache-2.0",
        "pinning": "Store scheme, version, code, source and local mapping; never replace the canonical category ID.",
        "qualifiedId": "format:unspsc",
        "role": "external catalogue and spend classification",
        "standardId": "unspsc"
      },
      {
        "conformanceStandardIds": [
          "us-irs-ein"
        ],
        "id": "format-us-irs-ein",
        "kind": "external-reference",
        "label": "US Employer Identification Number",
        "licenseId": "apache-2.0",
        "pinning": "Namespace and jurisdiction are explicit; EIN is not an electronic address.",
        "qualifiedId": "format:us-irs-ein",
        "role": "us party tax identifier",
        "standardId": "us-irs-ein"
      },
      {
        "conformanceStandardIds": [
          "gs1-identifiers"
        ],
        "id": "format-gs1-gln",
        "kind": "external-reference",
        "label": "GS1 identification keys",
        "licenseId": "apache-2.0",
        "pinning": "Record identifier type, issuing scheme, verification, subject and valid period.",
        "qualifiedId": "format:gs1-gln",
        "role": "party and location identifier or electronic address scheme",
        "standardId": "gs1-identifiers"
      },
      {
        "conformanceStandardIds": [
          "gs1-identifiers"
        ],
        "id": "format-gs1-gtin",
        "kind": "external-reference",
        "label": "GS1 identification keys",
        "licenseId": "apache-2.0",
        "pinning": "Record scheme and verified value; canonical item-service ID remains internal.",
        "qualifiedId": "format:gs1-gtin",
        "role": "trade item identifier",
        "standardId": "gs1-identifiers"
      },
      {
        "conformanceStandardIds": [
          "lei-17442"
        ],
        "id": "format-lei-17442",
        "kind": "external-reference",
        "label": "Legal Entity Identifier",
        "licenseId": "apache-2.0",
        "pinning": "Preserve GLEIF source, verification and validity.",
        "qualifiedId": "format:lei-17442",
        "role": "legal entity identifier",
        "standardId": "lei-17442"
      },
      {
        "conformanceStandardIds": [
          "unece-rec-20-21"
        ],
        "id": "format-unece-rec-20-21",
        "kind": "external-reference",
        "label": "UN/ECE unit codes",
        "licenseId": "apache-2.0",
        "pinning": "Pin the code-list release used by each document profile.",
        "qualifiedId": "format:unece-rec-20-21",
        "role": "unit codes",
        "standardId": "unece-rec-20-21"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-csv",
        "kind": "serialization",
        "label": "CSV",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:csv",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-json",
        "kind": "serialization",
        "label": "JSON",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:json",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-xml",
        "kind": "serialization",
        "label": "XML",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:xml",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-parquet",
        "kind": "serialization",
        "label": "Parquet",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:parquet",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-source-native-export",
        "kind": "file",
        "label": "Source native export",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:source-native-export",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-peppol-profile",
        "kind": "file",
        "label": "Peppol profile",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:peppol-profile",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-cxml",
        "kind": "serialization",
        "label": "cXML",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:cxml",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-idoc",
        "kind": "external-reference",
        "label": "IDoc",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:idoc",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-vendor-xml",
        "kind": "serialization",
        "label": "Vendor XML",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:vendor-xml",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-cxml-punchout",
        "kind": "serialization",
        "label": "cXML PunchOut",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:cxml-punchout",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-drive-item",
        "kind": "ui-artifact",
        "label": "Drive item",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:drive-item",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-list-item",
        "kind": "ui-artifact",
        "label": "List item",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:list-item",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-docx",
        "kind": "file",
        "label": "DOCX",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:docx",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-xlsx",
        "kind": "file",
        "label": "XLSX",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:xlsx",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-pdf",
        "kind": "file",
        "label": "PDF",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:pdf",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-structured-list",
        "kind": "external-reference",
        "label": "Structured list",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:structured-list",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-message",
        "kind": "message",
        "label": "Message",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:message",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-attachment",
        "kind": "file",
        "label": "Attachment",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:attachment",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-adaptive-card",
        "kind": "ui-artifact",
        "label": "Adaptive card",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:adaptive-card",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-email",
        "kind": "message",
        "label": "Email",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:email",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-file-link",
        "kind": "file",
        "label": "File link",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:file-link",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-table",
        "kind": "ui-artifact",
        "label": "Table",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:table",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-semantic-model",
        "kind": "semantic-model",
        "label": "Semantic model",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:semantic-model",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-document",
        "kind": "external-reference",
        "label": "Document",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:document",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-bank-csv",
        "kind": "serialization",
        "label": "Bank CSV",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:bank-csv",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-bank-xml",
        "kind": "serialization",
        "label": "Bank XML",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:bank-xml",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-proprietary-sample-required",
        "kind": "file",
        "label": "Proprietary sample required",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:proprietary-sample-required",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-mcp-json-rpc",
        "kind": "serialization",
        "label": "MCP JSON-RPC",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:mcp-json-rpc",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-external-item",
        "kind": "external-reference",
        "label": "External item",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact source or destination schema and release in the client overlay.",
        "qualifiedId": "format:external-item",
        "role": "Recipe format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-ubl-or-peppol-where-supported",
        "kind": "external-reference",
        "label": "UBL or Peppol where supported",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact installed product schema, release and representative authorised payload in the client overlay.",
        "qualifiedId": "format:structured-business-document",
        "role": "Client mapping format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-core-flat-file-csv",
        "kind": "serialization",
        "label": "Core flat file CSV",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact installed product schema, release and representative authorised payload in the client overlay.",
        "qualifiedId": "format:core-flat-file-csv",
        "role": "Client mapping format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-core-api-xml-or-json",
        "kind": "serialization",
        "label": "Core API XML or JSON",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact installed product schema, release and representative authorised payload in the client overlay.",
        "qualifiedId": "format:core-api-xml-or-json",
        "role": "Client mapping format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-cxml-where-configured",
        "kind": "serialization",
        "label": "cXML where configured",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact installed product schema, release and representative authorised payload in the client overlay.",
        "qualifiedId": "format:cxml-document",
        "role": "Client mapping format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-client-export",
        "kind": "file",
        "label": "Client export",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact installed product schema, release and representative authorised payload in the client overlay.",
        "qualifiedId": "format:client-export",
        "role": "Client mapping format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-cxml-or-edi-if-configured",
        "kind": "serialization",
        "label": "cXML or EDI if configured",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact installed product schema, release and representative authorised payload in the client overlay.",
        "qualifiedId": "format:trading-partner-document",
        "role": "Client mapping format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-client-import",
        "kind": "file",
        "label": "Client import",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact installed product schema, release and representative authorised payload in the client overlay.",
        "qualifiedId": "format:client-import",
        "role": "Client mapping format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-basware-xml",
        "kind": "serialization",
        "label": "Basware XML",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact installed product schema, release and representative authorised payload in the client overlay.",
        "qualifiedId": "format:basware-xml",
        "role": "Client mapping format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-basware-api",
        "kind": "external-reference",
        "label": "Basware API",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact installed product schema, release and representative authorised payload in the client overlay.",
        "qualifiedId": "format:basware-api",
        "role": "Client mapping format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-file-based-exchange",
        "kind": "file",
        "label": "File based exchange",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact installed product schema, release and representative authorised payload in the client overlay.",
        "qualifiedId": "format:file-based-exchange",
        "role": "Client mapping format family"
      },
      {
        "conformanceStandardIds": [],
        "id": "format-peppol-or-network-document",
        "kind": "external-reference",
        "label": "Peppol or network document",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact installed product schema, release and representative authorised payload in the client overlay.",
        "qualifiedId": "format:network-business-document",
        "role": "Client mapping format family"
      },
      {
        "conformanceStandardIds": [
          "cpv"
        ],
        "id": "format-cpv",
        "kind": "external-reference",
        "label": "Common Procurement Vocabulary classification",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact governed CPV release before exchanging classification codes.",
        "qualifiedId": "format:cpv",
        "role": "External European public-procurement classification reference",
        "standardId": "cpv"
      },
      {
        "conformanceStandardIds": [
          "eclass"
        ],
        "id": "format-eclass",
        "kind": "external-reference",
        "label": "ECLASS classification",
        "licenseId": "apache-2.0",
        "pinning": "Pin the exact governed ECLASS release before exchanging classes or properties.",
        "qualifiedId": "format:eclass",
        "role": "External product and service classification reference",
        "standardId": "eclass"
      }
    ],
    "licensing": {
      "defaultLicenseId": "bw-partner-1.0",
      "licenses": [
        {
          "assetPolicy": "platform-locked",
          "grant": "Free use, adaptation, redistribution and resale for participating partners. Execution and deployment of covered assets, and of derivatives of them, only on Beyond Work execution rails. Attribution as a Beyond Work foundation program for partners is required.",
          "id": "bw-partner-1.0",
          "label": "Beyond Work Partner License 1.0",
          "spdxId": "LicenseRef-BW-Partner-1.0",
          "textPath": "LICENSE"
        },
        {
          "assetPolicy": "integration-exempt",
          "grant": "Integration exemption. Definitions of third-party systems, system families, system roles, channels, formats and mapping boundaries are usable on any platform.",
          "id": "apache-2.0",
          "label": "Apache License 2.0",
          "spdxId": "Apache-2.0",
          "textPath": "LICENSES/Apache-2.0.txt"
        },
        {
          "assetPolicy": "partner-owned",
          "grant": "Owned by the named partner and distributed within the framework with the partner's permission. Rights come from the owning partner.",
          "id": "partner-owned",
          "label": "Partner-owned content",
          "spdxId": "LicenseRef-Partner-Owned",
          "textPath": "LICENSE"
        }
      ],
      "policyVersion": "1.0.0"
    },
    "mappingProfiles": [
      {
        "channelIds": [
          "channel-cxml",
          "channel-sap-document-exchange",
          "channel-csv",
          "channel-xml",
          "channel-sftp",
          "channel-narrow-api",
          "channel-edi"
        ],
        "clientOverlayRequired": true,
        "entityIds": [
          "party",
          "supplier-profile",
          "sourcing-event-record",
          "evidence-item",
          "award-scenario",
          "decision",
          "contract",
          "contract-version",
          "requisition",
          "requisition-line",
          "purchase-order",
          "order-line",
          "receipt",
          "receipt-line",
          "invoice",
          "invoice-line",
          "committed-action"
        ],
        "formatIds": [
          "format-cxml",
          "format-idoc",
          "format-csv",
          "format-xml",
          "format-ubl-or-peppol-where-supported"
        ],
        "id": "sap-ariba-document-exchange",
        "label": "SAP Ariba and SAP Business Network client mapping overlay",
        "licenseId": "apache-2.0",
        "mappingBoundary": "Pin the installed product, network route, document type, DTD or schema, realm configuration and sample payload. Prefer durable document exchange over a product API where it supports the required outcome. Client schema and representative payloads are required before field-level compatibility can be claimed.",
        "recipeIds": [
          "source-snapshot-delta-ingest",
          "master-reference-sync",
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "punchout-catalogue-session"
        ],
        "systemIds": [
          "sap-ariba-suite",
          "sap-business-network"
        ]
      },
      {
        "channelIds": [
          "channel-coupa-core-flat-file-csv",
          "channel-coupa-core-api-xml-json",
          "channel-cxml-where-configured"
        ],
        "clientOverlayRequired": true,
        "entityIds": [
          "party",
          "supplier-profile",
          "sourcing-event-record",
          "contract",
          "contract-version",
          "requisition",
          "requisition-line",
          "purchase-order",
          "order-line",
          "receipt",
          "receipt-line",
          "invoice",
          "invoice-line"
        ],
        "formatIds": [
          "format-core-flat-file-csv",
          "format-core-api-xml-or-json",
          "format-cxml-where-configured"
        ],
        "id": "coupa-exchange",
        "label": "Coupa client mapping overlay",
        "licenseId": "apache-2.0",
        "mappingBoundary": "Official documentation confirms Core API XML or JSON and Core flat-file CSV capabilities. Field mappings remain edition, object and sample specific. Client schema and representative payloads are required before field-level compatibility can be claimed.",
        "recipeIds": [
          "source-snapshot-delta-ingest",
          "master-reference-sync",
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "punchout-catalogue-session"
        ],
        "systemIds": [
          "coupa"
        ]
      },
      {
        "channelIds": [
          "channel-tenant-export-import",
          "channel-csv",
          "channel-xml",
          "channel-json",
          "channel-cxml-or-edi-if-configured"
        ],
        "clientOverlayRequired": true,
        "entityIds": [
          "party",
          "supplier-profile",
          "sourcing-event-record",
          "contract",
          "contract-version",
          "requisition",
          "requisition-line",
          "purchase-order",
          "order-line",
          "receipt",
          "receipt-line",
          "invoice",
          "invoice-line"
        ],
        "formatIds": [
          "format-client-export",
          "format-csv",
          "format-xml",
          "format-json",
          "format-cxml-or-edi-if-configured",
          "format-client-import"
        ],
        "id": "ivalua-exchange",
        "label": "Ivalua client mapping overlay",
        "licenseId": "apache-2.0",
        "mappingBoundary": "Pin the installed Ivalua release, enabled import and export definitions, tenant extensions and representative authorised payloads in the client overlay. Client schema and representative payloads are required before field-level compatibility can be claimed.",
        "recipeIds": [
          "source-snapshot-delta-ingest",
          "master-reference-sync",
          "structured-business-document-ingest",
          "structured-business-document-outbound"
        ],
        "systemIds": [
          "ivalua"
        ]
      },
      {
        "channelIds": [
          "channel-basware-xml",
          "channel-basware-api",
          "channel-file-based-exchange",
          "channel-peppol-or-network-document"
        ],
        "clientOverlayRequired": true,
        "entityIds": [
          "invoice",
          "invoice-line",
          "invoice-match-assessment",
          "exception",
          "decision",
          "committed-action",
          "integration-state",
          "source-record-reference",
          "evidence-item"
        ],
        "formatIds": [
          "format-basware-xml",
          "format-basware-api",
          "format-file-based-exchange",
          "format-peppol-or-network-document"
        ],
        "id": "basware-exchange",
        "label": "Basware client mapping overlay",
        "licenseId": "apache-2.0",
        "mappingBoundary": "Official developer documentation describes API, XML and file-based integration choices and publishes an XML format reference. Pin the selected interface and client tenant configuration. Client schema and representative payloads are required before field-level compatibility can be claimed.",
        "recipeIds": [
          "source-snapshot-delta-ingest",
          "structured-business-document-ingest",
          "structured-business-document-outbound"
        ],
        "systemIds": [
          "basware"
        ]
      }
    ],
    "moduleBindings": [
      {
        "businessModuleId": "spend-data-foundation",
        "entityIds": [
          "spend-record",
          "spend-classification-decision",
          "taxonomy-version",
          "category-dimension-assignment",
          "tail-spend-evaluation"
        ],
        "inboundRecipeIds": [
          "source-snapshot-delta-ingest",
          "master-reference-sync",
          "external-analytics-exchange"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "external-analytics-exchange"
        ],
        "representativeSystemIds": [
          "sap-s4hana-ecc",
          "oracle-fusion-ebs",
          "microsoft-dynamics-365-finance-supply-chain",
          "infor-cloudsuite"
        ],
        "sharePointPosture": "Evidence and exception artifacts only; not the spend ledger.",
        "systemRoleIds": [
          "erp",
          "ap-platform",
          "expense-platform",
          "data-warehouse",
          "spend-analytics",
          "mdm"
        ],
        "toolRecipeId": "tool-spend-data-foundation"
      },
      {
        "businessModuleId": "category-opportunity-radar",
        "entityIds": [
          "category-opportunity",
          "spend-record",
          "business-unit",
          "category",
          "source-record-reference",
          "evidence-item",
          "authority-envelope",
          "learning-example",
          "evaluation-result",
          "integration-state",
          "tail-spend-evaluation"
        ],
        "inboundRecipeIds": [
          "external-analytics-exchange",
          "risk-and-reference-evidence-feed",
          "master-reference-sync"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "external-analytics-exchange"
        ],
        "representativeSystemIds": [
          "client-prediction-models"
        ],
        "sharePointPosture": "Bind category evidence and approved working artifacts to the opportunity record.",
        "systemRoleIds": [
          "spend-analytics",
          "warehouse",
          "category-suite",
          "market-intelligence",
          "risk-platform",
          "planning"
        ],
        "toolRecipeId": "tool-category-opportunity-radar"
      },
      {
        "businessModuleId": "category-strategy-orchestrator",
        "entityIds": [
          "category-strategy",
          "category-opportunity",
          "spend-record",
          "tail-spend-evaluation"
        ],
        "inboundRecipeIds": [
          "external-analytics-exchange",
          "risk-and-reference-evidence-feed",
          "sharepoint-content-binding"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "sharepoint-content-binding",
          "external-analytics-exchange"
        ],
        "representativeSystemIds": [],
        "sharePointPosture": "Controlled document workspace and publication channel; canonical strategy state remains in GroundWorks.",
        "systemRoleIds": [
          "category-suite",
          "planning",
          "warehouse",
          "sharepoint",
          "office-documents"
        ],
        "toolRecipeId": "tool-category-strategy-orchestrator"
      },
      {
        "businessModuleId": "policy-rule-lifecycle",
        "entityIds": [
          "policy-rule-release",
          "tail-spend-rule",
          "policy-change-impact",
          "policy-guidance-result"
        ],
        "inboundRecipeIds": [
          "sharepoint-content-binding",
          "master-reference-sync"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "sharepoint-content-binding",
          "copilot-synced-knowledge-projection"
        ],
        "representativeSystemIds": [],
        "sharePointPosture": "Policy source and review workspace with exact version and approval binding.",
        "systemRoleIds": [
          "policy-repository",
          "sharepoint",
          "grc",
          "document-management"
        ],
        "toolRecipeId": "tool-policy-rule-lifecycle"
      },
      {
        "businessModuleId": "policy-guidance",
        "entityIds": [
          "policy-guidance-result",
          "policy-rule-release",
          "evidence-item",
          "policy",
          "policy-version",
          "exception",
          "registry-release",
          "tail-spend-evaluation",
          "policy-change-impact"
        ],
        "inboundRecipeIds": [
          "sharepoint-content-binding",
          "copilot-synced-knowledge-projection"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "copilot-synced-knowledge-projection",
          "copilot-federated-knowledge-query"
        ],
        "representativeSystemIds": [],
        "sharePointPosture": "Approved policy corpus and cited source versions.",
        "systemRoleIds": [
          "policy-repository",
          "sharepoint",
          "intranet",
          "service-management"
        ],
        "toolRecipeId": "tool-policy-guidance"
      },
      {
        "businessModuleId": "procurement-service-catalogue",
        "entityIds": [
          "procurement-service-offering",
          "policy-rule-release",
          "policy-change-impact"
        ],
        "inboundRecipeIds": [
          "master-reference-sync",
          "sharepoint-content-binding"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "copilot-synced-knowledge-projection",
          "copilot-federated-knowledge-query"
        ],
        "representativeSystemIds": [
          "sap-ariba-suite",
          "ivalua",
          "gep-smart",
          "jaggaer"
        ],
        "sharePointPosture": "Optional publication channel; service eligibility and version stay canonical.",
        "systemRoleIds": [
          "service-catalogue",
          "procurement-suite",
          "service-management",
          "sharepoint"
        ],
        "toolRecipeId": "tool-procurement-service-catalogue"
      },
      {
        "businessModuleId": "intelligent-intake",
        "entityIds": [
          "intake-request",
          "procurement-service-offering",
          "person",
          "business-unit",
          "category",
          "item-service",
          "source-record-reference",
          "policy",
          "policy-version",
          "authority-envelope",
          "learning-example",
          "evaluation-result",
          "integration-state",
          "budget",
          "policy-change-impact"
        ],
        "inboundRecipeIds": [
          "collaboration-intake",
          "sharepoint-content-binding",
          "master-reference-sync"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "sharepoint-content-binding"
        ],
        "representativeSystemIds": [],
        "sharePointPosture": "Accept attachments or list-form requests and project non-authoritative status.",
        "systemRoleIds": [
          "intake-orchestration",
          "service-management",
          "teams",
          "exchange",
          "sharepoint",
          "identity"
        ],
        "toolRecipeId": "tool-intelligent-intake"
      },
      {
        "businessModuleId": "request-enrichment-routing",
        "entityIds": [
          "enriched-request",
          "intake-request",
          "policy-guidance-result"
        ],
        "inboundRecipeIds": [
          "master-reference-sync",
          "risk-and-reference-evidence-feed",
          "external-analytics-exchange"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [],
        "representativeSystemIds": [
          "sap-s4hana-ecc",
          "oracle-fusion-ebs",
          "microsoft-dynamics-365-finance-supply-chain",
          "sap-ariba-suite"
        ],
        "sharePointPosture": "Read evidence links only where the request references governed content.",
        "systemRoleIds": [
          "procurement-suite",
          "erp",
          "supplier-master",
          "risk-platform",
          "budget-system"
        ],
        "toolRecipeId": "tool-request-enrichment-routing"
      },
      {
        "businessModuleId": "demand-orchestration",
        "entityIds": [
          "demand-case",
          "intake-request",
          "enriched-request",
          "person",
          "authority-envelope",
          "action-proposal",
          "committed-action",
          "decision",
          "exception",
          "audit-event",
          "business-event",
          "integration-state",
          "registry-release"
        ],
        "inboundRecipeIds": [
          "collaboration-intake",
          "master-reference-sync"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "sharepoint-content-binding",
          "collaboration-intake"
        ],
        "representativeSystemIds": [
          "sap-ariba-suite",
          "ivalua",
          "gep-smart",
          "jaggaer"
        ],
        "sharePointPosture": "Collaboration projection only; canonical case and handoffs remain in GroundWorks.",
        "systemRoleIds": [
          "intake-orchestration",
          "service-management",
          "workflow-platform",
          "procurement-suite",
          "collaboration"
        ],
        "toolRecipeId": "tool-demand-orchestration"
      },
      {
        "businessModuleId": "demand-consolidation-portfolio",
        "entityIds": [
          "demand-portfolio",
          "demand-case",
          "budget"
        ],
        "inboundRecipeIds": [
          "external-analytics-exchange",
          "master-reference-sync"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "external-analytics-exchange",
          "sharepoint-content-binding"
        ],
        "representativeSystemIds": [
          "sap-ibp",
          "client-prediction-models"
        ],
        "sharePointPosture": "Planning artifact exchange and review only.",
        "systemRoleIds": [
          "planning",
          "intake-orchestration",
          "warehouse",
          "sourcing-suite"
        ],
        "toolRecipeId": "tool-demand-consolidation-portfolio"
      },
      {
        "businessModuleId": "sourcing-pipeline-discovery",
        "entityIds": [
          "sourcing-opportunity",
          "category-opportunity",
          "demand-portfolio",
          "category-strategy",
          "buy-timing-mandate"
        ],
        "inboundRecipeIds": [
          "external-analytics-exchange",
          "master-reference-sync",
          "sharepoint-content-binding"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "external-analytics-exchange"
        ],
        "representativeSystemIds": [
          "icertis"
        ],
        "sharePointPosture": "Evidence and planning artifact binding only.",
        "systemRoleIds": [
          "sourcing-suite",
          "intake-orchestration",
          "clm",
          "category-suite",
          "planning"
        ],
        "toolRecipeId": "tool-sourcing-pipeline-discovery"
      },
      {
        "businessModuleId": "sourcing-event",
        "entityIds": [
          "sourcing-event-record",
          "sourcing-opportunity",
          "party",
          "person",
          "category",
          "item-service",
          "source-record-reference",
          "evidence-item",
          "policy",
          "policy-version",
          "authority-envelope",
          "action-proposal",
          "committed-action",
          "decision",
          "exception",
          "audit-event",
          "business-event",
          "learning-example",
          "evaluation-result",
          "integration-state",
          "registry-release",
          "supplier-response",
          "buy-timing-mandate"
        ],
        "inboundRecipeIds": [
          "master-reference-sync",
          "structured-business-document-ingest",
          "sharepoint-content-binding"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "structured-business-document-outbound",
          "sharepoint-content-binding"
        ],
        "representativeSystemIds": [],
        "sharePointPosture": "Event document workspace where selected; supplier submissions remain exact source artifacts.",
        "systemRoleIds": [
          "sourcing-suite",
          "supplier-network",
          "erp-master",
          "sharepoint",
          "office-documents"
        ],
        "toolRecipeId": "tool-sourcing-event"
      },
      {
        "businessModuleId": "bid-evaluation-award",
        "entityIds": [
          "award-scenario",
          "sourcing-event-record",
          "supplier-response",
          "negotiation-session",
          "tactical-sourcing-case"
        ],
        "inboundRecipeIds": [
          "structured-business-document-ingest",
          "external-analytics-exchange",
          "sharepoint-content-binding"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "structured-business-document-outbound",
          "external-analytics-exchange"
        ],
        "representativeSystemIds": [],
        "sharePointPosture": "Evidence and award-paper round trip; not the award authority.",
        "systemRoleIds": [
          "sourcing-suite",
          "optimisation-specialist",
          "spreadsheet",
          "supplier-network"
        ],
        "toolRecipeId": "tool-bid-evaluation-award"
      },
      {
        "businessModuleId": "negotiation-copilot",
        "entityIds": [
          "negotiation-session",
          "award-scenario",
          "sourcing-opportunity",
          "authority-envelope",
          "supplier-response",
          "buy-timing-mandate"
        ],
        "inboundRecipeIds": [
          "sharepoint-content-binding",
          "external-analytics-exchange",
          "master-reference-sync"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "sharepoint-content-binding"
        ],
        "representativeSystemIds": [
          "icertis"
        ],
        "sharePointPosture": "Bind meeting notes and negotiation artifacts; exact authority remains canonical.",
        "systemRoleIds": [
          "sourcing-suite",
          "clm",
          "warehouse",
          "sharepoint",
          "office-documents",
          "negotiation-specialist"
        ],
        "toolRecipeId": "tool-negotiation-copilot"
      },
      {
        "businessModuleId": "tactical-sourcing-autonomy",
        "entityIds": [
          "tactical-sourcing-case",
          "demand-case",
          "sourcing-opportunity",
          "supplier-response",
          "buy-timing-mandate"
        ],
        "inboundRecipeIds": [
          "structured-business-document-ingest",
          "master-reference-sync"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "structured-business-document-outbound"
        ],
        "representativeSystemIds": [],
        "sharePointPosture": "Exception evidence only; not a straight-through execution queue.",
        "systemRoleIds": [
          "sourcing-suite",
          "supplier-network",
          "erp-master",
          "procurement-policy"
        ],
        "toolRecipeId": "tool-tactical-sourcing-autonomy"
      },
      {
        "businessModuleId": "contract-intake-digitization",
        "entityIds": [
          "contract-template",
          "contract-intake",
          "contract",
          "supplier-profile"
        ],
        "inboundRecipeIds": [
          "sharepoint-content-binding",
          "collaboration-intake",
          "structured-business-document-ingest"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [],
        "representativeSystemIds": [
          "icertis",
          "ironclad",
          "agiloft"
        ],
        "sharePointPosture": "Primary governed content source where selected, with exact file version and permission binding.",
        "systemRoleIds": [
          "sharepoint",
          "clm",
          "email",
          "document-repository",
          "signature"
        ],
        "toolRecipeId": "tool-contract-intake-digitization"
      },
      {
        "businessModuleId": "contract-authoring-review",
        "entityIds": [
          "contract-intake",
          "contract-template",
          "clause-library-entry",
          "business-event",
          "contract",
          "contract-version",
          "clause-deviation",
          "party",
          "person",
          "source-record-reference",
          "evidence-item",
          "policy",
          "policy-version",
          "authority-envelope",
          "action-proposal",
          "committed-action",
          "decision",
          "exception",
          "audit-event",
          "learning-example",
          "evaluation-result",
          "integration-state",
          "registry-release"
        ],
        "inboundRecipeIds": [
          "sharepoint-content-binding",
          "master-reference-sync"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "sharepoint-content-binding"
        ],
        "representativeSystemIds": [
          "icertis",
          "ironclad",
          "agiloft"
        ],
        "sharePointPosture": "Native file round trip and version workspace; canonical deviations and decisions remain separate.",
        "systemRoleIds": [
          "clm",
          "sharepoint",
          "word",
          "document-repository"
        ],
        "toolRecipeId": "tool-contract-authoring-review"
      },
      {
        "businessModuleId": "contract-approval-repository",
        "entityIds": [
          "contract-template",
          "contract",
          "contract-version",
          "clause-deviation",
          "contract-approval",
          "audit-event",
          "contract-compliance-finding"
        ],
        "inboundRecipeIds": [
          "sharepoint-content-binding",
          "master-reference-sync"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "sharepoint-content-binding",
          "structured-business-document-outbound"
        ],
        "representativeSystemIds": [
          "icertis",
          "ironclad",
          "agiloft"
        ],
        "sharePointPosture": "Approved repository option with exact-content, signature and canonical activation reconciliation.",
        "systemRoleIds": [
          "clm",
          "signature",
          "sharepoint",
          "document-repository"
        ],
        "toolRecipeId": "tool-contract-approval-repository"
      },
      {
        "businessModuleId": "obligation-monitoring",
        "entityIds": [
          "clause-library-entry",
          "contract",
          "contract-version",
          "contract-approval",
          "contract-obligation",
          "contract-entitlement",
          "business-event",
          "contract-change"
        ],
        "inboundRecipeIds": [
          "sharepoint-content-binding",
          "external-analytics-exchange",
          "risk-and-reference-evidence-feed"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "collaboration-intake",
          "sharepoint-content-binding"
        ],
        "representativeSystemIds": [
          "icertis",
          "ironclad",
          "agiloft",
          "microsoft-teams"
        ],
        "sharePointPosture": "Source clause and completion-evidence binding; obligations remain canonical work.",
        "systemRoleIds": [
          "clm",
          "sharepoint",
          "performance-system",
          "service-management",
          "collaboration"
        ],
        "toolRecipeId": "tool-obligation-monitoring"
      },
      {
        "businessModuleId": "renewal-change-compliance",
        "entityIds": [
          "clause-library-entry",
          "contract",
          "contract-version",
          "contract-obligation",
          "contract-entitlement",
          "contract-change",
          "contract-compliance-finding"
        ],
        "inboundRecipeIds": [
          "sharepoint-content-binding",
          "external-analytics-exchange",
          "risk-and-reference-evidence-feed"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "sharepoint-content-binding",
          "structured-business-document-outbound"
        ],
        "representativeSystemIds": [
          "sap-s4hana-ecc",
          "oracle-fusion-ebs",
          "icertis",
          "ironclad"
        ],
        "sharePointPosture": "Evidence and approved change-document round trip; decision and commitment stay canonical.",
        "systemRoleIds": [
          "clm",
          "sharepoint",
          "erp",
          "usage-analytics",
          "risk-platform"
        ],
        "toolRecipeId": "tool-renewal-change-compliance"
      },
      {
        "businessModuleId": "supplier-onboarding",
        "entityIds": [
          "supplier-profile",
          "supplier-onboarding-case",
          "supplier-qualification",
          "supplier-risk-assessment",
          "party",
          "source-record-reference",
          "policy",
          "integration-state",
          "registry-release"
        ],
        "inboundRecipeIds": [
          "master-reference-sync",
          "risk-and-reference-evidence-feed",
          "collaboration-intake",
          "sharepoint-content-binding"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "master-reference-sync",
          "structured-business-document-outbound"
        ],
        "representativeSystemIds": [
          "sap-s4hana-ecc",
          "oracle-fusion-ebs",
          "microsoft-dynamics-365-finance-supply-chain",
          "infor-cloudsuite"
        ],
        "sharePointPosture": "Evidence artifact channel only where permitted; sensitive evidence needs field and file access controls.",
        "systemRoleIds": [
          "supplier-portal",
          "supplier-master",
          "erp",
          "risk-platform",
          "tax-registry",
          "identity-provider"
        ],
        "toolRecipeId": "tool-supplier-onboarding"
      },
      {
        "businessModuleId": "supplier-master-qualification",
        "entityIds": [
          "supplier-profile",
          "supplier-onboarding-case",
          "supplier-risk-assessment",
          "supplier-qualification",
          "supplier-master-change"
        ],
        "inboundRecipeIds": [
          "master-reference-sync",
          "risk-and-reference-evidence-feed"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "master-reference-sync"
        ],
        "representativeSystemIds": [],
        "sharePointPosture": "No master authority; may hold controlled evidence referenced by a change case.",
        "systemRoleIds": [
          "erp-supplier-master",
          "mdm",
          "tax-registry",
          "bank-validation",
          "risk-platform"
        ],
        "toolRecipeId": "tool-supplier-master-qualification"
      },
      {
        "businessModuleId": "third-party-risk-review",
        "entityIds": [
          "supplier-profile",
          "supplier-onboarding-case",
          "supplier-qualification",
          "supplier-risk-signal",
          "supplier-tier-link",
          "supplier-risk-assessment",
          "person",
          "evidence-item",
          "policy-version",
          "authority-envelope",
          "action-proposal",
          "committed-action",
          "decision",
          "exception",
          "audit-event",
          "business-event",
          "learning-example",
          "evaluation-result"
        ],
        "inboundRecipeIds": [
          "risk-and-reference-evidence-feed",
          "master-reference-sync",
          "sharepoint-content-binding"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "sharepoint-content-binding"
        ],
        "representativeSystemIds": [],
        "sharePointPosture": "Assessment artifacts and cited evidence; residual-risk decision remains canonical.",
        "systemRoleIds": [
          "grc",
          "risk-platform",
          "supplier-portal",
          "evidence-network",
          "sharepoint"
        ],
        "toolRecipeId": "tool-third-party-risk-review"
      },
      {
        "businessModuleId": "continuous-risk-monitoring",
        "entityIds": [
          "supplier-profile",
          "supplier-risk-assessment",
          "supplier-risk-signal",
          "supplier-risk-case",
          "supplier-tier-link",
          "supplier-master-change"
        ],
        "inboundRecipeIds": [
          "risk-and-reference-evidence-feed",
          "master-reference-sync"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "collaboration-intake"
        ],
        "representativeSystemIds": [],
        "sharePointPosture": "Evidence link only; not the signal ledger.",
        "systemRoleIds": [
          "risk-monitoring",
          "news-and-market-data",
          "cyber-risk",
          "sustainability",
          "supplier-master"
        ],
        "toolRecipeId": "tool-continuous-risk-monitoring"
      },
      {
        "businessModuleId": "supplier-remediation-exit",
        "entityIds": [
          "supplier-profile",
          "supplier-risk-assessment",
          "supplier-risk-case",
          "supplier-performance-signal",
          "supplier-remediation-action",
          "supplier-offboarding-case",
          "contract",
          "purchase-order"
        ],
        "inboundRecipeIds": [
          "master-reference-sync",
          "risk-and-reference-evidence-feed",
          "external-analytics-exchange"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "master-reference-sync",
          "structured-business-document-outbound",
          "collaboration-intake"
        ],
        "representativeSystemIds": [
          "sap-s4hana-ecc",
          "oracle-fusion-ebs",
          "microsoft-dynamics-365-finance-supply-chain",
          "infor-cloudsuite"
        ],
        "sharePointPosture": "Controlled remediation evidence and exit plan artifacts; completion is canonical and reconciled across systems.",
        "systemRoleIds": [
          "risk-platform",
          "erp",
          "identity-provider",
          "clm",
          "business-continuity",
          "collaboration"
        ],
        "toolRecipeId": "tool-supplier-remediation-exit"
      },
      {
        "businessModuleId": "guided-buying",
        "entityIds": [
          "buying-request",
          "catalogue-line",
          "supplier-profile",
          "supplier-qualification",
          "contract",
          "party",
          "business-unit",
          "category",
          "item-service",
          "source-record-reference",
          "policy",
          "policy-version",
          "authority-envelope",
          "evaluation-result",
          "integration-state",
          "registry-release"
        ],
        "inboundRecipeIds": [
          "master-reference-sync",
          "punchout-catalogue-session",
          "structured-business-document-ingest"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "punchout-catalogue-session"
        ],
        "representativeSystemIds": [
          "sap-s4hana-ecc",
          "oracle-fusion-ebs",
          "microsoft-dynamics-365-finance-supply-chain",
          "infor-cloudsuite"
        ],
        "sharePointPosture": "Read governed specifications or evidence only; buying route remains canonical.",
        "systemRoleIds": [
          "procurement-suite",
          "catalogue",
          "supplier-network",
          "erp",
          "policy-repository"
        ],
        "toolRecipeId": "tool-guided-buying"
      },
      {
        "businessModuleId": "requisition-policy-routing",
        "entityIds": [
          "buying-request",
          "requisition",
          "requisition-line",
          "catalogue-line",
          "supplier-profile",
          "supplier-qualification",
          "budget",
          "policy-change-impact"
        ],
        "inboundRecipeIds": [
          "master-reference-sync",
          "external-analytics-exchange",
          "punchout-catalogue-session"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "structured-business-document-outbound"
        ],
        "representativeSystemIds": [
          "sap-s4hana-ecc",
          "oracle-fusion-ebs",
          "microsoft-dynamics-365-finance-supply-chain",
          "infor-cloudsuite"
        ],
        "sharePointPosture": "Attachment evidence only; requisition is not a SharePoint list record.",
        "systemRoleIds": [
          "erp",
          "procurement-suite",
          "budget-system",
          "catalogue"
        ],
        "toolRecipeId": "tool-requisition-policy-routing"
      },
      {
        "businessModuleId": "purchase-order-orchestration",
        "entityIds": [
          "requisition",
          "requisition-line",
          "supplier-profile",
          "contract",
          "purchase-order",
          "order-line",
          "order-response",
          "catalogue-line"
        ],
        "inboundRecipeIds": [
          "structured-business-document-ingest",
          "master-reference-sync"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "structured-business-document-outbound"
        ],
        "representativeSystemIds": [
          "sap-s4hana-ecc",
          "oracle-fusion-ebs",
          "microsoft-dynamics-365-finance-supply-chain",
          "infor-cloudsuite"
        ],
        "sharePointPosture": "No order authority; supporting artifacts only.",
        "systemRoleIds": [
          "erp",
          "procurement-suite",
          "supplier-network",
          "edi-van",
          "peppol-access-point"
        ],
        "toolRecipeId": "tool-purchase-order-orchestration"
      },
      {
        "businessModuleId": "purchase-order-exception",
        "entityIds": [
          "purchase-order",
          "order-line",
          "order-response",
          "purchase-order-exception",
          "shipment",
          "receipt",
          "authority-envelope",
          "action-proposal",
          "committed-action",
          "decision",
          "exception",
          "audit-event",
          "business-event",
          "catalogue-line",
          "return-claim"
        ],
        "inboundRecipeIds": [
          "structured-business-document-ingest",
          "master-reference-sync"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "structured-business-document-outbound"
        ],
        "representativeSystemIds": [
          "sap-s4hana-ecc",
          "oracle-fusion-ebs",
          "microsoft-dynamics-365-finance-supply-chain",
          "infor-cloudsuite"
        ],
        "sharePointPosture": "Exception evidence only; source correction occurs through the owning system.",
        "systemRoleIds": [
          "erp",
          "procurement-suite",
          "supplier-network",
          "receiving-system"
        ],
        "toolRecipeId": "tool-purchase-order-exception"
      },
      {
        "businessModuleId": "receiving-service-entry",
        "entityIds": [
          "purchase-order",
          "order-line",
          "shipment",
          "receipt",
          "receipt-line",
          "service-entry-sheet",
          "return-claim"
        ],
        "inboundRecipeIds": [
          "structured-business-document-ingest",
          "collaboration-intake"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "structured-business-document-outbound"
        ],
        "representativeSystemIds": [
          "sap-s4hana-ecc",
          "oracle-fusion-ebs",
          "microsoft-dynamics-365-finance-supply-chain",
          "infor-cloudsuite"
        ],
        "sharePointPosture": "Delivery or service evidence binding where selected; receipt commitment remains in the authoritative system.",
        "systemRoleIds": [
          "erp",
          "warehouse-management",
          "field-service",
          "supplier-network",
          "procurement-suite"
        ],
        "toolRecipeId": "tool-receiving-service-entry"
      },
      {
        "businessModuleId": "invoice-intake-match",
        "entityIds": [
          "invoice",
          "invoice-line",
          "invoice-match-assessment",
          "purchase-order",
          "order-line",
          "receipt",
          "receipt-line",
          "service-entry-sheet"
        ],
        "inboundRecipeIds": [
          "structured-business-document-ingest",
          "master-reference-sync"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "structured-business-document-outbound"
        ],
        "representativeSystemIds": [
          "medius",
          "esker"
        ],
        "sharePointPosture": "Governed artifact source only for exception channels; not the invoice ledger.",
        "systemRoleIds": [
          "erp-ap",
          "invoice-network",
          "peppol-access-point",
          "ap-automation",
          "document-capture"
        ],
        "toolRecipeId": "tool-invoice-intake-match"
      },
      {
        "businessModuleId": "invoice-exception-triage",
        "entityIds": [
          "invoice",
          "invoice-match-assessment",
          "invoice-exception",
          "supplier-invoice-resolution",
          "party",
          "category",
          "item-service",
          "source-record-reference",
          "evidence-item",
          "policy",
          "policy-version",
          "authority-envelope",
          "action-proposal",
          "committed-action",
          "decision",
          "exception",
          "audit-event",
          "business-event",
          "learning-example",
          "evaluation-result",
          "integration-state",
          "registry-release",
          "purchase-order-exception"
        ],
        "inboundRecipeIds": [
          "structured-business-document-ingest",
          "master-reference-sync",
          "external-analytics-exchange"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "structured-business-document-outbound",
          "collaboration-intake"
        ],
        "representativeSystemIds": [
          "sap-ariba-suite",
          "ivalua",
          "gep-smart",
          "jaggaer"
        ],
        "sharePointPosture": "Evidence or collaboration projection only; source disposition stays in AP or ERP.",
        "systemRoleIds": [
          "erp-ap",
          "ap-automation",
          "procurement-suite",
          "invoice-network",
          "service-management"
        ],
        "toolRecipeId": "tool-invoice-exception-triage"
      },
      {
        "businessModuleId": "supplier-invoice-resolution",
        "entityIds": [
          "invoice-exception",
          "invoice",
          "supplier-invoice-resolution",
          "invoice-line"
        ],
        "inboundRecipeIds": [
          "structured-business-document-ingest",
          "collaboration-intake"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "structured-business-document-outbound",
          "collaboration-intake"
        ],
        "representativeSystemIds": [
          "medius",
          "esker"
        ],
        "sharePointPosture": "Controlled supporting evidence only; supplier exchange remains in an approved channel.",
        "systemRoleIds": [
          "invoice-network",
          "supplier-portal",
          "email",
          "erp-ap",
          "ap-automation"
        ],
        "toolRecipeId": "tool-supplier-invoice-resolution"
      },
      {
        "businessModuleId": "payment-readiness",
        "entityIds": [
          "invoice",
          "invoice-match-assessment",
          "invoice-exception",
          "payment-readiness-assessment",
          "person",
          "policy",
          "policy-version",
          "authority-envelope",
          "exception",
          "audit-event",
          "business-event",
          "integration-state",
          "invoice-line"
        ],
        "inboundRecipeIds": [
          "master-reference-sync",
          "external-analytics-exchange",
          "risk-and-reference-evidence-feed"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [],
        "representativeSystemIds": [],
        "sharePointPosture": "Evidence reference only; never a payment approval surface by default.",
        "systemRoleIds": [
          "erp-ap",
          "treasury",
          "fraud-control",
          "tax-control",
          "bank-validation"
        ],
        "toolRecipeId": "tool-payment-readiness"
      },
      {
        "businessModuleId": "payment-execution-guard",
        "entityIds": [
          "payment-readiness-assessment",
          "invoice",
          "payment-instruction",
          "payment-execution-status"
        ],
        "inboundRecipeIds": [
          "payment-and-bank-message-exchange",
          "master-reference-sync"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "payment-and-bank-message-exchange"
        ],
        "representativeSystemIds": [
          "coupa-pay"
        ],
        "sharePointPosture": "Out of scope for payment execution.",
        "systemRoleIds": [
          "treasury",
          "erp-ap",
          "bank",
          "payment-platform",
          "fraud-control"
        ],
        "toolRecipeId": "tool-payment-execution-guard"
      },
      {
        "businessModuleId": "supplier-segmentation-governance",
        "entityIds": [
          "supplier-performance-observation",
          "supplier-segment-assignment"
        ],
        "inboundRecipeIds": [
          "master-reference-sync",
          "external-analytics-exchange",
          "risk-and-reference-evidence-feed"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "external-analytics-exchange"
        ],
        "representativeSystemIds": [],
        "sharePointPosture": "Governance evidence and review artifact only.",
        "systemRoleIds": [
          "srm",
          "supplier-master",
          "warehouse",
          "risk-platform",
          "category-suite"
        ],
        "toolRecipeId": "tool-supplier-segmentation-governance"
      },
      {
        "businessModuleId": "supplier-performance-monitor-correct",
        "entityIds": [
          "supplier-segment-assignment",
          "supplier-performance-observation",
          "supplier-performance-signal",
          "supplier-performance-review-record"
        ],
        "inboundRecipeIds": [
          "external-analytics-exchange",
          "structured-business-document-ingest",
          "risk-and-reference-evidence-feed"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "collaboration-intake",
          "sharepoint-content-binding"
        ],
        "representativeSystemIds": [
          "sap-s4hana-ecc"
        ],
        "sharePointPosture": "Evidence and corrective-action artifact binding; canonical progress remains in GroundWorks.",
        "systemRoleIds": [
          "srm",
          "erp",
          "quality-system",
          "logistics",
          "risk-platform"
        ],
        "toolRecipeId": "tool-supplier-performance-monitor-correct"
      },
      {
        "businessModuleId": "supplier-performance-review",
        "entityIds": [
          "supplier-segment-assignment",
          "supplier-performance-observation",
          "supplier-performance-review-record",
          "party",
          "source-record-reference",
          "authority-envelope",
          "decision",
          "audit-event",
          "business-event",
          "learning-example",
          "evaluation-result",
          "integration-state",
          "registry-release",
          "supplier-performance-signal",
          "supplier-remediation-action",
          "supplier-offboarding-case"
        ],
        "inboundRecipeIds": [
          "external-analytics-exchange",
          "sharepoint-content-binding",
          "risk-and-reference-evidence-feed"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "sharepoint-content-binding",
          "external-analytics-exchange"
        ],
        "representativeSystemIds": [],
        "sharePointPosture": "Review pack, meeting artifacts and source evidence; accepted commitments remain canonical.",
        "systemRoleIds": [
          "srm",
          "sharepoint",
          "spreadsheet",
          "risk-platform",
          "quality-system"
        ],
        "toolRecipeId": "tool-supplier-performance-review"
      },
      {
        "businessModuleId": "supplier-innovation-pipeline",
        "entityIds": [
          "supplier-segment-assignment",
          "supplier-performance-review-record",
          "supplier-innovation-case",
          "supplier-joint-value-plan"
        ],
        "inboundRecipeIds": [
          "collaboration-intake",
          "sharepoint-content-binding"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "sharepoint-content-binding",
          "collaboration-intake"
        ],
        "representativeSystemIds": [
          "microsoft-teams"
        ],
        "sharePointPosture": "Controlled idea documents and collaboration space; stage and IP decisions remain canonical.",
        "systemRoleIds": [
          "innovation-portal",
          "srm",
          "sharepoint",
          "collaboration",
          "idea-management"
        ],
        "toolRecipeId": "tool-supplier-innovation-pipeline"
      },
      {
        "businessModuleId": "supplier-relationship-joint-value",
        "entityIds": [
          "supplier-segment-assignment",
          "supplier-performance-review-record",
          "supplier-innovation-case",
          "supplier-joint-value-plan"
        ],
        "inboundRecipeIds": [
          "external-analytics-exchange",
          "sharepoint-content-binding",
          "risk-and-reference-evidence-feed"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "external-analytics-exchange",
          "sharepoint-content-binding"
        ],
        "representativeSystemIds": [],
        "sharePointPosture": "Joint-plan document and collaboration channel; canonical commitments and value evidence remain separate.",
        "systemRoleIds": [
          "srm",
          "planning",
          "warehouse",
          "sharepoint",
          "value-management"
        ],
        "toolRecipeId": "tool-supplier-relationship-joint-value"
      },
      {
        "businessModuleId": "value-opportunity-baseline",
        "entityIds": [
          "value-opportunity-baseline",
          "savings-initiative-record"
        ],
        "inboundRecipeIds": [
          "external-analytics-exchange",
          "master-reference-sync",
          "sharepoint-content-binding"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "external-analytics-exchange",
          "sharepoint-content-binding"
        ],
        "representativeSystemIds": [],
        "sharePointPosture": "Baseline working artifacts and approval evidence; committed baseline remains canonical.",
        "systemRoleIds": [
          "finance-ledger",
          "warehouse",
          "planning",
          "savings-platform",
          "spreadsheet"
        ],
        "toolRecipeId": "tool-value-opportunity-baseline"
      },
      {
        "businessModuleId": "savings-initiative",
        "entityIds": [
          "value-opportunity-baseline",
          "savings-initiative-record",
          "value-realization-attribution",
          "value-leakage-finding",
          "business-unit",
          "category",
          "source-record-reference",
          "evidence-item",
          "authority-envelope",
          "action-proposal",
          "committed-action",
          "decision",
          "exception",
          "audit-event",
          "business-event",
          "learning-example",
          "evaluation-result",
          "integration-state",
          "registry-release",
          "budget",
          "value-portfolio-forecast"
        ],
        "inboundRecipeIds": [
          "external-analytics-exchange",
          "master-reference-sync",
          "sharepoint-content-binding"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "external-analytics-exchange",
          "sharepoint-content-binding"
        ],
        "representativeSystemIds": [],
        "sharePointPosture": "Evidence and initiative-document binding; status and validation stay canonical.",
        "systemRoleIds": [
          "savings-platform",
          "finance-ledger",
          "planning",
          "warehouse",
          "sharepoint"
        ],
        "toolRecipeId": "tool-savings-initiative"
      },
      {
        "businessModuleId": "realization-reconciliation-attribution",
        "entityIds": [
          "value-opportunity-baseline",
          "savings-initiative-record",
          "value-realization-attribution",
          "value-leakage-finding",
          "budget",
          "payment-instruction",
          "payment-execution-status"
        ],
        "inboundRecipeIds": [
          "external-analytics-exchange",
          "master-reference-sync"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "external-analytics-exchange"
        ],
        "representativeSystemIds": [],
        "sharePointPosture": "Approval evidence only; actuals and attribution remain in finance and canonical records.",
        "systemRoleIds": [
          "finance-ledger",
          "warehouse",
          "planning",
          "savings-platform"
        ],
        "toolRecipeId": "tool-realization-reconciliation-attribution"
      },
      {
        "businessModuleId": "value-leakage-monitor",
        "entityIds": [
          "value-opportunity-baseline",
          "savings-initiative-record",
          "value-leakage-finding",
          "value-realization-attribution",
          "authority-envelope",
          "business-event"
        ],
        "inboundRecipeIds": [
          "external-analytics-exchange",
          "structured-business-document-ingest",
          "master-reference-sync"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "collaboration-intake",
          "external-analytics-exchange"
        ],
        "representativeSystemIds": [
          "sap-s4hana-ecc",
          "oracle-fusion-ebs",
          "microsoft-dynamics-365-finance-supply-chain",
          "infor-cloudsuite"
        ],
        "sharePointPosture": "Evidence or remediation artifact only; leakage state is canonical.",
        "systemRoleIds": [
          "warehouse",
          "erp",
          "clm",
          "savings-platform",
          "planning"
        ],
        "toolRecipeId": "tool-value-leakage-monitor"
      },
      {
        "businessModuleId": "value-portfolio-forecast",
        "entityIds": [
          "value-opportunity-baseline",
          "savings-initiative-record",
          "value-realization-attribution",
          "value-leakage-finding",
          "value-portfolio-forecast"
        ],
        "inboundRecipeIds": [
          "external-analytics-exchange",
          "master-reference-sync"
        ],
        "licenseId": "bw-partner-1.0",
        "outboundRecipeIds": [
          "external-analytics-exchange",
          "sharepoint-content-binding"
        ],
        "representativeSystemIds": [
          "sap-ibp"
        ],
        "sharePointPosture": "Forecast pack publication only; canonical version and definition remain in GroundWorks.",
        "systemRoleIds": [
          "planning",
          "warehouse",
          "savings-platform",
          "finance-reporting"
        ],
        "toolRecipeId": "tool-value-portfolio-forecast"
      }
    ],
    "proofLegend": [
      {
        "definition": "A versioned framework contract for an integration or tool outcome. It is not an installed connector.",
        "id": "recipe",
        "label": "Recipe",
        "licenseId": "bw-partner-1.0"
      },
      {
        "definition": "A synthetic application of a recipe to a procurement case. It is not runtime evidence.",
        "id": "illustrative-example",
        "label": "Illustrative example",
        "licenseId": "bw-partner-1.0"
      },
      {
        "definition": "A runnable bounded flow in the declared demonstration environment.",
        "id": "demo-workblock",
        "label": "Demo Workblock",
        "licenseId": "bw-partner-1.0"
      },
      {
        "definition": "An exact connector, identity, permission and target release accepted for a named scope.",
        "id": "configured-deployment",
        "label": "Configured deployment",
        "licenseId": "bw-partner-1.0"
      },
      {
        "definition": "A configured path operating inside its accepted envelope with current support evidence.",
        "id": "production-evidence",
        "label": "Production evidence",
        "licenseId": "bw-partner-1.0"
      }
    ],
    "recipes": [
      {
        "actionClasses": [
          "not-applicable"
        ],
        "authorityBoundary": "The source remains authoritative for declared source fields. Only the owning GroundWorks service or business module changes a canonical record.",
        "businessModuleIds": [
          "spend-data-foundation"
        ],
        "channelIds": [
          "channel-sftp",
          "channel-as2",
          "channel-object-storage",
          "channel-https",
          "channel-event-stream",
          "channel-client-ipaas"
        ],
        "configurableFields": [
          "Installed system and release",
          "Record and field ownership",
          "Identity and credentials",
          "Channel and format version",
          "Freshness and service envelope",
          "Acceptance evidence and support owner"
        ],
        "direction": "inbound",
        "domainWorkblockIds": [
          "strategy-policy-category-spend"
        ],
        "entityIds": [
          "source-record-reference",
          "evidence-item",
          "integration-state",
          "business-event",
          "spend-record",
          "party",
          "business-unit",
          "category"
        ],
        "formatIds": [
          "format-csv",
          "format-json",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "source-snapshot-delta-ingest",
        "inputEntityIds": [
          "source-record-reference",
          "evidence-item",
          "integration-state",
          "business-event"
        ],
        "label": "Source snapshot and delta ingest",
        "licenseId": "bw-partner-1.0",
        "outcome": "Ingest source-owned records without losing source version, watermark, control totals or late-arrival state.",
        "outputEntityIds": [
          "spend-record",
          "party",
          "business-unit",
          "category",
          "integration-state"
        ],
        "owner": "The owning GroundWorks module accepts the canonical projection; the source-system owner remains accountable for source completeness and delivery.",
        "proofClass": "recipe",
        "reliability": {
          "acknowledgement": "Source counts, control totals, accepted, rejected, duplicated, late and superseded counts.",
          "degradedState": "Preserve last-good projection with real age; quarantine incompatible schema.",
          "freshness": "Record source-observed time, last successful exchange, next expected update and freshness status. Retain last-good data when an update is late.",
          "idempotency": "Stable source system, object type, record key, version and line key.",
          "monitoring": "Monitor identity, availability, latency, volume, validation, acknowledgement, reconciliation and recovery against the configured operating envelope.",
          "reconciliation": "Source counts, control totals, accepted, rejected, duplicated, late and superseded counts.",
          "recovery": "Resume from recorded delivery state. Never retry an uncertain consequential effect blindly.",
          "rollback": "Stop new effects, restore the last accepted mapping and adapter version, then replay from recorded checkpoints after reconciliation."
        },
        "standardIds": [],
        "systemRoleIds": [
          "erp",
          "ap-platform",
          "expense-platform",
          "data-warehouse",
          "spend-analytics",
          "mdm"
        ],
        "trigger": "A scheduled snapshot, source delta, file arrival or source event starts the exchange at the cadence pinned in the client overlay."
      },
      {
        "actionClasses": [
          "not-applicable"
        ],
        "authorityBoundary": "The source remains authoritative for declared source fields. Only the owning GroundWorks service or business module changes a canonical record.",
        "businessModuleIds": [
          "spend-data-foundation",
          "category-opportunity-radar",
          "policy-rule-lifecycle",
          "procurement-service-catalogue",
          "intelligent-intake",
          "request-enrichment-routing",
          "demand-orchestration",
          "demand-consolidation-portfolio",
          "sourcing-pipeline-discovery",
          "sourcing-event",
          "negotiation-copilot",
          "tactical-sourcing-autonomy",
          "contract-authoring-review",
          "contract-approval-repository",
          "supplier-onboarding",
          "supplier-master-qualification",
          "third-party-risk-review",
          "continuous-risk-monitoring",
          "supplier-remediation-exit",
          "guided-buying",
          "requisition-policy-routing",
          "purchase-order-orchestration",
          "purchase-order-exception",
          "invoice-intake-match",
          "invoice-exception-triage",
          "payment-readiness",
          "payment-execution-guard",
          "supplier-segmentation-governance",
          "value-opportunity-baseline",
          "savings-initiative",
          "realization-reconciliation-attribution",
          "value-leakage-monitor",
          "value-portfolio-forecast"
        ],
        "channelIds": [
          "channel-https",
          "channel-sftp",
          "channel-event-stream",
          "channel-client-ipaas"
        ],
        "configurableFields": [
          "Installed system and release",
          "Record and field ownership",
          "Identity and credentials",
          "Channel and format version",
          "Freshness and service envelope",
          "Acceptance evidence and support owner"
        ],
        "direction": "bidirectional",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "entityIds": [
          "party",
          "person",
          "business-unit",
          "category",
          "item-service",
          "policy",
          "source-record-reference",
          "integration-state",
          "spend-record",
          "evidence-item",
          "category-opportunity",
          "decision",
          "authority-envelope",
          "learning-example",
          "evaluation-result",
          "policy-version",
          "policy-rule-release",
          "policy-guidance-result",
          "procurement-service-offering",
          "intake-request",
          "enriched-request",
          "demand-case",
          "exception",
          "committed-action",
          "action-proposal",
          "audit-event",
          "business-event",
          "registry-release",
          "demand-portfolio",
          "sourcing-opportunity",
          "contract",
          "sourcing-event-record",
          "negotiation-session",
          "award-scenario",
          "tactical-sourcing-case",
          "contract-version",
          "contract-template",
          "clause-library-entry",
          "clause-deviation",
          "contract-intake",
          "contract-approval",
          "supplier-onboarding-case",
          "supplier-profile",
          "supplier-qualification",
          "supplier-risk-assessment",
          "supplier-master-change",
          "supplier-risk-signal",
          "supplier-tier-link",
          "supplier-risk-case",
          "supplier-remediation-action",
          "supplier-offboarding-case",
          "purchase-order",
          "buying-request",
          "catalogue-line",
          "requisition",
          "requisition-line",
          "order-line",
          "order-response",
          "purchase-order-exception",
          "receipt",
          "shipment",
          "invoice",
          "invoice-line",
          "invoice-match-assessment",
          "invoice-exception",
          "supplier-invoice-resolution",
          "payment-readiness-assessment",
          "payment-instruction",
          "payment-execution-status",
          "supplier-segment-assignment",
          "supplier-performance-observation",
          "value-opportunity-baseline",
          "savings-initiative-record",
          "value-realization-attribution",
          "value-leakage-finding",
          "value-portfolio-forecast"
        ],
        "formatIds": [
          "format-csv",
          "format-json",
          "format-xml",
          "format-source-native-export"
        ],
        "id": "master-reference-sync",
        "inputEntityIds": [
          "party",
          "person",
          "business-unit",
          "category",
          "item-service",
          "policy",
          "source-record-reference",
          "integration-state"
        ],
        "label": "Master and reference data synchronisation",
        "licenseId": "bw-partner-1.0",
        "outcome": "Reconcile parties, people, business units, categories, items, services, policies and code lists with one canonical owner.",
        "outputEntityIds": [
          "party",
          "person",
          "business-unit",
          "category",
          "item-service",
          "policy",
          "source-record-reference",
          "integration-state"
        ],
        "owner": "Each canonical record remains owned by its declared GroundWorks service or business module; source owners retain authority for source-owned fields.",
        "proofClass": "recipe",
        "reliability": {
          "acknowledgement": "Transport receipt, syntax acceptance and business acceptance remain separate states.",
          "degradedState": "Retain the verified identity and mark dependent decisions stale or blocked according to consequence.",
          "freshness": "Record source-observed time, last successful exchange, next expected update and freshness status. Retain last-good data when an update is late.",
          "idempotency": "Namespace plus identifier value plus source version.",
          "monitoring": "Monitor identity, availability, latency, volume, validation, acknowledgement, reconciliation and recovery against the configured operating envelope.",
          "reconciliation": "Source-to-canonical identity coverage, collisions, unresolved merges, rejected changes and readback.",
          "recovery": "Resume from recorded delivery state. Never retry an uncertain consequential effect blindly.",
          "rollback": "Stop new effects, restore the last accepted mapping and adapter version, then replay from recorded checkpoints after reconciliation."
        },
        "standardIds": [],
        "systemRoleIds": [
          "erp",
          "ap-platform",
          "expense-platform",
          "data-warehouse",
          "spend-analytics",
          "mdm",
          "warehouse",
          "category-suite",
          "market-intelligence",
          "risk-platform",
          "planning",
          "policy-repository",
          "sharepoint",
          "grc",
          "document-management",
          "service-catalogue",
          "procurement-suite",
          "service-management",
          "intake-orchestration",
          "teams",
          "exchange",
          "identity",
          "supplier-master",
          "budget-system",
          "workflow-platform",
          "collaboration",
          "sourcing-suite",
          "clm",
          "supplier-network",
          "erp-master",
          "office-documents",
          "negotiation-specialist",
          "procurement-policy",
          "word",
          "document-repository",
          "signature",
          "supplier-portal",
          "tax-registry",
          "identity-provider",
          "erp-supplier-master",
          "bank-validation",
          "evidence-network",
          "risk-monitoring",
          "news-and-market-data",
          "cyber-risk",
          "sustainability",
          "business-continuity",
          "catalogue",
          "edi-van",
          "peppol-access-point",
          "receiving-system",
          "erp-ap",
          "invoice-network",
          "ap-automation",
          "document-capture",
          "treasury",
          "fraud-control",
          "tax-control",
          "bank",
          "payment-platform",
          "srm",
          "finance-ledger",
          "savings-platform",
          "spreadsheet",
          "finance-reporting"
        ],
        "trigger": "A scheduled reconciliation, approved master-data change or source event starts synchronisation at the cadence pinned in the client overlay."
      },
      {
        "actionClasses": [
          "not-applicable"
        ],
        "authorityBoundary": "The source remains authoritative for declared source fields. Only the owning GroundWorks service or business module changes a canonical record.",
        "businessModuleIds": [
          "sourcing-event",
          "bid-evaluation-award",
          "tactical-sourcing-autonomy",
          "contract-intake-digitization",
          "guided-buying",
          "purchase-order-orchestration",
          "purchase-order-exception",
          "receiving-service-entry",
          "invoice-intake-match",
          "invoice-exception-triage",
          "supplier-invoice-resolution",
          "supplier-performance-monitor-correct",
          "value-leakage-monitor"
        ],
        "channelIds": [
          "channel-peppol-access-point",
          "channel-procurement-network",
          "channel-as2",
          "channel-sftp",
          "channel-https",
          "channel-email-gateway",
          "channel-client-ipaas"
        ],
        "configurableFields": [
          "Installed system and release",
          "Record and field ownership",
          "Identity and credentials",
          "Channel and format version",
          "Freshness and service envelope",
          "Acceptance evidence and support owner"
        ],
        "direction": "inbound",
        "domainWorkblockIds": [
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "entityIds": [
          "source-record-reference",
          "evidence-item",
          "integration-state",
          "sourcing-event-record",
          "party",
          "decision",
          "sourcing-opportunity",
          "person",
          "category",
          "item-service",
          "policy",
          "policy-version",
          "authority-envelope",
          "action-proposal",
          "committed-action",
          "exception",
          "audit-event",
          "business-event",
          "learning-example",
          "evaluation-result",
          "registry-release",
          "award-scenario",
          "tactical-sourcing-case",
          "demand-case",
          "contract-intake",
          "contract",
          "contract-template",
          "supplier-profile",
          "buying-request",
          "catalogue-line",
          "policy-guidance-result",
          "supplier-qualification",
          "business-unit",
          "purchase-order",
          "order-line",
          "order-response",
          "requisition",
          "requisition-line",
          "purchase-order-exception",
          "receipt",
          "shipment",
          "receipt-line",
          "service-entry-sheet",
          "return-claim",
          "invoice",
          "invoice-line",
          "invoice-match-assessment",
          "invoice-exception",
          "supplier-invoice-resolution",
          "supplier-performance-observation",
          "supplier-remediation-action",
          "supplier-segment-assignment",
          "supplier-performance-review-record",
          "value-leakage-finding",
          "savings-initiative-record",
          "value-opportunity-baseline",
          "value-realization-attribution"
        ],
        "formatIds": [
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json"
        ],
        "id": "structured-business-document-ingest",
        "inputEntityIds": [
          "source-record-reference",
          "evidence-item",
          "integration-state",
          "party"
        ],
        "label": "Structured business document ingest",
        "licenseId": "bw-partner-1.0",
        "outcome": "Validate, map and publish a canonical procurement document while preserving the exact source payload.",
        "outputEntityIds": [
          "sourcing-event-record",
          "contract",
          "purchase-order",
          "receipt",
          "invoice",
          "integration-state"
        ],
        "owner": "The receiving business module owns the canonical record; the sender remains accountable for the source document and declared business facts.",
        "proofClass": "recipe",
        "reliability": {
          "acknowledgement": "Transport receipt, syntax acceptance, business acceptance and canonical record version remain distinct.",
          "degradedState": "Keep last-good state visible with its real freshness and quarantine incompatible input.",
          "freshness": "Record source-observed time, last successful exchange, next expected update and freshness status. Retain last-good data when an update is late.",
          "idempotency": "Sender namespace, receiver namespace, document type, document ID and source version or hash.",
          "monitoring": "Monitor identity, availability, latency, volume, validation, acknowledgement, reconciliation and recovery against the configured operating envelope.",
          "reconciliation": "Transport receipt, syntax acceptance, business acceptance and canonical record version remain distinct.",
          "recovery": "Resume from recorded delivery state. Never retry an uncertain consequential effect blindly.",
          "rollback": "Stop new effects, restore the last accepted mapping and adapter version, then replay from recorded checkpoints after reconciliation."
        },
        "standardIds": [
          "ubl-2-4",
          "peppol-bis-billing-3",
          "peppol-ordering-3",
          "peppol-eas-iso-6523",
          "cxml-1-2-070",
          "edi-partner-agreement",
          "sap-idoc"
        ],
        "systemRoleIds": [
          "sourcing-suite",
          "supplier-network",
          "erp-master",
          "sharepoint",
          "office-documents",
          "optimisation-specialist",
          "spreadsheet",
          "procurement-policy",
          "clm",
          "email",
          "document-repository",
          "signature",
          "procurement-suite",
          "catalogue",
          "erp",
          "policy-repository",
          "edi-van",
          "peppol-access-point",
          "receiving-system",
          "warehouse-management",
          "field-service",
          "erp-ap",
          "invoice-network",
          "ap-automation",
          "document-capture",
          "service-management",
          "supplier-portal",
          "srm",
          "quality-system",
          "logistics",
          "risk-platform",
          "warehouse",
          "savings-platform",
          "planning"
        ],
        "trigger": "Receipt of a document, network message or agreed file starts validation and canonical mapping."
      },
      {
        "actionClasses": [
          "not-applicable"
        ],
        "authorityBoundary": "Only an authorised canonical commitment may be projected externally. Transport acceptance is not business completion.",
        "businessModuleIds": [
          "sourcing-event",
          "bid-evaluation-award",
          "tactical-sourcing-autonomy",
          "contract-approval-repository",
          "renewal-change-compliance",
          "supplier-onboarding",
          "supplier-remediation-exit",
          "requisition-policy-routing",
          "purchase-order-orchestration",
          "purchase-order-exception",
          "receiving-service-entry",
          "invoice-intake-match",
          "invoice-exception-triage",
          "supplier-invoice-resolution"
        ],
        "channelIds": [
          "channel-peppol-access-point",
          "channel-procurement-network",
          "channel-as2",
          "channel-sftp",
          "channel-https",
          "channel-client-ipaas"
        ],
        "configurableFields": [
          "Installed system and release",
          "Record and field ownership",
          "Identity and credentials",
          "Channel and format version",
          "Freshness and service envelope",
          "Acceptance evidence and support owner"
        ],
        "direction": "outbound",
        "domainWorkblockIds": [
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness"
        ],
        "entityIds": [
          "committed-action",
          "source-record-reference",
          "evidence-item",
          "integration-state",
          "sourcing-event-record",
          "party",
          "decision",
          "sourcing-opportunity",
          "person",
          "category",
          "item-service",
          "policy",
          "policy-version",
          "authority-envelope",
          "action-proposal",
          "exception",
          "audit-event",
          "business-event",
          "learning-example",
          "evaluation-result",
          "registry-release",
          "award-scenario",
          "tactical-sourcing-case",
          "demand-case",
          "contract",
          "contract-version",
          "contract-approval",
          "contract-template",
          "clause-deviation",
          "contract-change",
          "contract-compliance-finding",
          "clause-library-entry",
          "contract-obligation",
          "contract-entitlement",
          "supplier-onboarding-case",
          "supplier-profile",
          "supplier-qualification",
          "supplier-risk-assessment",
          "supplier-remediation-action",
          "supplier-offboarding-case",
          "supplier-risk-case",
          "purchase-order",
          "requisition",
          "requisition-line",
          "buying-request",
          "catalogue-line",
          "order-line",
          "order-response",
          "purchase-order-exception",
          "receipt",
          "shipment",
          "receipt-line",
          "service-entry-sheet",
          "return-claim",
          "invoice",
          "invoice-line",
          "invoice-match-assessment",
          "invoice-exception",
          "supplier-invoice-resolution"
        ],
        "formatIds": [
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-iso-20022",
          "format-vendor-xml",
          "format-json"
        ],
        "id": "structured-business-document-outbound",
        "inputEntityIds": [
          "committed-action",
          "purchase-order",
          "contract",
          "invoice",
          "source-record-reference"
        ],
        "label": "Structured business document projection and delivery",
        "licenseId": "bw-partner-1.0",
        "outcome": "Project an authorised canonical commitment to a pinned document profile and reconcile the external result.",
        "outputEntityIds": [
          "source-record-reference",
          "evidence-item",
          "integration-state",
          "business-event"
        ],
        "owner": "The accountable business owner authorises the commitment; the integration Workblock owns projection, delivery state and reconciliation.",
        "proofClass": "recipe",
        "reliability": {
          "acknowledgement": "Never retry blindly after an ambiguous response; query destination or reconcile through acknowledgement before resubmission.",
          "degradedState": "Keep last-good state visible with its real freshness and quarantine incompatible input.",
          "freshness": "Record source-observed time, last successful exchange, next expected update and freshness status. Retain last-good data when an update is late.",
          "idempotency": "Canonical commitment ID, destination, projection version and attempt sequence.",
          "monitoring": "Monitor identity, availability, latency, volume, validation, acknowledgement, reconciliation and recovery against the configured operating envelope.",
          "reconciliation": "Distinguish dispatch, transport acceptance, destination acknowledgement, authoritative readback and business completion.",
          "recovery": "Correct or reverse through a new authorised document or command; never rewrite the original commitment.",
          "rollback": "Stop new effects, restore the last accepted mapping and adapter version, then replay from recorded checkpoints after reconciliation."
        },
        "standardIds": [
          "ubl-2-4",
          "peppol-bis-billing-3",
          "peppol-ordering-3",
          "peppol-eas-iso-6523",
          "cxml-1-2-070",
          "edi-partner-agreement",
          "sap-idoc",
          "iso-20022"
        ],
        "systemRoleIds": [
          "sourcing-suite",
          "supplier-network",
          "erp-master",
          "sharepoint",
          "office-documents",
          "optimisation-specialist",
          "spreadsheet",
          "procurement-policy",
          "clm",
          "signature",
          "document-repository",
          "erp",
          "usage-analytics",
          "risk-platform",
          "supplier-portal",
          "supplier-master",
          "tax-registry",
          "identity-provider",
          "business-continuity",
          "collaboration",
          "procurement-suite",
          "budget-system",
          "catalogue",
          "edi-van",
          "peppol-access-point",
          "receiving-system",
          "warehouse-management",
          "field-service",
          "erp-ap",
          "invoice-network",
          "ap-automation",
          "document-capture",
          "service-management",
          "email"
        ],
        "trigger": "An authorised canonical commitment starts projection; delivery cadence follows the business event or batch contract pinned in the client overlay."
      },
      {
        "actionClasses": [
          "not-applicable"
        ],
        "authorityBoundary": "The source remains authoritative for declared source fields. Only the owning GroundWorks service or business module changes a canonical record.",
        "businessModuleIds": [
          "guided-buying",
          "requisition-policy-routing"
        ],
        "channelIds": [
          "channel-https"
        ],
        "configurableFields": [
          "Installed system and release",
          "Record and field ownership",
          "Identity and credentials",
          "Channel and format version",
          "Freshness and service envelope",
          "Acceptance evidence and support owner"
        ],
        "direction": "bidirectional",
        "domainWorkblockIds": [
          "buying-ordering-receiving"
        ],
        "entityIds": [
          "buying-request",
          "catalogue-line",
          "requisition",
          "requisition-line",
          "source-record-reference",
          "item-service",
          "party",
          "policy-guidance-result",
          "supplier-profile",
          "supplier-qualification",
          "contract",
          "business-unit",
          "category",
          "policy",
          "policy-version",
          "authority-envelope",
          "evaluation-result",
          "integration-state",
          "registry-release",
          "decision"
        ],
        "formatIds": [
          "format-cxml-punchout"
        ],
        "id": "punchout-catalogue-session",
        "inputEntityIds": [
          "buying-request",
          "party",
          "business-unit",
          "policy-guidance-result",
          "source-record-reference"
        ],
        "label": "PunchOut catalogue session",
        "licenseId": "bw-partner-1.0",
        "outcome": "Start a supplier catalogue session, retain buyer context and convert the returned basket into governed catalogue or requisition facts.",
        "outputEntityIds": [
          "catalogue-line",
          "requisition",
          "requisition-line",
          "source-record-reference",
          "integration-state"
        ],
        "owner": "The buying Workblock owns the request and returned basket; the supplier catalogue owns presented item facts until they are accepted into the canonical request.",
        "proofClass": "recipe",
        "reliability": {
          "acknowledgement": "Transport receipt, syntax acceptance and business acceptance remain separate states.",
          "degradedState": "Keep last-good state visible with its real freshness and quarantine incompatible input.",
          "freshness": "Record source-observed time, last successful exchange, next expected update and freshness status. Retain last-good data when an update is late.",
          "idempotency": "Session ID plus returned basket ID and line key.",
          "monitoring": "Monitor identity, availability, latency, volume, validation, acknowledgement, reconciliation and recovery against the configured operating envelope.",
          "reconciliation": "Reconcile source or destination state, counts, versions, exceptions and authoritative readback.",
          "recovery": "Expired or abandoned sessions close without creating a commitment.",
          "rollback": "Stop new effects, restore the last accepted mapping and adapter version, then replay from recorded checkpoints after reconciliation."
        },
        "standardIds": [
          "cxml-1-2-070"
        ],
        "systemRoleIds": [
          "procurement-suite",
          "catalogue",
          "supplier-network",
          "erp",
          "policy-repository",
          "budget-system"
        ],
        "trigger": "An authorised buyer starts a catalogue session and the supplier returns a basket within the configured session window."
      },
      {
        "actionClasses": [
          "not-applicable"
        ],
        "authorityBoundary": "SharePoint owns selected file versions and collaboration state. The Workblock owns procurement proposals, decisions, commitments and outcomes.",
        "businessModuleIds": [
          "category-strategy-orchestrator",
          "policy-rule-lifecycle",
          "policy-guidance",
          "procurement-service-catalogue",
          "intelligent-intake",
          "demand-orchestration",
          "demand-consolidation-portfolio",
          "sourcing-pipeline-discovery",
          "sourcing-event",
          "bid-evaluation-award",
          "negotiation-copilot",
          "contract-intake-digitization",
          "contract-authoring-review",
          "contract-approval-repository",
          "obligation-monitoring",
          "renewal-change-compliance",
          "supplier-onboarding",
          "third-party-risk-review",
          "supplier-performance-monitor-correct",
          "supplier-performance-review",
          "supplier-innovation-pipeline",
          "supplier-relationship-joint-value",
          "value-opportunity-baseline",
          "savings-initiative",
          "value-portfolio-forecast"
        ],
        "channelIds": [
          "channel-microsoft-graph"
        ],
        "configurableFields": [
          "Installed system and release",
          "Record and field ownership",
          "Identity and credentials",
          "Channel and format version",
          "Freshness and service envelope",
          "Acceptance evidence and support owner"
        ],
        "direction": "bidirectional",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "entityIds": [
          "source-record-reference",
          "evidence-item",
          "integration-state",
          "category-strategy",
          "category-opportunity",
          "decision",
          "spend-record",
          "policy",
          "policy-version",
          "policy-rule-release",
          "policy-guidance-result",
          "exception",
          "registry-release",
          "procurement-service-offering",
          "authority-envelope",
          "intake-request",
          "party",
          "person",
          "business-unit",
          "category",
          "item-service",
          "learning-example",
          "evaluation-result",
          "demand-case",
          "enriched-request",
          "committed-action",
          "action-proposal",
          "audit-event",
          "business-event",
          "demand-portfolio",
          "sourcing-opportunity",
          "contract",
          "sourcing-event-record",
          "award-scenario",
          "negotiation-session",
          "contract-intake",
          "contract-template",
          "supplier-profile",
          "contract-version",
          "clause-library-entry",
          "clause-deviation",
          "contract-approval",
          "contract-obligation",
          "contract-entitlement",
          "contract-change",
          "contract-compliance-finding",
          "supplier-onboarding-case",
          "supplier-qualification",
          "supplier-risk-assessment",
          "supplier-risk-signal",
          "supplier-tier-link",
          "supplier-performance-observation",
          "supplier-remediation-action",
          "supplier-segment-assignment",
          "supplier-performance-review-record",
          "supplier-innovation-case",
          "supplier-joint-value-plan",
          "value-realization-attribution",
          "value-opportunity-baseline",
          "savings-initiative-record",
          "value-leakage-finding",
          "value-portfolio-forecast"
        ],
        "formatIds": [
          "format-drive-item",
          "format-list-item",
          "format-docx",
          "format-xlsx",
          "format-pdf",
          "format-structured-list"
        ],
        "id": "sharepoint-content-binding",
        "inputEntityIds": [
          "source-record-reference",
          "evidence-item",
          "integration-state",
          "contract-version",
          "policy",
          "supplier-profile"
        ],
        "label": "SharePoint content binding",
        "licenseId": "bw-partner-1.0",
        "outcome": "Bind a SharePoint file or list item to a canonical record while preserving source version, permissions and content authority.",
        "outputEntityIds": [
          "source-record-reference",
          "evidence-item",
          "integration-state",
          "business-event",
          "audit-event"
        ],
        "owner": "SharePoint owns the selected file version, permissions and collaboration state; the owning GroundWorks module retains procurement decision and commitment state.",
        "proofClass": "recipe",
        "reliability": {
          "acknowledgement": "Transport receipt, syntax acceptance and business acceptance remain separate states.",
          "degradedState": "Keep last-good state visible with its real freshness and quarantine incompatible input.",
          "freshness": "Record source-observed time, last successful exchange, next expected update and freshness status. Retain last-good data when an update is late.",
          "idempotency": "Tenant, site, container, item ID and eTag or cTag.",
          "monitoring": "Monitor identity, availability, latency, volume, validation, acknowledgement, reconciliation and recovery against the configured operating envelope.",
          "reconciliation": "Reconcile source or destination state, counts, versions, exceptions and authoritative readback.",
          "recovery": "Resume from recorded delivery state. Never retry an uncertain consequential effect blindly.",
          "rollback": "Stop new effects, restore the last accepted mapping and adapter version, then replay from recorded checkpoints after reconciliation."
        },
        "standardIds": [],
        "systemRoleIds": [
          "category-suite",
          "planning",
          "warehouse",
          "sharepoint",
          "office-documents",
          "policy-repository",
          "grc",
          "document-management",
          "intranet",
          "service-management",
          "service-catalogue",
          "procurement-suite",
          "intake-orchestration",
          "teams",
          "exchange",
          "identity",
          "workflow-platform",
          "collaboration",
          "sourcing-suite",
          "clm",
          "supplier-network",
          "erp-master",
          "optimisation-specialist",
          "spreadsheet",
          "negotiation-specialist",
          "email",
          "document-repository",
          "signature",
          "word",
          "performance-system",
          "erp",
          "usage-analytics",
          "risk-platform",
          "supplier-portal",
          "supplier-master",
          "tax-registry",
          "identity-provider",
          "evidence-network",
          "srm",
          "quality-system",
          "logistics",
          "innovation-portal",
          "idea-management",
          "value-management",
          "finance-ledger",
          "savings-platform",
          "finance-reporting"
        ],
        "trigger": "A file or list-item version change, approved publication or scheduled reconciliation starts the binding flow."
      },
      {
        "actionClasses": [
          "not-applicable"
        ],
        "authorityBoundary": "The source remains authoritative for declared source fields. Only the owning GroundWorks service or business module changes a canonical record.",
        "businessModuleIds": [
          "intelligent-intake",
          "demand-orchestration",
          "contract-intake-digitization",
          "obligation-monitoring",
          "supplier-onboarding",
          "continuous-risk-monitoring",
          "supplier-remediation-exit",
          "receiving-service-entry",
          "invoice-exception-triage",
          "supplier-invoice-resolution",
          "supplier-performance-monitor-correct",
          "supplier-innovation-pipeline",
          "value-leakage-monitor"
        ],
        "channelIds": [
          "channel-microsoft-graph",
          "channel-webhook",
          "channel-email-gateway",
          "channel-client-ipaas"
        ],
        "configurableFields": [
          "Installed system and release",
          "Record and field ownership",
          "Identity and credentials",
          "Channel and format version",
          "Freshness and service envelope",
          "Acceptance evidence and support owner"
        ],
        "direction": "inbound",
        "domainWorkblockIds": [
          "intake-demand",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "entityIds": [
          "intake-request",
          "demand-case",
          "source-record-reference",
          "evidence-item",
          "party",
          "person",
          "business-unit",
          "procurement-service-offering",
          "category",
          "item-service",
          "policy",
          "policy-version",
          "authority-envelope",
          "learning-example",
          "evaluation-result",
          "integration-state",
          "enriched-request",
          "exception",
          "committed-action",
          "action-proposal",
          "decision",
          "audit-event",
          "business-event",
          "registry-release",
          "contract-intake",
          "contract",
          "contract-template",
          "supplier-profile",
          "contract-obligation",
          "contract-entitlement",
          "clause-library-entry",
          "contract-version",
          "contract-approval",
          "supplier-onboarding-case",
          "supplier-qualification",
          "supplier-risk-assessment",
          "supplier-risk-signal",
          "supplier-risk-case",
          "supplier-tier-link",
          "supplier-remediation-action",
          "supplier-offboarding-case",
          "purchase-order",
          "shipment",
          "receipt",
          "receipt-line",
          "service-entry-sheet",
          "return-claim",
          "order-line",
          "invoice-exception",
          "invoice-match-assessment",
          "invoice",
          "supplier-invoice-resolution",
          "supplier-performance-observation",
          "supplier-segment-assignment",
          "supplier-performance-review-record",
          "supplier-innovation-case",
          "supplier-joint-value-plan",
          "value-leakage-finding",
          "savings-initiative-record",
          "value-opportunity-baseline",
          "value-realization-attribution"
        ],
        "formatIds": [
          "format-message",
          "format-attachment",
          "format-adaptive-card",
          "format-email",
          "format-file-link"
        ],
        "id": "collaboration-intake",
        "inputEntityIds": [
          "source-record-reference",
          "evidence-item",
          "party",
          "person",
          "business-unit"
        ],
        "label": "Collaboration and mailbox intake",
        "licenseId": "bw-partner-1.0",
        "outcome": "Accept a request or artifact from Teams, Exchange, email or another collaboration channel without making the channel the case owner.",
        "outputEntityIds": [
          "intake-request",
          "demand-case",
          "contract-intake",
          "supplier-onboarding-case",
          "invoice-exception",
          "integration-state"
        ],
        "owner": "The receiving Workblock owns the resulting case; the collaboration channel retains the original message and attachment versions.",
        "proofClass": "recipe",
        "reliability": {
          "acknowledgement": "Acknowledge accepted intake only after the canonical case exists; reconcile orphan messages and failed attachments.",
          "degradedState": "Keep last-good state visible with its real freshness and quarantine incompatible input.",
          "freshness": "Record source-observed time, last successful exchange, next expected update and freshness status. Retain last-good data when an update is late.",
          "idempotency": "Channel, conversation, message and attachment identifiers.",
          "monitoring": "Monitor identity, availability, latency, volume, validation, acknowledgement, reconciliation and recovery against the configured operating envelope.",
          "reconciliation": "Reconcile source or destination state, counts, versions, exceptions and authoritative readback.",
          "recovery": "Acknowledge accepted intake only after the canonical case exists; reconcile orphan messages and failed attachments.",
          "rollback": "Stop new effects, restore the last accepted mapping and adapter version, then replay from recorded checkpoints after reconciliation."
        },
        "standardIds": [],
        "systemRoleIds": [
          "intake-orchestration",
          "service-management",
          "teams",
          "exchange",
          "sharepoint",
          "identity",
          "workflow-platform",
          "procurement-suite",
          "collaboration",
          "clm",
          "email",
          "document-repository",
          "signature",
          "performance-system",
          "supplier-portal",
          "supplier-master",
          "erp",
          "risk-platform",
          "tax-registry",
          "identity-provider",
          "risk-monitoring",
          "news-and-market-data",
          "cyber-risk",
          "sustainability",
          "business-continuity",
          "warehouse-management",
          "field-service",
          "supplier-network",
          "erp-ap",
          "ap-automation",
          "invoice-network",
          "srm",
          "quality-system",
          "logistics",
          "innovation-portal",
          "idea-management",
          "warehouse",
          "savings-platform",
          "planning"
        ],
        "trigger": "An authorised message, attachment, adaptive card submission or mailbox arrival starts intake."
      },
      {
        "actionClasses": [
          "not-applicable"
        ],
        "authorityBoundary": "The source remains authoritative for declared source fields. Only the owning GroundWorks service or business module changes a canonical record.",
        "businessModuleIds": [
          "spend-data-foundation",
          "category-opportunity-radar",
          "category-strategy-orchestrator",
          "request-enrichment-routing",
          "demand-consolidation-portfolio",
          "sourcing-pipeline-discovery",
          "bid-evaluation-award",
          "negotiation-copilot",
          "obligation-monitoring",
          "renewal-change-compliance",
          "supplier-remediation-exit",
          "requisition-policy-routing",
          "invoice-exception-triage",
          "payment-readiness",
          "supplier-segmentation-governance",
          "supplier-performance-monitor-correct",
          "supplier-performance-review",
          "supplier-relationship-joint-value",
          "value-opportunity-baseline",
          "savings-initiative",
          "realization-reconciliation-attribution",
          "value-leakage-monitor",
          "value-portfolio-forecast"
        ],
        "channelIds": [
          "channel-object-storage",
          "channel-sftp",
          "channel-sql",
          "channel-event-stream",
          "channel-https",
          "channel-client-ipaas"
        ],
        "configurableFields": [
          "Installed system and release",
          "Record and field ownership",
          "Identity and credentials",
          "Channel and format version",
          "Freshness and service envelope",
          "Acceptance evidence and support owner"
        ],
        "direction": "bidirectional",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "entityIds": [
          "source-record-reference",
          "evidence-item",
          "integration-state",
          "business-event",
          "spend-record",
          "party",
          "business-unit",
          "category",
          "category-opportunity",
          "decision",
          "authority-envelope",
          "learning-example",
          "evaluation-result",
          "category-strategy",
          "enriched-request",
          "intake-request",
          "policy-guidance-result",
          "demand-portfolio",
          "demand-case",
          "sourcing-opportunity",
          "contract",
          "award-scenario",
          "sourcing-event-record",
          "negotiation-session",
          "contract-obligation",
          "contract-entitlement",
          "committed-action",
          "clause-library-entry",
          "contract-version",
          "contract-approval",
          "contract-change",
          "contract-compliance-finding",
          "supplier-remediation-action",
          "supplier-offboarding-case",
          "supplier-risk-case",
          "supplier-profile",
          "supplier-risk-assessment",
          "purchase-order",
          "requisition",
          "requisition-line",
          "buying-request",
          "catalogue-line",
          "supplier-qualification",
          "invoice-exception",
          "invoice-match-assessment",
          "receipt",
          "invoice",
          "supplier-invoice-resolution",
          "item-service",
          "policy",
          "policy-version",
          "action-proposal",
          "exception",
          "audit-event",
          "registry-release",
          "payment-readiness-assessment",
          "person",
          "supplier-segment-assignment",
          "supplier-performance-observation",
          "supplier-performance-review-record",
          "supplier-joint-value-plan",
          "value-realization-attribution",
          "supplier-innovation-case",
          "value-opportunity-baseline",
          "savings-initiative-record",
          "value-leakage-finding",
          "value-portfolio-forecast"
        ],
        "formatIds": [
          "format-parquet",
          "format-csv",
          "format-json",
          "format-table",
          "format-semantic-model"
        ],
        "id": "external-analytics-exchange",
        "inputEntityIds": [
          "source-record-reference",
          "evidence-item",
          "integration-state",
          "business-event",
          "spend-record"
        ],
        "label": "Warehouse and analytics exchange",
        "licenseId": "bw-partner-1.0",
        "outcome": "Export governed operational projections and consume versioned analytical outputs without moving action authority to the analytical estate.",
        "outputEntityIds": [
          "category-opportunity",
          "demand-portfolio",
          "sourcing-opportunity",
          "value-opportunity-baseline",
          "value-leakage-finding",
          "integration-state"
        ],
        "owner": "The analytical estate owns derived analytical outputs; GroundWorks modules retain authority for operational records, proposals and commitments.",
        "proofClass": "recipe",
        "reliability": {
          "acknowledgement": "Transport receipt, syntax acceptance and business acceptance remain separate states.",
          "degradedState": "Recompute as a new projection and preserve the prior published result.",
          "freshness": "Record source-observed time, last successful exchange, next expected update and freshness status. Retain last-good data when an update is late.",
          "idempotency": "Dataset, partition, definition version, as-of time and content hash.",
          "monitoring": "Monitor identity, availability, latency, volume, validation, acknowledgement, reconciliation and recovery against the configured operating envelope.",
          "reconciliation": "Reconcile source or destination state, counts, versions, exceptions and authoritative readback.",
          "recovery": "Resume from recorded delivery state. Never retry an uncertain consequential effect blindly.",
          "rollback": "Stop new effects, restore the last accepted mapping and adapter version, then replay from recorded checkpoints after reconciliation."
        },
        "standardIds": [],
        "systemRoleIds": [
          "erp",
          "ap-platform",
          "expense-platform",
          "data-warehouse",
          "spend-analytics",
          "mdm",
          "warehouse",
          "category-suite",
          "market-intelligence",
          "risk-platform",
          "planning",
          "sharepoint",
          "office-documents",
          "procurement-suite",
          "supplier-master",
          "budget-system",
          "intake-orchestration",
          "sourcing-suite",
          "clm",
          "optimisation-specialist",
          "spreadsheet",
          "supplier-network",
          "negotiation-specialist",
          "performance-system",
          "service-management",
          "collaboration",
          "usage-analytics",
          "identity-provider",
          "business-continuity",
          "catalogue",
          "erp-ap",
          "ap-automation",
          "invoice-network",
          "treasury",
          "fraud-control",
          "tax-control",
          "bank-validation",
          "srm",
          "quality-system",
          "logistics",
          "value-management",
          "finance-ledger",
          "savings-platform",
          "finance-reporting"
        ],
        "trigger": "A scheduled projection, approved analytical request or source refresh starts the exchange at the cadence pinned in the client overlay."
      },
      {
        "actionClasses": [
          "not-applicable"
        ],
        "authorityBoundary": "The source remains authoritative for declared source fields. Only the owning GroundWorks service or business module changes a canonical record.",
        "businessModuleIds": [
          "category-opportunity-radar",
          "category-strategy-orchestrator",
          "request-enrichment-routing",
          "obligation-monitoring",
          "renewal-change-compliance",
          "supplier-onboarding",
          "supplier-master-qualification",
          "third-party-risk-review",
          "continuous-risk-monitoring",
          "supplier-remediation-exit",
          "payment-readiness",
          "supplier-segmentation-governance",
          "supplier-performance-monitor-correct",
          "supplier-performance-review",
          "supplier-relationship-joint-value"
        ],
        "channelIds": [
          "channel-https",
          "channel-sftp",
          "channel-client-ipaas"
        ],
        "configurableFields": [
          "Installed system and release",
          "Record and field ownership",
          "Identity and credentials",
          "Channel and format version",
          "Freshness and service envelope",
          "Acceptance evidence and support owner"
        ],
        "direction": "inbound",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship"
        ],
        "entityIds": [
          "party",
          "evidence-item",
          "source-record-reference",
          "supplier-risk-signal",
          "integration-state",
          "category-opportunity",
          "spend-record",
          "category",
          "decision",
          "business-unit",
          "authority-envelope",
          "learning-example",
          "evaluation-result",
          "category-strategy",
          "enriched-request",
          "intake-request",
          "policy-guidance-result",
          "contract-obligation",
          "contract-entitlement",
          "contract",
          "committed-action",
          "clause-library-entry",
          "contract-version",
          "contract-approval",
          "business-event",
          "contract-change",
          "contract-compliance-finding",
          "supplier-onboarding-case",
          "supplier-profile",
          "supplier-qualification",
          "supplier-risk-assessment",
          "policy",
          "registry-release",
          "supplier-master-change",
          "supplier-tier-link",
          "person",
          "policy-version",
          "action-proposal",
          "exception",
          "audit-event",
          "supplier-risk-case",
          "supplier-remediation-action",
          "supplier-offboarding-case",
          "purchase-order",
          "payment-readiness-assessment",
          "invoice",
          "invoice-match-assessment",
          "invoice-exception",
          "supplier-segment-assignment",
          "supplier-performance-observation",
          "supplier-performance-review-record",
          "supplier-joint-value-plan",
          "value-realization-attribution",
          "supplier-innovation-case"
        ],
        "formatIds": [
          "format-json",
          "format-xml",
          "format-csv",
          "format-document"
        ],
        "id": "risk-and-reference-evidence-feed",
        "inputEntityIds": [
          "party",
          "source-record-reference",
          "evidence-item",
          "integration-state"
        ],
        "label": "Risk and reference evidence feed",
        "licenseId": "bw-partner-1.0",
        "outcome": "Ingest ratings, registries, tax, sustainability, market and identity evidence with provider scope and freshness.",
        "outputEntityIds": [
          "supplier-risk-signal",
          "supplier-risk-assessment",
          "category-opportunity",
          "evidence-item",
          "integration-state"
        ],
        "owner": "The evidence provider owns the supplied observation; the accountable GroundWorks module owns its interpretation, decision and treatment.",
        "proofClass": "recipe",
        "reliability": {
          "acknowledgement": "Transport receipt, syntax acceptance and business acceptance remain separate states.",
          "degradedState": "Expired evidence remains visible as stale and cannot silently satisfy a current control.",
          "freshness": "Record source-observed time, last successful exchange, next expected update and freshness status. Retain last-good data when an update is late.",
          "idempotency": "Provider, subject namespace, subject identifier, observation type and effective time.",
          "monitoring": "Monitor identity, availability, latency, volume, validation, acknowledgement, reconciliation and recovery against the configured operating envelope.",
          "reconciliation": "Reconcile source or destination state, counts, versions, exceptions and authoritative readback.",
          "recovery": "Resume from recorded delivery state. Never retry an uncertain consequential effect blindly.",
          "rollback": "Stop new effects, restore the last accepted mapping and adapter version, then replay from recorded checkpoints after reconciliation."
        },
        "standardIds": [],
        "systemRoleIds": [
          "spend-analytics",
          "warehouse",
          "category-suite",
          "market-intelligence",
          "risk-platform",
          "planning",
          "sharepoint",
          "office-documents",
          "procurement-suite",
          "erp",
          "supplier-master",
          "budget-system",
          "clm",
          "performance-system",
          "service-management",
          "collaboration",
          "usage-analytics",
          "supplier-portal",
          "tax-registry",
          "identity-provider",
          "erp-supplier-master",
          "mdm",
          "bank-validation",
          "grc",
          "evidence-network",
          "risk-monitoring",
          "news-and-market-data",
          "cyber-risk",
          "sustainability",
          "business-continuity",
          "erp-ap",
          "treasury",
          "fraud-control",
          "tax-control",
          "srm",
          "quality-system",
          "logistics",
          "spreadsheet",
          "value-management"
        ],
        "trigger": "A provider update, scheduled refresh or case-specific request starts evidence collection."
      },
      {
        "actionClasses": [
          "not-applicable"
        ],
        "authorityBoundary": "Only an authorised canonical commitment may be projected externally. Transport acceptance is not business completion.",
        "businessModuleIds": [
          "payment-execution-guard"
        ],
        "channelIds": [
          "channel-bank-channel",
          "channel-treasury-platform",
          "channel-sftp",
          "channel-swift-service",
          "channel-client-ipaas"
        ],
        "configurableFields": [
          "Installed system and release",
          "Record and field ownership",
          "Identity and credentials",
          "Channel and format version",
          "Freshness and service envelope",
          "Acceptance evidence and support owner"
        ],
        "direction": "bidirectional",
        "domainWorkblockIds": [
          "invoice-exception-payment-readiness"
        ],
        "entityIds": [
          "payment-instruction",
          "payment-execution-status",
          "evidence-item",
          "source-record-reference",
          "integration-state",
          "committed-action",
          "payment-readiness-assessment",
          "invoice"
        ],
        "formatIds": [
          "format-iso-20022",
          "format-bank-csv",
          "format-bank-xml",
          "format-proprietary-sample-required"
        ],
        "id": "payment-and-bank-message-exchange",
        "inputEntityIds": [
          "payment-instruction",
          "committed-action",
          "payment-readiness-assessment",
          "invoice"
        ],
        "label": "Payment and bank message exchange",
        "licenseId": "bw-partner-1.0",
        "outcome": "Project authorised payment instructions and reconcile status, statement and return messages without blurring readiness, release and settlement.",
        "outputEntityIds": [
          "payment-execution-status",
          "evidence-item",
          "source-record-reference",
          "integration-state"
        ],
        "owner": "The authorised payment owner controls release; the bank or treasury rail owns execution status and settlement evidence returned through the adapter.",
        "proofClass": "recipe",
        "reliability": {
          "acknowledgement": "Reconcile status or statement before retry; represent accepted, rejected, pending, settled, returned and unknown distinctly.",
          "degradedState": "Keep last-good state visible with its real freshness and quarantine incompatible input.",
          "freshness": "Record source-observed time, last successful exchange, next expected update and freshness status. Retain last-good data when an update is late.",
          "idempotency": "Payment instruction ID, debtor account, message ID and end-to-end ID according to the bank contract.",
          "monitoring": "Monitor identity, availability, latency, volume, validation, acknowledgement, reconciliation and recovery against the configured operating envelope.",
          "reconciliation": "Reconcile source or destination state, counts, versions, exceptions and authoritative readback.",
          "recovery": "Reconcile status or statement before retry; represent accepted, rejected, pending, settled, returned and unknown distinctly.",
          "rollback": "Stop new effects, restore the last accepted mapping and adapter version, then replay from recorded checkpoints after reconciliation."
        },
        "standardIds": [
          "iso-20022"
        ],
        "systemRoleIds": [
          "treasury",
          "erp-ap",
          "bank",
          "payment-platform",
          "fraud-control"
        ],
        "trigger": "An authorised payment instruction or a bank status, statement or return message starts the corresponding exchange."
      },
      {
        "actionClasses": [
          "read-only",
          "read-or-propose",
          "draft-or-propose",
          "consequential-create",
          "consequential-action"
        ],
        "authorityBoundary": "The access surface may invoke only the selected outcome tool. Workblock identity, authority, confirmation, proposal, commitment and audit remain controlling.",
        "businessModuleIds": [
          "spend-data-foundation",
          "category-opportunity-radar",
          "category-strategy-orchestrator",
          "policy-rule-lifecycle",
          "policy-guidance",
          "procurement-service-catalogue",
          "intelligent-intake",
          "request-enrichment-routing",
          "demand-orchestration",
          "demand-consolidation-portfolio",
          "sourcing-pipeline-discovery",
          "sourcing-event",
          "bid-evaluation-award",
          "negotiation-copilot",
          "tactical-sourcing-autonomy",
          "contract-intake-digitization",
          "contract-authoring-review",
          "contract-approval-repository",
          "obligation-monitoring",
          "renewal-change-compliance",
          "supplier-onboarding",
          "supplier-master-qualification",
          "third-party-risk-review",
          "continuous-risk-monitoring",
          "supplier-remediation-exit",
          "guided-buying",
          "requisition-policy-routing",
          "purchase-order-orchestration",
          "purchase-order-exception",
          "receiving-service-entry",
          "invoice-intake-match",
          "invoice-exception-triage",
          "supplier-invoice-resolution",
          "payment-readiness",
          "payment-execution-guard",
          "supplier-segmentation-governance",
          "supplier-performance-monitor-correct",
          "supplier-performance-review",
          "supplier-innovation-pipeline",
          "supplier-relationship-joint-value",
          "value-opportunity-baseline",
          "savings-initiative",
          "realization-reconciliation-attribution",
          "value-leakage-monitor",
          "value-portfolio-forecast"
        ],
        "channelIds": [
          "channel-streamable-http"
        ],
        "configurableFields": [
          "Installed system and release",
          "Record and field ownership",
          "Identity and credentials",
          "Channel and format version",
          "Freshness and service envelope",
          "Acceptance evidence and support owner"
        ],
        "direction": "interactive",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "entityIds": [
          "authority-envelope",
          "action-proposal",
          "committed-action",
          "decision",
          "audit-event",
          "evidence-item",
          "spend-record",
          "party",
          "business-unit",
          "category",
          "source-record-reference",
          "integration-state",
          "category-opportunity",
          "learning-example",
          "evaluation-result",
          "category-strategy",
          "policy",
          "policy-version",
          "policy-rule-release",
          "policy-guidance-result",
          "exception",
          "registry-release",
          "procurement-service-offering",
          "intake-request",
          "person",
          "item-service",
          "enriched-request",
          "demand-case",
          "business-event",
          "demand-portfolio",
          "sourcing-opportunity",
          "contract",
          "sourcing-event-record",
          "award-scenario",
          "negotiation-session",
          "tactical-sourcing-case",
          "contract-intake",
          "contract-template",
          "supplier-profile",
          "contract-version",
          "clause-library-entry",
          "clause-deviation",
          "contract-approval",
          "contract-obligation",
          "contract-entitlement",
          "contract-change",
          "contract-compliance-finding",
          "supplier-onboarding-case",
          "supplier-qualification",
          "supplier-risk-assessment",
          "supplier-master-change",
          "supplier-risk-signal",
          "supplier-tier-link",
          "supplier-risk-case",
          "supplier-remediation-action",
          "supplier-offboarding-case",
          "purchase-order",
          "buying-request",
          "catalogue-line",
          "requisition",
          "requisition-line",
          "order-line",
          "order-response",
          "purchase-order-exception",
          "receipt",
          "shipment",
          "receipt-line",
          "service-entry-sheet",
          "return-claim",
          "invoice",
          "invoice-line",
          "invoice-match-assessment",
          "invoice-exception",
          "supplier-invoice-resolution",
          "payment-readiness-assessment",
          "payment-instruction",
          "payment-execution-status",
          "supplier-segment-assignment",
          "supplier-performance-observation",
          "supplier-performance-review-record",
          "supplier-innovation-case",
          "supplier-joint-value-plan",
          "value-realization-attribution",
          "value-opportunity-baseline",
          "savings-initiative-record",
          "value-leakage-finding",
          "value-portfolio-forecast"
        ],
        "formatIds": [
          "format-mcp-json-rpc"
        ],
        "id": "workblock-mcp-tool-exposure",
        "inputEntityIds": [
          "authority-envelope",
          "source-record-reference",
          "evidence-item",
          "integration-state"
        ],
        "label": "Workblock tool exposure over Model Context Protocol",
        "licenseId": "bw-partner-1.0",
        "outcome": "Expose a stable business-module outcome tool through an authenticated access surface while execution and audit remain on the execution rails.",
        "outputEntityIds": [
          "action-proposal",
          "decision",
          "committed-action",
          "audit-event",
          "evidence-item"
        ],
        "owner": "The business module owns the outcome and its published agents; the Workblock authority envelope governs every invocation and commitment.",
        "proofClass": "recipe",
        "reliability": {
          "acknowledgement": "Typed schema, omitted optional arguments accepted and unknown fields rejected.",
          "degradedState": "Keep last-good state visible with its real freshness and quarantine incompatible input.",
          "freshness": "Record source-observed time, last successful exchange, next expected update and freshness status. Retain last-good data when an update is late.",
          "idempotency": "Stable source, destination, business key and version prevent duplicate business effect.",
          "monitoring": "Monitor identity, availability, latency, volume, validation, acknowledgement, reconciliation and recovery against the configured operating envelope.",
          "reconciliation": "Reconcile source or destination state, counts, versions, exceptions and authoritative readback.",
          "recovery": "User-safe message, internal cause retained in telemetry, readiness cause preserved for operators.",
          "rollback": "Stop new effects, restore the last accepted mapping and adapter version, then replay from recorded checkpoints after reconciliation."
        },
        "standardIds": [],
        "systemRoleIds": [
          "erp",
          "ap-platform",
          "expense-platform",
          "data-warehouse",
          "spend-analytics",
          "mdm",
          "warehouse",
          "category-suite",
          "market-intelligence",
          "risk-platform",
          "planning",
          "sharepoint",
          "office-documents",
          "policy-repository",
          "grc",
          "document-management",
          "intranet",
          "service-management",
          "service-catalogue",
          "procurement-suite",
          "intake-orchestration",
          "teams",
          "exchange",
          "identity",
          "supplier-master",
          "budget-system",
          "workflow-platform",
          "collaboration",
          "sourcing-suite",
          "clm",
          "supplier-network",
          "erp-master",
          "optimisation-specialist",
          "spreadsheet",
          "negotiation-specialist",
          "procurement-policy",
          "email",
          "document-repository",
          "signature",
          "word",
          "performance-system",
          "usage-analytics",
          "supplier-portal",
          "tax-registry",
          "identity-provider",
          "erp-supplier-master",
          "bank-validation",
          "evidence-network",
          "risk-monitoring",
          "news-and-market-data",
          "cyber-risk",
          "sustainability",
          "business-continuity",
          "catalogue",
          "edi-van",
          "peppol-access-point",
          "receiving-system",
          "warehouse-management",
          "field-service",
          "erp-ap",
          "invoice-network",
          "ap-automation",
          "document-capture",
          "treasury",
          "fraud-control",
          "tax-control",
          "bank",
          "payment-platform",
          "srm",
          "quality-system",
          "logistics",
          "innovation-portal",
          "idea-management",
          "value-management",
          "finance-ledger",
          "savings-platform",
          "finance-reporting"
        ],
        "trigger": "An authorised person selects an enabled module outcome tool through an approved access surface."
      },
      {
        "actionClasses": [
          "read-only"
        ],
        "authorityBoundary": "Knowledge grounding is read-only and grants no Workblock action authority.",
        "businessModuleIds": [
          "policy-rule-lifecycle",
          "policy-guidance",
          "procurement-service-catalogue"
        ],
        "channelIds": [
          "channel-microsoft-graph-copilot-connector"
        ],
        "configurableFields": [
          "Installed system and release",
          "Record and field ownership",
          "Identity and credentials",
          "Channel and format version",
          "Freshness and service envelope",
          "Acceptance evidence and support owner"
        ],
        "direction": "outbound",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand"
        ],
        "entityIds": [
          "source-record-reference",
          "evidence-item",
          "integration-state",
          "policy",
          "policy-version",
          "policy-rule-release",
          "decision",
          "policy-guidance-result",
          "exception",
          "registry-release",
          "procurement-service-offering",
          "authority-envelope"
        ],
        "formatIds": [
          "format-external-item"
        ],
        "id": "copilot-synced-knowledge-projection",
        "inputEntityIds": [
          "policy",
          "policy-version",
          "policy-rule-release",
          "procurement-service-offering",
          "source-record-reference"
        ],
        "label": "Microsoft 365 Copilot synced knowledge projection",
        "licenseId": "bw-partner-1.0",
        "outcome": "Publish an approved read-only projection into Microsoft Graph external items for search and grounding.",
        "outputEntityIds": [
          "source-record-reference",
          "evidence-item",
          "integration-state",
          "registry-release"
        ],
        "owner": "The source-owning module approves the projection; Microsoft Graph owns the indexed external item while GroundWorks retains the canonical record.",
        "proofClass": "recipe",
        "reliability": {
          "acknowledgement": "Track crawl watermark, accepted items, failed items, lag and tombstones.",
          "degradedState": "Apply item-level access controls and prove deletion and revocation propagation.",
          "freshness": "Record source-observed time, last successful exchange, next expected update and freshness status. Retain last-good data when an update is late.",
          "idempotency": "Stable source, destination, business key and version prevent duplicate business effect.",
          "monitoring": "Monitor identity, availability, latency, volume, validation, acknowledgement, reconciliation and recovery against the configured operating envelope.",
          "reconciliation": "Reconcile source or destination state, counts, versions, exceptions and authoritative readback.",
          "recovery": "Resume from recorded delivery state. Never retry an uncertain consequential effect blindly.",
          "rollback": "Stop new effects, restore the last accepted mapping and adapter version, then replay from recorded checkpoints after reconciliation."
        },
        "standardIds": [],
        "systemRoleIds": [
          "policy-repository",
          "sharepoint",
          "grc",
          "document-management",
          "intranet",
          "service-management",
          "service-catalogue",
          "procurement-suite"
        ],
        "trigger": "An approved publication or scheduled incremental sync starts a read-only knowledge projection."
      },
      {
        "actionClasses": [
          "read-only"
        ],
        "authorityBoundary": "Knowledge grounding is read-only and grants no Workblock action authority.",
        "businessModuleIds": [
          "policy-guidance",
          "procurement-service-catalogue"
        ],
        "channelIds": [
          "channel-streamable-http"
        ],
        "configurableFields": [
          "Installed system and release",
          "Record and field ownership",
          "Identity and credentials",
          "Channel and format version",
          "Freshness and service envelope",
          "Acceptance evidence and support owner"
        ],
        "direction": "interactive",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand"
        ],
        "entityIds": [
          "source-record-reference",
          "evidence-item",
          "integration-state",
          "policy-guidance-result",
          "policy",
          "policy-version",
          "policy-rule-release",
          "exception",
          "registry-release",
          "procurement-service-offering",
          "authority-envelope"
        ],
        "formatIds": [
          "format-mcp-json-rpc"
        ],
        "id": "copilot-federated-knowledge-query",
        "inputEntityIds": [
          "authority-envelope",
          "policy",
          "policy-version",
          "procurement-service-offering",
          "source-record-reference"
        ],
        "label": "Microsoft 365 Copilot federated knowledge query",
        "licenseId": "bw-partner-1.0",
        "outcome": "Return current read-only knowledge at query time through a Microsoft-approved federated connector.",
        "outputEntityIds": [
          "policy-guidance-result",
          "evidence-item",
          "source-record-reference",
          "integration-state"
        ],
        "owner": "The source-owning module retains the canonical record and access policy; the connector owns only the bounded query exchange.",
        "proofClass": "recipe",
        "reliability": {
          "acknowledgement": "Transport receipt, syntax acceptance and business acceptance remain separate states.",
          "degradedState": "Keep last-good state visible with its real freshness and quarantine incompatible input.",
          "freshness": "Record source-observed time, last successful exchange, next expected update and freshness status. Retain last-good data when an update is late.",
          "idempotency": "Stable source, destination, business key and version prevent duplicate business effect.",
          "monitoring": "Monitor identity, availability, latency, volume, validation, acknowledgement, reconciliation and recovery against the configured operating envelope.",
          "reconciliation": "Reconcile source or destination state, counts, versions, exceptions and authoritative readback.",
          "recovery": "Resume from recorded delivery state. Never retry an uncertain consequential effect blindly.",
          "rollback": "Stop new effects, restore the last accepted mapping and adapter version, then replay from recorded checkpoints after reconciliation."
        },
        "standardIds": [],
        "systemRoleIds": [
          "policy-repository",
          "sharepoint",
          "intranet",
          "service-management",
          "service-catalogue",
          "procurement-suite"
        ],
        "trigger": "An authorised Microsoft 365 Copilot query requests current knowledge through the configured federated connector."
      }
    ],
    "systemFamilies": [
      {
        "id": "erp-finance-and-enterprise-core",
        "label": "ERP, finance and enterprise core",
        "licenseId": "apache-2.0",
        "responsibility": "Retain transaction, accounting, budget and master-data responsibilities unless a bounded replacement has equivalent controls and evidence."
      },
      {
        "id": "procurement-suites-and-networks",
        "label": "Procurement suites and trading networks",
        "licenseId": "apache-2.0",
        "responsibility": "Preserve configured suite and network strengths. Use Workblocks for measured cross-system evidence, judgement, ownership or change gaps."
      },
      {
        "id": "accounts-payable-payment-and-treasury",
        "label": "Accounts payable, e-invoicing, payment and treasury",
        "licenseId": "apache-2.0",
        "responsibility": "Keep high-volume capture, matching, compliance, payment and settlement in the specialist or financial system where it is effective. Target evidence-complete exceptions and reconciled handoffs."
      },
      {
        "id": "contracts-signature-and-content",
        "label": "Contract lifecycle, signature and content collaboration",
        "licenseId": "apache-2.0",
        "responsibility": "Separate content authority, legal decision authority, signature commitment and canonical procurement state."
      },
      {
        "id": "supplier-risk-identity-and-people",
        "label": "Supplier, risk, identity and people records",
        "licenseId": "apache-2.0",
        "responsibility": "Keep specialist networks and identity authorities. Canonical records store namespaced identifiers, evidence, freshness and decisions rather than copying an entire specialist dataset."
      },
      {
        "id": "intake-sourcing-and-specialists",
        "label": "Intake, sourcing, negotiation and innovation specialists",
        "licenseId": "apache-2.0",
        "responsibility": "Use specialist depth where it is stronger. Integrate its evidence or authorised tools into the owning Workblock and preserve cross-domain follow-through."
      },
      {
        "id": "analytics-planning-and-master-data",
        "label": "Data, analytics, planning and master-data estate",
        "licenseId": "apache-2.0",
        "responsibility": "Treat warehouses and analytics as connectable estates and read-model owners, not mandatory migrations or automatic action authorities."
      },
      {
        "id": "adjacent-operational-sources",
        "label": "Adjacent operational and evidence sources",
        "licenseId": "apache-2.0",
        "responsibility": "Map only the records needed by a bounded outcome. Do not absorb another operational domain into procurement taxonomy."
      },
      {
        "id": "integration-transport-and-channels",
        "label": "Integration estate and durable channels",
        "licenseId": "apache-2.0",
        "responsibility": "These systems move, transform or schedule messages. They do not decide canonical record ownership, business authority or completion."
      }
    ],
    "systemProfiles": [
      {
        "channelIds": [
          "channel-sap-idoc",
          "channel-cxml",
          "channel-ubl-or-peppol-where-supported",
          "channel-csv",
          "channel-xml",
          "channel-sftp",
          "channel-as2",
          "channel-narrow-api"
        ],
        "classificationAnchors": [
          {
            "attributeLabel": "Material group (MARA-MATKL)",
            "authority": "authoritative-default",
            "businessEffectIds": [],
            "canonicalEntityId": "item-service",
            "canonicalFieldId": "category-id",
            "id": "sap-material-group-item-default",
            "objectLabel": "Material master purchasing view",
            "objectRole": "item-default"
          },
          {
            "attributeLabel": "Strategic grouping over material groups and suppliers",
            "authority": "proposal-signal",
            "businessEffectIds": [],
            "canonicalEntityId": "category",
            "canonicalFieldId": "category-id",
            "id": "sap-purchasing-category-strategy-hierarchy",
            "objectLabel": "Purchasing category",
            "objectRole": "strategy-hierarchy"
          }
        ],
        "designQuestion": "Pin module, basic type or document contract, custom extensions, logical system, company code, purchasing organisation, authoritative readback and correction route.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "familyId": "erp-finance-and-enterprise-core",
        "formatIds": [
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-csv",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "sap-s4hana-ecc",
        "licenseId": "apache-2.0",
        "name": "SAP S/4HANA or SAP ECC",
        "recipeIds": [
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "commitment-system"
        ]
      },
      {
        "channelIds": [
          "channel-business-document",
          "channel-csv",
          "channel-xml",
          "channel-sftp",
          "channel-event",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin cloud or EBS edition, business unit and ledger scope, bulk import/export contract, REST or SOAP version, callback and scheduled-process reconciliation.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "value-realization-savings"
        ],
        "familyId": "erp-finance-and-enterprise-core",
        "formatIds": [
          "format-drive-item",
          "format-list-item",
          "format-docx",
          "format-xlsx",
          "format-pdf",
          "format-structured-list",
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-csv",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "oracle-fusion-ebs",
        "licenseId": "apache-2.0",
        "name": "Oracle Fusion Cloud ERP or Oracle E-Business Suite",
        "recipeIds": [
          "sharepoint-content-binding",
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "commitment-system"
        ]
      },
      {
        "channelIds": [
          "channel-business-event",
          "channel-data-entity",
          "channel-odata",
          "channel-csv",
          "channel-microsoft-dataverse",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin legal entity, data entities, dual-write or Dataverse use, batch semantics, business events and source readback.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "value-realization-savings"
        ],
        "familyId": "erp-finance-and-enterprise-core",
        "formatIds": [
          "format-csv",
          "format-json",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "microsoft-dynamics-365-finance-supply-chain",
        "licenseId": "apache-2.0",
        "name": "Microsoft Dynamics 365 Finance and Supply Chain Management",
        "recipeIds": [
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "commitment-system"
        ]
      },
      {
        "channelIds": [
          "channel-workday-report",
          "channel-workday-eib",
          "channel-xml",
          "channel-sftp",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin tenant, business process, report or EIB contract, security group and inbound-event completion evidence.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "value-realization-savings"
        ],
        "familyId": "erp-finance-and-enterprise-core",
        "formatIds": [
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-csv",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "workday-financial-management",
        "licenseId": "apache-2.0",
        "name": "Workday Financial Management",
        "recipeIds": [
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "commitment-system"
        ]
      },
      {
        "channelIds": [
          "channel-infor-ion-document",
          "channel-edi",
          "channel-csv",
          "channel-xml",
          "channel-sftp",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin CloudSuite product, ION business object documents, tenant, accounting entity, custom fields and delivery acknowledgement.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "value-realization-savings"
        ],
        "familyId": "erp-finance-and-enterprise-core",
        "formatIds": [
          "format-drive-item",
          "format-list-item",
          "format-docx",
          "format-xlsx",
          "format-pdf",
          "format-structured-list",
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-csv",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "infor-cloudsuite",
        "licenseId": "apache-2.0",
        "name": "Infor CloudSuite",
        "recipeIds": [
          "sharepoint-content-binding",
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "commitment-system"
        ]
      },
      {
        "channelIds": [
          "channel-csv",
          "channel-xml",
          "channel-sftp",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin edition, object contract, flexi-fields, batch completion and authoritative correction flow.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "value-realization-savings"
        ],
        "familyId": "erp-finance-and-enterprise-core",
        "formatIds": [
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-csv",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "unit4-erp",
        "licenseId": "apache-2.0",
        "name": "Unit4 ERP",
        "recipeIds": [
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "commitment-system"
        ]
      },
      {
        "channelIds": [
          "channel-csv",
          "channel-sftp",
          "channel-rest",
          "channel-soap",
          "channel-event"
        ],
        "designQuestion": "Pin account, subsidiary, custom record and field definitions, concurrency governance and saved-search or batch reconciliation.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "value-realization-savings"
        ],
        "familyId": "erp-finance-and-enterprise-core",
        "formatIds": [
          "format-csv",
          "format-json",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "oracle-netsuite",
        "licenseId": "apache-2.0",
        "name": "Oracle NetSuite",
        "recipeIds": [
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "commitment-system"
        ]
      },
      {
        "channelIds": [
          "channel-cxml",
          "channel-sap-document-exchange",
          "channel-csv",
          "channel-xml",
          "channel-sftp",
          "channel-narrow-api"
        ],
        "classificationAnchors": [
          {
            "attributeLabel": "Custom or ERP commodity code mapped within the realm",
            "authority": "authoritative-default",
            "businessEffectIds": [
              "accounting-default",
              "receiving",
              "tax",
              "catalogue-navigation"
            ],
            "canonicalEntityId": "item-service",
            "canonicalFieldId": "category-id",
            "id": "ariba-realm-commodity-item-default",
            "objectLabel": "Realm commodity dimension",
            "objectRole": "item-default",
            "standardIds": [
              "unspsc"
            ]
          },
          {
            "attributeLabel": "Commodity",
            "authority": "discovery-only",
            "businessEffectIds": [
              "qualification"
            ],
            "canonicalEntityId": "supplier-qualification",
            "canonicalFieldId": "scope-code",
            "id": "ariba-supplier-commodity-discovery",
            "objectLabel": "Supplier record",
            "objectRole": "supplier-discovery"
          },
          {
            "attributeLabel": "UNSPSC system code",
            "authority": "proposal-signal",
            "businessEffectIds": [],
            "canonicalEntityId": "category",
            "canonicalFieldId": "external-classification",
            "id": "ariba-unspsc-external-code",
            "objectLabel": "Commodity code mapping",
            "objectRole": "external-code",
            "standardIds": [
              "unspsc"
            ]
          }
        ],
        "designQuestion": "Pin each installed module and release, realm, network routing, source responsibility, cXML DTD, integration events, custom fields and document-status readback.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "familyId": "procurement-suites-and-networks",
        "formatIds": [
          "format-drive-item",
          "format-list-item",
          "format-docx",
          "format-xlsx",
          "format-pdf",
          "format-structured-list",
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-csv",
          "format-xml",
          "format-parquet",
          "format-source-native-export",
          "format-ubl-or-peppol-where-supported",
          "format-unspsc"
        ],
        "id": "sap-ariba-suite",
        "licenseId": "apache-2.0",
        "name": "SAP Ariba applications",
        "recipeIds": [
          "sharepoint-content-binding",
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "commitment-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-cxml",
          "channel-edi",
          "channel-sap-document-exchange"
        ],
        "designQuestion": "Pin buyer and supplier accounts, document routing, network IDs, transaction rules, rejection statuses and duplicate-delivery behaviour.",
        "domainWorkblockIds": [
          "sourcing-negotiation",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness"
        ],
        "familyId": "procurement-suites-and-networks",
        "formatIds": [
          "format-drive-item",
          "format-list-item",
          "format-docx",
          "format-xlsx",
          "format-pdf",
          "format-structured-list",
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-csv",
          "format-xml",
          "format-ubl-or-peppol-where-supported"
        ],
        "id": "sap-business-network",
        "licenseId": "apache-2.0",
        "name": "SAP Business Network",
        "recipeIds": [
          "sharepoint-content-binding",
          "structured-business-document-ingest",
          "structured-business-document-outbound"
        ],
        "systemRoleIds": [
          "managed-network",
          "execution-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-coupa-core-flat-file-csv",
          "channel-coupa-core-api-xml-json",
          "channel-cxml-where-configured"
        ],
        "classificationAnchors": [
          {
            "attributeLabel": "Commodity",
            "authority": "committed-value",
            "businessEffectIds": [
              "accounting-default",
              "approval"
            ],
            "canonicalEntityId": "spend-record",
            "canonicalFieldId": "category-id",
            "id": "coupa-commodity-transaction-classification",
            "objectLabel": "Requisition and order line",
            "objectRole": "transaction-classification"
          },
          {
            "attributeLabel": "Commodity",
            "authority": "authoritative-default",
            "businessEffectIds": [
              "accounting-default",
              "approval"
            ],
            "canonicalEntityId": "item-service",
            "canonicalFieldId": "category-id",
            "id": "coupa-commodity-item-default",
            "objectLabel": "Item record",
            "objectRole": "item-default"
          },
          {
            "attributeLabel": "Commodity",
            "authority": "discovery-only",
            "businessEffectIds": [
              "qualification"
            ],
            "canonicalEntityId": "supplier-qualification",
            "canonicalFieldId": "scope-code",
            "id": "coupa-supplier-commodity-discovery",
            "objectLabel": "Supplier record",
            "objectRole": "supplier-discovery"
          },
          {
            "attributeLabel": "UNSPSC code",
            "authority": "proposal-signal",
            "businessEffectIds": [],
            "canonicalEntityId": "item-service",
            "canonicalFieldId": "external-classification",
            "id": "coupa-unspsc-external-code",
            "objectLabel": "Transaction line",
            "objectRole": "external-code",
            "standardIds": [
              "unspsc"
            ]
          }
        ],
        "designQuestion": "Pin modules, release, object contracts, CSV format, API version, custom fields, integration history and source readback.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "familyId": "procurement-suites-and-networks",
        "formatIds": [
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-csv",
          "format-xml",
          "format-parquet",
          "format-source-native-export",
          "format-core-flat-file-csv",
          "format-core-api-xml-or-json",
          "format-cxml-where-configured",
          "format-unspsc"
        ],
        "id": "coupa",
        "licenseId": "apache-2.0",
        "name": "Coupa",
        "recipeIds": [
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "commitment-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-tenant-export-import",
          "channel-csv",
          "channel-xml",
          "channel-json",
          "channel-cxml-or-edi-if-configured"
        ],
        "designQuestion": "Obtain tenant-specific integration definitions, object and custom-field dictionaries, samples, scheduler or event behaviour and acknowledgement records.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "familyId": "procurement-suites-and-networks",
        "formatIds": [
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-csv",
          "format-xml",
          "format-parquet",
          "format-source-native-export",
          "format-client-export",
          "format-cxml-or-edi-if-configured",
          "format-client-import"
        ],
        "id": "ivalua",
        "licenseId": "apache-2.0",
        "name": "Ivalua",
        "recipeIds": [
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "commitment-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-client-export-import",
          "channel-csv",
          "channel-xml",
          "channel-json",
          "channel-cxml",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin licensed modules, data ownership, exchange catalogue and operational receipts before selecting recipes.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "value-realization-savings"
        ],
        "familyId": "procurement-suites-and-networks",
        "formatIds": [
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-csv",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "gep-smart",
        "licenseId": "apache-2.0",
        "name": "GEP SMART",
        "recipeIds": [
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "commitment-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-client-export-import",
          "channel-cxml",
          "channel-edi",
          "channel-csv",
          "channel-xml",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin product family, supplier network, document route, custom fields and completion evidence.",
        "domainWorkblockIds": [
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness"
        ],
        "familyId": "procurement-suites-and-networks",
        "formatIds": [
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-csv",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "jaggaer",
        "licenseId": "apache-2.0",
        "name": "JAGGAER",
        "recipeIds": [
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "commitment-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-business-document",
          "channel-csv",
          "channel-xml",
          "channel-sftp",
          "channel-event",
          "channel-narrow-api"
        ],
        "classificationAnchors": [
          {
            "attributeLabel": "Purchasing category",
            "authority": "committed-value",
            "businessEffectIds": [],
            "canonicalEntityId": "spend-record",
            "canonicalFieldId": "category-id",
            "id": "oracle-requisition-category-transaction",
            "objectLabel": "Requisition line",
            "objectRole": "transaction-classification"
          },
          {
            "attributeLabel": "Item or purchasing category",
            "authority": "authoritative-default",
            "businessEffectIds": [
              "catalogue-navigation"
            ],
            "canonicalEntityId": "item-service",
            "canonicalFieldId": "category-id",
            "id": "oracle-item-category-default",
            "objectLabel": "Catalogue item",
            "objectRole": "item-default"
          },
          {
            "attributeLabel": "Navigation category",
            "authority": "proposal-signal",
            "businessEffectIds": [
              "catalogue-navigation"
            ],
            "canonicalEntityId": "category",
            "canonicalFieldId": "parent-category-id",
            "id": "oracle-browsing-category-navigation",
            "objectLabel": "Browsing category hierarchy",
            "objectRole": "strategy-hierarchy"
          },
          {
            "attributeLabel": "Hierarchy level used by approval rules",
            "authority": "proposal-signal",
            "businessEffectIds": [
              "approval"
            ],
            "canonicalEntityId": "category",
            "canonicalFieldId": "parent-category-id",
            "id": "oracle-procurement-category-approval",
            "objectLabel": "Procurement category hierarchy",
            "objectRole": "approval-input"
          }
        ],
        "designQuestion": "Separate procurement and financial ownership, pin release and bulk-import or REST contracts, and reconcile scheduled processes.",
        "domainWorkblockIds": [
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving"
        ],
        "familyId": "procurement-suites-and-networks",
        "formatIds": [
          "format-drive-item",
          "format-list-item",
          "format-docx",
          "format-xlsx",
          "format-pdf",
          "format-structured-list",
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-csv",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "oracle-fusion-cloud-procurement",
        "licenseId": "apache-2.0",
        "name": "Oracle Fusion Cloud Procurement",
        "recipeIds": [
          "sharepoint-content-binding",
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "commitment-system"
        ]
      },
      {
        "channelIds": [
          "channel-client-export-import",
          "channel-csv",
          "channel-xml",
          "channel-json",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin modules, object contracts, custom fields and authoritative downstream system.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness"
        ],
        "familyId": "procurement-suites-and-networks",
        "formatIds": [
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-csv",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "zycus",
        "licenseId": "apache-2.0",
        "name": "Zycus",
        "recipeIds": [
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-client-export-import",
          "channel-csv",
          "channel-xml",
          "channel-cxml",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin modules, supplier-network responsibilities, payloads and reconciliation path.",
        "domainWorkblockIds": [
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness"
        ],
        "familyId": "procurement-suites-and-networks",
        "formatIds": [
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-csv",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "proactis",
        "licenseId": "apache-2.0",
        "name": "Proactis",
        "recipeIds": [
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-basware-xml",
          "channel-basware-api",
          "channel-file-based-exchange",
          "channel-peppol-or-network-document"
        ],
        "designQuestion": "Pin AP or network products, tenant configuration, XML interface, API family, invoice images, statuses and ERP handoff.",
        "domainWorkblockIds": [
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "value-realization-savings"
        ],
        "familyId": "accounts-payable-payment-and-treasury",
        "formatIds": [
          "format-drive-item",
          "format-list-item",
          "format-docx",
          "format-xlsx",
          "format-pdf",
          "format-structured-list",
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-csv",
          "format-xml",
          "format-parquet",
          "format-source-native-export",
          "format-basware-xml",
          "format-basware-api",
          "format-file-based-exchange",
          "format-peppol-or-network-document"
        ],
        "id": "basware",
        "licenseId": "apache-2.0",
        "name": "Basware",
        "recipeIds": [
          "sharepoint-content-binding",
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "evidence-source",
          "managed-network"
        ]
      },
      {
        "channelIds": [
          "channel-invoice-document",
          "channel-csv",
          "channel-xml",
          "channel-sftp",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin products, capture channels, matching authority, ERP handoff and exception completion evidence.",
        "domainWorkblockIds": [
          "invoice-exception-payment-readiness",
          "value-realization-savings"
        ],
        "familyId": "accounts-payable-payment-and-treasury",
        "formatIds": [
          "format-drive-item",
          "format-list-item",
          "format-docx",
          "format-xlsx",
          "format-pdf",
          "format-structured-list",
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-csv",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "medius",
        "licenseId": "apache-2.0",
        "name": "Medius",
        "recipeIds": [
          "sharepoint-content-binding",
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-invoice-document",
          "channel-csv",
          "channel-xml",
          "channel-sftp",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin solution, document channels, approval ownership and ERP reconciliation.",
        "domainWorkblockIds": [
          "invoice-exception-payment-readiness"
        ],
        "familyId": "accounts-payable-payment-and-treasury",
        "formatIds": [
          "format-drive-item",
          "format-list-item",
          "format-docx",
          "format-xlsx",
          "format-pdf",
          "format-structured-list",
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-csv",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "esker",
        "licenseId": "apache-2.0",
        "name": "Esker",
        "recipeIds": [
          "sharepoint-content-binding",
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-invoice-document",
          "channel-csv",
          "channel-sftp",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin payee, AP and payment products, banking boundary, payment authority, status and return reconciliation.",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk",
          "invoice-exception-payment-readiness"
        ],
        "familyId": "accounts-payable-payment-and-treasury",
        "formatIds": [
          "format-drive-item",
          "format-list-item",
          "format-docx",
          "format-xlsx",
          "format-pdf",
          "format-structured-list",
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-csv",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "tipalti",
        "licenseId": "apache-2.0",
        "name": "Tipalti",
        "recipeIds": [
          "sharepoint-content-binding",
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "commitment-system",
          "payment-or-settlement-rail"
        ]
      },
      {
        "channelIds": [
          "channel-invoice-document",
          "channel-edi",
          "channel-xml",
          "channel-sftp",
          "channel-narrow-api"
        ],
        "designQuestion": "Separate capture and network products, pin message formats and destination acknowledgement.",
        "domainWorkblockIds": [
          "invoice-exception-payment-readiness"
        ],
        "familyId": "accounts-payable-payment-and-treasury",
        "formatIds": [
          "format-drive-item",
          "format-list-item",
          "format-docx",
          "format-xlsx",
          "format-pdf",
          "format-structured-list",
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-csv",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "tungsten-automation-network",
        "licenseId": "apache-2.0",
        "name": "Tungsten Automation and Tungsten Network",
        "recipeIds": [
          "sharepoint-content-binding",
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "execution-system",
          "evidence-source",
          "managed-network"
        ]
      },
      {
        "channelIds": [
          "channel-peppol",
          "channel-edi",
          "channel-xml",
          "channel-csv",
          "channel-as2",
          "channel-sftp"
        ],
        "designQuestion": "Pin contracted network service, country mandates, profile versions, access point and receipt semantics.",
        "domainWorkblockIds": [
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness"
        ],
        "familyId": "accounts-payable-payment-and-treasury",
        "formatIds": [
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-csv",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "opentext-pagero",
        "licenseId": "apache-2.0",
        "name": "OpenText and Pagero",
        "recipeIds": [
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "managed-network",
          "execution-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-peppol-bis-billing-3",
          "channel-peppol-ordering-3",
          "channel-peppol-eas-iso-6523"
        ],
        "designQuestion": "Pin provider, network agreement, jurisdiction, participant schemes, profiles, releases, service metadata and receipt chain.",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness"
        ],
        "familyId": "accounts-payable-payment-and-treasury",
        "formatIds": [
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-peppol-bis-billing-3",
          "format-peppol-eas-iso-6523"
        ],
        "id": "peppol-access-point",
        "licenseId": "apache-2.0",
        "name": "Peppol access point",
        "recipeIds": [
          "structured-business-document-ingest",
          "structured-business-document-outbound"
        ],
        "systemRoleIds": [
          "managed-network",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-iso-20022",
          "channel-bank-xml",
          "channel-bank-csv",
          "channel-sftp",
          "channel-swift-service",
          "channel-host-to-host"
        ],
        "designQuestion": "Pin bank, country, account, channel, message version, release authority, cut-off, acknowledgement, statement and return contract.",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk",
          "invoice-exception-payment-readiness",
          "value-realization-savings"
        ],
        "familyId": "accounts-payable-payment-and-treasury",
        "formatIds": [
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-bank-csv",
          "format-bank-xml",
          "format-proprietary-sample-required",
          "format-csv",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "bank",
        "licenseId": "apache-2.0",
        "name": "Banks and banking portals",
        "recipeIds": [
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "payment-and-bank-message-exchange",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "commitment-system",
          "payment-or-settlement-rail",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-iso-20022",
          "channel-bank-file",
          "channel-sftp",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin treasury ownership, payment factory flow, bank connectivity and readback.",
        "domainWorkblockIds": [
          "invoice-exception-payment-readiness",
          "value-realization-savings"
        ],
        "familyId": "accounts-payable-payment-and-treasury",
        "formatIds": [
          "format-iso-20022",
          "format-bank-csv",
          "format-bank-xml",
          "format-proprietary-sample-required",
          "format-csv",
          "format-json",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "kyriba",
        "licenseId": "apache-2.0",
        "name": "Kyriba",
        "recipeIds": [
          "payment-and-bank-message-exchange",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "commitment-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-coupa-exchange",
          "channel-bank-message",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin product, funding and banking model, authority, settlement state and ERP reconciliation.",
        "domainWorkblockIds": [
          "invoice-exception-payment-readiness"
        ],
        "familyId": "accounts-payable-payment-and-treasury",
        "formatIds": [
          "format-iso-20022",
          "format-bank-csv",
          "format-bank-xml",
          "format-proprietary-sample-required",
          "format-message",
          "format-attachment",
          "format-adaptive-card",
          "format-email",
          "format-file-link"
        ],
        "id": "coupa-pay",
        "licenseId": "apache-2.0",
        "name": "Coupa Pay",
        "recipeIds": [
          "payment-and-bank-message-exchange",
          "collaboration-intake"
        ],
        "systemRoleIds": [
          "execution-system",
          "commitment-system",
          "payment-or-settlement-rail",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-sap-idoc",
          "channel-iso-20022",
          "channel-bank-file",
          "channel-sftp"
        ],
        "designQuestion": "Pin component, payment medium workbench, bank communication, logical systems and status reconciliation.",
        "domainWorkblockIds": [
          "invoice-exception-payment-readiness",
          "value-realization-savings"
        ],
        "familyId": "accounts-payable-payment-and-treasury",
        "formatIds": [
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-bank-csv",
          "format-bank-xml",
          "format-proprietary-sample-required",
          "format-csv",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "sap-treasury",
        "licenseId": "apache-2.0",
        "name": "SAP Treasury and payment processing",
        "recipeIds": [
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "payment-and-bank-message-exchange",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "commitment-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-document",
          "channel-csv",
          "channel-xml",
          "channel-event",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin modules, repository authority, native-file fidelity, metadata schema, obligation model and signature handoff.",
        "domainWorkblockIds": [
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "familyId": "contracts-signature-and-content",
        "formatIds": [
          "format-drive-item",
          "format-list-item",
          "format-docx",
          "format-xlsx",
          "format-pdf",
          "format-structured-list",
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-csv",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "icertis",
        "licenseId": "apache-2.0",
        "name": "Icertis",
        "recipeIds": [
          "sharepoint-content-binding",
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "commitment-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-document",
          "channel-csv",
          "channel-xml",
          "channel-event",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin contract and performance responsibilities, record versions and downstream actions.",
        "domainWorkblockIds": [
          "contract-lifecycle-management",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "familyId": "contracts-signature-and-content",
        "formatIds": [
          "format-drive-item",
          "format-list-item",
          "format-docx",
          "format-xlsx",
          "format-pdf",
          "format-structured-list",
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-csv",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "sirion",
        "licenseId": "apache-2.0",
        "name": "Sirion",
        "recipeIds": [
          "sharepoint-content-binding",
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-document",
          "channel-csv",
          "channel-event",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin workflow and repository scope, metadata, versioning and signature integration.",
        "domainWorkblockIds": [
          "contract-lifecycle-management"
        ],
        "familyId": "contracts-signature-and-content",
        "formatIds": [
          "format-drive-item",
          "format-list-item",
          "format-docx",
          "format-xlsx",
          "format-pdf",
          "format-structured-list",
          "format-csv",
          "format-json",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "ironclad",
        "licenseId": "apache-2.0",
        "name": "Ironclad",
        "recipeIds": [
          "sharepoint-content-binding",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-document",
          "channel-csv",
          "channel-xml",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin table and field configuration, workflow authority, document store and integration triggers.",
        "domainWorkblockIds": [
          "contract-lifecycle-management"
        ],
        "familyId": "contracts-signature-and-content",
        "formatIds": [
          "format-drive-item",
          "format-list-item",
          "format-docx",
          "format-xlsx",
          "format-pdf",
          "format-structured-list",
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-csv",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "agiloft",
        "licenseId": "apache-2.0",
        "name": "Agiloft",
        "recipeIds": [
          "sharepoint-content-binding",
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-document",
          "channel-webhook",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin account, envelope templates, signer identity, callback security, exact-content binding and completed-artifact retrieval.",
        "domainWorkblockIds": [
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk"
        ],
        "familyId": "contracts-signature-and-content",
        "formatIds": [
          "format-drive-item",
          "format-list-item",
          "format-docx",
          "format-xlsx",
          "format-pdf",
          "format-structured-list",
          "format-message",
          "format-attachment",
          "format-adaptive-card",
          "format-email",
          "format-file-link"
        ],
        "id": "docusign",
        "licenseId": "apache-2.0",
        "name": "DocuSign",
        "recipeIds": [
          "sharepoint-content-binding",
          "collaboration-intake"
        ],
        "systemRoleIds": [
          "commitment-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-document",
          "channel-webhook",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin account, workflow, signer identity, callback and exact approved version.",
        "domainWorkblockIds": [
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk"
        ],
        "familyId": "contracts-signature-and-content",
        "formatIds": [
          "format-drive-item",
          "format-list-item",
          "format-docx",
          "format-xlsx",
          "format-pdf",
          "format-structured-list",
          "format-message",
          "format-attachment",
          "format-adaptive-card",
          "format-email",
          "format-file-link"
        ],
        "id": "adobe-acrobat-sign",
        "licenseId": "apache-2.0",
        "name": "Adobe Acrobat Sign",
        "recipeIds": [
          "sharepoint-content-binding",
          "collaboration-intake"
        ],
        "systemRoleIds": [
          "commitment-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-microsoft-graph",
          "channel-sharepoint-content-binding"
        ],
        "designQuestion": "Pin tenant, sites, libraries, lists, content types, columns, permissions, retention, sensitivity, versioning, selected scopes, delta and notification coverage.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "familyId": "contracts-signature-and-content",
        "formatIds": [
          "format-drive-item",
          "format-list-item",
          "format-docx",
          "format-xlsx",
          "format-pdf",
          "format-structured-list"
        ],
        "id": "microsoft-sharepoint",
        "licenseId": "apache-2.0",
        "name": "Microsoft SharePoint",
        "recipeIds": [
          "sharepoint-content-binding"
        ],
        "systemRoleIds": [
          "source-of-record",
          "evidence-source",
          "collaboration-channel"
        ]
      },
      {
        "channelIds": [
          "channel-microsoft-graph"
        ],
        "designQuestion": "Define whether personal content is permitted, how ownership changes are handled and when content must move to a governed site.",
        "domainWorkblockIds": [
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-performance-innovation-relationship"
        ],
        "familyId": "contracts-signature-and-content",
        "formatIds": [
          "format-drive-item",
          "format-list-item",
          "format-docx",
          "format-xlsx",
          "format-pdf",
          "format-structured-list"
        ],
        "id": "microsoft-onedrive",
        "licenseId": "apache-2.0",
        "name": "Microsoft OneDrive for Business",
        "recipeIds": [
          "sharepoint-content-binding"
        ],
        "systemRoleIds": [
          "source-of-record",
          "evidence-source",
          "collaboration-channel"
        ]
      },
      {
        "channelIds": [
          "channel-microsoft-graph",
          "channel-webhook",
          "channel-adaptive-card"
        ],
        "designQuestion": "Pin teams, channels, app policy, user identity, message retention and SharePoint-backed file locations.",
        "domainWorkblockIds": [
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "supplier-performance-innovation-relationship"
        ],
        "familyId": "contracts-signature-and-content",
        "formatIds": [
          "format-drive-item",
          "format-list-item",
          "format-docx",
          "format-xlsx",
          "format-pdf",
          "format-structured-list",
          "format-message",
          "format-attachment",
          "format-adaptive-card",
          "format-email",
          "format-file-link"
        ],
        "id": "microsoft-teams",
        "licenseId": "apache-2.0",
        "name": "Microsoft Teams",
        "recipeIds": [
          "sharepoint-content-binding",
          "collaboration-intake"
        ],
        "systemRoleIds": [
          "collaboration-channel",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-microsoft-graph",
          "channel-email-gateway"
        ],
        "designQuestion": "Pin mailboxes, delegated or application access, retention, journalling, attachment policy and acknowledgement behaviour.",
        "domainWorkblockIds": [
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship"
        ],
        "familyId": "contracts-signature-and-content",
        "formatIds": [
          "format-drive-item",
          "format-list-item",
          "format-docx",
          "format-xlsx",
          "format-pdf",
          "format-structured-list",
          "format-message",
          "format-attachment",
          "format-adaptive-card",
          "format-email",
          "format-file-link"
        ],
        "id": "microsoft-exchange-online",
        "licenseId": "apache-2.0",
        "name": "Microsoft Exchange Online",
        "recipeIds": [
          "sharepoint-content-binding",
          "collaboration-intake"
        ],
        "systemRoleIds": [
          "collaboration-channel",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-webhook",
          "channel-narrow-api",
          "channel-file-export"
        ],
        "designQuestion": "Pin enterprise account, folder taxonomy, metadata templates, permissions, retention and event delivery.",
        "domainWorkblockIds": [
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "supplier-performance-innovation-relationship"
        ],
        "familyId": "contracts-signature-and-content",
        "formatIds": [
          "format-message",
          "format-attachment",
          "format-adaptive-card",
          "format-email",
          "format-file-link",
          "format-csv",
          "format-json",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "box",
        "licenseId": "apache-2.0",
        "name": "Box",
        "recipeIds": [
          "collaboration-intake",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "source-of-record",
          "evidence-source",
          "collaboration-channel"
        ]
      },
      {
        "channelIds": [
          "channel-webhook",
          "channel-narrow-api",
          "channel-file-export"
        ],
        "designQuestion": "Pin domains, shared drives, service-account delegation, native-format export, permissions and retention.",
        "domainWorkblockIds": [
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-performance-innovation-relationship"
        ],
        "familyId": "contracts-signature-and-content",
        "formatIds": [
          "format-message",
          "format-attachment",
          "format-adaptive-card",
          "format-email",
          "format-file-link",
          "format-csv",
          "format-json",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "google-drive-workspace",
        "licenseId": "apache-2.0",
        "name": "Google Drive and Google Workspace",
        "recipeIds": [
          "collaboration-intake",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "source-of-record",
          "evidence-source",
          "collaboration-channel"
        ]
      },
      {
        "channelIds": [
          "channel-master-reference-sync"
        ],
        "designQuestion": "Identify the canonical writer for each field, duplicate and merge policy, fraud controls, identifier namespaces and downstream distribution.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship"
        ],
        "familyId": "supplier-risk-identity-and-people",
        "formatIds": [
          "format-csv",
          "format-json",
          "format-xml",
          "format-source-native-export",
          "format-gs1-gln"
        ],
        "id": "client-supplier-master",
        "licenseId": "apache-2.0",
        "name": "Client supplier master or master-data hub",
        "recipeIds": [
          "master-reference-sync"
        ],
        "systemRoleIds": [
          "system-of-record",
          "identity-authority"
        ]
      },
      {
        "channelIds": [
          "channel-risk-evidence-feed",
          "channel-csv",
          "channel-sftp",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin modules, content providers, assessment authority, residual-risk decision and remediation state.",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk",
          "contract-lifecycle-management"
        ],
        "familyId": "supplier-risk-identity-and-people",
        "formatIds": [
          "format-json",
          "format-xml",
          "format-csv",
          "format-document",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "processunity",
        "licenseId": "apache-2.0",
        "name": "ProcessUnity",
        "recipeIds": [
          "risk-and-reference-evidence-feed",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-risk-evidence-feed",
          "channel-csv",
          "channel-sftp",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin programme configuration, third-party identity, workflow authority and evidence retention.",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk",
          "contract-lifecycle-management"
        ],
        "familyId": "supplier-risk-identity-and-people",
        "formatIds": [
          "format-json",
          "format-xml",
          "format-csv",
          "format-document",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "aravo",
        "licenseId": "apache-2.0",
        "name": "Aravo",
        "recipeIds": [
          "risk-and-reference-evidence-feed",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-risk-evidence-feed",
          "channel-csv",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin product modules, assessment scope, privacy ownership and record handoffs.",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk",
          "contract-lifecycle-management"
        ],
        "familyId": "supplier-risk-identity-and-people",
        "formatIds": [
          "format-json",
          "format-xml",
          "format-csv",
          "format-document",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "onetrust",
        "licenseId": "apache-2.0",
        "name": "OneTrust",
        "recipeIds": [
          "risk-and-reference-evidence-feed",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-risk-evidence-feed",
          "channel-csv",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin configured workflows, identity matching, source integrations and commitment boundary.",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk",
          "intake-demand"
        ],
        "familyId": "supplier-risk-identity-and-people",
        "formatIds": [
          "format-json",
          "format-xml",
          "format-csv",
          "format-document",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "certa",
        "licenseId": "apache-2.0",
        "name": "Certa",
        "recipeIds": [
          "risk-and-reference-evidence-feed",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-risk-evidence-feed",
          "channel-csv",
          "channel-sftp",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin assessment and monitoring products, evidence licences, identity and remediation authority.",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk"
        ],
        "familyId": "supplier-risk-identity-and-people",
        "formatIds": [
          "format-json",
          "format-xml",
          "format-csv",
          "format-document",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "prevalent",
        "licenseId": "apache-2.0",
        "name": "Prevalent",
        "recipeIds": [
          "risk-and-reference-evidence-feed",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-risk-evidence-feed"
        ],
        "designQuestion": "Pin subscription, supplier coverage, rating version, licence, permitted storage and refresh cadence.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "supplier-performance-innovation-relationship"
        ],
        "familyId": "supplier-risk-identity-and-people",
        "formatIds": [
          "format-json",
          "format-xml",
          "format-csv",
          "format-document"
        ],
        "id": "ecovadis",
        "licenseId": "apache-2.0",
        "name": "EcoVadis",
        "recipeIds": [
          "risk-and-reference-evidence-feed"
        ],
        "systemRoleIds": [
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-risk-evidence-feed",
          "channel-master-reference-sync"
        ],
        "designQuestion": "Pin data product, identifier namespace, coverage, licence, matching method and refresh.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "sourcing-negotiation",
          "supplier-lifecycle-third-party-risk",
          "supplier-performance-innovation-relationship"
        ],
        "familyId": "supplier-risk-identity-and-people",
        "formatIds": [
          "format-json",
          "format-xml",
          "format-csv",
          "format-document",
          "format-source-native-export"
        ],
        "id": "dun-and-bradstreet",
        "licenseId": "apache-2.0",
        "name": "Dun & Bradstreet",
        "recipeIds": [
          "risk-and-reference-evidence-feed",
          "master-reference-sync"
        ],
        "systemRoleIds": [
          "identity-authority",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-risk-evidence-feed",
          "channel-master-reference-sync"
        ],
        "designQuestion": "Preserve LEI namespace, verification time and relationship data without replacing the canonical party ID.",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk",
          "contract-lifecycle-management",
          "invoice-exception-payment-readiness"
        ],
        "familyId": "supplier-risk-identity-and-people",
        "formatIds": [
          "format-json",
          "format-xml",
          "format-csv",
          "format-document",
          "format-source-native-export",
          "format-lei-17442"
        ],
        "id": "gleif",
        "licenseId": "apache-2.0",
        "name": "Global Legal Entity Identifier Foundation data",
        "recipeIds": [
          "risk-and-reference-evidence-feed",
          "master-reference-sync"
        ],
        "systemRoleIds": [
          "identity-authority",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-risk-evidence-feed",
          "channel-master-reference-sync"
        ],
        "designQuestion": "Pin jurisdiction, legal basis, identifier scheme, permitted use, coverage and freshness. Treat US EIN as a tax identifier, not an electronic address.",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk",
          "contract-lifecycle-management",
          "invoice-exception-payment-readiness"
        ],
        "familyId": "supplier-risk-identity-and-people",
        "formatIds": [
          "format-json",
          "format-xml",
          "format-csv",
          "format-document",
          "format-source-native-export",
          "format-us-irs-ein"
        ],
        "id": "tax-and-company-registries",
        "licenseId": "apache-2.0",
        "name": "Tax, company and beneficial-ownership registries",
        "recipeIds": [
          "risk-and-reference-evidence-feed",
          "master-reference-sync"
        ],
        "systemRoleIds": [
          "identity-authority",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-oauth",
          "channel-oidc",
          "channel-scim",
          "channel-microsoft-graph"
        ],
        "designQuestion": "Pin tenant, conditional access, groups, app registrations, selected permissions, workload identities, credential rotation and revocation latency.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "familyId": "supplier-risk-identity-and-people",
        "formatIds": [
          "format-drive-item",
          "format-list-item",
          "format-docx",
          "format-xlsx",
          "format-pdf",
          "format-structured-list",
          "format-csv",
          "format-json",
          "format-xml",
          "format-source-native-export"
        ],
        "id": "microsoft-entra-id",
        "licenseId": "apache-2.0",
        "name": "Microsoft Entra ID",
        "recipeIds": [
          "sharepoint-content-binding",
          "master-reference-sync"
        ],
        "systemRoleIds": [
          "identity-authority"
        ]
      },
      {
        "channelIds": [
          "channel-oauth",
          "channel-oidc",
          "channel-saml",
          "channel-scim"
        ],
        "designQuestion": "Pin organisation, identity source, groups, app assignments, token claims and deprovisioning.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "familyId": "supplier-risk-identity-and-people",
        "formatIds": [
          "format-csv",
          "format-json",
          "format-xml",
          "format-source-native-export"
        ],
        "id": "okta",
        "licenseId": "apache-2.0",
        "name": "Okta",
        "recipeIds": [
          "master-reference-sync"
        ],
        "systemRoleIds": [
          "identity-authority"
        ]
      },
      {
        "channelIds": [
          "channel-workday-report",
          "channel-workday-eib",
          "channel-scim",
          "channel-sftp",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin worker population, contingent workers, organisational hierarchy, effective dates and identity provisioning boundary.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness"
        ],
        "familyId": "supplier-risk-identity-and-people",
        "formatIds": [
          "format-csv",
          "format-json",
          "format-xml",
          "format-source-native-export",
          "format-parquet"
        ],
        "id": "workday-hcm",
        "licenseId": "apache-2.0",
        "name": "Workday Human Capital Management",
        "recipeIds": [
          "master-reference-sync",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "identity-authority"
        ]
      },
      {
        "channelIds": [
          "channel-sap-document-exchange",
          "channel-odata",
          "channel-csv",
          "channel-sftp"
        ],
        "designQuestion": "Pin modules, employee and contingent populations, effective-dated records, permissions and identity handoff.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness"
        ],
        "familyId": "supplier-risk-identity-and-people",
        "formatIds": [
          "format-drive-item",
          "format-list-item",
          "format-docx",
          "format-xlsx",
          "format-pdf",
          "format-structured-list",
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-csv",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "sap-successfactors",
        "licenseId": "apache-2.0",
        "name": "SAP SuccessFactors",
        "recipeIds": [
          "sharepoint-content-binding",
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "identity-authority"
        ]
      },
      {
        "channelIds": [
          "channel-webhook",
          "channel-csv",
          "channel-narrow-api",
          "channel-client-ipaas"
        ],
        "designQuestion": "Pin intake and orchestration scope, downstream ownership, approval authority and integration evidence.",
        "domainWorkblockIds": [
          "intake-demand",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving"
        ],
        "familyId": "intake-sourcing-and-specialists",
        "formatIds": [
          "format-message",
          "format-attachment",
          "format-adaptive-card",
          "format-email",
          "format-file-link",
          "format-csv",
          "format-json",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "zip",
        "licenseId": "apache-2.0",
        "name": "Zip",
        "recipeIds": [
          "collaboration-intake",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "collaboration-channel"
        ]
      },
      {
        "channelIds": [
          "channel-webhook",
          "channel-csv",
          "channel-narrow-api",
          "channel-client-ipaas"
        ],
        "designQuestion": "Pin configured workflows, source ownership and downstream handoff.",
        "domainWorkblockIds": [
          "intake-demand",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving"
        ],
        "familyId": "intake-sourcing-and-specialists",
        "formatIds": [
          "format-message",
          "format-attachment",
          "format-adaptive-card",
          "format-email",
          "format-file-link",
          "format-csv",
          "format-json",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "oro-labs",
        "licenseId": "apache-2.0",
        "name": "ORO Labs",
        "recipeIds": [
          "collaboration-intake",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "collaboration-channel"
        ]
      },
      {
        "channelIds": [
          "channel-webhook",
          "channel-csv",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin modules, request ownership, embedded content and destination commitments.",
        "domainWorkblockIds": [
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk"
        ],
        "familyId": "intake-sourcing-and-specialists",
        "formatIds": [
          "format-message",
          "format-attachment",
          "format-adaptive-card",
          "format-email",
          "format-file-link",
          "format-csv",
          "format-json",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "levelpath",
        "licenseId": "apache-2.0",
        "name": "Levelpath",
        "recipeIds": [
          "collaboration-intake",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "collaboration-channel"
        ]
      },
      {
        "channelIds": [
          "channel-webhook",
          "channel-event",
          "channel-csv",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin applications and tables, procurement semantics, business rules, approval authority and source integrations.",
        "domainWorkblockIds": [
          "intake-demand",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness"
        ],
        "familyId": "intake-sourcing-and-specialists",
        "formatIds": [
          "format-message",
          "format-attachment",
          "format-adaptive-card",
          "format-email",
          "format-file-link",
          "format-csv",
          "format-json",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "servicenow",
        "licenseId": "apache-2.0",
        "name": "ServiceNow",
        "recipeIds": [
          "collaboration-intake",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "collaboration-channel"
        ]
      },
      {
        "channelIds": [
          "channel-dataverse",
          "channel-power-automate-connector",
          "channel-microsoft-graph",
          "channel-webhook"
        ],
        "designQuestion": "Pin environments, solutions, Dataverse tables, data-loss-prevention policy, connection references, owners and ALM.",
        "domainWorkblockIds": [
          "intake-demand",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness"
        ],
        "familyId": "intake-sourcing-and-specialists",
        "formatIds": [
          "format-drive-item",
          "format-list-item",
          "format-docx",
          "format-xlsx",
          "format-pdf",
          "format-structured-list",
          "format-message",
          "format-attachment",
          "format-adaptive-card",
          "format-email",
          "format-file-link"
        ],
        "id": "microsoft-power-platform",
        "licenseId": "apache-2.0",
        "name": "Microsoft Power Platform",
        "recipeIds": [
          "sharepoint-content-binding",
          "collaboration-intake"
        ],
        "systemRoleIds": [
          "execution-system",
          "collaboration-channel",
          "system-of-record"
        ]
      },
      {
        "channelIds": [
          "channel-csv",
          "channel-sftp",
          "channel-event",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin sourcing scope, supplier network, event ownership and award handoff.",
        "domainWorkblockIds": [
          "sourcing-negotiation",
          "value-realization-savings"
        ],
        "familyId": "intake-sourcing-and-specialists",
        "formatIds": [
          "format-csv",
          "format-json",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "fairmarkit",
        "licenseId": "apache-2.0",
        "name": "Fairmarkit",
        "recipeIds": [
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-csv",
          "channel-workbook",
          "channel-sftp",
          "channel-narrow-api",
          "channel-authorised-tool"
        ],
        "designQuestion": "Pin installed products, optimisation model, supplier interaction, authority and output evidence.",
        "domainWorkblockIds": [
          "sourcing-negotiation",
          "value-realization-savings"
        ],
        "familyId": "intake-sourcing-and-specialists",
        "formatIds": [
          "format-mcp-json-rpc",
          "format-csv",
          "format-json",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "keelvar",
        "licenseId": "apache-2.0",
        "name": "Keelvar",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "execution-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-csv",
          "channel-sftp",
          "channel-narrow-api",
          "channel-authorised-tool"
        ],
        "designQuestion": "Pin data sources, offer and recommendation authority, supplier interaction and downstream award.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "sourcing-negotiation",
          "value-realization-savings"
        ],
        "familyId": "intake-sourcing-and-specialists",
        "formatIds": [
          "format-mcp-json-rpc",
          "format-csv",
          "format-json",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "arkestro",
        "licenseId": "apache-2.0",
        "name": "Arkestro",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "execution-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-csv",
          "channel-document",
          "channel-narrow-api",
          "channel-authorised-tool"
        ],
        "designQuestion": "Pin negotiated population, policy and authority, supplier identity, agreement status and contract handoff.",
        "domainWorkblockIds": [
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "value-realization-savings"
        ],
        "familyId": "intake-sourcing-and-specialists",
        "formatIds": [
          "format-mcp-json-rpc",
          "format-drive-item",
          "format-list-item",
          "format-docx",
          "format-xlsx",
          "format-pdf",
          "format-structured-list",
          "format-csv",
          "format-json",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "pactum",
        "licenseId": "apache-2.0",
        "name": "Pactum",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "sharepoint-content-binding",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "execution-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-csv",
          "channel-webhook",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin supplier or public participation, confidentiality, intellectual-property terms, stage authority and value handoff.",
        "domainWorkblockIds": [
          "supplier-performance-innovation-relationship"
        ],
        "familyId": "intake-sourcing-and-specialists",
        "formatIds": [
          "format-message",
          "format-attachment",
          "format-adaptive-card",
          "format-email",
          "format-file-link",
          "format-csv",
          "format-json",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "wazoku",
        "licenseId": "apache-2.0",
        "name": "Wazoku",
        "recipeIds": [
          "collaboration-intake",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "collaboration-channel"
        ]
      },
      {
        "channelIds": [
          "channel-external-analytics-exchange",
          "channel-table",
          "channel-parquet",
          "channel-event"
        ],
        "designQuestion": "Pin databases, schemas, shares, lineage, definitions, row access, freshness and return-output ownership.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "familyId": "analytics-planning-and-master-data",
        "formatIds": [
          "format-parquet",
          "format-csv",
          "format-json",
          "format-table",
          "format-semantic-model",
          "format-xml",
          "format-source-native-export"
        ],
        "id": "snowflake",
        "licenseId": "apache-2.0",
        "name": "Snowflake",
        "recipeIds": [
          "external-analytics-exchange",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "analytical-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-external-analytics-exchange",
          "channel-delta-table",
          "channel-parquet",
          "channel-event"
        ],
        "designQuestion": "Pin catalogue, schemas, jobs, models, lineage, access policy and output versioning.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "supplier-lifecycle-third-party-risk",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "familyId": "analytics-planning-and-master-data",
        "formatIds": [
          "format-parquet",
          "format-csv",
          "format-json",
          "format-table",
          "format-semantic-model",
          "format-xml",
          "format-source-native-export"
        ],
        "id": "databricks",
        "licenseId": "apache-2.0",
        "name": "Databricks",
        "recipeIds": [
          "external-analytics-exchange",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "analytical-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-external-analytics-exchange",
          "channel-onelake",
          "channel-parquet",
          "channel-table",
          "channel-event"
        ],
        "designQuestion": "Pin workspaces, items, OneLake shortcuts, sensitivity, tenant and region, refresh and semantic definitions.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "familyId": "analytics-planning-and-master-data",
        "formatIds": [
          "format-parquet",
          "format-csv",
          "format-json",
          "format-table",
          "format-semantic-model",
          "format-xml",
          "format-source-native-export"
        ],
        "id": "microsoft-fabric-synapse-adls",
        "licenseId": "apache-2.0",
        "name": "Microsoft Fabric, Synapse Analytics and Azure Data Lake Storage",
        "recipeIds": [
          "external-analytics-exchange",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "analytical-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-external-analytics-exchange",
          "channel-table",
          "channel-parquet",
          "channel-object-storage"
        ],
        "designQuestion": "Pin projects, datasets, access policy, regions, lineage, freshness and outputs.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "supplier-lifecycle-third-party-risk",
          "invoice-exception-payment-readiness",
          "value-realization-savings"
        ],
        "familyId": "analytics-planning-and-master-data",
        "formatIds": [
          "format-parquet",
          "format-csv",
          "format-json",
          "format-table",
          "format-semantic-model"
        ],
        "id": "google-bigquery",
        "licenseId": "apache-2.0",
        "name": "Google BigQuery",
        "recipeIds": [
          "external-analytics-exchange"
        ],
        "systemRoleIds": [
          "analytical-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-external-analytics-exchange",
          "channel-table",
          "channel-parquet",
          "channel-object-storage"
        ],
        "designQuestion": "Pin clusters or serverless workgroups, schemas, access, region, lineage and refresh.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "supplier-lifecycle-third-party-risk",
          "invoice-exception-payment-readiness",
          "value-realization-savings"
        ],
        "familyId": "analytics-planning-and-master-data",
        "formatIds": [
          "format-parquet",
          "format-csv",
          "format-json",
          "format-table",
          "format-semantic-model"
        ],
        "id": "amazon-redshift",
        "licenseId": "apache-2.0",
        "name": "Amazon Redshift",
        "recipeIds": [
          "external-analytics-exchange"
        ],
        "systemRoleIds": [
          "analytical-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-semantic-model",
          "channel-external-analytics-exchange"
        ],
        "designQuestion": "Pin workspaces, semantic models, metric definitions, refresh, row-level security, alerts and action handoff.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "familyId": "analytics-planning-and-master-data",
        "formatIds": [
          "format-parquet",
          "format-csv",
          "format-json",
          "format-table",
          "format-semantic-model"
        ],
        "id": "power-bi",
        "licenseId": "apache-2.0",
        "name": "Microsoft Power BI",
        "recipeIds": [
          "external-analytics-exchange"
        ],
        "systemRoleIds": [
          "analytical-system",
          "collaboration-channel"
        ]
      },
      {
        "channelIds": [
          "channel-external-analytics-exchange",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin sites, data sources, calculations, permissions, refresh and action handoff.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "supplier-lifecycle-third-party-risk",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "familyId": "analytics-planning-and-master-data",
        "formatIds": [
          "format-parquet",
          "format-csv",
          "format-json",
          "format-table",
          "format-semantic-model"
        ],
        "id": "tableau",
        "licenseId": "apache-2.0",
        "name": "Tableau",
        "recipeIds": [
          "external-analytics-exchange"
        ],
        "systemRoleIds": [
          "analytical-system",
          "collaboration-channel"
        ]
      },
      {
        "channelIds": [
          "channel-external-analytics-exchange",
          "channel-file",
          "channel-event"
        ],
        "designQuestion": "Pin products, applications, data models, calculations, reloads and action handoff.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "familyId": "analytics-planning-and-master-data",
        "formatIds": [
          "format-parquet",
          "format-csv",
          "format-json",
          "format-table",
          "format-semantic-model",
          "format-xml",
          "format-source-native-export"
        ],
        "id": "qlik",
        "licenseId": "apache-2.0",
        "name": "Qlik",
        "recipeIds": [
          "external-analytics-exchange",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "analytical-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-external-analytics-exchange",
          "channel-csv",
          "channel-sftp",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin models, lists, modules, versions, approved scenarios, export and import actions.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "familyId": "analytics-planning-and-master-data",
        "formatIds": [
          "format-parquet",
          "format-csv",
          "format-json",
          "format-table",
          "format-semantic-model",
          "format-xml",
          "format-source-native-export"
        ],
        "id": "anaplan",
        "licenseId": "apache-2.0",
        "name": "Anaplan",
        "recipeIds": [
          "external-analytics-exchange",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "planning-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-external-analytics-exchange",
          "channel-csv",
          "channel-sftp",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin planning areas, key figures, versions and approved scenarios, master-data types, unit-of-measure and calendar contracts, extraction schedule, and the one authorised import path for procurement-committed quantities.",
        "domainWorkblockIds": [
          "intake-demand",
          "strategy-policy-category-spend",
          "sourcing-negotiation",
          "value-realization-savings"
        ],
        "familyId": "analytics-planning-and-master-data",
        "formatIds": [
          "format-parquet",
          "format-csv",
          "format-json",
          "format-table",
          "format-xml",
          "format-source-native-export"
        ],
        "id": "sap-ibp",
        "licenseId": "apache-2.0",
        "name": "SAP Integrated Business Planning",
        "recipeIds": [
          "external-analytics-exchange",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "planning-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-external-analytics-exchange",
          "channel-csv",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin models, dimensions, scenarios, access, export and import contracts.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "familyId": "analytics-planning-and-master-data",
        "formatIds": [
          "format-parquet",
          "format-csv",
          "format-json",
          "format-table",
          "format-semantic-model",
          "format-xml",
          "format-source-native-export"
        ],
        "id": "pigment",
        "licenseId": "apache-2.0",
        "name": "Pigment",
        "recipeIds": [
          "external-analytics-exchange",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "planning-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-external-analytics-exchange",
          "channel-csv",
          "channel-sftp",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin modules, taxonomy and supplier normalisation, metric definitions, source lineage and workflow ownership.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "familyId": "analytics-planning-and-master-data",
        "formatIds": [
          "format-parquet",
          "format-csv",
          "format-json",
          "format-table",
          "format-semantic-model",
          "format-xml",
          "format-source-native-export"
        ],
        "id": "sievo",
        "licenseId": "apache-2.0",
        "name": "Sievo",
        "recipeIds": [
          "external-analytics-exchange",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "analytical-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-external-analytics-exchange",
          "channel-csv",
          "channel-sftp",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin the model inventory, price outlooks, demand models and risk scores alike, and for each model its owner, method class, input lineage, output schema and units, confidence measure, refresh cadence and revision policy, plus the one governed exchange path through which outputs enter procurement records as signals with source, method, confidence and freshness preserved.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand"
        ],
        "familyId": "analytics-planning-and-master-data",
        "formatIds": [
          "format-parquet",
          "format-csv",
          "format-json",
          "format-table",
          "format-semantic-model",
          "format-source-native-export"
        ],
        "id": "client-prediction-models",
        "licenseId": "apache-2.0",
        "name": "Client-built prediction and forecasting models",
        "recipeIds": [
          "external-analytics-exchange"
        ],
        "systemRoleIds": [
          "analytical-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-external-analytics-exchange",
          "channel-csv",
          "channel-sftp",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin modules, taxonomy, opportunity and savings ownership, lineage and export.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "value-realization-savings"
        ],
        "familyId": "analytics-planning-and-master-data",
        "formatIds": [
          "format-parquet",
          "format-csv",
          "format-json",
          "format-table",
          "format-semantic-model",
          "format-xml",
          "format-source-native-export"
        ],
        "id": "spendhq",
        "licenseId": "apache-2.0",
        "name": "SpendHQ",
        "recipeIds": [
          "external-analytics-exchange",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "analytical-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-master-reference-sync",
          "channel-client-ipaas",
          "channel-event",
          "channel-file"
        ],
        "designQuestion": "Separate MDM authority from integration execution. Pin domains, match and merge, survivorship, stewardship and distribution.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness"
        ],
        "familyId": "analytics-planning-and-master-data",
        "formatIds": [
          "format-csv",
          "format-json",
          "format-xml",
          "format-source-native-export",
          "format-parquet"
        ],
        "id": "informatica",
        "licenseId": "apache-2.0",
        "name": "Informatica",
        "recipeIds": [
          "master-reference-sync",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "identity-authority",
          "transport-execution-boundary"
        ]
      },
      {
        "channelIds": [
          "channel-master-reference-sync",
          "channel-event",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin tenant, entity model, match and merge, survivorship, crosswalks and event delivery.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "supplier-lifecycle-third-party-risk"
        ],
        "familyId": "analytics-planning-and-master-data",
        "formatIds": [
          "format-csv",
          "format-json",
          "format-xml",
          "format-source-native-export",
          "format-parquet"
        ],
        "id": "reltio",
        "licenseId": "apache-2.0",
        "name": "Reltio",
        "recipeIds": [
          "master-reference-sync",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "identity-authority"
        ]
      },
      {
        "channelIds": [
          "channel-master-reference-sync",
          "channel-event",
          "channel-file",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin data locations, models, certification, match and merge, survivorship and distribution.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "supplier-lifecycle-third-party-risk"
        ],
        "familyId": "analytics-planning-and-master-data",
        "formatIds": [
          "format-csv",
          "format-json",
          "format-xml",
          "format-source-native-export",
          "format-parquet"
        ],
        "id": "semarchy",
        "licenseId": "apache-2.0",
        "name": "Semarchy",
        "recipeIds": [
          "master-reference-sync",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "identity-authority"
        ]
      },
      {
        "channelIds": [
          "channel-edi",
          "channel-business-document",
          "channel-event",
          "channel-csv",
          "channel-sftp",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin locations, item identifiers, order references, event time, quantity and receipt authority.",
        "domainWorkblockIds": [
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship"
        ],
        "familyId": "adjacent-operational-sources",
        "formatIds": [
          "format-drive-item",
          "format-list-item",
          "format-docx",
          "format-xlsx",
          "format-pdf",
          "format-structured-list",
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-csv",
          "format-xml",
          "format-parquet",
          "format-source-native-export",
          "format-gs1-gln",
          "format-gs1-gtin"
        ],
        "id": "warehouse-and-inventory-management",
        "licenseId": "apache-2.0",
        "name": "Warehouse and inventory management systems",
        "recipeIds": [
          "sharepoint-content-binding",
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-event",
          "channel-csv",
          "channel-sftp",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin supplier and item identity, severity, disposition, corrective-action owner and freshness.",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "familyId": "adjacent-operational-sources",
        "formatIds": [
          "format-csv",
          "format-json",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "quality-and-manufacturing",
        "licenseId": "apache-2.0",
        "name": "Quality and manufacturing systems",
        "recipeIds": [
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-event",
          "channel-csv",
          "channel-sftp",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin work-order and service-entry linkage, acceptance authority and contract evidence.",
        "domainWorkblockIds": [
          "contract-lifecycle-management",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship"
        ],
        "familyId": "adjacent-operational-sources",
        "formatIds": [
          "format-csv",
          "format-json",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "enterprise-asset-and-field-service",
        "licenseId": "apache-2.0",
        "name": "Enterprise asset management and field-service systems",
        "recipeIds": [
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-source-snapshot-delta-ingest",
          "channel-csv",
          "channel-sftp",
          "channel-narrow-api"
        ],
        "designQuestion": "Pin source transactions, employee and merchant identity, policy status, personal data and accounting reconciliation.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "value-realization-savings"
        ],
        "familyId": "adjacent-operational-sources",
        "formatIds": [
          "format-csv",
          "format-json",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "travel-expense-and-card",
        "licenseId": "apache-2.0",
        "name": "Travel, expense and commercial-card systems",
        "recipeIds": [
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "system-of-record",
          "execution-system",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-risk-evidence-feed",
          "channel-external-analytics-exchange"
        ],
        "designQuestion": "Pin provider, licence, coverage, methodology, timestamp, units, revision policy and permitted derived use.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "sourcing-negotiation",
          "supplier-performance-innovation-relationship",
          "value-realization-savings",
          "intake-demand"
        ],
        "familyId": "adjacent-operational-sources",
        "formatIds": [
          "format-parquet",
          "format-csv",
          "format-json",
          "format-table",
          "format-semantic-model",
          "format-xml",
          "format-document"
        ],
        "id": "market-price-and-commodity-data",
        "licenseId": "apache-2.0",
        "name": "Market, price, commodity and supply intelligence services",
        "recipeIds": [
          "external-analytics-exchange",
          "risk-and-reference-evidence-feed"
        ],
        "systemRoleIds": [
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-client-ipaas"
        ],
        "designQuestion": "Pin APIs and flows, source control, runtime, credential vault, retries, dead letters, observability and deployment ownership.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "familyId": "integration-transport-and-channels",
        "formatIds": [
          "format-csv",
          "format-json",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "mulesoft",
        "licenseId": "apache-2.0",
        "name": "MuleSoft",
        "recipeIds": [
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "transport-execution-boundary"
        ]
      },
      {
        "channelIds": [
          "channel-client-ipaas"
        ],
        "designQuestion": "Pin processes, atoms, environments, credentials, retries, queues, logs and release ownership.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "familyId": "integration-transport-and-channels",
        "formatIds": [
          "format-csv",
          "format-json",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "boomi",
        "licenseId": "apache-2.0",
        "name": "Boomi",
        "recipeIds": [
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "transport-execution-boundary"
        ]
      },
      {
        "channelIds": [
          "channel-client-ipaas"
        ],
        "designQuestion": "Pin subscriptions, resource groups, workflows, managed identities, connectors, integration accounts, run retention and deployment ownership.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "familyId": "integration-transport-and-channels",
        "formatIds": [
          "format-csv",
          "format-json",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "azure-logic-apps",
        "licenseId": "apache-2.0",
        "name": "Azure Logic Apps",
        "recipeIds": [
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "transport-execution-boundary"
        ]
      },
      {
        "channelIds": [
          "channel-client-ipaas",
          "channel-sap-document-exchange"
        ],
        "designQuestion": "Pin tenant, integration flows, trading-partner management, mappings, credentials, queues, monitoring and deployment ownership.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "familyId": "integration-transport-and-channels",
        "formatIds": [
          "format-drive-item",
          "format-list-item",
          "format-docx",
          "format-xlsx",
          "format-pdf",
          "format-structured-list",
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-csv",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "sap-integration-suite",
        "licenseId": "apache-2.0",
        "name": "SAP Integration Suite",
        "recipeIds": [
          "sharepoint-content-binding",
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "transport-execution-boundary"
        ]
      },
      {
        "channelIds": [
          "channel-edi",
          "channel-as2",
          "channel-sftp"
        ],
        "designQuestion": "Pin provider, partner agreements, transaction sets, implementation guides, envelopes, acknowledgements, retention and replay.",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness"
        ],
        "familyId": "integration-transport-and-channels",
        "formatIds": [
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022",
          "format-csv",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "edi-van",
        "licenseId": "apache-2.0",
        "name": "EDI value-added network",
        "recipeIds": [
          "structured-business-document-ingest",
          "structured-business-document-outbound",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "managed-network",
          "transport-execution-boundary",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-sftp"
        ],
        "designQuestion": "Pin host, folders, keys, cipher policy, naming, ready markers, atomic move, retention, duplicates and replay.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "familyId": "integration-transport-and-channels",
        "formatIds": [
          "format-csv",
          "format-json",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "sftp-service",
        "licenseId": "apache-2.0",
        "name": "SFTP service",
        "recipeIds": [
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "transport-execution-boundary"
        ]
      },
      {
        "channelIds": [
          "channel-as2",
          "channel-edi",
          "channel-xml"
        ],
        "designQuestion": "Pin partner, AS2 IDs, certificates, signing, encryption, message-disposition notification, retries and non-repudiation retention.",
        "domainWorkblockIds": [
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness"
        ],
        "familyId": "integration-transport-and-channels",
        "formatIds": [
          "format-ubl-2-4",
          "format-peppol-profile",
          "format-cxml",
          "format-edi",
          "format-idoc",
          "format-vendor-xml",
          "format-json",
          "format-iso-20022"
        ],
        "id": "as2-service",
        "licenseId": "apache-2.0",
        "name": "AS2 service",
        "recipeIds": [
          "structured-business-document-ingest",
          "structured-business-document-outbound"
        ],
        "systemRoleIds": [
          "transport-execution-boundary",
          "evidence-source"
        ]
      },
      {
        "channelIds": [
          "channel-email-gateway",
          "channel-microsoft-graph"
        ],
        "designQuestion": "Define authorised mailboxes, senders, attachment limits, malware and data-loss prevention, acknowledgement, duplicate threads and retention.",
        "domainWorkblockIds": [
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship"
        ],
        "familyId": "integration-transport-and-channels",
        "formatIds": [
          "format-drive-item",
          "format-list-item",
          "format-docx",
          "format-xlsx",
          "format-pdf",
          "format-structured-list",
          "format-message",
          "format-attachment",
          "format-adaptive-card",
          "format-email",
          "format-file-link"
        ],
        "id": "email-channel",
        "licenseId": "apache-2.0",
        "name": "Email",
        "recipeIds": [
          "sharepoint-content-binding",
          "collaboration-intake"
        ],
        "systemRoleIds": [
          "collaboration-channel",
          "evidence-source",
          "transport-execution-boundary"
        ]
      },
      {
        "channelIds": [
          "channel-event-stream"
        ],
        "designQuestion": "Pin broker, topics, schemas, partitions, ordering, at-least-once semantics, retention, replay, dead letters and tenancy.",
        "domainWorkblockIds": [
          "strategy-policy-category-spend",
          "intake-demand",
          "sourcing-negotiation",
          "contract-lifecycle-management",
          "supplier-lifecycle-third-party-risk",
          "buying-ordering-receiving",
          "invoice-exception-payment-readiness",
          "supplier-performance-innovation-relationship",
          "value-realization-savings"
        ],
        "familyId": "integration-transport-and-channels",
        "formatIds": [
          "format-csv",
          "format-json",
          "format-xml",
          "format-parquet",
          "format-source-native-export"
        ],
        "id": "event-stream-and-message-broker",
        "licenseId": "apache-2.0",
        "name": "Event stream and message broker",
        "recipeIds": [
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "transport-execution-boundary"
        ]
      },
      {
        "channelIds": [
          "channel-cxml",
          "channel-narrow-api",
          "channel-csv"
        ],
        "designQuestion": "Pin the punchout level and punch-in endpoint ownership, the order transmission path, the invoice document feed, category and merchant restrictions, and the reporting export used as spend evidence.",
        "domainWorkblockIds": [
          "buying-ordering-receiving",
          "intake-demand",
          "strategy-policy-category-spend"
        ],
        "familyId": "procurement-suites-and-networks",
        "formatIds": [
          "format-cxml-punchout",
          "format-cxml",
          "format-csv",
          "format-json"
        ],
        "id": "amazon-business",
        "licenseId": "apache-2.0",
        "name": "Amazon Business",
        "recipeIds": [
          "structured-business-document-ingest",
          "source-snapshot-delta-ingest"
        ],
        "systemRoleIds": [
          "managed-network",
          "execution-system",
          "evidence-source"
        ]
      }
    ],
    "systemRoles": [
      {
        "id": "source-of-record",
        "label": "Source of record",
        "licenseId": "apache-2.0"
      },
      {
        "id": "system-of-record",
        "label": "System of record",
        "licenseId": "apache-2.0"
      },
      {
        "id": "execution-system",
        "label": "Execution system",
        "licenseId": "apache-2.0"
      },
      {
        "id": "commitment-system",
        "label": "Commitment system",
        "licenseId": "apache-2.0"
      },
      {
        "id": "evidence-source",
        "label": "Evidence source",
        "licenseId": "apache-2.0"
      },
      {
        "id": "analytical-system",
        "label": "Analytical system",
        "licenseId": "apache-2.0"
      },
      {
        "id": "planning-system",
        "label": "Planning system",
        "licenseId": "apache-2.0"
      },
      {
        "id": "collaboration-channel",
        "label": "Collaboration channel",
        "licenseId": "apache-2.0"
      },
      {
        "id": "identity-authority",
        "label": "Identity authority",
        "licenseId": "apache-2.0"
      },
      {
        "id": "managed-network",
        "label": "Managed network",
        "licenseId": "apache-2.0"
      },
      {
        "id": "payment-or-settlement-rail",
        "label": "Payment or settlement rail",
        "licenseId": "apache-2.0"
      },
      {
        "id": "transport-execution-boundary",
        "label": "Transport execution boundary",
        "licenseId": "apache-2.0"
      },
      {
        "id": "candidate-for-selective-replacement",
        "label": "Candidate for selective replacement",
        "licenseId": "apache-2.0"
      },
      {
        "id": "erp",
        "label": "ERP",
        "licenseId": "apache-2.0"
      },
      {
        "id": "ap-platform",
        "label": "AP platform",
        "licenseId": "apache-2.0"
      },
      {
        "id": "expense-platform",
        "label": "Expense platform",
        "licenseId": "apache-2.0"
      },
      {
        "id": "data-warehouse",
        "label": "Data warehouse",
        "licenseId": "apache-2.0"
      },
      {
        "id": "spend-analytics",
        "label": "Spend analytics",
        "licenseId": "apache-2.0"
      },
      {
        "id": "mdm",
        "label": "MDM",
        "licenseId": "apache-2.0"
      },
      {
        "id": "warehouse",
        "label": "Warehouse",
        "licenseId": "apache-2.0"
      },
      {
        "id": "category-suite",
        "label": "Category suite",
        "licenseId": "apache-2.0"
      },
      {
        "id": "market-intelligence",
        "label": "Market intelligence",
        "licenseId": "apache-2.0"
      },
      {
        "id": "risk-platform",
        "label": "Risk platform",
        "licenseId": "apache-2.0"
      },
      {
        "id": "planning",
        "label": "Planning",
        "licenseId": "apache-2.0"
      },
      {
        "id": "sharepoint",
        "label": "SharePoint",
        "licenseId": "apache-2.0"
      },
      {
        "id": "office-documents",
        "label": "Office documents",
        "licenseId": "apache-2.0"
      },
      {
        "id": "policy-repository",
        "label": "Policy repository",
        "licenseId": "apache-2.0"
      },
      {
        "id": "grc",
        "label": "GRC",
        "licenseId": "apache-2.0"
      },
      {
        "id": "document-management",
        "label": "Document management",
        "licenseId": "apache-2.0"
      },
      {
        "id": "intranet",
        "label": "Intranet",
        "licenseId": "apache-2.0"
      },
      {
        "id": "service-management",
        "label": "Service management",
        "licenseId": "apache-2.0"
      },
      {
        "id": "service-catalogue",
        "label": "Service catalogue",
        "licenseId": "apache-2.0"
      },
      {
        "id": "procurement-suite",
        "label": "Procurement suite",
        "licenseId": "apache-2.0"
      },
      {
        "id": "intake-orchestration",
        "label": "Intake orchestration",
        "licenseId": "apache-2.0"
      },
      {
        "id": "teams",
        "label": "Teams",
        "licenseId": "apache-2.0"
      },
      {
        "id": "exchange",
        "label": "Exchange",
        "licenseId": "apache-2.0"
      },
      {
        "id": "identity",
        "label": "Identity",
        "licenseId": "apache-2.0"
      },
      {
        "id": "supplier-master",
        "label": "Supplier master",
        "licenseId": "apache-2.0"
      },
      {
        "id": "budget-system",
        "label": "Budget system",
        "licenseId": "apache-2.0"
      },
      {
        "id": "workflow-platform",
        "label": "Workflow platform",
        "licenseId": "apache-2.0"
      },
      {
        "id": "collaboration",
        "label": "Collaboration",
        "licenseId": "apache-2.0"
      },
      {
        "id": "sourcing-suite",
        "label": "Sourcing suite",
        "licenseId": "apache-2.0"
      },
      {
        "id": "clm",
        "label": "CLM",
        "licenseId": "apache-2.0"
      },
      {
        "id": "supplier-network",
        "label": "Supplier network",
        "licenseId": "apache-2.0"
      },
      {
        "id": "erp-master",
        "label": "ERP master",
        "licenseId": "apache-2.0"
      },
      {
        "id": "optimisation-specialist",
        "label": "Optimisation specialist",
        "licenseId": "apache-2.0"
      },
      {
        "id": "spreadsheet",
        "label": "Spreadsheet",
        "licenseId": "apache-2.0"
      },
      {
        "id": "negotiation-specialist",
        "label": "Negotiation specialist",
        "licenseId": "apache-2.0"
      },
      {
        "id": "procurement-policy",
        "label": "Procurement policy",
        "licenseId": "apache-2.0"
      },
      {
        "id": "email",
        "label": "Email",
        "licenseId": "apache-2.0"
      },
      {
        "id": "document-repository",
        "label": "Document repository",
        "licenseId": "apache-2.0"
      },
      {
        "id": "signature",
        "label": "Signature",
        "licenseId": "apache-2.0"
      },
      {
        "id": "word",
        "label": "Word",
        "licenseId": "apache-2.0"
      },
      {
        "id": "performance-system",
        "label": "Performance system",
        "licenseId": "apache-2.0"
      },
      {
        "id": "usage-analytics",
        "label": "Usage analytics",
        "licenseId": "apache-2.0"
      },
      {
        "id": "supplier-portal",
        "label": "Supplier portal",
        "licenseId": "apache-2.0"
      },
      {
        "id": "tax-registry",
        "label": "Tax registry",
        "licenseId": "apache-2.0"
      },
      {
        "id": "identity-provider",
        "label": "Identity provider",
        "licenseId": "apache-2.0"
      },
      {
        "id": "erp-supplier-master",
        "label": "ERP supplier master",
        "licenseId": "apache-2.0"
      },
      {
        "id": "bank-validation",
        "label": "Bank validation",
        "licenseId": "apache-2.0"
      },
      {
        "id": "evidence-network",
        "label": "Evidence network",
        "licenseId": "apache-2.0"
      },
      {
        "id": "risk-monitoring",
        "label": "Risk monitoring",
        "licenseId": "apache-2.0"
      },
      {
        "id": "news-and-market-data",
        "label": "News and market data",
        "licenseId": "apache-2.0"
      },
      {
        "id": "cyber-risk",
        "label": "Cyber risk",
        "licenseId": "apache-2.0"
      },
      {
        "id": "sustainability",
        "label": "Sustainability",
        "licenseId": "apache-2.0"
      },
      {
        "id": "business-continuity",
        "label": "Business continuity",
        "licenseId": "apache-2.0"
      },
      {
        "id": "catalogue",
        "label": "Catalogue",
        "licenseId": "apache-2.0"
      },
      {
        "id": "edi-van",
        "label": "EDI VAN",
        "licenseId": "apache-2.0"
      },
      {
        "id": "peppol-access-point",
        "label": "Peppol access point",
        "licenseId": "apache-2.0"
      },
      {
        "id": "receiving-system",
        "label": "Receiving system",
        "licenseId": "apache-2.0"
      },
      {
        "id": "warehouse-management",
        "label": "Warehouse management",
        "licenseId": "apache-2.0"
      },
      {
        "id": "field-service",
        "label": "Field service",
        "licenseId": "apache-2.0"
      },
      {
        "id": "erp-ap",
        "label": "ERP AP",
        "licenseId": "apache-2.0"
      },
      {
        "id": "invoice-network",
        "label": "Invoice network",
        "licenseId": "apache-2.0"
      },
      {
        "id": "ap-automation",
        "label": "AP automation",
        "licenseId": "apache-2.0"
      },
      {
        "id": "document-capture",
        "label": "Document capture",
        "licenseId": "apache-2.0"
      },
      {
        "id": "treasury",
        "label": "Treasury",
        "licenseId": "apache-2.0"
      },
      {
        "id": "fraud-control",
        "label": "Fraud control",
        "licenseId": "apache-2.0"
      },
      {
        "id": "tax-control",
        "label": "Tax control",
        "licenseId": "apache-2.0"
      },
      {
        "id": "bank",
        "label": "Bank",
        "licenseId": "apache-2.0"
      },
      {
        "id": "payment-platform",
        "label": "Payment platform",
        "licenseId": "apache-2.0"
      },
      {
        "id": "srm",
        "label": "SRM",
        "licenseId": "apache-2.0"
      },
      {
        "id": "quality-system",
        "label": "Quality system",
        "licenseId": "apache-2.0"
      },
      {
        "id": "logistics",
        "label": "Logistics",
        "licenseId": "apache-2.0"
      },
      {
        "id": "innovation-portal",
        "label": "Innovation portal",
        "licenseId": "apache-2.0"
      },
      {
        "id": "idea-management",
        "label": "Idea management",
        "licenseId": "apache-2.0"
      },
      {
        "id": "value-management",
        "label": "Value management",
        "licenseId": "apache-2.0"
      },
      {
        "id": "finance-ledger",
        "label": "Finance ledger",
        "licenseId": "apache-2.0"
      },
      {
        "id": "savings-platform",
        "label": "Savings platform",
        "licenseId": "apache-2.0"
      },
      {
        "id": "finance-reporting",
        "label": "Finance reporting",
        "licenseId": "apache-2.0"
      }
    ],
    "toolRecipes": [
      {
        "actionClass": "read-only",
        "agentIds": [
          "spend-steward-agent",
          "spend-quality-critic-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "spend-data-foundation",
        "entityIds": [
          "spend-record",
          "party",
          "business-unit",
          "category",
          "source-record-reference",
          "evidence-item",
          "integration-state"
        ],
        "id": "tool-spend-data-foundation",
        "label": "Spend data ingestion, classification and reconciliation outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Explain source coverage, reconciliation, freshness and classification exceptions.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "source-snapshot-delta-ingest",
          "master-reference-sync",
          "external-analytics-exchange"
        ]
      },
      {
        "actionClass": "read-or-propose",
        "agentIds": [
          "category-radar-agent",
          "opportunity-critic-agent",
          "commodity-price-outlook-agent",
          "tail-spend-consolidation-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "category-opportunity-radar",
        "entityIds": [
          "category-opportunity",
          "spend-record",
          "category",
          "party",
          "decision",
          "evidence-item",
          "business-unit",
          "source-record-reference",
          "authority-envelope",
          "learning-example",
          "evaluation-result",
          "integration-state",
          "buying-request",
          "tail-spend-evaluation"
        ],
        "id": "tool-category-opportunity-radar",
        "label": "Category opportunity discovery and prioritisation outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Retrieve evidence-linked opportunities or propose a triage action without committing the backlog.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "external-analytics-exchange",
          "risk-and-reference-evidence-feed",
          "master-reference-sync"
        ]
      },
      {
        "actionClass": "draft-or-propose",
        "agentIds": [
          "category-strategist-agent",
          "strategy-orchestration-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "category-strategy-orchestrator",
        "entityIds": [
          "category-strategy",
          "category-opportunity",
          "decision",
          "evidence-item",
          "spend-record"
        ],
        "id": "tool-category-strategy-orchestrator",
        "label": "Category strategy design and governance outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Assemble current evidence and draft a strategy review package.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "external-analytics-exchange",
          "risk-and-reference-evidence-feed",
          "sharepoint-content-binding"
        ]
      },
      {
        "actionClass": "read-or-propose",
        "agentIds": [
          "policy-rule-author-agent",
          "policy-release-critic-agent",
          "channel-drift-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "policy-rule-lifecycle",
        "entityIds": [
          "policy",
          "policy-version",
          "policy-rule-release",
          "decision",
          "evidence-item",
          "policy-guidance-result",
          "requisition",
          "tail-spend-rule",
          "policy-change-impact"
        ],
        "id": "tool-policy-rule-lifecycle",
        "label": "Procurement policy rule authoring and lifecycle outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Explain rule lineage and propose validation or release actions; policy meaning changes require owner authority.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "sharepoint-content-binding",
          "master-reference-sync",
          "copilot-synced-knowledge-projection"
        ]
      },
      {
        "actionClass": "read-only",
        "agentIds": [
          "policy-guidance-agent",
          "guidance-critic-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "policy-guidance",
        "entityIds": [
          "policy-guidance-result",
          "policy",
          "policy-version",
          "evidence-item",
          "policy-rule-release",
          "exception",
          "registry-release",
          "policy-change-impact"
        ],
        "id": "tool-policy-guidance",
        "label": "Procurement policy guidance outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Return a source-cited answer or named escalation for the supplied facts.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "sharepoint-content-binding",
          "copilot-synced-knowledge-projection",
          "copilot-federated-knowledge-query"
        ]
      },
      {
        "actionClass": "read-only",
        "agentIds": [
          "service-catalogue-curator-agent",
          "service-discovery-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "procurement-service-catalogue",
        "entityIds": [
          "procurement-service-offering",
          "policy",
          "authority-envelope",
          "policy-rule-release",
          "policy-change-impact"
        ],
        "id": "tool-procurement-service-catalogue",
        "label": "Procurement service catalogue outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Find an eligible service and explain its start conditions.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "master-reference-sync",
          "sharepoint-content-binding",
          "copilot-synced-knowledge-projection",
          "copilot-federated-knowledge-query"
        ]
      },
      {
        "actionClass": "consequential-create",
        "agentIds": [
          "request-intake-agent",
          "intake-quality-critic-agent"
        ],
        "authorityCeiling": "The tool may act only after exact confirmation, current authority, expected-version checks, idempotency and external reconciliation.",
        "businessModuleId": "intelligent-intake",
        "entityIds": [
          "intake-request",
          "policy-change-impact",
          "party",
          "person",
          "business-unit",
          "source-record-reference",
          "evidence-item",
          "procurement-service-offering",
          "category",
          "item-service",
          "policy",
          "policy-version",
          "authority-envelope",
          "learning-example",
          "evaluation-result",
          "integration-state"
        ],
        "id": "tool-intelligent-intake",
        "label": "Procurement request intake outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Create an intake request after showing captured facts, route and authority boundary.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "collaboration-intake",
          "sharepoint-content-binding",
          "master-reference-sync"
        ]
      },
      {
        "actionClass": "read-or-propose",
        "agentIds": [
          "request-enrichment-agent",
          "request-routing-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "request-enrichment-routing",
        "entityIds": [
          "enriched-request",
          "intake-request",
          "policy-guidance-result",
          "party",
          "category"
        ],
        "id": "tool-request-enrichment-routing",
        "label": "Procurement request enrichment and routing outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Explain missing facts and propose the next valid route without committing downstream work.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "master-reference-sync",
          "risk-and-reference-evidence-feed",
          "external-analytics-exchange"
        ]
      },
      {
        "actionClass": "consequential-action",
        "agentIds": [
          "demand-orchestrator-agent",
          "journey-critic-agent"
        ],
        "authorityCeiling": "The tool may act only after exact confirmation, current authority, expected-version checks, idempotency and external reconciliation.",
        "businessModuleId": "demand-orchestration",
        "entityIds": [
          "demand-case",
          "enriched-request",
          "exception",
          "committed-action",
          "intake-request",
          "person",
          "authority-envelope",
          "action-proposal",
          "decision",
          "audit-event",
          "business-event",
          "integration-state",
          "registry-release"
        ],
        "id": "tool-demand-orchestration",
        "label": "Procurement request coordination outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Propose or execute an authorised next handoff with explicit confirmation and recovery.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "collaboration-intake",
          "master-reference-sync",
          "sharepoint-content-binding"
        ]
      },
      {
        "actionClass": "draft-or-propose",
        "agentIds": [
          "demand-portfolio-agent",
          "demand-portfolio-critic-agent",
          "raw-material-demand-agent",
          "coverage-position-agent",
          "specification-harmonisation-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "demand-consolidation-portfolio",
        "entityIds": [
          "demand-portfolio",
          "demand-case",
          "category",
          "decision",
          "item-service",
          "contract-entitlement"
        ],
        "id": "tool-demand-consolidation-portfolio",
        "label": "Demand consolidation and portfolio planning outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Prepare consolidation options and surface conflicts for owner decision.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "external-analytics-exchange",
          "master-reference-sync",
          "sharepoint-content-binding"
        ]
      },
      {
        "actionClass": "read-or-propose",
        "agentIds": [
          "sourcing-discovery-agent",
          "sourcing-pipeline-agent",
          "buy-timing-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "sourcing-pipeline-discovery",
        "entityIds": [
          "sourcing-opportunity",
          "buy-timing-mandate",
          "demand-case",
          "category-opportunity",
          "contract",
          "decision",
          "demand-portfolio",
          "authority-envelope"
        ],
        "id": "tool-sourcing-pipeline-discovery",
        "label": "Sourcing pipeline discovery outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Retrieve evidence-linked sourcing opportunities and propose a route.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "external-analytics-exchange",
          "master-reference-sync",
          "sharepoint-content-binding"
        ]
      },
      {
        "actionClass": "draft-or-propose",
        "agentIds": [
          "sourcing-event-designer-agent",
          "sourcing-event-operator-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "sourcing-event",
        "entityIds": [
          "sourcing-event-record",
          "buy-timing-mandate",
          "party",
          "evidence-item",
          "decision",
          "sourcing-opportunity",
          "person",
          "category",
          "item-service",
          "source-record-reference",
          "policy",
          "policy-version",
          "authority-envelope",
          "action-proposal",
          "committed-action",
          "exception",
          "audit-event",
          "business-event",
          "learning-example",
          "evaluation-result",
          "integration-state",
          "registry-release"
        ],
        "id": "tool-sourcing-event",
        "label": "Sourcing event preparation and evaluation outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Assemble event evidence and prepare a reviewable decision package.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "master-reference-sync",
          "structured-business-document-ingest",
          "sharepoint-content-binding",
          "structured-business-document-outbound"
        ]
      },
      {
        "actionClass": "draft-or-propose",
        "agentIds": [
          "bid-evaluation-agent",
          "award-optimizer-critic-agent",
          "landed-cost-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "bid-evaluation-award",
        "entityIds": [
          "award-scenario",
          "sourcing-event-record",
          "decision",
          "evidence-item",
          "supplier-risk-assessment"
        ],
        "id": "tool-bid-evaluation-award",
        "label": "Bid evaluation and award preparation outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Compare scenarios and prepare an award proposal; authorised award remains a separate commitment.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "structured-business-document-ingest",
          "external-analytics-exchange",
          "sharepoint-content-binding",
          "structured-business-document-outbound"
        ]
      },
      {
        "actionClass": "draft-or-propose",
        "agentIds": [
          "negotiation-strategy-agent",
          "negotiation-execution-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "negotiation-copilot",
        "entityIds": [
          "negotiation-session",
          "buy-timing-mandate",
          "contract",
          "spend-record",
          "authority-envelope",
          "evidence-item",
          "award-scenario",
          "sourcing-opportunity"
        ],
        "id": "tool-negotiation-copilot",
        "label": "Negotiation preparation outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Prepare issues, evidence, feasible packages and current authority for review.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "sharepoint-content-binding",
          "external-analytics-exchange",
          "master-reference-sync"
        ]
      },
      {
        "actionClass": "consequential-action",
        "agentIds": [
          "tactical-sourcing-mission-agent",
          "tactical-sourcing-critic-agent",
          "spot-buy-conversion-agent"
        ],
        "authorityCeiling": "The tool may act only after exact confirmation, current authority, expected-version checks, idempotency and external reconciliation.",
        "businessModuleId": "tactical-sourcing-autonomy",
        "entityIds": [
          "tactical-sourcing-case",
          "buy-timing-mandate",
          "authority-envelope",
          "committed-action",
          "decision",
          "evidence-item",
          "demand-case",
          "sourcing-opportunity",
          "tail-spend-evaluation"
        ],
        "id": "tool-tactical-sourcing-autonomy",
        "label": "Policy-bounded tactical sourcing execution outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Execute only within a current policy grant; otherwise return an evidence-complete escalation.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "structured-business-document-ingest",
          "master-reference-sync",
          "structured-business-document-outbound"
        ]
      },
      {
        "actionClass": "consequential-create",
        "agentIds": [
          "contract-intake-agent",
          "intake-critic-agent"
        ],
        "authorityCeiling": "The tool may act only after exact confirmation, current authority, expected-version checks, idempotency and external reconciliation.",
        "businessModuleId": "contract-intake-digitization",
        "entityIds": [
          "contract-intake",
          "contract",
          "party",
          "evidence-item",
          "source-record-reference",
          "contract-template",
          "supplier-profile"
        ],
        "id": "tool-contract-intake-digitization",
        "label": "Contract data capture and extraction outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Capture and validate a contract intake from authorised artifacts before creating the canonical record.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "sharepoint-content-binding",
          "collaboration-intake",
          "structured-business-document-ingest"
        ]
      },
      {
        "actionClass": "draft-or-propose",
        "agentIds": [
          "contract-drafting-agent",
          "contract-review-critic"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "contract-authoring-review",
        "entityIds": [
          "contract-version",
          "contract-template",
          "clause-library-entry",
          "clause-deviation",
          "decision",
          "contract-intake",
          "business-event",
          "contract",
          "party",
          "person",
          "source-record-reference",
          "evidence-item",
          "policy",
          "policy-version",
          "authority-envelope",
          "action-proposal",
          "committed-action",
          "exception",
          "audit-event",
          "learning-example",
          "evaluation-result",
          "integration-state",
          "registry-release"
        ],
        "id": "tool-contract-authoring-review",
        "label": "Contract drafting, negotiation and redlining outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Prepare a source-linked review and redline package without accepting legal positions.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "sharepoint-content-binding",
          "master-reference-sync"
        ]
      },
      {
        "actionClass": "consequential-action",
        "agentIds": [
          "contract-approval-agent",
          "execution-critic-agent"
        ],
        "authorityCeiling": "The tool may act only after exact confirmation, current authority, expected-version checks, idempotency and external reconciliation.",
        "businessModuleId": "contract-approval-repository",
        "entityIds": [
          "contract",
          "contract-version",
          "contract-approval",
          "committed-action",
          "evidence-item",
          "contract-template",
          "clause-deviation",
          "audit-event"
        ],
        "id": "tool-contract-approval-repository",
        "label": "Contract approval, execution and storage outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Submit the exact bound version for authorised approval or signature with explicit confirmation.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "sharepoint-content-binding",
          "master-reference-sync",
          "structured-business-document-outbound"
        ]
      },
      {
        "actionClass": "read-or-propose",
        "agentIds": [
          "obligation-owner-agent",
          "entitlement-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "obligation-monitoring",
        "entityIds": [
          "contract-obligation",
          "contract-entitlement",
          "contract",
          "committed-action",
          "evidence-item",
          "clause-library-entry",
          "contract-version",
          "contract-approval",
          "business-event"
        ],
        "id": "tool-obligation-monitoring",
        "label": "Obligation and performance management outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Retrieve obligations by consequence and propose an owner action.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "sharepoint-content-binding",
          "external-analytics-exchange",
          "risk-and-reference-evidence-feed",
          "collaboration-intake"
        ]
      },
      {
        "actionClass": "draft-or-propose",
        "agentIds": [
          "contract-change-agent",
          "contract-compliance-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "renewal-change-compliance",
        "entityIds": [
          "contract-change",
          "contract-compliance-finding",
          "contract",
          "decision",
          "committed-action",
          "clause-library-entry",
          "contract-version",
          "contract-obligation",
          "contract-entitlement"
        ],
        "id": "tool-renewal-change-compliance",
        "label": "Renewal, change and compliance outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Prepare options, deadlines, evidence and approval needs for the owner.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "sharepoint-content-binding",
          "external-analytics-exchange",
          "risk-and-reference-evidence-feed",
          "structured-business-document-outbound"
        ]
      },
      {
        "actionClass": "read-or-propose",
        "agentIds": [
          "supplier-onboarding-agent",
          "onboarding-critic-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "supplier-onboarding",
        "entityIds": [
          "supplier-onboarding-case",
          "supplier-profile",
          "party",
          "supplier-qualification",
          "committed-action",
          "supplier-risk-assessment",
          "source-record-reference",
          "policy",
          "integration-state",
          "registry-release"
        ],
        "id": "tool-supplier-onboarding",
        "label": "Supplier onboarding outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Explain readiness, missing evidence and proposed next action; master activation remains authorised.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "master-reference-sync",
          "risk-and-reference-evidence-feed",
          "collaboration-intake",
          "sharepoint-content-binding",
          "structured-business-document-outbound"
        ]
      },
      {
        "actionClass": "consequential-action",
        "agentIds": [
          "supplier-qualification-agent",
          "supplier-master-change-agent",
          "carbon-compliance-agent",
          "supplier-quality-prediction-agent"
        ],
        "authorityCeiling": "The tool may act only after exact confirmation, current authority, expected-version checks, idempotency and external reconciliation.",
        "businessModuleId": "supplier-master-qualification",
        "entityIds": [
          "supplier-qualification",
          "supplier-master-change",
          "supplier-profile",
          "party",
          "decision",
          "supplier-onboarding-case",
          "supplier-risk-assessment",
          "evidence-item",
          "supplier-performance-observation"
        ],
        "id": "tool-supplier-master-qualification",
        "label": "Supplier master data and qualification outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Prepare or submit a verified change through the source owner, with high-risk fields requiring explicit authority.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "master-reference-sync",
          "risk-and-reference-evidence-feed"
        ]
      },
      {
        "actionClass": "draft-or-propose",
        "agentIds": [
          "third-party-risk-agent",
          "risk-assessment-critic"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "third-party-risk-review",
        "entityIds": [
          "supplier-risk-assessment",
          "supplier-profile",
          "decision",
          "evidence-item",
          "supplier-onboarding-case",
          "supplier-qualification",
          "supplier-risk-signal",
          "supplier-tier-link",
          "person",
          "policy-version",
          "authority-envelope",
          "action-proposal",
          "committed-action",
          "exception",
          "audit-event",
          "business-event",
          "learning-example",
          "evaluation-result"
        ],
        "id": "tool-third-party-risk-review",
        "label": "Third-party risk review outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Assemble current evidence, remaining risk and treatment options for the authorised owner.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "risk-and-reference-evidence-feed",
          "master-reference-sync",
          "sharepoint-content-binding"
        ]
      },
      {
        "actionClass": "read-or-propose",
        "agentIds": [
          "supplier-risk-monitor-agent",
          "supply-network-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "continuous-risk-monitoring",
        "entityIds": [
          "supplier-risk-signal",
          "supplier-risk-case",
          "supplier-tier-link",
          "evidence-item",
          "supplier-profile",
          "supplier-risk-assessment"
        ],
        "id": "tool-continuous-risk-monitoring",
        "label": "Third-party risk signal tracking outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Retrieve material signals and propose a relationship-specific case.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "risk-and-reference-evidence-feed",
          "master-reference-sync",
          "collaboration-intake"
        ]
      },
      {
        "actionClass": "consequential-action",
        "agentIds": [
          "supplier-remediation-agent",
          "supplier-exit-agent"
        ],
        "authorityCeiling": "The tool may act only after exact confirmation, current authority, expected-version checks, idempotency and external reconciliation.",
        "businessModuleId": "supplier-remediation-exit",
        "entityIds": [
          "supplier-remediation-action",
          "supplier-performance-signal",
          "supplier-offboarding-case",
          "supplier-risk-case",
          "committed-action",
          "supplier-profile",
          "supplier-risk-assessment",
          "contract",
          "purchase-order"
        ],
        "id": "tool-supplier-remediation-exit",
        "label": "Supplier remediation and exit coordination outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Execute an authorised remediation step or return a dependency-complete escalation.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "master-reference-sync",
          "risk-and-reference-evidence-feed",
          "external-analytics-exchange",
          "structured-business-document-outbound",
          "collaboration-intake"
        ]
      },
      {
        "actionClass": "read-or-propose",
        "agentIds": [
          "requester-buying-agent",
          "buying-guidance-critic",
          "catalogue-coverage-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "guided-buying",
        "entityIds": [
          "buying-request",
          "catalogue-line",
          "item-service",
          "party",
          "policy-guidance-result",
          "supplier-profile",
          "supplier-qualification",
          "contract",
          "business-unit",
          "category",
          "source-record-reference",
          "policy",
          "policy-version",
          "authority-envelope",
          "evaluation-result",
          "integration-state",
          "registry-release",
          "contract-entitlement"
        ],
        "id": "tool-guided-buying",
        "label": "Guided buying outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Return the compliant route, source and any missing approval facts.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "master-reference-sync",
          "punchout-catalogue-session",
          "structured-business-document-ingest"
        ]
      },
      {
        "actionClass": "consequential-create",
        "agentIds": [
          "requisition-policy-agent",
          "requisition-critic-agent"
        ],
        "authorityCeiling": "The tool may act only after exact confirmation, current authority, expected-version checks, idempotency and external reconciliation.",
        "businessModuleId": "requisition-policy-routing",
        "entityIds": [
          "requisition",
          "requisition-line",
          "buying-request",
          "policy-change-impact",
          "decision",
          "catalogue-line",
          "supplier-profile",
          "supplier-qualification"
        ],
        "id": "tool-requisition-policy-routing",
        "label": "Requisition policy evaluation and routing outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Submit a validated requisition through the authoritative execution boundary after confirmation.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "master-reference-sync",
          "external-analytics-exchange",
          "punchout-catalogue-session",
          "structured-business-document-outbound"
        ]
      },
      {
        "actionClass": "consequential-action",
        "agentIds": [
          "purchase-order-agent",
          "order-response-agent"
        ],
        "authorityCeiling": "The tool may act only after exact confirmation, current authority, expected-version checks, idempotency and external reconciliation.",
        "businessModuleId": "purchase-order-orchestration",
        "entityIds": [
          "purchase-order",
          "order-line",
          "order-response",
          "committed-action",
          "integration-state",
          "requisition",
          "requisition-line",
          "supplier-profile",
          "contract",
          "catalogue-line"
        ],
        "id": "tool-purchase-order-orchestration",
        "label": "Purchase order orchestration outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Dispatch an already authorised order and return delivery, acknowledgement and reconciliation state.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "structured-business-document-ingest",
          "master-reference-sync",
          "structured-business-document-outbound"
        ]
      },
      {
        "actionClass": "consequential-action",
        "agentIds": [
          "purchase-order-exception-agent",
          "order-exception-critic"
        ],
        "authorityCeiling": "The tool may act only after exact confirmation, current authority, expected-version checks, idempotency and external reconciliation.",
        "businessModuleId": "purchase-order-exception",
        "entityIds": [
          "purchase-order-exception",
          "purchase-order",
          "order-response",
          "receipt",
          "decision",
          "order-line",
          "shipment",
          "authority-envelope",
          "action-proposal",
          "committed-action",
          "exception",
          "audit-event",
          "business-event",
          "catalogue-line"
        ],
        "id": "tool-purchase-order-exception",
        "label": "Purchase order exception resolution outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Propose or execute a permitted source correction with readback and uncertain-effect handling.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "structured-business-document-ingest",
          "master-reference-sync",
          "structured-business-document-outbound"
        ]
      },
      {
        "actionClass": "consequential-create",
        "agentIds": [
          "receiving-agent",
          "service-acceptance-agent",
          "return-recovery-agent"
        ],
        "authorityCeiling": "The tool may act only after exact confirmation, current authority, expected-version checks, idempotency and external reconciliation.",
        "businessModuleId": "receiving-service-entry",
        "entityIds": [
          "shipment",
          "receipt",
          "receipt-line",
          "service-entry-sheet",
          "return-claim",
          "purchase-order",
          "order-line"
        ],
        "id": "tool-receiving-service-entry",
        "label": "Goods receipt and service-entry coordination outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Submit verified receipt or service-entry facts with explicit authority and source readback.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "structured-business-document-ingest",
          "collaboration-intake",
          "structured-business-document-outbound"
        ]
      },
      {
        "actionClass": "read-only",
        "agentIds": [
          "invoice-intake-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "invoice-intake-match",
        "entityIds": [
          "invoice",
          "invoice-line",
          "invoice-match-assessment",
          "source-record-reference",
          "evidence-item"
        ],
        "id": "tool-invoice-intake-match",
        "label": "Invoice intake and matching outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Explain canonicalisation, validation and match evidence for an invoice.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "structured-business-document-ingest",
          "master-reference-sync",
          "structured-business-document-outbound"
        ]
      },
      {
        "actionClass": "read-or-propose",
        "agentIds": [
          "invoice-exception-coordinator-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "invoice-exception-triage",
        "entityIds": [
          "invoice-exception",
          "invoice-match-assessment",
          "purchase-order",
          "receipt",
          "contract",
          "invoice",
          "supplier-invoice-resolution",
          "party",
          "category",
          "item-service",
          "source-record-reference",
          "evidence-item",
          "policy",
          "policy-version",
          "authority-envelope",
          "action-proposal",
          "committed-action",
          "decision",
          "exception",
          "audit-event",
          "business-event",
          "learning-example",
          "evaluation-result",
          "integration-state",
          "registry-release"
        ],
        "id": "tool-invoice-exception-triage",
        "label": "Invoice exception triage outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Assemble causal evidence and propose the next valid resolution.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "structured-business-document-ingest",
          "master-reference-sync",
          "external-analytics-exchange",
          "structured-business-document-outbound",
          "collaboration-intake"
        ],
        "workblockPath": "workblocks/invoice-exception-copilot-demo"
      },
      {
        "actionClass": "consequential-action",
        "agentIds": [
          "supplier-invoice-resolution-agent"
        ],
        "authorityCeiling": "The tool may act only after exact confirmation, current authority, expected-version checks, idempotency and external reconciliation.",
        "businessModuleId": "supplier-invoice-resolution",
        "entityIds": [
          "supplier-invoice-resolution",
          "invoice-exception",
          "party",
          "evidence-item",
          "committed-action",
          "invoice"
        ],
        "id": "tool-supplier-invoice-resolution",
        "label": "Supplier invoice resolution outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Send or reconcile an authorised supplier resolution step and retain the two-sided record.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "structured-business-document-ingest",
          "collaboration-intake",
          "structured-business-document-outbound"
        ]
      },
      {
        "actionClass": "read-or-propose",
        "agentIds": [
          "payment-readiness-agent",
          "payment-terms-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "payment-readiness",
        "entityIds": [
          "payment-readiness-assessment",
          "invoice",
          "decision",
          "evidence-item",
          "invoice-match-assessment",
          "invoice-exception",
          "person",
          "policy",
          "policy-version",
          "authority-envelope",
          "exception",
          "audit-event",
          "business-event",
          "integration-state",
          "contract-entitlement"
        ],
        "id": "tool-payment-readiness",
        "label": "Payment readiness check outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Return readiness, stale conditions and the named authority required for release.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "master-reference-sync",
          "external-analytics-exchange",
          "risk-and-reference-evidence-feed"
        ]
      },
      {
        "actionClass": "consequential-action",
        "agentIds": [
          "payment-execution-guard-agent"
        ],
        "authorityCeiling": "The tool may act only after exact confirmation, current authority, expected-version checks, idempotency and external reconciliation.",
        "businessModuleId": "payment-execution-guard",
        "entityIds": [
          "payment-instruction",
          "payment-execution-status",
          "committed-action",
          "integration-state",
          "payment-readiness-assessment",
          "invoice"
        ],
        "id": "tool-payment-execution-guard",
        "label": "Payment execution control outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Submit an already authorised instruction with confirmation, segregation and status reconciliation.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "payment-and-bank-message-exchange",
          "master-reference-sync"
        ]
      },
      {
        "actionClass": "read-or-propose",
        "agentIds": [
          "supplier-segmentation-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "supplier-segmentation-governance",
        "entityIds": [
          "supplier-segment-assignment",
          "supplier-profile",
          "party",
          "decision",
          "supplier-performance-observation"
        ],
        "id": "tool-supplier-segmentation-governance",
        "label": "Supplier segmentation and governance outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Explain a segment assignment and propose a change for owner review.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "master-reference-sync",
          "external-analytics-exchange",
          "risk-and-reference-evidence-feed"
        ]
      },
      {
        "actionClass": "consequential-create",
        "agentIds": [
          "supplier-performance-monitor-agent"
        ],
        "authorityCeiling": "The tool may act only after exact confirmation, current authority, expected-version checks, idempotency and external reconciliation.",
        "businessModuleId": "supplier-performance-monitor-correct",
        "entityIds": [
          "supplier-performance-observation",
          "supplier-performance-signal",
          "supplier-remediation-action",
          "party",
          "evidence-item",
          "supplier-segment-assignment",
          "supplier-performance-review-record"
        ],
        "id": "tool-supplier-performance-monitor-correct",
        "label": "Supplier performance tracking and corrective action outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Create an evidence-linked corrective action after confirmation and authority checks.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "external-analytics-exchange",
          "structured-business-document-ingest",
          "risk-and-reference-evidence-feed",
          "collaboration-intake",
          "sharepoint-content-binding"
        ]
      },
      {
        "actionClass": "draft-or-propose",
        "agentIds": [
          "supplier-performance-review-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "supplier-performance-review",
        "entityIds": [
          "supplier-performance-review-record",
          "supplier-performance-observation",
          "supplier-performance-signal",
          "committed-action",
          "evidence-item",
          "supplier-segment-assignment",
          "party",
          "source-record-reference",
          "authority-envelope",
          "decision",
          "audit-event",
          "business-event",
          "learning-example",
          "evaluation-result",
          "integration-state",
          "registry-release"
        ],
        "id": "tool-supplier-performance-review",
        "label": "Supplier performance review outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Assemble current evidence and prepare a review and commitment proposal.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "external-analytics-exchange",
          "sharepoint-content-binding",
          "risk-and-reference-evidence-feed"
        ]
      },
      {
        "actionClass": "read-or-propose",
        "agentIds": [
          "supplier-innovation-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "supplier-innovation-pipeline",
        "entityIds": [
          "supplier-innovation-case",
          "party",
          "decision",
          "evidence-item",
          "supplier-segment-assignment",
          "supplier-performance-review-record",
          "supplier-joint-value-plan"
        ],
        "id": "tool-supplier-innovation-pipeline",
        "label": "Supplier innovation pipeline outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Explain evidence, confidentiality and next stage decision without creating a commercial commitment.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "collaboration-intake",
          "sharepoint-content-binding"
        ]
      },
      {
        "actionClass": "draft-or-propose",
        "agentIds": [
          "supplier-relationship-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "supplier-relationship-joint-value",
        "entityIds": [
          "supplier-joint-value-plan",
          "committed-action",
          "value-realization-attribution",
          "evidence-item",
          "supplier-segment-assignment",
          "supplier-performance-review-record",
          "supplier-innovation-case"
        ],
        "id": "tool-supplier-relationship-joint-value",
        "label": "Supplier relationship and joint-value planning outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Prepare a shared plan review with commitments, risks and finance-visible evidence.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "external-analytics-exchange",
          "sharepoint-content-binding",
          "risk-and-reference-evidence-feed"
        ]
      },
      {
        "actionClass": "draft-or-propose",
        "agentIds": [
          "value-baseline-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "value-opportunity-baseline",
        "entityIds": [
          "value-opportunity-baseline",
          "spend-record",
          "decision",
          "evidence-item",
          "savings-initiative-record"
        ],
        "id": "tool-value-opportunity-baseline",
        "label": "Value opportunity and baseline definition outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Prepare a reproducible baseline and surface assumptions for finance decision.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "external-analytics-exchange",
          "master-reference-sync",
          "sharepoint-content-binding"
        ]
      },
      {
        "actionClass": "read-or-propose",
        "agentIds": [
          "savings-initiative-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "savings-initiative",
        "entityIds": [
          "savings-initiative-record",
          "value-opportunity-baseline",
          "committed-action",
          "evidence-item",
          "value-realization-attribution",
          "value-leakage-finding",
          "business-unit",
          "category",
          "source-record-reference",
          "authority-envelope",
          "action-proposal",
          "decision",
          "exception",
          "audit-event",
          "business-event",
          "learning-example",
          "evaluation-result",
          "integration-state",
          "registry-release"
        ],
        "id": "tool-savings-initiative",
        "label": "Savings initiative tracking outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Explain initiative state, evidence, owner and proposed next action without validating value.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "external-analytics-exchange",
          "master-reference-sync",
          "sharepoint-content-binding"
        ]
      },
      {
        "actionClass": "draft-or-propose",
        "agentIds": [
          "value-attribution-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "realization-reconciliation-attribution",
        "entityIds": [
          "value-realization-attribution",
          "savings-initiative-record",
          "spend-record",
          "decision",
          "value-opportunity-baseline",
          "value-leakage-finding"
        ],
        "id": "tool-realization-reconciliation-attribution",
        "label": "Value realisation reconciliation and attribution outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Prepare a source-linked attribution for finance approval.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "external-analytics-exchange",
          "master-reference-sync"
        ]
      },
      {
        "actionClass": "read-or-propose",
        "agentIds": [
          "value-leakage-agent",
          "price-variance-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "value-leakage-monitor",
        "entityIds": [
          "value-leakage-finding",
          "savings-initiative-record",
          "contract",
          "purchase-order",
          "invoice",
          "value-opportunity-baseline",
          "value-realization-attribution",
          "authority-envelope",
          "business-event"
        ],
        "id": "tool-value-leakage-monitor",
        "label": "Value leakage monitoring outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Explain causal evidence and propose a recovery action.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "external-analytics-exchange",
          "structured-business-document-ingest",
          "master-reference-sync",
          "collaboration-intake"
        ]
      },
      {
        "actionClass": "read-or-propose",
        "agentIds": [
          "value-portfolio-agent",
          "margin-tradeoff-agent"
        ],
        "authorityCeiling": "The tool may read, draft or propose within the module envelope. A named person or policy commits any consequential outcome.",
        "businessModuleId": "value-portfolio-forecast",
        "entityIds": [
          "value-portfolio-forecast",
          "savings-initiative-record",
          "value-realization-attribution",
          "evidence-item",
          "value-opportunity-baseline",
          "value-leakage-finding",
          "award-scenario"
        ],
        "id": "tool-value-portfolio-forecast",
        "label": "Value portfolio forecasting outcome tool",
        "licenseId": "bw-partner-1.0",
        "outcome": "Explain forecast version, assumptions, contributing initiatives, freshness and uncertainty.",
        "proofClass": "recipe",
        "recipeIds": [
          "workblock-mcp-tool-exposure",
          "external-analytics-exchange",
          "master-reference-sync",
          "sharepoint-content-binding"
        ]
      }
    ],
    "versioningPolicy": "The integration registry uses semantic versioning. A recipe is framework proof, not an installed connector. Client overlays pin installed releases, schemas, identity, permissions, channels, operating envelopes and acceptance evidence without changing the shared recipe ID."
  },
  "locale": "en-GB",
  "partnerCapabilityMappings": [
    {
      "descriptionKey": "partner-capability.map.description",
      "id": "accenture-s2p-master",
      "licenseId": "partner-owned",
      "mappingDirection": "partner-to-groundworks",
      "nodes": [
        {
          "groundworks": {
            "businessModuleIds": [],
            "domainWorkblockIds": [
              "intake-demand"
            ],
            "fit": "partial",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "intake-management",
          "kind": "area",
          "labelKey": "partner-capability.intake-management.label",
          "order": 1
        },
        {
          "groundworks": {
            "businessModuleIds": [],
            "domainWorkblockIds": [
              "strategy-policy-category-spend"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "category-management",
          "kind": "area",
          "labelKey": "partner-capability.category-management.label",
          "order": 2
        },
        {
          "groundworks": {
            "businessModuleIds": [],
            "domainWorkblockIds": [
              "sourcing-negotiation"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "sourcing-negotiation",
          "kind": "area",
          "labelKey": "partner-capability.sourcing-negotiation.label",
          "order": 3
        },
        {
          "groundworks": {
            "businessModuleIds": [],
            "domainWorkblockIds": [
              "contract-lifecycle-management"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": [
              "office-composer-conductor"
            ]
          },
          "id": "contract-lifecycle-management",
          "kind": "area",
          "labelKey": "partner-capability.contract-lifecycle-management.label",
          "order": 4
        },
        {
          "groundworks": {
            "businessModuleIds": [],
            "domainWorkblockIds": [
              "supplier-lifecycle-third-party-risk"
            ],
            "fit": "partial",
            "relationship": "overlaps",
            "sharedCapabilityIds": [
              "identity-policy-controls-audit"
            ]
          },
          "id": "supplier-lifecycle-risk",
          "kind": "area",
          "labelKey": "partner-capability.supplier-lifecycle-risk.label",
          "order": 5
        },
        {
          "groundworks": {
            "businessModuleIds": [],
            "domainWorkblockIds": [
              "buying-ordering-receiving"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": [
              "integration-coexistence"
            ]
          },
          "id": "purchasing-ordering",
          "kind": "area",
          "labelKey": "partner-capability.purchasing-ordering.label",
          "order": 6
        },
        {
          "groundworks": {
            "businessModuleIds": [],
            "domainWorkblockIds": [
              "invoice-exception-payment-readiness"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": [
              "identity-policy-controls-audit",
              "integration-coexistence"
            ]
          },
          "id": "invoicing-payment",
          "kind": "area",
          "labelKey": "partner-capability.invoicing-payment.label",
          "order": 7
        },
        {
          "groundworks": {
            "businessModuleIds": [],
            "domainWorkblockIds": [
              "supplier-performance-innovation-relationship"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "supplier-relationship-management",
          "kind": "area",
          "labelKey": "partner-capability.supplier-relationship-management.label",
          "order": 8
        },
        {
          "groundworks": {
            "businessModuleIds": [],
            "domainWorkblockIds": [
              "value-realization-savings"
            ],
            "fit": "partial",
            "relationship": "overlaps",
            "sharedCapabilityIds": [
              "data-evidence-analytics-learning"
            ]
          },
          "id": "savings-value-realisation",
          "kind": "area",
          "labelKey": "partner-capability.savings-value-realisation.label",
          "order": 9
        },
        {
          "groundworks": {
            "businessModuleIds": [],
            "domainWorkblockIds": [],
            "fit": "cross-cutting",
            "relationship": "supports",
            "sharedCapabilityIds": [
              "data-evidence-analytics-learning",
              "identity-policy-controls-audit",
              "integration-coexistence",
              "workblock-authoring-adaptability"
            ]
          },
          "id": "enterprise-enablers-controls",
          "kind": "cross-cutting-area",
          "labelKey": "partner-capability.enterprise-enablers-controls.label",
          "order": 10
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "category-strategy-orchestrator",
              "demand-orchestration"
            ],
            "domainWorkblockIds": [
              "strategy-policy-category-spend",
              "intake-demand"
            ],
            "fit": "partial",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "category-demand-stakeholder-engagement",
          "kind": "capability",
          "labelKey": "partner-capability.category-demand-stakeholder-engagement.label",
          "order": 1,
          "parentId": "category-management"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "spend-data-foundation",
              "category-opportunity-radar"
            ],
            "domainWorkblockIds": [
              "strategy-policy-category-spend"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": [
              "data-evidence-analytics-learning"
            ]
          },
          "id": "category-analysis",
          "kind": "capability",
          "labelKey": "partner-capability.category-analysis.label",
          "order": 2,
          "parentId": "category-management"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "category-opportunity-radar",
              "value-opportunity-baseline"
            ],
            "domainWorkblockIds": [
              "strategy-policy-category-spend",
              "value-realization-savings"
            ],
            "fit": "partial",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "category-opportunity-prioritisation",
          "kind": "capability",
          "labelKey": "partner-capability.category-opportunity-prioritisation.label",
          "order": 3,
          "parentId": "category-management"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "category-strategy-orchestrator"
            ],
            "domainWorkblockIds": [
              "strategy-policy-category-spend"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "category-plan-development",
          "kind": "capability",
          "labelKey": "partner-capability.category-plan-development.label",
          "order": 4,
          "parentId": "category-management"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "category-strategy-orchestrator",
              "policy-rule-lifecycle"
            ],
            "domainWorkblockIds": [
              "strategy-policy-category-spend"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "category-plan-governance",
          "kind": "capability",
          "labelKey": "partner-capability.category-plan-governance.label",
          "order": 5,
          "parentId": "category-management"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "category-strategy-orchestrator",
              "value-portfolio-forecast"
            ],
            "domainWorkblockIds": [
              "strategy-policy-category-spend",
              "value-realization-savings"
            ],
            "fit": "partial",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "budget-alignment",
          "kind": "capability",
          "labelKey": "partner-capability.budget-alignment.label",
          "order": 6,
          "parentId": "category-management"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "intelligent-intake",
              "request-enrichment-routing"
            ],
            "domainWorkblockIds": [
              "intake-demand"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "procurement-intake",
          "kind": "capability",
          "labelKey": "partner-capability.procurement-intake.label",
          "order": 1,
          "parentId": "intake-management"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "demand-orchestration",
              "demand-consolidation-portfolio"
            ],
            "domainWorkblockIds": [
              "intake-demand"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "demand-planning-management",
          "kind": "capability",
          "labelKey": "partner-capability.demand-planning-management.label",
          "order": 2,
          "parentId": "intake-management"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "procurement-service-catalogue",
              "guided-buying"
            ],
            "domainWorkblockIds": [
              "intake-demand",
              "buying-ordering-receiving"
            ],
            "fit": "partial",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "buying-channel-content",
          "kind": "capability",
          "labelKey": "partner-capability.buying-channel-content.label",
          "order": 3,
          "parentId": "intake-management"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "sourcing-pipeline-discovery",
              "sourcing-event"
            ],
            "domainWorkblockIds": [
              "sourcing-negotiation"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "sourcing-requirements",
          "kind": "capability",
          "labelKey": "partner-capability.sourcing-requirements.label",
          "order": 1,
          "parentId": "sourcing-negotiation"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "sourcing-pipeline-discovery",
              "negotiation-copilot"
            ],
            "domainWorkblockIds": [
              "sourcing-negotiation"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "sourcing-strategy",
          "kind": "capability",
          "labelKey": "partner-capability.sourcing-strategy.label",
          "order": 2,
          "parentId": "sourcing-negotiation"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "sourcing-event",
              "bid-evaluation-award"
            ],
            "domainWorkblockIds": [
              "sourcing-negotiation"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "supplier-selection-award",
          "kind": "capability",
          "labelKey": "partner-capability.supplier-selection-award.label",
          "order": 3,
          "parentId": "sourcing-negotiation"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "sourcing-event",
              "bid-evaluation-award"
            ],
            "domainWorkblockIds": [
              "sourcing-negotiation"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "sourcing-project-execution",
          "kind": "capability",
          "labelKey": "partner-capability.sourcing-project-execution.label",
          "order": 4,
          "parentId": "sourcing-negotiation"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "negotiation-copilot"
            ],
            "domainWorkblockIds": [
              "sourcing-negotiation"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "negotiation-cost-modelling",
          "kind": "capability",
          "labelKey": "partner-capability.negotiation-cost-modelling.label",
          "order": 5,
          "parentId": "sourcing-negotiation"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "tactical-sourcing-autonomy",
              "guided-buying"
            ],
            "domainWorkblockIds": [
              "sourcing-negotiation",
              "buying-ordering-receiving"
            ],
            "fit": "partial",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "tactical-spot-buy",
          "kind": "capability",
          "labelKey": "partner-capability.tactical-spot-buy.label",
          "order": 6,
          "parentId": "sourcing-negotiation"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "tactical-sourcing-autonomy",
              "demand-consolidation-portfolio"
            ],
            "domainWorkblockIds": [
              "sourcing-negotiation",
              "intake-demand"
            ],
            "fit": "partial",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "tail-spend-management",
          "kind": "capability",
          "labelKey": "partner-capability.tail-spend-management.label",
          "order": 7,
          "parentId": "sourcing-negotiation"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "contract-authoring-review",
              "contract-approval-repository"
            ],
            "domainWorkblockIds": [
              "contract-lifecycle-management"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": [
              "office-composer-conductor"
            ]
          },
          "id": "contract-create-approve",
          "kind": "capability",
          "labelKey": "partner-capability.contract-create-approve.label",
          "order": 1,
          "parentId": "contract-lifecycle-management"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "contract-intake-digitization",
              "contract-approval-repository"
            ],
            "domainWorkblockIds": [
              "contract-lifecycle-management"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "contract-administration-repository",
          "kind": "capability",
          "labelKey": "partner-capability.contract-administration-repository.label",
          "order": 2,
          "parentId": "contract-lifecycle-management"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "obligation-monitoring",
              "renewal-change-compliance"
            ],
            "domainWorkblockIds": [
              "contract-lifecycle-management"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "contract-performance-compliance",
          "kind": "capability",
          "labelKey": "partner-capability.contract-performance-compliance.label",
          "order": 3,
          "parentId": "contract-lifecycle-management"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "renewal-change-compliance"
            ],
            "domainWorkblockIds": [
              "contract-lifecycle-management"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "contract-change-closure",
          "kind": "capability",
          "labelKey": "partner-capability.contract-change-closure.label",
          "order": 4,
          "parentId": "contract-lifecycle-management"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "supplier-onboarding"
            ],
            "domainWorkblockIds": [
              "supplier-lifecycle-third-party-risk"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "supplier-onboarding-registration",
          "kind": "capability",
          "labelKey": "partner-capability.supplier-onboarding-registration.label",
          "order": 1,
          "parentId": "supplier-lifecycle-risk"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "supplier-master-qualification"
            ],
            "domainWorkblockIds": [
              "supplier-lifecycle-third-party-risk"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "supplier-master-data",
          "kind": "capability",
          "labelKey": "partner-capability.supplier-master-data.label",
          "order": 2,
          "parentId": "supplier-lifecycle-risk"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "third-party-risk-review"
            ],
            "domainWorkblockIds": [
              "supplier-lifecycle-third-party-risk"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "supplier-qualification-risk",
          "kind": "capability",
          "labelKey": "partner-capability.supplier-qualification-risk.label",
          "order": 3,
          "parentId": "supplier-lifecycle-risk"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "continuous-risk-monitoring"
            ],
            "domainWorkblockIds": [
              "supplier-lifecycle-third-party-risk"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "supplier-risk-resilience",
          "kind": "capability",
          "labelKey": "partner-capability.supplier-risk-resilience.label",
          "order": 4,
          "parentId": "supplier-lifecycle-risk"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "supplier-remediation-exit"
            ],
            "domainWorkblockIds": [
              "supplier-lifecycle-third-party-risk"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "supplier-remediation-exit",
          "kind": "capability",
          "labelKey": "partner-capability.supplier-remediation-exit.label",
          "order": 5,
          "parentId": "supplier-lifecycle-risk"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "supplier-onboarding",
              "invoice-intake-match"
            ],
            "domainWorkblockIds": [
              "supplier-lifecycle-third-party-risk",
              "invoice-exception-payment-readiness"
            ],
            "fit": "partial",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "supplier-einvoicing-enablement",
          "kind": "capability",
          "labelKey": "partner-capability.supplier-einvoicing-enablement.label",
          "order": 6,
          "parentId": "supplier-lifecycle-risk"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "guided-buying",
              "supplier-master-qualification"
            ],
            "domainWorkblockIds": [
              "buying-ordering-receiving",
              "supplier-lifecycle-third-party-risk"
            ],
            "fit": "partial",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "catalogue-management",
          "kind": "capability",
          "labelKey": "partner-capability.catalogue-management.label",
          "order": 1,
          "parentId": "purchasing-ordering"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "guided-buying",
              "requisition-policy-routing"
            ],
            "domainWorkblockIds": [
              "buying-ordering-receiving"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "guided-buying-requisition",
          "kind": "capability",
          "labelKey": "partner-capability.guided-buying-requisition.label",
          "order": 2,
          "parentId": "purchasing-ordering"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "requisition-policy-routing",
              "purchase-order-orchestration"
            ],
            "domainWorkblockIds": [
              "buying-ordering-receiving"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "requisition-approval-order",
          "kind": "capability",
          "labelKey": "partner-capability.requisition-approval-order.label",
          "order": 3,
          "parentId": "purchasing-ordering"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "purchase-order-orchestration",
              "purchase-order-exception"
            ],
            "domainWorkblockIds": [
              "buying-ordering-receiving"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "purchase-order-management",
          "kind": "capability",
          "labelKey": "partner-capability.purchase-order-management.label",
          "order": 4,
          "parentId": "purchasing-ordering"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "receiving-service-entry"
            ],
            "domainWorkblockIds": [
              "buying-ordering-receiving"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "goods-service-receipt",
          "kind": "capability",
          "labelKey": "partner-capability.goods-service-receipt.label",
          "order": 5,
          "parentId": "purchasing-ordering"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "invoice-intake-match"
            ],
            "domainWorkblockIds": [
              "invoice-exception-payment-readiness"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "invoice-receipt-capture",
          "kind": "capability",
          "labelKey": "partner-capability.invoice-receipt-capture.label",
          "order": 1,
          "parentId": "invoicing-payment"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "invoice-intake-match"
            ],
            "domainWorkblockIds": [
              "invoice-exception-payment-readiness"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "invoice-processing-match",
          "kind": "capability",
          "labelKey": "partner-capability.invoice-processing-match.label",
          "order": 2,
          "parentId": "invoicing-payment"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "invoice-exception-triage",
              "supplier-invoice-resolution"
            ],
            "domainWorkblockIds": [
              "invoice-exception-payment-readiness"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "invoice-exception-resolution",
          "kind": "capability",
          "labelKey": "partner-capability.invoice-exception-resolution.label",
          "order": 3,
          "parentId": "invoicing-payment"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "payment-readiness",
              "payment-execution-guard"
            ],
            "domainWorkblockIds": [
              "invoice-exception-payment-readiness"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "payment-readiness-execution",
          "kind": "capability",
          "labelKey": "partner-capability.payment-readiness-execution.label",
          "order": 4,
          "parentId": "invoicing-payment"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "supplier-invoice-resolution"
            ],
            "domainWorkblockIds": [
              "invoice-exception-payment-readiness"
            ],
            "fit": "partial",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "accounts-payable-support",
          "kind": "capability",
          "labelKey": "partner-capability.accounts-payable-support.label",
          "order": 5,
          "parentId": "invoicing-payment"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "supplier-segmentation-governance"
            ],
            "domainWorkblockIds": [
              "supplier-performance-innovation-relationship"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "supplier-segmentation",
          "kind": "capability",
          "labelKey": "partner-capability.supplier-segmentation.label",
          "order": 1,
          "parentId": "supplier-relationship-management"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "supplier-performance-review",
              "supplier-performance-monitor-correct"
            ],
            "domainWorkblockIds": [
              "supplier-performance-innovation-relationship"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "supplier-performance-reporting",
          "kind": "capability",
          "labelKey": "partner-capability.supplier-performance-reporting.label",
          "order": 2,
          "parentId": "supplier-relationship-management"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "supplier-performance-review",
              "supplier-relationship-joint-value"
            ],
            "domainWorkblockIds": [
              "supplier-performance-innovation-relationship"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "supplier-relationship-governance",
          "kind": "capability",
          "labelKey": "partner-capability.supplier-relationship-governance.label",
          "order": 3,
          "parentId": "supplier-relationship-management"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "supplier-innovation-pipeline",
              "supplier-relationship-joint-value"
            ],
            "domainWorkblockIds": [
              "supplier-performance-innovation-relationship"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "supplier-development-innovation",
          "kind": "capability",
          "labelKey": "partner-capability.supplier-development-innovation.label",
          "order": 4,
          "parentId": "supplier-relationship-management"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "value-opportunity-baseline",
              "savings-initiative"
            ],
            "domainWorkblockIds": [
              "value-realization-savings"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "savings-opportunity",
          "kind": "capability",
          "labelKey": "partner-capability.savings-opportunity.label",
          "order": 1,
          "parentId": "savings-value-realisation"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "savings-initiative",
              "realization-reconciliation-attribution"
            ],
            "domainWorkblockIds": [
              "value-realization-savings"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "value-tracking-reporting",
          "kind": "capability",
          "labelKey": "partner-capability.value-tracking-reporting.label",
          "order": 2,
          "parentId": "savings-value-realisation"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "value-portfolio-forecast"
            ],
            "domainWorkblockIds": [
              "value-realization-savings"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "benefit-performance-control",
          "kind": "capability",
          "labelKey": "partner-capability.benefit-performance-control.label",
          "order": 3,
          "parentId": "savings-value-realisation"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "value-leakage-monitor",
              "realization-reconciliation-attribution"
            ],
            "domainWorkblockIds": [
              "value-realization-savings"
            ],
            "fit": "direct",
            "relationship": "overlaps",
            "sharedCapabilityIds": []
          },
          "id": "value-leakage-variance",
          "kind": "capability",
          "labelKey": "partner-capability.value-leakage-variance.label",
          "order": 4,
          "parentId": "savings-value-realisation"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "category-strategy-orchestrator",
              "demand-orchestration"
            ],
            "domainWorkblockIds": [
              "strategy-policy-category-spend",
              "intake-demand"
            ],
            "fit": "cross-cutting",
            "relationship": "supports",
            "sharedCapabilityIds": [
              "identity-policy-controls-audit"
            ]
          },
          "id": "stakeholder-partnering-governance",
          "kind": "capability",
          "labelKey": "partner-capability.stakeholder-partnering-governance.label",
          "order": 1,
          "parentId": "enterprise-enablers-controls"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "spend-data-foundation",
              "value-portfolio-forecast"
            ],
            "domainWorkblockIds": [
              "strategy-policy-category-spend",
              "value-realization-savings"
            ],
            "fit": "cross-cutting",
            "relationship": "supports",
            "sharedCapabilityIds": [
              "data-evidence-analytics-learning"
            ]
          },
          "id": "data-insights-analytics",
          "kind": "capability",
          "labelKey": "partner-capability.data-insights-analytics.label",
          "order": 2,
          "parentId": "enterprise-enablers-controls"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "third-party-risk-review",
              "supplier-performance-monitor-correct"
            ],
            "domainWorkblockIds": [
              "supplier-lifecycle-third-party-risk",
              "supplier-performance-innovation-relationship"
            ],
            "fit": "cross-cutting",
            "relationship": "supports",
            "sharedCapabilityIds": [
              "data-evidence-analytics-learning"
            ]
          },
          "id": "supplier-inclusion-sustainability",
          "kind": "capability",
          "labelKey": "partner-capability.supplier-inclusion-sustainability.label",
          "order": 3,
          "parentId": "enterprise-enablers-controls"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "policy-rule-lifecycle",
              "policy-guidance",
              "value-leakage-monitor"
            ],
            "domainWorkblockIds": [
              "strategy-policy-category-spend",
              "value-realization-savings"
            ],
            "fit": "cross-cutting",
            "relationship": "supports",
            "sharedCapabilityIds": [
              "identity-policy-controls-audit"
            ]
          },
          "id": "policy-control-monitoring",
          "kind": "capability",
          "labelKey": "partner-capability.policy-control-monitoring.label",
          "order": 4,
          "parentId": "enterprise-enablers-controls"
        },
        {
          "groundworks": {
            "businessModuleIds": [],
            "domainWorkblockIds": [],
            "fit": "cross-cutting",
            "relationship": "supports",
            "sharedCapabilityIds": [
              "workblock-authoring-adaptability"
            ]
          },
          "id": "change-continuous-improvement",
          "kind": "capability",
          "labelKey": "partner-capability.change-continuous-improvement.label",
          "order": 5,
          "parentId": "enterprise-enablers-controls"
        }
      ],
      "supportedLookups": [
        "partner-to-groundworks",
        "groundworks-to-partner"
      ],
      "titleKey": "partner-capability.map.title",
      "version": "1.1.1"
    },
    {
      "descriptionKey": "partner-capability.direct-material.map.description",
      "id": "accenture-direct-material",
      "licenseId": "partner-owned",
      "mappingDirection": "partner-to-groundworks",
      "nodes": [
        {
          "groundworks": {
            "businessModuleIds": [],
            "domainWorkblockIds": [
              "intake-demand",
              "sourcing-negotiation",
              "strategy-policy-category-spend",
              "supplier-lifecycle-third-party-risk",
              "value-realization-savings"
            ],
            "fit": "cross-cutting",
            "relationship": "supports",
            "sharedCapabilityIds": []
          },
          "id": "direct-material-economics",
          "kind": "area",
          "labelKey": "partner-capability.direct-material.area.label",
          "order": 1
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "category-opportunity-radar"
            ],
            "domainWorkblockIds": [
              "strategy-policy-category-spend"
            ],
            "fit": "direct",
            "relationship": "supports",
            "sharedCapabilityIds": []
          },
          "id": "commodity-price-outlook",
          "kind": "capability",
          "labelKey": "partner-capability.direct-material.commodity-price-outlook.label",
          "order": 1,
          "parentId": "direct-material-economics"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "demand-consolidation-portfolio"
            ],
            "domainWorkblockIds": [
              "intake-demand"
            ],
            "fit": "direct",
            "relationship": "supports",
            "sharedCapabilityIds": []
          },
          "id": "raw-material-demand-signalling",
          "kind": "capability",
          "labelKey": "partner-capability.direct-material.raw-material-demand-signalling.label",
          "order": 2,
          "parentId": "direct-material-economics"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "demand-consolidation-portfolio"
            ],
            "domainWorkblockIds": [
              "intake-demand"
            ],
            "fit": "direct",
            "relationship": "supports",
            "sharedCapabilityIds": []
          },
          "id": "coverage-position-monitoring",
          "kind": "capability",
          "labelKey": "partner-capability.direct-material.coverage-position-monitoring.label",
          "order": 3,
          "parentId": "direct-material-economics"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "demand-consolidation-portfolio"
            ],
            "domainWorkblockIds": [
              "intake-demand"
            ],
            "fit": "direct",
            "relationship": "supports",
            "sharedCapabilityIds": []
          },
          "id": "material-specification-harmonisation",
          "kind": "capability",
          "labelKey": "partner-capability.direct-material.material-specification-harmonisation.label",
          "order": 4,
          "parentId": "direct-material-economics"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "sourcing-pipeline-discovery"
            ],
            "domainWorkblockIds": [
              "sourcing-negotiation"
            ],
            "fit": "direct",
            "relationship": "supports",
            "sharedCapabilityIds": []
          },
          "id": "buy-timing-mandates",
          "kind": "capability",
          "labelKey": "partner-capability.direct-material.buy-timing-mandates.label",
          "order": 5,
          "parentId": "direct-material-economics"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "bid-evaluation-award"
            ],
            "domainWorkblockIds": [
              "sourcing-negotiation"
            ],
            "fit": "direct",
            "relationship": "supports",
            "sharedCapabilityIds": []
          },
          "id": "total-landed-cost-optimisation",
          "kind": "capability",
          "labelKey": "partner-capability.direct-material.total-landed-cost-optimisation.label",
          "order": 6,
          "parentId": "direct-material-economics"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "supplier-master-qualification"
            ],
            "domainWorkblockIds": [
              "supplier-lifecycle-third-party-risk"
            ],
            "fit": "direct",
            "relationship": "supports",
            "sharedCapabilityIds": []
          },
          "id": "carbon-cost-compliance",
          "kind": "capability",
          "labelKey": "partner-capability.direct-material.carbon-cost-compliance.label",
          "order": 7,
          "parentId": "direct-material-economics"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "supplier-master-qualification"
            ],
            "domainWorkblockIds": [
              "supplier-lifecycle-third-party-risk"
            ],
            "fit": "direct",
            "relationship": "supports",
            "sharedCapabilityIds": []
          },
          "id": "supplier-quality-prediction",
          "kind": "capability",
          "labelKey": "partner-capability.direct-material.supplier-quality-prediction.label",
          "order": 8,
          "parentId": "direct-material-economics"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "value-portfolio-forecast"
            ],
            "domainWorkblockIds": [
              "value-realization-savings"
            ],
            "fit": "direct",
            "relationship": "supports",
            "sharedCapabilityIds": []
          },
          "id": "margin-tradeoff-arbitration",
          "kind": "capability",
          "labelKey": "partner-capability.direct-material.margin-tradeoff-arbitration.label",
          "order": 9,
          "parentId": "direct-material-economics"
        }
      ],
      "supportedLookups": [
        "partner-to-groundworks",
        "groundworks-to-partner"
      ],
      "titleKey": "partner-capability.direct-material.map.title",
      "version": "1.0.0"
    },
    {
      "descriptionKey": "partner-capability.indirect-buying.map.description",
      "id": "accenture-indirect-buying",
      "licenseId": "partner-owned",
      "mappingDirection": "partner-to-groundworks",
      "nodes": [
        {
          "groundworks": {
            "businessModuleIds": [],
            "domainWorkblockIds": [
              "intake-demand",
              "strategy-policy-category-spend",
              "sourcing-negotiation",
              "buying-ordering-receiving",
              "value-realization-savings",
              "invoice-exception-payment-readiness"
            ],
            "fit": "cross-cutting",
            "relationship": "supports",
            "sharedCapabilityIds": []
          },
          "id": "indirect-buying",
          "kind": "area",
          "labelKey": "partner-capability.indirect-buying.area.label",
          "order": 1
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "intelligent-intake"
            ],
            "domainWorkblockIds": [
              "intake-demand"
            ],
            "fit": "direct",
            "relationship": "supports",
            "sharedCapabilityIds": []
          },
          "id": "intake-clarification",
          "kind": "capability",
          "labelKey": "partner-capability.indirect-buying.intake-clarification.label",
          "order": 1,
          "parentId": "indirect-buying"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "guided-buying"
            ],
            "domainWorkblockIds": [
              "buying-ordering-receiving"
            ],
            "fit": "direct",
            "relationship": "supports",
            "sharedCapabilityIds": []
          },
          "id": "catalogue-coverage-adoption",
          "kind": "capability",
          "labelKey": "partner-capability.indirect-buying.catalogue-coverage-adoption.label",
          "order": 2,
          "parentId": "indirect-buying"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "policy-rule-lifecycle"
            ],
            "domainWorkblockIds": [
              "strategy-policy-category-spend"
            ],
            "fit": "direct",
            "relationship": "supports",
            "sharedCapabilityIds": []
          },
          "id": "buying-channel-drift-detection",
          "kind": "capability",
          "labelKey": "partner-capability.indirect-buying.buying-channel-drift-detection.label",
          "order": 3,
          "parentId": "indirect-buying"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "category-opportunity-radar"
            ],
            "domainWorkblockIds": [
              "strategy-policy-category-spend"
            ],
            "fit": "direct",
            "relationship": "supports",
            "sharedCapabilityIds": []
          },
          "id": "tail-spend-consolidation",
          "kind": "capability",
          "labelKey": "partner-capability.indirect-buying.tail-spend-consolidation.label",
          "order": 4,
          "parentId": "indirect-buying"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "tactical-sourcing-autonomy"
            ],
            "domainWorkblockIds": [
              "sourcing-negotiation"
            ],
            "fit": "direct",
            "relationship": "supports",
            "sharedCapabilityIds": []
          },
          "id": "spot-buy-conversion",
          "kind": "capability",
          "labelKey": "partner-capability.indirect-buying.spot-buy-conversion.label",
          "order": 5,
          "parentId": "indirect-buying"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "requisition-policy-routing"
            ],
            "domainWorkblockIds": [
              "buying-ordering-receiving"
            ],
            "fit": "direct",
            "relationship": "supports",
            "sharedCapabilityIds": []
          },
          "id": "requisition-policy-routing",
          "kind": "capability",
          "labelKey": "partner-capability.indirect-buying.requisition-policy-routing.label",
          "order": 6,
          "parentId": "indirect-buying"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "purchase-order-orchestration"
            ],
            "domainWorkblockIds": [
              "buying-ordering-receiving"
            ],
            "fit": "direct",
            "relationship": "supports",
            "sharedCapabilityIds": []
          },
          "id": "order-and-receipt-execution",
          "kind": "capability",
          "labelKey": "partner-capability.indirect-buying.order-and-receipt-execution.label",
          "order": 7,
          "parentId": "indirect-buying"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "value-leakage-monitor"
            ],
            "domainWorkblockIds": [
              "value-realization-savings"
            ],
            "fit": "direct",
            "relationship": "supports",
            "sharedCapabilityIds": []
          },
          "id": "off-contract-price-variance",
          "kind": "capability",
          "labelKey": "partner-capability.indirect-buying.off-contract-price-variance.label",
          "order": 8,
          "parentId": "indirect-buying"
        },
        {
          "groundworks": {
            "businessModuleIds": [
              "payment-readiness"
            ],
            "domainWorkblockIds": [
              "invoice-exception-payment-readiness"
            ],
            "fit": "direct",
            "relationship": "supports",
            "sharedCapabilityIds": []
          },
          "id": "payment-terms-positioning",
          "kind": "capability",
          "labelKey": "partner-capability.indirect-buying.payment-terms-positioning.label",
          "order": 9,
          "parentId": "indirect-buying"
        }
      ],
      "supportedLookups": [
        "partner-to-groundworks",
        "groundworks-to-partner"
      ],
      "titleKey": "partner-capability.indirect-buying.map.title",
      "version": "1.0.0"
    }
  ],
  "partnerId": "accenture",
  "partnerVersion": "6.6.0",
  "release": {
    "breakingChanges": {
      "entityRenames": [],
      "fieldRenames": []
    },
    "businessModuleVersion": "5.3.0",
    "compatiblePredecessor": {
      "businessModuleVersion": "5.2.0",
      "frameworkVersion": "6.5.0",
      "groundworksVersion": "4.2.0"
    },
    "frameworkVersion": "6.6.0",
    "groundworksVersion": "4.3.0",
    "gwodVersion": "0.6.0"
  },
  "schemaVersion": "6.4.0",
  "theme": {
    "className": "apf-theme-accenture",
    "id": "accenture-native"
  }
}
